/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 675);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(143);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return wrapWithTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_is_function__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_is_function___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_is_function__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);







/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate$2(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate$2;

var hyphenate = hyphenate_1;

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var hyphenateStyleName_1 = hyphenateStyleName;

//      
var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).map(function (key) {
    if (__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName_1(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
    /* Flatten ruleSet */
    if (Array.isArray(chunk)) return [].concat(ruleSet, flatten(chunk, executionContext));

    /* Handle other components */
    // $FlowFixMe not sure how to make this pass
    if (chunk.hasOwnProperty('styledComponentId')) return [].concat(ruleSet, ['.' + chunk.styledComponentId]);

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
    }

    /* Handle objects */
    // $FlowFixMe have to add %checks somehow to isPlainObject
    return ruleSet.concat(__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(chunk) ? objToCss(chunk) : chunk.toString());
  }, []);
};

//      
var stylis = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: true
});

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

//      
var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
var charsLength = chars.length;

/* Some high number, usually 9-digit base-10. Map it to base-😎 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = chars[x % charsLength] + name;
  }

  return chars[x % charsLength] + name;
};

//      


var interleave = (function (strings, interpolations) {
  return interpolations.reduce(function (array, interp, i) {
    return array.concat(interp, strings[i + 1]);
  }, [strings[0]]);
});

//      
var css = (function (strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  return flatten(interleave(strings, interpolations));
});

//      
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s+(\S+)\s+\*\//mg;

var extractCompsFromCSS = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

//      
/* eslint-disable no-underscore-dangle */
/*
 * Browser Style Sheet with Rehydration
 *
 * <style data-styled-components="x y z"
 *        data-styled-components-is-local="true">
 *   /· sc-component-id: a ·/
 *   .sc-a { ... }
 *   .x { ... }
 *   /· sc-component-id: b ·/
 *   .sc-b { ... }
 *   .y { ... }
 *   .z { ... }
 * </style>
 *
 * Note: replace · with * in the above snippet.
 * */
var COMPONENTS_PER_TAG = 40;

var BrowserTag = function () {
  function BrowserTag(el, isLocal) {
    var existingSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    classCallCheck(this, BrowserTag);

    this.el = el;
    this.isLocal = isLocal;
    this.ready = false;

    var extractedComps = extractCompsFromCSS(existingSource);

    this.size = extractedComps.length;
    this.components = extractedComps.reduce(function (acc, obj) {
      acc[obj.componentId] = obj; // eslint-disable-line no-param-reassign
      return acc;
    }, {});
  }

  BrowserTag.prototype.isFull = function isFull() {
    return this.size >= COMPONENTS_PER_TAG;
  };

  BrowserTag.prototype.addComponent = function addComponent(componentId) {
    if (!this.ready) this.replaceElement();
    if (this.components[componentId]) throw new Error('Trying to add Component \'' + componentId + '\' twice!');

    var comp = { componentId: componentId, textNode: document.createTextNode('') };
    this.el.appendChild(comp.textNode);

    this.size += 1;
    this.components[componentId] = comp;
  };

  BrowserTag.prototype.inject = function inject(componentId, css, name) {
    if (!this.ready) this.replaceElement();
    var comp = this.components[componentId];

    if (!comp) throw new Error('Must add a new component before you can inject css into it');
    if (comp.textNode.data === '') comp.textNode.appendData('\n/* sc-component-id: ' + componentId + ' */\n');

    comp.textNode.appendData(css);
    if (name) {
      var existingNames = this.el.getAttribute(SC_ATTR);
      this.el.setAttribute(SC_ATTR, existingNames ? existingNames + ' ' + name : name);

      if (typeof window !== 'undefined' && window.__webpack_nonce__) {
        this.el.setAttribute('nonce', window.__webpack_nonce__);
      }
    }
  };

  BrowserTag.prototype.toHTML = function toHTML() {
    return this.el.outerHTML;
  };

  BrowserTag.prototype.toReactElement = function toReactElement() {
    throw new Error('BrowserTag doesn\'t implement toReactElement!');
  };

  BrowserTag.prototype.clone = function clone() {
    throw new Error('BrowserTag cannot be cloned!');
  };

  /* Because we care about source order, before we can inject anything we need to
   * create a text node for each component and replace the existing CSS. */


  BrowserTag.prototype.replaceElement = function replaceElement() {
    var _this = this;

    this.ready = true;
    // We have nothing to inject. Use the current el.
    if (this.size === 0) return;

    // Build up our replacement style tag
    var newEl = this.el.cloneNode();
    newEl.appendChild(document.createTextNode('\n'));

    Object.keys(this.components).forEach(function (key) {
      var comp = _this.components[key];

      // eslint-disable-next-line no-param-reassign
      comp.textNode = document.createTextNode(comp.cssFromDOM);
      newEl.appendChild(comp.textNode);
    });

    if (!this.el.parentNode) throw new Error("Trying to replace an element that wasn't mounted!");

    // The ol' switcheroo
    this.el.parentNode.replaceChild(newEl, this.el);
    this.el = newEl;
  };

  return BrowserTag;
}();

/* Factory function to separate DOM operations from logical ones*/


var BrowserStyleSheet = {
  create: function create() {
    var tags = [];
    var names = {};

    /* Construct existing state from DOM */
    var nodes = document.querySelectorAll('[' + SC_ATTR + ']');
    var nodesLength = nodes.length;

    for (var i = 0; i < nodesLength; i += 1) {
      var el = nodes[i];

      tags.push(new BrowserTag(el, el.getAttribute(LOCAL_ATTR) === 'true', el.innerHTML));

      var attr = el.getAttribute(SC_ATTR);
      if (attr) {
        attr.trim().split(/\s+/).forEach(function (name) {
          names[name] = true;
        });
      }
    }

    /* Factory for making more tags */
    var tagConstructor = function tagConstructor(isLocal) {
      var el = document.createElement('style');
      el.type = 'text/css';
      el.setAttribute(SC_ATTR, '');
      el.setAttribute(LOCAL_ATTR, isLocal ? 'true' : 'false');
      if (!document.head) throw new Error('Missing document <head>');
      document.head.appendChild(el);
      return new BrowserTag(el, isLocal);
    };

    return new StyleSheet(tagConstructor, tags, names);
  }
};

//      
var SC_ATTR = 'data-styled-components';
var LOCAL_ATTR = 'data-styled-components-is-local';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var instance = null;
// eslint-disable-next-line no-use-before-define
var clones = [];

var StyleSheet = function () {
  function StyleSheet(tagConstructor) {
    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, StyleSheet);
    this.hashes = {};
    this.deferredInjections = {};

    this.tagConstructor = tagConstructor;
    this.tags = tags;
    this.names = names;
    this.constructComponentTagMap();
  }

  StyleSheet.prototype.constructComponentTagMap = function constructComponentTagMap() {
    var _this = this;

    this.componentTags = {};

    this.tags.forEach(function (tag) {
      Object.keys(tag.components).forEach(function (componentId) {
        _this.componentTags[componentId] = tag;
      });
    });
  };

  /* Best level of caching—get the name from the hash straight away. */


  StyleSheet.prototype.getName = function getName(hash) {
    return this.hashes[hash.toString()];
  };

  /* Second level of caching—if the name is already in the dom, don't
   * inject anything and record the hash for getName next time. */


  StyleSheet.prototype.alreadyInjected = function alreadyInjected(hash, name) {
    if (!this.names[name]) return false;

    this.hashes[hash.toString()] = name;
    return true;
  };

  /* Third type of caching—don't inject components' componentId twice. */


  StyleSheet.prototype.hasInjectedComponent = function hasInjectedComponent(componentId) {
    return !!this.componentTags[componentId];
  };

  StyleSheet.prototype.deferredInject = function deferredInject(componentId, isLocal, css) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.deferredInject(componentId, isLocal, css);
      });
    }

    this.getOrCreateTag(componentId, isLocal);
    this.deferredInjections[componentId] = css;
  };

  StyleSheet.prototype.inject = function inject(componentId, isLocal, css, hash, name) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.inject(componentId, isLocal, css);
      });
    }

    var tag = this.getOrCreateTag(componentId, isLocal);

    var deferredInjection = this.deferredInjections[componentId];
    if (deferredInjection) {
      tag.inject(componentId, deferredInjection);
      delete this.deferredInjections[componentId];
    }

    tag.inject(componentId, css, name);

    if (hash && name) {
      this.hashes[hash.toString()] = name;
    }
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    return this.tags.map(function (tag, i) {
      return tag.toReactElement('sc-' + i);
    });
  };

  StyleSheet.prototype.getOrCreateTag = function getOrCreateTag(componentId, isLocal) {
    var existingTag = this.componentTags[componentId];
    if (existingTag) {
      return existingTag;
    }

    var lastTag = this.tags[this.tags.length - 1];
    var componentTag = !lastTag || lastTag.isFull() || lastTag.isLocal !== isLocal ? this.createNewTag(isLocal) : lastTag;
    this.componentTags[componentId] = componentTag;
    componentTag.addComponent(componentId);
    return componentTag;
  };

  StyleSheet.prototype.createNewTag = function createNewTag(isLocal) {
    var newTag = this.tagConstructor(isLocal);
    this.tags.push(newTag);
    return newTag;
  };

  StyleSheet.reset = function reset(isServer) {
    instance = StyleSheet.create(isServer);
  };

  /* We can make isServer totally implicit once Jest 20 drops and we
   * can change environment on a per-test basis. */


  StyleSheet.create = function create() {
    var isServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof document === 'undefined';

    return (isServer ? ServerStyleSheet : BrowserStyleSheet).create();
  };

  StyleSheet.clone = function clone(oldSheet) {
    var newSheet = new StyleSheet(oldSheet.tagConstructor, oldSheet.tags.map(function (tag) {
      return tag.clone();
    }), _extends({}, oldSheet.names));

    newSheet.hashes = _extends({}, oldSheet.hashes);
    newSheet.deferredInjections = _extends({}, oldSheet.deferredInjections);
    clones.push(newSheet);

    return newSheet;
  };

  createClass(StyleSheet, null, [{
    key: 'instance',
    get: function get$$1() {
      return instance || (instance = StyleSheet.create());
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

//      
var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.props.sheet, _ref;
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet).isRequired, _StyleSheetManager$ch);

StyleSheetManager.propTypes = {
  sheet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet).isRequired
};

//      
/* eslint-disable no-underscore-dangle */
var ServerTag = function () {
  function ServerTag(isLocal) {
    classCallCheck(this, ServerTag);

    this.isLocal = isLocal;
    this.components = {};
    this.size = 0;
    this.names = [];
  }

  ServerTag.prototype.isFull = function isFull() {
    return false;
  };

  ServerTag.prototype.addComponent = function addComponent(componentId) {
    if (this.components[componentId]) throw new Error('Trying to add Component \'' + componentId + '\' twice!');
    this.components[componentId] = { componentId: componentId, css: '' };
    this.size += 1;
  };

  ServerTag.prototype.concatenateCSS = function concatenateCSS() {
    var _this = this;

    return Object.keys(this.components).reduce(function (styles, k) {
      return styles + _this.components[k].css;
    }, '');
  };

  ServerTag.prototype.inject = function inject(componentId, css, name) {
    var comp = this.components[componentId];

    if (!comp) throw new Error('Must add a new component before you can inject css into it');
    if (comp.css === '') comp.css = '/* sc-component-id: ' + componentId + ' */\n';

    comp.css += css.replace(/\n*$/, '\n');

    if (name) this.names.push(name);
  };

  ServerTag.prototype.toHTML = function toHTML() {
    var attrs = ['type="text/css"', SC_ATTR + '="' + this.names.join(' ') + '"', LOCAL_ATTR + '="' + (this.isLocal ? 'true' : 'false') + '"'];

    if (typeof global !== 'undefined' && global.__webpack_nonce__) {
      attrs.push('nonce="' + global.__webpack_nonce__ + '"');
    }

    return '<style ' + attrs.join(' ') + '>' + this.concatenateCSS() + '</style>';
  };

  ServerTag.prototype.toReactElement = function toReactElement(key) {
    var _attrs;

    var attrs = (_attrs = {}, _attrs[SC_ATTR] = this.names.join(' '), _attrs[LOCAL_ATTR] = this.isLocal.toString(), _attrs);

    if (typeof global !== 'undefined' && global.__webpack_nonce__) {
      attrs.nonce = global.__webpack_nonce__;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({
      key: key, type: 'text/css' }, attrs, {
      dangerouslySetInnerHTML: { __html: this.concatenateCSS() }
    }));
  };

  ServerTag.prototype.clone = function clone() {
    var _this2 = this;

    var copy = new ServerTag(this.isLocal);
    copy.names = [].concat(this.names);
    copy.size = this.size;
    copy.components = Object.keys(this.components).reduce(function (acc, key) {
      acc[key] = _extends({}, _this2.components[key]); // eslint-disable-line no-param-reassign
      return acc;
    }, {});

    return copy;
  };

  return ServerTag;
}();

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    this.instance = StyleSheet.clone(StyleSheet.instance);
  }

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) throw new Error("Can't collect styles once you've called getStyleTags!");
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toReactElements();
  };

  ServerStyleSheet.create = function create() {
    return new StyleSheet(function (isLocal) {
      return new ServerTag(isLocal);
    });
  };

  return ServerStyleSheet;
}();

//      

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. ' + 'Consider using style property for frequently changed styles.\n' + 'Example:\n' + '  const StyledComp = styled.div`width: 100%;`\n' + '  <StyledComp style={{ background: background }} />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

//      
/* Trying to avoid the unknown-prop errors on styled components
 by filtering by React's attribute whitelist.
 */

/* Logic copied from ReactDOMUnknownPropertyHook */
var reactProps = {
  children: true,
  dangerouslySetInnerHTML: true,
  key: true,
  ref: true,
  autoFocus: true,
  defaultValue: true,
  valueLink: true,
  defaultChecked: true,
  checkedLink: true,
  innerHTML: true,
  suppressContentEditableWarning: true,
  onFocusIn: true,
  onFocusOut: true,
  className: true,

  /* List copied from https://facebook.github.io/react/docs/events.html */
  onCopy: true,
  onCut: true,
  onPaste: true,
  onCompositionEnd: true,
  onCompositionStart: true,
  onCompositionUpdate: true,
  onKeyDown: true,
  onKeyPress: true,
  onKeyUp: true,
  onFocus: true,
  onBlur: true,
  onChange: true,
  onInput: true,
  onSubmit: true,
  onClick: true,
  onContextMenu: true,
  onDoubleClick: true,
  onDrag: true,
  onDragEnd: true,
  onDragEnter: true,
  onDragExit: true,
  onDragLeave: true,
  onDragOver: true,
  onDragStart: true,
  onDrop: true,
  onMouseDown: true,
  onMouseEnter: true,
  onMouseLeave: true,
  onMouseMove: true,
  onMouseOut: true,
  onMouseOver: true,
  onMouseUp: true,
  onSelect: true,
  onTouchCancel: true,
  onTouchEnd: true,
  onTouchMove: true,
  onTouchStart: true,
  onScroll: true,
  onWheel: true,
  onAbort: true,
  onCanPlay: true,
  onCanPlayThrough: true,
  onDurationChange: true,
  onEmptied: true,
  onEncrypted: true,
  onEnded: true,
  onError: true,
  onLoadedData: true,
  onLoadedMetadata: true,
  onLoadStart: true,
  onPause: true,
  onPlay: true,
  onPlaying: true,
  onProgress: true,
  onRateChange: true,
  onSeeked: true,
  onSeeking: true,
  onStalled: true,
  onSuspend: true,
  onTimeUpdate: true,
  onVolumeChange: true,
  onWaiting: true,
  onLoad: true,
  onAnimationStart: true,
  onAnimationEnd: true,
  onAnimationIteration: true,
  onTransitionEnd: true,

  onCopyCapture: true,
  onCutCapture: true,
  onPasteCapture: true,
  onCompositionEndCapture: true,
  onCompositionStartCapture: true,
  onCompositionUpdateCapture: true,
  onKeyDownCapture: true,
  onKeyPressCapture: true,
  onKeyUpCapture: true,
  onFocusCapture: true,
  onBlurCapture: true,
  onChangeCapture: true,
  onInputCapture: true,
  onSubmitCapture: true,
  onClickCapture: true,
  onContextMenuCapture: true,
  onDoubleClickCapture: true,
  onDragCapture: true,
  onDragEndCapture: true,
  onDragEnterCapture: true,
  onDragExitCapture: true,
  onDragLeaveCapture: true,
  onDragOverCapture: true,
  onDragStartCapture: true,
  onDropCapture: true,
  onMouseDownCapture: true,
  onMouseEnterCapture: true,
  onMouseLeaveCapture: true,
  onMouseMoveCapture: true,
  onMouseOutCapture: true,
  onMouseOverCapture: true,
  onMouseUpCapture: true,
  onSelectCapture: true,
  onTouchCancelCapture: true,
  onTouchEndCapture: true,
  onTouchMoveCapture: true,
  onTouchStartCapture: true,
  onScrollCapture: true,
  onWheelCapture: true,
  onAbortCapture: true,
  onCanPlayCapture: true,
  onCanPlayThroughCapture: true,
  onDurationChangeCapture: true,
  onEmptiedCapture: true,
  onEncryptedCapture: true,
  onEndedCapture: true,
  onErrorCapture: true,
  onLoadedDataCapture: true,
  onLoadedMetadataCapture: true,
  onLoadStartCapture: true,
  onPauseCapture: true,
  onPlayCapture: true,
  onPlayingCapture: true,
  onProgressCapture: true,
  onRateChangeCapture: true,
  onSeekedCapture: true,
  onSeekingCapture: true,
  onStalledCapture: true,
  onSuspendCapture: true,
  onTimeUpdateCapture: true,
  onVolumeChangeCapture: true,
  onWaitingCapture: true,
  onLoadCapture: true,
  onAnimationStartCapture: true,
  onAnimationEndCapture: true,
  onAnimationIterationCapture: true,
  onTransitionEndCapture: true
};

/* From HTMLDOMPropertyConfig */
var htmlProps = {
  /**
   * Standard Properties
   */
  accept: true,
  acceptCharset: true,
  accessKey: true,
  action: true,
  allowFullScreen: true,
  allowTransparency: true,
  alt: true,
  // specifies target context for links with `preload` type
  as: true,
  async: true,
  autoComplete: true,
  // autoFocus is polyfilled/normalized by AutoFocusUtils
  // autoFocus: true,
  autoPlay: true,
  capture: true,
  cellPadding: true,
  cellSpacing: true,
  charSet: true,
  challenge: true,
  checked: true,
  cite: true,
  classID: true,
  className: true,
  cols: true,
  colSpan: true,
  content: true,
  contentEditable: true,
  contextMenu: true,
  controls: true,
  coords: true,
  crossOrigin: true,
  data: true, // For `<object />` acts as `src`.
  dateTime: true,
  default: true,
  defer: true,
  dir: true,
  disabled: true,
  download: true,
  draggable: true,
  encType: true,
  form: true,
  formAction: true,
  formEncType: true,
  formMethod: true,
  formNoValidate: true,
  formTarget: true,
  frameBorder: true,
  headers: true,
  height: true,
  hidden: true,
  high: true,
  href: true,
  hrefLang: true,
  htmlFor: true,
  httpEquiv: true,
  icon: true,
  id: true,
  inputMode: true,
  integrity: true,
  is: true,
  keyParams: true,
  keyType: true,
  kind: true,
  label: true,
  lang: true,
  list: true,
  loop: true,
  low: true,
  manifest: true,
  marginHeight: true,
  marginWidth: true,
  max: true,
  maxLength: true,
  media: true,
  mediaGroup: true,
  method: true,
  min: true,
  minLength: true,
  // Caution; `option.selected` is not updated if `select.multiple` is
  // disabled with `removeAttribute`.
  multiple: true,
  muted: true,
  name: true,
  nonce: true,
  noValidate: true,
  open: true,
  optimum: true,
  pattern: true,
  placeholder: true,
  playsInline: true,
  poster: true,
  preload: true,
  profile: true,
  radioGroup: true,
  readOnly: true,
  referrerPolicy: true,
  rel: true,
  required: true,
  reversed: true,
  role: true,
  rows: true,
  rowSpan: true,
  sandbox: true,
  scope: true,
  scoped: true,
  scrolling: true,
  seamless: true,
  selected: true,
  shape: true,
  size: true,
  sizes: true,
  span: true,
  spellCheck: true,
  src: true,
  srcDoc: true,
  srcLang: true,
  srcSet: true,
  start: true,
  step: true,
  style: true,
  summary: true,
  tabIndex: true,
  target: true,
  title: true,
  // Setting .type throws on non-<input> tags
  type: true,
  useMap: true,
  value: true,
  width: true,
  wmode: true,
  wrap: true,

  /**
   * RDFa Properties
   */
  about: true,
  datatype: true,
  inlist: true,
  prefix: true,
  // property is also supported for OpenGraph in meta tags.
  property: true,
  resource: true,
  typeof: true,
  vocab: true,

  /**
   * Non-standard Properties
   */
  // autoCapitalize and autoCorrect are supported in Mobile Safari for
  // keyboard hints.
  autoCapitalize: true,
  autoCorrect: true,
  // autoSave allows WebKit/Blink to persist values of input fields on page reloads
  autoSave: true,
  // color is for Safari mask-icon link
  color: true,
  // itemProp, itemScope, itemType are for
  // Microdata support. See http://schema.org/docs/gs.html
  itemProp: true,
  itemScope: true,
  itemType: true,
  // itemID and itemRef are for Microdata support as well but
  // only specified in the WHATWG spec document. See
  // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
  itemID: true,
  itemRef: true,
  // results show looking glass icon and recent searches on input
  // search fields in WebKit/Blink
  results: true,
  // IE-only attribute that specifies security restrictions on an iframe
  // as an alternative to the sandbox attribute on IE<10
  security: true,
  // IE-only attribute that controls focus behavior
  unselectable: 0
};

var svgProps = {
  accentHeight: true,
  accumulate: true,
  additive: true,
  alignmentBaseline: true,
  allowReorder: true,
  alphabetic: true,
  amplitude: true,
  arabicForm: true,
  ascent: true,
  attributeName: true,
  attributeType: true,
  autoReverse: true,
  azimuth: true,
  baseFrequency: true,
  baseProfile: true,
  baselineShift: true,
  bbox: true,
  begin: true,
  bias: true,
  by: true,
  calcMode: true,
  capHeight: true,
  clip: true,
  clipPath: true,
  clipRule: true,
  clipPathUnits: true,
  colorInterpolation: true,
  colorInterpolationFilters: true,
  colorProfile: true,
  colorRendering: true,
  contentScriptType: true,
  contentStyleType: true,
  cursor: true,
  cx: true,
  cy: true,
  d: true,
  decelerate: true,
  descent: true,
  diffuseConstant: true,
  direction: true,
  display: true,
  divisor: true,
  dominantBaseline: true,
  dur: true,
  dx: true,
  dy: true,
  edgeMode: true,
  elevation: true,
  enableBackground: true,
  end: true,
  exponent: true,
  externalResourcesRequired: true,
  fill: true,
  fillOpacity: true,
  fillRule: true,
  filter: true,
  filterRes: true,
  filterUnits: true,
  floodColor: true,
  floodOpacity: true,
  focusable: true,
  fontFamily: true,
  fontSize: true,
  fontSizeAdjust: true,
  fontStretch: true,
  fontStyle: true,
  fontVariant: true,
  fontWeight: true,
  format: true,
  from: true,
  fx: true,
  fy: true,
  g1: true,
  g2: true,
  glyphName: true,
  glyphOrientationHorizontal: true,
  glyphOrientationVertical: true,
  glyphRef: true,
  gradientTransform: true,
  gradientUnits: true,
  hanging: true,
  horizAdvX: true,
  horizOriginX: true,
  ideographic: true,
  imageRendering: true,
  in: true,
  in2: true,
  intercept: true,
  k: true,
  k1: true,
  k2: true,
  k3: true,
  k4: true,
  kernelMatrix: true,
  kernelUnitLength: true,
  kerning: true,
  keyPoints: true,
  keySplines: true,
  keyTimes: true,
  lengthAdjust: true,
  letterSpacing: true,
  lightingColor: true,
  limitingConeAngle: true,
  local: true,
  markerEnd: true,
  markerMid: true,
  markerStart: true,
  markerHeight: true,
  markerUnits: true,
  markerWidth: true,
  mask: true,
  maskContentUnits: true,
  maskUnits: true,
  mathematical: true,
  mode: true,
  numOctaves: true,
  offset: true,
  opacity: true,
  operator: true,
  order: true,
  orient: true,
  orientation: true,
  origin: true,
  overflow: true,
  overlinePosition: true,
  overlineThickness: true,
  paintOrder: true,
  panose1: true,
  pathLength: true,
  patternContentUnits: true,
  patternTransform: true,
  patternUnits: true,
  pointerEvents: true,
  points: true,
  pointsAtX: true,
  pointsAtY: true,
  pointsAtZ: true,
  preserveAlpha: true,
  preserveAspectRatio: true,
  primitiveUnits: true,
  r: true,
  radius: true,
  refX: true,
  refY: true,
  renderingIntent: true,
  repeatCount: true,
  repeatDur: true,
  requiredExtensions: true,
  requiredFeatures: true,
  restart: true,
  result: true,
  rotate: true,
  rx: true,
  ry: true,
  scale: true,
  seed: true,
  shapeRendering: true,
  slope: true,
  spacing: true,
  specularConstant: true,
  specularExponent: true,
  speed: true,
  spreadMethod: true,
  startOffset: true,
  stdDeviation: true,
  stemh: true,
  stemv: true,
  stitchTiles: true,
  stopColor: true,
  stopOpacity: true,
  strikethroughPosition: true,
  strikethroughThickness: true,
  string: true,
  stroke: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeLinecap: true,
  strokeLinejoin: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true,
  surfaceScale: true,
  systemLanguage: true,
  tableValues: true,
  targetX: true,
  targetY: true,
  textAnchor: true,
  textDecoration: true,
  textRendering: true,
  textLength: true,
  to: true,
  transform: true,
  u1: true,
  u2: true,
  underlinePosition: true,
  underlineThickness: true,
  unicode: true,
  unicodeBidi: true,
  unicodeRange: true,
  unitsPerEm: true,
  vAlphabetic: true,
  vHanging: true,
  vIdeographic: true,
  vMathematical: true,
  values: true,
  vectorEffect: true,
  version: true,
  vertAdvY: true,
  vertOriginX: true,
  vertOriginY: true,
  viewBox: true,
  viewTarget: true,
  visibility: true,
  widths: true,
  wordSpacing: true,
  writingMode: true,
  x: true,
  xHeight: true,
  x1: true,
  x2: true,
  xChannelSelector: true,
  xlinkActuate: true,
  xlinkArcrole: true,
  xlinkHref: true,
  xlinkRole: true,
  xlinkShow: true,
  xlinkTitle: true,
  xlinkType: true,
  xmlBase: true,
  xmlns: true,
  xmlnsXlink: true,
  xmlLang: true,
  xmlSpace: true,
  y: true,
  y1: true,
  y2: true,
  yChannelSelector: true,
  z: true,
  zoomAndPan: true
};

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var hasOwnProperty = {}.hasOwnProperty;
var validAttr = (function (name) {
  return hasOwnProperty.call(htmlProps, name) || hasOwnProperty.call(svgProps, name) || isCustomAttribute(name.toLowerCase()) || hasOwnProperty.call(reactProps, name);
});

//      


function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

//      


function isStyledComponent(target) /* : %checks */{
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}

//      

/* eslint-disable no-undef */
function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

//      
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialValue) {
  var listeners = [];
  var currentValue = initialValue;

  return {
    publish: function publish(value) {
      currentValue = value;
      listeners.forEach(function (listener) {
        return listener(currentValue);
      });
    },
    subscribe: function subscribe(listener) {
      listeners.push(listener);

      // Publish to this subscriber once immediately.
      listener(currentValue);

      return function () {
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });
      };
    }
  };
};

var _ThemeProvider$childC;
var _ThemeProvider$contex;

//      
/* globals React$Element */
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    if (this.context[CHANNEL]) {
      var subscribe = this.context[CHANNEL];
      this.unsubscribeToOuter = subscribe(function (theme) {
        _this2.outerTheme = theme;
      });
    }
    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL] = this.broadcast.subscribe, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) this.broadcast.publish(this.getTheme(nextProps.theme));
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.context[CHANNEL]) {
      this.unsubscribeToOuter();
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;
    if (__WEBPACK_IMPORTED_MODULE_4_is_function___default()(theme)) {
      var mergedTheme = theme(this.outerTheme);
      if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(mergedTheme)) {
        throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
      }
      return mergedTheme;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(theme)) {
      throw new Error('[ThemeProvider] Please make your theme prop a plain object');
    }
    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired, _ThemeProvider$childC);
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _ThemeProvider$contex);

var _AbstractStyledCompon;

//      
var AbstractStyledComponent = function (_Component) {
  inherits(AbstractStyledComponent, _Component);

  function AbstractStyledComponent() {
    classCallCheck(this, AbstractStyledComponent);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  return AbstractStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

AbstractStyledComponent.contextTypes = (_AbstractStyledCompon = {}, _AbstractStyledCompon[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _AbstractStyledCompon[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), _AbstractStyledCompon);

//      

var escapeRegex = /[[\].#*$><+~=|^:(),"'`]/g;
var multiDashRegex = /--+/g;

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  /* We depend on components having unique IDs */
  var identifiers = {};
  var generateId = function generateId(_displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : _displayName.replace(escapeRegex, '-') // Replace all possible CSS selectors
    .replace(multiDashRegex, '-'); // Replace multiple -- with single -

    var nr = (identifiers[displayName] || 0) + 1;
    identifiers[displayName] = nr;

    var hash = ComponentStyle.generateName(displayName + nr);
    var componentId = displayName + '-' + hash;
    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
  };

  var BaseStyledComponent = function (_AbstractStyledCompon) {
    inherits(BaseStyledComponent, _AbstractStyledCompon);

    function BaseStyledComponent() {
      var _temp, _this, _ret;

      classCallCheck(this, BaseStyledComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _AbstractStyledCompon.call.apply(_AbstractStyledCompon, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
        theme: null,
        generatedClassName: ''
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
      var attrs = this.constructor.attrs;

      var context = _extends({}, props, { theme: theme });
      if (attrs === undefined) {
        return context;
      }

      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
        var attr = attrs[key];
        // eslint-disable-next-line no-param-reassign
        acc[key] = typeof attr === 'function' ? attr(context) : attr;
        return acc;
      }, {});

      return _extends({}, context, this.attrs);
    };

    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
      var _constructor = this.constructor,
          componentStyle = _constructor.componentStyle,
          warnTooManyClasses = _constructor.warnTooManyClasses;

      var executionContext = this.buildExecutionContext(theme, props);
      var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.instance;
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (warnTooManyClasses !== undefined) warnTooManyClasses(className);

      return className;
    };

    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
      if (this.context[CHANNEL]) {
        var subscribe = this.context[CHANNEL];
        this.unsubscribe = subscribe(function (nextTheme) {
          // This will be called once immediately

          // Props should take precedence over ThemeProvider, which should take precedence over
          // defaultProps, but React automatically puts defaultProps on props.
          var defaultProps = _this2.constructor.defaultProps;

          var isDefaultTheme = defaultProps && _this2.props.theme === defaultProps.theme;
          var theme = _this2.props.theme && !isDefaultTheme ? _this2.props.theme : nextTheme;
          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
        });
      } else {
        var theme = this.props.theme || {};
        var generatedClassName = this.generateAndInjectStyles(theme, this.props);
        this.setState({ theme: theme, generatedClassName: generatedClassName });
      }
    };

    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.setState(function (oldState) {
        // Props should take precedence over ThemeProvider, which should take precedence over
        // defaultProps, but React automatically puts defaultProps on props.
        var defaultProps = _this3.constructor.defaultProps;

        var isDefaultTheme = defaultProps && nextProps.theme === defaultProps.theme;
        var theme = nextProps.theme && !isDefaultTheme ? nextProps.theme : oldState.theme;
        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

        return { theme: theme, generatedClassName: generatedClassName };
      });
    };

    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    };

    BaseStyledComponent.prototype.render = function render() {
      var _this4 = this;

      var innerRef = this.props.innerRef;
      var generatedClassName = this.state.generatedClassName;
      var _constructor2 = this.constructor,
          styledComponentId = _constructor2.styledComponentId,
          target = _constructor2.target;


      var isTargetTag = isTag(target);

      var className = [this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

      var baseProps = _extends({}, this.attrs, {
        className: className
      });

      if (isStyledComponent(target)) {
        baseProps.innerRef = innerRef;
      } else {
        baseProps.ref = innerRef;
      }

      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
        // Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || validAttr(propName))) {
          // eslint-disable-next-line no-param-reassign
          acc[propName] = _this4.props[propName];
        }

        return acc;
      }, baseProps);

      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(target, propsForElement);
    };

    return BaseStyledComponent;
  }(AbstractStyledComponent);

  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _StyledComponent$cont;

    var _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')' : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? options.displayName + '-' + options.componentId : componentId;

    var warnTooManyClasses = void 0;
    if (typeof process !== 'undefined' && "development" !== 'production') {
      warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : getComponentName(tag));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _StyledComponent$cont[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), _StyledComponent$cont);
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.warnTooManyClasses = warnTooManyClasses;
    StyledComponent.target = target;


    return StyledComponent;
  };

  return createStyledComponent;
});

// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

//      
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  var ComponentStyle = function () {
    function ComponentStyle(rules, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.componentId = componentId;
      if (!StyleSheet.instance.hasInjectedComponent(this.componentId)) {
        var placeholder = '.' + componentId + ' {}';
        StyleSheet.instance.deferredInject(componentId, true, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var flatCSS = flatten(this.rules, executionContext);
      var hash = doHash(this.componentId + flatCSS.join(''));

      var existingName = styleSheet.getName(hash);
      if (existingName) return existingName;

      var name = nameGenerator(hash);
      if (styleSheet.alreadyInjected(hash, name)) return name;

      var css = '\n' + stringifyRules(flatCSS, '.' + name);
      styleSheet.inject(this.componentId, true, css, hash, name);
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return nameGenerator(doHash(str));
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

//      
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

//      

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

//      
var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(replaceWhitespace(JSON.stringify(rules)));

    var existingName = StyleSheet.instance.getName(hash);
    if (existingName) return existingName;

    var name = nameGenerator(hash);
    if (StyleSheet.instance.alreadyInjected(hash, name)) return name;

    var generatedCSS = stringifyRules(rules, name, '@keyframes');
    StyleSheet.instance.inject('sc-keyframes-' + name, true, generatedCSS, hash, name);
    return name;
  };
});

//      
var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal(strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(JSON.stringify(rules));

    var componentId = 'sc-global-' + hash;
    if (StyleSheet.instance.hasInjectedComponent(componentId)) return;

    StyleSheet.instance.inject(componentId, false, stringifyRules(rules));
  };

  return injectGlobal;
});

//      


var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (typeof tag !== 'string' && typeof tag !== 'function') {
      // $FlowInvalidInputTest
      throw new Error('Cannot create styled-component for component: ' + tag);
    }

    /* This is callable directly as a template function */
    var templateFunction = function templateFunction(strings) {
      for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        interpolations[_key - 1] = arguments[_key];
      }

      return componentConstructor(tag, options, css.apply(undefined, [strings].concat(interpolations)));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || {}, attrs) }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

//      
/* globals ReactClass */

var wrapWithTheme = function wrapWithTheme(Component$$1) {
  var _WithTheme$contextTyp;

  var componentName = Component$$1.displayName || Component$$1.name || 'Component';

  var isStyledComponent$$1 = isStyledComponent(Component$$1);

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      if (!this.context[CHANNEL]) {
        throw new Error('[withTheme] Please use ThemeProvider to be able to use withTheme');
      }

      var subscribe = this.context[CHANNEL];
      this.unsubscribe = subscribe(function (theme) {
        _this2.setState({ theme: theme });
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (typeof this.unsubscribe === 'function') this.unsubscribe();
    };

    WithTheme.prototype.render = function render() {
      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var theme = this.state.theme;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({
        theme: theme
      }, this.props, {
        innerRef: isStyledComponent$$1 ? innerRef : undefined,
        ref: isStyledComponent$$1 ? undefined : innerRef
      }));
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  WithTheme.displayName = 'WithTheme(' + componentName + ')';
  WithTheme.styledComponentId = 'withTheme';
  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _WithTheme$contextTyp);


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
};

//      

/* Import singletons */
/* Import singleton constructors */
/* Import components */
/* Import Higher Order Components */
/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(77), __webpack_require__(83)))

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={darkGreen:'#187580',green:'#d7dd1a',olive:'#c2c600',violet:'#C5168C',darkViolet:'#9000a3',deepCerise:'#ca2293',yellow:'#ffd200',posYellow:'#e5b200',yellowGreen:'#b8e986',eletricViolet:'#bd10e0',orange:'#f2634e',red:'#f3614b',carnation:'#f45f48',lightRed:'#f45f48',crimson:'#F55D45',lightOlive:'#d7dd1a',easternBlue:'#23abba',lightEasternBlue:'#1F94A1',navyBlue:'#18a2b3',lightBlue:'#27c2d5',darkBlue:'#2a2264',linkNavyBlue:'#292663',skyBlue:'#28c4d4',paleBlue:'#9eaec8',greyBlue:'#73829b',veloeBlue:'#36bfd4',blizzardBlue:'#93E1E9',lightestBlue:'#f0f0f4',menuOptionGrey:'#5b5983',posGrey:'#d8d7e1',posGreyInfo:'#b5bbc1',deepPurple:'#100d49',charcoal:'#354762',darkGrey:'#8583a4',grey:'#c5c3d8',lighterGrey:'#edf0f2',borderGrey:'#eaebf0',disabledGrey:'#919394',lightGrey:'#a1a0b7',mediumGrey:'#9a98b2',separatorGrey:'#364762',paleGray:'#f1f1f7',paleGrayTwo:'#e9e9ef',paleGrayThree:'#e4e3ed',offWhite:'#f1f1f7',graySuit:'#bbbace',white:'#ffffff',darkSlateBlue:'#2a2264',lightGray:'#edf0f2',blueGray:'#b1b0c5',tealish:'#27c2d5',nearWhite:'#fafafc',ghostWhite:'#f8f8fb',lightSilver:'#c5c3d8',organicSilver:'#a7a6c4',deliveredGreen:'#6c9807'};module.exports=exports['default'];

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=rem;function rem(size){var remSize=parseFloat(size.replace('px',''))/16;return remSize+'rem';}module.exports=exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.txt10OpenSans=exports.txt12OpenSansLight=exports.txt12OpenSansBold=exports.txt12OpenSans=exports.txt14OpenSansBold=exports.txt14OpenSans=exports.txt16OpenSansBold=exports.txt16OpenSansLight=exports.txt16OpenSans=exports.txt18OpenSans=exports.txt18OpenSansLight=exports.txt20OpenSansBold=exports.txt20OpenSansLight=exports.txt40OpenSans=exports.txt20OpenSans=exports.txt24OpenSansNormal=exports.txt24OpenSansBold=exports.title14Galano=exports.title16Galano=exports.title18Galano=exports.title20GalanoBold=exports.title24GalanoBold=exports.title24Galano=exports.title26GalanoBold=exports.title30Galano=exports.title28GalanoBold=exports.title30GalanoBold=exports.title32GalanoBold=exports.title36GalanoBold=exports.title40GalanoBold=exports.title44GalanoBold=exports.title60GalanoBold=exports.title144GalanoBold=undefined;var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var title144GalanoBold=exports.title144GalanoBold='\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('144px')+';\n    font-weight: 600;\n    line-height: 1;\n';var title60GalanoBold=exports.title60GalanoBold='\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('60px')+';\n    font-weight: 600;\n';var title44GalanoBold=exports.title44GalanoBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('44px')+';\n    font-weight: 600;\n    line-height: 1.39;\n';var title40GalanoBold=exports.title40GalanoBold='\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('40px')+';\n    font-weight: 600;\n    letter-spacing: '+(0,_em2.default)('0.4px')+';\n    line-height: 1;\n';var title36GalanoBold=exports.title36GalanoBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('36px')+';\n    font-weight: 600;\n    line-height: 1.39;\n';var title32GalanoBold=exports.title32GalanoBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('32px')+';\n    font-weight: bold;\n    letter-spacing: '+(0,_em2.default)('0.3px')+';\n';var title30GalanoBold=exports.title30GalanoBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('30px')+';\n    font-weight: bold;\n    letter-spacing: '+(0,_em2.default)('4px')+';\n';var title28GalanoBold=exports.title28GalanoBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('28px')+';\n    font-weight: bold;\n    letter-spacing: 0.3px;\n';var title30Galano=exports.title30Galano='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('30px')+';\n';var title26GalanoBold=exports.title26GalanoBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\tline-height: 1.17;\n    font-family: Galano;\n    font-weight: bold;\n    font-size: '+(0,_rem2.default)('26px')+';\n';var title24Galano=exports.title24Galano='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('24px')+';\n';var title24GalanoBold=exports.title24GalanoBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\tline-height: 1.17;\n    font-family: Galano;\n    font-weight: bold;\n    font-size: '+(0,_rem2.default)('24px')+';\n';var title20GalanoBold=exports.title20GalanoBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('20px')+';\n    letter-spacing: '+(0,_em2.default)('2.7px')+';\n    font-weight: bold;\n    line-height: 1.17;\n';var title18Galano=exports.title18Galano='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('18px')+';\n    font-weight: bold;\n    line-height: 1;\n';var title16Galano=exports.title16Galano='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('16px')+';\n    font-weight: bold;\n';var title14Galano=exports.title14Galano='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: Galano;\n    font-size: '+(0,_rem2.default)('14px')+';\n    font-weight: bold;\n';var txt24OpenSansBold=exports.txt24OpenSansBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('24px')+';\n    font-weight: bold;\n';var txt24OpenSansNormal=exports.txt24OpenSansNormal='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('24px')+';\n    font-weight: 400;\n';var txt20OpenSans=exports.txt20OpenSans='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('20px')+';\n    font-weight: normal;\n    line-height: 1;\n';var txt40OpenSans=exports.txt40OpenSans='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('40px')+';\n    font-weight: normal;\n    line-height: 1;\n';var txt20OpenSansLight=exports.txt20OpenSansLight='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('20px')+';\n    font-weight: 200;\n';var txt20OpenSansBold=exports.txt20OpenSansBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('20px')+';\n    font-weight: 600;\n    line-height: 1;\n';var txt18OpenSansLight=exports.txt18OpenSansLight='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\tfont-size: 18px;\n\tline-height: 1.33;\n    font-family: OpenSans;\n    font-weight: 200;\n    letter-spacing: '+(0,_em2.default)('-0.5px')+';\n';var txt18OpenSans=exports.txt18OpenSans='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('18px')+';\n    font-weight: normal;\n';var txt16OpenSans=exports.txt16OpenSans='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('16px')+';\n    font-weight: normal;\n';var txt16OpenSansLight=exports.txt16OpenSansLight='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('16px')+';\n    font-weight: 200;\n    letter-spacing: -0.5px;\n';var txt16OpenSansBold=exports.txt16OpenSansBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('16px')+';\n    font-weight: bold;\n';var txt14OpenSans=exports.txt14OpenSans='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('14px')+';\n    font-weight: normal;\n';var txt14OpenSansBold=exports.txt14OpenSansBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('14px')+';\n    font-weight: bold;\n';var txt12OpenSans=exports.txt12OpenSans='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('12px')+';\n    font-weight: normal;\n    line-height: 1.83;\n';var txt12OpenSansBold=exports.txt12OpenSansBold='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('12px')+';\n    font-weight: bold;\n    line-height: 1.83;\n';var txt12OpenSansLight=exports.txt12OpenSansLight='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('12px')+';\n    font-weight: 200;\n    letter-spacing: '+(0,_em2.default)('1px')+';\n';var txt10OpenSans=exports.txt10OpenSans='\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    font-family: OpenSans;\n    font-size: 10px;\n    letter-spacing: 0.8px;\n    line-height: 1;\n';

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var core = __webpack_require__(68);
var hide = __webpack_require__(55);
var redefine = __webpack_require__(56);
var ctx = __webpack_require__(69);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _styledComponents=__webpack_require__(1);var media={small:function small(){return(0,_styledComponents.css)(['@media (max-width:767px){',';}'],_styledComponents.css.apply(undefined,arguments));},large:function large(){return(0,_styledComponents.css)(['@media (min-width:768px){',';}'],_styledComponents.css.apply(undefined,arguments));}};exports.default=media;module.exports=exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(977);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Box = __webpack_require__(364);

Object.defineProperty(exports, 'Box', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Box).default;
  }
});

var _Grid = __webpack_require__(182);

Object.defineProperty(exports, 'Grid', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Grid).default;
  }
});

var _Flex = __webpack_require__(1579);

Object.defineProperty(exports, 'Flex', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Flex).default;
  }
});

var _Half = __webpack_require__(1580);

Object.defineProperty(exports, 'Half', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Half).default;
  }
});

var _Third = __webpack_require__(1581);

Object.defineProperty(exports, 'Third', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Third).default;
  }
});

var _Quarter = __webpack_require__(1582);

Object.defineProperty(exports, 'Quarter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Quarter).default;
  }
});

var _Golden = __webpack_require__(1583);

Object.defineProperty(exports, 'Golden', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Golden).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(974)();
}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={STATE_MODAL:'STATE_MODAL',LOGIN_MSG_ERROR:'LOGIN_MSG_ERROR',SHOW_CAPTCHA:'SHOW_CAPTCHA',ACTIVATION_IDENTIFIER:'ACTIVATION_IDENTIFIER',INACTIVE_IDENTIFIER:'INACTIVE_IDENTIFIER',REPLACE_IDENTIFIER:'REPLACE_IDENTIFIER',NEW_IDENTIFIER:'NEW_IDENTIFIER',ADD_REPRESENTATIVE:'ADD_REPRESENTATIVE',CLEAR_CONTESTATION_PROTOCOL:'CLEAR_CONTESTATION_PROTOCOL',CLEAR_EC_QUERY_PLATE:'CLEAR_EC_QUERY_PLATE',DELETE_REPRESENTATIVE:'DELETE_REPRESENTATIVE',DOWNLOAD_STATEMENTS:'DOWNLOAD_STATEMENTS',DOWNLOAD_INVOICES:'DOWNLOAD_INVOICES',FETCH_ADDRESS_DELETE:'FETCH_ADDRESS_DELETE',FETCH_ADDRESS_UPDATE:'FETCH_ADDRESS_UPDATE',FETCH_BANK_LIST:'FETCH_BANK_LIST',FETCH_CANCEL_ACCOUNT:'FETCH_CANCEL_ACCOUNT',FETCH_CONTACT_UPDATE:'FETCH_CONTACT_UPDATE',FETCH_EC_CONTESTATIONS:'FETCH_EC_CONTESTATIONS',FETCH_EC_LOCATIONS:'FETCH_EC_LOCATIONS',FETCH_EC_MONEY_TRANSER:'FETCH_EC_MONEY_TRANSER',FETCH_EC_REQUEST_FILE_HISTORY:'FETCH_EC_REQUEST_FILE_HISTORY',FETCH_EC_QUERY_PLATE:'FETCH_EC_QUERY_PLATE',FETCH_GENERATE_CANCEL_ACCOUNT_TOKEN:'FETCH_GENERATE_CANCEL_ACCOUNT_TOKEN',FETCH_PROFILE_UPDATE:'FETCH_PROFILE_UPDATE',FETCH_PAYMENT_TYPE:'FETCH_PAYMENT_TYPE',FETCH_DUE_DATES:'FETCH_DUE_DATES',FETCH_SHIPPING_UPDATE_ADDRESS:'FETCH_SHIPPING_UPDATE_ADDRESS',FETCH_SHIPPING_AMOUNT:'FETCH_SHIPPING_AMOUNT',FETCH_USER:'FETCH_USER',FETCH_ZIP_CODE:'FETCH_ZIP_CODE',FETCH_STATES:'FETCH_STATES',FETCH_CITIES_FROM_STATE:'FETCH_CITIES_FROM_STATE',FETCH_VEHICLES:'FETCH_VEHICLES',FETCH_FILTER_VEHICLES:'FETCH_FILTER_VEHICLES',FETCH_TERMS_CONDITIONS:'FETCH_TERMS_CONDITIONS',FETCH_REASON_LIST:'FETCH_REASON_LIST',GET_EDIT_AUTH_PAYMENT:'GET_EDIT_AUTH_PAYMENT',SET_EDIT_AUTH_PAYMENT:'SET_EDIT_AUTH_PAYMENT',LOCK_EDIT_AUTH_PAYMENT:'LOCK_EDIT_AUTH_PAYMENT',LOGOUT:'LOGOUT',FETCH_RECOVER:'FETCH_RECOVER',RESET_INVOICES:'RESET_INVOICES',RESET_INVOICE_DETAILS:'RESET_INVOICE_DETAILS',RESET_RECHARGES:'RESET_RECHARGES',RESET_STATEMENTS:'RESET_STATEMENTS',SET_ACCOUNT_ACTIVE_PLAN_ID:'SET_ACCOUNT_ACTIVE_PLAN_ID',SET_ACCOUNT_PLAN:'SET_ACCOUNT_PLAN',SET_ACCOUNT_PLANS:'SET_ACCOUNT_PLANS',SET_EC_ACCOUNT_PLANS:'SET_EC_ACCOUNT_PLANS',SET_AUTHENTICATION:'SET_AUTHENTICATION',SET_NEW_DATA_VALUE:'SET_NEW_DATA_VALUE',SET_NEW_DUE_DATE:'SET_NEW_DUE_DATE',UPDATE_CONTESTATION_PROTOCOL:'UPDATE_CONTESTATION_PROTOCOL',UPDATE_INVOICE_DETAILS:'UPDATE_INVOICE_DETAILS',UPDATE_INVOICES:'UPDATE_INVOICES',UPDATE_PLAN_RESUME:'UPDATE_PLAN_RESUME',UPDATE_REASONS:'UPDATE_REASONS',UPDATE_REASONS_BLOCK:'UPDATE_REASONS_BLOCK',UPDATE_RECHARGES:'UPDATE_RECHARGES',UPDATE_REPRESENTATIVE:'UPDATE_REPRESENTATIVE',UPDATE_STATEMENT:'UPDATE_STATEMENT',UPDATE_STATEMENTS:'UPDATE_STATEMENTS',UPDATE_RECOVER_TOKEN_STATUS:'UPDATE_RECOVER_TOKEN_STATUS',SET_RECHARGE_VALUES:'SET_RECHARGE_VALUES',SET_CURRENT_RECHARGE_VALUE:'SET_CURRENT_RECHARGE_VALUE',SET_CANCEL_ACCOUNT_STATUS:'SET_CANCEL_ACCOUNT_STATUS',SET_PAYMENT_INFO:'SET_PAYENT_INFO',UPDATE_PLAN_DATA:'UPDATE_PLAN_DATA',SET_CHANGE_RECHARGE:'SET_CHANGE_RECHARGE',SET_RESENT_STATEMENT:'SET_RESENT_STATEMENT',// Manage Infos
FETCH_MANAGE_INF:'FETCH_MANAGE_INF',FETCH_MANAGE_INF_FINISHED:'FETCH_MANAGE_INF_FINISHED',FETCH_HIST_MANAGE_INF:'FETCH_HIST_MANAGE_INF',FETCH_HIST_MANAGE_INF_FINISHED:'FETCH_HIST_MANAGE_INF_FINISHED',FETCH_TOP5_MANAGE_INF:'FETCH_TOP5_MANAGE_INF',FETCH_TOP5_MANAGE_INF_FINISHED:'FETCH_TOP5_MANAGE_INF_FINISHED',UPDATE_MANAGE_INF:'UPDATE_MANAGE_INF',UPDATE_MANAGE_INF_FINISHED:'UPDATE_MANAGE_INF_FINISHED'};module.exports=exports['default'];

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionTypes", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayInsert", function() { return arrayInsert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayMove", function() { return arrayMove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayPop", function() { return arrayPop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayPush", function() { return arrayPush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayRemove", function() { return arrayRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayRemoveAll", function() { return arrayRemoveAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayShift", function() { return arrayShift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arraySplice", function() { return arraySplice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arraySwap", function() { return arraySwap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayUnshift", function() { return arrayUnshift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autofill", function() { return autofill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blur", function() { return blur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "change", function() { return change; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearSubmitErrors", function() { return clearSubmitErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroy", function() { return destroy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focus", function() { return focus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialize", function() { return initialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerField", function() { return registerField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubmitFailed", function() { return setSubmitFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubmitSucceeded", function() { return setSubmitSucceeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startAsyncValidation", function() { return startAsyncValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startSubmit", function() { return startSubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopAsyncValidation", function() { return stopAsyncValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopSubmit", function() { return stopSubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submit", function() { return submit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "touch", function() { return touch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unregisterField", function() { return unregisterField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "untouch", function() { return untouch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__ = __webpack_require__(493);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultShouldAsyncValidate", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__ = __webpack_require__(494);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultShouldValidate", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Form__ = __webpack_require__(1032);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_4__Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormSection__ = __webpack_require__(1033);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormSection", function() { return __WEBPACK_IMPORTED_MODULE_5__FormSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SubmissionError__ = __webpack_require__(495);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubmissionError", function() { return __WEBPACK_IMPORTED_MODULE_6__SubmissionError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__propTypes__ = __webpack_require__(1035);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return __WEBPACK_IMPORTED_MODULE_7__propTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldInputPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_7__propTypes__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldMetaPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_7__propTypes__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_7__propTypes__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_7__propTypes__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Field__ = __webpack_require__(1036);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return __WEBPACK_IMPORTED_MODULE_8__Field__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Fields__ = __webpack_require__(1106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Fields", function() { return __WEBPACK_IMPORTED_MODULE_9__Fields__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FieldArray__ = __webpack_require__(1109);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldArray", function() { return __WEBPACK_IMPORTED_MODULE_10__FieldArray__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__formValueSelector__ = __webpack_require__(1127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formValueSelector", function() { return __WEBPACK_IMPORTED_MODULE_11__formValueSelector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__formValues__ = __webpack_require__(1129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formValues", function() { return __WEBPACK_IMPORTED_MODULE_12__formValues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__getFormNames__ = __webpack_require__(1131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormNames", function() { return __WEBPACK_IMPORTED_MODULE_13__getFormNames__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__getFormValues__ = __webpack_require__(1133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormValues", function() { return __WEBPACK_IMPORTED_MODULE_14__getFormValues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__getFormInitialValues__ = __webpack_require__(1135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormInitialValues", function() { return __WEBPACK_IMPORTED_MODULE_15__getFormInitialValues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getFormSyncErrors__ = __webpack_require__(1137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormSyncErrors", function() { return __WEBPACK_IMPORTED_MODULE_16__getFormSyncErrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getFormMeta__ = __webpack_require__(1139);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormMeta", function() { return __WEBPACK_IMPORTED_MODULE_17__getFormMeta__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getFormAsyncErrors__ = __webpack_require__(1141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormAsyncErrors", function() { return __WEBPACK_IMPORTED_MODULE_18__getFormAsyncErrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__getFormSyncWarnings__ = __webpack_require__(1143);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormSyncWarnings", function() { return __WEBPACK_IMPORTED_MODULE_19__getFormSyncWarnings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__getFormSubmitErrors__ = __webpack_require__(1145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormSubmitErrors", function() { return __WEBPACK_IMPORTED_MODULE_20__getFormSubmitErrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__isDirty__ = __webpack_require__(1147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isDirty", function() { return __WEBPACK_IMPORTED_MODULE_21__isDirty__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__isInvalid__ = __webpack_require__(1149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isInvalid", function() { return __WEBPACK_IMPORTED_MODULE_22__isInvalid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__isPristine__ = __webpack_require__(1152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isPristine", function() { return __WEBPACK_IMPORTED_MODULE_23__isPristine__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__isValid__ = __webpack_require__(1153);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isValid", function() { return __WEBPACK_IMPORTED_MODULE_24__isValid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isSubmitting__ = __webpack_require__(1154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSubmitting", function() { return __WEBPACK_IMPORTED_MODULE_25__isSubmitting__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__hasSubmitSucceeded__ = __webpack_require__(1156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hasSubmitSucceeded", function() { return __WEBPACK_IMPORTED_MODULE_26__hasSubmitSucceeded__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__hasSubmitFailed__ = __webpack_require__(1158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hasSubmitFailed", function() { return __WEBPACK_IMPORTED_MODULE_27__hasSubmitFailed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__reduxForm__ = __webpack_require__(1160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduxForm", function() { return __WEBPACK_IMPORTED_MODULE_28__reduxForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__reducer__ = __webpack_require__(1191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return __WEBPACK_IMPORTED_MODULE_29__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__values__ = __webpack_require__(1194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_30__values__["a"]; });







// alias for propTypes
























var actionTypes = __WEBPACK_IMPORTED_MODULE_1__actionTypes__;
var arrayInsert = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayInsert;
var arrayMove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayMove;
var arrayPop = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPop;
var arrayPush = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPush;
var arrayRemove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemove;
var arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemoveAll;
var arrayShift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayShift;
var arraySplice = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySplice;
var arraySwap = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySwap;
var arrayUnshift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayUnshift;
var autofill = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].autofill;
var blur = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].blur;
var change = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].change;
var clearSubmitErrors = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearSubmitErrors;
var destroy = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].destroy;
var focus = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].focus;
var initialize = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].initialize;
var registerField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].registerField;
var reset = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].reset;
var setSubmitFailed = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitFailed;
var setSubmitSucceeded = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitSucceeded;
var startAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startAsyncValidation;
var startSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startSubmit;
var stopAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopAsyncValidation;
var stopSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopSubmit;
var submit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].submit;
var touch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].touch;
var unregisterField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].unregisterField;
var untouch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].untouch;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.services=exports.utils=exports.reducers=exports.actions=undefined;var _actions=__webpack_require__(13);var actions=_interopRequireWildcard(_actions);var _reducers=__webpack_require__(1386);var _reducers2=_interopRequireDefault(_reducers);var _utils=__webpack_require__(95);var utils=_interopRequireWildcard(_utils);var _services=__webpack_require__(175);var services=_interopRequireWildcard(_services);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}exports.actions=actions;exports.reducers=_reducers2.default;exports.utils=utils;exports.services=services;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _clearECQueryPlate=__webpack_require__(1198);Object.defineProperty(exports,'clearECQueryPlate',{enumerable:true,get:function get(){return _interopRequireDefault(_clearECQueryPlate).default;}});var _fetchCancelAccount=__webpack_require__(1199);Object.defineProperty(exports,'fetchCancelAccount',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchCancelAccount).default;}});var _fetchCancelAccountTokenCreate=__webpack_require__(1322);Object.defineProperty(exports,'fetchCancelAccountTokenCreate',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchCancelAccountTokenCreate).default;}});var _fetchCancelAccountTokenValidate=__webpack_require__(1323);Object.defineProperty(exports,'fetchCancelAccountTokenValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchCancelAccountTokenValidate).default;}});var _fetchDashboardResume=__webpack_require__(1324);Object.defineProperty(exports,'fetchDashboardResume',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchDashboardResume).default;}});var _fetchResendStatement=__webpack_require__(1329);Object.defineProperty(exports,'fetchResendStatement',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchResendStatement).default;}});var _fetchECContestations=__webpack_require__(1330);Object.defineProperty(exports,'fetchECContestations',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchECContestations).default;}});var _fetchECLocations=__webpack_require__(1331);Object.defineProperty(exports,'fetchECLocations',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchECLocations).default;}});var _fetchECMoneyTransfer=__webpack_require__(1332);Object.defineProperty(exports,'fetchECMoneyTransfer',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchECMoneyTransfer).default;}});var _fetchECQueryPlate=__webpack_require__(1333);Object.defineProperty(exports,'fetchECQueryPlate',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchECQueryPlate).default;}});var _fetchECRequestFileHistory=__webpack_require__(1334);Object.defineProperty(exports,'fetchECRequestFileHistory',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchECRequestFileHistory).default;}});var _fetchGetBusinessUser=__webpack_require__(1335);Object.defineProperty(exports,'fetchGetBusinessUser',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchGetBusinessUser).default;}});Object.defineProperty(exports,'fetchGetBusinessUserOnly',{enumerable:true,get:function get(){return _fetchGetBusinessUser.fetchGetBusinessUserOnly;}});var _fetchGetUser=__webpack_require__(1338);Object.defineProperty(exports,'fetchGetUser',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchGetUser).default;}});var _fetchGetVehicles=__webpack_require__(1339);Object.defineProperty(exports,'fetchGetVehicles',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchGetVehicles).default;}});var _fetchFilterVehicles=__webpack_require__(1340);Object.defineProperty(exports,'fetchFilterVehicles',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchFilterVehicles).default;}});var _fetchRecover=__webpack_require__(1341);Object.defineProperty(exports,'fetchRecover',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchRecover).default;}});var _fetchReasons=__webpack_require__(1342);Object.defineProperty(exports,'fetchReasons',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchReasons).default;}});var _fetchStatement=__webpack_require__(1343);Object.defineProperty(exports,'fetchStatement',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchStatement).default;}});var _fetchUpdateBusinessContact=__webpack_require__(1344);Object.defineProperty(exports,'fetchUpdateBusinessContact',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchUpdateBusinessContact).default;}});var _fetchUpdateBusinessProfile=__webpack_require__(1345);Object.defineProperty(exports,'fetchUpdateBusinessProfile',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchUpdateBusinessProfile).default;}});var _fetchUpdateContact=__webpack_require__(1346);Object.defineProperty(exports,'fetchUpdateContact',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchUpdateContact).default;}});var _fetchUpdatePassword=__webpack_require__(1347);Object.defineProperty(exports,'fetchUpdatePassword',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchUpdatePassword).default;}});var _fetchUpdateProfile=__webpack_require__(1348);Object.defineProperty(exports,'fetchUpdateProfile',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchUpdateProfile).default;}});var _fetchVerifyUserPassword=__webpack_require__(1349);Object.defineProperty(exports,'fetchVerifyUserPassword',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchVerifyUserPassword).default;}});var _fetchZipCode=__webpack_require__(1350);Object.defineProperty(exports,'fetchZipCode',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchZipCode).default;}});var _fetchStates=__webpack_require__(1353);Object.defineProperty(exports,'fetchStates',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchStates).default;}});var _fetchCitiesFromState=__webpack_require__(1354);Object.defineProperty(exports,'fetchCitiesFromState',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchCitiesFromState).default;}});var _types=__webpack_require__(10);Object.defineProperty(exports,'types',{enumerable:true,get:function get(){return _interopRequireDefault(_types).default;}});var _fetchNewPassword=__webpack_require__(1355);Object.defineProperty(exports,'fetchNewPassword',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchNewPassword).default;}});var _fetchRecoverTokenStatus=__webpack_require__(1356);Object.defineProperty(exports,'fetchRecoverTokenStatus',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchRecoverTokenStatus).default;}});var _fetchTermsAndConditions=__webpack_require__(1357);Object.defineProperty(exports,'fetchTermsAndConditions',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchTermsAndConditions).default;}});var _fetchBankList=__webpack_require__(1358);Object.defineProperty(exports,'fetchBankList',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchBankList).default;}});var _fetchPlanData=__webpack_require__(1359);Object.defineProperty(exports,'fetchPlanData',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchPlanData).default;}});var _fetchFollowRequest=__webpack_require__(1360);Object.defineProperty(exports,'fetchFollowRequest',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchFollowRequest).default;}});var _fetchBlockIdentifier=__webpack_require__(1361);Object.defineProperty(exports,'fetchReasonList',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchBlockIdentifier).default;}});var _fetchFollowRequestDetails=__webpack_require__(1362);Object.defineProperty(exports,'fetchFollowRequestDetails',{enumerable:true,get:function get(){return _interopRequireDefault(_fetchFollowRequestDetails).default;}});var _fetchAddress=__webpack_require__(1363);Object.keys(_fetchAddress).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _fetchAddress[key];}});});var _loginModal=__webpack_require__(1364);Object.keys(_loginModal).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _loginModal[key];}});});var _fetchBusinessAddress=__webpack_require__(1365);Object.keys(_fetchBusinessAddress).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _fetchBusinessAddress[key];}});});var _fetchContestationProtocol=__webpack_require__(1366);Object.keys(_fetchContestationProtocol).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _fetchContestationProtocol[key];}});});var _fetchRepresentatives=__webpack_require__(1367);Object.keys(_fetchRepresentatives).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _fetchRepresentatives[key];}});});var _fetchDashboardStatements=__webpack_require__(1368);Object.keys(_fetchDashboardStatements).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _fetchDashboardStatements[key];}});});var _fetchDashboardInvoices=__webpack_require__(1369);Object.keys(_fetchDashboardInvoices).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _fetchDashboardInvoices[key];}});});var _fetchDashboardRecharges=__webpack_require__(1370);Object.keys(_fetchDashboardRecharges).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _fetchDashboardRecharges[key];}});});var _fetchShippingAddress=__webpack_require__(1371);Object.keys(_fetchShippingAddress).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _fetchShippingAddress[key];}});});var _accountPlans=__webpack_require__(1373);Object.keys(_accountPlans).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _accountPlans[key];}});});var _authentication=__webpack_require__(1374);Object.keys(_authentication).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _authentication[key];}});});var _recharge=__webpack_require__(1375);Object.keys(_recharge).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _recharge[key];}});});var _options=__webpack_require__(1376);Object.keys(_options).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _options[key];}});});var _activation=__webpack_require__(1377);Object.keys(_activation).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _activation[key];}});});var _editPaymentData=__webpack_require__(1378);Object.keys(_editPaymentData).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _editPaymentData[key];}});});var _fetchInvoiceDetails=__webpack_require__(1380);Object.keys(_fetchInvoiceDetails).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _fetchInvoiceDetails[key];}});});var _fetchManagInf=__webpack_require__(1382);Object.keys(_fetchManagInf).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _fetchManagInf[key];}});});var _paymentInfo=__webpack_require__(1385);Object.keys(_paymentInfo).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _paymentInfo[key];}});});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Button=__webpack_require__(155);var _Button2=_interopRequireDefault(_Button);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Button2.default;module.exports=exports['default'];

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(1482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(1483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(565);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(1485);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(1486);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(1487);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(1488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(1489);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(1490);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(1491);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(1492);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(1493);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_11__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(1494);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.hideModal=exports.showModal=undefined;var _ActionTypes=__webpack_require__(230);var showModal=exports.showModal=function showModal(type,props){return{type:_ActionTypes.SHOW_MODAL,payload:{type:type,props:props}};};var hideModal=exports.hideModal=function hideModal(){return{type:_ActionTypes.HIDE_MODAL};};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.19.3
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, tmpLocale, parentConfig = baseConfig;
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
            parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.3';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)(module)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var CONFIRM_UPDATE=exports.CONFIRM_UPDATE='CONFIRM_UPDATE';var TOKEN_MODAL=exports.TOKEN_MODAL='TOKEN_MODAL';var INPUT_MODAL=exports.INPUT_MODAL='INPUT_MODAL';

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default='\n    max-width: '+(0,_rem2.default)('1000px')+';\n    padding: 0 '+(0,_rem2.default)('30px')+';\n    margin: 0 auto;\n    width: 100%;\n';module.exports=exports['default'];

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(1670);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(1672);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(1675);

var _HelmetConstants = __webpack_require__(593);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splice__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getIn__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setIn__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepEqual__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deleteIn__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys__ = __webpack_require__(1105);








var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: __WEBPACK_IMPORTED_MODULE_1__getIn__["a" /* default */],
  setIn: __WEBPACK_IMPORTED_MODULE_2__setIn__["a" /* default */],
  deepEqual: __WEBPACK_IMPORTED_MODULE_3__deepEqual__["a" /* default */],
  deleteIn: __WEBPACK_IMPORTED_MODULE_4__deleteIn__["a" /* default */],
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: __WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */],
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: __WEBPACK_IMPORTED_MODULE_0__splice__["a" /* default */],
  toJS: function toJS(value) {
    return value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _templateObject=_taggedTemplateLiteral(['\n        padding: 0 ',';\n    '],['\n        padding: 0 ',';\n    ']);var _gridStyled=__webpack_require__(8);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}exports.default=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'Content',componentId:'sc-1dxb4zr-0'})(['margin:0 auto;max-width:',';padding:0 ',';width:100%;',';'],(0,_rem2.default)('1000px'),(0,_rem2.default)('20px'),_media2.default.large(_templateObject,(0,_rem2.default)('30px')));module.exports=exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(63);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/Icon.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _waiting=__webpack_require__(1584);var _waiting2=_interopRequireDefault(_waiting);var _appStore=__webpack_require__(1585);var _appStore2=_interopRequireDefault(_appStore);var _alertPurple=__webpack_require__(1586);var _alertPurple2=_interopRequireDefault(_alertPurple);var _tagAlert=__webpack_require__(1587);var _tagAlert2=_interopRequireDefault(_tagAlert);var _attachment=__webpack_require__(1588);var _attachment2=_interopRequireDefault(_attachment);var _overdue=__webpack_require__(1589);var _overdue2=_interopRequireDefault(_overdue);var _backArrow=__webpack_require__(1590);var _backArrow2=_interopRequireDefault(_backArrow);var _calendar=__webpack_require__(1591);var _calendar2=_interopRequireDefault(_calendar);var _car=__webpack_require__(1592);var _car2=_interopRequireDefault(_car);var _card=__webpack_require__(1593);var _card2=_interopRequireDefault(_card);var _check=__webpack_require__(1594);var _check2=_interopRequireDefault(_check);var _checkStatus=__webpack_require__(1595);var _checkStatus2=_interopRequireDefault(_checkStatus);var _checkGreen=__webpack_require__(1596);var _checkGreen2=_interopRequireDefault(_checkGreen);var _close=__webpack_require__(1597);var _close2=_interopRequireDefault(_close);var _diners=__webpack_require__(1598);var _diners2=_interopRequireDefault(_diners);var _dropdownArrow=__webpack_require__(1599);var _dropdownArrow2=_interopRequireDefault(_dropdownArrow);var _edit=__webpack_require__(1600);var _edit2=_interopRequireDefault(_edit);var _eye=__webpack_require__(1601);var _eye2=_interopRequireDefault(_eye);var _exclude=__webpack_require__(1602);var _exclude2=_interopRequireDefault(_exclude);var _closed=__webpack_require__(1603);var _closed2=_interopRequireDefault(_closed);var _fuel=__webpack_require__(1604);var _fuel2=_interopRequireDefault(_fuel);var _gift=__webpack_require__(1605);var _gift2=_interopRequireDefault(_gift);var _greenCheck=__webpack_require__(1606);var _greenCheck2=_interopRequireDefault(_greenCheck);var _hand=__webpack_require__(1607);var _hand2=_interopRequireDefault(_hand);var _hamburger=__webpack_require__(1608);var _hamburger2=_interopRequireDefault(_hamburger);var _install=__webpack_require__(1609);var _install2=_interopRequireDefault(_install);var _info=__webpack_require__(1610);var _info2=_interopRequireDefault(_info);var _loading=__webpack_require__(1611);var _loading2=_interopRequireDefault(_loading);var _money=__webpack_require__(1612);var _money2=_interopRequireDefault(_money);var _maestro=__webpack_require__(1613);var _maestro2=_interopRequireDefault(_maestro);var _master=__webpack_require__(1614);var _master2=_interopRequireDefault(_master);var _modalClose=__webpack_require__(1615);var _modalClose2=_interopRequireDefault(_modalClose);var _lock=__webpack_require__(1616);var _lock2=_interopRequireDefault(_lock);var _percentual=__webpack_require__(1617);var _percentual2=_interopRequireDefault(_percentual);var _park=__webpack_require__(1618);var _park2=_interopRequireDefault(_park);var _packageDelivery=__webpack_require__(1619);var _packageDelivery2=_interopRequireDefault(_packageDelivery);var _payment=__webpack_require__(1620);var _payment2=_interopRequireDefault(_payment);var _playStore=__webpack_require__(1621);var _playStore2=_interopRequireDefault(_playStore);var _faceIcon=__webpack_require__(1622);var _faceIcon2=_interopRequireDefault(_faceIcon);var _refills=__webpack_require__(1623);var _refills2=_interopRequireDefault(_refills);var _resend=__webpack_require__(1624);var _resend2=_interopRequireDefault(_resend);var _rightArrow=__webpack_require__(1625);var _rightArrow2=_interopRequireDefault(_rightArrow);var _rightArrowLarge=__webpack_require__(1626);var _rightArrowLarge2=_interopRequireDefault(_rightArrowLarge);var _leftArrowLarge=__webpack_require__(1627);var _leftArrowLarge2=_interopRequireDefault(_leftArrowLarge);var _socialIcons=__webpack_require__(1628);var _socialIcons2=_interopRequireDefault(_socialIcons);var _supply=__webpack_require__(1629);var _supply2=_interopRequireDefault(_supply);var _veloeLogo=__webpack_require__(1630);var _veloeLogo2=_interopRequireDefault(_veloeLogo);var _visa=__webpack_require__(1631);var _visa2=_interopRequireDefault(_visa);var _tagVeloe=__webpack_require__(1632);var _tagVeloe2=_interopRequireDefault(_tagVeloe);var _tramaVeloe=__webpack_require__(1633);var _tramaVeloe2=_interopRequireDefault(_tramaVeloe);var _tramaVeloeFooter=__webpack_require__(1634);var _tramaVeloeFooter2=_interopRequireDefault(_tramaVeloeFooter);var _trophy=__webpack_require__(1635);var _trophy2=_interopRequireDefault(_trophy);var _truck=__webpack_require__(1636);var _truck2=_interopRequireDefault(_truck);var _toll=__webpack_require__(1637);var _toll2=_interopRequireDefault(_toll);var _update=__webpack_require__(1638);var _update2=_interopRequireDefault(_update);var _newClose=__webpack_require__(1639);var _newClose2=_interopRequireDefault(_newClose);var _dropdown=__webpack_require__(1640);var _dropdown2=_interopRequireDefault(_dropdown);var _download=__webpack_require__(1641);var _download2=_interopRequireDefault(_download);var _share=__webpack_require__(1642);var _share2=_interopRequireDefault(_share);var _print=__webpack_require__(1643);var _print2=_interopRequireDefault(_print);var _dollarSign=__webpack_require__(1644);var _dollarSign2=_interopRequireDefault(_dollarSign);var _doc=__webpack_require__(1645);var _doc2=_interopRequireDefault(_doc);var _barcode=__webpack_require__(1646);var _barcode2=_interopRequireDefault(_barcode);var _styles=__webpack_require__(1647);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var files={waiting:_waiting2.default,'app-store':_appStore2.default,alert:_alertPurple2.default,alertTag:_tagAlert2.default,attachment:_attachment2.default,overdue:_overdue2.default,'back-arrow':_backArrow2.default,barcode:_barcode2.default,calendar:_calendar2.default,car:_car2.default,card:_card2.default,check:_check2.default,checkStatus:_checkStatus2.default,checkGreen:_checkGreen2.default,close:_close2.default,diners:_diners2.default,'dropdown-arrow':_dropdownArrow2.default,dropdown:_dropdown2.default,download:_download2.default,edit:_edit2.default,eye:_eye2.default,exclude:_exclude2.default,closed:_closed2.default,fuel:_fuel2.default,gift:_gift2.default,'green-check':_greenCheck2.default,hand:_hand2.default,hamburger:_hamburger2.default,install:_install2.default,info:_info2.default,loading:_loading2.default,money:_money2.default,maestro:_maestro2.default,master:_master2.default,'modal-close':_modalClose2.default,lock:_lock2.default,packageDelivery:_packageDelivery2.default,percentual:_percentual2.default,park:_park2.default,payment:_payment2.default,print:_print2.default,'play-store':_playStore2.default,recharge:_faceIcon2.default,refills:_refills2.default,resend:_resend2.default,'right-arrow':_rightArrow2.default,'right-arrow-large':_rightArrowLarge2.default,'left-arrow-large':_leftArrowLarge2.default,'social-icons':_socialIcons2.default,share:_share2.default,supply:_supply2.default,'veloe-logo':_veloeLogo2.default,visa:_visa2.default,tagVeloe:_tagVeloe2.default,'trama-veloe':_tramaVeloe2.default,'trama-veloe-footer':_tramaVeloeFooter2.default,toll:_toll2.default,trophy:_trophy2.default,truck:_truck2.default,update:_update2.default,'new-close':_newClose2.default,'dollar-sign':_dollarSign2.default,doc:_doc2.default};var renderIcon=function renderIcon(icon){var selectedIcon=Object.keys(files).filter(function(iconFile){return icon===iconFile;});return files[selectedIcon];};function Icon(props){var selectedIcon=renderIcon(props.icon);return _react2.default.createElement(_styles.Svg,_extends({},props,{xmlns:'http://www.w3.org/2000/svg',dangerouslySetInnerHTML:selectedIcon,__source:{fileName:_jsxFileName,lineNumber:146}}));}Icon.defaultProps={icon:'',svgStyle:''};Icon.propTypes={icon:_propTypes.string.isRequired,svgStyle:_propTypes.string};exports.default=Icon;module.exports=exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Icon=__webpack_require__(30);Object.defineProperty(exports,'Icon',{enumerable:true,get:function get(){return _interopRequireDefault(_Icon).default;}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/styles/utilities/Hide.js';var _templateObject=_taggedTemplateLiteral(['\n        display: none;\n    '],['\n        display: none;\n    ']);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _gridStyled=__webpack_require__(8);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}exports.default=(0,_styledComponents2.default)(function(_ref){var at=_ref.at,props=_objectWithoutProperties(_ref,['at']);return _react2.default.createElement(_gridStyled.Box,_extends({},props,{__source:{fileName:_jsxFileName,lineNumber:6}}));}).withConfig({displayName:'Hide',componentId:'sc-r7n5xa-0'})(['',';'],function(props){return _media2.default[props.at](_templateObject);});module.exports=exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(159)('wks');
var uid = __webpack_require__(116);
var Symbol = __webpack_require__(21).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=em;function em(size){var emSize=parseFloat(size.replace('px',''))/16;return emSize+'em';}module.exports=exports['default'];

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setLoading=setLoading;function setLoading(isLoading){return{type:'SET_LOADING',isLoading:isLoading};}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(71);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(24)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__createBinding"] = __createBinding;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__spreadArrays"] = __spreadArrays;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldGet"] = __classPrivateFieldGet;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldSet"] = __classPrivateFieldSet;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var IE8_DOM_DEFINE = __webpack_require__(409);
var toPrimitive = __webpack_require__(78);
var dP = Object.defineProperty;

exports.f = __webpack_require__(38) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var DOMProperty = __webpack_require__(145);
var ReactDOMComponentFlags = __webpack_require__(452);

var invariant = __webpack_require__(17);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.gqlMutate=exports.gqlQuery=exports.revokeToken=exports.refreshToken=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _apolloClient=__webpack_require__(1221);var _index=__webpack_require__(1230);var _index2=__webpack_require__(1237);var _index3=__webpack_require__(1241);var _index4=__webpack_require__(1242);var _constants=__webpack_require__(149);var _storage=__webpack_require__(343);var _qs=__webpack_require__(340);var _qs2=_interopRequireDefault(_qs);var _axiosClient=__webpack_require__(341);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var refreshToken=exports.refreshToken=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _refreshToken=arguments.length>0&&arguments[0]!==undefined?arguments[0]:(0,_storage.getRefreshToken)();var retryCount=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var postData,cred,statusCode,err;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;if(!((0,_storage.getTimeRefreshToken)()<new Date().getTime()/1000+600)){_context.next=10;break;}postData=_qs2.default.stringify({grant_type:'refresh_token',refresh_token:_refreshToken});_context.next=5;return(0,_axiosClient.post)(_constants.AUTH_URL,postData,{preventToken:true,headers:{'Content-Type':'application/x-www-form-urlencoded'}});case 5:cred=_context.sent;_context.next=8;return revokeToken();case 8:(0,_storage.setAuthObj)(cred);(0,_storage.setTimeRefreshToken)(new Date().getTime()/1000);case 10:_context.next=24;break;case 12:_context.prev=12;_context.t0=_context['catch'](0);statusCode=_context.t0.status;if(!_context.t0.networkError){_context.next=20;break;}statusCode=_context.t0.networkError.statusCode;// Erros 504 não são tratados pois podem gerar duplicidade de dados em algumas requisições
if(![502].includes(statusCode)){_context.next=20;break;}if(!(retryCount<_constants.AJAX_MAX_RETRY)){_context.next=20;break;}return _context.abrupt('return',_refreshToken(_refreshToken,retryCount+1));case 20:err=new Error('Error refreshing token:'+_context.t0.message);err.status=statusCode;if(err.status===401)err.status=403;// FIXME: o tratamento na UI é feito apenas para o erro 403
throw err;case 24:case'end':return _context.stop();}}},_callee,undefined,[[0,12]]);}));return function refreshToken(){return _ref.apply(this,arguments);};}();var revokeToken=exports.revokeToken=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_axiosClient.post)(_constants.REVOKE_TOKEN,{access_token:(0,_storage.getAccessToken)()},{preventToken:true,headers:{'Content-Type':'application/x-www-form-urlencoded'}});case 2:case'end':return _context2.stop();}}},_callee2,undefined);}));return function revokeToken(){return _ref2.apply(this,arguments);};}();var apolloClient=new _apolloClient.ApolloClient({link:_index4.ApolloLink.from([(0,_index3.onError)(function(_ref3){var graphQLErrors=_ref3.graphQLErrors,networkError=_ref3.networkError;if(graphQLErrors)graphQLErrors.map(function(_ref4){var message=_ref4.message,locations=_ref4.locations,path=_ref4.path;return console.log('[GraphQL error]: Message: '+message+', Location: '+locations+', Path: '+path);});if(networkError)console.log('[Network error]: '+networkError);}),new _index2.HttpLink({uri:_constants.GRAPHQL_URL,credentials:'same-origin'})]),cache:new _index.InMemoryCache()});apolloClient.defaultOptions={query:{fetchPolicy:'network-only'}};var handleNetworkErros=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(e){var retryCount=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var retryFn=arguments[2];var statusCode;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:statusCode=-1;if(!e.networkError){_context3.next=12;break;}statusCode=e.networkError.statusCode;// Erros 504 não são tratados pois podem gerar duplicidade de dados em algumas requisições
if(![502].includes(statusCode)){_context3.next=8;break;}if(!(retryCount<_constants.GRAPHQL_MAX_RETY)){_context3.next=6;break;}return _context3.abrupt('return',retryFn(retryCount+1));case 6:_context3.next=12;break;case 8:if(!(statusCode===403)){_context3.next=12;break;}_context3.next=11;return refreshToken();case 11:return _context3.abrupt('return',retryFn(1));case 12:e.status=statusCode;throw e;case 14:case'end':return _context3.stop();}}},_callee3,undefined);}));return function handleNetworkErros(_x3){return _ref5.apply(this,arguments);};}();var gqlQuery=exports.gqlQuery=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(query,variables){var retryCount=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;var token;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:// TODO tratar expiração de token e outros erros
token=(0,_storage.getAccessToken)();_context4.prev=1;_context4.next=4;return apolloClient.query({query:query,variables:variables,context:{headers:_extends({Authorization:localStorage.getItem('OauthDomain')==='c6'?_constants.API_AUTHORIZATION_C6:_constants.API_AUTHORIZATION},token&&{token:token})}});case 4:return _context4.abrupt('return',_context4.sent);case 7:_context4.prev=7;_context4.t0=_context4['catch'](1);return _context4.abrupt('return',handleNetworkErros(_context4.t0,retryCount,function(retry){return gqlQuery(query,variables,retry);}));case 10:_context4.prev=10;(0,_storage.setTimeRefreshToken)(new Date().getTime()/1000);return _context4.finish(10);case 13:case'end':return _context4.stop();}}},_callee4,undefined,[[1,7,10,13]]);}));return function gqlQuery(_x5,_x6){return _ref6.apply(this,arguments);};}();var gqlMutate=exports.gqlMutate=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(mutation,variables){var retryCount=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;_context5.next=3;return apolloClient.mutate({mutation:mutation,variables:variables,context:{headers:{Authorization:localStorage.getItem('OauthDomain')==='c6'?_constants.API_AUTHORIZATION_C6:_constants.API_AUTHORIZATION,token:(0,_storage.getAccessToken)()}}});case 3:return _context5.abrupt('return',_context5.sent);case 6:_context5.prev=6;_context5.t0=_context5['catch'](0);return _context5.abrupt('return',handleNetworkErros(_context5.t0,retryCount,function(retry){return gqlMutate(mutation,variables,retry);}));case 9:_context5.prev=9;(0,_storage.setTimeRefreshToken)(new Date().getTime()/1000);return _context5.finish(9);case 12:case'end':return _context5.stop();}}},_callee5,undefined,[[0,6,9,12]]);}));return function gqlMutate(_x8,_x9){return _ref7.apply(this,arguments);};}();exports.default=apolloClient;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.4';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, customDefaultsAssignIn);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77), __webpack_require__(151)(module)))

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.renderCvcInput=exports.renderValidThruInput=exports.renderAccountDigitInput=exports.renderAccountInput=exports.renderAgencyInput=exports.renderCardInput=exports.renderPasswordInput=exports.renderCheckboxField=exports.renderZipCodeInput=exports.renderCnpjInput=exports.renderCpfInput=exports.renderPhoneInput=exports.renderTelephoneField=exports.renderSelectField=exports.renderRoundedInput=exports.renderTextInput=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/utils/renderInputs.js';exports.renderGenderField=renderGenderField;exports.renderMaritialStatusField=renderMaritialStatusField;exports.renderTelephoneTypesField=renderTelephoneTypesField;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _actions=__webpack_require__(13);var _TextInput=__webpack_require__(101);var _TextInput2=_interopRequireDefault(_TextInput);var _Select=__webpack_require__(595);var _Select2=_interopRequireDefault(_Select);var _PhoneInput=__webpack_require__(1701);var _PhoneInput2=_interopRequireDefault(_PhoneInput);var _Checkbox=__webpack_require__(1704);var _Checkbox2=_interopRequireDefault(_Checkbox);var _PasswordInput=__webpack_require__(599);var _PasswordInput2=_interopRequireDefault(_PasswordInput);var _masks=__webpack_require__(390);var _RoundedInput=__webpack_require__(1713);var _RoundedInput2=_interopRequireDefault(_RoundedInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var renderTextInput=exports.renderTextInput=function renderTextInput(props){return _react2.default.createElement(_TextInput2.default,_extends({},props.input,{label:props.label,disabled:props.disabled,placeholder:props.placeholder,errorMessage:props.meta.touched&&props.meta.error,isRequired:props.isRequired,lockCursor:props.lockCursor,negative:props.negative,maxlength:props.maxlength,lengthCounter:props.lengthCounter,tooltip:props.tooltip,autoComplete:props.autoComplete,id:props.id,onPaste:props.onPaste,__source:{fileName:_jsxFileName,lineNumber:24}}));};var renderRoundedInput=exports.renderRoundedInput=function renderRoundedInput(props){return _react2.default.createElement(_RoundedInput2.default,_extends({},props.input,props.meta,{placeholder:props.placeholder,__source:{fileName:_jsxFileName,lineNumber:43}}));};var renderSelectField=exports.renderSelectField=function renderSelectField(props){return _react2.default.createElement(_Select2.default,_extends({},props.input,{label:props.label,onChange:function onChange(value){return props.input.onChange(value);},options:props.options,errorMessage:props.meta.touched&&props.meta.error,isRequired:props.isRequired,placeholder:props.placeholder,negative:props.negative,disabled:props.disabled,__source:{fileName:_jsxFileName,lineNumber:47}}));};var renderTelephoneField=exports.renderTelephoneField=function renderTelephoneField(props){return _react2.default.createElement(_PhoneInput2.default,_extends({},props.input,{label:props.label,disabled:props.disabled,errorMessage:props.meta.touched&&props.meta.error,isRequired:props.isRequired,negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:61}}));};var renderPhoneInput=exports.renderPhoneInput=function renderPhoneInput(props){return _react2.default.createElement(_TextInput2.default,_extends({},props.input,{maxlength:props.maxlength,label:props.label,disabled:props.disabled,placeholder:props.placeholder,errorMessage:props.errorMessage,value:_aleloLogic.utils.phoneMask(''+props.input.value),negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:72}}));};var renderCpfInput=exports.renderCpfInput=function renderCpfInput(props){return _react2.default.createElement(_TextInput2.default,_extends({},props.input,{label:props.label,disabled:props.disabled,placeholder:props.placeholder,errorMessage:props.meta.touched&&props.meta.error,isRequired:props.isRequired,value:_aleloLogic.utils.cpfMask(props.input.value),negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:85}}));};var renderCnpjInput=exports.renderCnpjInput=function renderCnpjInput(props){return _react2.default.createElement(_TextInput2.default,_extends({},props.input,{label:props.label,disabled:props.disabled,placeholder:props.placeholder,errorMessage:props.meta.touched&&props.meta.error,isRequired:props.isRequired,value:_aleloLogic.utils.cnpjMask(props.input.value),negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:98}}));};var renderZipCodeInput=exports.renderZipCodeInput=function renderZipCodeInput(props){return _react2.default.createElement(_TextInput2.default,_extends({},props.input,{label:props.label,disabled:props.disabled,errorMessage:props.meta.touched&&props.meta.error,value:_aleloLogic.utils.cepMask(props.input.value),negative:props.negative,loading:props.loading,__source:{fileName:_jsxFileName,lineNumber:111}}));};var renderCheckboxField=exports.renderCheckboxField=function renderCheckboxField(props){return _react2.default.createElement(_Checkbox2.default,_extends({},props.input,{label:props.label,checked:props.input.value,disabled:props.disabled,onChange:function onChange(value){return props.input.onChange(value);},negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:123}}));};var renderPasswordInput=exports.renderPasswordInput=function renderPasswordInput(props){var _props$meta=props.meta,touched=_props$meta.touched,error=_props$meta.error;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:137}},_react2.default.createElement(_PasswordInput2.default,_extends({},props.input,{label:props.label,placeholder:props.placeholder,disabled:props.disabled,errorMessage:touched&&!!error,passwordMessage:touched&&error,type:'password',negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:138}})));};function renderGenderField(props){var getGenders=function getGenders(){return(0,_actions.fetchGenderList)().then(function(response){return{options:response};});};return _react2.default.createElement(_Select2.default,_extends({},props.input,{label:props.label,onChange:function onChange(value){return props.input.onChange(value);},options:[],errorMessage:props.meta.touched&&props.meta.error,isRequired:props.isRequired,negative:props.negative,disabled:props.disabled,loadOptions:getGenders,__source:{fileName:_jsxFileName,lineNumber:156}}));}function renderMaritialStatusField(props){var getMaritialStatus=function getMaritialStatus(){return(0,_actions.fetchMaritialStatusList)().then(function(response){return{options:response};});};return _react2.default.createElement(_Select2.default,_extends({},props.input,{label:props.label,onChange:function onChange(value){return props.input.onChange(value);},options:[],errorMessage:props.meta.touched&&props.meta.error,isRequired:props.isRequired,negative:props.negative,disabled:props.disabled,loadOptions:getMaritialStatus,__source:{fileName:_jsxFileName,lineNumber:175}}));}function renderTelephoneTypesField(props){var getTelephoneTypes=function getTelephoneTypes(){return(0,_actions.fetchTelephoneTypeList)().then(function(response){return{options:response};});};return _react2.default.createElement(_Select2.default,_extends({},props.input,{label:props.label,onChange:function onChange(value){return props.input.onChange(value);},options:[],errorMessage:props.meta.touched&&props.meta.error,isRequired:props.isRequired,negative:props.negative,disabled:props.disabled,loadOptions:getTelephoneTypes,__source:{fileName:_jsxFileName,lineNumber:193}}));}var renderCardInput=exports.renderCardInput=function renderCardInput(props){return _react2.default.createElement(_TextInput2.default,_extends({},props.input,{maxlength:props.maxlength,label:props.label,disabled:props.disabled,placeholder:props.placeholder,errorMessage:props.meta.touched&&props.meta.error?props.errorMessage||props.meta.error:'',value:(0,_masks.creditCardMask)(''+props.input.value),negative:props.negative,labelIcon:props.labelIcon,__source:{fileName:_jsxFileName,lineNumber:208}}));};var renderAgencyInput=exports.renderAgencyInput=function renderAgencyInput(props){return _react2.default.createElement(_TextInput2.default,_extends({},props.input,{maxlength:props.maxlength,label:props.label,disabled:props.disabled,placeholder:props.placeholder,errorMessage:props.meta.touched&&props.meta.error?props.errorMessage||props.meta.error:'',value:(0,_masks.numberMask)(''+props.input.value,4),negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:224}}));};var renderAccountInput=exports.renderAccountInput=function renderAccountInput(props){return _react2.default.createElement(_TextInput2.default,_extends({},props.input,{maxlength:props.maxlength,label:props.label,disabled:props.disabled,placeholder:props.placeholder,errorMessage:props.meta.touched&&props.meta.error?props.errorMessage||props.meta.error:'',value:(0,_masks.numberMask)(''+props.input.value,props.limitDigit?props.limitDigit:7),negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:239}}));};var renderAccountDigitInput=exports.renderAccountDigitInput=function renderAccountDigitInput(props){return _react2.default.createElement(_TextInput2.default,_extends({},props.input,{maxlength:props.maxlength,label:props.label,disabled:props.disabled,placeholder:props.placeholder,errorMessage:props.meta.touched&&props.meta.error?props.errorMessage||props.meta.error:'',value:(0,_masks.accountDigitMask)(''+props.input.value,props.limitDigit?props.limitDigit:1),negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:254}}));};var renderValidThruInput=exports.renderValidThruInput=function renderValidThruInput(props){return _react2.default.createElement(_TextInput2.default,_extends({},props.input,{maxlength:props.maxlength,label:props.label,disabled:props.disabled,placeholder:props.placeholder,isRequired:props.isRequired,errorMessage:props.meta.touched&&props.meta.error?props.errorMessage||props.meta.error:'',value:(0,_masks.validThruMask)(''+props.input.value),negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:269}}));};var renderCvcInput=exports.renderCvcInput=function renderCvcInput(props){return _react2.default.createElement(_TextInput2.default,_extends({},props.input,{maxlength:props.maxlength,label:props.label,disabled:props.disabled,placeholder:props.placeholder,errorMessage:props.meta.touched&&props.meta.error?props.errorMessage||props.meta.error:'',value:(0,_masks.cvcMask)(''+props.input.value,props.limitDigit),negative:props.negative,tooltip:props.tooltip,tooltipColor:props.tooltipColor,tooltipPositionRight:props.tooltipPositionRight,endIcon:props.endIcon,__source:{fileName:_jsxFileName,lineNumber:285}}));};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(79);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/* eslint-disable */var VALIDATION_CPF=exports.VALIDATION_CPF=/[0-9]{3}\.?[0-9]{3}\.?[0-9]{3}\-?[0-9]{2}/;var VALIDATION_CNPJ=exports.VALIDATION_CNPJ=/[0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2}/;var VALIDATION_PHONE=exports.VALIDATION_PHONE=/^1\d\d(\d\d)?$|^0800 ?\d{3} ?\d{4}$|^(\(0?([1-9a-zA-Z][0-9a-zA-Z])?[1-9]\d\) ?|0?([1-9a-zA-Z][0-9a-zA-Z])?[1-9]\d[ .-]?)?(9|9[ .-])?[2-9]\d{3}[ .-]?\d{4}$/;var VALIDATION_DDD=exports.VALIDATION_DDD=/\(?(\d{2})\)?/;var VALIDATION_EMAIL=exports.VALIDATION_EMAIL=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;var VALIDATION_CEP=exports.VALIDATION_CEP=/^[0-9]{5}-?[0-9]{3}$/;var VALIDATION_OLD_PLATE=exports.VALIDATION_OLD_PLATE=/[a-z]{3}[0-9]{4}$/;var VALIDATION_NEW_PLATE=exports.VALIDATION_NEW_PLATE=/[a-z]{3}[0-9]{1}[a-z]{1}[0-9]{2}$/;var VALIDATION_IDENTIFIER=exports.VALIDATION_IDENTIFIER=/(^\d{10})$/;var VALIDATION_CEP_MSG_EMPTY=exports.VALIDATION_CEP_MSG_EMPTY='O CEP é obrigatório.';var VALIDATION_CEP_MSG_INVALID=exports.VALIDATION_CEP_MSG_INVALID='O CEP digitado é inválido.';var VALIDATION_CPF_MSG_EMPTY=exports.VALIDATION_CPF_MSG_EMPTY='O CPF é obrigatório.';var VALIDATION_CPF_MSG_INVALID=exports.VALIDATION_CPF_MSG_INVALID='O CPF digitado é inválido.';var VALIDATION_CNPJ_MSG_EMPTY=exports.VALIDATION_CNPJ_MSG_EMPTY='O CNPJ é obrigatório.';var VALIDATION_CNPJ_MSG_INVALID=exports.VALIDATION_CNPJ_MSG_INVALID='O CNPJ digitado é inválido.';var VALIDATION_EMAIL_MSG_EMPTY=exports.VALIDATION_EMAIL_MSG_EMPTY='O e-mail é obrigatório.';var VALIDATION_EMAIL_MSG_INVALID=exports.VALIDATION_EMAIL_MSG_INVALID='O e-mail digitado é inválido.';var VALIDATION_PHONE_MSG_EMPTY=exports.VALIDATION_PHONE_MSG_EMPTY='O telefone é obrigatório.';var VALIDATION_PHONE_MSG_INVALID=exports.VALIDATION_PHONE_MSG_INVALID='O telefone digitado é inválido.';var VALIDATION_DOB_MSG_EMPTY=exports.VALIDATION_DOB_MSG_EMPTY='A data de nascimento é obrigatória.';var VALIDATION_DOB_MSG_INVALID=exports.VALIDATION_DOB_MSG_INVALID='A data de nascimento digitada é inválida.';var FORMAT_DATE=exports.FORMAT_DATE='DD/MM/YYYY';var ISO_FORMAT_DATE=exports.ISO_FORMAT_DATE='YYYY-MM-DDTHH:mm:ss.SSSZ';var FORMAT_TIME=exports.FORMAT_TIME='HH:mm';var FORMAT_TIME_INVALID=exports.FORMAT_TIME_INVALID='To format a time, a proper object should be present as a parameter.';var FORMAT_DATE_INVALID=exports.FORMAT_DATE_INVALID='Data inválida';var FORMAT_HOUR_MINUTE_INVALID=exports.FORMAT_HOUR_MINUTE_INVALID='Horário inválido';var VALIDATION_DBT_MSG_INVALID=exports.VALIDATION_DBT_MSG_INVALID='Data precisa ser menor que a data atual.';var FORMAT_DATE_MINIMUM_YEAR=exports.FORMAT_DATE_MINIMUM_YEAR='1900-01-01';var EMPTY_FIELD=exports.EMPTY_FIELD='Campo obrigatório';var VALIDATION_DDD_MSG_EMPTY=exports.VALIDATION_DDD_MSG_EMPTY='O DDD é obrigatório.';var VALIDATION_DDD_MSG_INVALID=exports.VALIDATION_DDD_MSG_INVALID='O DDD digitado é inválido.';var VALIDATION_PLATE_MSG_EMPTY=exports.VALIDATION_PLATE_MSG_EMPTY='A placa é obrigatório.';var VALIDATION_PLATE_MSG_INVALID=exports.VALIDATION_PLATE_MSG_INVALID='A placa informada é inválida.';var VALIDATION_IDENTIFIER_MSG_EMPTY=exports.VALIDATION_IDENTIFIER_MSG_EMPTY='O VeloeTag é obrigatório';var VALIDATION_IDENTIFIER_MSG_INVALID=exports.VALIDATION_IDENTIFIER_MSG_INVALID='O VeloeTag é inválida.';

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/contestacao.a047c51b.png";

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var parser = __webpack_require__(1244);

var parse = parser.parse;

// Strip insignificant whitespace
// Note that this could do a lot more, such as reorder fields etc.
function normalize(string) {
  return string.replace(/[\s,]+/g, ' ').trim();
}

// A map docString -> graphql document
var docCache = {};

// A map fragmentName -> [normalized source]
var fragmentSourceMap = {};

function cacheKeyFromLoc(loc) {
  return normalize(loc.source.body.substring(loc.start, loc.end));
}

// For testing.
function resetCaches() {
  docCache = {};
  fragmentSourceMap = {};
}

// Take a unstripped parsed document (query/mutation or even fragment), and
// check all fragment definitions, checking for name->source uniqueness.
// We also want to make sure only unique fragments exist in the document.
var printFragmentWarnings = true;
function processFragments(ast) {
  var astFragmentMap = {};
  var definitions = [];

  for (var i = 0; i < ast.definitions.length; i++) {
    var fragmentDefinition = ast.definitions[i];

    if (fragmentDefinition.kind === 'FragmentDefinition') {
      var fragmentName = fragmentDefinition.name.value;
      var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);

      // We know something about this fragment
      if (fragmentSourceMap.hasOwnProperty(fragmentName) && !fragmentSourceMap[fragmentName][sourceKey]) {

        // this is a problem because the app developer is trying to register another fragment with
        // the same name as one previously registered. So, we tell them about it.
        if (printFragmentWarnings) {
          console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
            + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
            + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
        }

        fragmentSourceMap[fragmentName][sourceKey] = true;

      } else if (!fragmentSourceMap.hasOwnProperty(fragmentName)) {
        fragmentSourceMap[fragmentName] = {};
        fragmentSourceMap[fragmentName][sourceKey] = true;
      }

      if (!astFragmentMap[sourceKey]) {
        astFragmentMap[sourceKey] = true;
        definitions.push(fragmentDefinition);
      }
    } else {
      definitions.push(fragmentDefinition);
    }
  }

  ast.definitions = definitions;
  return ast;
}

function disableFragmentWarnings() {
  printFragmentWarnings = false;
}

function stripLoc(doc, removeLocAtThisLevel) {
  var docType = Object.prototype.toString.call(doc);

  if (docType === '[object Array]') {
    return doc.map(function (d) {
      return stripLoc(d, removeLocAtThisLevel);
    });
  }

  if (docType !== '[object Object]') {
    throw new Error('Unexpected input.');
  }

  // We don't want to remove the root loc field so we can use it
  // for fragment substitution (see below)
  if (removeLocAtThisLevel && doc.loc) {
    delete doc.loc;
  }

  // https://github.com/apollographql/graphql-tag/issues/40
  if (doc.loc) {
    delete doc.loc.startToken;
    delete doc.loc.endToken;
  }

  var keys = Object.keys(doc);
  var key;
  var value;
  var valueType;

  for (key in keys) {
    if (keys.hasOwnProperty(key)) {
      value = doc[keys[key]];
      valueType = Object.prototype.toString.call(value);

      if (valueType === '[object Object]' || valueType === '[object Array]') {
        doc[keys[key]] = stripLoc(value, true);
      }
    }
  }

  return doc;
}

var experimentalFragmentVariables = false;
function parseDocument(doc) {
  var cacheKey = normalize(doc);

  if (docCache[cacheKey]) {
    return docCache[cacheKey];
  }

  var parsed = parse(doc, { experimentalFragmentVariables: experimentalFragmentVariables });
  if (!parsed || parsed.kind !== 'Document') {
    throw new Error('Not a valid GraphQL document.');
  }

  // check that all "new" fragments inside the documents are consistent with
  // existing fragments of the same name
  parsed = processFragments(parsed);
  parsed = stripLoc(parsed, false);
  docCache[cacheKey] = parsed;

  return parsed;
}

function enableExperimentalFragmentVariables() {
  experimentalFragmentVariables = true;
}

function disableExperimentalFragmentVariables() {
  experimentalFragmentVariables = false;
}

// XXX This should eventually disallow arbitrary string interpolation, like Relay does
function gql(/* arguments */) {
  var args = Array.prototype.slice.call(arguments);

  var literals = args[0];

  // We always get literals[0] and then matching post literals for each arg given
  var result = (typeof(literals) === "string") ? literals : literals[0];

  for (var i = 1; i < args.length; i++) {
    if (args[i] && args[i].kind && args[i].kind === 'Document') {
      result += args[i].loc.source.body;
    } else {
      result += args[i];
    }

    result += literals[i];
  }

  return parseDocument(result);
}

// Support typescript, which isn't as nice as Babel about default exports
gql.default = gql;
gql.resetCaches = resetCaches;
gql.disableFragmentWarnings = disableFragmentWarnings;
gql.enableExperimentalFragmentVariables = enableExperimentalFragmentVariables;
gql.disableExperimentalFragmentVariables = disableExperimentalFragmentVariables;

module.exports = gql;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/confirmation.71a1cbe3.png";

/***/ }),
/* 50 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ImersiveHeader/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _styles=__webpack_require__(1767);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function ImersiveHeader(_ref){var text=_ref.text,url=_ref.url,isColored=_ref.isColored,back=_ref.back;return _react2.default.createElement(_styles.Wrapper,{isColored:isColored,__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:9}},url!=='/'?_react2.default.createElement(_styles.BackLink,{to:url,__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement(_styles.BackIcon,{icon:'back-arrow',width:'8px',height:'12px',viewBox:'0 0 8 12',__source:{fileName:_jsxFileName,lineNumber:12}}),text):_react2.default.createElement(_styles.ButtonLink,{onClick:back,__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement(_styles.BackIcon,{icon:'back-arrow',width:'8px',height:'12px',viewBox:'0 0 8 12',__source:{fileName:_jsxFileName,lineNumber:17}}),text)));}ImersiveHeader.defaultProps={text:null,url:'/'};ImersiveHeader.propTypes={text:_propTypes.string.isRequired,url:_propTypes.string};exports.default=ImersiveHeader;module.exports=exports['default'];

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(991);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(995);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_1__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(996);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_2__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(320);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(999);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_5__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(1000);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__matchPath__ = __webpack_require__(321);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_7__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withRouter__ = __webpack_require__(1001);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_8__withRouter__["a"]; });



















/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(40);
var createDesc = __webpack_require__(115);
module.exports = __webpack_require__(38) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var hide = __webpack_require__(55);
var has = __webpack_require__(59);
var SRC = __webpack_require__(116)('src');
var $toString = __webpack_require__(683);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(68).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var fails = __webpack_require__(24);
var defined = __webpack_require__(79);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(372)('wks');
var uid = __webpack_require__(235);
var Symbol = __webpack_require__(87).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 59 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(160);
var defined = __webpack_require__(79);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(161);
var createDesc = __webpack_require__(115);
var toIObject = __webpack_require__(60);
var toPrimitive = __webpack_require__(78);
var has = __webpack_require__(59);
var IE8_DOM_DEFINE = __webpack_require__(409);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(38) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(59);
var toObject = __webpack_require__(45);
var IE_PROTO = __webpack_require__(272)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getProfilesPartners=exports.getProfileActivation=exports.getOrders=exports.getTrackIdentifiersDetails=exports.getTermsAndConditions=exports.getAccountPlansActivation=exports.getAccountPlans=exports.authenticateGQL=exports.logout=exports.authenticate=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var authenticate=exports.authenticate=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(login,password,responseCaptcha){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt('return',authenticateGQL(login,password));case 1:case'end':return _context.stop();}}},_callee,this);}));return function authenticate(_x,_x2,_x3){return _ref.apply(this,arguments);};}();var logout=exports.logout=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:(0,_storage.removeAuthObj)();case 1:case'end':return _context2.stop();}}},_callee2,this);}));return function logout(){return _ref2.apply(this,arguments);};}();var authenticateGQL=exports.authenticateGQL=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(login,password,responseCaptcha){var scope,headers,cred,accessToken;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;scope=void 0;headers={'Content-Type':'application/x-www-form-urlencoded'};if(login.indexOf('@c6bank.com')!==-1){headers['x-auth-domain']='PORTAL_PJ';localStorage.setItem('OauthDomain','c6');}else{localStorage.setItem('OauthDomain','');}(0,_storage.removeAuthObj)();_context3.next=7;return(0,_axiosClient.post)(_constants.AUTH_URL,_qs2.default.stringify({grant_type:'password',scope:scope||_constants.AUTH_SCOPE,username:login,password:password}),{headers:headers});case 7:cred=_context3.sent;(0,_storage.setAuthObj)(cred);accessToken=(0,_storage.getAccessTokenObject)();// TODO Trata erros
if(!(!accessToken||!accessToken.title)){_context3.next=12;break;}throw new Error('accessToken Object is invalid:'+JSON.stringify({accessToken:accessToken,cred:cred}));case 12:return _context3.abrupt('return',{accountType:accessToken.title.toLowerCase(),success:true,active:true});case 15:_context3.prev=15;_context3.t0=_context3['catch'](0);console.error('authenticate failed:',_context3.t0);throw _context3.t0;case 19:case'end':return _context3.stop();}}},_callee3,this,[[0,15]]);}));return function authenticateGQL(_x4,_x5,_x6){return _ref3.apply(this,arguments);};}();// FIXME accountId não é passado para a função
var getAccountPlans=exports.getAccountPlans=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(accountId){var contas,infoAdicionaisPromises,infosAdicionais;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.t0=_plans.transformConta;_context4.next=3;return(0,_apolloClient.gqlQuery)(_plans.gqlContas);case 3:_context4.t1=_context4.sent;contas=(0,_context4.t0)(_context4.t1);infoAdicionaisPromises=contas.map(function(c){return(0,_apolloClient.gqlQuery)(_plans.gqlInfoExtra,{idConta:c.id});});_context4.next=8;return Promise.all(infoAdicionaisPromises);case 8:infosAdicionais=_context4.sent;return _context4.abrupt('return',contas.map(function(conta,ind){return _extends({},conta,(0,_plans.transformInfosAdicionais)(infosAdicionais[ind]));}));case 10:case'end':return _context4.stop();}}},_callee4,this);}));return function getAccountPlans(_x7){return _ref4.apply(this,arguments);};}();var getAccountPlansActivation=exports.getAccountPlansActivation=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(accountId){var contas;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.t0=_plans.transformConta;_context5.next=3;return(0,_apolloClient.gqlQuery)(_plans.gqlContas);case 3:_context5.t1=_context5.sent;contas=(0,_context5.t0)(_context5.t1);return _context5.abrupt('return',contas.map(function(conta,ind){return _extends({},conta,{identifiersOrders:[],identifiers:[]});}));case 6:case'end':return _context5.stop();}}},_callee5,this);}));return function getAccountPlansActivation(_x8){return _ref5.apply(this,arguments);};}();var getTermsAndConditions=exports.getTermsAndConditions=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(){var _ref7,_ref7$data,_ref7$data$buscarTerm,buscarTermo,_ref7$data$buscarTerm2,buscarTermoPrivacidade,_ref7$data$buscarManu,buscarManualDoUsuario,_buscarTermo,_buscarTermo$,termo,termoPrivacidade,manualUsuario;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return(0,_apolloClient.gqlQuery)(_term.gqlTermo);case 2:_ref7=_context6.sent;_ref7$data=_ref7.data;_ref7$data=_ref7$data===undefined?{}:_ref7$data;_ref7$data$buscarTerm=_ref7$data.buscarTermo,buscarTermo=_ref7$data$buscarTerm===undefined?[]:_ref7$data$buscarTerm,_ref7$data$buscarTerm2=_ref7$data.buscarTermoPrivacidade,buscarTermoPrivacidade=_ref7$data$buscarTerm2===undefined?[]:_ref7$data$buscarTerm2,_ref7$data$buscarManu=_ref7$data.buscarManualDoUsuario,buscarManualDoUsuario=_ref7$data$buscarManu===undefined?[]:_ref7$data$buscarManu;_buscarTermo=_slicedToArray(buscarTermo,1),_buscarTermo$=_buscarTermo[0],termo=_buscarTermo$===undefined?{}:_buscarTermo$;termoPrivacidade=buscarTermoPrivacidade;manualUsuario=buscarManualDoUsuario;return _context6.abrupt('return',{termo:termo,termoPrivacidade:termoPrivacidade,manualUsuario:manualUsuario});case 10:case'end':return _context6.stop();}}},_callee6,this);}));return function getTermsAndConditions(){return _ref6.apply(this,arguments);};}();var getOrders=exports.getOrders=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(conta,type){var result;return regeneratorRuntime.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return(0,_apolloClient.gqlQuery)(_tracking.gqlPedidosEntregasRecargas,{conta:conta});case 2:result=_context8.sent;return _context8.abrupt('return',(0,_orders.transformOrders)(result,type));case 4:case'end':return _context8.stop();}}},_callee8,this);}));return function getOrders(_x11,_x12){return _ref9.apply(this,arguments);};}();var getProfileActivation=exports.getProfileActivation=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(parametro){var _ref11,parametrizacao,profileActivationValeu;return regeneratorRuntime.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.next=2;return(0,_apolloClient.gqlQuery)(_parameterization.gqlParametrizacao,{parametro:parametro});case 2:_ref11=_context9.sent;parametrizacao=_ref11.data.parametrizacao;profileActivationValeu=window.atob(parametrizacao[0].valor);return _context9.abrupt('return',profileActivationValeu);case 6:case'end':return _context9.stop();}}},_callee9,this);}));return function getProfileActivation(_x13){return _ref10.apply(this,arguments);};}();var getProfilesPartners=exports.getProfilesPartners=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(param,email){var profilePartners,profiles;return regeneratorRuntime.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:profilePartners=param.map(function(item){return(0,_apolloClient.gqlQuery)(_parameterization.gqlEmailsUsuarios,{parametro:item,email:email});});_context10.next=3;return Promise.all(profilePartners);case 3:profiles=_context10.sent;console.log(profiles);return _context10.abrupt('return',profiles.map(function(profile){var emailsUsuarios=profile.data.emailsUsuarios;return emailsUsuarios;}));case 6:case'end':return _context10.stop();}}},_callee10,this);}));return function getProfilesPartners(_x14,_x15){return _ref12.apply(this,arguments);};}();var _accountService=__webpack_require__(1200);Object.keys(_accountService).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _accountService[key];}});});var _qs=__webpack_require__(340);var _qs2=_interopRequireDefault(_qs);var _axiosClient=__webpack_require__(341);var _storage=__webpack_require__(343);var _constants=__webpack_require__(149);var _apolloClient=__webpack_require__(42);var _plans=__webpack_require__(542);var _tracking=__webpack_require__(1319);var _orders=__webpack_require__(1320);var _term=__webpack_require__(1321);var _parameterization=__webpack_require__(555);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getTrackIdentifiersDetails=exports.getTrackIdentifiersDetails=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(accountNumber,orderNumber){var queryresult;return regeneratorRuntime.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return(0,_apolloClient.gqlQuery)(_tracking.gqlPedidosEntregasRecargas,{conta:accountNumber});case 2:queryresult=_context7.sent;return _context7.abrupt('return',(0,_tracking.transformRastreio)(queryresult,orderNumber));case 4:case'end':return _context7.stop();}}},_callee7,undefined);}));return function getTrackIdentifiersDetails(_x9,_x10){return _ref8.apply(this,arguments);};}();

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(527);
var isBuffer = __webpack_require__(528);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sendStatementEmail=exports.downloadTicket=exports.downloadCSVInvoice=exports.downloadFatura=exports.downloadStatement=exports.downloadStatementCSV=exports.resendStatement=exports.downloadInvoice=exports.downloadVehiclesCSV=exports.getVehiclesByNumber=exports.getVehicles=exports.getPlanData=exports.getStatements=exports.deletePlateFilter=exports.updatePlateFilter=exports.addPlateFilter=exports.getPlateFilters=exports.getRecharges=exports.getInvoices=exports.getPlanResume=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var getPlanResume=exports.getPlanResume=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(planId){var resumo;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.t0=_resumo.resumoTransform;_context.next=3;return(0,_apolloClient.gqlQuery)(_resumo.gqlResumo,{idConta:planId});case 3:_context.t1=_context.sent;_context.t2=planId;resumo=(0,_context.t0)(_context.t1,_context.t2);return _context.abrupt('return',resumo);case 7:case'end':return _context.stop();}}},_callee,this);}));return function getPlanResume(_x){return _ref.apply(this,arguments);};}();var getInvoices=exports.getInvoices=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(planId,next){var proxima,payload,_ref3,_ref3$data,data,_data$historicoFatura,historicoFaturas,_historicoFaturas$pag,paginacao,response;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:proxima=next||1;payload={idConta:planId,page:proxima};_context2.next=4;return(0,_apolloClient.gqlQuery)(_invoices.gqlInvoices,payload);case 4:_ref3=_context2.sent;_ref3$data=_ref3.data;data=_ref3$data===undefined?{}:_ref3$data;_data$historicoFatura=data.historicoFaturas,historicoFaturas=_data$historicoFatura===undefined?{}:_data$historicoFatura;_historicoFaturas$pag=historicoFaturas.paginacao,paginacao=_historicoFaturas$pag===undefined?{}:_historicoFaturas$pag;response=_extends({},historicoFaturas,{paginacao:paginacao.proxima?paginacao:{}});return _context2.abrupt('return',response);case 11:case'end':return _context2.stop();}}},_callee2,this);}));return function getInvoices(_x2,_x3){return _ref2.apply(this,arguments);};}();var getRecharges=exports.getRecharges=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(planId,_next){var next,payload,_ref5,_ref5$data,data,_data$historicoRecarg,_data$historicoRecarg2,remaining,_data$historicoRecarg3,recargas,recharges,response;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:next=_next||0;payload={idConta:planId,skip:next};_context3.next=4;return(0,_apolloClient.gqlQuery)(_recharges.gqlRecharges,payload);case 4:_ref5=_context3.sent;_ref5$data=_ref5.data;data=_ref5$data===undefined?{}:_ref5$data;_data$historicoRecarg=data.historicoRecargas;_data$historicoRecarg=_data$historicoRecarg===undefined?{}:_data$historicoRecarg;_data$historicoRecarg2=_data$historicoRecarg.remaining,remaining=_data$historicoRecarg2===undefined?0:_data$historicoRecarg2,_data$historicoRecarg3=_data$historicoRecarg.recargas,recargas=_data$historicoRecarg3===undefined?[]:_data$historicoRecarg3;recharges=(0,_recharges.transformRecharges)(recargas);response={data:recharges,next:remaining?next+recargas.length:null,totalCount:next+recargas.length+remaining};return _context3.abrupt('return',response);case 13:case'end':return _context3.stop();}}},_callee3,this);}));return function getRecharges(_x4,_x5){return _ref4.apply(this,arguments);};}();var getPlateFilters=exports.getPlateFilters=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(planId,type){var result;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return(0,_apolloClient.gqlQuery)(_transactions.gqlListPlateFilters,{conta:planId,tipo:type});case 2:result=_context4.sent;return _context4.abrupt('return',{data:result.data.listaFiltro||[]});case 4:case'end':return _context4.stop();}}},_callee4,this);}));return function getPlateFilters(_x6,_x7){return _ref6.apply(this,arguments);};}();var addPlateFilter=exports.addPlateFilter=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(filter){var result;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return(0,_apolloClient.gqlMutate)(_transactions.gqlCreatePlateFilter,{filtro:filter});case 2:result=_context5.sent;return _context5.abrupt('return',{data:result.data.inserirFiltro});case 4:case'end':return _context5.stop();}}},_callee5,this);}));return function addPlateFilter(_x8){return _ref7.apply(this,arguments);};}();var updatePlateFilter=exports.updatePlateFilter=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref9){var id=_ref9.id,filterData=_objectWithoutProperties(_ref9,['id']);var result;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return(0,_apolloClient.gqlMutate)(_transactions.gqlUpdatePlateFilter,{filtro:filterData,id:id});case 2:result=_context6.sent;return _context6.abrupt('return',{data:result.data.alterarFiltro});case 4:case'end':return _context6.stop();}}},_callee6,this);}));return function updatePlateFilter(_x9){return _ref8.apply(this,arguments);};}();var deletePlateFilter=exports.deletePlateFilter=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(planId,filterId){var result;return regeneratorRuntime.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return(0,_apolloClient.gqlMutate)(_transactions.gqlDeletePlateFilter,{conta:planId,id:filterId});case 2:result=_context7.sent;return _context7.abrupt('return',{data:result.data.deletarFiltro});case 4:case'end':return _context7.stop();}}},_callee7,this);}));return function deletePlateFilter(_x10,_x11){return _ref10.apply(this,arguments);};}();var getStatements=exports.getStatements=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(planId,next){var filter=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var pagina,portalParceiro,hasRangeDates,QTD,gqlVars,getPlacas,transacaoes,transacoes,enviarExtratoEmail,nextAttrs;return regeneratorRuntime.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:getPlacas=function getPlacas(placas){var arrayPlacas=placas.split(',');arrayPlacas=arrayPlacas.map(function(placa){return{placa:placa};});return arrayPlacas;};pagina=next&&next.pagina||1;portalParceiro='true';hasRangeDates=filter.rangeDates&&filter.rangeDates.from&&filter.rangeDates.to;QTD=30;gqlVars=_extends({portalParceiro:portalParceiro,pagina:pagina},!filter.plate.includes(',')&&filter.plate&&{placa:filter.plate},filter.plate&&filter.plate.length!==0&&{placas:getPlacas(filter.plate)},!!filter.periodo&&{periodo:filter.periodo.toString()},filter.type&&filter.type.some(function(item){return item.tipo==='VALE_PEDAGIO';})&&{valePedagio:'1'},filter.type&&{transacoes:(0,_helpers.getTipoTransacao)(filter.type)},filter.diaDaSemana?{diaDaSemana:filter.diaDaSemana.toString()}:{diaDaSemana:'0,1,2,3,4,5,6'},hasRangeDates&&{startSqlDateFilter:(0,_moment2.default)(filter.rangeDates.from).format('YYYY-MM-DD'),endSqlDateFilter:(0,_moment2.default)(filter.rangeDates.to).format('YYYY-MM-DD')});_context8.t0=_transactions.transformExtrato;_context8.next=9;return(0,_apolloClient.gqlQuery)(_transactions.gqlExtrato,_extends({idConta:planId,quantidade:filter.quantidade?filter.quantidade:QTD},gqlVars));case 9:_context8.t1=_context8.sent;transacaoes=(0,_context8.t0)(_context8.t1);transacoes=transacaoes.transacoes,enviarExtratoEmail=transacaoes.enviarExtratoEmail;// O serviço não retorna a quantidade de páginas, se vier a quantidade solicitada, considera que tem mais uma página
nextAttrs={hasNext:1,next:{pagina:pagina+1}};return _context8.abrupt('return',_extends({data:transacoes||{},enviarExtratoEmail:enviarExtratoEmail},transacoes&&transacoes.length===QTD&&nextAttrs));case 14:case'end':return _context8.stop();}}},_callee8,this);}));return function getStatements(_x12,_x13){return _ref11.apply(this,arguments);};}();var getPlanData=exports.getPlanData=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(plan){var idConta,_ref13,_ref13$data,data,_data$valorMensalidad,monthlyPayment,_data$valorRecarga,recharge,_data$valorBonificaca,bonificationEndDate,bonificationType,bonificationVaue;return regeneratorRuntime.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:idConta=plan.id;_context9.next=3;return(0,_apolloClient.gqlQuery)(_plans.gqlPlanData,{idConta:idConta});case 3:_ref13=_context9.sent;_ref13$data=_ref13.data;data=_ref13$data===undefined?{}:_ref13$data;_data$valorMensalidad=data.valorMensalidade;_data$valorMensalidad=_data$valorMensalidad===undefined?{}:_data$valorMensalidad;monthlyPayment=_data$valorMensalidad.valor,_data$valorRecarga=data.valorRecarga;_data$valorRecarga=_data$valorRecarga===undefined?{}:_data$valorRecarga;recharge=_data$valorRecarga.valor,_data$valorBonificaca=data.valorBonificacao;_data$valorBonificaca=_data$valorBonificaca===undefined?{}:_data$valorBonificaca;bonificationEndDate=_data$valorBonificaca.dataFimBonificacao,bonificationType=_data$valorBonificaca.tipoBonificacao,bonificationVaue=_data$valorBonificaca.valorBonificacao;return _context9.abrupt('return',{monthlyPayment:monthlyPayment,recharge:recharge,bonificationEndDate:bonificationEndDate,bonificationVaue:bonificationVaue,bonificationType:bonificationType});case 14:case'end':return _context9.stop();}}},_callee9,this);}));return function getPlanData(_x15){return _ref12.apply(this,arguments);};}();var getVehicles=exports.getVehicles=function(){var _ref14=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(accountId){var resp;return regeneratorRuntime.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.next=2;return(0,_apolloClient.gqlQuery)(_vehicles.gqlIdentificadores,{idConta:accountId});case 2:resp=_context10.sent;return _context10.abrupt('return',(0,_vehicles.transformIndentificadores)(resp));case 4:case'end':return _context10.stop();}}},_callee10,this);}));return function getVehicles(_x16){return _ref14.apply(this,arguments);};}();var getVehiclesByNumber=exports.getVehiclesByNumber=function(){var _ref15=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11(identifierNumber){var _ref16,_ref16$data,_ref16$data$identific,identificador;return regeneratorRuntime.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.next=2;return(0,_apolloClient.gqlQuery)(_vehicles.gqlIdentificador,{numero:identifierNumber});case 2:_ref16=_context11.sent;_ref16$data=_ref16.data;_ref16$data=_ref16$data===undefined?{}:_ref16$data;_ref16$data$identific=_ref16$data.identificador,identificador=_ref16$data$identific===undefined?{}:_ref16$data$identific;return _context11.abrupt('return',identificador);case 7:case'end':return _context11.stop();}}},_callee11,this);}));return function getVehiclesByNumber(_x17){return _ref15.apply(this,arguments);};}();var downloadVehiclesCSV=exports.downloadVehiclesCSV=function(){var _ref17=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12(planId){var resp,b64File;return regeneratorRuntime.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.next=2;return(0,_apolloClient.gqlQuery)(_vehicles.gqlDownloadIdentificadoresCsv,{idConta:planId});case 2:resp=_context12.sent;b64File=resp.data.consultarIdentificadoresAtivos;return _context12.abrupt('return',(0,_helpers.downloadBase64)(b64File,'text/csv','identificadores.csv'));case 5:case'end':return _context12.stop();}}},_callee12,this);}));return function downloadVehiclesCSV(_x18){return _ref17.apply(this,arguments);};}();// TODO IMPLEMENTAR !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var downloadInvoice=exports.downloadInvoice=function(){var _ref18=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13(planId,year,month){return regeneratorRuntime.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:case'end':return _context13.stop();}}},_callee13,this);}));return function downloadInvoice(_x19,_x20,_x21){return _ref18.apply(this,arguments);};}();var resendStatement=exports.resendStatement=function(){var _ref19=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee14(fastId){var response;return regeneratorRuntime.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.next=2;return(0,_apolloClient.gqlMutate)(_transactions.gqlResendStatement,{fastId:fastId});case 2:response=_context14.sent;return _context14.abrupt('return',response);case 4:case'end':return _context14.stop();}}},_callee14,this);}));return function resendStatement(_x22){return _ref19.apply(this,arguments);};}();var downloadStatementCSV=exports.downloadStatementCSV=function(){var _ref20=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee15(planId){var filter=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var hasRangeDates,gqlVars,resp,b64File;return regeneratorRuntime.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:hasRangeDates=filter.rangeDates&&filter.rangeDates.from&&filter.rangeDates.to;gqlVars=_extends({},filter.plate&&{placa:filter.plate},filter.placas&&filter.placas.length!==0&&{placas:filter.placas},!!filter.periodo&&{periodo:filter.periodo.toString()},filter.type&&filter.type.some(function(item){return item.tipo==='VALE_PEDAGIO';})&&{valePedagio:'1'},filter.type&&{transacoes:(0,_helpers.getTipoTransacao)(filter.type)},filter.diaDaSemana?{diaDaSemana:filter.diaDaSemana.toString()}:{diaDaSemana:'0,1,2,3,4,5,6'},hasRangeDates&&{startSqlDateFilter:(0,_moment2.default)(filter.rangeDates.from).format('YYYY-MM-DD'),endSqlDateFilter:(0,_moment2.default)(filter.rangeDates.to).format('YYYY-MM-DD')});_context15.next=4;return(0,_apolloClient.gqlQuery)(_transactions.gqlDownloadExtratoCsv,_extends({idConta:planId},gqlVars));case 4:resp=_context15.sent;b64File=resp.data.extratoCSV.result;return _context15.abrupt('return',(0,_helpers.downloadBase64)(b64File,'text/csv','extrato.csv'));case 7:case'end':return _context15.stop();}}},_callee15,this);}));return function downloadStatementCSV(_x23){return _ref20.apply(this,arguments);};}();var downloadStatement=exports.downloadStatement=function(){var _ref21=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee16(planId){var filter=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var hasRangeDates,gqlVars,resp,b64File;return regeneratorRuntime.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:hasRangeDates=filter.rangeDates&&filter.rangeDates.from&&filter.rangeDates.to;gqlVars=_extends({},filter.plate&&{placa:filter.plate},filter.placas&&filter.placas.length!==0&&{placas:filter.placas},!!filter.periodo&&{periodo:filter.periodo.toString()},filter.type&&filter.type.some(function(item){return item.tipo==='VALE_PEDAGIO';})&&{valePedagio:'1'},filter.type&&{transacoes:(0,_helpers.getTipoTransacao)(filter.type)},filter.diaDaSemana?{diaDaSemana:filter.diaDaSemana.toString()}:{diaDaSemana:'0,1,2,3,4,5,6'},hasRangeDates&&{startSqlDateFilter:(0,_moment2.default)(filter.rangeDates.from).format('YYYY-MM-DD'),endSqlDateFilter:(0,_moment2.default)(filter.rangeDates.to).format('YYYY-MM-DD')});_context16.next=4;return(0,_apolloClient.gqlQuery)(_transactions.gqlDownloadExtratoPdf,_extends({idConta:planId},gqlVars));case 4:resp=_context16.sent;b64File=resp.data.download.result;return _context16.abrupt('return',(0,_helpers.downloadBase64)(b64File,'application/pdf','extrato.pdf'));case 7:case'end':return _context16.stop();}}},_callee16,this);}));return function downloadStatement(_x25){return _ref21.apply(this,arguments);};}();var downloadFatura=exports.downloadFatura=function(){var _ref22=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee17(planId,invoiceId){var resp,b64File,err;return regeneratorRuntime.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:_context17.next=2;return(0,_apolloClient.gqlQuery)(_invoices.gqlDownloadFaturaPdf,{idConta:planId,numeroFatura:parseInt(invoiceId,10)});case 2:resp=_context17.sent;b64File=resp.data.downloadFaturaPdf&&resp.data.downloadFaturaPdf.result;if(b64File){_context17.next=8;break;}err=new Error('Erro ao baixar fatura');err.status=404;throw err;case 8:return _context17.abrupt('return',(0,_helpers.downloadBase64)(b64File,'application/pdf','fatura.pdf'));case 9:case'end':return _context17.stop();}}},_callee17,this);}));return function downloadFatura(_x27,_x28){return _ref22.apply(this,arguments);};}();var downloadCSVInvoice=exports.downloadCSVInvoice=function(){var _ref23=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee18(planId,invoiceId){var resp,b64File,err;return regeneratorRuntime.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:_context18.next=2;return(0,_apolloClient.gqlQuery)(_invoices.gqlDownloadFaturaCsv,{idConta:planId,numeroFatura:parseInt(invoiceId,10)});case 2:resp=_context18.sent;b64File=resp.data.downloadFatura&&resp.data.downloadFatura.result;if(b64File){_context18.next=8;break;}err=new Error('Erro ao baixar fatura');err.status=404;throw err;case 8:return _context18.abrupt('return',(0,_helpers.downloadBase64)(b64File,'text/csv','fatura.csv'));case 9:case'end':return _context18.stop();}}},_callee18,this);}));return function downloadCSVInvoice(_x29,_x30){return _ref23.apply(this,arguments);};}();var downloadTicket=exports.downloadTicket=function(){var _ref24=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee19(planId,nsu){var resp,b64File,errObj,result,err;return regeneratorRuntime.wrap(function _callee19$(_context19){while(1){switch(_context19.prev=_context19.next){case 0:_context19.next=2;return(0,_apolloClient.gqlQuery)(_invoices.gqlDownloadBoleto,{idConta:planId,nsu:parseInt(nsu,10)});case 2:resp=_context19.sent;b64File=null;errObj=null;result=resp.data.downloadBoleto&&resp.data.downloadBoleto.result;try{errObj=JSON.parse(result);}catch(e){b64File=result;}if(!errObj){_context19.next=11;break;}err=new Error(errObj.message);err.statusCode=errObj.statusCode;throw err;case 11:if(b64File)(0,_helpers.downloadBase64)(b64File,'application/pdf','boleto.pdf');case 12:case'end':return _context19.stop();}}},_callee19,this);}));return function downloadTicket(_x31,_x32){return _ref24.apply(this,arguments);};}();var sendStatementEmail=exports.sendStatementEmail=function(){var _ref25=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee20(planId,email){var filter=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var formato=arguments[3];var hasRangeDates,gqlVars,resp;return regeneratorRuntime.wrap(function _callee20$(_context20){while(1){switch(_context20.prev=_context20.next){case 0:hasRangeDates=filter.rangeDates&&filter.rangeDates.from&&filter.rangeDates.to;gqlVars=_extends({},filter.plate&&{placa:filter.plate},filter.placas&&filter.placas.length!==0&&{placas:filter.placas},filter.month&&{mes:filter.month},filter.year&&{ano:filter.year},!!filter.periodo&&{periodo:filter.periodo.toString()},filter.type&&filter.type.some(function(item){return item.tipo==='VALE_PEDAGIO';})&&{valePedagio:'1'},filter.type&&{transacoes:(0,_helpers.getTipoTransacao)(filter.type)},filter.diaDaSemana?{diaDaSemana:filter.diaDaSemana.toString()}:{diaDaSemana:'0,1,2,3,4,5,6'},hasRangeDates&&{startSqlDateFilter:(0,_moment2.default)(filter.rangeDates.from).format('YYYY-MM-DD'),endSqlDateFilter:(0,_moment2.default)(filter.rangeDates.to).format('YYYY-MM-DD')});_context20.next=4;return(0,_apolloClient.gqlQuery)(_transactions.gqlSendStatementEmail,_extends({idConta:planId,email:email,formato:formato},gqlVars));case 4:resp=_context20.sent;return _context20.abrupt('return',resp);case 6:case'end':return _context20.stop();}}},_callee20,this);}));return function sendStatementEmail(_x33,_x34){return _ref25.apply(this,arguments);};}();var _dashboardService=__webpack_require__(1325);Object.keys(_dashboardService).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _dashboardService[key];}});});var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _apolloClient=__webpack_require__(42);var _resumo=__webpack_require__(1326);var _recharges=__webpack_require__(355);var _invoices=__webpack_require__(356);var _transactions=__webpack_require__(1328);var _vehicles=__webpack_require__(94);var _helpers=__webpack_require__(152);var _plans=__webpack_require__(542);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(87);
var core = __webpack_require__(50);
var ctx = __webpack_require__(131);
var hide = __webpack_require__(109);
var has = __webpack_require__(133);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(52);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(24);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.deleteBusinessUserAddress=exports.updateBusinessUserAddress=exports.updateUserContact=exports.updateBusinessUserContact=exports.updateUserProfile=exports.updateBusinessUserProfile=exports.getBusinessUser=exports.getBusinessUserOnly=exports.getUser=exports.deleteUserAddress=exports.updateUserAddress=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var updateUserAddress=exports.updateUserAddress=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(data){var transformedData,enderecos;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:transformedData=data.map(function(_ref2){var principal=_ref2.principal,rest=_objectWithoutProperties(_ref2,['principal']);return _extends({},rest);});enderecos={enderecos:transformedData};_context.next=4;return(0,_apolloClient.gqlMutate)(_address.gqlUpdateAddress,enderecos);case 4:case'end':return _context.stop();}}},_callee,this);}));return function updateUserAddress(_x){return _ref.apply(this,arguments);};}();var deleteUserAddress=exports.deleteUserAddress=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(id){var codigo;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:codigo={id:id};_context2.next=3;return(0,_apolloClient.gqlMutate)(_address.gqlDeleteAddress,codigo);case 3:case'end':return _context2.stop();}}},_callee2,this);}));return function deleteUserAddress(_x2){return _ref3.apply(this,arguments);};}();var getUser=exports.getUser=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(){var pessoalQuery,documento,papQuery;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return(0,_apolloClient.gqlQuery)(_pessoal.gqlPessoal);case 2:pessoalQuery=_context3.sent;documento=pessoalQuery.data.usuario.cpf;_context3.next=6;return(0,_apolloClient.gqlQuery)(_pessoal.gqlPap,{documento:documento});case 6:papQuery=_context3.sent;return _context3.abrupt('return',(0,_pessoal.transformPessoal)(_extends({},pessoalQuery,{pap:papQuery.data.pap})));case 8:case'end':return _context3.stop();}}},_callee3,this);}));return function getUser(){return _ref4.apply(this,arguments);};}();var getBusinessUserOnly=exports.getBusinessUserOnly=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(){var businessQuery;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return(0,_apolloClient.gqlQuery)(_business.gqlBusinessUserOnly);case 2:businessQuery=_context4.sent;return _context4.abrupt('return',(0,_business.transformBusinessUser)(_extends({},businessQuery)));case 4:case'end':return _context4.stop();}}},_callee4,this);}));return function getBusinessUserOnly(){return _ref5.apply(this,arguments);};}();var getBusinessUser=exports.getBusinessUser=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(){var businessQuery,documento,papQuery;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return(0,_apolloClient.gqlQuery)(_business.gqlBusiness);case 2:businessQuery=_context5.sent;documento=businessQuery.data.usuario.cnpj;_context5.next=6;return(0,_apolloClient.gqlQuery)(_pessoal.gqlPap,{documento:documento});case 6:papQuery=_context5.sent;return _context5.abrupt('return',(0,_business.transformBusiness)(_extends({},businessQuery,{pap:papQuery.data.pap})));case 8:case'end':return _context5.stop();}}},_callee5,this);}));return function getBusinessUser(){return _ref6.apply(this,arguments);};}();var updateBusinessUserProfile=exports.updateBusinessUserProfile=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(data){var nomeFantasia,faturamentoMedioMensal,cnaePrincipal,response;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:nomeFantasia=data.nomeFantasia,faturamentoMedioMensal=data.faturamentoMedioMensal,cnaePrincipal=data.cnaePrincipal;_context6.next=3;return(0,_apolloClient.gqlMutate)(_business.gqlUpdateBusiness,_extends({nomeFantasia:nomeFantasia,faturamentoMedioMensal:faturamentoMedioMensal,cnaePrincipal:cnaePrincipal,tipoUsuario:'pessoa-juridica'},data.pap));case 3:response=_context6.sent;return _context6.abrupt('return',response);case 5:case'end':return _context6.stop();}}},_callee6,this);}));return function updateBusinessUserProfile(_x3){return _ref7.apply(this,arguments);};}();var updateUserProfile=exports.updateUserProfile=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(data){var _data$user,sexo,estadoCivil;return regeneratorRuntime.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_data$user=data.user,sexo=_data$user.sexo,estadoCivil=_data$user['estado-civil'];_context7.next=3;return(0,_apolloClient.gqlMutate)(_pessoal.gqlEditarUsuarioFisico,_extends({sexo:sexo.codigo,estadoCivil:estadoCivil.codigo},data.pap));case 3:case'end':return _context7.stop();}}},_callee7,this);}));return function updateUserProfile(_x4){return _ref8.apply(this,arguments);};}();var updateBusinessUserContact=exports.updateBusinessUserContact=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(data){var variables;return regeneratorRuntime.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:variables={nome:data.nome&&data.nome.nomeCompleto,email:data.email.enderecoEletronico,site:data.site.enderecoEletronico,newsletter:data.email.newsletter,telefoneDDD:Number.parseInt(data.telefone.ddd,10),telefoneNumero:getTelefoneAsNumber(data.telefone.numero),telefoneTipo:Number.parseInt(data.telefone.tipoTelefone,10),telefoneRamal:Number.parseInt(data.telefone.ramal,10),celular:Number.parseInt(data.celular.ddd,10)||getTelefoneAsNumber(data.celular.numero)?{ddd:Number.parseInt(data.celular.ddd,10),numero:getTelefoneAsNumber(data.celular.numero),tipoTelefone:42}:null};_context8.next=3;return(0,_apolloClient.gqlMutate)(_business.gqlEditarContatoAdministrador,variables);case 3:case'end':return _context8.stop();}}},_callee8,this);}));return function updateBusinessUserContact(_x5){return _ref9.apply(this,arguments);};}();var updateUserContact=exports.updateUserContact=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(data){var variables;return regeneratorRuntime.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:variables={email:data.email.enderecoEletronico,newsletter:!!data.email.newsletter,telefoneDDD:data.telefone&&data.telefone.ddd?Number.parseInt(data.telefone.ddd,10):null,telefoneNumero:getTelefoneAsNumber(data.telefone&&data.telefone.numero),telefoneTipo:42,celularDDD:data.celular&&data.celular.ddd?Number.parseInt(data.celular.ddd,10):null,celularNumero:getTelefoneAsNumber(data.celular&&data.celular.numero,10)};_context9.next=3;return(0,_apolloClient.gqlMutate)(_pessoal.gqlEditarContato,variables);case 3:case'end':return _context9.stop();}}},_callee9,this);}));return function updateUserContact(_x6){return _ref10.apply(this,arguments);};}();var updateBusinessUserAddress=exports.updateBusinessUserAddress=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10(data){var transformedData,enderecos;return regeneratorRuntime.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:transformedData=data.map(function(_ref12){var principal=_ref12.principal,rest=_objectWithoutProperties(_ref12,['principal']);return _extends({},rest);});enderecos={enderecos:transformedData};_context10.next=4;return(0,_apolloClient.gqlMutate)(_address.gqlUpdateAddress,enderecos);case 4:case'end':return _context10.stop();}}},_callee10,this);}));return function updateBusinessUserAddress(_x7){return _ref11.apply(this,arguments);};}();var deleteBusinessUserAddress=exports.deleteBusinessUserAddress=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11(id){var codigo;return regeneratorRuntime.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:codigo={id:id};_context11.next=3;return(0,_apolloClient.gqlMutate)(_address.gqlDeleteAddress,codigo);case 3:case'end':return _context11.stop();}}},_callee11,this);}));return function deleteBusinessUserAddress(_x8){return _ref13.apply(this,arguments);};}();exports.updateUserPassword=updateUserPassword;var _apolloClient=__webpack_require__(42);var _pessoal=__webpack_require__(1336);var _axiosClient=__webpack_require__(341);var _constants=__webpack_require__(149);var _business=__webpack_require__(1337);var _address=__webpack_require__(556);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getTelefoneAsNumber=function getTelefoneAsNumber(value){return value?Number.parseInt(value.toString().replace('-',''),10):null;};function updateUserPassword(data){var transformedData={antiga:data.current_password,nova:data.new_password};return(0,_axiosClient.put)(_constants.CHANGE_PASSWORD,transformedData,{'content-type':'application/json'});}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(110);
var IE8_DOM_DEFINE = __webpack_require__(571);
var toPrimitive = __webpack_require__(369);
var dP = Object.defineProperty;

exports.f = __webpack_require__(76) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(132)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 77 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(26);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(5);
var core = __webpack_require__(68);
var fails = __webpack_require__(24);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(69);
var IObject = __webpack_require__(160);
var toObject = __webpack_require__(45);
var toLength = __webpack_require__(37);
var asc = __webpack_require__(288);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29),
    _assign = __webpack_require__(34);

var CallbackQueue = __webpack_require__(456);
var PooledClass = __webpack_require__(126);
var ReactFeatureFlags = __webpack_require__(457);
var ReactReconciler = __webpack_require__(146);
var Transaction = __webpack_require__(205);

var invariant = __webpack_require__(17);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(480);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addTypenameToDocument", function() { return addTypenameToDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "argumentsObjectFromField", function() { return argumentsObjectFromField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildQueryFromSelectionSet", function() { return buildQueryFromSelectionSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canUseWeakMap", function() { return canUseWeakMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkDocument", function() { return checkDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneDeep", function() { return cloneDeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFragmentMap", function() { return createFragmentMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultValues", function() { return getDefaultValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDirectiveInfoFromField", function() { return getDirectiveInfoFromField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDirectiveNames", function() { return getDirectiveNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDirectivesFromDocument", function() { return getDirectivesFromDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEnv", function() { return getEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFragmentDefinition", function() { return getFragmentDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFragmentDefinitions", function() { return getFragmentDefinitions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFragmentQueryDocument", function() { return getFragmentQueryDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInclusionDirectives", function() { return getInclusionDirectives; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMainDefinition", function() { return getMainDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMutationDefinition", function() { return getMutationDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOperationDefinition", function() { return getOperationDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOperationDefinitionOrDie", function() { return getOperationDefinitionOrDie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOperationName", function() { return getOperationName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getQueryDefinition", function() { return getQueryDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStoreKeyName", function() { return getStoreKeyName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "graphQLResultHasError", function() { return graphQLResultHasError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasClientExports", function() { return hasClientExports; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasDirectives", function() { return hasDirectives; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDevelopment", function() { return isDevelopment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEnv", function() { return isEnv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isField", function() { return isField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIdValue", function() { return isIdValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isInlineFragment", function() { return isInlineFragment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isJsonValue", function() { return isJsonValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNumberValue", function() { return isNumberValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isProduction", function() { return isProduction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isScalarValue", function() { return isScalarValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTest", function() { return isTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maybeDeepFreeze", function() { return maybeDeepFreeze; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeDeep", function() { return mergeDeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeDeepArray", function() { return mergeDeepArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeArgumentsFromDocument", function() { return removeArgumentsFromDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeClientSetsFromDocument", function() { return removeClientSetsFromDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeConnectionDirectiveFromDocument", function() { return removeConnectionDirectiveFromDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeDirectivesFromDocument", function() { return removeDirectivesFromDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeFragmentSpreadFromDocument", function() { return removeFragmentSpreadFromDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resultKeyNameFromField", function() { return resultKeyNameFromField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldInclude", function() { return shouldInclude; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "storeKeyNameFromField", function() { return storeKeyNameFromField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stripSymbols", function() { return stripSymbols; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toIdValue", function() { return toIdValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tryFunctionOrLogError", function() { return tryFunctionOrLogError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "valueFromNode", function() { return valueFromNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "valueToObjectRepresentation", function() { return valueToObjectRepresentation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "variablesInOperation", function() { return variablesInOperation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "warnOnceInDevelopment", function() { return warnOnceInDevelopment; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ts_invariant__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tslib__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wry_equality__ = __webpack_require__(1226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isEqual", function() { return __WEBPACK_IMPORTED_MODULE_4__wry_equality__["a"]; });






function isScalarValue(value) {
    return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](17) : new InvariantError("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\"" +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.');
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = __WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify___default()(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function isIdValue(idObject) {
    return idObject &&
        idObject.type === 'id' &&
        typeof idObject.generated === 'boolean';
}
function toIdValue(idConfig, generated) {
    if (generated === void 0) { generated = false; }
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({ type: 'id', generated: generated }, (typeof idConfig === 'string'
        ? { id: idConfig, typename: undefined }
        : idConfig));
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}
function defaultValueFromVariable(node) {
    throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](18) : new InvariantError("Variable nodes are not supported by valueFromNode");
}
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) { onVariable = defaultValueFromVariable; }
    switch (node.kind) {
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function (v) { return valueFromNode(v, onVariable); });
        case 'ObjectValue': {
            var value = {};
            for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        }
        default:
            return node.value;
    }
}

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    return getInclusionDirectives(selection.directives).every(function (_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
             true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(evaledValue !== void 0, 13) : invariant(evaledValue !== void 0, "Invalid variable referenced in @" + directive.name.value + " directive.");
        }
        else {
            evaledValue = ifArgument.value.value;
        }
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function getDirectiveNames(doc) {
    var names = [];
    Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(doc, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
function hasClientExports(document) {
    return (document &&
        hasDirectives(['client'], document) &&
        hasDirectives(['export'], document));
}
function isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function getInclusionDirectives(directives) {
    return directives ? directives.filter(isInclusionDirective).map(function (directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
         true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(directiveArguments && directiveArguments.length === 1, 14) : invariant(directiveArguments && directiveArguments.length === 1, "Incorrect number of arguments for the @" + directiveName + " directive.");
        var ifArgument = directiveArguments[0];
         true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(ifArgument.name && ifArgument.name.value === 'if', 15) : invariant(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @" + directiveName + " directive.");
        var ifValue = ifArgument.value;
         true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(ifValue &&
            (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16) : invariant(ifValue &&
            (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), "Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
        return { directive: directive, ifArgument: ifArgument };
    }) : [];
}

function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](11) : new InvariantError("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
         true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(fragments.length === 1, 12) : invariant(fragments.length === 1, "Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
        actualFragmentName = fragments[0].name.value;
    }
    var query = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, document), { definitions: Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__spreadArrays"])([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ], document.definitions) });
    return query;
}

function assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}

function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation';
    })[0];
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(mutationDef, 1) : invariant(mutationDef, 'Must contain a mutation definition.');
    return mutationDef;
}
function checkDocument(doc) {
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(doc && doc.kind === 'Document', 2) : invariant(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](3) : new InvariantError("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
        }
        return definition;
    });
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(operations.length <= 1, 4) : invariant(operations.length <= 1, "Ambiguous GraphQL document: contains " + operations.length + " operations");
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(def, 5) : invariant(def, "GraphQL document is missing an operation");
    return def;
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(queryDef && queryDef.operation === 'query', 6) : invariant(queryDef && queryDef.operation === 'query', 'Must contain a query definition.');
    return queryDef;
}
function getFragmentDefinition(doc) {
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(doc.kind === 'Document', 7) : invariant(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(doc.definitions.length <= 1, 8) : invariant(doc.definitions.length <= 1, 'Fragment must have exactly one definition.');
    var fragmentDef = doc.definitions[0];
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */])(fragmentDef.kind === 'FragmentDefinition', 9) : invariant(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.');
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](10) : new InvariantError('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return assign.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__spreadArrays"])([{}], defaultValues));
    }
    return {};
}
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) {
        for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
    }
    return names;
}

function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}

var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function (selection) {
        return selection.kind === 'FragmentSpread' &&
            isEmpty(fragments[selection.name.value], fragments);
    });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            return (dir.name && dir.name === directive.name.value) ||
                (dir.test && dir.test(directive));
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(doc, {
        Variable: {
            enter: function (node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') {
                    variablesInUse[node.name.value] = true;
                }
            },
        },
        Field: {
            enter: function (node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function (directive) { return directive.remove; });
                    if (shouldRemoveField &&
                        node.directives &&
                        node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) {
                            node.arguments.forEach(function (arg) {
                                if (arg.value.kind === 'Variable') {
                                    variablesToRemove.push({
                                        name: arg.value.name.value,
                                    });
                                }
                            });
                        }
                        if (node.selectionSet) {
                            getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value,
                                });
                            });
                        }
                        return null;
                    }
                }
            },
        },
        FragmentSpread: {
            enter: function (node) {
                fragmentSpreadsInUse[node.name.value] = true;
            },
        },
        Directive: {
            enter: function (node) {
                if (getDirectiveMatcher(directives)(node)) {
                    return null;
                }
            },
        },
    }));
    if (modifiedDoc &&
        filterInPlace(variablesToRemove, function (v) { return !variablesInUse[v.name]; }).length) {
        modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    }
    if (modifiedDoc &&
        filterInPlace(fragmentSpreadsToRemove, function (fs) { return !fragmentSpreadsInUse[fs.name]; })
            .length) {
        modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    }
    return modifiedDoc;
}
function addTypenameToDocument(doc) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(checkDocument(doc), {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === 'OperationDefinition') {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return (isField(selection) &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                var field = parent;
                if (isField(field) &&
                    field.directives &&
                    field.directives.some(function (d) { return d.name.value === 'export'; })) {
                    return;
                }
                return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, node), { selections: Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__spreadArrays"])(selections, [TYPENAME_FIELD]) });
            },
        },
    });
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                "production" === "production" || __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */].warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (!isField(selection)) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getDirectivesFromDocument(directives, doc) {
    checkDocument(doc);
    var parentPath;
    return nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(doc, {
        SelectionSet: {
            enter: function (node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath ||
                    currentPath === parentPath ||
                    !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function (selection) { return hasDirectivesInSelection(directives, selection); });
                        if (hasDirectivesInSelectionSet(directives, node, false)) {
                            parentPath = currentPath;
                        }
                        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, node), { selections: selectionsWithDirectives });
                    }
                    else {
                        return null;
                    }
                }
            },
        },
    }));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === 'Variable' &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(doc, {
        OperationDefinition: {
            enter: function (node) {
                return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, node), { variableDefinitions: node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function (arg) {
                        if (argMatcher(arg)) {
                            argMatchCount_1 += 1;
                        }
                    });
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function (selection) {
        if ((isField(selection) || isInlineFragment(selection)) &&
            selection.selectionSet) {
            getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) { return allFragments.push(frag); });
        }
        else if (selection.kind === 'FragmentSpread') {
            allFragments.push(selection);
        }
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(document, {
        OperationDefinition: {
            enter: function (node) {
                return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])(Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, node), { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    if (modifiedDoc) {
        modifiedDoc = Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(modifiedDoc, {
            FragmentDefinition: {
                enter: function (node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
                            return isField(selection) && selection.name.value === '__typename';
                        });
                        if (isTypenameOnly) {
                            return null;
                        }
                    }
                },
            },
        });
    }
    return modifiedDoc;
}

var canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' &&
    navigator.product === 'ReactNative');

var toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value, new Map());
}
function cloneDeepHelper(val, seen) {
    switch (toString.call(val)) {
        case "[object Array]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}

function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}

function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}

function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (isDevelopment() || isTest()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) {
            return deepFreeze(obj);
        }
    }
    return obj;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = shallowCopyForMerge(target, pastCopies);
        for (var i = 1; i < count; ++i) {
            target = mergeHelper(target, sources[i], pastCopies);
        }
    }
    return target;
}
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function mergeHelper(target, source, pastCopies) {
    if (isObject(source) && isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) {
            target = shallowCopyForMerge(target, pastCopies);
        }
        Object.keys(source).forEach(function (sourceKey) {
            var sourceValue = source[sourceKey];
            if (hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) {
                    target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
                }
            }
            else {
                target[sourceKey] = sourceValue;
            }
        });
        return target;
    }
    return source;
}
function shallowCopyForMerge(value, pastCopies) {
    if (value !== null &&
        typeof value === 'object' &&
        pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) {
            value = value.slice(0);
        }
        else {
            value = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({ __proto__: Object.getPrototypeOf(value) }, value);
        }
        pastCopies.push(value);
    }
    return value;
}

var haveWarned = Object.create({});
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) { type = 'warn'; }
    if (!isProduction() && !haveWarned[msg]) {
        if (!isTest()) {
            haveWarned[msg] = true;
        }
        if (type === 'error') {
            console.error(msg);
        }
        else {
            console.warn(msg);
        }
    }
}

function stripSymbols(data) {
    return JSON.parse(JSON.stringify(data));
}


//# sourceMappingURL=bundle.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(83)))

/***/ }),
/* 87 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/PageLoader/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _Loader=__webpack_require__(1665);var _Loader2=_interopRequireDefault(_Loader);var _styles=__webpack_require__(1668);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PageLoaderContent=function(_Component){_inherits(PageLoaderContent,_Component);function PageLoaderContent(){_classCallCheck(this,PageLoaderContent);return _possibleConstructorReturn(this,(PageLoaderContent.__proto__||Object.getPrototypeOf(PageLoaderContent)).apply(this,arguments));}_createClass(PageLoaderContent,[{key:'shouldComponentUpdate',value:function shouldComponentUpdate(){return true;}},{key:'render',value:function render(){return this.props.content;}}]);return PageLoaderContent;}(_react.Component);function StatementsFilter(_ref){var children=_ref.children,pageLoader=_ref.pageLoader;var isLoading=pageLoader.isLoading;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_styles.LoaderContainer,{isLoading:isLoading,__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(_Loader2.default,{__source:{fileName:_jsxFileName,lineNumber:23}})),_react2.default.createElement(_styles.ContentContainer,{isLoading:isLoading,__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement(PageLoaderContent,{content:children,__source:{fileName:_jsxFileName,lineNumber:26}})));}var mapStateToProps=function mapStateToProps(_ref2){var pageLoader=_ref2.pageLoader;return{pageLoader:pageLoader};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(StatementsFilter);module.exports=exports['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(38)) {
  var LIBRARY = __webpack_require__(105);
  var global = __webpack_require__(21);
  var fails = __webpack_require__(24);
  var $export = __webpack_require__(5);
  var $typed = __webpack_require__(201);
  var $buffer = __webpack_require__(296);
  var ctx = __webpack_require__(69);
  var anInstance = __webpack_require__(122);
  var propertyDesc = __webpack_require__(115);
  var hide = __webpack_require__(55);
  var redefineAll = __webpack_require__(124);
  var toInteger = __webpack_require__(71);
  var toLength = __webpack_require__(37);
  var toIndex = __webpack_require__(437);
  var toAbsoluteIndex = __webpack_require__(118);
  var toPrimitive = __webpack_require__(78);
  var has = __webpack_require__(59);
  var classof = __webpack_require__(140);
  var isObject = __webpack_require__(26);
  var toObject = __webpack_require__(45);
  var isArrayIter = __webpack_require__(285);
  var create = __webpack_require__(119);
  var getPrototypeOf = __webpack_require__(62);
  var gOPN = __webpack_require__(120).f;
  var getIterFn = __webpack_require__(287);
  var uid = __webpack_require__(116);
  var wks = __webpack_require__(33);
  var createArrayMethod = __webpack_require__(81);
  var createArrayIncludes = __webpack_require__(191);
  var speciesConstructor = __webpack_require__(163);
  var ArrayIterators = __webpack_require__(290);
  var Iterators = __webpack_require__(142);
  var $iterDetect = __webpack_require__(196);
  var setSpecies = __webpack_require__(121);
  var arrayFill = __webpack_require__(289);
  var arrayCopyWithin = __webpack_require__(426);
  var $DP = __webpack_require__(40);
  var $GOPD = __webpack_require__(61);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(432);
var $export = __webpack_require__(5);
var shared = __webpack_require__(159)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(435))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var PooledClass = __webpack_require__(126);

var emptyFunction = __webpack_require__(63);
var warning = __webpack_require__(28);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.transformIndentificadores=exports.transformIndentificadoresPaginado=exports.gqlDownloadIdentificadoresCsv=exports.gqlModificarPapIndividual=exports.gqlSubstituirIdentificador=exports.gqlDesabilitarIdentificador=exports.gqlIdentificador=exports.gqlTotalIdentificadores=exports.gqlHistoricoIdentificadorTag=exports.gqlIdentificadoresPaginado=exports.gqlIdentificadores=exports.gqlNewIdentifier=exports.gqlActivateIdentification=exports.gqlGetVehiclesCategory=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _templateObject=_taggedTemplateLiteral(['\n  query consultaCategorias($categoria: String!) {\n    consultaCategorias(categoria: $categoria) {\n      descricao\n      id\n    }\n  }\n'],['\n  query consultaCategorias($categoria: String!) {\n    consultaCategorias(categoria: $categoria) {\n      descricao\n      id\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation identificadorAtivar(\n    $placa: String!\n    $categoria: String!\n    $id: String!\n    $tipoProduto: String!\n    $codIdentificador: String!\n    $tipoIdentificador: String!\n  ) {\n    identificadorAtivar(\n      identificador: {\n        veiculo: { placa: $placa, categoria: $categoria }\n        clienteConta: { conta: { id: $id, tipoProduto: $tipoProduto } }\n        codIdentificador: $codIdentificador\n        tipoIdentificador: $tipoIdentificador\n      }\n    ) {\n      result {\n        idConta\n        nomeUsuario\n      }\n      error {\n        codigo\n        message\n      }\n    }\n  }\n'],['\n  mutation identificadorAtivar(\n    $placa: String!\n    $categoria: String!\n    $id: String!\n    $tipoProduto: String!\n    $codIdentificador: String!\n    $tipoIdentificador: String!\n  ) {\n    identificadorAtivar(\n      identificador: {\n        veiculo: { placa: $placa, categoria: $categoria }\n        clienteConta: { conta: { id: $id, tipoProduto: $tipoProduto } }\n        codIdentificador: $codIdentificador\n        tipoIdentificador: $tipoIdentificador\n      }\n    ) {\n      result {\n        idConta\n        nomeUsuario\n      }\n      error {\n        codigo\n        message\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation identificadorAdquirir(\n    $quantidadeIdentificadores: Int!\n    $endereco: EnderecoIdentificadorInput\n    $id: String!\n  ) {\n    identificadorAdquirir(\n      adquirirIdentificador: {\n        quantidadeIdentificadores: $quantidadeIdentificadores\n        endereco: $endereco\n        codigoCliente: { conta: { id: $id } }\n      }\n    ) {\n      result\n      error {\n        message\n      }\n    }\n  }\n'],['\n  mutation identificadorAdquirir(\n    $quantidadeIdentificadores: Int!\n    $endereco: EnderecoIdentificadorInput\n    $id: String!\n  ) {\n    identificadorAdquirir(\n      adquirirIdentificador: {\n        quantidadeIdentificadores: $quantidadeIdentificadores\n        endereco: $endereco\n        codigoCliente: { conta: { id: $id } }\n      }\n    ) {\n      result\n      error {\n        message\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query identificadoresPJ($idConta: String!) {\n    identificadoresPJ(idConta: $idConta) {\n      idIdentificador\n      codIdentificador\n      tipoIdentificador\n      informacoesGerenciais {\n        tipoInfo\n        descricaoAtual\n      }\n      veiculo {\n        marca\n        modelo\n        placa\n        chassi\n        renavam\n        categoria\n        tipo\n      }\n      situacao\n      dataAtualizacao\n    }\n  }\n'],['\n  query identificadoresPJ($idConta: String!) {\n    identificadoresPJ(idConta: $idConta) {\n      idIdentificador\n      codIdentificador\n      tipoIdentificador\n      informacoesGerenciais {\n        tipoInfo\n        descricaoAtual\n      }\n      veiculo {\n        marca\n        modelo\n        placa\n        chassi\n        renavam\n        categoria\n        tipo\n      }\n      situacao\n      dataAtualizacao\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query identificadoresPJV2(\n    $idConta: String!\n    $placa: String\n    $identificador: String\n    $gerencial: Boolean\n    $pagina: Int\n    $quantidade: Int\n    $ordenacao: String\n    $somentePlacas: Boolean\n  ) {\n    identificadoresPJV2(\n      idConta: $idConta\n      placa: $placa\n      identificador: $identificador\n      gerencial: $gerencial\n      pagina: $pagina\n      quantidade: $quantidade\n      ordenacao: $ordenacao\n      somentePlacas: $somentePlacas\n    ) {\n      identificadores {\n        idIdentificador\n        codIdentificador\n        tipoIdentificador\n        informacoesGerenciais {\n          tipoInfo\n          descricaoAtual\n        }\n        veiculo {\n          marca\n          modelo\n          placa\n          chassi\n          renavam\n          categoria\n          tipo\n        }\n        situacao\n        dataAtualizacao\n        pap\n      }\n      paginacao {\n        pagina\n        quantidade\n        total\n        proxima\n        anterior\n      }\n    }\n  }\n'],['\n  query identificadoresPJV2(\n    $idConta: String!\n    $placa: String\n    $identificador: String\n    $gerencial: Boolean\n    $pagina: Int\n    $quantidade: Int\n    $ordenacao: String\n    $somentePlacas: Boolean\n  ) {\n    identificadoresPJV2(\n      idConta: $idConta\n      placa: $placa\n      identificador: $identificador\n      gerencial: $gerencial\n      pagina: $pagina\n      quantidade: $quantidade\n      ordenacao: $ordenacao\n      somentePlacas: $somentePlacas\n    ) {\n      identificadores {\n        idIdentificador\n        codIdentificador\n        tipoIdentificador\n        informacoesGerenciais {\n          tipoInfo\n          descricaoAtual\n        }\n        veiculo {\n          marca\n          modelo\n          placa\n          chassi\n          renavam\n          categoria\n          tipo\n        }\n        situacao\n        dataAtualizacao\n        pap\n      }\n      paginacao {\n        pagina\n        quantidade\n        total\n        proxima\n        anterior\n      }\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query historicoIdentificadorTag($idConta: String!, $identificador: String!) {\n    historicoIdentificadorTag(idConta: $idConta, identificador: $identificador) {\n      id\n      pap\n      placa\n      historicos {\n        codIdentificador\n        dataInclusao\n        operacao\n        placa\n      }\n    }\n  }\n'],['\n  query historicoIdentificadorTag($idConta: String!, $identificador: String!) {\n    historicoIdentificadorTag(idConta: $idConta, identificador: $identificador) {\n      id\n      pap\n      placa\n      historicos {\n        codIdentificador\n        dataInclusao\n        operacao\n        placa\n      }\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query totalIdentificadores($idConta: String!) {\n    identificadoresPJV2(idConta: $idConta, ativos: true) {\n      paginacao {\n        total\n      }\n    }\n  }\n'],['\n  query totalIdentificadores($idConta: String!) {\n    identificadoresPJV2(idConta: $idConta, ativos: true) {\n      paginacao {\n        total\n      }\n    }\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  query identificador($numero: String!) {\n    identificador(numero: $numero) {\n      idIdentificador\n      codIdentificador\n      tipoIdentificador\n      veiculo {\n        marca\n        modelo\n        placa\n        chassi\n        renavam\n        categoria\n        tipo\n      }\n      situacao\n      dataAtualizacao\n    }\n  }\n'],['\n  query identificador($numero: String!) {\n    identificador(numero: $numero) {\n      idIdentificador\n      codIdentificador\n      tipoIdentificador\n      veiculo {\n        marca\n        modelo\n        placa\n        chassi\n        renavam\n        categoria\n        tipo\n      }\n      situacao\n      dataAtualizacao\n    }\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  mutation identificadorInativar(\n    $quantidadeIdentificadores: Int!\n    $codigoIdentificador: String!\n    $motivoInativacaoIdentificador: String!\n    $motivoInativacaoIdentificadorDescricao: String\n    $id: String!\n  ) {\n    identificadorInativar(\n      inativarIdentificador: {\n        quantidadeIdentificadores: $quantidadeIdentificadores\n        codigoIdentificador: $codigoIdentificador\n        motivoInativacaoIdentificador: $motivoInativacaoIdentificador\n        motivoInativacaoIdentificadorDescricao: $motivoInativacaoIdentificadorDescricao\n        codigoCliente: { conta: { id: $id } }\n      }\n    ) {\n      result\n      error {\n        message\n      }\n    }\n  }\n'],['\n  mutation identificadorInativar(\n    $quantidadeIdentificadores: Int!\n    $codigoIdentificador: String!\n    $motivoInativacaoIdentificador: String!\n    $motivoInativacaoIdentificadorDescricao: String\n    $id: String!\n  ) {\n    identificadorInativar(\n      inativarIdentificador: {\n        quantidadeIdentificadores: $quantidadeIdentificadores\n        codigoIdentificador: $codigoIdentificador\n        motivoInativacaoIdentificador: $motivoInativacaoIdentificador\n        motivoInativacaoIdentificadorDescricao: $motivoInativacaoIdentificadorDescricao\n        codigoCliente: { conta: { id: $id } }\n      }\n    ) {\n      result\n      error {\n        message\n      }\n    }\n  }\n']),_templateObject10=_taggedTemplateLiteral(['\n  mutation identificadorSubstituir(\n    $codigoConta: String!\n    $codigoIdentificador: String\n    $motivoInativacao: String\n    $motivoDescricao: String\n    $novoCodigo: String\n    $cep: String\n    $logradouro: String\n    $numero: String\n    $complemento: String\n    $bairro: String\n    $uf: String\n    $cidade: String\n  ) {\n    identificadorSubstituir(\n      substituirIdentificador: {\n        codigoCliente: { conta: { id: $codigoConta, tipoProduto: "POS" } }\n        codigoIdentificador: $codigoIdentificador\n        motivoInativacaoIdentificador: $motivoInativacao\n        motivoInativacaoIdentificadorDescricao: $motivoDescricao\n        novoCodigoIdentificador: $novoCodigo\n        endereco: {\n          cep: $cep\n          logradouro: $logradouro\n          numero: $numero\n          complemento: $complemento\n          bairro: $bairro\n          uf: $uf\n          cidade: $cidade\n        }\n      }\n    ) {\n      result\n      error {\n        codigo\n        message\n      }\n    }\n  }\n'],['\n  mutation identificadorSubstituir(\n    $codigoConta: String!\n    $codigoIdentificador: String\n    $motivoInativacao: String\n    $motivoDescricao: String\n    $novoCodigo: String\n    $cep: String\n    $logradouro: String\n    $numero: String\n    $complemento: String\n    $bairro: String\n    $uf: String\n    $cidade: String\n  ) {\n    identificadorSubstituir(\n      substituirIdentificador: {\n        codigoCliente: { conta: { id: $codigoConta, tipoProduto: "POS" } }\n        codigoIdentificador: $codigoIdentificador\n        motivoInativacaoIdentificador: $motivoInativacao\n        motivoInativacaoIdentificadorDescricao: $motivoDescricao\n        novoCodigoIdentificador: $novoCodigo\n        endereco: {\n          cep: $cep\n          logradouro: $logradouro\n          numero: $numero\n          complemento: $complemento\n          bairro: $bairro\n          uf: $uf\n          cidade: $cidade\n        }\n      }\n    ) {\n      result\n      error {\n        codigo\n        message\n      }\n    }\n  }\n']),_templateObject11=_taggedTemplateLiteral(['\n  mutation mudarSituacaoPapIndividual(\n    $idConta: String!\n    $adesaoPap: Boolean\n    $identificador: String\n    $placa: String\n  ) {\n    mudarSituacaoPapIndividual(\n      idConta: $idConta\n      adesaoPap: $adesaoPap\n      identificador: $identificador\n      placa: $placa\n    ) {\n      adesaoPap\n    }\n  }\n'],['\n  mutation mudarSituacaoPapIndividual(\n    $idConta: String!\n    $adesaoPap: Boolean\n    $identificador: String\n    $placa: String\n  ) {\n    mudarSituacaoPapIndividual(\n      idConta: $idConta\n      adesaoPap: $adesaoPap\n      identificador: $identificador\n      placa: $placa\n    ) {\n      adesaoPap\n    }\n  }\n']),_templateObject12=_taggedTemplateLiteral(['\n  query consultarIdentificadoresAtivos($idConta: String!) {\n    consultarIdentificadoresAtivos(idConta: $idConta)\n  }\n'],['\n  query consultarIdentificadoresAtivos($idConta: String!) {\n    consultarIdentificadoresAtivos(idConta: $idConta)\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlGetVehiclesCategory=exports.gqlGetVehiclesCategory=(0,_graphqlTag2.default)(_templateObject);var gqlActivateIdentification=exports.gqlActivateIdentification=(0,_graphqlTag2.default)(_templateObject2);var gqlNewIdentifier=exports.gqlNewIdentifier=(0,_graphqlTag2.default)(_templateObject3);var gqlIdentificadores=exports.gqlIdentificadores=(0,_graphqlTag2.default)(_templateObject4);var gqlIdentificadoresPaginado=exports.gqlIdentificadoresPaginado=(0,_graphqlTag2.default)(_templateObject5);var gqlHistoricoIdentificadorTag=exports.gqlHistoricoIdentificadorTag=(0,_graphqlTag2.default)(_templateObject6);var gqlTotalIdentificadores=exports.gqlTotalIdentificadores=(0,_graphqlTag2.default)(_templateObject7);var gqlIdentificador=exports.gqlIdentificador=(0,_graphqlTag2.default)(_templateObject8);var gqlDesabilitarIdentificador=exports.gqlDesabilitarIdentificador=(0,_graphqlTag2.default)(_templateObject9);var gqlSubstituirIdentificador=exports.gqlSubstituirIdentificador=(0,_graphqlTag2.default)(_templateObject10);var gqlModificarPapIndividual=exports.gqlModificarPapIndividual=(0,_graphqlTag2.default)(_templateObject11);var gqlDownloadIdentificadoresCsv=exports.gqlDownloadIdentificadoresCsv=(0,_graphqlTag2.default)(_templateObject12);var transformIndentificadoresPaginado=function transformIndentificadoresPaginado(src){var _src$data$identificad=src.data.identificadoresPJV2,identificadores=_src$data$identificad.identificadores,paginacao=_src$data$identificad.paginacao;return identificadores&&identificadores.map(function(_ref){var idConta=_ref['id-conta'],idCliente=_ref['id-cliente'],rest=_objectWithoutProperties(_ref,['id-conta','id-cliente']);return _extends({},rest,{idConta:idConta,idCliente:idCliente});},paginacao);};exports.transformIndentificadoresPaginado=transformIndentificadoresPaginado;var transformIndentificadores=function transformIndentificadores(src){var identificadoresPJ=src.data.identificadoresPJ;return identificadoresPJ&&identificadoresPJ.map(function(_ref2){var idConta=_ref2['id-conta'],idCliente=_ref2['id-cliente'],rest=_objectWithoutProperties(_ref2,['id-conta','id-cliente']);return _extends({},rest,{idConta:idConta,idCliente:idCliente});});};exports.transformIndentificadores=transformIndentificadores;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _birthDateValidate=__webpack_require__(1416);Object.defineProperty(exports,'birthDateValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_birthDateValidate).default;}});var _capitalize=__webpack_require__(1418);Object.defineProperty(exports,'capitalize',{enumerable:true,get:function get(){return _interopRequireDefault(_capitalize).default;}});var _cepMask=__webpack_require__(1419);Object.defineProperty(exports,'cepMask',{enumerable:true,get:function get(){return _interopRequireDefault(_cepMask).default;}});var _cepValidate=__webpack_require__(1420);Object.defineProperty(exports,'cepValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_cepValidate).default;}});var _cpfMask=__webpack_require__(1421);Object.defineProperty(exports,'cpfMask',{enumerable:true,get:function get(){return _interopRequireDefault(_cpfMask).default;}});var _cpfValidate=__webpack_require__(1422);Object.defineProperty(exports,'cpfValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_cpfValidate).default;}});var _currencyParser=__webpack_require__(1423);Object.defineProperty(exports,'currencyParser',{enumerable:true,get:function get(){return _interopRequireDefault(_currencyParser).default;}});var _calculateDataPercentage=__webpack_require__(1424);Object.defineProperty(exports,'calculateDataPercentage',{enumerable:true,get:function get(){return _interopRequireDefault(_calculateDataPercentage).default;}});var _dateMask=__webpack_require__(1425);Object.defineProperty(exports,'dateMask',{enumerable:true,get:function get(){return _interopRequireDefault(_dateMask).default;}});var _dateFormat=__webpack_require__(1426);Object.defineProperty(exports,'dateFormat',{enumerable:true,get:function get(){return _interopRequireDefault(_dateFormat).default;}});var _dateParser=__webpack_require__(1427);Object.defineProperty(exports,'dateParser',{enumerable:true,get:function get(){return _interopRequireDefault(_dateParser).default;}});var _dateValidate=__webpack_require__(1428);Object.defineProperty(exports,'dateValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_dateValidate).default;}});var _dateValidateWithFormat=__webpack_require__(1429);Object.defineProperty(exports,'dateValidateWithFormat',{enumerable:true,get:function get(){return _interopRequireDefault(_dateValidateWithFormat).default;}});var _dddMask=__webpack_require__(1430);Object.defineProperty(exports,'dddMask',{enumerable:true,get:function get(){return _interopRequireDefault(_dddMask).default;}});var _dddValidate=__webpack_require__(1431);Object.defineProperty(exports,'dddValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_dddValidate).default;}});var _emailValidate=__webpack_require__(1432);Object.defineProperty(exports,'emailValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_emailValidate).default;}});var _emptyFieldValidate=__webpack_require__(1433);Object.defineProperty(exports,'emptyFieldValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_emptyFieldValidate).default;}});var _formatBytes=__webpack_require__(1434);Object.defineProperty(exports,'formatBytes',{enumerable:true,get:function get(){return _interopRequireDefault(_formatBytes).default;}});var _getDayOfWeek=__webpack_require__(1435);Object.defineProperty(exports,'getDayOfWeek',{enumerable:true,get:function get(){return _interopRequireDefault(_getDayOfWeek).default;}});var _getMonth=__webpack_require__(1436);Object.defineProperty(exports,'getMonth',{enumerable:true,get:function get(){return _interopRequireDefault(_getMonth).default;}});var _groupArray=__webpack_require__(1437);Object.defineProperty(exports,'groupArray',{enumerable:true,get:function get(){return _interopRequireDefault(_groupArray).default;}});var _hasLetters=__webpack_require__(1438);Object.defineProperty(exports,'hasLetters',{enumerable:true,get:function get(){return _interopRequireDefault(_hasLetters).default;}});var _hasNumbers=__webpack_require__(1439);Object.defineProperty(exports,'hasNumbers',{enumerable:true,get:function get(){return _interopRequireDefault(_hasNumbers).default;}});var _identifierValidate=__webpack_require__(1440);Object.defineProperty(exports,'identifierValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_identifierValidate).default;}});var _plateMask=__webpack_require__(1441);Object.defineProperty(exports,'plateMask',{enumerable:true,get:function get(){return _interopRequireDefault(_plateMask).default;}});var _plateValidate=__webpack_require__(1442);Object.defineProperty(exports,'plateValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_plateValidate).default;}});var _queryStringParser=__webpack_require__(1443);Object.defineProperty(exports,'queryStringParser',{enumerable:true,get:function get(){return _interopRequireDefault(_queryStringParser).default;}});var _ISODateCalcDiff=__webpack_require__(1444);Object.defineProperty(exports,'ISODateCalcDiff',{enumerable:true,get:function get(){return _interopRequireDefault(_ISODateCalcDiff).default;}});var _ISODateFormat=__webpack_require__(1445);Object.defineProperty(exports,'ISODateFormat',{enumerable:true,get:function get(){return _interopRequireDefault(_ISODateFormat).default;}});var _ISODateParser=__webpack_require__(1446);Object.defineProperty(exports,'ISODateParser',{enumerable:true,get:function get(){return _interopRequireDefault(_ISODateParser).default;}});var _numberMask=__webpack_require__(1447);Object.defineProperty(exports,'numberMask',{enumerable:true,get:function get(){return _interopRequireDefault(_numberMask).default;}});var _phoneMask=__webpack_require__(1448);Object.defineProperty(exports,'phoneMask',{enumerable:true,get:function get(){return _interopRequireDefault(_phoneMask).default;}});var _phoneValidate=__webpack_require__(1449);Object.defineProperty(exports,'phoneValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_phoneValidate).default;}});var _validatePasswordLength=__webpack_require__(1450);Object.defineProperty(exports,'validatePasswordLength',{enumerable:true,get:function get(){return _interopRequireDefault(_validatePasswordLength).default;}});var _cnpjMask=__webpack_require__(1451);Object.defineProperty(exports,'cnpjMask',{enumerable:true,get:function get(){return _interopRequireDefault(_cnpjMask).default;}});var _cnpjValidate=__webpack_require__(1452);Object.defineProperty(exports,'cnpjValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_cnpjValidate).default;}});var _dateBeforeTodayValidate=__webpack_require__(1453);Object.defineProperty(exports,'dateBeforeTodayValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_dateBeforeTodayValidate).default;}});var _planColor=__webpack_require__(1454);Object.defineProperty(exports,'planColor',{enumerable:true,get:function get(){return _interopRequireDefault(_planColor).default;}});var _cookie=__webpack_require__(558);Object.defineProperty(exports,'cookie',{enumerable:true,get:function get(){return _interopRequireDefault(_cookie).default;}});var _numberAndLetter=__webpack_require__(1455);Object.defineProperty(exports,'numberAndLetter',{enumerable:true,get:function get(){return _interopRequireDefault(_numberAndLetter).default;}});var _creditCardValidate=__webpack_require__(1456);Object.defineProperty(exports,'creditCardValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_creditCardValidate).default;}});var _creditCardMask=__webpack_require__(1464);Object.defineProperty(exports,'creditCardMask',{enumerable:true,get:function get(){return _interopRequireDefault(_creditCardMask).default;}});var _creditCardValidadMask=__webpack_require__(1465);Object.defineProperty(exports,'creditCardValidadMask',{enumerable:true,get:function get(){return _interopRequireDefault(_creditCardValidadMask).default;}});var _creditCardValidadValidate=__webpack_require__(1466);Object.defineProperty(exports,'creditCardValidadValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_creditCardValidadValidate).default;}});var _creditCardCvcValidadMask=__webpack_require__(1467);Object.defineProperty(exports,'creditCardCvcValidadMask',{enumerable:true,get:function get(){return _interopRequireDefault(_creditCardCvcValidadMask).default;}});var _creditCardCvcValidate=__webpack_require__(1468);Object.defineProperty(exports,'creditCardCvcValidate',{enumerable:true,get:function get(){return _interopRequireDefault(_creditCardCvcValidate).default;}});var _integerParse=__webpack_require__(1469);Object.defineProperty(exports,'integerParse',{enumerable:true,get:function get(){return _interopRequireDefault(_integerParse).default;}});var _timeFormat=__webpack_require__(1470);Object.defineProperty(exports,'timeFormat',{enumerable:true,get:function get(){return _interopRequireDefault(_timeFormat).default;}});var _hourMask=__webpack_require__(1471);Object.defineProperty(exports,'hourMask',{enumerable:true,get:function get(){return _interopRequireDefault(_hourMask).default;}});var _newDefaultPassword=__webpack_require__(1472);Object.defineProperty(exports,'newDefaultPassword',{enumerable:true,get:function get(){return _newDefaultPassword.newDefaultPassword;}});Object.defineProperty(exports,'validateLetterLow',{enumerable:true,get:function get(){return _newDefaultPassword.validateLetterLow;}});Object.defineProperty(exports,'validateLetterUpper',{enumerable:true,get:function get(){return _newDefaultPassword.validateLetterUpper;}});Object.defineProperty(exports,'validateLetterEspecial',{enumerable:true,get:function get(){return _newDefaultPassword.validateLetterEspecial;}});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RouteWithSubRoutes=exports.routes=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/routes/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(15);var _TemplateLayout=__webpack_require__(362);var _TemplateLayout2=_interopRequireDefault(_TemplateLayout);var _Home=__webpack_require__(388);var _Home2=_interopRequireDefault(_Home);var _EditUserData=__webpack_require__(1678);var _EditUserData2=_interopRequireDefault(_EditUserData);var _EditCompanyData=__webpack_require__(1719);var _EditCompanyData2=_interopRequireDefault(_EditCompanyData);var _EditContactData=__webpack_require__(1724);var _EditContactData2=_interopRequireDefault(_EditContactData);var _EditAddress=__webpack_require__(1730);var _EditAddress2=_interopRequireDefault(_EditAddress);var _EditCompanyAddress=__webpack_require__(1739);var _EditCompanyAddress2=_interopRequireDefault(_EditCompanyAddress);var _EditRepresentatives=__webpack_require__(1742);var _EditRepresentatives2=_interopRequireDefault(_EditRepresentatives);var _EditAdminContact=__webpack_require__(1753);var _EditAdminContact2=_interopRequireDefault(_EditAdminContact);var _ChangePassword=__webpack_require__(1758);var _ChangePassword2=_interopRequireDefault(_ChangePassword);var _CancelAccount=__webpack_require__(1766);var _CancelAccount2=_interopRequireDefault(_CancelAccount);var _CanceledAccount=__webpack_require__(1773);var _CanceledAccount2=_interopRequireDefault(_CanceledAccount);var _firstAccess=__webpack_require__(1776);var _firstAccess2=_interopRequireDefault(_firstAccess);var _blockIdentifiers=__webpack_require__(1790);var _blockIdentifiers2=_interopRequireDefault(_blockIdentifiers);var _editIdentifier=__webpack_require__(1811);var _editIdentifier2=_interopRequireDefault(_editIdentifier);var _contestation=__webpack_require__(1829);var _contestation2=_interopRequireDefault(_contestation);var _recharge=__webpack_require__(1840);var _recharge2=_interopRequireDefault(_recharge);var _dashboard=__webpack_require__(1857);var _dashboard2=_interopRequireDefault(_dashboard);var _authentication=__webpack_require__(404);var _authentication2=_interopRequireDefault(_authentication);var _editPaymentMethod=__webpack_require__(2128);var _editPaymentMethod2=_interopRequireDefault(_editPaymentMethod);var _editDueDate=__webpack_require__(2139);var _editDueDate2=_interopRequireDefault(_editDueDate);var _cancelPlan=__webpack_require__(2148);var _cancelPlan2=_interopRequireDefault(_cancelPlan);var _followRequest=__webpack_require__(2161);var _followRequest2=_interopRequireDefault(_followRequest);var _activation=__webpack_require__(2182);var _activation2=_interopRequireDefault(_activation);var _editPaymentData=__webpack_require__(2190);var _editPaymentData2=_interopRequireDefault(_editPaymentData);var _ec=__webpack_require__(2212);var _ec2=_interopRequireDefault(_ec);var _profileActivation=__webpack_require__(2256);var _profileActivation2=_interopRequireDefault(_profileActivation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var inactiveRoutes=[{exact:true,path:'/',component:_Home2.default},{path:'/perfil',component:_TemplateLayout2.default,routes:[{path:'/perfil/conta-cancelada',component:_CanceledAccount2.default}]},_authentication2.default,{component:_Home2.default}];var inactiveProfileActivation=[{exact:true,path:'/',component:_Home2.default},{path:'/perfil',component:_TemplateLayout2.default,routes:[{path:'/perfil/editar-dados',component:_EditUserData2.default},{path:'/perfil/editar-contatos',component:_EditContactData2.default},{path:'/perfil/editar-endereco',component:_EditAddress2.default},{path:'/perfil/alterar-senha',component:_ChangePassword2.default},{path:'/perfil/conta-cancelada',component:_CanceledAccount2.default}]},_authentication2.default,{component:_Home2.default}];var routes=exports.routes={pf:{active:[{exact:true,path:'/',component:_Home2.default},{path:'/perfil',component:_TemplateLayout2.default,routes:[{path:'/perfil/editar-dados',component:_EditUserData2.default},{path:'/perfil/editar-contatos',component:_EditContactData2.default},{path:'/perfil/editar-endereco',component:_EditAddress2.default},{path:'/perfil/alterar-senha',component:_ChangePassword2.default},{path:'/perfil/conta-cancelada',component:_CanceledAccount2.default}]},{path:'/cancelar-conta',component:_CancelAccount2.default},_firstAccess2.default,_followRequest2.default,_blockIdentifiers2.default,_editIdentifier2.default,_cancelPlan2.default,_editPaymentMethod2.default,_editDueDate2.default,_contestation2.default,_recharge2.default,_activation2.default,_editPaymentData2.default,_dashboard2.default,_authentication2.default],inactive:inactiveRoutes},pj:{active:[{exact:true,path:'/',component:_Home2.default},{path:'/perfil',component:_TemplateLayout2.default,routes:[{path:'/perfil/editar-dados',component:_EditCompanyData2.default},{path:'/perfil/endereco-comercial',component:_EditCompanyAddress2.default},{path:'/perfil/representantes',component:_EditRepresentatives2.default},{path:'/perfil/contato-do-administrador',component:_EditAdminContact2.default},{path:'/perfil/alterar-senha',component:_ChangePassword2.default},{path:'/perfil/conta-cancelada',component:_CanceledAccount2.default}]},{path:'/cancelar-conta',component:_CancelAccount2.default},_firstAccess2.default,_followRequest2.default,_blockIdentifiers2.default,_editIdentifier2.default,_cancelPlan2.default,_editDueDate2.default,_editPaymentMethod2.default,_contestation2.default,_recharge2.default,_activation2.default,_editPaymentData2.default,_dashboard2.default,_authentication2.default],inactive:inactiveRoutes},ec:{active:_ec2.default,inactive:inactiveRoutes},at:{active:_profileActivation2.default,inactive:inactiveProfileActivation}};var RouteWithSubRoutes=exports.RouteWithSubRoutes=function RouteWithSubRoutes(route){return _react2.default.createElement(_reactRouterDom.Route,{exact:route.exact,path:route.path,render:function render(props){return _react2.default.createElement(route.component,_extends({},props,{routes:route.routes,profile:route.profile,__source:{fileName:_jsxFileName,lineNumber:219}}));},__source:{fileName:_jsxFileName,lineNumber:216}});};

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof2 = __webpack_require__(377);

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__(180);

var _keys2 = _interopRequireDefault(_keys);

var _assign = __webpack_require__(237);

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = __webpack_require__(135);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _toConsumableArray2 = __webpack_require__(381);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = __webpack_require__(239),
    breakpoints = _require.breakpoints;

var is = function is(n) {
  return n !== undefined && n !== null;
};
var num = function num(n) {
  return typeof n === 'number' && !isNaN(n);
};
var px = function px(n) {
  return num(n) ? n + 'px' : n;
};
var em = function em(n) {
  return num(n) ? n + 'em' : n;
};
var neg = function neg(n) {
  return n < 0;
};
var arr = function arr(n) {
  return Array.isArray(n) ? n : [n];
};

var get = function get(obj, path, fallback) {
  return path.split('.').reduce(function (a, b) {
    return a && a[b] ? a[b] : null;
  }, obj) || fallback;
};

var mq = function mq(n) {
  return '@media screen and (min-width: ' + em(n) + ')';
};

var breaks = function breaks(props) {
  return [null].concat((0, _toConsumableArray3.default)(get(props, 'theme.breakpoints', breakpoints).map(mq)));
};

var dec = function dec(props) {
  return function (val) {
    return arr(props).reduce(function (acc, prop) {
      return acc[prop] = val, acc;
    }, {});
  };
};

var media = function media(bp) {
  return function (d, i) {
    return is(d) ? bp[i] ? (0, _defineProperty3.default)({}, bp[i], d) : d : null;
  };
};

var merge = function merge(a, b) {
  return (0, _assign2.default)({}, a, b, (0, _keys2.default)(b).reduce(function (obj, key) {
    return (0, _assign2.default)(obj, (0, _defineProperty3.default)({}, key, a[key] !== null && (0, _typeof3.default)(a[key]) === 'object' ? merge(a[key], b[key]) : b[key]));
  }, {}));
};

// keeping for backwards-compatibility only
var idx = function idx(keys, obj) {
  return get(obj, keys.join('.')) || null;
};

module.exports = {
  get: get,
  is: is,
  px: px,
  em: em,
  neg: neg,
  num: num,
  arr: arr,
  idx: idx,
  breaks: breaks,
  media: media,
  dec: dec,
  merge: merge,
  mq: mq
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__(135);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = __webpack_require__(98),
    get = _require.get,
    is = _require.is,
    px = _require.px;

module.exports = function (_ref) {
  var key = _ref.key,
      prop = _ref.prop,
      cssProperty = _ref.cssProperty,
      numberToPx = _ref.numberToPx;
  return function (props) {
    var n = props[prop];
    if (!is(n)) return null;
    var val = get(props, ['theme', key, n].join('.'), n);
    var value = numberToPx ? px(val) : val;

    return (0, _defineProperty3.default)({}, cssProperty || prop, value);
  };
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loading.9e0373c2.gif";

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TextInput=__webpack_require__(1689);var _TextInput2=_interopRequireDefault(_TextInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_TextInput2.default;module.exports=exports['default'];

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.stopSaving=exports.startSaving=undefined;var _ActionTypes=__webpack_require__(230);var startSaving=exports.startSaving=function startSaving(){return{type:_ActionTypes.SAVING_FORM,state:{saving:true}};};var stopSaving=exports.stopSaving=function stopSaving(){return{type:_ActionTypes.SAVING_FORM,state:{saving:false}};};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.PageTitle=exports.HeaderLink=exports.HeaderContainer=exports.Header=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n        height: ',';\n    '],['\n        height: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        display: block;\n        line-height: ',';\n        position: relative;\n        text-align: center;\n        vertical-align: middle;\n        width: 100%;\n\n        svg {\n            left: 0;\n            position: absolute;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n    '],['\n        display: block;\n        line-height: ',';\n        position: relative;\n        text-align: center;\n        vertical-align: middle;\n        width: 100%;\n\n        svg {\n            left: 0;\n            position: absolute;\n            top: 50%;\n            transform: translateY(-50%);\n        }\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        ',';\n        padding: 0;\n    '],['\n        ',';\n        padding: 0;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-1p1je5a-0'})(['background-color:',';height:100vh;overflow:auto;'],_colors.skyBlue);var Header=exports.Header=_styledComponents2.default.header.withConfig({displayName:'styles__Header',componentId:'sc-1p1je5a-1'})(['background-color:',';border-bottom:solid ',' ',';'],_colors.skyBlue,(0,_rem2.default)('2px'),_colors.navyBlue);var HeaderContainer=exports.HeaderContainer=_styledComponents2.default.div.withConfig({displayName:'styles__HeaderContainer',componentId:'sc-1p1je5a-2'})(['align-items:center;display:flex;height:',';margin:0 ',';position:relative;',';'],(0,_rem2.default)('60px'),(0,_rem2.default)('30px'),_media2.default.large(_templateObject,(0,_rem2.default)('70px')));var HeaderLink=exports.HeaderLink=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__HeaderLink',componentId:'sc-1p1je5a-3'})(['',';align-items:center;color:',';display:inline-flex;line-height:1;text-decoration:none;svg{margin-right:',';}',';'],_types.txt14OpenSansBold,_colors.white,(0,_rem2.default)('25px'),_media2.default.small(_templateObject2,(0,_rem2.default)('60px')));var PageTitle=exports.PageTitle=_styledComponents2.default.p.withConfig({displayName:'styles__PageTitle',componentId:'sc-1p1je5a-4'})(['',';color:',';line-height:1;padding-right:',';margin:0;',';'],_types.title24Galano,_colors.white,(0,_rem2.default)('80px'),_media2.default.large(_templateObject3,_types.title40GalanoBold));

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var logDisabled_ = true;
var deprecationWarnings_ = true;

/**
 * Extract browser version out of the provided user agent string.
 *
 * @param {!string} uastring userAgent string.
 * @param {!string} expr Regular expression used as match criteria.
 * @param {!number} pos position in the version string to be returned.
 * @return {!number} browser version.
 */
function extractVersion(uastring, expr, pos) {
  var match = uastring.match(expr);
  return match && match.length >= pos && parseInt(match[pos], 10);
}

// Wraps the peerconnection event eventNameToWrap in a function
// which returns the modified event object (or false to prevent
// the event).
function wrapPeerConnectionEvent(window, eventNameToWrap, wrapper) {
  if (!window.RTCPeerConnection) {
    return;
  }
  var proto = window.RTCPeerConnection.prototype;
  var nativeAddEventListener = proto.addEventListener;
  proto.addEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap) {
      return nativeAddEventListener.apply(this, arguments);
    }
    var wrappedCallback = function(e) {
      var modifiedEvent = wrapper(e);
      if (modifiedEvent) {
        cb(modifiedEvent);
      }
    };
    this._eventMap = this._eventMap || {};
    this._eventMap[cb] = wrappedCallback;
    return nativeAddEventListener.apply(this, [nativeEventName,
      wrappedCallback]);
  };

  var nativeRemoveEventListener = proto.removeEventListener;
  proto.removeEventListener = function(nativeEventName, cb) {
    if (nativeEventName !== eventNameToWrap || !this._eventMap
        || !this._eventMap[cb]) {
      return nativeRemoveEventListener.apply(this, arguments);
    }
    var unwrappedCb = this._eventMap[cb];
    delete this._eventMap[cb];
    return nativeRemoveEventListener.apply(this, [nativeEventName,
      unwrappedCb]);
  };

  Object.defineProperty(proto, 'on' + eventNameToWrap, {
    get: function() {
      return this['_on' + eventNameToWrap];
    },
    set: function(cb) {
      if (this['_on' + eventNameToWrap]) {
        this.removeEventListener(eventNameToWrap,
            this['_on' + eventNameToWrap]);
        delete this['_on' + eventNameToWrap];
      }
      if (cb) {
        this.addEventListener(eventNameToWrap,
            this['_on' + eventNameToWrap] = cb);
      }
    },
    enumerable: true,
    configurable: true
  });
}

// Utility methods.
module.exports = {
  extractVersion: extractVersion,
  wrapPeerConnectionEvent: wrapPeerConnectionEvent,
  disableLog: function(bool) {
    if (typeof bool !== 'boolean') {
      return new Error('Argument type: ' + typeof bool +
          '. Please use a boolean.');
    }
    logDisabled_ = bool;
    return (bool) ? 'adapter.js logging disabled' :
        'adapter.js logging enabled';
  },

  /**
   * Disable or enable deprecation warnings
   * @param {!boolean} bool set to true to disable warnings.
   */
  disableWarnings: function(bool) {
    if (typeof bool !== 'boolean') {
      return new Error('Argument type: ' + typeof bool +
          '. Please use a boolean.');
    }
    deprecationWarnings_ = !bool;
    return 'adapter.js deprecation warnings ' + (bool ? 'disabled' : 'enabled');
  },

  log: function() {
    if (typeof window === 'object') {
      if (logDisabled_) {
        return;
      }
      if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.log.apply(console, arguments);
      }
    }
  },

  /**
   * Shows a deprecation warning suggesting the modern and spec-compatible API.
   */
  deprecated: function(oldMethod, newMethod) {
    if (!deprecationWarnings_) {
      return;
    }
    console.warn(oldMethod + ' is deprecated, please use ' + newMethod +
        ' instead.');
  },

  /**
   * Browser detector.
   *
   * @return {object} result containing browser and version
   *     properties.
   */
  detectBrowser: function(window) {
    var navigator = window && window.navigator;

    // Returned result object.
    var result = {};
    result.browser = null;
    result.version = null;

    // Fail early if it's not a browser
    if (typeof window === 'undefined' || !window.navigator) {
      result.browser = 'Not a browser.';
      return result;
    }

    if (navigator.mozGetUserMedia) { // Firefox.
      result.browser = 'firefox';
      result.version = extractVersion(navigator.userAgent,
          /Firefox\/(\d+)\./, 1);
    } else if (navigator.webkitGetUserMedia) {
      // Chrome, Chromium, Webview, Opera.
      // Version matches Chrome/WebRTC version.
      result.browser = 'chrome';
      result.version = extractVersion(navigator.userAgent,
          /Chrom(e|ium)\/(\d+)\./, 2);
    } else if (navigator.mediaDevices &&
        navigator.userAgent.match(/Edge\/(\d+).(\d+)$/)) { // Edge.
      result.browser = 'edge';
      result.version = extractVersion(navigator.userAgent,
          /Edge\/(\d+).(\d+)$/, 2);
    } else if (window.RTCPeerConnection &&
        navigator.userAgent.match(/AppleWebKit\/(\d+)\./)) { // Safari.
      result.browser = 'safari';
      result.version = extractVersion(navigator.userAgent,
          /AppleWebKit\/(\d+)\./, 1);
    } else { // Default fallthrough: not supported.
      result.browser = 'Not a supported browser.';
      return result;
    }

    return result;
  }
};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(116)('meta');
var isObject = __webpack_require__(26);
var has = __webpack_require__(59);
var setDesc = __webpack_require__(40).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(24)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(33)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(55)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(75);
var createDesc = __webpack_require__(177);
module.exports = __webpack_require__(76) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(97);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__(135);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = __webpack_require__(98),
    get = _require.get,
    is = _require.is,
    arr = _require.arr,
    num = _require.num,
    px = _require.px,
    breaks = _require.breaks,
    dec = _require.dec,
    media = _require.media,
    merge = _require.merge;

module.exports = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (props) {
    // support for legacy API
    var arg = args[0],
        _prop = args[1],
        _bool = args[2];

    var _ref = typeof arg === 'string' ? { cssProperty: arg, prop: _prop, boolValue: _bool } : arg,
        cssProperty = _ref.cssProperty,
        prop = _ref.prop,
        boolValue = _ref.boolValue,
        key = _ref.key,
        numberToPx = _ref.numberToPx;

    prop = prop || cssProperty;
    var n = props[prop];
    if (!is(n)) return null;

    var bp = breaks(props);
    var scale = get(props, ['theme', key || prop].join('.'), {});
    var sx = function sx(val) {
      return get(scale, '' + val, numberToPx ? px(val) : val);
    };

    if (!Array.isArray(n)) {
      return (0, _defineProperty3.default)({}, cssProperty, sx(bool(boolValue)(n)));
    }

    var val = arr(n);
    return val.map(bool(boolValue)).map(sx).map(dec(cssProperty)).map(media(bp)).reduce(merge, {});
  };
};

var bool = function bool(val) {
  return function (n) {
    if (Array.isArray(val)) return n === true ? val[0] : val[1];

    return n === true ? val : n;
  };
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/templates/TemplateEmpty/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _routes=__webpack_require__(96);var _PageLoader=__webpack_require__(88);var _PageLoader2=_interopRequireDefault(_PageLoader);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function TemplateEmpty(_ref){var routes=_ref.routes;return _react2.default.createElement(_PageLoader2.default,{__source:{fileName:_jsxFileName,lineNumber:7}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:8}},routes.map(function(route){return _react2.default.createElement(_routes.RouteWithSubRoutes,_extends({key:route.path},route,{__source:{fileName:_jsxFileName,lineNumber:8}}));})));}exports.default=TemplateEmpty;module.exports=exports['default'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SimpleModal=undefined;var _reactRedux=__webpack_require__(7);var _Modal=__webpack_require__(1815);var _Modal2=_interopRequireDefault(_Modal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function mapStateToProps(state){return{isOpen:state.modal};}exports.SimpleModal=_Modal.SimpleModal;exports.default=(0,_reactRedux.connect)(mapStateToProps)(_Modal2.default);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/RechargeBreadcrumbs/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(43);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _styles=__webpack_require__(1845);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RechargeBreadcrumbs=function RechargeBreadcrumbs(_ref){var _ref$steps=_ref.steps,steps=_ref$steps===undefined?3:_ref$steps,_ref$active=_ref.active,active=_ref$active===undefined?1:_ref$active;return _react2.default.createElement('nav',{__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement(_styles.Steps,{__source:{fileName:_jsxFileName,lineNumber:10}},(0,_lodash.range)(steps).map(function(step){return _react2.default.createElement(_styles.Step,{key:step,active:step+1===active,visited:step+1<active,__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_styles.StepCircle,{__source:{fileName:_jsxFileName,lineNumber:13}},step+1>9?step+1:'0'+(step+1),step+1<active&&_react2.default.createElement(_styles.CircleCheck,{__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement(_Icon2.default,{width:'20',height:'20',icon:'green-check',viewBox:'0 0 20 20',__source:{fileName:_jsxFileName,lineNumber:18}}))));})));};exports.default=RechargeBreadcrumbs;module.exports=exports['default'];

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 116 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(411);
var enumBugKeys = __webpack_require__(273);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(71);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(16);
var dPs = __webpack_require__(412);
var enumBugKeys = __webpack_require__(273);
var IE_PROTO = __webpack_require__(272)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(270)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(274).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(411);
var hiddenKeys = __webpack_require__(273).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(21);
var dP = __webpack_require__(40);
var DESCRIPTORS = __webpack_require__(38);
var SPECIES = __webpack_require__(33)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(69);
var call = __webpack_require__(424);
var isArrayIter = __webpack_require__(285);
var anObject = __webpack_require__(16);
var toLength = __webpack_require__(37);
var getIterFn = __webpack_require__(287);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(56);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(29);

var invariant = __webpack_require__(17);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(1052);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Observable", function() { return Observable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_zen_observable__);


var Observable = __WEBPACK_IMPORTED_MODULE_0_zen_observable___default.a;

/* harmony default export */ __webpack_exports__["default"] = (Observable);

//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(570);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 133 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(367);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(577);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Radio=__webpack_require__(1768);var _Radio2=_interopRequireDefault(_Radio);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Radio2.default;module.exports=exports['default'];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/icon-veloe-background.27f1a96c.svg";

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1945)();
}


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(40).f;
var has = __webpack_require__(59);
var TAG = __webpack_require__(33)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(70);
var TAG = __webpack_require__(33)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var defined = __webpack_require__(79);
var fails = __webpack_require__(24);
var spaces = __webpack_require__(276);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var ReactBaseClasses = __webpack_require__(445);
var ReactChildren = __webpack_require__(885);
var ReactDOMFactories = __webpack_require__(890);
var ReactElement = __webpack_require__(144);
var ReactPropTypes = __webpack_require__(891);
var ReactVersion = __webpack_require__(894);

var createReactClass = __webpack_require__(895);
var onlyChild = __webpack_require__(896);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var ReactCurrentOwner = __webpack_require__(91);

var warning = __webpack_require__(28);
var canDefineProperty = __webpack_require__(447);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(448);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var invariant = __webpack_require__(17);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactRef = __webpack_require__(905);
var ReactInstrumentation = __webpack_require__(73);

var warning = __webpack_require__(28);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = __webpack_require__(306);
var setInnerHTML = __webpack_require__(207);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(307);
var setTextContent = __webpack_require__(461);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(981);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.AJAX_MAX_RETRY=exports.GRAPHQL_MAX_RETY=exports.CHANGE_PASSWORD=exports.GRAPHQL_URL=exports.API_AUTHORIZATION_C6=exports.API_AUTHORIZATION=exports.AUTH_SCOPE=exports.REVOKE_TOKEN=exports.AUTH_URL=exports.API_BRASPAG_TOKEN_URL=exports.API_BRASPAG_CARD_URL=exports.LOGOUT=exports.BRASPAG_URL=exports.BUILD_NUMBER=exports.PUBLIC_SITE_URL=exports.API_URL=undefined;var _config=__webpack_require__(221);var _config2=_interopRequireDefault(_config);var _config3=__webpack_require__(221);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import { apiURLVeloe, apiAuthorization } from '../../../config.json'
var apiURLVeloe=_config2.default.apiURLVeloe,apiAuthorization=_config2.default.apiAuthorization,apiAuthorizationC6=_config2.default.apiAuthorizationC6,brasPagURL=_config2.default.brasPagURL,buildNumber=_config2.default.buildNumber,authScope=_config2.default.authScope;var API_URL=exports.API_URL=''+_config3.apiURL;var PUBLIC_SITE_URL=exports.PUBLIC_SITE_URL=''+_config3.publicSite;var BUILD_NUMBER=exports.BUILD_NUMBER='build.'+buildNumber;var BRASPAG_URL=exports.BRASPAG_URL=''+brasPagURL;var LOGOUT=exports.LOGOUT='/auth/logout';var API_BRASPAG_CARD_URL=exports.API_BRASPAG_CARD_URL=brasPagURL+'/card';var API_BRASPAG_TOKEN_URL=exports.API_BRASPAG_TOKEN_URL=apiURLVeloe+'/ms-proxy/gateway/accesstoken';var AUTH_URL=exports.AUTH_URL=apiURLVeloe+'/auth/v1/authentication/token';var REVOKE_TOKEN=exports.REVOKE_TOKEN=apiURLVeloe+'/auth/v1/revoke-token';var AUTH_SCOPE=exports.AUTH_SCOPE=authScope;var API_AUTHORIZATION=exports.API_AUTHORIZATION=apiAuthorization;var API_AUTHORIZATION_C6=exports.API_AUTHORIZATION_C6=apiAuthorizationC6;var GRAPHQL_URL=exports.GRAPHQL_URL=apiURLVeloe+'/api/graphql';var CHANGE_PASSWORD=exports.CHANGE_PASSWORD=apiURLVeloe+'/auth/v1/alterar-senha';var GRAPHQL_MAX_RETY=exports.GRAPHQL_MAX_RETY=5;var AJAX_MAX_RETRY=exports.AJAX_MAX_RETRY=5;

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvariantError", function() { return InvariantError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invariant", function() { return invariant; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(39);


var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
(function (invariant) {
    function warn() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return console.warn.apply(console, args);
    }
    invariant.warn = warn;
    function error() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return console.error.apply(console, args);
    }
    invariant.error = error;
})(invariant || (invariant = {}));
var invariant$1 = invariant;

/* harmony default export */ __webpack_exports__["default"] = (invariant$1);



/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.downloadFile=exports.downloadBase64=exports.base64toResponse=exports.splitNumeroConta=exports.getTipoTransacao=exports.getTipoConta=exports.copyNotTransformed=exports.transformObject=exports.removeTypename=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var base64toResponse=exports.base64toResponse=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(b64String,mimeType){var url,res,blob;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:url='data:'+mimeType+';base64,'+b64String;_context.next=3;return fetch(url);case 3:res=_context.sent;_context.next=6;return res.blob();case 6:blob=_context.sent;return _context.abrupt('return',new Response(blob));case 8:case'end':return _context.stop();}}},_callee,this);}));return function base64toResponse(_x2,_x3){return _ref5.apply(this,arguments);};}();var downloadBase64=exports.downloadBase64=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(b64String,mimeType,filename){var url,res,blob;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:url='data:'+mimeType+';base64,'+b64String;_context2.next=3;return fetch(url);case 3:res=_context2.sent;_context2.next=6;return res.blob();case 6:blob=_context2.sent;downloadFile(blob,filename);case 8:case'end':return _context2.stop();}}},_callee2,this);}));return function downloadBase64(_x4,_x5,_x6){return _ref6.apply(this,arguments);};}();var _get2=__webpack_require__(1254);var _get3=_interopRequireDefault(_get2);var _set2=__webpack_require__(1290);var _set3=_interopRequireDefault(_set2);var _invert2=__webpack_require__(1295);var _invert3=_interopRequireDefault(_invert2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var removeTypename=exports.removeTypename=function removeTypename(obj){return JSON.parse(JSON.stringify(obj,function(k,v){return k==='__typename'?undefined:v;}));};var transformObject=exports.transformObject=function transformObject(obj,attrMap){return Object.entries(attrMap).reduce(function(acc,_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];(0,_set3.default)(acc,key,(0,_get3.default)(obj,value));return acc;},{});};var copyNotTransformed=exports.copyNotTransformed=function copyNotTransformed(obj,attrMap){var attrsToExclude=(0,_invert3.default)(attrMap);return Object.entries(obj).reduce(function(acc,_ref3){var _ref4=_slicedToArray(_ref3,2),key=_ref4[0],value=_ref4[1];if(!attrsToExclude[key]){(0,_set3.default)(acc,key,(0,_get3.default)(obj,value));}return acc;},{});};var getTipoConta=exports.getTipoConta=function getTipoConta(tipo){return tipo==='CLIENTES_PRE'?'pre':'pos';};var getTipoTransacao=exports.getTipoTransacao=function getTipoTransacao(tipo){if(Array.isArray(tipo)){if(tipo.length===1&&!tipo.some(function(item){return item.tipo==='VALE_PEDAGIO';})){return tipo;}if(tipo.length===1&&tipo.some(function(item){return item.tipo==='VALE_PEDAGIO';})){return null;}if(tipo.length>1&&tipo.some(function(item){return item.tipo==='VALE_PEDAGIO';})){var indexOfPedagio=tipo.findIndex(function(item){return item.tipo==='VALE_PEDAGIO';});var tipoCopy=tipo.slice();tipoCopy.splice(indexOfPedagio,1);return tipoCopy;}return tipo;}};var splitNumeroConta=exports.splitNumeroConta=function splitNumeroConta(){var numero=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return[numero.substring(0,numero.length-1),numero.substring(numero.length-1)];};var downloadFile=exports.downloadFile=function downloadFile(blob,fileName){var useDownloadAttr=arguments.length>2&&arguments[2]!==undefined?arguments[2]:true;var link=document.createElement('a');// create a blobURI pointing to our Blob
link.href=URL.createObjectURL(blob);link.download=fileName;// some browser needs the anchor to be in the doc
document.body.append(link);if('download'in link){link.download=fileName;}link.click();link.remove();// in case the Blob uses a lot of memory
window.addEventListener('focus',function(e){return URL.revokeObjectURL(link.href);},{once:true});};

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(365);
var defined = __webpack_require__(367);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Button/Button.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _propTypes2=_interopRequireDefault(_propTypes);var _styles=__webpack_require__(1687);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Button(_ref){var disabled=_ref.disabled,text=_ref.text,href=_ref.href,onClick=_ref.onClick,buttonType=_ref.buttonType,type=_ref.type,width=_ref.width,id=_ref.id,loading=_ref.loading,secondary=_ref.secondary,props=_objectWithoutProperties(_ref,['disabled','text','href','onClick','buttonType','type','width','id','loading','secondary']);var handleDisabled=function handleDisabled(e){e.preventDefault();};var handleClick=function handleClick(e){e.preventDefault();if(onClick){onClick();}};return _react2.default.createElement(_styles.Wrapper,{width:width,disabled:disabled,buttonType:buttonType,secondary:secondary,__source:{fileName:_jsxFileName,lineNumber:32}},type&&type==='submit'?_react2.default.createElement(_styles.FormButtonField,_extends({disabled:disabled,type:type,loading:loading},props,{__source:{fileName:_jsxFileName,lineNumber:34}}),text):_react2.default.createElement(_styles.ButtonField,_extends({id:id,disabled:disabled,href:href,onClick:disabled?handleDisabled:handleClick,loading:loading,width:width},props,{__source:{fileName:_jsxFileName,lineNumber:38}}),props.icon&&_react2.default.createElement(_styles.BtnIcon,{alt:'',src:props.icon,__source:{fileName:_jsxFileName,lineNumber:47}}),text));}Button.defaultProps={disabled:null,buttonType:'',text:null,href:null,onClick:null,loading:false};Button.propTypes={disabled:_propTypes2.default.bool,buttonType:_propTypes2.default.string,text:_propTypes2.default.string.isRequired,href:_propTypes2.default.string,onClick:_propTypes2.default.func,loading:_propTypes2.default.bool};exports.default=Button;module.exports=exports['default'];

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(451);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-close.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IcClose=function IcClose(props){return _react2.default.createElement('svg',{width:props.width||'11',height:props.height||'11',viewBox:'0 0 48 48',__source:{fileName:_jsxFileName,lineNumber:4}},_react2.default.createElement('defs',{__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement('path',{id:'abbbb',d:'M35.122 37.262c-.59 0-1.18-.221-1.623-.664L.664 3.837a2.227 2.227 0 0 1 0-3.173 2.227 2.227 0 0 1 3.173 0l32.835 32.761a2.227 2.227 0 0 1 0 3.173c-.37.443-.96.664-1.55.664zm-32.835.517c-.59 0-1.18-.222-1.623-.664a2.227 2.227 0 0 1 0-3.173l10.7-10.552a2.227 2.227 0 0 1 3.172 0 2.227 2.227 0 0 1 0 3.173l-10.7 10.552c-.442.442-.958.664-1.549.664zM24.94 15.052c-.59 0-1.18-.22-1.623-.664a2.227 2.227 0 0 1 0-3.172L33.942.738a2.227 2.227 0 0 1 3.173 0 2.227 2.227 0 0 1 0 3.173L26.489 14.388a2.25 2.25 0 0 1-1.55.664z',__source:{fileName:_jsxFileName,lineNumber:6}})),_react2.default.createElement('g',{fill:'none',fillRule:'evenodd',transform:'translate(5 5)',__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement('mask',{id:'bbbb',fill:props.fill||'#fff',__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement('use',{xlinkHref:'#abbbb',__source:{fileName:_jsxFileName,lineNumber:10}})),_react2.default.createElement('use',{fill:props.fill||'#fff',fillRule:'nonzero',xlinkHref:'#abbbb',__source:{fileName:_jsxFileName,lineNumber:12}}),_react2.default.createElement('g',{mask:'url(#bbbb)',__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement('path',{fill:props.fill||'#fff',d:'M-5-5h48v48H-5z',__source:{fileName:_jsxFileName,lineNumber:14}}))));};exports.default=IcClose;module.exports=exports['default'];

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.isDate = isDate;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isSameMonth = isSameMonth;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */
function isDate(value) {
  return value instanceof Date && !isNaN(value.valueOf());
}

/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {Date} d
 * @param {number} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameMonth(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDate: isDate,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay,
  isSameMonth: isSameMonth
};
//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(68);
var global = __webpack_require__(21);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(105) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(70);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(16);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(16);
var aFunction = __webpack_require__(52);
var SPECIES = __webpack_require__(33)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(166);
var EventPluginUtils = __webpack_require__(300);

var accumulateInto = __webpack_require__(453);
var forEachAccumulated = __webpack_require__(454);
var warning = __webpack_require__(28);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var EventPluginRegistry = __webpack_require__(299);
var EventPluginUtils = __webpack_require__(300);
var ReactErrorUtils = __webpack_require__(301);

var accumulateInto = __webpack_require__(453);
var forEachAccumulated = __webpack_require__(454);
var invariant = __webpack_require__(17);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(92);

var getEventTarget = __webpack_require__(302);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + '.' + name : name;
};


/* harmony default export */ __webpack_exports__["a"] = (formatName);

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(214);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getLocations=getLocations;exports.queryPlate=queryPlate;exports.requestFileHistory=requestFileHistory;exports.requestMoneyTransfer=requestMoneyTransfer;exports.requestContestations=requestContestations;var locations=[{value:'1',label:'Posto Rebouças - Av. Rebouças, 2012, Campinas, São Paulo/SP'},{value:'2',label:'Posto Rebouças 2 - Av. Paulista, 1550, São Paulo/SP'},{value:'3',label:'Posto Rebouças 3 - Rua do Posto, 5, Guarulhos/SP'},{value:'4',label:'Posto Rebouças 4 - Av. Principal, 2015, Congonhas, São Paulo/SP'}];var unblockedCar={blocked:false,plate:'FRM-0009',queries:[{date:'04/11',hour:'12:20',blocked:false},{date:'05/11',hour:'07:20',blocked:false},{date:'06/11',hour:'05:20',blocked:false},{date:'07/11',hour:'13:20',blocked:false},{date:'08/11',hour:'14:20',blocked:true},{date:'09/11',hour:'16:20',blocked:true}]};var blockedCar={blocked:true,plate:'FRM-0099',queries:[{date:'04/11',hour:'12:20',blocked:false},{date:'05/11',hour:'07:20',blocked:false},{date:'06/11',hour:'05:20',blocked:false},{date:'07/11',hour:'13:20',blocked:true},{date:'08/11',hour:'14:20',blocked:true},{date:'09/11',hour:'16:20',blocked:true}]};var requestFileData=[{date:'11/03/2018',hour:'10:15pm',fileType:'TRT',sequential:'12345678',status:'Processando'},{date:'01/03/2018',hour:'06:47pm',fileType:'TRF',sequential:'12345678',status:'Finalizado'},{date:'11/11/2018',hour:'02:47am',fileType:'NEL',sequential:'12345678',status:'Finalizado'},{date:'12/28/2018',hour:'00:09am',fileType:'TAG',sequential:'12345678',status:'Finalizado'},{date:'10/30/2018',hour:'09:50am',fileType:'TGT',sequential:'12345678',status:'Finalizado'},{date:'12/02/2018',hour:'08:44am',fileType:'LNT',sequential:'12345678',status:'Finalizado'}];var moneyTransfers=[{date:'30/09/2017',value:1700,status:'Realizado'},{date:'01/10/2017',value:1750,status:'Realizado'},{date:'05/10/2017',value:1250,status:'Realizado'}];var contestations=[{date:'04/11',value:30},{date:'01/11',value:230},{date:'29/10',value:50},{date:'22/10',value:230},{date:'14/10',value:50},{date:'09/10',value:230},{date:'05/10',value:30}];var createPromise=function createPromise(body){return new Promise(function(resolve){window.setTimeout(function(){resolve(body);},1000);});};function getLocations(){return createPromise(locations);}function queryPlate(formData){return new Promise(function(resolve){window.setTimeout(function(){if(formData.plate==='FRM-0099')resolve(blockedCar);else resolve(unblockedCar);},1000);});}function requestFileHistory(){return createPromise(requestFileData);}function requestMoneyTransfer(){return createPromise(moneyTransfers);}function requestContestations(){return createPromise(contestations);}

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _commonService=__webpack_require__(357);Object.keys(_commonService).forEach(function(key){if(key==="default"||key==="__esModule")return;Object.defineProperty(exports,key,{enumerable:true,get:function get(){return _commonService[key];}});});

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/Header/index.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _propTypes2=_interopRequireDefault(_propTypes);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _MobileMenu=__webpack_require__(1648);var _MobileMenu2=_interopRequireDefault(_MobileMenu);var _Dropdown=__webpack_require__(587);var _Dropdown2=_interopRequireDefault(_Dropdown);var _DropdownList=__webpack_require__(588);var _DropdownList2=_interopRequireDefault(_DropdownList);var _ClickOut=__webpack_require__(590);var _ClickOut2=_interopRequireDefault(_ClickOut);var _apolloClient=__webpack_require__(42);var _ChoosePlanDropdown=__webpack_require__(1653);var _ChoosePlanDropdown2=_interopRequireDefault(_ChoosePlanDropdown);var _data=__webpack_require__(1661);var _styles=__webpack_require__(385);var _avatarPj=__webpack_require__(387);var _avatarPj2=_interopRequireDefault(_avatarPj);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var avatarList=[__webpack_require__(240),__webpack_require__(241),__webpack_require__(242),__webpack_require__(243),__webpack_require__(244),__webpack_require__(245),__webpack_require__(246),__webpack_require__(247)];var Header=function(_React$Component){_inherits(Header,_React$Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.toggleDropdownList=function(){_this.setState({isUserDropdownOpen:!_this.state.isUserDropdownOpen});};_this.closeDropdownList=function(){_this.setState({isUserDropdownOpen:false});};_this.toggleMobileMenu=function(){_this.setState({isMobileMenuOpen:!_this.state.isMobileMenuOpen});};_this.closeMobileMenu=function(){_this.setState({isMobileMenuOpen:false});};_this.mapLogoutAction=function(menu,doLogout,history){return menu.map(function(itemMenu){if(itemMenu.isLogout){return _extends({},itemMenu,{onClick:function onClick(){history.push('/conta/login');doLogout();}});}return itemMenu;});};_this.filterInvisibleItens=function(menu,active){var filterLabel=active?'active':'canceled';return menu.filter(function(itemMenu){return!itemMenu.exclude||Array.isArray(itemMenu.exclude)&&!itemMenu.exclude.includes(filterLabel);});};_this.state={isUserDropdownOpen:false,isPlanDropdownOpen:false,isMobileMenuOpen:false,isChoosePlanOpen:true};return _this;}_createClass(Header,[{key:'render',value:function render(){var _this2=this;var _props=this.props,userCancelled=_props.userCancelled,avatar=_props.avatar,account=_props.account,doLogout=_props.doLogout,history=_props.history,accountPlans=_props.accountPlans;// Verifica se existe o at referente a perfil ativação.
var profileActivationType=(account||{}).at||(account||{}).pc?'at':'';// Menu Options By Account Type
var headerMenuOptions=_data.headerMenuLinks[profileActivationType||account.accountType]||[];// Map Logout Action on Menu
headerMenuOptions=this.mapLogoutAction(headerMenuOptions,doLogout,history);// Exclude not visible menu itens
headerMenuOptions=this.filterInvisibleItens(headerMenuOptions,account.active);var resumeLink='/minha-veloe'+(accountPlans.activePlanId?'/'+accountPlans.activePlanId+'/':'/')+'resumo';var accountTypeLabel=account.accountType==='pf'?'Pessoal':'Empresarial';return _react2.default.createElement(_styles.HeaderWrapper,{__source:{fileName:_jsxFileName,lineNumber:121}},_react2.default.createElement(_styles.HeaderContainer,{__source:{fileName:_jsxFileName,lineNumber:122}},_react2.default.createElement(_styles.FlexContainer,{__source:{fileName:_jsxFileName,lineNumber:123}},_react2.default.createElement(_reactRouterDom.Link,{to:resumeLink,__source:{fileName:_jsxFileName,lineNumber:124}},_react2.default.createElement(_Icon2.default,{icon:'veloe-logo',svgStyle:_styles.Logo,width:'74',height:'31',viewBox:'0 0 74 31',__source:{fileName:_jsxFileName,lineNumber:125}})),_react2.default.createElement(_Hide2.default,{at:'large',__source:{fileName:_jsxFileName,lineNumber:128}},this.state.isMobileMenuOpen?_react2.default.createElement('a',{href:'#a',onClick:this.toggleMobileMenu,__source:{fileName:_jsxFileName,lineNumber:130}},_react2.default.createElement(_Icon2.default,{icon:'close',svgStyle:'height: 15px; width: 22px',viewBox:'0 0 14 14',__source:{fileName:_jsxFileName,lineNumber:131}})):_react2.default.createElement('a',{href:'#a',onClick:this.toggleMobileMenu,__source:{fileName:_jsxFileName,lineNumber:134}},_react2.default.createElement(_Icon2.default,{icon:'hamburger',width:'22',height:'15',viewBox:'0 0 22 15',__source:{fileName:_jsxFileName,lineNumber:135}}))),_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:140}},_react2.default.createElement(_ChoosePlanDropdown2.default,{__source:{fileName:_jsxFileName,lineNumber:141}}))),_react2.default.createElement(_Hide2.default,{at:'large',__source:{fileName:_jsxFileName,lineNumber:144}},_react2.default.createElement(_MobileMenu2.default,{avatar:avatarList[avatar],isOpen:this.state.isMobileMenuOpen,menuOptions:headerMenuOptions,categoryLabel:accountTypeLabel,username:account.name,headerLabelCategory:'profile',onClose:this.closeMobileMenu,userCancelled:userCancelled,profileActivationType:profileActivationType==='at',__source:{fileName:_jsxFileName,lineNumber:145}})),_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:157}},_react2.default.createElement(_styles.FlexContainer,{__source:{fileName:_jsxFileName,lineNumber:158}},_react2.default.createElement(_styles.VerticalSpacer,{__source:{fileName:_jsxFileName,lineNumber:160}}),_react2.default.createElement(_styles.UserInfoContainer,{__source:{fileName:_jsxFileName,lineNumber:161}},_react2.default.createElement(_ClickOut2.default,{callback:function callback(){return _this2.closeDropdownList();},__source:{fileName:_jsxFileName,lineNumber:162}},_react2.default.createElement(_styles.UserDropdownInfo,{isOpen:this.state.isUserDropdownOpen,__source:{fileName:_jsxFileName,lineNumber:163}},_react2.default.createElement(_styles.Avatar,{src:account.accountType==='pj'?_avatarPj2.default:avatarList[avatar],__source:{fileName:_jsxFileName,lineNumber:164}}),_react2.default.createElement(_Dropdown2.default,{categoryLabel:accountTypeLabel,dropdownLabel:account.name,headerLabelCategory:'profile',onClick:this.toggleDropdownList,__source:{fileName:_jsxFileName,lineNumber:165}})),_react2.default.createElement(_DropdownList2.default,{options:headerMenuOptions,isOpen:this.state.isUserDropdownOpen,onClose:this.closeDropdownList,userCancelled:userCancelled,__source:{fileName:_jsxFileName,lineNumber:172}})))))));}}]);return Header;}(_react2.default.Component);Header.defaultProps={account:{},userCancelled:false};Header.propTypes={account:_propTypes2.default.shape({name:_propTypes2.default.string,accountType:_propTypes2.default.string}),userCancelled:_propTypes2.default.bool};var mapStateToProps=function mapStateToProps(state){return{user:state.reducer.user.profile,avatar:state.header.avatar,account:state.reducer.account,accountPlans:state.reducer.accountPlans};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{doLogout:function doLogout(){(0,_apolloClient.revokeToken)();}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)((0,_reactRouterDom.withRouter)(Header));module.exports=exports['default'];

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(574);
var enumBugKeys = __webpack_require__(373);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1513)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(368)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1522), __esModule: true };

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__(135);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = __webpack_require__(98),
    get = _require.get,
    px = _require.px;

module.exports = function (pseudoclass, prop) {
  return function () {
    var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function (props) {
      var style = props[prop || pseudoclass];
      var numberToPx = keys.numberToPx || {};
      for (var key in style) {
        var toPx = numberToPx[key];

        if (!keys[key] && !toPx) continue;
        var themeKey = [keys[key], style[key]].join('.');
        style[key] = get(props.theme, themeKey, style[key]);

        if (toPx) style[key] = px(style[key]);
      }

      return (0, _defineProperty3.default)({}, '&:' + pseudoclass, style);
    };
  };
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Box = __webpack_require__(364);

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var align = function align(props) {
  return { verticalAlign: props.align || 'top' };
};

var Grid = (0, _styledComponents2.default)(_Box2.default)([], {
  display: 'inline-block'
}, align);
Grid.displayName = 'Grid';

exports.default = Grid;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default='\n    max-width: '+(0,_rem2.default)('1280px')+';\n    margin: 0 auto;\n';module.exports=exports['default'];

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.converText=converText;exports.removeSpecialChars=removeSpecialChars;function converText(text){var a='àáäâãèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;';var b='aaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------';var p=new RegExp(a.split('').join('|'),'g');return text.toString().toLowerCase().trim().replace(p,function(c){return b.charAt(a.indexOf(c));})// Replace special chars
.replace(/&/g,'-and-')// Replace & with 'and'
.replace(/[\s\W-]+/g,'-');// Replace spaces, non-word characters and dashes with a single dash (-)
}function removeSpecialChars(){var text=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return text.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.InputIconWrapper=exports.LabelIconWrapper=exports.Wrapper=exports.LengthCounter=exports.LoadingContainer=exports.ShowPassword=exports.BottomMessage=exports.Error=exports.InputField=exports.Label=exports.Content=exports.bottomLine=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var bottomLine=exports.bottomLine='\n    border-radius: '+(0,_rem2.default)('4px')+';\n    bottom: 0;\n    content: \'\';\n    height: '+(0,_rem2.default)('4px')+';\n    position: absolute;\n';var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-1r2r57q-0'})(['position:relative;:before{',' background-color:',';left:50%;right:0;transform:translateX(-50%);transition:0.5s ease width;width:0;z-index:1;',' ',';}:after{',' background-color:',';left:0;right:0;width:100%;',';}'],bottomLine,_colors.skyBlue,function(props){return props.isFocus&&'\n            width: 100%;\n        ';},function(props){return props.hasError&&'\n            background-color: '+_colors.red+';\n            width: 100%;\n        ';},bottomLine,_colors.grey,function(props){return props.disabled&&'\n            background-color: '+_colors.lighterGrey+';\n        ';});var Label=exports.Label=_styledComponents2.default.label.withConfig({displayName:'styles__Label',componentId:'sc-1r2r57q-1'})(['color:',';font-family:OpenSans;font-size:',';font-weight:200;margin-left:',';letter-spacing:',';line-height:1;opacity:0.6;pointer-events:none;text-transform:uppercase;white-space:nowrap;'],_colors.darkGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('16px'),(0,_rem2.default)('1px'));var InputField=exports.InputField=_styledComponents2.default.input.withConfig({displayName:'styles__InputField',componentId:'sc-1r2r57q-2'})(['background:none;border:none;box-shadow:none;box-sizing:border-box;color:',';font-family:OpenSans;font-size:',';height:',';letter-spacing:',';outline:none;padding-left:',';width:100%;position:relative;z-index:1;',' ','::placeholder{color:rgba(0,0,0,0.1);transition:0.2s color;',';}'],_colors.darkGrey,(0,_rem2.default)('20px'),(0,_rem2.default)('45px'),(0,_rem2.default)('-0.6px'),(0,_rem2.default)('16px'),function(props){return props.disabled&&'\n        color: '+_colors.disabledGrey+';\n        user-select: none;\n    ';},function(props){return props.isFocus&&'\n        color: '+_colors.charcoal+';\n    ';},function(props){return props.highlightPlaceholderOnBlur&&'\n            color: rgba(0, 0, 0, .2);\n        ';});var bottomAnimate=(0,_styledComponents.keyframes)(['0%{max-height:0;}100%{max-height:',';}'],(0,_rem2.default)('50px'));var Error=exports.Error=_styledComponents2.default.span.withConfig({displayName:'styles__Error',componentId:'sc-1r2r57q-3'})(['color:',';display:inline-block;font-family:OpenSans;font-size:',';letter-spacing:',';'],_colors.red,(0,_rem2.default)('12px'),(0,_rem2.default)('-0.3px'));var BottomMessage=exports.BottomMessage=_styledComponents2.default.div.withConfig({displayName:'styles__BottomMessage',componentId:'sc-1r2r57q-4'})(['animation:0.4s ',' forwards;display:flex;align-items:center;margin-top:',';max-height:0;overflow:hidden;padding-left:',';.animated-loading{margin-right:',';fill:',';}'],bottomAnimate,(0,_rem2.default)('8px'),(0,_rem2.default)('16px'),(0,_rem2.default)('8px'),_colors.grey);var ShowPassword=exports.ShowPassword=_styledComponents2.default.div.withConfig({displayName:'styles__ShowPassword',componentId:'sc-1r2r57q-5'})(['cursor:pointer;position:absolute;right:',';top:',';z-index:1;'],(0,_rem2.default)('17px'),(0,_rem2.default)('16px'));var rotateLoading=(0,_styledComponents.keyframes)(['0%{transform:rotate(0deg);}100%{transform:rotate(359deg);}']);var LoadingContainer=exports.LoadingContainer=_styledComponents2.default.div.withConfig({displayName:'styles__LoadingContainer',componentId:'sc-1r2r57q-6'})(['animation:1s ',' infinite linear;color:',';padding-top:',';position:absolute;right:',';top:',';z-index:1;'],rotateLoading,_colors.linkNavyBlue,(0,_rem2.default)('6px'),(0,_rem2.default)('20px'),(0,_rem2.default)('12px'));var LengthCounter=exports.LengthCounter=_styledComponents2.default.span.withConfig({displayName:'styles__LengthCounter',componentId:'sc-1r2r57q-7'})(['float:right;font-family:OpenSans;font-size:',';padding-top:',';color:',';text-align:right;'],(0,_rem2.default)('14px'),(0,_rem2.default)('7px'),_colors.skyBlue);var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-1r2r57q-8'})(['padding-top:',';position:relative;',';'],(0,_rem2.default)('5px'),function(props){return props.negative&&(0,_styledComponents.css)(['','{:before{display:none;}:after{background-color:',';}}','{color:',';opacity:1;}','{color:',';::placeholder{color:rgba(255,255,255,0.4);}}','{color:',';}','{color:',';}','{color:',';}'],Content,_colors.white,Label,_colors.white,InputField,_colors.white,Error,_colors.white,LoadingContainer,_colors.white,LengthCounter,_colors.white);});var LabelIconWrapper=exports.LabelIconWrapper=_styledComponents2.default.span.withConfig({displayName:'styles__LabelIconWrapper',componentId:'sc-1r2r57q-9'})(['position:absolute;left:92%;']);var InputIconWrapper=exports.InputIconWrapper=_styledComponents2.default.span.withConfig({displayName:'styles__InputIconWrapper',componentId:'sc-1r2r57q-10'})(['position:absolute;left:85%;top:25%;']);

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.EditUserDataWrapper=exports.Paragraph=exports.Heading=exports.Wrapper=exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n        margin: ',' auto;\n    '],['\n        margin: ',' auto;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        ','\n    '],['\n        ','\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        width: ',';\n        margin: 0;\n    '],['\n        width: ',';\n        margin: 0;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-b22rpz-0'})(['',';margin:',' auto;',';'],_content2.default,(0,_rem2.default)('42px'),_media2.default.small(_templateObject,(0,_rem2.default)('29px')));var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-b22rpz-1'})(['margin:',' 0;'],(0,_rem2.default)('32px'));var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-b22rpz-2'})(['',' color:',';font-weight:bold;margin-bottom:',';',';'],_types.title18Galano,_colors.darkBlue,(0,_rem2.default)('20px'),_media2.default.large(_templateObject2,_types.title24Galano));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-b22rpz-3'})(['',' color:',';width:',';margin-top:',';',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('270px'),(0,_rem2.default)('7px'),_media2.default.large(_templateObject3,(0,_rem2.default)('313px')));var EditUserDataWrapper=exports.EditUserDataWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__EditUserDataWrapper',componentId:'sc-b22rpz-4'})(['margin-left:',';margin-right:',';'],(0,_rem2.default)('30px'),(0,_rem2.default)('30px'));

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.hexToRgba=hexToRgba;function hexToRgba(hex){var opacity=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;hex=hex.replace('#','');hex=hex.length===3?''+hex+hex:hex;var red=parseInt(hex.substring(0,2),16);var green=parseInt(hex.substring(2,4),16);var blue=parseInt(hex.substring(4,6),16);return'rgba('+red+', '+green+', '+blue+', '+opacity+')';}

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ModalBlue/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _propTypes2=_interopRequireDefault(_propTypes);var _styles=__webpack_require__(1800);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Blue=function Blue(_ref){var backgroundImage=_ref.backgroundImage,children=_ref.children,position=_ref.position;return _react2.default.createElement(_styles.Overlay,{__source:{fileName:_jsxFileName,lineNumber:7}},_react2.default.createElement(_styles.Modal,{backgroundImage:backgroundImage,position:position,__source:{fileName:_jsxFileName,lineNumber:8}},children));};Blue.propTypes={backgroundImage:_propTypes2.default.string,children:_propTypes2.default.element.isRequired,position:_propTypes2.default.string};exports.default=Blue;module.exports=exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ManageInfoModal/index.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _propTypes=__webpack_require__(9);var _Modal=__webpack_require__(113);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _icClose=__webpack_require__(157);var _icClose2=_interopRequireDefault(_icClose);var _icCheck=__webpack_require__(612);var _icCheck2=_interopRequireDefault(_icCheck);var _colors=__webpack_require__(2);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _actions=__webpack_require__(13);var _styles=__webpack_require__(613);var _FormEditManageInfo=__webpack_require__(1818);var _FormEditManageInfo2=_interopRequireDefault(_FormEditManageInfo);var _ChooseGeneralInformation=__webpack_require__(1820);var _ChooseGeneralInformation2=_interopRequireDefault(_ChooseGeneralInformation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Assets
// UIComponents
// Actions
// Styles
// Components
var GeneralInformationModal=function(_Component){_inherits(GeneralInformationModal,_Component);function GeneralInformationModal(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,GeneralInformationModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GeneralInformationModal.__proto__||Object.getPrototypeOf(GeneralInformationModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={onSucessUpdate:false,informationSelected:null,// 'chooseRemove', 'chooseEdit', 'form', 'success'
modalType:'chooseEdit',successMessage:'Sucesso',successBtnTitle:'OK',loading:false,msgError:'',dayMonth:(0,_moment2.default)().format('DD/MM/YYYY'),hourMinute:(0,_moment2.default)().format('HH:mm')},_this.prepareModal=function(){var modalStart=_this.props.modalStart;if(modalStart==='edit'){_this.setState({modalType:'form'});}else if(modalStart==='include'){_this.setState({modalType:'chooseEdit'});}else if(modalStart==='remove'){_this.setState({modalType:'chooseRemove'});}},_this.onSubmit=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(values){var _this$props,saveManageInf,updateManageInf,vehicle,controlled,handleSubmitExternal,modalStart,match,informationSelected,year,dateTime,isoDate,data;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({loading:true});_this$props=_this.props,saveManageInf=_this$props.saveManageInf,updateManageInf=_this$props.updateManageInf,vehicle=_this$props.vehicle,controlled=_this$props.controlled,handleSubmitExternal=_this$props.handleSubmitExternal,modalStart=_this$props.modalStart,match=_this$props.match;informationSelected=_this.state.informationSelected;year=(0,_moment2.default)().year();dateTime=values.data+'/'+year+' '+values.hora;isoDate=(0,_moment2.default)(dateTime,'DD/MM/YYYY HH:mm').toISOString();data=_extends({},vehicle.id&&{id:vehicle.id},{dataInicioVigencia:isoDate,descricao:values.descricao,tipoInfo:modalStart==='edit'?vehicle.tipoInfo:informationSelected,placa:vehicle.codIdentificador?vehicle.veiculo.placa:'',conta:match.params.id,codIdentificador:vehicle?vehicle.codIdentificador:''});if(!controlled){_context.next=10;break;}_this.setState({loading:false});return _context.abrupt('return',handleSubmitExternal(data));case 10:if(modalStart==='edit'){updateManageInf({data:data}).then(function(resp){_this.setState({modalType:'success',successMessage:'Informação alterada com sucesso',loading:false});}).catch(function(error){error.json().then(function(reponse){return _this.setState({loading:false,msgError:reponse.message});});});}else{saveManageInf({data:data}).then(function(resp){_this.setState({modalType:'success',successMessage:'Informação adicionada com sucesso',loading:false});}).catch(function(error){error.json().then(function(reponse){return _this.setState({loading:false,msgError:reponse.message});});});}case 11:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.onRemoveInfo=function(){_this.props.deleteManageInf().then(function(){_this.setState({modalType:'success',successMessage:'Informação removida com sucesso'});}).catch(function(error){return _this.setState({msgError:error});});},_this.handleChangeInformation=function(informationSelected){_this.setState({informationSelected:informationSelected});},_this.chooseOnSubmit=function(){_this.setState({modalType:'form'});},_this.handleCloseModal=function(){_this.setState({modalType:'chooseEdit',informationSelected:null,msgError:''});_this.props.toggleModal();},_this.handleCloseModalSuccess=function(){_this.handleCloseModal();},_this.renderContentModal=function(){var _this$props2=_this.props,hideSuccessButton=_this$props2.hideSuccessButton,manageInfsReducer=_this$props2.manageInfsReducer,modalStart=_this$props2.modalStart,vehicle=_this$props2.vehicle;var updateLoading=manageInfsReducer.updateLoading,manageInfsTop5=manageInfsReducer.manageInfsTop5;var _this$state=_this.state,informationSelected=_this$state.informationSelected,modalType=_this$state.modalType,successMessage=_this$state.successMessage,successBtnTitle=_this$state.successBtnTitle,loading=_this$state.loading,msgError=_this$state.msgError,dayMonth=_this$state.dayMonth,hourMinute=_this$state.hourMinute;switch(modalType){case'chooseEdit':return _react2.default.createElement(_styles.WrapperContentModal,{__source:{fileName:_jsxFileName,lineNumber:203}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:204}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:205}},'Selecione a informa\xE7\xE3o que deseja Incluir.'),_react2.default.createElement(_ChooseGeneralInformation2.default,{handleChangeInformation:_this.handleChangeInformation,__source:{fileName:_jsxFileName,lineNumber:206}})),_react2.default.createElement(_styles.WrapperButton,{__source:{fileName:_jsxFileName,lineNumber:208}},_react2.default.createElement(_Button2.default,{text:'OK',buttonType:'darkBlue',onClick:_this.chooseOnSubmit,loading:false,disabled:!informationSelected,__source:{fileName:_jsxFileName,lineNumber:209}})));case'chooseRemove':return _react2.default.createElement(_styles.WrapperContentModal,{__source:{fileName:_jsxFileName,lineNumber:221}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:222}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:223}},'Selecione a informa\xE7\xE3o que deseja remover.'),_react2.default.createElement(_ChooseGeneralInformation2.default,{handleChangeInformation:_this.handleChangeInformation,__source:{fileName:_jsxFileName,lineNumber:224}})),_react2.default.createElement(_styles.WrapperButton,{__source:{fileName:_jsxFileName,lineNumber:226}},_react2.default.createElement(_Button2.default,{text:'OK',buttonType:'darkBlue',onClick:_this.onRemoveInfo,loading:updateLoading,disabled:!informationSelected||updateLoading,__source:{fileName:_jsxFileName,lineNumber:227}})));case'success':return _react2.default.createElement(_styles.SuccessContainer,{__source:{fileName:_jsxFileName,lineNumber:239}},_react2.default.createElement(_styles.SuccessContent,{__source:{fileName:_jsxFileName,lineNumber:240}},_react2.default.createElement('img',{src:_icCheck2.default,alt:'Success Check',__source:{fileName:_jsxFileName,lineNumber:241}}),_react2.default.createElement(_styles.SuccessMessage,{__source:{fileName:_jsxFileName,lineNumber:242}},successMessage)),!hideSuccessButton&&_react2.default.createElement(_styles.WrapperButton,{justify:'center',__source:{fileName:_jsxFileName,lineNumber:245}},_react2.default.createElement(_Button2.default,{text:successBtnTitle,onClick:_this.handleCloseModalSuccess,buttonType:'transparent',__source:{fileName:_jsxFileName,lineNumber:246}})));// Default is ModalType=form
default:var formTitle=informationSelected==='INFORMACAO_1'?'Informação 1':informationSelected==='INFORMACAO_2'?'Informação 2':'Informação 3';var parseDate=function parseDate(isoDate){return(0,_moment2.default)(isoDate).format('DD/MM/YYYY');};var parseHour=function parseHour(isoDate){return(0,_moment2.default)(isoDate).format('HH:mm');};return _react2.default.createElement(_FormEditManageInfo2.default,{isLoading:updateLoading,initialValues:modalStart==='edit'?{data:parseDate(vehicle.dataInicioVigencia),hora:parseHour(vehicle.dataInicioVigencia),descricao:vehicle.descricaoAtual}:{data:dayMonth,hora:hourMinute},onSubmit:_this.onSubmit,formTitle:modalStart==='edit'?'Alterar':formTitle,dateTimeDisabled:modalStart==='edit',top5List:manageInfsTop5,loading:loading,msgError:msgError,__source:{fileName:_jsxFileName,lineNumber:265}});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GeneralInformationModal,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,fetchGetManageInfsTop5=_props.fetchGetManageInfsTop5,match=_props.match,fetchLogout=_props.fetchLogout,history=_props.history;this.prepareModal();if(match.params.id){fetchGetManageInfsTop5(match.params.id).then(function(resp){if(resp&&(resp.status===401||resp.status===403)){fetchLogout();history.push('/conta/login');}});}var dayMonth=(0,_moment2.default)().format('DD/MM/YYYY');var hourMinute=(0,_moment2.default)().format('HH:mm');this.setState({dayMonth:dayMonth,hourMinute:hourMinute});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(prevProps.modalStart!==this.props.modalStart){this.prepareModal();}}},{key:'render',value:function render(){var _props2=this.props,isOpen=_props2.isOpen,toggleModal=_props2.toggleModal,modalType=_props2.modalType;var iconColor=modalType==='success'?_colors.white:_colors.blueGray;if(isOpen){return _react2.default.createElement(_Modal.SimpleModal,{hideModal:toggleModal,__source:{fileName:_jsxFileName,lineNumber:292}},this.renderContentModal(),_react2.default.createElement(_styles.Back,{onClick:this.handleCloseModal,__source:{fileName:_jsxFileName,lineNumber:294}},_react2.default.createElement(_icClose2.default,{width:24,height:24,fill:iconColor,__source:{fileName:_jsxFileName,lineNumber:295}})));}return null;}}]);return GeneralInformationModal;}(_react.Component);GeneralInformationModal.defaultProps={controlled:false,isOpen:false,hideSuccessButton:false,toggleModal:function toggleModal(){},modalStart:'',vehicle:{},isUpdating:false};GeneralInformationModal.propTypes={controlled:_propTypes.bool,isOpen:_propTypes.bool.isRequired,toggleModal:_propTypes.func,hideSuccessButton:_propTypes.bool,vehicle:_propTypes.object,isUpdating:_propTypes.bool,modalStart:(0,_propTypes.oneOf)(['edit','remove','include'])};var mapStateToProps=function mapStateToProps(_ref3){var reducer=_ref3.reducer;return{manageInfsReducer:reducer.manageInfs};};// eslint-disable-next-line no-class-assign
GeneralInformationModal=(0,_reactRouterDom.withRouter)(GeneralInformationModal);exports.default=(0,_reactRedux.connect)(mapStateToProps,{fetchGetManageInfsTop5:_actions.fetchGetManageInfsTop5,fetchGetVehicles:_actions.fetchGetVehicles,fetchLogout:_actions.fetchLogout,saveManageInf:_actions.saveManageInf,updateManageInf:_actions.updateManageInf,deleteManageInf:_actions.deleteManageInf})(GeneralInformationModal);module.exports=exports['default'];

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.CarPlateQuerySubtitle=exports.CarPlateQueryTitle=exports.BackToFormText=exports.BackToFormContainer=exports.CarStatus=exports.SimpleFormQueryButtonContainer=exports.QueryButtonContainer=exports.Divider=exports.Label=exports.Plate=exports.PlateLabel=exports.CarContent=exports.FormContent=exports.FormSimpleContent=exports.BaseFormContent=exports.Subtitle=exports.Title=exports.SubHeader=exports.Main=exports.RowContainer=exports.Container=exports.HideOnLarge=exports.HideOnSmall=undefined;var _templateObject=_taggedTemplateLiteral(['\n    display: none;\n  '],['\n    display: none;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    padding: 0px ',';\n  '],['\n    padding: 0px ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    padding: ',';\n  '],['\n    padding: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    padding: ',' ',';\n  '],['\n    padding: ',' ',';\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    margin: 17px 0px 0px 0px;\n  '],['\n    margin: 17px 0px 0px 0px;\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    width: 50%;\n    margin: auto;\n  '],['\n    width: 50%;\n    margin: auto;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _container=__webpack_require__(183);var _container2=_interopRequireDefault(_container);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var HideOnSmall=exports.HideOnSmall=_styledComponents2.default.div.withConfig({displayName:'styles__HideOnSmall',componentId:'sc-16yaiye-0'})(['',';'],_media2.default.small(_templateObject));var HideOnLarge=exports.HideOnLarge=_styledComponents2.default.div.withConfig({displayName:'styles__HideOnLarge',componentId:'sc-16yaiye-1'})(['',';'],_media2.default.large(_templateObject));var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-16yaiye-2'})(['width:100%;',';'],_container2.default);var RowContainer=exports.RowContainer=(0,_styledComponents2.default)(Container).withConfig({displayName:'styles__RowContainer',componentId:'sc-16yaiye-3'})(['display:flex;flex-direction:row;']);var Main=exports.Main=_styledComponents2.default.main.withConfig({displayName:'styles__Main',componentId:'sc-16yaiye-4'})(['display:block;']);var SubHeader=exports.SubHeader=_styledComponents2.default.div.withConfig({displayName:'styles__SubHeader',componentId:'sc-16yaiye-5'})(['margin:40px 0px;',';'],_media2.default.small(_templateObject2,(0,_rem2.default)('16px')));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-16yaiye-6'})(['',' margin:0px;color:',';'],_types.title24GalanoBold,_colors.linkNavyBlue);var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-16yaiye-7'})(['',' margin:0px;color:',';'],_types.txt14OpenSans,_colors.linkNavyBlue);var BaseFormContent=exports.BaseFormContent=_styledComponents2.default.div.withConfig({displayName:'styles__BaseFormContent',componentId:'sc-16yaiye-8'})(['display:flex;flex-direction:row;padding:20px;width:100%;form{width:100%;',';}'],_container2.default);var FormSimpleContent=exports.FormSimpleContent=(0,_styledComponents2.default)(BaseFormContent).withConfig({displayName:'styles__FormSimpleContent',componentId:'sc-16yaiye-9'})(['border-radius:4.4px;border:solid 1px #c5c3d8;']);var FormContent=exports.FormContent=(0,_styledComponents2.default)(BaseFormContent).withConfig({displayName:'styles__FormContent',componentId:'sc-16yaiye-10'})(['background-color:',';',';',';'],_colors.offWhite,_media2.default.small(_templateObject3,(0,_rem2.default)('16px')),_media2.default.large(_templateObject4,(0,_rem2.default)('50px'),(0,_rem2.default)('65px')));var CarContent=exports.CarContent=(0,_styledComponents2.default)(FormContent).withConfig({displayName:'styles__CarContent',componentId:'sc-16yaiye-11'})(['',';flex-direction:column;'],function(_ref){var color=_ref.color;return'background-color: '+color+';';});var PlateLabel=exports.PlateLabel=_styledComponents2.default.div.withConfig({displayName:'styles__PlateLabel',componentId:'sc-16yaiye-12'})(['',';',';'],_types.txt12OpenSans,function(_ref2){var color=_ref2.color;return'color: '+color+';';});var Plate=exports.Plate=_styledComponents2.default.div.withConfig({displayName:'styles__Plate',componentId:'sc-16yaiye-13'})(['',';',';margin-bottom:36px;'],_types.txt20OpenSansBold,function(_ref3){var color=_ref3.color;return'color: '+color+';';});var Label=exports.Label=_styledComponents2.default.span.withConfig({displayName:'styles__Label',componentId:'sc-16yaiye-14'})(['',' color:',';align-self:flex-end;margin-bottom:10px;text-align:center;width:22px;'],_types.txt14OpenSans,_colors.darkGrey);var Divider=exports.Divider=_styledComponents2.default.div.withConfig({displayName:'styles__Divider',componentId:'sc-16yaiye-15'})(['width:22px;']);var QueryButtonContainer=exports.QueryButtonContainer=_styledComponents2.default.div.withConfig({displayName:'styles__QueryButtonContainer',componentId:'sc-16yaiye-16'})(['',';',';'],_media2.default.large(_templateObject5),_media2.default.small(_templateObject6));var SimpleFormQueryButtonContainer=exports.SimpleFormQueryButtonContainer=(0,_styledComponents2.default)(QueryButtonContainer).withConfig({displayName:'styles__SimpleFormQueryButtonContainer',componentId:'sc-16yaiye-17'})(['width:100%;div{width:100%;}']);var CarStatus=exports.CarStatus=_styledComponents2.default.p.withConfig({displayName:'styles__CarStatus',componentId:'sc-16yaiye-18'})(['',' margin:6px 16px;',';'],_types.title24GalanoBold,function(_ref4){var color=_ref4.color;return'color: '+color+';';});var BackToFormContainer=exports.BackToFormContainer=_styledComponents2.default.div.withConfig({displayName:'styles__BackToFormContainer',componentId:'sc-16yaiye-19'})(['display:flex;flex-direction:row;margin:16px;']);var BackToFormText=exports.BackToFormText=_styledComponents2.default.p.withConfig({displayName:'styles__BackToFormText',componentId:'sc-16yaiye-20'})(['',' margin:0px 8px;color:',';cursor:pointer;'],_types.txt14OpenSansBold,_colors.linkNavyBlue);var CarPlateQueryTitle=exports.CarPlateQueryTitle=_styledComponents2.default.p.withConfig({displayName:'styles__CarPlateQueryTitle',componentId:'sc-16yaiye-21'})(['',';color:',';margin:0;'],_types.txt24OpenSansBold,_colors.linkNavyBlue);var CarPlateQuerySubtitle=exports.CarPlateQuerySubtitle=_styledComponents2.default.p.withConfig({displayName:'styles__CarPlateQuerySubtitle',componentId:'sc-16yaiye-22'})(['',';color:',';margin:0 0 28px 0;'],_types.txt14OpenSans,_colors.darkGrey);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(60);
var toLength = __webpack_require__(37);
var toAbsoluteIndex = __webpack_require__(118);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 192 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(70);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(71);
var defined = __webpack_require__(79);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(26);
var cof = __webpack_require__(70);
var MATCH = __webpack_require__(33)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(33)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(140);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(428);
var redefine = __webpack_require__(56);
var hide = __webpack_require__(55);
var fails = __webpack_require__(24);
var defined = __webpack_require__(79);
var wks = __webpack_require__(33);
var regexpExec = __webpack_require__(291);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(21);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(56);
var redefineAll = __webpack_require__(124);
var meta = __webpack_require__(106);
var forOf = __webpack_require__(123);
var anInstance = __webpack_require__(122);
var isObject = __webpack_require__(26);
var fails = __webpack_require__(24);
var $iterDetect = __webpack_require__(196);
var setToStringTag = __webpack_require__(139);
var inheritIfRequired = __webpack_require__(277);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var hide = __webpack_require__(55);
var uid = __webpack_require__(116);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(105) || !__webpack_require__(24)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(21)[K];
});


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(5);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(5);
var aFunction = __webpack_require__(52);
var ctx = __webpack_require__(69);
var forOf = __webpack_require__(123);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(29);

var invariant = __webpack_require__(17);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(167);
var ViewportMetrics = __webpack_require__(460);

var getEventModifierState = __webpack_require__(304);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(53);
var DOMNamespaces = __webpack_require__(306);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(307);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var EventPluginRegistry = __webpack_require__(299);
var ReactEventEmitterMixin = __webpack_require__(926);
var ViewportMetrics = __webpack_require__(460);

var getVendorPrefixedEventName = __webpack_require__(927);
var isEventSupported = __webpack_require__(303);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(127);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(84);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(503);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(127);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(129);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(1057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(1059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(1061);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(172);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(1063);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(333);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(510);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = {"apiURL":"https://dev.api.veloe.com.br","apiURLVeloe":"https://dev.api.veloe.com.br","apiAuthorization":"Basic Q3VzdG9tZXJDbGllbnQ6ZW9CWDYxaWc4Z0plTnVaRHpH","apiAuthorizationC6":"Basic UGFyY2Vpcm8tYzY6MlkhZlRlY0pOWmdScEJmbjJaa1pSJCZmeWp0NCFU","publicSite":"http://dev.fastalelo.com","brasPagURL":"https://transactionsandbox.pagador.com.br/post/api/public/v1","pfURL":"http://minha-veloe-pf-dev.s3-website-us-east-1.amazonaws.com","buildNumber":"1687543219522","authScope":"Customer.Info"}

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visit = visit;
exports.visitInParallel = visitInParallel;
exports.visitWithTypeInfo = visitWithTypeInfo;
exports.getVisitFn = getVisitFn;
exports.BREAK = exports.QueryDocumentKeys = void 0;

var _inspect = _interopRequireDefault(__webpack_require__(533));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
exports.QueryDocumentKeys = QueryDocumentKeys;
var BREAK = {};
/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

exports.BREAK = BREAK;

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          var _arr = Object.keys(node);

          for (var _i = 0; _i < _arr.length; _i++) {
            var k = _arr[_i];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error('Invalid AST Node: ' + (0, _inspect.default)(node));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : visitorKeys[node.kind] || [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}

function isNode(maybeNode) {
  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */


function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */


function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter: function enter(node) {
      typeInfo.enter(node);
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      false);

      if (fn) {
        var result = fn.apply(visitor, arguments);

        if (result !== undefined) {
          typeInfo.leave(node);

          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }

        return result;
      }
    },
    leave: function leave(node) {
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      true);
      var result;

      if (fn) {
        result = fn.apply(visitor, arguments);
      }

      typeInfo.leave(node);
      return result;
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */


function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

/***/ }),
/* 223 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(352),
    getRawTag = __webpack_require__(1257),
    objectToString = __webpack_require__(1258);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(549);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 226 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(353);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(551);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1283);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var SHOW_MODAL=exports.SHOW_MODAL='SHOW_MODAL';var HIDE_MODAL=exports.HIDE_MODAL='HIDE_MODAL';var FETCH_STATEMENTS=exports.FETCH_STATEMENTS='FETCH_STATEMENTS';var FETCH_MORE_STATEMENTS=exports.FETCH_MORE_STATEMENTS='FETCH_MORE_STATEMENTS';var SAVING_FORM=exports.SAVING_FORM='SAVING_FORM';

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1506);
var global = __webpack_require__(87);
var hide = __webpack_require__(109);
var Iterators = __webpack_require__(153);
var TO_STRING_TAG = __webpack_require__(58)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(110);
var dPs = __webpack_require__(1509);
var enumBugKeys = __webpack_require__(373);
var IE_PROTO = __webpack_require__(371)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(572)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1512).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(370);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(75).f;
var has = __webpack_require__(133);
var TAG = __webpack_require__(58)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1519), __esModule: true };

/***/ }),
/* 238 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var breakpoints = [40, 52, 64];

var space = [0, 8, 16, 32, 64];

var fontSizes = [12, 14, 16, 20, 24, 32, 48, 64, 72];

module.exports = {
  breakpoints: breakpoints,
  space: space,
  fontSizes: fontSizes
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/avatar-1.05dd2498.png";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/avatar-2.303222e7.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/avatar-3.9842db4c.png";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/avatar-4.72f6e795.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/avatar-5.e6bc68ab.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/avatar-6.8fabbe5e.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/avatar-7.3befef8d.png";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/avatar-8.e581598b.png";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reactRedux=__webpack_require__(7);var _Submenu=__webpack_require__(1662);var _Submenu2=_interopRequireDefault(_Submenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var mapStateToProps=function mapStateToProps(_ref){var router=_ref.router;return{router:router};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(_Submenu2.default);module.exports=exports['default'];

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/FooterSmall/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _FooterNavigationLarge=__webpack_require__(1664);var _FooterNavigationLarge2=_interopRequireDefault(_FooterNavigationLarge);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _styles=__webpack_require__(592);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Footer=function Footer(){return _react2.default.createElement(_styles.FooterContainer,{id:'footer',__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:10}},_react2.default.createElement(_FooterNavigationLarge2.default,{__source:{fileName:_jsxFileName,lineNumber:11}}),_react2.default.createElement(_styles.CardsContainer,{__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_styles.NavigationText,{marginOnSmall:true,__source:{fileName:_jsxFileName,lineNumber:13}},'\xA9 Veloe 2018 todos direitos reservados'))));};exports.default=Footer;module.exports=exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/



Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(156);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(298);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactInputAutosize = __webpack_require__(1693);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _classnames = __webpack_require__(251);

var _classnames2 = _interopRequireDefault(_classnames);

var _utilsDefaultArrowRenderer = __webpack_require__(1694);

var _utilsDefaultArrowRenderer2 = _interopRequireDefault(_utilsDefaultArrowRenderer);

var _utilsDefaultFilterOptions = __webpack_require__(596);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(598);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var _utilsDefaultClearRenderer = __webpack_require__(1695);

var _utilsDefaultClearRenderer2 = _interopRequireDefault(_utilsDefaultClearRenderer);

var _Async = __webpack_require__(1696);

var _Async2 = _interopRequireDefault(_Async);

var _AsyncCreatable = __webpack_require__(1697);

var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);

var _Creatable = __webpack_require__(1698);

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Option = __webpack_require__(1699);

var _Option2 = _interopRequireDefault(_Option);

var _Value = __webpack_require__(1700);

var _Value2 = _interopRequireDefault(_Value);

function stringifyValue(value) {
	var valueType = typeof value;
	if (valueType === 'string') {
		return value;
	} else if (valueType === 'object') {
		return JSON.stringify(value);
	} else if (valueType === 'number' || valueType === 'boolean') {
		return String(value);
	} else {
		return '';
	}
}

var stringOrNode = _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].node]);

var instanceId = 1;

var Select = (0, _createReactClass2['default'])({

	displayName: 'Select',

	propTypes: {
		addLabelText: _propTypes2['default'].string, // placeholder displayed when you want to add a label on a multi-value input
		'aria-describedby': _propTypes2['default'].string, // HTML ID(s) of element(s) that should be used to describe this input (for assistive tech)
		'aria-label': _propTypes2['default'].string, // Aria label (for assistive tech)
		'aria-labelledby': _propTypes2['default'].string, // HTML ID of an element that should be used as the label (for assistive tech)
		arrowRenderer: _propTypes2['default'].func, // Create drop-down caret element
		autoBlur: _propTypes2['default'].bool, // automatically blur the component when an option is selected
		autofocus: _propTypes2['default'].bool, // autofocus the component on mount
		autosize: _propTypes2['default'].bool, // whether to enable autosizing or not
		backspaceRemoves: _propTypes2['default'].bool, // whether backspace removes an item if there is no text input
		backspaceToRemoveMessage: _propTypes2['default'].string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
		className: _propTypes2['default'].string, // className for the outer element
		clearAllText: stringOrNode, // title for the "clear" control when multi: true
		clearRenderer: _propTypes2['default'].func, // create clearable x element
		clearValueText: stringOrNode, // title for the "clear" control
		clearable: _propTypes2['default'].bool, // should it be possible to reset value
		deleteRemoves: _propTypes2['default'].bool, // whether backspace removes an item if there is no text input
		delimiter: _propTypes2['default'].string, // delimiter to use to join multiple values for the hidden field value
		disabled: _propTypes2['default'].bool, // whether the Select is disabled or not
		escapeClearsValue: _propTypes2['default'].bool, // whether escape clears the value when the menu is closed
		filterOption: _propTypes2['default'].func, // method to filter a single option (option, filterString)
		filterOptions: _propTypes2['default'].any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
		ignoreAccents: _propTypes2['default'].bool, // whether to strip diacritics when filtering
		ignoreCase: _propTypes2['default'].bool, // whether to perform case-insensitive filtering
		inputProps: _propTypes2['default'].object, // custom attributes for the Input
		inputRenderer: _propTypes2['default'].func, // returns a custom input component
		instanceId: _propTypes2['default'].string, // set the components instanceId
		isLoading: _propTypes2['default'].bool, // whether the Select is loading externally or not (such as options being loaded)
		joinValues: _propTypes2['default'].bool, // joins multiple values into a single form field with the delimiter (legacy mode)
		labelKey: _propTypes2['default'].string, // path of the label value in option objects
		matchPos: _propTypes2['default'].string, // (any|start) match the start or entire string when filtering
		matchProp: _propTypes2['default'].string, // (any|label|value) which option property to filter on
		menuBuffer: _propTypes2['default'].number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
		menuContainerStyle: _propTypes2['default'].object, // optional style to apply to the menu container
		menuRenderer: _propTypes2['default'].func, // renders a custom menu with options
		menuStyle: _propTypes2['default'].object, // optional style to apply to the menu
		multi: _propTypes2['default'].bool, // multi-value input
		name: _propTypes2['default'].string, // generates a hidden <input /> tag with this field name for html forms
		noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
		onBlur: _propTypes2['default'].func, // onBlur handler: function (event) {}
		onBlurResetsInput: _propTypes2['default'].bool, // whether input is cleared on blur
		onChange: _propTypes2['default'].func, // onChange handler: function (newValue) {}
		onClose: _propTypes2['default'].func, // fires when the menu is closed
		onCloseResetsInput: _propTypes2['default'].bool, // whether input is cleared when menu is closed through the arrow
		onFocus: _propTypes2['default'].func, // onFocus handler: function (event) {}
		onInputChange: _propTypes2['default'].func, // onInputChange handler: function (inputValue) {}
		onInputKeyDown: _propTypes2['default'].func, // input keyDown handler: function (event) {}
		onMenuScrollToBottom: _propTypes2['default'].func, // fires when the menu is scrolled to the bottom; can be used to paginate options
		onOpen: _propTypes2['default'].func, // fires when the menu is opened
		onValueClick: _propTypes2['default'].func, // onClick handler for value labels: function (value, event) {}
		openAfterFocus: _propTypes2['default'].bool, // boolean to enable opening dropdown when focused
		openOnFocus: _propTypes2['default'].bool, // always open options menu on focus
		optionClassName: _propTypes2['default'].string, // additional class(es) to apply to the <Option /> elements
		optionComponent: _propTypes2['default'].func, // option component to render in dropdown
		optionRenderer: _propTypes2['default'].func, // optionRenderer: function (option) {}
		options: _propTypes2['default'].array, // array of options
		pageSize: _propTypes2['default'].number, // number of entries to page when using page up/down keys
		placeholder: stringOrNode, // field placeholder, displayed when there's no value
		required: _propTypes2['default'].bool, // applies HTML5 required attribute when needed
		resetValue: _propTypes2['default'].any, // value to use when you clear the control
		scrollMenuIntoView: _propTypes2['default'].bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
		searchable: _propTypes2['default'].bool, // whether to enable searching feature or not
		simpleValue: _propTypes2['default'].bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
		style: _propTypes2['default'].object, // optional style to apply to the control
		tabIndex: _propTypes2['default'].string, // optional tab index of the control
		tabSelectsValue: _propTypes2['default'].bool, // whether to treat tabbing out while focused to be value selection
		value: _propTypes2['default'].any, // initial field value
		valueComponent: _propTypes2['default'].func, // value component to render
		valueKey: _propTypes2['default'].string, // path of the label value in option objects
		valueRenderer: _propTypes2['default'].func, // valueRenderer: function (option) {}
		wrapperStyle: _propTypes2['default'].object },

	// optional style to apply to the component wrapper
	statics: { Async: _Async2['default'], AsyncCreatable: _AsyncCreatable2['default'], Creatable: _Creatable2['default'] },

	getDefaultProps: function getDefaultProps() {
		return {
			addLabelText: 'Add "{label}"?',
			arrowRenderer: _utilsDefaultArrowRenderer2['default'],
			autosize: true,
			backspaceRemoves: true,
			backspaceToRemoveMessage: 'Press backspace to remove {label}',
			clearable: true,
			clearAllText: 'Clear all',
			clearRenderer: _utilsDefaultClearRenderer2['default'],
			clearValueText: 'Clear value',
			deleteRemoves: true,
			delimiter: ',',
			disabled: false,
			escapeClearsValue: true,
			filterOptions: _utilsDefaultFilterOptions2['default'],
			ignoreAccents: true,
			ignoreCase: true,
			inputProps: {},
			isLoading: false,
			joinValues: false,
			labelKey: 'label',
			matchPos: 'any',
			matchProp: 'any',
			menuBuffer: 0,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			multi: false,
			noResultsText: 'No results found',
			onBlurResetsInput: true,
			onCloseResetsInput: true,
			optionComponent: _Option2['default'],
			pageSize: 5,
			placeholder: 'Select...',
			required: false,
			scrollMenuIntoView: true,
			searchable: true,
			simpleValue: false,
			tabSelectsValue: true,
			valueComponent: _Value2['default'],
			valueKey: 'value'
		};
	},

	getInitialState: function getInitialState() {
		return {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
	},

	componentWillMount: function componentWillMount() {
		this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
		var valueArray = this.getValueArray(this.props.value);

		if (this.props.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], this.props.multi)
			});
		}
	},

	componentDidMount: function componentDidMount() {
		if (this.props.autofocus) {
			this.focus();
		}
	},

	componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
		var valueArray = this.getValueArray(nextProps.value, nextProps);

		if (nextProps.required) {
			this.setState({
				required: this.handleRequired(valueArray[0], nextProps.multi)
			});
		}
	},

	componentWillUpdate: function componentWillUpdate(nextProps, nextState) {
		if (nextState.isOpen !== this.state.isOpen) {
			this.toggleTouchOutsideEvent(nextState.isOpen);
			var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
			handler && handler();
		}
	},

	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		// focus to the selected option
		if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
			var focusedOptionNode = _reactDom2['default'].findDOMNode(this.focused);
			var menuNode = _reactDom2['default'].findDOMNode(this.menu);
			menuNode.scrollTop = focusedOptionNode.offsetTop;
			this.hasScrolledToOption = true;
		} else if (!this.state.isOpen) {
			this.hasScrolledToOption = false;
		}

		if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
			this._scrollToFocusedOptionOnUpdate = false;
			var focusedDOM = _reactDom2['default'].findDOMNode(this.focused);
			var menuDOM = _reactDom2['default'].findDOMNode(this.menu);
			var focusedRect = focusedDOM.getBoundingClientRect();
			var menuRect = menuDOM.getBoundingClientRect();
			if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
				menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
			}
		}
		if (this.props.scrollMenuIntoView && this.menuContainer) {
			var menuContainerRect = this.menuContainer.getBoundingClientRect();
			if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
				window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
			}
		}
		if (prevProps.disabled !== this.props.disabled) {
			this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
			this.closeMenu();
		}
	},

	componentWillUnmount: function componentWillUnmount() {
		if (!document.removeEventListener && document.detachEvent) {
			document.detachEvent('ontouchstart', this.handleTouchOutside);
		} else {
			document.removeEventListener('touchstart', this.handleTouchOutside);
		}
	},

	toggleTouchOutsideEvent: function toggleTouchOutsideEvent(enabled) {
		if (enabled) {
			if (!document.addEventListener && document.attachEvent) {
				document.attachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.addEventListener('touchstart', this.handleTouchOutside);
			}
		} else {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		}
	},

	handleTouchOutside: function handleTouchOutside(event) {
		// handle touch outside on ios to dismiss menu
		if (this.wrapper && !this.wrapper.contains(event.target)) {
			this.closeMenu();
		}
	},

	focus: function focus() {
		if (!this.input) return;
		this.input.focus();
	},

	blurInput: function blurInput() {
		if (!this.input) return;
		this.input.blur();
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.handleMouseDown(event);
	},

	handleTouchEndClearValue: function handleTouchEndClearValue(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Clear the value
		this.clearValue(event);
	},

	handleMouseDown: function handleMouseDown(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}

		if (event.target.tagName === 'INPUT') {
			return;
		}

		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();

		// for the non-searchable select, toggle the menu
		if (!this.props.searchable) {
			this.focus();
			return this.setState({
				isOpen: !this.state.isOpen
			});
		}

		if (this.state.isFocused) {
			// On iOS, we can get into a state where we think the input is focused but it isn't really,
			// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
			// Call focus() again here to be safe.
			this.focus();

			var input = this.input;
			if (typeof input.getInput === 'function') {
				// Get the actual DOM input if the ref is an <AutosizeInput /> component
				input = input.getInput();
			}

			// clears the value so that the cursor will be at the end of input when the component re-renders
			input.value = '';

			// if the input is focused, ensure the menu is open
			this.setState({
				isOpen: true,
				isPseudoFocused: false
			});
		} else {
			// otherwise, focus the input and open the menu
			this._openAfterFocus = true;
			this.focus();
		}
	},

	handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		// If the menu isn't open, let the event bubble to the main handleMouseDown
		if (!this.state.isOpen) {
			return;
		}
		// prevent default event handlers
		event.stopPropagation();
		event.preventDefault();
		// close the menu
		this.closeMenu();
	},

	handleMouseDownOnMenu: function handleMouseDownOnMenu(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, or if the component is disabled, ignore it.
		if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();

		this._openAfterFocus = true;
		this.focus();
	},

	closeMenu: function closeMenu() {
		if (this.props.onCloseResetsInput) {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: ''
			});
		} else {
			this.setState({
				isOpen: false,
				isPseudoFocused: this.state.isFocused && !this.props.multi,
				inputValue: this.state.inputValue
			});
		}
		this.hasScrolledToOption = false;
	},

	handleInputFocus: function handleInputFocus(event) {
		if (this.props.disabled) return;
		var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
		if (this.props.onFocus) {
			this.props.onFocus(event);
		}
		this.setState({
			isFocused: true,
			isOpen: isOpen
		});
		this._openAfterFocus = false;
	},

	handleInputBlur: function handleInputBlur(event) {
		// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
		if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
			this.focus();
			return;
		}

		if (this.props.onBlur) {
			this.props.onBlur(event);
		}
		var onBlurredState = {
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false
		};
		if (this.props.onBlurResetsInput) {
			onBlurredState.inputValue = '';
		}
		this.setState(onBlurredState);
	},

	handleInputChange: function handleInputChange(event) {
		var newInputValue = event.target.value;

		if (this.state.inputValue !== event.target.value && this.props.onInputChange) {
			var nextState = this.props.onInputChange(newInputValue);
			// Note: != used deliberately here to catch undefined and null
			if (nextState != null && typeof nextState !== 'object') {
				newInputValue = '' + nextState;
			}
		}

		this.setState({
			isOpen: true,
			isPseudoFocused: false,
			inputValue: newInputValue
		});
	},

	handleKeyDown: function handleKeyDown(event) {
		if (this.props.disabled) return;

		if (typeof this.props.onInputKeyDown === 'function') {
			this.props.onInputKeyDown(event);
			if (event.defaultPrevented) {
				return;
			}
		}

		switch (event.keyCode) {
			case 8:
				// backspace
				if (!this.state.inputValue && this.props.backspaceRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			case 9:
				// tab
				if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
					return;
				}
				this.selectFocusedOption();
				return;
			case 13:
				// enter
				if (!this.state.isOpen) return;
				event.stopPropagation();
				this.selectFocusedOption();
				break;
			case 27:
				// escape
				if (this.state.isOpen) {
					this.closeMenu();
					event.stopPropagation();
				} else if (this.props.clearable && this.props.escapeClearsValue) {
					this.clearValue(event);
					event.stopPropagation();
				}
				break;
			case 38:
				// up
				this.focusPreviousOption();
				break;
			case 40:
				// down
				this.focusNextOption();
				break;
			case 33:
				// page up
				this.focusPageUpOption();
				break;
			case 34:
				// page down
				this.focusPageDownOption();
				break;
			case 35:
				// end key
				if (event.shiftKey) {
					return;
				}
				this.focusEndOption();
				break;
			case 36:
				// home key
				if (event.shiftKey) {
					return;
				}
				this.focusStartOption();
				break;
			case 46:
				// backspace
				if (!this.state.inputValue && this.props.deleteRemoves) {
					event.preventDefault();
					this.popValue();
				}
				return;
			default:
				return;
		}
		event.preventDefault();
	},

	handleValueClick: function handleValueClick(option, event) {
		if (!this.props.onValueClick) return;
		this.props.onValueClick(option, event);
	},

	handleMenuScroll: function handleMenuScroll(event) {
		if (!this.props.onMenuScrollToBottom) return;
		var target = event.target;

		if (target.scrollHeight > target.offsetHeight && !(target.scrollHeight - target.offsetHeight - target.scrollTop)) {
			this.props.onMenuScrollToBottom();
		}
	},

	handleRequired: function handleRequired(value, multi) {
		if (!value) return true;
		return multi ? value.length === 0 : Object.keys(value).length === 0;
	},

	getOptionLabel: function getOptionLabel(op) {
		return op[this.props.labelKey];
	},

	/**
  * Turns a value into an array from the given options
  * @param	{String|Number|Array}	value		- the value of the select input
  * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
  * @returns	{Array}	the value of the select represented in an array
  */
	getValueArray: function getValueArray(value, nextProps) {
		var _this = this;

		/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
		var props = typeof nextProps === 'object' ? nextProps : this.props;
		if (props.multi) {
			if (typeof value === 'string') value = value.split(props.delimiter);
			if (!Array.isArray(value)) {
				if (value === null || value === undefined) return [];
				value = [value];
			}
			return value.map(function (value) {
				return _this.expandValue(value, props);
			}).filter(function (i) {
				return i;
			});
		}
		var expandedValue = this.expandValue(value, props);
		return expandedValue ? [expandedValue] : [];
	},

	/**
  * Retrieve a value from the given options and valueKey
  * @param	{String|Number|Array}	value	- the selected value(s)
  * @param	{Object}		props	- the Select component's props (or nextProps)
  */
	expandValue: function expandValue(value, props) {
		var valueType = typeof value;
		if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
		var options = props.options;
		var valueKey = props.valueKey;

		if (!options) return;
		for (var i = 0; i < options.length; i++) {
			if (options[i][valueKey] === value) return options[i];
		}
	},

	setValue: function setValue(value) {
		var _this2 = this;

		if (this.props.autoBlur) {
			this.blurInput();
		}
		if (!this.props.onChange) return;
		if (this.props.required) {
			var required = this.handleRequired(value, this.props.multi);
			this.setState({ required: required });
		}
		if (this.props.simpleValue && value) {
			value = this.props.multi ? value.map(function (i) {
				return i[_this2.props.valueKey];
			}).join(this.props.delimiter) : value[this.props.valueKey];
		}
		this.props.onChange(value);
	},

	selectValue: function selectValue(value) {
		var _this3 = this;

		//NOTE: update value in the callback to make sure the input value is empty so that there are no styling issues (Chrome had issue otherwise)
		this.hasScrolledToOption = false;
		if (this.props.multi) {
			this.setState({
				inputValue: '',
				focusedIndex: null
			}, function () {
				_this3.addValue(value);
			});
		} else {
			this.setState({
				isOpen: false,
				inputValue: '',
				isPseudoFocused: this.state.isFocused
			}, function () {
				_this3.setValue(value);
			});
		}
	},

	addValue: function addValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		var visibleOptions = this._visibleOptions.filter(function (val) {
			return !val.disabled;
		});
		var lastValueIndex = visibleOptions.indexOf(value);
		this.setValue(valueArray.concat(value));
		if (visibleOptions.length - 1 === lastValueIndex) {
			// the last option was selected; focus the second-last one
			this.focusOption(visibleOptions[lastValueIndex - 1]);
		} else if (visibleOptions.length > lastValueIndex) {
			// focus the option below the selected one
			this.focusOption(visibleOptions[lastValueIndex + 1]);
		}
	},

	popValue: function popValue() {
		var valueArray = this.getValueArray(this.props.value);
		if (!valueArray.length) return;
		if (valueArray[valueArray.length - 1].clearableValue === false) return;
		this.setValue(valueArray.slice(0, valueArray.length - 1));
	},

	removeValue: function removeValue(value) {
		var valueArray = this.getValueArray(this.props.value);
		this.setValue(valueArray.filter(function (i) {
			return i !== value;
		}));
		this.focus();
	},

	clearValue: function clearValue(event) {
		// if the event was triggered by a mousedown and not the primary
		// button, ignore it.
		if (event && event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		event.stopPropagation();
		event.preventDefault();
		this.setValue(this.getResetValue());
		this.setState({
			isOpen: false,
			inputValue: ''
		}, this.focus);
	},

	getResetValue: function getResetValue() {
		if (this.props.resetValue !== undefined) {
			return this.props.resetValue;
		} else if (this.props.multi) {
			return [];
		} else {
			return null;
		}
	},

	focusOption: function focusOption(option) {
		this.setState({
			focusedOption: option
		});
	},

	focusNextOption: function focusNextOption() {
		this.focusAdjacentOption('next');
	},

	focusPreviousOption: function focusPreviousOption() {
		this.focusAdjacentOption('previous');
	},

	focusPageUpOption: function focusPageUpOption() {
		this.focusAdjacentOption('page_up');
	},

	focusPageDownOption: function focusPageDownOption() {
		this.focusAdjacentOption('page_down');
	},

	focusStartOption: function focusStartOption() {
		this.focusAdjacentOption('start');
	},

	focusEndOption: function focusEndOption() {
		this.focusAdjacentOption('end');
	},

	focusAdjacentOption: function focusAdjacentOption(dir) {
		var options = this._visibleOptions.map(function (option, index) {
			return { option: option, index: index };
		}).filter(function (option) {
			return !option.option.disabled;
		});
		this._scrollToFocusedOptionOnUpdate = true;
		if (!this.state.isOpen) {
			this.setState({
				isOpen: true,
				inputValue: '',
				focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
			});
			return;
		}
		if (!options.length) return;
		var focusedIndex = -1;
		for (var i = 0; i < options.length; i++) {
			if (this._focusedOption === options[i].option) {
				focusedIndex = i;
				break;
			}
		}
		if (dir === 'next' && focusedIndex !== -1) {
			focusedIndex = (focusedIndex + 1) % options.length;
		} else if (dir === 'previous') {
			if (focusedIndex > 0) {
				focusedIndex = focusedIndex - 1;
			} else {
				focusedIndex = options.length - 1;
			}
		} else if (dir === 'start') {
			focusedIndex = 0;
		} else if (dir === 'end') {
			focusedIndex = options.length - 1;
		} else if (dir === 'page_up') {
			var potentialIndex = focusedIndex - this.props.pageSize;
			if (potentialIndex < 0) {
				focusedIndex = 0;
			} else {
				focusedIndex = potentialIndex;
			}
		} else if (dir === 'page_down') {
			var potentialIndex = focusedIndex + this.props.pageSize;
			if (potentialIndex > options.length - 1) {
				focusedIndex = options.length - 1;
			} else {
				focusedIndex = potentialIndex;
			}
		}

		if (focusedIndex === -1) {
			focusedIndex = 0;
		}

		this.setState({
			focusedIndex: options[focusedIndex].index,
			focusedOption: options[focusedIndex].option
		});
	},

	getFocusedOption: function getFocusedOption() {
		return this._focusedOption;
	},

	getInputValue: function getInputValue() {
		return this.state.inputValue;
	},

	selectFocusedOption: function selectFocusedOption() {
		if (this._focusedOption) {
			return this.selectValue(this._focusedOption);
		}
	},

	renderLoading: function renderLoading() {
		if (!this.props.isLoading) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
			_react2['default'].createElement('span', { className: 'Select-loading' })
		);
	},

	renderValue: function renderValue(valueArray, isOpen) {
		var _this4 = this;

		var renderLabel = this.props.valueRenderer || this.getOptionLabel;
		var ValueComponent = this.props.valueComponent;
		if (!valueArray.length) {
			return !this.state.inputValue ? _react2['default'].createElement(
				'div',
				{ className: 'Select-placeholder' },
				this.props.placeholder
			) : null;
		}
		var onClick = this.props.onValueClick ? this.handleValueClick : null;
		if (this.props.multi) {
			return valueArray.map(function (value, i) {
				return _react2['default'].createElement(
					ValueComponent,
					{
						id: _this4._instancePrefix + '-value-' + i,
						instancePrefix: _this4._instancePrefix,
						disabled: _this4.props.disabled || value.clearableValue === false,
						key: 'value-' + i + '-' + value[_this4.props.valueKey],
						onClick: onClick,
						onRemove: _this4.removeValue,
						value: value
					},
					renderLabel(value, i),
					_react2['default'].createElement(
						'span',
						{ className: 'Select-aria-only' },
						' '
					)
				);
			});
		} else if (!this.state.inputValue) {
			if (isOpen) onClick = null;
			return _react2['default'].createElement(
				ValueComponent,
				{
					id: this._instancePrefix + '-value-item',
					disabled: this.props.disabled,
					instancePrefix: this._instancePrefix,
					onClick: onClick,
					value: valueArray[0]
				},
				renderLabel(valueArray[0])
			);
		}
	},

	renderInput: function renderInput(valueArray, focusedOptionIndex) {
		var _classNames,
		    _this5 = this;

		var className = (0, _classnames2['default'])('Select-input', this.props.inputProps.className);
		var isOpen = !!this.state.isOpen;

		var ariaOwns = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

		// TODO: Check how this project includes Object.assign()
		var inputProps = _extends({}, this.props.inputProps, {
			role: 'combobox',
			'aria-expanded': '' + isOpen,
			'aria-owns': ariaOwns,
			'aria-haspopup': '' + isOpen,
			'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
			'aria-describedby': this.props['aria-describedby'],
			'aria-labelledby': this.props['aria-labelledby'],
			'aria-label': this.props['aria-label'],
			className: className,
			tabIndex: this.props.tabIndex,
			onBlur: this.handleInputBlur,
			onChange: this.handleInputChange,
			onFocus: this.handleInputFocus,
			ref: function ref(_ref) {
				return _this5.input = _ref;
			},
			required: this.state.required,
			value: this.state.inputValue
		});

		if (this.props.inputRenderer) {
			return this.props.inputRenderer(inputProps);
		}

		if (this.props.disabled || !this.props.searchable) {
			var _props$inputProps = this.props.inputProps;
			var inputClassName = _props$inputProps.inputClassName;

			var divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);

			var _ariaOwns = (0, _classnames2['default'])(_defineProperty({}, this._instancePrefix + '-list', isOpen));

			return _react2['default'].createElement('div', _extends({}, divProps, {
				role: 'combobox',
				'aria-expanded': isOpen,
				'aria-owns': _ariaOwns,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				className: className,
				tabIndex: this.props.tabIndex || 0,
				onBlur: this.handleInputBlur,
				onFocus: this.handleInputFocus,
				ref: function (ref) {
					return _this5.input = ref;
				},
				'aria-readonly': '' + !!this.props.disabled,
				style: { border: 0, width: 1, display: 'inline-block' } }));
		}

		if (this.props.autosize) {
			return _react2['default'].createElement(_reactInputAutosize2['default'], _extends({}, inputProps, { minWidth: '5' }));
		}
		return _react2['default'].createElement(
			'div',
			{ className: className },
			_react2['default'].createElement('input', inputProps)
		);
	},

	renderClear: function renderClear() {

		if (!this.props.clearable || this.props.value === undefined || this.props.value === null || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
		var clear = this.props.clearRenderer();

		return _react2['default'].createElement(
			'span',
			{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
				onMouseDown: this.clearValue,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEndClearValue
			},
			clear
		);
	},

	renderArrow: function renderArrow() {
		var onMouseDown = this.handleMouseDownOnArrow;
		var isOpen = this.state.isOpen;
		var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

		return _react2['default'].createElement(
			'span',
			{
				className: 'Select-arrow-zone',
				onMouseDown: onMouseDown
			},
			arrow
		);
	},

	filterOptions: function filterOptions(excludeOptions) {
		var filterValue = this.state.inputValue;
		var options = this.props.options || [];
		if (this.props.filterOptions) {
			// Maintain backwards compatibility with boolean attribute
			var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _utilsDefaultFilterOptions2['default'];

			return filterOptions(options, filterValue, excludeOptions, {
				filterOption: this.props.filterOption,
				ignoreAccents: this.props.ignoreAccents,
				ignoreCase: this.props.ignoreCase,
				labelKey: this.props.labelKey,
				matchPos: this.props.matchPos,
				matchProp: this.props.matchProp,
				valueKey: this.props.valueKey
			});
		} else {
			return options;
		}
	},

	onOptionRef: function onOptionRef(ref, isFocused) {
		if (isFocused) {
			this.focused = ref;
		}
	},

	renderMenu: function renderMenu(options, valueArray, focusedOption) {
		if (options && options.length) {
			return this.props.menuRenderer({
				focusedOption: focusedOption,
				focusOption: this.focusOption,
				instancePrefix: this._instancePrefix,
				labelKey: this.props.labelKey,
				onFocus: this.focusOption,
				onSelect: this.selectValue,
				optionClassName: this.props.optionClassName,
				optionComponent: this.props.optionComponent,
				optionRenderer: this.props.optionRenderer || this.getOptionLabel,
				options: options,
				selectValue: this.selectValue,
				valueArray: valueArray,
				valueKey: this.props.valueKey,
				onOptionRef: this.onOptionRef
			});
		} else if (this.props.noResultsText) {
			return _react2['default'].createElement(
				'div',
				{ className: 'Select-noresults' },
				this.props.noResultsText
			);
		} else {
			return null;
		}
	},

	renderHiddenField: function renderHiddenField(valueArray) {
		var _this6 = this;

		if (!this.props.name) return;
		if (this.props.joinValues) {
			var value = valueArray.map(function (i) {
				return stringifyValue(i[_this6.props.valueKey]);
			}).join(this.props.delimiter);
			return _react2['default'].createElement('input', {
				type: 'hidden',
				ref: function (ref) {
					return _this6.value = ref;
				},
				name: this.props.name,
				value: value,
				disabled: this.props.disabled });
		}
		return valueArray.map(function (item, index) {
			return _react2['default'].createElement('input', { key: 'hidden.' + index,
				type: 'hidden',
				ref: 'value' + index,
				name: _this6.props.name,
				value: stringifyValue(item[_this6.props.valueKey]),
				disabled: _this6.props.disabled });
		});
	},

	getFocusableOptionIndex: function getFocusableOptionIndex(selectedOption) {
		var options = this._visibleOptions;
		if (!options.length) return null;

		var valueKey = this.props.valueKey;
		var focusedOption = this.state.focusedOption || selectedOption;
		if (focusedOption && !focusedOption.disabled) {
			var focusedOptionIndex = -1;
			options.some(function (option, index) {
				var isOptionEqual = option[valueKey] === focusedOption[valueKey];
				if (isOptionEqual) {
					focusedOptionIndex = index;
				}
				return isOptionEqual;
			});
			if (focusedOptionIndex !== -1) {
				return focusedOptionIndex;
			}
		}

		for (var i = 0; i < options.length; i++) {
			if (!options[i].disabled) return i;
		}
		return null;
	},

	renderOuter: function renderOuter(options, valueArray, focusedOption) {
		var _this7 = this;

		var menu = this.renderMenu(options, valueArray, focusedOption);
		if (!menu) {
			return null;
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this7.menuContainer = ref;
				}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this7.menu = ref;
					}, role: 'listbox', className: 'Select-menu', id: this._instancePrefix + '-list',
					style: this.props.menuStyle,
					onScroll: this.handleMenuScroll,
					onMouseDown: this.handleMouseDownOnMenu },
				menu
			)
		);
	},

	render: function render() {
		var _this8 = this;

		var valueArray = this.getValueArray(this.props.value);
		var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
		var isOpen = this.state.isOpen;
		if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
		var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

		var focusedOption = null;
		if (focusedOptionIndex !== null) {
			focusedOption = this._focusedOption = options[focusedOptionIndex];
		} else {
			focusedOption = this._focusedOption = null;
		}
		var className = (0, _classnames2['default'])('Select', this.props.className, {
			'Select--multi': this.props.multi,
			'Select--single': !this.props.multi,
			'is-clearable': this.props.clearable,
			'is-disabled': this.props.disabled,
			'is-focused': this.state.isFocused,
			'is-loading': this.props.isLoading,
			'is-open': isOpen,
			'is-pseudo-focused': this.state.isPseudoFocused,
			'is-searchable': this.props.searchable,
			'has-value': valueArray.length
		});

		var removeMessage = null;
		if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
			removeMessage = _react2['default'].createElement(
				'span',
				{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
				this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
			);
		}

		return _react2['default'].createElement(
			'div',
			{ ref: function (ref) {
					return _this8.wrapper = ref;
				},
				className: className,
				style: this.props.wrapperStyle },
			this.renderHiddenField(valueArray),
			_react2['default'].createElement(
				'div',
				{ ref: function (ref) {
						return _this8.control = ref;
					},
					className: 'Select-control',
					style: this.props.style,
					onKeyDown: this.handleKeyDown,
					onMouseDown: this.handleMouseDown,
					onTouchEnd: this.handleTouchEnd,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove
				},
				_react2['default'].createElement(
					'span',
					{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
					this.renderValue(valueArray, isOpen),
					this.renderInput(valueArray, focusedOptionIndex)
				),
				removeMessage,
				this.renderLoading(),
				this.renderClear(),
				this.renderArrow()
			),
			isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
		);
	}

});

exports['default'] = Select;
module.exports = exports['default'];

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var errorMessage=exports.errorMessage={required:'Campo obrigatório.',cpfFormat:'Tem algo errado com o formato desse número. Tente de novo.',emailFormat:'Esse e-mail não está no formato certo. Tente de novo.',emailDifferent:'Para alterar o email você precisa confirmar o novo email.',different:'Parece que você ainda não decorou seu email. Tente novamente.'};

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/DotButton/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _styles=__webpack_require__(1826);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DotButtonComponent=function DotButtonComponent(_ref){var _ref$onClick=_ref.onClick,onClick=_ref$onClick===undefined?function(){}:_ref$onClick,_ref$color=_ref.color,color=_ref$color===undefined?'':_ref$color,_ref$removeCursor=_ref.removeCursor,removeCursor=_ref$removeCursor===undefined?false:_ref$removeCursor;return _react2.default.createElement(_styles.DotButton,{onClick:onClick,removeCursor:removeCursor,__source:{fileName:_jsxFileName,lineNumber:6}},_react2.default.createElement(_styles.DotIcon,{color:color,__source:{fileName:_jsxFileName,lineNumber:7}},'\xA0'));};DotButtonComponent.propTypes={onClick:_propTypes.func,removeCursor:_propTypes.bool,color:_propTypes.string};exports.default=DotButtonComponent;module.exports=exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/recarga.055d62cf.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/PlanResume/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _aleloLogic=__webpack_require__(12);var _gridStyled=__webpack_require__(8);var _Icon=__webpack_require__(31);var _styles=__webpack_require__(1867);var _data=__webpack_require__(1868);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var planTypes={pos:'pós',pre:'pré'};var PlanResume=function PlanResume(_ref){var accountPlans=_ref.accountPlans,showSummary=_ref.showSummary,plandata=_ref.plandata,qtdTag=_ref.qtdTag;var plans=accountPlans.plans,activePlanId=accountPlans.activePlanId;if(!activePlanId||plans.length<=0){return null;}var currentPlan=plans.find(function(plan){return String(plan.id)===String(activePlanId);})||{plan:{}};var planColors=currentPlan.plan&&_aleloLogic.utils.planColor(currentPlan.plan.type,currentPlan.plan.category)||{plan:{}};var vehiclesQtd=qtdTag;var active=currentPlan.active;return _react2.default.createElement(_styles.Aside,{color:planColors.normal,__source:{fileName:_jsxFileName,lineNumber:63}},_react2.default.createElement(_styles.PlansContainer,{__source:{fileName:_jsxFileName,lineNumber:64}},_react2.default.createElement(_styles.TitlePlan,{__source:{fileName:_jsxFileName,lineNumber:65}},_react2.default.createElement(_styles.Title,{id:'lblPlanTypes',__source:{fileName:_jsxFileName,lineNumber:66}},currentPlan.plan.category),_react2.default.createElement(_styles.PlanType,{__source:{fileName:_jsxFileName,lineNumber:67}},planTypes[currentPlan.plan.type])),_react2.default.createElement(_styles.State,{__source:{fileName:_jsxFileName,lineNumber:69}},_react2.default.createElement(_styles.PlanState,{__source:{fileName:_jsxFileName,lineNumber:70}},active),showSummary&&currentPlan.accessionDate&&_react2.default.createElement(_styles.WrapperAccession,{bonification:plandata.bonificationEndDate,__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement(_styles.Accession,{__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:75}},_data.accessionDate),_react2.default.createElement(_styles.Date,{__source:{fileName:_jsxFileName,lineNumber:76}},_aleloLogic.utils.ISODateFormat(currentPlan.accessionDate))),plandata.bonificationEndDate&&_react2.default.createElement(_styles.Accession,{__source:{fileName:_jsxFileName,lineNumber:79}},_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:80}},_data.bonificationEndDate,' ',plandata.bonificationType==='VL'?'R$ ':'',plandata.bonificationType==='VL'?_aleloLogic.utils.currencyParser(plandata.bonificationVaue):plandata.bonificationVaue,plandata.bonificationType==='PC'?'%':''),_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:87}},_data.bonificationValid,' ',_react2.default.createElement(_styles.Date,{__source:{fileName:_jsxFileName,lineNumber:88}},plandata.bonificationEndDate)))))),_react2.default.createElement(_styles.VehiclesContainer,{color:planColors.darken,__source:{fileName:_jsxFileName,lineNumber:96}},_react2.default.createElement(_styles.FinancialInfo,{__source:{fileName:_jsxFileName,lineNumber:97}},currentPlan.plan.type==='pos'&&currentPlan.limit&&showSummary&&_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:101}},_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:102}},_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:103}},_data.totalLimit),_react2.default.createElement(_styles.ValueLimited,{__source:{fileName:_jsxFileName,lineNumber:104}},_react2.default.createElement(_styles.Currency,{__source:{fileName:_jsxFileName,lineNumber:105}},_data.currency,' '),_aleloLogic.utils.currencyParser(currentPlan.limit)))),currentPlan.isMonthlyPayment&&showSummary&&plandata&&plandata.monthlyPayment!==undefined&&_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:115}},_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:116}},_data.monthlyPayment),_react2.default.createElement(_styles.MonthlyPayment,{__source:{fileName:_jsxFileName,lineNumber:117}},_react2.default.createElement(_styles.Currency,{__source:{fileName:_jsxFileName,lineNumber:118}},_data.currency,' '),_aleloLogic.utils.currencyParser(plandata.monthlyPayment)))),vehiclesQtd!==undefined&&_react2.default.createElement(_styles.VehicleText,{color:planColors.lighter,__source:{fileName:_jsxFileName,lineNumber:125}},_react2.default.createElement(_styles.VehicleNumber,{__source:{fileName:_jsxFileName,lineNumber:126}},vehiclesQtd<=9?'0'+vehiclesQtd:vehiclesQtd),_react2.default.createElement(_styles.Vehicle,{__source:{fileName:_jsxFileName,lineNumber:127}},vehiclesQtd>1?_data.vehicleLabel.multiple:_data.vehicleLabel.single)),_react2.default.createElement(_styles.VehicleSvg,{color:planColors.lighter,__source:{fileName:_jsxFileName,lineNumber:130}},_react2.default.createElement(_Icon.Icon,{width:'100%',icon:'trama-veloe',svgStyle:'\n                            height: 70px;\n                            margin-top: 15px;\n                        ',__source:{fileName:_jsxFileName,lineNumber:131}}))));};var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{accountPlans:reducer.accountPlans,plandata:reducer.planData};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(PlanResume);module.exports=exports['default'];

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mail-to.f5302853.png";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardResume/Warning/base.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(1922);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var WarningBase=function WarningBase(_ref){var content=_ref.content,image=_ref.image;return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:6}},_react2.default.createElement(_styles.ContainerContent,{__source:{fileName:_jsxFileName,lineNumber:7}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:8}},'Dicas para seguir tranquilo nas pra\xE7as de ped\xE1gio ;)'),_react2.default.createElement(_styles.Body,{__source:{fileName:_jsxFileName,lineNumber:9}},content)),image);};exports.default=WarningBase;module.exports=exports['default'];

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/AddItem/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddItem=function(_Component){_inherits(AddItem,_Component);function AddItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddItem.__proto__||Object.getPrototypeOf(AddItem)).call.apply(_ref,[this].concat(args))),_this),_this.getMore=function(){var _this$props=_this.props,fetchHandler=_this$props.fetchHandler,next=_this$props.next;fetchHandler(next);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddItem,[{key:'render',value:function render(){var _props=this.props,children=_props.children,data=_props.data,next=_props.next,planId=_props.planId,hasNext=_props.hasNext;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.cloneElement(children,{data:data,next:next,planId:planId,loadMoreHandler:this.getMore,hasNext:hasNext}));}}]);return AddItem;}(_react.Component);exports.default=AddItem;module.exports=exports['default'];

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};
//# sourceMappingURL=LocaleUtils.js.map

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var TAB = exports.TAB = 9;
//# sourceMappingURL=keys.js.map

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  months: 'DayPicker-Months',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};
//# sourceMappingURL=classNames.js.map

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;
exports.getDayNodes = getDayNodes;
exports.nodeListToArray = nodeListToArray;
exports.hasOwnProp = hasOwnProp;

var _DateUtils = __webpack_require__(158);

var _LocaleUtils = __webpack_require__(259);

var _classNames = __webpack_require__(261);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, _DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}

function getDayNodes(node, classNames) {
  var outsideClassName = void 0;
  if (classNames === _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
  } else {
    outsideClassName = '' + classNames.outside;
  }
  var dayQuery = classNames.day.replace(/ /g, '.');
  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
  return node.querySelectorAll(selector);
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList, 0);
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
//# sourceMappingURL=Helpers.js.map

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SaveFilterSelection=exports.FilterContainer=exports.SearchContainer=exports.PaginatorContainer=exports.PageList=exports.Page=exports.IdentifierItemContainer=exports.ListItem=exports.InputIdentifier=exports.IdentifierLabel=exports.FilterTypes=exports.InputContainer=exports.Title=exports.Content=exports.Container=exports.SearchInputWrapper=exports.Error=exports.LoadingTable=exports.Loading=exports.SearchInput=exports.CloseIconContainer=exports.SearchIconContainer=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SearchIconContainer=exports.SearchIconContainer=_styledComponents2.default.div.withConfig({displayName:'styles__SearchIconContainer',componentId:'sc-33pwcr-0'})(['position:absolute;left:15px;top:20px;']);var CloseIconContainer=exports.CloseIconContainer=_styledComponents2.default.div.withConfig({displayName:'styles__CloseIconContainer',componentId:'sc-33pwcr-1'})(['position:absolute;right:15px;top:20px;']);var SearchInput=exports.SearchInput=_styledComponents2.default.input.withConfig({displayName:'styles__SearchInput',componentId:'sc-33pwcr-2'})(['border:none;border-bottom:3px solid ',';',';',';background-color:rgba(226,225,235,0.16);padding:',' ',' ',' ',';line-height:',';color:',';',';width:100%;'],_colors.darkSlateBlue,function(_ref){var plateIsValid=_ref.plateIsValid;return plateIsValid&&'border-bottom: 3px solid '+_colors.deliveredGreen;},function(_ref2){var invalidInput=_ref2.invalidInput;return invalidInput&&'border-bottom: 3px solid '+_colors.red;},(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('50px'),(0,_rem2.default)('24px'),_colors.darkSlateBlue,_types.txt16OpenSans);var Loading=exports.Loading=_styledComponents2.default.img.withConfig({displayName:'styles__Loading',componentId:'sc-33pwcr-3'})(['width:',';position:absolute;right:',';top:',';'],(0,_rem2.default)('25px'),(0,_rem2.default)('5px'),(0,_rem2.default)('16px'));var LoadingTable=exports.LoadingTable=_styledComponents2.default.img.withConfig({displayName:'styles__LoadingTable',componentId:'sc-33pwcr-4'})(['width:',';'],(0,_rem2.default)('45px'));var Error=exports.Error=_styledComponents2.default.span.withConfig({displayName:'styles__Error',componentId:'sc-33pwcr-5'})(['color:',';display:inline-block;font-family:OpenSans;font-size:',';letter-spacing:',';'],_colors.red,(0,_rem2.default)('14px'),(0,_rem2.default)('-0.3px'));var SearchInputWrapper=exports.SearchInputWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__SearchInputWrapper',componentId:'sc-33pwcr-6'})(['position:relative;display:flex;flex-direction:column;',';'],function(_ref3){var hide=_ref3.hide;return hide&&'display: none';});var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-33pwcr-7'})(['width:100%;padding:',' 0 ',';background-color:white;display:flex;justify-content:center;'],(0,_rem2.default)('9px'),(0,_rem2.default)('17px'));var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-33pwcr-8'})(['display:flex;justify-content:flex-start;',';flex-direction:column;width:',';'],function(_ref4){var isLoadingPagination=_ref4.isLoadingPagination;return isLoadingPagination&&'align-items: center;';},(0,_rem2.default)('960px'));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-33pwcr-9'})(['letter-spacing:',';color:',';margin-top:',';margin-bottom:',';',';letter-spacing:normal;line-height:1;'],(0,_em2.default)('0.4px'),_colors.darkSlateBlue,(0,_rem2.default)('25px'),(0,_rem2.default)('30px'),_types.title28GalanoBold);var InputContainer=exports.InputContainer=_styledComponents2.default.div.withConfig({displayName:'styles__InputContainer',componentId:'sc-33pwcr-10'})(['display:flex;width:100%;justify-content:space-between;margin-bottom:32px;']);var FilterTypes=exports.FilterTypes=_styledComponents2.default.ul.withConfig({displayName:'styles__FilterTypes',componentId:'sc-33pwcr-11'})(['display:flex;align-items:center;list-style:none;margin:0;height:auto;padding:0;width:100%;overflow:visible;flex-wrap:wrap;justify-content:flex-start;']);var IdentifierLabel=exports.IdentifierLabel=_styledComponents2.default.label.withConfig({displayName:'styles__IdentifierLabel',componentId:'sc-33pwcr-12'})(['position:relative;color:',';',';padding:',' ',';height:100%;width:100%;text-align:center;line-height:20px;display:flex;justify-content:center;align-items:center;',';',';'],_colors.darkSlateBlue,_types.title16Galano,(0,_rem2.default)('10px'),(0,_rem2.default)('15px'),function(_ref5){var isSelected=_ref5.isSelected;return isSelected&&'background: #aeabc4; border-radius: '+(0,_rem2.default)('8px')+';';},function(_ref6){var isSelected=_ref6.isSelected,isBlockedEdit=_ref6.isBlockedEdit;return!isSelected&&isBlockedEdit&&'background: #aeabc4; border-radius: '+(0,_rem2.default)('8px')+'; opacity: 0.4;';});var InputIdentifier=exports.InputIdentifier=_styledComponents2.default.input.attrs({type:'checkbox'}).withConfig({displayName:'styles__InputIdentifier',componentId:'sc-33pwcr-13'})(['opacity:0;display:block;z-index:1;position:absolute;width:100%;height:100%;']);var ListItem=exports.ListItem=_styledComponents2.default.li.withConfig({displayName:'styles__ListItem',componentId:'sc-33pwcr-14'})(['height:',';margin:',' ',';width:',';box-shadow:0px 4px 12px rgba(0,0,0,0.08),0px 0px 1px rgba(0,0,0,0.12);border-radius:',';'],(0,_rem2.default)('56px'),(0,_rem2.default)('10px'),(0,_rem2.default)('10px'),(0,_rem2.default)('140px'),(0,_rem2.default)('8px'));var IdentifierItemContainer=exports.IdentifierItemContainer=_styledComponents2.default.div.withConfig({displayName:'styles__IdentifierItemContainer',componentId:'sc-33pwcr-15'})(['position:relative;height:100%;width:100%;display:flex;']);var Page=exports.Page=_styledComponents2.default.li.withConfig({displayName:'styles__Page',componentId:'sc-33pwcr-16'})(['margin:0 ',';',';color:',';cursor:pointer;&:hover{color:',';}'],(0,_rem2.default)('15px'),_types.title16Galano,function(_ref7){var isCurrentPage=_ref7.isCurrentPage;return isCurrentPage?_colors.darkSlateBlue:_colors.organicSilver;},_colors.darkSlateBlue);var PageList=exports.PageList=_styledComponents2.default.ul.withConfig({displayName:'styles__PageList',componentId:'sc-33pwcr-17'})(['list-style:none;display:flex;padding:0;margin-top:',';'],(0,_rem2.default)('12px'));var PaginatorContainer=exports.PaginatorContainer=_styledComponents2.default.div.withConfig({displayName:'styles__PaginatorContainer',componentId:'sc-33pwcr-18'})(['display:flex;width:100%;justify-content:center;margin-top:',';div{display:flex;align-items:center;}'],(0,_rem2.default)('40px'));var SearchContainer=exports.SearchContainer=_styledComponents2.default.div.withConfig({displayName:'styles__SearchContainer',componentId:'sc-33pwcr-19'})(['']);var FilterContainer=exports.FilterContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FilterContainer',componentId:'sc-33pwcr-20'})(['display:flex;justify-content:flex-end;margin-bottom:64px;button:last-child{margin-left:24px;}']);var SaveFilterSelection=exports.SaveFilterSelection=_styledComponents2.default.button.withConfig({displayName:'styles__SaveFilterSelection',componentId:'sc-33pwcr-21'})(['',';line-height:20.8px;color:',';background-color:',';padding:16px 32px;min-width:116px;height:52px;border:none;border-radius:28px;',';cursor:pointer;svg{margin-left:8px;}'],_types.title16Galano,function(_ref8){var secondary=_ref8.secondary;return secondary?_colors.darkSlateBlue:_colors.white;},function(_ref9){var secondary=_ref9.secondary;return secondary?_colors.white:_colors.darkSlateBlue;},function(_ref10){var secondary=_ref10.secondary;return secondary&&(0,_styledComponents.css)(['border:2px solid ',';'],_colors.darkSlateBlue);});

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ListItem=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/IdentifiersList/DropdownList/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ClickOut=__webpack_require__(590);var _styles=__webpack_require__(1971);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ListItem=exports.ListItem=function ListItem(_ref){var children=_ref.children,onClick=_ref.onClick,isActived=_ref.isActived,secondary=_ref.secondary,withIcon=_ref.withIcon;return _react2.default.createElement(_styles.DropdownListItem,{onClick:onClick,secondary:secondary,__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement(_styles.Title,{withIcon:withIcon,isActived:isActived,__source:{fileName:_jsxFileName,lineNumber:9}},children));};function DropdownList(_ref2){var options=_ref2.options,isOpen=_ref2.isOpen,onClose=_ref2.onClose,onSelect=_ref2.onSelect,optionSelected=_ref2.optionSelected,secondary=_ref2.secondary,withIcon=_ref2.withIcon,children=_ref2.children;var closeDropdown=function closeDropdown(onClick){if(onClose){onClose();}if(onClick){onClick();}};return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_ClickOut.OverlayClick,{onClick:onClose,isOpen:isOpen,__source:{fileName:_jsxFileName,lineNumber:38}}),_react2.default.createElement(_styles.DropdownListContainer,{isOpen:isOpen,withIcon:withIcon,secondary:secondary,__source:{fileName:_jsxFileName,lineNumber:39}},options&&options.map(function(option,index){var isActived=optionSelected===option;return _react2.default.createElement(ListItem,{key:index,secondary:secondary,isActived:isActived,withIcon:withIcon,onClick:function onClick(){closeDropdown(option.onClick);onSelect(option);},__source:{fileName:_jsxFileName,lineNumber:44}},option);}),children));}exports.default=DropdownList;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(131);
var call = __webpack_require__(583);
var isArrayIter = __webpack_require__(584);
var anObject = __webpack_require__(110);
var toLength = __webpack_require__(234);
var getIterFn = __webpack_require__(375);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.validElo=exports.validateCreditCardFlag=exports.validateCreditCard=exports.cvcRequired=undefined;var _cardValidator=__webpack_require__(562);var _cardValidator2=_interopRequireDefault(_cardValidator);var _elo=__webpack_require__(2132);var _elo2=_interopRequireDefault(_elo);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var cvcRequired=exports.cvcRequired=function cvcRequired(value){return value?undefined:'Digite o código.';};var validateCreditCard=exports.validateCreditCard=function validateCreditCard(value){var numberValidation=_cardValidator2.default.number(value);return numberValidation.isPotentiallyValid?undefined:'Cartão de crédito inválido.';};var validateCreditCardFlag=exports.validateCreditCardFlag=function validateCreditCardFlag(value){var numberValidation=_cardValidator2.default.number(value);return numberValidation.isPotentiallyValid?validElo(value)?'elo':numberValidation.card&&numberValidation.card.type==='mastercard'||numberValidation.card&&numberValidation.card.type==='master-card'?'master':numberValidation.card&&numberValidation.card.type==='american-express'?'amex':numberValidation.card&&numberValidation.card.type:undefined;};var validElo=exports.validElo=function validElo(cardNum){if(!cardNum){return undefined;}var card=cardNum.replace(/[\s+|\.|\-]/g,'');// eslint-disable-line
return _elo2.default.test(card);};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var composeValidators=exports.composeValidators=function composeValidators(){for(var _len=arguments.length,validators=Array(_len),_key=0;_key<_len;_key++){validators[_key]=arguments[_key];}return function(value,values){return validators.reduce(function(error,validator){return error||validator(value,values);},undefined);};};var VALIDTHRU_REGEX=/^(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/;// MM/yyyy
var validateExpireDate=exports.validateExpireDate=function validateExpireDate(date){return VALIDTHRU_REGEX.test(date)?undefined:'Padrão obrigatório MM/YYYY';};var validateAmexCVV=exports.validateAmexCVV=function validateAmexCVV(value){return value.length<4?'No m\xEDnimo 4 d\xEDgitos':undefined;};var validateCVV=exports.validateCVV=function validateCVV(value){return value.length<3?'No m\xEDnimo 3 d\xEDgitos':undefined;};var required=exports.required=function required(value){return value?undefined:'Campo Obrigatório';};

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = {"labels":{"location":"PRAÇA","plate":"PLACA","period":"PERÍODO","periodEnd":"ATÉ","submitButton":"Consultar"},"queryPlateTitle":"Consultar Placa","queryPlateSubtitle":"Consulte o status de uma placa."}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RequestFileFormSubtitle=exports.RequestFileFormTitle=exports.TableTitle=exports.SimpleFormQueryButtonContainer=exports.QueryButtonContainer=exports.FormContent=exports.FormSimpleContent=exports.BaseFormContent=exports.Subtitle=exports.Title=exports.SubHeader=exports.Main=exports.RowContainer=exports.Container=exports.HideOnLarge=exports.HideOnSmall=undefined;var _templateObject=_taggedTemplateLiteral(['\n      display: none;\n  '],['\n      display: none;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n      padding: 0px ',';\n  '],['\n      padding: 0px ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    padding: ',';\n  '],['\n    padding: ',';\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    padding: ',' ',';\n  '],['\n    padding: ',' ',';\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    margin: 17px 0px 0px 0px;\n  '],['\n    margin: 17px 0px 0px 0px;\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    width: 50%;\n    margin: auto;\n  '],['\n    width: 50%;\n    margin: auto;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _container=__webpack_require__(183);var _container2=_interopRequireDefault(_container);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var HideOnSmall=exports.HideOnSmall=_styledComponents2.default.div.withConfig({displayName:'styles__HideOnSmall',componentId:'sc-g7ttxp-0'})(['',';'],_media2.default.small(_templateObject));var HideOnLarge=exports.HideOnLarge=_styledComponents2.default.div.withConfig({displayName:'styles__HideOnLarge',componentId:'sc-g7ttxp-1'})(['',';'],_media2.default.large(_templateObject));var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-g7ttxp-2'})(['width:100%;',';'],_container2.default);var RowContainer=exports.RowContainer=(0,_styledComponents2.default)(Container).withConfig({displayName:'styles__RowContainer',componentId:'sc-g7ttxp-3'})(['display:flex;flex-direction:row;']);var Main=exports.Main=_styledComponents2.default.main.withConfig({displayName:'styles__Main',componentId:'sc-g7ttxp-4'})(['display:block;']);var SubHeader=exports.SubHeader=_styledComponents2.default.div.withConfig({displayName:'styles__SubHeader',componentId:'sc-g7ttxp-5'})(['margin:40px 0px;',';'],_media2.default.small(_templateObject2,(0,_rem2.default)('16px')));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-g7ttxp-6'})(['',' margin:0px;color:',';'],_types.title24GalanoBold,_colors.linkNavyBlue);var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-g7ttxp-7'})(['',' margin:0px;color:',';'],_types.txt14OpenSans,_colors.linkNavyBlue);var BaseFormContent=exports.BaseFormContent=_styledComponents2.default.div.withConfig({displayName:'styles__BaseFormContent',componentId:'sc-g7ttxp-8'})(['display:flex;flex-direction:row;width:100%;form{width:100%;',';}'],_container2.default);var FormSimpleContent=exports.FormSimpleContent=(0,_styledComponents2.default)(BaseFormContent).withConfig({displayName:'styles__FormSimpleContent',componentId:'sc-g7ttxp-9'})(['border-radius:4.4px;border:solid 1px #c5c3d8;padding:20px;height:100%;']);var FormContent=exports.FormContent=(0,_styledComponents2.default)(BaseFormContent).withConfig({displayName:'styles__FormContent',componentId:'sc-g7ttxp-10'})(['background-color:',';',';',';'],_colors.offWhite,_media2.default.small(_templateObject3,(0,_rem2.default)('16px')),_media2.default.large(_templateObject4,(0,_rem2.default)('50px'),(0,_rem2.default)('65px')));var QueryButtonContainer=exports.QueryButtonContainer=_styledComponents2.default.div.withConfig({displayName:'styles__QueryButtonContainer',componentId:'sc-g7ttxp-11'})(['',';',';'],_media2.default.large(_templateObject5),_media2.default.small(_templateObject6));var SimpleFormQueryButtonContainer=exports.SimpleFormQueryButtonContainer=(0,_styledComponents2.default)(QueryButtonContainer).withConfig({displayName:'styles__SimpleFormQueryButtonContainer',componentId:'sc-g7ttxp-12'})(['width:100%;div{width:100%;}']);var TableTitle=exports.TableTitle=_styledComponents2.default.p.withConfig({displayName:'styles__TableTitle',componentId:'sc-g7ttxp-13'})(['',' margin:40px 0px 24px;color:',';'],_types.txt14OpenSans,_colors.linkNavyBlue);var RequestFileFormTitle=exports.RequestFileFormTitle=_styledComponents2.default.p.withConfig({displayName:'styles__RequestFileFormTitle',componentId:'sc-g7ttxp-14'})(['',';color:',';margin:0;'],_types.txt24OpenSansBold,_colors.linkNavyBlue);var RequestFileFormSubtitle=exports.RequestFileFormSubtitle=_styledComponents2.default.p.withConfig({displayName:'styles__RequestFileFormSubtitle',componentId:'sc-g7ttxp-15'})(['',';color:',';margin:0 0 28px 0;'],_types.txt14OpenSans,_colors.darkGrey);

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var document = __webpack_require__(21).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var core = __webpack_require__(68);
var LIBRARY = __webpack_require__(105);
var wksExt = __webpack_require__(410);
var defineProperty = __webpack_require__(40).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(159)('keys');
var uid = __webpack_require__(116);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 273 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(21).document;
module.exports = document && document.documentElement;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(26);
var anObject = __webpack_require__(16);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(69)(Function.call, __webpack_require__(61).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var setPrototypeOf = __webpack_require__(275).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(71);
var defined = __webpack_require__(79);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 279 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(105);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(56);
var hide = __webpack_require__(55);
var Iterators = __webpack_require__(142);
var $iterCreate = __webpack_require__(282);
var setToStringTag = __webpack_require__(139);
var getPrototypeOf = __webpack_require__(62);
var ITERATOR = __webpack_require__(33)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(119);
var descriptor = __webpack_require__(115);
var setToStringTag = __webpack_require__(139);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(55)(IteratorPrototype, __webpack_require__(33)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(195);
var defined = __webpack_require__(79);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(33)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(142);
var ITERATOR = __webpack_require__(33)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(40);
var createDesc = __webpack_require__(115);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(140);
var ITERATOR = __webpack_require__(33)('iterator');
var Iterators = __webpack_require__(142);
module.exports = __webpack_require__(68).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(772);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(118);
var toLength = __webpack_require__(37);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(107);
var step = __webpack_require__(427);
var Iterators = __webpack_require__(142);
var toIObject = __webpack_require__(60);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(281)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(162);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(194)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(69);
var invoke = __webpack_require__(417);
var html = __webpack_require__(274);
var cel = __webpack_require__(270);
var global = __webpack_require__(21);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(70)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var macrotask = __webpack_require__(293).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(70)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(52);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(21);
var DESCRIPTORS = __webpack_require__(38);
var LIBRARY = __webpack_require__(105);
var $typed = __webpack_require__(201);
var hide = __webpack_require__(55);
var redefineAll = __webpack_require__(124);
var fails = __webpack_require__(24);
var anInstance = __webpack_require__(122);
var toInteger = __webpack_require__(71);
var toLength = __webpack_require__(37);
var toIndex = __webpack_require__(437);
var gOPN = __webpack_require__(120).f;
var dP = __webpack_require__(40).f;
var arrayFill = __webpack_require__(289);
var setToStringTag = __webpack_require__(139);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(897);


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(29);

var invariant = __webpack_require__(17);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var ReactErrorUtils = __webpack_require__(301);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(28);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = func.bind(null, a);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(53);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMLazyTree = __webpack_require__(147);
var Danger = __webpack_require__(911);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactInstrumentation = __webpack_require__(73);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(307);
var setInnerHTML = __webpack_require__(207);
var setTextContent = __webpack_require__(461);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var ReactPropTypesSecret = __webpack_require__(929);
var propTypesFactory = __webpack_require__(449);

var React = __webpack_require__(143);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(28);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(29);

var invariant = __webpack_require__(17);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var ReactCurrentOwner = __webpack_require__(91);
var ReactInstanceMap = __webpack_require__(168);
var ReactInstrumentation = __webpack_require__(73);
var ReactUpdates = __webpack_require__(82);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(28);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var emptyFunction = __webpack_require__(63);
var warning = __webpack_require__(28);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__ = __webpack_require__(990);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ConnectedRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__ConnectedRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__(490);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LOCATION_CHANGE", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerReducer", function() { return __WEBPACK_IMPORTED_MODULE_1__reducer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(491);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CALL_HISTORY_METHOD", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "push", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "replace", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "go", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "goBack", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "goForward", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerActions", function() { return __WEBPACK_IMPORTED_MODULE_2__actions__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middleware__ = __webpack_require__(1002);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__middleware__["a"]; });








/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(993);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(994);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(170);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(128);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict;

  var _compilePath = compilePath(path, { end: exact, strict: strict }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_INSERT", function() { return ARRAY_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_MOVE", function() { return ARRAY_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_POP", function() { return ARRAY_POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_PUSH", function() { return ARRAY_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE", function() { return ARRAY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE_ALL", function() { return ARRAY_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SHIFT", function() { return ARRAY_SHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SPLICE", function() { return ARRAY_SPLICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_UNSHIFT", function() { return ARRAY_UNSHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SWAP", function() { return ARRAY_SWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOFILL", function() { return AUTOFILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLUR", function() { return BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT", function() { return CLEAR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT_ERRORS", function() { return CLEAR_SUBMIT_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ASYNC_ERROR", function() { return CLEAR_ASYNC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTROY", function() { return DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS", function() { return FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_FIELD", function() { return REGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_FAILED", function() { return SET_SUBMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_SUCCEEDED", function() { return SET_SUBMIT_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ASYNC_VALIDATION", function() { return START_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SUBMIT", function() { return START_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_ASYNC_VALIDATION", function() { return STOP_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_SUBMIT", function() { return STOP_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT", function() { return SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH", function() { return TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNREGISTER_FIELD", function() { return UNREGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNTOUCH", function() { return UNTOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_ERRORS", function() { return UPDATE_SYNC_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_WARNINGS", function() { return UPDATE_SYNC_WARNINGS; });
var prefix = '@@redux-form/';

var ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = prefix + 'AUTOFILL';
var BLUR = prefix + 'BLUR';
var CHANGE = prefix + 'CHANGE';
var CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = prefix + 'DESTROY';
var FOCUS = prefix + 'FOCUS';
var INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = prefix + 'RESET';
var SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = prefix + 'SUBMIT';
var TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(1066);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(108);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(84);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(127);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(1075);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(219);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(127);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(1093);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(212)(module)))

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(1096);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(214);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasError__ = __webpack_require__(1151);



var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = Object(__WEBPACK_IMPORTED_MODULE_0__hasError__["a" /* default */])(structure);
  return function (form, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsValid);

/***/ }),
/* 338 */
/***/ (function(module, exports) {

module.exports = isPromise;
module.exports.default = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FETCH_MAX_RETRY=exports.EC_QUERY_PLATE=exports.EC_LOCATIONS=exports.MANAGE_INF=exports.PLAN_INVOICE_DETAILS=exports.LOGOUT=exports.ACCESS_TOKEN=exports.PLAN_RECHARGES=exports.PLAN_INVOICES=exports.PLAN_STATEMENTS=exports.PLAN_RESUME=exports.VERIFY_USER_PASSWORD=exports.VALIDATE_CANCEL_TOKEN=exports.CREATE_CANCEL_TOKEN=exports.CANCEL_OPTIONS=exports.CEP=exports.BUSINESS_USER_CONTACTS=exports.BUSINESS_USER_REPRESENTATIVE=exports.BUSINESS_USER_ADDRESS=exports.BUSINESS_USER_PROFILE=exports.USER_AVATAR=exports.USER_CONTACTS=exports.USER_PROFILE=exports.USER_ADDRESS=exports.USER_CREDENTIALS=exports.USER_CANCEL=exports.BUSINESS_USER=exports.INDIVIDUAL_USER=exports.ACCOUNT=exports.SUPPORT=exports.BRASPAG_URL=exports.PUBLIC_SITE_URL=exports.dynPublicAPI=exports.dynamicAPI=exports.API=exports.API_URL=undefined;var _config=__webpack_require__(221);var API_URL=exports.API_URL=''+_config.apiURL;var API=exports.API=_config.apiURL+'/mocks';var dynamicAPI=exports.dynamicAPI=''+_config.apiURL;var dynPublicAPI=exports.dynPublicAPI=_config.apiURL+'/publico';var PUBLIC_SITE_URL=exports.PUBLIC_SITE_URL=''+_config.publicSite;var BRASPAG_URL=exports.BRASPAG_URL=''+_config.brasPagURL;var SUPPORT=exports.SUPPORT='/suporte';var ACCOUNT=exports.ACCOUNT='/conta';var INDIVIDUAL_USER=exports.INDIVIDUAL_USER='/pessoal';var BUSINESS_USER=exports.BUSINESS_USER='/empresarial';var USER_CANCEL=exports.USER_CANCEL=ACCOUNT+'/cancelamento';var USER_CREDENTIALS=exports.USER_CREDENTIALS=ACCOUNT+'/credenciais';var USER_ADDRESS=exports.USER_ADDRESS=INDIVIDUAL_USER+'/endereco';var USER_PROFILE=exports.USER_PROFILE=INDIVIDUAL_USER+'/perfil';var USER_CONTACTS=exports.USER_CONTACTS=INDIVIDUAL_USER+'/contato';var USER_AVATAR=exports.USER_AVATAR=INDIVIDUAL_USER+'/avatar';var BUSINESS_USER_PROFILE=exports.BUSINESS_USER_PROFILE=BUSINESS_USER+'/institucional';var BUSINESS_USER_ADDRESS=exports.BUSINESS_USER_ADDRESS=BUSINESS_USER+'/endereco';var BUSINESS_USER_REPRESENTATIVE=exports.BUSINESS_USER_REPRESENTATIVE=BUSINESS_USER+'/representante';var BUSINESS_USER_CONTACTS=exports.BUSINESS_USER_CONTACTS=BUSINESS_USER+'/contato';var CEP=exports.CEP=SUPPORT+'/cep';var CANCEL_OPTIONS=exports.CANCEL_OPTIONS='/cancelamento';var CREATE_CANCEL_TOKEN=exports.CREATE_CANCEL_TOKEN=ACCOUNT+CANCEL_OPTIONS+'/token/create';var VALIDATE_CANCEL_TOKEN=exports.VALIDATE_CANCEL_TOKEN=ACCOUNT+CANCEL_OPTIONS+'/token/validate';var VERIFY_USER_PASSWORD=exports.VERIFY_USER_PASSWORD='/verificar-senha';var PLAN_RESUME=exports.PLAN_RESUME='/minha-veloe/resumo';var PLAN_STATEMENTS=exports.PLAN_STATEMENTS='/minha-veloe/extrato';var PLAN_INVOICES=exports.PLAN_INVOICES='/minha-veloe/fatura';var PLAN_RECHARGES=exports.PLAN_RECHARGES='/minha-veloe/historico-de-recarga';var ACCESS_TOKEN=exports.ACCESS_TOKEN='/auth/login';var LOGOUT=exports.LOGOUT='/auth/logout';var PLAN_INVOICE_DETAILS=exports.PLAN_INVOICE_DETAILS='/minha-veloe';// Informação Gerencial
var MANAGE_INF=exports.MANAGE_INF='/minha-veloe/informacao-gerencial';// EC
var EC_LOCATIONS=exports.EC_LOCATIONS='/ec/locations';var EC_QUERY_PLATE=exports.EC_QUERY_PLATE='/ec/query-plate';var FETCH_MAX_RETRY=exports.FETCH_MAX_RETRY=5;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(1202);
var parse = __webpack_require__(1203);
var formats = __webpack_require__(525);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.put=exports.post=exports.get=exports.request=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _index=__webpack_require__(526);var _index2=_interopRequireDefault(_index);var _constants=__webpack_require__(149);var _storage=__webpack_require__(343);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var getResponseErrorDescription=function getResponseErrorDescription(error){var decription='Erro inesperado';var respData=error.response.data;if(typeof respData==='string'||respData instanceof String){try{var respDataObj=JSON.parse(error.response.data);decription=respDataObj.messageError||respDataObj.description;}catch(e){decription=respData;}}else{decription=respData.messageError;}return decription;};var request=exports.request=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(config){var retryCount=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;var token,headers,resp;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;token=(0,_storage.getAccessToken)();headers=_extends({},config.headers,{Authorization:localStorage.getItem('OauthDomain')==='c6'?_constants.API_AUTHORIZATION_C6:_constants.API_AUTHORIZATION// prevent token from being sent in the request, used by authentication
});if(!config.preventToken&&token)headers.token=token;_context2.next=6;return _index2.default.request(_extends({},config,{headers:headers}));case 6:resp=_context2.sent;return _context2.abrupt('return',resp.data);case 10:_context2.prev=10;_context2.t0=_context2['catch'](0);if(!_context2.t0.response){_context2.next=17;break;}_context2.t0.jsonMessage=getResponseErrorDescription(_context2.t0);_context2.t0.status=_context2.t0.response.status||-1;_context2.next=27;break;case 17:if(!_context2.t0.request){_context2.next=24;break;}if(!(retryCount<_constants.AJAX_MAX_RETRY)){_context2.next=20;break;}return _context2.abrupt('return',request(config,retryCount+1));case 20:_context2.t0.jsonMessage='Erro ao se comunicar com o servidor, aguarde alguns instantes e tente novamente.';_context2.t0.status=0;_context2.next=27;break;case 24:// Something happened in setting up the request that triggered an Error
_context2.t0.jsonMessage='Error n\xE3o esperado';_context2.t0.status=-1;console.error('Error n\xE3o esperado: '+_context2.t0.message);case 27:_context2.t0.json=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt('return',{messageError:_context2.t0.jsonMessage});case 1:case'end':return _context.stop();}}},_callee,undefined);}));throw _context2.t0;case 29:case'end':return _context2.stop();}}},_callee2,undefined,[[0,10]]);}));return function request(_x){return _ref.apply(this,arguments);};}();var get=exports.get=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(url,config){return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:return _context3.abrupt('return',request(_extends({},config,{url:url,method:'get'})));case 1:case'end':return _context3.stop();}}},_callee3,undefined);}));return function get(_x3,_x4){return _ref3.apply(this,arguments);};}();var post=exports.post=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(url){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var config=arguments[2];return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:return _context4.abrupt('return',request(_extends({data:data},config,{url:url,method:'post'})));case 1:case'end':return _context4.stop();}}},_callee4,undefined);}));return function post(_x5){return _ref4.apply(this,arguments);};}();var put=exports.put=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(url){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var config=arguments[2];return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:return _context5.abrupt('return',request(_extends({data:data},config,{url:url,method:'put'})));case 1:case'end':return _context5.stop();}}},_callee5,undefined);}));return function put(_x7){return _ref5.apply(this,arguments);};}();

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(65);
var normalizeHeaderName = __webpack_require__(1206);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(529);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(529);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)))

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var AUTH_KEY='veloe-auth';var parseJwt=function parseJwt(token){var base64Url=token.split('.')[1];var base64=base64Url.replace(/-/g,'+').replace(/_/g,'/');return JSON.parse(window.atob(base64));};var objectSetter=function objectSetter(key){return function(obj){var authObj=sessionStorage.getItem(key);if(authObj){authObj=JSON.parse(authObj);obj.refresh_token=authObj.refresh_token;}sessionStorage.setItem(key,JSON.stringify(obj));};};var objectRemover=function objectRemover(key){return function(){sessionStorage.removeItem(key);};};var objectGetter=function objectGetter(key){return function(){var json=sessionStorage.getItem(key);try{return JSON.parse(json);}catch(e){console.warn('Erro parsing storage key "'+key+'" object. value="'+json+'"');return null;}};};var getAuthObj=objectGetter(AUTH_KEY);var setAuthObj=exports.setAuthObj=objectSetter(AUTH_KEY);var removeAuthObj=exports.removeAuthObj=objectRemover(AUTH_KEY);var getAccessToken=exports.getAccessToken=function getAccessToken(){var authObj=getAuthObj();if(!authObj||!authObj.access_token)return null;return authObj.access_token;};var getAccessTokenObject=exports.getAccessTokenObject=function getAccessTokenObject(){var acessToken=getAccessToken();return acessToken&&parseJwt(acessToken)||null;};var getRefreshToken=exports.getRefreshToken=function getRefreshToken(){var authObj=getAuthObj();if(!authObj||!authObj.refresh_token)return null;return authObj.refresh_token;};var setTimeRefreshToken=exports.setTimeRefreshToken=function setTimeRefreshToken(time){sessionStorage.setItem('timeRefreshToken',time);};var getTimeRefreshToken=exports.getTimeRefreshToken=function getTimeRefreshToken(){return sessionStorage.getItem('timeRefreshToken');};

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOperation", function() { return createOperation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makePromise", function() { return makePromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toPromise", function() { return toPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromPromise", function() { return fromPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromError", function() { return fromError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "from", function() { return from; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "split", function() { return split; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "concat", function() { return concat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloLink", function() { return ApolloLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "execute", function() { return execute; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Observable", function() { return __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ts_invariant__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tslib__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_language_printer__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_graphql_language_printer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_graphql_language_printer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_apollo_utilities__ = __webpack_require__(86);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getOperationName", function() { return __WEBPACK_IMPORTED_MODULE_4_apollo_utilities__["getOperationName"]; });








function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["InvariantError"](2) : new InvariantError("illegal argument: " + key);
        }
    }
    return operation;
}
var LinkError = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__extends"])(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    "production" === "production" || __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"].warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"](function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"](function (observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? Object(__WEBPACK_IMPORTED_MODULE_4_apollo_utilities__["getOperationName"])(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, context, next(context));
        }
        else {
            context = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, context, next);
        }
    };
    var getContext = function () { return (Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
function getKey(operation) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_graphql_language_printer__["print"])(operation.query) + "|" + JSON.stringify(operation.variables) + "|" + operation.operationName;
}

function passthrough(op, forward) {
    return forward ? forward(op) : __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function () { return __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of(); });
}
function from(links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of()
                : rightLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of()
                : rightLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of();
        });
    }
}
var concat = function (first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) {
        "production" === "production" || __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"].warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of(); }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of();
            }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of());
        });
    }
};
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["InvariantError"](1) : new InvariantError('request is not implemented');
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());
function execute(link, operation) {
    return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of());
}


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvariantError", function() { return InvariantError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invariant", function() { return invariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "process", function() { return processStub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(39);


var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
(function (invariant) {
    function warn() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return console.warn.apply(console, args);
    }
    invariant.warn = warn;
    function error() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return console.error.apply(console, args);
    }
    invariant.error = error;
})(invariant || (invariant = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
var processStub = typeof process === "object" ? process : { env: {} };
var invariant$1 = invariant;

/* harmony default export */ __webpack_exports__["default"] = (invariant$1);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(83)))

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.print = print;

var _visitor = __webpack_require__(222);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */
function print(ast) {
  return (0, _visitor.visit)(ast, {
    leave: printDocASTReducer
  });
}

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === 'description') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: function SchemaDefinition(_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray, separator) {
  return maybeArray ? maybeArray.filter(function (x) {
    return x;
  }).join(separator || '') : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */


function wrap(start, maybeString, end) {
  return maybeString ? start + maybeString + (end || '') : '';
}

function indent(maybeString) {
  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}

function isMultiline(string) {
  return string.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray && maybeArray.some(isMultiline);
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */


function printBlockString(value, isDescription) {
  var escaped = value.replace(/"""/g, '\\"""');
  return isMultiline(value) || value[0] !== ' ' && value[0] !== '\t' ? "\"\"\"\n".concat(isDescription ? escaped : indent(escaped), "\n\"\"\"") : "\"\"\"".concat(escaped.replace(/"$/, '"\n'), "\"\"\"");
}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cache = __webpack_require__(1234).Cache;
var tuple = __webpack_require__(1235).tuple;
var Entry = __webpack_require__(1236).Entry;
var getLocal = __webpack_require__(536).get;

// Exported so that custom makeCacheKey functions can easily reuse the
// default implementation (with different arguments).
exports.defaultMakeCacheKey = tuple;

function normalizeOptions(options) {
  options = options || Object.create(null);

  if (typeof options.makeCacheKey !== "function") {
    options.makeCacheKey = tuple;
  }

  if (typeof options.max !== "number") {
    options.max = Math.pow(2, 16);
  }

  return options;
}

function wrap(fn, options) {
  options = normalizeOptions(options);

  // If this wrapped function is disposable, then its creator does not
  // care about its return value, and it should be removed from the cache
  // immediately when it no longer has any parents that depend on it.
  var disposable = !! options.disposable;

  var cache = new Cache({
    max: options.max,
    dispose: function (key, entry) {
      entry.dispose();
    }
  });

  function reportOrphan(entry) {
    if (disposable) {
      // Triggers the entry.dispose() call above.
      cache.delete(entry.key);
      return true;
    }
  }

  function optimistic() {
    if (disposable && ! getLocal().currentParentEntry) {
      // If there's no current parent computation, and this wrapped
      // function is disposable (meaning we don't care about entry.value,
      // just dependency tracking), then we can short-cut everything else
      // in this function, because entry.recompute() is going to recycle
      // the entry object without recomputing anything, anyway.
      return;
    }

    var key = options.makeCacheKey.apply(null, arguments);
    if (! key) {
      return fn.apply(null, arguments);
    }

    var args = [], len = arguments.length;
    while (len--) args[len] = arguments[len];

    var entry = cache.get(key);
    if (entry) {
      entry.args = args;
    } else {
      cache.set(key, entry = Entry.acquire(fn, key, args));
      entry.subscribe = options.subscribe;
      if (disposable) {
        entry.reportOrphan = reportOrphan;
      }
    }

    var value = entry.recompute();

    // Move this entry to the front of the least-recently used queue,
    // since we just finished computing its value.
    cache.set(key, entry);

    // Clean up any excess entries in the cache, but only if this entry
    // has no parents, which means we're not in the middle of a larger
    // computation that might be flummoxed by the cleaning.
    if (entry.parents.size === 0) {
      cache.clean();
    }

    // If options.disposable is truthy, the caller of wrap is telling us
    // they don't care about the result of entry.recompute(), so we should
    // avoid returning the value, so it won't be accidentally used.
    if (! disposable) {
      return value;
    }
  }

  optimistic.dirty = function () {
    var key = options.makeCacheKey.apply(null, arguments);
    if (! key) {
      return;
    }

    if (! cache.has(key)) {
      return;
    }

    cache.get(key).setDirty();
  };

  return optimistic;
}

exports.wrap = wrap;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var optimism_1 = __webpack_require__(347);
var hasOwn = Object.prototype.hasOwnProperty;
var DepTrackingCache = (function () {
    function DepTrackingCache(data) {
        if (data === void 0) { data = Object.create(null); }
        var _this = this;
        this.data = data;
        this.depend = optimism_1.wrap(function (dataId) { return _this.data[dataId]; }, {
            disposable: true,
            makeCacheKey: function (dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function () {
        return this.data;
    };
    DepTrackingCache.prototype.get = function (dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function (dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function (dataId) {
        if (hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function () {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function (newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function (dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function (dataId) {
                if (!hasOwn.call(newData, dataId)) {
                    _this.delete(dataId);
                }
            });
        }
        else {
            Object.keys(this.data).forEach(function (dataId) {
                _this.delete(dataId);
            });
        }
    };
    return DepTrackingCache;
}());
exports.DepTrackingCache = DepTrackingCache;
function defaultNormalizedCacheFactory(seed) {
    return new DepTrackingCache(seed);
}
exports.defaultNormalizedCacheFactory = defaultNormalizedCacheFactory;
//# sourceMappingURL=depTrackingCache.js.map

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ObjectCache = (function () {
    function ObjectCache(data) {
        if (data === void 0) { data = Object.create(null); }
        this.data = data;
    }
    ObjectCache.prototype.toObject = function () {
        return this.data;
    };
    ObjectCache.prototype.get = function (dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function (dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function (dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function () {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function (newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}());
exports.ObjectCache = ObjectCache;
function defaultNormalizedCacheFactory(seed) {
    return new ObjectCache(seed);
}
exports.defaultNormalizedCacheFactory = defaultNormalizedCacheFactory;
//# sourceMappingURL=objectCache.js.map

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GraphQLError = GraphQLError;

var _printError = __webpack_require__(546);

var _location = __webpack_require__(547);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function GraphQLError( // eslint-disable-line no-redeclare
message, nodes, source, positions, path, originalError, extensions) {
  // Compute list of blame nodes.
  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined; // Compute locations in the source for the given nodes/positions.


  var _source = source;

  if (!_source && _nodes) {
    var node = _nodes[0];
    _source = node && node.loc && node.loc.source;
  }

  var _positions = positions;

  if (!_positions && _nodes) {
    _positions = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(node.loc.start);
      }

      return list;
    }, []);
  }

  if (_positions && _positions.length === 0) {
    _positions = undefined;
  }

  var _locations;

  if (positions && source) {
    _locations = positions.map(function (pos) {
      return (0, _location.getLocation)(source, pos);
    });
  } else if (_nodes) {
    _locations = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push((0, _location.getLocation)(node.loc.source, node.loc.start));
      }

      return list;
    }, []);
  }

  var _extensions = extensions || originalError && originalError.extensions;

  Object.defineProperties(this, {
    message: {
      value: message,
      // By being enumerable, JSON.stringify will include `message` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true,
      writable: true
    },
    locations: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _locations || undefined,
      // By being enumerable, JSON.stringify will include `locations` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_locations)
    },
    path: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: path || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(path)
    },
    nodes: {
      value: _nodes || undefined
    },
    source: {
      value: _source || undefined
    },
    positions: {
      value: _positions || undefined
    },
    originalError: {
      value: originalError
    },
    extensions: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _extensions || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_extensions)
    }
  }); // Include (non-enumerable) stack trace.

  if (originalError && originalError.stack) {
    Object.defineProperty(this, 'stack', {
      value: originalError.stack,
      writable: true,
      configurable: true
    });
  } else if (Error.captureStackTrace) {
    Error.captureStackTrace(this, GraphQLError);
  } else {
    Object.defineProperty(this, 'stack', {
      value: Error().stack,
      writable: true,
      configurable: true
    });
  }
}

GraphQLError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: GraphQLError
  },
  name: {
    value: 'GraphQLError'
  },
  toString: {
    value: function toString() {
      return (0, _printError.printError)(this);
    }
  }
});

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(224),
    isObjectLike = __webpack_require__(226);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(225);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1266),
    getValue = __webpack_require__(1270);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.transformDadosPagamento=exports.transformRecharges=exports.transformValoresRecarga=exports.gqlAccessTokenBrasPag=exports.gqlEditarDadoPagamento=exports.gqlEditarValorRecarga=exports.gqlDadosPagamento=exports.gqlValoresRecarga=exports.gqlRecharges=exports.gqlInserirRecarga=undefined;var _templateObject=_taggedTemplateLiteral(['\n  mutation inserirRecarga(\n    $conta: String!\n    $valor: Int!\n    $atividade: String!\n    $formaPagamento: String!\n    $canal: String!\n  ) {\n    inserirRecarga(\n      recarga: {\n        conta: $conta\n        valor: $valor\n        atividade: $atividade\n        formaPagamento: $formaPagamento\n        canal: $canal\n      }\n    ) {\n      conta\n      valor\n      atividade\n      formaPagamento\n      canal\n    }\n  }\n'],['\n  mutation inserirRecarga(\n    $conta: String!\n    $valor: Int!\n    $atividade: String!\n    $formaPagamento: String!\n    $canal: String!\n  ) {\n    inserirRecarga(\n      recarga: {\n        conta: $conta\n        valor: $valor\n        atividade: $atividade\n        formaPagamento: $formaPagamento\n        canal: $canal\n      }\n    ) {\n      conta\n      valor\n      atividade\n      formaPagamento\n      canal\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query historicoRecargas($idConta: String!, $skip: Int) {\n    historicoRecargas(conta: $idConta, skip: $skip) {\n      limit\n      remaining\n      recargas {\n        valor\n        formaPagamento\n        atividade\n        id\n        conta\n        data\n      }\n    }\n  }\n'],['\n  query historicoRecargas($idConta: String!, $skip: Int) {\n    historicoRecargas(conta: $idConta, skip: $skip) {\n      limit\n      remaining\n      recargas {\n        valor\n        formaPagamento\n        atividade\n        id\n        conta\n        data\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query valoresRecarga($idConta: String!) {\n    valoresRecarga(conta: $idConta) {\n      valor\n    }\n  }\n'],['\n  query valoresRecarga($idConta: String!) {\n    valoresRecarga(conta: $idConta) {\n      valor\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query dadosPagamento($conta: String!) {\n    dadosPagamento(conta: $conta) {\n      id\n      paymentId\n      conta\n      numeroMascarado\n      validade\n      bandeira\n      alias\n      cpf\n      cnpj\n      nome\n      paymentToken\n      cardToken\n      ativo\n      excluido\n      message\n      estornado\n    }\n  }\n'],['\n  query dadosPagamento($conta: String!) {\n    dadosPagamento(conta: $conta) {\n      id\n      paymentId\n      conta\n      numeroMascarado\n      validade\n      bandeira\n      alias\n      cpf\n      cnpj\n      nome\n      paymentToken\n      cardToken\n      ativo\n      excluido\n      message\n      estornado\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  mutation editarValorRecarga($valor: Float!, $conta: String!) {\n    editarValorRecarga(\n      recargaValor: { valorRecarga: $valor, recargaConta: { conta: { id: $conta } } }\n    ) {\n      valorRecarga\n    }\n  }\n'],['\n  mutation editarValorRecarga($valor: Float!, $conta: String!) {\n    editarValorRecarga(\n      recargaValor: { valorRecarga: $valor, recargaConta: { conta: { id: $conta } } }\n    ) {\n      valorRecarga\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation editarDadoPagamento(\n    $conta: String!\n    $numeroMascarado: String!\n    $validade: String!\n    $bandeira: String!\n    $alias: String!\n    $nome: String!\n    $paymentToken: String!\n    $cvv: String!\n    $ativo: Boolean!\n    $valorRecarga: String!\n  ) {\n    editarDadoPagamento(\n      dadoPagamento: {\n        conta: $conta\n        numeroMascarado: $numeroMascarado\n        validade: $validade\n        alias: $alias\n        bandeira: $bandeira\n        nome: $nome\n        paymentToken: $paymentToken\n        cvv: $cvv\n        ativo: $ativo\n        valorRecarga: $valorRecarga\n      }\n    ) {\n      conta\n      numeroMascarado\n      validade\n      alias\n      nome\n      paymentToken\n      cvv\n      ativo\n      valorRecarga\n    }\n  }\n'],['\n  mutation editarDadoPagamento(\n    $conta: String!\n    $numeroMascarado: String!\n    $validade: String!\n    $bandeira: String!\n    $alias: String!\n    $nome: String!\n    $paymentToken: String!\n    $cvv: String!\n    $ativo: Boolean!\n    $valorRecarga: String!\n  ) {\n    editarDadoPagamento(\n      dadoPagamento: {\n        conta: $conta\n        numeroMascarado: $numeroMascarado\n        validade: $validade\n        alias: $alias\n        bandeira: $bandeira\n        nome: $nome\n        paymentToken: $paymentToken\n        cvv: $cvv\n        ativo: $ativo\n        valorRecarga: $valorRecarga\n      }\n    ) {\n      conta\n      numeroMascarado\n      validade\n      alias\n      nome\n      paymentToken\n      cvv\n      ativo\n      valorRecarga\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  {\n    accessTokenBrasPag\n  }\n'],['\n  {\n    accessTokenBrasPag\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);var _unixTimestamp=__webpack_require__(1327);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlInserirRecarga=exports.gqlInserirRecarga=(0,_graphqlTag2.default)(_templateObject);var gqlRecharges=exports.gqlRecharges=(0,_graphqlTag2.default)(_templateObject2);var gqlValoresRecarga=exports.gqlValoresRecarga=(0,_graphqlTag2.default)(_templateObject3);var gqlDadosPagamento=exports.gqlDadosPagamento=(0,_graphqlTag2.default)(_templateObject4);var gqlEditarValorRecarga=exports.gqlEditarValorRecarga=(0,_graphqlTag2.default)(_templateObject5);var gqlEditarDadoPagamento=exports.gqlEditarDadoPagamento=(0,_graphqlTag2.default)(_templateObject6);var gqlAccessTokenBrasPag=exports.gqlAccessTokenBrasPag=(0,_graphqlTag2.default)(_templateObject7);var transformValoresRecarga=exports.transformValoresRecarga=function transformValoresRecarga(src){var valoresRecarga=src.data.valoresRecarga;var rechargeValues=valoresRecarga.reduce(function(acc,curr){acc.push(Number.parseInt(curr.valor,10));return acc;},[]);return{rechargeValues:rechargeValues};};var decodePaymentMethod={CARTAO_DE_CREDITO:'credit',DEBITO_EM_CONTA:'debit',BOLETO:'bankSlip'};var decodeType={RECARGA_MANUAL:'manual',RECARGA_AUTOMATICA:'auto'};var transformRecharges=exports.transformRecharges=function transformRecharges(src){return src.map(function(r){return{value:r.valor,paymentMethod:decodePaymentMethod[r.formaPagamento],type:decodeType[r.atividade],id:r.id,accountPlanId:r.conta,date:(0,_unixTimestamp.toDate)(r.data/1000)};});};var transformDadosPagamento=exports.transformDadosPagamento=function transformDadosPagamento(src){return src.data.dadosPagamento[0];};

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.gqlSolicitarBoleto=exports.gqlDownloadBoleto=exports.gqlDownloadFaturaCsv=exports.gqlDownloadFaturaPdf=exports.gqlInvoice=exports.gqlInvoices=undefined;var _templateObject=_taggedTemplateLiteral(['\n  query historicoFaturas($idConta: String!, $page: Int) {\n    historicoFaturas(idConta: $idConta, pagina: $page) {\n      faturas {\n        numero\n        valor\n        dataVencimento\n        numero\n        status\n        formaPagamento\n        mes\n        nsu\n        qtdTransacoes\n        exibirTransacoes\n        linkBoleto\n      }\n      paginacao {\n        anterior\n        atual\n        proxima\n        total\n      }\n    }\n  }\n'],['\n  query historicoFaturas($idConta: String!, $page: Int) {\n    historicoFaturas(idConta: $idConta, pagina: $page) {\n      faturas {\n        numero\n        valor\n        dataVencimento\n        numero\n        status\n        formaPagamento\n        mes\n        nsu\n        qtdTransacoes\n        exibirTransacoes\n        linkBoleto\n      }\n      paginacao {\n        anterior\n        atual\n        proxima\n        total\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query detalheFatura($idConta: String!, $faturaId: Int!, $qtdTransacoes: Int!) {\n    detalheFaturaPj(idConta: $idConta, numeroFatura: $faturaId, qtdTransacoes: $qtdTransacoes) {\n      servicosVeloe {\n        tipoTransacao\n        quantidade\n        total\n      }\n      consumos {\n        tipoTransacao\n        quantidade\n        total\n      }\n      transacoes {\n        placa\n        condutor\n        total\n        transacoesAgrupadas {\n          tipoTransacao\n          total\n          transacaoes {\n            data\n            hora\n            categoria\n            horaEntrada\n            horaSaida\n            estabelecimento\n            valor\n            endereco\n            permanencia\n          }\n        }\n      }\n      formaPagamento\n      total\n      linkNFE\n      numeroNF\n      dataEmissaoNF\n      error\n      totalBeneficios\n      subTotal\n      dataVencimento\n      exibirTransacoes\n      linkFaturaPDF\n      linkFaturaCSV\n      linkBoleto\n    }\n  }\n'],['\n  query detalheFatura($idConta: String!, $faturaId: Int!, $qtdTransacoes: Int!) {\n    detalheFaturaPj(idConta: $idConta, numeroFatura: $faturaId, qtdTransacoes: $qtdTransacoes) {\n      servicosVeloe {\n        tipoTransacao\n        quantidade\n        total\n      }\n      consumos {\n        tipoTransacao\n        quantidade\n        total\n      }\n      transacoes {\n        placa\n        condutor\n        total\n        transacoesAgrupadas {\n          tipoTransacao\n          total\n          transacaoes {\n            data\n            hora\n            categoria\n            horaEntrada\n            horaSaida\n            estabelecimento\n            valor\n            endereco\n            permanencia\n          }\n        }\n      }\n      formaPagamento\n      total\n      linkNFE\n      numeroNF\n      dataEmissaoNF\n      error\n      totalBeneficios\n      subTotal\n      dataVencimento\n      exibirTransacoes\n      linkFaturaPDF\n      linkFaturaCSV\n      linkBoleto\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query downloadFaturaPdf($idConta: String!, $numeroFatura: Int!) {\n    downloadFaturaPdf(idConta: $idConta, numeroFatura: $numeroFatura) {\n      result\n    }\n  }\n'],['\n  query downloadFaturaPdf($idConta: String!, $numeroFatura: Int!) {\n    downloadFaturaPdf(idConta: $idConta, numeroFatura: $numeroFatura) {\n      result\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query downloadFaturaCsv($idConta: String!, $numeroFatura: Int!) {\n    downloadFatura(idConta: $idConta, numeroFatura: $numeroFatura) {\n      result\n    }\n  }\n'],['\n  query downloadFaturaCsv($idConta: String!, $numeroFatura: Int!) {\n    downloadFatura(idConta: $idConta, numeroFatura: $numeroFatura) {\n      result\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query downloadBoleto($idConta: String!, $nsu: Int!) {\n    downloadBoleto(idConta: $idConta, nsu: $nsu) {\n      result\n    }\n  }\n'],['\n  query downloadBoleto($idConta: String!, $nsu: Int!) {\n    downloadBoleto(idConta: $idConta, nsu: $nsu) {\n      result\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  mutation solicitarBoleto($idConta: String, $nsu: String) {\n    solicitarBoleto(idConta: $idConta, nsu: $nsu) {\n      codigo\n      mensagem\n    }\n  }\n'],['\n  mutation solicitarBoleto($idConta: String, $nsu: String) {\n    solicitarBoleto(idConta: $idConta, nsu: $nsu) {\n      codigo\n      mensagem\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlInvoices=exports.gqlInvoices=(0,_graphqlTag2.default)(_templateObject);var gqlInvoice=exports.gqlInvoice=(0,_graphqlTag2.default)(_templateObject2);var gqlDownloadFaturaPdf=exports.gqlDownloadFaturaPdf=(0,_graphqlTag2.default)(_templateObject3);var gqlDownloadFaturaCsv=exports.gqlDownloadFaturaCsv=(0,_graphqlTag2.default)(_templateObject4);var gqlDownloadBoleto=exports.gqlDownloadBoleto=(0,_graphqlTag2.default)(_templateObject5);var gqlSolicitarBoleto=exports.gqlSolicitarBoleto=(0,_graphqlTag2.default)(_templateObject6);

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getMaritialStatusList=exports.getGenderList=exports.getStates=exports.getReasonList=exports.zipCodeGet=exports.getCitiesFromState=exports.getTelephoneTypesList=exports.getBankList=undefined;// TODO Migrar para serviço graphQL
var getBankList=exports.getBankList=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var resp;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_apolloClient.gqlQuery)(_domain.gqlParametrizacao,{parametro:'bancos'});case 2:resp=_context.sent;return _context.abrupt('return',(0,_domain.transformBancos)(resp));case 4:case'end':return _context.stop();}}},_callee,this);}));return function getBankList(){return _ref.apply(this,arguments);};}();var getTelephoneTypesList=exports.getTelephoneTypesList=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var telefones;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_apolloClient.gqlQuery)(_telephone.gqlTiposTelefone);case 2:telefones=_context2.sent;return _context2.abrupt('return',(0,_telephone.transformTelefones)(telefones));case 4:case'end':return _context2.stop();}}},_callee2,this);}));return function getTelephoneTypesList(){return _ref2.apply(this,arguments);};}();var getCitiesFromState=exports.getCitiesFromState=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(data){var payload,response;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:payload={estado:data.state};_context3.next=3;return(0,_apolloClient.gqlQuery)(_address.gqlGetCitiesFromState,payload);case 3:response=_context3.sent;return _context3.abrupt('return',response.data.cidades);case 5:case'end':return _context3.stop();}}},_callee3,this);}));return function getCitiesFromState(_x){return _ref3.apply(this,arguments);};}();var zipCodeGet=exports.zipCodeGet=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(data){var payload,response;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:payload={cep:data.zip_code};_context4.next=3;return(0,_apolloClient.gqlQuery)(_address.gqlSearchAddress,payload);case 3:response=_context4.sent;return _context4.abrupt('return',response.data.cep);case 5:case'end':return _context4.stop();}}},_callee4,this);}));return function zipCodeGet(_x2){return _ref4.apply(this,arguments);};}();// TODO Migrar para grapqhQL quando serviço for implementado
var getReasonList=exports.getReasonList=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(){var data;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:data=[{chave:'PARABRISA_QUEBRADO',cobrar:false,descricao:'Parabrisa quebrado'},{chave:'ERRO_LEITURA_TAG',cobrar:false,descricao:'Erro de leitura da VeloeTag'},{chave:'EXTRAVIO_TAG',cobrar:true,descricao:'Perdi a VeloeTag',valor:'34.9'},{chave:'ROUBO_VEICULO',cobrar:false,descricao:'Fui roubado'},{chave:'VENDA_VEICULO',cobrar:true,descricao:'Venda do veículo',valor:'34.9'},{chave:'OUTRO',cobrar:true,descricao:'Outro motivo',valor:'34.9'}];return _context5.abrupt('return',data);case 2:case'end':return _context5.stop();}}},_callee5,this);}));return function getReasonList(){return _ref5.apply(this,arguments);};}();var getStates=exports.getStates=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(){var response;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return(0,_apolloClient.gqlQuery)(_address.gqlGetStates);case 2:response=_context6.sent;return _context6.abrupt('return',response.data.estados);case 4:case'end':return _context6.stop();}}},_callee6,this);}));return function getStates(){return _ref6.apply(this,arguments);};}();var getGenderList=exports.getGenderList=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(){var resp;return regeneratorRuntime.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return(0,_apolloClient.gqlQuery)(_domain.gqlSexos);case 2:resp=_context7.sent;return _context7.abrupt('return',(0,_domain.transformSexos)(resp));case 4:case'end':return _context7.stop();}}},_callee7,this);}));return function getGenderList(){return _ref7.apply(this,arguments);};}();var getMaritialStatusList=exports.getMaritialStatusList=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(){var resp;return regeneratorRuntime.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.next=2;return(0,_apolloClient.gqlQuery)(_domain.gqlEstadosCivis);case 2:resp=_context8.sent;return _context8.abrupt('return',(0,_domain.transformEstadosCivis)(resp));case 4:case'end':return _context8.stop();}}},_callee8,this);}));return function getMaritialStatusList(){return _ref8.apply(this,arguments);};}();var _apolloClient=__webpack_require__(42);var _telephone=__webpack_require__(1351);var _address=__webpack_require__(556);var _domain=__webpack_require__(1352);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.postBraspagCard=exports.getBrasPagAccessToken=exports.changeRecharge=exports.getPaymentInfo=exports.getRechargeValues=exports.createRecharge=undefined;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var createRecharge=exports.createRecharge=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(accountPlanId,value,paymentMethod,type){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_apolloClient.gqlMutate)(_recharges.gqlInserirRecarga,{conta:accountPlanId,valor:value,atividade:atividadeMap[type],formaPagamento:formaPagamentoMap[paymentMethod],canal:'site'});case 2:case'end':return _context.stop();}}},_callee,this);}));return function createRecharge(_x,_x2,_x3,_x4){return _ref.apply(this,arguments);};}();var getRechargeValues=exports.getRechargeValues=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(accountPlanId){var gqlResp;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_apolloClient.gqlQuery)(_recharges.gqlValoresRecarga,{idConta:accountPlanId});case 2:gqlResp=_context2.sent;return _context2.abrupt('return',(0,_recharges.transformValoresRecarga)(gqlResp));case 4:case'end':return _context2.stop();}}},_callee2,this);}));return function getRechargeValues(_x5){return _ref2.apply(this,arguments);};}();var getPaymentInfo=exports.getPaymentInfo=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(accountPlanId){var gqlResp;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return(0,_apolloClient.gqlQuery)(_recharges.gqlDadosPagamento,{conta:accountPlanId});case 2:gqlResp=_context3.sent;return _context3.abrupt('return',(0,_recharges.transformDadosPagamento)(gqlResp));case 4:case'end':return _context3.stop();}}},_callee3,this);}));return function getPaymentInfo(_x6){return _ref3.apply(this,arguments);};}();var changeRecharge=exports.changeRecharge=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(accountPlanId,valorRecarga){return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return(0,_apolloClient.gqlMutate)(_recharges.gqlEditarValorRecarga,{conta:accountPlanId,valor:valorRecarga});case 2:case'end':return _context4.stop();}}},_callee4,this);}));return function changeRecharge(_x7,_x8){return _ref4.apply(this,arguments);};}();var getBrasPagAccessToken=exports.getBrasPagAccessToken=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(){var _ref6,accessTokenBrasPag;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return(0,_apolloClient.gqlQuery)(_recharges.gqlAccessTokenBrasPag);case 2:_ref6=_context5.sent;accessTokenBrasPag=_ref6.data.accessTokenBrasPag;return _context5.abrupt('return',{data:accessTokenBrasPag});case 5:case'end':return _context5.stop();}}},_callee5,this);}));return function getBrasPagAccessToken(){return _ref5.apply(this,arguments);};}();var postBraspagCard=exports.postBraspagCard=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(HolderName,RawNumber,Expiration,SecurityCode,AccessToken){var headers;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:headers={Accept:'application/json','Content-Type':'application/x-www-form-urlencoded'};return _context6.abrupt('return',_index2.default.post(_constants.API_BRASPAG_CARD_URL,_qs2.default.stringify({HolderName:HolderName,RawNumber:RawNumber,Expiration:normalizeValidade(Expiration),SecurityCode:SecurityCode,AccessToken:AccessToken}),{headers:headers}));case 2:case'end':return _context6.stop();}}},_callee6,this);}));return function postBraspagCard(_x9,_x10,_x11,_x12,_x13){return _ref7.apply(this,arguments);};}();var _apolloClient=__webpack_require__(42);var _index=__webpack_require__(526);var _index2=_interopRequireDefault(_index);var _qs=__webpack_require__(340);var _qs2=_interopRequireDefault(_qs);var _constants=__webpack_require__(149);var _recharges=__webpack_require__(355);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var formaPagamentoMap={credit:'CARTAO_DE_CREDITO',debit:'DEBITO_EM_CONTA',bankSlip:'BOLETO'};var atividadeMap={manual:'RECARGA_MANUAL',auto:'RECARGA_AUTOMATICA'};var normalizeValidade=function normalizeValidade(src){var _src$split=src.split('/'),_src$split2=_slicedToArray(_src$split,2),mes=_src$split2[0],ano=_src$split2[1];if(!mes||!ano||![2,4].includes(ano.length))throw new Error('Data de validade inválida');if(ano.length===2){ano='20'+ano;}return mes+'/'+ano;};

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.inactiveIdentifier=exports.replaceIdentifier=exports.newIdentifier=exports.activateIdentifier=exports.getVehiclesCategory=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var getVehiclesCategory=exports.getVehiclesCategory=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(categoria){var payload,response;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:payload={categoria:categoria};_context.next=3;return(0,_apolloClient.gqlQuery)(_vehicles.gqlGetVehiclesCategory,payload);case 3:response=_context.sent;return _context.abrupt('return',response.data.consultaCategorias);case 5:case'end':return _context.stop();}}},_callee,this);}));return function getVehiclesCategory(_x){return _ref.apply(this,arguments);};}();var activateIdentifier=exports.activateIdentifier=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(data){var _this=this;var payload,_ref3,respData,error;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:payload={placa:data.plate,categoria:data.typeCar==='carro-passeio'||data.typeCar==='carro-utilitario'?'DOIS_EIXOS_RODAGEM_SIMPLES':data.axis,id:data.accountId,tipoProduto:data.type==='pre'?'PRE_PAGO':'POS_PAGO',codIdentificador:data.identifier||'',tipoIdentificador:'TAG'};_context3.next=3;return(0,_apolloClient.gqlMutate)(_vehicles.gqlActivateIdentification,payload);case 3:_ref3=_context3.sent;respData=_ref3.data;if(!(respData&&respData.identificadorAtivar.error&&respData.identificadorAtivar.error[0])){_context3.next=9;break;}error=new Error('Erro ao ativa identificador');error.json=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:return _context2.abrupt('return',respData.identificadorAtivar.error[0]);case 1:case'end':return _context2.stop();}}},_callee2,_this);}));throw error;case 9:return _context3.abrupt('return',_extends({status:200},respData));case 10:case'end':return _context3.stop();}}},_callee3,this);}));return function activateIdentifier(_x2){return _ref2.apply(this,arguments);};}();var newIdentifier=exports.newIdentifier=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(data){var payload,response;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:payload={id:data.codigoConta,endereco:{cep:data.endereco.cep,logradouro:data.endereco.logradouro,numero:data.endereco.numero,complemento:data.endereco.complemento,bairro:data.endereco.bairro,uf:data.endereco.uf,cidade:data.endereco.cidade},quantidadeIdentificadores:Number(data.quantidadeIdentificadores)};_context4.next=3;return(0,_apolloClient.gqlMutate)(_vehicles.gqlNewIdentifier,payload);case 3:response=_context4.sent;return _context4.abrupt('return',response);case 5:case'end':return _context4.stop();}}},_callee4,this);}));return function newIdentifier(_x3){return _ref5.apply(this,arguments);};}();var replaceIdentifier=exports.replaceIdentifier=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(data){var _this2=this;var payload,response,feedback,errorFeedback,err;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:payload=_extends({codigoConta:data.codigoConta,codigoIdentificador:data.codigoIdentificador,motivoInativacao:data.motivoInativacaoIdentificador,motivoDescricao:data.motivoInativacaoIdentificadorDescricao,novoCodigo:data.novoCodigoIdentificador},data.endereco);_context6.next=3;return(0,_apolloClient.gqlMutate)(_vehicles.gqlSubstituirIdentificador,payload);case 3:response=_context6.sent;feedback=response.data.identificadorSubstituir;if(!(feedback.error.length>0)){_context6.next=10;break;}errorFeedback={title:feedback.error[0].codigo,message:feedback.error[0].message};err=new Error('Erro ao bloquear VeloeTag');err.json=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(){return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:return _context5.abrupt('return',errorFeedback);case 1:case'end':return _context5.stop();}}},_callee5,_this2);}));throw err;case 10:return _context6.abrupt('return',feedback);case 11:case'end':return _context6.stop();}}},_callee6,this);}));return function replaceIdentifier(_x4){return _ref6.apply(this,arguments);};}();var inactiveIdentifier=exports.inactiveIdentifier=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(data){var payload,response;return regeneratorRuntime.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:payload={quantidadeIdentificadores:1,codigoIdentificador:data.codigoIdentificador,motivoInativacaoIdentificador:data.motivoInativacaoIdentificador,motivoInativacaoIdentificadorDescricao:data.motivoInativacaoIdentificadorDescricao,id:data.codigoConta};_context7.next=3;return(0,_apolloClient.gqlMutate)(_vehicles.gqlDesabilitarIdentificador,payload);case 3:response=_context7.sent;return _context7.abrupt('return',{result:response.data.identificadorInativar.result});case 5:case'end':return _context7.stop();}}},_callee7,this);}));return function inactiveIdentifier(_x5){return _ref8.apply(this,arguments);};}();var _apolloClient=__webpack_require__(42);var _vehicles=__webpack_require__(94);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(19)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var ptBr = moment.defineLocale('pt-br', {
    months : 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
    monthsShort : 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
    weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D [de] MMMM [de] YYYY',
        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
    },
    calendar : {
        sameDay: '[Hoje às] LT',
        nextDay: '[Amanhã às] LT',
        nextWeek: 'dddd [às] LT',
        lastDay: '[Ontem às] LT',
        lastWeek: function () {
            return (this.day() === 0 || this.day() === 6) ?
                '[Último] dddd [às] LT' : // Saturday + Sunday
                '[Última] dddd [às] LT'; // Monday - Friday
        },
        sameElse: 'L'
    },
    relativeTime : {
        future : 'em %s',
        past : '%s atrás',
        s : 'poucos segundos',
        ss : '%d segundos',
        m : 'um minuto',
        mm : '%d minutos',
        h : 'uma hora',
        hh : '%d horas',
        d : 'um dia',
        dd : '%d dias',
        M : 'um mês',
        MM : '%d meses',
        y : 'um ano',
        yy : '%d anos'
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal : '%dº'
});

return ptBr;

})));


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE = 19;

function verification(isValid, isPotentiallyValid, isCurrentYear) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    isCurrentYear: isCurrentYear || false
  };
}

function expirationYear(value, maxElapsedYear) {
  var currentFirstTwo, currentYear, firstTwo, len, twoDigitYear, valid, isCurrentYear;

  maxElapsedYear = maxElapsedYear || DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE;

  if (typeof value !== 'string') {
    return verification(false, false);
  }
  if (value.replace(/\s/g, '') === '') {
    return verification(false, true);
  }
  if (!/^\d*$/.test(value)) {
    return verification(false, false);
  }

  len = value.length;

  if (len < 2) {
    return verification(false, true);
  }

  currentYear = new Date().getFullYear();

  if (len === 3) {
    // 20x === 20x
    firstTwo = value.slice(0, 2);
    currentFirstTwo = String(currentYear).slice(0, 2);
    return verification(false, firstTwo === currentFirstTwo);
  }

  if (len > 4) {
    return verification(false, false);
  }

  value = parseInt(value, 10);
  twoDigitYear = Number(String(currentYear).substr(2, 2));

  if (len === 2) {
    isCurrentYear = twoDigitYear === value;
    valid = value >= twoDigitYear && value <= twoDigitYear + maxElapsedYear;
  } else if (len === 4) {
    isCurrentYear = currentYear === value;
    valid = value >= currentYear && value <= currentYear + maxElapsedYear;
  }

  return verification(valid, valid, isCurrentYear);
}

module.exports = expirationYear;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/templates/TemplateLayout/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactTransitionGroup=__webpack_require__(363);var _actions=__webpack_require__(13);var _Header=__webpack_require__(176);var _Header2=_interopRequireDefault(_Header);var _Submenu=__webpack_require__(248);var _Submenu2=_interopRequireDefault(_Submenu);var _FooterSmall=__webpack_require__(249);var _FooterSmall2=_interopRequireDefault(_FooterSmall);var _PageLoader=__webpack_require__(88);var _PageLoader2=_interopRequireDefault(_PageLoader);var _actions2=__webpack_require__(36);var _data=__webpack_require__(1669);var _routes=__webpack_require__(96);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TemplateLayout=function(_Component){_inherits(TemplateLayout,_Component);function TemplateLayout(props){_classCallCheck(this,TemplateLayout);var _this=_possibleConstructorReturn(this,(TemplateLayout.__proto__||Object.getPrototypeOf(TemplateLayout)).call(this,props));_this.state={};return _this;}_createClass(TemplateLayout,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.props.setLoading(true);if(!(this.props.account||{}).pc){_context.next=6;break;}_context.next=4;return this.props.getAccountPlansActivation();case 4:_context.next=8;break;case 6:_context.next=8;return this.props.getAccountPlans();case 8:_context.next=10;return this.props.getUser(this.props.account.accountType);case 10:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var hasChange=nextProps.location.pathname!==this.props.location.pathname;return hasChange;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,routes=_props.routes,location=_props.location,account=_props.account;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement('div',{className:'empty-template',__source:{fileName:_jsxFileName,lineNumber:47}},_react2.default.createElement(_Header2.default,{userCancelled:!account.active,__source:{fileName:_jsxFileName,lineNumber:48}}),account.active&&// <Submenu lastItemOnRight navItems={subnavLinks[account.accountType]} />
// Substituir a linha abaixo pela linha de cima, quando for voltar o menu de cancelar conta, e voltar os links no json do arquivo TemplateLayout/data.json
_react2.default.createElement(_Submenu2.default,{navItems:_data.subnavLinks[(this.props.account||{}).pc?'pc':account.accountType],__source:{fileName:_jsxFileName,lineNumber:52}})),_react2.default.createElement(_reactTransitionGroup.TransitionGroup,{__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_reactTransitionGroup.CSSTransition,{key:location.key,timeout:500,exit:false,classNames:'fade-in',__source:{fileName:_jsxFileName,lineNumber:58}},_react2.default.createElement(_PageLoader2.default,{__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:60}},routes.map(function(route){return _react2.default.createElement(_routes.RouteWithSubRoutes,_extends({user:_this2.state.user,key:route.path},route,{__source:{fileName:_jsxFileName,lineNumber:62}}));}))))),_react2.default.createElement('div',{className:'empty-template',__source:{fileName:_jsxFileName,lineNumber:68}},_react2.default.createElement(_FooterSmall2.default,{__source:{fileName:_jsxFileName,lineNumber:69}})));}}]);return TemplateLayout;}(_react.Component);var mapStateToProps=function mapStateToProps(state){return{account:state.reducer.account,user:state.reducer.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAccountPlans:function getAccountPlans(){return dispatch((0,_actions.fetchAccountPlans)());},getAccountPlansActivation:function getAccountPlansActivation(){return dispatch((0,_actions.fetchAccountPlansActivation)());},getUser:function getUser(userType){if(userType==='pf'){dispatch((0,_actions.fetchGetUser)());}else{dispatch((0,_actions.fetchGetBusinessUser)()).finally(function(){return dispatch((0,_actions2.setLoading)(false));});}},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(TemplateLayout);module.exports=exports['default'];

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(1495);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _TransitionGroup = __webpack_require__(1500);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(566);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.order = exports.flex = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = __webpack_require__(568);

var _propTypes = __webpack_require__(9);

var _tagHoc = __webpack_require__(1577);

var _tagHoc2 = _interopRequireDefault(_tagHoc);

var _propTypes2 = __webpack_require__(586);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _removeProps = __webpack_require__(1578);

var _removeProps2 = _interopRequireDefault(_removeProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flex = exports.flex = (0, _styledSystem.responsiveStyle)('flex');
var order = exports.order = (0, _styledSystem.responsiveStyle)('order');

var Tag = (0, _tagHoc2.default)(_removeProps2.default);
var Base = Tag('div');

var Box = (0, _styledComponents2.default)(Base)([], { boxSizing: 'border-box' }, _styledSystem.width, _styledSystem.space, flex, order);
Box.displayName = 'Box';

var responsivePropType = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string, _propTypes.array]);

Box.propTypes = Object.assign({}, _propTypes3.default, {
  flex: responsivePropType,
  order: responsivePropType
});

exports.default = Box;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(366);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 366 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 367 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(232);
var $export = __webpack_require__(67);
var redefine = __webpack_require__(573);
var hide = __webpack_require__(109);
var Iterators = __webpack_require__(153);
var $iterCreate = __webpack_require__(1508);
var setToStringTag = __webpack_require__(236);
var getPrototypeOf = __webpack_require__(575);
var ITERATOR = __webpack_require__(58)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(97);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 370 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(372)('keys');
var uid = __webpack_require__(235);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(50);
var global = __webpack_require__(87);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(232) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 373 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(366);
var TAG = __webpack_require__(58)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(374);
var ITERATOR = __webpack_require__(58)('iterator');
var Iterators = __webpack_require__(153);
module.exports = __webpack_require__(50).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 376 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1524);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1526);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(58);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(235)('meta');
var isObject = __webpack_require__(97);
var has = __webpack_require__(133);
var setDesc = __webpack_require__(75).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(132)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(87);
var core = __webpack_require__(50);
var LIBRARY = __webpack_require__(232);
var wksExt = __webpack_require__(378);
var defineProperty = __webpack_require__(75).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1533);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(377);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1569);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1573);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(377);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.UserDropdownInfo=exports.Logo=exports.Avatar=exports.VerticalSpacer=exports.HelpLink=exports.UserInfoContainer=exports.FlexContainer=exports.HeaderContainer=exports.HeaderWrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n        height: ',';\n        background: ',';\n    '],['\n        height: ',';\n        background: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        padding: ',' ',';\n        position: fixed;\n        height: ',';\n        top: 0;\n        left: 0;\n        right: 0;\n        z-index: 50;\n    '],['\n        padding: ',' ',';\n        position: fixed;\n        height: ',';\n        top: 0;\n        left: 0;\n        right: 0;\n        z-index: 50;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        width: 100%;\n    '],['\n        width: 100%;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _container=__webpack_require__(183);var _container2=_interopRequireDefault(_container);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var blueLink='\n    color: '+_colors.linkNavyBlue+';\n    font-family: \'Galano\';\n    font-size: '+(0,_rem2.default)('14px')+';\n';var HeaderWrapper=exports.HeaderWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__HeaderWrapper',componentId:'sc-tc7mx0-0'})(['',';'],_media2.default.small(_templateObject,(0,_rem2.default)('70px'),_colors.white));var HeaderContainer=exports.HeaderContainer=_styledComponents2.default.div.withConfig({displayName:'styles__HeaderContainer',componentId:'sc-tc7mx0-1'})(['',';align-items:center;display:flex;justify-content:space-between;padding:',' ',';background:',';',';'],_container2.default,(0,_rem2.default)('5px'),(0,_rem2.default)('65px'),_colors.white,_media2.default.small(_templateObject2,(0,_rem2.default)('20px'),(0,_rem2.default)('30px'),(0,_rem2.default)('70px')));var flexStyle='\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n';var FlexContainer=exports.FlexContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FlexContainer',componentId:'sc-tc7mx0-2'})(['',';',';'],flexStyle,_media2.default.small(_templateObject3));var UserInfoContainer=exports.UserInfoContainer=_styledComponents2.default.div.withConfig({displayName:'styles__UserInfoContainer',componentId:'sc-tc7mx0-3'})(['',' margin-left:',';'],flexStyle,(0,_rem2.default)('10px'));var HelpLink=exports.HelpLink=_styledComponents2.default.a.withConfig({displayName:'styles__HelpLink',componentId:'sc-tc7mx0-4'})(['cursor:pointer;margin:0 ',';text-decoration:none;',';'],(0,_rem2.default)('35px'),blueLink);var VerticalSpacer=exports.VerticalSpacer=_styledComponents2.default.div.withConfig({displayName:'styles__VerticalSpacer',componentId:'sc-tc7mx0-5'})(['background-color:',';height:',';opacity:0.1;width:',';'],_colors.separatorGrey,(0,_rem2.default)('77px'),(0,_rem2.default)('2px'));var Avatar=exports.Avatar=_styledComponents2.default.img.withConfig({displayName:'styles__Avatar',componentId:'sc-tc7mx0-6'})(['height:',';margin:0 ',' 0 ',';width:',';'],(0,_rem2.default)('50px'),(0,_rem2.default)('5px'),(0,_rem2.default)('15px'),(0,_rem2.default)('50px'));var Logo=exports.Logo='\n    height: '+(0,_rem2.default)('30px')+';\n    fill: '+_colors.linkNavyBlue+';\n    width: '+(0,_rem2.default)('74px')+';\n';var UserDropdownInfo=exports.UserDropdownInfo=_styledComponents2.default.div.withConfig({displayName:'styles__UserDropdownInfo',componentId:'sc-tc7mx0-7'})(['',' padding:',' 0;z-index:0;',';'],flexStyle,(0,_rem2.default)('20px'),function(props){return props.isOpen&&'\n        box-shadow: 0 '+(0,_rem2.default)('8px')+' '+(0,_rem2.default)('8px')+' 0 rgba(182, 193, 205, 0.66);\n    ';});

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DropdownContainer=exports.HeaderLabel=exports.DropdownArrow=exports.DropdownLabelContainer=exports.DropdownLabel=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DropdownLabel=exports.DropdownLabel=_styledComponents2.default.p.withConfig({displayName:'styles__DropdownLabel',componentId:'sc-1oq0ax8-0'})(['color:',';font-family:\'Galano\';font-size:',';margin:0;margin-right:',';min-width:',';user-select:none;'],_colors.linkNavyBlue,(0,_rem2.default)('14px'),(0,_rem2.default)('10px'),(0,_rem2.default)('60px'));var DropdownLabelContainer=exports.DropdownLabelContainer=_styledComponents2.default.div.withConfig({displayName:'styles__DropdownLabelContainer',componentId:'sc-1oq0ax8-1'})(['align-items:center;display:flex;position:relative;']);var DropdownArrow=exports.DropdownArrow='height: 5px; width: 10px; stroke: '+_colors.linkNavyBlue;var HeaderLabel=exports.HeaderLabel=_styledComponents2.default.p.withConfig({displayName:'styles__HeaderLabel',componentId:'sc-1oq0ax8-2'})(['color:',';font-family:OpenSans;font-size:',';letter-spacing:',';margin:0;text-transform:uppercase;',';'],_colors.lightGrey,(0,_rem2.default)('10px'),(0,_rem2.default)('0.8px'),function(props){return props.component==='profile'&&'\n        font-size: '+(0,_rem2.default)('12px')+';\n        letter-spacing: '+(0,_rem2.default)('1px')+';\n    ';});var DropdownContainer=exports.DropdownContainer=_styledComponents2.default.div.withConfig({displayName:'styles__DropdownContainer',componentId:'sc-1oq0ax8-3'})(['cursor:pointer;margin:0 ',' 0 ',';',';'],(0,_rem2.default)('15px'),(0,_rem2.default)('20px'),function(_ref){var isOpen=_ref.isOpen;return isOpen&&(0,_styledComponents.css)(['','{color:',';}svg{color:',';transform:rotate(180deg);}'],DropdownLabel,_colors.darkGrey,_colors.darkGrey);});

/***/ }),
/* 387 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/Home/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRouterDom=__webpack_require__(15);var _actions=__webpack_require__(13);var _styles=__webpack_require__(1676);var _data=__webpack_require__(1677);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Home=function Home(_ref){var loadUser=_ref.loadUser,history=_ref.history;history.push('/conta/login');return _react2.default.createElement(_styles.Main,{__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement(_reactHelmet2.default,{title:'Veloe',__source:{fileName:_jsxFileName,lineNumber:16}}),_react2.default.createElement('h1',{__source:{fileName:_jsxFileName,lineNumber:17}},'Hello Veloe'),_react2.default.createElement('ul',{__source:{fileName:_jsxFileName,lineNumber:18}},_data.profiles.map(function(profile,index){return _react2.default.createElement('li',{key:index,__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement('button',{onClick:function onClick(){return loadUser(profile,history);},__source:{fileName:_jsxFileName,lineNumber:21}},profile.description));})));};Home.displayName='Home';var mapDispatchToProps=function mapDispatchToProps(dispatch){return{loadUser:function loadUser(profile,history){if(!profile.login){history.push(profile.redirectTo);return;}if(profile.login){dispatch((0,_actions.fetchAuthentication)(profile.login,profile.password)).then(function(credentials){if(credentials.success){history.push(profile.redirectTo);}});}}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(null,mapDispatchToProps)(Home));module.exports=exports['default'];

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Text=exports.Container=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-e2ud55-0'})(['',';'],_content2.default);var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-e2ud55-1'})(['',' white-space:normal;color:',';'],_types.txt12OpenSans,_colors.darkGrey);

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.noSpecialCharacters=exports.cepMask=exports.validThruMask=exports.autoCorrectedExpireDatePipe=exports.accountDigitMask=exports.numberMask=exports.cvcMask=exports.creditCardMask=exports.dddMask=undefined;var _createAutoCorrectedDatePipe=__webpack_require__(1712);var _createAutoCorrectedDatePipe2=_interopRequireDefault(_createAutoCorrectedDatePipe);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var dddMask=exports.dddMask=function dddMask(value,previousValue){var onlyNums=value&&value.replace(/[^\d]/g,'');if(!value||previousValue&&value.length<previousValue.length){return onlyNums.slice(0,1);}if(onlyNums.length<2){return onlyNums;}return'('+onlyNums.slice(0,2)+')';};var amexMaskFormat=function amexMaskFormat(value){if(value.length<=4){return value;}if(value.length<=10){return value.slice(0,4)+' '+value.slice(4);}if(value<=15){return value.slice(0,4)+' '+value.slice(4,10)+' '+value.slice(10);}return value.slice(0,4)+' '+value.slice(4,10)+' '+value.slice(10,15);};var creditCardMask=exports.creditCardMask=function creditCardMask(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums[0]==='3'&&(onlyNums[1]==='4'||onlyNums[1]==='7')){return amexMaskFormat(onlyNums);}else{if(onlyNums.length<=4){return onlyNums;}if(onlyNums.length<=8){return onlyNums.slice(0,4)+' '+onlyNums.slice(4);}if(onlyNums.length<=12){return onlyNums.slice(0,4)+' '+onlyNums.slice(4,8)+' '+onlyNums.slice(8,12);}return onlyNums.slice(0,4)+' '+onlyNums.slice(4,8)+' '+onlyNums.slice(8,12)+'  '+onlyNums.slice(12,16);}};var cvcMask=exports.cvcMask=function cvcMask(value){var maxLength=arguments.length>1&&arguments[1]!==undefined?arguments[1]:3;if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');return''+onlyNums.slice(0,maxLength);};var numberMask=exports.numberMask=function numberMask(value,maxLength){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums.length<=maxLength){return onlyNums;}return''+onlyNums.slice(0,maxLength);};var accountDigitMask=exports.accountDigitMask=function accountDigitMask(value,maxLength){if(!value){return value;}var onlyNumsAndSpecialCharacters=value.replace(/[^\d|x|X]/g,'').toUpperCase();if(onlyNumsAndSpecialCharacters.length<=maxLength){return onlyNumsAndSpecialCharacters;}return''+onlyNumsAndSpecialCharacters.slice(0,maxLength);};var autoCorrectedExpireDatePipe=exports.autoCorrectedExpireDatePipe=(0,_createAutoCorrectedDatePipe2.default)('mm/yy');var validThruMask=exports.validThruMask=function validThruMask(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums.length<=2){return onlyNums;}return onlyNums.slice(0,2)+'/'+onlyNums.slice(2,6);};var cepMask=exports.cepMask=function cepMask(number){if(!number)return'';var newNumber=number.replace(/\D/g,'');newNumber=newNumber.substring(0,8);newNumber=newNumber.replace(/^(\d{5})(\d)/,'$1-$2');return newNumber;};var noSpecialCharacters=exports.noSpecialCharacters=function noSpecialCharacters(str){if(!str){return'';}return str.replace(/[^\w]|_/gi,'');};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/EditAddressForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _AddressFormSection=__webpack_require__(1731);var _AddressFormSection2=_interopRequireDefault(_AddressFormSection);var _AddressFormShippingSection=__webpack_require__(1734);var _AddressFormShippingSection2=_interopRequireDefault(_AddressFormShippingSection);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var EditAddressForm=function EditAddressForm(props){var initialValues=props.initialValues,handleSubmit=props.handleSubmit,onDelete=props.onDelete,saving=props.saving;var componectSection=window.location.href.includes('/perfil/editar-endereco')||window.location.href.includes('/perfil/endereco-comercial')?_AddressFormSection2.default:_AddressFormShippingSection2.default;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement(_reduxForm.FieldArray,{name:'address',component:componectSection,initialValues:initialValues.address,onDelete:onDelete,saving:saving,__source:{fileName:_jsxFileName,lineNumber:15}}));};exports.default=(0,_reduxForm.reduxForm)({form:'editAddress',destroyOnUnmount:false,enableReinitialize:true})(EditAddressForm);module.exports=exports['default'];

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.parseCities=parseCities;exports.parseStates=parseStates;function parseCities(list){var result=[];for(var i=0,len=list.length;i<len;i+=1){result.push({label:list[i].descricao,value:list[i].descricao});}return result;}function parseStates(list){var result=[];for(var i=0,len=list.length;i<len;i+=1){result.push({label:list[i].uf,value:list[i].uf});}return result;}

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ChangePasswordForm/index.js';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _PasswordInput=__webpack_require__(599);var _PasswordInput2=_interopRequireDefault(_PasswordInput);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _StepBox=__webpack_require__(1759);var _StepBox2=_interopRequireDefault(_StepBox);var _aleloLogic=__webpack_require__(12);var _validatePassword=__webpack_require__(1761);var _data=__webpack_require__(602);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var renderPasswordInput=function renderPasswordInput(props){var _props$meta=props.meta,touched=_props$meta.touched,error=_props$meta.error;var strength=void 0;var errorMessage=void 0;if((typeof error==='undefined'?'undefined':_typeof(error))==='object'){var passwordMaxStrength=8;var errorList=Object.keys(error);strength=passwordMaxStrength/(errorList.length+1);errorMessage=_data.errors[errorList[0]];}else if(typeof error==='string'){errorMessage=error;}return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement(_PasswordInput2.default,_extends({},props.input,{value:_aleloLogic.utils.newDefaultPassword(props.input.value),label:props.label,placeholder:props.placeholder,disabled:props.disabled,loading:props.loading,maxlength:props.maxlength,passwordStrength:touched&&props.passwordStrength&&strength,errorMessage:touched&&!!errorMessage,passwordMessage:touched&&(strength>=8&&_data.passwordStrength.high||errorMessage),__source:{fileName:_jsxFileName,lineNumber:30}})));};var ChangePasswordForm=function(_Component){_inherits(ChangePasswordForm,_Component);function ChangePasswordForm(props){_classCallCheck(this,ChangePasswordForm);var _this=_possibleConstructorReturn(this,(ChangePasswordForm.__proto__||Object.getPrototypeOf(ChangePasswordForm)).call(this,props));_this.state={stepBoxErrors:{}};return _this;}_createClass(ChangePasswordForm,[{key:'render',value:function render(){var _props=this.props,asyncValidating=_props.asyncValidating,handleSubmit=_props.handleSubmit,hasCurrentPasswordField=_props.hasCurrentPasswordField,valid=_props.valid;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:58}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_gridStyled.Box,{width:[1,6/12],__source:{fileName:_jsxFileName,lineNumber:60}},hasCurrentPasswordField&&_react2.default.createElement(_gridStyled.Box,{mb:3,__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement(_reduxForm.Field,{component:renderPasswordInput,label:_data.labels.current,placeholder:_data.placeholders.current,name:'currentPassword',loading:asyncValidating,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:63}})),_react2.default.createElement(_gridStyled.Box,{mb:3,__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement(_reduxForm.Field,{component:renderPasswordInput,label:_data.labels.new,placeholder:_data.placeholders.new,passwordStrength:true,name:'newPassword',setStepBoxErrors:true,isRequired:true,maxlength:'14',__source:{fileName:_jsxFileName,lineNumber:74}})),_react2.default.createElement(_gridStyled.Box,{mb:3,__source:{fileName:_jsxFileName,lineNumber:85}},_react2.default.createElement(_reduxForm.Field,{component:renderPasswordInput,label:_data.labels.confirm,placeholder:_data.placeholders.confirm,name:'confirmPassword',isRequired:true,maxlength:'14',__source:{fileName:_jsxFileName,lineNumber:86}}))),_react2.default.createElement(_gridStyled.Box,{mb:[38,0],ml:[0,60],width:[1,3/10],__source:{fileName:_jsxFileName,lineNumber:96}},_react2.default.createElement(_StepBox2.default,{title:_data.stepBox.title,steps:[{text:_data.stepBox.newPasswordLength},{text:_data.stepBox.upperLetterNeeded},{text:_data.stepBox.lowerLetterNeeded},{text:_data.stepBox.numberNeeded},{text:_data.stepBox.especialNeeded}],__source:{fileName:_jsxFileName,lineNumber:97}}))),_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:119}},_react2.default.createElement(_Button2.default,{type:'submit',text:_data.buttonText,disabled:!valid,__source:{fileName:_jsxFileName,lineNumber:120}})));}}]);return ChangePasswordForm;}(_react.Component);exports.default=(0,_reduxForm.reduxForm)({form:'changeUserPasswordData',validate:_validatePassword.validatePassword,asyncBlurFields:['currentPassword'],destroyOnUnmount:true})(ChangePasswordForm);module.exports=exports['default'];

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/alterarSenha.e9a977b5.png";

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.StatusWrapper=exports.ListItemText=exports.ListItem=exports.NoContentText=exports.EditHeader=exports.Wrapper=exports.Paragraph=exports.Title=exports.CustomContent=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CustomContent=exports.CustomContent=(0,_styledComponents2.default)(_Content2.default).withConfig({displayName:'styles__CustomContent',componentId:'sc-1vye6ef-0'})(['margin-bottom:',';'],(0,_rem2.default)('40px'));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-1vye6ef-1'})(['',';margin-top:',';margin-bottom:',';color:',';'],_types.title32GalanoBold,(0,_rem2.default)('30px'),(0,_rem2.default)('10px'),_colors.darkBlue);var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-1vye6ef-2'})(['',';margin-bottom:',';color:',';'],_types.txt16OpenSans,(0,_rem2.default)('10px'),_colors.darkBlue);var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-1vye6ef-3'})(['border-bottom:',' solid ',';width:100%;'],(0,_rem2.default)('1px'),_colors.lightGray);var EditHeader=exports.EditHeader=_styledComponents2.default.div.withConfig({displayName:'styles__EditHeader',componentId:'sc-1vye6ef-4'})(['padding:',' 0;text-transform:uppercase;',';line-height:1.67;color:',';letter-spacing:1px;'],(0,_rem2.default)('12px'),_types.txt12OpenSans,_colors.blueGray);var NoContentText=exports.NoContentText=_styledComponents2.default.span.withConfig({displayName:'styles__NoContentText',componentId:'sc-1vye6ef-5'})(['',';letter-spacing:0;color:',';'],_types.title20GalanoBold,_colors.darkGrey);var ListItem=exports.ListItem=_styledComponents2.default.div.withConfig({displayName:'styles__ListItem',componentId:'sc-1vye6ef-6'})(['padding:',' 0;position:relative;overflow:hidden;&:nth-child(2n + 1){background-color:',';}',';'],(0,_rem2.default)('15px'),_colors.ghostWhite,function(_ref){var isActived=_ref.isActived;return isActived&&(0,_styledComponents.css)(['outline:1px solid ',';'],_colors.lightBlue);});var ListItemText=exports.ListItemText=_styledComponents2.default.span.withConfig({displayName:'styles__ListItemText',componentId:'sc-1vye6ef-7'})(['',';color:',';font-weight:',';'],_types.txt12OpenSans,function(_ref2){var color=_ref2.color;return color||_colors.darkGrey;},function(_ref3){var bold=_ref3.bold;return bold?'bold':'regular';});var StatusWrapper=exports.StatusWrapper=_styledComponents2.default.span.withConfig({displayName:'styles__StatusWrapper',componentId:'sc-1vye6ef-8'})(['color:',';&:before{background:',';border-radius:50%;content:\'\';position:absolute;top:9px;left:0px;height:6px;width:6px;}display:flex;flex-direction:column;padding-left:10px;position:relative;'],function(_ref4){var active=_ref4.active;return active?_colors.darkBlue:_colors.red;},function(_ref5){var active=_ref5.active;return active?_colors.lightOlive:_colors.red;});

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/login.c3683c21.png";

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logoVeloe.236076e7.png";

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/LoadMore/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(1934);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LoadMore=function LoadMore(_ref){var onClick=_ref.onClick,w=_ref.w,loadingMore=_ref.loadingMore;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:5}},loadingMore?_react2.default.createElement(_styles.LabelLoading,{__source:{fileName:_jsxFileName,lineNumber:7}},'carregando'):_react2.default.createElement(_styles.Container,{width:w+'px',className:'load-more-container',__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement(_styles.ItemIcon,{id:'btnLoadMore',onClick:onClick,__source:{fileName:_jsxFileName,lineNumber:10}},_react2.default.createElement('img',{src:__webpack_require__(1935),alt:'',__source:{fileName:_jsxFileName,lineNumber:11}})),_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:13}},'Carregar mais')));};exports.default=LoadMore;module.exports=exports['default'];

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;

var _DateUtils = __webpack_require__(158);

var _Helpers = __webpack_require__(262);

/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, _DateUtils.isSameDay)(day, mod);
    }
    if ((0, _Helpers.isRangeOfDates)(mod)) {
      return (0, _DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after) {
      return (0, _DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
//# sourceMappingURL=ModifiersUtils.js.map

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icons/SearchIcon.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function SearchIcon(){return _react2.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"22",height:"22",fill:"none",viewBox:"0 0 22 22",__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{fill:"#24206B",fillRule:"evenodd",d:"M9.223 2.095c-3.906 0-7.083 3.177-7.083 7.082s3.177 7.081 7.083 7.081 7.082-3.176 7.082-7.081c0-3.905-3.176-7.082-7.082-7.082zm0 16.176a9.041 9.041 0 01-6.432-2.663A9.034 9.034 0 01.126 9.177c0-2.43.947-4.713 2.665-6.431A9.041 9.041 0 019.223.082c2.43 0 4.714.946 6.432 2.664a9.034 9.034 0 012.664 6.43c0 2.43-.946 4.714-2.664 6.432a9.036 9.036 0 01-6.432 2.663zm-4.245-8.07c-.555 0-1.005-.45-1.005-1.007a5.238 5.238 0 015.233-5.233 1.006 1.006 0 010 2.013 3.225 3.225 0 00-3.222 3.22c0 .556-.45 1.007-1.006 1.007zm15.848 11.66c-.26 0-.516-.1-.713-.296l-3.344-3.345a1.005 1.005 0 111.422-1.423l3.344 3.345a1.004 1.004 0 01-.71 1.718z",clipRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:6}}));}exports.default=SearchIcon;module.exports=exports["default"];

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/traffic-signal-error.528f38b6.svg";

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SearchForm=exports.searchFilter=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/SearchForm/index.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};// Assets
// Components(styles)
// Util
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _icSearch=__webpack_require__(627);var _icSearch2=_interopRequireDefault(_icSearch);var _styles=__webpack_require__(2017);var _textSlug=__webpack_require__(184);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var searchFilter=exports.searchFilter=function searchFilter(searchValue,list){if(searchValue&&searchValue.length>2){return list.filter(function(_ref){var codIdentificador=_ref.codIdentificador,veiculo=_ref.veiculo,informacoesGerenciais=_ref.informacoesGerenciais;var onlyChars=(0,_textSlug.removeSpecialChars)(searchValue);return codIdentificador.includes(onlyChars.toUpperCase())||veiculo.placa.includes(onlyChars.toUpperCase())||informacoesGerenciais&&informacoesGerenciais.map(function(inf){return _extends({},inf,{descricaoAtual:(0,_textSlug.removeSpecialChars)(inf.descricaoAtual)});}).some(function(inf){return inf.descricaoAtual.includes(onlyChars);});});}return list;};var SearchForm=exports.SearchForm=function SearchForm(props){var _ref2=props||{},_ref2$onSearch=_ref2.onSearch,onSearch=_ref2$onSearch===undefined?null:_ref2$onSearch,width=_ref2.width;var handleSearch=function handleSearch(e){if(onSearch){e.preventDefault();e.stopPropagation();onSearch();}};return _react2.default.createElement(_styles.Form,{width:width,__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement(_styles.SearchField,_extends({type:'text',name:'search'},props,{id:'inputBuscaIdentificador',__source:{fileName:_jsxFileName,lineNumber:39}})),_react2.default.createElement(_styles.SearchButton,{onClick:handleSearch,id:'btnBuscaIdentificador',__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_styles.SearchImg,{src:_icSearch2.default,alt:'Search Image',__source:{fileName:_jsxFileName,lineNumber:41}})));};exports.default=SearchForm;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Option/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(2043);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// import Mark from 'app/components/Icons/Mark'
var Option=function Option(_ref){var active=_ref.active,value=_ref.value,setOption=_ref.setOption,icon=_ref.icon,description=_ref.description,children=_ref.children,notGray=_ref.notGray,props=_objectWithoutProperties(_ref,['active','value','setOption','icon','description','children','notGray']);return _react2.default.createElement(_styles.Wrap,_extends({active:active,onClick:function onClick(){return setOption(value);}},props,{__source:{fileName:_jsxFileName,lineNumber:7}}),_react2.default.createElement(_styles.Icon,{active:active,notGray:notGray,__source:{fileName:_jsxFileName,lineNumber:8}},icon),_react2.default.createElement(_styles.Description,{active:active,__source:{fileName:_jsxFileName,lineNumber:11}},description));};exports.default=Option;module.exports=exports['default'];

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateEmpty=__webpack_require__(112);var _TemplateEmpty2=_interopRequireDefault(_TemplateEmpty);var _Login=__webpack_require__(2089);var _Login2=_interopRequireDefault(_Login);var _ForgotPassword=__webpack_require__(2118);var _ForgotPassword2=_interopRequireDefault(_ForgotPassword);var _CreateNewPassword=__webpack_require__(2124);var _CreateNewPassword2=_interopRequireDefault(_CreateNewPassword);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/conta',component:_TemplateEmpty2.default,routes:[{path:'/conta/login',exact:true,component:_Login2.default},{path:'/conta/esqueci-a-senha',exact:true,component:_ForgotPassword2.default},{path:'/conta/esqueci-a-senha/:token',exact:true,component:_CreateNewPassword2.default}]};module.exports=exports['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = {"forgotpassword":"Esqueceu sua senha?","labels":{"bank":"informe seu banco","agency":"agência","account":"conta corrente","accountDigit":"Dígito","cardNumber":"Número do cartão de crédito","yourName":"Nome impresso no cartao","month":"Mês","year":"Ano","validThru":"Validade","securityCode":"código de segurança","buttons":{"save":"Alterar forma de pagamento","saving":"Salvando","cancel":"Cancelar","back":"Voltar"},"placeholder":{"bank":"Selecione","account":"00000","agency":"0000","accountDigit":"0","validThru":"mm/aaaa","cardNumber":"0000 1111 2222 3333","yourName":"Digite aqui","securityCode":"000","amexSecurityCode":"0000"},"radiosButtons":{"credit":"Cartão de crédito","debit":"Débito em conta"}},"banks":[{"value":"","label":"Selecione","disabled":true,"hidden":true},{"value":"Bradesco","label":"Bradesco"},{"value":"Banco do Brasil","label":"Banco do Brasil"},{"value":"Banco Safra","label":"Banco Safra"},{"value":"Itaú","label":"Itaú"},{"value":"Santander","label":"Santander"}]}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Logo=exports.VeloeLogo=exports.TelephoneNumber=exports.SocialIcons=exports.NavigationText=exports.NavigationLabel=exports.NavigationContent=exports.NavigationColumn=exports.NavigationBottomItem=exports.NavigationLink=exports.LogoSocial=exports.FooterNavigation=exports.FooterContainer=exports.CardsFlags=exports.CardFlag=exports.CardsContainer=exports.AppsLinkContainer=exports.AppIcon=undefined;var _templateObject=_taggedTemplateLiteral(['\n      flex-direction: column-reverse;\n      padding: 30px 50px;\n  '],['\n      flex-direction: column-reverse;\n      padding: 30px 50px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n        margin-top: 30px;\n    '],['\n        margin-top: 30px;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var AppIcon=exports.AppIcon='height: 38px; width: 110px; margin: 17px 20px 0 0;';var AppsLinkContainer=exports.AppsLinkContainer=_styledComponents2.default.div.withConfig({displayName:'styles__AppsLinkContainer',componentId:'sc-115u8og-0'})(['display:flex;']);var CardsContainer=exports.CardsContainer=_styledComponents2.default.div.withConfig({displayName:'styles__CardsContainer',componentId:'sc-115u8og-1'})(['align-items:center;background-color:',';color:',';display:flex;font-size:',';justify-content:space-between;letter-spacing:',';padding:30px 160px;',';'],_colors.deepPurple,_colors.greyBlue,(0,_rem2.default)('12px'),(0,_rem2.default)('0.8px'),_media2.default.small(_templateObject));var CardFlag=exports.CardFlag='height: 30px; width: 50px; margin-right: 10px';var CardsFlags=exports.CardsFlags=_styledComponents2.default.div.withConfig({displayName:'styles__CardsFlags',componentId:'sc-115u8og-2'})(['display:flex;']);var FooterContainer=exports.FooterContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FooterContainer',componentId:'sc-115u8og-3'})(['font-family:\'OpenSans\';overflow:hidden;width:100%;']);var FooterNavigation=exports.FooterNavigation=_styledComponents2.default.div.withConfig({displayName:'styles__FooterNavigation',componentId:'sc-115u8og-4'})(['align-items:center;background-color:',';color:',';display:flex;justify-content:space-between;padding:50px 160px;'],_colors.linkNavyBlue,_colors.paleBlue);var LogoSocial=exports.LogoSocial=_styledComponents2.default.div.withConfig({displayName:'styles__LogoSocial',componentId:'sc-115u8og-5'})(['align-items:center;display:flex;flex-direction:column;margin-right:80px;']);var NavigationLink=exports.NavigationLink=_styledComponents2.default.a.withConfig({displayName:'styles__NavigationLink',componentId:'sc-115u8og-6'})(['cursor:pointer;font-size:',';font-weight:600;letter-spacing:',';margin-bottom:16px;&:last-child{margin-bottom:0;}'],(0,_rem2.default)('12px'),(0,_rem2.default)('0.8px'));var NavigationBottomItem=exports.NavigationBottomItem=_styledComponents2.default.div.withConfig({displayName:'styles__NavigationBottomItem',componentId:'sc-115u8og-7'})(['display:flex;flex-direction:column;margin-top:48px;','{margin-bottom:0;}'],NavigationLink);var NavigationColumn=exports.NavigationColumn=_styledComponents2.default.div.withConfig({displayName:'styles__NavigationColumn',componentId:'sc-115u8og-8'})(['display:flex;flex-direction:column;min-width:240px;']);var NavigationContent=exports.NavigationContent=_styledComponents2.default.div.withConfig({displayName:'styles__NavigationContent',componentId:'sc-115u8og-9'})(['display:flex;justify-content:space-between;']);var NavigationLabel=exports.NavigationLabel=_styledComponents2.default.div.withConfig({displayName:'styles__NavigationLabel',componentId:'sc-115u8og-10'})(['']);var NavigationText=exports.NavigationText=_styledComponents2.default.span.withConfig({displayName:'styles__NavigationText',componentId:'sc-115u8og-11'})(['font-size:',';line-height:1.5;',';',';'],(0,_rem2.default)('12px'),function(_ref){var marginOnSmall=_ref.marginOnSmall;return marginOnSmall&&_media2.default.small(_templateObject2);},function(props){return props.short&&'\n      max-width: '+(0,_rem2.default)('200px')+';\n  ';});var SocialIcons=exports.SocialIcons='height: 24px; width: 58px;';var TelephoneNumber=exports.TelephoneNumber=_styledComponents2.default.span.withConfig({displayName:'styles__TelephoneNumber',componentId:'sc-115u8og-12'})(['color:',';font-family:\'Galano\';font-size:',';font-weight:600;margin-top:5px;'],_colors.white,(0,_rem2.default)('24px'));var VeloeLogo=exports.VeloeLogo='fill: '+_colors.white+'; height: 41px; width: 99px; margin-bottom: 15px;';var Logo=exports.Logo='height: 30px; width: 74px;';

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = {"labels":{"fileNumber":"Sequencial","fileType":"Tipo de arquivo","submitButton":"Solicitar"},"fileTypes":[{"value":"TRT","label":"TRT"},{"value":"TRF","label":"TRF"},{"value":"TGT","label":"TGT"},{"value":"TAG","label":"TAG"},{"value":"NEL","label":"NEL"}],"simpleForm":{"title":"Solicitar lista","subtitle":"Solicite uma lista atualizada."}}

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(678);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._40 = 0;
  this._65 = 0;
  this._55 = null;
  this._72 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._37 = null;
Promise._87 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._65 === 3) {
    self = self._55;
  }
  if (Promise._37) {
    Promise._37(self);
  }
  if (self._65 === 0) {
    if (self._40 === 0) {
      self._40 = 1;
      self._72 = deferred;
      return;
    }
    if (self._40 === 1) {
      self._40 = 2;
      self._72 = [self._72, deferred];
      return;
    }
    self._72.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._65 === 1) {
        resolve(deferred.promise, self._55);
      } else {
        reject(deferred.promise, self._55);
      }
      return;
    }
    var ret = tryCallOne(cb, self._55);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._65 = 3;
      self._55 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._65 = 1;
  self._55 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._65 = 2;
  self._55 = newValue;
  if (Promise._87) {
    Promise._87(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._40 === 1) {
    handle(self, self._72);
    self._72 = null;
  }
  if (self._40 === 2) {
    for (var i = 0; i < self._72.length; i++) {
      handle(self, self._72[i]);
    }
    self._72 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(38) && !__webpack_require__(24)(function () {
  return Object.defineProperty(__webpack_require__(270)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(33);


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(59);
var toIObject = __webpack_require__(60);
var arrayIndexOf = __webpack_require__(191)(false);
var IE_PROTO = __webpack_require__(272)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(40);
var anObject = __webpack_require__(16);
var getKeys = __webpack_require__(117);

module.exports = __webpack_require__(38) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(60);
var gOPN = __webpack_require__(120).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(38);
var getKeys = __webpack_require__(117);
var gOPS = __webpack_require__(192);
var pIE = __webpack_require__(161);
var toObject = __webpack_require__(45);
var IObject = __webpack_require__(160);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(24)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 415 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(52);
var isObject = __webpack_require__(26);
var invoke = __webpack_require__(417);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 417 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(21).parseInt;
var $trim = __webpack_require__(141).trim;
var ws = __webpack_require__(276);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(21).parseFloat;
var $trim = __webpack_require__(141).trim;

module.exports = 1 / $parseFloat(__webpack_require__(276) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(70);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(26);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 422 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(279);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(16);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(52);
var toObject = __webpack_require__(45);
var IObject = __webpack_require__(160);
var toLength = __webpack_require__(37);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(45);
var toAbsoluteIndex = __webpack_require__(118);
var toLength = __webpack_require__(37);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(291);
__webpack_require__(5)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(38) && /./g.flags != 'g') __webpack_require__(40).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(162)
});


/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(16);
var isObject = __webpack_require__(26);
var newPromiseCapability = __webpack_require__(295);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(433);
var validate = __webpack_require__(125);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(200)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(40).f;
var create = __webpack_require__(119);
var redefineAll = __webpack_require__(124);
var ctx = __webpack_require__(69);
var anInstance = __webpack_require__(122);
var forOf = __webpack_require__(123);
var $iterDefine = __webpack_require__(281);
var step = __webpack_require__(427);
var setSpecies = __webpack_require__(121);
var DESCRIPTORS = __webpack_require__(38);
var fastKey = __webpack_require__(106).fastKey;
var validate = __webpack_require__(125);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(433);
var validate = __webpack_require__(125);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(200)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(21);
var each = __webpack_require__(81)(0);
var redefine = __webpack_require__(56);
var meta = __webpack_require__(106);
var assign = __webpack_require__(414);
var weak = __webpack_require__(436);
var isObject = __webpack_require__(26);
var validate = __webpack_require__(125);
var NATIVE_WEAK_MAP = __webpack_require__(125);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(200)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(124);
var getWeak = __webpack_require__(106).getWeak;
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(26);
var anInstance = __webpack_require__(122);
var forOf = __webpack_require__(123);
var createArrayMethod = __webpack_require__(81);
var $has = __webpack_require__(59);
var validate = __webpack_require__(125);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(71);
var toLength = __webpack_require__(37);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(120);
var gOPS = __webpack_require__(192);
var anObject = __webpack_require__(16);
var Reflect = __webpack_require__(21).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(193);
var isObject = __webpack_require__(26);
var toLength = __webpack_require__(37);
var ctx = __webpack_require__(69);
var IS_CONCAT_SPREADABLE = __webpack_require__(33)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(37);
var repeat = __webpack_require__(278);
var defined = __webpack_require__(79);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(38);
var getKeys = __webpack_require__(117);
var toIObject = __webpack_require__(60);
var isEnum = __webpack_require__(161).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(140);
var from = __webpack_require__(443);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(123);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 444 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(164),
    _assign = __webpack_require__(34);

var ReactNoopUpdateQueue = __webpack_require__(446);

var canDefineProperty = __webpack_require__(447);
var emptyObject = __webpack_require__(297);
var invariant = __webpack_require__(17);
var lowPriorityWarning = __webpack_require__(884);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(28);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(892);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(34);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(29);

var invariant = __webpack_require__(17);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(53);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(29);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(126);

var invariant = __webpack_require__(17);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(41);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  delete inst._wrapperState.valueTracker;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(53);
var escapeTextContentForBrowser = __webpack_require__(208);
var setInnerHTML = __webpack_require__(207);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(145);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactInstrumentation = __webpack_require__(73);

var quoteAttributeValueForBrowser = __webpack_require__(925);
var warning = __webpack_require__(28);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var LinkedValueUtils = __webpack_require__(308);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactUpdates = __webpack_require__(82);

var warning = __webpack_require__(28);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29),
    _assign = __webpack_require__(34);

var ReactCompositeComponent = __webpack_require__(934);
var ReactEmptyComponent = __webpack_require__(468);
var ReactHostComponent = __webpack_require__(469);

var getNextDebugID = __webpack_require__(935);
var invariant = __webpack_require__(17);
var warning = __webpack_require__(28);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(29);

var React = __webpack_require__(143);

var invariant = __webpack_require__(17);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var invariant = __webpack_require__(17);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var ReactCurrentOwner = __webpack_require__(91);
var REACT_ELEMENT_TYPE = __webpack_require__(936);

var getIteratorFn = __webpack_require__(937);
var invariant = __webpack_require__(17);
var KeyEscapeUtils = __webpack_require__(312);
var warning = __webpack_require__(28);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(164);

var ReactCurrentOwner = __webpack_require__(91);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(28);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(63);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMSelection = __webpack_require__(949);

var containsNode = __webpack_require__(951);
var focusNode = __webpack_require__(462);
var getActiveElement = __webpack_require__(474);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var DOMLazyTree = __webpack_require__(147);
var DOMProperty = __webpack_require__(145);
var React = __webpack_require__(143);
var ReactBrowserEventEmitter = __webpack_require__(209);
var ReactCurrentOwner = __webpack_require__(91);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactDOMContainerInfo = __webpack_require__(966);
var ReactDOMFeatureFlags = __webpack_require__(967);
var ReactFeatureFlags = __webpack_require__(457);
var ReactInstanceMap = __webpack_require__(168);
var ReactInstrumentation = __webpack_require__(73);
var ReactMarkupChecksum = __webpack_require__(968);
var ReactReconciler = __webpack_require__(146);
var ReactUpdateQueue = __webpack_require__(313);
var ReactUpdates = __webpack_require__(82);

var emptyObject = __webpack_require__(297);
var instantiateReactComponent = __webpack_require__(466);
var invariant = __webpack_require__(17);
var setInnerHTML = __webpack_require__(207);
var shouldUpdateReactComponent = __webpack_require__(311);
var warning = __webpack_require__(28);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactNodeTypes = __webpack_require__(467);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(477);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(483);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(77)))

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(482);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(982);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(77), __webpack_require__(212)(module)))

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(487);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(316);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(321);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, _ref2) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact;
    var route = _ref2.route;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        component = _props.component,
        render = _props.render,
        children = _props.children;


    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(component && children), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(render && children), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props2 = this.props,
        children = _props2.children,
        component = _props2.component,
        render = _props2.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !Array.isArray(children) || children.length ? // Preact defaults to empty children array
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOCATION_CHANGE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = routerReducer;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  location: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { location: payload });
  }

  return state;
}

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALL_HISTORY_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return replace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return go; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return goBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return goForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return routerActions; });

/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = updateLocation('push');
var replace = updateLocation('replace');
var go = updateLocation('go');
var goBack = updateLocation('goBack');
var goForward = updateLocation('goForward');

var routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(322);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"],
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"],
    meta: { form: form, field: field, from: from, to: to }
  };
};

var arrayPop = function arrayPop(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"],
    meta: { form: form, field: field }
  };
};

var arrayPush = function arrayPush(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"],
    meta: { form: form, field: field },
    payload: value
  };
};

var arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"],
    meta: { form: form, field: field, index: index }
  };
};

var arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"],
    meta: { form: form, field: field }
  };
};

var arrayShift = function arrayShift(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"],
    meta: { form: form, field: field }
  };
};

var arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"],
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"],
    meta: { form: form, field: field },
    payload: value
  };
};

var autofill = function autofill(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"],
    meta: { form: form, field: field },
    payload: value
  };
};

var blur = function blur(form, field, value, touch) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"],
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"],
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var clearSubmit = function clearSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"],
    meta: { form: form }
  };
};

var clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"],
    meta: { form: form }
  };
};

var clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"],
    meta: { form: form, field: field }
  };
};

var destroy = function destroy() {
  for (var _len = arguments.length, form = Array(_len), _key = 0; _key < _len; _key++) {
    form[_key] = arguments[_key];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"],
    meta: { form: form }
  };
};

var focus = function focus(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"],
    meta: { form: form, field: field }
  };
};

var initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"],
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var registerField = function registerField(form, name, type) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var reset = function reset(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"],
    meta: { form: form }
  };
};

var startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"],
    meta: { form: form, field: field }
  };
};

var startSubmit = function startSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"],
    meta: { form: form }
  };
};

var stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var stopSubmit = function stopSubmit(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var submit = function submit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"],
    meta: { form: form }
  };
};

var setSubmitFailed = function setSubmitFailed(form) {
  for (var _len2 = arguments.length, fields = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    fields[_key2 - 1] = arguments[_key2];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"],
    meta: { form: form, fields: fields },
    error: true
  };
};

var setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len3 = arguments.length, fields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    fields[_key3 - 1] = arguments[_key3];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"],
    meta: { form: form, fields: fields },
    error: false
  };
};

var touch = function touch(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"],
    meta: { form: form, fields: fields }
  };
};

var unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var untouch = function untouch(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"],
    meta: { form: form, fields: fields }
  };
};

var updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"],
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"],
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

var actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  registerField: registerField,
  reset: reset,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldAsyncValidate);

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldValidate);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error__ = __webpack_require__(1034);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SubmissionError = function (_ExtendableError) {
  _inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    _classCallCheck(this, SubmissionError);

    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(__WEBPACK_IMPORTED_MODULE_0_es6_error__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SubmissionError);

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var processProps = function processProps(type, props, _value) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return _extends({}, props, {
      checked: value === _value,
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return _extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return _extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value),
    meta: _extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends({}, custom, props)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldProps);

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getValue__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isReactNative__ = __webpack_require__(1040);




var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = Object(__WEBPACK_IMPORTED_MODULE_0__getValue__["a" /* default */])(event, __WEBPACK_IMPORTED_MODULE_1__isReactNative__["a" /* default */]);

  // parse value if we have a parser
  if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (onChangeValue);

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

/* harmony default export */ __webpack_exports__["a"] = (isEvent);

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(1044);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(1067);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(326);


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (isEqualWith);


/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(1080);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(84);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(332);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(504);



var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.props, nextProps, customizer) || !Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.state, nextState, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (shallowCompare);

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(1114);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(129);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(1113);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(108);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(173);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(503);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsPristine);

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(172);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (safeGet);


/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(219);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(498);


var silenceEvent = function silenceEvent(event) {
  var is = Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvent);

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(128);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(93);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(318);

var _PathUtils = __webpack_require__(170);

var _createTransitionManager = __webpack_require__(319);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(522);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=fetchHandler;var _tokenStorage=__webpack_require__(1201);var _tokenStorage2=_interopRequireDefault(_tokenStorage);var _constants=__webpack_require__(339);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getHeaders=function getHeaders(account){var headers=new Headers();headers.append('Content-Type','application/json');if(account)headers.append('Authorization','Bearer '+account.token);return headers;};var storage=new _tokenStorage2.default();function fetchHandler(url,options){var retryCount=arguments.length>2&&arguments[2]!==undefined?arguments[2]:1;return new Promise(function(resolve,reject){var headers=getHeaders(storage.getAccount());fetch(url,_extends({},options,{credentials:'include',headers:headers})).then(function(resp){var contentType=resp.headers.get('content-type');if(resp.status<200||resp.status>=300){if(resp&&resp.status===502&&retryCount<_constants.FETCH_MAX_RETRY){resolve(fetchHandler(url,options,retryCount+1));}else{reject(resp);}}else if(resp.status===204){resolve(resp);}else if(contentType&&contentType.indexOf('application/json')!==-1){resolve(resp.json());}else{resolve(resp);}}).catch(function(e){reject(e);});});}module.exports=exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (Array.isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        } else if (typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (Array.isArray(target) && !Array.isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (Array.isArray(target) && Array.isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                if (target[i] && typeof target[i] === 'object') {
                    target[i] = merge(target[i], item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (obj === null || typeof obj === 'undefined') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1204);

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 528 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var settle = __webpack_require__(1207);
var buildURL = __webpack_require__(1209);
var parseHeaders = __webpack_require__(1210);
var isURLSameOrigin = __webpack_require__(1211);
var createError = __webpack_require__(530);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(1212);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1213);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1208);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inspect;

var _nodejsCustomInspectSymbol = _interopRequireDefault(__webpack_require__(534));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Used to print values in error messages.
 */
function inspect(value) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value) {
        var customInspectFn = getCustomFn(value);

        if (customInspectFn) {
          // $FlowFixMe(>=0.90.0)
          var customValue = customInspectFn.call(value);
          return typeof customValue === 'string' ? customValue : inspect(customValue);
        } else if (Array.isArray(value)) {
          return '[' + value.map(inspect).join(', ') + ']';
        }

        var properties = Object.keys(value).map(function (k) {
          return "".concat(k, ": ").concat(inspect(value[k]));
        }).join(', ');
        return properties ? '{ ' + properties + ' }' : '{}';
      }

      return String(value);

    default:
      return String(value);
  }
}

function getCustomFn(object) {
  var customInspectFn = object[String(_nodejsCustomInspectSymbol.default)];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Copyright (c) 2018-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var nodejsCustomInspectSymbol = typeof Symbol === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var _default = nodejsCustomInspectSymbol;
exports.default = _default;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = { cmp: opts };
    var cycles = (typeof opts.cycles === 'boolean') ? opts.cycles : false;

    var cmp = opts.cmp && (function (f) {
        return function (node) {
            return function (a, b) {
                var aobj = { key: a, value: node[a] };
                var bobj = { key: b, value: node[b] };
                return f(aobj, bobj);
            };
        };
    })(opts.cmp);

    var seen = [];
    return (function stringify (node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') {
            node = node.toJSON();
        }

        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);

        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for (i = 0; i < node.length; i++) {
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }

        if (node === null) return 'null';

        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }

        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for (i = 0; i < keys.length; i++) {
            var key = keys[i];
            var value = stringify(node[key]);

            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    })(data);
};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var fakeNullFiber = new (function Fiber(){});
var localKey = "_optimism_local";

function getCurrentFiber() {
  return fakeNullFiber;
}

if (true) {
  try {
    var Fiber = module["eriuqer".split("").reverse().join("")]("fibers");
    // If we were able to require fibers, redefine the getCurrentFiber
    // function so that it has a chance to return Fiber.current.
    getCurrentFiber = function () {
      return Fiber.current || fakeNullFiber;
    };
  } catch (e) {}
}

// Returns an object unique to Fiber.current, if fibers are enabled.
// This object is used for Fiber-local storage in ./entry.js.
exports.get = function () {
  var fiber = getCurrentFiber();
  return fiber[localKey] || (fiber[localKey] = Object.create(null));
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)(module)))

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var apollo_utilities_1 = __webpack_require__(86);
var ts_invariant_1 = __webpack_require__(150);
var haveWarned = false;
function shouldWarn() {
    var answer = !haveWarned;
    if (!apollo_utilities_1.isTest()) {
        haveWarned = true;
    }
    return answer;
}
var HeuristicFragmentMatcher = (function () {
    function HeuristicFragmentMatcher() {
    }
    HeuristicFragmentMatcher.prototype.ensureReady = function () {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function () {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        if (!obj && idValue.id === 'ROOT_QUERY') {
            return true;
        }
        if (!obj) {
            return false;
        }
        if (!obj.__typename) {
            if (shouldWarn()) {
                ts_invariant_1.invariant.warn("You're using fragments in your queries, but either don't have the addTypename:\n  true option set in Apollo Client, or you are trying to write a fragment to the store without the __typename.\n   Please turn on the addTypename option and include __typename when writing fragments so that Apollo Client\n   can accurately match fragments.");
                ts_invariant_1.invariant.warn('Could not find __typename on Fragment ', typeCondition, obj);
                ts_invariant_1.invariant.warn("DEPRECATION WARNING: using fragments without __typename is unsupported behavior " +
                    "and will be removed in future versions of Apollo client. You should fix this and set addTypename to true now.");
            }
            return 'heuristic';
        }
        if (obj.__typename === typeCondition) {
            return true;
        }
        if (shouldWarn()) {
            ts_invariant_1.invariant.error('You are using the simple (heuristic) fragment matcher, but your ' +
                'queries contain union or interface types. Apollo Client will not be ' +
                'able to accurately map fragments. To make this error go away, use ' +
                'the `IntrospectionFragmentMatcher` as described in the docs: ' +
                'https://www.apollographql.com/docs/react/advanced/fragments.html#fragment-matcher');
        }
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}());
exports.HeuristicFragmentMatcher = HeuristicFragmentMatcher;
var IntrospectionFragmentMatcher = (function () {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        }
        else {
            this.isReady = false;
        }
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function (idValue, typeCondition, context) {
        ts_invariant_1.invariant(this.isReady, 'FragmentMatcher.match() was called before FragmentMatcher.init()');
        var obj = context.store.get(idValue.id);
        if (!obj) {
            return false;
        }
        ts_invariant_1.invariant(obj.__typename, "Cannot match fragment because __typename property is missing: " + JSON.stringify(obj));
        if (obj.__typename === typeCondition) {
            return true;
        }
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (implementingTypes && implementingTypes.indexOf(obj.__typename) > -1) {
            return true;
        }
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function (introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function (type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') {
                typeMap[type.name] = type.possibleTypes.map(function (implementingType) { return implementingType.name; });
            }
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}());
exports.IntrospectionFragmentMatcher = IntrospectionFragmentMatcher;
//# sourceMappingURL=fragmentMatcher.js.map

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(39);
var apollo_utilities_1 = __webpack_require__(86);
var optimism_1 = __webpack_require__(347);
var cacheKeys_1 = __webpack_require__(539);
var depTrackingCache_1 = __webpack_require__(348);
var ts_invariant_1 = __webpack_require__(150);
var StoreReader = (function () {
    function StoreReader(cacheKeyRoot) {
        if (cacheKeyRoot === void 0) { cacheKeyRoot = new cacheKeys_1.CacheKeyNode; }
        var _this = this;
        this.cacheKeyRoot = cacheKeyRoot;
        var reader = this;
        var executeStoreQuery = reader.executeStoreQuery, executeSelectionSet = reader.executeSelectionSet;
        this.executeStoreQuery = optimism_1.wrap(function (options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof depTrackingCache_1.DepTrackingCache) {
                    return reader.cacheKeyRoot.lookup(query, contextValue.store, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
                return;
            }
        });
        this.executeSelectionSet = optimism_1.wrap(function (options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function (_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof depTrackingCache_1.DepTrackingCache) {
                    return reader.cacheKeyRoot.lookup(selectionSet, execContext.contextValue.store, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
                return;
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function (options) {
        var optsPatch = { returnPartialData: false };
        return this.diffQueryAgainstStore(tslib_1.__assign({}, options, optsPatch)).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function (_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = apollo_utilities_1.getQueryDefinition(query);
        variables = apollo_utilities_1.assign({}, apollo_utilities_1.getDefaultValues(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: (config && config.dataIdFromObject) || null,
            cacheRedirects: (config && config.cacheRedirects) || {},
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query',
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction,
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) {
            execResult.missing.forEach(function (info) {
                if (info.tolerable)
                    return;
                throw new ts_invariant_1.InvariantError("Can't find field " + info.fieldName + " on object " + JSON.stringify(info.object, null, 2) + ".");
            });
        }
        if (previousResult) {
            if (apollo_utilities_1.isEqual(previousResult, execResult.result)) {
                execResult.result = previousResult;
            }
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields,
        };
    };
    StoreReader.prototype.executeStoreQuery = function (_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? defaultFragmentMatcher : _b;
        var mainDefinition = apollo_utilities_1.getMainDefinition(query);
        var fragments = apollo_utilities_1.getFragmentDefinitions(query);
        var fragmentMap = apollo_utilities_1.createFragmentMap(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher,
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext,
        });
    };
    StoreReader.prototype.executeSelectionSet = function (_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = { result: null };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = (object && object.__typename) ||
            (rootValue.id === 'ROOT_QUERY' && 'Query') ||
            void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function (selection) {
            var _a;
            if (!apollo_utilities_1.shouldInclude(selection, variables)) {
                return;
            }
            if (apollo_utilities_1.isField(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') {
                    objectsToMerge.push((_a = {},
                        _a[apollo_utilities_1.resultKeyNameFromField(selection)] = fieldResult,
                        _a));
                }
            }
            else {
                var fragment = void 0;
                if (apollo_utilities_1.isInlineFragment(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) {
                        throw new ts_invariant_1.InvariantError("No fragment named " + selection.name.value);
                    }
                }
                var typeCondition = fragment.typeCondition.name.value;
                var match = execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext,
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) {
                        fragmentExecResult = tslib_1.__assign({}, fragmentExecResult, { missing: fragmentExecResult.missing.map(function (info) {
                                return tslib_1.__assign({}, info, { tolerable: true });
                            }) });
                    }
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = apollo_utilities_1.mergeDeepArray(objectsToMerge);
        return finalResult;
    };
    StoreReader.prototype.executeField = function (object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = apollo_utilities_1.argumentsObjectFromField(field, variables);
        var info = {
            resultKey: apollo_utilities_1.resultKeyNameFromField(field),
            directives: apollo_utilities_1.getDirectiveInfoFromField(field, variables),
        };
        var readStoreResult = readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) {
            return this.combineExecResults(readStoreResult, this.executeSubSelectedArray(field, readStoreResult.result, execContext));
        }
        if (!field.selectionSet) {
            assertSelectionSetForIdValue(field, readStoreResult.result);
            return readStoreResult;
        }
        if (readStoreResult.result == null) {
            return readStoreResult;
        }
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext,
        }));
    };
    StoreReader.prototype.combineExecResults = function () {
        var execResults = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            execResults[_i] = arguments[_i];
        }
        var missing = null;
        execResults.forEach(function (execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing,
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        var missing = null;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        result = result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return handleMissing(_this.executeSubSelectedArray(field, item, execContext));
            }
            if (field.selectionSet) {
                return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext,
                }));
            }
            assertSelectionSetForIdValue(field, item);
            return item;
        });
        return { result: result, missing: missing };
    };
    return StoreReader;
}());
exports.StoreReader = StoreReader;
function assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && apollo_utilities_1.isIdValue(value)) {
        throw new ts_invariant_1.InvariantError("Missing selection set for object of type " + value.typename + " returned for query field " + field.name.value);
    }
}
function defaultFragmentMatcher() {
    return true;
}
function assertIdValue(idValue) {
    ts_invariant_1.invariant(apollo_utilities_1.isIdValue(idValue), "Encountered a sub-selection on the query, but the store doesn't have an object reference. This should never happen during normal use unless you have custom code that is directly manipulating the store; please file an issue.");
}
exports.assertIdValue = assertIdValue;
function readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) {
        storeKeyName = apollo_utilities_1.getStoreKeyName(storeKeyName, args, directives);
    }
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' &&
            context.cacheRedirects &&
            typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) {
                    fieldValue = resolver(object, args, {
                        getCacheKey: function (storeObj) {
                            return apollo_utilities_1.toIdValue({
                                id: context.dataIdFromObject(storeObj),
                                typename: storeObj.__typename,
                            });
                        },
                    });
                }
            }
        }
    }
    if (typeof fieldValue === 'undefined') {
        return {
            result: fieldValue,
            missing: [{
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false,
                }],
        };
    }
    if (apollo_utilities_1.isJsonValue(fieldValue)) {
        fieldValue = fieldValue.json;
    }
    return {
        result: fieldValue,
    };
}
//# sourceMappingURL=readFromStore.js.map

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CacheKeyNode = (function () {
    function CacheKeyNode() {
        this.children = null;
        this.key = null;
    }
    CacheKeyNode.prototype.lookup = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return this.lookupArray(args);
    };
    CacheKeyNode.prototype.lookupArray = function (array) {
        var node = this;
        array.forEach(function (value) {
            node = node.getOrCreate(value);
        });
        return node.key || (node.key = Object.create(null));
    };
    CacheKeyNode.prototype.getOrCreate = function (value) {
        var map = this.children || (this.children = new Map());
        var node = map.get(value);
        if (!node) {
            map.set(value, (node = new CacheKeyNode()));
        }
        return node;
    };
    return CacheKeyNode;
}());
exports.CacheKeyNode = CacheKeyNode;
//# sourceMappingURL=cacheKeys.js.map

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(39);
var apollo_utilities_1 = __webpack_require__(86);
var ts_invariant_1 = __webpack_require__(150);
var objectCache_1 = __webpack_require__(349);
var depTrackingCache_1 = __webpack_require__(348);
var WriteError = (function (_super) {
    tslib_1.__extends(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error));
exports.WriteError = WriteError;
function enhanceErrorWithDocument(error, document) {
    var enhancedError = new WriteError("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
exports.enhanceErrorWithDocument = enhanceErrorWithDocument;
var StoreWriter = (function () {
    function StoreWriter() {
    }
    StoreWriter.prototype.writeQueryToStore = function (_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? depTrackingCache_1.defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction,
        });
    };
    StoreWriter.prototype.writeResultToStore = function (_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? depTrackingCache_1.defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = apollo_utilities_1.getOperationDefinition(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: apollo_utilities_1.assign({}, apollo_utilities_1.getDefaultValues(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: apollo_utilities_1.createFragmentMap(apollo_utilities_1.getFragmentDefinitions(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction,
                },
            });
        }
        catch (e) {
            throw enhanceErrorWithDocument(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function (_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function (selection) {
            if (!apollo_utilities_1.shouldInclude(selection, variables)) {
                return;
            }
            if (apollo_utilities_1.isField(selection)) {
                var resultFieldKey = apollo_utilities_1.resultKeyNameFromField(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') {
                    _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context,
                    });
                }
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function (directive) { return directive.name && directive.name.value === 'defer'; });
                        isClient = selection.directives.some(function (directive) { return directive.name && directive.name.value === 'client'; });
                    }
                    if (!isDefered && !isClient && context.fragmentMatcherFunction) {
                        ts_invariant_1.invariant.warn("Missing field " + resultFieldKey + " in " + JSON.stringify(result, null, 2).substring(0, 100));
                    }
                }
            }
            else {
                var fragment = void 0;
                if (apollo_utilities_1.isInlineFragment(selection)) {
                    fragment = selection;
                }
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    ts_invariant_1.invariant(fragment, "No fragment named " + selection.name.value + ".");
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var idValue = apollo_utilities_1.toIdValue({ id: 'self', typename: undefined });
                    var fakeContext = {
                        store: new objectCache_1.ObjectCache({ self: result }),
                        cacheRedirects: {},
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    if (!apollo_utilities_1.isProduction() && match === 'heuristic') {
                        ts_invariant_1.invariant.error('WARNING: heuristic fragment matching going on!');
                    }
                    matches = !!match;
                }
                if (matches) {
                    _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context,
                    });
                }
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function (_a) {
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var _b;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = apollo_utilities_1.storeKeyNameFromField(field, variables);
        if (!field.selectionSet || value === null) {
            storeValue =
                value != null && typeof value === 'object'
                    ?
                        { type: 'json', json: value }
                    :
                        value;
        }
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        }
        else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!isGeneratedId(valueDataId)) {
                valueDataId = '$' + valueDataId;
            }
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                ts_invariant_1.invariant(!semanticId || !isGeneratedId(semanticId), 'IDs returned by dataIdFromObject cannot begin with the "$" character.');
                if (semanticId ||
                    (typeof semanticId === 'number' && semanticId === 0)) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(valueDataId, field, context.processedData)) {
                this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context,
                });
            }
            var typename = value.__typename;
            storeValue = apollo_utilities_1.toIdValue({ id: valueDataId, typename: typename }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && apollo_utilities_1.isIdValue(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                ts_invariant_1.invariant(!generated || escapedId.generated || typenameChanged, "Store error: the application attempted to write an object with no provided id but the store already contains an id of " + escapedId.id + " for this object. The selectionSet that was trying to be written is:\n" + JSON.stringify(field));
                ts_invariant_1.invariant(!hadTypename || hasTypename, "Store error: the application attempted to write an object with no provided typename but the store already contains an object with typename of " + escapedId.typename + " for the object of id " + escapedId.id + ". The selectionSet that was trying to be written is:\n" + JSON.stringify(field));
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) {
                            store.delete(escapedId.id);
                        }
                    }
                    else {
                        mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !apollo_utilities_1.isEqual(storeValue, storeObject[storeFieldName])) {
            store.set(dataId, tslib_1.__assign({}, storeObject, (_b = {}, _b[storeFieldName] = storeValue, _b)));
        }
    };
    StoreWriter.prototype.processArrayValue = function (value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function (item, index) {
            if (item === null) {
                return null;
            }
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) {
                return _this.processArrayValue(item, itemDataId, selectionSet, context);
            }
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!isDataProcessed(itemDataId, selectionSet, context.processedData)) {
                _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context,
                });
            }
            return apollo_utilities_1.toIdValue({ id: itemDataId, typename: item.__typename }, generated);
        });
    };
    return StoreWriter;
}());
exports.StoreWriter = StoreWriter;
function isGeneratedId(id) {
    return id[0] === '$';
}
function mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) {
        return false;
    }
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function (key) {
        var value = generated[key];
        var realValue = real[key];
        if (apollo_utilities_1.isIdValue(value) &&
            isGeneratedId(value.id) &&
            apollo_utilities_1.isIdValue(realValue) &&
            !apollo_utilities_1.isEqual(value, realValue) &&
            mergeWithGenerated(value.id, realValue.id, cache)) {
            madeChanges = true;
        }
    });
    cache.delete(generatedKey);
    var newRealValue = tslib_1.__assign({}, generated, real);
    if (apollo_utilities_1.isEqual(newRealValue, real)) {
        return madeChanges;
    }
    cache.set(realKey, newRealValue);
    return true;
}
function isDataProcessed(dataId, field, processedData) {
    if (!processedData) {
        return false;
    }
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) {
            return true;
        }
        else {
            processedData[dataId].push(field);
        }
    }
    else {
        processedData[dataId] = [field];
    }
    return false;
}
//# sourceMappingURL=writeToStore.js.map

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(39);
var zen_observable_ts_1 = tslib_1.__importDefault(__webpack_require__(130));
var printer_1 = __webpack_require__(346);
var apollo_utilities_1 = __webpack_require__(86);
exports.getOperationName = apollo_utilities_1.getOperationName;
var ts_invariant_1 = __webpack_require__(345);
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw new ts_invariant_1.InvariantError("illegal argument: " + key);
        }
    }
    return operation;
}
exports.validateOperation = validateOperation;
var LinkError = (function (_super) {
    tslib_1.__extends(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
exports.LinkError = LinkError;
function isTerminating(link) {
    return link.request.length <= 1;
}
exports.isTerminating = isTerminating;
function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    ts_invariant_1.invariant.warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
exports.toPromise = toPromise;
exports.makePromise = toPromise;
function fromPromise(promise) {
    return new zen_observable_ts_1.default(function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
exports.fromPromise = fromPromise;
function fromError(errorValue) {
    return new zen_observable_ts_1.default(function (observer) {
        observer.error(errorValue);
    });
}
exports.fromError = fromError;
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? apollo_utilities_1.getOperationName(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
exports.transformOperation = transformOperation;
function createOperation(starting, operation) {
    var context = tslib_1.__assign({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = tslib_1.__assign({}, context, next(context));
        }
        else {
            context = tslib_1.__assign({}, context, next);
        }
    };
    var getContext = function () { return (tslib_1.__assign({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
exports.createOperation = createOperation;
function getKey(operation) {
    return printer_1.print(operation.query) + "|" + JSON.stringify(operation.variables) + "|" + operation.operationName;
}
exports.getKey = getKey;
//# sourceMappingURL=linkUtils.js.map

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.transformInfosAdicionais=exports.transformConta=exports.gqlInfoExtra=exports.gqlPlanData=exports.gqlContas=undefined;var _templateObject=_taggedTemplateLiteral(['\n  query {\n    contas {\n      produto\n      plano\n      conta\n      status\n      tipo\n      dataAdesao\n      temMensalidade\n      totalIdentificadores\n      saldoMinRecarga\n      tipoRecarga\n      limite\n      saldoDisponivel\n      tipoPagamento\n      saldo\n      dadosPos {\n        vencimentoFatura\n        dataCorteFatura\n        diaVencimentoConta\n      }\n      dadosPagamentoDebito {\n        codigoBanco\n        nomeBanco\n        agencia\n        digitoAgencia\n        contaCorrente\n      }\n    }\n  }\n'],['\n  query {\n    contas {\n      produto\n      plano\n      conta\n      status\n      tipo\n      dataAdesao\n      temMensalidade\n      totalIdentificadores\n      saldoMinRecarga\n      tipoRecarga\n      limite\n      saldoDisponivel\n      tipoPagamento\n      saldo\n      dadosPos {\n        vencimentoFatura\n        dataCorteFatura\n        diaVencimentoConta\n      }\n      dadosPagamentoDebito {\n        codigoBanco\n        nomeBanco\n        agencia\n        digitoAgencia\n        contaCorrente\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query valorMensalidade($idConta: String!) {\n    valorMensalidade(idConta: $idConta) {\n      valor\n    }\n    valorRecarga(idConta: $idConta) {\n      valor\n    }\n    valorBonificacao(idConta: $idConta) {\n      dataFimBonificacao\n      tipoBonificacao\n      valorBonificacao\n    }\n  }\n'],['\n  query valorMensalidade($idConta: String!) {\n    valorMensalidade(idConta: $idConta) {\n      valor\n    }\n    valorRecarga(idConta: $idConta) {\n      valor\n    }\n    valorBonificacao(idConta: $idConta) {\n      dataFimBonificacao\n      tipoBonificacao\n      valorBonificacao\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query infosAdicionais($idConta: String!) {\n    buscarPedido(conta: $idConta) {\n      pedido\n      data\n    }\n    identificadores(idConta: $idConta) {\n      idIdentificador\n      veiculo {\n        marca\n        modelo\n        placa\n      }\n      placaVeiculo\n      valorConsumido\n      situacao\n    }\n  }\n'],['\n  query infosAdicionais($idConta: String!) {\n    buscarPedido(conta: $idConta) {\n      pedido\n      data\n    }\n    identificadores(idConta: $idConta) {\n      idIdentificador\n      veiculo {\n        marca\n        modelo\n        placa\n      }\n      placaVeiculo\n      valorConsumido\n      situacao\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);var _helpers=__webpack_require__(152);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlContas=exports.gqlContas=(0,_graphqlTag2.default)(_templateObject);var gqlPlanData=exports.gqlPlanData=(0,_graphqlTag2.default)(_templateObject2);var gqlInfoExtra=exports.gqlInfoExtra=(0,_graphqlTag2.default)(_templateObject3);var contaMap={id:'conta',active:'status',accountId:'conta','plan.id':'conta','plan.category':'plano','plan.rechargeType':'tipoRecarga','plan.rechargeAmount':'saldoMinRecarga',accessionDate:'dataAdesao',isMonthlyPayment:'temMensalidade',ammount:'saldo',limit:'limite','posData.payDay':'dadosPos.vencimentoFatura','posData.cutDay':'dadosPos.dataCorteFatura','posData.dueDayAccount':'dadosPos.diaVencimentoConta','debitPaymentData.bankCode':'dadosPagamentoDebito.codigoBanco','debitPaymentData.bankName':'dadosPagamentoDebito.nomeBanco','debitPaymentData.agency':'dadosPagamentoDebito.agencia','debitPaymentData.agencyDigit':'dadosPagamentoDebito.digitoAgencia','debitPaymentData.account':'dadosPagamentoDebito.contaCorrente',availableAmount:'saldoDisponivel',paymentType:'tipoPagamento',// paymentMethod: '???', TODO valor não encontrado no graphQL
__v:''};var InfosAdicionaisMap={carPlate:'veiculo.placa',identifierId:'idIdentificador',// "carNick": "",
carBrand:'veiculo.marca',carModel:'veiculo.modelo',// "carYear": 0,
// "carColor": "",
// "driverName": "",
consumption:'valorConsumido',active:'situacao'// TODO pode ser que não retorne nenhum plano por algum motivo, tratar!!
};var transformConta=exports.transformConta=function transformConta(src){var contas=src.data.contas;return contas.map(function(conta){var contaTransformed=(0,_helpers.transformObject)(conta,contaMap);contaTransformed.plan.type=(0,_helpers.getTipoConta)(conta.tipo);return contaTransformed;});};var transformInfosAdicionais=exports.transformInfosAdicionais=function transformInfosAdicionais(src){return{identifiersOrders:src.data.buscarPedido,identifiers:src.data.identificadores.map(function(i){return(0,_helpers.transformObject)(i,InfosAdicionaisMap);}),identifiersQtd:{quantidade:src.data.identificadores.filter(function(i){return i.situacao==='ATIVO';}).length},representatives:[]// TODO O middleware retorna sempre este valor
};};

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defineToJSON;

var _nodejsCustomInspectSymbol = _interopRequireDefault(__webpack_require__(534));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * The `defineToJSON()` function defines toJSON() and inspect() prototype
 * methods, if no function provided they become aliases for toString().
 */
function defineToJSON( // eslint-disable-next-line flowtype/no-weak-types
classObject) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : classObject.prototype.toString;
  classObject.prototype.toJSON = fn;
  classObject.prototype.inspect = fn;

  if (_nodejsCustomInspectSymbol.default) {
    classObject.prototype[_nodejsCustomInspectSymbol.default] = fn;
  }
}

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = invariant;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function invariant(condition, message) {
  /* istanbul ignore else */
  if (!condition) {
    throw new Error(message);
  }
}

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GraphQLError", {
  enumerable: true,
  get: function get() {
    return _GraphQLError.GraphQLError;
  }
});
Object.defineProperty(exports, "syntaxError", {
  enumerable: true,
  get: function get() {
    return _syntaxError.syntaxError;
  }
});
Object.defineProperty(exports, "locatedError", {
  enumerable: true,
  get: function get() {
    return _locatedError.locatedError;
  }
});
Object.defineProperty(exports, "printError", {
  enumerable: true,
  get: function get() {
    return _printError.printError;
  }
});
Object.defineProperty(exports, "formatError", {
  enumerable: true,
  get: function get() {
    return _formatError.formatError;
  }
});

var _GraphQLError = __webpack_require__(350);

var _syntaxError = __webpack_require__(1247);

var _locatedError = __webpack_require__(1248);

var _printError = __webpack_require__(546);

var _formatError = __webpack_require__(1249);

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printError = printError;

var _location = __webpack_require__(547);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */
function printError(error) {
  var printedLocations = [];

  if (error.nodes) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = error.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var node = _step.value;

        if (node.loc) {
          printedLocations.push(highlightSourceAtLocation(node.loc.source, (0, _location.getLocation)(node.loc.source, node.loc.start)));
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else if (error.source && error.locations) {
    var source = error.source;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = error.locations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var location = _step2.value;
        printedLocations.push(highlightSourceAtLocation(source, location));
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return printedLocations.length === 0 ? error.message : [error.message].concat(printedLocations).join('\n\n') + '\n';
}
/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */


function highlightSourceAtLocation(source, location) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = location.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = location.line + lineOffset;
  var columnOffset = location.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = location.column + columnOffset;
  var lines = body.split(/\r\n|[\n\r]/g);
  return "".concat(source.name, " (").concat(lineNum, ":").concat(columnNum, ")\n") + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1, ": "), lines[lineIndex - 1]], ["".concat(lineNum, ": "), lines[lineIndex]], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1, ": "), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = 0;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = existingLines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var _ref4 = _step3.value;
      var prefix = _ref4[0];
      padLen = Math.max(padLen, prefix.length);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return lpad(padLen, prefix) + line;
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function lpad(len, str) {
  return whitespace(len - str.length) + str;
}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = getLocation;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(223),
    isKey = __webpack_require__(1256),
    stringToPath = __webpack_require__(1259),
    toString = __webpack_require__(1287);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(224),
    isObject = __webpack_require__(354);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 551 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(351);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 553 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 554 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.gqlEmailsUsuarios=exports.gqlParametrizacao=undefined;var _templateObject=_taggedTemplateLiteral(['\n  query parametrizacao($parametro: String!) {\n    parametrizacao(parametro: $parametro) {\n      chave\n      valor\n    }\n  }\n'],['\n  query parametrizacao($parametro: String!) {\n    parametrizacao(parametro: $parametro) {\n      chave\n      valor\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query($parametro: String!, $email: String) {\n    emailsUsuarios(parametro: $parametro, email: $email) {\n      chave\n    }\n  }\n'],['\n  query($parametro: String!, $email: String) {\n    emailsUsuarios(parametro: $parametro, email: $email) {\n      chave\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlParametrizacao=exports.gqlParametrizacao=(0,_graphqlTag2.default)(_templateObject);var gqlEmailsUsuarios=exports.gqlEmailsUsuarios=(0,_graphqlTag2.default)(_templateObject2);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.gqlGetCitiesFromState=exports.gqlGetStates=exports.gqlSearchAddress=exports.gqlUpdateAddress=exports.gqlAddAddress=exports.gqlDeleteAddress=exports.gqlGetAddress=undefined;var _templateObject=_taggedTemplateLiteral(['\n  {\n    enderecos {\n      cep\n      uf\n      cidade\n      bairro\n      logradouro\n      numero\n      complemento\n      correspondencia\n      codigo\n    }\n  }\n'],['\n  {\n    enderecos {\n      cep\n      uf\n      cidade\n      bairro\n      logradouro\n      numero\n      complemento\n      correspondencia\n      codigo\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation excluirEndereco($id: Int) {\n    excluirEndereco(id: $id)\n  }\n'],['\n  mutation excluirEndereco($id: Int) {\n    excluirEndereco(id: $id)\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation inserirEndereco($enderecos: [EnderecoInput]) {\n    inserirEndereco(enderecos: $enderecos) {\n      cep\n      uf\n      cidade\n      bairro\n      logradouro\n      numero\n      complemento\n      correspondencia\n      codigo\n    }\n  }\n'],['\n  mutation inserirEndereco($enderecos: [EnderecoInput]) {\n    inserirEndereco(enderecos: $enderecos) {\n      cep\n      uf\n      cidade\n      bairro\n      logradouro\n      numero\n      complemento\n      correspondencia\n      codigo\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation editarEndereco($enderecos: [EnderecoInput]) {\n    editarEndereco(enderecos: $enderecos) {\n      cep\n      uf\n      cidade\n      bairro\n      logradouro\n      numero\n      complemento\n      correspondencia\n      codigo\n    }\n  }\n'],['\n  mutation editarEndereco($enderecos: [EnderecoInput]) {\n    editarEndereco(enderecos: $enderecos) {\n      cep\n      uf\n      cidade\n      bairro\n      logradouro\n      numero\n      complemento\n      correspondencia\n      codigo\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query cep($cep: String!) {\n    cep(cep: $cep) {\n      logradouro\n      bairro\n      cidade\n      uf\n      cep\n    }\n  }\n'],['\n  query cep($cep: String!) {\n    cep(cep: $cep) {\n      logradouro\n      bairro\n      cidade\n      uf\n      cep\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query {\n    estados {\n      id\n      descricao\n      uf\n    }\n  }\n'],['\n  query {\n    estados {\n      id\n      descricao\n      uf\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query cidades($estado: String!) {\n    cidades(estado: $estado) {\n      id\n      descricao\n      abreviacao\n    }\n  }\n'],['\n  query cidades($estado: String!) {\n    cidades(estado: $estado) {\n      id\n      descricao\n      abreviacao\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlGetAddress=exports.gqlGetAddress=(0,_graphqlTag2.default)(_templateObject);var gqlDeleteAddress=exports.gqlDeleteAddress=(0,_graphqlTag2.default)(_templateObject2);var gqlAddAddress=exports.gqlAddAddress=(0,_graphqlTag2.default)(_templateObject3);var gqlUpdateAddress=exports.gqlUpdateAddress=(0,_graphqlTag2.default)(_templateObject4);var gqlSearchAddress=exports.gqlSearchAddress=(0,_graphqlTag2.default)(_templateObject5);var gqlGetStates=exports.gqlGetStates=(0,_graphqlTag2.default)(_templateObject6);var gqlGetCitiesFromState=exports.gqlGetCitiesFromState=(0,_graphqlTag2.default)(_templateObject7);

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/**
 * Arquivo legado utilizado para função de conexão com middleware
 * TODO: Conseguir remover este arquivo
 */var Storage=function Storage(){_classCallCheck(this,Storage);this.setAccount=function(){var token=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(token.success){var encodedToken=btoa(JSON.stringify(token));sessionStorage.setItem('token',encodedToken);}else{sessionStorage.setItem('token','');}};this.getAccount=function(){var token=sessionStorage.getItem('token');if(token&&typeof token!=='undefined'){var decodedToken=atob(token);return JSON.parse(decodedToken);}sessionStorage.setItem('token','');return{};};this.setSessionId=function(sessionId){sessionStorage.setItem('sessionId',sessionId);};this.getSessionId=function(){return sessionStorage.getItem('sessionId');};};exports.default=Storage;module.exports=exports['default'];

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setCookie=setCookie;exports.getCookie=getCookie;function setCookie(cname,cvalue,exdays){var d=new Date();d.setTime(d.getTime()+exdays*24*60*60*1000);var expires='expires='+d.toUTCString();document.cookie=cname+'='+cvalue+';'+expires+';path=/';}function getCookie(cname){var name=cname+'=';var ca=document.cookie.split(';');for(var i=0;i<ca.length;i+=1){var c=ca[i];while(c.charAt(0)===' '){c=c.substring(1);}if(c.indexOf(name)===0){return c.substring(name.length,c.length);}}return'';}

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.editPaymentMethodWithoutRecharge=exports.getDueDate=exports.getEditAuthorizationPayment=exports.getPaymentType=exports.editPaymentMethod=undefined;var editPaymentMethod=exports.editPaymentMethod=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(data){var _data$dados,conta,numeroMascarado,validade,bandeira,alias,nome,paymentToken,cvv,valorRecarga;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_data$dados=data.dados,conta=_data$dados.conta,numeroMascarado=_data$dados.numeroMascarado,validade=_data$dados.validade,bandeira=_data$dados.bandeira,alias=_data$dados.alias,nome=_data$dados.nome,paymentToken=_data$dados.paymentToken,cvv=_data$dados.cvv,valorRecarga=_data$dados.valorRecarga;_context.next=3;return(0,_apolloClient.gqlMutate)(_recharges.gqlEditarDadoPagamento,{conta:conta,numeroMascarado:numeroMascarado,validade:validade,bandeira:bandeira,alias:alias,nome:nome,paymentToken:paymentToken,cvv:cvv,valorRecarga:''+valorRecarga,ativo:true});case 3:case'end':return _context.stop();}}},_callee,this);}));return function editPaymentMethod(_x){return _ref.apply(this,arguments);};}();var getPaymentType=exports.getPaymentType=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var resp;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_apolloClient.gqlQuery)(_paymentType.gqlConsultarFormasPagamento);case 2:resp=_context2.sent;return _context2.abrupt('return',resp.data.ConsultarFormasPagamento);case 4:case'end':return _context2.stop();}}},_callee2,this);}));return function getPaymentType(){return _ref2.apply(this,arguments);};}();var getEditAuthorizationPayment=exports.getEditAuthorizationPayment=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(type,accountPlanId){var resp;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return(0,_apolloClient.gqlQuery)(_paymentType.gqlAutorizaEditarFormaPagamentoDataVencimento,{tipo:type,idConta:accountPlanId});case 2:resp=_context3.sent;return _context3.abrupt('return',resp.data.AutorizaEditarFormaPagamentoDataVencimento);case 4:case'end':return _context3.stop();}}},_callee3,this);}));return function getEditAuthorizationPayment(_x2,_x3){return _ref3.apply(this,arguments);};}();var getDueDate=exports.getDueDate=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(){var resp;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return(0,_apolloClient.gqlQuery)(_paymentType.gqlConsultarDataVencimento);case 2:resp=_context4.sent;return _context4.abrupt('return',resp.data.ConsultarDataVencimento);case 4:case'end':return _context4.stop();}}},_callee4,this);}));return function getDueDate(){return _ref4.apply(this,arguments);};}();var editPaymentMethodWithoutRecharge=exports.editPaymentMethodWithoutRecharge=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(data){var resp;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return(0,_apolloClient.gqlMutate)(_paymentType.gqlEditarFormaPagamento,data.dados);case 2:resp=_context5.sent;return _context5.abrupt('return',resp.data.EditarFormaPagamento);case 4:case'end':return _context5.stop();}}},_callee5,this);}));return function editPaymentMethodWithoutRecharge(_x4){return _ref5.apply(this,arguments);};}();exports.editDueDate=editDueDate;var _apolloClient=__webpack_require__(42);var _recharges=__webpack_require__(355);var _paymentType=__webpack_require__(1379);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function editDueDate(data){return(0,_apolloClient.gqlMutate)(_paymentType.gqlEditarDataVencimento,data);}

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {/*!
 * validate.js 0.12.0
 *
 * (c) 2013-2017 Nicklas Ansman, 2013 Wrapp
 * Validate.js may be freely distributed under the MIT license.
 * For all details and documentation:
 * http://validatejs.org/
 */

(function(exports, module, define) {
  "use strict";

  // The main function that calls the validators specified by the constraints.
  // The options are the following:
  //   - format (string) - An option that controls how the returned value is formatted
  //     * flat - Returns a flat array of just the error messages
  //     * grouped - Returns the messages grouped by attribute (default)
  //     * detailed - Returns an array of the raw validation data
  //   - fullMessages (boolean) - If `true` (default) the attribute name is prepended to the error.
  //
  // Please note that the options are also passed to each validator.
  var validate = function(attributes, constraints, options) {
    options = v.extend({}, v.options, options);

    var results = v.runValidations(attributes, constraints, options)
      , attr
      , validator;

    if (results.some(function(r) { return v.isPromise(r.error); })) {
      throw new Error("Use validate.async if you want support for promises");
    }
    return validate.processValidationResults(results, options);
  };

  var v = validate;

  // Copies over attributes from one or more sources to a single destination.
  // Very much similar to underscore's extend.
  // The first argument is the target object and the remaining arguments will be
  // used as sources.
  v.extend = function(obj) {
    [].slice.call(arguments, 1).forEach(function(source) {
      for (var attr in source) {
        obj[attr] = source[attr];
      }
    });
    return obj;
  };

  v.extend(validate, {
    // This is the version of the library as a semver.
    // The toString function will allow it to be coerced into a string
    version: {
      major: 0,
      minor: 12,
      patch: 0,
      metadata: null,
      toString: function() {
        var version = v.format("%{major}.%{minor}.%{patch}", v.version);
        if (!v.isEmpty(v.version.metadata)) {
          version += "+" + v.version.metadata;
        }
        return version;
      }
    },

    // Below is the dependencies that are used in validate.js

    // The constructor of the Promise implementation.
    // If you are using Q.js, RSVP or any other A+ compatible implementation
    // override this attribute to be the constructor of that promise.
    // Since jQuery promises aren't A+ compatible they won't work.
    Promise: typeof Promise !== "undefined" ? Promise : /* istanbul ignore next */ null,

    EMPTY_STRING_REGEXP: /^\s*$/,

    // Runs the validators specified by the constraints object.
    // Will return an array of the format:
    //     [{attribute: "<attribute name>", error: "<validation result>"}, ...]
    runValidations: function(attributes, constraints, options) {
      var results = []
        , attr
        , validatorName
        , value
        , validators
        , validator
        , validatorOptions
        , error;

      if (v.isDomElement(attributes) || v.isJqueryElement(attributes)) {
        attributes = v.collectFormValues(attributes);
      }

      // Loops through each constraints, finds the correct validator and run it.
      for (attr in constraints) {
        value = v.getDeepObjectValue(attributes, attr);
        // This allows the constraints for an attribute to be a function.
        // The function will be called with the value, attribute name, the complete dict of
        // attributes as well as the options and constraints passed in.
        // This is useful when you want to have different
        // validations depending on the attribute value.
        validators = v.result(constraints[attr], value, attributes, attr, options, constraints);

        for (validatorName in validators) {
          validator = v.validators[validatorName];

          if (!validator) {
            error = v.format("Unknown validator %{name}", {name: validatorName});
            throw new Error(error);
          }

          validatorOptions = validators[validatorName];
          // This allows the options to be a function. The function will be
          // called with the value, attribute name, the complete dict of
          // attributes as well as the options and constraints passed in.
          // This is useful when you want to have different
          // validations depending on the attribute value.
          validatorOptions = v.result(validatorOptions, value, attributes, attr, options, constraints);
          if (!validatorOptions) {
            continue;
          }
          results.push({
            attribute: attr,
            value: value,
            validator: validatorName,
            globalOptions: options,
            attributes: attributes,
            options: validatorOptions,
            error: validator.call(validator,
                value,
                validatorOptions,
                attr,
                attributes,
                options)
          });
        }
      }

      return results;
    },

    // Takes the output from runValidations and converts it to the correct
    // output format.
    processValidationResults: function(errors, options) {
      errors = v.pruneEmptyErrors(errors, options);
      errors = v.expandMultipleErrors(errors, options);
      errors = v.convertErrorMessages(errors, options);

      var format = options.format || "grouped";

      if (typeof v.formatters[format] === 'function') {
        errors = v.formatters[format](errors);
      } else {
        throw new Error(v.format("Unknown format %{format}", options));
      }

      return v.isEmpty(errors) ? undefined : errors;
    },

    // Runs the validations with support for promises.
    // This function will return a promise that is settled when all the
    // validation promises have been completed.
    // It can be called even if no validations returned a promise.
    async: function(attributes, constraints, options) {
      options = v.extend({}, v.async.options, options);

      var WrapErrors = options.wrapErrors || function(errors) {
        return errors;
      };

      // Removes unknown attributes
      if (options.cleanAttributes !== false) {
        attributes = v.cleanAttributes(attributes, constraints);
      }

      var results = v.runValidations(attributes, constraints, options);

      return new v.Promise(function(resolve, reject) {
        v.waitForResults(results).then(function() {
          var errors = v.processValidationResults(results, options);
          if (errors) {
            reject(new WrapErrors(errors, options, attributes, constraints));
          } else {
            resolve(attributes);
          }
        }, function(err) {
          reject(err);
        });
      });
    },

    single: function(value, constraints, options) {
      options = v.extend({}, v.single.options, options, {
        format: "flat",
        fullMessages: false
      });
      return v({single: value}, {single: constraints}, options);
    },

    // Returns a promise that is resolved when all promises in the results array
    // are settled. The promise returned from this function is always resolved,
    // never rejected.
    // This function modifies the input argument, it replaces the promises
    // with the value returned from the promise.
    waitForResults: function(results) {
      // Create a sequence of all the results starting with a resolved promise.
      return results.reduce(function(memo, result) {
        // If this result isn't a promise skip it in the sequence.
        if (!v.isPromise(result.error)) {
          return memo;
        }

        return memo.then(function() {
          return result.error.then(function(error) {
            result.error = error || null;
          });
        });
      }, new v.Promise(function(r) { r(); })); // A resolved promise
    },

    // If the given argument is a call: function the and: function return the value
    // otherwise just return the value. Additional arguments will be passed as
    // arguments to the function.
    // Example:
    // ```
    // result('foo') // 'foo'
    // result(Math.max, 1, 2) // 2
    // ```
    result: function(value) {
      var args = [].slice.call(arguments, 1);
      if (typeof value === 'function') {
        value = value.apply(null, args);
      }
      return value;
    },

    // Checks if the value is a number. This function does not consider NaN a
    // number like many other `isNumber` functions do.
    isNumber: function(value) {
      return typeof value === 'number' && !isNaN(value);
    },

    // Returns false if the object is not a function
    isFunction: function(value) {
      return typeof value === 'function';
    },

    // A simple check to verify that the value is an integer. Uses `isNumber`
    // and a simple modulo check.
    isInteger: function(value) {
      return v.isNumber(value) && value % 1 === 0;
    },

    // Checks if the value is a boolean
    isBoolean: function(value) {
      return typeof value === 'boolean';
    },

    // Uses the `Object` function to check if the given argument is an object.
    isObject: function(obj) {
      return obj === Object(obj);
    },

    // Simply checks if the object is an instance of a date
    isDate: function(obj) {
      return obj instanceof Date;
    },

    // Returns false if the object is `null` of `undefined`
    isDefined: function(obj) {
      return obj !== null && obj !== undefined;
    },

    // Checks if the given argument is a promise. Anything with a `then`
    // function is considered a promise.
    isPromise: function(p) {
      return !!p && v.isFunction(p.then);
    },

    isJqueryElement: function(o) {
      return o && v.isString(o.jquery);
    },

    isDomElement: function(o) {
      if (!o) {
        return false;
      }

      if (!o.querySelectorAll || !o.querySelector) {
        return false;
      }

      if (v.isObject(document) && o === document) {
        return true;
      }

      // http://stackoverflow.com/a/384380/699304
      /* istanbul ignore else */
      if (typeof HTMLElement === "object") {
        return o instanceof HTMLElement;
      } else {
        return o &&
          typeof o === "object" &&
          o !== null &&
          o.nodeType === 1 &&
          typeof o.nodeName === "string";
      }
    },

    isEmpty: function(value) {
      var attr;

      // Null and undefined are empty
      if (!v.isDefined(value)) {
        return true;
      }

      // functions are non empty
      if (v.isFunction(value)) {
        return false;
      }

      // Whitespace only strings are empty
      if (v.isString(value)) {
        return v.EMPTY_STRING_REGEXP.test(value);
      }

      // For arrays we use the length property
      if (v.isArray(value)) {
        return value.length === 0;
      }

      // Dates have no attributes but aren't empty
      if (v.isDate(value)) {
        return false;
      }

      // If we find at least one property we consider it non empty
      if (v.isObject(value)) {
        for (attr in value) {
          return false;
        }
        return true;
      }

      return false;
    },

    // Formats the specified strings with the given values like so:
    // ```
    // format("Foo: %{foo}", {foo: "bar"}) // "Foo bar"
    // ```
    // If you want to write %{...} without having it replaced simply
    // prefix it with % like this `Foo: %%{foo}` and it will be returned
    // as `"Foo: %{foo}"`
    format: v.extend(function(str, vals) {
      if (!v.isString(str)) {
        return str;
      }
      return str.replace(v.format.FORMAT_REGEXP, function(m0, m1, m2) {
        if (m1 === '%') {
          return "%{" + m2 + "}";
        } else {
          return String(vals[m2]);
        }
      });
    }, {
      // Finds %{key} style patterns in the given string
      FORMAT_REGEXP: /(%?)%\{([^\}]+)\}/g
    }),

    // "Prettifies" the given string.
    // Prettifying means replacing [.\_-] with spaces as well as splitting
    // camel case words.
    prettify: function(str) {
      if (v.isNumber(str)) {
        // If there are more than 2 decimals round it to two
        if ((str * 100) % 1 === 0) {
          return "" + str;
        } else {
          return parseFloat(Math.round(str * 100) / 100).toFixed(2);
        }
      }

      if (v.isArray(str)) {
        return str.map(function(s) { return v.prettify(s); }).join(", ");
      }

      if (v.isObject(str)) {
        return str.toString();
      }

      // Ensure the string is actually a string
      str = "" + str;

      return str
        // Splits keys separated by periods
        .replace(/([^\s])\.([^\s])/g, '$1 $2')
        // Removes backslashes
        .replace(/\\+/g, '')
        // Replaces - and - with space
        .replace(/[_-]/g, ' ')
        // Splits camel cased words
        .replace(/([a-z])([A-Z])/g, function(m0, m1, m2) {
          return "" + m1 + " " + m2.toLowerCase();
        })
        .toLowerCase();
    },

    stringifyValue: function(value, options) {
      var prettify = options && options.prettify || v.prettify;
      return prettify(value);
    },

    isString: function(value) {
      return typeof value === 'string';
    },

    isArray: function(value) {
      return {}.toString.call(value) === '[object Array]';
    },

    // Checks if the object is a hash, which is equivalent to an object that
    // is neither an array nor a function.
    isHash: function(value) {
      return v.isObject(value) && !v.isArray(value) && !v.isFunction(value);
    },

    contains: function(obj, value) {
      if (!v.isDefined(obj)) {
        return false;
      }
      if (v.isArray(obj)) {
        return obj.indexOf(value) !== -1;
      }
      return value in obj;
    },

    unique: function(array) {
      if (!v.isArray(array)) {
        return array;
      }
      return array.filter(function(el, index, array) {
        return array.indexOf(el) == index;
      });
    },

    forEachKeyInKeypath: function(object, keypath, callback) {
      if (!v.isString(keypath)) {
        return undefined;
      }

      var key = ""
        , i
        , escape = false;

      for (i = 0; i < keypath.length; ++i) {
        switch (keypath[i]) {
          case '.':
            if (escape) {
              escape = false;
              key += '.';
            } else {
              object = callback(object, key, false);
              key = "";
            }
            break;

          case '\\':
            if (escape) {
              escape = false;
              key += '\\';
            } else {
              escape = true;
            }
            break;

          default:
            escape = false;
            key += keypath[i];
            break;
        }
      }

      return callback(object, key, true);
    },

    getDeepObjectValue: function(obj, keypath) {
      if (!v.isObject(obj)) {
        return undefined;
      }

      return v.forEachKeyInKeypath(obj, keypath, function(obj, key) {
        if (v.isObject(obj)) {
          return obj[key];
        }
      });
    },

    // This returns an object with all the values of the form.
    // It uses the input name as key and the value as value
    // So for example this:
    // <input type="text" name="email" value="foo@bar.com" />
    // would return:
    // {email: "foo@bar.com"}
    collectFormValues: function(form, options) {
      var values = {}
        , i
        , j
        , input
        , inputs
        , option
        , value;

      if (v.isJqueryElement(form)) {
        form = form[0];
      }

      if (!form) {
        return values;
      }

      options = options || {};

      inputs = form.querySelectorAll("input[name], textarea[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);

        if (v.isDefined(input.getAttribute("data-ignored"))) {
          continue;
        }

        name = input.name.replace(/\./g, "\\\\.");
        value = v.sanitizeFormValue(input.value, options);
        if (input.type === "number") {
          value = value ? +value : null;
        } else if (input.type === "checkbox") {
          if (input.attributes.value) {
            if (!input.checked) {
              value = values[name] || null;
            }
          } else {
            value = input.checked;
          }
        } else if (input.type === "radio") {
          if (!input.checked) {
            value = values[name] || null;
          }
        }
        values[name] = value;
      }

      inputs = form.querySelectorAll("select[name]");
      for (i = 0; i < inputs.length; ++i) {
        input = inputs.item(i);
        if (v.isDefined(input.getAttribute("data-ignored"))) {
          continue;
        }

        if (input.multiple) {
          value = [];
          for (j in input.options) {
            option = input.options[j];
             if (option && option.selected) {
              value.push(v.sanitizeFormValue(option.value, options));
            }
          }
        } else {
          var _val = typeof input.options[input.selectedIndex] !== 'undefined' ? input.options[input.selectedIndex].value : '';
          value = v.sanitizeFormValue(_val, options);
        }
        values[input.name] = value;
      }

      return values;
    },

    sanitizeFormValue: function(value, options) {
      if (options.trim && v.isString(value)) {
        value = value.trim();
      }

      if (options.nullify !== false && value === "") {
        return null;
      }
      return value;
    },

    capitalize: function(str) {
      if (!v.isString(str)) {
        return str;
      }
      return str[0].toUpperCase() + str.slice(1);
    },

    // Remove all errors who's error attribute is empty (null or undefined)
    pruneEmptyErrors: function(errors) {
      return errors.filter(function(error) {
        return !v.isEmpty(error.error);
      });
    },

    // In
    // [{error: ["err1", "err2"], ...}]
    // Out
    // [{error: "err1", ...}, {error: "err2", ...}]
    //
    // All attributes in an error with multiple messages are duplicated
    // when expanding the errors.
    expandMultipleErrors: function(errors) {
      var ret = [];
      errors.forEach(function(error) {
        // Removes errors without a message
        if (v.isArray(error.error)) {
          error.error.forEach(function(msg) {
            ret.push(v.extend({}, error, {error: msg}));
          });
        } else {
          ret.push(error);
        }
      });
      return ret;
    },

    // Converts the error mesages by prepending the attribute name unless the
    // message is prefixed by ^
    convertErrorMessages: function(errors, options) {
      options = options || {};

      var ret = []
        , prettify = options.prettify || v.prettify;
      errors.forEach(function(errorInfo) {
        var error = v.result(errorInfo.error,
            errorInfo.value,
            errorInfo.attribute,
            errorInfo.options,
            errorInfo.attributes,
            errorInfo.globalOptions);

        if (!v.isString(error)) {
          ret.push(errorInfo);
          return;
        }

        if (error[0] === '^') {
          error = error.slice(1);
        } else if (options.fullMessages !== false) {
          error = v.capitalize(prettify(errorInfo.attribute)) + " " + error;
        }
        error = error.replace(/\\\^/g, "^");
        error = v.format(error, {
          value: v.stringifyValue(errorInfo.value, options)
        });
        ret.push(v.extend({}, errorInfo, {error: error}));
      });
      return ret;
    },

    // In:
    // [{attribute: "<attributeName>", ...}]
    // Out:
    // {"<attributeName>": [{attribute: "<attributeName>", ...}]}
    groupErrorsByAttribute: function(errors) {
      var ret = {};
      errors.forEach(function(error) {
        var list = ret[error.attribute];
        if (list) {
          list.push(error);
        } else {
          ret[error.attribute] = [error];
        }
      });
      return ret;
    },

    // In:
    // [{error: "<message 1>", ...}, {error: "<message 2>", ...}]
    // Out:
    // ["<message 1>", "<message 2>"]
    flattenErrorsToArray: function(errors) {
      return errors
        .map(function(error) { return error.error; })
        .filter(function(value, index, self) {
          return self.indexOf(value) === index;
        });
    },

    cleanAttributes: function(attributes, whitelist) {
      function whitelistCreator(obj, key, last) {
        if (v.isObject(obj[key])) {
          return obj[key];
        }
        return (obj[key] = last ? true : {});
      }

      function buildObjectWhitelist(whitelist) {
        var ow = {}
          , lastObject
          , attr;
        for (attr in whitelist) {
          if (!whitelist[attr]) {
            continue;
          }
          v.forEachKeyInKeypath(ow, attr, whitelistCreator);
        }
        return ow;
      }

      function cleanRecursive(attributes, whitelist) {
        if (!v.isObject(attributes)) {
          return attributes;
        }

        var ret = v.extend({}, attributes)
          , w
          , attribute;

        for (attribute in attributes) {
          w = whitelist[attribute];

          if (v.isObject(w)) {
            ret[attribute] = cleanRecursive(ret[attribute], w);
          } else if (!w) {
            delete ret[attribute];
          }
        }
        return ret;
      }

      if (!v.isObject(whitelist) || !v.isObject(attributes)) {
        return {};
      }

      whitelist = buildObjectWhitelist(whitelist);
      return cleanRecursive(attributes, whitelist);
    },

    exposeModule: function(validate, root, exports, module, define) {
      if (exports) {
        if (module && module.exports) {
          exports = module.exports = validate;
        }
        exports.validate = validate;
      } else {
        root.validate = validate;
        if (validate.isFunction(define) && define.amd) {
          define([], function () { return validate; });
        }
      }
    },

    warn: function(msg) {
      if (typeof console !== "undefined" && console.warn) {
        console.warn("[validate.js] " + msg);
      }
    },

    error: function(msg) {
      if (typeof console !== "undefined" && console.error) {
        console.error("[validate.js] " + msg);
      }
    }
  });

  validate.validators = {
    // Presence validates that the value isn't empty
    presence: function(value, options) {
      options = v.extend({}, this.options, options);
      if (options.allowEmpty !== false ? !v.isDefined(value) : v.isEmpty(value)) {
        return options.message || this.message || "can't be blank";
      }
    },
    length: function(value, options, attribute) {
      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var is = options.is
        , maximum = options.maximum
        , minimum = options.minimum
        , tokenizer = options.tokenizer || function(val) { return val; }
        , err
        , errors = [];

      value = tokenizer(value);
      var length = value.length;
      if(!v.isNumber(length)) {
        v.error(v.format("Attribute %{attr} has a non numeric value for `length`", {attr: attribute}));
        return options.message || this.notValid || "has an incorrect length";
      }

      // Is checks
      if (v.isNumber(is) && length !== is) {
        err = options.wrongLength ||
          this.wrongLength ||
          "is the wrong length (should be %{count} characters)";
        errors.push(v.format(err, {count: is}));
      }

      if (v.isNumber(minimum) && length < minimum) {
        err = options.tooShort ||
          this.tooShort ||
          "is too short (minimum is %{count} characters)";
        errors.push(v.format(err, {count: minimum}));
      }

      if (v.isNumber(maximum) && length > maximum) {
        err = options.tooLong ||
          this.tooLong ||
          "is too long (maximum is %{count} characters)";
        errors.push(v.format(err, {count: maximum}));
      }

      if (errors.length > 0) {
        return options.message || errors;
      }
    },
    numericality: function(value, options, attribute, attributes, globalOptions) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var errors = []
        , name
        , count
        , checks = {
            greaterThan:          function(v, c) { return v > c; },
            greaterThanOrEqualTo: function(v, c) { return v >= c; },
            equalTo:              function(v, c) { return v === c; },
            lessThan:             function(v, c) { return v < c; },
            lessThanOrEqualTo:    function(v, c) { return v <= c; },
            divisibleBy:          function(v, c) { return v % c === 0; }
          }
        , prettify = options.prettify ||
          (globalOptions && globalOptions.prettify) ||
          v.prettify;

      // Strict will check that it is a valid looking number
      if (v.isString(value) && options.strict) {
        var pattern = "^-?(0|[1-9]\\d*)";
        if (!options.onlyInteger) {
          pattern += "(\\.\\d+)?";
        }
        pattern += "$";

        if (!(new RegExp(pattern).test(value))) {
          return options.message ||
            options.notValid ||
            this.notValid ||
            this.message ||
            "must be a valid number";
        }
      }

      // Coerce the value to a number unless we're being strict.
      if (options.noStrings !== true && v.isString(value) && !v.isEmpty(value)) {
        value = +value;
      }

      // If it's not a number we shouldn't continue since it will compare it.
      if (!v.isNumber(value)) {
        return options.message ||
          options.notValid ||
          this.notValid ||
          this.message ||
          "is not a number";
      }

      // Same logic as above, sort of. Don't bother with comparisons if this
      // doesn't pass.
      if (options.onlyInteger && !v.isInteger(value)) {
        return options.message ||
          options.notInteger ||
          this.notInteger ||
          this.message ||
          "must be an integer";
      }

      for (name in checks) {
        count = options[name];
        if (v.isNumber(count) && !checks[name](value, count)) {
          // This picks the default message if specified
          // For example the greaterThan check uses the message from
          // this.notGreaterThan so we capitalize the name and prepend "not"
          var key = "not" + v.capitalize(name);
          var msg = options[key] ||
            this[key] ||
            this.message ||
            "must be %{type} %{count}";

          errors.push(v.format(msg, {
            count: count,
            type: prettify(name)
          }));
        }
      }

      if (options.odd && value % 2 !== 1) {
        errors.push(options.notOdd ||
            this.notOdd ||
            this.message ||
            "must be odd");
      }
      if (options.even && value % 2 !== 0) {
        errors.push(options.notEven ||
            this.notEven ||
            this.message ||
            "must be even");
      }

      if (errors.length) {
        return options.message || errors;
      }
    },
    datetime: v.extend(function(value, options) {
      if (!v.isFunction(this.parse) || !v.isFunction(this.format)) {
        throw new Error("Both the parse and format functions needs to be set to use the datetime/date validator");
      }

      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var err
        , errors = []
        , earliest = options.earliest ? this.parse(options.earliest, options) : NaN
        , latest = options.latest ? this.parse(options.latest, options) : NaN;

      value = this.parse(value, options);

      // 86400000 is the number of milliseconds in a day, this is used to remove
      // the time from the date
      if (isNaN(value) || options.dateOnly && value % 86400000 !== 0) {
        err = options.notValid ||
          options.message ||
          this.notValid ||
          "must be a valid date";
        return v.format(err, {value: arguments[0]});
      }

      if (!isNaN(earliest) && value < earliest) {
        err = options.tooEarly ||
          options.message ||
          this.tooEarly ||
          "must be no earlier than %{date}";
        err = v.format(err, {
          value: this.format(value, options),
          date: this.format(earliest, options)
        });
        errors.push(err);
      }

      if (!isNaN(latest) && value > latest) {
        err = options.tooLate ||
          options.message ||
          this.tooLate ||
          "must be no later than %{date}";
        err = v.format(err, {
          date: this.format(latest, options),
          value: this.format(value, options)
        });
        errors.push(err);
      }

      if (errors.length) {
        return v.unique(errors);
      }
    }, {
      parse: null,
      format: null
    }),
    date: function(value, options) {
      options = v.extend({}, options, {dateOnly: true});
      return v.validators.datetime.call(v.validators.datetime, value, options);
    },
    format: function(value, options) {
      if (v.isString(options) || (options instanceof RegExp)) {
        options = {pattern: options};
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is invalid"
        , pattern = options.pattern
        , match;

      // Empty values are allowed
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }

      if (v.isString(pattern)) {
        pattern = new RegExp(options.pattern, options.flags);
      }
      match = pattern.exec(value);
      if (!match || match[0].length != value.length) {
        return message;
      }
    },
    inclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (v.contains(options.within, value)) {
        return;
      }
      var message = options.message ||
        this.message ||
        "^%{value} is not included in the list";
      return v.format(message, {value: value});
    },
    exclusion: function(value, options) {
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (v.isArray(options)) {
        options = {within: options};
      }
      options = v.extend({}, this.options, options);
      if (!v.contains(options.within, value)) {
        return;
      }
      var message = options.message || this.message || "^%{value} is restricted";
      return v.format(message, {value: value});
    },
    email: v.extend(function(value, options) {
      options = v.extend({}, this.options, options);
      var message = options.message || this.message || "is not a valid email";
      // Empty values are fine
      if (!v.isDefined(value)) {
        return;
      }
      if (!v.isString(value)) {
        return message;
      }
      if (!this.PATTERN.exec(value)) {
        return message;
      }
    }, {
      PATTERN: /^[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+(?:\.[a-z0-9\u007F-\uffff!#$%&'*+\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z]{2,}$/i
    }),
    equality: function(value, options, attribute, attributes, globalOptions) {
      if (!v.isDefined(value)) {
        return;
      }

      if (v.isString(options)) {
        options = {attribute: options};
      }
      options = v.extend({}, this.options, options);
      var message = options.message ||
        this.message ||
        "is not equal to %{attribute}";

      if (v.isEmpty(options.attribute) || !v.isString(options.attribute)) {
        throw new Error("The attribute must be a non empty string");
      }

      var otherValue = v.getDeepObjectValue(attributes, options.attribute)
        , comparator = options.comparator || function(v1, v2) {
          return v1 === v2;
        }
        , prettify = options.prettify ||
          (globalOptions && globalOptions.prettify) ||
          v.prettify;

      if (!comparator(value, otherValue, options, attribute, attributes)) {
        return v.format(message, {attribute: prettify(options.attribute)});
      }
    },

    // A URL validator that is used to validate URLs with the ability to
    // restrict schemes and some domains.
    url: function(value, options) {
      if (!v.isDefined(value)) {
        return;
      }

      options = v.extend({}, this.options, options);

      var message = options.message || this.message || "is not a valid url"
        , schemes = options.schemes || this.schemes || ['http', 'https']
        , allowLocal = options.allowLocal || this.allowLocal || false;

      if (!v.isString(value)) {
        return message;
      }

      // https://gist.github.com/dperini/729294
      var regex =
        "^" +
        // protocol identifier
        "(?:(?:" + schemes.join("|") + ")://)" +
        // user:pass authentication
        "(?:\\S+(?::\\S*)?@)?" +
        "(?:";

      var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";

      if (allowLocal) {
        tld += "?";
      } else {
        regex +=
          // IP address exclusion
          // private & local networks
          "(?!(?:10|127)(?:\\.\\d{1,3}){3})" +
          "(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})" +
          "(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})";
      }

      regex +=
          // IP address dotted notation octets
          // excludes loopback network 0.0.0.0
          // excludes reserved space >= 224.0.0.0
          // excludes network & broacast addresses
          // (first & last IP address of each class)
          "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])" +
          "(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}" +
          "(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))" +
        "|" +
          // host name
          "(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)" +
          // domain name
          "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*" +
          tld +
        ")" +
        // port number
        "(?::\\d{2,5})?" +
        // resource path
        "(?:[/?#]\\S*)?" +
      "$";

      var PATTERN = new RegExp(regex, 'i');
      if (!PATTERN.exec(value)) {
        return message;
      }
    }
  };

  validate.formatters = {
    detailed: function(errors) {return errors;},
    flat: v.flattenErrorsToArray,
    grouped: function(errors) {
      var attr;

      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = v.flattenErrorsToArray(errors[attr]);
      }
      return errors;
    },
    constraint: function(errors) {
      var attr;
      errors = v.groupErrorsByAttribute(errors);
      for (attr in errors) {
        errors[attr] = errors[attr].map(function(result) {
          return result.validator;
        }).sort();
      }
      return errors;
    }
  };

  validate.exposeModule(validate, this, exports, module, __webpack_require__(561));
}).call(this,
         true ? /* istanbul ignore next */ exports : null,
         true ? /* istanbul ignore next */ module : null,
        __webpack_require__(561));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)(module)))

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  number: __webpack_require__(1457),
  expirationDate: __webpack_require__(1459),
  expirationMonth: __webpack_require__(564),
  expirationYear: __webpack_require__(361),
  cvv: __webpack_require__(1462),
  postalCode: __webpack_require__(1463),
  creditCardType: __webpack_require__(563)
};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var testOrder;
var types = {};
var customCards = {};
var VISA = 'visa';
var MASTERCARD = 'mastercard';
var AMERICAN_EXPRESS = 'american-express';
var DINERS_CLUB = 'diners-club';
var DISCOVER = 'discover';
var ELO = 'elo';
var JCB = 'jcb';
var UNIONPAY = 'unionpay';
var MAESTRO = 'maestro';
var MIR = 'mir';
var CVV = 'CVV';
var CID = 'CID';
var CVC = 'CVC';
var CVN = 'CVN';
var CVP2 = 'CVP2';
var CVE = 'CVE';
var ORIGINAL_TEST_ORDER = [
  VISA,
  MASTERCARD,
  AMERICAN_EXPRESS,
  DINERS_CLUB,
  DISCOVER,
  JCB,
  UNIONPAY,
  MAESTRO,
  ELO,
  MIR
];

function clone(originalObject, persistPatterns) {
  var dupe, prefixPattern, exactPattern;

  if (!originalObject) { return null; }

  prefixPattern = originalObject.prefixPattern;
  exactPattern = originalObject.exactPattern;
  dupe = JSON.parse(JSON.stringify(originalObject));

  if (persistPatterns) {
    dupe.prefixPattern = prefixPattern;
    dupe.exactPattern = exactPattern;
  } else {
    delete dupe.prefixPattern;
    delete dupe.exactPattern;
  }

  return dupe;
}

testOrder = clone(ORIGINAL_TEST_ORDER);

types[VISA] = {
  niceType: 'Visa',
  type: VISA,
  prefixPattern: /^4/,
  exactPattern: new RegExp('^' +
    '4' +
    '(?!' +
      '31274|51416|57393|0117[89]|38935|5763[12]' + // Elo cards
    ')\\d{5,}' +
  '$'),
  gaps: [4, 8, 12],
  lengths: [16, 18, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[MASTERCARD] = {
  niceType: 'Mastercard',
  type: MASTERCARD,
  prefixPattern: /^(5|5[1-5]|2|22|222|222[1-9]|2[3-6]|27|27[0-2]|2720)$/,
  exactPattern: /^(5[1-5]|222[1-9]|22[3-9]|2[3-6]|27[0-1]|2720)\d*$/,
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: CVC,
    size: 3
  }
};

types[AMERICAN_EXPRESS] = {
  niceType: 'American Express',
  type: AMERICAN_EXPRESS,
  prefixPattern: /^(3|34|37)$/,
  exactPattern: /^3[47]\d*$/,
  isAmex: true,
  gaps: [4, 10],
  lengths: [15],
  code: {
    name: CID,
    size: 4
  }
};

types[DINERS_CLUB] = {
  niceType: 'Diners Club',
  type: DINERS_CLUB,
  prefixPattern: /^(3|3[0689]|30[0-5])$/,
  exactPattern: /^3(0[0-5]|[689])\d*$/,
  gaps: [4, 10],
  lengths: [14, 16, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[DISCOVER] = {
  niceType: 'Discover',
  type: DISCOVER,
  prefixPattern: /^(6|60|601|6011|65|65\d{1,4}|64|64[4-9])$/,
  exactPattern: new RegExp('^(' +
    '6011' +
    '|' +
    '65' +
      '(?!' + // Elo cards
        '003[1-3]' +
        '|' +
        '003[5-9]|004\\d|005[0-1]' +
        '|' +
        '040[5-9]|04[1-3]\\d' +
        '|' +
        '048[5-9]|049\\d|05[0-2]\\d|053[0-8]' +
        '|' +
        '054[1-9]|05[5-8]\\d|059[0-8]' +
        '|' +
        '070\\d|071[0-8]' +
        '|' +
        '072[0-7]' +
        '|' +
        '090[1-9]|09[1-6]\\d|097[0-8]' +
        '|' +
        '165[2-9]|16[6-7]\\d' +
        '|' +
        '50[0-1]\\d' +
        '|' +
        '502[1-9]|50[3-4]\\d|505[0-8]' +
      ')\\d{4}' +
    '|' +
    '64[4-9]' +
  ')\\d*$'),
  gaps: [4, 8, 12],
  lengths: [16, 19],
  code: {
    name: CID,
    size: 3
  }
};

types[JCB] = {
  niceType: 'JCB',
  type: JCB,
  prefixPattern: /^(2|21|213|2131|1|18|180|1800|3|35)$/,
  exactPattern: /^(2131|1800|35)\d*$/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVV,
    size: 3
  }
};

types[UNIONPAY] = {
  niceType: 'UnionPay',
  type: UNIONPAY,
  prefixPattern: /^((6|62|62\d|(621(?!83|88|98|99))|622(?!06)|627[0267]\d?|628(?!0|1)|629[1,2])|622018)$/,
  exactPattern: new RegExp('^(' +
    '(' +
      '620' +
      '|' +
      '(621(?!83|88|98|99))' +
      '|' +
      '622(?!06|018)' +
      '|' +
      '62[3-6]' +
      '|' +
      '627[026]' +
      '|' +
      '6277(?!80)\\d{2}' + // Elo card
      '|' +
      '628(?!0|1)' +
      '|' +
      '629[12]' +
    ')\\d*' +

    '|' +

    '622018\\d{12}' +
  ')$'),
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVN,
    size: 3
  }
};

types[MAESTRO] = {
  niceType: 'Maestro',
  type: MAESTRO,
  prefixPattern: /^(5|5[06-9]|6\d*)$/,
  exactPattern: new RegExp('^(' +
    '5[6-9]' +
    '|' +
    '50' +
      '(?!' + // Elo card ranges
        '6699|067[0-6][0-9]' +
        '|' +
        '677[0-8]' +
        '|' +
        '9[0-9][0-9][0-9]' +
      ')\\d{4}' +
    '|' +
    '67' +
    '|' +
    '63' +
      '(?!' + // More Elo card ranges
        '6297|6368' +
      ')\\d{4}' +
    ')\\d*$'
  ),
  gaps: [4, 8, 12],
  lengths: [12, 13, 14, 15, 16, 17, 18, 19],
  code: {
    name: CVC,
    size: 3
  }
};

types[ELO] = {
  niceType: 'Elo',
  type: ELO,
  prefixPattern: new RegExp('^(' +
    '[4-6]' +

    '|' +

    '4[035]|4[035]1' +
    '|' +
    '4011|40117|40117[89]' +
    '|' +
    '4312|43127|431274' +
    '|' +
    '438|4389|43893|438935' +
    '|' +
    '4514|45141|451416' +
    '|' +
    '457|457[36]|45739|45763|457393|45763[12]' +

    '|' +

    '50|50[69]' +
    '|' +
    '506[6-7]|50669|5067[0-7]|5067[0-6][0-9]|50677[0-8]' +
    '|' +
    '509[0-9]|509[0-9][0-9]|509[0-9][0-9][0-9]' +

    '|' +

    '6[235]|627|636|65[015]' +
    '|' +
    '6277|62778|627780' +
    '|' +
    '636[23]|63629|636297|63636|636368' +
    '|' +
    '650[0479]' +
    '|' +
    '6500[3-5]|65003[1-3]|65003[5-9]|65004[0-9]65005[01]' +
    '|' +
    '6504[0-3]|65040[5-9]|65041[0-9]' +
    '|' +
    '6505[4-9]|65054[1-9]|6505[5-8][0-9]|65059[0-8]' +
    '|' +
    '6507[0-2]|65070[0-9]|65071[0-8]|65072[0-7]' +
    '|' +
    '6509[0-7]|65090[1-9]|6509[1-6][0-9]|65097[0-8]' +
    '|' +
    '6516|6516[5-7]|65165[2-9]|6516[6-7][0-9]' +
    '|' +
    '6550|6550[0-5]|6550[01][0-9]|65502[1-9]|6550[3-4][0-9]|65505[0-8]' +
  ')$'),
  exactPattern: new RegExp('^(' +
    // Elo only ranges
    '4(31274|51416|57393)' +

    '|' +

    '50(' +
      '4175' +
      '|' +
      '6699|67[0-6][0-9]|677[0-8]' + // 506699-506778
      '|' +
      '9[0-9][0-9][0-9]' + // 509000-509999
    ')' +

    '|' +

    '627780' +

    '|' +

    '636(297|368)' +

    '|' +

    // Dual Branded with Visa
    '4(0117[89]|38935|5763[12])' +

    '|' +

    // Dual Branded with Discover
    '65(' +
      '003[1-3]' + // 650031-650033
      '|' +
      '003[5-9]|004\\d|005[0-1]' + // 650035-650051
      '|' +
      '040[5-9]|04[1-3]\\d' + // 650405-650439
      '|' +
      '048[5-9]|049\\d|05[0-2]\\d|053[0-8]' + // 650485-650538
      '|' +
      '054[1-9]|05[5-8]\\d|059[0-8]' + // 650541-650598
      '|' +
      '070[0-9]|071[0-8]' + // 650700-650718
      '|' +
      '072[0-7]' + // 650720-650727
      '|' +
      '090[1-9]|09[1-6][0-9]|097[0-8]' + // 650901-650978
      '|' +
      '165[2-9]|16[6-7][0-9]' + // 651652-651679
      '|' +
      '50[0-1][0-9]' + // 655000-655019
      '|' +
      '502[1-9]|50[3-4][0-9]|505[0-8]' + // 655021-655058
    ')' +
  ')\\d*$'),
  gaps: [4, 8, 12],
  lengths: [16],
  code: {
    name: CVE,
    size: 3
  }
};

types[MIR] = {
  niceType: 'Mir',
  type: MIR,
  prefixPattern: /^(2|22|220|220[0-4])$/,
  exactPattern: /^(220[0-4])\d*$/,
  gaps: [4, 8, 12],
  lengths: [16, 17, 18, 19],
  code: {
    name: CVP2,
    size: 3
  }
};

function findType(type) {
  return customCards[type] || types[type];
}

function creditCardType(cardNumber) {
  var type, value, i;
  var prefixResults = [];
  var exactResults = [];

  if (!(typeof cardNumber === 'string' || cardNumber instanceof String)) {
    return [];
  }

  for (i = 0; i < testOrder.length; i++) {
    type = testOrder[i];
    value = findType(type);

    if (cardNumber.length === 0) {
      prefixResults.push(clone(value));
      continue;
    }

    if (value.exactPattern.test(cardNumber)) {
      exactResults.push(clone(value));
    } else if (value.prefixPattern.test(cardNumber)) {
      prefixResults.push(clone(value));
    }
  }

  return exactResults.length ? exactResults : prefixResults;
}

creditCardType.getTypeInfo = function (type) {
  return clone(findType(type));
};

function getCardPosition(name, ignoreErrorForNotExisting) {
  var position = testOrder.indexOf(name);

  if (!ignoreErrorForNotExisting && position === -1) {
    throw new Error('"' + name + '" is not a supported card type.');
  }

  return position;
}

creditCardType.removeCard = function (name) {
  var position = getCardPosition(name);

  testOrder.splice(position, 1);
};

creditCardType.addCard = function (config) {
  var existingCardPosition = getCardPosition(config.type, true);

  customCards[config.type] = config;

  if (existingCardPosition === -1) {
    testOrder.push(config.type);
  }
};

creditCardType.updateCard = function (cardType, updates) {
  var clonedCard;
  var originalObject = customCards[cardType] || types[cardType];

  if (!originalObject) {
    throw new Error('"' + cardType + '" is not a recognized type. Use `addCard` instead.');
  }

  if (updates.type && originalObject.type !== updates.type) {
    throw new Error('Cannot overwrite type parameter.');
  }

  clonedCard = clone(originalObject, true);

  Object.keys(clonedCard).forEach(function (key) {
    if (updates[key]) {
      clonedCard[key] = updates[key];
    }
  });

  customCards[clonedCard.type] = clonedCard;
};

creditCardType.changeOrder = function (name, position) {
  var currentPosition = getCardPosition(name);

  testOrder.splice(currentPosition, 1);
  testOrder.splice(position, 0, name);
};

creditCardType.resetModifications = function () {
  testOrder = clone(ORIGINAL_TEST_ORDER);
  customCards = {};
};

creditCardType.types = {
  VISA: VISA,
  MASTERCARD: MASTERCARD,
  AMERICAN_EXPRESS: AMERICAN_EXPRESS,
  DINERS_CLUB: DINERS_CLUB,
  DISCOVER: DISCOVER,
  JCB: JCB,
  UNIONPAY: UNIONPAY,
  MAESTRO: MAESTRO,
  ELO: ELO,
  MIR: MIR
};

module.exports = creditCardType;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function verification(isValid, isPotentiallyValid, isValidForThisYear) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    isValidForThisYear: isValidForThisYear || false
  };
}

function expirationMonth(value) {
  var month, result;
  var currentMonth = new Date().getMonth() + 1;

  if (typeof value !== 'string') {
    return verification(false, false);
  }
  if (value.replace(/\s/g, '') === '' || value === '0') {
    return verification(false, true);
  }
  if (!/^\d*$/.test(value)) {
    return verification(false, false);
  }

  month = parseInt(value, 10);

  if (isNaN(value)) {
    return verification(false, false);
  }

  result = month > 0 && month < 13;

  return verification(result, result, result && month >= currentMonth);
}

module.exports = expirationMonth;


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(9);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(298);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _PropTypes = __webpack_require__(567);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm A fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `ENTERING`
 *  - `ENTERED`
 *  - `EXITING`
 *  - `EXITED`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state= { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) when finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null }; // allows for nested Transitions
  };

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true);
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var status = this.state.status;


    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;


    if (this.nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (this.nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }

      this.nextStatus = null;
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    this.setState(nextState, this.setNextCallback(callback));
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `apprear` only an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration for the transition, in milliseconds.
   * Required unless `addEventListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "enter" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occuring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = Transition;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core
var space = __webpack_require__(1502);
var width = __webpack_require__(1538);
var fontSize = __webpack_require__(1539);
var color = __webpack_require__(1540);

// low-level style function creators
var style = __webpack_require__(99);
var responsiveStyle = __webpack_require__(111);
var pseudoStyle = __webpack_require__(181);

// extras
var textAlign = __webpack_require__(1541);
var lineHeight = __webpack_require__(1542);
var fontWeight = __webpack_require__(1543);
var letterSpacing = __webpack_require__(1544);
var alignItems = __webpack_require__(1545);
var justifyContent = __webpack_require__(1546);
var flexWrap = __webpack_require__(1547);
var flexDirection = __webpack_require__(1548);
var flex = __webpack_require__(1549);
var alignSelf = __webpack_require__(1550);
var borderRadius = __webpack_require__(1551);
var borderColor = __webpack_require__(1552);
var borderWidth = __webpack_require__(1553);
var boxShadow = __webpack_require__(1554);
var maxWidth = __webpack_require__(1555);
var hover = __webpack_require__(1556);
var focus = __webpack_require__(1557);
var active = __webpack_require__(1558);
var disabled = __webpack_require__(1559);

// other
var theme = __webpack_require__(1560);
var propTypes = __webpack_require__(585);
var cleanElement = __webpack_require__(1564);
var removeProps = __webpack_require__(1576);
var util = __webpack_require__(98);
var constants = __webpack_require__(239);

module.exports = {
  space: space,
  width: width,
  fontSize: fontSize,
  color: color,
  style: style,
  responsiveStyle: responsiveStyle,
  pseudoStyle: pseudoStyle,
  textAlign: textAlign,
  lineHeight: lineHeight,
  fontWeight: fontWeight,
  letterSpacing: letterSpacing,
  alignItems: alignItems,
  justifyContent: justifyContent,
  flexWrap: flexWrap,
  flexDirection: flexDirection,
  flex: flex,
  alignSelf: alignSelf,
  borderRadius: borderRadius,
  borderColor: borderColor,
  borderWidth: borderWidth,
  boxShadow: boxShadow,
  maxWidth: maxWidth,
  hover: hover,
  focus: focus,
  active: active,
  disabled: disabled,
  theme: theme,
  propTypes: propTypes,
  cleanElement: cleanElement,
  removeProps: removeProps,
  util: util,
  constants: constants
};

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(76) && !__webpack_require__(132)(function () {
  return Object.defineProperty(__webpack_require__(572)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(97);
var document = __webpack_require__(87).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(109);


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(133);
var toIObject = __webpack_require__(154);
var arrayIndexOf = __webpack_require__(1510)(false);
var IE_PROTO = __webpack_require__(371)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(133);
var toObject = __webpack_require__(134);
var IE_PROTO = __webpack_require__(371)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1515), __esModule: true };

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1517), __esModule: true };

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(67);
var core = __webpack_require__(50);
var fails = __webpack_require__(132);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(366);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(574);
var hiddenKeys = __webpack_require__(373).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(238);
var createDesc = __webpack_require__(177);
var toIObject = __webpack_require__(154);
var toPrimitive = __webpack_require__(369);
var has = __webpack_require__(133);
var IE8_DOM_DEFINE = __webpack_require__(571);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(76) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 582 */
/***/ (function(module, exports) {



/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(110);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(153);
var ITERATOR = __webpack_require__(58)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var PropTypes = __webpack_require__(1561);

var responsive = PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.array]);

var responsiveBoolean = PropTypes.oneOfType([PropTypes.bool, PropTypes.array]);

var numberOrString = PropTypes.oneOfType([PropTypes.number, PropTypes.string]);

var width = {
  width: responsive,
  w: responsive
};

var space = {
  m: responsive,
  mt: responsive,
  mr: responsive,
  mb: responsive,
  ml: responsive,
  mx: responsive,
  my: responsive,
  p: responsive,
  pt: responsive,
  pr: responsive,
  pb: responsive,
  pl: responsive,
  px: responsive,
  py: responsive
};

var fontSize = {
  fontSize: responsive,
  f: responsive
};

var color = {
  color: responsive,
  bg: responsive
};

var textAlign = {
  align: responsive
};

var fontWeight = {
  fontWeight: numberOrString
};

var lineHeight = {
  lineHeight: numberOrString
};

var alignItems = {
  align: responsive
};

var justifyContent = {
  justify: responsive
};

var flexWrap = {
  wrap: responsiveBoolean
};

var flexDirection = {
  flexDirection: responsive
};

var flex = {
  flex: responsive
};

var alignSelf = {
  alignSelf: responsive
};

var maxWidth = {
  maxWidth: numberOrString
};

var borderRadius = {
  borderRadius: numberOrString
};

var borderWidth = {
  borderWidth: numberOrString,
  borderTop: PropTypes.bool,
  borderRight: PropTypes.bool,
  borderBottom: PropTypes.bool,
  borderLeft: PropTypes.bool
};

var borderColor = {
  borderColor: PropTypes.string
};

var boxShadow = {
  boxShadow: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

var hover = {
  hover: PropTypes.object
};

var focus = {
  focus: PropTypes.object
};

var active = {
  active: PropTypes.object
};

var disabled = {
  disabledStyle: PropTypes.object
};

var propTypes = {
  width: width,
  space: space,
  fontSize: fontSize,
  color: color,
  textAlign: textAlign,
  fontWeight: fontWeight,
  lineHeight: lineHeight,
  alignItems: alignItems,
  justifyContent: justifyContent,
  flexWrap: flexWrap,
  flexDirection: flexDirection,
  flex: flex,
  alignSelf: alignSelf,
  maxWidth: maxWidth,
  borderRadius: borderRadius,
  borderWidth: borderWidth,
  borderColor: borderColor,
  boxShadow: boxShadow,
  hover: hover,
  focus: focus,
  active: active,
  disabled: disabled
};

module.exports = propTypes;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(9);

var responsivePropType = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string, _propTypes.array]);

var propTypes = {
  width: responsivePropType,
  fontSize: responsivePropType,
  color: responsivePropType,
  bg: responsivePropType,
  m: responsivePropType,
  mt: responsivePropType,
  mr: responsivePropType,
  mb: responsivePropType,
  ml: responsivePropType,
  mx: responsivePropType,
  my: responsivePropType,
  p: responsivePropType,
  pt: responsivePropType,
  pr: responsivePropType,
  pb: responsivePropType,
  pl: responsivePropType,
  px: responsivePropType,
  py: responsivePropType
};

exports.default = propTypes;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Dropdown/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _propTypes2=_interopRequireDefault(_propTypes);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _styles=__webpack_require__(386);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function Dropdown(_ref){var categoryLabel=_ref.categoryLabel,dropdownLabel=_ref.dropdownLabel,headerLabelCategory=_ref.headerLabelCategory,onClick=_ref.onClick,isOpen=_ref.isOpen;return _react2.default.createElement(_styles.DropdownContainer,{isOpen:isOpen,onClick:onClick,__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement(_styles.HeaderLabel,{component:headerLabelCategory,__source:{fileName:_jsxFileName,lineNumber:16}},categoryLabel),_react2.default.createElement(_styles.DropdownLabelContainer,{__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement(_styles.DropdownLabel,{__source:{fileName:_jsxFileName,lineNumber:18}},dropdownLabel),_react2.default.createElement(_Icon2.default,{icon:'dropdown-arrow',svgStyle:_styles.DropdownArrow,width:'12',height:'7',viewBox:'0 0 12 7',__source:{fileName:_jsxFileName,lineNumber:19}})));}Dropdown.defaultProps={categoryLabel:'',dropdownLabel:'',headerLabelCategory:'',onClick:null};Dropdown.propTypes={categoryLabel:_propTypes2.default.string,dropdownLabel:_propTypes2.default.string,headerLabelCategory:_propTypes2.default.string,onClick:_propTypes2.default.func};exports.default=Dropdown;module.exports=exports['default'];

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/DropdownList/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _propTypes2=_interopRequireDefault(_propTypes);var _textSlug=__webpack_require__(184);var _styles=__webpack_require__(589);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function DropdownList(_ref){var options=_ref.options,isOpen=_ref.isOpen,onClose=_ref.onClose,userCancelled=_ref.userCancelled;function checkUserStatus(option){return option.cancelledMenu?option.link:'#';}var closeDropdown=function closeDropdown(onClick){if(onClose){onClose();}if(onClick){onClick();}};var gtmLabel='item:';return _react2.default.createElement(_styles.DropdownListContainer,{isOpen:isOpen,__source:{fileName:_jsxFileName,lineNumber:26}},options.map(function(option,index){return _react2.default.createElement(_styles.DropdownListItem,{key:index,userCancelled:userCancelled,onClick:function onClick(){return closeDropdown(option.onClick);},cancelledMenuItem:option.cancelledMenu,__source:{fileName:_jsxFileName,lineNumber:28}},option.onClick?_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:35}},option.title&&_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:36}},option.title),option.description&&_react2.default.createElement(_styles.Description,{className:'gtm-element-event','data-gtm-event-category':'veloe:area-logado:geral','data-gtm-event-action':'clique:menu-principal','data-gtm-event-label':gtmLabel+(0,_textSlug.converText)(option.description),__source:{fileName:_jsxFileName,lineNumber:38}},option.description)):_react2.default.createElement(_styles.DropdowLink,{to:userCancelled?checkUserStatus(option):option.link,className:'gtm-link-event','data-gtm-event-category':'veloe:area-logado:geral','data-gtm-event-action':'clique:menu-principal','data-gtm-event-label':gtmLabel+(0,_textSlug.converText)(option.description),__source:{fileName:_jsxFileName,lineNumber:49}},option.title&&_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:56}},option.title),option.description&&_react2.default.createElement(_styles.Description,{__source:{fileName:_jsxFileName,lineNumber:57}},option.description)));}));}DropdownList.defaultProps={options:[],isOpen:false,title:null,description:null,userCancelled:false};DropdownList.propTypes={options:_propTypes2.default.arrayOf(_propTypes2.default.shape({link:_propTypes2.default.string,title:_propTypes2.default.string,description:_propTypes2.default.string,cancelledMenu:_propTypes2.default.bool})),isOpen:_propTypes2.default.bool,userCancelled:_propTypes2.default.bool};exports.default=DropdownList;module.exports=exports['default'];

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DropdowLink=exports.DropdownListItem=exports.DropdownListContainer=exports.Title=exports.Description=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Description=exports.Description=_styledComponents2.default.span.withConfig({displayName:'styles__Description',componentId:'sc-dmm0ru-0'})(['display:block;']);var Title=exports.Title=_styledComponents2.default.span.withConfig({displayName:'styles__Title',componentId:'sc-dmm0ru-1'})(['',';color:',';display:block;line-height:1;text-transform:capitalize;+ ','{',';}'],_types.title16Galano,_colors.linkNavyBlue,Description,_types.txt12OpenSansLight);var DropdownListContainer=exports.DropdownListContainer=_styledComponents2.default.ul.withConfig({displayName:'styles__DropdownListContainer',componentId:'sc-dmm0ru-2'})(['background-color:white;border-radius:',';box-shadow:0 ',' ',' 0 rgba(0,0,0,0.2);display:flex;flex-direction:column;left:0;padding:0 0 ',';pointer-events:none;position:absolute;top:',';visibility:hidden;width:100%;z-index:101;margin:0;',';'],(0,_rem2.default)('2px'),(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),(0,_rem2.default)('32px'),(0,_rem2.default)('90px'),function(props){return props.isOpen&&'\n        pointer-events: all;\n        visibility: visible;\n    ';});var DropdownListItem=exports.DropdownListItem=_styledComponents2.default.li.withConfig({displayName:'styles__DropdownListItem',componentId:'sc-dmm0ru-3'})(['color:',';font-family:\'OpenSans\';font-size:',';font-weight:bold;margin:0 ',';text-decoration:none;padding:0;list-style:none;:not(:last-child){margin-bottom:',';}',' ',';'],_colors.menuOptionGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('22px'),(0,_rem2.default)('24px'),function(props){return props.userCancelled&&'\n        color: '+_colors.linkNavyBlue+';\n        cursor: default;\n        opacity: 0.2;\n        pointer-events: none;\n    ';},function(props){return props.cancelledMenuItem&&'\n        color: '+_colors.menuOptionGrey+';\n        cursor: pointer;\n        opacity: 1;\n        pointer-events: all;\n    ';});var DropdowLink=exports.DropdowLink=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__DropdowLink',componentId:'sc-dmm0ru-4'})(['text-decoration:none;color:inherit;']);

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.OverlayClick=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ClickOut/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(1652);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var ClickOut=function(_Component){_inherits(ClickOut,_Component);function ClickOut(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClickOut);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClickOut.__proto__||Object.getPrototypeOf(ClickOut)).call.apply(_ref,[this].concat(args))),_this),_this.onSelfClick=function(e){e.clickOutTarget=_this.el;},_this.onAnyClick=function(e){var _this2=_this,el=_this2.el,callback=_this2.props.callback;if(e.clickOutTarget!==el){callback(e);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClickOut,[{key:'componentDidMount',value:function componentDidMount(){this.el.addEventListener('click',this.onSelfClick);document.addEventListener('click',this.onAnyClick);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.el.removeEventListener('click',this.onSelfClick);document.removeEventListener('click',this.onAnyClick);}},{key:'render',value:function render(){var _this3=this;return _react2.default.createElement('div',{ref:function ref(el){_this3.el=el;},__source:{fileName:_jsxFileName,lineNumber:30}},this.props.children);}}]);return ClickOut;}(_react.Component);exports.default=ClickOut;var OverlayClick=exports.OverlayClick=function OverlayClick(_ref2){var isOpen=_ref2.isOpen,onClick=_ref2.onClick;return _react2.default.createElement(_styles.Overlay,{isOpen:isOpen,onClick:onClick,__source:{fileName:_jsxFileName,lineNumber:43}});};

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1654);


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.VeloeLogo=exports.TelephoneNumber=exports.SocialIcons=exports.NavigationText=exports.NavigationLabel=exports.NavigationContent=exports.NavigationColumn=exports.NavigationBottomItem=exports.DescriptionItem=exports.LogoSocial=exports.FooterNavigation=exports.AppsLinkContainer=exports.AppIcon=exports.Row=exports.CardFlag=exports.CardsContainer=exports.CardsFlags=exports.FooterContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n      flex-direction: column-reverse;\n      padding: 0px 0px 30px;\n  '],['\n      flex-direction: column-reverse;\n      padding: 0px 0px 30px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    margin-bottom: 0;\n  '],['\n    margin-bottom: 0;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    flex-flow: wrap;\n  '],['\n    flex-flow: wrap;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n        margin-top: 30px;\n    '],['\n        margin-top: 30px;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FooterContainer=exports.FooterContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FooterContainer',componentId:'sc-1j47pw6-0'})(['background-color:',';font-family:\'OpenSans\';overflow:hidden;width:100%;'],_colors.linkNavyBlue);var CardsFlags=exports.CardsFlags=_styledComponents2.default.div.withConfig({displayName:'styles__CardsFlags',componentId:'sc-1j47pw6-1'})(['display:flex;']);var CardsContainer=exports.CardsContainer=_styledComponents2.default.div.withConfig({displayName:'styles__CardsContainer',componentId:'sc-1j47pw6-2'})(['align-items:center;color:',';display:flex;font-size:',';justify-content:center;letter-spacing:',';padding:30px 0;',';'],_colors.greyBlue,(0,_rem2.default)('12px'),(0,_rem2.default)('0.8px'),_media2.default.small(_templateObject));var CardFlag=exports.CardFlag='height: 30px; width: 50px; margin-right: 10px';var Row=exports.Row=_styledComponents2.default.div.withConfig({displayName:'styles__Row',componentId:'sc-1j47pw6-3'})(['margin-bottom:20px;display:block;']);var AppIcon=exports.AppIcon='height: 38px; width: 110px; margin: 17px 20px 0 0;';var AppsLinkContainer=exports.AppsLinkContainer=_styledComponents2.default.div.withConfig({displayName:'styles__AppsLinkContainer',componentId:'sc-1j47pw6-4'})(['display:flex;']);var FooterNavigation=exports.FooterNavigation=_styledComponents2.default.div.withConfig({displayName:'styles__FooterNavigation',componentId:'sc-1j47pw6-5'})(['align-items:center;background-color:',';color:',';display:flex;justify-content:center;padding:50px 0 20px;'],_colors.linkNavyBlue,_colors.paleBlue);var LogoSocial=exports.LogoSocial=_styledComponents2.default.div.withConfig({displayName:'styles__LogoSocial',componentId:'sc-1j47pw6-6'})(['align-items:center;display:flex;flex-direction:column;margin-right:140px;']);var DescriptionItem=exports.DescriptionItem=_styledComponents2.default.p.withConfig({displayName:'styles__DescriptionItem',componentId:'sc-1j47pw6-7'})(['font-size:',';font-weight:600;margin:0;&:last-child{margin-bottom:0;}'],(0,_rem2.default)('12px'));var NavigationBottomItem=exports.NavigationBottomItem=_styledComponents2.default.div.withConfig({displayName:'styles__NavigationBottomItem',componentId:'sc-1j47pw6-8'})(['display:flex;flex-direction:column;margin-top:48px;','{margin-bottom:0;}'],DescriptionItem);var NavigationColumn=exports.NavigationColumn=_styledComponents2.default.div.withConfig({displayName:'styles__NavigationColumn',componentId:'sc-1j47pw6-9'})(['display:flex;flex-direction:column;width:240px;justify-content:center;',';'],_media2.default.small(_templateObject2));var NavigationContent=exports.NavigationContent=_styledComponents2.default.div.withConfig({displayName:'styles__NavigationContent',componentId:'sc-1j47pw6-10'})(['display:flex;justify-content:space-between;width:100%;',';'],_media2.default.small(_templateObject3));var NavigationLabel=exports.NavigationLabel=_styledComponents2.default.div.withConfig({displayName:'styles__NavigationLabel',componentId:'sc-1j47pw6-11'})(['',';'],function(_ref){var bold=_ref.bold;return bold?_types.txt16OpenSansBold:_types.txt16OpenSans;});var NavigationText=exports.NavigationText=_styledComponents2.default.span.withConfig({displayName:'styles__NavigationText',componentId:'sc-1j47pw6-12'})(['font-size:',';line-height:1.5;text-align:center;',';',';'],(0,_rem2.default)('12px'),function(_ref2){var marginOnSmall=_ref2.marginOnSmall;return marginOnSmall&&_media2.default.small(_templateObject4);},function(props){return props.short&&'\n      max-width: '+(0,_rem2.default)('200px')+';\n  ';});var SocialIcons=exports.SocialIcons='height: 24px; width: 58px;';var TelephoneNumber=exports.TelephoneNumber=_styledComponents2.default.span.withConfig({displayName:'styles__TelephoneNumber',componentId:'sc-1j47pw6-13'})(['color:',';font-family:\'Galano\';font-size:',';font-weight:600;margin-top:5px;'],_colors.white,(0,_rem2.default)('24px'));var VeloeLogo=exports.VeloeLogo='fill: '+_colors.white+'; height: 41px; width: 99px; margin-bottom: 15px;';

/***/ }),
/* 593 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    "accesskey": "accessKey",
    "charset": "charSet",
    "class": "className",
    "contenteditable": "contentEditable",
    "contextmenu": "contextMenu",
    "http-equiv": "httpEquiv",
    "itemprop": "itemProp",
    "tabindex": "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/TextInput/Tooltip.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _propTypes=__webpack_require__(9);var _propTypes2=_interopRequireDefault(_propTypes);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Tooltip=_styledComponents2.default.div.withConfig({displayName:'Tooltip',componentId:'sc-1nw0soz-0'})(['position:relative;display:block;']);var TooltipText=_styledComponents2.default.span.withConfig({displayName:'Tooltip__TooltipText',componentId:'sc-1nw0soz-1'})(['',';color:#fff;visibility:',';width:200px;background-color:',';text-align:center;border-radius:6px;padding:5px 0;position:absolute;z-index:1;left:50%;',' &::after{',';}'],_types.txt12OpenSansBold,function(_ref){var show=_ref.show;return show?'visible':'hidden';},function(_ref2){var tooltipColor=_ref2.tooltipColor;return tooltipColor?''+tooltipColor:'black';},function(_ref3){var positionRight=_ref3.positionRight;return positionRight?'\n    transform: translateX(65%);\n    top: 0;\n  ':'\n  transform: translateX(-50%);\n  top: 115%;\n  ';},function(_ref4){var positionRight=_ref4.positionRight,tooltipColor=_ref4.tooltipColor;return positionRight?'\n    content: \'\';\n    position: absolute;\n    bottom: 45%;\n    left: -2%;\n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent '+(tooltipColor?''+tooltipColor:'black')+' transparent transparent;\n    ':'\n    content: \'\';\n    position: absolute;\n    bottom: 100%;\n    left: 50%;    \n    margin-left: -5px;\n    border-width: 5px;\n    border-style: solid;\n    border-color: transparent transparent\n      '+(tooltipColor?''+tooltipColor:'black')+' transparent;\n    ';});var TooltipComponent=function TooltipComponent(_ref5){var text=_ref5.text,showTooltip=_ref5.showTooltip,children=_ref5.children,tooltipColor=_ref5.tooltipColor,positionRight=_ref5.positionRight;return _react2.default.createElement(Tooltip,{__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(TooltipText,{tooltipColor:tooltipColor,positionRight:positionRight,show:showTooltip,__source:{fileName:_jsxFileName,lineNumber:61}},text),children);};TooltipComponent.propTypes={text:_propTypes2.default.string.isRequired,showTooltip:_propTypes2.default.bool.isRequired};TooltipComponent.defaultProps={text:'',showTooltip:false};exports.default=TooltipComponent;module.exports=exports['default'];

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Select=__webpack_require__(1690);var _Select2=_interopRequireDefault(_Select);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Select2.default;module.exports=exports['default'];

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _stripDiacritics = __webpack_require__(597);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = (0, _stripDiacritics2['default'])(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);
		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2['default'])(valueTest);
			if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2['default'])(labelTest);
		}
		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

module.exports = filterOptions;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

module.exports = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _classnames = __webpack_require__(251);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption;
	var instancePrefix = _ref.instancePrefix;
	var labelKey = _ref.labelKey;
	var onFocus = _ref.onFocus;
	var onSelect = _ref.onSelect;
	var optionClassName = _ref.optionClassName;
	var optionComponent = _ref.optionComponent;
	var optionRenderer = _ref.optionRenderer;
	var options = _ref.options;
	var valueArray = _ref.valueArray;
	var valueKey = _ref.valueKey;
	var onOptionRef = _ref.onOptionRef;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.indexOf(option) > -1;
		var isFocused = option === focusedOption;
		var optionClass = (0, _classnames2['default'])(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return _react2['default'].createElement(
			Option,
			{
				className: optionClass,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function (ref) {
					onOptionRef(ref, isFocused);
				}
			},
			optionRenderer(option, i)
		);
	});
}

module.exports = menuRenderer;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _PasswordInput=__webpack_require__(1707);var _PasswordInput2=_interopRequireDefault(_PasswordInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_PasswordInput2.default;module.exports=exports['default'];

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/icSearch.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Path=_styledComponents2.default.path.withConfig({displayName:'icSearch__Path',componentId:'sc-15cgtnl-0'})(['',';'],function(_ref){var active=_ref.active,hover=_ref.hover;if(active)return'fill: #2a2264';if(hover)return'fill: #8583a4';return'fill: #c5c3d8';});var IcSearch=function IcSearch(props){return _react2.default.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',width:'24',height:'24',viewBox:'0 0 24 24',__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(Path,_extends({},props,{d:'M10.974 18.876c-2.13 0-4.116-.83-5.642-2.32A7.895 7.895 0 0 1 3 10.937c0-2.12.835-4.098 2.332-5.617A7.967 7.967 0 0 1 10.974 3c2.13 0 4.117.831 5.643 2.321a7.895 7.895 0 0 1 2.331 5.617c0 2.12-.834 4.098-2.331 5.617-1.526 1.49-3.512 2.321-5.643 2.321zm0-14.128c-3.426 0-6.218 2.78-6.218 6.19 0 3.41 2.792 6.19 6.218 6.19s6.218-2.78 6.218-6.19c-.028-3.41-2.792-6.19-6.218-6.19zm-3.742 7.079a.895.895 0 0 1-.893-.889 4.56 4.56 0 0 1 4.578-4.556c.49 0 .892.4.892.888a.895.895 0 0 1-.892.888 2.82 2.82 0 0 0-2.822 2.809c.03.458-.374.86-.863.86zM21.136 22a.895.895 0 0 1-.633-.258l-2.936-2.923a.862.862 0 0 1 0-1.232.872.872 0 0 1 1.238 0l2.936 2.923a.862.862 0 0 1 0 1.232.786.786 0 0 1-.605.258z',__source:{fileName:_jsxFileName,lineNumber:14}})));};exports.default=IcSearch;module.exports=exports['default'];

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonContainer=exports.LastSavedLabel=exports.AddressFormsContainer=exports.ExcludeLinkContainer=exports.SecondaryHeading=exports.ExcludeLink=exports.Paragraph=exports.Heading=exports.Wrapper=exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n        width: ',';\n    '],['\n        width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        width: 100%\n    '],['\n        width: 100%\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-17bkpm2-0'})(['',';margin:',' auto;'],_content2.default,(0,_rem2.default)('42px'));var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-17bkpm2-1'})(['margin-top:',';'],(0,_rem2.default)('32px'));var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-17bkpm2-2'})(['',' color:',';'],_types.title24Galano,_colors.darkBlue);var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-17bkpm2-3'})(['',' color:',';width:',';',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('270px'),_media2.default.large(_templateObject,(0,_rem2.default)('435px')));var ExcludeLink=exports.ExcludeLink=_styledComponents2.default.a.withConfig({displayName:'styles__ExcludeLink',componentId:'sc-17bkpm2-4'})(['color:',';cursor:pointer;font-family:OpenSans;font-size:',';margin-left:',';'],_colors.darkGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('9px'));var SecondaryHeading=exports.SecondaryHeading=_styledComponents2.default.div.withConfig({displayName:'styles__SecondaryHeading',componentId:'sc-17bkpm2-5'})(['align-items:center;display:flex;justify-content:space-between;']);var ExcludeLinkContainer=exports.ExcludeLinkContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ExcludeLinkContainer',componentId:'sc-17bkpm2-6'})(['align-items:center;display:flex;']);var AddressFormsContainer=exports.AddressFormsContainer=_styledComponents2.default.div.withConfig({displayName:'styles__AddressFormsContainer',componentId:'sc-17bkpm2-7'})(['',';'],function(props){return props.index===1&&'\n        border-top: 1px solid '+_colors.grey+';\n        margin: '+(0,_rem2.default)('16px')+' 0;\n        padding-top: '+(0,_rem2.default)('32px')+';\n    ';});var LastSavedLabel=exports.LastSavedLabel=_styledComponents2.default.label.withConfig({displayName:'styles__LastSavedLabel',componentId:'sc-17bkpm2-8'})(['color:',';display:block;font-family:OpenSans;font-size:',';letter-spacing:',';margin-top:',';text-transform:uppercase;'],_colors.grey,(0,_rem2.default)('12px'),(0,_rem2.default)('1px'),(0,_rem2.default)('8px'));var ButtonContainer=exports.ButtonContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonContainer',componentId:'sc-17bkpm2-9'})(['',' ',';'],function(props){return props.amount==='singular'&&'\n        float: left;\n        margin-right: '+(0,_rem2.default)('20px')+';\n    ';},_media2.default.small(_templateObject2));

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = {"buttonText":"salvar","labels":{"current":"Senha atual*","new":"Nova senha*","confirm":"Confirme sua senha*"},"placeholders":{"current":"Aquela que só você sabe ;)","new":"Pensa direitinho, hein?","confirm":"Digite de novo, só para garantir."},"passwordStrength":{"high":"Sua senha parece ótima! \\o/"},"stepBox":{"title":"Sua senha deve ter","newPasswordLength":"Entre 6 e 14 caracteres.","upperLetterNeeded":"Uma letra maiuscula","lowerLetterNeeded":"Uma letra minúscula","letterNeeded":"Pelo menos uma letra.","numberNeeded":"Pelo menos um número.","especialNeeded":"Um caractere especial exceto % ( ) & + \\ ' > <"},"errors":{"notFilled":"Não preencheu todos os campos","wrongPassword":"Opa! Essa não parece ser sua senha. Tente novamente.","newPasswordLength":"Sua nova senha precisa ter entre 6 e 14 caracteres.","letterNeeded":"Sua nova senha precisa ter pelo menos uma letra.","lowerLetterNeeded":"Sua nova senha precisa ter pelo menos uma letra minúscula.","upperLetterNeeded":"Sua nova senha precisa ter pelo menos uma letra maiuscula.","numberNeeded":"Sua nova senha precisa ter pelo menos um número.","notMatch":"Parece que você ainda não decorou sua senha nova. Tente novamente.","emptyCurrentPassword":"Você precisa digitar sua senha atual antes de continuar.","emptyNewPassword":"Não esqueça de criar sua senha.","emptyConfirmPassword":"Não esqueça de confirmar sua senha.","samePassword":"Ei! Sua nova senha precisa ser diferente da atual.","especialNeeded":"Sua nova senha precisa ter pelo menos umcaracter especial."}}

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/CancelAccountForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _reactRouterDom=__webpack_require__(15);var _TextInput=__webpack_require__(101);var _TextInput2=_interopRequireDefault(_TextInput);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _Radio=__webpack_require__(136);var _Radio2=_interopRequireDefault(_Radio);var _data=__webpack_require__(1770);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var renderRadio=function renderRadio(_ref){var input=_ref.input,label=_ref.label;return _react2.default.createElement(_Radio2.default,_extends({},input,{label:label,__source:{fileName:_jsxFileName,lineNumber:12}}));};var renderOtherMotive=function renderOtherMotive(_ref2){var placeholder=_ref2.placeholder,input=_ref2.input,_ref2$meta=_ref2.meta,touched=_ref2$meta.touched,error=_ref2$meta.error;return _react2.default.createElement(_TextInput2.default,_extends({placeholder:placeholder,maxlength:'150',lengthCounter:true},input,{errorMessage:touched&&error,__source:{fileName:_jsxFileName,lineNumber:15}}));};var renderRadioWithContent=function renderRadioWithContent(_ref3){var input=_ref3.input,label=_ref3.label;return _react2.default.createElement(_Radio2.default,_extends({},input,{label:label,__source:{fileName:_jsxFileName,lineNumber:25}}),_react2.default.createElement(_reduxForm.Field,{placeholder:_data.placeholders.other,name:'otherMotive',component:renderOtherMotive,__source:{fileName:_jsxFileName,lineNumber:26}}));};var validateCancel=function validateCancel(){var values=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var errors={};var allFields=Object.keys(values);var option=values.option,otherMotive=values.otherMotive;var validOtherMotive=otherMotive&&otherMotive.length>0;if(option===_data.labels.other&&!validOtherMotive){errors.otherMotive=_data.errorMessage.otherMotive;}errors.option=allFields.length===0;return errors;};var CancelAccountForm=function CancelAccountForm(props){var handleSubmit=props.handleSubmit,pristine=props.pristine,history=props.history,ctaText=props.ctaText;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement(_gridStyled.Box,{mb:24,__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:_data.labels.dontWantService,name:'option',value:_data.labels.dontWantService,type:'radio',__source:{fileName:_jsxFileName,lineNumber:52}})),_react2.default.createElement(_gridStyled.Box,{mb:24,__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:_data.labels.dontWantCar,name:'option',value:_data.labels.dontWantCar,type:'radio',__source:{fileName:_jsxFileName,lineNumber:61}})),props.profile==='pf'?_react2.default.createElement(_gridStyled.Box,{mb:24,__source:{fileName:_jsxFileName,lineNumber:70}},_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:_data.labels.moving,name:'option',value:_data.labels.moving,type:'radio',__source:{fileName:_jsxFileName,lineNumber:71}})):_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:80}},_react2.default.createElement(_gridStyled.Box,{mb:24,__source:{fileName:_jsxFileName,lineNumber:81}},_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:_data.labels.changingCompanies,name:'option',value:_data.labels.changingCompanies,type:'radio',__source:{fileName:_jsxFileName,lineNumber:82}})),_react2.default.createElement(_gridStyled.Box,{mb:24,__source:{fileName:_jsxFileName,lineNumber:90}},_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:_data.labels.cantPayForService,name:'option',value:_data.labels.cantPayForService,type:'radio',__source:{fileName:_jsxFileName,lineNumber:91}}))),_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:101}},_react2.default.createElement(_reduxForm.Field,{component:renderRadioWithContent,label:_data.labels.other,name:'option',value:_data.labels.other,type:'radio',__source:{fileName:_jsxFileName,lineNumber:102}})),_react2.default.createElement(_gridStyled.Flex,{wrap:true,mt:60,__source:{fileName:_jsxFileName,lineNumber:110}},_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],mr:[0,30],mb:[20,0],__source:{fileName:_jsxFileName,lineNumber:111}},_react2.default.createElement(_Button2.default,{disabled:pristine,type:'submit',text:ctaText||_data.buttons.cancel,__source:{fileName:_jsxFileName,lineNumber:112}})),_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],__source:{fileName:_jsxFileName,lineNumber:114}},_react2.default.createElement(_Button2.default,{buttonType:'white',onClick:function onClick(){return history.goBack();},text:_data.buttons.back,__source:{fileName:_jsxFileName,lineNumber:115}}))));};exports.default=(0,_reduxForm.reduxForm)({form:'changeUserPasswordData',validate:validateCancel,destroyOnUnmount:false})((0,_reactRouterDom.withRouter)(CancelAccountForm));module.exports=exports['default'];

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var updateTokenModal=exports.updateTokenModal=function updateTokenModal(token){return{type:'UPDATE_TOKEN_MODAL',data:token};};var setTokenModalError=exports.setTokenModalError=function setTokenModalError(error){return{type:'SET_TOKEN_MODAL_ERROR',data:error};};var setTokenModalLoading=exports.setTokenModalLoading=function setTokenModalLoading(isLoading){return{type:'SET_TOKEN_MODAL_LOADING',data:isLoading};};var setTokenModalTitle=exports.setTokenModalTitle=function setTokenModalTitle(title){return{type:'SET_TOKEN_MODAL_TITLE',data:title};};

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/modalBuddies.d033accb.png";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/HeaderWithBrand/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _styles=__webpack_require__(1787);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var HeaderWithBrand=function HeaderWithBrand(){return _react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:10}},_react2.default.createElement(_Icon2.default,{icon:'veloe-logo',svgStyle:_styles.Logo,width:'74',height:'31',viewBox:'0 0 74 31',__source:{fileName:_jsxFileName,lineNumber:11}})));};exports.default=HeaderWithBrand;module.exports=exports['default'];

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/truck-travel.7bad6968.png";

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ParagraphGrayLabel=exports.Content=exports.Wrapper=exports.Paragraph=exports.Subtitle=exports.Heading=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-15vx0i7-0'})(['',';color:',';line-height:1;margin:0 0 ',';max-width:',';'],_types.title24Galano,_colors.darkBlue,(0,_rem2.default)('24px'),(0,_rem2.default)('300px'));var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-15vx0i7-1'})(['',';color:',';font-weight:bold;line-height:1;margin:0 0 ',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('10px'));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-15vx0i7-2'})(['',';color:',';margin:0 0 ',';'],_types.txt14OpenSans,_colors.darkGrey,(0,_rem2.default)('40px'));var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-15vx0i7-3'})(['margin-bottom:',';'],(0,_rem2.default)('32px'));var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-15vx0i7-4'})(['',';margin:',' auto;'],_content2.default,(0,_rem2.default)('42px'));var ParagraphGrayLabel=exports.ParagraphGrayLabel=_styledComponents2.default.p.withConfig({displayName:'styles__ParagraphGrayLabel',componentId:'sc-15vx0i7-5'})(['',';text-transform:uppercase;color:',';margin:0 0;margin:10px 0 0 15px;position:absolute;'],_types.txt14OpenSans,_colors.darkGrey);

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/semaphore.bdc05180.png";

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.NewAddressText=exports.WrapperFormNewAddress=exports.CheckBoxCep=exports.WrapperSelectNewAddress=exports.NewAddress=exports.CepText=exports.BoxCep=exports.WrapperAddress=exports.ParagraphGrayLabel=exports.Row=exports.ParagraphGray=exports.Content=exports.Wrapper=exports.Paragraph=exports.Subtitle=exports.Heading=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-1ld6f66-0'})(['',';color:',';line-height:1;margin:0 0 ',';max-width:',';'],_types.title24Galano,_colors.darkBlue,(0,_rem2.default)('24px'),(0,_rem2.default)('300px'));var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-1ld6f66-1'})(['',';color:',';font-weight:bold;line-height:1;margin:0 0 ',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('10px'));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-1ld6f66-2'})(['',';color:',';margin:0 0 ',';'],_types.txt14OpenSans,_colors.darkGrey,(0,_rem2.default)('40px'));var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-1ld6f66-3'})(['margin-bottom:',';'],(0,_rem2.default)('32px'));var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-1ld6f66-4'})(['',';display:flex;justify-content:space-between;margin:',' auto;'],_content2.default,(0,_rem2.default)('42px'));var ParagraphGray=exports.ParagraphGray=_styledComponents2.default.p.withConfig({displayName:'styles__ParagraphGray',componentId:'sc-1ld6f66-5'})(['',';text-transform:uppercase;color:',';margin:0 0;'],_types.txt14OpenSans,_colors.darkGrey);var Row=exports.Row=_styledComponents2.default.div.withConfig({displayName:'styles__Row',componentId:'sc-1ld6f66-6'})(['margin:5px 0;display:inline-block;width:100%;']);var ParagraphGrayLabel=exports.ParagraphGrayLabel=_styledComponents2.default.p.withConfig({displayName:'styles__ParagraphGrayLabel',componentId:'sc-1ld6f66-7'})(['',';text-transform:uppercase;color:',';margin:0 0;margin:10px 0 0 15px;position:absolute;'],_types.txt14OpenSans,_colors.darkGrey);var WrapperAddress=exports.WrapperAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperAddress',componentId:'sc-1ld6f66-8'})(['']);var BoxCep=exports.BoxCep=_styledComponents2.default.label.withConfig({displayName:'styles__BoxCep',componentId:'sc-1ld6f66-9'})(['flex-grow:1;']);var CepText=exports.CepText=_styledComponents2.default.div.withConfig({displayName:'styles__CepText',componentId:'sc-1ld6f66-10'})(['',';color:',';width:100%;padding-left:30px;cursor:pointer;'],_types.txt16OpenSans,_colors.darkGrey);var NewAddress=exports.NewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__NewAddress',componentId:'sc-1ld6f66-11'})(['color:',';',';letter-spacing:0.4px;display:flex;flex-direction:column;'],function(props){return props.focus?''+_colors.darkSlateBlue:''+_colors.blueGray;},_types.txt16OpenSans);var WrapperSelectNewAddress=exports.WrapperSelectNewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperSelectNewAddress',componentId:'sc-1ld6f66-12'})(['']);var CheckBoxCep=exports.CheckBoxCep=_styledComponents2.default.input.withConfig({displayName:'styles__CheckBoxCep',componentId:'sc-1ld6f66-13'})(['margin-right:15px;&:checked,&:not(:checked){position:absolute;z-index:99999;margin-left:2px;cursor:pointer;}&:checked + label,&:not(:checked) + label{position:relative;padding-left:35px;line-height:20px;display:inline-block;}&:checked,&:not(:checked){&:before{content:\'\';position:absolute;left:-2px;top:0;width:20px;height:20px;border:2px solid ',';border-radius:100%;background:',';}}&:checked{&:before{border:2px solid ',';}}&:checked,&:not(:checked){&:after{content:\'\';width:12px;height:12px;background:',';position:absolute;top:4px;left:2px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;}}&:not(:checked){&:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}}&:checked{&:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}}'],_colors.grey,_colors.white,_colors.skyBlue,_colors.skyBlue);var WrapperFormNewAddress=exports.WrapperFormNewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperFormNewAddress',componentId:'sc-1ld6f66-14'})(['margin-top:30px;form > div > div > div{width:100%;}']);var NewAddressText=exports.NewAddressText=_styledComponents2.default.label.withConfig({displayName:'styles__NewAddressText',componentId:'sc-1ld6f66-15'})(['']);

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/OtherAddressForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _AddressFormOtherSection=__webpack_require__(1807);var _AddressFormOtherSection2=_interopRequireDefault(_AddressFormOtherSection);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var OtherAddressForm=function OtherAddressForm(props){var initialValues=props.initialValues,handleSubmit=props.handleSubmit,onDelete=props.onDelete,onChange=props.onChange,disableButton=props.disableButton,saving=props.saving,history=props.history,loadingButton=props.loadingButton;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement(_reduxForm.FieldArray,{name:'address',component:_AddressFormOtherSection2.default,initialValues:initialValues.address,onDelete:onDelete,saving:saving,history:history,disableButton:disableButton,onChange:onChange,loadingButton:loadingButton,__source:{fileName:_jsxFileName,lineNumber:18}}));};exports.default=(0,_reduxForm.reduxForm)({form:'othertAddress',destroyOnUnmount:false,enableReinitialize:true})(OtherAddressForm);module.exports=exports['default'];

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAYAAABV7bNHAAAAAXNSR0IArs4c6QAABSlJREFUeAHtml2oVUUUxz1qauYHxgXpKcSH9ClDUVDzJoFmDyKCFgWB2KugIOKDj/rgk/jggyQEPaXhR2F2A3upi999UGgg1IMSpCD4kWRd9fr7yx7dzp3ZZ8+++5y993EWLGbPmpm11vzO7Dn7zD5jxkSJBCKBSCASiAQigUggEogEIoFwAq3wIU9HDA8Pj6e2DJ2D9qFj0SrlPsGvoRdardbPlSUCmAnoNvQGWle5TGLruw6JoH3oYF2pOPI6gG1cUVBBtwSBJhDoGLqkaMAKxm0k5h5f3GROvubgPWMznpoEx0x8EyDeNBWV1Bejv3N5j/I0Ojvdbq5zb9I40DK9jr5sBqfKq1xfQh+kbFVcTiLoG+gMR/ABNu5VsjOX5RTH0cmqJzJI+zMQTUOuEqezUJfsxhh0q+YKWLATuUxDBxyJDmGbii5H73racy+YEenhcKHD6VVstYFjkianVx25yrQVdcFR23kzvlCJg355seTbQs66MIg8b1u5ZlVv0jjPlVbIp+9aflXvOa45GdtDc9GmvEX7CvafX1z9QgC5xjfdZuCc803keQbUFo6gPa+ABGclt5V35ZgV1ZOA2HD7meBLZpJWeZu64Jy17M5qzwFK4HzNbHXSYIvgaEPOBUeDewpQCo5r9QTD6SlAwNG5lFaOD07u20pgjPTECkrgnGBSWXDOmEmHlI0H1Ek4AtloQMDRr++slfMOG3KhlWNWWWMBJXC+YSKu2+oOdsE5bSZatGwkoDYrR3C0IY8ajqC6nhWKwn5mHJP4AINugV/RT0hYbxxGLSk4UxzOSoXj8O83kdhbqC26/0cInXZaHb+jnj69GzEmjwEfS9E7lm9T1fHG4jx+OtKH4LkA0a+F3kJtOYnhxaLJMbYQHMbpRUNhKX0P4lYaJhvXOdHb2I+RsM6Ng0RwGKAN2XdbaUM+lXbKmFfQk9j+pbyCrky3l35NgFwrSIHpux31yQkaJuZNkL5FV84hKwGt6ul54wb3w3luQHJO/31WgunqcSptlz59lqBZe473FRTj/kZt0a/8zgiRQgFpL9pvZ5iqf8n1C75sacuCI2heOPJJu86ZbVnhizdqO5GCACVJCtIBO8tU/QjXIx41sAmO79C9LZwkdv0BJYmOZbKfoj75goYnkLjWG88sONqw2wo+mgFIMyFZQfoM9cnnNIxDS4GTxCwF0JNPru1HMooOfAU/ZPIbcKHX13rCtuU9DNNQrY6pdiP1f9BV+Bl0tHXU1BVAmgGTewCkj7hUzPWyWfL4vbllU7UyOApe+oOinPpEkGj7ED3s62PZBefdKlaOyaOrgBSUyd6neB89qnqGGDg/ZPTpeFPXAWlGCSTtO195ZngXu1ZOpXCUWyWAFJjJD1GsQ3XQnpbawFFSlQFScCD9T7EW3YVeRAfQpdi/p6yFdO1bzDfbBNIO2qW1k0pXUO1oOBKKgBxQ0qYIKE3DcR0CSBuqLTNtQx3qPLHr/Nt1+qhvyCAJAaSX/7a8TjKLbGMN6h+Tg3732XLFNrSru/536BwDCL2gEyQbql617EV/Q11n0Zi7Jjrv1qnhRtTO8zLfmK91NBMg6eymqbKlCJzcK0jOITOb4idURxNNEj2EzmcF/ReatL0MM8cT4A866DfUvcyO9Wr8i3RWF4GjaQQB0gAC6eeA/qykT6XuolwXkPOfRRMNusXSQbjd9C2xJtG5lH1oYX+MLUN0lHIN/RE9CJjBMpxGH5FAJBAJRAKRQCQQCUQCkUAkEAmUTOARnytWxCpg+ZcAAAAASUVORK5CYII="

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.WrapperButton=exports.Content=exports.Back=exports.Header=exports.SuccessMessage=exports.SuccessContent=exports.SuccessContainer=exports.WrapperContentModal=exports.Form=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Form=exports.Form=_styledComponents2.default.form.withConfig({displayName:'styles__Form',componentId:'sc-pzjfrv-0'})(['display:flex;flex-direction:column;height:100%;min-height:380px;']);var WrapperContentModal=exports.WrapperContentModal=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperContentModal',componentId:'sc-pzjfrv-1'})(['display:flex;justify-content:space-between;flex-direction:column;min-height:380px;padding:',';width:100%;overflow:hidden;'],(0,_rem2.default)('24px'));var SuccessContainer=exports.SuccessContainer=_styledComponents2.default.div.withConfig({displayName:'styles__SuccessContainer',componentId:'sc-pzjfrv-2'})(['padding:',';flex-direction:column;width:100%;display:flex;background:',';'],(0,_rem2.default)('24px'),_colors.lightBlue);var SuccessContent=exports.SuccessContent=_styledComponents2.default.div.withConfig({displayName:'styles__SuccessContent',componentId:'sc-pzjfrv-3'})(['display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1;']);var SuccessMessage=exports.SuccessMessage=_styledComponents2.default.h2.withConfig({displayName:'styles__SuccessMessage',componentId:'sc-pzjfrv-4'})(['',';margin:0;margin-top:',';color:',';font-weight:bold;'],_types.title18Galano,(0,_rem2.default)('25px'),_colors.white);var Header=exports.Header=_styledComponents2.default.div.withConfig({displayName:'styles__Header',componentId:'sc-pzjfrv-5'})(['',';font-weight:bold;width:100%;display:flex;justify-content:space-between;color:',';margin-bottom:20px;'],_types.title18Galano,_colors.linkNavyBlue);var Back=exports.Back=_styledComponents2.default.a.withConfig({displayName:'styles__Back',componentId:'sc-pzjfrv-6'})(['',';font-weight:bold;line-height:1;color:',';display:flex;position:absolute;top:0;right:0;padding:',';cursor:pointer;svg{fill:',';}'],_types.txt14OpenSans,_colors.linkNavyBlue,(0,_rem2.default)('16px'),_colors.posGreyInfo);var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-pzjfrv-7'})(['padding:',';'],(0,_rem2.default)('24px'));var WrapperButton=exports.WrapperButton=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButton',componentId:'sc-pzjfrv-8'})(['margin-top:auto;display:flex;justify-content:',';'],function(props){return props.justify;});WrapperButton.defaultProps={justify:'flex-end'};

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/templates/TemplateRecharge/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(13);var _routes=__webpack_require__(96);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _styles=__webpack_require__(103);var _data=__webpack_require__(1841);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TemplateRecharge=function(_Component){_inherits(TemplateRecharge,_Component);function TemplateRecharge(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TemplateRecharge);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TemplateRecharge.__proto__||Object.getPrototypeOf(TemplateRecharge)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TemplateRecharge,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;this.props.fetchRechargeValues(this.props.match.params.id).then(function(){return _this2.props.getAccountPlans();});}},{key:'render',value:function render(){var _props=this.props,routes=_props.routes,match=_props.match,search=_props.location.search;var templateType=routes[0].path==='/minha-veloe/:id/editar-dados'&search!=='?path=recharge'&search!=='?path=track'?'dados-do-plano':'resumo';var textLinkBack=templateType==='dados-do-plano'&&search!=='?path=recharge'?_data.backCopyDados:_data.backCopy;return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement(_styles.HeaderContainer,{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.HeaderLink,{id:'hypBackSummary',to:'/minha-veloe/'+match.params.id+'/'+templateType,__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_Icon2.default,{icon:'back-arrow',width:'10px',height:'15px',viewBox:'0 0 10 15',__source:{fileName:_jsxFileName,lineNumber:41}}),_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:42}},textLinkBack)))),_react2.default.createElement(_gridStyled.Box,{my:(0,_rem2.default)('45px'),__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:47}},routes.map(function(route){return _react2.default.createElement(_routes.RouteWithSubRoutes,_extends({key:route.path},route,{__source:{fileName:_jsxFileName,lineNumber:48}}));}))));}}]);return TemplateRecharge;}(_react.Component);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAccountPlans:function getAccountPlans(){return dispatch((0,_actions.fetchAccountPlans)());},fetchRechargeValues:function fetchRechargeValues(planId){return dispatch((0,_actions.fetchRechargeValues)(planId));}};};exports.default=(0,_reactRedux.connect)(null,mapDispatchToProps)(TemplateRecharge);module.exports=exports['default'];

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ValuePicker/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _styles=__webpack_require__(1843);var _slider=__webpack_require__(1844);var _slider2=_interopRequireDefault(_slider);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ValuePicker=function(_React$Component){_inherits(ValuePicker,_React$Component);function ValuePicker(){_classCallCheck(this,ValuePicker);return _possibleConstructorReturn(this,(ValuePicker.__proto__||Object.getPrototypeOf(ValuePicker)).apply(this,arguments));}_createClass(ValuePicker,[{key:'componentDidMount',value:function componentDidMount(){this.slider=new _slider2.default({el:this.el,startIndex:this.props.startIndex,onSlide:this.props.onChange});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.slider.destroy();}},{key:'render',value:function render(){var _this2=this;var _props=this.props,values=_props.values,id=_props.id;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement(_styles.List,{id:id,innerRef:function innerRef(el){_this2.el=el;},__source:{fileName:_jsxFileName,lineNumber:26}},values.map(function(value,index){return _react2.default.createElement(_styles.Item,{key:index,__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:34}},value));})));}}]);return ValuePicker;}(_react2.default.Component);ValuePicker.defaultProps={startIndex:2,onChange:null};ValuePicker.propTypes={values:(0,_propTypes.arrayOf)((0,_propTypes.oneOfType)([_propTypes.number,_propTypes.string])).isRequired,startIndex:_propTypes.number,onChange:_propTypes.func};exports.default=ValuePicker;module.exports=exports['default'];

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./avatar-1.png": 240,
	"./avatar-2.png": 241,
	"./avatar-3.png": 242,
	"./avatar-4.png": 243,
	"./avatar-5.png": 244,
	"./avatar-6.png": 245,
	"./avatar-7.png": 246,
	"./avatar-8.png": 247,
	"./avatar-pj.png": 387
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 616;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ConsumptionChartBar/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _styles=__webpack_require__(1870);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ConsumptionChartBar=function ConsumptionChartBar(_ref){var colors=_ref.colors,values=_ref.values;return _react2.default.createElement(_styles.BarContainer,{__source:{fileName:_jsxFileName,lineNumber:7}},values.map(function(value,index){return _react2.default.createElement(_styles.BarSlice,{key:index,width:value+'%',color:colors[index],__source:{fileName:_jsxFileName,lineNumber:9}});}));};ConsumptionChartBar.defaultProps={colors:[],values:[]};ConsumptionChartBar.propTypes={colors:(0,_propTypes.arrayOf)(_propTypes.string),values:(0,_propTypes.arrayOf)(_propTypes.number)};exports.default=ConsumptionChartBar;module.exports=exports['default'];

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ConsumptionChartIndicator/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _styles=__webpack_require__(1871);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ConsumptionChartIndicator=function ConsumptionChartIndicator(_ref){var name=_ref.name,value=_ref.value,color=_ref.color;return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:7}},_react2.default.createElement(_styles.Name,{color:color,__source:{fileName:_jsxFileName,lineNumber:8}},name),_react2.default.createElement(_styles.Value,{__source:{fileName:_jsxFileName,lineNumber:9}},value));};ConsumptionChartIndicator.defaultProps={name:'',value:null,color:''};ConsumptionChartIndicator.propTypes={name:_propTypes.string,value:(0,_propTypes.oneOfType)([_propTypes.number,_propTypes.string]),color:_propTypes.string};exports.default=ConsumptionChartIndicator;module.exports=exports['default'];

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ConsumptionChartBarPos/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _styles=__webpack_require__(1875);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ConsumptionChartBarPos=function ConsumptionChartBarPos(_ref){var _ref$colors=_ref.colors,colors=_ref$colors===undefined?[]:_ref$colors,_ref$values=_ref.values,values=_ref$values===undefined?[10,90]:_ref$values,_ref$height=_ref.height,height=_ref$height===undefined?'16px':_ref$height;return _react2.default.createElement(_styles.BarContainer,{height:height,__source:{fileName:_jsxFileName,lineNumber:7}},values.map(function(value,index){return _react2.default.createElement(_styles.BarSlice,{key:index,width:value+'%',color:colors[index],__source:{fileName:_jsxFileName,lineNumber:9}});}));};ConsumptionChartBarPos.propTypes={colors:(0,_propTypes.arrayOf)(_propTypes.string),values:(0,_propTypes.arrayOf)(_propTypes.number)};exports.default=ConsumptionChartBarPos;module.exports=exports['default'];

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg-modal-desligamento.6d6c0635.png";

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAAH7+Yj7AAAAAXNSR0IArs4c6QAAAwNJREFUWAntmL9rFFEQxy9GIv42jY2/SCHYiIU2CkIkQbCyEEGtbFIJErG1sFUQNDYiEu1ExT9AsRHsLP2NFqJWIsEoBCTq+Zm9N8fs3uzu270LRNiB783vebNv3763e61WEbU79FJiVprASSO3WgRNpAyqhPS26vlcItW7QgT077BJ+JA6Eo5hDsx0jShKH7rGygIlHmgS8laVUxzH/pQBBdsttSWdB2WNGg1fMPKyEGl+AiRU2BARzzVAolUWbheG6M/w++tBvELZCsH2NHHyY+cxsZEwpU5479zmVOz2bHu8mg0egkz15SzS+hFwGthLqtYyycNAaJ/N7Jjas9YWJZP4FZzxgqWoZxebO+tFCZlCY9y4jxlbWqVYssCtFds6cDRjm8HWXS/q61mJ6sjwY+g3MjZX7blk6YbIn2AMFG0Rb/Hf5pLPwxv6r2eAu74eTIGDfV8IReRIFFrssORXllN1IvUN+GYz0aelpLVFy3mJYofO5hWKffRs/hOUcWuwsrth0sFaCYJ7Z9YGW6BUpshlEEM/SotJQKi0syxY4ryYvDlM7TLkXveSo2yhwy022OvGs0lOXoe2XiU5qiCbaM9GnDeKt2z+Eix3+lxeEvbdBb60i0KrwB+ZoxI6kM5stGYGmhlwZoDHaBu4A345j5QclxdBsvU76UtnYtC9YAEI/QaXgNhGwCZwCDwCSu8RRpeuI1OZgU7qqPATxuWKxNwL8XIhO9ygQRoZ5HUYMPrIIv5LyLlZtZeowyRTdHPQX2XsReqL4NTcotjqPq5e1pYcWHKb+iVZj9HnUOkxSzF5CufBMLgPLoDFAFg0jRC5C9wFG8E1TvlpeH9Eg93/SJBTbzp1KlNDPjWFej43vXp11qBXR14mTyXDttuf3YCaxoE1yPi6ISuv2VI6zXuDS0fEaw8JPQwex6eUR8Y0aF/ZV+eVZMHP4Tue5zd2/Q/N1jXuGiJr60pYX4Ni8xTaHtNK6TZji1BUtoc9QGfBustk+dL6BN4x2/Ih0FAzAzID/wCAReGJl/O7OAAAAABJRU5ErkJggg=="

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/car.00aa5f8d.png";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/carro-veloe.a30178ae.png";

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAlCAYAAADFniADAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAOeSURBVHgBzZjPTxNBFMffzEJLYrUtJF4gWH5I4sGAiQkkYqyhGCWY4BUOgCfiQTyZFA+WmFg9Ef8C5GDVk0QNYExjuRhvBk30IJhK4KAH2A0SKbJd39u0DdDuj2m3jd+EsDPzpvvZmTdv5g0DQQV8EZ+kSkFNk4IMWLumQYAxCGTbsZzEclIDbYkxNaFKaiIpR2QQELNr2Oq5F0yDNIAgw1j0gYg0eKyqMJncCSftmFtCBWqiAakKpvBxAEqVTTjJrLH5SHScS/AMHzvACTHo4BxG/NU9qc2/8Q8gCtXsiU6hb0TwsQacVQ1j7LLf1QObu/HFQgYFp6/lSHQaW0ag3MLpXNkOjx6uzhupZs/9u/glt6ASwun0u0I+HLE3YARFPoRAD6CCwqnqQh9T9vtYbvoyq+wjiC53ZySre3Amuyp5tlaSdKc2BDp1+jjUN3qhGB31uqGzu9HMxJcJO5CDolHCMRs26kEwr95fhyfzg8JgBBSbH9L7dp43BRto9USDOajMKBlqS9mB9R8KNCCQCFgWiEZ5S96BNfwNM6UhrQdopu9le+5NqxcQSGwOgU54YW1VgaErMVhfVWwDDfY9ha+ff1q9RlarUk1cUl1BsCECGOyL2Rox/QMyQGTff27aDhDJB6r7AsddPQg2ZQesPlOfBdLtVxW7rwCupS9yOn6AgKzARm+c1euLASIx4O2SvzoUwT1OKDZtKSl4+/obXOpvgwb0sd6rbXqZ6t01Vfrf+OhLYSBdGoK1eKIaFClR57crDiVIxPkrBlUuMFp9SShCFIfuPAxBb/9JZ8GQh9MhHwSVDYy00m6Gu/U6x8CQh1PWIdLncKS+PTaXa3MCTIP0Eo1Uwm4HO1tHqWBpxt9xVdpN4LNlXiayl5UEJqUWOSWKOIUzVraim2shMPowU+GZnXj0kMCBzZrZEozgbp8H5j3mtrSnnJD+547DGNlfgEnCSUv/y6dfRUdsGiXahgy1L7P5L8/ouWxG3ovLdZi5AiaKUGExTQt//zOxkC0fSLE2MM2pdfX40awLKiScqsnl7YkDaV1eMoqJ4UJtdaiJEkUotzSYQT/KS3wL3iVgYjhb5wqRvwWhfESPVrYnxgq1GF5wbOzGE+hjCvoYTaWTlxwy+RACRYwMTK+CyMe8PPQcz8x+h6ZzFlfZtf1OXUi2b/L0kEH5oUnSaiB9x6AAvfw7nLDTwTZUDk6/83QFKQuyvvOEBO2tonee/wBdQO151mZGnQAAAABJRU5ErkJggg=="

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAFo9M/3AAAAAXNSR0IArs4c6QAAAbBJREFUOBGNUUlLw0AUnpnErdQFFfEmXpImqR5atNYFXKigBy8e/AFJKwge/DOCtb9BES/qQQuCB7GeGrBHERFEULpYpWmeE+GF1CZgLu/Lt7z3ZoaQ4E+RdGhRVdmoOQRDFgBCiH+rpu2EXUKR9TL+sERit48KQgoJ4fn59ntkKBYdHY4NvL7dv6DgVj6tokjGh0sgcPriKsg51V1LYHTTWU2T0lNeQxtWFGOdd3psE5BoOQ8n3RGOQZMy83bju+I1uYZoJD1rk+a1yNiiae5XsaPggEnFmLFsuGFUWC6WDvMoOvW3Q8OGC47LZil75RVbMH+fuu8FeV3c8KVK+ruXa8OqrFfj8UwHChRBUFVVYwEsckooaTCxc9x7QicjBgU1WZ8DQs/AgjClpAZM3Pgb9m0wEdlOWmCd20B6efCTv/FS8SGXDxrkbsDPFapX7SfLtgYJoXVGyYpZyl0GBZF3X7JQyH4Co1tc+CIEevgGR5qmT6MxqPpeYjSSWW3azRMe6uaGD0bFVLF0cOfXxLcBGlUpvQYEjvlGXYTSl1CYjfFNG6j/u/L76U8m93r8Aj/mR44GUGmERwAAAABJRU5ErkJggg=="

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAArBJREFUSA21VWtT2lAQ3ZDwRt5YxaJ2pj7a6Tj2//+DTqdlOlO1DD4qrYBUQR4pkIfdc/GmJCTyBfcDIffuPefu7tmN8shGL2ihF8QW0NoygunEpKlhkm0/kqqGKBxWKRJZesyBDfRst3rUaNwRCLwWi4Wpsl2k0nrau7XwrnhrYFk21X40qXs/FDculdKUziTEzQ2O5KGnU6fTFxEVimu0t79JoZCyACwXFghOT34L8HQ6Tm/5MG4LQ4okkK5PqV5r0nA4piKT7B+WJd7C00WAtJzX2wTwD0fbZJoWXV50BCEiO/64S/FERIBAfN+qP2k0mtDewSYhUj9zqQg5RyFxc8OwqPrlijq3D6RxYddfZSganUUDIEVRhB+i+nV954ct1pwiT6esFi7oxkZWpKV2dkNY294p0utKwRcgmYxSvrBGf7gmSFviKbp5ZycCY2qJdRQU1u2OCABB4MKJfzKZuPirc6r8zCGwbFvsa+GQyD2Kmskm/c641jRNFe+ol585KVKfpIZIcOjoeIfisVlB/Q7KNdQKhgb0MycC2Z293kj4IT0hNVjfEszxT8XkkuvpEIS5/ePxCBdsIPTt8gp46ff/soRHlGJw2S9eV4cAGxVWDPRdr7VEY3md59/RF2g2+ENpQeYiQFdC77o+oerXKxrwDf0M4wI9Mh4bVC7nKJsLFoOrkwGGr8PlRZtazZ5opmw2MTeLLDGLZN7LW3nafVMiy7RJ1Vx3de61QCB3ANLgDh0OxiINch0djFGCaZrmHoA8P3865yhSdMAzibddFkggvSDbEafMZDlCiglWl1eSp995QHaH3NUg2XKRLCWQRM89Ueizk5sZSZ5J3v0n8U/cc2g+e0jb4fsy5Rj8nr8jGJDSVhKBBEMkndu+SJUcISslkETzz5WkaB7Q+/8ff084eLuOiPgAAAAASUVORK5CYII="

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/irrf-auto-retencao.9ccc892d.png";

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tag_veloe@2x.a76ebff3.png";

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Carousel/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _carousel=__webpack_require__(632);var _carousel2=_interopRequireDefault(_carousel);var _lodash=__webpack_require__(43);__webpack_require__(1907);var _mediaQuery=__webpack_require__(633);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _styles=__webpack_require__(1908);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Carousel=function(_React$Component){_inherits(Carousel,_React$Component);function Carousel(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Carousel);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Carousel.__proto__||Object.getPrototypeOf(Carousel)).call.apply(_ref,[this].concat(args))),_this),_this.state={startedCarousel:false},_this.onSlide=function(to){_this.setState({activeSlide:to});if(_this.props.onSlide){_this.props.onSlide();}},_this.mountCarousel=function(){var options={onSlide:_this.onSlide,activeClass:'active',slideWrap:'ul',slides:'li',infinite:false,display:1,disableDragging:false,initialIndex:0};if(_this._carousel){_this.carousel=new _carousel2.default(_this._carousel,options);_this.setState({startedCarousel:true,activeSlide:_this.carousel.current});}},_this.handleMobileCarousel=(0,_lodash.debounce)(function(){if((0,_mediaQuery.isMobile)()&&!_this.carousel){_this.mountCarousel();}if((0,_mediaQuery.isDesktop)()&&_this.carousel){_this._wrap.style.transform='none';_this.carousel.destroy();_this.setState({startedCarousel:false});delete _this.carousel;}},250,{maxWait:1000}),_this.resizeHandler=function(){_this.handleMobileCarousel();},_this.moveCarousel=function(to){_this.carousel.go(to);},_this.mountNavigator=function(listItems,hasArrow){return _react2.default.createElement(_styles.Navigator,{hasArrow:hasArrow,__source:{fileName:_jsxFileName,lineNumber:98}},hasArrow&&!(0,_mediaQuery.isMobile)()&&_react2.default.createElement(_Icon2.default,{icon:'left-arrow-large',svgStyle:_styles.IconColor,width:'30',height:'30',viewBox:'0 0 70 70',onClick:function onClick(){return _this.moveCarousel(_this.carousel.current-1);},__source:{fileName:_jsxFileName,lineNumber:101}}),_react2.default.createElement(_styles.NavigatorList,{__source:{fileName:_jsxFileName,lineNumber:110}},listItems.map(function(child,index){return _react2.default.createElement(_styles.NavItem,{active:_this.state.activeSlide===index,key:index,onClick:function onClick(){return _this.moveCarousel(index);},__source:{fileName:_jsxFileName,lineNumber:112}});})),hasArrow&&!(0,_mediaQuery.isMobile)()&&_react2.default.createElement(_Icon2.default,{icon:'right-arrow-large',svgStyle:_styles.IconColor,width:'30',height:'30',viewBox:'15 15 70 70',onClick:function onClick(){return _this.moveCarousel(_this.carousel.current+1);},__source:{fileName:_jsxFileName,lineNumber:121}}));},_this.handleMountNavigator=function(listItems){if((0,_mediaQuery.isMobile)()&&_this.props.hasMobileNavigation||_this.props.hasNavigation)return _this.mountNavigator(listItems,_this.props.hasArrow);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Carousel,[{key:'componentDidMount',value:function componentDidMount(){if(typeof window==='undefined'){return;}if(this.props.mobileOnly){window.addEventListener('resize',this.resizeHandler);this.handleMobileCarousel();}else if(!this.carousel){this.mountCarousel();}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.props.mobileOnly){window.removeEventListener('resize',this.resizeHandler);}if(this.carousel){this.carousel.destroy();}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,children=_props.children,flexibleWidth=_props.flexibleWidth,fullWidth=_props.fullWidth;var listItems=(0,_lodash.flatten)(children).filter(function(child){return child;});return _react2.default.createElement(_styles.CarouselWrapper,{mobileOnly:this.props.mobileOnly,className:'carousel',startedCarousel:this.state.startedCarousel,fullWidth:fullWidth,innerRef:function innerRef(el){_this2._carousel=el;},__source:{fileName:_jsxFileName,lineNumber:144}},_react2.default.createElement(_styles.List,{className:'wrap',innerRef:function innerRef(el){_this2._wrap=el;},__source:{fileName:_jsxFileName,lineNumber:153}},listItems.map(function(child,index){return _react2.default.createElement(_styles.Item,{flexibleWidth:flexibleWidth,key:index,__source:{fileName:_jsxFileName,lineNumber:160}},child);})),this.handleMountNavigator(listItems));}}]);return Carousel;}(_react2.default.Component);Carousel.defaultProps={onSlide:null,mobileOnly:true,fullWidth:true};Carousel.propTypes={onSlide:_propTypes.func,mobileOnly:_propTypes.bool};exports.default=Carousel;module.exports=exports['default'];

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * carousel ten billion
 * https://github.com/apathetic/flexicarousel
 *
 * Copyright (c) 2013, 2016 Wes Hatch
 * Licensed under the MIT license.
 *
 */

// import transform from './transform';

var Carousel = function Carousel(container, options) {
  var this$1 = this;
  if ( options === void 0 ) options={};


  this.handle = container;

  // default options
  // --------------------
  this.options = {
    animateClass: 'animate',
    activeClass: 'active',
    slideWrap: 'ul',
    slides: 'li',         // the slides
    infinite: true,       // infinite scrolling or not
    display: 1,           // the minimum # of slides to display at a time. If you want to have slides
                            // "hanging" off outside the currently viewable ones, they'd be included here.
    disableDragging: false, // only use API to navigate
    initialIndex: 0       // slide index where the carousel should start
  };

  // state vars
  // --------------------
  this.current = 0;
  this.slides = [];
  this.sliding = false;
  this.cloned = 0;
  this.active = true;

  // touch vars
  // --------------------
  this.dragging = false;
  this.dragThreshold = 50;
  this.deltaX = 0;

  // feature detection
  // --------------------
  this.isTouch = 'ontouchend' in document;

  ['transform', 'webkitTransform', 'MozTransform', 'OTransform', 'msTransform'].forEach(function (t) {
    if (document.body.style[t] !== undefined) { this$1.transform = t; }
  });

  // set up options
  // --------------------
  this.options = Object.assign(this.options, options);

  // engage engines
  // --------------------
  this.init();
};

/**
 * Initialize the carousel and set some defaults
 * @param{object} options List of key: value options
 * @return {void}
 */
Carousel.prototype.init = function init () {
    var this$1 = this;

  // find carousel elements
  this.slideWrap = this.handle.querySelector(this.options.slideWrap);
  this.slides = this.slideWrap.querySelectorAll(this.options.slides);
  this.numSlides = this.slides.length;
  this.current = this.options.initialIndex;

  if (!this.slideWrap || !this.slides || this.numSlides < this.options.display) { console.log('Carousel: insufficient # slides'); return this.active = false; }
  if (this.options.infinite) { this._cloneSlides(); }

  this._createBindings();// set up Events
  this._getDimensions();
  this.go(this.current, false);

  if (!this.options.disableDragging) {
    if (this.isTouch) {
      ['touchstart', 'touchmove', 'touchend', 'touchcancel'].map(function (event) {
        this$1.handle.addEventListener(event, this$1._bindings[event]);
      });
    } else {
      ['mousedown', 'mousemove', 'mouseup', 'mouseleave', 'click'].map(function (event) {
        this$1.handle.addEventListener(event, this$1._bindings[event]);
      });
    }
  }

  window.addEventListener('resize', this._bindings['resize']);
  window.addEventListener('orientationchange', this._bindings['orientationchange']);

  return this;
};

/**
 * Removes all event bindings.
 * @returns {Carousel}
 * */
Carousel.prototype.destroy = function destroy () {
    var this$1 = this;

  for (var event in this._bindings) {
    this$1.handle.removeEventListener(event, this$1._bindings[event]);
  }

  window.removeEventListener('resize', this._bindings['resize']);
  window.removeEventListener('orientationchange', this._bindings['orientationchange']);

  this._bindings = null;
  this.options = this.slides = this.slideWrap = this.handle = null;
  this.active = false;

  // remove classes ...
  // remove clones ...
};

/**
 * Go to the next slide
 * @return {void}
 */
Carousel.prototype.next = function next () {
  if (this.options.infinite || this.current !== this.numSlides-1) {
    this.go(this.current + 1);
  } else {
    this.go(this.numSlides-1);
  }
};

/**
 * Go to the previous slide
 * @return {void}
 */
Carousel.prototype.prev = function prev () {
  if (this.options.infinite || this.current !== 0) {
    this.go(this.current - 1);
  } else {
    this.go(0);  // allow the slide to "snap" back if dragging and not infinite
  }
};

/**
 * Go to a particular slide. Prime the "to" slide by positioning it, and then calling _slide() if needed
 * @param{int} to  the slide to go to
 * @return {void}
 */
Carousel.prototype.go = function go (to, animate) {
    if ( animate === void 0 ) animate = true;

  var opts = this.options;

  if (this.sliding || !this.active) { return; }

  if (to < 0 || to >= this.numSlides) {                           // position the carousel if infinite and at end of bounds
    var temp = (to < 0) ? this.current + this.numSlides : this.current - this.numSlides;
    this._slide( -(temp * this.width - this.deltaX) );
    this.slideWrap.offsetHeight;                                  // force a repaint to actually position "to" slide. *Important*
  }

  to = this._loop(to);
  this._slide( -(to * this.width), animate );

  if (opts.onSlide) { opts.onSlide.call(this, to, this.current); }// note: doesn't check if it's a function

  this._removeClass(this.slides[this.current], opts.activeClass);
  this._addClass(this.slides[to], opts.activeClass);
  this.current = to;
};

// ----------------------------------- Event Listeners ----------------------------------- //

/**
 * Create references to all bound Events so that they may be removed upon destroy()
 * @return {Object} containing references to each event and its bound function
 */
Carousel.prototype._createBindings = function _createBindings () {
  this._bindings = {
    // handle
    'touchstart': this._dragStart.bind(this),
    'touchmove': this._drag.bind(this),
    'touchend': this._dragEnd.bind(this),
    'touchcancel': this._dragEnd.bind(this),
    'mousedown': this._dragStart.bind(this),
    'mousemove': this._drag.bind(this),
    'mouseup': this._dragEnd.bind(this),
    'mouseleave': this._dragEnd.bind(this),
    'click': this._checkDragThreshold.bind(this),

    // window
    'resize': this._updateView.bind(this),
    'orientationchange': this._updateView.bind(this)
  };
};

// ------------------------------------- Drag Events ------------------------------------- //

Carousel.prototype._checkDragThreshold = function _checkDragThreshold (e) {
  if (this.dragThresholdMet) {
    e.preventDefault();
  }
};

/**
 * Start dragging (via touch)
 * @param{event} e Touch event
 * @return {void}
 */
Carousel.prototype._dragStart = function _dragStart (e) {
  var touches;

  if (this.sliding) {
    return false;
  }

  e = e.originalEvent || e;
  touches = e.touches !== undefined ? e.touches : false;

  this.dragThresholdMet = false;
  this.dragging = true;
  this.startClientX = touches ? touches[0].pageX : e.clientX;
  this.startClientY = touches ? touches[0].pageY : e.clientY;
  this.deltaX = 0;// reset for the case when user does 0,0 touch
  this.deltaY = 0;// reset for the case when user does 0,0 touch

  if (e.target.tagName === 'IMG' || e.target.tagName === 'A') { e.target.draggable = false; }
};

/**
 * Update slides positions according to user's touch
 * @param{event} e Touch event
 * @return {void}
 */
Carousel.prototype._drag = function _drag (e) {
  var touches;

  if (!this.dragging) {
    return;
  }

  e = e.originalEvent || e;
  touches = e.touches !== undefined ? e.touches : false;
  this.deltaX = (touches ? touches[0].pageX : e.clientX) - this.startClientX;
  this.deltaY = (touches ? touches[0].pageY : e.clientY) - this.startClientY;

  // drag slide along with cursor
  this._slide( -(this.current * this.width - this.deltaX ) );

  // determine if we should do slide, or cancel and let the event pass through to the page
  this.dragThresholdMet = Math.abs(this.deltaX) > this.dragThreshold;
};

/**
 * Drag end, calculate slides' new positions
 * @param{event} e Touch event
 * @return {void}
 */
Carousel.prototype._dragEnd = function _dragEnd (e) {
  if (!this.dragging) {
    return;
  }

  if (this.dragThresholdMet) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }

  this.dragging = false;

  if ( this.deltaX !== 0 && Math.abs(this.deltaX) < this.dragThreshold ) {
    this.go(this.current);
  }
  else if ( this.deltaX > 0 ) {
    // var jump = Math.round(this.deltaX / this.width);// distance-based check to swipe multiple slides
    // this.go(this.current - jump);
    this.prev();
  }
  else if ( this.deltaX < 0 ) {
    this.next();
  }

  this.deltaX = 0;
};


// ------------------------------------- carousel engine ------------------------------------- //


/**
 * Helper function to translate slide in browser
 * @param{[type]} el   [description]
 * @param{[type]} offset [description]
 * @return {[type]}      [description]
 */
Carousel.prototype._slide = function _slide (offset, animate) {
    var this$1 = this;

  var delay = 400;

  offset -= this.offset;

  if (animate) {
    this.sliding = true;
    this._addClass(this.slideWrap, this.options.animateClass);

    setTimeout(function () {
      this$1.sliding = false;
      this$1._removeClass(this$1.slideWrap, this$1.options.animateClass);
    }, delay);
  }

  if (this.transform) {
    this.slideWrap.style[this.transform] = 'translate3d(' + offset + 'px, 0, 0)';
  }
  else {
    this.slideWrap.style.left = offset+'px';
  }
};


// ------------------------------------- "helper" functions ------------------------------------- //


/**
 * Helper function. Calculate modulo of a slides position
 * @param{int} val Slide's position
 * @return {int} the index modulo the # of slides
 */
Carousel.prototype._loop = function _loop (val) {
  return (this.numSlides + (val % this.numSlides)) % this.numSlides;
};

/**
 * Set the Carousel's width and determine the slide offset.
 * @return {void}
 */
Carousel.prototype._getDimensions = function _getDimensions () {
  this.width = this.slides[0].getBoundingClientRect().width;
  this.offset = this.cloned * this.width;
};

/**
 * Update the slides' position on a resize. This is throttled at 300ms
 * @return {void}
 */
Carousel.prototype._updateView = function _updateView () {
    var this$1 = this;

  // Check if the resize was _horizontal_ -- on touch devices, changing scroll
  // direction will cause the browser tab bar to appear, which triggers a resize
  if (window.innerWidth !== this._viewport) {
    this._viewport = window.innerWidth;
    clearTimeout(this.timer);
    this.timer = setTimeout(function () {
      this$1._getDimensions();
      this$1.go(this$1.current);
    }, 300);
  }
};

/**
 * Duplicate the first and last N slides so that infinite scrolling can work.
 * Depends on how many slides are visible at a time, and any outlying slides as well
 * @return {void}
 */
Carousel.prototype._cloneSlides = function _cloneSlides () {
    var this$1 = this;

  var duplicate;
  var display = this.options.display;
  var fromEnd = Math.max(this.numSlides - display, 0);
  var fromBeg = Math.min(display, this.numSlides);

  // take "display" slides from the end and add to the beginning
  for (var i = this.numSlides; i > fromEnd; i--) {
    duplicate = this$1.slides[i-1].cloneNode(true);                     // cloneNode --> true is deep cloning
    duplicate.removeAttribute('id');
    duplicate.setAttribute('aria-hidden', 'true');
    this$1._addClass(duplicate, 'clone');
    this$1.slideWrap.insertBefore(duplicate, this$1.slideWrap.firstChild);// "prependChild"
    this$1.cloned++;
  }

  // take "display" slides from the beginning and add to the end
  for (var i$1 = 0; i$1 < fromBeg; i$1++) {
    duplicate = this$1.slides[i$1].cloneNode(true);
    duplicate.removeAttribute('id');
    duplicate.setAttribute('aria-hidden', 'true');
    this$1._addClass(duplicate, 'clone');
    this$1.slideWrap.appendChild(duplicate);
  }
};

/**
 * Helper function to add a class to an element
 * @param{int} i  Index of the slide to add a class to
 * @param{string} name Class name
 * @return {void}
 */
Carousel.prototype._addClass = function _addClass (el, name) {
  if (el.classList) { el.classList.add(name); }
  else {el.className += ' ' + name; }
};

/**
 * Helper function to remove a class from an element
 * @param{int} i  Index of the slide to remove class from
 * @param{string} name Class name
 * @return {void}
 */
Carousel.prototype._removeClass = function _removeClass (el, name) {
  if (el.classList) { el.classList.remove(name); }
  else { el.className = el.className.replace(new RegExp('(^|\\b)' + name.split(' ').join('|') + '(\\b|$)', 'gi'), ' '); }
};

module.exports = Carousel;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var isClient=typeof window!=='undefined';function getScreenWidth(){if(isClient){return window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth||document.body.offsetWidth;}}function isMobile(){if(isClient){return getScreenWidth()<767;}}function isDesktop(){if(isClient){return getScreenWidth()>767;}}exports.default={isMobile:isMobile,isDesktop:isDesktop};module.exports=exports['default'];

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/StatementsHeader/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _actions2=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _Icon=__webpack_require__(31);var _actions3=__webpack_require__(36);var _mailTo=__webpack_require__(256);var _mailTo2=_interopRequireDefault(_mailTo);var _styles=__webpack_require__(1932);var _data=__webpack_require__(1933);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var StatementsHeader=function StatementsHeader(_ref){var currency=_ref.currency,match=_ref.match,statements=_ref.statements,downloadEnabled=_ref.downloadEnabled,openModal=_ref.openModal,props=_objectWithoutProperties(_ref,['currency','match','statements','downloadEnabled','openModal']);return _react2.default.createElement(_styles.StatementHeader,{__source:{fileName:_jsxFileName,lineNumber:30}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_styles.HeaderText,{__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:33}},'Atualizado \xE0s ',_aleloLogic.utils.ISODateFormat(new Date(),'HH:mm'),','),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:34}},'dia ',_aleloLogic.utils.ISODateFormat(new Date()),' - Valores em ',currency)),_react2.default.createElement(_styles.NavHeader,{__source:{fileName:_jsxFileName,lineNumber:38}},downloadEnabled&&_react2.default.createElement(_styles.NavIcon,{alt:'Download',title:'Download extrato em CSV',id:'btnDownloadCSV',__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_Icon.Icon,{icon:'download',svgStyle:_styles.IconColor,'aria-label':_data.downloadStatementCSV,width:'31',height:'31',viewBox:'0 0 70 70',onClick:function onClick(){if(statements.enviarExtratoEmail){openModal(true,'csv');}else{props.setLoading(true);props.downloadCSVStatement(match.params.id,statements.filter);}},__source:{fileName:_jsxFileName,lineNumber:41}})),downloadEnabled&&_react2.default.createElement(_styles.NavIcon,{className:'print',alt:'Download',title:'Download extrato em PDF',id:'btnDownloadPDF',__source:{fileName:_jsxFileName,lineNumber:61}},_react2.default.createElement(_Icon.Icon,{icon:'print',svgStyle:_styles.IconColor,'aria-label':_data.downloadStatement,width:'31',height:'31',viewBox:'0 0 85 75',onClick:function onClick(){if(statements.enviarExtratoEmail){openModal(true,'pdf');}else{props.setLoading(true);props.downloadPdfStatement(match.params.id,statements.filter);}},__source:{fileName:_jsxFileName,lineNumber:67}})))));};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{downloadPdfStatement:function downloadPdfStatement(planId,filter){return dispatch((0,_actions.downloadStatementFile)(planId,filter)).finally(function(){return dispatch((0,_actions3.setLoading)(false));});},setLoading:function setLoading(isLoading){dispatch((0,_actions3.setLoading)(isLoading));},shareStatement:function shareStatement(planId,year,month){dispatch((0,_actions2.showModal)(_ModalTypes.INPUT_MODAL,_extends({},_data.modal,{fetchSendProvider:function fetchSendProvider(){return fetch('/api/accountplans/'+planId+'/invoices/'+year+'/'+month+'/mail');},onConfirm:function onConfirm(){return dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:'Seu extrato foi enviado.',image:_mailTo2.default}));},image:_mailTo2.default})));},downloadCSVStatement:function downloadCSVStatement(planId,filter){return dispatch((0,_actions.downloadStatementFileCSV)(planId,filter)).finally(function(){return dispatch((0,_actions3.setLoading)(false));});}};};exports.default=(0,_reactRedux.connect)(null,mapDispatchToProps)(StatementsHeader);module.exports=exports['default'];

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/StatementsList/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _LoadMore=__webpack_require__(398);var _LoadMore2=_interopRequireDefault(_LoadMore);var _StatementsListItem=__webpack_require__(1936);var _StatementsListItem2=_interopRequireDefault(_StatementsListItem);var _styles=__webpack_require__(1939);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var dayOfWeekMap={0:'Domingo',1:'Segunda',2:'Terça',3:'Quarta',4:'Quinta',5:'Sexta',6:'Sábado'};var monthOfYearMap={0:'Janeiro',1:'Fevereiro',2:'Março',3:'Abril',4:'Maio',5:'Junho',6:'Julho',7:'Agosto',8:'Setembro',9:'Outubro',10:'Novembro',11:'Dezembro'};function renderSectionItems(items){return items.map(function(statement,index){return _react2.default.createElement(_StatementsListItem2.default,_extends({},statement,{key:index,nextType:items[index+1]?items[index+1].type:'',__source:{fileName:_jsxFileName,lineNumber:33}}));});}function renderSectionDate(key){var date=_aleloLogic.utils.dateParser(key);return _react2.default.createElement(_styles.Sidebar,{__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:45}},dayOfWeekMap[date.getDay()].toUpperCase()),_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:46}},date.getDate()),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:47}},monthOfYearMap[date.getMonth()].toUpperCase()));}function renderSection(data){var groupedData=_aleloLogic.utils.groupArray(data||[],function(item){return _aleloLogic.utils.ISODateFormat(item.processDate);});var keys=Object.keys(groupedData);return keys.map(function(key){return _react2.default.createElement(_styles.StatementGroup,{key:key,__source:{fileName:_jsxFileName,lineNumber:58}},renderSectionDate(key),_react2.default.createElement(_styles.List,{__source:{fileName:_jsxFileName,lineNumber:60}},renderSectionItems(groupedData[key])));});}var StatementsList=function StatementsList(_ref){var data=_ref.data,next=_ref.next,loadMoreHandler=_ref.loadMoreHandler,hasNext=_ref.hasNext;return _react2.default.createElement(_styles.Statements,{__source:{fileName:_jsxFileName,lineNumber:66}},renderSection(data),next!=null&&hasNext!=null&&_react2.default.createElement(_styles.StatementsFooter,{__source:{fileName:_jsxFileName,lineNumber:70}},_react2.default.createElement(_LoadMore2.default,{w:130,onClick:loadMoreHandler,__source:{fileName:_jsxFileName,lineNumber:71}})));};exports.default=StatementsList;module.exports=exports['default'];

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/FilterByPeriod/FilterByPeriod.js';/* eslint-disable */var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _PeriodOption=__webpack_require__(1942);var _PeriodOption2=_interopRequireDefault(_PeriodOption);var _CalendarFilter=__webpack_require__(1943);var _CalendarFilter2=_interopRequireDefault(_CalendarFilter);var _styles=__webpack_require__(637);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var filterItems=[{value:7,label:'7 dias'},{value:15,label:'15 dias'},{value:30,label:'30 dias'},{value:60,label:'60 dias'},{value:90,label:'90 dias'},{value:0,label:'Período específico'}];function FilterByPeriod(_ref){var selectedPeriod=_ref.selectedPeriod,onChange=_ref.onChange,_ref$options=_ref.options,options=_ref$options===undefined?filterItems:_ref$options,_ref$rangeForValidati=_ref.rangeForValidation,rangeForValidation=_ref$rangeForValidati===undefined?90:_ref$rangeForValidati;return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:42}},'Per\xEDodo'),_react2.default.createElement(_styles.FilterTypeContainer,{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_styles.FilterTypes,{__source:{fileName:_jsxFileName,lineNumber:44}},options.map(function(type){return _react2.default.createElement(_styles.ListItem,{key:type.value,__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_PeriodOption2.default,{key:type.value,value:type.value,onChange:onChange,name:'periodo',label:type.label,selectedPeriod:selectedPeriod,__source:{fileName:_jsxFileName,lineNumber:47}}));}))),selectedPeriod===0&&_react2.default.createElement(_CalendarFilter2.default,{rangeForValidation:rangeForValidation,__source:{fileName:_jsxFileName,lineNumber:59}})));}var mapStateToProps=function mapStateToProps(state){var selector=(0,_reduxForm.formValueSelector)('statementsFilter');return{selectedPeriod:selector(state,'periodo')};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(FilterByPeriod);module.exports=exports['default'];

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RadioLabel=exports.Radio=exports.CheckMark=exports.InputRadio=exports.ListItem=exports.FilterTypes=exports.FilterTypeContainer=exports.Content=exports.Container=exports.Title=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-i8r622-0'})(['letter-spacing:',';color:',';margin-top:',';margin-bottom:',';',';letter-spacing:normal;line-height:1;'],(0,_em2.default)('0.4px'),_colors.darkSlateBlue,(0,_rem2.default)('25px'),(0,_rem2.default)('30px'),_types.title28GalanoBold);var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-i8r622-1'})(['width:100%;padding:',' 0 ',';background-color:white;display:flex;justify-content:center;'],(0,_rem2.default)('9px'),(0,_rem2.default)('17px'));var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-i8r622-2'})(['display:flex;justify-content:flex-start;flex-direction:column;width:',';'],(0,_rem2.default)('940px'));var FilterTypeContainer=exports.FilterTypeContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FilterTypeContainer',componentId:'sc-i8r622-3'})(['padding:0;overflow:auto;']);var FilterTypes=exports.FilterTypes=_styledComponents2.default.ul.withConfig({displayName:'styles__FilterTypes',componentId:'sc-i8r622-4'})(['display:flex;justify-content:flex-start;list-style:none;margin:0;min-height:',';padding:0;width:100%;align-items:center;'],(0,_rem2.default)('56px'));var ListItem=exports.ListItem=_styledComponents2.default.li.withConfig({displayName:'styles__ListItem',componentId:'sc-i8r622-5'})(['margin-right:40px;']);var InputRadio=exports.InputRadio=_styledComponents2.default.input.attrs({type:'radio'}).withConfig({displayName:'styles__InputRadio',componentId:'sc-i8r622-6'})(['display:none;']);var CheckMark=exports.CheckMark=_styledComponents2.default.span.withConfig({displayName:'styles__CheckMark',componentId:'sc-i8r622-7'})(['border-radius:30px;width:7px;height:7px;position:absolute;top:6px;left:6px;content:\' \';background:white;display:block;z-index:1;']);var Radio=exports.Radio=_styledComponents2.default.span.withConfig({displayName:'styles__Radio',componentId:'sc-i8r622-8'})(['display:inline-block;position:absolute;top:0;left:0;margin:0 5px 0 0;width:20px;height:20px;border-radius:11px;border:2px solid #004c97;background-color:',';'],function(_ref){var isSelected=_ref.isSelected;return isSelected?_colors.darkSlateBlue:'transparent';});var RadioLabel=exports.RadioLabel=_styledComponents2.default.label.withConfig({displayName:'styles__RadioLabel',componentId:'sc-i8r622-9'})(['position:relative;color:',';',';padding-left:30px;'],_colors.darkSlateBlue,_types.txt16OpenSansBold);

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DayPicker = __webpack_require__(1944);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DayPicker).default;
  }
});

var _DateUtils = __webpack_require__(158);

Object.defineProperty(exports, 'DateUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DateUtils).default;
  }
});

var _LocaleUtils = __webpack_require__(259);

Object.defineProperty(exports, 'LocaleUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_LocaleUtils).default;
  }
});

var _ModifiersUtils = __webpack_require__(399);

Object.defineProperty(exports, 'ModifiersUtils', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ModifiersUtils).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/FilterByWeekDays/FilterByWeekDays.js';/* eslint-disable */var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _CheckboxItem=__webpack_require__(1957);var _CheckboxItem2=_interopRequireDefault(_CheckboxItem);var _styles=__webpack_require__(640);var _CalendarIcon=__webpack_require__(1958);var _CalendarIcon2=_interopRequireDefault(_CalendarIcon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var filterItems=[{value:6,label:'Dom'},{value:0,label:'Seg'},{value:1,label:'Ter'},{value:2,label:'Qua'},{value:3,label:'Qui'},{value:4,label:'Sex'},{value:5,label:'Sab'}];function FilterByWeekDays(props){return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_styles.TitleContainer,{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_CalendarIcon2.default,{__source:{fileName:_jsxFileName,lineNumber:44}}),_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:45}},'Dias da semana espec\xEDficos')),_react2.default.createElement(_styles.FilterContainer,{__source:{fileName:_jsxFileName,lineNumber:47}},_react2.default.createElement(_styles.FilterTypes,{__source:{fileName:_jsxFileName,lineNumber:48}},filterItems.map(function(type,index){return _react2.default.createElement(_styles.ListItem,{key:type.value,__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_CheckboxItem2.default,{setWeekDayRef:props.setWeekDayRef,typeValue:type.value,onChange:props.onChange,name:'diaDaSemana',label:type.label,index:index,__source:{fileName:_jsxFileName,lineNumber:52}}));})))));}exports.default=FilterByWeekDays;module.exports=exports['default'];

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.InputCheckbox=exports.CheckboxLabel=exports.FilterTypes=exports.CheckBoxContainer=exports.ListItem=exports.FilterContainer=exports.Content=exports.Container=exports.TitleContainer=exports.Title=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-1j3rkfa-0'})(['letter-spacing:',';color:',';',';letter-spacing:normal;line-height:1;margin-left:15px;margin-top:',';'],(0,_em2.default)('0.4px'),_colors.darkSlateBlue,_types.title16Galano,(0,_rem2.default)('8px'));var TitleContainer=exports.TitleContainer=_styledComponents2.default.div.withConfig({displayName:'styles__TitleContainer',componentId:'sc-1j3rkfa-1'})(['display:flex;flex-direction:row;align-items:center;justify-content:flex-start;margin-bottom:30px;margin-top:',';'],(0,_rem2.default)('20px'));var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-1j3rkfa-2'})(['width:100%;padding:',' 0 ',';background-color:white;display:flex;justify-content:center;'],(0,_rem2.default)('9px'),(0,_rem2.default)('50px'));var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-1j3rkfa-3'})(['display:flex;justify-content:flex-start;flex-direction:column;width:',';align-items:flex-start;'],(0,_rem2.default)('940px'));var FilterContainer=exports.FilterContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FilterContainer',componentId:'sc-1j3rkfa-4'})(['padding:0;']);var ListItem=exports.ListItem=_styledComponents2.default.li.withConfig({displayName:'styles__ListItem',componentId:'sc-1j3rkfa-5'})(['margin:0;height:100%;']);var CheckBoxContainer=exports.CheckBoxContainer=_styledComponents2.default.div.withConfig({displayName:'styles__CheckBoxContainer',componentId:'sc-1j3rkfa-6'})(['position:relative;height:100%;width:100%;display:flex;']);var FilterTypes=exports.FilterTypes=_styledComponents2.default.ul.withConfig({displayName:'styles__FilterTypes',componentId:'sc-1j3rkfa-7'})(['display:flex;align-items:center;list-style:none;margin:0;height:',';padding:0;width:100%;box-shadow:0px 4px 12px rgba(0,0,0,0.08),0px 0px 1px rgba(0,0,0,0.12);border-radius:',';overflow:auto;& li:last-of-type label{border:none;}'],(0,_rem2.default)('45px'),(0,_rem2.default)('8px'));var CheckboxLabel=exports.CheckboxLabel=_styledComponents2.default.label.withConfig({displayName:'styles__CheckboxLabel',componentId:'sc-1j3rkfa-8'})(['position:relative;color:',';',';padding:',' ',';height:100%;border-right:1px solid rgba(17,14,73,0.16);'],_colors.darkSlateBlue,_types.txt16OpenSansBold,(0,_rem2.default)('10px'),(0,_rem2.default)('30px'));var InputCheckbox=exports.InputCheckbox=_styledComponents2.default.input.attrs({type:'checkbox'}).withConfig({displayName:'styles__InputCheckbox',componentId:'sc-1j3rkfa-9'})(['opacity:0;display:block;z-index:1;position:absolute;width:100%;height:100%;&:checked + ','{background:#aeabc4;}'],CheckboxLabel);

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Title=exports.ServicesCheckboxes=exports.ServicesCheckboxesContainer=exports.Content=exports.Container=exports.InputCheckbox=exports.Box=exports.Label=exports.CheckIcon=exports.CheckBoxContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n        padding: 0;\n    '],['\n        padding: 0;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        margin: 0 ',';\n        overflow: auto;\n        padding: 0 ',';\n    '],['\n        margin: 0 ',';\n        overflow: auto;\n        padding: 0 ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        display: block;\n        padding-right: 10%;\n        width 212%;\n\n        :after {\n            clear: both;\n            content: \'\';\n            display: table;\n        }\n    '],['\n        display: block;\n        padding-right: 10%;\n        width 212%;\n\n        :after {\n            clear: both;\n            content: \'\';\n            display: table;\n        }\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var animateCheck=(0,_styledComponents.keyframes)(['0%{transform:translateX(-50%) translateY(-50%) scale(0.6);}40%{transform:translateX(-50%) translateY(-50%) scale(1.3);}70%{transform:translateX(-50%) translateY(-50%) scale(.8);}100%{transform:translateX(-50%) translateY(-50%) scale(1);}']);var CheckBoxContainer=exports.CheckBoxContainer=_styledComponents2.default.li.withConfig({displayName:'styles__CheckBoxContainer',componentId:'sc-7sg4hp-0'})(['',';',';position:relative;height:100%;display:flex;align-items:center;margin-right:',';'],function(_ref){var disabled=_ref.disabled;return disabled&&'pointer-events: none;';},function(_ref2){var disabled=_ref2.disabled;return disabled&&'opacity: 0.3;';},(0,_rem2.default)('40px'));var CheckIcon=exports.CheckIcon=_styledComponents2.default.i.withConfig({displayName:'styles__CheckIcon',componentId:'sc-7sg4hp-1'})(['animation:0.4s ',' forwards;color:white;display:none;height:auto;left:50%;position:absolute;top:50%;transform:translateX(-50%) translateY(-50%) scale(1);width:auto;'],animateCheck);var Label=exports.Label=_styledComponents2.default.span.withConfig({displayName:'styles__Label',componentId:'sc-7sg4hp-2'})(['color:',';',';margin-left:',';'],_colors.darkSlateBlue,_types.txt16OpenSansBold,(0,_rem2.default)('10px'));var Box=exports.Box=_styledComponents2.default.span.withConfig({displayName:'styles__Box',componentId:'sc-7sg4hp-3'})(['',';position:relative;border:solid ',' ',';border-radius:',';box-shadow:0;display:block;height:',';min-width:',';min-height:',';position:relative;transition:0.3s box-shadow;width:',';'],function(_ref3){var checked=_ref3.checked;return checked&&'display: block';},(0,_rem2.default)('2px'),_colors.darkSlateBlue,(0,_rem2.default)('4px'),(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('16px'));var InputCheckbox=exports.InputCheckbox=_styledComponents2.default.input.attrs({type:'checkbox'}).withConfig({displayName:'styles__InputCheckbox',componentId:'sc-7sg4hp-4'})(['opacity:0;display:block;z-index:1;position:absolute;width:100%;height:100%;&:checked + ','{background:',';','{display:block;}}'],Box,_colors.darkSlateBlue,CheckIcon);var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-7sg4hp-5'})(['width:100%;padding:',' 0 ',';background-color:white;display:flex;justify-content:center;'],(0,_rem2.default)('9px'),(0,_rem2.default)('17px'));var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-7sg4hp-6'})(['display:flex;justify-content:flex-start;flex-direction:column;width:',';'],(0,_rem2.default)('940px'));var ServicesCheckboxesContainer=exports.ServicesCheckboxesContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ServicesCheckboxesContainer',componentId:'sc-7sg4hp-7'})(['',';',';'],_media2.default.large(_templateObject),_media2.default.small(_templateObject2,(0,_rem2.default)('-24px'),(0,_rem2.default)('20px')));var ServicesCheckboxes=exports.ServicesCheckboxes=_styledComponents2.default.ul.withConfig({displayName:'styles__ServicesCheckboxes',componentId:'sc-7sg4hp-8'})(['display:flex;justify-content:flex-start;list-style:none;margin:0;min-height:',';padding:0;',';'],(0,_rem2.default)('76px'),_media2.default.small(_templateObject3));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-7sg4hp-9'})(['letter-spacing:',';color:',';margin-top:',';margin-bottom:',';',';letter-spacing:normal;line-height:1;'],(0,_em2.default)('0.4px'),_colors.darkSlateBlue,(0,_rem2.default)('25px'),(0,_rem2.default)('30px'),_types.title28GalanoBold);

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/EmailStatementModal/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _ModalBlue=__webpack_require__(188);var _ModalBlue2=_interopRequireDefault(_ModalBlue);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _TextInput=__webpack_require__(101);var _TextInput2=_interopRequireDefault(_TextInput);var _aleloLogic=__webpack_require__(12);var _styles=__webpack_require__(1978);var _iconVeloeBackground=__webpack_require__(137);var _iconVeloeBackground2=_interopRequireDefault(_iconVeloeBackground);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var validate=function validate(values){var errors={};if(!values.email){errors.email='Campo Obrigatório';}};var renderTextInput=function renderTextInput(_ref){var input=_ref.input,_ref$meta=_ref.meta,touched=_ref$meta.touched,error=_ref$meta.error,props=_objectWithoutProperties(_ref,['input','meta']);return _react2.default.createElement(_TextInput2.default,_extends({type:'text'},input,props,{errorMessage:touched&&error,__source:{fileName:_jsxFileName,lineNumber:21}}));};var EmailStatementModal=function(_React$Component){_inherits(EmailStatementModal,_React$Component);function EmailStatementModal(){_classCallCheck(this,EmailStatementModal);return _possibleConstructorReturn(this,(EmailStatementModal.__proto__||Object.getPrototypeOf(EmailStatementModal)).apply(this,arguments));}_createClass(EmailStatementModal,[{key:'render',value:function render(){var _props=this.props,handleClick=_props.handleClick,openModal=_props.openModal,handleChangeEmail=_props.handleChangeEmail,valid=_props.valid,saving=_props.saving;return _react2.default.createElement(_ModalBlue2.default,{backgroundImage:_iconVeloeBackground2.default,position:'right bottom',__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:30}},'Download do extrato'),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:31}}),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:32}},'Informe o email para receber o link para fazer download do extrato.'),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:33}}),_react2.default.createElement(_styles.Form,{__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement(_reduxForm.Field,{name:'email',lengthCounter:true,placeholder:'Digite Aqui',component:renderTextInput,label:'E-mail',validate:[_aleloLogic.utils.emptyFieldValidate,_aleloLogic.utils.emailValidate],onChange:function onChange(evt){return handleChangeEmail(evt);},isRequired:true,negative:true,__source:{fileName:_jsxFileName,lineNumber:35}})),_react2.default.createElement(_styles.WrapperButton,{__source:{fileName:_jsxFileName,lineNumber:47}},_react2.default.createElement(_Button2.default,{disabled:!valid||saving,loading:saving,buttonType:'darkBlue',text:'Ok',onClick:function onClick(){return handleClick();},type:'button',__source:{fileName:_jsxFileName,lineNumber:48}}),_react2.default.createElement(_Button2.default,{buttonType:'white',text:'Cancelar',onClick:function onClick(){return openModal(false,null);},type:'button',__source:{fileName:_jsxFileName,lineNumber:57}}))));}}]);return EmailStatementModal;}(_react2.default.Component);exports.default=(0,_reduxForm.reduxForm)({form:'EmailStatementModal',validate:validate})(EmailStatementModal);module.exports=exports['default'];

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1982);


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var isType = function (type, value) {
  return typeof value === type;
};
exports.isType = isType;
var isObject = function (value) {
  return isType("object", value);
};
exports.isObject = isObject;
var isString = function (value) {
  return isType("string", value);
};
exports.isString = isString;
var isNumber = function (value) {
  return isType("number", value);
};
exports.isNumber = isNumber;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RadioLabel=exports.CheckMark=exports.Radio=exports.InputRadio=exports.ListItem=exports.FilterTypes=exports.FilterTypeContainer=exports.SearchButton=exports.InputContainer=exports.Container=exports.SearchInputWrapper=exports.Valid=exports.Error=exports.Loading=exports.SearchInput=exports.SearchIconContainer=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SearchIconContainer=exports.SearchIconContainer=_styledComponents2.default.div.withConfig({displayName:'styles__SearchIconContainer',componentId:'sc-gnt9w8-0'})(['position:absolute;left:15px;top:20px;']);var SearchInput=exports.SearchInput=_styledComponents2.default.input.withConfig({displayName:'styles__SearchInput',componentId:'sc-gnt9w8-1'})(['border:none;border-bottom:3px solid ',';',';',';background-color:',';padding:',' ',' ',' ',';line-height:',';color:',';',';width:100%;margin-bottom:',';'],_colors.darkSlateBlue,function(_ref){var plateIsValid=_ref.plateIsValid;return plateIsValid&&'border-bottom: 3px solid '+_colors.deliveredGreen;},function(_ref2){var invalidInput=_ref2.invalidInput;return invalidInput&&'border-bottom: 3px solid '+_colors.red;},_colors.paleGray,(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('50px'),(0,_rem2.default)('24px'),_colors.darkSlateBlue,_types.txt16OpenSans,(0,_rem2.default)('15px'));var Loading=exports.Loading=_styledComponents2.default.img.withConfig({displayName:'styles__Loading',componentId:'sc-gnt9w8-2'})(['width:',';'],(0,_rem2.default)('25px'));var Error=exports.Error=_styledComponents2.default.span.withConfig({displayName:'styles__Error',componentId:'sc-gnt9w8-3'})(['color:',';display:inline-block;font-family:OpenSans;font-size:',';letter-spacing:',';'],_colors.red,(0,_rem2.default)('14px'),(0,_rem2.default)('-0.3px'));var Valid=exports.Valid=_styledComponents2.default.span.withConfig({displayName:'styles__Valid',componentId:'sc-gnt9w8-4'})(['color:',';display:inline-block;font-family:OpenSans;font-size:',';'],_colors.deliveredGreen,(0,_rem2.default)('14px'));var SearchInputWrapper=exports.SearchInputWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__SearchInputWrapper',componentId:'sc-gnt9w8-5'})(['position:relative;width:100%;display:flex;flex-direction:column;',';'],function(_ref3){var hide=_ref3.hide;return hide&&'display: none';});var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-gnt9w8-6'})(['width:100%;padding:',' 0 ',';background-color:white;display:flex;justify-content:center;flex-direction:column;'],(0,_rem2.default)('50px'),(0,_rem2.default)('15px'));var InputContainer=exports.InputContainer=_styledComponents2.default.div.withConfig({displayName:'styles__InputContainer',componentId:'sc-gnt9w8-7'})(['position:relative;display:flex;justify-content:flex-start;flex-direction:row;width:',';align-items:flex-start;'],(0,_rem2.default)('940px'));var SearchButton=exports.SearchButton=_styledComponents2.default.button.withConfig({displayName:'styles__SearchButton',componentId:'sc-gnt9w8-8'})(['background-color:',';color:white;',';padding:',' ',';border-radius:25px;margin-left:',';',';'],_colors.darkSlateBlue,_types.txt16OpenSansBold,(0,_rem2.default)('13px'),(0,_rem2.default)('35px'),(0,_rem2.default)('20px'),function(_ref4){var plateIsValid=_ref4.plateIsValid;return plateIsValid&&'display:none;';});var FilterTypeContainer=exports.FilterTypeContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FilterTypeContainer',componentId:'sc-gnt9w8-9'})(['padding:0;overflow:auto;']);var FilterTypes=exports.FilterTypes=_styledComponents2.default.ul.withConfig({displayName:'styles__FilterTypes',componentId:'sc-gnt9w8-10'})(['display:flex;justify-content:flex-start;list-style:none;margin:0;min-height:',';padding:0;width:100%;align-items:center;'],(0,_rem2.default)('56px'));var ListItem=exports.ListItem=_styledComponents2.default.li.withConfig({displayName:'styles__ListItem',componentId:'sc-gnt9w8-11'})(['margin-right:40px;']);var InputRadio=exports.InputRadio=_styledComponents2.default.input.attrs({type:'radio'}).withConfig({displayName:'styles__InputRadio',componentId:'sc-gnt9w8-12'})(['display:none;']);var Radio=exports.Radio=_styledComponents2.default.span.withConfig({displayName:'styles__Radio',componentId:'sc-gnt9w8-13'})(['display:inline-block;position:absolute;top:0;left:0;margin:0 5px 0 0;width:20px;height:20px;border-radius:11px;border:2px solid #004c97;background-color:transparent;']);var CheckMark=exports.CheckMark=_styledComponents2.default.span.withConfig({displayName:'styles__CheckMark',componentId:'sc-gnt9w8-14'})(['display:none;border-radius:30px;width:7px;height:7px;position:absolute;top:6px;left:6px;content:\' \';background:white;']);var RadioLabel=exports.RadioLabel=_styledComponents2.default.label.withConfig({displayName:'styles__RadioLabel',componentId:'sc-gnt9w8-15'})(['position:relative;color:',';',';padding-left:30px;',':checked ~ ','{display:block;z-index:1;}',':checked ~ ','{background-color:',';}'],_colors.darkSlateBlue,_types.txt16OpenSansBold,InputRadio,CheckMark,InputRadio,Radio,_colors.darkSlateBlue);

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RadioLabel=exports.Radio=exports.CheckMark=exports.InputRadio=exports.ListItem=exports.FilterTypes=exports.FilterTypeContainer=exports.Content=exports.Container=exports.Title=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-sbstzy-0'})(['letter-spacing:',';color:',';margin-top:',';margin-bottom:',';',';letter-spacing:normal;line-height:1;'],(0,_em2.default)('0.4px'),_colors.darkSlateBlue,(0,_rem2.default)('30px'),(0,_rem2.default)('30px'),_types.title28GalanoBold);var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-sbstzy-1'})(['width:100%;padding:',' 0 ',';background-color:white;display:flex;justify-content:center;'],(0,_rem2.default)('9px'),(0,_rem2.default)('17px'));var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-sbstzy-2'})(['display:flex;justify-content:flex-start;flex-direction:column;width:',';'],(0,_rem2.default)('940px'));var FilterTypeContainer=exports.FilterTypeContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FilterTypeContainer',componentId:'sc-sbstzy-3'})(['padding:0;overflow:auto;']);var FilterTypes=exports.FilterTypes=_styledComponents2.default.ul.withConfig({displayName:'styles__FilterTypes',componentId:'sc-sbstzy-4'})(['display:flex;justify-content:flex-start;list-style:none;margin:0;min-height:',';padding:0;width:100%;align-items:center;'],(0,_rem2.default)('56px'));var ListItem=exports.ListItem=_styledComponents2.default.li.withConfig({displayName:'styles__ListItem',componentId:'sc-sbstzy-5'})(['margin-right:40px;']);var InputRadio=exports.InputRadio=_styledComponents2.default.input.attrs({type:'radio'}).withConfig({displayName:'styles__InputRadio',componentId:'sc-sbstzy-6'})(['display:none;']);var CheckMark=exports.CheckMark=_styledComponents2.default.span.withConfig({displayName:'styles__CheckMark',componentId:'sc-sbstzy-7'})(['display:none;border-radius:30px;width:7px;height:7px;position:absolute;top:6px;left:6px;content:\' \';background:white;']);var Radio=exports.Radio=_styledComponents2.default.span.withConfig({displayName:'styles__Radio',componentId:'sc-sbstzy-8'})(['display:inline-block;position:absolute;top:0;left:0;margin:0 5px 0 0;width:20px;height:20px;border-radius:11px;border:2px solid #004c97;background-color:transparent;']);var RadioLabel=exports.RadioLabel=_styledComponents2.default.label.withConfig({displayName:'styles__RadioLabel',componentId:'sc-sbstzy-9'})(['position:relative;color:',';',';padding-left:30px;',':checked ~ ','{display:block;z-index:1;}',':checked ~ ','{background-color:',';}'],_colors.darkSlateBlue,_types.txt16OpenSansBold,InputRadio,CheckMark,InputRadio,Radio,_colors.darkSlateBlue);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ResetButton=exports.ShowResultsInput=exports.FormButton=exports.ShowResultsFormWrapper=exports.ShowResultsBtnWrapper=exports.Grid=exports.InputsContainer=exports.ButtonsContainer=exports.Separator=exports.FormsContainer=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FormsContainer=exports.FormsContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FormsContainer',componentId:'sc-1q9qq0f-0'})(['width:100%;display:flex;align-items:center;flex-direction:column;']);var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'styles__Separator',componentId:'sc-1q9qq0f-1'})(['border-top:2px solid ',';width:100%;margin:0;'],_colors.paleGray);var ButtonsContainer=exports.ButtonsContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonsContainer',componentId:'sc-1q9qq0f-2'})(['width:100%;background-color:',';height:',';align-items:center;justify-content:center;display:flex;'],_colors.darkSlateBlue,(0,_rem2.default)('100px'));var InputsContainer=exports.InputsContainer=_styledComponents2.default.div.withConfig({displayName:'styles__InputsContainer',componentId:'sc-1q9qq0f-3'})(['width:',';align-items:center;justify-content:center;display:flex;flex-direction:column;'],(0,_rem2.default)('940px'));var Grid=exports.Grid=_styledComponents2.default.div.withConfig({displayName:'styles__Grid',componentId:'sc-1q9qq0f-4'})(['width:',';display:flex;justify-content:space-between;'],(0,_rem2.default)('940px'));var ShowResultsBtnWrapper=exports.ShowResultsBtnWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__ShowResultsBtnWrapper',componentId:'sc-1q9qq0f-5'})(['width:',';display:flex;justify-content:flex-end;margin:',' 0;'],(0,_rem2.default)('940px'),(0,_rem2.default)('30px'));var ShowResultsFormWrapper=exports.ShowResultsFormWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__ShowResultsFormWrapper',componentId:'sc-1q9qq0f-6'})(['width:100%;display:flex;justify-content:center;']);var FormButton=exports.FormButton=_styledComponents2.default.button.withConfig({displayName:'styles__FormButton',componentId:'sc-1q9qq0f-7'})(['background-color:',';color:white;',';padding:',' ',';border-radius:25px;margin-left:',';border-width:0;',';',';'],_colors.skyBlue,_types.txt16OpenSansBold,(0,_rem2.default)('13px'),(0,_rem2.default)('25px'),(0,_rem2.default)('20px'),function(_ref){var invalid=_ref.invalid;return!invalid&&'cursor: pointer;';},function(_ref2){var invalid=_ref2.invalid;return invalid&&'opacity: 0.5;';});var ShowResultsInput=exports.ShowResultsInput=_styledComponents2.default.input.withConfig({displayName:'styles__ShowResultsInput',componentId:'sc-1q9qq0f-8'})(['border:none;border-bottom:3px solid ',';background-color:',';padding:',';line-height:',';color:',';',';width:100%;margin:0 ',';&:first-of-type{margin:0;margin-right:',';}&:last-of-type{margin:0;margin-left:',';}'],_colors.darkSlateBlue,_colors.paleGray,(0,_rem2.default)('16px'),(0,_rem2.default)('24px'),_colors.darkSlateBlue,_types.txt16OpenSans,(0,_rem2.default)('10px'),(0,_rem2.default)('10px'),(0,_rem2.default)('10px'));var ResetButton=exports.ResetButton=_styledComponents2.default.button.withConfig({displayName:'styles__ResetButton',componentId:'sc-1q9qq0f-9'})(['color:',';',';border-width:0;border-bottom:2px solid ',';'],function(_ref3){var showResults=_ref3.showResults;return showResults?_colors.darkSlateBlue:'white';},_types.txt16OpenSansBold,function(_ref4){var showResults=_ref4.showResults;return showResults?_colors.darkSlateBlue:'white';});

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonContainer=exports.ListItem=exports.StatusContent=exports.IconContainer=exports.StatusContainer=exports.LinkToInvoice=exports.ButtonAlert=exports.Download=exports.Text=exports.Title=exports.Label=exports.Item=exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n        width: 25%;\n    '],['\n        width: 25%;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        margin-top: ',';\n    '],['\n        margin-top: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        margin-right: ',';\n    '],['\n        margin-right: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        ',';\n\n        .month {\n            display: none;\n        }\n\n        .download-button {\n            display: block;\n        }\n    '],['\n        ',';\n\n        .month {\n            display: none;\n        }\n\n        .download-button {\n            display: block;\n        }\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-1eqaurh-0'})(['',';display:flex;'],_content2.default);var Item=exports.Item=_styledComponents2.default.div.withConfig({displayName:'styles__Item',componentId:'sc-1eqaurh-1'})(['',';'],_media2.default.large(_templateObject));var Label=exports.Label=_styledComponents2.default.label.withConfig({displayName:'styles__Label',componentId:'sc-1eqaurh-2'})(['color:',';font-family:OpenSans;font-size:',';font-weight:200;letter-spacing:',';line-height:1;pointer-events:none;text-transform:uppercase;white-space:nowrap;display:block;margin-bottom:',';'],_colors.darkGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('0.4px'),(0,_rem2.default)('15px'));var Title=exports.Title=_styledComponents2.default.p.withConfig({displayName:'styles__Title',componentId:'sc-1eqaurh-3'})(['letter-spacing:',';margin:0;line-height:1;font-size:',';font-weight:normal;',';',';'],(0,_rem2.default)('0.3px'),(0,_rem2.default)('14px'),function(props){return props.right&&'\n      text-align: right;\n      padding-right: 50px;\n    ';},function(props){return props.left&&'\n      text-align: left;\n      padding-left: 32px;\n    ';});var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1eqaurh-4'})(['',';color:',';line-height:',';',';'],_types.txt14OpenSansBold,_colors.darkGrey,(0,_rem2.default)('1.2px'),function(props){return props.status==='atraso'&&'\n        color: '+_colors.orange+'\n    ';});var Download=exports.Download=_styledComponents2.default.button.withConfig({displayName:'styles__Download',componentId:'sc-1eqaurh-5'})(['',';color:',';text-decoration:none;cursor:pointer;'],_types.txt14OpenSansBold,_colors.linkNavyBlue);var ButtonAlert=exports.ButtonAlert=_styledComponents2.default.a.withConfig({displayName:'styles__ButtonAlert',componentId:'sc-1eqaurh-6'})(['display:block;width:100%;text-decoration:none;cursor:pointer;']);var LinkToInvoice=exports.LinkToInvoice=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__LinkToInvoice',componentId:'sc-1eqaurh-7'})(['display:block;width:100%;text-decoration:none;color:inherit;']);var StatusContainer=exports.StatusContainer=_styledComponents2.default.div.withConfig({displayName:'styles__StatusContainer',componentId:'sc-1eqaurh-8'})(['position:relative;display:flex;align-items:flex-start;height:100%;',';'],_media2.default.small(_templateObject2,(0,_rem2.default)('20px')));var IconContainer=exports.IconContainer=_styledComponents2.default.div.withConfig({displayName:'styles__IconContainer',componentId:'sc-1eqaurh-9'})(['display:inline-block;width:',';margin-right:',';img{max-width:100%;}',';'],(0,_rem2.default)('40px'),(0,_rem2.default)('15px'),_media2.default.large(_templateObject3,(0,_rem2.default)('30px')));var StatusContent=exports.StatusContent=_styledComponents2.default.div.withConfig({displayName:'styles__StatusContent',componentId:'sc-1eqaurh-10'})(['p{font-size:',';}'],(0,_rem2.default)('14px'));var ListItem=exports.ListItem=_styledComponents2.default.li.withConfig({displayName:'styles__ListItem',componentId:'sc-1eqaurh-11'})(['position:relative;padding:',' 0;border-bottom:',' solid ',';color:',';:hover{background-color:',';p{color:',';}}.download-button{position:absolute;top:',';right:',';display:none;}',';',';'],(0,_rem2.default)('5px'),(0,_rem2.default)('1px'),_colors.lightestBlue,_colors.darkGrey,_colors.nearWhite,_colors.linkNavyBlue,(0,_rem2.default)('30px'),(0,_rem2.default)('30px'),function(props){return props.first?'\n            '+Title+' {\n                '+_types.title30GalanoBold+';\n                color: '+_colors.linkNavyBlue+';\n                letter-spacing: 0.001em;\n            }\n        ':'\n            '+Title+' {\n                '+_types.title24Galano+';\n            }\n    ';},_media2.default.small(_templateObject4,function(props){return props.first&&'\n            '+Title+' {\n                font-size: '+(0,_rem2.default)('36px')+';\n            }\n\n            .download-button {\n                top: '+(0,_rem2.default)('40px')+';\n            }\n          ';}));var ButtonContainer=exports.ButtonContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonContainer',componentId:'sc-1eqaurh-12'})(['position:absolute;left:256px;top:4px;']);

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var paymentMethodDescription=exports.paymentMethodDescription={DEBITO_EM_CONTA:'Débito em Conta',CARTAO_DE_CREDITO:'Cartão de Crédito',money:'Dinheiro',BOLETO:'Boleto',partner:'Parceiros'/**
 * Return Payment Method based on status
 * @param {*} method
 */};var formatMethod=exports.formatMethod=function formatMethod(status,method){switch(status){case'PENDENTE':return'Aguardando pagamento';case'ATRASO':return'Regularize sua situação';case'COMPENSADO':return paymentMethodDescription[method];default:return'Em aberto';}};

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/IdentifiersList/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _gridStyled=__webpack_require__(8);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _DropdownList=__webpack_require__(264);var _DropdownList2=_interopRequireDefault(_DropdownList);var _Dropdown=__webpack_require__(2010);var _Dropdown2=_interopRequireDefault(_Dropdown);var _DotButton=__webpack_require__(253);var _DotButton2=_interopRequireDefault(_DotButton);var _IdentifiersListItem=__webpack_require__(2012);var _IdentifiersListItem2=_interopRequireDefault(_IdentifiersListItem);var _styles=__webpack_require__(2016);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Components
// import Checkbox from 'app/elements/Checkbox'
// Styles
var IdentifiersList=function(_Component){_inherits(IdentifiersList,_Component);function IdentifiersList(props){_classCallCheck(this,IdentifiersList);var _this=_possibleConstructorReturn(this,(IdentifiersList.__proto__||Object.getPrototypeOf(IdentifiersList)).call(this,props));_this.componentDidUpdate=function(prevProps,prevState){var identifiers=_this.props.identifiers;if(prevProps.identifiers!==identifiers&&identifiers.length>0){_this.setState({identificadores:_this.props.identifiers});}};_this.handleDropdown=function(){_this.setState({isDropdownOpen:!_this.state.isDropdownOpen});};_this.handleItemDropdown=function(itemDropdownId){return function(){if(itemDropdownId){return _this.setState({isItemDropdownOpen:true,itemDropdownId:itemDropdownId});}_this.setState({isItemDropdownOpen:false,itemDropdownId:null});};};_this.handleSelectOption=function(selectedOption){_this.setState({selectedOption:selectedOption,isDropdownOpen:false});};_this.changeTagIdentifiers=function(identifier){var identifiers=_this.state.identificadores.map(function(item){return item.codIdentificador===identifier.codIdentificadore?identifier:item;});_this.setState({identificadores:identifiers});};_this.state={isItemDropdownOpen:null,itemDropdownId:null,isDropdownOpen:false,veloeTagsOptions:['Ativa','Bloqueada'],selectedOption:'Ativa',identificadores:props.identifiers||[]};window.onscroll=function(){if(document.getElementById('footer')&&window.innerHeight+document.documentElement.scrollTop+document.getElementById('footer').offsetHeight>=document.documentElement.offsetHeight){props.handleLoadMoreItems();}};return _this;}_createClass(IdentifiersList,[{key:'componentDidMount',value:function componentDidMount(){this.setState({identificadores:this.props.identifiers});}},{key:'render',value:function render(){var _this2=this;var _props=this.props,checkboxValues=_props.checkboxValues,handleSelectItem=_props.handleSelectItem,handleCreateInf=_props.handleCreateInf,isPartner=_props.isPartner,idConta=_props.idConta;var _state=this.state,isDropdownOpen=_state.isDropdownOpen,veloeTagsOptions=_state.veloeTagsOptions,selectedOption=_state.selectedOption,identificadores=_state.identificadores;var itemStatus=selectedOption==='Bloqueada'?'INATIVO':'ATIVO';// const isAllChecked = checkboxValues.length === identifiers.length
var identifiersFiltered=identificadores.filter(function(_ref){var situacao=_ref.situacao;return situacao===itemStatus;});return identifiersFiltered&&_react2.default.createElement(_styles.ListContainer,{__source:{fileName:_jsxFileName,lineNumber:104}},_react2.default.createElement(_styles.ListItem,{__source:{fileName:_jsxFileName,lineNumber:105}},_react2.default.createElement(_gridStyled.Flex,{width:1,direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:106}},_react2.default.createElement(_gridStyled.Box,{width:[3/12,2/12],__source:{fileName:_jsxFileName,lineNumber:110}},'ve\xEDculo'),_react2.default.createElement(_gridStyled.Box,{width:[3/12,2/12],__source:{fileName:_jsxFileName,lineNumber:111}},'placa'),_react2.default.createElement(_Hide2.default,{at:'small',width:[1,2/12],__source:{fileName:_jsxFileName,lineNumber:112}},'eixos'),_react2.default.createElement(_styles.DropdownBox,{width:[3/12,2/12],__source:{fileName:_jsxFileName,lineNumber:115}},_react2.default.createElement(_Dropdown2.default,{isOpen:isDropdownOpen,categoryLabel:'VeloeTag',dropdownLabel:selectedOption,onClick:this.handleDropdown,__source:{fileName:_jsxFileName,lineNumber:116}}),_react2.default.createElement(_DropdownList2.default,{optionSelected:selectedOption,options:veloeTagsOptions,isOpen:isDropdownOpen,onClose:this.handleDropdown,onSelect:this.handleSelectOption,__source:{fileName:_jsxFileName,lineNumber:122}})),_react2.default.createElement(_gridStyled.Box,{width:[3/12,3/12],__source:{fileName:_jsxFileName,lineNumber:130}},'Informa\xE7\xF5es gerenciais'),isPartner&&_react2.default.createElement(_gridStyled.Box,{width:[3/12,2/12],__source:{fileName:_jsxFileName,lineNumber:131}},'Ponto a Ponto'),_react2.default.createElement(_gridStyled.Box,{width:[1,0.5/12],__source:{fileName:_jsxFileName,lineNumber:132}},_react2.default.createElement(_DotButton2.default,{color:_colors.blueGray,removeCursor:true,__source:{fileName:_jsxFileName,lineNumber:133}})))),identifiersFiltered.map(function(vehicle,index){return _react2.default.createElement(_IdentifiersListItem2.default,{checkboxValues:checkboxValues,vehicle:vehicle,handleSelectItem:handleSelectItem,key:index,handleCreateInf:handleCreateInf,itemDropdownId:_this2.state.itemDropdownId,isItemDropdownOpen:_this2.state.isItemDropdownOpen,handleItemDropdown:_this2.handleItemDropdown,itemStatus:itemStatus,isPartner:isPartner,changeTagIdentifiers:_this2.changeTagIdentifiers,idConta:idConta,__source:{fileName:_jsxFileName,lineNumber:138}});}));}}]);return IdentifiersList;}(_react.Component);IdentifiersList.propTypes={identifiers:_propTypes.array.isRequired,checkboxValues:_propTypes.array.isRequired,handleSelectItem:_propTypes.func.isRequired,handleSelectAll:_propTypes.func.isRequired,handleLoadMoreItems:_propTypes.func.isRequired};IdentifiersList.defaultProps={identifiers:[],checkboxValues:[],handleSelectItem:function handleSelectItem(){},handleSelectAll:function handleSelectAll(){},handleIncreaseList:function handleIncreaseList(){}};exports.default=IdentifiersList;module.exports=exports['default'];

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ToggleSwitch/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(2013);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var ToggleSwitch=function ToggleSwitch(_ref){var checked=_ref.checked,label=_ref.label,name=_ref.name,togglePap=_ref.togglePap,props=_objectWithoutProperties(_ref,['checked','label','name','togglePap']);var inputProps=props.input;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:7}},_react2.default.createElement(_styles.SwitchContainer,{__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement(_styles.Input,_extends({},inputProps,props,{onChange:function onChange(){return togglePap(!checked);},checked:checked,type:'checkbox',name:name,__source:{fileName:_jsxFileName,lineNumber:10}})),_react2.default.createElement(_styles.Slider,{className:'slider round',__source:{fileName:_jsxFileName,lineNumber:18}}))),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:21}},label));};exports.default=ToggleSwitch;module.exports=exports['default'];

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonIcon=exports.IdentifiersCardLabel=exports.IdentifiersCardWrapper=exports.CardAndIconWrap=exports.HeadingContent=exports.iconColor=exports.SubHeader=exports.LoadingText=exports.LoadingContainer=exports.SearchBox=exports.BoxHeader=exports.WrapperButtons=exports.Heading=exports.Paragraph=exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n      margin: ',' auto;\n  '],['\n      margin: ',' auto;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    width: ',';\n    margin: 0;\n  '],['\n    width: ',';\n    margin: 0;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    ','\n    margin: ',' 0;\n  '],['\n    ','\n    margin: ',' 0;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-o165sq-0'})(['',';margin:',' auto;',';'],_content2.default,(0,_rem2.default)('42px'),_media2.default.small(_templateObject,(0,_rem2.default)('29px')));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-o165sq-1'})(['',' color:',';width:',';margin-top:',';',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('270px'),(0,_rem2.default)('7px'),_media2.default.large(_templateObject2,(0,_rem2.default)('313px')));var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-o165sq-2'})(['',' color:',';font-size:48px;font-weight:bold;line-height:1.08;letter-spacing:normal;margin:0 0 ',';',';'],_types.title24Galano,_colors.darkSlateBlue,(0,_rem2.default)('10px'),_media2.default.small(_templateObject3,_types.title18Galano,(0,_rem2.default)('8px')));var WrapperButtons=exports.WrapperButtons=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButtons',componentId:'sc-o165sq-3'})(['display:flex;justify-content:space-between;min-width:400px;& > div{margin:0 15px;}']);var BoxHeader=exports.BoxHeader=_styledComponents2.default.div.withConfig({displayName:'styles__BoxHeader',componentId:'sc-o165sq-4'})(['display:flex;justify-content:space-between;margin-bottom:40px;']);var SearchBox=exports.SearchBox=_styledComponents2.default.div.withConfig({displayName:'styles__SearchBox',componentId:'sc-o165sq-5'})(['display:flex;justify-content:flex-end;margin-bottom:',';flex:1;flex-direction:column;align-items:flex-end;'],(0,_rem2.default)('20px'));var spin=(0,_styledComponents.keyframes)(['from{transform:rotate(0deg);}to{transform:rotate(360deg);}']);var LoadingContainer=exports.LoadingContainer=_styledComponents2.default.div.withConfig({displayName:'styles__LoadingContainer',componentId:'sc-o165sq-6'})(['margin-top:',';display:flex;align-items:center;justify-content:center;svg{animation:',' 1s linear infinite;}'],(0,_rem2.default)('20px'),spin);var LoadingText=exports.LoadingText=_styledComponents2.default.span.withConfig({displayName:'styles__LoadingText',componentId:'sc-o165sq-7'})(['margin-left:',';',';color:',';'],(0,_rem2.default)('10px'),_types.txt14OpenSans,_colors.darkGrey);var SubHeader=exports.SubHeader=_styledComponents2.default.div.withConfig({displayName:'styles__SubHeader',componentId:'sc-o165sq-8'})(['display:flex;flex-direction:row;']);var iconColor=exports.iconColor='fill: '+_colors.linkNavyBlue;var HeadingContent=exports.HeadingContent=_styledComponents2.default.div.withConfig({displayName:'styles__HeadingContent',componentId:'sc-o165sq-9'})(['display:flex;flex-direction:column;flex:1;']);var CardAndIconWrap=exports.CardAndIconWrap=_styledComponents2.default.div.withConfig({displayName:'styles__CardAndIconWrap',componentId:'sc-o165sq-10'})(['display:flex;flex-direction:row;align-items:flex-end;margin-bottom:20px;']);var IdentifiersCardWrapper=exports.IdentifiersCardWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__IdentifiersCardWrapper',componentId:'sc-o165sq-11'})(['width:264px;height:96px;display:flex;border:2px solid #e2e1eb;border-radius:8px;margin-right:20px;padding:16px;justify-content:space-between;span{',';font-size:32px;color:',';line-height:31px;margin-bottom:8px;}p{',';color:',';margin:0;}img{}'],_types.title32GalanoBold,_colors.darkSlateBlue,_types.txt14OpenSans,_colors.darkSlateBlue);var IdentifiersCardLabel=exports.IdentifiersCardLabel=_styledComponents2.default.div.withConfig({displayName:'styles__IdentifiersCardLabel',componentId:'sc-o165sq-12'})(['display:flex;flex-direction:column;']);var ButtonIcon=exports.ButtonIcon=_styledComponents2.default.a.withConfig({displayName:'styles__ButtonIcon',componentId:'sc-o165sq-13'})(['display:inline-block;width:',';height:',';cursor:pointer;img{width:100%;height:auto;}'],(0,_rem2.default)('31px'),(0,_rem2.default)('31px'));

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-loading.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IcLoading=function IcLoading(props){return _react2.default.createElement("svg",_extends({width:24,height:24},props,{__source:{fileName:_jsxFileName,lineNumber:4}}),_react2.default.createElement("g",{fill:"none",fillRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{fill:"#2A2264",d:"M20.167 13.082a.604.604 0 0 1-.55-.588v-1.16c0-.301.248-.566.55-.588l3.282-.241a.504.504 0 0 1 .551.507v1.804c0 .3-.247.53-.55.507l-3.283-.241z",__source:{fileName:_jsxFileName,lineNumber:6}}),_react2.default.createElement("path",{fill:"#C5C3D8",d:"M10.824 20.022a.603.603 0 0 1 .592-.546h1.168c.303 0 .57.246.592.546l.243 3.259a.504.504 0 0 1-.51.547h-1.817a.504.504 0 0 1-.511-.547l.243-3.259zm-5.43-3.2a.608.608 0 0 1 .808.03l.823.819c.216.213.23.574.032.802l-2.15 2.475a.509.509 0 0 1-.751.027L2.871 19.7a.5.5 0 0 1 .03-.745l2.493-2.133zm-1.561-6.076c.302.022.55.287.55.588v1.16a.603.603 0 0 1-.55.587l-3.282.242A.504.504 0 0 1 0 12.816v-1.804c0-.301.247-.53.55-.508l3.283.242zm3.224-5.392a.598.598 0 0 1-.03.803l-.827.819a.608.608 0 0 1-.808.03L2.901 4.872a.5.5 0 0 1-.028-.745l1.285-1.275c.214-.213.55-.2.75.028l2.149 2.474z",__source:{fileName:_jsxFileName,lineNumber:10}}),_react2.default.createElement("path",{fill:"#2A2264",d:"M13.176 3.805a.603.603 0 0 1-.592.547h-1.168a.603.603 0 0 1-.592-.547L10.581.547A.504.504 0 0 1 11.09 0h1.817c.304 0 .534.246.511.547l-.243 3.258zm5.598 3.601a.609.609 0 0 1-.809-.03l-.825-.82a.6.6 0 0 1-.031-.802l2.15-2.475a.509.509 0 0 1 .75-.027l1.285 1.275a.5.5 0 0 1-.027.745l-2.493 2.134z",__source:{fileName:_jsxFileName,lineNumber:14}}),_react2.default.createElement("path",{fill:"#C5C3D8",d:"M17.11 18.074a.598.598 0 0 1 .03-.803l.825-.819a.608.608 0 0 1 .809-.03l2.493 2.134a.5.5 0 0 1 .027.745l-1.284 1.275a.51.51 0 0 1-.751-.027l-2.148-2.475z",__source:{fileName:_jsxFileName,lineNumber:18}})));};exports.default=IcLoading;module.exports=exports["default"];

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(237);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(109);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(97);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FormField=exports.CardFlagItem=exports.CardFlagList=exports.SelectCreditCardWrapper=exports.CardSubtitle=exports.CardTitle=exports.ItemDescription=exports.Item=exports.Separator=exports.Buttons=exports.Legend=exports.Subtitle=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ','\n\n    '],['\n        ','\n\n    ']),_templateObject2=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  '],['\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-1cka96u-0'})(['',' color:',';margin:',' 0 ',' 0;',';'],_types.title32GalanoBold,_colors.linkNavyBlue,(0,_rem2.default)('40px'),(0,_rem2.default)('30px'),_media2.default.large(_templateObject,_types.title32GalanoBold));var Subtitle=exports.Subtitle=_styledComponents2.default.div.withConfig({displayName:'styles__Subtitle',componentId:'sc-1cka96u-1'})(['color:',';',' font-weight:bold;margin:12px 0 36px 0;'],_colors.darkBlue,_types.title26GalanoBold);var Legend=exports.Legend=_styledComponents2.default.div.withConfig({displayName:'styles__Legend',componentId:'sc-1cka96u-2'})(['color:',';',';letter-spacing:normal;margin-top:62px;'],_colors.darkBlue,_types.txt14OpenSans);var Buttons=exports.Buttons=_styledComponents2.default.div.withConfig({displayName:'styles__Buttons',componentId:'sc-1cka96u-3'})(['display:flex;flex-direction:column;margin-top:',';margin-left:',';',';'],(0,_rem2.default)('88px'),(0,_rem2.default)('130px'),_media2.default.large(_templateObject2));var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'styles__Separator',componentId:'sc-1cka96u-4'})(['border:1px solid ',';margin-left:-20px;width:calc(100% + 36px);'],_colors.paleGrayTwo);var Item=exports.Item=_styledComponents2.default.div.withConfig({displayName:'styles__Item',componentId:'sc-1cka96u-5'})(['display:flex;flex-direction:row;width:223px;cursor:pointer;align-items:center;box-shadow:0 12px 27px 0 rgba(221,231,243,0.66);']);var ItemDescription=exports.ItemDescription=_styledComponents2.default.div.withConfig({displayName:'styles__ItemDescription',componentId:'sc-1cka96u-6'})(['flex-direction:column;flex:0.85;padding:22px 14px;']);var CardTitle=exports.CardTitle=_styledComponents2.default.div.withConfig({displayName:'styles__CardTitle',componentId:'sc-1cka96u-7'})(['',';font-weight:500;color:#14110c;'],_types.title16Galano);var CardSubtitle=exports.CardSubtitle=_styledComponents2.default.div.withConfig({displayName:'styles__CardSubtitle',componentId:'sc-1cka96u-8'})(['',';color:#656769;'],_types.txt12OpenSans);var SelectCreditCardWrapper=exports.SelectCreditCardWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__SelectCreditCardWrapper',componentId:'sc-1cka96u-9'})(['display:flex;justify-content:space-between;']);var CardFlagList=exports.CardFlagList=_styledComponents2.default.div.withConfig({displayName:'styles__CardFlagList',componentId:'sc-1cka96u-10'})(['padding:8px 0 0 12px;']);var CardFlagItem=exports.CardFlagItem=_styledComponents2.default.span.withConfig({displayName:'styles__CardFlagItem',componentId:'sc-1cka96u-11'})(['',';margin-right:8px;'],function(props){return props.hideCard?'display: none':'display: inline';});var FormField=exports.FormField=_styledComponents2.default.fieldset.withConfig({displayName:'styles__FormField',componentId:'sc-1cka96u-12'})(['border:0;padding:0;margin:0;min-width:0;',';'],function(_ref){var disabled=_ref.disabled;return disabled&&'\n  opacity: 0.4;\n  cursor: not-allowed\n  ';});

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/FirstAccessFollowRequest/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _IdentifiersRequestStatus=__webpack_require__(661);var _IdentifiersRequestStatus2=_interopRequireDefault(_IdentifiersRequestStatus);var _OrdersRequestList=__webpack_require__(2164);var _OrdersRequestList2=_interopRequireDefault(_OrdersRequestList);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _arrowRight=__webpack_require__(662);var _arrowRight2=_interopRequireDefault(_arrowRight);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _actions=__webpack_require__(36);var _fetchOrders=__webpack_require__(2175);var _fetchOrders2=_interopRequireDefault(_fetchOrders);var _PageLoader=__webpack_require__(88);var _PageLoader2=_interopRequireDefault(_PageLoader);var _RoundedSearchForm=__webpack_require__(2176);var _RoundedSearchForm2=_interopRequireDefault(_RoundedSearchForm);var _styles=__webpack_require__(2178);var _data=__webpack_require__(2179);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var FirstAccessFollowRequest=function(_React$Component){_inherits(FirstAccessFollowRequest,_React$Component);function FirstAccessFollowRequest(props){_classCallCheck(this,FirstAccessFollowRequest);var _this=_possibleConstructorReturn(this,(FirstAccessFollowRequest.__proto__||Object.getPrototypeOf(FirstAccessFollowRequest)).call(this,props));_this.state={orders:[],type:'pre'};return _this;}_createClass(FirstAccessFollowRequest,[{key:'componentWillMount',value:function componentWillMount(){var accPlans=this.props.accountPlans;var acc=accPlans&&accPlans.plans&&accPlans.plans.length>0?accPlans.plans.find(function(plan){return plan.accountId==accPlans.activePlanId;}):null;var type=acc&&acc.plan&&acc.plan.type?acc.plan.type:null;this.setState({type:type});}},{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var accountNumber,response;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.props.setLoading(true);accountNumber=this.props.match.params.id;_context.prev=2;_context.next=5;return(0,_fetchOrders2.default)(accountNumber,this.state.type);case 5:response=_context.sent;this.setState({orders:response});this.props.setLoading(false);_context.next=13;break;case 10:_context.prev=10;_context.t0=_context['catch'](2);console.log(_context.t0);case 13:case'end':return _context.stop();}}},_callee,this,[[2,10]]);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var orders=this.state.orders;var _props=this.props,activePlanId=_props.accountPlans.activePlanId,url=_props.match.url,history=_props.history,loading=_props.loading;var urlBack='/minha-veloe/'+activePlanId+'/identificadores';var urlIdentifierFollow=url==='/minha-veloe/'+activePlanId+'/identificadores/acompanhar-pedido';return _react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:60}},urlIdentifierFollow&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Voltar',url:urlBack,__source:{fileName:_jsxFileName,lineNumber:63}})),_react2.default.createElement(_PageLoader2.default,{__source:{fileName:_jsxFileName,lineNumber:66}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:67}},_react2.default.createElement(_styles.TitleContainer,{__source:{fileName:_jsxFileName,lineNumber:68}},_react2.default.createElement(_styles.TitleBox,{__source:{fileName:_jsxFileName,lineNumber:69}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:70}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:71}},_data.paragraph)),_react2.default.createElement(_styles.TitleBox,{alignSelf:'flex-end',margin:'0 0 20px 0',__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement(_RoundedSearchForm2.default,{placeholder:_data.searchPlaceholder,__source:{fileName:_jsxFileName,lineNumber:74}}))),_react2.default.createElement(_OrdersRequestList2.default,{orders:(0,_RoundedSearchForm.searchFilter)(this.props.searchValue,orders),history:history,accountId:this.props.match.params.id,type:this.state.type,__source:{fileName:_jsxFileName,lineNumber:78}}))));}}]);return FirstAccessFollowRequest;}(_react2.default.Component);var selector=(0,_reduxForm.formValueSelector)('searchOrders');var mapStateToProps=function mapStateToProps(state){return{accountPlans:state.reducer.accountPlans,loading:state.pageLoader.isLoading,searchValue:selector(state,'search')};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setLoading:function setLoading(isLoading){dispatch((0,_actions.setLoading)(isLoading));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(FirstAccessFollowRequest);module.exports=exports['default'];

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/IdentifiersRequestStatus/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Icon=__webpack_require__(31);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(2163);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IndentifiersRequestStatus=function IndentifiersRequestStatus(props){return _react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement(_styles.ItemContainer,{borderBlue:true,__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement(_styles.Item,{__source:{fileName:_jsxFileName,lineNumber:10}},_react2.default.createElement(_Icon.Icon,{icon:'checkStatus',width:'28',height:'28',viewBox:'0 0 28 28',__source:{fileName:_jsxFileName,lineNumber:11}})),_react2.default.createElement(_styles.Infos,{__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_styles.Description,{light:true,__source:{fileName:_jsxFileName,lineNumber:14}},props.payment.status),_react2.default.createElement(_styles.DateTicket,{__source:{fileName:_jsxFileName,lineNumber:15}},props.payment.date))),_react2.default.createElement(_styles.ItemContainer,{borderBlue:props.tracker[0].date!=='',__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement(_styles.Item,{__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_Icon.Icon,{icon:'truck',width:'35',height:'25',viewBox:'0 0 35 25',__source:{fileName:_jsxFileName,lineNumber:21}})),_react2.default.createElement(_styles.Infos,{__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(_styles.Description,{light:true,__source:{fileName:_jsxFileName,lineNumber:24}},props.tracker[0].status),_react2.default.createElement(_styles.DateTicket,{__source:{fileName:_jsxFileName,lineNumber:25}},props.tracker[0].date))),_react2.default.createElement(_styles.ItemContainer,{borderBlue:props.tracker[1].status==='EXTRAVIADO'||props.tracker[1].status==='DEVOLVIDO'||props.tracker[1].status==='CANCELADO',__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement(_styles.Item,{__source:{fileName:_jsxFileName,lineNumber:36}},_react2.default.createElement(_Icon.Icon,{icon:'packageDelivery',width:'30',height:'27',viewBox:'0 0 30 27',__source:{fileName:_jsxFileName,lineNumber:37}})),_react2.default.createElement(_styles.Infos,{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.Description,{light:true,__source:{fileName:_jsxFileName,lineNumber:40}},props.tracker[1].status.toLowerCase()),_react2.default.createElement(_styles.DateTicket,{__source:{fileName:_jsxFileName,lineNumber:41}},props.tracker[1].date))),_react2.default.createElement(_styles.ItemContainer,{__source:{fileName:_jsxFileName,lineNumber:44}},props.payment.status==='Pagamento Aprovado'||props.type==='pos'?_react2.default.createElement(_Button2.default,{text:'Ativar sua VeloeTag',onClick:function onClick(){return props.history.push('/identificadores/ativacao');},disabled:props.tracker[1].date===''||props.tracker[1].status==='EXTRAVIADO'||props.tracker[1].status==='DEVOLVIDO'||props.tracker[1].status==='CANCELADO',loading:false,__source:{fileName:_jsxFileName,lineNumber:46}}):_react2.default.createElement(_Button2.default,{text:'Efetuar Recarga',onClick:function onClick(){return props.history.push('/minha-veloe/'+props.accountId+'/editar-dados/cartao?path=track');},loading:false,__source:{fileName:_jsxFileName,lineNumber:58}})));};exports.default=IndentifiersRequestStatus;module.exports=exports['default'];

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/arrow-right.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ArrowRight=function ArrowRight(props){return _react2.default.createElement("svg",{width:props.width,height:props.height,viewBox:props.viewBox,__source:{fileName:_jsxFileName,lineNumber:4}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{id:"a",d:"M4.463 9.401l5.763-5.527a1.369 1.369 0 0 1 1.886.005c.52.504.517 1.318-.005 1.818l-6.704 6.429c-.52.499-1.36.499-1.88 0l-6.63-6.358a1.253 1.253 0 0 1-.005-1.818 1.369 1.369 0 0 1 1.886-.005L4.464 9.4z",__source:{fileName:_jsxFileName,lineNumber:5}})),_react2.default.createElement("use",{fill:"#292663",fillRule:"nonzero",transform:"matrix(0 1 1 0 .5 3.5)",xlinkHref:"#a",__source:{fileName:_jsxFileName,lineNumber:5}}));};exports.default=ArrowRight;module.exports=exports["default"];

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.WrapperHelpers=exports.ButtonAddress=exports.TextInfoLink=exports.WrapperInfoLink=exports.Ticket=exports.Wrapper=exports.Paragraph=exports.Title=exports.WrapperOrder=undefined;var _templateObject=_taggedTemplateLiteral(['\n    ','\n    letter-spacing: normal;\n    line-height: 1;\n  '],['\n    ','\n    letter-spacing: normal;\n    line-height: 1;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    ','\n    letter-spacing: normal;\n    line-height: 1.17;\n  '],['\n    ','\n    letter-spacing: normal;\n    line-height: 1.17;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _gridStyled=__webpack_require__(8);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var WrapperOrder=exports.WrapperOrder=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperOrder',componentId:'sc-1awhasb-0'})(['padding:20px 0 25px;:not(:last-child){box-shadow:0 1px 0 0 ',';}'],_colors.paleGray);var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-1awhasb-1'})(['',' letter-spacing:',';color:',';margin-top:',';',';'],_types.title40GalanoBold,(0,_em2.default)('0.4px'),_colors.darkSlateBlue,(0,_rem2.default)('40px'),_media2.default.small(_templateObject,_types.title28GalanoBold));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-1awhasb-2'})(['',' color:',';max-width:',';'],_types.txt14OpenSans,_colors.darkSlateBlue,(0,_rem2.default)('400px'));var Wrapper=exports.Wrapper=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'styles__Wrapper',componentId:'sc-1awhasb-3'})(['border-top:',' solid ',';'],(0,_rem2.default)('1px'),_colors.lightGray);var Ticket=exports.Ticket=_styledComponents2.default.h2.withConfig({displayName:'styles__Ticket',componentId:'sc-1awhasb-4'})(['',' letter-spacing:',';color:',';',';'],_types.title32GalanoBold,(0,_em2.default)('0.4px'),_colors.darkSlateBlue,_media2.default.small(_templateObject2,_types.title24GalanoBold));var WrapperInfoLink=exports.WrapperInfoLink=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperInfoLink',componentId:'sc-1awhasb-5'})(['display:flex;flex-direction:column;justify-content:space-beetween;']);var TextInfoLink=exports.TextInfoLink=_styledComponents2.default.span.withConfig({displayName:'styles__TextInfoLink',componentId:'sc-1awhasb-6'})(['color:',';',';line-height:1.22;letter-spacing:normal;text-align:left;'],_colors.darkSlateBlue,_types.title18Galano);var ButtonAddress=exports.ButtonAddress=_styledComponents2.default.a.withConfig({displayName:'styles__ButtonAddress',componentId:'sc-1awhasb-7'})(['color:',';cursor:pointer;',';display:inline-table;line-height:1.57;letter-spacing:normal;text-align:left;text-decoration:none;svg{margin-left:5px;}'],_colors.darkSlateBlue,_types.txt14OpenSans);var WrapperHelpers=exports.WrapperHelpers=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperHelpers',componentId:'sc-1awhasb-8'})(['display:flex;justify-content:space-between;']);

/***/ }),
/* 664 */
/***/ (function(module, exports) {

module.exports = {"title":"Rastrear Pedido","paragraph":"Acompanhe seu pedido por aqui ou no aplicativo. Sua entrega chega em até 7 dias úteis.","ticket":"Pedido nº","textNotArrived":"Seu pedido ainda não chegou?","textActivateTagHelper":"Já recebeu o pedido?","buttonActivateTagHelper":"Ative sua VeloeTag agora!","buttonNotArrived":"Calma que te ajudamos..."}

/***/ }),
/* 665 */
/***/ (function(module, exports) {

module.exports = {"labels":{"axis":"EIXOS","plate":"PLACA","identifier":"Nº DA VELOETAG","submitButton":"Ativar VeloeTag","addInformation":"Add informação"},"titleModal":"VeloeTag ativada com sucesso! Com restrição no cadastro","titleModalError":"Erro ao ativar sua VeloeTag","modalDescriptionError":"Por favor, tente novamente.","title":"Ativar VeloeTag","paragraph":"Informe o tipo do seu veículo e o número da VeloeTag que recebeu.","textInfo":"Tipo do veículo*","mandatoryInfo":"*Campo obrigatório"}

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-car.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IcCar=function IcCar(props){return _react2.default.createElement("svg",{width:"48",height:"48",viewBox:"0 0 48 48",__source:{fileName:_jsxFileName,lineNumber:4}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{id:"a",d:"M20.631 9.25h7.037a5.71 5.71 0 0 0-1.678-4.007 5.71 5.71 0 0 0-4.054-1.678H12.01c-.793 0-1.445.652-1.445 1.445v5.732c0 .792-.652 1.444-1.445 1.444H3.016v6.105c0 .792.652 1.445 1.444 1.445h.654c.587-1.7 2.211-2.936 4.1-2.936 1.872 0 3.484 1.215 4.084 2.893l11.763.039c.589-1.698 2.211-2.932 4.098-2.932 1.889 0 3.512 1.236 4.1 2.936h2.145v-6.152c0-.792-.653-1.444-1.445-1.444H19.55a1.426 1.426 0 0 1-.725 0h-3.972a1.452 1.452 0 0 1-1.444-1.445c0-.792.652-1.445 1.444-1.445h2.89V6.967c0-.792.652-1.445 1.444-1.445.793 0 1.445.653 1.445 1.445V9.25zM5.131 22.58h-.624A4.276 4.276 0 0 1 .219 18.29v-7.55c0-.791.653-1.444 1.445-1.444H7.77V5.01A4.276 4.276 0 0 1 12.056.722h9.927c4.737 0 8.549 3.843 8.574 8.528h3.402a4.276 4.276 0 0 1 4.288 4.288v7.596c0 .373-.14.746-.42 1.025-.28.326-.606.466-1.025.466l-3.563-.036c-.604 1.67-2.212 2.879-4.08 2.879-1.855 0-3.455-1.193-4.067-2.847l-11.797-.039c-.601 1.674-2.212 2.886-4.081 2.886-1.872 0-3.483-1.213-4.084-2.89zm24.028-2.936c-.792 0-1.491.652-1.491 1.491 0 .839.652 1.491 1.491 1.491.792 0 1.491-.652 1.491-1.491 0-.839-.699-1.491-1.49-1.491zm-19.945 0c-.793 0-1.492.652-1.492 1.491 0 .839.653 1.491 1.492 1.491.792 0 1.49-.652 1.49-1.491 0-.839-.698-1.491-1.49-1.491z",__source:{fileName:_jsxFileName,lineNumber:6}})),_react2.default.createElement("g",{fill:"none",fillRule:"evenodd",transform:"translate(5 12)",__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement("mask",{id:"b",fill:"#fff",__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement("use",{xlinkHref:"#a",__source:{fileName:_jsxFileName,lineNumber:10}})),_react2.default.createElement("use",{fill:"#2A2264",fillRule:"nonzero",xlinkHref:"#a",__source:{fileName:_jsxFileName,lineNumber:12}}),_react2.default.createElement("g",{mask:"url(#b)",__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement("path",{fill:"currentColor",d:"M-5-12h48v48H-5z",__source:{fileName:_jsxFileName,lineNumber:14}})),_react2.default.createElement("path",{d:"M-4.627-11.581h47.534v47.534H-4.627z",mask:"url(#b)",__source:{fileName:_jsxFileName,lineNumber:16}})));};exports.default=IcCar;module.exports=exports["default"];

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-utility.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IcUtility=function IcUtility(props){return _react2.default.createElement("svg",{width:"48",height:"48",viewBox:"0 0 48 48",__source:{fileName:_jsxFileName,lineNumber:4}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{id:"a1",d:"M17.429 2.833H4.259c-.782 0-1.42.64-1.42 1.422v13.162a1.42 1.42 0 0 0 1.42 1.416h.008l.563.003a4.315 4.315 0 0 1 4.068-2.887 4.314 4.314 0 0 1 4.076 2.914l11.687.024a4.315 4.315 0 0 1 4.085-2.938c1.89 0 3.5 1.223 4.078 2.918l2.122.013v-5.593a3.743 3.743 0 0 0-3.742-3.736H7.099a1.42 1.42 0 1 1 0-2.838h10.333a1.436 1.436 0 0 1-.003-.093V2.866v-.033zm2.839 0V6.62l-.003.093h6.85a5.25 5.25 0 0 0-1.437-2.287 5.89 5.89 0 0 0-4.056-1.593h-1.354zM4.833 21.674l-.577-.003A4.26 4.26 0 0 1 0 17.417V4.255A4.261 4.261 0 0 1 4.26 0h17.362c2.257 0 4.39.838 6.006 2.366 1.275 1.204 2.103 2.713 2.407 4.347h1.169c3.629 0 6.581 2.949 6.581 6.574v7.019c0 .38-.15.74-.418 1.004a1.408 1.408 0 0 1-1.002.417h-.008l-3.557-.022a4.314 4.314 0 0 1-4.054 2.85 4.314 4.314 0 0 1-4.047-2.83L12.953 21.7a4.313 4.313 0 0 1-4.055 2.855 4.314 4.314 0 0 1-4.065-2.882zm23.913-2.887c-.81 0-1.468.657-1.468 1.463a1.468 1.468 0 0 0 2.935 0c0-.806-.658-1.463-1.467-1.463zm-19.848 0c-.81 0-1.468.657-1.468 1.463a1.468 1.468 0 0 0 2.935 0c0-.806-.658-1.463-1.467-1.463z",__source:{fileName:_jsxFileName,lineNumber:6}})),_react2.default.createElement("g",{fill:"none",fillRule:"evenodd",transform:"translate(5 12)",__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement("mask",{id:"b1",fill:"#fff",__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement("use",{xlinkHref:"#a1",__source:{fileName:_jsxFileName,lineNumber:10}})),_react2.default.createElement("use",{fill:"#252853",xlinkHref:"#a1",__source:{fileName:_jsxFileName,lineNumber:12}}),_react2.default.createElement("g",{mask:"url(#b1)",__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement("path",{fill:"currentColor",d:"M-5-12h48v48H-5z",__source:{fileName:_jsxFileName,lineNumber:14}})),_react2.default.createElement("path",{d:"M-4.627-11.581h47.534v47.534H-4.627z",mask:"url(#b1)",__source:{fileName:_jsxFileName,lineNumber:16}})));};exports.default=IcUtility;module.exports=exports["default"];

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-truck.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IcTruck=function IcTruck(props){return _react2.default.createElement("svg",{width:"48",height:"48",viewBox:"0 0 48 48",__source:{fileName:_jsxFileName,lineNumber:4}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{id:"a2",d:"M7.444 24.956l-2.775-.007c-2.185 0-3.964-1.804-3.964-4.022V4.021C.705 1.804 2.484 0 4.673 0h14.924c2.19 0 3.968 1.804 3.968 4.021V5.34h5.618c3.718 0 6.741 3.064 6.741 6.829v11.49c0 .74-.592 1.341-1.321 1.341h-2.445c-.562 1.558-2.041 2.674-3.774 2.674-1.73 0-3.208-1.117-3.77-2.676l-9.604-.021c-.556 1.57-2.04 2.697-3.782 2.697-1.744 0-3.234-1.136-3.784-2.717zm-.006-2.68c.545-1.59 2.04-2.735 3.79-2.735 1.762 0 3.262 1.153 3.802 2.754l9.55.02c.534-1.61 2.038-2.774 3.804-2.774 1.77 0 3.276 1.165 3.81 2.777h1.083V14.4l-5.255-.04a1.333 1.333 0 0 1-1.313-1.35 1.33 1.33 0 0 1 1.334-1.33l5.21.04c-.221-2.077-1.961-3.699-4.07-3.699h-5.618v10.307c0 .74-.591 1.34-1.321 1.34-.734 0-1.326-.6-1.326-1.34V4.02c0-.739-.591-1.34-1.321-1.34H4.673c-.73 0-1.321.601-1.321 1.34v7.662l12.931.046c.793.005 1.43.61 1.426 1.35-.01.737-.652 1.33-1.44 1.33l-12.917-.046v6.564c0 .74.592 1.34 1.321 1.34l2.765.008zm20.946-.054c-.75 0-1.364.621-1.364 1.385s.613 1.385 1.364 1.385c.756 0 1.37-.622 1.37-1.385 0-.764-.614-1.385-1.37-1.385zm-17.156 0c-.751 0-1.364.621-1.364 1.385s.613 1.385 1.364 1.385c.756 0 1.37-.622 1.37-1.385 0-.764-.614-1.385-1.37-1.385z",__source:{fileName:_jsxFileName,lineNumber:6}})),_react2.default.createElement("g",{fill:"none",fillRule:"evenodd",transform:"translate(7 10)",__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement("mask",{id:"b2",fill:"#fff",__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement("use",{xlinkHref:"#a2",__source:{fileName:_jsxFileName,lineNumber:10}})),_react2.default.createElement("use",{fill:"#252853",xlinkHref:"#a2",__source:{fileName:_jsxFileName,lineNumber:12}}),_react2.default.createElement("g",{mask:"url(#b2)",__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement("path",{fill:"currentColor",d:"M-7-10h48v48H-7z",__source:{fileName:_jsxFileName,lineNumber:14}})),_react2.default.createElement("path",{d:"M-6.627-9.581h47.534v47.534H-6.627z",mask:"url(#b2)",__source:{fileName:_jsxFileName,lineNumber:16}})));};exports.default=IcTruck;module.exports=exports["default"];

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-bus.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IcBus=function IcBus(props){return _react2.default.createElement("svg",{width:"48",height:"48",viewBox:"0 0 48 48",__source:{fileName:_jsxFileName,lineNumber:4}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{id:"a3",d:"M25.268 14.838v3.875h5.206v-3.875h-5.206zm-2.84 0h-5.3v3.875h5.3v-3.875zm10.886 0v3.875h2.89a6.55 6.55 0 0 1 3.742 1.168v-1.307a3.743 3.743 0 0 0-3.742-3.736h-2.89zm-19.026 0H9.26c-.782 0-1.42.634-1.42 1.417v13.162c0 .782.638 1.421 1.42 1.421h.008l.562.003a4.314 4.314 0 0 1 4.069-2.892 4.314 4.314 0 0 1 4.076 2.914l11.688.024a4.314 4.314 0 0 1 4.084-2.938 4.314 4.314 0 0 1 4.077 2.918l2.123.013v-5.593a3.743 3.743 0 0 0-3.742-3.736H12.099a1.418 1.418 0 1 1 0-2.838h2.19v-3.875zM9.832 33.674l-.577-.003A4.258 4.258 0 0 1 5 29.417V16.255A4.261 4.261 0 0 1 9.26 12h26.944c3.629 0 6.581 2.95 6.581 6.574v13.732c0 .38-.15.74-.418 1.009a1.422 1.422 0 0 1-1.001.412h-.009l-3.557-.022a4.315 4.315 0 0 1-4.054 2.85 4.315 4.315 0 0 1-4.048-2.83L17.954 33.7a4.315 4.315 0 0 1-4.056 2.855 4.315 4.315 0 0 1-4.066-2.882zm23.914-2.887c-.81 0-1.468.657-1.468 1.468a1.467 1.467 0 0 0 2.935 0c0-.81-.658-1.468-1.467-1.468zm-19.848 0c-.81 0-1.468.657-1.468 1.468a1.467 1.467 0 0 0 2.935 0c0-.81-.658-1.468-1.467-1.468z",__source:{fileName:_jsxFileName,lineNumber:6}})),_react2.default.createElement("g",{fill:"none",fillRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement("mask",{id:"b3",fill:"#fff",__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement("use",{xlinkHref:"#a3",__source:{fileName:_jsxFileName,lineNumber:10}})),_react2.default.createElement("use",{fill:"#252853",xlinkHref:"#a3",__source:{fileName:_jsxFileName,lineNumber:12}}),_react2.default.createElement("g",{fill:"currentColor",mask:"url(#b3)",__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement("path",{d:"M0 0h48v48H0z",__source:{fileName:_jsxFileName,lineNumber:14}})),_react2.default.createElement("path",{d:"M.373.419h47.534v47.534H.373z",mask:"url(#b3)",__source:{fileName:_jsxFileName,lineNumber:16}})));};exports.default=IcBus;module.exports=exports["default"];

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.PeriodEndDateField=exports.PeriodInitDateField=exports.PlateField=exports.LocationField=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/CarPlateQuery/form-fields.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _renderInputs=__webpack_require__(44);var _reduxForm=__webpack_require__(11);var _data=__webpack_require__(268);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LocationField=function LocationField(_ref){var locations=_ref.locations;return _react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderSelectField,label:_data.labels.location,name:'location',options:locations,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:9}});};var PlateField=function PlateField(){return _react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.plate,name:'plate',type:'text',validate:_aleloLogic.utils.plateValidate,normalize:_aleloLogic.utils.plateMask,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:19}});};var PeriodInitDateField=function PeriodInitDateField(_ref2){var dateFormat=_ref2.dateFormat;return _react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.period,name:'periodInitDate',type:'text',validate:_aleloLogic.utils.dateValidateWithFormat(dateFormat),normalize:_aleloLogic.utils.dateMask,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:31}});};var PeriodEndDateField=function PeriodEndDateField(_ref3){var dateFormat=_ref3.dateFormat;return _react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.periodEnd,name:'periodEndDate',type:'text',validate:_aleloLogic.utils.dateValidateWithFormat(dateFormat),normalize:_aleloLogic.utils.dateMask,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:43}});};exports.LocationField=LocationField;exports.PlateField=PlateField;exports.PeriodInitDateField=PeriodInitDateField;exports.PeriodEndDateField=PeriodEndDateField;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BaseTableRowCell=exports.BaseTableRow=exports.BaseTableHeaderCell=exports.BaseTableHeader=exports.BaseTable=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var BaseTable=exports.BaseTable=_styledComponents2.default.div.withConfig({displayName:'Table__BaseTable',componentId:'sc-lotn5h-0'})(['display:flex;flex-direction:column;width:100%;']);var BaseTableHeader=exports.BaseTableHeader=_styledComponents2.default.div.withConfig({displayName:'Table__BaseTableHeader',componentId:'sc-lotn5h-1'})(['border-top:1px solid ',';border-bottom:1px solid ',';display:flex;flex-direction:row;width:100%;'],_colors.paleGrayTwo,_colors.paleGrayTwo);var BaseTableHeaderCell=exports.BaseTableHeaderCell=_styledComponents2.default.p.withConfig({displayName:'Table__BaseTableHeaderCell',componentId:'sc-lotn5h-2'})(['display:inline-block;margin:10px;overflow:hidden;',';'],function(_ref){var width=_ref.width;return'width: '+width+';';});var BaseTableRow=exports.BaseTableRow=_styledComponents2.default.div.withConfig({displayName:'Table__BaseTableRow',componentId:'sc-lotn5h-3'})(['display:flex;flex-direction:row;width:100%;']);var BaseTableRowCell=exports.BaseTableRowCell=_styledComponents2.default.p.withConfig({displayName:'Table__BaseTableRowCell',componentId:'sc-lotn5h-4'})(['display:inline-block;margin:10px;overflow:hidden;white-space:nowrap;',';'],function(_ref2){var width=_ref2.width;return'width: '+width+';';});

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SequentialField=exports.FileTypeField=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/RequestFile/form-fields.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _renderInputs=__webpack_require__(44);var _reduxForm=__webpack_require__(11);var _data=__webpack_require__(407);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FileTypeField=function FileTypeField(_ref){var fileTypes=_ref.fileTypes,saving=_ref.saving;return _react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderSelectField,label:_data.labels.fileType,name:'fileType',options:fileTypes,validate:_aleloLogic.utils.emptyFieldValidate,isRequired:true,disabled:saving,__source:{fileName:_jsxFileName,lineNumber:8}});};var SequentialField=function SequentialField(_ref2){var saving=_ref2.saving;return _react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.fileNumber,name:'sequential',type:'text',validate:_aleloLogic.utils.emptyFieldValidate,normalize:_aleloLogic.utils.numberMask,isRequired:true,disabled:saving,__source:{fileName:_jsxFileName,lineNumber:20}});};exports.FileTypeField=FileTypeField;exports.SequentialField=SequentialField;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-env node */


// SDP helpers.
var SDPUtils = {};

// Generate an alphanumeric identifier for cname or mids.
// TODO: use UUIDs instead? https://gist.github.com/jed/982883
SDPUtils.generateIdentifier = function() {
  return Math.random().toString(36).substr(2, 10);
};

// The RTCP CNAME used by all peerconnections from the same JS.
SDPUtils.localCName = SDPUtils.generateIdentifier();

// Splits SDP into lines, dealing with both CRLF and LF.
SDPUtils.splitLines = function(blob) {
  return blob.trim().split('\n').map(function(line) {
    return line.trim();
  });
};
// Splits SDP into sessionpart and mediasections. Ensures CRLF.
SDPUtils.splitSections = function(blob) {
  var parts = blob.split('\nm=');
  return parts.map(function(part, index) {
    return (index > 0 ? 'm=' + part : part).trim() + '\r\n';
  });
};

// returns the session description.
SDPUtils.getDescription = function(blob) {
  var sections = SDPUtils.splitSections(blob);
  return sections && sections[0];
};

// returns the individual media sections.
SDPUtils.getMediaSections = function(blob) {
  var sections = SDPUtils.splitSections(blob);
  sections.shift();
  return sections;
};

// Returns lines that start with a certain prefix.
SDPUtils.matchPrefix = function(blob, prefix) {
  return SDPUtils.splitLines(blob).filter(function(line) {
    return line.indexOf(prefix) === 0;
  });
};

// Parses an ICE candidate line. Sample input:
// candidate:702786350 2 udp 41819902 8.8.8.8 60769 typ relay raddr 8.8.8.8
// rport 55996"
SDPUtils.parseCandidate = function(line) {
  var parts;
  // Parse both variants.
  if (line.indexOf('a=candidate:') === 0) {
    parts = line.substring(12).split(' ');
  } else {
    parts = line.substring(10).split(' ');
  }

  var candidate = {
    foundation: parts[0],
    component: parseInt(parts[1], 10),
    protocol: parts[2].toLowerCase(),
    priority: parseInt(parts[3], 10),
    ip: parts[4],
    address: parts[4], // address is an alias for ip.
    port: parseInt(parts[5], 10),
    // skip parts[6] == 'typ'
    type: parts[7]
  };

  for (var i = 8; i < parts.length; i += 2) {
    switch (parts[i]) {
      case 'raddr':
        candidate.relatedAddress = parts[i + 1];
        break;
      case 'rport':
        candidate.relatedPort = parseInt(parts[i + 1], 10);
        break;
      case 'tcptype':
        candidate.tcpType = parts[i + 1];
        break;
      case 'ufrag':
        candidate.ufrag = parts[i + 1]; // for backward compability.
        candidate.usernameFragment = parts[i + 1];
        break;
      default: // extension handling, in particular ufrag
        candidate[parts[i]] = parts[i + 1];
        break;
    }
  }
  return candidate;
};

// Translates a candidate object into SDP candidate attribute.
SDPUtils.writeCandidate = function(candidate) {
  var sdp = [];
  sdp.push(candidate.foundation);
  sdp.push(candidate.component);
  sdp.push(candidate.protocol.toUpperCase());
  sdp.push(candidate.priority);
  sdp.push(candidate.address || candidate.ip);
  sdp.push(candidate.port);

  var type = candidate.type;
  sdp.push('typ');
  sdp.push(type);
  if (type !== 'host' && candidate.relatedAddress &&
      candidate.relatedPort) {
    sdp.push('raddr');
    sdp.push(candidate.relatedAddress);
    sdp.push('rport');
    sdp.push(candidate.relatedPort);
  }
  if (candidate.tcpType && candidate.protocol.toLowerCase() === 'tcp') {
    sdp.push('tcptype');
    sdp.push(candidate.tcpType);
  }
  if (candidate.usernameFragment || candidate.ufrag) {
    sdp.push('ufrag');
    sdp.push(candidate.usernameFragment || candidate.ufrag);
  }
  return 'candidate:' + sdp.join(' ');
};

// Parses an ice-options line, returns an array of option tags.
// a=ice-options:foo bar
SDPUtils.parseIceOptions = function(line) {
  return line.substr(14).split(' ');
};

// Parses an rtpmap line, returns RTCRtpCoddecParameters. Sample input:
// a=rtpmap:111 opus/48000/2
SDPUtils.parseRtpMap = function(line) {
  var parts = line.substr(9).split(' ');
  var parsed = {
    payloadType: parseInt(parts.shift(), 10) // was: id
  };

  parts = parts[0].split('/');

  parsed.name = parts[0];
  parsed.clockRate = parseInt(parts[1], 10); // was: clockrate
  parsed.channels = parts.length === 3 ? parseInt(parts[2], 10) : 1;
  // legacy alias, got renamed back to channels in ORTC.
  parsed.numChannels = parsed.channels;
  return parsed;
};

// Generate an a=rtpmap line from RTCRtpCodecCapability or
// RTCRtpCodecParameters.
SDPUtils.writeRtpMap = function(codec) {
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  var channels = codec.channels || codec.numChannels || 1;
  return 'a=rtpmap:' + pt + ' ' + codec.name + '/' + codec.clockRate +
      (channels !== 1 ? '/' + channels : '') + '\r\n';
};

// Parses an a=extmap line (headerextension from RFC 5285). Sample input:
// a=extmap:2 urn:ietf:params:rtp-hdrext:toffset
// a=extmap:2/sendonly urn:ietf:params:rtp-hdrext:toffset
SDPUtils.parseExtmap = function(line) {
  var parts = line.substr(9).split(' ');
  return {
    id: parseInt(parts[0], 10),
    direction: parts[0].indexOf('/') > 0 ? parts[0].split('/')[1] : 'sendrecv',
    uri: parts[1]
  };
};

// Generates a=extmap line from RTCRtpHeaderExtensionParameters or
// RTCRtpHeaderExtension.
SDPUtils.writeExtmap = function(headerExtension) {
  return 'a=extmap:' + (headerExtension.id || headerExtension.preferredId) +
      (headerExtension.direction && headerExtension.direction !== 'sendrecv'
        ? '/' + headerExtension.direction
        : '') +
      ' ' + headerExtension.uri + '\r\n';
};

// Parses an ftmp line, returns dictionary. Sample input:
// a=fmtp:96 vbr=on;cng=on
// Also deals with vbr=on; cng=on
SDPUtils.parseFmtp = function(line) {
  var parsed = {};
  var kv;
  var parts = line.substr(line.indexOf(' ') + 1).split(';');
  for (var j = 0; j < parts.length; j++) {
    kv = parts[j].trim().split('=');
    parsed[kv[0].trim()] = kv[1];
  }
  return parsed;
};

// Generates an a=ftmp line from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeFmtp = function(codec) {
  var line = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.parameters && Object.keys(codec.parameters).length) {
    var params = [];
    Object.keys(codec.parameters).forEach(function(param) {
      if (codec.parameters[param]) {
        params.push(param + '=' + codec.parameters[param]);
      } else {
        params.push(param);
      }
    });
    line += 'a=fmtp:' + pt + ' ' + params.join(';') + '\r\n';
  }
  return line;
};

// Parses an rtcp-fb line, returns RTCPRtcpFeedback object. Sample input:
// a=rtcp-fb:98 nack rpsi
SDPUtils.parseRtcpFb = function(line) {
  var parts = line.substr(line.indexOf(' ') + 1).split(' ');
  return {
    type: parts.shift(),
    parameter: parts.join(' ')
  };
};
// Generate a=rtcp-fb lines from RTCRtpCodecCapability or RTCRtpCodecParameters.
SDPUtils.writeRtcpFb = function(codec) {
  var lines = '';
  var pt = codec.payloadType;
  if (codec.preferredPayloadType !== undefined) {
    pt = codec.preferredPayloadType;
  }
  if (codec.rtcpFeedback && codec.rtcpFeedback.length) {
    // FIXME: special handling for trr-int?
    codec.rtcpFeedback.forEach(function(fb) {
      lines += 'a=rtcp-fb:' + pt + ' ' + fb.type +
      (fb.parameter && fb.parameter.length ? ' ' + fb.parameter : '') +
          '\r\n';
    });
  }
  return lines;
};

// Parses an RFC 5576 ssrc media attribute. Sample input:
// a=ssrc:3735928559 cname:something
SDPUtils.parseSsrcMedia = function(line) {
  var sp = line.indexOf(' ');
  var parts = {
    ssrc: parseInt(line.substr(7, sp - 7), 10)
  };
  var colon = line.indexOf(':', sp);
  if (colon > -1) {
    parts.attribute = line.substr(sp + 1, colon - sp - 1);
    parts.value = line.substr(colon + 1);
  } else {
    parts.attribute = line.substr(sp + 1);
  }
  return parts;
};

SDPUtils.parseSsrcGroup = function(line) {
  var parts = line.substr(13).split(' ');
  return {
    semantics: parts.shift(),
    ssrcs: parts.map(function(ssrc) {
      return parseInt(ssrc, 10);
    })
  };
};

// Extracts the MID (RFC 5888) from a media section.
// returns the MID or undefined if no mid line was found.
SDPUtils.getMid = function(mediaSection) {
  var mid = SDPUtils.matchPrefix(mediaSection, 'a=mid:')[0];
  if (mid) {
    return mid.substr(6);
  }
};

SDPUtils.parseFingerprint = function(line) {
  var parts = line.substr(14).split(' ');
  return {
    algorithm: parts[0].toLowerCase(), // algorithm is case-sensitive in Edge.
    value: parts[1]
  };
};

// Extracts DTLS parameters from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the fingerprint line as input. See also getIceParameters.
SDPUtils.getDtlsParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=fingerprint:');
  // Note: a=setup line is ignored since we use the 'auto' role.
  // Note2: 'algorithm' is not case sensitive except in Edge.
  return {
    role: 'auto',
    fingerprints: lines.map(SDPUtils.parseFingerprint)
  };
};

// Serializes DTLS parameters to SDP.
SDPUtils.writeDtlsParameters = function(params, setupType) {
  var sdp = 'a=setup:' + setupType + '\r\n';
  params.fingerprints.forEach(function(fp) {
    sdp += 'a=fingerprint:' + fp.algorithm + ' ' + fp.value + '\r\n';
  });
  return sdp;
};

// Parses a=crypto lines into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#dictionary-rtcsrtpsdesparameters-members
SDPUtils.parseCryptoLine = function(line) {
  var parts = line.substr(9).split(' ');
  return {
    tag: parseInt(parts[0], 10),
    cryptoSuite: parts[1],
    keyParams: parts[2],
    sessionParams: parts.slice(3),
  };
};

SDPUtils.writeCryptoLine = function(parameters) {
  return 'a=crypto:' + parameters.tag + ' ' +
    parameters.cryptoSuite + ' ' +
    (typeof parameters.keyParams === 'object'
      ? SDPUtils.writeCryptoKeyParams(parameters.keyParams)
      : parameters.keyParams) +
    (parameters.sessionParams ? ' ' + parameters.sessionParams.join(' ') : '') +
    '\r\n';
};

// Parses the crypto key parameters into
//   https://rawgit.com/aboba/edgertc/master/msortc-rs4.html#rtcsrtpkeyparam*
SDPUtils.parseCryptoKeyParams = function(keyParams) {
  if (keyParams.indexOf('inline:') !== 0) {
    return null;
  }
  var parts = keyParams.substr(7).split('|');
  return {
    keyMethod: 'inline',
    keySalt: parts[0],
    lifeTime: parts[1],
    mkiValue: parts[2] ? parts[2].split(':')[0] : undefined,
    mkiLength: parts[2] ? parts[2].split(':')[1] : undefined,
  };
};

SDPUtils.writeCryptoKeyParams = function(keyParams) {
  return keyParams.keyMethod + ':'
    + keyParams.keySalt +
    (keyParams.lifeTime ? '|' + keyParams.lifeTime : '') +
    (keyParams.mkiValue && keyParams.mkiLength
      ? '|' + keyParams.mkiValue + ':' + keyParams.mkiLength
      : '');
};

// Extracts all SDES paramters.
SDPUtils.getCryptoParameters = function(mediaSection, sessionpart) {
  var lines = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=crypto:');
  return lines.map(SDPUtils.parseCryptoLine);
};

// Parses ICE information from SDP media section or sessionpart.
// FIXME: for consistency with other functions this should only
//   get the ice-ufrag and ice-pwd lines as input.
SDPUtils.getIceParameters = function(mediaSection, sessionpart) {
  var ufrag = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=ice-ufrag:')[0];
  var pwd = SDPUtils.matchPrefix(mediaSection + sessionpart,
    'a=ice-pwd:')[0];
  if (!(ufrag && pwd)) {
    return null;
  }
  return {
    usernameFragment: ufrag.substr(12),
    password: pwd.substr(10),
  };
};

// Serializes ICE parameters to SDP.
SDPUtils.writeIceParameters = function(params) {
  return 'a=ice-ufrag:' + params.usernameFragment + '\r\n' +
      'a=ice-pwd:' + params.password + '\r\n';
};

// Parses the SDP media section and returns RTCRtpParameters.
SDPUtils.parseRtpParameters = function(mediaSection) {
  var description = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: [],
    rtcp: []
  };
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  for (var i = 3; i < mline.length; i++) { // find all codecs from mline[3..]
    var pt = mline[i];
    var rtpmapline = SDPUtils.matchPrefix(
      mediaSection, 'a=rtpmap:' + pt + ' ')[0];
    if (rtpmapline) {
      var codec = SDPUtils.parseRtpMap(rtpmapline);
      var fmtps = SDPUtils.matchPrefix(
        mediaSection, 'a=fmtp:' + pt + ' ');
      // Only the first a=fmtp:<pt> is considered.
      codec.parameters = fmtps.length ? SDPUtils.parseFmtp(fmtps[0]) : {};
      codec.rtcpFeedback = SDPUtils.matchPrefix(
        mediaSection, 'a=rtcp-fb:' + pt + ' ')
        .map(SDPUtils.parseRtcpFb);
      description.codecs.push(codec);
      // parse FEC mechanisms from rtpmap lines.
      switch (codec.name.toUpperCase()) {
        case 'RED':
        case 'ULPFEC':
          description.fecMechanisms.push(codec.name.toUpperCase());
          break;
        default: // only RED and ULPFEC are recognized as FEC mechanisms.
          break;
      }
    }
  }
  SDPUtils.matchPrefix(mediaSection, 'a=extmap:').forEach(function(line) {
    description.headerExtensions.push(SDPUtils.parseExtmap(line));
  });
  // FIXME: parse rtcp.
  return description;
};

// Generates parts of the SDP media section describing the capabilities /
// parameters.
SDPUtils.writeRtpDescription = function(kind, caps) {
  var sdp = '';

  // Build the mline.
  sdp += 'm=' + kind + ' ';
  sdp += caps.codecs.length > 0 ? '9' : '0'; // reject if no codecs.
  sdp += ' UDP/TLS/RTP/SAVPF ';
  sdp += caps.codecs.map(function(codec) {
    if (codec.preferredPayloadType !== undefined) {
      return codec.preferredPayloadType;
    }
    return codec.payloadType;
  }).join(' ') + '\r\n';

  sdp += 'c=IN IP4 0.0.0.0\r\n';
  sdp += 'a=rtcp:9 IN IP4 0.0.0.0\r\n';

  // Add a=rtpmap lines for each codec. Also fmtp and rtcp-fb.
  caps.codecs.forEach(function(codec) {
    sdp += SDPUtils.writeRtpMap(codec);
    sdp += SDPUtils.writeFmtp(codec);
    sdp += SDPUtils.writeRtcpFb(codec);
  });
  var maxptime = 0;
  caps.codecs.forEach(function(codec) {
    if (codec.maxptime > maxptime) {
      maxptime = codec.maxptime;
    }
  });
  if (maxptime > 0) {
    sdp += 'a=maxptime:' + maxptime + '\r\n';
  }
  sdp += 'a=rtcp-mux\r\n';

  if (caps.headerExtensions) {
    caps.headerExtensions.forEach(function(extension) {
      sdp += SDPUtils.writeExtmap(extension);
    });
  }
  // FIXME: write fecMechanisms.
  return sdp;
};

// Parses the SDP media section and returns an array of
// RTCRtpEncodingParameters.
SDPUtils.parseRtpEncodingParameters = function(mediaSection) {
  var encodingParameters = [];
  var description = SDPUtils.parseRtpParameters(mediaSection);
  var hasRed = description.fecMechanisms.indexOf('RED') !== -1;
  var hasUlpfec = description.fecMechanisms.indexOf('ULPFEC') !== -1;

  // filter a=ssrc:... cname:, ignore PlanB-msid
  var ssrcs = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
    .map(function(line) {
      return SDPUtils.parseSsrcMedia(line);
    })
    .filter(function(parts) {
      return parts.attribute === 'cname';
    });
  var primarySsrc = ssrcs.length > 0 && ssrcs[0].ssrc;
  var secondarySsrc;

  var flows = SDPUtils.matchPrefix(mediaSection, 'a=ssrc-group:FID')
    .map(function(line) {
      var parts = line.substr(17).split(' ');
      return parts.map(function(part) {
        return parseInt(part, 10);
      });
    });
  if (flows.length > 0 && flows[0].length > 1 && flows[0][0] === primarySsrc) {
    secondarySsrc = flows[0][1];
  }

  description.codecs.forEach(function(codec) {
    if (codec.name.toUpperCase() === 'RTX' && codec.parameters.apt) {
      var encParam = {
        ssrc: primarySsrc,
        codecPayloadType: parseInt(codec.parameters.apt, 10)
      };
      if (primarySsrc && secondarySsrc) {
        encParam.rtx = {ssrc: secondarySsrc};
      }
      encodingParameters.push(encParam);
      if (hasRed) {
        encParam = JSON.parse(JSON.stringify(encParam));
        encParam.fec = {
          ssrc: primarySsrc,
          mechanism: hasUlpfec ? 'red+ulpfec' : 'red'
        };
        encodingParameters.push(encParam);
      }
    }
  });
  if (encodingParameters.length === 0 && primarySsrc) {
    encodingParameters.push({
      ssrc: primarySsrc
    });
  }

  // we support both b=AS and b=TIAS but interpret AS as TIAS.
  var bandwidth = SDPUtils.matchPrefix(mediaSection, 'b=');
  if (bandwidth.length) {
    if (bandwidth[0].indexOf('b=TIAS:') === 0) {
      bandwidth = parseInt(bandwidth[0].substr(7), 10);
    } else if (bandwidth[0].indexOf('b=AS:') === 0) {
      // use formula from JSEP to convert b=AS to TIAS value.
      bandwidth = parseInt(bandwidth[0].substr(5), 10) * 1000 * 0.95
          - (50 * 40 * 8);
    } else {
      bandwidth = undefined;
    }
    encodingParameters.forEach(function(params) {
      params.maxBitrate = bandwidth;
    });
  }
  return encodingParameters;
};

// parses http://draft.ortc.org/#rtcrtcpparameters*
SDPUtils.parseRtcpParameters = function(mediaSection) {
  var rtcpParameters = {};

  // Gets the first SSRC. Note tha with RTX there might be multiple
  // SSRCs.
  var remoteSsrc = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
    .map(function(line) {
      return SDPUtils.parseSsrcMedia(line);
    })
    .filter(function(obj) {
      return obj.attribute === 'cname';
    })[0];
  if (remoteSsrc) {
    rtcpParameters.cname = remoteSsrc.value;
    rtcpParameters.ssrc = remoteSsrc.ssrc;
  }

  // Edge uses the compound attribute instead of reducedSize
  // compound is !reducedSize
  var rsize = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-rsize');
  rtcpParameters.reducedSize = rsize.length > 0;
  rtcpParameters.compound = rsize.length === 0;

  // parses the rtcp-mux attrіbute.
  // Note that Edge does not support unmuxed RTCP.
  var mux = SDPUtils.matchPrefix(mediaSection, 'a=rtcp-mux');
  rtcpParameters.mux = mux.length > 0;

  return rtcpParameters;
};

// parses either a=msid: or a=ssrc:... msid lines and returns
// the id of the MediaStream and MediaStreamTrack.
SDPUtils.parseMsid = function(mediaSection) {
  var parts;
  var spec = SDPUtils.matchPrefix(mediaSection, 'a=msid:');
  if (spec.length === 1) {
    parts = spec[0].substr(7).split(' ');
    return {stream: parts[0], track: parts[1]};
  }
  var planB = SDPUtils.matchPrefix(mediaSection, 'a=ssrc:')
    .map(function(line) {
      return SDPUtils.parseSsrcMedia(line);
    })
    .filter(function(msidParts) {
      return msidParts.attribute === 'msid';
    });
  if (planB.length > 0) {
    parts = planB[0].value.split(' ');
    return {stream: parts[0], track: parts[1]};
  }
};

// SCTP
// parses draft-ietf-mmusic-sctp-sdp-26 first and falls back
// to draft-ietf-mmusic-sctp-sdp-05
SDPUtils.parseSctpDescription = function(mediaSection) {
  var mline = SDPUtils.parseMLine(mediaSection);
  var maxSizeLine = SDPUtils.matchPrefix(mediaSection, 'a=max-message-size:');
  var maxMessageSize;
  if (maxSizeLine.length > 0) {
    maxMessageSize = parseInt(maxSizeLine[0].substr(19), 10);
  }
  if (isNaN(maxMessageSize)) {
    maxMessageSize = 65536;
  }
  var sctpPort = SDPUtils.matchPrefix(mediaSection, 'a=sctp-port:');
  if (sctpPort.length > 0) {
    return {
      port: parseInt(sctpPort[0].substr(12), 10),
      protocol: mline.fmt,
      maxMessageSize: maxMessageSize
    };
  }
  var sctpMapLines = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:');
  if (sctpMapLines.length > 0) {
    var parts = SDPUtils.matchPrefix(mediaSection, 'a=sctpmap:')[0]
      .substr(10)
      .split(' ');
    return {
      port: parseInt(parts[0], 10),
      protocol: parts[1],
      maxMessageSize: maxMessageSize
    };
  }
};

// SCTP
// outputs the draft-ietf-mmusic-sctp-sdp-26 version that all browsers
// support by now receiving in this format, unless we originally parsed
// as the draft-ietf-mmusic-sctp-sdp-05 format (indicated by the m-line
// protocol of DTLS/SCTP -- without UDP/ or TCP/)
SDPUtils.writeSctpDescription = function(media, sctp) {
  var output = [];
  if (media.protocol !== 'DTLS/SCTP') {
    output = [
      'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.protocol + '\r\n',
      'c=IN IP4 0.0.0.0\r\n',
      'a=sctp-port:' + sctp.port + '\r\n'
    ];
  } else {
    output = [
      'm=' + media.kind + ' 9 ' + media.protocol + ' ' + sctp.port + '\r\n',
      'c=IN IP4 0.0.0.0\r\n',
      'a=sctpmap:' + sctp.port + ' ' + sctp.protocol + ' 65535\r\n'
    ];
  }
  if (sctp.maxMessageSize !== undefined) {
    output.push('a=max-message-size:' + sctp.maxMessageSize + '\r\n');
  }
  return output.join('');
};

// Generate a session ID for SDP.
// https://tools.ietf.org/html/draft-ietf-rtcweb-jsep-20#section-5.2.1
// recommends using a cryptographically random +ve 64-bit value
// but right now this should be acceptable and within the right range
SDPUtils.generateSessionId = function() {
  return Math.random().toString().substr(2, 21);
};

// Write boilder plate for start of SDP
// sessId argument is optional - if not supplied it will
// be generated randomly
// sessVersion is optional and defaults to 2
// sessUser is optional and defaults to 'thisisadapterortc'
SDPUtils.writeSessionBoilerplate = function(sessId, sessVer, sessUser) {
  var sessionId;
  var version = sessVer !== undefined ? sessVer : 2;
  if (sessId) {
    sessionId = sessId;
  } else {
    sessionId = SDPUtils.generateSessionId();
  }
  var user = sessUser || 'thisisadapterortc';
  // FIXME: sess-id should be an NTP timestamp.
  return 'v=0\r\n' +
      'o=' + user + ' ' + sessionId + ' ' + version +
        ' IN IP4 127.0.0.1\r\n' +
      's=-\r\n' +
      't=0 0\r\n';
};

SDPUtils.writeMediaSection = function(transceiver, caps, type, stream) {
  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);

  // Map ICE parameters (ufrag, pwd) to SDP.
  sdp += SDPUtils.writeIceParameters(
    transceiver.iceGatherer.getLocalParameters());

  // Map DTLS parameters to SDP.
  sdp += SDPUtils.writeDtlsParameters(
    transceiver.dtlsTransport.getLocalParameters(),
    type === 'offer' ? 'actpass' : 'active');

  sdp += 'a=mid:' + transceiver.mid + '\r\n';

  if (transceiver.direction) {
    sdp += 'a=' + transceiver.direction + '\r\n';
  } else if (transceiver.rtpSender && transceiver.rtpReceiver) {
    sdp += 'a=sendrecv\r\n';
  } else if (transceiver.rtpSender) {
    sdp += 'a=sendonly\r\n';
  } else if (transceiver.rtpReceiver) {
    sdp += 'a=recvonly\r\n';
  } else {
    sdp += 'a=inactive\r\n';
  }

  if (transceiver.rtpSender) {
    // spec.
    var msid = 'msid:' + stream.id + ' ' +
        transceiver.rtpSender.track.id + '\r\n';
    sdp += 'a=' + msid;

    // for Chrome.
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
        ' ' + msid;
    if (transceiver.sendEncodingParameters[0].rtx) {
      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
          ' ' + msid;
      sdp += 'a=ssrc-group:FID ' +
          transceiver.sendEncodingParameters[0].ssrc + ' ' +
          transceiver.sendEncodingParameters[0].rtx.ssrc +
          '\r\n';
    }
  }
  // FIXME: this should be written by writeRtpDescription.
  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
      ' cname:' + SDPUtils.localCName + '\r\n';
  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
        ' cname:' + SDPUtils.localCName + '\r\n';
  }
  return sdp;
};

// Gets the direction from the mediaSection or the sessionpart.
SDPUtils.getDirection = function(mediaSection, sessionpart) {
  // Look for sendrecv, sendonly, recvonly, inactive, default to sendrecv.
  var lines = SDPUtils.splitLines(mediaSection);
  for (var i = 0; i < lines.length; i++) {
    switch (lines[i]) {
      case 'a=sendrecv':
      case 'a=sendonly':
      case 'a=recvonly':
      case 'a=inactive':
        return lines[i].substr(2);
      default:
        // FIXME: What should happen here?
    }
  }
  if (sessionpart) {
    return SDPUtils.getDirection(sessionpart);
  }
  return 'sendrecv';
};

SDPUtils.getKind = function(mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var mline = lines[0].split(' ');
  return mline[0].substr(2);
};

SDPUtils.isRejected = function(mediaSection) {
  return mediaSection.split(' ', 2)[1] === '0';
};

SDPUtils.parseMLine = function(mediaSection) {
  var lines = SDPUtils.splitLines(mediaSection);
  var parts = lines[0].substr(2).split(' ');
  return {
    kind: parts[0],
    port: parseInt(parts[1], 10),
    protocol: parts[2],
    fmt: parts.slice(3).join(' ')
  };
};

SDPUtils.parseOLine = function(mediaSection) {
  var line = SDPUtils.matchPrefix(mediaSection, 'o=')[0];
  var parts = line.substr(2).split(' ');
  return {
    username: parts[0],
    sessionId: parts[1],
    sessionVersion: parseInt(parts[2], 10),
    netType: parts[3],
    addressType: parts[4],
    address: parts[5]
  };
};

// a very naive interpretation of a valid SDP.
SDPUtils.isValidSDP = function(blob) {
  if (typeof blob !== 'string' || blob.length === 0) {
    return false;
  }
  var lines = SDPUtils.splitLines(blob);
  for (var i = 0; i < lines.length; i++) {
    if (lines[i].length < 2 || lines[i].charAt(1) !== '=') {
      return false;
    }
    // TODO: check the modifier a bit more.
  }
  return true;
};

// Expose public methods.
if (true) {
  module.exports = SDPUtils;
}


/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = {"labels":{"axis":"EIXOS","plate":"PLACA","confirmPlate":"CONFIRMAR PLACA","identifier":"Nº DA VELOETAG","submitButton":"Ativar VeloeTag","addInformation":"Add informação"},"titleModal":"VeloeTag ativada com sucesso! Com restrição no cadastro","titleModalError":"Erro ao ativar sua VeloeTag","modalDescriptionError":"Por favor, tente novamente.","title":"Ativar VeloeTag","paragraph":"Informe o tipo do seu veículo e o número da VeloeTag que recebeu.","textInfo":"Tipo do veículo*","mandatoryInfo":"*Campo obrigatório"}

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(676);
module.exports = __webpack_require__(883);


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(677).enable()
  window.Promise = __webpack_require__(679)
}

// polyfill needed for some functions on Internet Explorer 10 and 11
__webpack_require__(680)

// fetch() polyfill for making API calls.
__webpack_require__(882)

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(34)


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(408);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._37 = null;
  Promise._87 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._37 = function (promise) {
    if (
      promise._65 === 2 && // IS REJECTED
      rejections[promise._51]
    ) {
      if (rejections[promise._51].logged) {
        onHandled(promise._51);
      } else {
        clearTimeout(rejections[promise._51].timeout);
      }
      delete rejections[promise._51];
    }
  };
  Promise._87 = function (promise, err) {
    if (promise._40 === 0) { // not yet handled
      promise._51 = id++;
      rejections[promise._51] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._51),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(408);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._65 = 1;
  p._55 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._65 === 3) {
            val = val._55;
          }
          if (val._65 === 1) return res(i, val._55);
          if (val._65 === 2) reject(val._55);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(681);

__webpack_require__(878);

__webpack_require__(879);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(682);
__webpack_require__(685);
__webpack_require__(686);
__webpack_require__(687);
__webpack_require__(688);
__webpack_require__(689);
__webpack_require__(690);
__webpack_require__(691);
__webpack_require__(692);
__webpack_require__(693);
__webpack_require__(694);
__webpack_require__(695);
__webpack_require__(696);
__webpack_require__(697);
__webpack_require__(698);
__webpack_require__(699);
__webpack_require__(700);
__webpack_require__(701);
__webpack_require__(702);
__webpack_require__(703);
__webpack_require__(704);
__webpack_require__(705);
__webpack_require__(706);
__webpack_require__(707);
__webpack_require__(708);
__webpack_require__(709);
__webpack_require__(710);
__webpack_require__(711);
__webpack_require__(712);
__webpack_require__(713);
__webpack_require__(714);
__webpack_require__(715);
__webpack_require__(716);
__webpack_require__(717);
__webpack_require__(718);
__webpack_require__(719);
__webpack_require__(720);
__webpack_require__(721);
__webpack_require__(722);
__webpack_require__(723);
__webpack_require__(724);
__webpack_require__(725);
__webpack_require__(726);
__webpack_require__(727);
__webpack_require__(728);
__webpack_require__(729);
__webpack_require__(730);
__webpack_require__(731);
__webpack_require__(732);
__webpack_require__(733);
__webpack_require__(734);
__webpack_require__(735);
__webpack_require__(736);
__webpack_require__(737);
__webpack_require__(738);
__webpack_require__(739);
__webpack_require__(740);
__webpack_require__(741);
__webpack_require__(742);
__webpack_require__(743);
__webpack_require__(744);
__webpack_require__(745);
__webpack_require__(746);
__webpack_require__(747);
__webpack_require__(748);
__webpack_require__(749);
__webpack_require__(750);
__webpack_require__(751);
__webpack_require__(752);
__webpack_require__(753);
__webpack_require__(754);
__webpack_require__(755);
__webpack_require__(756);
__webpack_require__(757);
__webpack_require__(758);
__webpack_require__(759);
__webpack_require__(760);
__webpack_require__(762);
__webpack_require__(763);
__webpack_require__(765);
__webpack_require__(766);
__webpack_require__(767);
__webpack_require__(768);
__webpack_require__(769);
__webpack_require__(770);
__webpack_require__(771);
__webpack_require__(773);
__webpack_require__(774);
__webpack_require__(775);
__webpack_require__(776);
__webpack_require__(777);
__webpack_require__(778);
__webpack_require__(779);
__webpack_require__(780);
__webpack_require__(781);
__webpack_require__(782);
__webpack_require__(783);
__webpack_require__(784);
__webpack_require__(785);
__webpack_require__(290);
__webpack_require__(786);
__webpack_require__(428);
__webpack_require__(787);
__webpack_require__(429);
__webpack_require__(788);
__webpack_require__(789);
__webpack_require__(790);
__webpack_require__(791);
__webpack_require__(792);
__webpack_require__(432);
__webpack_require__(434);
__webpack_require__(435);
__webpack_require__(793);
__webpack_require__(794);
__webpack_require__(795);
__webpack_require__(796);
__webpack_require__(797);
__webpack_require__(798);
__webpack_require__(799);
__webpack_require__(800);
__webpack_require__(801);
__webpack_require__(802);
__webpack_require__(803);
__webpack_require__(804);
__webpack_require__(805);
__webpack_require__(806);
__webpack_require__(807);
__webpack_require__(808);
__webpack_require__(809);
__webpack_require__(810);
__webpack_require__(811);
__webpack_require__(812);
__webpack_require__(813);
__webpack_require__(814);
__webpack_require__(815);
__webpack_require__(816);
__webpack_require__(817);
__webpack_require__(818);
__webpack_require__(819);
__webpack_require__(820);
__webpack_require__(821);
__webpack_require__(822);
__webpack_require__(823);
__webpack_require__(824);
__webpack_require__(825);
__webpack_require__(826);
__webpack_require__(827);
__webpack_require__(828);
__webpack_require__(829);
__webpack_require__(830);
__webpack_require__(831);
__webpack_require__(832);
__webpack_require__(833);
__webpack_require__(834);
__webpack_require__(835);
__webpack_require__(836);
__webpack_require__(837);
__webpack_require__(838);
__webpack_require__(839);
__webpack_require__(840);
__webpack_require__(841);
__webpack_require__(842);
__webpack_require__(843);
__webpack_require__(844);
__webpack_require__(845);
__webpack_require__(846);
__webpack_require__(847);
__webpack_require__(848);
__webpack_require__(849);
__webpack_require__(850);
__webpack_require__(851);
__webpack_require__(852);
__webpack_require__(853);
__webpack_require__(854);
__webpack_require__(855);
__webpack_require__(856);
__webpack_require__(857);
__webpack_require__(858);
__webpack_require__(859);
__webpack_require__(860);
__webpack_require__(861);
__webpack_require__(862);
__webpack_require__(863);
__webpack_require__(864);
__webpack_require__(865);
__webpack_require__(866);
__webpack_require__(867);
__webpack_require__(868);
__webpack_require__(869);
__webpack_require__(870);
__webpack_require__(871);
__webpack_require__(872);
__webpack_require__(873);
__webpack_require__(874);
__webpack_require__(875);
__webpack_require__(876);
__webpack_require__(877);
module.exports = __webpack_require__(68);


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(21);
var has = __webpack_require__(59);
var DESCRIPTORS = __webpack_require__(38);
var $export = __webpack_require__(5);
var redefine = __webpack_require__(56);
var META = __webpack_require__(106).KEY;
var $fails = __webpack_require__(24);
var shared = __webpack_require__(159);
var setToStringTag = __webpack_require__(139);
var uid = __webpack_require__(116);
var wks = __webpack_require__(33);
var wksExt = __webpack_require__(410);
var wksDefine = __webpack_require__(271);
var enumKeys = __webpack_require__(684);
var isArray = __webpack_require__(193);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(26);
var toObject = __webpack_require__(45);
var toIObject = __webpack_require__(60);
var toPrimitive = __webpack_require__(78);
var createDesc = __webpack_require__(115);
var _create = __webpack_require__(119);
var gOPNExt = __webpack_require__(413);
var $GOPD = __webpack_require__(61);
var $GOPS = __webpack_require__(192);
var $DP = __webpack_require__(40);
var $keys = __webpack_require__(117);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(120).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(161).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(105)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(55)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(159)('native-function-to-string', Function.toString);


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(117);
var gOPS = __webpack_require__(192);
var pIE = __webpack_require__(161);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(119) });


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(38), 'Object', { defineProperty: __webpack_require__(40).f });


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(38), 'Object', { defineProperties: __webpack_require__(412) });


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(60);
var $getOwnPropertyDescriptor = __webpack_require__(61).f;

__webpack_require__(80)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(45);
var $getPrototypeOf = __webpack_require__(62);

__webpack_require__(80)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(45);
var $keys = __webpack_require__(117);

__webpack_require__(80)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(80)('getOwnPropertyNames', function () {
  return __webpack_require__(413).f;
});


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(106).onFreeze;

__webpack_require__(80)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(106).onFreeze;

__webpack_require__(80)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(26);
var meta = __webpack_require__(106).onFreeze;

__webpack_require__(80)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(26);

__webpack_require__(80)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(26);

__webpack_require__(80)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(26);

__webpack_require__(80)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(5);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(414) });


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(5);
$export($export.S, 'Object', { is: __webpack_require__(415) });


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(5);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(275).set });


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(140);
var test = {};
test[__webpack_require__(33)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(56)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(5);

$export($export.P, 'Function', { bind: __webpack_require__(416) });


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(40).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(38) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(26);
var getPrototypeOf = __webpack_require__(62);
var HAS_INSTANCE = __webpack_require__(33)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(40).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseInt = __webpack_require__(418);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseFloat = __webpack_require__(419);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(21);
var has = __webpack_require__(59);
var cof = __webpack_require__(70);
var inheritIfRequired = __webpack_require__(277);
var toPrimitive = __webpack_require__(78);
var fails = __webpack_require__(24);
var gOPN = __webpack_require__(120).f;
var gOPD = __webpack_require__(61).f;
var dP = __webpack_require__(40).f;
var $trim = __webpack_require__(141).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(119)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(38) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(56)(global, NUMBER, $Number);
}


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toInteger = __webpack_require__(71);
var aNumberValue = __webpack_require__(420);
var repeat = __webpack_require__(278);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(24)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $fails = __webpack_require__(24);
var aNumberValue = __webpack_require__(420);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(5);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(5);
var _isFinite = __webpack_require__(21).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(5);

$export($export.S, 'Number', { isInteger: __webpack_require__(421) });


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(5);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(5);
var isInteger = __webpack_require__(421);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(5);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(5);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseFloat = __webpack_require__(419);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $parseInt = __webpack_require__(418);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(5);
var log1p = __webpack_require__(422);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(5);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(5);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(5);
var sign = __webpack_require__(279);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(5);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(5);
var $expm1 = __webpack_require__(280);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', { fround: __webpack_require__(423) });


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(5);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(5);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(24)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', { log1p: __webpack_require__(422) });


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', { sign: __webpack_require__(279) });


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(5);
var expm1 = __webpack_require__(280);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(24)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(5);
var expm1 = __webpack_require__(280);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var toAbsoluteIndex = __webpack_require__(118);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var toIObject = __webpack_require__(60);
var toLength = __webpack_require__(37);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(141)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(194)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(281)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $at = __webpack_require__(194)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(5);
var toLength = __webpack_require__(37);
var context = __webpack_require__(283);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(284)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(5);
var context = __webpack_require__(283);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(284)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(278)
});


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(5);
var toLength = __webpack_require__(37);
var context = __webpack_require__(283);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(284)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(57)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(57)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(57)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(57)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(57)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(57)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(57)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(57)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(57)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(57)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(57)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(57)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(57)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(5);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(78);

$export($export.P + $export.F * __webpack_require__(24)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(5);
var toISOString = __webpack_require__(761);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(24);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(56)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(33)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(55)(proto, TO_PRIMITIVE, __webpack_require__(764));


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(78);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(5);

$export($export.S, 'Array', { isArray: __webpack_require__(193) });


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(69);
var $export = __webpack_require__(5);
var toObject = __webpack_require__(45);
var call = __webpack_require__(424);
var isArrayIter = __webpack_require__(285);
var toLength = __webpack_require__(37);
var createProperty = __webpack_require__(286);
var getIterFn = __webpack_require__(287);

$export($export.S + $export.F * !__webpack_require__(196)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var createProperty = __webpack_require__(286);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(24)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(5);
var toIObject = __webpack_require__(60);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(160) != Object || !__webpack_require__(72)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var html = __webpack_require__(274);
var cof = __webpack_require__(70);
var toAbsoluteIndex = __webpack_require__(118);
var toLength = __webpack_require__(37);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(24)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var aFunction = __webpack_require__(52);
var toObject = __webpack_require__(45);
var fails = __webpack_require__(24);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(72)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $forEach = __webpack_require__(81)(0);
var STRICT = __webpack_require__(72)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(26);
var isArray = __webpack_require__(193);
var SPECIES = __webpack_require__(33)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $map = __webpack_require__(81)(1);

$export($export.P + $export.F * !__webpack_require__(72)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $filter = __webpack_require__(81)(2);

$export($export.P + $export.F * !__webpack_require__(72)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $some = __webpack_require__(81)(3);

$export($export.P + $export.F * !__webpack_require__(72)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $every = __webpack_require__(81)(4);

$export($export.P + $export.F * !__webpack_require__(72)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $reduce = __webpack_require__(425);

$export($export.P + $export.F * !__webpack_require__(72)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $reduce = __webpack_require__(425);

$export($export.P + $export.F * !__webpack_require__(72)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $indexOf = __webpack_require__(191)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(72)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toIObject = __webpack_require__(60);
var toInteger = __webpack_require__(71);
var toLength = __webpack_require__(37);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(72)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(5);

$export($export.P, 'Array', { copyWithin: __webpack_require__(426) });

__webpack_require__(107)('copyWithin');


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(5);

$export($export.P, 'Array', { fill: __webpack_require__(289) });

__webpack_require__(107)('fill');


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(5);
var $find = __webpack_require__(81)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(107)(KEY);


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(5);
var $find = __webpack_require__(81)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(107)(KEY);


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(121)('Array');


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(21);
var inheritIfRequired = __webpack_require__(277);
var dP = __webpack_require__(40).f;
var gOPN = __webpack_require__(120).f;
var isRegExp = __webpack_require__(195);
var $flags = __webpack_require__(162);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(38) && (!CORRECT_NEW || __webpack_require__(24)(function () {
  re2[__webpack_require__(33)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(56)(global, 'RegExp', $RegExp);
}

__webpack_require__(121)('RegExp');


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(429);
var anObject = __webpack_require__(16);
var $flags = __webpack_require__(162);
var DESCRIPTORS = __webpack_require__(38);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(56)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(24)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(16);
var toLength = __webpack_require__(37);
var advanceStringIndex = __webpack_require__(292);
var regExpExec = __webpack_require__(197);

// @@match logic
__webpack_require__(198)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(16);
var toObject = __webpack_require__(45);
var toLength = __webpack_require__(37);
var toInteger = __webpack_require__(71);
var advanceStringIndex = __webpack_require__(292);
var regExpExec = __webpack_require__(197);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(198)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(16);
var sameValue = __webpack_require__(415);
var regExpExec = __webpack_require__(197);

// @@search logic
__webpack_require__(198)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(195);
var anObject = __webpack_require__(16);
var speciesConstructor = __webpack_require__(163);
var advanceStringIndex = __webpack_require__(292);
var toLength = __webpack_require__(37);
var callRegExpExec = __webpack_require__(197);
var regexpExec = __webpack_require__(291);
var fails = __webpack_require__(24);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(198)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(105);
var global = __webpack_require__(21);
var ctx = __webpack_require__(69);
var classof = __webpack_require__(140);
var $export = __webpack_require__(5);
var isObject = __webpack_require__(26);
var aFunction = __webpack_require__(52);
var anInstance = __webpack_require__(122);
var forOf = __webpack_require__(123);
var speciesConstructor = __webpack_require__(163);
var task = __webpack_require__(293).set;
var microtask = __webpack_require__(294)();
var newPromiseCapabilityModule = __webpack_require__(295);
var perform = __webpack_require__(430);
var userAgent = __webpack_require__(199);
var promiseResolve = __webpack_require__(431);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(33)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(124)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(139)($Promise, PROMISE);
__webpack_require__(121)(PROMISE);
Wrapper = __webpack_require__(68)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(196)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(436);
var validate = __webpack_require__(125);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(200)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var $typed = __webpack_require__(201);
var buffer = __webpack_require__(296);
var anObject = __webpack_require__(16);
var toAbsoluteIndex = __webpack_require__(118);
var toLength = __webpack_require__(37);
var isObject = __webpack_require__(26);
var ArrayBuffer = __webpack_require__(21).ArrayBuffer;
var speciesConstructor = __webpack_require__(163);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(24)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(121)(ARRAY_BUFFER);


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
$export($export.G + $export.W + $export.F * !__webpack_require__(201).ABV, {
  DataView: __webpack_require__(296).DataView
});


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(89)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(5);
var aFunction = __webpack_require__(52);
var anObject = __webpack_require__(16);
var rApply = (__webpack_require__(21).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(24)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(5);
var create = __webpack_require__(119);
var aFunction = __webpack_require__(52);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(26);
var fails = __webpack_require__(24);
var bind = __webpack_require__(416);
var rConstruct = (__webpack_require__(21).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(40);
var $export = __webpack_require__(5);
var anObject = __webpack_require__(16);
var toPrimitive = __webpack_require__(78);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(24)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(5);
var gOPD = __webpack_require__(61).f;
var anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(5);
var anObject = __webpack_require__(16);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(282)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(61);
var getPrototypeOf = __webpack_require__(62);
var has = __webpack_require__(59);
var $export = __webpack_require__(5);
var isObject = __webpack_require__(26);
var anObject = __webpack_require__(16);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(61);
var $export = __webpack_require__(5);
var anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(5);
var getProto = __webpack_require__(62);
var anObject = __webpack_require__(16);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(5);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(5);
var anObject = __webpack_require__(16);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(5);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(438) });


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(5);
var anObject = __webpack_require__(16);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(40);
var gOPD = __webpack_require__(61);
var getPrototypeOf = __webpack_require__(62);
var has = __webpack_require__(59);
var $export = __webpack_require__(5);
var createDesc = __webpack_require__(115);
var anObject = __webpack_require__(16);
var isObject = __webpack_require__(26);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(5);
var setProto = __webpack_require__(275);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(5);
var $includes = __webpack_require__(191)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(107)('includes');


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(5);
var flattenIntoArray = __webpack_require__(439);
var toObject = __webpack_require__(45);
var toLength = __webpack_require__(37);
var aFunction = __webpack_require__(52);
var arraySpeciesCreate = __webpack_require__(288);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(107)('flatMap');


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(5);
var flattenIntoArray = __webpack_require__(439);
var toObject = __webpack_require__(45);
var toLength = __webpack_require__(37);
var toInteger = __webpack_require__(71);
var arraySpeciesCreate = __webpack_require__(288);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(107)('flatten');


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(5);
var $at = __webpack_require__(194)(true);
var $fails = __webpack_require__(24);

var FORCED = $fails(function () {
  return '𠮷'.at(0) !== '𠮷';
});

$export($export.P + $export.F * FORCED, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(5);
var $pad = __webpack_require__(440);
var userAgent = __webpack_require__(199);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(5);
var $pad = __webpack_require__(440);
var userAgent = __webpack_require__(199);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(141)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(141)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(5);
var defined = __webpack_require__(79);
var toLength = __webpack_require__(37);
var isRegExp = __webpack_require__(195);
var getFlags = __webpack_require__(162);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(282)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(271)('asyncIterator');


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(271)('observable');


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(5);
var ownKeys = __webpack_require__(438);
var toIObject = __webpack_require__(60);
var gOPD = __webpack_require__(61);
var createProperty = __webpack_require__(286);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $values = __webpack_require__(441)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(5);
var $entries = __webpack_require__(441)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(45);
var aFunction = __webpack_require__(52);
var $defineProperty = __webpack_require__(40);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(38) && $export($export.P + __webpack_require__(202), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(45);
var aFunction = __webpack_require__(52);
var $defineProperty = __webpack_require__(40);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(38) && $export($export.P + __webpack_require__(202), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(78);
var getPrototypeOf = __webpack_require__(62);
var getOwnPropertyDescriptor = __webpack_require__(61).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(38) && $export($export.P + __webpack_require__(202), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(5);
var toObject = __webpack_require__(45);
var toPrimitive = __webpack_require__(78);
var getPrototypeOf = __webpack_require__(62);
var getOwnPropertyDescriptor = __webpack_require__(61).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(38) && $export($export.P + __webpack_require__(202), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(5);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(442)('Map') });


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(5);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(442)('Set') });


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(203)('Map');


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(203)('Set');


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(203)('WeakMap');


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(203)('WeakSet');


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(204)('Map');


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(204)('Set');


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(204)('WeakMap');


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(204)('WeakSet');


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(5);

$export($export.G, { global: __webpack_require__(21) });


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(5);

$export($export.S, 'System', { global: __webpack_require__(21) });


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(5);
var cof = __webpack_require__(70);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);
var scale = __webpack_require__(444);
var fround = __webpack_require__(423);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(5);

$export($export.S, 'Math', { scale: __webpack_require__(444) });


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(5);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(5);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(5);
var core = __webpack_require__(68);
var global = __webpack_require__(21);
var speciesConstructor = __webpack_require__(163);
var promiseResolve = __webpack_require__(431);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(5);
var newPromiseCapability = __webpack_require__(295);
var perform = __webpack_require__(430);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(90);
var anObject = __webpack_require__(16);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(90);
var anObject = __webpack_require__(16);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(90);
var anObject = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(62);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(434);
var from = __webpack_require__(443);
var metadata = __webpack_require__(90);
var anObject = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(62);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(90);
var anObject = __webpack_require__(16);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(90);
var anObject = __webpack_require__(16);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(90);
var anObject = __webpack_require__(16);
var getPrototypeOf = __webpack_require__(62);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(90);
var anObject = __webpack_require__(16);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(90);
var anObject = __webpack_require__(16);
var aFunction = __webpack_require__(52);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(5);
var microtask = __webpack_require__(294)();
var process = __webpack_require__(21).process;
var isNode = __webpack_require__(70)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(5);
var global = __webpack_require__(21);
var core = __webpack_require__(68);
var microtask = __webpack_require__(294)();
var OBSERVABLE = __webpack_require__(33)('observable');
var aFunction = __webpack_require__(52);
var anObject = __webpack_require__(16);
var anInstance = __webpack_require__(122);
var redefineAll = __webpack_require__(124);
var hide = __webpack_require__(55);
var forOf = __webpack_require__(123);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(121)('Observable');


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(21);
var $export = __webpack_require__(5);
var userAgent = __webpack_require__(199);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
var $task = __webpack_require__(293);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(290);
var getKeys = __webpack_require__(117);
var redefine = __webpack_require__(56);
var global = __webpack_require__(21);
var hide = __webpack_require__(55);
var Iterators = __webpack_require__(142);
var wks = __webpack_require__(33);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(880);
module.exports = __webpack_require__(68).RegExp.escape;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(5);
var $re = __webpack_require__(881)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var global =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  (typeof global !== 'undefined' && global)

var support = {
  searchParams: 'URLSearchParams' in global,
  iterable: 'Symbol' in global && 'iterator' in Symbol,
  blob:
    'FileReader' in global &&
    'Blob' in global &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in global,
  arrayBuffer: 'ArrayBuffer' in global
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name: "' + name + '"')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    this.bodyUsed = this.bodyUsed
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this)
        if (isConsumed) {
          return isConsumed
        }
        if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(
            this._bodyArrayBuffer.buffer.slice(
              this._bodyArrayBuffer.byteOffset,
              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
            )
          )
        } else {
          return Promise.resolve(this._bodyArrayBuffer)
        }
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime())
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime()
      }
    }
  }
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders
    .split('\r')
    .map(function(header) {
      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
    })
    .forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = options.statusText === undefined ? '' : '' + options.statusText
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = global.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      setTimeout(function() {
        resolve(new Response(body, options))
      }, 0)
    }

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException('Aborted', 'AbortError'))
      }, 0)
    }

    function fixUrl(url) {
      try {
        return url === '' && global.location.href ? global.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob'
      } else if (
        support.arrayBuffer &&
        request.headers.get('Content-Type') &&
        request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
      ) {
        xhr.responseType = 'arraybuffer'
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]))
      })
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!global.fetch) {
  global.fetch = fetch
  global.Headers = Headers
  global.Request = Request
  global.Response = Response
}


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(298);var _reactDom2=_interopRequireDefault(_reactDom);var _reactRedux=__webpack_require__(7);var _reactRouterRedux=__webpack_require__(317);__webpack_require__(1003);__webpack_require__(1004);__webpack_require__(1030);var _store=__webpack_require__(1031);var _store2=_interopRequireDefault(_store);var _App=__webpack_require__(1480);var _App2=_interopRequireDefault(_App);var _ModalRoot=__webpack_require__(2290);var _ModalRoot2=_interopRequireDefault(_ModalRoot);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var target=document.getElementById('root');_reactDom2.default.render(_react2.default.createElement(_reactRedux.Provider,{store:_store2.default,__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement(_reactRouterRedux.ConnectedRouter,{history:_store.history,__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement(_App2.default,{__source:{fileName:_jsxFileName,lineNumber:19}}),_react2.default.createElement(_ModalRoot2.default,{__source:{fileName:_jsxFileName,lineNumber:20}})))),target);

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(886);
var ReactElement = __webpack_require__(144);

var emptyFunction = __webpack_require__(63);
var traverseAllChildren = __webpack_require__(887);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(164);

var invariant = __webpack_require__(17);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(164);

var ReactCurrentOwner = __webpack_require__(91);
var REACT_ELEMENT_TYPE = __webpack_require__(448);

var getIteratorFn = __webpack_require__(888);
var invariant = __webpack_require__(17);
var KeyEscapeUtils = __webpack_require__(889);
var warning = __webpack_require__(28);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(144);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(144),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(449);

module.exports = factory(isValidElement);

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(63);
var invariant = __webpack_require__(17);
var warning = __webpack_require__(28);

var ReactPropTypesSecret = __webpack_require__(450);
var checkPropTypes = __webpack_require__(893);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplid to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', componentName || 'React class', location, typeSpecName);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _require = __webpack_require__(445),
    Component = _require.Component;

var _require2 = __webpack_require__(144),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(446);
var factory = __webpack_require__(451);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(164);

var ReactElement = __webpack_require__(144);

var invariant = __webpack_require__(17);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(41);
var ReactDefaultInjection = __webpack_require__(898);
var ReactMount = __webpack_require__(475);
var ReactReconciler = __webpack_require__(146);
var ReactUpdates = __webpack_require__(82);
var ReactVersion = __webpack_require__(970);

var findDOMNode = __webpack_require__(971);
var getHostComponentFromComposite = __webpack_require__(476);
var renderSubtreeIntoContainer = __webpack_require__(972);
var warning = __webpack_require__(28);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(899);
var BeforeInputEventPlugin = __webpack_require__(900);
var ChangeEventPlugin = __webpack_require__(904);
var DefaultEventPluginOrder = __webpack_require__(907);
var EnterLeaveEventPlugin = __webpack_require__(908);
var HTMLDOMPropertyConfig = __webpack_require__(909);
var ReactComponentBrowserEnvironment = __webpack_require__(910);
var ReactDOMComponent = __webpack_require__(916);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactDOMEmptyComponent = __webpack_require__(941);
var ReactDOMTreeTraversal = __webpack_require__(942);
var ReactDOMTextComponent = __webpack_require__(943);
var ReactDefaultBatchingStrategy = __webpack_require__(944);
var ReactEventListener = __webpack_require__(945);
var ReactInjection = __webpack_require__(947);
var ReactReconcileTransaction = __webpack_require__(948);
var SVGDOMPropertyConfig = __webpack_require__(954);
var SelectEventPlugin = __webpack_require__(955);
var SimpleEventPlugin = __webpack_require__(956);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(165);
var ExecutionEnvironment = __webpack_require__(53);
var FallbackCompositionState = __webpack_require__(901);
var SyntheticCompositionEvent = __webpack_require__(902);
var SyntheticInputEvent = __webpack_require__(903);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var PooledClass = __webpack_require__(126);

var getTextContentAccessor = __webpack_require__(455);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(92);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(92);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(166);
var EventPropagators = __webpack_require__(165);
var ExecutionEnvironment = __webpack_require__(53);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactUpdates = __webpack_require__(82);
var SyntheticEvent = __webpack_require__(92);

var inputValueTracking = __webpack_require__(458);
var getEventTarget = __webpack_require__(302);
var isEventSupported = __webpack_require__(303);
var isTextInputElement = __webpack_require__(459);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactOwner = __webpack_require__(906);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(29);

var invariant = __webpack_require__(17);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(165);
var ReactDOMComponentTree = __webpack_require__(41);
var SyntheticMouseEvent = __webpack_require__(206);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(145);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(305);
var ReactDOMIDOperations = __webpack_require__(915);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var DOMLazyTree = __webpack_require__(147);
var ExecutionEnvironment = __webpack_require__(53);

var createNodesFromMarkup = __webpack_require__(912);
var emptyFunction = __webpack_require__(63);
var invariant = __webpack_require__(17);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(53);

var createArrayFromMixed = __webpack_require__(913);
var getMarkupWrap = __webpack_require__(914);
var invariant = __webpack_require__(17);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(17);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(53);

var invariant = __webpack_require__(17);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMChildrenOperations = __webpack_require__(305);
var ReactDOMComponentTree = __webpack_require__(41);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(29),
    _assign = __webpack_require__(34);

var AutoFocusUtils = __webpack_require__(917);
var CSSPropertyOperations = __webpack_require__(918);
var DOMLazyTree = __webpack_require__(147);
var DOMNamespaces = __webpack_require__(306);
var DOMProperty = __webpack_require__(145);
var DOMPropertyOperations = __webpack_require__(464);
var EventPluginHub = __webpack_require__(166);
var EventPluginRegistry = __webpack_require__(299);
var ReactBrowserEventEmitter = __webpack_require__(209);
var ReactDOMComponentFlags = __webpack_require__(452);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactDOMInput = __webpack_require__(928);
var ReactDOMOption = __webpack_require__(930);
var ReactDOMSelect = __webpack_require__(465);
var ReactDOMTextarea = __webpack_require__(931);
var ReactInstrumentation = __webpack_require__(73);
var ReactMultiChild = __webpack_require__(932);
var ReactServerRenderingTransaction = __webpack_require__(939);

var emptyFunction = __webpack_require__(63);
var escapeTextContentForBrowser = __webpack_require__(208);
var invariant = __webpack_require__(17);
var isEventSupported = __webpack_require__(303);
var shallowEqual = __webpack_require__(310);
var inputValueTracking = __webpack_require__(458);
var validateDOMNesting = __webpack_require__(314);
var warning = __webpack_require__(28);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMComponentTree = __webpack_require__(41);

var focusNode = __webpack_require__(462);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(463);
var ExecutionEnvironment = __webpack_require__(53);
var ReactInstrumentation = __webpack_require__(73);

var camelizeStyleName = __webpack_require__(919);
var dangerousStyleValue = __webpack_require__(921);
var hyphenateStyleName = __webpack_require__(922);
var memoizeStringOnly = __webpack_require__(924);
var warning = __webpack_require__(28);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(920);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var CSSProperty = __webpack_require__(463);
var warning = __webpack_require__(28);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(923);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(208);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPluginHub = __webpack_require__(166);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(53);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29),
    _assign = __webpack_require__(34);

var DOMPropertyOperations = __webpack_require__(464);
var LinkedValueUtils = __webpack_require__(308);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactUpdates = __webpack_require__(82);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(28);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var React = __webpack_require__(143);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactDOMSelect = __webpack_require__(465);

var warning = __webpack_require__(28);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29),
    _assign = __webpack_require__(34);

var LinkedValueUtils = __webpack_require__(308);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactUpdates = __webpack_require__(82);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(28);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var ReactComponentEnvironment = __webpack_require__(309);
var ReactInstanceMap = __webpack_require__(168);
var ReactInstrumentation = __webpack_require__(73);

var ReactCurrentOwner = __webpack_require__(91);
var ReactReconciler = __webpack_require__(146);
var ReactChildReconciler = __webpack_require__(933);

var emptyFunction = __webpack_require__(63);
var flattenChildren = __webpack_require__(938);
var invariant = __webpack_require__(17);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactReconciler = __webpack_require__(146);

var instantiateReactComponent = __webpack_require__(466);
var KeyEscapeUtils = __webpack_require__(312);
var shouldUpdateReactComponent = __webpack_require__(311);
var traverseAllChildren = __webpack_require__(470);
var warning = __webpack_require__(28);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(471);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)))

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29),
    _assign = __webpack_require__(34);

var React = __webpack_require__(143);
var ReactComponentEnvironment = __webpack_require__(309);
var ReactCurrentOwner = __webpack_require__(91);
var ReactErrorUtils = __webpack_require__(301);
var ReactInstanceMap = __webpack_require__(168);
var ReactInstrumentation = __webpack_require__(73);
var ReactNodeTypes = __webpack_require__(467);
var ReactReconciler = __webpack_require__(146);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(297);
var invariant = __webpack_require__(17);
var shallowEqual = __webpack_require__(310);
var shouldUpdateReactComponent = __webpack_require__(311);
var warning = __webpack_require__(28);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(312);
var traverseAllChildren = __webpack_require__(470);
var warning = __webpack_require__(28);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(471);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(83)))

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var PooledClass = __webpack_require__(126);
var Transaction = __webpack_require__(205);
var ReactInstrumentation = __webpack_require__(73);
var ReactServerUpdateQueue = __webpack_require__(940);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(313);

var warning = __webpack_require__(28);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var DOMLazyTree = __webpack_require__(147);
var ReactDOMComponentTree = __webpack_require__(41);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var invariant = __webpack_require__(17);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29),
    _assign = __webpack_require__(34);

var DOMChildrenOperations = __webpack_require__(305);
var DOMLazyTree = __webpack_require__(147);
var ReactDOMComponentTree = __webpack_require__(41);

var escapeTextContentForBrowser = __webpack_require__(208);
var invariant = __webpack_require__(17);
var validateDOMNesting = __webpack_require__(314);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var ReactUpdates = __webpack_require__(82);
var Transaction = __webpack_require__(205);

var emptyFunction = __webpack_require__(63);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var EventListener = __webpack_require__(472);
var ExecutionEnvironment = __webpack_require__(53);
var PooledClass = __webpack_require__(126);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactUpdates = __webpack_require__(82);

var getEventTarget = __webpack_require__(302);
var getUnboundedScrollPosition = __webpack_require__(946);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var DOMProperty = __webpack_require__(145);
var EventPluginHub = __webpack_require__(166);
var EventPluginUtils = __webpack_require__(300);
var ReactComponentEnvironment = __webpack_require__(309);
var ReactEmptyComponent = __webpack_require__(468);
var ReactBrowserEventEmitter = __webpack_require__(209);
var ReactHostComponent = __webpack_require__(469);
var ReactUpdates = __webpack_require__(82);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(34);

var CallbackQueue = __webpack_require__(456);
var PooledClass = __webpack_require__(126);
var ReactBrowserEventEmitter = __webpack_require__(209);
var ReactInputSelection = __webpack_require__(473);
var ReactInstrumentation = __webpack_require__(73);
var Transaction = __webpack_require__(205);
var ReactUpdateQueue = __webpack_require__(313);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ExecutionEnvironment = __webpack_require__(53);

var getNodeForCharacterOffset = __webpack_require__(950);
var getTextContentAccessor = __webpack_require__(455);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(952);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(953);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var EventPropagators = __webpack_require__(165);
var ExecutionEnvironment = __webpack_require__(53);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactInputSelection = __webpack_require__(473);
var SyntheticEvent = __webpack_require__(92);

var getActiveElement = __webpack_require__(474);
var isTextInputElement = __webpack_require__(459);
var shallowEqual = __webpack_require__(310);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(29);

var EventListener = __webpack_require__(472);
var EventPropagators = __webpack_require__(165);
var ReactDOMComponentTree = __webpack_require__(41);
var SyntheticAnimationEvent = __webpack_require__(957);
var SyntheticClipboardEvent = __webpack_require__(958);
var SyntheticEvent = __webpack_require__(92);
var SyntheticFocusEvent = __webpack_require__(959);
var SyntheticKeyboardEvent = __webpack_require__(960);
var SyntheticMouseEvent = __webpack_require__(206);
var SyntheticDragEvent = __webpack_require__(962);
var SyntheticTouchEvent = __webpack_require__(963);
var SyntheticTransitionEvent = __webpack_require__(964);
var SyntheticUIEvent = __webpack_require__(167);
var SyntheticWheelEvent = __webpack_require__(965);

var emptyFunction = __webpack_require__(63);
var getEventCharCode = __webpack_require__(315);
var invariant = __webpack_require__(17);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(92);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(92);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(167);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(167);

var getEventCharCode = __webpack_require__(315);
var getEventKey = __webpack_require__(961);
var getEventModifierState = __webpack_require__(304);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var getEventCharCode = __webpack_require__(315);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(206);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticUIEvent = __webpack_require__(167);

var getEventModifierState = __webpack_require__(304);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticEvent = __webpack_require__(92);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var SyntheticMouseEvent = __webpack_require__(206);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var validateDOMNesting = __webpack_require__(314);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var adler32 = __webpack_require__(969);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.6.1';

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(29);

var ReactCurrentOwner = __webpack_require__(91);
var ReactDOMComponentTree = __webpack_require__(41);
var ReactInstanceMap = __webpack_require__(168);

var getHostComponentFromComposite = __webpack_require__(476);
var invariant = __webpack_require__(17);
var warning = __webpack_require__(28);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactMount = __webpack_require__(475);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(316);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(63);
var invariant = __webpack_require__(17);
var ReactPropTypesSecret = __webpack_require__(450);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(988);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(486);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(211);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(484);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(485);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(486);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(487);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(989);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(316);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducer__ = __webpack_require__(490);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var ConnectedRouter = function (_Component) {
  _inherits(ConnectedRouter, _Component);

  function ConnectedRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, ConnectedRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.handleLocationChange = function (location) {
      _this.store.dispatch({
        type: __WEBPACK_IMPORTED_MODULE_3__reducer__["a" /* LOCATION_CHANGE */],
        payload: location
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  ConnectedRouter.prototype.componentWillMount = function componentWillMount() {
    var _props = this.props,
        propsStore = _props.store,
        history = _props.history;

    this.store = propsStore || this.context.store;

    this.unsubscribeFromHistory = history.listen(this.handleLocationChange);
    this.handleLocationChange(history.location);
  };

  ConnectedRouter.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeFromHistory) this.unsubscribeFromHistory();
  };

  ConnectedRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Router"], this.props);
  };

  return ConnectedRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ConnectedRouter.propTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};
ConnectedRouter.contextTypes = {
  store: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (ConnectedRouter);

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Router__ = __webpack_require__(320);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(128);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(170);

var _LocationUtils = __webpack_require__(318);

var _createTransitionManager = __webpack_require__(319);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var valueEqual = function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
    return valueEqual(item, b[index]);
  });

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
};

exports.default = valueEqual;

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The public API for updating the location programatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(998)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(320);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_3_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__matchPath__ = __webpack_require__(321);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_3__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(488);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = routerMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(491);


/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* CALL_HISTORY_METHOD */]) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, args);
      };
    };
  };
}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _styledComponents=__webpack_require__(1);var _opensansSemibolditalicWebfont=__webpack_require__(1009);var _opensansSemibolditalicWebfont2=_interopRequireDefault(_opensansSemibolditalicWebfont);var _opensansSemibolditalicWebfont3=__webpack_require__(1010);var _opensansSemibolditalicWebfont4=_interopRequireDefault(_opensansSemibolditalicWebfont3);var _opensansSemiboldWebfont=__webpack_require__(1011);var _opensansSemiboldWebfont2=_interopRequireDefault(_opensansSemiboldWebfont);var _opensansSemiboldWebfont3=__webpack_require__(1012);var _opensansSemiboldWebfont4=_interopRequireDefault(_opensansSemiboldWebfont3);var _opensansRegularWebfont=__webpack_require__(1013);var _opensansRegularWebfont2=_interopRequireDefault(_opensansRegularWebfont);var _opensansRegularWebfont3=__webpack_require__(1014);var _opensansRegularWebfont4=_interopRequireDefault(_opensansRegularWebfont3);var _opensansLightitalicWebfont=__webpack_require__(1015);var _opensansLightitalicWebfont2=_interopRequireDefault(_opensansLightitalicWebfont);var _opensansLightitalicWebfont3=__webpack_require__(1016);var _opensansLightitalicWebfont4=_interopRequireDefault(_opensansLightitalicWebfont3);var _opensansLightWebfont=__webpack_require__(1017);var _opensansLightWebfont2=_interopRequireDefault(_opensansLightWebfont);var _opensansLightWebfont3=__webpack_require__(1018);var _opensansLightWebfont4=_interopRequireDefault(_opensansLightWebfont3);var _opensansItalicWebfont=__webpack_require__(1019);var _opensansItalicWebfont2=_interopRequireDefault(_opensansItalicWebfont);var _opensansItalicWebfont3=__webpack_require__(1020);var _opensansItalicWebfont4=_interopRequireDefault(_opensansItalicWebfont3);var _opensansExtrabolditalicWebfont=__webpack_require__(1021);var _opensansExtrabolditalicWebfont2=_interopRequireDefault(_opensansExtrabolditalicWebfont);var _opensansExtrabolditalicWebfont3=__webpack_require__(1022);var _opensansExtrabolditalicWebfont4=_interopRequireDefault(_opensansExtrabolditalicWebfont3);var _opensansExtraboldWebfont=__webpack_require__(1023);var _opensansExtraboldWebfont2=_interopRequireDefault(_opensansExtraboldWebfont);var _opensansExtraboldWebfont3=__webpack_require__(1024);var _opensansExtraboldWebfont4=_interopRequireDefault(_opensansExtraboldWebfont3);var _opensansBolditalicWebfont=__webpack_require__(1025);var _opensansBolditalicWebfont2=_interopRequireDefault(_opensansBolditalicWebfont);var _opensansBolditalicWebfont3=__webpack_require__(1026);var _opensansBolditalicWebfont4=_interopRequireDefault(_opensansBolditalicWebfont3);var _opensansBoldWebfont=__webpack_require__(1027);var _opensansBoldWebfont2=_interopRequireDefault(_opensansBoldWebfont);var _opensansBoldWebfont3=__webpack_require__(1028);var _opensansBoldWebfont4=_interopRequireDefault(_opensansBoldWebfont3);var _galanoGrotesqueAltBold=__webpack_require__(1029);var _galanoGrotesqueAltBold2=_interopRequireDefault(_galanoGrotesqueAltBold);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}(0,_styledComponents.injectGlobal)(['@font-face{font-family:Galano;font-style:bold;font-weight:600;src:url(',') format(\'woff\');}@font-face{font-family:OpenSans;font-style:italic;font-weight:600;src:url(',') format(\'woff2\'),url(',') format(\'woff\');}@font-face{font-family:OpenSans;font-style:normal;font-weight:600;src:url(',') format(\'woff2\'),url(',') format(\'woff\');}@font-face{font-family:OpenSans;font-style:normal;font-weight:400;src:url(',') format(\'woff2\'),url(',') format(\'woff\');}@font-face{font-family:OpenSans;font-style:italic;font-weight:300;src:url(',') format(\'woff2\'),url(',') format(\'woff\');}@font-face{font-family:OpenSans;font-style:normal;font-weight:300;src:url(',') format(\'woff2\'),url(',') format(\'woff\');}@font-face{font-family:OpenSans;font-style:italic;font-weight:400;src:url(',') format(\'woff2\'),url(',') format(\'woff\');}@font-face{font-family:OpenSans;font-style:italic;font-weight:800;src:url(',') format(\'woff2\'),url(',') format(\'woff\');}@font-face{font-family:OpenSans;font-style:normal;font-weight:800;src:url(',') format(\'woff2\'),url(',') format(\'woff\');}@font-face{font-family:OpenSans;font-style:italic;font-weight:700;src:url(',') format(\'woff2\'),url(',') format(\'woff\');}@font-face{font-family:OpenSans;font-style:normal;font-weight:700;src:url(',') format(\'woff2\'),url(',') format(\'woff\');}'],_galanoGrotesqueAltBold2.default,_opensansSemibolditalicWebfont2.default,_opensansSemibolditalicWebfont4.default,_opensansSemiboldWebfont2.default,_opensansSemiboldWebfont4.default,_opensansRegularWebfont2.default,_opensansRegularWebfont4.default,_opensansLightitalicWebfont2.default,_opensansLightitalicWebfont4.default,_opensansLightWebfont2.default,_opensansLightWebfont4.default,_opensansItalicWebfont2.default,_opensansItalicWebfont4.default,_opensansExtrabolditalicWebfont2.default,_opensansExtrabolditalicWebfont4.default,_opensansExtraboldWebfont2.default,_opensansExtraboldWebfont4.default,_opensansBolditalicWebfont2.default,_opensansBolditalicWebfont4.default,_opensansBoldWebfont2.default,_opensansBoldWebfont4.default);

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(1006);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 1008 */
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  if (!fn) {
    return false
  }
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-semibolditalic-webfont.e0be507a.woff2";

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-semibolditalic-webfont.a6357716.woff";

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-semibold-webfont.b1c1678e.woff2";

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-semibold-webfont.54ccb61c.woff";

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-regular-webfont.fcd27989.woff2";

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-regular-webfont.89331c7e.woff";

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-lightitalic-webfont.772fac09.woff2";

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-lightitalic-webfont.d920bf7a.woff";

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-light-webfont.c1596d95.woff2";

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-light-webfont.ec1037c4.woff";

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-italic-webfont.159f88f7.woff2";

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-italic-webfont.33de3716.woff";

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-extrabolditalic-webfont.96e3c241.woff2";

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-extrabolditalic-webfont.96797caf.woff";

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-extrabold-webfont.5fea2732.woff2";

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-extrabold-webfont.47007265.woff";

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-bolditalic-webfont.bc72a681.woff2";

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-bolditalic-webfont.495dfe5e.woff";

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-bold-webfont.09abf747.woff2";

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opensans-bold-webfont.4fc8e036.woff";

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/galano-grotesque-alt-bold.db7e9199.woff";

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _styledComponents=__webpack_require__(1);(0,_styledComponents.injectGlobal)(['.fade-in-enter{opacity:0.01;}.fade-in-enter.fade-in-enter-active{opacity:1;transition:opacity 500ms ease-in;}.fade-in-leave{opacity:1;}.fade-in-leave.fade-in-leave-active{opacity:0.01;transition:opacity 300ms ease-in;}']);

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.history=undefined;var _redux=__webpack_require__(169);var _reactRouterRedux=__webpack_require__(317);var _reduxForm=__webpack_require__(11);var _reduxThunk=__webpack_require__(1196);var _reduxThunk2=_interopRequireDefault(_reduxThunk);var _createBrowserHistory=__webpack_require__(521);var _createBrowserHistory2=_interopRequireDefault(_createBrowserHistory);var _reducer=__webpack_require__(1197);var _reducer2=_interopRequireDefault(_reducer);var _reduxPromiseMiddleware=__webpack_require__(1474);var _reduxPromiseMiddleware2=_interopRequireDefault(_reduxPromiseMiddleware);var _reducer3=__webpack_require__(1475);var _reducer4=_interopRequireDefault(_reducer3);var _reducer5=__webpack_require__(1476);var _reducer6=_interopRequireDefault(_reducer5);var _reducer7=__webpack_require__(1477);var _reducer8=_interopRequireDefault(_reducer7);var _reducer9=__webpack_require__(1478);var _reducer10=_interopRequireDefault(_reducer9);var _reducer11=__webpack_require__(1479);var _reducer12=_interopRequireDefault(_reducer11);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var appReducer=(0,_redux.combineReducers)({router:_reactRouterRedux.routerReducer,form:_reduxForm.reducer,reducer:_reducer2.default,tokenModal:_reducer8.default,modalReducer:_reducer4.default,stepBox:_reducer6.default,header:_reducer10.default,pageLoader:_reducer12.default});var history=exports.history=(0,_createBrowserHistory2.default)();var initialState={};var enhancers=[];var middleware=[_reduxPromiseMiddleware2.default,_reduxThunk2.default,(0,_reactRouterRedux.routerMiddleware)(history)];var token=sessionStorage.getItem('token');if(token&&typeof token!=='undefined'){var decodedToken=atob(token);initialState.reducer={account:JSON.parse(decodedToken)};}if(false){var devToolsExtension=window.devToolsExtension;if(typeof devToolsExtension==='function'){enhancers.push(devToolsExtension());}}var rootReducer=function rootReducer(state,action){if(action.type==='LOGOUT'){sessionStorage.clear();return appReducer(initialState,action);}return appReducer(state,action);};var composedEnhancers=_redux.compose.apply(undefined,[_redux.applyMiddleware.apply(undefined,middleware)].concat(enhancers));var store=(0,_redux.createStore)(rootReducer,initialState,composedEnhancers);exports.default=store;

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', this.props);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
Form.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_prefixName__ = __webpack_require__(171);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection(props, context) {
    _classCallCheck(this, FormSection);

    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: _extends({}, context._reduxForm, {
          sectionPrefix: Object(__WEBPACK_IMPORTED_MODULE_2__util_prefixName__["a" /* default */])(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(children)) {
        return children;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormSection.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

FormSection.defaultProps = {
  component: 'div'
};

FormSection.childContextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FormSection.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (FormSection);

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

/* harmony default export */ __webpack_exports__["a"] = (ExtendableError);


/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fieldInputPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fieldMetaPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fieldPropTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var any = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    bool = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    func = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    shape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape,
    string = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType,
    object = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object;


var formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: func.isRequired, // function to insert a value into an array field
    move: func.isRequired, // function to move a value within an array field
    pop: func.isRequired, // function to pop a value off of an array field
    push: func.isRequired, // function to push a value onto an array field
    remove: func.isRequired, // function to remove a value from an array field
    removeAll: func.isRequired, // function to remove all the values from an array field
    shift: func.isRequired, // function to shift a value out of an array field
    splice: func.isRequired, // function to splice a value into an array field
    swap: func.isRequired, // function to swap values in an array field
    unshift: func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: func.isRequired, // function to trigger async validation
  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: func.isRequired, // action to mark a field as blurred
  change: func.isRequired, // action to change the value of a field
  clearAsyncError: func.isRequired, // action to clear the async error of a field
  destroy: func.isRequired, // action to destroy the form's data in Redux
  dispatch: func.isRequired, // the Redux dispatch action
  handleSubmit: func.isRequired, // function to submit the form
  initialize: func.isRequired, // action to initialize form data
  reset: func.isRequired, // action to reset the form data to previously initialized values
  touch: func.isRequired, // action to mark fields as touched
  submit: func.isRequired, // action to trigger a submission of the specified form
  untouch: func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
};

var fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: string,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
};

var fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (formPropTypes);

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createField__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createField__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConnectedField__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_shallowCompare__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_prefixName__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var createField = function createField(structure) {
  var ConnectedField = Object(__WEBPACK_IMPORTED_MODULE_3__ConnectedField__["a" /* default */])(structure);

  var setIn = structure.setIn;

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field(props, context) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      };

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Field, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.name !== nextProps.name ||
        // use deepEqual here because they could be a function or an array of functions
        !__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.validate, nextProps.validate) || !__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.warn, nextProps.warn)) {
          // unregister old name
          this.context._reduxForm.unregister(this.name);
          // register new name
          this.context._reduxForm.register(Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, nextProps.name), 'Field', function () {
            return nextProps.validate;
          }, function () {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedField, _extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.ref.getWrappedInstance().isPristine();
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Field.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    normalize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  };
  Field.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  return Field;
};

/* harmony default export */ __webpack_exports__["a"] = (createField);

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(25);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name);
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    _inherits(ConnectedField, _Component);

    function ConnectedField() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.isPristine = function () {
        return _this.props.pristine;
      }, _this.getValue = function () {
        return _this.props.value;
      }, _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          onChange(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue);
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
        }
      }, _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;


        var defaultPrevented = false;
        if (onFocus) {
          onFocus(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }));
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.
        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          onBlur(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue);
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue));

          // call post-blur callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue);
          }
        }
      }, _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;

        eventDataTransferSetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */], value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event);
        }
      }, _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;

        var newValue = eventDataTransferGetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */]);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            normalize = _props.normalize,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onDragStart = _props.onDragStart,
            onDrop = _props.onDrop,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop']);

        var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = _objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, input, custom));
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedField.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedField);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(498);



var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return checked || '';
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

/* harmony default export */ __webpack_exports__["a"] = (getValue);

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

/* harmony default export */ __webpack_exports__["a"] = (isReactNative);

/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataKey; });
var dataKey = 'text';

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, true); // temporary placeholder
      _copy2[index] = undefined; // set to undefined
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value); // removing and adding
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum); // removing
    return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

/* harmony default export */ __webpack_exports__["a"] = (splice);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(213);



var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(1045);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(323);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(325);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(1053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(1056);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(215);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(502);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(1051);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(84);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(215);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(215);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(215);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(217);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(217);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(217);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(217);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(218);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(218);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(218);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(218);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(214);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(213);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      return _defineProperty({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field), 0);
};

/* harmony default export */ __webpack_exports__["a"] = (setIn);

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(504);



var customizer = function customizer(obj, other) {
  if (obj === other) return true;
  if ((obj == null || obj === '' || obj === false) && (other == null || other === '' || other === false)) {
    return !(obj === undefined && other === false || obj === false && other === undefined);
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
};

var deepEqual = function deepEqual(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(a, b, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (deepEqual);

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(332);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(216);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(323);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(1078);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(1083);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(1085);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(328);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(85);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(1090);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(127);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(127);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(480);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(212)(module)))

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(1098);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(482);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(502);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(84);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(84);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(84);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(84);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(213);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(_toConsumableArray(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(_toConsumableArray(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field))));
};

/* harmony default export */ __webpack_exports__["a"] = (deleteIn);

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}


/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFields__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFields__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConnectedFields__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_shallowCompare__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__structure_plain__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(171);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields = function createFields(structure) {
  var ConnectedFields = Object(__WEBPACK_IMPORTED_MODULE_3__ConnectedFields__["a" /* default */])(structure);

  var Fields = function (_Component) {
    _inherits(Fields, _Component);

    function Fields(props, context) {
      _classCallCheck(this, Fields);

      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        var error = validateNameProp(this.props.names);
        if (error) {
          throw error;
        }
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_5__structure_plain__["a" /* default */].deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister(Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(context, name));
          });
          // register new name
          nextProps.names.forEach(function (name) {
            return register(Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister(Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFields, _extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    withRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  };
  Fields.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  return Fields;
};

/* harmony default export */ __webpack_exports__["a"] = (createFields);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__structure_plain__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__ = __webpack_require__(497);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var propsToNotUpdateFor = ['_reduxForm'];

var createConnectedFields = function createConnectedFields(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;


  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error') || __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_Component) {
    _inherits(ConnectedFields, _Component);

    function ConnectedFields(props) {
      _classCallCheck(this, ConnectedFields);

      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.onChangeFns = {};
      _this.onFocusFns = {};
      _this.onBlurFns = {};

      _this.prepareEventHandlers = function (_ref) {
        var names = _ref.names;
        return names.forEach(function (name) {
          _this.onChangeFns[name] = function (event) {
            return _this.handleChange(name, event);
          };
          _this.onFocusFns[name] = function () {
            return _this.handleFocus(name);
          };
          _this.onBlurFns[name] = function (event) {
            return _this.handleBlur(name, event);
          };
        });
      };

      _this.handleChange = function (name, event) {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            _reduxForm = _this$props._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        dispatch(_reduxForm.change(name, value));
      };

      _this.handleFocus = function (name) {
        var _this$props2 = _this.props,
            dispatch = _this$props2.dispatch,
            _reduxForm = _this$props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      };

      _this.handleBlur = function (name, event) {
        var _this$props3 = _this.props,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            _reduxForm = _this$props3._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        // dispatch blur action
        dispatch(_reduxForm.blur(name, value));

        // call post-blur callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value);
        }
      };

      _this.prepareEventHandlers(props);
      return _this;
    }

    _createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names has changed. The cached event handlers need to be updated
          this.prepareEventHandlers(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        });
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.refs.renderedComponent;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            _fields = _props._fields,
            _reduxForm = _props._reduxForm,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = 'renderedComponent';
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedFields.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
    _fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          initial: initial,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFields);

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFieldArray__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFieldArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConnectedFieldArray__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_prefixName__ = __webpack_require__(171);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray = function createFieldArray(structure) {
  var ConnectedFieldArray = Object(__WEBPACK_IMPORTED_MODULE_3__ConnectedFieldArray__["a" /* default */])(structure);

  var FieldArray = function (_Component) {
    _inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      _classCallCheck(this, FieldArray);

      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(FieldArray, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.name !== nextProps.name) {
          // unregister old name
          this.context._reduxForm.unregister(this.name);
          // register new name
          this.context._reduxForm.register(Object(__WEBPACK_IMPORTED_MODULE_4__util_prefixName__["a" /* default */])(this.context, nextProps.name), 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFieldArray, _extends({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.ref.getWrappedInstance().pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref.getWrappedInstance().value;
      }
    }]);

    return FieldArray;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  FieldArray.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  return FieldArray;
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldArray);

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(25);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var propsToNotUpdateFor = ['_reduxForm', 'value'];

var createConnectedFieldArray = function createConnectedFieldArray(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_Component) {
    _inherits(ConnectedFieldArray, _Component);

    function ConnectedFieldArray() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedFieldArray);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.getValue = function (index) {
        return _this.props.value && getIn(_this.props.value, String(index));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          if (thisValue.length !== nextValue.length || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
            return !deepEqual(val, nextValue[index]);
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        return nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = Object(__WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__["a" /* default */])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  ConnectedFieldArray.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    rerenderOnEveryChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFieldArray);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(328);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(1115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(1123);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(513);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(326);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(328);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(1120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(173);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(514);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(1122);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(173);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(173);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(514);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
  var getIn = _ref2.getIn;

  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = _extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, String(length - 1));
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, '0');
      },
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};


/* harmony default export */ __webpack_exports__["a"] = (createFieldArrayProps);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);




var createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(form, 'Form value must be specified');
    var nonNullGetFormState = getFormState || function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      __WEBPACK_IMPORTED_MODULE_0_invariant___default()(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : __WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */].setIn(accumulator, field, value);
      }, {});
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFormValueSelector);

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValues__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_prefixName__ = __webpack_require__(171);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (firstArg) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    var valuesMap = void 0;

    if (typeof firstArg === 'string') {
      valuesMap = [firstArg].concat(_toConsumableArray(rest)).map(function (k) {
        return {
          prop: k,
          path: k
        };
      });
    } else {
      var config = firstArg;
      valuesMap = Object.keys(config).map(function (k) {
        return {
          prop: k,
          path: config[k]
        };
      });
    }
    if (!valuesMap.length) {
      throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...})');
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        _inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          _classCallCheck(this, FormValues);

          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          var formValuesSelector = function formValuesSelector(_, _ref2) {
            var sectionPrefix = _ref2.sectionPrefix;

            // Yes, we're only using connect() for listening to updates.
            // The second argument needs to be there so that connect calls
            // the selector when props change
            var getValues = _this.context._reduxForm.getValues;

            var props = {};
            var values = getValues();
            valuesMap.forEach(function (_ref3) {
              var prop = _ref3.prop,
                  path = _ref3.path;
              return props[prop] = getIn(values, Object(__WEBPACK_IMPORTED_MODULE_3__util_prefixName__["a" /* default */])(_this.context, path));
            });
            return props;
          };
          _this.Component = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(formValuesSelector, function () {
            return {};
          } // ignore dispatch
          )(function (_ref4) {
            var sectionPrefix = _ref4.sectionPrefix,
                otherProps = _objectWithoutProperties(_ref4, ['sectionPrefix']);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, otherProps);
          });
          return _this;
        }

        _createClass(FormValues, [{
          key: 'render',
          value: function render() {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.Component, _extends({
              // so that the connected component updates props when sectionPrefix has changed
              sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }]);

        return FormValues;
      }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

      FormValues.contextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
      };
      return FormValues;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__ = __webpack_require__(1132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormNames = function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;
  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return keys(nonNullGetFormState(state));
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormNames);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__ = __webpack_require__(1134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormValues);

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormInitialValues);

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncErrors);

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormMeta);

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormAsyncErrors);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncWarnings);

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSubmitErrors);

/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPristine__ = __webpack_require__(516);



var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = Object(__WEBPACK_IMPORTED_MODULE_0__isPristine__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isPristine(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsDirty);

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__ = __webpack_require__(1150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid__ = __webpack_require__(337);



var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_0__isValid__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsInvalid);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};


var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

/* harmony default export */ __webpack_exports__["a"] = (createHasError);

/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isValid__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isValid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitting');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsSubmitting);

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitSucceeded);

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitFailed);

/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduxForm__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduxForm__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_promise__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_redux__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__asyncValidation__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__defaultShouldAsyncValidate__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__defaultShouldValidate__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__events_silenceEvent__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__events_silenceEvents__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__generateValidator__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__handleSubmit__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__selectors_isValid__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__structure_plain__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_getDisplayName__ = __webpack_require__(1190);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





















var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

// extract field-specific actions

var arrayInsert = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].arrayInsert,
    arrayMove = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].arrayMove,
    arrayPop = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].arrayPop,
    arrayPush = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].arrayPush,
    arrayRemove = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].arrayRemove,
    arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].arrayRemoveAll,
    arrayShift = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].arrayShift,
    arraySplice = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].arraySplice,
    arraySwap = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].arraySwap,
    arrayUnshift = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].arrayUnshift,
    blur = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].blur,
    change = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].change,
    focus = __WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].focus,
    formActions = _objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */], ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift
};

var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */])), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = Object(__WEBPACK_IMPORTED_MODULE_16__selectors_isValid__["a" /* default */])(structure);
  return function (initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: __WEBPACK_IMPORTED_MODULE_10__defaultShouldAsyncValidate__["a" /* default */],
      shouldValidate: __WEBPACK_IMPORTED_MODULE_11__defaultShouldValidate__["a" /* default */],
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        _inherits(Form, _Component);

        function Form() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, Form);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
            return _this.props.values;
          }, _this.isValid = function () {
            return _this.props.valid;
          }, _this.isPristine = function () {
            return _this.props.pristine;
          }, _this.register = function (name, type, getValidator, getWarner) {
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function (name) {
            if (!_this.destroyed) {
              if (_this.props.destroyOnUnmount || _this.props.forceUnregisterOnUnmount) {
                _this.props.unregisterField(name);
                delete _this.fieldValidators[name];
                delete _this.fieldWarners[name];
              } else {
                _this.props.unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function () {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? Object(__WEBPACK_IMPORTED_MODULE_14__generateValidator__["a" /* default */])(validators, structure) : undefined;
          }, _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function () {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? Object(__WEBPACK_IMPORTED_MODULE_14__generateValidator__["a" /* default */])(warners, structure) : undefined;
          }, _this.asyncValidate = function (name, value) {
            var _this$props = _this.props,
                asyncBlurFields = _this$props.asyncBlurFields,
                asyncErrors = _this$props.asyncErrors,
                asyncValidate = _this$props.asyncValidate,
                dispatch = _this$props.dispatch,
                initialized = _this$props.initialized,
                pristine = _this$props.pristine,
                shouldAsyncValidate = _this$props.shouldAsyncValidate,
                startAsyncValidation = _this$props.startAsyncValidation,
                stopAsyncValidation = _this$props.stopAsyncValidation,
                syncErrors = _this$props.syncErrors,
                values = _this$props.values;

            var submitting = !name;
            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              var isBlurredField = !submitting && (!asyncBlurFields || ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]')));
              if ((isBlurredField || submitting) && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : 'blur',
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return Object(__WEBPACK_IMPORTED_MODULE_9__asyncValidation__["a" /* default */])(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }, _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function (error) {
            delete _this.submitPromise;
            return error;
          }, _this.listenToSubmit = function (promise) {
            if (!__WEBPACK_IMPORTED_MODULE_3_is_promise___default()(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function (submitOrEvent) {
            var _this$props2 = _this.props,
                onSubmit = _this$props2.onSubmit,
                blur = _this$props2.blur,
                change = _this$props2.change,
                dispatch = _this$props2.dispatch;


            if (!submitOrEvent || Object(__WEBPACK_IMPORTED_MODULE_12__events_silenceEvent__["a" /* default */])(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_15__handleSubmit__["a" /* default */])(checkSubmit(onSubmit), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return Object(__WEBPACK_IMPORTED_MODULE_13__events_silenceEvents__["a" /* default */])(function () {
                return !_this.submitPromise && _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_15__handleSubmit__["a" /* default */])(checkSubmit(submitOrEvent), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function () {
            return _this.props.reset();
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  lastInitialValues: this.props.initialValues
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize);
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!__WEBPACK_IMPORTED_MODULE_17__structure_plain__["a" /* default */].deepEqual(lastSyncErrors, nextSyncErrors) || !__WEBPACK_IMPORTED_MODULE_17__structure_plain__["a" /* default */].deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                validate = _props3.validate,
                values = _props3.values;

            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var shouldValidateResult = shouldValidate({
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              });

              if (shouldValidateResult) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

                var _merge2 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props4 = this.props,
                warning = _props4.warning,
                syncWarnings = _props4.syncWarnings,
                updateSyncWarnings = _props4.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!__WEBPACK_IMPORTED_MODULE_17__structure_plain__["a" /* default */].deepEqual(lastSyncWarnings, nextSyncWarnings) || !__WEBPACK_IMPORTED_MODULE_17__structure_plain__["a" /* default */].deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props5 = this.props,
                shouldValidate = _props5.shouldValidate,
                warn = _props5.warn,
                values = _props5.values;

            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var shouldWarnResult = shouldValidate({
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              });

              if (shouldWarnResult) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

                var _merge3 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            this.initIfNeeded();
            this.validateIfNeeded();
            this.warnIfNeeded();
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange,
                values = nextProps.values,
                dispatch = nextProps.dispatch;

            if (onChange && !deepEqual(values, this.props.values)) {
              onChange(values, dispatch, nextProps);
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps,
                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;

            return Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            });
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props6 = this.props,
                destroyOnUnmount = _props6.destroyOnUnmount,
                destroy = _props6.destroy;

            if (destroyOnUnmount) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props7 = this.props,
                anyTouched = _props7.anyTouched,
                arrayInsert = _props7.arrayInsert,
                arrayMove = _props7.arrayMove,
                arrayPop = _props7.arrayPop,
                arrayPush = _props7.arrayPush,
                arrayRemove = _props7.arrayRemove,
                arrayRemoveAll = _props7.arrayRemoveAll,
                arrayShift = _props7.arrayShift,
                arraySplice = _props7.arraySplice,
                arraySwap = _props7.arraySwap,
                arrayUnshift = _props7.arrayUnshift,
                asyncErrors = _props7.asyncErrors,
                asyncValidate = _props7.asyncValidate,
                asyncValidating = _props7.asyncValidating,
                blur = _props7.blur,
                change = _props7.change,
                clearSubmit = _props7.clearSubmit,
                destroy = _props7.destroy,
                destroyOnUnmount = _props7.destroyOnUnmount,
                forceUnregisterOnUnmount = _props7.forceUnregisterOnUnmount,
                dirty = _props7.dirty,
                dispatch = _props7.dispatch,
                enableReinitialize = _props7.enableReinitialize,
                error = _props7.error,
                focus = _props7.focus,
                form = _props7.form,
                getFormState = _props7.getFormState,
                initialize = _props7.initialize,
                initialized = _props7.initialized,
                initialValues = _props7.initialValues,
                invalid = _props7.invalid,
                keepDirtyOnReinitialize = _props7.keepDirtyOnReinitialize,
                pristine = _props7.pristine,
                propNamespace = _props7.propNamespace,
                registeredFields = _props7.registeredFields,
                registerField = _props7.registerField,
                reset = _props7.reset,
                setSubmitFailed = _props7.setSubmitFailed,
                setSubmitSucceeded = _props7.setSubmitSucceeded,
                shouldAsyncValidate = _props7.shouldAsyncValidate,
                shouldValidate = _props7.shouldValidate,
                startAsyncValidation = _props7.startAsyncValidation,
                startSubmit = _props7.startSubmit,
                stopAsyncValidation = _props7.stopAsyncValidation,
                stopSubmit = _props7.stopSubmit,
                submitting = _props7.submitting,
                submitFailed = _props7.submitFailed,
                submitSucceeded = _props7.submitSucceeded,
                touch = _props7.touch,
                touchOnBlur = _props7.touchOnBlur,
                touchOnChange = _props7.touchOnChange,
                persistentSubmitErrors = _props7.persistentSubmitErrors,
                syncErrors = _props7.syncErrors,
                syncWarnings = _props7.syncWarnings,
                unregisterField = _props7.unregisterField,
                untouch = _props7.untouch,
                updateSyncErrors = _props7.updateSyncErrors,
                updateSyncWarnings = _props7.updateSyncWarnings,
                valid = _props7.valid,
                validExceptSubmit = _props7.validExceptSubmit,
                values = _props7.values,
                warning = _props7.warning,
                rest = _objectWithoutProperties(_props7, ['anyTouched', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */


            var reduxFormProps = _extends({
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch), {
              clearSubmit: clearSubmit,
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              propsToPass.ref = 'wrapped';
            }
            return Object(__WEBPACK_IMPORTED_MODULE_5_react__["createElement"])(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

      Form.displayName = 'Form(' + Object(__WEBPACK_IMPORTED_MODULE_18__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
        forceUnregisterOnUnmount: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
        form: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,
        initialValues: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
        getFormState: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
        onSubmitFail: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
        onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
        propNamespace: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
        validate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
        warn: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
        touchOnBlur: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
        touchOnChange: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
        triggerSubmit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
        persistentSubmitErrors: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
        registeredFields: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
      };

      var connector = Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["connect"])(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || {};
        var syncWarnings = getIn(formState, 'syncWarnings') || {};
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };

        // Bind the first parameter on `props.form`
        var boundFormACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(formActions, bindForm);
        var boundArrayACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus);

        // Wrap action creators with `dispatch`
        var connectedFormACs = Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])(boundArrayACs.arrayInsert, dispatch),
          move: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])(boundArrayACs.arrayMove, dispatch),
          pop: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])(boundArrayACs.arrayPop, dispatch),
          push: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])(boundArrayACs.arrayPush, dispatch),
          remove: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])(boundArrayACs.arrayRemove, dispatch),
          removeAll: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])(boundArrayACs.arrayRemoveAll, dispatch),
          shift: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])(boundArrayACs.arrayShift, dispatch),
          splice: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])(boundArrayACs.arraySplice, dispatch),
          swap: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])(boundArrayACs.arraySwap, dispatch),
          unshift: Object(__WEBPACK_IMPORTED_MODULE_7_redux__["bindActionCreators"])(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api
      return function (_Component2) {
        _inherits(ReduxForm, _Component2);

        function ReduxForm() {
          _classCallCheck(this, ReduxForm);

          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        _createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.refs.wrapped.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            return this.refs.wrapped.getWrappedInstance().reset();
          }
        }, {
          key: 'render',
          value: function render() {
            var _props8 = this.props,
                initialValues = _props8.initialValues,
                rest = _objectWithoutProperties(_props8, ['initialValues']);

            return Object(__WEBPACK_IMPORTED_MODULE_5_react__["createElement"])(ConnectedForm, _extends({}, rest, {
              ref: 'wrapped',
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return this.refs.wrapped.getWrappedInstance().isValid();
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return this.refs.wrapped.getWrappedInstance().isPristine();
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.refs.wrapped.getWrappedInstance().getValues();
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.refs.wrapped.getWrappedInstance().getFieldList();
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.refs.wrapped.getWrappedInstance().refs.wrapped;
          }
        }]);

        return ReduxForm;
      }(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createReduxForm);

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(1176);



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex);
});

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__safeGet_js__ = __webpack_require__(518);








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      Object(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(Object(__WEBPACK_IMPORTED_MODULE_6__safeGet_js__["a" /* default */])(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__safeGet_js__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__ = __webpack_require__(1171);
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(object, key),
      srcValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && Object(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (Object(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!Object(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || Object(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(84);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(212)(module)))

/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(1167);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(506);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(334);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(108);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(127);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(519);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(220);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(172);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(1175);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 1175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(1184);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(1180);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 1178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(1179);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(1183);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(336);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(108);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);


var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (errors && Object.keys(errors).length) {
        stop(errors);
        return errors;
      } else if (rejected) {
        stop();
        throw new Error('Asynchronous validation promise was rejected without errors.');
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

/* harmony default export */ __webpack_exports__["a"] = (asyncValidation);

/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__silenceEvent__ = __webpack_require__(520);


var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__silenceEvent__["a" /* default */])(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvents);

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__structure_plain__ = __webpack_require__(25);



var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators) {
  var array = toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props);
    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name]);
      if (error) {
        errors = __WEBPACK_IMPORTED_MODULE_0__structure_plain__["a" /* default */].setIn(errors, name, error);
      }
    });
    return errors;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (generateValidator);

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionError__ = __webpack_require__(495);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;


  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
    if (onSubmitFail) {
      onSubmitFail(syncErrors, dispatch, null, props);
    }
    return syncErrors;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleSubmit);

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};

/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReducer__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__structure_plain__ = __webpack_require__(25);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length && action.type.substring(0, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length) === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"];
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;

  var deleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(structure);
  var plainDeleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */]);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].getIn(slice, field);
    return existing || force ? setIn(state, key, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].setIn(slice, field, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"], function (state, _ref) {
    var _ref$meta = _ref.meta,
        field = _ref$meta.field,
        index = _ref$meta.index,
        payload = _ref.payload;

    return arraySplice(state, field, index, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"], function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        from = _ref2$meta.from,
        to = _ref2$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"], function (state, _ref3) {
    var field = _ref3.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"], function (state, _ref4) {
    var field = _ref4.meta.field,
        payload = _ref4.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"], function (state, _ref5) {
    var _ref5$meta = _ref5.meta,
        field = _ref5$meta.field,
        index = _ref5$meta.index;

    return arraySplice(state, field, index, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"], function (state, _ref6) {
    var field = _ref6.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"], function (state, _ref7) {
    var field = _ref7.meta.field;

    return arraySplice(state, field, 0, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"], function (state, _ref8) {
    var _ref8$meta = _ref8.meta,
        field = _ref8$meta.field,
        index = _ref8$meta.index,
        removeNum = _ref8$meta.removeNum,
        payload = _ref8.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        indexA = _ref9$meta.indexA,
        indexB = _ref9$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"], function (state, _ref10) {
    var field = _ref10.meta.field,
        payload = _ref10.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"], function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"], function (state, _ref12) {
    var _ref12$meta = _ref12.meta,
        field = _ref12$meta.field,
        touch = _ref12$meta.touch,
        payload = _ref12.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"], function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        persistentSubmitErrors = _ref13$meta.persistentSubmitErrors,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"], function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"], function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"], function (state, _ref14) {
    var field = _ref14.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"], function (state, _ref15) {
    var field = _ref15.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"], function (state, _ref16) {
    var payload = _ref16.payload,
        _ref16$meta = _ref16.meta,
        keepDirty = _ref16$meta.keepDirty,
        keepSubmitSucceeded = _ref16$meta.keepSubmitSucceeded;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');
    var newInitialValues = mapData;

    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        forEach(keys(registeredFields), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);

            // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)
            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        });

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"], function (state, _ref17) {
    var _ref17$payload = _ref17.payload,
        name = _ref17$payload.name,
        type = _ref17$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"], function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"], function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"], function (state, _ref18) {
    var field = _ref18.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"], function (state) {
    return setIn(state, 'submitting', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"], function (state, _ref19) {
    var payload = _ref19.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"], function (state, _ref20) {
    var payload = _ref20.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = setIn(result, 'submitSucceeded', true);
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"], function (state, _ref21) {
    var fields = _ref21.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"], function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"], function (state, _ref22) {
    var fields = _ref22.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"], function (state, _ref23) {
    var _ref23$payload = _ref23.payload,
        name = _ref23$payload.name,
        destroyOnUnmount = _ref23$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
      var syncErrors = getIn(result, 'syncErrors');
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncErrors, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }
      var syncWarnings = getIn(result, 'syncWarnings');
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncWarnings, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"], function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"], function (state, _ref25) {
    var _ref25$payload = _ref25.payload,
        syncErrors = _ref25$payload.syncErrors,
        error = _ref25$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"], function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        syncWarnings = _ref26$payload.syncWarnings,
        warning = _ref26$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

      var form = action && action.meta && action.meta.form;
      if (!form || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"] && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function plugin(reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };
        return Object.keys(reducers).reduce(function (accumulator, key) {
          var previousState = getIn(accumulator, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState === previousState ? accumulator : setIn(accumulator, key, nextState);
        }, _this(state, action));
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(213);



function createDeleteInWithCleanUp(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn,
      deleteIn = _ref.deleteIn,
      setIn = _ref.setIn;

  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
    if (path[path.length - 1] === ']') {
      // array path
      var pathTokens = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(path);
      pathTokens.pop();
      var parent = getIn(state, pathTokens.join('.'));
      return parent ? setIn(state, path) : state;
    }

    var result = state;
    if (getIn(state, path) !== undefined) {
      result = deleteIn(state, path);
    }

    var dotIndex = path.lastIndexOf('.');
    if (dotIndex > 0) {
      var parentPath = path.substring(0, dotIndex);
      if (parentPath[parentPath.length - 1] !== ']') {
        var _parent = getIn(result, parentPath);
        if (deepEqual(_parent, empty)) {
          return deleteInWithCleanUp(result, parentPath);
        }
      }
    }
    return result;
  };

  return deleteInWithCleanUp;
}

/* harmony default export */ __webpack_exports__["a"] = (createDeleteInWithCleanUp);

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createValues__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(25);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 1195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = _extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }
    // ignore dispatch
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _redux=__webpack_require__(169);var _aleloLogic=__webpack_require__(12);var _formStateReducer=__webpack_require__(1473);var _formStateReducer2=_interopRequireDefault(_formStateReducer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var parsedReducers={};var reducersKeys=Object.keys(_aleloLogic.reducers);reducersKeys.forEach(function(reducerKey){var parsedKey=reducerKey.replace('Reducer','');parsedReducers[parsedKey]=_aleloLogic.reducers[reducerKey];});// Reducers específicos do WEBSITE
parsedReducers.formState=_formStateReducer2.default;var reducer=(0,_redux.combineReducers)(parsedReducers);exports.default=reducer;module.exports=exports['default'];

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CLEAR_EC_QUERY_PLATE=_types2.default.CLEAR_EC_QUERY_PLATE;function clearECQueryPlate(){return function(dispatch){return dispatch({type:CLEAR_EC_QUERY_PLATE,state:null});};}exports.default=clearECQueryPlate;module.exports=exports['default'];

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _accountService=__webpack_require__(64);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_CANCEL_ACCOUNT=_types2.default.FETCH_CANCEL_ACCOUNT;function fetchCancelAccount(data){return function(dispatch){return(0,_accountService.doCancelAccount)(data).then(function(){dispatch({type:FETCH_CANCEL_ACCOUNT,state:false});});};}exports.default=fetchCancelAccount;module.exports=exports['default'];

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.doCancelAccount=doCancelAccount;exports.createCancelAccountToken=createCancelAccountToken;exports.validateCancelAccountToken=validateCancelAccountToken;exports.getCancelOptions=getCancelOptions;exports.recover=recover;exports.newUserPassword=newUserPassword;exports.verifyRecoverTokenStatus=verifyRecoverTokenStatus;exports.getECAccountPlans=getECAccountPlans;exports.postCancellationRequest=postCancellationRequest;exports.putCancellationRequest=putCancellationRequest;exports.getTrackIdentifiers=getTrackIdentifiers;var _constants=__webpack_require__(339);var _fetchHandler=__webpack_require__(523);var _fetchHandler2=_interopRequireDefault(_fetchHandler);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ecAccountPlans=[{_id:'5a15bab4fd64ee427df9ea26',id:'89392',active:'Vigente',accountId:'89392',plan:{id:'89392',category:'normal',type:'ec'},accessionDate:'2017-10-05T05:00:00.000Z',isMonthlyPayment:true,paymentMethod:null,identifiersQtd:'',__v:0,identifiersOrders:[{orderNumber:13420,orderAmount:12,orderTrackingUrl:'#',_id:'5a15bab4fd64ee427df9ea28'},{orderNumber:13421,orderAmount:8,orderTrackingUrl:'#',_id:'5a15bab4fd64ee427df9ea27'}],identifiers:[],representatives:[]}];function doCancelAccount(data){return(0,_fetchHandler2.default)(_constants.API+_constants.USER_CANCEL,{method:'PUT',body:JSON.stringify(data)});}function createCancelAccountToken(){return(0,_fetchHandler2.default)(_constants.API+_constants.CREATE_CANCEL_TOKEN,{method:'POST'});}function validateCancelAccountToken(token){return(0,_fetchHandler2.default)(_constants.API+_constants.VALIDATE_CANCEL_TOKEN,{method:'POST',body:JSON.stringify({token:token})});}function getCancelOptions(){return(0,_fetchHandler2.default)(_constants.API+_constants.CANCEL_OPTIONS,{method:'GET'});}// export async function authenticate(login, password, responseCaptcha) {
//   // TODO Remover chamada fetchHandler quando terminar de migrar os serviços
//   const [middlewareResp] = await Promise.all([
//     fetchHandler(dynamicAPI + ACCESS_TOKEN, {
//       method: 'POST',
//       body: JSON.stringify({ login, password, responseCaptcha })
//     }),
//     accountService.authenticate(login, password)
//   ])
//
//   return middlewareResp
// }
// TODO Remover quando terminar de migrar os serviços
// export function logout() {
//   return fetchHandler(dynamicAPI + LOGOUT, {
//     method: 'DELETE'
//   })
// }
function recover(login){return(0,_fetchHandler2.default)(_constants.dynPublicAPI+'/account/recover',{method:'POST',body:JSON.stringify({login:login})});}function newUserPassword(data){return(0,_fetchHandler2.default)(_constants.dynamicAPI+'/account/password',{method:'POST',body:JSON.stringify(data)});}function verifyRecoverTokenStatus(){var token=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return(0,_fetchHandler2.default)(_constants.dynamicAPI+'/account/recover/'+token+'/status',{method:'GET'});}// export function getAccountPlans(accountId) {
//   return accountService.getAccountPlans(accountId)
// }
function getECAccountPlans(accountId){return new Promise(function(resolve){window.setTimeout(function(){resolve(ecAccountPlans);},1000);});}// export function getTermsAndConditions() {
//   return accountService.getTermsAndConditions()
// }
function postCancellationRequest(accountId,planId,motive){return(0,_fetchHandler2.default)(_constants.dynamicAPI+'/accounts/'+accountId+'/plans/'+planId+'/cancellation-request',{method:'POST',body:JSON.stringify(motive)});}function putCancellationRequest(accountId,planId,token){return(0,_fetchHandler2.default)(_constants.dynamicAPI+'/accounts/'+accountId+'/plans/'+planId+'/cancellation-request',{method:'PUT',body:JSON.stringify({token:token})});}function getTrackIdentifiers(accountNumber,type){var url=_constants.API_URL+'/acompanhar-pedido/'+accountNumber+'?type='+type;return(0,_fetchHandler2.default)(url,{method:'GET'});}// export function getTrackIdentifiersDetails(accountNumber, order) {
//   return accountService.getTrackIdentifiersDetails(accountNumber, order)
// }
//
// export function getOrders(accountNumber, type) {
//   return accountService.getOrders(accountNumber, type)
// }

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Storage=function Storage(){_classCallCheck(this,Storage);this.setAccount=function(){var token=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(token.success){var encodedToken=btoa(JSON.stringify(token));sessionStorage.setItem('token',encodedToken);}else{sessionStorage.setItem('token','');}};this.getAccount=function(){var token=sessionStorage.getItem('token');if(token&&typeof token!=='undefined'){var decodedToken=atob(token);return JSON.parse(decodedToken);}sessionStorage.setItem('token','');return{};};this.setSessionId=function(sessionId){sessionStorage.setItem('sessionId',sessionId);};this.getSessionId=function(){return sessionStorage.getItem('sessionId');};};exports.default=Storage;module.exports=exports['default'];

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(524);
var formats = __webpack_require__(525);

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly,
    charset
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (Array.isArray(obj)) {
            pushToArray(values, stringify(
                obj[key],
                generateArrayPrefix(prefix, key),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        } else {
            pushToArray(values, stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        }
    }

    return values;
};

module.exports = function (object, opts) {
    var obj = object;
    var options = opts ? utils.assign({}, opts) : {};

    if (options.encoder !== null && options.encoder !== undefined && typeof options.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var delimiter = typeof options.delimiter === 'undefined' ? defaults.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : defaults.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : defaults.encode;
    var encoder = typeof options.encoder === 'function' ? options.encoder : defaults.encoder;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var allowDots = typeof options.allowDots === 'undefined' ? defaults.allowDots : !!options.allowDots;
    var serializeDate = typeof options.serializeDate === 'function' ? options.serializeDate : defaults.serializeDate;
    var encodeValuesOnly = typeof options.encodeValuesOnly === 'boolean' ? options.encodeValuesOnly : defaults.encodeValuesOnly;
    var charset = options.charset || defaults.charset;
    if (typeof options.charset !== 'undefined' && options.charset !== 'utf-8' && options.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof options.format === 'undefined') {
        options.format = formats['default'];
    } else if (!Object.prototype.hasOwnProperty.call(formats.formatters, options.format)) {
        throw new TypeError('Unknown format option provided.');
    }
    var formatter = formats.formatters[options.format];
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (Array.isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    } else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encode ? encoder : null,
            filter,
            sort,
            allowDots,
            serializeDate,
            formatter,
            encodeValuesOnly,
            charset
        ));
    }

    var joined = keys.join(delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(524);

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset);
            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset);
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }
        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

module.exports = function (str, opts) {
    var options = opts ? utils.assign({}, opts) : {};

    if (options.decoder !== null && options.decoder !== undefined && typeof options.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    options.ignoreQueryPrefix = options.ignoreQueryPrefix === true;
    options.delimiter = typeof options.delimiter === 'string' || utils.isRegExp(options.delimiter) ? options.delimiter : defaults.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : defaults.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : defaults.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.decoder = typeof options.decoder === 'function' ? options.decoder : defaults.decoder;
    options.allowDots = typeof options.allowDots === 'undefined' ? defaults.allowDots : !!options.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : defaults.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : defaults.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : defaults.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : defaults.strictNullHandling;

    if (typeof options.charset !== 'undefined' && options.charset !== 'utf-8' && options.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    if (typeof options.charset === 'undefined') {
        options.charset = defaults.charset;
    }

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var bind = __webpack_require__(527);
var Axios = __webpack_require__(1205);
var defaults = __webpack_require__(342);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(532);
axios.CancelToken = __webpack_require__(1219);
axios.isCancel = __webpack_require__(531);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1220);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(342);
var utils = __webpack_require__(65);
var InterceptorManager = __webpack_require__(1214);
var dispatchRequest = __webpack_require__(1215);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(530);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);
var transformData = __webpack_require__(1216);
var isCancel = __webpack_require__(531);
var defaults = __webpack_require__(342);
var isAbsoluteURL = __webpack_require__(1217);
var combineURLs = __webpack_require__(1218);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(65);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(532);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloClient", function() { return ApolloClient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObservableQuery", function() { return ObservableQuery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NetworkStatus", function() { return NetworkStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isApolloError", function() { return isApolloError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloError", function() { return ApolloError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FetchType", function() { return FetchType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_utilities__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_apollo_link__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_symbol_observable__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ts_invariant__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_apollo_link_dedup__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_language_visitor__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_graphql_language_visitor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_graphql_language_visitor__);








var NetworkStatus;
(function (NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})(NetworkStatus || (NetworkStatus = {}));
function isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}

var Observable = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[__WEBPACK_IMPORTED_MODULE_3_symbol_observable__["a" /* default */]] = function () {
        return this;
    };
    Observable.prototype['@@observable'] = function () {
        return this;
    };
    return Observable;
}(__WEBPACK_IMPORTED_MODULE_2_apollo_link__["Observable"]));

function isApolloError(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var generateErrorMessage = function (err) {
    var message = '';
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) {
        err.graphQLErrors.forEach(function (graphQLError) {
            var errorMessage = graphQLError
                ? graphQLError.message
                : 'Error message not found.';
            message += "GraphQL error: " + errorMessage + "\n";
        });
    }
    if (err.networkError) {
        message += 'Network error: ' + err.networkError.message + '\n';
    }
    message = message.replace(/\n$/, '');
    return message;
};
var ApolloError = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) {
            _this.message = generateErrorMessage(_this);
        }
        else {
            _this.message = errorMessage;
        }
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error));

var FetchType;
(function (FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})(FetchType || (FetchType = {}));

var hasError = function (storeValue, policy) {
    if (policy === void 0) { policy = 'none'; }
    return storeValue &&
        ((storeValue.graphQLErrors &&
            storeValue.graphQLErrors.length > 0 &&
            policy === 'none') ||
            storeValue.networkError);
};
var ObservableQuery = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function (observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        _this.queryManager = queryManager;
        _this.observers = [];
        _this.subscriptionHandles = [];
        return _this;
    }
    ObservableQuery.prototype.result = function () {
        var that = this;
        return new Promise(function (resolve, reject) {
            var subscription;
            var observer = {
                next: function (result) {
                    resolve(result);
                    if (!that.observers.some(function (obs) { return obs !== observer; })) {
                        that.queryManager.removeQuery(that.queryId);
                    }
                    setTimeout(function () {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: function (error) {
                    reject(error);
                },
            };
            subscription = that.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function () {
        var result = this.getCurrentResult();
        if (result.data === undefined) {
            result.data = {};
        }
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function () {
        if (this.isTornDown) {
            return {
                data: this.lastError
                    ? undefined
                    : this.lastResult
                        ? this.lastResult.data
                        : undefined,
                error: this.lastError,
                loading: false,
                networkStatus: NetworkStatus.error,
            };
        }
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        if (hasError(queryStoreValue, this.options.errorPolicy)) {
            return {
                data: undefined,
                loading: false,
                networkStatus: queryStoreValue.networkStatus,
                error: new ApolloError({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError,
                }),
            };
        }
        if (queryStoreValue && queryStoreValue.variables) {
            this.options.variables = Object.assign({}, this.options.variables, queryStoreValue.variables);
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryLoading = !queryStoreValue ||
            queryStoreValue.networkStatus === NetworkStatus.loading;
        var loading = (this.options.fetchPolicy === 'network-only' && queryLoading) ||
            (partial && this.options.fetchPolicy !== 'cache-only');
        var networkStatus;
        if (queryStoreValue) {
            networkStatus = queryStoreValue.networkStatus;
        }
        else {
            networkStatus = loading ? NetworkStatus.loading : NetworkStatus.ready;
        }
        var result = {
            data: data,
            loading: isNetworkRequestInFlight(networkStatus),
            networkStatus: networkStatus,
        };
        if (queryStoreValue &&
            queryStoreValue.graphQLErrors &&
            this.options.errorPolicy === 'all') {
            result.errors = queryStoreValue.graphQLErrors;
        }
        if (!partial) {
            this.lastResult = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, result, { stale: false });
            this.lastResultSnapshot = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["d" /* cloneDeep */])(this.lastResult);
        }
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, result, { partial: partial });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function (newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot &&
            newResult &&
            snapshot.networkStatus === newResult.networkStatus &&
            snapshot.stale === newResult.stale &&
            Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["p" /* isEqual */])(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function () {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function () {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function () {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.refetch = function (variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') {
            return Promise.reject(new Error('cache-only fetchPolicy option should not be used together with query refetch.'));
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["p" /* isEqual */])(this.variables, variables)) {
            this.variables = Object.assign({}, this.variables, variables);
        }
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["p" /* isEqual */])(this.options.variables, this.variables)) {
            this.options.variables = Object.assign({}, this.options.variables, this.variables);
        }
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        var combinedOptions = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.options, { fetchPolicy: isNetworkFetchPolicy ? fetchPolicy : 'network-only' });
        return this.queryManager
            .fetchQuery(this.queryId, combinedOptions, FetchType.refetch)
            .then(function (result) { return result; });
    };
    ObservableQuery.prototype.fetchMore = function (fetchMoreOptions) {
        var _this = this;
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(fetchMoreOptions.updateQuery) : invariant(fetchMoreOptions.updateQuery, 'updateQuery option is required. This function defines how to update the query data with the new results.');
        var combinedOptions;
        return Promise.resolve()
            .then(function () {
            var qid = _this.queryManager.generateQueryId();
            if (fetchMoreOptions.query) {
                combinedOptions = fetchMoreOptions;
            }
            else {
                combinedOptions = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, _this.options, fetchMoreOptions, { variables: Object.assign({}, _this.variables, fetchMoreOptions.variables) });
            }
            combinedOptions.fetchPolicy = 'network-only';
            return _this.queryManager.fetchQuery(qid, combinedOptions, FetchType.normal, _this.queryId);
        })
            .then(function (fetchMoreResult) {
            _this.updateQuery(function (previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables,
                });
            });
            return fetchMoreResult;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function (options) {
        var _this = this;
        var subscription = this.queryManager
            .startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
        })
            .subscribe({
            next: function (subscriptionData) {
                if (options.updateQuery) {
                    _this.updateQuery(function (previous, _a) {
                        var variables = _a.variables;
                        return options.updateQuery(previous, {
                            subscriptionData: subscriptionData,
                            variables: variables,
                        });
                    });
                }
            },
            error: function (err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                console.error('Unhandled GraphQL subscription error', err);
            },
        });
        this.subscriptionHandles.push(subscription);
        return function () {
            var i = _this.subscriptionHandles.indexOf(subscription);
            if (i >= 0) {
                _this.subscriptionHandles.splice(i, 1);
                subscription.unsubscribe();
            }
        };
    };
    ObservableQuery.prototype.setOptions = function (opts) {
        var oldOptions = this.options;
        this.options = Object.assign({}, this.options, opts);
        if (opts.pollInterval) {
            this.startPolling(opts.pollInterval);
        }
        else if (opts.pollInterval === 0) {
            this.stopPolling();
        }
        var tryFetch = (oldOptions.fetchPolicy !== 'network-only' &&
            opts.fetchPolicy === 'network-only') ||
            (oldOptions.fetchPolicy === 'cache-only' &&
                opts.fetchPolicy !== 'cache-only') ||
            (oldOptions.fetchPolicy === 'standby' &&
                opts.fetchPolicy !== 'standby') ||
            false;
        return this.setVariables(this.options.variables, tryFetch, opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function (variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) { tryFetch = false; }
        if (fetchResults === void 0) { fetchResults = true; }
        this.isTornDown = false;
        var newVariables = variables ? variables : this.variables;
        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["p" /* isEqual */])(newVariables, this.variables) && !tryFetch) {
            if (this.observers.length === 0 || !fetchResults) {
                return new Promise(function (resolve) { return resolve(); });
            }
            return this.result();
        }
        else {
            this.variables = newVariables;
            this.options.variables = newVariables;
            if (this.observers.length === 0) {
                return new Promise(function (resolve) { return resolve(); });
            }
            return this.queryManager
                .fetchQuery(this.queryId, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.options, { variables: this.variables }))
                .then(function (result) { return result; });
        }
    };
    ObservableQuery.prototype.updateQuery = function (mapFn) {
        var _a = this.queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["y" /* tryFunctionOrLogError */])(function () {
            return mapFn(previousResult, { variables: variables });
        });
        if (newResult) {
            this.queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            this.queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function () {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function (pollInterval) {
        assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.onSubscribe = function (observer) {
        var _this = this;
        if (observer._subscription &&
            observer._subscription._observer &&
            !observer._subscription._observer.error) {
            observer._subscription._observer.error = function (error) {
                console.error('Unhandled error', error.message, error.stack);
            };
        }
        this.observers.push(observer);
        if (observer.next && this.lastResult)
            observer.next(this.lastResult);
        if (observer.error && this.lastError)
            observer.error(this.lastError);
        if (this.observers.length === 1)
            this.setUpQuery();
        return function () {
            _this.observers = _this.observers.filter(function (obs) { return obs !== observer; });
            if (_this.observers.length === 0) {
                _this.tearDownQuery();
            }
        };
    };
    ObservableQuery.prototype.setUpQuery = function () {
        var _this = this;
        if (this.shouldSubscribe) {
            this.queryManager.addObservableQuery(this.queryId, this);
        }
        if (!!this.options.pollInterval) {
            assertNotCacheFirstOrOnly(this);
            this.queryManager.startPollingQuery(this.options, this.queryId);
        }
        var observer = {
            next: function (result) {
                _this.lastResult = result;
                _this.lastResultSnapshot = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["d" /* cloneDeep */])(result);
                _this.observers.forEach(function (obs) { return obs.next && obs.next(result); });
            },
            error: function (error) {
                _this.lastError = error;
                _this.observers.forEach(function (obs) { return obs.error && obs.error(error); });
            },
        };
        this.queryManager.startQuery(this.queryId, this.options, this.queryManager.queryListenerForObserver(this.queryId, this.options, observer));
    };
    ObservableQuery.prototype.tearDownQuery = function () {
        this.isTornDown = true;
        this.queryManager.stopPollingQuery(this.queryId);
        this.subscriptionHandles.forEach(function (sub) { return sub.unsubscribe(); });
        this.subscriptionHandles = [];
        this.queryManager.removeObservableQuery(this.queryId);
        this.queryManager.stopQuery(this.queryId);
        this.observers = [];
    };
    return ObservableQuery;
}(Observable));
function assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
     true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only') : invariant(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 'Queries that specify the cache-first and cache-only fetchPolicies cannot also be polling queries.');
}

var MutationStore = (function () {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function () {
        return this.store;
    };
    MutationStore.prototype.get = function (mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function (mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null,
        };
    };
    MutationStore.prototype.markMutationError = function (mutationId, error) {
        var mutation = this.store[mutationId];
        if (!mutation) {
            return;
        }
        mutation.loading = false;
        mutation.error = error;
    };
    MutationStore.prototype.markMutationResult = function (mutationId) {
        var mutation = this.store[mutationId];
        if (!mutation) {
            return;
        }
        mutation.loading = false;
        mutation.error = null;
    };
    MutationStore.prototype.reset = function () {
        this.store = {};
    };
    return MutationStore;
}());

var QueryStore = (function () {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function () {
        return this.store;
    };
    QueryStore.prototype.get = function (queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function (query) {
        var previousQuery = this.store[query.queryId];
        if (previousQuery &&
            previousQuery.document !== query.document &&
            !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["p" /* isEqual */])(previousQuery.document, query.document)) {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["InvariantError"]() : new InvariantError('Internal Error: may not update existing query string in store');
        }
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables &&
            previousQuery &&
            previousQuery.networkStatus !== NetworkStatus.loading) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["p" /* isEqual */])(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) {
            networkStatus = NetworkStatus.setVariables;
        }
        else if (query.isPoll) {
            networkStatus = NetworkStatus.poll;
        }
        else if (query.isRefetch) {
            networkStatus = NetworkStatus.refetch;
        }
        else {
            networkStatus = NetworkStatus.loading;
        }
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) {
            graphQLErrors = previousQuery.graphQLErrors;
        }
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata,
        };
        if (typeof query.fetchMoreForQueryId === 'string' &&
            this.store[query.fetchMoreForQueryId]) {
            this.store[query.fetchMoreForQueryId].networkStatus =
                NetworkStatus.fetchMore;
        }
    };
    QueryStore.prototype.markQueryResult = function (queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors =
            result.errors && result.errors.length ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = NetworkStatus.ready;
        if (typeof fetchMoreForQueryId === 'string' &&
            this.store[fetchMoreForQueryId]) {
            this.store[fetchMoreForQueryId].networkStatus = NetworkStatus.ready;
        }
    };
    QueryStore.prototype.markQueryError = function (queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = NetworkStatus.error;
        if (typeof fetchMoreForQueryId === 'string') {
            this.markQueryResultClient(fetchMoreForQueryId, true);
        }
    };
    QueryStore.prototype.markQueryResultClient = function (queryId, complete) {
        if (!this.store || !this.store[queryId])
            return;
        this.store[queryId].networkError = null;
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = complete
            ? NetworkStatus.ready
            : NetworkStatus.loading;
    };
    QueryStore.prototype.stopQuery = function (queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function (observableQueryIds) {
        var _this = this;
        this.store = Object.keys(this.store)
            .filter(function (queryId) {
            return observableQueryIds.indexOf(queryId) > -1;
        })
            .reduce(function (res, key) {
            res[key] = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, _this.store[key], { networkStatus: NetworkStatus.loading });
            return res;
        }, {});
    };
    return QueryStore;
}());

function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

var LocalState = (function () {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) {
            this.client = client;
        }
        if (resolvers) {
            this.addResolvers(resolvers);
        }
        if (fragmentMatcher) {
            this.setFragmentMatcher(fragmentMatcher);
        }
    }
    LocalState.prototype.addResolvers = function (resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) {
            resolvers.forEach(function (resolverGroup) {
                _this.resolvers = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* mergeDeep */])(_this.resolvers, resolverGroup);
            });
        }
        else {
            this.resolvers = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["s" /* mergeDeep */])(this.resolvers, resolvers);
        }
    };
    LocalState.prototype.setResolvers = function (resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function () {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function (_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_c) {
                if (document) {
                    return [2, this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function (localResult) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, remoteResult, { data: localResult.result })); })];
                }
                return [2, remoteResult];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function (fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function () {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function (document) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["o" /* hasDirectives */])(['client'], document)) {
            if (this.resolvers) {
                return document;
            }
            "production" === "production" || __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"].warn('Found @client directives in query but no client resolvers were specified. ' +
                'You can now pass apollo-link-state resolvers to the ApolloClient constructor.');
        }
        return null;
    };
    LocalState.prototype.serverQuery = function (document) {
        return this.resolvers ? Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["u" /* removeClientSetsFromDocument */])(document) : document;
    };
    LocalState.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var cache = this.cache;
        var newContext = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, context, { cache: cache, getCacheKey: function (obj) {
                if (cache.config) {
                    return cache.config.dataIdFromObject(obj);
                }
                else {
                     true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(false) : invariant(false, 'To use context.getCacheKey, you need to use a cache that has ' +
                        'a configurable dataIdFromObject, like apollo-cache-inmemory.');
                }
            } });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function (document, variables, context) {
        if (variables === void 0) { variables = {}; }
        if (context === void 0) { context = {}; }
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                if (document) {
                    return [2, this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function (data) { return (Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, variables, data.exportedVariables)); })];
                }
                return [2, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, variables)];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function (document) {
        var forceResolvers = false;
        Object(__WEBPACK_IMPORTED_MODULE_6_graphql_language_visitor__["visit"])(document, {
            Directive: {
                enter: function (node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function (arg) {
                            return arg.name.value === 'always' &&
                                arg.value.kind === 'BooleanValue' &&
                                arg.value.value === true;
                        });
                        if (forceResolvers) {
                            return __WEBPACK_IMPORTED_MODULE_6_graphql_language_visitor__["BREAK"];
                        }
                    }
                },
            },
        });
        return forceResolvers;
    };
    LocalState.prototype.shouldForceResolver = function (field) {
        return this.shouldForceResolvers(field);
    };
    LocalState.prototype.buildRootValueFromCache = function (document, variables) {
        return this.cache.diff({
            query: Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["c" /* buildQueryFromSelectionSet */])(document),
            variables: variables,
            optimistic: false,
        }).result;
    };
    LocalState.prototype.resolveDocument = function (document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) { context = {}; }
        if (variables === void 0) { variables = {}; }
        if (fragmentMatcher === void 0) { fragmentMatcher = function () { return true; }; }
        if (onlyRunForcedResolvers === void 0) { onlyRunForcedResolvers = false; }
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_b) {
                mainDefinition = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["h" /* getMainDefinition */])(document);
                fragments = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["g" /* getFragmentDefinitions */])(document);
                fragmentMap = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["e" /* createFragmentMap */])(fragments);
                definitionOperation = mainDefinition
                    .operation;
                defaultOperationType = definitionOperation
                    ? capitalizeFirstLetter(definitionOperation)
                    : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, context, { cache: cache,
                        client: client }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers,
                };
                return [2, this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function (result) { return ({
                        result: result,
                        exportedVariables: execContext.exportedVariables,
                    }); })];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function (selectionSet, rootValue, execContext) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [rootValue];
                execute = function (selection) { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
                    var fragment, typeCondition;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["x" /* shouldInclude */])(selection, variables)) {
                            return [2];
                        }
                        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["q" /* isField */])(selection)) {
                            return [2, this.resolveField(selection, rootValue, execContext).then(function (fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') {
                                        resultsToMerge.push((_a = {},
                                            _a[Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["w" /* resultKeyNameFromField */])(selection)] = fieldResult,
                                            _a));
                                    }
                                })];
                        }
                        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["r" /* isInlineFragment */])(selection)) {
                            fragment = selection;
                        }
                        else {
                            fragment = fragmentMap[selection.name.value];
                             true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(fragment) : invariant(fragment, "No fragment named " + selection.name.value);
                        }
                        if (fragment && fragment.typeCondition) {
                            typeCondition = fragment.typeCondition.name.value;
                            if (execContext.fragmentMatcher(rootValue, typeCondition, context)) {
                                return [2, this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function (fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })];
                            }
                        }
                        return [2];
                    });
                }); };
                return [2, Promise.all(selectionSet.selections.map(execute)).then(function () {
                        return Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["t" /* mergeDeepArray */])(resultsToMerge);
                    })];
            });
        });
    };
    LocalState.prototype.resolveField = function (field, rootValue, execContext) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["w" /* resultKeyNameFromField */])(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers ||
                    this.shouldForceResolver(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) {
                            resultPromise = Promise.resolve(resolve(rootValue, Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["a" /* argumentsObjectFromField */])(field, variables), execContext.context, { field: field }));
                        }
                    }
                }
                return [2, resultPromise.then(function (result) {
                        if (result === void 0) { result = defaultResult; }
                        if (field.directives) {
                            field.directives.forEach(function (directive) {
                                if (directive.name.value === 'export' && directive.arguments) {
                                    directive.arguments.forEach(function (arg) {
                                        if (arg.name.value === 'as' && arg.value.kind === 'StringValue') {
                                            execContext.exportedVariables[arg.value.value] = result;
                                        }
                                    });
                                }
                            });
                        }
                        if (!field.selectionSet) {
                            return result;
                        }
                        if (result == null) {
                            return result;
                        }
                        if (Array.isArray(result)) {
                            return _this.resolveSubSelectedArray(field, result, execContext);
                        }
                        if (field.selectionSet) {
                            return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                        }
                    })];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function (field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function (item) {
            if (item === null) {
                return null;
            }
            if (Array.isArray(item)) {
                return _this.resolveSubSelectedArray(field, item, execContext);
            }
            if (field.selectionSet) {
                return _this.resolveSelectionSet(field.selectionSet, item, execContext);
            }
        }));
    };
    return LocalState;
}());

var QueryManager = (function () {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function () { return undefined; } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState;
        this.mutationStore = new MutationStore();
        this.queryStore = new QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.queryIdsByName = {};
        this.pollingInfoByQueryId = new Map();
        this.nextPoll = null;
        this.link = link;
        this.deduplicator = __WEBPACK_IMPORTED_MODULE_2_apollo_link__["ApolloLink"].from([new __WEBPACK_IMPORTED_MODULE_5_apollo_link_dedup__["a" /* DedupLink */](), link]);
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new LocalState({ cache: store.getCache() });
        this.ssrMode = ssrMode;
    }
    QueryManager.prototype.stop = function () {
        var _this = this;
        this.queries.forEach(function (_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function (reject) {
            reject(new Error('QueryManager stopped while query was in flight'));
        });
    };
    QueryManager.prototype.mutate = function (_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var mutationId, cache, generateUpdateQueriesInfo, updatedVariables, _f;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_g) {
                switch (_g.label) {
                    case 0:
                         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(mutation) : invariant(mutation, 'mutation option is required. You must specify your GraphQL document in the mutation option.');
                         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(!fetchPolicy || fetchPolicy === 'no-cache') : invariant(!fetchPolicy || fetchPolicy === 'no-cache', "fetchPolicy for mutations currently only supports the 'no-cache' policy");
                        mutationId = this.generateQueryId();
                        cache = this.dataStore.getCache();
                        (mutation = cache.transformDocument(mutation)),
                            (variables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["b" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["f" /* getDefaultValues */])(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["i" /* getMutationDefinition */])(mutation)), variables));
                        this.setQuery(mutationId, function () { return ({ document: mutation }); });
                        generateUpdateQueriesInfo = function () {
                            var ret = {};
                            if (updateQueriesByName) {
                                Object.keys(updateQueriesByName).forEach(function (queryName) {
                                    return (_this.queryIdsByName[queryName] || []).forEach(function (queryId) {
                                        ret[queryId] = {
                                            updater: updateQueriesByName[queryName],
                                            query: _this.queryStore.get(queryId),
                                        };
                                    });
                                });
                            }
                            return ret;
                        };
                        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["n" /* hasClientExports */])(mutation)) return [3, 2];
                        return [4, this.localState.addExportedVariables(mutation, variables, context)];
                    case 1:
                        _f = _g.sent();
                        return [3, 3];
                    case 2:
                        _f = variables;
                        _g.label = 3;
                    case 3:
                        updatedVariables = _f;
                        this.mutationStore.initMutation(mutationId, mutation, updatedVariables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: updatedVariables || {},
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse,
                        });
                        this.broadcastQueries();
                        return [2, new Promise(function (resolve, reject) {
                                var storeResult;
                                var error;
                                var operation = _this.buildOperationForLink(mutation, updatedVariables, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, context, { optimisticResponse: optimisticResponse }));
                                var completeMutation = function () {
                                    if (error) {
                                        _this.mutationStore.markMutationError(mutationId, error);
                                    }
                                    _this.dataStore.markMutationComplete({
                                        mutationId: mutationId,
                                        optimisticResponse: optimisticResponse,
                                    });
                                    _this.broadcastQueries();
                                    if (error) {
                                        return Promise.reject(error);
                                    }
                                    if (typeof refetchQueries === 'function') {
                                        refetchQueries = refetchQueries(storeResult);
                                    }
                                    var refetchQueryPromises = [];
                                    for (var _i = 0, refetchQueries_1 = refetchQueries; _i < refetchQueries_1.length; _i++) {
                                        var refetchQuery = refetchQueries_1[_i];
                                        if (typeof refetchQuery === 'string') {
                                            var promise = _this.refetchQueryByName(refetchQuery);
                                            if (promise) {
                                                refetchQueryPromises.push(promise);
                                            }
                                            continue;
                                        }
                                        var queryOptions = {
                                            query: refetchQuery.query,
                                            variables: refetchQuery.variables,
                                            fetchPolicy: 'network-only',
                                        };
                                        if (refetchQuery.context) {
                                            queryOptions.context = refetchQuery.context;
                                        }
                                        refetchQueryPromises.push(_this.query(queryOptions));
                                    }
                                    return Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function () {
                                        _this.setQuery(mutationId, function () { return ({ document: null }); });
                                        if (errorPolicy === 'ignore' &&
                                            storeResult &&
                                            Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["m" /* graphQLResultHasError */])(storeResult)) {
                                            delete storeResult.errors;
                                        }
                                        return storeResult;
                                    });
                                };
                                var clientQuery = _this.localState.clientQuery(operation.query);
                                var serverQuery = _this.localState.serverQuery(operation.query);
                                if (serverQuery) {
                                    operation.query = serverQuery;
                                }
                                var obs = serverQuery
                                    ? Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link__["execute"])(_this.link, operation)
                                    : Observable.of({
                                        data: {},
                                    });
                                var self = _this;
                                var complete = false;
                                var handlingNext = false;
                                obs.subscribe({
                                    next: function (result) { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
                                        var updatedResult, context, variables;
                                        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    handlingNext = true;
                                                    if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["m" /* graphQLResultHasError */])(result) && errorPolicy === 'none') {
                                                        handlingNext = false;
                                                        error = new ApolloError({
                                                            graphQLErrors: result.errors,
                                                        });
                                                        return [2];
                                                    }
                                                    self.mutationStore.markMutationResult(mutationId);
                                                    updatedResult = result;
                                                    context = operation.context, variables = operation.variables;
                                                    if (!(clientQuery && Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["o" /* hasDirectives */])(['client'], clientQuery))) return [3, 2];
                                                    return [4, self.localState
                                                            .runResolvers({
                                                            document: clientQuery,
                                                            remoteResult: result,
                                                            context: context,
                                                            variables: variables,
                                                        })
                                                            .catch(function (error) {
                                                            handlingNext = false;
                                                            reject(error);
                                                            return result;
                                                        })];
                                                case 1:
                                                    updatedResult = _a.sent();
                                                    _a.label = 2;
                                                case 2:
                                                    if (fetchPolicy !== 'no-cache') {
                                                        self.dataStore.markMutationResult({
                                                            mutationId: mutationId,
                                                            result: updatedResult,
                                                            document: mutation,
                                                            variables: updatedVariables || {},
                                                            updateQueries: generateUpdateQueriesInfo(),
                                                            update: updateWithProxyFn,
                                                        });
                                                    }
                                                    storeResult = updatedResult;
                                                    handlingNext = false;
                                                    if (complete) {
                                                        completeMutation().then(resolve, reject);
                                                    }
                                                    return [2];
                                            }
                                        });
                                    }); },
                                    error: function (err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse,
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function () { return ({ document: null }); });
                                        reject(new ApolloError({
                                            networkError: err,
                                        }));
                                    },
                                    complete: function () {
                                        if (!handlingNext) {
                                            completeMutation().then(resolve, reject);
                                        }
                                        complete = true;
                                    },
                                });
                            })];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function (queryId, options, fetchType, fetchMoreForQueryId) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var _a, variables, _b, metadata, _c, fetchPolicy, _d, context, cache, query, updatedVariables, _e, updatedOptions, storeResult, needToFetch, _f, complete, result, shouldFetch, requestId, cancel, shouldDispatchClientResult, networkResult;
            var _this = this;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _a = options.variables, variables = _a === void 0 ? {} : _a, _b = options.metadata, metadata = _b === void 0 ? null : _b, _c = options.fetchPolicy, fetchPolicy = _c === void 0 ? 'cache-first' : _c, _d = options.context, context = _d === void 0 ? {} : _d;
                        cache = this.dataStore.getCache();
                        query = cache.transformDocument(options.query);
                        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["n" /* hasClientExports */])(query)) return [3, 2];
                        return [4, this.localState.addExportedVariables(query, variables, context)];
                    case 1:
                        _e = _g.sent();
                        return [3, 3];
                    case 2:
                        _e = variables;
                        _g.label = 3;
                    case 3:
                        updatedVariables = _e;
                        updatedOptions = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, options, { variables: updatedVariables });
                        needToFetch = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        if (fetchType !== FetchType.refetch &&
                            fetchPolicy !== 'network-only' &&
                            fetchPolicy !== 'no-cache') {
                            _f = this.dataStore.getCache().diff({
                                query: query,
                                variables: updatedVariables,
                                returnPartialData: true,
                                optimistic: false,
                            }), complete = _f.complete, result = _f.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["o" /* hasDirectives */])(['live'], query))
                            shouldFetch = true;
                        requestId = this.generateRequestId();
                        cancel = this.updateQueryWatch(queryId, query, updatedOptions);
                        this.setQuery(queryId, function () { return ({
                            document: query,
                            lastRequestId: requestId,
                            invalidated: true,
                            cancel: cancel,
                        }); });
                        this.invalidate(true, fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: updatedVariables,
                            isPoll: fetchType === FetchType.poll,
                            isRefetch: fetchType === FetchType.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId,
                        });
                        this.broadcastQueries();
                        shouldDispatchClientResult = !shouldFetch || fetchPolicy === 'cache-and-network';
                        if (shouldDispatchClientResult) {
                            this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                            this.invalidate(true, queryId, fetchMoreForQueryId);
                            this.broadcastQueries(this.localState.shouldForceResolvers(query));
                        }
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: updatedOptions,
                                fetchMoreForQueryId: fetchMoreForQueryId,
                            }).catch(function (error) {
                                if (isApolloError(error)) {
                                    throw error;
                                }
                                else {
                                    var lastRequestId = _this.getQuery(queryId).lastRequestId;
                                    if (requestId >= (lastRequestId || 1)) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(true, queryId, fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new ApolloError({ networkError: error });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') {
                                return [2, networkResult];
                            }
                            else {
                                networkResult.catch(function () { });
                            }
                        }
                        return [2, Promise.resolve({ data: storeResult })];
                }
            });
        });
    };
    QueryManager.prototype.queryListenerForObserver = function (queryId, options, observer) {
        var _this = this;
        var previouslyHadError = false;
        return function (queryStoreValue, newData, forceResolvers) { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
            var observableQuery, fetchPolicy, errorPolicy, lastResult, lastError, shouldNotifyIfLoading, networkStatusChanged, errorStatusChanged, apolloError_1, data, isMissing, document_1, readResult, resultFromStore, query, variables, context, updatedResult, e_1, error_1;
            return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.invalidate(false, queryId);
                        if (!queryStoreValue)
                            return [2];
                        observableQuery = this.getQuery(queryId).observableQuery;
                        fetchPolicy = observableQuery
                            ? observableQuery.options.fetchPolicy
                            : options.fetchPolicy;
                        if (fetchPolicy === 'standby')
                            return [2];
                        errorPolicy = observableQuery
                            ? observableQuery.options.errorPolicy
                            : options.errorPolicy;
                        lastResult = observableQuery
                            ? observableQuery.getLastResult()
                            : null;
                        lastError = observableQuery ? observableQuery.getLastError() : null;
                        shouldNotifyIfLoading = (!newData && queryStoreValue.previousVariables != null) ||
                            fetchPolicy === 'cache-only' ||
                            fetchPolicy === 'cache-and-network';
                        networkStatusChanged = Boolean(lastResult &&
                            queryStoreValue.networkStatus !== lastResult.networkStatus);
                        errorStatusChanged = errorPolicy &&
                            (lastError && lastError.graphQLErrors) !==
                                queryStoreValue.graphQLErrors &&
                            errorPolicy !== 'none';
                        if (!(!isNetworkRequestInFlight(queryStoreValue.networkStatus) ||
                            (networkStatusChanged && options.notifyOnNetworkStatusChange) ||
                            shouldNotifyIfLoading)) return [3, 8];
                        if (((!errorPolicy || errorPolicy === 'none') &&
                            queryStoreValue.graphQLErrors &&
                            queryStoreValue.graphQLErrors.length > 0) ||
                            queryStoreValue.networkError) {
                            apolloError_1 = new ApolloError({
                                graphQLErrors: queryStoreValue.graphQLErrors,
                                networkError: queryStoreValue.networkError,
                            });
                            previouslyHadError = true;
                            if (observer.error) {
                                try {
                                    observer.error(apolloError_1);
                                }
                                catch (e) {
                                    setTimeout(function () {
                                        throw e;
                                    }, 0);
                                }
                            }
                            else {
                                setTimeout(function () {
                                    throw apolloError_1;
                                }, 0);
                                if (false) {
                                    console.info('An unhandled error was thrown because no error handler is registered ' +
                                        'for the query ' +
                                        JSON.stringify(queryStoreValue.document));
                                }
                            }
                            return [2];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        data = void 0;
                        isMissing = void 0;
                        if (newData) {
                            if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') {
                                this.setQuery(queryId, function () { return ({ newData: null }); });
                            }
                            data = newData.result;
                            isMissing = !newData.complete || false;
                        }
                        else {
                            if (lastResult && lastResult.data && !errorStatusChanged) {
                                data = lastResult.data;
                                isMissing = false;
                            }
                            else {
                                document_1 = this.getQuery(queryId).document;
                                readResult = this.dataStore.getCache().diff({
                                    query: document_1,
                                    variables: queryStoreValue.previousVariables ||
                                        queryStoreValue.variables,
                                    optimistic: true,
                                });
                                data = readResult.result;
                                isMissing = !readResult.complete;
                            }
                        }
                        resultFromStore = void 0;
                        if (isMissing && fetchPolicy !== 'cache-only') {
                            resultFromStore = {
                                data: lastResult && lastResult.data,
                                loading: isNetworkRequestInFlight(queryStoreValue.networkStatus),
                                networkStatus: queryStoreValue.networkStatus,
                                stale: true,
                            };
                        }
                        else {
                            resultFromStore = {
                                data: data,
                                loading: isNetworkRequestInFlight(queryStoreValue.networkStatus),
                                networkStatus: queryStoreValue.networkStatus,
                                stale: false,
                            };
                        }
                        if (errorPolicy === 'all' &&
                            queryStoreValue.graphQLErrors &&
                            queryStoreValue.graphQLErrors.length > 0) {
                            resultFromStore.errors = queryStoreValue.graphQLErrors;
                        }
                        if (!observer.next) return [3, 6];
                        if (!(previouslyHadError ||
                            !observableQuery ||
                            observableQuery.isDifferentFromLastResult(resultFromStore))) return [3, 6];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, , 6]);
                        if (!forceResolvers) return [3, 4];
                        query = options.query, variables = options.variables, context = options.context;
                        return [4, this.localState.runResolvers({
                                document: query,
                                remoteResult: resultFromStore,
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: forceResolvers,
                            })];
                    case 3:
                        updatedResult = _a.sent();
                        resultFromStore = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, resultFromStore, updatedResult);
                        _a.label = 4;
                    case 4:
                        observer.next(resultFromStore);
                        return [3, 6];
                    case 5:
                        e_1 = _a.sent();
                        setTimeout(function () {
                            throw e_1;
                        }, 0);
                        return [3, 6];
                    case 6:
                        previouslyHadError = false;
                        return [3, 8];
                    case 7:
                        error_1 = _a.sent();
                        previouslyHadError = true;
                        if (observer.error)
                            observer.error(new ApolloError({ networkError: error_1 }));
                        return [2];
                    case 8: return [2];
                }
            });
        }); };
    };
    QueryManager.prototype.watchQuery = function (options, shouldSubscribe) {
        if (shouldSubscribe === void 0) { shouldSubscribe = true; }
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(options.fetchPolicy !== 'standby') : invariant(options.fetchPolicy !== 'standby', 'client.watchQuery cannot be called with fetchPolicy set to "standby"');
        var queryDefinition = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["l" /* getQueryDefinition */])(options.query);
        if (queryDefinition.variableDefinitions &&
            queryDefinition.variableDefinitions.length) {
            var defaultValues = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["f" /* getDefaultValues */])(queryDefinition);
            options.variables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["b" /* assign */])({}, defaultValues, options.variables);
        }
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') {
            options.notifyOnNetworkStatusChange = false;
        }
        var transformedOptions = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, options);
        return new ObservableQuery({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe,
        });
    };
    QueryManager.prototype.query = function (options) {
        var _this = this;
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(options.query) : invariant(options.query, 'query option is required. You must specify your GraphQL document ' +
            'in the query option.');
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(options.query.kind === 'Document') : invariant(options.query.kind === 'Document', 'You must wrap the query string in a "gql" tag.');
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(!options.returnPartialData) : invariant(!options.returnPartialData, 'returnPartialData option only supported on watchQuery.');
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(!options.pollInterval) : invariant(!options.pollInterval, 'pollInterval option only supported on watchQuery.');
        return new Promise(function (resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery
                .result()
                .then(resolve, reject)
                .then(function () {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function () {
        var queryId = this.idCounter.toString();
        this.idCounter++;
        return queryId;
    };
    QueryManager.prototype.stopQueryInStore = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function (queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(true, queryId);
    };
    QueryManager.prototype.addQueryListener = function (queryId, listener) {
        this.setQuery(queryId, function (_a) {
            var _b = _a.listeners, listeners = _b === void 0 ? [] : _b;
            return ({
                listeners: listeners.concat([listener]),
                invalidated: false,
            });
        });
    };
    QueryManager.prototype.updateQueryWatch = function (queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel)
            cancel();
        var previousResult = function () {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) {
                    previousResult = lastResult.data;
                }
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function (newData) {
                _this.setQuery(queryId, function () { return ({ invalidated: true, newData: newData }); });
            },
        });
    };
    QueryManager.prototype.addObservableQuery = function (queryId, observableQuery) {
        this.setQuery(queryId, function () { return ({ observableQuery: observableQuery }); });
        var queryDef = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["l" /* getQueryDefinition */])(observableQuery.options.query);
        if (queryDef.name && queryDef.name.value) {
            var queryName = queryDef.name.value;
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName] || [];
            this.queryIdsByName[queryName].push(observableQuery.queryId);
        }
    };
    QueryManager.prototype.removeObservableQuery = function (queryId) {
        var _a = this.getQuery(queryId), observableQuery = _a.observableQuery, cancel = _a.cancel;
        if (cancel)
            cancel();
        if (!observableQuery)
            return;
        var definition = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["l" /* getQueryDefinition */])(observableQuery.options.query);
        var queryName = definition.name ? definition.name.value : null;
        this.setQuery(queryId, function () { return ({ observableQuery: null }); });
        if (queryName) {
            this.queryIdsByName[queryName] = this.queryIdsByName[queryName].filter(function (val) {
                return !(observableQuery.queryId === val);
            });
        }
    };
    QueryManager.prototype.clearStore = function () {
        this.fetchQueryRejectFns.forEach(function (reject) {
            reject(new Error('Store reset while query was in flight(not completed in link chain)'));
        });
        var resetIds = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery)
                resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        var reset = this.dataStore.reset();
        return reset;
    };
    QueryManager.prototype.resetStore = function () {
        var _this = this;
        return this.clearStore().then(function () {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function (includeStandby) {
        var observableQueryPromises = this.getObservableQueryPromises(includeStandby);
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.startQuery = function (queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options)
            .catch(function () { return undefined; });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function (options) {
        var _this = this;
        var query = options.query;
        var isCacheEnabled = !(options.fetchPolicy && options.fetchPolicy === 'no-cache');
        var cache = this.dataStore.getCache();
        var transformedDoc = cache.transformDocument(query);
        var variables = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["b" /* assign */])({}, Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["f" /* getDefaultValues */])(Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["j" /* getOperationDefinition */])(query)), options.variables);
        var updatedVariables = variables;
        var sub;
        var observers = [];
        var clientQuery = this.localState.clientQuery(transformedDoc);
        return new Observable(function (observer) {
            observers.push(observer);
            if (observers.length === 1) {
                var activeNextCalls_1 = 0;
                var complete_1 = false;
                var handler_1 = {
                    next: function (result) { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
                        var updatedResult;
                        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    activeNextCalls_1 += 1;
                                    updatedResult = result;
                                    if (!(clientQuery && Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["o" /* hasDirectives */])(['client'], clientQuery))) return [3, 2];
                                    return [4, this.localState.runResolvers({
                                            document: clientQuery,
                                            remoteResult: result,
                                            context: {},
                                            variables: updatedVariables,
                                        })];
                                case 1:
                                    updatedResult = _a.sent();
                                    _a.label = 2;
                                case 2:
                                    if (isCacheEnabled) {
                                        this.dataStore.markSubscriptionResult(updatedResult, transformedDoc, updatedVariables);
                                        this.broadcastQueries();
                                    }
                                    observers.forEach(function (obs) {
                                        if (Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["m" /* graphQLResultHasError */])(updatedResult) && obs.error) {
                                            obs.error(new ApolloError({
                                                graphQLErrors: updatedResult.errors,
                                            }));
                                        }
                                        else if (obs.next) {
                                            obs.next(updatedResult);
                                        }
                                        activeNextCalls_1 -= 1;
                                    });
                                    if (activeNextCalls_1 === 0 && complete_1) {
                                        handler_1.complete();
                                    }
                                    return [2];
                            }
                        });
                    }); },
                    error: function (error) {
                        observers.forEach(function (obs) {
                            if (obs.error) {
                                obs.error(error);
                            }
                        });
                    },
                    complete: function () {
                        if (activeNextCalls_1 === 0) {
                            observers.forEach(function (obs) {
                                if (obs.complete) {
                                    obs.complete();
                                }
                            });
                        }
                        complete_1 = true;
                    }
                };
                (function () { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
                    var updatedVariables, _a, serverQuery, operation;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["n" /* hasClientExports */])(transformedDoc)) return [3, 2];
                                return [4, this.localState.addExportedVariables(transformedDoc, variables)];
                            case 1:
                                _a = _b.sent();
                                return [3, 3];
                            case 2:
                                _a = variables;
                                _b.label = 3;
                            case 3:
                                updatedVariables = _a;
                                serverQuery = this.localState.serverQuery(transformedDoc);
                                if (serverQuery) {
                                    operation = this.buildOperationForLink(serverQuery, updatedVariables);
                                    sub = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link__["execute"])(this.link, operation).subscribe(handler_1);
                                }
                                else {
                                    sub = Observable.of({ data: {} }).subscribe(handler_1);
                                }
                                return [2];
                        }
                    });
                }); })();
            }
            return function () {
                observers = observers.filter(function (obs) { return obs !== observer; });
                if (observers.length === 0 && sub) {
                    sub.unsubscribe();
                }
            };
        });
    };
    QueryManager.prototype.stopQuery = function (queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function (queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function (queryId) {
        var subscriptions = this.getQuery(queryId).subscriptions;
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        subscriptions.forEach(function (x) { return x.unsubscribe(); });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function (observableQuery, optimistic) {
        if (optimistic === void 0) { optimistic = true; }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) {
            return { data: newData.result, partial: false };
        }
        else if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') {
            return { data: undefined, partial: false };
        }
        else {
            try {
                var data = this.dataStore.getCache().read({
                    query: query,
                    variables: variables,
                    previousResult: lastResult ? lastResult.data : undefined,
                    optimistic: optimistic,
                }) || undefined;
                return { data: data, partial: false };
            }
            catch (e) {
                return { data: undefined, partial: true };
            }
        }
    };
    QueryManager.prototype.getQueryWithPreviousResult = function (queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
             true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(foundObserveableQuery) : invariant(foundObserveableQuery, "ObservableQuery with this id doesn't exist: " + queryIdOrObservable);
            observableQuery = foundObserveableQuery;
        }
        else {
            observableQuery = queryIdOrObservable;
        }
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        var data = this.getCurrentQueryResult(observableQuery, false).data;
        return {
            previousResult: data,
            variables: variables,
            document: query,
        };
    };
    QueryManager.prototype.broadcastQueries = function (forceResolvers) {
        var _this = this;
        if (forceResolvers === void 0) { forceResolvers = false; }
        this.onBroadcast();
        this.queries.forEach(function (info, id) {
            if (!info.invalidated || !info.listeners)
                return;
            info.listeners
                .filter(function (x) { return !!x; })
                .forEach(function (listener) {
                listener(_this.queryStore.get(id), info.newData, forceResolvers);
            });
        });
    };
    QueryManager.prototype.getLocalState = function () {
        return this.localState;
    };
    QueryManager.prototype.getObservableQueryPromises = function (includeStandby) {
        var _this = this;
        var observableQueryPromises = [];
        this.queries.forEach(function (_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (!observableQuery)
                return;
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (fetchPolicy !== 'cache-only' &&
                (includeStandby || fetchPolicy !== 'standby')) {
                observableQueryPromises.push(observableQuery.refetch());
            }
            _this.setQuery(queryId, function () { return ({ newData: null }); });
            _this.invalidate(true, queryId);
        });
        return observableQueryPromises;
    };
    QueryManager.prototype.fetchRequest = function (_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, context = options.context, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function (resolve, reject) {
            var obs;
            var updatedContext = {};
            var clientQuery = _this.localState.clientQuery(document);
            var serverQuery = _this.localState.serverQuery(document);
            if (serverQuery) {
                var operation = _this.buildOperationForLink(serverQuery, variables, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, context, { forceFetch: !_this.queryDeduplication }));
                updatedContext = operation.context;
                obs = Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link__["execute"])(_this.deduplicator, operation);
            }
            else {
                updatedContext = _this.prepareContext(context);
                obs = Observable.of({ data: {} });
            }
            _this.fetchQueryRejectFns.set("fetchRequest:" + queryId, reject);
            var complete = false;
            var handlingNext = true;
            var subscriber = {
                next: function (result) { return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
                    var updatedResult, lastRequestId;
                    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                handlingNext = true;
                                updatedResult = result;
                                lastRequestId = this.getQuery(queryId).lastRequestId;
                                if (!(requestId >= (lastRequestId || 1))) return [3, 3];
                                if (!(clientQuery && Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["o" /* hasDirectives */])(['client'], clientQuery))) return [3, 2];
                                return [4, this.localState
                                        .runResolvers({
                                        document: clientQuery,
                                        remoteResult: result,
                                        context: updatedContext,
                                        variables: variables,
                                    })
                                        .catch(function (error) {
                                        handlingNext = false;
                                        reject(error);
                                        return result;
                                    })];
                            case 1:
                                updatedResult = _a.sent();
                                _a.label = 2;
                            case 2:
                                if (fetchPolicy !== 'no-cache') {
                                    try {
                                        this.dataStore.markQueryResult(updatedResult, document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
                                    }
                                    catch (e) {
                                        handlingNext = false;
                                        reject(e);
                                        return [2];
                                    }
                                }
                                else {
                                    this.setQuery(queryId, function () { return ({
                                        newData: { result: updatedResult.data, complete: true },
                                    }); });
                                }
                                this.queryStore.markQueryResult(queryId, updatedResult, fetchMoreForQueryId);
                                this.invalidate(true, queryId, fetchMoreForQueryId);
                                this.broadcastQueries();
                                _a.label = 3;
                            case 3:
                                if (updatedResult.errors && errorPolicy === 'none') {
                                    handlingNext = false;
                                    reject(new ApolloError({
                                        graphQLErrors: updatedResult.errors,
                                    }));
                                    return [2];
                                }
                                else if (errorPolicy === 'all') {
                                    errorsFromStore = updatedResult.errors;
                                }
                                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') {
                                    resultFromStore = updatedResult.data;
                                }
                                else {
                                    try {
                                        resultFromStore = this.dataStore.getCache().read({
                                            variables: variables,
                                            query: document,
                                            optimistic: false,
                                        });
                                    }
                                    catch (e) { }
                                }
                                handlingNext = false;
                                if (complete) {
                                    subscriber.complete();
                                }
                                return [2];
                        }
                    });
                }); },
                error: function (error) {
                    _this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
                    _this.setQuery(queryId, function (_a) {
                        var subscriptions = _a.subscriptions;
                        return ({
                            subscriptions: subscriptions.filter(function (x) { return x !== subscription; }),
                        });
                    });
                    reject(error);
                },
                complete: function () {
                    if (!handlingNext) {
                        _this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
                        _this.setQuery(queryId, function (_a) {
                            var subscriptions = _a.subscriptions;
                            return ({
                                subscriptions: subscriptions.filter(function (x) { return x !== subscription; }),
                            });
                        });
                        resolve({
                            data: resultFromStore,
                            errors: errorsFromStore,
                            loading: false,
                            networkStatus: NetworkStatus.ready,
                            stale: false,
                        });
                    }
                    complete = true;
                },
            };
            var subscription = obs.subscribe(subscriber);
            _this.setQuery(queryId, function (_a) {
                var subscriptions = _a.subscriptions;
                return ({
                    subscriptions: subscriptions.concat([subscription]),
                });
            });
        }).catch(function (error) {
            _this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
            throw error;
        });
    };
    QueryManager.prototype.refetchQueryByName = function (queryName) {
        var _this = this;
        var refetchedQueries = this.queryIdsByName[queryName];
        if (refetchedQueries === undefined)
            return;
        return Promise.all(refetchedQueries
            .map(function (id) { return _this.getQuery(id).observableQuery; })
            .filter(function (x) { return !!x; })
            .map(function (x) { return x.refetch(); }));
    };
    QueryManager.prototype.generateRequestId = function () {
        var requestId = this.idCounter;
        this.idCounter++;
        return requestId;
    };
    QueryManager.prototype.getQuery = function (queryId) {
        return (this.queries.get(queryId) || {
            listeners: [],
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: null,
            observableQuery: null,
            subscriptions: [],
        });
    };
    QueryManager.prototype.setQuery = function (queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, prev, updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function (invalidated, queryId, fetchMoreForQueryId) {
        if (queryId)
            this.setQuery(queryId, function () { return ({ invalidated: invalidated }); });
        if (fetchMoreForQueryId) {
            this.setQuery(fetchMoreForQueryId, function () { return ({ invalidated: invalidated }); });
        }
    };
    QueryManager.prototype.buildOperationForLink = function (document, variables, extraContext) {
        var cache = this.dataStore.getCache();
        return {
            query: cache.transformForLink
                ? cache.transformForLink(document)
                : document,
            variables: variables,
            operationName: Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["k" /* getOperationName */])(document) || undefined,
            context: this.prepareContext(extraContext),
        };
    };
    QueryManager.prototype.prepareContext = function (context) {
        if (context === void 0) { context = {}; }
        var newContext = this.localState.prepareContext(context);
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, newContext, { clientAwareness: this.clientAwareness });
    };
    QueryManager.prototype.checkInFlight = function (queryId) {
        var query = this.queryStore.get(queryId);
        return (query &&
            query.networkStatus !== NetworkStatus.ready &&
            query.networkStatus !== NetworkStatus.error);
    };
    QueryManager.prototype.startPollingQuery = function (options, queryId, listener) {
        var pollInterval = options.pollInterval;
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(pollInterval) : invariant(pollInterval, 'Attempted to start a polling query without a polling interval.');
        if (!this.ssrMode) {
            this.pollingInfoByQueryId.set(queryId, {
                interval: pollInterval,
                lastPollTimeMs: Date.now() - 10,
                options: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, options, { fetchPolicy: 'network-only' }),
            });
            if (listener) {
                this.addQueryListener(queryId, listener);
            }
            this.schedulePoll(pollInterval);
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function (queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    QueryManager.prototype.schedulePoll = function (timeLimitMs) {
        var _this = this;
        var now = Date.now();
        if (this.nextPoll) {
            if (timeLimitMs < this.nextPoll.time - now) {
                clearTimeout(this.nextPoll.timeout);
            }
            else {
                return;
            }
        }
        this.nextPoll = {
            time: now + timeLimitMs,
            timeout: setTimeout(function () {
                _this.nextPoll = null;
                var nextTimeLimitMs = Infinity;
                _this.pollingInfoByQueryId.forEach(function (info, queryId) {
                    if (info.interval < nextTimeLimitMs) {
                        nextTimeLimitMs = info.interval;
                    }
                    if (!_this.checkInFlight(queryId)) {
                        if (Date.now() - info.lastPollTimeMs >= info.interval) {
                            var updateLastPollTime = function () {
                                info.lastPollTimeMs = Date.now();
                            };
                            _this.fetchQuery(queryId, info.options, FetchType.poll).then(updateLastPollTime, updateLastPollTime);
                        }
                    }
                });
                if (isFinite(nextTimeLimitMs)) {
                    _this.schedulePoll(nextTimeLimitMs);
                }
            }, timeLimitMs),
        };
    };
    return QueryManager;
}());

var DataStore = (function () {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function () {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function (result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) { ignoreErrors = false; }
        var writeWithErrors = !Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["m" /* graphQLResultHasError */])(result);
        if (ignoreErrors && Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["m" /* graphQLResultHasError */])(result) && result.data) {
            writeWithErrors = true;
        }
        if (!fetchMoreForQueryId && writeWithErrors) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_QUERY',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markSubscriptionResult = function (result, document, variables) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["m" /* graphQLResultHasError */])(result)) {
            this.cache.write({
                result: result.data,
                dataId: 'ROOT_SUBSCRIPTION',
                query: document,
                variables: variables,
            });
        }
    };
    DataStore.prototype.markMutationInit = function (mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') {
                optimistic_1 = mutation.optimisticResponse(mutation.variables);
            }
            else {
                optimistic_1 = mutation.optimisticResponse;
            }
            var changeFn_1 = function () {
                _this.markMutationResult({
                    mutationId: mutation.mutationId,
                    result: { data: optimistic_1 },
                    document: mutation.document,
                    variables: mutation.variables,
                    updateQueries: mutation.updateQueries,
                    update: mutation.update,
                });
            };
            this.cache.recordOptimisticTransaction(function (c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    changeFn_1();
                }
                finally {
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function (mutation) {
        var _this = this;
        if (!Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["m" /* graphQLResultHasError */])(mutation.result)) {
            var cacheWrites_1 = [];
            cacheWrites_1.push({
                result: mutation.result.data,
                dataId: 'ROOT_MUTATION',
                query: mutation.document,
                variables: mutation.variables,
            });
            if (mutation.updateQueries) {
                Object.keys(mutation.updateQueries)
                    .filter(function (id) { return mutation.updateQueries[id]; })
                    .forEach(function (queryId) {
                    var _a = mutation.updateQueries[queryId], query = _a.query, updater = _a.updater;
                    var _b = _this.cache.diff({
                        query: query.document,
                        variables: query.variables,
                        returnPartialData: true,
                        optimistic: false,
                    }), currentQueryResult = _b.result, complete = _b.complete;
                    if (!complete) {
                        return;
                    }
                    var nextQueryResult = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["y" /* tryFunctionOrLogError */])(function () {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["k" /* getOperationName */])(query.document) || undefined,
                            queryVariables: query.variables,
                        });
                    });
                    if (nextQueryResult) {
                        cacheWrites_1.push({
                            result: nextQueryResult,
                            dataId: 'ROOT_QUERY',
                            query: query.document,
                            variables: query.variables,
                        });
                    }
                });
            }
            this.cache.performTransaction(function (c) {
                cacheWrites_1.forEach(function (write) { return c.write(write); });
            });
            var update_1 = mutation.update;
            if (update_1) {
                this.cache.performTransaction(function (c) {
                    Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["y" /* tryFunctionOrLogError */])(function () { return update_1(c, mutation.result); });
                });
            }
        }
    };
    DataStore.prototype.markMutationComplete = function (_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (!optimisticResponse)
            return;
        this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function (document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document,
        });
    };
    DataStore.prototype.reset = function () {
        return this.cache.reset();
    };
    return DataStore;
}());

var version = "2.5.1";

var hasSuggestedDevtools = false;
var ApolloClient = (function () {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        this.clientAwareness = {};
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) {
            link = __WEBPACK_IMPORTED_MODULE_2_apollo_link__["ApolloLink"].empty();
        }
        if (!link || !cache) {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_4_ts_invariant__["InvariantError"]() : new InvariantError("\n        In order to initialize Apollo Client, you must specify link & cache properties on the config object.\n        This is part of the required upgrade when migrating from Apollo Client 1.0 to Apollo Client 2.0.\n        For more information, please visit:\n          https://www.apollographql.com/docs/react/basics/setup.html\n        to help you get started.\n      ");
        }
        var supportedCache = new Map();
        var supportedDirectives = new __WEBPACK_IMPORTED_MODULE_2_apollo_link__["ApolloLink"](function (operation, forward) {
            var result = supportedCache.get(operation.query);
            if (!result) {
                result = Object(__WEBPACK_IMPORTED_MODULE_1_apollo_utilities__["v" /* removeConnectionDirectiveFromDocument */])(operation.query);
                supportedCache.set(operation.query, result);
                supportedCache.set(result, result);
            }
            operation.query = result;
            return forward(operation);
        });
        this.link = supportedDirectives.concat(link);
        this.cache = cache;
        this.store = new DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.ssrMode = ssrMode;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) {
            setTimeout(function () { return (_this.disableNetworkFetches = false); }, ssrForceFetchDelay);
        }
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = "production" !== 'production' &&
            typeof window !== 'undefined' &&
            !window.__APOLLO_CLIENT__;
        if (typeof connectToDevTools === 'undefined'
            ? defaultConnectToDevTools
            : connectToDevTools && typeof window !== 'undefined') {
            window.__APOLLO_CLIENT__ = this;
        }
        if (!hasSuggestedDevtools && "production" !== 'production') {
            hasSuggestedDevtools = true;
            if (typeof window !== 'undefined' &&
                window.document &&
                window.top === window.self) {
                if (typeof window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
                    if (window.navigator &&
                        window.navigator.userAgent &&
                        window.navigator.userAgent.indexOf('Chrome') > -1) {
                        console.debug('Download the Apollo DevTools ' +
                            'for a better development experience: ' +
                            'https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm');
                    }
                }
            }
        }
        this.version = version;
        if (clientAwarenessName) {
            this.clientAwareness.name = clientAwarenessName;
        }
        if (clientAwarenessVersion) {
            this.clientAwareness.version = clientAwarenessVersion;
        }
        this.localState = new LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher,
        });
    }
    ApolloClient.prototype.stop = function () {
        if (this.queryManager) {
            this.queryManager.stop();
        }
    };
    ApolloClient.prototype.watchQuery = function (options) {
        if (this.defaultOptions.watchQuery) {
            options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.defaultOptions.watchQuery, options);
        }
        if (this.disableNetworkFetches &&
            (options.fetchPolicy === 'network-only' ||
                options.fetchPolicy === 'cache-and-network')) {
            options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.initQueryManager().watchQuery(options);
    };
    ApolloClient.prototype.query = function (options) {
        if (this.defaultOptions.query) {
            options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.defaultOptions.query, options);
        }
         true ? Object(__WEBPACK_IMPORTED_MODULE_4_ts_invariant__["invariant"])(options.fetchPolicy !== 'cache-and-network') : invariant(options.fetchPolicy !== 'cache-and-network', 'cache-and-network fetchPolicy can only be used with watchQuery');
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') {
            options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, options, { fetchPolicy: 'cache-first' });
        }
        return this.initQueryManager().query(options);
    };
    ApolloClient.prototype.mutate = function (options) {
        if (this.defaultOptions.mutate) {
            options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.defaultOptions.mutate, options);
        }
        return this.initQueryManager().mutate(options);
    };
    ApolloClient.prototype.subscribe = function (options) {
        return this.initQueryManager().startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.initProxy().readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.initProxy().readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function (options) {
        var result = this.initProxy().writeQuery(options);
        this.initQueryManager().broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function (options) {
        var result = this.initProxy().writeFragment(options);
        this.initQueryManager().broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function (options) {
        var result = this.initProxy().writeData(options);
        this.initQueryManager().broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function (cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function (payload) {
        return Object(__WEBPACK_IMPORTED_MODULE_2_apollo_link__["execute"])(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function () {
        var _this = this;
        if (!this.queryManager) {
            this.queryManager = new QueryManager({
                link: this.link,
                store: this.store,
                queryDeduplication: this.queryDeduplication,
                ssrMode: this.ssrMode,
                clientAwareness: this.clientAwareness,
                localState: this.localState,
                onBroadcast: function () {
                    if (_this.devToolsHookCb) {
                        _this.devToolsHookCb({
                            action: {},
                            state: {
                                queries: _this.queryManager
                                    ? _this.queryManager.queryStore.getStore()
                                    : {},
                                mutations: _this.queryManager
                                    ? _this.queryManager.mutationStore.getStore()
                                    : {},
                            },
                            dataWithOptimisticResults: _this.cache.extract(true),
                        });
                    }
                },
            });
        }
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            return _this.queryManager
                ? _this.queryManager.clearStore()
                : Promise.resolve(null);
        })
            .then(function () { return Promise.all(_this.resetStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () {
            return _this.queryManager && _this.queryManager.reFetchObservableQueries
                ? _this.queryManager.reFetchObservableQueries()
                : Promise.resolve(null);
        });
    };
    ApolloClient.prototype.clearStore = function () {
        var _this = this;
        var queryManager = this.queryManager;
        return Promise.resolve()
            .then(function () { return Promise.all(_this.clearStoreCallbacks.map(function (fn) { return fn(); })); })
            .then(function () {
            return queryManager ? queryManager.clearStore() : Promise.resolve(null);
        });
    };
    ApolloClient.prototype.onResetStore = function (cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function () {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.onClearStore = function (cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function () {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function (c) { return c !== cb; });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function (includeStandby) {
        return this.queryManager
            ? this.queryManager.reFetchObservableQueries(includeStandby)
            : Promise.resolve(null);
    };
    ApolloClient.prototype.extract = function (optimistic) {
        return this.initProxy().extract(optimistic);
    };
    ApolloClient.prototype.restore = function (serializedState) {
        return this.initProxy().restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function (resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function (resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function () {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function (fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    ApolloClient.prototype.initProxy = function () {
        if (!this.proxy) {
            this.initQueryManager();
            this.proxy = this.cache;
        }
        return this.proxy;
    };
    return ApolloClient;
}());

/* harmony default export */ __webpack_exports__["default"] = (ApolloClient);

//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* unused harmony export getDirectiveInfoFromField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return shouldInclude; });
/* unused harmony export getDirectiveNames */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return hasDirectives; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return hasClientExports; });
/* unused harmony export getFragmentQueryDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getMutationDefinition; });
/* unused harmony export checkDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getOperationDefinition; });
/* unused harmony export getOperationDefinitionOrDie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getOperationName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getFragmentDefinitions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getQueryDefinition; });
/* unused harmony export getFragmentDefinition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getMainDefinition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createFragmentMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getDefaultValues; });
/* unused harmony export variablesInOperation */
/* unused harmony export removeDirectivesFromDocument */
/* unused harmony export addTypenameToDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return removeConnectionDirectiveFromDocument; });
/* unused harmony export getDirectivesFromDocument */
/* unused harmony export removeArgumentsFromDocument */
/* unused harmony export removeFragmentSpreadFromDocument */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return buildQueryFromSelectionSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return removeClientSetsFromDocument; });
/* unused harmony export isScalarValue */
/* unused harmony export isNumberValue */
/* unused harmony export valueToObjectRepresentation */
/* unused harmony export storeKeyNameFromField */
/* unused harmony export getStoreKeyName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return argumentsObjectFromField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return resultKeyNameFromField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return isInlineFragment; });
/* unused harmony export isIdValue */
/* unused harmony export toIdValue */
/* unused harmony export isJsonValue */
/* unused harmony export valueFromNode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cloneDeep; });
/* unused harmony export getEnv */
/* unused harmony export isEnv */
/* unused harmony export isProduction */
/* unused harmony export isDevelopment */
/* unused harmony export isTest */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return tryFunctionOrLogError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return graphQLResultHasError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isEqual; });
/* unused harmony export maybeDeepFreeze */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return mergeDeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return mergeDeepArray; });
/* unused harmony export warnOnceInDevelopment */
/* unused harmony export stripSymbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ts_invariant__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tslib__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify__);





function isScalarValue(value) {
    return ['StringValue', 'BooleanValue', 'EnumValue'].indexOf(value.kind) > -1;
}
function isNumberValue(value) {
    return ['IntValue', 'FloatValue'].indexOf(value.kind) > -1;
}
function isStringValue(value) {
    return value.kind === 'StringValue';
}
function isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function isIntValue(value) {
    return value.kind === 'IntValue';
}
function isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function isVariable(value) {
    return value.kind === 'Variable';
}
function isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function isListValue(value) {
    return value.kind === 'ListValue';
}
function isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function isNullValue(value) {
    return value.kind === 'NullValue';
}
function valueToObjectRepresentation(argObj, name, value, variables) {
    if (isIntValue(value) || isFloatValue(value)) {
        argObj[name.value] = Number(value.value);
    }
    else if (isBooleanValue(value) || isStringValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function (obj) {
            return valueToObjectRepresentation(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    }
    else if (isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    }
    else if (isListValue(value)) {
        argObj[name.value] = value.values.map(function (listValue) {
            var nestedArgArrayObj = {};
            valueToObjectRepresentation(nestedArgArrayObj, name, listValue, variables);
            return nestedArgArrayObj[name.value];
        });
    }
    else if (isEnumValue(value)) {
        argObj[name.value] = value.value;
    }
    else if (isNullValue(value)) {
        argObj[name.value] = null;
    }
    else {
        throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["InvariantError"]() : new InvariantError("The inline argument \"" + name.value + "\" of kind \"" + value.kind + "\"" +
            'is not supported. Use variables instead of inline arguments to ' +
            'overcome this limitation.');
    }
}
function storeKeyNameFromField(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function (directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) {
                directive.arguments.forEach(function (_a) {
                    var name = _a.name, value = _a.value;
                    return valueToObjectRepresentation(directivesObj[directive.name.value], name, value, variables);
                });
            }
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj, name, value, variables);
        });
    }
    return getStoreKeyName(field.name.value, argObj, directivesObj);
}
var KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export',
];
function getStoreKeyName(fieldName, args, directives) {
    if (directives &&
        directives['connection'] &&
        directives['connection']['key']) {
        if (directives['connection']['filter'] &&
            directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter']
                ? directives['connection']['filter']
                : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function (key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        }
        else {
            return directives['connection']['key'];
        }
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = __WEBPACK_IMPORTED_MODULE_3_fast_json_stable_stringify___default()(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) {
        Object.keys(directives).forEach(function (key) {
            if (KNOWN_DIRECTIVES.indexOf(key) !== -1)
                return;
            if (directives[key] && Object.keys(directives[key]).length) {
                completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
            }
            else {
                completeFieldName += "@" + key;
            }
        });
    }
    return completeFieldName;
}
function argumentsObjectFromField(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function (_a) {
            var name = _a.name, value = _a.value;
            return valueToObjectRepresentation(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function resultKeyNameFromField(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function isField(selection) {
    return selection.kind === 'Field';
}
function isInlineFragment(selection) {
    return selection.kind === 'InlineFragment';
}
function isIdValue(idObject) {
    return idObject &&
        idObject.type === 'id' &&
        typeof idObject.generated === 'boolean';
}
function toIdValue(idConfig, generated) {
    if (generated === void 0) { generated = false; }
    return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({ type: 'id', generated: generated }, (typeof idConfig === 'string'
        ? { id: idConfig, typename: undefined }
        : idConfig));
}
function isJsonValue(jsonObject) {
    return (jsonObject != null &&
        typeof jsonObject === 'object' &&
        jsonObject.type === 'json');
}
function defaultValueFromVariable(node) {
    throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["InvariantError"]() : new InvariantError("Variable nodes are not supported by valueFromNode");
}
function valueFromNode(node, onVariable) {
    if (onVariable === void 0) { onVariable = defaultValueFromVariable; }
    switch (node.kind) {
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function (v) { return valueFromNode(v, onVariable); });
        case 'ObjectValue': {
            var value = {};
            for (var _i = 0, _a = node.fields; _i < _a.length; _i++) {
                var field = _a[_i];
                value[field.name.value] = valueFromNode(field.value, onVariable);
            }
            return value;
        }
        default:
            return node.value;
    }
}

function getDirectiveInfoFromField(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function (directive) {
            directiveObj_1[directive.name.value] = argumentsObjectFromField(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function shouldInclude(selection, variables) {
    if (variables === void 0) { variables = {}; }
    if (!selection.directives) {
        return true;
    }
    var res = true;
    selection.directives.forEach(function (directive) {
        if (directive.name.value !== 'skip' && directive.name.value !== 'include') {
            return;
        }
        var directiveArguments = directive.arguments || [];
        var directiveName = directive.name.value;
         true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(directiveArguments.length === 1) : invariant(directiveArguments.length === 1, "Incorrect number of arguments for the @" + directiveName + " directive.");
        var ifArgument = directiveArguments[0];
         true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(ifArgument.name && ifArgument.name.value === 'if') : invariant(ifArgument.name && ifArgument.name.value === 'if', "Invalid argument for the @" + directiveName + " directive.");
        var ifValue = directiveArguments[0].value;
        var evaledValue = false;
        if (!ifValue || ifValue.kind !== 'BooleanValue') {
             true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(ifValue.kind === 'Variable') : invariant(ifValue.kind === 'Variable', "Argument for the @" + directiveName + " directive must be a variable or a boolean value.");
            evaledValue = variables[ifValue.name.value];
             true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(evaledValue !== void 0) : invariant(evaledValue !== void 0, "Invalid variable referenced in @" + directiveName + " directive.");
        }
        else {
            evaledValue = ifValue.value;
        }
        if (directiveName === 'skip') {
            evaledValue = !evaledValue;
        }
        if (!evaledValue) {
            res = false;
        }
    });
    return res;
}
function getDirectiveNames(doc) {
    var names = [];
    Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(doc, {
        Directive: function (node) {
            names.push(node.name.value);
        },
    });
    return names;
}
function hasDirectives(names, doc) {
    return getDirectiveNames(doc).some(function (name) { return names.indexOf(name) > -1; });
}
function hasClientExports(document) {
    return (document &&
        hasDirectives(['client'], document) &&
        hasDirectives(['export'], document));
}

function getFragmentQueryDocument(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function (definition) {
        if (definition.kind === 'OperationDefinition') {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["InvariantError"]() : new InvariantError("Found a " + definition.operation + " operation" + (definition.name ? " named '" + definition.name.value + "'" : '') + ". " +
                'No operations are allowed when using a fragment as a query. Only fragments are allowed.');
        }
        if (definition.kind === 'FragmentDefinition') {
            fragments.push(definition);
        }
    });
    if (typeof actualFragmentName === 'undefined') {
         true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(fragments.length === 1) : invariant(fragments.length === 1, "Found " + fragments.length + " fragments. `fragmentName` must be provided when there is not exactly 1 fragment.");
        actualFragmentName = fragments[0].name.value;
    }
    var query = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, document, { definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName,
                            },
                        },
                    ],
                },
            }
        ].concat(document.definitions) });
    return query;
}

function assign(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    sources.forEach(function (source) {
        if (typeof source === 'undefined' || source === null) {
            return;
        }
        Object.keys(source).forEach(function (key) {
            target[key] = source[key];
        });
    });
    return target;
}

function getMutationDefinition(doc) {
    checkDocument(doc);
    var mutationDef = doc.definitions.filter(function (definition) {
        return definition.kind === 'OperationDefinition' &&
            definition.operation === 'mutation';
    })[0];
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(mutationDef) : invariant(mutationDef, 'Must contain a mutation definition.');
    return mutationDef;
}
function checkDocument(doc) {
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(doc && doc.kind === 'Document') : invariant(doc && doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
    var operations = doc.definitions
        .filter(function (d) { return d.kind !== 'FragmentDefinition'; })
        .map(function (definition) {
        if (definition.kind !== 'OperationDefinition') {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["InvariantError"]() : new InvariantError("Schema type definitions not allowed in queries. Found: \"" + definition.kind + "\"");
        }
        return definition;
    });
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(operations.length <= 1) : invariant(operations.length <= 1, "Ambiguous GraphQL document: contains " + operations.length + " operations");
    return doc;
}
function getOperationDefinition(doc) {
    checkDocument(doc);
    return doc.definitions.filter(function (definition) { return definition.kind === 'OperationDefinition'; })[0];
}
function getOperationDefinitionOrDie(document) {
    var def = getOperationDefinition(document);
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(def) : invariant(def, "GraphQL document is missing an operation");
    return def;
}
function getOperationName(doc) {
    return (doc.definitions
        .filter(function (definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    })
        .map(function (x) { return x.name.value; })[0] || null);
}
function getFragmentDefinitions(doc) {
    return doc.definitions.filter(function (definition) { return definition.kind === 'FragmentDefinition'; });
}
function getQueryDefinition(doc) {
    var queryDef = getOperationDefinition(doc);
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(queryDef && queryDef.operation === 'query') : invariant(queryDef && queryDef.operation === 'query', 'Must contain a query definition.');
    return queryDef;
}
function getFragmentDefinition(doc) {
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(doc.kind === 'Document') : invariant(doc.kind === 'Document', "Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a \"gql\" tag? http://docs.apollostack.com/apollo-client/core.html#gql");
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(doc.definitions.length <= 1) : invariant(doc.definitions.length <= 1, 'Fragment must have exactly one definition.');
    var fragmentDef = doc.definitions[0];
     true ? Object(__WEBPACK_IMPORTED_MODULE_1_ts_invariant__["invariant"])(fragmentDef.kind === 'FragmentDefinition') : invariant(fragmentDef.kind === 'FragmentDefinition', 'Must be a fragment definition.');
    return fragmentDef;
}
function getMainDefinition(queryDoc) {
    checkDocument(queryDoc);
    var fragmentDefinition;
    for (var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++) {
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' ||
                operation === 'mutation' ||
                operation === 'subscription') {
                return definition;
            }
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) {
            fragmentDefinition = definition;
        }
    }
    if (fragmentDefinition) {
        return fragmentDefinition;
    }
    throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["InvariantError"]() : new InvariantError('Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment.');
}
function createFragmentMap(fragments) {
    if (fragments === void 0) { fragments = []; }
    var symTable = {};
    fragments.forEach(function (fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function getDefaultValues(definition) {
    if (definition &&
        definition.variableDefinitions &&
        definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions
            .filter(function (_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        })
            .map(function (_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            valueToObjectRepresentation(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return assign.apply(void 0, [{}].concat(defaultValues));
    }
    return {};
}
function variablesInOperation(operation) {
    var names = new Set();
    if (operation.variableDefinitions) {
        for (var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++) {
            var definition = _a[_i];
            names.add(definition.variable.name.value);
        }
    }
    return names;
}

function filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function (elem, i) {
        if (test.call(this, elem, i, array)) {
            array[target++] = elem;
        }
    }, context);
    array.length = target;
    return array;
}

var TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename',
    },
};
function isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function (selection) {
        return selection.kind === 'FragmentSpread' &&
            isEmpty(fragments[selection.name.value], fragments);
    });
}
function nullIfDocIsEmpty(doc) {
    return isEmpty(getOperationDefinition(doc) || getFragmentDefinition(doc), createFragmentMap(getFragmentDefinitions(doc)))
        ? null
        : doc;
}
function getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function (dir) {
            return (dir.name && dir.name === directive.name.value) ||
                (dir.test && dir.test(directive));
        });
    };
}
function removeDirectivesFromDocument(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(doc, {
        Variable: {
            enter: function (node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') {
                    variablesInUse[node.name.value] = true;
                }
            },
        },
        Field: {
            enter: function (node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function (directive) { return directive.remove; });
                    if (shouldRemoveField &&
                        node.directives &&
                        node.directives.some(getDirectiveMatcher(directives))) {
                        if (node.arguments) {
                            node.arguments.forEach(function (arg) {
                                if (arg.value.kind === 'Variable') {
                                    variablesToRemove.push({
                                        name: arg.value.name.value,
                                    });
                                }
                            });
                        }
                        if (node.selectionSet) {
                            getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function (frag) {
                                fragmentSpreadsToRemove.push({
                                    name: frag.name.value,
                                });
                            });
                        }
                        return null;
                    }
                }
            },
        },
        FragmentSpread: {
            enter: function (node) {
                fragmentSpreadsInUse[node.name.value] = true;
            },
        },
        Directive: {
            enter: function (node) {
                if (getDirectiveMatcher(directives)(node)) {
                    return null;
                }
            },
        },
    }));
    if (modifiedDoc &&
        filterInPlace(variablesToRemove, function (v) { return !variablesInUse[v.name]; }).length) {
        modifiedDoc = removeArgumentsFromDocument(variablesToRemove, modifiedDoc);
    }
    if (modifiedDoc &&
        filterInPlace(fragmentSpreadsToRemove, function (fs) { return !fragmentSpreadsInUse[fs.name]; })
            .length) {
        modifiedDoc = removeFragmentSpreadFromDocument(fragmentSpreadsToRemove, modifiedDoc);
    }
    return modifiedDoc;
}
function addTypenameToDocument(doc) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(checkDocument(doc), {
        SelectionSet: {
            enter: function (node, _key, parent) {
                if (parent &&
                    parent.kind === 'OperationDefinition') {
                    return;
                }
                var selections = node.selections;
                if (!selections) {
                    return;
                }
                var skip = selections.some(function (selection) {
                    return (selection.kind === 'Field' &&
                        (selection.name.value === '__typename' ||
                            selection.name.value.lastIndexOf('__', 0) === 0));
                });
                if (skip) {
                    return;
                }
                return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, node, { selections: selections.concat([TYPENAME_FIELD]) });
            },
        },
    });
}
var connectionRemoveConfig = {
    test: function (directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) {
            if (!directive.arguments ||
                !directive.arguments.some(function (arg) { return arg.name.value === 'key'; })) {
                console.warn('Removing an @connection directive even though it does not have a key. ' +
                    'You may want to use the key parameter to specify a store key.');
            }
        }
        return willRemove;
    },
};
function removeConnectionDirectiveFromDocument(doc) {
    return removeDirectivesFromDocument([connectionRemoveConfig], checkDocument(doc));
}
function hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    return (selectionSet &&
        selectionSet.selections &&
        selectionSet.selections.some(function (selection) {
            return hasDirectivesInSelection(directives, selection, nestedCheck);
        }));
}
function hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) { nestedCheck = true; }
    if (selection.kind !== 'Field' || !selection) {
        return true;
    }
    if (!selection.directives) {
        return false;
    }
    return (selection.directives.some(getDirectiveMatcher(directives)) ||
        (nestedCheck &&
            hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck)));
}
function getDirectivesFromDocument(directives, doc) {
    checkDocument(doc);
    var parentPath;
    return nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(doc, {
        SelectionSet: {
            enter: function (node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath ||
                    currentPath === parentPath ||
                    !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function (selection) { return hasDirectivesInSelection(directives, selection); });
                        if (hasDirectivesInSelectionSet(directives, node, false)) {
                            parentPath = currentPath;
                        }
                        return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, node, { selections: selectionsWithDirectives });
                    }
                    else {
                        return null;
                    }
                }
            },
        },
    }));
}
function getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function (aConfig) {
            return argument.value &&
                argument.value.kind === 'Variable' &&
                argument.value.name &&
                (aConfig.name === argument.value.name.value ||
                    (aConfig.test && aConfig.test(argument)));
        });
    };
}
function removeArgumentsFromDocument(config, doc) {
    var argMatcher = getArgumentMatcher(config);
    return nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(doc, {
        OperationDefinition: {
            enter: function (node) {
                return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, node, { variableDefinitions: node.variableDefinitions.filter(function (varDef) {
                        return !config.some(function (arg) { return arg.name === varDef.variable.name.value; });
                    }) });
            },
        },
        Field: {
            enter: function (node) {
                var shouldRemoveField = config.some(function (argConfig) { return argConfig.remove; });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function (arg) {
                        if (argMatcher(arg)) {
                            argMatchCount_1 += 1;
                        }
                    });
                    if (argMatchCount_1 === 1) {
                        return null;
                    }
                }
            },
        },
        Argument: {
            enter: function (node) {
                if (argMatcher(node)) {
                    return null;
                }
            },
        },
    }));
}
function removeFragmentSpreadFromDocument(config, doc) {
    function enter(node) {
        if (config.some(function (def) { return def.name === node.name.value; })) {
            return null;
        }
    }
    return nullIfDocIsEmpty(Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(doc, {
        FragmentSpread: { enter: enter },
        FragmentDefinition: { enter: enter },
    }));
}
function getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function (selection) {
        if ((selection.kind === 'Field' || selection.kind === 'InlineFragment') &&
            selection.selectionSet) {
            getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function (frag) { return allFragments.push(frag); });
        }
        else if (selection.kind === 'FragmentSpread') {
            allFragments.push(selection);
        }
    });
    return allFragments;
}
function buildQueryFromSelectionSet(document) {
    var definition = getMainDefinition(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') {
        return document;
    }
    var modifiedDoc = Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(document, {
        OperationDefinition: {
            enter: function (node) {
                return Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, node, { operation: 'query' });
            },
        },
    });
    return modifiedDoc;
}
function removeClientSetsFromDocument(document) {
    checkDocument(document);
    var modifiedDoc = removeDirectivesFromDocument([
        {
            test: function (directive) { return directive.name.value === 'client'; },
            remove: true,
        },
    ], document);
    if (modifiedDoc) {
        modifiedDoc = Object(__WEBPACK_IMPORTED_MODULE_0_graphql_language_visitor__["visit"])(modifiedDoc, {
            FragmentDefinition: {
                enter: function (node) {
                    if (node.selectionSet) {
                        var isTypenameOnly = node.selectionSet.selections.every(function (selection) {
                            return (selection.kind === 'Field' &&
                                selection.name.value === '__typename');
                        });
                        if (isTypenameOnly) {
                            return null;
                        }
                    }
                },
            },
        });
    }
    return modifiedDoc;
}

var toString = Object.prototype.toString;
function cloneDeep(value) {
    return cloneDeepHelper(value, new Map());
}
function cloneDeepHelper(val, seen) {
    switch (toString.call(val)) {
        case "[object Array]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function (child, i) {
                copy_1[i] = cloneDeepHelper(child, seen);
            });
            return copy_1;
        }
        case "[object Object]": {
            if (seen.has(val))
                return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function (key) {
                copy_2[key] = cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        }
        default:
            return val;
    }
}

function getEnv() {
    if (typeof process !== 'undefined' && "production") {
        return "production";
    }
    return 'development';
}
function isEnv(env) {
    return getEnv() === env;
}
function isProduction() {
    return isEnv('production') === true;
}
function isDevelopment() {
    return isEnv('development') === true;
}
function isTest() {
    return isEnv('test') === true;
}

function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
function graphQLResultHasError(result) {
    return result.errors && result.errors.length;
}

function isEqual(a, b) {
    if (a === b) {
        return true;
    }
    if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime();
    }
    if (a != null &&
        typeof a === 'object' &&
        b != null &&
        typeof b === 'object') {
        for (var key in a) {
            if (Object.prototype.hasOwnProperty.call(a, key)) {
                if (!Object.prototype.hasOwnProperty.call(b, key)) {
                    return false;
                }
                if (!isEqual(a[key], b[key])) {
                    return false;
                }
            }
        }
        for (var key in b) {
            if (Object.prototype.hasOwnProperty.call(b, key) &&
                !Object.prototype.hasOwnProperty.call(a, key)) {
                return false;
            }
        }
        return true;
    }
    return false;
}

function deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}
function maybeDeepFreeze(obj) {
    if (isDevelopment() || isTest()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) {
            return deepFreeze(obj);
        }
    }
    return obj;
}

var hasOwnProperty = Object.prototype.hasOwnProperty;
function mergeDeep() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return mergeDeepArray(sources);
}
function mergeDeepArray(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = shallowCopyForMerge(target, pastCopies);
        for (var i = 1; i < count; ++i) {
            target = mergeHelper(target, sources[i], pastCopies);
        }
    }
    return target;
}
function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function mergeHelper(target, source, pastCopies) {
    if (isObject(source) && isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) {
            target = shallowCopyForMerge(target, pastCopies);
        }
        Object.keys(source).forEach(function (sourceKey) {
            var sourceValue = source[sourceKey];
            if (hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) {
                    target[sourceKey] = mergeHelper(shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
                }
            }
            else {
                target[sourceKey] = sourceValue;
            }
        });
        return target;
    }
    return source;
}
function shallowCopyForMerge(value, pastCopies) {
    if (value !== null &&
        typeof value === 'object' &&
        pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) {
            value = value.slice(0);
        }
        else {
            value = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({ __proto__: Object.getPrototypeOf(value) }, value);
        }
        pastCopies.push(value);
    }
    return value;
}

var haveWarned = Object.create({});
function warnOnceInDevelopment(msg, type) {
    if (type === void 0) { type = 'warn'; }
    if (isProduction()) {
        return;
    }
    if (!haveWarned[msg]) {
        if (!isTest()) {
            haveWarned[msg] = true;
        }
        switch (type) {
            case 'error':
                console.error(msg);
                break;
            default:
                console.warn(msg);
        }
    }
}

function stripSymbols(data) {
    return JSON.parse(JSON.stringify(data));
}


//# sourceMappingURL=bundle.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(83)))

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1224).Observable;


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Observable = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(observer, subscriber) {
    _classCallCheck(this, Subscription);

    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  _createClass(Subscription, [{
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this._state !== 'closed') {
        closeSubscription(this);
        cleanupSubscription(this);
      }
    }
  }, {
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver =
/*#__PURE__*/
function () {
  function SubscriptionObserver(subscription) {
    _classCallCheck(this, SubscriptionObserver);

    this._subscription = subscription;
  }

  _createClass(SubscriptionObserver, [{
    key: "next",
    value: function next(value) {
      onNotify(this._subscription, 'next', value);
    }
  }, {
    key: "error",
    value: function error(value) {
      onNotify(this._subscription, 'error', value);
    }
  }, {
    key: "complete",
    value: function complete() {
      onNotify(this._subscription, 'complete');
    }
  }, {
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable =
/*#__PURE__*/
function () {
  function Observable(subscriber) {
    _classCallCheck(this, Observable);

    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  _createClass(Observable, [{
    key: "subscribe",
    value: function subscribe(observer) {
      if (typeof observer !== 'object' || observer === null) {
        observer = {
          next: observer,
          error: arguments[1],
          complete: arguments[2]
        };
      }

      return new Subscription(observer, this._subscriber);
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof fn !== 'function') {
          reject(new TypeError(fn + ' is not a function'));
          return;
        }

        function done() {
          subscription.unsubscribe();
          resolve();
        }

        var subscription = _this.subscribe({
          next: function (value) {
            try {
              fn(value, done);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },
          error: reject,
          complete: resolve
        });
      });
    }
  }, {
    key: "map",
    value: function map(fn) {
      var _this2 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this2.subscribe({
          next: function (value) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "filter",
    value: function filter(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this3.subscribe({
          next: function (value) {
            try {
              if (!fn(value)) return;
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "reduce",
    value: function reduce(fn) {
      var _this4 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      var hasSeed = arguments.length > 1;
      var hasValue = false;
      var seed = arguments[1];
      var acc = seed;
      return new C(function (observer) {
        return _this4.subscribe({
          next: function (value) {
            var first = !hasValue;
            hasValue = true;

            if (!first || hasSeed) {
              try {
                acc = fn(acc, value);
              } catch (e) {
                return observer.error(e);
              }
            } else {
              acc = value;
            }
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
            observer.next(acc);
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "concat",
    value: function concat() {
      var _this5 = this;

      for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      var C = getSpecies(this);
      return new C(function (observer) {
        var subscription;
        var index = 0;

        function startNext(next) {
          subscription = next.subscribe({
            next: function (v) {
              observer.next(v);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              if (index === sources.length) {
                subscription = undefined;
                observer.complete();
              } else {
                startNext(C.from(sources[index++]));
              }
            }
          });
        }

        startNext(_this5);
        return function () {
          if (subscription) {
            subscription.unsubscribe();
            subscription = undefined;
          }
        };
      });
    }
  }, {
    key: "flatMap",
    value: function flatMap(fn) {
      var _this6 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        var subscriptions = [];

        var outer = _this6.subscribe({
          next: function (value) {
            if (fn) {
              try {
                value = fn(value);
              } catch (e) {
                return observer.error(e);
              }
            }

            var inner = C.from(value).subscribe({
              next: function (value) {
                observer.next(value);
              },
              error: function (e) {
                observer.error(e);
              },
              complete: function () {
                var i = subscriptions.indexOf(inner);
                if (i >= 0) subscriptions.splice(i, 1);
                completeIfDone();
              }
            });
            subscriptions.push(inner);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            completeIfDone();
          }
        });

        function completeIfDone() {
          if (outer.closed && subscriptions.length === 0) observer.complete();
        }

        return function () {
          subscriptions.forEach(function (s) {
            return s.unsubscribe();
          });
          outer.unsubscribe();
        };
      });
    }
  }, {
    key: SymbolObservable,
    value: function () {
      return this;
    }
  }], [{
    key: "from",
    value: function from(x) {
      var C = typeof this === 'function' ? this : Observable;
      if (x == null) throw new TypeError(x + ' is not an object');
      var method = getMethod(x, SymbolObservable);

      if (method) {
        var observable = method.call(x);
        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
        if (isObservable(observable) && observable.constructor === C) return observable;
        return new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      if (hasSymbol('iterator')) {
        method = getMethod(x, SymbolIterator);

        if (method) {
          return new C(function (observer) {
            enqueue(function () {
              if (observer.closed) return;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _item = _step.value;
                  observer.next(_item);
                  if (observer.closed) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              observer.complete();
            });
          });
        }
      }

      if (Array.isArray(x)) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var i = 0; i < x.length; ++i) {
              observer.next(x[i]);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }

      throw new TypeError(x + ' is not observable');
    }
  }, {
    key: "of",
    value: function of() {
      for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      var C = typeof this === 'function' ? this : Observable;
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }
  }, {
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

exports.Observable = Observable;

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InvariantError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return invariant; });
/* unused harmony export process */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(39);


var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
function wrapConsoleMethod(method) {
    return function () {
        return console[method].apply(console, arguments);
    };
}
(function (invariant) {
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var processStub = { env: {} };
if (typeof process === "object") {
    processStub = process;
}
else
    try {
        // Using Function to evaluate this assignment in global scope also escapes
        // the strict mode of the current module, thereby allowing the assignment.
        // Inspired by https://github.com/facebook/regenerator/pull/369.
        Function("stub", "process = stub")(processStub);
    }
    catch (atLeastWeTried) {
        // The assignment can fail if a Content Security Policy heavy-handedly
        // forbids Function usage. In those environments, developers should take
        // extra care to replace process.env.NODE_ENV in their production builds,
        // or define an appropriate global.process polyfill.
    }
var invariant$1 = invariant;

/* unused harmony default export */ var _unused_webpack_default_export = (invariant$1);

//# sourceMappingURL=invariant.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(83)))

/***/ }),
/* 1226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return equal; });
var _a = Object.prototype, toString = _a.toString, hasOwnProperty = _a.hasOwnProperty;
var previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */
function equal(a, b) {
    try {
        return check(a, b);
    }
    finally {
        previousComparisons.clear();
    }
}
function check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) {
        return true;
    }
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = toString.call(a);
    var bTag = toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) {
        return false;
    }
    switch (aTag) {
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length)
                return false;
        // Fall through to object case...
        case '[object Object]': {
            if (previouslyCompared(a, b))
                return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length)
                return false;
            // Now make sure they have the same keys.
            for (var k = 0; k < keyCount; ++k) {
                if (!hasOwnProperty.call(b, aKeys[k])) {
                    return false;
                }
            }
            // Finally, check deep equality of all child properties.
            for (var k = 0; k < keyCount; ++k) {
                var key = aKeys[k];
                if (!check(a[key], b[key])) {
                    return false;
                }
            }
            return true;
        }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a)
                return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]': {
            if (a.size !== b.size)
                return false;
            if (previouslyCompared(a, b))
                return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while (true) {
                var info = aIterator.next();
                if (info.done)
                    break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) {
                    return false;
                }
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !check(aValue, b.get(aKey))) {
                    return false;
                }
            }
            return true;
        }
    }
    // Otherwise the values are not equal.
    return false;
}
function previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b))
            return true;
    }
    else {
        previousComparisons.set(a, bSet = new Set);
    }
    bSet.add(b);
    return false;
}

/* unused harmony default export */ var _unused_webpack_default_export = (equal);

//# sourceMappingURL=equality.esm.js.map


/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DedupLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_apollo_link__ = __webpack_require__(1228);



var DedupLink = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(DedupLink, _super);
    function DedupLink() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inFlightRequestObservables = new Map();
        _this.subscribers = new Map();
        return _this;
    }
    DedupLink.prototype.request = function (operation, forward) {
        var _this = this;
        if (operation.getContext().forceFetch) {
            return forward(operation);
        }
        var key = operation.toKey();
        if (!this.inFlightRequestObservables.get(key)) {
            var singleObserver_1 = forward(operation);
            var subscription_1;
            var sharedObserver = new __WEBPACK_IMPORTED_MODULE_1_apollo_link__["b" /* Observable */](function (observer) {
                if (!_this.subscribers.has(key))
                    _this.subscribers.set(key, new Set());
                _this.subscribers.get(key).add(observer);
                if (!subscription_1) {
                    subscription_1 = singleObserver_1.subscribe({
                        next: function (result) {
                            var subscribers = _this.subscribers.get(key);
                            _this.subscribers.delete(key);
                            _this.inFlightRequestObservables.delete(key);
                            if (subscribers) {
                                subscribers.forEach(function (obs) { return obs.next(result); });
                                subscribers.forEach(function (obs) { return obs.complete(); });
                            }
                        },
                        error: function (error) {
                            var subscribers = _this.subscribers.get(key);
                            _this.subscribers.delete(key);
                            _this.inFlightRequestObservables.delete(key);
                            if (subscribers) {
                                subscribers.forEach(function (obs) { return obs.error(error); });
                            }
                        },
                    });
                }
                return function () {
                    if (_this.subscribers.has(key)) {
                        _this.subscribers.get(key).delete(observer);
                        if (_this.subscribers.get(key).size === 0) {
                            _this.inFlightRequestObservables.delete(key);
                            if (subscription_1)
                                subscription_1.unsubscribe();
                        }
                    }
                };
            });
            this.inFlightRequestObservables.set(key, sharedObserver);
        }
        return this.inFlightRequestObservables.get(key);
    };
    return DedupLink;
}(__WEBPACK_IMPORTED_MODULE_1_apollo_link__["a" /* ApolloLink */]));


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ApolloLink; });
/* unused harmony export concat */
/* unused harmony export createOperation */
/* unused harmony export empty */
/* unused harmony export execute */
/* unused harmony export from */
/* unused harmony export fromError */
/* unused harmony export fromPromise */
/* unused harmony export makePromise */
/* unused harmony export split */
/* unused harmony export toPromise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__ = __webpack_require__(130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ts_invariant__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tslib__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_apollo_utilities__ = __webpack_require__(86);
/* unused harmony reexport getOperationName */







function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context',
    ];
    for (var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++) {
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) {
            throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](2) : new InvariantError("illegal argument: " + key);
        }
    }
    return operation;
}
var LinkError = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__extends"])(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error));
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function (resolve, reject) {
        observable.subscribe({
            next: function (data) {
                if (completed) {
                    "production" === "production" || __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */].warn("Promise Wrapper does not support multiple results from Observable");
                }
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject,
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"](function (observer) {
        promise
            .then(function (value) {
            observer.next(value);
            observer.complete();
        })
            .catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"](function (observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query,
    };
    if (!transformedOperation.operationName) {
        transformedOperation.operationName =
            typeof transformedOperation.query !== 'string'
                ? Object(__WEBPACK_IMPORTED_MODULE_3_apollo_utilities__["getOperationName"])(transformedOperation.query)
                : '';
    }
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, starting);
    var setContext = function (next) {
        if (typeof next === 'function') {
            context = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, context, next(context));
        }
        else {
            context = Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, context, next);
        }
    };
    var getContext = function () { return (Object(__WEBPACK_IMPORTED_MODULE_2_tslib__["__assign"])({}, context)); };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext,
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext,
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function () { return getKey(operation); },
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([operationName, query, variables]);
}

function passthrough(op, forward) {
    return forward ? forward(op) : __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function () { return __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of(); });
}
function from(links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of()
                : rightLink.request(operation) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of()
                : rightLink.request(operation, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of();
        });
    }
}
var concat = function (first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) {
        "production" === "production" || __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["b" /* invariant */].warn(new LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of(); }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of();
            }) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of());
        });
    }
};
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw  true ? new __WEBPACK_IMPORTED_MODULE_1_ts_invariant__["a" /* InvariantError */](1) : new InvariantError('request is not implemented');
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());
function execute(link, operation) {
    return (link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["default"].of());
}


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InvariantError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return invariant; });
/* unused harmony export process */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(39);


var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
function wrapConsoleMethod(method) {
    return function () {
        return console[method].apply(console, arguments);
    };
}
(function (invariant) {
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var processStub = { env: {} };
if (typeof process === "object") {
    processStub = process;
}
else
    try {
        // Using Function to evaluate this assignment in global scope also escapes
        // the strict mode of the current module, thereby allowing the assignment.
        // Inspired by https://github.com/facebook/regenerator/pull/369.
        Function("stub", "process = stub")(processStub);
    }
    catch (atLeastWeTried) {
        // The assignment can fail if a Content Security Policy heavy-handedly
        // forbids Function usage. In those environments, developers should take
        // extra care to replace process.env.NODE_ENV in their production builds,
        // or define an appropriate global.process polyfill.
    }
var invariant$1 = invariant;

/* unused harmony default export */ var _unused_webpack_default_export = (invariant$1);

//# sourceMappingURL=invariant.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(83)))

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(39);
var inMemoryCache_1 = __webpack_require__(1231);
exports.InMemoryCache = inMemoryCache_1.InMemoryCache;
exports.defaultDataIdFromObject = inMemoryCache_1.defaultDataIdFromObject;
tslib_1.__exportStar(__webpack_require__(538), exports);
tslib_1.__exportStar(__webpack_require__(540), exports);
tslib_1.__exportStar(__webpack_require__(537), exports);
tslib_1.__exportStar(__webpack_require__(349), exports);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(39);
__webpack_require__(1232);
var apollo_cache_1 = __webpack_require__(1233);
var apollo_utilities_1 = __webpack_require__(86);
var optimism_1 = __webpack_require__(347);
var ts_invariant_1 = __webpack_require__(150);
var fragmentMatcher_1 = __webpack_require__(537);
var readFromStore_1 = __webpack_require__(538);
var writeToStore_1 = __webpack_require__(540);
var depTrackingCache_1 = __webpack_require__(348);
var cacheKeys_1 = __webpack_require__(539);
var objectCache_1 = __webpack_require__(349);
var defaultConfig = {
    fragmentMatcher: new fragmentMatcher_1.HeuristicFragmentMatcher(),
    dataIdFromObject: defaultDataIdFromObject,
    addTypename: true,
    resultCaching: true,
};
function defaultDataIdFromObject(result) {
    if (result.__typename) {
        if (result.id !== undefined) {
            return result.__typename + ":" + result.id;
        }
        if (result._id !== undefined) {
            return result.__typename + ":" + result._id;
        }
    }
    return null;
}
exports.defaultDataIdFromObject = defaultDataIdFromObject;
var hasOwn = Object.prototype.hasOwnProperty;
var OptimisticCacheLayer = (function (_super) {
    tslib_1.__extends(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function () {
        return tslib_1.__assign({}, this.parent.toObject(), this.data);
    };
    OptimisticCacheLayer.prototype.get = function (dataId) {
        return hasOwn.call(this.data, dataId)
            ? this.data[dataId]
            : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}(objectCache_1.ObjectCache));
exports.OptimisticCacheLayer = OptimisticCacheLayer;
var InMemoryCache = (function (_super) {
    tslib_1.__extends(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new cacheKeys_1.CacheKeyNode();
        _this.silenceBroadcast = false;
        _this.config = tslib_1.__assign({}, defaultConfig, config);
        if (_this.config.customResolvers) {
            ts_invariant_1.invariant.warn('customResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating customResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.customResolvers;
        }
        if (_this.config.cacheResolvers) {
            ts_invariant_1.invariant.warn('cacheResolvers have been renamed to cacheRedirects. Please update your config as we will be deprecating cacheResolvers in the next major version.');
            _this.config.cacheRedirects = _this.config.cacheResolvers;
        }
        _this.addTypename = _this.config.addTypename;
        _this.data = _this.config.resultCaching
            ? new depTrackingCache_1.DepTrackingCache()
            : new objectCache_1.ObjectCache();
        _this.optimisticData = _this.data;
        _this.storeReader = new readFromStore_1.StoreReader(_this.cacheKeyRoot);
        _this.storeWriter = new writeToStore_1.StoreWriter();
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = optimism_1.wrap(function (c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function (c) {
                if (c.optimistic) {
                    return;
                }
                if (c.previousResult) {
                    return;
                }
                if (cache.data instanceof depTrackingCache_1.DepTrackingCache) {
                    return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function (data) {
        if (data)
            this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function (optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function (options) {
        if (typeof options.rootId === 'string' &&
            typeof this.data.get(options.rootId) === 'undefined') {
            return null;
        }
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            previousResult: options.previousResult,
            config: this.config,
        });
    };
    InMemoryCache.prototype.write = function (write) {
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function (query) {
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: this.config.fragmentMatcher.match,
            config: this.config,
        });
    };
    InMemoryCache.prototype.watch = function (watch) {
        var _this = this;
        this.watches.add(watch);
        return function () {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function (query) {
        throw new ts_invariant_1.InvariantError("eviction is not implemented on InMemory Cache");
    };
    InMemoryCache.prototype.reset = function () {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function (idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while (layer instanceof OptimisticCacheLayer) {
            if (layer.optimisticId === idToRemove) {
                ++removedCount;
            }
            else {
                toReapply.push(layer);
            }
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while (toReapply.length > 0) {
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function (transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') {
            this.data = this.optimisticData = new OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        }
        try {
            transaction(this);
        }
        finally {
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function (transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function (document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = apollo_utilities_1.addTypenameToDocument(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function () {
        var _this = this;
        if (!this.silenceBroadcast) {
            this.watches.forEach(function (c) { return _this.maybeBroadcastWatch(c); });
        }
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function (c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic,
        }));
    };
    return InMemoryCache;
}(apollo_cache_1.ApolloCache));
exports.InMemoryCache = InMemoryCache;
//# sourceMappingURL=inMemoryCache.js.map

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

var testMap = new Map();
if (testMap.set(1, 2) !== testMap) {
    var set_1 = testMap.set;
    Map.prototype.set = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        set_1.apply(this, args);
        return this;
    };
}
var testSet = new Set();
if (testSet.add(3) !== testSet) {
    var add_1 = testSet.add;
    Set.prototype.add = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        add_1.apply(this, args);
        return this;
    };
}
var frozen = {};
if (typeof Object.freeze === 'function') {
    Object.freeze(frozen);
}
try {
    testMap.set(frozen, frozen).delete(frozen);
}
catch (_a) {
    var wrap = function (method) {
        return method && (function (obj) {
            try {
                testMap.set(obj, obj).delete(obj);
            }
            finally {
                return method.call(Object, obj);
            }
        });
    };
    Object.freeze = wrap(Object.freeze);
    Object.seal = wrap(Object.seal);
    Object.preventExtensions = wrap(Object.preventExtensions);
}
//# sourceMappingURL=fixPolyfills.js.map

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApolloCache", function() { return ApolloCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cache", function() { return Cache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_apollo_utilities__ = __webpack_require__(86);


function queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [op],
    };
    return out;
}
function fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType',
            },
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery',
        },
        selectionSet: selectionSetFromObj(obj),
    };
    var out = {
        kind: 'Document',
        definitions: [frag],
    };
    return out;
}
function selectionSetFromObj(obj) {
    if (typeof obj === 'number' ||
        typeof obj === 'boolean' ||
        typeof obj === 'string' ||
        typeof obj === 'undefined' ||
        obj === null) {
        return null;
    }
    if (Array.isArray(obj)) {
        return selectionSetFromObj(obj[0]);
    }
    var selections = [];
    Object.keys(obj).forEach(function (key) {
        var nestedSelSet = selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key,
            },
            selectionSet: nestedSelSet || undefined,
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections,
    };
    return selectionSet;
}
var justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename',
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null,
                    },
                ],
            },
        },
    ],
};

var ApolloCache = (function () {
    function ApolloCache() {
    }
    ApolloCache.prototype.transformDocument = function (document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function (document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.readFragment = function (options, optimistic) {
        if (optimistic === void 0) { optimistic = false; }
        return this.read({
            query: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["getFragmentQueryDocument"])(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic,
        });
    };
    ApolloCache.prototype.writeQuery = function (options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables,
        });
    };
    ApolloCache.prototype.writeFragment = function (options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: Object(__WEBPACK_IMPORTED_MODULE_0_apollo_utilities__["getFragmentQueryDocument"])(options.fragment, options.fragmentName),
        });
    };
    ApolloCache.prototype.writeData = function (_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: justTypenameQuery,
                });
            }
            catch (e) {
            }
            var __typename = (typenameResult && typenameResult.__typename) || '__ClientData';
            var dataToWrite = Object.assign({ __typename: __typename }, data);
            this.writeFragment({
                id: id,
                fragment: fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite,
            });
        }
        else {
            this.writeQuery({ query: queryFromPojo(data), data: data });
        }
    };
    return ApolloCache;
}());

var Cache;
(function (Cache) {
})(Cache || (Cache = {}));


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function Cache(options) {
  this.map = new Map;
  this.newest = null;
  this.oldest = null;
  this.max = options && options.max;
  this.dispose = options && options.dispose;
}

exports.Cache = Cache;

var Cp = Cache.prototype;

Cp.has = function (key) {
  return this.map.has(key);
};

Cp.get = function (key) {
  var entry = getEntry(this, key);
  return entry && entry.value;
};

function getEntry(cache, key) {
  var entry = cache.map.get(key);
  if (entry &&
      entry !== cache.newest) {
    var older = entry.older;
    var newer = entry.newer;

    if (newer) {
      newer.older = older;
    }

    if (older) {
      older.newer = newer;
    }

    entry.older = cache.newest;
    entry.older.newer = entry;

    entry.newer = null;
    cache.newest = entry;

    if (entry === cache.oldest) {
      cache.oldest = newer;
    }
  }

  return entry;
}

Cp.set = function (key, value) {
  var entry = getEntry(this, key);
  if (entry) {
    return entry.value = value;
  }

  entry = {
    key: key,
    value: value,
    newer: null,
    older: this.newest
  };

  if (this.newest) {
    this.newest.newer = entry;
  }

  this.newest = entry;
  this.oldest = this.oldest || entry;

  this.map.set(key, entry);

  return entry.value;
};

Cp.clean = function () {
  if (typeof this.max === "number") {
    while (this.oldest &&
           this.map.size > this.max) {
      this.delete(this.oldest.key);
    }
  }
};

Cp.delete = function (key) {
  var entry = this.map.get(key);
  if (entry) {
    if (entry === this.newest) {
      this.newest = entry.older;
    }

    if (entry === this.oldest) {
      this.oldest = entry.newer;
    }

    if (entry.newer) {
      entry.newer.older = entry.older;
    }

    if (entry.older) {
      entry.older.newer = entry.newer;
    }

    this.map.delete(key);

    if (typeof this.dispose === "function") {
      this.dispose(key, entry.value);
    }

    return true;
  }

  return false;
};


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tuple.e6b50867.mjs";

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getLocal = __webpack_require__(536).get;
var UNKNOWN_VALUE = Object.create(null);
var emptySetPool = [];
var entryPool = [];

// Don't let the emptySetPool or entryPool grow larger than this size,
// since unconstrained pool growth could lead to memory leaks.
exports.POOL_TARGET_SIZE = 100;

// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function assert(condition, optionalMessage) {
  if (! condition) {
    throw new Error(optionalMessage || "assertion failure");
  }
}

function Entry(fn, key, args) {
  this.parents = new Set;
  this.childValues = new Map;

  // When this Entry has children that are dirty, this property becomes
  // a Set containing other Entry objects, borrowed from emptySetPool.
  // When the set becomes empty, it gets recycled back to emptySetPool.
  this.dirtyChildren = null;

  reset(this, fn, key, args);

  ++Entry.count;
}

Entry.count = 0;

function reset(entry, fn, key, args) {
  entry.fn = fn;
  entry.key = key;
  entry.args = args;
  entry.value = UNKNOWN_VALUE;
  entry.dirty = true;
  entry.subscribe = null;
  entry.unsubscribe = null;
  entry.recomputing = false;
  // Optional callback that will be invoked when entry.parents becomes
  // empty. The Entry object is given as the first parameter. If the
  // callback returns true, then this entry can be removed from the graph
  // and safely recycled into the entryPool.
  entry.reportOrphan = null;
}

Entry.acquire = function (fn, key, args) {
  var entry = entryPool.pop();
  if (entry) {
    reset(entry, fn, key, args);
    return entry;
  }
  return new Entry(fn, key, args);
};

function release(entry) {
  assert(entry.parents.size === 0);
  assert(entry.childValues.size === 0);
  assert(entry.dirtyChildren === null);
  if (entryPool.length < exports.POOL_TARGET_SIZE) {
    entryPool.push(entry);
  }
}

exports.Entry = Entry;

var Ep = Entry.prototype;

// The public API of Entry objects consists of the Entry constructor,
// along with the recompute, setDirty, and dispose methods.

Ep.recompute = function recompute() {
  if (! rememberParent(this) &&
      maybeReportOrphan(this)) {
    // The recipient of the entry.reportOrphan callback decided to dispose
    // of this orphan entry by calling entry.dispos(), which recycles it
    // into the entryPool, so we don't need to (and should not) proceed
    // with the recomputation.
    return;
  }

  return recomputeIfDirty(this);
};

// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function maybeReportOrphan(entry) {
  var report = entry.reportOrphan;
  return typeof report === "function" &&
    entry.parents.size === 0 &&
    report(entry) === true;
}

Ep.setDirty = function setDirty() {
  if (this.dirty) return;
  this.dirty = true;
  this.value = UNKNOWN_VALUE;
  reportDirty(this);
  // We can go ahead and unsubscribe here, since any further dirty
  // notifications we receive will be redundant, and unsubscribing may
  // free up some resources, e.g. file watchers.
  unsubscribe(this);
};

Ep.dispose = function dispose() {
  var entry = this;
  forgetChildren(entry).forEach(maybeReportOrphan);
  unsubscribe(entry);

  // Because this entry has been kicked out of the cache (in index.js),
  // we've lost the ability to find out if/when this entry becomes dirty,
  // whether that happens through a subscription, because of a direct call
  // to entry.setDirty(), or because one of its children becomes dirty.
  // Because of this loss of future information, we have to assume the
  // worst (that this entry might have become dirty very soon), so we must
  // immediately mark this entry's parents as dirty. Normally we could
  // just call entry.setDirty() rather than calling parent.setDirty() for
  // each parent, but that would leave this entry in parent.childValues
  // and parent.dirtyChildren, which would prevent the child from being
  // truly forgotten.
  entry.parents.forEach(function (parent) {
    parent.setDirty();
    forgetChild(parent, entry);
  });

  // Since this entry has no parents and no children anymore, and the
  // caller of Entry#dispose has indicated that entry.value no longer
  // matters, we can safely recycle this Entry object for later use.
  release(entry);
};

function setClean(entry) {
  entry.dirty = false;

  if (mightBeDirty(entry)) {
    // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
  }

  reportClean(entry);
}

function reportDirty(entry) {
  entry.parents.forEach(function (parent) {
    reportDirtyChild(parent, entry);
  });
}

function reportClean(entry) {
  entry.parents.forEach(function (parent) {
    reportCleanChild(parent, entry);
  });
}

function mightBeDirty(entry) {
  return entry.dirty ||
    (entry.dirtyChildren &&
     entry.dirtyChildren.size);
}

// Let a parent Entry know that one of its children may be dirty.
function reportDirtyChild(entry, child) {
  // Must have called rememberParent(child) before calling
  // reportDirtyChild(parent, child).
  assert(entry.childValues.has(child));
  assert(mightBeDirty(child));

  if (! entry.dirtyChildren) {
    entry.dirtyChildren = emptySetPool.pop() || new Set;

  } else if (entry.dirtyChildren.has(child)) {
    // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
  }

  entry.dirtyChildren.add(child);
  reportDirty(entry);
}

// Let a parent Entry know that one of its children is no longer dirty.
function reportCleanChild(entry, child) {
  var cv = entry.childValues;

  // Must have called rememberChild(child) before calling
  // reportCleanChild(parent, child).
  assert(cv.has(child));
  assert(! mightBeDirty(child));

  var childValue = cv.get(child);
  if (childValue === UNKNOWN_VALUE) {
    cv.set(child, child.value);
  } else if (childValue !== child.value) {
    entry.setDirty();
  }

  removeDirtyChild(entry, child);

  if (mightBeDirty(entry)) {
    return;
  }

  reportClean(entry);
}

function removeDirtyChild(entry, child) {
  var dc = entry.dirtyChildren;
  if (dc) {
    dc.delete(child);
    if (dc.size === 0) {
      if (emptySetPool.length < exports.POOL_TARGET_SIZE) {
        emptySetPool.push(dc);
      }
      entry.dirtyChildren = null;
    }
  }
}

function rememberParent(entry) {
  var local = getLocal();
  var parent = local.currentParentEntry;
  if (parent) {
    entry.parents.add(parent);

    if (! parent.childValues.has(entry)) {
      parent.childValues.set(entry, UNKNOWN_VALUE);
    }

    if (mightBeDirty(entry)) {
      reportDirtyChild(parent, entry);
    } else {
      reportCleanChild(parent, entry);
    }

    return parent;
  }
}

// This is the most important method of the Entry API, because it
// determines whether the cached entry.value can be returned immediately,
// or must be recomputed. The overall performance of the caching system
// depends on the truth of the following observations: (1) this.dirty is
// usually false, (2) this.dirtyChildren is usually null/empty, and thus
// (3) this.value is usally returned very quickly, without recomputation.
function recomputeIfDirty(entry) {
  if (entry.dirty) {
    // If this Entry is explicitly dirty because someone called
    // entry.setDirty(), recompute.
    return reallyRecompute(entry);
  }

  if (mightBeDirty(entry)) {
    // Get fresh values for any dirty children, and if those values
    // disagree with this.childValues, mark this Entry explicitly dirty.
    entry.dirtyChildren.forEach(function (child) {
      assert(entry.childValues.has(child));
      try {
        recomputeIfDirty(child);
      } catch (e) {
        entry.setDirty();
      }
    });

    if (entry.dirty) {
      // If this Entry has become explicitly dirty after comparing the fresh
      // values of its dirty children against this.childValues, recompute.
      return reallyRecompute(entry);
    }
  }

  assert(entry.value !== UNKNOWN_VALUE);

  return entry.value;
}

function reallyRecompute(entry) {
  assert(! entry.recomputing, "already recomputing");
  entry.recomputing = true;

  // Since this recomputation is likely to re-remember some of this
  // entry's children, we forget our children here but do not call
  // maybeReportOrphan until after the recomputation finishes.
  var originalChildren = forgetChildren(entry);

  var local = getLocal();
  var parent = local.currentParentEntry;
  local.currentParentEntry = entry;

  var threw = true;
  try {
    entry.value = entry.fn.apply(null, entry.args);
    threw = false;

  } finally {
    entry.recomputing = false;

    assert(local.currentParentEntry === entry);
    local.currentParentEntry = parent;

    if (threw || ! subscribe(entry)) {
      // Mark this Entry dirty if entry.fn threw or we failed to
      // resubscribe. This is important because, if we have a subscribe
      // function and it failed, then we're going to miss important
      // notifications about the potential dirtiness of entry.value.
      entry.setDirty();
    } else {
      // If we successfully recomputed entry.value and did not fail to
      // (re)subscribe, then this Entry is no longer explicitly dirty.
      setClean(entry);
    }
  }

  // Now that we've had a chance to re-remember any children that were
  // involved in the recomputation, we can safely report any orphan
  // children that remain.
  originalChildren.forEach(maybeReportOrphan);

  return entry.value;
}

var reusableEmptyArray = [];

// Removes all children from this entry and returns an array of the
// removed children.
function forgetChildren(entry) {
  var children = reusableEmptyArray;

  if (entry.childValues.size > 0) {
    children = [];
    entry.childValues.forEach(function (value, child) {
      forgetChild(entry, child);
      children.push(child);
    });
  }

  // After we forget all our children, this.dirtyChildren must be empty
  // and therefor must have been reset to null.
  assert(entry.dirtyChildren === null);

  return children;
}

function forgetChild(entry, child) {
  child.parents.delete(entry);
  entry.childValues.delete(child);
  removeDirtyChild(entry, child);
}

function subscribe(entry) {
  if (typeof entry.subscribe === "function") {
    try {
      unsubscribe(entry); // Prevent double subscriptions.
      entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
      // If this Entry has a subscribe function and it threw an exception
      // (or an unsubscribe function it previously returned now throws),
      // return false to indicate that we were not able to subscribe (or
      // unsubscribe), and this Entry should remain dirty.
      entry.setDirty();
      return false;
    }
  }

  // Returning true indicates either that there was no entry.subscribe
  // function or that it succeeded.
  return true;
}

function unsubscribe(entry) {
  var unsub = entry.unsubscribe;
  if (typeof unsub === "function") {
    entry.unsubscribe = null;
    unsub();
  }
}


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(39);
tslib_1.__exportStar(__webpack_require__(1238), exports);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(39);
var apollo_link_1 = __webpack_require__(344);
var apollo_link_http_common_1 = __webpack_require__(1239);
exports.createHttpLink = function (linkOptions) {
    if (linkOptions === void 0) { linkOptions = {}; }
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, requestOptions = tslib_1.__rest(linkOptions, ["uri", "fetch", "includeExtensions", "useGETForQueries"]);
    apollo_link_http_common_1.checkFetcher(fetcher);
    if (!fetcher) {
        fetcher = fetch;
    }
    var linkConfig = {
        http: { includeExtensions: includeExtensions },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers,
    };
    return new apollo_link_1.ApolloLink(function (operation) {
        var chosenURI = apollo_link_http_common_1.selectURI(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) {
                clientAwarenessHeaders['apollographql-client-name'] = name_1;
            }
            if (version) {
                clientAwarenessHeaders['apollographql-client-version'] = version;
            }
        }
        var contextHeaders = tslib_1.__assign({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders,
        };
        var _b = apollo_link_http_common_1.selectHttpOptionsAndBody(operation, apollo_link_http_common_1.fallbackHttpConfig, linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = apollo_link_http_common_1.createSignalIfSupported(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller)
                options.signal = signal;
        }
        var definitionIsMutation = function (d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries &&
            !operation.query.definitions.some(definitionIsMutation)) {
            options.method = 'GET';
        }
        if (options.method === 'GET') {
            var _d = rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) {
                return apollo_link_1.fromError(parseError);
            }
            chosenURI = newURI;
        }
        else {
            try {
                options.body = apollo_link_http_common_1.serializeFetchParameter(body, 'Payload');
            }
            catch (parseError) {
                return apollo_link_1.fromError(parseError);
            }
        }
        return new apollo_link_1.Observable(function (observer) {
            fetcher(chosenURI, options)
                .then(function (response) {
                operation.setContext({ response: response });
                return response;
            })
                .then(apollo_link_http_common_1.parseAndCheckHttpResponse(operation))
                .then(function (result) {
                observer.next(result);
                observer.complete();
                return result;
            })
                .catch(function (err) {
                if (err.name === 'AbortError')
                    return;
                if (err.result && err.result.errors && err.result.data) {
                    observer.next(err.result);
                }
                observer.error(err);
            });
            return function () {
                if (controller)
                    controller.abort();
            };
        });
    });
};
function rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function (key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) {
        addQueryParam('query', body.query);
    }
    if (body.operationName) {
        addQueryParam('operationName', body.operationName);
    }
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = apollo_link_http_common_1.serializeFetchParameter(body.variables, 'Variables map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = apollo_link_http_common_1.serializeFetchParameter(body.extensions, 'Extensions map');
        }
        catch (parseError) {
            return { parseError: parseError };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return { newURI: newURI };
}
var HttpLink = (function (_super) {
    tslib_1.__extends(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, exports.createHttpLink(opts).request) || this;
    }
    return HttpLink;
}(apollo_link_1.ApolloLink));
exports.HttpLink = HttpLink;
//# sourceMappingURL=httpLink.js.map

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkFetcher", function() { return checkFetcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSignalIfSupported", function() { return createSignalIfSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fallbackHttpConfig", function() { return fallbackHttpConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseAndCheckHttpResponse", function() { return parseAndCheckHttpResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectHttpOptionsAndBody", function() { return selectHttpOptionsAndBody; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectURI", function() { return selectURI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serializeFetchParameter", function() { return serializeFetchParameter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "throwServerError", function() { return throwServerError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_language_printer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ts_invariant__ = __webpack_require__(1240);




var defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
};
var defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json',
};
var defaultOptions = {
    method: 'POST',
};
var fallbackHttpConfig = {
    http: defaultHttpOptions,
    headers: defaultHeaders,
    options: defaultOptions,
};
var throwServerError = function (response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var parseAndCheckHttpResponse = function (operations) { return function (response) {
    return (response
        .text()
        .then(function (bodyText) {
        try {
            return JSON.parse(bodyText);
        }
        catch (err) {
            var parseError = err;
            parseError.name = 'ServerParseError';
            parseError.response = response;
            parseError.statusCode = response.status;
            parseError.bodyText = bodyText;
            return Promise.reject(parseError);
        }
    })
        .then(function (result) {
        if (response.status >= 300) {
            throwServerError(response, result, "Response not successful: Received status code " + response.status);
        }
        if (!Array.isArray(result) &&
            !result.hasOwnProperty('data') &&
            !result.hasOwnProperty('errors')) {
            throwServerError(response, result, "Server response was missing for query '" + (Array.isArray(operations)
                ? operations.map(function (op) { return op.operationName; })
                : operations.operationName) + "'.");
        }
        return result;
    }));
}; };
var checkFetcher = function (fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined')
            library = 'node-fetch';
        throw  true ? new __WEBPACK_IMPORTED_MODULE_2_ts_invariant__["a" /* InvariantError */](1) : new InvariantError("\nfetch is not found globally and no fetcher passed, to fix pass a fetch for\nyour environment like https://www.npmjs.com/package/" + library + ".\n\nFor example:\nimport fetch from '" + library + "';\nimport { createHttpLink } from 'apollo-link-http';\n\nconst link = createHttpLink({ uri: '/graphql', fetch: fetch });");
    }
};
var createSignalIfSupported = function () {
    if (typeof AbortController === 'undefined')
        return { controller: false, signal: false };
    var controller = new AbortController();
    var signal = controller.signal;
    return { controller: controller, signal: signal };
};
var selectHttpOptionsAndBody = function (operation, fallbackConfig) {
    var configs = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        configs[_i - 2] = arguments[_i];
    }
    var options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, fallbackConfig.options, { headers: fallbackConfig.headers, credentials: fallbackConfig.credentials });
    var http = fallbackConfig.http;
    configs.forEach(function (config) {
        options = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, options, config.options, { headers: Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, options.headers, config.headers) });
        if (config.credentials)
            options.credentials = config.credentials;
        http = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = { operationName: operationName, variables: variables };
    if (http.includeExtensions)
        body.extensions = extensions;
    if (http.includeQuery)
        body.query = Object(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__["print"])(query);
    return {
        options: options,
        body: body,
    };
};
var serializeFetchParameter = function (p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    }
    catch (e) {
        var parseError =  true ? new __WEBPACK_IMPORTED_MODULE_2_ts_invariant__["a" /* InvariantError */](2) : new InvariantError("Network request failed. " + label + " is not serializable: " + e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var selectURI = function (operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) {
        return contextURI;
    }
    else if (typeof fallbackURI === 'function') {
        return fallbackURI(operation);
    }
    else {
        return fallbackURI || '/graphql';
    }
};


//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InvariantError; });
/* unused harmony export invariant */
/* unused harmony export process */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(39);


var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
function wrapConsoleMethod(method) {
    return function () {
        return console[method].apply(console, arguments);
    };
}
(function (invariant) {
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var processStub = { env: {} };
if (typeof process === "object") {
    processStub = process;
}
else
    try {
        // Using Function to evaluate this assignment in global scope also escapes
        // the strict mode of the current module, thereby allowing the assignment.
        // Inspired by https://github.com/facebook/regenerator/pull/369.
        Function("stub", "process = stub")(processStub);
    }
    catch (atLeastWeTried) {
        // The assignment can fail if a Content Security Policy heavy-handedly
        // forbids Function usage. In those environments, developers should take
        // extra care to replace process.env.NODE_ENV in their production builds,
        // or define an appropriate global.process polyfill.
    }
var invariant$1 = invariant;

/* unused harmony default export */ var _unused_webpack_default_export = (invariant$1);

//# sourceMappingURL=invariant.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(83)))

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(39);
var apollo_link_1 = __webpack_require__(344);
function onError(errorHandler) {
    return new apollo_link_1.ApolloLink(function (operation, forward) {
        return new apollo_link_1.Observable(function (observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function (result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward,
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer),
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function (networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError &&
                                networkError.result &&
                                networkError.result.errors,
                            forward: forward,
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer),
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function () {
                        if (!retriedResult) {
                            observer.complete.bind(observer)();
                        }
                    },
                });
            }
            catch (e) {
                errorHandler({ networkError: e, operation: operation, forward: forward });
                observer.error(e);
            }
            return function () {
                if (sub)
                    sub.unsubscribe();
                if (retriedSub)
                    sub.unsubscribe();
            };
        });
    });
}
exports.onError = onError;
var ErrorLink = (function (_super) {
    tslib_1.__extends(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = onError(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function (operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}(apollo_link_1.ApolloLink));
exports.ErrorLink = ErrorLink;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(39);
tslib_1.__exportStar(__webpack_require__(1243), exports);
var linkUtils_1 = __webpack_require__(541);
exports.createOperation = linkUtils_1.createOperation;
exports.makePromise = linkUtils_1.makePromise;
exports.toPromise = linkUtils_1.toPromise;
exports.fromPromise = linkUtils_1.fromPromise;
exports.fromError = linkUtils_1.fromError;
exports.getOperationName = linkUtils_1.getOperationName;
var zen_observable_ts_1 = tslib_1.__importDefault(__webpack_require__(130));
exports.Observable = zen_observable_ts_1.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(39);
var zen_observable_ts_1 = tslib_1.__importDefault(__webpack_require__(130));
var ts_invariant_1 = __webpack_require__(345);
var linkUtils_1 = __webpack_require__(541);
function passthrough(op, forward) {
    return forward ? forward(op) : zen_observable_ts_1.default.of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function () { return zen_observable_ts_1.default.of(); });
}
exports.empty = empty;
function from(links) {
    if (links.length === 0)
        return empty();
    return links.map(toLink).reduce(function (x, y) { return x.concat(y); });
}
exports.from = from;
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (linkUtils_1.isTerminating(leftLink) && linkUtils_1.isTerminating(rightLink)) {
        return new ApolloLink(function (operation) {
            return test(operation)
                ? leftLink.request(operation) || zen_observable_ts_1.default.of()
                : rightLink.request(operation) || zen_observable_ts_1.default.of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return test(operation)
                ? leftLink.request(operation, forward) || zen_observable_ts_1.default.of()
                : rightLink.request(operation, forward) || zen_observable_ts_1.default.of();
        });
    }
}
exports.split = split;
exports.concat = function (first, second) {
    var firstLink = toLink(first);
    if (linkUtils_1.isTerminating(firstLink)) {
        ts_invariant_1.invariant.warn(new linkUtils_1.LinkError("You are calling concat on a terminating link, which will have no effect", firstLink));
        return firstLink;
    }
    var nextLink = toLink(second);
    if (linkUtils_1.isTerminating(nextLink)) {
        return new ApolloLink(function (operation) {
            return firstLink.request(operation, function (op) { return nextLink.request(op) || zen_observable_ts_1.default.of(); }) || zen_observable_ts_1.default.of();
        });
    }
    else {
        return new ApolloLink(function (operation, forward) {
            return (firstLink.request(operation, function (op) {
                return nextLink.request(op, forward) || zen_observable_ts_1.default.of();
            }) || zen_observable_ts_1.default.of());
        });
    }
};
var ApolloLink = (function () {
    function ApolloLink(request) {
        if (request)
            this.request = request;
    }
    ApolloLink.prototype.split = function (test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function (next) {
        return exports.concat(this, next);
    };
    ApolloLink.prototype.request = function (operation, forward) {
        throw new ts_invariant_1.InvariantError('request is not implemented');
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}());
exports.ApolloLink = ApolloLink;
function execute(link, operation) {
    return (link.request(linkUtils_1.createOperation(operation.context, linkUtils_1.transformOperation(linkUtils_1.validateOperation(operation)))) || zen_observable_ts_1.default.of());
}
exports.execute = execute;
//# sourceMappingURL=link.js.map

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = parse;
exports.parseValue = parseValue;
exports.parseType = parseType;
exports.parseConstValue = parseConstValue;
exports.parseTypeReference = parseTypeReference;
exports.parseNamedType = parseNamedType;

var _inspect = _interopRequireDefault(__webpack_require__(533));

var _defineToJSON = _interopRequireDefault(__webpack_require__(543));

var _source = __webpack_require__(1245);

var _error = __webpack_require__(545);

var _lexer = __webpack_require__(1250);

var _kinds = __webpack_require__(1252);

var _directiveLocation = __webpack_require__(1253);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;

  if (!(sourceObj instanceof _source.Source)) {
    throw new TypeError("Must provide Source. Received: ".concat((0, _inspect.default)(sourceObj)));
  }

  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
  return parseDocument(lexer);
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */


function parseValue(source, options) {
  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
  expect(lexer, _lexer.TokenKind.SOF);
  var value = parseValueLiteral(lexer, false);
  expect(lexer, _lexer.TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */


function parseType(source, options) {
  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
  expect(lexer, _lexer.TokenKind.SOF);
  var type = parseTypeReference(lexer);
  expect(lexer, _lexer.TokenKind.EOF);
  return type;
}
/**
 * Converts a name lex token into a name parse node.
 */


function parseName(lexer) {
  var token = expect(lexer, _lexer.TokenKind.NAME);
  return {
    kind: _kinds.Kind.NAME,
    value: token.value,
    loc: loc(lexer, token)
  };
} // Implements the parsing rules in the Document section.

/**
 * Document : Definition+
 */


function parseDocument(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.DOCUMENT,
    definitions: many(lexer, _lexer.TokenKind.SOF, parseDefinition, _lexer.TokenKind.EOF),
    loc: loc(lexer, start)
  };
}
/**
 * Definition :
 *   - ExecutableDefinition
 *   - TypeSystemDefinition
 *   - TypeSystemExtension
 */


function parseDefinition(lexer) {
  if (peek(lexer, _lexer.TokenKind.NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
      case 'fragment':
        return parseExecutableDefinition(lexer);

      case 'schema':
      case 'scalar':
      case 'type':
      case 'interface':
      case 'union':
      case 'enum':
      case 'input':
      case 'directive':
        return parseTypeSystemDefinition(lexer);

      case 'extend':
        return parseTypeSystemExtension(lexer);
    }
  } else if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
    return parseExecutableDefinition(lexer);
  } else if (peekDescription(lexer)) {
    return parseTypeSystemDefinition(lexer);
  }

  throw unexpected(lexer);
}
/**
 * ExecutableDefinition :
 *   - OperationDefinition
 *   - FragmentDefinition
 */


function parseExecutableDefinition(lexer) {
  if (peek(lexer, _lexer.TokenKind.NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
        return parseOperationDefinition(lexer);

      case 'fragment':
        return parseFragmentDefinition(lexer);
    }
  } else if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
    return parseOperationDefinition(lexer);
  }

  throw unexpected(lexer);
} // Implements the parsing rules in the Operations section.

/**
 * OperationDefinition :
 *  - SelectionSet
 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
 */


function parseOperationDefinition(lexer) {
  var start = lexer.token;

  if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
    return {
      kind: _kinds.Kind.OPERATION_DEFINITION,
      operation: 'query',
      name: undefined,
      variableDefinitions: [],
      directives: [],
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }

  var operation = parseOperationType(lexer);
  var name;

  if (peek(lexer, _lexer.TokenKind.NAME)) {
    name = parseName(lexer);
  }

  return {
    kind: _kinds.Kind.OPERATION_DEFINITION,
    operation: operation,
    name: name,
    variableDefinitions: parseVariableDefinitions(lexer),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * OperationType : one of query mutation subscription
 */


function parseOperationType(lexer) {
  var operationToken = expect(lexer, _lexer.TokenKind.NAME);

  switch (operationToken.value) {
    case 'query':
      return 'query';

    case 'mutation':
      return 'mutation';

    case 'subscription':
      return 'subscription';
  }

  throw unexpected(lexer, operationToken);
}
/**
 * VariableDefinitions : ( VariableDefinition+ )
 */


function parseVariableDefinitions(lexer) {
  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseVariableDefinition, _lexer.TokenKind.PAREN_R) : [];
}
/**
 * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
 */


function parseVariableDefinition(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.VARIABLE_DEFINITION,
    variable: parseVariable(lexer),
    type: (expect(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
    defaultValue: skip(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : undefined,
    directives: parseDirectives(lexer, true),
    loc: loc(lexer, start)
  };
}
/**
 * Variable : $ Name
 */


function parseVariable(lexer) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.DOLLAR);
  return {
    kind: _kinds.Kind.VARIABLE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * SelectionSet : { Selection+ }
 */


function parseSelectionSet(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.SELECTION_SET,
    selections: many(lexer, _lexer.TokenKind.BRACE_L, parseSelection, _lexer.TokenKind.BRACE_R),
    loc: loc(lexer, start)
  };
}
/**
 * Selection :
 *   - Field
 *   - FragmentSpread
 *   - InlineFragment
 */


function parseSelection(lexer) {
  return peek(lexer, _lexer.TokenKind.SPREAD) ? parseFragment(lexer) : parseField(lexer);
}
/**
 * Field : Alias? Name Arguments? Directives? SelectionSet?
 *
 * Alias : Name :
 */


function parseField(lexer) {
  var start = lexer.token;
  var nameOrAlias = parseName(lexer);
  var alias;
  var name;

  if (skip(lexer, _lexer.TokenKind.COLON)) {
    alias = nameOrAlias;
    name = parseName(lexer);
  } else {
    name = nameOrAlias;
  }

  return {
    kind: _kinds.Kind.FIELD,
    alias: alias,
    name: name,
    arguments: parseArguments(lexer, false),
    directives: parseDirectives(lexer, false),
    selectionSet: peek(lexer, _lexer.TokenKind.BRACE_L) ? parseSelectionSet(lexer) : undefined,
    loc: loc(lexer, start)
  };
}
/**
 * Arguments[Const] : ( Argument[?Const]+ )
 */


function parseArguments(lexer, isConst) {
  var item = isConst ? parseConstArgument : parseArgument;
  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, item, _lexer.TokenKind.PAREN_R) : [];
}
/**
 * Argument[Const] : Name : Value[?Const]
 */


function parseArgument(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, false)),
    loc: loc(lexer, start)
  };
}

function parseConstArgument(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, _lexer.TokenKind.COLON), parseConstValue(lexer)),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Fragments section.

/**
 * Corresponds to both FragmentSpread and InlineFragment in the spec.
 *
 * FragmentSpread : ... FragmentName Directives?
 *
 * InlineFragment : ... TypeCondition? Directives? SelectionSet
 */


function parseFragment(lexer) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.SPREAD);
  var hasTypeCondition = skipKeyword(lexer, 'on');

  if (!hasTypeCondition && peek(lexer, _lexer.TokenKind.NAME)) {
    return {
      kind: _kinds.Kind.FRAGMENT_SPREAD,
      name: parseFragmentName(lexer),
      directives: parseDirectives(lexer, false),
      loc: loc(lexer, start)
    };
  }

  return {
    kind: _kinds.Kind.INLINE_FRAGMENT,
    typeCondition: hasTypeCondition ? parseNamedType(lexer) : undefined,
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * FragmentDefinition :
 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
 *
 * TypeCondition : NamedType
 */


function parseFragmentDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'fragment'); // Experimental support for defining variables within fragments changes
  // the grammar of FragmentDefinition:
  //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

  if (lexer.options.experimentalFragmentVariables) {
    return {
      kind: _kinds.Kind.FRAGMENT_DEFINITION,
      name: parseFragmentName(lexer),
      variableDefinitions: parseVariableDefinitions(lexer),
      typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
      directives: parseDirectives(lexer, false),
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }

  return {
    kind: _kinds.Kind.FRAGMENT_DEFINITION,
    name: parseFragmentName(lexer),
    typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * FragmentName : Name but not `on`
 */


function parseFragmentName(lexer) {
  if (lexer.token.value === 'on') {
    throw unexpected(lexer);
  }

  return parseName(lexer);
} // Implements the parsing rules in the Values section.

/**
 * Value[Const] :
 *   - [~Const] Variable
 *   - IntValue
 *   - FloatValue
 *   - StringValue
 *   - BooleanValue
 *   - NullValue
 *   - EnumValue
 *   - ListValue[?Const]
 *   - ObjectValue[?Const]
 *
 * BooleanValue : one of `true` `false`
 *
 * NullValue : `null`
 *
 * EnumValue : Name but not `true`, `false` or `null`
 */


function parseValueLiteral(lexer, isConst) {
  var token = lexer.token;

  switch (token.kind) {
    case _lexer.TokenKind.BRACKET_L:
      return parseList(lexer, isConst);

    case _lexer.TokenKind.BRACE_L:
      return parseObject(lexer, isConst);

    case _lexer.TokenKind.INT:
      lexer.advance();
      return {
        kind: _kinds.Kind.INT,
        value: token.value,
        loc: loc(lexer, token)
      };

    case _lexer.TokenKind.FLOAT:
      lexer.advance();
      return {
        kind: _kinds.Kind.FLOAT,
        value: token.value,
        loc: loc(lexer, token)
      };

    case _lexer.TokenKind.STRING:
    case _lexer.TokenKind.BLOCK_STRING:
      return parseStringLiteral(lexer);

    case _lexer.TokenKind.NAME:
      if (token.value === 'true' || token.value === 'false') {
        lexer.advance();
        return {
          kind: _kinds.Kind.BOOLEAN,
          value: token.value === 'true',
          loc: loc(lexer, token)
        };
      } else if (token.value === 'null') {
        lexer.advance();
        return {
          kind: _kinds.Kind.NULL,
          loc: loc(lexer, token)
        };
      }

      lexer.advance();
      return {
        kind: _kinds.Kind.ENUM,
        value: token.value,
        loc: loc(lexer, token)
      };

    case _lexer.TokenKind.DOLLAR:
      if (!isConst) {
        return parseVariable(lexer);
      }

      break;
  }

  throw unexpected(lexer);
}

function parseStringLiteral(lexer) {
  var token = lexer.token;
  lexer.advance();
  return {
    kind: _kinds.Kind.STRING,
    value: token.value,
    block: token.kind === _lexer.TokenKind.BLOCK_STRING,
    loc: loc(lexer, token)
  };
}

function parseConstValue(lexer) {
  return parseValueLiteral(lexer, true);
}

function parseValueValue(lexer) {
  return parseValueLiteral(lexer, false);
}
/**
 * ListValue[Const] :
 *   - [ ]
 *   - [ Value[?Const]+ ]
 */


function parseList(lexer, isConst) {
  var start = lexer.token;
  var item = isConst ? parseConstValue : parseValueValue;
  return {
    kind: _kinds.Kind.LIST,
    values: any(lexer, _lexer.TokenKind.BRACKET_L, item, _lexer.TokenKind.BRACKET_R),
    loc: loc(lexer, start)
  };
}
/**
 * ObjectValue[Const] :
 *   - { }
 *   - { ObjectField[?Const]+ }
 */


function parseObject(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.BRACE_L);
  var fields = [];

  while (!skip(lexer, _lexer.TokenKind.BRACE_R)) {
    fields.push(parseObjectField(lexer, isConst));
  }

  return {
    kind: _kinds.Kind.OBJECT,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * ObjectField[Const] : Name : Value[?Const]
 */


function parseObjectField(lexer, isConst) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.OBJECT_FIELD,
    name: parseName(lexer),
    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, isConst)),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Directives section.

/**
 * Directives[Const] : Directive[?Const]+
 */


function parseDirectives(lexer, isConst) {
  var directives = [];

  while (peek(lexer, _lexer.TokenKind.AT)) {
    directives.push(parseDirective(lexer, isConst));
  }

  return directives;
}
/**
 * Directive[Const] : @ Name Arguments[?Const]?
 */


function parseDirective(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.AT);
  return {
    kind: _kinds.Kind.DIRECTIVE,
    name: parseName(lexer),
    arguments: parseArguments(lexer, isConst),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Types section.

/**
 * Type :
 *   - NamedType
 *   - ListType
 *   - NonNullType
 */


function parseTypeReference(lexer) {
  var start = lexer.token;
  var type;

  if (skip(lexer, _lexer.TokenKind.BRACKET_L)) {
    type = parseTypeReference(lexer);
    expect(lexer, _lexer.TokenKind.BRACKET_R);
    type = {
      kind: _kinds.Kind.LIST_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  } else {
    type = parseNamedType(lexer);
  }

  if (skip(lexer, _lexer.TokenKind.BANG)) {
    return {
      kind: _kinds.Kind.NON_NULL_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  }

  return type;
}
/**
 * NamedType : Name
 */


function parseNamedType(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.NAMED_TYPE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Type Definition section.

/**
 * TypeSystemDefinition :
 *   - SchemaDefinition
 *   - TypeDefinition
 *   - DirectiveDefinition
 *
 * TypeDefinition :
 *   - ScalarTypeDefinition
 *   - ObjectTypeDefinition
 *   - InterfaceTypeDefinition
 *   - UnionTypeDefinition
 *   - EnumTypeDefinition
 *   - InputObjectTypeDefinition
 */


function parseTypeSystemDefinition(lexer) {
  // Many definitions begin with a description and require a lookahead.
  var keywordToken = peekDescription(lexer) ? lexer.lookahead() : lexer.token;

  if (keywordToken.kind === _lexer.TokenKind.NAME) {
    switch (keywordToken.value) {
      case 'schema':
        return parseSchemaDefinition(lexer);

      case 'scalar':
        return parseScalarTypeDefinition(lexer);

      case 'type':
        return parseObjectTypeDefinition(lexer);

      case 'interface':
        return parseInterfaceTypeDefinition(lexer);

      case 'union':
        return parseUnionTypeDefinition(lexer);

      case 'enum':
        return parseEnumTypeDefinition(lexer);

      case 'input':
        return parseInputObjectTypeDefinition(lexer);

      case 'directive':
        return parseDirectiveDefinition(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}

function peekDescription(lexer) {
  return peek(lexer, _lexer.TokenKind.STRING) || peek(lexer, _lexer.TokenKind.BLOCK_STRING);
}
/**
 * Description : StringValue
 */


function parseDescription(lexer) {
  if (peekDescription(lexer)) {
    return parseStringLiteral(lexer);
  }
}
/**
 * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
 */


function parseSchemaDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'schema');
  var directives = parseDirectives(lexer, true);
  var operationTypes = many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R);
  return {
    kind: _kinds.Kind.SCHEMA_DEFINITION,
    directives: directives,
    operationTypes: operationTypes,
    loc: loc(lexer, start)
  };
}
/**
 * OperationTypeDefinition : OperationType : NamedType
 */


function parseOperationTypeDefinition(lexer) {
  var start = lexer.token;
  var operation = parseOperationType(lexer);
  expect(lexer, _lexer.TokenKind.COLON);
  var type = parseNamedType(lexer);
  return {
    kind: _kinds.Kind.OPERATION_TYPE_DEFINITION,
    operation: operation,
    type: type,
    loc: loc(lexer, start)
  };
}
/**
 * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
 */


function parseScalarTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.SCALAR_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * ObjectTypeDefinition :
 *   Description?
 *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
 */


function parseObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: _kinds.Kind.OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * ImplementsInterfaces :
 *   - implements `&`? NamedType
 *   - ImplementsInterfaces & NamedType
 */


function parseImplementsInterfaces(lexer) {
  var types = [];

  if (skipKeyword(lexer, 'implements')) {
    // Optional leading ampersand
    skip(lexer, _lexer.TokenKind.AMP);

    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, _lexer.TokenKind.AMP) || // Legacy support for the SDL?
    lexer.options.allowLegacySDLImplementsInterfaces && peek(lexer, _lexer.TokenKind.NAME));
  }

  return types;
}
/**
 * FieldsDefinition : { FieldDefinition+ }
 */


function parseFieldsDefinition(lexer) {
  // Legacy support for the SDL?
  if (lexer.options.allowLegacySDLEmptyFields && peek(lexer, _lexer.TokenKind.BRACE_L) && lexer.lookahead().kind === _lexer.TokenKind.BRACE_R) {
    lexer.advance();
    lexer.advance();
    return [];
  }

  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * FieldDefinition :
 *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
 */


function parseFieldDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expect(lexer, _lexer.TokenKind.COLON);
  var type = parseTypeReference(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.FIELD_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    type: type,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * ArgumentsDefinition : ( InputValueDefinition+ )
 */


function parseArgumentDefs(lexer) {
  if (!peek(lexer, _lexer.TokenKind.PAREN_L)) {
    return [];
  }

  return many(lexer, _lexer.TokenKind.PAREN_L, parseInputValueDef, _lexer.TokenKind.PAREN_R);
}
/**
 * InputValueDefinition :
 *   - Description? Name : Type DefaultValue? Directives[Const]?
 */


function parseInputValueDef(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  expect(lexer, _lexer.TokenKind.COLON);
  var type = parseTypeReference(lexer);
  var defaultValue;

  if (skip(lexer, _lexer.TokenKind.EQUALS)) {
    defaultValue = parseConstValue(lexer);
  }

  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.INPUT_VALUE_DEFINITION,
    description: description,
    name: name,
    type: type,
    defaultValue: defaultValue,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * InterfaceTypeDefinition :
 *   - Description? interface Name Directives[Const]? FieldsDefinition?
 */


function parseInterfaceTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: _kinds.Kind.INTERFACE_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * UnionTypeDefinition :
 *   - Description? union Name Directives[Const]? UnionMemberTypes?
 */


function parseUnionTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);
  return {
    kind: _kinds.Kind.UNION_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}
/**
 * UnionMemberTypes :
 *   - = `|`? NamedType
 *   - UnionMemberTypes | NamedType
 */


function parseUnionMemberTypes(lexer) {
  var types = [];

  if (skip(lexer, _lexer.TokenKind.EQUALS)) {
    // Optional leading pipe
    skip(lexer, _lexer.TokenKind.PIPE);

    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, _lexer.TokenKind.PIPE));
  }

  return types;
}
/**
 * EnumTypeDefinition :
 *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
 */


function parseEnumTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);
  return {
    kind: _kinds.Kind.ENUM_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}
/**
 * EnumValuesDefinition : { EnumValueDefinition+ }
 */


function parseEnumValuesDefinition(lexer) {
  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseEnumValueDefinition, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * EnumValueDefinition : Description? EnumValue Directives[Const]?
 *
 * EnumValue : Name
 */


function parseEnumValueDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.ENUM_VALUE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * InputObjectTypeDefinition :
 *   - Description? input Name Directives[Const]? InputFieldsDefinition?
 */


function parseInputObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);
  return {
    kind: _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * InputFieldsDefinition : { InputValueDefinition+ }
 */


function parseInputFieldsDefinition(lexer) {
  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseInputValueDef, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * TypeSystemExtension :
 *   - SchemaExtension
 *   - TypeExtension
 *
 * TypeExtension :
 *   - ScalarTypeExtension
 *   - ObjectTypeExtension
 *   - InterfaceTypeExtension
 *   - UnionTypeExtension
 *   - EnumTypeExtension
 *   - InputObjectTypeDefinition
 */


function parseTypeSystemExtension(lexer) {
  var keywordToken = lexer.lookahead();

  if (keywordToken.kind === _lexer.TokenKind.NAME) {
    switch (keywordToken.value) {
      case 'schema':
        return parseSchemaExtension(lexer);

      case 'scalar':
        return parseScalarTypeExtension(lexer);

      case 'type':
        return parseObjectTypeExtension(lexer);

      case 'interface':
        return parseInterfaceTypeExtension(lexer);

      case 'union':
        return parseUnionTypeExtension(lexer);

      case 'enum':
        return parseEnumTypeExtension(lexer);

      case 'input':
        return parseInputObjectTypeExtension(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}
/**
 * SchemaExtension :
 *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
 *  - extend schema Directives[Const]
 */


function parseSchemaExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'schema');
  var directives = parseDirectives(lexer, true);
  var operationTypes = peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R) : [];

  if (directives.length === 0 && operationTypes.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.SCHEMA_EXTENSION,
    directives: directives,
    operationTypes: operationTypes,
    loc: loc(lexer, start)
  };
}
/**
 * ScalarTypeExtension :
 *   - extend scalar Name Directives[Const]
 */


function parseScalarTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);

  if (directives.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.SCALAR_TYPE_EXTENSION,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * ObjectTypeExtension :
 *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
 *  - extend type Name ImplementsInterfaces? Directives[Const]
 *  - extend type Name ImplementsInterfaces
 */


function parseObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);

  if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.OBJECT_TYPE_EXTENSION,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * InterfaceTypeExtension :
 *   - extend interface Name Directives[Const]? FieldsDefinition
 *   - extend interface Name Directives[Const]
 */


function parseInterfaceTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);

  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.INTERFACE_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * UnionTypeExtension :
 *   - extend union Name Directives[Const]? UnionMemberTypes
 *   - extend union Name Directives[Const]
 */


function parseUnionTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);

  if (directives.length === 0 && types.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.UNION_TYPE_EXTENSION,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}
/**
 * EnumTypeExtension :
 *   - extend enum Name Directives[Const]? EnumValuesDefinition
 *   - extend enum Name Directives[Const]
 */


function parseEnumTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);

  if (directives.length === 0 && values.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.ENUM_TYPE_EXTENSION,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}
/**
 * InputObjectTypeExtension :
 *   - extend input Name Directives[Const]? InputFieldsDefinition
 *   - extend input Name Directives[Const]
 */


function parseInputObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);

  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * DirectiveDefinition :
 *   - Description? directive @ Name ArgumentsDefinition? on DirectiveLocations
 */


function parseDirectiveDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'directive');
  expect(lexer, _lexer.TokenKind.AT);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expectKeyword(lexer, 'on');
  var locations = parseDirectiveLocations(lexer);
  return {
    kind: _kinds.Kind.DIRECTIVE_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    locations: locations,
    loc: loc(lexer, start)
  };
}
/**
 * DirectiveLocations :
 *   - `|`? DirectiveLocation
 *   - DirectiveLocations | DirectiveLocation
 */


function parseDirectiveLocations(lexer) {
  // Optional leading pipe
  skip(lexer, _lexer.TokenKind.PIPE);
  var locations = [];

  do {
    locations.push(parseDirectiveLocation(lexer));
  } while (skip(lexer, _lexer.TokenKind.PIPE));

  return locations;
}
/*
 * DirectiveLocation :
 *   - ExecutableDirectiveLocation
 *   - TypeSystemDirectiveLocation
 *
 * ExecutableDirectiveLocation : one of
 *   `QUERY`
 *   `MUTATION`
 *   `SUBSCRIPTION`
 *   `FIELD`
 *   `FRAGMENT_DEFINITION`
 *   `FRAGMENT_SPREAD`
 *   `INLINE_FRAGMENT`
 *
 * TypeSystemDirectiveLocation : one of
 *   `SCHEMA`
 *   `SCALAR`
 *   `OBJECT`
 *   `FIELD_DEFINITION`
 *   `ARGUMENT_DEFINITION`
 *   `INTERFACE`
 *   `UNION`
 *   `ENUM`
 *   `ENUM_VALUE`
 *   `INPUT_OBJECT`
 *   `INPUT_FIELD_DEFINITION`
 */


function parseDirectiveLocation(lexer) {
  var start = lexer.token;
  var name = parseName(lexer);

  if (_directiveLocation.DirectiveLocation.hasOwnProperty(name.value)) {
    return name;
  }

  throw unexpected(lexer, start);
} // Core parsing utility functions

/**
 * Returns a location object, used to identify the place in
 * the source that created a given parsed object.
 */


function loc(lexer, startToken) {
  if (!lexer.options.noLocation) {
    return new Loc(startToken, lexer.lastToken, lexer.source);
  }
}

function Loc(startToken, endToken, source) {
  this.start = startToken.start;
  this.end = endToken.end;
  this.startToken = startToken;
  this.endToken = endToken;
  this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.


(0, _defineToJSON.default)(Loc, function () {
  return {
    start: this.start,
    end: this.end
  };
});
/**
 * Determines if the next token is of a given kind
 */

function peek(lexer, kind) {
  return lexer.token.kind === kind;
}
/**
 * If the next token is of the given kind, return true after advancing
 * the lexer. Otherwise, do not change the parser state and return false.
 */


function skip(lexer, kind) {
  if (lexer.token.kind === kind) {
    lexer.advance();
    return true;
  }

  return false;
}
/**
 * If the next token is of the given kind, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and throw an error.
 */


function expect(lexer, kind) {
  var token = lexer.token;

  if (token.kind === kind) {
    lexer.advance();
    return token;
  }

  throw (0, _error.syntaxError)(lexer.source, token.start, "Expected ".concat(kind, ", found ").concat((0, _lexer.getTokenDesc)(token)));
}
/**
 * If the next token is a keyword with the given value, return true after advancing
 * the lexer. Otherwise, do not change the parser state and return false.
 */


function skipKeyword(lexer, value) {
  var token = lexer.token;

  if (token.kind === _lexer.TokenKind.NAME && token.value === value) {
    lexer.advance();
    return true;
  }

  return false;
}
/**
 * If the next token is a keyword with the given value, return that token after
 * advancing the lexer. Otherwise, do not change the parser state and throw
 * an error.
 */


function expectKeyword(lexer, value) {
  if (!skipKeyword(lexer, value)) {
    throw (0, _error.syntaxError)(lexer.source, lexer.token.start, "Expected \"".concat(value, "\", found ").concat((0, _lexer.getTokenDesc)(lexer.token)));
  }
}
/**
 * Helper function for creating an error when an unexpected lexed token
 * is encountered.
 */


function unexpected(lexer, atToken) {
  var token = atToken || lexer.token;
  return (0, _error.syntaxError)(lexer.source, token.start, "Unexpected ".concat((0, _lexer.getTokenDesc)(token)));
}
/**
 * Returns a possibly empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */


function any(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [];

  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }

  return nodes;
}
/**
 * Returns a non-empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */


function many(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [parseFn(lexer)];

  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }

  return nodes;
}

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Source = void 0;

var _invariant = _interopRequireDefault(__webpack_require__(544));

var _defineToStringTag = _interopRequireDefault(__webpack_require__(1246));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */
var Source = function Source(body, name, locationOffset) {
  this.body = body;
  this.name = name || 'GraphQL request';
  this.locationOffset = locationOffset || {
    line: 1,
    column: 1
  };
  !(this.locationOffset.line > 0) ? (0, _invariant.default)(0, 'line in locationOffset is 1-indexed and must be positive') : void 0;
  !(this.locationOffset.column > 0) ? (0, _invariant.default)(0, 'column in locationOffset is 1-indexed and must be positive') : void 0;
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.Source = Source;
(0, _defineToStringTag.default)(Source);

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defineToStringTag;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * The `defineToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method defineToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */
function defineToStringTag(classObject) {
  if (typeof Symbol === 'function' && Symbol.toStringTag) {
    Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
      get: function get() {
        return this.constructor.name;
      }
    });
  }
}

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syntaxError = syntaxError;

var _GraphQLError = __webpack_require__(350);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */
function syntaxError(source, position, description) {
  return new _GraphQLError.GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locatedError = locatedError;

var _GraphQLError = __webpack_require__(350);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * Given an arbitrary Error, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */
function locatedError(originalError, nodes, path) {
  // Note: this uses a brand-check to support GraphQL errors originating from
  // other contexts.
  if (originalError && Array.isArray(originalError.path)) {
    return originalError;
  }

  return new _GraphQLError.GraphQLError(originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
}

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatError = formatError;

var _invariant = _interopRequireDefault(__webpack_require__(544));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */
function formatError(error) {
  !error ? (0, _invariant.default)(0, 'Received null or undefined error.') : void 0;
  var message = error.message || 'An unknown error occurred.';
  var locations = error.locations;
  var path = error.path;
  var extensions = error.extensions;
  return extensions ? {
    message: message,
    locations: locations,
    path: path,
    extensions: extensions
  } : {
    message: message,
    locations: locations,
    path: path
  };
}

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLexer = createLexer;
exports.getTokenDesc = getTokenDesc;
exports.TokenKind = void 0;

var _defineToJSON = _interopRequireDefault(__webpack_require__(543));

var _error = __webpack_require__(545);

var _blockStringValue = _interopRequireDefault(__webpack_require__(1251));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
function createLexer(source, options) {
  var startOfFileToken = new Tok(TokenKind.SOF, 0, 0, 0, 0, null);
  var lexer = {
    source: source,
    options: options,
    lastToken: startOfFileToken,
    token: startOfFileToken,
    line: 1,
    lineStart: 0,
    advance: advanceLexer,
    lookahead: lookahead
  };
  return lexer;
}

function advanceLexer() {
  this.lastToken = this.token;
  var token = this.token = this.lookahead();
  return token;
}

function lookahead() {
  var token = this.token;

  if (token.kind !== TokenKind.EOF) {
    do {
      // Note: next is only mutable during parsing, so we cast to allow this.
      token = token.next || (token.next = readToken(this, token));
    } while (token.kind === TokenKind.COMMENT);
  }

  return token;
}
/**
 * The return type of createLexer.
 */


/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

exports.TokenKind = TokenKind;

/**
 * A helper function to describe a token as a string for debugging
 */
function getTokenDesc(token) {
  var value = token.value;
  return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
}

var charCodeAt = String.prototype.charCodeAt;
var slice = String.prototype.slice;
/**
 * Helper function for constructing the Token object.
 */

function Tok(kind, start, end, line, column, prev, value) {
  this.kind = kind;
  this.start = start;
  this.end = end;
  this.line = line;
  this.column = column;
  this.value = value;
  this.prev = prev;
  this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.


(0, _defineToJSON.default)(Tok, function () {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
});

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = positionAfterWhitespace(body, prev.end, lexer);
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;

  if (pos >= bodyLength) {
    return new Tok(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
  }

  var code = charCodeAt.call(body, pos); // SourceCharacter

  switch (code) {
    // !
    case 33:
      return new Tok(TokenKind.BANG, pos, pos + 1, line, col, prev);
    // #

    case 35:
      return readComment(source, pos, line, col, prev);
    // $

    case 36:
      return new Tok(TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
    // &

    case 38:
      return new Tok(TokenKind.AMP, pos, pos + 1, line, col, prev);
    // (

    case 40:
      return new Tok(TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
    // )

    case 41:
      return new Tok(TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
    // .

    case 46:
      if (charCodeAt.call(body, pos + 1) === 46 && charCodeAt.call(body, pos + 2) === 46) {
        return new Tok(TokenKind.SPREAD, pos, pos + 3, line, col, prev);
      }

      break;
    // :

    case 58:
      return new Tok(TokenKind.COLON, pos, pos + 1, line, col, prev);
    // =

    case 61:
      return new Tok(TokenKind.EQUALS, pos, pos + 1, line, col, prev);
    // @

    case 64:
      return new Tok(TokenKind.AT, pos, pos + 1, line, col, prev);
    // [

    case 91:
      return new Tok(TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
    // ]

    case 93:
      return new Tok(TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
    // {

    case 123:
      return new Tok(TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
    // |

    case 124:
      return new Tok(TokenKind.PIPE, pos, pos + 1, line, col, prev);
    // }

    case 125:
      return new Tok(TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
    // A-Z _ a-z

    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return readName(source, pos, line, col, prev);
    // - 0-9

    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return readNumber(source, pos, code, line, col, prev);
    // "

    case 34:
      if (charCodeAt.call(body, pos + 1) === 34 && charCodeAt.call(body, pos + 2) === 34) {
        return readBlockString(source, pos, line, col, prev, lexer);
      }

      return readString(source, pos, line, col, prev);
  }

  throw (0, _error.syntaxError)(source, pos, unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return "Unexpected single quote character ('), did you mean to use " + 'a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * character, then returns the position of that character for lexing.
 */


function positionAfterWhitespace(body, startPosition, lexer) {
  var bodyLength = body.length;
  var position = startPosition;

  while (position < bodyLength) {
    var code = charCodeAt.call(body, position); // tab | space | comma | BOM

    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
      ++position;
    } else if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (charCodeAt.call(body, position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else {
      break;
    }
  }

  return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = charCodeAt.call(body, ++position);
  } while (code !== null && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Tok(TokenKind.COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = charCodeAt.call(body, ++position);
  }

  if (code === 48) {
    // 0
    code = charCodeAt.call(body, ++position);

    if (code >= 48 && code <= 57) {
      throw (0, _error.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = charCodeAt.call(body, ++position);
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = charCodeAt.call(body, ++position);

    if (code === 43 || code === 45) {
      // + -
      code = charCodeAt.call(body, ++position);
    }

    position = readDigits(source, position, code);
  }

  return new Tok(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, slice.call(body, start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = charCodeAt.call(body, ++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw (0, _error.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw (0, _error.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += slice.call(body, chunkStart, position - 1);
      code = charCodeAt.call(body, position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          // u
          var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));

          if (charCode < 0) {
            throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: ' + "\\u".concat(body.slice(position + 1, position + 5), "."));
          }

          value += String.fromCharCode(charCode);
          position += 4;
          break;

        default:
          throw (0, _error.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null) {
    // Closing Triple-Quote (""")
    if (code === 34 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34) {
      rawValue += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockStringValue.default)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw (0, _error.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (charCodeAt.call(body, position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34 && charCodeAt.call(body, position + 3) === 34) {
      rawValue += slice.call(body, chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && (code = charCodeAt.call(body, position)) !== null && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new Tok(TokenKind.NAME, start, position, line, col, prev, slice.call(body, start, position));
}

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = blockStringValue;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */
function blockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = null;

  for (var i = 1; i < lines.length; i++) {
    var line = lines[i];
    var indent = leadingWhitespace(line);

    if (indent < line.length && (commonIndent === null || indent < commonIndent)) {
      commonIndent = indent;

      if (commonIndent === 0) {
        break;
      }
    }
  }

  if (commonIndent) {
    for (var _i = 1; _i < lines.length; _i++) {
      lines[_i] = lines[_i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  while (lines.length > 0 && isBlank(lines[0])) {
    lines.shift();
  }

  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
    lines.pop();
  } // Return a string of the lines joined with U+000A.


  return lines.join('\n');
}

function leadingWhitespace(str) {
  var i = 0;

  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
    i++;
  }

  return i;
}

function isBlank(str) {
  return leadingWhitespace(str) === str.length;
}

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Kind = void 0;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */

exports.Kind = Kind;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectiveLocation = void 0;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

exports.DirectiveLocation = DirectiveLocation;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(1255);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(548),
    toKey = __webpack_require__(552);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(223),
    isSymbol = __webpack_require__(351);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(352);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1258 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1260);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1261);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(1262);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1263),
    mapCacheDelete = __webpack_require__(1282),
    mapCacheGet = __webpack_require__(1284),
    mapCacheHas = __webpack_require__(1285),
    mapCacheSet = __webpack_require__(1286);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1264),
    ListCache = __webpack_require__(1275),
    Map = __webpack_require__(1281);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1265),
    hashDelete = __webpack_require__(1271),
    hashGet = __webpack_require__(1272),
    hashHas = __webpack_require__(1273),
    hashSet = __webpack_require__(1274);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(227);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(550),
    isMasked = __webpack_require__(1267),
    isObject = __webpack_require__(354),
    toSource = __webpack_require__(1269);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1268);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(225);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1269 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 1270 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(227);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(227);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(227);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1276),
    listCacheDelete = __webpack_require__(1277),
    listCacheGet = __webpack_require__(1278),
    listCacheHas = __webpack_require__(1279),
    listCacheSet = __webpack_require__(1280);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 1276 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(228);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(228);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(228);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(228);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(353),
    root = __webpack_require__(225);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(229);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1283 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(229);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(229);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(229);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1288);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(352),
    arrayMap = __webpack_require__(1289),
    isArray = __webpack_require__(223),
    isSymbol = __webpack_require__(351);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1289 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(1291);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(1292),
    castPath = __webpack_require__(548),
    isIndex = __webpack_require__(553),
    isObject = __webpack_require__(354),
    toKey = __webpack_require__(552);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(1293),
    eq = __webpack_require__(551);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(1294);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(353);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1296),
    createInverter = __webpack_require__(1297),
    identity = __webpack_require__(1318);

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  result[value] = key;
}, constant(identity));

module.exports = invert;


/***/ }),
/* 1296 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

var baseInverter = __webpack_require__(1298);

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

module.exports = createInverter;


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1299);

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

module.exports = baseInverter;


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1300),
    keys = __webpack_require__(1302);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1301);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1301 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1303),
    baseKeys = __webpack_require__(1313),
    isArrayLike = __webpack_require__(1317);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1304),
    isArguments = __webpack_require__(1305),
    isArray = __webpack_require__(223),
    isBuffer = __webpack_require__(1307),
    isIndex = __webpack_require__(553),
    isTypedArray = __webpack_require__(1309);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 1304 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1306),
    isObjectLike = __webpack_require__(226);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(224),
    isObjectLike = __webpack_require__(226);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(225),
    stubFalse = __webpack_require__(1308);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)(module)))

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1310),
    baseUnary = __webpack_require__(1311),
    nodeUtil = __webpack_require__(1312);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(224),
    isLength = __webpack_require__(554),
    isObjectLike = __webpack_require__(226);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1311 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(549);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(151)(module)))

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(1314),
    nativeKeys = __webpack_require__(1315);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1314 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1316);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1316 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(550),
    isLength = __webpack_require__(554);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 1318 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.transformRastreio=exports.gqlPedidosEntregasRecargas=undefined;var _templateObject=_taggedTemplateLiteral(['\n  query pedidosEntregasRecargas($conta: String!) {\n    buscarPedido(conta: $conta) {\n      pedido\n      data\n    }\n    buscarEntrega(conta: $conta) {\n      arsMestre {\n        id\n        codRastreio\n        tipoRegistro\n        cnpjCpf\n        razaoSocial\n        numeroRegistro\n        codigoRetorno\n        tipoProduto\n        codigoPedido\n        qtdeIdentificadores\n        nome\n        statusPedido\n        dataEntrega\n        peso\n        valor\n        tipoKit\n        identificadores\n        motivo\n        conta\n        codigoCliente\n        dataPrevistaEntrega\n        lote\n      }\n    }\n    temRecarga(conta: $conta) {\n      status\n    }\n  }\n'],['\n  query pedidosEntregasRecargas($conta: String!) {\n    buscarPedido(conta: $conta) {\n      pedido\n      data\n    }\n    buscarEntrega(conta: $conta) {\n      arsMestre {\n        id\n        codRastreio\n        tipoRegistro\n        cnpjCpf\n        razaoSocial\n        numeroRegistro\n        codigoRetorno\n        tipoProduto\n        codigoPedido\n        qtdeIdentificadores\n        nome\n        statusPedido\n        dataEntrega\n        peso\n        valor\n        tipoKit\n        identificadores\n        motivo\n        conta\n        codigoCliente\n        dataPrevistaEntrega\n        lote\n      }\n    }\n    temRecarga(conta: $conta) {\n      status\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlPedidosEntregasRecargas=exports.gqlPedidosEntregasRecargas=(0,_graphqlTag2.default)(_templateObject);var transformRastreio=exports.transformRastreio=function transformRastreio(src,orderNumber){var _src$data=src.data,orders=_src$data.buscarPedido,detailsQuery=_src$data.buscarEntrega,recargaQuery=_src$data.temRecarga;var temRecarga=recargaQuery.status;var detailsList=detailsQuery.arsMestre;var status=temRecarga?'Pagamento Aprovado':'Aguardando pagamento';var order=orders.find(function(o){return parseInt(o.pedido,10)===parseInt(orderNumber,10);});var fullOrder={id:order.pedido,ticket:order.pedido,payment:{id:order.pedido,status:status,date:order.data.split('-').reverse().join('/')},tracker:[]// recuperar envio mais recente
};var orderDetail=detailsList.filter(function(o){return parseInt(o.codigoPedido,10)===parseInt(orderNumber,10);});var transportes=orderDetail&&orderDetail.find(function(d){return d.statusPedido==='TRANSPORTE'||d.statusPedido==='ENTREGUE'||d.statusPedido==='DEVOLVIDO'||d.statusPedido==='EXTRAVIADO';});if(transportes){var transporte=Array.isArray(transportes)?transportes.find(function(d){return d.statusPedido==='TRANSPORTE';}):transportes;var dtEnvio=new Date(parseInt(transporte.dataEntrega,10));fullOrder.tracker.push({id:transporte.id,tipo:'envio',status:'Em Transporte',date:dtEnvio.toISOString().substr(0,10).split('-').reverse().join('/'),showNotArrived:new Date().getTime()>transporte.dataPrevistaEntrega});}else{fullOrder.tracker.push({id:'',tipo:'envio',status:'Em Transporte',date:'',showNotArrived:false});}var entregues=orderDetail&&orderDetail.find(function(d){return d.statusPedido==='ENTREGUE'||d.statusPedido==='DEVOLVIDO'||d.statusPedido==='EXTRAVIADO';});if(!entregues){fullOrder.tracker.push({id:'',tipo:'entrega',status:'Entregue',date:''});}else{var dtEntrega=new Date(parseInt(entregues.dataEntrega,10));fullOrder.tracker.push({id:entregues.id,tipo:'entrega',status:entregues.statusPedido,date:dtEntrega.toISOString().substr(0,10).split('-').reverse().join('/')});}return fullOrder;};

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var getOrderStatus=function getOrderStatus(detailsList,orderNumber){var orderDetailsList=detailsList.filter(function(d){return d.codigoPedido===parseInt(orderNumber,10);});// Recuperar último status
var latestDetails=orderDetailsList.reduce(function(latest,details){return latest&&details.dataEntrega<latest.dataEntrega?latest:details;},{dataEntrega:0,statusPedido:'Processado'});return latestDetails.statusPedido;// verificar se existe algum status diferente de enviado, inpendente da data (este registro tem precedencia)
// Isto trata alguns casos de dados errados onde a data de entrega é inferior a data de envio
// const entregaDetails = orderDetailsList.find(d => d.statusPedido !== 'ENVIADO')
// return entregaDetails ? entregaDetails.statusPedido : latestDetails.statusPedido
};var transformOrders=exports.transformOrders=function transformOrders(_ref,type){var data=_ref.data;var orders=data.buscarPedido,detailsQuery=data.buscarEntrega,recargaQuery=data.temRecarga;var temRecarga=recargaQuery.status;var detailsList=detailsQuery.arsMestre;var paymentStatus='Pedido Realizado';if(type==='pre'){paymentStatus=temRecarga?'Pagamento Aprovado':'Aguardando pagamento';}return orders.map(function(order){var date=order.data||'';var _date$split=date.split('-'),_date$split2=_slicedToArray(_date$split,3),year=_date$split2[0],month=_date$split2[1],day=_date$split2[2];var newDate=date&&day?day+'/'+month+'/'+year:date;var ret={paymentStatus:paymentStatus,number:order.pedido,date:newDate,status:getOrderStatus(detailsList,order.pedido)};return ret;});};

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.gqlTermo=undefined;var _templateObject=_taggedTemplateLiteral(['\n  {\n    buscarTermo {\n      url\n    }\n    buscarTermoPrivacidade {\n      url\n      tipoTermo\n    }\n    buscarManualDoUsuario {\n      url\n      tipoTermo\n    }\n  }\n'],['\n  {\n    buscarTermo {\n      url\n    }\n    buscarTermoPrivacidade {\n      url\n      tipoTermo\n    }\n    buscarManualDoUsuario {\n      url\n      tipoTermo\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlTermo=exports.gqlTermo=(0,_graphqlTag2.default)(_templateObject);

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _accountService=__webpack_require__(64);function fetchCancelAccountTokenCreate(){return function(){return(0,_accountService.createCancelAccountToken)();};}exports.default=fetchCancelAccountTokenCreate;module.exports=exports['default'];

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _accountService=__webpack_require__(64);function fetchCancelAccountTokenValidate(token){return function(){return(0,_accountService.validateCancelAccountToken)(token);};}exports.default=fetchCancelAccountTokenValidate;module.exports=exports['default'];

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=fetchDashboardResume;var _dashboardService=__webpack_require__(66);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_PLAN_RESUME=_types2.default.UPDATE_PLAN_RESUME;function fetchDashboardResume(planId){return function(dispatch){dispatch({type:UPDATE_PLAN_RESUME,planResume:{}});return(0,_dashboardService.getPlanResume)(planId).then(function(planResume){dispatch({type:UPDATE_PLAN_RESUME,planResume:planResume});});};}module.exports=exports['default'];

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getPlans=getPlans;exports.getStatement=getStatement;exports.getReasons=getReasons;exports.getContestationProtocol=getContestationProtocol;var _constants=__webpack_require__(339);var _fetchHandler=__webpack_require__(523);var _fetchHandler2=_interopRequireDefault(_fetchHandler);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// export * from '../services/dashboardService'
function getPlans(){return(0,_fetchHandler2.default)(''+(_constants.API+_constants.PLAN_RESUME),{method:'GET'});}// export function getPlanResume(planId) {
//   fetchHandler(`${dynamicAPI}/minha-veloe/${planId}/resumo`, {
//     method: 'GET'
//   }).then(console.log)
//   return dashboardService.getPlanResume(planId)
// }
// export function getInvoices(planId, next) {
//   const url = next ? `${dynamicAPI}${next}` : `${dynamicAPI}/minha-veloe/fatura/${planId}/historico`
//   return fetchHandler(url, {
//     method: 'GET'
//   })
// }
// export function getStatements(planId, next, filter = {}) {
//   const query = `&${queryStringParser(filter)}`
//
//   const url = next
//     ? `${API_URL}${next}${query}`
//     : `${API_URL}/api/accountplans/${planId}/transactions?limit=7${query}`
//   return fetchHandler(url, {
//     method: 'GET'
//   })
// }
function getStatement(planId,statementId){var url=_constants.dynamicAPI+'/accountplans/'+planId+'/transactions/'+statementId;return(0,_fetchHandler2.default)(url,{method:'GET'});}// export function downloadStatement(planId, filter = {}) {
//   const query = queryStringParser(filter)
//   const url = `${dynamicAPI}/accountplans/${planId}/statement/download?${query}`
//   return fetchHandler(url, {
//     method: 'GET'
//   })
// }
// export function downloadStatementCSV(planId, filter = {}) {
//   const query = queryStringParser(filter)
//   const url = `${dynamicAPI}/accountplans/${planId}/statement/csv?${query}`
//   return fetchHandler(url, {
//     method: 'GET'
//   })
// }
// export function downloadCSVInvoice(planId, invoiceId) {
//   const url = `${dynamicAPI}/minha-veloe/fatura/${planId}/detalhe/${invoiceId}/download`
//   return fetchHandler(url, {
//     method: 'GET'
//   })
// }
// export function downloadTicket(planId, invoiceId) {
//   const url = `${dynamicAPI}/minha-veloe/boleto/${planId}/${invoiceId}/download`
//   return fetchHandler(url, {
//     method: 'GET'
//   })
// }
// export function downloadInvoice(planId, year, month) {
//   const url = `${dynamicAPI}/accountplans/${planId}/invoices/${year}/${month}/pdf`
//   return fetchHandler(url, {
//     method: 'GET'
//   })
// }
function getReasons(){var url=_constants.dynamicAPI+'/contestationreasons';return(0,_fetchHandler2.default)(url,{method:'GET'});}function getContestationProtocol(data){var url=_constants.dynamicAPI+'/transactions/'+data.transactionId+'/contestation';return(0,_fetchHandler2.default)(url,{method:'POST',body:JSON.stringify(data)});}// export function getRecharges(planId, next) {
//   const url = next
//     ? `${dynamicAPI}${next}`
//     : `${dynamicAPI}/accountplans/${planId}/recharges?limit=6`
//   return fetchHandler(url, {
//     method: 'GET'
//   })
// }
// export function getVehicles(accountId) {
//   const url = `${dynamicAPI}/accountplans/${accountId}/vehicles`
//   return fetchHandler(url, {
//     method: 'GET'
//   })
// }
// export function downloadFatura(planId, invoiceId) {
//   const url = `${dynamicAPI}/minha-veloe/fatura/${planId}/detalhe/${invoiceId}/pdf`
//   return fetchHandler(url, {
//     method: 'GET'
//   })
// }

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.resumoTransform=exports.gqlResumo=undefined;var _templateObject=_taggedTemplateLiteral(['\n  query ResumoV2($idConta: String!) {\n    contas {\n      tipo\n      conta\n    }\n    resumoV2(idConta: $idConta) {\n      resumo {\n        transacoesAgrupadas {\n          ESTACIONAMENTO\n          PEDAGIO\n          ABASTECIMENTO\n        }\n      }\n    }\n  }\n'],['\n  query ResumoV2($idConta: String!) {\n    contas {\n      tipo\n      conta\n    }\n    resumoV2(idConta: $idConta) {\n      resumo {\n        transacoesAgrupadas {\n          ESTACIONAMENTO\n          PEDAGIO\n          ABASTECIMENTO\n        }\n      }\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _helpers=__webpack_require__(152);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var formatDateResumo=function formatDateResumo(date){return(0,_moment2.default)(date).format('HH:mm - DD/MM/YYYY');};var gqlResumo=exports.gqlResumo=(0,_graphqlTag2.default)(_templateObject);var resumoMap={// type: 'contas[0].tipo', buscar conta pelo id
// 'balance.date': data atual
'balance.spending.fuel':'resumo.transacoesAgrupadas.ABASTECIMENTO','balance.spending.park':'resumo.transacoesAgrupadas.ESTACIONAMENTO','balance.spending.toll':'resumo.transacoesAgrupadas.PEDAGIO'};var resumoTransform=exports.resumoTransform=function resumoTransform(src,idConta){var resumo=(0,_helpers.transformObject)(src.data.resumoV2,resumoMap);var conta=src.data.contas.find(function(c){return c.conta===idConta;});resumo.type=(0,_helpers.getTipoConta)(conta.tipo);var balance=resumo.balance;var spending=balance.spending;balance.date=formatDateResumo(new Date());spending.fuel=spending.fuel||0;spending.park=spending.park||0;spending.toll=spending.toll||0;resumo.vehicles=[];return resumo;};

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

/**
 * Tiny library to create and manipulate Unix timestamps
 * (i.e. defined as the number of seconds since Unix epoch time).
 */

var timestamp = module.exports = {};

// constants

timestamp.Millisecond = 0.001;
timestamp.Second = 1;
timestamp.Minute = 60;
timestamp.Hour = 60 * timestamp.Minute;
timestamp.Day = 24 * timestamp.Hour;
timestamp.Week = 7 * timestamp.Day;
/**
 * = mean Gregorian month
 */
timestamp.Month = 30.436875 * timestamp.Day;
timestamp.Year = 12 * timestamp.Month;

var DeltaRegExp = new RegExp('^\\s*' +
    '([-+]?)\\s*' +
    [ 'y', 'M', 'w', 'd', 'h', 'm', 's', 'ms' ]
        .map(function (t) { return '(?:(\\d+)\\s*' + t + ')?'; })
        .join('\\s*') +
    '\\s*$');

var outputFn = dontRound;
function dontRound(time) { return time; }
function round(time) { return Math.round(time); }
/**
 * Set to `true` to round all returned timestamps to the second. Defaults to `false`.
 */
Object.defineProperty(timestamp, 'round', {
  get: function () { return outputFn; },
  set: function (value) { outputFn = value ? round : dontRound; }
});


/**
 * Gets the current time as Unix timestamp.
 * Optionally applying a given delta specified as either a human-readable string or a number of
 * seconds.
 *
 * @param {String|Number} delta The optional delta time to apply
 * @returns {Number} The corresponding timestamp
 */
timestamp.now = function (delta) {
  var now = Date.now() / 1000;
  return outputFn(delta ? timestamp.add(now, delta) : now);
};

/**
 * Applies the given delta to the given timestamp.
 * The delta is specified as either a human-readable string or a number of
 * seconds.
 *
 * @param {Number} time The original timestamp
 * @param {String|Number} delta The delta time to apply
 * @returns {Number} The result timestamp
 */
timestamp.add = function (time, delta) {
  if (! isNumber(time)) {
    throw new Error('Time must be a number');
  }
  if (isString(delta)) {
    var matches = DeltaRegExp.exec(delta);
    if (! matches) {
      throw new Error('Expected delta string format: [+|-] [{years}y] [{months}M] [{weeks}w] ' +
          '[{days}d] [{hours}h] [{minutes}m] [{seconds}s] [{milliseconds}ms]');
    }
    delta = (matches[1] === '-' ? -1 : 1) * (
        (matches[2] || 0) * timestamp.Year +
        (matches[3] || 0) * timestamp.Month +
        (matches[4] || 0) * timestamp.Week +
        (matches[5] || 0) * timestamp.Day +
        (matches[6] || 0) * timestamp.Hour +
        (matches[7] || 0) * timestamp.Minute +
        (matches[8] || 0) * timestamp.Second +
        (matches[9] || 0) * timestamp.Millisecond
    );
  } else if (! isNumber(delta)) {
    throw new Error('Delta must be either a string or a number');
  }
  return outputFn(time + delta);
};

/**
 * Gets the delta timestamp for the given delta string.
 * (Alias for .add() using a time of zero.)
 *
 * @param {String|Number} delta The delta time for the duration
 * @returns {Number} The result time delta
 */
timestamp.duration = function (delta) {
  return timestamp.add(0, delta);
};

/**
 * Gets the Unix timestamp for the given date object or string.
 *
 * @param {Date|String} date A date object or an ISO 8601 date string
 * @returns {Number} The corresponding timestamp
 */
timestamp.fromDate = function (date) {
  if (isString(date)) {
    date = new Date(date);
  } else if (! isDate(date)) {
    throw new Error('Expected either a string or a date');
  }
  return outputFn(date.getTime() / 1000);
};

/**
 * Gets the date for the given Unix timestamp.
 *
 * @param {Number} time A timestamp
 * @returns {Date} The corresponding date
 */
timestamp.toDate = function (time) {
  if (! isNumber(time)) {
    throw new Error('Expected a number');
  }
  return new Date(time * 1000);
};

function isString(value) {
  return typeof value === 'string' || Object.prototype.toString.call(value) === '[object String]';
}

function isNumber(value) {
  return typeof value === 'number' || Object.prototype.toString.call(value) === '[object Number]';
}

function isDate(value) {
  return Object.prototype.toString.call(value) === '[object Date]';
}


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.gqlDeletePlateFilter=exports.gqlUpdatePlateFilter=exports.gqlCreatePlateFilter=exports.gqlListPlateFilters=exports.gqlSendStatementEmail=exports.gqlResendStatement=exports.gqlDownloadExtratoPdf=exports.gqlDownloadExtratoCsv=exports.transformExtrato=exports.gqlExtrato=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _templateObject=_taggedTemplateLiteral(['\n  query extrato(\n    $idConta: String!\n    $quantidade: Int\n    $pagina: Int\n    $placa: String\n    $placas: [FiltroPlacas]\n    $transacoes: [FiltroTransacoes]\n    $periodo: String\n    $diaDaSemana: String\n    $startSqlDateFilter: String\n    $endSqlDateFilter: String\n    $valePedagio: String\n    $portalParceiro: String\n  ) {\n    extrato(\n      idConta: $idConta\n      pagina: $pagina\n      placa: $placa\n      placas: $placas\n      quantidade: $quantidade\n      transacoes: $transacoes\n      periodo: $periodo\n      diaDaSemana: $diaDaSemana\n      startSqlDateFilter: $startSqlDateFilter\n      endSqlDateFilter: $endSqlDateFilter\n      valePedagio: $valePedagio\n      portalParceiro: $portalParceiro\n    ) {\n      transacoes {\n        identificador\n        veiculo {\n          placa\n        }\n        endereco\n        valor\n        valePedagio\n        vpVigenciaInicio\n        vpVigenciaFim\n        vpOrigem\n        vpDestino\n        vpIdveloe\n        vpCnpjEmbarcador\n        fastId\n        cyberId\n        estabelecimentoComercial {\n          codigo\n          nome\n          tipoTransacao\n        }\n        clienteConta {\n          cliente {\n            id\n          }\n          conta {\n            conta\n          }\n        }\n        tipoMovimento\n        dataProcessamento\n        horaProcessamento\n        dataEvento\n        horaEvento\n        dataFimEvento\n        horaFimEvento\n        motivoTransacao\n        permanencia\n      }\n      enviarExtratoEmail\n    }\n  }\n'],['\n  query extrato(\n    $idConta: String!\n    $quantidade: Int\n    $pagina: Int\n    $placa: String\n    $placas: [FiltroPlacas]\n    $transacoes: [FiltroTransacoes]\n    $periodo: String\n    $diaDaSemana: String\n    $startSqlDateFilter: String\n    $endSqlDateFilter: String\n    $valePedagio: String\n    $portalParceiro: String\n  ) {\n    extrato(\n      idConta: $idConta\n      pagina: $pagina\n      placa: $placa\n      placas: $placas\n      quantidade: $quantidade\n      transacoes: $transacoes\n      periodo: $periodo\n      diaDaSemana: $diaDaSemana\n      startSqlDateFilter: $startSqlDateFilter\n      endSqlDateFilter: $endSqlDateFilter\n      valePedagio: $valePedagio\n      portalParceiro: $portalParceiro\n    ) {\n      transacoes {\n        identificador\n        veiculo {\n          placa\n        }\n        endereco\n        valor\n        valePedagio\n        vpVigenciaInicio\n        vpVigenciaFim\n        vpOrigem\n        vpDestino\n        vpIdveloe\n        vpCnpjEmbarcador\n        fastId\n        cyberId\n        estabelecimentoComercial {\n          codigo\n          nome\n          tipoTransacao\n        }\n        clienteConta {\n          cliente {\n            id\n          }\n          conta {\n            conta\n          }\n        }\n        tipoMovimento\n        dataProcessamento\n        horaProcessamento\n        dataEvento\n        horaEvento\n        dataFimEvento\n        horaFimEvento\n        motivoTransacao\n        permanencia\n      }\n      enviarExtratoEmail\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query extratoCSV(\n    $idConta: String!\n    $pagina: Int\n    $placa: String\n    $placas: [FiltroPlacas]\n    $quantidade: Int\n    $transacoes: [FiltroTransacoes]\n    $periodo: String\n    $diaDaSemana: String\n    $startSqlDateFilter: String\n    $endSqlDateFilter: String\n    $valePedagio: String\n  ) {\n    extratoCSV(\n      idConta: $idConta\n      pagina: $pagina\n      placa: $placa\n      placas: $placas\n      quantidade: $quantidade\n      transacoes: $transacoes\n      periodo: $periodo\n      diaDaSemana: $diaDaSemana\n      startSqlDateFilter: $startSqlDateFilter\n      endSqlDateFilter: $endSqlDateFilter\n      valePedagio: $valePedagio\n    ) {\n      result\n    }\n  }\n'],['\n  query extratoCSV(\n    $idConta: String!\n    $pagina: Int\n    $placa: String\n    $placas: [FiltroPlacas]\n    $quantidade: Int\n    $transacoes: [FiltroTransacoes]\n    $periodo: String\n    $diaDaSemana: String\n    $startSqlDateFilter: String\n    $endSqlDateFilter: String\n    $valePedagio: String\n  ) {\n    extratoCSV(\n      idConta: $idConta\n      pagina: $pagina\n      placa: $placa\n      placas: $placas\n      quantidade: $quantidade\n      transacoes: $transacoes\n      periodo: $periodo\n      diaDaSemana: $diaDaSemana\n      startSqlDateFilter: $startSqlDateFilter\n      endSqlDateFilter: $endSqlDateFilter\n      valePedagio: $valePedagio\n    ) {\n      result\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query download(\n    $idConta: String!\n    $pagina: Int\n    $placa: String\n    $quantidade: Int\n    $placas: [FiltroPlacas]\n    $transacoes: [FiltroTransacoes]\n    $periodo: String\n    $diaDaSemana: String\n    $startSqlDateFilter: String\n    $endSqlDateFilter: String\n    $valePedagio: String\n  ) {\n    download(\n      idConta: $idConta\n      pagina: $pagina\n      placa: $placa\n      placas: $placas\n      quantidade: $quantidade\n      transacoes: $transacoes\n      periodo: $periodo\n      diaDaSemana: $diaDaSemana\n      startSqlDateFilter: $startSqlDateFilter\n      endSqlDateFilter: $endSqlDateFilter\n      valePedagio: $valePedagio\n    ) {\n      result\n    }\n  }\n'],['\n  query download(\n    $idConta: String!\n    $pagina: Int\n    $placa: String\n    $quantidade: Int\n    $placas: [FiltroPlacas]\n    $transacoes: [FiltroTransacoes]\n    $periodo: String\n    $diaDaSemana: String\n    $startSqlDateFilter: String\n    $endSqlDateFilter: String\n    $valePedagio: String\n  ) {\n    download(\n      idConta: $idConta\n      pagina: $pagina\n      placa: $placa\n      placas: $placas\n      quantidade: $quantidade\n      transacoes: $transacoes\n      periodo: $periodo\n      diaDaSemana: $diaDaSemana\n      startSqlDateFilter: $startSqlDateFilter\n      endSqlDateFilter: $endSqlDateFilter\n      valePedagio: $valePedagio\n    ) {\n      result\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation reenvioTransacaoPost($fastId: String!) {\n    reenvioTransacaoPost(fastId: $fastId) {\n      codigo\n    }\n  }\n'],['\n  mutation reenvioTransacaoPost($fastId: String!) {\n    reenvioTransacaoPost(fastId: $fastId) {\n      codigo\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query extratoEmail(\n    $idConta: String!\n    $email: String\n    $formato: String\n    $placa: String\n    $placas: [FiltroPlacas]\n    $transacoes: [FiltroTransacoes]\n    $periodo: String\n    $diaDaSemana: String\n    $startSqlDateFilter: String\n    $endSqlDateFilter: String\n    $valePedagio: String\n  ) {\n    extratoEmail(\n      idConta: $idConta\n      email: $email\n      placa: $placa\n      placas: $placas\n      transacoes: $transacoes\n      formato: $formato\n      periodo: $periodo\n      diaDaSemana: $diaDaSemana\n      startSqlDateFilter: $startSqlDateFilter\n      endSqlDateFilter: $endSqlDateFilter\n      valePedagio: $valePedagio\n    ) {\n      result\n    }\n  }\n'],['\n  query extratoEmail(\n    $idConta: String!\n    $email: String\n    $formato: String\n    $placa: String\n    $placas: [FiltroPlacas]\n    $transacoes: [FiltroTransacoes]\n    $periodo: String\n    $diaDaSemana: String\n    $startSqlDateFilter: String\n    $endSqlDateFilter: String\n    $valePedagio: String\n  ) {\n    extratoEmail(\n      idConta: $idConta\n      email: $email\n      placa: $placa\n      placas: $placas\n      transacoes: $transacoes\n      formato: $formato\n      periodo: $periodo\n      diaDaSemana: $diaDaSemana\n      startSqlDateFilter: $startSqlDateFilter\n      endSqlDateFilter: $endSqlDateFilter\n      valePedagio: $valePedagio\n    ) {\n      result\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query listaFiltro($conta: String, $tipo: String) {\n    listaFiltro(conta: $conta, tipo: $tipo) {\n      id\n      descricaoFiltro\n      info {\n        placa\n      }\n      tipo\n    }\n  }\n'],['\n  query listaFiltro($conta: String, $tipo: String) {\n    listaFiltro(conta: $conta, tipo: $tipo) {\n      id\n      descricaoFiltro\n      info {\n        placa\n      }\n      tipo\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  mutation inserirFiltro($filtro: FiltroExtrato) {\n    inserirFiltro(filtroExtrato: $filtro) {\n      id\n    }\n  }\n'],['\n  mutation inserirFiltro($filtro: FiltroExtrato) {\n    inserirFiltro(filtroExtrato: $filtro) {\n      id\n    }\n  }\n']),_templateObject8=_taggedTemplateLiteral(['\n  mutation alterarFiltro($filtro: FiltroExtrato, $id: String) {\n    alterarFiltro(filtroExtrato: $filtro, id: $id) {\n      id\n      descricaoFiltro\n      info {\n        placa\n      }\n      tipo\n    }\n  }\n'],['\n  mutation alterarFiltro($filtro: FiltroExtrato, $id: String) {\n    alterarFiltro(filtroExtrato: $filtro, id: $id) {\n      id\n      descricaoFiltro\n      info {\n        placa\n      }\n      tipo\n    }\n  }\n']),_templateObject9=_taggedTemplateLiteral(['\n  mutation deletarFiltro($conta: String, $id: String) {\n    deletarFiltro(conta: $conta, id: $id) {\n      msg\n    }\n  }\n'],['\n  mutation deletarFiltro($conta: String, $id: String) {\n    deletarFiltro(conta: $conta, id: $id) {\n      msg\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);var _helpers=__webpack_require__(152);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlExtrato=exports.gqlExtrato=(0,_graphqlTag2.default)(_templateObject);var mapExtrato={'fast-id':'fastId','cyber-id':'cyberId','estabelecimento-comercial.nome':'estabelecimentoComercial.nome','estabelecimento-comercial.tipo-transacao':'estabelecimentoComercial.tipoTransacao','cliente-conta':'clienteConta','tipo-movimento':'tipoMovimento','data-processamento':'dataProcessamento','hora-processamento':'horaProcessamento','data-evento':'dataEvento','hora-evento':'horaEvento','data-fim-evento':'dataFimEvento','hora-fim-evento':'horaFimEvento','motivo-transacao':'motivoTransacao'// TODO GraphQL não retorna info de eixo-cobrado
// TODO GraphQL não retorna info de eixo-cadastrado
};var transformExtrato=exports.transformExtrato=function transformExtrato(src){var extrato=src.data.extrato;var transacoes=extrato.transacoes,enviarExtratoEmail=extrato.enviarExtratoEmail;if(!transacoes)return[];var newTransacoes=transacoes.map(function(t){return _extends({},t,(0,_helpers.transformObject)(t,mapExtrato),{valePedagio:Boolean(t.valePedagio),identificador:Number.parseInt(t.identificador,10)});});return{transacoes:newTransacoes,enviarExtratoEmail:enviarExtratoEmail};};var gqlDownloadExtratoCsv=exports.gqlDownloadExtratoCsv=(0,_graphqlTag2.default)(_templateObject2);var gqlDownloadExtratoPdf=exports.gqlDownloadExtratoPdf=(0,_graphqlTag2.default)(_templateObject3);var gqlResendStatement=exports.gqlResendStatement=(0,_graphqlTag2.default)(_templateObject4);var gqlSendStatementEmail=exports.gqlSendStatementEmail=(0,_graphqlTag2.default)(_templateObject5);var gqlListPlateFilters=exports.gqlListPlateFilters=(0,_graphqlTag2.default)(_templateObject6);var gqlCreatePlateFilter=exports.gqlCreatePlateFilter=(0,_graphqlTag2.default)(_templateObject7);var gqlUpdatePlateFilter=exports.gqlUpdatePlateFilter=(0,_graphqlTag2.default)(_templateObject8);var gqlDeletePlateFilter=exports.gqlDeletePlateFilter=(0,_graphqlTag2.default)(_templateObject9);

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _dashboardService=__webpack_require__(66);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SET_RESENT_STATEMENT=_types2.default.SET_RESENT_STATEMENT;function fetchReasonList(fastId){return function(dispatch){return(0,_dashboardService.resendStatement)(fastId).then(function(response){dispatch({type:SET_RESENT_STATEMENT,state:response});return response;});};}exports.default=fetchReasonList;module.exports=exports['default'];

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecService=__webpack_require__(174);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_EC_CONTESTATIONS=_types2.default.FETCH_EC_CONTESTATIONS;function fetchECContestations(){return function(dispatch){return(0,_ecService.requestContestations)().then(function(contestations){dispatch({type:FETCH_EC_CONTESTATIONS,state:contestations});return contestations;}).catch(function(error){console.log('Erro em #fetchECContestations()');console.log(error);});};}exports.default=fetchECContestations;module.exports=exports['default'];

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecService=__webpack_require__(174);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_EC_LOCATIONS=_types2.default.FETCH_EC_LOCATIONS;function fetchECLocations(){return function(dispatch){return(0,_ecService.getLocations)().then(function(locations){dispatch({type:FETCH_EC_LOCATIONS,state:locations});return locations;}).catch(function(error){console.log('Erro em #fetchGetLocations()');console.log(error);});};}exports.default=fetchECLocations;module.exports=exports['default'];

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecService=__webpack_require__(174);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_EC_MONEY_TRANSER=_types2.default.FETCH_EC_MONEY_TRANSER;function fetchECMoneyTransfer(){return function(dispatch){return(0,_ecService.requestMoneyTransfer)().then(function(moneyTransfer){dispatch({type:FETCH_EC_MONEY_TRANSER,state:moneyTransfer});return moneyTransfer;}).catch(function(error){console.log('Erro em #fetchECMoneyTransfer()');console.log(error);});};}exports.default=fetchECMoneyTransfer;module.exports=exports['default'];

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecService=__webpack_require__(174);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_EC_QUERY_PLATE=_types2.default.FETCH_EC_QUERY_PLATE;function fetchECQueryPlate(formData){return function(dispatch){return(0,_ecService.queryPlate)(formData).then(function(result){dispatch({type:FETCH_EC_QUERY_PLATE,state:result});return result;}).catch(function(error){console.log('Erro em #fetchECQueryPlate()');console.log(error);});};}exports.default=fetchECQueryPlate;module.exports=exports['default'];

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ecService=__webpack_require__(174);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_EC_REQUEST_FILE_HISTORY=_types2.default.FETCH_EC_REQUEST_FILE_HISTORY;function fetchECRequestFileHistory(){return function(dispatch){return(0,_ecService.requestFileHistory)().then(function(result){dispatch({type:FETCH_EC_REQUEST_FILE_HISTORY,state:result});return result;}).catch(function(error){console.log('Erro em #fetchECRequestFileHistory()');console.log(error);});};}exports.default=fetchECRequestFileHistory;module.exports=exports['default'];

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.fetchGetBusinessUserOnly=fetchGetBusinessUserOnly;var _userService=__webpack_require__(74);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_USER=_types2.default.FETCH_USER;function fetchGetBusinessUserOnly(token){return function(dispatch){return(0,_userService.getBusinessUserOnly)(token).then(function(user){dispatch({type:FETCH_USER,state:_extends({},user,{token:token})});});};}function fetchGetBusinessUser(token){return function(dispatch){return(0,_userService.getBusinessUser)(token).then(function(user){dispatch({type:FETCH_USER,state:_extends({},user,{token:token})});return user;});};}exports.default=fetchGetBusinessUser;

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.gqlEditarUsuarioFisico=exports.transformPessoal=exports.gqlEditarContato=exports.gqlPap=exports.gqlPessoal=undefined;var _templateObject=_taggedTemplateLiteral(['\n  {\n    usuario {\n      cpf\n      estadoCivil {\n        codigo\n      }\n      nascimento\n      nome\n      nomeMae\n      sexo {\n        codigo\n      }\n      enderecos {\n        bairro\n        cep\n        cidade\n        codigo\n        complemento\n        correspondencia\n        logradouro\n        numero\n        uf\n      }\n    }\n    contatos {\n      celular {\n        ddd\n        id\n        numero\n        tipoTelefone\n      }\n      email {\n        id\n        enderecoEletronico\n        # additionDate - "20180521000000000" chega nesse formato pelo middlaew\n        newsletter\n      }\n      # identificationNumber: null\n      nome {\n        nomeCompleto\n        id\n        emiteNotaFiscal\n      }\n      # site: null\n      # telefone: null\n      telefone {\n        id\n        ddd\n        numero\n        tipoTelefone\n        # ramal\n      }\n    }\n    representantes {\n      nome\n      cpf\n      nacionalidade\n      tipoRelacao {\n        id\n        longDesc\n        nemotecnico\n        shortDesc\n      }\n      email\n      celular\n      dataInicio # 2002-01-02 vindo pelo middlware neste formato\n      dataFim # 2078-12-31 vindo pelo middlware neste formato\n    }\n  }\n'],['\n  {\n    usuario {\n      cpf\n      estadoCivil {\n        codigo\n      }\n      nascimento\n      nome\n      nomeMae\n      sexo {\n        codigo\n      }\n      enderecos {\n        bairro\n        cep\n        cidade\n        codigo\n        complemento\n        correspondencia\n        logradouro\n        numero\n        uf\n      }\n    }\n    contatos {\n      celular {\n        ddd\n        id\n        numero\n        tipoTelefone\n      }\n      email {\n        id\n        enderecoEletronico\n        # additionDate - "20180521000000000" chega nesse formato pelo middlaew\n        newsletter\n      }\n      # identificationNumber: null\n      nome {\n        nomeCompleto\n        id\n        emiteNotaFiscal\n      }\n      # site: null\n      # telefone: null\n      telefone {\n        id\n        ddd\n        numero\n        tipoTelefone\n        # ramal\n      }\n    }\n    representantes {\n      nome\n      cpf\n      nacionalidade\n      tipoRelacao {\n        id\n        longDesc\n        nemotecnico\n        shortDesc\n      }\n      email\n      celular\n      dataInicio # 2002-01-02 vindo pelo middlware neste formato\n      dataFim # 2078-12-31 vindo pelo middlware neste formato\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query pap($documento: String!) {\n    pap(documento: $documento) {\n      adesaoPap\n      documento\n    }\n  }\n'],['\n  query pap($documento: String!) {\n    pap(documento: $documento) {\n      adesaoPap\n      documento\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation editarContato(\n    $email: String!\n    $newsletter: Boolean\n    $telefoneDDD: Int\n    $telefoneNumero: Int\n    $telefoneTipo: Int\n    $celularDDD: Int\n    $celularNumero: Int\n    $celularTipo: Int\n  ) {\n    editarContato(\n      contato: {\n        email: { enderecoEletronico: $email, newsletter: $newsletter }\n        telefone: { ddd: $telefoneDDD, numero: $telefoneNumero, tipoTelefone: $telefoneTipo }\n        celular: { ddd: $celularDDD, numero: $celularNumero, tipoTelefone: $celularTipo }\n      }\n    ) {\n      email {\n        enderecoEletronico\n        newsletter\n      }\n      telefone {\n        ddd\n        numero\n        tipoTelefone\n      }\n      celular {\n        ddd\n        numero\n        tipoTelefone\n      }\n    }\n  }\n'],['\n  mutation editarContato(\n    $email: String!\n    $newsletter: Boolean\n    $telefoneDDD: Int\n    $telefoneNumero: Int\n    $telefoneTipo: Int\n    $celularDDD: Int\n    $celularNumero: Int\n    $celularTipo: Int\n  ) {\n    editarContato(\n      contato: {\n        email: { enderecoEletronico: $email, newsletter: $newsletter }\n        telefone: { ddd: $telefoneDDD, numero: $telefoneNumero, tipoTelefone: $telefoneTipo }\n        celular: { ddd: $celularDDD, numero: $celularNumero, tipoTelefone: $celularTipo }\n      }\n    ) {\n      email {\n        enderecoEletronico\n        newsletter\n      }\n      telefone {\n        ddd\n        numero\n        tipoTelefone\n      }\n      celular {\n        ddd\n        numero\n        tipoTelefone\n      }\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation editarUsuarioFisico(\n    $sexo: String!\n    $estadoCivil: String!\n    $adesaoPap: Boolean\n    $documento: String\n  ) {\n    editarUsuarioFisico(\n      usuarioFisico: {\n        sexo: { codigo: $sexo }\n        estadoCivil: { codigo: $estadoCivil }\n        tipo: "pessoa-fisica"\n      }\n    ) {\n      cpf\n      sexo {\n        codigo\n      }\n    }\n    mudarSituacaoPap(adesaoPap: $adesaoPap, documento: $documento) {\n      adesaoPap\n      documento\n    }\n  }\n'],['\n  mutation editarUsuarioFisico(\n    $sexo: String!\n    $estadoCivil: String!\n    $adesaoPap: Boolean\n    $documento: String\n  ) {\n    editarUsuarioFisico(\n      usuarioFisico: {\n        sexo: { codigo: $sexo }\n        estadoCivil: { codigo: $estadoCivil }\n        tipo: "pessoa-fisica"\n      }\n    ) {\n      cpf\n      sexo {\n        codigo\n      }\n    }\n    mudarSituacaoPap(adesaoPap: $adesaoPap, documento: $documento) {\n      adesaoPap\n      documento\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);var _helpers=__webpack_require__(152);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlPessoal=exports.gqlPessoal=(0,_graphqlTag2.default)(_templateObject);var gqlPap=exports.gqlPap=(0,_graphqlTag2.default)(_templateObject2);var gqlEditarContato=exports.gqlEditarContato=(0,_graphqlTag2.default)(_templateObject3);// TODO No objeto de contato algumas informações não foram encontradas no graphql
// identificationNumber
// nome.emiteNotaFiscal
// site
var profileMap={cpf:'cpf','estado-civil':'estadoCivil',nascimento:'nascimento',nome:'nome','nome-mae':'nomeMae',// 'pap': não achamos na query
sexo:'sexo'};var transformPessoal=exports.transformPessoal=function transformPessoal(src){var _src$data=src.data,contato=_src$data.contatos,usuario=_src$data.usuario;var pap=src.pap;var enderecos=usuario.enderecos;var profile=(0,_helpers.transformObject)(usuario,profileMap);profile.sexo.codigo=profile.sexo.codigo.toString();profile['estado-civil'].codigo=profile['estado-civil'].codigo.toString();profile.pap=pap.adesaoPap;var representantes=src.data.representantes;return(0,_helpers.removeTypename)({contato:contato,enderecos:enderecos,profile:profile,representantes:representantes});};var gqlEditarUsuarioFisico=exports.gqlEditarUsuarioFisico=(0,_graphqlTag2.default)(_templateObject4);

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.transformBusinessUser=exports.transformBusiness=exports.gqlEditarContatoAdministrador=exports.gqlBusiness=exports.gqlBusinessUserOnly=exports.gqlUpdateBusiness=undefined;var _templateObject=_taggedTemplateLiteral(['\n  mutation editarUsuarioJuridico(\n    $nomeFantasia: String!\n    $faturamentoMedioMensal: String!\n    $cnaePrincipal: String!\n    $tipoUsuario: String!\n    $adesaoPap: Boolean\n    $documento: String\n  ) {\n    editarUsuarioJuridico(\n      usuarioJuridico: {\n        nomeFantasia: $nomeFantasia\n        faturamentoMedioMensal: $faturamentoMedioMensal\n        cnaePrincipal: $cnaePrincipal\n        tipo: $tipoUsuario\n      }\n    ) {\n      nomeFantasia\n      faturamentoMedioMensal\n      cnaePrincipal\n    }\n    mudarSituacaoPap(adesaoPap: $adesaoPap, documento: $documento) {\n      adesaoPap\n      documento\n    }\n  }\n'],['\n  mutation editarUsuarioJuridico(\n    $nomeFantasia: String!\n    $faturamentoMedioMensal: String!\n    $cnaePrincipal: String!\n    $tipoUsuario: String!\n    $adesaoPap: Boolean\n    $documento: String\n  ) {\n    editarUsuarioJuridico(\n      usuarioJuridico: {\n        nomeFantasia: $nomeFantasia\n        faturamentoMedioMensal: $faturamentoMedioMensal\n        cnaePrincipal: $cnaePrincipal\n        tipo: $tipoUsuario\n      }\n    ) {\n      nomeFantasia\n      faturamentoMedioMensal\n      cnaePrincipal\n    }\n    mudarSituacaoPap(adesaoPap: $adesaoPap, documento: $documento) {\n      adesaoPap\n      documento\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  {\n    usuario {\n      customerId\n      cnpj\n      nomeFantasia\n      razaoSocial\n      dataConstituicao\n      formaConstituicao {\n        longDesc\n      }\n      cnaePrincipal\n      inscricaoMunicipal\n      faturamentoMedioMensal\n      enderecos {\n        bairro\n        cep\n        cidade\n        codigo\n        complemento\n        correspondencia\n        logradouro\n        numero\n        uf\n      }\n    }\n  }\n'],['\n  {\n    usuario {\n      customerId\n      cnpj\n      nomeFantasia\n      razaoSocial\n      dataConstituicao\n      formaConstituicao {\n        longDesc\n      }\n      cnaePrincipal\n      inscricaoMunicipal\n      faturamentoMedioMensal\n      enderecos {\n        bairro\n        cep\n        cidade\n        codigo\n        complemento\n        correspondencia\n        logradouro\n        numero\n        uf\n      }\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  {\n    usuario {\n      customerId\n      cnpj\n      nomeFantasia\n      razaoSocial\n      dataConstituicao\n      formaConstituicao {\n        longDesc\n      }\n      cnaePrincipal\n      inscricaoMunicipal\n      faturamentoMedioMensal\n      enderecos {\n        bairro\n        cep\n        cidade\n        codigo\n        complemento\n        correspondencia\n        logradouro\n        numero\n        uf\n      }\n    }\n    contatoAdministrador {\n      celular {\n        ddd\n        id\n        numero\n        tipoTelefone\n      }\n      email {\n        id\n        enderecoEletronico\n        # additionDate - "20180521000000000" chega nesse formato pelo middlaew\n        newsletter\n      }\n      # identificationNumber: null\n      nome {\n        nomeCompleto\n        id\n        # emiteNotaFiscal - false chega neste formato pelo middleware\n      }\n      site {\n        enderecoEletronico\n      }\n      # telefone: null\n      telefone {\n        id\n        ddd\n        numero\n        tipoTelefone\n        ramal\n      }\n    }\n    representantes {\n      nome\n      cpf\n      nacionalidade\n      tipoRelacao {\n        id\n        longDesc\n        nemotecnico\n        shortDesc\n      }\n      email\n      celular\n    }\n  }\n'],['\n  {\n    usuario {\n      customerId\n      cnpj\n      nomeFantasia\n      razaoSocial\n      dataConstituicao\n      formaConstituicao {\n        longDesc\n      }\n      cnaePrincipal\n      inscricaoMunicipal\n      faturamentoMedioMensal\n      enderecos {\n        bairro\n        cep\n        cidade\n        codigo\n        complemento\n        correspondencia\n        logradouro\n        numero\n        uf\n      }\n    }\n    contatoAdministrador {\n      celular {\n        ddd\n        id\n        numero\n        tipoTelefone\n      }\n      email {\n        id\n        enderecoEletronico\n        # additionDate - "20180521000000000" chega nesse formato pelo middlaew\n        newsletter\n      }\n      # identificationNumber: null\n      nome {\n        nomeCompleto\n        id\n        # emiteNotaFiscal - false chega neste formato pelo middleware\n      }\n      site {\n        enderecoEletronico\n      }\n      # telefone: null\n      telefone {\n        id\n        ddd\n        numero\n        tipoTelefone\n        ramal\n      }\n    }\n    representantes {\n      nome\n      cpf\n      nacionalidade\n      tipoRelacao {\n        id\n        longDesc\n        nemotecnico\n        shortDesc\n      }\n      email\n      celular\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation editarContatoAdministrador(\n    $nome: String!\n    $email: String!\n    $site: String\n    $newsletter: Boolean!\n    $telefoneDDD: Int\n    $telefoneNumero: Int\n    $telefoneTipo: Int\n    $telefoneRamal: Int\n    $celular: TelefoneInput\n  ) {\n    editarContatoAdministrador(\n      contatoAdministrador: {\n        nome: { nomeCompleto: $nome }\n        email: { enderecoEletronico: $email, newsletter: $newsletter }\n        site: { enderecoEletronico: $site, newsletter: $newsletter }\n        telefone: {\n          ddd: $telefoneDDD\n          numero: $telefoneNumero\n          tipoTelefone: $telefoneTipo\n          ramal: $telefoneRamal\n        }\n        celular: $celular\n      }\n    ) {\n      email {\n        enderecoEletronico\n        newsletter\n      }\n      telefone {\n        ddd\n        numero\n        tipoTelefone\n        ramal\n      }\n      celular {\n        ddd\n        numero\n        tipoTelefone\n      }\n      site {\n        enderecoEletronico\n      }\n    }\n  }\n'],['\n  mutation editarContatoAdministrador(\n    $nome: String!\n    $email: String!\n    $site: String\n    $newsletter: Boolean!\n    $telefoneDDD: Int\n    $telefoneNumero: Int\n    $telefoneTipo: Int\n    $telefoneRamal: Int\n    $celular: TelefoneInput\n  ) {\n    editarContatoAdministrador(\n      contatoAdministrador: {\n        nome: { nomeCompleto: $nome }\n        email: { enderecoEletronico: $email, newsletter: $newsletter }\n        site: { enderecoEletronico: $site, newsletter: $newsletter }\n        telefone: {\n          ddd: $telefoneDDD\n          numero: $telefoneNumero\n          tipoTelefone: $telefoneTipo\n          ramal: $telefoneRamal\n        }\n        celular: $celular\n      }\n    ) {\n      email {\n        enderecoEletronico\n        newsletter\n      }\n      telefone {\n        ddd\n        numero\n        tipoTelefone\n        ramal\n      }\n      celular {\n        ddd\n        numero\n        tipoTelefone\n      }\n      site {\n        enderecoEletronico\n      }\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);var _helpers=__webpack_require__(152);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlUpdateBusiness=exports.gqlUpdateBusiness=(0,_graphqlTag2.default)(_templateObject);var gqlBusinessUserOnly=exports.gqlBusinessUserOnly=(0,_graphqlTag2.default)(_templateObject2);var gqlBusiness=exports.gqlBusiness=(0,_graphqlTag2.default)(_templateObject3);var gqlEditarContatoAdministrador=exports.gqlEditarContatoAdministrador=(0,_graphqlTag2.default)(_templateObject4);// TODO No objeto de contato algumas informações não foram encontradas no graphql
// identificationNumber
// nome.emiteNotaFiscal
// site
var businessMap={nomeFantasia:'nomeFantasia',cnpj:'cnpj',razaoSocial:'razaoSocial',dataConstituicao:'dataConstituicao',formaConstituicao:'formaConstituicao.longDesc',cnaePrincipal:'cnaePrincipal',inscricaoMunicipal:'inscricaoMunicipal',faturamentoMedioMensal:'faturamentoMedioMensal',customerId:'customerId'// pap: 'pap',
};var transformBusiness=exports.transformBusiness=function transformBusiness(src){var _src$data=src.data,contato=_src$data.contatoAdministrador,usuario=_src$data.usuario,representantes=_src$data.representantes;var pap=src.pap;var enderecos=usuario.enderecos;var profile=(0,_helpers.transformObject)(usuario,businessMap);profile.pap=pap.adesaoPap;return{contato:contato,enderecos:enderecos,profile:profile,representantes:representantes};};var transformBusinessUser=exports.transformBusinessUser=function transformBusinessUser(src){var usuario=src.data.usuario;var enderecos=usuario.enderecos;var profile=(0,_helpers.transformObject)(usuario,businessMap);return{enderecos:enderecos,profile:profile};};

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _userService=__webpack_require__(74);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_USER=_types2.default.FETCH_USER;function fetchGetUser(token){return function(dispatch){return(0,_userService.getUser)(token).then(function(user){dispatch({type:FETCH_USER,state:_extends({},user,{token:token})});return user;}).catch(function(error){console.log('Erro em #fetchGetUser()');console.log(error);});};}exports.default=fetchGetUser;module.exports=exports['default'];

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _dashboardService=__webpack_require__(66);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_VEHICLES=_types2.default.FETCH_VEHICLES;var fetchGetVehicles=function fetchGetVehicles(accountId){return function(dispatch){return(0,_dashboardService.getVehicles)(accountId).then(function(vehicles){dispatch({type:FETCH_VEHICLES,vehicles:vehicles});}).catch(function(error){console.log('Erro em #fetchGetVehicles()',error);return error;});};};exports.default=fetchGetVehicles;module.exports=exports['default'];

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _dashboardService=__webpack_require__(66);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_FILTER_VEHICLES=_types2.default.FETCH_FILTER_VEHICLES;var fetchFilterVehicles=function fetchFilterVehicles(identifierNumber){return function(dispatch){return(0,_dashboardService.getVehiclesByNumber)(identifierNumber).then(function(vehicles){dispatch({type:FETCH_FILTER_VEHICLES,vehicles:vehicles});vehicles.codIdentificador=identifierNumber;return[vehicles];}).catch(function(error){console.log('Erro em #fetchFilterVehicles()',error);return error;});};};exports.default=fetchFilterVehicles;module.exports=exports['default'];

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=fetchRecover;var _accountService=__webpack_require__(64);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_RECOVER=_types2.default.FETCH_RECOVER;function fetchRecover(login){return function(dispatch){return(0,_accountService.recover)(login).then(function(email){dispatch({type:FETCH_RECOVER,email:email});return email;});};}module.exports=exports['default'];

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=fetchReasons;var _dashboardService=__webpack_require__(66);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_REASONS=_types2.default.UPDATE_REASONS;function fetchReasons(){return function(dispatch){return(0,_dashboardService.getReasons)().then(function(reasons){dispatch({type:UPDATE_REASONS,reasons:reasons.data});});};}module.exports=exports['default'];

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=fetchStatement;var _dashboardService=__webpack_require__(66);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_STATEMENT=_types2.default.UPDATE_STATEMENT;function fetchStatement(planId,statementId){return function(dispatch){return(0,_dashboardService.getStatement)(planId,statementId).then(function(statement){dispatch({type:UPDATE_STATEMENT,statement:statement});});};}module.exports=exports['default'];

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _userService=__webpack_require__(74);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_CONTACT_UPDATE=_types2.default.FETCH_CONTACT_UPDATE;function fetchUpdateBusinessContact(data){return function(dispatch){return(0,_userService.updateBusinessUserContact)(data).then(function(contact){dispatch({type:FETCH_CONTACT_UPDATE,state:data});});};}exports.default=fetchUpdateBusinessContact;module.exports=exports['default'];

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _userService=__webpack_require__(74);// import types from './types'
// const { FETCH_PROFILE_UPDATE } = types
function fetchUpdateBusinessProfile(data){return function(dispatch){return(0,_userService.updateBusinessUserProfile)(data).then(function(user){// dispatch({
//   type: FETCH_PROFILE_UPDATE,
//   state: user
// })
});};}exports.default=fetchUpdateBusinessProfile;module.exports=exports['default'];

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _userService=__webpack_require__(74);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_CONTACT_UPDATE=_types2.default.FETCH_CONTACT_UPDATE;function fetchUpdateContact(data){return function(dispatch){return(0,_userService.updateUserContact)(data).then(function(contact){dispatch({type:FETCH_CONTACT_UPDATE,state:contact});});};}exports.default=fetchUpdateContact;module.exports=exports['default'];

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _userService=__webpack_require__(74);function fetchUpdatePassword(data){return function(){return(0,_userService.updateUserPassword)(data);};}exports.default=fetchUpdatePassword;module.exports=exports['default'];

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _userService=__webpack_require__(74);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_PROFILE_UPDATE=_types2.default.FETCH_PROFILE_UPDATE;function fetchUpdateProfile(data){return function(dispatch){return(0,_userService.updateUserProfile)(data).then(function(response){dispatch({type:FETCH_PROFILE_UPDATE,state:data.user});});};}exports.default=fetchUpdateProfile;module.exports=exports['default'];

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _userService=__webpack_require__(74);function fetchVerifyUserPassword(password){return(0,_userService.verifyUserPassword)({password:password});}exports.default=fetchVerifyUserPassword;module.exports=exports['default'];

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _services=__webpack_require__(175);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_ZIP_CODE=_types2.default.FETCH_ZIP_CODE;function fetchGetZipCode(data){return function(dispatch){return(0,_services.zipCodeGet)(data).then(function(address){dispatch({type:FETCH_ZIP_CODE,state:address});return address;});};}exports.default=fetchGetZipCode;module.exports=exports['default'];

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.transformTelefones=exports.gqlTiposTelefone=undefined;var _templateObject=_taggedTemplateLiteral(['\n  {\n    tiposTelefone {\n      id\n      shortDesc\n    }\n  }\n'],['\n  {\n    tiposTelefone {\n      id\n      shortDesc\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlTiposTelefone=exports.gqlTiposTelefone=(0,_graphqlTag2.default)(_templateObject);var transformTelefones=exports.transformTelefones=function transformTelefones(src){var tiposTelefone=src.data.tiposTelefone;return tiposTelefone.map(function(t){return{value:t.id.toString(),label:t.shortDesc};});};

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.transformBancos=exports.gqlParametrizacao=exports.transformEstadosCivis=exports.gqlEstadosCivis=exports.transformSexos=exports.gqlSexos=undefined;var _templateObject=_taggedTemplateLiteral(['\n  {\n    sexos {\n      codigo\n      nome\n    }\n  }\n'],['\n  {\n    sexos {\n      codigo\n      nome\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query {\n    estadosCivis {\n      codigo\n      nome\n      nemotecnico\n    }\n  }\n'],['\n  query {\n    estadosCivis {\n      codigo\n      nome\n      nemotecnico\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  query parametrizacao($parametro: String!) {\n    parametrizacao(parametro: $parametro) {\n      cobrar\n      chave\n      descricao\n      valor\n    }\n  }\n'],['\n  query parametrizacao($parametro: String!) {\n    parametrizacao(parametro: $parametro) {\n      cobrar\n      chave\n      descricao\n      valor\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlSexos=exports.gqlSexos=(0,_graphqlTag2.default)(_templateObject);var transformSexos=exports.transformSexos=function transformSexos(_ref){var data=_ref.data;return data.sexos.map(function(ec){return{value:ec.codigo.toString(),label:ec.nome};});};var gqlEstadosCivis=exports.gqlEstadosCivis=(0,_graphqlTag2.default)(_templateObject2);var transformEstadosCivis=exports.transformEstadosCivis=function transformEstadosCivis(_ref2){var data=_ref2.data;return data.estadosCivis.map(function(ec){return{value:ec.codigo.toString(),label:ec.nome};});};var gqlParametrizacao=exports.gqlParametrizacao=(0,_graphqlTag2.default)(_templateObject3);var transformBancos=exports.transformBancos=function transformBancos(_ref3){var data=_ref3.data;return data.parametrizacao.map(function(it){return{value:parseInt(it.chave,10),label:it.descricao};});};

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _services=__webpack_require__(175);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_STATES=_types2.default.FETCH_STATES;function fetchStates(){return function(dispatch){return(0,_services.getStates)().then(function(address){dispatch({type:FETCH_STATES,state:address});return address;});};}exports.default=fetchStates;module.exports=exports['default'];

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _services=__webpack_require__(175);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_CITIES_FROM_STATE=_types2.default.FETCH_CITIES_FROM_STATE;function fetchCitiesFromState(data){return function(dispatch){return(0,_services.getCitiesFromState)(data).then(function(address){dispatch({type:FETCH_CITIES_FROM_STATE,state:address});return address;});};}exports.default=fetchCitiesFromState;module.exports=exports['default'];

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _accountService=__webpack_require__(64);function fetchNewPassword(data){return function(){return(0,_accountService.newUserPassword)(data);};}exports.default=fetchNewPassword;module.exports=exports['default'];

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=fetchRecoverTokenStatus;var _accountService=__webpack_require__(64);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_RECOVER_TOKEN_STATUS=_types2.default.UPDATE_RECOVER_TOKEN_STATUS;function fetchRecoverTokenStatus(token){return function(dispatch){return(0,_accountService.verifyRecoverTokenStatus)(token).then(function(recoverTokenStatus){dispatch({type:UPDATE_RECOVER_TOKEN_STATUS,recoverTokenStatus:recoverTokenStatus});}).catch(function(err){err.json().then(function(response){dispatch({type:UPDATE_RECOVER_TOKEN_STATUS,recoverTokenStatus:response});});});};}module.exports=exports['default'];

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _accountService=__webpack_require__(64);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_TERMS_CONDITIONS=_types2.default.FETCH_TERMS_CONDITIONS;function fetchTermsAndConditions(){return function(dispatch){return(0,_accountService.getTermsAndConditions)().then(function(response){dispatch({type:FETCH_TERMS_CONDITIONS,state:response});});};}exports.default=fetchTermsAndConditions;module.exports=exports['default'];

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _services=__webpack_require__(175);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_BANK_LIST=_types2.default.FETCH_BANK_LIST;function fetchBankList(){return function(dispatch){return(0,_services.getBankList)().then(function(banks){dispatch({type:FETCH_BANK_LIST,state:banks});return banks;});};}exports.default=fetchBankList;module.exports=exports['default'];

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=fetchPlanData;var _dashboardService=__webpack_require__(66);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_PLAN_DATA=_types2.default.UPDATE_PLAN_DATA;function fetchPlanData(plan){return function(dispatch){return(0,_dashboardService.getPlanData)(plan).then(function(plandata){dispatch({type:UPDATE_PLAN_DATA,plandata:plandata});}).catch(function(error){console.log('Erro em #fetchPlanData()',error);return error;});};}module.exports=exports['default'];

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _accountService=__webpack_require__(64);function fetchFollowRequest(accountNumber,type){return(0,_accountService.getTrackIdentifiers)(accountNumber,type);}exports.default=fetchFollowRequest;module.exports=exports['default'];

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _commonService=__webpack_require__(357);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_REASON_LIST=_types2.default.FETCH_REASON_LIST;function fetchReasonList(){return function(dispatch){return(0,_commonService.getReasonList)().then(function(response){dispatch({type:FETCH_REASON_LIST,state:response});return response;});};}exports.default=fetchReasonList;module.exports=exports['default'];

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _accountService=__webpack_require__(64);function fetchFollowRequestDetails(accountNumber,order){return(0,_accountService.getTrackIdentifiersDetails)(accountNumber,order);}exports.default=fetchFollowRequestDetails;module.exports=exports['default'];

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchUpdateAddress=fetchUpdateAddress;exports.fetchDeleteAddress=fetchDeleteAddress;var _userService=__webpack_require__(74);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_ADDRESS_UPDATE=_types2.default.FETCH_ADDRESS_UPDATE,FETCH_ADDRESS_DELETE=_types2.default.FETCH_ADDRESS_DELETE;function fetchUpdateAddress(data){return function(dispatch){return(0,_userService.updateUserAddress)(data).then(function(response){dispatch({type:FETCH_ADDRESS_UPDATE,state:data});});};}function fetchDeleteAddress(data){return function(dispatch){return(0,_userService.deleteUserAddress)(data).then(function(address){dispatch({type:FETCH_ADDRESS_DELETE,state:address});});};}

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setStateModal=setStateModal;exports.setLoginMsgError=setLoginMsgError;exports.setShowCaptch=setShowCaptch;var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var STATE_MODAL=_types2.default.STATE_MODAL,LOGIN_MSG_ERROR=_types2.default.LOGIN_MSG_ERROR,SHOW_CAPTCHA=_types2.default.SHOW_CAPTCHA;function setStateModal(data){return{type:STATE_MODAL,stateModal:data};}function setLoginMsgError(data){return{type:LOGIN_MSG_ERROR,loginMsgError:data};}function setShowCaptch(data){return{type:SHOW_CAPTCHA,showCaptcha:data};}

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchUpdateBusinessAddress=fetchUpdateBusinessAddress;exports.fetchDeleteBusinessAddress=fetchDeleteBusinessAddress;var _userService=__webpack_require__(74);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_ADDRESS_UPDATE=_types2.default.FETCH_ADDRESS_UPDATE,FETCH_ADDRESS_DELETE=_types2.default.FETCH_ADDRESS_DELETE;function fetchUpdateBusinessAddress(data){return function(dispatch){return(0,_userService.updateBusinessUserAddress)(data).then(function(address){dispatch({type:FETCH_ADDRESS_UPDATE,state:data});});};}function fetchDeleteBusinessAddress(data){return function(dispatch){return(0,_userService.deleteBusinessUserAddress)(data).then(function(address){dispatch({type:FETCH_ADDRESS_DELETE,state:address});});};}

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchContestationProtocol=fetchContestationProtocol;exports.clearContestationProtocol=clearContestationProtocol;var _dashboardService=__webpack_require__(66);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_CONTESTATION_PROTOCOL=_types2.default.UPDATE_CONTESTATION_PROTOCOL,CLEAR_CONTESTATION_PROTOCOL=_types2.default.CLEAR_CONTESTATION_PROTOCOL;function fetchContestationProtocol(data){return function(dispatch){return(0,_dashboardService.getContestationProtocol)(data).then(function(protocol){dispatch({type:UPDATE_CONTESTATION_PROTOCOL,protocol:protocol});return protocol;});};}function clearContestationProtocol(){return function(dispatch){return dispatch({type:CLEAR_CONTESTATION_PROTOCOL});};}

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchDeleteRepresentative=fetchDeleteRepresentative;exports.fetchUpdateRepresentative=fetchUpdateRepresentative;exports.fetchCreateRepresentative=fetchCreateRepresentative;var _userService=__webpack_require__(74);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DELETE_REPRESENTATIVE=_types2.default.DELETE_REPRESENTATIVE,UPDATE_REPRESENTATIVE=_types2.default.UPDATE_REPRESENTATIVE,ADD_REPRESENTATIVE=_types2.default.ADD_REPRESENTATIVE;var cleanDocument=function cleanDocument(){var document=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return document.replace(/\.|-/g,'');};function fetchDeleteRepresentative(rawDocument){var document=cleanDocument(rawDocument);return function(dispatch){return(0,_userService.deleteRepresentative)(document).then(function(){setTimeout(function(){dispatch({type:DELETE_REPRESENTATIVE,document:document});},600);});};}function fetchUpdateRepresentative(rawData){var data=rawData;data.document=cleanDocument(data.document);return function(dispatch){return(0,_userService.updateBusinessUserRepresentative)(data).then(function(){dispatch({type:UPDATE_REPRESENTATIVE,data:data});});};}function fetchCreateRepresentative(rawData){var data=rawData;data.document=cleanDocument(data.document);return function(dispatch){return(0,_userService.createRepresentative)(data).then(function(){dispatch({type:ADD_REPRESENTATIVE,data:data});});};}

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchDashboardStatements=fetchDashboardStatements;exports.downloadStatementFile=downloadStatementFile;exports.downloadStatementFileCSV=downloadStatementFileCSV;exports.resetDashboardStatements=resetDashboardStatements;exports.sendStatementemail=sendStatementemail;exports.downloadVehiclesFileCSV=downloadVehiclesFileCSV;var _dashboardService=__webpack_require__(66);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_STATEMENTS=_types2.default.UPDATE_STATEMENTS,RESET_STATEMENTS=_types2.default.RESET_STATEMENTS;function fetchDashboardStatements(planId,next,filter){return function(dispatch){return(0,_dashboardService.getStatements)(planId,next,filter).then(function(statements){if(statements.status===204){console.log('statements status -> ',status);}else{dispatch({type:UPDATE_STATEMENTS,data:statements.data,total:statements.total,monthlyTotal:statements.monthlyTotal,filter:filter,next:statements.next,updatedOn:statements.updatedOn,hasNext:statements.hasNext,enviarExtratoEmail:statements.enviarExtratoEmail});}});};}function downloadStatementFile(planId,filter){return function(){return(0,_dashboardService.downloadStatement)(planId,filter);};}function downloadStatementFileCSV(planId,filter){return function(){return(0,_dashboardService.downloadStatementCSV)(planId,filter);};}function resetDashboardStatements(){return function(dispatch){return dispatch({type:RESET_STATEMENTS});};}function sendStatementemail(planId,email,filter,formato){return function(){return(0,_dashboardService.sendStatementEmail)(planId,email,filter,formato);};}function downloadVehiclesFileCSV(planId){return function(){return(0,_dashboardService.downloadVehiclesCSV)(planId);};}

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchDashboardInvoices=fetchDashboardInvoices;exports.downloadInvoiceCSVFile=downloadInvoiceCSVFile;exports.downloadTicketFile=downloadTicketFile;exports.downloadInvoiceFile=downloadInvoiceFile;exports.resetDashboardInvoices=resetDashboardInvoices;exports.downloadFaturaFile=downloadFaturaFile;var _dashboardService=__webpack_require__(66);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_INVOICES=_types2.default.UPDATE_INVOICES,RESET_INVOICES=_types2.default.RESET_INVOICES;function fetchDashboardInvoices(planId,nextURL){return function(dispatch){return(0,_dashboardService.getInvoices)(planId,nextURL).then(function(invoices){if(invoices&&invoices.faturas){dispatch({type:UPDATE_INVOICES,data:invoices.faturas,next:invoices.paginacao});}});};}function downloadInvoiceCSVFile(planId,invoiceId){return function(){return(0,_dashboardService.downloadCSVInvoice)(planId,invoiceId).then(function(result){return result;});};}function downloadTicketFile(planId,invoiceId){return function(){return(0,_dashboardService.downloadTicket)(planId,invoiceId).then(function(result){return result;});};}function downloadInvoiceFile(planId,year,month){return function(){return(0,_dashboardService.downloadInvoice)(planId,year,month).then(function(result){return result;});};}function resetDashboardInvoices(){return function(dispatch){return dispatch({type:RESET_INVOICES});};}function downloadFaturaFile(planId,invoiceId){return function(){return(0,_dashboardService.downloadFatura)(planId,invoiceId).then(function(result){return result;});};}

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchDashboardRecharges=fetchDashboardRecharges;exports.resetDashboardRecharges=resetDashboardRecharges;var _dashboardService=__webpack_require__(66);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_RECHARGES=_types2.default.UPDATE_RECHARGES,RESET_RECHARGES=_types2.default.RESET_RECHARGES;function fetchDashboardRecharges(planId,next){return function(dispatch){return(0,_dashboardService.getRecharges)(planId,next).then(function(recharges){dispatch({type:UPDATE_RECHARGES,data:recharges.data,next:recharges.next});});};}function resetDashboardRecharges(){return function(dispatch){return dispatch({type:RESET_RECHARGES});};}

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchShippingUpdateAddress=fetchShippingUpdateAddress;exports.fetchGetShippingAmount=fetchGetShippingAmount;var _shipping=__webpack_require__(1372);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_SHIPPING_UPDATE_ADDRESS=_types2.default.FETCH_SHIPPING_UPDATE_ADDRESS,FETCH_SHIPPING_AMOUNT=_types2.default.FETCH_SHIPPING_AMOUNT;function fetchShippingUpdateAddress(data){return function(dispatch){return(0,_shipping.updateShippingAddress)(data).then(function(response){dispatch({type:FETCH_SHIPPING_UPDATE_ADDRESS,state:false});return response;});};}function fetchGetShippingAmount(data){return function(dispatch){return(0,_shipping.getShippingAmount)(data).then(function(shippingAmount){dispatch({type:FETCH_SHIPPING_AMOUNT,state:shippingAmount.amount});return shippingAmount;}).catch(function(error){console.log('Erro em #fetchGetShippingAmount()');console.log(error);});};}

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.updateShippingAddress=updateShippingAddress;exports.getShippingAmount=getShippingAmount;/**
 * ARQUIVO LEGADO.
 * TODO: Conseguir excluir arquivo de serviço. Primeiro acesso é realizado pelo site público
 */var activationResponse={status:true,protocol:'201801228659'};var unactivationResponse={status:false};var freeResponseShipping={status:true,amount:'Grátis'};var valueResponseShipping={status:false,amount:'29,00'};function updateShippingAddress(address){return new Promise(function(resolve,reject){window.setTimeout(function(){if(address)resolve(activationResponse);else reject(unactivationResponse);},1000);});}function getShippingAmount(zipcode){return new Promise(function(resolve,reject){window.setTimeout(function(){if(zipcode)resolve(freeResponseShipping);else resolve(valueResponseShipping);},1000);});}

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchAccountPlans=fetchAccountPlans;exports.fetchAccountPlansActivation=fetchAccountPlansActivation;exports.fetchECAccountPlans=fetchECAccountPlans;exports.fetchAccountPlan=fetchAccountPlan;exports.setActivePlanId=setActivePlanId;exports.fetchPostCancellationRequest=fetchPostCancellationRequest;exports.fetchPutCancellationRequest=fetchPutCancellationRequest;var _accountService=__webpack_require__(64);var _tokenStorage=__webpack_require__(557);var _tokenStorage2=_interopRequireDefault(_tokenStorage);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SET_ACCOUNT_PLANS=_types2.default.SET_ACCOUNT_PLANS,SET_EC_ACCOUNT_PLANS=_types2.default.SET_EC_ACCOUNT_PLANS,SET_ACCOUNT_PLAN=_types2.default.SET_ACCOUNT_PLAN,SET_ACCOUNT_ACTIVE_PLAN_ID=_types2.default.SET_ACCOUNT_ACTIVE_PLAN_ID,SET_CANCEL_ACCOUNT_STATUS=_types2.default.SET_CANCEL_ACCOUNT_STATUS;var storage=new _tokenStorage2.default();function fetchAccountPlans(){var accountId=storage.getAccount().id;return function(dispatch){return(0,_accountService.getAccountPlans)(accountId).then(function(plans){dispatch({type:SET_ACCOUNT_PLANS,plans:plans});return plans;});};}function fetchAccountPlansActivation(){var accountId=storage.getAccount().id;return function(dispatch){return(0,_accountService.getAccountPlansActivation)(accountId).then(function(plans){dispatch({type:SET_ACCOUNT_PLANS,plans:plans});return plans;});};}function fetchECAccountPlans(){var accountId=storage.getAccount().id;return function(dispatch){return(0,_accountService.getECAccountPlans)(accountId).then(function(plans){dispatch({type:SET_EC_ACCOUNT_PLANS,plans:plans});return plans;});};}function fetchAccountPlan(planId){var accountId=storage.getAccount().id;return function(dispatch){return(0,_accountService.getAccountPlans)(accountId,planId).then(function(plan){dispatch({type:SET_ACCOUNT_PLAN,plan:plan});return plan;});};}function setActivePlanId(activePlanId){return{type:SET_ACCOUNT_ACTIVE_PLAN_ID,activePlanId:activePlanId};}function fetchPostCancellationRequest(accountId,planId,motive){return function(dispatch){return(0,_accountService.postCancellationRequest)(accountId,planId,motive).then(function(resp){dispatch({type:SET_CANCEL_ACCOUNT_STATUS,payload:{waitingCancellationToken:true}});return resp;});};}function fetchPutCancellationRequest(accountId,planId,token){return function(dispatch){return(0,_accountService.putCancellationRequest)(accountId,planId,token).then(function(resp){dispatch({type:SET_CANCEL_ACCOUNT_STATUS,payload:{waitingCancellationToken:false,protocol:resp.protocol,date:resp.date}});return resp;});};}

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();exports.fetchAuthentication=fetchAuthentication;exports.setToken=setToken;exports.fetchLogout=fetchLogout;var _accountService=__webpack_require__(64);var _tokenStorage=__webpack_require__(557);var _tokenStorage2=_interopRequireDefault(_tokenStorage);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var SET_AUTHENTICATION=_types2.default.SET_AUTHENTICATION,LOGOUT=_types2.default.LOGOUT;var storage=new _tokenStorage2.default();function fetchAuthentication(login,password,responseCaptcha){var _this=this;return function(dispatch){return(0,_accountService.authenticate)(login,password,responseCaptcha).then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(credentials){var _ref2,_ref3,profileAtivadoresUnidas,profileWhiteLabelMails,profileParceirosMails;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_accountService.getProfilesPartners)(['usuariosAtivadoresUnidas','usuariosWhiteLabel','usuariosPortalParceiro'],login);case 2:_ref2=_context.sent;_ref3=_slicedToArray(_ref2,3);profileAtivadoresUnidas=_ref3[0];profileWhiteLabelMails=_ref3[1];profileParceirosMails=_ref3[2];if(profileAtivadoresUnidas.length>0){credentials.at=window.btoa(login);}if(profileWhiteLabelMails.length>0){credentials.wl=window.btoa(login);}if(profileParceirosMails.length>0){credentials.pc=window.btoa(login);}storage.setAccount(credentials);storage.setSessionId(credentials.sessionId);dispatch({type:SET_AUTHENTICATION,credentials:credentials});return _context.abrupt('return',credentials);case 14:case'end':return _context.stop();}}},_callee,_this);}));return function(_x){return _ref.apply(this,arguments);};}());};}function setToken(credentials){return function(dispatch){storage.setAccount(credentials);return dispatch({type:SET_AUTHENTICATION,credentials:credentials});};}function fetchLogout(){return function(dispatch){return(0,_accountService.logout)().then(function(){dispatch({type:LOGOUT});return true;});};}

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setCurrentRechargeValue=setCurrentRechargeValue;exports.fetchRechargeValues=fetchRechargeValues;exports.fetchPaymentInfo=fetchPaymentInfo;exports.fetchCreateRecharge=fetchCreateRecharge;exports.fetchChangeRecharge=fetchChangeRecharge;var _rechargeService=__webpack_require__(358);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SET_RECHARGE_VALUES=_types2.default.SET_RECHARGE_VALUES,SET_CURRENT_RECHARGE_VALUE=_types2.default.SET_CURRENT_RECHARGE_VALUE,SET_PAYMENT_INFO=_types2.default.SET_PAYMENT_INFO,SET_CHANGE_RECHARGE=_types2.default.SET_CHANGE_RECHARGE;function setCurrentRechargeValue(currentRechargeValue){return{type:SET_CURRENT_RECHARGE_VALUE,currentRechargeValue:currentRechargeValue};}function fetchRechargeValues(accountPlanId){return function(dispatch){return(0,_rechargeService.getRechargeValues)(accountPlanId).then(function(){var resp=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var rechargeValues=resp.rechargeValues||[];dispatch({type:SET_RECHARGE_VALUES,rechargeValues:rechargeValues});return rechargeValues;});};}function fetchPaymentInfo(accountPlanId){return function(dispatch){return(0,_rechargeService.getPaymentInfo)(accountPlanId).then(function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action={type:SET_PAYMENT_INFO,paymentInfo:info};dispatch(action);return info;});};}function fetchCreateRecharge(_ref){var accountPlanId=_ref.accountPlanId,value=_ref.value,paymentMethod=_ref.paymentMethod,type=_ref.type;return function(){return(0,_rechargeService.createRecharge)(accountPlanId,value,paymentMethod,type).then(function(resp){return resp;});};}function fetchChangeRecharge(accountId,valorRecarga){return function(dispatch){return(0,_rechargeService.changeRecharge)(accountId,valorRecarga).then(function(){var info=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action={type:SET_CHANGE_RECHARGE,valorRecarga:info};dispatch(action);return info;});};}

/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchGenderList=fetchGenderList;exports.fetchMaritialStatusList=fetchMaritialStatusList;exports.fetchTelephoneTypeList=fetchTelephoneTypeList;exports.fetchStatesList=fetchStatesList;var _commonService=__webpack_require__(357);var _cookie=__webpack_require__(558);var genderList=null;var maritialStatusList=null;function fetchGenderList(){if(genderList)return Promise.resolve(genderList);return(0,_commonService.getGenderList)().then(function(resp){genderList=resp;console.log({genderList:genderList});return resp;});}function fetchMaritialStatusList(){if(maritialStatusList)return Promise.resolve(maritialStatusList);return(0,_commonService.getMaritialStatusList)().then(function(resp){maritialStatusList=resp;console.log({maritialStatusList:maritialStatusList});return resp;});}function fetchTelephoneTypeList(){// const storedTelephoneType = getCookie('telephone-type');
// if (storedTelephoneType) {
//    return new Promise(resolve => resolve(JSON.parse(storedTelephoneType)));
// }
return(0,_commonService.getTelephoneTypesList)().then(function(resp){(0,_cookie.setCookie)('telephone-type',JSON.stringify(resp),30);return resp;});}function fetchStatesList(){var storedStates=(0,_cookie.getCookie)('states');if(storedStates){return new Promise(function(resolve){return resolve(JSON.parse(storedStates));});}return fetchStatesList().then(function(resp){(0,_cookie.setCookie)('states',JSON.stringify(resp),30);return resp;});}

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchActivation=fetchActivation;exports.fetchActivationForPartners=fetchActivationForPartners;exports.fetchInactiveIdentifier=fetchInactiveIdentifier;exports.fetchReplaceIdentifier=fetchReplaceIdentifier;exports.fetchNewIdentifier=fetchNewIdentifier;var _activationService=__webpack_require__(359);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ACTIVATION_IDENTIFIER=_types2.default.ACTIVATION_IDENTIFIER,INACTIVE_IDENTIFIER=_types2.default.INACTIVE_IDENTIFIER,REPLACE_IDENTIFIER=_types2.default.REPLACE_IDENTIFIER,NEW_IDENTIFIER=_types2.default.NEW_IDENTIFIER;function fetchActivation(data){return function(dispatch){return(0,_activationService.activateIdentifier)(data).then(function(activation){dispatch({type:ACTIVATION_IDENTIFIER,state:null});return activation;});};}function fetchActivationForPartners(data){return function(dispatch){return(0,_activationService.activateIdentifier)(data).then(function(){dispatch({type:ACTIVATION_IDENTIFIER,state:null});return data;});};}function fetchInactiveIdentifier(data){return function(dispatch){return(0,_activationService.inactiveIdentifier)(data).then(function(activation){dispatch({type:INACTIVE_IDENTIFIER,state:null});return activation;});};}function fetchReplaceIdentifier(data){return function(dispatch){return(0,_activationService.replaceIdentifier)(data).then(function(activation){dispatch({type:REPLACE_IDENTIFIER,state:null});return activation;});};}function fetchNewIdentifier(data){return function(dispatch){return(0,_activationService.newIdentifier)(data).then(function(identifier){dispatch({type:NEW_IDENTIFIER,state:null});return identifier;});};}

/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.setNewDataValue=setNewDataValue;exports.setNewDataValueWithoutRecharge=setNewDataValueWithoutRecharge;exports.setNewDueDate=setNewDueDate;exports.fetchEditPaymentData=fetchEditPaymentData;exports.lockAuthorizationPayment=lockAuthorizationPayment;exports.checkEditAuthorizationPayment=checkEditAuthorizationPayment;var _editPaymentDataService=__webpack_require__(559);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SET_NEW_DATA_VALUE=_types2.default.SET_NEW_DATA_VALUE,SET_NEW_DUE_DATE=_types2.default.SET_NEW_DUE_DATE,GET_EDIT_AUTH_PAYMENT=_types2.default.GET_EDIT_AUTH_PAYMENT,LOCK_EDIT_AUTH_PAYMENT=_types2.default.LOCK_EDIT_AUTH_PAYMENT;function setNewDataValue(data){return function(dispatch){return(0,_editPaymentDataService.editPaymentMethod)(data).then(function(edited){dispatch({type:SET_NEW_DATA_VALUE,data:data});return edited;});};}function setNewDataValueWithoutRecharge(data){return function(dispatch){return(0,_editPaymentDataService.editPaymentMethodWithoutRecharge)(data).then(function(edited){dispatch({type:SET_NEW_DATA_VALUE,data:data});return edited;});};}function setNewDueDate(data){return function(dispatch){return(0,_editPaymentDataService.editDueDate)(data).then(function(edited){dispatch({type:SET_NEW_DUE_DATE,data:data});});};}function fetchEditPaymentData(_ref){var accountPlanId=_ref.accountPlanId,recharge=_ref.recharge,payment=_ref.payment;return function(){return(0,_editPaymentDataService.editPaymentData)(accountPlanId,recharge,payment).then(function(resp){return resp;});};}function lockAuthorizationPayment(type){return function(dispatch){return dispatch({type:LOCK_EDIT_AUTH_PAYMENT,changeType:type,authorizations:{error:'Já alterado'}});};}function checkEditAuthorizationPayment(type,accountPlanId){return function(dispatch){return(0,_editPaymentDataService.getEditAuthorizationPayment)(type,accountPlanId).then(function(authorizations){return dispatch({type:GET_EDIT_AUTH_PAYMENT,changeType:type,authorizations:authorizations});});};}

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.gqlEditarFormaPagamento=exports.gqlEditarDataVencimento=exports.gqlConsultarDataVencimento=exports.gqlAutorizaEditarFormaPagamentoDataVencimento=exports.gqlConsultarFormasPagamento=undefined;var _templateObject=_taggedTemplateLiteral(['\n  query ConsultarFormasPagamento {\n    ConsultarFormasPagamento {\n      formas {\n        forma\n        descricao\n      }\n    }\n  }\n'],['\n  query ConsultarFormasPagamento {\n    ConsultarFormasPagamento {\n      formas {\n        forma\n        descricao\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query AutorizaEditarFormaPagamentoDataVencimento($tipo: String, $idConta: String) {\n    AutorizaEditarFormaPagamentoDataVencimento(tipo: $tipo, idConta: $idConta) {\n      mensagem\n      dataUltimaAlteracao\n      dataProximaAlteracao\n    }\n  }\n'],['\n  query AutorizaEditarFormaPagamentoDataVencimento($tipo: String, $idConta: String) {\n    AutorizaEditarFormaPagamentoDataVencimento(tipo: $tipo, idConta: $idConta) {\n      mensagem\n      dataUltimaAlteracao\n      dataProximaAlteracao\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  {\n    ConsultarDataVencimento {\n      dia\n      proximasFaturas\n    }\n  }\n'],['\n  {\n    ConsultarDataVencimento {\n      dia\n      proximasFaturas\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  mutation EditarDataVencimento($idConta: String!, $diaVenctoSolicitado: String!) {\n    EditarDataVencimento(\n      dataVencimento: { idConta: $idConta, diaVenctoSolicitado: $diaVenctoSolicitado }\n    ) {\n      statusCode\n      message\n    }\n  }\n'],['\n  mutation EditarDataVencimento($idConta: String!, $diaVenctoSolicitado: String!) {\n    EditarDataVencimento(\n      dataVencimento: { idConta: $idConta, diaVenctoSolicitado: $diaVenctoSolicitado }\n    ) {\n      statusCode\n      message\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  mutation EditarFormaPagamento(\n    $tipoPagamento: String\n    $conta: String\n    $numeroMascarado: String\n    $validade: String\n    $bandeira: String\n    $alias: String\n    $cpf: String\n    $nome: String\n    $paymentToken: String\n    $cvv: String\n    $agencia: String\n    $ativo: Int\n    $numeroContaCorrente: String\n    $idBanco: String\n  ) {\n    EditarFormaPagamento(\n      formaPagamento: {\n        tipoPagamento: $tipoPagamento\n        conta: $conta\n        numeroMascarado: $numeroMascarado\n        validade: $validade\n        bandeira: $bandeira\n        alias: $alias\n        cpf: $cpf\n        nome: $nome\n        paymentToken: $paymentToken\n        cvv: $cvv\n        agencia: $agencia\n        ativo: $ativo\n        numeroContaCorrente: $numeroContaCorrente\n        idBanco: $idBanco\n      }\n    ) {\n      tipoPagamento\n      conta\n      numeroMascarado\n      validade\n      bandeira\n      alias\n      cpf\n      nome\n      paymentToken\n      cvv\n      agencia\n      ativo\n      numeroContaCorrente\n      idBanco\n    }\n  }\n'],['\n  mutation EditarFormaPagamento(\n    $tipoPagamento: String\n    $conta: String\n    $numeroMascarado: String\n    $validade: String\n    $bandeira: String\n    $alias: String\n    $cpf: String\n    $nome: String\n    $paymentToken: String\n    $cvv: String\n    $agencia: String\n    $ativo: Int\n    $numeroContaCorrente: String\n    $idBanco: String\n  ) {\n    EditarFormaPagamento(\n      formaPagamento: {\n        tipoPagamento: $tipoPagamento\n        conta: $conta\n        numeroMascarado: $numeroMascarado\n        validade: $validade\n        bandeira: $bandeira\n        alias: $alias\n        cpf: $cpf\n        nome: $nome\n        paymentToken: $paymentToken\n        cvv: $cvv\n        agencia: $agencia\n        ativo: $ativo\n        numeroContaCorrente: $numeroContaCorrente\n        idBanco: $idBanco\n      }\n    ) {\n      tipoPagamento\n      conta\n      numeroMascarado\n      validade\n      bandeira\n      alias\n      cpf\n      nome\n      paymentToken\n      cvv\n      agencia\n      ativo\n      numeroContaCorrente\n      idBanco\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlConsultarFormasPagamento=exports.gqlConsultarFormasPagamento=(0,_graphqlTag2.default)(_templateObject);var gqlAutorizaEditarFormaPagamentoDataVencimento=exports.gqlAutorizaEditarFormaPagamentoDataVencimento=(0,_graphqlTag2.default)(_templateObject2);var gqlConsultarDataVencimento=exports.gqlConsultarDataVencimento=(0,_graphqlTag2.default)(_templateObject3);var gqlEditarDataVencimento=exports.gqlEditarDataVencimento=(0,_graphqlTag2.default)(_templateObject4);var gqlEditarFormaPagamento=exports.gqlEditarFormaPagamento=(0,_graphqlTag2.default)(_templateObject5);

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchInvoiceDetails=fetchInvoiceDetails;exports.resetInvoiceDetails=resetInvoiceDetails;var _invoiceService=__webpack_require__(1381);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_INVOICE_DETAILS=_types2.default.UPDATE_INVOICE_DETAILS,RESET_INVOICE_DETAILS=_types2.default.RESET_INVOICE_DETAILS;function fetchInvoiceDetails(planId,faturaId,qtdTransacoes){return function(dispatch){return(0,_invoiceService.getInvoiceDetails)(planId,faturaId,qtdTransacoes).then(function(details){dispatch({type:UPDATE_INVOICE_DETAILS,details:details});});};}function resetInvoiceDetails(){return function(dispatch){return dispatch({type:RESET_INVOICE_DETAILS});};}

/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getInvoiceDetails=undefined;var getInvoiceDetails=exports.getInvoiceDetails=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(idConta,faturaId,qtdTransacoes){var payload,_ref2,_ref2$data,_ref2$data$detalheFat,detalheFaturaPj;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:payload={idConta:idConta,faturaId:parseInt(faturaId),qtdTransacoes:parseInt(qtdTransacoes)};_context.next=3;return(0,_apolloClient.gqlQuery)(_invoices.gqlInvoice,payload);case 3:_ref2=_context.sent;_ref2$data=_ref2.data;_ref2$data=_ref2$data===undefined?{}:_ref2$data;_ref2$data$detalheFat=_ref2$data.detalheFaturaPj,detalheFaturaPj=_ref2$data$detalheFat===undefined?{}:_ref2$data$detalheFat;return _context.abrupt('return',detalheFaturaPj);case 8:case'end':return _context.stop();}}},_callee,this);}));return function getInvoiceDetails(_x,_x2,_x3){return _ref.apply(this,arguments);};}();var _apolloClient=__webpack_require__(42);var _invoices=__webpack_require__(356);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}

/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.updateManageInf=exports.deleteManageInf=exports.saveManageInf=exports.fetchGetManageInfsTop5=exports.fetchGetManageInfsHistory=exports.fetchGetManageInfsActive=exports.fetchGetManageInfs=undefined;var _manageInfService=__webpack_require__(1383);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var fetchGetManageInfs=exports.fetchGetManageInfs=function fetchGetManageInfs(accountId,plate){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch){var informations;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch({type:_types2.default.FETCH_MANAGE_INF});_context.prev=1;_context.next=4;return(0,_manageInfService.getManageInfs)(accountId,plate);case 4:informations=_context.sent;dispatch({type:_types2.default.FETCH_MANAGE_INF_FINISHED,informations:informations});_context.next=13;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);console.log('Erro em #fetchGetManageInfs()',_context.t0);dispatch({type:_types2.default.FETCH_MANAGE_INF_FINISHED,informations:[]});return _context.abrupt('return',_context.t0);case 13:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var fetchGetManageInfsActive=exports.fetchGetManageInfsActive=function fetchGetManageInfsActive(accountId,plate){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch){var informations;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch({type:_types2.default.FETCH_MANAGE_INF});_context2.prev=1;_context2.next=4;return(0,_manageInfService.getManageInfsActive)(accountId,plate);case 4:informations=_context2.sent;dispatch({type:_types2.default.FETCH_MANAGE_INF_FINISHED,informations:informations});_context2.next=13;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);console.log('Erro em #getManageInfsActive()',_context2.t0);dispatch({type:_types2.default.FETCH_MANAGE_INF_FINISHED,informations:[]});return _context2.abrupt('return',_context2.t0);case 13:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var fetchGetManageInfsHistory=exports.fetchGetManageInfsHistory=function fetchGetManageInfsHistory(accountId,plate){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch){var informations;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch({type:_types2.default.FETCH_HIST_MANAGE_INF});_context3.prev=1;_context3.next=4;return(0,_manageInfService.getManageInfHistory)(accountId,plate);case 4:informations=_context3.sent;dispatch({type:_types2.default.FETCH_HIST_MANAGE_INF_FINISHED,informations:informations});_context3.next=13;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);console.log('Erro em #fetchGetManageInfHistory()',_context3.t0);dispatch({type:_types2.default.FETCH_HIST_MANAGE_INF_FINISHED,informations:[]});return _context3.abrupt('return',_context3.t0);case 13:case'end':return _context3.stop();}}},_callee3,undefined,[[1,8]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var fetchGetManageInfsTop5=exports.fetchGetManageInfsTop5=function fetchGetManageInfsTop5(accountId){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch){var informations;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch({type:_types2.default.FETCH_TOP5_MANAGE_INF});_context4.prev=1;_context4.next=4;return(0,_manageInfService.getManageInfTop5)(accountId);case 4:informations=_context4.sent;dispatch({type:_types2.default.FETCH_TOP5_MANAGE_INF_FINISHED,informations:informations});_context4.next=13;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](1);console.log('Erro em #fetchGetManageInfTop5()',_context4.t0);dispatch({type:_types2.default.FETCH_TOP5_MANAGE_INF_FINISHED,informations:[]});return _context4.abrupt('return',_context4.t0);case 13:case'end':return _context4.stop();}}},_callee4,undefined,[[1,8]]);}));return function(_x4){return _ref4.apply(this,arguments);};}();};var saveManageInf=exports.saveManageInf=function saveManageInf(data){return function(dispatch){dispatch({type:_types2.default.UPDATE_MANAGE_INF});return new Promise(function(resolve,reject){return(0,_manageInfService.createManageInfo)(data).then(function(resp){dispatch({type:_types2.default.UPDATE_MANAGE_INF_FINISHED});return resolve(resp);}).catch(function(error){console.log('Erro em #saveManageInf(): ',error);dispatch({type:_types2.default.UPDATE_MANAGE_INF_FINISHED});return reject(error);});});};};var deleteManageInf=exports.deleteManageInf=function deleteManageInf(data){return function(dispatch){dispatch({type:_types2.default.UPDATE_MANAGE_INF});return new Promise(function(resolve,reject){return(0,_manageInfService.deleteManageInfo)(data).then(function(resp){dispatch({type:_types2.default.UPDATE_MANAGE_INF_FINISHED});return resolve(resp);}).catch(function(error){console.log('Erro em #deleteManageInf()',error);dispatch({type:_types2.default.UPDATE_MANAGE_INF_FINISHED});return reject(error);});});};};var updateManageInf=exports.updateManageInf=function updateManageInf(data){return function(dispatch){dispatch({type:_types2.default.UPDATE_MANAGE_INF});return new Promise(function(resolve,reject){return(0,_manageInfService.updateManageInfo)(data).then(function(resp){dispatch({type:_types2.default.UPDATE_MANAGE_INF_FINISHED});return resolve(resp);}).catch(function(error){console.log('Erro em #updateManageInf()',error);dispatch({type:_types2.default.UPDATE_MANAGE_INF_FINISHED});return reject(error);});});};};

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.deleteManageInfo=exports.updateManageInfo=exports.createManageInfo=exports.getManageInfTop5=exports.getManageInfHistory=exports.getManageInfsActive=exports.getManageInfs=undefined;var getManageInfs=exports.getManageInfs=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(accountId,plate){var payload,response;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:payload={idConta:accountId,placa:plate};_context.next=3;return(0,_apolloClient.gqlQuery)(_informacaoGerencial.gqlBuscarInfoGerencialVigente,payload);case 3:response=_context.sent;return _context.abrupt('return',response.data.buscarInfoGerencialVigente);case 5:case'end':return _context.stop();}}},_callee,this);}));return function getManageInfs(_x,_x2){return _ref.apply(this,arguments);};}();var getManageInfsActive=exports.getManageInfsActive=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(accountId,plate){var payload,response;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:payload={idConta:accountId,placa:plate};_context2.next=3;return(0,_apolloClient.gqlQuery)(_informacaoGerencial.gqlBuscarInfoGerencialAtiva,payload);case 3:response=_context2.sent;return _context2.abrupt('return',response.data.buscarInfoGerencialAtiva);case 5:case'end':return _context2.stop();}}},_callee2,this);}));return function getManageInfsActive(_x3,_x4){return _ref2.apply(this,arguments);};}();var getManageInfHistory=exports.getManageInfHistory=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(accountId,plate){var payload,response;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:payload={idConta:accountId,placa:plate};_context3.next=3;return(0,_apolloClient.gqlQuery)(_informacaoGerencial.gqlBuscarInfoGerencialHistorico,payload);case 3:response=_context3.sent;return _context3.abrupt('return',response.data.buscarInfoGerencialHistorico);case 5:case'end':return _context3.stop();}}},_callee3,this);}));return function getManageInfHistory(_x5,_x6){return _ref3.apply(this,arguments);};}();var getManageInfTop5=exports.getManageInfTop5=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(accountId,plate){var payload,response;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:payload={idConta:accountId,placa:plate};_context4.next=3;return(0,_apolloClient.gqlQuery)(_informacaoGerencial.gqlBuscarInfoGerencialTop5,payload);case 3:response=_context4.sent;return _context4.abrupt('return',response.data.buscarInfoGerencialTop5);case 5:case'end':return _context4.stop();}}},_callee4,this);}));return function getManageInfTop5(_x7,_x8){return _ref4.apply(this,arguments);};}();var createManageInfo=exports.createManageInfo=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(_ref6){var data=_ref6.data;var payload,response;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:payload={identificador:data.codIdentificador,conta:data.conta,data:data.dataInicioVigencia,descricao:data.descricao,placa:data.placa,tipo:data.tipoInfo};_context5.next=3;return(0,_apolloClient.gqlMutate)(_informacaoGerencial.gqlCriarInfoGerencial,payload);case 3:response=_context5.sent;return _context5.abrupt('return',response);case 5:case'end':return _context5.stop();}}},_callee5,this);}));return function createManageInfo(_x9){return _ref5.apply(this,arguments);};}();var updateManageInfo=exports.updateManageInfo=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(_ref8){var data=_ref8.data;var payload,response;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:payload={identificador:data.codIdentificador,conta:data.conta,data:data.dataInicioVigencia,descricao:data.descricao,placa:data.placa,tipo:data.tipoInfo};_context6.next=3;return(0,_apolloClient.gqlMutate)(_informacaoGerencial.gqlAlterarInfoGerencial,payload);case 3:response=_context6.sent;return _context6.abrupt('return',response);case 5:case'end':return _context6.stop();}}},_callee6,this);}));return function updateManageInfo(_x10){return _ref7.apply(this,arguments);};}();var deleteManageInfo=exports.deleteManageInfo=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(data){var payload,response;return regeneratorRuntime.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:payload={identificador:data.codIdentificador,conta:data.conta,data:data.dataInicioVigencia,descricao:data.descricao,placa:data.placa,tipo:data.tipoInfo};_context7.next=3;return(0,_apolloClient.gqlMutate)(_informacaoGerencial.gqlExcluirInfoGerencial,payload);case 3:response=_context7.sent;return _context7.abrupt('return',response);case 5:case'end':return _context7.stop();}}},_callee7,this);}));return function deleteManageInfo(_x11){return _ref9.apply(this,arguments);};}();var _apolloClient=__webpack_require__(42);var _informacaoGerencial=__webpack_require__(1384);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.gqlBuscarInfoGerencialTop5=exports.gqlBuscarInfoGerencialAtiva=exports.gqlBuscarInfoGerencialVigente=exports.gqlBuscarInfoGerencialHistorico=exports.gqlExcluirInfoGerencial=exports.gqlAlterarInfoGerencial=exports.gqlCriarInfoGerencial=undefined;var _templateObject=_taggedTemplateLiteral(['\n  mutation criarInfoGerencial(\n    $identificador: String!\n    $conta: String\n    $data: String\n    $descricao: String\n    $placa: String\n    $tipo: String\n  ) {\n    criarInfoGerencial(\n      info: {\n        codIdentificador: $identificador\n        conta: $conta\n        dataInicioVigencia: $data\n        descricao: $descricao\n        placa: $placa\n        tipoInfo: $tipo\n      }\n    ) {\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      tipoInfo\n    }\n  }\n'],['\n  mutation criarInfoGerencial(\n    $identificador: String!\n    $conta: String\n    $data: String\n    $descricao: String\n    $placa: String\n    $tipo: String\n  ) {\n    criarInfoGerencial(\n      info: {\n        codIdentificador: $identificador\n        conta: $conta\n        dataInicioVigencia: $data\n        descricao: $descricao\n        placa: $placa\n        tipoInfo: $tipo\n      }\n    ) {\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      tipoInfo\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  mutation alterarInfoGerencial(\n    $identificador: String!\n    $conta: String\n    $data: String\n    $descricao: String\n    $id: String\n    $placa: String\n    $tipo: String\n  ) {\n    alterarInfoGerencial(\n      info: {\n        codIdentificador: $identificador\n        conta: $conta\n        dataInicioVigencia: $data\n        descricao: $descricao\n        id: $id\n        placa: $placa\n        tipoInfo: $tipo\n      }\n    ) {\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      tipoInfo\n    }\n  }\n'],['\n  mutation alterarInfoGerencial(\n    $identificador: String!\n    $conta: String\n    $data: String\n    $descricao: String\n    $id: String\n    $placa: String\n    $tipo: String\n  ) {\n    alterarInfoGerencial(\n      info: {\n        codIdentificador: $identificador\n        conta: $conta\n        dataInicioVigencia: $data\n        descricao: $descricao\n        id: $id\n        placa: $placa\n        tipoInfo: $tipo\n      }\n    ) {\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      tipoInfo\n    }\n  }\n']),_templateObject3=_taggedTemplateLiteral(['\n  mutation excluirInfoGerencial(\n    $identificador: String!\n    $conta: String\n    $data: String\n    $descricao: String\n    $id: String\n    $placa: String\n    $tipo: String\n  ) {\n    excluirInfoGerencial(\n      info: {\n        codIdentificador: $identificador\n        conta: $conta\n        dataInicioVigencia: $data\n        descricao: $descricao\n        id: $id\n        placa: $placa\n        tipoInfo: $tipo\n      }\n    ) {\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      tipoInfo\n    }\n  }\n'],['\n  mutation excluirInfoGerencial(\n    $identificador: String!\n    $conta: String\n    $data: String\n    $descricao: String\n    $id: String\n    $placa: String\n    $tipo: String\n  ) {\n    excluirInfoGerencial(\n      info: {\n        codIdentificador: $identificador\n        conta: $conta\n        dataInicioVigencia: $data\n        descricao: $descricao\n        id: $id\n        placa: $placa\n        tipoInfo: $tipo\n      }\n    ) {\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      tipoInfo\n    }\n  }\n']),_templateObject4=_taggedTemplateLiteral(['\n  query buscarInfoGerencialHistorico($idConta: String!, $placa: String!) {\n    buscarInfoGerencialHistorico(idConta: $idConta, placa: $placa) {\n      id\n      descricaoAtual\n      descricaoAnterior\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      dataAtualizacao\n      acao\n    }\n  }\n'],['\n  query buscarInfoGerencialHistorico($idConta: String!, $placa: String!) {\n    buscarInfoGerencialHistorico(idConta: $idConta, placa: $placa) {\n      id\n      descricaoAtual\n      descricaoAnterior\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      dataAtualizacao\n      acao\n    }\n  }\n']),_templateObject5=_taggedTemplateLiteral(['\n  query buscarInfoGerencialVigente($idConta: String!, $placa: String!) {\n    buscarInfoGerencialVigente(idConta: $idConta, placa: $placa) {\n      id\n      tipoInfo\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      dataAtualizacao\n      acao\n      situacao\n    }\n  }\n'],['\n  query buscarInfoGerencialVigente($idConta: String!, $placa: String!) {\n    buscarInfoGerencialVigente(idConta: $idConta, placa: $placa) {\n      id\n      tipoInfo\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      dataAtualizacao\n      acao\n      situacao\n    }\n  }\n']),_templateObject6=_taggedTemplateLiteral(['\n  query buscarInfoGerencialAtiva($idConta: String!, $placa: String!) {\n    buscarInfoGerencialAtiva(idConta: $idConta, placa: $placa) {\n      id\n      tipoInfo\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      dataAtualizacao\n      acao\n      situacao\n    }\n  }\n'],['\n  query buscarInfoGerencialAtiva($idConta: String!, $placa: String!) {\n    buscarInfoGerencialAtiva(idConta: $idConta, placa: $placa) {\n      id\n      tipoInfo\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      dataAtualizacao\n      acao\n      situacao\n    }\n  }\n']),_templateObject7=_taggedTemplateLiteral(['\n  query buscarInfoGerencialTop5($idConta: String!) {\n    buscarInfoGerencialTop5(idConta: $idConta) {\n      id\n      tipoInfo\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      dataAtualizacao\n      acao\n      situacao\n    }\n  }\n'],['\n  query buscarInfoGerencialTop5($idConta: String!) {\n    buscarInfoGerencialTop5(idConta: $idConta) {\n      id\n      tipoInfo\n      descricaoAtual\n      placa\n      conta\n      codIdentificador\n      dataInicioVigencia\n      dataAtualizacao\n      acao\n      situacao\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var gqlCriarInfoGerencial=exports.gqlCriarInfoGerencial=(0,_graphqlTag2.default)(_templateObject);var gqlAlterarInfoGerencial=exports.gqlAlterarInfoGerencial=(0,_graphqlTag2.default)(_templateObject2);var gqlExcluirInfoGerencial=exports.gqlExcluirInfoGerencial=(0,_graphqlTag2.default)(_templateObject3);var gqlBuscarInfoGerencialHistorico=exports.gqlBuscarInfoGerencialHistorico=(0,_graphqlTag2.default)(_templateObject4);var gqlBuscarInfoGerencialVigente=exports.gqlBuscarInfoGerencialVigente=(0,_graphqlTag2.default)(_templateObject5);var gqlBuscarInfoGerencialAtiva=exports.gqlBuscarInfoGerencialAtiva=(0,_graphqlTag2.default)(_templateObject6);var gqlBuscarInfoGerencialTop5=exports.gqlBuscarInfoGerencialTop5=(0,_graphqlTag2.default)(_templateObject7);

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchPaymentType=fetchPaymentType;exports.fetchDueDates=fetchDueDates;var _editPaymentDataService=__webpack_require__(559);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_PAYMENT_TYPE=_types2.default.FETCH_PAYMENT_TYPE,FETCH_DUE_DATES=_types2.default.FETCH_DUE_DATES;function fetchPaymentType(accountPlanId){return function(dispatch){return(0,_editPaymentDataService.getPaymentType)(accountPlanId).then(function(){var types=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action={type:FETCH_PAYMENT_TYPE,paymentTypes:types};dispatch(action);});};}function fetchDueDates(){return function(dispatch){return(0,_editPaymentDataService.getDueDate)().then(function(){var dates=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action={type:FETCH_DUE_DATES,dueDates:dates};dispatch(action);});};}

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _accountPlansReducer=__webpack_require__(1387);var _accountPlansReducer2=_interopRequireDefault(_accountPlansReducer);var _accountReducer=__webpack_require__(1388);var _accountReducer2=_interopRequireDefault(_accountReducer);var _banksReducer=__webpack_require__(1389);var _banksReducer2=_interopRequireDefault(_banksReducer);var _cancelAccountReducer=__webpack_require__(1390);var _cancelAccountReducer2=_interopRequireDefault(_cancelAccountReducer);var _contestationProtocolReducer=__webpack_require__(1391);var _contestationProtocolReducer2=_interopRequireDefault(_contestationProtocolReducer);var _dashboardInvoicesReducer=__webpack_require__(1392);var _dashboardInvoicesReducer2=_interopRequireDefault(_dashboardInvoicesReducer);var _dashboardRechargesReducer=__webpack_require__(1393);var _dashboardRechargesReducer2=_interopRequireDefault(_dashboardRechargesReducer);var _dashboardResumeReducer=__webpack_require__(1394);var _dashboardResumeReducer2=_interopRequireDefault(_dashboardResumeReducer);var _dashboardStatementsReducer=__webpack_require__(1395);var _dashboardStatementsReducer2=_interopRequireDefault(_dashboardStatementsReducer);var _dashboardVehiclesReducer=__webpack_require__(1396);var _dashboardVehiclesReducer2=_interopRequireDefault(_dashboardVehiclesReducer);var _ecContestations=__webpack_require__(1397);var _ecContestations2=_interopRequireDefault(_ecContestations);var _ecLocationsReducer=__webpack_require__(1398);var _ecLocationsReducer2=_interopRequireDefault(_ecLocationsReducer);var _ecMoneyTransfer=__webpack_require__(1399);var _ecMoneyTransfer2=_interopRequireDefault(_ecMoneyTransfer);var _ecQueryPlateReducer=__webpack_require__(1400);var _ecQueryPlateReducer2=_interopRequireDefault(_ecQueryPlateReducer);var _ecRequestFileHistory=__webpack_require__(1401);var _ecRequestFileHistory2=_interopRequireDefault(_ecRequestFileHistory);var _invoiceDetailsReducer=__webpack_require__(1402);var _invoiceDetailsReducer2=_interopRequireDefault(_invoiceDetailsReducer);var _reasonsReducer=__webpack_require__(1403);var _reasonsReducer2=_interopRequireDefault(_reasonsReducer);var _rechargeReducer=__webpack_require__(1404);var _rechargeReducer2=_interopRequireDefault(_rechargeReducer);var _recoverReducer=__webpack_require__(1405);var _recoverReducer2=_interopRequireDefault(_recoverReducer);var _recoverTokenStatusReducer=__webpack_require__(1406);var _recoverTokenStatusReducer2=_interopRequireDefault(_recoverTokenStatusReducer);var _statementReducer=__webpack_require__(1407);var _statementReducer2=_interopRequireDefault(_statementReducer);var _userReducer=__webpack_require__(1408);var _userReducer2=_interopRequireDefault(_userReducer);var _planDataReducer=__webpack_require__(1409);var _planDataReducer2=_interopRequireDefault(_planDataReducer);var _termsAndConditionReducer=__webpack_require__(1410);var _termsAndConditionReducer2=_interopRequireDefault(_termsAndConditionReducer);var _shippingAmountReducer=__webpack_require__(1411);var _shippingAmountReducer2=_interopRequireDefault(_shippingAmountReducer);var _editPaymentDataReducer=__webpack_require__(1412);var _editPaymentDataReducer2=_interopRequireDefault(_editPaymentDataReducer);var _loginModalReducer=__webpack_require__(1413);var _loginModalReducer2=_interopRequireDefault(_loginModalReducer);var _manageInfsReducer=__webpack_require__(1414);var _manageInfsReducer2=_interopRequireDefault(_manageInfsReducer);var _reasonListBlockReducer=__webpack_require__(1415);var _reasonListBlockReducer2=_interopRequireDefault(_reasonListBlockReducer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={accountPlansReducer:_accountPlansReducer2.default,accountReducer:_accountReducer2.default,banksReducer:_banksReducer2.default,cancelAccountReducer:_cancelAccountReducer2.default,contestationProtocolReducer:_contestationProtocolReducer2.default,dashboardInvoicesReducer:_dashboardInvoicesReducer2.default,dashboardRechargesReducer:_dashboardRechargesReducer2.default,dashboardResumeReducer:_dashboardResumeReducer2.default,dashboardStatementsReducer:_dashboardStatementsReducer2.default,dashboardVehiclesReducer:_dashboardVehiclesReducer2.default,ecContestations:_ecContestations2.default,ecLocationsReducer:_ecLocationsReducer2.default,ecMoneyTransfer:_ecMoneyTransfer2.default,ecQueryPlateReducer:_ecQueryPlateReducer2.default,ecRequestFileHistory:_ecRequestFileHistory2.default,invoiceDetailsReducer:_invoiceDetailsReducer2.default,reasonsReducer:_reasonsReducer2.default,rechargeReducer:_rechargeReducer2.default,recoverReducer:_recoverReducer2.default,recoverTokenStatusReducer:_recoverTokenStatusReducer2.default,statementReducer:_statementReducer2.default,userReducer:_userReducer2.default,planDataReducer:_planDataReducer2.default,termsConditionReducer:_termsAndConditionReducer2.default,shippingAmountReducer:_shippingAmountReducer2.default,editPaymentDataReducer:_editPaymentDataReducer2.default,loginModalReducer:_loginModalReducer2.default,manageInfsReducer:_manageInfsReducer2.default,reasonsListBlockReducer:_reasonListBlockReducer2.default};module.exports=exports['default'];

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SET_ACCOUNT_PLANS=_types2.default.SET_ACCOUNT_PLANS,SET_EC_ACCOUNT_PLANS=_types2.default.SET_EC_ACCOUNT_PLANS,SET_ACCOUNT_ACTIVE_PLAN_ID=_types2.default.SET_ACCOUNT_ACTIVE_PLAN_ID,SET_ACCOUNT_PLAN=_types2.default.SET_ACCOUNT_PLAN,SET_CANCEL_ACCOUNT_STATUS=_types2.default.SET_CANCEL_ACCOUNT_STATUS;var initialState={plans:[],ecPlans:[],activePlanId:null};function accountPlansReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case SET_ACCOUNT_PLANS:{return _extends({},state,{plans:action.plans});}case SET_EC_ACCOUNT_PLANS:{return _extends({},state,{plans:action.plans});}case SET_ACCOUNT_PLAN:{return _extends({},state,{plan:action.plan});}case SET_CANCEL_ACCOUNT_STATUS:{return _extends({},state,{plan:_extends({},state.plan,{cancelation:action.payload})});}case SET_ACCOUNT_ACTIVE_PLAN_ID:{return _extends({},state,{activePlanId:action.activePlanId});}default:return state;}}exports.default=accountPlansReducer;module.exports=exports['default'];

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SET_AUTHENTICATION=_types2.default.SET_AUTHENTICATION,FETCH_CANCEL_ACCOUNT=_types2.default.FETCH_CANCEL_ACCOUNT,LOGOUT=_types2.default.LOGOUT;var initialValues={};function accountReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialValues;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case SET_AUTHENTICATION:{return _extends({},state,action.credentials);}case FETCH_CANCEL_ACCOUNT:{return _extends({},state,{active:action.state});}case LOGOUT:{return{};}default:return state;}}exports.default=accountReducer;module.exports=exports['default'];

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_BANK_LIST=_types2.default.FETCH_BANK_LIST;function banksReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case FETCH_BANK_LIST:{return action.state;}default:return state;}}exports.default=banksReducer;module.exports=exports['default'];

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_GENERATE_CANCEL_ACCOUNT_TOKEN=_types2.default.FETCH_GENERATE_CANCEL_ACCOUNT_TOKEN;function cancelAccountReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case FETCH_GENERATE_CANCEL_ACCOUNT_TOKEN:{return _extends({},state,action.state,{generatedToken:true});}default:return state;}}exports.default=cancelAccountReducer;module.exports=exports['default'];

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_CONTESTATION_PROTOCOL=_types2.default.UPDATE_CONTESTATION_PROTOCOL,CLEAR_CONTESTATION_PROTOCOL=_types2.default.CLEAR_CONTESTATION_PROTOCOL;function contestationProtocolReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case UPDATE_CONTESTATION_PROTOCOL:{return _extends({},state,action.protocol);}case CLEAR_CONTESTATION_PROTOCOL:{return{};}default:return state;}}exports.default=contestationProtocolReducer;module.exports=exports['default'];

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _lodash=__webpack_require__(43);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var UPDATE_INVOICES=_types2.default.UPDATE_INVOICES,RESET_INVOICES=_types2.default.RESET_INVOICES;var initialState={data:[],next:null};function dashboardInvoicesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case UPDATE_INVOICES:{return _extends({},state,{data:(0,_lodash.merge)([].concat(_toConsumableArray(state.data),_toConsumableArray(action.data))),next:action.next});}case RESET_INVOICES:{return _extends({},state,{data:[],next:null});}default:return state;}}exports.default=dashboardInvoicesReducer;module.exports=exports['default'];

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _lodash=__webpack_require__(43);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var UPDATE_RECHARGES=_types2.default.UPDATE_RECHARGES,RESET_RECHARGES=_types2.default.RESET_RECHARGES;var initialState={data:[],next:null};function dashboardRechargesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case UPDATE_RECHARGES:{return _extends({},state,{data:(0,_lodash.merge)([].concat(_toConsumableArray(state.data),_toConsumableArray(action.data))),next:action.next});}case RESET_RECHARGES:{return _extends({},state,{data:[],next:null});}default:return state;}}exports.default=dashboardRechargesReducer;module.exports=exports['default'];

/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_PLAN_RESUME=_types2.default.UPDATE_PLAN_RESUME;function dashboardResumeReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case UPDATE_PLAN_RESUME:{return action.planResume;}default:return state;}}exports.default=dashboardResumeReducer;module.exports=exports['default'];

/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _lodash=__webpack_require__(43);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var UPDATE_STATEMENTS=_types2.default.UPDATE_STATEMENTS,RESET_STATEMENTS=_types2.default.RESET_STATEMENTS;var initialState={data:[],total:null,monthlyTotal:null,next:null,filter:{},updatedOn:null,hasNext:null,enviarExtratoEmail:false};function dashboardStatementsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case UPDATE_STATEMENTS:{return _extends({},state,{data:(0,_lodash.merge)([].concat(_toConsumableArray(state.data),_toConsumableArray(action.data))),total:action.total,monthlyTotal:action.monthlyTotal,filter:action.filter,next:action.next,updatedOn:action.updatedOn,hasNext:action.hasNext,enviarExtratoEmail:action.enviarExtratoEmail});}case RESET_STATEMENTS:{return _extends({},state,{data:[],filter:{},total:null,monthlyTotal:null,next:null,updatedOn:null,hasNext:null,enviarExtratoEmail:false});}default:return state;}}exports.default=dashboardStatementsReducer;module.exports=exports['default'];

/***/ }),
/* 1396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_VEHICLES=_types2.default.FETCH_VEHICLES;function dashboardVehiclesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case FETCH_VEHICLES:{return action.vehicles;}default:return state;}}exports.default=dashboardVehiclesReducer;module.exports=exports['default'];

/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_EC_CONTESTATIONS=_types2.default.FETCH_EC_CONTESTATIONS;function ecContestations(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case FETCH_EC_CONTESTATIONS:{return action.state;}default:return state;}}exports.default=ecContestations;module.exports=exports['default'];

/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_EC_LOCATIONS=_types2.default.FETCH_EC_LOCATIONS;function ecLocationsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case FETCH_EC_LOCATIONS:{return action.state;}default:return state;}}exports.default=ecLocationsReducer;module.exports=exports['default'];

/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_EC_MONEY_TRANSER=_types2.default.FETCH_EC_MONEY_TRANSER;function ecMoneyTransfer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case FETCH_EC_MONEY_TRANSER:{return action.state;}default:return state;}}exports.default=ecMoneyTransfer;module.exports=exports['default'];

/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CLEAR_EC_QUERY_PLATE=_types2.default.CLEAR_EC_QUERY_PLATE,FETCH_EC_QUERY_PLATE=_types2.default.FETCH_EC_QUERY_PLATE;function ecQueryPlateReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case CLEAR_EC_QUERY_PLATE:return null;case FETCH_EC_QUERY_PLATE:return action.state;default:return state;}}exports.default=ecQueryPlateReducer;module.exports=exports['default'];

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_EC_REQUEST_FILE_HISTORY=_types2.default.FETCH_EC_REQUEST_FILE_HISTORY;function ecRequestFileHistory(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case FETCH_EC_REQUEST_FILE_HISTORY:return action.state;default:return state;}}exports.default=ecRequestFileHistory;module.exports=exports['default'];

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _lodash=__webpack_require__(43);var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_INVOICE_DETAILS=_types2.default.UPDATE_INVOICE_DETAILS,RESET_INVOICE_DETAILS=_types2.default.RESET_INVOICE_DETAILS;var initialState={details:{}};function invoiceDetailsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case UPDATE_INVOICE_DETAILS:{return _extends({},state,{details:(0,_lodash.merge)(_extends({},state.details,action.details))});}case RESET_INVOICE_DETAILS:{return _extends({},state,{details:{}});}default:return state;}}exports.default=invoiceDetailsReducer;module.exports=exports['default'];

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_REASONS=_types2.default.UPDATE_REASONS;function reasonsReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case UPDATE_REASONS:{return _extends({},state,{reasons:action.reasons});}default:return state;}}exports.default=reasonsReducer;module.exports=exports['default'];

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SET_RECHARGE_VALUES=_types2.default.SET_RECHARGE_VALUES,SET_CURRENT_RECHARGE_VALUE=_types2.default.SET_CURRENT_RECHARGE_VALUE,SET_PAYMENT_INFO=_types2.default.SET_PAYMENT_INFO,SET_CHANGE_RECHARGE=_types2.default.SET_CHANGE_RECHARGE;var initialState={rechargeValues:[],currentRechargeValue:100,paymentInfo:{},valorRecarga:0};function rechargeReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case SET_RECHARGE_VALUES:{return _extends({},state,{rechargeValues:action.rechargeValues});}case SET_CURRENT_RECHARGE_VALUE:{return _extends({},state,{currentRechargeValue:action.currentRechargeValue});}case SET_PAYMENT_INFO:{return _extends({},state,{paymentInfo:action.paymentInfo});}case SET_CHANGE_RECHARGE:{return _extends({},state,{valorRecarga:action.valorRecarga});}default:return state;}}exports.default=rechargeReducer;module.exports=exports['default'];

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RECOVER=_types2.default.RECOVER;function recoverReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case RECOVER:{return _extends({},state,action.recover);}default:return state;}}exports.default=recoverReducer;module.exports=exports['default'];

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_RECOVER_TOKEN_STATUS=_types2.default.UPDATE_RECOVER_TOKEN_STATUS;function recoverTokenStatusReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case UPDATE_RECOVER_TOKEN_STATUS:{return _extends({},state,{recoverTokenStatus:action.recoverTokenStatus});}default:return state;}}exports.default=recoverTokenStatusReducer;module.exports=exports['default'];

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var UPDATE_STATEMENT=_types2.default.UPDATE_STATEMENT;function statementReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case UPDATE_STATEMENT:{return _extends({},state,action.statement);}default:return state;}}exports.default=statementReducer;module.exports=exports['default'];

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ADD_REPRESENTATIVE=_types2.default.ADD_REPRESENTATIVE,UPDATE_REPRESENTATIVE=_types2.default.UPDATE_REPRESENTATIVE,DELETE_REPRESENTATIVE=_types2.default.DELETE_REPRESENTATIVE,FETCH_USER=_types2.default.FETCH_USER,FETCH_PROFILE_UPDATE=_types2.default.FETCH_PROFILE_UPDATE,FETCH_ADDRESS_UPDATE=_types2.default.FETCH_ADDRESS_UPDATE,FETCH_CONTACT_UPDATE=_types2.default.FETCH_CONTACT_UPDATE;function userReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case UPDATE_REPRESENTATIVE:{var representatives=state.representatives||[];if(action.data&&action.data.document){var representativeIndex=representatives.findIndex(function(representive){return representive.document===action.data.document;});representatives[representativeIndex]=action.data;}return _extends({},state,{representatives:representatives});}case ADD_REPRESENTATIVE:{var _representatives=state.representatives||[];if(action.data&&action.data.document){_representatives.push(action.data);}return _extends({},state,{representatives:_representatives});}case DELETE_REPRESENTATIVE:{var _representatives2=state.representatives||[];_representatives2.splice(_representatives2.findIndex(function(representive){return representive.document===action.document;}),1);return _extends({},state,{representatives:_representatives2});}case FETCH_USER:{return action.state;}case FETCH_PROFILE_UPDATE:{state.profile.sexo.codigo=action.state.sexo.codigo;state.profile['estado-civil'].codigo=action.state['estado-civil'].codigo;return state;}case FETCH_ADDRESS_UPDATE:{state.enderecos=action.state;return state;}case FETCH_CONTACT_UPDATE:{state.contato=action.state;return state;}default:return state;}}exports.default=userReducer;module.exports=exports['default'];

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var UPDATE_PLAN_DATA=_types2.default.UPDATE_PLAN_DATA,FETCH_PAYMENT_TYPE=_types2.default.FETCH_PAYMENT_TYPE,FETCH_DUE_DATES=_types2.default.FETCH_DUE_DATES,GET_EDIT_AUTH_PAYMENT=_types2.default.GET_EDIT_AUTH_PAYMENT,SET_EDIT_AUTH_PAYMENT=_types2.default.SET_EDIT_AUTH_PAYMENT,LOCK_EDIT_AUTH_PAYMENT=_types2.default.LOCK_EDIT_AUTH_PAYMENT;function planDataReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{authorizations:{}};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case UPDATE_PLAN_DATA:{return _extends({},state,action.plandata);}case FETCH_PAYMENT_TYPE:{return _extends({},state,{paymentTypes:action.paymentTypes});}case FETCH_DUE_DATES:{return _extends({},state,{dueDates:action.dueDates});}case GET_EDIT_AUTH_PAYMENT:case LOCK_EDIT_AUTH_PAYMENT:{return _extends({},state,{authorizations:_extends({},state.authorizations,_defineProperty({},action.changeType,action.authorizations))});}case SET_EDIT_AUTH_PAYMENT:{return _extends({},state,{authorizations:_extends({},state.authorizations,_defineProperty({},action.changeType,_extends({},action.authorizations.message)))});}default:return state;}}exports.default=planDataReducer;module.exports=exports['default'];

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_TERMS_CONDITIONS=_types2.default.FETCH_TERMS_CONDITIONS;function termsConditionReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case FETCH_TERMS_CONDITIONS:{return _extends({},state,action.state);}default:return state;}}exports.default=termsConditionReducer;module.exports=exports['default'];

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_SHIPPING_AMOUNT=_types2.default.FETCH_SHIPPING_AMOUNT;function shippingAmountReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case FETCH_SHIPPING_AMOUNT:return action.state;default:return state;}}exports.default=shippingAmountReducer;module.exports=exports['default'];

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SET_NEW_DATA_VALUE=_types2.default.SET_NEW_DATA_VALUE;var initialState={currentEditDataValue:{accountPlanId:'',recharge:'',payment:{paymentMethod:'',type:'',cardNumber:'',yourName:'',validad:'',securityCode:'',save:''}}};function editPaymentReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case SET_NEW_DATA_VALUE:{return _extends({},state,{currentEditDataValue:action.currentEditDataValue});}default:return state;}}exports.default=editPaymentReducer;module.exports=exports['default'];

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=loginModalReducer;var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var STATE_MODAL=_types2.default.STATE_MODAL,LOGIN_MSG_ERROR=_types2.default.LOGIN_MSG_ERROR,SHOW_CAPTCHA=_types2.default.SHOW_CAPTCHA;var initialState={stateModal:false,loginMsgError:'',showCaptcha:false};function loginModalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case STATE_MODAL:{return _extends({},state,{stateModal:action.stateModal});}case LOGIN_MSG_ERROR:{return _extends({},state,{loginMsgError:action.loginMsgError});}case SHOW_CAPTCHA:{return _extends({},state,{showCaptcha:action.showCaptcha});}default:return state;}}module.exports=exports['default'];

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_MANAGE_INF=_types2.default.FETCH_MANAGE_INF,FETCH_MANAGE_INF_FINISHED=_types2.default.FETCH_MANAGE_INF_FINISHED,FETCH_HIST_MANAGE_INF=_types2.default.FETCH_HIST_MANAGE_INF,FETCH_HIST_MANAGE_INF_FINISHED=_types2.default.FETCH_HIST_MANAGE_INF_FINISHED,FETCH_TOP5_MANAGE_INF=_types2.default.FETCH_TOP5_MANAGE_INF,FETCH_TOP5_MANAGE_INF_FINISHED=_types2.default.FETCH_TOP5_MANAGE_INF_FINISHED,UPDATE_MANAGE_INF=_types2.default.UPDATE_MANAGE_INF,UPDATE_MANAGE_INF_FINISHED=_types2.default.UPDATE_MANAGE_INF_FINISHED;var initialState={manageInfs:[],loadingInfs:false,manageInfsHistory:[],loadingHistory:false,manageInfsTop5:[],loadingTop5:false,updateLoading:false};function dashboardVehiclesReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case FETCH_MANAGE_INF:{return _extends({},state,{loadingInfs:true});}case FETCH_MANAGE_INF_FINISHED:{return _extends({},state,{manageInfs:action.informations,loadingInfs:false});}case FETCH_TOP5_MANAGE_INF:{return _extends({},state,{loadingTop5:true});}case FETCH_TOP5_MANAGE_INF_FINISHED:{return _extends({},state,{manageInfsTop5:action.informations,loadingTop5:false});}case FETCH_HIST_MANAGE_INF:{return _extends({},state,{loadingHistory:true});}case FETCH_HIST_MANAGE_INF_FINISHED:{return _extends({},state,{manageInfsHistory:action.informations,loadingHistory:false});}case UPDATE_MANAGE_INF:return _extends({},state,{updateLoading:true});case UPDATE_MANAGE_INF_FINISHED:return _extends({},state,{updateLoading:false});default:return state;}}exports.default=dashboardVehiclesReducer;module.exports=exports['default'];

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _types=__webpack_require__(10);var _types2=_interopRequireDefault(_types);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FETCH_REASON_LIST=_types2.default.FETCH_REASON_LIST;function reasonsListBlockReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case FETCH_REASON_LIST:{return _extends({},state,{reasons:action.state});}default:return state;}}exports.default=reasonsListBlockReducer;module.exports=exports['default'];

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=birthDateValidate;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _dateTimeCurrent=__webpack_require__(1417);var _dateTimeCurrent2=_interopRequireDefault(_dateTimeCurrent);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function birthDateValidate(date){var valid=(0,_moment2.default)(date).isAfter(_constants.FORMAT_DATE_MINIMUM_YEAR)&&(0,_moment2.default)(date).isBefore((0,_dateTimeCurrent2.default)(),'year');return!date?_constants.VALIDATION_DOB_MSG_EMPTY:!valid?_constants.VALIDATION_DOB_MSG_INVALID:undefined;}module.exports=exports['default'];

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=dateTimeCurrent;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function dateTimeCurrent(){return(0,_moment2.default)().format();}module.exports=exports['default'];

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var capitalize=function capitalize(value){if(!value)return null;return value.toLowerCase().replace(/\b./,function(a){return a.toUpperCase();});};exports.default=capitalize;module.exports=exports["default"];

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var cepMask=function cepMask(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums.length<=5){return onlyNums;}return onlyNums.slice(0,5)+'-'+onlyNums.slice(5,8);};exports.default=cepMask;module.exports=exports['default'];

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=validateCep;var _constants=__webpack_require__(46);function validateCep(value){return!value?_constants.VALIDATION_CEP_MSG_EMPTY:!_constants.VALIDATION_CEP.test(value)?_constants.VALIDATION_CEP_MSG_INVALID:undefined;}/* eslint-disable */module.exports=exports['default'];

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var cpfMask=function cpfMask(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums.length<=3){return onlyNums;}if(onlyNums.length<=6){return onlyNums.slice(0,3)+'.'+onlyNums.slice(3);}if(onlyNums.length<=9){return onlyNums.slice(0,3)+'.'+onlyNums.slice(3,6)+'.'+onlyNums.slice(6);}return onlyNums.slice(0,3)+'.'+onlyNums.slice(3,6)+'.'+onlyNums.slice(6,9)+'-'+onlyNums.slice(9,11);// eslint-disable-line
};exports.default=cpfMask;module.exports=exports['default'];

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=validateCPF;var _validate=__webpack_require__(560);var _validate2=_interopRequireDefault(_validate);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable */function checkCPF(){var cpf=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var sum=0;var residual=void 0;var value=cpf.replace(/(-)|\./g,'');if(value===null||value==='00000000000'||'')return false;if(value.length!==11)return false;for(var i=1;i<=9;i++){sum+=parseInt(value.substring(i-1,i))*(11-i);}residual=sum*10%11;if(residual===10||residual===11)residual=0;if(residual!=parseInt(value.substring(9,10)))return false;sum=0;for(var _i=1;_i<=10;_i++){sum+=parseInt(value.substring(_i-1,_i))*(12-_i);}residual=sum*10%11;if(residual===10||residual===11)residual=0;if(residual!=parseInt(value.substring(10,11)))return false;return true;}function validateCPF(value){if(checkCPF(value))return undefined;return _constants.VALIDATION_CPF_MSG_INVALID;}module.exports=exports['default'];

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var placeDots=function placeDots(string){var iteration=-2;var arrayWithDots=[];for(var i=string.length-1;i>-1;i-=1){if(iteration%3===0&&i!==0){arrayWithDots.push('.'+string[i]);}else{arrayWithDots.push(string[i]);}iteration+=1;}return arrayWithDots.reverse().join('');};var currencyParser=function currencyParser(value){var prefix=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var isAbsolute=arguments[2];var stringValue=new String(value);// eslint-disable-line
var integers=[];var decimals='';var sign=/-.+/.test(stringValue)?'-':'';stringValue=stringValue.replace(/-/g,'').replace(/,/g,'.').replace(prefix,'');if(isAbsolute){var absoluteValues=stringValue.replace(/[^\d]/g,'');decimals=absoluteValues.substr(-2,2);integers=placeDots(absoluteValues.slice(0,-2));return''+(prefix+sign+integers+','+decimals);}var splitedValues=stringValue.split('.');decimals=splitedValues.length>1?splitedValues.pop():'00';var integerValues=splitedValues.join('');integers=placeDots(integerValues);if(decimals.length<2){decimals=decimals+'0';}else if(decimals.length>2){decimals=decimals.substring(0,2);}return prefix+sign+integers+','+decimals;};exports.default=currencyParser;module.exports=exports['default'];

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=calculateDataPercentage;function calculateDataPercentage(){var dataArray=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var maxValue=arguments[1];if(maxValue){return dataArray.map(function(data){return data/maxValue*100;});}var total=dataArray.reduce(function(data,nextData){return data+nextData;},0);return dataArray.map(function(data){return data/total*100;});}module.exports=exports["default"];

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dateMask=function dateMask(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums.length<=2){return onlyNums;}if(onlyNums.length<=4){return onlyNums.slice(0,2)+'/'+onlyNums.slice(2);}return onlyNums.slice(0,2)+'/'+onlyNums.slice(2,4)+'/'+onlyNums.slice(4,8);};exports.default=dateMask;module.exports=exports['default'];

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=dateFormat;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function dateFormat(date){var format=arguments.length>1&&arguments[1]!==undefined?arguments[1]:_constants.FORMAT_DATE;if(!date)throw new Error(_constants.FORMAT_DATE_INVALID);return(0,_moment2.default)(date).format(format);}module.exports=exports['default'];

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=dateParser;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function dateParser(date){if(!date)return null;return(0,_moment2.default)(date,_constants.FORMAT_DATE).toDate();}module.exports=exports['default'];

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=dateValidate;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function dateValidate(date){var valid=(0,_moment2.default)(date).isValid();return!date?_constants.EMPTY_FIELD:!valid?_constants.FORMAT_DATE_INVALID:undefined;}module.exports=exports['default'];

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=dateValidateWithFormat;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function dateValidateWithFormat(format){return function(dateAsString){if(!dateAsString)return _constants.EMPTY_FIELD;return(0,_moment2.default)(dateAsString,format,true).isValid()===false?format==='HH:mm'?_constants.FORMAT_HOUR_MINUTE_INVALID:_constants.FORMAT_DATE_INVALID:undefined;// }
// return undefined
};}module.exports=exports['default'];

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var dddMask=function dddMask(value,previousValue){if(!value){return undefined;}var onlyNums=value&&value.replace(/[^\d]/g,'');if(!value||previousValue&&value.length<previousValue.length){return onlyNums.slice(0,1);}if(onlyNums.length<2){return onlyNums;}return'('+onlyNums.slice(0,2)+')';};exports.default=dddMask;module.exports=exports['default'];

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=validateDDD;var _constants=__webpack_require__(46);function validateDDD(value){var validate=!_constants.VALIDATION_DDD.test(value)?_constants.VALIDATION_DDD_MSG_INVALID:undefined;return!value?_constants.VALIDATION_DDD_MSG_EMPTY:validate;}module.exports=exports['default'];

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=validateEmail;var _constants=__webpack_require__(46);function validateEmail(value){return!value?_constants.VALIDATION_EMAIL_MSG_EMPTY:!_constants.VALIDATION_EMAIL.test(value)?_constants.VALIDATION_EMAIL_MSG_INVALID:undefined;}/* eslint-disable */module.exports=exports['default'];

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=emptyFieldValidate;var _constants=__webpack_require__(46);function emptyFieldValidate(value){return!value?_constants.EMPTY_FIELD:null;}module.exports=exports['default'];

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=formatBytes;function formatBytes(bytes,decimals){if(bytes===0){return'0 Bytes';}var size=1000;var dm=decimals||2;var sizes=['Bytes','KB','MB','GB','TB','PB','EB','ZB','YB'];var currentSizeindex=Math.floor(Math.log(bytes)/Math.log(size));var convertedSize=parseFloat((bytes/Math.pow(size,currentSizeindex)).toFixed(dm));return convertedSize+' '+sizes[currentSizeindex];}module.exports=exports['default'];

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=getDayOfWeek;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// eslint-disable-next-line no-unused-vars
var ptBrLocale=__webpack_require__(360);function getDayOfWeek(date){if(!date){return null;}return(0,_moment2.default)(date).locale('pt-br').format('dddd');}module.exports=exports['default'];

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=getMonth;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// eslint-disable-next-line no-unused-vars
var ptBrLocale=__webpack_require__(360);function getMonth(date){if(!date){return null;}return(0,_moment2.default)(date).locale('pt-br').format('MMMM');}module.exports=exports['default'];

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=groupArray;function groupArray(data,getKey){if(!data||!getKey)return null;return data.reduce(function(groups,item){var result=groups;var val=getKey(item);result[val]=groups[val]||[];result[val].push(item);return result;},{});}module.exports=exports["default"];

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=hasLetters;function hasLetters(value){return typeof value==='string'&&/[a-zA-Z]/.test(value);}module.exports=exports['default'];

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=hasNumbers;function hasNumbers(value){return typeof value==='string'&&/[0-9]/.test(value);}module.exports=exports['default'];

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=validateIdentifier;var _constants=__webpack_require__(46);function validateIdentifier(value){var validate=!_constants.VALIDATION_IDENTIFIER.test(value)?_constants.VALIDATION_IDENTIFIER_MSG_INVALID:undefined;return!value?_constants.VALIDATION_IDENTIFIER_MSG_EMPTY:validate;}module.exports=exports['default'];

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var plateMask=function plateMask(value){if(!value){return value;}var onlyChars=value.replace(/[^\w\d]/g,'').toUpperCase();if(onlyChars.length<=3){return onlyChars;}return''+onlyChars.slice(0,3)+onlyChars.slice(3,7);};exports.default=plateMask;module.exports=exports['default'];

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=validatePlate;var _constants=__webpack_require__(46);function validatePlate(value){var lowPlate=String(value).toLowerCase();if(!value)return _constants.VALIDATION_PLATE_MSG_EMPTY;if(value.length===7){var letters=value.match(/[a-zA-Z]/g)?value.match(/[a-zA-Z]/g).length:0;var numbers=value.match(/[0-9]/g)?value.match(/[0-9]/g).length:0;if(letters===4&&numbers===3){if(!_constants.VALIDATION_NEW_PLATE.test(lowPlate)){return _constants.VALIDATION_PLATE_MSG_INVALID;}}else if(letters===3&&numbers===4){if(!_constants.VALIDATION_OLD_PLATE.test(lowPlate)){return _constants.VALIDATION_PLATE_MSG_INVALID;}}else{return _constants.VALIDATION_PLATE_MSG_INVALID;}}else{return _constants.VALIDATION_PLATE_MSG_INVALID;}}module.exports=exports['default'];

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=queryStringParser;var parseValue=function parseValue(value){if(value instanceof Array)return value.join(',');return value;};function queryStringParser(query){if(!query)return'';return Object.keys(query).filter(function(key){return query[key]!=null&&query[key]!=='';}).map(function(key){return key+'='+parseValue(query[key]);}).join('&');}module.exports=exports['default'];

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=ISODateCalcDiff;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function ISODateCalcDiff(firstDate,secondDate){if(!firstDate&&!secondDate)return null;var calc=(0,_moment2.default)(secondDate,_constants.ISO_FORMAT_DATE).diff((0,_moment2.default)(firstDate,_constants.ISO_FORMAT_DATE));var duration=_moment2.default.duration(calc);return _moment2.default.utc(duration.asMilliseconds()).format('HH:mm');}module.exports=exports['default'];

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=ISODateFormat;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function ISODateFormat(date){var format=arguments.length>1&&arguments[1]!==undefined?arguments[1]:_constants.FORMAT_DATE;if(!date)return null;return(0,_moment2.default)(date,_constants.ISO_FORMAT_DATE).format(format);}module.exports=exports['default'];

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=jsonDateParser;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function jsonDateParser(date){if(!date)return null;return(0,_moment2.default)(date,_constants.ISO_FORMAT_DATE).toDate();}module.exports=exports['default'];

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var numberMask=function numberMask(value){if(!value){return value;}return value.replace(/[^\d]/g,'');};exports.default=numberMask;module.exports=exports['default'];

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var phoneMask=function phoneMask(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums.length<=4){return onlyNums;}if(onlyNums.length<=8){return onlyNums.slice(0,4)+'-'+onlyNums.slice(4);}return onlyNums.slice(0,5)+'-'+onlyNums.slice(5,9);};exports.default=phoneMask;module.exports=exports['default'];

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=validatePhone;var _constants=__webpack_require__(46);function validatePhone(value){var validate=!_constants.VALIDATION_PHONE.test(value)?_constants.VALIDATION_PHONE_MSG_INVALID:undefined;return!value?_constants.VALIDATION_PHONE_MSG_EMPTY:validate;}module.exports=exports['default'];

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=validatePasswordLength;function validatePasswordLength(value){return typeof value==='string'&&value.length>=6;}module.exports=exports['default'];

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var cnpjMask=function cnpjMask(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums.length<=2){return onlyNums;}if(onlyNums.length<=5){return onlyNums.slice(0,2)+'.'+onlyNums.slice(2);}if(onlyNums.length<=8){return onlyNums.slice(0,2)+'.'+onlyNums.slice(2,5)+'.'+onlyNums.slice(5);}if(onlyNums.length<=12){return onlyNums.slice(0,2)+'.'+onlyNums.slice(2,5)+'.'+onlyNums.slice(5,8)+'/'+onlyNums.slice(8);// eslint-disable-line
}return onlyNums.slice(0,2)+'.'+onlyNums.slice(2,5)+'.'+onlyNums.slice(5,8)+'/'+onlyNums.slice(8,12)+'-'+onlyNums.slice(12,14);// eslint-disable-line
};exports.default=cnpjMask;module.exports=exports['default'];

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=validateCNPJ;var _validate=__webpack_require__(560);var _validate2=_interopRequireDefault(_validate);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable */function checkCNPJ(){var cnpj=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';cnpj=cnpj.replace(/[^\d]+/g,'');if(cnpj===''||cnpj.length!=14)return false;var size=cnpj.length-2;var numbers=cnpj.substring(0,size);var digits=cnpj.substring(size);var sum=0;var pos=size-7;for(var i=size;i>=1;i--){sum+=numbers.charAt(size-i)*pos--;if(pos<2)pos=9;}var result=sum%11<2?0:11-sum%11;if(result!=digits.charAt(0))return false;size+=1;numbers=cnpj.substring(0,size);sum=0;pos=size-7;for(var _i=size;_i>=1;_i--){sum+=numbers.charAt(size-_i)*pos--;if(pos<2)pos=9;}result=sum%11<2?0:11-sum%11;if(result!=digits.charAt(1))return false;return true;}function validateCNPJ(value){if(checkCNPJ(value))return undefined;return _constants.VALIDATION_CNPJ_MSG_INVALID;}module.exports=exports['default'];

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=dateBeforeTodayValidate;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable */function dateBeforeTodayValidate(date){var format='DD/MM/YYYY';var valid=(0,_moment2.default)(date,format,true).isValid();var isBeforeToday=(0,_moment2.default)(date,format,true).isBefore((0,_moment2.default)().startOf('day'));return!date?_constants.EMPTY_FIELD:!valid?_constants.FORMAT_DATE_INVALID:!isBeforeToday?_constants.VALIDATION_DBT_MSG_INVALID:undefined;}module.exports=exports['default'];

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var colors={pre:{normal:{normal:'#c11f57',darken:'#a81b4c',lighter:'#cf7c99'},Autorrecarga:{normal:'#561dff',darken:'#4416cc',lighter:'#8c66ff'}},pos:{normal:{normal:'#e5b200',darken:'#c79c00',lighter:'#E8C23A'},Urbano:{normal:'#9000a3',darken:'#710080',lighter:'#AA6BB3'},Estrada:{normal:'#6c9807',darken:'#5b8006',lighter:'#A2B86E'}},ec:{normal:{normal:'#28c4d4'}}};exports.default=function(type,category){var colorType=colors[type];if(!category){return{};}if(!category.length||!colorType[category])return colorType.normal;return colorType[category];};module.exports=exports['default'];

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var numberAndLetter=function numberAndLetter(value){if(!value){return value;}return value.replace(/[^0-9a-zA-Z]+/g,'');};exports.default=numberAndLetter;module.exports=exports['default'];

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=validateCreditCard;var _cardValidator=__webpack_require__(562);var _cardValidator2=_interopRequireDefault(_cardValidator);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function validateCreditCard(value){var numberValidation=_cardValidator2.default.number(value);return numberValidation.isPotentiallyValid?undefined:'Cartão de crédito inválido.';}module.exports=exports['default'];

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var luhn10 = __webpack_require__(1458);
var getCardTypes = __webpack_require__(563);

function verification(card, isPotentiallyValid, isValid) {
  return {card: card, isPotentiallyValid: isPotentiallyValid, isValid: isValid};
}

function cardNumber(value) {
  var potentialTypes, cardType, isPotentiallyValid, isValid, i, maxLength;

  if (typeof value === 'number') {
    value = String(value);
  }

  if (typeof value !== 'string') { return verification(null, false, false); }

  value = value.replace(/\-|\s/g, '');

  if (!/^\d*$/.test(value)) { return verification(null, false, false); }

  potentialTypes = getCardTypes(value);

  if (potentialTypes.length === 0) {
    return verification(null, false, false);
  } else if (potentialTypes.length !== 1) {
    return verification(null, true, false);
  }

  cardType = potentialTypes[0];

  if (cardType.type === 'unionpay') {  // UnionPay is not Luhn 10 compliant
    isValid = true;
  } else {
    isValid = luhn10(value);
  }

  maxLength = Math.max.apply(null, cardType.lengths);

  for (i = 0; i < cardType.lengths.length; i++) {
    if (cardType.lengths[i] === value.length) {
      isPotentiallyValid = value.length !== maxLength || isValid;
      return verification(cardType, isPotentiallyValid, isValid);
    }
  }

  return verification(cardType, value.length < maxLength, false);
}

module.exports = cardNumber;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Luhn algorithm implementation in JavaScript
 * Copyright (c) 2009 Nicholas C. Zakas
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */


function luhn10(identifier) {
  var sum = 0;
  var alt = false;
  var i = identifier.length - 1;
  var num;

  while (i >= 0) {
    num = parseInt(identifier.charAt(i), 10);

    if (alt) {
      num *= 2;
      if (num > 9) {
        num = (num % 10) + 1; // eslint-disable-line no-extra-parens
      }
    }

    alt = !alt;

    sum += num;

    i--;
  }

  return sum % 10 === 0;
}

module.exports = luhn10;


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var parseDate = __webpack_require__(1460);
var expirationMonth = __webpack_require__(564);
var expirationYear = __webpack_require__(361);

function verification(isValid, isPotentiallyValid, month, year) {
  return {
    isValid: isValid,
    isPotentiallyValid: isPotentiallyValid,
    month: month,
    year: year
  };
}

function expirationDate(value, maxElapsedYear) {
  var date, monthValid, yearValid, isValidForThisYear;

  if (typeof value === 'string') {
    value = value.replace(/^(\d\d) (\d\d(\d\d)?)$/, '$1/$2');
    date = parseDate(value);
  } else if (value !== null && typeof value === 'object') {
    date = {
      month: String(value.month),
      year: String(value.year)
    };
  } else {
    return verification(false, false, null, null);
  }

  monthValid = expirationMonth(date.month);
  yearValid = expirationYear(date.year, maxElapsedYear);

  if (monthValid.isValid) {
    if (yearValid.isCurrentYear) {
      isValidForThisYear = monthValid.isValidForThisYear;
      return verification(isValidForThisYear, isValidForThisYear, date.month, date.year);
    }

    if (yearValid.isValid) {
      return verification(true, true, date.month, date.year);
    }
  }

  if (monthValid.isPotentiallyValid && yearValid.isPotentiallyValid) {
    return verification(false, true, null, null);
  }

  return verification(false, false, null, null);
}

module.exports = expirationDate;


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var expirationYear = __webpack_require__(361);
var isArray = __webpack_require__(1461);

function parseDate(value) {
  var month, len, year, yearValid;

  if (/\//.test(value)) {
    value = value.split(/\s*\/\s*/g);
  } else if (/\s/.test(value)) {
    value = value.split(/ +/g);
  }

  if (isArray(value)) {
    return {
      month: value[0],
      year: value.slice(1).join()
    };
  }

  len = value[0] === '0' || value.length > 5 ? 2 : 1;

  if (value[0] === '1') {
    year = value.substr(1);
    yearValid = expirationYear(year);
    if (!yearValid.isPotentiallyValid) {
      len = 2;
    }
  }

  month = value.substr(0, len);

  return {
    month: month,
    year: value.substr(month.length)
  };
}

module.exports = parseDate;


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Polyfill taken from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray#Polyfill>.

module.exports = Array.isArray || function (arg) {
  return Object.prototype.toString.call(arg) === '[object Array]';
};


/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DEFAULT_LENGTH = 3;

function includes(array, thing) {
  var i = 0;

  for (; i < array.length; i++) {
    if (thing === array[i]) { return true; }
  }

  return false;
}

function max(array) {
  var maximum = DEFAULT_LENGTH;
  var i = 0;

  for (; i < array.length; i++) {
    maximum = array[i] > maximum ? array[i] : maximum;
  }

  return maximum;
}

function verification(isValid, isPotentiallyValid) {
  return {isValid: isValid, isPotentiallyValid: isPotentiallyValid};
}

function cvv(value, maxLength) {
  maxLength = maxLength || DEFAULT_LENGTH;
  maxLength = maxLength instanceof Array ? maxLength : [maxLength];

  if (typeof value !== 'string') { return verification(false, false); }
  if (!/^\d*$/.test(value)) { return verification(false, false); }
  if (includes(maxLength, value.length)) { return verification(true, true); }
  if (value.length < Math.min.apply(null, maxLength)) { return verification(false, true); }
  if (value.length > max(maxLength)) { return verification(false, false); }

  return verification(true, true);
}

module.exports = cvv;


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DEFAULT_MIN_POSTAL_CODE_LENGTH = 3;

function verification(isValid, isPotentiallyValid) {
  return {isValid: isValid, isPotentiallyValid: isPotentiallyValid};
}

function postalCode(value, options) {
  var minLength;

  options = options || {};

  minLength = options.minLength || DEFAULT_MIN_POSTAL_CODE_LENGTH;

  if (typeof value !== 'string') {
    return verification(false, false);
  } else if (value.length < minLength) {
    return verification(false, true);
  }

  return verification(true, true);
}

module.exports = postalCode;


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var creditCardMask=function creditCardMask(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums.length<=4){return onlyNums;}if(onlyNums.length<=8){return onlyNums.slice(0,4)+' '+onlyNums.slice(4);}if(onlyNums.length<=12){return onlyNums.slice(0,4)+' '+onlyNums.slice(4,8)+' '+onlyNums.slice(8);}if(onlyNums.length<=16){return onlyNums.slice(0,4)+' '+onlyNums.slice(4,8)+' '+onlyNums.slice(8,12)+' '+onlyNums.slice(12);}return onlyNums.slice(0,4)+' '+onlyNums.slice(4,8)+' '+onlyNums.slice(8,12)+' '+onlyNums.slice(12,16);};exports.default=creditCardMask;module.exports=exports['default'];

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});/* eslint-disable */var creditCardValidadMask=function creditCardValidadMask(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums.length<=2){return onlyNums;}return onlyNums.slice(0,2)+'/'+onlyNums.slice(2,4);};exports.default=creditCardValidadMask;module.exports=exports['default'];

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=creditCardValidadValidate;function creditCardValidadValidate(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');var actualDate=new Date();var actualMonth=actualDate.getMonth()+1;var actualYear=actualDate.getFullYear()+'';var aux=actualYear.replace(/[^\d]/g,'');if(onlyNums.length<=3){return onlyNums.slice(0,2)<1||onlyNums.slice(0,2)>12?'Mês inválido.':undefined;}if(onlyNums.length>=4){return onlyNums.slice(2,4)<aux.slice(2,4)||onlyNums.slice(2,4)<=aux.slice(2,4)&&onlyNums.slice(0,2)<actualMonth?'Ano inválido.':onlyNums.slice(0,2)<1||onlyNums.slice(0,2)>12||onlyNums.slice(2,4)<aux.slice(2,4)&&onlyNums.slice(0,2)<actualMonth?'Mês inválido.':undefined;}return onlyNums?undefined:'Data inválido.';}module.exports=exports['default'];

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var creditCardCvcValidadMask=function creditCardCvcValidadMask(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums.length<=3){return''+onlyNums.slice(0,3);}};exports.default=creditCardCvcValidadMask;module.exports=exports['default'];

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=creditCardCvcValidate;function creditCardCvcValidate(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');return onlyNums.length<3?'CVC inválido.':undefined;}module.exports=exports['default'];

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var integerParse=function integerParse(value){var prefix=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'';var isAbsolute=arguments[2];var stringValue=new String(value);// eslint-disable-line
stringValue=stringValue.replace(/-/g,'').replace(/,/g,'.').replace(prefix,'');var splitedValues=stringValue.split('.');return splitedValues[0];};exports.default=integerParse;module.exports=exports['default'];

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=timeFormat;var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _constants=__webpack_require__(46);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function timeFormat(momentObject){if(!momentObject){throw new Error(_constants.FORMAT_TIME_INVALID);}return(0,_moment2.default)(momentObject).format(_constants.FORMAT_TIME);}module.exports=exports['default'];

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var hourMask=function hourMask(value){if(!value){return value;}var onlyNums=value.replace(/[^\d]/g,'');if(onlyNums.length<=2){return onlyNums;}return onlyNums.slice(0,2)+':'+onlyNums.slice(2,4);// if (onlyNums.length <= 4) {
// }
// return `${onlyNums.slice(0, 2)}/${onlyNums.slice(2, 4)}/${onlyNums.slice(4, 8)}`
};exports.default=hourMask;module.exports=exports['default'];

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var validateLetterLow=exports.validateLetterLow=function validateLetterLow(str){return str&&str.search(/[a-z]/)===-1;};var validateLetterUpper=exports.validateLetterUpper=function validateLetterUpper(str){return str&&str.search(/[A-Z]/)===-1;};var validateLetterEspecial=exports.validateLetterEspecial=function validateLetterEspecial(str){return str&&str.search(/[~`_!#$@\^*=\-;,/{}|:\?]/)===-1;};// eslint-disable-line
var newDefaultPassword=exports.newDefaultPassword=function newDefaultPassword(value){if(!value){return value;}return value.replace(/[^0-9a-zA-Z~`_!#$@\^*=\-;,/{}|:\?]+/g,'');// eslint-disable-line
};

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ActionTypes=__webpack_require__(230);function formStateReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case _ActionTypes.SAVING_FORM:{return action.state;}default:return state;}}exports.default=formStateReducer;module.exports=exports['default'];

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _reactRouterRedux=__webpack_require__(317);exports.default=function(store){return function(next){return function(action){var resolvedAction=next(action);if(resolvedAction&&resolvedAction.catch){resolvedAction.catch(function(e){if((typeof e==='undefined'?'undefined':_typeof(e))==='object'&&e.status===403){store.dispatch((0,_reactRouterRedux.push)('/conta/login'));}return e;});}return resolvedAction;};};};module.exports=exports['default'];

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _ActionTypes=__webpack_require__(230);var initialState={type:null,props:{}};function modalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case _ActionTypes.SHOW_MODAL:return _extends({},state,{type:action.payload.type,props:action.payload.props});case _ActionTypes.HIDE_MODAL:return initialState;default:return state;}}exports.default=modalReducer;module.exports=exports['default'];

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var initialState={stepsValidity:[],showErrors:true};function stepBoxReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'SET_STEPBOX_ERRORS':{return _extends({},state,{stepsValidity:action.stepsValidity});}case'SHOW_STEPBOX_ERRORS':{return _extends({},state,{showErrors:action.showErrors});}default:return state;}}exports.default=stepBoxReducer;module.exports=exports['default'];

/***/ }),
/* 1477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var initialState={token:'',error:null,title:null,loading:null};function tokenModalReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case'UPDATE_TOKEN_MODAL':return _extends({},state,{token:action.data});case'SET_TOKEN_MODAL_TITLE':return _extends({},state,{title:action.data});case'SET_TOKEN_MODAL_ERROR':return _extends({},state,{error:action.data});case'SET_TOKEN_MODAL_LOADING':return _extends({},state,{loading:action.data});default:return state;}}exports.default=tokenModalReducer;module.exports=exports['default'];

/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=headerReducer;var initialState={avatar:0};function headerReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};switch(action.type){case'CHANGE_AVATAR':return _extends({},state,{avatar:action.avatar});default:return state;}}module.exports=exports['default'];

/***/ }),
/* 1479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};exports.default=pageLoaderReducer;function pageLoaderReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case'SET_LOADING':{return _extends({},state,{isLoading:action.isLoading});}default:{return state;}}}module.exports=exports['default'];

/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=undefined;var _App=__webpack_require__(1481);var _App2=_interopRequireDefault(_App);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_App2.default;module.exports=exports['default'];

/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/templates/App/App.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _styledComponents=__webpack_require__(1);var _routes=__webpack_require__(96);var _styles=__webpack_require__(2289);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function App(props){var account=props.account;var profileType=void 0;var accountStatus=void 0;if(account&&account.accountType){profileType=account.accountType;}else{profileType='pf';}if(account&&account.active===true){accountStatus='active';}else{accountStatus='inactive';}// TEMPORARIO ALTERAR DEPOIS
// accountStatus = 'active'
// profileType = 'pj'
if(account&&account.at){profileType='at';}return _react2.default.createElement(_styledComponents.ThemeProvider,{theme:{breakpoints:[48,48,64]},__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement(_styles.Main,{modalOpen:props.modal.type,__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_reactRouterDom.Switch,{__source:{fileName:_jsxFileName,lineNumber:40}},_routes.routes[profileType][accountStatus].map(function(route){return _react2.default.createElement(_routes.RouteWithSubRoutes,_extends({key:route.path},route,{profile:profileType,__source:{fileName:_jsxFileName,lineNumber:42}}));}))));}var mapStateToProps=function mapStateToProps(state){return{modal:state.modalReducer,account:state.reducer.account};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps)(App));module.exports=exports['default'];

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(54);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Router"], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(54);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["Router"], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 1484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(128);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(93);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(318);

var _PathUtils = __webpack_require__(170);

var _createTransitionManager = __webpack_require__(319);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(522);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["MemoryRouter"]; });


/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(565);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Route"], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [activeClassName, className].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

NavLink.defaultProps = {
  activeClassName: 'active'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Prompt"]; });


/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Redirect"]; });


/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Route"]; });


/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Router"]; });


/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["StaticRouter"]; });


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["Switch"]; });


/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["matchPath"]; });


/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(54);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["withRouter"]; });


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(9);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(1496);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(1499);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(566);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(567);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters or exits.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-exit`, `fade-exit-active`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   * }}
   * ```
   *
   * @type {{
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  exit?: string,
   *  exitActive?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit'  class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is
   * class is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** from the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) libary.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ```js
 * import CSSTransition from 'react-transition-group/CSSTransition';
 *
 * const Fade = ({ children, ...props }) => (
 *  <CSSTransition
 *    {...props}
 *    timeout={500}
 *    classNames="fade"
 *  >
 *   {children}
 *  </CSSTransition>
 * );
 *
 * class FadeInAndOut extends React.Component {
 *   constructor(...args) {
 *     super(...args);
 *     this.state= { show: false }
 *
 *     setInterval(() => {
 *       this.setState({ show: !this.state.show })
 *     }, 5000)
 *   }
 *   render() {
 *     return (
 *       <Fade in={this.state.show}>
 *         <div>Hello world</div>
 *       </Fade>
 *     )
 *   }
 * }
 * ```
 *
 * And the coorresponding CSS for the `<Fade>` component:
 *
 * ```css
 * .fade-enter {
 *   opacity: 0.01;
 * }
 *
 * .fade-enter.fade-enter-active {
 *   opacity: 1;
 *   transition: opacity 500ms ease-in;
 * }
 *
 * .fade-exit {
 *   opacity: 1;
 * }
 *
 * .fade-exit.fade-exit-active {
 *   opacity: 0.01;
 *   transition: opacity 300ms ease-in;
 * }
 * ```
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      _this.removeClasses(node, 'exit');

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      return { className: className, activeClassName: activeClassName };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    /* eslint-disable no-unused-expressions */
    node.scrollTop;
    /* eslint-enable no-unused-expressions */
    addClass(node, className);
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(1497);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(1498));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 1497 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ChildMapping = __webpack_require__(1501);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them throguh if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disabled appear animations
   * for all children. Note that specifiying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disabled enter animations
   * for all children. Note that specifiying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
    * A convenience prop that enables or disabled exit animations
    * for all children. Note that specifiying this will override any defaults set
    * on individual children Transitions.
    */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};

/**
 * The `<TransitionGroup>` component manages a set of `<Transition>` components
 * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
 * state machine for managing the mounting and unmounting of components over
 * time.
 *
 * Consider the example below using the `Fade` CSS transition from before.
 * As items are removed or added to the TodoList the `in` prop is toggled
 * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
 * component in a `<TransitionGroup>`, not just css.
 *
 * ```jsx
 * import TransitionGroup from 'react-transition-group/TransitionGroup';
 *
 * class TodoList extends React.Component {
 *   constructor(props) {
 *     super(props)
 *     this.state = {items: ['hello', 'world', 'click', 'me']}
 *   }
 *   handleAdd() {
 *     const newItems = this.state.items.concat([
 *       prompt('Enter some text')
 *     ]);
 *     this.setState({ items: newItems });
 *   }
 *   handleRemove(i) {
 *     let newItems = this.state.items.slice();
 *     newItems.splice(i, 1);
 *     this.setState({items: newItems});
 *   }
 *   render() {
 *     return (
 *       <div>
 *         <button onClick={() => this.handleAdd()}>Add Item</button>
 *         <TransitionGroup>
 *           {this.state.items.map((item, i) => (
 *             <FadeTransition key={item}>
 *               <div>
 *                 {item}{' '}
 *                 <button onClick={() => this.handleRemove(i)}>
 *                   remove
 *                 </button>
 *               </div>
 *             </FadeTransition>
 *           ))}
 *         </TransitionGroup>
 *       </div>
 *     );
 *   }
 * }
 * ```
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual `<Transition>`
 * components. This means you can mix and match animations across different
 * list items.
 */

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    // Initial children should all be entering, dependent on appear
    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleExited = function (key, node, originalHandler) {
      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (key in currentChildMapping) return;

      if (originalHandler) originalHandler(node);

      _this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[key];
        return { children: children };
      });
    };

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children, function (child) {
        var onExited = function onExited(node) {
          _this.handleExited(child.key, node, child.props.onExited);
        };

        return (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          appear: _this.getProp(child, 'appear'),
          enter: _this.getProp(child, 'enter'),
          exit: _this.getProp(child, 'exit')
        });
      })
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };
  // use child config unless explictly set by the Group


  TransitionGroup.prototype.getProp = function getProp(child, prop) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props;

    return props[prop] != null ? props[prop] : child.props[prop];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    var prevChildMapping = this.state.children;
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);

    var children = (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping);

    Object.keys(children).forEach(function (key) {
      var child = children[key];

      if (!(0, _react.isValidElement)(child)) return;

      var onExited = function onExited(node) {
        _this2.handleExited(child.key, node, child.props.onExited);
      };

      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;

      var prevChild = prevChildMapping[key];
      var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

      // item is new (entering)
      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = (0, _react.cloneElement)(child, {
          onExited: onExited,
          in: true,
          exit: _this2.getProp(child, 'exit', nextProps),
          enter: _this2.getProp(child, 'enter', nextProps)
        });
      }
      // item is old (exiting)
      else if (!hasNext && hasPrev && !isLeaving) {
          // console.log('leaving', key)
          children[key] = (0, _react.cloneElement)(child, { in: false });
        }
        // item hasn't changed transition states
        // copy over the last transition props;
        else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
            // console.log('unchanged', key)
            children[key] = (0, _react.cloneElement)(child, {
              onExited: onExited,
              in: prevChild.props.in,
              exit: _this2.getProp(child, 'exit', nextProps),
              enter: _this2.getProp(child, 'enter', nextProps)
            });
          }
    });

    this.setState({ children: children });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = this.state.children;


    delete props.appear;
    delete props.enter;
    delete props.exit;

    return _react2.default.createElement(
      Component,
      props,
      values(children).map(childFactory)
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray2 = __webpack_require__(1503);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = __webpack_require__(135);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assign = __webpack_require__(237);

var _assign2 = _interopRequireDefault(_assign);

var _keys = __webpack_require__(180);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = __webpack_require__(98),
    get = _require.get,
    arr = _require.arr,
    px = _require.px,
    neg = _require.neg,
    num = _require.num,
    breaks = _require.breaks,
    dec = _require.dec,
    media = _require.media,
    merge = _require.merge;

var _require2 = __webpack_require__(239),
    space = _require2.space;

var REG = /^[mp][trblxy]?$/;

module.exports = function (props) {
  var keys = (0, _keys2.default)(props).filter(function (key) {
    return REG.test(key);
  }).sort();
  var bp = breaks(props);
  var sc = get(props, 'theme.space', space);

  return keys.map(function (key) {
    var val = props[key];
    var p = getProperties(key);

    if (!Array.isArray(val)) {
      return p.reduce(function (a, b) {
        return (0, _assign2.default)(a, (0, _defineProperty3.default)({}, b, mx(sc)(val)));
      }, {});
    }

    return arr(val).map(mx(sc)).map(dec(p)).map(media(bp)).reduce(merge, {});
  }).reduce(merge, {});
};

var mx = function mx(scale) {
  return function (n) {
    if (!num(n)) {
      return n;
    }

    var value = scale[Math.abs(n)] || Math.abs(n);
    if (!num(value)) {
      return value;
    }

    return px(value * (neg(n) ? -1 : 1));
  };
};

var getProperties = function getProperties(key) {
  var _key$split = key.split(''),
      _key$split2 = (0, _slicedToArray3.default)(_key$split, 2),
      a = _key$split2[0],
      b = _key$split2[1];

  var prop = properties[a];
  var dirs = directions[b] || [''];
  return dirs.map(function (dir) {
    return prop + dir;
  });
};

var properties = {
  m: 'margin',
  p: 'padding'
};

var directions = {
  t: ['Top'],
  r: ['Right'],
  b: ['Bottom'],
  l: ['Left'],
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};

/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1504);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(576);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1505), __esModule: true };

/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(231);
__webpack_require__(179);
module.exports = __webpack_require__(1514);


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1507);
var step = __webpack_require__(569);
var Iterators = __webpack_require__(153);
var toIObject = __webpack_require__(154);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(368)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1507 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(233);
var descriptor = __webpack_require__(177);
var setToStringTag = __webpack_require__(236);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(109)(IteratorPrototype, __webpack_require__(58)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(75);
var anObject = __webpack_require__(110);
var getKeys = __webpack_require__(178);

module.exports = __webpack_require__(76) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(154);
var toLength = __webpack_require__(234);
var toAbsoluteIndex = __webpack_require__(1511);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(370);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(87).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(370);
var defined = __webpack_require__(367);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(374);
var ITERATOR = __webpack_require__(58)('iterator');
var Iterators = __webpack_require__(153);
module.exports = __webpack_require__(50).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(231);
__webpack_require__(179);
module.exports = __webpack_require__(1516);


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(110);
var get = __webpack_require__(375);
module.exports = __webpack_require__(50).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1518);
var $Object = __webpack_require__(50).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(67);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(76), 'Object', { defineProperty: __webpack_require__(75).f });


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1520);
module.exports = __webpack_require__(50).Object.assign;


/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(67);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1521) });


/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(76);
var getKeys = __webpack_require__(178);
var gOPS = __webpack_require__(376);
var pIE = __webpack_require__(238);
var toObject = __webpack_require__(134);
var IObject = __webpack_require__(365);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(132)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1523);
module.exports = __webpack_require__(50).Object.keys;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(134);
var $keys = __webpack_require__(178);

__webpack_require__(578)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1525), __esModule: true };

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(179);
__webpack_require__(231);
module.exports = __webpack_require__(378).f('iterator');


/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1527), __esModule: true };

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1528);
__webpack_require__(582);
__webpack_require__(1531);
__webpack_require__(1532);
module.exports = __webpack_require__(50).Symbol;


/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(87);
var has = __webpack_require__(133);
var DESCRIPTORS = __webpack_require__(76);
var $export = __webpack_require__(67);
var redefine = __webpack_require__(573);
var META = __webpack_require__(379).KEY;
var $fails = __webpack_require__(132);
var shared = __webpack_require__(372);
var setToStringTag = __webpack_require__(236);
var uid = __webpack_require__(235);
var wks = __webpack_require__(58);
var wksExt = __webpack_require__(378);
var wksDefine = __webpack_require__(380);
var enumKeys = __webpack_require__(1529);
var isArray = __webpack_require__(579);
var anObject = __webpack_require__(110);
var isObject = __webpack_require__(97);
var toObject = __webpack_require__(134);
var toIObject = __webpack_require__(154);
var toPrimitive = __webpack_require__(369);
var createDesc = __webpack_require__(177);
var _create = __webpack_require__(233);
var gOPNExt = __webpack_require__(1530);
var $GOPD = __webpack_require__(581);
var $GOPS = __webpack_require__(376);
var $DP = __webpack_require__(75);
var $keys = __webpack_require__(178);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(580).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(238).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(232)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(109)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(178);
var gOPS = __webpack_require__(376);
var pIE = __webpack_require__(238);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(154);
var gOPN = __webpack_require__(580).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(380)('asyncIterator');


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(380)('observable');


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1534), __esModule: true };

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(179);
__webpack_require__(1535);
module.exports = __webpack_require__(50).Array.from;


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(131);
var $export = __webpack_require__(67);
var toObject = __webpack_require__(134);
var call = __webpack_require__(583);
var isArrayIter = __webpack_require__(584);
var toLength = __webpack_require__(234);
var createProperty = __webpack_require__(1536);
var getIterFn = __webpack_require__(375);

$export($export.S + $export.F * !__webpack_require__(1537)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(75);
var createDesc = __webpack_require__(177);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(58)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(98),
    is = _require.is,
    arr = _require.arr,
    num = _require.num,
    px = _require.px,
    breaks = _require.breaks,
    dec = _require.dec,
    media = _require.media,
    merge = _require.merge;

module.exports = function (props) {
  var n = is(props.width) ? props.width : props.width || props.w;
  if (!is(n)) return null;

  if (!Array.isArray(n)) {
    return {
      width: wx(n)
    };
  }

  var bp = breaks(props);

  return n.map(wx).map(dec('width')).map(media(bp)).reduce(merge, {});
};

var wx = function wx(n) {
  return !num(n) || n > 1 ? px(n) : n * 100 + '%';
};

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(98),
    get = _require.get,
    is = _require.is,
    arr = _require.arr,
    num = _require.num,
    px = _require.px,
    breaks = _require.breaks,
    dec = _require.dec,
    media = _require.media,
    merge = _require.merge;

var _require2 = __webpack_require__(239),
    fontSizes = _require2.fontSizes;

module.exports = function (props) {
  var n = is(props.fontSize) ? props.fontSize : props.fontSize || props.f;
  if (!is(n)) return null;

  var scale = get(props, 'theme.fontSizes', fontSizes);

  if (!Array.isArray(n)) {
    return {
      fontSize: fx(scale)(n)
    };
  }

  var bp = breaks(props);

  return n.map(fx(scale)).map(dec('fontSize')).map(media(bp)).reduce(merge, {});
};

var fx = function fx(scale) {
  return function (n) {
    return num(n) ? px(scale[n] || n) : n;
  };
};

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty2 = __webpack_require__(135);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = __webpack_require__(180);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _require = __webpack_require__(98),
    get = _require.get,
    breaks = _require.breaks,
    merge = _require.merge,
    arr = _require.arr,
    dec = _require.dec,
    media = _require.media;

var REG = /^color|bg$/;

module.exports = function (props) {
  var keys = (0, _keys2.default)(props).filter(function (key) {
    return REG.test(key);
  });
  var bp = breaks(props);
  var palette = get(props, 'theme.colors', {});

  return keys.map(function (key) {
    var val = props[key];
    var prop = properties[key] || key;

    if (!Array.isArray(val)) {
      return (0, _defineProperty3.default)({}, prop, cx(palette)(val));
    }

    return val.map(cx(palette)).map(dec(prop)).map(media(bp)).reduce(merge, {});
  }).reduce(merge, {});
};

var cx = function cx(obj) {
  return function (n) {
    return get(obj, n + '', n);
  };
};

var properties = {
  bg: 'backgroundColor'
};

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var responsiveStyle = __webpack_require__(111);
module.exports = responsiveStyle('textAlign', 'align');

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var style = __webpack_require__(99);

module.exports = style({
  prop: 'lineHeight',
  key: 'lineHeights'
});

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var style = __webpack_require__(99);

module.exports = style({
  prop: 'fontWeight',
  key: 'fontWeights'
});

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var style = __webpack_require__(99);

module.exports = style({
  prop: 'letterSpacing',
  key: 'letterSpacings',
  numberToPx: true
});

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var responsiveStyle = __webpack_require__(111);
module.exports = responsiveStyle('alignItems', 'align');

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var responsiveStyle = __webpack_require__(111);
module.exports = responsiveStyle('justifyContent', 'justify');

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var responsiveStyle = __webpack_require__(111);
module.exports = responsiveStyle('flexWrap', 'wrap', 'wrap');

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var responsiveStyle = __webpack_require__(111);
module.exports = responsiveStyle('flexDirection');

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var responsiveStyle = __webpack_require__(111);
module.exports = responsiveStyle('flex');

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var responsiveStyle = __webpack_require__(111);
module.exports = responsiveStyle('alignSelf', 'alignSelf');

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var style = __webpack_require__(99);

module.exports = style({
  prop: 'borderRadius',
  key: 'radii',
  numberToPx: true
});

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var style = __webpack_require__(99);

module.exports = style({
  prop: 'borderColor',
  key: 'colors'
});

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__(237);

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = __webpack_require__(381);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _defineProperty2 = __webpack_require__(135);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var style = __webpack_require__(99);

var getDirectionProp = function getDirectionProp(template) {
  return function (dir) {
    return template(dir);
  };
};
var getWidthProp = getDirectionProp(function (dir) {
  return 'border' + dir + 'Width';
});
var getStyleProp = getDirectionProp(function (dir) {
  return 'border' + dir + 'Style';
});

var getDirections = function getDirections(props) {
  var directions = [];
  if (props.borderTop) directions.push('Top');
  if (props.borderRight) directions.push('Right');
  if (props.borderBottom) directions.push('Bottom');
  if (props.borderLeft) directions.push('Left');
  return directions.length ? directions : null;
};

module.exports = function (props) {
  var directions = getDirections(props);
  var borderWidths = directions ? directions.map(function (dir) {
    return style({
      key: 'borderWidths',
      prop: 'borderWidth',
      cssProperty: getWidthProp(dir),
      numberToPx: true
    })(props);
  }) : [style({
    key: 'borderWidths',
    prop: 'borderWidth',
    numberToPx: true
  })(props)];

  var borderStyles = directions ? directions.map(function (dir) {
    return (0, _defineProperty3.default)({}, getStyleProp(dir), 'solid');
  }) : [{ borderStyle: 'solid' }];

  return props.borderWidth || props.borderWidth === 0 ? _assign2.default.apply(Object, [{}].concat((0, _toConsumableArray3.default)(borderWidths), (0, _toConsumableArray3.default)(borderStyles))) : null;
};

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var style = __webpack_require__(99);

module.exports = style({
  prop: 'boxShadow',
  key: 'shadows'
});

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var style = __webpack_require__(99);

module.exports = style({
  prop: 'maxWidth',
  cssProperty: 'maxWidth',
  key: 'maxWidths',
  numberToPx: true
});

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pseudoStyle = __webpack_require__(181);
module.exports = pseudoStyle('hover')({
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  boxShadow: 'shadows'
});

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pseudoStyle = __webpack_require__(181);
module.exports = pseudoStyle('focus')({
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  boxShadow: 'shadows'
});

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pseudoStyle = __webpack_require__(181);
module.exports = pseudoStyle('active')({
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  boxShadow: 'shadows'
});

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pseudoStyle = __webpack_require__(181);
module.exports = pseudoStyle('disabled', 'disabledStyle')({
  color: 'colors',
  backgroundColor: 'colors',
  borderColor: 'colors',
  boxShadow: 'shadows'
});

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// theme getter
var _require = __webpack_require__(98),
    get = _require.get;

module.exports = function (keys, fallback) {
  return function (props) {
    return get(props.theme, keys, fallback);
  };
};

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1562)();
}


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1563);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__(180);

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = __webpack_require__(1565);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(382);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(1568);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(383);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(384);

var _inherits3 = _interopRequireDefault(_inherits2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var React = __webpack_require__(0);

var cleanElement = function cleanElement(Component) {
  return function (_React$Component) {
    (0, _inherits3.default)(Cleaned, _React$Component);

    function Cleaned() {
      (0, _classCallCheck3.default)(this, Cleaned);
      return (0, _possibleConstructorReturn3.default)(this, (Cleaned.__proto__ || (0, _getPrototypeOf2.default)(Cleaned)).apply(this, arguments));
    }

    (0, _createClass3.default)(Cleaned, [{
      key: 'render',
      value: function render() {
        var next = {};
        var keys = (0, _keys2.default)(Cleaned.propTypes || {});
        for (var key in this.props) {
          if (keys.includes(key)) continue;
          next[key] = this.props[key];
        }

        return React.createElement(Component, next);
      }
    }]);
    return Cleaned;
  }(React.Component);
};

module.exports = cleanElement;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1566), __esModule: true };

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1567);
module.exports = __webpack_require__(50).Object.getPrototypeOf;


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(134);
var $getPrototypeOf = __webpack_require__(575);

__webpack_require__(578)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(577);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1570), __esModule: true };

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1571);
module.exports = __webpack_require__(50).Object.setPrototypeOf;


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(67);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1572).set });


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(97);
var anObject = __webpack_require__(110);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(131)(Function.call, __webpack_require__(581).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1574), __esModule: true };

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1575);
var $Object = __webpack_require__(50).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(67);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(233) });


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray2 = __webpack_require__(381);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _keys = __webpack_require__(180);

var _keys2 = _interopRequireDefault(_keys);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = __webpack_require__(585);

var blacklist = (0, _keys2.default)(propTypes).reduce(function (a, key) {
  return [].concat((0, _toConsumableArray3.default)(a), (0, _toConsumableArray3.default)((0, _keys2.default)(propTypes[key])));
}, []);

module.exports = function (props) {
  var next = {};

  for (var key in props) {
    if (blacklist.includes(key)) continue;
    next[key] = props[key];
  }

  return next;
};

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cleanProps = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tag = function tag() {
  var blacklist = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var clean = cleanProps(blacklist);

  return function (type) {
    var Base = function Base(props) {
      var isEl = typeof type === 'string';
      var Comp = isEl ? props.is || type : type;
      var next = isEl ? clean(props) : props;

      if (isEl) next.is = null;

      return _react2.default.createElement(Comp, next);
    };

    return Base;
  };
};

var cleanProps = exports.cleanProps = function cleanProps(blacklist) {
  return function (props) {
    var next = {};
    for (var key in props) {
      if (blacklist.includes(key)) continue;
      next[key] = props[key];
    }
    return next;
  };
};

exports.default = tag;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['width', 'w', 'm', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'flex', 'order', 'wrap', 'direction', 'align', 'justify', 'column'];

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _styledComponents = __webpack_require__(1);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledSystem = __webpack_require__(568);

var _propTypes = __webpack_require__(9);

var _propTypes2 = __webpack_require__(586);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _Box = __webpack_require__(364);

var _Box2 = _interopRequireDefault(_Box);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrap = (0, _styledSystem.responsiveStyle)('flex-wrap', 'wrap', 'wrap');
var direction = (0, _styledSystem.responsiveStyle)('flex-direction', 'direction');
var align = function align(props) {
  return (0, _styledSystem.responsiveStyle)('align-items', 'align');
};
var justify = function justify(props) {
  return (0, _styledSystem.responsiveStyle)('justify-content', 'justify');
};
var column = function column(props) {
  return props.column ? 'flex-direction:column;' : null;
};

var Flex = (0, _styledComponents2.default)(_Box2.default)([], { display: 'flex' }, wrap, column, direction, align, justify);
Flex.displayName = 'Flex';

var responsivePropType = (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string, _propTypes.array, _propTypes.bool]);

Flex.propTypes = Object.assign({}, _propTypes3.default, {
  wrap: responsivePropType,
  direction: responsivePropType,
  align: responsivePropType,
  justify: responsivePropType,
  column: _propTypes.bool
});

exports.default = Flex;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Grid = __webpack_require__(182);

var _Grid2 = _interopRequireDefault(_Grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Half = function Half(props) {
  return _react2.default.createElement(_Grid2.default, _extends({}, props, { width: [1, 1 / 2] }));
};
Half.displayName = 'Half';

exports.default = Half;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Grid = __webpack_require__(182);

var _Grid2 = _interopRequireDefault(_Grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Third = function Third(props) {
  return _react2.default.createElement(_Grid2.default, _extends({}, props, { width: [1, 1 / 3] }));
};
Third.displayName = 'Third';

exports.default = Third;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Grid = __webpack_require__(182);

var _Grid2 = _interopRequireDefault(_Grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Quarter = function Quarter(props) {
  return _react2.default.createElement(_Grid2.default, _extends({}, props, { width: [1, 1 / 4] }));
};
Quarter.displayName = 'Quarter';

exports.default = Quarter;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.B = exports.A = exports.gb = exports.ga = exports.φ = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Grid = __webpack_require__(182);

var _Grid2 = _interopRequireDefault(_Grid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var φ = exports.φ = (1 + Math.sqrt(5)) / 2;
var ga = exports.ga = φ - 1;
var gb = exports.gb = 1 - ga;

var A = exports.A = function A(props) {
  return _react2.default.createElement(_Grid2.default, _extends({}, props, { width: [1, ga] }));
};
var B = exports.B = function B(props) {
  return _react2.default.createElement(_Grid2.default, _extends({}, props, { width: [1, gb] }));
};

var Golden = {
  A: A,
  B: B
};
Golden.displayName = 'Golden';

exports.default = Golden;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#ffd300\" fill-rule=\"nonzero\" d=\"M3.97 28.757c-.29 0-.485 0-.776-.097-1.553-.388-2.524-2.039-2.136-3.69 1.845-6.99 6.117-13.3 11.845-17.766 2.913-2.233 6.116-3.98 9.514-5.146C26.01.796 29.7.214 33.485.214c3.787 0 7.476.582 11.068 1.844 3.398 1.165 6.602 2.913 9.515 5.146 2.815 2.233 5.34 4.854 7.282 7.864a34.002 34.002 0 0 1 4.563 9.903 3.065 3.065 0 0 1-2.136 3.69 3.065 3.065 0 0 1-3.69-2.137c-1.553-5.728-5.048-10.874-9.805-14.563a27.418 27.418 0 0 0-16.894-5.825c-6.213 0-12.038 2.039-16.99 5.825a27.487 27.487 0 0 0-9.709 14.66c-.194 1.262-1.456 2.136-2.718 2.136zM33.485 67.398c-15.242 0-28.64-10.291-32.524-25.048-.388-1.554.486-3.204 2.136-3.593 1.553-.388 3.204.486 3.592 2.136 3.204 12.136 14.175 20.583 26.7 20.583 12.524 0 23.592-8.447 26.698-20.583.389-1.553 2.04-2.524 3.593-2.136 1.553.389 2.524 2.04 2.136 3.593-3.69 14.757-16.99 25.048-32.33 25.048z\"/>\n                <path fill=\"#ffd300\" fill-rule=\"nonzero\" d=\"M47.175 50.699a3.012 3.012 0 0 1-2.136-.874l-13.787-13.98c-.582-.583-.873-1.262-.873-2.136V16.816c0-1.651 1.359-3.01 3.01-3.01 1.65 0 3.01 1.359 3.01 3.01v15.728L49.31 45.65a2.93 2.93 0 0 1 0 4.175 3.012 3.012 0 0 1-2.136.874z\"/>\n                <path d=\"M-16.223-15.903h99.029v99.029h-99.029z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <rect width=\"109\" height=\"37\" x=\".5\" y=\".5\" stroke=\"#FFF\" rx=\"3\"/>\n                <g fill=\"#FFF\">\n                    <path d=\"M10.705 7.945C9.763 7.945 9 8.78 9 9.812v19.32C9 30.165 9.762 31 10.705 31h8.49c.94 0 1.704-.834 1.704-1.867V9.813c0-1.032-.762-1.868-1.705-1.868h-8.49zm-.59 3.024v17.007h9.669V10.97h-9.668zm4.835 19.275a.75.75 0 0 0 .743-.756.75.75 0 0 0-.743-.756.75.75 0 0 0-.744.756.75.75 0 0 0 .744.756zM13.462 9.457c0 .209.128.378.296.378h2.383c.163 0 .296-.175.296-.378 0-.209-.128-.378-.296-.378h-2.383c-.163 0-.296.175-.296.378z\"/>\n                    <text font-family=\"OpenSans, Open Sans\" font-size=\"9\" letter-spacing=\".18\">\n                        <tspan x=\"30.103\" y=\"15.231\">Dispon\xEDvel na</tspan>\n                    </text>\n                    <text font-family=\"OpenSans, Open Sans\" font-size=\"16\" letter-spacing=\"-.567\">\n                        <tspan x=\"30.103\" y=\"30.077\">App Store</tspan>\n                    </text>\n                </g>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <rect width=\"16\" height=\"16\" fill=\"#9000A3\" rx=\"8\"/>\n        <g fill=\"#D37EDF\" fill-rule=\"nonzero\" transform=\"translate(7 3)\">\n            <path d=\"M.886 6.429A.89.89 0 0 1 0 5.543V.886C0 .4.4 0 .886 0c.485 0 .885.4.885.886v4.657c0 .514-.4.886-.885.886z\"/>\n            <circle cx=\".914\" cy=\"8.914\" r=\"1\"/>\n        </g>\n    </g>\n</svg>\n"};module.exports=exports["default"];

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <rect width=\"16\" height=\"16\" fill=\"#e5b200\" rx=\"8\"/>\n        <g fill=\"#FFFFFF\" fill-rule=\"nonzero\" transform=\"translate(7 3)\">\n            <path d=\"M.886 6.429A.89.89 0 0 1 0 5.543V.886C0 .4.4 0 .886 0c.485 0 .885.4.885.886v4.657c0 .514-.4.886-.885.886z\"/>\n            <circle cx=\".914\" cy=\"8.914\" r=\"1\"/>\n        </g>\n    </g>\n</svg>\n"};module.exports=exports["default"];

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n        <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M21.515 79.515c-5.534 0-10.68-2.136-14.66-6.117C2.97 69.515.737 64.272.737 58.738V14.95C.738 6.796 7.437.097 15.592.097c8.156 0 14.855 6.7 14.855 14.854v43.496a8.909 8.909 0 0 1-8.932 8.932 8.909 8.909 0 0 1-8.932-8.932V14.854c0-1.65 1.359-3.01 3.01-3.01 1.65 0 3.009 1.36 3.009 3.01v43.593c0 1.65 1.36 3.01 3.01 3.01 1.65 0 3.01-1.36 3.01-3.01V14.95c0-2.33-.972-4.563-2.622-6.31-1.65-1.748-3.883-2.622-6.31-2.622-2.33 0-4.564.971-6.311 2.622a8.883 8.883 0 0 0-2.622 6.31v43.787c0 3.883 1.554 7.67 4.37 10.485 2.815 2.816 6.504 4.37 10.485 4.37 3.98 0 7.67-1.554 10.485-4.37 2.816-2.815 4.369-6.505 4.369-10.485V14.95c0-1.65 1.36-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01v43.787c0 5.534-2.136 10.68-6.117 14.66-4.078 3.98-9.32 6.117-14.854 6.117z\"/>\n        <path d=\"M-27.903-9.903h99.029v99.029h-99.029z\"/>\n    </g>"};module.exports=exports["default"];

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(-17 -17)\">\n            <path fill=\"#f45f48\" fill-rule=\"nonzero\" d=\"M20.392 45.534c-.294 0-.49 0-.784-.097-1.569-.388-2.55-2.039-2.157-3.69 1.863-6.99 6.176-13.3 11.96-17.766 2.942-2.233 6.177-3.981 9.609-5.146 3.627-1.262 7.353-1.845 11.176-1.845 3.824 0 7.55.583 11.177 1.845 3.43 1.165 6.666 2.913 9.607 5.146 2.844 2.233 5.393 4.854 7.353 7.864a33.85 33.85 0 0 1 4.608 9.903c.392 1.553-.49 3.203-2.157 3.689A3.099 3.099 0 0 1 77.06 43.3c-1.569-5.728-5.098-10.874-9.902-14.563a27.86 27.86 0 0 0-17.059-5.825c-6.274 0-12.157 2.038-17.157 5.825a27.471 27.471 0 0 0-9.804 14.66c-.196 1.262-1.372 2.136-2.745 2.136zM50.294 84.175c-15.392 0-28.921-10.292-32.843-25.049-.392-1.553.49-3.204 2.157-3.592 1.568-.388 3.235.485 3.627 2.136 3.236 12.136 14.314 20.582 26.961 20.582 12.647 0 23.824-8.446 26.96-20.582.393-1.553 2.06-2.524 3.628-2.136 1.569.388 2.55 2.039 2.157 3.592-3.725 14.757-17.255 25.049-32.647 25.049z\"/>\n            <path fill=\"#f45f48\" fill-rule=\"nonzero\" d=\"M50.294 59.32c-1.667 0-3.04-1.359-3.04-3.01V33.69c0-1.651 1.373-3.01 3.04-3.01s3.04 1.359 3.04 3.01v22.62c0 1.748-1.373 3.01-3.04 3.01z\"/>\n            <ellipse cx=\"50.196\" cy=\"67.184\" fill=\"#f45f48\" fill-rule=\"nonzero\" rx=\"3.137\" ry=\"3.107\"/>\n            <path d=\"M0 .874h100v99.029H0z\"/>\n        </g>"};module.exports=exports["default"];

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n                <g transform=\"translate(-163.000000, -33.000000)\" stroke=\"currentColor\" stroke-width=\"2\">\n                    <g id=\"Group\" transform=\"translate(164.000000, 31.000000)\">\n                        <polyline id=\"Path-2\" transform=\"translate(3.000000, 8.000000) scale(-1, 1) rotate(-90.000000) translate(-3.000000, -8.000000) \" points=\"-2 5.55487907 2.97240905 10.5 8 5.5\"></polyline>\n                    </g>\n                </g>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#c5c3d8\" fill-rule=\"nonzero\" d=\"M65.146 28.35c-1.65 0-3.01-1.36-3.01-3.01V13.495c0-1.65 1.36-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01V25.34c0 1.65-1.36 3.01-3.01 3.01zM35.437 28.35c-1.65 0-3.01-1.36-3.01-3.01V13.495c0-1.65 1.36-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01V25.34c-.097 1.65-1.36 3.01-3.01 3.01z\"/>\n                <path fill=\"#c5c3d8\" fill-rule=\"nonzero\" d=\"M74.272 83.98H26.31c-5.34 0-9.71-4.368-9.71-9.708V26.31c0-5.34 4.37-9.71 9.71-9.71h47.96c5.34 0 9.71 4.37 9.71 9.71v47.96c0 5.34-4.37 9.71-9.71 9.71zM26.31 22.428c-2.136 0-3.787 1.748-3.787 3.787v47.96c0 2.137 1.748 3.787 3.787 3.787h47.96c2.137 0 3.787-1.747 3.787-3.786V26.214c0-2.136-1.747-3.787-3.786-3.787H26.31z\"/>\n                <path fill=\"#c5c3d8\" fill-rule=\"nonzero\" d=\"M69.223 42.233H31.456c-1.65 0-3.01-1.36-3.01-3.01 0-1.65 1.36-3.01 3.01-3.01h37.767c1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.36 3.01-3.01 3.01z\"/>\n                <path d=\"M.583.583h99.029v99.029H.583z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#151245\" d=\"M1.405 32.503c.112 1.383.222 2.793-.127 4.14-.167.644-.435 1.336-.159 1.945.067.147.166.298.132.455-.03.131-.146.23-.186.358-.125.404.493.605.932.599l11.121-.158c2.643-.038 5.29-.076 7.922-.32 1.147-.107 2.295-.253 3.447-.222 1.365.038 2.708.326 4.066.462 1.696.171 3.407.106 5.11.042l8.543-.326c.856-.032 1.762-.08 2.47-.543.136-.089.27-.203.31-.356.079-.291-.2-.551-.461-.718-.83-.53-1.897-1.044-1.984-1.996-.036-.386.11-.763.194-1.141.143-.648.104-1.318.065-1.978l-.249-4.221a38.497 38.497 0 0 0-7.85-.201c-.487.037-.985.087-1.423.294-.72.341-1.176 1.072-1.345 1.826-.169.754-.09 1.538.017 2.303.065.462.067 1.059-.379 1.247-.267.112-.573.01-.853-.067-2.01-.564-4.174.128-6.254-.105-1.41-.159-2.77-.742-4.19-.685-.703.028-1.39.214-2.093.265-1.017.074-2.028-.137-3.036-.285-1.16-.17-2.332-.258-3.505-.328a112.607 112.607 0 0 0-4.487-.177c.13-1.154.177-2.518-.76-3.25-.357-.278-.806-.416-1.243-.547l-1.844-.557c-.984-.297-2.06-.567-2.199.582-.138 1.142.205 2.514.298 3.663\"/>\n                <path fill=\"#C5168C\" d=\"M42.82 27.045c.197-.467.188-.991.173-1.497-.101-3.572-.748-7.077-.464-10.701.093-1.187-.347-2.32-.968-3.34a241.87 241.87 0 0 0-6.638-10.282c-.168-.246-.341-.498-.58-.678-.45-.34-1.053-.378-1.618-.401-7.358-.299-12.57-.108-21.878.291-1.72.074-3.64.25-4.877 1.434-.438.42-.713.974-.98 1.516-1.25 2.54-2.5 5.079-3.697 7.643-.5 1.072-.996 2.163-1.188 3.328-.15.917-.108 1.852-.065 2.78l.366 7.967c.04.845.081 1.707.392 2.495.31.788 41.657.312 42.022-.555\"/>\n                <path fill=\"#151245\" d=\"M41.582 28.836c.89-.387 1.864-.855 2.236-1.769.135-.333.175-.692.182-1.055.003-.175-43 1.64-43 1.64.316.83.96 1.584 1.81 1.78 11.492 2.644 23.703 1.412 35.42.17 1.063-.113 2.368-.34 3.352-.766\"/>\n                <path fill=\"#28C4D4\" d=\"M37.001 14.798c-.005-.194.003-.416.16-.539.093-.073.218-.091.337-.106a19.473 19.473 0 0 1 3.447-.127c.198.011.41.03.565.148.201.154.245.426.274.672.316 2.776-.066 5.093-.15 7.885-.007.204.479.904.342 1.06-.195.223-.547.22-.849.2l-2.72-.187c-.222-.015-.461-.037-.628-.178-.182-.154-.227-.405-.26-.636-.388-2.76-.444-5.441-.518-8.192M1.009 16.508c-.027-.657-.021-1.39.478-1.869.434-.417 1.115-.517 1.745-.589.694-.079 1.494-.121 1.996.319.405.355.476.91.518 1.418.188 2.306.272 4.618.25 6.93-.001.243-.008.496-.135.71-.293.491-1.04.541-1.66.529-.643-.014-2.26.22-2.726-.27-.349-.365-.161-1.273-.185-1.711-.1-1.823-.207-3.644-.281-5.467\"/>\n                <path fill=\"#FFF\" d=\"M26 24c.213 0 .44.004.617.133.276.2.33.616.356.98.057.767.071 1.657-.452 2.165-.371.36-.905.409-1.398.438a162.02 162.02 0 0 1-10.882.279c-.27-.003-.562-.013-.776-.196-.276-.238-.322-.672-.346-1.058-.04-.622-.078-1.245-.117-1.867-.07-1.142 1.442-.71 2.155-.727A476.236 476.236 0 0 1 26.001 24M21.38 15.86c1.208.062 2.457.228 3.6-.207.052-.576.036-1.294-.436-1.556-.208-.115-.453-.102-.685-.088l-3.213.206c-.553.036-1.106.071-1.658.124-.24.023-.497.058-.678.232-.64.616-.184 1.328.418 1.405.813.103 1.802-.16 2.651-.116\"/>\n                <path fill=\"#28C4D4\" d=\"M37.99 10.757a57.518 57.518 0 0 0-4.103-7.272c-.327-.494-.69-1.007-1.244-1.265-.492-.23-1.065-.226-1.615-.217-3.85.064-7.701.17-11.551.277l-3.783.104c-2.57.07-5.144.142-7.705.364-.45.04-.922.091-1.29.338-.344.232-.546.602-.735.958L2.04 11.421c-.24.45.632.633 1.163.565 4.472-.574 8.994-.69 13.506-.762 6.868-.108 13.776-.716 20.605-.026 1.012.102.572-.355.676-.44\"/>\n                <path fill=\"#FFF\" d=\"M5 20.42c5.476-.66 10.978-.81 16.474-.959l16.999-.46c.164-.005.354.007.452.19.098.181.11.517-.022.381C27.7 19.931 16.5 20.407 5.301 21c-.061-.221-.16-.444-.301-.58\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#c5c3d8\" fill-rule=\"nonzero\" d=\"M13.168 42.098c-1.64 0-2.968 1.342-2.968 2.997v21.099c0 5.411 4.366 9.82 9.725 9.82h59.704c5.359 0 9.725-4.409 9.725-9.82v-11.05c0-1.654-1.329-2.996-2.968-2.996-1.64 0-2.968 1.342-2.968 2.997v11.049c0 2.1-1.708 3.826-3.79 3.826H19.926c-2.081 0-3.79-1.725-3.79-3.826V48.092h70.25c1.64 0 2.969-1.342 2.969-2.997V33.776c0-5.411-4.366-9.82-9.725-9.82H19.925c-5.36 0-9.725 4.409-9.725 9.82v1.13c0 1.654 1.328 2.996 2.968 2.996 1.639 0 2.968-1.342 2.968-2.997v-1.129c0-2.1 1.708-3.826 3.789-3.826h59.704c2.08 0 3.789 1.725 3.789 3.826v8.322h-70.25z\"/>\n                <path d=\"M.04 0h99.029v100H.04z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n                <g transform=\"translate(-5.000000, -6.000000)\" stroke-width=\"2\" stroke=\"currentColor\">\n                    <polyline id=\"Mark\" points=\"15 7 8.51694215 13 6 10.6705972\"></polyline>\n                </g>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"#currentColor\" fill-rule=\"evenodd\">\n                <path d=\"M20.153 23H3.847C1.726 23 0 21.4 0 19.434V3.566C0 1.6 1.726 0 3.847 0h16.306C22.274 0 24 1.6 24 3.566v2.639c0 .656-.574 1.188-1.283 1.188-.708 0-1.282-.532-1.282-1.188V3.566c0-.655-.575-1.188-1.282-1.188H3.847c-.707 0-1.282.533-1.282 1.188v15.868c0 .655.575 1.188 1.282 1.188h16.306c.707 0 1.282-.533 1.282-1.188v-7.095c0-.656.574-1.188 1.282-1.188.71 0 1.283.532 1.283 1.188v7.095C24 21.4 22.274 23 20.153 23\"/>\n                <path d=\"M11.573 18h-.004a1.274 1.274 0 0 1-.883-.356l-5.328-5.181a1.156 1.156 0 0 1 .013-1.686 1.283 1.283 0 0 1 1.76.013l4.447 4.325L24.874 2.35a1.283 1.283 0 0 1 1.76-.002c.487.465.488 1.22.002 1.686L12.454 17.65c-.234.224-.551.35-.881.35\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"#currentColor\" fill-rule=\"evenodd\">\n              <circle cx=\"12\" cy=\"12\" r=\"12\" fill=\"#D7DD1A\"/>\n              <path stroke=\"#2A2264\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M17 9l-6.483 6L8 12.67\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#292663\" d=\"M14 1.4L12.6 0 7 5.6 1.4 0 0 1.4 5.6 7 0 12.6 1.4 14 7 8.4l5.6 5.6 1.4-1.4L8.4 7z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <rect width=\"50\" height=\"30\" fill=\"#FFF\" rx=\"3\"/>\n                <g fill=\"#1A1919\">\n                    <path d=\"M9.774 17.992c0-.604-.315-.564-.617-.57v-.175c.262.013.53.013.792.013.282 0 .664-.013 1.16-.013 1.738 0 2.685 1.16 2.685 2.348 0 .665-.39 2.336-2.765 2.336-.342 0-.658-.014-.973-.014-.302 0-.597.007-.899.014v-.175c.402-.04.597-.054.617-.51v-3.254zm.658 3.146c0 .517.369.577.698.577 1.45 0 1.925-1.093 1.925-2.093 0-1.254-.805-2.16-2.1-2.16-.276 0-.402.02-.523.027v3.65zM14.029 21.756h.127c.188 0 .322 0 .322-.222v-1.818c0-.295-.1-.336-.349-.47v-.107c.315-.094.691-.221.718-.241a.237.237 0 0 1 .121-.034c.033 0 .047.04.047.094v2.576c0 .222.148.222.336.222h.113v.175c-.228 0-.463-.014-.704-.014-.241 0-.483.007-.731.014v-.175zm.718-3.925a.344.344 0 0 1-.33-.336c0-.168.162-.322.33-.322.174 0 .329.141.329.322a.335.335 0 0 1-.33.336zM16.102 19.756c0-.248-.074-.315-.389-.442v-.128c.288-.094.563-.181.886-.322.02 0 .04.013.04.067v.436c.382-.275.711-.503 1.161-.503.57 0 .771.416.771.94v1.73c0 .222.148.222.336.222h.121v.175c-.236 0-.47-.014-.711-.014-.242 0-.484.007-.725.014v-.175h.12c.189 0 .322 0 .322-.222v-1.737c0-.383-.234-.57-.616-.57-.215 0-.558.174-.78.322v1.985c0 .222.149.222.337.222h.12v.175c-.235 0-.47-.014-.712-.014-.24 0-.482.007-.724.014v-.175h.121c.188 0 .322 0 .322-.222v-1.778M19.538 20.079c-.014.06-.014.16 0 .389.04.637.45 1.16.986 1.16.37 0 .658-.201.906-.449l.094.094c-.309.41-.691.759-1.241.759-1.067 0-1.282-1.034-1.282-1.464 0-1.315.886-1.704 1.355-1.704.544 0 1.128.342 1.134 1.053 0 .041 0 .081-.006.121l-.06.04h-1.886zm1.188-.215c.168 0 .187-.087.187-.168 0-.342-.208-.617-.584-.617-.409 0-.69.301-.771.785h1.168zM21.645 21.756h.181c.187 0 .322 0 .322-.222V19.65c0-.208-.248-.248-.35-.302v-.1c.49-.209.76-.383.82-.383.04 0 .06.02.06.087v.604h.014c.167-.261.45-.691.859-.691.167 0 .382.114.382.355 0 .182-.127.343-.315.343-.208 0-.208-.161-.444-.161-.113 0-.49.154-.49.557v1.576c0 .222.135.222.323.222h.375v.175c-.369-.007-.65-.014-.939-.014-.275 0-.557.007-.798.014v-.175M24.228 20.998c.087.442.355.819.846.819.395 0 .543-.242.543-.477 0-.792-1.463-.537-1.463-1.617 0-.376.303-.86 1.04-.86.215 0 .504.062.765.196l.047.684h-.154c-.067-.423-.302-.664-.732-.664-.268 0-.523.154-.523.443 0 .785 1.557.543 1.557 1.597 0 .442-.356.913-1.154.913-.269 0-.584-.095-.819-.229l-.074-.772.121-.033M32.213 18.461h-.168c-.127-.784-.684-1.1-1.435-1.1-.773 0-1.893.516-1.893 2.127 0 1.356.966 2.329 2 2.329.663 0 1.215-.457 1.349-1.162l.154.04-.154.98c-.282.175-1.04.357-1.484.357-1.57 0-2.562-1.014-2.562-2.524 0-1.376 1.227-2.362 2.543-2.362.543 0 1.066.175 1.583.356l.067.96M32.455 21.756h.127c.188 0 .322 0 .322-.222v-3.736c0-.437-.1-.45-.355-.524v-.108c.268-.087.55-.207.691-.288.073-.04.127-.074.147-.074.041 0 .054.04.054.094v4.636c0 .222.148.222.336.222h.113v.175c-.227 0-.462-.014-.704-.014-.241 0-.482.007-.731.014v-.175M36.763 21.561c0 .121.074.128.187.128.081 0 .182-.007.27-.007v.142c-.29.026-.84.167-.967.208l-.034-.02v-.544c-.402.328-.711.564-1.188.564-.362 0-.738-.236-.738-.799v-1.718c0-.175-.027-.343-.402-.376v-.127c.242-.007.778-.047.865-.047.075 0 .075.047.075.194v1.732c0 .201 0 .777.583.777.228 0 .53-.174.812-.408v-1.806c0-.134-.322-.207-.563-.274v-.12c.603-.042.979-.095 1.046-.095.054 0 .054.047.054.12v2.476M38.098 19.347c.268-.228.63-.483 1-.483.778 0 1.248.678 1.248 1.41 0 .878-.644 1.758-1.604 1.758-.496 0-.758-.162-.933-.236l-.2.155-.141-.074c.06-.396.094-.785.094-1.194v-2.885c0-.437-.101-.45-.356-.524v-.108c.268-.087.55-.207.69-.288.075-.04.128-.074.149-.074.04 0 .053.04.053.094v2.449zm0 1.825c0 .255.242.685.691.685.718 0 1.02-.705 1.02-1.302 0-.725-.55-1.329-1.073-1.329-.25 0-.457.162-.638.316v1.63zM9.15 25.832h.05c.132 0 .271-.018.271-.208v-1.913c0-.19-.139-.208-.27-.208H9.15v-.11c.142 0 .361.015.54.015.183 0 .402-.015.573-.015v.11h-.051c-.131 0-.27.018-.27.208v1.913c0 .19.139.208.27.208h.051v.11c-.175 0-.394-.014-.576-.014-.18 0-.395.014-.537.014v-.11\"/>\n                    <path d=\"M10.263 25.958c-.176 0-.395-.015-.577-.015-.178 0-.393.015-.536.015h-.016v-.142H9.2c.132-.003.253-.013.254-.192v-1.913c-.001-.178-.122-.19-.254-.192h-.067v-.142h.016c.143 0 .362.015.54.015.182 0 .4-.015.573-.015h.017v.142h-.068c-.132.002-.253.014-.254.192v1.913c0 .179.122.19.254.192h.068v.142h-.017zm-.015-.032v-.077h-.036c-.13 0-.285-.023-.286-.225v-1.913c0-.201.156-.224.286-.224h.036v-.078c-.169 0-.38.015-.558.015-.173 0-.383-.014-.524-.015v.078H9.2c.13 0 .285.023.285.224v1.913c0 .202-.155.225-.285.225h-.035v.077c.141 0 .347-.014.52-.014.178 0 .39.013.562.014zM12.772 25.222l.007-.007v-1.369c0-.3-.208-.343-.318-.343h-.08v-.11c.172 0 .34.015.51.015.15 0 .3-.015.45-.015v.11h-.054c-.154 0-.326.029-.326.464v1.66c0 .129.004.256.022.37h-.139l-1.88-2.096v1.504c0 .318.062.427.343.427h.062v.11c-.157 0-.314-.014-.47-.014-.165 0-.333.014-.497.014v-.11h.05c.253 0 .33-.171.33-.463v-1.538a.328.328 0 0 0-.333-.328h-.047v-.11c.138 0 .28.015.42.015.11 0 .215-.015.324-.015l1.626 1.83\"/>\n                    <path d=\"M12.983 26.012l-.15-.005-1.854-2.065v1.463c.005.318.053.408.328.411h.078v.142h-.016c-.158 0-.315-.015-.47-.015-.164 0-.332.015-.497.015h-.017v-.142h.068c.241-.001.31-.156.313-.447v-1.537a.312.312 0 0 0-.317-.313h-.064v-.142h.017c.14 0 .282.015.419.015.109 0 .214-.015.337-.009l1.605 1.806v-1.343c-.002-.29-.196-.325-.302-.327h-.096v-.142h.016c.172 0 .34.015.51.015.15 0 .3-.015.45-.015h.016v.142h-.07c-.151.004-.306.017-.31.448v1.66c0 .129.004.256.021.367l.004.018h-.02zm-.139-.032h.121a2.459 2.459 0 0 1-.02-.352v-1.661c0-.439.184-.48.342-.48h.038v-.078c-.144.001-.288.014-.433.014-.167 0-.33-.013-.495-.014v.078h.064c.112 0 .334.05.334.36l-.005 1.38-.007.007-.013.011-1.624-1.836c-.108 0-.214.014-.325.014-.134 0-.27-.013-.403-.014l-.001.078h.032c.172 0 .348.13.348.345v1.537c0 .292-.081.479-.344.48l-.035-.001v.078c.158 0 .32-.014.48-.014.153 0 .305.013.455.014v-.077h-.046c-.287-.001-.358-.126-.359-.444V23.86l1.896 2.12zm-.072-.758l.011-.01-.011.01zm-.009-.007v-.001l-.003-.003.003.004zM13.888 23.576c-.274 0-.285.066-.34.332h-.109c.014-.102.032-.204.044-.31.014-.103.022-.205.022-.31h.087c.03.11.12.105.22.105h1.883c.1 0 .19-.003.198-.113l.087.015c-.014.098-.029.197-.04.296-.007.098-.007.197-.007.295l-.11.04c-.007-.134-.025-.35-.27-.35h-.599v1.942c0 .282.128.314.303.314h.07v.11c-.142 0-.398-.014-.595-.014-.22 0-.475.014-.618.014v-.11h.07c.201 0 .303-.018.303-.306v-1.95h-.599\"/>\n                    <path d=\"M15.327 25.958c-.144 0-.399-.015-.595-.015-.219 0-.474.015-.618.015H14.1v-.142h.085c.201-.004.282-.007.287-.29V23.59h-.583v-.031h.614v1.966c0 .293-.118.323-.318.323h-.054v.077c.144 0 .39-.014.602-.014.19 0 .434.013.579.014v-.077h-.054c-.176 0-.318-.044-.318-.33v-1.96h.614c.245.001.278.21.285.345l.08-.029c0-.095 0-.19.006-.286.011-.095.024-.188.038-.281l-.055-.01c-.017.107-.12.113-.212.111h-1.902c-.086 0-.18-.004-.212-.106h-.06c-.001.101-.008.2-.022.296-.01.1-.028.197-.04.294h.077c.048-.255.08-.337.352-.333v.031c-.27.006-.264.051-.324.32l-.003.013h-.14l.002-.019c.015-.102.033-.204.044-.31.015-.101.022-.203.022-.307v-.016h.116l.003.011c.024.092.092.093.185.094h1.902c.102-.001.176-.003.182-.098l.001-.017.017.003.103.016-.002.016a8.622 8.622 0 0 0-.04.294c-.007.098-.007.196-.007.295v.011l-.01.004-.13.048v-.021c-.01-.138-.025-.337-.256-.337h-.583v1.927c.004.276.113.295.287.298h.086v.142h-.016M16.097 25.832h.051c.131 0 .27-.018.27-.208v-1.913c0-.19-.139-.208-.27-.208h-.051v-.11c.222 0 .602.015.908.015.308 0 .687-.015.935-.015-.006.157-.003.399.008.56l-.11.028c-.018-.237-.061-.427-.445-.427h-.507v.956h.434c.219 0 .267-.123.288-.32h.11a8.327 8.327 0 0 0 0 .843l-.11.021c-.021-.218-.032-.36-.285-.36h-.437v.85c0 .237.211.237.445.237.438 0 .631-.03.741-.445l.102.025c-.047.194-.091.387-.124.58-.234 0-.654-.013-.982-.013-.329 0-.763.014-.971.014v-.11\"/>\n                    <path d=\"M18.05 25.958c-.234 0-.654-.016-.982-.016-.329 0-.763.016-.971.016h-.016v-.142h.067c.132-.002.252-.013.254-.192v-1.913c-.002-.178-.122-.19-.254-.192h-.067v-.142h.016c.223 0 .602.015.908.015.307 0 .686-.015.935-.015h.016v.017a5.76 5.76 0 0 0 .007.557v.013l-.012.004-.128.033v-.019c-.022-.236-.054-.409-.43-.412h-.492v.924h.419c.21-.002.248-.11.273-.306v-.015h.14v.017a8.638 8.638 0 0 0 0 .842v.013l-.012.003-.128.026v-.018c-.026-.222-.027-.345-.27-.347h-.422v.835c0 .222.192.22.43.222.44-.003.615-.025.725-.434l.004-.015.016.003.117.03-.004.015c-.047.193-.09.386-.124.58l-.002.013h-.013zm-.014-.032c.032-.185.074-.369.119-.553l-.072-.018c-.11.408-.321.445-.752.442-.23 0-.46 0-.462-.253v-.867h.454c.255-.002.281.152.3.36l.078-.017a7.735 7.735 0 0 1 0-.815h-.079c-.02.19-.08.324-.302.321h-.45v-.988h.523c.38-.003.443.193.46.423l.078-.021a6.147 6.147 0 0 1-.007-.531c-.248.001-.618.014-.919.014-.3 0-.669-.013-.892-.014v.078h.035c.13 0 .285.023.286.224v1.913c0 .202-.156.224-.286.225h-.035v.077c.212 0 .634-.014.955-.014.322 0 .733.013.968.014zM18.667 23.78c0-.266-.146-.277-.26-.277h-.065v-.11c.116 0 .343.015.566.015.218 0 .394-.015.587-.015.46 0 .87.124.87.643 0 .328-.22.529-.508.643l.624.934c.103.154.175.198.354.22v.109c-.12 0-.237-.014-.357-.014-.113 0-.23.014-.343.014a10.106 10.106 0 0 1-.76-1.183h-.24v.781c0 .282.13.292.298.292h.066v.11c-.209 0-.42-.014-.628-.014-.175 0-.347.014-.53.014v-.11h.066c.136 0 .26-.062.26-.196V23.78zm.467.847h.179c.365 0 .562-.138.562-.57 0-.324-.208-.532-.533-.532-.11 0-.157.01-.208.014v1.088z\"/>\n                    <path d=\"M20.835 25.958c-.122 0-.238-.015-.358-.015-.111 0-.228.015-.355.008-.28-.367-.52-.76-.756-1.176h-.216v.765c.004.275.114.273.283.276h.082v.142h-.016c-.21 0-.421-.015-.628-.015-.175 0-.346.015-.53.015h-.015v-.142h.081c.132 0 .243-.058.243-.18V23.78c-.002-.259-.13-.258-.243-.261h-.081v-.142h.016c.118 0 .343.015.566.015.218 0 .393-.015.587-.015.46.001.884.128.885.659 0 .329-.217.535-.499.65l.613.918c.102.152.166.19.344.212l.013.002v.14h-.016zm-1.7-1.215h.249l.004.008c.238.42.478.814.747 1.175.11 0 .228-.014.342-.014.116 0 .23.012.342.014v-.08c-.17-.021-.251-.073-.35-.224l-.636-.95.018-.008c.286-.112.497-.307.498-.628 0-.507-.395-.624-.854-.627-.192 0-.367.015-.587.015-.215 0-.431-.014-.55-.015v.078h.05c.113 0 .274.019.274.293v1.856c0 .146-.137.213-.275.213h-.05v.077c.176 0 .342-.014.514-.014.204 0 .41.013.612.014v-.077h-.05c-.166 0-.315-.021-.315-.31v-.796h.016zm0-.1h-.017v-1.118l.014-.001c.05-.004.1-.014.21-.014.332 0 .549.216.549.548-.001.436-.21.585-.578.585h-.179zm.178-.031c.361-.004.543-.13.547-.554-.002-.319-.2-.516-.518-.518-.099 0-.146.01-.192.014v1.058h.163zM23.314 25.222l.007-.007v-1.369c0-.3-.208-.343-.317-.343h-.08v-.11c.171 0 .339.015.51.015.15 0 .3-.015.45-.015v.11h-.055c-.153 0-.325.029-.325.464v1.66c0 .129.004.256.022.37h-.138l-1.88-2.096v1.504c0 .318.061.427.342.427h.062v.11c-.157 0-.314-.014-.47-.014-.166 0-.333.014-.497.014v-.11h.05c.252 0 .33-.171.33-.463v-1.538a.327.327 0 0 0-.333-.328h-.047v-.11c.138 0 .281.015.42.015.108 0 .215-.015.324-.015l1.625 1.83\"/>\n                    <path d=\"M23.526 26.012l-.15-.005-1.854-2.065v1.463c.005.318.053.408.328.411h.078v.142h-.016c-.158 0-.315-.016-.471-.016-.163 0-.332.016-.496.016h-.017v-.142h.067c.242 0 .31-.156.313-.448v-1.537a.311.311 0 0 0-.316-.312h-.064v-.142h.017c.139 0 .282.015.42.015.107 0 .213-.015.335-.01l1.605 1.807v-1.343c0-.29-.195-.326-.301-.327h-.097v-.142h.016c.173 0 .341.015.512.015.148 0 .298-.015.448-.015h.017v.142h-.07c-.152.003-.307.017-.31.448v1.66c0 .129.003.255.022.367l.001.018h-.017zm-.139-.032h.12a2.493 2.493 0 0 1-.02-.352v-1.661c.001-.439.186-.48.342-.48h.039v-.078c-.144.001-.288.014-.433.014-.168 0-.33-.013-.496-.014v.078h.065c.112 0 .333.05.333.36l-.005 1.38-.007.007-.011.012-1.625-1.837c-.108 0-.214.014-.324.014-.136 0-.272-.013-.405-.014v.078h.032c.172 0 .348.13.348.344v1.537c0 .293-.083.48-.345.48h-.035v.078c.158 0 .32-.014.48-.014.154 0 .306.013.456.014v-.077h-.046c-.287 0-.359-.126-.36-.444V23.86l1.897 2.12zm-.073-.758l.012-.01-.012.01zm-.009-.007l-.002-.004.002.004zM24.471 25.42c-.037.124-.08.22-.08.284 0 .11.153.128.273.128h.04v.11a6.596 6.596 0 0 0-.837 0l.001-.11h.023c.142 0 .263-.084.317-.237l.584-1.676c.048-.135.113-.317.136-.453.116-.04.262-.112.332-.157.01-.003.018-.007.029-.007.01 0 .018 0 .026.011l.032.091.672 1.91c.044.127.088.262.134.373.045.102.122.145.242.145h.022v.11a10.377 10.377 0 0 0-1.052 0v-.11h.04c.084 0 .227-.014.227-.106 0-.047-.033-.145-.073-.263l-.143-.423h-.828l-.117.38zm.533-1.618h-.007l-.34 1.034h.682l-.335-1.034z\"/>\n                    <path d=\"M26.416 25.958c-.164-.008-.328-.016-.502-.016-.18 0-.361.008-.548.016h-.017v-.142h.057c.084 0 .21-.02.21-.09 0-.041-.032-.141-.072-.257l-.14-.413H24.6l-.113.369c-.037.124-.081.22-.08.28 0 .089.137.11.258.11h.056v.143h-.016c-.146-.008-.295-.016-.441-.016-.13 0-.263.008-.393.016h-.017v-.142h.037c.136 0 .25-.078.302-.226l.585-1.676c.047-.135.114-.317.145-.463a1.88 1.88 0 0 0 .332-.157c.01-.003.02-.008.035-.008.009 0 .028.002.04.021l.033.092.672 1.91c.043.128.087.263.135.37.042.098.11.136.226.137h.037v.142h-.016zm-1.035-.033c.18-.006.358-.013.533-.013.169 0 .328.007.487.013v-.076h-.006c-.125 0-.21-.049-.256-.156-.047-.11-.092-.246-.135-.374l-.672-1.91-.03-.088c-.004-.003-.004-.003-.007-.003h-.006c-.008 0-.012.002-.022.004-.07.046-.216.118-.325.146-.022.139-.088.321-.135.457l-.584 1.675a.348.348 0 0 1-.333.249h-.006v.076c.126-.006.252-.013.379-.013.14 0 .285.007.425.013v-.076h-.024c-.12-.002-.285-.015-.29-.144 0-.073.046-.166.081-.29l.016.005-.016-.005.12-.39h.852l.146.433c.041.118.074.215.074.268-.005.112-.159.12-.241.123h-.025v.076zm-.746-1.074l.35-1.065h.02v.016l-.005.001h.004v-.017h.011l.347 1.065h-.727zm.044-.031h.639L25 23.84l-.321.979zm.31-1.013l.008-.003-.009.003zM26.578 23.576c-.274 0-.285.066-.34.332h-.11c.015-.102.033-.204.045-.31a2.24 2.24 0 0 0 .02-.31h.09c.028.11.12.105.218.105h1.884c.098 0 .19-.003.197-.113l.087.015c-.014.098-.028.197-.04.296-.008.098-.008.197-.008.295l-.109.04c-.006-.134-.025-.35-.27-.35h-.598v1.942c0 .282.128.314.303.314h.07v.11c-.143 0-.398-.014-.596-.014-.219 0-.475.014-.617.014v-.11h.07c.2 0 .302-.018.302-.306v-1.95h-.598\"/>\n                    <path d=\"M28.016 25.958c-.143 0-.4-.015-.595-.015-.218 0-.474.015-.617.015h-.016v-.142h.085c.202-.004.282-.007.287-.29V23.59h-.582v-.031h.614v1.966c0 .293-.118.322-.319.323h-.054v.077c.145 0 .39-.014.602-.014.19 0 .435.013.579.014v-.077h-.054c-.176-.001-.318-.043-.318-.33v-1.96h.614c.246.001.278.21.285.345l.079-.029c0-.095 0-.19.008-.286.01-.094.024-.188.037-.28l-.055-.01c-.017.106-.12.112-.21.11h-1.904c-.086.001-.18-.004-.212-.106h-.06c0 .101-.008.2-.022.296-.01.101-.028.198-.042.294h.079c.048-.255.08-.337.353-.333v.031c-.271.005-.265.051-.325.32l-.002.013h-.141l.002-.018c.015-.103.033-.205.044-.31.015-.102.022-.204.022-.308v-.016h.116l.003.011c.025.092.092.093.185.094h1.903c.101-.001.175-.003.181-.098v-.017l.018.003.103.016-.002.016a7.43 7.43 0 0 0-.04.294c-.007.098-.007.197-.007.295v.011l-.011.004-.13.048v-.021c-.01-.138-.024-.337-.255-.337h-.583v1.927c.004.276.113.295.287.298h.086v.142h-.016M28.804 25.832h.051c.132 0 .27-.018.27-.208v-1.913c0-.19-.138-.208-.27-.208h-.05v-.11c.142 0 .36.015.539.015.183 0 .402-.015.574-.015v.11h-.051c-.132 0-.271.018-.271.208v1.913c0 .19.139.208.27.208h.052v.11c-.175 0-.395-.014-.577-.014-.18 0-.394.014-.537.014v-.11\"/>\n                    <path d=\"M29.918 25.958c-.176 0-.395-.016-.577-.016-.179 0-.394.016-.537.016h-.016v-.142h.067c.132-.002.253-.013.254-.192v-1.913c0-.178-.122-.19-.254-.192h-.067v-.142h.016c.143 0 .362.015.54.015.182 0 .401-.015.574-.015h.015v.142h-.066c-.134.002-.254.014-.255.192v1.913c.001.179.121.19.255.192h.066v.142h-.015zm-.017-.032v-.077h-.034c-.131 0-.286-.023-.286-.225v-1.913c0-.201.155-.224.286-.224h.034v-.078c-.168.001-.38.014-.557.014-.173 0-.382-.013-.524-.014v.078h.035c.13 0 .286.023.286.224v1.913c0 .202-.156.225-.286.225h-.035v.077c.14-.002.347-.014.521-.014.177 0 .388.013.56.014zM31.374 23.339c.778 0 1.399.482 1.399 1.26 0 .84-.603 1.398-1.38 1.398-.775 0-1.366-.526-1.366-1.311 0-.76.588-1.347 1.347-1.347m.055 2.497c.709 0 .832-.625.832-1.157 0-.534-.288-1.18-.894-1.18-.639 0-.829.57-.829 1.059 0 .653.3 1.278.891 1.278\"/>\n                    <path d=\"M30.01 24.686a1.346 1.346 0 0 1 1.364-1.363v.032c-.75 0-1.331.58-1.332 1.33.001.777.584 1.295 1.35 1.295.77 0 1.364-.55 1.365-1.382 0-.768-.611-1.243-1.383-1.243v-.032c.784 0 1.413.488 1.414 1.275 0 .849-.61 1.413-1.395 1.414-.781-.001-1.38-.532-1.382-1.326m.511-.128c.001-.492.193-1.075.845-1.075.62.001.909.66.91 1.196-.001.532-.126 1.172-.848 1.172v-.031c.694 0 .815-.609.816-1.141 0-.53-.285-1.163-.878-1.164-.627 0-.812.556-.813 1.043 0 .65.297 1.261.875 1.262v.031c-.606 0-.906-.636-.907-1.293M35.233 25.222l.008-.007v-1.369c0-.3-.21-.343-.319-.343h-.08v-.11c.172 0 .34.015.511.015.15 0 .3-.015.45-.015v.11h-.055c-.153 0-.325.029-.325.464v1.66c0 .129.004.256.022.37h-.139l-1.88-2.096v1.504c0 .318.062.427.342.427h.063v.11c-.157 0-.314-.014-.47-.014-.165 0-.333.014-.498.014v-.11h.052c.252 0 .328-.171.328-.463v-1.538a.327.327 0 0 0-.332-.328h-.048v-.11c.14 0 .281.015.42.015.11 0 .215-.015.325-.015l1.625 1.83\"/>\n                    <path d=\"M35.445 26.012l-.15-.005-1.854-2.065v1.463c.005.318.053.408.327.41h.079v.143h-.016c-.158 0-.315-.015-.47-.015-.164 0-.333.015-.498.015h-.015v-.142h.066c.241-.001.31-.156.313-.447v-1.538a.311.311 0 0 0-.316-.312h-.063v-.142h.015c.14 0 .282.015.42.015.109 0 .213-.015.337-.009l1.605 1.806v-1.343c-.002-.29-.196-.325-.303-.327h-.096v-.142h.017c.171 0 .34.015.51.015.15 0 .298-.015.45-.015h.015v.142h-.07c-.15.004-.306.017-.309.448v1.66c0 .129.003.256.02.367l.004.018h-.018zm-.139-.032h.12a2.585 2.585 0 0 1-.02-.352v-1.661c0-.44.185-.48.342-.48h.04v-.078c-.146.001-.29.014-.435.014-.166 0-.33-.013-.495-.014v.078h.064c.113 0 .334.05.334.36l-.004 1.38-.007.007-.012.012-1.625-1.837c-.108 0-.214.014-.325.014-.134 0-.272-.013-.404-.014v.078h.032c.171 0 .348.13.348.344v1.538c0 .292-.082.479-.345.48h-.035v.077c.158 0 .32-.014.481-.014.152 0 .304.013.455.014v-.077h-.047c-.286 0-.358-.126-.358-.444V23.86l1.896 2.12zm-.073-.758l.012-.01-.012.01zm-.008-.007l-.003-.004.003.004zM36.39 25.42c-.036.124-.08.22-.08.284 0 .11.153.128.273.128h.04v.11a6.553 6.553 0 0 0-.836 0l.001-.11h.02c.144 0 .265-.084.318-.237l.586-1.676c.047-.135.113-.317.134-.453.117-.04.263-.112.333-.157.01-.003.018-.007.03-.007.01 0 .017 0 .024.011l.033.091.672 1.91c.043.127.088.262.135.373.044.102.12.145.241.145h.023v.11a10.382 10.382 0 0 0-1.053 0v-.11h.04c.084 0 .227-.014.227-.106 0-.047-.032-.145-.073-.263l-.142-.423h-.83l-.117.38zm.533-1.618h-.007l-.34 1.034h.683l-.336-1.034z\"/>\n                    <path d=\"M38.335 25.958c-.165-.007-.329-.015-.503-.015-.178 0-.36.008-.547.015h-.016v-.142h.055c.085 0 .211-.02.211-.09a1.136 1.136 0 0 0-.073-.257l-.138-.413h-.806l-.113.369c-.037.125-.08.22-.08.28 0 .089.137.111.258.111h.056v.142h-.017c-.145-.007-.295-.015-.44-.015-.131 0-.262.008-.394.015h-.016v-.142h.037c.136 0 .25-.078.303-.226l.584-1.676c.047-.135.113-.317.145-.462.115-.04.261-.113.332-.158.01-.003.02-.008.035-.008.01 0 .029.002.04.022l.033.091.672 1.91c.044.128.087.263.135.371.043.097.109.135.226.136h.037v.142h-.016zm-1.035-.033c.18-.006.358-.013.532-.013.17 0 .329.007.488.013v-.076h-.006c-.124 0-.21-.049-.256-.156-.048-.11-.091-.246-.135-.374l-.672-1.91a3.612 3.612 0 0 1-.03-.087c-.004-.004-.004-.004-.006-.004h-.007c-.008 0-.012.002-.02.005a1.402 1.402 0 0 1-.326.145c-.023.139-.089.321-.136.457l-.585 1.675a.347.347 0 0 1-.332.249h-.006v.076c.126-.006.252-.013.379-.013.141 0 .285.007.426.013v-.076h-.025c-.119-.002-.285-.015-.29-.145.001-.072.046-.165.082-.289l.014.005-.014-.005.12-.39h.851l.147.433c.04.118.073.215.073.268-.005.112-.159.12-.242.123H37.3v.076zm-.746-1.074l.35-1.065h.02v.016l-.005.001h.004v-.017h.011l.346 1.065h-.726zm.044-.031h.639l-.318-.978-.321.978zm.31-1.013l.007-.003-.007.003zM39.256 25.584c0 .147.102.19.219.205.15.011.314.011.482-.008a.52.52 0 0 0 .35-.197.838.838 0 0 0 .114-.263h.105c-.04.208-.091.413-.135.62-.32 0-.643-.013-.964-.013-.321 0-.642.014-.963.014v-.11h.05c.132 0 .275-.018.275-.244V23.71c0-.19-.143-.208-.275-.208h-.05v-.11c.193 0 .383.015.576.015.187 0 .369-.015.556-.015v.11h-.092c-.139 0-.248.004-.248.197v1.884\"/>\n                    <path d=\"M40.391 25.958c-.322 0-.643-.015-.964-.015-.32 0-.642.015-.964.015h-.015v-.142h.066c.132-.003.257-.012.259-.228V23.71c-.002-.178-.126-.19-.259-.192h-.066v-.142h.015c.194 0 .384.015.577.015.186 0 .368-.015.556-.015h.014v.142h-.106c-.142.003-.23-.003-.233.181v1.884c.001.136.09.173.205.19a2.961 2.961 0 0 0 .478-.008.51.51 0 0 0 .34-.19.822.822 0 0 0 .11-.258l.004-.013h.137l-.003.02c-.041.208-.091.412-.136.62l-.003.013h-.012zm-.013-.032c.042-.198.09-.392.13-.59h-.076a.826.826 0 0 1-.112.258.542.542 0 0 1-.362.203 2.803 2.803 0 0 1-.485.007c-.12-.013-.234-.064-.234-.22V23.7c0-.203.129-.213.265-.213h.075v-.078c-.18.001-.357.015-.54.015-.188 0-.373-.014-.56-.015v.078h.035c.13 0 .29.023.29.224v1.877c0 .236-.159.26-.29.26h-.035v.078c.316 0 .631-.014.948-.014.318 0 .635.013.95.014zM40.482 23.29c.22 0 .384.169.384.385a.376.376 0 0 1-.384.383.377.377 0 0 1-.385-.383c0-.216.165-.385.385-.385zm0 .697a.31.31 0 0 0 .304-.312.31.31 0 0 0-.304-.313.31.31 0 0 0-.305.313.31.31 0 0 0 .305.312zm-.192-.11v-.018c.047-.007.056-.005.056-.034v-.285c0-.04-.004-.054-.054-.052v-.02h.197c.067 0 .13.033.13.103 0 .057-.038.1-.091.116l.063.088c.03.04.063.077.085.09v.013H40.6c-.036 0-.068-.076-.138-.177h-.043v.127c0 .026.009.024.056.031v.019h-.186zm.13-.202h.045c.05 0 .073-.037.073-.098 0-.061-.035-.083-.075-.083h-.043v.181z\"/>\n                </g>\n                <path fill=\"#FFFFFE\" d=\"M17.677 10.503a6.184 6.184 0 1 1 12.367 0 6.184 6.184 0 0 1-12.367 0\"/>\n                <path fill=\"#0069AA\" d=\"M27.6 10.382a3.72 3.72 0 0 0-2.387-3.47v6.938a3.72 3.72 0 0 0 2.387-3.468zm-5.048 3.467V6.913a3.723 3.723 0 0 0-2.385 3.469 3.722 3.722 0 0 0 2.385 3.467zm1.331-9.331a5.864 5.864 0 0 0 0 11.726 5.864 5.864 0 0 0 0-11.726zm-.014 12.28c-3.544.016-6.46-2.855-6.46-6.35 0-3.819 2.916-6.46 6.46-6.46h1.66c3.503 0 6.699 2.64 6.699 6.46 0 3.494-3.196 6.35-6.698 6.35h-1.66z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:'<path fill="none" fill-rule="evenodd" stroke-linecap="round" stroke="currentColor" stroke-linejoin="round" stroke-width="2" d="M1 1.055L5.972 6 11 1"/>'};module.exports=exports['default'];

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill-rule=\"evenodd\">\n                <path fill-rule=\"nonzero\" d=\"M71.068 80.388h-41.65a8.909 8.909 0 0 1-8.933-8.932v-41.65a8.909 8.909 0 0 1 8.932-8.932h21.845c1.65 0 3.01 1.359 3.01 3.01 0 1.65-1.36 3.01-3.01 3.01H29.417c-1.65 0-3.01 1.358-3.01 3.009v41.65c0 1.65 1.36 3.01 3.01 3.01h41.651c1.65 0 3.01-1.36 3.01-3.01V49.515c0-1.65 1.359-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01v21.941c-.098 4.855-4.176 8.932-9.03 8.932z\"/>\n                <path fill-rule=\"nonzero\" d=\"M46.699 65.34h-8.447c-1.65 0-3.01-1.36-3.01-3.01v-8.447c0-.776.292-1.553.875-2.135L68.544 19.32a8.883 8.883 0 0 1 6.31-2.621c2.428 0 4.66.97 6.311 2.621a8.883 8.883 0 0 1 2.621 6.311c0 2.427-.97 4.66-2.621 6.31L48.738 64.37c-.486.68-1.262.97-2.039.97zm-5.437-5.923h4.175L76.99 27.864c.583-.582.874-1.262.874-2.136 0-.777-.291-1.553-.874-2.136-.582-.582-1.262-.874-2.136-.874-.776 0-1.553.292-2.136.874L41.165 55.146v4.271h.097z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M49.903 79.417c-8.932 0-17.476-2.815-24.66-8.058a39.842 39.842 0 0 1-9.03-9.029c-2.62-3.495-4.563-7.281-5.922-11.456a3.042 3.042 0 0 1 1.845-3.787 3.042 3.042 0 0 1 3.786 1.845c1.165 3.495 2.913 6.796 5.146 9.806a34.263 34.263 0 0 0 7.767 7.67A35.822 35.822 0 0 0 50 73.3c7.67 0 14.951-2.427 21.165-6.893a32.777 32.777 0 0 0 7.767-7.767c2.233-3.01 3.884-6.31 5.146-9.806.485-1.553 2.233-2.427 3.786-1.845 1.553.486 2.427 2.233 1.845 3.787-1.36 4.077-3.398 7.96-5.923 11.456-2.524 3.495-5.63 6.505-9.029 9.03-7.281 5.436-15.825 8.154-24.854 8.154z\"/>\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M13.107 53.01c-.291 0-.583-.097-.971-.194-1.553-.486-2.427-2.233-1.845-3.787 1.36-4.078 3.398-7.961 5.923-11.456 2.524-3.495 5.63-6.505 9.029-9.03 7.184-5.242 15.728-8.058 24.66-8.058s17.476 2.816 24.66 8.059a39.842 39.842 0 0 1 9.03 9.029c2.62 3.495 4.562 7.281 5.922 11.456a3.042 3.042 0 0 1-1.845 3.787 3.042 3.042 0 0 1-3.787-1.845c-1.165-3.495-2.912-6.796-5.145-9.806a34.263 34.263 0 0 0-7.767-7.67 35.822 35.822 0 0 0-21.165-6.893c-7.67 0-14.952 2.427-21.165 6.893a32.777 32.777 0 0 0-7.767 7.767c-2.233 3.01-3.884 6.31-5.146 9.806-.194 1.165-1.36 1.942-2.621 1.942z\"/>\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M50 70c-11.068 0-20.097-9.03-20.097-20.097 0-11.068 9.029-20.097 20.097-20.097 11.068 0 20.097 9.029 20.097 20.097C70 60.97 61.068 70 50 70zm0-34.175c-7.767 0-14.078 6.31-14.078 14.078 0 7.767 6.311 14.078 14.078 14.078 7.767 0 14.078-6.311 14.078-14.078 0-7.767-6.311-14.078-14.078-14.078z\"/>\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M42.913 53.01c-1.65 0-3.01-1.36-3.01-3.01 0-5.534 4.466-10 10-10 1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.36 3.01-3.01 3.01-2.233 0-4.078 1.844-4.078 4.077 0 1.65-1.262 2.913-2.912 2.913z\"/>\n                <path d=\"M.388.388h99.029v99.029H.388z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#5B5983\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\">\n                <path d=\"M1 1l5.657 5.657M1 6.657L6.657 1\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g>\n                <path fill=\"#b7c203\"  d=\"M3,28.5c-0.3,0-0.5,0-0.8-0.1c-1.6-0.4-2.5-2-2.2-3.7c1.9-7,6.2-13.3,12-17.8c2.9-2.2,6.2-4,9.6-5.1\n                    C25.3,0.6,29,0,32.8,0c3.8,0,7.5,0.6,11.2,1.8C47.4,3,50.7,4.8,53.6,7c2.8,2.2,5.4,4.9,7.4,7.9c2.1,3,3.6,6.4,4.6,9.9\n                    c0.4,1.6-0.5,3.2-2.2,3.7c-1.6,0.4-3.3-0.5-3.7-2.1c-1.6-5.7-5.1-10.9-9.9-14.6C44.9,8,38.9,5.9,32.7,5.9c-6.3,0-12.2,2-17.2,5.8\n                    c-4.8,3.7-8.2,8.8-9.8,14.7C5.6,27.7,4.4,28.5,3,28.5L3,28.5z M32.9,67.2c-15.4,0-28.9-10.3-32.8-25c-0.4-1.6,0.5-3.2,2.2-3.6\n                    c1.6-0.4,3.2,0.5,3.6,2.1c3.2,12.1,14.3,20.6,27,20.6s23.8-8.4,27-20.6c0.4-1.6,2.1-2.5,3.6-2.1c1.6,0.4,2.6,2,2.2,3.6\n                    C61.9,56.9,48.3,67.2,32.9,67.2z\"/>\n                <path  fill=\"#b7c203\"  d=\"M25.7,47.5l-9.8-10.9c-1.1-1.3-1-3.2,0.2-4.3c1.3-1.1,3.2-1,4.3,0.2l0,0l7.6,8.5l17-15.5\n                    c1.2-1.2,3.1-1.2,4.3,0c1.2,1.2,1.2,3.1,0,4.3l0,0L30.1,47.6c-0.6,0.6-1.3,0.9-2.1,0.9C27.1,48.4,26.3,48.1,25.7,47.5L25.7,47.5z\"\n                    />\n                <path fill=\"none\" d=\"M-17.4-16.1h100v99h-100V-16.1z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M53.806 67.01c-1.65 0-3.01-1.36-3.01-3.01V9.728c0-1.65-1.36-3.01-3.01-3.01H20.02c-1.65 0-3.01 1.36-3.01 3.01V64c0 1.65-1.359 3.01-3.009 3.01s-3.01-1.36-3.01-3.01V9.728A8.909 8.909 0 0 1 19.922.796H47.69a8.909 8.909 0 0 1 8.932 8.932V64c.195 1.65-1.165 3.01-2.815 3.01z\"/>\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M64.777 68.175H3.223c-1.65 0-3.01-1.36-3.01-3.01 0-1.65 1.36-3.01 3.01-3.01h61.554c1.65 0 3.01 1.36 3.01 3.01-.098 1.65-1.457 3.01-3.01 3.01zM43.709 32.447H23.806c-1.65 0-3.01-1.36-3.01-3.01 0-1.65 1.36-3.01 3.01-3.01h20c1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.457 3.01-3.107 3.01zM58.757 56.33H54c-1.65 0-3.01-1.36-3.01-3.01 0-1.65 1.36-3.01 3.01-3.01h4.757c1.65 0 3.01-1.359 3.01-3.009V22.835l-4.175-4.175H54c-1.65 0-3.01-1.359-3.01-3.01 0-1.65 1.36-3.01 3.01-3.01h4.757c.777 0 1.554.292 2.136.875l5.923 5.922c.582.582.873 1.36.873 2.136v25.825a8.909 8.909 0 0 1-8.932 8.932z\"/>\n                <path d=\"M-15.806-15.126h99.029v99.029h-99.029z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <g fill=\"#201A5B\" fill-rule=\"nonzero\">\n                    <path d=\"M50.194 83.786c-1.65 0-3.01-1.359-3.01-3.01V61.069c0-1.65 1.36-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01v19.709c-.097 1.65-1.36 3.01-3.01 3.01z\"/>\n                    <path d=\"M70.68 83.98H29.806c-4.078 0-7.476-3.3-7.476-7.475v-26.31c0-1.651 1.36-3.01 3.01-3.01 1.65 0 3.01 1.359 3.01 3.01v26.31c0 .777.68 1.456 1.456 1.456H70.68c.776 0 1.456-.68 1.456-1.456v-26.31c0-1.651 1.36-3.01 3.01-3.01 1.65 0 3.01 1.359 3.01 3.01v26.31c0 4.175-3.399 7.476-7.476 7.476z\"/>\n                </g>\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M75.049 53.204H25.534a8.909 8.909 0 0 1-8.932-8.932V35.34a8.909 8.909 0 0 1 8.932-8.932h49.515a8.909 8.909 0 0 1 8.932 8.932v8.932a8.909 8.909 0 0 1-8.932 8.932zM25.534 32.33c-1.65 0-3.01 1.36-3.01 3.01v8.932c0 1.65 1.36 3.01 3.01 3.01h49.515c1.65 0 3.01-1.36 3.01-3.01V35.34c0-1.65-1.36-3.01-3.01-3.01H25.534z\"/>\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M50.194 53.204c-1.65 0-3.01-1.36-3.01-3.01V29.32c0-1.65 1.36-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01v20.874c-.097 1.65-1.36 3.01-3.01 3.01z\"/>\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M50.194 32.33c-1.65 0-3.01-1.36-3.01-3.01 0-3.883-3.203-7.087-7.087-7.087-3.883 0-7.087 3.204-7.087 7.087 0 1.65-1.36 3.01-3.01 3.01-1.65 0-3.01-1.36-3.01-3.01 0-7.184 5.826-13.01 13.01-13.01s13.01 5.826 13.01 13.01a2.809 2.809 0 0 1-2.816 3.01z\"/>\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M70.388 32.427c-1.65 0-3.01-1.359-3.01-3.01 0-3.883-3.203-7.087-7.087-7.087-3.883 0-7.087 3.204-7.087 7.087 0 1.651-1.36 3.01-3.01 3.01-1.65 0-3.01-1.359-3.01-3.01 0-7.184 5.826-13.01 13.01-13.01 7.185 0 13.01 5.826 13.01 13.01.097 1.651-1.262 3.01-2.816 3.01z\"/>\n                <path d=\"M.583.583h99.029v99.029H.583z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"\n        <g fill=\"none\" fill-rule=\"evenodd\">\n            <g transform=\"translate(2 2)\">\n                <rect fill=\"#D6DE26\" id=\"a\" width=\"16\" height=\"16\" rx=\"8\"/>\n                <rect width=\"18\" height=\"18\" x=\"-1\" y=\"-1\" stroke=\"#28C4D4\" stroke-width=\"2\" rx=\"9\"/>\n            </g>\n            <path stroke=\"#6C9807\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13 8l-4.322 4.286L7 10.622\"/>\n        </g>\n    "};module.exports=exports["default"];

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#FFD300\" fill-rule=\"evenodd\" d=\"M3.442 42.558c-.844-1.943-1.69-4.139-2.28-6.335-.085-.338-.17-.676-.17-.93-.084-.337-.168-.76-.168-1.097-.085-.423-.085-.76-.17-1.183-.084-.422-.084-.76-.084-1.098 0-.253 0-.591-.084-.845 0-.253-.085-.591-.085-.844-.422-3.38-.76-7.011.338-10.221.254-.592.507-1.267 1.183-1.52.507-.17 1.183 0 1.52-.423.17-.169.254-.338.338-.507.254-.422.592-1.013 1.014-1.351.422-.338.76-.254 1.267-.423.76-.253 1.183-.844 1.352-1.605.338-1.605-.338-3.378-.591-4.983-.085-.338-.085-.676-.17-1.014-.084-.338-.084-.676-.084-1.098 0-.422-.084-.76-.084-1.267v-.76-.845-.93-.844-.76c0-.254 0-.422.084-.591.085-.338.17-.676.422-.845.17-.169.507-.338.845-.169.17.084.338.253.423.422.084.17.253.338.338.592.084.253.253.422.337.675.085.254.17.507.338.76l.254.76c.084.254.169.508.169.761.084.253.084.507.169.676.084.422.169.844.253 1.182.085.338.17.76.17 1.098.084.338.168.676.168 1.014.085.338.169.676.169 1.014.253 1.182.422 2.365.591 3.547.085.592.254 1.183.423 1.774.084.254.169.592.169.845 0 .169.084.338.169.422.422.592.507-.253.591-.506.084-.592.169-1.183.253-1.69.17-1.098.254-2.196.338-3.21.085-.591.085-1.267.17-1.858 0-.338.084-.591.084-.93 0-.337.084-.675.084-.928 0-.338.085-.676.17-1.014.084-.338.084-.676.168-1.014.085-.337.085-.59.17-.929.084-.253.084-.507.168-.676.085-.337.169-.675.338-.929.169-.253.338-.507.591-.675.17-.085.338-.254.592-.17.253 0 .422.17.591.338.169.17.253.423.338.676.084.254.169.592.253.845.085.253.085.591.17.845 0 .338.084.59.084.929 0 .338 0 .591.084.844v2.62c0 2.11-.338 4.307-.507 6.419-.084.76-.253 1.774-.338 2.618 0 .254 0 .592.085.845 0 .253.169.422.338.676.169.253.422.422.676.591l.76.507c.253.169.507.338.676.422.253.17.422.338.591.591.17.17.254.423.338.676.085.254.085.507.085.76 0 .338.084.592.084.93V26.424c0 .338 0 .676-.084 1.014 0 .338-.085.591-.17.93-.422 1.604-1.267 3.21-1.858 4.898-1.098 3.464-1.858 7.011-1.69 10.728 0 .76.254 1.774 0 2.45-.337.76-1.351 1.351-1.942 1.858-.93.676-1.859 1.352-3.042 1.52-1.69.254-3.294-.675-4.646-1.689-1.605-1.52-2.45-4.054-3.126-5.575z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"#292663\" fill-rule=\"evenodd\">\n                <path d=\"M21.118 1.769H.874A.871.871 0 0 1 0 .901C0 .42.391.032.874.032h20.244c.483 0 .874.389.874.869s-.391.868-.874.868M.874 8.206A.871.871 0 0 1 0 7.338c0-.48.391-.869.874-.869h16.362c.482 0 .874.39.874.869 0 .48-.392.868-.874.868H.874zM10.054 14.637H.874A.871.871 0 0 1 0 13.768c0-.48.391-.868.874-.868h9.18c.482 0 .873.389.873.868 0 .48-.39.869-.873.869\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill-rule=\"evenodd\">\n                <path fill-rule=\"nonzero\" d=\"M28.4 84.2c-2.4 0-4.8-.9-6.6-2.7-3.7-3.7-3.7-9.6 0-13.3L38.9 51c-4.1-6.1-3.4-14.5 2-19.9L51 21c3-3 6.9-4.6 11.1-4.6h.1c4.2 0 8.1 1.6 11 4.6 1.2 1.2 1.2 3.1 0 4.3L58.9 39.6c-.6.6-1 1.4-1 2.3 0 .9.3 1.7 1 2.3.6.6 1.4 1 2.3 1 .9 0 1.7-.3 2.3-1L77.8 30c1.2-1.2 3.1-1.2 4.3 0 3 3 4.6 6.9 4.6 11.1 0 4.2-1.6 8.2-4.6 11.1L72 62.3c-6.1 6.1-16.1 6.1-22.3 0-1.2-1.2-1.2-3.1 0-4.3 1.2-1.2 3.1-1.2 4.3 0 1.8 1.8 4.2 2.8 6.8 2.8 2.6 0 5-1 6.8-2.8l10.1-10.1c1.8-1.8 2.8-4.2 2.8-6.8 0-1.5-.3-3-1-4.3L67.7 48.5c-1.8 1.8-4.1 2.7-6.6 2.7s-4.9-1-6.6-2.7c-1.8-1.8-2.7-4.1-2.7-6.6s1-4.9 2.7-6.6l11.7-11.8c-1.3-.6-2.7-1-4.2-1-2.6 0-5 1-6.8 2.8L45.1 35.4c-1.8 1.8-2.8 4.2-2.8 6.8 0 2.6 1 5 2.8 6.8 1.2 1.2 1.2 3.1 0 4.3l-19 19.1c-1.3 1.3-1.3 3.4 0 4.6 1.3 1.3 3.4 1.3 4.6 0l11.1-11.2c1.2-1.2 3.1-1.2 4.3 0 1.2 1.2 1.2 3.1 0 4.3L35 81.3c-1.8 2-4.2 2.9-6.6 2.9z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n    <g fill=\"#B1B0C5\" fill-rule=\"nonzero\">\n        <path d=\"M4.894 10.928c-.07 0-.118 0-.188-.023a.732.732 0 0 1-.518-.886c.447-1.677 1.483-3.192 2.87-4.264a8.155 8.155 0 0 1 4.99-1.677 8.155 8.155 0 0 1 4.988 1.678c.682.535 1.293 1.164 1.764 1.887.494.722.87 1.538 1.106 2.376a.735.735 0 0 1-.518.886.744.744 0 0 1-.894-.513c-.376-1.375-1.223-2.61-2.376-3.495A6.686 6.686 0 0 0 12.024 5.5c-1.506 0-2.918.49-4.118 1.398a6.593 6.593 0 0 0-2.353 3.519c-.047.302-.33.512-.659.512zM12.07 20.202c-3.694 0-6.94-2.47-7.882-6.012a.7.7 0 0 1 .518-.862.708.708 0 0 1 .87.513c.777 2.912 3.436 4.94 6.471 4.94s5.718-2.028 6.47-4.94a.727.727 0 0 1 .871-.513c.377.093.612.49.518.862-.894 3.542-4.141 6.012-7.835 6.012z\"/>\n        <path d=\"M12.024 9.996c.4 0 .729.326.729.722v5.43a.73.73 0 0 1-1.459 0v-5.43c0-.419.33-.722.73-.722z\"/>\n        <ellipse cx=\"12.047\" cy=\"8.109\" rx=\"1\" ry=\"1\" transform=\"rotate(-180 12.047 8.109)\"/>\n    </g>\n</svg>\n  "};module.exports=exports["default"];

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g transform=\"translate(-46.000000, -36.000000)\" fill=\"currentColor\">\n                <g transform=\"translate(23.000000, 18.000000)\">\n                    <path d=\"M28.6963091,21.9375 C26.8332808,21.9375 25.1481052,21.2807162 23.9512394,20.0881937 C23.8021486,19.945803 23.7342049,19.7952681 23.7512622,19.6430913 C23.7743145,19.4388315 23.9431747,19.3175892 23.9790021,19.2940764 L25.181863,18.4342806 C25.217405,18.4059076 25.386836,18.28125 25.6222125,18.28125 C25.7992088,18.28125 25.9629303,18.3505407 26.1086667,18.4872831 C26.7681919,19.073594 27.6882156,19.3979139 28.6963091,19.3979139 C29.7044741,19.3979139 30.6244978,19.073594 31.2868063,18.4847216 C31.429688,18.3505407 31.5934095,18.28125 31.7704771,18.28125 C32.005925,18.28125 32.1752847,18.4059076 32.2108267,18.434215 L33.4136875,19.2940764 C33.4494436,19.3175892 33.6183751,19.4388315 33.6414274,19.6430913 C33.6584134,19.7952681 33.590541,19.945803 33.4393805,20.0902954 C32.2444417,21.2807162 30.5592661,21.9375 28.6963091,21.9375\"></path>\n                </g>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\" width=\"100\" height=\"100\" viewBox=\"0 0 100 100\">\n                <path fill=\"#c5c3d8\" fill-rule=\"nonzero\" d=\"M45.631 71.456H39.71c-1.65 0-3.01-1.359-3.01-3.01 0-1.65 1.36-3.01 3.01-3.01h5.922c1.65 0 3.01-1.358 3.01-3.009 0-1.65-1.36-3.01-3.01-3.01H43.69a8.909 8.909 0 0 1-8.932-8.932 8.909 8.909 0 0 1 8.932-8.932h5.923c1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.36 3.01-3.01 3.01h-5.923c-1.65 0-3.01 1.359-3.01 3.01 0 1.65 1.36 3.01 3.01 3.01h1.942a8.909 8.909 0 0 1 8.932 8.931 8.909 8.909 0 0 1-8.932 8.932z\"/>\n                <path fill=\"#c5c3d8\" fill-rule=\"nonzero\" d=\"M33.495 80.388H20.583c-5.34 0-9.71-4.369-9.71-9.708V42.62c0-5.34 4.37-9.708 9.71-9.708h18.155a8.909 8.909 0 0 1 8.932 8.932v2.912c0 1.65-1.36 3.01-3.01 3.01-1.65 0-3.01-1.36-3.01-3.01v-2.912c0-1.65-1.359-3.01-3.01-3.01H20.486c-2.135 0-3.786 1.748-3.786 3.786V70.68c0 2.136 1.748 3.786 3.786 3.786h12.913c1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.262 2.912-2.913 2.912z\"/>\n                <path fill=\"#c5c3d8\" fill-rule=\"nonzero\" d=\"M80.388 70.291h-5.145c-1.65 0-3.01-1.359-3.01-3.01 0-1.65 1.36-3.01 3.01-3.01h5.145c2.136 0 3.787-1.747 3.787-3.786V32.427c0-1.262-.583-2.815-1.457-3.98-.776-1.068-1.65-1.748-2.33-1.748h-46.02c-2.135 0-3.785 1.748-3.785 3.786v5.146c0 1.65-1.36 3.01-3.01 3.01-1.65 0-3.01-1.36-3.01-3.01v-5.146c0-5.34 4.369-9.708 9.709-9.708h46.02c2.718 0 5.242 1.456 7.184 4.174C89.029 27.184 90 30 90 32.427v28.058c.194 5.437-4.175 9.806-9.612 9.806z\"/>\n                <path fill=\"#c5c3d8\" fill-rule=\"nonzero\" d=\"M68.544 80.388H50.485a8.909 8.909 0 0 1-8.932-8.932v-2.912c0-1.65 1.36-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01v2.912c0 1.65 1.359 3.01 3.01 3.01H68.64c2.136 0 3.786-1.748 3.786-3.786V42.62c0-2.136-1.747-3.786-3.786-3.786H55.728c-1.65 0-3.01-1.36-3.01-3.01 0-1.65 1.36-3.01 3.01-3.01h12.913c5.34 0 9.709 4.37 9.709 9.71v28.058c-.098 5.436-4.467 9.805-9.806 9.805z\"/>\n                <path d=\"M.583.874h99.029v99.029H.583z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <rect width=\"50\" height=\"30\" fill=\"#FFF\" rx=\"3\"/>\n                <path fill=\"#C00\" d=\"M41.828 14.992c0 5.528-4.463 10.008-9.97 10.008-5.505 0-9.968-4.48-9.968-10.008 0-5.528 4.463-10.009 9.969-10.009 5.506 0 9.97 4.481 9.97 10.009\"/>\n                <path fill=\"#06C\" d=\"M24.157 21.348a9.936 9.936 0 0 1-.759-1.06h3.533c.212-.34.404-.694.575-1.06h-4.682a9.955 9.955 0 0 1-.422-1.06h5.525a10.095 10.095 0 0 0 .289-5.296h-6.102a9.99 9.99 0 0 1 .29-1.06h5.523a10.085 10.085 0 0 0-.422-1.059h-4.68c.17-.366.363-.72.574-1.06h3.531c-.23-.37-.484-.723-.759-1.059h-2.012c.31-.377.646-.731 1.006-1.059a9.912 9.912 0 0 0-6.694-2.592c-5.507 0-9.97 4.481-9.97 10.009C8.5 20.52 12.964 25 18.47 25a9.913 9.913 0 0 0 6.694-2.591c.36-.329.697-.683 1.007-1.061h-2.015\"/>\n                <path fill=\"#006\" d=\"M25.023 17.696a4.828 4.828 0 0 1-1.274.168c-1.39-.001-2.113-.636-2.113-1.852 0-1.419.921-2.463 2.172-2.463 1.023 0 1.676.585 1.676 1.502 0 .305-.044.601-.153 1.02h-2.47c-.089.594.343.854 1.078.854.44 0 .838-.079 1.278-.257l-.194 1.028zm-.665-2.462c0-.09.138-.726-.577-.74-.395 0-.678.263-.793.74h1.37zM25.86 14.956c0 .524.294.887.963 1.156.51.21.59.271.59.459 0 .26-.225.38-.726.376a4.126 4.126 0 0 1-1.126-.161l-.18.956c.361.084.867.112 1.315.122 1.334 0 1.95-.438 1.95-1.387 0-.57-.257-.905-.89-1.155-.53-.212-.592-.258-.592-.45 0-.226.21-.34.619-.34.248 0 .587.022.91.062l.18-.962a9.77 9.77 0 0 0-1.114-.082c-1.414 0-1.903.638-1.9 1.406M20.958 17.796h-1.036l.025-.436c-.316.344-.738.504-1.309.504-.676 0-1.14-.464-1.14-1.132 0-1.015.806-1.6 2.19-1.6.143 0 .324.01.51.032a.9.9 0 0 0 .049-.268c0-.278-.218-.38-.801-.38a4.77 4.77 0 0 0-1.322.184l.177-.93c.622-.16 1.03-.221 1.49-.221 1.073 0 1.639.422 1.639 1.215.009.212-.064.637-.101.823-.042.27-.34 1.839-.37 2.209zm-.91-1.852a2.454 2.454 0 0 0-.278-.017c-.707 0-1.065.212-1.065.629 0 .262.175.425.447.425.508 0 .875-.426.897-1.037zM30.83 17.73c-.34.093-.605.134-.891.134-.635 0-.982-.326-.982-.906-.02-.16.135-.896.17-1.1.035-.207.585-3.206.585-3.206h1.234l-.187.992h.633l-.172 1.013h-.635s-.349 1.758-.349 1.893c0 .213.129.306.424.306.141 0 .25-.014.335-.04l-.165.914M36.343 13.549c-.904 0-1.61.374-2.021.998l.356-.926c-.656-.242-1.08.104-1.462.594 0 0-.064.082-.128.156v-.727H31.93c-.157 1.284-.435 2.586-.652 3.872l-.052.28h1.246c.118-.653.215-1.183.312-1.605.265-1.16.71-1.514 1.38-1.357a2.709 2.709 0 0 0-.24 1.146c0 1.036.56 1.884 1.953 1.884 1.404 0 2.421-.753 2.421-2.47 0-1.036-.678-1.845-1.955-1.845zm-.363 3.308c-.44.007-.707-.364-.707-.919 0-.657.39-1.4 1.016-1.4.504 0 .677.402.677.83 0 .935-.382 1.489-.986 1.489zM16.918 17.796h-1.241l.737-3.9-1.698 3.9h-1.131l-.207-3.878-.74 3.878h-1.126l.96-5.074h1.939l.161 2.829 1.229-2.83h2.095l-.978 5.075\"/>\n                <path fill=\"#FFF\" d=\"M25.334 17.384a4.818 4.818 0 0 1-1.273.168c-1.39-.002-2.113-.637-2.113-1.852 0-1.42.92-2.464 2.171-2.464 1.023 0 1.676.586 1.676 1.503 0 .304-.044.6-.152 1.02h-2.471c-.088.593.343.854 1.078.854.44 0 .838-.08 1.279-.258l-.195 1.029zm-.664-2.462c0-.09.137-.727-.578-.74-.395 0-.678.263-.793.74h1.37zM26.172 14.643c0 .525.293.887.962 1.157.511.21.591.27.591.458 0 .26-.225.38-.726.377a4.13 4.13 0 0 1-1.126-.162l-.18.956c.36.084.867.112 1.314.123 1.334 0 1.95-.44 1.95-1.388 0-.57-.256-.905-.89-1.154-.53-.213-.592-.259-.592-.45 0-.227.21-.341.62-.341.247 0 .587.023.91.062l.18-.962a9.628 9.628 0 0 0-1.115-.082c-1.414 0-1.903.638-1.898 1.406M21.27 17.483h-1.037l.025-.436c-.316.344-.737.504-1.308.504-.676 0-1.14-.464-1.14-1.132 0-1.014.805-1.6 2.19-1.6.142 0 .323.011.51.031a.893.893 0 0 0 .048-.267c0-.279-.218-.38-.8-.38a4.766 4.766 0 0 0-1.322.185l.177-.931c.622-.16 1.029-.22 1.49-.22 1.072 0 1.638.421 1.638 1.215.01.212-.064.636-.1.822-.043.27-.34 1.839-.37 2.209zm-.91-1.851a2.318 2.318 0 0 0-.279-.017c-.706 0-1.065.21-1.065.627 0 .263.175.427.448.427.508 0 .875-.427.896-1.037zM31.142 17.417c-.34.094-.605.135-.892.135-.635 0-.982-.326-.982-.907-.02-.159.135-.895.17-1.1.036-.206.586-3.206.586-3.206h1.234l-.187.992h.633l-.172 1.013h-.636s-.349 1.759-.349 1.892c0 .214.13.306.425.306.14 0 .25-.012.335-.038l-.165.913M37.278 15.054c0 .936-.382 1.49-.986 1.49-.44.007-.707-.364-.707-.919 0-.657.39-1.4 1.015-1.4.505 0 .678.402.678.83zm1.332.027c0-1.036-.678-1.845-1.955-1.845-1.47 0-2.42.983-2.42 2.431 0 1.037.561 1.885 1.953 1.885 1.405 0 2.422-.754 2.422-2.471zM32.24 13.33c-.156 1.285-.433 2.587-.65 3.873l-.053.28h1.246c.45-2.484.6-3.192 1.541-2.943l.453-1.176c-.656-.241-1.079.104-1.461.595.034-.221.1-.434.084-.628h-1.16M17.23 17.484h-1.241l.737-3.901-1.698 3.9h-1.132l-.207-3.878-.74 3.879h-1.125l.959-5.075h1.94l.102 3.142 1.365-3.142h2.018l-.979 5.075\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <rect width=\"50\" height=\"30\" fill=\"#FFF\" rx=\"3\"/>\n                <path fill=\"#C00\" d=\"M28.064 15.243c0 5.389-4.368 9.757-9.757 9.757-5.39 0-9.758-4.368-9.758-9.757 0-5.39 4.369-9.758 9.758-9.758 5.389 0 9.757 4.369 9.757 9.758\"/>\n                <path fill=\"#F90\" d=\"M31.407 5.485a9.723 9.723 0 0 0-7.536 3.559h1.972c.27.328.517.672.744 1.033h-3.46a9.803 9.803 0 0 0-.562 1.034h4.584c.156.334.294.679.413 1.033h-5.41a9.714 9.714 0 0 0-.283 1.032h5.976a9.829 9.829 0 0 1-.283 5.166h-5.41c.119.354.257.7.413 1.034h4.584a9.775 9.775 0 0 1-.563 1.033h-3.459c.226.36.475.705.744 1.033h1.971a9.751 9.751 0 0 1-.985 1.033A9.722 9.722 0 0 0 31.407 25c5.389 0 9.757-4.368 9.757-9.757 0-5.389-4.368-9.758-9.757-9.758\"/>\n                <path fill=\"#006\" d=\"M16.028 16.311a1.822 1.822 0 0 0-.236-.017c-.6 0-.904.206-.904.613 0 .25.148.41.38.41.43 0 .742-.41.76-1.006zm.77 1.793h-.877l.02-.417c-.268.33-.625.487-1.11.487-.574 0-.968-.448-.968-1.1 0-.98.685-1.551 1.86-1.551.12 0 .274.011.432.03a.994.994 0 0 0 .041-.26c0-.267-.184-.367-.68-.367a3.532 3.532 0 0 0-1.12.182l.147-.905c.527-.156.875-.213 1.267-.213.91 0 1.392.408 1.39 1.18.003.207-.032.461-.085.797-.092.583-.29 1.833-.316 2.137zM13.42 18.104h-1.06l.608-3.804-1.356 3.804h-.721l-.09-3.783-.637 3.783h-.992L10 13.155h1.524l.092 2.77.929-2.77h1.694l-.819 4.95M32.716 16.311a1.814 1.814 0 0 0-.236-.017c-.6 0-.904.206-.904.613 0 .25.147.41.38.41.43 0 .742-.41.76-1.006zm.77 1.793h-.877l.02-.417c-.268.33-.625.487-1.11.487-.574 0-.968-.448-.968-1.1 0-.98.685-1.551 1.86-1.551.12 0 .274.011.432.03a.988.988 0 0 0 .041-.26c0-.267-.184-.367-.68-.367a3.54 3.54 0 0 0-1.121.182c.012-.067.148-.905.148-.905.527-.156.876-.213 1.267-.213.91 0 1.392.408 1.39 1.18.002.207-.032.461-.085.797-.092.583-.29 1.833-.316 2.137zM21.507 18.043c-.29.092-.516.131-.761.131-.542 0-.837-.311-.837-.884-.008-.178.077-.646.145-1.073.061-.376.46-2.747.46-2.747h1.052l-.123.61h.636l-.144.967h-.638c-.122.765-.296 1.719-.298 1.845 0 .208.11.298.362.298.121 0 .215-.012.286-.038l-.14.891M24.735 18.01c-.362.111-.71.165-1.08.164-1.18-.002-1.794-.617-1.794-1.796 0-1.375.782-2.388 1.843-2.388.868 0 1.423.567 1.423 1.456 0 .295-.038.583-.13.99H22.9c-.07.584.303.827.916.827.376 0 .716-.078 1.094-.253l-.175 1zm-.592-2.385c.006-.084.112-.719-.49-.719-.335 0-.575.256-.673.719h1.163zM17.434 15.352c0 .509.247.86.807 1.124.429.202.495.261.495.444 0 .25-.19.364-.608.364-.316 0-.61-.05-.95-.159l-.145.93c.24.052.456.1 1.103.119 1.117 0 1.633-.426 1.633-1.345 0-.553-.215-.878-.746-1.122-.444-.204-.495-.25-.495-.437 0-.218.176-.33.518-.33.208 0 .492.023.761.061l.15-.933a7.152 7.152 0 0 0-.931-.078c-1.185 0-1.596.618-1.592 1.362M29.887 14.096c.294 0 .569.076.947.267l.173-1.074c-.156-.061-.702-.42-1.164-.42-.709 0-1.309.353-1.73.933-.615-.204-.868.208-1.178.618l-.275.064c.021-.135.04-.269.034-.405h-.973c-.133 1.247-.368 2.508-.553 3.755l-.048.27h1.06a68.74 68.74 0 0 0 .332-2.383l.4-.221c.06-.222.245-.297.62-.288a4.509 4.509 0 0 0-.076.825c0 1.317.712 2.137 1.852 2.137.294 0 .546-.039.936-.145l.186-1.128c-.351.173-.639.254-.9.254-.615 0-.988-.455-.988-1.206 0-1.09.554-1.853 1.345-1.853M38.856 13.155l-.236 1.43c-.29-.381-.6-.657-1.011-.657-.534 0-1.021.405-1.34 1.002-.443-.092-.902-.249-.902-.249v.004a5.96 5.96 0 0 0 .047-.606h-.973c-.133 1.247-.368 2.508-.552 3.755l-.05.27H34.9c.143-.928.252-1.7.333-2.312.362-.328.544-.613.91-.594a3.45 3.45 0 0 0-.258 1.306c0 1.006.509 1.67 1.28 1.67.388 0 .686-.134.976-.444l-.05.374h1.002l.807-4.949h-1.044zm-1.325 4.02c-.36 0-.543-.268-.543-.794 0-.791.34-1.352.821-1.352.364 0 .562.277.562.788 0 .798-.347 1.358-.84 1.358z\"/>\n                <path fill=\"#FFF\" d=\"M13.725 17.81h-1.06l.608-3.804-1.355 3.805h-.723l-.089-3.783-.638 3.783h-.991l.828-4.95h1.523l.043 3.064 1.028-3.063h1.645l-.82 4.949M16.333 16.018a1.761 1.761 0 0 0-.236-.017c-.6 0-.904.206-.904.613 0 .25.148.41.38.41.43 0 .742-.41.76-1.006zm.77 1.793h-.877l.02-.417c-.268.33-.625.487-1.11.487-.574 0-.968-.45-.968-1.1 0-.98.685-1.551 1.86-1.551.12 0 .274.01.432.03A.999.999 0 0 0 16.5 15c0-.267-.184-.366-.68-.366a3.519 3.519 0 0 0-1.12.18l.146-.905c.528-.155.876-.213 1.268-.213.91 0 1.392.409 1.39 1.18.002.207-.032.463-.085.798-.092.582-.29 1.833-.316 2.137zM31.312 12.995l-.174 1.074c-.378-.19-.652-.267-.946-.267-.79 0-1.346.764-1.346 1.855 0 .75.373 1.204.99 1.204.26 0 .548-.08.899-.253l-.186 1.127c-.39.107-.643.146-.936.146-1.141 0-1.851-.82-1.851-2.137 0-1.77.982-3.006 2.386-3.006.462 0 1.008.196 1.164.257M33.02 16.018a1.748 1.748 0 0 0-.235-.017c-.6 0-.904.206-.904.613 0 .25.148.41.38.41.43 0 .742-.41.76-1.006zm.772 1.793h-.878l.02-.417c-.268.33-.625.487-1.11.487-.575 0-.968-.45-.968-1.1 0-.98.684-1.551 1.86-1.551.12 0 .274.01.431.03a.994.994 0 0 0 .042-.26c0-.267-.184-.366-.68-.366a3.52 3.52 0 0 0-1.12.18l.146-.905c.528-.155.876-.213 1.268-.213.91 0 1.392.409 1.39 1.18.003.207-.032.463-.085.798-.092.582-.29 1.833-.316 2.137zM21.811 17.75a2.42 2.42 0 0 1-.76.13c-.542 0-.838-.31-.838-.883-.007-.179.078-.646.146-1.073.06-.377.459-2.747.459-2.747h1.053l-.123.609h.54l-.144.967h-.542c-.122.766-.297 1.72-.299 1.846 0 .208.111.298.363.298.121 0 .214-.012.286-.038l-.14.89M25.04 17.718c-.362.11-.711.163-1.08.163-1.18-.001-1.794-.617-1.794-1.796 0-1.376.782-2.39 1.843-2.39.868 0 1.423.568 1.423 1.458 0 .295-.039.583-.13.99h-2.097c-.07.584.303.827.915.827.377 0 .717-.078 1.095-.254l-.175 1.002zm-.592-2.387c.006-.084.112-.719-.49-.719-.335 0-.575.257-.673.719h1.163zM17.739 15.058c0 .51.247.86.807 1.124.429.202.495.262.495.445 0 .25-.189.364-.608.364-.316 0-.61-.05-.95-.159l-.145.93c.24.052.456.1 1.102.119 1.118 0 1.634-.426 1.634-1.346 0-.553-.216-.877-.746-1.121-.444-.204-.495-.25-.495-.438 0-.217.176-.33.518-.33.208 0 .492.024.761.062l.15-.933a7.21 7.21 0 0 0-.931-.08c-1.186 0-1.596.62-1.592 1.363M39.398 17.81h-1.002l.05-.374c-.29.31-.588.445-.977.445-.77 0-1.279-.664-1.279-1.67 0-1.34.79-2.468 1.724-2.468.41 0 .722.168 1.011.55l.235-1.431h1.045l-.807 4.949zm-1.563-.93c.494 0 .84-.558.84-1.355 0-.512-.197-.79-.56-.79-.481 0-.822.561-.822 1.353 0 .526.182.793.542.793zM34.746 13.786c-.133 1.246-.368 2.507-.553 3.754l-.048.27h1.06c.379-2.46.47-2.94 1.064-2.88.095-.505.271-.946.402-1.168-.443-.093-.691.158-1.016.634.026-.206.073-.406.064-.61h-.973M26.026 13.786c-.133 1.246-.37 2.507-.553 3.754l-.048.27h1.06c.379-2.46.47-2.94 1.063-2.88.095-.505.272-.946.403-1.168-.443-.093-.691.158-1.016.634.026-.206.073-.406.064-.61h-.973\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\">\n                <path d=\"M19.516 2L2 19.516M2 2l17.516 17.516\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"\n    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n    <g fill=\"#B1B0C5\" fill-rule=\"nonzero\">\n        <path d=\"M15.868 11.464a.701.701 0 0 1-.7-.699V8.621c0-.862-.349-1.7-.954-2.306a3.225 3.225 0 0 0-2.307-.956c-.862 0-1.701.35-2.307.956a3.225 3.225 0 0 0-.955 2.306v2.144a.701.701 0 0 1-.7.7.717.717 0 0 1-.698-.7V8.621c0-1.258.489-2.423 1.374-3.308a4.674 4.674 0 0 1 3.31-1.375c1.234 0 2.422.49 3.308 1.375a4.674 4.674 0 0 1 1.375 3.308v2.144c-.047.396-.35.7-.746.7zM11.86 16.683a.701.701 0 0 1-.699-.699v-1.91c0-.396.326-.7.7-.7.372 0 .698.327.698.7v1.91a.687.687 0 0 1-.699.7z\"/>\n        <path d=\"M16.148 19.969H7.573a2.337 2.337 0 0 1-2.33-2.33v-5.266a2.337 2.337 0 0 1 2.33-2.33h8.575a2.337 2.337 0 0 1 2.33 2.33v5.266c-.024 1.281-1.072 2.33-2.33 2.33zm-8.575-8.505a.91.91 0 0 0-.909.909v5.266c0 .49.396.909.909.909h8.575a.91.91 0 0 0 .908-.91v-5.265a.91.91 0 0 0-.908-.909H7.573z\"/>\n    </g>\n</svg>\n\n    "};module.exports=exports["default"];

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g id=\"Styleguide\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n                <g id=\"Iconografia\" transform=\"translate(-1547.000000, -3151.000000)\">\n                    <g id=\"IC_close\" transform=\"translate(1547.000000, 3151.000000)\">\n                        <path fill=\"#c5c3d8\" d=\"M71.6504854,74.1747573 C70.8737864,74.1747573 70.0970874,73.8834951 69.5145631,73.3009709 L26.3106796,30.1941748 C25.1456311,29.0291262 25.1456311,27.184466 26.3106796,26.0194175 C27.4757282,24.8543689 29.3203883,24.8543689 30.4854369,26.0194175 L73.6893204,69.1262136 C74.8543689,70.2912621 74.8543689,72.1359223 73.6893204,73.3009709 C73.2038835,73.8834951 72.4271845,74.1747573 71.6504854,74.1747573 Z\" id=\"Shape\" fill=\"#201A5B\" fill-rule=\"nonzero\" transform=\"translate(50.000000, 49.660194) scale(-1, 1) translate(-50.000000, -49.660194) \"></path>\n                        <path fill=\"#c5c3d8\" d=\"M34.0291262,43.0582524 C29.0776699,43.0582524 25,38.9805825 25,34.0291262 C25,29.0776699 29.0776699,25 34.0291262,25 C38.9805825,25 43.0582524,29.0776699 43.0582524,34.0291262 C42.961165,38.9805825 38.9805825,43.0582524 34.0291262,43.0582524 Z M34.0291262,30.9223301 C32.3786408,30.9223301 30.9223301,32.2815534 30.9223301,34.0291262 C30.9223301,35.776699 32.2815534,37.1359223 34.0291262,37.1359223 C35.776699,37.1359223 37.1359223,35.776699 37.1359223,34.0291262 C37.1359223,32.2815534 35.6796117,30.9223301 34.0291262,30.9223301 Z\" id=\"Shape\" fill=\"#201A5B\" fill-rule=\"nonzero\" transform=\"translate(34.029126, 34.029126) scale(-1, 1) translate(-34.029126, -34.029126) \"></path>\n                        <path fill=\"#c5c3d8\" d=\"M66.0291262,74.0582524 C61.0776699,74.0582524 57,69.9805825 57,65.0291262 C57,60.0776699 61.0776699,56 66.0291262,56 C70.9805825,56 75.0582524,60.0776699 75.0582524,65.0291262 C74.961165,69.9805825 70.9805825,74.0582524 66.0291262,74.0582524 Z M66.0291262,61.9223301 C64.3786408,61.9223301 62.9223301,63.2815534 62.9223301,65.0291262 C62.9223301,66.776699 64.2815534,68.1359223 66.0291262,68.1359223 C67.776699,68.1359223 69.1359223,66.776699 69.1359223,65.0291262 C69.1359223,63.2815534 67.6796117,61.9223301 66.0291262,61.9223301 Z\" id=\"Shape\" fill=\"#201A5B\" fill-rule=\"nonzero\" transform=\"translate(66.029126, 65.029126) scale(-1, 1) translate(-66.029126, -65.029126) \"></path>\n                        <rect id=\"Rectangle-path\" x=\"0.776699029\" y=\"0.388349515\" width=\"99.0291262\" height=\"99.0291262\"></rect>\n                    </g>\n                </g>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M3.68 28.951c-.292 0-.486 0-.777-.097C1.35 28.466.379 26.816.767 25.165c1.845-6.99 6.116-13.3 11.845-17.767 2.912-2.233 6.116-3.98 9.514-5.146C25.718.99 29.408.408 33.194.408c3.787 0 7.476.582 11.068 1.844 3.398 1.165 6.602 2.913 9.515 5.146 2.815 2.233 5.34 4.854 7.281 7.864a34.002 34.002 0 0 1 4.563 9.903 3.065 3.065 0 0 1-2.136 3.69 3.065 3.065 0 0 1-3.689-2.137c-1.553-5.728-5.048-10.873-9.806-14.563A27.418 27.418 0 0 0 33.097 6.33c-6.214 0-12.039 2.039-16.99 5.825a27.487 27.487 0 0 0-9.709 14.66c-.194 1.263-1.456 2.136-2.718 2.136zM33.194 67.592c-15.243 0-28.64-10.291-32.524-25.048-.388-1.554.485-3.204 2.136-3.593 1.553-.388 3.204.486 3.592 2.136 3.204 12.136 14.175 20.583 26.7 20.583 12.523 0 23.591-8.447 26.698-20.583.388-1.553 2.039-2.524 3.592-2.136 1.554.389 2.525 2.04 2.136 3.593-3.689 14.757-16.99 25.048-32.33 25.048zM41.155 36.816H25.33c-1.65 0-3.01-1.36-3.01-3.01 0-1.65 1.36-3.01 3.01-3.01h15.825c1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.36 3.01-3.01 3.01z\"/>\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M41.155 50.699H25.33c-1.65 0-3.01-1.36-3.01-3.01V19.922c0-1.65 1.36-3.01 3.01-3.01h15.825c1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.36 3.01-3.01 3.01H28.243v21.845h12.912c1.65 0 3.01 1.359 3.01 3.01 0 1.65-1.36 2.912-3.01 2.912z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"#currentColor\" fill-rule=\"evenodd\">\n                <path d=\"M19.609 15H10.39C9.623 15 9 14.552 9 14s.623-1 1.391-1h9.218c.768 0 1.391.448 1.391 1s-.623 1-1.391 1\"/>\n                <path d=\"M23.997 24H7.004C4.796 24 3 22.304 3 20.22v-7.96c0-.696.598-1.26 1.335-1.26s1.334.564 1.334 1.26v7.96c0 .694.599 1.26 1.335 1.26h16.993c.735 0 1.334-.566 1.334-1.26v-7.96c0-.696.598-1.26 1.335-1.26S28 11.564 28 12.26v7.96c0 2.084-1.796 3.78-4.003 3.78M2.74 7.503h25.52V3.746c0-.689-.614-1.249-1.37-1.249H4.11c-.756 0-1.37.56-1.37 1.249v3.757zM29.63 10H1.37C.613 10 0 9.44 0 8.75V3.747C0 1.68 1.844 0 4.11 0h22.78C29.158 0 31 1.68 31 3.746V8.75C31 9.44 30.387 10 29.63 10z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g transform=\"translate(-13, -13)\">\n                <path d=\"M83.2,53l-3.2-4.1c-0.5-0.7-1.3-1-2.2-1c-0.9-0.1-1.8,0.3-2.4,1.1c-1.2,1.5-3,2.4-5.1,2.4\n                    c-2.1,0-3.9-0.9-5.1-2.4c-0.9-1.2-2.6-1.5-3.8-0.5c-1.2,1-1.4,2.7-0.5,4c2.2,2.9,5.6,4.6,9.4,4.6c0.9,0,1.8-0.1,2.6-0.3l1.3,2.6\n                    c0.5,1,1.4,1.5,2.4,1.5c0.4,0,0.8-0.1,1.2-0.3c1.3-0.7,1.9-2.4,1.2-3.8L79,56.6c0.5,0.6,1.3,1,2.1,1c0.6,0,1.2-0.2,1.7-0.6\n                    C84,56,84.1,54.2,83.2,53\"/>\n                <path d=\"M40.8,54.2c0,10.3,6.1,11.9,9.7,11.9c1.1,0,2.9-0.1,4.5-0.3c1.5-0.2,2.6-1.6,2.4-3.1\n                    c-0.2-1.5-1.7-2.5-3.2-2.3c-1.2,0.2-2.7,0.2-3.6,0.2c-1.4,0-4,0-4-6.4v-8c0-0.1,0-0.3,0-0.4c0.7-0.4,1.3-0.8,2-1.2\n                    c5.3-3.4,9.5-7.8,12.6-12.9c2.2,3.8,6.1,8.1,12.1,8.1c1.6,0,2.8-1.2,2.8-2.7c0-1.5-1.3-2.7-2.8-2.7c-5.2,0-8.3-7.3-9-9.2\n                    c0.6-1.7,1.1-3.5,1.5-5.3c0.3-1.5-0.7-2.9-2.2-3.2c-1.5-0.3-3,0.7-3.3,2.1C58.3,27.6,53,35.1,45.3,40c-7.7,4.9-16.9,6.7-25.9,4.9\n                    c-1.5-0.3-3,0.7-3.3,2.1c-0.3,1.5,0.7,2.9,2.2,3.2c2.7,0.5,5.4,0.8,8.1,0.8c4.9,0,9.8-0.9,14.4-2.6V54.2z\"/>\n                <path d=\"M64.5,74.5c-1.2-0.9-3-0.7-3.9,0.4c-2.4,2.8-6.3,4.4-10.6,4.4c-4.3,0-8.2-1.6-10.6-4.4\n                    c-1-1.1-2.7-1.3-3.9-0.4c-1.2,0.9-1.4,2.4-0.5,3.5c3.5,4,9,6.4,15,6.4c6.1,0,11.5-2.3,15-6.4C65.9,76.9,65.7,75.3,64.5,74.5\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <rect width=\"109\" height=\"37\" x=\".5\" y=\".5\" stroke=\"#FFF\" rx=\"3\"/>\n                <g fill=\"#FFF\">\n                    <path d=\"M68.472 29.022l-.732.687c-.169.093-.337.2-.505.277-.508.23-1.025.288-1.484.288-.49 0-1.256-.031-2.037-.595-1.086-.763-1.56-2.073-1.56-3.215 0-2.365 1.93-3.525 3.505-3.525.551 0 1.117.138 1.577.427.764.504.962 1.159 1.072 1.51l-3.598 1.449-1.178.09c.381 1.94 1.697 3.067 3.151 3.067.727 0 1.266-.236 1.76-.48 0 0 .1-.051.029.02zm-2.17-3.857c.292-.106.443-.198.443-.41 0-.609-.691-1.312-1.516-1.312-.612 0-1.76.474-1.76 2.122 0 .257.031.53.047.805l2.786-1.205z\"/>\n                    <path d=\"M60.95 28.903c0 .593.107.685.61.731.262.031.523.045.782.075l-.566.336h-2.697c.354-.457.415-.502.415-.807v-.34l-.006-9.069h-1.191l1.146-.55h2.188c-.474.273-.616.44-.677.974l-.004 8.65z\"/>\n                    <path d=\"M56.768 23.688c.351.288 1.085.898 1.085 2.058 0 1.13-.639 1.662-1.283 2.165-.198.199-.429.414-.429.747 0 .337.232.52.398.656l.553.426c.672.565 1.284 1.084 1.284 2.137 0 1.435-1.393 2.881-4.025 2.881-2.217 0-3.29-1.052-3.29-2.18 0-.55.275-1.328 1.18-1.86.949-.579 2.234-.656 2.922-.701-.215-.277-.46-.567-.46-1.04 0-.258.078-.412.153-.594-.167.016-.336.032-.489.032-1.623 0-2.54-1.206-2.54-2.396 0-.701.32-1.48.98-2.044.872-.716 1.912-.84 2.739-.84h3.153l-.98.553h-.95zm-1.084 6.77c-.125-.015-.2-.015-.352-.015-.139 0-.965.03-1.606.244-.338.123-1.317.488-1.317 1.572 0 1.08 1.057 1.86 2.692 1.86 1.469 0 2.25-.702 2.25-1.647-.001-.778-.506-1.188-1.667-2.013zm.44-2.897c.354-.352.385-.838.385-1.115 0-1.097-.657-2.805-1.928-2.805-.397 0-.827.199-1.071.505-.258.318-.336.73-.336 1.126 0 1.022.597 2.716 1.912 2.716.383 0 .796-.186 1.038-.427zM47.282 30.243c-2.433 0-3.734-1.889-3.734-3.598 0-1.997 1.636-3.706 3.963-3.706 2.25 0 3.658 1.756 3.658 3.599 0 1.8-1.392 3.705-3.887 3.705zm1.913-1.234c.37-.488.46-1.098.46-1.691 0-1.344-.642-3.906-2.54-3.906-.505 0-1.013.197-1.38.518-.597.534-.703 1.204-.703 1.863 0 1.506.746 3.992 2.6 3.992.6 0 1.21-.289 1.563-.776zM39.138 30.243c-2.433 0-3.732-1.889-3.732-3.598 0-1.997 1.636-3.706 3.963-3.706 2.248 0 3.655 1.756 3.655 3.599 0 1.8-1.39 3.705-3.886 3.705zm1.914-1.234c.367-.488.459-1.098.459-1.691 0-1.344-.644-3.906-2.54-3.906-.506 0-1.01.197-1.376.518-.599.534-.705 1.204-.705 1.863 0 1.506.75 3.992 2.601 3.992.598 0 1.208-.289 1.561-.776zM34.434 29.714l-2.052.467c-.83.131-1.577.246-2.368.246-3.957 0-5.464-2.903-5.464-5.175 0-2.775 2.136-5.347 5.794-5.347.774 0 1.52.113 2.197.297 1.076.301 1.578.672 1.893.89l-1.192 1.128-.502.112.358-.57c-.485-.472-1.377-1.344-3.07-1.344-2.263 0-3.97 1.715-3.97 4.219 0 2.689 1.95 5.218 5.075 5.218.919 0 1.392-.184 1.821-.356v-2.305l-2.166.116 1.149-.614h3.039l-.371.356c-.101.085-.114.114-.142.228-.015.13-.029.544-.029.69v1.744zM72.882 29.087v3.885h-.774v-9.886h.774v1.126a3.08 3.08 0 0 1 2.496-1.305c1.919 0 3.212 1.451 3.212 3.749 0 2.282-1.293 3.764-3.212 3.764-1.01 0-1.915-.52-2.496-1.333zm4.877-2.43c0-1.732-.906-3.053-2.512-3.053-.997 0-1.95.782-2.365 1.462v3.165c.415.682 1.368 1.492 2.365 1.492 1.606 0 2.512-1.332 2.512-3.067zM79.647 30.242v-9.885h.774v9.885h-.774zM89.106 32.332c.165.074.448.12.627.12.473 0 .803-.194 1.1-.876l.564-1.274-3.05-7.216h.864l2.615 6.253 2.59-6.253h.876l-3.719 8.73c-.386.899-.993 1.331-1.827 1.331-.25 0-.58-.044-.773-.103l.133-.712zM86.845 30.22c-.052-.247-.09-.466-.12-.649a4.263 4.263 0 0 1-.036-.558c-.266.389-.642.712-1.122.967-.48.256-.937.382-1.564.382-.754 0-1.339-.185-1.757-.56-.416-.375-.625-.883-.625-1.525 0-.641.303-1.162.908-1.56.605-.4 1.387-.599 2.354-.599h1.805v-.89c0-.511-.175-.913-.524-1.206-.351-.292-.844-.44-1.483-.44-.583 0-1.057.135-1.417.398-.357.269-.537.601-.537 1.002h-.792l-.016-.038c-.03-.54.219-1.015.746-1.424.525-.41 1.213-.615 2.06-.615.843 0 1.526.203 2.041.607.514.4.772.978.772 1.734v3.53a4.65 4.65 0 0 0 .198 1.445h-.89zm-2.746-.562c.657 0 1.13-.146 1.613-.436.48-.288.806-.664.977-1.118V26.73h-1.814c-.692 0-1.266.152-1.717.461-.452.307-.682.68-.682 1.112 0 .408.145.734.434.982.289.25.684.373 1.189.373zM6.157 33.568c-.279-.076-.46-.353-.46-.782V18.632c0-.397.153-.665.397-.763l6.956 7.889-6.893 7.81zm.958-.3l8.372-4.746-2.039-2.313-6.333 7.058zm8.43-10.337l-8.256-4.68 6.171 7.042 2.085-2.362zm.56.317l3.234 1.834c.613.347.618.906 0 1.257l-3.316 1.879-2.163-2.468 2.245-2.502z\"/>\n                    <text font-family=\"OpenSans, Open Sans\" font-size=\"9\" letter-spacing=\".18\">\n                        <tspan x=\"25.103\" y=\"14.231\">Dispon\xEDvel na</tspan>\n                    </text>\n                </g>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"#8583A4\" fill-rule=\"evenodd\">\n              <path d=\"M23.455 14.718l-.916-1.163a.76.76 0 0 0-.613-.292.763.763 0 0 0-.675.306c-.33.437-.858.688-1.45.688-.59 0-1.12-.25-1.449-.688a.76.76 0 0 0-1.089-.141.818.818 0 0 0-.136 1.124c.626.832 1.6 1.308 2.674 1.308.255 0 .505-.029.745-.08l.363.743c.138.279.41.44.695.44a.755.755 0 0 0 .349-.087.814.814 0 0 0 .343-1.076l-.025-.05a.756.756 0 0 0 1.071.096.817.817 0 0 0 .113-1.128\"/>\n              <path d=\"M11.425 15.07c0 2.936 1.72 3.374 2.744 3.374.326 0 .831-.023 1.272-.087a.784.784 0 0 0 .675-.888.8.8 0 0 0-.913-.656c-.353.052-.778.07-1.034.07-.397 0-1.138 0-1.138-1.814v-2.276c0-.04-.006-.08-.012-.12a11.173 11.173 0 0 0 4.142-4.013c.639 1.071 1.746 2.315 3.443 2.315.442 0 .803-.35.803-.78 0-.432-.36-.781-.803-.781-1.491 0-2.365-2.082-2.56-2.605.177-.486.323-.987.43-1.501a.78.78 0 0 0-.626-.922.803.803 0 0 0-.948.609c-.525 2.492-2.017 4.636-4.202 6.037a9.961 9.961 0 0 1-7.363 1.381.804.804 0 0 0-.948.608.782.782 0 0 0 .626.922c.77.153 1.543.229 2.312.229a11.56 11.56 0 0 0 4.1-.75v1.647zM18.136 20.817c-.349-.242-.851-.186-1.121.127-.691.797-1.79 1.254-3.016 1.254-1.223 0-2.322-.457-3.014-1.255-.27-.312-.772-.368-1.12-.126-.35.243-.412.693-.141 1.005.996 1.149 2.554 1.808 4.275 1.808 1.723 0 3.281-.66 4.277-1.808.271-.312.208-.762-.14-1.005\"/>\n          </g>"};module.exports=exports["default"];

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path d=\"M51.09,92A34.72,34.72,0,0,1,16.34,57.2a3.06,3.06,0,0,1,6.13,0,28.62,28.62,0,1,0,57.24,0,3.06,3.06,0,1,1,6.13,0A34.72,34.72,0,0,1,51.09,92Z\" />\n                <path d=\"M51.09,79.7A34.65,34.65,0,1,1,64.62,77,34.53,34.53,0,0,1,51.09,79.7Zm0-63.37a28.62,28.62,0,1,0,20.24,8.38A28.43,28.43,0,0,0,51.09,16.33Z\" />\n                <path d=\"M52.37,61.25H46.24a3.06,3.06,0,0,1,0-6.13h6.13a3.06,3.06,0,0,0,0-6.13h-2a9.19,9.19,0,1,1,0-18.38h6.13a3.06,3.06,0,1,1,0,6.13H50.32a3.06,3.06,0,1,0,0,6.13h2a9.19,9.19,0,0,1,0,18.38Z\" />\n                <path d=\"M51.35,36.74a3.06,3.06,0,0,1-3.06-3.06V26.54a3.06,3.06,0,1,1,6.13,0v7.13A3.06,3.06,0,0,1,51.35,36.74Z\" />\n                <path d=\"M51.15,67.36a3.06,3.06,0,0,1-3.06-3.06V58.2a3.06,3.06,0,0,1,6.13,0v6.1A3.06,3.06,0,0,1,51.15,67.36Z\" />\n                <rect width=\"102.13\" height=\"102.13\" style=\"fill:none\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\" stroke=\"#FFF\" stroke-linecap=\"round\" stroke-width=\"2\">\n                <path d=\"M15.886 4.743C14.429 2.57 11.77 1 9 1 4.571 1 1 4.571 1 9s3.571 8 8 8c4.314 0 7.857-3.429 8-7.714\"/>\n                <path stroke-linejoin=\"round\" d=\"M12.429 5.571H17V1\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n        <g id=\"07.8.2_Dados_Do_Plano_Pos_Pago_Debito\" transform=\"translate(-285.000000, -845.000000)\" stroke=\"#292663\" stroke-width=\"2\">\n            <polyline id=\"Path-2-Copy-2\" transform=\"translate(289.000000, 851.500000) rotate(-90.000000) translate(-289.000000, -851.500000) \" points=\"284 849.054879 288.972409 854 294 849\"></polyline>\n        </g>\n    </g>/>\n"};module.exports=exports["default"];

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <g fill=\"#201A5B\" fill-rule=\"nonzero\">\n                    <path d=\"M50.33 74.854a3.012 3.012 0 0 1-2.136-.873 2.93 2.93 0 0 1 0-4.175l17.767-17.67c.583-.583.874-1.36.874-2.136 0-.777-.291-1.553-.874-2.136L48.194 30.097a2.93 2.93 0 0 1 0-4.175 2.93 2.93 0 0 1 4.175 0L70.136 43.69c1.65 1.65 2.621 3.98 2.621 6.311 0 2.427-.97 4.66-2.621 6.31L52.369 73.98c-.486.583-1.262.874-2.039.874z\"/>\n                    <path d=\"M50.524 53.01H28.583c-1.651 0-3.01-1.36-3.01-3.01 0-1.65 1.359-3.01 3.01-3.01h21.941c1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.36 3.01-3.01 3.01z\"/>\n                </g>\n                <path d=\"M.913.388h99.029v99.029H.913z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\" transform=\"rotate(180 40,40)\">\n                <g fill=\"#201A5B\" fill-rule=\"nonzero\">\n                    <path d=\"M50.33 74.854a3.012 3.012 0 0 1-2.136-.873 2.93 2.93 0 0 1 0-4.175l17.767-17.67c.583-.583.874-1.36.874-2.136 0-.777-.291-1.553-.874-2.136L48.194 30.097a2.93 2.93 0 0 1 0-4.175 2.93 2.93 0 0 1 4.175 0L70.136 43.69c1.65 1.65 2.621 3.98 2.621 6.311 0 2.427-.97 4.66-2.621 6.31L52.369 73.98c-.486.583-1.262.874-2.039.874z\"/>\n                    <path d=\"M50.524 53.01H28.583c-1.651 0-3.01-1.36-3.01-3.01 0-1.65 1.359-3.01 3.01-3.01h21.941c1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.36 3.01-3.01 3.01z\"/>\n                </g>\n                <path d=\"M.913.388h99.029v99.029H.913z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"#A7B3C0\" fill-rule=\"evenodd\" opacity=\".5\">\n                <path d=\"M15.116 7.992h-1.13c-.885 0-1.057.422-1.057 1.039v1.362h2.113l-.275 2.133h-1.838V18h-2.203v-5.473H8.884v-2.134h1.842V8.82c0-1.826 1.116-2.82 2.744-2.82.78 0 1.45.058 1.646.084v1.908zM12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12zM50.772 9.553c.004.105.007.211.007.318 0 3.253-2.477 7.005-7.005 7.005A6.97 6.97 0 0 1 40 15.77a4.938 4.938 0 0 0 3.645-1.02 2.464 2.464 0 0 1-2.3-1.709 2.484 2.484 0 0 0 1.112-.043 2.462 2.462 0 0 1-1.975-2.413v-.032a2.45 2.45 0 0 0 1.115.308 2.462 2.462 0 0 1-.761-3.287 6.99 6.99 0 0 0 5.074 2.573A2.462 2.462 0 0 1 50.105 7.9a4.926 4.926 0 0 0 1.564-.597 2.474 2.474 0 0 1-1.083 1.362A4.94 4.94 0 0 0 52 8.278c-.33.494-.748.928-1.228 1.275M34 12c0 6.627 5.372 12 12 12s12-5.373 12-12c0-6.628-5.372-12-12-12S34 5.372 34 12z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"#292663\" fill-rule=\"evenodd\">\n                <path d=\"M71.77,84.56a3.06,3.06,0,0,1-3.06-3.06V25.56a3.07,3.07,0,0,0-3.06-3.06H37.09A3.07,3.07,0,0,0,34,25.56V81.5a3.06,3.06,0,0,1-6.13,0V25.56a9.2,9.2,0,0,1,9.19-9.19H65.64a9.2,9.2,0,0,1,9.19,9.19V81.5A3.06,3.06,0,0,1,71.77,84.56Z\"/>\n                <path d=\"M83,85.79H19.63a3.06,3.06,0,0,1,0-6.13H83a3.06,3.06,0,0,1,0,6.13Z\"/>\n                <path d=\"M61.35,49H40.79a3.06,3.06,0,0,1,0-6.13H61.35a3.06,3.06,0,0,1,0,6.13Z\"/>\n                <path d=\"M76.84,73.61H71.9a3.06,3.06,0,0,1,0-6.13h4.94a3.07,3.07,0,0,0,3.06-3.06V39.1l-4.33-4.33H71.9a3.06,3.06,0,1,1,0-6.13h4.94a3.06,3.06,0,0,1,2.17.9l6.13,6.13a3.06,3.06,0,0,1,.9,2.17V64.42A9.2,9.2,0,0,1,76.84,73.61Z\"/>\n                <rect width=\"102.13\" height=\"102.13\" style=\"fill:none\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fillRule=\"evenodd\">\n                <path\n                    d=\"M67.801 21.993c-3.534 0-6.199-2.344-6.199-5.454V13.11c0-3.36 2.491-5.617 6.199-5.617C71.509 7.493 74 9.75 74 13.11v1.084c0 1.733-1.074 2.474-1.994 2.474h-6.673c.084 1.446 1.576 1.837 2.468 1.837.496 0 .952-.076 1.393-.233.143-.052.432-.133.578-.133.54 0 .75.479.786.549l.848 1.673c.006.006.28.662-.345.955a8.015 8.015 0 0 1-3.26.677zm2.471-8.71c-.022-1.376-.853-2.303-2.471-2.303s-2.45.927-2.471 2.303h4.942zM25.183 21.993c-3.534 0-6.199-2.344-6.199-5.454V13.11c0-3.36 2.491-5.617 6.2-5.617 3.707 0 6.198 2.257 6.198 5.617v1.084c0 1.733-1.074 2.474-1.994 2.474h-6.673c.084 1.446 1.576 1.837 2.468 1.837.497 0 .952-.076 1.393-.233.143-.052.432-.133.578-.133.541 0 .751.479.787.549l.847 1.673c.006.006.281.662-.345.955a8.016 8.016 0 0 1-3.26.677zm2.471-8.71c-.021-1.376-.853-2.303-2.47-2.303-1.619 0-2.45.927-2.472 2.303h4.942zM52.304 21.993c-3.534 0-6.2-2.372-6.2-5.517v-3.302c0-3.398 2.492-5.681 6.2-5.681s6.199 2.283 6.199 5.68v3.303c0 3.145-2.665 5.517-6.2 5.517m0-11.076c-1.56 0-2.35.687-2.35 2.043v3.728c0 1.485 1.478 1.881 2.35 1.881.874 0 2.352-.396 2.352-1.88v-3.73c0-1.355-.791-2.042-2.351-2.042M39.325 30.389c-2.553 0-4.863-.892-6.503-2.51-.204-.193-.297-.397-.274-.603.032-.278.263-.442.312-.474l1.648-1.167c.05-.038.281-.207.604-.207.242 0 .467.094.667.28.903.795 2.164 1.235 3.546 1.235 1.381 0 2.642-.44 3.55-1.24a.958.958 0 0 1 .662-.275c.323 0 .555.169.604.207l1.648 1.167c.05.032.28.196.312.474.023.206-.07.41-.277.606-1.637 1.615-3.946 2.507-6.5 2.507M40.89 22.757c-3.138 0-5.246-2.095-5.246-5.212V1.295c0-.37.31-.671.691-.671h2.575c.38 0 .69.3.69.67v16.012c0 .988.467 1.492 1.388 1.492h.938c.382 0 .692.3.692.67v2.617c0 .37-.31.672-.692.672H40.89zM15.043 9.424a.671.671 0 0 0-.388-.343l-2.382-.787a.68.68 0 0 0-.224-.038.67.67 0 0 0-.644.457l-2.519 8.589c-.066.224-.14.432-.223.618-.197.452-.642.755-1.108.755-.466 0-.91-.303-1.108-.755a5.051 5.051 0 0 1-.223-.618l-2.52-8.59a.67.67 0 0 0-.643-.456.68.68 0 0 0-.224.038L.455 9.08a.671.671 0 0 0-.416.853l2.819 9.315c.427 1.342 1.26 2.367 2.462 2.992a4.793 4.793 0 0 0 2.1.516h.269c.326 0 1.184-.05 2.1-.516 1.204-.625 2.036-1.65 2.463-2.992l2.82-9.315a.656.656 0 0 0-.03-.51\"\n                />\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <rect width=\"50\" height=\"30\" fill=\"#FFF\" rx=\"3\"/>\n                <path fill=\"#26337A\" d=\"M20.745 19.773l1.537-9.537h2.458l-1.537 9.537h-2.458M32.116 10.47a6.075 6.075 0 0 0-2.202-.4c-2.43 0-4.14 1.295-4.154 3.148-.015 1.37 1.22 2.135 2.152 2.59.958.468 1.28.767 1.276 1.184-.007.639-.764.932-1.47.932-.985 0-1.507-.144-2.316-.5l-.316-.152-.343 2.134c.573.266 1.635.497 2.737.509 2.583 0 4.26-1.279 4.28-3.258.009-1.087-.646-1.91-2.064-2.591-.859-.442-1.386-.735-1.38-1.183 0-.396.445-.82 1.408-.82a4.31 4.31 0 0 1 1.839.366l.22.109.333-2.068M35.389 16.392c.203-.548.979-2.666.979-2.666-.015.026.202-.552.326-.91l.166.823s.472 2.276.569 2.753h-2.04zm3.031-6.146h-1.899c-.589 0-1.03.169-1.288.79l-3.65 8.74h2.582s.421-1.175.517-1.433l3.147.005c.074.333.3 1.429.3 1.429h2.28l-1.989-9.53zM18.683 10.244l-2.405 6.502-.258-1.321c-.448-1.523-1.843-3.174-3.404-4l2.2 8.34 2.602-.001 3.87-9.52h-2.605\"/>\n                <path fill=\"#EC982D\" d=\"M14.045 10.238h-3.963l-.032.197c3.083.79 5.124 2.697 5.97 4.99l-.86-4.382c-.15-.605-.581-.784-1.115-.805\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"nonzero\">\n                <path fill=\"#00C7D6\" d=\"M47.979 8.724c-.101-2.383-.06-3.771-.101-5.927-.02-.787-.222-1.595-.787-2.113C46.344 0 45.355 0 44.628 0 30.6.228 18.59.104 4.562.332 3.31.352.122 0 .06 2.01L0 3.73c1.433.829 3.007 2.797 3.916 3.626 1.877 1.782 3.936 3.565 5.106 5.844 12.232-.207 23.495.083 36.03-.56.727-.04 3.007.29 2.947-1.201-.08-.746 0-1.99-.02-2.715z\"/>\n                <g fill=\"#292763\">\n                    <path d=\"M33.097 8.4c-.78 0-1.355-.523-1.355-1.204v-.76c0-.745.542-1.236 1.355-1.236s1.355.491 1.355 1.236v.237c0 .38-.237.539-.44.539h-1.474c.017.317.339.412.542.412.101 0 .203-.016.305-.048a.421.421 0 0 1 .135-.031c.119 0 .17.11.17.126l.186.365s.068.142-.068.206c-.22.11-.457.158-.711.158zm.542-1.917c0-.3-.187-.507-.542-.507-.356 0-.542.206-.542.507h1.084zM42.387 8.4c-.779 0-1.355-.523-1.355-1.204v-.76c0-.745.542-1.236 1.355-1.236s1.355.491 1.355 1.236v.237c0 .38-.237.539-.44.539h-1.474c.017.317.339.412.542.412.102 0 .203-.016.305-.048a.421.421 0 0 1 .135-.031c.119 0 .17.11.17.126l.186.365s.068.142-.068.206c-.22.11-.457.158-.71.158zm.542-1.917c0-.3-.186-.507-.542-.507-.356 0-.542.206-.542.507h1.084zM38.903 8.4c-.77 0-1.355-.523-1.355-1.22v-.729c0-.744.552-1.251 1.355-1.251.82 0 1.355.507 1.355 1.251v.73c0 .696-.585 1.219-1.355 1.219m0-2.44c-.334 0-.518.159-.518.444v.824c0 .332.318.412.518.412.184 0 .519-.095.519-.412v-.824c0-.285-.184-.444-.519-.444M36 10.4c-.585 0-1.118-.214-1.48-.608a.197.197 0 0 1-.068-.148c0-.066.051-.099.068-.115l.379-.28a.215.215 0 0 1 .292.016c.207.198.5.297.809.297.31 0 .602-.099.809-.296a.215.215 0 0 1 .292-.017l.379.28c.017 0 .068.05.068.115 0 .05-.017.098-.068.148-.379.394-.895.608-1.48.608M36.4 8.4c-.698 0-1.174-.451-1.174-1.128V3.745c0-.08.068-.145.153-.145h.578c.086 0 .154.064.154.145v3.48c0 .209.102.321.306.321h.204c.085 0 .153.065.153.145v.564c0 .08-.068.145-.153.145H36.4zM29.26 8.4h-.034-.034c-.069 0-.274-.016-.48-.114-.257-.13-.445-.357-.565-.666l-.034-.065-.616-1.965a.132.132 0 0 1 0-.114.201.201 0 0 1 .085-.081l.548-.179c.017 0 .034-.016.052-.016.068 0 .12.032.154.097l.582 1.901c.017.049.034.097.051.13a.3.3 0 0 0 .257.162.3.3 0 0 0 .257-.162c.017-.049.034-.081.051-.13l.582-1.884c.017-.065.086-.098.154-.098.017 0 .034 0 .051.016l.548.18c.035.015.069.032.086.08a.132.132 0 0 1 0 .114l-.616 1.966-.018.065v.016a1.133 1.133 0 0 1-.564.666c-.223.081-.411.081-.497.081\"/>\n                </g>\n                <path fill=\"#2A2467\" d=\"M15.468 14.93c1.926.057 1.818-2.217.054-2.015-.434.057-.868-.029-1.302-.087-.922-.115-1.248-.518-2.062-.057-.298.173-1.437 3.425-.949 4.951.488 1.555 1.22 2.994 1.682 4.548.163.547.271 1.18-.027 1.67-.353.518-1.085.576-1.628.288-.542-.288-.922-.806-1.275-1.324-.678-.98-1.356-1.987-2.062-2.965-.217-.317-.434-.634-.515-1.037-.108-.518.109-1.036.271-1.525.679-2.015.977-4.146.814-6.276-.081-1.381-.19-3.166 1.004-3.742.542-.259 1.166-.144 1.736-.057 3.418.662 6.836 1.295 10.254 1.957.678.115 1.384.26 1.926.72 1.085.863 1.41 2.303 1.384 3.742v5.67c0 1.037-.353 1.641-1.221 2.13-2.496 1.498-10.363-6.678-8.084-6.591z\"/>\n                <path fill=\"#FFD100\" d=\"M8.374 12.694c.423.335.966.67 1.45.418.26-.146.422-.418.583-.69.422-.668 1.006-1.232 1.428-1.922.423-.69.705-1.526.463-2.3-.402-1.274-1.932-1.65-3.22-1.922a27.803 27.803 0 0 1-6.016-1.944c-.543-.25-2.898-1.358-3.059-.25-.1.69 2.033 2.612 2.496 3.114 1.79 2.027 3.762 3.845 5.875 5.496z\"/>\n                <path fill=\"#2A2467\" d=\"M35.613 34.433s-3.545-1.112-6.107-3.99c-2.563-2.88-4.445-6.614-4.39-10.547 0-1.055.136-2.223-.464-3.078-.327-.456-.845-.77-1.39-.94-2.645-.97-5.78.256-8.261-1.084-1.582-.855-2.509-2.565-3.49-4.104-.982-1.54-2.236-3.136-3.981-3.45-.627-.113-1.336 0-1.772.485-.437.513-.382 1.311-.218 1.967.708 2.508 3.08 4.019 4.416 6.214 1.909 3.05 1.636 7.011 2.618 10.489.9 3.25 2.89 6.042 5.262 8.351 2.372 2.309 5.099 4.162 7.798 5.986 3.026 2.052 6.734 5.558 9.952 7.268V34.433h.027z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n                <g id=\"09.1_Resumo_Pos_Pago_complexo\" transform=\"translate(-185.000000, -603.000000)\" stroke=\"currentColor\">\n                    <g id=\"card_5-copy-7\" transform=\"translate(170.000000, 247.000000)\">\n                        <g id=\"Trama-veloe\" transform=\"translate(110.500000, 383.500000) rotate(-270.000000) translate(-110.500000, -383.500000) translate(84.000000, 289.000000)\">\n                            <g id=\"Group-6\" transform=\"translate(0.000000, -0.000000)\">\n                                <path d=\"M5.51858426,43.3442316 C5.51858426,39.8812322 6.88279615,36.6281115 9.29640182,34.4243846 C9.61121995,34.1095665 9.92603808,34.0046271 10.2408562,34.0046271 C10.6606137,34.0046271 10.8704925,34.3194453 10.9754318,34.4243846 L12.7594012,36.7330509 C12.8643406,36.8379903 13.0742194,37.1528084 13.0742194,37.5725659 C13.0742194,37.8873841 12.96928,38.2022022 12.6544619,38.5170203 C11.3951893,39.7762928 10.7655531,41.4553229 10.7655531,43.3442316 C10.7655531,45.2331404 11.3951893,47.0171098 12.6544619,48.171443 C12.96928,48.4862611 13.0742194,48.6961399 13.0742194,49.1158974 C13.0742194,49.5356549 12.8643406,49.850473 12.7594012,49.9554124 L10.9754318,52.2640787 C10.9754318,52.369018 10.6606137,52.6838362 10.2408562,52.6838362 C9.92603808,52.6838362 9.61121995,52.5788968 9.29640182,52.2640787 C6.88279615,49.9554124 5.51858426,46.8072311 5.51858426,43.3442316\" id=\"Shape\"></path>\n                                <path d=\"M40.7782148,40.6158079 C43.2967598,38.0972628 46.4449411,36.8379903 49.8030012,36.9429297 C50.2227587,36.9429297 50.5375768,37.0478691 50.7474556,37.3626872 C50.9573343,37.6775053 50.9573343,38.0972628 50.9573343,38.2022022 L50.5375768,41.0355654 C50.5375768,41.1405047 50.5375768,41.5602622 50.2227587,41.8750804 C50.0128799,42.0849591 49.6980618,42.1898985 49.2783043,42.1898985 C47.5992743,42.1898985 45.8153049,42.9244741 44.5560323,44.288686 C43.1918204,45.6528979 42.4572448,47.331928 42.4572448,49.010958 C42.4572448,49.4307155 42.3523054,49.7455336 42.1424267,49.9554124 C41.8276086,50.2702305 41.407851,50.2702305 41.3029117,50.2702305 L38.4695485,50.5850486 C38.3646091,50.5850486 37.9448516,50.689988 37.6300335,50.3751699 C37.4201547,50.1652911 37.210276,49.850473 37.210276,49.4307155 C37.0003972,46.2825342 38.3646091,43.1343529 40.7782148,40.6158079\" id=\"Shape\"></path>\n                                <path d=\"M11.9198862,75.0359234 C14.4384313,77.5544684 15.6977038,80.7026497 15.5927644,84.0607098 C15.5927644,84.4804673 15.487825,84.7952854 15.1730069,85.0051641 C14.8581888,85.3199823 14.4384313,85.2150429 14.3334919,85.2150429 L11.5001287,84.9002248 C11.3951893,84.9002248 10.9754318,84.9002248 10.6606137,84.5854066 C10.450735,84.3755279 10.3457956,84.0607098 10.3457956,83.6409523 C10.3457956,81.9619222 9.50628057,80.1779528 8.24700805,78.9186803 C6.88279615,77.5544684 5.20376613,76.8198928 3.5247361,76.8198928 C3.1049786,76.8198928 2.79016047,76.7149534 2.58028172,76.5050746 C2.26546359,76.1902565 2.26546359,75.770499 2.16052421,75.6655596 L1.84570608,72.8321965 C1.84570608,72.7272571 1.7407667,72.3074996 2.05558483,71.9926815 C2.26546359,71.7828027 2.58028172,71.5729239 3.00003922,71.5729239 C6.2531599,71.3630452 9.40134119,72.6223177 11.9198862,75.0359234\" id=\"Shape\"></path>\n                                <path d=\"M39.728821,77.7643472 C39.728821,74.3013477 41.0930329,71.0482271 43.5066386,68.8445002 C43.8214567,68.529682 44.1362748,68.4247426 44.451093,68.4247426 C44.8708505,68.4247426 45.0807292,68.7395608 45.1856686,68.8445002 L46.969638,71.1531664 C47.0745774,71.2581058 47.2844561,71.5729239 47.2844561,71.9926815 C47.2844561,72.3074996 47.1795168,72.6223177 46.8646986,72.9371358 C45.7103655,74.1964084 44.9757899,75.8754384 44.9757899,77.7643472 C44.9757899,79.6532559 45.6054261,81.4372253 46.8646986,82.5915585 C47.1795168,82.9063766 47.2844561,83.1162554 47.2844561,83.5360129 C47.2844561,83.9557704 47.0745774,84.2705885 46.969638,84.3755279 L45.1856686,86.6841942 C45.0807292,86.7891335 44.8708505,87.1039517 44.451093,87.1039517 C44.1362748,87.1039517 43.8214567,86.9990123 43.5066386,86.6841942 C41.0930329,84.3755279 39.728821,81.2273466 39.728821,77.7643472\" id=\"Shape\"></path>\n                                <path d=\"M9.29640182,175.523608 C12.7594012,175.523608 16.0125219,176.88782 18.2162488,179.301426 C18.531067,179.616244 18.6360063,179.931062 18.6360063,180.24588 C18.6360063,180.665638 18.3211882,180.875517 18.2162488,180.980456 L16.0125219,182.764425 C15.9075825,182.869365 15.5927644,183.079244 15.1730069,183.079244 C14.8581888,183.079244 14.5433706,182.974304 14.2285525,182.659486 C12.96928,181.505153 11.29025,180.770577 9.40134119,180.770577 C7.51243241,180.770577 5.72846301,181.400214 4.57412987,182.659486 C4.25931174,182.974304 4.04943299,183.079244 3.62967548,183.079244 C3.20991797,183.079244 2.89509984,182.869365 2.79016047,182.764425 L0.481494184,180.980456 C0.376554807,180.980456 0.0617366772,180.665638 0.0617366772,180.24588 C0.0617366772,179.931062 0.166676054,179.616244 0.481494184,179.301426 C2.58028172,176.88782 5.72846301,175.523608 9.29640182,175.523608\" id=\"Shape\"></path>\n                                <path d=\"M43.4016992,141.103493 C46.8646986,141.103493 50.1178193,142.467705 52.3215462,144.881311 C52.6363643,145.196129 52.7413037,145.510947 52.7413037,145.825765 C52.7413037,146.245522 52.3215462,146.455401 52.3215462,146.560341 L50.0128799,148.34431 C49.9079406,148.449249 49.5931224,148.659128 49.1733649,148.659128 C48.8585468,148.659128 48.5437287,148.554189 48.2289105,148.239371 C46.969638,147.085037 45.290608,146.350462 43.4016992,146.350462 C41.5127904,146.350462 39.728821,146.980098 38.5744879,148.239371 C38.2596698,148.554189 37.9448516,148.659128 37.6300335,148.659128 C37.210276,148.659128 36.8954579,148.449249 36.7905185,148.34431 L34.4818522,146.560341 C34.3769128,146.560341 34.0620947,146.245522 34.0620947,145.825765 C34.0620947,145.510947 34.1670341,145.196129 34.4818522,144.881311 C36.7905185,142.467705 39.9386998,141.103493 43.4016992,141.103493\" id=\"Shape\"></path>\n                                <path d=\"M47.1795168,179.301426 C47.1795168,182.764425 45.8153049,186.017546 43.4016992,188.221273 C43.0868811,188.536091 42.7720629,188.641031 42.4572448,188.641031 C42.0374873,188.641031 41.8276086,188.326212 41.7226692,188.221273 L39.9386998,185.912607 C39.8337604,185.807667 39.6238816,185.492849 39.6238816,185.073092 C39.6238816,184.758274 39.728821,184.443455 40.0436392,184.128637 C41.1979723,182.869365 41.9325479,181.190335 41.9325479,179.301426 C41.9325479,177.412517 41.3029117,175.628548 40.0436392,174.474215 C39.728821,174.159397 39.6238816,173.949518 39.6238816,173.52976 C39.6238816,173.110003 39.8337604,172.795185 39.9386998,172.690245 L41.7226692,170.381579 C41.8276086,170.27664 42.0374873,169.961822 42.4572448,169.961822 C42.7720629,169.961822 43.0868811,170.066761 43.4016992,170.381579 C45.8153049,172.585306 47.1795168,175.733487 47.1795168,179.301426\" id=\"Shape\"></path>\n                                <path d=\"M12.96928,144.881311 C12.96928,148.34431 11.6050681,151.597431 9.19146244,153.801158 C8.87664431,154.115976 8.56182618,154.220915 8.24700805,154.220915 C7.82725054,154.220915 7.61737179,153.906097 7.51243241,153.801158 L5.72846301,151.492491 C5.62352364,151.387552 5.41364488,151.072734 5.41364488,150.652976 C5.41364488,150.338158 5.51858426,150.02334 5.83340239,149.708522 C6.98773553,148.449249 7.72231117,146.770219 7.72231117,144.881311 C7.72231117,142.992402 7.09267491,141.208432 5.83340239,140.054099 C5.51858426,139.739281 5.41364488,139.424463 5.41364488,139.109645 C5.41364488,138.689887 5.62352364,138.375069 5.72846301,138.27013 L7.51243241,135.961464 C7.51243241,135.856524 7.82725054,135.541706 8.24700805,135.541706 C8.56182618,135.541706 8.87664431,135.646645 9.19146244,135.961464 C11.7100075,138.16519 12.96928,141.313372 12.96928,144.881311\" id=\"Shape\"></path>\n                                <path d=\"M11.9198862,107.732771 C14.4384313,110.251316 15.6977038,113.399498 15.5927644,116.757558 C15.5927644,117.177315 15.487825,117.492133 15.1730069,117.702012 C14.8581888,118.01683 14.4384313,117.911891 14.3334919,117.911891 L11.5001287,117.597073 C11.3951893,117.597073 10.9754318,117.597073 10.6606137,117.282254 C10.450735,117.072376 10.3457956,116.757558 10.3457956,116.3378 C10.3457956,114.65877 9.50628057,112.874801 8.24700805,111.615528 C6.88279615,110.251316 5.20376613,109.516741 3.5247361,109.516741 C3.1049786,109.516741 2.79016047,109.411801 2.58028172,109.201922 C2.26546359,108.887104 2.26546359,108.467347 2.16052421,108.362407 L1.84570608,105.529044 C1.84570608,105.424105 1.7407667,105.004347 2.05558483,104.689529 C2.26546359,104.479651 2.58028172,104.269772 3.00003922,104.269772 C6.2531599,103.954954 9.40134119,105.319166 11.9198862,107.732771\" id=\"Shape\"></path>\n                                <path d=\"M39.728821,110.461195 C39.728821,106.998196 41.0930329,103.745075 43.5066386,101.541348 C43.8214567,101.22653 44.1362748,101.12159 44.451093,101.12159 C44.8708505,101.12159 45.0807292,101.436409 45.1856686,101.541348 L46.969638,103.850014 C47.0745774,103.954954 47.2844561,104.269772 47.2844561,104.689529 C47.2844561,105.004347 47.1795168,105.319166 46.8646986,105.633984 C45.7103655,106.893256 44.9757899,108.572286 44.9757899,110.461195 C44.9757899,112.350104 45.6054261,114.134073 46.8646986,115.288406 C47.1795168,115.603224 47.2844561,115.813103 47.2844561,116.232861 C47.2844561,116.652618 47.0745774,116.967436 46.969638,117.072376 L45.1856686,119.381042 C45.0807292,119.485981 44.8708505,119.8008 44.451093,119.8008 C44.1362748,119.8008 43.8214567,119.69586 43.5066386,119.381042 C41.0930329,117.072376 39.728821,113.924194 39.728821,110.461195\" id=\"Shape\"></path>\n                                <path d=\"M43.4016992,11.3170104 C39.9386998,11.3170104 36.6855791,9.95279851 34.4818522,7.53919284 C34.1670341,7.22437471 34.0620947,6.90955659 34.0620947,6.59473846 C34.1670341,6.17498095 34.4818522,5.9651022 34.4818522,5.86016282 L36.7905185,4.07619342 C36.8954579,3.97125404 37.210276,3.76137529 37.6300335,3.76137529 C37.9448516,3.76137529 38.2596698,3.86631466 38.5744879,4.18113279 C39.8337604,5.33546594 41.5127904,6.07004157 43.4016992,6.07004157 C45.290608,6.07004157 47.0745774,5.44040531 48.3338499,4.18113279 C48.5437287,3.86631466 48.8585468,3.76137529 49.2783043,3.76137529 C49.6980618,3.76137529 50.0128799,3.97125404 50.1178193,4.07619342 L52.4264856,5.86016282 C52.531425,5.86016282 52.8462431,6.17498095 52.8462431,6.59473846 C52.8462431,6.90955659 52.7413037,7.22437471 52.4264856,7.53919284 C50.1178193,9.95279851 46.969638,11.3170104 43.4016992,11.3170104\" id=\"Shape\"></path>\n                                <path d=\"M6.56797802,10.2676166 C4.04943299,7.7490716 2.79016047,4.6008903 2.89509984,1.24283025 C2.89509984,0.823072744 3.00003922,0.508254614 3.31485735,0.298375861 C3.62967548,-0.0164422687 4.04943299,0.0884971078 4.15437236,0.0884971078 L6.98773553,0.403315238 C7.09267491,0.403315238 7.51243241,0.403315238 7.82725054,0.718133367 C8.0371293,0.92801212 8.14206867,1.24283025 8.14206867,1.66258776 C8.14206867,3.34161778 8.98158369,5.12558718 10.2408562,6.3848597 C11.6050681,7.7490716 13.2840981,8.48364723 14.9631282,8.48364723 C15.3828857,8.48364723 15.6977038,8.58858661 15.9075825,8.79846536 C16.2224007,9.11328349 16.2224007,9.533041 16.2224007,9.63798038 L16.5372188,12.4713435 C16.5372188,12.5762829 16.6421582,12.9960404 16.32734,13.3108586 C16.1174613,13.5207373 15.8026432,13.7306161 15.3828857,13.7306161 C12.3396437,14.0454342 9.08652306,12.6812223 6.56797802,10.2676166\" id=\"Shape\"></path>\n                            </g>\n                        </g>\n                    </g>\n                </g>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"\n    <g fill=\"none\" fill-rule=\"evenodd\" opacity=\"0.858150653\">\n        <g id=\"07.6.1_Fatura_Pos_Pago_Simples_Detalhe\" transform=\"translate(-877.000000, -2309.000000)\" stroke=\"#C5C3D8\" stroke-width=\"1.8\">\n            <g id=\"Infos\" transform=\"translate(0.000000, 2255.000000)\">\n                <g id=\"Trama-veloe-Copy\" transform=\"translate(1066.000000, 172.500000) rotate(-270.000000) translate(-1066.000000, -172.500000) translate(949.000000, -16.000000)\">\n                    <g id=\"Group-8\" transform=\"translate(-0.000000, 0.000000)\">\n                        <g id=\"Group-2\" transform=\"translate(0.000000, 0.000000)\">\n                            <path d=\"M11,18.5566253 C11,11.6760789 13.7267556,5.21253521 18.5510156,0.834005634 C19.1802669,0.208501408 19.8095182,0 20.4387695,0 C21.2777712,0 21.6972721,0.625504225 21.9070225,0.834005634 L25.4727799,5.42103662 C25.6825303,5.62953803 26.1020312,6.25504225 26.1020312,7.08904788 C26.1020312,7.71455211 25.8922807,8.34005634 25.2630294,8.96556056 C22.7460242,11.4675775 21.4875216,14.8036 21.4875216,18.5566253 C21.4875216,22.3096507 22.7460242,25.8541746 25.2630294,28.1476901 C25.8922807,28.7731944 26.1020312,29.1901972 26.1020312,30.0242028 C26.1020312,30.8582084 25.6825303,31.4837127 25.4727799,31.6922141 L21.9070225,36.2792451 C21.9070225,36.4877465 21.2777712,37.1132507 20.4387695,37.1132507 C19.8095182,37.1132507 19.1802669,36.9047493 18.5510156,36.2792451 C13.7267556,31.6922141 11,25.4371718 11,18.5566253\" id=\"Shape\"></path>\n                            <path d=\"M81.1737808,12.3095901 C86.2077912,7.30555631 92.5003042,4.80353941 99.212318,5.01204082 C100.05132,5.01204082 100.680571,5.22054223 101.100072,5.84604645 C101.519573,6.47155068 101.519573,7.30555631 101.519573,7.51405772 L100.680571,13.1435957 C100.680571,13.3520972 100.680571,14.1861028 100.05132,14.811607 C99.6318189,15.2286098 99.0025676,15.4371112 98.1635659,15.4371112 C94.807559,15.4371112 91.2418016,16.8966211 88.7247964,19.6071394 C85.9980408,22.3176577 84.5297878,25.6536802 84.5297878,28.9897028 C84.5297878,29.8237084 84.3200373,30.4492126 83.9005365,30.8662155 C83.2712852,31.4917197 82.4322834,31.4917197 82.222533,31.4917197 L76.5592713,32.1172239 C76.3495209,32.1172239 75.5105192,32.3257253 74.8812679,31.7002211 C74.461767,31.2832183 74.0422661,30.657714 74.0422661,29.8237084 C73.6227653,23.5686662 76.3495209,17.3136239 81.1737808,12.3095901\" id=\"Shape\"></path>\n                            <path d=\"M23.1696016,80.925456 C28.203612,85.9294898 30.7206172,92.184532 30.5108667,98.8565771 C30.5108667,99.6905827 30.3011163,100.316087 29.671865,100.73309 C29.0426137,101.358594 28.203612,101.150093 27.9938616,101.150093 L22.3305999,100.524588 C22.1208494,100.524588 21.2818477,100.524588 20.6525964,99.8990841 C20.2330955,99.4820813 20.0233451,98.8565771 20.0233451,98.0225714 C20.0233451,94.6865489 18.3453417,91.142025 15.8283365,88.6400081 C13.1015808,85.9294898 9.74557391,84.4699799 6.38956699,84.4699799 C5.55056526,84.4699799 4.92131396,84.2614785 4.5018131,83.8444757 C3.8725618,83.2189715 3.8725618,82.3849658 3.66281137,82.1764644 L3.03356007,76.5469264 C3.03356007,76.338425 2.82380964,75.5044193 3.45306093,74.8789151 C3.8725618,74.4619123 4.5018131,74.0449095 5.34081483,74.0449095 C11.8430782,73.6279067 18.1355912,76.1299236 23.1696016,80.925456\" id=\"Shape\"></path>\n                            <path d=\"M79,86.5566253 C79,79.6760789 81.7267556,73.2125352 86.5510156,68.8340056 C87.1802669,68.2085014 87.8095182,68 88.4387695,68 C89.2777712,68 89.6972721,68.6255042 89.9070225,68.8340056 L93.4727799,73.4210366 C93.6825303,73.629538 94.1020312,74.2550423 94.1020312,75.0890479 C94.1020312,75.7145521 93.8922807,76.3400563 93.2630294,76.9655606 C90.9557747,79.4675775 89.4875216,82.8036 89.4875216,86.5566253 C89.4875216,90.3096507 90.7460242,93.8541746 93.2630294,96.1476901 C93.8922807,96.7731944 94.1020312,97.1901972 94.1020312,98.0242028 C94.1020312,98.8582084 93.6825303,99.4837127 93.4727799,99.6922141 L89.9070225,104.279245 C89.6972721,104.487746 89.2777712,105.113251 88.4387695,105.113251 C87.8095182,105.113251 87.1802669,104.904749 86.5510156,104.279245 C81.7267556,99.6922141 79,93.4371718 79,86.5566253\" id=\"Shape\"></path>\n                            <path d=\"M18.4580381,281 C25.3798024,281 31.8820658,283.710518 36.2868249,288.506051 C36.9160761,289.131555 37.1258266,289.757059 37.1258266,290.382563 C37.1258266,291.216569 36.4965753,291.633572 36.2868249,291.842073 L31.8820658,295.386597 C31.6723153,295.595099 31.043064,296.012101 30.2040623,296.012101 C29.574811,296.012101 28.9455597,295.8036 28.3163084,295.178096 C25.7993032,292.88458 22.4432963,291.42507 18.6677885,291.42507 C14.8922807,291.42507 11.3265234,292.676079 9.0192686,295.178096 C8.39001731,295.8036 7.97051644,296.012101 7.13151471,296.012101 C6.29251298,296.012101 5.66326168,295.595099 5.45351125,295.386597 L0.839001731,291.842073 C0.629251298,291.842073 7.10542736e-14,291.216569 7.10542736e-14,290.382563 C7.10542736e-14,289.757059 0.209750433,289.131555 0.839001731,288.506051 C5.03401038,283.710518 11.3265234,281 18.4580381,281\" id=\"Shape\"></path>\n                            <path d=\"M86.6677885,212 C93.5895528,212 100.091816,214.710518 104.496575,219.506051 C105.125827,220.131555 105.335577,220.757059 105.335577,221.382563 C105.335577,222.216569 104.496575,222.633572 104.496575,222.842073 L99.8820658,226.386597 C99.6723153,226.595099 99.043064,227.012101 98.2040623,227.012101 C97.574811,227.012101 96.9455597,226.8036 96.3163084,226.178096 C93.7993032,223.88458 90.4432963,222.42507 86.6677885,222.42507 C82.8922807,222.42507 79.3265234,223.676079 77.0192686,226.178096 C76.3900173,226.8036 75.760766,227.012101 75.1315147,227.012101 C74.292513,227.012101 73.6632617,226.595099 73.4535112,226.386597 L68.8390017,222.842073 C68.6292513,222.842073 68,222.216569 68,221.382563 C68,220.757059 68.2097504,220.131555 68.8390017,219.506051 C73.4535112,214.710518 79.7460242,212 86.6677885,212\" id=\"Shape\"></path>\n                            <path d=\"M94.1020312,288.556625 C94.1020312,295.437172 91.3752755,301.900715 86.5510156,306.279245 C85.9217643,306.904749 85.292513,307.113251 84.6632617,307.113251 C83.82426,307.113251 83.4047591,306.487746 83.1950087,306.279245 L79.6292513,301.692214 C79.4195009,301.483713 79,300.858208 79,300.024203 C79,299.398699 79.2097504,298.773194 79.8390017,298.14769 C82.1462565,295.645673 83.6145095,292.309651 83.6145095,288.556625 C83.6145095,284.8036 82.3560069,281.259076 79.8390017,278.965561 C79.2097504,278.340056 79,277.923054 79,277.089048 C79,276.255042 79.4195009,275.629538 79.6292513,275.421037 L83.1950087,270.834006 C83.4047591,270.625504 83.82426,270 84.6632617,270 C85.292513,270 85.9217643,270.208501 86.5510156,270.834006 C91.3752755,275.212535 94.1020312,281.467577 94.1020312,288.556625\" id=\"Shape\"></path>\n                            <path d=\"M26.1020312,219.556625 C26.1020312,226.437172 23.3752755,232.900715 18.5510156,237.279245 C17.9217643,237.904749 17.292513,238.113251 16.6632617,238.113251 C15.82426,238.113251 15.4047591,237.487746 15.1950087,237.279245 L11.6292513,232.692214 C11.4195009,232.483713 11,231.858208 11,231.024203 C11,230.398699 11.2097504,229.773194 11.8390017,229.14769 C14.1462565,226.645673 15.6145095,223.309651 15.6145095,219.556625 C15.6145095,215.8036 14.3560069,212.259076 11.8390017,209.965561 C11.2097504,209.340056 11,208.714552 11,208.089048 C11,207.255042 11.4195009,206.629538 11.6292513,206.421037 L15.1950087,201.834006 C15.1950087,201.625504 15.82426,201 16.6632617,201 C17.292513,201 17.9217643,201.208501 18.5510156,201.834006 C23.585026,206.212535 26.1020312,212.467577 26.1020312,219.556625\" id=\"Shape\"></path>\n                            <path d=\"M23.1696016,145.969567 C28.203612,150.973601 30.7206172,157.228643 30.5108667,163.900688 C30.5108667,164.734694 30.3011163,165.360198 29.671865,165.777201 C29.0426137,166.402705 28.203612,166.194204 27.9938616,166.194204 L22.3305999,165.568699 C22.1208494,165.568699 21.2818477,165.568699 20.6525964,164.943195 C20.2330955,164.526192 20.0233451,163.900688 20.0233451,163.066682 C20.0233451,159.73066 18.3453417,156.186136 15.8283365,153.684119 C13.1015808,150.973601 9.74557391,149.514091 6.38956699,149.514091 C5.55056526,149.514091 4.92131396,149.30559 4.5018131,148.888587 C3.8725618,148.263082 3.8725618,147.429077 3.66281137,147.220575 L3.03356007,141.591037 C3.03356007,141.382536 2.82380964,140.54853 3.45306093,139.923026 C3.8725618,139.506023 4.5018131,139.089021 5.34081483,139.089021 C11.8430782,138.463516 18.1355912,141.174035 23.1696016,145.969567\" id=\"Shape\"></path>\n                            <path d=\"M79,151.556625 C79,144.676079 81.7267556,138.212535 86.5510156,133.834006 C87.1802669,133.208501 87.8095182,133 88.4387695,133 C89.2777712,133 89.6972721,133.625504 89.9070225,133.834006 L93.4727799,138.421037 C93.6825303,138.629538 94.1020312,139.255042 94.1020312,140.089048 C94.1020312,140.714552 93.8922807,141.340056 93.2630294,141.965561 C90.9557747,144.467577 89.4875216,147.8036 89.4875216,151.556625 C89.4875216,155.309651 90.7460242,158.854175 93.2630294,161.14769 C93.8922807,161.773194 94.1020312,162.190197 94.1020312,163.024203 C94.1020312,163.858208 93.6825303,164.483713 93.4727799,164.692214 L89.9070225,169.279245 C89.6972721,169.487746 89.2777712,170.113251 88.4387695,170.113251 C87.8095182,170.113251 87.1802669,169.904749 86.5510156,169.279245 C81.7267556,164.692214 79,158.437172 79,151.556625\" id=\"Shape\"></path>\n                            <path d=\"M23.1696016,351.969567 C28.203612,356.973601 30.7206172,363.228643 30.5108667,369.900688 C30.5108667,370.734694 30.3011163,371.360198 29.671865,371.777201 C29.0426137,372.402705 28.203612,372.194204 27.9938616,372.194204 L22.3305999,371.568699 C22.1208494,371.568699 21.2818477,371.568699 20.6525964,370.943195 C20.2330955,370.526192 20.0233451,369.900688 20.0233451,369.066682 C20.0233451,365.73066 18.3453417,362.186136 15.8283365,359.684119 C13.1015808,356.973601 9.74557391,355.514091 6.38956699,355.514091 C5.55056526,355.514091 4.92131396,355.30559 4.5018131,354.888587 C3.8725618,354.263082 3.8725618,353.429077 3.66281137,353.220575 L3.03356007,347.591037 C3.03356007,347.382536 2.82380964,346.54853 3.45306093,345.923026 C3.8725618,345.506023 4.5018131,345.089021 5.34081483,345.089021 C11.8430782,344.463516 18.1355912,347.174035 23.1696016,351.969567\" id=\"Shape\"></path>\n                            <path d=\"M79,357.556625 C79,350.676079 81.7267556,344.212535 86.5510156,339.834006 C87.1802669,339.208501 87.8095182,339 88.4387695,339 C89.2777712,339 89.6972721,339.625504 89.9070225,339.834006 L93.4727799,344.421037 C93.6825303,344.629538 94.1020312,345.255042 94.1020312,346.089048 C94.1020312,346.714552 93.8922807,347.340056 93.2630294,347.965561 C90.9557747,350.467577 89.4875216,353.8036 89.4875216,357.556625 C89.4875216,361.309651 90.7460242,364.854175 93.2630294,367.14769 C93.8922807,367.773194 94.1020312,368.190197 94.1020312,369.024203 C94.1020312,369.858208 93.6825303,370.483713 93.4727799,370.692214 L89.9070225,375.279245 C89.6972721,375.487746 89.2777712,376.113251 88.4387695,376.113251 C87.8095182,376.113251 87.1802669,375.904749 86.5510156,375.279245 C81.7267556,370.692214 79,364.437172 79,357.556625\" id=\"Shape\"></path>\n                            <path d=\"M141.259542,18.5566253 C141.259542,11.6760789 143.986298,5.21253521 148.810558,0.834005634 C149.439809,0.208501408 150.06906,0 150.698311,0 C151.537313,0 151.956814,0.625504225 152.166564,0.834005634 L155.732322,5.42103662 C155.942072,5.62953803 156.361573,6.25504225 156.361573,7.08904788 C156.361573,7.71455211 156.151823,8.34005634 155.522571,8.96556056 C153.005566,11.4675775 151.747064,14.8036 151.747064,18.5566253 C151.747064,22.3096507 153.005566,25.8541746 155.522571,28.1476901 C156.151823,28.7731944 156.361573,29.1901972 156.361573,30.0242028 C156.361573,30.8582084 155.942072,31.4837127 155.732322,31.6922141 L152.166564,36.2792451 C152.166564,36.4877465 151.537313,37.1132507 150.698311,37.1132507 C150.06906,37.1132507 149.439809,36.9047493 148.810558,36.2792451 C143.986298,31.6922141 141.259542,25.4371718 141.259542,18.5566253\" id=\"Shape\"></path>\n                            <path d=\"M209.433323,12.3095901 C214.467333,7.30555631 220.759846,4.80353941 227.47186,5.01204082 C228.310862,5.01204082 228.940113,5.22054223 229.359614,5.84604645 C229.779115,6.47155068 229.779115,7.30555631 229.779115,7.51405772 L228.940113,13.1435957 C228.940113,13.3520972 228.940113,14.1861028 228.310862,14.811607 C227.891361,15.2286098 227.26211,15.4371112 226.423108,15.4371112 C223.067101,15.4371112 219.501344,16.8966211 216.984338,19.6071394 C214.257583,22.3176577 212.78933,25.6536802 212.78933,28.9897028 C212.78933,29.8237084 212.579579,30.4492126 212.160078,30.8662155 C211.530827,31.4917197 210.691825,31.4917197 210.482075,31.4917197 L204.818813,32.1172239 C204.609063,32.1172239 203.770061,32.3257253 203.14081,31.7002211 C202.721309,31.2832183 202.301808,30.657714 202.301808,29.8237084 C201.882307,23.5686662 204.609063,17.3136239 209.433323,12.3095901\" id=\"Shape\"></path>\n                            <path d=\"M153.429144,80.925456 C158.463154,85.9294898 160.980159,92.184532 160.770409,98.8565771 C160.770409,99.6905827 160.560658,100.316087 159.931407,100.73309 C159.302156,101.358594 158.463154,101.150093 158.253404,101.150093 L152.590142,100.524588 C152.380391,100.524588 151.54139,100.524588 150.912138,99.8990841 C150.492638,99.4820813 150.282887,98.8565771 150.282887,98.0225714 C150.282887,94.6865489 148.604884,91.142025 146.087878,88.6400081 C143.361123,85.9294898 140.005116,84.4699799 136.649109,84.4699799 C135.810107,84.4699799 135.180856,84.2614785 134.761355,83.8444757 C134.132104,83.2189715 134.132104,82.3849658 133.922353,82.1764644 L133.293102,76.5469264 C133.293102,76.338425 133.083352,75.5044193 133.712603,74.8789151 C134.132104,74.4619123 134.761355,74.0449095 135.600357,74.0449095 C142.10262,73.6279067 148.395133,76.1299236 153.429144,80.925456\" id=\"Shape\"></path>\n                            <path d=\"M207.259542,86.5566253 C207.259542,79.6760789 209.986298,73.2125352 214.810558,68.8340056 C215.439809,68.2085014 216.06906,68 216.698311,68 C217.537313,68 217.956814,68.6255042 218.166564,68.8340056 L221.732322,73.4210366 C221.942072,73.629538 222.361573,74.2550423 222.361573,75.0890479 C222.361573,75.7145521 222.151823,76.3400563 221.522571,76.9655606 C219.215317,79.4675775 217.747064,82.8036 217.747064,86.5566253 C217.747064,90.3096507 219.005566,93.8541746 221.522571,96.1476901 C222.151823,96.7731944 222.361573,97.1901972 222.361573,98.0242028 C222.361573,98.8582084 221.942072,99.4837127 221.732322,99.6922141 L218.166564,104.279245 C217.956814,104.487746 217.537313,105.113251 216.698311,105.113251 C216.06906,105.113251 215.439809,104.904749 214.810558,104.279245 C209.986298,99.6922141 207.259542,93.4371718 207.259542,86.5566253\" id=\"Shape\"></path>\n                            <path d=\"M148.71758,281 C155.639344,281 162.141608,283.710518 166.546367,288.506051 C167.175618,289.131555 167.385369,289.757059 167.385369,290.382563 C167.385369,291.216569 166.756117,291.633572 166.546367,291.842073 L162.141608,295.386597 C161.931857,295.595099 161.302606,296.012101 160.463604,296.012101 C159.834353,296.012101 159.205102,295.8036 158.57585,295.178096 C156.058845,292.88458 152.702838,291.42507 148.92733,291.42507 C145.151823,291.42507 141.586065,292.676079 139.278811,295.178096 C138.649559,295.8036 138.230058,296.012101 137.391057,296.012101 C136.552055,296.012101 135.922804,295.595099 135.713053,295.386597 L131.098544,291.842073 C130.888793,291.842073 130.259542,291.216569 130.259542,290.382563 C130.259542,289.757059 130.469292,289.131555 131.098544,288.506051 C135.293552,283.710518 141.586065,281 148.71758,281\" id=\"Shape\"></path>\n                            <path d=\"M214.92733,212 C221.849095,212 228.351358,214.710518 232.756117,219.506051 C233.385369,220.131555 233.595119,220.757059 233.595119,221.382563 C233.595119,222.216569 232.756117,222.633572 232.756117,222.842073 L228.141608,226.386597 C227.931857,226.595099 227.302606,227.012101 226.463604,227.012101 C225.834353,227.012101 225.205102,226.8036 224.57585,226.178096 C222.058845,223.88458 218.702838,222.42507 214.92733,222.42507 C211.151823,222.42507 207.586065,223.676079 205.278811,226.178096 C204.649559,226.8036 204.020308,227.012101 203.391057,227.012101 C202.552055,227.012101 201.922804,226.595099 201.713053,226.386597 L197.098544,222.842073 C196.888793,222.842073 196.259542,222.216569 196.259542,221.382563 C196.259542,220.757059 196.469292,220.131555 197.098544,219.506051 C201.713053,214.710518 208.005566,212 214.92733,212\" id=\"Shape\"></path>\n                            <path d=\"M222.361573,288.556625 C222.361573,295.437172 219.634818,301.900715 214.810558,306.279245 C214.181306,306.904749 213.552055,307.113251 212.922804,307.113251 C212.083802,307.113251 211.664301,306.487746 211.454551,306.279245 L207.888793,301.692214 C207.679043,301.483713 207.259542,300.858208 207.259542,300.024203 C207.259542,299.398699 207.469292,298.773194 208.098544,298.14769 C210.405798,295.645673 211.874052,292.309651 211.874052,288.556625 C211.874052,284.8036 210.615549,281.259076 208.098544,278.965561 C207.469292,278.340056 207.259542,277.923054 207.259542,277.089048 C207.259542,276.255042 207.679043,275.629538 207.888793,275.421037 L211.454551,270.834006 C211.664301,270.625504 212.083802,270 212.922804,270 C213.552055,270 214.181306,270.208501 214.810558,270.834006 C219.634818,275.212535 222.361573,281.467577 222.361573,288.556625\" id=\"Shape\"></path>\n                            <path d=\"M156.361573,219.556625 C156.361573,226.437172 153.634818,232.900715 148.810558,237.279245 C148.181306,237.904749 147.552055,238.113251 146.922804,238.113251 C146.083802,238.113251 145.664301,237.487746 145.454551,237.279245 L141.888793,232.692214 C141.679043,232.483713 141.259542,231.858208 141.259542,231.024203 C141.259542,230.398699 141.469292,229.773194 142.098544,229.14769 C144.405798,226.645673 145.874052,223.309651 145.874052,219.556625 C145.874052,215.8036 144.615549,212.259076 142.098544,209.965561 C141.469292,209.340056 141.259542,208.714552 141.259542,208.089048 C141.259542,207.255042 141.679043,206.629538 141.888793,206.421037 L145.454551,201.834006 C145.454551,201.625504 146.083802,201 146.922804,201 C147.552055,201 148.181306,201.208501 148.810558,201.834006 C153.844568,206.212535 156.361573,212.467577 156.361573,219.556625\" id=\"Shape\"></path>\n                            <path d=\"M153.429144,145.969567 C158.463154,150.973601 160.980159,157.228643 160.770409,163.900688 C160.770409,164.734694 160.560658,165.360198 159.931407,165.777201 C159.302156,166.402705 158.463154,166.194204 158.253404,166.194204 L152.590142,165.568699 C152.380391,165.568699 151.54139,165.568699 150.912138,164.943195 C150.492638,164.526192 150.282887,163.900688 150.282887,163.066682 C150.282887,159.73066 148.604884,156.186136 146.087878,153.684119 C143.361123,150.973601 140.005116,149.514091 136.649109,149.514091 C135.810107,149.514091 135.180856,149.30559 134.761355,148.888587 C134.132104,148.263082 134.132104,147.429077 133.922353,147.220575 L133.293102,141.591037 C133.293102,141.382536 133.083352,140.54853 133.712603,139.923026 C134.132104,139.506023 134.761355,139.089021 135.600357,139.089021 C142.10262,138.463516 148.395133,141.174035 153.429144,145.969567\" id=\"Shape\"></path>\n                            <path d=\"M207.259542,151.556625 C207.259542,144.676079 209.986298,138.212535 214.810558,133.834006 C215.439809,133.208501 216.06906,133 216.698311,133 C217.537313,133 217.956814,133.625504 218.166564,133.834006 L221.732322,138.421037 C221.942072,138.629538 222.361573,139.255042 222.361573,140.089048 C222.361573,140.714552 222.151823,141.340056 221.522571,141.965561 C219.215317,144.467577 217.747064,147.8036 217.747064,151.556625 C217.747064,155.309651 219.005566,158.854175 221.522571,161.14769 C222.151823,161.773194 222.361573,162.190197 222.361573,163.024203 C222.361573,163.858208 221.942072,164.483713 221.732322,164.692214 L218.166564,169.279245 C217.956814,169.487746 217.537313,170.113251 216.698311,170.113251 C216.06906,170.113251 215.439809,169.904749 214.810558,169.279245 C209.986298,164.692214 207.259542,158.437172 207.259542,151.556625\" id=\"Shape\"></path>\n                            <path d=\"M153.429144,351.969567 C158.463154,356.973601 160.980159,363.228643 160.770409,369.900688 C160.770409,370.734694 160.560658,371.360198 159.931407,371.777201 C159.302156,372.402705 158.463154,372.194204 158.253404,372.194204 L152.590142,371.568699 C152.380391,371.568699 151.54139,371.568699 150.912138,370.943195 C150.492638,370.526192 150.282887,369.900688 150.282887,369.066682 C150.282887,365.73066 148.604884,362.186136 146.087878,359.684119 C143.361123,356.973601 140.005116,355.514091 136.649109,355.514091 C135.810107,355.514091 135.180856,355.30559 134.761355,354.888587 C134.132104,354.263082 134.132104,353.429077 133.922353,353.220575 L133.293102,347.591037 C133.293102,347.382536 133.083352,346.54853 133.712603,345.923026 C134.132104,345.506023 134.761355,345.089021 135.600357,345.089021 C142.10262,344.463516 148.395133,347.174035 153.429144,351.969567\" id=\"Shape\"></path>\n                            <path d=\"M207.259542,357.556625 C207.259542,350.676079 209.986298,344.212535 214.810558,339.834006 C215.439809,339.208501 216.06906,339 216.698311,339 C217.537313,339 217.956814,339.625504 218.166564,339.834006 L221.732322,344.421037 C221.942072,344.629538 222.361573,345.255042 222.361573,346.089048 C222.361573,346.714552 222.151823,347.340056 221.522571,347.965561 C219.215317,350.467577 217.747064,353.8036 217.747064,357.556625 C217.747064,361.309651 219.005566,364.854175 221.522571,367.14769 C222.151823,367.773194 222.361573,368.190197 222.361573,369.024203 C222.361573,369.858208 221.942072,370.483713 221.732322,370.692214 L218.166564,375.279245 C217.956814,375.487746 217.537313,376.113251 216.698311,376.113251 C216.06906,376.113251 215.439809,375.904749 214.810558,375.279245 C209.986298,370.692214 207.259542,364.437172 207.259542,357.556625\" id=\"Shape\"></path>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>"};module.exports=exports["default"];

/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M43.592 56.893c-.68 0-1.359-.194-1.942-.776-2.815-2.428-4.368-6.02-4.368-9.71v-17.28c0-1.651 1.359-3.01 3.01-3.01 1.65 0 3.009 1.359 3.009 3.01v17.28c0 1.943.874 3.884 2.33 5.243 1.262 1.068 1.36 2.913.291 4.175-.68.777-1.456 1.068-2.33 1.068z\"/>\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M50.097 70.194c-6.116 0-11.845-2.427-16.214-6.699-4.368-4.272-6.699-10.097-6.699-16.213V19.417c0-1.65 1.36-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01v27.865c0 4.466 1.747 8.737 4.951 11.941a16.825 16.825 0 0 0 11.942 4.952c4.466 0 8.738-1.748 11.942-4.952a16.825 16.825 0 0 0 4.951-11.941V19.417c0-1.65 1.36-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01v27.865c0 6.116-2.427 11.844-6.7 16.213-4.271 4.37-10.096 6.7-16.213 6.7z\"/>\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M50.097 83.98c-1.65 0-3.01-1.359-3.01-3.01V67.185c0-1.65 1.36-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01v13.787c0 1.65-1.36 3.01-3.01 3.01z\"/>\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M59.903 83.98H40.097c-1.65 0-3.01-1.359-3.01-3.01 0-1.65 1.36-3.009 3.01-3.009h19.806c1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.36 3.01-3.01 3.01zM70.097 45.146H70c-1.65 0-3.01-1.36-3.01-3.01 0-1.65 1.36-3.01 3.01-3.01h.097c4.272 0 7.767-3.495 7.767-7.767v-1.262c0-4.272-3.495-7.767-7.767-7.767h-40c-4.272 0-7.767 3.495-7.767 7.767v1.36c0 4.271 3.495 7.766 7.767 7.766 1.65 0 3.01 1.36 3.01 3.01 0 1.65-1.36 3.01-3.01 3.01a13.673 13.673 0 0 1-13.69-13.69v-1.456c0-7.573 6.117-13.69 13.69-13.69h40c7.573 0 13.69 6.117 13.69 13.69v1.36c0 7.572-6.117 13.689-13.69 13.689z\"/>\n                <path d=\"M.388.583h99.029v99.029H.388z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"#currentColor\" fill-rule=\"evenodd\">\n                <path d=\"M33.766 22h-3.29c-.681 0-1.234-.519-1.234-1.159s.553-1.16 1.234-1.16h2.056v-8.776c0-1.978-1.714-3.587-3.82-3.587h-6.478C21.553 7.318 21 6.8 21 6.16c0-.64.553-1.16 1.234-1.16h6.478C32.179 5 35 7.649 35 10.905v9.936c0 .64-.553 1.159-1.234 1.159M26.686 21h-.003l-11.371-.019c-.726-.001-1.313-.446-1.312-.993.002-.546.59-.988 1.315-.988h.003l11.37.019c.726.001 1.314.446 1.312.992-.001.547-.59.989-1.314.989\"/>\n                <path d=\"M22.785 17c-.671 0-1.215-.518-1.215-1.158V3.476c0-.639-.545-1.159-1.216-1.159H6.646c-.67 0-1.215.52-1.215 1.159v4.563c0 .64-.544 1.158-1.215 1.158C3.544 9.197 3 8.68 3 8.04V3.476C3 1.559 4.636 0 6.646 0h13.708C22.364 0 24 1.56 24 3.476v12.366c0 .64-.544 1.158-1.215 1.158\"/>\n                <path d=\"M10.454 22h-.003l-3.453-.008C4.795 21.992 3 20.304 3 18.229v-4.975C3 12.562 3.597 12 4.334 12h8.332c.737 0 1.334.562 1.334 1.254 0 .693-.597 1.254-1.334 1.254H5.668v3.721c0 .692.598 1.255 1.333 1.255l3.457.008c.736.002 1.332.564 1.33 1.257-.002.692-.599 1.251-1.334 1.251M8.689 9h-.01l-7.376-.037C.579 8.96-.005 8.517 0 7.975.005 7.435.591 7 1.312 7h.008l7.377.037c.725.003 1.308.446 1.303.988-.005.54-.59.975-1.311.975M34.707 13h-.01l-6.413-.037c-.714-.004-1.29-.446-1.284-.989.006-.54.584-.974 1.294-.974h.01l6.412.037c.714.004 1.289.447 1.284.989-.006.54-.584.974-1.293.974M28 19.308c-.751 0-1.363.535-1.363 1.192 0 .657.612 1.193 1.363 1.193s1.363-.536 1.363-1.193-.612-1.192-1.363-1.192M28 24c-2.206 0-4-1.57-4-3.5s1.794-3.5 4-3.5c2.205 0 4 1.57 4 3.5S30.205 24 28 24\"/>\n                <path d=\"M13 19.308c-.751 0-1.363.535-1.363 1.192 0 .657.612 1.193 1.363 1.193s1.363-.536 1.363-1.193-.612-1.192-1.363-1.192M13 24c-2.205 0-4-1.57-4-3.5s1.795-3.5 4-3.5c2.206 0 4 1.57 4 3.5S15.206 24 13 24\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M71.553 48.369H42.33c-1.65 0-2.913-1.36-2.913-2.913 0-1.553 1.36-2.912 2.913-2.912h29.223c1.554 0 2.816-1.262 2.913-2.816-.097-1.553-1.36-2.815-2.913-2.815H42.33c-1.65 0-2.913-1.36-2.913-2.913 0-1.65 1.36-2.913 2.913-2.913h29.223c4.66 0 8.447 3.593 8.835 8.059v1.262c-.388 4.369-4.271 7.96-8.835 7.96z\"/>\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M42.233 65.942c-1.65 0-2.913-1.36-2.913-2.913V9.243c0-1.65-1.359-2.913-2.912-2.913H14.854c-1.65 0-2.912 1.36-2.912 2.913v53.786c0 1.65-1.36 2.913-2.913 2.913-1.65 0-2.912-1.36-2.912-2.913V9.243c0-4.855 3.98-8.835 8.834-8.835h21.554c4.854 0 8.835 3.98 8.835 8.835v53.786a3.092 3.092 0 0 1-3.107 2.913z\"/>\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M75.825 67.107H3.107c-1.65 0-2.913-1.36-2.913-2.913 0-1.553 1.36-2.912 2.913-2.912h72.718c1.65 0 2.913 1.359 2.913 2.912 0 1.554-1.262 2.913-2.913 2.913zM25.534 34.874c-1.65 0-2.913-1.36-2.913-2.913V13.223c0-1.65 1.36-2.912 2.913-2.912 1.65 0 2.913 1.359 2.913 2.912v18.738c0 1.65-1.263 2.913-2.913 2.913z\"/>\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M39.32 36.913H11.748c-1.65 0-2.913-1.36-2.913-2.913 0-1.65 1.36-2.913 2.913-2.913H39.32c1.65 0 2.913 1.36 2.913 2.913 0 1.553-1.262 2.913-2.913 2.913z\"/>\n                <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M62.718 47.883a2.74 2.74 0 0 1-1.456-.388c-1.456-.777-1.942-2.621-1.165-3.98l6.02-10.971c.776-1.457 2.62-1.942 3.98-1.165 1.456.776 1.942 2.621 1.165 3.98l-6.02 10.971a2.799 2.799 0 0 1-2.524 1.553zM49.417 47.883a2.74 2.74 0 0 1-1.456-.388c-1.456-.777-1.942-2.621-1.165-3.98l6.02-10.971c.776-1.457 2.62-1.942 3.98-1.165 1.456.776 1.942 2.621 1.165 3.98l-6.02 10.971c-.485.971-1.553 1.553-2.524 1.553z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill-rule=\"evenodd\">\n                <path fill-rule=\"nonzero\" d=\"M23.204 36.214a3.012 3.012 0 0 1-2.136-.874 3.012 3.012 0 0 1-.874-2.136V15.146c0-1.65 1.36-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01v15.048l15.048-.097c1.65 0 3.01 1.36 3.01 2.913 0 1.65-1.36 3.01-2.913 3.01l-18.155.194z\"/>\n                <path fill-rule=\"nonzero\" d=\"M80.68 52.913c-1.65 0-3.01-1.36-3.01-3.01 0-7.379-2.913-14.369-8.155-19.612-5.243-5.242-12.233-8.155-19.612-8.155-9.418 0-18.058 4.66-23.204 12.524-.874 1.36-2.718 1.748-4.078.874-1.359-.874-1.747-2.718-.873-4.078C28.058 21.942 38.544 16.214 50 16.214c4.563 0 8.932.873 13.107 2.621 3.98 1.748 7.67 4.175 10.68 7.184 3.106 3.107 5.533 6.7 7.184 10.68a33.61 33.61 0 0 1 2.621 13.107 2.91 2.91 0 0 1-2.912 3.107zM49.903 83.69a33.61 33.61 0 0 1-13.107-2.622c-3.98-1.748-7.67-4.175-10.68-7.185-3.106-3.106-5.533-6.699-7.184-10.68a33.61 33.61 0 0 1-2.621-13.106c0-1.65 1.359-3.01 3.01-3.01 1.65 0 3.01 1.36 3.01 3.01 0 7.379 2.912 14.369 8.154 19.612 5.243 5.242 12.233 8.155 19.612 8.155 9.126 0 17.67-4.466 22.913-12.039.97-1.359 2.815-1.65 4.174-.776 1.36.97 1.651 2.815.777 4.174-6.602 9.03-16.99 14.466-28.058 14.466z\"/>\n                <path fill-rule=\"nonzero\" d=\"M76.699 87.476c-1.65 0-3.01-1.36-3.01-3.01V69.612l-14.757.097c-1.65 0-3.01-1.36-3.01-2.913 0-1.65 1.36-3.01 2.913-3.01l17.67-.097c.777 0 1.553.292 2.136.874.582.583.874 1.36.874 2.136v17.864c.097 1.65-1.165 2.913-2.816 2.913z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#fff\" fill-rule=\"nonzero\" d=\"M47.8 51.4c-.8 0-1.6-.3-2.2-.9L1.1 6.1C-.1 4.9-.1 3 1.1 1.8 2.3.6 4.2.6 5.4 1.8l44.5 44.4c1.2 1.2 1.2 3.1 0 4.3-.5.6-1.3.9-2.1.9zM3.3 52.1c-.8 0-1.6-.3-2.2-.9-1.2-1.2-1.2-3.1 0-4.3l14.5-14.3c1.2-1.2 3.1-1.2 4.3 0 1.2 1.2 1.2 3.1 0 4.3L5.4 51.2c-.6.6-1.3.9-2.1.9zM34 21.3c-.8 0-1.6-.3-2.2-.9-1.2-1.2-1.2-3.1 0-4.3L46.2 1.9c1.2-1.2 3.1-1.2 4.3 0 1.2 1.2 1.2 3.1 0 4.3L36.1 20.4c-.6.6-1.4.9-2.1.9z\"/>\n                <path d=\"M-25.2-24.6H76.9V77.5H-25.2z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M26.2 49.6c-2.5 0-4.8-1-6.5-2.7L1.5 28.6c-1.2-1.2-1.2-3.1 0-4.3 1.2-1.2 3.1-1.2 4.3 0L24 42.6c.6.6 1.4.9 2.2.9.8 0 1.6-.3 2.2-.9l18.3-18.3c1.2-1.2 3.1-1.2 4.3 0 1.2 1.2 1.2 3.1 0 4.3L32.7 46.9c-1.7 1.7-4 2.7-6.5 2.7z\"/>\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M26.2 29.6c-1.7 0-3.1-1.4-3.1-3.1V3.9c0-1.7 1.4-3.1 3.1-3.1 1.7 0 3.1 1.4 3.1 3.1v22.6c0 1.7-1.4 3.1-3.1 3.1z\"/>\n                <path d=\"M-24.8-24.6H77.3V77.5H-24.8z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill-rule=\"evenodd\">\n                <path fill-rule=\"nonzero\" d=\"M33.7 51.4c-2.5 0-4.8-1-6.5-2.7l-9.9-10c-1.2-1.2-1.2-3.1 0-4.3 1.2-1.2 3.1-1.2 4.3 0l9.9 10c.6.6 1.4.9 2.2.9.8 0 1.6-.3 2.2-.9l10-10c1.2-1.2 3.1-1.2 4.3 0 1.2 1.2 1.2 3.1 0 4.3l-10 10c-1.7 1.7-4.1 2.7-6.5 2.7z\"/>\n                <path fill-rule=\"nonzero\" d=\"M33.7 37.6c-1.7 0-3.1-1.4-3.1-3.1V20.2c0-1.7 1.4-3.1 3.1-3.1 1.7 0 3.1 1.4 3.1 3.1v14.3c-.1 1.7-1.4 3.1-3.1 3.1z\"/>\n                <path fill-rule=\"nonzero\" d=\"M3.4 29.4c-.3 0-.5 0-.8-.1C1 28.9 0 27.2.4 25.5c1.9-7.2 6.3-13.7 12.2-18.3 3-2.3 6.3-4.1 9.8-5.3C26.1.6 29.9 0 33.8 0c3.9 0 7.7.6 11.4 1.9 3.5 1.2 6.8 3 9.8 5.3 2.9 2.3 5.5 5 7.5 8.1 2.1 3.1 3.7 6.6 4.7 10.2.4 1.6-.5 3.3-2.2 3.8-1.6.4-3.3-.5-3.8-2.2-1.6-5.9-5.2-11.2-10.1-15-5-3.9-11.1-6-17.4-6-6.4 0-12.4 2.1-17.5 6-4.9 3.8-8.4 9.1-10 15.1-.2 1.3-1.4 2.2-2.8 2.2zM33.9 69.1C18.2 69.1 4.4 58.5.4 43.3 0 41.7.9 40 2.6 39.6c1.7-.4 3.3.5 3.7 2.2C9.6 54.3 20.9 63 33.8 63s24.3-8.7 27.5-21.2c.4-1.6 2.1-2.6 3.7-2.2 1.6.4 2.6 2.1 2.2 3.7-3.8 15.2-17.6 25.8-33.3 25.8z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"#201A5B\" fill-rule=\"nonzero\">\n                <path d=\"M72.6 51.6H9.7c-5.2 0-9.4-4.2-9.4-9.4V10C.3 4.8 4.5.6 9.7.6h62.9C77.8.6 82 4.8 82 10v32.2c0 5.1-4.2 9.4-9.4 9.4zM9.7 6.7c-1.8 0-3.3 1.5-3.3 3.3v32.2c0 1.8 1.5 3.3 3.3 3.3h62.9c1.8 0 3.3-1.5 3.3-3.3V10c0-1.8-1.5-3.3-3.3-3.3H9.7z\"/>\n                <path d=\"M41 34.9c-1.1 0-2.2-.6-2.7-1.6-.8-1.5-.2-3.3 1.3-4.1l26.6-14.1c1.5-.8 3.3-.2 4.1 1.3.8 1.5.2 3.3-1.3 4.1L42.4 34.6c-.4.2-.9.3-1.4.3z\"/>\n                <path d=\"M41 34.9c-.5 0-1-.1-1.4-.4L13 20.4c-1.5-.8-2.1-2.7-1.3-4.1.8-1.5 2.7-2.1 4.1-1.3l26.6 14.1c1.5.8 2.1 2.7 1.3 4.1-.6 1.1-1.6 1.7-2.7 1.7z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M72.4 51.6h-8.2c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1h8.2c2.2 0 3.9-1.8 3.9-3.9V22.8c0-2.2-1.8-3.9-3.9-3.9H10.9c-2.2 0-3.9 1.8-3.9 3.9v18.7c0 2.2 1.8 3.9 3.9 3.9H18c1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1h-7.1c-5.5 0-10-4.5-10-10V22.9c0-5.5 4.5-10 10-10h61.5c5.5 0 10 4.5 10 10v18.7c0 5.5-4.5 10-10 10z\"/>\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M64 18.9c-1.7 0-3.1-1.4-3.1-3.1v-6c0-1.7-1.4-3.1-3.1-3.1H25.1c-1.7 0-3.1 1.4-3.1 3.1v6c0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1v-6c0-5.1 4.1-9.2 9.2-9.2h32.7c5.1 0 9.2 4.1 9.2 9.2v6c.1 1.8-1.2 3.1-2.9 3.1zM57.9 76.2H25.2c-5.1 0-9.2-4.1-9.2-9.2V36.3c0-1.7 1.4-3.1 3.1-3.1H64c1.7 0 3.1 1.4 3.1 3.1V67c-.1 5.1-4.2 9.2-9.2 9.2zM22.1 39.4V67c0 1.7 1.4 3.1 3.1 3.1h32.7c1.7 0 3.1-1.4 3.1-3.1V39.3H22.1v.1z\"/>\n                <path fill=\"#201A5B\" fill-rule=\"nonzero\" d=\"M52.7 63.9H30.3c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1h22.4c1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1zM52.7 51.6H30.3c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1h22.4c1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1z\"/>\n                <path d=\"M-9.6-15.9H92.5V86.2H-9.6z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g  fill=\"currentColor\" fill-rule=\"evenodd\" transform=\"translate(-10, -30)\">>\n    <g fill-rule=\"nonzero\">\n        <path fill=\"#c5c3d8\" d=\"M50.297 71.386h-6.04c-1.683 0-2.97-1.386-2.97-2.97 0-1.683 1.386-2.97 2.97-2.97h6.04c1.683 0 2.97-1.387 2.97-2.97 0-1.684-1.386-2.971-2.97-2.971h-1.98c-4.95 0-9.01-4.06-9.01-9.01s4.06-9.01 9.01-9.01h6.04c1.683 0 2.97 1.386 2.97 2.97 0 1.585-1.386 2.97-2.97 2.97h-6.04c-1.683 0-2.97 1.387-2.97 2.971 0 1.683 1.386 2.97 2.97 2.97h1.98c4.95 0 9.01 4.06 9.01 9.01s-4.06 9.01-9.01 9.01z\"/>\n        <path fill=\"#c5c3d8\" d=\"M49.307 47.327c-1.683 0-2.97-1.386-2.97-2.97v-6.04c0-1.683 1.386-2.97 2.97-2.97 1.584 0 2.97 1.386 2.97 2.97v6.04c0 1.683-1.287 2.97-2.97 2.97zM49.109 76.436c-1.683 0-2.97-1.386-2.97-2.97v-4.951c0-1.683 1.386-2.97 2.97-2.97 1.683 0 2.97 1.386 2.97 2.97v4.95c0 1.585-1.287 2.97-2.97 2.97z\"/>  \n    </g>\n</g>"};module.exports=exports["default"];

/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<defs>\n            <path id=\"ab123\" d=\"M15.27 3.906H4.354a.724.724 0 0 0-.706.706V36c0 .376.33.706.706.706h19.812c.376 0 .706-.33.706-.706V13.506h-5.977a3.625 3.625 0 0 1-3.623-3.624V3.906zm8.895 35.718H4.353A3.625 3.625 0 0 1 .729 36V4.612C.73 2.635 2.33.988 4.353.988h12.33c.376 0 .752.141 1.035.424l9.6 9.553c.282.282.423.659.423 1.035v24c.047 2.024-1.6 3.624-3.576 3.624zm-5.647-19.295h-8.66c-.8 0-1.458-.658-1.458-1.458 0-.8.659-1.46 1.459-1.46h8.659c.8 0 1.458.66 1.458 1.46 0 .8-.658 1.458-1.458 1.458zm0 6.212h-8.66c-.8 0-1.458-.659-1.458-1.459s.659-1.458 1.459-1.458h8.659c.8 0 1.458.658 1.458 1.458 0 .8-.658 1.46-1.458 1.46zm0 6.212h-8.66c-.8 0-1.458-.659-1.458-1.459s.659-1.459 1.459-1.459h8.659c.8 0 1.458.66 1.458 1.46 0 .8-.658 1.458-1.458 1.458z\"/>\n          </defs>\n          <g fill=\"none\" fill-rule=\"evenodd\" transform=\"translate(10 4)\">\n            <mask id=\"ba123\" fill=\"#fff\">\n                <use xlink:href=\"#ab123\"/>\n            </mask>\n            <use fill=\"#201A5B\" fill-rule=\"nonzero\" xlink:href=\"#ab123\"/>\n            <g fill=\"#2A2264\" mask=\"url(#ba123)\">\n                <path d=\"M-10-4h48v48h-48z\"/>\n            </g>\n          </g>"};module.exports=exports["default"];

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default={__html:"<g fill=\"none\" fill-rule=\"evenodd\">\n  <path fill=\"#292663\" d=\"M5 6a1 1 0 0 0-1 1v9.2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H5zm0-1.8h14A2.8 2.8 0 0 1 21.8 7v9.2A2.8 2.8 0 0 1 19 19H5a2.8 2.8 0 0 1-2.8-2.8V7A2.8 2.8 0 0 1 5 4.2zm1.35 3.4a.75.75 0 0 0-.75.75v6.5c0 .414.336.75.75.75h.1a.75.75 0 0 0 .75-.75v-6.5a.75.75 0 0 0-.75-.75h-.1zm2.4 0a.75.75 0 0 0-.75.75v6.5c0 .414.336.75.75.75h.1a.75.75 0 0 0 .75-.75v-6.5a.75.75 0 0 0-.75-.75h-.1zm3.2 0h.1a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-.1a.75.75 0 0 1-.75-.75v-6.5a.75.75 0 0 1 .75-.75zm3.2 0h.1a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-.1a.75.75 0 0 1-.75-.75v-6.5a.75.75 0 0 1 .75-.75zm2.4 0h.1a.75.75 0 0 1 .75.75v6.5a.75.75 0 0 1-.75.75h-.1a.75.75 0 0 1-.75-.75v-6.5a.75.75 0 0 1 .75-.75z\"/>\n            </g>"};module.exports=exports["default"];

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Svg=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Svg=exports.Svg=_styledComponents2.default.svg.withConfig({displayName:'styles__Svg',componentId:'sc-1viggiq-0'})(['',';'],function(props){return props.svgStyle;});

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _MobileMenu=__webpack_require__(1649);var _MobileMenu2=_interopRequireDefault(_MobileMenu);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_MobileMenu2.default;module.exports=exports['default'];

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/MobileMenu/MobileMenu.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _propTypes2=_interopRequireDefault(_propTypes);var _reactRedux=__webpack_require__(7);var _styles=__webpack_require__(385);var _styles2=__webpack_require__(386);var _data=__webpack_require__(1650);var _styles3=__webpack_require__(1651);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function MobileMenu(_ref){var avatar=_ref.avatar,menuOptions=_ref.menuOptions,categoryLabel=_ref.categoryLabel,username=_ref.username,isOpen=_ref.isOpen,headerLabelCategory=_ref.headerLabelCategory,accountPlans=_ref.accountPlans,onClose=_ref.onClose,userCancelled=_ref.userCancelled,profileActivationType=_ref.profileActivationType;var planList=accountPlans.map(function(accountPlan){return{link:'/minha-veloe/'+accountPlan.plan.id+'/resumo',title:accountPlan.plan.type,description:accountPlan.plan.category};});function checkUserStatus(option){return option.cancelledMenu?option.link:'#';}return _react2.default.createElement(_styles3.MobileMenuContainer,{isOpen:isOpen,__source:{fileName:_jsxFileName,lineNumber:48}},_react2.default.createElement(_styles3.MobileMenuUpperInfo,{__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_styles.Avatar,{src:avatar,__source:{fileName:_jsxFileName,lineNumber:50}}),_react2.default.createElement(_styles3.UserInfoContainer,{__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_styles2.HeaderLabel,{component:headerLabelCategory,__source:{fileName:_jsxFileName,lineNumber:52}},categoryLabel),_react2.default.createElement(_styles2.DropdownLabel,{__source:{fileName:_jsxFileName,lineNumber:53}},username))),_react2.default.createElement(_styles3.Hr,{__source:{fileName:_jsxFileName,lineNumber:56}}),_react2.default.createElement(_styles3.List,{__source:{fileName:_jsxFileName,lineNumber:57}},planList.map(function(plan,index){return _react2.default.createElement(_styles3.PlanItem,{key:index,__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_styles3.Anchor,{to:plan.link,onClick:onClose,__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_styles3.PlanTitle,{__source:{fileName:_jsxFileName,lineNumber:61}},plan.title),_react2.default.createElement(_styles3.PlanDescription,{__source:{fileName:_jsxFileName,lineNumber:62}},plan.description)));})),_react2.default.createElement(_styles3.Hr,{__source:{fileName:_jsxFileName,lineNumber:67}}),!profileActivationType&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:69}},_react2.default.createElement(_styles3.AnchorFull,{to:'#',onClick:onClose,__source:{fileName:_jsxFileName,lineNumber:70}},_data.allPlans),_react2.default.createElement(_styles3.Hr,{__source:{fileName:_jsxFileName,lineNumber:73}})),_react2.default.createElement(_styles3.List,{__source:{fileName:_jsxFileName,lineNumber:76}},menuOptions.map(function(option){return _react2.default.createElement(_styles3.NavItem,{key:option.link,__source:{fileName:_jsxFileName,lineNumber:78}},_react2.default.createElement(_styles3.Anchor,{to:userCancelled?checkUserStatus(option):option.link,onClick:onClose,__source:{fileName:_jsxFileName,lineNumber:79}},option.description));})));}MobileMenu.defaultProps={avatar:'',menuOptions:[],categoryLabel:'Pessoal',username:'',isOpen:false,headerLabelCategory:'',userCancelled:false};MobileMenu.propTypes={avatar:_propTypes2.default.string,menuOptions:_propTypes2.default.arrayOf(Object),categoryLabel:_propTypes2.default.string,username:_propTypes2.default.string,isOpen:_propTypes2.default.bool,headerLabelCategory:_propTypes2.default.string,userCancelled:_propTypes2.default.bool};var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{accountPlans:reducer.accountPlans.plans};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(MobileMenu);module.exports=exports['default'];

/***/ }),
/* 1650 */
/***/ (function(module, exports) {

module.exports = {"allPlans":"Ver todos os planos"}

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.List=exports.PlanItem=exports.NavItem=exports.PlanDescription=exports.PlanTitle=exports.Anchor=exports.AnchorFull=exports.Hr=exports.MobileMenuUpperInfo=exports.UserInfoContainer=exports.MobileMenuContainer=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _styles=__webpack_require__(385);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MobileMenuContainer=exports.MobileMenuContainer=_styledComponents2.default.div.withConfig({displayName:'styles__MobileMenuContainer',componentId:'sc-40e6v0-0'})(['background-color:',';height:calc(100vh - ',');left:0;opacity:0;overflow:auto;padding-top:',';position:absolute;top:',';visibility:hidden;width:100%;z-index:2;',' ','{margin-left:0;margin-right:',';}'],_colors.white,(0,_rem2.default)('71px'),(0,_rem2.default)('10px'),(0,_rem2.default)('70px'),function(props){return props.isOpen&&'\n        opacity: 1;\n        visibility: visible;\n    ';},_styles.Avatar,(0,_rem2.default)('24px'));var UserInfoContainer=exports.UserInfoContainer=_styledComponents2.default.div.withConfig({displayName:'styles__UserInfoContainer',componentId:'sc-40e6v0-1'})(['align-items:flex-start;display:flex;flex-direction:column;justify-content:flex-start;']);var MobileMenuUpperInfo=exports.MobileMenuUpperInfo=_styledComponents2.default.div.withConfig({displayName:'styles__MobileMenuUpperInfo',componentId:'sc-40e6v0-2'})(['align-items:center;display:flex;justify-content:flex-start;padding:',' ',';width:100%;'],(0,_rem2.default)('22px'),(0,_rem2.default)('28px'));var Hr=exports.Hr=_styledComponents2.default.hr.withConfig({displayName:'styles__Hr',componentId:'sc-40e6v0-3'})(['background:rgba(41,38,99,0.1);border:0;height:',';margin:0;padding:0;'],(0,_rem2.default)('1px'));var AnchorFull=exports.AnchorFull=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__AnchorFull',componentId:'sc-40e6v0-4'})(['',';color:',';display:block;padding:',' ',';text-decoration:none;'],_types.txt12OpenSansBold,_colors.darkGrey,(0,_rem2.default)('22px'),(0,_rem2.default)('28px'));var Anchor=exports.Anchor=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__Anchor',componentId:'sc-40e6v0-5'})(['',';color:',';text-decoration:none;'],_types.txt12OpenSansBold,_colors.darkGrey);var PlanTitle=exports.PlanTitle=_styledComponents2.default.p.withConfig({displayName:'styles__PlanTitle',componentId:'sc-40e6v0-6'})(['',';color:',';line-height:1;margin:0;text-transform:capitalize;'],_types.title16Galano,_colors.linkNavyBlue);var PlanDescription=exports.PlanDescription=_styledComponents2.default.p.withConfig({displayName:'styles__PlanDescription',componentId:'sc-40e6v0-7'})(['',' color:',';margin:0;text-transform:capitalize;'],_types.txt12OpenSans,_colors.darkGrey);var NavItem=exports.NavItem=_styledComponents2.default.li.withConfig({displayName:'styles__NavItem',componentId:'sc-40e6v0-8'})(['padding:0;:not(:first-child){margin-top:',';}:last-child{margin-top:',';}'],(0,_rem2.default)('16px'),(0,_rem2.default)('40px'));var PlanItem=exports.PlanItem=_styledComponents2.default.li.withConfig({displayName:'styles__PlanItem',componentId:'sc-40e6v0-9'})(['padding:0;:not(:first-child){margin-top:',';}'],(0,_rem2.default)('24px'));var List=exports.List=_styledComponents2.default.ul.withConfig({displayName:'styles__List',componentId:'sc-40e6v0-10'})(['list-style:none;margin:0;padding:',' ',';'],(0,_rem2.default)('24px'),(0,_rem2.default)('28px'));

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Overlay=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Overlay=exports.Overlay=_styledComponents2.default.div.withConfig({displayName:'styles__Overlay',componentId:'sc-1iow7f1-0'})(['position:fixed;display:',';top:0;left:0;width:100%;height:100%;z-index:',';'],function(_ref){var isOpen=_ref.isOpen;return isOpen?'initial':'none';},function(_ref2){var isOpen=_ref2.isOpen;return isOpen?0:-1;});

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ChoosePlanDropdown/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactClickOut=__webpack_require__(591);var _reactClickOut2=_interopRequireDefault(_reactClickOut);var _reactRouterDom=__webpack_require__(15);var _reactRedux=__webpack_require__(7);var _Dropdown=__webpack_require__(587);var _Dropdown2=_interopRequireDefault(_Dropdown);var _DropdownList=__webpack_require__(588);var _DropdownList2=_interopRequireDefault(_DropdownList);var _styles=__webpack_require__(1660);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var ChoosePlanDropdown=function(_Component){_inherits(ChoosePlanDropdown,_Component);function ChoosePlanDropdown(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ChoosePlanDropdown);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ChoosePlanDropdown.__proto__||Object.getPrototypeOf(ChoosePlanDropdown)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:false},_this.toggleDropdownList=function(){_this.setState({isOpen:!_this.state.isOpen});},_this.closeDropdownList=function(){_this.setState({isOpen:false});},_this.goToPlanResume=function(){var _this$props=_this.props,accountPlans=_this$props.accountPlans,history=_this$props.history;var planId=accountPlans.plans[0].id;history.push('/minha-veloe/'+planId+'/resumo');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChoosePlanDropdown,[{key:'render',value:function render(){var isOpen=this.state.isOpen,accountPlans=this.props.accountPlans;var activePlanId=accountPlans&&accountPlans.activePlanId;var planList=accountPlans&&accountPlans.plans;var activePlan={};if(activePlanId){activePlan=planList.find(function(plan){return activePlanId==plan.id;})||{};}else if(planList.length>0){activePlan=planList[0];}var activePlanData=activePlan.plan||{};var activePlanFullName=activePlanData.category;var isSinglePlan=planList.length<=1;return _react2.default.createElement(_styles.Wrapper,{isSinglePlan:isSinglePlan,__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_reactClickOut2.default,{callback:this.closeDropdownList,__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_Dropdown2.default,{isOpen:isOpen,categoryLabel:isOpen?'Planos':'Plano',dropdownLabel:isOpen?'Todos os planos':activePlanFullName,headerLabelCategory:'plan',onClick:isSinglePlan?this.goToPlanResume:this.toggleDropdownList,__source:{fileName:_jsxFileName,lineNumber:61}}),!isSinglePlan&&_react2.default.createElement(_DropdownList2.default,{options:[].concat(_toConsumableArray(planList.map(function(accountPlan){return{link:'/minha-veloe/'+accountPlan.plan.id+'/resumo',title:accountPlan.plan.type,description:accountPlan.plan.category};}))),isOpen:isOpen,onClose:this.toggleDropdownList,__source:{fileName:_jsxFileName,lineNumber:70}})));}}]);return ChoosePlanDropdown;}(_react.Component);ChoosePlanDropdown.defaultProps={accountPlans:{}};var mapStateToProps=function mapStateToProps(state){return{accountPlans:state.reducer.accountPlans};};exports.default=(0,_reactRedux.connect)(mapStateToProps)((0,_reactRouterDom.withRouter)(ChoosePlanDropdown));module.exports=exports['default'];

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1655);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1657);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClickOut = function (_Component) {
    _inherits(ClickOut, _Component);

    function ClickOut() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ClickOut);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClickOut.__proto__ || Object.getPrototypeOf(ClickOut)).call.apply(_ref, [this].concat(args))), _this), _this.onSelfClick = function (e) {
            e.clickOutTarget = _this.wrapper;
        }, _this.onAnyClick = function (e) {
            var _this2 = _this,
                wrapper = _this2.wrapper,
                callback = _this2.props.callback;


            if (e.clickOutTarget !== wrapper) {
                callback(e);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ClickOut, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (typeof window !== 'undefined') {
                this.wrapper.addEventListener('click', this.onSelfClick);
                document.addEventListener('click', this.onAnyClick);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.wrapper.removeEventListener('click', this.onSelfClick);
            document.removeEventListener('click', this.onAnyClick);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                { ref: function ref(wrapper) {
                        _this3.wrapper = wrapper;
                    } },
                this.props.children
            );
        }
    }]);

    return ClickOut;
}(_react.Component);

ClickOut.propTypes = {
    callback: _propTypes.func.isRequired,
    children: _propTypes.node.isRequired
};
exports.default = ClickOut;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1656);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(34),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1658)();
}


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1659);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Wrapper=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _styles=__webpack_require__(589);var _styles2=__webpack_require__(386);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-gfo565-0'})(['position:relative;min-width:',';',' ','{position:relative;z-index:21;}','{top:0;padding-top:',';}','{margin-bottom:',';:last-child{padding-top:',';margin-bottom:0;}}','{font-size:',';}'],(0,_rem2.default)('300px'),function(_ref){var isSinglePlan=_ref.isSinglePlan;return isSinglePlan&&(0,_styledComponents.css)(['svg{display:none;}']);},_styles2.DropdownContainer,_styles.DropdownListContainer,(0,_rem2.default)('65px'),_styles.DropdownListItem,(0,_rem2.default)('32px'),(0,_rem2.default)('10px'),_styles2.HeaderLabel,(0,_rem2.default)('10px'));

/***/ }),
/* 1661 */
/***/ (function(module, exports) {

module.exports = {"headerMenuLinks":{"pf":[{"description":"Dados pessoais","link":"/perfil/editar-dados"},{"description":"Contatos","link":"/perfil/editar-contatos"},{"description":"Endereços","link":"/perfil/editar-endereco"},{"description":"Alterar senha","link":"/perfil/alterar-senha"},{"description":"Reativar conta","link":"/reativar-conta","exclude":["active"],"cancelledMenu":true},{"description":"Sair","link":"/","cancelledMenu":true,"isLogout":true}],"pj":[{"description":"Dados institucionais","link":"/perfil/editar-dados"},{"description":"Endereço comercial","link":"/perfil/endereco-comercial"},{"description":"Representantes","link":"/perfil/representantes"},{"description":"Contato do administrador","link":"/perfil/contato-do-administrador"},{"description":"Alterar senha","link":"/perfil/alterar-senha"},{"description":"Reativar conta","link":"/reativar-conta","exclude":["active"],"cancelledMenu":true},{"description":"Sair","link":"/","cancelledMenu":true,"isLogout":true}],"at":[{"description":"Alterar senha","link":"/perfil/alterar-senha"},{"description":"Sair","link":"/","cancelledMenu":true,"isLogout":true}]}}

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Submenu/Submenu.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(15);var _propTypes=__webpack_require__(9);var _textSlug=__webpack_require__(184);var _styles=__webpack_require__(1663);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Submenu=function(_Component){_inherits(Submenu,_Component);function Submenu(props){_classCallCheck(this,Submenu);var _this=_possibleConstructorReturn(this,(Submenu.__proto__||Object.getPrototypeOf(Submenu)).call(this,props));_this.componentDidMount=function(){if(!_this.props.secondary){return _this.setState({currentIndex:0});}_this.setState({currentIndex:_this.findCurrentIndex()});};_this.componentDidUpdate=function(prevProps,prevState){var _this$props=_this.props,router=_this$props.router,navItems=_this$props.navItems,secondary=_this$props.secondary;var pathname=router.location.pathname;var currentIndex=_this.state.currentIndex;if(prevProps.history.action==='POP'&&currentIndex===0){return _this.setState({currentIndex:_this.findCurrentIndex()});}if(prevProps.router.location.pathname!==pathname){if(!secondary&&pathname.includes('/instalacao')){return _this.setState({currentIndex:3});}_this.setState({currentIndex:_this.findCurrentIndex()});}if((currentIndex===null||currentIndex===-1)&&prevProps.navItems!==navItems){_this.setState({currentIndex:_this.findCurrentIndex()});}};_this.setActiveElement=function(index){var isClient=typeof window!=='undefined';var activeNavElement=_this.navigationItems[index];if(activeNavElement&&isClient){return{bottomLinePosition:activeNavElement.offsetLeft,bottomLineWidth:activeNavElement.clientWidth};}};_this.findCurrentIndex=function(){var _this$props2=_this.props,navItems=_this$props2.navItems,router=_this$props2.router;var pathname=router.location.pathname;if(router&&navItems.length>0){var endOfLink=function endOfLink(link){return link&&link.split('/')[link.split('/').length-1];};return navItems.findIndex(function(navItem){return pathname.indexOf(endOfLink(navItem.link))!==-1;});}};_this.state={currentIndex:null,bottomLinePosition:0,bottomLineWidth:0};_this.navigationItems=[];return _this;}_createClass(Submenu,[{key:'render',value:function render(){var _this2=this;var _props=this.props,navItems=_props.navItems,lastItemOnRight=_props.lastItemOnRight,secondary=_props.secondary;var currentIndex=this.state.currentIndex;var _ref=this.setActiveElement(currentIndex)||{},bottomLinePosition=_ref.bottomLinePosition,bottomLineWidth=_ref.bottomLineWidth;var gtmLabel='item:';return _react2.default.createElement(_styles.SubmenuNavigation,{secondary:secondary,lastItemOnRight:lastItemOnRight,__source:{fileName:_jsxFileName,lineNumber:83}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:84}},_react2.default.createElement(_styles.RelativeContainer,{__source:{fileName:_jsxFileName,lineNumber:85}},_react2.default.createElement(_styles.SubmenuNavigationList,{__source:{fileName:_jsxFileName,lineNumber:86}},navItems.map(function(item,index){var isActive=index===currentIndex;return _react2.default.createElement(_styles.SubmenuNavigationItem,{secondary:secondary,active:isActive,key:item.label,innerRef:function innerRef(el){return _this2.navigationItems[index]=el;},__source:{fileName:_jsxFileName,lineNumber:90}},_react2.default.createElement(_styles.NavigationLink,{to:item.link,id:item.id,className:'gtm-link-event','data-gtm-event-category':'veloe:area-logado:geral','data-gtm-event-action':'clique:menu-principal','data-gtm-event-label':gtmLabel+(0,_textSlug.converText)(item.label),__source:{fileName:_jsxFileName,lineNumber:96}},item.label));})),!secondary&&_react2.default.createElement(_styles.BottomLine,{style:{left:bottomLinePosition,width:bottomLineWidth},__source:{fileName:_jsxFileName,lineNumber:111}}))));}}]);return Submenu;}(_react.Component);Submenu.defaultProps={navItems:[],secondary:false};Submenu.propTypes={secondary:_propTypes.bool,navItems:(0,_propTypes.arrayOf)((0,_propTypes.shape)({external:_propTypes.bool,label:_propTypes.string,link:_propTypes.string,id:_propTypes.string}))};exports.default=(0,_reactRouterDom.withRouter)(Submenu);module.exports=exports['default'];

/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SubmenuNavigation=exports.BottomLine=exports.SubmenuNavigationItem=exports.SubmenuNavigationList=exports.NavigationLink=exports.RelativeContainer=exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n        height: ',';\n    '],['\n        height: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n      float: left;\n      :last-child {\n        margin-right: 0;\n      }\n  '],['\n      float: left;\n      :last-child {\n        margin-right: 0;\n      }\n  ']),_templateObject3=_taggedTemplateLiteral(['\n        overflow: hidden;\n    '],['\n        overflow: hidden;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n            float: right;\n        '],['\n            float: right;\n        ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _colors=__webpack_require__(2);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-1iwknpz-0'})(['',';margin:0 auto;user-select:none;'],_content2.default);var RelativeContainer=exports.RelativeContainer=_styledComponents2.default.div.withConfig({displayName:'styles__RelativeContainer',componentId:'sc-1iwknpz-1'})(['position:relative;']);var NavigationLink=exports.NavigationLink=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__NavigationLink',componentId:'sc-1iwknpz-2'})(['outline:none;font-family:\'OpenSans\';font-size:',';font-weight:600;text-decoration:none;transition:0.2s color;position:relative;transition:font-weight 0.3s;'],(0,_rem2.default)('14px'));var SubmenuNavigationList=exports.SubmenuNavigationList=_styledComponents2.default.ul.withConfig({displayName:'styles__SubmenuNavigationList',componentId:'sc-1iwknpz-3'})(['margin:0;padding:0;position:relative;text-decoration:none;white-space:nowrap;width:100%;',';:after{content:\'\';clear:both;display:table;}'],_media2.default.small(_templateObject,(0,_rem2.default)('46px')));var SubmenuNavigationItem=exports.SubmenuNavigationItem=_styledComponents2.default.li.withConfig({displayName:'styles__SubmenuNavigationItem',componentId:'sc-1iwknpz-4'})(['display:inline-block;margin-right:',';padding:',' 0;',';','{',';}a{color:',';}a:hover{color:',';}',';'],(0,_rem2.default)('32px'),function(_ref){var secondary=_ref.secondary;return secondary?(0,_rem2.default)('12px'):(0,_rem2.default)('15px');},_media2.default.large(_templateObject2),NavigationLink,function(_ref2){var active=_ref2.active;return active&&(0,_styledComponents.css)(['color:',';'],function(_ref3){var secondary=_ref3.secondary;return secondary?_colors.white:_colors.linkNavyBlue;});},function(_ref4){var secondary=_ref4.secondary;return secondary?_colors.white:_colors.darkGrey;},function(_ref5){var secondary=_ref5.secondary;return!secondary?_colors.linkNavyBlue:_colors.white;},function(_ref6){var secondary=_ref6.secondary,active=_ref6.active;return secondary&&active&&(0,_styledComponents.css)(['a{font-weight:bold;&::after{position:absolute;content:\'\';height:',';border-radius:',';background-color:',';left:0;bottom:',';width:100%;}}'],(0,_rem2.default)('4px'),(0,_rem2.default)('4px'),_colors.white,(0,_rem2.default)('-12px'));});var BottomLine=exports.BottomLine=_styledComponents2.default.span.withConfig({displayName:'styles__BottomLine',componentId:'sc-1iwknpz-5'})(['background-color:',';border-radius:',';bottom:0;content:\'\';height:',';position:absolute;left:0;transition:0.4s left,0.4s width;width:0;'],_colors.linkNavyBlue,(0,_rem2.default)('4px'),(0,_rem2.default)('4px'));var SubmenuNavigation=exports.SubmenuNavigation=_styledComponents2.default.nav.withConfig({displayName:'styles__SubmenuNavigation',componentId:'sc-1iwknpz-6'})(['background-color:',';overflow-style:none;-ms-overflow-style:none;overflow-x:scroll;overflow-y:hidden;::scrollbar{display:none;}::-webkit-scrollbar{display:none;}',';',';'],function(_ref7){var secondary=_ref7.secondary;return secondary?_colors.tealish:_colors.offWhite;},_media2.default.large(_templateObject3),function(_ref8){var lastItemOnRight=_ref8.lastItemOnRight;return lastItemOnRight&&(0,_styledComponents.css)(['',':last-child{',';}'],SubmenuNavigationItem,_media2.default.large(_templateObject4));});

/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Logo=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/FooterSmall/FooterNavigationLarge.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _styles=__webpack_require__(592);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Logo=exports.Logo='height: 30px; width: 74px;';function FooterNavigationLarge(){return _react2.default.createElement(_styles.FooterNavigation,{__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_styles.NavigationContent,{__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_styles.NavigationColumn,{__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(_styles.LogoSocial,{__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(_Icon2.default,{icon:'veloe-logo',svgStyle:_styles.VeloeLogo,width:'74',height:'31',viewBox:'0 0 74 31',__source:{fileName:_jsxFileName,lineNumber:24}})),_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_styles.NavigationLabel,{__source:{fileName:_jsxFileName,lineNumber:33}},'Central de relacionamento para clientes'),_react2.default.createElement(_styles.TelephoneNumber,{__source:{fileName:_jsxFileName,lineNumber:34}},'3003 3510'),_react2.default.createElement(_styles.DescriptionItem,{__source:{fileName:_jsxFileName,lineNumber:35}},'Capitais e regi\xF5es metropolitanas')),_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_styles.TelephoneNumber,{__source:{fileName:_jsxFileName,lineNumber:38}},'0800 208 3510'),_react2.default.createElement(_styles.DescriptionItem,{__source:{fileName:_jsxFileName,lineNumber:39}},'Demais cidades'),_react2.default.createElement(_styles.DescriptionItem,{__source:{fileName:_jsxFileName,lineNumber:40}},'24 horas 7 dias por semana'))),_react2.default.createElement(_styles.NavigationColumn,{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_styles.NavigationLabel,{bold:true,__source:{fileName:_jsxFileName,lineNumber:45}},'SAC')),_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:47}},_react2.default.createElement(_styles.TelephoneNumber,{__source:{fileName:_jsxFileName,lineNumber:48}},'0800 208 2010'),_react2.default.createElement(_styles.DescriptionItem,{__source:{fileName:_jsxFileName,lineNumber:49}},'24 horas 7 dias por semana'))),_react2.default.createElement(_styles.NavigationColumn,{__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_styles.NavigationLabel,{bold:true,__source:{fileName:_jsxFileName,lineNumber:54}},'Ouvidoria')),_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:56}},_react2.default.createElement(_styles.TelephoneNumber,{__source:{fileName:_jsxFileName,lineNumber:57}},'0800 202 3278'),_react2.default.createElement(_styles.DescriptionItem,{__source:{fileName:_jsxFileName,lineNumber:58}},'De segunda a sexta,'),_react2.default.createElement(_styles.DescriptionItem,{__source:{fileName:_jsxFileName,lineNumber:59}},'das 10h \xE0s 16h')))));}exports.default=FooterNavigationLarge;

/***/ }),
/* 1665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Loader/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(1666);var _data=__webpack_require__(1667);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function Loader(){var messageNumber=Math.floor(Math.random()*_data.LoadMessages.length);return _react2.default.createElement(_styles.LoaderContainer,{__source:{fileName:_jsxFileName,lineNumber:10}},_react2.default.createElement(_styles.LoaderContent,{__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement(_styles.LoaderAnimation,{__source:{fileName:_jsxFileName,lineNumber:12}}),_react2.default.createElement(_styles.LoaderMessage,{__source:{fileName:_jsxFileName,lineNumber:13}},_data.LoadMessages[messageNumber])));}exports.default=Loader;module.exports=exports['default'];

/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.LoaderMessage=exports.LoaderAnimation=exports.LoaderContent=exports.LoaderContainer=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LoaderContainer=exports.LoaderContainer=_styledComponents2.default.div.withConfig({displayName:'styles__LoaderContainer',componentId:'sc-1kmyfx9-0'})(['display:block;position:relative;width:100%;height:calc(100vh - 200px);']);var LoaderContent=exports.LoaderContent=_styledComponents2.default.div.withConfig({displayName:'styles__LoaderContent',componentId:'sc-1kmyfx9-1'})(['display:block;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);']);var LoaderAnimation=exports.LoaderAnimation=_styledComponents2.default.div.withConfig({displayName:'styles__LoaderAnimation',componentId:'sc-1kmyfx9-2'})(['width:',';height:',';border-radius:100%;position:relative;margin:0 auto;&:before,&:after{content:\'\';position:absolute;top:',';left:',';width:100%;height:100%;border-radius:100%;border:',' solid transparent;border-top-color:#00c3d3;}&:before{z-index:100;animation:spin 1s infinite linear;}&:after{border:',' solid #f1f1f7;}@keyframes spin{0%{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);-o-transform:rotate(0deg);transform:rotate(0deg);}100%{-webkit-transform:rotate(360deg);-ms-transform:rotate(360deg);-o-transform:rotate(360deg);transform:rotate(360deg);}}'],(0,_rem2.default)('24px'),(0,_rem2.default)('24px'),(0,_rem2.default)('-4px'),(0,_rem2.default)('-4px'),(0,_rem2.default)('4px'),(0,_rem2.default)('4px'));var LoaderMessage=exports.LoaderMessage=_styledComponents2.default.div.withConfig({displayName:'styles__LoaderMessage',componentId:'sc-1kmyfx9-3'})(['',' display:block;text-align:center;color:',';margin-top:',';opacity:0;animation:fadeIn 0.4s 1s linear;animation-iteration-count:1;animation-fill-mode:forwards;@keyframes fadeIn{0%{opacity:0;}100%{opacity:1;}}'],_types.title18Galano,_colors.linkNavyBlue,(0,_rem2.default)('15px'));

/***/ }),
/* 1667 */
/***/ (function(module, exports) {

module.exports = {"LoadMessages":["Descomplicando sua rotina...","Contando os segundos...","Acertando os ponteiros pra você."]}

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ContentContainer=exports.LoaderContainer=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LoaderContainer=exports.LoaderContainer=_styledComponents2.default.div.withConfig({displayName:'styles__LoaderContainer',componentId:'sc-5en0l7-0'})(['visibility:hidden;opacity:0;height:0;overflow:hidden;transition:opacity 0.3s ease,visibility 0s 0.3s ease,height 0s 0.3s ease;',';'],function(props){return props.isLoading&&'\n        visibility: visible;\n        opacity: 1;\n        height: auto;\n        overflow: visible;\n    ';});var ContentContainer=exports.ContentContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ContentContainer',componentId:'sc-5en0l7-1'})(['visibility:visible;opacity:1;transition:opacity 0.3s 0.3s ease,visibility 0s 0.3s ease,height 0s 0.3s ease;height:auto;overflow:visible;',';'],function(props){return props.isLoading&&'\n        visibility: hidden;\n        opacity: 0;\n        height: 0;\n        overflow: hidden;\n    ';});

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

module.exports = {"subnavLinks":{"pf":[{"label":"Dados Pessoais","link":"/perfil/editar-dados"},{"label":"Contatos","link":"/perfil/editar-contatos"},{"label":"Endereços","link":"/perfil/editar-endereco"},{"label":"Alterar senha","link":"/perfil/alterar-senha"}],"pj":[{"label":"Dados institucionais","link":"/perfil/editar-dados"},{"label":"Endereço comercial","link":"/perfil/endereco-comercial"},{"label":"Representantes","link":"/perfil/representantes"},{"label":"Contato do administrador","link":"/perfil/contato-do-administrador"},{"label":"Alterar senha","link":"/perfil/alterar-senha"}],"pc":[{"label":"Alterar senha","link":"/perfil/alterar-senha"}]}}

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(1671));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 1671 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(1673);
var isArguments = __webpack_require__(1674);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 1673 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 1674 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.warn = exports.requestIdleCallback = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(34);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(593);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var requestIdleCallback = function () {
    if (typeof window !== "undefined" && typeof window.requestIdleCallback !== "undefined") {
        return window.requestIdleCallback;
    }

    return function (cb) {
        var start = Date.now();
        return setTimeout(function () {
            cb({
                didTimeout: false,
                timeRemaining: function timeRemaining() {
                    return Math.max(0, 50 - (Date.now() - start));
                }
            });
        }, 1);
    };
}();

var cancelIdleCallback = function () {
    if (typeof window !== "undefined" && typeof window.cancelIdleCallback !== "undefined") {
        return window.cancelIdleCallback;
    }

    return function (id) {
        return clearTimeout(id);
    };
}();

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetIdleCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;


    if (_helmetIdleCallback) {
        cancelIdleCallback(_helmetIdleCallback);
    }

    _helmetIdleCallback = requestIdleCallback(function () {
        updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
        updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

        updateTitle(title, titleAttributes);

        var tagUpdates = {
            baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
            linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
            metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
            noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
            scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
            styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
        };

        var addedTags = {};
        var removedTags = {};

        Object.keys(tagUpdates).forEach(function (tagType) {
            var _tagUpdates$tagType = tagUpdates[tagType],
                newTags = _tagUpdates$tagType.newTags,
                oldTags = _tagUpdates$tagType.oldTags;


            if (newTags.length) {
                addedTags[tagType] = newTags;
            }
            if (oldTags.length) {
                removedTags[tagType] = tagUpdates[tagType].oldTags;
            }
        });

        _helmetIdleCallback = null;
        onChangeClientState(newState, addedTags, removedTags);
    });
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = Array.isArray(title) ? title.join("") : title;
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(title, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(title, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestIdleCallback = requestIdleCallback;
exports.warn = warn;

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Main=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Main=exports.Main=_styledComponents2.default.main.withConfig({displayName:'styles__Main',componentId:'sc-16z10nk-0'})(['display:block;text-align:center;h1{',' margin-bottom:30px;}ul,li{margin:0 0 15px;padding:0;list-style:none;}'],_types.title36GalanoBold);

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

module.exports = {"profiles":[{"description":"Meu Perfil PF Ativo","login":"veloe@veloe.com","password":"abc123","redirectTo":"/perfil/editar-dados"},{"description":"Meu Perfil PJ Ativo","login":"alelo@alelo.com","password":"abc123","redirectTo":"/perfil/editar-dados"},{"description":"Minha Veloe Resumo Pré","login":"alelo@alelo.com","password":"abc123","redirectTo":"/minha-veloe/resumo/combo-pre-pago-auto"},{"description":"Minha Veloe Resumo Pos","login":"veloe@veloe.com","password":"abc123","redirectTo":"/minha-veloe/resumo/urbano-pos-pago-30"},{"description":"Minha Veloe Extrato","login":"veloe@veloe.com","password":"abc123","redirectTo":"/minha-veloe/combo-pre-pago-auto/extrato"},{"description":"Minha Veloe Fatura","login":"veloe@veloe.com","password":"abc123","redirectTo":"/minha-veloe/combo-pre-pago-auto/fatura"},{"description":"Minha Veloe Histórico de Recarga","login":"veloe@veloe.com","password":"abc123","redirectTo":"/minha-veloe/combo-pre-pago-auto/historico-de-recarga"},{"description":"Login de usuário","redirectTo":"/conta/login"}]}

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditUserData/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _aleloLogic=__webpack_require__(12);var _EditUserDataForm=__webpack_require__(1679);var _EditUserDataForm2=_interopRequireDefault(_EditUserDataForm);var _actions=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _formStateActions=__webpack_require__(102);var _actions2=__webpack_require__(1716);var _factory=__webpack_require__(1717);var _factory2=_interopRequireDefault(_factory);var _styles=__webpack_require__(186);var _data=__webpack_require__(1718);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var fetchUpdateProfile=_aleloLogic.actions.fetchUpdateProfile,fetchUpdateContact=_aleloLogic.actions.fetchUpdateContact;var EditUserData=function EditUserData(props){var initialValues=_factory2.default.toForm(props.profile,props.contato);return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:26}}),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:28}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:29}},_data.subtitle)),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_EditUserDataForm2.default,{initialValues:initialValues,onSubmit:function onSubmit(values){return props.handleSave(_factory2.default.toAPI(values),props.contato);},__source:{fileName:_jsxFileName,lineNumber:32}})));};var mapStateToProps=function mapStateToProps(state){return{profile:state.reducer.user.profile,contato:state.reducer.user.contato};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{handleSave:function handleSave(profile,contato){dispatch((0,_formStateActions.startSaving)());var dataProfile={user:{'estado-civil':profile['estado-civil'],sexo:profile.sexo},pap:{adesaoPap:!(profile.pap===''||profile.pap===undefined||profile.pap===false),documento:profile.documento}};contato.nome.nomeCompleto=profile.name;contato.nome.emiteNotaFiscal=!(profile.emiteNotaFiscal===undefined||profile.emiteNotaFiscal===''||profile.emiteNotaFiscal===false);Promise.all([dispatch(fetchUpdateContact(contato)),dispatch(fetchUpdateProfile(dataProfile))]).then(function(){dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modalTitle,image:_confirmation2.default}));dispatch((0,_formStateActions.stopSaving)());dispatch((0,_actions2.changeUserAvatar)(profile.avatar));}).catch(function(e){dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,image:_contestacao2.default}));dispatch((0,_formStateActions.stopSaving)());});}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(EditUserData);module.exports=exports['default'];

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/EditUserDataForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _ChooseAvatar=__webpack_require__(1680);var _ChooseAvatar2=_interopRequireDefault(_ChooseAvatar);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(389);var _data=__webpack_require__(1688);var _renderInputs=__webpack_require__(44);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var EditUserDataForm=function EditUserDataForm(props){var handleSubmit=props.handleSubmit,lastTimeSaved=props.lastTimeSaved,saving=props.saving;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,width:[1,7/12],__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.name,name:'name',type:'text',disabled:true,validate:_aleloLogic.utils.emptyFieldValidate,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:29}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCpfInput,label:_data.labels.cpf,validate:_aleloLogic.utils.cpfValidate,normalize:_aleloLogic.utils.cpfMask,name:'cpf',type:'text',disabled:true,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:40}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.dob,name:'dob',type:'text',normalize:_aleloLogic.utils.dateMask,disabled:true,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:52}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pl:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderGenderField,label:_data.labels.gender,name:'gender',validate:_aleloLogic.utils.emptyFieldValidate,isRequired:true,disabled:saving,__source:{fileName:_jsxFileName,lineNumber:63}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:72}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderMaritialStatusField,label:_data.labels.maritalStatus,name:'maritalStatus',validate:_aleloLogic.utils.emptyFieldValidate,isRequired:true,disabled:saving,__source:{fileName:_jsxFileName,lineNumber:73}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:82}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.mothersName,name:'mothersName',type:'text',validate:_aleloLogic.utils.emptyFieldValidate,disabled:true,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:83}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:93}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCheckboxField,label:_data.labels.emiteNotaFiscal,name:'emiteNotaFiscal',disabled:saving,__source:{fileName:_jsxFileName,lineNumber:94}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:101}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCheckboxField,label:_data.labels.pap,name:'pap',disabled:saving,__source:{fileName:_jsxFileName,lineNumber:102}})))),_react2.default.createElement(_gridStyled.Box,{mb:50,__source:{fileName:_jsxFileName,lineNumber:111}},_react2.default.createElement(_ChooseAvatar2.default,{__source:{fileName:_jsxFileName,lineNumber:112}})),_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:114}},_react2.default.createElement(_Button2.default,{type:'submit',text:'Salvar',disabled:saving,__source:{fileName:_jsxFileName,lineNumber:115}}),lastTimeSaved));};var mapStateToProps=function mapStateToProps(state){return{saving:state.reducer.formState.saving};};var form=(0,_reduxForm.reduxForm)({form:'editUserData',enableReinitialize:true,destroyOnUnmount:false})(EditUserDataForm);exports.default=(0,_reactRedux.connect)(mapStateToProps,undefined)(form);module.exports=exports['default'];

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ChooseAvatar=__webpack_require__(1681);var _ChooseAvatar2=_interopRequireDefault(_ChooseAvatar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_ChooseAvatar2.default;module.exports=exports['default'];

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _ChooseAvatarOption=__webpack_require__(1682);var _ChooseAvatarOption2=_interopRequireDefault(_ChooseAvatarOption);var _styles=__webpack_require__(1685);var _data=__webpack_require__(1686);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var avatarList=[__webpack_require__(240),__webpack_require__(241),__webpack_require__(242),__webpack_require__(243),__webpack_require__(244),__webpack_require__(245),__webpack_require__(246),__webpack_require__(247)];/* eslint-disable */function ChooseAvatar(props){var label=props.label;return null;// return (
//   <Container>
//     <Content>
//       <Title>{title}</Title>
//       <AvatarContainer>
//         <AvatarList>
//           {avatarList.map((avatar, i) => (
//             <ListItem key={avatar}>
//               <ChooseAvatarOption
//                 key={avatar}
//                 value={i}
//                 onChange={props.onChange}
//                 name="avatar"
//                 avatarUrl={avatar}
//               />
//             </ListItem>
//           ))}
//         </AvatarList>
//       </AvatarContainer>
//     </Content>
//   </Container>
// )
}ChooseAvatar.defaultProps={label:null};ChooseAvatar.propTypes={label:_propTypes.string};exports.default=ChooseAvatar;module.exports=exports['default'];

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _ChooseAvatarOption=__webpack_require__(1683);var _ChooseAvatarOption2=_interopRequireDefault(_ChooseAvatarOption);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_ChooseAvatarOption2.default;module.exports=exports['default'];

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.renderAvatarOption=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ChooseAvatarOption/ChooseAvatarOption.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _reduxForm=__webpack_require__(11);var _styles=__webpack_require__(1684);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var renderAvatarOption=exports.renderAvatarOption=function renderAvatarOption(props){return _react2.default.createElement(_styles.Input,_extends({},props.input,{name:props.name,onChange:function onChange(){return props.input.onChange(props.input.value);},value:props.input.value,type:'radio',__source:{fileName:_jsxFileName,lineNumber:9}}));};function ChooseAvatarOption(props){var avatarUrl=props.avatarUrl,name=props.name,value=props.value;return _react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(_reduxForm.Field,{component:renderAvatarOption,name:name,type:'radio',value:value,__source:{fileName:_jsxFileName,lineNumber:23}}),_react2.default.createElement(_styles.Avatar,{alt:'avatar type '+avatarUrl,src:avatarUrl,__source:{fileName:_jsxFileName,lineNumber:24}}));}ChooseAvatarOption.defaultProps={avatarUrl:null};ChooseAvatarOption.propTypes={avatarUrl:_propTypes.string.isRequired};exports.default=ChooseAvatarOption;

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Input=exports.Label=exports.Avatar=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Avatar=exports.Avatar=_styledComponents2.default.img.withConfig({displayName:'styles__Avatar',componentId:'sc-1yjwd5q-0'})(['border-radius:100%;height:',';transition:0.2s box-shadow,0.2s transform;width:',';'],(0,_rem2.default)('76px'),(0,_rem2.default)('76px'));var Label=exports.Label=_styledComponents2.default.label.withConfig({displayName:'styles__Label',componentId:'sc-1yjwd5q-1'})(['cursor:pointer;user-select:none;:hover{','{box-shadow:0 ',' ',' 0 rgba(51,48,106,0.31);transform:scale(1.26);}}'],Avatar,(0,_rem2.default)('6px'),(0,_rem2.default)('11px'));var Input=exports.Input=_styledComponents2.default.input.withConfig({displayName:'styles__Input',componentId:'sc-1yjwd5q-2'})(['display:none;:checked + ','{box-shadow:0 ',' ',' 0 rgba(51,48,106,0.31);transform:scale(1.26);}'],Avatar,(0,_rem2.default)('6px'),(0,_rem2.default)('11px'));

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Title=exports.ListItem=exports.AvatarList=exports.AvatarContainer=exports.Content=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n        padding: ',' ',' ',';\n    '],['\n        padding: ',' ',' ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        padding: 0 ',' 0;\n    '],['\n        padding: 0 ',' 0;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        display: block;\n\n        :after {\n            clear: both;\n            content: \'\';\n            display: table;\n        }\n    '],['\n        display: block;\n\n        :after {\n            clear: both;\n            content: \'\';\n            display: table;\n        }\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        float: left;\n        margin-bottom: ',';\n        text-align: center;\n        width: 50%;\n    '],['\n        float: left;\n        margin-bottom: ',';\n        text-align: center;\n        width: 50%;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n        ','\n    '],['\n        ','\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-tfk3ev-0'})(['background-color:',';border-bottom:',' solid rgba(197,195,216,0.4);border-top:',' solid rgba(197,195,216,0.4);margin:0 auto;padding:',' 0 ',';',';'],_colors.offWhite,(0,_rem2.default)('1px'),(0,_rem2.default)('1px'),(0,_rem2.default)('23px'),(0,_rem2.default)('51px'),_media2.default.small(_templateObject,(0,_rem2.default)('32px'),(0,_rem2.default)('30px'),(0,_rem2.default)('6px')));var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-tfk3ev-1'})(['',';'],_content2.default);var AvatarContainer=exports.AvatarContainer=_styledComponents2.default.div.withConfig({displayName:'styles__AvatarContainer',componentId:'sc-tfk3ev-2'})(['',';'],_media2.default.large(_templateObject2,(0,_rem2.default)('11px')));var AvatarList=exports.AvatarList=_styledComponents2.default.ul.withConfig({displayName:'styles__AvatarList',componentId:'sc-tfk3ev-3'})(['display:flex;justify-content:space-between;list-style:none;margin:0;min-height:',';padding:0;width:100%;',';'],(0,_rem2.default)('76px'),_media2.default.small(_templateObject3));var ListItem=exports.ListItem=_styledComponents2.default.li.withConfig({displayName:'styles__ListItem',componentId:'sc-tfk3ev-4'})(['',';'],_media2.default.small(_templateObject4,(0,_rem2.default)('24px')));var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-tfk3ev-5'})(['',' color:',';letter-spacing:',';line-height:1.33;margin:0 0 ',';',';'],_types.txt18OpenSans,_colors.darkBlue,(0,_em2.default)('-0.5px'),(0,_rem2.default)('40px'),_media2.default.small(_templateObject5,_types.txt14OpenSans));

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

module.exports = {"title":"Escolher Avatar"}

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BtnIcon=exports.FormButtonField=exports.ButtonField=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n            :hover {\n                border-color: ',';\n                color: ',';\n            }\n        '],['\n            :hover {\n                border-color: ',';\n                color: ',';\n            }\n        ']),_templateObject2=_taggedTemplateLiteral(['\n            :hover {\n                color: ',';\n            }\n        '],['\n            :hover {\n                color: ',';\n            }\n        ']),_templateObject3=_taggedTemplateLiteral(['\n      transition:\n        ','s transform linear,\n        ','s color;\n      min-width: ',';\n      width: auto;\n\n      :active {\n        transition: none;\n        transform: translateY(',');\n      }\n\n      :before {\n        background-color: ',';\n        ',';\n        content: \'\';\n        display: block;\n        height: 100%;\n        position: absolute;\n        right: 0px;\n        top: 0px;\n        transition-delay: 0;\n        transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1);\n        width: 0px;\n        z-index: 0;\n      }\n\n      :hover {\n        transition:\n          ','s transform linear,\n          ','s .2s color;\n\n        :before {\n          left: 0%;\n          right: auto;\n          transition-delay: .2s;\n          width: 100%;\n        }\n      }\n    '],['\n      transition:\n        ','s transform linear,\n        ','s color;\n      min-width: ',';\n      width: auto;\n\n      :active {\n        transition: none;\n        transform: translateY(',');\n      }\n\n      :before {\n        background-color: ',';\n        ',';\n        content: \'\';\n        display: block;\n        height: 100%;\n        position: absolute;\n        right: 0px;\n        top: 0px;\n        transition-delay: 0;\n        transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1);\n        width: 0px;\n        z-index: 0;\n      }\n\n      :hover {\n        transition:\n          ','s transform linear,\n          ','s .2s color;\n\n        :before {\n          left: 0%;\n          right: auto;\n          transition-delay: .2s;\n          width: 100%;\n        }\n      }\n    ']),_templateObject4=_taggedTemplateLiteral(['\n    min-width: ',';\n  '],['\n    min-width: ',';\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    line-height: ',';\n    padding: ',';\n    min-width: ',';\n  '],['\n    line-height: ',';\n    padding: ',';\n    min-width: ',';\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    border: none;\n'],['\n    border: none;\n']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _loading=__webpack_require__(100);var _loading2=_interopRequireDefault(_loading);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* istanbul ignore file */var transitionTime=0.4;var floatingSlices={white:'background-color: '+_colors.darkBlue+';',transparent:'background-color: '+_colors.white+';',darkBlue:'background-color: '+_colors.white+';',whiteNavyBlue:'background-color: '+_colors.darkBlue+';'};var buttonStyles={white:(0,_styledComponents.css)(['background-color:',';box-shadow:0 0 0 ',' ',' inset;color:',';',';'],_colors.white,(0,_rem2.default)('2px'),_colors.mediumGrey,_colors.mediumGrey,_media2.default.large(_templateObject,_colors.darkBlue,_colors.white)),transparent:(0,_styledComponents.css)(['background-color:transparent;box-shadow:0 0 0 ',' ',' inset;color:',';',';'],(0,_rem2.default)('2px'),_colors.white,_colors.white,_media2.default.large(_templateObject2,_colors.darkBlue)),darkBlue:(0,_styledComponents.css)(['background-color:',';box-shadow:0 ',' ',' 0 rgba(0,0,0,0.29);color:',';',';'],_colors.darkBlue,(0,_rem2.default)('2px'),(0,_rem2.default)('8px'),_colors.white,_media2.default.large(_templateObject2,_colors.darkBlue)),skyBlue:(0,_styledComponents.css)(['background-color:',';box-shadow:0 ',' ',' 0 rgba(0,0,0,0.29);color:',';',';'],_colors.skyBlue,(0,_rem2.default)('2px'),(0,_rem2.default)('8px'),_colors.white,_media2.default.large(_templateObject2,_colors.skyBlue)),whiteNavyBlue:(0,_styledComponents.css)(['background-color:',';box-shadow:0 0 0 ',' ',' inset;color:',';',';'],_colors.white,(0,_rem2.default)('2px'),_colors.linkNavyBlue,_colors.linkNavyBlue,_media2.default.large(_templateObject,_colors.linkNavyBlue,_colors.white))};var disabled=function disabled(props){return props.disabled&&'\n        background-color: '+_colors.offWhite+';\n        box-shadow: none;\n        color: '+_colors.grey+';\n        cursor: default;\n\n        :hover,\n        :visited,\n        :active,\n        :focus {\n            transform: none;\n            background-color: '+_colors.offWhite+';\n            box-shadow: none;\n            color: '+_colors.grey+';\n            cursor: default;\n        }\n\n        :before {\n            display: none;\n        }\n    ';};var dispatchColor=function dispatchColor(props){return floatingSlices[props.buttonType];};var buttonModifier=function buttonModifier(props){return buttonStyles[props.buttonType];};var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-1cuxmhx-0'})(['background:transparent;background-color:',';border-radius:',';color:',';display:inline-block;min-width:auto;overflow:hidden;position:relative;text-align:center;transform:translateY(0);user-select:none;width:100%;',';',';',';',';'],function(props){return props.secondary?_colors.linkNavyBlue:_colors.lightBlue;},(0,_rem2.default)('6px'),_colors.white,_media2.default.large(_templateObject3,transitionTime/4,transitionTime,function(props){return props.width||(0,_rem2.default)('160px');},(0,_rem2.default)('2px'),_colors.navyBlue,dispatchColor,transitionTime/4,transitionTime),_media2.default.small(_templateObject4,function(props){return props.width||(0,_rem2.default)('100px');}),buttonModifier,disabled);var ButtonField=exports.ButtonField=_styledComponents2.default.a.withConfig({displayName:'styles__ButtonField',componentId:'sc-1cuxmhx-1'})(['cursor:pointer;display:block;font-family:OpenSans;font-size:',';font-weight:600;height:100%;line-height:',';letter-spacing:',';position:relative;text-align:center;width:100%;z-index:1;',';',';'],function(props){return props.fontSize?(0,_rem2.default)(props.fontSize):(0,_rem2.default)('16px');},function(props){return props.lineHeight?(0,_rem2.default)(props.lineHeight):(0,_rem2.default)('60px');},(0,_rem2.default)('-0.5px'),_media2.default.large(_templateObject5,function(props){return props.lineHeight?(0,_rem2.default)(props.lineHeight):(0,_rem2.default)('48px');},function(props){return props.padding?props.padding:'0 '+(0,_rem2.default)('30px');},function(props){return props.width||(0,_rem2.default)('160px');}),function(_ref){var disabled=_ref.disabled,loading=_ref.loading;return disabled&&(0,_styledComponents.css)(['cursor:not-allowed;',';background-repeat:no-repeat;background-position:20px center;background-size:20px;'],loading&&'background-image: url('+_loading2.default+')');});var FormButtonField=exports.FormButtonField=ButtonField.withComponent('button').extend(_templateObject6);var BtnIcon=exports.BtnIcon=_styledComponents2.default.img.withConfig({displayName:'styles__BtnIcon',componentId:'sc-1cuxmhx-2'})(['padding-right:10px;']);

/***/ }),
/* 1688 */
/***/ (function(module, exports) {

module.exports = {"labels":{"name":"Nome","cpf":"CPF","dob":"Data do seu nascimento","gender":"Sexo","maritalStatus":"Estado civil","mothersName":"Nome da sua mãe","emiteNotaFiscal":"Desejo enviar meus dados pessoais para os parceiros conveniamos me identificarem na emissão de Nota Fiscal Eletrônica.","pap":"Desejo aderir ao Ponto-a-Ponto"},"errorMessages":{"emptyField":"Campo obrigatório"}}

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/TextInput/TextInput.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _Icon=__webpack_require__(31);var _Tooltip=__webpack_require__(594);var _Tooltip2=_interopRequireDefault(_Tooltip);var _styles=__webpack_require__(185);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TextInput=function(_Component){_inherits(TextInput,_Component);function TextInput(props){_classCallCheck(this,TextInput);var _this=_possibleConstructorReturn(this,(TextInput.__proto__||Object.getPrototypeOf(TextInput)).call(this,props));_this.onClick=function(e){if(_this.props.lockCursor){_this.lockCursorFunc(e);}};_this.keyUp=function(e){var _this$props=_this.props,lockCursor=_this$props.lockCursor,lengthCounter=_this$props.lengthCounter;if(lockCursor){_this.lockCursorFunc(e);}if(lengthCounter){_this.setState({valueLength:e.target.value.length});}};_this.keyDown=function(e){if(_this.props.lockCursor){_this.lockCursorFunc(e);}};_this.blur=function(){if(_this.props.onBlur){_this.props.onBlur();}_this.input.blur();_this.setState({isFocus:false});};_this.focus=function(){if(_this.props.onFocus){_this.props.onFocus();}_this.input.focus();_this.setState({isFocus:true});};_this.lockCursorFunc=function(e){var currentValue=e.target.value;e.target.value='';e.target.value=currentValue;};_this.isEmpty=function(value){var isString=typeof value==='string';var isEmpty=!(isString&&value.length>0);return isEmpty;};_this.state={valueLength:props.value&&props.value.length||0,isFocus:false};return _this;}_createClass(TextInput,[{key:'render',value:function render(){var _this2=this;var _props=this.props,disabled=_props.disabled,errorMessage=_props.errorMessage,label=_props.label,loading=_props.loading,name=_props.name,onChange=_props.onChange,value=_props.value,negative=_props.negative,isRequired=_props.isRequired,tooltip=_props.tooltip,tooltipColor=_props.tooltipColor,tooltipPositionRight=_props.tooltipPositionRight,endIcon=_props.endIcon,labelIcon=_props.labelIcon;var isFocus=this.state.isFocus;var isEmpty=this.isEmpty(value);var highlightPlaceholderOnBlur=isEmpty&&!isFocus;return _react2.default.createElement(_Tooltip2.default,{text:tooltip,tooltipColor:tooltipColor,positionRight:tooltipPositionRight,showTooltip:tooltip&&isFocus,__source:{fileName:_jsxFileName,lineNumber:109}},_react2.default.createElement(_styles.Wrapper,{negative:negative,__source:{fileName:_jsxFileName,lineNumber:115}},_react2.default.createElement(_styles.Label,{htmlFor:name,__source:{fileName:_jsxFileName,lineNumber:116}},label,isRequired&&'*'),labelIcon&&_react2.default.createElement(_styles.LabelIconWrapper,{__source:{fileName:_jsxFileName,lineNumber:120}},labelIcon),_react2.default.createElement(_styles.Content,{disabled:disabled,isFocus:isFocus,hasError:errorMessage,__source:{fileName:_jsxFileName,lineNumber:121}},_react2.default.createElement(_styles.InputField,_extends({},this.props,{maxLength:this.props.maxlength,innerRef:function innerRef(component){_this2.input=component;},onChange:onChange&&function(e){return onChange(e.target.value);},onFocus:this.focus,onKeyUp:this.keyUp,onKeyDown:this.keyDown,onClick:this.onClick,onBlur:this.blur,isFocus:isFocus,highlightPlaceholderOnBlur:highlightPlaceholderOnBlur,__source:{fileName:_jsxFileName,lineNumber:122}})),endIcon&&_react2.default.createElement(_styles.InputIconWrapper,{__source:{fileName:_jsxFileName,lineNumber:137}},endIcon),loading&&_react2.default.createElement(_styles.LoadingContainer,{__source:{fileName:_jsxFileName,lineNumber:139}},_react2.default.createElement(_Icon.Icon,{width:'11',height:'4',icon:'loading',viewBox:'0 0 11 4',__source:{fileName:_jsxFileName,lineNumber:140}}))),this.props.lengthCounter&&this.props.maxlength&&_react2.default.createElement(_styles.LengthCounter,{__source:{fileName:_jsxFileName,lineNumber:146}},this.state.valueLength,'/',this.props.maxlength),errorMessage&&errorMessage.length>1&&_react2.default.createElement(_styles.BottomMessage,{__source:{fileName:_jsxFileName,lineNumber:152}},_react2.default.createElement(_styles.Error,{__source:{fileName:_jsxFileName,lineNumber:153}},errorMessage))));}}]);return TextInput;}(_react.Component);TextInput.defaultProps={disabled:null,errorMessage:null,label:null,lengthCounter:null,loading:null,lockCursor:null,name:'',maxlength:null,onChange:null,negative:null};TextInput.propTypes={disabled:_propTypes.bool,errorMessage:(0,_propTypes.oneOfType)([_propTypes.string,_propTypes.bool]),label:_propTypes.string,lengthCounter:_propTypes.bool,loading:_propTypes.bool,lockCursor:_propTypes.bool,name:_propTypes.string,maxlength:_propTypes.string,onChange:_propTypes.func,negative:_propTypes.bool};exports.default=TextInput;module.exports=exports['default'];

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Select/Select.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1691);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _styles=__webpack_require__(1692);var _styles2=__webpack_require__(185);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function SelectBox(_ref){var disabled=_ref.disabled,errorMessage=_ref.errorMessage,isRequired=_ref.isRequired,label=_ref.label,name=_ref.name,negative=_ref.negative,_onChange=_ref.onChange,options=_ref.options,loadOptions=_ref.loadOptions,value=_ref.value,placeholder=_ref.placeholder;var Select=(0,_styles.SelectConstructor)(loadOptions);return _react2.default.createElement(_styles.Wrapper,{negative:negative,__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement(_styles2.Label,{htmlFor:name,__source:{fileName:_jsxFileName,lineNumber:25}},label,isRequired&&'*'),_react2.default.createElement(_styles.WrapperSelect,{__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement(Select,{value:value,onChange:function onChange(e){return _onChange(e.value);},options:options,placeholder:placeholder,searchable:false,clearable:false,arrowRenderer:function arrowRenderer(){return null;},hasError:errorMessage,openOnFocus:true,disabled:disabled,loadOptions:loadOptions,__source:{fileName:_jsxFileName,lineNumber:30}}),_react2.default.createElement(_Icon2.default,{icon:'dropdown-arrow',svgStyle:_styles.dropdownArrow,width:'12',height:'7',viewBox:'0 0 12 7',__source:{fileName:_jsxFileName,lineNumber:43}})),_react2.default.createElement(_styles.MobileSelect,{disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement('select',{className:'Select-control',value:value,disabled:disabled,onChange:function onChange(e){return _onChange(e.target.value);},onBlur:function onBlur(e){return _onChange(e.target.value);},__source:{fileName:_jsxFileName,lineNumber:52}},options.map(function(option){return _react2.default.createElement('option',{key:option.value,value:option.value,__source:{fileName:_jsxFileName,lineNumber:60}},option.label);})),_react2.default.createElement(_Icon2.default,{icon:'dropdown-arrow',svgStyle:_styles.dropdownArrow,width:'12',height:'7',viewBox:'0 0 12 7',__source:{fileName:_jsxFileName,lineNumber:65}})),errorMessage&&errorMessage.length>1&&_react2.default.createElement(_styles2.BottomMessage,{__source:{fileName:_jsxFileName,lineNumber:75}},_react2.default.createElement(_styles2.Error,{__source:{fileName:_jsxFileName,lineNumber:76}},errorMessage)));}exports.default=SelectBox;module.exports=exports['default'];

/***/ }),
/* 1691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Wrapper=exports.SelectConstructor=exports.WrapperSelect=exports.MobileSelect=exports.dropdownArrow=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: block;\n    '],['\n        display: block;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactSelect=__webpack_require__(250);var _reactSelect2=_interopRequireDefault(_reactSelect);var _styles=__webpack_require__(185);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var placeholderStyle='\n    font-family: OpenSans;\n    font-size: 20px;\n    line-height: '+(0,_rem2.default)('45px')+';\n    display: flex;\n';var greyBottomLine='\n    '+_styles.bottomLine+'\n    background-color: '+_colors.grey+';\n    left: 0;\n    right: 0;\n    width: 100%;\n';var dropdownArrow=exports.dropdownArrow='\n    stroke: '+_colors.grey+'; height: 10px; width: 15px;\n';var MobileSelect=exports.MobileSelect=_styledComponents2.default.div.withConfig({displayName:'styles__MobileSelect',componentId:'sc-17bm0z-0'})(['display:none;position:relative;width:100%;> select{background:transparent;color:',';font-size:',';font-family:OpenSans;height:',';padding-top:',';text-indent:',';-webkit-appearance:none;-moz-appearance:none;}:after{',';}> select,> select:hover{border:none;}> svg{position:absolute;right:15px;top:20px;pointer-events:none;',';}',';'],_colors.white,(0,_rem2.default)('20px'),(0,_rem2.default)('45px'),(0,_rem2.default)('5px'),(0,_rem2.default)('16px'),greyBottomLine,function(props){return props.disabled&&'opacity: .3';},_media2.default.small(_templateObject));var WrapperSelect=exports.WrapperSelect=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperSelect',componentId:'sc-17bm0z-1'})(['display:none;',';'],_media2.default.large(_templateObject));var SelectConstructor=exports.SelectConstructor=function SelectConstructor(isAsync){return(0,_styledComponents2.default)(isAsync?_reactSelect2.default.Async:_reactSelect2.default).withConfig({displayName:'styles',componentId:'sc-17bm0z-2'})(['+ svg{position:absolute;right:15px;top:38px;pointer-events:none;','}&.has-value.Select--single > .Select-control .Select-value .Select-value-label,&.has-value.is-focused.Select--single > .Select-control .Select-value .Select-value-label{color:','}.Select-placeholder{padding-left:',';}.Select-value-label{padding-left:',';}&.is-focused{.Select-control{background-color:transparent}:not(.is-open){> .Select-control{box-shadow:none;}}}.Select-placeholder{','}& .Select-control{border:none;border-radius:0;background-color:transparent;height:',';:after{',' ','}:before{',' background-color:transparent;left:50%;right:0;transform:translateX(-50%);transition:0.6s ease width,0.6s ease background-color;width:0;z-index:1;','}.Select-value{.Select-value-label{font-family:OpenSans;font-size:',';line-height:',';}}}&.is-open{+ svg{transform:rotate(180deg);}.Select-control{box-shadow:0 8px 8px 0 rgba(30,27,91,0.2);:hover{box-shadow:0 8px 8px 0 rgba(30,27,91,0.2);}:after{background-color:',';width:100%;transition:0.6s ease width,0.6s ease background-color;}:before{background-color:',';width:100%;}}}& .Select-menu-outer{box-shadow:0 8px 8px 0 rgba(30,27,91,0.2);border:none;margin-top:0;z-index:10;}& .Select-option{font-family:OpenSans;font-size:',';padding:',' ',';color:',';&.is-selected{background-color:transparent;color:',';}&.is-focused{background-color:transparent;color ',';}}'],function(props){return props.disabled&&'opacity: .3';},_colors.darkGrey,(0,_rem2.default)('16px'),(0,_rem2.default)('5px'),placeholderStyle,(0,_rem2.default)('45px'),greyBottomLine,function(props){return props.disabled&&'opacity: .3';},_styles.bottomLine,function(props){return props.hasError&&'\n                background-color: '+_colors.red+';\n                width: 100%;\n            ';},(0,_rem2.default)('20px'),(0,_rem2.default)('45px'),_colors.lighterGrey,_colors.lighterGrey,(0,_rem2.default)('16px'),(0,_rem2.default)('15px'),(0,_rem2.default)('16px'),_colors.mediumGrey,_colors.mediumGrey,_colors.darkBlue);};var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-17bm0z-3'})(['padding-top:0.3125rem;position:relative;.Select.is-disabled .Select-control{background:transparent;}',' ','{:after{background-color:white;font-size:10px;}}'],function(props){return props.negative&&(0,_styledComponents.css)(['color:',';','{color:',';opacity:1;}','{& .Select-control{&:after{background-color:',';}}&.has-value.Select--single,&.has-value.is-focused.Select--single{> .Select-control .Select-value .Select-value-label{color:',';}}}'],_colors.white,_styles.Label,_colors.white,SelectConstructor,_colors.white,_colors.white);},MobileSelect);

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = __webpack_require__(0);
var PropTypes = __webpack_require__(9);
var createClass = __webpack_require__(156);

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = createClass({
	propTypes: {
		className: PropTypes.string, // className for the outer element
		defaultValue: PropTypes.any, // default field value
		inputClassName: PropTypes.string, // className for the input element
		inputRef: PropTypes.func, // ref callback for the input element
		inputStyle: PropTypes.object, // css styles for the input element
		minWidth: PropTypes.oneOfType([// minimum width for input element
		PropTypes.number, PropTypes.string]),
		onAutosize: PropTypes.func, // onAutosize handler: function(newWidth) {}
		onChange: PropTypes.func, // onChange handler: function(newValue) {}
		placeholder: PropTypes.string, // placeholder text
		placeholderIsMinWidth: PropTypes.bool, // don't collapse size to less than the placeholder
		style: PropTypes.object, // css styles for the outer element
		value: PropTypes.any },
	// field value
	getDefaultProps: function getDefaultProps() {
		return {
			minWidth: 1
		};
	},
	getInitialState: function getInitialState() {
		return {
			inputWidth: this.props.minWidth,
			inputId: '_' + Math.random().toString(36).substr(2, 12)
		};
	},
	componentDidMount: function componentDidMount() {
		this.mounted = true;
		this.copyInputStyles();
		this.updateInputWidth();
	},
	componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
		if (prevState.inputWidth !== this.state.inputWidth) {
			if (typeof this.props.onAutosize === 'function') {
				this.props.onAutosize(this.state.inputWidth);
			}
		}
		this.updateInputWidth();
	},
	componentWillUnmount: function componentWillUnmount() {
		this.mounted = false;
	},
	inputRef: function inputRef(el) {
		this.input = el;
		if (typeof this.props.inputRef === 'function') {
			this.props.inputRef(el);
		}
	},
	placeHolderSizerRef: function placeHolderSizerRef(el) {
		this.placeHolderSizer = el;
	},
	sizerRef: function sizerRef(el) {
		this.sizer = el;
	},
	copyInputStyles: function copyInputStyles() {
		if (!this.mounted || !window.getComputedStyle) {
			return;
		}
		var inputStyle = this.input && window.getComputedStyle(this.input);
		if (!inputStyle) {
			return;
		}
		var widthNode = this.sizer;
		widthNode.style.fontSize = inputStyle.fontSize;
		widthNode.style.fontFamily = inputStyle.fontFamily;
		widthNode.style.fontWeight = inputStyle.fontWeight;
		widthNode.style.fontStyle = inputStyle.fontStyle;
		widthNode.style.letterSpacing = inputStyle.letterSpacing;
		widthNode.style.textTransform = inputStyle.textTransform;
		if (this.props.placeholder) {
			var placeholderNode = this.placeHolderSizer;
			placeholderNode.style.fontSize = inputStyle.fontSize;
			placeholderNode.style.fontFamily = inputStyle.fontFamily;
			placeholderNode.style.fontWeight = inputStyle.fontWeight;
			placeholderNode.style.fontStyle = inputStyle.fontStyle;
			placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			placeholderNode.style.textTransform = inputStyle.textTransform;
		}
	},
	updateInputWidth: function updateInputWidth() {
		if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
			return;
		}
		var newInputWidth = undefined;
		if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
			newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
		} else {
			newInputWidth = this.sizer.scrollWidth + 2;
		}
		if (newInputWidth < this.props.minWidth) {
			newInputWidth = this.props.minWidth;
		}
		if (newInputWidth !== this.state.inputWidth) {
			this.setState({
				inputWidth: newInputWidth
			});
		}
	},
	getInput: function getInput() {
		return this.input;
	},
	focus: function focus() {
		this.input.focus();
	},
	blur: function blur() {
		this.input.blur();
	},
	select: function select() {
		this.input.select();
	},
	render: function render() {
		var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
			if (previousValue !== null && previousValue !== undefined) {
				return previousValue;
			}
			return currentValue;
		});

		var wrapperStyle = this.props.style || {};
		if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
		var inputStyle = _extends({}, this.props.inputStyle);
		inputStyle.width = this.state.inputWidth + 'px';
		inputStyle.boxSizing = 'content-box';
		var inputProps = _extends({}, this.props);
		inputProps.className = this.props.inputClassName;
		inputProps.style = inputStyle;
		// ensure props meant for `AutosizeInput` don't end up on the `input`
		delete inputProps.inputClassName;
		delete inputProps.inputStyle;
		delete inputProps.minWidth;
		delete inputProps.onAutosize;
		delete inputProps.placeholderIsMinWidth;
		delete inputProps.inputRef;
		return React.createElement(
			'div',
			{ className: this.props.className, style: wrapperStyle },
			React.createElement('style', { dangerouslySetInnerHTML: {
					__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
				} }),
			React.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
			React.createElement(
				'div',
				{ ref: this.sizerRef, style: sizerStyle },
				sizerValue
			),
			this.props.placeholder ? React.createElement(
				'div',
				{ ref: this.placeHolderSizerRef, style: sizerStyle },
				this.props.placeholder
			) : null
		);
	}
});

module.exports = AutosizeInput;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports["default"] = arrowRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return _react2["default"].createElement("span", {
		className: "Select-arrow",
		onMouseDown: onMouseDown
	});
}

;
module.exports = exports["default"];

/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = clearRenderer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function clearRenderer() {
	return _react2['default'].createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
}

;
module.exports = exports['default'];

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(250);

var _Select2 = _interopRequireDefault(_Select);

var _utilsStripDiacritics = __webpack_require__(597);

var _utilsStripDiacritics2 = _interopRequireDefault(_utilsStripDiacritics);

var propTypes = {
	autoload: _propTypes2['default'].bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: _propTypes2['default'].any, // object to use to cache results; set to null/false to disable caching
	children: _propTypes2['default'].func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: _propTypes2['default'].bool, // strip diacritics when filtering; defaults to true
	ignoreCase: _propTypes2['default'].bool, // perform case-insensitive filtering; defaults to true
	loadingPlaceholder: _propTypes2['default'].oneOfType([// replaces the placeholder while options are loading
	_propTypes2['default'].string, _propTypes2['default'].node]),
	loadOptions: _propTypes2['default'].func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	multi: _propTypes2['default'].bool, // multi-value input
	options: _propTypes2['default'].array.isRequired, // array of options
	placeholder: _propTypes2['default'].oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	_propTypes2['default'].string, _propTypes2['default'].node]),
	noResultsText: _propTypes2['default'].oneOfType([// field noResultsText, displayed when no options come back from the server
	_propTypes2['default'].string, _propTypes2['default'].node]),
	onChange: _propTypes2['default'].func, // onChange handler: function (newValue) {}
	searchPromptText: _propTypes2['default'].oneOfType([// label to prompt for search input
	_propTypes2['default'].string, _propTypes2['default'].node]),
	onInputChange: _propTypes2['default'].func, // optional for keeping track of what is being typed
	value: _propTypes2['default'].any };

// initial field value
var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = (function (_Component) {
	_inherits(Async, _Component);

	function Async(props, context) {
		_classCallCheck(this, Async);

		_get(Object.getPrototypeOf(Async.prototype), 'constructor', this).call(this, props, context);

		this._cache = props.cache === defaultCache ? {} : props.cache;

		this.state = {
			isLoading: false,
			options: props.options
		};

		this._onInputChange = this._onInputChange.bind(this);
	}

	_createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;

			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			var _this = this;

			var propertiesToSync = ['options'];
			propertiesToSync.forEach(function (prop) {
				if (_this.props[prop] !== nextProps[prop]) {
					_this.setState(_defineProperty({}, prop, nextProps[prop]));
				}
			});
		}
	}, {
		key: 'clearOptions',
		value: function clearOptions() {
			this.setState({ options: [] });
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && cache.hasOwnProperty(inputValue)) {
				this.setState({
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				if (callback === _this2._callback) {
					_this2._callback = null;

					var options = data && data.options || [];

					if (cache) {
						cache[inputValue] = options;
					}

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}

			return inputValue;
		}
	}, {
		key: '_onInputChange',
		value: function _onInputChange(inputValue) {
			var _props = this.props;
			var ignoreAccents = _props.ignoreAccents;
			var ignoreCase = _props.ignoreCase;
			var onInputChange = _props.onInputChange;

			if (ignoreAccents) {
				inputValue = (0, _utilsStripDiacritics2['default'])(inputValue);
			}

			if (ignoreCase) {
				inputValue = inputValue.toLowerCase();
			}

			if (onInputChange) {
				onInputChange(inputValue);
			}

			return this.loadOptions(inputValue);
		}
	}, {
		key: 'inputValue',
		value: function inputValue() {
			if (this.select) {
				return this.select.state.inputValue;
			}
			return '';
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props;
			var loadingPlaceholder = _props2.loadingPlaceholder;
			var noResultsText = _props2.noResultsText;
			var searchPromptText = _props2.searchPromptText;
			var isLoading = this.state.isLoading;

			var inputValue = this.inputValue();

			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props;
			var children = _props3.children;
			var loadingPlaceholder = _props3.loadingPlaceholder;
			var placeholder = _props3.placeholder;
			var _state = this.state;
			var isLoading = _state.isLoading;
			var options = _state.options;

			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				},
				onChange: function onChange(newValues) {
					if (_this3.props.multi && _this3.props.value && newValues.length > _this3.props.value.length) {
						_this3.clearOptions();
					}
					_this3.props.onChange(newValues);
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this._onInputChange
			}));
		}
	}]);

	return Async;
})(_react.Component);

exports['default'] = Async;

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
}
module.exports = exports['default'];

/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(156);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _Select = __webpack_require__(250);

var _Select2 = _interopRequireDefault(_Select);

function reduce(obj) {
	var props = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	return Object.keys(obj).reduce(function (props, key) {
		var value = obj[key];
		if (value !== undefined) props[key] = value;
		return props;
	}, props);
}

var AsyncCreatable = (0, _createReactClass2['default'])({
	displayName: 'AsyncCreatableSelect',

	focus: function focus() {
		this.select.focus();
	},

	render: function render() {
		var _this = this;

		return _react2['default'].createElement(
			_Select2['default'].Async,
			this.props,
			function (asyncProps) {
				return _react2['default'].createElement(
					_Select2['default'].Creatable,
					_this.props,
					function (creatableProps) {
						return _react2['default'].createElement(_Select2['default'], _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
							onInputChange: function (input) {
								creatableProps.onInputChange(input);
								return asyncProps.onInputChange(input);
							},
							ref: function (ref) {
								_this.select = ref;
								creatableProps.ref(ref);
								asyncProps.ref(ref);
							}
						}));
					}
				);
			}
		);
	}
});

module.exports = AsyncCreatable;

/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(156);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(250);

var _Select2 = _interopRequireDefault(_Select);

var _utilsDefaultFilterOptions = __webpack_require__(596);

var _utilsDefaultFilterOptions2 = _interopRequireDefault(_utilsDefaultFilterOptions);

var _utilsDefaultMenuRenderer = __webpack_require__(598);

var _utilsDefaultMenuRenderer2 = _interopRequireDefault(_utilsDefaultMenuRenderer);

var Creatable = (0, _createReactClass2['default'])({
	displayName: 'CreatableSelect',

	propTypes: {
		// Child function responsible for creating the inner Select component
		// This component can be used to compose HOCs (eg Creatable and Async)
		// (props: Object): PropTypes.element
		children: _propTypes2['default'].func,

		// See Select.propTypes.filterOptions
		filterOptions: _propTypes2['default'].any,

		// Searches for any matching option within the set of options.
		// This function prevents duplicate options from being created.
		// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
		isOptionUnique: _propTypes2['default'].func,

		// Determines if the current input text represents a valid option.
		// ({ label: string }): boolean
		isValidNewOption: _propTypes2['default'].func,

		// See Select.propTypes.menuRenderer
		menuRenderer: _propTypes2['default'].any,

		// Factory to create new option.
		// ({ label: string, labelKey: string, valueKey: string }): Object
		newOptionCreator: _propTypes2['default'].func,

		// input change handler: function (inputValue) {}
		onInputChange: _propTypes2['default'].func,

		// input keyDown handler: function (event) {}
		onInputKeyDown: _propTypes2['default'].func,

		// new option click handler: function (option) {}
		onNewOptionClick: _propTypes2['default'].func,

		// See Select.propTypes.options
		options: _propTypes2['default'].array,

		// Creates prompt/placeholder option text.
		// (filterText: string): string
		promptTextCreator: _propTypes2['default'].func,

		// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
		shouldKeyDownEventCreateNewOption: _propTypes2['default'].func
	},

	// Default prop methods
	statics: {
		isOptionUnique: isOptionUnique,
		isValidNewOption: isValidNewOption,
		newOptionCreator: newOptionCreator,
		promptTextCreator: promptTextCreator,
		shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
	},

	getDefaultProps: function getDefaultProps() {
		return {
			filterOptions: _utilsDefaultFilterOptions2['default'],
			isOptionUnique: isOptionUnique,
			isValidNewOption: isValidNewOption,
			menuRenderer: _utilsDefaultMenuRenderer2['default'],
			newOptionCreator: newOptionCreator,
			promptTextCreator: promptTextCreator,
			shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
		};
	},

	createNewOption: function createNewOption() {
		var _props = this.props;
		var isValidNewOption = _props.isValidNewOption;
		var newOptionCreator = _props.newOptionCreator;
		var onNewOptionClick = _props.onNewOptionClick;
		var _props$options = _props.options;
		var options = _props$options === undefined ? [] : _props$options;
		var shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;

		if (isValidNewOption({ label: this.inputValue })) {
			var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
			var _isOptionUnique = this.isOptionUnique({ option: option });

			// Don't add the same option twice.
			if (_isOptionUnique) {
				if (onNewOptionClick) {
					onNewOptionClick(option);
				} else {
					options.unshift(option);

					this.select.selectValue(option);
				}
			}
		}
	},

	filterOptions: function filterOptions() {
		var _props2 = this.props;
		var filterOptions = _props2.filterOptions;
		var isValidNewOption = _props2.isValidNewOption;
		var options = _props2.options;
		var promptTextCreator = _props2.promptTextCreator;

		// TRICKY Check currently selected options as well.
		// Don't display a create-prompt for a value that's selected.
		// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.
		var excludeOptions = arguments[2] || [];

		var filteredOptions = filterOptions.apply(undefined, arguments) || [];

		if (isValidNewOption({ label: this.inputValue })) {
			var _newOptionCreator = this.props.newOptionCreator;

			var option = _newOptionCreator({
				label: this.inputValue,
				labelKey: this.labelKey,
				valueKey: this.valueKey
			});

			// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
			// For multi-selects, this would remove it from the filtered list.
			var _isOptionUnique2 = this.isOptionUnique({
				option: option,
				options: excludeOptions.concat(filteredOptions)
			});

			if (_isOptionUnique2) {
				var _prompt = promptTextCreator(this.inputValue);

				this._createPlaceholderOption = _newOptionCreator({
					label: _prompt,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				filteredOptions.unshift(this._createPlaceholderOption);
			}
		}

		return filteredOptions;
	},

	isOptionUnique: function isOptionUnique(_ref2) {
		var option = _ref2.option;
		var options = _ref2.options;
		var isOptionUnique = this.props.isOptionUnique;

		options = options || this.select.filterOptions();

		return isOptionUnique({
			labelKey: this.labelKey,
			option: option,
			options: options,
			valueKey: this.valueKey
		});
	},

	menuRenderer: function menuRenderer(params) {
		var menuRenderer = this.props.menuRenderer;

		return menuRenderer(_extends({}, params, {
			onSelect: this.onOptionSelect,
			selectValue: this.onOptionSelect
		}));
	},

	onInputChange: function onInputChange(input) {
		var onInputChange = this.props.onInputChange;

		if (onInputChange) {
			onInputChange(input);
		}

		// This value may be needed in between Select mounts (when this.select is null)
		this.inputValue = input;
	},

	onInputKeyDown: function onInputKeyDown(event) {
		var _props3 = this.props;
		var shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption;
		var onInputKeyDown = _props3.onInputKeyDown;

		var focusedOption = this.select.getFocusedOption();

		if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
			this.createNewOption();

			// Prevent decorated Select from doing anything additional with this keyDown event
			event.preventDefault();
		} else if (onInputKeyDown) {
			onInputKeyDown(event);
		}
	},

	onOptionSelect: function onOptionSelect(option, event) {
		if (option === this._createPlaceholderOption) {
			this.createNewOption();
		} else {
			this.select.selectValue(option);
		}
	},

	focus: function focus() {
		this.select.focus();
	},

	render: function render() {
		var _this = this;

		var _props4 = this.props;
		var newOptionCreator = _props4.newOptionCreator;
		var shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption;

		var restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);

		var children = this.props.children;

		// We can't use destructuring default values to set the children,
		// because it won't apply work if `children` is null. A falsy check is
		// more reliable in real world use-cases.
		if (!children) {
			children = defaultChildren;
		}

		var props = _extends({}, restProps, {
			allowCreate: true,
			filterOptions: this.filterOptions,
			menuRenderer: this.menuRenderer,
			onInputChange: this.onInputChange,
			onInputKeyDown: this.onInputKeyDown,
			ref: function ref(_ref) {
				_this.select = _ref;

				// These values may be needed in between Select mounts (when this.select is null)
				if (_ref) {
					_this.labelKey = _ref.props.labelKey;
					_this.valueKey = _ref.props.valueKey;
				}
			}
		});

		return children(props);
	}
});

function defaultChildren(props) {
	return _react2['default'].createElement(_Select2['default'], props);
};

function isOptionUnique(_ref3) {
	var option = _ref3.option;
	var options = _ref3.options;
	var labelKey = _ref3.labelKey;
	var valueKey = _ref3.valueKey;

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

function isValidNewOption(_ref4) {
	var label = _ref4.label;

	return !!label;
};

function newOptionCreator(_ref5) {
	var label = _ref5.label;
	var labelKey = _ref5.labelKey;
	var valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';
	return option;
};

function promptTextCreator(label) {
	return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
	}

	return false;
};

module.exports = Creatable;

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(156);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(251);

var _classnames2 = _interopRequireDefault(_classnames);

var Option = (0, _createReactClass2['default'])({
	propTypes: {
		children: _propTypes2['default'].node,
		className: _propTypes2['default'].string, // className (based on mouse position)
		instancePrefix: _propTypes2['default'].string.isRequired, // unique prefix for the ids (used for aria)
		isDisabled: _propTypes2['default'].bool, // the option is disabled
		isFocused: _propTypes2['default'].bool, // the option is focused
		isSelected: _propTypes2['default'].bool, // the option is selected
		onFocus: _propTypes2['default'].func, // method to handle mouseEnter on option element
		onSelect: _propTypes2['default'].func, // method to handle click on option element
		onUnfocus: _propTypes2['default'].func, // method to handle mouseLeave on option element
		option: _propTypes2['default'].object.isRequired, // object that is base for that option
		optionIndex: _propTypes2['default'].number },
	// index of the option, used to generate unique ids for aria
	blockEvent: function blockEvent(event) {
		event.preventDefault();
		event.stopPropagation();
		if (event.target.tagName !== 'A' || !('href' in event.target)) {
			return;
		}
		if (event.target.target) {
			window.open(event.target.href, event.target.target);
		} else {
			window.location.href = event.target.href;
		}
	},

	handleMouseDown: function handleMouseDown(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onSelect(this.props.option, event);
	},

	handleMouseEnter: function handleMouseEnter(event) {
		this.onFocus(event);
	},

	handleMouseMove: function handleMouseMove(event) {
		this.onFocus(event);
	},

	handleTouchEnd: function handleTouchEnd(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		this.handleMouseDown(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	onFocus: function onFocus(event) {
		if (!this.props.isFocused) {
			this.props.onFocus(this.props.option, event);
		}
	},
	render: function render() {
		var _props = this.props;
		var option = _props.option;
		var instancePrefix = _props.instancePrefix;
		var optionIndex = _props.optionIndex;

		var className = (0, _classnames2['default'])(this.props.className, option.className);

		return option.disabled ? _react2['default'].createElement(
			'div',
			{ className: className,
				onMouseDown: this.blockEvent,
				onClick: this.blockEvent },
			this.props.children
		) : _react2['default'].createElement(
			'div',
			{ className: className,
				style: option.style,
				role: 'option',
				onMouseDown: this.handleMouseDown,
				onMouseEnter: this.handleMouseEnter,
				onMouseMove: this.handleMouseMove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove,
				onTouchEnd: this.handleTouchEnd,
				id: instancePrefix + '-option-' + optionIndex,
				title: option.title },
			this.props.children
		);
	}
});

module.exports = Option;

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(156);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(251);

var _classnames2 = _interopRequireDefault(_classnames);

var Value = (0, _createReactClass2['default'])({

	displayName: 'Value',

	propTypes: {
		children: _propTypes2['default'].node,
		disabled: _propTypes2['default'].bool, // disabled prop passed to ReactSelect
		id: _propTypes2['default'].string, // Unique id for the value - used for aria
		onClick: _propTypes2['default'].func, // method to handle click on value label
		onRemove: _propTypes2['default'].func, // method to handle removal of the value
		value: _propTypes2['default'].object.isRequired },

	// the option object for this value
	handleMouseDown: function handleMouseDown(event) {
		if (event.type === 'mousedown' && event.button !== 0) {
			return;
		}
		if (this.props.onClick) {
			event.stopPropagation();
			this.props.onClick(this.props.value, event);
			return;
		}
		if (this.props.value.href) {
			event.stopPropagation();
		}
	},

	onRemove: function onRemove(event) {
		event.preventDefault();
		event.stopPropagation();
		this.props.onRemove(this.props.value);
	},

	handleTouchEndRemove: function handleTouchEndRemove(event) {
		// Check if the view is being dragged, In this case
		// we don't want to fire the click event (because the user only wants to scroll)
		if (this.dragging) return;

		// Fire the mouse events
		this.onRemove(event);
	},

	handleTouchMove: function handleTouchMove(event) {
		// Set a flag that the view is being dragged
		this.dragging = true;
	},

	handleTouchStart: function handleTouchStart(event) {
		// Set a flag that the view is not being dragged
		this.dragging = false;
	},

	renderRemoveIcon: function renderRemoveIcon() {
		if (this.props.disabled || !this.props.onRemove) return;
		return _react2['default'].createElement(
			'span',
			{ className: 'Select-value-icon',
				'aria-hidden': 'true',
				onMouseDown: this.onRemove,
				onTouchEnd: this.handleTouchEndRemove,
				onTouchStart: this.handleTouchStart,
				onTouchMove: this.handleTouchMove },
			'×'
		);
	},

	renderLabel: function renderLabel() {
		var className = 'Select-value-label';
		return this.props.onClick || this.props.value.href ? _react2['default'].createElement(
			'a',
			{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
			this.props.children
		) : _react2['default'].createElement(
			'span',
			{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
			this.props.children
		);
	},

	render: function render() {
		return _react2['default'].createElement(
			'div',
			{ className: (0, _classnames2['default'])('Select-value', this.props.value.className),
				style: this.props.value.style,
				title: this.props.value.title
			},
			this.renderRemoveIcon(),
			this.renderLabel()
		);
	}

});

module.exports = Value;

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _PhoneInput=__webpack_require__(1702);var _PhoneInput2=_interopRequireDefault(_PhoneInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_PhoneInput2.default;module.exports=exports['default'];

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/PhoneInput/PhoneInput.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _aleloLogic=__webpack_require__(12);var _renderInputs=__webpack_require__(44);var _styles=__webpack_require__(1703);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var prefixInput=void 0;var phoneInput=void 0;var prefixOnChange=function prefixOnChange(e){if(e.length>=4){phoneInput.focus();}};var phoneOnChange=function phoneOnChange(e){if(e.length===0){prefixInput.focus();}};var PhoneInput=function PhoneInput(_ref){var errorMessage=_ref.errorMessage,label=_ref.label,name=_ref.name,isRequired=_ref.isRequired,disabled=_ref.disabled;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement(_styles.Column,{__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderPhoneInput,maxlength:'2',type:'tel',name:name+'ddd',ref:function ref(component){prefixInput=component;},onChange:prefixOnChange,label:''+label+(isRequired!==undefined?'*':''),errorMessage:!!errorMessage,placeholder:'XX',disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:27}})),_react2.default.createElement(_styles.Column,{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderPhoneInput,maxlength:'10',type:'tel',name:name,ref:function ref(component){phoneInput=component;},onChange:phoneOnChange,errorMessage:!!errorMessage,placeholder:'XXXXX-XXXX',normalize:_aleloLogic.utils.phoneMask,disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:44}}))),errorMessage&&errorMessage.length>1&&_react2.default.createElement(_styles.BottomMessage,{__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement(_styles.Error,{__source:{fileName:_jsxFileName,lineNumber:63}},errorMessage)));};exports.default=PhoneInput;module.exports=exports['default'];

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BottomMessage=exports.Error=exports.Column=exports.Row=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Row=exports.Row=_styledComponents2.default.div.withConfig({displayName:'styles__Row',componentId:'sc-ceuxgn-0'})(['display:flex;']);var Column=exports.Column=_styledComponents2.default.div.withConfig({displayName:'styles__Column',componentId:'sc-ceuxgn-1'})(['flex:1 1 auto;width:100%;:not(:last-child){flex:0 0 53px;margin-right:27px;width:53px;}']);var bottomAnimate=(0,_styledComponents.keyframes)(['0%{max-height:0;}100%{max-height:',';}'],(0,_rem2.default)('50px'));var Error=exports.Error=_styledComponents2.default.span.withConfig({displayName:'styles__Error',componentId:'sc-ceuxgn-2'})(['color:',';display:inline-block;font-family:OpenSans;font-size:',';letter-spacing:',';'],_colors.red,(0,_rem2.default)('12px'),(0,_rem2.default)('-0.3px'));var BottomMessage=exports.BottomMessage=_styledComponents2.default.div.withConfig({displayName:'styles__BottomMessage',componentId:'sc-ceuxgn-3'})(['animation:0.4s ',' forwards;display:flex;align-items:center;margin-top:',';max-height:0;overflow:hidden;padding-left:',';.animated-loading{margin-right:',';fill:',';}'],bottomAnimate,(0,_rem2.default)('8px'),(0,_rem2.default)('16px'),(0,_rem2.default)('8px'),_colors.grey);

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Checkbox=__webpack_require__(1705);var _Checkbox2=_interopRequireDefault(_Checkbox);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Checkbox2.default;module.exports=exports['default'];

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Checkbox/Checkbox.js';/* eslint-disable */var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _Icon=__webpack_require__(31);var _styles=__webpack_require__(1706);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function Checkbox(props){var label=props.label,negative=props.negative;return _react2.default.createElement(_styles.Label,{disabled:props.disabled,__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_styles.Input,_extends({},props,{name:props.name,type:'checkbox',disabled:props.disabled,negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:14}})),_react2.default.createElement(_styles.Box,{negative:props.negative,__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement(_styles.CheckIcon,{__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement(_Icon.Icon,{width:'11',height:'8',icon:'check',viewBox:'0 0 11 8',__source:{fileName:_jsxFileName,lineNumber:17}}))),label&&_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:20}},label));}Checkbox.defaultProps={label:null};Checkbox.propTypes={label:_propTypes.string};exports.default=Checkbox;module.exports=exports['default'];

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Input=exports.Text=exports.Label=exports.Box=exports.CheckIcon=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var animateCheck=(0,_styledComponents.keyframes)(['0%{transform:translateX(-50%) translateY(-50%) scale(0.6);}40%{transform:translateX(-50%) translateY(-50%) scale(1.3);}70%{transform:translateX(-50%) translateY(-50%) scale(.8);}100%{transform:translateX(-50%) translateY(-50%) scale(1);}']);var CheckIcon=exports.CheckIcon=_styledComponents2.default.i.withConfig({displayName:'styles__CheckIcon',componentId:'sc-1mv4qjy-0'})(['animation:0.4s ',' forwards;color:white;display:none;height:auto;left:50%;position:absolute;top:50%;transform:translateX(-50%) translateY(-50%) scale(1);width:auto;'],animateCheck);var Box=exports.Box=_styledComponents2.default.span.withConfig({displayName:'styles__Box',componentId:'sc-1mv4qjy-1'})(['border:solid ',' ',';border-radius:',';box-shadow:0;display:block;height:',';min-width:',';min-height:',';position:relative;transition:0.3s box-shadow;width:',';:not(:last-child){margin-right:',';}'],(0,_rem2.default)('1px'),function(props){return props.negative?''+_colors.white:''+_colors.lightGrey;},(0,_rem2.default)('4px'),(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('15px'));var Label=exports.Label=_styledComponents2.default.label.withConfig({displayName:'styles__Label',componentId:'sc-1mv4qjy-2'})(['align-items:center;cursor:pointer;display:inline-flex;user-select:none;',';:hover{','{box-shadow:0 0 0 ',' ',' inset;}}'],function(props){return props.disabled&&'\n        opacity: 0.4;\n    ';},Box,(0,_rem2.default)('5px'),_colors.skyBlue);var Text=exports.Text=_styledComponents2.default.span.withConfig({displayName:'styles__Text',componentId:'sc-1mv4qjy-3'})(['color:',';display:inline-block;font-family:OpenSans;font-size:',';font-weight:200;letter-spacing:',';line-height:1.5;'],_colors.darkGrey,(0,_rem2.default)('16px'),(0,_rem2.default)('-0.4px'));var Input=exports.Input=_styledComponents2.default.input.withConfig({displayName:'styles__Input',componentId:'sc-1mv4qjy-4'})(['display:none;:checked + ','{border-color:',';box-shadow:0 0 0 ',' ',' inset;','{display:block;}}'],Box,function(props){return props.negative?''+_colors.white:''+_colors.lightGrey;},(0,_rem2.default)('50px'),_colors.skyBlue,CheckIcon);

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/PasswordInput/PasswordInput.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _colors=__webpack_require__(2);var _Icon=__webpack_require__(31);var _TextInput=__webpack_require__(101);var _TextInput2=_interopRequireDefault(_TextInput);var _StepCounter=__webpack_require__(1708);var _StepCounter2=_interopRequireDefault(_StepCounter);var _styles=__webpack_require__(1711);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PasswordInput=function(_Component){_inherits(PasswordInput,_Component);function PasswordInput(props){_classCallCheck(this,PasswordInput);var _this=_possibleConstructorReturn(this,(PasswordInput.__proto__||Object.getPrototypeOf(PasswordInput)).call(this,props));_this.preventDefault=function(e){e.preventDefault();};_this.togglePassword=function(){_this.setState({showPassword:!_this.state.showPassword});};_this.state={showPassword:false};return _this;}_createClass(PasswordInput,[{key:'render',value:function render(){var showPassword=this.state.showPassword;var _props=this.props,passwordStrength=_props.passwordStrength,passwordMessage=_props.passwordMessage,errorMessage=_props.errorMessage,loading=_props.loading,maxlength=_props.maxlength;var isSecurity=!showPassword;var inputType=isSecurity?'password':'text';return _react2.default.createElement(_styles.Wrapper,{isSecurity:isSecurity,__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_TextInput2.default,_extends({},this.props,{onCopy:this.preventDefault,onCut:this.preventDefault,onPaste:this.preventDefault,type:inputType,maxlength:maxlength,errorMessage:errorMessage||!!passwordStrength&&passwordStrength<8,__source:{fileName:_jsxFileName,lineNumber:41}})),!loading&&_react2.default.createElement(_styles.ShowPassword,{onClick:this.togglePassword,__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_Icon.Icon,{width:'24',height:'24',icon:'eye',viewBox:'0 -20 100 100',color:showPassword?_colors.skyBlue:_colors.grey,__source:{fileName:_jsxFileName,lineNumber:52}}))),(passwordMessage||passwordStrength)&&_react2.default.createElement(_styles.SecurityLevel,{__source:{fileName:_jsxFileName,lineNumber:63}},_react2.default.createElement(_StepCounter2.default,{counter:passwordStrength,message:passwordMessage,__source:{fileName:_jsxFileName,lineNumber:64}})));}}]);return PasswordInput;}(_react.Component);_TextInput2.default.defaultProps={passwordStrength:null,passwordMessage:null};_TextInput2.default.propTypes={passwordStrength:(0,_propTypes.oneOfType)([_propTypes.string,_propTypes.bool]),passwordMessage:(0,_propTypes.oneOfType)([_propTypes.string,_propTypes.bool])};exports.default=PasswordInput;module.exports=exports['default'];

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _StepCounter=__webpack_require__(1709);var _StepCounter2=_interopRequireDefault(_StepCounter);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_StepCounter2.default;module.exports=exports['default'];

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/StepCounter/StepCounter.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _styles=__webpack_require__(1710);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable */var paths=['M13.18,3.81a0.6,0.6,0,0,1-.59.55H11.42a0.6,0.6,0,0,1-.59-0.55L10.58,0.55A0.5,0.5,0,0,1,11,0h1.87a0.5,0.5,0,0,1,.51.55L13.18,3.8h0Z','M18.77,7.41a0.61,0.61,0,0,1-.81,0l-0.83-.82a0.6,0.6,0,0,1,0-.8l2.15-2.47A0.51,0.51,0,0,1,20,3.22l0,0,1.28,1.28a0.5,0.5,0,0,1,0,.71l0,0Z','M20.17,13.08a0.6,0.6,0,0,1-.55-0.59V11.33a0.6,0.6,0,0,1,.55-0.59l3.28-.24A0.5,0.5,0,0,1,24,11v1.8a0.5,0.5,0,0,1-.55.51Z','M17.11,18.07a0.6,0.6,0,0,1,0-.8L18,16.45a0.61,0.61,0,0,1,.81,0l2.49,2.13a0.5,0.5,0,0,1,.07.7l0,0L20,20.58a0.51,0.51,0,0,1-.72,0l0,0-2.15-2.48h0Z','M10.82,20a0.6,0.6,0,0,1,.59-0.55h1.17a0.6,0.6,0,0,1,.59.55l0.24,3.26a0.5,0.5,0,0,1-.46.55H11.09a0.5,0.5,0,0,1-.51-0.55Z','M5.39,16.82a0.61,0.61,0,0,1,.81,0L7,17.67a0.6,0.6,0,0,1,0,.8L4.91,20.95a0.51,0.51,0,0,1-.72.06l0,0L2.87,19.7a0.5,0.5,0,0,1,0-.71l0,0Z','M3.83,10.75a0.6,0.6,0,0,1,.55.59v1.16a0.6,0.6,0,0,1-.55.59l-3.28.24A0.5,0.5,0,0,1,0,12.82V11A0.5,0.5,0,0,1,.55,10.5Z','M7.06,5.35a0.6,0.6,0,0,1,0,.8L6.2,7a0.61,0.61,0,0,1-.81,0L2.9,4.87a0.5,0.5,0,0,1-.07-0.7l0,0L4.16,2.85a0.51,0.51,0,0,1,.75,0Z'];/* eslint-enable */function StepCounter(_ref){var counter=_ref.counter,message=_ref.message;return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:21}},counter&&counter!==0&&_react2.default.createElement('svg',{height:'24',width:'24',className:'animated-loading',xmlns:'http://www.w3.org/2000/svg',__source:{fileName:_jsxFileName,lineNumber:24}},paths.map(function(path,index){return _react2.default.createElement(_styles.Path,{key:path,counter:counter,active:counter>=index,className:'loading-dash',d:path,transform:'translate(0 0)',__source:{fileName:_jsxFileName,lineNumber:31}});})),message&&_react2.default.createElement(_styles.Message,{counter:counter,__source:{fileName:_jsxFileName,lineNumber:42}},message));}StepCounter.defaultProps={counter:null,message:null};StepCounter.propTypes={counter:(0,_propTypes.oneOfType)([_propTypes.number,_propTypes.string]),message:_propTypes.string};exports.default=StepCounter;module.exports=exports['default'];

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Message=exports.Container=exports.Path=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function getFilledColor(counter){var color=_colors.grey;switch(true){case counter>=8:color=_colors.green;break;case counter>=3:color=_colors.yellow;break;case counter>=1:color=_colors.orange;break;default:break;}return color;}var Path=exports.Path=_styledComponents2.default.path.withConfig({displayName:'styles__Path',componentId:'sc-q0soph-0'})(['fill:',';',';'],_colors.grey,function(props){return props.active&&'\n        fill: '+getFilledColor(props.counter)+';\n    ';});var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-q0soph-1'})(['align-items:center;display:flex;']);var Message=exports.Message=_styledComponents2.default.span.withConfig({displayName:'styles__Message',componentId:'sc-q0soph-2'})(['color:',';display:inline-block;font-family:OpenSans;font-size:',';letter-spacing:',';margin-left:',';',' ',';'],_colors.darkBlue,(0,_rem2.default)('12px'),(0,_rem2.default)('-0.5px'),(0,_rem2.default)('12px'),function(props){return props.counter<8&&'\n        color: '+_colors.orange+';\n    ';},function(props){return!props.counter&&props.counter!==0&&'\n        color: '+_colors.orange+';\n        margin-left: 0;\n    ';});

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SecurityLevel=exports.ShowPassword=exports.Wrapper=exports.Content=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _styles=__webpack_require__(185);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-tmv43l-0'})(['position:relative;']);var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-tmv43l-1'})(['position:relative;',';'],function(props){return props.isSecurity&&'\n        input {\n            line-height: '+(0,_rem2.default)('0.83px')+';\n            letter-spacing: '+(0,_rem2.default)('5.5px')+';\n        }\n        input::placeholder {\n            letter-spacing: '+(0,_rem2.default)('-0.6px')+';\n        }\n    ';});var ShowPassword=exports.ShowPassword=_styledComponents2.default.div.withConfig({displayName:'styles__ShowPassword',componentId:'sc-tmv43l-2'})(['cursor:pointer;position:absolute;right:',';bottom:',';z-index:1;'],(0,_rem2.default)('17px'),(0,_rem2.default)('16px'));var SecurityLevel=exports.SecurityLevel=_styles.BottomMessage;

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.createAutoCorrectedDatePipe=t():e.createAutoCorrectedDatePipe=t()}(this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t,r){e.exports=r(1)},function(e,t){"use strict";function r(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"mm dd yyyy";return function(t){var r=[],n=e.split(/[^dmyHMS]+/),o={dd:31,mm:12,yy:99,yyyy:9999,HH:23,MM:59,SS:59},i={dd:1,mm:1,yy:0,yyyy:1,HH:0,MM:0,SS:0},u=t.split("");n.forEach(function(t){var n=e.indexOf(t),i=parseInt(o[t].toString().substr(0,1),10);parseInt(u[n],10)>i&&(u[n+1]=u[n],u[n]=0,r.push(n))});var d=n.some(function(r){var n=e.indexOf(r),u=r.length,d=t.substr(n,u).replace(/\D/g,""),s=parseInt(d,10);return s>o[r]||d.length===u&&s<i[r]});return!d&&{value:u.join(""),indexesOfPipedChars:r}}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r}])});

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _RoundedInput=__webpack_require__(1714);var _RoundedInput2=_interopRequireDefault(_RoundedInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_RoundedInput2.default;module.exports=exports['default'];

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/RoundedInput/RoundedInput.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(1715);var _icSearch=__webpack_require__(600);var _icSearch2=_interopRequireDefault(_icSearch);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RoundedInput=function(_Component){_inherits(RoundedInput,_Component);function RoundedInput(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RoundedInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RoundedInput.__proto__||Object.getPrototypeOf(RoundedInput)).call.apply(_ref,[this].concat(args))),_this),_this.state={focused:false},_this.setFocus=function(){_this.setState({focused:true});},_this.setBlur=function(){_this.setState({focused:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RoundedInput,[{key:'render',value:function render(){var _this2=this;var focused=this.state.focused;return _react2.default.createElement(_styles.Container,{focused:focused,empty:this.props.pristine,__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement(_styles.InputField,_extends({},this.props,{empty:this.props.pristine,placeholder:this.props.placeholder,focused:focused,onFocus:function onFocus(){return _this2.setFocus();},onBlur:function onBlur(){return _this2.setBlur();},__source:{fileName:_jsxFileName,lineNumber:19}})),_react2.default.createElement(_icSearch2.default,_extends({},this.props,{focused:focused,__source:{fileName:_jsxFileName,lineNumber:27}})));}}]);return RoundedInput;}(_react.Component);exports.default=RoundedInput;module.exports=exports['default'];

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.InputField=exports.Container=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-1fj6hik-0'})(['position:relative;svg{position:absolute;right:24px;top:7px;}&:hover path{fill:',';}path{fill:',' !important;}'],_colors.darkGrey,function(_ref){var focused=_ref.focused,empty=_ref.empty;return focused||!empty?_colors.darkBlue:_colors.grey;});var InputField=exports.InputField=_styledComponents2.default.input.withConfig({displayName:'styles__InputField',componentId:'sc-1fj6hik-1'})(['width:100%;height:40px;border-radius:32px;outline:none;border:solid 2px ',';&:hover{border:solid 2px ',';}&::placeholder{color:',';}&::placeholder:hover{color:',';}'],function(_ref2){var empty=_ref2.empty,focused=_ref2.focused;if(!empty)return _colors.darkGrey+' !important';if(focused)return _colors.lightBlue+' !important';return _colors.grey;},_colors.darkGrey,function(_ref3){var focused=_ref3.focused;return focused?_colors.darkBlue:_colors.grey;},_colors.darkGrey);

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.changeUserAvatar=changeUserAvatar;function changeUserAvatar(avatar){return{type:'CHANGE_AVATAR',avatar:avatar};}

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var userFactory={toAPI:function toAPI(data){return data&&{name:data.name,// cpf: data.cpf,
'estado-civil':{codigo:data.maritalStatus},// date_of_birth: data.dob,
// mother_name: data.mothersName,
sexo:{codigo:data.gender},// "lastTimeSaved": new Date().toLocaleString(),
// "avatar": data.avatar //TODO quando existir....
emiteNotaFiscal:data.emiteNotaFiscal,pap:data.pap,documento:data.cpf};},toForm:function toForm(data,contact){return data&&{name:data.nome,cpf:data.cpf,dob:(0,_moment2.default)(data.nascimento).format('DD/MM/YYYY'),mothersName:data['nome-mae'],gender:data.sexo.codigo,maritalStatus:data['estado-civil'].codigo,lastTimeSaved:new Date().toLocaleString(),avatar:data.avatar,emiteNotaFiscal:contact.nome.emiteNotaFiscal,pap:data.pap};}};exports.default=userFactory;module.exports=exports['default'];

/***/ }),
/* 1718 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Editar Dados Pessoais","title":"Dados pessoais","subtitle":"Aqui você pode editar suas informações para deixar a gente sempre atualizado. :)","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","titleModalError":"Oops, problemas ao salvar suas alterações :("}

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditCompanyData/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _aleloLogic=__webpack_require__(12);var _reactRedux=__webpack_require__(7);var _EditCompanyDataForm=__webpack_require__(1720);var _EditCompanyDataForm2=_interopRequireDefault(_EditCompanyDataForm);var _actions=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _formStateActions=__webpack_require__(102);var _factory=__webpack_require__(1722);var _factory2=_interopRequireDefault(_factory);var _styles=__webpack_require__(186);var _data=__webpack_require__(1723);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var fetchUpdateBusinessProfile=_aleloLogic.actions.fetchUpdateBusinessProfile;var EditCompanyData=function EditCompanyData(props){var initialValues=_factory2.default.toForm(props.profile);return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:34}}),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:35}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:36}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:37}},_data.subtitle)),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_EditCompanyDataForm2.default,{initialValues:initialValues,onSubmit:function onSubmit(values){return props.handleSave(_factory2.default.toAPI(values));},__source:{fileName:_jsxFileName,lineNumber:40}})));};var mapStateToProps=function mapStateToProps(state){return{profile:state.reducer.user.profile};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{initFormState:function initFormState(){return dispatch((0,_formStateActions.stopSaving)());},handleSave:function handleSave(profile){dispatch((0,_formStateActions.startSaving)());dispatch(fetchUpdateBusinessProfile(_extends({},profile,{pap:{adesaoPap:!(profile.pap===''||profile.pap===undefined||profile.pap===false),documento:profile.documento}}))).then(function(){dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modalTitle,image:_confirmation2.default}));}).then(function(){return dispatch((0,_formStateActions.stopSaving)());}).catch(function(e){dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,modalDescription:_data.descriptionModalError,image:_contestacao2.default}));dispatch((0,_formStateActions.stopSaving)());console.log('Erro na promise',e);});}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(EditCompanyData);module.exports=exports['default'];

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/EditCompanyDataForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _renderInputs=__webpack_require__(44);var _styles=__webpack_require__(389);var _data=__webpack_require__(1721);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var currencyParser=_aleloLogic.utils.currencyParser;var EditCompanyDataForm=function EditCompanyDataForm(props){var _React$createElement;var handleSubmit=props.handleSubmit,saving=props.saving;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,width:[1,7/12],__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.name,name:'name',type:'text',validate:_aleloLogic.utils.emptyFieldValidate,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:23}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCnpjInput,label:_data.labels.cnpj,name:'cnpj',type:'text',normalize:_aleloLogic.utils.cnpjMask,validate:_aleloLogic.utils.cnpjValidate,disabled:true,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:33}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.companyName,name:'companyName',type:'text',validate:_aleloLogic.utils.emptyFieldValidate,disabled:true,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:45}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:55}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.foc,name:'foc',type:'text',validate:_aleloLogic.utils.emptyFieldValidate,disabled:true,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:56}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:66}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.doc,name:'doc',type:'text',validate:_aleloLogic.utils.dateBeforeTodayValidate,normalize:_aleloLogic.utils.dateMask,disabled:true,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:67}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pl:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:79}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.cnae,name:'cnae',type:'text',normalize:_aleloLogic.utils.numberMask,validate:_aleloLogic.utils.emptyFieldValidate,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:80}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:90}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.registration,name:'registration',type:'text',validate:_aleloLogic.utils.emptyFieldValidate,disabled:true,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:91}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pl:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:101}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.income,name:'income',type:'text',isRequired:true,format:function format(value){return currencyParser(value,'',true);},lockCursor:true,__source:{fileName:_jsxFileName,lineNumber:102}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:112}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCheckboxField,label:_data.labels.pap,name:'pap',disabled:saving,__source:{fileName:_jsxFileName,lineNumber:113}})))),_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:122}},_react2.default.createElement(_Button2.default,(_React$createElement={type:'submit',text:'Salvar',disabled:true},_defineProperty(_React$createElement,'disabled',saving),_defineProperty(_React$createElement,'loading',saving),_defineProperty(_React$createElement,'__source',{fileName:_jsxFileName,lineNumber:123}),_React$createElement))));};var mapStateToProps=function mapStateToProps(state){return{saving:state.reducer.formState.saving};};var form=(0,_reduxForm.reduxForm)({form:'editCompanyData',enableReinitialize:true,destroyOnUnmount:false})(EditCompanyDataForm);exports.default=(0,_reactRedux.connect)(mapStateToProps,undefined)(form);module.exports=exports['default'];

/***/ }),
/* 1721 */
/***/ (function(module, exports) {

module.exports = {"labels":{"name":"Nome Fantasia","cnpj":"CNPJ","companyName":"Razão Social","doc":"Data de Constituição","foc":"Forma de Constituição","cnae":"CNAE Principal","registration":"Inscrição Municipal","income":"Faturamento médio mensal","pap":"Desejo aderir ao Ponto-a-Ponto"},"focList":[{"value":"SA","label":"S/A"},{"value":"LTDA","label":"LTDA"},{"value":"Simples","label":"Simples"},{"value":"Microempresa","label":"Microempresa"},{"value":"MEI","label":"MEI/Autônomo"}],"errorMessages":{"emptyField":"Campo obrigatório"}}

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var companyFactory={toAPI:function toAPI(data){return data&&{nomeFantasia:data.name,cnaePrincipal:data.cnae,faturamentoMedioMensal:String(data.income).replace('.','').replace(',',''),pap:data.pap,documento:data.cnpj};},toForm:function toForm(data){return data&&{name:data.nomeFantasia,cnpj:data.cnpj,companyName:data.razaoSocial,doc:(0,_moment2.default)(data.dataConstituicao).format('DD/MM/YYYY'),foc:data.formaConstituicao,cnae:data.cnaePrincipal,registration:data.inscricaoMunicipal,income:data.faturamentoMedioMensal,avatar:data.avatar,pap:data.pap};}};exports.default=companyFactory;module.exports=exports['default'];

/***/ }),
/* 1723 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Editar Dados institucionais","title":"Dados institucionais","subtitle":"Aqui você pode editar as informações da sua empresa para deixar a gente sempre atualizado. :)","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","titleModalError":"Ops!","descriptionModalError":"Verifique todas as informações e tente novamente."}

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditContactData/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _aleloLogic=__webpack_require__(12);var _EditContactDataForm=__webpack_require__(1725);var _EditContactDataForm2=_interopRequireDefault(_EditContactDataForm);var _actions=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _formStateActions=__webpack_require__(102);var _factory=__webpack_require__(1728);var _factory2=_interopRequireDefault(_factory);var _styles=__webpack_require__(186);var _data=__webpack_require__(1729);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var fetchUpdateContact=_aleloLogic.actions.fetchUpdateContact;var EditContactData=function EditContactData(_ref){var contacts=_ref.contacts,handleSave=_ref.handleSave;var initialValues=_factory2.default.toForm(contacts);return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:30}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:31}}),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:33}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:34}},_data.subtitle),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:35}},_react2.default.createElement(_EditContactDataForm2.default,{initialValues:initialValues,onSubmit:function onSubmit(values){return handleSave(_factory2.default.toAPI(values));},__source:{fileName:_jsxFileName,lineNumber:36}}))));};var mapStateToProps=function mapStateToProps(state){return{contacts:state.reducer.user.contato,saving:state.reducer.formState.saving};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{initFormState:function initFormState(){return dispatch((0,_formStateActions.stopSaving)());},handleSave:function handleSave(contacts){dispatch((0,_formStateActions.startSaving)());dispatch(fetchUpdateContact(contacts)).then(function(){return dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modalTitle,image:_confirmation2.default}));}).then(function(){return dispatch((0,_formStateActions.stopSaving)());}).catch(function(e){dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modaTitleError,modalDescription:_data.modaTextError,image:_confirmation2.default}));dispatch((0,_formStateActions.stopSaving)());});}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(EditContactData);module.exports=exports['default'];

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/EditContactDataForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _renderInputs=__webpack_require__(44);var _validateContact=__webpack_require__(1726);var _data=__webpack_require__(1727);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var EditContactData=function EditContactData(props){var handleSubmit=props.handleSubmit,saving=props.saving;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,width:[1,7/12],__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.email,name:'email',type:'email',isRequired:true,disabled:saving,__source:{fileName:_jsxFileName,lineNumber:23}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTelephoneField,label:_data.labels.phone,name:'phone',type:'text',disabled:saving,__source:{fileName:_jsxFileName,lineNumber:33}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pl:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTelephoneField,label:_data.labels.mobile,name:'mobile',type:'text',isRequired:true,disabled:saving,__source:{fileName:_jsxFileName,lineNumber:42}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCheckboxField,label:_data.labels.checkbox,name:'checkbox',disabled:saving,__source:{fileName:_jsxFileName,lineNumber:52}}))),_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_Button2.default,{type:'submit',text:_data.labels.submit,disabled:saving,__source:{fileName:_jsxFileName,lineNumber:61}})));};var mapStateToProps=function mapStateToProps(state){return{saving:state.reducer.formState.saving};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{};};var form=(0,_reduxForm.reduxForm)({form:'editContactData',validate:_validateContact.validate,destroyOnUnmount:false})(EditContactData);exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(form);module.exports=exports['default'];

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.validate=undefined;var _aleloLogic=__webpack_require__(12);var _dictionary=__webpack_require__(252);var emailValidate=_aleloLogic.utils.emailValidate,dddValidate=_aleloLogic.utils.dddValidate,phoneValidate=_aleloLogic.utils.phoneValidate;var required=_dictionary.errorMessage.required,emailFormat=_dictionary.errorMessage.emailFormat;var validate=exports.validate=function validate(values){var errors={};if(!values.email){errors.email=required;}else if(values.email&&emailValidate(values.email)){errors.email=emailFormat;}if(values.phoneddd&&!values.phone){errors.phone='Campo obrigarório (preencher número)';}else if(!values.phoneddd&&values.phone){errors.phone='Campo obrigarório (preencher DDD)';}if(values.phoneddd&&dddValidate(values.phoneddd)){errors.phone=dddValidate(values.phoneddd);}if(values.phone&&phoneValidate(values.phone)){errors.phone=phoneValidate(values.phone);}if(!values.mobileddd||!values.mobile){errors.mobile=required;}else{if(values.mobileddd&&dddValidate(values.mobileddd)){errors.mobile=dddValidate(values.mobileddd);}if(values.mobile&&phoneValidate(values.mobile)){errors.mobile=phoneValidate(values.mobile);}}return errors;};

/***/ }),
/* 1727 */
/***/ (function(module, exports) {

module.exports = {"labels":{"email":"E-mail principal","phone":"Telefone","mobile":"Celular","checkbox":"Desejo receber promoções e novidades Veloe.","submit":"Salvar"}}

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var contactFactory={toAPI:function toAPI(data){return data&&{email:{enderecoEletronico:data.email,newsletter:data.optInPromotions},telefone:{ddd:data.phoneddd,numero:data.phone,tipoTelefone:'Telefone Residencial'},celular:{ddd:data.mobileddd,numero:data.mobile,tipoTelefone:'Celular'}};},toForm:function toForm(data){return data&&{mobileddd:data.celular&&data.celular.ddd,mobile:data.celular&&data.celular.numero,phoneddd:data.telefone&&data.telefone.ddd,phone:data.telefone&&data.telefone.numero,email:data.email&&data.email.enderecoEletronico,checkbox:data.email&&data.email.newsletter};}};exports.default=contactFactory;module.exports=exports['default'];

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Contatos","title":"Contatos","subtitle":"Deixe seus contatos atualizados. Mas fique tranquilo: não vamos mandar corrente nem ligar o tempo todo. :)","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","modaTitleError":"Foi Mal!","modaTextError":"Notamos que existe uma inconsistência nos dados de cadastro que você nos passou.  Por Favor, verifique e tente novamente."}

/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditAddress/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _aleloLogic=__webpack_require__(12);var _actions=__webpack_require__(18);var _EditAddressForm=__webpack_require__(391);var _EditAddressForm2=_interopRequireDefault(_EditAddressForm);var _ModalTypes=__webpack_require__(20);var _formStateActions=__webpack_require__(102);var _factory=__webpack_require__(1737);var _factory2=_interopRequireDefault(_factory);var _styles=__webpack_require__(601);var _data=__webpack_require__(1738);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fetchUpdateAddress=_aleloLogic.actions.fetchUpdateAddress,fetchDeleteAddress=_aleloLogic.actions.fetchDeleteAddress;var EditAddress=function(_PureComponent){_inherits(EditAddress,_PureComponent);function EditAddress(){_classCallCheck(this,EditAddress);return _possibleConstructorReturn(this,(EditAddress.__proto__||Object.getPrototypeOf(EditAddress)).apply(this,arguments));}_createClass(EditAddress,[{key:'render',value:function render(){var _props=this.props,address=_props.address,handleSave=_props.handleSave,handleDelete=_props.handleDelete,saving=_props.saving,match=_props.match;var initialValues=_factory2.default.toForm(address);return _react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:33}}),_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:34}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:35}},_data.subtitle),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:36}},_react2.default.createElement(_EditAddressForm2.default,{initialValues:{address:initialValues},onSubmit:function onSubmit(values){return handleSave(_factory2.default.toAPI(values.address));},onDelete:handleDelete,length:address?address.length:0,saving:saving,match:match,__source:{fileName:_jsxFileName,lineNumber:37}}),_react2.default.createElement(_styles.LastSavedLabel,{__source:{fileName:_jsxFileName,lineNumber:45}},_data.lastSaved)));}}]);return EditAddress;}(_react.PureComponent);var mapStateToProps=function mapStateToProps(state){return{address:state.reducer.user.enderecos,saving:state.reducer.formState.saving};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{handleSave:function handleSave(address){dispatch((0,_formStateActions.startSaving)());dispatch(fetchUpdateAddress(address)).then(function(){dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modalUpdateTitle,image:_confirmation2.default}));dispatch((0,_formStateActions.stopSaving)());}).catch(function(e){console.log('Erro ao atualizar o endereço',e);dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:'Ops! Falha ao atualizar o endereço.',image:_confirmation2.default}));dispatch((0,_formStateActions.stopSaving)());});},handleDelete:function handleDelete(id,isCorrespondence){return dispatch(fetchDeleteAddress(id)).then(function(){return dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,isCorrespondence?{modalTitle:_data.modalDeleteTitle,image:_confirmation2.default}:{modalTitle:_data.modalUpdateTitle,image:_confirmation2.default}));}).catch(function(e){console.log('Erro ao excluir o endereço',e);dispatch((0,_formStateActions.stopSaving)());});}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(EditAddress);module.exports=exports['default'];

/***/ }),
/* 1731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/AddressFormSection/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(1732);var _data=__webpack_require__(1733);var _renderInputs=__webpack_require__(44);var _parseCombo=__webpack_require__(392);var _actions=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fetchZipCode=_aleloLogic.actions.fetchZipCode;var getStates=_aleloLogic.services.getStates,getCitiesFromState=_aleloLogic.services.getCitiesFromState;var AddressFormSection=function(_Component){_inherits(AddressFormSection,_Component);function AddressFormSection(props){_classCallCheck(this,AddressFormSection);var _this=_possibleConstructorReturn(this,(AddressFormSection.__proto__||Object.getPrototypeOf(AddressFormSection)).call(this,props));_initialiseProps.call(_this);_this.state={states:[],formStatus:_this.createAllIntialFormStatus(props)};return _this;}_createClass(AddressFormSection,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:228}},this.props.fields&&this.props.fields.map(function(field,index){var formStatus=_this2.state.formStatus[index]||{};// primeira chamada initialValues está undefined
var disabled=formStatus.isNew&&formStatus.lastSearch===''||formStatus.isSearchingCep||_this2.props.saving;return _react2.default.createElement('div',{key:field,__source:{fileName:_jsxFileName,lineNumber:238}},index===1&&_react2.default.createElement(_styles.SecondaryHeading,{__source:{fileName:_jsxFileName,lineNumber:240}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:241}},_data.secondaryAddressTitle),_react2.default.createElement(_styles.ExcludeLinkContainer,{__source:{fileName:_jsxFileName,lineNumber:242}},_react2.default.createElement(_Icon2.default,{icon:'exclude',svgStyle:'height: 6px; width: 6px',viewBox:'0 0 8 8',__source:{fileName:_jsxFileName,lineNumber:243}}),_react2.default.createElement(_styles.ExcludeLink,{onClick:function onClick(){return _this2.removeAddress(index);},__source:{fileName:_jsxFileName,lineNumber:244}},_data.excludeLink))),_react2.default.createElement(_gridStyled.Flex,{wrap:true,width:[1,7/12],mb:[0,16],key:field,__source:{fileName:_jsxFileName,lineNumber:250}},_react2.default.createElement(_gridStyled.Box,{width:2/3,mb:3,__source:{fileName:_jsxFileName,lineNumber:251}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderZipCodeInput,label:_data.labels.zipCode,validate:_aleloLogic.utils.cepValidate,normalize:_aleloLogic.utils.cepMask,onBlur:_this2.autoCompleteAddress(index),name:field+'.zipCode',type:'text',isRequired:true,disabled:formStatus.isSearchingCep||_this2.props.saving,loading:formStatus.isSearchingCep,__source:{fileName:_jsxFileName,lineNumber:252}})),_react2.default.createElement(_gridStyled.Box,{width:[1,2/3],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:265}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.address,validate:_aleloLogic.utils.emptyFieldValidate,name:field+'.address',type:'text',isRequired:true,disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:266}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/3],pl:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:276}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.number,validate:_aleloLogic.utils.emptyFieldValidate,normalize:_aleloLogic.utils.numberMask,name:field+'.number',type:'text',isRequired:true,disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:277}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:288}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.additionalInfo,name:field+'.additionalInfo',type:'text',disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:289}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:297}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.neighborhood,validate:_aleloLogic.utils.emptyFieldValidate,name:field+'.neighborhood',type:'text',isRequired:true,disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:298}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/5],mb:3,__source:{fileName:_jsxFileName,lineNumber:308}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderSelectField,label:_data.labels.state,name:field+'.state',options:_this2.state.states,placeholder:_data.labels.select,isRequired:true,disabled:true,__source:{fileName:_jsxFileName,lineNumber:309}})),_react2.default.createElement(_gridStyled.Box,{width:[1,4/5],pl:[0,3],mb:3,__source:{fileName:_jsxFileName,lineNumber:319}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderSelectField,label:_data.labels.city,placeholder:_data.labels.select,validate:_aleloLogic.utils.emptyFieldValidate,name:field+'.city',options:formStatus.cities||[],isRequired:true,disabled:true,__source:{fileName:_jsxFileName,lineNumber:320}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:331}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCheckboxField,label:_data.labels.correspondence,name:field+'.mail',normalize:_this2.checkboxNormalize(index),disabled:_this2.props.fields.length===1,__source:{fileName:_jsxFileName,lineNumber:332}}))));}),_react2.default.createElement(_styles.ButtonContainer,{amount:this.props.fields.length<=1?'singular':'plural',__source:{fileName:_jsxFileName,lineNumber:344}},_react2.default.createElement(_Button2.default,{text:'Salvar',type:'submit',disabled:this.props.saving,__source:{fileName:_jsxFileName,lineNumber:345}})),this.props.fields.length<=1?_react2.default.createElement(_Button2.default,{text:'Adicionar endere\xE7o',buttonType:'white',onClick:this.addAddress,__source:{fileName:_jsxFileName,lineNumber:348}}):null);}}]);return AddressFormSection;}(_react.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.componentDidMount=function(){_this3.retrieveStates();if(!_this3.localControl.isCitiesInit){_this3.fetchCitiesForEachForm(_this3.props);}};this.componentWillReceiveProps=function(props,param2){if(!_this3.localControl.isCitiesInit){_this3.fetchCitiesForEachForm(props);}if(!_this3.localControl.isFormStatusInit){var allStatus=_this3.createAllIntialFormStatus(props);if(allStatus.length>0){_this3.setState({formStatus:allStatus});}}};this.localControl={isFormStatusInit:false,isCitiesInit:false};this.createAllIntialFormStatus=function(props){var allFormStatus=[];for(var i=0;i<props.fields.length;i+=1){var status=_this3.createEmptyFormStatus(false);status.lastSearch=props.fields.get(i).zipCode;allFormStatus.push(status);}_this3.localControl.isFormStatusInit=props.fields.length>0;return allFormStatus;};this.fetchCitiesForEachForm=function(props){var _loop=function _loop(i){_this3.updateFormStatus(i,{isSearchingCep:true});getCitiesFromState({state:props.fields.get(i).state}).then(function(){var address=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cities=(0,_parseCombo.parseCities)(address);_this3.updateFormStatus(i,{isSearchingCep:false,cities:cities});});};for(var i=0;i<props.fields.length;i+=1){_loop(i);}_this3.localControl.isCitiesInit=props.fields.length>0;};this.createEmptyFormStatus=function(isNew){return{lastSearch:'',isSearchingCep:false,isNew:isNew,cities:[]};};this.checkboxNormalize=function(index){return function(value){var newValue=!!value;var target=index===0?1:0;_this3.props.fields.get(target).mail=!newValue;return newValue;};};this.resetPage=function(index){var fieldValues=_this3.props.fields.get(index);var fielsToPopulate={address:'',number:'',additionalInfo:'',neighborhood:'',state:'',city:'',zipCode:''};_this3.props.fields.remove(index);_this3.props.fields.insert(index,_extends({},fieldValues,fielsToPopulate));};this.autoCompleteAddress=function(index){return function(event,oldValue,newValue){var formStatus=_this3.state.formStatus[index];if(newValue&&newValue.length>=9&&newValue!==formStatus.lastSearch){_this3.updateFormStatus(index,{isSearchingCep:true});var fieldValues=_this3.props.fields.get(index);var data={zip_code:newValue};_this3.props.getAddressFromZipCode(data).then(function(){var address=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fielsToPopulate={address:address.logradouro,number:'',additionalInfo:'',neighborhood:address.bairro,state:address.uf,city:address.cidade};_this3.props.fields.remove(index);_this3.props.fields.insert(index,_extends({},fieldValues,fielsToPopulate));_this3.updateFormStatus(index,{lastSearch:newValue});_this3.retrieveCities(index,address.uf);}).catch(function(e){console.log('Erro ao consultar CEP',e);_this3.resetPage(index);_this3.updateFormStatus(index,{isSearchingCep:false});_this3.props.showErrorModal();});}};};this.retrieveStates=function(){getStates().then(function(address){var states=(0,_parseCombo.parseStates)(address);_this3.setState({states:states});});};this.retrieveCities=function(index,state){// this.props.getCitiesFromState({ state: state })
getCitiesFromState({state:state}).then(function(){var address=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cities=(0,_parseCombo.parseCities)(address);_this3.updateFormStatus(index,{isSearchingCep:false,cities:cities});});};this.changeComboStates=function(index){return function(event,oldValue,newValue){console.log(index,event,oldValue,newValue);_this3.retrieveCities(index,newValue);};};this.removeAddress=function(index){var isCorrespondence=_this3.props.fields.get(index).mail;var key=_this3.props.fields.get(index).key;_this3.props.onDelete(key,isCorrespondence).then(function(){_this3.props.fields.pop();_this3.props.fields.get(0).mail=true;_this3.state.formStatus.pop();});};this.addAddress=function(){var allFormStatus=_this3.state.formStatus;allFormStatus.push(_this3.createEmptyFormStatus(true));_this3.setState({formStatus:allFormStatus});_this3.props.fields.push({mail:false});};this.updateFormStatus=function(index,newData){var allFormStatus=_this3.state.formStatus;var oldData=allFormStatus[index];allFormStatus[index]=_extends({},oldData,newData);_this3.setState({formStatus:allFormStatus});};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAddressFromZipCode:function getAddressFromZipCode(zipCode){return dispatch(fetchZipCode(zipCode));},showErrorModal:function showErrorModal(){return dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,modalDescription:_data.descriptionModalError,image:_contestacao2.default}));}// getCitiesFromState: state => dispatch(fetchCitiesFromState(state)),
// getStates: state => dispatch(fetchStates())
};};exports.default=(0,_reactRedux.connect)(null,mapDispatchToProps)(AddressFormSection);

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonContainer=exports.ExcludeLinkContainer=exports.SecondaryHeading=exports.ExcludeLink=exports.Heading=undefined;var _templateObject=_taggedTemplateLiteral(['\n        width: 100%\n    '],['\n        width: 100%\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-r4od98-0'})(['',' color:',';'],_types.title24Galano,_colors.darkBlue);var ExcludeLink=exports.ExcludeLink=_styledComponents2.default.a.withConfig({displayName:'styles__ExcludeLink',componentId:'sc-r4od98-1'})(['color:',';cursor:pointer;font-family:OpenSans;font-size:',';margin-left:',';'],_colors.darkGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('9px'));var SecondaryHeading=exports.SecondaryHeading=_styledComponents2.default.div.withConfig({displayName:'styles__SecondaryHeading',componentId:'sc-r4od98-2'})(['align-items:center;display:flex;justify-content:space-between;padding-top:',';border-top:1px solid rgba(197,195,216,0.5);'],(0,_rem2.default)('32px'));var ExcludeLinkContainer=exports.ExcludeLinkContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ExcludeLinkContainer',componentId:'sc-r4od98-3'})(['align-items:center;display:flex;']);var ButtonContainer=exports.ButtonContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonContainer',componentId:'sc-r4od98-4'})(['',' ',';'],function(props){return props.amount==='singular'&&'\n        float: left;\n        margin-right: '+(0,_rem2.default)('20px')+';\n    ';},_media2.default.small(_templateObject));

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

module.exports = {"cities":[],"states":[{"value":"RJ","label":"RJ"},{"value":"SP","label":"SP"},{"value":"MG","label":"MG"},{"value":"SC","label":"SC"},{"value":"RS","label":"RS"}],"labels":{"zipCode":"Cep*","address":"Endereço","number":"Número","additionalInfo":"Complemento","neighborhood":"Bairro","state":"Estado","city":"Cidade","correspondence":"Esse é o endereço para envio de correspondência ","select":" "},"errorMessages":{"emptyField":"Campo obrigatório"},"secondaryAddressTitle":"Endereço secundário","excludeLink":"Excluir","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","titleModalError":"Ops!","descriptionModalError":"CEP informado inválido. Confira as informações e tente novamente."}

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/AddressFormShippingSection/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(1735);var _data=__webpack_require__(1736);var _renderInputs=__webpack_require__(44);var _parseCombo=__webpack_require__(392);var _actions=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fetchZipCode=_aleloLogic.actions.fetchZipCode;var getStates=_aleloLogic.services.getStates,getCitiesFromState=_aleloLogic.services.getCitiesFromState;var AddressFormSection=function(_Component){_inherits(AddressFormSection,_Component);function AddressFormSection(props){_classCallCheck(this,AddressFormSection);var _this=_possibleConstructorReturn(this,(AddressFormSection.__proto__||Object.getPrototypeOf(AddressFormSection)).call(this,props));_initialiseProps.call(_this);_this.state={states:[],formStatus:_this.createAllIntialFormStatus(props)};return _this;}_createClass(AddressFormSection,[{key:'render',value:function render(){var _this2=this;var shippingAmount=this.props.shippingAmount;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:224}},this.props.fields&&this.props.fields.map(function(field,index){var formStatus=_this2.state.formStatus[index]||{};// primeira chamada initialValues está undefined
var disabled=formStatus.isNew&&formStatus.lastSearch===''||formStatus.isSearchingCep||_this2.props.saving;return _react2.default.createElement('div',{key:field,__source:{fileName:_jsxFileName,lineNumber:234}},index===1&&_react2.default.createElement(_styles.SecondaryHeading,{__source:{fileName:_jsxFileName,lineNumber:236}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:237}},_data.secondaryAddressTitle),_react2.default.createElement(_styles.ExcludeLinkContainer,{__source:{fileName:_jsxFileName,lineNumber:238}},_react2.default.createElement(_Icon2.default,{icon:'exclude',svgStyle:'height: 6px; width: 6px',viewBox:'0 0 8 8',__source:{fileName:_jsxFileName,lineNumber:239}}),_react2.default.createElement(_styles.ExcludeLink,{onClick:function onClick(){return _this2.removeAddress(index);},__source:{fileName:_jsxFileName,lineNumber:240}},_data.excludeLink))),_react2.default.createElement(_gridStyled.Flex,{wrap:true,width:[1,7/12],mb:[0,16],key:field,__source:{fileName:_jsxFileName,lineNumber:246}},_react2.default.createElement(_gridStyled.Box,{width:2/3,mb:3,__source:{fileName:_jsxFileName,lineNumber:247}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderZipCodeInput,label:_data.labels.zipCode,validate:_aleloLogic.utils.cepValidate,normalize:_aleloLogic.utils.cepMask,onBlur:_this2.autoCompleteAddress(index),name:field+'.zipCode',type:'text',isRequired:true,disabled:formStatus.isSearchingCep||_this2.props.saving,loading:formStatus.isSearchingCep,__source:{fileName:_jsxFileName,lineNumber:248}})),_react2.default.createElement(_gridStyled.Box,{width:[1,2/3],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:261}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.address,validate:_aleloLogic.utils.emptyFieldValidate,name:field+'.address',type:'text',isRequired:true,disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:262}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/3],pl:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:272}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.number,validate:_aleloLogic.utils.emptyFieldValidate,normalize:_aleloLogic.utils.numberMask,name:field+'.number',type:'text',isRequired:true,disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:273}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:284}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.additionalInfo,name:field+'.additionalInfo',type:'text',disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:285}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:293}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.neighborhood,validate:_aleloLogic.utils.emptyFieldValidate,name:field+'.neighborhood',type:'text',isRequired:true,disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:294}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/5],mb:3,__source:{fileName:_jsxFileName,lineNumber:304}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderSelectField,label:_data.labels.state,name:field+'.state',options:_this2.state.states,isRequired:true,disabled:true,__source:{fileName:_jsxFileName,lineNumber:305}})),_react2.default.createElement(_gridStyled.Box,{width:[1,4/5],pl:[0,3],mb:3,__source:{fileName:_jsxFileName,lineNumber:314}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderSelectField,label:_data.labels.city,validate:_aleloLogic.utils.emptyFieldValidate,name:field+'.city',options:formStatus.cities||[],isRequired:true,disabled:true,__source:{fileName:_jsxFileName,lineNumber:315}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:325}},_react2.default.createElement(_styles.ShippingText,{__source:{fileName:_jsxFileName,lineNumber:326}},'Frete'),_react2.default.createElement(_styles.ShippingAmount,{__source:{fileName:_jsxFileName,lineNumber:327}},'R$ ',shippingAmount||'0,00'))),_react2.default.createElement(_styles.ButtonContainer,{__source:{fileName:_jsxFileName,lineNumber:330}},_react2.default.createElement(_Button2.default,{text:'Reenviar Identificador',type:'submit',disabled:_this2.props.saving,__source:{fileName:_jsxFileName,lineNumber:331}})));}));}}]);return AddressFormSection;}(_react.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.componentDidMount=function(){_this3.retrieveStates();if(!_this3.localControl.isCitiesInit){_this3.fetchCitiesForEachForm(_this3.props);}_this3.addAddress();};this.componentWillReceiveProps=function(props,param2){if(!_this3.localControl.isCitiesInit){_this3.fetchCitiesForEachForm(props);}if(!_this3.localControl.isFormStatusInit){var allStatus=_this3.createAllIntialFormStatus(props);if(allStatus.length>0){_this3.setState({formStatus:allStatus});}}};this.localControl={isFormStatusInit:false,isCitiesInit:false};this.createAllIntialFormStatus=function(props){var allFormStatus=[];for(var i=0;i<props.fields.length;i+=1){var status=_this3.createEmptyFormStatus(false);status.lastSearch=props.fields.get(i).zipCode;allFormStatus.push(status);}_this3.localControl.isFormStatusInit=props.fields.length>0;return allFormStatus;};this.fetchCitiesForEachForm=function(props){var _loop=function _loop(i){_this3.updateFormStatus(i,{isSearchingCep:true});getCitiesFromState({state:props.fields.get(i).state}).then(function(){var address=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cities=(0,_parseCombo.parseCities)(address);_this3.updateFormStatus(i,{isSearchingCep:false,cities:cities});});};for(var i=0;i<props.fields.length;i+=1){_loop(i);}_this3.localControl.isCitiesInit=props.fields.length>0;};this.createEmptyFormStatus=function(isNew){return{lastSearch:'',isSearchingCep:false,isNew:isNew,cities:[]};};this.checkboxNormalize=function(index){return function(value){var newValue=!!value;var target=index===0?1:0;_this3.props.fields.get(target).mail=!newValue;return newValue;};};this.resetPage=function(index){var fieldValues=_this3.props.fields.get(index);var fielsToPopulate={address:'',number:'',additionalInfo:'',neighborhood:'',state:'',city:'',zipCode:''};_this3.props.fields.remove(index);_this3.props.fields.insert(index,_extends({},fieldValues,fielsToPopulate));};this.autoCompleteAddress=function(index){return function(event,oldValue,newValue){var formStatus=_this3.state.formStatus[index];if(newValue&&newValue.length>=9&&newValue!==formStatus.lastSearch){_this3.updateFormStatus(index,{isSearchingCep:true});var fieldValues=_this3.props.fields.get(index);var data={zip_code:newValue};_this3.props.getAddressFromZipCode(data).then(function(){var address=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fielsToPopulate={address:address.logradouro,number:'',additionalInfo:'',neighborhood:address.bairro,state:address.uf,city:address.cidade};_this3.props.fields.remove(index);_this3.props.fields.insert(index,_extends({},fieldValues,fielsToPopulate));_this3.updateFormStatus(index,{lastSearch:newValue});_this3.retrieveCities(index,address.uf);}).catch(function(e){console.log('Erro ao consultar CEP',e);_this3.resetPage(index);_this3.updateFormStatus(index,{isSearchingCep:false});_this3.props.showErrorModal();});}};};this.retrieveStates=function(){getStates().then(function(address){var states=(0,_parseCombo.parseStates)(address);_this3.setState({states:states});});};this.retrieveCities=function(index,state){getCitiesFromState({state:state}).then(function(){var address=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cities=(0,_parseCombo.parseCities)(address);_this3.updateFormStatus(index,{isSearchingCep:false,cities:cities});});};this.changeComboStates=function(index){return function(event,oldValue,newValue){_this3.retrieveCities(index,newValue);};};this.removeAddress=function(index){var isCorrespondence=_this3.props.fields.get(index).mail;var key=_this3.props.fields.get(index).key;_this3.props.onDelete(key,isCorrespondence).then(function(){_this3.props.fields.pop();_this3.props.fields.get(0).mail=true;_this3.state.formStatus.pop();});};this.addAddress=function(){var allFormStatus=_this3.state.formStatus;allFormStatus.push(_this3.createEmptyFormStatus(true));_this3.setState({formStatus:allFormStatus});_this3.props.fields.push({mail:false});};this.updateFormStatus=function(index,newData){var allFormStatus=_this3.state.formStatus;var oldData=allFormStatus[index];allFormStatus[index]=_extends({},oldData,newData);_this3.setState({formStatus:allFormStatus});};};var mapStateToProps=exports.mapStateToProps=function mapStateToProps(state){return{shippingAmount:state.reducer.shippingAmount};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAddressFromZipCode:function getAddressFromZipCode(zipCode){return dispatch(fetchZipCode(zipCode));},showErrorModal:function showErrorModal(){return dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,modalDescription:_data.descriptionModalError,image:_contestacao2.default}));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(AddressFormSection);

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonContainer=exports.ShippingAmount=exports.ShippingText=exports.ExcludeLinkContainer=exports.SecondaryHeading=exports.ExcludeLink=exports.Heading=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-85n1uk-0'})(['',' color:',';'],_types.title24Galano,_colors.darkBlue);var ExcludeLink=exports.ExcludeLink=_styledComponents2.default.a.withConfig({displayName:'styles__ExcludeLink',componentId:'sc-85n1uk-1'})(['color:',';cursor:pointer;font-family:OpenSans;font-size:',';margin-left:',';'],_colors.darkGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('9px'));var SecondaryHeading=exports.SecondaryHeading=_styledComponents2.default.div.withConfig({displayName:'styles__SecondaryHeading',componentId:'sc-85n1uk-2'})(['align-items:center;display:flex;justify-content:space-between;padding-top:',';border-top:1px solid rgba(197,195,216,0.5);'],(0,_rem2.default)('32px'));var ExcludeLinkContainer=exports.ExcludeLinkContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ExcludeLinkContainer',componentId:'sc-85n1uk-3'})(['align-items:center;display:flex;']);var ShippingText=exports.ShippingText=_styledComponents2.default.span.withConfig({displayName:'styles__ShippingText',componentId:'sc-85n1uk-4'})(['',';font-weight:bold;line-height:1.67;letter-spacing:1.6px;color:',';text-transform:uppercase;'],_types.txt12OpenSans,_colors.blueGray);var ShippingAmount=exports.ShippingAmount=_styledComponents2.default.p.withConfig({displayName:'styles__ShippingAmount',componentId:'sc-85n1uk-5'})(['',';font-weight:bold;line-height:1.5;letter-spacing:normal;color:',';margin:5px 0;'],_types.txt16OpenSans,_colors.darkBlue);var ButtonContainer=exports.ButtonContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonContainer',componentId:'sc-85n1uk-6'})(['margin:-20px 0 20px;']);

/***/ }),
/* 1736 */
/***/ (function(module, exports) {

module.exports = {"cities":[],"states":[{"value":"RJ","label":"RJ"},{"value":"SP","label":"SP"},{"value":"MG","label":"MG"},{"value":"SC","label":"SC"},{"value":"RS","label":"RS"}],"labels":{"zipCode":"Cep*","address":"Endereço","number":"Número","additionalInfo":"Complemento","neighborhood":"Bairro","state":"Estado","city":"Cidade","correspondence":"Esse é o endereço para envio de correspondência"},"errorMessages":{"emptyField":"Campo obrigatório"},"secondaryAddressTitle":"Endereço secundário","excludeLink":"Excluir","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","titleModalError":"Ops!","descriptionModalError":"CEP informado inválido. Confira as informações e tente novamente."}

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var addressFactory={toAPI:function toAPI(address){return address&&address.map(function(data,index){return{cep:data.zipCode,logradouro:data.address,numero:data.number,complemento:data.additionalInfo,bairro:data.neighborhood,uf:data.state,cidade:data.city,correspondencia:data.mail,principal:data.principal,codigo:data.key};});},toForm:function toForm(address){return address&&address.map(function(data,index){return address&&{zipCode:data.cep,address:data.logradouro,number:data.numero,additionalInfo:data.complemento,neighborhood:data.bairro,state:data.uf,city:data.cidade,mail:data.correspondencia,principal:data.principal,key:data.codigo};});}};exports.default=addressFactory;module.exports=exports["default"];

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Editar Endereços","title":"Endereço principal","subtitle":"Mantenha seu endereço atualizado para sua correspondência sempre chegar direitinho.","lastSaved":"Salvo em 10/10/2017 às 19:30","modalUpdateTitle":"Pronto! A gente já salvou suas alterações. ;)","modalDeleteTitle":"Pronto! Agora, sua correspondência vai para o endereço principal."}

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditCompanyAddress/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _aleloLogic=__webpack_require__(12);var _actions=__webpack_require__(18);var _EditAddressForm=__webpack_require__(391);var _EditAddressForm2=_interopRequireDefault(_EditAddressForm);var _ModalTypes=__webpack_require__(20);var _formStateActions=__webpack_require__(102);var _factory=__webpack_require__(1740);var _factory2=_interopRequireDefault(_factory);var _styles=__webpack_require__(601);var _data=__webpack_require__(1741);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fetchUpdateBusinessAddress=_aleloLogic.actions.fetchUpdateBusinessAddress,fetchDeleteBusinessAddress=_aleloLogic.actions.fetchDeleteBusinessAddress;var key=0;var EditAddress=function(_Component){_inherits(EditAddress,_Component);function EditAddress(props){_classCallCheck(this,EditAddress);var _this=_possibleConstructorReturn(this,(EditAddress.__proto__||Object.getPrototypeOf(EditAddress)).call(this,props));_this.removeAddress=function(){_this.props.address.splice(0,1);_this.props.address[0].mail=true;_this.setState({address:_this.props.address});};_this.saveForm=function(){_this.props.handleSave(_this.props.address);};_this.addAddress=function(){key+=1;_this.props.address.push({zipCode:'',address:'',number:'',additionalInfo:'',neighborhood:'',state:'',city:'',key:key,mail:true});_this.setState({address:_this.props.address});};_this.state={address:props.address};return _this;}_createClass(EditAddress,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.address){return false;}}},{key:'render',value:function render(){var _props=this.props,address=_props.address,handleSave=_props.handleSave,handleDelete=_props.handleDelete,saving=_props.saving;var initialValues=_factory2.default.toForm(address);return _react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:80}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:81}}),_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:82}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:83}},_data.subtitle),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:84}},_react2.default.createElement(_EditAddressForm2.default,{initialValues:{address:initialValues},saveForm:this.saveForm,removeAddress:this.removeAddress,addAddress:this.addAddress,onSubmit:function onSubmit(values){return handleSave(_factory2.default.toAPI(values.address));},onDelete:handleDelete,length:address?address.length:0,saving:saving,__source:{fileName:_jsxFileName,lineNumber:85}}),_react2.default.createElement(_styles.LastSavedLabel,{__source:{fileName:_jsxFileName,lineNumber:95}},_data.lastSaved)));}}]);return EditAddress;}(_react.Component);var mapStateToProps=function mapStateToProps(state){return{address:state.reducer.user.enderecos,saving:state.reducer.formState.saving};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{initFormState:function initFormState(){return dispatch((0,_formStateActions.stopSaving)());},handleSave:function handleSave(address){dispatch((0,_formStateActions.startSaving)());dispatch(fetchUpdateBusinessAddress(address)).then(function(){dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modalUpdateTitle,image:_confirmation2.default}));dispatch((0,_formStateActions.stopSaving)());}).catch(function(e){console.log('Erro na promise',e);dispatch((0,_formStateActions.stopSaving)());});},handleDelete:function handleDelete(id,isCorrespondence){return dispatch(fetchDeleteBusinessAddress(id)).then(function(){return dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,isCorrespondence?{modalTitle:_data.modalDeleteTitle}:{modalTitle:_data.modalUpdateTitle}));});}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(EditAddress);module.exports=exports['default'];

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var addressFactory={toAPI:function toAPI(address){return address&&address.map(function(data,index){return{cep:data.zipCode,logradouro:data.address,numero:data.number,complemento:data.additionalInfo,bairro:data.neighborhood,uf:data.state,cidade:data.city,correspondencia:data.mail,principal:data.principal,codigo:data.key};});},toForm:function toForm(address){return address&&address.map(function(data,index){return{zipCode:data.cep,address:data.logradouro,number:data.numero,additionalInfo:data.complemento,neighborhood:data.bairro,state:data.uf,city:data.cidade,mail:data.correspondencia,principal:data.principal,key:data.codigo};});}};exports.default=addressFactory;module.exports=exports["default"];

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Endereço Comercial","title":"Endereço comercial","subtitle":"Mantenha o endereço da sua empresa sempre atualizado para não ter problemas de correspondência.","secondaryAddressTitle":"Endereço secundário","excludeLink":"Excluir","lastSaved":"Salvo em 10/10/2017 às 19:30","modalUpdateTitle":"Pronto! A gente já salvou suas alterações. ;)","modalDeleteTitle":"Pronto! Agora, sua correspondência vai para o endereço principal."}

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditRepresentatives/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _aleloLogic=__webpack_require__(12);var _CollapsibleFormList=__webpack_require__(1743);var _CollapsibleFormList2=_interopRequireDefault(_CollapsibleFormList);var _EditRepresentativesForm=__webpack_require__(1748);var _EditRepresentativesForm2=_interopRequireDefault(_EditRepresentativesForm);var _actions=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _factory=__webpack_require__(1751);var _factory2=_interopRequireDefault(_factory);var _styles=__webpack_require__(186);var _data=__webpack_require__(1752);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var fetchCreateRepresentative=_aleloLogic.actions.fetchCreateRepresentative,fetchUpdateRepresentative=_aleloLogic.actions.fetchUpdateRepresentative,fetchDeleteRepresentative=_aleloLogic.actions.fetchDeleteRepresentative;var EditRepresentatives=function EditRepresentatives(_ref){var representatives=_ref.representatives,addRepresentative=_ref.addRepresentative,removeRepresentative=_ref.removeRepresentative,updateRepresentative=_ref.updateRepresentative,triggerDocumentError=_ref.triggerDocumentError;var initialValues=_factory2.default.toForm(representatives);var onUpdate=function onUpdate(values,dispatch,props,done){updateRepresentative(_factory2.default.toAPI(values)).then(function(){done();});};var onDelete=function onDelete(document,done){if(representatives.length>1){removeRepresentative(document).then(function(){done();});}};var onCreate=function onCreate(values,dispatch,props,done){if(representatives.findIndex(function(representative){return representative.document===values.document.replace(/\.|-/g,'');})===-1){addRepresentative(_factory2.default.toAPI(values)).then(function(){props.reset();done();});}else{triggerDocumentError();}};return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:61}}),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:63}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:64}},_data.subtitle)),_react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:66}},_react2.default.createElement(_CollapsibleFormList2.default,{onDelete:onDelete,onCreate:onCreate,onUpdate:onUpdate,collapsibleItems:initialValues||[],__source:{fileName:_jsxFileName,lineNumber:67}},_react2.default.createElement(_EditRepresentativesForm2.default,{__source:{fileName:_jsxFileName,lineNumber:73}}))));};var mapStateToProps=function mapStateToProps(state){return{representatives:state.reducer.user.representantes};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{addRepresentative:function addRepresentative(data){return dispatch(fetchCreateRepresentative(data));},removeRepresentative:function removeRepresentative(document){return dispatch(fetchDeleteRepresentative(document));},updateRepresentative:function updateRepresentative(data){return dispatch(fetchUpdateRepresentative(data)).then(function(){return dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modalTitle,image:_confirmation2.default}));});},triggerDocumentError:function triggerDocumentError(){return dispatch((0,_reduxForm.stopSubmit)('addrepresentative',{document:_data.sameCpfError}));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(EditRepresentatives);module.exports=exports['default'];

/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _CollapsibleFormList=__webpack_require__(1744);var _CollapsibleFormList2=_interopRequireDefault(_CollapsibleFormList);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_CollapsibleFormList2.default;module.exports=exports['default'];

/***/ }),
/* 1744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/CollapsibleFormList/CollapsibleFormList.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _CollapsibleItem=__webpack_require__(1745);var _CollapsibleItem2=_interopRequireDefault(_CollapsibleItem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CollapsibleFormList=function(_Component){_inherits(CollapsibleFormList,_Component);function CollapsibleFormList(props){_classCallCheck(this,CollapsibleFormList);var _this=_possibleConstructorReturn(this,(CollapsibleFormList.__proto__||Object.getPrototypeOf(CollapsibleFormList)).call(this,props));_this.toggleItem=function(index){var newItemsStatus=_this.state.itemsStatus;newItemsStatus[index]=!newItemsStatus[index];_this.setState({itemsStatus:newItemsStatus});};_this.state={itemsStatus:[],addingItem:false};return _this;}_createClass(CollapsibleFormList,[{key:'render',value:function render(){var _this2=this;var itemsStatus=this.state.itemsStatus;var _props=this.props,onDelete=_props.onDelete,onUpdate=_props.onUpdate,collapsibleItems=_props.collapsibleItems,children=_props.children;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:31}},collapsibleItems.map(function(collapsibleItem,index){return collapsibleItem.document&&_react2.default.createElement(_CollapsibleItem2.default,{key:collapsibleItem.document,label:collapsibleItem.relationship,title:collapsibleItem.name,active:itemsStatus[index],onClick:function onClick(){return _this2.toggleItem(index);},__source:{fileName:_jsxFileName,lineNumber:35}},_react2.default.cloneElement(children,{form:'representative'+collapsibleItem.document,initialValues:collapsibleItem,disableKeyFields:true,onDelete:collapsibleItems.length>1&&function(){return onDelete(collapsibleItem.document,function(){return _this2.toggleItem(index);});},onSubmit:function onSubmit(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return onUpdate.apply(undefined,args.concat([function(){return _this2.toggleItem(index);}]));},onCancel:function onCancel(){return _this2.toggleItem(index);}}));}));}}]);return CollapsibleFormList;}(_react.Component);CollapsibleFormList.defaultProps={collapsibleItems:[]};exports.default=CollapsibleFormList;module.exports=exports['default'];

/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _CollapsibleItem=__webpack_require__(1746);var _CollapsibleItem2=_interopRequireDefault(_CollapsibleItem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_CollapsibleItem2.default;module.exports=exports['default'];

/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/CollapsibleItem/CollapsibleItem.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _Icon=__webpack_require__(31);var _styles=__webpack_require__(1747);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CollapsibleItem=function CollapsibleItem(_ref){var active=_ref.active,children=_ref.children,label=_ref.label,onClick=_ref.onClick,title=_ref.title;return _react2.default.createElement(_styles.ListItem,{active:active,__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:10}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement(_styles.Header,{onClick:onClick,__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:13}},label),_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:14}},title),_react2.default.createElement(_styles.Arrow,{__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement(_Icon.Icon,{height:'12px',icon:'dropdown-arrow',viewBox:'0 0 16 8',width:'100%',__source:{fileName:_jsxFileName,lineNumber:16}})))),_react2.default.createElement(_styles.InnerContent,{__source:{fileName:_jsxFileName,lineNumber:20}},children)));};exports.default=CollapsibleItem;module.exports=exports['default'];

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ListItem=exports.InnerContent=exports.Arrow=exports.Title=exports.Label=exports.Header=undefined;var _templateObject=_taggedTemplateLiteral(['\n        height: ',';\n    '],['\n        height: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        letter-spacing: ',';\n        margin: 0 0 ',';\n    '],['\n        letter-spacing: ',';\n        margin: 0 0 ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        ',';\n    '],['\n        ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        margin-right: ',';\n        width: ',';\n    '],['\n        margin-right: ',';\n        width: ',';\n    ']),_templateObject5=_taggedTemplateLiteral(['\n                margin-bottom: ',';\n            '],['\n                margin-bottom: ',';\n            ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=exports.Header=_styledComponents2.default.header.withConfig({displayName:'styles__Header',componentId:'sc-uxh926-0'})(['cursor:pointer;display:flex;flex-direction:column;height:',';justify-content:center;position:relative;user-select:none;width:100%;',';'],(0,_rem2.default)('90px'),_media2.default.large(_templateObject,(0,_rem2.default)('100px')));var Label=exports.Label=_styledComponents2.default.p.withConfig({displayName:'styles__Label',componentId:'sc-uxh926-1'})(['',';color:',';margin:0 0 ',';text-transform:uppercase;',';'],_types.txt12OpenSansLight,_colors.darkGrey,(0,_rem2.default)('8px'),_media2.default.large(_templateObject2,(0,_em2.default)('1px'),(0,_rem2.default)('10px')));var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-uxh926-2'})(['',';color:',';margin:0;',';'],_types.title14Galano,_colors.linkNavyBlue,_media2.default.large(_templateObject3,_types.title18Galano));var Arrow=exports.Arrow=_styledComponents2.default.i.withConfig({displayName:'styles__Arrow',componentId:'sc-uxh926-3'})(['color:',';margin-right:',';position:absolute;right:0;text-align:center;top:50%;transform:translateY(-50%) scaleY(1);width:',';',';'],_colors.linkNavyBlue,(0,_rem2.default)('8px'),(0,_rem2.default)('20px'),_media2.default.large(_templateObject4,(0,_rem2.default)('12px'),(0,_rem2.default)('24px')));var InnerContent=exports.InnerContent=(0,_styledComponents2.default)(_Content2.default).withConfig({displayName:'styles__InnerContent',componentId:'sc-uxh926-4'})(['max-height:0;margin-bottom:0;overflow:hidden;transition:0.6s max-height ease-in-out,0.6s margin-bottom ease-in-out;']);var ListItem=exports.ListItem=_styledComponents2.default.li.withConfig({displayName:'styles__ListItem',componentId:'sc-uxh926-5'})(['border-bottom:',' solid ',';list-style:none;margin:0;padding:0;:first-child{border-top:',' solid ',';}',';'],(0,_rem2.default)('1px'),_colors.lighterGrey,(0,_rem2.default)('1px'),_colors.lighterGrey,function(_ref){var active=_ref.active;return active&&(0,_styledComponents.css)(['','{margin-bottom:',';max-height:',';',';}','{transform:translateY(-50%) scaleY(-1);}'],InnerContent,(0,_rem2.default)('24px'),(0,_rem2.default)('1000px'),_media2.default.large(_templateObject5,(0,_rem2.default)('40px')),Arrow);});

/***/ }),
/* 1748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/EditRepresentativesForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _validateRepresentatives=__webpack_require__(1749);var _renderInputs=__webpack_require__(44);var _data=__webpack_require__(1750);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var EditRepresentativesForm=function EditRepresentativesForm(_ref){var onCancel=_ref.onCancel,onDelete=_ref.onDelete,reset=_ref.reset,handleSubmit=_ref.handleSubmit,pristine=_ref.pristine,disableKeyFields=_ref.disableKeyFields;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,width:[1,7/12],__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.name,name:'name',placeholder:_data.placeholders.name,type:'text',isRequired:true,disabled:disableKeyFields,__source:{fileName:_jsxFileName,lineNumber:21}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCpfInput,label:_data.labels.cpf,normalize:_aleloLogic.utils.cpfMask,placeholder:_data.placeholders.cpf,name:'document',type:'text',disabled:disableKeyFields,__source:{fileName:_jsxFileName,lineNumber:32}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pl:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.nationality,name:'nationality',placeholder:_data.placeholders.nationality,type:'text',isRequired:true,disabled:disableKeyFields,__source:{fileName:_jsxFileName,lineNumber:43}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.relationship,name:'relationship',validate:_aleloLogic.utils.emptyFieldValidate,isRequired:true,disabled:disableKeyFields,__source:{fileName:_jsxFileName,lineNumber:54}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:63}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.relationshipStart,placeholder:_data.placeholders.date,name:'relationshipStart',validate:_aleloLogic.utils.emptyFieldValidate,normalize:_aleloLogic.utils.dateMask,disabled:disableKeyFields,__source:{fileName:_jsxFileName,lineNumber:64}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pl:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.relationshipEnding,placeholder:_data.placeholders.date,normalize:_aleloLogic.utils.dateMask,name:'relationshipEnding',type:'text',disabled:disableKeyFields,__source:{fileName:_jsxFileName,lineNumber:75}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:85}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.email,name:'email',placeholder:_data.placeholders.email,type:'email',disabled:disableKeyFields,__source:{fileName:_jsxFileName,lineNumber:86}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:95}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTelephoneField,label:_data.labels.telephone,name:'telephone',type:'text',disabled:disableKeyFields,__source:{fileName:_jsxFileName,lineNumber:96}}))));};exports.default=(0,_reduxForm.reduxForm)({form:'editUserData',destroyOnUnmount:false,validate:_validateRepresentatives.validate,forceUnregisterOnUnmount:true})(EditRepresentativesForm);module.exports=exports['default'];

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.validate=undefined;var _aleloLogic=__webpack_require__(12);var _dictionary=__webpack_require__(252);var cpfValidate=_aleloLogic.utils.cpfValidate,emailValidate=_aleloLogic.utils.emailValidate,dddValidate=_aleloLogic.utils.dddValidate,phoneValidate=_aleloLogic.utils.phoneValidate;var emailFormat=_dictionary.errorMessage.emailFormat,required=_dictionary.errorMessage.required;var validate=exports.validate=function validate(values){var errors={};if(!values.email){errors.email=required;}else if(values.email&&emailValidate(values.email)){errors.email=emailFormat;}if(values.document&&cpfValidate(values.document)){errors.document=cpfValidate(values.document);}if(!values.name){errors.name=required;}if(!values.relationship){errors.relationship=required;}if(!values.document){errors.document=required;}if(!values.relationship||values.relationship.length===0){errors.relationship=required;}if(!values.nationality){errors.nationality=required;}if(!values.telephoneddd||!values.telephone){errors.telephone=required;}else{if(values.telephoneddd&&dddValidate(values.telephoneddd)){errors.telephone=dddValidate(values.telephoneddd);}if(values.telephone&&phoneValidate(values.telephone)){errors.telephone=phoneValidate(values.telephone);}}return errors;};

/***/ }),
/* 1750 */
/***/ (function(module, exports) {

module.exports = {"relationship":[{"value":"","label":"Selecione","selected":true,"disabled":true,"hidden":true},{"value":"acionista","label":"Acionista"},{"value":"avalista","label":"Avalista"},{"value":"procurador","label":"Procurador"}],"labels":{"cpf":"CPF","email":"Email","name":"Nome","nationality":"Nacionalidade","telephone":"Celular","relationship":"Tipo de relacão","relationshipStart":"Data de início da relação","relationshipEnding":"Data de término da relação"},"placeholders":{"cpf":"Ex 000.000.000-00","email":"Ex nome@exemplo.com","name":"Ex João Divino","nationality":"Ex Brasileiro","date":"00/00/0000"}}

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var representativesFactory={toAPI:function toAPI(data){return{name:data.name,document:data.document,relationship:data.relationship,relationship_start:data.relationshipStart,relationship_ending:data.relationshipEnding,nationality:data.nationality,email:data.email,mobile_phone:{number:data.telephone,area_code:data.telephoneddd}};},toForm:function toForm(representative){return representative&&representative.map(function(data){return{name:data.nome,document:data.cpf,relationship:data.tipoRelacao.nome,relationshipStart:(0,_moment2.default)(data.dataInicio).format('DD/MM/YYYY'),relationshipEnding:(0,_moment2.default)(data.dataFim).format('DD/MM/YYYY'),nationality:data.nacionalidade,email:data.email,telephone:data.celular&&data.celular.toString().substring(2),telephoneddd:data.celular&&data.celular.toString().substring(0,2)};});}};exports.default=representativesFactory;module.exports=exports['default'];

/***/ }),
/* 1752 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Editar Representantes legais","title":"Representantes legais","subtitle":"Mantenha as informações dos responsáveis pela sua empresa sempre atualizadas.","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","sameCpfError":"Este CPF já está cadastrado. Tente novamente."}

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditAdminContact/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _aleloLogic=__webpack_require__(12);var _reactRedux=__webpack_require__(7);var _EditAdminContactForm=__webpack_require__(1754);var _EditAdminContactForm2=_interopRequireDefault(_EditAdminContactForm);var _actions=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _formStateActions=__webpack_require__(102);var _factory=__webpack_require__(1756);var _factory2=_interopRequireDefault(_factory);var _styles=__webpack_require__(186);var _data=__webpack_require__(1757);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fetchUpdateBusinessContact=_aleloLogic.actions.fetchUpdateBusinessContact;var EditAdminContact=function(_React$Component){_inherits(EditAdminContact,_React$Component);function EditAdminContact(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EditAdminContact);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EditAdminContact.__proto__||Object.getPrototypeOf(EditAdminContact)).call.apply(_ref,[this].concat(args))),_this),_this.state={initialValues:null},_this.handleSave=function(contacts){var _this$props=_this.props,handleSave=_this$props.handleSave,dispatch=_this$props.dispatch;dispatch((0,_formStateActions.startSaving)());handleSave(contacts).then(function(resp){dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modalTitle,image:_confirmation2.default}));}).catch(function(e){console.log('Erro na promise erro ao salvar',e);dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modaTitleError,modalDescription:_data.modaTextError,image:_confirmation2.default}));}).finally(function(){return dispatch((0,_formStateActions.stopSaving)());});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EditAdminContact,[{key:'componentDidMount',value:function componentDidMount(){this.setState({initialValues:_factory2.default.toForm(this.props.contacts)});}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var _props=this.props,contacts=_props.contacts,history=_props.history;if(prevProps.contacts!==contacts){this.setState({initialValues:_factory2.default.toForm(contacts)});}if(contacts&&prevProps.contacts&&prevProps.contacts.email.enderecoEletronico!==contacts.email.enderecoEletronico){window.setTimeout(function(){_aleloLogic.actions.fetchLogout();history.push('/conta/login');},4000);}}},{key:'render',value:function render(){var _this2=this;var initialValues=this.state.initialValues;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:75}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:76}}),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:77}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:78}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:79}},_data.subtitle)),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:81}},_react2.default.createElement(_EditAdminContactForm2.default,_extends({initialValues:initialValues,onSubmit:function onSubmit(values){return _this2.handleSave(_factory2.default.toAPI(values));}},this.props,{__source:{fileName:_jsxFileName,lineNumber:82}}))));}}]);return EditAdminContact;}(_react2.default.Component);var mapStateToProps=function mapStateToProps(state){return{contacts:state.reducer.user.contato,saving:state.reducer.formState.saving};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{initFormState:function initFormState(){return dispatch((0,_formStateActions.stopSaving)());},handleSave:function handleSave(contacts){return dispatch(fetchUpdateBusinessContact(contacts));},dispatch:dispatch};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(EditAdminContact);module.exports=exports['default'];

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/EditAdminContactForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _reactRedux=__webpack_require__(7);var _aleloLogic=__webpack_require__(12);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _renderInputs=__webpack_require__(44);var _dictionary=__webpack_require__(252);var _styles=__webpack_require__(389);var _data=__webpack_require__(1755);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var validate=function validate(values,props){var errors={};if(!values.telephoneType){errors.telephoneType=_dictionary.errorMessage.required;}if(!values.telephone){errors.telephone=_dictionary.errorMessage.required;}if(props.initialValues&&values.email!==props.initialValues.email&&values.email!==values.validEmail){errors.email=_dictionary.errorMessage.emailDifferent;}if(props.initialValues&&values.email!==values.validEmail){errors.validEmail=_dictionary.errorMessage.different;}return errors;};var preventDefault=function preventDefault(e){e.preventDefault();var currentValue=e.target.value;e.target.value='';e.target.value=currentValue;};var EditAdminContactForm=function EditAdminContactForm(props){var handleSubmit=props.handleSubmit,saving=props.saving;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:58}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,width:[1,7/12],__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:61}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.name,validate:_aleloLogic.utils.emptyFieldValidate,name:'name',type:'text',isRequired:true,__source:{fileName:_jsxFileName,lineNumber:62}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:71}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.email,validate:_aleloLogic.utils.emailValidate,name:'email',type:'text',onPaste:function onPaste(e){return preventDefault(e);},isRequired:true,__source:{fileName:_jsxFileName,lineNumber:72}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:82}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.validateEmail,validate:_aleloLogic.utils.emailValidate,name:'validEmail',type:'text',onPaste:function onPaste(e){return preventDefault(e);},isRequired:true,__source:{fileName:_jsxFileName,lineNumber:83}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:93}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.site,validate:_aleloLogic.utils.emptyFieldValidate,name:'site',type:'text',isRequired:true,__source:{fileName:_jsxFileName,lineNumber:94}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:103}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTelephoneField,label:_data.labels.telephone,name:'telephone',type:'text',isRequired:true,__source:{fileName:_jsxFileName,lineNumber:104}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/6],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:112}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.line,name:'line',type:'text',__source:{fileName:_jsxFileName,lineNumber:113}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/3],mb:3,__source:{fileName:_jsxFileName,lineNumber:115}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTelephoneTypesField,label:_data.labels.telephoneType,name:'telephoneType',isRequired:true,id:'tipoDoTelefone',__source:{fileName:_jsxFileName,lineNumber:116}})),_react2.default.createElement(_gridStyled.Box,{width:[1,1/2],pr:[0,2],mb:3,__source:{fileName:_jsxFileName,lineNumber:124}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTelephoneField,label:_data.labels.cellphone,name:'cellphone',type:'text',__source:{fileName:_jsxFileName,lineNumber:125}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:132}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCheckboxField,label:_data.labels.promotions,name:'optInPromotions',__source:{fileName:_jsxFileName,lineNumber:133}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:139}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:140}},'* Caso altere seu email, voc\xEA ser\xE1 deslogado automaticamente.')))),_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:144}},_react2.default.createElement(_Button2.default,{type:'submit',text:'Salvar',disabled:saving||!props.valid,loading:saving,__source:{fileName:_jsxFileName,lineNumber:145}})));};var mapStateToProps=function mapStateToProps(state){return{saving:state.reducer.formState.saving};};var form=(0,_reduxForm.reduxForm)({form:'editAdminContactForm',destroyOnUnmount:false,validate:validate})(EditAdminContactForm);exports.default=(0,_reactRedux.connect)(mapStateToProps,undefined)(form);module.exports=exports['default'];

/***/ }),
/* 1755 */
/***/ (function(module, exports) {

module.exports = {"labels":{"name":"Nome","email":"E-mail","validateEmail":"Confirme o e-mail","site":"Site","telephone":"Telefone principal","line":"Ramal","telephoneType":"Tipo","cellphone":"Celular","promotions":"Quero saber das promoções e novidades mais legais :D"},"telephoneTypeOptions":[{"value":1,"label":"Comercial"},{"value":2,"label":"Residencial"}]}

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var contactFactory={toAPI:function toAPI(data){return data&&{nome:{nomeCompleto:data.name},site:{enderecoEletronico:data.site},email:{enderecoEletronico:data.email,newsletter:data.optInPromotions},telefone:{ddd:data.telephoneddd,numero:data.telephone,tipoTelefone:data.telephoneType,ramal:data.line},celular:{ddd:data.cellphoneddd,numero:data.cellphone}};},toForm:function toForm(data){return data&&{name:data.nome&&data.nome.nomeCompleto,email:data.email&&data.email.enderecoEletronico,validEmail:data.email&&data.email.enderecoEletronico,telephoneddd:data.telefone&&data.telefone.ddd,telephone:data.telefone&&data.telefone.numero,line:data.telefone&&data.telefone.ramal,telephoneType:data.telefone&&String(data.telefone.tipoTelefone),cellphoneddd:data.celular&&data.celular.ddd,cellphone:data.celular&&data.celular.numero,optInPromotions:data.email&&data.email.newsletter,site:data.site&&data.site.enderecoEletronico};}};exports.default=contactFactory;module.exports=exports["default"];

/***/ }),
/* 1757 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Editar Contato do Administrador","title":"Contato do administrador","subtitle":"Deixe os contatos da sua empresa atualizados. Assim, podemos ajudar quando for preciso. ;)","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","modaTitleError":"Foi Mal!","modaTextError":"Notamos que existe uma inconsistência nos dados de cadastro que você nos passou.  Por Favor, verifique e tente novamente."}

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ChangePassword/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _reduxForm=__webpack_require__(11);var _ChangePasswordForm=__webpack_require__(393);var _ChangePasswordForm2=_interopRequireDefault(_ChangePasswordForm);var _actions2=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _factory=__webpack_require__(1763);var _factory2=_interopRequireDefault(_factory);var _styles=__webpack_require__(1764);var _data=__webpack_require__(1765);var _alterarSenha=__webpack_require__(394);var _alterarSenha2=_interopRequireDefault(_alterarSenha);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function ChangePassword(_ref){var handleSave=_ref.handleSave;return _react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:21}}),_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:22}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:23}},_data.subtitle),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement(_ChangePasswordForm2.default,{hasCurrentPasswordField:true,onSubmit:function onSubmit(values){return handleSave(_factory2.default.toAPI(values));},__source:{fileName:_jsxFileName,lineNumber:25}})));}var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch){return{handleSave:function handleSave(password){return dispatch((0,_actions.fetchUpdatePassword)(password)).then(function(){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modalTitle,image:_alterarSenha2.default}));dispatch((0,_reduxForm.reset)('changeUserPasswordData'));}).catch(function(){return dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:'Ocorreu algum problema!',modalDescription:'Tente novamente mais tarde.',image:_contestacao2.default}));});}};};exports.default=(0,_reactRedux.connect)(null,mapDispatchToProps)(ChangePassword);

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/StepBox/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _propTypes=__webpack_require__(9);var _styles=__webpack_require__(1760);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/* eslint-disable */var roundedSvg={cross:['M10.982 11.57a.586.586 0 0 1-.415-.172L5.172 6.004a.588.588 0 0 1 .832-.832l5.394 5.395a.588.588 0 0 1-.416 1.004','M5.588 11.57a.588.588 0 0 1-.416-1.004l5.395-5.394a.588.588 0 1 1 .831.832l-5.394 5.394a.586.586 0 0 1-.416.173'],check:'M8.18779462,10.978096 C8.18124917,10.978096 8.1747781,10.9780015 8.16820785,10.9778126 C7.9846376,10.9727102 7.81128223,10.8959385 7.68885248,10.7655448 L5.17051363,8.08333225 C4.92399297,7.82082044 4.94757148,7.41759209 5.2231252,7.18276532 C5.49857975,6.9478913 5.92180289,6.97033225 6.16834834,7.2328913 L8.21620785,9.41393855 L15.8461748,2.18552122 C16.1083649,1.93718264 16.5322326,1.93829288 16.7928607,2.18807241 C17.0535632,2.43785193 17.0523483,2.84169445 16.7902078,3.09003303 L8.65978636,10.7925685 C8.53418305,10.9115763 8.36439793,10.978096 8.18779462,10.978096',circle:'M8.28 16.272a7.964 7.964 0 0 1-5.65-2.34A7.964 7.964 0 0 1 .29 8.28a7.963 7.963 0 0 1 2.34-5.65A7.964 7.964 0 0 1 8.28.29a7.963 7.963 0 0 1 5.65 2.34 7.963 7.963 0 0 1 2.342 5.65 7.94 7.94 0 0 1-.766 3.419.54.54 0 1 1-.976-.462 6.86 6.86 0 0 0 .662-2.956 6.866 6.866 0 0 0-2.024-4.887A6.866 6.866 0 0 0 8.281 1.37a6.866 6.866 0 0 0-4.887 2.024A6.866 6.866 0 0 0 1.37 8.28c0 1.846.718 3.582 2.024 4.887a6.866 6.866 0 0 0 4.887 2.024c.93 0 1.833-.181 2.683-.54a.54.54 0 0 1 .42.995 7.943 7.943 0 0 1-3.103.625'/* eslint-enable */};function StepBox(_ref){var steps=_ref.steps,title=_ref.title,stepBoxData=_ref.stepBoxData;var stepsValidity=stepBoxData.stepsValidity,showErrors=stepBoxData.showErrors;var validatedSteps=steps.map(function(step,index){var newStep=step;newStep.valid=stepsValidity[index];return newStep;});return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:32}},title),_react2.default.createElement(_styles.StepList,{__source:{fileName:_jsxFileName,lineNumber:33}},validatedSteps.map(function(step){return _react2.default.createElement(_styles.StepItem,{key:step.text,__source:{fileName:_jsxFileName,lineNumber:35}},_react2.default.createElement(_styles.RoundedCheck,{valid:step.valid,showErrors:showErrors,height:'16',width:'16',__source:{fileName:_jsxFileName,lineNumber:36}},showErrors&&step.valid&&_react2.default.createElement('path',{d:roundedSvg.check,__source:{fileName:_jsxFileName,lineNumber:37}}),showErrors&&!step.valid&&_react2.default.createElement('g',{__source:{fileName:_jsxFileName,lineNumber:41}},roundedSvg.cross.map(function(crossDimension){return _react2.default.createElement('path',{key:crossDimension,d:crossDimension,__source:{fileName:_jsxFileName,lineNumber:43}});})),_react2.default.createElement('path',{d:roundedSvg.circle,__source:{fileName:_jsxFileName,lineNumber:47}})),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:49}},step.text));})));}StepBox.defaultProps={steps:[],title:_propTypes.string,stepBoxData:{showErrors:true,stepsValidity:[]}};StepBox.propTypes={steps:(0,_propTypes.arrayOf)((0,_propTypes.shape)({valid:_propTypes.bool,text:_propTypes.string.isRequired})),title:_propTypes.string.isRequired,stepBoxData:(0,_propTypes.shape)({showErrors:_propTypes.bool,stepsValidity:(0,_propTypes.arrayOf)(_propTypes.bool)})};exports.default=(0,_reactRedux.connect)(function(state){return{stepBoxData:state.stepBox};})(StepBox);module.exports=exports['default'];

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RoundedCheck=exports.Text=exports.StepItem=exports.StepList=exports.Title=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n        background-color: ',';\n        box-shadow: 0 ',' ',' ',' rgba(0, 0, 0, .2);\n        padding: ',' ',';\n    '],['\n        background-color: ',';\n        box-shadow: 0 ',' ',' ',' rgba(0, 0, 0, .2);\n        padding: ',' ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.aside.withConfig({displayName:'styles__Container',componentId:'sc-trsbu6-0'})(['border-radius:',';width:100%;',';'],(0,_rem2.default)('6px'),_media2.default.large(_templateObject,_colors.offWhite,(0,_rem2.default)('10px'),(0,_rem2.default)('15px'),(0,_rem2.default)('-5px'),(0,_rem2.default)('22px'),(0,_rem2.default)('38px')));var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-trsbu6-1'})(['color:',';font-family:Galano;font-size:',';font-weight:bold;margin-bottom:',';'],_colors.linkNavyBlue,(0,_rem2.default)('20px'),(0,_rem2.default)('10px'));var StepList=exports.StepList=_styledComponents2.default.ul.withConfig({displayName:'styles__StepList',componentId:'sc-trsbu6-2'})(['margin:0;padding:0;']);var StepItem=exports.StepItem=_styledComponents2.default.li.withConfig({displayName:'styles__StepItem',componentId:'sc-trsbu6-3'})(['align-items:center;display:flex;list-style:none;margin-bottom:',';'],(0,_rem2.default)('17px'));var Text=exports.Text=_styledComponents2.default.div.withConfig({displayName:'styles__Text',componentId:'sc-trsbu6-4'})(['color:',';font-family:OpenSans;font-size:',';letter-spacing:',';'],_colors.linkNavyBlue,(0,_rem2.default)('12px'),(0,_em2.default)('-0.5px'));var RoundedCheck=exports.RoundedCheck=_styledComponents2.default.svg.withConfig({displayName:'styles__RoundedCheck',componentId:'sc-trsbu6-5'})(['flex:0 0 auto;fill:',';margin-right:',';transition:0.2s fill;',' ',';'],_colors.olive,(0,_rem2.default)('8px'),function(_ref){var showErrors=_ref.showErrors,valid=_ref.valid;return showErrors&&!valid&&(0,_styledComponents.css)(['fill:',';'],_colors.crimson);},function(_ref2){var showErrors=_ref2.showErrors,valid=_ref2.valid;return!showErrors&&!valid&&(0,_styledComponents.css)(['fill:',';'],_colors.grey);});

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _actions=__webpack_require__(13);var _utils=__webpack_require__(95);var _lodash=__webpack_require__(43);var _actions2=__webpack_require__(1762);var _data=__webpack_require__(602);var emptyConfirmPassword=_data.errors.emptyConfirmPassword,emptyCurrentPassword=_data.errors.emptyCurrentPassword,emptyNewPassword=_data.errors.emptyNewPassword,lowerLetterNeeded=_data.errors.lowerLetterNeeded,upperLetterNeeded=_data.errors.upperLetterNeeded,especialNeeded=_data.errors.especialNeeded,newPasswordLength=_data.errors.newPasswordLength,notMatch=_data.errors.notMatch,numberNeeded=_data.errors.numberNeeded,samePassword=_data.errors.samePassword;function validateNewPassword(value,dispatch){var error={};if(!value||value.length===0){dispatch((0,_actions2.showStepBoxErrors)());}else{dispatch((0,_actions2.showStepBoxErrors)(true));if(!value||!(0,_utils.validatePasswordLength)(value)){error.newPasswordLength=newPasswordLength;}if((0,_utils.validateLetterLow)(value)){error.lowerLetterNeeded=lowerLetterNeeded;}if((0,_utils.validateLetterUpper)(value)){error.upperLetterNeeded=upperLetterNeeded;}if(!(0,_utils.hasNumbers)(value)){error.numberNeeded=numberNeeded;}if((0,_utils.validateLetterEspecial)(value)){error.especialNeeded=especialNeeded;}dispatch((0,_actions2.setStepValidity)([!error.newPasswordLength,!error.lowerLetterNeeded,!error.upperLetterNeeded,!error.numberNeeded,!error.especialNeeded]));}return error;}function validatePassword(){var values=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var props=arguments[1];var confirmPassword=values.confirmPassword,currentPassword=values.currentPassword,newPassword=values.newPassword;var error={};var newPasswordErrors=validateNewPassword(newPassword,props.dispatch);var confirmPasswordErrors=newPassword!==confirmPassword&&notMatch;error.confirmPassword=(0,_lodash.isEmpty)(confirmPassword)?emptyConfirmPassword:confirmPasswordErrors;error.currentPassword=(0,_lodash.isEmpty)(currentPassword)&&emptyCurrentPassword;error.newPassword=(0,_lodash.isEmpty)(newPassword)?emptyNewPassword:newPasswordErrors;error.newPassword=newPassword&&newPassword===currentPassword?samePassword:error.newPassword;return(0,_lodash.omitBy)(error,_lodash.isEmpty);}var fetchCheckPassword=function fetchCheckPassword(val,dispatch,props){return(0,_actions.fetchVerifyUserPassword)(props.values.currentPassword).catch(function(){throw{currentPassword:{wrongPassword:true}// eslint-disable-line no-throw-literal
};});};exports.default={fetchCheckPassword:fetchCheckPassword,validateNewPassword:validateNewPassword,validatePassword:validatePassword};module.exports=exports['default'];

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var setStepValidity=exports.setStepValidity=function setStepValidity(stepsValidity){return{type:'SET_STEPBOX_ERRORS',stepsValidity:stepsValidity};};var showStepBoxErrors=exports.showStepBoxErrors=function showStepBoxErrors(showErrors){return{type:'SHOW_STEPBOX_ERRORS',showErrors:showErrors};};

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var passwordFactory={toAPI:function toAPI(data){return data&&{current_password:data.currentPassword,new_password:data.newPassword};}};exports.default=passwordFactory;module.exports=exports["default"];

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Content=exports.Wrapper=exports.Paragraph=exports.Heading=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-1hwvgh9-0'})(['',' color:',';'],_types.title24Galano,_colors.darkBlue);var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-1hwvgh9-1'})(['',' color:',';width:',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('270px'));var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-1hwvgh9-2'})(['margin-top:',';'],(0,_rem2.default)('32px'));var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-1hwvgh9-3'})(['',';margin:',' auto;'],_content2.default,(0,_rem2.default)('42px'));

/***/ }),
/* 1765 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Alterar senha","title":"Alterar senha","subtitle":"Troque a senha de vez em quando. Mínimo de seis caracteres e máximo de 14 caracteres, pelo menos uma letra e um número são sua segurança.","modalTitle":"Pronto! A gente já salvou sua nova senha. ;)"}

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/CancelAccount/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _gridStyled=__webpack_require__(8);var _reactRedux=__webpack_require__(7);var _aleloLogic=__webpack_require__(12);var _reactRouterDom=__webpack_require__(15);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _CancelAccountForm=__webpack_require__(603);var _CancelAccountForm2=_interopRequireDefault(_CancelAccountForm);var _actions=__webpack_require__(18);var _actions2=__webpack_require__(604);var _ModalTypes=__webpack_require__(20);var _styles=__webpack_require__(1771);var _data=__webpack_require__(1772);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var fetchCancelAccount=_aleloLogic.actions.fetchCancelAccount,fetchCancelAccountTokenCreate=_aleloLogic.actions.fetchCancelAccountTokenCreate,fetchCancelAccountTokenValidate=_aleloLogic.actions.fetchCancelAccountTokenValidate;var CancelAccount=function CancelAccount(props){return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Perfil',__source:{fileName:_jsxFileName,lineNumber:30}}),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_gridStyled.Box,{width:[1,6/12],__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:33}}),_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:34}},_data.title),_react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:35}},_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:36}},_data.infoSubtitle),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:37}},_data.text)),_react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:40}},_data.optionsSubtitle),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement(_CancelAccountForm2.default,{onSubmit:function onSubmit(values){return props.handleSave(values,props.history);},__source:{fileName:_jsxFileName,lineNumber:42}}))))));};var handleCancelToken=function handleCancelToken(data,dispatch,history){dispatch((0,_actions.showModal)(_ModalTypes.TOKEN_MODAL,{onConfirm:function onConfirm(_ref){var hideModal=_ref.hideModal,token=_ref.token;dispatch((0,_actions2.setTokenModalLoading)(true));dispatch(fetchCancelAccountTokenValidate(token)).then(function(){dispatch(fetchCancelAccount({reason:data.option,detail:data.otherMotive})).then(function(){hideModal();dispatch((0,_actions2.setTokenModalLoading)(null));dispatch((0,_actions2.setTokenModalError)(null));history.push('/perfil/conta-cancelada');});}).catch(function(){dispatch((0,_actions2.setTokenModalLoading)(null));dispatch((0,_actions2.setTokenModalError)('O código não é esse. Tente de novo.'));});},onResendToken:function onResendToken(){dispatch((0,_actions2.setTokenModalLoading)(true));dispatch(fetchCancelAccountTokenCreate()).then(function(){dispatch((0,_actions2.setTokenModalLoading)(null));dispatch((0,_actions2.setTokenModalTitle)('Reenviamos o código para você.'));}).catch(function(){dispatch((0,_actions2.setTokenModalLoading)(null));});}}));};var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref2){var form=_ref2.form,reducer=_ref2.reducer;return{form:form,cancelAccount:reducer.cancelAccount};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch){return{handleSave:function handleSave(values,history){dispatch(fetchCancelAccountTokenCreate()).then(function(){return handleCancelToken(values,dispatch,history);});}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)((0,_reactRouterDom.withRouter)(CancelAccount));

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Wrapper=exports.ButtonLink=exports.BackLink=exports.BackIcon=exports.Content=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content=exports.Content=(0,_styledComponents2.default)(_Content2.default).withConfig({displayName:'styles__Content',componentId:'sc-su3zi6-0'})(['height:',';line-height:',';'],(0,_rem2.default)('70px'),(0,_rem2.default)('70px'));var BackIcon=exports.BackIcon=(0,_styledComponents2.default)(_Icon2.default).withConfig({displayName:'styles__BackIcon',componentId:'sc-su3zi6-1'})(['margin-right:',';display:inline-block;'],(0,_rem2.default)('18px'));var BackLink=exports.BackLink=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__BackLink',componentId:'sc-su3zi6-2'})(['',';color:',';display:inline-block;position:relative;text-decoration:none;'],_types.txt14OpenSansBold,_colors.linkNavyBlue);var ButtonLink=exports.ButtonLink=_styledComponents2.default.a.withConfig({displayName:'styles__ButtonLink',componentId:'sc-su3zi6-3'})(['',';cursor:pointer;color:',';display:inline-block;position:relative;text-decoration:none;'],_types.txt14OpenSansBold,_colors.linkNavyBlue);var Wrapper=exports.Wrapper=_styledComponents2.default.nav.withConfig({displayName:'styles__Wrapper',componentId:'sc-su3zi6-4'})(['width:100%;',';'],function(props){return props.isColored&&(0,_styledComponents.css)(['background:',';border:',' solid ',';','{color:white;}'],_colors.skyBlue,(0,_rem2.default)('1px'),_colors.blizzardBlue,BackLink);});

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Radio/Radio.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(43);var _propTypes=__webpack_require__(9);var _styles=__webpack_require__(1769);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function Radio(props){var label=props.label,children=props.children,negative=props.negative,name=props.name;var inputProps=props.input?props.input:(0,_lodash.omit)(props,['label','children']);return _react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_styles.Input,_extends({},inputProps,{type:'radio',name:name,__source:{fileName:_jsxFileName,lineNumber:13}})),_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement(_styles.Circle,{negative:negative,__source:{fileName:_jsxFileName,lineNumber:15}}),label&&_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:16}},label)),children&&_react2.default.createElement(_styles.HiddenContent,{__source:{fileName:_jsxFileName,lineNumber:19}},children));}Radio.defaultProps={label:null};Radio.propTypes={label:_propTypes.string};exports.default=Radio;module.exports=exports['default'];

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Input=exports.HiddenContent=exports.Text=exports.Container=exports.Label=exports.Circle=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var bounceRadio=(0,_styledComponents.keyframes)(['0%{transform:translateX(-50%) translateY(-50%) scale(0);}40%{transform:translateX(-50%) translateY(-50%) scale(1.1);}70%{transform:translateX(-50%) translateY(-50%) scale(0.95);}100%{transform:translateX(-50%) translateY(-50%) scale(1);}']);var Circle=exports.Circle=_styledComponents2.default.span.withConfig({displayName:'styles__Circle',componentId:'sc-46hkv6-0'})(['border:solid ',' ',';border-radius:100%;box-shadow:0;display:block;height:',';position:relative;transition:0.3s box-shadow;width:',';:after{animation:0.4s ',' forwards;background:',';border-radius:100%;content:\'\';display:none;height:',';left:50%;position:absolute;top:50%;transform:translateX(-50%) translateY(-50%) scale(0);width:',';}:not(:last-child){margin-right:',';}'],(0,_rem2.default)('1px'),function(props){return props.negative?''+_colors.white:''+_colors.lightGrey;},(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),bounceRadio,function(props){return props.negative?''+_colors.white:''+_colors.skyBlue;},(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),(0,_rem2.default)('15px'));var Label=exports.Label=_styledComponents2.default.label.withConfig({displayName:'styles__Label',componentId:'sc-46hkv6-1'})(['user-select:none;:hover{','{box-shadow:0 0 0 ',' ',' inset;}}'],Circle,(0,_rem2.default)('1px'),_colors.grey);var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-46hkv6-2'})(['align-items:center;cursor:pointer;display:inline-flex;']);var Text=exports.Text=_styledComponents2.default.span.withConfig({displayName:'styles__Text',componentId:'sc-46hkv6-3'})(['',' color:',';display:inline-block;letter-spacing:',';line-height:1.5;'],_types.txt16OpenSans,_colors.darkGrey,(0,_rem2.default)('-0.4px'));var HiddenContent=exports.HiddenContent=_styledComponents2.default.div.withConfig({displayName:'styles__HiddenContent',componentId:'sc-46hkv6-4'})(['display:none;']);var Input=exports.Input=_styledComponents2.default.input.withConfig({displayName:'styles__Input',componentId:'sc-46hkv6-5'})(['display:none;:checked{+ ',' ','{border-color:',';box-shadow:0 0 0 ',' ',' inset;:after{display:block;}}~ ','{display:block;}}'],Container,Circle,function(props){return props.negative?''+_colors.white:''+_colors.skyBlue;},(0,_rem2.default)('1px'),function(props){return props.negative?''+_colors.white:''+_colors.skyBlue;},HiddenContent);

/***/ }),
/* 1770 */
/***/ (function(module, exports) {

module.exports = {"buttons":{"cancel":"Cancelar conta","back":"Voltar"},"labels":{"dontWantService":"Não tenho mais interesse pelo serviço.","dontWantCar":"Não quero mais ter carro.","moving":"Estou me mudando.","changingCompanies":"Estou trocando de empresa.","cantPayForService":"Não posso mais pagar o serviço.","other":"Outro motivo:"},"placeholders":{"other":"Estou desempregado."},"errorMessage":{"otherMotive":"Não esqueça de dizer o motivo do cancelamento."}}

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Content=exports.Wrapper=exports.Paragraph=exports.Subtitle=exports.Heading=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-xjczqq-0'})(['',';color:',';line-height:1;margin:0 0 ',';max-width:',';'],_types.title24Galano,_colors.darkBlue,(0,_rem2.default)('24px'),(0,_rem2.default)('200px'));var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-xjczqq-1'})(['',';color:',';font-weight:bold;line-height:1;margin:0 0 ',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('24px'));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-xjczqq-2'})(['',';color:',';margin:0 0 ',';'],_types.txt14OpenSans,_colors.darkGrey,(0,_rem2.default)('40px'));var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-xjczqq-3'})(['margin-bottom:',';'],(0,_rem2.default)('32px'));var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-xjczqq-4'})(['',';margin:',' auto;'],_content2.default,(0,_rem2.default)('42px'));

/***/ }),
/* 1772 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Cancelar conta","title":"Processo de cancelamento","infoSubtitle":"Você quer realmente voltar a contar o troco do pedágio?","text":"Fazendo o cancelamento, seus planos vão ser suspensos e você não vai mais ter acesso livre aos locais conveniados. E ainda vai ter que tomar cuidado para não perder nenhum ticket de estacionamento.","optionsSubtitle":"Por que você quer cancelar sua conta?"}

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/CanceledAccount/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _modalBuddies=__webpack_require__(605);var _modalBuddies2=_interopRequireDefault(_modalBuddies);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _styles=__webpack_require__(1774);var _data=__webpack_require__(1775);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function CanceledAccount(){return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement(_gridStyled.Flex,{align:'center',wrap:true,justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_gridStyled.Box,{width:[1,7/12],__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:29}},_data.title),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:30}},_data.description)),_react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_styles.ProtocolTitle,{__source:{fileName:_jsxFileName,lineNumber:33}},_data.protocolTitle),_react2.default.createElement(_styles.Protocol,{__source:{fileName:_jsxFileName,lineNumber:34}},'12340298091284091284'),_react2.default.createElement(_styles.SmallText,{__source:{fileName:_jsxFileName,lineNumber:36}},_data.generationDate),_react2.default.createElement(_Hide2.default,{at:'large',mt:'10%',mx:'auto',width:[6/12],__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement('img',{alt:'',src:_modalBuddies2.default,width:'100%',__source:{fileName:_jsxFileName,lineNumber:39}})),_react2.default.createElement(_gridStyled.Box,{mt:60,__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_gridStyled.Box,{mb:[8,24],__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_Button2.default,{buttonType:'transparent',text:'Reativar conta',__source:{fileName:_jsxFileName,lineNumber:44}})),_react2.default.createElement(_styles.SavedDate,{__source:{fileName:_jsxFileName,lineNumber:46}},_data.savedDate)))),_react2.default.createElement(_Hide2.default,{at:'small',mt:'10%',width:[1,'auto'],__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement('img',{alt:'',src:_modalBuddies2.default,width:'100%',__source:{fileName:_jsxFileName,lineNumber:51}}))))));}exports.default=CanceledAccount;module.exports=exports['default'];

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SavedDate=exports.Protocol=exports.ProtocolTitle=exports.SmallText=exports.Text=exports.Title=exports.Content=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ',';\n    '],['\n        ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n  border-bottom: solid ',' rgba(255, 255, 255, 0.5);\n  display: inline-block;\n  margin-bottom: ',';\n  padding-bottom: ',';\n\n  ',';\n'],['\n  border-bottom: solid ',' rgba(255, 255, 255, 0.5);\n  display: inline-block;\n  margin-bottom: ',';\n  padding-bottom: ',';\n\n  ',';\n']),_templateObject3=_taggedTemplateLiteral(['\n        margin-bottom: ',';\n        padding-bottom: ',';\n    '],['\n        margin-bottom: ',';\n        padding-bottom: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n  ',';\n'],['\n  ',';\n']),_templateObject5=_taggedTemplateLiteral(['\n        text-align: center;\n    '],['\n        text-align: center;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-5rkjwv-0'})(['background:',';'],_colors.skyBlue);var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-5rkjwv-1'})(['',';padding-bottom:',';padding-top:',';'],_content2.default,(0,_rem2.default)('60px'),(0,_rem2.default)('60px'));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-5rkjwv-2'})(['',';color:',';',';'],_types.title24GalanoBold,_colors.white,_media2.default.large(_templateObject,_types.title36GalanoBold));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-5rkjwv-3'})(['',';color:',';font-weight:200;',';'],_types.txt14OpenSans,_colors.white,_media2.default.large(_templateObject,_types.txt18OpenSansLight));var SmallText=exports.SmallText=_styledComponents2.default.span.withConfig({displayName:'styles__SmallText',componentId:'sc-5rkjwv-4'})(['',';color:',';display:block;text-transform:uppercase;'],_types.txt12OpenSansLight,_colors.white);var ProtocolTitle=exports.ProtocolTitle=Text.extend(_templateObject2,(0,_rem2.default)('1px'),(0,_rem2.default)('24px'),(0,_rem2.default)('24px'),_media2.default.large(_templateObject3,(0,_rem2.default)('32px'),(0,_rem2.default)('32px')));var Protocol=exports.Protocol=_styledComponents2.default.span.withConfig({displayName:'styles__Protocol',componentId:'sc-5rkjwv-5'})(['',';color:',';display:block;letter-spacing:',';margin-bottom:',';word-break:break-all;',';'],_types.title20GalanoBold,_colors.white,(0,_em2.default)('2.7px'),(0,_rem2.default)('24px'),_media2.default.large(_templateObject,_types.title30GalanoBold));var SavedDate=exports.SavedDate=SmallText.extend(_templateObject4,_media2.default.small(_templateObject5));

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Cancelar conta","title":"Recebemos seu pedido de cancelamento.","description":"Sua solicitação foi enviada e já está sendo analisada. Em até 7 dias, a gente vai entrar em contato com sua empresa para confirmar o cancelamento. Se mudar de ideia, vocês têm até 7 dias para reativar a conta.","protocolTitle":"Seu protocolo de atendimento:","generationDate":"protocolo gerado às 19:30, dia 10/10/2017","savedDate":"Salvo em 10/10/2017 às 19:30","headerMenuOptions":{"pf":[{"label":"Dados pessoais","link":"/perfil/editar-dados"},{"label":"Contatos","link":"/perfil/editar-contatos"},{"label":"Endereços","link":"/perfil/editar-endereco"},{"label":"Alterar senha","link":"/perfil/alterar-senha"},{"label":"Cancelar conta","link":"/conta/cancelar-conta","cancelledMenu":true},{"label":"Sair","link":"/","cancelledMenu":true}],"pj":[{"label":"Dados institucionais","link":"/perfil-pj/editar-dados"},{"label":"Endereço comercial","link":"/perfil-pj/endereco-comercial"},{"label":"Representantes","link":"/perfil-pj/representantes"},{"label":"Contato do administrador","link":"/perfil-pj/contato-do-administrador"},{"label":"Alterar senha","link":"/perfil-pj/alterar-senha"},{"label":"Cancelar conta","link":"/pj/conta/cancelar-conta","cancelledMenu":true},{"label":"Sair","link":"/","cancelledMenu":true}]}}

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateEmpty=__webpack_require__(112);var _TemplateEmpty2=_interopRequireDefault(_TemplateEmpty);var _FirstAccessIdentifierNotArrived=__webpack_require__(1777);var _FirstAccessIdentifierNotArrived2=_interopRequireDefault(_FirstAccessIdentifierNotArrived);var _FirstAccessCreatePassword=__webpack_require__(1781);var _FirstAccessCreatePassword2=_interopRequireDefault(_FirstAccessCreatePassword);var _FirstAccessIdentifierNewAddress=__webpack_require__(1785);var _FirstAccessIdentifierNewAddress2=_interopRequireDefault(_FirstAccessIdentifierNewAddress);var _NewIdentifierSuccess=__webpack_require__(1786);var _NewIdentifierSuccess2=_interopRequireDefault(_NewIdentifierSuccess);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/primeiro-acesso',component:_TemplateEmpty2.default,routes:[{path:'/primeiro-acesso/criar-senha',exact:true,component:_FirstAccessCreatePassword2.default},{path:'/primeiro-acesso/extravio',exact:true,component:_FirstAccessIdentifierNotArrived2.default},{path:'/primeiro-acesso/novo-endereco',exact:true,component:_FirstAccessIdentifierNewAddress2.default},{path:'/primeiro-acesso/novo-identificador-sucesso',exact:true,component:_NewIdentifierSuccess2.default}]};module.exports=exports['default'];

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/FirstAccessIdentifierNotArrived/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _aleloLogic=__webpack_require__(12);var _actions=__webpack_require__(18);var _EditAddressForm=__webpack_require__(391);var _EditAddressForm2=_interopRequireDefault(_EditAddressForm);var _ModalTypes=__webpack_require__(20);var _formStateActions=__webpack_require__(102);var _factory=__webpack_require__(1778);var _factory2=_interopRequireDefault(_factory);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _data=__webpack_require__(1779);var _styles=__webpack_require__(1780);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fetchShippingUpdateAddress=_aleloLogic.actions.fetchShippingUpdateAddress,fetchGetShippingAmount=_aleloLogic.actions.fetchGetShippingAmount;var FirstAccessIdentifierNotArrived=function(_React$Component){_inherits(FirstAccessIdentifierNotArrived,_React$Component);function FirstAccessIdentifierNotArrived(props){_classCallCheck(this,FirstAccessIdentifierNotArrived);var _this=_possibleConstructorReturn(this,(FirstAccessIdentifierNotArrived.__proto__||Object.getPrototypeOf(FirstAccessIdentifierNotArrived)).call(this,props));_this.changeCheckBox=function(evt){_this.setState({addressSelected:evt.target.value});};_this.state={addressSelected:'actual',addressMock:{cep:'12100-290',logradouro:'Alameda Xingu',numero:'512',complemento:'21º andar Tamboré',bairro:'Barueri',uf:'SP',cidade:'São Paulo',correspondencia:'',principal:true,codigo:'1'}};return _this;}_createClass(FirstAccessIdentifierNotArrived,[{key:'componentDidMount',value:function componentDidMount(){this.getShippingAmount();}},{key:'getShippingAmount',value:function getShippingAmount(){var cep=this.state.cep;this.props.handleShippingAmount(cep);}},{key:'render',value:function render(){var _this2=this;var _state=this.state,addressSelected=_state.addressSelected,addressMock=_state.addressMock;var _props=this.props,address=_props.address,handleSave=_props.handleSave,handleDelete=_props.handleDelete,saving=_props.saving,match=_props.match,history=_props.history;var initialValues=_factory2.default.toForm(address);return _react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:83}},_react2.default.createElement(_reactHelmet2.default,{title:'Minha Veloe - Extravio de identificador',__source:{fileName:_jsxFileName,lineNumber:84}}),_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:85}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Acompanhar pedido',back:history.goBack,__source:{fileName:_jsxFileName,lineNumber:86}})),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:89}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:90}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:91}},_data.paragraph),_react2.default.createElement(_styles.WrapperAddress,{__source:{fileName:_jsxFileName,lineNumber:92}},_react2.default.createElement(_styles.ActualAddress,{focus:addressSelected==='actual',__source:{fileName:_jsxFileName,lineNumber:93}},_react2.default.createElement(_styles.CheckBoxCep,{type:'radio',value:'actual',checked:addressSelected==='actual',onChange:function onChange(e){return _this2.changeCheckBox(e);},__source:{fileName:_jsxFileName,lineNumber:94}}),_react2.default.createElement(_styles.BoxCep,{__source:{fileName:_jsxFileName,lineNumber:100}},_react2.default.createElement(_styles.Cep,{__source:{fileName:_jsxFileName,lineNumber:101}},_data.cep,' ',addressMock.cep),_react2.default.createElement(_styles.CepText,{__source:{fileName:_jsxFileName,lineNumber:104}},addressMock.logradouro,' ',addressMock.numero,', ',addressMock.complemento,' ',addressMock.bairro,' ',addressMock.estado,' ',addressMock.cidade)),addressSelected==='actual'?_react2.default.createElement(_styles.BoxShipping,{__source:{fileName:_jsxFileName,lineNumber:110}},_react2.default.createElement(_styles.ShippingTitle,{__source:{fileName:_jsxFileName,lineNumber:111}},_data.shippingTitle),_react2.default.createElement(_styles.ShippingText,{__source:{fileName:_jsxFileName,lineNumber:112}},_react2.default.createElement(_Icon2.default,{icon:'checkGreen',svgStyle:'height: 16px; width: 16px',viewBox:'0 0 24 24',__source:{fileName:_jsxFileName,lineNumber:113}}),_react2.default.createElement(_styles.ShippingIconText,{__source:{fileName:_jsxFileName,lineNumber:118}},'Gr\xE1tis'))):null),_react2.default.createElement(_styles.NewAddress,{focus:addressSelected==='new',__source:{fileName:_jsxFileName,lineNumber:123}},_react2.default.createElement(_styles.WrapperSelectNewAddress,{__source:{fileName:_jsxFileName,lineNumber:124}},_react2.default.createElement(_styles.CheckBoxCep,{type:'radio',value:'new',checked:addressSelected==='new',onChange:function onChange(e){return _this2.changeCheckBox(e);},__source:{fileName:_jsxFileName,lineNumber:125}}),_react2.default.createElement(_styles.NewAddressText,{__source:{fileName:_jsxFileName,lineNumber:131}},_data.newAddressText)),_react2.default.createElement(_styles.WrapperFormNewAddress,{__source:{fileName:_jsxFileName,lineNumber:133}},addressSelected==='new'?_react2.default.createElement(_EditAddressForm2.default,{initialValues:{address:initialValues},onSubmit:function onSubmit(values){return handleSave(_factory2.default.toAPI(values.address));},onDelete:handleDelete,length:address?address.length:0,saving:saving,match:match,__source:{fileName:_jsxFileName,lineNumber:135}}):null)),addressSelected!=='new'?_react2.default.createElement(_styles.ButtonContainer,{__source:{fileName:_jsxFileName,lineNumber:147}},_react2.default.createElement(_Button2.default,{text:'Reenviar Identificador',onClick:function onClick(){return handleSave(_factory2.default.toAPI(address));},__source:{fileName:_jsxFileName,lineNumber:148}})):null)));}}]);return FirstAccessIdentifierNotArrived;}(_react2.default.Component);var mapStateToProps=function mapStateToProps(state){return{address:state.reducer.user.enderecos,saving:state.reducer.formState.saving};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{initFormState:function initFormState(){return dispatch((0,_formStateActions.stopSaving)());},handleSave:function handleSave(address){dispatch((0,_formStateActions.startSaving)());dispatch(fetchShippingUpdateAddress(address)).then(function(resp){if(resp&&resp.status){ownProps.history.push('/primeiro-acesso/novo-identificador-sucesso');}else{dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModal,image:_confirmation2.default}));}}).catch(function(e){dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModal,image:_confirmation2.default}));console.log('Erro ao atualizar o endereço',e);dispatch((0,_formStateActions.stopSaving)());});},handleShippingAmount:function handleShippingAmount(zipcode){return dispatch(fetchGetShippingAmount(zipcode));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(FirstAccessIdentifierNotArrived);module.exports=exports['default'];

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var addressFactory={toAPI:function toAPI(address){return address&&address.map(function(data,index){return{cep:data.zipCode,logradouro:data.address,numero:data.number,complemento:data.additionalInfo,bairro:data.neighborhood,uf:data.state,cidade:data.city,correspondencia:data.mail,principal:data.principal,codigo:data.key};});},toForm:function toForm(address){return address&&address.map(function(data,index){return{zipCode:data.cep,address:data.logradouro,number:data.numero,additionalInfo:data.complemento,neighborhood:data.bairro,state:data.uf,city:data.cidade,mail:data.correspondencia,principal:data.principal,key:data.codigo};});}};exports.default=addressFactory;module.exports=exports["default"];

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

module.exports = {"title":"Sua VeloeTag ainda não chegou?","paragraph":"Seu pedido deve ser entregue em até 7 dias úteis depois da confirmação do pagamento. Se isso não acontecer, você pode pedir um novo para nós. O antigo será bloqueado e você só vai precisar escolher se quer receber no mesmo endereço ou em outro.","titleModal":"Problemas ao alterar seu endereço para novo envio!","shippingTitle":"FRETE","newAddressText":"Prefiro receber em outro endereço","cep":"CEP"}

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonContainer=exports.CheckBoxCep=exports.NewAddressText=exports.WrapperFormNewAddress=exports.WrapperSelectNewAddress=exports.NewAddress=exports.ShippingIconText=exports.ShippingText=exports.ShippingTitle=exports.BoxShipping=exports.CepText=exports.Cep=exports.BoxCep=exports.ActualAddress=exports.WrapperAddress=exports.Paragraph=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n    ',';\n    letter-spacing: normal;\n  '],['\n    ',';\n    letter-spacing: normal;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n        width: ',';\n    '],['\n        width: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n    flex-direction: column;\n  '],['\n    flex-direction: column;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    margin: 15px 0 15px 35px;\n  '],['\n    margin: 15px 0 15px 35px;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    margin-top: 0;\n  '],['\n    margin-top: 0;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-18qv1bc-0'})(['',' letter-spacing:',';color:',';margin-top:',';max-width:520px;',';'],_types.title40GalanoBold,(0,_em2.default)('0.4px'),_colors.darkSlateBlue,(0,_rem2.default)('40px'),_media2.default.small(_templateObject,_types.title28GalanoBold));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-18qv1bc-1'})(['',' color:',';margin-bottom:60px;width:',';',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('270px'),_media2.default.large(_templateObject2,(0,_rem2.default)('435px')));var WrapperAddress=exports.WrapperAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperAddress',componentId:'sc-18qv1bc-2'})(['']);var ActualAddress=exports.ActualAddress=_styledComponents2.default.div.withConfig({displayName:'styles__ActualAddress',componentId:'sc-18qv1bc-3'})(['color:',';',';letter-spacing:',';display:flex;margin-bottom:20px;max-width:520px;justify-content:space-between;',';'],function(props){return props.focus?''+_colors.darkSlateBlue:''+_colors.blueGray;},_types.txt16OpenSans,(0,_em2.default)('0.4px'),_media2.default.small(_templateObject3));var BoxCep=exports.BoxCep=_styledComponents2.default.label.withConfig({displayName:'styles__BoxCep',componentId:'sc-18qv1bc-4'})(['flex-grow:1;']);var Cep=exports.Cep=_styledComponents2.default.div.withConfig({displayName:'styles__Cep',componentId:'sc-18qv1bc-5'})(['',';font-weight:bold;'],_types.txt16OpenSans);var CepText=exports.CepText=_styledComponents2.default.div.withConfig({displayName:'styles__CepText',componentId:'sc-18qv1bc-6'})(['max-width:250px;']);var BoxShipping=exports.BoxShipping=_styledComponents2.default.div.withConfig({displayName:'styles__BoxShipping',componentId:'sc-18qv1bc-7'})(['',';'],_media2.default.small(_templateObject4));var ShippingTitle=exports.ShippingTitle=_styledComponents2.default.div.withConfig({displayName:'styles__ShippingTitle',componentId:'sc-18qv1bc-8'})(['color:',';',';font-weight:bold;'],_colors.blueGray,_types.txt12OpenSans);var ShippingText=exports.ShippingText=_styledComponents2.default.div.withConfig({displayName:'styles__ShippingText',componentId:'sc-18qv1bc-9'})(['color:',';',';font-weight:bold;display:flex;align-items:center;'],_colors.darkSlateBlue,_types.txt16OpenSans);var ShippingIconText=exports.ShippingIconText=_styledComponents2.default.span.withConfig({displayName:'styles__ShippingIconText',componentId:'sc-18qv1bc-10'})(['margin-left:8px;']);var NewAddress=exports.NewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__NewAddress',componentId:'sc-18qv1bc-11'})(['color:',';',';letter-spacing:',';display:flex;flex-direction:column;'],function(props){return props.focus?''+_colors.darkSlateBlue:''+_colors.blueGray;},_types.txt16OpenSans,(0,_em2.default)('0.4px'));var WrapperSelectNewAddress=exports.WrapperSelectNewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperSelectNewAddress',componentId:'sc-18qv1bc-12'})(['']);var WrapperFormNewAddress=exports.WrapperFormNewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperFormNewAddress',componentId:'sc-18qv1bc-13'})(['margin-top:30px;']);var NewAddressText=exports.NewAddressText=_styledComponents2.default.label.withConfig({displayName:'styles__NewAddressText',componentId:'sc-18qv1bc-14'})(['']);var CheckBoxCep=exports.CheckBoxCep=_styledComponents2.default.input.withConfig({displayName:'styles__CheckBoxCep',componentId:'sc-18qv1bc-15'})(['margin-right:15px;&:checked,&:not(:checked){position:absolute;z-index:99999;margin-left:2px;cursor:pointer;}&:checked + label,&:not(:checked) + label{position:relative;padding-left:35px;line-height:20px;display:inline-block;}&:checked,&:not(:checked){&:before{content:\'\';position:absolute;left:-2px;top:0;width:20px;height:20px;border:2px solid ',';border-radius:100%;background:',';}}&:checked{&:before{border:2px solid ',';}}&:checked,&:not(:checked){&:after{content:\'\';width:12px;height:12px;background:',';position:absolute;top:4px;left:2px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;}}&:not(:checked){&:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}}&:checked{&:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}}'],_colors.grey,_colors.white,_colors.skyBlue,_colors.skyBlue);var ButtonContainer=exports.ButtonContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonContainer',componentId:'sc-18qv1bc-16'})(['margin-top:40px;',';'],_media2.default.small(_templateObject5));

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/FirstAccessCreatePassword/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(15);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _ChangePasswordForm=__webpack_require__(393);var _ChangePasswordForm2=_interopRequireDefault(_ChangePasswordForm);var _actions2=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _factory=__webpack_require__(1782);var _factory2=_interopRequireDefault(_factory);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _styles=__webpack_require__(1783);var _data=__webpack_require__(1784);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FirstAccessCreatePassword=function(_Component){_inherits(FirstAccessCreatePassword,_Component);function FirstAccessCreatePassword(){_classCallCheck(this,FirstAccessCreatePassword);return _possibleConstructorReturn(this,(FirstAccessCreatePassword.__proto__||Object.getPrototypeOf(FirstAccessCreatePassword)).apply(this,arguments));}_createClass(FirstAccessCreatePassword,[{key:'componentWillMount',value:function componentWillMount(){var params=this.props.match.params||{};this.props.fetchStatusToken(params.token);}},{key:'render',value:function render(){var _this2=this;var token=this.props.match.params.token||{};return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_styles.HeaderContent,{__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement(_reactRouterDom.Link,{to:'/conta/login',__source:{fileName:_jsxFileName,lineNumber:30}},_react2.default.createElement(_Icon2.default,{icon:'veloe-logo',svgStyle:_styles.Logo,width:'74',height:'31',viewBox:'0 0 74 31',__source:{fileName:_jsxFileName,lineNumber:31}})))),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:35}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:36}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:37}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:38}},_data.subtitle),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_ChangePasswordForm2.default,{form:'createNewPasswordData',asyncValidate:null,asyncBlurFields:['newPassword'],onSubmit:function onSubmit(values){return _this2.props.handleSave(_factory2.default.toAPI(values,token));},__source:{fileName:_jsxFileName,lineNumber:40}})))));}}]);return FirstAccessCreatePassword;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var reducer=_ref.reducer;return{recoverTokenStatus:reducer.recoverTokenStatus};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{handleSave:function handleSave(newPass){dispatch((0,_actions.fetchNewPassword)(newPass)).then(function(data){if(data.success){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modalTitle,onConfirm:function onConfirm(){return ownProps.history.push('/conta/login');},image:_confirmation2.default}));}else{dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:data.message,image:_confirmation2.default}));}},function(data){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:data.message,image:_confirmation2.default}));});},fetchStatusToken:function fetchStatusToken(token){return dispatch((0,_actions.fetchRecoverTokenStatus)(token));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(FirstAccessCreatePassword);module.exports=exports['default'];

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var passwordFactory={toAPI:function toAPI(data,token){return data&&token&&{token:token,password:data.newPassword};}};exports.default=passwordFactory;module.exports=exports["default"];

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Logo=exports.Content=exports.Wrapper=exports.Paragraph=exports.Heading=exports.Hr=exports.HeaderContent=exports.Header=undefined;var _templateObject=_taggedTemplateLiteral(['\n        padding: ',' ',';\n        position: relative;\n        text-align: center;\n        a {\n            margin: 0 auto;\n        }\n    '],['\n        padding: ',' ',';\n        position: relative;\n        text-align: center;\n        a {\n            margin: 0 auto;\n        }\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        font-size: ',';\n        margin: 0;\n    '],['\n        font-size: ',';\n        margin: 0;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        margin: ',' auto ',';\n    '],['\n        margin: ',' auto ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=exports.Header=_styledComponents2.default.nav.withConfig({displayName:'styles__Header',componentId:'sc-1shoy8b-0'})(['align-items:center;display:flex;justify-content:space-between;border-bottom:1px solid #e9e9ef;',';'],_media2.default.small(_templateObject,(0,_rem2.default)('20px'),(0,_rem2.default)('30px')));var HeaderContent=exports.HeaderContent=_styledComponents2.default.div.withConfig({displayName:'styles__HeaderContent',componentId:'sc-1shoy8b-1'})(['',';height:96px;padding:',' ',' ',';'],_content2.default,(0,_rem2.default)('40px'),(0,_rem2.default)('65px'),(0,_rem2.default)('5px'));var Hr=exports.Hr=_styledComponents2.default.hr.withConfig({displayName:'styles__Hr',componentId:'sc-1shoy8b-2'})(['width:100%;height:1px;background-color:#e9e9ef;']);var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-1shoy8b-3'})(['',' color:',';font-size:',';margin-bottom:0;',';'],_types.title24Galano,_colors.darkBlue,(0,_rem2.default)('40px'),_media2.default.small(_templateObject2,(0,_rem2.default)('24px')));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-1shoy8b-4'})(['',' color:',';max-width:',';margin-top:0;'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('430px'));var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-1shoy8b-5'})(['margin-top:',';'],(0,_rem2.default)('32px'));var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-1shoy8b-6'})(['',';margin:',' auto;',';'],_content2.default,(0,_rem2.default)('42px'),_media2.default.small(_templateObject3,(0,_rem2.default)('10px'),(0,_rem2.default)('42px')));var Logo=exports.Logo='\n    height: '+(0,_rem2.default)('30px')+';\n    fill: '+_colors.linkNavyBlue+';\n    width: '+(0,_rem2.default)('74px')+';\n';

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Criar senha","title":"Oi,","subtitle":"Tickets de estacionamento e filas de pedágio vão sair da sua vida. Crie uma senha com seis caracteres e pelo menos uma letra e um número.","modalTitle":"Pronto! A gente já salvou suas alterações. ;)"}

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/FirstAccessIdentifierNewAddress/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FirstAccessIdentifierNewAddress=function FirstAccessIdentifierNewAddress(){return _react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Novo endere\xE7o',url:'/',__source:{fileName:_jsxFileName,lineNumber:10}})),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement('p',{__source:{fileName:_jsxFileName,lineNumber:14}},'Pronto! Identificador novo a caminho. :)')));};exports.default=FirstAccessIdentifierNewAddress;module.exports=exports['default'];

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/NewIdentifierSuccess/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _HeaderWithBrand=__webpack_require__(606);var _HeaderWithBrand2=_interopRequireDefault(_HeaderWithBrand);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(1788);var _data=__webpack_require__(1789);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ActivationSuccess=function ActivationSuccess(props){var history=props.history;return _react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement(_HeaderWithBrand2.default,{__source:{fileName:_jsxFileName,lineNumber:16}}),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:18}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:19}},_data.paragraph),_react2.default.createElement(_styles.ProtocolTitle,{__source:{fileName:_jsxFileName,lineNumber:20}},_data.titleProtocol),_react2.default.createElement(_styles.Protocol,{__source:{fileName:_jsxFileName,lineNumber:21}},'201801228659'),_react2.default.createElement(_styles.UpdateIn,{__source:{fileName:_jsxFileName,lineNumber:22}},'Salvo em 22/01/2018, \xE0s 19:30.'),_react2.default.createElement(_Button2.default,{text:_data.submitButton,onClick:function onClick(){return history.goBack(-3);},buttonType:'transparent',__source:{fileName:_jsxFileName,lineNumber:23}})));};var mapStateToProps=function mapStateToProps(_ref){var reducer=_ref.reducer;return{accountPlans:reducer.accountPlans};};exports.default=(0,_reactRedux.connect)(mapStateToProps,null)(ActivationSuccess);module.exports=exports['default'];

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Wrapper=exports.Logo=exports.Content=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _hexToRgba=__webpack_require__(187);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content=exports.Content=(0,_styledComponents2.default)(_Content2.default).withConfig({displayName:'styles__Content',componentId:'sc-11m6m6x-0'})(['height:',';line-height:',';'],(0,_rem2.default)('70px'),(0,_rem2.default)('70px'));var Logo=exports.Logo='\n  height: '+(0,_rem2.default)('30px')+';\n  fill: '+_colors.white+';\n  width: '+(0,_rem2.default)('74px')+';\n';var Wrapper=exports.Wrapper=_styledComponents2.default.nav.withConfig({displayName:'styles__Wrapper',componentId:'sc-11m6m6x-1'})(['box-shadow:0 1px 0 0 ',';width:100%;'],(0,_hexToRgba.hexToRgba)(_colors.white,0.64));

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.UpdateIn=exports.Protocol=exports.ProtocolTitle=exports.Paragraph=exports.Title=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n    background-size: contain;\n    padding-bottom: 190px;\n  '],['\n    background-size: contain;\n    padding-bottom: 190px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    font-size: ',';\n  '],['\n    font-size: ',';\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);var _truckTravel=__webpack_require__(607);var _truckTravel2=_interopRequireDefault(_truckTravel);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-18r6lcl-0'})(['background:url(',') no-repeat bottom right;background-color:',';min-height:100vh;',';'],_truckTravel2.default,_colors.tealish,_media2.default.small(_templateObject));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-18r6lcl-1'})(['',' letter-spacing:',';color:',';font-size:',';margin:',' 0;max-width:',';',';'],_types.title40GalanoBold,(0,_em2.default)('0.4px'),_colors.white,(0,_rem2.default)('48px'),(0,_rem2.default)('40px'),(0,_rem2.default)('615px'),_media2.default.small(_templateObject2,(0,_rem2.default)('35px')));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-18r6lcl-2'})(['',' color:',';max-width:',';margin-bottom:',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('615px'),(0,_rem2.default)('40px'));var ProtocolTitle=exports.ProtocolTitle=_styledComponents2.default.p.withConfig({displayName:'styles__ProtocolTitle',componentId:'sc-18r6lcl-3'})(['',' color:',';max-width:',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('615px'));var Protocol=exports.Protocol=_styledComponents2.default.h2.withConfig({displayName:'styles__Protocol',componentId:'sc-18r6lcl-4'})(['',' color:',';font-size:',';max-width:',';margin-top:',';'],_types.title40GalanoBold,_colors.darkBlue,(0,_rem2.default)('32px'),(0,_rem2.default)('615px'),(0,_rem2.default)('0'));var UpdateIn=exports.UpdateIn=_styledComponents2.default.p.withConfig({displayName:'styles__UpdateIn',componentId:'sc-18r6lcl-5'})(['',' color:',';opacity:0.72;max-width:',';margin-bottom:40px;'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('615px'));

/***/ }),
/* 1789 */
/***/ (function(module, exports) {

module.exports = {"title":"Pronto! VeloeTag nova a caminho. :)","paragraph":"Nós vamos mandar uma VeloeTag novinha em folha para você. Em até 7 dias úteis, você receberá o Veloe no endereço selecionado. A entrega só pode ser recebida por uma pessoa com mais de 18 anos, com documento atualizado e com foto.","titleProtocol":"Enquanto isso, anote o número do protocolo:","submitButton":"Continuar"}

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateEmpty=__webpack_require__(112);var _TemplateEmpty2=_interopRequireDefault(_TemplateEmpty);var _BlockIdentifiers=__webpack_require__(1791);var _BlockIdentifiers2=_interopRequireDefault(_BlockIdentifiers);var _BlockIdentifierSuccess=__webpack_require__(1795);var _BlockIdentifierSuccess2=_interopRequireDefault(_BlockIdentifierSuccess);var _BlockIdentifierNew=__webpack_require__(1798);var _BlockIdentifierNew2=_interopRequireDefault(_BlockIdentifierNew);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id/identificador/:identifierId/bloquear',component:_TemplateEmpty2.default,routes:[{path:'/minha-veloe/:id/identificador/:identifierId/bloquear',exact:true,component:_BlockIdentifiers2.default},{path:'/minha-veloe/:id/identificador/:identifierId/bloquear/sucesso',exact:true,component:_BlockIdentifierSuccess2.default},{path:'/minha-veloe/:id/identificador/:identifierId/bloquear/novo-identificador',exact:true,component:_BlockIdentifierNew2.default}]};module.exports=exports['default'];

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/BlockIdentifiers/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _gridStyled=__webpack_require__(8);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _reactRouterDom=__webpack_require__(15);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _BlockIdentifiersForm=__webpack_require__(1792);var _BlockIdentifiersForm2=_interopRequireDefault(_BlockIdentifiersForm);var _actions2=__webpack_require__(36);var _actions3=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);var _styles=__webpack_require__(608);var _data=__webpack_require__(1794);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BlockIdentifiers=function(_React$Component){_inherits(BlockIdentifiers,_React$Component);function BlockIdentifiers(){var _ref;var _temp,_this,_ret;_classCallCheck(this,BlockIdentifiers);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BlockIdentifiers.__proto__||Object.getPrototypeOf(BlockIdentifiers)).call.apply(_ref,[this].concat(args))),_this),_this.state={reasonList:[],reasonSelected:''},_this.handleSave=function(values,history){var idAccount=_this.props.match.params.id;var identifier=_this.props.match.params.identifierId;history.push('/minha-veloe/'+idAccount+'/identificador/'+identifier+'/bloquear/novo-identificador/?option='+values.option+(values.descricaoOutroProblema?'&description='+values.descricaoOutroProblema:''));},_this.handleChangeReason=function(value){return _this.setState(function(){return{reasonSelected:value};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BlockIdentifiers,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _this2=this;var _props,dispatch,setLoading,history,getUser,user,reasonListBlock,id,idAccount;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=this.props,dispatch=_props.dispatch,setLoading=_props.setLoading,history=_props.history,getUser=_props.getUser,user=_props.user,reasonListBlock=_props.reasonListBlock,id=_props.match.params.id;idAccount=id;if(!(user&&user.enderecos&&user.enderecos.length>0&&reasonListBlock)){_context.next=6;break;}this.setState({reasonList:reasonListBlock});_context.next=9;break;case 6:setLoading(true);_context.next=9;return getUser(history).then(function(resp){_this2.setState({reasonList:resp&&resp[1]||[]});}).catch(function(resp){if(resp&&(resp.status===401||resp.status===403)){dispatch((0,_actions.fetchLogout)());history.push('/conta/login');}else{dispatch((0,_actions3.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:'Ops! Seus dados estão incompletos',modalDescription:'Não foi possível seguir com sua solicitação. Atualize seus dados cadastrais no menu empresarial e caso o erro persista, entre em contato com a gente.',image:_contestacao2.default}));history.push('/minha-veloe/'+idAccount+'/identificadores');// history.back()
}}).finally(function(){return setLoading(false);});case 9:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()// componentDidUpdate = (prevProps, prevState) => {
//   const { shoModalErro, profile } = this.props
//   console.log('prevProps -> ', prevProps)
//   console.log('prevState <-', prevState)
//   console.log('profile -> ', profile)
//   if (!prevState.profile) {
//     shoModalErro(CONFIRM_UPDATE, {
//       modalTitle:
//         '2222Problema ao buscar dados da conta, caso persista entre em contato com o suporte.',
//       image: imageError
//     })
//   }
// }
},{key:'render',value:function render(){var _this3=this;var history=this.props.history;var _state=this.state,reasonList=_state.reasonList,reasonSelected=_state.reasonSelected;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:98}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Minhas Veloetags',back:history.goBack,__source:{fileName:_jsxFileName,lineNumber:99}}),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:100}},_react2.default.createElement(_gridStyled.Box,{width:[1,6/12],__source:{fileName:_jsxFileName,lineNumber:101}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:102}}),_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:103}},_data.title),_react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:104}},_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:105}},_data.text)),_react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:107}},_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:108}},_data.optionsSubtitle),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:109}},_react2.default.createElement(_BlockIdentifiersForm2.default,{onSubmit:function onSubmit(values){return _this3.handleSave(values,history);},reasonList:reasonList,reasonSelected:reasonSelected,handleChangeReason:this.handleChangeReason,__source:{fileName:_jsxFileName,lineNumber:110}}))))));}}]);return BlockIdentifiers;}(_react2.default.Component);var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref3){var form=_ref3.form,reducer=_ref3.reducer;return{form:form,account:reducer.account,user:reducer.user,reasonListBlock:reducer.reasonsListBlock.reasons};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch){return{dispatch:dispatch,getUser:function getUser(history){return Promise.all([dispatch((0,_actions.fetchGetBusinessUser)()),dispatch((0,_actions.fetchReasonList)())]);},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));},shoModalErro:function shoModalErro(imagem,infos){return dispatch((0,_actions3.showModal)(imagem,infos));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)((0,_reactRouterDom.withRouter)(BlockIdentifiers));

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/BlockIdentifiersForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _reactRouterDom=__webpack_require__(15);var _aleloLogic=__webpack_require__(12);var _TextInput=__webpack_require__(101);var _TextInput2=_interopRequireDefault(_TextInput);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _Radio=__webpack_require__(136);var _Radio2=_interopRequireDefault(_Radio);var _data=__webpack_require__(1793);var _styles=__webpack_require__(608);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var renderRadio=function renderRadio(_ref){var input=_ref.input,label=_ref.label;return _react2.default.createElement(_Radio2.default,_extends({},input,{label:label,__source:{fileName:_jsxFileName,lineNumber:15}}));};var renderOtherMotive=function renderOtherMotive(_ref2){var placeholder=_ref2.placeholder,input=_ref2.input,onChange=_ref2.onChange,value=_ref2.value,_ref2$meta=_ref2.meta,touched=_ref2$meta.touched,error=_ref2$meta.error;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement(_styles.ParagraphGrayLabel,{__source:{fileName:_jsxFileName,lineNumber:19}},'DESCREVA O MOTIVO'),_react2.default.createElement(_TextInput2.default,_extends({},input,{placeholder:placeholder,maxlength:'40',lengthCounter:true,errorMessage:touched&&error,__source:{fileName:_jsxFileName,lineNumber:20}})));};var BlockIdentifiersForm=function BlockIdentifiersForm(props){var handleSubmit=props.handleSubmit,pristine=props.pristine,history=props.history,reasonList=props.reasonList,handleChangeReason=props.handleChangeReason,reasonSelected=props.reasonSelected;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:34}},reasonList&&reasonList.map(function(item){return _react2.default.createElement(_gridStyled.Box,{mb:24,key:item.chave,__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:item.descricao,name:'option',value:item.chave,type:'radio',onChange:function onChange(evt){return handleChangeReason(evt.target.value);},__source:{fileName:_jsxFileName,lineNumber:38}}));}),reasonSelected==='OUTRO'&&_react2.default.createElement(_gridStyled.Box,{mb:20,__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_reduxForm.Field,{component:renderOtherMotive,placeholder:'Digite aqui',name:'descricaoOutroProblema',validate:_aleloLogic.utils.emptyFieldValidate,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:50}})),_react2.default.createElement(_gridStyled.Flex,{wrap:true,mt:60,__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_Button2.default,{buttonType:'white',onClick:function onClick(){return history.goBack();},text:_data.buttons.back,__source:{fileName:_jsxFileName,lineNumber:61}})),_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],ml:[0,30],mt:[20,0],__source:{fileName:_jsxFileName,lineNumber:63}},_react2.default.createElement(_Button2.default,{disabled:pristine,type:'submit',text:_data.buttons.next,__source:{fileName:_jsxFileName,lineNumber:64}}))));};exports.default=(0,_reduxForm.reduxForm)({form:'formBlockChangeidentifier',destroyOnUnmount:true})((0,_reactRouterDom.withRouter)(BlockIdentifiersForm));module.exports=exports['default'];

/***/ }),
/* 1793 */
/***/ (function(module, exports) {

module.exports = {"buttons":{"next":"Continuar","back":"Voltar"}}

/***/ }),
/* 1794 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Bloquear / Substituir VeloeTag","title":"Bloquear / Substituir VeloeTag","text":"Fazendo o bloqueio, você não vai mais ter acesso livre aos locais conveniados.","optionsSubtitle":"Conte para a gente o motivo do bloqueio / substituição:"}

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/BlockIdentifierSuccess/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _gridStyled=__webpack_require__(8);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _styles=__webpack_require__(1796);var _data=__webpack_require__(1797);var _semaphore=__webpack_require__(609);var _semaphore2=_interopRequireDefault(_semaphore);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var BlockIdentifierSuccess=function BlockIdentifierSuccess(props){return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:17}}),_react2.default.createElement(_ImersiveHeader2.default,{isColored:true,text:'Dados de plano',url:'/minha-veloe/2/identificadores',__source:{fileName:_jsxFileName,lineNumber:18}}),_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_gridStyled.Flex,{direction:'row',__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_gridStyled.Box,{width:1,__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:23}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:24}},_data.infoSubtitle),_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:25}}),_react2.default.createElement(_styles.Protocol,{__source:{fileName:_jsxFileName,lineNumber:26}},_data.protocol),_react2.default.createElement(_styles.Date,{__source:{fileName:_jsxFileName,lineNumber:27}},_data.date),_react2.default.createElement(_gridStyled.Box,{mt:32,mb:37,__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_Button2.default,{buttonType:'transparent',text:'Ok',width:140,__source:{fileName:_jsxFileName,lineNumber:29}}))),_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_styles.Illustration,{__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement('img',{src:_semaphore2.default,alt:'sem\xE1foro',__source:{fileName:_jsxFileName,lineNumber:35}}))))))));};exports.default=BlockIdentifierSuccess;module.exports=exports['default'];

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Separator=exports.Illustration=exports.Date=exports.Protocol=exports.Paragraph=exports.Title=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ','\n\n        letter-spacing: ',';\n        margin: ',' 0 ',' 0;\n        max-width: ',';\n    '],['\n        ','\n\n        letter-spacing: ',';\n        margin: ',' 0 ',' 0;\n        max-width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        border: ',' solid ',';\n        display: block;\n        margin-right: ',';\n        margin: ',' 0 ',' 0;\n        width: 30%;\n    '],['\n        border: ',' solid ',';\n        display: block;\n        margin-right: ',';\n        margin: ',' 0 ',' 0;\n        width: 30%;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.main.withConfig({displayName:'styles__Container',componentId:'sc-h6cop9-0'})(['background:',';height:100vh;margin:0;overflow:auto;'],_colors.skyBlue);var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-h6cop9-1'})(['',' color:',';letter-spacing:',';font-weight:bold;margin:',' 0 ',' 0;max-width:',';',';'],_types.title24GalanoBold,_colors.white,(0,_rem2.default)('0.4px'),(0,_rem2.default)('46px'),(0,_rem2.default)('16px'),(0,_rem2.default)('231px'),_media2.default.large(_templateObject,_types.title40GalanoBold,(0,_rem2.default)('0.4px'),(0,_rem2.default)('78px'),(0,_rem2.default)('16px'),(0,_rem2.default)('364px')));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-h6cop9-2'})(['',' color:',';margin:0;max-width:',';'],_types.txt14OpenSans,_colors.white,(0,_rem2.default)('431px'));var Protocol=exports.Protocol=_styledComponents2.default.p.withConfig({displayName:'styles__Protocol',componentId:'sc-h6cop9-3'})(['',' color:',';letter-spacing:0.3px;line-height:1;margin:0;'],_types.title32GalanoBold,_colors.white);var Date=exports.Date=_styledComponents2.default.time.withConfig({displayName:'styles__Date',componentId:'sc-h6cop9-4'})(['',' color:',';letter-spacing:1px;'],_types.txt12OpenSans,_colors.white);var Illustration=exports.Illustration=_styledComponents2.default.div.withConfig({displayName:'styles__Illustration',componentId:'sc-h6cop9-5'})(['position:relative;top:',';'],(0,_rem2.default)('95px'));var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'styles__Separator',componentId:'sc-h6cop9-6'})(['border:',' solid ',';margin:',' 0 ',' 0;width:100%;',';'],(0,_rem2.default)('1px'),_colors.blizzardBlue,(0,_rem2.default)('29px'),(0,_rem2.default)('34px'),_media2.default.large(_templateObject2,(0,_rem2.default)('1px'),_colors.blizzardBlue,(0,_rem2.default)('600px'),(0,_rem2.default)('29px'),(0,_rem2.default)('32px')));

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"VeloeTag bloqueado","title":"Sua VeloeTag foi bloqueado","infoSubtitle":"Seu pedido já está com a gente para análise. Em breve, vamos entrar em contato para você pedir uma nova VeloeTag. Enquanto isso, guarde o número do protocolo:","protocol":"1234029809","date":"Salvo em 10/10/2017 às 19:30"}

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/BlockIdentifierNew/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _gridStyled=__webpack_require__(8);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _actions=__webpack_require__(13);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _actions2=__webpack_require__(36);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _BlockReplaceModal=__webpack_require__(1799);var _BlockReplaceModal2=_interopRequireDefault(_BlockReplaceModal);var _BlockModal=__webpack_require__(1802);var _BlockModal2=_interopRequireDefault(_BlockModal);var _ReceivedModal=__webpack_require__(1804);var _ReceivedModal2=_interopRequireDefault(_ReceivedModal);var _utils=__webpack_require__(95);var _actions3=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);var _styles=__webpack_require__(610);var _BlockIdentifiersListOptions=__webpack_require__(1806);var _BlockIdentifiersListOptions2=_interopRequireDefault(_BlockIdentifiersListOptions);var _OtherAddressForm=__webpack_require__(611);var _OtherAddressForm2=_interopRequireDefault(_OtherAddressForm);var _data3=__webpack_require__(1810);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ListOptions=[{chave:'RECEBER',descricao:'Receber nova VeloeTag'},{chave:'POSSUO',descricao:'Já possuo uma VeloeTag, quero apenas substituí-la'},{chave:'BLOQUEAR',descricao:'Quero apenas bloquear a VeloeTag'}];var BlockNewIdentifier=function(_React$Component){_inherits(BlockNewIdentifier,_React$Component);function BlockNewIdentifier(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,BlockNewIdentifier);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=BlockNewIdentifier.__proto__||Object.getPrototypeOf(BlockNewIdentifier)).call.apply(_ref,[this].concat(args))),_this),_this.state={addressSelected:'actual',address:{cep:'',logradouro:'',numero:'',complemento:'',bairro:'',uf:'',cidade:''},reasonList:[],reasonSelected:'',identifier:'',idAccount:'',optionSelected:null,loading:false,newIdentifier:'',modalBlock:false,modalReceive:false,modalReplace:false,idOrder:''},_this.getUrlParameter=function(name){name=name.replace(/[[]/,'\\[').replace(/[\]]/,'\\]');var regex=new RegExp('[\\?&]'+name+'=([^&#]*)');var results=regex.exec(location.search);return results===null?'':decodeURIComponent(results[1].replace(/\+/g,' '));},_this.changeCheckBox=function(evt){_this.setState({addressSelected:evt.target.value});},_this.handleSave=function(values){_this.setState({loading:true});var _this$state=_this.state,reasonSelected=_this$state.reasonSelected,identifier=_this$state.identifier,idAccount=_this$state.idAccount,optionSelected=_this$state.optionSelected,newIdentifier=_this$state.newIdentifier;var _this$props=_this.props,shoModalErro=_this$props.shoModalErro,fetchInactive=_this$props.fetchInactive,fetchReplace=_this$props.fetchReplace;if(optionSelected==='BLOQUEAR'){var data={codigoIdentificador:identifier,codigoConta:idAccount,motivoInativacaoIdentificador:reasonSelected.chave,motivoInativacaoIdentificadorDescricao:reasonSelected.descricao};fetchInactive(data).then(function(response){_this.setState({loading:false,idOrder:response.result,modalBlock:true});}).catch(function(error){console.log('error',error);error.json().then(function(reponse){shoModalErro(_ModalTypes.CONFIRM_UPDATE,{modalTitle:reponse.message||'Problemas ao bloquear sua veloeTag tente novamente mais tarde.',image:_contestacao2.default});_this.setState({loading:false});});});}else if(optionSelected==='POSSUO'){var _data={codigoIdentificador:identifier,codigoConta:idAccount,motivoInativacaoIdentificador:reasonSelected.chave,motivoInativacaoIdentificadorDescricao:reasonSelected.descricao,novoCodigoIdentificador:newIdentifier};fetchReplace(_data).then(function(response){console.log(response);_this.setState({loading:false,idOrder:response.result,modalReplace:true});}).catch(function(error){error.json().then(function(reponse){shoModalErro(_ModalTypes.CONFIRM_UPDATE,{modalTitle:reponse.message,image:_contestacao2.default});_this.setState({loading:false});});});}else if(optionSelected==='RECEBER'){var addressSelected=_this.state.addressSelected;var addressNew=null;if(addressSelected==='new'){var _values$=values[0],additionalInfo=_values$.additionalInfo,address=_values$.address,city=_values$.city,neighborhood=_values$.neighborhood,number=_values$.number,state=_values$.state,zipCode=_values$.zipCode;addressNew={cep:zipCode,logradouro:address,numero:number,complemento:additionalInfo||'',bairro:neighborhood,uf:state,cidade:city};}else{var _this$state$address=_this.state.address,cep=_this$state$address.cep,logradouro=_this$state$address.logradouro,numero=_this$state$address.numero,complemento=_this$state$address.complemento,bairro=_this$state$address.bairro,uf=_this$state$address.uf,cidade=_this$state$address.cidade;addressNew={cep:cep,logradouro:logradouro,numero:numero,complemento:complemento,bairro:bairro,uf:uf,cidade:cidade};}var _data2={codigoIdentificador:identifier,codigoConta:idAccount,motivoInativacaoIdentificador:reasonSelected.chave,motivoInativacaoIdentificadorDescricao:reasonSelected.descricao,endereco:addressNew};fetchReplace(_data2).then(function(response){_this.setState({loading:false,idOrder:response.result,modalReceive:true});}).catch(function(error){console.log('error',error);error.json().then(function(reponse){shoModalErro(_ModalTypes.CONFIRM_UPDATE,{modalTitle:reponse.message||'Problemas ao bloquear sua veloeTag tente novamente mais tarde.',image:_contestacao2.default});_this.setState({loading:false});});});}},_this.handleChange=function(e){_this.setState({optionSelected:e.currentTarget.value});},_this.handleChangeNewVeloeTag=function(value){var result=Object.keys(value).map(function(key){return[value[key]];});var valueFilter=result.splice(0,result.length-1).join('');_this.setState({newIdentifier:valueFilter});},_this.handleClick=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({modal:false});_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/identificadores');case 2:case'end':return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(BlockNewIdentifier,[{key:'componentDidMount',value:function componentDidMount(){var reasonList=this.props.reasonListBlock||this.state.reasonList;var reasonParam=this.getUrlParameter('option');var descriptionParam=this.getUrlParameter('description');var reasonSelected=descriptionParam?{chave:reasonParam,descricao:descriptionParam}:reasonList.filter(function(el){return el.chave===reasonParam;})[0];var identifier=this.props.match.params.identifierId;var idAccount=this.props.match.params.id;if(this.props.user&&!this.props.user.enderecos){this.props.history.push('/minha-veloe/'+idAccount+'/identificadores');return true;}var _props$user$enderecos=this.props.user.enderecos[0],cep=_props$user$enderecos.cep,uf=_props$user$enderecos.uf,cidade=_props$user$enderecos.cidade,bairro=_props$user$enderecos.bairro,logradouro=_props$user$enderecos.logradouro,numero=_props$user$enderecos.numero,complemento=_props$user$enderecos.complemento;this.setState({reasonList:reasonList,reasonSelected:reasonSelected,identifier:identifier,idAccount:idAccount,optionSelected:'',address:{cep:cep,logradouro:logradouro,numero:numero,complemento:complemento,bairro:bairro,uf:uf,cidade:cidade}});}},{key:'render',value:function render(){var _this3=this;var _props=this.props,history=_props.history,handleDelete=_props.handleDelete,saving=_props.saving,match=_props.match,_props$account=_props.account,account=_props$account===undefined?{}:_props$account;var _state=this.state,reasonSelected=_state.reasonSelected,identifier=_state.identifier,optionSelected=_state.optionSelected,loading=_state.loading,newIdentifier=_state.newIdentifier,addressSelected=_state.addressSelected,address=_state.address,modalBlock=_state.modalBlock,modalReceive=_state.modalReceive,modalReplace=_state.modalReplace,idOrder=_state.idOrder;var _account$wl=account.wl,isWhiteLabel=_account$wl===undefined?false:_account$wl;var listReasonsWithoutNewIdentifier=ListOptions.slice(1);return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:275}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Minhas Veloetags',back:history.goBack,__source:{fileName:_jsxFileName,lineNumber:276}}),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:277}},_react2.default.createElement(_gridStyled.Box,{width:[1,1],__source:{fileName:_jsxFileName,lineNumber:278}},_react2.default.createElement(_reactHelmet2.default,{title:_data3.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:279}}),_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:280}},_data3.title),_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:281}},_react2.default.createElement(_styles.ParagraphGray,{__source:{fileName:_jsxFileName,lineNumber:282}},'MOTIVO'),_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:283}},reasonSelected.descricao)),_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:285}},_react2.default.createElement(_styles.ParagraphGray,{__source:{fileName:_jsxFileName,lineNumber:286}},'VELOETAG A SER BLOQUEADA/SUBSTITUIDA'),_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:287}},identifier)),_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:289}},_react2.default.createElement(_gridStyled.Box,{width:[1,6/12],__source:{fileName:_jsxFileName,lineNumber:290}},_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:291}},_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:292}},'Selecione uma op\xE7\xE3o'),_react2.default.createElement(_BlockIdentifiersListOptions2.default,{list:isWhiteLabel?listReasonsWithoutNewIdentifier:ListOptions,handleChange:this.handleChange,optionSelected:optionSelected,handleChangeNewVeloeTag:this.handleChangeNewVeloeTag,newIdentifier:newIdentifier,__source:{fileName:_jsxFileName,lineNumber:293}})))),(optionSelected==='RECEBER'||optionSelected==='POSSUO')&&_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:304}},_react2.default.createElement(_gridStyled.Box,{width:[1,6/12],__source:{fileName:_jsxFileName,lineNumber:305}},_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:306}},reasonSelected.cobrar&&_react2.default.createElement('p',{__source:{fileName:_jsxFileName,lineNumber:308}},'Para substituir sua VeloeTag, ser\xE1 necess\xE1rio o pagamento do valor adicional de R$',(0,_utils.currencyParser)(reasonSelected.valor),' que ser\xE1 descontado do seu saldo atual.')))),optionSelected!=='RECEBER'&&_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:319}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,__source:{fileName:_jsxFileName,lineNumber:320}},_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],__source:{fileName:_jsxFileName,lineNumber:321}},_react2.default.createElement(_Button2.default,{buttonType:'white',onClick:function onClick(){return history.goBack();},text:'Cancelar',__source:{fileName:_jsxFileName,lineNumber:322}})),_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],ml:[0,30],mt:[20,0],__source:{fileName:_jsxFileName,lineNumber:324}},_react2.default.createElement(_Button2.default,{disabled:!optionSelected||loading,loading:loading,buttonType:'skyBlue',text:optionSelected==='POSSUO'?'Substituir':'Bloquear',onClick:function onClick(){return _this3.handleSave();},__source:{fileName:_jsxFileName,lineNumber:325}})))),optionSelected==='RECEBER'&&_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:337}},_react2.default.createElement(_gridStyled.Box,{width:[1],__source:{fileName:_jsxFileName,lineNumber:338}},_react2.default.createElement(_gridStyled.Flex,{align:'center',px:[0,0,0,0],__source:{fileName:_jsxFileName,lineNumber:339}},_react2.default.createElement(_gridStyled.Box,{width:[1,1],__source:{fileName:_jsxFileName,lineNumber:340}},_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:341}},_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:342}},'Confirme endere\xE7o de entrega')),_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:344}},_react2.default.createElement(_styles.BoxCep,{__source:{fileName:_jsxFileName,lineNumber:345}},_react2.default.createElement(_styles.CheckBoxCep,{type:'radio',value:'actual',checked:addressSelected==='actual',onChange:function onChange(e){return _this3.changeCheckBox(e);},__source:{fileName:_jsxFileName,lineNumber:346}}),_react2.default.createElement(_styles.CepText,{__source:{fileName:_jsxFileName,lineNumber:352}},address.logradouro,', ',address.numero,', ',address.complemento,' ',address.bairro,' - ',address.cidade,' - ',address.uf,' -',address.cep))),_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:358}},_react2.default.createElement(_styles.NewAddress,{focus:addressSelected==='new',__source:{fileName:_jsxFileName,lineNumber:359}},_react2.default.createElement(_styles.WrapperSelectNewAddress,{__source:{fileName:_jsxFileName,lineNumber:360}},_react2.default.createElement(_styles.NewAddressText,{__source:{fileName:_jsxFileName,lineNumber:361}},_react2.default.createElement(_styles.CheckBoxCep,{type:'radio',value:'new',checked:addressSelected==='new',onChange:function onChange(e){return _this3.changeCheckBox(e);},__source:{fileName:_jsxFileName,lineNumber:362}}),_react2.default.createElement(_styles.CepText,{__source:{fileName:_jsxFileName,lineNumber:368}},'Outro endere\xE7o de entrega'))),_react2.default.createElement(_styles.WrapperFormNewAddress,{__source:{fileName:_jsxFileName,lineNumber:371}},addressSelected==='new'?_react2.default.createElement(_OtherAddressForm2.default,{initialValues:{address:[]},onSubmit:function onSubmit(values){return _this3.handleSave(values.address);},onDelete:handleDelete,length:address?address.length:0,saving:saving,match:match,history:history,loadingButton:loading,disableButton:loading,__source:{fileName:_jsxFileName,lineNumber:373}}):null))),optionSelected==='RECEBER'&&addressSelected==='actual'&&_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:390}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,__source:{fileName:_jsxFileName,lineNumber:391}},_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],__source:{fileName:_jsxFileName,lineNumber:392}},_react2.default.createElement(_Button2.default,{buttonType:'white',onClick:function onClick(){return history.goBack();},text:'Cancelar',__source:{fileName:_jsxFileName,lineNumber:393}})),_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],ml:[0,30],mt:[20,0],__source:{fileName:_jsxFileName,lineNumber:399}},_react2.default.createElement(_Button2.default,{disabled:!optionSelected||loading,loading:loading,width:'185px',buttonType:'skyBlue',text:'Enviar Pedido',onClick:function onClick(){return _this3.handleSave();},__source:{fileName:_jsxFileName,lineNumber:400}})))))))))),modalBlock&&_react2.default.createElement(_BlockModal2.default,{handleClick:this.handleClick,idPedido:idOrder,__source:{fileName:_jsxFileName,lineNumber:419}}),modalReceive&&_react2.default.createElement(_ReceivedModal2.default,{handleClick:this.handleClick,idPedido:idOrder,__source:{fileName:_jsxFileName,lineNumber:420}}),modalReplace&&_react2.default.createElement(_BlockReplaceModal2.default,{handleClick:this.handleClick,idPedido:idOrder,__source:{fileName:_jsxFileName,lineNumber:421}}));}}]);return BlockNewIdentifier;}(_react2.default.Component);var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref3){var form=_ref3.form,reducer=_ref3.reducer;return{form:form,account:reducer.account,user:reducer.user,reasonListBlock:reducer.reasonsListBlock.reasons};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch){return{setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));},fetchInactive:function fetchInactive(data){return dispatch((0,_actions.fetchInactiveIdentifier)(data));},fetchReplace:function fetchReplace(data){return dispatch((0,_actions.fetchReplaceIdentifier)(data));},shoModalErro:function shoModalErro(imagem,infos){return dispatch((0,_actions3.showModal)(imagem,infos));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)((0,_reactRouterDom.withRouter)(BlockNewIdentifier));

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/BlockReplaceModal/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ModalBlue=__webpack_require__(188);var _ModalBlue2=_interopRequireDefault(_ModalBlue);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(1801);var _iconVeloeBackground=__webpack_require__(137);var _iconVeloeBackground2=_interopRequireDefault(_iconVeloeBackground);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddTagsModal=function(_React$Component){_inherits(AddTagsModal,_React$Component);function AddTagsModal(){_classCallCheck(this,AddTagsModal);return _possibleConstructorReturn(this,(AddTagsModal.__proto__||Object.getPrototypeOf(AddTagsModal)).apply(this,arguments));}_createClass(AddTagsModal,[{key:'render',value:function render(){var handleClick=this.props.handleClick;return _react2.default.createElement(_ModalBlue2.default,{backgroundImage:_iconVeloeBackground2.default,position:'right bottom',__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:15}},'Sua tag foi substitu\xEDda.'),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:16}}),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:17}},'Tudo certo, agora \xE9 s\xF3 colar a tag no para-brisa do ve\xEDculo e curtir o caminho livre.'),_react2.default.createElement(_styles.WrapperButton,{__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_Button2.default,{buttonType:'darkBlue',text:'Ok',onClick:function onClick(){return handleClick();},__source:{fileName:_jsxFileName,lineNumber:21}}))));}}]);return AddTagsModal;}(_react2.default.Component);exports.default=AddTagsModal;module.exports=exports['default'];

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Left=exports.Modal=exports.Overlay=undefined;var _templateObject=_taggedTemplateLiteral(['\n    background-image: none;\n    border-radius: 0;\n    left: 0;\n    height: 100vh;\n    min-width: calc(100vw - 48px);\n    padding: 24px;\n    top: 0;\n    transform: none;\n  '],['\n    background-image: none;\n    border-radius: 0;\n    left: 0;\n    height: 100vh;\n    min-width: calc(100vw - 48px);\n    padding: 24px;\n    top: 0;\n    transform: none;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n      margin-bottom: 24px;\n    '],['\n      margin-bottom: 24px;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _hexToRgba=__webpack_require__(187);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Overlay=exports.Overlay=_styledComponents2.default.div.withConfig({displayName:'styles__Overlay',componentId:'sc-hn19og-0'})(['background-color:',';height:100vh;width:100vw;position:fixed;left:0;top:0;z-index:99999;'],(0,_hexToRgba.hexToRgba)(_colors.darkBlue,0.64));var Modal=exports.Modal=_styledComponents2.default.section.withConfig({displayName:'styles__Modal',componentId:'sc-hn19og-1'})(['background:',' url(',') ',' no-repeat;border-radius:12px;box-shadow:0 12px 16px 0 rgba(42,34,100,0.64);left:50%;max-width:calc(100% - 40px);padding:50px;position:fixed;top:50%;transform:translate(-50%,-50%);',';h3{',';color:',';line-height:1.12;margin:0 0 16px;',';}'],_colors.lightBlue,function(_ref){var backgroundImage=_ref.backgroundImage;return backgroundImage;},function(_ref2){var position=_ref2.position;return position||'right center';},_media2.default.small(_templateObject),_types.title32GalanoBold,_colors.white,_media2.default.small(_templateObject2));var Left=exports.Left=_styledComponents2.default.div.withConfig({displayName:'styles__Left',componentId:'sc-hn19og-2'})(['max-width:100%;width:70%;height:100%;',';'],function(_ref3){var backgroundImage=_ref3.backgroundImage;return backgroundImage&&'\n      width: 328px;\n  ';});

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.WrapperButton=exports.Subtitle=exports.Text=exports.Title=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n    min-width: auto;\n    max-width: auto;\n  '],['\n    min-width: auto;\n    max-width: auto;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    ',';\n  '],['\n    ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 18px;\n  '],['\n    font-size: 18px;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-1oatc54-0'})(['min-width:596px;max-width:596px;width:100%;min-height:360px;display:flex;justify-content:space-around;flex-direction:column;',';'],_media2.default.small(_templateObject));var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-1oatc54-1'})(['',';color:',';margin:0 0 16px;max-width:422px;line-height:32px;',';'],_types.title32GalanoBold,_colors.white,_media2.default.small(_templateObject2,_types.title24GalanoBold));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1oatc54-2'})(['',';color:',';line-height:25px;margin:0 0 10px;max-width:550px;'],_types.txt16OpenSans,_colors.darkBlue);var Subtitle=exports.Subtitle=_styledComponents2.default.h2.withConfig({displayName:'styles__Subtitle',componentId:'sc-1oatc54-3'})(['',';color:',';font-size:24px;margin:0;',';'],_types.title24GalanoBold,_colors.darkBlue,_media2.default.small(_templateObject3));var WrapperButton=exports.WrapperButton=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButton',componentId:'sc-1oatc54-4'})(['display:block;margin-top:44px;']);

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/BlockModal/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ModalBlue=__webpack_require__(188);var _ModalBlue2=_interopRequireDefault(_ModalBlue);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(1803);var _iconVeloeBackground=__webpack_require__(137);var _iconVeloeBackground2=_interopRequireDefault(_iconVeloeBackground);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddTagsModal=function(_React$Component){_inherits(AddTagsModal,_React$Component);function AddTagsModal(){_classCallCheck(this,AddTagsModal);return _possibleConstructorReturn(this,(AddTagsModal.__proto__||Object.getPrototypeOf(AddTagsModal)).apply(this,arguments));}_createClass(AddTagsModal,[{key:'render',value:function render(){var handleClick=this.props.handleClick;return _react2.default.createElement(_ModalBlue2.default,{backgroundImage:_iconVeloeBackground2.default,position:'right bottom',__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:15}},'Sua VeloeTag foi bloqueada'),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:16}},'Por enquanto, voc\xEA n\xE3o vai conseguir ter acesso livre aos locais conveniados, mas fique tranquilo. Voc\xEA pode pedir uma nova VeloeTag para curtir o que realmente importa.'),_react2.default.createElement(_styles.WrapperButton,{__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_Button2.default,{buttonType:'darkBlue',text:'Ok',onClick:function onClick(){return handleClick();},__source:{fileName:_jsxFileName,lineNumber:22}}))));}}]);return AddTagsModal;}(_react2.default.Component);exports.default=AddTagsModal;module.exports=exports['default'];

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.WrapperButton=exports.Subtitle=exports.Text=exports.Title=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n    min-width: auto;\n    max-width: auto;\n  '],['\n    min-width: auto;\n    max-width: auto;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    ',';\n  '],['\n    ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 18px;\n  '],['\n    font-size: 18px;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-kea9hf-0'})(['min-width:596px;max-width:596px;width:100%;min-height:360px;display:flex;justify-content:space-around;flex-direction:column;',';'],_media2.default.small(_templateObject));var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-kea9hf-1'})(['',';color:',';margin:0 0 16px;max-width:422px;line-height:32px;',';'],_types.title32GalanoBold,_colors.white,_media2.default.small(_templateObject2,_types.title24GalanoBold));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-kea9hf-2'})(['',';color:',';line-height:25px;margin:0 0 10px;max-width:550px;'],_types.txt16OpenSans,_colors.darkBlue);var Subtitle=exports.Subtitle=_styledComponents2.default.h2.withConfig({displayName:'styles__Subtitle',componentId:'sc-kea9hf-3'})(['',';color:',';font-size:24px;margin:0;',';'],_types.title24GalanoBold,_colors.darkBlue,_media2.default.small(_templateObject3));var WrapperButton=exports.WrapperButton=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButton',componentId:'sc-kea9hf-4'})(['display:block;margin-top:44px;']);

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ReceivedModal/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ModalBlue=__webpack_require__(188);var _ModalBlue2=_interopRequireDefault(_ModalBlue);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(1805);var _iconVeloeBackground=__webpack_require__(137);var _iconVeloeBackground2=_interopRequireDefault(_iconVeloeBackground);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddTagsModal=function(_React$Component){_inherits(AddTagsModal,_React$Component);function AddTagsModal(){_classCallCheck(this,AddTagsModal);return _possibleConstructorReturn(this,(AddTagsModal.__proto__||Object.getPrototypeOf(AddTagsModal)).apply(this,arguments));}_createClass(AddTagsModal,[{key:'render',value:function render(){var handleClick=this.props.handleClick;return _react2.default.createElement(_ModalBlue2.default,{backgroundImage:_iconVeloeBackground2.default,position:'right bottom',__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:15}},'Sua VeloeTag foi bloqueada'),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:16}},'Agora este ve\xEDculo n\xE3o vai mais ter acesso livre aos locais conveniados. Voc\xEA receber\xE1 sua VeloeTag em at\xE9 ',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:18}},'10 dias \xFAteis'),', no endere\xE7o solicitado. Ela dever\xE1 ser recebida por uma pessoa maior de 18 anos com documento com foto em m\xE3os. Fique tranquilo, a mensalidade ser\xE1 cobrada apenas ap\xF3s voc\xEA receber e ativar a sua VeloeTag.'),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:22}}),_react2.default.createElement(_styles.WrapperButton,{__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement(_Button2.default,{buttonType:'darkBlue',text:'Ok',onClick:function onClick(){return handleClick();},__source:{fileName:_jsxFileName,lineNumber:25}}))));}}]);return AddTagsModal;}(_react2.default.Component);exports.default=AddTagsModal;module.exports=exports['default'];

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.WrapperButton=exports.Subtitle=exports.Text=exports.Title=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n    min-width: auto;\n    max-width: auto;\n  '],['\n    min-width: auto;\n    max-width: auto;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    ',';\n  '],['\n    ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 18px;\n  '],['\n    font-size: 18px;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-k729zi-0'})(['min-width:596px;max-width:596px;width:100%;min-height:360px;display:flex;justify-content:space-around;flex-direction:column;',';'],_media2.default.small(_templateObject));var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-k729zi-1'})(['',';color:',';margin:0 0 16px;max-width:422px;line-height:32px;',';'],_types.title32GalanoBold,_colors.white,_media2.default.small(_templateObject2,_types.title24GalanoBold));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-k729zi-2'})(['',';color:',';line-height:25px;margin:0 0 10px;max-width:550px;'],_types.txt16OpenSans,_colors.darkBlue);var Subtitle=exports.Subtitle=_styledComponents2.default.h2.withConfig({displayName:'styles__Subtitle',componentId:'sc-k729zi-3'})(['',';color:',';font-size:24px;margin:0;',';'],_types.title24GalanoBold,_colors.darkBlue,_media2.default.small(_templateObject3));var WrapperButton=exports.WrapperButton=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButton',componentId:'sc-k729zi-4'})(['display:block;margin-top:44px;']);

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/BlockIdentifiersListOptions/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _reactRouterDom=__webpack_require__(15);var _aleloLogic=__webpack_require__(12);var _Radio=__webpack_require__(136);var _Radio2=_interopRequireDefault(_Radio);var _TextInput=__webpack_require__(101);var _TextInput2=_interopRequireDefault(_TextInput);var _styles=__webpack_require__(610);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var renderRadio=function renderRadio(_ref){var input=_ref.input,label=_ref.label;return _react2.default.createElement(_Radio2.default,_extends({},input,{label:label,__source:{fileName:_jsxFileName,lineNumber:12}}));};var renderOtherMotive=function renderOtherMotive(_ref2){var placeholder=_ref2.placeholder,input=_ref2.input,onChange=_ref2.onChange,value=_ref2.value,_ref2$meta=_ref2.meta,touched=_ref2$meta.touched,error=_ref2$meta.error;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement(_styles.ParagraphGrayLabel,{__source:{fileName:_jsxFileName,lineNumber:16}},'QUAL O N\xDAMERO DA NOVA VELOETAG?'),_react2.default.createElement(_TextInput2.default,_extends({},input,{placeholder:placeholder,maxlength:'10',errorMessage:touched&&error,__source:{fileName:_jsxFileName,lineNumber:17}})));};var BlockIdentifiersListOptions=function BlockIdentifiersListOptions(props){var list=props.list,handleChange=props.handleChange,optionSelected=props.optionSelected,handleChangeNewVeloeTag=props.handleChangeNewVeloeTag;return _react2.default.createElement(_gridStyled.Box,{mt:15,__source:{fileName:_jsxFileName,lineNumber:30}},_react2.default.createElement('form',{onSubmit:function onSubmit(){},__source:{fileName:_jsxFileName,lineNumber:31}},list&&list.map(function(item){return _react2.default.createElement(_gridStyled.Box,{mb:10,key:item.chave,__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:item.descricao,name:'option',value:item.chave,type:'radio',onChange:function onChange(e){return handleChange(e);},__source:{fileName:_jsxFileName,lineNumber:35}}));}),optionSelected==='POSSUO'&&_react2.default.createElement(_gridStyled.Box,{mb:20,__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_reduxForm.Field,{component:renderOtherMotive,placeholder:'Digite aqui',name:'novoCodigoIdentificador',onChange:function onChange(e){return handleChangeNewVeloeTag(e);},validate:_aleloLogic.utils.identifierValidate,__source:{fileName:_jsxFileName,lineNumber:47}}))));};exports.default=(0,_reduxForm.reduxForm)({form:'formBlockIdentifierListOptions',destroyOnUnmount:true})((0,_reactRouterDom.withRouter)(BlockIdentifiersListOptions));module.exports=exports['default'];

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/AddressFormOtherSection/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(1808);var _data=__webpack_require__(1809);var _renderInputs=__webpack_require__(44);var _parseCombo=__webpack_require__(392);var _actions=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fetchZipCode=_aleloLogic.actions.fetchZipCode;var getStates=_aleloLogic.services.getStates,getCitiesFromState=_aleloLogic.services.getCitiesFromState;var AddressFormSection=function(_Component){_inherits(AddressFormSection,_Component);function AddressFormSection(props){_classCallCheck(this,AddressFormSection);var _this=_possibleConstructorReturn(this,(AddressFormSection.__proto__||Object.getPrototypeOf(AddressFormSection)).call(this,props));_initialiseProps.call(_this);_this.state={states:[],formStatus:_this.createAllIntialFormStatus(props)};return _this;}_createClass(AddressFormSection,[{key:'render',value:function render(){var _this2=this;var history=this.props.history;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:210}},this.props.fields&&this.props.fields.map(function(field,index){var formStatus=_this2.state.formStatus[index]||{};// primeira chamada initialValues está undefined
var disabled=formStatus.isNew&&formStatus.lastSearch===''||formStatus.isSearchingCep||_this2.props.saving;return _react2.default.createElement('div',{key:field,__source:{fileName:_jsxFileName,lineNumber:220}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,width:[1],mb:[0,32],key:field,__source:{fileName:_jsxFileName,lineNumber:221}},_react2.default.createElement(_gridStyled.Box,{width:3/12,mb:3,__source:{fileName:_jsxFileName,lineNumber:222}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderZipCodeInput,label:_data.labels.zipCode,validate:_aleloLogic.utils.cepValidate,normalize:_aleloLogic.utils.cepMask,onBlur:_this2.autoCompleteAddress(index),name:field+'.zipCode',type:'text',isRequired:true,disabled:formStatus.isSearchingCep||_this2.props.saving,loading:formStatus.isSearchingCep,__source:{fileName:_jsxFileName,lineNumber:223}})),_react2.default.createElement(_gridStyled.Box,{width:6/12,px:3,mb:3,__source:{fileName:_jsxFileName,lineNumber:236}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.address,validate:_aleloLogic.utils.emptyFieldValidate,name:field+'.address',type:'text',isRequired:true,disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:237}})),_react2.default.createElement(_gridStyled.Box,{width:3/12,mb:3,__source:{fileName:_jsxFileName,lineNumber:247}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.number,validate:_aleloLogic.utils.emptyFieldValidate,normalize:_aleloLogic.utils.numberMask,name:field+'.number',type:'text',isRequired:true,disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:248}})),_react2.default.createElement(_gridStyled.Box,{width:8/12,pr:3,mb:3,__source:{fileName:_jsxFileName,lineNumber:259}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.additionalInfo,name:field+'.additionalInfo',type:'text',disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:260}})),_react2.default.createElement(_gridStyled.Box,{width:4/12,mb:3,__source:{fileName:_jsxFileName,lineNumber:268}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.neighborhood,validate:_aleloLogic.utils.emptyFieldValidate,name:field+'.neighborhood',type:'text',isRequired:true,disabled:disabled,__source:{fileName:_jsxFileName,lineNumber:269}})),_react2.default.createElement(_gridStyled.Box,{width:6/12,pr:3,mb:3,__source:{fileName:_jsxFileName,lineNumber:279}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderSelectField,label:_data.labels.state,placeholder:_data.labels.select,name:field+'.state',options:_this2.state.states,isRequired:true,disabled:true,__source:{fileName:_jsxFileName,lineNumber:280}})),_react2.default.createElement(_gridStyled.Box,{width:6/12,mb:3,__source:{fileName:_jsxFileName,lineNumber:290}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderSelectField,label:_data.labels.city,validate:_aleloLogic.utils.emptyFieldValidate,placeholder:_data.labels.select,name:field+'.city',options:formStatus.cities||[],isRequired:true,disabled:true,__source:{fileName:_jsxFileName,lineNumber:291}}))),_react2.default.createElement(_styles.ButtonContainer,{__source:{fileName:_jsxFileName,lineNumber:303}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,__source:{fileName:_jsxFileName,lineNumber:304}},_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],__source:{fileName:_jsxFileName,lineNumber:305}},_react2.default.createElement(_Button2.default,{buttonType:'white',onClick:function onClick(){return history.goBack();},text:'Cancelar',__source:{fileName:_jsxFileName,lineNumber:306}})),_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],ml:[0,30],mt:[20,0],__source:{fileName:_jsxFileName,lineNumber:308}},_react2.default.createElement(_Button2.default,{text:'Enviar Pedido',width:'185px',type:'submit',loading:_this2.props.loadingButton,disabled:_this2.props.saving||_this2.props.disableButton,__source:{fileName:_jsxFileName,lineNumber:309}})))));}));}}]);return AddressFormSection;}(_react.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.componentDidMount=function(){_this3.retrieveStates();// if (!this.localControl.isCitiesInit) {
//   this.fetchCitiesForEachForm(this.props)
// }
_this3.addAddress();};this.componentWillReceiveProps=function(props,param2){if(!_this3.localControl.isCitiesInit){_this3.fetchCitiesForEachForm(props);}if(!_this3.localControl.isFormStatusInit){var allStatus=_this3.createAllIntialFormStatus(props);if(allStatus.length>0){_this3.setState({formStatus:allStatus});}}};this.localControl={isFormStatusInit:false,isCitiesInit:false};this.createAllIntialFormStatus=function(props){var allFormStatus=[];for(var i=0;i<props.fields.length;i+=1){var status=_this3.createEmptyFormStatus(false);status.lastSearch=props.fields.get(i).zipCode;allFormStatus.push(status);}_this3.localControl.isFormStatusInit=props.fields.length>0;return allFormStatus;};this.fetchCitiesForEachForm=function(props){var _loop=function _loop(i){_this3.updateFormStatus(i,{isSearchingCep:true});getCitiesFromState({state:props.fields.get(i).state}).then(function(){var address=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cities=(0,_parseCombo.parseCities)(address);_this3.updateFormStatus(i,{isSearchingCep:false,cities:cities});});};for(var i=0;i<props.fields.length;i+=1){_loop(i);}_this3.localControl.isCitiesInit=props.fields.length>0;};this.createEmptyFormStatus=function(isNew){return{lastSearch:'',isSearchingCep:false,isNew:isNew,cities:[]};};this.checkboxNormalize=function(index){return function(value){var newValue=!!value;var target=index===0?1:0;_this3.props.fields.get(target).mail=!newValue;return newValue;};};this.resetPage=function(index){var fieldValues=_this3.props.fields.get(index);var fielsToPopulate={address:'',number:'',additionalInfo:'',neighborhood:'',state:'',city:'',zipCode:''};_this3.props.fields.remove(index);_this3.props.fields.insert(index,_extends({},fieldValues,fielsToPopulate));};this.autoCompleteAddress=function(index){return function(event,oldValue,newValue){var formStatus=_this3.state.formStatus[index];if(newValue&&newValue.length>=9&&newValue!==formStatus.lastSearch){_this3.updateFormStatus(index,{isSearchingCep:true});var fieldValues=_this3.props.fields.get(index);var data={zip_code:newValue};_this3.props.getAddressFromZipCode(data).then(function(){var address=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var fielsToPopulate={address:address.logradouro,number:'',additionalInfo:'',neighborhood:address.bairro,state:address.uf,city:address.cidade};_this3.props.fields.remove(index);_this3.props.fields.insert(index,_extends({},fieldValues,fielsToPopulate));_this3.updateFormStatus(index,{lastSearch:newValue});_this3.retrieveCities(index,address.uf);}).catch(function(e){console.log('Erro ao consultar CEP',e);_this3.resetPage(index);_this3.updateFormStatus(index,{isSearchingCep:false});_this3.props.showErrorModal();});}};};this.retrieveStates=function(){getStates().then(function(address){var states=(0,_parseCombo.parseStates)(address);_this3.setState({states:states});});};this.retrieveCities=function(index,state){getCitiesFromState({state:state}).then(function(){var address=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var cities=(0,_parseCombo.parseCities)(address);_this3.updateFormStatus(index,{isSearchingCep:false,cities:cities});});};this.changeComboStates=function(index){return function(event,oldValue,newValue){_this3.retrieveCities(index,newValue);};};this.removeAddress=function(index){var isCorrespondence=_this3.props.fields.get(index).mail;var key=_this3.props.fields.get(index).key;_this3.props.onDelete(key,isCorrespondence).then(function(){_this3.props.fields.pop();_this3.props.fields.get(0).mail=true;_this3.state.formStatus.pop();});};this.addAddress=function(){var allFormStatus=_this3.state.formStatus;allFormStatus.push(_this3.createEmptyFormStatus(true));_this3.setState({formStatus:allFormStatus});_this3.props.fields.push({mail:false});};this.updateFormStatus=function(index,newData){var allFormStatus=_this3.state.formStatus;var oldData=allFormStatus[index];allFormStatus[index]=_extends({},oldData,newData);_this3.setState({formStatus:allFormStatus});};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAddressFromZipCode:function getAddressFromZipCode(zipCode){return dispatch(fetchZipCode(zipCode));},showErrorModal:function showErrorModal(){return dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,modalDescription:_data.descriptionModalError,image:_contestacao2.default}));}};};exports.default=(0,_reactRedux.connect)(null,mapDispatchToProps)(AddressFormSection);

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonContainer=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ButtonContainer=exports.ButtonContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonContainer',componentId:'sc-1laugxd-0'})(['margin:-20px 0 20px;display:flex;justify-content:space-between;align-items:center;']);

/***/ }),
/* 1809 */
/***/ (function(module, exports) {

module.exports = {"cities":[],"states":[{"value":"RJ","label":"RJ"},{"value":"SP","label":"SP"},{"value":"MG","label":"MG"},{"value":"SC","label":"SC"},{"value":"RS","label":"RS"}],"labels":{"zipCode":"Cep*","address":"Rua","number":"Número","additionalInfo":"Complemento","neighborhood":"Bairro","state":"Estado","city":"Cidade","correspondence":"Esse é o endereço para envio de correspondência","select":" "},"errorMessages":{"emptyField":"Campo obrigatório"},"secondaryAddressTitle":"Endereço secundário","excludeLink":"Excluir","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","titleModalError":"Ops!","descriptionModalError":"CEP informado inválido. Confira as informações e tente novamente."}

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Bloquear / Substituir VeloeTag","title":"Bloquear / Substituir VeloeTag","text":"Fazendo o bloqueio, você não vai mais ter acesso livre aos locais conveniados.","optionsSubtitle":"Conte para a gente o motivo do bloqueio / substituição:"}

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateEmptyWithLoading=__webpack_require__(1812);var _TemplateEmptyWithLoading2=_interopRequireDefault(_TemplateEmptyWithLoading);var _EditIdentifiers=__webpack_require__(1813);var _EditIdentifiers2=_interopRequireDefault(_EditIdentifiers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id/identificador/:identifierId/alterar',component:_TemplateEmptyWithLoading2.default,routes:[{path:'/minha-veloe/:id/identificador/:identifierId/alterar',exact:true,component:_EditIdentifiers2.default}]};module.exports=exports['default'];

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/templates/TemplateEmptyWithLoading/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _routes=__webpack_require__(96);var _PageLoader=__webpack_require__(88);var _PageLoader2=_interopRequireDefault(_PageLoader);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function TemplateEmpty(_ref){var routes=_ref.routes;return _react2.default.createElement(_PageLoader2.default,{__source:{fileName:_jsxFileName,lineNumber:7}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:8}},routes.map(function(route){return _react2.default.createElement(_routes.RouteWithSubRoutes,_extends({key:route.path},route,{__source:{fileName:_jsxFileName,lineNumber:8}}));})));}exports.default=TemplateEmpty;module.exports=exports['default'];

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditIdentifiers/index.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _actions=__webpack_require__(13);var _actions2=__webpack_require__(36);var _actions3=__webpack_require__(18);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);var _ModalTypes=__webpack_require__(20);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _data=__webpack_require__(1814);var _ManageInfoModal=__webpack_require__(189);var _ManageInfoModal2=_interopRequireDefault(_ManageInfoModal);var _EditIdentifierHeader=__webpack_require__(1823);var _EditIdentifierHeader2=_interopRequireDefault(_EditIdentifierHeader);var _ManageInfoList=__webpack_require__(1825);var _ManageInfoList2=_interopRequireDefault(_ManageInfoList);var _ManageInfoHistoricList=__webpack_require__(1828);var _ManageInfoHistoricList2=_interopRequireDefault(_ManageInfoHistoricList);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Services and Actions
// UIComponents
// Components
var EditIdentifiers=function(_Component){_inherits(EditIdentifiers,_Component);function EditIdentifiers(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EditIdentifiers);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EditIdentifiers.__proto__||Object.getPrototypeOf(EditIdentifiers)).call.apply(_ref,[this].concat(args))),_this),_this.state={vehicle:{},rowActive:null,identifier:{},selectValue:'INFORMACAO_1',idIdentifierDelete:null,isModalOpen:false,modalType:'edit',loadingDelete:false},_this.setVehicle=function(){var _this$props=_this.props,vehicles=_this$props.vehicles,match=_this$props.match,fetchGetManageInfsHistory=_this$props.fetchGetManageInfsHistory,fetchGetManageInfsActive=_this$props.fetchGetManageInfsActive;var _match$params=match.params,identifierId=_match$params.identifierId,id=_match$params.id;var vehicle=vehicles.find(function(obj){return obj.codIdentificador===identifierId;});if(vehicle){_this.setState({vehicle:vehicle},function(){fetchGetManageInfsActive(id,vehicle.veiculo.placa);fetchGetManageInfsHistory(id,vehicle.veiculo.placa);});}},_this.onChangeSelect=function(selectValue){_this.setState({selectValue:selectValue});},_this.onRowClick=function(id){var rowActive=_this.state.rowActive;_this.setState({rowActive:rowActive!==null?null:id});},_this.onRowEdit=function(identifier){var vehicle=_extends({veiculo:{placa:identifier.placa}},identifier);_this.setState({identifier:vehicle,isModalOpen:true,modalType:'edit'});},_this.onRowDelete=function(item){_this.setState({loadingDelete:true});var data={id:item.id,tipoInfo:item.tipoInfo,descricao:item.descricaoAtual,placa:item.placa,conta:item.conta,dataInicioVigencia:item.dataInicioVigencia,codIdentificador:item.codIdentificador};_this.props.deleteManageInf(data).then(function(){_this.setVehicle();_this.setState({loadingDelete:false});}).catch(function(){_this.props.dispatch((0,_actions3.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,image:_contestacao2.default}));_this.setState({loadingDelete:false});});},_this.toggleModal=function(){_this.setState(function(prevState){if(prevState.isModalOpen){_this.setVehicle();}return{isModalOpen:!prevState.isModalOpen};});},_this.onAddInf=function(){_this.setState({isModalOpen:true,modalType:'include',identifier:_this.state.vehicle});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EditIdentifiers,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,vehicles=_props.vehicles,fetchGetVehicles=_props.fetchGetVehicles,fetchLogout=_props.fetchLogout,setLoading=_props.setLoading,history=_props.history,match=_props.match;var id=match.params.id;if(vehicles.length===0){setLoading(true);return fetchGetVehicles(id).then(function(resp){if(resp&&(resp.status===401||resp.status===403)){fetchLogout();history.push('/conta/login');}setLoading(false);});}this.setVehicle();}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var vehicles=this.props.vehicles;if(vehicles!==prevProps.vehicles&&vehicles.length>0){this.setVehicle();}}},{key:'render',value:function render(){var _state=this.state,vehicle=_state.vehicle,rowActive=_state.rowActive,selectValue=_state.selectValue,isModalOpen=_state.isModalOpen,identifier=_state.identifier,loadingDelete=_state.loadingDelete;var _props2=this.props,manageInfsReducer=_props2.manageInfsReducer,match=_props2.match;var manageInfs=manageInfsReducer.manageInfs,manageInfsHistory=manageInfsReducer.manageInfsHistory;var id=match.params.id;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:134}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:135}}),_react2.default.createElement(_ImersiveHeader2.default,{text:'Minhas VeloeTags',url:'/minha-veloe/'+id+'/identificadores',__source:{fileName:_jsxFileName,lineNumber:136}}),_react2.default.createElement(_EditIdentifierHeader2.default,{vehicle:vehicle,__source:{fileName:_jsxFileName,lineNumber:138}}),_react2.default.createElement(_ManageInfoList2.default,{data:manageInfs,rowActived:rowActive,onRowClick:this.onRowClick,onDelete:this.onRowDelete,onEdit:this.onRowEdit,onAddInf:this.onAddInf,valueSelect:selectValue,onChangeSelect:this.onChangeSelect,toggleModal:this.toggleModal,loadingDelete:loadingDelete,__source:{fileName:_jsxFileName,lineNumber:140}}),_react2.default.createElement(_ManageInfoHistoricList2.default,{data:manageInfsHistory,__source:{fileName:_jsxFileName,lineNumber:153}}),isModalOpen&&_react2.default.createElement(_ManageInfoModal2.default,{isOpen:isModalOpen,toggleModal:this.toggleModal,modalStart:this.state.modalType,vehicle:identifier,__source:{fileName:_jsxFileName,lineNumber:156}}));}}]);return EditIdentifiers;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{vehicles:reducer.dashboardVehicles,manageInfsReducer:reducer.manageInfs};};var dispatch=function dispatch(_dispatch){return _dispatch;};exports.default=(0,_reactRedux.connect)(mapStateToProps,{setLoading:_actions2.setLoading,fetchLogout:_actions.fetchLogout,fetchGetVehicles:_actions.fetchGetVehicles,fetchGetManageInfsActive:_actions.fetchGetManageInfsActive,deleteManageInf:_actions.deleteManageInf,fetchGetManageInfsHistory:_actions.fetchGetManageInfsHistory,dispatch:dispatch})(EditIdentifiers);module.exports=exports['default'];

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Editar Informações Gerenciais","titleModalError":"Erro ao excluir informação"}

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SimpleModal=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Modal/Modal.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _reactTransitionGroup=__webpack_require__(363);var _gridStyled=__webpack_require__(8);var _Icon=__webpack_require__(31);var _Button=__webpack_require__(155);var _Button2=_interopRequireDefault(_Button);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _styles=__webpack_require__(1816);var _data=__webpack_require__(1817);var _data2=_interopRequireDefault(_data);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Fade=function Fade(_ref){var isOpen=_ref.isOpen,children=_ref.children;return _react2.default.createElement(_reactTransitionGroup.Transition,{'in':isOpen,timeout:400,__source:{fileName:_jsxFileName,lineNumber:25}},function(state){return(0,_react.cloneElement)(children,{state:state});});};var Modal=function(_Component){_inherits(Modal,_Component);function Modal(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,Modal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=Modal.__proto__||Object.getPrototypeOf(Modal)).call.apply(_ref2,[this].concat(args))),_this),_this.state={isOpen:true},_this.close=function(){_this.setState({isOpen:!_this.state.isOpen});setTimeout(function(){_this.props.hideModal();},400);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Modal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,description=_props.description,image=_props.image,title=_props.title,children=_props.children,compact=_props.compact,background=_props.background,modalBlue=_props.modalBlue,maxWidth=_props.maxWidth,noPadding=_props.noPadding,accountType=_props.accountType,confirmButtonLabel=_props.confirmButtonLabel;return _react2.default.createElement(Fade,{isOpen:this.state.isOpen,__source:{fileName:_jsxFileName,lineNumber:55}},_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:56}},_react2.default.createElement(Fade,{isOpen:this.state.isOpen,__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_styles.Content,{maxWidth:maxWidth,__source:{fileName:_jsxFileName,lineNumber:58}},_react2.default.createElement(_styles.ModalContainer,{background:background,__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_styles.ModalContent,{compact:compact,noPadding:noPadding,__source:{fileName:_jsxFileName,lineNumber:60}},title&&_react2.default.createElement(_gridStyled.Box,{mb:['2.188rem',compact?'1.5rem':'3.125rem'],__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement(_styles.ModalTitle,{compact:compact,__source:{fileName:_jsxFileName,lineNumber:63}},title)),description&&_react2.default.createElement(_gridStyled.Box,{mb:['2.188rem','3.125rem'],__source:{fileName:_jsxFileName,lineNumber:67}},_react2.default.createElement(_styles.ModalDescription,{__source:{fileName:_jsxFileName,lineNumber:68}},description)),children&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:71}},children),image&&_react2.default.createElement(_Hide2.default,{className:'feedback-image',at:'large',mb:'2.813rem',__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement(_styles.ModalIllustration,{src:image,__source:{fileName:_jsxFileName,lineNumber:74}})),this.props.onConfirm&&_react2.default.createElement(_Button2.default,{buttonType:'transparent',text:confirmButtonLabel||_data2.default.confirmBtn,onClick:this.props.onConfirm,__source:{fileName:_jsxFileName,lineNumber:78}})),image&&_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:86}},_react2.default.createElement(_styles.ModalIllustration,{accountType:accountType,src:image,__source:{fileName:_jsxFileName,lineNumber:87}})),_react2.default.createElement(_styles.Close,{onClick:function onClick(){return _this2.close();},__source:{fileName:_jsxFileName,lineNumber:90}},_react2.default.createElement(_Icon.Icon,{icon:'modal-close',height:'1.125rem',width:'1.125rem',viewBox:'0 0 21 21',__source:{fileName:_jsxFileName,lineNumber:91}}))))),_react2.default.createElement(_styles.Overlay,{onClick:function onClick(){return _this2.close();},modalBlue:modalBlue,__source:{fileName:_jsxFileName,lineNumber:96}})));}}]);return Modal;}(_react.Component);var SimpleModal=exports.SimpleModal=function(_Component2){_inherits(SimpleModal,_Component2);function SimpleModal(){var _ref3;var _temp2,_this3,_ret2;_classCallCheck(this,SimpleModal);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this3=_possibleConstructorReturn(this,(_ref3=SimpleModal.__proto__||Object.getPrototypeOf(SimpleModal)).call.apply(_ref3,[this].concat(args))),_this3),_this3.state={isOpen:true},_this3.close=function(){_this3.setState({isOpen:!_this3.state.isOpen});setTimeout(function(){_this3.props.hideModal();},400);},_temp2),_possibleConstructorReturn(_this3,_ret2);}_createClass(SimpleModal,[{key:'render',value:function render(){var isOpen=this.state.isOpen;var children=this.props.children;var _props2=this.props,maxWidth=_props2.maxWidth,minHeight=_props2.minHeight,borderRadius=_props2.borderRadius;return _react2.default.createElement(Fade,{isOpen:isOpen,__source:{fileName:_jsxFileName,lineNumber:118}},_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:119}},_react2.default.createElement(Fade,{isOpen:isOpen,__source:{fileName:_jsxFileName,lineNumber:120}},_react2.default.createElement(_styles.Content,{maxWidth:maxWidth||400,__source:{fileName:_jsxFileName,lineNumber:121}},_react2.default.createElement(_styles.ModalSimpleContainer,{borderRadius:borderRadius||20,minHeight:minHeight||440,__source:{fileName:_jsxFileName,lineNumber:122}},children)))));}}]);return SimpleModal;}(_react.Component);Modal.defaultProps={title:null,onConfirm:null,hideModal:null};Modal.propTypes={title:_propTypes.string,onConfirm:_propTypes.func,hideModal:_propTypes.func};exports.default=Modal;

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Close=exports.ModalDescription=exports.ModalTitle=exports.ModalIllustration=exports.ModalContent=exports.ModalSimpleContainer=exports.ModalContainer=exports.Wrapper=exports.Content=exports.Overlay=undefined;var _templateObject=_taggedTemplateLiteral(['\n      max-width: ',';\n  '],['\n      max-width: ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    border-radius: ',';\n    box-shadow: 0 ',' ',' 0 rgba(0, 0, 0, 0.12);\n    height: auto;\n    min-height: ',';\n  '],['\n    border-radius: ',';\n    box-shadow: 0 ',' ',' 0 rgba(0, 0, 0, 0.12);\n    height: auto;\n    min-height: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n      ','\n  '],['\n      ','\n  ']),_templateObject4=_taggedTemplateLiteral(['\n  display: block;\n    max-height: 88%;\n    position: absolute;\n    right: ',';\n    top: 56%;\n    transform: translateY(-50%) translateX(19%);\n  '],['\n  display: block;\n    max-height: 88%;\n    position: absolute;\n    right: ',';\n    top: 56%;\n    transform: translateY(-50%) translateX(19%);\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    display: block;\n    max-height: 75%;\n    position: absolute;\n    right: ',';\n    top: 50%;\n    transform: translateY(-50%);\n    width: auto;\n  '],['\n    display: block;\n    max-height: 75%;\n    position: absolute;\n    right: ',';\n    top: 50%;\n    transform: translateY(-50%);\n    width: auto;\n  ']),_templateObject6=_taggedTemplateLiteral(['\n  font-size: ',';\n    line-height: 1.04;\n    max-width: ',';\n    text-align: left;\n  '],['\n  font-size: ',';\n    line-height: 1.04;\n    max-width: ',';\n    text-align: left;\n  ']),_templateObject7=_taggedTemplateLiteral(['\n    text-align: left;\n  '],['\n    text-align: left;\n  ']),_templateObject8=_taggedTemplateLiteral(['\n    right: ',';\n    top: ',';\n  '],['\n    right: ',';\n    top: ',';\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _hexToRgba=__webpack_require__(187);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var showModalContent=(0,_styledComponents.keyframes)(['0%{opacity:0;transform:translateY(',') scale(.95);}100%{opacity:1;transform:translateY(0) scale(1);}'],(0,_rem2.default)('30px'));var hideModalContent=(0,_styledComponents.keyframes)(['0%{opacity:1;transform:translateY(0) scale(1);}100%{opacity:0;transform:translateY(',') scale(.95);}'],(0,_rem2.default)('30px'));var showModal=(0,_styledComponents.keyframes)(['0%{opacity:0;}100%{opacity:1;}']);var hideModal=(0,_styledComponents.keyframes)(['0%{opacity:1;}100%{opacity:0;}']);var Overlay=exports.Overlay=_styledComponents2.default.div.withConfig({displayName:'styles__Overlay',componentId:'sc-18ngxmb-0'})(['align-items:center;background:',';bottom:0;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0;'],function(_ref){var modalBlue=_ref.modalBlue;return modalBlue?(0,_hexToRgba.hexToRgba)(_colors.darkBlue,0.64):'rgba(0, 0, 0, 0.15)';});var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-18ngxmb-1'})(['opacity:0;position:relative;transform-origin:bottom;transition:0.4s;z-index:1;width:100%;',';',';'],function(_ref2){var state=_ref2.state;switch(state){case'entered':return(0,_styledComponents.css)(['animation:0.4s ',' forwards;'],showModalContent);case'exiting':return(0,_styledComponents.css)(['animation:0.4s ',' forwards;'],hideModalContent);case'exited':return(0,_styledComponents.css)(['display:none;']);default:return(0,_styledComponents.css)(['display:block;']);}},_media2.default.large(_templateObject,function(_ref3){var maxWidth=_ref3.maxWidth;return maxWidth?maxWidth+'px':(0,_rem2.default)('660px');}));var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-18ngxmb-2'})(['align-items:center;background:rgba(0,0,0,0.2);bottom:0;display:flex;justify-content:center;left:0;opacity:0;position:fixed;right:0;top:0;transition:0.4s;z-index:101;',';'],function(_ref4){var state=_ref4.state;switch(state){case'entered':return(0,_styledComponents.css)(['animation:0.4s ',' forwards;'],showModal);case'exiting':return(0,_styledComponents.css)(['animation:0.4s ',' forwards;'],hideModal);case'exited':return(0,_styledComponents.css)(['display:none;']);default:return(0,_styledComponents.css)(['display:block;']);}});var ModalContainer=exports.ModalContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ModalContainer',componentId:'sc-18ngxmb-3'})(['background-color:',';height:100vh;overflow:auto;position:relative;width:100%;',';'],function(props){return props.background||_colors.skyBlue;},_media2.default.large(_templateObject2,(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),(0,_rem2.default)('440px')));var ModalSimpleContainer=exports.ModalSimpleContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ModalSimpleContainer',componentId:'sc-18ngxmb-4'})(['background-color:',';height:100vh;overflow:auto;position:relative;width:100%;display:flex;',';'],_colors.white,_media2.default.large(_templateObject2,function(_ref5){var borderRadius=_ref5.borderRadius;return(0,_rem2.default)(borderRadius+'px');},(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),function(_ref6){var minHeight=_ref6.minHeight;return(0,_rem2.default)(minHeight+'px');}));var ModalContent=exports.ModalContent=_styledComponents2.default.div.withConfig({displayName:'styles__ModalContent',componentId:'sc-18ngxmb-5'})(['padding:',';',';'],function(_ref7){var noPadding=_ref7.noPadding;return noPadding?'0 !important':(0,_rem2.default)('60px')+' '+(0,_rem2.default)('30px');},_media2.default.large(_templateObject3,function(_ref8){var compact=_ref8.compact;return compact?(0,_styledComponents.css)(['padding:',' ',';'],(0,_rem2.default)('40px'),(0,_rem2.default)('64px')):(0,_styledComponents.css)(['padding:',' ',' ',';'],(0,_rem2.default)('74px'),(0,_rem2.default)('60px'),(0,_rem2.default)('55px'));}));var ModalIllustration=exports.ModalIllustration=_styledComponents2.default.img.withConfig({displayName:'styles__ModalIllustration',componentId:'sc-18ngxmb-6'})(['display:block;margin:0 auto;width:40%;',';'],function(_ref9){var accountType=_ref9.accountType;return accountType==='pj'?_media2.default.large(_templateObject4,(0,_rem2.default)('50px')):_media2.default.large(_templateObject5,(0,_rem2.default)('50px'));});var ModalTitle=exports.ModalTitle=_styledComponents2.default.h1.withConfig({displayName:'styles__ModalTitle',componentId:'sc-18ngxmb-7'})(['color:',';font-family:\'Galano\';font-size:',';font-weight:600;line-height:1.17;margin:0;text-align:center;',';'],_colors.offWhite,(0,_rem2.default)('24px'),_media2.default.large(_templateObject6,function(props){return props.compact?(0,_rem2.default)('32px'):(0,_rem2.default)('34px');},(0,_rem2.default)('320px')));var ModalDescription=exports.ModalDescription=_styledComponents2.default.h1.withConfig({displayName:'styles__ModalDescription',componentId:'sc-18ngxmb-8'})(['',' color:',';font-weight:normal;letter-spacing:$normal;line-height:1.5;margin-bottom:',';white-space:normal;width:',';',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('20px'),(0,_rem2.default)('250px'),_media2.default.large(_templateObject7));var Close=exports.Close=_styledComponents2.default.div.withConfig({displayName:'styles__Close',componentId:'sc-18ngxmb-9'})(['color:',';cursor:pointer;height:',';position:absolute;right:',';top:',';width:',';',';'],_colors.white,(0,_rem2.default)('18px'),(0,_rem2.default)('30px'),(0,_rem2.default)('30px'),(0,_rem2.default)('18px'),_media2.default.large(_templateObject8,(0,_rem2.default)('35px'),(0,_rem2.default)('38px')));

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

module.exports = {"confirmBtn":"Ok"}

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/FormEditManageInfo/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _reduxForm=__webpack_require__(11);var _aleloLogic=__webpack_require__(12);var _TextInput=__webpack_require__(101);var _TextInput2=_interopRequireDefault(_TextInput);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _styles=__webpack_require__(613);var _styles2=__webpack_require__(1819);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// Assets
var validate=function validate(values){var errors={};if(!values.description){errors.description='Campo Obrigatório';}if(!values.data){errors.data='Campo Obrigatório';}if(!values.hora){errors.hora='Campo Obrigatório';}};var renderTextInput=function renderTextInput(_ref){var input=_ref.input,_ref$meta=_ref.meta,touched=_ref$meta.touched,error=_ref$meta.error,props=_objectWithoutProperties(_ref,['input','meta']);return _react2.default.createElement(_TextInput2.default,_extends({type:'text'},input,props,{errorMessage:touched&&error,__source:{fileName:_jsxFileName,lineNumber:33}}));};var FormEditManageInfo=function(_React$Component){_inherits(FormEditManageInfo,_React$Component);function FormEditManageInfo(){_classCallCheck(this,FormEditManageInfo);return _possibleConstructorReturn(this,(FormEditManageInfo.__proto__||Object.getPrototypeOf(FormEditManageInfo)).apply(this,arguments));}_createClass(FormEditManageInfo,[{key:'render',value:function render(){var _this2=this;var _props=this.props,handleSubmit=_props.handleSubmit,formTitle=_props.formTitle,saving=_props.saving,isLoading=_props.isLoading,top5List=_props.top5List,onSubmit=_props.onSubmit,loading=_props.loading,msgError=_props.msgError,dateTimeDisabled=_props.dateTimeDisabled,valid=_props.valid;return _react2.default.createElement(_styles.WrapperContentModal,{__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_styles.Form,{onSubmit:handleSubmit(onSubmit),__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:53}},formTitle),_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:54}},_react2.default.createElement(_gridStyled.Box,{width:[11/12],__source:{fileName:_jsxFileName,lineNumber:55}},_react2.default.createElement(_reduxForm.Field,{name:'descricao',lengthCounter:true,placeholder:'Digite Aqui',maxlength:'20',component:renderTextInput,label:'Nome da Informa\xE7\xE3o',validate:_aleloLogic.utils.emptyFieldValidate,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:56}}))),_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:68}},_react2.default.createElement(_gridStyled.Box,{width:[5/12],__source:{fileName:_jsxFileName,lineNumber:69}},_react2.default.createElement(_reduxForm.Field,{name:'data',placeholder:'15/02/2019',component:renderTextInput,label:'data',validate:_aleloLogic.utils.dateValidateWithFormat('DD/MM/YYYY'),normalize:_aleloLogic.utils.dateMask,disabled:dateTimeDisabled,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:70}})),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:81}}),_react2.default.createElement(_gridStyled.Box,{width:[5/12],mb:(0,_rem2.default)('20px'),__source:{fileName:_jsxFileName,lineNumber:82}},_react2.default.createElement(_reduxForm.Field,{name:'hora',placeholder:'10:40',component:renderTextInput,label:'hora',validate:_aleloLogic.utils.dateValidateWithFormat('HH:mm'),normalize:_aleloLogic.utils.hourMask,disabled:dateTimeDisabled,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:83}}))),_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:95}},'Informa\xE7\xF5es Recentes'),_react2.default.createElement(_styles2.ChipsContainer,{__source:{fileName:_jsxFileName,lineNumber:96}},top5List.map(function(item,i){return _react2.default.createElement(_styles2.Chip,{key:i,onClick:function onClick(){return _this2.props.change('descricao',item.descricaoAtual);},__source:{fileName:_jsxFileName,lineNumber:98}},item.descricaoAtual);})),_react2.default.createElement(_styles.WrapperButton,{__source:{fileName:_jsxFileName,lineNumber:103}},_react2.default.createElement(_Button2.default,{text:'OK',buttonType:'darkBlue',type:'submit',loading:loading,disabled:!valid||saving||isLoading||loading,__source:{fileName:_jsxFileName,lineNumber:104}}))),msgError&&_react2.default.createElement(_styles2.MsgError,{__source:{fileName:_jsxFileName,lineNumber:113}},msgError));}}]);return FormEditManageInfo;}(_react2.default.Component);exports.default=(0,_reduxForm.reduxForm)({form:'manageInfoForm',validate:validate})(FormEditManageInfo);module.exports=exports['default'];

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.MsgError=exports.Chip=exports.ChipsContainer=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ChipsContainer=exports.ChipsContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ChipsContainer',componentId:'sc-w1p38m-0'})(['flex-wrap:wrap;display:flex;']);var Chip=exports.Chip=_styledComponents2.default.span.withConfig({displayName:'styles__Chip',componentId:'sc-w1p38m-1'})(['',';color:',';background-color:',';padding:',' ',';border-radius:',';margin-top:',';margin-right:',';margin-left:',';cursor:pointer;'],_types.txt12OpenSansBold,_colors.white,_colors.tealish,(0,_rem2.default)('3px'),(0,_rem2.default)('10px'),(0,_rem2.default)('15px'),(0,_rem2.default)('5px'),(0,_rem2.default)('4px'),(0,_rem2.default)('4px'));var MsgError=exports.MsgError=_styledComponents2.default.div.withConfig({displayName:'styles__MsgError',componentId:'sc-w1p38m-2'})(['',';color:',';padding:',';margin-top:',';'],_types.txt12OpenSansBold,_colors.lightRed,(0,_rem2.default)('5px'),(0,_rem2.default)('20px'));

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _GeneralnformationOption=__webpack_require__(1821);var _GeneralnformationOption2=_interopRequireDefault(_GeneralnformationOption);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_GeneralnformationOption2.default;module.exports=exports['default'];

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ChooseGeneralInformation/GeneralnformationOption.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _Radio=__webpack_require__(136);var _Radio2=_interopRequireDefault(_Radio);var _styles=__webpack_require__(1822);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var renderRadio=function renderRadio(_ref){var input=_ref.input,label=_ref.label,checked=_ref.checked;return _react2.default.createElement(_Radio2.default,_extends({},input,{label:label,checked:checked,__source:{fileName:_jsxFileName,lineNumber:9}}));};var validate=function validate(values){var errors={};if(!values.information){errors.information='Campo Obrigatório';}};var ChooseInformationOption=function ChooseInformationOption(props){var handleChangeInformation=props.handleChangeInformation;return _react2.default.createElement('form',{__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:'Informa\xE7\xE3o 1',name:'information',type:'radio',value:'INFORMACAO_1',onChange:function onChange(){return handleChangeInformation('INFORMACAO_1');},__source:{fileName:_jsxFileName,lineNumber:24}}),_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:'Informa\xE7\xE3o 2',name:'information',type:'radio',value:'INFORMACAO_2',onChange:function onChange(){return handleChangeInformation('INFORMACAO_2');},__source:{fileName:_jsxFileName,lineNumber:32}}),_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:'Informa\xE7\xE3o 3',name:'information',type:'radio',value:'INFORMACAO_3',onChange:function onChange(){return handleChangeInformation('INFORMACAO_3');},__source:{fileName:_jsxFileName,lineNumber:40}})));};exports.default=(0,_reduxForm.reduxForm)({form:'ChoosemanageInfoForm',validate:validate})(ChooseInformationOption);module.exports=exports['default'];

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Wrapper=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-62am29-0'})(['display:flex;justify-content:space-between;flex-direction:column;min-height:130px;']);

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/EditIdentifierHeader/index.js';// Styles
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _propTypes=__webpack_require__(9);var _propTypes2=_interopRequireDefault(_propTypes);var _styles=__webpack_require__(1824);var _styles2=__webpack_require__(395);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Status=function Status(status,data){return _react2.default.createElement(_styles2.StatusWrapper,{active:status==='ATIVO',__source:{fileName:_jsxFileName,lineNumber:10}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:11}},status==='ATIVO'?'Ativa':'Bloqueada '+(data?' em':'')),data&&status!=='ATIVO'?_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:12}},data):'');};var Header=function Header(_ref){var vehicle=_ref.vehicle;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement(_styles2.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_styles2.EditHeader,{__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(_gridStyled.Box,{width:[3/12],__source:{fileName:_jsxFileName,lineNumber:23}},'ve\xEDculo'),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:24}},'placa'),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:25}},'eixos'),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:26}},'veloetag'),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:27}},'status'))))),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_styles.VehicleInfo,{__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_gridStyled.Flex,{align:'center',__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement(_gridStyled.Box,{width:[3/12],__source:{fileName:_jsxFileName,lineNumber:35}},_react2.default.createElement('strong',{__source:{fileName:_jsxFileName,lineNumber:36}},vehicle.veiculo&&vehicle.veiculo.tipo)),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:38}},vehicle.veiculo&&vehicle.veiculo.placa),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:39}},vehicle.veiculo&&vehicle.veiculo.categoria),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:40}},vehicle.codIdentificador),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:41}},Status(vehicle.situacao))))));};Header.defaultProps={vehicle:{veiculo:{tipo:'',placa:'',categoria:''},codIdentificador:'',situacao:''}};Header.propTypes={vehicle:_propTypes2.default.shape({veiculo:_propTypes2.default.shape({tipo:_propTypes2.default.string,placa:_propTypes2.default.string,categoria:_propTypes2.default.string}),codIdentificador:_propTypes2.default.string,situacao:_propTypes2.default.string}).isRequired};exports.default=Header;module.exports=exports['default'];

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.VehicleInfo=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var VehicleInfo=exports.VehicleInfo=_styledComponents2.default.div.withConfig({displayName:'styles__VehicleInfo',componentId:'sc-1pf89t2-0'})(['',';color:',';padding:',' 0;'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('15px'));

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ManageInfoList/index.js';// Assets
// UIComponents
// Styles
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _propTypes=__webpack_require__(9);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _colors=__webpack_require__(2);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _DotButton=__webpack_require__(253);var _DotButton2=_interopRequireDefault(_DotButton);var _Select=__webpack_require__(595);var _Select2=_interopRequireDefault(_Select);var _styles=__webpack_require__(395);var _styles2=__webpack_require__(1827);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var options=[{value:'INFORMACAO_1',label:'Informação 1'},{value:'INFORMACAO_2',label:'Informação 2'},{value:'INFORMACAO_3',label:'Informação 3'}];var ManageInfoList=function ManageInfoList(_ref){var onRowClick=_ref.onRowClick,data=_ref.data,rowActived=_ref.rowActived,onEdit=_ref.onEdit,onDelete=_ref.onDelete,onChangeSelect=_ref.onChangeSelect,valueSelect=_ref.valueSelect,onAddInf=_ref.onAddInf,loadingDelete=_ref.loadingDelete;var dayMonth=function dayMonth(date){return(0,_moment2.default)(date).format('DD/MM');};var hourMinute=function hourMinute(date){return(0,_moment2.default)(date).format('HH:mm');};return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:47}},'Informa\xE7\xF5es Gerenciais'),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:48}},'Para facilitar o gerenciamento das suas transa\xE7\xF5es, voc\xEA pode adicionar at\xE9 3 informa\xE7\xF5es gerenciais por VeloeTag, que ser\xE3o apresentadas nos seus extratos e faturas no formato .csv'),_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_gridStyled.Box,{width:[4/12],mb:(0,_rem2.default)('20px'),__source:{fileName:_jsxFileName,lineNumber:54}},_react2.default.createElement(_Select2.default,{value:valueSelect,onChange:onChangeSelect,options:options,label:'Seleciona o tipo da informa\xE7\xE3o',__source:{fileName:_jsxFileName,lineNumber:55}})))),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:64}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:65}},_react2.default.createElement(_styles.EditHeader,{__source:{fileName:_jsxFileName,lineNumber:66}},_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:67}},_react2.default.createElement(_gridStyled.Box,{width:[4/12],pl:(0,_rem2.default)('15px'),__source:{fileName:_jsxFileName,lineNumber:68}},'Descri\xE7\xE3o'),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:71}},'Data'),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:72}},'Hora'))))),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:77}},data.length>0&&data.filter(function(obj){return obj.tipoInfo===valueSelect;}).map(function(item){var isActived=rowActived===item.id;return _react2.default.createElement(_styles.ListItem,{key:item.id,isActived:isActived,__source:{fileName:_jsxFileName,lineNumber:82}},_react2.default.createElement(_gridStyled.Flex,{width:1,__source:{fileName:_jsxFileName,lineNumber:83}},_react2.default.createElement(_gridStyled.Box,{width:[4/12],pl:(0,_rem2.default)('15px'),__source:{fileName:_jsxFileName,lineNumber:84}},_react2.default.createElement(_styles.ListItemText,{bold:true,__source:{fileName:_jsxFileName,lineNumber:85}},item.descricaoAtual)),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:87}},_react2.default.createElement(_styles.ListItemText,{color:_colors.darkBlue,bold:true,__source:{fileName:_jsxFileName,lineNumber:88}},dayMonth(item.dataInicioVigencia))),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:92}},_react2.default.createElement(_styles.ListItemText,{__source:{fileName:_jsxFileName,lineNumber:93}},hourMinute(item.dataInicioVigencia))),_react2.default.createElement(_styles2.Options,{isActived:isActived,__source:{fileName:_jsxFileName,lineNumber:95}},_react2.default.createElement(_styles2.Option,{loading:loadingDelete,onClick:function onClick(){return onDelete(item);},__source:{fileName:_jsxFileName,lineNumber:96}},'Apagar'),_react2.default.createElement(_styles2.OptionsSeparator,{__source:{fileName:_jsxFileName,lineNumber:99}},'|'),_react2.default.createElement(_styles2.Option,{onClick:function onClick(){return onEdit(item);},__source:{fileName:_jsxFileName,lineNumber:100}},'Editar')),_react2.default.createElement(_styles2.RowButtonContainer,{isActived:isActived,__source:{fileName:_jsxFileName,lineNumber:102}},_react2.default.createElement(_DotButton2.default,{onClick:function onClick(){return onRowClick(item.id);},__source:{fileName:_jsxFileName,lineNumber:103}}))));}),_react2.default.createElement(_gridStyled.Flex,{direction:'column',justify:'flex-end',__source:{fileName:_jsxFileName,lineNumber:109}},_react2.default.createElement(_gridStyled.Box,{mt:(0,_rem2.default)('20px'),__source:{fileName:_jsxFileName,lineNumber:110}},data.length===0&&_react2.default.createElement(_styles.NoContentText,{__source:{fileName:_jsxFileName,lineNumber:112}},'Voc\xEA ainda n\xE3o possui informa\xE7\xF5es gerenciais adicionadas')),_react2.default.createElement(_styles2.BoxEnd,{mt:(0,_rem2.default)('20px'),__source:{fileName:_jsxFileName,lineNumber:117}},_react2.default.createElement(_Button2.default,{text:'Add Informa\xE7\xE3o',buttonType:'darkBlue',onClick:onAddInf,__source:{fileName:_jsxFileName,lineNumber:118}})))));};ManageInfoList.defaultProps={onRowClick:function onRowClick(){},onEdit:function onEdit(){},onDelete:function onDelete(){},onChangeSelect:function onChangeSelect(){},valueSelect:'',data:[],rowActived:null};ManageInfoList.propTypes={onRowClick:_propTypes.func.isRequired,onEdit:_propTypes.func.isRequired,onDelete:_propTypes.func.isRequired,data:_propTypes.array.isRequired,onChangeSelect:_propTypes.func,valueSelect:_propTypes.any,rowActived:_propTypes.any};exports.default=ManageInfoList;module.exports=exports['default'];

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DotIcon=exports.DotButton=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DotButton=exports.DotButton=_styledComponents2.default.a.withConfig({displayName:'styles__DotButton',componentId:'sc-16j7499-0'})(['cursor:',';padding:10px;'],function(_ref){var removeCursor=_ref.removeCursor;return!removeCursor?'pointer':'initial';});var DotIcon=exports.DotIcon=_styledComponents2.default.span.withConfig({displayName:'styles__DotIcon',componentId:'sc-16j7499-1'})(['position:relative;&,&::before,&::after{width:4px;height:4px;border-radius:100px;background-color:',';display:inline-block;}&::before,&::after{content:\'\';position:absolute;left:0;transition:all 0.2s;}&::before{top:8px;}&::after{top:16px;}'],function(_ref2){var color=_ref2.color;return color===''?_colors.darkGrey:color;});

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RowButtonContainer=exports.OptionsSeparator=exports.Option=exports.Options=exports.ListItemText=exports.ListItem=exports.BoxEnd=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _gridStyled=__webpack_require__(8);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _loading=__webpack_require__(100);var _loading2=_interopRequireDefault(_loading);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var BoxEnd=exports.BoxEnd=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'styles__BoxEnd',componentId:'sc-nse1oo-0'})(['align-self:flex-end;']);var ListItem=exports.ListItem=_styledComponents2.default.div.withConfig({displayName:'styles__ListItem',componentId:'sc-nse1oo-1'})(['padding:',' 0;position:relative;overflow:hidden;&:nth-child(2n + 1){background-color:',';}',';'],(0,_rem2.default)('15px'),_colors.ghostWhite,function(_ref){var isActived=_ref.isActived;return isActived&&(0,_styledComponents.css)(['outline:1px solid ',';'],_colors.lightBlue);});var ListItemText=exports.ListItemText=_styledComponents2.default.span.withConfig({displayName:'styles__ListItemText',componentId:'sc-nse1oo-2'})(['',';color:',';font-weight:',';'],_types.txt12OpenSans,function(_ref2){var color=_ref2.color;return color||_colors.darkGrey;},function(_ref3){var bold=_ref3.bold;return bold?'bold':'regular';});var Options=exports.Options=_styledComponents2.default.div.withConfig({displayName:'styles__Options',componentId:'sc-nse1oo-3'})(['position:absolute;right:10%;display:flex;top:50%;transition:transform 0.3s ease-in;transform:',';'],function(_ref4){var isActived=_ref4.isActived;return isActived?'translateY(-50%)':'translateY(4rem)';});var Option=exports.Option=_styledComponents2.default.a.withConfig({displayName:'styles__Option',componentId:'sc-nse1oo-4'})(['cursor:pointer;',';letter-spacing:1px;color:',';&:hover{text-decoration:underline;}',';'],_types.txt12OpenSansBold,_colors.darkBlue,function(props){return props.loading&&'\n      background-image: url('+_loading2.default+');\n      background-size: contain;\n      padding-left: 30px;\n      cursor: not-allowed;\n      color: '+_colors.posGreyInfo+';\n\n      &:hover {\n        text-decoration: none;\n      }\n    ';});var OptionsSeparator=exports.OptionsSeparator=(0,_styledComponents2.default)(ListItemText).withConfig({displayName:'styles__OptionsSeparator',componentId:'sc-nse1oo-5'})(['margin:0 ',';color:',';font-weight:bold;'],(0,_rem2.default)('10px'),_colors.darkBlue);var RowButtonContainer=exports.RowButtonContainer=_styledComponents2.default.div.withConfig({displayName:'styles__RowButtonContainer',componentId:'sc-nse1oo-6'})(['top:30%;position:absolute;right:',';transition:transform 0.3s;',';'],(0,_rem2.default)('20px'),function(_ref5){var isActived=_ref5.isActived;return isActived&&(0,_styledComponents.css)(['transform:rotate(-90deg);span,span::after,span::before{background-color:',';}'],_colors.darkBlue);});

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ManageInfoHistoricList/index.js';// Assets
// Styles
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _gridStyled=__webpack_require__(8);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _colors=__webpack_require__(2);var _styles=__webpack_require__(395);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ManageInfoHistoricList=function ManageInfoHistoricList(_ref){var _ref$data=_ref.data,data=_ref$data===undefined?[]:_ref$data;var dayMonth=function dayMonth(date){return(0,_moment2.default)(date).format('DD/MM');};var hourMinute=function hourMinute(date){return(0,_moment2.default)(date).format('HH:mm');};return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:27}},'Hist\xF3rico'),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:28}},'Veja abaixo todas as a\xE7\xF5es referente ao ve\xEDculo selecionado:')),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:30}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_styles.EditHeader,{__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_gridStyled.Box,{width:[1.6/12],pl:(0,_rem2.default)('15px'),__source:{fileName:_jsxFileName,lineNumber:34}},'Data da a\xE7\xE3o'),_react2.default.createElement(_gridStyled.Box,{width:[1.6/12],__source:{fileName:_jsxFileName,lineNumber:37}},'hora da a\xE7\xE3o'),_react2.default.createElement(_gridStyled.Box,{width:[1.6/12],__source:{fileName:_jsxFileName,lineNumber:38}},'tipo da a\xE7\xE3o'),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:39}},'descri\xE7\xE3o'),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:40}},'descri\xE7\xE3o nova'),_react2.default.createElement(_gridStyled.Box,{width:[1.6/12],__source:{fileName:_jsxFileName,lineNumber:41}},'data in\xEDcio'),_react2.default.createElement(_gridStyled.Box,{width:[1.6/12],__source:{fileName:_jsxFileName,lineNumber:42}},'hora in\xEDcio'))))),_react2.default.createElement(_styles.CustomContent,{__source:{fileName:_jsxFileName,lineNumber:47}},data.length>0&&data.map(function(item,i){return _react2.default.createElement(_styles.ListItem,{key:i,__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement(_gridStyled.Flex,{width:1,__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_gridStyled.Box,{width:[1.6/12],pl:(0,_rem2.default)('15px'),__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_styles.ListItemText,{color:_colors.darkBlue,bold:true,__source:{fileName:_jsxFileName,lineNumber:53}},dayMonth(item.dataAtualizacao))),_react2.default.createElement(_gridStyled.Box,{width:[1.6/12],__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_styles.ListItemText,{__source:{fileName:_jsxFileName,lineNumber:58}},hourMinute(item.dataAtualizacao))),_react2.default.createElement(_gridStyled.Box,{width:[1.6/12],__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_styles.ListItemText,{bold:true,__source:{fileName:_jsxFileName,lineNumber:61}},item.acao)),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:63}},_react2.default.createElement(_styles.ListItemText,{bold:true,__source:{fileName:_jsxFileName,lineNumber:64}},item.descricaoAnterior)),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:66}},_react2.default.createElement(_styles.ListItemText,{bold:true,__source:{fileName:_jsxFileName,lineNumber:67}},item.descricaoAtual)),_react2.default.createElement(_gridStyled.Box,{width:[1.6/12],__source:{fileName:_jsxFileName,lineNumber:69}},_react2.default.createElement(_styles.ListItemText,{color:_colors.darkBlue,bold:true,__source:{fileName:_jsxFileName,lineNumber:70}},dayMonth(item.dataInicioVigencia))),_react2.default.createElement(_gridStyled.Box,{width:[1.6/12],__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement(_styles.ListItemText,{__source:{fileName:_jsxFileName,lineNumber:75}},hourMinute(item.dataInicioVigencia)))));}),_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:81}},data.length===0&&_react2.default.createElement(_gridStyled.Box,{mt:(0,_rem2.default)('20px'),__source:{fileName:_jsxFileName,lineNumber:83}},_react2.default.createElement(_styles.NoContentText,{__source:{fileName:_jsxFileName,lineNumber:84}},'Voc\xEA ainda n\xE3o possui um hist\xF3rico')))));};ManageInfoHistoricList.propTypes={data:_propTypes.array.isRequired};exports.default=ManageInfoHistoricList;module.exports=exports['default'];

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateEmpty=__webpack_require__(112);var _TemplateEmpty2=_interopRequireDefault(_TemplateEmpty);var _Contestation=__webpack_require__(1830);var _Contestation2=_interopRequireDefault(_Contestation);var _ContestationConfirm=__webpack_require__(1837);var _ContestationConfirm2=_interopRequireDefault(_ContestationConfirm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id/extrato/:statementId/contestacao',component:_TemplateEmpty2.default,routes:[{path:'/minha-veloe/:id/extrato/:statementId/contestacao',exact:true,component:_Contestation2.default},{path:'/minha-veloe/:id/extrato/:statementId/contestacao/confirmacao',exact:true,component:_ContestationConfirm2.default}]};module.exports=exports['default'];

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/Contestation/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _actions=__webpack_require__(13);var _factory=__webpack_require__(1831);var _factory2=_interopRequireDefault(_factory);var _style=__webpack_require__(1832);var _data=__webpack_require__(1833);var _Icon=__webpack_require__(31);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _ContestationForm=__webpack_require__(1834);var _ContestationForm2=_interopRequireDefault(_ContestationForm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function getUrlStatement(urlContestation){var split=urlContestation.split('/');return'/'+split[1]+'/'+split[2]+'/'+split[3];}function renderValue(value){if(value<0)return'- '+_aleloLogic.utils.currencyParser(value*-1,'R$ ');return''+_aleloLogic.utils.currencyParser(value,'R$ ');}var Contestation=function(_Component){_inherits(Contestation,_Component);function Contestation(){_classCallCheck(this,Contestation);return _possibleConstructorReturn(this,(Contestation.__proto__||Object.getPrototypeOf(Contestation)).apply(this,arguments));}_createClass(Contestation,[{key:'componentWillMount',value:function componentWillMount(){var params=this.props.match.params||{};this.props.transaction(params.id,params.statementId);this.props.reasons();}},{key:'render',value:function render(){var handleSend=this.props.handleSend;var statementId=this.props.match.params.statementId;var statement=this.props.statement;var reasonsItems=Object.values(this.props.reasonsItems)||[];var urlStatement=getUrlStatement(this.props.location.pathname);return _react2.default.createElement(_style.Container,{__source:{fileName:_jsxFileName,lineNumber:56}},_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_reactHelmet2.default,{title:'Contestation',__source:{fileName:_jsxFileName,lineNumber:58}}),_react2.default.createElement(_style.Header,{__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_style.Title,{__source:{fileName:_jsxFileName,lineNumber:60}},_data.title),_react2.default.createElement(_style.Close,{to:urlStatement,__source:{fileName:_jsxFileName,lineNumber:61}},_react2.default.createElement(_Icon.Icon,{height:23,icon:'new-close',viewBox:'0 0 52 53',__source:{fileName:_jsxFileName,lineNumber:62}})))),_react2.default.createElement(_style.Separator,{__source:{fileName:_jsxFileName,lineNumber:66}}),_react2.default.createElement(_style.Details,{__source:{fileName:_jsxFileName,lineNumber:67}},_react2.default.createElement(_gridStyled.Flex,{justify:'space-between',align:'baseline',__source:{fileName:_jsxFileName,lineNumber:68}},_react2.default.createElement(_style.Locale,{__source:{fileName:_jsxFileName,lineNumber:69}},statement.title),_react2.default.createElement(_style.ValueLarge,{__source:{fileName:_jsxFileName,lineNumber:70}},renderValue(statement.value))),_react2.default.createElement(_style.LocaleDetail,{__source:{fileName:_jsxFileName,lineNumber:72}},statement.local),_react2.default.createElement(_gridStyled.Flex,{justify:['space-between','flex-start'],__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement(_style.Date,{__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement(_style.Bold,{__source:{fileName:_jsxFileName,lineNumber:75}},'Utilizado em '),_aleloLogic.utils.ISODateFormat(statement.date)),_react2.default.createElement(_style.Date,{__source:{fileName:_jsxFileName,lineNumber:78}},_react2.default.createElement(_style.Bold,{__source:{fileName:_jsxFileName,lineNumber:79}},'Hora '),_aleloLogic.utils.ISODateFormat(statement.date,'HH:mm'))),_react2.default.createElement(_Hide2.default,{at:'large',__source:{fileName:_jsxFileName,lineNumber:83}},_react2.default.createElement(_gridStyled.Box,{mb:24,__source:{fileName:_jsxFileName,lineNumber:84}},_react2.default.createElement(_style.Value,{__source:{fileName:_jsxFileName,lineNumber:85}},renderValue(statement.value))))),_react2.default.createElement(_style.Separator,{__source:{fileName:_jsxFileName,lineNumber:89}}),_react2.default.createElement(_gridStyled.Box,{width:[1,500],mt:15,__source:{fileName:_jsxFileName,lineNumber:90}},_react2.default.createElement(_ContestationForm2.default,{data:reasonsItems[0],onSubmit:function onSubmit(values){return handleSend(_factory2.default.toAPI(values,statementId));},__source:{fileName:_jsxFileName,lineNumber:91}})));}}]);return Contestation;}(_react.Component);var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref){var reducer=_ref.reducer;return{reasonsItems:reducer.reasons,statement:reducer.statement,protocol:reducer.protocol};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{handleSend:function handleSend(contestation){return dispatch((0,_actions.fetchContestationProtocol)(contestation)).then(function(){ownProps.history.push(ownProps.location.pathname+'/confirmacao');});},reasons:function reasons(){return dispatch((0,_actions.fetchReasons)());},transaction:function transaction(planId,statementId){return dispatch((0,_actions.fetchStatement)(planId,statementId));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(Contestation);

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var contestationFactory={toAPI:function toAPI(data,transactionId){return data&&transactionId&&{transactionId:transactionId,reason:1,details:data.name};}};exports.default=contestationFactory;module.exports=exports["default"];

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Separator=exports.Bold=exports.ValueLarge=exports.Value=exports.Date=exports.LocaleDetail=exports.Locale=exports.Details=exports.Close=exports.Title=exports.Header=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n        padding: ',' ',' ',' ',';\n    '],['\n        padding: ',' ',' ',' ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        ',';\n\n        margin: 0 0 0 ',';\n        max-width: ',';\n    '],['\n        ',';\n\n        margin: 0 0 0 ',';\n        max-width: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        cursor: pointer;\n        width: ',';\n        height: ',';\n        bottom: ',';\n    '],['\n        cursor: pointer;\n        width: ',';\n        height: ',';\n        bottom: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        flex-grow: 1;\n        margin: ',' 0 0 ',';\n    '],['\n        flex-grow: 1;\n        margin: ',' 0 0 ',';\n    ']),_templateObject5=_taggedTemplateLiteral(['\n        ','\n        margin-left: ',';\n    '],['\n        ','\n        margin-left: ',';\n    ']),_templateObject6=_taggedTemplateLiteral(['\n        ','\n        margin: 0 ',' 0 ',';\n    '],['\n        ','\n        margin: 0 ',' 0 ',';\n    ']),_templateObject7=_taggedTemplateLiteral(['\n        ','\n\n        display: inline-block;\n        margin-right: 30%;\n    '],['\n        ','\n\n        display: inline-block;\n        margin-right: 30%;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'style__Container',componentId:'sc-2o4o0d-0'})(['background-color:',';height:100vh;padding:',';width:100%;overflow:auto;',';'],_colors.skyBlue,(0,_rem2.default)('29px'),_media2.default.large(_templateObject,(0,_rem2.default)('81px'),(0,_rem2.default)('170px'),(0,_rem2.default)('69px'),(0,_rem2.default)('170px')));var Header=exports.Header=_styledComponents2.default.div.withConfig({displayName:'style__Header',componentId:'sc-2o4o0d-1'})(['display:flex;justify-content:space-between;width:100%;']);var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'style__Title',componentId:'sc-2o4o0d-2'})(['',';color:',';letter-spacing:',';',';'],_types.title24Galano,_colors.white,(0,_em2.default)('0.4'),_media2.default.large(_templateObject2,_types.title40GalanoBold,(0,_rem2.default)('15px'),(0,_rem2.default)('390px')));var Close=exports.Close=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'style__Close',componentId:'sc-2o4o0d-3'})(['bottom:0;cursor:pointer;position:relative;right:',';',';'],'2px',_media2.default.large(_templateObject3,(0,_rem2.default)('20px'),(0,_rem2.default)('20px'),(0,_rem2.default)('30px')));var Details=exports.Details=_styledComponents2.default.div.withConfig({displayName:'style__Details',componentId:'sc-2o4o0d-4'})(['width:100%;']);var Locale=exports.Locale=_styledComponents2.default.span.withConfig({displayName:'style__Locale',componentId:'sc-2o4o0d-5'})(['',' color:',';margin:0;',';'],_types.title14Galano,_colors.white,_media2.default.large(_templateObject4,(0,_rem2.default)('24px'),(0,_rem2.default)('15px')));var LocaleDetail=exports.LocaleDetail=_styledComponents2.default.p.withConfig({displayName:'style__LocaleDetail',componentId:'sc-2o4o0d-6'})(['',' color:',';margin:0;',';'],_types.txt12OpenSans,_colors.white,_media2.default.large(_templateObject5,_types.txt14OpenSans,(0,_rem2.default)('15px')));var Date=exports.Date=_styledComponents2.default.time.withConfig({displayName:'style__Date',componentId:'sc-2o4o0d-7'})(['',' color:',';',';'],_types.txt12OpenSans,_colors.white,_media2.default.large(_templateObject6,_types.txt14OpenSans,(0,_rem2.default)('48px'),(0,_rem2.default)('15px')));var Value=exports.Value=_styledComponents2.default.span.withConfig({displayName:'style__Value',componentId:'sc-2o4o0d-8'})(['',' color:',';display:flex;justify-content:flex-end;'],_types.title16Galano,_colors.white);var ValueLarge=exports.ValueLarge=_styledComponents2.default.span.withConfig({displayName:'style__ValueLarge',componentId:'sc-2o4o0d-9'})(['',' color:',';display:none;',';'],_types.title16Galano,_colors.white,_media2.default.large(_templateObject7,_types.title24Galano));var Bold=exports.Bold=_styledComponents2.default.span.withConfig({displayName:'style__Bold',componentId:'sc-2o4o0d-10'})(['font-weight:bold;']);var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'style__Separator',componentId:'sc-2o4o0d-11'})(['border:',' solid ',';margin:',' 0 ',' 0;'],(0,_rem2.default)('1px'),_colors.blizzardBlue,(0,_rem2.default)('30px'),(0,_rem2.default)('10px'));

/***/ }),
/* 1833 */
/***/ (function(module, exports) {

module.exports = {"title":"Qual o motivo da sua contestação?"}

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ContestationForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _styles=__webpack_require__(1835);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _data=__webpack_require__(1836);var _renderInputs=__webpack_require__(44);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function convertData(data){if(data){var reasonsOptions=[];var newItem=void 0;reasonsOptions.push({value:'',label:'Selecione',selected:true,disabled:true,hidden:true});data.forEach(function(oldItem){newItem={};newItem.value=oldItem.id;newItem.label=oldItem.description;reasonsOptions.push(newItem);});return reasonsOptions;}}var ContestationForm=function ContestationForm(_ref){var data=_ref.data,handleSubmit=_ref.handleSubmit;var reasonsData=convertData(data)||[];return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,width:[1,420],__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement(_gridStyled.Box,{width:1,mb:2,__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderSelectField,label:_data.labels.motivation,name:'options',options:reasonsData,validate:_aleloLogic.utils.emptyFieldValidate,negative:true,__source:{fileName:_jsxFileName,lineNumber:43}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.details,name:'name',type:'text',maxlength:'150',lengthCounter:true,placeholder:_data.labels.insert,negative:true,__source:{fileName:_jsxFileName,lineNumber:53}})),_react2.default.createElement(_gridStyled.Box,{mt:39,width:[1,180],__source:{fileName:_jsxFileName,lineNumber:64}},_react2.default.createElement(_Button2.default,{type:'submit',buttonType:'transparent',text:'Enviar',__source:{fileName:_jsxFileName,lineNumber:65}})))));};exports.default=(0,_reduxForm.reduxForm)({form:'contestationForm',destroyOnUnmount:false})(ContestationForm);module.exports=exports['default'];

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Container=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-1tcq5ur-0'})(['',' padding:0;'],_content2.default);

/***/ }),
/* 1836 */
/***/ (function(module, exports) {

module.exports = {"labels":{"motivation":"Motivo","details":"Conte mais detalhes (Opcional)","choice":"escolha","insert":"EX o que deve ser inserido"},"errorMessages":{"emptyField":"Campo obrigatório"}}

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ContestationConfirm/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRedux=__webpack_require__(7);var _aleloLogic=__webpack_require__(12);var _gridStyled=__webpack_require__(8);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _style=__webpack_require__(1838);var _data=__webpack_require__(1839);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _Icon=__webpack_require__(31);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContestationConfirm=function(_Component){_inherits(ContestationConfirm,_Component);function ContestationConfirm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ContestationConfirm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ContestationConfirm.__proto__||Object.getPrototypeOf(ContestationConfirm)).call.apply(_ref,[this].concat(args))),_this),_this.getUrlStatement=function(urlContestation){var split=urlContestation.split('/');return'/'+split[1]+'/'+split[2]+'/'+split[3];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ContestationConfirm,[{key:'render',value:function render(){var _this2=this;var contestationProtocol=this.props.contestationProtocol;var urlStatement=this.getUrlStatement(this.props.location.pathname);return _react2.default.createElement(_style.Container,{__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_style.Main,{__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_reactHelmet2.default,{title:'Contestation',__source:{fileName:_jsxFileName,lineNumber:47}}),_react2.default.createElement(_style.Header,{__source:{fileName:_jsxFileName,lineNumber:48}},_react2.default.createElement(_style.Title,{__source:{fileName:_jsxFileName,lineNumber:49}},_data.title),_react2.default.createElement(_style.Close,{to:urlStatement,__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement(_Icon.Icon,{height:23,icon:'new-close',viewBox:'0 0 52 53',__source:{fileName:_jsxFileName,lineNumber:51}})))),_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:55}},_react2.default.createElement(_style.Text,{__source:{fileName:_jsxFileName,lineNumber:56}},_data.text)),_react2.default.createElement(_style.Separator,{__source:{fileName:_jsxFileName,lineNumber:58}}),_react2.default.createElement(_gridStyled.Box,{mb:[90,75],__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_style.Protocol,{__source:{fileName:_jsxFileName,lineNumber:61}},contestationProtocol.protocol)),_react2.default.createElement(_style.Date,{__source:{fileName:_jsxFileName,lineNumber:63}},'Salvo em ',_aleloLogic.utils.ISODateFormat(contestationProtocol.date),'\xE0s ',_aleloLogic.utils.ISODateFormat(contestationProtocol.date,'HH:mm'))),_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:68}},_react2.default.createElement(_Button2.default,{buttonType:'transparent',text:_data.confirmButtonLabel,width:'204px',onClick:function onClick(){return _this2.props.history.push(urlStatement);},__source:{fileName:_jsxFileName,lineNumber:69}}))),_react2.default.createElement(_style.Illustration,{__source:{fileName:_jsxFileName,lineNumber:77}},_react2.default.createElement('img',{src:_contestacao2.default,alt:'Ilustra\xE7\u0101o veloe',__source:{fileName:_jsxFileName,lineNumber:78}})))));}}]);return ContestationConfirm;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{contestationProtocol:reducer.contestationProtocol};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(ContestationConfirm);module.exports=exports['default'];

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Separator=exports.Illustration=exports.Protocol=exports.Date=exports.Text=exports.Close=exports.Title=exports.Header=exports.Main=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n        padding: ',' 0 ',';\n    '],['\n        padding: ',' 0 ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        ',';\n\n        margin: ',';\n        max-width: ',';\n    '],['\n        ',';\n\n        margin: ',';\n        max-width: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        bottom: ',';\n        height: ',';\n        left: ',';\n        width: ',';\n    '],['\n        bottom: ',';\n        height: ',';\n        left: ',';\n        width: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        max-width: ',';\n    '],['\n        max-width: ',';\n    ']),_templateObject5=_taggedTemplateLiteral(['\n\n        position: relative;\n        letter-spacing: ',';\n\n    '],['\n\n        position: relative;\n        letter-spacing: ',';\n\n    ']),_templateObject6=_taggedTemplateLiteral(['\n    ','\n\n    letter-spacing: ',';\n    '],['\n    ','\n\n    letter-spacing: ',';\n    ']),_templateObject7=_taggedTemplateLiteral(['\n        display: block;\n    '],['\n        display: block;\n    ']),_templateObject8=_taggedTemplateLiteral(['\n        width: ',';\n        border: ',' solid ',';\n        margin: ',' 0 ',' 0;\n        display: block;\n        margin-right: ',';\n        width: 30%;\n    '],['\n        width: ',';\n        border: ',' solid ',';\n        margin: ',' 0 ',' 0;\n        display: block;\n        margin-right: ',';\n        width: 30%;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'style__Container',componentId:'sc-ffy5fm-0'})(['background-color:',';height:100vh;padding:',' 0;width:100%;display:flex;overflow:auto;',';'],_colors.skyBlue,(0,_rem2.default)('62px'),_media2.default.large(_templateObject,(0,_rem2.default)('124px'),(0,_rem2.default)('69px')));var Main=exports.Main=_styledComponents2.default.main.withConfig({displayName:'style__Main',componentId:'sc-ffy5fm-1'})(['width:100%;']);var Header=exports.Header=_styledComponents2.default.div.withConfig({displayName:'style__Header',componentId:'sc-ffy5fm-2'})(['display:flex;justify-content:space-between;width:100%;']);var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'style__Title',componentId:'sc-ffy5fm-3'})(['',';color:',';letter-spacing:',';line-height:1;margin-bottom:',';',';'],_types.title24Galano,_colors.white,(0,_em2.default)('0.4'),(0,_rem2.default)('-3px'),_media2.default.large(_templateObject2,_types.title40GalanoBold,(0,_rem2.default)('-3px'),(0,_rem2.default)('390px')));var Close=exports.Close=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'style__Close',componentId:'sc-ffy5fm-4'})(['bottom:',';position:relative;right:',';text-decoration:none;',';'],'27px','2px',_media2.default.large(_templateObject3,(0,_rem2.default)('83px'),(0,_rem2.default)('20px'),(0,_rem2.default)('160px'),(0,_rem2.default)('20px')));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'style__Text',componentId:'sc-ffy5fm-5'})(['',' font-weight:200;color:',';margin-bottom:0;max-width:',';',';'],_types.txt14OpenSans,_colors.white,(0,_rem2.default)('215px'),_media2.default.large(_templateObject4,(0,_rem2.default)('333px')));var Date=exports.Date=_styledComponents2.default.time.withConfig({displayName:'style__Date',componentId:'sc-ffy5fm-6'})(['',' color:',';text-transform:uppercase;',';'],_types.txt12OpenSans,_colors.white,_media2.default.large(_templateObject5,(0,_em2.default)('1px')));var Protocol=exports.Protocol=_styledComponents2.default.p.withConfig({displayName:'style__Protocol',componentId:'sc-ffy5fm-7'})(['',' color:',';margin:0;',';'],_types.title18Galano,_colors.white,_media2.default.large(_templateObject6,_types.title32GalanoBold,(0,_em2.default)('0.3px')));var Illustration=exports.Illustration=_styledComponents2.default.div.withConfig({displayName:'style__Illustration',componentId:'sc-ffy5fm-8'})(['display:none;',';'],_media2.default.large(_templateObject7));var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'style__Separator',componentId:'sc-ffy5fm-9'})(['border:',' solid ',';margin:',' 0 ',' 0;',';'],(0,_rem2.default)('1px'),_colors.blizzardBlue,(0,_rem2.default)('29px'),(0,_rem2.default)('34px'),_media2.default.large(_templateObject8,(0,_rem2.default)('228px'),(0,_rem2.default)('1px'),_colors.blizzardBlue,(0,_rem2.default)('29px'),(0,_rem2.default)('32px'),(0,_rem2.default)('600px')));

/***/ }),
/* 1839 */
/***/ (function(module, exports) {

module.exports = {"title":"Recebemos sua contestação","protocol":"12340298091284091284","text":"Em breve, a gente vai entrar em contato com você. Enquanto isso, guarde o número do protocolo:","used":" 21/10/2017","hour":" 16:30","confirmButtonLabel":"Ok"}

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateRecharge=__webpack_require__(614);var _TemplateRecharge2=_interopRequireDefault(_TemplateRecharge);var _RechargePrices=__webpack_require__(1842);var _RechargePrices2=_interopRequireDefault(_RechargePrices);var _RechargePayment=__webpack_require__(1848);var _RechargePayment2=_interopRequireDefault(_RechargePayment);var _RechargeConfirmation=__webpack_require__(1854);var _RechargeConfirmation2=_interopRequireDefault(_RechargeConfirmation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id/recarga',component:_TemplateRecharge2.default,routes:[{path:'/minha-veloe/:id/recarga',exact:true,component:_RechargePrices2.default},{path:'/minha-veloe/:id/recarga/pagamento',exact:true,component:_RechargePayment2.default},{path:'/minha-veloe/:id/recarga/confirmacao',exact:true,component:_RechargeConfirmation2.default}]};module.exports=exports['default'];

/***/ }),
/* 1841 */
/***/ (function(module, exports) {

module.exports = {"backCopy":"Voltar para resumo","backCopyDados":"Voltar para dados do plano"}

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/RechargePrices/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(13);var _ValuePicker=__webpack_require__(615);var _ValuePicker2=_interopRequireDefault(_ValuePicker);var _RechargeBreadcrumbs=__webpack_require__(114);var _RechargeBreadcrumbs2=_interopRequireDefault(_RechargeBreadcrumbs);var _Button=__webpack_require__(155);var _Button2=_interopRequireDefault(_Button);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _styles=__webpack_require__(1846);var _data=__webpack_require__(1847);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var RechargePrices=function(_Component){_inherits(RechargePrices,_Component);function RechargePrices(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RechargePrices);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RechargePrices.__proto__||Object.getPrototypeOf(RechargePrices)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.onConfirm=function(){_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/recarga/pagamento');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RechargePrices,[{key:'render',value:function render(){var _this2=this;var _props$recharge=this.props.recharge,currentRechargeValue=_props$recharge.currentRechargeValue,rechargeValues=_props$recharge.rechargeValues;var valuePickerStartIndex=rechargeValues.findIndex(function(rechargeValue){return rechargeValue===currentRechargeValue;});return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_RechargeBreadcrumbs2.default,{active:1,__source:{fileName:_jsxFileName,lineNumber:32}}),_react2.default.createElement(_gridStyled.Flex,{justify:'space-between',direction:['column','row'],mt:(0,_rem2.default)('50px'),__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:35}},_data.title)),_react2.default.createElement(_gridStyled.Flex,{justify:'space-between',align:'center',mt:[(0,_rem2.default)('50px'),(0,_rem2.default)('-30px')],wrap:true,width:[1,8/12],__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_styles.Currency,{__source:{fileName:_jsxFileName,lineNumber:44}},_data.currency),rechargeValues.length>0&&_react2.default.createElement(_ValuePicker2.default,{id:'lstRechargesValues',values:rechargeValues,startIndex:valuePickerStartIndex,onChange:function onChange(index){return _this2.props.dispatch((0,_actions.setCurrentRechargeValue)(rechargeValues[index]));},__source:{fileName:_jsxFileName,lineNumber:47}}),_react2.default.createElement(_gridStyled.Box,{mt:[(0,_rem2.default)('50px'),0],width:[1,'auto'],__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_Button2.default,{id:'btnContinue',width:(0,_rem2.default)('182px'),buttonType:'transparent',text:'Continuar',onClick:this.onConfirm,className:'gtm-link-event','data-gtm-event-category':'veloe:area-logado:recarga','data-gtm-event-action':'clique:continuar','data-gtm-event-label':'codigo-token',__source:{fileName:_jsxFileName,lineNumber:58}})))));}}]);return RechargePrices;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{recharge:reducer.recharge};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(RechargePrices);module.exports=exports['default'];

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.List=exports.Item=exports.Text=undefined;var _templateObject=_taggedTemplateLiteral(['\n        font-size: ',';\n        text-align: center;\n    '],['\n        font-size: ',';\n        text-align: center;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        right: auto;\n        left: ',';\n    '],['\n        right: auto;\n        left: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n                font-size: ',';\n            '],['\n                font-size: ',';\n            ']),_templateObject4=_taggedTemplateLiteral(['\n        height: ',';\n        width: ',';\n    '],['\n        height: ',';\n        width: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1uepnti-0'})(['',' color:',';letter-spacing:',';line-height:1;margin:0;text-align:right;transition:0.3s font-size,0.3s color;',';'],_types.title60GalanoBold,_colors.blizzardBlue,(0,_rem2.default)('4.5px'),_media2.default.large(_templateObject,(0,_rem2.default)('90px')));var Item=exports.Item=_styledComponents2.default.li.withConfig({displayName:'styles__Item',componentId:'sc-1uepnti-1'})(['cursor:pointer;list-style:none;left:0;margin:0;position:absolute;top:-150%;transform:translateY(0);transition:0.3s all;right:',';',' &.carousel-item-prev{top:0;}&.carousel-item-next{top:100%;transform:translateY(-100%);}&.carousel-item-active{left:5%;top:50%;transform:translateY(-50%);','{color:',';font-size:',';',';}~ li:not(.carousel-item-next){top:150%;}}'],(0,_rem2.default)('30px'),_media2.default.large(_templateObject2,(0,_rem2.default)('30px')),Text,_colors.white,(0,_rem2.default)('60px'),_media2.default.large(_templateObject3,(0,_rem2.default)('100px')));var List=exports.List=_styledComponents2.default.ul.withConfig({displayName:'styles__List',componentId:'sc-1uepnti-2'})(['display:block;height:',';margin:0;overflow:hidden;padding:0;position:relative;user-select:none;width:',';',';'],(0,_rem2.default)('250px'),(0,_rem2.default)('300px'),_media2.default.large(_templateObject4,(0,_rem2.default)('400px'),(0,_rem2.default)('380px')));

/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _lodash=__webpack_require__(43);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Slider=function(){function Slider(_ref){var _this=this;var el=_ref.el,onSlide=_ref.onSlide,startIndex=_ref.startIndex;_classCallCheck(this,Slider);this._scrollHandler=function(e){var isLast=_this.active+1>=_this.sections.length;var isFirst=_this.active<=0;if(e.deltaY>0&&!isLast||e.deltaY<0&&!isFirst){e.preventDefault();}_this._handleSlideOnScroll(e);};this._handleSlideOnScroll=(0,_lodash.debounce)(function(e){if(e.deltaY>0){_this.next();}else if(e.deltaY<0){_this.prev();}},45,{leading:true,trailing:false});this.active=startIndex||0;this.onSlide=onSlide;this.carousel=el;this.sections=el.children;this.carouselClass='carousel';this.carouselItemClass='carousel-item';this.carouselActiveClass='carousel-item-active';this.carouselPreviewClass='carousel-item-prev';this.carouselNextClass='carousel-item-next';this._init();}_createClass(Slider,[{key:'_init',value:function _init(){var _this2=this;this.carousel.classList.add(this.carouselClass);Array.map(this.sections,function(section){return section.classList.add(_this2.carouselItemClass);});this._setActiveItem(this.active);this._listenClick();this._listenScroll();this._listenTouch();}},{key:'_removeSectionsClasses',value:function _removeSectionsClasses(){var _this3=this;Array.map(this.sections,function(section){section.classList.remove(_this3.carouselActiveClass);section.classList.remove(_this3.carouselPreviewClass);section.classList.remove(_this3.carouselNextClass);});}},{key:'_setActiveItem',value:function _setActiveItem(index){this.active=index;var activeSection=this.sections[index];var prevSection=this.sections[index-1];var nextSection=this.sections[index+1];this._removeSectionsClasses();if(activeSection){activeSection.classList.add(this.carouselActiveClass);}if(prevSection){prevSection.classList.add(this.carouselPreviewClass);}if(nextSection){nextSection.classList.add(this.carouselNextClass);}}},{key:'_onSlide',value:function _onSlide(){if(this.onSlide){this.onSlide(this.active);}}},{key:'_listenClick',value:function _listenClick(){var _this4=this;Array.map(this.sections,function(section,index){return section.addEventListener('click',_this4.to.bind(_this4,index));});}},{key:'_unlistenClick',value:function _unlistenClick(){var _this5=this;Array.map(this.sections,function(section,index){return section.removeEventListener('click',_this5.to.bind(_this5,index));});}},{key:'_listenScroll',value:function _listenScroll(){this.carousel.addEventListener('wheel',this._scrollHandler);}},{key:'_unlistenScroll',value:function _unlistenScroll(){this.carousel.removeEventListener('wheel',this._scrollHandler);}},{key:'_listenTouch',value:function _listenTouch(){this.carousel.addEventListener('touchstart',this._touchStartHandler.bind(this));this.carousel.addEventListener('touchmove',this._touchMoveHandler.bind(this));this.carousel.addEventListener('touchend',this._touchEndHandler.bind(this));}},{key:'_unlistenTouch',value:function _unlistenTouch(){this.carousel.removeEventListener('touchstart',this._touchStartHandler);this.carousel.removeEventListener('touchmove',this._touchMoveHandler);this.carousel.removeEventListener('touchend',this._touchEndHandler);}},{key:'_touchStartHandler',value:function _touchStartHandler(e){this.touchStart=e.changedTouches[0];}},{key:'_touchMoveHandler',value:function _touchMoveHandler(e){e.preventDefault();var isLast=this.active+1>=this.sections.length;var isFirst=this.active<=0;// TODO: MAKE TOUCHES PREVENT SCROLL AT SLIDER OFFSET
if(this.touchStart.pageY<e.changedTouches[0].pageY&&!isLast||this.touchStart.pageY>e.changedTouches[0].pageY&&!isFirst){e.preventDefault();}}},{key:'_touchEndHandler',value:function _touchEndHandler(e){this.touchEnd=e.changedTouches[0];if(this.touchStart.pageY>this.touchEnd.pageY){this.next();}else if(this.touchStart.pageY<this.touchEnd.pageY){this.prev();}}},{key:'next',value:function next(){if(this.active+1>=this.sections.length){return;}this.active+=1;this._setActiveItem(this.active);this._onSlide();}},{key:'prev',value:function prev(){if(this.active<=0){return;}this.active-=1;this._setActiveItem(this.active);this._onSlide();}},{key:'to',value:function to(index){if(index===this.active){return;}this._setActiveItem(index);this._onSlide();}},{key:'destroy',value:function destroy(){this.carousel.classList.remove(this.carouselClass);this._removeSectionsClasses();this._unlistenClick();this._unlistenScroll();this._unlistenTouch();}}]);return Slider;}();exports.default=Slider;module.exports=exports['default'];

/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Step=exports.StepCircle=exports.CircleCheck=exports.Steps=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: inline-flex;\n    '],['\n        display: inline-flex;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n            flex: none;\n        '],['\n            flex: none;\n        ']),_templateObject3=_taggedTemplateLiteral(['\n                flex: none;\n                margin: 0 ',';\n            '],['\n                flex: none;\n                margin: 0 ',';\n            ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Steps=exports.Steps=_styledComponents2.default.ol.withConfig({displayName:'styles__Steps',componentId:'sc-w00tid-0'})(['align-items:center;display:flex;justify-content:space-between;margin:0;padding:0;',';'],_media2.default.large(_templateObject));var CircleCheck=exports.CircleCheck=_styledComponents2.default.span.withConfig({displayName:'styles__CircleCheck',componentId:'sc-w00tid-1'})(['position:absolute;right:',';top:',';'],(0,_rem2.default)('-8px'),(0,_rem2.default)('-8px'));var StepCircle=exports.StepCircle=_styledComponents2.default.span.withConfig({displayName:'styles__StepCircle',componentId:'sc-w00tid-2'})(['',';align-items:center;border-radius:100%;border:solid ',' ',';color:',';display:inline-flex;height:',';justify-content:center;line-height:1;position:relative;transition:0.2s background,0.2s color,0.2s border;width:',';'],_types.txt14OpenSansBold,(0,_rem2.default)('2px'),_colors.white,_colors.white,(0,_rem2.default)('44px'),(0,_rem2.default)('44px'));var Step=exports.Step=_styledComponents2.default.li.withConfig({displayName:'styles__Step',componentId:'sc-w00tid-3'})(['align-items:center;display:inline-flex;margin:0;padding:0;:not(:first-child){flex:1;',':before{background-color:',';border-radius:',';content:\'\';display:block;height:',';margin:0 ',';width:',';flex:1;',';}}',' ','{',' ',';}'],_media2.default.large(_templateObject2),_colors.white,(0,_rem2.default)('100px'),(0,_rem2.default)('2px'),(0,_rem2.default)('20px'),(0,_rem2.default)('36px'),_media2.default.large(_templateObject3,(0,_rem2.default)('10px')),function(_ref){var visited=_ref.visited,active=_ref.active;return!visited&&!active&&(0,_styledComponents.css)(['opacity:0.5;']);},StepCircle,function(_ref2){var visited=_ref2.visited;return visited&&(0,_styledComponents.css)(['background:',';color:',';'],_colors.white,_colors.skyBlue);},function(_ref3){var active=_ref3.active;return active&&(0,_styledComponents.css)(['border:solid ',' ',';'],(0,_rem2.default)('3px'),_colors.white);});

/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Currency=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n        max-width: ',';\n    '],['\n        max-width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        font-size: ',';\n        letter-spacing: ',';\n    '],['\n        font-size: ',';\n        letter-spacing: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _styles=__webpack_require__(103);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__Title',componentId:'sc-1ixygan-0'})(['',';'],_media2.default.large(_templateObject,(0,_rem2.default)('240px')));var Currency=exports.Currency=_styledComponents2.default.span.withConfig({displayName:'styles__Currency',componentId:'sc-1ixygan-1'})(['',';color:',';font-weight:bold;',';'],_types.title24Galano,_colors.white,_media2.default.large(_templateObject2,(0,_rem2.default)('50px'),(0,_rem2.default)('-1.1px')));

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

module.exports = {"title":"Escolha um valor para sua recarga","currency":"R$"}

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/RechargePayment/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _textSlug=__webpack_require__(184);var _gridStyled=__webpack_require__(8);var _PaymentInfoCard=__webpack_require__(1849);var _PaymentInfoCard2=_interopRequireDefault(_PaymentInfoCard);var _RechargeBreadcrumbs=__webpack_require__(114);var _RechargeBreadcrumbs2=_interopRequireDefault(_RechargeBreadcrumbs);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _actions2=__webpack_require__(18);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);var _ModalTypes=__webpack_require__(20);var _styles=__webpack_require__(1852);var _data=__webpack_require__(1853);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var RechargePayment=function(_Component){_inherits(RechargePayment,_Component);function RechargePayment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RechargePayment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RechargePayment.__proto__||Object.getPrototypeOf(RechargePayment)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false},_this.onConfirm=function(){_this.setState({loading:true});var _this$props=_this.props,_this$props$recharge=_this$props.recharge,currentRechargeValue=_this$props$recharge.currentRechargeValue,paymentInfo=_this$props$recharge.paymentInfo,history=_this$props.history,match=_this$props.match,dispatch=_this$props.dispatch,dashboardResume=_this$props.dashboardResume,actualPlan=_this$props.actualPlan;dispatch((0,_actions.fetchCreateRecharge)({accountPlanId:match.params.id,value:currentRechargeValue,paymentMethod:'credit',type:'manual'})).then(function(){window.dataLayer.push({event:'purchase',eventCategory:'veloe:area-logado:recarga-manual',eventAction:'sucesso:recarga',eventLabel:'purchase',dimension9:'recarga',ecommerce:{purchase:{actionField:{id:paymentInfo.id,revenue:currentRechargeValue.toFixed(2)},products:[{name:(0,_textSlug.converText)('plano-'+actualPlan.plan.category),id:(0,_textSlug.converText)('plano-'+actualPlan.plan.category+'-'+currentRechargeValue),price:currentRechargeValue.toFixed(2),category:dashboardResume.type,quantity:'1'}]}}});_this.setState({loading:false});history.push('/minha-veloe/'+match.params.id+'/recarga/confirmacao');}).catch(function(e){_this.setState({loading:false});console.error(e);// eslint-disable-line
dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,modalDescription:_data.descriptionModalError,image:_contestacao2.default}));});},_this.onEdit=function(){var history=_this.props.history;history.push('/minha-veloe/'+_this.props.match.params.id+'/editar-dados/cartao?path=recharge');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RechargePayment,[{key:'render',value:function render(){var _props=this.props,currentRechargeValue=_props.recharge.currentRechargeValue,account=_props.account;var loading=this.state.loading;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:99}},_react2.default.createElement(_RechargeBreadcrumbs2.default,{active:2,__source:{fileName:_jsxFileName,lineNumber:100}}),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],justify:account&&account.accountType==="pj"?"space-between":"",__source:{fileName:_jsxFileName,lineNumber:101}},_react2.default.createElement(_gridStyled.Box,{mr:[0,1/12*100+'%'],mb:(0,_rem2.default)('20px'),width:[1,4/12],__source:{fileName:_jsxFileName,lineNumber:102}},_react2.default.createElement(_styles.RechargeValue,{__source:{fileName:_jsxFileName,lineNumber:103}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:104}},_data.rechargeValueLabel),_react2.default.createElement(_styles.Cash,{__source:{fileName:_jsxFileName,lineNumber:105}},_react2.default.createElement(_styles.CashPrefix,{__source:{fileName:_jsxFileName,lineNumber:106}},_data.currency),_react2.default.createElement(_styles.CashValue,{id:'lblCurrentRechargeValue',__source:{fileName:_jsxFileName,lineNumber:107}},currentRechargeValue))),_react2.default.createElement(_styles.Text,{id:'lblDisclaimer',__source:{fileName:_jsxFileName,lineNumber:110}},_data.disclaimer)),_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:112}},_react2.default.createElement(_PaymentInfoCard2.default,{accountPlanId:this.props.match.params.id,onConfirm:this.onConfirm,onEdit:this.onEdit,loading:loading,__source:{fileName:_jsxFileName,lineNumber:113}}))));}}]);return RechargePayment;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{recharge:reducer.recharge,dashboardResume:reducer.dashboardResume,account:reducer.account,actualPlan:reducer.accountPlans.plans.find(function(plan){return plan.accountId===reducer.accountPlans.activePlanId;})||{}};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(RechargePayment);module.exports=exports['default'];

/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/PaymentInfoCard/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(13);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _styles=__webpack_require__(1850);var _data=__webpack_require__(1851);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentInfoCard=function(_React$Component){_inherits(PaymentInfoCard,_React$Component);function PaymentInfoCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PaymentInfoCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PaymentInfoCard.__proto__||Object.getPrototypeOf(PaymentInfoCard)).call.apply(_ref,[this].concat(args))),_this),_this.state={editing:false},_this.onConfirm=function(){_this.props.onConfirm();},_this.onEdit=function(){_this.props.onEdit();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PaymentInfoCard,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,getPaymentInfo=_props.getPaymentInfo,accountPlanId=_props.accountPlanId;getPaymentInfo(accountPlanId);}},{key:'render',value:function render(){var _props2=this.props,avatar=_props2.avatar,paymentInfo=_props2.paymentInfo,loading=_props2.loading;var splitedUsername=paymentInfo.nome?paymentInfo.nome.split(' '):[''];return _react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('20px'),(0,_rem2.default)('50px')],__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:40}},_data.paymentTypeLabel),_react2.default.createElement(_styles.TextBold,{__source:{fileName:_jsxFileName,lineNumber:41}},_data.creditLabel)),_react2.default.createElement(_gridStyled.Flex,{align:'center',mb:[(0,_rem2.default)('30px'),(0,_rem2.default)('40px')],__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_styles.UserImage,{src:__webpack_require__(616)("./avatar-"+(avatar+1)+'.png'),__source:{fileName:_jsxFileName,lineNumber:44}}),_react2.default.createElement(_styles.Username,{__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement('span',{id:'lblFirstName',__source:{fileName:_jsxFileName,lineNumber:46}},splitedUsername.shift()),_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:47}}),_react2.default.createElement('span',{id:'lblLastName',__source:{fileName:_jsxFileName,lineNumber:48}},splitedUsername.join(' ')))),_react2.default.createElement(_gridStyled.Box,{mb:'30px',__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:52}},_data.cardLabel),_react2.default.createElement(_styles.TextBold,{id:'lblMaskedCard',__source:{fileName:_jsxFileName,lineNumber:53}},paymentInfo.numeroMascarado)),_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:55}},_react2.default.createElement(_Button2.default,{id:'btnContinue',onClick:this.onConfirm,width:'100%',text:_data.confirmBtn,disabled:loading,loading:loading,className:'gtm-link-event','data-gtm-event-category':'veloe:area-logado:recarga','data-gtm-event-action':'clique:confirmar-recarga','data-gtm-event-label':'confirmacao',__source:{fileName:_jsxFileName,lineNumber:56}}),_react2.default.createElement(_styles.EditPaymentMethod,{__source:{fileName:_jsxFileName,lineNumber:68}},_react2.default.createElement(_Button2.default,{id:'btnEdit',onClick:this.onEdit,width:'100%',text:_data.editDataBtn,__source:{fileName:_jsxFileName,lineNumber:69}}))));}}]);return PaymentInfoCard;}(_react2.default.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer,header=_ref2.header;return{account:reducer.account,avatar:header.avatar,paymentInfo:reducer.recharge.paymentInfo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getPaymentInfo:function getPaymentInfo(accountPlanId){return(0,_actions.fetchPaymentInfo)(accountPlanId)(dispatch);}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(PaymentInfoCard);module.exports=exports['default'];

/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.EditPaymentMethod=exports.Username=exports.UserImage=exports.TextBold=exports.Text=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n        padding: ',' ',' ',';\n        width: ',';\n    '],['\n        padding: ',' ',' ',';\n        width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        ','\n    '],['\n        ','\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=exports.Wrapper=_styledComponents2.default.section.withConfig({displayName:'styles__Wrapper',componentId:'sc-1g28ec9-0'})(['width:100%;border-radius:',';background-color:',';padding:',';box-shadow:0 ',' ',' 0 rgba(30,27,91,0.11);',';'],(0,_rem2.default)('6px'),_colors.white,(0,_rem2.default)('22px'),(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),_media2.default.large(_templateObject,(0,_rem2.default)('40px'),(0,_rem2.default)('40px'),(0,_rem2.default)('30px'),(0,_rem2.default)('335px')));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1g28ec9-1'})(['',' letter-spacing:',';color:',';margin:0;margin-bottom:',';text-transform:uppercase;'],_types.txt12OpenSansLight,(0,_rem2.default)('1px'),_colors.darkGrey,(0,_rem2.default)('5px'));var TextBold=exports.TextBold=_styledComponents2.default.p.withConfig({displayName:'styles__TextBold',componentId:'sc-1g28ec9-2'})(['',' font-weight:bold;color:',';margin:0;'],_types.txt16OpenSans,_colors.linkNavyBlue);var UserImage=exports.UserImage=_styledComponents2.default.img.withConfig({displayName:'styles__UserImage',componentId:'sc-1g28ec9-3'})(['width:',';height:',';border-radius:100%;margin-right:',';'],(0,_rem2.default)('50px'),(0,_rem2.default)('50px'),(0,_rem2.default)('25px'));var Username=exports.Username=_styledComponents2.default.p.withConfig({displayName:'styles__Username',componentId:'sc-1g28ec9-4'})(['',' color:',';font-weight:bold;margin:0;',';'],_types.txt16OpenSans,_colors.linkNavyBlue,_media2.default.large(_templateObject2,_types.txt24OpenSansBold));var EditPaymentMethod=exports.EditPaymentMethod=_styledComponents2.default.p.withConfig({displayName:'styles__EditPaymentMethod',componentId:'sc-1g28ec9-5'})(['',';line-height:1;text-align:center;margin-top:',';margin-bottom:0;color:',';'],_types.txt14OpenSansBold,(0,_rem2.default)('20px'),_colors.linkNavyBlue);

/***/ }),
/* 1851 */
/***/ (function(module, exports) {

module.exports = {"paymentTypeLabel":"tipo de pagamento","creditLabel":"Crédito","cardLabel":"Cartão","confirmBtn":"Confirmar a recarga","editDataBtn":"Editar dados"}

/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RechargeValue=exports.CashValue=exports.CashPrefix=exports.Cash=exports.Text=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: flex;\n    '],['\n        display: flex;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        ','\n    '],['\n        ','\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        ','\n        letter-spacing: .072em;\n    '],['\n        ','\n        letter-spacing: .072em;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        margin: 0;\n        display: block;\n    '],['\n        margin: 0;\n        display: block;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n            margin: ',' 0 ',';\n            text-transform: uppercase;\n        '],['\n            margin: ',' 0 ',';\n            text-transform: uppercase;\n        ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _styles=__webpack_require__(103);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Text=exports.Text=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__Text',componentId:'sc-1o8efnw-0'})(['',';letter-spacing:',';'],_types.txt12OpenSans,(0,_rem2.default)('1px'));var Cash=exports.Cash=_styledComponents2.default.p.withConfig({displayName:'styles__Cash',componentId:'sc-1o8efnw-1'})(['color:',';margin:0;align-items:center;display:inline-flex;justify-content:space-between;',';'],_colors.white,_media2.default.large(_templateObject));var CashPrefix=exports.CashPrefix=_styledComponents2.default.span.withConfig({displayName:'styles__CashPrefix',componentId:'sc-1o8efnw-2'})(['',' line-height:1;margin-right:',';',';'],_types.title18Galano,(0,_rem2.default)('12px'),_media2.default.large(_templateObject2,_types.title32GalanoBold));var CashValue=exports.CashValue=_styledComponents2.default.span.withConfig({displayName:'styles__CashValue',componentId:'sc-1o8efnw-3'})(['',' line-height:1;',';'],_types.title44GalanoBold,_media2.default.large(_templateObject3,_types.title144GalanoBold));var RechargeValue=exports.RechargeValue=_styledComponents2.default.div.withConfig({displayName:'styles__RechargeValue',componentId:'sc-1o8efnw-4'})(['display:flex;align-items:center;justify-content:space-between;margin:',' 0 ',';',' ','{',';}'],(0,_rem2.default)('28px'),(0,_rem2.default)('5px'),_media2.default.large(_templateObject4),Text,_media2.default.large(_templateObject5,(0,_rem2.default)('50px'),(0,_rem2.default)('25px')));

/***/ }),
/* 1853 */
/***/ (function(module, exports) {

module.exports = {"rechargeValueLabel":"Valor da Recarga","currency":"R$","disclaimer":"","button":"continue","titleModalError":"Ops.","descriptionModalError":"Recarga não autorizada. Consulte seu cartão ou tente novamente com outro cartão de crédito."}

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/RechargeConfirmation/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _RechargeBreadcrumbs=__webpack_require__(114);var _RechargeBreadcrumbs2=_interopRequireDefault(_RechargeBreadcrumbs);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _recarga=__webpack_require__(254);var _recarga2=_interopRequireDefault(_recarga);var _styles=__webpack_require__(1855);var _data=__webpack_require__(1856);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var RechargeConfirmation=function(_Component){_inherits(RechargeConfirmation,_Component);function RechargeConfirmation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RechargeConfirmation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RechargeConfirmation.__proto__||Object.getPrototypeOf(RechargeConfirmation)).call.apply(_ref,[this].concat(args))),_this),_this.state={isEditCard:false},_this.onConfirm=function(){_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/resumo');},_this.onNewRecharge=function(){_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/recarga');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RechargeConfirmation,[{key:'componentDidMount',value:function componentDidMount(){var search=this.props.location.search;if(search.includes('path=recharge'))this.setState({isEditCard:true});}},{key:'render',value:function render(){var currentRechargeValue=this.props.recharge.currentRechargeValue;var isEditCard=this.state.isEditCard;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_RechargeBreadcrumbs2.default,{active:4,__source:{fileName:_jsxFileName,lineNumber:44}}),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement(_gridStyled.Box,{mr:[0,1/12*100+'%'],mt:[(0,_rem2.default)('35px'),(0,_rem2.default)('60px')],mb:(0,_rem2.default)('20px'),width:[1,7/12],__source:{fileName:_jsxFileName,lineNumber:46}},isEditCard?_react2.default.createElement(_styles.TitleEdit,{__source:{fileName:_jsxFileName,lineNumber:53}},_data.titleEdit):_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:55}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:56}},_data.title),_react2.default.createElement(_styles.TextSmall,{__source:{fileName:_jsxFileName,lineNumber:58}},_data.awaitUpdate),_react2.default.createElement(_styles.Cash,{__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_styles.CashPrefix,{__source:{fileName:_jsxFileName,lineNumber:61}},_data.currency),_react2.default.createElement(_styles.CashValue,{id:'lblCurrentRechargeValue',__source:{fileName:_jsxFileName,lineNumber:62}},currentRechargeValue)),_react2.default.createElement(_styles.Text,{id:'lblDisclaimer',__source:{fileName:_jsxFileName,lineNumber:64}},_data.disclaimer)),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],mt:[(0,_rem2.default)('30px'),(0,_rem2.default)('30px')],__source:{fileName:_jsxFileName,lineNumber:68}},_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('16px'),0],mr:[0,(0,_rem2.default)('10px')],width:[1,1/2],__source:{fileName:_jsxFileName,lineNumber:69}},_react2.default.createElement(_Button2.default,{id:'btnOk',buttonType:'white',onClick:this.onConfirm,width:'100%',text:'Ok',__source:{fileName:_jsxFileName,lineNumber:70}})),_react2.default.createElement(_gridStyled.Box,{ml:[0,(0,_rem2.default)('10px')],width:[1,1/2],__source:{fileName:_jsxFileName,lineNumber:78}},_react2.default.createElement(_Button2.default,{id:'btnNewRecharge',buttonType:'transparent',onClick:this.onNewRecharge,width:'100%',text:_data.buttonLabel,__source:{fileName:_jsxFileName,lineNumber:79}})))),_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:89}},_react2.default.createElement('img',{alt:'recarga',src:_recarga2.default,__source:{fileName:_jsxFileName,lineNumber:90}}))));}}]);return RechargeConfirmation;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{recharge:reducer.recharge};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(RechargeConfirmation);module.exports=exports['default'];

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.CashValue=exports.CashPrefix=exports.Cash=exports.TextSmall=exports.Text=exports.TitleEdit=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n        max-width: ',';\n    '],['\n        max-width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n    margin-bottom: ',';\n  '],['\n    margin-bottom: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n        margin-right: ',';\n        ','\n    '],['\n        margin-right: ',';\n        ','\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        ','\n        letter-spacing: .072em;\n    '],['\n        ','\n        letter-spacing: .072em;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _styles=__webpack_require__(103);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__Title',componentId:'sc-z8w98d-0'})(['line-height:1.3;margin-bottom:',';',';'],(0,_rem2.default)('30px'),_media2.default.large(_templateObject,(0,_rem2.default)('350px')));var TitleEdit=exports.TitleEdit=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__TitleEdit',componentId:'sc-z8w98d-1'})(['line-height:1.3;',';'],_media2.default.large(_templateObject2,(0,_rem2.default)('150px')));var Text=exports.Text=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__Text',componentId:'sc-z8w98d-2'})(['',';letter-spacing:',';'],_types.txt12OpenSans,(0,_rem2.default)('1px'));var TextSmall=exports.TextSmall=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__TextSmall',componentId:'sc-z8w98d-3'})(['',';font-size:',';letter-spacing:',';'],_types.title24Galano,(0,_rem2.default)('15px'),(0,_rem2.default)('1px'));var Cash=exports.Cash=_styledComponents2.default.p.withConfig({displayName:'styles__Cash',componentId:'sc-z8w98d-4'})(['align-items:center;color:',';display:inline-flex;justify-content:space-between;margin:0;'],_colors.white);var CashPrefix=exports.CashPrefix=_styledComponents2.default.span.withConfig({displayName:'styles__CashPrefix',componentId:'sc-z8w98d-5'})(['',' line-height:1;margin-right:',';',';'],_types.title24Galano,(0,_rem2.default)('22px'),_media2.default.large(_templateObject3,(0,_rem2.default)('12px'),_types.title32GalanoBold));var CashValue=exports.CashValue=_styledComponents2.default.span.withConfig({displayName:'styles__CashValue',componentId:'sc-z8w98d-6'})(['',' font-size:',';line-height:1;',';'],_types.title44GalanoBold,(0,_rem2.default)('100px'),_media2.default.large(_templateObject4,_types.title144GalanoBold));

/***/ }),
/* 1856 */
/***/ (function(module, exports) {

module.exports = {"title":"Seu Veloe já está carregado! ;)","currency":"R$","disclaimer":"","buttonLabel":"Fazer nova recarga","titleEdit":"Vimos que você alterou seus dados, mas a recarga não foi efetuada.","awaitUpdate":"Dentro de alguns segundos o saldo da sua conta estará atualizado."}

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateDashboard=__webpack_require__(1858);var _TemplateDashboard2=_interopRequireDefault(_TemplateDashboard);var _DashboardResume=__webpack_require__(1862);var _DashboardResume2=_interopRequireDefault(_DashboardResume);var _DashboardStatement=__webpack_require__(1931);var _DashboardStatement2=_interopRequireDefault(_DashboardStatement);var _DashboardStatementPartner=__webpack_require__(1986);var _DashboardStatementPartner2=_interopRequireDefault(_DashboardStatementPartner);var _DashboardInvoice=__webpack_require__(2002);var _DashboardInvoice2=_interopRequireDefault(_DashboardInvoice);var _DashboardIdentifiers=__webpack_require__(2009);var _DashboardIdentifiers2=_interopRequireDefault(_DashboardIdentifiers);var _DashboardIdentifiersPartner=__webpack_require__(2020);var _DashboardIdentifiersPartner2=_interopRequireDefault(_DashboardIdentifiersPartner);var _DashboardIdentifiersHistory=__webpack_require__(2023);var _DashboardIdentifiersHistory2=_interopRequireDefault(_DashboardIdentifiersHistory);var _DashboardIdentifiersRequests=__webpack_require__(2026);var _DashboardIdentifiersRequests2=_interopRequireDefault(_DashboardIdentifiersRequests);var _DashboardRechargeHistory=__webpack_require__(2034);var _DashboardRechargeHistory2=_interopRequireDefault(_DashboardRechargeHistory);var _DashboardHowToInstall=__webpack_require__(2040);var _DashboardHowToInstall2=_interopRequireDefault(_DashboardHowToInstall);var _PlanData=__webpack_require__(2052);var _PlanData2=_interopRequireDefault(_PlanData);var _InvoiceDetails=__webpack_require__(2063);var _InvoiceDetails2=_interopRequireDefault(_InvoiceDetails);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id',component:_TemplateDashboard2.default,routes:[{exact:true,path:'/minha-veloe/:id/resumo/',component:_DashboardResume2.default},{exact:true,path:'/minha-veloe/:id/extrato',component:_DashboardStatement2.default},{exact:true,path:'/minha-veloe/:id/extrato-parceiro',component:_DashboardStatementPartner2.default},{exact:true,path:'/minha-veloe/:id/fatura',component:_DashboardInvoice2.default},{exact:true,path:'/minha-veloe/:id/fatura/:fatura',component:_InvoiceDetails2.default},{exact:true,path:'/minha-veloe/:id/fatura/:fatura/:qtdtransacoes',component:_InvoiceDetails2.default},{exact:true,path:'/minha-veloe/:id/historico-de-recarga',component:_DashboardRechargeHistory2.default},{exact:true,path:'/minha-veloe/:id/identificadores',component:_DashboardIdentifiers2.default},{exact:true,path:'/minha-veloe/:id/identificadores-parceiro',component:_DashboardIdentifiersPartner2.default},{exact:true,path:'/minha-veloe/:id/identificadores/historico-tag',component:_DashboardIdentifiersHistory2.default},{exact:true,path:'/minha-veloe/:id/instalacao',component:_DashboardHowToInstall2.default},{exact:true,path:'/minha-veloe/:id/dados-do-plano',component:_PlanData2.default},{exact:true,path:'/minha-veloe/:id/identificadores/nova-tag',component:_DashboardIdentifiersRequests2.default}]};module.exports=exports['default'];

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/templates/TemplateDashboard/index.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _actions=__webpack_require__(13);var _apolloClient=__webpack_require__(42);var _parameterization=__webpack_require__(555);var _Header=__webpack_require__(176);var _Header2=_interopRequireDefault(_Header);var _Submenu=__webpack_require__(248);var _Submenu2=_interopRequireDefault(_Submenu);var _FooterSmall=__webpack_require__(249);var _FooterSmall2=_interopRequireDefault(_FooterSmall);var _PageLoader=__webpack_require__(88);var _PageLoader2=_interopRequireDefault(_PageLoader);var _data=__webpack_require__(1859);var _routes=__webpack_require__(96);var _linksVeloeTags=__webpack_require__(1860);var _linksVeloeTags2=_interopRequireDefault(_linksVeloeTags);var _linksHistoricoTags=__webpack_require__(1861);var _linksHistoricoTags2=_interopRequireDefault(_linksHistoricoTags);var _actions2=__webpack_require__(36);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TemplateDashboard=function(_Component){_inherits(TemplateDashboard,_Component);function TemplateDashboard(){_classCallCheck(this,TemplateDashboard);return _possibleConstructorReturn(this,(TemplateDashboard.__proto__||Object.getPrototypeOf(TemplateDashboard)).apply(this,arguments));}_createClass(TemplateDashboard,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(){var _this2=this;var typeAccountPartner;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:this.props.setLoading(true);if(!((this.props.account||{}).wl||(this.props.account||{}).pc)){_context3.next=7;break;}typeAccountPartner=(this.props.account||{}).wl?'wl':(this.props.account||{}).pc?'pc':'at';_context3.next=5;return this.props.fetchAccountPlansActivation(typeAccountPartner).then(_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var infoChangeTags;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this2.props.setActivePlanId(_this2.props.match.params.id);_context.next=3;return _this2.props.getInfoTags('avisoTrocaTags');case 3:infoChangeTags=_context.sent;_context.next=6;return _this2.verifyChangeTags(infoChangeTags);case 6:case'end':return _context.stop();}}},_callee,_this2);}))).then(function(){return _this2.props.setLoading(false);});case 5:_context3.next=9;break;case 7:_context3.next=9;return this.props.fetchAccountPlans().then(_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var infoChangeTags;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this2.props.setActivePlanId(_this2.props.match.params.id);_context2.next=3;return _this2.props.getInfoTags('avisoTrocaTags');case 3:infoChangeTags=_context2.sent;_context2.next=6;return _this2.verifyChangeTags(infoChangeTags);case 6:case'end':return _context2.stop();}}},_callee2,_this2);}))).then(function(){return _this2.props.setLoading(false);});case 9:case'end':return _context3.stop();}}},_callee3,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'verifyChangeTags',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(list){var _this3=this;var accountsId;return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:if(!list){_context4.next=5;break;}_context4.next=3;return list.find(function(el){return String(el.conta)===String(_this3.props.match.params.id);});case 3:accountsId=_context4.sent;if(accountsId){sessionStorage.setItem('warnTags',JSON.stringify(accountsId));}case 5:case'end':return _context4.stop();}}},_callee4,this);}));function verifyChangeTags(_x){return _ref4.apply(this,arguments);}return verifyChangeTags;}()},{key:'shouldComponentUpdate',value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(nextProps){var hasChange,infoChangeTags;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:this.props.setDataLayer(nextProps);hasChange=// eslint-disable-next-line
nextProps.accountPlans.activePlanId!=nextProps.match.params.id||nextProps.location.pathname!==this.props.location.pathname;if(!hasChange){_context5.next=9;break;}this.props.setActivePlanId(this.props.match.params.id);_context5.next=6;return this.props.getInfoTags('avisoTrocaTags');case 6:infoChangeTags=_context5.sent;_context5.next=9;return this.verifyChangeTags(infoChangeTags);case 9:return _context5.abrupt('return',hasChange);case 10:case'end':return _context5.stop();}}},_callee5,this);}));function shouldComponentUpdate(_x2){return _ref5.apply(this,arguments);}return shouldComponentUpdate;}()},{key:'componentDidUpdate',value:function componentDidUpdate(){this.props.setActivePlanId(this.props.match.params.id);}},{key:'render',value:function render(){var _this4=this;var _props=this.props,routes=_props.routes,accountPlans=_props.accountPlans,match=_props.match,location=_props.location,account=_props.account;var currentAccountPlan=accountPlans&&accountPlans.find(function(_ref6){var id=_ref6.id;return id===match.params.id;})||{};// eslint-disable-line
var currentPlan=currentAccountPlan.plan||{};// Substitui no link o :id pelo id
var subnavLinksWithPlanId=_data.subnavLinks[currentPlan.type]&&_data.subnavLinks[currentPlan.type].map(function(navLink){return _extends({},navLink,{label:(_this4.props.account||{}).pc?navLink.label.replace('Minhas VeloeTags','Consultar VeloeTags'):navLink.label,link:navLink.link.replace(':id',match.params.id)});});var veloeTagsLinksWithPlanId=_linksVeloeTags2.default.map(function(navLink){return _extends({},navLink,{link:navLink.link.replace(':id',match.params.id)});});var hitoricoTagsLinkWithPlanId=_linksHistoricoTags2.default.map(function(navLink){return _extends({},navLink,{link:navLink.link.replace(':id',match.params.id)});});var showSubMenu=location.pathname.includes('/identificadores')||location.pathname.includes('/instalacao');return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:113}},_react2.default.createElement('div',{className:'empty-template',__source:{fileName:_jsxFileName,lineNumber:114}},_react2.default.createElement(_Header2.default,{__source:{fileName:_jsxFileName,lineNumber:115}}),_react2.default.createElement(_Submenu2.default,{navItems:subnavLinksWithPlanId,__source:{fileName:_jsxFileName,lineNumber:116}})),showSubMenu&&_react2.default.createElement(_Submenu2.default,{secondary:true,navItems:(account||{}).pc?hitoricoTagsLinkWithPlanId:veloeTagsLinksWithPlanId,__source:{fileName:_jsxFileName,lineNumber:119}}),_react2.default.createElement(_PageLoader2.default,{__source:{fileName:_jsxFileName,lineNumber:124}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:125}},routes.map(function(route){return _react2.default.createElement(_routes.RouteWithSubRoutes,_extends({key:route.path},route,{__source:{fileName:_jsxFileName,lineNumber:125}}));}))),_react2.default.createElement('div',{className:'empty-template',__source:{fileName:_jsxFileName,lineNumber:127}},_react2.default.createElement(_FooterSmall2.default,{__source:{fileName:_jsxFileName,lineNumber:128}})));}}]);return TemplateDashboard;}(_react.Component);var mapStateToProps=function mapStateToProps(state){return{account:state.reducer.account,accountPlans:state.reducer.accountPlans.plans};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{fetchAccountPlansActivation:function fetchAccountPlansActivation(typeAccountPartner){return dispatch((0,_actions.fetchAccountPlansActivation)()).then(function(accountPlans){var history=ownProps.history,match=ownProps.match;if(accountPlans&&(match.params.id===''||match.params.id==='resumo')){var _ref7=accountPlans||[],_ref8=_slicedToArray(_ref7,1),_ref8$=_ref8[0],_accountPlans=_ref8$===undefined?{}:_ref8$;var firstPlanId=accountPlans&&_accountPlans&&_accountPlans.id;if(typeAccountPartner&&accountPlans.find(function(c){return c.plan.category==='TRANSAÇÕES WHITE LABEL';}))firstPlanId=accountPlans.find(function(c){return c.plan.category==='TRANSAÇÕES WHITE LABEL';}).id;history.push('/minha-veloe/'+firstPlanId+'/resumo');window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'login',eventCategory:'veloe:login',eventAction:'login:tentativa',eventLabel:'sucesso',dimension1:_accountPlans.id,dimension4:_accountPlans.accountId});}});},fetchAccountPlans:function fetchAccountPlans(){return dispatch((0,_actions.fetchAccountPlans)()).then(function(accountPlans){var history=ownProps.history,match=ownProps.match;if(accountPlans&&(match.params.id===''||match.params.id==='resumo')){var _ref9=accountPlans||[],_ref10=_slicedToArray(_ref9,1),_ref10$=_ref10[0],_accountPlans=_ref10$===undefined?{}:_ref10$;var firstPlanId=accountPlans&&_accountPlans&&_accountPlans.id;history.push('/minha-veloe/'+firstPlanId+'/resumo');window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'login',eventCategory:'veloe:login',eventAction:'login:tentativa',eventLabel:'sucesso',dimension1:_accountPlans.id,dimension4:_accountPlans.accountId});}});},setActivePlanId:function setActivePlanId(planId){return dispatch((0,_actions.setActivePlanId)(planId));},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));},setDataLayer:function setDataLayer(_ref11){var _ref11$accountPlans=_ref11.accountPlans,accountPlans=_ref11$accountPlans===undefined?[]:_ref11$accountPlans,account=_ref11.account;window.dataLayer=window.dataLayer||[];var _ref12=accountPlans||[],_ref13=_slicedToArray(_ref12,1),_ref13$=_ref13[0],_accountPlans=_ref13$===undefined?{}:_ref13$;window.dataLayer.push({dimension1:_accountPlans.id,dimension4:_accountPlans.accountId,dimension6:'logado',dimension7:account.accountType,diemsnion8:(_accountPlans.plan||{}).category});},getInfoTags:function(){var _ref14=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(parametro){var _ref15,parametrizacao,infoChangeTags;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return(0,_apolloClient.gqlQuery)(_parameterization.gqlParametrizacao,{parametro:parametro});case 2:_ref15=_context6.sent;parametrizacao=_ref15.data.parametrizacao;infoChangeTags=JSON.parse(parametrizacao[0].valor);return _context6.abrupt('return',infoChangeTags);case 6:case'end':return _context6.stop();}}},_callee6,undefined);}));return function getInfoTags(_x3){return _ref14.apply(this,arguments);};}()};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)((0,_reactRouterDom.withRouter)(TemplateDashboard));module.exports=exports['default'];

/***/ }),
/* 1859 */
/***/ (function(module, exports) {

module.exports = {"subnavLinks":{"pre":[{"label":"Resumo","link":"/minha-veloe/:id/resumo","id":"mnuSummary"},{"label":"Extrato","link":"/minha-veloe/:id/extrato","id":"mnuCheckingAccount"},{"label":"Histórico de recarga","link":"/minha-veloe/:id/historico-de-recarga","id":"mnuRechargeHistory"},{"label":"Minhas VeloeTags","link":"/minha-veloe/:id/identificadores","id":"mnuIdentifiers"},{"label":"Dados do plano","link":"/minha-veloe/:id/dados-do-plano","id":"mnuPlanData"}],"pos":[{"label":"Resumo","link":"/minha-veloe/:id/resumo","id":"mnuSummary"},{"label":"Extrato","link":"/minha-veloe/:id/extrato","id":"mnuCheckingAccount"},{"label":"Faturas","link":"/minha-veloe/:id/fatura","id":"mnuRechargeHistory"},{"label":"Minhas VeloeTags","link":"/minha-veloe/:id/identificadores","id":"mnuIdentifiers"},{"label":"Dados do plano","link":"/minha-veloe/:id/dados-do-plano","id":"mnuPlanData"}]}}

/***/ }),
/* 1860 */
/***/ (function(module, exports) {

module.exports = [{"label":"Solicitar VeloeTag","link":"/minha-veloe/:id/identificadores/nova-tag","id":"menuSummary"},{"label":"Meus Pedidos","link":"/minha-veloe/:id/identificadores/acompanhar-pedido","id":"menuMeusPerdidos"},{"label":"Ativar novo veículo","link":"/identificadores/ativacao","id":"menuAtivar"},{"label":"Como instalar","link":"/minha-veloe/:id/instalacao","id":"menuInstalar"}]

/***/ }),
/* 1861 */
/***/ (function(module, exports) {

module.exports = [{"label":"Histórico de VeloeTag","link":"/minha-veloe/:id/identificadores/historico-tag","id":"menuHistorico"}]

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardResume/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(13);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _Advertisement=__webpack_require__(1863);var _Advertisement2=_interopRequireDefault(_Advertisement);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _PlanResume=__webpack_require__(255);var _PlanResume2=_interopRequireDefault(_PlanResume);var _ConsumptionChart=__webpack_require__(1869);var _ConsumptionChart2=_interopRequireDefault(_ConsumptionChart);var _ConsumptionChartPos=__webpack_require__(1874);var _ConsumptionChartPos2=_interopRequireDefault(_ConsumptionChartPos);var _DashboardCashDisplay=__webpack_require__(1901);var _DashboardCashDisplay2=_interopRequireDefault(_DashboardCashDisplay);var _DashboardIdentifierList=__webpack_require__(1904);var _DashboardIdentifierList2=_interopRequireDefault(_DashboardIdentifierList);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _actions2=__webpack_require__(36);var _Icon=__webpack_require__(31);var _styles=__webpack_require__(1911);var _DashboardInvoiceWidget=__webpack_require__(1912);var _DashboardInvoiceWidget2=_interopRequireDefault(_DashboardInvoiceWidget);var _PageLoader=__webpack_require__(88);var _PageLoader2=_interopRequireDefault(_PageLoader);var _InfoCarousel=__webpack_require__(1917);var _InfoCarousel2=_interopRequireDefault(_InfoCarousel);var _carroVeloe=__webpack_require__(624);var _carroVeloe2=_interopRequireDefault(_carroVeloe);var _data=__webpack_require__(1919);var _Warning=__webpack_require__(1920);var _Warning2=_interopRequireDefault(_Warning);var _Modal=__webpack_require__(113);var _Modal2=_interopRequireDefault(_Modal);var _colors=__webpack_require__(2);var _apolloClient=__webpack_require__(42);var _vehicles=__webpack_require__(94);var _ModalDesligamento=__webpack_require__(1929);var _ModalDesligamento2=_interopRequireDefault(_ModalDesligamento);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/anchor-is-valid *//* eslint-disable jsx-a11y/click-events-have-key-events */// import image from '../../../static/icon-veloe-background.svg'
var DashboardResume=function(_Component){_inherits(DashboardResume,_Component);function DashboardResume(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DashboardResume);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DashboardResume.__proto__||Object.getPrototypeOf(DashboardResume)).call.apply(_ref,[this].concat(args))),_this),_this.state={modalBanner:false,qtdTag:'0'},_this.closeModal=function(){_this.setState({modalBanner:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DashboardResume,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var qtdTag;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.props.setLoading(true);_context.next=3;return this.props.fetchResume(this.props.match.params.id);case 3:_context.next=5;return this.getWarnTags(this.props.match.params.id);case 5:_context.next=7;return this.props.getTotalTags(this.props.match.params.id);case 7:qtdTag=_context.sent;this.setState({qtdTag:qtdTag||'0'});case 9:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'shouldComponentUpdate',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(nextProps){var hasPlanChange;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:hasPlanChange=this.props.accountPlans.activePlanId!==nextProps.accountPlans.activePlanId;if(!hasPlanChange){_context2.next=7;break;}this.props.setLoading(true);_context2.next=5;return this.props.fetchResume(this.props.match.params.id);case 5:_context2.next=7;return this.getWarnTags(this.props.match.params.id);case 7:return _context2.abrupt('return',true);case 8:case'end':return _context2.stop();}}},_callee2,this);}));function shouldComponentUpdate(_x){return _ref3.apply(this,arguments);}return shouldComponentUpdate;}()},{key:'componentWillUnmount',value:function componentWillUnmount(){return _react2.default.createElement(_InfoCarousel2.default,{__source:{fileName:_jsxFileName,lineNumber:72}});}},{key:'getWarnTags',value:function getWarnTags(identifierId){var listTagsWarn=JSON.parse(sessionStorage.getItem('warnTags'));this.setState({modalBanner:listTagsWarn&&parseInt(listTagsWarn.conta)===parseInt(identifierId)});}},{key:'goIdentifier',value:function goIdentifier(){this.props.history.push('/minha-veloe/'+this.props.match.params.id+'/identificadores');}},{key:'modalChangeTag',value:function modalChangeTag(){var _this2=this;return _react2.default.createElement(_styles.WrapperModal,{__source:{fileName:_jsxFileName,lineNumber:92}},_react2.default.createElement(_Modal2.default,{background:_colors.skyBlue,hideModal:this.closeModal,__source:{fileName:_jsxFileName,lineNumber:93}},_react2.default.createElement(_styles.ModalTitle,{__source:{fileName:_jsxFileName,lineNumber:94}},_react2.default.createElement(_Icon.Icon,{icon:'info',width:'34',height:'34',viewBox:'0 0 24 24',__source:{fileName:_jsxFileName,lineNumber:95}}),'Voc\xEA precisa trocar sua tag'),_react2.default.createElement(_styles.ModalDescription,{__source:{fileName:_jsxFileName,lineNumber:98}},'Vimos que em algum momento a cancela n\xE3o abriu pra voc\xEA.',_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:99}}),_react2.default.createElement(_styles.LinkBanner,{onClick:function onClick(){return _this2.goIdentifier();},__source:{fileName:_jsxFileName,lineNumber:100}},'Clique aqui'),'',' ou v\xE1 at\xE9 ',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:101}},'"Minhas Veloetags"'),', substitua as tags sinalizadas.',_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:101}}),'Evite ficar parado, troque agora.'),_react2.default.createElement(_styles.ModalIllustration,{src:_carroVeloe2.default,__source:{fileName:_jsxFileName,lineNumber:104}})));}},{key:'render',value:function render(){var _props=this.props,resume=_props.resume,accountPlans=_props.accountPlans,history=_props.history,match=_props.match,accountType=_props.account.accountType;var _state=this.state,modalBanner=_state.modalBanner,qtdTag=_state.qtdTag;var isPartner=(this.props.account||{}).pc;if(!resume||!resume.type){return null;}var obj=accountPlans&&accountPlans.plans&&accountPlans.plans.length>0?accountPlans.plans.find(function(el){return el&&el.id===match.params.id;}):null;if(this.props.account.at){history.push('/minha-veloe/identificadores-parceiros');return true;}if(resume&&resume.vehicles&&resume.vehicles.length===0&&obj&&obj.identifiers&&obj.identifiers.length<=0&&obj.identifiersOrders.length>0){history.push('/minha-veloe/'+match.params.id+'/identificadores/acompanhar-pedido');}var finantialData=resume.consumption||resume.balance||{};var currentAccountPlan=accountPlans&&accountPlans.plans.find(function(plan){return plan.id==match.params.id;})||{};// eslint-disable-line
var currentPlan=currentAccountPlan.plan||{};var isPrePaid=currentPlan&&currentPlan.type==='pre';return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:149}},_react2.default.createElement(_PageLoader2.default,{__source:{fileName:_jsxFileName,lineNumber:150}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:151}},resume&&_react2.default.createElement(_gridStyled.Flex,{mt:[0,(0,_rem2.default)('35px')],mb:(0,_rem2.default)('60px'),align:'stretch',wrap:[true,false],__source:{fileName:_jsxFileName,lineNumber:153}},_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('20px'),0],pr:[0,20],width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:154}},_react2.default.createElement(_PlanResume2.default,{qtdTag:qtdTag,__source:{fileName:_jsxFileName,lineNumber:155}})),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,9/12],__source:{fileName:_jsxFileName,lineNumber:157}},_react2.default.createElement(_DashboardCashDisplay2.default,{recharge:isPrePaid,updateDate:finantialData.date,value:obj?!isPrePaid?obj.availableAmount:obj.ammount:null,isPartner:isPartner,__source:{fileName:_jsxFileName,lineNumber:158}}),isPrePaid&&_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:164}}),isPrePaid?_react2.default.createElement(_ConsumptionChart2.default,{consumption:resume.consumption,balance:resume.balance,__source:{fileName:_jsxFileName,lineNumber:166}}):_react2.default.createElement(_ConsumptionChartPos2.default,{consumption:resume.balance,balance:resume.balance,currentPlan:currentAccountPlan,accountType:(this.props.account||{}).pc,__source:{fileName:_jsxFileName,lineNumber:168}}),isPrePaid&&_react2.default.createElement(_Hide2.default,{at:'large',mt:(0,_rem2.default)('20px'),__source:{fileName:_jsxFileName,lineNumber:176}},_react2.default.createElement(_Button2.default,{id:'button-manual-recharge',onClick:function onClick(){return history.push('/minha-veloe/'+match.params.id+'/recarga');},text:_data.rechargeButtonLabel,__source:{fileName:_jsxFileName,lineNumber:177}})),!isPrePaid&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:185}},_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:186}}),_react2.default.createElement(_DashboardInvoiceWidget2.default,{currentAccountPlan:currentAccountPlan,match:match,isPartner:isPartner,__source:{fileName:_jsxFileName,lineNumber:187}})),_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:194}}),_react2.default.createElement(_DashboardIdentifierList2.default,{accountPlans:accountPlans,resume:resume,isPartner:isPartner,__source:{fileName:_jsxFileName,lineNumber:195}}),_react2.default.createElement(_InfoCarousel2.default,{__source:{fileName:_jsxFileName,lineNumber:200}},_react2.default.createElement(_Warning2.default.IrrfAutoRetencao,{__source:{fileName:_jsxFileName,lineNumber:201}}),_react2.default.createElement(_Warning2.default.Toll,{__source:{fileName:_jsxFileName,lineNumber:202}}),_react2.default.createElement(_Warning2.default.CheckApp,{__source:{fileName:_jsxFileName,lineNumber:203}}),_react2.default.createElement(_Warning2.default.Signalization,{__source:{fileName:_jsxFileName,lineNumber:204}}),accountType==='pf'&&_react2.default.createElement(_Advertisement2.default,{__source:{fileName:_jsxFileName,lineNumber:205}})))))),modalBanner&&this.modalChangeTag(),_react2.default.createElement(_ModalDesligamento2.default,{__source:{fileName:_jsxFileName,lineNumber:213}}));}}]);return DashboardResume;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref4){var reducer=_ref4.reducer;return{resume:reducer.dashboardResume,accountPlans:reducer.accountPlans,account:reducer.account};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchResume:function fetchResume(token,planId){return dispatch((0,_actions.fetchDashboardResume)(token,planId)).then().finally(function(){return dispatch((0,_actions2.setLoading)(false));});},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));},getTotalTags:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(idConta){var _ref6,total;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return(0,_apolloClient.gqlQuery)(_vehicles.gqlTotalIdentificadores,{idConta:idConta});case 2:_ref6=_context3.sent;total=_ref6.data.identificadoresPJV2.paginacao.total;return _context3.abrupt('return',total);case 5:case'end':return _context3.stop();}}},_callee3,undefined);}));return function getTotalTags(_x2){return _ref5.apply(this,arguments);};}(),dispatch:dispatch};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DashboardResume);module.exports=exports['default'];

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardResume/Advertisement/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(1864);var _styles=__webpack_require__(1865);var _handPhone=__webpack_require__(1866);var _handPhone2=_interopRequireDefault(_handPhone);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Advertisement=function Advertisement(){return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement('img',{src:_handPhone2.default,className:'WarningImage-phone',alt:'phone',__source:{fileName:_jsxFileName,lineNumber:16}}),_react2.default.createElement(_styles.ContainerContent,{__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:18}},'Baixe nosso app. ',_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:19}}),'Agora mesmo ;)'),_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:22}},'Tenha acesso aos nossos servi\xE7os e gerencie a sua conta pelo celular de forma simples e descomplicada.',_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:25}}),_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:26}}),'Use o seu tempo com o que realmente importa!'),_react2.default.createElement(_styles.ButtonContainer,{__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement('a',{href:_data.androidAppUrl,target:'_blank',__source:{fileName:_jsxFileName,lineNumber:30}},_react2.default.createElement('img',{alt:_data.androidAppImgAlt,src:_data.androidAppImgSrc,__source:{fileName:_jsxFileName,lineNumber:31}})),_react2.default.createElement('a',{href:_data.iosAppUrl,target:'_blank',__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement('img',{alt:_data.iosAppImgAlt,src:_data.iosAppImgSrc,__source:{fileName:_jsxFileName,lineNumber:34}})))));};exports.default=Advertisement;module.exports=exports['default'];

/***/ }),
/* 1864 */
/***/ (function(module, exports) {

module.exports = {"title":"Baixe nosso APP ;)","subtitle":"Tenha acesso a todas nossas funcionalidades e gerencie sua conta  direto do seu celular","androidAppUrl":"https://play.google.com/store/apps/details?id=br.com.veloe.mobile","androidAppImgAlt":"Disponível no Google Play","androidAppImgSrc":"https://play.google.com/intl/pt_br/badges/images/generic/pt_badge_web_generic.png","iosAppUrl":"https://itunes.apple.com/us/app/veloe/id1278343398?ls=1&mt=8","iosAppImgAlt":"Baixar na App Store","iosAppImgSrc":"https://linkmaker.itunes.apple.com/assets/shared/badges/pt-br/appstore-lrg.svg"}

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonContainer=exports.Subtitle=exports.Title=exports.ContainerContent=exports.Container=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-1c47oeq-0'})(['background-color:',';border-radius:4.4px;display:flex;width:100%;.WarningImage-phone{position:relative;height:222px;top:50px;}'],_colors.skyBlue);var ContainerContent=exports.ContainerContent=_styledComponents2.default.section.withConfig({displayName:'styles__ContainerContent',componentId:'sc-1c47oeq-1'})(['display:flex;flex-direction:column;align-items:flex-end;margin:35px 0;margin-right:33px;max-width:351px;']);var Title=exports.Title=_styledComponents2.default.p.withConfig({displayName:'styles__Title',componentId:'sc-1c47oeq-2'})(['',';color:',';margin:0;'],_types.title24GalanoBold,_colors.linkNavyBlue);var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-1c47oeq-3'})(['',';color:',';text-align:right;padding-left:50px;line-height:21px;margin:25px 0 29px;letter-spacing:',';max-width:385px;'],_types.txt14OpenSans,_colors.white,(0,_rem2.default)('-0.5px'));var ButtonContainer=exports.ButtonContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonContainer',componentId:'sc-1c47oeq-4'})(['a{img{max-width:176px;max-height:60px;}&:first-child{margin-right:4px;}}']);

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hand-phone.d620646a.svg";

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.MonthlyPayment=exports.ValueLimited=exports.Currency=exports.FinancialInfo=exports.Date=exports.Label=exports.Accession=exports.WrapperAccession=exports.VehicleSvg=exports.VehicleNumber=exports.Vehicle=exports.VehicleText=exports.State=exports.PlanState=exports.PlanType=exports.TitlePlan=exports.Title=exports.VehiclesContainer=exports.PlansContainer=exports.Aside=undefined;var _templateObject=_taggedTemplateLiteral(['\n        background-color: background-color: ',';\n        border-radius: ',';\n        display: flex;\n        flex-direction: column;\n        min-height: ',';\n        justify-content: stretch;\n        margin: ',';\n        padding: 0;\n        width: ',';\n    '],['\n        background-color: background-color: ',';\n        border-radius: ',';\n        display: flex;\n        flex-direction: column;\n        min-height: ',';\n        justify-content: stretch;\n        margin: ',';\n        padding: 0;\n        width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        flex: 1;\n        padding: ',' ',' 0;\n        position: relative;\n    '],['\n        flex: 1;\n        padding: ',' ',' 0;\n        position: relative;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        background-color: ',';\n        display: flex;\n        flex-direction: column;\n        height: auto;\n        justify-content: flex-end;\n        min-height: ',';\n        padding: 0;\n    '],['\n        background-color: ',';\n        display: flex;\n        flex-direction: column;\n        height: auto;\n        justify-content: flex-end;\n        min-height: ',';\n        padding: 0;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        ','\n    '],['\n        ','\n    ']),_templateObject5=_taggedTemplateLiteral(['\n        display: block;\n        line-height: 1;\n    '],['\n        display: block;\n        line-height: 1;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n        ','\n        margin: 0 0 ',';\n        max-width: ',';\n    '],['\n        ','\n        margin: 0 0 ',';\n        max-width: ',';\n    ']),_templateObject7=_taggedTemplateLiteral(['\n        display: block;\n    '],['\n        display: block;\n    ']),_templateObject8=_taggedTemplateLiteral(['\n        ',';\n        display: block;\n        font-size: ',';\n        line-height: 0;\n        padding: 0 ',';\n        text-align: left;\n    '],['\n        ',';\n        display: block;\n        font-size: ',';\n        line-height: 0;\n        padding: 0 ',';\n        text-align: left;\n    ']),_templateObject9=_taggedTemplateLiteral(['\n        ','\n\n        line-height: 1.5;\n    '],['\n        ','\n\n        line-height: 1.5;\n    ']),_templateObject10=_taggedTemplateLiteral(['\n        border-radius: ',';\n        display: block;\n        margin-left: ',';\n    '],['\n        border-radius: ',';\n        display: block;\n        margin-left: ',';\n    ']),_templateObject11=_taggedTemplateLiteral(['\n        bottom: ',';\n        display: block;\n    '],['\n        bottom: ',';\n        display: block;\n    ']),_templateObject12=_taggedTemplateLiteral(['\n        flex-direction: column;\n        margin-bottom: 0;\n        padding: ',' 0 ',' ',';\n    '],['\n        flex-direction: column;\n        margin-bottom: 0;\n        padding: ',' 0 ',' ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Aside=exports.Aside=_styledComponents2.default.aside.withConfig({displayName:'styles__Aside',componentId:'sc-1npwacp-0'})(['align-items:center;background-color:',';display:block;margin:0 -',';overflow:hidden;',';@media print{background-color:',';border-radius:',';display:flex;flex-direction:column;min-height:',';justify-content:stretch;margin:',';padding:0;width:',';}'],function(props){return props.color;},(0,_rem2.default)('20px'),_media2.default.large(_templateObject,function(props){return props.color;},(0,_rem2.default)('4.4px'),(0,_rem2.default)('472px'),(0,_rem2.default)('-3px'),(0,_rem2.default)('220px')),function(props){return props.color;},(0,_rem2.default)('4.4px'),(0,_rem2.default)('472px'),(0,_rem2.default)('-3px'),(0,_rem2.default)('220px'));var PlansContainer=exports.PlansContainer=_styledComponents2.default.div.withConfig({displayName:'styles__PlansContainer',componentId:'sc-1npwacp-1'})(['background-color:',';height:auto;padding:',' 0 0 ',';width:100%;',';@media print{flex:1;padding:',' ',' 0;position:relative;}'],function(props){return props.color;},(0,_rem2.default)('23px'),(0,_rem2.default)('28px'),_media2.default.large(_templateObject2,(0,_rem2.default)('28px'),(0,_rem2.default)('22px')),(0,_rem2.default)('28px'),(0,_rem2.default)('22px'));var VehiclesContainer=exports.VehiclesContainer=_styledComponents2.default.div.withConfig({displayName:'styles__VehiclesContainer',componentId:'sc-1npwacp-2'})(['height:auto;padding:0 ',' 0 ',';',';@media print{background-color:',';display:flex;flex-direction:column;height:auto;justify-content:flex-end;min-height:',';padding:0;}'],(0,_rem2.default)('30px'),(0,_rem2.default)('30px'),_media2.default.large(_templateObject3,function(props){return props.color;},(0,_rem2.default)('221px')),function(props){return props.color;},(0,_rem2.default)('221px'));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-1npwacp-3'})(['',' color:',';display:flex;flex-direction:row;line-height:1;margin:0 ',' 0 0;text-transform:capitalize;',';'],_types.title24GalanoBold,_colors.white,(0,_rem2.default)('10px'),_media2.default.large(_templateObject4,_types.title24GalanoBold));var TitlePlan=exports.TitlePlan=_styledComponents2.default.div.withConfig({displayName:'styles__TitlePlan',componentId:'sc-1npwacp-4'})(['align-items:baseline;display:flex;',';@media print{display:block;line-height:1;}'],_media2.default.large(_templateObject5));var PlanType=exports.PlanType=_styledComponents2.default.p.withConfig({displayName:'styles__PlanType',componentId:'sc-1npwacp-5'})(['',' color:',';font-weight:bold;margin:0;text-transform:capitalize;',';@media print{',' margin:0 0 ',';max-width:',';}'],_types.txt24OpenSansNormal,_colors.white,_media2.default.large(_templateObject6,_types.txt24OpenSansNormal,(0,_rem2.default)('12px'),(0,_rem2.default)('160')),_types.txt24OpenSansNormal,(0,_rem2.default)('12px'),(0,_rem2.default)('160'));var PlanState=exports.PlanState=_styledComponents2.default.p.withConfig({displayName:'styles__PlanState',componentId:'sc-1npwacp-6'})(['',' color:',';display:block;letter-spacing:',';margin-right:',';text-transform:uppercase;vertical-align:center;:before{background-color:',';border-radius:',';content:\'\';display:inline-block;height:',';margin-right:',';width:',';}'],_types.txt12OpenSansLight,_colors.white,(0,_em2.default)('1.3px'),(0,_rem2.default)('17px'),_colors.green,(0,_rem2.default)('64px'),(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),(0,_rem2.default)('24px'));var State=exports.State=_styledComponents2.default.div.withConfig({displayName:'styles__State',componentId:'sc-1npwacp-7'})(['align-items:baseline;display:flex;',';@media print{display:block;}'],_media2.default.large(_templateObject7));var VehicleText=exports.VehicleText=_styledComponents2.default.p.withConfig({displayName:'styles__VehicleText',componentId:'sc-1npwacp-8'})(['',' align-items:baseline;color:',';display:flex;line-height:1;margin:0;text-align:left;',';@media print{',';display:block;font-size:',';line-height:0;padding:0 ',';text-align:left;}'],_types.txt16OpenSans,function(props){return props.color;},_media2.default.large(_templateObject8,_types.txt16OpenSans,(0,_rem2.default)('14px'),(0,_rem2.default)('22px')),_types.txt16OpenSans,(0,_rem2.default)('14px'),(0,_rem2.default)('22px'));var Vehicle=exports.Vehicle=_styledComponents2.default.span.withConfig({displayName:'styles__Vehicle',componentId:'sc-1npwacp-9'})(['',' font-weight:bold;margin-bottom:',';'],_types.txt16OpenSans,(0,_rem2.default)('14px'));var VehicleNumber=exports.VehicleNumber=_styledComponents2.default.span.withConfig({displayName:'styles__VehicleNumber',componentId:'sc-1npwacp-10'})(['',';display:block;letter-spacing:',';margin-right:',';',';@media print{',' line-height:1.5;}'],_types.txt16OpenSans,(0,_rem2.default)('0.2px'),(0,_rem2.default)('5px'),_media2.default.large(_templateObject9,_types.title32GalanoBold),_types.title32GalanoBold);var VehicleSvg=exports.VehicleSvg=_styledComponents2.default.div.withConfig({displayName:'styles__VehicleSvg',componentId:'sc-1npwacp-11'})(['',';color:',';display:none;',';@media print{border-radius:',';display:block;margin-left:',';}'],_types.title32GalanoBold,function(props){return props.color;},_media2.default.large(_templateObject10,(0,_rem2.default)('4.4px'),(0,_rem2.default)('15px')),(0,_rem2.default)('4.4px'),(0,_rem2.default)('15px'));var WrapperAccession=exports.WrapperAccession=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperAccession',componentId:'sc-1npwacp-12'})(['display:flex;min-height:150px;flex-direction:column;justify-content:',';padding:12px 0;'],function(props){return props.bonification?'space-between':'flex-end';});var Accession=exports.Accession=_styledComponents2.default.div.withConfig({displayName:'styles__Accession',componentId:'sc-1npwacp-13'})(['display:flex;flex-direction:row;',';@media print{bottom:',';display:block;position:absolute;}'],_media2.default.large(_templateObject11,(0,_rem2.default)('10px')),(0,_rem2.default)('10px'));var Label=exports.Label=_styledComponents2.default.p.withConfig({displayName:'styles__Label',componentId:'sc-1npwacp-14'})(['',' color:',';letter-spacing:',';margin:0;text-transform:uppercase;'],_types.txt12OpenSans,_colors.white,(0,_rem2.default)('1px'));var Date=exports.Date=_styledComponents2.default.time.withConfig({displayName:'styles__Date',componentId:'sc-1npwacp-15'})(['',' color:',';letter-spacing:',';'],_types.txt12OpenSans,_colors.white,(0,_rem2.default)('1px'));var FinancialInfo=exports.FinancialInfo=_styledComponents2.default.div.withConfig({displayName:'styles__FinancialInfo',componentId:'sc-1npwacp-16'})(['display:flex;flex-direction:row;justify-content:space-between;margin-bottom:',';padding:0;',';@media print{flex-direction:column;margin-bottom:0;padding:',' 0 ',' ',';}'],(0,_rem2.default)('10px'),_media2.default.large(_templateObject12,(0,_rem2.default)('17px'),(0,_rem2.default)('10'),(0,_rem2.default)('20px')),(0,_rem2.default)('17px'),(0,_rem2.default)('10'),(0,_rem2.default)('20px'));var Currency=exports.Currency=_styledComponents2.default.span.withConfig({displayName:'styles__Currency',componentId:'sc-1npwacp-17'})(['',' color:',';font-weight:bold;'],_types.title14Galano,_colors.white);var ValueLimited=exports.ValueLimited=_styledComponents2.default.p.withConfig({displayName:'styles__ValueLimited',componentId:'sc-1npwacp-18'})(['',' color:',';margin:0;',';'],_types.title18Galano,_colors.white,_media2.default.large(_templateObject4,_types.title24GalanoBold));var MonthlyPayment=exports.MonthlyPayment=_styledComponents2.default.p.withConfig({displayName:'styles__MonthlyPayment',componentId:'sc-1npwacp-19'})(['',' color:',';margin:0;',';'],_types.title18Galano,_colors.white,_media2.default.large(_templateObject4,_types.title24GalanoBold));

/***/ }),
/* 1868 */
/***/ (function(module, exports) {

module.exports = {"vehicleLabel":{"single":"Veículo","multiple":"Veículos"},"activeLabel":"Ativo","accessionDate":"Data de adesão","bonificationEndDate":"Promoção de","bonificationValid":"Válida até","currency":"R$","monthlyPayment":"Mensalidade","totalLimit":"Limite total"}

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ConsumptionChart/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _colors=__webpack_require__(2);var _ConsumptionChartBar=__webpack_require__(617);var _ConsumptionChartBar2=_interopRequireDefault(_ConsumptionChartBar);var _ConsumptionChartIndicator=__webpack_require__(618);var _ConsumptionChartIndicator2=_interopRequireDefault(_ConsumptionChartIndicator);var _styles=__webpack_require__(1872);var _data=__webpack_require__(1873);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var currencyParser=_aleloLogic.utils.currencyParser;var colors=[_colors.violet,_colors.orange,_colors.yellow];var toPercentage=function toPercentage(value,total){var decimal=value/total;return decimal*100;};// TODO: move to logic
var calculateDataPercentage=function calculateDataPercentage(){var dataArray=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var maxValue=arguments[1];if(maxValue){return dataArray.map(function(data){return toPercentage(data,maxValue);});}var total=dataArray.reduce(function(data,nextData){return data+nextData;},0);return dataArray.map(function(data){return toPercentage(data,total);});};var ConsumptionChart=function ConsumptionChart(_ref){var consumption=_ref.consumption,balance=_ref.balance;var data=consumption&&consumption.spending||balance&&balance.spending;var consumptionTypes=Object.keys(data);var consumptionValues=consumptionTypes.map(function(consumptionType){return data[consumptionType];});var dataPercentage=calculateDataPercentage(consumptionValues,consumption&&consumption.limit)||[];var totalPercentage=dataPercentage.reduce(function(percentage,nextData){return percentage+nextData;},0);return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:40}},balance&&_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:41}},'\xFAltimos 30 dias'),_react2.default.createElement(_ConsumptionChartBar2.default,{colors:colors,values:dataPercentage,__source:{fileName:_jsxFileName,lineNumber:43}}),consumption&&_react2.default.createElement(_styles.Usage,{__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:47}},totalPercentage,'%'),_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:49}},'De ',currencyParser(consumption.limit,'R$ '))),_react2.default.createElement(_styles.IndicatorList,{__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_styles.IndicatorItem,{__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:54}},_data.consumptionLabel)),consumptionTypes.map(function(indicator,index){return _react2.default.createElement(_styles.IndicatorItem,{key:indicator,__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_ConsumptionChartIndicator2.default,{name:_data.indicatorLabel[indicator],color:colors[index],value:currencyParser(data[indicator]),__source:{fileName:_jsxFileName,lineNumber:58}}));})));};exports.default=ConsumptionChart;module.exports=exports['default'];

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BarSlice=exports.BarContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n        height: ',';\n    '],['\n        height: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BarContainer=exports.BarContainer=_styledComponents2.default.div.withConfig({displayName:'styles__BarContainer',componentId:'sc-136kks4-0'})(['height:',';border-radius:78px;overflow:hidden;display:flex;background-color:#f1f1f7;',';'],(0,_rem2.default)('8px'),_media2.default.large(_templateObject,(0,_rem2.default)('16px')));var BarSlice=exports.BarSlice=_styledComponents2.default.div.withConfig({displayName:'styles__BarSlice',componentId:'sc-136kks4-1'})(['height:100%;width:',';',';'],function(props){return props.width;},function(_ref){var color=_ref.color;return'background-color: '+color+';';});

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Value=exports.Name=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n        line-height: 1.9;\n        margin-bottom: 0;\n    '],['\n        line-height: 1.9;\n        margin-bottom: 0;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n            margin-bottom: 0;\n        '],['\n            margin-bottom: 0;\n        ']),_templateObject3=_taggedTemplateLiteral(['\n        ','\n        letter-spacing: ',';\n    '],['\n        ','\n        letter-spacing: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.p.withConfig({displayName:'styles__Container',componentId:'sc-1o6gzq7-0'})(['margin:0;']);var Name=exports.Name=_styledComponents2.default.span.withConfig({displayName:'styles__Name',componentId:'sc-1o6gzq7-1'})(['color:',';display:block;font-family:OpenSans;font-size:',';font-weight:200;line-height:1;margin-bottom:',';',':before{background-color:',';border-radius:',';content:\'\';display:block;height:',';margin-bottom:',';width:',';',';}'],_colors.darkGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('4px'),_media2.default.large(_templateObject),function(props){return props.color||_colors.offWhite;},(0,_rem2.default)('64px'),(0,_rem2.default)('8px'),(0,_rem2.default)('5px'),(0,_rem2.default)('24px'),_media2.default.large(_templateObject2));var Value=exports.Value=_styledComponents2.default.span.withConfig({displayName:'styles__Value',componentId:'sc-1o6gzq7-2'})(['',' color:',';letter-spacing:',';line-height:1;',';'],_types.title16Galano,_colors.linkNavyBlue,(0,_rem2.default)('1.2px'),_media2.default.large(_templateObject3,_types.title18Galano,(0,_rem2.default)('1px')));

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.IndicatorItem=exports.IndicatorList=exports.Text=exports.Usage=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: flex;\n        justify-content: space-between;\n        margin-top: ',';\n    '],['\n        display: flex;\n        justify-content: space-between;\n        margin-top: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        display: inline-flex;\n        width: 33%;\n\n        :first-child {\n            width: 100%;\n        }\n    '],['\n        display: inline-flex;\n        width: 33%;\n\n        :first-child {\n            width: 100%;\n        }\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var textStyles='\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('12px')+';\n    letter-spacing: '+(0,_rem2.default)('1px')+';\n    color: '+_colors.darkGrey+';\n    font-weight: 200;\n    text-transform: uppercase;\n';var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-1q8h5bf-0'})(['',';margin-top:0;'],textStyles);var Usage=exports.Usage=_styledComponents2.default.p.withConfig({displayName:'styles__Usage',componentId:'sc-1q8h5bf-1'})(['',';margin-top:0;display:flex;justify-content:space-between;span{font-family:OpenSans;font-size:',';font-weight:400;line-height:1.57;color:',';text-transform:none;margin-top:',';:first-child{font-family:Galano;font-size:',';font-weight:bold;}}'],textStyles,(0,_rem2.default)('14px'),_colors.darkGrey,(0,_rem2.default)('7px'),(0,_rem2.default)('18px'));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1q8h5bf-2'})(['',';'],textStyles);var IndicatorList=exports.IndicatorList=_styledComponents2.default.ul.withConfig({displayName:'styles__IndicatorList',componentId:'sc-1q8h5bf-3'})(['display:block;list-style:none;padding:0;margin:0;',';'],_media2.default.large(_templateObject,(0,_rem2.default)('12px')));var IndicatorItem=exports.IndicatorItem=_styledComponents2.default.li.withConfig({displayName:'styles__IndicatorItem',componentId:'sc-1q8h5bf-4'})(['flex-grow:1;',';'],_media2.default.small(_templateObject2));

/***/ }),
/* 1873 */
/***/ (function(module, exports) {

module.exports = {"consumptionLabel":"Tipos Consumo","indicatorLabel":{"fuel":"Abastecimento","park":"Estacionamento","toll":"Pedágio"}}

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ConsumptionChartPos/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _utils=__webpack_require__(95);var _colors=__webpack_require__(2);var _ConsumptionChartBarPos=__webpack_require__(619);var _ConsumptionChartBarPos2=_interopRequireDefault(_ConsumptionChartBarPos);var _ConsumptionChartIndicatorPos=__webpack_require__(1876);var _ConsumptionChartIndicatorPos2=_interopRequireDefault(_ConsumptionChartIndicatorPos);var _styles=__webpack_require__(1899);var _data=__webpack_require__(1900);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var colors=[_colors.posYellow];var toPercentage=function toPercentage(value,total){var decimal=value/total;return decimal*100;};// TODO: move to logic
var calculateDataPercentage=function calculateDataPercentage(){var dataArray=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var maxValue=arguments[1];if(maxValue){return dataArray.map(function(data){return toPercentage(data,maxValue);});}var total=dataArray.reduce(function(data,nextData){return data+nextData;},0);return dataArray.map(function(data){return toPercentage(data,total);});};var ConsumptionChartPos=function ConsumptionChartPos(_ref){var _ref$balance=_ref.balance,balance=_ref$balance===undefined?{spending:{toll:500}}:_ref$balance,currentPlan=_ref.currentPlan,accountType=_ref.accountType;var data=balance&&balance.spending||{};var consumptionTypes=Object.keys(data);var dataPercentage=calculateDataPercentage([currentPlan.ammount],currentPlan.limit)||[];if(accountType&&consumptionTypes.length>2)delete consumptionTypes[0];return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:50}}),_react2.default.createElement(_ConsumptionChartBarPos2.default,{colors:colors,values:dataPercentage,__source:{fileName:_jsxFileName,lineNumber:51}}),_react2.default.createElement(_styles.BarInfoContainer,{__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_styles.SpentBalance,{__source:{fileName:_jsxFileName,lineNumber:53}},'Fatura atual R$ ',_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:54}},(0,_utils.currencyParser)(currentPlan.ammount))),_react2.default.createElement(_styles.Limit,{__source:{fileName:_jsxFileName,lineNumber:56}},'Limite total R$ ',_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:57}},(0,_utils.currencyParser)(currentPlan.limit)))),_react2.default.createElement(_styles.IndicatorList,{__source:{fileName:_jsxFileName,lineNumber:61}},consumptionTypes.map(function(indicator){return _react2.default.createElement(_styles.IndicatorItem,{key:indicator,__source:{fileName:_jsxFileName,lineNumber:63}},_react2.default.createElement(_ConsumptionChartIndicatorPos2.default,{name:_data.indicatorLabel[indicator],color:_colors.posYellow,value:(0,_utils.currencyParser)(data[indicator]),indicator:indicator,dataPercentage:calculateDataPercentage([data[indicator]],currentPlan.limit),__source:{fileName:_jsxFileName,lineNumber:64}}));})));};exports.default=ConsumptionChartPos;module.exports=exports['default'];

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BarSlice=exports.BarContainer=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var BarContainer=exports.BarContainer=_styledComponents2.default.div.withConfig({displayName:'styles__BarContainer',componentId:'sc-1g4murc-0'})(['height:',';border-radius:78px;overflow:hidden;display:flex;background-color:#f1f1f7;width:100%;'],function(_ref){var height=_ref.height;return(0,_rem2.default)(height||'16px');});var BarSlice=exports.BarSlice=_styledComponents2.default.div.withConfig({displayName:'styles__BarSlice',componentId:'sc-1g4murc-1'})(['height:100%;width:',';',';'],function(props){return props.width;},function(_ref2){var color=_ref2.color;return'background-color: '+color+';';});

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ConsumptionChartIndicatorPos/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _styles=__webpack_require__(1877);var _ConsumptionChartBarPos=__webpack_require__(619);var _ConsumptionChartBarPos2=_interopRequireDefault(_ConsumptionChartBarPos);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var colors=[_colors.posYellow,_colors.posGrey];var Icon=function Icon(_ref){var icon=_ref.icon,name=_ref.name,otherProps=_objectWithoutProperties(_ref,['icon','name']);return _react2.default.createElement('img',_extends({src:__webpack_require__(1878)("./"+icon+'.png'),alt:name},otherProps,{__source:{fileName:_jsxFileName,lineNumber:11}}));};var ConsumptionChartIndicatorPos=function ConsumptionChartIndicatorPos(_ref2){var _ref2$indicator=_ref2.indicator,indicator=_ref2$indicator===undefined?'':_ref2$indicator,_ref2$name=_ref2.name,name=_ref2$name===undefined?'':_ref2$name,_ref2$value=_ref2.value,value=_ref2$value===undefined?0:_ref2$value,_ref2$color=_ref2.color,color=_ref2$color===undefined?'':_ref2$color,dataPercentage=_ref2.dataPercentage;return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(Icon,{width:'24px',height:'24px',icon:indicator,alt:name,viewBox:'0 0 11 8',__source:{fileName:_jsxFileName,lineNumber:22}}),_react2.default.createElement(_styles.Name,{color:color,__source:{fileName:_jsxFileName,lineNumber:23}},name),_react2.default.createElement(_styles.BarChartContainer,{__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement(_ConsumptionChartBarPos2.default,{height:'8px',colors:colors,values:dataPercentage,__source:{fileName:_jsxFileName,lineNumber:25}})),_react2.default.createElement(_styles.Value,{__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:29}},'R$'),value));};ConsumptionChartIndicatorPos.propTypes={name:_propTypes.string,value:(0,_propTypes.oneOfType)([_propTypes.number,_propTypes.string]),color:_propTypes.string,indicator:_propTypes.string};exports.default=ConsumptionChartIndicatorPos;module.exports=exports['default'];

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Value=exports.Name=exports.BarChartContainer=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ','\n        letter-spacing: ',';\n    '],['\n        ','\n        letter-spacing: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-1466ani-0'})(['width:100%;display:flex;']);var BarChartContainer=exports.BarChartContainer=_styledComponents2.default.div.withConfig({displayName:'styles__BarChartContainer',componentId:'sc-1466ani-1'})(['display:flex;align-items:center;margin:',';width:100%;'],(0,_rem2.default)('8px'));var Name=exports.Name=_styledComponents2.default.div.withConfig({displayName:'styles__Name',componentId:'sc-1466ani-2'})(['color:',';display:block;font-family:OpenSans;font-size:',';font-weight:200;line-height:1;margin:',';'],_colors.darkGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('8px'));var Value=exports.Value=_styledComponents2.default.div.withConfig({displayName:'styles__Value',componentId:'sc-1466ani-3'})(['',' color:',';letter-spacing:',';line-height:1;margin:',' 0 ',' ',';span{','}',';'],_types.title14Galano,_colors.linkNavyBlue,(0,_rem2.default)('1.2px'),(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),_types.txt14OpenSans,_media2.default.large(_templateObject,_types.title18Galano,(0,_rem2.default)('1px')));

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./adesivo-veloe.png": 620,
	"./alterarSenha.png": 394,
	"./avatar.png": 1879,
	"./avatars/avatar-1.png": 240,
	"./avatars/avatar-2.png": 241,
	"./avatars/avatar-3.png": 242,
	"./avatars/avatar-4.png": 243,
	"./avatars/avatar-5.png": 244,
	"./avatars/avatar-6.png": 245,
	"./avatars/avatar-7.png": 246,
	"./avatars/avatar-8.png": 247,
	"./avatars/avatar-pj.png": 387,
	"./bg-modal-desligamento.png": 621,
	"./blocked-car.png": 622,
	"./cancelAccount.png": 1880,
	"./car.png": 623,
	"./carro-veloe.png": 624,
	"./close-icon.png": 625,
	"./close.png": 1881,
	"./confirmation.png": 49,
	"./contestacao.png": 47,
	"./fuel.png": 1882,
	"./ic-arrow-blue-left.png": 626,
	"./ic-check.png": 612,
	"./ic-check@2x.png": 1883,
	"./ic-check@3x.png": 1884,
	"./ic-picker-plus.png": 1885,
	"./ic-search.png": 627,
	"./iconDownload.png": 1886,
	"./iconPrint.png": 1887,
	"./iconShare.png": 1888,
	"./irrf-auto-retencao.png": 628,
	"./login.png": 396,
	"./logoVeloe.png": 397,
	"./mail-to.png": 256,
	"./mail-to@2x.png": 1889,
	"./mail-to@3x.png": 1890,
	"./modalBuddies.png": 605,
	"./modalBuddies@2x.png": 1891,
	"./modalBuddies@3x.png": 1892,
	"./park.png": 1893,
	"./perfil-1@2x.png": 1894,
	"./perfil-1@3x.png": 1895,
	"./recarga.png": 254,
	"./semaphore.png": 609,
	"./tag_veloe@2x.png": 629,
	"./toll.png": 1896,
	"./truck-travel.png": 607,
	"./truck-travel@2x.png": 1897,
	"./truck-travel@3x.png": 1898,
	"./unblocked-car.png": 630
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1878;

/***/ }),
/* 1879 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cancelAccount.00aa5f8d.png";

/***/ }),
/* 1881 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1882 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAACXBIWXMAAAsSAAALEgHS3X78AAAB90lEQVRoge2ZwU3DMBSGvyKOSO0G9GYpp2xARugG5JA7bEDZoANEKp2AESgbtJdIubUbpBL3cogBk1CIY0fYlb+THcVP72/s5/deR8fjkXPk4r8dGIogzDeCMN8IwnwjCPONS1uGIpFNgNjARFWU+caWPyMbKVUksgVwZ+4OWyC1IdBYmEVRHxyAuCjznYkRo60YiWxKW9QWqDRNxcBYjsfAHEgNXDM+Y7PGfFWUeaprJBJZDKz5EpcYeYV5VJwo420fUQDyTKlrrw18AuyGe93t9+v6SGTzSGRJX2Mu32MPwEsksrTPYpeEXZ14vuwjziVhb435QRlri3NJWJOEtrjJiXdbOCtMRsqk8bhzyuasMPgU1wtrSbCKTLO6/LoVdW5oelW0sC6sR+64xqwq+JEhtuIT3w/9XywG8MH+FyvKfCNzv2mH163WYCqDnDFZcuyGsN0Vp6OiCUGYbwRhvuG0MHlt9MJZYZHIZtRZicqu6/pB7jFLPDfmrzotOZe+2KkKGuoU7V7HmEvCmhU0wB5YUTdQtVIvZ7diUeYjk/UufTGraPXuZaRSQ3AC3Mjxnrpk6csUuFXmj8q4Kspcq7zpLEx2iZY6xi2j1T7X2YrWq1xNYp0ule5W7NrLsI12b8TKH38ucrZRMQjzjSDMN4Iw3wjCfOMdqxGI/L9TS3wAAAAASUVORK5CYII="

/***/ }),
/* 1883 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1884 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1885 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAASdJREFUOBGtlTFuwkAQRbNI7mjS5gJcIHW4AhQcIZfhJnQpQkdFzQWIUucClCmc98xYMrLXmGhX+trdmT9fM+vZdXoaGHVdV5hXgVfml6D9MJ/Ah0gp/YY9PyG2Bt/gAN7BAswDrrXpk7POKuGcgS34AsssMRxygmvMrMfHqOMInnvOjEFuxGxvKBgt08wGxbDvwedNUGyMAcZey2dRAc8jWya+ZgwJasO5BGpUbjbgkCNHAJS6vsPxQ208TNtjN0ae6FNjZYZnsBgLwt+MOxxb6qzgBcxbMms/wNSx78TZq5d+/7SMaXP3XFMTgmrRks3Qu/k2LaFRlhqn4m2jYNnGtghEy1299lQQLfc4RJZln69OppbvRfduPvzAXpuxVYsZoX//Av4A2a3Ljp09cCcAAAAASUVORK5CYII="

/***/ }),
/* 1886 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1887 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1888 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mail-to@2x.f09f7e51.png";

/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mail-to@3x.8ace5120.png";

/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/modalBuddies@2x.672bbb22.png";

/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/modalBuddies@3x.89beb031.png";

/***/ }),
/* 1893 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAACXBIWXMAAAsSAAALEgHS3X78AAADYElEQVRoge2ZwW3bMBSGvxS918cCPcQ3AbzYQAeIO0G0QVRAA6gT1J2gzl1A7Q3sCeoBClS+CBDQg7OBNUF6IB3TMiWLooRWgX4ggEJTj/zJn4/vPd08Pz/zGvHmX0+gKwzE+oaBWN8wEOsbBmJ9w9sujQsvnAJjYKo1H4AESNIsPnQ19k3bIZXwwgDwgRnw7kr3HbAE1mkW79ucR2vEFKE5cNvQxAqI2tpFZ2LCC8fIVb8r6ZIjpXfEmHLyOZLc0mlSOBITXjgD1lxK7qrEhBf6SMk+GH5epVkcNJ4YDsSU9H4UmnfIFd9a2BkBCy4JOpFrREx5uy3nO/WYZnHUdCIlu9+YnDUxtcL7wgQ+t3Eu1HldAxNX202ILTmXzZc0ixclkxxX2TJJVr2XcFq4HJjaXgdWxJRcfmpNmzSLfUM/k1RNMErNMI61JG1DKt14Xvhfx4LrpAB8tUNnUDu50poeTP2qUJuYOlu6BBeOl2kOzCokVnREgY1xm1ixKLmLc1WCb2kWzy3GASDN4oPwwhWnxfSRkU0t2Ehxrz1vugxgNSxLxr+K2sSU7jfqL7AZpCnUmJ/UmFZ3ZOvRPYDwwi2n2HHF+cq/wCZCsUVXxH4BH2t0dY4Jy9BVBv2+Zj+ju28DXWXQf4AP6vmJ8oMftZ1gHmFFTK3uwdIjLpu4+8K40zSLk+s9T7C9oBMgUSFP5xBeOBJeuAZ+Cy+08oo2ZyxAhkm31L+cXeED9+p5bvOijRT32vPEQh4z4YWmSR1MWUEBgfa8rTHWC2oTS7N4Lbww5xTcRtS7qO8oqYeoxTHaUHLX31vXnSvYu3t9hR8qzlrdg17l7vWxcttk0zYfK2bPT8gk8MJLCi9ccF4oNSEyyVlJ96vWZExmq9Akg46A71rTLs3iawRs7AecF4ka2beOPNTKbbSmifDCRO2mEwykqpLZSjQNqQJkqe2ICQ73m7qvllyW84xSrQOXuuII6YInhZ9WwLxOqKRsBMg7qlhKcKp8uVaCR8iU5N7w8w7porcgUxStcjVFfrSYcUkoB3zXlKaVtEU5lDn1CjhV2ABBG9l5m19bRshLO8Ke4AZZHNq2Mhm6SzSPHxymXJ5BkPdfgpRp69/GoCNi/wNe7TfogVjfMBDrGwZifcNArG/4CwOVbWP4mYsOAAAAAElFTkSuQmCC"

/***/ }),
/* 1894 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/perfil-1@3x.b94eeca0.png";

/***/ }),
/* 1896 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAACXBIWXMAAAsSAAALEgHS3X78AAABuElEQVRoge2ZzW2DMBhAX6re2w3CDYlLM0I2aDZoIvnejpAROgBSYYN2g4yQXCxxarpBN6CHWmoUBWywKXyR3wmI/x58mM/xrK5rrpGbsQcwFFFMGlFMGlFMGlFMGrddK2SpWgLLHn0ddZUXPer1YuaaUmWpugcK4NGjvy9gpat879GGE11CcYufFMAceDc3aVCcQjFLVQI8n10+AN+O/SyAO3M8B1b8Pv3BcH3HkrPzUlf52rWTLFULYMef3Hl7wek1K3aRMuX3wGufvvrSeVYcE/NKJAC6yndtZcWIXQjnWVt5ER/oC1JWJi/WIFXa6k1arEnKZfKarJiPFExUzFcKJigWQgomJhZKCgJ8x8wypom9rnKnfDKkFHiKZakqgKeWIocsVUubXGgp8AhF86TapAAegBdLO8GlwEPM5GobS7FSV/m26UeT++0ILAWeoWiW+oVHE1sGkILxZ8Xk5PgjlBSML3ZK0P9BpiQWlCgmjSgmjSgmjSgmjdbdlixVa+Dt30bjjjWnbBQzmfdn+DEFY9O239YYirrKj9iXJWNR2jYRnTf+pHG1k0cUk0YUk0YUk0YUk8YPOVOUrXF4K48AAAAASUVORK5CYII="

/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/truck-travel@2x.24ebc716.png";

/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/truck-travel@3x.3f99e602.png";

/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Separator=exports.IndicatorItem=exports.IndicatorList=exports.Text=exports.Usage=exports.Title=exports.BarInfoContainer=exports.Limit=exports.SpentBalance=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: flex;\n        justify-content: space-between;\n        margin-top: ',';\n    '],['\n        display: flex;\n        justify-content: space-between;\n        margin-top: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var textStyles='\n    font-family: OpenSans;\n    font-size: '+(0,_rem2.default)('12px')+';\n    letter-spacing: '+(0,_rem2.default)('1px')+';\n    color: '+_colors.darkGrey+';\n    font-weight: 200;\n    text-transform: uppercase;\n';var SpentBalance=exports.SpentBalance=_styledComponents2.default.div.withConfig({displayName:'styles__SpentBalance',componentId:'sc-1b73rkd-0'})(['font-family:OpenSans;font-size:',';color:',';span{font-family:Galano;font-size:',';font-weight:bold;color:',';}'],(0,_rem2.default)('12px'),_colors.posYellow,(0,_rem2.default)('12px'),_colors.posYellow);var Limit=exports.Limit=_styledComponents2.default.div.withConfig({displayName:'styles__Limit',componentId:'sc-1b73rkd-1'})(['font-family:OpenSans;font-size:',';color:',';span{font-family:Galano;font-size:',';font-weight:bold;color:',';}'],(0,_rem2.default)('12px'),_colors.posGreyInfo,(0,_rem2.default)('12px'),_colors.posGreyInfo);var BarInfoContainer=exports.BarInfoContainer=_styledComponents2.default.div.withConfig({displayName:'styles__BarInfoContainer',componentId:'sc-1b73rkd-2'})(['width:100%;display:flex;justify-content:space-between;div{padding:',';}'],(0,_rem2.default)('2px'));var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-1b73rkd-3'})(['',';margin-top:0;'],textStyles);var Usage=exports.Usage=_styledComponents2.default.p.withConfig({displayName:'styles__Usage',componentId:'sc-1b73rkd-4'})(['',';margin-top:0;display:flex;justify-content:space-between;span{font-family:OpenSans;font-size:',';font-weight:400;line-height:1.57;color:',';text-transform:none;margin-top:',';:first-child{font-family:Galano;font-size:',';font-weight:bold;}}'],textStyles,(0,_rem2.default)('14px'),_colors.darkGrey,(0,_rem2.default)('7px'),(0,_rem2.default)('18px'));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1b73rkd-5'})(['',';'],textStyles);var IndicatorList=exports.IndicatorList=_styledComponents2.default.div.withConfig({displayName:'styles__IndicatorList',componentId:'sc-1b73rkd-6'})(['display:flex;flex-direction:column;padding:0;margin:0;',';'],_media2.default.large(_templateObject,(0,_rem2.default)('12px')));var IndicatorItem=exports.IndicatorItem=_styledComponents2.default.div.withConfig({displayName:'styles__IndicatorItem',componentId:'sc-1b73rkd-7'})(['display:flex;']);var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'styles__Separator',componentId:'sc-1b73rkd-8'})(['background-color:',';border:0;height:',';margin:',' 0;'],_colors.offWhite,(0,_rem2.default)('1px'),(0,_rem2.default)('10px'));

/***/ }),
/* 1900 */
/***/ (function(module, exports) {

module.exports = {"consumptionLabel":"Tipos Consumo","indicatorLabel":{"fuel":"Abastecimento","park":"Estacionamento","toll":"Pedágio"}}

/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/DashboardCashDisplay/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(15);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _styles=__webpack_require__(1902);var _data=__webpack_require__(1903);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function renderTitle(recharge){return _data.planTypes[checkPlanType(recharge)].balance;}var currencyParser=_aleloLogic.utils.currencyParser;var checkPlanType=function checkPlanType(isPrePaid){return isPrePaid?'pre':'pos';};var DashboardCashDisplay=function DashboardCashDisplay(_ref){var recharge=_ref.recharge,updateDate=_ref.updateDate,value=_ref.value,match=_ref.match,history=_ref.history,isPartner=_ref.isPartner;return _react2.default.createElement(_styles.CashDisplay,{recharge:recharge,__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement('span',{className:'teste',__source:{fileName:_jsxFileName,lineNumber:23}},renderTitle(recharge)),updateDate),_react2.default.createElement(_gridStyled.Flex,{display:'flex',direction:['column','row'],justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement(_styles.Currency,{__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:29}},'R$'),' ',currencyParser(value)),!isPartner&&_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_Button2.default,{id:'btnManual',onClick:function onClick(){return history.push('/minha-veloe/'+match.params.id+'/'+_data.planTypes[checkPlanType(recharge)].buttonAction);},text:_data.planTypes[checkPlanType(recharge)].buttonLabel,__source:{fileName:_jsxFileName,lineNumber:33}}))));};exports.default=(0,_reactRouterDom.withRouter)(DashboardCashDisplay);module.exports=exports['default'];

/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Currency=exports.DueDate=exports.DueDateContainer=exports.Text=exports.CashDisplay=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: flex;\n        justify-content: space-between;\n    '],['\n        display: flex;\n        justify-content: space-between;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n            display: inline;\n\n            :after {\n                content: " \u2022 "\n            }\n        '],['\n            display: inline;\n\n            :after {\n                content: " \u2022 "\n            }\n        ']),_templateObject3=_taggedTemplateLiteral(['\n        margin-top: 0;\n    '],['\n        margin-top: 0;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        ',';\n        text-align: left;\n        margin-top: ',';\n    '],['\n        ',';\n        text-align: left;\n        margin-top: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CashDisplay=exports.CashDisplay=_styledComponents2.default.section.withConfig({displayName:'styles__CashDisplay',componentId:'sc-ktvugc-0'})(['',';',';'],_media2.default.small(_templateObject),function(_ref){var recharge=_ref.recharge;return!recharge&&(0,_styledComponents.css)(['margin-bottom:',';'],(0,_rem2.default)('15px'));});var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-ktvugc-1'})(['',';color:',';margin:0;text-transform:uppercase;span{display:block;',';}'],_types.txt12OpenSansLight,_colors.darkGrey,_media2.default.large(_templateObject2));var DueDateContainer=exports.DueDateContainer=_styledComponents2.default.div.withConfig({displayName:'styles__DueDateContainer',componentId:'sc-ktvugc-2'})(['text-align:right;margin-top:',';','{margin:',';}',';'],(0,_rem2.default)('10px'),Text,(0,_rem2.default)('2px'),_media2.default.large(_templateObject3));var DueDate=exports.DueDate=_styledComponents2.default.span.withConfig({displayName:'styles__DueDate',componentId:'sc-ktvugc-3'})(['font-family:Galano;font-size:',';font-weight:bold;color:',';'],(0,_rem2.default)('18px'),_colors.linkNavyBlue);var Currency=exports.Currency=_styledComponents2.default.p.withConfig({displayName:'styles__Currency',componentId:'sc-ktvugc-4'})(['',';color:',';margin:0;text-align:right;span{',';}',';'],_types.title24GalanoBold,_colors.linkNavyBlue,_types.txt40OpenSans,_media2.default.large(_templateObject4,_types.title40GalanoBold,(0,_rem2.default)('10')));

/***/ }),
/* 1903 */
/***/ (function(module, exports) {

module.exports = {"planTypes":{"pre":{"balance":"Saldo (R$)","buttonLabel":"Fazer Recarga","buttonAction":"recarga"},"pos":{"balance":"Limite disponível","buttonLabel":"Ver faturas","buttonAction":"fatura"}}}

/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/DashboardIdentifierList/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _DashboardIdentifierCard=__webpack_require__(1905);var _DashboardIdentifierCard2=_interopRequireDefault(_DashboardIdentifierCard);var _Carousel=__webpack_require__(631);var _Carousel2=_interopRequireDefault(_Carousel);var _styles=__webpack_require__(1909);var _data=__webpack_require__(1910);var _Icon=__webpack_require__(31);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DashboardIdentifierList=function DashboardIdentifierList(_ref){var accountPlans=_ref.accountPlans,match=_ref.match,resume=_ref.resume,isPartner=_ref.isPartner;var plans=accountPlans.plans,activePlanId=accountPlans.activePlanId;if(!activePlanId){return null;}var currentPlan=plans.find(function(plan){return String(plan.id)===String(activePlanId);});function filterIdentifiers(data){return data.filter(function(identifier){return identifier.active&&!identifier.blocked;});}function sortIdentifiers(data){var innerData=[].concat(_toConsumableArray(data));innerData.sort(function(current,next){return next.expense-current.expense;});return innerData;}var filteredIdentifiers=filterIdentifiers(resume.vehicles);var identifiers=sortIdentifiers(filteredIdentifiers).slice(0,3);var isSimplified=identifiers.length<=1;var showMoreText=currentPlan&&isSimplified?_data.planTypes[currentPlan.plan.type].showMore.simplified:_data.planTypes[currentPlan.plan.type].showMore.complex;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:45}},currentPlan&&_data.planTypes[currentPlan.plan.type].yourIdentifier),_react2.default.createElement(_styles.Text,{to:'/minha-veloe/'+match.params.id+'/identificadores',__source:{fileName:_jsxFileName,lineNumber:46}},isPartner?_react2.default.createElement(_styles.DesktopText,{__source:{fileName:_jsxFileName,lineNumber:48}},'Consultar Tags'):_react2.default.createElement(_styles.DesktopText,{__source:{fileName:_jsxFileName,lineNumber:50}},showMoreText),_react2.default.createElement(_styles.MobileText,{__source:{fileName:_jsxFileName,lineNumber:52}},'Ver mais'),_react2.default.createElement(_styles.Span,{__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_Icon.Icon,{icon:'right-arrow',width:'8',height:'13',viewBox:'0 0 8 13',__source:{fileName:_jsxFileName,lineNumber:54}})))),_react2.default.createElement(_styles.IdentifierList,{__source:{fileName:_jsxFileName,lineNumber:58}},_react2.default.createElement(_Carousel2.default,{hasMobileNavigation:true,fullWidth:false,__source:{fileName:_jsxFileName,lineNumber:59}},identifiers.map(function(identifier,index){return _react2.default.createElement(_DashboardIdentifierCard2.default,{key:identifier.id+index,order:index+1,isOrdered:identifiers.length>1,description:identifier.description,consumptionLabel:currentPlan&&_data.planTypes[currentPlan.plan.type].consumption,plate:identifier.plate,expense:identifier.expense,__source:{fileName:_jsxFileName,lineNumber:61}});}))));};var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{accountPlans:reducer.accountPlans};};exports.default=(0,_reactRedux.connect)(mapStateToProps)((0,_reactRouterDom.withRouter)(DashboardIdentifierList));module.exports=exports['default'];

/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/DashboardIdentifierCard/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _styles=__webpack_require__(1906);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var currencyParser=_aleloLogic.utils.currencyParser;var DashboardIdentifierCard=function DashboardIdentifierCard(_ref){var consumptionLabel=_ref.consumptionLabel,order=_ref.order,isOrdered=_ref.isOrdered,plate=_ref.plate,expense=_ref.expense;var licensePlateLetters=plate.slice(0,3);var licensePlateNumbers=plate.slice(3);return _react2.default.createElement(_styles.Container,{isOrdered:isOrdered&&order,__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(_styles.Info,{__source:{fileName:_jsxFileName,lineNumber:24}},plate&&_react2.default.createElement(_styles.LicensePlate,{__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_styles.LicenseLabel,{__source:{fileName:_jsxFileName,lineNumber:27}},'Placa'),_react2.default.createElement(_styles.LicenseCode,{__source:{fileName:_jsxFileName,lineNumber:28}},licensePlateLetters,_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:30}},licensePlateNumbers))),_react2.default.createElement(_styles.Tax,{__source:{fileName:_jsxFileName,lineNumber:35}},_react2.default.createElement(_styles.DriverName,{__source:{fileName:_jsxFileName,lineNumber:36}},consumptionLabel),_react2.default.createElement(_styles.Currency,{__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_styles.CurrencySign,{__source:{fileName:_jsxFileName,lineNumber:38}},'R$'),currencyParser(expense)))));};DashboardIdentifierCard.defaultProps={carNickname:'',driverName:'',order:0,licensePlate:'',tax:''};exports.default=DashboardIdentifierCard;module.exports=exports['default'];

/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Container=exports.Order=exports.CarNickname=exports.ShowMore=exports.CurrencyLabel=exports.CurrencySign=exports.Currency=exports.DriverName=exports.Tax=exports.LicenseCode=exports.LicenseLabel=exports.LicensePlate=exports.Info=undefined;var _templateObject=_taggedTemplateLiteral(['\n        margin-bottom: ',';\n    '],['\n        margin-bottom: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Info=exports.Info=_styledComponents2.default.div.withConfig({displayName:'styles__Info',componentId:'sc-1f03ud4-0'})(['display:flex;justify-content:space-between;margin-bottom:',';',';'],(0,_rem2.default)('19px'),_media2.default.large(_templateObject,(0,_rem2.default)('15px')));var LicensePlate=exports.LicensePlate=_styledComponents2.default.h3.withConfig({displayName:'styles__LicensePlate',componentId:'sc-1f03ud4-1'})(['line-height:0;margin:0;']);var LicenseLabel=exports.LicenseLabel=_styledComponents2.default.span.withConfig({displayName:'styles__LicenseLabel',componentId:'sc-1f03ud4-2'})(['',';color:',';display:inline-block;line-height:1;margin-bottom:',';text-align:left;text-transform:uppercase;'],_types.txt12OpenSansLight,_colors.darkGrey,(0,_rem2.default)('10px'));var LicenseCode=exports.LicenseCode=_styledComponents2.default.strong.withConfig({displayName:'styles__LicenseCode',componentId:'sc-1f03ud4-3'})(['',';color:',';display:block;line-height:1;text-align:left;white-space:nowrap;span{font-family:Galano;font-weight:bold;}'],_types.txt20OpenSans,_colors.linkNavyBlue);var Tax=exports.Tax=_styledComponents2.default.div.withConfig({displayName:'styles__Tax',componentId:'sc-1f03ud4-4'})(['margin:0;text-align:right;']);var DriverName=exports.DriverName=_styledComponents2.default.p.withConfig({displayName:'styles__DriverName',componentId:'sc-1f03ud4-5'})(['',';color:',';font-weight:200;line-height:1;margin:0 0 ',';'],_types.txt12OpenSans,_colors.darkGrey,(0,_rem2.default)('10px'));var Currency=exports.Currency=_styledComponents2.default.p.withConfig({displayName:'styles__Currency',componentId:'sc-1f03ud4-6'})(['',';color:',';display:flex;justify-content:flex-end;letter-spacing:0;line-height:1em;margin:0;'],_types.title20GalanoBold,_colors.linkNavyBlue);var CurrencySign=exports.CurrencySign=_styledComponents2.default.span.withConfig({displayName:'styles__CurrencySign',componentId:'sc-1f03ud4-7'})(['',';margin-right:5px;'],_types.txt20OpenSans);var CurrencyLabel=exports.CurrencyLabel=_styledComponents2.default.span.withConfig({displayName:'styles__CurrencyLabel',componentId:'sc-1f03ud4-8'})(['',';color:',';'],_types.txt10OpenSans,_colors.grey);var ShowMore=exports.ShowMore=_styledComponents2.default.div.withConfig({displayName:'styles__ShowMore',componentId:'sc-1f03ud4-9'})(['align-items:center;display:flex;justify-content:space-between;min-height:',';margin-right:',';margin-bottom:',';'],(0,_rem2.default)('20px'),(0,_rem2.default)('18px'),(0,_rem2.default)('10px'));var CarNickname=exports.CarNickname=_styledComponents2.default.strong.withConfig({displayName:'styles__CarNickname',componentId:'sc-1f03ud4-10'})(['',';color:',';font-weight:400;text-align:center;'],_types.txt12OpenSansLight,_colors.darkGrey);var Order=exports.Order=_styledComponents2.default.strong.withConfig({displayName:'styles__Order',componentId:'sc-1f03ud4-11'})(['',';background-color:#f1f1f7;color:#292663;padding:',';'],_types.title28GalanoBold,(0,_rem2.default)('13px'));var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-1f03ud4-12'})(['background-color:',';border-radius:',';border:solid ',' ',';padding:',' ',' ',';',';'],_colors.white,(0,_rem2.default)('4.4px'),(0,_rem2.default)('1px'),_colors.grey,(0,_rem2.default)('18px'),(0,_rem2.default)('20px'),(0,_rem2.default)('14px'),function(_ref){var isOrdered=_ref.isOrdered;return isOrdered&&(0,_styledComponents.css)(['display:flex;flex-direction:column;padding:0;','{margin-bottom:',';}','{flex:1;padding:',';margin:0;height:100px;}','{margin-bottom:',';}','{display:block;}'],LicensePlate,(0,_rem2.default)('20px'),Info,(0,_rem2.default)('16px'),DriverName,(0,_rem2.default)('10px'),Currency);});

/***/ }),
/* 1907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.CarouselWrapper=exports.NavItem=exports.NavigatorList=exports.Navigator=exports.List=exports.IconColor=exports.Item=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ','\n    '],['\n        ','\n    ']),_templateObject2=_taggedTemplateLiteral(['\n                        flex: ',';\n                        :not(:last-child) {\n                            margin-right: ',';\n                        }\n                    '],['\n                        flex: ',';\n                        :not(:last-child) {\n                            margin-right: ',';\n                        }\n                    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Item=exports.Item=_styledComponents2.default.li.withConfig({displayName:'styles__Item',componentId:'sc-afl80i-0'})(['margin:0;',' &:last-child{max-width:100%;}'],function(props){return props.flexibleWidth&&(0,_styledComponents.css)(['max-width:',';'],(0,_rem2.default)('190px'));});var IconColor=exports.IconColor='fill: '+_colors.linkNavyBlue;var List=exports.List=_styledComponents2.default.ul.withConfig({displayName:'styles__List',componentId:'sc-afl80i-1'})(['list-style:none;margin:0;padding:0;']);var Navigator=exports.Navigator=_styledComponents2.default.nav.withConfig({displayName:'styles__Navigator',componentId:'sc-afl80i-2'})(['padding:1em;text-align:center;',';'],_media2.default.large(_templateObject,function(_ref){var hasArrow=_ref.hasArrow;return hasArrow&&(0,_styledComponents.css)(['display:flex;flex-direction:row;justify-content:space-between;padding-top:0;padding-bottom:0;']);}));var NavigatorList=exports.NavigatorList=_styledComponents2.default.ul.withConfig({displayName:'styles__NavigatorList',componentId:'sc-afl80i-3'})(['margin:0;padding:0;display:flex;align-items:center;justify-content:center;']);var NavItem=exports.NavItem=_styledComponents2.default.li.withConfig({displayName:'styles__NavItem',componentId:'sc-afl80i-4'})(['-webkit-transition:all .5s;background-clip:content-box;background-color:',';border-radius:50%;border:',';solid transparent;cursor:pointer;display:inline-block;height:',';height:',';list-style:none;margin:0 ',';transition:all .5s;width:',';width:',';',''],_colors.grey,(0,_rem2.default)('1px'),(0,_rem2.default)('12px'),(0,_rem2.default)('8px'),(0,_rem2.default)('3px'),(0,_rem2.default)('12px'),(0,_rem2.default)('8px'),function(props){return props.active&&'\n        background-color: '+_colors.linkNavyBlue+';\n    ';});var CarouselWrapper=exports.CarouselWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__CarouselWrapper',componentId:'sc-afl80i-5'})(['overflow:hidden;width:100%;',';'],function(_ref2){var mobileOnly=_ref2.mobileOnly;return mobileOnly&&(0,_styledComponents.css)(['> ','{> ','{cursor:default;',' ',';}}'],List,Item,function(_ref3){var startedCarousel=_ref3.startedCarousel,fullWidth=_ref3.fullWidth;return!startedCarousel&&(0,_styledComponents.css)(['',';'],_media2.default.large(_templateObject2,fullWidth?'1':'.5',(0,_rem2.default)('20px')));},function(_ref4){var startedCarousel=_ref4.startedCarousel;return startedCarousel&&'\n                    flex: none;\n                    cursor: move;\n                ';});});

/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DesktopText=exports.MobileText=exports.IdentifierItem=exports.IdentifierList=exports.Span=exports.Text=exports.Title=exports.Header=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: flex;\n        margin-top: ',';\n    '],['\n        display: flex;\n        margin-top: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        :not(:last-child) {\n            margin-right: ',';\n        }\n    '],['\n        :not(:last-child) {\n            margin-right: ',';\n        }\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        display: none;\n    '],['\n        display: none;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=exports.Header=_styledComponents2.default.header.withConfig({displayName:'styles__Header',componentId:'sc-1097qc9-0'})(['color:',';display:flex;justify-content:space-between;width:100%;'],_colors.darkGrey);var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-1097qc9-1'})(['',';color:',';letter-spacing:',';margin:13px 0 ',';text-transform:uppercase;'],_types.txt12OpenSansLight,_colors.darkGrey,(0,_rem2.default)('1px'),(0,_rem2.default)('22px'));var Text=exports.Text=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__Text',componentId:'sc-1097qc9-2'})(['',' color:',';cursor:pointer;font-weight:700;letter-spacing:',';margin:',';text-decoration:none;'],_types.txt14OpenSans,_colors.linkNavyBlue,(0,_rem2.default)('-0.4px'),(0,_rem2.default)('10px'));var Span=exports.Span=_styledComponents2.default.span.withConfig({displayName:'styles__Span',componentId:'sc-1097qc9-3'})(['color:',';padding-left:',';'],_colors.linkNavyBlue,(0,_rem2.default)('9px'));var IdentifierList=exports.IdentifierList=_styledComponents2.default.div.withConfig({displayName:'styles__IdentifierList',componentId:'sc-1097qc9-4'})(['',';'],_media2.default.large(_templateObject,(0,_rem2.default)('5px')));var IdentifierItem=exports.IdentifierItem=_styledComponents2.default.div.withConfig({displayName:'styles__IdentifierItem',componentId:'sc-1097qc9-5'})(['flex:1;',';'],_media2.default.large(_templateObject2,(0,_rem2.default)('20px')));var MobileText=exports.MobileText=_styledComponents2.default.span.withConfig({displayName:'styles__MobileText',componentId:'sc-1097qc9-6'})(['',';'],_media2.default.large(_templateObject3));var DesktopText=exports.DesktopText=_styledComponents2.default.span.withConfig({displayName:'styles__DesktopText',componentId:'sc-1097qc9-7'})(['',';'],_media2.default.small(_templateObject3));

/***/ }),
/* 1910 */
/***/ (function(module, exports) {

module.exports = {"planTypes":{"pre":{"showMore":{"simplified":"Ative aqui sua VeloeTag","complex":"Ative aqui sua VeloeTag"},"yourIdentifier":"Suas VeloeTags","consumption":"Valor consumido"},"pos":{"showMore":{"simplified":"Ver todas as VeloeTags","complex":"Ver todas as VeloeTags"},"yourIdentifier":"Suas VeloeTags","consumption":"Valor consumido"}}}

/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.WrapperModal=exports.ModalDescription=exports.ModalTitle=exports.ModalIllustration=exports.LinkBanner=exports.WarningDisclaimer=exports.WarningSubtitle=exports.WarningContent=exports.Separator=undefined;var _templateObject=_taggedTemplateLiteral(['\n  font-size: ',';\n    line-height: 1.04;\n    max-width: ',';\n    text-align: left;\n  '],['\n  font-size: ',';\n    line-height: 1.04;\n    max-width: ',';\n    text-align: left;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    text-align: left;\n  '],['\n    text-align: left;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'styles__Separator',componentId:'sc-loxhbb-0'})(['background-color:',';border:0;height:',';margin:',' 0;'],_colors.offWhite,(0,_rem2.default)('1px'),(0,_rem2.default)('20px'));var WarningContent=exports.WarningContent=_styledComponents2.default.div.withConfig({displayName:'styles__WarningContent',componentId:'sc-loxhbb-1'})(['color:',';font-family:OpenSans;font-size:',';'],_colors.darkBlue,(0,_rem2.default)('14px'));var WarningSubtitle=exports.WarningSubtitle=_styledComponents2.default.div.withConfig({displayName:'styles__WarningSubtitle',componentId:'sc-loxhbb-2'})(['margin-bottom:',';font-size:',';font-weight:600;'],(0,_rem2.default)('4px'),(0,_rem2.default)('16px'));var WarningDisclaimer=exports.WarningDisclaimer=_styledComponents2.default.div.withConfig({displayName:'styles__WarningDisclaimer',componentId:'sc-loxhbb-3'})(['margin-top:',';margin-bottom:',';font-size:',';font-weight:600;'],(0,_rem2.default)('24px'),(0,_rem2.default)('36px'),(0,_rem2.default)('12px'));var LinkBanner=exports.LinkBanner=_styledComponents2.default.a.withConfig({displayName:'styles__LinkBanner',componentId:'sc-loxhbb-4'})(['',' color:',';font-weight:normal;letter-spacing:$normal;line-height:1.5;white-space:normal;cursor:pointer;text-decoration:underline;'],_types.txt16OpenSans,_colors.darkBlue);var ModalIllustration=exports.ModalIllustration=_styledComponents2.default.img.withConfig({displayName:'styles__ModalIllustration',componentId:'sc-loxhbb-5'})(['display:block;margin:0 auto;width:32%;display:block;max-height:88%;position:absolute;right:',';top:51%;transform:translateY(-50%) translateX(0%);'],(0,_rem2.default)('50px'));var ModalTitle=exports.ModalTitle=_styledComponents2.default.h1.withConfig({displayName:'styles__ModalTitle',componentId:'sc-loxhbb-6'})(['color:',';font-family:\'Galano\';font-size:',';font-weight:600;line-height:1.17;margin:0;text-align:center;',';svg{margin-left:-5px;g{fill:#fff !important;}}'],_colors.offWhite,(0,_rem2.default)('24px'),_media2.default.large(_templateObject,function(props){return props.compact?(0,_rem2.default)('24px'):(0,_rem2.default)('26px');},(0,_rem2.default)('215px')));var ModalDescription=exports.ModalDescription=_styledComponents2.default.h1.withConfig({displayName:'styles__ModalDescription',componentId:'sc-loxhbb-7'})(['',' color:',';font-weight:normal;letter-spacing:$normal;line-height:1.5;margin-bottom:',';white-space:normal;width:100%;max-width:',';',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('20px'),(0,_rem2.default)('320px'),_media2.default.large(_templateObject2));var WrapperModal=exports.WrapperModal=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperModal',componentId:'sc-loxhbb-8'})(['div > div{min-height:168px !important;margin-top:-14px;margin-bottom:-11px;}div > div > div{overflow-x:hidden;}']);

/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/DashboardInvoiceWidget/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _DashboardInvoiceCard=__webpack_require__(1913);var _DashboardInvoiceCard2=_interopRequireDefault(_DashboardInvoiceCard);var _Icon=__webpack_require__(31);var _styles=__webpack_require__(1915);var _data=__webpack_require__(1916);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DashboardInvoice=function DashboardInvoice(_ref){var currentAccountPlan=_ref.currentAccountPlan,match=_ref.match,isPartner=_ref.isPartner;return currentAccountPlan&&_react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:15}},_data.title),!isPartner&&_react2.default.createElement(_styles.Text,{to:'/minha-veloe/'+match.params.id+'/fatura',__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement(_styles.DesktopText,{__source:{fileName:_jsxFileName,lineNumber:19}},_data.desktopText),_react2.default.createElement(_styles.MobileText,{__source:{fileName:_jsxFileName,lineNumber:20}},_data.mobileText),_react2.default.createElement(_styles.Span,{__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_Icon.Icon,{icon:'right-arrow',width:'8',height:'13',viewBox:'0 0 8 13',__source:{fileName:_jsxFileName,lineNumber:22}})))),_react2.default.createElement(_styles.InvoiceList,{__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement(_DashboardInvoiceCard2.default,{currentAccountPlan:currentAccountPlan,__source:{fileName:_jsxFileName,lineNumber:28}})));};exports.default=DashboardInvoice;module.exports=exports['default'];

/***/ }),
/* 1913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/DashboardInvoiceCard/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _styles=__webpack_require__(1914);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var currencyParser=_aleloLogic.utils.currencyParser;var DashboardInvoiceCard=function DashboardInvoiceCard(_ref){var currentAccountPlan=_ref.currentAccountPlan;return currentAccountPlan&&_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement(_styles.Info,{__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_styles.InvoiceValue,{__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_styles.ValueLabel,{__source:{fileName:_jsxFileName,lineNumber:14}},'Fatura Atual'),_react2.default.createElement(_styles.Currency,{__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:16}},'R$'),currencyParser(currentAccountPlan.ammount))),_react2.default.createElement(_styles.InvoiceValue,{__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_styles.ValueLabel,{__source:{fileName:_jsxFileName,lineNumber:21}},'Limite Dispon\xEDvel'),_react2.default.createElement(_styles.Currency,{lightBlue:true,__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:23}},'R$'),currencyParser(currentAccountPlan.availableAmount)))),_react2.default.createElement(_styles.Details,{__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement('p',{__source:{fileName:_jsxFileName,lineNumber:29}},'Fechamento da fatura em',' ',_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:31}},currentAccountPlan.posData&&_aleloLogic.utils.ISODateFormat(currentAccountPlan.posData.cutDay))),_react2.default.createElement('p',{__source:{fileName:_jsxFileName,lineNumber:35}},'Vencimento em',' ',_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:37}},currentAccountPlan.posData&&_aleloLogic.utils.ISODateFormat(currentAccountPlan.posData.payDay)))));};exports.default=DashboardInvoiceCard;module.exports=exports['default'];

/***/ }),
/* 1914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Container=exports.Currency=exports.Details=exports.ValueLabel=exports.InvoiceValue=exports.Info=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Info=exports.Info=_styledComponents2.default.div.withConfig({displayName:'styles__Info',componentId:'sc-3zq1o9-0'})(['display:flex;justify-content:space-between;']);var InvoiceValue=exports.InvoiceValue=_styledComponents2.default.div.withConfig({displayName:'styles__InvoiceValue',componentId:'sc-3zq1o9-1'})(['margin:',' ',' 0 ',';'],(0,_rem2.default)('15px'),(0,_rem2.default)('15px'),(0,_rem2.default)('15px'));var ValueLabel=exports.ValueLabel=_styledComponents2.default.span.withConfig({displayName:'styles__ValueLabel',componentId:'sc-3zq1o9-2'})(['',';color:',';display:inline-block;line-height:1;margin-bottom:',';text-align:left;text-transform:uppercase;'],_types.txt12OpenSansLight,_colors.darkGrey,(0,_rem2.default)('4px'));var Details=exports.Details=_styledComponents2.default.div.withConfig({displayName:'styles__Details',componentId:'sc-3zq1o9-3'})(['margin:',';color:',';text-align:left;display:flex;flex-direction:column;',' span{font-weight:bold;}}p{margin:0;}'],(0,_rem2.default)('15px'),_colors.darkBlue,_types.txt12OpenSans);var Currency=exports.Currency=_styledComponents2.default.p.withConfig({displayName:'styles__Currency',componentId:'sc-3zq1o9-4'})(['',';color:',';display:flex;justify-content:flex-end;letter-spacing:0;line-height:1em;margin:0;padding-bottom:',';padding-top:',';span{',';margin-right:',';}'],_types.title20GalanoBold,function(_ref){var lightBlue=_ref.lightBlue;return lightBlue?_colors.skyBlue:_colors.darkBlue;},(0,_rem2.default)('15px'),(0,_rem2.default)('15px'),_types.txt20OpenSans,(0,_rem2.default)('3px'));var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-3zq1o9-5'})(['background-color:',';border-radius:',';border:solid ',' ',';display:flex;flex-direction:column;'],_colors.white,(0,_rem2.default)('4.4px'),(0,_rem2.default)('1px'),_colors.grey);

/***/ }),
/* 1915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DesktopText=exports.MobileText=exports.InvoiceList=exports.Span=exports.Text=exports.Title=exports.Header=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: flex;\n        margin-top: ',';\n    '],['\n        display: flex;\n        margin-top: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        display: none;\n    '],['\n        display: none;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=exports.Header=_styledComponents2.default.header.withConfig({displayName:'styles__Header',componentId:'sc-1fim3nz-0'})(['color:',';display:flex;justify-content:space-between;width:100%;'],_colors.darkGrey);var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-1fim3nz-1'})(['',';color:',';letter-spacing:',';margin:13px 0 ',';text-transform:uppercase;'],_types.txt12OpenSansLight,_colors.darkGrey,(0,_rem2.default)('1px'),(0,_rem2.default)('22px'));var Text=exports.Text=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__Text',componentId:'sc-1fim3nz-2'})(['',' color:',';cursor:pointer;font-weight:700;letter-spacing:',';margin:',';text-decoration:none;'],_types.txt14OpenSans,_colors.linkNavyBlue,(0,_rem2.default)('-0.4px'),(0,_rem2.default)('10px'));var Span=exports.Span=_styledComponents2.default.span.withConfig({displayName:'styles__Span',componentId:'sc-1fim3nz-3'})(['color:',';padding-left:',';'],_colors.linkNavyBlue,(0,_rem2.default)('9px'));var InvoiceList=exports.InvoiceList=_styledComponents2.default.div.withConfig({displayName:'styles__InvoiceList',componentId:'sc-1fim3nz-4'})(['',';'],_media2.default.large(_templateObject,(0,_rem2.default)('5px')));var MobileText=exports.MobileText=_styledComponents2.default.span.withConfig({displayName:'styles__MobileText',componentId:'sc-1fim3nz-5'})(['',';'],_media2.default.large(_templateObject2));var DesktopText=exports.DesktopText=_styledComponents2.default.span.withConfig({displayName:'styles__DesktopText',componentId:'sc-1fim3nz-6'})(['',';'],_media2.default.small(_templateObject2));

/***/ }),
/* 1916 */
/***/ (function(module, exports) {

module.exports = {"title":"Sua Fatura","desktopText":"Ver todas as faturas","mobileText":"Ver mais"}

/***/ }),
/* 1917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardResume/InfoCarousel/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(43);var _carousel=__webpack_require__(632);var _carousel2=_interopRequireDefault(_carousel);var _styles=__webpack_require__(1918);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AUTO_SLIDE_TIMEOUT=5000;var InfoCarouselWrapper=function(_React$Component){_inherits(InfoCarouselWrapper,_React$Component);function InfoCarouselWrapper(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InfoCarouselWrapper);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InfoCarouselWrapper.__proto__||Object.getPrototypeOf(InfoCarouselWrapper)).call.apply(_ref,[this].concat(args))),_this),_this.state={activeSlide:null},_this.mountCarousel=function(){var options={onSlide:function onSlide(to){return _this.moveCarousel(to);},activeClass:'active',slideWrap:'ul',slides:'li',infinite:false,display:1,disableDragging:false,initialIndex:0};if(_this._carousel){_this.carousel=new _carousel2.default(_this._carousel,options);_this.setState({startedCarousel:true,activeSlide:_this.carousel.current});}},_this.scheduleSlideNext=function(){if(_this.carouselTimeout){clearTimeout(_this.carouselTimeout);}_this.carouselTimeout=setTimeout(_this.slideNext,AUTO_SLIDE_TIMEOUT);},_this.slideNext=function(){var activeSlide=_this.state.activeSlide;var slidesAmount=_this.props.children.length;_this.moveCarousel((activeSlide+1)%slidesAmount,true);},_this.moveCarousel=function(to,withTransition){if(withTransition){_this.carousel.go(to);}_this.setState({activeSlide:to});_this.scheduleSlideNext();},_this.registerCarouselRef=function(ref){_this._carousel=ref;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InfoCarouselWrapper,[{key:'componentDidMount',value:function componentDidMount(){if(typeof window==='undefined'){return;}if(!this.carousel){this.mountCarousel();}this.scheduleSlideNext();}},{key:'componentWillUnmount',value:function componentWillUnmount(){console.log('...');clearTimeout(this.carouselTimeout);}},{key:'render',value:function render(){var _this2=this;var listItems=(0,_lodash.compact)(this.props.children);var activeSlide=this.state.activeSlide;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:84}},_react2.default.createElement(_styles.Wrapper,{className:'carousel',innerRef:this.registerCarouselRef,__source:{fileName:_jsxFileName,lineNumber:85}},_react2.default.createElement('ul',{className:'wrap',__source:{fileName:_jsxFileName,lineNumber:86}},listItems.map(function(child,index){return _react2.default.createElement('li',{key:index,__source:{fileName:_jsxFileName,lineNumber:87}},' ',child,' ');}))),_react2.default.createElement(_styles.Navigator,{__source:{fileName:_jsxFileName,lineNumber:91}},listItems.map(function(_,index){var _React$createElement;return _react2.default.createElement(_styles.NavigatorButton,(_React$createElement={type:'button',key:index,active:activeSlide===index,onClick:function onClick(){return _this2.moveCarousel(index,true);}},_defineProperty(_React$createElement,'key',index),_defineProperty(_React$createElement,'__source',{fileName:_jsxFileName,lineNumber:93}),_React$createElement));})));}}]);return InfoCarouselWrapper;}(_react2.default.Component);exports.default=InfoCarouselWrapper;module.exports=exports['default'];

/***/ }),
/* 1918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.NavigatorButton=exports.Navigator=exports.Wrapper=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Wrapper=exports.Wrapper=_styledComponents2.default.section.withConfig({displayName:'styles__Wrapper',componentId:'sc-febkal-0'})(['margin-top:30px;display:flex;overflow:hidden;.wrap{white-space:normal;background-color:',';}.active{cursor:unset !important;}'],_colors.offWhite);var Navigator=exports.Navigator=_styledComponents2.default.div.withConfig({displayName:'styles__Navigator',componentId:'sc-febkal-1'})(['position:relative;bottom:56px;left:24px;']);var NavigatorButton=exports.NavigatorButton=_styledComponents2.default.button.withConfig({displayName:'styles__NavigatorButton',componentId:'sc-febkal-2'})(['background-color:',';height:6px;width:18px;border:none;border-radius:6px;margin:16px 8px;cursor:pointer;outline:none;',';'],_colors.grey,function(props){return props.active&&'\n      background-color: '+_colors.linkNavyBlue+';\n      width: 28px\n  ';});

/***/ }),
/* 1919 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Editar Dados Pessoais","title":"Dados pessoais","subtitle":"Aqui você pode editar suas informações para deixar a gente sempre atualizado. :)","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","rechargeButtonLabel":"Fazer recarga","warningModalTitle":"Aviso pra você ;)","warningModalSubtitle":"Fique atento","warningModalDisclaimer":"*Veículos com mais de 6 eixos não poderão exceder 20km/h ou inferior se previsto.","warningModalConfirm":"Ok"}

/***/ }),
/* 1920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toll=__webpack_require__(1921);var _toll2=_interopRequireDefault(_toll);var _checkApp=__webpack_require__(1924);var _checkApp2=_interopRequireDefault(_checkApp);var _signalization=__webpack_require__(1926);var _signalization2=_interopRequireDefault(_signalization);var _irrfAutoRetencao=__webpack_require__(1928);var _irrfAutoRetencao2=_interopRequireDefault(_irrfAutoRetencao);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={Toll:_toll2.default,CheckApp:_checkApp2.default,Signalization:_signalization2.default,IrrfAutoRetencao:_irrfAutoRetencao2.default};module.exports=exports['default'];

/***/ }),
/* 1921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardResume/Warning/toll.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _base=__webpack_require__(257);var _base2=_interopRequireDefault(_base);var _illustrationManMegaphone=__webpack_require__(1923);var _illustrationManMegaphone2=_interopRequireDefault(_illustrationManMegaphone);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Toll=function Toll(){return _react2.default.createElement(_base2.default,{content:_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:9}},'Ande sempre a ',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:10}},'40 km/h ou menos'),', conforme a legisla\xE7\xE3o local.*',_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:10}}),'Mantenha ao menos 30 (trinta) metros do ve\xEDculo \xE0 sua frente.',_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:12}}),_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:13}}),_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:14}},'*Ve\xEDculos com mais de 6 eixos n\xE3o poder\xE3o exceder 20km/h ou inferior se previsto.')),image:_react2.default.createElement('img',{src:_illustrationManMegaphone2.default,className:'WarningImage-megaphone',alt:'man-megaphone',__source:{fileName:_jsxFileName,lineNumber:18}}),__source:{fileName:_jsxFileName,lineNumber:7}});};exports.default=Toll;module.exports=exports['default'];

/***/ }),
/* 1922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Body=exports.Title=exports.ContainerContent=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n    margin: 20px;\n  '],['\n    margin: 20px;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-1coimpc-0'})(['display:flex;flex-direction:row;border-radius:4.4px;height:100%;width:100%;background-color:',';b{color:',';}.WarningImage-megaphone{position:absolute;right:10px;bottom:0;}.WarningImage-irrf{position:absolute;right:1px;bottom:0;}.WarningImage-mobile{position:absolute;right:54px;bottom:124px;}.WarningImage-signal{position:absolute;right:64px;bottom:0;}'],_colors.offWhite,_colors.linkNavyBlue);var ContainerContent=exports.ContainerContent=_styledComponents2.default.div.withConfig({displayName:'styles__ContainerContent',componentId:'sc-1coimpc-1'})(['width:351px;margin:30px;',';'],_media2.default.small(_templateObject));var Title=exports.Title=_styledComponents2.default.p.withConfig({displayName:'styles__Title',componentId:'sc-1coimpc-2'})(['',';color:',';margin:0;'],_types.title24GalanoBold,_colors.linkNavyBlue);var Body=exports.Body=_styledComponents2.default.div.withConfig({displayName:'styles__Body',componentId:'sc-1coimpc-3'})(['',';margin-top:24px;color:',';'],_types.txt14OpenSans,_colors.darkGrey);

/***/ }),
/* 1923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/illustration-man-megaphone.b3284927.svg";

/***/ }),
/* 1924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardResume/Warning/check-app.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _base=__webpack_require__(257);var _base2=_interopRequireDefault(_base);var _illustrationMobile=__webpack_require__(1925);var _illustrationMobile2=_interopRequireDefault(_illustrationMobile);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CheckApp=function CheckApp(){return _react2.default.createElement(_base2.default,{content:_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:10}},'Vai pegar a estrada?'),' Consulte o app, veja se sua VeloeTag est\xE1 ativa e seu saldo.',_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:11}}),_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:12}}),'Conte com a gente para descomplicar o seu caminho!'),image:_react2.default.createElement('img',{src:_illustrationMobile2.default,className:'WarningImage-mobile',alt:'mobile',__source:{fileName:_jsxFileName,lineNumber:16}}),__source:{fileName:_jsxFileName,lineNumber:7}});};exports.default=CheckApp;module.exports=exports['default'];

/***/ }),
/* 1925 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/illustration-mobile.73c575eb.svg";

/***/ }),
/* 1926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardResume/Warning/signalization.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _base=__webpack_require__(257);var _base2=_interopRequireDefault(_base);var _illustrationSignal=__webpack_require__(1927);var _illustrationSignal2=_interopRequireDefault(_illustrationSignal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Signalization=function Signalization(){return _react2.default.createElement(_base2.default,{content:_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:9}},'Ao ver um ',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:10}},'sinal vermelho'),' na pista, ',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:10}},'pare e siga as orienta\xE7\xF5es do agente.'),' Assim voc\xEA evita multa por evas\xE3o de ped\xE1gio.'),image:_react2.default.createElement('img',{src:_illustrationSignal2.default,className:'WarningImage-signal',alt:'sinal',__source:{fileName:_jsxFileName,lineNumber:14}}),__source:{fileName:_jsxFileName,lineNumber:7}});};exports.default=Signalization;module.exports=exports['default'];

/***/ }),
/* 1927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/illustration-signal.2db6aae0.svg";

/***/ }),
/* 1928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardResume/Warning/irrf-auto-retencao.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _base=__webpack_require__(257);var _base2=_interopRequireDefault(_base);var _irrfAutoRetencao=__webpack_require__(628);var _irrfAutoRetencao2=_interopRequireDefault(_irrfAutoRetencao);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IrrfAutoRetencao=function IrrfAutoRetencao(){return _react2.default.createElement(_base2.default,{content:_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:8}},'Irrf Auto Reten\xE7\xE3o.'),image:_react2.default.createElement('img',{src:_irrfAutoRetencao2.default,className:'WarningImage-irrf',alt:'irrf',__source:{fileName:_jsxFileName,lineNumber:9}}),__source:{fileName:_jsxFileName,lineNumber:7}});};exports.default=IrrfAutoRetencao;module.exports=exports['default'];

/***/ }),
/* 1929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ModalDesligamento/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(1930);var _closeIcon=__webpack_require__(625);var _closeIcon2=_interopRequireDefault(_closeIcon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ModalDesligamento=function(_Component){_inherits(ModalDesligamento,_Component);function ModalDesligamento(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalDesligamento);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalDesligamento.__proto__||Object.getPrototypeOf(ModalDesligamento)).call.apply(_ref,[this].concat(args))),_this),_this.state={shouldShowModal:true},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalDesligamento,[{key:'closeModal',value:function closeModal(){this.setState({shouldShowModal:false});}},{key:'checkSessionStorage',value:function checkSessionStorage(key){if(typeof sessionStorage!=='undefined'){var data=sessionStorage.getItem(key);return data?JSON.parse(data):null;}return null;}},{key:'writeSessionStorage',value:function writeSessionStorage(key,data){sessionStorage.setItem(key,JSON.stringify(data));}},{key:'componentDidMount',value:function componentDidMount(){var modalHasBeenShown=this.checkSessionStorage('modalDesligamento');if(modalHasBeenShown){this.setState({shouldShowModal:false});}else{this.writeSessionStorage('modalDesligamento','true');}}},{key:'render',value:function render(){var shouldShowModal=this.state.shouldShowModal;if(!shouldShowModal){return null;}return _react2.default.createElement(_styles.Overlay,{__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement(_styles.Alert,{__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_styles.Modal,{__source:{fileName:_jsxFileName,lineNumber:47}},_react2.default.createElement(_styles.ModalHeader,{__source:{fileName:_jsxFileName,lineNumber:48}},_react2.default.createElement('button',{onClick:this.closeModal.bind(this),__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement('img',{alt:'close icon',src:_closeIcon2.default,__source:{fileName:_jsxFileName,lineNumber:50}}))),_react2.default.createElement('h1',{__source:{fileName:_jsxFileName,lineNumber:53}},'Ol\xE1, parceiro (a)!'),_react2.default.createElement('p',{__source:{fileName:_jsxFileName,lineNumber:54}},'Estamos de mudan\xE7a para uma casa nova, maior e com tudo que voc\xEA precisa para gerenciar suas tags.'),_react2.default.createElement('p',{__source:{fileName:_jsxFileName,lineNumber:58}},'Por isso, a partir de 20/07/2023 esse portal ser\xE1 desligado. Mas fique tranquilo(a), todas as funcionalidades j\xE1 est\xE3o dispon\xEDveis no novo portal.'),_react2.default.createElement(_styles.ModalButton,{href:'https://portal-parceiro.veloe.com.br',__source:{fileName:_jsxFileName,lineNumber:62}},'Acessar novo portal'))));}}]);return ModalDesligamento;}(_react.Component);exports.default=ModalDesligamento;module.exports=exports['default'];

/***/ }),
/* 1930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ModalHeader=exports.ModalButton=exports.Modal=exports.Alert=exports.Overlay=undefined;var _templateObject=_taggedTemplateLiteral(['\n        padding: 15px 24px;\n    '],['\n        padding: 15px 24px;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        max-width: 100%;\n        font-size:',';\n    '],['\n        max-width: 100%;\n        font-size:',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _bgModalDesligamento=__webpack_require__(621);var _bgModalDesligamento2=_interopRequireDefault(_bgModalDesligamento);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Overlay=exports.Overlay=_styledComponents2.default.div.withConfig({displayName:'styles__Overlay',componentId:'sc-1iglw6h-0'})(['position:fixed;z-index:2000;bottom:0;top:0%;left:0;background:rgba(0,0,0,0.4);height:100%;width:100%;']);var Alert=exports.Alert=_styledComponents2.default.div.withConfig({displayName:'styles__Alert',componentId:'sc-1iglw6h-1'})(['position:absolute;display:flex;justify-content:center;width:100%;z-index:2001;left:50%;top:50%;transform:translate(-50%,-50%);']);var Modal=exports.Modal=_styledComponents2.default.div.withConfig({displayName:'styles__Modal',componentId:'sc-1iglw6h-2'})(['z-index:2002;padding:45px 64px;width:1000px;max-width:90%;background-color:#25d6e9;background-image:url(',');background-repeat:no-repeat;background-position:center right;background-size:contain;color:#230c87;',';h1{font-size:',';font-family:Galano;font-weight:700;margin:0 0 43px 0;',';}p{font-size:',';font-weight:400;font-family:\'Open Sans\',sans-serif;max-width:60%;margin:0 0 24px 0;',';}button{border:none;}animation:slide-up 0.3s ease-in-out;@keyframes slide-up{from{transform:translateY(20%);opacity:0;}to{transform:none;opacity:1;}}'],_bgModalDesligamento2.default,_media2.default.small(_templateObject),(0,_rem2.default)('48px'),_media2.default.small(_templateObject2,(0,_rem2.default)('40px')),(0,_rem2.default)('26x'),_media2.default.small(_templateObject2,(0,_rem2.default)('18px')));var ModalButton=exports.ModalButton=_styledComponents2.default.a.withConfig({displayName:'styles__ModalButton',componentId:'sc-1iglw6h-3'})(['display:inline-block;color:#fff;text-align:center;text-decoration:none;background:#230C87;border-radius:50px;padding:18.5px 29.5px;font-size:',' font-weight:700;font-family:\'Open Sans\',sans-serif;margin:18px 0 37px 0;'],(0,_rem2.default)('14px'));var ModalHeader=exports.ModalHeader=_styledComponents2.default.div.withConfig({displayName:'styles__ModalHeader',componentId:'sc-1iglw6h-4'})(['display:flex;justify-content:flex-end;img{cursor:pointer;}']);

/***/ }),
/* 1931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatement/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _actions=__webpack_require__(13);var _StatementsHeader=__webpack_require__(634);var _StatementsHeader2=_interopRequireDefault(_StatementsHeader);var _AddItem=__webpack_require__(258);var _AddItem2=_interopRequireDefault(_AddItem);var _StatementsList=__webpack_require__(635);var _StatementsList2=_interopRequireDefault(_StatementsList);var _StatementsFilter=__webpack_require__(1940);var _StatementsFilter2=_interopRequireDefault(_StatementsFilter);var _actions2=__webpack_require__(36);var _ShowResults=__webpack_require__(1976);var _ShowResults2=_interopRequireDefault(_ShowResults);var _EmailStatementModal=__webpack_require__(642);var _EmailStatementModal2=_interopRequireDefault(_EmailStatementModal);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _styles=__webpack_require__(1979);var _data=__webpack_require__(1980);var _factory=__webpack_require__(1981);var _factory2=_interopRequireDefault(_factory);var _actions3=__webpack_require__(18);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);var _ModalTypes=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DashboardStatement=function(_Component){_inherits(DashboardStatement,_Component);function DashboardStatement(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DashboardStatement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DashboardStatement.__proto__||Object.getPrototypeOf(DashboardStatement)).call.apply(_ref,[this].concat(args))),_this),_this.state={showFilter:false,loading:false,showModalEmail:false,formato:null,emailSendStatement:null,showResults:false,hasValePedagio:false},_this.selectedFilters={},_this.loadStatements=function(){var nextPage=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var params=_this.props.match.params||{};_this.props.fetchStatements(params.id,nextPage,_this.selectedFilters);},_this.doStatementFetch=function(nextPage,filter){var params=_this.props.match.params||{};_this.props.fetchStatements(params.id,nextPage,filter).then(function(){_this.setState({loading:false});});_this.setState({loading:true});},_this.openFilter=function(){_this.setState({showFilter:true});},_this.applyFilter=function(filter){_this.selectedFilters=filter;_this.props.resetStatements();_this.doStatementFetch(null,_this.selectedFilters);_this.setState({showFilter:false,showResults:true});},_this.unsetResults=function(){return _this.setState({showResults:false});},_this.closeFilter=function(){_this.setState({showFilter:false});},_this.handleModal=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _this$state,emailSendStatement,formato,params;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$state=_this.state,emailSendStatement=_this$state.emailSendStatement,formato=_this$state.formato;params=_this.props.match.params||{};_context.next=4;return _this.props.sendStatementEmail(params.id,emailSendStatement,_this.selectedFilters,formato);case 4:_this.setState({showModalEmail:!_this.state.showModalEmail,formato:null});case 5:case'end':return _context.stop();}}},_callee,_this2);})),_this.handleChangeEmail=function(value){var result=Object.keys(value).map(function(key){return[value[key]];});var valueEmail=result.splice(0,result.length-1).join('');_this.setState({emailSendStatement:valueEmail});},_this.modalEmail=function(state,formato){return _this.setState({showModalEmail:state,formato:formato});},_this.setHasValePedagio=function(boolean){return _this.setState({hasValePedagio:boolean});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DashboardStatement,[{key:'componentWillMount',value:function componentWillMount(){this.props.setLoading(true);if((this.props.account||{}).pc){this.props.history.push('/minha-veloe/'+this.props.match.params.id+'/extrato-parceiro');return;}this.props.fetchStatements(this.props.match.params.id);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.resetStatements();}},{key:'resetList',value:function resetList(){this.props.resetStatements();this.doStatementFetch();}},{key:'render',value:function render(){var _this3=this;var _props=this.props,statements=_props.statements,accountPlans=_props.accountPlans;var _state=this.state,showModalEmail=_state.showModalEmail,showFilter=_state.showFilter,showResults=_state.showResults,hasValePedagio=_state.hasValePedagio;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:121}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:122}}),_react2.default.createElement(_StatementsFilter2.default,{onFilter:function onFilter(values){return _this3.applyFilter(values);},statements:statements,accountPlans:accountPlans,accountId:this.props.match.params.id,showFilter:showFilter,unsetResults:this.unsetResults,hasValePedagio:hasValePedagio,setHasValePedagio:this.setHasValePedagio,__source:{fileName:_jsxFileName,lineNumber:123}}),_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:133}},showResults&&_react2.default.createElement(_styles.ShowResultsContainer,{__source:{fileName:_jsxFileName,lineNumber:135}},_react2.default.createElement(_styles.ShowResultsInner,{__source:{fileName:_jsxFileName,lineNumber:136}},_react2.default.createElement(_ShowResults2.default,{selectedFilters:this.selectedFilters,hasValePedagio:hasValePedagio,showQuantity:false,__source:{fileName:_jsxFileName,lineNumber:137}}))),_react2.default.createElement(_StatementsHeader2.default,{statements:statements,currency:_data.topbar.currency,match:this.props.match,downloadEnabled:!!statements.data.length,openModal:this.modalEmail,__source:{fileName:_jsxFileName,lineNumber:145}}),statements.data.length===0?_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:153}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:154}},'Ops!'),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:155}},'Nenhuma transa\xE7\xE3o encontrada para o filtro selecionado.')):_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:158}},_react2.default.createElement(_AddItem2.default,{data:_factory2.default.toForm(statements.data),next:statements.next,fetchHandler:this.loadStatements,hasNext:statements.hasNext,__source:{fileName:_jsxFileName,lineNumber:159}},_react2.default.createElement(_StatementsList2.default,{__source:{fileName:_jsxFileName,lineNumber:165}})))),showModalEmail&&_react2.default.createElement(_EmailStatementModal2.default,{handleClick:this.handleModal,openModal:this.modalEmail,handleChangeEmail:this.handleChangeEmail,__source:{fileName:_jsxFileName,lineNumber:171}}));}}]);return DashboardStatement;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref3){var reducer=_ref3.reducer;return{statements:reducer.dashboardStatements,accountPlans:reducer.accountPlans,account:reducer.account};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchStatements:function fetchStatements(planId,nextPage,filter){return dispatch((0,_actions.fetchDashboardStatements)(planId,nextPage,filter)).then(function(resp){if(resp&&resp.status===204){dispatch((0,_actions2.setLoading)(false));dispatch((0,_actions.resetDashboardStatements)());}dispatch((0,_actions2.setLoading)(false));});},sendStatementEmail:function sendStatementEmail(planId,email,filter,formato){return dispatch((0,_actions.sendStatementemail)(planId,email,filter,formato)).then(function(){dispatch((0,_actions3.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:'Extrato em processamento.',modalDescription:'O '+formato+' do seu extrato est\xE1 em processamento, assim que finalizado voc\xEA recebera um email com o link para baixa-lo.',image:_contestacao2.default}));dispatch((0,_actions2.setLoading)(false));});},resetStatements:function resetStatements(){dispatch((0,_actions2.setLoading)(true));dispatch((0,_actions.resetDashboardStatements)());},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DashboardStatement);module.exports=exports['default'];

/***/ }),
/* 1932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.NavIcon=exports.NavHeader=exports.Text=exports.HeaderText=exports.Content=exports.IconColor=exports.StatementHeader=undefined;var _templateObject=_taggedTemplateLiteral(['\n        height: ',';\n    '],['\n        height: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        min-height: ',';\n    '],['\n        min-height: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        align-items: center;\n        flex-direction: row;\n\n        .month {\n            font-size: ',';\n            margin-bottom: 0;\n\n            span {\n                display: inline-block;\n            }\n        }\n    '],['\n        align-items: center;\n        flex-direction: row;\n\n        .month {\n            font-size: ',';\n            margin-bottom: 0;\n\n            span {\n                display: inline-block;\n            }\n        }\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        margin: ',' 0;\n    '],['\n        margin: ',' 0;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n        margin: 0 ',' 0 0;\n    '],['\n        margin: 0 ',' 0 0;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n        .print {\n            display: block;\n        }\n    '],['\n        .print {\n            display: block;\n        }\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StatementHeader=exports.StatementHeader=_styledComponents2.default.div.withConfig({displayName:'styles__StatementHeader',componentId:'sc-nxf1y2-0'})(['border-bottom:',' solid ',';'],(0,_rem2.default)('1px'),_colors.lighterGrey);var IconColor=exports.IconColor='fill: '+_colors.linkNavyBlue;var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-nxf1y2-1'})(['',';display:flex;flex-direction:row;justify-content:space-between;',' ',';'],_content2.default,_media2.default.large(_templateObject,(0,_rem2.default)('49px')),_media2.default.small(_templateObject2,(0,_rem2.default)('49px')));var HeaderText=exports.HeaderText=_styledComponents2.default.div.withConfig({displayName:'styles__HeaderText',componentId:'sc-nxf1y2-2'})(['display:flex;flex-wrap:wrap;justify-content:center;flex-direction:column;.month{font-size:',';font-weight:bold;margin-right:',';margin-bottom:',';span{display:none;}}',' ',';'],(0,_rem2.default)('14px'),(0,_rem2.default)('60px'),(0,_rem2.default)('5px'),_media2.default.large(_templateObject3,(0,_rem2.default)('12px')),_media2.default.small(_templateObject4,(0,_rem2.default)('10px')));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-nxf1y2-3'})(['',';margin:0;color:',';',';'],_types.txt12OpenSans,_colors.darkGrey,_media2.default.large(_templateObject5,(0,_rem2.default)('5px')));var NavHeader=exports.NavHeader=_styledComponents2.default.div.withConfig({displayName:'styles__NavHeader',componentId:'sc-nxf1y2-4'})(['display:flex;align-items:center;.print{display:none;}',';'],_media2.default.large(_templateObject6));var NavIcon=exports.NavIcon=_styledComponents2.default.a.withConfig({displayName:'styles__NavIcon',componentId:'sc-nxf1y2-5'})(['display:inline-block;width:',';height:',';cursor:pointer;img{width:100%;height:auto;}:not(:first-child){margin-left:20px;}'],(0,_rem2.default)('31px'),(0,_rem2.default)('31px'));

/***/ }),
/* 1933 */
/***/ (function(module, exports) {

module.exports = {"downloadStatement":"Baixar extrato","downloadStatementCSV":"Baixar extrato CSV","printStatement":"Imprimir extrato","shareStatement":"Enviar extrato por e-mail","modal":{"title":"Já vamos enviar o seu extrato.","description":"Diga pra gente o e-mail em que você quer receber seu extrato.","buttonText":"Enviar","label":"E-mail","placeholder":"Ex nome@exemplo.com.br"}}

/***/ }),
/* 1934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.LabelLoading=exports.Label=exports.ItemIcon=exports.Container=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _loading=__webpack_require__(100);var _loading2=_interopRequireDefault(_loading);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-1ayg8mo-0'})(['display:flex;justify-content:center;align-items:center;flex-wrap:wrap;',';'],function(props){return props.width&&'\n        width: '+(0,_rem2.default)(props.width)+';\n    ';});var ItemIcon=exports.ItemIcon=_styledComponents2.default.a.withConfig({displayName:'styles__ItemIcon',componentId:'sc-1ayg8mo-1'})(['position:relative;display:flex;justify-content:center;align-items:center;width:',';height:',';border:1px solid ',';border-radius:',';margin-right:',';margin-bottom:',';background-color:',';box-shadow:0 0 0 10px ',';z-index:11;cursor:pointer;img{width:',';height:auto;}'],(0,_rem2.default)('40px'),(0,_rem2.default)('40px'),_colors.borderGrey,(0,_rem2.default)('80px'),(0,_rem2.default)('15px'),(0,_rem2.default)('10px'),_colors.white,_colors.white,(0,_rem2.default)('22px'));var Label=exports.Label=_styledComponents2.default.span.withConfig({displayName:'styles__Label',componentId:'sc-1ayg8mo-2'})(['',';margin:0;color:',';font-size:',';font-weight:100;text-transform:uppercase;letter-spacing:',';margin-bottom:',';margin-right:',';'],_types.txt14OpenSans,_colors.darkGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('1px'),(0,_rem2.default)('10px'),(0,_rem2.default)('15px'));var LabelLoading=exports.LabelLoading=_styledComponents2.default.span.withConfig({displayName:'styles__LabelLoading',componentId:'sc-1ayg8mo-3'})(['cursor:not-allowed;background-image:url(',');background-repeat:no-repeat;background-position:left;background-size:18px;',';color:',';font-size:',';font-weight:100;text-transform:uppercase;padding-left:24px;'],_loading2.default,_types.txt14OpenSans,_colors.darkGrey,(0,_rem2.default)('12px'));

/***/ }),
/* 1935 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/StatementsListItem/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _aleloLogic=__webpack_require__(12);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _actions=__webpack_require__(13);var _Icon=__webpack_require__(31);var _styles=__webpack_require__(1937);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var formatTime=function formatTime(info){var time='';if(info.type==='park'&&info.value<0){time=_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:27}},'Utilizado em'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:28}},_aleloLogic.utils.ISODateFormat(info.date))),_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:30}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:31}},'Entrada'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:32}},_aleloLogic.utils.timeFormat((0,_moment2.default)(info.startTime,'HH:mm:ss')))),_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:35}},'Sa\xEDda'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:36}},_aleloLogic.utils.timeFormat((0,_moment2.default)(info.exitTime,'HH:mm:ss')))),_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:39}},'Perman\xEAncia'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:40}},info.stayTime)),info.vehicle.placa&&_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:44}},'Placa'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:45}},info.vehicle.placa)));}else if(info.type==='payment'){time=_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:54}},'Recebido em'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:55}},_aleloLogic.utils.ISODateFormat(info.date))),_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:58}},'Hora'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:59}},_aleloLogic.utils.timeFormat((0,_moment2.default)(info.startTime,'HH:mm:ss')))));}else if(info.value>0){time=_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:65}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:66}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:67}},'Realizada em'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:68}},_aleloLogic.utils.ISODateFormat(info.date))),_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:70}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:71}},'Hora'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:72}},_aleloLogic.utils.timeFormat((0,_moment2.default)(info.startTime,'HH:mm:ss')))));}else{time=_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:78}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:79}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:80}},'Utilizado em'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:81}},_aleloLogic.utils.ISODateFormat(info.date))),_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:83}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:84}},'Hora'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:85}},_aleloLogic.utils.timeFormat((0,_moment2.default)(info.startTime,'HH:mm:ss')))),info.type==='toll'&&info.vehicle.placa&&_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:89}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:90}},'Placa'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:91}},info.vehicle.placa)),info.tollFreeVeloeId&&_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:95}},_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:96}}),_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:97}},'N\xDAMERO DA VIAGEM'),_react2.default.createElement('time',{__source:{fileName:_jsxFileName,lineNumber:98}},info.tollFreeVeloeId)));}return time;};var displayStatementIcon=function displayStatementIcon(type,value){var width='100';var heigth='70';if(type==='tax'){return _react2.default.createElement(_styles.ItemBullet,{__source:{fileName:_jsxFileName,lineNumber:112}},_react2.default.createElement(_styles.Bullet,{type:type,__source:{fileName:_jsxFileName,lineNumber:113}}));}if(type==='recharge'){width='200px';heigth='140px';}return value>0?_react2.default.createElement(_styles.ItemIcon,{__source:{fileName:_jsxFileName,lineNumber:122}},_react2.default.createElement(_Icon.Icon,{width:'24',height:'26',icon:type,color:'#d7dd1a',viewBox:'-15 0 '+width+' '+heigth,__source:{fileName:_jsxFileName,lineNumber:123}})):_react2.default.createElement(_styles.ItemIcon,{__source:{fileName:_jsxFileName,lineNumber:132}},_react2.default.createElement(_Icon.Icon,{width:'24',height:'26',icon:type,color:'#8583a4',viewBox:'-15 0 '+width+' '+heigth,__source:{fileName:_jsxFileName,lineNumber:133}}));};var StatementsListItem=function(_Component){_inherits(StatementsListItem,_Component);function StatementsListItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StatementsListItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StatementsListItem.__proto__||Object.getPrototypeOf(StatementsListItem)).call.apply(_ref,[this].concat(args))),_this),_this.state={resent:false},_this.setResent=function(_ref2){var fastId=_ref2.fastId;_this.props.fetchResend(fastId);_this.setState({resent:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StatementsListItem,[{key:'render',value:function render(){var _this2=this;var _props=this.props,match=_props.match,statement=_objectWithoutProperties(_props,['match']);return _react2.default.createElement(_styles.ListItem,{value:statement.value,__source:{fileName:_jsxFileName,lineNumber:158}},displayStatementIcon(statement.type,statement.value),_react2.default.createElement(_styles.ItemDescription,{__source:{fileName:_jsxFileName,lineNumber:160}},_react2.default.createElement(_styles.ItemTitle,{type:statement.type,__source:{fileName:_jsxFileName,lineNumber:161}},statement.tollFree&&'VALE PEDÁGIO - ',statement.title),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:165}},statement.code+' '+(statement.details?' - '+statement.details:'')),formatTime(statement)),_react2.default.createElement(_styles.ItemPrice,{__source:{fileName:_jsxFileName,lineNumber:168}},_react2.default.createElement(_styles.Price,{type:statement.type,__source:{fileName:_jsxFileName,lineNumber:169}},statement.value.toFixed(2)>0?'+'+statement.value.toFixed(2):statement.value.toFixed(2)),statement.partner&&(!this.state.resent?_react2.default.createElement(_styles.ResendButton,{onClick:function onClick(){return _this2.setResent(statement);},id:'resend',className:'resend',title:'Reenviar transa\xE7\xE3o',__source:{fileName:_jsxFileName,lineNumber:176}},'Reenviar'):_react2.default.createElement('img',{src:__webpack_require__(1938),alt:'Transa\xE7\xE3o reenviada com sucesso!',__source:{fileName:_jsxFileName,lineNumber:185}}))));}}]);return StatementsListItem;}(_react.Component);var mapStateToProps=function mapStateToProps(){return{};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchResend:function fetchResend(fastId){return dispatch((0,_actions.fetchResendStatement)(fastId)).then(function(){// if (resp && resp.status === 204) {
//   dispatch(setLoading(false))
// }
// dispatch(setLoading(false))
});}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(StatementsListItem);module.exports=exports['default'];

/***/ }),
/* 1937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ListItem=exports.ContestButtonMobile=exports.ContestButton=exports.ResendButton=exports.Price=exports.ItemPrice=exports.ItemTitle=exports.ItemDescription=exports.Bullet=exports.ItemBullet=exports.ItemIcon=exports.Text=undefined;var _templateObject=_taggedTemplateLiteral(['\n        span {\n            display: block;\n        }\n    '],['\n        span {\n            display: block;\n        }\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        margin-right: ',';\n    '],['\n        margin-right: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        font-size: ',';\n    '],['\n        font-size: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        display: none;\n    '],['\n        display: none;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n        min-height: ',';\n        padding-bottom: 0;\n\n        :before {\n            background: transparent;\n            content: \'\';\n            left: 0;\n            min-height: ',';\n            position: absolute;\n            transition: background 0.3s ease;\n            width: 100vw;\n            z-index: 1;\n        }\n\n        :hover {\n            :before {\n                background-color: ',';\n            }\n\n            .contest, .resend {\n                opacity: 1;\n            }\n        }\n\n    '],['\n        min-height: ',';\n        padding-bottom: 0;\n\n        :before {\n            background: transparent;\n            content: \'\';\n            left: 0;\n            min-height: ',';\n            position: absolute;\n            transition: background 0.3s ease;\n            width: 100vw;\n            z-index: 1;\n        }\n\n        :hover {\n            :before {\n                background-color: ',';\n            }\n\n            .contest, .resend {\n                opacity: 1;\n            }\n        }\n\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1mzs5wu-0'})(['',';margin:0;'],_types.txt14OpenSans);var ItemIcon=exports.ItemIcon=_styledComponents2.default.div.withConfig({displayName:'styles__ItemIcon',componentId:'sc-1mzs5wu-1'})(['align-items:center;background-color:',';border-radius:',';border:',' solid ',';box-shadow:0 0 0 ',' ',';display:flex;height:',';justify-content:center;margin-right:',';margin-top:',';position:relative;width:',';z-index:11;'],_colors.white,(0,_rem2.default)('80px'),(0,_rem2.default)('1px'),_colors.lightGray,(0,_rem2.default)('10px'),_colors.white,(0,_rem2.default)('40px'),(0,_rem2.default)('20px'),(0,_rem2.default)('16px'),(0,_rem2.default)('40px'));var ItemBullet=exports.ItemBullet=_styledComponents2.default.div.withConfig({displayName:'styles__ItemBullet',componentId:'sc-1mzs5wu-2'})(['align-items:center;background-color:',';border-radius:',';display:flex;height:',';height:',';justify-content:center;margin-right:',';position:relative;width:',';width:',';z-index:11;'],_colors.white,(0,_rem2.default)('80px'),(0,_rem2.default)('40px'),(0,_rem2.default)('40px'),(0,_rem2.default)('20px'),(0,_rem2.default)('40px'),(0,_rem2.default)('40px'));var Bullet=exports.Bullet=_styledComponents2.default.div.withConfig({displayName:'styles__Bullet',componentId:'sc-1mzs5wu-3'})(['background-color:',';border-radius:',';display:block;height:',';margin-top:',';width:',';'],_colors.darkGrey,(0,_rem2.default)('80px'),(0,_rem2.default)('14px'),(0,_rem2.default)('5px'),(0,_rem2.default)('14px'));var ItemDescription=exports.ItemDescription=_styledComponents2.default.div.withConfig({displayName:'styles__ItemDescription',componentId:'sc-1mzs5wu-4'})(['flex:8;position:relative;z-index:10;:after{border-left:',' solid ',';content:\'\';height:90%;left:',';position:absolute;top:',';z-index:10;}','{color:',';margin-bottom:',';b{font-weight:600;margin-right:',';}}span{margin-right:',';}',';'],(0,_rem2.default)('1px'),_colors.lightGray,(0,_rem2.default)('-40px'),(0,_rem2.default)('20px'),Text,_colors.blueGray,(0,_rem2.default)('2px'),(0,_rem2.default)('5px'),(0,_rem2.default)('10px'),_media2.default.small(_templateObject));var ItemTitle=exports.ItemTitle=_styledComponents2.default.h2.withConfig({displayName:'styles__ItemTitle',componentId:'sc-1mzs5wu-5'})(['',' color:',';font-weight:700;margin-bottom:',';',' ','}'],_types.txt14OpenSans,_colors.linkNavyBlue,(0,_rem2.default)('2px'),function(props){return props.type==='refund'&&'\n        color: '+_colors.olive+';\n    ';},function(props){return props.type==='payment'&&'\n        font-size: '+(0,_rem2.default)('16px')+';\n    ';});var ItemPrice=exports.ItemPrice=_styledComponents2.default.div.withConfig({displayName:'styles__ItemPrice',componentId:'sc-1mzs5wu-6'})(['flex:2;position:relative;text-align:right;z-index:11;min-height:',';',';'],(0,_rem2.default)('95px'),_media2.default.large(_templateObject2,(0,_rem2.default)('10px')));var Price=exports.Price=_styledComponents2.default.strong.withConfig({displayName:'styles__Price',componentId:'sc-1mzs5wu-7'})(['display:block;',';font-weight:600;color:',';margin-top:',';',' ',';'],_types.txt12OpenSans,_colors.linkNavyBlue,(0,_rem2.default)('10px'),function(props){return props.type==='refund'&&'\n        color: '+_colors.olive+';\n    ';},_media2.default.large(_templateObject3,(0,_rem2.default)('16px')));var ResendButton=exports.ResendButton=_styledComponents2.default.div.withConfig({displayName:'styles__ResendButton',componentId:'sc-1mzs5wu-8'})(['',';border-radius:',';border:',' solid ',';bottom:',';color:',';font-weight:600;margin:0;opacity:0;padding:',' ',';position:absolute;right:0;transition:opacity 0.2s linear;:hover{cursor:pointer;}'],_types.txt14OpenSans,(0,_rem2.default)('6px'),(0,_rem2.default)('1px'),_colors.blueGray,(0,_rem2.default)('15px'),_colors.linkNavyBlue,(0,_rem2.default)('7px'),(0,_rem2.default)('20px'));var ContestButton=exports.ContestButton=_styledComponents2.default.div.withConfig({displayName:'styles__ContestButton',componentId:'sc-1mzs5wu-9'})(['',';border-radius:',';border:',' solid ',';bottom:',';color:',';font-weight:600;margin:0;opacity:0;padding:',' ',';position:absolute;right:0;transition:opacity 0.2s linear;:hover{cursor:pointer;}'],_types.txt14OpenSans,(0,_rem2.default)('6px'),(0,_rem2.default)('1px'),_colors.blueGray,(0,_rem2.default)('15px'),_colors.linkNavyBlue,(0,_rem2.default)('7px'),(0,_rem2.default)('20px'));var ContestButtonMobile=exports.ContestButtonMobile=_styledComponents2.default.div.withConfig({displayName:'styles__ContestButtonMobile',componentId:'sc-1mzs5wu-10'})(['position:absolute;right:0;bottom:',';width:',';img{max-width:100%;height:auto;}',';'],(0,_rem2.default)('10px'),(0,_rem2.default)('22px'),_media2.default.large(_templateObject4));var ListItem=exports.ListItem=_styledComponents2.default.li.withConfig({displayName:'styles__ListItem',componentId:'sc-1mzs5wu-11'})(['display:flex;padding-bottom:',';align-items:stratch;',' ',';'],(0,_rem2.default)('20px'),function(props){return props.value>0&&(0,_styledComponents.css)(['','{color:',';}','{color:',';}'],ItemTitle,_colors.olive,Price,_colors.olive);},_media2.default.large(_templateObject5,(0,_rem2.default)('95px'),(0,_rem2.default)('97px'),_colors.nearWhite));

/***/ }),
/* 1938 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.StatementsFooter=exports.List=exports.Sidebar=exports.StatementGroup=exports.Statements=exports.Text=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n        flex-direction: row;\n    '],['\n        flex-direction: row;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        flex-direction: column;\n        flex: 1;\n        justify-content: flex-start;\n        margin-right: ',';\n        \n    '],['\n        flex-direction: column;\n        flex: 1;\n        justify-content: flex-start;\n        margin-right: ',';\n        \n    ']),_templateObject3=_taggedTemplateLiteral(['\n            margin-top: ',';\n            margin-right: ',';\n        '],['\n            margin-top: ',';\n            margin-right: ',';\n        ']),_templateObject4=_taggedTemplateLiteral(['\n        margin: 0;\n    '],['\n        margin: 0;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n        li:last-child {\n            .description:after {\n                border-left: 0;\n            }\n        }\n    '],['\n        li:last-child {\n            .description:after {\n                border-left: 0;\n            }\n        }\n    ']),_templateObject6=_taggedTemplateLiteral(['\n        margin-left: ',';\n        justify-content: flex-start;\n    '],['\n        margin-left: ',';\n        justify-content: flex-start;\n    ']),_templateObject7=_taggedTemplateLiteral(['\n        .load-more-container {\n            margin-left: ',';\n            width: ',';\n        }\n    '],['\n        .load-more-container {\n            margin-left: ',';\n            width: ',';\n        }\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-1i2765h-0'})(['',' color:',';line-height:1;margin:0;'],_types.title44GalanoBold,_colors.darkGrey);var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1i2765h-1'})(['',';margin:0;'],_types.txt14OpenSans);var Statements=exports.Statements=_styledComponents2.default.div.withConfig({displayName:'styles__Statements',componentId:'sc-1i2765h-2'})(['',';margin-top:',';margin-bottom:',';'],_content2.default,(0,_rem2.default)('26px'),(0,_rem2.default)('30px'));var StatementGroup=exports.StatementGroup=_styledComponents2.default.div.withConfig({displayName:'styles__StatementGroup',componentId:'sc-1i2765h-3'})(['display:flex;flex-direction:column;flex-wrap:wrap;flex:1;',';'],_media2.default.large(_templateObject));var Sidebar=exports.Sidebar=_styledComponents2.default.div.withConfig({displayName:'styles__Sidebar',componentId:'sc-1i2765h-4'})(['position:relative;display:flex;align-items:center;z-index:2;',' ','{margin-top:',';margin-bottom:',';font-size:',';',';}','{color:',';font-size:',';font-weight:100;letter-spacing:',';text-transform:uppercase;}'],_media2.default.large(_templateObject2,(0,_rem2.default)('105px')),Title,(0,_rem2.default)('-0px'),(0,_rem2.default)('8px'),(0,_rem2.default)('30px'),_media2.default.small(_templateObject3,(0,_rem2.default)('10px'),(0,_rem2.default)('13px')),Text,_colors.darkGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('1px'));var List=exports.List=_styledComponents2.default.ul.withConfig({displayName:'styles__List',componentId:'sc-1i2765h-5'})(['flex:10;list-style:none;margin-bottom:',';padding:0;',' ',';'],(0,_rem2.default)('20px'),_media2.default.large(_templateObject4),_media2.default.small(_templateObject5));var StatementsFooter=exports.StatementsFooter=_styledComponents2.default.div.withConfig({displayName:'styles__StatementsFooter',componentId:'sc-1i2765h-6'})(['display:flex;',' ',';'],_media2.default.large(_templateObject6,(0,_rem2.default)('142px')),_media2.default.small(_templateObject7,(0,_rem2.default)('-4px'),(0,_rem2.default)('180px')));

/***/ }),
/* 1940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/StatementsFilter/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(43);var _reduxForm=__webpack_require__(11);var _reactRedux=__webpack_require__(7);var _Button=__webpack_require__(155);var _Button2=_interopRequireDefault(_Button);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _StatementsFilterForm=__webpack_require__(1941);var _StatementsFilterForm2=_interopRequireDefault(_StatementsFilterForm);var _styles=__webpack_require__(1975);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StatementsFilter=function(_Component){_inherits(StatementsFilter,_Component);function StatementsFilter(props){_classCallCheck(this,StatementsFilter);var _this=_possibleConstructorReturn(this,(StatementsFilter.__proto__||Object.getPrototypeOf(StatementsFilter)).call(this,props));_this.handleScroll=(0,_lodash.throttle)(function(){var footer=document.getElementById('footer');var currentScroll=footer.getBoundingClientRect().top-window.innerHeight>0;if(currentScroll>0){_this.setState({isFixed:true});}else{_this.setState({isFixed:false});}},50,{maxWait:1000});_this.state={isOpen:false,isFixed:true,currentValues:{}};return _this;}_createClass(StatementsFilter,[{key:'componentDidMount',value:function componentDidMount(){window.addEventListener('scroll',this.handleScroll);this.handleScroll();}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('scroll',this.handleScroll);}},{key:'render',value:function render(){var _this2=this;var openFilter=function openFilter(){_this2.setState({isOpen:true});};var closeFilter=function closeFilter(){_this2.setState({isOpen:false});};var onSubmitFilter=function onSubmitFilter(values){var changedValues={plate:values.plate,placas:values.placas,month:values.month,type:values.type,year:values.year,periodo:values.periodo,diaDaSemana:values.diaDaSemana,rangeDates:values.rangeDates};if(_this2.props.onFilter){_this2.props.onFilter(changedValues);}_this2.setState({isOpen:false,currentValues:changedValues});};return _react2.default.createElement(_styles.FilterWrapper,{__source:{fileName:_jsxFileName,lineNumber:95}},_react2.default.createElement(_styles.Filter,{isOpen:this.state.isOpen,isFixed:this.state.isFixed,__source:{fileName:_jsxFileName,lineNumber:96}},_react2.default.createElement(_styles.FilterContainer,{isOpen:this.state.isOpen,__source:{fileName:_jsxFileName,lineNumber:97}},_react2.default.createElement(_styles.FilterClosed,{isOpen:this.state.isOpen,__source:{fileName:_jsxFileName,lineNumber:98}},_react2.default.createElement(_styles.ButtonContainerMobile,{__source:{fileName:_jsxFileName,lineNumber:99}},_react2.default.createElement(_Button2.default,{buttonType:'skyBlue',text:'Filtrar',onClick:openFilter,__source:{fileName:_jsxFileName,lineNumber:100}})),_react2.default.createElement(_styles.ButtonContainerDesktop,{__source:{fileName:_jsxFileName,lineNumber:102}},_react2.default.createElement(_Button2.default,{buttonType:'transparent',text:'Filtrar',onClick:openFilter,__source:{fileName:_jsxFileName,lineNumber:103}}))),_react2.default.createElement(_styles.FilterOpened,{isOpen:this.state.isOpen,__source:{fileName:_jsxFileName,lineNumber:106}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Voltar',back:closeFilter,__source:{fileName:_jsxFileName,lineNumber:107}}),_react2.default.createElement(_StatementsFilterForm2.default,{onClick:closeFilter,onSubmit:onSubmitFilter,accountPlans:this.props.accountPlans,accountId:this.props.accountId,unsetResults:this.props.unsetResults,setHasValePedagio:this.props.setHasValePedagio,hasValePedagio:this.props.hasValePedagio,__source:{fileName:_jsxFileName,lineNumber:108}})))));}}]);return StatementsFilter;}(_react.Component);StatementsFilter.defaultProps={plate:''};var mapStateToProps=function mapStateToProps(state){var selector=(0,_reduxForm.formValueSelector)('statementsFilter');return{plate:selector(state,'plate')};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(StatementsFilter);module.exports=exports['default'];

/***/ }),
/* 1941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/StatementsFilterForm/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _FilterByPeriod=__webpack_require__(636);var _FilterByPeriod2=_interopRequireDefault(_FilterByPeriod);var _FilterByWeekDays=__webpack_require__(639);var _FilterByWeekDays2=_interopRequireDefault(_FilterByWeekDays);var _FilterByServices=__webpack_require__(1959);var _FilterByServices2=_interopRequireDefault(_FilterByServices);var _styles=__webpack_require__(1961);var _FilterByIdentifier=__webpack_require__(1962);var _FilterByIdentifier2=_interopRequireDefault(_FilterByIdentifier);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StatementsFilterForm=function(_Component){_inherits(StatementsFilterForm,_Component);function StatementsFilterForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,StatementsFilterForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=StatementsFilterForm.__proto__||Object.getPrototypeOf(StatementsFilterForm)).call.apply(_ref,[this].concat(args))),_this),_this.state={weekRefs:[],servicesRefs:[],isFixed:true,hasValePedagio:false},_this.setWeekDayRef=function(ref){return _this.setState({weekRefs:[].concat(_toConsumableArray(_this.state.weekRefs),[ref])});},_this.setServicesRef=function(ref){return _this.setState({servicesRefs:[].concat(_toConsumableArray(_this.state.servicesRefs),[ref])});},_this.unsetFilterByWeekDays=function(){_this.state.weekRefs.map(function(ref){ref.checked=false;});_this.setState({weekRefs:[]});},_this.unsetServices=function(){_this.state.servicesRefs.map(function(ref){ref.checked=false;});_this.setState({servicesRefs:[]});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StatementsFilterForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,handleSubmit=_props.handleSubmit,accountPlans=_props.accountPlans,unsetResults=_props.unsetResults,dispatch=_props.dispatch,accountId=_props.accountId;return _react2.default.createElement('form',{onSubmit:handleSubmit,id:'filter-form',__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_gridStyled.Box,{mb:50,__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement(_FilterByIdentifier2.default,{accountId:accountId,__source:{fileName:_jsxFileName,lineNumber:42}}),_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:43}}),_react2.default.createElement(_FilterByPeriod2.default,{__source:{fileName:_jsxFileName,lineNumber:44}}),_react2.default.createElement(_FilterByWeekDays2.default,{setWeekDayRef:this.setWeekDayRef,__source:{fileName:_jsxFileName,lineNumber:45}}),_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:46}}),_react2.default.createElement(_FilterByServices2.default,{setServicesRef:this.setServicesRef,activePlanId:accountPlans.activePlanId,setHasValePedagio:this.props.setHasValePedagio,hasValePedagio:this.props.hasValePedagio,__source:{fileName:_jsxFileName,lineNumber:47}}),_react2.default.createElement(_styles.ButtonsContainer,{__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_styles.ButtonsWrapper,{__source:{fileName:_jsxFileName,lineNumber:54}},_react2.default.createElement(_styles.ResetButton,{onClick:function onClick(e){e.preventDefault();unsetResults();_this2.unsetFilterByWeekDays();_this2.unsetServices();dispatch((0,_reduxForm.reset)('statementsFilter'));},__source:{fileName:_jsxFileName,lineNumber:55}},'Remover filtros'),_react2.default.createElement(_styles.FormButton,{type:'submit',__source:{fileName:_jsxFileName,lineNumber:67}},'Aplicar filtros')))));}}]);return StatementsFilterForm;}(_react.Component);exports.default=(0,_reduxForm.reduxForm)({form:'statementsFilter',destroyOnUnmount:true})((0,_reactRedux.connect)(function(state){return{accountPlans:state.reducer.accountPlans};})(StatementsFilterForm));module.exports=exports['default'];

/***/ }),
/* 1942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/FilterByPeriod/PeriodOption.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _styles=__webpack_require__(637);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var renderFilterTypeOption=function renderFilterTypeOption(props){return _react2.default.createElement(_styles.InputRadio,_extends({},props.input,{name:props.name,onChange:function onChange(){return props.input.onChange(props.input.value);},value:props.input.value,type:'radio',__source:{fileName:_jsxFileName,lineNumber:6}}));};function PeriodOption(props){var label=props.label,name=props.name,value=props.value,selectedPeriod=props.selectedPeriod;var isSelected=value===selectedPeriod;return _react2.default.createElement(_styles.RadioLabel,{__source:{fileName:_jsxFileName,lineNumber:19}},label,_react2.default.createElement(_reduxForm.Field,{component:renderFilterTypeOption,name:name,type:'radio',value:value,__source:{fileName:_jsxFileName,lineNumber:21}}),isSelected&&_react2.default.createElement(_styles.CheckMark,{__source:{fileName:_jsxFileName,lineNumber:22}}),_react2.default.createElement(_styles.Radio,{isSelected:isSelected,__source:{fileName:_jsxFileName,lineNumber:23}}));}exports.default=PeriodOption;module.exports=exports['default'];

/***/ }),
/* 1943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/FilterByPeriod/CalendarFilter/CalendarFilter.js';exports.default=CalendarFilter;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDayPicker=__webpack_require__(638);var _moment=__webpack_require__(1953);var _moment2=_interopRequireDefault(_moment);var _moment3=__webpack_require__(19);var _moment4=_interopRequireDefault(_moment3);__webpack_require__(360);var _reduxForm=__webpack_require__(11);__webpack_require__(1955);var _styles=__webpack_require__(1956);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function renderDay(day){return _react2.default.createElement(_styles.Day,{__source:{fileName:_jsxFileName,lineNumber:12}},day.getDate());}var WEEKDAYS_SHORT=['Dom','Seg','Ter','Qua','Qui','Sex','Sab'];var validateRange=function validateRange(rangeForValidation,value){if(value){if(value.from!==undefined&&value.to!==undefined){var dateFrom=(0,_moment4.default)(value.from);var dateTo=(0,_moment4.default)(value.to);var diff=dateTo.diff(dateFrom,'days');if(diff>rangeForValidation)return'Voc\xEA s\xF3 pode selecionar at\xE9 '+rangeForValidation+' dias para o per\xEDodo.';}}return undefined;};function CalendarFilter(props){function handleDayClick(day,fieldProps){var range=_reactDayPicker.DateUtils.addDayToRange(day,fieldProps.value);fieldProps.onChange(range);}return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_reduxForm.Field,{name:'rangeDates',type:'text',validate:function validate(value){return validateRange(props.rangeForValidation,value);},component:function component(props){var _props$input$value=props.input.value,from=_props$input$value.from,to=_props$input$value.to;var parsedDateFrom=(0,_moment4.default)(from).format('D')+' de '+(0,_moment4.default)(from).format('MMMM');var parsedDateTo=(0,_moment4.default)(to).format('D')+' de '+(0,_moment4.default)(to).format('MMMM');var modifiers={start:from,end:to};return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_styles.RangeInputWrapper,{__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement(_styles.RangeInput,{invalid:props.meta.error,disabled:true,placeholder:(from?parsedDateFrom:'Data inicial')+' / '+(to?parsedDateTo:'Data final'),__source:{fileName:_jsxFileName,lineNumber:51}}),props.meta.error&&_react2.default.createElement(_styles.Error,{__source:{fileName:_jsxFileName,lineNumber:58}},props.meta.error)),_react2.default.createElement(_styles.StyledCalendarPicker,{renderDay:renderDay,numberOfMonths:2,selectedDays:[from,{from:from,to:to}],modifiers:modifiers,onDayClick:function onDayClick(day){handleDayClick(day,props.input);},localeUtils:_moment2.default,locale:'pt-br',weekdaysShort:WEEKDAYS_SHORT,__source:{fileName:_jsxFileName,lineNumber:60}}));},__source:{fileName:_jsxFileName,lineNumber:38}}));}module.exports=exports['default'];

/***/ }),
/* 1944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifiersUtils = exports.LocaleUtils = exports.DateUtils = exports.DayPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(138);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Caption = __webpack_require__(1947);

var _Caption2 = _interopRequireDefault(_Caption);

var _Navbar = __webpack_require__(1948);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Month = __webpack_require__(1949);

var _Month2 = _interopRequireDefault(_Month);

var _Weekday = __webpack_require__(1952);

var _Weekday2 = _interopRequireDefault(_Weekday);

var _Helpers = __webpack_require__(262);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(158);

var DateUtils = _interopRequireWildcard(_DateUtils);

var _LocaleUtils = __webpack_require__(259);

var LocaleUtils = _interopRequireWildcard(_LocaleUtils);

var _ModifiersUtils = __webpack_require__(399);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _classNames = __webpack_require__(261);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(260);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayPicker = exports.DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _this.dayPicker = null;

    _this.showNextMonth = function (callback) {
      if (!_this.allowNextMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var nextMonth = DateUtils.addMonths(_this.state.currentMonth, deltaMonths);
      _this.showMonth(nextMonth, callback);
    };

    _this.showPreviousMonth = function (callback) {
      if (!_this.allowPreviousMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var previousMonth = DateUtils.addMonths(_this.state.currentMonth, -deltaMonths);
      _this.showMonth(previousMonth, callback);
    };

    _this.handleKeyDown = function (e) {
      e.persist();

      switch (e.keyCode) {
        case _keys.LEFT:
          if (_this.props.dir === 'rtl') {
            _this.showNextMonth();
          } else {
            _this.showPreviousMonth();
          }
          Helpers.cancelEvent(e);
          break;
        case _keys.RIGHT:
          if (_this.props.dir === 'rtl') {
            _this.showPreviousMonth();
          } else {
            _this.showNextMonth();
          }
          Helpers.cancelEvent(e);
          break;
        case _keys.UP:
          _this.showPreviousYear();
          Helpers.cancelEvent(e);
          break;
        case _keys.DOWN:
          _this.showNextYear();
          Helpers.cancelEvent(e);
          break;
        default:
          break;
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleDayKeyDown = function (day, modifiers, e) {
      e.persist();

      switch (e.keyCode) {
        case _keys.LEFT:
          Helpers.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusNextDay(e.target);
          } else {
            _this.focusPreviousDay(e.target);
          }
          break;
        case _keys.RIGHT:
          Helpers.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusPreviousDay(e.target);
          } else {
            _this.focusNextDay(e.target);
          }
          break;
        case _keys.UP:
          Helpers.cancelEvent(e);
          _this.focusPreviousWeek(e.target);
          break;
        case _keys.DOWN:
          Helpers.cancelEvent(e);
          _this.focusNextWeek(e.target);
          break;
        case _keys.ENTER:
        case _keys.SPACE:
          Helpers.cancelEvent(e);
          if (_this.props.onDayClick) {
            _this.handleDayClick(day, modifiers, e);
          }
          break;
        default:
          break;
      }
      if (_this.props.onDayKeyDown) {
        _this.props.onDayKeyDown(day, modifiers, e);
      }
    };

    _this.handleDayClick = function (day, modifiers, e) {
      e.persist();

      if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) {
        _this.handleOutsideDayClick(day);
      }
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, modifiers, e);
      }
    };

    _this.handleTodayButtonClick = function (e) {
      var today = new Date();
      var month = new Date(today.getFullYear(), today.getMonth());
      _this.showMonth(month);
      e.target.blur();
      if (_this.props.onTodayButtonClick) {
        e.persist();
        _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils.getModifiersForDay(today, _this.props.modifiers), e);
      }
    };

    var currentMonth = _this.getCurrentMonthFromProps(props);
    _this.state = { currentMonth: currentMonth };
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Changing the `month` props means changing the current displayed month
      if (prevProps.month !== this.props.month && !DateUtils.isSameMonth(prevProps.month, this.props.month)) {
        var currentMonth = this.getCurrentMonthFromProps(this.props);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ currentMonth: currentMonth });
      }
    }
  }, {
    key: 'getCurrentMonthFromProps',


    /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */
    value: function getCurrentMonthFromProps(props) {
      var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth || new Date());
      var currentMonth = initialMonth;

      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
        var fromMonth = Helpers.startOfMonth(props.fromMonth);
        var diffInMonths = Helpers.getMonthsDiff(fromMonth, currentMonth);
        currentMonth = DateUtils.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
      } else if (props.toMonth && props.numberOfMonths > 1 && Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
        currentMonth = DateUtils.addMonths(Helpers.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
      }
      return currentMonth;
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.wrapper.focus();
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        month: this.state.currentMonth,
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);
      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils.addMonths(this.state.currentMonth, i);
        months.push(_react2.default.createElement(_Month2.default, _extends({
          key: i
        }, this.props, {
          month: month,
          firstDayOfWeek: firstDayOfWeek,
          onDayKeyDown: this.handleDayKeyDown,
          onDayClick: this.handleDayClick
        })));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (this.props.todayButton) {
        return _react2.default.createElement(
          'div',
          { className: this.props.classNames.footer },
          this.renderTodayButton()
        );
      }
      return null;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          tabIndex: 0,
          className: this.props.classNames.todayButton,
          'aria-label': this.props.todayButton,
          onClick: this.handleTodayButtonClick
        },
        this.props.todayButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }
      return _react2.default.createElement(
        'div',
        _extends({}, this.props.containerProps, {
          className: className,
          ref: function ref(el) {
            return _this7.dayPicker = el;
          },
          lang: this.props.locale
        }),
        _react2.default.createElement(
          'div',
          {
            className: this.props.classNames.wrapper,
            ref: function ref(el) {
              return _this7.wrapper = el;
            },
            tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
            onKeyDown: this.handleKeyDown,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur
          },
          this.renderNavbar(),
          _react2.default.createElement(
            'div',
            { className: this.props.classNames.months },
            this.renderMonths()
          ),
          this.renderFooter()
        )
      );
    }
  }]);

  return DayPicker;
}(_react.Component);

DayPicker.propTypes = {
  // Rendering months
  initialMonth: _propTypes2.default.instanceOf(Date),
  month: _propTypes2.default.instanceOf(Date),
  numberOfMonths: _propTypes2.default.number,
  fromMonth: _propTypes2.default.instanceOf(Date),
  toMonth: _propTypes2.default.instanceOf(Date),
  canChangeMonth: _propTypes2.default.bool,
  reverseMonths: _propTypes2.default.bool,
  pagedNavigation: _propTypes2.default.bool,
  todayButton: _propTypes2.default.string,
  showWeekNumbers: _propTypes2.default.bool,
  showWeekDays: _propTypes2.default.bool,

  // Modifiers
  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),

  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,

  // Localization
  dir: _propTypes2.default.string,
  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
  labels: _propTypes2.default.shape({
    nextMonth: _propTypes2.default.string.isRequired,
    previousMonth: _propTypes2.default.string.isRequired
  }),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Customization
  showOutsideDays: _propTypes2.default.bool,
  enableOutsideDaysClick: _propTypes2.default.bool,
  fixedWeeks: _propTypes2.default.bool,

  // CSS and HTML
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string,
    container: _propTypes2.default.string,
    day: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    footer: _propTypes2.default.string,
    interactionDisabled: _propTypes2.default.string,
    months: _propTypes2.default.string,
    month: _propTypes2.default.string,
    navBar: _propTypes2.default.string,
    outside: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    todayButton: _propTypes2.default.string,
    week: _propTypes2.default.string,
    wrapper: _propTypes2.default.string
  }),
  className: _propTypes2.default.string,
  containerProps: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,

  // Custom elements
  renderDay: _propTypes2.default.func,
  renderWeek: _propTypes2.default.func,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),

  // Events
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  onCaptionClick: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func,
  onTodayButtonClick: _propTypes2.default.func
};
DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils,
  showOutsideDays: false,
  enableOutsideDaysClick: true,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  showWeekDays: true,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  renderWeek: function renderWeek(weekNumber) {
    return weekNumber;
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};
DayPicker.VERSION = '7.4.8';


DayPicker.DateUtils = DateUtils;
DayPicker.LocaleUtils = LocaleUtils;
DayPicker.ModifiersUtils = ModifiersUtils;

exports.DateUtils = DateUtils;
exports.LocaleUtils = LocaleUtils;
exports.ModifiersUtils = ModifiersUtils;
exports.default = DayPicker;
//# sourceMappingURL=DayPicker.js.map

/***/ }),
/* 1945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1946);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(138);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LocaleUtils = __webpack_require__(259);

var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);

var _keys = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption(props) {
    _classCallCheck(this, Caption);

    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(Caption, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (e.keyCode === _keys.ENTER) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          date = _props.date,
          months = _props.months,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          onClick = _props.onClick;

      return _react2.default.createElement(
        'div',
        { className: classNames.caption, role: 'heading' },
        _react2.default.createElement(
          'div',
          { onClick: onClick, onKeyUp: this.handleKeyUp },
          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
        )
      );
    }
  }]);

  return Caption;
}(_react.Component);

Caption.propTypes = {
  date: _propTypes2.default.instanceOf(Date),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    caption: _propTypes2.default.string.isRequired
  }).isRequired
};
Caption.defaultProps = {
  localeUtils: _LocaleUtils2.default
};
exports.default = Caption;
//# sourceMappingURL=Caption.js.map

/***/ }),
/* 1948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(138);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classNames = __webpack_require__(261);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navbar = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    }, _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    }, _this.handleNextKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handleNextClick();
    }, _this.handlePreviousKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handlePreviousClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          className = _props.className,
          showPreviousButton = _props.showPreviousButton,
          showNextButton = _props.showNextButton,
          labels = _props.labels,
          dir = _props.dir;


      var previousClickHandler = void 0;
      var nextClickHandler = void 0;
      var previousKeyDownHandler = void 0;
      var nextKeyDownHandler = void 0;
      var shouldShowPrevious = void 0;
      var shouldShowNext = void 0;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;

      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

      var previousButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.previousMonth,
        key: 'previous',
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });

      var nextButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.nextMonth,
        key: 'right',
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });

      return _react2.default.createElement(
        'div',
        { className: className || classNames.navBar },
        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
      );
    }
  }]);

  return Navbar;
}(_react.Component);

Navbar.propTypes = {
  classNames: _propTypes2.default.shape({
    navBar: _propTypes2.default.string.isRequired,
    navButtonPrev: _propTypes2.default.string.isRequired,
    navButtonNext: _propTypes2.default.string.isRequired,
    navButtonInteractionDisabled: _propTypes2.default.string.isRequired
  }),
  className: _propTypes2.default.string,
  showPreviousButton: _propTypes2.default.bool,
  showNextButton: _propTypes2.default.bool,
  onPreviousClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func,
  dir: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    previousMonth: _propTypes2.default.string.isRequired,
    nextMonth: _propTypes2.default.string.isRequired
  })
};
Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
exports.default = Navbar;
//# sourceMappingURL=Navbar.js.map

/***/ }),
/* 1949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(138);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Weekdays = __webpack_require__(1950);

var _Weekdays2 = _interopRequireDefault(_Weekdays);

var _Day = __webpack_require__(1951);

var _Day2 = _interopRequireDefault(_Day);

var _keys = __webpack_require__(260);

var _ModifiersUtils = __webpack_require__(399);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _Helpers = __webpack_require__(262);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(158);

var DateUtils = _interopRequireWildcard(_DateUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
      var monthNumber = _this.props.month.getMonth();
      var propModifiers = Helpers.getModifiersFromProps(_this.props);
      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
        dayModifiers.push(_this.props.classNames.today);
      }
      if (day.getMonth() !== monthNumber) {
        dayModifiers.push(_this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== monthNumber;
      var tabIndex = -1;
      // Focus on the first day of the month
      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(
        _Day2.default,
        {
          key: '' + (isOutside ? 'outside-' : '') + key,
          classNames: _this.props.classNames,
          day: day,
          modifiers: modifiers,
          modifiersStyles: _this.props.modifiersStyles,
          empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
          tabIndex: tabIndex,
          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
          ariaDisabled: isOutside || dayModifiers.indexOf(_this.props.classNames.disabled) > -1,
          ariaSelected: dayModifiers.indexOf(_this.props.classNames.selected) > -1,
          onClick: _this.props.onDayClick,
          onFocus: _this.props.onDayFocus,
          onKeyDown: _this.props.onDayKeyDown,
          onMouseEnter: _this.props.onDayMouseEnter,
          onMouseLeave: _this.props.onDayMouseLeave,
          onMouseDown: _this.props.onDayMouseDown,
          onMouseUp: _this.props.onDayMouseUp,
          onTouchEnd: _this.props.onDayTouchEnd,
          onTouchStart: _this.props.onDayTouchStart
        },
        _this.props.renderDay(day, modifiers)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classNames = _props.classNames,
          month = _props.month,
          months = _props.months,
          fixedWeeks = _props.fixedWeeks,
          captionElement = _props.captionElement,
          weekdayElement = _props.weekdayElement,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          firstDayOfWeek = _props.firstDayOfWeek,
          onCaptionClick = _props.onCaptionClick,
          showWeekNumbers = _props.showWeekNumbers,
          showWeekDays = _props.showWeekDays,
          onWeekClick = _props.onWeekClick;


      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
      return _react2.default.createElement(
        'div',
        { className: classNames.month, role: 'grid' },
        caption,
        showWeekDays && _react2.default.createElement(_Weekdays2.default, {
          classNames: classNames,
          weekdaysShort: weekdaysShort,
          weekdaysLong: weekdaysLong,
          firstDayOfWeek: firstDayOfWeek,
          showWeekNumbers: showWeekNumbers,
          locale: locale,
          localeUtils: localeUtils,
          weekdayElement: weekdayElement
        }),
        _react2.default.createElement(
          'div',
          { className: classNames.body, role: 'rowgroup' },
          weeks.map(function (week) {
            var weekNumber = void 0;
            if (showWeekNumbers) {
              weekNumber = DateUtils.getWeekNumber(week[6]);
            }
            return _react2.default.createElement(
              'div',
              {
                key: week[0].getTime(),
                className: classNames.week,
                role: 'row'
              },
              showWeekNumbers && _react2.default.createElement(
                'div',
                {
                  className: classNames.weekNumber,
                  tabIndex: onWeekClick ? 0 : -1,
                  role: 'gridcell',
                  onClick: onWeekClick ? function (e) {
                    return onWeekClick(weekNumber, week, e);
                  } : undefined,
                  onKeyUp: onWeekClick ? function (e) {
                    return e.keyCode === _keys.ENTER && onWeekClick(weekNumber, week, e);
                  } : undefined
                },
                _this2.props.renderWeek(weekNumber, week, month)
              ),
              week.map(_this2.renderDay)
            );
          })
        )
      );
    }
  }]);

  return Month;
}(_react.Component);

Month.propTypes = {
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string.isRequired,
    month: _propTypes2.default.string.isRequired,
    outside: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    week: _propTypes2.default.string.isRequired,
    weekNumber: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired
  }).isRequired,
  tabIndex: _propTypes2.default.number,

  month: _propTypes2.default.instanceOf(Date).isRequired,
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),

  modifiersStyles: _propTypes2.default.object,

  showWeekDays: _propTypes2.default.bool,
  showOutsideDays: _propTypes2.default.bool,

  renderDay: _propTypes2.default.func.isRequired,
  renderWeek: _propTypes2.default.func.isRequired,

  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),

  fixedWeeks: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,

  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  firstDayOfWeek: _propTypes2.default.number.isRequired,

  onCaptionClick: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
};
exports.default = Month;
//# sourceMappingURL=Month.js.map

/***/ }),
/* 1950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(138);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          firstDayOfWeek = _props.firstDayOfWeek,
          showWeekNumbers = _props.showWeekNumbers,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdayElement = _props.weekdayElement;

      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return _react2.default.createElement(
        'div',
        { className: classNames.weekdays, role: 'rowgroup' },
        _react2.default.createElement(
          'div',
          { className: classNames.weekdaysRow, role: 'row' },
          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
          days
        )
      );
    }
  }]);

  return Weekdays;
}(_react.Component);

Weekdays.propTypes = {
  classNames: _propTypes2.default.shape({
    weekday: _propTypes2.default.string.isRequired,
    weekdays: _propTypes2.default.string.isRequired,
    weekdaysRow: _propTypes2.default.string.isRequired
  }).isRequired,

  firstDayOfWeek: _propTypes2.default.number.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showWeekNumbers: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
};
exports.default = Weekdays;
//# sourceMappingURL=Weekdays.js.map

/***/ }),
/* 1951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(138);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateUtils = __webpack_require__(158);

var _Helpers = __webpack_require__(262);

var _classNames = __webpack_require__(261);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
  }

  _createClass(Day, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);
      if (propNames.length !== nextPropNames.length) {
        return true;
      }
      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this2.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);
          if (modifiers.length !== nextModifiers.length) {
            return true;
          }
          return modifiers.some(function (mod) {
            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }
        if (name === 'day') {
          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
        }
        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          modifiersStyles = _props.modifiersStyles,
          day = _props.day,
          tabIndex = _props.tabIndex,
          empty = _props.empty,
          modifiers = _props.modifiers,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onFocus = _props.onFocus,
          ariaLabel = _props.ariaLabel,
          ariaDisabled = _props.ariaDisabled,
          ariaSelected = _props.ariaSelected,
          children = _props.children;


      var className = classNames.day;
      if (classNames !== _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += ' ' + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return ' ' + className + '--' + modifier;
        }).join('');
      }

      var style = void 0;
      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = _extends({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
      }
      return _react2.default.createElement(
        'div',
        {
          className: className,
          tabIndex: tabIndex,
          style: style,
          role: 'gridcell',
          'aria-label': ariaLabel,
          'aria-disabled': ariaDisabled,
          'aria-selected': ariaSelected,
          onClick: handleEvent(onClick, day, modifiers),
          onKeyDown: handleEvent(onKeyDown, day, modifiers),
          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
          onMouseUp: handleEvent(onMouseUp, day, modifiers),
          onMouseDown: handleEvent(onMouseDown, day, modifiers),
          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
          onTouchStart: handleEvent(onTouchStart, day, modifiers),
          onFocus: handleEvent(onFocus, day, modifiers)
        },
        children
      );
    }
  }]);

  return Day;
}(_react.Component);

Day.propTypes = {
  classNames: _propTypes2.default.shape({
    day: _propTypes2.default.string.isRequired
  }).isRequired,

  day: _propTypes2.default.instanceOf(Date).isRequired,
  children: _propTypes2.default.node.isRequired,

  ariaDisabled: _propTypes2.default.bool,
  ariaLabel: _propTypes2.default.string,
  ariaSelected: _propTypes2.default.bool,
  empty: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
};
Day.defaultProps = {
  tabIndex: -1
};
Day.defaultProps = {
  modifiers: {},
  modifiersStyles: {},
  empty: false
};
exports.default = Day;
//# sourceMappingURL=Day.js.map

/***/ }),
/* 1952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(138);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekday = function (_Component) {
  _inherits(Weekday, _Component);

  function Weekday() {
    _classCallCheck(this, Weekday);

    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
  }

  _createClass(Weekday, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weekday = _props.weekday,
          className = _props.className,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          localeUtils = _props.localeUtils,
          locale = _props.locale;

      var title = void 0;
      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }
      var content = void 0;
      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return _react2.default.createElement(
        'div',
        { className: className, role: 'columnheader' },
        _react2.default.createElement(
          'abbr',
          { title: title },
          content
        )
      );
    }
  }]);

  return Weekday;
}(_react.Component);

Weekday.propTypes = {
  weekday: _propTypes2.default.number,
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,

  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
};
exports.default = Weekday;
//# sourceMappingURL=Weekday.js.map

/***/ }),
/* 1953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1954);


/***/ }),
/* 1954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
exports.formatDate = formatDate;
exports.parseDate = parseDate;

var _moment = __webpack_require__(19);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatDay(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return (0, _moment2.default)(day).locale(locale).format('ddd ll');
} /* eslint-disable import/no-extraneous-dependencies, no-underscore-dangle */

function formatMonthTitle(date) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return (0, _moment2.default)(date).locale(locale).format('MMMM YYYY');
}

function formatWeekdayShort(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return _moment2.default.localeData(locale).weekdaysMin()[day];
}

function formatWeekdayLong(day) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';

  return _moment2.default.localeData(locale).weekdays()[day];
}

function getFirstDayOfWeek() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

  return _moment2.default.localeData(locale).firstDayOfWeek();
}

function getMonths() {
  var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en';

  return _moment2.default.localeData(locale).months();
}

function formatDate(date) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';

  return (0, _moment2.default)(date).locale(locale).format(Array.isArray(format) ? format[0] : format);
}

function parseDate(str) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'L';
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en';

  var m = (0, _moment2.default)(str, format, locale, true);
  if (m.isValid()) {
    return m.toDate();
  }
  return undefined;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths,
  formatDate: formatDate,
  parseDate: parseDate
};
//# sourceMappingURL=MomentLocaleUtils.js.map

/***/ }),
/* 1955 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Day=exports.Error=exports.StyledCalendarPicker=exports.RangeInputWrapper=exports.RangeInput=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactDayPicker=__webpack_require__(638);var _reactDayPicker2=_interopRequireDefault(_reactDayPicker);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RangeInput=exports.RangeInput=_styledComponents2.default.input.withConfig({displayName:'styles__RangeInput',componentId:'sc-1kpl7nk-0'})(['border:none;border-bottom:2px solid ',';background-color:#e2e1eb;padding:',';line-height:',';color:',';',';width:',';'],function(_ref){var invalid=_ref.invalid;return invalid?_colors.red:_colors.darkSlateBlue;},(0,_rem2.default)('16px'),(0,_rem2.default)('24px'),_colors.darkSlateBlue,_types.txt16OpenSans,(0,_rem2.default)('360px'));var RangeInputWrapper=exports.RangeInputWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__RangeInputWrapper',componentId:'sc-1kpl7nk-1'})(['display:flex;flex-direction:column;']);var StyledCalendarPicker=exports.StyledCalendarPicker=(0,_styledComponents2.default)(_reactDayPicker2.default).withConfig({displayName:'styles__StyledCalendarPicker',componentId:'sc-1kpl7nk-2'})(['.DayPicker-Day--selected:not(.DayPicker-Day--start):not(.DayPicker-Day--end):not(.DayPicker-Day--outside){background-color:#e2e1eb !important;color:',';}.DayPicker-Day{border-radius:0 !important;color:',';',';}.DayPicker-Caption{',';color:',';text-align:center;}.DayPicker-NavButton--next{right:0;}.DayPicker-NavButton--prev{left:0;}.DayPicker-Day--start,.DayPicker-Day--end{outline:none;padding:0 !important;}.DayPicker-Day--start{background:linear-gradient(90deg,rgba(255,255,255,1) 50%,rgba(226,225,235,1) 50%);}.DayPicker-Day--end{background:linear-gradient(90deg,rgba(226,225,235,1) 50%,rgba(255,255,255,1) 50%);}.DayPicker-Day--start div,.DayPicker-Day--end div{background-color:',';color:white;outline:none;border-radius:60px !important;padding:0.5em;}.DayPicker-Weekday abbr{',';}'],_colors.darkSlateBlue,_colors.darkSlateBlue,_types.txt14OpenSans,_types.title16Galano,_colors.darkSlateBlue,_colors.darkSlateBlue,_types.txt14OpenSans);var Error=exports.Error=_styledComponents2.default.span.withConfig({displayName:'styles__Error',componentId:'sc-1kpl7nk-3'})(['color:',';display:inline-block;font-family:OpenSans;font-size:',';letter-spacing:',';margin-top:',';'],_colors.red,(0,_rem2.default)('14px'),(0,_rem2.default)('-0.3px'),(0,_rem2.default)('10px'));var Day=exports.Day=_styledComponents2.default.div.withConfig({displayName:'styles__Day',componentId:'sc-1kpl7nk-4'})(['color:',';'],_colors.darkSlateBlue);

/***/ }),
/* 1957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/FilterByWeekDays/CheckboxItem.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _styles=__webpack_require__(640);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var renderCheckboxItem=function renderCheckboxItem(props){var inputValue=props.input.value;return _react2.default.createElement(_styles.InputCheckbox,_extends({},props,{onChange:function onChange(e){var arr=[].concat(_toConsumableArray(inputValue));if(e.target.checked){arr.push(props.typeValue);}else{arr.splice(arr.indexOf(props.typeValue),1);}props.input.onChange(arr);props.setWeekDayRef(e.target);},value:props.input.value,type:'checkbox',__source:{fileName:_jsxFileName,lineNumber:8}}));};function CheckboxItem(props){return _react2.default.createElement(_styles.CheckBoxContainer,{__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_reduxForm.Field,_extends({component:renderCheckboxItem},props,{__source:{fileName:_jsxFileName,lineNumber:29}})),_react2.default.createElement(_styles.CheckboxLabel,{__source:{fileName:_jsxFileName,lineNumber:30}},props.label));}exports.default=CheckboxItem;module.exports=exports['default'];

/***/ }),
/* 1958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icons/CalendarIcon.js";exports.default=CalendarIcon;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function CalendarIcon(props){return _react2.default.createElement("svg",_extends({width:18,height:20,viewBox:"0 0 18 20",fill:"none"},props,{__source:{fileName:_jsxFileName,lineNumber:5}}),_react2.default.createElement("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M11.963 3.81H6.03v.72a.742.742 0 01-1.484 0v-.72H3.024a.948.948 0 00-.947.948v11.951c0 .523.425.948.947.948h11.952a.948.948 0 00.948-.948V4.758a.948.948 0 00-.948-.947h-1.53v.718a.742.742 0 01-1.483 0v-.718zm0-1.483v-.756a.742.742 0 111.483 0v.756h1.53c1.34 0 2.43 1.09 2.43 2.43V16.71c0 1.34-1.09 2.43-2.43 2.43H3.024c-1.34 0-2.43-1.09-2.43-2.43V4.758c0-1.34 1.09-2.43 2.43-2.43h1.522V1.57a.742.742 0 111.484 0v.756h5.933zM13.72 8.73H4.295a.742.742 0 010-1.484h9.425a.742.742 0 110 1.484z",fill:"#24206B",__source:{fileName:_jsxFileName,lineNumber:6}}));}module.exports=exports["default"];

/***/ }),
/* 1959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.gqlValePedagio=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/StatementsFilterForm/FilterByServices/FilterByServices.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(['\n  query valePedagio($idConta: String) {\n    valePedagio(idConta: $idConta) {\n      valePedagio\n    }\n  }\n'],['\n  query valePedagio($idConta: String) {\n    valePedagio(idConta: $idConta) {\n      valePedagio\n    }\n  }\n']);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _apolloClient=__webpack_require__(42);var _CheckboxItem=__webpack_require__(1960);var _CheckboxItem2=_interopRequireDefault(_CheckboxItem);var _styles=__webpack_require__(641);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* eslint-disable */var gqlValePedagio=exports.gqlValePedagio=(0,_graphqlTag2.default)(_templateObject);var FilterByServices=function(_React$Component){_inherits(FilterByServices,_React$Component);function FilterByServices(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FilterByServices);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FilterByServices.__proto__||Object.getPrototypeOf(FilterByServices)).call.apply(_ref,[this].concat(args))),_this),_this.state={loadingValePedagio:true},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FilterByServices,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _ref3,data;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_apolloClient.gqlQuery)(gqlValePedagio,{idConta:this.props.activePlanId});case 2:_ref3=_context.sent;data=_ref3.data;this.setState({loadingValePedagio:false});this.props.setHasValePedagio(data.valePedagio.valePedagio);case 6:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:42}},'Servi\xE7os'),_react2.default.createElement(_styles.ServicesCheckboxesContainer,{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_styles.ServicesCheckboxes,{__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_CheckboxItem2.default,{disabled:this.state.loadingValePedagio,label:'Estacionamento',onChange:this.props.onChange,setServicesRef:this.props.setServicesRef,typeValue:'ESTACIONAMENTO',name:'type',index:1,__source:{fileName:_jsxFileName,lineNumber:45}}),_react2.default.createElement(_CheckboxItem2.default,{disabled:this.state.loadingValePedagio,label:'Ped\xE1gio',onChange:this.props.onChange,setServicesRef:this.props.setServicesRef,typeValue:'PEDAGIO',name:'type',index:2,__source:{fileName:_jsxFileName,lineNumber:54}}),this.props.hasValePedagio&&_react2.default.createElement(_CheckboxItem2.default,{selectedTypes:this.props.selectedTypes,label:'Vale Ped\xE1gio',onChange:this.props.onChange,setServicesRef:this.props.setServicesRef,typeValue:'VALE_PEDAGIO',name:'type',index:3,__source:{fileName:_jsxFileName,lineNumber:63}})))));}}]);return FilterByServices;}(_react2.default.Component);var formSelector=(0,_reduxForm.formValueSelector)('statementsFilter');exports.default=(0,_reactRedux.connect)(function(state){return{selectedTypes:formSelector(state,'type')};})(FilterByServices);

/***/ }),
/* 1960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/StatementsFilterForm/FilterByServices/CheckboxItem.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _Icon=__webpack_require__(31);var _styles=__webpack_require__(641);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var renderCheckboxItem=function renderCheckboxItem(props){var inputValue=props.input.value;return _react2.default.createElement(_styles.InputCheckbox,_extends({},props,{onChange:function onChange(e){var arr=[].concat(_toConsumableArray(inputValue));if(e.target.checked){arr.push({tipo:props.typeValue});}else{var pos=arr.map(function(arrItem){return arrItem.tipo;}).indexOf(props.typeValue);arr.splice(pos,1);}props.input.onChange(arr);props.setServicesRef(e.target);},value:props.input.value,type:'checkbox',__source:{fileName:_jsxFileName,lineNumber:10}}));};function CheckboxItem(_ref){var _ref$selectedTypes=_ref.selectedTypes,selectedTypes=_ref$selectedTypes===undefined?[]:_ref$selectedTypes,otherProps=_objectWithoutProperties(_ref,['selectedTypes']);var checked=selectedTypes.some(function(type){return type.tipo===otherProps.typeValue;});return _react2.default.createElement(_styles.CheckBoxContainer,{disabled:otherProps.disabled,__source:{fileName:_jsxFileName,lineNumber:36}},_react2.default.createElement(_reduxForm.Field,_extends({component:renderCheckboxItem},otherProps,{__source:{fileName:_jsxFileName,lineNumber:37}})),_react2.default.createElement(_styles.Box,{checked:checked,__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement(_styles.CheckIcon,{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_Icon.Icon,{width:'11',height:'8',icon:'check',viewBox:'0 0 11 8',__source:{fileName:_jsxFileName,lineNumber:40}}))),_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:43}},otherProps.label));}exports.default=CheckboxItem;module.exports=exports['default'];

/***/ }),
/* 1961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonsWrapper=exports.ButtonsContainer=exports.FormButton=exports.ResetButton=exports.Separator=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'styles__Separator',componentId:'sc-1ltbecr-0'})(['border-top:2px solid ',';width:',';margin:0 auto;'],_colors.paleGray,(0,_rem2.default)('960px'));var ResetButton=exports.ResetButton=_styledComponents2.default.button.withConfig({displayName:'styles__ResetButton',componentId:'sc-1ltbecr-1'})(['color:white;',';border-width:0;border-bottom:2px solid white;'],_types.txt16OpenSansBold);var FormButton=exports.FormButton=_styledComponents2.default.button.withConfig({displayName:'styles__FormButton',componentId:'sc-1ltbecr-2'})(['background-color:',';color:',';',';padding:',' ',';border-radius:25px;margin-left:',';border-width:0;width:173px;height:52px;'],_colors.skyBlue,_colors.darkSlateBlue,_types.title16Galano,(0,_rem2.default)('13px'),(0,_rem2.default)('25px'),(0,_rem2.default)('20px'));var ButtonsContainer=exports.ButtonsContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonsContainer',componentId:'sc-1ltbecr-3'})(['width:100%;background-color:',';height:',';align-items:center;justify-content:space-around;display:flex;position:fixed;bottom:0;z-index:2;'],_colors.darkSlateBlue,(0,_rem2.default)('100px'));var ButtonsWrapper=exports.ButtonsWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonsWrapper',componentId:'sc-1ltbecr-4'})(['width:',';background-color:',';height:',';align-items:center;justify-content:space-between;display:flex;'],(0,_rem2.default)('960px'),_colors.darkSlateBlue,(0,_rem2.default)('100px'));

/***/ }),
/* 1962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.renderSelectFilterField=undefined;var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatement/FilterByIdentifier/FilterByIdentifier.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _reactRedux=__webpack_require__(7);var _lodash=__webpack_require__(43);var _aleloLogic=__webpack_require__(12);var _apolloClient=__webpack_require__(42);var _dashboardService=__webpack_require__(66);var _vehicles=__webpack_require__(94);var _styles=__webpack_require__(263);var _loading=__webpack_require__(100);var _loading2=_interopRequireDefault(_loading);var _SearchIcon=__webpack_require__(400);var _SearchIcon2=_interopRequireDefault(_SearchIcon);var _icClose=__webpack_require__(157);var _icClose2=_interopRequireDefault(_icClose);var _icEdit=__webpack_require__(1963);var _icEdit2=_interopRequireDefault(_icEdit);var _IdentifierTable=__webpack_require__(1964);var _IdentifierTable2=_interopRequireDefault(_IdentifierTable);var _IdentifierPaginator=__webpack_require__(1966);var _IdentifierPaginator2=_interopRequireDefault(_IdentifierPaginator);var _colors=__webpack_require__(2);var _masks=__webpack_require__(390);var _SelectPlateFilterSelection=__webpack_require__(1969);var _SelectPlateFilterSelection2=_interopRequireDefault(_SelectPlateFilterSelection);var _CreateEditFilterSelectionModal=__webpack_require__(1973);var _CreateEditFilterSelectionModal2=_interopRequireDefault(_CreateEditFilterSelectionModal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var renderSelectFilterField=exports.renderSelectFilterField=function renderSelectFilterField(props){return _react2.default.createElement(Select,_extends({},props.input,{label:props.label,onChange:function onChange(value){return props.input.onChange(value);},options:props.options,errorMessage:props.meta.touched&&props.meta.error,isRequired:props.isRequired,placeholder:props.placeholder,negative:props.negative,disabled:props.disabled,__source:{fileName:_jsxFileName,lineNumber:42}}));};var renderSearchInput=function renderSearchInput(props){return _react2.default.createElement(_styles.SearchInputWrapper,{hide:props.hide,__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_styles.SearchIconContainer,{__source:{fileName:_jsxFileName,lineNumber:58}},_react2.default.createElement(_SearchIcon2.default,{__source:{fileName:_jsxFileName,lineNumber:59}})),props.input.value.length>0&&!props.isLoading&&_react2.default.createElement(_styles.CloseIconContainer,{onClick:function onClick(){return props.resetInput();},__source:{fileName:_jsxFileName,lineNumber:63}},_react2.default.createElement(_icClose2.default,{width:'22',height:'22',fill:_colors.darkSlateBlue,__source:{fileName:_jsxFileName,lineNumber:64}})),_react2.default.createElement(_styles.SearchInput,_extends({},props.input,{value:(0,_masks.noSpecialCharacters)(props.input.value),type:'text',placeholder:props.placeholder,__source:{fileName:_jsxFileName,lineNumber:67}})),props.loading&&_react2.default.createElement(_styles.Loading,{src:_loading2.default,__source:{fileName:_jsxFileName,lineNumber:73}}),props.meta.error&&_react2.default.createElement(_styles.Error,{__source:{fileName:_jsxFileName,lineNumber:74}},props.meta.error));};var throttledGqlQuery=(0,_lodash.throttle)(_apolloClient.gqlQuery,2000);function fixedGqlParams(accountId){return{idConta:accountId,quantidade:24,ordenacao:'placa',somentePlacas:true};}var FilterByIdentifier=function(_React$Component){_inherits(FilterByIdentifier,_React$Component);function FilterByIdentifier(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,FilterByIdentifier);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FilterByIdentifier.__proto__||Object.getPrototypeOf(FilterByIdentifier)).call.apply(_ref,[this].concat(args))),_this),_this.state={openModal:false,editFilter:null,modalType:'CREATE',showEditSelectionBlock:false,editingSelection:false,currentOption:null,isLoading:false,isLoadingPagination:false,identificadores:[],requestPaginationTotal:0,total:0,paginaAtual:1,previousSearch:'',options:[]},_this.changeOption=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(optionSelected){var requestPaginationTotal;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(optionSelected.id==='TODAS'){requestPaginationTotal=_this.state.requestPaginationTotal;_this.setState({currentOption:optionSelected,total:requestPaginationTotal,paginaAtual:1,showEditSelectionBlock:false});_this.props.dispatch((0,_reduxForm.change)('statementsFilter','placas',[]));}else{_this.setState({paginaAtual:1,currentOption:optionSelected,showEditSelectionBlock:true});_this.props.dispatch((0,_reduxForm.change)('statementsFilter','placas',optionSelected.info));}case 1:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.changePage=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(page){var selectedIdentifiers,_this$state,editingSelection,currentOption,response;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:selectedIdentifiers=_this.props.selectedIdentifiers;_this$state=_this.state,editingSelection=_this$state.editingSelection,currentOption=_this$state.currentOption;if(!(selectedIdentifiers&&selectedIdentifiers.length>0&&currentOption&&currentOption.id!=='TODAS'&&!editingSelection)){_context2.next=6;break;}_this.setState({paginaAtual:page});_context2.next=11;break;case 6:_this.setState({isLoadingPagination:true});_context2.next=9;return throttledGqlQuery(_vehicles.gqlIdentificadoresPaginado,_extends({placa:_this.props.searchInputValue,pagina:page},fixedGqlParams(_this.props.accountId)));case 9:response=_context2.sent;if(response.data.identificadoresPJV2.identificadores.length){_this.setState({isLoadingPagination:false,identificadores:response.data.identificadoresPJV2.identificadores,paginaAtual:page});}case 11:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x2){return _ref3.apply(this,arguments);};}(),_this.getFilteredSelectedIdentifiers=function(value){if(!value){return _this.state.currentOption.info;}else{var filteredIdentifiers=(0,_lodash.filter)(_this.state.currentOption.info,function(i){return i.placa.toLocaleLowerCase().indexOf(value)>=0||i.placa.toLocaleLowerCase().indexOf(value)>=0;});return filteredIdentifiers;}},_this.changeInput=(0,_lodash.debounce)(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(value){var selectedIdentifiers,filteredIdentifiers,response,_response$data$identi,identificadores,paginacao;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!((value.length>2||value.length===0)&&value!==_this.state.previousSearch)){_context3.next=15;break;}if(!(_this.state.currentOption&&_this.state.currentOption.id!=='TODAS')){_context3.next=8;break;}selectedIdentifiers=_this.props.selectedIdentifiers;filteredIdentifiers=_this.getFilteredSelectedIdentifiers(value);_this.setState({isLoading:false,previousSearch:value,total:filteredIdentifiers.length>0?filteredIdentifiers.length:selectedIdentifiers.length,paginaAtual:1});_this.props.dispatch((0,_reduxForm.change)('statementsFilter','placas',filteredIdentifiers));_context3.next=15;break;case 8:_this.setState({isLoading:true});_context3.next=11;return(0,_apolloClient.gqlQuery)(_vehicles.gqlIdentificadoresPaginado,_extends({placa:value},fixedGqlParams(_this.props.accountId)));case 11:response=_context3.sent;_response$data$identi=response.data.identificadoresPJV2,identificadores=_response$data$identi.identificadores,paginacao=_response$data$identi.paginacao;_this.setState({isLoading:false,previousSearch:value});_this.setState({identificadores:identificadores,total:paginacao.total,paginaAtual:1});case 15:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x3){return _ref4.apply(this,arguments);};}(),1000),_this.resetInput=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(){return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_this.setState({paginaAtual:1});_this.props.dispatch((0,_reduxForm.change)('statementsFilter','searchPlate',''));if(_this.state.showEditSelectionBlock){_this.props.dispatch((0,_reduxForm.change)('statementsFilter','placas',_this.state.currentOption.info));}case 3:case'end':return _context4.stop();}}},_callee4,_this2);})),_this.plateValidation=function(value){if(value&&value.length>=7){return _aleloLogic.utils.plateValidate(value);}return undefined;},_this.toggleModal=function(){var modalType=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'CREATE';var editFilter=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;_this.setState({openModal:!_this.state.openModal,modalType:modalType,editFilter:editFilter});},_this.onCancelEditSelection=function(){_this.props.dispatch((0,_reduxForm.change)('statementsFilter','placas',_this.state.currentOption.info));_this.setState({showEditSelectionBlock:!_this.state.showEditSelectionBlock,editingSelection:!_this.state.editingSelection});},_this.createPlateFilter=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(filterName){var selectedIdentifiers,result;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:selectedIdentifiers=_this.props.selectedIdentifiers;_context5.next=3;return(0,_dashboardService.addPlateFilter)({conta:_this.props.accountId,descricaoFiltro:filterName,info:selectedIdentifiers,tipo:'PLACAS'});case 3:result=_context5.sent;if(result.data){_this.setState({options:[].concat(_toConsumableArray(_this.state.options),[{id:result.data.id,descricaoFiltro:filterName,info:selectedIdentifiers}]),currentOption:{id:result.data.id,descricaoFiltro:filterName,info:selectedIdentifiers},showEditSelectionBlock:true});}case 5:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x6){return _ref6.apply(this,arguments);};}(),_this.editPlateFilter=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(filterName){var currentOption,selectedIdentifiers,result,optionIndex,newData;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:currentOption=_this.state.currentOption;selectedIdentifiers=_this.props.selectedIdentifiers;_context6.next=4;return(0,_dashboardService.updatePlateFilter)({id:currentOption.id,conta:_this.props.accountId,descricaoFiltro:filterName,info:selectedIdentifiers.map(function(selected){return{placa:selected.placa};}),tipo:'PLACAS'});case 4:result=_context6.sent;if(result.data){optionIndex=_this.state.options.findIndex(function(option){return option.id===result.data.id;});newData=_this.state.options;newData[optionIndex]=result.data;_this.setState({currentOption:_extends({},result.data,{info:result.data.info.map(function(i){return{placa:i.placa};})}),options:newData,showEditSelectionBlock:true,editingSelection:false});}case 6:case'end':return _context6.stop();}}},_callee6,_this2);}));return function(_x7){return _ref7.apply(this,arguments);};}(),_this.deletePlateFilter=function(){var _ref8=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(id){var result,newData;return regeneratorRuntime.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.next=2;return(0,_dashboardService.deletePlateFilter)(_this.props.accountId,id);case 2:result=_context7.sent;if(result&&result.data&&result.data.msg.includes('sucesso')){newData=_this.state.options.filter(function(option){return option.id!==id;});_this.setState({options:newData});}case 4:case'end':return _context7.stop();}}},_callee7,_this2);}));return function(_x8){return _ref8.apply(this,arguments);};}(),_this.renderCreateEditSelection=function(){var _this$state2=_this.state,currentOption=_this$state2.currentOption,showEditSelectionBlock=_this$state2.showEditSelectionBlock,editingSelection=_this$state2.editingSelection;var selectedIdentifiers=_this.props.selectedIdentifiers;if(showEditSelectionBlock&&currentOption){return _react2.default.createElement(_styles.FilterContainer,{__source:{fileName:_jsxFileName,lineNumber:350}},_react2.default.createElement(_styles.SaveFilterSelection,{type:'button',onClick:function onClick(){return _this.setState({showEditSelectionBlock:!showEditSelectionBlock,editingSelection:true,paginaAtual:1});},__source:{fileName:_jsxFileName,lineNumber:351}},'Editar sele\xE7\xE3o',_react2.default.createElement(_icEdit2.default,{__source:{fileName:_jsxFileName,lineNumber:362}})));}if(currentOption&&currentOption.id!=='TODAS'&&editingSelection){return _react2.default.createElement(_styles.FilterContainer,{__source:{fileName:_jsxFileName,lineNumber:370}},_react2.default.createElement(_styles.SaveFilterSelection,{secondary:true,type:'button',onClick:function onClick(){return _this.onCancelEditSelection();},__source:{fileName:_jsxFileName,lineNumber:371}},'Cancelar'),_react2.default.createElement(_styles.SaveFilterSelection,{type:'button',onClick:function onClick(){return _this.toggleModal('EDIT',currentOption);},__source:{fileName:_jsxFileName,lineNumber:374}},'Salvar altera\xE7\xF5es',_react2.default.createElement(_icEdit2.default,{__source:{fileName:_jsxFileName,lineNumber:379}})));}else if(selectedIdentifiers&&selectedIdentifiers.length>0){return _react2.default.createElement(_styles.FilterContainer,{__source:{fileName:_jsxFileName,lineNumber:385}},_react2.default.createElement(_styles.SaveFilterSelection,{type:'button',onClick:function onClick(){return _this.toggleModal();},__source:{fileName:_jsxFileName,lineNumber:386}},'Salvar sele\xE7\xE3o de placas'));}return null;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FilterByIdentifier,[{key:'componentDidMount',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8(){var filtrosPlacas,response,_response$data$identi2,identificadores,paginacao;return regeneratorRuntime.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:this.setState({isLoading:true});_context8.next=3;return(0,_dashboardService.getPlateFilters)(this.props.accountId,'PLACAS');case 3:filtrosPlacas=_context8.sent;_context8.next=6;return(0,_apolloClient.gqlQuery)(_vehicles.gqlIdentificadoresPaginado,_extends({},fixedGqlParams(this.props.accountId)));case 6:response=_context8.sent;_response$data$identi2=response.data.identificadoresPJV2,identificadores=_response$data$identi2.identificadores,paginacao=_response$data$identi2.paginacao;this.setState({identificadores:identificadores,requestPaginationTotal:paginacao.total,total:paginacao.total,isLoading:false,options:filtrosPlacas.data.map(function(filtro){return _extends({},filtro,{info:filtro.info.map(function(info){return{placa:info.placa};})});})});case 9:case'end':return _context8.stop();}}},_callee8,this);}));function componentDidMount(){return _ref9.apply(this,arguments);}return componentDidMount;}()},{key:'componentDidUpdate',value:function(){var _ref10=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9(prevProps){var response,_response$data$identi3,identificadores,paginacao;return regeneratorRuntime.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:if(prevProps.selectedIdentifiers&&this.props.selectedIdentifiers===undefined){this.setState({currentOption:null,showEditSelectionBlock:false});}if(!(prevProps.searchInputValue&&this.props.searchInputValue===undefined)){_context9.next=12;break;}if(!(this.state.currentOption&&this.state.currentOption.id!=='TODAS')){_context9.next=6;break;}this.props.dispatch((0,_reduxForm.change)('statementsFilter','placas',this.state.currentOption.info));_context9.next=12;break;case 6:this.setState({isLoading:true});_context9.next=9;return(0,_apolloClient.gqlQuery)(_vehicles.gqlIdentificadoresPaginado,_extends({},fixedGqlParams(this.props.accountId)));case 9:response=_context9.sent;_response$data$identi3=response.data.identificadoresPJV2,identificadores=_response$data$identi3.identificadores,paginacao=_response$data$identi3.paginacao;this.setState({identificadores:identificadores,requestPaginationTotal:paginacao.total,total:paginacao.total,isLoading:false});case 12:case'end':return _context9.stop();}}},_callee9,this);}));function componentDidUpdate(_x9){return _ref10.apply(this,arguments);}return componentDidUpdate;}()},{key:'render',value:function render(){var _this3=this;var _state=this.state,identificadores=_state.identificadores,total=_state.total,paginaAtual=_state.paginaAtual,isLoading=_state.isLoading,isLoadingPagination=_state.isLoadingPagination,currentOption=_state.currentOption,options=_state.options,openModal=_state.openModal,editFilter=_state.editFilter,modalType=_state.modalType,showEditSelectionBlock=_state.showEditSelectionBlock,editingSelection=_state.editingSelection;var selectedIdentifiers=this.props.selectedIdentifiers;var identificadoresOrderDesc=identificadores.length>0?identificadores.sort(function(a,b){return a.veiculo.placa.localeCompare(b.veiculo.placa);}):identificadores;var selectedIdentifiersChunk=selectedIdentifiers&&selectedIdentifiers.length>0?(0,_lodash.chunk)(selectedIdentifiers.sort(function(a,b){return a.placa.localeCompare(b.placa);}),24):[[]];var totalItems=selectedIdentifiers&&selectedIdentifiers.length>0&&currentOption&&currentOption.id!=='TODAS'&&!editingSelection?selectedIdentifiers.length:total;return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:433}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:434}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:435}},'Placa'),_react2.default.createElement(_styles.InputContainer,{__source:{fileName:_jsxFileName,lineNumber:437}},_react2.default.createElement(_reduxForm.Field,{component:renderSearchInput,onChange:function onChange(e){return _this3.changeInput((0,_masks.noSpecialCharacters)(e.target.value));},name:'searchPlate',validate:this.plateValidation,placeholder:'Busque por placa',loading:isLoading,resetInput:this.resetInput,isLoading:isLoading,__source:{fileName:_jsxFileName,lineNumber:438}}),_react2.default.createElement(_SelectPlateFilterSelection2.default,{currentOption:currentOption,setOption:this.changeOption,onDelete:function onDelete(item){return _this3.toggleModal('DELETE',item);},options:options,editingSelection:editingSelection,showEditSelectionBlock:showEditSelectionBlock,editingNewSelectionLength:selectedIdentifiers&&selectedIdentifiers.length,__source:{fileName:_jsxFileName,lineNumber:448}})),_react2.default.createElement(_IdentifierTable2.default,{editSelectionBlock:showEditSelectionBlock,editingSelection:editingSelection,isLoadingPagination:isLoadingPagination,identificadores:identificadoresOrderDesc,selectedIdentifiers:selectedIdentifiersChunk&&!editingSelection&&currentOption&&currentOption.id!=='TODAS'?selectedIdentifiersChunk[paginaAtual-1]:selectedIdentifiers,__source:{fileName:_jsxFileName,lineNumber:459}}),_react2.default.createElement(_IdentifierPaginator2.default,{total:totalItems,paginaAtual:paginaAtual,changePage:this.changePage,__source:{fileName:_jsxFileName,lineNumber:473}}),this.renderCreateEditSelection()),openModal&&_react2.default.createElement(_CreateEditFilterSelectionModal2.default,{onCreate:function onCreate(filterName){return _this3.createPlateFilter(filterName);},onEdit:function onEdit(filterName){return _this3.editPlateFilter(filterName);},onDelete:function onDelete(id){return _this3.deletePlateFilter(id);},modalType:modalType,editFilter:editFilter,isOpen:openModal,toggleModal:this.toggleModal,__source:{fileName:_jsxFileName,lineNumber:481}}));}}]);return FilterByIdentifier;}(_react2.default.Component);var selector=(0,_reduxForm.formValueSelector)('statementsFilter');var mapStateToProps=function mapStateToProps(state){return{searchInputValue:selector(state,'searchPlate'),selectedIdentifiers:selector(state,'placas')};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(FilterByIdentifier);

/***/ }),
/* 1963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-edit.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function IcEdit(_ref){var width=_ref.width,height=_ref.height;return _react2.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:width||"17",height:height||"18",fill:"none",viewBox:"0 0 17 18",__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M13.376 17.02H2.81a2.268 2.268 0 01-2.264-2.265V4.19A2.268 2.268 0 012.81 1.926h5.534a.755.755 0 010 1.51H2.81a.755.755 0 00-.754.754v10.565c0 .416.338.755.754.755h10.565a.757.757 0 00.756-.755V9.198a.754.754 0 111.508 0v5.557a2.266 2.266 0 01-2.264 2.264zm-7.55-5.323h1.068L14.9 3.689c.14-.141.22-.33.22-.534a.747.747 0 00-.754-.753.746.746 0 00-.533.22l-8.007 8.007v1.068zm1.38 1.51H5.07a.754.754 0 01-.754-.755v-2.135c0-.2.08-.393.222-.534l8.227-8.23a2.254 2.254 0 011.601-.66c.607 0 1.176.235 1.602.661.426.427.663.995.663 1.601a2.25 2.25 0 01-.663 1.602l-8.23 8.229a.75.75 0 01-.531.22z",clipRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:12}}));}exports.default=IcEdit;module.exports=exports["default"];

/***/ }),
/* 1964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatement/FilterByIdentifier/IdentifierTable.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _IdentifierItem=__webpack_require__(1965);var _IdentifierItem2=_interopRequireDefault(_IdentifierItem);var _styles=__webpack_require__(263);var _loading=__webpack_require__(100);var _loading2=_interopRequireDefault(_loading);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function IdentifierTable(_ref){var editingSelection=_ref.editingSelection,editSelectionBlock=_ref.editSelectionBlock,_ref$identificadores=_ref.identificadores,identificadores=_ref$identificadores===undefined?[]:_ref$identificadores,_ref$selectedIdentifi=_ref.selectedIdentifiers,selectedIdentifiers=_ref$selectedIdentifi===undefined?[]:_ref$selectedIdentifi,_ref$isLoadingPaginat=_ref.isLoadingPagination,isLoadingPagination=_ref$isLoadingPaginat===undefined?false:_ref$isLoadingPaginat;var filteredIdentifiers=selectedIdentifiers&&editSelectionBlock&&!editingSelection?selectedIdentifiers.map(function(identifier){return{veiculo:{placa:identifier.placa}};}):identificadores;return _react2.default.createElement(_styles.Content,{isLoadingPagination:isLoadingPagination,__source:{fileName:_jsxFileName,lineNumber:27}},isLoadingPagination?_react2.default.createElement(_styles.LoadingTable,{src:_loading2.default,__source:{fileName:_jsxFileName,lineNumber:29}}):_react2.default.createElement(_styles.FilterTypes,{__source:{fileName:_jsxFileName,lineNumber:31}},filteredIdentifiers.map(function(type,index){var isSelected=selectedIdentifiers.some(function(identifier){return identifier.placa===type.veiculo.placa;});return _react2.default.createElement(_styles.ListItem,{key:type.veiculo.placa+'-'+index,__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_IdentifierItem2.default,{blocked:editSelectionBlock,typeValue:type.veiculo.placa,name:'placas',label:type.veiculo.placa,index:index,isSelected:isSelected,__source:{fileName:_jsxFileName,lineNumber:38}}));})));}exports.default=IdentifierTable;module.exports=exports['default'];

/***/ }),
/* 1965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatement/FilterByIdentifier/IdentifierItem.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _styles=__webpack_require__(263);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var renderIdentifierItem=function renderIdentifierItem(props){var inputValue=props.input.value;return _react2.default.createElement(_styles.InputIdentifier,_extends({},props,{onChange:function onChange(e){var arr=[].concat(_toConsumableArray(inputValue));if(!props.isSelected&&!arr.find(function(item){return item.placa===props.typeValue;})){arr.push({placa:props.typeValue});}else{var pos=arr.map(function(arrItem){return arrItem.placa;}).indexOf(props.typeValue);arr.splice(pos,1);}props.input.onChange(arr);},value:props.input.value,type:'checkbox',disabled:props.blocked,__source:{fileName:_jsxFileName,lineNumber:8}}));};function IdentifierItem(props){return _react2.default.createElement(_styles.IdentifierItemContainer,{__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_reduxForm.Field,_extends({component:renderIdentifierItem},props,{__source:{fileName:_jsxFileName,lineNumber:34}})),_react2.default.createElement(_styles.IdentifierLabel,{isSelected:props.isSelected,isBlockedEdit:props.blocked,__source:{fileName:_jsxFileName,lineNumber:35}},props.label.substring(0,3)+'-'+props.label.substring(3)));}exports.default=IdentifierItem;module.exports=exports['default'];

/***/ }),
/* 1966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.IdentifierPaginator=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatement/FilterByIdentifier/IdentifierPaginator.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(263);var _ChevronLeft=__webpack_require__(1967);var _ChevronLeft2=_interopRequireDefault(_ChevronLeft);var _ChevronRight=__webpack_require__(1968);var _ChevronRight2=_interopRequireDefault(_ChevronRight);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getNumberOfPages=function getNumberOfPages(total,quantidade){return Math.ceil(total/quantidade);};var IdentifierPaginator=exports.IdentifierPaginator=function(_Component){_inherits(IdentifierPaginator,_Component);function IdentifierPaginator(){_classCallCheck(this,IdentifierPaginator);return _possibleConstructorReturn(this,(IdentifierPaginator.__proto__||Object.getPrototypeOf(IdentifierPaginator)).apply(this,arguments));}_createClass(IdentifierPaginator,[{key:'render',value:function render(){var _props=this.props,_props$total=_props.total,total=_props$total===undefined?0:_props$total,_props$quantidade=_props.quantidade,quantidade=_props$quantidade===undefined?24:_props$quantidade,changePage=_props.changePage,_props$paginaAtual=_props.paginaAtual,paginaAtual=_props$paginaAtual===undefined?1:_props$paginaAtual;var numberOfPages=getNumberOfPages(total,quantidade);var delta=2;var left=paginaAtual-delta;var right=paginaAtual+delta+1;var range=[];var rangeWithDots=[];var l=void 0;for(var i=1;i<=numberOfPages;i++){if(i===1||i===numberOfPages||i>=left&&i<right){range.push(i);}}var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=range[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _i=_step.value;if(l){if(_i-l===2){rangeWithDots.push(l+1);}else if(_i-l!==1){rangeWithDots.push('...');}}rangeWithDots.push(_i);l=_i;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return _react2.default.createElement(_styles.PaginatorContainer,{__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_ChevronLeft2.default,{disabled:paginaAtual===1,onClick:function onClick(){return changePage(paginaAtual-1);},__source:{fileName:_jsxFileName,lineNumber:44}}),_react2.default.createElement(_styles.PageList,{__source:{fileName:_jsxFileName,lineNumber:45}},rangeWithDots.map(function(p,i){if(p==='...'){return _react2.default.createElement('span',{style:{padding:'4px'},key:'page-'+i,__source:{fileName:_jsxFileName,lineNumber:49}},p);}return _react2.default.createElement(_styles.Page,{isCurrentPage:p===paginaAtual,onClick:function onClick(){return changePage(p);},key:'page-'+i,__source:{fileName:_jsxFileName,lineNumber:56}},p);})),_react2.default.createElement(_ChevronRight2.default,{disabled:numberOfPages===paginaAtual,onClick:function onClick(){return changePage(paginaAtual+1);},__source:{fileName:_jsxFileName,lineNumber:66}})));}}]);return IdentifierPaginator;}(_react.Component);exports.default=IdentifierPaginator;

/***/ }),
/* 1967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Icons/ChevronLeft.js';var _react=__webpack_require__(0);var React=_interopRequireWildcard(_react);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}var Svg=_styledComponents2.default.svg.withConfig({displayName:'ChevronLeft__Svg',componentId:'sc-6i8eyr-0'})(['opacity:',';',';cursor:pointer;background-color:',';border-radius:50%;&:hover{background-color:',';path{stroke:white;}}'],function(_ref){var disabled=_ref.disabled;return disabled?0.3:1;},function(_ref2){var disabled=_ref2.disabled;return disabled&&'pointer-events: none';},_colors.paleGray,_colors.darkSlateBlue);function ChevronLeft(props){return React.createElement(Svg,_extends({width:'20px',height:'20px',viewBox:'0 0 32 32',xmlns:'http://www.w3.org/2000/svg'},props,{__source:{fileName:_jsxFileName,lineNumber:21}}),React.createElement('defs',{__source:{fileName:_jsxFileName,lineNumber:28}},React.createElement('style',{__source:{fileName:_jsxFileName,lineNumber:29}},'.prefix__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}')),React.createElement('title',{__source:{fileName:_jsxFileName,lineNumber:35}}),React.createElement('g',{id:'prefix__chevron-left',__source:{fileName:_jsxFileName,lineNumber:36}},React.createElement('path',{className:'prefix__cls-1',d:'M11 16l9-9M20 25l-9-9',__source:{fileName:_jsxFileName,lineNumber:37}})));}exports.default=ChevronLeft;module.exports=exports['default'];

/***/ }),
/* 1968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Icons/ChevronRight.js';var _react=__webpack_require__(0);var React=_interopRequireWildcard(_react);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}var Svg=_styledComponents2.default.svg.withConfig({displayName:'ChevronRight__Svg',componentId:'sc-1461kld-0'})(['cursor:pointer;opacity:',';',';width:\'20px\';right:\'20px\';background-color:',';border-radius:50%;&:hover{background-color:',';path{stroke:white;}}'],function(_ref){var disabled=_ref.disabled;return disabled?0.3:1;},function(_ref2){var disabled=_ref2.disabled;return disabled&&'pointer-events: none';},_colors.paleGray,_colors.darkSlateBlue);function ChevronRight(props){return React.createElement(Svg,_extends({width:'20px',height:'20px',viewBox:'0 0 32 32',xmlns:'http://www.w3.org/2000/svg'},props,{__source:{fileName:_jsxFileName,lineNumber:24}}),React.createElement('defs',{__source:{fileName:_jsxFileName,lineNumber:31}},React.createElement('style',{__source:{fileName:_jsxFileName,lineNumber:32}},'.prefix__cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}')),React.createElement('title',{__source:{fileName:_jsxFileName,lineNumber:38}}),React.createElement('g',{id:'prefix__chevron-right',__source:{fileName:_jsxFileName,lineNumber:39}},React.createElement('path',{className:'prefix__cls-1',d:'M21 16l-9 9M12 7l9 9',__source:{fileName:_jsxFileName,lineNumber:40}})));}exports.default=ChevronRight;module.exports=exports['default'];

/***/ }),
/* 1969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatement/FilterByIdentifier/SelectPlateFilterSelection/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _icClose=__webpack_require__(157);var _icClose2=_interopRequireDefault(_icClose);var _icCheck=__webpack_require__(1970);var _icCheck2=_interopRequireDefault(_icCheck);var _DropdownList=__webpack_require__(264);var _DropdownList2=_interopRequireDefault(_DropdownList);var _colors=__webpack_require__(2);var _styles=__webpack_require__(1972);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable jsx-a11y/no-static-element-interactions *//* eslint-disable jsx-a11y/click-events-have-key-events */var SelectPlateFilterSelection=function(_React$Component){_inherits(SelectPlateFilterSelection,_React$Component);function SelectPlateFilterSelection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SelectPlateFilterSelection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SelectPlateFilterSelection.__proto__||Object.getPrototypeOf(SelectPlateFilterSelection)).call.apply(_ref,[this].concat(args))),_this),_this.state={showDropdown:false},_this.toggleDropdown=function(){_this.setState({showDropdown:!_this.state.showDropdown});},_this.showCurrentOption=function(){var _this$props=_this.props,currentOption=_this$props.currentOption,editingSelection=_this$props.editingSelection,showEditSelectionBlock=_this$props.showEditSelectionBlock,editingNewSelectionLength=_this$props.editingNewSelectionLength;if(currentOption){if(currentOption.id==='TODAS'&&!editingNewSelectionLength){return currentOption.descricaoFiltro;}if(showEditSelectionBlock){return currentOption.descricaoFiltro+' ('+currentOption.info.length+')';}if(editingSelection&&editingNewSelectionLength){return currentOption.descricaoFiltro+' ('+editingNewSelectionLength+')';}if(editingNewSelectionLength){return'Nova sele\xE7\xE3o ('+editingNewSelectionLength+')';}else{return currentOption.descricaoFiltro+' ('+currentOption.info.length+')';}}if(editingNewSelectionLength){return'Nova sele\xE7\xE3o ('+editingNewSelectionLength+')';}return'Minhas seleções';},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectPlateFilterSelection,[{key:'render',value:function render(){var _this2=this;var showDropdown=this.state.showDropdown;var _props=this.props,options=_props.options,setOption=_props.setOption,currentOption=_props.currentOption,onDelete=_props.onDelete;return _react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:55}},_react2.default.createElement(_styles.Select,{type:'button',onClick:function onClick(){return _this2.toggleDropdown();},__source:{fileName:_jsxFileName,lineNumber:56}},this.showCurrentOption(),_react2.default.createElement(_Icon2.default,{icon:'dropdown-arrow',svgStyle:_styles.dropdownArrow,width:'12',height:'7',viewBox:'0 0 12 7',__source:{fileName:_jsxFileName,lineNumber:58}})),_react2.default.createElement(_DropdownList2.default,{withIcon:true,isOpen:showDropdown,onClose:function onClose(){return _this2.toggleDropdown();},__source:{fileName:_jsxFileName,lineNumber:66}},_react2.default.createElement(_styles.ItemWrapper,{__source:{fileName:_jsxFileName,lineNumber:67}},_react2.default.createElement(_styles.Text,{onClick:function onClick(){return setOption({id:'TODAS',descricaoFiltro:'Todas as placas',info:[]});},__source:{fileName:_jsxFileName,lineNumber:68}},'Todas as placas')),options.map(function(option){return _react2.default.createElement(_styles.ItemWrapper,{key:option.id,__source:{fileName:_jsxFileName,lineNumber:81}},_react2.default.createElement(_styles.Text,{onClick:function onClick(){return setOption(option);},__source:{fileName:_jsxFileName,lineNumber:82}},option.descricaoFiltro,' (',option.info.length,')'),currentOption&&currentOption.descricaoFiltro===option.descricaoFiltro?_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:87}},_react2.default.createElement(_icCheck2.default,{__source:{fileName:_jsxFileName,lineNumber:88}})):_react2.default.createElement(_styles.Delete,{onClick:function onClick(){return onDelete(option);},__source:{fileName:_jsxFileName,lineNumber:91}},_react2.default.createElement(_icClose2.default,{width:16,height:16,fill:_colors.darkBlue,__source:{fileName:_jsxFileName,lineNumber:92}})));})));}}]);return SelectPlateFilterSelection;}(_react2.default.Component);exports.default=SelectPlateFilterSelection;module.exports=exports['default'];

/***/ }),
/* 1970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-check.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function icCheck(_ref){var height=_ref.height,width=_ref.width;return _react2.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:width||'16',height:height||'14',fill:"none",viewBox:"0 0 16 14",__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{fill:"#24206B",fillRule:"evenodd",d:"M13.061.564c.678-.759 1.771-.75 2.44.017.636.727.663 1.876.088 2.64l-.102.123-9.025 10.092c-.624.698-1.603.75-2.28.146l-.115-.113L.543 9.716C-.15 8.976-.184 7.74.47 6.954c.619-.744 1.632-.817 2.327-.194l.113.11 2.31 2.462L13.062.564z",clipRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:12}}));}exports.default=icCheck;module.exports=exports["default"];

/***/ }),
/* 1971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DropdownListContainer=exports.Title=exports.DropdownListItem=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DropdownListItem=exports.DropdownListItem=_styledComponents2.default.li.withConfig({displayName:'styles__DropdownListItem',componentId:'sc-xyxaep-0'})(['text-decoration:none;list-style:none;cursor:pointer;',';'],function(_ref){var secondary=_ref.secondary;return secondary?(0,_styledComponents.css)(['padding:',' ',';'],(0,_rem2.default)('10px'),(0,_rem2.default)('15px')):(0,_styledComponents.css)(['padding:',' ',';'],(0,_rem2.default)('15px'),(0,_rem2.default)('20px'));});var Title=exports.Title=_styledComponents2.default.span.withConfig({displayName:'styles__Title',componentId:'sc-xyxaep-1'})(['',';color:',';display:block;line-height:1;text-transform:',';transition:color 0.2s;',':hover &{color:',';}'],_types.txt12OpenSans,function(_ref2){var isActived=_ref2.isActived;return isActived?_colors.linkNavyBlue:_colors.darkGrey;},function(_ref3){var withIcon=_ref3.withIcon;return withIcon?'initial':'capitalize';},DropdownListItem,_colors.linkNavyBlue);var DropdownListContainer=exports.DropdownListContainer=_styledComponents2.default.ul.withConfig({displayName:'styles__DropdownListContainer',componentId:'sc-xyxaep-2'})(['background-color:white;border-radius:',';box-shadow:0 ',' ',' 0 rgba(0,0,0,0.2);display:flex;flex-direction:column;pointer-events:none;position:absolute;top:',';z-index:20;margin:0;visibility:hidden;opacity:0;transform:translateY(-2em);transition:all 0.2s ease-in 0s,visibility 0s linear 0.2s;',';',';'],(0,_rem2.default)('6px'),(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),(0,_rem2.default)('50px'),function(_ref4){var secondary=_ref4.secondary,withIcon=_ref4.withIcon;return withIcon?(0,_styledComponents.css)(['right:80%;left:initial;width:',';padding:',' 0;'],(0,_rem2.default)('256px'),(0,_rem2.default)('8px')):secondary?(0,_styledComponents.css)(['right:80%;left:initial;width:',';padding:',' 0;'],(0,_rem2.default)('200px'),(0,_rem2.default)('8px')):(0,_styledComponents.css)(['right:initial;left:0;width:100%;padding:',' 0;'],(0,_rem2.default)('15px'));},function(_ref5){var isOpen=_ref5.isOpen;return isOpen&&(0,_styledComponents.css)(['pointer-events:all;visibility:visible;opacity:1;transform:translateY(0%);transition-delay:0s,0s;']);});

/***/ }),
/* 1972 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.dropdownArrow=exports.Delete=exports.Text=exports.ItemWrapper=exports.Select=exports.Wrapper=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-1mqncwc-0'})(['position:relative;ul{left:0px;top:60px;width:200px;max-height:240px;overflow:auto;&::-webkit-scrollbar-track{border-radius:16px;background-color:#f1f1f7;}&::-webkit-scrollbar{width:12px;}&::-webkit-scrollbar-thumb{border-radius:8px;background-color:',';}}'],_colors.grey);var Select=exports.Select=_styledComponents2.default.button.withConfig({displayName:'styles__Select',componentId:'sc-1mqncwc-1'})(['',';color:',';font-weight:700;height:100%;min-width:200px;border:none;border-bottom:1px solid #e2e1eb;display:flex;align-items:center;cursor:pointer;svg{margin-left:auto;margin-right:6px;}'],_types.txt14OpenSans,_colors.darkBlue);var ItemWrapper=exports.ItemWrapper=_styledComponents2.default.li.withConfig({displayName:'styles__ItemWrapper',componentId:'sc-1mqncwc-2'})(['display:flex;align-items:center;justify-content:space-between;list-style:none;width:100%;padding:16px;']);var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1mqncwc-3'})(['',';color:',';line-height:24px;margin:0;cursor:pointer;'],_types.txt16OpenSans,_colors.darkBlue);var Delete=exports.Delete=_styledComponents2.default.span.withConfig({displayName:'styles__Delete',componentId:'sc-1mqncwc-4'})(['cursor:pointer;']);var dropdownArrow=exports.dropdownArrow='\n    stroke: '+_colors.grey+'; height: 10px; width: 15px;\n';

/***/ }),
/* 1973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatement/FilterByIdentifier/CreateEditFilterSelectionModal/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Modal=__webpack_require__(113);var _icClose=__webpack_require__(157);var _icClose2=_interopRequireDefault(_icClose);var _colors=__webpack_require__(2);var _styles=__webpack_require__(1974);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Assets
// Styles
// Components
var CreateEditFilterSelectionModal=function(_Component){_inherits(CreateEditFilterSelectionModal,_Component);function CreateEditFilterSelectionModal(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,CreateEditFilterSelectionModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CreateEditFilterSelectionModal.__proto__||Object.getPrototypeOf(CreateEditFilterSelectionModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false,inputValue:''},_this.onChangeInput=function(e){_this.setState({inputValue:e.target.value});},_this.chooseOnSubmit=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _this$props,onCreate,onEdit,onDelete,toggleModal,modalType,editFilter,inputValue;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,onCreate=_this$props.onCreate,onEdit=_this$props.onEdit,onDelete=_this$props.onDelete,toggleModal=_this$props.toggleModal,modalType=_this$props.modalType,editFilter=_this$props.editFilter;inputValue=_this.state.inputValue;_this.setState({loading:true});if(!(modalType==='EDIT')){_context.next=8;break;}_context.next=6;return onEdit(inputValue);case 6:_context.next=15;break;case 8:if(!(modalType==='CREATE')){_context.next=13;break;}_context.next=11;return onCreate(inputValue);case 11:_context.next=15;break;case 13:_context.next=15;return onDelete(editFilter.id);case 15:_this.setState({loading:false});toggleModal();case 17:case'end':return _context.stop();}}},_callee,_this2);})),_this.handleCloseModal=function(){_this.props.toggleModal();},_this.handleCloseModalSuccess=function(){_this.handleCloseModal();},_this.renderContentModal=function(){var _this$props2=_this.props,editFilter=_this$props2.editFilter,modalType=_this$props2.modalType;var loading=_this.state.loading;if(editFilter&&modalType==='EDIT'){return _react2.default.createElement(_styles.WrapperContentModal,{__source:{fileName:_jsxFileName,lineNumber:70}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:71}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:72}},'Salvar altera\xE7\xF5es')),_react2.default.createElement(_styles.Input,{onChange:_this.onChangeInput,value:_this.state.inputValue,type:'text',placeholder:'Insira o nome da sele\xE7\xE3o',__source:{fileName:_jsxFileName,lineNumber:74}}),_react2.default.createElement(_styles.WrapperButton,{__source:{fileName:_jsxFileName,lineNumber:80}},_react2.default.createElement(_styles.Button,{type:'button',secondary:true,disabled:loading,onClick:_this.handleCloseModal,__source:{fileName:_jsxFileName,lineNumber:81}},'Cancelar'),_react2.default.createElement(_styles.Button,{type:'button',disabled:!_this.state.inputValue||loading,onClick:_this.chooseOnSubmit,__source:{fileName:_jsxFileName,lineNumber:84}},loading?'Salvando':'Salvar')));}if(editFilter&&modalType==='DELETE'){return _react2.default.createElement(_styles.WrapperContentModal,{__source:{fileName:_jsxFileName,lineNumber:97}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:98}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:99}},'Excluir sele\xE7\xE3o')),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:101}},'Tem certeza que deseja excluir a sele\xE7\xE3o ',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:102}},editFilter.descricaoFiltro)),_react2.default.createElement(_styles.WrapperButton,{__source:{fileName:_jsxFileName,lineNumber:104}},_react2.default.createElement(_styles.Button,{type:'button',disabled:loading,secondary:true,onClick:_this.handleCloseModal,__source:{fileName:_jsxFileName,lineNumber:105}},'Cancelar'),_react2.default.createElement(_styles.Button,{type:'button',disabled:loading,onClick:_this.chooseOnSubmit,__source:{fileName:_jsxFileName,lineNumber:108}},loading?'Excluindo':'Excluir')));}return _react2.default.createElement(_styles.WrapperContentModal,{__source:{fileName:_jsxFileName,lineNumber:116}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:117}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:118}},'Nova sele\xE7\xE3o')),_react2.default.createElement(_styles.Input,{onChange:_this.onChangeInput,value:_this.state.inputValue,type:'text',placeholder:'Insira o nome da sele\xE7\xE3o',__source:{fileName:_jsxFileName,lineNumber:120}}),_react2.default.createElement(_styles.WrapperButton,{__source:{fileName:_jsxFileName,lineNumber:126}},_react2.default.createElement(_styles.Button,{type:'button',secondary:true,disabled:loading,onClick:_this.handleCloseModal,__source:{fileName:_jsxFileName,lineNumber:127}},'Cancelar'),_react2.default.createElement(_styles.Button,{type:'button',disabled:!_this.state.inputValue||loading,onClick:_this.chooseOnSubmit,__source:{fileName:_jsxFileName,lineNumber:130}},loading?'Salvando':'Salvar')));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CreateEditFilterSelectionModal,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.editFilter){this.setState({inputValue:this.props.editFilter.descricaoFiltro});}}},{key:'render',value:function render(){var _props=this.props,isOpen=_props.isOpen,toggleModal=_props.toggleModal;var iconColor=_colors.darkBlue;if(isOpen){return _react2.default.createElement(_Modal.SimpleModal,{maxWidth:615,minHeight:'0',borderRadius:8,hideModal:toggleModal,__source:{fileName:_jsxFileName,lineNumber:147}},this.renderContentModal(),_react2.default.createElement(_styles.Back,{onClick:this.handleCloseModal,__source:{fileName:_jsxFileName,lineNumber:149}},_react2.default.createElement(_icClose2.default,{width:24,height:24,fill:iconColor,__source:{fileName:_jsxFileName,lineNumber:150}})));}return null;}}]);return CreateEditFilterSelectionModal;}(_react.Component);exports.default=CreateEditFilterSelectionModal;module.exports=exports['default'];

/***/ }),
/* 1974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Paragraph=exports.Button=exports.Input=exports.WrapperButton=exports.Content=exports.Back=exports.Header=exports.WrapperContentModal=exports.Form=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Form=exports.Form=_styledComponents2.default.form.withConfig({displayName:'styles__Form',componentId:'sc-1qc3de7-0'})(['display:flex;flex-direction:column;height:100%;min-height:380px;']);var WrapperContentModal=exports.WrapperContentModal=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperContentModal',componentId:'sc-1qc3de7-1'})(['display:flex;flex-direction:column;padding:',';width:100%;overflow:hidden;'],(0,_rem2.default)('48px'));var Header=exports.Header=_styledComponents2.default.div.withConfig({displayName:'styles__Header',componentId:'sc-1qc3de7-2'})(['',';font-weight:bold;width:100%;display:flex;justify-content:space-between;color:',';margin-bottom:20px;'],_types.title32GalanoBold,_colors.linkNavyBlue);var Back=exports.Back=_styledComponents2.default.a.withConfig({displayName:'styles__Back',componentId:'sc-1qc3de7-3'})(['',';font-weight:bold;line-height:1;color:',';display:flex;position:absolute;top:0;right:0;padding:',';cursor:pointer;svg{fill:',';}'],_types.txt14OpenSans,_colors.linkNavyBlue,(0,_rem2.default)('16px'),_colors.posGreyInfo);var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-1qc3de7-4'})(['padding:',';'],(0,_rem2.default)('24px'));var WrapperButton=exports.WrapperButton=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButton',componentId:'sc-1qc3de7-5'})(['display:flex;justify-content:',';margin-top:40px;button:first-child{margin-right:16px;}'],function(props){return props.justify;});WrapperButton.defaultProps={justify:'flex-end'};var Input=exports.Input=_styledComponents2.default.input.withConfig({displayName:'styles__Input',componentId:'sc-1qc3de7-6'})(['',';border:none;border-bottom:3px solid ',';background-color:rgba(226,225,235,0.16);color:',';padding:',' ',' ',' ',';line-height:',';width:100%;'],_types.txt16OpenSans,_colors.darkSlateBlue,_colors.darkSlateBlue,(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('16px'),(0,_rem2.default)('24px'));var Button=exports.Button=_styledComponents2.default.button.withConfig({displayName:'styles__Button',componentId:'sc-1qc3de7-7'})(['',';line-height:20.8px;color:',';background-color:',';padding:16px 32px;min-width:116px;height:52px;border:none;border-radius:28px;',';cursor:pointer;'],_types.title16Galano,function(_ref){var secondary=_ref.secondary;return secondary?_colors.darkSlateBlue:_colors.white;},function(_ref2){var secondary=_ref2.secondary;return secondary?_colors.white:_colors.darkSlateBlue;},function(_ref3){var secondary=_ref3.secondary;return secondary&&(0,_styledComponents.css)(['border:2px solid ',';'],_colors.darkSlateBlue);});var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-1qc3de7-8'})(['',';color:',';margin:0;'],_types.txt14OpenSans,_colors.darkSlateBlue);

/***/ }),
/* 1975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonContainerDesktop=exports.ButtonContainerMobile=exports.FilterOpened=exports.FilterTotalFuel=exports.FilterFuel=exports.FilterClosed=exports.FilterContainer=exports.Filter=exports.FilterWrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n        height: ',';\n    '],['\n        height: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        background: transparent;\n        transition: height .3s 0s ease,\n                    position 0s .3s ease,\n                    bottom 0s 0s ease,\n                    background .3s 0s ease;\n        ','\n        ',';\n    '],['\n        background: transparent;\n        transition: height .3s 0s ease,\n                    position 0s .3s ease,\n                    bottom 0s 0s ease,\n                    background .3s 0s ease;\n        ','\n        ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        display: none;\n    '],['\n        display: none;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        display: block;\n        margin: 0 auto;\n        width: ',';\n    '],['\n        display: block;\n        margin: 0 auto;\n        width: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FilterWrapper=exports.FilterWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__FilterWrapper',componentId:'sc-1mvb9p7-0'})(['height:',';overflow:hidden;position:relative;',';'],(0,_rem2.default)('80px'),_media2.default.small(_templateObject,(0,_rem2.default)('110px')));var Filter=exports.Filter=_styledComponents2.default.div.withConfig({displayName:'styles__Filter',componentId:'sc-1mvb9p7-1'})(['background:',';bottom:0;display:block;height:',';left:0;position:relative;transition:height .3s 0s ease,position 0s .3s ease;width:100%;z-index:100;',' ',' ',';'],function(_ref){var isOpen=_ref.isOpen;return isOpen?'white':_colors.skyBlue;},(0,_rem2.default)('80px'),function(_ref2){var isOpen=_ref2.isOpen;return isOpen&&'\n        height: 100vh;\n        position: fixed;\n        transition: height .3s .3s ease, position 0s .3s ease;\n    ';},function(_ref3){var isFixed=_ref3.isFixed;return isFixed&&'\n        position: fixed;\n    ';},_media2.default.small(_templateObject2,function(_ref4){var isFixed=_ref4.isFixed;return isFixed&&'\n            bottom: '+(0,_rem2.default)('40px')+';\n            transition: height .3s 0s ease,\n                        position 0s .3s ease,\n                        bottom 0s 0s ease,\n                        background .3s 0s ease;\n        ';},function(_ref5){var isOpen=_ref5.isOpen;return isOpen&&'\n            background: '+_colors.skyBlue+';\n            bottom: 0;\n            height: 100vh;\n            position: fixed;\n            transition: height .3s .3s ease,\n                        position 0s .3s ease,\n                        bottom 0s 0s ease,\n                        background .3s 0s ease;\n            '+function(_ref6){var isFixed=_ref6.isFixed;return isFixed&&'\n                bottom: 0;\n            ';}+';\n        ';}));var FilterContainer=exports.FilterContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FilterContainer',componentId:'sc-1mvb9p7-2'})(['display:block;height:100%;margin:0 auto;position:relative;',';'],function(_ref7){var isOpen=_ref7.isOpen;return isOpen&&'\n        overflow: auto;\n    ';});var FilterClosed=exports.FilterClosed=_styledComponents2.default.div.withConfig({displayName:'styles__FilterClosed',componentId:'sc-1mvb9p7-3'})(['align-items:center;display:flex;height:100%;margin:0 auto;max-width:',';justify-content:flex-end;transition:opacity 0.3s 0.6s ease,height 0.3s 0.3s ease,visibility 0s 0s ease;',';'],(0,_rem2.default)('940px'),function(_ref8){var isOpen=_ref8.isOpen;return isOpen&&'\n        height: 0;\n        opacity: 0;\n        transition: opacity .3s ease, height 0s .3s ease, visibility 0s .3s ease;\n        visibility: hidden;\n    ';});var FilterFuel=exports.FilterFuel=_styledComponents2.default.div.withConfig({displayName:'styles__FilterFuel',componentId:'sc-1mvb9p7-4'})(['display:block;',';'],_media2.default.small(_templateObject3));var FilterTotalFuel=exports.FilterTotalFuel=_styledComponents2.default.div.withConfig({displayName:'styles__FilterTotalFuel',componentId:'sc-1mvb9p7-5'})(['display:block;',';'],_media2.default.small(_templateObject3));var FilterOpened=exports.FilterOpened=_styledComponents2.default.div.withConfig({displayName:'styles__FilterOpened',componentId:'sc-1mvb9p7-6'})(['display:block;opacity:0;transition:opacity 0.3s 0s ease,visible 0s 0.6s ease;visibility:hidden;',';'],function(_ref9){var isOpen=_ref9.isOpen;return isOpen&&'\n        opacity: 1;\n        transition: opacity .3s .6s ease, visible 0s 0s ease;\n        visibility: visible;\n    ';});var ButtonContainerMobile=exports.ButtonContainerMobile=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonContainerMobile',componentId:'sc-1mvb9p7-7'})(['display:none;',';'],_media2.default.small(_templateObject4,(0,_rem2.default)('164px')));var ButtonContainerDesktop=exports.ButtonContainerDesktop=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonContainerDesktop',componentId:'sc-1mvb9p7-8'})(['display:flex;align-items:flex-end;',';'],_media2.default.small(_templateObject3));

/***/ }),
/* 1976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatement/ShowResults/ShowResults.js';/* eslint-disable */var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _styles=__webpack_require__(1977);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var diaDaSemanaMap=[{value:6,label:'Dom'},{value:0,label:'Seg'},{value:1,label:'Ter'},{value:2,label:'Qua'},{value:3,label:'Qui'},{value:4,label:'Sex'},{value:5,label:'Sab'}];var getChoosenDays=function getChoosenDays(days){if(days===undefined||days.length===7||days.length===0)return'Todos os dias';var foundDays=diaDaSemanaMap.filter(function(dia){var found=days.find(function(day){return day===dia.value;});return found!==undefined;});var stringOfDays=foundDays.map(function(day){return day.label;}).toString();return stringOfDays;};var getPeriodo=function getPeriodo(periodo,rangeDates){if(rangeDates){return(0,_moment2.default)(rangeDates.from).format('DD/MM/YYYY')+' a '+(0,_moment2.default)(rangeDates.to).format('DD/MM/YYYY');}if(!periodo)return'90 dias';return periodo+' dias';};var getTipoTransacao=function getTipoTransacao(tipoTransacao,hasValePedagio){if(!tipoTransacao||tipoTransacao.length===0)return'Todos os tipos';if(tipoTransacao.length===3)return'Todos os tipos';if(hasValePedagio&&tipoTransacao.length===2){return tipoTransacao.map(function(item){return{PEDAGIO:'Pedágio',ESTACIONAMENTO:'Estacionamento',VALE_PEDAGIO:'Vale-pedágio'}[item.tipo];});}return{PEDAGIO:'Pedágio',ESTACIONAMENTO:'Estacionamento',VALE_PEDAGIO:'Vale-pedágio'}[tipoTransacao[0].tipo];};var getQuantidade=function getQuantidade(quantidade){if(!quantidade)return'30 transações';return quantidade+' transa\xE7\xF5es';};function ShowResults(_ref){var selectedFilters=_ref.selectedFilters,hasValePedagio=_ref.hasValePedagio,_ref$showQuantity=_ref.showQuantity,showQuantity=_ref$showQuantity===undefined?true:_ref$showQuantity;return _react2.default.createElement(_styles.ShowResultsFormWrapper,{__source:{fileName:_jsxFileName,lineNumber:77}},_react2.default.createElement(_styles.ShowResultsInput,{placeholder:getTipoTransacao(selectedFilters.type,hasValePedagio),disabled:true,__source:{fileName:_jsxFileName,lineNumber:78}}),_react2.default.createElement(_styles.ShowResultsInput,{placeholder:getPeriodo(selectedFilters.periodo,selectedFilters.rangeDates),disabled:true,__source:{fileName:_jsxFileName,lineNumber:79}}),_react2.default.createElement(_styles.ShowResultsInput,{placeholder:getChoosenDays(selectedFilters.diaDaSemana),disabled:true,__source:{fileName:_jsxFileName,lineNumber:80}}),showQuantity&&_react2.default.createElement(_styles.ShowResultsInput,{placeholder:getQuantidade(selectedFilters.quantidade),disabled:true,__source:{fileName:_jsxFileName,lineNumber:81}}));}exports.default=ShowResults;module.exports=exports['default'];

/***/ }),
/* 1977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ShowResultsInput=exports.ShowResultsFormWrapper=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ShowResultsFormWrapper=exports.ShowResultsFormWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__ShowResultsFormWrapper',componentId:'sc-1d94g87-0'})(['width:100%;display:flex;justify-content:center;']);var ShowResultsInput=exports.ShowResultsInput=_styledComponents2.default.input.withConfig({displayName:'styles__ShowResultsInput',componentId:'sc-1d94g87-1'})(['border:none;border-bottom:3px solid ',';background-color:',';padding:',';line-height:',';color:',';',';width:100%;margin:0 ',';&:first-of-type{margin:0;margin-right:',';}&:last-of-type{margin:0;margin-left:',';}'],_colors.darkSlateBlue,_colors.paleGray,(0,_rem2.default)('16px'),(0,_rem2.default)('24px'),_colors.darkSlateBlue,_types.txt16OpenSans,(0,_rem2.default)('10px'),(0,_rem2.default)('10px'),(0,_rem2.default)('10px'));

/***/ }),
/* 1978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.WrapperButton=exports.Subtitle=exports.Text=exports.Title=exports.Form=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n    min-width: auto;\n    max-width: auto;\n  '],['\n    min-width: auto;\n    max-width: auto;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    ',';\n  '],['\n    ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 18px;\n  '],['\n    font-size: 18px;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-1tmq1hr-0'})(['min-width:596px;max-width:596px;width:100%;min-height:160px;display:flex;justify-content:space-around;flex-direction:column;',';'],_media2.default.small(_templateObject));var Form=exports.Form=_styledComponents2.default.form.withConfig({displayName:'styles__Form',componentId:'sc-1tmq1hr-1'})(['display:flex;flex-direction:column;height:100%;']);var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-1tmq1hr-2'})(['',';color:',';margin:0 0 16px;max-width:422px;line-height:32px;',';'],_types.title32GalanoBold,_colors.white,_media2.default.small(_templateObject2,_types.title24GalanoBold));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1tmq1hr-3'})(['',';color:',';line-height:25px;margin:0 0 10px;max-width:550px;'],_types.txt16OpenSans,_colors.darkBlue);var Subtitle=exports.Subtitle=_styledComponents2.default.h2.withConfig({displayName:'styles__Subtitle',componentId:'sc-1tmq1hr-4'})(['',';color:',';font-size:24px;margin:0;',';'],_types.title24GalanoBold,_colors.darkBlue,_media2.default.small(_templateObject3));var WrapperButton=exports.WrapperButton=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButton',componentId:'sc-1tmq1hr-5'})(['display:block;margin-top:44px;div{margin-right:20px;}']);

/***/ }),
/* 1979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Paragraph=exports.ShowResultsInner=exports.ShowResultsContainer=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n    ','\n    letter-spacing: normal;\n    line-height: 1;\n  '],['\n    ','\n    letter-spacing: normal;\n    line-height: 1;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-1kggmsl-0'})(['',' letter-spacing:',';color:',';margin-top:',';',';'],_types.title40GalanoBold,(0,_em2.default)('0.4px'),_colors.darkSlateBlue,(0,_rem2.default)('40px'),_media2.default.small(_templateObject,_types.title28GalanoBold));var ShowResultsContainer=exports.ShowResultsContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ShowResultsContainer',componentId:'sc-1kggmsl-1'})(['display:flex;justify-content:center;']);var ShowResultsInner=exports.ShowResultsInner=_styledComponents2.default.div.withConfig({displayName:'styles__ShowResultsInner',componentId:'sc-1kggmsl-2'})(['width:',';display:flex;justify-content:space-around;margin:',' 0;'],(0,_rem2.default)('940px'),(0,_rem2.default)('15px'));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-1kggmsl-3'})(['',' color:',';max-width:',';'],_types.txt14OpenSans,_colors.darkSlateBlue,(0,_rem2.default)('400px'));

/***/ }),
/* 1980 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Minha Veloe - Extrato","topbar":{"date":{"month":"Outubro","hour":"07:58","day":"10/10/2017"},"currency":"R$"},"statements":[{"id":0,"date":9,"dayweek":"Domingo","items":[{"id":0,"type":"fuel","title":"Posto Shell Nova Odessa","local":"D01239982 - Av. Dr. Ernesto Sprogis, 802-986 - Nova Odessa - SP","date":"05/10/2017","time":"19:17","value":"-37,00"},{"id":1,"type":"refund","title":"Posto Shell Afonso Bovero","local":"D01239982 - Rua Fradique Coutinho, 0909 - São Paulo","date":"05/10/2017","time":"19:17","value":"+27,00"},{"id":2,"type":"park","title":"Concessionária Rota Das Bandeiras S. ","local":"D01239982 - SP280, KM18, OESTE, OSASCO","date":"05/10/2017","entry":"07:50","exit":"08:20","stay":"00:30","value":"-37,00"}]},{"id":1,"date":8,"dayweek":"Sábado","items":[{"id":3,"type":"pass","title":"Posto Shell Nova Odessa","local":"D01239982 - Av. Dr. Ernesto Sprogis, 802-986 - Nova Odessa - SP","date":"05/10/2017","time":"19:17","value":"-37,00"},{"id":4,"type":"fuel","title":"Posto Shell Nova Odessa","local":"D01239982 - Av. Dr. Ernesto Sprogis, 802-986 - Nova Odessa - SP","date":"05/10/2017","time":"19:17","value":"-37,00"},{"id":5,"type":"payment","title":"Recebemos seu pagamento","local":"D01239982 - Via App Veloe - Débito em conta","date":"05/10/2017","time":"19:17","value":"-37,00"}]}]}

/***/ }),
/* 1981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _enum=__webpack_require__(643);var _enum2=_interopRequireDefault(_enum);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var myEnum=new _enum2.default({ABASTECIMENTO:'fuel',ESTACIONAMENTO:'park',PEDAGIO:'toll',FATURA:'payment',RECARGA:'recharge'});var myEnumTitle=new _enum2.default({FATURA:'Recebemos seu pagamento',RECARGA:'Recebemos sua recarga'});function getTitle(data){if(data['estabelecimento-comercial']['tipo-transacao']){return myEnumTitle.get(data['estabelecimento-comercial']['tipo-transacao'])?myEnumTitle.get(data['estabelecimento-comercial']['tipo-transacao']).value:data['estabelecimento-comercial'].nome;}return data['motivo-transacao'];}function getType(data){return myEnum.get(data['estabelecimento-comercial']['tipo-transacao'])?myEnum.get(data['estabelecimento-comercial']['tipo-transacao']).value:'tax';}var statementFactory={toForm:function toForm(statement){return statement&&statement.map(function(data,index){return statement&&{id:data['cyber-id'],date:(0,_moment2.default)(data['data-evento'],'DD/MM/YYYY HH:mm:ss').toDate(),processDate:(0,_moment2.default)(data['data-processamento'],'DD/MM/YYYY HH:mm:ss').toDate(),exitDate:(0,_moment2.default)(data['data-fim-evento'],'DD/MM/YYYY HH:mm:ss').toDate(),startTime:data['hora-evento'],exitTime:data['hora-fim-evento'],stayTime:data['permanencia'],type:getType(data),value:data.valor,title:getTitle(data),details:data.endereco,tollFree:data.valePedagio,tollFreeValidityStart:data.vpVigenciaInicio,tollFreeValidityEnd:data.vpVigenciaFim,tollFreeOrigin:data.vpOrigem,tollFreeDestination:data.vpDestino,tollFreeVeloeId:data.vpIdveloe,tollFreeCNPJ:data.vpCnpjEmbarcador,code:data['cyber-id'],vehicle:data.veiculo};});}};exports.default=statementFactory;module.exports=exports['default'];

/***/ }),
/* 1982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var _interopRequire = function (obj) { return obj && obj.__esModule ? obj["default"] : obj; };

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var os = _interopRequire(__webpack_require__(1983));

var EnumItem = _interopRequire(__webpack_require__(1984));

var _isType = __webpack_require__(644);

var isString = _isType.isString;
var isNumber = _isType.isNumber;

var indexOf = __webpack_require__(1985).indexOf;

var isBuffer = _interopRequire(__webpack_require__(528));

var endianness = os.endianness();

/**
 * Represents an Enum with enum items.
 * @param {Array || Object}  map     This are the enum items.
 * @param {String || Object} options This are options. [optional]
 */

var Enum = (function () {
  function Enum(map, options) {
    var _this = this;

    _classCallCheck(this, Enum);

    /* implement the "ref type interface", so that Enum types can
     * be used in `node-ffi` function declarations and invokations.
     * In C, these Enums act as `uint32_t` types.
     *
     * https://github.com/TooTallNate/ref#the-type-interface
     */
    this.size = 4;
    this.indirection = 1;

    if (options && isString(options)) {
      options = { name: options };
    }

    this._options = options || {};
    this._options.separator = this._options.separator || " | ";
    this._options.endianness = this._options.endianness || endianness;
    this._options.ignoreCase = this._options.ignoreCase || false;
    this._options.freez = this._options.freez || false;

    this.enums = [];

    if (map.length) {
      this._enumLastIndex = map.length;
      var array = map;
      map = {};

      for (var i = 0; i < array.length; i++) {
        map[array[i]] = Math.pow(2, i);
      }
    }

    for (var member in map) {
      guardReservedKeys(this._options.name, member);
      this[member] = new EnumItem(member, map[member], { ignoreCase: this._options.ignoreCase });
      this.enums.push(this[member]);
    }
    this._enumMap = map;

    if (this._options.ignoreCase) {
      this.getLowerCaseEnums = function () {
        var res = {};
        for (var i = 0, len = this.enums.length; i < len; i++) {
          res[this.enums[i].key.toLowerCase()] = this.enums[i];
        }
        return res;
      };
    }

    if (this._options.name) {
      this.name = this._options.name;
    }

    var isFlaggable = function () {
      for (var i = 0, len = _this.enums.length; i < len; i++) {
        var e = _this.enums[i];

        if (!(e.value !== 0 && !(e.value & e.value - 1))) {
          return false;
        }
      }
      return true;
    };

    this.isFlaggable = isFlaggable();
    if (this._options.freez) {
      this.freezeEnums(); //this will make instances of Enum non-extensible
    }
  }

  /**
   * Returns the appropriate EnumItem key.
   * @param  {EnumItem || String || Number} key The object to get with.
   * @return {String}                           The get result.
   */

  Enum.prototype.getKey = function getKey(value) {
    var item = this.get(value);
    if (item) {
      return item.key;
    }
  };

  /**
   * Returns the appropriate EnumItem value.
   * @param  {EnumItem || String || Number} key The object to get with.
   * @return {Number}                           The get result.
   */

  Enum.prototype.getValue = function getValue(key) {
    var item = this.get(key);
    if (item) {
      return item.value;
    }
  };

  /**
   * Returns the appropriate EnumItem.
   * @param  {EnumItem || String || Number} key The object to get with.
   * @return {EnumItem}                         The get result.
   */

  Enum.prototype.get = function get(key, offset) {
    if (key === null || key === undefined) {
      return;
    } // Buffer instance support, part of the ref Type interface
    if (isBuffer(key)) {
      key = key["readUInt32" + this._options.endianness](offset || 0);
    }

    if (EnumItem.isEnumItem(key)) {
      var foundIndex = indexOf.call(this.enums, key);
      if (foundIndex >= 0) {
        return key;
      }
      if (!this.isFlaggable || this.isFlaggable && key.key.indexOf(this._options.separator) < 0) {
        return;
      }
      return this.get(key.key);
    } else if (isString(key)) {

      var enums = this;
      if (this._options.ignoreCase) {
        enums = this.getLowerCaseEnums();
        key = key.toLowerCase();
      }

      if (key.indexOf(this._options.separator) > 0) {
        var parts = key.split(this._options.separator);

        var value = 0;
        for (var i = 0; i < parts.length; i++) {
          var part = parts[i];

          value |= enums[part].value;
        }

        return new EnumItem(key, value);
      } else {
        return enums[key];
      }
    } else {
      for (var m in this) {
        if (this.hasOwnProperty(m)) {
          if (this[m].value === key) {
            return this[m];
          }
        }
      }

      var result = null;

      if (this.isFlaggable) {
        for (var n in this) {
          if (this.hasOwnProperty(n)) {
            if ((key & this[n].value) !== 0) {
              if (result) {
                result += this._options.separator;
              } else {
                result = "";
              }
              result += n;
            }
          }
        }
      }

      return this.get(result || null);
    }
  };

  /**
   * Sets the Enum "value" onto the give `buffer` at the specified `offset`.
   * Part of the ref "Type interface".
   *
   * @param  {Buffer} buffer The Buffer instance to write to.
   * @param  {Number} offset The offset in the buffer to write to. Default 0.
   * @param  {EnumItem || String || Number} value The EnumItem to write.
   */

  Enum.prototype.set = function set(buffer, offset, value) {
    var item = this.get(value);
    if (item) {
      return buffer["writeUInt32" + this._options.endianness](item.value, offset || 0);
    }
  };

  /**
   * Define freezeEnums() as a property of the prototype.
   * make enumerable items nonconfigurable and deep freeze the properties. Throw Error on property setter.
   */

  Enum.prototype.freezeEnums = function freezeEnums() {
    function envSupportsFreezing() {
      return Object.isFrozen && Object.isSealed && Object.getOwnPropertyNames && Object.getOwnPropertyDescriptor && Object.defineProperties && Object.__defineGetter__ && Object.__defineSetter__;
    }

    function freezer(o) {
      var props = Object.getOwnPropertyNames(o);
      props.forEach(function (p) {
        if (!Object.getOwnPropertyDescriptor(o, p).configurable) {
          return;
        }

        Object.defineProperties(o, p, { writable: false, configurable: false });
      });
      return o;
    }

    function getPropertyValue(value) {
      return value;
    }

    function deepFreezeEnums(o) {
      if (typeof o !== "object" || o === null || Object.isFrozen(o) || Object.isSealed(o)) {
        return;
      }
      for (var key in o) {
        if (o.hasOwnProperty(key)) {
          o.__defineGetter__(key, getPropertyValue.bind(null, o[key]));
          o.__defineSetter__(key, function throwPropertySetError(value) {
            throw TypeError("Cannot redefine property; Enum Type is not extensible.");
          });
          deepFreezeEnums(o[key]);
        }
      }
      if (Object.freeze) {
        Object.freeze(o);
      } else {
        freezer(o);
      }
    }

    if (envSupportsFreezing()) {
      deepFreezeEnums(this);
    }

    return this;
  };

  /**
   * Return true whether the enumItem parameter passed in is an EnumItem object and 
   * has been included as constant of this Enum   
   * @param  {EnumItem} enumItem
   */

  Enum.prototype.isDefined = function isDefined(enumItem) {
    var condition = function (e) {
      return e === enumItem;
    };
    if (isString(enumItem) || isNumber(enumItem)) {
      condition = function (e) {
        return e.is(enumItem);
      };
    }
    return this.enums.some(condition);
  };

  /**
   * Returns JSON object representation of this Enum.
   * @return {String} JSON object representation of this Enum.
   */

  Enum.prototype.toJSON = function toJSON() {
    return this._enumMap;
  };

  /**
   * Extends the existing Enum with a New Map.
   * @param  {Array}  map  Map to extend from
   */

  Enum.prototype.extend = function extend(map) {
    if (map.length) {
      var array = map;
      map = {};

      for (var i = 0; i < array.length; i++) {
        var exponent = this._enumLastIndex + i;
        map[array[i]] = Math.pow(2, exponent);
      }

      for (var member in map) {
        guardReservedKeys(this._options.name, member);
        this[member] = new EnumItem(member, map[member], { ignoreCase: this._options.ignoreCase });
        this.enums.push(this[member]);
      }

      for (var key in this._enumMap) {
        map[key] = this._enumMap[key];
      }

      this._enumLastIndex += map.length;
      this._enumMap = map;

      if (this._options.freez) {
        this.freezeEnums(); //this will make instances of new Enum non-extensible
      }
    }
  };

  /**
   * Registers the Enum Type globally in node.js.
   * @param  {String} key Global variable. [optional]
   */

  Enum.register = function register() {
    var key = arguments[0] === undefined ? "Enum" : arguments[0];

    if (!global[key]) {
      global[key] = Enum;
    }
  };

  Enum.prototype[Symbol.iterator] = function () {
    var _this = this;

    var index = 0;
    return {
      next: function () {
        return index < _this.enums.length ? { done: false, value: _this.enums[index++] } : { done: true };
      }
    };
  };

  return Enum;
})();

module.exports = Enum;

// private

var reservedKeys = ["_options", "get", "getKey", "getValue", "enums", "isFlaggable", "_enumMap", "toJSON", "_enumLastIndex"];

function guardReservedKeys(customName, key) {
  if (customName && key === "name" || indexOf.call(reservedKeys, key) >= 0) {
    throw new Error("Enum key " + key + " is a reserved word!");
  }
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ }),
/* 1983 */
/***/ (function(module, exports) {

exports.endianness = function () { return 'LE' };

exports.hostname = function () {
    if (typeof location !== 'undefined') {
        return location.hostname
    }
    else return '';
};

exports.loadavg = function () { return [] };

exports.uptime = function () { return 0 };

exports.freemem = function () {
    return Number.MAX_VALUE;
};

exports.totalmem = function () {
    return Number.MAX_VALUE;
};

exports.cpus = function () { return [] };

exports.type = function () { return 'Browser' };

exports.release = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.appVersion;
    }
    return '';
};

exports.networkInterfaces
= exports.getNetworkInterfaces
= function () { return {} };

exports.arch = function () { return 'javascript' };

exports.platform = function () { return 'browser' };

exports.tmpdir = exports.tmpDir = function () {
    return '/tmp';
};

exports.EOL = '\n';

exports.homedir = function () {
	return '/'
};


/***/ }),
/* 1984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

var _isType = __webpack_require__(644);

var isObject = _isType.isObject;
var isString = _isType.isString;

/**
 * Represents an Item of an Enum.
 * @param {String} key   The Enum key.
 * @param {Number} value The Enum value.
 */

var EnumItem = (function () {

  /*constructor reference so that, this.constructor===EnumItem//=>true */

  function EnumItem(key, value) {
    var options = arguments[2] === undefined ? {} : arguments[2];

    _classCallCheck(this, EnumItem);

    this.key = key;
    this.value = value;

    this._options = options;
    this._options.ignoreCase = this._options.ignoreCase || false;
  }

  /**
   * Checks if the flagged EnumItem has the passing object.
   * @param  {EnumItem || String || Number} value The object to check with.
   * @return {Boolean}                            The check result.
   */

  EnumItem.prototype.has = function has(value) {
    if (EnumItem.isEnumItem(value)) {
      return (this.value & value.value) !== 0;
    } else if (isString(value)) {
      if (this._options.ignoreCase) {
        return this.key.toLowerCase().indexOf(value.toLowerCase()) >= 0;
      }
      return this.key.indexOf(value) >= 0;
    } else {
      return (this.value & value) !== 0;
    }
  };

  /**
   * Checks if the EnumItem is the same as the passing object.
   * @param  {EnumItem || String || Number} key The object to check with.
   * @return {Boolean}                          The check result.
   */

  EnumItem.prototype.is = function is(key) {
    if (EnumItem.isEnumItem(key)) {
      return this.key === key.key;
    } else if (isString(key)) {
      if (this._options.ignoreCase) {
        return this.key.toLowerCase() === key.toLowerCase();
      }
      return this.key === key;
    } else {
      return this.value === key;
    }
  };

  /**
   * Returns String representation of this EnumItem.
   * @return {String} String representation of this EnumItem.
   */

  EnumItem.prototype.toString = function toString() {
    return this.key;
  };

  /**
   * Returns JSON object representation of this EnumItem.
   * @return {String} JSON object representation of this EnumItem.
   */

  EnumItem.prototype.toJSON = function toJSON() {
    return this.key;
  };

  /**
   * Returns the value to compare with.
   * @return {String} The value to compare with.
   */

  EnumItem.prototype.valueOf = function valueOf() {
    return this.value;
  };

  EnumItem.isEnumItem = function isEnumItem(value) {
    return value instanceof EnumItem || isObject(value) && value.key !== undefined && value.value !== undefined;
  };

  return EnumItem;
})();

module.exports = EnumItem;

/***/ }),
/* 1985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var indexOf = Array.prototype.indexOf || function (find, i /*opt*/) {
  if (i === undefined) i = 0;
  if (i < 0) i += this.length;
  if (i < 0) i = 0;
  for (var n = this.length; i < n; i++) if (i in this && this[i] === find) return i;
  return -1;
};
exports.indexOf = indexOf;

/***/ }),
/* 1986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatementPartner/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _actions=__webpack_require__(13);var _StatementsHeader=__webpack_require__(634);var _StatementsHeader2=_interopRequireDefault(_StatementsHeader);var _AddItem=__webpack_require__(258);var _AddItem2=_interopRequireDefault(_AddItem);var _StatementsList=__webpack_require__(635);var _StatementsList2=_interopRequireDefault(_StatementsList);var _actions2=__webpack_require__(36);var _PartnerStatementsFilter=__webpack_require__(1987);var _PartnerStatementsFilter2=_interopRequireDefault(_PartnerStatementsFilter);var _EmailStatementModal=__webpack_require__(642);var _EmailStatementModal2=_interopRequireDefault(_EmailStatementModal);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _styles=__webpack_require__(1999);var _data=__webpack_require__(2000);var _factory=__webpack_require__(2001);var _factory2=_interopRequireDefault(_factory);var _actions3=__webpack_require__(18);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);var _ModalTypes=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DashboardStatement=function(_Component){_inherits(DashboardStatement,_Component);function DashboardStatement(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DashboardStatement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DashboardStatement.__proto__||Object.getPrototypeOf(DashboardStatement)).call.apply(_ref,[this].concat(args))),_this),_this.state={showFilter:false,showResults:false,loading:false,showModalEmail:false,formato:null,emailSendStatement:null},_this.selectedFilters={},_this.loadStatements=function(){var nextPage=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var params=_this.props.match.params||{};_this.props.fetchStatements(params.id,nextPage,_this.selectedFilters);},_this.doStatementFetch=function(nextPage,filter){var params=_this.props.match.params||{};_this.props.fetchStatements(params.id,nextPage,filter).then(function(){_this.setState({loading:false});});_this.setState({loading:true});},_this.openFilter=function(){_this.setState({showFilter:true});},_this.unsetResults=function(){return _this.setState({showResults:false});},_this.applyFilter=function(filter){_this.selectedFilters=filter;_this.props.resetStatements();_this.doStatementFetch(null,_this.selectedFilters);_this.setState({showFilter:false,showResults:true});},_this.closeFilter=function(){_this.setState({showFilter:false});},_this.handleModal=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _this$state,emailSendStatement,formato,params;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$state=_this.state,emailSendStatement=_this$state.emailSendStatement,formato=_this$state.formato;params=_this.props.match.params||{};_context.next=4;return _this.props.sendStatementEmail(params.id,emailSendStatement,_this.selectedFilters,formato);case 4:_this.setState({showModalEmail:!_this.state.showModalEmail,formato:null});case 5:case'end':return _context.stop();}}},_callee,_this2);})),_this.handleChangeEmail=function(value){var result=Object.keys(value).map(function(key){return[value[key]];});var valueEmail=result.splice(0,result.length-1).join('');_this.setState({emailSendStatement:valueEmail});},_this.modalEmail=function(state,formato){return _this.setState({showModalEmail:state,formato:formato});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DashboardStatement,[{key:'componentDidMount',value:function componentDidMount(){this.props.setLoading(false);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.resetStatements();}},{key:'resetList',value:function resetList(){this.props.resetStatements();this.doStatementFetch();}},{key:'render',value:function render(){var _this3=this;var _props=this.props,statements=_props.statements,accountPlans=_props.accountPlans;var _state=this.state,showModalEmail=_state.showModalEmail,showFilter=_state.showFilter,showResults=_state.showResults;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:111}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:112}}),_react2.default.createElement(_PartnerStatementsFilter2.default,{onFilter:function onFilter(values){return _this3.applyFilter(values);},statements:statements,accountPlans:accountPlans,showFilter:showFilter,showResults:showResults,unsetResults:this.unsetResults,__source:{fileName:_jsxFileName,lineNumber:113}}),showResults&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:122}},_react2.default.createElement(_StatementsHeader2.default,{statements:statements,currency:_data.topbar.currency,match:this.props.match,downloadEnabled:!!statements.data.length,openModal:this.modalEmail,__source:{fileName:_jsxFileName,lineNumber:123}}),statements.data.length===0?_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:131}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:132}},'Ops!'),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:133}},'Nenhuma transa\xE7\xE3o encontrada para o filtro selecionado.')):_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:136}},_react2.default.createElement(_AddItem2.default,{data:_factory2.default.toForm(statements.data),next:statements.next,fetchHandler:this.loadStatements,hasNext:statements.hasNext,__source:{fileName:_jsxFileName,lineNumber:137}},_react2.default.createElement(_StatementsList2.default,{__source:{fileName:_jsxFileName,lineNumber:143}})))),showModalEmail&&_react2.default.createElement(_EmailStatementModal2.default,{handleClick:this.handleModal,openModal:this.modalEmail,handleChangeEmail:this.handleChangeEmail,__source:{fileName:_jsxFileName,lineNumber:151}}));}}]);return DashboardStatement;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref3){var reducer=_ref3.reducer;return{statements:reducer.dashboardStatements,accountPlans:reducer.accountPlans};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchStatements:function fetchStatements(planId,nextPage,filter){return dispatch((0,_actions.fetchDashboardStatements)(planId,nextPage,filter)).then(function(resp){if(resp&&resp.status===204){dispatch((0,_actions2.setLoading)(false));dispatch((0,_actions.resetDashboardStatements)());}dispatch((0,_actions2.setLoading)(false));});},sendStatementEmail:function sendStatementEmail(planId,email,filter,formato){return dispatch((0,_actions.sendStatementemail)(planId,email,filter,formato)).then(function(){dispatch((0,_actions3.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:'Extrato em processamento.',modalDescription:'O '+formato+' do seu extrato est\xE1 em processamento, assim que finalizado voc\xEA recebera um email com o link para baixa-lo.',image:_contestacao2.default}));dispatch((0,_actions2.setLoading)(false));});},resetStatements:function resetStatements(){dispatch((0,_actions2.setLoading)(true));dispatch((0,_actions.resetDashboardStatements)());},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DashboardStatement);module.exports=exports['default'];

/***/ }),
/* 1987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PartnerStatementsFilter.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _PartnerFilterForm=__webpack_require__(1988);var _PartnerFilterForm2=_interopRequireDefault(_PartnerFilterForm);var _styles=__webpack_require__(1998);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PartnerStatementsFilter=function(_Component){_inherits(PartnerStatementsFilter,_Component);function PartnerStatementsFilter(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PartnerStatementsFilter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PartnerStatementsFilter.__proto__||Object.getPrototypeOf(PartnerStatementsFilter)).call.apply(_ref,[this].concat(args))),_this),_this.state={currentValues:{},currentVehicle:''},_this.applyFilter=function(checkPlan){return checkPlan.id.toString()===_this.props.accountPlans.activePlanId.toString();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PartnerStatementsFilter,[{key:'render',value:function render(){var _this2=this;var currentPlan=this.props.accountPlans.plans[0]?this.props.accountPlans.plans.find(this.applyFilter):'';var findCurrentVehicle=function findCurrentVehicle(currentIdentifierId){var currentIdentifier=currentPlan.identifiers.find(function(value){return currentIdentifierId.toString()===value.carPlate.toString();});_this2.setState({currentVehicle:currentIdentifier});};var onSubmitFilter=function onSubmitFilter(values){var changedValues={plate:values.plate,month:values.month,type:values.type,year:values.year,periodo:values.periodo,diaDaSemana:values.diaDaSemana,rangeDates:values.rangeDates,quantidade:values.quantidade};if(_this2.props.onFilter){_this2.props.onFilter(changedValues);}_this2.setState({isOpen:false,currentValues:changedValues});if(changedValues.plate){findCurrentVehicle(changedValues.plate);}};if(currentPlan.identifiers&&currentPlan.identifiers.length===1&&this.state.currentVehicle===''){this.setState({currentVehicle:currentPlan.identifiers[0]});}return _react2.default.createElement(_styles.FilterContainer,{isOpen:this.state.isOpen,__source:{fileName:_jsxFileName,lineNumber:65}},_react2.default.createElement(_PartnerFilterForm2.default,{onSubmitFilter:onSubmitFilter,showResults:this.props.showResults,unsetResults:this.props.unsetResults,__source:{fileName:_jsxFileName,lineNumber:66}}));}}]);return PartnerStatementsFilter;}(_react.Component);PartnerStatementsFilter.defaultProps={visible:false};exports.default=PartnerStatementsFilter;module.exports=exports['default'];

/***/ }),
/* 1988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PartnerFilterForm/PartnerFilterForm.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _FilterByPeriod=__webpack_require__(636);var _FilterByPeriod2=_interopRequireDefault(_FilterByPeriod);var _FilterByWeekDays=__webpack_require__(639);var _FilterByWeekDays2=_interopRequireDefault(_FilterByWeekDays);var _FilterByTag=__webpack_require__(1989);var _FilterByTag2=_interopRequireDefault(_FilterByTag);var _PaginationSelector=__webpack_require__(1993);var _PaginationSelector2=_interopRequireDefault(_PaginationSelector);var _FilterByType=__webpack_require__(1995);var _FilterByType2=_interopRequireDefault(_FilterByType);var _ShowResultsForm=__webpack_require__(1997);var _ShowResultsForm2=_interopRequireDefault(_ShowResultsForm);var _styles=__webpack_require__(647);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var filterItems=[{value:15,label:'15 dias'},{value:30,label:'30 dias'},{value:60,label:'60 dias'},{value:90,label:'90 dias'},{value:180,label:'180 dias'},{value:0,label:'Período específico'}];var FormInputs=function FormInputs(_ref){var handleSubmit=_ref.handleSubmit,setTypeRef=_ref.setTypeRef,setWeekDayRef=_ref.setWeekDayRef;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_reduxForm.Field,{name:'plate',component:'input',type:'hidden',__source:{fileName:_jsxFileName,lineNumber:52}}),_react2.default.createElement(_FilterByType2.default,{setTypeRef:setTypeRef,__source:{fileName:_jsxFileName,lineNumber:53}}),_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:54}}),_react2.default.createElement(_FilterByPeriod2.default,{options:filterItems,rangeForValidation:180,__source:{fileName:_jsxFileName,lineNumber:55}}),_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:56}}),_react2.default.createElement(_FilterByWeekDays2.default,{setWeekDayRef:setWeekDayRef,__source:{fileName:_jsxFileName,lineNumber:57}}),_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:58}}),_react2.default.createElement(_PaginationSelector2.default,{__source:{fileName:_jsxFileName,lineNumber:59}}));};var BeforeResultsForm=(0,_reduxForm.reduxForm)({form:'statementsFilter',destroyOnUnmount:false})((0,_reactRedux.connect)(function(state){return{accountPlans:state.reducer.accountPlans};})(FormInputs));var RemoteSubmitButton=function RemoteSubmitButton(_ref2){var dispatch=_ref2.dispatch,invalid=_ref2.invalid,plateIsValid=_ref2.plateIsValid;return _react2.default.createElement(_styles.FormButton,{onClick:function onClick(){return dispatch((0,_reduxForm.submit)('statementsFilter'));},disabled:invalid||!plateIsValid,invalid:invalid||!plateIsValid,type:'submit',__source:{fileName:_jsxFileName,lineNumber:75}},'Aplicar filtros');};RemoteSubmitButton=(0,_reactRedux.connect)()(RemoteSubmitButton);var PartnerFilterForm=function(_Component){_inherits(PartnerFilterForm,_Component);function PartnerFilterForm(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,PartnerFilterForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=PartnerFilterForm.__proto__||Object.getPrototypeOf(PartnerFilterForm)).call.apply(_ref3,[this].concat(args))),_this),_this.state={weekRefs:[],typeRefs:[],loading:false,plateIsValid:false},_this.unsetFilterByWeekDays=function(){_this.state.weekRefs.map(function(ref){ref.checked=false;});_this.setState({weekRefs:[]});},_this.setWeekDayRef=function(ref){return _this.setState({weekRefs:[].concat(_toConsumableArray(_this.state.weekRefs),[ref])});},_this.unsetFilterByType=function(){_this.state.typeRefs.map(function(ref){ref.checked=false;});_this.setState({typeRefs:[]});},_this.setPlateValidation=function(bool){_this.setState({plateIsValid:bool});},_this.setLoading=function(bool){return _this.setState({loading:bool});},_this.setTypeRef=function(ref){return _this.setState({typeRefs:[].concat(_toConsumableArray(_this.state.typeRefs),[ref])});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PartnerFilterForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,onSubmitFilter=_props.onSubmitFilter,showResults=_props.showResults,dispatch=_props.dispatch,unsetResults=_props.unsetResults,plateFormError=_props.plateFormError,plateFormIsInvalid=_props.plateFormIsInvalid;var _state=this.state,plateIsValid=_state.plateIsValid,loading=_state.loading;var invalid=plateFormError||plateFormIsInvalid;return _react2.default.createElement(_styles.FormsContainer,{__source:{fileName:_jsxFileName,lineNumber:130}},_react2.default.createElement(_styles.InputsContainer,{__source:{fileName:_jsxFileName,lineNumber:131}},_react2.default.createElement(_FilterByTag2.default,{setPlateValidation:this.setPlateValidation,plateIsValid:plateIsValid,setLoading:this.setLoading,loading:loading,__source:{fileName:_jsxFileName,lineNumber:132}}),!showResults&&_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:138}}),showResults?_react2.default.createElement(_ShowResultsForm2.default,{__source:{fileName:_jsxFileName,lineNumber:140}}):_react2.default.createElement(BeforeResultsForm,{onSubmit:onSubmitFilter,setTypeRef:this.setTypeRef,setWeekDayRef:this.setWeekDayRef,__source:{fileName:_jsxFileName,lineNumber:142}})),showResults?_react2.default.createElement(_styles.ShowResultsBtnWrapper,{__source:{fileName:_jsxFileName,lineNumber:151}},_react2.default.createElement(_styles.ResetButton,{showResults:showResults,onClick:function onClick(e){e.preventDefault();unsetResults();_this2.unsetFilterByWeekDays();dispatch((0,_reduxForm.reset)('statementsFilter'));dispatch((0,_reduxForm.change)('checkPlateOrIdForm','validPlate',''));dispatch((0,_reduxForm.change)('checkPlateOrIdForm','identificador',''));_this2.setPlateValidation(false);},__source:{fileName:_jsxFileName,lineNumber:152}},'Remover filtros')):_react2.default.createElement(_styles.ButtonsContainer,{__source:{fileName:_jsxFileName,lineNumber:168}},_react2.default.createElement(_styles.Grid,{__source:{fileName:_jsxFileName,lineNumber:169}},_react2.default.createElement(_styles.ResetButton,{onClick:function onClick(e){e.preventDefault();unsetResults();_this2.unsetFilterByWeekDays();dispatch((0,_reduxForm.reset)('statementsFilter'));dispatch((0,_reduxForm.change)('checkPlateOrIdForm','validPlate',''));dispatch((0,_reduxForm.change)('checkPlateOrIdForm','identificador',''));_this2.setPlateValidation(false);},__source:{fileName:_jsxFileName,lineNumber:170}},'Remover filtros'),_react2.default.createElement(RemoteSubmitButton,{invalid:invalid,plateIsValid:plateIsValid,__source:{fileName:_jsxFileName,lineNumber:184}}))),_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:188}}));}}]);return PartnerFilterForm;}(_react.Component);exports.default=(0,_reactRedux.connect)(function(state){return{plateFormError:(0,_reduxForm.getFormSubmitErrors)('checkPlateOrIdForm')(state),plateFormIsInvalid:(0,_reduxForm.isInvalid)('checkPlateOrIdForm')(state)};})(PartnerFilterForm);module.exports=exports['default'];

/***/ }),
/* 1989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/FilterByTag/FilterByTag.js';/* eslint-disable */var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _reactRedux=__webpack_require__(7);var _utils=__webpack_require__(1990);var _apolloClient=__webpack_require__(42);var _styles=__webpack_require__(645);var _loading=__webpack_require__(100);var _loading2=_interopRequireDefault(_loading);var _query=__webpack_require__(1991);var _InputTagOptions=__webpack_require__(1992);var _InputTagOptions2=_interopRequireDefault(_InputTagOptions);var _SearchIcon=__webpack_require__(400);var _SearchIcon2=_interopRequireDefault(_SearchIcon);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var renderSearchInput=function renderSearchInput(props){var invalidInput=props.meta.invalid||props.meta.submitFailed;return _react2.default.createElement(_styles.SearchInputWrapper,{hide:props.hide,__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_styles.SearchIconContainer,{__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement(_SearchIcon2.default,{__source:{fileName:_jsxFileName,lineNumber:30}})),_react2.default.createElement(_styles.SearchInput,_extends({},props.input,{disabled:props.plateIsValid,invalidInput:invalidInput,plateIsValid:props.plateIsValid,onChange:function onChange(e){props.input.onChange(e.target.value);if(props.option==='placa'){return props.meta.dispatch((0,_reduxForm.change)('statementsFilter','plate',e.target.value));}},value:props.input.value,type:'text',placeholder:props.placeholder,__source:{fileName:_jsxFileName,lineNumber:32}})),invalidInput&&_react2.default.createElement(_styles.Error,{__source:{fileName:_jsxFileName,lineNumber:47}},props.meta.error||props.formError),props.plateIsValid&&_react2.default.createElement(_styles.Valid,{__source:{fileName:_jsxFileName,lineNumber:48}},'Placa ou tag v\xE1lida'));};var FilterByTag=function(_React$Component){_inherits(FilterByTag,_React$Component);function FilterByTag(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,FilterByTag);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FilterByTag.__proto__||Object.getPrototypeOf(FilterByTag)).call.apply(_ref,[this].concat(args))),_this),_this.state={option:'placa'},_this.setOption=function(value){return _this.setState({option:value});},_this.submit=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(values){var response,response2,placas;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.props.setLoading(true);if(!values.validPlate){_context.next=10;break;}_context.next=4;return(0,_apolloClient.gqlQuery)(_query.validPlateOrIdQuery,_extends({idConta:_this.props.accountPlans.activePlanId,placa:values.validPlate},values.validPlate&&{placa:values.validPlate},values.identificador&&{identificador:values.identificador}));case 4:response=_context.sent;if(!(response.data.identificadoresPJV2.identificadores.length>0)){_context.next=10;break;}_this.props.setPlateValidation(true);_this.props.setLoading(false);_this.props.dispatch((0,_reduxForm.change)('statementsFilter','plate',response.data.identificadoresPJV2.identificadores[0].veiculo.placa));return _context.abrupt('return',Promise.resolve());case 10:if(!values.identificador){_context.next=29;break;}response2=void 0;_context.prev=12;_context.next=15;return(0,_apolloClient.gqlQuery)(_query.gqlHistoricoIdentificadorTag,{idConta:_this.props.accountPlans.activePlanId,identificador:values.identificador});case 15:response2=_context.sent;_context.next=23;break;case 18:_context.prev=18;_context.t0=_context['catch'](12);_this.props.setPlateValidation(false);_this.props.setLoading(false);throw new _reduxForm.SubmissionError({_error:'Essa '+(values.identificador?'tag':'placa')+' n\xE3o \xE9 valida!'});case 23:if(!(response2.data.historicoIdentificadorTag.historicos.length>0)){_context.next=29;break;}_this.props.setPlateValidation(true);_this.props.setLoading(false);placas=response2.data.historicoIdentificadorTag.historicos.map(function(historico){return historico.placa;}).join();_this.props.dispatch((0,_reduxForm.change)('statementsFilter','plate',placas));return _context.abrupt('return',Promise.resolve());case 29:_this.props.setPlateValidation(false);_this.props.setLoading(false);throw new _reduxForm.SubmissionError({_error:'Essa '+(values.identificador?'tag':'placa')+' n\xE3o \xE9 valida!'});case 32:case'end':return _context.stop();}}},_callee,_this2,[[12,18]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FilterByTag,[{key:'render',value:function render(){var _props=this.props,handleSubmit=_props.handleSubmit,error=_props.error,plateIsValid=_props.plateIsValid,loading=_props.loading,dispatch=_props.dispatch,setPlateValidation=_props.setPlateValidation;var option=this.state.option;return _react2.default.createElement(_reduxForm.Form,{onSubmit:handleSubmit(this.submit),__source:{fileName:_jsxFileName,lineNumber:116}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:117}},_react2.default.createElement(_styles.InputContainer,{__source:{fileName:_jsxFileName,lineNumber:118}},_react2.default.createElement(_reduxForm.Field,{component:renderSearchInput,formError:error,plateIsValid:plateIsValid,name:'validPlate',hide:option==='tag',validate:_utils.validatePlate,placeholder:'Buscar por placa',__source:{fileName:_jsxFileName,lineNumber:119}}),_react2.default.createElement(_reduxForm.Field,{component:renderSearchInput,formError:error,plateIsValid:plateIsValid,name:'identificador',hide:option==='placa',validate:_utils.validateTag,placeholder:'Buscar por tag',__source:{fileName:_jsxFileName,lineNumber:128}}),_react2.default.createElement(_styles.SearchButton,{type:'submit',plateIsValid:plateIsValid,__source:{fileName:_jsxFileName,lineNumber:137}},loading?_react2.default.createElement(_styles.Loading,{src:_loading2.default,__source:{fileName:_jsxFileName,lineNumber:138}}):'Buscar')),_react2.default.createElement(_InputTagOptions2.default,{setPlateValidation:setPlateValidation,setOption:this.setOption,name:'placaOrIdOptions',value:option,dispatch:dispatch,__source:{fileName:_jsxFileName,lineNumber:141}})));}}]);return FilterByTag;}(_react2.default.Component);var mapStateToProps=function mapStateToProps(state){return{accountPlans:state.reducer.accountPlans};};exports.default=(0,_reduxForm.reduxForm)({form:'checkPlateOrIdForm'})((0,_reactRedux.connect)(mapStateToProps)(FilterByTag));module.exports=exports['default'];

/***/ }),
/* 1990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.validatePlate=exports.validateTag=undefined;var _aleloLogic=__webpack_require__(12);var validateTag=exports.validateTag=function validateTag(value,allValues){if(!allValues.validPlate||allValues.validPlate===''){if(!value)return'A tag é obrigatório.';if(value.length!==10)return'Tag inválida.';}return undefined;};var validatePlate=exports.validatePlate=function validatePlate(value,allValues){if(!allValues.identificador||allValues.identificador===''){return _aleloLogic.utils.plateValidate(value);}return undefined;};

/***/ }),
/* 1991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.gqlHistoricoIdentificadorTag=exports.validPlateOrIdQuery=undefined;var _templateObject=_taggedTemplateLiteral(['\n  query identificadoresPJV2(\n    $idConta: String!\n    $placa: String\n    $identificador: String\n    $gerencial: Boolean\n    $pagina: Int\n    $quantidade: Int\n  ) {\n    identificadoresPJV2(\n      idConta: $idConta\n      placa: $placa\n      identificador: $identificador\n      gerencial: $gerencial\n      pagina: $pagina\n      quantidade: $quantidade\n    ) {\n      identificadores {\n        idIdentificador\n        codIdentificador\n        veiculo {\n          placa\n        }\n      }\n    }\n  }\n'],['\n  query identificadoresPJV2(\n    $idConta: String!\n    $placa: String\n    $identificador: String\n    $gerencial: Boolean\n    $pagina: Int\n    $quantidade: Int\n  ) {\n    identificadoresPJV2(\n      idConta: $idConta\n      placa: $placa\n      identificador: $identificador\n      gerencial: $gerencial\n      pagina: $pagina\n      quantidade: $quantidade\n    ) {\n      identificadores {\n        idIdentificador\n        codIdentificador\n        veiculo {\n          placa\n        }\n      }\n    }\n  }\n']),_templateObject2=_taggedTemplateLiteral(['\n  query historicoIdentificadorTag($idConta: String!, $identificador: String!) {\n    historicoIdentificadorTag(idConta: $idConta, identificador: $identificador) {\n      id\n      pap\n      placa\n      historicos {\n        codIdentificador\n        dataInclusao\n        operacao\n        placa\n      }\n    }\n  }\n'],['\n  query historicoIdentificadorTag($idConta: String!, $identificador: String!) {\n    historicoIdentificadorTag(idConta: $idConta, identificador: $identificador) {\n      id\n      pap\n      placa\n      historicos {\n        codIdentificador\n        dataInclusao\n        operacao\n        placa\n      }\n    }\n  }\n']);var _graphqlTag=__webpack_require__(48);var _graphqlTag2=_interopRequireDefault(_graphqlTag);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var validPlateOrIdQuery=exports.validPlateOrIdQuery=(0,_graphqlTag2.default)(_templateObject);var gqlHistoricoIdentificadorTag=exports.gqlHistoricoIdentificadorTag=(0,_graphqlTag2.default)(_templateObject2);

/***/ }),
/* 1992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/FilterByTag/InputTagOptions.js';/* eslint-disable */var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _styles=__webpack_require__(645);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var filterItems=[{value:'placa',label:'Placa'},{value:'tag',label:'Tag'}];function InputTagOptions(_ref){var setOption=_ref.setOption,name=_ref.name,value=_ref.value,dispatch=_ref.dispatch,setPlateValidation=_ref.setPlateValidation;return _react2.default.createElement(_styles.FilterTypeContainer,{__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement(_styles.FilterTypes,{__source:{fileName:_jsxFileName,lineNumber:30}},filterItems.map(function(type){return _react2.default.createElement(_styles.ListItem,{key:type.value,__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_styles.RadioLabel,{__source:{fileName:_jsxFileName,lineNumber:33}},type.label,_react2.default.createElement(_styles.InputRadio,{checked:type.value===value,name:name,onChange:function onChange(){dispatch((0,_reduxForm.change)('checkPlateOrIdForm','validPlate',''));dispatch((0,_reduxForm.change)('checkPlateOrIdForm','identificador',''));setPlateValidation(false);setOption(type.value);},value:type.value,type:'radio',__source:{fileName:_jsxFileName,lineNumber:35}}),_react2.default.createElement(_styles.CheckMark,{__source:{fileName:_jsxFileName,lineNumber:47}}),_react2.default.createElement(_styles.Radio,{__source:{fileName:_jsxFileName,lineNumber:48}})));})));}exports.default=InputTagOptions;module.exports=exports['default'];

/***/ }),
/* 1993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PaginationSelector/PaginationSelector.js';/* eslint-disable */exports.default=PaginationSelector;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _PeriodOption=__webpack_require__(1994);var _PeriodOption2=_interopRequireDefault(_PeriodOption);var _styles=__webpack_require__(646);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var filterItems=[{value:15,label:'15 transações'},{value:30,label:'30 transações'},{value:60,label:'60 transações'},{value:90,label:'90 transações'}];function PaginationSelector(onChange){return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:30}},'Visualizar'),_react2.default.createElement(_styles.FilterTypeContainer,{__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_styles.FilterTypes,{__source:{fileName:_jsxFileName,lineNumber:32}},filterItems.map(function(type){return _react2.default.createElement(_styles.ListItem,{key:type.value,__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement(_PeriodOption2.default,{key:type.value,value:type.value,onChange:onChange,name:'quantidade',label:type.label,__source:{fileName:_jsxFileName,lineNumber:35}}));})))));}module.exports=exports['default'];

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PaginationSelector/PeriodOption.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _styles=__webpack_require__(646);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var renderFilterTypeOption=function renderFilterTypeOption(props){return _react2.default.createElement(_styles.InputRadio,_extends({},props.input,{name:props.name,onChange:function onChange(){return props.input.onChange(props.input.value);},value:props.input.value,type:'radio',__source:{fileName:_jsxFileName,lineNumber:6}}));};function PeriodOption(props){var label=props.label,name=props.name,value=props.value;return _react2.default.createElement(_styles.RadioLabel,{__source:{fileName:_jsxFileName,lineNumber:19}},label,_react2.default.createElement(_reduxForm.Field,{component:renderFilterTypeOption,name:name,type:'radio',value:value,__source:{fileName:_jsxFileName,lineNumber:21}}),_react2.default.createElement(_styles.CheckMark,{__source:{fileName:_jsxFileName,lineNumber:22}}),_react2.default.createElement(_styles.Radio,{__source:{fileName:_jsxFileName,lineNumber:23}}));}exports.default=PeriodOption;module.exports=exports['default'];

/***/ }),
/* 1995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PartnerFilterForm/FilterByType/FilterByType.js';/* eslint-disable */var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _styles=__webpack_require__(1996);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var filterItems=[{value:"ESTACIONAMENTO",label:'Estacionamento'},{value:"PEDAGIO",label:'Pedágio'}];var renderCheckboxItem=function renderCheckboxItem(props){var inputValue=props.input.value;return _react2.default.createElement(_styles.InputCheckbox,_extends({},props,{onChange:function onChange(e){var arr=[].concat(_toConsumableArray(inputValue));if(e.target.checked){arr.push({tipo:props.typeValue});}else{arr.splice(arr.indexOf(props.typeValue),1);}props.input.onChange(arr);props.setTypeRef(e.target);},value:props.input.value,type:'checkbox',__source:{fileName:_jsxFileName,lineNumber:20}}));};function CheckboxItem(props){return _react2.default.createElement(_styles.CheckBoxContainer,{__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_reduxForm.Field,_extends({component:renderCheckboxItem},props,{__source:{fileName:_jsxFileName,lineNumber:41}})),_react2.default.createElement(_styles.CheckboxLabel,{__source:{fileName:_jsxFileName,lineNumber:42}},props.label));}function FilterByType(props){return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement(_styles.TitleContainer,{__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:52}},'Tipo de transa\xE7\xE3o')),_react2.default.createElement(_styles.FilterContainer,{__source:{fileName:_jsxFileName,lineNumber:54}},_react2.default.createElement(_styles.FilterTypes,{__source:{fileName:_jsxFileName,lineNumber:55}},filterItems.map(function(type,index){return _react2.default.createElement(_styles.ListItem,{key:type.value,__source:{fileName:_jsxFileName,lineNumber:58}},_react2.default.createElement(CheckboxItem,{setTypeRef:props.setTypeRef,typeValue:type.value,onChange:props.onChange,name:'type',label:type.label,index:index,__source:{fileName:_jsxFileName,lineNumber:59}}));})))));}exports.default=FilterByType;module.exports=exports['default'];

/***/ }),
/* 1996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.InputCheckbox=exports.CheckboxLabel=exports.FilterTypes=exports.CheckBoxContainer=exports.ListItem=exports.FilterContainer=exports.Content=exports.Container=exports.TitleContainer=exports.Title=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-o0swvv-0'})(['letter-spacing:',';color:',';',';letter-spacing:normal;line-height:1;margin-bottom:0;'],(0,_em2.default)('0.4px'),_colors.darkSlateBlue,_types.title28GalanoBold);var TitleContainer=exports.TitleContainer=_styledComponents2.default.div.withConfig({displayName:'styles__TitleContainer',componentId:'sc-o0swvv-1'})(['display:flex;flex-direction:row;align-items:center;justify-content:flex-start;margin-bottom:30px;']);var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-o0swvv-2'})(['width:100%;padding:',' 0 ',';background-color:white;display:flex;justify-content:center;'],(0,_rem2.default)('9px'),(0,_rem2.default)('50px'));var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-o0swvv-3'})(['display:flex;justify-content:flex-start;flex-direction:column;width:',';align-items:flex-start;'],(0,_rem2.default)('940px'));var FilterContainer=exports.FilterContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FilterContainer',componentId:'sc-o0swvv-4'})(['padding:0;']);var ListItem=exports.ListItem=_styledComponents2.default.li.withConfig({displayName:'styles__ListItem',componentId:'sc-o0swvv-5'})(['margin:0;height:100%;']);var CheckBoxContainer=exports.CheckBoxContainer=_styledComponents2.default.div.withConfig({displayName:'styles__CheckBoxContainer',componentId:'sc-o0swvv-6'})(['position:relative;height:100%;width:100%;display:flex;']);var FilterTypes=exports.FilterTypes=_styledComponents2.default.ul.withConfig({displayName:'styles__FilterTypes',componentId:'sc-o0swvv-7'})(['display:flex;align-items:center;list-style:none;margin:0;height:',';padding:0;width:100%;box-shadow:0px 4px 12px rgba(0,0,0,0.08),0px 0px 1px rgba(0,0,0,0.12);border-radius:',';overflow:auto;& li:last-of-type label{border:none;}'],(0,_rem2.default)('45px'),(0,_rem2.default)('8px'));var CheckboxLabel=exports.CheckboxLabel=_styledComponents2.default.label.withConfig({displayName:'styles__CheckboxLabel',componentId:'sc-o0swvv-8'})(['position:relative;color:',';',';padding:',' ',';height:100%;border-right:1px solid rgba(17,14,73,0.16);'],_colors.darkSlateBlue,_types.txt16OpenSansBold,(0,_rem2.default)('10px'),(0,_rem2.default)('30px'));var InputCheckbox=exports.InputCheckbox=_styledComponents2.default.input.attrs({type:'checkbox'}).withConfig({displayName:'styles__InputCheckbox',componentId:'sc-o0swvv-9'})(['opacity:0;display:block;z-index:1;position:absolute;width:100%;height:100%;&:checked + ','{background:#aeabc4;}'],CheckboxLabel);

/***/ }),
/* 1997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PartnerFilterForm/ShowResultsForm.js';/* eslint-disable */var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _reactRedux=__webpack_require__(7);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _styles=__webpack_require__(647);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var diaDaSemanaMap=[{value:6,label:'Dom'},{value:0,label:'Seg'},{value:1,label:'Ter'},{value:2,label:'Qua'},{value:3,label:'Qui'},{value:4,label:'Sex'},{value:5,label:'Sab'}];var getChoosenDays=function getChoosenDays(days){if(days===undefined||days.length===7)return'Todos os dias';var foundDays=diaDaSemanaMap.filter(function(dia){var found=days.find(function(day){return day===dia.value;});return found!==undefined;});var stringOfDays=foundDays.map(function(day){return day.label;}).toString();return stringOfDays;};var getPeriodo=function getPeriodo(periodo,rangeDates){if(rangeDates){return(0,_moment2.default)(rangeDates.from).format('MM/DD')+' a '+(0,_moment2.default)(rangeDates.to).format('MM/DD')+' de '+(0,_moment2.default)(rangeDates.from).format('YYYY');}if(!periodo)return'90 dias';return periodo+' dias';};var getTipoTransacao=function getTipoTransacao(tipoTransacao){if(!tipoTransacao||tipoTransacao.length===0)return'Todos os tipos';if(tipoTransacao&&tipoTransacao.length===2)return'Todos os tipos';return{PEDAGIO:'Pedágio',ESTACIONAMENTO:'Estacionamento'}[tipoTransacao[0].tipo];};var getQuantidade=function getQuantidade(quantidade){if(!quantidade)return'30 transações';return quantidade+' transa\xE7\xF5es';};function ShowResultsForm(_ref){var tipoTransacao=_ref.tipoTransacao,rangeDates=_ref.rangeDates,periodo=_ref.periodo,quantidade=_ref.quantidade,diaDaSemana=_ref.diaDaSemana;return _react2.default.createElement(_styles.ShowResultsFormWrapper,{__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement(_styles.ShowResultsInput,{placeholder:getTipoTransacao(tipoTransacao),disabled:true,__source:{fileName:_jsxFileName,lineNumber:75}}),_react2.default.createElement(_styles.ShowResultsInput,{placeholder:getPeriodo(periodo,rangeDates),disabled:true,__source:{fileName:_jsxFileName,lineNumber:76}}),_react2.default.createElement(_styles.ShowResultsInput,{placeholder:getChoosenDays(diaDaSemana),disabled:true,__source:{fileName:_jsxFileName,lineNumber:77}}),_react2.default.createElement(_styles.ShowResultsInput,{placeholder:getQuantidade(quantidade),disabled:true,__source:{fileName:_jsxFileName,lineNumber:78}}));}var mapStateToProps=function mapStateToProps(state){var selector=(0,_reduxForm.formValueSelector)('statementsFilter');return{tipoTransacao:selector(state,'type'),periodo:selector(state,'periodo'),quantidade:selector(state,'quantidade'),diaDaSemana:selector(state,'diaDaSemana'),rangeDates:selector(state,'rangeDates')};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(ShowResultsForm);module.exports=exports['default'];

/***/ }),
/* 1998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FilterContainer=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var FilterContainer=exports.FilterContainer=_styledComponents2.default.div.withConfig({displayName:'styles__FilterContainer',componentId:'sc-gooxxe-0'})(['align-items:center;display:flex;width:100%;align-items:center;transition:opacity 0.3s 0.6s ease,height 0.3s 0.3s ease,visibility 0s 0s ease;']);

/***/ }),
/* 1999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Paragraph=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n    ','\n    letter-spacing: normal;\n    line-height: 1;\n  '],['\n    ','\n    letter-spacing: normal;\n    line-height: 1;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-1pa3wqu-0'})(['',' letter-spacing:',';color:',';margin-top:',';',';'],_types.title40GalanoBold,(0,_em2.default)('0.4px'),_colors.darkSlateBlue,(0,_rem2.default)('40px'),_media2.default.small(_templateObject,_types.title28GalanoBold));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-1pa3wqu-1'})(['',' color:',';max-width:',';'],_types.txt14OpenSans,_colors.darkSlateBlue,(0,_rem2.default)('400px'));

/***/ }),
/* 2000 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Minha Veloe - Extrato","topbar":{"date":{"month":"Outubro","hour":"07:58","day":"10/10/2017"},"currency":"R$"},"statements":[{"id":0,"date":9,"dayweek":"Domingo","items":[{"id":0,"type":"fuel","title":"Posto Shell Nova Odessa","local":"D01239982 - Av. Dr. Ernesto Sprogis, 802-986 - Nova Odessa - SP","date":"05/10/2017","time":"19:17","value":"-37,00"},{"id":1,"type":"refund","title":"Posto Shell Afonso Bovero","local":"D01239982 - Rua Fradique Coutinho, 0909 - São Paulo","date":"05/10/2017","time":"19:17","value":"+27,00"},{"id":2,"type":"park","title":"Concessionária Rota Das Bandeiras S. ","local":"D01239982 - SP280, KM18, OESTE, OSASCO","date":"05/10/2017","entry":"07:50","exit":"08:20","stay":"00:30","value":"-37,00"}]},{"id":1,"date":8,"dayweek":"Sábado","items":[{"id":3,"type":"pass","title":"Posto Shell Nova Odessa","local":"D01239982 - Av. Dr. Ernesto Sprogis, 802-986 - Nova Odessa - SP","date":"05/10/2017","time":"19:17","value":"-37,00"},{"id":4,"type":"fuel","title":"Posto Shell Nova Odessa","local":"D01239982 - Av. Dr. Ernesto Sprogis, 802-986 - Nova Odessa - SP","date":"05/10/2017","time":"19:17","value":"-37,00"},{"id":5,"type":"payment","title":"Recebemos seu pagamento","local":"D01239982 - Via App Veloe - Débito em conta","date":"05/10/2017","time":"19:17","value":"-37,00"}]}]}

/***/ }),
/* 2001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _enum=__webpack_require__(643);var _enum2=_interopRequireDefault(_enum);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var myEnum=new _enum2.default({ABASTECIMENTO:'fuel',ESTACIONAMENTO:'park',PEDAGIO:'toll',FATURA:'payment',RECARGA:'recharge'});var myEnumTitle=new _enum2.default({FATURA:'Recebemos seu pagamento',RECARGA:'Recebemos sua recarga'});function getTitle(data){if(data['estabelecimento-comercial']['tipo-transacao']){return myEnumTitle.get(data['estabelecimento-comercial']['tipo-transacao'])?myEnumTitle.get(data['estabelecimento-comercial']['tipo-transacao']).value:data['estabelecimento-comercial'].nome;}return data['motivo-transacao'];}function getType(data){return myEnum.get(data['estabelecimento-comercial']['tipo-transacao'])?myEnum.get(data['estabelecimento-comercial']['tipo-transacao']).value:'tax';}var statementFactory={toForm:function toForm(statement){return statement&&statement.map(function(data,index){return statement&&{id:data['cyber-id'],date:(0,_moment2.default)(data['data-evento'],'DD/MM/YYYY HH:mm:ss').toDate(),processDate:(0,_moment2.default)(data['data-processamento'],'DD/MM/YYYY HH:mm:ss').toDate(),exitDate:(0,_moment2.default)(data['data-fim-evento'],'DD/MM/YYYY HH:mm:ss').toDate(),startTime:data['hora-evento'],exitTime:data['hora-fim-evento'],stayTime:data['permanencia'],type:getType(data),value:data.valor,fastId:data.fastId,title:getTitle(data),details:data.endereco,tollFree:data.valePedagio,tollFreeValidityStart:data.vpVigenciaInicio,tollFreeValidityEnd:data.vpVigenciaFim,tollFreeOrigin:data.vpOrigem,tollFreeDestination:data.vpDestino,tollFreeVeloeId:data.vpIdveloe,tollFreeCNPJ:data.vpCnpjEmbarcador,code:data['cyber-id'],vehicle:data.veiculo,partner:true};});}};exports.default=statementFactory;module.exports=exports['default'];

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardInvoice/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _actions=__webpack_require__(13);var _AddItem=__webpack_require__(258);var _AddItem2=_interopRequireDefault(_AddItem);var _actions2=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _InvoicesList=__webpack_require__(2003);var _InvoicesList2=_interopRequireDefault(_InvoicesList);var _actions3=__webpack_require__(36);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);var _trafficSignalError=__webpack_require__(401);var _trafficSignalError2=_interopRequireDefault(_trafficSignalError);var _apolloClient=__webpack_require__(42);var _invoices=__webpack_require__(356);var _styles=__webpack_require__(2007);var _data=__webpack_require__(2008);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DashboardInvoice=function(_Component){_inherits(DashboardInvoice,_Component);function DashboardInvoice(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DashboardInvoice);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DashboardInvoice.__proto__||Object.getPrototypeOf(DashboardInvoice)).call.apply(_ref,[this].concat(args))),_this),_this.state={loadingMore:false},_this.fetchInvoices=function(nextUrl){_this.setState(function(){return{loadingMore:true};});var params=_this.props.match.params||{};_this.props.fetchInvoices(params.id,nextUrl).then().catch().finally(function(){_this.setState(function(){return{loadingMore:false};});});},_this.handleRequestNewBoleto=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(planId,invoiceId){var _this$props,showRequestNewBoletoResponseModal,showErrorModal,_ref3,data;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,showRequestNewBoletoResponseModal=_this$props.showRequestNewBoletoResponseModal,showErrorModal=_this$props.showErrorModal;_context.next=3;return(0,_apolloClient.gqlMutate)(_invoices.gqlSolicitarBoleto,{idConta:planId,nsu:invoiceId});case 3:_ref3=_context.sent;data=_ref3.data;if(!(data&&data.solicitarBoleto&&data.solicitarBoleto.codigo==='200')){_context.next=9;break;}return _context.abrupt('return',showRequestNewBoletoResponseModal());case 9:if(!(data.solicitarBoleto.mensagem==='Já existe uma solicitação para o boleto')){_context.next=13;break;}return _context.abrupt('return',showErrorModal(_data.boletoUnavailableModalBody));case 13:return _context.abrupt('return',showErrorModal());case 14:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DashboardInvoice,[{key:'componentDidMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.props.setLoading(true);_context2.next=3;return this.props.getUserData();case 3:_context2.next=5;return this.props.resetInvoices();case 5:this.fetchInvoices();case 6:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidMount(){return _ref4.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _props=this.props,invoices=_props.invoices,downloadCSVInvoice=_props.downloadCSVInvoice;var loadingMore=this.state.loadingMore;var params=this.props.match.params||{};return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:86}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:87}}),!invoices||invoices.data.length===0?_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:89}},_react2.default.createElement(_styles.BoxHeader,{__source:{fileName:_jsxFileName,lineNumber:90}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:91}},_data.noInvoiceTitle),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:92}},_data.noInvoiceDescription))):_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:96}},_react2.default.createElement(_styles.BoxHeader,{__source:{fileName:_jsxFileName,lineNumber:97}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:98}},(this.props.account||{}).pc?'Faturas e Repasses':_data.invoiceTitle),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:101}},(this.props.account||{}).pc?'':_data.invoiceDescription)),_react2.default.createElement(_AddItem2.default,{data:invoices.data,next:invoices.next.proxima,planId:params.id,fetchHandler:this.fetchInvoices,__source:{fileName:_jsxFileName,lineNumber:103}},_react2.default.createElement(_InvoicesList2.default,{downloadTicket:downloadCSVInvoice,loadingMore:loadingMore,requestNewBoleto:this.handleRequestNewBoleto,__source:{fileName:_jsxFileName,lineNumber:109}}))));}}]);return DashboardInvoice;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref5){var reducer=_ref5.reducer;return{invoices:reducer.dashboardInvoices,account:reducer.account};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{fetchInvoices:function fetchInvoices(planId,nextURL){return dispatch((0,_actions.fetchDashboardInvoices)(planId,nextURL)).then(function(){return dispatch((0,_actions3.setLoading)(false));}).catch(function(resp){if(resp&&(resp.status===401||resp.status===403)){dispatch((0,_actions.fetchLogout)());ownProps.history.push('/conta/login');}});},showRequestNewBoletoResponseModal:function showRequestNewBoletoResponseModal(){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.boletoModalTitle,modalDescription:_data.boletoModalBody,image:_confirmation2.default}));},showErrorModal:function showErrorModal(){var description=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';return dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:'Ops! Algo deu errado',modalDescription:description?_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:151}},description):_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:153}},'Erro ao solicitar gera\xE7\xE3o de boleto.'),accountType:'pf',image:_trafficSignalError2.default}));},resetInvoices:function resetInvoices(){return dispatch((0,_actions.resetDashboardInvoices)());},downloadCSVInvoice:function downloadCSVInvoice(planId,invoiceId){dispatch((0,_actions3.setLoading)(true));dispatch((0,_actions.downloadTicketFile)(planId,invoiceId)).then(function(response){response.arrayBuffer().then(function(buffer){if(window.navigator&&window.navigator.msSaveOrOpenBlob){window.navigator.msSaveOrOpenBlob(new Blob([buffer]),'Boleto.pdf');}else{var url=window.URL.createObjectURL(new Blob([buffer]));var link=document.createElement('a');link.href=url;link.setAttribute('download','Boleto.pdf');document.body.appendChild(link);link.click();}});}).catch(function(err){return err.json();}).then(function(message){if(message.statusCode==='20'||message.statusName==='NAO_DISPONIVEL_SOLICITANDO'){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.boletoModalTitle,modalDescription:_data.boletoModalBody,image:_confirmation2.default}));}else if(message.statusCode==='21'||message.statusName==='NAO_DISPONIVEL_SOLICITADO_PREVIAMENTE'){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.boletoUnavailableModalTitle,modalDescription:_data.boletoUnavailableModalBody,image:_confirmation2.default}));}}).finally(function(){return dispatch((0,_actions3.setLoading)(false));});},getUserData:function getUserData(){return dispatch((0,_actions.fetchGetBusinessUserOnly)());},setLoading:function setLoading(isLoading){dispatch((0,_actions3.setLoading)(isLoading));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DashboardInvoice);module.exports=exports['default'];

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/InvoicesList/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _LoadMore=__webpack_require__(398);var _LoadMore2=_interopRequireDefault(_LoadMore);var _InvoiceListItem=__webpack_require__(2004);var _InvoiceListItem2=_interopRequireDefault(_InvoiceListItem);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _styles=__webpack_require__(2006);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InvoicesList=function InvoicesList(_ref){var data=_ref.data,loadMoreHandler=_ref.loadMoreHandler,next=_ref.next,planId=_ref.planId,downloadTicket=_ref.downloadTicket,loadingMore=_ref.loadingMore,requestNewBoleto=_ref.requestNewBoleto;return _react2.default.createElement(_styles.ListContainer,{__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement(_gridStyled.Flex,{width:1,direction:['column','row'],style:{padding:'0 30px'},__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement(_gridStyled.Box,{width:[1,2/12],mr:35,__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_styles.Label,{className:'month',__source:{fileName:_jsxFileName,lineNumber:21}},'M\xEAs')),_react2.default.createElement(_Hide2.default,{at:'small',width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(_styles.Label,{right:true,__source:{fileName:_jsxFileName,lineNumber:24}},'Valor total (R$)')),_react2.default.createElement(_Hide2.default,{at:'small',width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:27}},'Vencimento')),_react2.default.createElement(_gridStyled.Box,{width:[1,4/12],__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement(_styles.Label,{marginStatus:true,__source:{fileName:_jsxFileName,lineNumber:30}},'Status da fatura'))),data.map(function(invoice,index){return _react2.default.createElement(_InvoiceListItem2.default,_extends({key:index,first:index===0},invoice,{planId:planId,downloadTicket:downloadTicket,requestNewBoleto:requestNewBoleto,__source:{fileName:_jsxFileName,lineNumber:34}}));}),next&&_react2.default.createElement(_styles.ListFooter,{__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_LoadMore2.default,{onClick:loadMoreHandler,loadingMore:loadingMore,__source:{fileName:_jsxFileName,lineNumber:45}})));};exports.default=InvoicesList;module.exports=exports['default'];

/***/ }),
/* 2004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/InvoiceListItem/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _utils=__webpack_require__(95);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _InvoiceStatus=__webpack_require__(2005);var _InvoiceStatus2=_interopRequireDefault(_InvoiceStatus);var _styles=__webpack_require__(648);var _actions=__webpack_require__(18);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);var _ModalTypes=__webpack_require__(20);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InvoiceListItem=function(_Component){_inherits(InvoiceListItem,_Component);function InvoiceListItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InvoiceListItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InvoiceListItem.__proto__||Object.getPrototypeOf(InvoiceListItem)).call.apply(_ref,[this].concat(args))),_this),_this.currentInvoiceMessage=function(){var cutDay=_this.props.actualPlan.posData.cutDay;_this.props.dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:'Fatura Atual',modalDescription:'A sua fatura ainda est\xE1 aberta e ser\xE1 fechada dia '+(0,_utils.ISODateFormat)(cutDay)+'. Para consultar suas transa\xE7\xF5es antes do fechamento acesse o menu Extrato.',image:_contestacao2.default}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InvoiceListItem,[{key:'render',value:function render(){var _this2=this;var _props=this.props,dataVencimento=_props.dataVencimento,formaPagamento=_props.formaPagamento,planId=_props.planId,status=_props.status,valor=_props.valor,numero=_props.numero,nsu=_props.nsu,qtdTransacoes=_props.qtdTransacoes,downloadTicket=_props.downloadTicket,exibirTransacoes=_props.exibirTransacoes,linkBoleto=_props.linkBoleto,requestNewBoleto=_props.requestNewBoleto;var idMes='lista_fatura_mes_'+numero;var idValorTotal='lista_fatura_valor_total_'+numero;var idVencimento='lista_fatura_vencimento_'+numero;var idStatus='lista_fatura_status_'+numero;return _react2.default.createElement(_styles.ListItem,{__source:{fileName:_jsxFileName,lineNumber:48}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_gridStyled.Flex,{width:1,direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement(_gridStyled.Box,{width:[1,2/12],mr:35,style:{display:'flex',alignItems:'stretch'},__source:{fileName:_jsxFileName,lineNumber:51}},dataVencimento===null&&exibirTransacoes===false?_react2.default.createElement(_styles.ButtonAlert,{onClick:function onClick(){return _this2.currentInvoiceMessage();},style:{display:'flex',alignItems:'center'},__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_styles.Title,{status:status,id:idMes,__source:{fileName:_jsxFileName,lineNumber:57}},(0,_utils.capitalize)((0,_utils.ISODateFormat)(dataVencimento,'MMMM'))||'Atual')):_react2.default.createElement(_styles.LinkToInvoice,{to:'/minha-veloe/'+planId+'/fatura/'+numero+'/'+qtdTransacoes,style:{display:'flex',alignItems:'center'},__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement(_styles.Title,{status:status,id:idMes,__source:{fileName:_jsxFileName,lineNumber:66}},(0,_utils.capitalize)((0,_utils.ISODateFormat)(dataVencimento,'MMMM'))||'Atual'))),_react2.default.createElement(_Hide2.default,{at:'small',width:[1,3/12],style:{display:'flex',alignItems:'stretch',justifyContent:'flex-end'},__source:{fileName:_jsxFileName,lineNumber:72}},dataVencimento===null&&exibirTransacoes===false?_react2.default.createElement(_styles.ButtonAlert,{onClick:function onClick(){return _this2.currentInvoiceMessage();},style:{display:'flex',alignItems:'center',justifyContent:'flex-end'},__source:{fileName:_jsxFileName,lineNumber:78}},_react2.default.createElement(_styles.Title,{right:true,status:status,id:idValorTotal,__source:{fileName:_jsxFileName,lineNumber:82}},(0,_utils.currencyParser)(valor*-1))):_react2.default.createElement(_styles.LinkToInvoice,{to:'/minha-veloe/'+planId+'/fatura/'+numero+'/'+qtdTransacoes,style:{display:'flex',alignItems:'center',justifyContent:'flex-end'},__source:{fileName:_jsxFileName,lineNumber:87}},_react2.default.createElement(_styles.Title,{right:true,status:status,id:idValorTotal,__source:{fileName:_jsxFileName,lineNumber:91}},(0,_utils.currencyParser)(valor*-1)))),_react2.default.createElement(_Hide2.default,{at:'small',width:[1,3/12],style:{display:'flex',alignItems:'stretch'},__source:{fileName:_jsxFileName,lineNumber:97}},dataVencimento===null&&exibirTransacoes===false?_react2.default.createElement(_styles.ButtonAlert,{onClick:function onClick(){return _this2.currentInvoiceMessage();},style:{display:'flex',alignItems:'center'},__source:{fileName:_jsxFileName,lineNumber:99}},_react2.default.createElement(_styles.Title,{status:status,id:idVencimento,__source:{fileName:_jsxFileName,lineNumber:103}},(0,_utils.ISODateFormat)(dataVencimento)||'Em aberto')):_react2.default.createElement(_styles.LinkToInvoice,{to:'/minha-veloe/'+planId+'/fatura/'+numero+'/'+qtdTransacoes,style:{display:'flex',alignItems:'center'},__source:{fileName:_jsxFileName,lineNumber:108}},_react2.default.createElement(_styles.Title,{status:status,id:idVencimento,__source:{fileName:_jsxFileName,lineNumber:112}},(0,_utils.ISODateFormat)(dataVencimento)||'Em aberto'))),_react2.default.createElement(_gridStyled.Box,{width:[2,4/12],__source:{fileName:_jsxFileName,lineNumber:118}},_react2.default.createElement(_InvoiceStatus2.default,{dataVencimento:dataVencimento,status:status,method:formaPagamento,planId:planId,fatura:numero,nsu:nsu,qtdTransacoes:qtdTransacoes,downloadTicket:downloadTicket,idElemento:idStatus,linkBoleto:linkBoleto,requestNewBoleto:requestNewBoleto,__source:{fileName:_jsxFileName,lineNumber:119}})))));}}]);return InvoiceListItem;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{actualPlan:reducer.accountPlans.plans.find(function(plan){return plan.accountId===reducer.accountPlans.activePlanId;})||{}};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(InvoiceListItem);module.exports=exports['default'];

/***/ }),
/* 2005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/InvoiceStatus/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _styles=__webpack_require__(648);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _paymentMethods=__webpack_require__(649);var _Icon=__webpack_require__(31);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/**
 * Return label based on status
 * @param {string} status
 */var formatLabel=function formatLabel(status){switch(status){case'PENDENTE':return'Fatura fechada';case'AGENDADO':return'Fatura fechada';case'NAO_AUTORIZADO':return'Fatura fechada';case'NAO_COMPENSADO':return'Fatura fechada';case'CANCELADO':return'Fatura fechada';case'COMPENSADO':return'Fatura paga';case'AUTORIZADO':return'Fatura paga';case'ATRASO':return'Fatura em atraso';default:return'Fatura atual';}};var checkRequestNewBoleto=function checkRequestNewBoleto(status,paymentType,dataVencimento){if(!dataVencimento&&!paymentType){return false;}if(status!=='COMPENSADO'&&status!=='EM_ABERTO'&&status!=='FATURA_ATUAL'&&status!=='AUTORIZADO'){var currentDate=new Date();if(paymentType==='DEBITO_EM_CONTA'){var dueDate=new Date(dataVencimento+' 23:59:59');dueDate.setDate(dueDate.getDate()+4);// 4 Dias de ataso
return currentDate>dueDate;}if(paymentType==='CARTAO_DE_CREDITO'||paymentType==='BOLETO'){var _dueDate=new Date(dataVencimento+' 23:59:59');return currentDate>_dueDate;}}return false;};var InvoiceStatus=function InvoiceStatus(_ref){var status=_ref.status,method=_ref.method,planId=_ref.planId,nsu=_ref.nsu,downloadTicket=_ref.downloadTicket,idElemento=_ref.idElemento,linkBoleto=_ref.linkBoleto,dataVencimento=_ref.dataVencimento,requestNewBoleto=_ref.requestNewBoleto,userData=_ref.userData,currentAccount=_ref.currentAccount;return _react2.default.createElement(_styles.StatusContainer,{__source:{fileName:_jsxFileName,lineNumber:83}},_react2.default.createElement(_styles.IconContainer,{__source:{fileName:_jsxFileName,lineNumber:84}},_react2.default.createElement(_Icon.Icon,{width:'62',height:'50',icon:status,viewBox:'0 0 102 102',__source:{fileName:_jsxFileName,lineNumber:85}})),_react2.default.createElement(_styles.StatusContent,{__source:{fileName:_jsxFileName,lineNumber:87}},_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:88}},formatLabel(status)),_react2.default.createElement(_styles.Text,{status:status,id:idElemento,__source:{fileName:_jsxFileName,lineNumber:89}},(0,_paymentMethods.formatMethod)(status,method))),linkBoleto&&_react2.default.createElement(_styles.ButtonContainer,{__source:{fileName:_jsxFileName,lineNumber:94}},_react2.default.createElement(_Button2.default,{id:'link_boleto_'+nsu,secondary:true,width:'112px',lineHeight:'32px',fontSize:'14.5px',padding:'2px',onClick:function onClick(){return window.open(linkBoleto,'_blank');},text:'Baixar boleto',__source:{fileName:_jsxFileName,lineNumber:95}})),currentAccount&&!linkBoleto&&checkRequestNewBoleto(status,currentAccount.paymentType,dataVencimento)&&_react2.default.createElement(_styles.ButtonContainer,{__source:{fileName:_jsxFileName,lineNumber:110}},_react2.default.createElement(_Button2.default,{width:'112px',lineHeight:'32px',fontSize:'14.5px',padding:'2px',onClick:function onClick(){return requestNewBoleto(userData.profile.customerId,nsu);},id:'solicitar_boleto_'+nsu,text:'Solicitar boleto',__source:{fileName:_jsxFileName,lineNumber:111}})));};var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{userData:reducer.user,currentAccount:reducer.accountPlans.plans.find(function(ac){return ac.id===reducer.accountPlans.activePlanId;})};};exports.default=(0,_reactRedux.connect)(mapStateToProps,null)(InvoiceStatus);module.exports=exports['default'];

/***/ }),
/* 2006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Label=exports.ListFooter=exports.ListContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n        li:last-of-type {\n            border-bottom: 0 !important;\n        }\n    '],['\n        li:last-of-type {\n            border-bottom: 0 !important;\n        }\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        justify-content: center;\n        width: ',';\n    '],['\n        justify-content: center;\n        width: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ListContainer=exports.ListContainer=_styledComponents2.default.ul.withConfig({displayName:'styles__ListContainer',componentId:'sc-7lzo0m-0'})(['list-style:none;margin:0;padding:0;',';'],_media2.default.small(_templateObject));var ListFooter=exports.ListFooter=_styledComponents2.default.div.withConfig({displayName:'styles__ListFooter',componentId:'sc-7lzo0m-1'})(['',' display:flex;justify-content:flex-start;padding:',' ',';',';'],_content2.default,(0,_rem2.default)('40px'),(0,_rem2.default)('30px'),_media2.default.small(_templateObject2,(0,_rem2.default)('180px')));var Label=exports.Label=_styledComponents2.default.label.withConfig({displayName:'styles__Label',componentId:'sc-7lzo0m-2'})(['color:',';font-family:OpenSans;font-size:',';font-weight:200;letter-spacing:',';line-height:1;pointer-events:none;text-transform:uppercase;white-space:nowrap;display:block;margin-bottom:',';',';',';'],_colors.darkGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('0.4px'),(0,_rem2.default)('15px'),function(props){return props.right&&'\n      text-align: right;\n      padding-right: 50px;\n    ';},function(props){return props.marginStatus&&'\n        margin-left: 70px;\n      ';});

/***/ }),
/* 2007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BoxHeader=exports.Heading=exports.Paragraph=exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n        margin: ',' auto;\n    '],['\n        margin: ',' auto;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        width: ',';\n        margin: 0;\n    '],['\n        width: ',';\n        margin: 0;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n    ','\n    margin: ',' 0;\n  '],['\n    ','\n    margin: ',' 0;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-2up0oe-0'})(['',';margin:',' auto;',';'],_content2.default,(0,_rem2.default)('42px'),_media2.default.small(_templateObject,(0,_rem2.default)('29px')));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-2up0oe-1'})(['',' color:',';margin-top:',';',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('7px'),_media2.default.large(_templateObject2,(0,_rem2.default)('313px')));var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-2up0oe-2'})(['',' color:',';font-size:40px;font-weight:bold;line-height:normal;letter-spacing:0.4px;margin:0;',';'],_types.title24Galano,_colors.darkSlateBlue,_media2.default.small(_templateObject3,_types.title18Galano,(0,_rem2.default)('8px')));var BoxHeader=exports.BoxHeader=_styledComponents2.default.div.withConfig({displayName:'styles__BoxHeader',componentId:'sc-2up0oe-3'})(['display:flex;justify-content:space-between;margin-bottom:40px;flex-direction:column;']);

/***/ }),
/* 2008 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Minha Veloe - Faturas","invoiceTitle":"Faturas","invoiceDescription":"Veja abaixo suas faturas:","noInvoiceTitle":"Ops!","noInvoiceDescription":"Você não tem faturas a serem exibidas.","boletoModalTitle":"Seu boleto está a caminho!","boletoModalBody":"Você vai receber em até 2 dias úteis no seu e-mail e também poderá consultar no site ou app.","boletoModalNoEmailBody":"Em até 2 dias úteis você poderá consultar no site ou app.","boletoUnavailableModalTitle":"Boleto ainda não disponível","boletoUnavailableModalBody":"Boleto já foi solicitado previamente. Favor aguardar o prazo informado."}

/***/ }),
/* 2009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardIdentifiers/index.js';var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _actions=__webpack_require__(13);var _actions2=__webpack_require__(36);var _IdentifiersList=__webpack_require__(650);var _IdentifiersList2=_interopRequireDefault(_IdentifiersList);var _styles=__webpack_require__(652);var _SearchForm=__webpack_require__(402);var _SearchForm2=_interopRequireDefault(_SearchForm);var _ManageInfoModal=__webpack_require__(189);var _ManageInfoModal2=_interopRequireDefault(_ManageInfoModal);var _icLoading=__webpack_require__(653);var _icLoading2=_interopRequireDefault(_icLoading);var _Icon=__webpack_require__(31);var _data=__webpack_require__(2018);var _TotalIdentifiersCard=__webpack_require__(2019);var _TotalIdentifiersCard2=_interopRequireDefault(_TotalIdentifiersCard);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Services and Actions
// Components
// Assets
var DashboardIdentifiers=function(_Component){_inherits(DashboardIdentifiers,_Component);function DashboardIdentifiers(props){var _this2=this;_classCallCheck(this,DashboardIdentifiers);var _this=_possibleConstructorReturn(this,(DashboardIdentifiers.__proto__||Object.getPrototypeOf(DashboardIdentifiers)).call(this,props));_this.componentDidUpdate=function(prevProps,prevState){var vehicles=_this.props.vehicles;if(prevProps.vehicles!==vehicles&&vehicles.length>0){_this._prepareVehiclesList();}};_this._prepareVehiclesList=function(){var _this$props=_this.props,vehicles=_this$props.vehicles,setLoading=_this$props.setLoading;var listGrowNumber=_this.state.listGrowNumber;var newVehicles=_this.handleSortIdentifier(vehicles);if(newVehicles.length>listGrowNumber){_this.setState({identifiersList:newVehicles.slice(0,listGrowNumber)});}else{_this.setState({identifiersList:newVehicles});}setLoading(false);};_this.handleSearchChange=function(_ref){var target=_ref.target;_this.setState({searchText:target.value});};_this.handleSelectItem=function(item){return function(){var itemsSelected=_this.state.itemsSelected;var newArray=void 0;var hasItem=itemsSelected.findIndex(function(_ref2){var idIdentificador=_ref2.idIdentificador;return item.idIdentificador===idIdentificador;})!==-1;if(hasItem){newArray=itemsSelected.filter(function(_ref3){var idIdentificador=_ref3.idIdentificador;return item.idIdentificador!==idIdentificador;});return _this.setState({itemsSelected:newArray});}newArray=[].concat(_toConsumableArray(itemsSelected),[item]);_this.setState({itemsSelected:newArray});};};_this.handleSelectAll=function(){var _this$state=_this.state,itemsSelected=_this$state.itemsSelected,identifiersList=_this$state.identifiersList;if(itemsSelected.length===identifiersList.length){return _this.setState({itemsSelected:[]});}_this.setState({itemsSelected:identifiersList});};_this.loadMoreItems=function(){var _this$state2=_this.state,identifiersList=_this$state2.identifiersList,listGrowNumber=_this$state2.listGrowNumber;var vehicles=_this.props.vehicles;var newVehicles=_this.handleSortIdentifier(vehicles);if(newVehicles.length!==identifiersList.length){_this.setState({isLoadingMoreItems:true});setTimeout(function(){return _this.setState({isLoadingMoreItems:false,identifiersList:newVehicles.slice(0,identifiersList.length+listGrowNumber)});},400);}};_this.handleModalCreateInfo=function(vehicle){_this.setState({modalOpen:true,vehicle:vehicle});};_this.handleCloseModal=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _this$props2,match,history,fetchVehicles,id;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({modalOpen:false,vehicle:{}});_this$props2=_this.props,match=_this$props2.match,history=_this$props2.history,fetchVehicles=_this$props2.fetchVehicles;id=match.params.id;_context.next=5;return fetchVehicles(history,id);case 5:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleSortIdentifier=function(vehicle){var newVehicle=vehicle.map(function(item){item.order=_this.getWarnTags(item.codIdentificador)?-1:1;return item;});newVehicle.sort(function(a,b){return a.order-b.order;});return newVehicle;};_this.getWarnTags=function(identifierId){var listTagsWarn=JSON.parse(sessionStorage.getItem('warnTags'));return listTagsWarn&&listTagsWarn.tags&&listTagsWarn.tags.includes(parseInt(identifierId));};_this.handleGetVehicle=function(identifierNumber,next){_this.props.dispatch((0,_actions.fetchFilterVehicles)(identifierNumber)).then(function(resp){var _ref5=resp||[],_ref6=_slicedToArray(_ref5,1),_ref6$=_ref6[0],identifier=_ref6$===undefined?{}:_ref6$;if(identifier.codIdentificador){_this.setState({identifiersList:[identifier]});}});};_this.state={itemsSelected:[],searchText:'',identifiersList:[],listGrowNumber:20,isLoadingMoreItems:false,modalOpen:false,vehicle:{}};return _this;}_createClass(DashboardIdentifiers,[{key:'componentDidMount',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var _props,setLoading,match,history,fetchVehicles,_props$account,account,id,wl,pc,isWhiteLabel;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_props=this.props,setLoading=_props.setLoading,match=_props.match,history=_props.history,fetchVehicles=_props.fetchVehicles,_props$account=_props.account,account=_props$account===undefined?{}:_props$account;setLoading(true);id=match.params.id;// const { wl: isWhiteLabel = false } = account
wl=account.wl,pc=account.pc;if(!pc){_context2.next=7;break;}this.props.history.push('/minha-veloe/'+id+'/identificadores-parceiro');return _context2.abrupt('return');case 7:isWhiteLabel=wl||pc||false;if(isWhiteLabel){_context2.next=13;break;}_context2.next=11;return fetchVehicles(history,id);case 11:_context2.next=14;break;case 13:setLoading(false);case 14:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidMount(){return _ref7.apply(this,arguments);}return componentDidMount;}()// Checkbox
// Infinity List
// Modal
},{key:'render',value:function render(){var _this3=this;var _state=this.state,searchText=_state.searchText,itemsSelected=_state.itemsSelected,identifiersList=_state.identifiersList,isLoadingMoreItems=_state.isLoadingMoreItems,modalOpen=_state.modalOpen,vehicle=_state.vehicle;var _props2=this.props,vehicles=_props2.vehicles,_props2$account=_props2.account,account=_props2$account===undefined?{}:_props2$account,match=_props2.match;// const { wl: isWhiteLabel = false } = account
var wl=account.wl,pc=account.pc;var isWhiteLabel=wl||pc||false;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:197}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:198}}),!isWhiteLabel&&(!identifiersList||identifiersList.length===0)?_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:200}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:201}},_data.noIdentifierTitle),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:202}},_data.noIdentifierDescription)):_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:205}},_react2.default.createElement(_styles.SubHeader,{__source:{fileName:_jsxFileName,lineNumber:206}},_react2.default.createElement(_styles.HeadingContent,{__source:{fileName:_jsxFileName,lineNumber:207}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:208}},isWhiteLabel?'Consultar VeloeTag':_data.identifiersTitle),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:209}},isWhiteLabel?'Pesquise por número de VeloeTag para ver detalhes do dispositivo':_data.identifiersDescription)),_react2.default.createElement(_styles.SearchBox,{__source:{fileName:_jsxFileName,lineNumber:216}},_react2.default.createElement(_styles.CardAndIconWrap,{__source:{fileName:_jsxFileName,lineNumber:217}},_react2.default.createElement(_TotalIdentifiersCard2.default,{account:match.params.id,__source:{fileName:_jsxFileName,lineNumber:218}}),_react2.default.createElement(_styles.ButtonIcon,{alt:'Download Informa\xE7\xF5es Adesivos em CSV',title:'Download Informa\xE7\xF5es Adesivos em CSV',__source:{fileName:_jsxFileName,lineNumber:219}},_react2.default.createElement(_Icon.Icon,{icon:'download',svgStyle:_styles.iconColor,width:'31',height:'31',viewBox:'0 0 70 70',onClick:function onClick(){_this3.props.downloadCSVVehicles(match.params.id);},__source:{fileName:_jsxFileName,lineNumber:223}}))),isWhiteLabel?_react2.default.createElement(_SearchForm2.default,{width:'100%',value:searchText,onChange:this.handleSearchChange,onSearch:function onSearch(){return _this3.handleGetVehicle(searchText,false);},placeholder:'Pesquise por n\xFAmero da VeloeTag',__source:{fileName:_jsxFileName,lineNumber:237}}):_react2.default.createElement(_SearchForm2.default,{width:'100%',value:searchText,onChange:this.handleSearchChange,placeholder:'Busque pela placa, VeloeTag ou Informa\xE7\xE3o gerencial',__source:{fileName:_jsxFileName,lineNumber:245}}))),isWhiteLabel?_react2.default.createElement(_IdentifiersList2.default,{handleCreateInf:this.handleModalCreateInfo,checkboxValues:itemsSelected,handleLoadMoreItems:function handleLoadMoreItems(){},handleSelectItem:this.handleSelectItem,handleSelectAll:this.handleSelectAll,identifiers:identifiersList,__source:{fileName:_jsxFileName,lineNumber:256}}):_react2.default.createElement(_IdentifiersList2.default,{handleCreateInf:this.handleModalCreateInfo,checkboxValues:itemsSelected,handleLoadMoreItems:this.loadMoreItems,handleSelectItem:this.handleSelectItem,handleSelectAll:this.handleSelectAll,identifiers:searchText&&searchText.length>=3?(0,_SearchForm.searchFilter)(searchText,vehicles):identifiersList,__source:{fileName:_jsxFileName,lineNumber:265}}),isLoadingMoreItems&&_react2.default.createElement(_styles.LoadingContainer,{__source:{fileName:_jsxFileName,lineNumber:279}},_react2.default.createElement(_icLoading2.default,{__source:{fileName:_jsxFileName,lineNumber:280}}),_react2.default.createElement(_styles.LoadingText,{__source:{fileName:_jsxFileName,lineNumber:281}},'Carregando')),modalOpen&&_react2.default.createElement(_ManageInfoModal2.default,{vehicle:vehicle,isOpen:modalOpen,modalStart:'include',toggleModal:this.handleCloseModal,__source:{fileName:_jsxFileName,lineNumber:285}})));}}]);return DashboardIdentifiers;}(_react.Component);var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref8){var reducer=_ref8.reducer;return{vehicles:reducer.dashboardVehicles,accountPlans:reducer.accountPlans,account:reducer.account};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchVehicles:function fetchVehicles(history,accountId){return dispatch((0,_actions.fetchGetVehicles)(accountId)).then(function(resp){if(resp&&(resp.status===401||resp.status===403)){dispatch((0,_actions.fetchLogout)());history.push('/conta/login');}dispatch((0,_actions2.setLoading)(false));});},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));},downloadCSVVehicles:function downloadCSVVehicles(planId){return dispatch((0,_actions.downloadVehiclesFileCSV)(planId)).finally(function(){return dispatch((0,_actions2.setLoading)(false));});},dispatch:dispatch};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DashboardIdentifiers);

/***/ }),
/* 2010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/IdentifiersList/Dropdown/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _propTypes2=_interopRequireDefault(_propTypes);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _styles=__webpack_require__(2011);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function Dropdown(_ref){var categoryLabel=_ref.categoryLabel,dropdownLabel=_ref.dropdownLabel,onClick=_ref.onClick,isOpen=_ref.isOpen;return _react2.default.createElement(_styles.DropdownContainer,{isOpen:isOpen,onClick:onClick,__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement(_styles.DropdownLabelContainer,{__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement(_styles.HeaderLabel,{isOpen:isOpen,__source:{fileName:_jsxFileName,lineNumber:17}},categoryLabel),_react2.default.createElement(_Icon2.default,{icon:'dropdown-arrow',svgStyle:_styles.DropdownArrow,width:'12',height:'7',viewBox:'0 0 12 7',__source:{fileName:_jsxFileName,lineNumber:18}})),_react2.default.createElement(_styles.DropdownLabel,{__source:{fileName:_jsxFileName,lineNumber:27}},dropdownLabel));}Dropdown.defaultProps={categoryLabel:'',dropdownLabel:'',headerLabelCategory:'',onClick:null};Dropdown.propTypes={categoryLabel:_propTypes2.default.string,dropdownLabel:_propTypes2.default.string,headerLabelCategory:_propTypes2.default.string,onClick:_propTypes2.default.func};exports.default=Dropdown;module.exports=exports['default'];

/***/ }),
/* 2011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DropdownContainer=exports.HeaderLabel=exports.DropdownArrow=exports.DropdownLabelContainer=exports.DropdownLabel=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DropdownLabel=exports.DropdownLabel=_styledComponents2.default.p.withConfig({displayName:'styles__DropdownLabel',componentId:'sc-8enykg-0'})(['color:',';font-family:\'OpenSans\';font-size:',';font-weight:lighter;margin:0;min-width:',';user-select:none;text-transform:capitalize;'],_colors.darkBlue,(0,_rem2.default)('12px'),(0,_rem2.default)('60px'));var DropdownLabelContainer=exports.DropdownLabelContainer=_styledComponents2.default.div.withConfig({displayName:'styles__DropdownLabelContainer',componentId:'sc-8enykg-1'})(['align-items:center;display:flex;position:relative;']);var DropdownArrow=exports.DropdownArrow='height: 5px; width: 10px; stroke: '+_colors.linkNavyBlue;var HeaderLabel=exports.HeaderLabel=_styledComponents2.default.p.withConfig({displayName:'styles__HeaderLabel',componentId:'sc-8enykg-2'})(['',';margin:0;margin-right:',';line-height:1.67;letter-spacing:1.6px;text-align:left;color:',';text-transform:uppercase;'],_types.txt12OpenSansBold,(0,_rem2.default)('3px'),function(_ref){var isOpen=_ref.isOpen;return isOpen?_colors.linkNavyBlue:_colors.blueGray;});var DropdownContainer=exports.DropdownContainer=_styledComponents2.default.div.withConfig({displayName:'styles__DropdownContainer',componentId:'sc-8enykg-3'})(['cursor:pointer;margin:0;transition:all 0.5s;',';'],function(_ref2){var isOpen=_ref2.isOpen;return isOpen&&(0,_styledComponents.css)(['svg{color:',';transform:rotate(180deg);}'],_colors.darkGrey);});

/***/ }),
/* 2012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/IdentifiersListItem/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _reactRouterDom=__webpack_require__(15);var _DropdownList=__webpack_require__(264);var _DropdownList2=_interopRequireDefault(_DropdownList);var _DotButton=__webpack_require__(253);var _DotButton2=_interopRequireDefault(_DotButton);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _Tooltip=__webpack_require__(594);var _Tooltip2=_interopRequireDefault(_Tooltip);var _ToggleSwitch=__webpack_require__(651);var _ToggleSwitch2=_interopRequireDefault(_ToggleSwitch);var _icPlus=__webpack_require__(2014);var _icPlus2=_interopRequireDefault(_icPlus);var _styles=__webpack_require__(2015);var _apolloClient=__webpack_require__(42);var _vehicles=__webpack_require__(94);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// import Checkbox from 'app/elements/Checkbox'
var IdentifierListItem=function IdentifierListItem(_ref){var checkboxValues=_ref.checkboxValues,vehicle=_ref.vehicle,itemDropdownId=_ref.itemDropdownId,history=_ref.history,isItemDropdownOpen=_ref.isItemDropdownOpen,handleSelectItem=_ref.handleSelectItem,handleItemDropdown=_ref.handleItemDropdown,handleItemDropdownClose=_ref.handleItemDropdownClose,handleCreateInf=_ref.handleCreateInf,itemStatus=_ref.itemStatus,isPartner=_ref.isPartner,changeTagIdentifiers=_ref.changeTagIdentifiers,idConta=_ref.idConta;var idIdentificador=vehicle.idIdentificador,veiculo=vehicle.veiculo,situacao=vehicle.situacao,codIdentificador=vehicle.codIdentificador,informacoesGerenciais=vehicle.informacoesGerenciais;var active=situacao==='ATIVO';var carPlate=veiculo.placa;var identifierId=codIdentificador;var carCategory=veiculo.categoria;var carType=veiculo.tipo==='CAMINHAO'?'Caminhão':veiculo.tipo;var sortedInfos=sortedInformations(informacoesGerenciais);// const isChecked = !!checkboxValues.find(item => item.idIdentificador === idIdentificador)
var renderIndexInfoManage=function renderIndexInfoManage(tipo){return tipo==='INFORMACAO_1'?1:tipo==='INFORMACAO_2'?2:3;};var loadingPap=false;function onUnload(){loadingPap=true;}window.addEventListener('beforeunload',onUnload);function sortedInformations(informations){return informations==null?null:informations.sort(function(a,b){return a.tipoInfo.toLowerCase()<b.tipoInfo.toLowerCase()?-1:1;});}function getWarnTags(identifierId){var listTagsWarn=JSON.parse(sessionStorage.getItem('warnTags'));if(listTagsWarn&&listTagsWarn.tags&&listTagsWarn.tags.includes(parseInt(identifierId)))return listTagsWarn.tags;return false;}var togglePap=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(checked){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:vehicle.pap=checked?1:0;changeTagIdentifiers(vehicle);_context.prev=2;_context.next=5;return(0,_apolloClient.gqlMutate)(_vehicles.gqlModificarPapIndividual,{idConta:idConta,adesaoPap:checked,identificador:vehicle.codIdentificador,placa:veiculo.placa});case 5:changeTagIdentifiers(vehicle);_context.next=13;break;case 8:_context.prev=8;_context.t0=_context['catch'](2);vehicle.pap=!checked?1:0;changeTagIdentifiers(vehicle);if(!loadingPap){alert('Problema ao executar pap');}else{loadingPap=false;window.removeEventListener('beforeunload',undefined.onUnload);}case 13:case'end':return _context.stop();}}},_callee,undefined,[[2,8]]);}));return function togglePap(_x){return _ref2.apply(this,arguments);};}();return _react2.default.createElement(_styles.ListItem,{blocked:!!active,warn:!getWarnTags(identifierId),__source:{fileName:_jsxFileName,lineNumber:92}},_react2.default.createElement(_gridStyled.Flex,{width:1,direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:93}},_react2.default.createElement(_gridStyled.Box,{width:[3/12,2/12],__source:{fileName:_jsxFileName,lineNumber:99}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:100}},getWarnTags(identifierId)&&_react2.default.createElement(_Tooltip2.default,{text:'Esta tag precisa ser trocada.',tooltipColor:'#e5b200',showTooltip:true,__source:{fileName:_jsxFileName,lineNumber:102}},_react2.default.createElement(_Icon2.default,{style:{marginRight:'5px'},height:14,icon:'alertTag',viewBox:'0 0 16 16',display:'flex',__source:{fileName:_jsxFileName,lineNumber:103}})),_react2.default.createElement(_styles.LineText,{capitalize:true,bold:true,__source:{fileName:_jsxFileName,lineNumber:112}},carType.toLowerCase()))),_react2.default.createElement(_gridStyled.Box,{width:[3/12,2/12],__source:{fileName:_jsxFileName,lineNumber:117}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:118}},_react2.default.createElement(_styles.LineText,{__source:{fileName:_jsxFileName,lineNumber:119}},carPlate))),_react2.default.createElement(_Hide2.default,{at:'small',width:[1,2/12],__source:{fileName:_jsxFileName,lineNumber:122}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:123}},_react2.default.createElement(_styles.LineText,{__source:{fileName:_jsxFileName,lineNumber:124}},carCategory))),_react2.default.createElement(_gridStyled.Box,{width:[3/12,2/12],__source:{fileName:_jsxFileName,lineNumber:127}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:128}},_react2.default.createElement(_styles.LineText,{__source:{fileName:_jsxFileName,lineNumber:129}},identifierId))),_react2.default.createElement(_gridStyled.Box,{width:[3/12,3/12],__source:{fileName:_jsxFileName,lineNumber:132}},_react2.default.createElement(_styles.ChipContainer,{__source:{fileName:_jsxFileName,lineNumber:133}},!sortedInfos||sortedInfos.length===0?_react2.default.createElement(_styles.ChipEmpty,{onClick:function onClick(){return handleCreateInf(vehicle);},__source:{fileName:_jsxFileName,lineNumber:135}},_react2.default.createElement(_icPlus2.default,{__source:{fileName:_jsxFileName,lineNumber:136}}),' Add Informa\xE7\xE3o'):sortedInfos.map(function(item,i){return _react2.default.createElement(_styles.Chip,{key:i,__source:{fileName:_jsxFileName,lineNumber:140}},renderIndexInfoManage(item.tipoInfo),'. ',item.descricaoAtual);}))),isPartner&&_react2.default.createElement(_gridStyled.Box,{width:[3/12,2/12],style:{paddingTop:'15px'},__source:{fileName:_jsxFileName,lineNumber:148}},_react2.default.createElement(_ToggleSwitch2.default,{checked:vehicle.pap===1,label:vehicle.pap===1?'Ativo':'Inativo',name:'pap',togglePap:togglePap,__source:{fileName:_jsxFileName,lineNumber:149}})),_react2.default.createElement(_gridStyled.Box,{width:[1,0.5/12],__source:{fileName:_jsxFileName,lineNumber:157}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:158}},_react2.default.createElement(_DotButton2.default,{onClick:handleItemDropdown(idIdentificador),__source:{fileName:_jsxFileName,lineNumber:159}}),_react2.default.createElement(_DropdownList2.default,{secondary:true,isOpen:isItemDropdownOpen&&itemDropdownId===idIdentificador,onClose:handleItemDropdown(),__source:{fileName:_jsxFileName,lineNumber:160}},itemStatus!=='INATIVO'&&!isPartner&&_react2.default.createElement(_DropdownList.ListItem,{onClick:function onClick(){return history.push('identificador/'+identifierId+'/bloquear');},__source:{fileName:_jsxFileName,lineNumber:167}},'Bloquear / Substituir'),_react2.default.createElement(_DropdownList.ListItem,{onClick:function onClick(){return history.push('identificador/'+identifierId+'/alterar');},__source:{fileName:_jsxFileName,lineNumber:173}},'Gerenciar informa\xE7\xF5es'))))));};IdentifierListItem.defaultProps={checkboxValues:[],vehicle:{},handleSelectItem:function handleSelectItem(){},itemDropdownId:0,isItemDropdownOpen:false,handleItemDropdown:function handleItemDropdown(){},handleItemDropdownClose:function handleItemDropdownClose(){},handleCreateInf:function handleCreateInf(){}};exports.default=(0,_reactRouterDom.withRouter)(IdentifierListItem);module.exports=exports['default'];

/***/ }),
/* 2013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Input=exports.Label=exports.Slider=exports.Text=exports.SwitchContainer=exports.Container=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-cz9gm3-0'})(['width:56px;height:56px;border-radius:60px;display:flex;background-color:',';justify-content:center;align-items:center;cursor:pointer;'],function(props){return props.checked?_colors.lightBlue:_colors.paleGray;});var SwitchContainer=exports.SwitchContainer=_styledComponents2.default.div.withConfig({displayName:'styles__SwitchContainer',componentId:'sc-cz9gm3-1'})(['user-select:none;position:relative;display:inline-block;width:30px;height:17px;.slider{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:',';-webkit-transition:0.4s;transition:0.4s;}.slider:before{position:absolute;content:\'\';height:13px;width:13px;left:4px;bottom:4px;background-color:white;-webkit-transition:0.4s;transition:0.4s;}input:checked + .slider{background-color:',';}input:focus + .slider{box-shadow:0 0 1px ',';}input:checked + .slider:before{-webkit-transform:translateX(13px);-ms-transform:translateX(13px);transform:translateX(13px);}.slider.round{border-radius:17px;}.slider.round:before{border-radius:50%;}'],_colors.paleGray,_colors.darkSlateBlue,_colors.darkSlateBlue);var Text=exports.Text=_styledComponents2.default.span.withConfig({displayName:'styles__Text',componentId:'sc-cz9gm3-2'})(['',';font-weight:bold;text-align:center;color:',';'],_types.txt16OpenSans,function(props){return props.checked?_colors.white:_colors.lightSilver;});var Slider=exports.Slider=_styledComponents2.default.span.withConfig({displayName:'styles__Slider',componentId:'sc-cz9gm3-3'})(['']);var Label=exports.Label=_styledComponents2.default.label.withConfig({displayName:'styles__Label',componentId:'sc-cz9gm3-4'})(['user-select:none;margin-left:40px;']);var Input=exports.Input=_styledComponents2.default.input.withConfig({displayName:'styles__Input',componentId:'sc-cz9gm3-5'})(['display:none;']);

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-plus.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IcPlus=function IcPlus(props){return _react2.default.createElement("svg",_extends({width:"1em",height:"1em",viewBox:"0 0 24 24"},props,{__source:{fileName:_jsxFileName,lineNumber:4}}),_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{id:"prefix__a",d:"M11 11V7a1 1 0 0 1 2 0v4h4a1 1 0 0 1 0 2h-4v4a1 1 0 0 1-2 0v-4H7a1 1 0 0 1 0-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-1a9 9 0 1 0 0-18 9 9 0 0 0 0 18z",__source:{fileName:_jsxFileName,lineNumber:6}})),_react2.default.createElement("g",{fill:"none",fillRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement("mask",{id:"prefix__b",fill:"#fff",__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement("use",{xlinkHref:"#prefix__a",__source:{fileName:_jsxFileName,lineNumber:13}})),_react2.default.createElement("use",{fill:"#27C2D5",fillRule:"nonzero",xlinkHref:"#prefix__a",__source:{fileName:_jsxFileName,lineNumber:15}}),_react2.default.createElement("g",{fill:"#D8D7E1",mask:"url(#prefix__b)",__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement("path",{d:"M0 0h24v24H0z",__source:{fileName:_jsxFileName,lineNumber:17}}))));};exports.default=IcPlus;module.exports=exports["default"];

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ChipEmpty=exports.Chip=exports.ChipContainer=exports.ListItem=exports.LineText=exports.LineTextContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  '],['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LineTextContainer=exports.LineTextContainer=_styledComponents2.default.div.withConfig({displayName:'styles__LineTextContainer',componentId:'sc-dnzy85-0'})(['display:flex;align-items:center;min-height:100%;position:relative;div > span{transform:translateX(-51%) !important;top:140% !important;}']);var LineText=exports.LineText=_styledComponents2.default.div.withConfig({displayName:'styles__LineText',componentId:'sc-dnzy85-1'})(['',';font-weight:normal;line-height:1.5;letter-spacing:normal;text-align:left;color:',';display:block;',';',';',';'],_types.txt16OpenSans,_colors.darkSlateBlue,function(_ref){var capitalize=_ref.capitalize;return capitalize&&(0,_styledComponents.css)(['text-transform:capitalize;']);},function(_ref2){var uppercase=_ref2.uppercase;return uppercase&&(0,_styledComponents.css)(['text-transform:uppercase;font-size:12px;font-weight:bold;letter-spacing:1.6px;']);},function(_ref3){var bold=_ref3.bold;return bold&&(0,_styledComponents.css)(['font-weight:bold;']);});var ListItem=exports.ListItem=_styledComponents2.default.div.withConfig({displayName:'styles__ListItem',componentId:'sc-dnzy85-2'})(['display:block;padding:',' 0 ',';border-bottom:',' solid ',';',';',';',';'],(0,_rem2.default)('18px'),(0,_rem2.default)('18px'),(0,_rem2.default)('1px'),_colors.paleGrayTwo,_media2.default.small(_templateObject,(0,_rem2.default)('13px')),function(props){return!props.blocked&&(0,_styledComponents.css)(['border-bottom:',' solid ',';','{color:',';}'],(0,_rem2.default)('4px'),_colors.red,LineText,_colors.red);},function(props){return!props.warn&&(0,_styledComponents.css)(['border-bottom:',' solid ',';','{font-weight:bold;color:',';}'],(0,_rem2.default)('2px'),_colors.posYellow,LineText,_colors.posYellow);});var ChipContainer=exports.ChipContainer=(0,_styledComponents2.default)(LineTextContainer).withConfig({displayName:'styles__ChipContainer',componentId:'sc-dnzy85-3'})(['flex-wrap:wrap;& span:nth-child(1),& span:nth-child(2){margin-right:',';}'],(0,_rem2.default)('5px'));var Chip=exports.Chip=_styledComponents2.default.span.withConfig({displayName:'styles__Chip',componentId:'sc-dnzy85-4'})(['',';color:',';background-color:',';padding:',' ',';border-radius:',';margin-top:',';'],_types.txt12OpenSansBold,_colors.white,_colors.tealish,(0,_rem2.default)('3px'),(0,_rem2.default)('10px'),(0,_rem2.default)('15px'),(0,_rem2.default)('5px'));var ChipEmpty=exports.ChipEmpty=_styledComponents2.default.a.withConfig({displayName:'styles__ChipEmpty',componentId:'sc-dnzy85-5'})(['',';background-color:',';padding:',' ',';cursor:pointer;text-transform:uppercase;border-radius:',';border:solid 1px ',';color:',';transition:all 0.3s;svg{font-size:',';margin-right:',';path{fill:',';}}&:hover{background-color:',';color:',';svg{path{fill:',';}}}'],_types.txt12OpenSansBold,_colors.paleGray,(0,_rem2.default)('3px'),(0,_rem2.default)('10px'),(0,_rem2.default)('15px'),_colors.darkGrey,_colors.darkGrey,(0,_rem2.default)('18px'),(0,_rem2.default)('4px'),_colors.darkGrey,_colors.darkGrey,_colors.paleGray,_colors.paleGray);

/***/ }),
/* 2016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DropdownBox=exports.ListItem=exports.ListContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n        li:last-of-type {\n            border-bottom: 0 !important;\n        }\n    '],['\n        li:last-of-type {\n            border-bottom: 0 !important;\n        }\n    ']),_templateObject2=_taggedTemplateLiteral(['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  '],['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _gridStyled=__webpack_require__(8);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ListContainer=exports.ListContainer=_styledComponents2.default.ul.withConfig({displayName:'styles__ListContainer',componentId:'sc-xdl2bz-0'})(['list-style:none;margin:15px 0 0;padding:0;',';'],_media2.default.small(_templateObject));var ListItem=exports.ListItem=_styledComponents2.default.div.withConfig({displayName:'styles__ListItem',componentId:'sc-xdl2bz-1'})(['display:block;padding:',' 0 ',';border-bottom:',' solid ',';',';line-height:1.67;letter-spacing:1.6px;text-align:left;color:',';text-transform:uppercase;',';'],(0,_rem2.default)('18px'),(0,_rem2.default)('18px'),(0,_rem2.default)('1px'),_colors.paleGrayTwo,_types.txt12OpenSansBold,_colors.blueGray,_media2.default.small(_templateObject2,(0,_rem2.default)('13px')));var DropdownBox=exports.DropdownBox=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'styles__DropdownBox',componentId:'sc-xdl2bz-2'})(['position:relative;']);

/***/ }),
/* 2017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SearchImg=exports.SearchButton=exports.Form=exports.SearchField=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var SearchField=exports.SearchField=_styledComponents2.default.input.withConfig({displayName:'styles__SearchField',componentId:'sc-chlu6t-0'})(['',';border:none;color:',';width:100%;&::-webkit-input-placeholder{color:',';}&:focus{outline:none;}'],_types.txt16OpenSans,_colors.darkBlue,_colors.blueGray);var Form=exports.Form=_styledComponents2.default.form.withConfig({displayName:'styles__Form',componentId:'sc-chlu6t-1'})(['width:',';display:inline-flex;align-items:center;justify-content:center;padding:',' ',';border:1px solid ',';border-radius:',';transition:all 0.3s;&:focus-within{border-color:',';}'],function(_ref){var width=_ref.width;return width||'53%';},(0,_rem2.default)('8px'),(0,_rem2.default)('15px'),_colors.grey,(0,_rem2.default)('30px'),_colors.darkBlue);var SearchButton=exports.SearchButton=_styledComponents2.default.button.withConfig({displayName:'styles__SearchButton',componentId:'sc-chlu6t-2'})(['border:none;&:focus{outline:none;}&:active{transform:translateX(10px);}']);var SearchImg=exports.SearchImg=_styledComponents2.default.img.withConfig({displayName:'styles__SearchImg',componentId:'sc-chlu6t-3'})(['width:auto;height:auto;']);

/***/ }),
/* 2018 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Minha Veloe - VeloeTags","identifiersTitle":"Minhas VeloeTags","identifiersDescription":"Veja abaixo a sua lista de veículos ativados:","btnFollow":"Meus pedidos","btnActivation":"Ativar novo veículo","btnNewTag":"Solicitar VeloeTag","noIdentifierTitle":"Ops","noIdentifierDescription":"Você não tem VeloeTags a serem exibidas."}

/***/ }),
/* 2019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardIdentifiers/TotalIdentifiersCard.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(652);var _adesivoVeloe=__webpack_require__(620);var _adesivoVeloe2=_interopRequireDefault(_adesivoVeloe);var _loading=__webpack_require__(100);var _loading2=_interopRequireDefault(_loading);var _vehicles=__webpack_require__(94);var _apolloClient=__webpack_require__(42);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TotalIdentifiersCard=function(_Component){_inherits(TotalIdentifiersCard,_Component);function TotalIdentifiersCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TotalIdentifiersCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TotalIdentifiersCard.__proto__||Object.getPrototypeOf(TotalIdentifiersCard)).call.apply(_ref,[this].concat(args))),_this),_this.state={totalTags:'carregando...',loading:true},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TotalIdentifiersCard,[{key:'componentDidMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _ref3,paginacao;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_apolloClient.gqlQuery)(_vehicles.gqlTotalIdentificadores,{idConta:this.props.account});case 2:_ref3=_context.sent;paginacao=_ref3.data.identificadoresPJV2.paginacao;this.setState({totalTags:paginacao.total||0,loading:false});case 5:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref2.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _state=this.state,loading=_state.loading,totalTags=_state.totalTags;return _react2.default.createElement(_styles.IdentifiersCardWrapper,{__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_styles.IdentifiersCardLabel,{__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:30}},loading?_react2.default.createElement('img',{alt:'carregando...',width:'20px',height:'20px',src:_loading2.default,__source:{fileName:_jsxFileName,lineNumber:32}}):totalTags),_react2.default.createElement('p',{__source:{fileName:_jsxFileName,lineNumber:37}},'Adesivos ativos')),_react2.default.createElement('img',{src:_adesivoVeloe2.default,alt:'Adesivos',__source:{fileName:_jsxFileName,lineNumber:39}}));}}]);return TotalIdentifiersCard;}(_react.Component);exports.default=TotalIdentifiersCard;module.exports=exports['default'];

/***/ }),
/* 2020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardIdentifiersPartner/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _actions=__webpack_require__(36);var _IdentifiersList=__webpack_require__(650);var _IdentifiersList2=_interopRequireDefault(_IdentifiersList);var _styles=__webpack_require__(2021);var _SearchForm=__webpack_require__(402);var _SearchForm2=_interopRequireDefault(_SearchForm);var _ManageInfoModal=__webpack_require__(189);var _ManageInfoModal2=_interopRequireDefault(_ManageInfoModal);var _icLoading=__webpack_require__(653);var _icLoading2=_interopRequireDefault(_icLoading);var _apolloClient=__webpack_require__(42);var _vehicles=__webpack_require__(94);var _data=__webpack_require__(2022);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Services and Actions
// Components
// Assets
var DashboardIdentifiersPartners=function(_Component){_inherits(DashboardIdentifiersPartners,_Component);function DashboardIdentifiersPartners(props){var _this2=this;_classCallCheck(this,DashboardIdentifiersPartners);var _this=_possibleConstructorReturn(this,(DashboardIdentifiersPartners.__proto__||Object.getPrototypeOf(DashboardIdentifiersPartners)).call(this,props));_this.componentDidUpdate=function(prevProps,prevState){var vehicles=_this.props.vehicles;if(prevProps.vehicles!==vehicles&&vehicles.length>0){_this._prepareVehiclesList();}};_this._prepareVehiclesList=function(){var _this$props=_this.props,vehicles=_this$props.vehicles,setLoading=_this$props.setLoading;var listGrowNumber=_this.state.listGrowNumber;var newVehicles=_this.handleSortIdentifier(vehicles);if(newVehicles.length>listGrowNumber){_this.setState({identifiersList:newVehicles.slice(0,listGrowNumber)});}else{_this.setState({identifiersList:newVehicles});}setLoading(false);};_this.handleSearchChange=function(_ref){var target=_ref.target;_this.setState({searchText:target.value});};_this.handleSelectItem=function(item){return function(){var itemsSelected=_this.state.itemsSelected;var newArray=void 0;var hasItem=itemsSelected.findIndex(function(_ref2){var idIdentificador=_ref2.idIdentificador;return item.idIdentificador===idIdentificador;})!==-1;if(hasItem){newArray=itemsSelected.filter(function(_ref3){var idIdentificador=_ref3.idIdentificador;return item.idIdentificador!==idIdentificador;});return _this.setState({itemsSelected:newArray});}newArray=[].concat(_toConsumableArray(itemsSelected),[item]);_this.setState({itemsSelected:newArray});};};_this.handleSelectAll=function(){var _this$state=_this.state,itemsSelected=_this$state.itemsSelected,identifiersList=_this$state.identifiersList;if(itemsSelected.length===identifiersList.length){return _this.setState({itemsSelected:[]});}_this.setState({itemsSelected:identifiersList});};_this.loadMoreItems=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var page,_ref5,identificadores,paginacao;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:page=_this.state.paginacao;if(!(page.proxima&&_this.state.isLoadingMoreItems===false)){_context.next=9;break;}_this.setState({isLoadingMoreItems:true});_context.next=5;return _this.props.fetchVehicles(_this.props.match.params.id,'','',null,page.proxima,page.quantidade);case 5:_ref5=_context.sent;identificadores=_ref5.identificadores;paginacao=_ref5.paginacao;setTimeout(function(){return _this.setState({identifiersList:[].concat(_toConsumableArray(_this.state.identifiersList),_toConsumableArray(identificadores)),paginacao:paginacao},function(){return _this.setState({isLoadingMoreItems:false});});},400);case 9:case'end':return _context.stop();}}},_callee,_this2);}));_this.handleModalCreateInfo=function(vehicle){_this.setState({modalOpen:true,vehicle:vehicle});};_this.handleCloseModal=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var _this$props2,match,history,fetchVehicles,id;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.setState({modalOpen:false,vehicle:{}});_this$props2=_this.props,match=_this$props2.match,history=_this$props2.history,fetchVehicles=_this$props2.fetchVehicles;id=match.params.id;_context2.next=5;return fetchVehicles(history,id);case 5:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.handleSortIdentifier=function(vehicle){var newVehicle=vehicle.map(function(item){item.order=_this.getWarnTags(item.codIdentificador)?-1:1;return item;});newVehicle.sort(function(a,b){return a.order-b.order;});return newVehicle;};_this.getWarnTags=function(identifierId){var listTagsWarn=JSON.parse(sessionStorage.getItem('warnTags'));return listTagsWarn&&listTagsWarn.tags&&listTagsWarn.tags.includes(parseInt(identifierId));};_this.handleGetVehicle=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(identifierNumber){var _ref8,identificadores,paginacao;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(identifierNumber.length>=3)){_context3.next=8;break;}_this.setState({identifiersList:[],isLoadingMoreItems:true});_context3.next=4;return _this.props.fetchVehicles(_this.props.match.params.id,identifierNumber,identifierNumber);case 4:_ref8=_context3.sent;identificadores=_ref8.identificadores;paginacao=_ref8.paginacao;_this.setState({identifiersList:identificadores,paginacao:paginacao},function(){return _this.setState({isLoadingMoreItems:false});});case 8:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x){return _ref7.apply(this,arguments);};}();_this.state={itemsSelected:[],searchText:'',identifiersList:[],listGrowNumber:20,isLoadingMoreItems:false,modalOpen:false,vehicle:{},paginacao:{}};return _this;}_createClass(DashboardIdentifiersPartners,[{key:'componentDidMount',value:function(){var _ref9=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(){return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:this.props.setLoading(false);case 1:case'end':return _context4.stop();}}},_callee4,this);}));function componentDidMount(){return _ref9.apply(this,arguments);}return componentDidMount;}()// Checkbox
// Infinity List
// Modal
},{key:'render',value:function render(){var _this3=this;var _state=this.state,searchText=_state.searchText,itemsSelected=_state.itemsSelected,identifiersList=_state.identifiersList,isLoadingMoreItems=_state.isLoadingMoreItems,modalOpen=_state.modalOpen,vehicle=_state.vehicle;var _props$account=this.props.account,account=_props$account===undefined?{}:_props$account;// const { wl: isWhiteLabel = false } = account
var wl=account.wl,pc=account.pc;var isWhiteLabel=wl||pc||false;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:181}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:182}}),!isWhiteLabel&&(!identifiersList||identifiersList.length===0)?_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:184}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:185}},_data.noIdentifierTitle),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:186}},_data.noIdentifierDescription)):_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:189}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:190}},isWhiteLabel?'Consultar VeloeTag':_data.identifiersTitle),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:191}},isWhiteLabel?'Pesquise por número de VeloeTag ou Placa para ver detalhes do dispositivo':_data.identifiersDescription),_react2.default.createElement(_styles.SearchBox,{__source:{fileName:_jsxFileName,lineNumber:196}},isWhiteLabel?_react2.default.createElement(_SearchForm2.default,{value:searchText,onChange:this.handleSearchChange,onSearch:function onSearch(){return _this3.handleGetVehicle(searchText);},placeholder:'Pesquise por n\xFAmero da VeloeTag ou Placa',__source:{fileName:_jsxFileName,lineNumber:198}}):_react2.default.createElement(_SearchForm2.default,{value:searchText,onChange:this.handleSearchChange,placeholder:'Busque pela placa, VeloeTag ou Informa\xE7\xE3o gerencial',__source:{fileName:_jsxFileName,lineNumber:205}})),!isWhiteLabel?_react2.default.createElement(_IdentifiersList2.default,{handleCreateInf:this.handleModalCreateInfo,checkboxValues:itemsSelected,handleLoadMoreItems:function handleLoadMoreItems(){},handleSelectItem:this.handleSelectItem,handleSelectAll:this.handleSelectAll,identifiers:identifiersList,__source:{fileName:_jsxFileName,lineNumber:213}}):_react2.default.createElement(_IdentifiersList2.default,{handleCreateInf:this.handleModalCreateInfo,checkboxValues:itemsSelected,handleLoadMoreItems:this.loadMoreItems,handleSelectItem:this.handleSelectItem,handleSelectAll:this.handleSelectAll,identifiers:identifiersList,isPartner:isWhiteLabel,idConta:this.props.match.params.id,__source:{fileName:_jsxFileName,lineNumber:222}}),isLoadingMoreItems&&_react2.default.createElement(_styles.LoadingContainer,{__source:{fileName:_jsxFileName,lineNumber:234}},_react2.default.createElement(_icLoading2.default,{__source:{fileName:_jsxFileName,lineNumber:235}}),_react2.default.createElement(_styles.LoadingText,{__source:{fileName:_jsxFileName,lineNumber:236}},'Carregando')),modalOpen&&_react2.default.createElement(_ManageInfoModal2.default,{vehicle:vehicle,isOpen:modalOpen,modalStart:'include',toggleModal:this.handleCloseModal,__source:{fileName:_jsxFileName,lineNumber:240}})));}}]);return DashboardIdentifiersPartners;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref10){var reducer=_ref10.reducer;return{vehicles:reducer.dashboardVehicles,accountPlans:reducer.accountPlans,account:reducer.account};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchVehicles:function(){var _ref11=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(idConta,placa,identificador,gerencial,pagina,quantidade){var _ref12,_ref12$data$identific,identificadores,paginacao;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return(0,_apolloClient.gqlQuery)(_vehicles.gqlIdentificadoresPaginado,{idConta:idConta,placa:placa,identificador:identificador,gerencial:gerencial,pagina:pagina,quantidade:quantidade});case 2:_ref12=_context5.sent;_ref12$data$identific=_ref12.data.identificadoresPJV2;identificadores=_ref12$data$identific.identificadores;paginacao=_ref12$data$identific.paginacao;return _context5.abrupt('return',{identificadores:identificadores,paginacao:paginacao});case 7:case'end':return _context5.stop();}}},_callee5,undefined);}));return function fetchVehicles(_x2,_x3,_x4,_x5,_x6,_x7){return _ref11.apply(this,arguments);};}(),setLoading:function setLoading(isLoading){dispatch((0,_actions.setLoading)(isLoading));},dispatch:dispatch};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DashboardIdentifiersPartners);module.exports=exports['default'];

/***/ }),
/* 2021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.LoadingText=exports.LoadingContainer=exports.SearchBox=exports.BoxHeader=exports.WrapperButtons=exports.Heading=exports.Paragraph=exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n      margin: ',' auto;\n  '],['\n      margin: ',' auto;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    width: ',';\n    margin: 0;\n  '],['\n    width: ',';\n    margin: 0;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    ','\n    margin: ',' 0;\n  '],['\n    ','\n    margin: ',' 0;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-1gyd69n-0'})(['',';margin:',' auto;',';'],_content2.default,(0,_rem2.default)('42px'),_media2.default.small(_templateObject,(0,_rem2.default)('29px')));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-1gyd69n-1'})(['',' color:',';width:',';margin-top:',';',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('270px'),(0,_rem2.default)('7px'),_media2.default.large(_templateObject2,(0,_rem2.default)('313px')));var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-1gyd69n-2'})(['',' color:',';font-size:48px;font-weight:bold;line-height:1.08;letter-spacing:normal;margin:0 0 ',';',';'],_types.title24Galano,_colors.darkSlateBlue,(0,_rem2.default)('10px'),_media2.default.small(_templateObject3,_types.title18Galano,(0,_rem2.default)('8px')));var WrapperButtons=exports.WrapperButtons=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButtons',componentId:'sc-1gyd69n-3'})(['display:flex;justify-content:space-between;min-width:400px;& > div{margin:0 15px;}']);var BoxHeader=exports.BoxHeader=_styledComponents2.default.div.withConfig({displayName:'styles__BoxHeader',componentId:'sc-1gyd69n-4'})(['display:flex;justify-content:space-between;margin-bottom:40px;']);var SearchBox=exports.SearchBox=_styledComponents2.default.div.withConfig({displayName:'styles__SearchBox',componentId:'sc-1gyd69n-5'})(['display:flex;justify-content:flex-end;margin-bottom:',';'],(0,_rem2.default)('20px'));var spin=(0,_styledComponents.keyframes)(['from{transform:rotate(0deg);}to{transform:rotate(360deg);}']);var LoadingContainer=exports.LoadingContainer=_styledComponents2.default.div.withConfig({displayName:'styles__LoadingContainer',componentId:'sc-1gyd69n-6'})(['margin-top:',';display:flex;align-items:center;justify-content:center;svg{animation:',' 1s linear infinite;}'],(0,_rem2.default)('20px'),spin);var LoadingText=exports.LoadingText=_styledComponents2.default.span.withConfig({displayName:'styles__LoadingText',componentId:'sc-1gyd69n-7'})(['margin-left:',';',';color:',';'],(0,_rem2.default)('10px'),_types.txt14OpenSans,_colors.darkGrey);

/***/ }),
/* 2022 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Minha Veloe - VeloeTags","identifiersTitle":"Minhas VeloeTags","identifiersDescription":"Veja abaixo a sua lista de veículos ativados:","btnFollow":"Meus pedidos","btnActivation":"Ativar novo veículo","btnNewTag":"Solicitar VeloeTag","noIdentifierTitle":"Ops","noIdentifierDescription":"Você não tem VeloeTags a serem exibidas."}

/***/ }),
/* 2023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardIdentifiersHistory/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _styles=__webpack_require__(2024);var _actions=__webpack_require__(36);var _ToggleSwitch=__webpack_require__(651);var _ToggleSwitch2=_interopRequireDefault(_ToggleSwitch);var _SearchIcon=__webpack_require__(400);var _SearchIcon2=_interopRequireDefault(_SearchIcon);var _data=__webpack_require__(2025);var _apolloClient=__webpack_require__(42);var _vehicles=__webpack_require__(94);var _tag_veloe2x=__webpack_require__(629);var _tag_veloe2x2=_interopRequireDefault(_tag_veloe2x);var _loading=__webpack_require__(100);var _loading2=_interopRequireDefault(_loading);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { Button, InputText,  } from 'veloe-ds'
var DashboardIdentifiersHistory=function(_Component){_inherits(DashboardIdentifiersHistory,_Component);function DashboardIdentifiersHistory(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DashboardIdentifiersHistory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DashboardIdentifiersHistory.__proto__||Object.getPrototypeOf(DashboardIdentifiersHistory)).call.apply(_ref,[this].concat(args))),_this),_this.state={identifier:null,pap:null,searchText:'',historico:null,loading:false,loadingPap:false,semRegistro:false,placa:null,tagInvalida:false},_this.componentDidUpdate=function(prevProps){var accountPlans=_this.props.accountPlans;if(prevProps.accountPlans.activePlanId&&accountPlans&&accountPlans.plans.length>0){setTimeout(function(){return _this.props.setLoading(false);},400);}},_this.handleSearchChange=function(_ref2){var target=_ref2.target;// const { searchText } = this.state
// if (searchText === '' || searchText.length < 10) {
//   this.setState({ tagInvalida: true })
// } else {
//   this.setState({ tagInvalida: false })
// }
_this.setState({searchText:target.value});},_this.handleSearchTag=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var returnData,_returnData,_returnData$data$hist,historicos,id,pap,placa;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({loading:true,semRegistro:false});returnData=void 0;_context.prev=2;_context.next=5;return(0,_apolloClient.gqlQuery)(_vehicles.gqlHistoricoIdentificadorTag,{idConta:_this.props.match.params.id,identificador:_this.state.searchText});case 5:returnData=_context.sent;_context.next=12;break;case 8:_context.prev=8;_context.t0=_context['catch'](2);returnData={data:{historicoIdentificadorTag:{historicos:null,id:null,pap:null,placa:null}}};_this.setState({semRegistro:true,historico:null,identifier:null,pap:null,placa:null});case 12:_returnData=returnData,_returnData$data$hist=_returnData.data.historicoIdentificadorTag,historicos=_returnData$data$hist.historicos,id=_returnData$data$hist.id,pap=_returnData$data$hist.pap,placa=_returnData$data$hist.placa;if(historicos&&_this.state.semRegistro===false){_this.setState({historico:historicos,pap:pap,placa:placa,identifier:id},function(){return _this.setState({loading:false});});}else{_this.setState({loading:false,semRegistro:true,historico:null,identifier:null,pap:null,placa:null});}case 14:case'end':return _context.stop();}}},_callee,_this2,[[2,8]]);})),_this.convertDate=function(date){var data=new Date(parseInt(date,10)).toISOString().substr(0,10).split('-').reverse().join('/');var hora=new Date(parseInt(date,10)).toISOString().substr(11,8);return data+' '+hora;},_this.togglePap=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(checked){var _this$state,identifier,placa;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this$state=_this.state,identifier=_this$state.identifier,placa=_this$state.placa;// const changePap = checked ? 1 : 0
_this.setState({pap:checked?1:0});// changeTagIdentifiers(vehicle)
_context2.prev=2;_context2.next=5;return(0,_apolloClient.gqlMutate)(_vehicles.gqlModificarPapIndividual,{idConta:_this.props.match.params.id,adesaoPap:checked,identificador:identifier,placa:placa});case 5:_context2.next=11;break;case 7:_context2.prev=7;_context2.t0=_context2['catch'](2);_this.setState({pap:!checked?1:0});if(!_this.state.loadingPap)alert('Problema ao executar pap');else _this.setState({loadingPap:false});case 11:case'end':return _context2.stop();}}},_callee2,_this2,[[2,7]]);}));return function(_x){return _ref4.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DashboardIdentifiersHistory,[{key:'onUnload',value:function onUnload(){this.setState({loadingPap:true});}},{key:'componentDidMount',value:function componentDidMount(){this.props.setLoading(true);window.addEventListener('beforeunload',this.onUnload());}},{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener('beforeunload',this.onUnload());}},{key:'render',value:function render(){var _this3=this;var _state=this.state,historico=_state.historico,loading=_state.loading,semRegistro=_state.semRegistro,pap=_state.pap,identifier=_state.identifier,tagInvalida=_state.tagInvalida,searchText=_state.searchText;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:156}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:157}}),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:158}},_react2.default.createElement(_styles.Container,{style:{display:'flex',flexDirection:'column'},__source:{fileName:_jsxFileName,lineNumber:159}},_react2.default.createElement(_styles.InputContainer,{__source:{fileName:_jsxFileName,lineNumber:160}},_react2.default.createElement(_styles.SearchIconContainer,{__source:{fileName:_jsxFileName,lineNumber:161}},_react2.default.createElement(_SearchIcon2.default,{__source:{fileName:_jsxFileName,lineNumber:162}})),_react2.default.createElement(_styles.SearchInput,{onChange:this.handleSearchChange,placeholder:'Buscar pelo n\xFAmero da Tag',__source:{fileName:_jsxFileName,lineNumber:164}}),_react2.default.createElement(_styles.SearchButton,{onClick:this.handleSearchTag,disabled:searchText.length<10,__source:{fileName:_jsxFileName,lineNumber:168}},'Buscar')),tagInvalida&&_react2.default.createElement('div',{style:{width:'100%',textAlign:'center',marginTop:'20px'},__source:{fileName:_jsxFileName,lineNumber:173}},_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:174}},'TAG inv\xE1lido'))),loading&&_react2.default.createElement('div',{style:{width:'100%',textAlign:'center'},__source:{fileName:_jsxFileName,lineNumber:179}},_react2.default.createElement(_styles.Loading,{src:_loading2.default,__source:{fileName:_jsxFileName,lineNumber:180}})),semRegistro&&_react2.default.createElement('div',{style:{width:'100%',textAlign:'center'},__source:{fileName:_jsxFileName,lineNumber:184}},_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:185}},'N\xFAmero de TAG inv\xE1lido')),historico&&!loading&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:190}},_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:191}},_react2.default.createElement(_styles.WrapperTextoHeader,{__source:{fileName:_jsxFileName,lineNumber:192}},_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:193}},_data.tag),_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:194}},identifier),_react2.default.createElement(_styles.Paragraph,{style:{display:'flex'},__source:{fileName:_jsxFileName,lineNumber:195}},_react2.default.createElement('span',{style:{marginRight:'10px'},__source:{fileName:_jsxFileName,lineNumber:196}},_data.papText),_react2.default.createElement(_ToggleSwitch2.default,{checked:pap===1,label:pap===1?'Ativo':'Inativo',name:'pap',togglePap:this.togglePap,__source:{fileName:_jsxFileName,lineNumber:197}}))),_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:205}},_react2.default.createElement('img',{src:_tag_veloe2x2.default,alt:'',style:{width:'240px'},__source:{fileName:_jsxFileName,lineNumber:206}}))),_react2.default.createElement(_styles.Timeline,{__source:{fileName:_jsxFileName,lineNumber:210}},_react2.default.createElement('div',{className:'history-tl-container',__source:{fileName:_jsxFileName,lineNumber:211}},_react2.default.createElement('ul',{className:'tl',__source:{fileName:_jsxFileName,lineNumber:212}},historico.map(function(item,index){return _react2.default.createElement('li',{key:index,className:'tl-item',__source:{fileName:_jsxFileName,lineNumber:214}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:215}},index+1),_react2.default.createElement('div',{className:'item-title',__source:{fileName:_jsxFileName,lineNumber:216}},_data.operacao[item.operacao]),_react2.default.createElement('div',{className:'item-detail',__source:{fileName:_jsxFileName,lineNumber:217}},_this3.convertDate(item.dataInclusao)));})))))));}}]);return DashboardIdentifiersHistory;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref5){var reducer=_ref5.reducer;return{accountPlans:reducer.accountPlans};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{dispatch:dispatch,setLoading:function setLoading(isLoading){dispatch((0,_actions.setLoading)(isLoading));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DashboardIdentifiersHistory);module.exports=exports['default'];

/***/ }),
/* 2024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Timeline=exports.SearchIconContainer=exports.WrapperTextoHeader=exports.Loading=exports.Wrapper=exports.SearchButton=exports.InputContainer=exports.Container=exports.SearchInput=exports.Subtitle=exports.Row=exports.BoxCep=exports.NewAddressText=exports.WrapperFormNewAddress=exports.CheckBoxCep=exports.WrapperSelectNewAddress=exports.NewAddress=exports.CepText=exports.WrapperAddress=exports.SearchBox=exports.BoxHeader=exports.WrapperRadios=exports.WrapperButtons=exports.Heading=exports.Paragraph=exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n        margin: ',' auto;\n    '],['\n        margin: ',' auto;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n\n        margin: 0;\n    '],['\n\n        margin: 0;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        ','\n        margin: ',' 0;\n    '],['\n        ','\n        margin: ',' 0;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        padding: ',' ',' ',';\n        width: ',';\n    '],['\n        padding: ',' ',' ',';\n        width: ',';\n    ']),_templateObject5=_taggedTemplateLiteral(['\n          margin: 0;\n      '],['\n          margin: 0;\n      ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-lyoeno-0'})(['',';margin:',' auto;',';'],_content2.default,(0,_rem2.default)('42px'),_media2.default.small(_templateObject,(0,_rem2.default)('29px')));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-lyoeno-1'})(['',' color:',';margin-top:',';',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('7px'),_media2.default.large(_templateObject2));var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-lyoeno-2'})(['',' color:',';font-size:48px;font-weight:bold;line-height:1.08;letter-spacing:normal;margin:0;',';'],_types.title24Galano,_colors.darkSlateBlue,_media2.default.small(_templateObject3,_types.title18Galano,(0,_rem2.default)('8px')));var WrapperButtons=exports.WrapperButtons=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButtons',componentId:'sc-lyoeno-3'})(['display:flex;justify-content:start;min-width:400px;& > div{margin:0 0;}']);var WrapperRadios=exports.WrapperRadios=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperRadios',componentId:'sc-lyoeno-4'})(['display:flex;justify-content:flex-start;min-width:200px;& > div{margin:0 0;}']);var BoxHeader=exports.BoxHeader=_styledComponents2.default.div.withConfig({displayName:'styles__BoxHeader',componentId:'sc-lyoeno-5'})(['display:flex;justify-content:space-between;margin-bottom:40px;']);var SearchBox=exports.SearchBox=_styledComponents2.default.div.withConfig({displayName:'styles__SearchBox',componentId:'sc-lyoeno-6'})(['display:flex;justify-content:flex-end;margin-bottom:40px;']);var WrapperAddress=exports.WrapperAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperAddress',componentId:'sc-lyoeno-7'})(['']);var CepText=exports.CepText=_styledComponents2.default.div.withConfig({displayName:'styles__CepText',componentId:'sc-lyoeno-8'})(['',';color:',';width:100%;padding-left:30px;cursor:pointer;text-transform:',';'],_types.txt16OpenSans,_colors.darkGrey,function(props){return props.transform;});CepText.defaultProps={transform:'capitalize'};var NewAddress=exports.NewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__NewAddress',componentId:'sc-lyoeno-9'})(['color:',';',';letter-spacing:0.4px;display:flex;flex-direction:column;'],function(props){return props.focus?''+_colors.darkSlateBlue:''+_colors.blueGray;},_types.txt16OpenSans);var WrapperSelectNewAddress=exports.WrapperSelectNewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperSelectNewAddress',componentId:'sc-lyoeno-10'})(['']);var CheckBoxCep=exports.CheckBoxCep=_styledComponents2.default.input.withConfig({displayName:'styles__CheckBoxCep',componentId:'sc-lyoeno-11'})(['margin-right:15px;&:checked,&:not(:checked){position:absolute;z-index:99;margin-left:2px;cursor:pointer;}&:checked + label,&:not(:checked) + label{position:relative;padding-left:35px;line-height:20px;display:inline-block;}&:checked,&:not(:checked){&:before{content:\'\';position:absolute;left:-2px;top:0;width:20px;height:20px;border:2px solid ',';border-radius:100%;background:',';}}&:checked{&:before{border:2px solid ',';}}&:checked,&:not(:checked){&:after{content:\'\';width:12px;height:12px;background:',';position:absolute;top:4px;left:2px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;}}&:not(:checked){&:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}}&:checked{&:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}}'],_colors.grey,_colors.white,_colors.skyBlue,_colors.skyBlue);var WrapperFormNewAddress=exports.WrapperFormNewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperFormNewAddress',componentId:'sc-lyoeno-12'})(['margin-top:30px;']);var NewAddressText=exports.NewAddressText=_styledComponents2.default.label.withConfig({displayName:'styles__NewAddressText',componentId:'sc-lyoeno-13'})(['']);var BoxCep=exports.BoxCep=_styledComponents2.default.label.withConfig({displayName:'styles__BoxCep',componentId:'sc-lyoeno-14'})(['flex-grow:1;']);var Row=exports.Row=_styledComponents2.default.div.withConfig({displayName:'styles__Row',componentId:'sc-lyoeno-15'})(['margin:5px 0;display:inline-block;width:100%;']);var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-lyoeno-16'})(['',';color:',';font-weight:bold;line-height:1;margin:0 0 ',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('10px'));var SearchInput=exports.SearchInput=_styledComponents2.default.input.withConfig({displayName:'styles__SearchInput',componentId:'sc-lyoeno-17'})(['border:none;border-bottom:3px solid ',';background-color:',';padding:',';line-height:',';color:',';',';width:100%;text-indent:40px;'],_colors.darkSlateBlue,_colors.paleGray,(0,_rem2.default)('16px'),(0,_rem2.default)('24px'),_colors.darkSlateBlue,_types.txt16OpenSans);var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-lyoeno-18'})(['width:100%;padding:',' 0 ',';background-color:white;display:flex;justify-content:center;'],(0,_rem2.default)('9px'),(0,_rem2.default)('50px'));var InputContainer=exports.InputContainer=_styledComponents2.default.div.withConfig({displayName:'styles__InputContainer',componentId:'sc-lyoeno-19'})(['position:relative;display:flex;justify-content:flex-start;flex-direction:row;width:',';align-items:center;'],(0,_rem2.default)('940px'));var SearchButton=exports.SearchButton=_styledComponents2.default.button.withConfig({displayName:'styles__SearchButton',componentId:'sc-lyoeno-20'})(['background-color:',';color:',';',';padding:',' ',';border-radius:25px;margin-left:',';outline:none;'],function(_ref){var disabled=_ref.disabled;return disabled?_colors.paleGray:_colors.darkSlateBlue;},function(_ref2){var disabled=_ref2.disabled;return disabled?_colors.darkGrey:'white';},_types.txt16OpenSansBold,(0,_rem2.default)('13px'),(0,_rem2.default)('25px'),(0,_rem2.default)('20px'));var Wrapper=exports.Wrapper=_styledComponents2.default.section.withConfig({displayName:'styles__Wrapper',componentId:'sc-lyoeno-21'})(['width:100%;min-width:100%;border-radius:',';background-color:',';padding:',';box-shadow:0 ',' ',' 0 rgba(30,27,91,0.11);display:flex;justify-content:space-around;',';'],(0,_rem2.default)('6px'),_colors.white,(0,_rem2.default)('22px'),(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),_media2.default.large(_templateObject4,(0,_rem2.default)('40px'),(0,_rem2.default)('40px'),(0,_rem2.default)('30px'),(0,_rem2.default)('335px')));var Loading=exports.Loading=_styledComponents2.default.img.withConfig({displayName:'styles__Loading',componentId:'sc-lyoeno-22'})(['width:',';'],(0,_rem2.default)('25px'));var WrapperTextoHeader=exports.WrapperTextoHeader=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperTextoHeader',componentId:'sc-lyoeno-23'})(['span{',' color:',';margin-top:',';margin-left:',' !important;',';position:relative;}'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('7px'),(0,_rem2.default)('5px'),_media2.default.large(_templateObject5));var SearchIconContainer=exports.SearchIconContainer=_styledComponents2.default.div.withConfig({displayName:'styles__SearchIconContainer',componentId:'sc-lyoeno-24'})(['left:15px;width:0;position:relative;display:flex;flex-direction:column;']);var Timeline=exports.Timeline=_styledComponents2.default.div.withConfig({displayName:'styles__Timeline',componentId:'sc-lyoeno-25'})(['margin-top:20px;.history-tl-container{font-family:\'Roboto\',sans-serif;width:50%;margin:auto;display:block;position:relative;}.history-tl-container ul.tl{margin:20px 0;padding:0;display:inline-block;}.history-tl-container ul.tl li{list-style:none;margin:auto;margin-left:200px;min-height:50px;border-left:2px solid ',';padding:0 0 50px 30px;position:relative;}.history-tl-container ul.tl li:last-child{border-left:0;}.history-tl-container ul.tl li::before{position:absolute;left:-10px;top:-5px;content:\' \';border-radius:500%;background:',';height:20px;width:20px;transition:all 500ms ease-in-out;}.history-tl-container ul.tl li:hover::before{border-color:',';transition:all 1000ms ease-in-out;}ul.tl li .item-title{}ul.tl li .item-detail{color:rgba(0,0,0,0.5);font-size:12px;}ul.tl li .timestamp{color:#8d8d8d;position:absolute;width:100px;left:-50%;text-align:right;font-size:12px;}ul.tl li span{position:absolute;top:-1px;left:-3px;color:#fff;font-size:11px;}'],_colors.darkSlateBlue,_colors.darkSlateBlue,_colors.darkSlateBlue);

/***/ }),
/* 2025 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Minha Veloe - Histórico de VeloeTag","tag":"Tag","papText":"PONTO A PONTO:","operacao":{"ATIVAR":"Ativado","INATIVAR":"Inativado","BLOQUEAR":"Bloqueado","DESBLOQUEAR":"Desbloqueado","ALTERAR_PLACA":"Alteração de placa","ALTERAR_CATEGORIA":"Alteração de categoria","SUBSTITUIR":"Substituído"}}

/***/ }),
/* 2026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardIdentifiersRequests/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _actions=__webpack_require__(13);var _gridStyled=__webpack_require__(8);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(2027);var _actions2=__webpack_require__(36);var _IdentifierQuantityForm=__webpack_require__(2028);var _IdentifierQuantityForm2=_interopRequireDefault(_IdentifierQuantityForm);var _OtherAddressForm=__webpack_require__(611);var _OtherAddressForm2=_interopRequireDefault(_OtherAddressForm);var _RequestIdentifierModal=__webpack_require__(2031);var _RequestIdentifierModal2=_interopRequireDefault(_RequestIdentifierModal);var _masks=__webpack_require__(390);var _actions3=__webpack_require__(18);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);var _ModalTypes=__webpack_require__(20);var _data=__webpack_require__(2033);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DashboardIdentifiersRequests=function(_Component){_inherits(DashboardIdentifiersRequests,_Component);function DashboardIdentifiersRequests(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,DashboardIdentifiersRequests);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DashboardIdentifiersRequests.__proto__||Object.getPrototypeOf(DashboardIdentifiersRequests)).call.apply(_ref,[this].concat(args))),_this),_this.state={addressSelected:'actual',address:{bairro:'',cep:'',cidade:'',codigo:'',complemento:'',correspondencia:'',logradouro:'',numero:'',uf:''},disableButton:true,accountId:'',quantity:'',loading:false},_this.changeCheckBox=function(evt){_this.setState({addressSelected:evt.target.value});},_this.handleSaveQuantity=function(evt){if(evt>0){_this.setState({quantity:evt,disableButton:false});}else{_this.setState({quantity:evt,disableButton:true});}},_this.handleSaveAddress=function(evt){_this.setState({saveAddress:evt});},_this.handleClick=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({modal:false});_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/identificadores');case 2:case'end':return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}// constructor(props) {
//   super(props)
// }
_createClass(DashboardIdentifiersRequests,[{key:'componentDidMount',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.props.getUser(this.props.account.accountType,this.props.history);case 1:case'end':return _context2.stop();}}},_callee2,this);}));function componentDidMount(){return _ref3.apply(this,arguments);}return componentDidMount;}()},{key:'handleSave',value:function handleSave(){var _this3=this;this.setState({loading:true,disableButton:true});var _props=this.props,history=_props.history,match=_props.match;var _state=this.state,saveAddress=_state.saveAddress,address=_state.address,addressSelected=_state.addressSelected,quantity=_state.quantity;var endereco=void 0;if(addressSelected==='actual'&&address){endereco=address;}else if(addressSelected==='new'&&saveAddress&&saveAddress[0]){endereco={bairro:saveAddress[0].neighborhood,cep:saveAddress[0].zipCode.replace(/-/g,''),cidade:saveAddress[0].city,complemento:saveAddress[0].additionalInfo,correspondencia:saveAddress[0].mail,logradouro:saveAddress[0].address,numero:saveAddress[0].number,uf:saveAddress[0].state};}var data={codigoConta:match.params.id,quantidadeIdentificadores:quantity,endereco:endereco};this.props.newIdentifier(data,history).then(function(response){_this3.setState({loading:false,idOrder:response.result,modal:true});}).catch(function(){_this3.props.dispatch((0,_actions3.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,image:_contestacao2.default}));_this3.setState({loading:false,disableButton:false});});}},{key:'disableButton',value:function disableButton(){var disableButton=this.state.disableButton;var othertAddress=this.props.form.othertAddress;if(othertAddress&&!othertAddress.syncErrors){if(!disableButton){return false;}else{return true;}}else{return true;}}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,history=_props2.history,match=_props2.match,handleDelete=_props2.handleDelete,enderecos=_props2.user.enderecos;var _state2=this.state,loading=_state2.loading,addressSelected=_state2.addressSelected,disableButton=_state2.disableButton,idOrder=_state2.idOrder,modal=_state2.modal;this.state.address=enderecos&&enderecos[0];return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:162}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:163}}),this.state.address?_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:165}},_react2.default.createElement(_styles.BoxHeader,{__source:{fileName:_jsxFileName,lineNumber:166}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:167}},_data.identifiersTitle)),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:170}},_data.identifiersDescription),_react2.default.createElement(_IdentifierQuantityForm2.default,{initialValues:{identifiersQuantity:null},onChange:function onChange(values){return _this4.handleSaveQuantity(values.identifiersQuantity);},onDelete:handleDelete,length:0,match:match,history:history,__source:{fileName:_jsxFileName,lineNumber:172}}),_react2.default.createElement(_styles.WrapperRadios,{__source:{fileName:_jsxFileName,lineNumber:181}},_react2.default.createElement(_gridStyled.Box,{width:[1],style:{alignSelf:'center'},__source:{fileName:_jsxFileName,lineNumber:182}},_react2.default.createElement(_gridStyled.Flex,{align:'center',px:[0,0,0,0],__source:{fileName:_jsxFileName,lineNumber:183}},_react2.default.createElement(_gridStyled.Box,{width:[1],__source:{fileName:_jsxFileName,lineNumber:184}},_react2.default.createElement(_gridStyled.Flex,{direction:'column',__source:{fileName:_jsxFileName,lineNumber:185}},_react2.default.createElement(_gridStyled.Box,{width:[1],__source:{fileName:_jsxFileName,lineNumber:186}},_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:187}},_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:188}},_data.addressDescription))),_react2.default.createElement(_gridStyled.Box,{width:[7/12],__source:{fileName:_jsxFileName,lineNumber:191}},_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:192}},_react2.default.createElement(_styles.BoxCep,{__source:{fileName:_jsxFileName,lineNumber:193}},_react2.default.createElement(_styles.CheckBoxCep,{type:'radio',value:'actual',checked:addressSelected==='actual',onChange:function onChange(e){return _this4.changeCheckBox(e);},__source:{fileName:_jsxFileName,lineNumber:194}}),_react2.default.createElement(_styles.CepText,{__source:{fileName:_jsxFileName,lineNumber:201}},this.state.address.logradouro,', ',this.state.address.numero,' -',' ',this.state.address.complemento?this.state.address.complemento+' - ':'',' ',this.state.address.bairro,' - ',this.state.address.cidade,' -',' ',this.state.address.uf.toUpperCase(),' -',' ',(0,_masks.cepMask)(this.state.address.cep),' ')))),_react2.default.createElement(_gridStyled.Box,{width:[10/12],__source:{fileName:_jsxFileName,lineNumber:213}},_react2.default.createElement(_styles.Row,{__source:{fileName:_jsxFileName,lineNumber:214}},_react2.default.createElement(_styles.NewAddress,{focus:addressSelected==='new',__source:{fileName:_jsxFileName,lineNumber:215}},_react2.default.createElement(_styles.WrapperSelectNewAddress,{__source:{fileName:_jsxFileName,lineNumber:216}},_react2.default.createElement(_styles.NewAddressText,{__source:{fileName:_jsxFileName,lineNumber:217}},_react2.default.createElement(_styles.CheckBoxCep,{type:'radio',value:'new',checked:addressSelected==='new',onChange:function onChange(e){return _this4.changeCheckBox(e);},__source:{fileName:_jsxFileName,lineNumber:218}}),_react2.default.createElement(_styles.CepText,{transform:'initial',__source:{fileName:_jsxFileName,lineNumber:224}},'Outro endere\xE7o de entrega'))),_react2.default.createElement(_styles.WrapperFormNewAddress,{__source:{fileName:_jsxFileName,lineNumber:227}},addressSelected==='new'?_react2.default.createElement(_OtherAddressForm2.default,{initialValues:{address:[]},disableButton:this.disableButton(),onDelete:handleDelete,length:0,match:match,history:history,onSubmit:function onSubmit(){return _this4.handleSave();},onChange:function onChange(values){return _this4.handleSaveAddress(values.address);},loadingButton:loading,__source:{fileName:_jsxFileName,lineNumber:229}}):null))))),addressSelected==='actual'&&_react2.default.createElement(_styles.WrapperButtons,{__source:{fileName:_jsxFileName,lineNumber:247}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,__source:{fileName:_jsxFileName,lineNumber:248}},_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],mr:[0,30],mb:[20,0],__source:{fileName:_jsxFileName,lineNumber:249}},_react2.default.createElement(_Button2.default,{disabled:disableButton,loading:loading,width:'185px',buttonType:'skyBlue',text:'Enviar Pedido',onClick:function onClick(){return _this4.handleSave();},id:'btnSendRequest',__source:{fileName:_jsxFileName,lineNumber:250}})),_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],__source:{fileName:_jsxFileName,lineNumber:260}},_react2.default.createElement(_Button2.default,{buttonType:'white',onClick:function onClick(){return history.goBack();},text:'Cancelar',id:'btnCancelRequest',__source:{fileName:_jsxFileName,lineNumber:261}}))))))))):_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:277}}),modal&&_react2.default.createElement(_RequestIdentifierModal2.default,{handleClick:this.handleClick,idPedido:idOrder,__source:{fileName:_jsxFileName,lineNumber:279}}));}}]);return DashboardIdentifiersRequests;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref4){var form=_ref4.form,reducer=_ref4.reducer;return{form:form,account:reducer.account,user:reducer.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{dispatch:dispatch,getUser:function getUser(userType,history){dispatch((0,_actions2.setLoading)(true));if(userType==='pf'){dispatch((0,_actions.fetchGetUser)()).then(function(){return dispatch((0,_actions2.setLoading)(false));}).catch(function(resp){if(resp&&(resp.status===401||resp.status===403)){dispatch((0,_actions.fetchLogout)());history.push('/conta/login');}dispatch((0,_actions2.setLoading)(false));});}else{dispatch((0,_actions.fetchGetBusinessUser)()).then(function(){return dispatch((0,_actions2.setLoading)(false));}).catch(function(resp){if(resp&&(resp.status===401||resp.status===403)){dispatch((0,_actions.fetchLogout)());history.push('/conta/login');}dispatch((0,_actions2.setLoading)(false));});}},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));},newIdentifier:function newIdentifier(data,history){return dispatch((0,_actions.fetchNewIdentifier)(data));}// .then()
// .catch(resp => {
//   if (resp && (resp.status === 401 || resp.status === 403)) {
//     dispatch(fetchLogout())
//     history.push('/conta/login')
//   }
//   dispatch(setLoading(false))
// })
};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DashboardIdentifiersRequests);module.exports=exports['default'];

/***/ }),
/* 2027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Subtitle=exports.Row=exports.BoxCep=exports.NewAddressText=exports.WrapperFormNewAddress=exports.CheckBoxCep=exports.WrapperSelectNewAddress=exports.NewAddress=exports.CepText=exports.WrapperAddress=exports.SearchBox=exports.BoxHeader=exports.WrapperRadios=exports.WrapperButtons=exports.Heading=exports.Paragraph=exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n        margin: ',' auto;\n    '],['\n        margin: ',' auto;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n\n        margin: 0;\n    '],['\n\n        margin: 0;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        ','\n        margin: ',' 0;\n    '],['\n        ','\n        margin: ',' 0;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-10w3nb6-0'})(['',';margin:',' auto;',';'],_content2.default,(0,_rem2.default)('42px'),_media2.default.small(_templateObject,(0,_rem2.default)('29px')));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-10w3nb6-1'})(['',' color:',';margin-top:',';',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('7px'),_media2.default.large(_templateObject2));var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-10w3nb6-2'})(['',' color:',';font-size:48px;font-weight:bold;line-height:1.08;letter-spacing:normal;margin:0;',';'],_types.title24Galano,_colors.darkSlateBlue,_media2.default.small(_templateObject3,_types.title18Galano,(0,_rem2.default)('8px')));var WrapperButtons=exports.WrapperButtons=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButtons',componentId:'sc-10w3nb6-3'})(['display:flex;justify-content:start;min-width:400px;& > div{margin:0 0;}']);var WrapperRadios=exports.WrapperRadios=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperRadios',componentId:'sc-10w3nb6-4'})(['display:flex;justify-content:flex-start;min-width:200px;& > div{margin:0 0;}']);var BoxHeader=exports.BoxHeader=_styledComponents2.default.div.withConfig({displayName:'styles__BoxHeader',componentId:'sc-10w3nb6-5'})(['display:flex;justify-content:space-between;margin-bottom:40px;']);var SearchBox=exports.SearchBox=_styledComponents2.default.div.withConfig({displayName:'styles__SearchBox',componentId:'sc-10w3nb6-6'})(['display:flex;justify-content:flex-end;margin-bottom:40px;']);var WrapperAddress=exports.WrapperAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperAddress',componentId:'sc-10w3nb6-7'})(['']);var CepText=exports.CepText=_styledComponents2.default.div.withConfig({displayName:'styles__CepText',componentId:'sc-10w3nb6-8'})(['',';color:',';width:100%;padding-left:30px;cursor:pointer;text-transform:',';'],_types.txt16OpenSans,_colors.darkGrey,function(props){return props.transform;});CepText.defaultProps={transform:'capitalize'};var NewAddress=exports.NewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__NewAddress',componentId:'sc-10w3nb6-9'})(['color:',';',';letter-spacing:0.4px;display:flex;flex-direction:column;'],function(props){return props.focus?''+_colors.darkSlateBlue:''+_colors.blueGray;},_types.txt16OpenSans);var WrapperSelectNewAddress=exports.WrapperSelectNewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperSelectNewAddress',componentId:'sc-10w3nb6-10'})(['']);var CheckBoxCep=exports.CheckBoxCep=_styledComponents2.default.input.withConfig({displayName:'styles__CheckBoxCep',componentId:'sc-10w3nb6-11'})(['margin-right:15px;&:checked,&:not(:checked){position:absolute;z-index:99;margin-left:2px;cursor:pointer;}&:checked + label,&:not(:checked) + label{position:relative;padding-left:35px;line-height:20px;display:inline-block;}&:checked,&:not(:checked){&:before{content:\'\';position:absolute;left:-2px;top:0;width:20px;height:20px;border:2px solid ',';border-radius:100%;background:',';}}&:checked{&:before{border:2px solid ',';}}&:checked,&:not(:checked){&:after{content:\'\';width:12px;height:12px;background:',';position:absolute;top:4px;left:2px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;}}&:not(:checked){&:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}}&:checked{&:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}}'],_colors.grey,_colors.white,_colors.skyBlue,_colors.skyBlue);var WrapperFormNewAddress=exports.WrapperFormNewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperFormNewAddress',componentId:'sc-10w3nb6-12'})(['margin-top:30px;']);var NewAddressText=exports.NewAddressText=_styledComponents2.default.label.withConfig({displayName:'styles__NewAddressText',componentId:'sc-10w3nb6-13'})(['']);var BoxCep=exports.BoxCep=_styledComponents2.default.label.withConfig({displayName:'styles__BoxCep',componentId:'sc-10w3nb6-14'})(['flex-grow:1;']);var Row=exports.Row=_styledComponents2.default.div.withConfig({displayName:'styles__Row',componentId:'sc-10w3nb6-15'})(['margin:5px 0;display:inline-block;width:100%;']);var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-10w3nb6-16'})(['',';color:',';font-weight:bold;line-height:1;margin:0 0 ',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('10px'));

/***/ }),
/* 2028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/IdentifierQuantityForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _styles=__webpack_require__(2029);var _data=__webpack_require__(2030);var _renderInputs=__webpack_require__(44);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IdentifierQuantityForm=function IdentifierQuantityForm(props){var onChange=props.onChange;return _react2.default.createElement('form',{onChange:onChange,__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,width:[1,7/12],__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,mt:50,__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.identifiersQuantity,name:'identifiersQuantity',type:'number',placeholder:'Digite aqui',validate:_aleloLogic.utils.emptyFieldValidate,normalize:_aleloLogic.utils.numberMask,maxlength:'10',isRequired:true,id:'qtdVeloeTags',__source:{fileName:_jsxFileName,lineNumber:20}})))));};var mapStateToProps=function mapStateToProps(state){return{};};var form=(0,_reduxForm.reduxForm)({form:'identifierQuantity',enableReinitialize:true,destroyOnUnmount:false})(IdentifierQuantityForm);exports.default=(0,_reactRedux.connect)(mapStateToProps,undefined)(form);module.exports=exports['default'];

/***/ }),
/* 2029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Subtitle=exports.Row=exports.BoxCep=exports.NewAddressText=exports.WrapperFormNewAddress=exports.CheckBoxCep=exports.WrapperSelectNewAddress=exports.NewAddress=exports.CepText=exports.WrapperAddress=exports.WrapperRadios=exports.WrapperButtons=exports.Container=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _container=__webpack_require__(183);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import content from '../../../styles/_objects/content'
var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-83oe13-0'})(['display:flex;justify-content:space-between;',';label{color:',';font-weight:bold;opacity:1;}'],_container.container,_colors.darkBlue);var WrapperButtons=exports.WrapperButtons=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButtons',componentId:'sc-83oe13-1'})(['display:flex;justify-content:start;min-width:400px;& > div{margin:0 0;}']);var WrapperRadios=exports.WrapperRadios=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperRadios',componentId:'sc-83oe13-2'})(['display:flex;justify-content:flex-start;min-width:200px;& > div{margin:0 0;}']);var WrapperAddress=exports.WrapperAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperAddress',componentId:'sc-83oe13-3'})(['']);var CepText=exports.CepText=_styledComponents2.default.div.withConfig({displayName:'styles__CepText',componentId:'sc-83oe13-4'})(['',';color:',';width:100%;padding-left:30px;cursor:pointer;'],_types.txt16OpenSans,_colors.darkGrey);var NewAddress=exports.NewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__NewAddress',componentId:'sc-83oe13-5'})(['color:',';',';letter-spacing:0.4px;display:flex;flex-direction:column;'],function(props){return props.focus?''+_colors.darkSlateBlue:''+_colors.blueGray;},_types.txt16OpenSans);var WrapperSelectNewAddress=exports.WrapperSelectNewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperSelectNewAddress',componentId:'sc-83oe13-6'})(['']);var CheckBoxCep=exports.CheckBoxCep=_styledComponents2.default.input.withConfig({displayName:'styles__CheckBoxCep',componentId:'sc-83oe13-7'})(['margin-right:15px;&:checked,&:not(:checked){position:absolute;z-index:99999;margin-left:2px;cursor:pointer;}&:checked + label,&:not(:checked) + label{position:relative;padding-left:35px;line-height:20px;display:inline-block;}&:checked,&:not(:checked){&:before{content:\'\';position:absolute;left:-2px;top:0;width:20px;height:20px;border:2px solid ',';border-radius:100%;background:',';}}&:checked{&:before{border:2px solid ',';}}&:checked,&:not(:checked){&:after{content:\'\';width:12px;height:12px;background:',';position:absolute;top:4px;left:2px;border-radius:100%;-webkit-transition:all 0.2s ease;transition:all 0.2s ease;}}&:not(:checked){&:after{opacity:0;-webkit-transform:scale(0);transform:scale(0);}}&:checked{&:after{opacity:1;-webkit-transform:scale(1);transform:scale(1);}}'],_colors.grey,_colors.white,_colors.skyBlue,_colors.skyBlue);var WrapperFormNewAddress=exports.WrapperFormNewAddress=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperFormNewAddress',componentId:'sc-83oe13-8'})(['margin-top:30px;form > div > div > div{width:100%;}']);var NewAddressText=exports.NewAddressText=_styledComponents2.default.label.withConfig({displayName:'styles__NewAddressText',componentId:'sc-83oe13-9'})(['']);var BoxCep=exports.BoxCep=_styledComponents2.default.label.withConfig({displayName:'styles__BoxCep',componentId:'sc-83oe13-10'})(['flex-grow:1;']);var Row=exports.Row=_styledComponents2.default.div.withConfig({displayName:'styles__Row',componentId:'sc-83oe13-11'})(['margin:5px 0;display:inline-block;width:100%;']);var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-83oe13-12'})(['',';color:',';font-weight:bold;line-height:1;margin:0 0 ',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('10px'));

/***/ }),
/* 2030 */
/***/ (function(module, exports) {

module.exports = {"labels":{"identifiersQuantity":"QUANTAS VELOETAGS VOCÊ QUER?"},"errorMessages":{"emptyField":"Campo obrigatório"}}

/***/ }),
/* 2031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/RequestIdentifierModal/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ModalBlue=__webpack_require__(188);var _ModalBlue2=_interopRequireDefault(_ModalBlue);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(2032);var _iconVeloeBackground=__webpack_require__(137);var _iconVeloeBackground2=_interopRequireDefault(_iconVeloeBackground);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AddTagsModal=function(_React$Component){_inherits(AddTagsModal,_React$Component);function AddTagsModal(){_classCallCheck(this,AddTagsModal);return _possibleConstructorReturn(this,(AddTagsModal.__proto__||Object.getPrototypeOf(AddTagsModal)).apply(this,arguments));}_createClass(AddTagsModal,[{key:'render',value:function render(){var handleClick=this.props.handleClick;return _react2.default.createElement(_ModalBlue2.default,{backgroundImage:_iconVeloeBackground2.default,position:'right bottom',__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:15}},'Seu pedido foi solicitado.'),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:16}},'Em at\xE9 24h voc\xEA poder\xE1 acompanhar o status do seu pedido no menu "',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:17}},'Meus pedidos'),'"'),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:20}},'Obrigado por escolher Veloe! ;)')),_react2.default.createElement(_styles.WrapperButton,{__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(_Button2.default,{buttonType:'darkBlue',text:'Ok',onClick:function onClick(){return handleClick();},__source:{fileName:_jsxFileName,lineNumber:24}}))));}}]);return AddTagsModal;}(_react2.default.Component);exports.default=AddTagsModal;module.exports=exports['default'];

/***/ }),
/* 2032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.WrapperButton=exports.Subtitle=exports.Text=exports.Title=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n    min-width: auto;\n    max-width: auto;\n  '],['\n    min-width: auto;\n    max-width: auto;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    ',';\n  '],['\n    ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: 18px;\n  '],['\n    font-size: 18px;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-j25ihb-0'})(['min-width:596px;max-width:596px;width:100%;min-height:360px;display:flex;justify-content:space-around;flex-direction:column;',';'],_media2.default.small(_templateObject));var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-j25ihb-1'})(['',';color:',';margin:0 0 16px;max-width:422px;line-height:32px;',';'],_types.title32GalanoBold,_colors.white,_media2.default.small(_templateObject2,_types.title24GalanoBold));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-j25ihb-2'})(['',';color:',';line-height:25px;margin:0 0 10px;max-width:550px;'],_types.txt16OpenSans,_colors.darkBlue);var Subtitle=exports.Subtitle=_styledComponents2.default.h2.withConfig({displayName:'styles__Subtitle',componentId:'sc-j25ihb-3'})(['',';color:',';font-size:24px;margin:0;',';'],_types.title24GalanoBold,_colors.darkBlue,_media2.default.small(_templateObject3));var WrapperButton=exports.WrapperButton=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButton',componentId:'sc-j25ihb-4'})(['display:block;margin-top:44px;']);

/***/ }),
/* 2033 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Minha Veloe - Solicitar VeloeTag","identifiersTitle":"Solicitar VeloeTag","identifiersQuantity":"QUANTAS VELOETAGS VOCÊ QUER?","identifiersDescription":"Informe o número de VeloeTags que você deseja e o endereço de entrega.","addressDescription":"Em qual endereço você deseja receber seu pedido?","addressRadio":"Outro endereço da entrega","btnFollow":"Enviar aaa pedido","btnCancel":"Cancelar","titleModalError":"Tem algo errado com os dados informados. Tente novamente."}

/***/ }),
/* 2034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardRechargeHistory/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _AddItem=__webpack_require__(258);var _AddItem2=_interopRequireDefault(_AddItem);var _RechargeList=__webpack_require__(2035);var _RechargeList2=_interopRequireDefault(_RechargeList);var _actions2=__webpack_require__(36);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DashboardRechargeHistory=function(_Component){_inherits(DashboardRechargeHistory,_Component);function DashboardRechargeHistory(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DashboardRechargeHistory);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DashboardRechargeHistory.__proto__||Object.getPrototypeOf(DashboardRechargeHistory)).call.apply(_ref,[this].concat(args))),_this),_this.fetchRecharge=function(nextPage){var params=_this.props.match.params||{};_this.props.fetchRecharges(params.id,nextPage);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DashboardRechargeHistory,[{key:'componentWillMount',value:function componentWillMount(){this.props.setLoading(true);this.props.fetchRecharges(this.props.match.params.id);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.resetRecharges();}},{key:'render',value:function render(){var recharges=this.props.recharges;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement(_AddItem2.default,{data:recharges.data,next:recharges.next,fetchHandler:this.fetchRecharge,__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_RechargeList2.default,{__source:{fileName:_jsxFileName,lineNumber:29}})));}}]);return DashboardRechargeHistory;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{recharges:reducer.dashboardRecharges};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchRecharges:function fetchRecharges(planId,nextPage){return dispatch((0,_actions.fetchDashboardRecharges)(planId,nextPage)).then(function(){return dispatch((0,_actions2.setLoading)(false));});},resetRecharges:function resetRecharges(){return dispatch((0,_actions.resetDashboardRecharges)());},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DashboardRechargeHistory);module.exports=exports['default'];

/***/ }),
/* 2035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/RechargeList/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _LoadMore=__webpack_require__(398);var _LoadMore2=_interopRequireDefault(_LoadMore);var _RechargeListItem=__webpack_require__(2036);var _RechargeListItem2=_interopRequireDefault(_RechargeListItem);var _styles=__webpack_require__(2039);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InvoicesList=function InvoicesList(_ref){var data=_ref.data,next=_ref.next,loadMoreHandler=_ref.loadMoreHandler;return _react2.default.createElement(_styles.ListContainer,{id:'lctRechargeTable',__source:{fileName:_jsxFileName,lineNumber:7}},data.map(function(recharge){return _react2.default.createElement(_RechargeListItem2.default,_extends({key:recharge.id},recharge,{__source:{fileName:_jsxFileName,lineNumber:8}}));}),next&&_react2.default.createElement(_styles.ListFooter,{__source:{fileName:_jsxFileName,lineNumber:10}},_react2.default.createElement(_LoadMore2.default,{onClick:loadMoreHandler,__source:{fileName:_jsxFileName,lineNumber:11}})));};exports.default=InvoicesList;module.exports=exports['default'];

/***/ }),
/* 2036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/RechargeListItem/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _utils=__webpack_require__(95);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _styles=__webpack_require__(2037);var _data=__webpack_require__(2038);var _data2=_interopRequireDefault(_data);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var RechargeListItem=function RechargeListItem(_ref){var date=_ref.date,paymentMethod=_ref.paymentMethod,type=_ref.type,value=_ref.value;return _react2.default.createElement(_styles.ListItem,{id:'litRechargeItem',__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_gridStyled.Flex,{width:1,__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_gridStyled.Box,{width:[6/12,1/12],mr:70,__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement(_styles.Label,{name:'recharge-item-date-label',__source:{fileName:_jsxFileName,lineNumber:15}},_data2.default.title.date),_react2.default.createElement(_styles.Title,{className:'date',name:'recharge-item-date',__source:{fileName:_jsxFileName,lineNumber:16}},(0,_utils.ISODateFormat)(date,'DD/MM/YYYY'))),_react2.default.createElement(_Hide2.default,{at:'small',width:[1/12],mr:25,__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_styles.Label,{name:'recharge-item-hour-label',__source:{fileName:_jsxFileName,lineNumber:21}},_data2.default.title.hour),_react2.default.createElement(_styles.Title,{name:'recharge-item-hour',__source:{fileName:_jsxFileName,lineNumber:22}},(0,_utils.ISODateFormat)(date,'HH:mm'))),_react2.default.createElement(_Hide2.default,{at:'small',width:[3/12],mr:12,__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement(_styles.Label,{name:'recharge-item-payment-label',__source:{fileName:_jsxFileName,lineNumber:25}},_data2.default.title.payment),_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:26}},_data2.default.paymentMethod[paymentMethod])),_react2.default.createElement(_Hide2.default,{at:'small',width:[4/12],mr:10,__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_styles.Label,{name:'recharge-item-type-label',__source:{fileName:_jsxFileName,lineNumber:29}},_data2.default.title.type),_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:30}},_data2.default.type[type])),_react2.default.createElement(_gridStyled.Box,{width:[6/12,1/12],__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_styles.Label,{name:'recharge-item-value-label',__source:{fileName:_jsxFileName,lineNumber:33}},_data2.default.title.value),_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:34}},(0,_utils.currencyParser)(value))))));};exports.default=RechargeListItem;module.exports=exports['default'];

/***/ }),
/* 2037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ListItem=exports.StatusContainer=exports.Text=exports.Title=exports.Label=exports.Item=exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n    width: 25%;\n  '],['\n    width: 25%;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n        margin-top: ',';\n    '],['\n        margin-top: ',';\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        ','\n    '],['\n        ','\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-ivvqye-0'})(['',';display:flex;'],_content2.default);var Item=exports.Item=_styledComponents2.default.div.withConfig({displayName:'styles__Item',componentId:'sc-ivvqye-1'})(['',';'],_media2.default.large(_templateObject));var Label=exports.Label=_styledComponents2.default.label.withConfig({displayName:'styles__Label',componentId:'sc-ivvqye-2'})(['color:',';font-family:OpenSans;font-size:',';font-weight:200;letter-spacing:',';line-height:1;pointer-events:none;text-transform:uppercase;white-space:nowrap;display:block;margin-bottom:',';'],_colors.darkGrey,(0,_rem2.default)('12px'),(0,_rem2.default)('0.4px'),(0,_rem2.default)('15px'));var Title=exports.Title=_styledComponents2.default.p.withConfig({displayName:'styles__Title',componentId:'sc-ivvqye-3'})(['',';letter-spacing:',';margin:0;line-height:1;-webkit-font-smoothing:antialiased;'],_types.title20GalanoBold,(0,_rem2.default)('0.3px'));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-ivvqye-4'})(['',';font-weight:500;color:',';line-height:',';'],_types.txt14OpenSans,_colors.darkGrey,(0,_rem2.default)('1.2px'));var StatusContainer=exports.StatusContainer=_styledComponents2.default.div.withConfig({displayName:'styles__StatusContainer',componentId:'sc-ivvqye-5'})(['display:flex;align-items:flex-start;height:100%;',';'],_media2.default.small(_templateObject2,(0,_rem2.default)('20px')));var ListItem=exports.ListItem=_styledComponents2.default.li.withConfig({displayName:'styles__ListItem',componentId:'sc-ivvqye-6'})(['position:relative;padding:',' 0 ',' 0;border-bottom:',' solid ',';color:',';justify-content:center;:hover{cursor:pointer;background-color:',';}.download-button{position:absolute;top:',';right:',';display:none;}',';'],(0,_rem2.default)('30px'),(0,_rem2.default)('23px'),(0,_rem2.default)('1px'),_colors.lightestBlue,_colors.darkGrey,_colors.nearWhite,(0,_rem2.default)('30px'),(0,_rem2.default)('30px'),_media2.default.small(_templateObject3,function(props){return props.first&&'\n            '+Title+' {\n                font-size: '+(0,_rem2.default)('36px')+';\n            }\n        ';}));

/***/ }),
/* 2038 */
/***/ (function(module, exports) {

module.exports = {"paymentMethod":{"credit":"Cartão de crédito","money":"Dinheiro","bankSlip":"Boleto","partners":"Parceiros","debit":"Cartão de débito"},"type":{"manual":"Recarga Manual","auto":"Recarga Automática"},"title":{"date":"Data","hour":"Hora","payment":"Pagamento","type":"Tipo","value":"Valor total (R$)"}}

/***/ }),
/* 2039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ListFooter=exports.ListContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n        justify-content: center;\n        width: ',';\n    '],['\n        justify-content: center;\n        width: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ListContainer=exports.ListContainer=_styledComponents2.default.ul.withConfig({displayName:'styles__ListContainer',componentId:'sc-y0ty3u-0'})(['list-style:none;margin:0;padding:0;min-height:560px;']);var ListFooter=exports.ListFooter=_styledComponents2.default.div.withConfig({displayName:'styles__ListFooter',componentId:'sc-y0ty3u-1'})(['',' display:flex;justify-content:flex-start;padding:',' ',';',';'],_content2.default,(0,_rem2.default)('40px'),(0,_rem2.default)('30px'),_media2.default.small(_templateObject,(0,_rem2.default)('180px')));

/***/ }),
/* 2040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardHowToInstall/index.js';// Styles
// Component
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _style=__webpack_require__(2041);var _HowToInstall=__webpack_require__(2042);var _HowToInstall2=_interopRequireDefault(_HowToInstall);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DashboardHowToInstall=function DashboardHowToInstall(){return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:10}},_react2.default.createElement(_reactHelmet2.default,{title:'Como instalar',__source:{fileName:_jsxFileName,lineNumber:11}}),_react2.default.createElement(_style.Content,{__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_HowToInstall2.default,{__source:{fileName:_jsxFileName,lineNumber:13}})));};exports.default=DashboardHowToInstall;module.exports=exports['default'];

/***/ }),
/* 2041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n      margin: ',' auto;\n  '],['\n      margin: ',' auto;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'style__Content',componentId:'sc-stet7y-0'})(['',';margin:',' auto;',';'],_content2.default,(0,_rem2.default)('42px'),_media2.default.small(_templateObject,(0,_rem2.default)('29px')));

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/HowToInstall/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Option=__webpack_require__(403);var _Option2=_interopRequireDefault(_Option);var _styles=__webpack_require__(2044);var _data=__webpack_require__(2045);var _icCarBig=__webpack_require__(2046);var _icCarBig2=_interopRequireDefault(_icCarBig);var _icBusBig=__webpack_require__(2047);var _icBusBig2=_interopRequireDefault(_icBusBig);var _icTruckBig=__webpack_require__(2048);var _icTruckBig2=_interopRequireDefault(_icTruckBig);var _truck=__webpack_require__(2049);var _truck2=_interopRequireDefault(_truck);var _car=__webpack_require__(2050);var _car2=_interopRequireDefault(_car);var _bus=__webpack_require__(2051);var _bus2=_interopRequireDefault(_bus);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var handleClickDownload=function handleClickDownload(path){window.open(path,'_blank');};var HowToInstall=function HowToInstall(props){return _react2.default.createElement(_styles.WrapperInstall,{__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_styles.TextInstall,{textWhite:props.textWhite,__source:{fileName:_jsxFileName,lineNumber:22}},_data.installText),_react2.default.createElement(_styles.List,{__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(_Option2.default,{description:_data.carType.car,icon:_react2.default.createElement(_icCarBig2.default,{__source:{fileName:_jsxFileName,lineNumber:26}}),setOption:function setOption(){return handleClickDownload(_car2.default);},value:'carro-passeio',notGray:true,className:'gtm-element-event','data-gtm-event-category':'veloe:area-logado:identificadores','data-gtm-event-action':'clique:como-instalar','data-gtm-event-label':'carro-passeio',__source:{fileName:_jsxFileName,lineNumber:24}}),_react2.default.createElement(_Option2.default,{description:_data.carType.truck,icon:_react2.default.createElement(_icTruckBig2.default,{__source:{fileName:_jsxFileName,lineNumber:37}}),value:'caminhao',setOption:function setOption(){return handleClickDownload(_truck2.default);},notGray:true,className:'gtm-element-event','data-gtm-event-category':'veloe:area-logado:identificadores','data-gtm-event-action':'clique:como-instalar','data-gtm-event-label':'caminhao',__source:{fileName:_jsxFileName,lineNumber:35}}),_react2.default.createElement(_Option2.default,{description:_data.carType.bus,icon:_react2.default.createElement(_icBusBig2.default,{__source:{fileName:_jsxFileName,lineNumber:48}}),value:'onibus',setOption:function setOption(){return handleClickDownload(_bus2.default);},notGray:true,className:'gtm-element-event','data-gtm-event-category':'veloe:area-logado:identificadores','data-gtm-event-action':'clique:como-instalar','data-gtm-event-label':'onibus',__source:{fileName:_jsxFileName,lineNumber:46}})));};exports.default=HowToInstall;module.exports=exports['default'];

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Description=exports.Icon=exports.Wrap=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _hexToRgba=__webpack_require__(187);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Wrap=exports.Wrap=_styledComponents2.default.li.withConfig({displayName:'styles__Wrap',componentId:'sc-4ow1j7-0'})(['background-color:',';border-radius:8px;border:solid 2px ',';display:flex;min-width:280px;padding:14px 13px;align-items:center;&:hover{cursor:pointer;}',';'],_colors.white,_colors.paleGrayThree,function(_ref){var active=_ref.active;return active&&'\n    border: solid 2px '+_colors.tealish+';\n    box-shadow: 0 4px 12px 0 '+(0,_hexToRgba.hexToRgba)(_colors.tealish,0.24)+';\n  ';});var Icon=exports.Icon=_styledComponents2.default.span.withConfig({displayName:'styles__Icon',componentId:'sc-4ow1j7-1'})(['position:relative;svg path{',';',';}'],function(_ref2){var notGray=_ref2.notGray;return!notGray&&'fill: '+_colors.blueGray+';';},function(_ref3){var active=_ref3.active;return active&&'fill: '+_colors.tealish+';';});var Description=exports.Description=_styledComponents2.default.p.withConfig({displayName:'styles__Description',componentId:'sc-4ow1j7-2'})(['',';color:',';font-weight:bold;line-height:1.38;margin:0 0 0 16px;',';'],_types.txt16OpenSans,_colors.blueGray,function(_ref4){var active=_ref4.active;return active&&'color: '+_colors.darkBlue+';';});

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.List=exports.TextInfo=exports.TextInstall=exports.WrapperInstall=undefined;var _templateObject=_taggedTemplateLiteral(['\n    flex-direction: column;\n  '],['\n    flex-direction: column;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n      max-width: 100%;\n      min-width: 100%;\n      margin-bottom: 10px;\n      padding-top: 0;\n      padding-bottom: 0;\n    '],['\n      max-width: 100%;\n      min-width: 100%;\n      margin-bottom: 10px;\n      padding-top: 0;\n      padding-bottom: 0;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _hexToRgba=__webpack_require__(187);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var WrapperInstall=exports.WrapperInstall=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperInstall',componentId:'sc-1e6a4z1-0'})(['margin:50px 0 0;']);var TextInstall=exports.TextInstall=_styledComponents2.default.div.withConfig({displayName:'styles__TextInstall',componentId:'sc-1e6a4z1-1'})(['',' color:',';letter-spacing:',';font-size:',';margin:',' 0 !important;'],_types.title40GalanoBold,function(_ref){var textWhite=_ref.textWhite;return textWhite?''+_colors.white:''+_colors.darkSlateBlue;},(0,_rem2.default)('0.4px'),(0,_rem2.default)('32px'),(0,_rem2.default)('15px'));var TextInfo=exports.TextInfo=_styledComponents2.default.p.withConfig({displayName:'styles__TextInfo',componentId:'sc-1e6a4z1-2'})(['',';font-weight:bold;letter-spacing:normal;font-weight:normal;line-height:1.57;color:',';margin-top:',';padding-bottom:',';'],_types.txt14OpenSans,_colors.darkSlateBlue,(0,_rem2.default)('40px'),(0,_rem2.default)('40px'));var List=exports.List=_styledComponents2.default.ul.withConfig({displayName:'styles__List',componentId:'sc-1e6a4z1-3'})(['display:flex;align-items:center;justify-content:space-between;margin:0;padding:0;',';li{min-height:160px;min-width:296px;max-width:296px;align-items:flex-start;flex-direction:column;justify-content:flex-end;padding:15px;',';&:hover{border:solid 2px ',';box-shadow:0 4px 12px 0 ',';svg{opacity:1;filter:grayscale(0);}p{color:',';}}}p{font-size:18px;margin:0;line-height:1.22;letter-spacing:normal;text-align:left;margin-top:20px;}svg{opacity:0.64;filter:grayscale(100%);}'],_media2.default.small(_templateObject),_media2.default.small(_templateObject2),_colors.tealish,(0,_hexToRgba.hexToRgba)(_colors.tealish,0.24),_colors.darkBlue);

/***/ }),
/* 2045 */
/***/ (function(module, exports) {

module.exports = {"installText":"Como instalar?","infoText":"Você pode sempre consultar esses passo-a-passo em caso de dúvida","carType":{"car":"Carro de passeio e utilitário","truck":"Caminhão","bus":"Ônibus"}}

/***/ }),
/* 2046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-car-big.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IcCarBig=function IcCarBig(props){return _react2.default.createElement("svg",{width:"106px",height:"40px",viewBox:"0 0 106 40",__source:{fileName:_jsxFileName,lineNumber:4}},_react2.default.createElement("g",{id:"1A---1o-Acesso",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("g",{id:"1A---7.5-Sucesso-(Varios)",transform:"translate(-276.000000, -618.000000)",__source:{fileName:_jsxFileName,lineNumber:6}},_react2.default.createElement("g",{id:"carro",transform:"translate(276.000000, 618.000000)",__source:{fileName:_jsxFileName,lineNumber:7}},_react2.default.createElement("g",{id:"Group",transform:"translate(2.211930, 3.333333)",fill:"#C5168C",fillRule:"nonzero",__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement("path",{d:"M57.7589219,1.05128205 C57.5350501,1.12820513 57.261429,1.20512821 57.1619304,1.23076923 C57.1121811,1.25641026 57.0375572,1.28205128 57.0375572,1.35897436 C57.0375572,1.38461538 57.0624319,1.43589744 57.0873065,1.46153846 C57.1868051,1.58974359 57.3360529,1.61538462 57.4853008,1.69230769 C57.5350501,1.71794872 57.5847994,1.76923077 57.6345487,1.79487179 C57.6594233,1.79487179 57.7091726,1.82051282 57.7837965,1.87179487 C57.8584204,1.92307692 57.957919,2 58.0822922,2.05128205 C58.1569162,2.1025641 58.2315401,2.15384615 58.3310387,2.20512821 C58.4056626,2.25641026 58.4802865,2.30769231 58.5549105,2.35897436 C58.6295344,2.41025641 58.7041583,2.46153846 58.7539076,2.51282051 C58.8036569,2.56410256 58.8782808,2.61538462 58.9777794,2.66666667 C59.0524033,2.71794872 59.1519019,2.79487179 59.2265258,2.87179487 C59.3260244,2.94871795 59.425523,3 59.5001469,3.07692308 C59.5996455,3.15384615 59.6742694,3.20512821 59.773768,3.28205128 C59.8483919,3.33333333 59.9230158,3.41025641 59.9976398,3.43589744 C60.0722637,3.48717949 60.122013,3.51282051 60.1468876,3.53846154 C60.1717623,3.56410256 60.2215116,3.58974359 60.2961355,3.64102564 C60.3707594,3.69230769 60.4453834,3.74358974 60.5200073,3.79487179 C60.6195059,3.84615385 60.7190044,3.92307692 60.818503,3.97435897 C60.9180016,4.05128205 61.0175002,4.12820513 61.1418734,4.17948718 C61.2413719,4.25641026 61.3408705,4.33333333 61.4652437,4.41025641 C61.5896169,4.48717949 61.6642409,4.56410256 61.7388648,4.61538462 C61.8134887,4.66666667 61.8881127,4.71794872 61.937862,4.76923077 C62.0622352,4.87179487 62.1617337,4.94871795 62.2612323,5.02564103 C62.3607309,5.1025641 62.4353548,5.17948718 62.5348534,5.25641026 C62.5846027,5.30769231 62.6592266,5.35897436 62.7089759,5.38461538 C62.7587252,5.43589744 62.8084745,5.48717949 62.8830984,5.51282051 C62.9328477,5.56410256 62.982597,5.61538462 63.0323463,5.66666667 C63.0820956,5.71794872 63.1815941,5.82051282 63.330842,5.94871795 C63.4054659,6 63.4800898,6.07692308 63.5795884,6.15384615 C63.679087,6.23076923 63.7785856,6.30769231 63.9029588,6.38461538 C64.027332,6.46153846 64.1268306,6.53846154 64.2512038,6.61538462 C64.3009531,6.66666667 64.375577,6.69230769 64.4253263,6.74358974 C64.4750756,6.79487179 64.5496995,6.82051282 64.5994488,6.87179487 C64.6491981,6.92307692 64.723822,6.94871795 64.7735713,7 C64.9476938,7.12820513 65.1218163,7.25641026 65.2959388,7.38461538 C65.5198106,7.53846154 65.7188077,7.69230769 65.8929302,7.82051282 C66.0670528,7.94871795 66.2163006,8.02564103 66.2909245,8.07692308 C66.539671,8.23076923 66.7635428,8.38461538 66.9625399,8.51282051 C67.584406,8.92307692 68.0321496,9.25641026 68.6788903,9.61538462 C68.7783889,9.66666667 68.8778875,9.71794872 69.0022607,9.76923077 C69.9226225,10.2051282 70.8181096,9.84615385 71.7135968,9.51282051 C71.5892236,9.41025641 71.4399757,9.28205128 71.3156025,9.17948718 C71.0917307,9 70.8927336,8.82051282 70.6688618,8.64102564 C70.4201153,8.43589744 70.1713689,8.23076923 69.9226225,8.02564103 C69.673876,7.82051282 69.400255,7.64102564 69.1515085,7.43589744 C68.9027621,7.23076923 68.629141,7.07692308 68.3555199,6.87179487 C68.0818989,6.69230769 67.8082778,6.51282051 67.5346567,6.33333333 C67.2610356,6.15384615 66.9625399,5.97435897 66.6889188,5.79487179 C66.4152978,5.61538462 66.116802,5.41025641 65.843181,5.23076923 C65.5944345,5.05128205 65.3456881,4.8974359 65.0969417,4.71794872 C64.8233206,4.53846154 64.5745742,4.38461538 64.3009531,4.20512821 C64.027332,4.05128205 63.7537109,3.8974359 63.4800898,3.74358974 C63.2064688,3.58974359 62.9328477,3.46153846 62.6841013,3.33333333 C62.634352,3.30769231 62.559728,3.25641026 62.5099788,3.23076923 C62.2363577,3.05128205 61.9627366,2.87179487 61.6891155,2.69230769 C61.4154944,2.51282051 61.1418734,2.33333333 60.8682523,2.15384615 C60.5946312,1.97435897 60.3210101,1.79487179 60.0473891,1.64102564 C59.773768,1.48717949 59.4752723,1.30769231 59.2016512,1.17948718 C59.1767765,1.17948718 59.1519019,1.15384615 59.1270273,1.15384615 C58.9777794,1.05128205 58.8285315,0.948717949 58.6792837,0.871794872 C58.5549105,0.794871795 58.4056626,0.743589744 58.2812894,0.692307692 C58.1569162,0.871794872 57.957919,0.974358974 57.7589219,1.05128205 Z",id:"Shape",__source:{fileName:_jsxFileName,lineNumber:9}}),_react2.default.createElement("path",{d:"M0.29849572,9.12820513 C0.37311965,9.1025641 0.44774358,9.1025641 0.52236751,9.1025641 C0.646740727,9.1025641 0.746239301,9.12820513 0.870612517,9.12820513 C0.970111091,9.12820513 1.06960966,9.12820513 1.16910824,9.12820513 C1.26860681,9.12820513 1.36810538,9.1025641 1.46760396,9.07692308 C1.56710253,9.05128205 1.6666011,9 1.79097432,8.94871795 C1.8904729,8.8974359 1.98997147,8.84615385 2.08947004,8.76923077 C2.18896862,8.71794872 2.28846719,8.64102564 2.38796576,8.58974359 C2.48746434,8.51282051 2.56208827,8.46153846 2.6367122,8.38461538 C3.50732471,7.66666667 4.32818794,6.8974359 5.17392582,6.15384615 C6.04453834,5.38461538 6.96490014,4.69230769 7.81063801,3.87179487 C8.65637589,3.07692308 9.45236448,2.17948718 10.3478516,1.43589744 C10.5468488,1.28205128 10.7458459,1.1025641 10.9199684,0.948717949 C11.0692163,0.820512821 11.3428374,0.717948718 11.4423359,0.564102564 C11.4672106,0.512820513 11.4672106,0.435897436 11.4423359,0.41025641 C11.4174613,0.41025641 11.3925867,0.384615385 11.367712,0.384615385 C11.0940909,0.358974359 10.8453445,0.41025641 10.5717234,0.435897436 C10.4970995,0.435897436 10.4224756,0.461538462 10.3478516,0.435897436 C10.2234784,0.41025641 10.0991052,0.358974359 9.99960663,0.230769231 C9.99960663,0.230769231 9.97473199,0.205128205 9.97473199,0.205128205 C9.94985734,0.205128205 9.94985734,0.230769231 9.9249827,0.230769231 C9.82548413,0.282051282 9.72598555,0.358974359 9.62648698,0.435897436 C9.52698841,0.512820513 9.42748983,0.564102564 9.30311662,0.641025641 C9.20361804,0.717948718 9.10411947,0.794871795 8.97974625,0.871794872 C8.80562375,1 8.65637589,1.1025641 8.48225338,1.23076923 C8.35788017,1.33333333 8.23350695,1.43589744 8.08425909,1.53846154 C7.95988587,1.64102564 7.83551266,1.74358974 7.71113944,1.84615385 C7.58676622,1.94871795 7.46239301,2.05128205 7.33801979,2.17948718 C7.21364657,2.28205128 7.08927336,2.38461538 6.96490014,2.51282051 C6.84052692,2.61538462 6.74102835,2.71794872 6.61665513,2.84615385 C6.49228192,2.97435897 6.39278334,3.07692308 6.29328477,3.17948718 C6.1937862,3.25641026 6.09428762,3.33333333 5.99478905,3.43589744 C5.89529048,3.51282051 5.7957919,3.58974359 5.69629333,3.69230769 C5.52217082,3.82051282 5.37292296,3.94871795 5.2236751,4.07692308 C5.07442724,4.20512821 4.92517938,4.33333333 4.77593152,4.46153846 C4.67643295,4.53846154 4.57693438,4.64102564 4.4774358,4.71794872 C4.37793723,4.79487179 4.27843866,4.8974359 4.17894008,4.97435897 C4.07944151,5.05128205 3.97994294,5.15384615 3.90531901,5.23076923 C3.75607115,5.35897436 3.63169793,5.51282051 3.48245007,5.64102564 C3.33320221,5.79487179 3.18395435,5.92307692 3.00983185,6.07692308 C2.83570934,6.23076923 2.68646148,6.38461538 2.51233898,6.53846154 C2.33821648,6.69230769 2.18896862,6.84615385 2.03972076,7 C1.8904729,7.15384615 1.74122503,7.30769231 1.61685182,7.46153846 C1.46760396,7.61538462 1.34323074,7.76923077 1.19398288,7.94871795 C1.04473502,8.1025641 0.895487161,8.28205128 0.746239301,8.46153846 C0.671615371,8.53846154 0.596991441,8.64102564 0.52236751,8.71794872 C0.44774358,8.79487179 0.37311965,8.8974359 0.273621077,9 C0.22387179,9.05128205 0.198997147,9.12820513 0.174122503,9.17948718 C0.248746434,9.17948718 0.273621077,9.15384615 0.29849572,9.12820513 Z",id:"Shape",__source:{fileName:_jsxFileName,lineNumber:10}})),_react2.default.createElement("path",{d:"M104.843805,24.5613565 C104.843805,24.5095939 104.819043,24.4578313 104.794281,24.43195 C104.769518,24.4060687 104.744756,24.4060687 104.719994,24.4060687 C104.249509,24.43195 103.803787,24.4578313 103.333302,24.4837126 C102.912342,24.5095939 102.46662,24.5872378 102.04566,24.5872378 C101.773274,24.5872378 101.52565,24.5613565 101.253264,24.5872378 C101.030403,24.6131191 100.807542,24.4837126 100.658968,24.3025435 C100.510394,24.0954931 100.436107,23.8366801 100.386582,23.577867 C100.312295,23.1378849 100.26277,22.723784 100.287532,22.2838019 C100.287532,22.0249888 100.337057,21.7661758 100.386582,21.5332441 C100.460869,21.3003124 100.584681,21.0673806 100.758017,20.9120928 C100.931354,20.756805 101.154215,20.6532798 101.377076,20.5497546 C101.897085,20.3168228 102.342808,20.0062472 102.88758,19.8250781 C102.912342,19.8250781 102.937104,19.7991968 102.937104,19.7991968 C102.937104,19.7733155 102.937104,19.7474342 102.912342,19.7215529 C102.813292,19.5662651 102.689481,19.5403838 102.565669,19.4109772 C102.441857,19.2815707 102.293283,19.1780455 102.169471,19.048639 C102.095184,18.9968764 102.04566,18.9451138 101.971372,18.8933512 C101.897085,18.8415886 101.822798,18.8415886 101.748511,18.8674699 C101.674224,18.8933512 101.599937,18.9451138 101.52565,18.9968764 C101.302789,19.1521642 101.030403,19.2815707 100.758017,19.2556894 C100.460869,19.2039268 100.238008,19.0227577 99.9903842,18.8674699 C99.8665724,18.789826 99.7179983,18.7121821 99.5941865,18.6604195 C99.4456124,18.5827755 99.2970383,18.5310129 99.1484641,18.453369 C98.99989,18.3757251 98.8513159,18.3239625 98.6779794,18.2463186 C98.5046429,18.1686747 98.3560688,18.1169121 98.2074947,18.0651495 C98.0589206,18.0133869 97.8855841,17.935743 97.73701,17.8839804 C97.5389111,17.8063365 97.3655747,17.7545739 97.1674758,17.6769299 C96.969377,17.599286 96.7960405,17.5475234 96.5979417,17.4698795 C96.4246052,17.4181169 96.2265064,17.340473 96.0779323,17.2887104 C95.9293582,17.2369478 95.7312593,17.1851852 95.5826852,17.1334226 C95.4341111,17.08166 95.2607746,17.0298974 95.1369628,17.0040161 C95.0131511,16.9781348 94.864577,16.9263722 94.7407652,16.8746095 C94.6169534,16.8487282 94.517904,16.7969656 94.4188546,16.7710843 C94.2950428,16.745203 94.171231,16.6934404 94.0226569,16.6675591 C93.8740828,16.6416778 93.7255087,16.5899152 93.5769346,16.5640339 C93.4283604,16.5381526 93.255024,16.48639 93.0816875,16.4605087 C92.908351,16.4346274 92.7350145,16.3828648 92.5616781,16.3569835 C91.4721345,16.1240518 90.2587792,15.8652387 89.268285,15.632307 C88.0549297,15.3217314 86.8663367,15.2440875 86.0244167,15.2182062 C85.8758426,15.2182062 85.7520308,15.2182062 85.6529814,15.1923249 C85.5291696,15.1923249 85.4301202,15.1923249 85.3558331,15.1664436 C85.2815461,15.1664436 85.1577343,15.1405622 85.0339225,15.1405622 C84.9101108,15.1146809 84.7367743,15.0887996 84.5882002,15.0629183 C84.4148637,15.037037 84.2415272,15.0111557 84.0434284,14.9593931 C83.8453296,14.9335118 83.6472307,14.9076305 83.4243695,14.8817492 C83.3253201,14.8817492 83.2015084,14.8558679 83.102459,14.8558679 C83.0034095,14.8558679 82.8795978,14.8299866 82.7805484,14.8299866 C82.5576872,14.8041053 82.3595883,14.8041053 82.1614895,14.778224 C81.9633907,14.7523427 81.7900542,14.7523427 81.6414801,14.7264614 C81.492906,14.7005801 81.3443318,14.6746988 81.2452824,14.6488175 C81.1709954,14.6229362 81.0471836,14.6229362 80.9233718,14.5970549 C79.7843036,14.4158858 77.2090188,14.2605979 76.2680493,14.1570727 C75.2032681,14.0535475 75.2280305,13.5359215 75.3023175,13.1735832 C75.3766046,12.811245 74.7823081,12.6818385 74.7823081,12.6818385 L74.8813575,12.7077198 C74.7575458,12.6559572 74.6089716,12.6041946 74.4851599,12.552432 C74.3861105,12.5006693 74.287061,12.474788 74.1880116,12.4489067 C74.1384869,12.4489067 74.0641999,12.4489067 74.0146752,12.4489067 C73.8413387,12.4489067 73.6927646,12.474788 73.445141,12.5783133 C72.5289339,12.9147702 71.6622516,13.2771084 70.7212821,12.8371263 C70.6222327,12.7853637 70.5231833,12.7336011 70.3993715,12.6818385 C69.7555503,12.3195002 69.309828,11.9830433 68.6907691,11.5689424 C68.4926703,11.4395359 68.2698091,11.2842481 68.0221856,11.1289603 C67.9231361,11.0771977 67.7993244,10.9736725 67.6259879,10.8701473 C67.4526514,10.7407407 67.2545526,10.6113342 67.0316914,10.4301651 C66.8583549,10.3007586 66.6850185,10.1713521 66.511682,10.0419456 C66.4621573,9.99018295 66.3878702,9.96430165 66.3383455,9.91253905 C66.2888208,9.86077644 66.2145337,9.83489514 66.165009,9.78313253 C66.1154843,9.73136992 66.0411973,9.70548862 65.9916726,9.65372602 C65.8678608,9.57608211 65.744049,9.4984382 65.6449996,9.42079429 C65.5211878,9.34315038 65.4221384,9.26550647 65.323089,9.18786256 C65.2240396,9.11021865 65.1497525,9.05845605 65.0754655,8.98081214 C64.9268914,8.85140562 64.8278419,8.77376171 64.7783172,8.6961178 C64.7287925,8.6443552 64.6792678,8.59259259 64.6297431,8.54082999 C64.5802184,8.48906738 64.5306937,8.43730477 64.4564066,8.41142347 C64.4068819,8.35966087 64.3325949,8.30789826 64.2830702,8.28201696 C64.2087831,8.20437305 64.1097337,8.12672914 64.0106843,8.04908523 C63.9116348,7.97144132 63.8125854,7.89379741 63.6887737,7.7902722 C63.639249,7.73850959 63.5649619,7.68674699 63.4906748,7.63498438 C63.4163878,7.55734047 63.3173384,7.50557787 63.2182889,7.42793396 C63.1192395,7.35029005 63.0201901,7.27264614 62.8963783,7.19500223 C62.7973289,7.11735832 62.6735172,7.03971441 62.5744678,6.98795181 C62.4754183,6.9103079 62.3763689,6.85854529 62.2773195,6.80678269 C62.1782701,6.75502008 62.103983,6.70325747 62.0544583,6.65149487 C61.9801713,6.59973226 61.9306466,6.57385096 61.9058842,6.54796966 C61.8811218,6.52208835 61.8068348,6.49620705 61.7573101,6.44444444 C61.7077854,6.39268184 61.608736,6.34091923 61.5344489,6.28915663 C61.4601618,6.23739402 61.3611124,6.15975011 61.262063,6.0821062 C61.1630136,6.00446229 61.0639642,5.95269969 60.9896771,5.87505578 C60.8906277,5.79741187 60.8163406,5.74564926 60.7420536,5.66800535 C60.6677665,5.61624275 60.5934795,5.56448014 60.5191924,5.51271754 C60.4449053,5.46095493 60.3953806,5.40919232 60.3210936,5.35742972 C60.2468065,5.30566711 60.1725194,5.25390451 60.0982324,5.2021419 C60.0239453,5.15037929 59.9496583,5.09861669 59.8506088,5.04685408 C59.7267971,4.96921017 59.6277477,4.89156627 59.5534606,4.86568496 C59.4791735,4.81392236 59.4296488,4.78804105 59.4048865,4.78804105 C59.3553618,4.76215975 59.3058371,4.71039714 59.2563124,4.68451584 C59.1325006,4.60687193 58.9839265,4.58099063 58.8601147,4.45158411 C58.8353523,4.42570281 58.81059,4.39982151 58.81059,4.3480589 C58.81059,4.2962963 58.8848771,4.24453369 58.9344018,4.21865239 C59.0582135,4.16688978 59.3058371,4.11512718 59.5286982,4.03748327 C59.7515594,3.95983936 59.9744206,3.83043284 59.999183,3.70102633 C60.0239453,3.57161981 59.9496583,3.41633199 59.8258465,3.26104418 C59.7020347,3.10575636 59.578223,2.97634984 59.4791735,2.89870593 C59.3058371,2.74341812 59.1325006,2.6398929 58.9591641,2.51048639 C58.7858276,2.40696118 58.6124912,2.32931727 58.4391547,2.25167336 C58.2658182,2.17402945 58.0677194,2.09638554 57.8943829,2.04462294 C57.6962841,1.96697903 57.4734229,1.88933512 57.2505617,1.83757251 C57.0277005,1.78580991 56.8048393,1.708166 56.5819782,1.65640339 C56.433404,1.60464079 56.2600676,1.57875948 56.1114934,1.52699688 C55.9629193,1.47523427 55.7895828,1.44935297 55.6410087,1.39759036 C55.4924346,1.34582776 55.3190981,1.31994645 55.170524,1.26818385 C55.0219499,1.21642124 54.8486134,1.19053994 54.7000393,1.13877733 C54.5514652,1.08701473 54.3781287,1.06113342 54.2295546,1.03525212 C54.0809804,1.00937082 53.907644,0.983489514 53.7590698,0.957608211 C53.5857334,0.931726908 53.4123969,0.905845605 53.2142981,0.879964302 C53.0409616,0.854082999 52.8428628,0.828201696 52.6695263,0.802320393 C52.5457145,0.77643909 52.4219027,0.77643909 52.298091,0.750557787 C52.1247545,0.724676484 51.9761804,0.698795181 51.8028439,0.698795181 C51.6295074,0.672913878 51.4809333,0.672913878 51.3075968,0.647032575 C51.1342604,0.621151272 50.9856862,0.621151272 50.8123498,0.621151272 C50.6390133,0.621151272 50.4904392,0.595269969 50.3171027,0.595269969 C50.1437662,0.569388666 49.9951921,0.569388666 49.8218556,0.543507363 C49.6485191,0.51762606 49.499945,0.51762606 49.3266085,0.491744757 C49.1532721,0.465863454 49.0046979,0.439982151 48.8313615,0.439982151 C48.658025,0.414100848 48.4599262,0.388219545 48.2865897,0.362338242 C48.1132532,0.336456939 47.9151544,0.310575636 47.7418179,0.310575636 C47.5684814,0.284694333 47.3703826,0.284694333 47.1722838,0.25881303 C47.0237096,0.25881303 46.8503732,0.232931727 46.701799,0.232931727 C46.5532249,0.232931727 46.3798884,0.207050424 46.2313143,0.207050424 C46.0827402,0.207050424 45.9094037,0.181169121 45.7608296,0.181169121 C45.6122555,0.181169121 45.438919,0.181169121 45.2903449,0.155287818 C45.1417708,0.155287818 44.9684343,0.155287818 44.8198602,0.129406515 C44.671286,0.129406515 44.5227119,0.129406515 44.3493754,0.103525212 C44.176039,0.103525212 43.9779401,0.103525212 43.7798413,0.077643909 C43.5817425,0.077643909 43.408406,0.077643909 43.2103072,0.051762606 C43.0122083,0.051762606 42.8388719,0.051762606 42.6655354,0.025881303 C42.4921989,0.025881303 42.2941001,0.025881303 42.1207636,0 C41.9474271,0 41.7493283,0 41.5759918,0 C41.4026554,0 41.2045565,0 41.0064577,0 C40.8083589,0 40.6350224,0 40.4369236,0.025881303 C40.2635871,0.025881303 40.0902506,0.051762606 39.9169141,0.051762606 C39.7435777,0.051762606 39.5702412,0.077643909 39.3969047,0.077643909 C39.2235682,0.077643909 39.0502318,0.077643909 38.9016576,0.103525212 C38.7283212,0.103525212 38.5549847,0.103525212 38.4064106,0.103525212 C38.2330741,0.103525212 38.0845,0.103525212 37.9111635,0.103525212 C37.7873517,0.103525212 37.6635399,0.103525212 37.5397282,0.103525212 C37.4159164,0.103525212 37.2921046,0.103525212 37.1682929,0.103525212 C37.0444811,0.103525212 36.9206693,0.103525212 36.7968576,0.103525212 C36.6730458,0.103525212 36.549234,0.103525212 36.4254223,0.103525212 C36.2768481,0.103525212 36.128274,0.103525212 35.9796999,0.103525212 C35.8311258,0.103525212 35.6825517,0.103525212 35.5339775,0.129406515 C35.3854034,0.129406515 35.2368293,0.155287818 35.0882552,0.155287818 C34.939681,0.155287818 34.7911069,0.181169121 34.6425328,0.181169121 C34.4939587,0.181169121 34.3453846,0.207050424 34.1968104,0.207050424 C34.0482363,0.207050424 33.8996622,0.232931727 33.7510881,0.232931727 C33.6025139,0.232931727 33.4539398,0.232931727 33.3053657,0.25881303 C33.1567916,0.25881303 33.0082175,0.25881303 32.8596433,0.25881303 C32.6615445,0.25881303 32.488208,0.25881303 32.2901092,0.25881303 C32.0920104,0.25881303 31.9186739,0.25881303 31.7205751,0.25881303 C31.5224762,0.25881303 31.3243774,0.25881303 31.1510409,0.284694333 C30.9529421,0.284694333 30.7548433,0.310575636 30.5815068,0.310575636 C30.383408,0.310575636 30.1853091,0.336456939 30.0119727,0.336456939 C29.8386362,0.336456939 29.615775,0.362338242 29.4424385,0.362338242 C29.2443397,0.362338242 29.0462409,0.388219545 28.8729044,0.388219545 C28.6748056,0.388219545 28.5014691,0.388219545 28.3033703,0.388219545 C28.1052714,0.388219545 27.931935,0.388219545 27.7338361,0.388219545 C27.5357373,0.388219545 27.3624008,0.388219545 27.164302,0.414100848 C27.0404902,0.414100848 26.9166785,0.414100848 26.7928667,0.439982151 C26.6690549,0.439982151 26.5452431,0.439982151 26.4214314,0.465863454 C26.2976196,0.465863454 26.1738078,0.465863454 26.0499961,0.491744757 C25.9261843,0.491744757 25.8023725,0.491744757 25.6785608,0.51762606 C25.5299866,0.51762606 25.3566502,0.543507363 25.208076,0.543507363 C25.0595019,0.543507363 24.8861654,0.569388666 24.7375913,0.569388666 C24.5890172,0.569388666 24.4156807,0.595269969 24.2671066,0.595269969 C24.1928195,0.595269969 24.0937701,0.595269969 24.0194831,0.621151272 C23.8709089,0.621151272 23.7223348,0.621151272 23.5737607,0.621151272 C23.4251866,0.621151272 23.2766125,0.621151272 23.1280383,0.647032575 C22.8308901,0.647032575 22.5337418,0.672913878 22.2365936,0.698795181 C22.1623065,0.698795181 22.0880195,0.698795181 22.0137324,0.698795181 C21.9642077,0.698795181 21.914683,0.698795181 21.8651583,0.698795181 C21.6918218,0.698795181 21.5184853,0.698795181 21.3699112,0.724676484 C21.2213371,0.724676484 21.0480006,0.750557787 20.8746642,0.750557787 C20.7013277,0.77643909 20.5527536,0.77643909 20.3794171,0.802320393 C20.2060806,0.828201696 20.0327441,0.828201696 19.8346453,0.854082999 C19.6613088,0.879964302 19.46321,0.879964302 19.2651112,0.905845605 C19.0670123,0.931726908 18.8936759,0.957608211 18.695577,0.983489514 C18.4974782,1.00937082 18.3241417,1.03525212 18.1260429,1.06113342 C17.9279441,1.08701473 17.7546076,1.11289603 17.5812711,1.11289603 C17.4079346,1.13877733 17.2098358,1.13877733 17.0364993,1.16465863 C16.8384005,1.19053994 16.665064,1.19053994 16.4917276,1.21642124 C16.3183911,1.24230254 16.1202922,1.26818385 15.9469558,1.29406515 C15.7736193,1.31994645 15.6002828,1.37170906 15.402184,1.42347166 C15.2040852,1.47523427 15.055511,1.52699688 14.8821746,1.57875948 C14.7088381,1.63052209 14.5355016,1.708166 14.3621651,1.7599286 C14.213591,1.81169121 14.0650169,1.86345382 13.9412051,1.91521642 C13.792631,1.96697903 13.6688192,2.01874163 13.5202451,2.09638554 C13.371671,2.14814815 13.2478592,2.22579206 13.1240475,2.30343597 C13.0002357,2.38107988 12.8516616,2.45872378 12.7278498,2.53636769 C12.6288004,2.6140116 12.5049886,2.69165551 12.4059392,2.76929942 C12.3068898,2.84694333 12.2078404,2.89870593 12.1335533,2.95046854 C12.0592662,3.00223115 11.9849792,3.05399375 11.9849792,3.15751896 C11.9849792,3.20928157 12.0097415,3.28692548 12.0592662,3.33868809 C12.1335533,3.4422133 12.2573651,3.51985721 12.4059392,3.54573851 C12.4802263,3.54573851 12.5545133,3.54573851 12.6288004,3.54573851 C12.9011863,3.51985721 13.1488098,3.4680946 13.4211957,3.4939759 C13.445958,3.4939759 13.4707204,3.4939759 13.4954828,3.51985721 C13.5450075,3.54573851 13.5450075,3.62338242 13.4954828,3.67514502 C13.3964333,3.80455154 13.1240475,3.93395805 12.9754733,4.06336457 C12.7773745,4.21865239 12.5792757,4.39982151 12.4059392,4.55510933 C11.5144945,5.30566711 10.7468615,6.21151272 9.88017912,7.01383311 C9.03825909,7.8161535 8.12205201,8.54082999 7.25536963,9.31726908 C6.4134496,10.0678269 5.59629193,10.844266 4.72960955,11.5689424 C4.65532249,11.6465863 4.55627308,11.698349 4.48198602,11.7759929 C4.3829366,11.8536368 4.28388719,11.9053994 4.18483777,11.957162 C4.08578836,12.0089246 3.98673894,12.0865685 3.88768953,12.1383311 C3.76387776,12.1900937 3.66482834,12.2418563 3.56577893,12.2677376 C3.46672952,12.2936189 3.3676801,12.3195002 3.26863069,12.3195002 C3.16958127,12.3195002 3.07053186,12.3195002 2.97148244,12.3195002 C2.87243303,12.3195002 2.74862126,12.2936189 2.62480949,12.2936189 C2.55052243,12.2936189 2.47623537,12.2936189 2.40194831,12.3195002 C2.3524236,12.3453815 2.30289889,12.3971441 2.25337418,12.4489067 C2.15432477,12.5783133 2.030513,12.7077198 1.93146359,12.811245 C1.83241417,12.9406515 1.7086024,13.0441767 1.60955299,13.1735832 C1.41145416,13.4323963 1.21335533,13.7170906 1.04001885,14.0017849 C0.866682379,14.2864793 0.817157671,14.6488175 0.767632964,15.0111557 C0.718108257,15.2958501 0.668583549,15.5805444 0.643821196,15.8652387 C0.544771781,16.5381526 0.594296488,17.2369478 0.619058842,17.9098617 C0.619058842,17.935743 0.619058842,17.9616243 0.619058842,18.0133869 C0.619058842,18.1427934 0.619058842,18.2721999 0.619058842,18.4016064 C0.619058842,18.5051316 0.619058842,18.5827755 0.643821196,18.6863008 C0.643821196,18.8157073 0.643821196,18.9451138 0.643821196,19.0745203 C0.619058842,19.6180277 0.668583549,20.1097724 0.74287061,20.6532798 C0.817157671,21.1450245 0.792395318,21.5332441 0.792395318,22.0249888 C0.792395318,22.1026328 0.792395318,22.206158 0.817157671,22.2838019 C0.718108257,22.3096832 0.619058842,22.3614458 0.47048472,22.4390897 C0.371435305,22.5167336 0.297148244,22.5943775 0.247623537,22.6979027 C0.198098829,22.8014279 0.148574122,22.9308344 0.0990494147,23.0861223 C0.0990494147,23.1378849 0.074287061,23.1637662 0.074287061,23.2155288 C0.0495247074,23.2931727 0.0247623537,23.3966979 0.0247623537,23.4743418 C0,23.577867 0,23.6555109 0,23.7590361 C0,23.8625614 0,23.9402053 0,24.0437305 C0,24.1472557 0,24.2507809 0.0247623537,24.3543061 C0.0247623537,24.4837126 0.0495247074,24.6131191 0.0495247074,24.7166444 C0.0495247074,24.8201696 0.074287061,24.9754574 0.074287061,25.0789826 C0.074287061,25.2083891 0.0990494147,25.3377956 0.0990494147,25.4672021 C0.0990494147,25.5966087 0.0990494147,25.7260152 0.0990494147,25.8554217 C0.0990494147,25.9848282 0.0990494147,26.1142347 0.0990494147,26.2436412 C0.0990494147,26.3730477 0.123811768,26.5024543 0.123811768,26.6318608 C0.148574122,26.7612673 0.148574122,26.8906738 0.173336476,27.0200803 C0.173336476,27.1236055 0.198098829,27.2012494 0.198098829,27.3047747 C0.198098829,27.3047747 0.198098829,27.3047747 0.198098829,27.330656 C0.173336476,27.6412316 0.148574122,27.9518072 0.222861183,28.2623829 C0.222861183,28.3141455 0.27238589,28.3400268 0.321910598,28.3400268 C1.18859298,28.2623829 2.05527536,28.2882642 2.92195773,28.2882642 C3.78864011,28.2882642 4.63056014,28.443552 5.47248016,28.443552 C6.16582607,28.443552 6.85917197,28.443552 7.55251787,28.4694333 C7.60204258,28.4694333 7.65156729,28.4694333 7.67632964,28.443552 C7.70109199,28.4176707 7.72585435,28.3917894 7.7506167,28.3400268 C7.94871553,27.8741633 8.12205201,27.4341812 8.32015084,26.9683177 C8.46872496,26.6059795 8.61729908,26.3730477 8.84016026,26.0624721 C9.33540734,25.3636769 9.92970383,24.8201696 10.5487627,24.2248996 C11.0935344,23.7072735 11.7125933,23.2414101 12.3811768,22.9049531 C12.9259486,22.6461401 13.445958,22.3614458 14.0402545,22.206158 C14.5850263,22.0767515 15.1050357,22.0249888 15.6498075,22.0249888 C16.2193417,22.0508701 16.7641134,21.8955823 17.3336476,21.9473449 C18.1508052,22.0249888 18.9679629,22.206158 19.7603582,22.4908523 C20.2803677,22.6979027 20.8251394,22.8790718 21.2708618,23.1896475 C21.4194359,23.2931727 21.6175348,23.319054 21.7413465,23.4225792 C22.0632571,23.6813922 22.4099301,23.914324 22.756603,24.1472557 C23.0042266,24.3284248 23.2766125,24.5354752 23.4994736,24.7425257 C24.2175819,25.4672021 24.6633043,26.2695225 25.0595019,27.2012494 C25.133789,27.3824186 25.2328384,27.589469 25.3071255,27.7706381 C25.3814125,27.9518072 25.4556996,28.1588577 25.5052243,28.3659081 C25.5299866,28.443552 25.554749,28.5211959 25.554749,28.5988398 C25.5795114,28.6764837 25.5795114,28.7541276 25.6042737,28.8317715 C25.6290361,28.9094154 25.6290361,28.9870593 25.6537984,29.0647033 C25.6785608,29.1423472 25.6785608,29.2199911 25.7033231,29.297635 C25.7280855,29.4011602 25.7528478,29.5046854 25.7776102,29.5823293 C25.8023725,29.6858545 25.8271349,29.7893797 25.8518972,29.892905 C25.8766596,29.9964302 25.8766596,30.0999554 25.9014219,30.2034806 C25.9261843,30.3070058 25.9261843,30.410531 25.9509467,30.5140562 C25.975709,30.6175814 25.975709,30.7211066 25.975709,30.8246319 C26.0004714,30.9281571 26.0004714,31.0316823 26.0252337,31.1352075 C26.0499961,31.2387327 26.0499961,31.3422579 26.0747584,31.4457831 C26.0995208,31.5493083 26.0995208,31.6528336 26.1242831,31.7563588 C26.1490455,31.8857653 26.1985702,31.9634092 26.2233325,32.0151718 C26.2976196,32.0928157 26.3719067,32.118697 26.4709561,32.1445783 C26.5700055,32.1445783 26.6938173,32.1445783 26.817629,32.1445783 C27.0157279,32.1445783 27.1890643,32.1704596 27.3871632,32.1704596 C27.585262,32.1704596 27.7585985,32.1963409 27.9566973,32.1963409 C28.1547961,32.1963409 28.3281326,32.2222222 28.5262314,32.2222222 C28.7243303,32.2222222 28.8976667,32.2222222 29.0957656,32.2222222 C29.2938644,32.2222222 29.4919632,32.2222222 29.6652997,32.2222222 C29.8633985,32.2222222 30.0614974,32.2222222 30.2348338,32.1963409 C30.4329327,32.1963409 30.6310315,32.1963409 30.804368,32.1704596 C31.0024668,32.1704596 31.2005656,32.1704596 31.3739021,32.1704596 C31.5720009,32.1704596 31.7700998,32.1704596 31.9434362,32.1704596 C32.1415351,32.1704596 32.3396339,32.1704596 32.5129704,32.1704596 C37.1435305,32.1963409 41.7740907,32.2222222 46.4046508,32.1963409 C48.0884908,32.1963409 49.7723309,32.1963409 51.4561709,32.1704596 C51.6542698,32.1704596 51.877131,32.1704596 52.0999921,32.1704596 C52.3228533,32.1704596 52.5209522,32.1704596 52.7438133,32.1704596 C52.9666745,32.1704596 53.1647734,32.1704596 53.3876345,32.1445783 C53.6104957,32.1445783 53.8085945,32.1445783 54.0314557,32.118697 C54.2543169,32.118697 54.4524157,32.118697 54.6752769,32.118697 C54.8733758,32.118697 55.0962369,32.118697 55.2943358,32.118697 C55.4924346,32.118697 55.7152958,32.118697 55.9133946,32.118697 C56.1114934,32.118697 56.3343546,32.118697 56.5324535,32.118697 C56.7305523,32.118697 56.9534135,32.118697 57.1515123,32.118697 C57.3496111,32.118697 57.5724723,32.118697 57.7705711,32.118697 C57.9191453,32.118697 58.042957,32.118697 58.1915311,32.118697 C58.3401053,32.118697 58.463917,32.118697 58.6124912,32.118697 C58.7610653,32.118697 58.8848771,32.118697 59.0334512,32.118697 C59.1820253,32.118697 59.3058371,32.118697 59.4544112,32.118697 C59.6029853,32.118697 59.7267971,32.118697 59.8753712,32.118697 C60.0239453,32.118697 60.1477571,32.118697 60.2963312,32.118697 C60.6925289,32.118697 61.0639642,32.118697 61.4601618,32.118697 C61.8563595,32.118697 62.2277948,32.118697 62.6239925,32.118697 C63.9859219,32.0928157 65.323089,32.0928157 66.6850185,32.0669344 C66.8831173,32.0669344 67.0812161,32.0669344 67.2545526,32.0669344 C67.4031267,32.0669344 67.5517008,32.0669344 67.700275,32.0669344 C67.8488491,32.0669344 67.9974232,32.0669344 68.1459973,32.0410531 C68.2945715,32.0151718 68.4431456,32.0151718 68.5917197,32.0151718 C68.7402938,32.0151718 68.8888679,31.9892905 69.0374421,31.9892905 C69.1860162,31.9892905 69.3345903,31.9892905 69.4831644,31.9634092 C69.6317385,31.9375279 69.7803127,31.9634092 69.9288868,31.9634092 C70.0774609,31.9634092 70.226035,31.9634092 70.3498468,31.9634092 C70.4984209,31.9634092 70.6222327,31.9634092 70.7708068,31.9634092 C70.9193809,31.9634092 71.0431927,31.9634092 71.1917668,31.9634092 C71.340341,31.9634092 71.4641527,31.9634092 71.6127268,31.9892905 C71.761301,31.9892905 71.8851127,31.9892905 72.0336869,31.9892905 C72.182261,31.9892905 72.3308351,31.9892905 72.4546469,31.9634092 C72.6279833,31.9634092 72.7765575,31.9634092 72.9498939,31.9634092 C73.1232304,31.9634092 73.2718045,31.9892905 73.445141,31.9892905 C73.4699034,31.9892905 73.4946657,31.9892905 73.5194281,31.9892905 C73.5441904,31.9634092 73.5441904,31.9634092 73.5441904,31.9375279 C73.5689528,31.8340027 73.5937151,31.7045962 73.5937151,31.601071 C73.6184775,31.4975457 73.6184775,31.3681392 73.6432398,31.264614 C73.6680022,31.1610888 73.6680022,31.0316823 73.6927646,30.9281571 C73.7175269,30.8246319 73.7422893,30.6952253 73.7670516,30.5917001 C73.791814,30.4881749 73.8165763,30.3587684 73.866101,30.2552432 C73.9156257,30.151718 73.9156257,30.0223115 73.9651504,29.9187863 C73.9899128,29.7893797 74.0146752,29.6599732 74.0394375,29.5305667 C74.0641999,29.4011602 74.0889622,29.2717537 74.1137246,29.1682285 C74.1384869,29.038822 74.1384869,28.9352967 74.1632493,28.8058902 C74.1880116,28.6764837 74.1880116,28.5729585 74.212774,28.443552 C74.2375363,28.3141455 74.2622987,28.2106203 74.287061,28.0812137 C74.3118234,27.9518072 74.3613481,27.848282 74.4108728,27.7188755 C74.4603975,27.6153503 74.4851599,27.5377064 74.5346846,27.4341812 C74.9061199,26.5800982 75.3766046,25.7777778 75.9709011,25.0789826 C76.1194752,24.9236948 76.2680493,24.7425257 76.4166235,24.5872378 C76.5651976,24.43195 76.7385341,24.2766622 76.9118705,24.1213744 C77.085207,23.9660866 77.2833058,23.8366801 77.4566423,23.6813922 C77.6547411,23.5519857 77.85284,23.4225792 78.0261764,23.319054 C78.2242753,23.2155288 78.4471365,23.1120036 78.6452353,23.0084784 C78.7442847,22.9567158 78.8433341,22.9308344 78.9423835,22.8790718 C79.0414329,22.8273092 79.1652447,22.8014279 79.2642941,22.7755466 C79.3881059,22.7496653 79.5119177,22.6979027 79.6357294,22.6720214 C79.7595412,22.6461401 79.883353,22.6202588 80.0319271,22.5943775 C80.1805012,22.5684962 80.2795506,22.5426149 80.4033624,22.5167336 C80.5271742,22.4908523 80.6509859,22.464971 80.7500354,22.4390897 C80.8490848,22.4132084 80.9481342,22.3873271 81.0471836,22.3873271 C81.146233,22.3614458 81.2452824,22.3614458 81.3443318,22.3355645 C81.4433813,22.3096832 81.5424307,22.3096832 81.6414801,22.2838019 C81.7405295,22.2838019 81.8395789,22.2579206 81.9386283,22.2579206 C82.0376777,22.2579206 82.1367272,22.2320393 82.2357766,22.2320393 C82.334826,22.2320393 82.4338754,22.2320393 82.5081625,22.206158 C82.6072119,22.206158 82.6814989,22.206158 82.7805484,22.206158 C82.8548354,22.206158 82.9538848,22.206158 83.0281719,22.206158 C83.102459,22.206158 83.2015084,22.2320393 83.2757954,22.2320393 C83.3748448,22.2320393 83.4491319,22.2579206 83.5481813,22.2579206 C83.6472307,22.2579206 83.7462801,22.2838019 83.8453296,22.2838019 C83.944379,22.2838019 84.0434284,22.3096832 84.1424778,22.3096832 C84.2415272,22.3096832 84.3405766,22.3355645 84.4396261,22.3355645 C84.5386755,22.3355645 84.6377249,22.3614458 84.7367743,22.3614458 C84.8358237,22.3614458 84.9348731,22.3873271 85.0339225,22.3873271 C85.132972,22.4132084 85.2320214,22.4132084 85.3310708,22.4390897 C85.4301202,22.464971 85.5291696,22.4908523 85.628219,22.5167336 C85.7272684,22.5426149 85.8263179,22.5684962 85.9006049,22.5943775 C86.0987037,22.6461401 86.2720402,22.723784 86.4453767,22.8014279 C86.6930002,22.9049531 86.9158614,23.0343597 87.163485,23.1637662 C87.9558803,23.6037483 88.8720874,24.0954931 89.3673344,24.9236948 C89.4168591,25.0013387 89.4663838,25.0789826 89.5159086,25.1566265 C89.5654333,25.2342704 89.6397203,25.286033 89.689245,25.3636769 C89.7635321,25.4154395 89.8130568,25.4930834 89.8873439,25.5448461 C89.9368686,25.5966087 90.0111556,25.6742526 90.0606803,25.7518965 C90.110205,25.8036591 90.1349674,25.881303 90.1844921,25.9330656 C90.2092545,25.9848282 90.2340168,26.0624721 90.2835415,26.1142347 C90.3083039,26.1659973 90.3330662,26.2436412 90.3578286,26.2954038 C90.3825909,26.3471664 90.4073533,26.4248104 90.4321156,26.476573 C90.456878,26.5542169 90.5064027,26.6318608 90.5311651,26.7095047 C90.5806898,26.7871486 90.6054521,26.8647925 90.6549768,26.9424364 C90.7045015,27.0200803 90.7540262,27.0977242 90.8035509,27.1753681 C90.8530757,27.253012 90.9026004,27.330656 90.9521251,27.4341812 C91.0016498,27.5377064 91.0511745,27.6153503 91.0759368,27.6929942 C91.1006992,27.7706381 91.1502239,27.8741633 91.1997486,27.9518072 C91.224511,28.0294511 91.2492733,28.107095 91.298798,28.184739 C91.3235604,28.2623829 91.3730851,28.3400268 91.3978474,28.3917894 C91.4226098,28.4694333 91.4721345,28.5211959 91.4968968,28.5988398 C91.5216592,28.6764837 91.5711839,28.7282463 91.5959463,28.8058902 C91.6207086,28.8835341 91.6702333,28.961178 91.6949957,29.0129407 C91.719758,29.0905846 91.7692827,29.1682285 91.7940451,29.2458724 C91.8188074,29.3235163 91.8683322,29.4011602 91.8930945,29.4788041 C91.9178569,29.556448 91.9426192,29.6340919 91.9673816,29.7117358 C91.9921439,29.7893797 92.0169063,29.8670237 92.0169063,29.9446676 C92.0416686,30.151718 91.9921439,30.9540384 92.1902428,31.0834449 C92.2397675,31.1093262 92.2892922,31.1093262 92.3635792,31.1093262 C92.6112028,31.0834449 92.8588263,31.0834449 93.1064498,31.0575636 C93.3540734,31.0575636 93.6016969,31.0575636 93.8493204,31.0575636 C94.096944,31.0575636 94.3445675,31.0834449 94.5921911,31.0834449 C94.8398146,31.1093262 95.0874381,31.1093262 95.3350617,31.1352075 C95.5826852,31.1610888 95.8303087,31.1610888 96.0779323,31.1869701 C96.3255558,31.1869701 96.5731794,31.2128514 96.8208029,31.2128514 C97.0684264,31.2128514 97.31605,31.2387327 97.5636735,31.2387327 C97.811297,31.2387327 98.0836829,31.264614 98.3313065,31.264614 C98.57893,31.264614 98.8513159,31.2904953 99.0989394,31.2904953 C99.346563,31.2904953 99.5941865,31.3163766 99.84181,31.3163766 C100.039909,31.3163766 100.238008,31.3422579 100.436107,31.3422579 C100.658968,31.3422579 100.906591,31.3681392 101.129452,31.3681392 C101.352314,31.3681392 101.575175,31.3940205 101.798036,31.3940205 C102.020897,31.3940205 102.243758,31.4199018 102.46662,31.4199018 C102.689481,31.4199018 102.912342,31.4457831 103.159965,31.4457831 C103.382827,31.4457831 103.63045,31.4716644 103.853311,31.4716644 C104.076173,31.4975457 104.323796,31.4975457 104.546657,31.523427 C104.521895,31.2904953 104.497133,31.0575636 104.521895,30.8505132 C104.546657,30.6175814 104.57142,30.3846497 104.620944,30.1775993 C104.670469,29.9446676 104.719994,29.7117358 104.794281,29.5046854 C104.843805,29.2717537 104.89333,29.038822 104.942855,28.8058902 C104.967617,28.6247211 104.99238,28.4694333 104.99238,28.2882642 C105.017142,28.107095 105.017142,27.9518072 105.017142,27.7706381 C105.017142,27.589469 105.041904,27.4341812 105.041904,27.253012 C105.041904,27.0718429 105.066667,26.9165551 105.066667,26.735386 C105.066667,26.5542169 105.066667,26.398929 105.066667,26.2436412 C105.066667,26.0883534 105.066667,25.9071843 105.066667,25.7518965 C104.843805,25.3119143 104.89333,24.9495761 104.843805,24.5613565 Z M40.115013,12.7077198 C40.115013,12.9406515 40.0902506,13.1735832 39.9912012,13.3547523 C39.6445282,14.0017849 38.6292717,13.8206158 38.0597376,13.8206158 C37.0940058,13.8206158 36.128274,13.7947345 35.1625422,13.7947345 C33.255841,13.7947345 31.3491398,13.7947345 29.4424385,13.7947345 C28.9224291,13.7947345 28.427182,13.8206158 27.9071726,13.8206158 C27.3871632,13.8206158 26.8919161,13.8464971 26.3719067,13.8206158 C25.8518972,13.8206158 25.3566502,13.8206158 24.8366407,13.8206158 C24.3166313,13.8206158 23.7718595,13.7947345 23.2518501,13.7947345 C22.8061277,13.7947345 22.3604054,13.7947345 21.8899207,13.7688532 C21.3203865,13.7688532 20.7756147,13.7429719 20.2060806,13.7429719 C20.0822688,13.7429719 19.9832194,13.7429719 19.8594077,13.7429719 C19.7355959,13.7429719 19.6365465,13.7429719 19.5127347,13.7429719 C18.9432006,13.7170906 18.3736664,13.7429719 17.8041323,13.7688532 C17.6803205,13.7688532 17.5812711,13.7688532 17.4574593,13.7688532 C16.4917276,13.7688532 14.4859769,13.7429719 14.5355016,12.2936189 C14.5355016,12.2418563 14.5355016,12.1900937 14.560264,12.1124498 C14.560264,12.0606872 14.5850263,12.0089246 14.6097887,11.9312807 C14.634551,11.8795181 14.634551,11.8277555 14.6593134,11.7759929 C14.6840757,11.698349 14.7088381,11.6465863 14.7583628,11.5948237 C14.7831251,11.5430611 14.8326499,11.4654172 14.8821746,11.4136546 C14.9316993,11.361892 14.9564616,11.3101294 15.0059863,11.2583668 C15.055511,11.2066042 15.1050357,11.1548416 15.1297981,11.103079 C15.2536099,10.9736725 15.3526593,10.844266 15.4764711,10.7148594 C15.5755205,10.5854529 15.6993322,10.4560464 15.7983816,10.3266399 C15.8974311,10.1972334 16.0212428,10.0678269 16.1202922,9.93842035 C16.2193417,9.80901383 16.3183911,9.67960732 16.4422028,9.5502008 C16.5660146,9.42079429 16.6403017,9.29138777 16.7393511,9.16198126 C16.8384005,9.03257474 16.9374499,8.90316823 17.0612617,8.77376171 C17.1603111,8.6443552 17.2841229,8.51494868 17.3831723,8.38554217 C17.4822217,8.25613565 17.6060335,8.12672914 17.7298452,7.99732262 C17.9527064,7.73850959 18.1755676,7.50557787 18.4231911,7.24676484 C18.5470029,7.11735832 18.6708147,6.9620705 18.7946264,6.83266399 C18.9184382,6.70325747 19.04225,6.54796966 19.1660617,6.41856314 C19.2898735,6.28915663 19.4136853,6.13386881 19.5374971,6.00446229 C19.6613088,5.87505578 19.7851206,5.71976796 19.9089324,5.59036145 C20.0327441,5.46095493 20.1565559,5.33154842 20.30513,5.2021419 C20.4289418,5.07273539 20.5775159,4.94332887 20.72609,4.81392236 C20.8746642,4.68451584 21.0232383,4.55510933 21.1718124,4.45158411 C21.3203865,4.3221776 21.4689606,4.21865239 21.6175348,4.08924587 C21.7661089,3.95983936 21.914683,3.85631415 22.0632571,3.72690763 C22.1623065,3.64926372 22.2365936,3.57161981 22.335643,3.4939759 C22.4346924,3.41633199 22.5089795,3.31280678 22.6080289,3.23516287 C22.7318407,3.13163766 22.8556524,3.00223115 22.9794642,2.89870593 C23.103276,2.84694333 23.2270878,2.79518072 23.3261372,2.71753681 C23.4499489,2.66577421 23.5737607,2.6140116 23.6728101,2.562249 C23.7966219,2.51048639 23.9204337,2.45872378 24.0442454,2.43284248 C24.1680572,2.40696118 24.291869,2.38107988 24.4404431,2.35519857 C24.5642549,2.35519857 24.6633043,2.32931727 24.787116,2.32931727 C24.9109278,2.32931727 25.0099772,2.32931727 25.133789,2.32931727 C25.2576008,2.32931727 25.3566502,2.32931727 25.4804619,2.32931727 C25.6042737,2.32931727 25.7033231,2.32931727 25.8271349,2.32931727 C25.9509467,2.32931727 26.0499961,2.32931727 26.1738078,2.32931727 C26.2976196,2.32931727 26.396669,2.32931727 26.5204808,2.32931727 C26.6938173,2.32931727 26.8671537,2.32931727 27.0404902,2.32931727 C27.2138267,2.32931727 27.3871632,2.32931727 27.5604996,2.32931727 C27.9071726,2.32931727 28.2538455,2.32931727 28.6005185,2.32931727 C29.5910126,2.32931727 30.6310315,2.38107988 31.6215257,2.38107988 C31.7700998,2.38107988 31.9434362,2.38107988 32.0920104,2.38107988 C32.2405845,2.38107988 32.3891586,2.38107988 32.5624951,2.38107988 C32.7110692,2.38107988 32.8596433,2.38107988 33.0329798,2.38107988 C33.1815539,2.38107988 33.3301281,2.38107988 33.5034645,2.38107988 C33.676801,2.38107988 33.8748998,2.38107988 34.0482363,2.38107988 C34.2215728,2.38107988 34.4196716,2.38107988 34.6177704,2.40696118 C34.8158693,2.40696118 34.9892058,2.40696118 35.1873046,2.40696118 C35.3358787,2.40696118 35.5092152,2.40696118 35.6577893,2.40696118 C35.8063634,2.40696118 35.9796999,2.40696118 36.128274,2.40696118 C36.2768481,2.40696118 36.4501846,2.40696118 36.5987587,2.40696118 C36.7473329,2.40696118 36.9206693,2.40696118 37.0692435,2.40696118 C37.1930552,2.40696118 37.316867,2.40696118 37.4406788,2.38107988 C37.5644905,2.35519857 37.7130647,2.35519857 37.8616388,2.35519857 C38.0102129,2.35519857 38.158787,2.35519857 38.3073611,2.35519857 C38.4559353,2.35519857 38.6045094,2.35519857 38.7530835,2.38107988 C38.9016576,2.38107988 39.0254694,2.40696118 39.1740435,2.43284248 C39.3226176,2.45872378 39.4216671,2.51048639 39.5207165,2.562249 C39.5702412,2.5881303 39.6197659,2.6398929 39.6692906,2.66577421 C39.9912012,3.57161981 40.0159635,4.52922802 40.0407259,5.51271754 C40.0902506,6.70325747 39.9912012,7.86791611 40.0159635,9.03257474 C40.0159635,10.1972334 40.1645377,11.4654172 40.115013,12.7077198 Z M50.1685286,18.7639447 C50.1685286,18.7639447 50.1685286,18.789826 50.1685286,18.789826 C50.1437662,18.9451138 50.0942415,19.0745203 49.9951921,19.1780455 C49.8961427,19.2815707 49.7228062,19.3333333 49.5742321,19.3592146 C49.4256579,19.3850959 49.2770838,19.4109772 49.1532721,19.4368585 C48.4599262,19.5145025 47.7665802,19.4886212 47.0979967,19.4627398 C46.4294132,19.4368585 45.7360672,19.4627398 45.0674837,19.4368585 C44.8941472,19.4368585 44.7455731,19.4109772 44.5722366,19.4109772 C44.4236625,19.4109772 44.2750884,19.4109772 44.1512766,19.3850959 C43.9779401,19.3592146 43.829366,19.307452 43.6807919,19.2556894 C43.5074554,19.2039268 43.4331684,19.1262829 43.3341189,18.9709951 C43.2845942,18.8933512 43.1360201,18.7639447 43.1607825,18.6604195 C43.2103072,18.5310129 43.2598319,18.4274877 43.3588813,18.3239625 C43.4826931,18.194556 43.6807919,18.1169121 43.8541284,18.0651495 C44.2255637,17.9616243 44.6217613,17.935743 44.9931966,17.935743 C45.3893943,17.935743 45.8103543,17.9616243 46.206552,17.9616243 C46.3303637,17.9616243 46.4541755,17.9875056 46.5779873,17.9616243 C46.7265614,17.935743 46.8751355,17.935743 47.048472,17.935743 C47.4941944,17.9098617 47.9646791,17.9098617 48.4104014,17.9098617 C48.5589756,17.9098617 48.7075497,17.935743 48.8808862,17.935743 C49.0046979,17.935743 49.1532721,17.935743 49.3018462,17.9616243 C49.5742321,18.0392682 49.846618,18.1169121 50.0942415,18.2721999 C50.2180533,18.4016064 50.2180533,18.6086568 50.1685286,18.7639447 Z M67.4774138,13.6912093 C67.4526514,13.7947345 67.353602,13.8464971 67.279315,13.8723784 C67.1307408,13.924141 67.0069291,13.8723784 66.8583549,13.8723784 C66.7097808,13.8723784 66.585969,13.924141 66.4373949,13.924141 C66.1402467,13.924141 65.8430984,13.8982597 65.5459502,13.924141 C65.3478514,13.924141 65.1745149,13.9500223 64.9764161,13.9500223 C64.7783172,13.9500223 64.6049808,13.9500223 64.4068819,13.9500223 C64.2087831,13.9500223 64.0354466,13.9500223 63.8373478,13.9500223 C63.639249,13.9500223 63.4659125,13.9500223 63.2678137,13.924141 C63.0697148,13.924141 62.8963783,13.924141 62.7230419,13.8982597 C62.5497054,13.8982597 62.3516066,13.8982597 62.1782701,13.8982597 C62.0049336,13.8982597 61.8068348,13.8982597 61.6334983,13.8982597 C61.5096865,13.8982597 61.3611124,13.8982597 61.2373007,13.8982597 C61.1134889,13.8982597 60.9649148,13.8982597 60.841103,13.8982597 C60.7172912,13.8982597 60.5934795,13.8982597 60.4449053,13.8982597 C60.3210936,13.8982597 60.1972818,13.8982597 60.07347,13.8982597 C59.9496583,13.8982597 59.8258465,13.8982597 59.7020347,13.8723784 C59.578223,13.8464971 59.4544112,13.8723784 59.3058371,13.8723784 C59.1572629,13.8723784 58.9839265,13.8723784 58.8353523,13.8723784 C58.7115406,13.8723784 58.5877288,13.8723784 58.463917,13.8723784 C58.3401053,13.8723784 58.2162935,13.8723784 58.0924817,13.8723784 C57.96867,13.8723784 57.8448582,13.8723784 57.7210464,13.8723784 C57.5972347,13.8723784 57.4734229,13.8723784 57.3496111,13.8723784 C57.2257994,13.8723784 57.1019876,13.8723784 56.9781758,13.8464971 C56.8543641,13.8464971 56.7305523,13.8464971 56.6067405,13.8206158 C56.4829287,13.8206158 56.3343546,13.8206158 56.2105429,13.7947345 C56.0867311,13.7947345 55.938157,13.7947345 55.8143452,13.7688532 C55.2695734,13.7429719 54.7248016,13.7429719 54.2047922,13.7429719 C54.0314557,13.7429719 53.8828816,13.7429719 53.7095451,13.7429719 C53.5362087,13.7429719 53.3876345,13.7429719 53.2142981,13.7429719 C53.0409616,13.7429719 52.8923875,13.7429719 52.719051,13.7429719 C52.5457145,13.7429719 52.3971404,13.7429719 52.2238039,13.7429719 C52.0504674,13.7429719 51.9018933,13.7429719 51.7285568,13.7429719 C51.5552204,13.7429719 51.4066462,13.7429719 51.2333098,13.7429719 C51.0599733,13.7429719 50.9113992,13.7429719 50.762825,13.7170906 C50.5894886,13.7170906 50.4409144,13.6912093 50.267578,13.6912093 C50.0942415,13.6912093 49.9456674,13.665328 49.7723309,13.665328 C49.5989944,13.665328 49.4504203,13.665328 49.2770838,13.665328 C49.1037473,13.665328 48.9551732,13.665328 48.7818368,13.665328 C48.6085003,13.665328 48.4599262,13.665328 48.2865897,13.665328 C47.469432,13.6912093 46.6770367,13.7170906 45.859879,13.7429719 C45.7360672,13.7429719 45.6122555,13.7429719 45.4884437,13.7688532 C45.3646319,13.7688532 45.2408202,13.7688532 45.1170084,13.7947345 C44.9931966,13.7947345 44.8693849,13.8206158 44.7455731,13.8206158 C44.6217613,13.8206158 44.4979496,13.8206158 44.3741378,13.8464971 C44.250326,13.8464971 44.1265143,13.8464971 44.0027025,13.8464971 C43.8788907,13.8464971 43.755079,13.8464971 43.6312672,13.8464971 C42.8141095,13.8464971 42.1702883,13.8464971 41.9969518,12.8888889 C41.8731401,12.1900937 41.7740907,11.4654172 41.7740907,10.7407407 C41.7493283,10.2748773 41.7740907,9.78313253 41.7740907,9.31726908 C41.7740907,7.58322178 41.6255165,5.84917448 41.6750412,4.11512718 C41.6750412,3.85631415 41.6998036,3.57161981 41.798853,3.33868809 C41.9474271,2.95046854 42.3931495,2.53636769 42.7893472,2.40696118 C43.2845942,2.25167336 43.8788907,2.25167336 44.3741378,2.27755466 C45.785592,2.32931727 47.1722838,2.38107988 48.5837379,2.40696118 C49.4008956,2.43284248 50.2180533,2.53636769 51.0104486,2.69165551 C51.2828345,2.74341812 51.530458,2.76929942 51.7780815,2.82106203 C51.9018933,2.84694333 52.0257051,2.87282463 52.1495169,2.87282463 C52.2733286,2.89870593 52.3971404,2.92458724 52.5209522,2.95046854 C52.6447639,2.97634984 52.7685757,3.00223115 52.8923875,3.02811245 C53.0161992,3.05399375 53.140011,3.10575636 53.2638228,3.13163766 C53.4371592,3.18340027 53.6352581,3.26104418 53.8085945,3.31280678 C53.981931,3.36456939 54.1552675,3.4422133 54.328604,3.51985721 C54.5019405,3.59750112 54.6752769,3.64926372 54.8486134,3.70102633 C55.0219499,3.75278893 55.1952864,3.83043284 55.3686228,3.90807675 C55.5419593,3.98572066 55.7152958,4.03748327 55.8886323,4.11512718 C56.0619687,4.19277108 56.2353052,4.27041499 56.4086417,4.37394021 C56.5324535,4.42570281 56.6315029,4.50334672 56.7553146,4.55510933 C56.8791264,4.60687193 56.9781758,4.68451584 57.1019876,4.73627845 C57.2257994,4.78804105 57.3248488,4.86568496 57.4486605,4.91744757 C57.5724723,4.96921017 57.6715217,5.04685408 57.7953335,5.09861669 C57.8943829,5.15037929 57.96867,5.1762606 58.0677194,5.2280232 C58.1667688,5.27978581 58.2410559,5.33154842 58.3401053,5.38331102 C58.4143923,5.43507363 58.5134417,5.48683623 58.5877288,5.56448014 C58.6620159,5.61624275 58.7363029,5.69388666 58.81059,5.74564926 C58.9096394,5.82329317 58.9839265,5.90093708 59.0829759,5.97858099 C59.1572629,6.0562249 59.2563124,6.13386881 59.3553618,6.21151272 C59.4296488,6.26327532 59.4791735,6.31503793 59.5534606,6.34091923 C59.65251,6.39268184 59.7515594,6.44444444 59.8506088,6.52208835 C59.9496583,6.57385096 60.0487077,6.65149487 60.1477571,6.70325747 C60.2468065,6.75502008 60.3458559,6.83266399 60.4449053,6.9103079 C60.5439547,6.98795181 60.6430042,7.06559572 60.7420536,7.14323963 C60.841103,7.22088353 60.9401524,7.29852744 61.0392018,7.35029005 C61.1134889,7.40205266 61.1877759,7.45381526 61.262063,7.50557787 C61.3363501,7.55734047 61.4106371,7.60910308 61.4849242,7.68674699 C61.5592112,7.73850959 61.608736,7.7902722 61.683023,7.86791611 C61.7573101,7.94556002 61.8315971,7.97144132 61.9058842,8.02320393 C61.9801713,8.07496653 62.029696,8.10084784 62.0792207,8.15261044 C62.1287454,8.20437305 62.2030324,8.25613565 62.2525572,8.30789826 C62.3268442,8.38554217 62.4011313,8.46318608 62.4754183,8.51494868 C62.5497054,8.59259259 62.6239925,8.6702365 62.6982795,8.72199911 C62.7725666,8.79964302 62.871616,8.85140562 62.9706654,8.90316823 C63.0697148,8.95493083 63.1687642,9.03257474 63.2430513,9.08433735 C63.3421007,9.16198126 63.4411501,9.26550647 63.5401995,9.34315038 C63.639249,9.44667559 63.713536,9.5502008 63.8125854,9.62784471 C63.8621101,9.67960732 63.9363972,9.73136992 63.9859219,9.78313253 C64.0354466,9.83489514 64.1097337,9.88665774 64.1592584,9.93842035 C64.2087831,9.99018295 64.2830702,10.0419456 64.3573572,10.0937082 C64.4316443,10.1454708 64.481169,10.1972334 64.5306937,10.248996 C64.6297431,10.3266399 64.7040302,10.4042838 64.8030796,10.4819277 C64.902129,10.5595716 64.9764161,10.6113342 65.0754655,10.6889781 C65.1745149,10.766622 65.2735643,10.8183846 65.3478514,10.8960286 C65.4469008,10.9736725 65.5211878,11.0254351 65.5954749,11.103079 C65.669762,11.1807229 65.744049,11.2583668 65.8183361,11.3360107 C65.8926231,11.4136546 65.9669102,11.4912985 66.0411973,11.5689424 C66.1154843,11.6465863 66.1897714,11.7242303 66.2640584,11.8018742 C66.3383455,11.8795181 66.4126326,11.957162 66.4869196,12.0606872 C66.5364443,12.1124498 66.6107314,12.1900937 66.6602561,12.2677376 C66.7097808,12.3453815 66.7840679,12.4230254 66.8335926,12.474788 C66.9574044,12.6300759 67.0812161,12.7853637 67.1802655,12.9406515 C67.279315,13.0959393 67.353602,13.2771084 67.4031267,13.4323963 C67.4774138,13.5618028 67.5021761,13.6394467 67.4774138,13.6912093 Z",id:"Shape",fill:"#FFD300",fillRule:"nonzero",__source:{fileName:_jsxFileName,lineNumber:12}}),_react2.default.createElement("path",{d:"M21.4360396,35.2845528 C21.2112521,35.4471545 20.9864646,35.6097561 20.7616771,35.7181572 C20.112291,36.0704607 19.4379285,36.2601626 18.763566,36.4498645 C18.4388729,36.5311653 18.2140854,36.6666667 17.864416,36.6666667 C17.5646993,36.6666667 17.2400063,36.6124661 16.965266,36.5582656 C15.4417063,36.3143631 13.9930757,35.6368564 13.1938313,34.1463415 C12.9690438,33.7398374 12.8191854,33.2520325 12.6443507,32.8184282 C12.469516,32.4119241 12.3196577,32.0054201 12.2447285,31.5718157 C12.0948702,30.6504065 12.1697993,29.5934959 12.3696104,28.699187 C12.5444452,27.8861789 12.9440674,27.2899729 13.368666,26.6124661 C13.4685716,26.4498645 13.5684771,26.3143631 13.6933591,26.1788618 C14.7423674,25.0677507 15.9412341,24.4444444 17.414841,24.4444444 C18.5887313,24.4444444 19.8625271,24.7425474 20.8116299,25.5284553 C21.1862757,25.8536585 21.6108743,26.1517615 21.9355674,26.5582656 C22.0604493,26.6937669 22.2852368,26.8563686 22.360166,27.0460705 C22.7098354,27.804878 22.9595993,28.5365854 23.0844813,29.3766938 C23.1843868,30.1084011 23.259316,30.8672087 23.2093632,31.598916 C23.0844813,33.0081301 22.4600715,34.4444444 21.4360396,35.2845528 Z",id:"Shape",fill:"#C5168C",fillRule:"nonzero",__source:{fileName:_jsxFileName,lineNumber:13}}),_react2.default.createElement("path",{d:"M86.8207924,26.3213294 C87.1977975,26.6471749 87.6555895,26.8644051 88.0056657,27.1902506 C88.4634576,27.6247112 88.7866049,28.276402 89.0289653,28.8466315 C89.594473,30.0957057 89.7560466,31.5077025 89.3790415,32.8382381 C89.1097521,33.8429281 88.8673917,34.8204644 88.1941682,35.635078 C87.5478737,36.4225378 86.6322898,37.0199211 85.6359191,37.3186127 C84.5587616,37.6444582 83.4546751,37.8888422 82.3236597,37.7259195 C81.758152,37.6444582 81.3003601,37.4272279 80.7617813,37.2371514 C80.6271367,37.1828438 80.492492,37.15569 80.3578473,37.0742287 C80.2501315,37.0199211 80.1424158,36.9384597 80.061629,36.8569984 C78.8498267,35.8794621 78.1227454,34.5489266 77.6649535,33.0826221 C77.2879483,31.8607018 77.3418062,30.5030125 77.8265271,29.3353997 C78.1227454,28.5750937 78.6343952,27.7061725 79.3076187,27.2174044 C80.5194209,26.3213294 82.1082282,25.4795621 83.6701066,25.5610234 C84.1009697,25.5881772 84.5318327,25.6424848 84.9626957,25.6967923 C85.6359191,25.8325613 86.2014268,26.0769454 86.8207924,26.3213294 Z",id:"Shape",fill:"#C5168C",fillRule:"nonzero",__source:{fileName:_jsxFileName,lineNumber:14}}),_react2.default.createElement("path",{d:"M18.431602,14.3652545 C18.5544392,14.3652545 18.652709,14.3652545 18.7755462,14.3652545 C19.3651648,14.3379667 19.9056486,14.3379667 20.4706998,14.3379667 C20.593537,14.3379667 20.6918068,14.3379667 20.814644,14.3379667 C20.9374812,14.3379667 21.035751,14.3379667 21.1585882,14.3379667 C21.7236394,14.3652545 22.2641231,14.3652545 22.8291743,14.3652545 C23.2713883,14.3652545 23.7136023,14.3925422 24.1803837,14.3925422 C24.6963,14.3925422 25.2367838,14.3925422 25.7527001,14.4198299 C26.2686164,14.4198299 26.7599653,14.4198299 27.2758816,14.4198299 C27.7917979,14.4198299 28.2831467,14.4198299 28.799063,14.4198299 C29.3149794,14.4198299 29.8063282,14.3925422 30.3222445,14.3925422 C32.2139377,14.3652545 34.1056308,14.3652545 35.9973239,14.3925422 C36.9554542,14.3925422 37.9135845,14.4198299 38.8717148,14.4198299 C39.436766,14.4198299 40.4440312,14.6108439 40.7879754,13.9286511 C40.8862452,13.7376371 40.9108126,13.4920476 40.9108126,13.2464582 C40.9599475,11.936648 40.8125428,10.6268378 40.7634079,9.28973986 C40.7142731,8.03450507 40.8125428,6.80655799 40.7879754,5.57861091 C40.7634079,4.56896553 40.7142731,3.53203244 40.4194637,2.57696249 C40.3703289,2.54967478 40.321194,2.49509935 40.2720591,2.46781164 C40.1737893,2.41323621 40.0509521,2.35866079 39.9281149,2.33137307 C39.8052777,2.30408536 39.657873,2.27679765 39.5104683,2.27679765 C39.3630637,2.27679765 39.215659,2.24950994 39.0682544,2.24950994 C38.9208497,2.24950994 38.773445,2.24950994 38.6260404,2.24950994 C38.4786357,2.24950994 38.3312311,2.27679765 38.2083938,2.27679765 C38.0855566,2.27679765 37.938152,2.30408536 37.8398822,2.30408536 C37.6924775,2.30408536 37.5450729,2.30408536 37.3731008,2.30408536 C37.2256961,2.30408536 37.053724,2.30408536 36.9063193,2.30408536 C36.7589147,2.30408536 36.5869426,2.30408536 36.4395379,2.30408536 C36.2921333,2.30408536 36.1201612,2.30408536 35.9727565,2.30408536 C35.776217,2.30408536 35.6042448,2.30408536 35.4077053,2.30408536 C35.2111658,2.30408536 35.0391937,2.30408536 34.8426541,2.27679765 C34.670682,2.27679765 34.4741425,2.27679765 34.3021704,2.27679765 C34.1547657,2.27679765 34.007361,2.27679765 33.8353889,2.27679765 C33.6879843,2.27679765 33.5405796,2.27679765 33.3686075,2.27679765 C33.2212028,2.27679765 33.0737982,2.27679765 32.9018261,2.27679765 C32.7544214,2.27679765 32.6070168,2.27679765 32.4350447,2.27679765 C31.4523469,2.27679765 30.3959469,2.22222222 29.4378166,2.22222222 C29.0938724,2.22222222 28.7499282,2.22222222 28.405984,2.22222222 C28.2340119,2.22222222 28.0620397,2.22222222 27.8900676,2.22222222 C27.7180955,2.22222222 27.5461234,2.22222222 27.3741513,2.22222222 C27.2513141,2.22222222 27.1530443,2.22222222 27.0302071,2.22222222 C26.9073699,2.22222222 26.8091001,2.22222222 26.6862629,2.22222222 C26.5634257,2.22222222 26.4651559,2.22222222 26.3423187,2.22222222 C26.2194815,2.22222222 26.1212117,2.22222222 25.9983745,2.22222222 C25.8755373,2.22222222 25.7772675,2.22222222 25.6544303,2.22222222 C25.5315931,2.22222222 25.4333233,2.22222222 25.3104861,2.24950994 C25.1876489,2.24950994 25.0402442,2.27679765 24.917407,2.33137307 C24.7945698,2.35866079 24.6717326,2.41323621 24.5488954,2.46781164 C24.4260581,2.52238706 24.3032209,2.57696249 24.2049511,2.63153792 C24.0821139,2.68611334 23.9592767,2.74068877 23.8610069,2.82255191 C23.7381697,2.93170276 23.6153325,3.04085361 23.4924953,3.17729217 C23.3942255,3.25915531 23.2959557,3.36830616 23.2222534,3.4501693 C23.1239836,3.53203244 23.0502813,3.61389558 22.9520115,3.69575872 C22.8046069,3.83219728 22.6572022,3.94134813 22.5097976,4.0777867 C22.3623929,4.21422526 22.2149882,4.32337612 22.0675836,4.45981468 C21.9201789,4.59625324 21.7727743,4.73269181 21.6253696,4.84184266 C21.4779649,4.97828122 21.3551277,5.11471979 21.2077231,5.25115835 C21.0848858,5.38759692 20.9374812,5.52403548 20.814644,5.66047405 C20.6918068,5.79691261 20.5689695,5.93335118 20.4461323,6.09707745 C20.3232951,6.23351602 20.2004579,6.3972423 20.0776207,6.53368086 C19.9547835,6.67011942 19.8319462,6.8338457 19.709109,6.97028427 C19.5862718,7.10672283 19.4634346,7.27044911 19.3405974,7.40688767 C19.1194904,7.6797648 18.8738159,7.92535422 18.652709,8.19823135 C18.5298717,8.33466991 18.431602,8.47110848 18.3087648,8.60754704 C18.210495,8.7439856 18.0876578,8.88042417 17.989388,9.01686273 C17.8911182,9.1533013 17.7928484,9.28973986 17.6700112,9.42617843 C17.5717415,9.56261699 17.4734717,9.69905556 17.3752019,9.83549412 C17.2769321,9.97193268 17.1786624,10.1083712 17.0558251,10.2448098 C16.9575554,10.3812484 16.8347182,10.5176869 16.7364484,10.6541255 C16.6381786,10.7905641 16.5153414,10.9270026 16.4170716,11.0634412 C16.3188018,11.1998798 16.1959646,11.3363183 16.0731274,11.4727569 C16.0239925,11.5273323 15.9748576,11.5819077 15.9502902,11.6364832 C15.9011553,11.6910586 15.8765879,11.745634 15.827453,11.8002094 C15.7783181,11.8547849 15.7537506,11.9093603 15.7046158,11.9912234 C15.6800483,12.0457989 15.6309134,12.127662 15.606346,12.1822374 C15.5817785,12.2368129 15.5572111,12.2913883 15.5572111,12.3459637 C15.5326437,12.4005391 15.5326437,12.4551146 15.5080762,12.5369777 C15.5080762,12.5915531 15.4835088,12.6461285 15.4835088,12.7279917 C15.4835088,14.310679 17.4489042,14.3652545 18.431602,14.3652545 Z",id:"Shape",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:15}}),_react2.default.createElement("path",{d:"M44.7747354,20.7777778 C44.9138113,20.8518519 45.0760664,20.9259259 45.2151423,20.962963 C45.3542182,21 45.493294,21 45.6091906,21 C45.7714457,21 45.9105216,21.037037 46.0727768,21.037037 C46.6986181,21.0740741 47.3476388,21.037037 47.9734802,21.0740741 C48.6225008,21.1111111 49.2715215,21.1481481 49.8973629,21.037037 C50.0364387,21 50.1755146,21 50.2914111,20.9259259 C50.430487,20.8888889 50.5695628,20.8148148 50.6854594,20.6666667 C50.7781766,20.5185185 50.8245352,20.2962963 50.8477145,20.1111111 C50.8477145,20.1111111 50.8477145,20.0740741 50.8477145,20.0740741 C50.8940732,19.8518519 50.8940732,19.5555556 50.731818,19.4074074 C50.5000249,19.1851852 50.2682318,19.0740741 49.9900801,18.962963 C49.8741835,18.9259259 49.7351077,18.9259259 49.5960318,18.9259259 C49.456956,18.9259259 49.3178801,18.8888889 49.1556249,18.8888889 C48.7383974,18.8888889 48.2979905,18.8888889 47.8807629,18.9259259 C47.7416871,18.9259259 47.6026112,18.962963 47.440356,18.962963 C47.3244595,18.962963 47.2085629,18.962963 47.0926664,18.962963 C46.7217974,18.962963 46.3277492,18.9259259 45.9568802,18.9259259 C45.6091906,18.9259259 45.2383216,18.962963 44.890632,19.1111111 C44.7283768,19.1851852 44.5429423,19.2962963 44.4270458,19.4814815 C44.3343285,19.5925926 44.2879699,19.7777778 44.2416113,19.962963 C44.218432,20.1111111 44.3343285,20.2962963 44.4038665,20.4074074 C44.5429423,20.6296296 44.6124803,20.7037037 44.7747354,20.7777778 Z",id:"Shape",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:16}}),_react2.default.createElement("path",{d:"M64.4196615,14.3848058 C64.61536,14.3848058 64.7865961,14.3848058 64.9822946,14.3848058 C65.177993,14.3848058 65.3492292,14.3577475 65.5449276,14.3577475 C65.8384753,14.3306892 66.132023,14.3848058 66.4255706,14.3577475 C66.5723445,14.3577475 66.694656,14.3036309 66.8414299,14.3036309 C66.9882037,14.3036309 67.1105152,14.3577475 67.2572891,14.3036309 C67.3551383,14.2765726 67.4285252,14.1953978 67.4529875,14.1142229 C67.4774498,14.0330481 67.4529875,13.9789315 67.4529875,13.8977567 C67.4040629,13.7083487 67.330676,13.545999 67.2328268,13.3836493 C67.1349775,13.2212996 67.012666,13.0589499 66.8903545,12.8966002 C66.8414299,12.8154253 66.7680429,12.7342505 66.7191183,12.6801339 C66.6701937,12.5989591 66.5968068,12.5448425 66.5478822,12.4636677 C66.4744953,12.3824928 66.4011083,12.2742597 66.3277214,12.1930848 C66.2543345,12.11191 66.1809476,12.0307351 66.1075607,11.9495603 C66.0341737,11.8683854 65.9607868,11.7872106 65.8873999,11.7060357 C65.814013,11.6248609 65.7406261,11.543686 65.6672392,11.4625112 C65.5938522,11.3813363 65.496003,11.3001615 65.4226161,11.2460449 C65.3247669,11.16487 65.2513799,11.1107535 65.1535307,11.0295786 C65.0556815,10.9484038 64.9578323,10.8942872 64.8844454,10.8131124 C64.7865961,10.7319375 64.7132092,10.6507627 64.61536,10.5695878 C64.5664354,10.5154712 64.4930485,10.4613547 64.4441238,10.4072381 C64.3707369,10.3531215 64.3218123,10.299005 64.2484254,10.2448884 C64.1995008,10.1907718 64.1261139,10.1366553 64.0771892,10.0825387 C64.0282646,10.0284221 63.9548777,9.97430557 63.9059531,9.92018901 C63.8081039,9.81195587 63.734717,9.70372274 63.6368677,9.62254789 C63.5390185,9.51431476 63.4656316,9.4331399 63.3433201,9.35196505 C63.2454708,9.29784849 63.1720839,9.21667364 63.0742347,9.16255707 C62.9763855,9.1084405 62.8785362,9.02726565 62.8051493,8.97314909 C62.7317624,8.89197424 62.6583755,8.83785767 62.5849886,8.75668282 C62.5116016,8.67550797 62.4382147,8.59433312 62.3648278,8.54021655 C62.3159032,8.48609998 62.2669786,8.43198342 62.1935917,8.37786685 C62.144667,8.32375028 62.0712801,8.296692 62.0223555,8.24257543 C61.9489686,8.18845887 61.8755817,8.1343423 61.8021948,8.08022573 C61.7288078,8.02610916 61.6554209,7.9719926 61.6064963,7.89081775 C61.5331094,7.83670118 61.4597225,7.78258461 61.3863356,7.70140976 C61.3129486,7.6472932 61.2395617,7.59317663 61.1661748,7.53906006 C61.0683256,7.4849435 60.9704763,7.40376865 60.8726271,7.32259379 C60.7747779,7.24141894 60.6769287,7.16024409 60.5790794,7.07906924 C60.4812302,6.99789439 60.383381,6.91671954 60.2855318,6.86260298 C60.1876825,6.80848641 60.0898333,6.72731156 59.9919841,6.67319499 C59.8941349,6.61907842 59.7962856,6.56496186 59.6984364,6.48378701 C59.6250495,6.42967044 59.5516626,6.40261216 59.502738,6.34849559 C59.4048887,6.26732074 59.3315018,6.18614589 59.2336526,6.10497104 C59.1602657,6.02379619 59.0624165,5.94262134 58.9645672,5.86144649 C58.8911803,5.80732992 58.8177934,5.72615507 58.7444065,5.6720385 C58.6710196,5.61792194 58.5976326,5.56380537 58.4997834,5.48263052 C58.4263965,5.42851395 58.3285473,5.37439739 58.230698,5.32028082 C58.1328488,5.26616425 58.0594619,5.21204768 57.9616127,5.1849894 C57.8393011,5.13087283 57.7414519,5.07675627 57.6191404,4.99558142 C57.4968289,4.94146485 57.3989796,4.86029 57.2766681,4.80617343 C57.1543566,4.75205687 57.0565073,4.67088202 56.9341958,4.61676545 C56.8118843,4.56264888 56.7140351,4.48147403 56.5917235,4.42735746 C56.4204874,4.34618261 56.2492512,4.23794948 56.0780151,4.15677463 C55.9067789,4.07559978 55.7355428,3.99442493 55.5643067,3.94030836 C55.3930705,3.85913351 55.2218344,3.80501694 55.0505982,3.72384209 C54.8793621,3.66972553 54.7081259,3.58855068 54.5368898,3.53443411 C54.3656536,3.45325926 54.1944175,3.39914269 54.0231814,3.31796784 C53.8519452,3.26385128 53.6807091,3.18267642 53.4850106,3.12855986 C53.3626991,3.07444329 53.2403876,3.04738501 53.118076,3.02032672 C52.9957645,2.99326844 52.873453,2.96621016 52.7511414,2.93915187 C52.6288299,2.91209359 52.5065184,2.88503531 52.3842068,2.85797702 C52.2618953,2.83091874 52.1395838,2.80386046 52.0172722,2.80386046 C51.7726492,2.74974389 51.5035638,2.72268561 51.2589408,2.66856904 C50.4516846,2.50621934 49.6688908,2.3979862 48.8616347,2.37092792 C47.4672833,2.31681135 46.0973941,2.26269479 44.7030427,2.2356365 C44.2137965,2.20857822 43.6267012,2.20857822 43.1374551,2.37092792 C42.7460582,2.50621934 42.330199,2.93915187 42.1589628,3.34502613 C42.0611136,3.58855068 42.0611136,3.88619179 42.0366513,4.15677463 C41.9877267,5.96967962 42.1345005,7.78258461 42.1345005,9.59548961 C42.1345005,10.0825387 42.1100382,10.5966461 42.1345005,11.0836952 C42.1589628,11.8413271 42.2323497,12.5989591 42.3546613,13.3295327 C42.5258974,14.3577475 43.1863797,14.3306892 43.9691735,14.3306892 C44.091485,14.3306892 44.2137965,14.3306892 44.3361081,14.3306892 C44.4584196,14.3306892 44.5807311,14.3306892 44.7030427,14.3306892 C44.8253542,14.3306892 44.9476657,14.3306892 45.0699773,14.3036309 C45.1922888,14.3036309 45.3146003,14.2765726 45.4369119,14.2765726 C45.5592234,14.2765726 45.6815349,14.2495144 45.8038464,14.2495144 C45.926158,14.2495144 46.0484695,14.2495144 46.170781,14.2224561 C46.9780372,14.1953978 47.760831,14.1683395 48.5680871,14.1412812 C48.7393232,14.1412812 48.886097,14.1412812 49.0573332,14.1412812 C49.2285693,14.1412812 49.3753432,14.1412812 49.5465793,14.1412812 C49.7178155,14.1412812 49.8645893,14.1412812 50.0358254,14.1412812 C50.2070616,14.1412812 50.3538354,14.1683395 50.5250716,14.1683395 C50.6963077,14.1683395 50.8430815,14.1953978 51.0143177,14.1953978 C51.1610915,14.1953978 51.3323277,14.2224561 51.4791015,14.2224561 C51.6503377,14.2224561 51.7971115,14.2224561 51.9683476,14.2224561 C52.1395838,14.2224561 52.2863576,14.2224561 52.4575938,14.2224561 C52.6288299,14.2224561 52.7756037,14.2224561 52.9468399,14.2224561 C53.118076,14.2224561 53.2648499,14.2224561 53.436086,14.2224561 C53.6073222,14.2224561 53.754096,14.2224561 53.9253321,14.2224561 C54.0965683,14.2224561 54.2433421,14.2224561 54.4145783,14.2224561 C54.952749,14.2224561 55.4909197,14.2495144 56.0046282,14.2495144 C56.1269397,14.2495144 56.2737135,14.2495144 56.3960251,14.2765726 C56.5183366,14.2765726 56.6651104,14.2765726 56.787422,14.3036309 C56.9097335,14.3036309 57.032045,14.3036309 57.1543566,14.3306892 C57.2766681,14.3306892 57.3989796,14.3306892 57.5212912,14.3577475 C57.6436027,14.3577475 57.7659142,14.3577475 57.8882258,14.3577475 C58.0105373,14.3577475 58.1328488,14.3577475 58.2551603,14.3577475 C58.3774719,14.3577475 58.4997834,14.3577475 58.6220949,14.3577475 C58.7444065,14.3577475 58.866718,14.3577475 58.9890295,14.3577475 C59.1358034,14.3577475 59.3070395,14.3577475 59.4538134,14.3577475 C59.5761249,14.3577475 59.6984364,14.3577475 59.8452103,14.3577475 C59.9919841,14.3577475 60.0898333,14.3577475 60.2121449,14.3848058 C60.3344564,14.3848058 60.4567679,14.3848058 60.5790794,14.3848058 C60.701391,14.3848058 60.8237025,14.3848058 60.9704763,14.3848058 C61.0927879,14.3848058 61.2395617,14.3848058 61.3618732,14.3848058 C61.4841848,14.3848058 61.6309586,14.3848058 61.7532701,14.3848058 C61.9245063,14.3848058 62.1202047,14.3848058 62.2914409,14.3848058 C62.462677,14.3848058 62.6583755,14.3848058 62.8296116,14.3848058 C63.0008478,14.3848058 63.1965462,14.3848058 63.3677824,14.4118641 C63.5634808,14.4118641 63.734717,14.4118641 63.9304154,14.4389223 C64.1261139,14.4659806 64.2484254,14.3848058 64.4196615,14.3848058 Z",id:"Shape",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:17}}),_react2.default.createElement("path",{d:"M91.7950877,30.8018169 C91.7683674,30.562757 91.741647,30.3502593 91.7149266,30.1111994 C91.6882063,29.8721395 91.6614859,29.6596418 91.6080452,29.4471441 C91.5813249,29.2346464 91.5278841,28.9955864 91.4744434,28.7830887 C91.3942823,28.4112178 91.2874009,28.0127846 91.1537991,27.6409136 C91.0469177,27.3487293 90.8598752,27.0831071 90.7797141,26.7909228 C90.7529937,26.7112362 90.7262734,26.6315495 90.6728327,26.5518629 C90.5125105,26.2862408 90.3521884,26.0471808 90.1384255,25.8081209 C89.9246626,25.5956232 89.7108998,25.3565633 89.4971369,25.1440656 C89.283374,24.9315679 89.0696112,24.692508 88.8558483,24.4800103 C88.6688058,24.2940748 88.4550429,24.0815771 88.24128,23.9222038 C88.1076782,23.815955 87.9740765,23.7097061 87.8137543,23.6300195 C87.5732711,23.4706462 87.3060675,23.3112729 87.0388639,23.1784619 C86.7716603,23.0456508 86.4777364,22.9128398 86.2105328,22.8065909 C85.9700496,22.700342 85.702846,22.6472176 85.4623628,22.5940932 C85.2218795,22.5409688 84.9546759,22.4878443 84.7141927,22.4081577 C84.5271502,22.3550333 84.3401077,22.3019089 84.1263448,22.2753466 C83.9393023,22.2487844 83.7255395,22.2222222 83.5384969,22.2222222 C83.3514544,22.2222222 83.1376916,22.2222222 82.9506491,22.2222222 C82.7636065,22.2222222 82.5498437,22.2487844 82.3628012,22.2753466 C82.1757587,22.3019089 81.9619958,22.3284711 81.7749533,22.3815955 C81.5879108,22.4081577 81.4008683,22.4612821 81.2138258,22.5144066 C80.0114096,22.8065909 78.5417899,23.1518997 77.579857,23.948766 C76.7782462,24.5862591 76.1102373,25.4096877 75.4422283,26.2065541 C74.9612619,26.7643606 74.6406176,27.5346648 74.4535751,28.2518445 C74.4001343,28.4643422 74.3466936,28.6768399 74.2932529,28.9158998 C74.1329308,29.686204 74.07949,30.4299459 74.1062104,31.2268123 C74.1062104,32.1033653 74.2130918,32.9799183 74.4268547,33.8564714 C74.5337361,34.2814668 74.6673379,34.7064622 74.8276601,35.1048954 C74.9879822,35.5033285 75.3353469,35.7689507 75.5758301,36.1142594 C75.7628726,36.4064438 76.0033558,36.6720659 76.2438391,36.9642502 C76.5110427,37.309559 76.831687,37.6017433 77.1523313,37.8673655 C77.3126534,37.9736143 77.4729756,38.053301 77.6332977,38.1595498 C77.7668995,38.2657987 77.8203402,38.3986097 77.9806624,38.5048586 C78.5417899,38.8236051 79.1296378,39.0892273 79.6907653,39.3814116 C79.8778078,39.4876604 80.0648503,39.5673471 80.2518928,39.6470337 C80.4923761,39.7532826 80.7863,39.806407 81.0535036,39.8595314 C81.9352754,40.0454669 82.7903269,40.0189047 83.6988191,39.9392181 C83.912582,39.9126558 84.1263448,39.8860936 84.3133873,39.8329692 C84.5271502,39.7798448 84.7409131,39.7267204 84.9546759,39.6735959 C85.1684388,39.6204715 85.3822017,39.5939093 85.5959645,39.5407849 C85.8097274,39.4876604 86.0234903,39.434536 86.2372532,39.3814116 C86.451016,39.3282872 86.6380585,39.2486005 86.8518214,39.1423517 C87.0121435,39.062665 87.1724657,38.9829784 87.3327878,38.9032918 C87.4663896,38.8236051 87.6267118,38.7173563 87.7870339,38.6376696 C87.9473561,38.5314208 88.0809579,38.4517342 88.2145597,38.3454853 C88.3481615,38.2392365 88.5084836,38.1329876 88.6420854,38.0267388 C88.7756872,37.9204899 88.909289,37.7876788 89.0428908,37.68143 C89.3368147,37.3892456 89.657459,37.1501857 89.951383,36.8580014 C90.0849848,36.7251903 90.2185866,36.6189415 90.325468,36.4861304 C90.4323494,36.3533194 90.5125105,36.2205083 90.5926716,36.061135 C90.993477,35.3173931 91.2339602,34.5470889 91.4477231,33.7502225 C91.5011638,33.5908492 91.5278841,33.431476 91.5546045,33.2455405 C91.5813249,33.059605 91.6080452,32.9002317 91.6347656,32.7408584 C91.6882063,32.4221119 91.7149266,32.1033653 91.741647,31.811181 C91.741647,31.6518077 91.7683674,31.4924344 91.7683674,31.3330612 C91.7950877,31.1471257 91.7950877,30.9877524 91.7950877,30.8018169 Z M86.3975753,26.1799919 C86.7716603,26.4987385 87.2259064,26.7112362 87.5732711,27.0299827 C88.0275172,27.4549781 88.3481615,28.0924712 88.5886447,28.6502777 C89.1497722,29.8721395 89.3100944,31.2533745 88.9360094,32.5549229 C88.6688058,33.5377248 88.4283225,34.4939645 87.7603136,35.2908308 C87.119025,36.061135 86.2105328,36.6455037 85.2218795,36.937688 C84.1530652,37.2564346 83.0575305,37.4954945 81.9352754,37.3361212 C81.3741479,37.2564346 80.9199018,37.0439369 80.3854946,36.8580014 C80.2518928,36.804877 80.1182911,36.7783148 79.9846893,36.6986281 C79.8778078,36.6455037 79.7709264,36.5658171 79.6907653,36.4861304 C78.4883492,35.5298908 77.7668995,34.2283423 77.3126534,32.7939829 C76.9385684,31.5986833 76.9920091,30.2705727 77.4729756,29.1283975 C77.7668995,28.3846556 78.2745863,27.5346648 78.9425953,27.0565449 C80.1450114,26.1799919 81.7215126,25.3565633 83.2712934,25.43625 C83.6988191,25.4628122 84.1263448,25.5159366 84.5538706,25.569061 C85.2218795,25.7018721 85.7830071,25.940932 86.3975753,26.1799919 Z",id:"Shape",fill:"#107B86",__source:{fileName:_jsxFileName,lineNumber:18}}),_react2.default.createElement("path",{d:"M25.4173476,29.8031365 C25.3908872,29.5362029 25.3644267,29.2959626 25.2850453,29.0557224 C25.2321243,28.8421755 25.1527429,28.6286286 25.0733615,28.4417751 C24.9939801,28.2282282 24.8881383,28.0413747 24.8087568,27.8278278 C24.6764545,27.5875876 24.5970731,27.320654 24.4912312,27.0537204 C24.3853893,26.7867868 24.2795475,26.5465465 24.1472451,26.2796129 C24.0149428,26.0393727 23.85618,25.8258258 23.6709567,25.6122789 C23.4857334,25.3987321 23.2740496,25.2118785 23.0623659,25.025025 C22.8506821,24.8381715 22.6389984,24.6780113 22.4008542,24.5178512 C22.1891704,24.357691 21.9510262,24.2242242 21.7393424,24.0640641 C21.5011982,23.9039039 21.263054,23.7704371 21.0513703,23.6102769 C20.813226,23.4768101 20.5750818,23.31665 20.3633981,23.2098765 C20.1252538,23.0764097 19.8871096,22.9696363 19.6489654,22.8628629 C19.4108212,22.7560894 19.1462165,22.6760093 18.8816118,22.5959293 C18.6170071,22.5158492 18.325942,22.4357691 18.0084163,22.3823824 C17.7173512,22.3289957 17.3998255,22.2756089 17.0822999,22.2489156 C16.7647743,22.2222222 16.4472487,22.2222222 16.129723,22.2222222 C15.8121974,22.2222222 15.4946718,22.2489156 15.2036066,22.2756089 C15.0183833,22.3023023 14.8596205,22.3289957 14.7008577,22.355689 C14.5420949,22.3823824 14.3833321,22.4357691 14.2245693,22.4891558 C14.0658065,22.5425425 13.9335041,22.5959293 13.7747413,22.6760093 C13.6159785,22.7293961 13.4836761,22.8094761 13.3513738,22.8895562 C13.13969,22.9696363 12.9015458,23.0497164 12.6898621,23.1297965 C12.4781783,23.2098765 12.2664946,23.31665 12.0548108,23.4234234 C11.8431271,23.5301969 11.6579038,23.6636637 11.44622,23.7971305 C11.2609968,23.9305973 11.049313,24.0640641 10.8640897,24.2242242 C10.7053269,24.357691 10.5730246,24.4911578 10.4407222,24.6246246 C10.3084199,24.7580914 10.1496571,24.9182516 10.0173547,25.0784117 C9.88505237,25.2385719 9.75275002,25.3987321 9.59398721,25.5588922 C9.46168487,25.7190524 9.32938252,25.8792125 9.19708018,26.0660661 C9.06477783,26.2262262 8.95893596,26.4130797 8.82663361,26.5999333 C8.69433127,26.7867868 8.61494986,26.9736403 8.50910798,27.1604938 C8.40326611,27.3473473 8.3238847,27.5342009 8.2445033,27.7210544 C8.16512189,27.9079079 8.08574048,28.1214548 8.03281954,28.3083083 C7.97989861,28.4684685 7.95343814,28.6286286 7.9005172,28.7887888 C7.87405673,28.9489489 7.84759626,29.1091091 7.82113579,29.2692693 C7.79467532,29.4294294 7.79467532,29.6162829 7.76821485,29.7764431 C7.76821485,29.9632966 7.74175439,30.1234568 7.74175439,30.3103103 C7.74175439,30.4971638 7.74175439,30.657324 7.74175439,30.8441775 C7.74175439,31.031031 7.74175439,31.1911912 7.74175439,31.3780447 C7.74175439,31.5648982 7.76821485,31.7250584 7.76821485,31.9119119 C7.76821485,32.0987654 7.79467532,32.2589256 7.82113579,32.4190858 C7.84759626,32.5792459 7.87405673,32.7660994 7.87405673,32.9262596 C7.9005172,33.0864198 7.92697767,33.2732733 7.95343814,33.4334334 C7.97989861,33.5935936 8.03281954,33.7537538 8.05928001,33.9139139 C8.11220095,34.0740741 8.16512189,34.2342342 8.21804283,34.3943944 C8.27096376,34.5545546 8.3238847,34.7147147 8.40326611,34.8748749 C8.45618705,35.035035 8.53556845,35.1951952 8.61494986,35.328662 C8.72079174,35.5155155 8.82663361,35.7290624 8.93247549,35.9426093 C9.03831736,36.1561562 9.17061971,36.3430097 9.30292205,36.5298632 C9.4352244,36.7167167 9.59398721,36.9302636 9.72628956,37.1171171 C9.88505237,37.3039706 10.0438152,37.4908242 10.202578,37.6509843 C10.3613408,37.8111445 10.5465641,37.9713046 10.7317874,38.1314648 C10.9170107,38.291625 11.1022339,38.3983984 11.3139177,38.5318652 C11.499141,38.665332 11.7108247,38.7721054 11.896048,38.8788789 C12.0812713,38.9856523 12.292955,39.0924258 12.5046388,39.1725058 C12.7692435,39.3059726 13.0338482,39.4127461 13.3249133,39.4928262 C13.6159785,39.5729062 13.9070436,39.6529863 14.2245693,39.706373 C14.5420949,39.7597598 14.8331601,39.8131465 15.1506857,39.8665332 C15.4417508,39.9199199 15.7592765,39.9466133 16.0503416,39.9733066 C16.3414068,40 16.6324719,40 16.9235371,40 C17.2146023,40 17.5056674,39.9733066 17.7967326,39.9199199 C18.0348768,39.8932266 18.273021,39.8398398 18.5111652,39.8131465 C18.7493095,39.7597598 18.9609932,39.706373 19.172677,39.6529863 C19.3843607,39.5995996 19.5960445,39.5195195 19.8077282,39.4127461 C20.019412,39.3059726 20.2310957,39.1991992 20.4692399,39.0657324 C20.6809237,38.9322656 20.8926074,38.7987988 21.1042912,38.6386386 C21.3159749,38.5051718 21.5276587,38.3450117 21.712882,38.1848515 C21.9245657,38.0246914 22.109789,37.8645312 22.2950123,37.704371 C22.4802356,37.5442109 22.6654589,37.3840507 22.8506821,37.1971972 C22.956524,37.0904238 23.0888264,36.956957 23.1946682,36.8501835 C23.3005101,36.7434101 23.406352,36.6099433 23.5121939,36.4764765 C23.6444962,36.3163163 23.7767986,36.1561562 23.8826404,35.995996 C23.9884823,35.8358358 24.1207847,35.6756757 24.2266265,35.4888222 C24.3324684,35.328662 24.4383103,35.1418085 24.5176917,34.954955 C24.5970731,34.7681014 24.702915,34.6079413 24.7822964,34.4210878 C24.8616778,34.2342342 24.9145987,34.0473807 24.9939801,33.8605272 C25.0733615,33.6736737 25.099822,33.4868202 25.1527429,33.2732733 C25.2056639,33.0864198 25.2321243,32.8728729 25.2585848,32.6860194 C25.2850453,32.4724725 25.3115058,32.285619 25.3379662,32.0720721 C25.3644267,31.8318318 25.3908872,31.5648982 25.3908872,31.2979646 C25.4173476,31.031031 25.4173476,30.7907908 25.4173476,30.5238572 C25.4438081,30.3103103 25.4438081,30.0700701 25.4173476,29.8031365 Z M20.7867656,35.702369 C20.5486213,35.8625292 20.3104771,36.0226894 20.0723329,36.1294628 C19.3843607,36.4764765 18.6699281,36.66333 17.9554954,36.8501835 C17.6115093,36.9302636 17.3733651,37.0637304 17.0029185,37.0637304 C16.6853929,37.0637304 16.3414068,37.0103437 16.0503416,36.956957 C14.436253,36.7167167 12.9015458,36.0493827 12.0548108,34.5812479 C11.8166666,34.1808475 11.6579038,33.700367 11.4726805,33.2732733 C11.2874572,32.8728729 11.1286944,32.4724725 11.049313,32.0453787 C10.8905502,31.1378045 10.9699316,30.0967634 11.1816153,29.2158825 C11.3668386,28.4150817 11.7902061,27.8278278 12.2400341,27.1604938 C12.345876,27.0003337 12.4517179,26.8668669 12.5840202,26.7334001 C13.6953599,25.6389723 14.9654624,25.025025 16.5266301,25.025025 C17.7702721,25.025025 19.119756,25.318652 20.1252538,26.0927594 C20.5221609,26.4130797 20.9719889,26.7067067 21.3159749,27.1071071 C21.4482773,27.2405739 21.6864215,27.4007341 21.7658029,27.5875876 C22.1362495,28.3350017 22.4008542,29.0557224 22.5331565,29.8832165 C22.6389984,30.6039373 22.7183798,31.3513514 22.6654589,32.0720721 C22.5331565,33.4601268 21.8716448,34.8748749 20.7867656,35.702369 Z",id:"Shape",fill:"#107B86",__source:{fileName:_jsxFileName,lineNumber:19}}),_react2.default.createElement("path",{d:"M25.8904348,29.4960603 C25.8904348,29.3983937 25.8655259,29.3007271 25.8655259,29.2030605 C25.8406169,29.1053939 25.8406169,29.0077273 25.8157079,28.9100607 C25.7907989,28.8123941 25.7907989,28.7147275 25.7658899,28.6170609 C25.7409809,28.5193943 25.7160719,28.4217277 25.691163,28.3240611 C25.666254,28.2263945 25.641345,28.1287279 25.616436,28.055478 C25.591527,27.9822281 25.591527,27.9089781 25.566618,27.8357282 C25.5417091,27.7624782 25.5417091,27.6892283 25.5168001,27.6159783 C25.4918911,27.5427284 25.4918911,27.4694784 25.4669821,27.3962285 C25.4420731,27.3229785 25.4420731,27.2497286 25.4171641,27.1764786 C25.3673462,26.9811454 25.2926192,26.8102289 25.2178922,26.6148957 C25.1431653,26.4439791 25.0684383,26.2486459 24.9688024,26.0777294 C24.5702586,25.19873 24.1218969,24.4173972 23.3995363,23.7581477 C23.1753555,23.5628145 22.9262656,23.3430647 22.6522668,23.1965648 C22.303541,22.9768149 21.9548152,22.7570651 21.6309984,22.5128986 C21.5064535,22.3908153 21.3071816,22.3908153 21.1577277,22.2931487 C20.709366,22.000149 20.1613683,21.8292324 19.6382796,21.6338992 C18.8661011,21.3653161 18.0441046,21.1943995 17.1971991,21.1211496 C16.6242924,21.0723163 16.0762948,21.2188162 15.5033881,21.1943995 C14.9553904,21.1699829 14.4323018,21.2432328 13.8843041,21.3653161 C13.2864885,21.4873993 12.7633998,21.7803991 12.2154021,22.0245656 C11.5428595,22.3175654 10.9201349,22.7814817 10.3721372,23.2698147 C9.74941259,23.806981 9.15159695,24.3441473 8.65341725,25.0033968 C8.42923639,25.2963966 8.27978248,25.5161465 8.13032857,25.8579796 C7.93105669,26.2974792 7.7566938,26.7125623 7.55742192,27.152062 C7.53251293,27.1764786 7.53251293,27.2253119 7.48269496,27.2497286 C7.45778598,27.2741452 7.40796801,27.2741452 7.35815004,27.2741452 C7.18378714,27.2741452 7.00942425,27.2741452 6.83506135,27.2741452 C6.7603344,28.0310614 6.73542541,28.6170609 6.81015237,28.958894 L6.63578947,29.2518938 C6.63578947,29.2518938 7.2585141,29.3007271 7.65705786,29.3739771 C7.80651177,29.3983937 8.03069263,29.4228104 8.27978248,29.447227 C8.27978248,29.3495604 8.30469147,29.2763105 8.30469147,29.1786439 C8.32960045,29.032144 8.35450944,28.8856441 8.37941842,28.7391442 C8.40432741,28.5926443 8.45414538,28.4461444 8.50396335,28.2996445 C8.55378131,28.1287279 8.62850827,27.9333948 8.70323522,27.7624782 C8.77796218,27.5915617 8.85268913,27.4206451 8.95232507,27.2497286 C9.05196101,27.078812 9.15159695,26.9078955 9.25123289,26.7369789 C9.35086883,26.5660624 9.47541376,26.4195625 9.59995868,26.2486459 C9.72450361,26.1021461 9.84904853,25.9312295 9.97359346,25.7847296 C10.0981384,25.6382297 10.2226833,25.4917298 10.3721372,25.3452299 C10.4966821,25.19873 10.6461361,25.0766468 10.770681,24.9301469 C10.8952259,24.8080636 11.0446798,24.6859804 11.1692247,24.5638971 C11.3435876,24.4173972 11.5179505,24.295314 11.7172224,24.1732308 C11.8915853,24.0511475 12.0908572,23.9290643 12.2901291,23.8313977 C12.4894009,23.7337311 12.6886728,23.6360645 12.8879447,23.5628145 C13.0872166,23.4895646 13.3113974,23.391898 13.5106693,23.3430647 C13.6352142,23.2698147 13.7846682,23.2209814 13.9092131,23.1477315 C14.033758,23.0744815 14.1832119,23.0256482 14.3326658,22.9768149 C14.4821197,22.9279816 14.6315736,22.8791483 14.7810276,22.8547317 C14.9304815,22.830315 15.1048444,22.8058984 15.2542983,22.7814817 C15.5532061,22.7570651 15.8521139,22.7326484 16.1261127,22.7326484 C16.4250206,22.7326484 16.7239284,22.7326484 17.0228362,22.7570651 C17.321744,22.7814817 17.5957429,22.8058984 17.8946507,22.8791483 C18.1686495,22.9279816 18.4426483,23.0012316 18.7166472,23.0744815 C18.965737,23.1477315 19.2148269,23.2209814 19.4390077,23.318648 C19.6631886,23.4163146 19.8873695,23.5139812 20.1115503,23.6360645 C20.3357312,23.7581477 20.5599121,23.880231 20.7591839,24.0023142 C20.9833648,24.1243975 21.2075457,24.2708973 21.4068175,24.4173972 C21.6060894,24.5394805 21.8053613,24.6859804 22.0295422,24.8324803 C22.2288141,24.9789802 22.4529949,25.1254801 22.6522668,25.2963966 C22.8515387,25.4673132 23.0508106,25.6382297 23.2251735,25.8335629 C23.3995363,26.0288961 23.5489903,26.2242293 23.6735352,26.4439791 C23.7980801,26.663729 23.897716,26.9078955 23.997352,27.152062 C24.0969879,27.3962285 24.1966239,27.6159783 24.2962598,27.8601448 C24.3958957,28.0310614 24.4706227,28.2263945 24.5453497,28.4217277 C24.6200766,28.6170609 24.6948036,28.7879775 24.7446215,28.9833107 C24.7944395,29.2030605 24.8442575,29.447227 24.8691665,29.6669769 C24.8691665,29.7158102 24.8691665,29.7890601 24.8691665,29.8378934 C25.1929833,29.8867267 25.591527,29.93556 25.9153438,29.9843933 C25.9153438,29.93556 25.8904348,29.8867267 25.8904348,29.8134768 C25.9153438,29.6913935 25.9153438,29.5937269 25.8904348,29.4960603 Z M92.8706954,29.8623101 C92.7959684,29.8623101 92.7212415,29.8623101 92.6465145,29.8867267 C92.5966965,29.8867267 92.5219696,29.8867267 92.4721516,29.8623101 C92.2728797,29.7646435 92.3226977,29.0077273 92.2977887,28.7879775 C92.2728797,28.7147275 92.2728797,28.6414776 92.2479708,28.5682276 C92.2230618,28.4949777 92.1981528,28.4217277 92.1732438,28.3484778 C92.1483348,28.2752278 92.1234258,28.2019779 92.0736079,28.1287279 C92.0486989,28.055478 91.9988809,27.9822281 91.9739719,27.9089781 C91.9490629,27.8357282 91.899245,27.7624782 91.874336,27.7136449 C91.849427,27.640395 91.799609,27.5915617 91.7747,27.5183117 C91.7497911,27.4450618 91.6999731,27.3962285 91.6750641,27.3229785 C91.6501551,27.2497286 91.6003371,27.2008953 91.5754282,27.1276453 C91.5505192,27.0543954 91.5007012,26.9811454 91.4757922,26.9078955 C91.4508832,26.8346455 91.4010653,26.7369789 91.3512473,26.663729 C91.3014293,26.590479 91.2516114,26.4928124 91.2267024,26.4195625 C91.2017934,26.3463125 91.1270664,26.2486459 91.0772485,26.175396 C91.0274305,26.1021461 90.9776125,26.0288961 90.9277945,25.9556462 C90.8779766,25.8823962 90.8530676,25.8091463 90.8032496,25.7358963 C90.7534317,25.6626464 90.7285227,25.5893964 90.7036137,25.5161465 C90.6787047,25.4673132 90.6537957,25.3940632 90.6288867,25.3452299 C90.6039777,25.2963966 90.5790688,25.2231467 90.5541598,25.1743134 C90.5292508,25.1254801 90.5043418,25.0522301 90.4545238,25.0033968 C90.4296148,24.9545635 90.3797969,24.8813136 90.3299789,24.8324803 C90.2801609,24.7592303 90.205434,24.710397 90.155616,24.6371471 C90.105798,24.5883138 90.0310711,24.5150638 89.9563441,24.4662305 C89.8816172,24.4173972 89.8317992,24.3441473 89.7819812,24.2708973 C89.7321633,24.1976474 89.6574363,24.1243975 89.6325273,24.0511475 C89.1592566,23.2453981 88.2376242,22.8058984 87.4156277,22.3908153 C87.1914468,22.2687321 86.942357,22.1466489 86.6932671,22.0489823 C86.5189042,21.9757323 86.3196323,21.9024824 86.1452694,21.8536491 C86.0456335,21.8292324 85.9459976,21.8048158 85.8712706,21.7803991 C85.7716347,21.7559825 85.6719987,21.7315658 85.5723628,21.7071492 C85.4727268,21.6827325 85.3730909,21.6827325 85.273455,21.6583159 C85.173819,21.6338992 85.0741831,21.6338992 84.9745471,21.6338992 C84.8749112,21.6338992 84.7752753,21.6094826 84.6756393,21.6094826 C84.5760034,21.6094826 84.4763674,21.5850659 84.3767315,21.5850659 C84.2770956,21.5850659 84.1774596,21.5606493 84.0778237,21.5606493 C83.9781877,21.5606493 83.8785518,21.5362326 83.7789159,21.5362326 C83.6792799,21.5362326 83.604553,21.511816 83.504917,21.511816 C83.4052811,21.511816 83.3305541,21.4873993 83.2558272,21.4873993 C83.1811002,21.4873993 83.0814643,21.4873993 83.0067373,21.4873993 C82.9320104,21.4873993 82.8323744,21.4873993 82.7327385,21.4873993 C82.6331026,21.4873993 82.5583756,21.4873993 82.4587397,21.511816 C82.3591037,21.511816 82.2594678,21.5362326 82.1598318,21.5362326 C82.0601959,21.5362326 81.96056,21.5606493 81.860924,21.5606493 C81.7612881,21.5606493 81.6616521,21.5850659 81.5620162,21.6094826 C81.4623803,21.6338992 81.3627443,21.6338992 81.2631084,21.6583159 C81.1634724,21.6827325 81.0638365,21.6827325 80.9642006,21.7071492 C80.8396556,21.7315658 80.7400197,21.7559825 80.6154748,21.7803991 C80.4909299,21.8048158 80.3663849,21.8292324 80.24184,21.8536491 C80.1172951,21.8780657 79.9927502,21.9024824 79.8432962,21.926899 C79.7187513,21.9513157 79.5942064,22.000149 79.4696615,22.0245656 C79.3451165,22.0489823 79.2454806,22.0978156 79.1458447,22.1222322 C79.0462087,22.1710655 78.9465728,22.1954822 78.8469368,22.2443155 C78.647665,22.3175654 78.4483931,22.415232 78.2242122,22.5373152 C78.0249403,22.6349818 77.8256685,22.7570651 77.6513056,22.8791483 C77.4520337,23.0012316 77.2776708,23.1477315 77.1033079,23.2942314 C76.928945,23.4407313 76.7794911,23.5872312 76.6051282,23.7337311 C76.4556743,23.880231 76.3062204,24.0511475 76.1567665,24.1976474 C75.5589508,24.8568969 75.0856801,25.6138131 74.7120453,26.4195625 C74.6622274,26.5172291 74.6373184,26.590479 74.5875004,26.6881456 C74.5376825,26.8102289 74.4878645,26.9078955 74.4629555,27.0299787 C74.4380465,27.152062 74.4131375,27.2497286 74.3882285,27.3718118 C74.3633196,27.4938951 74.3384106,27.5915617 74.3384106,27.7136449 C74.3135016,27.8357282 74.3135016,27.9333948 74.2885926,28.055478 C74.2636836,28.1775612 74.2387746,28.2752278 74.2138656,28.3973111 C74.1889567,28.5193943 74.1640477,28.6414776 74.1391387,28.7635608 C74.1142297,28.8612274 74.0893207,28.9833107 74.0395028,29.0809773 C73.9896848,29.1786439 73.9896848,29.3007271 73.9398668,29.3983937 C73.8900488,29.4960603 73.8900488,29.6181436 73.8651399,29.7158102 C73.8402309,29.8134768 73.8153219,29.93556 73.8153219,30.0332266 C73.7904129,30.1308932 73.7655039,30.2529764 73.7405949,30.350643 C73.7405949,30.4483096 73.7655039,30.5215596 73.7156859,30.6192262 C73.7156859,30.6436428 73.690777,30.6680595 73.690777,30.6924761 C73.690777,30.7168928 73.690777,30.7413094 73.690777,30.7657261 C73.690777,30.8145594 73.690777,30.8633927 73.7156859,30.912226 C73.7156859,30.9366426 73.7156859,30.9610593 73.7405949,30.9610593 C73.7405949,30.9610593 73.7655039,30.9610593 73.7655039,30.9610593 C73.8402309,30.9610593 74.6871364,31.0831425 74.6871364,31.0587259 C74.6871364,31.0343092 74.6871364,31.0098926 74.6871364,30.9854759 C74.6871364,30.2529764 74.7120453,29.5937269 74.8614993,28.8612274 C74.9113172,28.6658942 74.9362262,28.4461444 75.0109532,28.2508112 C75.1853161,27.6159783 75.4842239,26.8834788 75.9325856,26.3707292 C76.5553102,25.6626464 77.1531259,24.9057302 77.9253044,24.295314 C78.8220279,23.5872312 80.216931,23.2453981 81.3129264,22.9768149 C81.4872893,22.9279816 81.6616521,22.903565 81.836015,22.8547317 C82.0103779,22.830315 82.2096498,22.7814817 82.3840127,22.7570651 C82.5583756,22.7326484 82.7576475,22.7082318 82.9320104,22.7082318 C83.1063733,22.7082318 83.3056452,22.6838151 83.480008,22.7082318 C83.6543709,22.7082318 83.8536428,22.7326484 84.0280057,22.7570651 C84.2023686,22.7814817 84.3767315,22.830315 84.5760034,22.8791483 C84.8250932,22.9523983 85.0492741,23.0012316 85.273455,23.0500649 C85.4976358,23.0988982 85.7467257,23.1721481 85.9709065,23.2453981 C86.2449054,23.3430647 86.4939952,23.4651479 86.7430851,23.5872312 C86.9921749,23.7093144 87.2412648,23.8558143 87.4654456,24.0023142 C87.5899906,24.0755642 87.7394445,24.1732308 87.8639894,24.2708973 C88.0632613,24.4173972 88.2376242,24.6127304 88.4368961,24.783647 C88.6361679,24.9789802 88.8354398,25.1743134 89.0347117,25.3940632 C89.2339836,25.5893964 89.4332555,25.8091463 89.6325273,26.0044795 C89.8317992,26.2242293 89.9812531,26.4195625 90.130707,26.6881456 C90.180525,26.7613956 90.205434,26.8102289 90.230343,26.9078955 C90.3050699,27.1764786 90.4794328,27.4206451 90.5790688,27.6892283 C90.7036137,28.0310614 90.8032496,28.3728944 90.8779766,28.7391442 C90.9277945,28.9344774 90.9527035,29.1542272 91.0025215,29.3495604 C91.0274305,29.5448936 91.0772485,29.7646435 91.1021574,29.9599767 C91.1270664,30.1797265 91.1519754,30.3750597 91.1768844,30.5948095 C91.2017934,30.7413094 91.2017934,30.8878093 91.2017934,31.0343092 C91.2017934,31.0343092 91.2017934,31.0587259 91.2017934,31.0587259 C91.3014293,31.0587259 91.3761563,31.0587259 91.4259742,31.0587259 C92.1483348,30.9854759 92.3226977,31.1808091 92.7710594,31.0831425 C92.8706954,31.0098926 92.9454223,30.5703929 92.8706954,29.8623101 Z",id:"Shape",fill:"#292663",fillRule:"nonzero",__source:{fileName:_jsxFileName,lineNumber:20}}),_react2.default.createElement("path",{d:"M102.735221,20.089032 C102.704544,20.089032 102.704544,20.089032 102.704544,20.1187093 C102.459129,20.2077413 102.244391,20.2967733 101.998975,20.3858053 C101.784237,20.4748373 101.569498,20.6232239 101.35476,20.7122559 C101.201375,20.8012879 101.047991,20.8606426 100.894606,20.9199972 C100.618514,21.0387066 100.342422,21.1574159 100.127683,21.3354799 C99.9129451,21.5135438 99.7595605,21.7806398 99.6675297,22.0477358 C99.575499,22.3148318 99.5448221,22.6116051 99.5448221,22.9083784 C99.5141452,23.412893 99.575499,23.9174076 99.6675297,24.3922449 C99.7288836,24.6890182 99.8209143,24.9857915 100.004976,25.2232101 C100.189037,25.4309514 100.46513,25.5793381 100.741222,25.5496608 C101.047991,25.5199834 101.385437,25.5496608 101.722883,25.5496608 C102.244391,25.5793381 102.796575,25.4903061 103.318083,25.4309514 C103.900944,25.4012741 104.453128,25.3715968 105.03599,25.3419194 C105.03599,25.3419194 105.066667,25.3419194 105.066667,25.3419194 C105.066667,25.2528875 105.066667,25.1341781 105.03599,25.0451461 C105.005313,24.8077275 104.913282,24.5999862 104.913282,24.4219222 C104.882605,24.2438582 104.882605,24.0361169 104.821251,23.8283756 C104.790574,23.6503116 104.729221,23.4722476 104.698544,23.2645063 C104.63719,23.0864423 104.575836,22.878701 104.514482,22.6709597 C104.453128,22.4632184 104.361098,22.2851544 104.269067,22.0774131 C104.177036,21.8696718 104.085005,21.6916078 103.992975,21.4838665 C103.900944,21.3058025 103.778236,21.0980612 103.655529,20.9199972 C103.532821,20.7419333 103.410113,20.5638693 103.287406,20.4154826 C103.226052,20.3264506 103.134021,20.2374186 103.04199,20.178064 C102.980636,20.1187093 102.888606,20 102.796575,20 C102.735221,20.089032 102.735221,20.089032 102.735221,20.089032 Z",id:"Shape",fill:"#E5B200",__source:{fileName:_jsxFileName,lineNumber:21}}),_react2.default.createElement("path",{d:"M72.8697746,31.2741676 C72.8449927,31.3013437 72.8202108,31.3013437 72.7954289,31.2741676 C72.6219555,31.2469915 72.473264,31.2469915 72.2997906,31.2469915 C72.1263173,31.2469915 71.9776258,31.2469915 71.8041524,31.2469915 C71.6554609,31.2469915 71.5067694,31.2741676 71.3828599,31.2741676 C71.2341684,31.2741676 71.0854769,31.2741676 70.9615673,31.2741676 C70.8128759,31.2741676 70.6889663,31.2741676 70.5402748,31.2469915 C70.3915833,31.2469915 70.2676738,31.2469915 70.1189823,31.2469915 C69.9702908,31.2469915 69.8463812,31.2469915 69.6976898,31.2469915 C69.5489983,31.2469915 69.4250887,31.2469915 69.2763972,31.2469915 C69.1277058,31.2469915 68.9790143,31.2469915 68.8303228,31.2469915 C68.6816313,31.2469915 68.5329399,31.2469915 68.3842484,31.2741676 C68.2355569,31.2741676 68.0868654,31.3013437 67.9381739,31.3013437 C67.7894825,31.3013437 67.640791,31.3285198 67.4920995,31.3285198 C67.343408,31.3285198 67.1947165,31.3556959 67.0460251,31.3556959 C66.8973336,31.3556959 66.7486421,31.3556959 66.5999506,31.3556959 C66.4016953,31.3556959 66.20344,31.3556959 66.0299666,31.3556959 C64.6669614,31.382872 63.3287381,31.382872 61.9657329,31.4100481 C61.5692223,31.4100481 61.1974936,31.4100481 60.800983,31.4100481 C60.4044724,31.4100481 60.0327437,31.4100481 59.6362331,31.4100481 C59.4875416,31.4100481 59.363632,31.4100481 59.2149405,31.4100481 C59.0662491,31.4100481 58.9423395,31.4100481 58.793648,31.4100481 C58.6449565,31.4100481 58.521047,31.4100481 58.3723555,31.4100481 C58.223664,31.4100481 58.0997544,31.4100481 57.951063,31.4100481 C57.8023715,31.4100481 57.6784619,31.4100481 57.5297704,31.4100481 C57.381079,31.4100481 57.2571694,31.4100481 57.1084779,31.4100481 C56.9102226,31.4100481 56.6871854,31.4100481 56.4889301,31.4100481 C56.2906748,31.4100481 56.0676376,31.4100481 55.8693823,31.4100481 C55.671127,31.4100481 55.4480897,31.4100481 55.2498344,31.4100481 C55.0515791,31.4100481 54.8285419,31.4100481 54.6302866,31.4100481 C54.4320313,31.4100481 54.2089941,31.4100481 54.0107388,31.4100481 C53.8124835,31.4100481 53.5894463,31.4100481 53.366409,31.4100481 C53.1433718,31.4100481 52.9451165,31.4100481 52.7220793,31.4372242 C52.4990421,31.4372242 52.3007868,31.4372242 52.0777496,31.4644002 C51.8547123,31.4644002 51.656457,31.4644002 51.4334198,31.4644002 C51.2103826,31.4644002 51.0121273,31.4644002 50.7890901,31.4644002 C49.10392,31.4644002 47.4187499,31.4644002 45.7335798,31.4915763 C41.0993621,31.4915763 36.4651443,31.4915763 31.8309266,31.4644002 C31.6326713,31.4644002 31.434416,31.4644002 31.2609426,31.4644002 C31.0626873,31.4644002 30.864432,31.4644002 30.6909586,31.4644002 C30.4927033,31.4644002 30.2944479,31.4644002 30.1209746,31.4644002 C29.9227193,31.4644002 29.7244639,31.4644002 29.5509906,31.4915763 C29.3527353,31.4915763 29.1544799,31.4915763 28.9810066,31.5187524 C28.7827513,31.5187524 28.5844959,31.5187524 28.4110226,31.5187524 C28.2375492,31.5187524 28.0145119,31.5187524 27.8410386,31.5187524 C27.6427832,31.5187524 27.4693099,31.5187524 27.2710546,31.4915763 C27.0727992,31.4915763 26.8993259,31.4644002 26.7010706,31.4644002 C26.5028152,31.4644002 26.3293419,31.4372242 26.1310865,31.4372242 C25.9823951,31.4372242 25.8832674,31.4372242 25.7841398,31.4372242 C25.6850121,31.4372242 25.6106664,31.4100481 25.5363206,31.3013437 C25.5115387,31.2469915 25.4619749,31.1926394 25.4619749,31.1111111 C25.4619749,31.1382872 25.437193,31.1654633 25.437193,31.1926394 C25.437193,31.2198155 25.437193,31.2198155 25.437193,31.2469915 C25.437193,31.3013437 25.4619749,31.3285198 25.4619749,31.382872 C25.6602302,32.5514437 25.7593579,33.8287198 26.9984535,34.1276568 C27.2710546,34.209185 27.5684375,34.209185 27.8410386,34.209185 C28.7084055,34.209185 29.6005544,34.3178894 30.4431394,34.209185 C31.1865968,34.1276568 31.9548361,34.2635372 32.6735116,34.2363611 C33.0700222,34.2363611 33.4665328,34.1820089 33.8630434,34.1548328 C34.3586817,34.1548328 34.85432,34.1820089 35.3499582,34.1820089 C37.2333836,34.1820089 39.0920271,34.2907133 40.9506706,34.2635372 C41.7932556,34.2363611 42.6606226,34.2635372 43.5032076,34.2635372 C43.676681,34.2635372 43.8501544,34.2635372 44.0236278,34.2635372 C44.1971012,34.2635372 44.3705746,34.2635372 44.544048,34.2635372 C44.7175214,34.2635372 44.8909948,34.2635372 45.0644682,34.2635372 C45.2379415,34.2635372 45.4114149,34.2635372 45.5848883,34.2635372 C45.7583617,34.2635372 45.9318351,34.2635372 46.1053085,34.2635372 C46.3035638,34.2635372 46.4770372,34.2635372 46.6752925,34.2635372 C46.8735478,34.2635372 47.0470212,34.2635372 47.2452765,34.2635372 C47.4435318,34.2635372 47.6170052,34.2635372 47.8152605,34.2635372 C48.0135158,34.2635372 48.1869892,34.2635372 48.3852445,34.2635372 C48.5834998,34.2635372 48.7569732,34.2635372 48.9552285,34.2363611 C49.1534838,34.2363611 49.3269572,34.2363611 49.5252125,34.2363611 C49.7234678,34.2363611 49.8969412,34.2363611 50.0951965,34.2363611 C50.243888,34.2363611 50.4173614,34.2363611 50.5660529,34.2363611 C50.7147443,34.2363611 50.8882177,34.2363611 51.0616911,34.2635372 C51.2351645,34.2635372 51.383856,34.2907133 51.5573294,34.2907133 C52.6972974,34.3450655 53.8620473,34.4809459 55.0020153,34.3450655 C55.8941642,34.2363611 56.8358769,34.3994176 57.7280257,34.4265937 C58.6697384,34.4537698 59.6114511,34.4537698 60.5531638,34.3994176 C62.1392063,34.3450655 63.7004668,34.3722415 65.2865092,34.2907133 C66.4264772,34.2363611 67.5664452,34.3722415 68.6816313,34.3722415 C68.9542324,34.3722415 69.2268334,34.3722415 69.4994345,34.3722415 C69.6481259,34.3722415 69.7720355,34.3722415 69.920727,34.3722415 C70.0694185,34.3722415 70.193328,34.3722415 70.3420195,34.3722415 C70.490711,34.3722415 70.6146206,34.3722415 70.763312,34.3450655 C70.9120035,34.3450655 71.0359131,34.3178894 71.1846046,34.3178894 C71.4076418,34.2907133 71.630679,34.2635372 71.8537162,34.1820089 C71.9528439,34.1276568 72.0519715,34.0733046 72.1510992,33.9917763 C72.2502268,33.9102481 72.3245726,33.8287198 72.3989183,33.7200155 C72.473264,33.6113111 72.5228279,33.5026068 72.5971736,33.3667263 C72.6467374,33.2308459 72.6963013,33.0949655 72.7458651,32.959085 C72.7954289,32.8232046 72.8202108,32.6601481 72.8449927,32.5242676 C72.8697746,32.3883872 72.8945566,32.2253307 72.9193385,32.1166263 C72.9689023,31.8720415 72.9936842,31.6274568 72.9936842,31.382872 C72.8945566,31.3285198 72.8945566,31.2741676 72.8697746,31.2741676 C72.8945566,31.2469915 72.8697746,31.2469915 72.8697746,31.2741676 Z",id:"Shape",fill:"#C5168C",fillRule:"nonzero",__source:{fileName:_jsxFileName,lineNumber:22}}),_react2.default.createElement("path",{d:"M103.960702,30.3773585 C103.740399,30.3563941 103.495618,30.3563941 103.275315,30.3354298 C103.055012,30.3144654 102.810231,30.3144654 102.589928,30.3144654 C102.369625,30.3144654 102.149323,30.293501 101.904542,30.293501 C101.684239,30.293501 101.463936,30.2725367 101.243633,30.2725367 C101.02333,30.2725367 100.803027,30.2515723 100.582724,30.2515723 C100.362422,30.2515723 100.142119,30.230608 99.8973377,30.230608 C99.7015129,30.230608 99.5056882,30.2096436 99.3098634,30.2096436 C99.0650824,30.2096436 98.8203015,30.1886792 98.5755205,30.1886792 C98.3307395,30.1886792 98.0859586,30.1677149 97.8166995,30.1677149 C97.5719185,30.1677149 97.3026595,30.1467505 97.0578785,30.1467505 C96.8130975,30.1467505 96.5683166,30.1257862 96.3235356,30.1257862 C96.0787546,30.1257862 95.8339737,30.1048218 95.5891927,30.1048218 C95.3444117,30.1048218 95.0996308,30.0838574 94.8548498,30.0628931 C94.6100688,30.0419287 94.3652879,30.0419287 94.1205069,30.0209644 C93.8757259,30 93.630945,30 93.386164,30 C93.141383,30 92.8966021,30 92.6518211,30 C92.4070401,30 92.1622592,30.0209644 91.9174782,30.0419287 C91.868522,30.0419287 91.8195658,30.0419287 91.7950877,30.0419287 C91.8195658,30.293501 91.868522,30.5660377 91.868522,30.8176101 C91.868522,30.9433962 91.8440439,31.0901468 91.8440439,31.2159329 C91.8195658,31.3626834 91.7950877,31.4884696 91.8195658,31.6352201 C91.8195658,31.8658281 91.9174782,31.9706499 92.113303,32.0754717 C92.2356935,32.1174004 92.4315182,32.1383648 92.6028649,32.1383648 C92.7986897,32.1383648 92.9945145,32.1174004 93.141383,32.1174004 C93.2637735,32.1174004 93.4106421,32.1174004 93.5330326,32.1174004 C93.6554231,32.1174004 93.7778135,32.1174004 93.9246821,32.1174004 C94.0470726,32.1174004 94.1939412,32.1174004 94.3163317,32.1174004 C94.4387222,32.1174004 94.5855907,32.1174004 94.7079812,32.1174004 C94.8303717,32.1174004 94.9772403,32.1174004 95.0996308,32.1174004 C95.2220213,32.1174004 95.3688898,32.1174004 95.5157584,32.1383648 C95.6871051,32.1593291 95.8584518,32.1593291 96.0297984,32.1802935 C96.2011451,32.2012579 96.3724918,32.2012579 96.5438385,32.2012579 C96.7151851,32.2012579 96.8865318,32.2222222 97.0334004,32.2222222 C97.2047471,32.2222222 97.3516157,32.2222222 97.4984842,32.2222222 C97.6453528,32.2222222 97.7922214,32.2222222 97.9635681,32.2012579 C98.1104367,32.2012579 98.2573052,32.1802935 98.4041738,32.1802935 C98.5755205,32.1593291 98.7713453,32.1593291 98.9426919,32.1383648 C99.1385167,32.1174004 99.3098634,32.1174004 99.5056882,32.1174004 C99.7015129,32.1174004 99.8728596,32.1174004 100.068684,32.1174004 C100.240031,32.1174004 100.411378,32.1383648 100.582724,32.1383648 C100.754071,32.1383648 100.925418,32.1383648 101.072286,32.1383648 C101.243633,32.1383648 101.41498,32.1383648 101.561848,32.1174004 C101.733195,32.1174004 101.904542,32.1174004 102.05141,32.0964361 C102.247235,32.0964361 102.418582,32.0754717 102.589928,32.0545073 C102.761275,32.033543 102.932622,31.9706499 103.103968,31.8658281 C103.201881,31.8238994 103.275315,31.7610063 103.373227,31.6981132 C103.47114,31.6352201 103.544574,31.5513627 103.618008,31.4884696 C103.691443,31.4046122 103.740399,31.3207547 103.789355,31.2368973 C103.838311,31.1320755 103.862789,31.048218 103.887267,30.9224319 C103.911746,30.8176101 103.936224,30.6918239 103.936224,30.5660377 C103.936224,30.5031447 103.936224,30.4192872 103.936224,30.3563941 C103.960702,30.3563941 103.960702,30.3773585 103.960702,30.3773585 Z",id:"Shape",fill:"#C5168C",fillRule:"nonzero",__source:{fileName:_jsxFileName,lineNumber:23}}),_react2.default.createElement("path",{d:"M7.7163326,27.8330943 C7.69091081,27.8587038 7.69091081,27.9099228 7.64006722,27.9355323 C7.61464543,27.9611418 7.56380185,27.9611418 7.51295827,27.9611418 C6.80114814,27.9611418 6.08933801,27.9611418 5.37752788,27.9355323 C4.48776522,27.9355323 3.62342435,27.7818753 2.75908348,27.7818753 C1.86932082,27.7818753 0.979558156,27.7562658 0.0897954944,27.8330943 C0.0643737041,27.8330943 0.0135301234,27.8074848 0.0135301234,27.7818753 C0.0135301234,28.0891894 -0.0118916669,28.3965034 0.0135301234,28.7038175 C-0.0627352476,29.2416172 0.191482656,29.8562453 0.572809511,30.1891689 C0.674496672,30.2659974 0.776183834,30.3428259 0.903292785,30.4196544 C1.03040174,30.496483 1.1320889,30.547702 1.25919785,30.6245305 C1.3863068,30.6757495 1.51341575,30.7269685 1.64052471,30.7781875 C1.76763366,30.8294065 1.9201644,30.855016 2.04727335,30.9062351 C2.1743823,30.9318446 2.32691304,30.9574541 2.454022,30.9830636 C2.58113095,31.0086731 2.73366169,31.0342826 2.86077064,31.0342826 C3.01330138,31.0598921 3.16583213,31.0855016 3.31836287,31.0855016 C3.47089361,31.1111111 3.62342435,31.1111111 3.77595509,31.1111111 C3.92848584,31.1111111 4.08101658,31.1111111 4.23354732,31.1111111 C4.38607806,31.1111111 4.5386088,31.1111111 4.69113955,31.0855016 C4.8182485,31.0855016 4.94535745,31.0855016 5.04704461,31.0598921 C5.19957535,31.0598921 5.37752788,31.0598921 5.55548042,31.0598921 C5.73343295,31.0598921 5.88596369,31.0598921 6.06391622,31.0598921 C6.24186876,31.0598921 6.3943995,31.0598921 6.54693024,31.0342826 C6.69946098,31.0086731 6.87741351,30.9830636 7.00452247,30.9062351 C7.05536605,30.8806256 7.10620963,30.803797 7.10620963,30.752578 C7.10620963,30.65014 7.10620963,30.547702 7.10620963,30.4452639 C7.10620963,30.4452639 7.13163142,30.4196544 7.13163142,30.4196544 C7.182475,30.2916069 7.23331858,30.1379499 7.25874037,30.0099023 C7.28416216,29.8818548 7.30958395,29.7025883 7.33500574,29.5489312 C7.36042753,29.3952742 7.36042753,29.2416172 7.38584932,29.0879601 C7.41127111,28.9343031 7.4366929,28.8062555 7.46211469,28.678208 C7.51295827,28.5501605 7.53838006,28.3965034 7.58922364,28.2684559 C7.64006722,28.1147989 7.69091081,27.9355323 7.74175439,27.7818753 C7.7163326,27.8330943 7.7163326,27.8330943 7.7163326,27.8330943 Z",id:"Shape",fill:"#C5168C",fillRule:"nonzero",__source:{fileName:_jsxFileName,lineNumber:24}}),_react2.default.createElement("path",{d:"M5.50147079,13.8860147 C5.47311703,14.6755595 5.44476326,15.4651044 5.44476326,16.2546492 C5.4164095,17.5705572 5.35970196,18.8864653 5.3313482,20.2023733 C5.3313482,20.4655549 5.30299443,20.7287365 5.10451807,20.9129636 C4.93439547,21.0708726 4.6508578,21.0971908 4.39567391,21.0971908 C3.82859858,21.0971908 3.00633935,21.2024634 2.55267909,20.8340092 C2.18408013,20.5445094 2.21243389,19.9655098 2.21243389,19.5444193 C2.21243389,18.7022381 2.24078766,17.860057 2.29749519,17.0178758 C2.32584896,16.4388763 2.21243389,15.9388312 2.43926402,15.3861499 C2.63774039,14.8597867 2.94963182,14.3597416 3.37493831,13.9123329 C3.68682974,13.5701968 4.14049001,13.4649241 4.59415027,13.4122878 C4.96274923,13.3859697 5.52982456,13.1491062 5.52982456,13.6491513 C5.50147079,13.7281057 5.50147079,13.8070602 5.50147079,13.8860147 Z",id:"Shape",fill:"#E5B200",__source:{fileName:_jsxFileName,lineNumber:25}})))));};exports.default=IcCarBig;module.exports=exports["default"];

/***/ }),
/* 2047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-bus-big.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IcBusBig=function IcBusBig(props){return _react2.default.createElement("svg",{width:"205px",height:"64px",viewBox:"0 0 205 64",__source:{fileName:_jsxFileName,lineNumber:4}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("polygon",{id:"path-1",points:"0 0.247238095 0.397828839 0.247238095 0.397828839 0.646331066 0 0.646331066",__source:{fileName:_jsxFileName,lineNumber:6}}),_react2.default.createElement("polygon",{id:"path-3",points:"0.256130116 0.151655329 202.441645 0.151655329 202.441645 53.2370357 0.256130116 53.2370357",__source:{fileName:_jsxFileName,lineNumber:7}}),_react2.default.createElement("polygon",{id:"path-5",points:"0.0458571957 0.369796633 15.8558738 0.369796633 15.8558738 15.9637188 0.0458571957 15.9637188",__source:{fileName:_jsxFileName,lineNumber:8}}),_react2.default.createElement("polygon",{id:"path-7",points:"0 0.247238095 0.397828839 0.247238095 0.397828839 0.646331066 0 0.646331066",__source:{fileName:_jsxFileName,lineNumber:9}}),_react2.default.createElement("polygon",{id:"path-9",points:"0.256130116 0.151655329 202.441645 0.151655329 202.441645 53.2370357 0.256130116 53.2370357",__source:{fileName:_jsxFileName,lineNumber:10}}),_react2.default.createElement("polygon",{id:"path-11",points:"0.0458571957 0.369796633 15.8558738 0.369796633 15.8558738 15.9637188 0.0458571957 15.9637188",__source:{fileName:_jsxFileName,lineNumber:11}})),_react2.default.createElement("g",{id:"1A---1o-Acesso",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement("g",{id:"1A---7.5-Sucesso-(Varios)",transform:"translate(-915.000000, -594.000000)",__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement("g",{id:"onibus",transform:"translate(892.000000, 560.000000)",__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement("g",{id:"Group-2",__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement("g",{id:"Page-1",transform:"translate(23.000000, 34.000000)",__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement("path",{d:"M49.5707031,58.2030041 C49.6721719,58.198215 49.7780177,58.1938249 49.8870469,58.1890358 C49.7780177,58.1938249 49.6721719,58.198215 49.5707031,58.2030041",id:"Fill-1",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:18}}),_react2.default.createElement("path",{d:"M1.07460938,52.2275048 C1.09410729,52.1129651 1.12633854,52.00521 1.17926146,51.9138177 C1.12633854,52.00521 1.09410729,52.1129651 1.07460938,52.2275048",id:"Fill-3",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:19}}),_react2.default.createElement("path",{d:"M48.4177794,58.2727655 C48.372019,58.2767565 48.3282481,58.2807474 48.2876606,58.2843392 C48.3282481,58.2807474 48.372019,58.2767565 48.4177794,58.2727655",id:"Fill-5",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:20}}),_react2.default.createElement("path",{d:"M50.7054023,58.1577868 C50.5792627,58.162576 50.4571023,58.1665669 50.3369315,58.1709569 C50.4571023,58.1665669 50.5792627,58.162576 50.7054023,58.1577868",id:"Fill-7",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:21}}),_react2.default.createElement("path",{d:"M49.1926425,58.2217215 C49.1277821,58.2253134 49.0645133,58.2289052 49.0032342,58.232098 C49.0645133,58.2289052 49.1277821,58.2253134 49.1926425,58.2217215",id:"Fill-9",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:22}}),_react2.default.createElement("path",{d:"M49.5707031,58.2030041 C49.4700302,58.2077932 49.3741323,58.2121832 49.2806219,58.2169723 C49.3741323,58.2121832 49.4696323,58.2077932 49.5707031,58.2030041",id:"Fill-11",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:23}}),_react2.default.createElement("g",{id:"Group-15",transform:"translate(1.000000, 54.335873)",__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement("mask",{id:"mask-2",fill:"white",__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement("use",{xlinkHref:"#path-1",__source:{fileName:_jsxFileName,lineNumber:26}})),_react2.default.createElement("g",{id:"Clip-14",__source:{fileName:_jsxFileName,lineNumber:28}}),_react2.default.createElement("path",{d:"M0.00194979167,0.247238095 C-3.97916667e-05,0.311092971 -0.00123354167,0.377342404 0.001551875,0.443192744 C-0.00123354167,0.377342404 -3.97916667e-05,0.311092971 0.00194979167,0.247238095",id:"Fill-13",fill:"#D6DE23",mask:"url(#mask-2)",__source:{fileName:_jsxFileName,lineNumber:29}})),_react2.default.createElement("path",{d:"M48.6847417,58.2521324 C48.6107292,58.2573206 48.5430833,58.2621098 48.477825,58.2676971 C48.5430833,58.2621098 48.6107292,58.2573206 48.6847417,58.2521324",id:"Fill-16",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:31}}),_react2.default.createElement("path",{d:"M48.2390352,58.2891283 C48.1861123,58.2947156 48.1359748,58.3003029 48.0929998,58.3058902 C48.1359748,58.3003029 48.1861123,58.2947156 48.2390352,58.2891283",id:"Fill-18",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:32}}),_react2.default.createElement("path",{d:"M50.7054023,58.1577868 C50.8303481,58.1533968 50.959671,58.1494059 51.0905856,58.145415 C50.959671,58.1494059 50.8303481,58.1533968 50.7054023,58.1577868",id:"Fill-20",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:33}}),_react2.default.createElement("path",{d:"M48.6847417,58.2521324 C48.7591521,58.2469442 48.8391333,58.2421551 48.9222979,58.2369669 C48.8391333,58.2421551 48.7591521,58.2469442 48.6847417,58.2521324",id:"Fill-22",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:34}}),_react2.default.createElement("path",{d:"M52.9324225,58.0946503 C52.8269746,58.097444 52.7227204,58.0998385 52.6192621,58.1026322 C52.7227204,58.0998385 52.8269746,58.097444 52.9324225,58.0946503",id:"Fill-24",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:35}}),_react2.default.createElement("path",{d:"M137.642435,58.5077914 C137.765789,58.5085896 137.888347,58.5081905 138.012099,58.5085896 C138.002549,58.5077914 137.993397,58.5073923 137.984245,58.5065941 C137.87243,58.5069932 137.755045,58.5073923 137.642435,58.5077914",id:"Fill-26",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:36}}),_react2.default.createElement("path",{d:"M55.5825873,58.0400943 C55.5591102,58.0404934 55.536031,58.0408925 55.512156,58.0412916 C55.5356331,58.0408925 55.5591102,58.0404934 55.5825873,58.0400943",id:"Fill-28",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:37}}),_react2.default.createElement("path",{d:"M149.114372,58.4380299 C148.984651,58.4508009 148.813945,58.4619755 148.611405,58.4723519 C149.020862,58.4699574 149.434297,58.4679619 149.839774,58.4655673 C149.955966,58.4647692 150.06977,58.4627737 150.185564,58.4619755 C149.511493,58.4472091 149.114372,58.4380299 149.114372,58.4380299",id:"Fill-30",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:38}}),_react2.default.createElement("path",{d:"M55.0156356,58.0506304 C54.708046,58.0566168 54.4044356,58.0622041 54.1052023,58.0685896 C54.4040377,58.0622041 54.708444,58.0566168 55.0156356,58.0506304",id:"Fill-32",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:39}}),_react2.default.createElement("g",{id:"Group-36",transform:"translate(1.795833, 5.247438)",__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement("mask",{id:"mask-4",fill:"white",__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement("use",{xlinkHref:"#path-3",__source:{fileName:_jsxFileName,lineNumber:42}})),_react2.default.createElement("g",{id:"Clip-35",__source:{fileName:_jsxFileName,lineNumber:44}}),_react2.default.createElement("path",{d:"M201.414235,43.8699755 C201.378821,43.8532136 201.344998,43.8324608 201.313562,43.8081161 C201.057702,43.6085696 201.194983,42.8255492 201.160364,42.5102658 C201.124154,42.1822113 201.078394,41.8174404 201.021491,41.4275265 C200.944694,40.9071093 200.846806,40.3407964 200.729819,39.7389642 C200.671325,39.4388463 200.608852,39.1307465 200.545185,38.8146649 C200.481916,38.4989823 200.418648,38.1741206 200.356573,37.8388825 C200.294896,37.5032454 200.234412,37.1548372 200.177112,36.7908644 C200.119812,36.4268916 200.066889,36.0449596 200.018344,35.6506558 C199.973379,35.2850866 199.9312,34.9107374 199.892602,34.5284063 C199.853606,34.1464744 199.815406,33.7581569 199.775614,33.3654494 C199.735823,32.972742 199.692848,32.5760435 199.646689,32.1769506 C199.607694,31.8409143 199.565514,31.5036807 199.520948,31.1660481 C199.476381,30.8280163 199.429825,30.4903837 199.382473,30.1539483 C199.334325,29.8171138 199.285381,29.4822748 199.235641,29.1502295 C199.185902,28.8185832 199.135366,28.4905288 199.084831,28.1664653 C199.033898,27.8432 198.982964,27.5243247 198.932827,27.2118349 C198.877914,26.8706104 198.824196,26.5365696 198.772466,26.2113088 C198.721135,25.8860481 198.6706,25.5691683 198.619269,25.2602703 C198.51581,24.6432726 198.414739,24.0578032 198.319637,23.5106467 C198.224535,22.9638893 198.138983,22.4538485 198.06696,21.9877079 C197.994539,21.5215673 197.93326,21.1005243 197.880735,20.734556 C197.82821,20.3681887 197.782848,20.0588916 197.74425,19.8154449 C197.693316,19.4905832 197.634027,19.1453678 197.567177,18.7821932 C197.500327,18.4190186 197.425519,18.0374857 197.345935,17.6407873 C197.26675,17.244488 197.182391,16.8330231 197.090075,16.4099846 C196.99736,15.9877442 196.895494,15.5539302 196.783281,15.1117351 C196.69375,14.7581388 196.597454,14.3989551 196.491608,14.0365787 C196.332839,13.492615 196.151787,12.9398712 195.94686,12.3831365 C195.741933,11.8256036 195.515519,11.2636807 195.277962,10.6989642 C195.044783,10.1334494 194.823144,9.56314558 194.616625,8.99324082 C194.412494,8.42253787 194.213535,7.85383039 194.011394,7.29310476 C193.808456,6.73198005 193.593979,6.18043356 193.363983,5.64165805 C193.129212,5.10407982 192.881708,4.57887347 192.613114,4.06963084 C192.392669,3.65257868 192.134421,3.27862857 191.844737,2.94418866 C191.627475,2.69315918 191.395489,2.464878 191.151169,2.25615238 C190.907246,2.04782585 190.650589,1.85985306 190.384383,1.69063764 C189.852369,1.35140862 189.285735,1.08641088 188.701594,0.880478912 C188.1847,0.696896145 187.656266,0.560406349 187.133006,0.457440363 C186.610541,0.354075283 186.096035,0.281839456 185.598241,0.233549206 C185.101641,0.185258957 184.614591,0.160914286 184.141866,0.153730612 C183.668744,0.146147846 183.208354,0.157322449 182.768656,0.177277098 C182.328958,0.196832653 181.909952,0.226365533 181.521187,0.255100227 C181.077112,0.28782585 180.672033,0.319354195 180.322662,0.332923356 C179.974087,0.346492517 179.578558,0.364052608 179.151196,0.384805442 C178.724231,0.409150113 178.267423,0.432696599 177.795096,0.454247619 C177.322371,0.475399546 176.834525,0.491762358 176.341904,0.502138776 C175.849283,0.5121161 175.350694,0.516107029 174.856083,0.512914286 C174.361075,0.509721542 173.868056,0.500542404 173.386975,0.48657415 C172.906689,0.472605896 172.435556,0.457440363 171.982727,0.445467574 C171.530296,0.433893878 171.095771,0.428306576 170.693875,0.42750839 C170.291979,0.427109297 169.926691,0.428705669 169.615123,0.429503855 C169.464312,0.429902948 169.116135,0.429503855 168.600435,0.428306576 C168.342983,0.42750839 168.045739,0.427109297 167.713081,0.428705669 C167.380821,0.430302041 167.013941,0.433494785 166.613637,0.435889342 C166.213731,0.4382839 165.780002,0.438682993 165.315633,0.436288435 C164.850866,0.433494785 164.354664,0.426710204 163.828619,0.413939229 C163.302573,0.401168254 162.740316,0.387998186 162.133891,0.383608163 C161.831077,0.381612698 161.515927,0.382410884 161.190033,0.385204535 C160.864935,0.386401814 160.531481,0.387599093 160.192854,0.387998186 C159.854625,0.387998186 159.510825,0.387998186 159.163444,0.386800907 C158.816062,0.386002721 158.464702,0.384805442 158.110158,0.384007256 C157.755614,0.38320907 157.398285,0.38320907 157.038171,0.383608163 C156.678454,0.384007256 156.315952,0.384406349 155.950266,0.382410884 C155.584979,0.38041542 155.216906,0.376025397 154.846844,0.367245351 C154.473996,0.360460771 154.095179,0.354075283 153.708006,0.350483447 C153.317252,0.348887075 152.917744,0.35088254 152.507889,0.35766712 C152.097637,0.363653515 151.678631,0.374429025 151.251269,0.387599093 C150.823906,0.400769161 150.390177,0.416333787 149.951673,0.432696599 C149.513169,0.449458503 149.071083,0.465821315 148.627804,0.480587755 C148.184525,0.495753288 147.741246,0.508524263 147.300354,0.517304308 C146.859064,0.526483447 146.422152,0.530075283 145.989616,0.530075283 C145.59926,0.528478912 145.212087,0.526483447 144.823323,0.524088889 C144.43615,0.521694331 144.050569,0.520497052 143.670956,0.515707937 C143.290946,0.511317914 142.916506,0.503336054 142.546841,0.492560544 C142.176381,0.481785034 141.809502,0.468614966 141.443816,0.454247619 C141.078529,0.439481179 140.713639,0.423916553 140.347954,0.407553741 C139.982666,0.391590023 139.614991,0.374828118 139.244133,0.358066213 C138.872877,0.341703401 138.497244,0.325739683 138.116039,0.310973243 C137.734437,0.297004989 137.346071,0.2850322 136.950541,0.27705034 C136.555012,0.268669388 136.151525,0.265476644 135.740875,0.267073016 C135.330623,0.268669388 134.9148,0.274655782 134.495794,0.284234014 C134.076389,0.293812245 133.655394,0.305785034 133.234398,0.319753288 C132.8138,0.333322449 132.394396,0.347689796 131.978971,0.362057143 C131.563546,0.37642449 131.153294,0.389594558 130.750204,0.400370068 C130.346716,0.411145578 129.952381,0.419925624 129.566004,0.425113832 C129.180423,0.429902948 128.80081,0.430302041 128.424381,0.42750839 C128.049544,0.425912018 127.676696,0.423916553 127.307031,0.421921088 C126.936571,0.419925624 126.568896,0.417930159 126.204404,0.415934694 C125.443189,0.413141043 124.695106,0.410347392 123.963735,0.409150113 C123.231966,0.407553741 122.516114,0.406755556 121.817771,0.406356463 C121.119427,0.40595737 120.437796,0.405558277 119.775264,0.405159184 C119.112733,0.404760091 118.468904,0.403163719 117.845369,0.400769161 C117.221833,0.398773696 116.619387,0.395580952 116.040419,0.391989116 C115.46145,0.388397279 114.906754,0.384406349 114.378321,0.380814512 C113.849489,0.377222676 113.348512,0.374029932 112.876185,0.371236281 C112.404256,0.36844263 111.961773,0.366447166 111.551521,0.364850794 C111.140871,0.363653515 110.76285,0.362855329 110.418254,0.362855329 C110.06371,0.364451701 109.744979,0.366048073 109.465641,0.369639909 C108.906966,0.376025397 108.503877,0.386002721 108.276269,0.395580952 C108.000114,0.407952834 107.537337,0.424315646 106.9142,0.445467574 C106.602233,0.456243084 106.250873,0.46781678 105.862108,0.479390476 C105.474139,0.491762358 105.048369,0.503735147 104.589571,0.515707937 C104.130375,0.527281633 103.636958,0.537258957 103.112902,0.542846259 C102.588846,0.548034467 102.032956,0.550029932 101.449212,0.546438095 C100.865866,0.542846259 100.253871,0.534465306 99.6176019,0.524088889 C98.9813331,0.512914286 98.3211894,0.499744218 97.6407519,0.485775964 C96.9599165,0.47180771 96.2591852,0.461431293 95.5433331,0.455045805 C95.1848102,0.451853061 94.822706,0.449458503 94.4570206,0.44905941 C94.0913352,0.448261224 93.7224665,0.449458503 93.3508123,0.452651247 C92.9783623,0.455843991 92.6031269,0.459435828 92.225106,0.463426757 C91.8466873,0.467417687 91.4654831,0.47180771 91.0822894,0.475798639 C90.3568873,0.483381406 89.6223331,0.489766893 88.8802185,0.49335873 C88.138104,0.496551474 87.388031,0.496551474 86.633979,0.49335873 C86.256754,0.492161451 85.8779373,0.489766893 85.4987227,0.48657415 C85.1195081,0.483780499 84.7398956,0.480188662 84.361079,0.477395011 C83.983456,0.476197732 83.606231,0.475399546 83.2305977,0.476197732 C82.8549644,0.476995918 82.479729,0.47859229 82.1056873,0.481385941 C81.7316456,0.483780499 81.3580019,0.486973243 80.9855519,0.490165986 C80.6131019,0.49335873 80.2406519,0.496152381 79.8689977,0.49734966 C79.4969456,0.498946032 79.1256894,0.498946032 78.7544331,0.498147846 C78.3835748,0.496950567 78.0131144,0.494556009 77.6430519,0.491363265 C77.2733873,0.487771429 76.9045185,0.483780499 76.5364456,0.478991383 C76.1683727,0.474601361 75.8014935,0.469413152 75.436604,0.464224943 C75.0721123,0.459435828 74.7092123,0.454247619 74.3494956,0.449857596 C73.989779,0.445068481 73.6324498,0.441875737 73.2787019,0.439082086 C72.9257498,0.435889342 72.575981,0.433893878 72.2313852,0.433095692 C71.8859935,0.431898413 71.5461727,0.432297506 71.2111269,0.433494785 C70.876081,0.434692063 70.5450144,0.435889342 70.2183248,0.436687528 C69.8916352,0.437086621 69.5689248,0.437485714 69.2509894,0.437086621 C68.6171081,0.435490249 68.0011331,0.433893878 67.4066456,0.432297506 C63.246029,0.419925624 60.1343206,0.40196644 59.0304998,0.378020862 C57.9963144,0.356070748 54.9526498,0.334120635 50.8123269,0.312968707 C50.2206248,0.31057415 49.6070373,0.308578685 48.9763394,0.312968707 C48.6607915,0.314964172 48.3416623,0.320551474 48.0189519,0.32813424 C47.6962415,0.336515193 47.3699498,0.346492517 47.0400769,0.358465306 C46.709806,0.370039002 46.375954,0.38320907 46.0377248,0.396379138 C45.7002915,0.409549206 45.358481,0.423118367 45.0126915,0.435889342 C44.6672998,0.448660317 44.317531,0.460234014 43.9637831,0.468614966 C43.6100352,0.477395011 43.2515123,0.483780499 42.8894081,0.48657415 C42.527304,0.489766893 42.1608227,0.488968707 41.7903623,0.484578685 C41.419504,0.480188662 41.0454623,0.472605896 40.6670435,0.460633107 C40.2890227,0.449458503 39.9078185,0.435490249 39.523829,0.419925624 C39.1398394,0.403961905 38.7534623,0.386800907 38.3650956,0.369240816 C37.9771269,0.351281633 37.5871685,0.334120635 37.1972102,0.318156916 C36.806456,0.30259229 36.4157019,0.289023129 36.0249477,0.277449433 C35.6345915,0.266673923 35.2442352,0.259889342 34.8550727,0.255898413 C34.4655123,0.25150839 34.0767477,0.249512925 33.6871873,0.246719274 C31.3506206,0.239934694 29.0049019,0.23275102 26.7212581,0.226365533 C26.3702956,0.22596644 26.0205269,0.225168254 25.6723498,0.224370068 C25.2740352,0.223571882 24.878506,0.223571882 24.4849665,0.223970975 C24.090631,0.227163719 23.6978873,0.231952834 23.3071331,0.237939229 C22.9167769,0.243925624 22.5288081,0.250710204 22.1444206,0.257494785 C21.7600331,0.263880272 21.3792269,0.269866667 21.0020019,0.27705034 C20.6247769,0.283435828 20.251531,0.293014059 19.8822644,0.30259229 C19.5129977,0.312170522 19.148506,0.321748753 18.7895852,0.329730612 C18.4306644,0.338510658 18.0769165,0.344896145 17.7295352,0.350084354 C17.381756,0.354873469 17.0395477,0.358066213 16.7045019,0.358864399 C16.3686602,0.360061678 16.0387873,0.358864399 15.715679,0.355671655 C15.0694623,0.348887075 14.4463248,0.340506122 13.8490519,0.330927891 C13.251779,0.317757823 12.6811665,0.302193197 12.1411935,0.283834921 C11.6012206,0.265476644 11.0902956,0.247118367 10.6116019,0.230755556 C10.1329081,0.214791837 9.68525188,0.202419955 9.27221438,0.194039002 C8.85917688,0.186456236 8.48075813,0.182864399 8.14014146,0.18166712 C7.79952479,0.180868934 7.49790396,0.180469841 7.23806438,0.179671655 C6.71838521,0.178873469 6.36622896,0.178474376 6.20706229,0.178474376 C5.02365813,0.178474376 4.09531854,0.641023129 3.45904979,1.10716372 C3.06113313,1.33225215 2.71932271,1.63995283 2.46664563,2.05939955 C2.24062896,2.43534512 2.08345188,2.86157642 1.97283104,3.29818413 C1.77347479,4.08160363 1.59162688,4.87340408 1.43285813,5.6783746 C1.35327479,6.08066032 1.27767063,6.48613878 1.20763729,6.89600726 C1.13800188,7.30627483 1.07314146,7.72053333 1.01544354,8.13878277 C0.938645625,8.69671474 0.874183125,9.26422494 0.815689375,9.83812063 C0.757195625,10.4116172 0.700691458,10.9907011 0.654533125,11.5753723 C0.607976875,12.1600435 0.575745625,12.7491048 0.556645625,13.3393633 C0.540728958,13.8246603 0.533168542,14.3063655 0.525608125,14.7864744 C0.518047708,15.2661841 0.507303958,15.746293 0.491785208,16.2260027 C0.477062292,16.7057125 0.462339375,17.1826286 0.448412292,17.6555537 C0.434485208,18.1284789 0.422149792,18.5978122 0.411008125,19.0615583 C0.402253958,19.4586558 0.396285208,19.8513633 0.391908125,20.240878 C0.388326875,20.6299937 0.385939375,21.0151184 0.383949792,21.3974494 C0.381960208,21.7797805 0.379572708,22.159717 0.377583125,22.537658 C0.375593542,22.9155991 0.373603958,23.2915447 0.370818542,23.6670912 C0.368033125,24.0422385 0.365645625,24.417785 0.363258125,24.7941297 C0.360870625,25.1704744 0.358483125,25.5480163 0.355697708,25.9279528 C0.352912292,26.3078893 0.348535208,26.6914177 0.341770625,27.078937 C0.335006042,27.4660571 0.325456042,27.8575673 0.313518542,28.2526694 C0.303172708,28.6513633 0.292428958,29.0552454 0.281287292,29.4627193 C0.271737292,29.8709914 0.263381042,30.2824562 0.256218542,30.6967147 C0.256218542,31.1149642 0.255422708,31.5340118 0.258606042,31.9530594 L0.258606042,31.8644608 C0.346943542,31.861268 0.434087292,31.8576762 0.523220625,31.8548825 C1.48578104,31.8185651 2.45908521,31.7870367 3.43437896,31.7638893 C4.03722271,31.749522 4.63847479,31.740742 5.23853313,31.7363519 C5.83859146,31.7315628 6.43745604,31.7303655 7.03632063,31.7319619 C7.63478729,31.7339574 8.23444771,31.7383474 8.83371021,31.7443338 C9.43297271,31.7503202 10.0302456,31.7563066 10.625131,31.7614948 C11.2200165,31.766683 11.8129123,31.7702748 12.4038185,31.7718712 C12.9947248,31.7734676 13.5852331,31.7730685 14.1757415,31.7722703 C14.7666477,31.771073 15.3599415,31.7702748 15.9556227,31.7706739 C16.551304,31.771073 17.1485769,31.7726694 17.7490331,31.7750639 C18.9041852,31.7806512 20.065704,31.8065923 21.2331915,31.8277442 C22.4010769,31.8484971 23.5733394,31.869649 24.7479894,31.8640617 C25.9552685,31.8580753 27.1617519,31.8261478 28.3674394,31.783844 C29.5703415,31.7571048 30.766081,31.7283701 31.9546581,31.7104109 C32.9160248,31.7000345 33.8757998,31.6988372 34.834381,31.7048236 C35.9127352,31.7116082 36.9898956,31.723581 38.0658623,31.7371501 C39.141431,31.7503202 40.2166019,31.7618939 41.290181,31.7682794 C42.3641581,31.7742658 43.4377373,31.7742658 44.5113165,31.7674812 C45.5848956,31.7602975 46.6592706,31.7503202 47.7336456,31.7399438 C48.8080206,31.7295673 49.8823956,31.7219846 50.954781,31.7128054 C52.0275644,31.7036263 53.098756,31.6920526 54.168754,31.6860662 C55.2387519,31.6792816 56.3087498,31.6836717 57.3795435,31.7048236 C58.4507352,31.7255764 59.5223248,31.7606966 60.5947102,31.801005 C61.5513019,31.8365243 62.5094852,31.8724426 63.4732394,31.8983837 C64.4369935,31.9235265 65.4063185,31.9339029 66.3816123,31.9319075 C67.356906,31.9295129 68.336179,31.9203338 69.3174415,31.908361 C70.2994998,31.8963882 71.281956,31.8844154 72.2640144,31.8756354 C73.2456748,31.8672544 74.2253456,31.8672544 75.2014352,31.8780299 C76.1783206,31.8848145 77.1524206,31.8856127 78.120154,31.8792272 C79.0882852,31.8724426 80.0504477,31.8636626 81.0078352,31.8556807 C81.9648248,31.8425107 82.918631,31.8369234 83.8708456,31.835327 C84.8226623,31.8337306 85.7732852,31.8345288 86.7239081,31.8377215 C87.674929,31.8401161 88.6263477,31.8465016 89.5785623,31.8560798 C90.7663435,31.8688508 91.952931,31.8712454 93.1407123,31.8548825 C93.7359956,31.8465016 94.3340644,31.8389188 94.9384998,31.830937 C95.5433331,31.8229551 96.1557269,31.8161705 96.7832415,31.8109823 C97.3832998,31.8057941 97.993704,31.7994086 98.609281,31.7938213 C99.225256,31.7886331 99.8468019,31.7818485 100.46795,31.7782567 C101.089098,31.7742658 101.704675,31.7698757 102.30911,31.7694766 C102.794171,31.7694766 103.279231,31.7718712 103.764291,31.7806512 C104.012591,31.7850413 104.279196,31.736751 104.524312,31.7618939 C104.760675,31.7862385 104.975152,31.7606966 105.2143,31.753912 C105.351979,31.7499211 105.490852,31.7674812 105.623358,31.8057941 C105.66116,31.8165696 105.70135,31.8305379 105.725623,31.8616671 C105.752681,31.8963882 105.754671,31.9430821 105.755864,31.9873814 C105.7682,32.5201705 105.780535,33.0529596 105.793269,33.5857488 C105.798839,33.8272 105.804808,34.0686512 105.792871,34.3097034 C105.782923,34.5216218 105.747508,34.7179755 105.774964,34.9278984 C105.805604,35.1597714 105.765414,35.4123973 105.752283,35.6454676 C105.73756,35.9056762 105.722439,36.1662839 105.72045,36.4272907 C105.716869,36.9796354 105.717664,37.5355719 105.720052,38.0923066 C105.722837,38.6658032 105.730796,39.2389007 105.743131,39.8183837 C105.756262,40.3974676 105.774566,40.9821388 105.794064,41.5700027 C105.813562,42.1586649 105.834652,42.7501206 105.851762,43.3427737 C105.869271,43.9354268 105.884789,44.5276807 105.893941,45.1191365 C105.903491,45.7381297 105.885585,46.3583202 105.859323,46.9892862 C105.833856,47.6206512 105.798441,48.2592 105.779739,48.9009415 C105.766608,49.3618939 105.776954,49.8208508 105.788494,50.2782113 C105.799635,50.7351728 105.811573,51.1893406 105.800829,51.6407147 C105.790085,52.0745288 105.760639,52.5753905 105.676281,53.0634812 C105.991431,53.0535039 106.306581,53.0439256 106.623721,53.0315537 C106.548116,52.556234 106.526231,52.0697397 106.526231,51.646302 C106.526231,51.1977215 106.552494,50.7459483 106.581939,50.289785 C106.610987,49.8340209 106.641627,49.3762612 106.649187,48.9157079 C106.659533,48.2735673 106.650779,47.6342204 106.642423,46.9992635 C106.634464,46.3639075 106.622925,45.7341388 106.634066,45.1023746 C106.638841,44.4957533 106.644014,43.8855401 106.636056,43.2749279 C106.628894,42.6643156 106.616558,42.0552998 106.600641,41.4514721 C106.584725,40.8480435 106.569206,40.2521977 106.553289,39.6667283 C106.537373,39.081259 106.52265,38.5077624 106.508325,37.9398531 C106.494398,37.3871093 106.486439,36.840751 106.480471,36.2991819 C106.477685,36.0441615 106.464952,35.7895401 106.453412,35.5353179 C106.443862,35.308234 106.408846,35.0619937 106.445454,34.8353088 C106.478083,34.6309732 106.448637,34.4394086 106.445852,34.2330776 C106.442271,33.9976127 106.456596,33.7617488 106.472114,33.5254857 C106.506335,33.0038712 106.542546,32.4810594 106.578756,31.955454 C106.581939,31.9123519 106.585919,31.8660571 106.614569,31.8321342 C106.640035,31.801005 106.681021,31.7870367 106.719221,31.7762612 C106.854114,31.7387465 106.994181,31.7215855 107.133054,31.7255764 C107.374987,31.7327601 107.591852,31.7587011 107.834183,31.7355537 C108.086462,31.7116082 108.358637,31.7606966 108.615691,31.7575039 C109.11826,31.7515175 109.622819,31.7519166 110.129366,31.7551093 C110.76086,31.758302 111.402302,31.7658848 112.045733,31.7718712 C112.689164,31.7774585 113.325433,31.7858395 113.95056,31.792624 C114.571708,31.7994086 115.183306,31.8057941 115.783364,31.8109823 C116.410879,31.8161705 117.023273,31.8229551 117.627708,31.830937 C118.232144,31.8389188 118.83061,31.8465016 119.425496,31.8548825 C120.613277,31.8712454 121.799864,31.8688508 122.987646,31.8560798 C123.940258,31.8465016 124.891279,31.8401161 125.8423,31.8377215 C126.792923,31.8345288 127.743546,31.8337306 128.69576,31.835327 C129.647577,31.8369234 130.601383,31.8425107 131.558373,31.8556807 C132.516158,31.8636626 133.478321,31.8724426 134.446054,31.8792272 C135.414185,31.8856127 136.387489,31.8848145 137.364773,31.8780299 C138.340464,31.8672544 139.320135,31.8672544 140.302194,31.8756354 C141.284252,31.8844154 142.266708,31.8963882 143.248369,31.908361 C144.230427,31.9203338 145.2097,31.9295129 146.184596,31.9319075 C147.159889,31.9339029 148.129612,31.9235265 149.093366,31.8983837 C150.056723,31.8724426 151.015304,31.8365243 151.971498,31.801005 C153.043883,31.7606966 154.115871,31.7255764 155.186664,31.7048236 C156.257856,31.6836717 157.327456,31.6792816 158.397852,31.6860662 C159.46785,31.6920526 160.538644,31.7036263 161.611427,31.7128054 C162.68421,31.7219846 163.758187,31.7295673 164.832562,31.7399438 C165.907335,31.7503202 166.981312,31.7602975 168.054891,31.7674812 C169.128471,31.7742658 170.202448,31.7742658 171.276027,31.7682794 C171.897573,31.7646875 172.519119,31.7591002 173.140266,31.7527147 C174.030008,31.7431365 174.919352,31.7303655 175.808696,31.7159982 C176.105144,31.7112091 176.401591,31.7060209 176.698437,31.7012317 C176.956685,31.6968417 177.230054,31.6828735 177.508596,31.6744925 C178.057323,31.6589279 178.529252,31.7363519 179.06246,31.7866376 C179.610391,31.8381206 180.184585,31.8476989 180.565789,32.3154358 C180.885714,32.7073451 180.903223,33.2572952 180.90561,33.7637442 C180.913569,35.3860571 180.862237,37.0255311 180.899641,38.6406603 C180.912773,39.1842249 180.924312,39.7277896 180.935454,40.2713542 C180.946198,40.8153179 180.954554,41.3592816 180.960125,41.9032454 C180.9649,42.4476082 180.966491,42.9915719 180.964104,43.5355356 C180.961716,44.0794993 180.95336,44.623463 180.94381,45.1674268 C180.932669,45.7109914 180.9267,46.2549551 180.929087,46.7981206 C180.931475,47.3412862 180.939831,47.8848508 180.948983,48.4272181 C180.958533,48.9699846 180.968083,49.5123519 180.97445,50.0543202 C180.980419,50.5962884 180.978031,51.1374585 180.964502,51.6778304 C180.952564,52.1838803 180.927894,52.6895311 180.895264,53.1939846 C181.431258,53.2007692 182.0154,53.2071546 182.638139,53.2119438 C183.346033,53.2175311 184.099687,53.2227193 184.879604,53.2267102 C186.244458,53.234293 187.689691,53.2382839 189.102296,53.2366875 C190.5149,53.2354902 191.896069,53.2299029 193.128416,53.2227193 C194.360366,53.2151365 195.442302,53.2067556 196.260021,53.19598 C197.077341,53.1852045 197.62965,53.1728327 197.803937,53.1580662 C198.139779,53.1301297 198.664233,52.4077714 199.245191,51.3832998 C199.438579,51.0412771 199.638333,50.6649324 199.841271,50.2634449 C200.51375,48.9137125 201.004779,47.5005243 201.605235,46.1184653 C201.816927,45.631971 202.229169,45.2320798 202.377194,44.7152544 C202.65096,43.7582295 201.999969,44.1493406 201.414235,43.8699755",id:"Fill-34",fill:"#D6DE23",mask:"url(#mask-4)",__source:{fileName:_jsxFileName,lineNumber:45}})),_react2.default.createElement("path",{d:"M50.2499867,58.1745488 C50.1596596,58.1781406 50.07172,58.1817324 49.98577,58.1849252 C50.0721179,58.1817324 50.1596596,58.1781406 50.2499867,58.1745488",id:"Fill-37",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:47}}),_react2.default.createElement("path",{d:"M52.0425615,58.1172789 C52.1842198,58.113288 52.3294594,58.1096961 52.4758927,58.1061043 C52.3294594,58.1096961 52.1842198,58.113288 52.0425615,58.1172789",id:"Fill-39",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:48}}),_react2.default.createElement("path",{d:"M52.0425615,58.1172789 C51.901301,58.1212698 51.762826,58.1252608 51.6259427,58.1288526 C51.762826,58.1252608 51.901301,58.1212698 52.0425615,58.1172789",id:"Fill-41",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:49}}),_react2.default.createElement("path",{d:"M53.536659,58.0806422 C53.3830631,58.084234 53.2318548,58.0878259 53.0814423,58.0910186 C53.2318548,58.0878259 53.3830631,58.084234 53.536659,58.0806422",id:"Fill-43",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:50}}),_react2.default.createElement("path",{d:"M51.5027875,58.1324444 C51.4009208,58.1356372 51.3006458,58.1388299 51.2015646,58.1416236 C51.3006458,58.1388299 51.4009208,58.1356372 51.5027875,58.1324444",id:"Fill-45",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:51}}),_react2.default.createElement("path",{d:"M53.536659,58.0806422 C53.6946319,58.0770503 53.8545944,58.0738576 54.0157506,58.0706649 C53.8549923,58.0738576 53.6946319,58.0770503 53.536659,58.0806422",id:"Fill-47",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:52}}),_react2.default.createElement("path",{d:"M144.809988,9.18357188 C144.809988,9.18357188 143.821563,9.08499592 143.790924,9.62616599 C143.775803,9.89675102 143.78774,10.8705379 143.811217,11.849912 C143.834694,12.8288871 143.868119,13.8122522 143.87568,14.0999982 C143.883638,14.3877442 143.927409,15.32681 143.968394,16.245522 C144.003013,17.1662295 144.024899,18.0673814 144.024103,18.2860844 C144.023307,18.5043882 144.014951,19.662556 143.983515,20.7592635 C143.95208,21.855971 143.914278,22.8928145 143.914278,22.8928145 C143.914278,22.8928145 143.683088,25.4685605 144.187249,25.5623474 C144.354771,25.5934766 145.671876,25.5898848 147.430269,25.5615492 C148.309267,25.547581 149.302069,25.526429 150.304421,25.504878 C151.306376,25.483327 152.311911,25.4633723 153.215978,25.4510005 C154.120044,25.4382295 154.930203,25.4294494 155.558115,25.4238621 C156.186028,25.4182748 156.63448,25.4154812 156.818317,25.4154812 C157.093676,25.414683 157.743076,25.4039075 158.579496,25.3947283 C159.205817,25.3883429 159.938382,25.3823565 160.699199,25.3827556 C162.981251,25.3831546 165.517969,25.4370322 166.207957,25.6800798 C167.434734,26.1122975 169.026401,26.3784925 172.176707,29.9703293 C173.797024,31.8173315 175.52438,33.5968871 177.420453,35.1605333 C178.738751,36.2468644 180.226163,37.0294857 181.931634,37.2729324 C182.574667,37.3643247 183.245953,37.4098213 183.894557,37.417005 C187.853828,37.4613043 191.814292,37.3926603 195.769186,37.2094766 C196.231167,37.1879256 196.692353,37.1651773 197.153936,37.1396354 C197.377167,37.1276626 197.611938,37.1112998 197.802142,36.9923701 C198.313465,36.6734948 198.059196,35.7851138 198.011446,35.3129868 C197.953351,34.7354993 197.886501,34.0734041 197.815274,33.3781841 C197.743649,32.6829642 197.661678,31.9534222 197.56578,31.2418395 C197.47028,30.5298576 197.359261,29.8374313 197.251028,29.2192363 C197.143192,28.6010413 197.044509,28.0578757 196.968905,27.64242 C196.906034,27.2960073 196.814911,26.8550095 196.702699,26.3449687 C196.64699,26.0895492 196.588099,25.8165696 196.527217,25.5284245 C196.46554,25.2402794 196.402271,24.9377669 196.338207,24.6236807 C196.274142,24.3091955 196.208884,23.9839347 196.141636,23.6510912 C196.07399,23.3178485 196.003559,22.9774222 195.929546,22.6322068 C195.840015,22.2183474 195.742924,21.7989007 195.637476,21.3798531 C195.532426,20.9604063 195.419815,20.5413587 195.302828,20.1278984 C195.18584,19.714039 195.065669,19.3049687 194.945101,18.9062748 C194.824532,18.507581 194.705157,18.1188644 194.588169,17.743717 C194.470784,17.3689687 194.358174,17.0081887 194.251134,16.6669642 C194.144094,16.3257397 194.042626,16.0040707 193.941157,15.708742 C193.840086,15.412615 193.739811,15.1432272 193.643117,14.9045696 C193.49748,14.5469823 193.347465,14.1885968 193.191084,13.8346014 C193.034305,13.4814041 192.871557,13.1321977 192.70483,12.7937669 C192.537705,12.4557351 192.370978,12.128878 192.201863,11.8191819 C192.032351,11.5090866 191.859257,11.2165515 191.680194,10.9455673 C191.501132,10.6749823 191.313315,10.4259483 191.112765,10.2040526 C190.912215,9.98215692 190.698136,9.78739955 190.467344,9.62456961 C190.236553,9.46253787 189.989049,9.33243356 189.721649,9.24064218 C189.454249,9.14805261 189.167749,9.09377596 188.859363,9.08339955 C188.551376,9.07302313 188.21434,9.0634449 187.857807,9.05586213 C187.500876,9.04788027 187.125242,9.04149478 186.740457,9.03590748 C186.355671,9.03071927 185.964917,9.02672834 185.576153,9.02513197 C185.187786,9.02273741 184.801807,9.02193923 184.421001,9.02233832 C184.041786,9.02313651 183.664163,9.02473288 183.294499,9.02553107 C182.185903,9.02872381 181.150524,9.03032018 180.367026,9.0179483 C178.90508,8.99440181 167.352365,9.18317279 160.404342,9.26418866 C159.411938,9.27576236 158.513442,9.28534059 157.751432,9.29172608 C156.225421,9.30569433 155.235803,9.3072907 155.147465,9.28733605 C155.03764,9.26259229 154.348846,9.24383492 153.367186,9.22747211 C152.385526,9.21150839 151.105428,9.19754014 149.829707,9.19115465 C148.553986,9.18437007 147.29259,9.1823746 146.357884,9.1823746 C145.422382,9.1823746 144.809988,9.18357188 144.809988,9.18357188",id:"Fill-49",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:53}}),_react2.default.createElement("path",{d:"M96.2513021,11.0032363 C96.2513021,11.0032363 96.2174792,10.6221025 96.2361812,10.2397714 C96.2548833,9.85744036 96.3344667,9.47431111 96.6209667,9.47311383 C96.8115687,9.47231565 97.0654396,9.469522 97.3845687,9.46513197 C97.5449292,9.4635356 97.7224,9.46114104 97.9161854,9.45834739 C98.1095729,9.45595283 98.3180812,9.45315918 98.5417104,9.45116372 C98.9889687,9.4467737 99.4955167,9.44318186 100.063344,9.44318186 C100.435396,9.44318186 101.343044,9.43719546 102.557485,9.42841542 C102.860698,9.42602086 103.183806,9.4236263 103.522035,9.42083265 C103.691548,9.41963537 103.865437,9.41883719 104.041715,9.4184381 C104.217992,9.418039 104.39785,9.418039 104.580096,9.41883719 C104.76274,9.41923628 104.947373,9.42043356 105.13519,9.42163084 C105.323006,9.42322721 105.512812,9.42442449 105.705006,9.42602086 C105.8972,9.42761723 106.091383,9.42921361 106.287556,9.43001179 C106.483331,9.43120907 106.6803,9.43200726 106.877269,9.43280544 C107.074635,9.43360363 107.2724,9.43400272 107.470165,9.43400272 C107.667929,9.43400272 107.86649,9.43360363 108.06505,9.43240635 C108.264008,9.43160816 108.463365,9.4296127 108.662721,9.42721814 C108.862077,9.42482358 109.062229,9.42163084 109.261983,9.4184381 C109.442637,9.41564444 109.624087,9.4124517 109.804742,9.40925896 C109.984998,9.40606621 110.163662,9.40287347 110.340735,9.40047891 C110.695677,9.3956898 111.043854,9.39249705 111.385267,9.39129977 C111.726679,9.39010249 112.060133,9.39090068 112.385231,9.39129977 C112.568273,9.39129977 112.748529,9.39090068 112.926398,9.39050159 C113.282533,9.38890522 113.628323,9.38930431 113.960583,9.39489161 C114.292844,9.40047891 114.609983,9.40885986 114.908819,9.41724082 C115.207256,9.42602086 115.4854,9.43400272 115.736883,9.44118639 C115.988765,9.44837007 116.212792,9.45315918 116.404985,9.45754921 C116.597975,9.46154014 116.758335,9.46433379 116.883679,9.46553107 C117.024144,9.46792562 117.206787,9.469522 117.42405,9.46992109 C117.641312,9.47071927 117.891602,9.46872381 118.16895,9.46393469 C118.4459,9.45914558 118.752694,9.44916825 119.083362,9.4352 C119.414031,9.42123175 119.768973,9.40367166 120.143412,9.38531338 C120.330831,9.37613424 120.522627,9.3673542 120.719198,9.35977143 C120.915769,9.35139048 121.116717,9.34500499 121.322042,9.33981678 C121.526969,9.33502766 121.735477,9.33223401 121.947567,9.33183492 C122.159656,9.33183492 122.374929,9.33223401 122.594181,9.3330322 C122.813831,9.33462857 123.03746,9.33742222 123.265467,9.34141315 C123.481933,9.34500499 123.70039,9.34899592 123.920437,9.35378503 C124.140485,9.35897324 124.362921,9.36535873 124.587346,9.3729415 C124.810975,9.38092336 125.036196,9.38930431 125.260223,9.39848345 C125.484648,9.4068644 125.707083,9.41524535 125.927131,9.42242902 C126.147577,9.43001179 126.364044,9.43559909 126.576531,9.44038821 C126.789417,9.44477823 126.997925,9.44717279 127.20126,9.44837007 C127.405392,9.44876916 127.60435,9.44797098 127.798931,9.44557642 C127.993115,9.44318186 128.183319,9.43919093 128.368748,9.43400272 C128.554575,9.4296127 128.736821,9.4236263 128.917077,9.41604354 C129.096935,9.40885986 129.274804,9.400878 129.451081,9.39249705 C129.802442,9.37533605 130.143456,9.36017052 130.466565,9.34739955 C130.790469,9.33422948 131.093283,9.32465125 131.372223,9.31826576 C131.790831,9.30908662 132.148956,9.30150385 132.42511,9.29711383 C132.70206,9.29192562 132.89704,9.28993016 132.996917,9.29072834 C133.108731,9.29152653 133.283815,9.28873288 133.507842,9.28394376 C133.731471,9.27995283 134.002452,9.27436553 134.30646,9.26957642 C134.610867,9.26438821 134.95029,9.2592 135.312394,9.25480998 C135.493446,9.25241542 135.680069,9.25041995 135.870671,9.24882358 C136.061671,9.24722721 136.256252,9.24563084 136.454017,9.24403447 C136.651781,9.2424381 136.852729,9.24044263 137.055667,9.23804807 C137.258206,9.23565351 137.461144,9.23365805 137.66249,9.23246077 C137.998331,9.23006621 138.330194,9.22926803 138.650119,9.22926803 C138.969646,9.22926803 139.278429,9.22966712 139.569704,9.22926803 C139.715342,9.22926803 139.857,9.22886893 139.993883,9.22846984 C140.130369,9.22807075 140.264865,9.22727256 140.396575,9.22607528 C140.594737,9.22407982 140.78335,9.22248345 140.956046,9.22088707 C141.128344,9.2192907 141.283531,9.21809342 141.416037,9.21769433 C141.68105,9.21649705 141.856133,9.21889161 141.916219,9.22687347 C142.155765,9.25640635 142.302596,9.22447891 142.41441,9.25560816 C142.525827,9.28673741 142.602625,9.38132245 142.690962,9.66587574 C142.720408,9.76125896 142.739906,9.90493243 142.75264,10.0801342 C142.765771,10.254937 142.77174,10.4604698 142.772933,10.6807692 C142.772933,10.7901206 142.771342,10.9030639 142.769352,11.0176036 C142.766965,11.1321433 142.764577,11.2478803 142.762587,11.3636172 C142.760598,11.5372227 142.758608,11.710429 142.756619,11.8796444 C142.755823,12.0069551 142.754629,12.1314721 142.753833,12.2519982 C142.753037,12.3725243 142.752242,12.4886603 142.75264,12.5976127 C142.753435,12.8163156 142.755823,13.0058848 142.757415,13.1435719 C142.759404,13.281259 142.762587,13.4808054 142.762985,13.7198621 C142.763383,13.8387918 142.76219,13.9684971 142.760598,14.1041887 C142.758608,14.2398803 142.755425,14.3831546 142.75065,14.53042 C142.746273,14.6776853 142.740702,14.8297397 142.735131,14.9825923 C142.729958,15.1354449 142.725183,15.2886966 142.722,15.4399528 C142.718817,15.5912091 142.718419,15.7396717 142.72001,15.8821478 C142.722,16.024624 142.725581,16.1615129 142.728367,16.29042 C142.731948,16.462429 142.733937,16.6204698 142.734335,16.7573587 C142.736325,16.8946467 142.737519,17.0111819 142.737519,17.0993814 C142.737121,17.2171138 142.739508,17.3827374 142.744681,17.5794902 C142.747467,17.6780662 142.75065,17.7838259 142.754629,17.8955719 C142.75821,18.0073179 142.76219,18.1246512 142.764975,18.2451773 C142.76776,18.3657034 142.770546,18.4902204 142.772933,18.6151365 C142.775321,18.7404517 142.776912,18.8665651 142.777708,18.9918803 C142.778504,19.1167964 142.778106,19.2409143 142.776515,19.3618395 C142.775321,19.4827646 142.772933,19.6008961 142.770546,19.7142385 C142.768158,19.827581 142.765771,19.9365333 142.764179,20.0387011 C142.76219,20.1404698 142.760996,20.235454 142.760996,20.3224562 C142.760996,20.4952635 142.766169,20.6333497 142.7793,20.7195537 C142.7984,20.8488599 142.811929,21.0112907 142.820285,21.1988644 C142.824662,21.2926512 142.82705,21.3928236 142.828244,21.4985832 C142.829437,21.6039438 142.830233,21.7156898 142.830233,21.8318259 C142.830233,21.9479619 142.82904,22.0692862 142.82705,22.1934041 C142.82506,22.3179211 142.822275,22.4456308 142.818694,22.5757351 C142.814317,22.7058395 142.80994,22.8383383 142.805562,22.9712363 C142.801185,23.1045333 142.796808,23.2382295 142.792829,23.3711274 C142.790442,23.5020299 142.790442,23.630937 142.791635,23.7550549 C142.791635,23.8795719 142.792033,23.9996989 142.792829,24.1146376 C142.793227,24.1972499 142.7984,24.3117896 142.799196,24.4398984 C142.80039,24.5676082 142.799196,24.7088871 142.789248,24.8437805 C142.780096,24.9782748 142.763383,25.1055855 142.729162,25.2093497 C142.694942,25.3131138 142.641621,25.3949279 142.555273,25.4376308 C142.47171,25.4791365 142.36666,25.477141 142.26161,25.4755447 C142.152979,25.4735492 142.039971,25.4719528 141.922585,25.4715537 C141.8052,25.4707556 141.686223,25.4711546 141.565654,25.4719528 C141.445085,25.472751 141.323323,25.4743474 141.20156,25.4759438 C141.0794,25.477141 140.956842,25.4787374 140.834283,25.4795356 C140.711725,25.481132 140.589962,25.4815311 140.468996,25.481132 C140.348029,25.4803338 140.228256,25.4795356 140.108085,25.4791365 C139.86854,25.4779392 139.630983,25.4763429 139.395815,25.4739483 C139.161044,25.4715537 138.929058,25.4675628 138.69946,25.4643701 C138.470658,25.4607782 138.242254,25.45998 138.015442,25.4635719 C137.871396,25.4659664 137.707056,25.468361 137.525208,25.4711546 C137.34336,25.4739483 137.144402,25.477141 136.928333,25.4791365 C136.640242,25.4831274 136.318725,25.4851229 135.968558,25.4875175 C135.792679,25.4883156 135.607648,25.4891138 135.415852,25.4895129 C135.22326,25.4895129 135.0247,25.4891138 134.820967,25.4875175 C134.617233,25.4863202 134.409123,25.4839256 134.198227,25.4807329 C133.988127,25.4775401 133.776833,25.4731501 133.566335,25.4671637 C133.356633,25.4615764 133.148125,25.45559 132.9428,25.4492045 C132.737475,25.4432181 132.536129,25.4368327 132.337171,25.4308463 C132.139008,25.425259 131.941642,25.4196717 131.743479,25.4164789 C131.545317,25.4128871 131.345165,25.4120889 131.143421,25.4120889 C130.941677,25.4128871 130.738342,25.4156807 130.534608,25.4200707 C130.331273,25.4240617 130.127937,25.429649 129.925,25.4368327 C129.72246,25.4436172 129.521512,25.4512 129.32335,25.459581 C129.125187,25.4675628 128.92981,25.476742 128.73881,25.4851229 C128.537465,25.494302 128.342087,25.5022839 128.153873,25.5094676 C127.784208,25.5194449 127.447969,25.5230367 127.153112,25.5206422 C126.858654,25.5170503 126.595631,25.5130594 126.366033,25.5098667 C125.906042,25.5030821 125.572587,25.5014857 125.41939,25.507073 C125.301606,25.511463 125.060867,25.5130594 124.717067,25.5150549 C124.545167,25.5162522 124.344219,25.5182476 124.11661,25.5210413 C123.889002,25.5238349 123.63354,25.5282249 123.353804,25.5338122 C123.074069,25.5397986 122.769662,25.5465832 122.446952,25.5549642 C122.123844,25.562946 121.786012,25.571327 121.441417,25.5789098 C121.096821,25.5868916 120.751827,25.5920798 120.408425,25.5948735 C120.065819,25.5968689 119.717642,25.5988644 119.365087,25.6000617 C119.163742,25.6008599 118.961202,25.601658 118.757867,25.6024562 C118.554531,25.6032544 118.3504,25.6040526 118.146269,25.6044517 C117.944127,25.605649 117.742383,25.6076444 117.541833,25.6096399 C117.341681,25.6116354 117.142723,25.614429 116.945754,25.6176218 C116.748785,25.6212136 116.55301,25.6256036 116.360021,25.6295946 C116.166633,25.6343837 115.975235,25.639971 115.786623,25.6451592 C115.597612,25.6511456 115.410592,25.6567329 115.226754,25.661522 C115.042121,25.6671093 114.860273,25.6718984 114.680812,25.6766875 C114.323085,25.6854676 113.977694,25.6918531 113.64981,25.6942476 C113.321529,25.6962431 113.011154,25.6938485 112.726246,25.6894585 C112.441735,25.683073 112.185079,25.6746921 111.961848,25.6635175 C111.515385,25.6419664 111.196654,25.6236082 111.04266,25.6164245 C110.916123,25.6108372 110.686525,25.5960707 110.377344,25.5765152 C110.222554,25.5661388 110.048267,25.5561615 109.856073,25.5465832 C109.664675,25.5374041 109.455769,25.5294222 109.23015,25.5238349 C109.004531,25.5174494 108.761802,25.5138576 108.50435,25.5126603 C108.2465,25.5118621 107.973529,25.5142567 107.687825,25.519844 C107.516721,25.5230367 107.340444,25.5278259 107.160983,25.532615 C106.981921,25.5378032 106.798879,25.5437896 106.613052,25.549776 C106.427225,25.5561615 106.239408,25.5621478 106.050796,25.566937 C105.862183,25.5717261 105.673571,25.5753179 105.48456,25.5769143 C105.29555,25.5785107 105.107733,25.5785107 104.920315,25.5761161 C104.733294,25.5733224 104.547865,25.5685333 104.362435,25.562946 C104.164273,25.5593542 103.96611,25.554166 103.768346,25.5505741 C103.570581,25.5469823 103.372817,25.5449868 103.176246,25.5441887 C102.979675,25.5433905 102.783502,25.5441887 102.589319,25.545785 C102.394737,25.5473814 102.201748,25.5505741 102.011146,25.5545651 C101.820544,25.5581569 101.631931,25.5621478 101.447298,25.5673361 C101.110262,25.5761161 100.783573,25.5832998 100.467627,25.5844971 C100.122633,25.5852952 99.7927604,25.5797079 99.4887521,25.5709279 C99.1576854,25.5589551 98.8616354,25.549776 98.6129375,25.5461841 C98.1159396,25.5390005 97.7793021,25.5421932 97.6463979,25.5469823 C97.3503479,25.5577578 97.1155771,25.5605515 96.9289542,25.5537669 C96.7423312,25.5465832 96.6030604,25.528624 96.4992042,25.4986921 C96.2918896,25.4388281 96.2254375,25.3286785 96.2242437,25.1686422 C96.2238458,25.1415039 96.2298146,25.0297578 96.2405583,24.8445787 C96.2505062,24.6593995 96.2632396,24.3979937 96.2743812,24.0719347 C96.2815437,23.854429 96.285125,23.6057941 96.2835333,23.33042 C96.2819417,23.0546467 96.2759729,22.750937 96.2708,22.4280707 C96.2656271,22.1048054 96.2656271,21.7691683 96.2672187,21.4251501 C96.2680146,21.2391728 96.2672187,21.0496036 96.2656271,20.8568417 C96.2636375,20.6640798 96.2604542,20.4685243 96.2568729,20.2701751 C96.2528937,20.072624 96.2497104,19.8730776 96.2473229,19.673132 C96.2449354,19.4731864 96.2433437,19.2728417 96.2429458,19.072098 C96.2425479,18.8717533 96.2429458,18.6714086 96.2437417,18.471463 C96.2445375,18.2938667 96.2437417,18.1154721 96.2437417,17.9382748 C96.2437417,17.7606785 96.2449354,17.5830821 96.2473229,17.4062839 C96.2497104,17.2294857 96.2528937,17.0526875 96.2568729,16.8762884 C96.2600562,16.6998893 96.2644333,16.5242884 96.2684125,16.3486875 C96.2767687,15.9970866 96.285125,15.6486785 96.2867167,15.307454 C96.2879104,15.1126966 96.2847271,14.9203338 96.2795542,14.7315628 C96.2723917,14.5423927 96.2644333,14.3564154 96.2568729,14.1752272 C96.2489146,13.9944381 96.24215,13.818039 96.2357833,13.646429 C96.2270292,13.3044063 96.2246417,12.9855311 96.2270292,12.6957896 C96.2298146,12.4068463 96.2341917,12.1458395 96.2377729,11.9187556 C96.2445375,11.4645878 96.2497104,11.1445152 96.2513021,11.0032363",id:"Fill-51",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:54}}),_react2.default.createElement("path",{d:"M51.4588973,9.32153832 C51.4588973,9.32153832 49.8588744,9.19901678 49.9786473,9.72941134 C50.0793202,10.1744 49.9388556,12.4639964 49.8588744,14.3417288 C49.7788931,16.2190621 49.8588744,17.5656018 49.8190827,18.62679 C49.8091348,18.8921868 49.8091348,19.1523955 49.8139098,19.4094113 C49.8190827,19.6664272 49.8286327,19.9202503 49.8389785,20.1724771 C49.8489265,20.425502 49.8580785,20.6793252 49.860466,20.9379374 C49.8632515,21.1969488 49.8596702,21.459951 49.8453452,21.7285406 C49.8357952,21.9073342 49.8210723,22.1172571 49.803166,22.343942 C49.7856577,22.5710259 49.765364,22.8148717 49.7446723,23.0607129 C49.7247765,23.3065542 49.7044827,23.5543909 49.6869744,23.7898558 C49.669466,24.0253206 49.655141,24.2480145 49.6451931,24.4455655 C49.6260931,24.8410667 49.6237056,25.1439782 49.650764,25.2637061 C49.6925452,25.4436971 49.7820765,25.5159329 49.980239,25.5414748 C50.1787994,25.5666177 50.4867869,25.5418739 50.9674702,25.5195247 C51.0872431,25.5135383 51.2464098,25.5051574 51.4342265,25.4955791 C51.622839,25.4860009 51.8408973,25.4760236 52.0804431,25.4656472 C52.3191931,25.456468 52.5802265,25.4488853 52.8539931,25.4456925 C53.1277598,25.4424998 53.4142598,25.4428989 53.7039431,25.4464907 C53.9932285,25.4508807 54.2849015,25.4580644 54.568616,25.4680417 C54.8531265,25.478019 55.1308723,25.4887946 55.3942931,25.4955791 C55.657714,25.5023637 55.9068098,25.5067537 56.1340202,25.5095474 C56.3608327,25.511942 56.5657598,25.5151347 56.7396494,25.520722 C56.9218952,25.5263093 57.2601244,25.5219193 57.715739,25.5111438 C57.9433473,25.5063546 58.2019931,25.5023637 58.4857077,25.5015655 C58.7698202,25.5007673 59.0778077,25.5055565 59.4037015,25.5147356 C59.7291973,25.5243138 60.0722015,25.5342912 60.4271431,25.5430712 C60.6487827,25.5486585 60.8744015,25.5530485 61.1028056,25.5566404 C61.3316077,25.5598331 61.5627973,25.5618286 61.7951806,25.5626268 C62.027564,25.563824 62.261141,25.5634249 62.495514,25.5626268 C62.7298869,25.5614295 62.9650556,25.5598331 63.1994285,25.5578376 C63.4338015,25.5554431 63.6681744,25.5530485 63.9009556,25.550654 C64.1341348,25.5486585 64.3657223,25.546663 64.5957181,25.5450667 C64.825714,25.5438694 65.0537202,25.5434703 65.278941,25.5434703 C65.5041619,25.5438694 65.7258015,25.5438694 65.9418702,25.5438694 C66.2880577,25.5438694 66.6203181,25.5430712 66.9326827,25.5438694 C67.2450473,25.5446676 67.5371181,25.5494567 67.804916,25.555044 C68.0969869,25.5610304 68.3604077,25.5670168 68.588016,25.5710077 C69.0452223,25.5805859 69.3647494,25.5861732 69.4865119,25.5773932 C69.5923577,25.5698104 69.9039265,25.5761959 70.3746619,25.5913615 C70.6102285,25.5985451 70.8859848,25.6053297 71.1947681,25.6085224 C71.5035515,25.6113161 71.8441681,25.6089215 72.2090577,25.5989442 C72.3917015,25.593756 72.579916,25.5861732 72.7729056,25.5761959 C72.9658952,25.5662186 73.1632619,25.5554431 73.3638119,25.5442685 C73.5643619,25.5330939 73.7680952,25.5227175 73.9750119,25.5131392 C74.1815306,25.5039601 74.3908348,25.49518 74.6029244,25.4864 C74.7728348,25.4792163 74.9443369,25.4720327 75.1190223,25.464849 C75.2929119,25.4580644 75.4695869,25.4512798 75.6486494,25.4460916 C75.827314,25.4413025 76.0095598,25.4397061 76.194591,25.4417016 C76.3796223,25.4436971 76.567439,25.4496834 76.7560515,25.4572662 C76.9454598,25.4644499 77.135266,25.4720327 77.326266,25.4796154 C77.5391515,25.4887946 77.7520369,25.4967764 77.9657181,25.5043592 C78.1793994,25.5115429 78.3946723,25.5183274 78.610741,25.5247129 C78.8268098,25.5306993 79.0436744,25.5362866 79.260141,25.5398785 C79.4766077,25.5434703 79.6926765,25.5458649 79.9067556,25.546663 C80.1208348,25.5474612 80.3329244,25.5470621 80.5426265,25.5446676 C80.7523285,25.542273 80.9592452,25.5374839 81.1625806,25.5306993 C81.366314,25.5243138 81.566466,25.5159329 81.7614452,25.5067537 C81.9572202,25.4971755 82.1482202,25.4871982 82.3340473,25.4768218 C82.5194765,25.4668444 82.7001306,25.4568671 82.875214,25.447688 C83.0506952,25.4385088 83.2206056,25.4301279 83.3849452,25.4241415 C83.7140223,25.4117696 84.0228056,25.4057832 84.3089077,25.4009941 C84.5946119,25.396205 84.8584306,25.3930122 85.0959869,25.3910168 C85.333941,25.3894204 85.5464285,25.3894204 85.7290723,25.391815 C85.911716,25.3938104 86.064914,25.3978014 86.183891,25.4041868 C86.4238348,25.4157605 86.7127223,25.4273342 87.0350348,25.4373116 C87.3577452,25.4472889 87.7134827,25.4556698 88.0903098,25.4624544 C88.3413952,25.4672435 88.6020306,25.4716336 88.867839,25.4764227 C89.1336473,25.4812118 89.4050265,25.4883955 89.6779973,25.4975746 C89.9509681,25.5067537 90.2259285,25.5167311 90.4988994,25.5275066 C90.7718702,25.5386812 91.0428515,25.5494567 91.307864,25.559434 C91.5728765,25.5690122 91.8323181,25.5773932 92.0822098,25.5837787 C92.415266,25.5925587 92.7312119,25.5969488 93.0204973,25.5989442 C93.3101806,25.6009397 93.5720098,25.602137 93.7976285,25.6045315 C94.248866,25.6085224 94.5612306,25.615307 94.6698619,25.6244862 C94.9408431,25.6464363 95.0665848,25.6272798 95.1187119,25.5099465 C95.1712369,25.3934113 95.1509431,25.1767039 95.132241,24.8015565 C95.1282619,24.7157515 95.1242827,24.4695111 95.123089,24.0971574 C95.1222931,23.9115791 95.122691,23.6936744 95.1234869,23.4494295 C95.1242827,23.2059828 95.1258744,22.9369941 95.127466,22.648849 C95.1290577,22.3607039 95.1290577,22.0538014 95.127466,21.7329306 C95.1254765,21.4116608 95.1218952,21.0756245 95.117916,20.7292118 C95.1159265,20.5556063 95.113539,20.3792073 95.1111515,20.2008127 C95.1047848,19.6640327 95.0980202,19.1057016 95.0908577,18.5401868 C95.0888681,18.3514159 95.0864806,18.1618467 95.0832973,17.9722776 C95.0805119,17.7827084 95.0769306,17.5931392 95.0725535,17.4035701 C95.0689723,17.2136018 95.0641973,17.0248308 95.0586265,16.836459 C95.0534535,16.6480871 95.0478827,16.4609125 95.041516,16.2749351 C95.0355473,16.0885587 95.0299765,15.9041778 95.0244056,15.7213932 C95.0192327,15.5390077 95.0144577,15.3582186 95.0100806,15.1802231 C95.0021223,14.8242322 94.9957556,14.4782186 94.9929702,14.1469714 C94.9897869,13.7853932 94.9901848,13.4413751 94.9917765,13.1205043 C94.993766,12.7992345 94.9973473,12.5003138 95.0025202,12.2289306 C95.0061015,11.9575474 95.0068973,11.7148989 94.9997348,11.5057741 C94.9854098,11.0871256 94.9671056,10.8089578 94.9575556,10.7203592 C94.9213452,10.3651664 94.9929702,10.00718 94.9754619,9.74258141 C94.9583515,9.47798277 94.8548931,9.30637279 94.459364,9.3227356 C94.402064,9.32513016 94.2385202,9.32991927 93.9782827,9.33590567 C93.848164,9.33909841 93.6909869,9.34149297 93.5067515,9.34308934 C93.322516,9.34508481 93.112814,9.34628209 92.8812265,9.34708027 C92.649241,9.34787846 92.3981556,9.34708027 92.1299598,9.34628209 C91.861764,9.34508481 91.5756619,9.3454839 91.2728473,9.34668118 C90.9700327,9.34867664 90.6505056,9.35186939 90.3170515,9.35506213 C90.1499265,9.3570576 89.980016,9.35865397 89.8057285,9.36025034 C89.631839,9.36184671 89.4543681,9.36304399 89.273714,9.36344308 C89.0930598,9.36464036 88.9092223,9.36503946 88.7222015,9.36503946 C88.5355785,9.36464036 88.3457723,9.36384218 88.1531806,9.3626449 C87.960589,9.36104853 87.7652119,9.35865397 87.5674473,9.35586032 C87.3692848,9.35266757 87.1691327,9.34907574 86.9661952,9.3454839 C86.7636556,9.34149297 86.5579327,9.33710295 86.3502202,9.33311202 C86.1425077,9.32952018 85.9324077,9.32552925 85.720716,9.32193741 C85.5082285,9.31794649 85.2949452,9.31475374 85.0796723,9.31196009 C84.8647973,9.30916644 84.6483306,9.30717098 84.4310681,9.3055746 C84.2142035,9.30397823 83.996941,9.30318005 83.7792806,9.30198277 C83.4509994,9.30078549 83.1211265,9.29879002 82.7904577,9.29679456 C82.459789,9.2944 82.1283244,9.29160635 81.7968598,9.28841361 C81.5899431,9.28681723 81.3830265,9.28482177 81.1765077,9.28362449 C80.969591,9.28242721 80.7638681,9.2828263 80.5597369,9.28641814 C80.3552077,9.29040907 80.1518723,9.29679456 79.9501285,9.30517551 C79.7479869,9.31355646 79.5462431,9.32393288 79.3452952,9.33470839 C79.1439494,9.34588299 78.9433994,9.3566585 78.7432473,9.36663583 C78.5426973,9.37741134 78.343341,9.38619138 78.143189,9.39417324 C77.9434348,9.40135692 77.7436806,9.40694422 77.5443244,9.40973787 C77.3449681,9.41253152 77.1460098,9.41293061 76.9470515,9.41053605 C76.748491,9.40854059 76.5499306,9.40375147 76.352564,9.3965678 C76.1547994,9.39018231 75.9582285,9.38140227 75.7632494,9.37182404 C75.5682702,9.36184671 75.3744848,9.3510712 75.182291,9.34029569 C74.9900973,9.32952018 74.7998931,9.31834558 74.6124744,9.30836825 C74.4246577,9.29799184 74.2396265,9.28921179 74.0573806,9.28122993 C73.8755327,9.27364717 73.6964702,9.26726168 73.520591,9.26327075 C73.3367535,9.2604771 73.1564973,9.260078 72.9802202,9.26087619 C72.8035452,9.26167438 72.6304515,9.26327075 72.4613369,9.2660644 C72.1235056,9.27244989 71.7999994,9.28162902 71.4924098,9.29240454 C71.1844223,9.30318005 70.8919535,9.31395556 70.6154015,9.32473107 C70.3388494,9.33470839 70.078214,9.34388753 69.8358827,9.35027302 C69.5927556,9.35745669 69.3687285,9.3622458 69.1641994,9.36503946 C68.755141,9.37102585 68.4264619,9.37501678 68.1924869,9.38060408 C68.0110369,9.3849941 67.7973556,9.38659048 67.5554223,9.38579229 C67.3142848,9.3849941 67.0444973,9.38220045 66.7508348,9.37860862 C66.4571723,9.37461769 66.1396348,9.37142494 65.8025994,9.37022766 C65.6338827,9.36982857 65.460789,9.37062676 65.283716,9.37262222 C65.1066431,9.37421859 64.9251931,9.37621406 64.7389681,9.37820952 C64.553141,9.3798059 64.3633348,9.38140227 64.1699473,9.38299864 C63.9765598,9.3849941 63.7803869,9.38619138 63.5810306,9.38778776 C63.3816744,9.38898503 63.1799306,9.39018231 62.9761973,9.3909805 C62.772464,9.39177868 62.566741,9.39217778 62.3602223,9.39257687 C62.1533056,9.39297596 61.9451952,9.39337506 61.7346973,9.39377415 C56.9286598,9.38818685 51.4588973,9.32153832 51.4588973,9.32153832",id:"Fill-53",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:55}}),_react2.default.createElement("path",{d:"M4.54046354,21.5659501 C4.53529063,21.6673197 4.53728021,21.9199456 4.59696771,22.1673832 C4.65665521,22.4148209 4.77563229,22.6586667 5.00801563,22.7576417 C5.12420729,22.8067302 5.44850938,22.952 5.88701354,23.1479546 C6.10626563,23.2457324 6.35934063,23.3558821 6.62833229,23.4736145 C6.89931354,23.5913469 7.18143646,23.7166621 7.46117188,23.8419773 C7.74090729,23.9680907 8.01984688,24.0930068 8.28446146,24.2115374 C8.54947396,24.330068 8.80055938,24.4410159 9.02219896,24.54039 C9.46508021,24.7387392 9.78580104,24.8915918 9.86697604,24.9526531 C10.1924719,25.1980952 10.5995406,25.5241542 11.1689594,25.4427392 C11.1689594,25.4427392 12.0917281,25.4563084 13.3407885,25.4730703 C13.9659156,25.4814512 14.6722177,25.4902313 15.3856823,25.4978141 C16.0991469,25.5053968 16.8189781,25.5113832 17.4711635,25.5141769 C18.1237469,25.5165714 18.7086844,25.5173696 19.1535552,25.5157732 C19.5976302,25.5149751 19.9012406,25.5109841 19.9887823,25.5038005 C20.0771198,25.4966168 20.601574,25.4910295 21.4192927,25.489034 C21.8279531,25.4878367 22.310626,25.4886349 22.8486094,25.4906304 C23.3865927,25.4930249 23.9802844,25.4966168 24.6141656,25.5041995 C24.9313052,25.5081905 25.2591885,25.5141769 25.5954281,25.5209615 C25.9320656,25.5285442 26.2762635,25.5365261 26.6260323,25.5457052 C26.975801,25.5548844 27.3307427,25.5640635 27.6912552,25.5696508 C27.8711135,25.5728435 28.0525635,25.574839 28.2340135,25.5764354 C28.4158615,25.5780317 28.5981073,25.579229 28.7803531,25.5800272 C28.962201,25.5804263 29.144049,25.5808254 29.325101,25.5812245 C29.5061531,25.5816236 29.6864094,25.5820227 29.8658698,25.58322 C30.2235969,25.5852154 30.576549,25.5880091 30.9211448,25.5916009 C31.2084406,25.5947937 31.4901656,25.5983855 31.7659219,25.6027755 C32.0412802,25.6071655 32.3114656,25.6115556 32.5744885,25.6151474 C32.8379094,25.6187392 33.0957594,25.6215329 33.3472427,25.6227302 C33.5979302,25.6239274 33.8434448,25.6231293 34.0817969,25.6199365 C34.320149,25.6163447 34.5517365,25.6115556 34.773774,25.6059683 C34.9958115,25.600381 35.2086969,25.5947937 35.4112365,25.5892063 C35.8159177,25.5780317 36.1784198,25.5680544 36.4883969,25.5612698 C37.108351,25.5465034 37.514624,25.540517 37.6224594,25.5437098 C37.719551,25.5461043 37.9618823,25.5445079 38.3136406,25.5421134 C38.4895198,25.5409161 38.6924573,25.5397188 38.9176781,25.5385215 C39.1421031,25.5377234 39.3892094,25.5373243 39.6530281,25.5373243 C39.9172448,25.5373243 40.2005615,25.5381224 40.4978052,25.5393197 C40.7954469,25.540517 41.1074135,25.5425125 41.4269406,25.544907 C41.7468656,25.5477007 42.074351,25.5508934 42.4030302,25.5556825 C42.7321073,25.5604717 43.0619802,25.5656599 43.387476,25.5724444 C43.7129719,25.5780317 44.0340906,25.5788299 44.3468531,25.5724444 C44.6596156,25.566059 44.9652156,25.5556825 45.259276,25.5441088 C45.5537344,25.5321361 45.8390406,25.5209615 46.1112156,25.5117823 C46.3833906,25.5022041 46.6436281,25.4958186 46.8871531,25.4922268 C47.1302802,25.4886349 47.355501,25.4882358 47.556449,25.4926259 C48.1588948,25.5053968 48.5412927,25.5209615 48.5719323,25.5225578 C48.654301,25.5265488 48.7490052,25.4750658 48.817049,25.3138322 C48.8854906,25.1521995 48.9280677,24.879619 48.9053865,24.4378231 C48.9010094,24.3496236 48.9061823,24.1389025 48.9189156,23.8268118 C48.9252823,23.668771 48.9328427,23.4839909 48.9415969,23.2768617 C48.9499531,23.0697324 48.960299,22.840254 48.9714406,22.5928163 C48.993724,22.097542 49.0160073,21.5272381 49.0343115,20.9078458 C49.0438615,20.5977506 49.0502281,20.2760816 49.0542073,19.9452336 C49.0581865,19.6147846 49.0597781,19.2755556 49.0593802,18.9303401 C49.0593802,18.5843265 49.0597781,18.2323265 49.0609719,17.8771338 C49.0621656,17.521542 49.0637573,17.1631565 49.0657469,16.8043719 C49.0673385,16.4459864 49.069726,16.0876009 49.0725115,15.7336054 C49.0752969,15.3792109 49.0788781,15.0288073 49.084051,14.6839909 C49.089224,14.3391746 49.0959885,14.0003447 49.103151,13.6718912 C49.1103135,13.3430385 49.1186698,13.0249615 49.127026,12.7204535 C49.1341885,12.4167438 49.1405552,12.1278005 49.1457281,11.8568163 C49.1505031,11.5854331 49.1544823,11.3324082 49.1564719,11.1005351 C49.1588594,10.8686621 49.1600531,10.657542 49.1600531,10.4695692 C49.160451,10.2823946 49.1592573,10.1175692 49.1572677,9.97988209 C49.1524927,9.70410884 49.141351,9.53449433 49.1242406,9.49418594 C49.0378927,9.29503855 48.9511469,9.20643991 48.654699,9.17930159 C48.506674,9.16533333 48.305726,9.16692971 48.0271844,9.17491156 C47.8883115,9.17930159 47.7291448,9.18488889 47.546899,9.19047619 C47.365051,9.19646259 47.159726,9.20244898 46.9281385,9.20803628 C46.8123448,9.21082993 46.6113969,9.21162812 46.3376302,9.21082993 C46.0638635,9.21003175 45.7172781,9.20803628 45.3110052,9.20524263 C45.1076698,9.20404535 44.8908052,9.20284807 44.6612073,9.20204989 C44.4316094,9.2012517 44.1892781,9.2012517 43.9350094,9.20204989 C43.6990448,9.20284807 43.4523365,9.20484354 43.1956802,9.20803628 C42.939024,9.21122902 42.6724198,9.21521995 42.3974594,9.21921088 C42.1161323,9.224 41.826449,9.22878912 41.530399,9.23238095 C41.2347469,9.2355737 40.9323302,9.23756916 40.6243427,9.23796825 C40.3163552,9.23836735 40.002001,9.23677098 39.6816781,9.23477551 C39.4095031,9.23278005 39.133349,9.23038549 38.8548073,9.22519728 C38.5766635,9.22040816 38.2961323,9.21362358 38.0132135,9.20444444 C37.7306927,9.1956644 37.4445906,9.18568707 37.1557031,9.17610884 C36.8664177,9.16692971 36.573551,9.15775057 36.277501,9.15056689 C35.981451,9.14338322 35.681024,9.1385941 35.3770156,9.13659864 C35.0730073,9.13500227 34.7658156,9.13619955 34.4562365,9.14058957 C34.1462594,9.14497959 33.8358844,9.15136508 33.5255094,9.15934694 C33.2155323,9.1673288 32.9043615,9.17650794 32.5947823,9.18568707 C32.2852031,9.19486621 31.9780115,9.20284807 31.6751969,9.20883447 C31.3727802,9.21442177 31.0747406,9.21761451 30.781874,9.21761451 C30.457174,9.21721542 30.137249,9.21601814 29.821701,9.21442177 C29.5097344,9.21082993 29.205726,9.20444444 28.9112677,9.19606349 C28.6168094,9.18728345 28.3299115,9.17690703 28.0509719,9.16573243 C27.7716344,9.15415873 27.4978677,9.14298413 27.2300698,9.1334059 C26.961874,9.12342857 26.6984531,9.11504762 26.4398073,9.10906122 C26.1811615,9.10267574 25.9268927,9.09948299 25.6781948,9.09828571 C25.429099,9.09708844 25.1859719,9.09828571 24.9500073,9.10107937 C24.7140427,9.10387302 24.4868323,9.10826304 24.2691719,9.11305215 C24.0515115,9.11784127 23.8449927,9.12302948 23.6500135,9.12821769 C23.2747781,9.13819501 22.9464969,9.14697506 22.673924,9.15256236 C22.129176,9.16413605 21.8032823,9.16692971 21.7447885,9.16333787 C21.6878865,9.16014512 21.5000698,9.15974603 21.2111823,9.16014512 C21.0663406,9.16054422 20.8964302,9.16094331 20.7034406,9.16253968 C20.5112469,9.16373696 20.2963719,9.16533333 20.0623969,9.1673288 C19.5948448,9.17131973 19.0520865,9.17690703 18.4627719,9.18209524 C18.1683135,9.18488889 17.8623156,9.18688435 17.5483594,9.18848073 C17.234801,9.19047619 16.9140802,9.19087528 16.590574,9.18808163 C16.2670677,9.18568707 15.9403781,9.18049887 15.6140865,9.1729161 C15.2873969,9.16613152 14.9603094,9.15775057 14.6352115,9.14976871 C14.3101135,9.14098866 13.9866073,9.13380499 13.6674781,9.1274195 C13.348349,9.12103401 13.032801,9.11744218 12.7244156,9.11544671 C12.4164281,9.11345125 12.1148073,9.11424943 11.824726,9.1162449 C11.533849,9.11824036 11.2545115,9.12143311 10.9902948,9.12542404 C10.7256802,9.12941497 10.4761865,9.1334059 10.2453948,9.13699773 C10.0146031,9.14098866 9.80291146,9.1445805 9.61310521,9.14777324 C9.47502813,9.1501678 9.34928646,9.15216327 9.23667604,9.15336054 C9.12446354,9.15535601 9.02498438,9.15775057 8.94022813,9.16054422 C8.75559479,9.16692971 8.63900521,9.17131973 8.60478438,9.1729161 C8.50172396,9.17690703 8.36444271,9.17890249 8.20686771,9.18129705 C8.04889479,9.18369161 7.87182188,9.18528798 7.69554479,9.18688435 C7.52085938,9.18808163 7.34975521,9.18887982 7.20252604,9.19287075 C7.05569479,9.19726077 6.93353438,9.20564172 6.84957396,9.22519728 C6.79346771,9.23796825 6.72263854,9.2750839 6.64424896,9.33135601 C6.56585938,9.38722902 6.48189896,9.4626576 6.39953021,9.55404989 C6.31716146,9.64544218 6.23797604,9.75439456 6.16714688,9.87731519 C6.09631771,10.0006349 6.03225313,10.1379229 5.97614688,10.2831927 C5.91964271,10.4308571 5.86910729,10.5825125 5.82692813,10.7289796 C5.78275938,10.876644 5.74575313,11.0179229 5.72068438,11.1464308 C5.70397188,11.2318367 5.68049479,11.3264218 5.65025313,11.4373696 C5.61762396,11.5479184 5.57823021,11.6764263 5.52968438,11.8300771 C5.49188229,11.949805 5.44612188,12.0850975 5.39439271,12.2403447 C5.34186771,12.3951927 5.28615938,12.5711927 5.22846146,12.7711383 C5.17872188,12.9463401 5.12977813,13.1402993 5.08361979,13.3558095 C5.06093854,13.4631655 5.04064479,13.5757098 5.02234063,13.6934422 C5.00363854,13.8111746 4.98851771,13.9336961 4.97538646,14.0614059 C4.96225521,14.1895147 4.95071563,14.3228118 4.94076771,14.4612971 C4.93081979,14.6001814 4.92126979,14.7446531 4.91171979,14.8959093 C4.90137396,15.0467664 4.89102813,15.2040091 4.87948854,15.3672381 C4.86715313,15.5304671 4.85441979,15.7000816 4.84049271,15.8760816 C4.82656563,16.0524807 4.81104688,16.2356644 4.79393646,16.4248345 C4.77642813,16.6148027 4.75732813,16.8111565 4.73743229,17.0142948 C4.71753646,17.2174331 4.69843646,17.4281542 4.67973438,17.646059 C4.66063438,17.8639637 4.64153438,18.0894512 4.62323021,18.3237188 C4.60771146,18.5188753 4.59497813,18.7212154 4.58662188,18.929941 C4.57826563,19.1382676 4.57388854,19.3529796 4.57229688,19.5740771 C4.57070521,19.7947755 4.57030729,20.0214603 4.56951146,20.2541315 C4.56871563,20.4864036 4.56593021,20.7250612 4.56115521,20.968907 C4.55677813,21.1640635 4.54961563,21.3632109 4.54046354,21.5659501",id:"Fill-55",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:56}}),_react2.default.createElement("path",{d:"M107.589977,46.8179592 C107.570479,46.2292971 107.551777,45.6450249 107.539044,45.065542 C107.526709,44.486458 107.518352,43.9133605 107.515567,43.3398639 C107.513577,42.7831293 107.512781,42.2271927 107.515965,41.6748481 C107.517954,41.4138413 107.533075,41.1532336 107.548196,40.8926259 C107.561327,40.6595556 107.601119,40.4073288 107.570877,40.1750567 C107.543421,39.9655329 107.578836,39.7691791 107.588784,39.5572608 C107.600323,39.3162086 107.594752,39.0747574 107.589181,38.8333061 C107.576846,38.3001179 107.564113,37.7673288 107.551379,37.2345397 C107.550186,37.1910385 107.548594,37.1439456 107.521536,37.1096236 C107.497263,37.0780952 107.457073,37.064127 107.418873,37.0529524 C107.286367,37.0150385 107.147892,36.9974785 107.010213,37.0010703 C106.770667,37.008254 106.55619,37.0333968 106.320623,37.0094512 C106.074711,36.9843084 105.808106,37.0321995 105.559806,37.0282086 C105.075144,37.0190295 104.590084,37.0166349 104.105023,37.0166349 C103.500588,37.017034 102.885011,37.0218231 102.263465,37.0258141 C101.642715,37.0294059 101.021169,37.0357914 100.404796,37.0413787 C99.789219,37.0473651 99.1788148,37.0533515 98.5791544,37.0585397 C97.9512419,37.0637279 97.3388481,37.0705125 96.7344127,37.0784943 C96.1299773,37.0860771 95.5315106,37.094059 94.9366252,37.1020408 C93.748844,37.1184036 92.5622565,37.1160091 91.3744752,37.1036372 C90.4218627,37.094059 89.4708419,37.0880726 88.519821,37.0848798 C87.5691981,37.0816871 86.6185752,37.081288 85.6663606,37.0824853 C84.714544,37.0840816 83.7603398,37.090068 82.8037481,37.1032381 C81.8463606,37.11122 80.8841981,37.1203991 79.9160669,37.1267846 C78.9483335,37.132771 77.9742335,37.1319728 76.9973481,37.1255873 C76.0212585,37.1148118 75.0419856,37.1148118 74.0595294,37.1231927 C73.077869,37.1315737 72.0954127,37.1439456 71.1133544,37.1559184 C70.131694,37.1674921 69.152421,37.1770703 68.1775252,37.1794649 C67.2022315,37.1814603 66.2325085,37.1710839 65.2691523,37.145941 C64.3053981,37.12 63.3468169,37.0836825 62.3906231,37.0485624 C61.3182377,37.008254 60.2462502,36.9731338 59.1754565,36.9519819 C58.1046627,36.931229 57.0346648,36.926839 55.9646669,36.9332245 C54.894271,36.93961 53.8234773,36.9507846 52.750694,36.9603628 C51.6779106,36.969542 50.6039335,36.9771247 49.5295585,36.9875011 C48.4551835,36.9978776 47.3804106,37.0078549 46.3072294,37.0150385 C45.2336502,37.0218231 44.160071,37.0222222 43.086094,37.0154376 C42.0121169,37.0094512 40.937344,36.9978776 39.8617752,36.9843084 C38.7858085,36.9711383 37.7086481,36.9591655 36.630294,36.952381 C35.6717127,36.9463946 34.7119377,36.9475918 33.750969,36.9579683 C32.561994,36.9759274 31.3658565,37.0046621 30.1633523,37.0314014 C28.9576648,37.0737052 27.7507835,37.1056327 26.5439023,37.111619 C25.3692523,37.1168073 24.1969898,37.0960544 23.0291044,37.0753016 C21.8620148,37.0541497 20.7000981,37.0282086 19.5445481,37.0226213 C18.9444898,37.0198277 18.3472169,37.0182313 17.7515356,37.0178322 C17.1554565,37.0174331 16.5625606,37.0182313 15.9720523,37.0198277 C15.381146,37.0206259 14.7906377,37.0210249 14.1997315,37.0194286 C13.6084273,37.0174331 13.0159294,37.0142404 12.421044,37.0090522 C11.8265565,37.0038639 11.2288856,36.9978776 10.6296231,36.9918912 C10.0303606,36.9855057 9.43030229,36.9815147 8.83223354,36.9795193 C8.23376688,36.9779229 7.63450438,36.9791202 7.03444604,36.9835102 C6.43438771,36.9882993 5.83273771,36.9970794 5.23029188,37.0114467 C4.25539604,37.034195 3.28129604,37.0661224 2.31873563,37.1020408 C2.23000021,37.1052336 2.14285646,37.1088254 2.05412104,37.1120181 L2.05412104,37.2002177 C2.05730438,37.6196644 2.06406896,38.0391111 2.07401688,38.4589569 C2.08436271,38.8784036 2.09749396,39.2970522 2.11142104,39.7141043 C2.12534813,40.1311565 2.13927521,40.5462132 2.15280438,40.9592744 C2.16673146,41.3719365 2.17827104,41.781805 2.18702521,42.1876825 C2.19617729,42.5939592 2.20214604,42.9970431 2.20493146,43.3965351 C2.20811479,43.7964263 2.20731896,44.1927256 2.20572729,44.5870295 C2.20413563,44.9809342 2.20254396,45.3728435 2.20254396,45.7623583 C2.20294188,47.2529705 2.21129813,48.7639365 2.29883979,50.2585397 C2.33067313,50.800907 2.39752313,51.534839 1.74573563,51.5879184 C1.57184604,51.6018866 1.39915021,51.667737 1.27420438,51.7898594 C0.974175208,52.0831927 1.06171688,52.7029841 1.04977938,53.080127 C1.03386271,53.5813878 1.01715021,54.0822494 1.00202938,54.5831111 C0.993673125,54.8385306 1.00282521,55.1330612 1.20178354,55.2919002 C1.30245646,55.3729161 1.43416688,55.4012517 1.56030646,55.4271927 C2.27098563,55.574059 2.97927729,55.7324989 3.68557938,55.8989206 C4.76273979,56.1527438 5.82398354,56.4257234 6.90034813,56.6779501 C7.36073771,56.7861043 7.82232104,56.8938594 8.27355854,57.0064036 C8.72479604,57.1193469 9.16648354,57.2342857 9.58787729,57.3536145 C9.96191896,57.4601723 10.3375523,57.5631383 10.7135835,57.6597188 C11.0900127,57.7559002 11.4684315,57.8440998 11.8484419,57.9231202 C12.2312377,57.9925624 12.616819,58.0508299 13.0047877,58.0995193 C13.3927565,58.1478095 13.7823169,58.1901134 14.1722752,58.2260317 C14.5626315,58.2619501 14.9533856,58.2930794 15.3449356,58.3194195 C15.7360877,58.3465578 16.1276377,58.3681088 16.5195856,58.3848707 C16.9111356,58.4020317 17.3042773,58.4152018 17.697021,58.4231837 C18.0901627,58.4303673 18.4825085,58.4327619 18.8740585,58.4303673 C19.2656085,58.4283719 19.6563627,58.4231837 20.0451273,58.4163991 C20.4342898,58.4100136 20.8214627,58.4024308 21.2078398,58.3956463 C21.5942169,58.3880635 21.9790023,58.3820771 22.362196,58.3760907 C22.7457877,58.3705034 23.1281856,58.3665125 23.5101856,58.364517 C23.8917877,58.3617234 24.2729919,58.3597279 24.654196,58.3569342 C25.0354002,58.3541406 25.4170023,58.3505488 25.7990023,58.3469569 C25.8821669,58.3457596 25.9657294,58.342966 26.048894,58.3413696 C32.4585356,58.4108118 46.3223502,58.5377234 48.0930794,58.3058503 C50.3811002,58.0065306 67.1930794,57.9067574 67.1930794,57.9067574 C68.1043085,58.0161088 70.8650544,58.1063039 74.9480773,58.1813333 C75.082971,58.1964989 75.2158752,58.2116644 75.3519627,58.2260317 C76.2345419,58.3178231 77.1616877,58.2890884 78.0892315,58.2324172 C85.5394252,58.3397732 96.0257231,58.4096145 107.448717,58.4543129 C107.554165,57.9227211 107.584804,57.36439 107.596742,56.887873 C107.607486,56.436898 107.595548,55.9827302 107.584009,55.5253696 C107.573265,55.0684082 107.562521,54.6090522 107.575652,54.1484989 C107.594354,53.5067574 107.629769,52.8682086 107.655236,52.2368435 C107.6811,51.6058776 107.699006,50.985288 107.689854,50.3666939 C107.680702,49.7752381 107.664786,49.1829841 107.647675,48.589932 C107.630565,47.997678 107.609475,47.4062222 107.589977,46.8179592 M182.744896,53.6747755 C182.735744,53.1320091 182.727388,52.5888435 182.724602,52.045678 C182.722215,51.5021134 182.728581,50.9585488 182.739325,50.4149841 C182.749273,49.8706213 182.757231,49.3270567 182.760017,48.783093 C182.762404,48.2391293 182.760813,47.6947664 182.75564,47.1508027 C182.750467,46.606839 182.742111,46.0624762 182.731367,45.5189116 C182.720225,44.9753469 182.708288,44.4317823 182.695554,43.8882177 C182.657752,42.2726893 182.709481,40.6336145 182.701523,39.0109025 C182.699136,38.5048526 182.681627,37.9549025 182.361702,37.5629932 C181.980498,37.0952562 181.406304,37.0852789 180.858373,37.0337959 C180.325165,36.9835102 179.852838,36.9064853 179.304509,36.9220499 C179.025569,36.9304308 178.752598,36.9443991 178.493952,36.9487891 C178.197106,36.9535782 177.901056,36.9587664 177.604609,36.9635556 C176.715265,36.9779229 175.825523,36.9906939 174.936179,36.999873 C174.315031,37.0066576 173.693486,37.0122449 173.07194,37.0154376 C171.997963,37.0222222 170.924384,37.0218231 169.850804,37.0150385 C168.777225,37.0078549 167.70285,36.9978776 166.628475,36.9875011 C165.5541,36.9771247 164.480123,36.969542 163.406942,36.9603628 C162.334556,36.9507846 161.263763,36.93961 160.193367,36.9332245 C159.123369,36.926839 158.053371,36.931229 156.982577,36.9519819 C155.911784,36.9731338 154.839796,37.008254 153.767411,37.0485624 C152.811217,37.0836825 151.852238,37.12 150.888881,37.145941 C149.925525,37.1710839 148.955802,37.1814603 147.980509,37.1794649 C147.005613,37.1770703 146.02634,37.1674921 145.044281,37.1559184 C144.062621,37.1439456 143.079767,37.1315737 142.098106,37.1231927 C141.116048,37.1148118 140.136377,37.1148118 139.160686,37.1255873 C138.183402,37.1319728 137.210098,37.132771 136.241967,37.1267846 C135.273836,37.1203991 134.311673,37.11122 133.354286,37.1032381 C132.397296,37.090068 131.44349,37.0840816 130.491673,37.0824853 C129.539459,37.081288 128.588438,37.0816871 127.638213,37.0848798 C126.687192,37.0880726 125.736171,37.094059 124.783559,37.1036372 C123.595777,37.1160091 122.40919,37.1184036 121.221409,37.1020408 C120.626523,37.094059 120.028056,37.0860771 119.423223,37.0784943 C118.819186,37.0705125 118.206792,37.0637279 117.579277,37.0585397 C116.979219,37.0533515 116.367621,37.046966 115.746473,37.0401814 C115.121346,37.0329977 114.485475,37.025415 113.841646,37.0190295 C113.198215,37.0134422 112.556375,37.0058594 111.925279,37.0022676 C111.419129,36.9994739 110.914173,36.9990748 110.411604,37.0050612 C110.154152,37.008254 109.882375,36.9591655 109.630096,36.982712 C109.387765,37.0062585 109.1709,36.9803175 108.928967,36.9731338 C108.790094,36.9687438 108.650027,36.9859048 108.515531,37.0238186 C108.476934,37.034195 108.435948,37.0485624 108.410481,37.0796916 C108.381831,37.1136145 108.377454,37.1599093 108.374669,37.2030113 C108.338459,37.7286168 108.302646,38.2514286 108.268027,38.7730431 C108.252906,39.0093061 108.238184,39.244771 108.241765,39.4802358 C108.244948,39.686966 108.273996,39.8781315 108.241367,40.0828662 C108.204759,40.3091519 108.239775,40.5557914 108.249325,40.7828753 C108.260865,41.0370975 108.273598,41.2913197 108.276384,41.5467392 C108.281954,42.0879093 108.290311,42.6350658 108.304238,43.1870113 C108.318563,43.7553197 108.333286,44.3288163 108.349202,44.9138866 C108.365119,45.499356 108.38024,46.0952018 108.396156,46.6990295 C108.412073,47.3028571 108.424806,47.9114739 108.431969,48.5224853 C108.439927,49.1330975 108.434754,49.7433107 108.429581,50.349932 C108.418838,50.9816961 108.429979,51.6114649 108.438336,52.2468209 C108.446294,52.8813787 108.455446,53.5211247 108.444702,54.1628662 C108.43754,54.6238186 108.4069,55.0815782 108.377454,55.5373424 C108.348406,55.9931066 108.322144,56.4452789 108.322144,56.8938594 C108.322144,57.368381 108.344825,57.9231202 108.446294,58.4515193 C108.796461,58.4499229 109.148617,58.4491247 109.503956,58.4475283 C109.8585,58.4463311 110.216625,58.4451338 110.577138,58.4435374 C110.937252,58.4423401 111.300152,58.4407438 111.664246,58.4395465 C112.028738,58.4383492 112.394025,58.4367528 112.760109,58.4351565 C113.125794,58.4339592 113.491479,58.4327619 113.855573,58.4311655 C114.219667,58.4299683 114.582169,58.4283719 114.942284,58.4267755 C115.302,58.42478 115.658931,58.4231837 116.012281,58.4215873 C116.365234,58.4195918 116.713809,58.4183946 117.056017,58.4179955 C117.740831,58.4175964 118.409331,58.4195918 119.070669,58.4239819 C119.978715,58.4299683 120.873629,58.4383492 121.754219,58.4495238 C122.634809,58.4599002 123.501471,58.4714739 124.354206,58.4834467 C125.206146,58.4958186 126.044556,58.5065941 126.86705,58.5165714 C127.69034,58.5265488 128.498509,58.5341315 129.290761,58.5389206 C130.347229,58.5457052 131.375844,58.5465034 132.373819,58.5409161 C133.372192,58.5353288 134.339925,58.5261497 135.276223,58.5185669 C136.212919,58.5113832 137.117384,58.5077914 137.984444,58.5065941 C138.9287,58.5812245 139.874946,58.6291156 140.777421,58.5568798 C140.917488,58.5461043 141.053575,58.5333333 141.191652,58.5217596 C142.236979,58.5293424 143.198346,58.5333333 144.066202,58.5345306 C144.934059,58.5357279 145.707609,58.5333333 146.378098,58.5265488 C147.719077,58.5129796 148.651794,58.4830476 149.114173,58.4379501 C149.114173,58.4379501 149.587694,58.4495238 150.384721,58.4662857 C151.181748,58.4826485 152.299894,58.5026032 153.591531,58.510585 C154.883567,58.5181678 156.347104,58.5077914 157.838098,58.4874376 C158.583794,58.4774603 159.335856,58.4646893 160.076777,58.4507211 C160.818096,58.4371519 161.548273,58.4231837 162.249004,58.4100136 C163.650865,58.3832744 164.939319,58.368907 165.971913,58.372898 C167.004109,58.3764898 167.78124,58.3984399 168.159261,58.4395465 C168.765288,58.5820227 169.503821,58.4966168 170.122979,58.5045986 C171.318321,58.5201633 172.512469,58.5153741 173.706219,58.5069932 C174.095381,58.5041995 174.483748,58.5006077 174.872513,58.4970159 C175.267246,58.4930249 175.661581,58.489034 176.064273,58.4842449 C176.466965,58.4798549 176.877217,58.4750658 177.293438,58.4698776 C177.709659,58.4650884 178.131052,58.4599002 178.556425,58.454712 C178.893859,58.450322 179.242036,58.4614966 179.594192,58.4778594 C179.946746,58.4942222 180.302484,58.5161723 180.656231,58.5357279 C181.362931,58.574839 182.053715,58.6019773 182.686402,58.5461043 C182.722613,58.0065306 182.747681,57.4665578 182.760415,56.9253878 C182.773546,56.3850159 182.776331,55.8434467 182.770363,55.3018776 C182.763996,54.7595102 182.754446,54.217542 182.744896,53.6747755",id:"Fill-57",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:57}}),_react2.default.createElement("path",{d:"M22.4556667,48.2447964 C22.3207729,48.182937 22.17235,48.1805424 22.0267125,48.1817397 C21.7219083,48.1849324 21.4127271,48.1989007 21.0939958,48.2168599 C20.7752646,48.234819 20.4469833,48.2555719 20.1071625,48.2675447 C19.8636375,48.2755265 19.6157354,48.2771229 19.3642521,48.2743293 C19.1131667,48.2711365 18.8585,48.2639528 18.6018438,48.2543746 C18.3447896,48.2451955 18.0885313,48.23442 17.8322729,48.226039 C17.5756167,48.2180571 17.3197563,48.2128689 17.0623042,48.213268 C16.8573771,48.213268 16.6516542,48.2140662 16.4455333,48.2156626 C16.2398104,48.217658 16.0336896,48.2200526 15.8275688,48.2232454 C15.62105,48.2268372 15.4149292,48.2308281 15.2088083,48.2352181 C15.0030854,48.23881 14.7973625,48.2432 14.5928333,48.2471909 C14.3202604,48.25198 14.0520646,48.2547737 13.7910313,48.2551728 C13.5976438,48.2555719 13.4070417,48.2551728 13.2176333,48.2543746 C13.0286229,48.2531773 12.8408063,48.25198 12.6537854,48.2503837 C12.4576125,48.2483882 12.2506958,48.2503837 12.0787958,48.3533497 C11.9072938,48.4563156 11.7907042,48.6945741 11.87745,48.8893315 C11.9757354,49.1112272 12.2463188,49.1475447 12.4671625,49.1527329 C12.6541833,49.1571229 12.842,49.1611138 13.0314083,49.1639075 C13.2208167,49.1671002 13.4118167,49.1686966 13.606,49.1694948 C13.7997854,49.1698939 13.9967542,49.1690957 14.1957125,49.1671002 C14.3950688,49.1647057 14.5968125,49.1615129 14.8005458,49.1571229 C15.0062688,49.1523338 15.2123896,49.1475447 15.4185104,49.1427556 C15.6246313,49.1379664 15.8315479,49.1335764 16.0372708,49.1303837 C16.3810708,49.1243973 16.7248708,49.1208054 17.067875,49.1208054 C17.4104813,49.1208054 17.7538833,49.1220027 18.0964896,49.1239982 C18.4394938,49.1255946 18.7832938,49.1263927 19.1223188,49.1247964 C19.4609458,49.1235991 19.7904208,49.1208054 20.1111417,49.1180118 C20.4318625,49.114819 20.7438292,49.1116263 21.0474396,49.1128236 C21.3506521,49.1140209 21.6459063,49.1196082 21.9367833,49.1287873 C22.2025917,49.1379664 22.635525,49.0872816 22.7127208,48.7057488 C22.7517167,48.513785 22.6156292,48.3214222 22.4556667,48.2447964",id:"Fill-59",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:58}}),_react2.default.createElement("path",{d:"M12.923931,47.5658594 C13.1169206,47.5666576 13.310706,47.5678549 13.5052873,47.5690522 C13.7002665,47.5706485 13.898429,47.5706485 14.0993769,47.5702494 C14.3003248,47.5698503 14.5040581,47.568254 14.7089852,47.5662585 C14.915504,47.5638639 15.1220227,47.5614694 15.3285415,47.5594739 C15.5350602,47.5574785 15.741579,47.5558821 15.9476998,47.5546848 C16.204754,47.5534875 16.462206,47.5534875 16.7184644,47.5534875 C16.9755185,47.5538866 17.2317769,47.5542857 17.4880352,47.5546848 C17.7438956,47.5550839 18.000154,47.5558821 18.2564123,47.5566803 C18.5126706,47.5574785 18.7693269,47.5578776 19.0271769,47.5574785 C19.3693852,47.5562812 19.7068185,47.5538866 20.033906,47.551093 C20.3605956,47.5482993 20.6769394,47.5455057 20.9849269,47.542712 C21.2917206,47.5411156 21.590556,47.542712 21.8842185,47.5482993 C22.1528123,47.5534875 22.5925102,47.4968163 22.6860206,47.1144853 C22.7333727,46.9225215 22.5992748,46.7349478 22.436129,46.662712 C22.2984498,46.6048435 22.1452519,46.6056417 21.9948394,46.6096327 C21.6800873,46.6180136 21.3609581,46.6379683 21.0362581,46.6587211 C20.7107623,46.6790748 20.3765123,46.6994286 20.0283352,46.709805 C19.7788415,46.7177868 19.5257665,46.718585 19.2714977,46.7149932 C19.0176269,46.7110023 18.7629602,46.7030204 18.5082935,46.6934422 C18.2540248,46.6846621 17.999756,46.6750839 17.7446915,46.6675011 C17.4904227,46.6603175 17.2349602,46.6555283 16.9790998,46.6559274 C16.7745706,46.6563265 16.5692456,46.6567256 16.3639206,46.6567256 L15.746354,46.6567256 C15.5398352,46.6567256 15.3337144,46.6567256 15.1267977,46.6571247 C14.920279,46.6575238 14.7129644,46.6579229 14.5068435,46.658322 C14.2310873,46.6591202 13.9589123,46.6587211 13.6899206,46.6579229 C13.4937477,46.6571247 13.2983706,46.6563265 13.1041873,46.6563265 C12.910004,46.6563265 12.7166165,46.6567256 12.522831,46.658322 C12.3194956,46.6595193 12.1042227,46.6659048 11.9267519,46.774059 C11.749281,46.8818141 11.6318956,47.1244626 11.725804,47.3172245 C11.8336394,47.5371247 12.1161602,47.5650612 12.3445644,47.5646621 C12.5379519,47.564263 12.7309415,47.5646621 12.923931,47.5658594",id:"Fill-61",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:59}}),_react2.default.createElement("path",{d:"M12.8022879,45.9761125 C13.0028379,45.9757134 13.2033879,45.9761125 13.4047338,45.9773098 C13.6056817,45.9789061 13.8082213,45.9809016 14.0123525,45.9828971 C14.2164838,45.9848925 14.4218088,45.986888 14.6283275,45.9888834 C14.8344483,45.9908789 15.041365,45.9924753 15.2478838,45.9940717 C15.4548004,45.9952689 15.6617171,45.9964662 15.86744,45.9972644 C16.2108421,45.9988608 16.5534483,46.000058 16.894065,46.0004571 C17.2354775,46.0008562 17.5752983,46.0008562 17.9151192,46.0008562 C18.2545421,46.0008562 18.593965,46.0008562 18.93299,46.0004571 C19.272015,46.000058 19.6090504,45.9992599 19.9425046,45.9976635 C20.2763567,45.9952689 20.6010567,45.9944707 20.9166046,45.9948698 C21.2317546,45.9952689 21.5405379,45.9968653 21.84574,45.9988608 C22.1254754,46.0008562 22.5838754,45.9377995 22.6761921,45.5746249 C22.7231463,45.3914413 22.5779067,45.2158404 22.4056088,45.1487927 C22.2599713,45.0937179 22.0996108,45.0945161 21.9432296,45.0969107 C21.6157442,45.1028971 21.2858713,45.1152689 20.9500296,45.1268426 C20.6133921,45.1388154 20.26999,45.1511873 19.9230067,45.1559764 C19.6743088,45.1599673 19.4244171,45.1587701 19.1737296,45.1551782 C18.92344,45.1523846 18.6719567,45.1448018 18.4188817,45.13682 C18.1658067,45.1288381 17.9127317,45.119659 17.6588608,45.1128744 C17.40499,45.1060898 17.1507213,45.1013007 16.8952588,45.1016998 C16.6907296,45.1016998 16.4862004,45.1016998 16.2804775,45.1013007 C16.0755504,45.1005025 15.8690317,45.1001034 15.6625129,45.0989061 C15.4559942,45.0977088 15.2494754,45.0961125 15.0433546,45.094117 C14.8368358,45.0921215 14.6311129,45.0901261 14.42539,45.0877315 C14.1512254,45.0849379 13.8778567,45.0817451 13.6044879,45.0793506 C13.4023463,45.0777542 13.2006025,45.0773551 12.9996546,45.0773551 C12.7983088,45.0777542 12.5973608,45.0789515 12.3968108,45.0809469 C12.1867108,45.0837406 11.9646733,45.0909243 11.7788463,45.2006748 C11.5934171,45.3100263 11.4668796,45.5546703 11.5619817,45.7458358 C11.670215,45.9637406 11.9634796,45.9860898 12.2006379,45.982498 C12.4015858,45.9789061 12.6021358,45.9769107 12.8022879,45.9761125",id:"Fill-63",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:60}}),_react2.default.createElement("path",{d:"M12.0830138,44.4031274 C12.2895325,44.3999347 12.4944596,44.3987374 12.6997846,44.3987374 C12.9047117,44.3983383 13.1092408,44.3995356 13.31377,44.4015311 C13.5182992,44.4039256 13.7228283,44.4067193 13.9277554,44.409912 C14.1322846,44.4127057 14.3372117,44.4158984 14.5425367,44.4190912 C14.7474638,44.4222839 14.9531867,44.4254766 15.1589096,44.4278712 C15.3650304,44.4302658 15.5711513,44.4326603 15.7772721,44.4346558 C15.9837908,44.4362522 16.1891158,44.4378485 16.3944408,44.4390458 C16.6001638,44.4402431 16.804295,44.4410413 17.0084263,44.4414404 C17.2129554,44.4418395 17.4162908,44.4418395 17.6196263,44.4414404 C17.8229617,44.4414404 18.0262971,44.4406422 18.2284388,44.4402431 C18.4309783,44.4394449 18.6327221,44.4382476 18.8332721,44.4370503 C19.0334242,44.4362522 19.2327804,44.4362522 19.4309429,44.4378485 C19.6291054,44.4390458 19.8260742,44.4418395 20.022645,44.4454313 C20.2188179,44.4494222 20.4149908,44.4542113 20.6111638,44.4593995 C20.8065408,44.4641887 21.0011221,44.4693769 21.1945096,44.4749642 C21.388295,44.4801524 21.5804888,44.4849415 21.7714888,44.4897306 C22.0635596,44.4961161 22.5398658,44.4362522 22.6246221,44.0674902 C22.6675971,43.8815129 22.5092263,43.7011229 22.3269804,43.6304834 C22.1725888,43.5730141 22.0062596,43.5722159 21.8443075,43.572615 C21.5056804,43.5738122 21.1674513,43.581395 20.8288242,43.5881796 C20.4901971,43.5945651 20.1495804,43.6009506 19.8069742,43.6005515 C19.5614596,43.6001524 19.3151492,43.5957624 19.0672471,43.5893769 C18.8189471,43.5829914 18.5686575,43.5758077 18.3163783,43.5674268 C18.0637013,43.559844 17.8110242,43.5502658 17.5567554,43.5434812 C17.3028846,43.5362975 17.0482179,43.5311093 16.7919596,43.5307102 C16.5189888,43.5307102 16.24562,43.529912 15.9714554,43.5287147 C15.6972908,43.5271184 15.4235242,43.5251229 15.1493596,43.5223293 C14.8759908,43.5191365 14.6026221,43.5159438 14.3300492,43.512751 C14.0574763,43.5091592 13.7856992,43.5051683 13.5151158,43.5015764 C13.3145658,43.4991819 13.11322,43.4971864 12.9118742,43.4959891 C12.7105283,43.4947918 12.5087846,43.4943927 12.3070408,43.4947918 C12.0953492,43.4947918 11.8729138,43.4991819 11.6827096,43.6073361 C11.4929033,43.7150912 11.3540304,43.9625288 11.44197,44.1588825 C11.542245,44.3819755 11.8398867,44.4063202 12.0830138,44.4031274",id:"Fill-65",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:61}}),_react2.default.createElement("path",{d:"M88.4950706,54.6941787 C88.4421477,54.6857977 88.3896227,54.6786141 88.3374956,54.6714304 C88.1807165,54.6510766 88.0243352,54.6351129 87.8667602,54.6239383 C87.7091852,54.6127637 87.5492227,54.6075755 87.385679,54.6087728 C87.2217373,54.609571 87.0526227,54.6171537 86.8803248,54.626732 C86.7080269,54.6367093 86.535331,54.6462875 86.3666144,54.6554667 C86.2432602,54.6622512 86.1238852,54.6590585 86.0112748,54.6574621 C85.8986644,54.6562649 85.7912269,54.6566639 85.6925435,54.6714304 C85.5934623,54.6861968 85.5023394,54.7157297 85.4207665,54.7712036 C85.3391935,54.8266776 85.2671706,54.9088907 85.2042998,55.030215 C85.1668956,55.103249 85.1895769,55.1990313 85.2349394,55.2644825 C85.3411831,55.4233215 85.4677206,55.4987501 85.6065935,55.5310766 C85.7458644,55.5630041 85.8998581,55.5506322 86.0586269,55.5358658 C86.1648706,55.5262875 86.2742977,55.5151129 86.3813373,55.5147138 C86.5027019,55.5131175 86.6248623,55.515512 86.7478185,55.5183057 C86.8707748,55.5210993 86.994129,55.5254893 87.1158915,55.5278839 C87.237654,55.5306776 87.3582227,55.5334712 87.4783935,55.5338703 C87.5973706,55.5350676 87.7155519,55.5354667 87.8333352,55.5334712 C88.0422415,55.5286821 88.2555248,55.5290812 88.4497081,55.4644281 C88.6434935,55.3997751 88.8185769,55.2549043 88.8448394,55.0585506 C88.8567769,54.9683556 88.8332998,54.8637932 88.760481,54.7947501 C88.6896519,54.7273034 88.588581,54.708546 88.4950706,54.6941787",id:"Fill-67",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:62}}),_react2.default.createElement("path",{d:"M186.999222,41.1448925 C186.981316,41.065473 186.948289,40.9856544 186.89656,40.9233959 C186.869103,40.8898721 186.835678,40.8623347 186.796682,40.841981 C186.706753,40.7964844 186.60051,40.8004753 186.499439,40.8052644 C186.279391,40.816439 186.060935,40.8192327 185.842876,40.8196317 C185.648295,40.8200308 185.399199,40.8044662 185.217749,40.8814912 C184.907374,41.0131918 184.801528,41.5284209 185.216555,41.5368018 C185.68928,41.5471782 186.16678,41.5451828 186.640301,41.5236317 C186.71113,41.520439 186.784347,41.5164481 186.84881,41.4853188 C186.978132,41.4226612 187.02827,41.2769923 186.999222,41.1448925",id:"Fill-69",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:63}}),_react2.default.createElement("path",{d:"M135.251035,55.0932717 C135.198112,55.0848907 135.145189,55.077707 135.093062,55.0705234 C134.936681,55.0501696 134.7803,55.0342059 134.622725,55.0230313 C134.464752,55.0122558 134.305187,55.0066685 134.141245,55.0078658 C133.977702,55.009063 133.808587,55.0166458 133.635891,55.0258249 C133.463991,55.0358023 133.291295,55.0453805 133.122579,55.0545596 C132.999225,55.0613442 132.87985,55.0581515 132.767239,55.0565551 C132.654231,55.0553578 132.547191,55.056156 132.44811,55.0709224 C132.349427,55.0856889 132.258304,55.1148227 132.176333,55.1702966 C132.095158,55.2257705 132.022737,55.3079837 131.960264,55.4293079 C131.922462,55.502342 131.945541,55.5981243 131.990904,55.6635755 C132.097148,55.8224145 132.223287,55.8982422 132.36216,55.9301696 C132.501431,55.9620971 132.655823,55.9497252 132.814591,55.9353578 C132.920437,55.9253805 133.029864,55.9142059 133.137302,55.9138068 C133.258268,55.9122104 133.380827,55.914605 133.503385,55.9173986 C133.626739,55.9201923 133.749695,55.9245823 133.871458,55.9269769 C133.99322,55.9297705 134.114187,55.9325642 134.23396,55.9329633 C134.353335,55.9345596 134.471516,55.9345596 134.5893,55.9325642 C134.798206,55.9277751 135.011489,55.9281741 135.205673,55.8635211 C135.399458,55.798868 135.574541,55.6539973 135.600804,55.4576435 C135.612741,55.3674485 135.589264,55.2628862 135.516445,55.1938431 C135.445218,55.1263964 135.344148,55.107639 135.251035,55.0932717",id:"Fill-71",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:64}}),_react2.default.createElement("path",{d:"M22.4556667,48.2447964 C22.3207729,48.182937 22.17235,48.1805424 22.0267125,48.1817397 C21.7219083,48.1849324 21.4127271,48.1989007 21.0939958,48.2168599 C20.7752646,48.234819 20.4469833,48.2555719 20.1071625,48.2675447 C19.8636375,48.2755265 19.6157354,48.2771229 19.3642521,48.2743293 C19.1131667,48.2711365 18.8585,48.2639528 18.6018438,48.2543746 C18.3447896,48.2451955 18.0885313,48.23442 17.8322729,48.226039 C17.5756167,48.2180571 17.3197563,48.2128689 17.0623042,48.213268 C16.8573771,48.213268 16.6516542,48.2140662 16.4455333,48.2156626 C16.2398104,48.217658 16.0336896,48.2200526 15.8275688,48.2232454 C15.62105,48.2268372 15.4149292,48.2308281 15.2088083,48.2352181 C15.0030854,48.23881 14.7973625,48.2432 14.5928333,48.2471909 C14.3202604,48.25198 14.0520646,48.2547737 13.7910313,48.2551728 C13.5976438,48.2555719 13.4070417,48.2551728 13.2176333,48.2543746 C13.0286229,48.2531773 12.8408063,48.25198 12.6537854,48.2503837 C12.4576125,48.2483882 12.2506958,48.2503837 12.0787958,48.3533497 C11.9072938,48.4563156 11.7907042,48.6945741 11.87745,48.8893315 C11.9757354,49.1112272 12.2463188,49.1475447 12.4671625,49.1527329 C12.6541833,49.1571229 12.842,49.1611138 13.0314083,49.1639075 C13.2208167,49.1671002 13.4118167,49.1686966 13.606,49.1694948 C13.7997854,49.1698939 13.9967542,49.1690957 14.1957125,49.1671002 C14.3950688,49.1647057 14.5968125,49.1615129 14.8005458,49.1571229 C15.0062688,49.1523338 15.2123896,49.1475447 15.4185104,49.1427556 C15.6246313,49.1379664 15.8315479,49.1335764 16.0372708,49.1303837 C16.3810708,49.1243973 16.7248708,49.1208054 17.067875,49.1208054 C17.4104813,49.1208054 17.7538833,49.1220027 18.0964896,49.1239982 C18.4394938,49.1255946 18.7832938,49.1263927 19.1223188,49.1247964 C19.4609458,49.1235991 19.7904208,49.1208054 20.1111417,49.1180118 C20.4318625,49.114819 20.7438292,49.1116263 21.0474396,49.1128236 C21.3506521,49.1140209 21.6459063,49.1196082 21.9367833,49.1287873 C22.2025917,49.1379664 22.635525,49.0872816 22.7127208,48.7057488 C22.7517167,48.513785 22.6156292,48.3214222 22.4556667,48.2447964",id:"Fill-73",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:65}}),_react2.default.createElement("path",{d:"M12.923931,47.5658594 C13.1169206,47.5666576 13.310706,47.5678549 13.5052873,47.5690522 C13.7002665,47.5706485 13.898429,47.5706485 14.0993769,47.5702494 C14.3003248,47.5698503 14.5040581,47.568254 14.7089852,47.5662585 C14.915504,47.5638639 15.1220227,47.5614694 15.3285415,47.5594739 C15.5350602,47.5574785 15.741579,47.5558821 15.9476998,47.5546848 C16.204754,47.5534875 16.462206,47.5534875 16.7184644,47.5534875 C16.9755185,47.5538866 17.2317769,47.5542857 17.4880352,47.5546848 C17.7438956,47.5550839 18.000154,47.5558821 18.2564123,47.5566803 C18.5126706,47.5574785 18.7693269,47.5578776 19.0271769,47.5574785 C19.3693852,47.5562812 19.7068185,47.5538866 20.033906,47.551093 C20.3605956,47.5482993 20.6769394,47.5455057 20.9849269,47.542712 C21.2917206,47.5411156 21.590556,47.542712 21.8842185,47.5482993 C22.1528123,47.5534875 22.5925102,47.4968163 22.6860206,47.1144853 C22.7333727,46.9225215 22.5992748,46.7349478 22.436129,46.662712 C22.2984498,46.6048435 22.1452519,46.6056417 21.9948394,46.6096327 C21.6800873,46.6180136 21.3609581,46.6379683 21.0362581,46.6587211 C20.7107623,46.6790748 20.3765123,46.6994286 20.0283352,46.709805 C19.7788415,46.7177868 19.5257665,46.718585 19.2714977,46.7149932 C19.0176269,46.7110023 18.7629602,46.7030204 18.5082935,46.6934422 C18.2540248,46.6846621 17.999756,46.6750839 17.7446915,46.6675011 C17.4904227,46.6603175 17.2349602,46.6555283 16.9790998,46.6559274 C16.7745706,46.6563265 16.5692456,46.6567256 16.3639206,46.6567256 L15.746354,46.6567256 C15.5398352,46.6567256 15.3337144,46.6567256 15.1267977,46.6571247 C14.920279,46.6575238 14.7129644,46.6579229 14.5068435,46.658322 C14.2310873,46.6591202 13.9589123,46.6587211 13.6899206,46.6579229 C13.4937477,46.6571247 13.2983706,46.6563265 13.1041873,46.6563265 C12.910004,46.6563265 12.7166165,46.6567256 12.522831,46.658322 C12.3194956,46.6595193 12.1042227,46.6659048 11.9267519,46.774059 C11.749281,46.8818141 11.6318956,47.1244626 11.725804,47.3172245 C11.8336394,47.5371247 12.1161602,47.5650612 12.3445644,47.5646621 C12.5379519,47.564263 12.7309415,47.5646621 12.923931,47.5658594",id:"Fill-75",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:66}}),_react2.default.createElement("path",{d:"M12.8022879,45.9761125 C13.0028379,45.9757134 13.2033879,45.9761125 13.4047338,45.9773098 C13.6056817,45.9789061 13.8082213,45.9809016 14.0123525,45.9828971 C14.2164838,45.9848925 14.4218088,45.986888 14.6283275,45.9888834 C14.8344483,45.9908789 15.041365,45.9924753 15.2478838,45.9940717 C15.4548004,45.9952689 15.6617171,45.9964662 15.86744,45.9972644 C16.2108421,45.9988608 16.5534483,46.000058 16.894065,46.0004571 C17.2354775,46.0008562 17.5752983,46.0008562 17.9151192,46.0008562 C18.2545421,46.0008562 18.593965,46.0008562 18.93299,46.0004571 C19.272015,46.000058 19.6090504,45.9992599 19.9425046,45.9976635 C20.2763567,45.9952689 20.6010567,45.9944707 20.9166046,45.9948698 C21.2317546,45.9952689 21.5405379,45.9968653 21.84574,45.9988608 C22.1254754,46.0008562 22.5838754,45.9377995 22.6761921,45.5746249 C22.7231463,45.3914413 22.5779067,45.2158404 22.4056088,45.1487927 C22.2599713,45.0937179 22.0996108,45.0945161 21.9432296,45.0969107 C21.6157442,45.1028971 21.2858713,45.1152689 20.9500296,45.1268426 C20.6133921,45.1388154 20.26999,45.1511873 19.9230067,45.1559764 C19.6743088,45.1599673 19.4244171,45.1587701 19.1737296,45.1551782 C18.92344,45.1523846 18.6719567,45.1448018 18.4188817,45.13682 C18.1658067,45.1288381 17.9127317,45.119659 17.6588608,45.1128744 C17.40499,45.1060898 17.1507213,45.1013007 16.8952588,45.1016998 C16.6907296,45.1016998 16.4862004,45.1016998 16.2804775,45.1013007 C16.0755504,45.1005025 15.8690317,45.1001034 15.6625129,45.0989061 C15.4559942,45.0977088 15.2494754,45.0961125 15.0433546,45.094117 C14.8368358,45.0921215 14.6311129,45.0901261 14.42539,45.0877315 C14.1512254,45.0849379 13.8778567,45.0817451 13.6044879,45.0793506 C13.4023463,45.0777542 13.2006025,45.0773551 12.9996546,45.0773551 C12.7983088,45.0777542 12.5973608,45.0789515 12.3968108,45.0809469 C12.1867108,45.0837406 11.9646733,45.0909243 11.7788463,45.2006748 C11.5934171,45.3100263 11.4668796,45.5546703 11.5619817,45.7458358 C11.670215,45.9637406 11.9634796,45.9860898 12.2006379,45.982498 C12.4015858,45.9789061 12.6021358,45.9769107 12.8022879,45.9761125",id:"Fill-77",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:67}}),_react2.default.createElement("path",{d:"M12.0830138,44.4031274 C12.2895325,44.3999347 12.4944596,44.3987374 12.6997846,44.3987374 C12.9047117,44.3983383 13.1092408,44.3995356 13.31377,44.4015311 C13.5182992,44.4039256 13.7228283,44.4067193 13.9277554,44.409912 C14.1322846,44.4127057 14.3372117,44.4158984 14.5425367,44.4190912 C14.7474638,44.4222839 14.9531867,44.4254766 15.1589096,44.4278712 C15.3650304,44.4302658 15.5711513,44.4326603 15.7772721,44.4346558 C15.9837908,44.4362522 16.1891158,44.4378485 16.3944408,44.4390458 C16.6001638,44.4402431 16.804295,44.4410413 17.0084263,44.4414404 C17.2129554,44.4418395 17.4162908,44.4418395 17.6196263,44.4414404 C17.8229617,44.4414404 18.0262971,44.4406422 18.2284388,44.4402431 C18.4309783,44.4394449 18.6327221,44.4382476 18.8332721,44.4370503 C19.0334242,44.4362522 19.2327804,44.4362522 19.4309429,44.4378485 C19.6291054,44.4390458 19.8260742,44.4418395 20.022645,44.4454313 C20.2188179,44.4494222 20.4149908,44.4542113 20.6111638,44.4593995 C20.8065408,44.4641887 21.0011221,44.4693769 21.1945096,44.4749642 C21.388295,44.4801524 21.5804888,44.4849415 21.7714888,44.4897306 C22.0635596,44.4961161 22.5398658,44.4362522 22.6246221,44.0674902 C22.6675971,43.8815129 22.5092263,43.7011229 22.3269804,43.6304834 C22.1725888,43.5730141 22.0062596,43.5722159 21.8443075,43.572615 C21.5056804,43.5738122 21.1674513,43.581395 20.8288242,43.5881796 C20.4901971,43.5945651 20.1495804,43.6009506 19.8069742,43.6005515 C19.5614596,43.6001524 19.3151492,43.5957624 19.0672471,43.5893769 C18.8189471,43.5829914 18.5686575,43.5758077 18.3163783,43.5674268 C18.0637013,43.559844 17.8110242,43.5502658 17.5567554,43.5434812 C17.3028846,43.5362975 17.0482179,43.5311093 16.7919596,43.5307102 C16.5189888,43.5307102 16.24562,43.529912 15.9714554,43.5287147 C15.6972908,43.5271184 15.4235242,43.5251229 15.1493596,43.5223293 C14.8759908,43.5191365 14.6026221,43.5159438 14.3300492,43.512751 C14.0574763,43.5091592 13.7856992,43.5051683 13.5151158,43.5015764 C13.3145658,43.4991819 13.11322,43.4971864 12.9118742,43.4959891 C12.7105283,43.4947918 12.5087846,43.4943927 12.3070408,43.4947918 C12.0953492,43.4947918 11.8729138,43.4991819 11.6827096,43.6073361 C11.4929033,43.7150912 11.3540304,43.9625288 11.44197,44.1588825 C11.542245,44.3819755 11.8398867,44.4063202 12.0830138,44.4031274",id:"Fill-79",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:68}}),_react2.default.createElement("path",{d:"M88.4950706,54.6941787 C88.4421477,54.6857977 88.3896227,54.6786141 88.3374956,54.6714304 C88.1807165,54.6510766 88.0243352,54.6351129 87.8667602,54.6239383 C87.7091852,54.6127637 87.5492227,54.6075755 87.385679,54.6087728 C87.2217373,54.609571 87.0526227,54.6171537 86.8803248,54.626732 C86.7080269,54.6367093 86.535331,54.6462875 86.3666144,54.6554667 C86.2432602,54.6622512 86.1238852,54.6590585 86.0112748,54.6574621 C85.8986644,54.6562649 85.7912269,54.6566639 85.6925435,54.6714304 C85.5934623,54.6861968 85.5023394,54.7157297 85.4207665,54.7712036 C85.3391935,54.8266776 85.2671706,54.9088907 85.2042998,55.030215 C85.1668956,55.103249 85.1895769,55.1990313 85.2349394,55.2644825 C85.3411831,55.4233215 85.4677206,55.4987501 85.6065935,55.5310766 C85.7458644,55.5630041 85.8998581,55.5506322 86.0586269,55.5358658 C86.1648706,55.5262875 86.2742977,55.5151129 86.3813373,55.5147138 C86.5027019,55.5131175 86.6248623,55.515512 86.7478185,55.5183057 C86.8707748,55.5210993 86.994129,55.5254893 87.1158915,55.5278839 C87.237654,55.5306776 87.3582227,55.5334712 87.4783935,55.5338703 C87.5973706,55.5350676 87.7155519,55.5354667 87.8333352,55.5334712 C88.0422415,55.5286821 88.2555248,55.5290812 88.4497081,55.4644281 C88.6434935,55.3997751 88.8185769,55.2549043 88.8448394,55.0585506 C88.8567769,54.9683556 88.8332998,54.8637932 88.760481,54.7947501 C88.6896519,54.7273034 88.588581,54.708546 88.4950706,54.6941787",id:"Fill-81",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:69}}),_react2.default.createElement("path",{d:"M186.999222,41.1448925 C186.981316,41.065473 186.948289,40.9856544 186.89656,40.9233959 C186.869103,40.8898721 186.835678,40.8623347 186.796682,40.841981 C186.706753,40.7964844 186.60051,40.8004753 186.499439,40.8052644 C186.279391,40.816439 186.060935,40.8192327 185.842876,40.8196317 C185.648295,40.8200308 185.399199,40.8044662 185.217749,40.8814912 C184.907374,41.0131918 184.801528,41.5284209 185.216555,41.5368018 C185.68928,41.5471782 186.16678,41.5451828 186.640301,41.5236317 C186.71113,41.520439 186.784347,41.5164481 186.84881,41.4853188 C186.978132,41.4226612 187.02827,41.2769923 186.999222,41.1448925",id:"Fill-83",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:70}}),_react2.default.createElement("path",{d:"M135.251035,55.0932717 C135.198112,55.0848907 135.145189,55.077707 135.093062,55.0705234 C134.936681,55.0501696 134.7803,55.0342059 134.622725,55.0230313 C134.464752,55.0122558 134.305187,55.0066685 134.141245,55.0078658 C133.977702,55.009063 133.808587,55.0166458 133.635891,55.0258249 C133.463991,55.0358023 133.291295,55.0453805 133.122579,55.0545596 C132.999225,55.0613442 132.87985,55.0581515 132.767239,55.0565551 C132.654231,55.0553578 132.547191,55.056156 132.44811,55.0709224 C132.349427,55.0856889 132.258304,55.1148227 132.176333,55.1702966 C132.095158,55.2257705 132.022737,55.3079837 131.960264,55.4293079 C131.922462,55.502342 131.945541,55.5981243 131.990904,55.6635755 C132.097148,55.8224145 132.223287,55.8982422 132.36216,55.9301696 C132.501431,55.9620971 132.655823,55.9497252 132.814591,55.9353578 C132.920437,55.9253805 133.029864,55.9142059 133.137302,55.9138068 C133.258268,55.9122104 133.380827,55.914605 133.503385,55.9173986 C133.626739,55.9201923 133.749695,55.9245823 133.871458,55.9269769 C133.99322,55.9297705 134.114187,55.9325642 134.23396,55.9329633 C134.353335,55.9345596 134.471516,55.9345596 134.5893,55.9325642 C134.798206,55.9277751 135.011489,55.9281741 135.205673,55.8635211 C135.399458,55.798868 135.574541,55.6539973 135.600804,55.4576435 C135.612741,55.3674485 135.589264,55.2628862 135.516445,55.1938431 C135.445218,55.1263964 135.344148,55.107639 135.251035,55.0932717",id:"Fill-85",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:71}}),_react2.default.createElement("path",{d:"M178.556346,58.4547918 C178.894177,58.4504018 179.242354,58.4615764 179.594112,58.4779392 C179.695183,58.4823293 179.79705,58.4887147 179.898519,58.494302 C179.889366,58.4372317 179.879021,58.3821569 179.871062,58.3238893 C179.806998,57.8697215 179.769991,57.3732499 179.735771,56.858819 C179.701152,56.3443882 179.670512,55.8131955 179.621171,55.2943746 C179.571431,54.7759528 179.505775,54.2750912 179.402714,53.8145379 C179.296471,53.3392181 179.173912,52.8778667 179.034641,52.4312816 C178.895769,51.9850957 178.740581,51.5584653 178.571069,51.1569778 C178.401556,50.7558893 178.217321,50.3847329 178.017169,50.0251501 C177.816619,49.6659664 177.60055,49.3135673 177.368166,48.9703474 C177.1326,48.6223383 176.888279,48.2882975 176.634408,47.9754086 C176.381731,47.6609234 176.117912,47.3691864 175.84335,47.1017941 C175.568389,46.8332045 175.281889,46.5901569 174.983452,46.3710549 C174.685014,46.1515537 174.375833,45.9559982 174.056306,45.7831909 C173.800844,45.6451048 173.538616,45.5221841 173.270023,45.4136308 C173.001827,45.3054766 172.727662,45.2108916 172.447529,45.131073 C172.167794,45.0512544 171.882885,44.9854041 171.592406,44.9339211 C171.302325,44.882039 171.006673,44.8441252 170.706644,44.8201796 C170.406614,44.7958349 170.100616,44.7858576 169.789446,44.7910458 C169.048525,44.8026195 168.345406,44.8696671 167.681681,44.9858032 C167.017956,45.1019392 166.394819,45.2867193 165.809483,45.5457306 C165.224148,45.805141 164.675819,46.1343927 164.16171,46.5271002 C163.647204,46.9202068 163.169306,47.3731773 162.732394,47.8756354 C162.296277,48.3780934 161.904329,48.9236535 161.560529,49.4979483 C161.217127,50.0722431 160.919485,50.6740753 160.668798,51.2874812 C160.41811,51.9008871 160.216366,52.5198803 160.063566,53.1444608 C159.951752,53.6038168 159.866996,54.0691592 159.805319,54.5396898 C159.720562,55.2389007 159.683158,55.9480889 159.689127,56.6520889 C159.693902,57.2120163 159.73051,57.7707465 159.783831,58.326683 C159.726929,58.3606059 159.679179,58.4076989 159.645356,58.4619755 C160.6111,58.4404245 161.564906,58.4200707 162.467381,58.4037079 C163.369856,58.3877442 164.221398,58.3757714 164.982214,58.3713814 C166.504246,58.3633995 167.66855,58.3857488 168.159181,58.4396263 C168.765606,58.5817034 169.503741,58.4962975 170.123298,58.5046785 C171.318639,58.5202431 172.512787,58.5150549 173.706537,58.507073 C174.095302,58.5042794 174.484066,58.5006875 174.872433,58.4966966 C175.267166,58.4931048 175.6619,58.4891138 176.064194,58.4843247 C176.466885,58.4795356 176.877137,58.4751456 177.293358,58.4699574 C177.709579,58.4647692 178.131371,58.45998 178.556346,58.4547918",id:"Fill-87",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:72}}),_react2.default.createElement("path",{d:"M47.2442435,55.230839 C47.1933102,54.8373333 47.1387956,54.4422313 47.0731394,54.0471293 C47.0074831,53.6516281 46.9306852,53.256127 46.8335935,52.8610249 C46.7365019,52.4655238 46.6195144,52.0704218 46.4754685,51.6769161 C46.3314227,51.2830113 46.1619102,50.8907029 45.9609623,50.5011882 C45.761606,50.1136689 45.5463331,49.740517 45.3183269,49.3849252 C45.0907185,49.0289342 44.8519685,48.6901043 44.6044644,48.3708299 C44.3569602,48.0515556 44.0975185,47.7522358 43.8241498,47.4748662 C43.551179,47.1978957 43.264679,46.9424762 42.9662415,46.7118005 C42.667406,46.4811247 42.357429,46.2747937 42.0339227,46.0944036 C41.7108144,45.9140136 41.3709935,45.7603628 41.0136644,45.6330522 C40.6531519,45.4191383 40.2822935,45.2355556 39.9090477,45.0898866 C39.5361998,44.9438186 39.1609644,44.8352653 38.7912998,44.7706122 C35.810506,44.2513923 32.7525165,45.3788299 30.6706165,47.5151746 C27.9727415,50.2820862 26.422856,54.9590567 27.8824144,58.3605261 C34.086731,58.4231837 44.1603894,58.4998095 47.3083081,58.3613243 C47.4181331,57.917932 47.4459873,57.445805 47.4308665,56.9748753 C47.4105727,56.3674558 47.313481,55.7628299 47.2442435,55.230839",id:"Fill-89",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:73}}),_react2.default.createElement("path",{d:"M71.0383869,58.0930939 C71.0435598,57.9957152 71.0491306,57.8991347 71.0495285,57.8001596 C71.052314,57.2182821 70.9775056,56.6060735 70.9178181,56.0493388 C70.8740473,55.6370757 70.8195327,55.2104454 70.7522848,54.7726404 C70.6854348,54.3348354 70.6066473,53.8878512 70.5091577,53.4348807 C70.4116681,52.9819102 70.2958744,52.5269442 70.1558077,52.0743728 C70.016139,51.6218014 69.853789,51.1772118 69.662789,50.7406041 C69.476564,50.3163683 69.2736265,49.916078 69.0587515,49.5461188 C68.8398973,49.177756 68.6095035,48.8337379 68.3675702,48.5132662 C68.1268306,48.19479 67.8705723,47.8994612 67.5979994,47.628078 C67.3258244,47.357493 67.0377327,47.1080599 66.7345202,46.8801778 C66.4309098,46.6522957 66.1117806,46.4459646 65.775541,46.2615837 C65.4396994,46.0776018 65.0819723,45.9139737 64.7027577,45.7762866 C64.3080244,45.5635701 63.903741,45.3859737 63.5006515,45.2506812 C63.097164,45.1153887 62.6952681,45.0204045 62.3033202,44.9713161 C61.7768765,44.9054658 61.2512285,44.8827175 60.7319473,44.8998785 C60.2118702,44.9166404 59.696966,44.9761052 59.1916119,45.0718875 C58.6858598,45.1680689 58.1916473,45.2933841 57.7173306,45.4422458 C57.2434119,45.5911075 56.7870015,45.7635156 56.3508848,45.9562776 C55.9147681,46.1490395 55.4969556,46.3693388 55.0998348,46.6207673 C54.702714,46.8721959 54.3246931,47.1547537 53.9693535,47.4740281 C53.5809869,47.8228354 53.2053535,48.2311075 52.8492181,48.6836789 C52.4938785,49.1362503 52.1592306,49.6319238 51.856814,50.1535383 C51.5539994,50.6751528 51.2846098,51.2259011 51.049839,51.8333206 C50.8142723,52.4415383 50.6177015,53.0988444 50.4692785,53.7940644 C50.3948681,54.1416744 50.3351806,54.4980644 50.2890223,54.8600417 C50.2432619,55.222019 50.2118265,55.5887855 50.1955119,55.9563501 C50.1787994,56.3231166 50.1772077,56.6846948 50.1907369,57.0354975 C50.204664,57.3863002 50.233314,57.7267265 50.2774827,58.0515882 C50.2834515,58.093493 50.2914098,58.132205 50.2973785,58.1725134 C55.5104848,57.9761596 67.1929202,57.9067175 67.1929202,57.9067175 C67.771889,57.9761596 69.1005327,58.03762 71.0383869,58.0930939",id:"Fill-91",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:74}}),_react2.default.createElement("path",{d:"M163.207387,51.8903909 C163.051801,52.2228354 162.920091,52.5584726 162.808674,52.8925134 C162.697655,53.2269533 162.605737,53.5625905 162.53252,53.9018195 C162.458905,54.2414476 162.403197,54.582273 162.364997,54.9207039 C162.326001,55.2591347 162.303718,55.5931755 162.297749,55.9188354 C162.291383,56.2440961 162.303718,56.5637696 162.333562,56.8790531 C162.356243,57.1201052 162.387678,57.3587628 162.42946,57.5946268 C162.470843,57.8304907 162.52297,58.0631619 162.587433,58.2906449 C162.655476,58.5145361 162.738243,58.7312435 162.837324,58.939171 C162.936405,59.1478966 163.051801,59.3482413 163.181522,59.5422005 C163.357799,59.8000145 163.557155,60.0494476 163.775612,60.2920961 C163.994068,60.5347447 164.226053,60.7730032 164.467987,61.0076698 C164.70992,61.2423365 164.960608,61.4738104 165.222835,61.6969034 C165.443678,61.892459 165.673674,62.0812299 165.914016,62.2584272 C166.07557,62.377756 166.240308,62.4875066 166.407433,62.5876789 C166.574558,62.6882503 166.744468,62.7788444 166.918358,62.8590621 C167.266137,63.0202957 167.625853,63.1400236 167.990345,63.2202413 C168.23586,63.2729215 168.482568,63.3152254 168.730868,63.3483501 C168.979566,63.3810757 169.229458,63.4046222 169.478951,63.416595 C169.728445,63.4281687 169.977541,63.4289669 170.225841,63.4181914 C170.474539,63.4070168 170.722839,63.3846676 170.971139,63.3515429 C171.218643,63.3184181 171.464953,63.2753161 171.709274,63.2218376 C171.988612,63.1603773 172.265164,63.0829533 172.534951,62.9891664 C172.805535,62.8953796 173.069353,62.7876245 173.32601,62.665502 C173.58187,62.5429805 173.830966,62.4060916 174.071705,62.2520417 C174.338708,62.0812299 174.594568,61.8892662 174.837695,61.6765497 C175.081618,61.4622367 175.313205,61.2275701 175.533651,60.974146 C175.753699,60.7211211 175.963401,60.4505361 176.157585,60.1607946 C176.352166,59.8694567 176.521678,59.5633524 176.665326,59.2432798 C176.80977,58.9236063 176.926758,58.5923592 177.01987,58.2563229 C177.11338,57.9103093 177.187791,57.5607039 177.244693,57.209502 C177.301993,56.8583002 177.340193,56.5082957 177.357303,56.1634794 C177.374414,55.8190621 177.370037,55.4786358 177.343376,55.1433977 C177.317512,54.8081596 177.270558,54.4781098 177.205697,54.1560417 C177.140837,53.8339737 177.056876,53.5202866 176.953816,53.2161778 C176.850358,52.912468 176.727799,52.6171392 176.586141,52.3333841 C176.444483,52.0500281 176.283724,51.7770485 176.102672,51.5108535 C175.921222,51.2442594 175.719478,50.9840508 175.501022,50.7322231 C175.280974,50.4784 175.043418,50.2313615 174.789149,49.9903093 C174.535278,49.7500553 174.263899,49.5189805 173.975808,49.3070621 C173.729099,49.1322594 173.477616,48.9762141 173.217776,48.8373297 C172.958335,48.6980463 172.690935,48.5739283 172.417566,48.4653751 C172.144197,48.3568218 171.866451,48.2638331 171.585522,48.18601 C171.304593,48.1077878 171.021674,48.0459283 170.739153,48.0004317 C170.45703,47.9549351 170.174908,47.9258014 169.891989,47.9150259 C169.609468,47.9038512 169.324958,47.9082413 169.041243,47.9262005 C168.697045,47.9521415 168.353643,47.9988354 168.009445,48.0690757 C167.668033,48.138917 167.32861,48.2319057 166.995951,48.3504363 C166.662895,48.4689669 166.336603,48.6134385 166.023841,48.7830531 C165.71068,48.9526676 165.41662,49.1454295 165.142853,49.3641324 C164.869883,49.5828354 164.614818,49.825883 164.380843,50.0904816 C164.14647,50.3546812 163.931993,50.6380372 163.736218,50.9389533 C163.540841,51.2390712 163.362972,51.5575474 163.207387,51.8903909",id:"Fill-93",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:75}}),_react2.default.createElement("path",{d:"M172.83319,58.4547918 C172.675217,58.6311909 172.503715,58.7840435 172.320673,58.9125515 C172.137631,59.0418576 171.944244,59.1480163 171.746877,59.2354177 C171.548715,59.3232181 171.347767,59.3942567 171.144829,59.451327 C170.94229,59.5087964 170.737761,59.5546921 170.532038,59.5838259 C170.3291,59.6225379 170.120194,59.6392998 169.906513,59.6373043 C169.58619,59.6341116 169.254327,59.5782385 168.92525,59.4573134 C168.589011,59.339581 168.260729,59.1607873 167.950354,58.9253224 C167.640377,58.6898576 167.368998,58.4144834 167.137809,58.1115719 C166.907415,57.8082612 166.718802,57.4730231 166.579134,57.1154358 C166.48244,56.879971 166.408825,56.6341297 166.357494,56.3831002 C166.305367,56.1312726 166.273534,55.8718621 166.260402,55.6112544 C166.247669,55.3506467 166.254434,55.090039 166.281492,54.8330231 C166.308948,54.5760073 166.360677,54.3221841 166.439067,54.077141 C166.517059,53.8324971 166.622506,53.5990277 166.755013,53.3811229 C166.887917,53.162819 167.042706,52.9688599 167.218984,52.793658 C167.395261,52.6184562 167.592229,52.4612136 167.803921,52.3263202 C168.016409,52.1910277 168.244017,52.0780844 168.483165,51.9898848 C168.722711,51.9008871 168.976184,51.8354358 169.243584,51.7919347 C169.511381,51.7480345 169.791515,51.7248871 170.076423,51.7232907 C170.361729,51.7220934 170.649025,51.7452408 170.933536,51.8015129 C171.216852,51.8581841 171.494996,51.9511728 171.758417,52.0776853 C172.022236,52.2041977 172.268546,52.3634358 172.492573,52.5557986 C172.714611,52.746166 172.904417,52.9636717 173.061594,53.2007329 C173.244636,53.4757079 173.386692,53.7702385 173.488559,54.0743474 C173.590823,54.3792544 173.656479,54.6933406 173.688711,55.0150095 C173.720544,55.330293 173.719748,55.6583474 173.693884,55.9872 C173.673988,56.2342385 173.646134,56.4772862 173.607536,56.7087601 C173.569734,56.9406331 173.517209,57.1613315 173.449563,57.3688599 C173.381519,57.5763882 173.297559,57.7715447 173.194896,57.9519347 C173.092234,58.1327238 172.971267,58.3003429 172.83319,58.4547918",id:"Fill-95",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:76}}),_react2.default.createElement("g",{id:"Group-99",transform:"translate(52.729167, 47.551293)",__source:{fileName:_jsxFileName,lineNumber:77}},_react2.default.createElement("mask",{id:"mask-6",fill:"white",__source:{fileName:_jsxFileName,lineNumber:78}},_react2.default.createElement("use",{xlinkHref:"#path-5",__source:{fileName:_jsxFileName,lineNumber:79}})),_react2.default.createElement("g",{id:"Clip-98",__source:{fileName:_jsxFileName,lineNumber:81}}),_react2.default.createElement("path",{d:"M1.03056438,4.33909841 C0.868214375,4.67194195 0.730137292,5.00757914 0.612353958,5.34281723 C0.494570625,5.67765624 0.397081042,6.0144907 0.317497708,6.3553161 C0.238312292,6.6957424 0.176635208,7.03856327 0.132466458,7.37898957 C0.088695625,7.71981497 0.061239375,8.05585125 0.050495625,8.38390567 C0.039751875,8.71196009 0.0477102083,9.03402812 0.0739727083,9.35210522 C0.0938685417,9.59515283 0.122916458,9.83620499 0.161912292,10.0744635 C0.200908125,10.312722 0.251045625,10.5477878 0.313518542,10.7772662 C0.379572708,11.0035519 0.461145625,11.222654 0.559033125,11.4333751 C0.657716458,11.6444952 0.771918542,11.8472345 0.900843542,12.0439873 C1.07632479,12.3053932 1.27528313,12.558019 1.49373937,12.8038603 C1.71179771,13.0497016 1.94418104,13.2915519 2.18651229,13.5290122 C2.42924146,13.7664726 2.68032687,14.0015383 2.94334979,14.2274249 C3.16459146,14.4257741 3.39538313,14.6165406 3.63652063,14.7953342 C3.79926854,14.9162594 3.96440396,15.0272073 4.13272271,15.1281778 C4.30064354,15.2295474 4.47174771,15.3213388 4.64722896,15.4023546 C4.99739562,15.5643864 5.35949979,15.6849125 5.72717479,15.7647311 C5.97507687,15.8170122 6.22417271,15.8585179 6.47565604,15.8908444 C6.72634354,15.923171 6.97941854,15.9451211 7.23249354,15.9558966 C7.48556854,15.9670712 7.73864354,15.966273 7.99211646,15.9539011 C8.24598729,15.9411302 8.49985813,15.9171846 8.75492271,15.8820644 C9.00919146,15.8469442 9.26306229,15.8026449 9.51573938,15.7467719 C9.80462688,15.6837152 10.0915248,15.6038966 10.3736477,15.5077152 C10.6557706,15.4119329 10.9335165,15.3017832 11.2040998,15.1772662 C11.475081,15.0531483 11.7396956,14.9134658 11.9975456,14.7578195 C12.2832498,14.5850122 12.5605977,14.3910531 12.8256102,14.175942 C13.0918165,13.9600327 13.346881,13.7237696 13.5923956,13.4695474 C13.838706,13.2149261 14.0742727,12.9435429 14.2963102,12.6526041 C14.5187456,12.3608671 14.7169081,12.0539646 14.8884102,11.7338921 C15.0607081,11.4142186 15.2055498,11.0825723 15.3261185,10.7477333 C15.4466873,10.4017197 15.5473602,10.0529125 15.629331,9.70250884 C15.7120977,9.35250431 15.772979,9.00369705 15.811179,8.65967891 C15.8485831,8.31645896 15.8625102,7.97683084 15.8529602,7.64279002 C15.8430123,7.30835011 15.8095873,6.97949751 15.7554706,6.65822766 C15.701354,6.33655873 15.6257498,6.02327075 15.5274644,5.7191619 C15.429179,5.41505306 15.3086102,5.12012336 15.1657581,4.83596916 C15.0237019,4.55181497 14.8593623,4.27843628 14.6715456,4.01144308 C14.483729,3.74405079 14.2724352,3.4826449 14.0416435,3.22922086 C13.8096581,2.97420045 13.5577769,2.72556553 13.2871935,2.4833161 C13.0162123,2.24066757 12.726131,2.00759728 12.4165519,1.79408254 C12.1523352,1.61768345 11.8821498,1.45964263 11.6032102,1.3191619 C11.3246685,1.17828209 11.0373727,1.0525678 10.7437102,0.942019048 C10.4504456,0.831869388 10.1520081,0.737284354 9.85078521,0.657066667 C9.54916438,0.577647166 9.24634979,0.514191383 8.94472896,0.467497506 C8.64310812,0.420404535 8.34188521,0.389674376 8.04066229,0.377302494 C7.73943938,0.364930612 7.43781854,0.368123356 7.13619771,0.384885261 C6.77130812,0.409229932 6.40761229,0.454726531 6.04431437,0.523769615 C5.68340396,0.592413605 5.32647271,0.684604082 4.97670396,0.802336508 C4.62653729,0.920068934 4.28552271,1.0637424 3.95843521,1.23295782 C3.63134771,1.40217324 3.32534979,1.59453605 3.04083937,1.81283991 C2.75672687,2.03154286 2.49290813,2.27459048 2.24978104,2.53918912 C2.00705188,2.80338866 1.78501437,3.08674467 1.58128104,3.38766077 C1.37834354,3.68777868 1.19291437,4.00625488 1.03056438,4.33909841",id:"Fill-97",fill:"#C5168C",mask:"url(#mask-6)",__source:{fileName:_jsxFileName,lineNumber:82}})),_react2.default.createElement("path",{d:"M63.648955,58.4999692 C63.47228,58.6771664 63.2820758,58.8308172 63.0823217,58.9601234 C62.8821696,59.0902277 62.6724675,59.1971846 62.45998,59.2857832 C62.2470946,59.3739828 62.0314237,59.4458195 61.8157529,59.503688 C61.6000821,59.5615565 61.3832175,59.6082503 61.165955,59.6381823 C60.95108,59.6772934 60.73143,59.6944544 60.5081987,59.692858 C60.1731529,59.6896653 59.8285571,59.6345905 59.48993,59.512468 C59.1445383,59.3935383 58.8086967,59.2131483 58.4939446,58.9752889 C58.1791925,58.7378286 57.9058237,58.4600599 57.6750321,58.1539556 C57.4446383,57.8470531 57.2580154,57.5090213 57.1227237,57.1474431 C57.0284175,56.9099828 56.9587821,56.662146 56.9110321,56.4083229 C56.86368,56.1544998 56.8370196,55.8930939 56.830255,55.6304907 C56.8234904,55.3674884 56.8362237,55.1052844 56.8708425,54.8466721 C56.9058592,54.5876608 56.9651487,54.3326404 57.0526904,54.0864 C57.1398342,53.8405587 57.2556279,53.6062912 57.3992758,53.3875882 C57.5433217,53.1696834 57.7108446,52.9749261 57.9006508,52.7997243 C58.0900592,52.6245224 58.3017508,52.468078 58.5289612,52.3335837 C58.7565696,52.1986902 59.0004925,52.0869442 59.2571487,51.9991438 C59.513805,51.9113433 59.7855821,51.8470893 60.0728779,51.8047855 C60.3597758,51.7620825 60.6606008,51.7405315 60.9665987,51.7405315 C61.2721987,51.7405315 61.5805842,51.7652753 61.8845925,51.8235429 C62.1886008,51.8814113 62.4850487,51.9763955 62.76558,52.1045043 C63.0461112,52.2322141 63.3075425,52.3926494 63.5431092,52.5866086 C63.7770842,52.7777741 63.9752467,52.9964771 64.1375967,53.2343365 C64.3254133,53.5101098 64.4682654,53.8046404 64.5661529,54.1099465 C64.6644383,54.4152526 64.7213404,54.730137 64.7412362,55.0514068 C64.7611321,55.3670893 64.7444196,55.695942 64.6998529,56.0255927 C64.6664279,56.2722322 64.6234529,56.5156789 64.5697342,56.747951 C64.5164133,56.9802231 64.4483696,57.2017197 64.3644092,57.4100463 C64.2800508,57.6179737 64.1797758,57.8135293 64.0607987,57.9947175 C63.9414237,58.1759057 63.8041425,58.3443229 63.648955,58.4999692",id:"Fill-100",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:84}}),_react2.default.createElement("path",{d:"M31.5265352,60.6665651 C31.785181,60.9287692 32.0541727,61.1694222 32.3291331,61.3901206 C32.6036956,61.6112181 32.8866144,61.8135583 33.1782873,61.9999347 C33.470756,62.1867102 33.7707852,62.3559256 34.0739977,62.5091773 C34.378006,62.6620299 34.6844019,62.7973224 34.9884102,62.9138576 C35.2928165,63.0307918 35.5988144,63.1265741 35.9071998,63.2032 C36.1435623,63.2618667 36.3807206,63.3109551 36.6190727,63.3488689 C36.8574248,63.3863837 37.0969706,63.4131229 37.3361185,63.4250957 C37.5732769,63.4326785 37.8088435,63.422302 38.0424206,63.3935673 C38.2759977,63.3652317 38.5079831,63.3177397 38.7383769,63.2538848 C39.0459665,63.164488 39.353556,63.0491501 39.659554,62.9110639 C39.9663477,62.7733769 40.2723456,62.6201252 40.5775477,62.4545016 C40.8831477,62.2892771 41.187156,62.1144744 41.4863894,61.9257034 C41.7454331,61.7700571 41.9997019,61.6024381 42.2456144,61.421649 C42.4115456,61.2995265 42.5691206,61.1722159 42.7175435,61.0389188 C42.8663644,60.9060209 43.0072269,60.7667374 43.1385394,60.6206694 C43.4011644,60.3281342 43.627579,60.0108553 43.8173852,59.6752181 C43.9435248,59.4485333 44.0597165,59.2182567 44.1675519,58.98359 C44.2749894,58.7489234 44.3728769,58.5102658 44.4592248,58.2688145 C44.5455727,58.0277624 44.6199831,57.7831184 44.682854,57.5360798 C44.7457248,57.2894404 44.7962602,57.03881 44.8364498,56.785785 C44.8766394,56.5339574 44.906881,56.2801342 44.9255831,56.0251138 C44.9474685,55.7341751 44.9518456,55.4408417 44.9395102,55.1487057 C44.9275727,54.8561705 44.8997185,54.5656308 44.8563456,54.2774857 C44.8133706,53.9901388 44.7536831,53.7043882 44.6764873,53.4214313 C44.5905373,53.106946 44.481906,52.7956535 44.3505935,52.4903474 C44.2180873,52.1830458 44.0628998,51.8805333 43.8890102,51.5824109 C43.7151206,51.2838893 43.5233248,50.9893587 43.3108373,50.7020118 C43.097554,50.4142658 42.8627831,50.1440798 42.6085144,49.8942476 C42.3534498,49.6440163 42.0792852,49.4153361 41.7919894,49.2078077 C41.4967352,48.9958893 41.1911352,48.801132 40.8791685,48.6215401 C40.5672019,48.4423474 40.2504602,48.2823111 39.9325248,48.1450231 C39.6145894,48.0077351 39.2938685,47.8943927 38.9699644,47.8045968 C38.6464581,47.7152 38.3205644,47.6485515 37.9962623,47.6038531 C37.6715623,47.5583565 37.348454,47.5368054 37.0277331,47.5392 C36.7074102,47.5419937 36.3890769,47.5687329 36.0755185,47.6194177 C35.7623581,47.6705016 35.452779,47.745132 35.1447915,47.8437079 C34.8356102,47.9422839 34.5280206,48.0640073 34.2240123,48.2060844 C33.9184123,48.3489596 33.6155977,48.5109914 33.3159665,48.6909823 C33.0163352,48.8709732 32.7222748,49.0701206 32.4417435,49.2932136 C32.2085644,49.4843791 31.9916998,49.6867193 31.7883644,49.9014313 C31.585029,50.1157442 31.394029,50.3420299 31.2153644,50.578293 C31.0370977,50.8141569 30.8707685,51.0588009 30.7171727,51.3102295 C30.5635769,51.5620571 30.4239081,51.8198712 30.2981665,52.0812771 C30.1732206,52.3434812 30.0625998,52.6096762 29.9682935,52.8810594 C29.8739873,53.1528417 29.7936081,53.4306104 29.7247685,53.7115719 C29.6443894,54.0539937 29.5831102,54.4020027 29.5421248,54.7571955 C29.5011394,55.1107918 29.4816415,55.4691773 29.4856206,55.8299574 C29.4899977,56.1907374 29.5186477,56.5531138 29.5731623,56.9118984 C29.6280748,57.270683 29.7092498,57.6186921 29.8202685,57.9555265 C29.9312873,58.292361 30.0725477,58.618819 30.2404685,58.932107 C30.4079915,59.2457941 30.6005831,59.5471093 30.815856,59.8368508 C31.0303331,60.1257941 31.2678894,60.404361 31.5265352,60.6665651",id:"Fill-102",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:85}}),_react2.default.createElement("path",{d:"M40.4773125,53.2790349 C40.6098188,53.4797787 40.7160625,53.687307 40.7964417,53.8988263 C40.8764229,54.1099465 40.9321313,54.3254567 40.9683417,54.5397696 C41.0045521,54.7540825 41.02405,54.9683955 41.0300188,55.1807129 C41.0359875,55.3930304 41.0304167,55.6041506 41.0077354,55.8132753 C40.9950021,56.0231982 40.9595875,56.2323229 40.9038792,56.4422458 C40.8203167,56.756332 40.6834333,57.0672254 40.4832813,57.3557696 C40.2831292,57.6550893 40.026075,57.9276698 39.7196792,58.1663274 C39.4124875,58.404985 39.0782375,58.5933569 38.7280708,58.7330395 C38.3783021,58.8723229 38.0106271,58.9597243 37.6361875,58.9904544 C37.3882854,59.0159964 37.1387917,59.0140009 36.8904917,58.9892571 C36.6417938,58.9637152 36.3926979,58.9162231 36.1483771,58.8487764 C35.9036583,58.7813297 35.6649083,58.6947265 35.4361063,58.5881687 C35.2069063,58.4812118 34.9880521,58.3519057 34.7859104,58.198654 C34.5833708,58.0458014 34.3999313,57.8698014 34.2383771,57.6722503 C34.0772208,57.4750984 33.9439188,57.2635791 33.8332979,57.0384907 C33.7222792,56.8130032 33.6339417,56.5747447 33.5678875,56.3293025 C33.5018333,56.0830621 33.4588583,55.8308354 33.4397583,55.5754159 C33.4210563,55.3195973 33.4246375,55.0585905 33.4501042,54.7907991 C33.4755708,54.5230077 33.5213313,54.249629 33.5861917,53.9782458 C33.6510521,53.7068626 33.7377979,53.4398694 33.8531938,53.1856472 C33.9685896,52.9314249 34.1150229,52.6935655 34.2885146,52.4780553 C34.4620063,52.2625451 34.6617604,52.0725769 34.8869813,51.9125406 C35.1102125,51.7544998 35.3517479,51.6347719 35.604425,51.5517605 C35.8976896,51.4555791 36.2001063,51.4040961 36.5037167,51.3937197 C36.8073271,51.3837424 37.1121313,51.412078 37.4169354,51.4743365 C37.7157708,51.5353977 38.0201771,51.63118 38.3217979,51.7509079 C38.5478146,51.8407039 38.7710458,51.9372844 38.9823396,52.0402503 C39.1940313,52.1432163 39.3929896,52.2561596 39.5760313,52.3810757 C39.7602667,52.5051937 39.9281875,52.6404862 40.0782021,52.790146 C40.2282167,52.9398059 40.3611208,53.103434 40.4773125,53.2790349",id:"Fill-104",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:86}}),_react2.default.createElement("path",{d:"M200.013922,55.7406404 C199.941104,56.2654476 199.423812,57.6993887 199.976518,58.0545814 C200.617164,58.4656472 200.915601,57.3952798 201.099837,56.9981823 C201.159126,56.8712707 201.216029,56.7515429 201.272533,56.6366041 C201.329435,56.5224635 201.385541,56.408722 201.442045,56.2945814 C201.526006,56.1233705 201.609568,55.9517605 201.691937,55.7801506 C201.774704,55.6085406 201.856674,55.4365315 201.938645,55.2653206 C202.020616,55.0933116 202.102587,54.9217016 202.184558,54.7504907 C202.266926,54.5788807 202.349693,54.4076698 202.433654,54.236459 C202.517614,54.0660463 202.60237,53.8956336 202.688718,53.72562 C202.775066,53.5560054 202.863006,53.38679 202.952935,53.2183728 C203.049231,53.0367855 203.153485,52.8516063 203.260126,52.6636336 C203.366768,52.4752617 203.475797,52.2844952 203.582837,52.0905361 C203.689081,51.8965769 203.793335,51.7002231 203.890029,51.5010757 C203.986324,51.3023274 204.07506,51.1011846 204.15146,50.8980463 C204.195231,50.7819102 204.234226,50.664976 204.268447,50.5484408 C204.301474,50.433502 204.326543,50.3209578 204.340868,50.2136018 C204.354795,50.1094385 204.359172,50.0104635 204.353999,49.9174748 C204.348031,49.7993433 204.214331,49.7115429 204.001047,49.6464907 C203.154679,49.3886766 201.054872,49.4912435 200.68481,49.5044136 C200.619949,49.5068082 200.551906,49.5111982 200.499779,49.5483138",id:"Fill-106",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:87}}),_react2.default.createElement("path",{d:"M49.5707031,58.2030041 C49.6721719,58.198215 49.7780177,58.1938249 49.8870469,58.1890358 C49.7780177,58.1938249 49.6721719,58.198215 49.5707031,58.2030041",id:"Fill-108",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:88}}),_react2.default.createElement("path",{d:"M1.07460938,52.2275048 C1.09410729,52.1129651 1.12633854,52.00521 1.17926146,51.9138177 C1.12633854,52.00521 1.09410729,52.1129651 1.07460938,52.2275048",id:"Fill-110",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:89}}),_react2.default.createElement("path",{d:"M48.4177794,58.2727655 C48.372019,58.2767565 48.3282481,58.2807474 48.2876606,58.2843392 C48.3282481,58.2807474 48.372019,58.2767565 48.4177794,58.2727655",id:"Fill-112",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:90}}),_react2.default.createElement("path",{d:"M50.7054023,58.1577868 C50.5792627,58.162576 50.4571023,58.1665669 50.3369315,58.1709569 C50.4571023,58.1665669 50.5792627,58.162576 50.7054023,58.1577868",id:"Fill-114",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:91}}),_react2.default.createElement("path",{d:"M49.1926425,58.2217215 C49.1277821,58.2253134 49.0645133,58.2289052 49.0032342,58.232098 C49.0645133,58.2289052 49.1277821,58.2253134 49.1926425,58.2217215",id:"Fill-116",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:92}}),_react2.default.createElement("path",{d:"M49.5707031,58.2030041 C49.4700302,58.2077932 49.3741323,58.2121832 49.2806219,58.2169723 C49.3741323,58.2121832 49.4696323,58.2077932 49.5707031,58.2030041",id:"Fill-118",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:93}}),_react2.default.createElement("g",{id:"Group-122",transform:"translate(1.000000, 54.335873)",__source:{fileName:_jsxFileName,lineNumber:94}},_react2.default.createElement("mask",{id:"mask-8",fill:"white",__source:{fileName:_jsxFileName,lineNumber:95}},_react2.default.createElement("use",{xlinkHref:"#path-7",__source:{fileName:_jsxFileName,lineNumber:96}})),_react2.default.createElement("g",{id:"Clip-121",__source:{fileName:_jsxFileName,lineNumber:98}}),_react2.default.createElement("path",{d:"M0.00194979167,0.247238095 C-3.97916667e-05,0.311092971 -0.00123354167,0.377342404 0.001551875,0.443192744 C-0.00123354167,0.377342404 -3.97916667e-05,0.311092971 0.00194979167,0.247238095",id:"Fill-120",fill:"#D6DE23",mask:"url(#mask-8)",__source:{fileName:_jsxFileName,lineNumber:99}})),_react2.default.createElement("path",{d:"M48.6847417,58.2521324 C48.6107292,58.2573206 48.5430833,58.2621098 48.477825,58.2676971 C48.5430833,58.2621098 48.6107292,58.2573206 48.6847417,58.2521324",id:"Fill-123",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:101}}),_react2.default.createElement("path",{d:"M48.2390352,58.2891283 C48.1861123,58.2947156 48.1359748,58.3003029 48.0929998,58.3058902 C48.1359748,58.3003029 48.1861123,58.2947156 48.2390352,58.2891283",id:"Fill-125",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:102}}),_react2.default.createElement("path",{d:"M50.7054023,58.1577868 C50.8303481,58.1533968 50.959671,58.1494059 51.0905856,58.145415 C50.959671,58.1494059 50.8303481,58.1533968 50.7054023,58.1577868",id:"Fill-127",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:103}}),_react2.default.createElement("path",{d:"M48.6847417,58.2521324 C48.7591521,58.2469442 48.8391333,58.2421551 48.9222979,58.2369669 C48.8391333,58.2421551 48.7591521,58.2469442 48.6847417,58.2521324",id:"Fill-129",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:104}}),_react2.default.createElement("path",{d:"M52.9324225,58.0946503 C52.8269746,58.097444 52.7227204,58.0998385 52.6192621,58.1026322 C52.7227204,58.0998385 52.8269746,58.097444 52.9324225,58.0946503",id:"Fill-131",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:105}}),_react2.default.createElement("path",{d:"M137.642435,58.5077914 C137.765789,58.5085896 137.888347,58.5081905 138.012099,58.5085896 C138.002549,58.5077914 137.993397,58.5073923 137.984245,58.5065941 C137.87243,58.5069932 137.755045,58.5073923 137.642435,58.5077914",id:"Fill-133",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:106}}),_react2.default.createElement("path",{d:"M55.5825873,58.0400943 C55.5591102,58.0404934 55.536031,58.0408925 55.512156,58.0412916 C55.5356331,58.0408925 55.5591102,58.0404934 55.5825873,58.0400943",id:"Fill-135",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:107}}),_react2.default.createElement("path",{d:"M149.114372,58.4380299 C148.984651,58.4508009 148.813945,58.4619755 148.611405,58.4723519 C149.020862,58.4699574 149.434297,58.4679619 149.839774,58.4655673 C149.955966,58.4647692 150.06977,58.4627737 150.185564,58.4619755 C149.511493,58.4472091 149.114372,58.4380299 149.114372,58.4380299",id:"Fill-137",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:108}}),_react2.default.createElement("path",{d:"M55.0156356,58.0506304 C54.708046,58.0566168 54.4044356,58.0622041 54.1052023,58.0685896 C54.4040377,58.0622041 54.708444,58.0566168 55.0156356,58.0506304",id:"Fill-139",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:109}}),_react2.default.createElement("g",{id:"Group-143",transform:"translate(1.795833, 5.247438)",__source:{fileName:_jsxFileName,lineNumber:110}},_react2.default.createElement("mask",{id:"mask-10",fill:"white",__source:{fileName:_jsxFileName,lineNumber:111}},_react2.default.createElement("use",{xlinkHref:"#path-9",__source:{fileName:_jsxFileName,lineNumber:112}})),_react2.default.createElement("g",{id:"Clip-142",__source:{fileName:_jsxFileName,lineNumber:114}}),_react2.default.createElement("path",{d:"M201.414235,43.8699755 C201.378821,43.8532136 201.344998,43.8324608 201.313562,43.8081161 C201.057702,43.6085696 201.194983,42.8255492 201.160364,42.5102658 C201.124154,42.1822113 201.078394,41.8174404 201.021491,41.4275265 C200.944694,40.9071093 200.846806,40.3407964 200.729819,39.7389642 C200.671325,39.4388463 200.608852,39.1307465 200.545185,38.8146649 C200.481916,38.4989823 200.418648,38.1741206 200.356573,37.8388825 C200.294896,37.5032454 200.234412,37.1548372 200.177112,36.7908644 C200.119812,36.4268916 200.066889,36.0449596 200.018344,35.6506558 C199.973379,35.2850866 199.9312,34.9107374 199.892602,34.5284063 C199.853606,34.1464744 199.815406,33.7581569 199.775614,33.3654494 C199.735823,32.972742 199.692848,32.5760435 199.646689,32.1769506 C199.607694,31.8409143 199.565514,31.5036807 199.520948,31.1660481 C199.476381,30.8280163 199.429825,30.4903837 199.382473,30.1539483 C199.334325,29.8171138 199.285381,29.4822748 199.235641,29.1502295 C199.185902,28.8185832 199.135366,28.4905288 199.084831,28.1664653 C199.033898,27.8432 198.982964,27.5243247 198.932827,27.2118349 C198.877914,26.8706104 198.824196,26.5365696 198.772466,26.2113088 C198.721135,25.8860481 198.6706,25.5691683 198.619269,25.2602703 C198.51581,24.6432726 198.414739,24.0578032 198.319637,23.5106467 C198.224535,22.9638893 198.138983,22.4538485 198.06696,21.9877079 C197.994539,21.5215673 197.93326,21.1005243 197.880735,20.734556 C197.82821,20.3681887 197.782848,20.0588916 197.74425,19.8154449 C197.693316,19.4905832 197.634027,19.1453678 197.567177,18.7821932 C197.500327,18.4190186 197.425519,18.0374857 197.345935,17.6407873 C197.26675,17.244488 197.182391,16.8330231 197.090075,16.4099846 C196.99736,15.9877442 196.895494,15.5539302 196.783281,15.1117351 C196.69375,14.7581388 196.597454,14.3989551 196.491608,14.0365787 C196.332839,13.492615 196.151787,12.9398712 195.94686,12.3831365 C195.741933,11.8256036 195.515519,11.2636807 195.277962,10.6989642 C195.044783,10.1334494 194.823144,9.56314558 194.616625,8.99324082 C194.412494,8.42253787 194.213535,7.85383039 194.011394,7.29310476 C193.808456,6.73198005 193.593979,6.18043356 193.363983,5.64165805 C193.129212,5.10407982 192.881708,4.57887347 192.613114,4.06963084 C192.392669,3.65257868 192.134421,3.27862857 191.844737,2.94418866 C191.627475,2.69315918 191.395489,2.464878 191.151169,2.25615238 C190.907246,2.04782585 190.650589,1.85985306 190.384383,1.69063764 C189.852369,1.35140862 189.285735,1.08641088 188.701594,0.880478912 C188.1847,0.696896145 187.656266,0.560406349 187.133006,0.457440363 C186.610541,0.354075283 186.096035,0.281839456 185.598241,0.233549206 C185.101641,0.185258957 184.614591,0.160914286 184.141866,0.153730612 C183.668744,0.146147846 183.208354,0.157322449 182.768656,0.177277098 C182.328958,0.196832653 181.909952,0.226365533 181.521187,0.255100227 C181.077112,0.28782585 180.672033,0.319354195 180.322662,0.332923356 C179.974087,0.346492517 179.578558,0.364052608 179.151196,0.384805442 C178.724231,0.409150113 178.267423,0.432696599 177.795096,0.454247619 C177.322371,0.475399546 176.834525,0.491762358 176.341904,0.502138776 C175.849283,0.5121161 175.350694,0.516107029 174.856083,0.512914286 C174.361075,0.509721542 173.868056,0.500542404 173.386975,0.48657415 C172.906689,0.472605896 172.435556,0.457440363 171.982727,0.445467574 C171.530296,0.433893878 171.095771,0.428306576 170.693875,0.42750839 C170.291979,0.427109297 169.926691,0.428705669 169.615123,0.429503855 C169.464312,0.429902948 169.116135,0.429503855 168.600435,0.428306576 C168.342983,0.42750839 168.045739,0.427109297 167.713081,0.428705669 C167.380821,0.430302041 167.013941,0.433494785 166.613637,0.435889342 C166.213731,0.4382839 165.780002,0.438682993 165.315633,0.436288435 C164.850866,0.433494785 164.354664,0.426710204 163.828619,0.413939229 C163.302573,0.401168254 162.740316,0.387998186 162.133891,0.383608163 C161.831077,0.381612698 161.515927,0.382410884 161.190033,0.385204535 C160.864935,0.386401814 160.531481,0.387599093 160.192854,0.387998186 C159.854625,0.387998186 159.510825,0.387998186 159.163444,0.386800907 C158.816062,0.386002721 158.464702,0.384805442 158.110158,0.384007256 C157.755614,0.38320907 157.398285,0.38320907 157.038171,0.383608163 C156.678454,0.384007256 156.315952,0.384406349 155.950266,0.382410884 C155.584979,0.38041542 155.216906,0.376025397 154.846844,0.367245351 C154.473996,0.360460771 154.095179,0.354075283 153.708006,0.350483447 C153.317252,0.348887075 152.917744,0.35088254 152.507889,0.35766712 C152.097637,0.363653515 151.678631,0.374429025 151.251269,0.387599093 C150.823906,0.400769161 150.390177,0.416333787 149.951673,0.432696599 C149.513169,0.449458503 149.071083,0.465821315 148.627804,0.480587755 C148.184525,0.495753288 147.741246,0.508524263 147.300354,0.517304308 C146.859064,0.526483447 146.422152,0.530075283 145.989616,0.530075283 C145.59926,0.528478912 145.212087,0.526483447 144.823323,0.524088889 C144.43615,0.521694331 144.050569,0.520497052 143.670956,0.515707937 C143.290946,0.511317914 142.916506,0.503336054 142.546841,0.492560544 C142.176381,0.481785034 141.809502,0.468614966 141.443816,0.454247619 C141.078529,0.439481179 140.713639,0.423916553 140.347954,0.407553741 C139.982666,0.391590023 139.614991,0.374828118 139.244133,0.358066213 C138.872877,0.341703401 138.497244,0.325739683 138.116039,0.310973243 C137.734437,0.297004989 137.346071,0.2850322 136.950541,0.27705034 C136.555012,0.268669388 136.151525,0.265476644 135.740875,0.267073016 C135.330623,0.268669388 134.9148,0.274655782 134.495794,0.284234014 C134.076389,0.293812245 133.655394,0.305785034 133.234398,0.319753288 C132.8138,0.333322449 132.394396,0.347689796 131.978971,0.362057143 C131.563546,0.37642449 131.153294,0.389594558 130.750204,0.400370068 C130.346716,0.411145578 129.952381,0.419925624 129.566004,0.425113832 C129.180423,0.429902948 128.80081,0.430302041 128.424381,0.42750839 C128.049544,0.425912018 127.676696,0.423916553 127.307031,0.421921088 C126.936571,0.419925624 126.568896,0.417930159 126.204404,0.415934694 C125.443189,0.413141043 124.695106,0.410347392 123.963735,0.409150113 C123.231966,0.407553741 122.516114,0.406755556 121.817771,0.406356463 C121.119427,0.40595737 120.437796,0.405558277 119.775264,0.405159184 C119.112733,0.404760091 118.468904,0.403163719 117.845369,0.400769161 C117.221833,0.398773696 116.619387,0.395580952 116.040419,0.391989116 C115.46145,0.388397279 114.906754,0.384406349 114.378321,0.380814512 C113.849489,0.377222676 113.348512,0.374029932 112.876185,0.371236281 C112.404256,0.36844263 111.961773,0.366447166 111.551521,0.364850794 C111.140871,0.363653515 110.76285,0.362855329 110.418254,0.362855329 C110.06371,0.364451701 109.744979,0.366048073 109.465641,0.369639909 C108.906966,0.376025397 108.503877,0.386002721 108.276269,0.395580952 C108.000114,0.407952834 107.537337,0.424315646 106.9142,0.445467574 C106.602233,0.456243084 106.250873,0.46781678 105.862108,0.479390476 C105.474139,0.491762358 105.048369,0.503735147 104.589571,0.515707937 C104.130375,0.527281633 103.636958,0.537258957 103.112902,0.542846259 C102.588846,0.548034467 102.032956,0.550029932 101.449212,0.546438095 C100.865866,0.542846259 100.253871,0.534465306 99.6176019,0.524088889 C98.9813331,0.512914286 98.3211894,0.499744218 97.6407519,0.485775964 C96.9599165,0.47180771 96.2591852,0.461431293 95.5433331,0.455045805 C95.1848102,0.451853061 94.822706,0.449458503 94.4570206,0.44905941 C94.0913352,0.448261224 93.7224665,0.449458503 93.3508123,0.452651247 C92.9783623,0.455843991 92.6031269,0.459435828 92.225106,0.463426757 C91.8466873,0.467417687 91.4654831,0.47180771 91.0822894,0.475798639 C90.3568873,0.483381406 89.6223331,0.489766893 88.8802185,0.49335873 C88.138104,0.496551474 87.388031,0.496551474 86.633979,0.49335873 C86.256754,0.492161451 85.8779373,0.489766893 85.4987227,0.48657415 C85.1195081,0.483780499 84.7398956,0.480188662 84.361079,0.477395011 C83.983456,0.476197732 83.606231,0.475399546 83.2305977,0.476197732 C82.8549644,0.476995918 82.479729,0.47859229 82.1056873,0.481385941 C81.7316456,0.483780499 81.3580019,0.486973243 80.9855519,0.490165986 C80.6131019,0.49335873 80.2406519,0.496152381 79.8689977,0.49734966 C79.4969456,0.498946032 79.1256894,0.498946032 78.7544331,0.498147846 C78.3835748,0.496950567 78.0131144,0.494556009 77.6430519,0.491363265 C77.2733873,0.487771429 76.9045185,0.483780499 76.5364456,0.478991383 C76.1683727,0.474601361 75.8014935,0.469413152 75.436604,0.464224943 C75.0721123,0.459435828 74.7092123,0.454247619 74.3494956,0.449857596 C73.989779,0.445068481 73.6324498,0.441875737 73.2787019,0.439082086 C72.9257498,0.435889342 72.575981,0.433893878 72.2313852,0.433095692 C71.8859935,0.431898413 71.5461727,0.432297506 71.2111269,0.433494785 C70.876081,0.434692063 70.5450144,0.435889342 70.2183248,0.436687528 C69.8916352,0.437086621 69.5689248,0.437485714 69.2509894,0.437086621 C68.6171081,0.435490249 68.0011331,0.433893878 67.4066456,0.432297506 C63.246029,0.419925624 60.1343206,0.40196644 59.0304998,0.378020862 C57.9963144,0.356070748 54.9526498,0.334120635 50.8123269,0.312968707 C50.2206248,0.31057415 49.6070373,0.308578685 48.9763394,0.312968707 C48.6607915,0.314964172 48.3416623,0.320551474 48.0189519,0.32813424 C47.6962415,0.336515193 47.3699498,0.346492517 47.0400769,0.358465306 C46.709806,0.370039002 46.375954,0.38320907 46.0377248,0.396379138 C45.7002915,0.409549206 45.358481,0.423118367 45.0126915,0.435889342 C44.6672998,0.448660317 44.317531,0.460234014 43.9637831,0.468614966 C43.6100352,0.477395011 43.2515123,0.483780499 42.8894081,0.48657415 C42.527304,0.489766893 42.1608227,0.488968707 41.7903623,0.484578685 C41.419504,0.480188662 41.0454623,0.472605896 40.6670435,0.460633107 C40.2890227,0.449458503 39.9078185,0.435490249 39.523829,0.419925624 C39.1398394,0.403961905 38.7534623,0.386800907 38.3650956,0.369240816 C37.9771269,0.351281633 37.5871685,0.334120635 37.1972102,0.318156916 C36.806456,0.30259229 36.4157019,0.289023129 36.0249477,0.277449433 C35.6345915,0.266673923 35.2442352,0.259889342 34.8550727,0.255898413 C34.4655123,0.25150839 34.0767477,0.249512925 33.6871873,0.246719274 C31.3506206,0.239934694 29.0049019,0.23275102 26.7212581,0.226365533 C26.3702956,0.22596644 26.0205269,0.225168254 25.6723498,0.224370068 C25.2740352,0.223571882 24.878506,0.223571882 24.4849665,0.223970975 C24.090631,0.227163719 23.6978873,0.231952834 23.3071331,0.237939229 C22.9167769,0.243925624 22.5288081,0.250710204 22.1444206,0.257494785 C21.7600331,0.263880272 21.3792269,0.269866667 21.0020019,0.27705034 C20.6247769,0.283435828 20.251531,0.293014059 19.8822644,0.30259229 C19.5129977,0.312170522 19.148506,0.321748753 18.7895852,0.329730612 C18.4306644,0.338510658 18.0769165,0.344896145 17.7295352,0.350084354 C17.381756,0.354873469 17.0395477,0.358066213 16.7045019,0.358864399 C16.3686602,0.360061678 16.0387873,0.358864399 15.715679,0.355671655 C15.0694623,0.348887075 14.4463248,0.340506122 13.8490519,0.330927891 C13.251779,0.317757823 12.6811665,0.302193197 12.1411935,0.283834921 C11.6012206,0.265476644 11.0902956,0.247118367 10.6116019,0.230755556 C10.1329081,0.214791837 9.68525188,0.202419955 9.27221438,0.194039002 C8.85917688,0.186456236 8.48075813,0.182864399 8.14014146,0.18166712 C7.79952479,0.180868934 7.49790396,0.180469841 7.23806438,0.179671655 C6.71838521,0.178873469 6.36622896,0.178474376 6.20706229,0.178474376 C5.02365813,0.178474376 4.09531854,0.641023129 3.45904979,1.10716372 C3.06113313,1.33225215 2.71932271,1.63995283 2.46664563,2.05939955 C2.24062896,2.43534512 2.08345188,2.86157642 1.97283104,3.29818413 C1.77347479,4.08160363 1.59162688,4.87340408 1.43285813,5.6783746 C1.35327479,6.08066032 1.27767063,6.48613878 1.20763729,6.89600726 C1.13800188,7.30627483 1.07314146,7.72053333 1.01544354,8.13878277 C0.938645625,8.69671474 0.874183125,9.26422494 0.815689375,9.83812063 C0.757195625,10.4116172 0.700691458,10.9907011 0.654533125,11.5753723 C0.607976875,12.1600435 0.575745625,12.7491048 0.556645625,13.3393633 C0.540728958,13.8246603 0.533168542,14.3063655 0.525608125,14.7864744 C0.518047708,15.2661841 0.507303958,15.746293 0.491785208,16.2260027 C0.477062292,16.7057125 0.462339375,17.1826286 0.448412292,17.6555537 C0.434485208,18.1284789 0.422149792,18.5978122 0.411008125,19.0615583 C0.402253958,19.4586558 0.396285208,19.8513633 0.391908125,20.240878 C0.388326875,20.6299937 0.385939375,21.0151184 0.383949792,21.3974494 C0.381960208,21.7797805 0.379572708,22.159717 0.377583125,22.537658 C0.375593542,22.9155991 0.373603958,23.2915447 0.370818542,23.6670912 C0.368033125,24.0422385 0.365645625,24.417785 0.363258125,24.7941297 C0.360870625,25.1704744 0.358483125,25.5480163 0.355697708,25.9279528 C0.352912292,26.3078893 0.348535208,26.6914177 0.341770625,27.078937 C0.335006042,27.4660571 0.325456042,27.8575673 0.313518542,28.2526694 C0.303172708,28.6513633 0.292428958,29.0552454 0.281287292,29.4627193 C0.271737292,29.8709914 0.263381042,30.2824562 0.256218542,30.6967147 C0.256218542,31.1149642 0.255422708,31.5340118 0.258606042,31.9530594 L0.258606042,31.8644608 C0.346943542,31.861268 0.434087292,31.8576762 0.523220625,31.8548825 C1.48578104,31.8185651 2.45908521,31.7870367 3.43437896,31.7638893 C4.03722271,31.749522 4.63847479,31.740742 5.23853313,31.7363519 C5.83859146,31.7315628 6.43745604,31.7303655 7.03632063,31.7319619 C7.63478729,31.7339574 8.23444771,31.7383474 8.83371021,31.7443338 C9.43297271,31.7503202 10.0302456,31.7563066 10.625131,31.7614948 C11.2200165,31.766683 11.8129123,31.7702748 12.4038185,31.7718712 C12.9947248,31.7734676 13.5852331,31.7730685 14.1757415,31.7722703 C14.7666477,31.771073 15.3599415,31.7702748 15.9556227,31.7706739 C16.551304,31.771073 17.1485769,31.7726694 17.7490331,31.7750639 C18.9041852,31.7806512 20.065704,31.8065923 21.2331915,31.8277442 C22.4010769,31.8484971 23.5733394,31.869649 24.7479894,31.8640617 C25.9552685,31.8580753 27.1617519,31.8261478 28.3674394,31.783844 C29.5703415,31.7571048 30.766081,31.7283701 31.9546581,31.7104109 C32.9160248,31.7000345 33.8757998,31.6988372 34.834381,31.7048236 C35.9127352,31.7116082 36.9898956,31.723581 38.0658623,31.7371501 C39.141431,31.7503202 40.2166019,31.7618939 41.290181,31.7682794 C42.3641581,31.7742658 43.4377373,31.7742658 44.5113165,31.7674812 C45.5848956,31.7602975 46.6592706,31.7503202 47.7336456,31.7399438 C48.8080206,31.7295673 49.8823956,31.7219846 50.954781,31.7128054 C52.0275644,31.7036263 53.098756,31.6920526 54.168754,31.6860662 C55.2387519,31.6792816 56.3087498,31.6836717 57.3795435,31.7048236 C58.4507352,31.7255764 59.5223248,31.7606966 60.5947102,31.801005 C61.5513019,31.8365243 62.5094852,31.8724426 63.4732394,31.8983837 C64.4369935,31.9235265 65.4063185,31.9339029 66.3816123,31.9319075 C67.356906,31.9295129 68.336179,31.9203338 69.3174415,31.908361 C70.2994998,31.8963882 71.281956,31.8844154 72.2640144,31.8756354 C73.2456748,31.8672544 74.2253456,31.8672544 75.2014352,31.8780299 C76.1783206,31.8848145 77.1524206,31.8856127 78.120154,31.8792272 C79.0882852,31.8724426 80.0504477,31.8636626 81.0078352,31.8556807 C81.9648248,31.8425107 82.918631,31.8369234 83.8708456,31.835327 C84.8226623,31.8337306 85.7732852,31.8345288 86.7239081,31.8377215 C87.674929,31.8401161 88.6263477,31.8465016 89.5785623,31.8560798 C90.7663435,31.8688508 91.952931,31.8712454 93.1407123,31.8548825 C93.7359956,31.8465016 94.3340644,31.8389188 94.9384998,31.830937 C95.5433331,31.8229551 96.1557269,31.8161705 96.7832415,31.8109823 C97.3832998,31.8057941 97.993704,31.7994086 98.609281,31.7938213 C99.225256,31.7886331 99.8468019,31.7818485 100.46795,31.7782567 C101.089098,31.7742658 101.704675,31.7698757 102.30911,31.7694766 C102.794171,31.7694766 103.279231,31.7718712 103.764291,31.7806512 C104.012591,31.7850413 104.279196,31.736751 104.524312,31.7618939 C104.760675,31.7862385 104.975152,31.7606966 105.2143,31.753912 C105.351979,31.7499211 105.490852,31.7674812 105.623358,31.8057941 C105.66116,31.8165696 105.70135,31.8305379 105.725623,31.8616671 C105.752681,31.8963882 105.754671,31.9430821 105.755864,31.9873814 C105.7682,32.5201705 105.780535,33.0529596 105.793269,33.5857488 C105.798839,33.8272 105.804808,34.0686512 105.792871,34.3097034 C105.782923,34.5216218 105.747508,34.7179755 105.774964,34.9278984 C105.805604,35.1597714 105.765414,35.4123973 105.752283,35.6454676 C105.73756,35.9056762 105.722439,36.1662839 105.72045,36.4272907 C105.716869,36.9796354 105.717664,37.5355719 105.720052,38.0923066 C105.722837,38.6658032 105.730796,39.2389007 105.743131,39.8183837 C105.756262,40.3974676 105.774566,40.9821388 105.794064,41.5700027 C105.813562,42.1586649 105.834652,42.7501206 105.851762,43.3427737 C105.869271,43.9354268 105.884789,44.5276807 105.893941,45.1191365 C105.903491,45.7381297 105.885585,46.3583202 105.859323,46.9892862 C105.833856,47.6206512 105.798441,48.2592 105.779739,48.9009415 C105.766608,49.3618939 105.776954,49.8208508 105.788494,50.2782113 C105.799635,50.7351728 105.811573,51.1893406 105.800829,51.6407147 C105.790085,52.0745288 105.760639,52.5753905 105.676281,53.0634812 C105.991431,53.0535039 106.306581,53.0439256 106.623721,53.0315537 C106.548116,52.556234 106.526231,52.0697397 106.526231,51.646302 C106.526231,51.1977215 106.552494,50.7459483 106.581939,50.289785 C106.610987,49.8340209 106.641627,49.3762612 106.649187,48.9157079 C106.659533,48.2735673 106.650779,47.6342204 106.642423,46.9992635 C106.634464,46.3639075 106.622925,45.7341388 106.634066,45.1023746 C106.638841,44.4957533 106.644014,43.8855401 106.636056,43.2749279 C106.628894,42.6643156 106.616558,42.0552998 106.600641,41.4514721 C106.584725,40.8480435 106.569206,40.2521977 106.553289,39.6667283 C106.537373,39.081259 106.52265,38.5077624 106.508325,37.9398531 C106.494398,37.3871093 106.486439,36.840751 106.480471,36.2991819 C106.477685,36.0441615 106.464952,35.7895401 106.453412,35.5353179 C106.443862,35.308234 106.408846,35.0619937 106.445454,34.8353088 C106.478083,34.6309732 106.448637,34.4394086 106.445852,34.2330776 C106.442271,33.9976127 106.456596,33.7617488 106.472114,33.5254857 C106.506335,33.0038712 106.542546,32.4810594 106.578756,31.955454 C106.581939,31.9123519 106.585919,31.8660571 106.614569,31.8321342 C106.640035,31.801005 106.681021,31.7870367 106.719221,31.7762612 C106.854114,31.7387465 106.994181,31.7215855 107.133054,31.7255764 C107.374987,31.7327601 107.591852,31.7587011 107.834183,31.7355537 C108.086462,31.7116082 108.358637,31.7606966 108.615691,31.7575039 C109.11826,31.7515175 109.622819,31.7519166 110.129366,31.7551093 C110.76086,31.758302 111.402302,31.7658848 112.045733,31.7718712 C112.689164,31.7774585 113.325433,31.7858395 113.95056,31.792624 C114.571708,31.7994086 115.183306,31.8057941 115.783364,31.8109823 C116.410879,31.8161705 117.023273,31.8229551 117.627708,31.830937 C118.232144,31.8389188 118.83061,31.8465016 119.425496,31.8548825 C120.613277,31.8712454 121.799864,31.8688508 122.987646,31.8560798 C123.940258,31.8465016 124.891279,31.8401161 125.8423,31.8377215 C126.792923,31.8345288 127.743546,31.8337306 128.69576,31.835327 C129.647577,31.8369234 130.601383,31.8425107 131.558373,31.8556807 C132.516158,31.8636626 133.478321,31.8724426 134.446054,31.8792272 C135.414185,31.8856127 136.387489,31.8848145 137.364773,31.8780299 C138.340464,31.8672544 139.320135,31.8672544 140.302194,31.8756354 C141.284252,31.8844154 142.266708,31.8963882 143.248369,31.908361 C144.230427,31.9203338 145.2097,31.9295129 146.184596,31.9319075 C147.159889,31.9339029 148.129612,31.9235265 149.093366,31.8983837 C150.056723,31.8724426 151.015304,31.8365243 151.971498,31.801005 C153.043883,31.7606966 154.115871,31.7255764 155.186664,31.7048236 C156.257856,31.6836717 157.327456,31.6792816 158.397852,31.6860662 C159.46785,31.6920526 160.538644,31.7036263 161.611427,31.7128054 C162.68421,31.7219846 163.758187,31.7295673 164.832562,31.7399438 C165.907335,31.7503202 166.981312,31.7602975 168.054891,31.7674812 C169.128471,31.7742658 170.202448,31.7742658 171.276027,31.7682794 C171.897573,31.7646875 172.519119,31.7591002 173.140266,31.7527147 C174.030008,31.7431365 174.919352,31.7303655 175.808696,31.7159982 C176.105144,31.7112091 176.401591,31.7060209 176.698437,31.7012317 C176.956685,31.6968417 177.230054,31.6828735 177.508596,31.6744925 C178.057323,31.6589279 178.529252,31.7363519 179.06246,31.7866376 C179.610391,31.8381206 180.184585,31.8476989 180.565789,32.3154358 C180.885714,32.7073451 180.903223,33.2572952 180.90561,33.7637442 C180.913569,35.3860571 180.862237,37.0255311 180.899641,38.6406603 C180.912773,39.1842249 180.924312,39.7277896 180.935454,40.2713542 C180.946198,40.8153179 180.954554,41.3592816 180.960125,41.9032454 C180.9649,42.4476082 180.966491,42.9915719 180.964104,43.5355356 C180.961716,44.0794993 180.95336,44.623463 180.94381,45.1674268 C180.932669,45.7109914 180.9267,46.2549551 180.929087,46.7981206 C180.931475,47.3412862 180.939831,47.8848508 180.948983,48.4272181 C180.958533,48.9699846 180.968083,49.5123519 180.97445,50.0543202 C180.980419,50.5962884 180.978031,51.1374585 180.964502,51.6778304 C180.952564,52.1838803 180.927894,52.6895311 180.895264,53.1939846 C181.431258,53.2007692 182.0154,53.2071546 182.638139,53.2119438 C183.346033,53.2175311 184.099687,53.2227193 184.879604,53.2267102 C186.244458,53.234293 187.689691,53.2382839 189.102296,53.2366875 C190.5149,53.2354902 191.896069,53.2299029 193.128416,53.2227193 C194.360366,53.2151365 195.442302,53.2067556 196.260021,53.19598 C197.077341,53.1852045 197.62965,53.1728327 197.803937,53.1580662 C198.139779,53.1301297 198.664233,52.4077714 199.245191,51.3832998 C199.438579,51.0412771 199.638333,50.6649324 199.841271,50.2634449 C200.51375,48.9137125 201.004779,47.5005243 201.605235,46.1184653 C201.816927,45.631971 202.229169,45.2320798 202.377194,44.7152544 C202.65096,43.7582295 201.999969,44.1493406 201.414235,43.8699755",id:"Fill-141",fill:"#D6DE23",mask:"url(#mask-10)",__source:{fileName:_jsxFileName,lineNumber:115}})),_react2.default.createElement("path",{d:"M50.2499867,58.1745488 C50.1596596,58.1781406 50.07172,58.1817324 49.98577,58.1849252 C50.0721179,58.1817324 50.1596596,58.1781406 50.2499867,58.1745488",id:"Fill-144",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:117}}),_react2.default.createElement("path",{d:"M52.0425615,58.1172789 C52.1842198,58.113288 52.3294594,58.1096961 52.4758927,58.1061043 C52.3294594,58.1096961 52.1842198,58.113288 52.0425615,58.1172789",id:"Fill-146",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:118}}),_react2.default.createElement("path",{d:"M52.0425615,58.1172789 C51.901301,58.1212698 51.762826,58.1252608 51.6259427,58.1288526 C51.762826,58.1252608 51.901301,58.1212698 52.0425615,58.1172789",id:"Fill-148",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:119}}),_react2.default.createElement("path",{d:"M53.536659,58.0806422 C53.3830631,58.084234 53.2318548,58.0878259 53.0814423,58.0910186 C53.2318548,58.0878259 53.3830631,58.084234 53.536659,58.0806422",id:"Fill-150",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:120}}),_react2.default.createElement("path",{d:"M51.5027875,58.1324444 C51.4009208,58.1356372 51.3006458,58.1388299 51.2015646,58.1416236 C51.3006458,58.1388299 51.4009208,58.1356372 51.5027875,58.1324444",id:"Fill-152",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:121}}),_react2.default.createElement("path",{d:"M53.536659,58.0806422 C53.6946319,58.0770503 53.8545944,58.0738576 54.0157506,58.0706649 C53.8549923,58.0738576 53.6946319,58.0770503 53.536659,58.0806422",id:"Fill-154",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:122}}),_react2.default.createElement("path",{d:"M144.809988,9.18357188 C144.809988,9.18357188 143.821563,9.08499592 143.790924,9.62616599 C143.775803,9.89675102 143.78774,10.8705379 143.811217,11.849912 C143.834694,12.8288871 143.868119,13.8122522 143.87568,14.0999982 C143.883638,14.3877442 143.927409,15.32681 143.968394,16.245522 C144.003013,17.1662295 144.024899,18.0673814 144.024103,18.2860844 C144.023307,18.5043882 144.014951,19.662556 143.983515,20.7592635 C143.95208,21.855971 143.914278,22.8928145 143.914278,22.8928145 C143.914278,22.8928145 143.683088,25.4685605 144.187249,25.5623474 C144.354771,25.5934766 145.671876,25.5898848 147.430269,25.5615492 C148.309267,25.547581 149.302069,25.526429 150.304421,25.504878 C151.306376,25.483327 152.311911,25.4633723 153.215978,25.4510005 C154.120044,25.4382295 154.930203,25.4294494 155.558115,25.4238621 C156.186028,25.4182748 156.63448,25.4154812 156.818317,25.4154812 C157.093676,25.414683 157.743076,25.4039075 158.579496,25.3947283 C159.205817,25.3883429 159.938382,25.3823565 160.699199,25.3827556 C162.981251,25.3831546 165.517969,25.4370322 166.207957,25.6800798 C167.434734,26.1122975 169.026401,26.3784925 172.176707,29.9703293 C173.797024,31.8173315 175.52438,33.5968871 177.420453,35.1605333 C178.738751,36.2468644 180.226163,37.0294857 181.931634,37.2729324 C182.574667,37.3643247 183.245953,37.4098213 183.894557,37.417005 C187.853828,37.4613043 191.814292,37.3926603 195.769186,37.2094766 C196.231167,37.1879256 196.692353,37.1651773 197.153936,37.1396354 C197.377167,37.1276626 197.611938,37.1112998 197.802142,36.9923701 C198.313465,36.6734948 198.059196,35.7851138 198.011446,35.3129868 C197.953351,34.7354993 197.886501,34.0734041 197.815274,33.3781841 C197.743649,32.6829642 197.661678,31.9534222 197.56578,31.2418395 C197.47028,30.5298576 197.359261,29.8374313 197.251028,29.2192363 C197.143192,28.6010413 197.044509,28.0578757 196.968905,27.64242 C196.906034,27.2960073 196.814911,26.8550095 196.702699,26.3449687 C196.64699,26.0895492 196.588099,25.8165696 196.527217,25.5284245 C196.46554,25.2402794 196.402271,24.9377669 196.338207,24.6236807 C196.274142,24.3091955 196.208884,23.9839347 196.141636,23.6510912 C196.07399,23.3178485 196.003559,22.9774222 195.929546,22.6322068 C195.840015,22.2183474 195.742924,21.7989007 195.637476,21.3798531 C195.532426,20.9604063 195.419815,20.5413587 195.302828,20.1278984 C195.18584,19.714039 195.065669,19.3049687 194.945101,18.9062748 C194.824532,18.507581 194.705157,18.1188644 194.588169,17.743717 C194.470784,17.3689687 194.358174,17.0081887 194.251134,16.6669642 C194.144094,16.3257397 194.042626,16.0040707 193.941157,15.708742 C193.840086,15.412615 193.739811,15.1432272 193.643117,14.9045696 C193.49748,14.5469823 193.347465,14.1885968 193.191084,13.8346014 C193.034305,13.4814041 192.871557,13.1321977 192.70483,12.7937669 C192.537705,12.4557351 192.370978,12.128878 192.201863,11.8191819 C192.032351,11.5090866 191.859257,11.2165515 191.680194,10.9455673 C191.501132,10.6749823 191.313315,10.4259483 191.112765,10.2040526 C190.912215,9.98215692 190.698136,9.78739955 190.467344,9.62456961 C190.236553,9.46253787 189.989049,9.33243356 189.721649,9.24064218 C189.454249,9.14805261 189.167749,9.09377596 188.859363,9.08339955 C188.551376,9.07302313 188.21434,9.0634449 187.857807,9.05586213 C187.500876,9.04788027 187.125242,9.04149478 186.740457,9.03590748 C186.355671,9.03071927 185.964917,9.02672834 185.576153,9.02513197 C185.187786,9.02273741 184.801807,9.02193923 184.421001,9.02233832 C184.041786,9.02313651 183.664163,9.02473288 183.294499,9.02553107 C182.185903,9.02872381 181.150524,9.03032018 180.367026,9.0179483 C178.90508,8.99440181 167.352365,9.18317279 160.404342,9.26418866 C159.411938,9.27576236 158.513442,9.28534059 157.751432,9.29172608 C156.225421,9.30569433 155.235803,9.3072907 155.147465,9.28733605 C155.03764,9.26259229 154.348846,9.24383492 153.367186,9.22747211 C152.385526,9.21150839 151.105428,9.19754014 149.829707,9.19115465 C148.553986,9.18437007 147.29259,9.1823746 146.357884,9.1823746 C145.422382,9.1823746 144.809988,9.18357188 144.809988,9.18357188",id:"Fill-156",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:123}}),_react2.default.createElement("path",{d:"M96.2513021,11.0032363 C96.2513021,11.0032363 96.2174792,10.6221025 96.2361812,10.2397714 C96.2548833,9.85744036 96.3344667,9.47431111 96.6209667,9.47311383 C96.8115687,9.47231565 97.0654396,9.469522 97.3845687,9.46513197 C97.5449292,9.4635356 97.7224,9.46114104 97.9161854,9.45834739 C98.1095729,9.45595283 98.3180812,9.45315918 98.5417104,9.45116372 C98.9889687,9.4467737 99.4955167,9.44318186 100.063344,9.44318186 C100.435396,9.44318186 101.343044,9.43719546 102.557485,9.42841542 C102.860698,9.42602086 103.183806,9.4236263 103.522035,9.42083265 C103.691548,9.41963537 103.865437,9.41883719 104.041715,9.4184381 C104.217992,9.418039 104.39785,9.418039 104.580096,9.41883719 C104.76274,9.41923628 104.947373,9.42043356 105.13519,9.42163084 C105.323006,9.42322721 105.512812,9.42442449 105.705006,9.42602086 C105.8972,9.42761723 106.091383,9.42921361 106.287556,9.43001179 C106.483331,9.43120907 106.6803,9.43200726 106.877269,9.43280544 C107.074635,9.43360363 107.2724,9.43400272 107.470165,9.43400272 C107.667929,9.43400272 107.86649,9.43360363 108.06505,9.43240635 C108.264008,9.43160816 108.463365,9.4296127 108.662721,9.42721814 C108.862077,9.42482358 109.062229,9.42163084 109.261983,9.4184381 C109.442637,9.41564444 109.624087,9.4124517 109.804742,9.40925896 C109.984998,9.40606621 110.163662,9.40287347 110.340735,9.40047891 C110.695677,9.3956898 111.043854,9.39249705 111.385267,9.39129977 C111.726679,9.39010249 112.060133,9.39090068 112.385231,9.39129977 C112.568273,9.39129977 112.748529,9.39090068 112.926398,9.39050159 C113.282533,9.38890522 113.628323,9.38930431 113.960583,9.39489161 C114.292844,9.40047891 114.609983,9.40885986 114.908819,9.41724082 C115.207256,9.42602086 115.4854,9.43400272 115.736883,9.44118639 C115.988765,9.44837007 116.212792,9.45315918 116.404985,9.45754921 C116.597975,9.46154014 116.758335,9.46433379 116.883679,9.46553107 C117.024144,9.46792562 117.206787,9.469522 117.42405,9.46992109 C117.641312,9.47071927 117.891602,9.46872381 118.16895,9.46393469 C118.4459,9.45914558 118.752694,9.44916825 119.083362,9.4352 C119.414031,9.42123175 119.768973,9.40367166 120.143412,9.38531338 C120.330831,9.37613424 120.522627,9.3673542 120.719198,9.35977143 C120.915769,9.35139048 121.116717,9.34500499 121.322042,9.33981678 C121.526969,9.33502766 121.735477,9.33223401 121.947567,9.33183492 C122.159656,9.33183492 122.374929,9.33223401 122.594181,9.3330322 C122.813831,9.33462857 123.03746,9.33742222 123.265467,9.34141315 C123.481933,9.34500499 123.70039,9.34899592 123.920437,9.35378503 C124.140485,9.35897324 124.362921,9.36535873 124.587346,9.3729415 C124.810975,9.38092336 125.036196,9.38930431 125.260223,9.39848345 C125.484648,9.4068644 125.707083,9.41524535 125.927131,9.42242902 C126.147577,9.43001179 126.364044,9.43559909 126.576531,9.44038821 C126.789417,9.44477823 126.997925,9.44717279 127.20126,9.44837007 C127.405392,9.44876916 127.60435,9.44797098 127.798931,9.44557642 C127.993115,9.44318186 128.183319,9.43919093 128.368748,9.43400272 C128.554575,9.4296127 128.736821,9.4236263 128.917077,9.41604354 C129.096935,9.40885986 129.274804,9.400878 129.451081,9.39249705 C129.802442,9.37533605 130.143456,9.36017052 130.466565,9.34739955 C130.790469,9.33422948 131.093283,9.32465125 131.372223,9.31826576 C131.790831,9.30908662 132.148956,9.30150385 132.42511,9.29711383 C132.70206,9.29192562 132.89704,9.28993016 132.996917,9.29072834 C133.108731,9.29152653 133.283815,9.28873288 133.507842,9.28394376 C133.731471,9.27995283 134.002452,9.27436553 134.30646,9.26957642 C134.610867,9.26438821 134.95029,9.2592 135.312394,9.25480998 C135.493446,9.25241542 135.680069,9.25041995 135.870671,9.24882358 C136.061671,9.24722721 136.256252,9.24563084 136.454017,9.24403447 C136.651781,9.2424381 136.852729,9.24044263 137.055667,9.23804807 C137.258206,9.23565351 137.461144,9.23365805 137.66249,9.23246077 C137.998331,9.23006621 138.330194,9.22926803 138.650119,9.22926803 C138.969646,9.22926803 139.278429,9.22966712 139.569704,9.22926803 C139.715342,9.22926803 139.857,9.22886893 139.993883,9.22846984 C140.130369,9.22807075 140.264865,9.22727256 140.396575,9.22607528 C140.594737,9.22407982 140.78335,9.22248345 140.956046,9.22088707 C141.128344,9.2192907 141.283531,9.21809342 141.416037,9.21769433 C141.68105,9.21649705 141.856133,9.21889161 141.916219,9.22687347 C142.155765,9.25640635 142.302596,9.22447891 142.41441,9.25560816 C142.525827,9.28673741 142.602625,9.38132245 142.690962,9.66587574 C142.720408,9.76125896 142.739906,9.90493243 142.75264,10.0801342 C142.765771,10.254937 142.77174,10.4604698 142.772933,10.6807692 C142.772933,10.7901206 142.771342,10.9030639 142.769352,11.0176036 C142.766965,11.1321433 142.764577,11.2478803 142.762587,11.3636172 C142.760598,11.5372227 142.758608,11.710429 142.756619,11.8796444 C142.755823,12.0069551 142.754629,12.1314721 142.753833,12.2519982 C142.753037,12.3725243 142.752242,12.4886603 142.75264,12.5976127 C142.753435,12.8163156 142.755823,13.0058848 142.757415,13.1435719 C142.759404,13.281259 142.762587,13.4808054 142.762985,13.7198621 C142.763383,13.8387918 142.76219,13.9684971 142.760598,14.1041887 C142.758608,14.2398803 142.755425,14.3831546 142.75065,14.53042 C142.746273,14.6776853 142.740702,14.8297397 142.735131,14.9825923 C142.729958,15.1354449 142.725183,15.2886966 142.722,15.4399528 C142.718817,15.5912091 142.718419,15.7396717 142.72001,15.8821478 C142.722,16.024624 142.725581,16.1615129 142.728367,16.29042 C142.731948,16.462429 142.733937,16.6204698 142.734335,16.7573587 C142.736325,16.8946467 142.737519,17.0111819 142.737519,17.0993814 C142.737121,17.2171138 142.739508,17.3827374 142.744681,17.5794902 C142.747467,17.6780662 142.75065,17.7838259 142.754629,17.8955719 C142.75821,18.0073179 142.76219,18.1246512 142.764975,18.2451773 C142.76776,18.3657034 142.770546,18.4902204 142.772933,18.6151365 C142.775321,18.7404517 142.776912,18.8665651 142.777708,18.9918803 C142.778504,19.1167964 142.778106,19.2409143 142.776515,19.3618395 C142.775321,19.4827646 142.772933,19.6008961 142.770546,19.7142385 C142.768158,19.827581 142.765771,19.9365333 142.764179,20.0387011 C142.76219,20.1404698 142.760996,20.235454 142.760996,20.3224562 C142.760996,20.4952635 142.766169,20.6333497 142.7793,20.7195537 C142.7984,20.8488599 142.811929,21.0112907 142.820285,21.1988644 C142.824662,21.2926512 142.82705,21.3928236 142.828244,21.4985832 C142.829437,21.6039438 142.830233,21.7156898 142.830233,21.8318259 C142.830233,21.9479619 142.82904,22.0692862 142.82705,22.1934041 C142.82506,22.3179211 142.822275,22.4456308 142.818694,22.5757351 C142.814317,22.7058395 142.80994,22.8383383 142.805562,22.9712363 C142.801185,23.1045333 142.796808,23.2382295 142.792829,23.3711274 C142.790442,23.5020299 142.790442,23.630937 142.791635,23.7550549 C142.791635,23.8795719 142.792033,23.9996989 142.792829,24.1146376 C142.793227,24.1972499 142.7984,24.3117896 142.799196,24.4398984 C142.80039,24.5676082 142.799196,24.7088871 142.789248,24.8437805 C142.780096,24.9782748 142.763383,25.1055855 142.729162,25.2093497 C142.694942,25.3131138 142.641621,25.3949279 142.555273,25.4376308 C142.47171,25.4791365 142.36666,25.477141 142.26161,25.4755447 C142.152979,25.4735492 142.039971,25.4719528 141.922585,25.4715537 C141.8052,25.4707556 141.686223,25.4711546 141.565654,25.4719528 C141.445085,25.472751 141.323323,25.4743474 141.20156,25.4759438 C141.0794,25.477141 140.956842,25.4787374 140.834283,25.4795356 C140.711725,25.481132 140.589962,25.4815311 140.468996,25.481132 C140.348029,25.4803338 140.228256,25.4795356 140.108085,25.4791365 C139.86854,25.4779392 139.630983,25.4763429 139.395815,25.4739483 C139.161044,25.4715537 138.929058,25.4675628 138.69946,25.4643701 C138.470658,25.4607782 138.242254,25.45998 138.015442,25.4635719 C137.871396,25.4659664 137.707056,25.468361 137.525208,25.4711546 C137.34336,25.4739483 137.144402,25.477141 136.928333,25.4791365 C136.640242,25.4831274 136.318725,25.4851229 135.968558,25.4875175 C135.792679,25.4883156 135.607648,25.4891138 135.415852,25.4895129 C135.22326,25.4895129 135.0247,25.4891138 134.820967,25.4875175 C134.617233,25.4863202 134.409123,25.4839256 134.198227,25.4807329 C133.988127,25.4775401 133.776833,25.4731501 133.566335,25.4671637 C133.356633,25.4615764 133.148125,25.45559 132.9428,25.4492045 C132.737475,25.4432181 132.536129,25.4368327 132.337171,25.4308463 C132.139008,25.425259 131.941642,25.4196717 131.743479,25.4164789 C131.545317,25.4128871 131.345165,25.4120889 131.143421,25.4120889 C130.941677,25.4128871 130.738342,25.4156807 130.534608,25.4200707 C130.331273,25.4240617 130.127937,25.429649 129.925,25.4368327 C129.72246,25.4436172 129.521512,25.4512 129.32335,25.459581 C129.125187,25.4675628 128.92981,25.476742 128.73881,25.4851229 C128.537465,25.494302 128.342087,25.5022839 128.153873,25.5094676 C127.784208,25.5194449 127.447969,25.5230367 127.153112,25.5206422 C126.858654,25.5170503 126.595631,25.5130594 126.366033,25.5098667 C125.906042,25.5030821 125.572587,25.5014857 125.41939,25.507073 C125.301606,25.511463 125.060867,25.5130594 124.717067,25.5150549 C124.545167,25.5162522 124.344219,25.5182476 124.11661,25.5210413 C123.889002,25.5238349 123.63354,25.5282249 123.353804,25.5338122 C123.074069,25.5397986 122.769662,25.5465832 122.446952,25.5549642 C122.123844,25.562946 121.786012,25.571327 121.441417,25.5789098 C121.096821,25.5868916 120.751827,25.5920798 120.408425,25.5948735 C120.065819,25.5968689 119.717642,25.5988644 119.365087,25.6000617 C119.163742,25.6008599 118.961202,25.601658 118.757867,25.6024562 C118.554531,25.6032544 118.3504,25.6040526 118.146269,25.6044517 C117.944127,25.605649 117.742383,25.6076444 117.541833,25.6096399 C117.341681,25.6116354 117.142723,25.614429 116.945754,25.6176218 C116.748785,25.6212136 116.55301,25.6256036 116.360021,25.6295946 C116.166633,25.6343837 115.975235,25.639971 115.786623,25.6451592 C115.597612,25.6511456 115.410592,25.6567329 115.226754,25.661522 C115.042121,25.6671093 114.860273,25.6718984 114.680812,25.6766875 C114.323085,25.6854676 113.977694,25.6918531 113.64981,25.6942476 C113.321529,25.6962431 113.011154,25.6938485 112.726246,25.6894585 C112.441735,25.683073 112.185079,25.6746921 111.961848,25.6635175 C111.515385,25.6419664 111.196654,25.6236082 111.04266,25.6164245 C110.916123,25.6108372 110.686525,25.5960707 110.377344,25.5765152 C110.222554,25.5661388 110.048267,25.5561615 109.856073,25.5465832 C109.664675,25.5374041 109.455769,25.5294222 109.23015,25.5238349 C109.004531,25.5174494 108.761802,25.5138576 108.50435,25.5126603 C108.2465,25.5118621 107.973529,25.5142567 107.687825,25.519844 C107.516721,25.5230367 107.340444,25.5278259 107.160983,25.532615 C106.981921,25.5378032 106.798879,25.5437896 106.613052,25.549776 C106.427225,25.5561615 106.239408,25.5621478 106.050796,25.566937 C105.862183,25.5717261 105.673571,25.5753179 105.48456,25.5769143 C105.29555,25.5785107 105.107733,25.5785107 104.920315,25.5761161 C104.733294,25.5733224 104.547865,25.5685333 104.362435,25.562946 C104.164273,25.5593542 103.96611,25.554166 103.768346,25.5505741 C103.570581,25.5469823 103.372817,25.5449868 103.176246,25.5441887 C102.979675,25.5433905 102.783502,25.5441887 102.589319,25.545785 C102.394737,25.5473814 102.201748,25.5505741 102.011146,25.5545651 C101.820544,25.5581569 101.631931,25.5621478 101.447298,25.5673361 C101.110262,25.5761161 100.783573,25.5832998 100.467627,25.5844971 C100.122633,25.5852952 99.7927604,25.5797079 99.4887521,25.5709279 C99.1576854,25.5589551 98.8616354,25.549776 98.6129375,25.5461841 C98.1159396,25.5390005 97.7793021,25.5421932 97.6463979,25.5469823 C97.3503479,25.5577578 97.1155771,25.5605515 96.9289542,25.5537669 C96.7423312,25.5465832 96.6030604,25.528624 96.4992042,25.4986921 C96.2918896,25.4388281 96.2254375,25.3286785 96.2242437,25.1686422 C96.2238458,25.1415039 96.2298146,25.0297578 96.2405583,24.8445787 C96.2505062,24.6593995 96.2632396,24.3979937 96.2743812,24.0719347 C96.2815437,23.854429 96.285125,23.6057941 96.2835333,23.33042 C96.2819417,23.0546467 96.2759729,22.750937 96.2708,22.4280707 C96.2656271,22.1048054 96.2656271,21.7691683 96.2672187,21.4251501 C96.2680146,21.2391728 96.2672187,21.0496036 96.2656271,20.8568417 C96.2636375,20.6640798 96.2604542,20.4685243 96.2568729,20.2701751 C96.2528937,20.072624 96.2497104,19.8730776 96.2473229,19.673132 C96.2449354,19.4731864 96.2433437,19.2728417 96.2429458,19.072098 C96.2425479,18.8717533 96.2429458,18.6714086 96.2437417,18.471463 C96.2445375,18.2938667 96.2437417,18.1154721 96.2437417,17.9382748 C96.2437417,17.7606785 96.2449354,17.5830821 96.2473229,17.4062839 C96.2497104,17.2294857 96.2528937,17.0526875 96.2568729,16.8762884 C96.2600562,16.6998893 96.2644333,16.5242884 96.2684125,16.3486875 C96.2767687,15.9970866 96.285125,15.6486785 96.2867167,15.307454 C96.2879104,15.1126966 96.2847271,14.9203338 96.2795542,14.7315628 C96.2723917,14.5423927 96.2644333,14.3564154 96.2568729,14.1752272 C96.2489146,13.9944381 96.24215,13.818039 96.2357833,13.646429 C96.2270292,13.3044063 96.2246417,12.9855311 96.2270292,12.6957896 C96.2298146,12.4068463 96.2341917,12.1458395 96.2377729,11.9187556 C96.2445375,11.4645878 96.2497104,11.1445152 96.2513021,11.0032363",id:"Fill-158",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:124}}),_react2.default.createElement("path",{d:"M51.4588973,9.32153832 C51.4588973,9.32153832 49.8588744,9.19901678 49.9786473,9.72941134 C50.0793202,10.1744 49.9388556,12.4639964 49.8588744,14.3417288 C49.7788931,16.2190621 49.8588744,17.5656018 49.8190827,18.62679 C49.8091348,18.8921868 49.8091348,19.1523955 49.8139098,19.4094113 C49.8190827,19.6664272 49.8286327,19.9202503 49.8389785,20.1724771 C49.8489265,20.425502 49.8580785,20.6793252 49.860466,20.9379374 C49.8632515,21.1969488 49.8596702,21.459951 49.8453452,21.7285406 C49.8357952,21.9073342 49.8210723,22.1172571 49.803166,22.343942 C49.7856577,22.5710259 49.765364,22.8148717 49.7446723,23.0607129 C49.7247765,23.3065542 49.7044827,23.5543909 49.6869744,23.7898558 C49.669466,24.0253206 49.655141,24.2480145 49.6451931,24.4455655 C49.6260931,24.8410667 49.6237056,25.1439782 49.650764,25.2637061 C49.6925452,25.4436971 49.7820765,25.5159329 49.980239,25.5414748 C50.1787994,25.5666177 50.4867869,25.5418739 50.9674702,25.5195247 C51.0872431,25.5135383 51.2464098,25.5051574 51.4342265,25.4955791 C51.622839,25.4860009 51.8408973,25.4760236 52.0804431,25.4656472 C52.3191931,25.456468 52.5802265,25.4488853 52.8539931,25.4456925 C53.1277598,25.4424998 53.4142598,25.4428989 53.7039431,25.4464907 C53.9932285,25.4508807 54.2849015,25.4580644 54.568616,25.4680417 C54.8531265,25.478019 55.1308723,25.4887946 55.3942931,25.4955791 C55.657714,25.5023637 55.9068098,25.5067537 56.1340202,25.5095474 C56.3608327,25.511942 56.5657598,25.5151347 56.7396494,25.520722 C56.9218952,25.5263093 57.2601244,25.5219193 57.715739,25.5111438 C57.9433473,25.5063546 58.2019931,25.5023637 58.4857077,25.5015655 C58.7698202,25.5007673 59.0778077,25.5055565 59.4037015,25.5147356 C59.7291973,25.5243138 60.0722015,25.5342912 60.4271431,25.5430712 C60.6487827,25.5486585 60.8744015,25.5530485 61.1028056,25.5566404 C61.3316077,25.5598331 61.5627973,25.5618286 61.7951806,25.5626268 C62.027564,25.563824 62.261141,25.5634249 62.495514,25.5626268 C62.7298869,25.5614295 62.9650556,25.5598331 63.1994285,25.5578376 C63.4338015,25.5554431 63.6681744,25.5530485 63.9009556,25.550654 C64.1341348,25.5486585 64.3657223,25.546663 64.5957181,25.5450667 C64.825714,25.5438694 65.0537202,25.5434703 65.278941,25.5434703 C65.5041619,25.5438694 65.7258015,25.5438694 65.9418702,25.5438694 C66.2880577,25.5438694 66.6203181,25.5430712 66.9326827,25.5438694 C67.2450473,25.5446676 67.5371181,25.5494567 67.804916,25.555044 C68.0969869,25.5610304 68.3604077,25.5670168 68.588016,25.5710077 C69.0452223,25.5805859 69.3647494,25.5861732 69.4865119,25.5773932 C69.5923577,25.5698104 69.9039265,25.5761959 70.3746619,25.5913615 C70.6102285,25.5985451 70.8859848,25.6053297 71.1947681,25.6085224 C71.5035515,25.6113161 71.8441681,25.6089215 72.2090577,25.5989442 C72.3917015,25.593756 72.579916,25.5861732 72.7729056,25.5761959 C72.9658952,25.5662186 73.1632619,25.5554431 73.3638119,25.5442685 C73.5643619,25.5330939 73.7680952,25.5227175 73.9750119,25.5131392 C74.1815306,25.5039601 74.3908348,25.49518 74.6029244,25.4864 C74.7728348,25.4792163 74.9443369,25.4720327 75.1190223,25.464849 C75.2929119,25.4580644 75.4695869,25.4512798 75.6486494,25.4460916 C75.827314,25.4413025 76.0095598,25.4397061 76.194591,25.4417016 C76.3796223,25.4436971 76.567439,25.4496834 76.7560515,25.4572662 C76.9454598,25.4644499 77.135266,25.4720327 77.326266,25.4796154 C77.5391515,25.4887946 77.7520369,25.4967764 77.9657181,25.5043592 C78.1793994,25.5115429 78.3946723,25.5183274 78.610741,25.5247129 C78.8268098,25.5306993 79.0436744,25.5362866 79.260141,25.5398785 C79.4766077,25.5434703 79.6926765,25.5458649 79.9067556,25.546663 C80.1208348,25.5474612 80.3329244,25.5470621 80.5426265,25.5446676 C80.7523285,25.542273 80.9592452,25.5374839 81.1625806,25.5306993 C81.366314,25.5243138 81.566466,25.5159329 81.7614452,25.5067537 C81.9572202,25.4971755 82.1482202,25.4871982 82.3340473,25.4768218 C82.5194765,25.4668444 82.7001306,25.4568671 82.875214,25.447688 C83.0506952,25.4385088 83.2206056,25.4301279 83.3849452,25.4241415 C83.7140223,25.4117696 84.0228056,25.4057832 84.3089077,25.4009941 C84.5946119,25.396205 84.8584306,25.3930122 85.0959869,25.3910168 C85.333941,25.3894204 85.5464285,25.3894204 85.7290723,25.391815 C85.911716,25.3938104 86.064914,25.3978014 86.183891,25.4041868 C86.4238348,25.4157605 86.7127223,25.4273342 87.0350348,25.4373116 C87.3577452,25.4472889 87.7134827,25.4556698 88.0903098,25.4624544 C88.3413952,25.4672435 88.6020306,25.4716336 88.867839,25.4764227 C89.1336473,25.4812118 89.4050265,25.4883955 89.6779973,25.4975746 C89.9509681,25.5067537 90.2259285,25.5167311 90.4988994,25.5275066 C90.7718702,25.5386812 91.0428515,25.5494567 91.307864,25.559434 C91.5728765,25.5690122 91.8323181,25.5773932 92.0822098,25.5837787 C92.415266,25.5925587 92.7312119,25.5969488 93.0204973,25.5989442 C93.3101806,25.6009397 93.5720098,25.602137 93.7976285,25.6045315 C94.248866,25.6085224 94.5612306,25.615307 94.6698619,25.6244862 C94.9408431,25.6464363 95.0665848,25.6272798 95.1187119,25.5099465 C95.1712369,25.3934113 95.1509431,25.1767039 95.132241,24.8015565 C95.1282619,24.7157515 95.1242827,24.4695111 95.123089,24.0971574 C95.1222931,23.9115791 95.122691,23.6936744 95.1234869,23.4494295 C95.1242827,23.2059828 95.1258744,22.9369941 95.127466,22.648849 C95.1290577,22.3607039 95.1290577,22.0538014 95.127466,21.7329306 C95.1254765,21.4116608 95.1218952,21.0756245 95.117916,20.7292118 C95.1159265,20.5556063 95.113539,20.3792073 95.1111515,20.2008127 C95.1047848,19.6640327 95.0980202,19.1057016 95.0908577,18.5401868 C95.0888681,18.3514159 95.0864806,18.1618467 95.0832973,17.9722776 C95.0805119,17.7827084 95.0769306,17.5931392 95.0725535,17.4035701 C95.0689723,17.2136018 95.0641973,17.0248308 95.0586265,16.836459 C95.0534535,16.6480871 95.0478827,16.4609125 95.041516,16.2749351 C95.0355473,16.0885587 95.0299765,15.9041778 95.0244056,15.7213932 C95.0192327,15.5390077 95.0144577,15.3582186 95.0100806,15.1802231 C95.0021223,14.8242322 94.9957556,14.4782186 94.9929702,14.1469714 C94.9897869,13.7853932 94.9901848,13.4413751 94.9917765,13.1205043 C94.993766,12.7992345 94.9973473,12.5003138 95.0025202,12.2289306 C95.0061015,11.9575474 95.0068973,11.7148989 94.9997348,11.5057741 C94.9854098,11.0871256 94.9671056,10.8089578 94.9575556,10.7203592 C94.9213452,10.3651664 94.9929702,10.00718 94.9754619,9.74258141 C94.9583515,9.47798277 94.8548931,9.30637279 94.459364,9.3227356 C94.402064,9.32513016 94.2385202,9.32991927 93.9782827,9.33590567 C93.848164,9.33909841 93.6909869,9.34149297 93.5067515,9.34308934 C93.322516,9.34508481 93.112814,9.34628209 92.8812265,9.34708027 C92.649241,9.34787846 92.3981556,9.34708027 92.1299598,9.34628209 C91.861764,9.34508481 91.5756619,9.3454839 91.2728473,9.34668118 C90.9700327,9.34867664 90.6505056,9.35186939 90.3170515,9.35506213 C90.1499265,9.3570576 89.980016,9.35865397 89.8057285,9.36025034 C89.631839,9.36184671 89.4543681,9.36304399 89.273714,9.36344308 C89.0930598,9.36464036 88.9092223,9.36503946 88.7222015,9.36503946 C88.5355785,9.36464036 88.3457723,9.36384218 88.1531806,9.3626449 C87.960589,9.36104853 87.7652119,9.35865397 87.5674473,9.35586032 C87.3692848,9.35266757 87.1691327,9.34907574 86.9661952,9.3454839 C86.7636556,9.34149297 86.5579327,9.33710295 86.3502202,9.33311202 C86.1425077,9.32952018 85.9324077,9.32552925 85.720716,9.32193741 C85.5082285,9.31794649 85.2949452,9.31475374 85.0796723,9.31196009 C84.8647973,9.30916644 84.6483306,9.30717098 84.4310681,9.3055746 C84.2142035,9.30397823 83.996941,9.30318005 83.7792806,9.30198277 C83.4509994,9.30078549 83.1211265,9.29879002 82.7904577,9.29679456 C82.459789,9.2944 82.1283244,9.29160635 81.7968598,9.28841361 C81.5899431,9.28681723 81.3830265,9.28482177 81.1765077,9.28362449 C80.969591,9.28242721 80.7638681,9.2828263 80.5597369,9.28641814 C80.3552077,9.29040907 80.1518723,9.29679456 79.9501285,9.30517551 C79.7479869,9.31355646 79.5462431,9.32393288 79.3452952,9.33470839 C79.1439494,9.34588299 78.9433994,9.3566585 78.7432473,9.36663583 C78.5426973,9.37741134 78.343341,9.38619138 78.143189,9.39417324 C77.9434348,9.40135692 77.7436806,9.40694422 77.5443244,9.40973787 C77.3449681,9.41253152 77.1460098,9.41293061 76.9470515,9.41053605 C76.748491,9.40854059 76.5499306,9.40375147 76.352564,9.3965678 C76.1547994,9.39018231 75.9582285,9.38140227 75.7632494,9.37182404 C75.5682702,9.36184671 75.3744848,9.3510712 75.182291,9.34029569 C74.9900973,9.32952018 74.7998931,9.31834558 74.6124744,9.30836825 C74.4246577,9.29799184 74.2396265,9.28921179 74.0573806,9.28122993 C73.8755327,9.27364717 73.6964702,9.26726168 73.520591,9.26327075 C73.3367535,9.2604771 73.1564973,9.260078 72.9802202,9.26087619 C72.8035452,9.26167438 72.6304515,9.26327075 72.4613369,9.2660644 C72.1235056,9.27244989 71.7999994,9.28162902 71.4924098,9.29240454 C71.1844223,9.30318005 70.8919535,9.31395556 70.6154015,9.32473107 C70.3388494,9.33470839 70.078214,9.34388753 69.8358827,9.35027302 C69.5927556,9.35745669 69.3687285,9.3622458 69.1641994,9.36503946 C68.755141,9.37102585 68.4264619,9.37501678 68.1924869,9.38060408 C68.0110369,9.3849941 67.7973556,9.38659048 67.5554223,9.38579229 C67.3142848,9.3849941 67.0444973,9.38220045 66.7508348,9.37860862 C66.4571723,9.37461769 66.1396348,9.37142494 65.8025994,9.37022766 C65.6338827,9.36982857 65.460789,9.37062676 65.283716,9.37262222 C65.1066431,9.37421859 64.9251931,9.37621406 64.7389681,9.37820952 C64.553141,9.3798059 64.3633348,9.38140227 64.1699473,9.38299864 C63.9765598,9.3849941 63.7803869,9.38619138 63.5810306,9.38778776 C63.3816744,9.38898503 63.1799306,9.39018231 62.9761973,9.3909805 C62.772464,9.39177868 62.566741,9.39217778 62.3602223,9.39257687 C62.1533056,9.39297596 61.9451952,9.39337506 61.7346973,9.39377415 C56.9286598,9.38818685 51.4588973,9.32153832 51.4588973,9.32153832",id:"Fill-160",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:125}}),_react2.default.createElement("path",{d:"M4.54046354,21.5659501 C4.53529063,21.6673197 4.53728021,21.9199456 4.59696771,22.1673832 C4.65665521,22.4148209 4.77563229,22.6586667 5.00801563,22.7576417 C5.12420729,22.8067302 5.44850938,22.952 5.88701354,23.1479546 C6.10626563,23.2457324 6.35934063,23.3558821 6.62833229,23.4736145 C6.89931354,23.5913469 7.18143646,23.7166621 7.46117188,23.8419773 C7.74090729,23.9680907 8.01984688,24.0930068 8.28446146,24.2115374 C8.54947396,24.330068 8.80055938,24.4410159 9.02219896,24.54039 C9.46508021,24.7387392 9.78580104,24.8915918 9.86697604,24.9526531 C10.1924719,25.1980952 10.5995406,25.5241542 11.1689594,25.4427392 C11.1689594,25.4427392 12.0917281,25.4563084 13.3407885,25.4730703 C13.9659156,25.4814512 14.6722177,25.4902313 15.3856823,25.4978141 C16.0991469,25.5053968 16.8189781,25.5113832 17.4711635,25.5141769 C18.1237469,25.5165714 18.7086844,25.5173696 19.1535552,25.5157732 C19.5976302,25.5149751 19.9012406,25.5109841 19.9887823,25.5038005 C20.0771198,25.4966168 20.601574,25.4910295 21.4192927,25.489034 C21.8279531,25.4878367 22.310626,25.4886349 22.8486094,25.4906304 C23.3865927,25.4930249 23.9802844,25.4966168 24.6141656,25.5041995 C24.9313052,25.5081905 25.2591885,25.5141769 25.5954281,25.5209615 C25.9320656,25.5285442 26.2762635,25.5365261 26.6260323,25.5457052 C26.975801,25.5548844 27.3307427,25.5640635 27.6912552,25.5696508 C27.8711135,25.5728435 28.0525635,25.574839 28.2340135,25.5764354 C28.4158615,25.5780317 28.5981073,25.579229 28.7803531,25.5800272 C28.962201,25.5804263 29.144049,25.5808254 29.325101,25.5812245 C29.5061531,25.5816236 29.6864094,25.5820227 29.8658698,25.58322 C30.2235969,25.5852154 30.576549,25.5880091 30.9211448,25.5916009 C31.2084406,25.5947937 31.4901656,25.5983855 31.7659219,25.6027755 C32.0412802,25.6071655 32.3114656,25.6115556 32.5744885,25.6151474 C32.8379094,25.6187392 33.0957594,25.6215329 33.3472427,25.6227302 C33.5979302,25.6239274 33.8434448,25.6231293 34.0817969,25.6199365 C34.320149,25.6163447 34.5517365,25.6115556 34.773774,25.6059683 C34.9958115,25.600381 35.2086969,25.5947937 35.4112365,25.5892063 C35.8159177,25.5780317 36.1784198,25.5680544 36.4883969,25.5612698 C37.108351,25.5465034 37.514624,25.540517 37.6224594,25.5437098 C37.719551,25.5461043 37.9618823,25.5445079 38.3136406,25.5421134 C38.4895198,25.5409161 38.6924573,25.5397188 38.9176781,25.5385215 C39.1421031,25.5377234 39.3892094,25.5373243 39.6530281,25.5373243 C39.9172448,25.5373243 40.2005615,25.5381224 40.4978052,25.5393197 C40.7954469,25.540517 41.1074135,25.5425125 41.4269406,25.544907 C41.7468656,25.5477007 42.074351,25.5508934 42.4030302,25.5556825 C42.7321073,25.5604717 43.0619802,25.5656599 43.387476,25.5724444 C43.7129719,25.5780317 44.0340906,25.5788299 44.3468531,25.5724444 C44.6596156,25.566059 44.9652156,25.5556825 45.259276,25.5441088 C45.5537344,25.5321361 45.8390406,25.5209615 46.1112156,25.5117823 C46.3833906,25.5022041 46.6436281,25.4958186 46.8871531,25.4922268 C47.1302802,25.4886349 47.355501,25.4882358 47.556449,25.4926259 C48.1588948,25.5053968 48.5412927,25.5209615 48.5719323,25.5225578 C48.654301,25.5265488 48.7490052,25.4750658 48.817049,25.3138322 C48.8854906,25.1521995 48.9280677,24.879619 48.9053865,24.4378231 C48.9010094,24.3496236 48.9061823,24.1389025 48.9189156,23.8268118 C48.9252823,23.668771 48.9328427,23.4839909 48.9415969,23.2768617 C48.9499531,23.0697324 48.960299,22.840254 48.9714406,22.5928163 C48.993724,22.097542 49.0160073,21.5272381 49.0343115,20.9078458 C49.0438615,20.5977506 49.0502281,20.2760816 49.0542073,19.9452336 C49.0581865,19.6147846 49.0597781,19.2755556 49.0593802,18.9303401 C49.0593802,18.5843265 49.0597781,18.2323265 49.0609719,17.8771338 C49.0621656,17.521542 49.0637573,17.1631565 49.0657469,16.8043719 C49.0673385,16.4459864 49.069726,16.0876009 49.0725115,15.7336054 C49.0752969,15.3792109 49.0788781,15.0288073 49.084051,14.6839909 C49.089224,14.3391746 49.0959885,14.0003447 49.103151,13.6718912 C49.1103135,13.3430385 49.1186698,13.0249615 49.127026,12.7204535 C49.1341885,12.4167438 49.1405552,12.1278005 49.1457281,11.8568163 C49.1505031,11.5854331 49.1544823,11.3324082 49.1564719,11.1005351 C49.1588594,10.8686621 49.1600531,10.657542 49.1600531,10.4695692 C49.160451,10.2823946 49.1592573,10.1175692 49.1572677,9.97988209 C49.1524927,9.70410884 49.141351,9.53449433 49.1242406,9.49418594 C49.0378927,9.29503855 48.9511469,9.20643991 48.654699,9.17930159 C48.506674,9.16533333 48.305726,9.16692971 48.0271844,9.17491156 C47.8883115,9.17930159 47.7291448,9.18488889 47.546899,9.19047619 C47.365051,9.19646259 47.159726,9.20244898 46.9281385,9.20803628 C46.8123448,9.21082993 46.6113969,9.21162812 46.3376302,9.21082993 C46.0638635,9.21003175 45.7172781,9.20803628 45.3110052,9.20524263 C45.1076698,9.20404535 44.8908052,9.20284807 44.6612073,9.20204989 C44.4316094,9.2012517 44.1892781,9.2012517 43.9350094,9.20204989 C43.6990448,9.20284807 43.4523365,9.20484354 43.1956802,9.20803628 C42.939024,9.21122902 42.6724198,9.21521995 42.3974594,9.21921088 C42.1161323,9.224 41.826449,9.22878912 41.530399,9.23238095 C41.2347469,9.2355737 40.9323302,9.23756916 40.6243427,9.23796825 C40.3163552,9.23836735 40.002001,9.23677098 39.6816781,9.23477551 C39.4095031,9.23278005 39.133349,9.23038549 38.8548073,9.22519728 C38.5766635,9.22040816 38.2961323,9.21362358 38.0132135,9.20444444 C37.7306927,9.1956644 37.4445906,9.18568707 37.1557031,9.17610884 C36.8664177,9.16692971 36.573551,9.15775057 36.277501,9.15056689 C35.981451,9.14338322 35.681024,9.1385941 35.3770156,9.13659864 C35.0730073,9.13500227 34.7658156,9.13619955 34.4562365,9.14058957 C34.1462594,9.14497959 33.8358844,9.15136508 33.5255094,9.15934694 C33.2155323,9.1673288 32.9043615,9.17650794 32.5947823,9.18568707 C32.2852031,9.19486621 31.9780115,9.20284807 31.6751969,9.20883447 C31.3727802,9.21442177 31.0747406,9.21761451 30.781874,9.21761451 C30.457174,9.21721542 30.137249,9.21601814 29.821701,9.21442177 C29.5097344,9.21082993 29.205726,9.20444444 28.9112677,9.19606349 C28.6168094,9.18728345 28.3299115,9.17690703 28.0509719,9.16573243 C27.7716344,9.15415873 27.4978677,9.14298413 27.2300698,9.1334059 C26.961874,9.12342857 26.6984531,9.11504762 26.4398073,9.10906122 C26.1811615,9.10267574 25.9268927,9.09948299 25.6781948,9.09828571 C25.429099,9.09708844 25.1859719,9.09828571 24.9500073,9.10107937 C24.7140427,9.10387302 24.4868323,9.10826304 24.2691719,9.11305215 C24.0515115,9.11784127 23.8449927,9.12302948 23.6500135,9.12821769 C23.2747781,9.13819501 22.9464969,9.14697506 22.673924,9.15256236 C22.129176,9.16413605 21.8032823,9.16692971 21.7447885,9.16333787 C21.6878865,9.16014512 21.5000698,9.15974603 21.2111823,9.16014512 C21.0663406,9.16054422 20.8964302,9.16094331 20.7034406,9.16253968 C20.5112469,9.16373696 20.2963719,9.16533333 20.0623969,9.1673288 C19.5948448,9.17131973 19.0520865,9.17690703 18.4627719,9.18209524 C18.1683135,9.18488889 17.8623156,9.18688435 17.5483594,9.18848073 C17.234801,9.19047619 16.9140802,9.19087528 16.590574,9.18808163 C16.2670677,9.18568707 15.9403781,9.18049887 15.6140865,9.1729161 C15.2873969,9.16613152 14.9603094,9.15775057 14.6352115,9.14976871 C14.3101135,9.14098866 13.9866073,9.13380499 13.6674781,9.1274195 C13.348349,9.12103401 13.032801,9.11744218 12.7244156,9.11544671 C12.4164281,9.11345125 12.1148073,9.11424943 11.824726,9.1162449 C11.533849,9.11824036 11.2545115,9.12143311 10.9902948,9.12542404 C10.7256802,9.12941497 10.4761865,9.1334059 10.2453948,9.13699773 C10.0146031,9.14098866 9.80291146,9.1445805 9.61310521,9.14777324 C9.47502813,9.1501678 9.34928646,9.15216327 9.23667604,9.15336054 C9.12446354,9.15535601 9.02498438,9.15775057 8.94022813,9.16054422 C8.75559479,9.16692971 8.63900521,9.17131973 8.60478438,9.1729161 C8.50172396,9.17690703 8.36444271,9.17890249 8.20686771,9.18129705 C8.04889479,9.18369161 7.87182188,9.18528798 7.69554479,9.18688435 C7.52085938,9.18808163 7.34975521,9.18887982 7.20252604,9.19287075 C7.05569479,9.19726077 6.93353438,9.20564172 6.84957396,9.22519728 C6.79346771,9.23796825 6.72263854,9.2750839 6.64424896,9.33135601 C6.56585938,9.38722902 6.48189896,9.4626576 6.39953021,9.55404989 C6.31716146,9.64544218 6.23797604,9.75439456 6.16714688,9.87731519 C6.09631771,10.0006349 6.03225313,10.1379229 5.97614688,10.2831927 C5.91964271,10.4308571 5.86910729,10.5825125 5.82692813,10.7289796 C5.78275938,10.876644 5.74575313,11.0179229 5.72068438,11.1464308 C5.70397188,11.2318367 5.68049479,11.3264218 5.65025313,11.4373696 C5.61762396,11.5479184 5.57823021,11.6764263 5.52968438,11.8300771 C5.49188229,11.949805 5.44612188,12.0850975 5.39439271,12.2403447 C5.34186771,12.3951927 5.28615938,12.5711927 5.22846146,12.7711383 C5.17872188,12.9463401 5.12977813,13.1402993 5.08361979,13.3558095 C5.06093854,13.4631655 5.04064479,13.5757098 5.02234063,13.6934422 C5.00363854,13.8111746 4.98851771,13.9336961 4.97538646,14.0614059 C4.96225521,14.1895147 4.95071563,14.3228118 4.94076771,14.4612971 C4.93081979,14.6001814 4.92126979,14.7446531 4.91171979,14.8959093 C4.90137396,15.0467664 4.89102813,15.2040091 4.87948854,15.3672381 C4.86715313,15.5304671 4.85441979,15.7000816 4.84049271,15.8760816 C4.82656563,16.0524807 4.81104688,16.2356644 4.79393646,16.4248345 C4.77642813,16.6148027 4.75732813,16.8111565 4.73743229,17.0142948 C4.71753646,17.2174331 4.69843646,17.4281542 4.67973438,17.646059 C4.66063438,17.8639637 4.64153438,18.0894512 4.62323021,18.3237188 C4.60771146,18.5188753 4.59497813,18.7212154 4.58662188,18.929941 C4.57826563,19.1382676 4.57388854,19.3529796 4.57229688,19.5740771 C4.57070521,19.7947755 4.57030729,20.0214603 4.56951146,20.2541315 C4.56871563,20.4864036 4.56593021,20.7250612 4.56115521,20.968907 C4.55677813,21.1640635 4.54961563,21.3632109 4.54046354,21.5659501",id:"Fill-162",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:126}}),_react2.default.createElement("path",{d:"M107.589977,46.8179592 C107.570479,46.2292971 107.551777,45.6450249 107.539044,45.065542 C107.526709,44.486458 107.518352,43.9133605 107.515567,43.3398639 C107.513577,42.7831293 107.512781,42.2271927 107.515965,41.6748481 C107.517954,41.4138413 107.533075,41.1532336 107.548196,40.8926259 C107.561327,40.6595556 107.601119,40.4073288 107.570877,40.1750567 C107.543421,39.9655329 107.578836,39.7691791 107.588784,39.5572608 C107.600323,39.3162086 107.594752,39.0747574 107.589181,38.8333061 C107.576846,38.3001179 107.564113,37.7673288 107.551379,37.2345397 C107.550186,37.1910385 107.548594,37.1439456 107.521536,37.1096236 C107.497263,37.0780952 107.457073,37.064127 107.418873,37.0529524 C107.286367,37.0150385 107.147892,36.9974785 107.010213,37.0010703 C106.770667,37.008254 106.55619,37.0333968 106.320623,37.0094512 C106.074711,36.9843084 105.808106,37.0321995 105.559806,37.0282086 C105.075144,37.0190295 104.590084,37.0166349 104.105023,37.0166349 C103.500588,37.017034 102.885011,37.0218231 102.263465,37.0258141 C101.642715,37.0294059 101.021169,37.0357914 100.404796,37.0413787 C99.789219,37.0473651 99.1788148,37.0533515 98.5791544,37.0585397 C97.9512419,37.0637279 97.3388481,37.0705125 96.7344127,37.0784943 C96.1299773,37.0860771 95.5315106,37.094059 94.9366252,37.1020408 C93.748844,37.1184036 92.5622565,37.1160091 91.3744752,37.1036372 C90.4218627,37.094059 89.4708419,37.0880726 88.519821,37.0848798 C87.5691981,37.0816871 86.6185752,37.081288 85.6663606,37.0824853 C84.714544,37.0840816 83.7603398,37.090068 82.8037481,37.1032381 C81.8463606,37.11122 80.8841981,37.1203991 79.9160669,37.1267846 C78.9483335,37.132771 77.9742335,37.1319728 76.9973481,37.1255873 C76.0212585,37.1148118 75.0419856,37.1148118 74.0595294,37.1231927 C73.077869,37.1315737 72.0954127,37.1439456 71.1133544,37.1559184 C70.131694,37.1674921 69.152421,37.1770703 68.1775252,37.1794649 C67.2022315,37.1814603 66.2325085,37.1710839 65.2691523,37.145941 C64.3053981,37.12 63.3468169,37.0836825 62.3906231,37.0485624 C61.3182377,37.008254 60.2462502,36.9731338 59.1754565,36.9519819 C58.1046627,36.931229 57.0346648,36.926839 55.9646669,36.9332245 C54.894271,36.93961 53.8234773,36.9507846 52.750694,36.9603628 C51.6779106,36.969542 50.6039335,36.9771247 49.5295585,36.9875011 C48.4551835,36.9978776 47.3804106,37.0078549 46.3072294,37.0150385 C45.2336502,37.0218231 44.160071,37.0222222 43.086094,37.0154376 C42.0121169,37.0094512 40.937344,36.9978776 39.8617752,36.9843084 C38.7858085,36.9711383 37.7086481,36.9591655 36.630294,36.952381 C35.6717127,36.9463946 34.7119377,36.9475918 33.750969,36.9579683 C32.561994,36.9759274 31.3658565,37.0046621 30.1633523,37.0314014 C28.9576648,37.0737052 27.7507835,37.1056327 26.5439023,37.111619 C25.3692523,37.1168073 24.1969898,37.0960544 23.0291044,37.0753016 C21.8620148,37.0541497 20.7000981,37.0282086 19.5445481,37.0226213 C18.9444898,37.0198277 18.3472169,37.0182313 17.7515356,37.0178322 C17.1554565,37.0174331 16.5625606,37.0182313 15.9720523,37.0198277 C15.381146,37.0206259 14.7906377,37.0210249 14.1997315,37.0194286 C13.6084273,37.0174331 13.0159294,37.0142404 12.421044,37.0090522 C11.8265565,37.0038639 11.2288856,36.9978776 10.6296231,36.9918912 C10.0303606,36.9855057 9.43030229,36.9815147 8.83223354,36.9795193 C8.23376688,36.9779229 7.63450438,36.9791202 7.03444604,36.9835102 C6.43438771,36.9882993 5.83273771,36.9970794 5.23029188,37.0114467 C4.25539604,37.034195 3.28129604,37.0661224 2.31873563,37.1020408 C2.23000021,37.1052336 2.14285646,37.1088254 2.05412104,37.1120181 L2.05412104,37.2002177 C2.05730438,37.6196644 2.06406896,38.0391111 2.07401688,38.4589569 C2.08436271,38.8784036 2.09749396,39.2970522 2.11142104,39.7141043 C2.12534813,40.1311565 2.13927521,40.5462132 2.15280438,40.9592744 C2.16673146,41.3719365 2.17827104,41.781805 2.18702521,42.1876825 C2.19617729,42.5939592 2.20214604,42.9970431 2.20493146,43.3965351 C2.20811479,43.7964263 2.20731896,44.1927256 2.20572729,44.5870295 C2.20413563,44.9809342 2.20254396,45.3728435 2.20254396,45.7623583 C2.20294188,47.2529705 2.21129813,48.7639365 2.29883979,50.2585397 C2.33067313,50.800907 2.39752313,51.534839 1.74573563,51.5879184 C1.57184604,51.6018866 1.39915021,51.667737 1.27420438,51.7898594 C0.974175208,52.0831927 1.06171688,52.7029841 1.04977938,53.080127 C1.03386271,53.5813878 1.01715021,54.0822494 1.00202938,54.5831111 C0.993673125,54.8385306 1.00282521,55.1330612 1.20178354,55.2919002 C1.30245646,55.3729161 1.43416688,55.4012517 1.56030646,55.4271927 C2.27098563,55.574059 2.97927729,55.7324989 3.68557938,55.8989206 C4.76273979,56.1527438 5.82398354,56.4257234 6.90034813,56.6779501 C7.36073771,56.7861043 7.82232104,56.8938594 8.27355854,57.0064036 C8.72479604,57.1193469 9.16648354,57.2342857 9.58787729,57.3536145 C9.96191896,57.4601723 10.3375523,57.5631383 10.7135835,57.6597188 C11.0900127,57.7559002 11.4684315,57.8440998 11.8484419,57.9231202 C12.2312377,57.9925624 12.616819,58.0508299 13.0047877,58.0995193 C13.3927565,58.1478095 13.7823169,58.1901134 14.1722752,58.2260317 C14.5626315,58.2619501 14.9533856,58.2930794 15.3449356,58.3194195 C15.7360877,58.3465578 16.1276377,58.3681088 16.5195856,58.3848707 C16.9111356,58.4020317 17.3042773,58.4152018 17.697021,58.4231837 C18.0901627,58.4303673 18.4825085,58.4327619 18.8740585,58.4303673 C19.2656085,58.4283719 19.6563627,58.4231837 20.0451273,58.4163991 C20.4342898,58.4100136 20.8214627,58.4024308 21.2078398,58.3956463 C21.5942169,58.3880635 21.9790023,58.3820771 22.362196,58.3760907 C22.7457877,58.3705034 23.1281856,58.3665125 23.5101856,58.364517 C23.8917877,58.3617234 24.2729919,58.3597279 24.654196,58.3569342 C25.0354002,58.3541406 25.4170023,58.3505488 25.7990023,58.3469569 C25.8821669,58.3457596 25.9657294,58.342966 26.048894,58.3413696 C32.4585356,58.4108118 46.3223502,58.5377234 48.0930794,58.3058503 C50.3811002,58.0065306 67.1930794,57.9067574 67.1930794,57.9067574 C68.1043085,58.0161088 70.8650544,58.1063039 74.9480773,58.1813333 C75.082971,58.1964989 75.2158752,58.2116644 75.3519627,58.2260317 C76.2345419,58.3178231 77.1616877,58.2890884 78.0892315,58.2324172 C85.5394252,58.3397732 96.0257231,58.4096145 107.448717,58.4543129 C107.554165,57.9227211 107.584804,57.36439 107.596742,56.887873 C107.607486,56.436898 107.595548,55.9827302 107.584009,55.5253696 C107.573265,55.0684082 107.562521,54.6090522 107.575652,54.1484989 C107.594354,53.5067574 107.629769,52.8682086 107.655236,52.2368435 C107.6811,51.6058776 107.699006,50.985288 107.689854,50.3666939 C107.680702,49.7752381 107.664786,49.1829841 107.647675,48.589932 C107.630565,47.997678 107.609475,47.4062222 107.589977,46.8179592 M182.744896,53.6747755 C182.735744,53.1320091 182.727388,52.5888435 182.724602,52.045678 C182.722215,51.5021134 182.728581,50.9585488 182.739325,50.4149841 C182.749273,49.8706213 182.757231,49.3270567 182.760017,48.783093 C182.762404,48.2391293 182.760813,47.6947664 182.75564,47.1508027 C182.750467,46.606839 182.742111,46.0624762 182.731367,45.5189116 C182.720225,44.9753469 182.708288,44.4317823 182.695554,43.8882177 C182.657752,42.2726893 182.709481,40.6336145 182.701523,39.0109025 C182.699136,38.5048526 182.681627,37.9549025 182.361702,37.5629932 C181.980498,37.0952562 181.406304,37.0852789 180.858373,37.0337959 C180.325165,36.9835102 179.852838,36.9064853 179.304509,36.9220499 C179.025569,36.9304308 178.752598,36.9443991 178.493952,36.9487891 C178.197106,36.9535782 177.901056,36.9587664 177.604609,36.9635556 C176.715265,36.9779229 175.825523,36.9906939 174.936179,36.999873 C174.315031,37.0066576 173.693486,37.0122449 173.07194,37.0154376 C171.997963,37.0222222 170.924384,37.0218231 169.850804,37.0150385 C168.777225,37.0078549 167.70285,36.9978776 166.628475,36.9875011 C165.5541,36.9771247 164.480123,36.969542 163.406942,36.9603628 C162.334556,36.9507846 161.263763,36.93961 160.193367,36.9332245 C159.123369,36.926839 158.053371,36.931229 156.982577,36.9519819 C155.911784,36.9731338 154.839796,37.008254 153.767411,37.0485624 C152.811217,37.0836825 151.852238,37.12 150.888881,37.145941 C149.925525,37.1710839 148.955802,37.1814603 147.980509,37.1794649 C147.005613,37.1770703 146.02634,37.1674921 145.044281,37.1559184 C144.062621,37.1439456 143.079767,37.1315737 142.098106,37.1231927 C141.116048,37.1148118 140.136377,37.1148118 139.160686,37.1255873 C138.183402,37.1319728 137.210098,37.132771 136.241967,37.1267846 C135.273836,37.1203991 134.311673,37.11122 133.354286,37.1032381 C132.397296,37.090068 131.44349,37.0840816 130.491673,37.0824853 C129.539459,37.081288 128.588438,37.0816871 127.638213,37.0848798 C126.687192,37.0880726 125.736171,37.094059 124.783559,37.1036372 C123.595777,37.1160091 122.40919,37.1184036 121.221409,37.1020408 C120.626523,37.094059 120.028056,37.0860771 119.423223,37.0784943 C118.819186,37.0705125 118.206792,37.0637279 117.579277,37.0585397 C116.979219,37.0533515 116.367621,37.046966 115.746473,37.0401814 C115.121346,37.0329977 114.485475,37.025415 113.841646,37.0190295 C113.198215,37.0134422 112.556375,37.0058594 111.925279,37.0022676 C111.419129,36.9994739 110.914173,36.9990748 110.411604,37.0050612 C110.154152,37.008254 109.882375,36.9591655 109.630096,36.982712 C109.387765,37.0062585 109.1709,36.9803175 108.928967,36.9731338 C108.790094,36.9687438 108.650027,36.9859048 108.515531,37.0238186 C108.476934,37.034195 108.435948,37.0485624 108.410481,37.0796916 C108.381831,37.1136145 108.377454,37.1599093 108.374669,37.2030113 C108.338459,37.7286168 108.302646,38.2514286 108.268027,38.7730431 C108.252906,39.0093061 108.238184,39.244771 108.241765,39.4802358 C108.244948,39.686966 108.273996,39.8781315 108.241367,40.0828662 C108.204759,40.3091519 108.239775,40.5557914 108.249325,40.7828753 C108.260865,41.0370975 108.273598,41.2913197 108.276384,41.5467392 C108.281954,42.0879093 108.290311,42.6350658 108.304238,43.1870113 C108.318563,43.7553197 108.333286,44.3288163 108.349202,44.9138866 C108.365119,45.499356 108.38024,46.0952018 108.396156,46.6990295 C108.412073,47.3028571 108.424806,47.9114739 108.431969,48.5224853 C108.439927,49.1330975 108.434754,49.7433107 108.429581,50.349932 C108.418838,50.9816961 108.429979,51.6114649 108.438336,52.2468209 C108.446294,52.8813787 108.455446,53.5211247 108.444702,54.1628662 C108.43754,54.6238186 108.4069,55.0815782 108.377454,55.5373424 C108.348406,55.9931066 108.322144,56.4452789 108.322144,56.8938594 C108.322144,57.368381 108.344825,57.9231202 108.446294,58.4515193 C108.796461,58.4499229 109.148617,58.4491247 109.503956,58.4475283 C109.8585,58.4463311 110.216625,58.4451338 110.577138,58.4435374 C110.937252,58.4423401 111.300152,58.4407438 111.664246,58.4395465 C112.028738,58.4383492 112.394025,58.4367528 112.760109,58.4351565 C113.125794,58.4339592 113.491479,58.4327619 113.855573,58.4311655 C114.219667,58.4299683 114.582169,58.4283719 114.942284,58.4267755 C115.302,58.42478 115.658931,58.4231837 116.012281,58.4215873 C116.365234,58.4195918 116.713809,58.4183946 117.056017,58.4179955 C117.740831,58.4175964 118.409331,58.4195918 119.070669,58.4239819 C119.978715,58.4299683 120.873629,58.4383492 121.754219,58.4495238 C122.634809,58.4599002 123.501471,58.4714739 124.354206,58.4834467 C125.206146,58.4958186 126.044556,58.5065941 126.86705,58.5165714 C127.69034,58.5265488 128.498509,58.5341315 129.290761,58.5389206 C130.347229,58.5457052 131.375844,58.5465034 132.373819,58.5409161 C133.372192,58.5353288 134.339925,58.5261497 135.276223,58.5185669 C136.212919,58.5113832 137.117384,58.5077914 137.984444,58.5065941 C138.9287,58.5812245 139.874946,58.6291156 140.777421,58.5568798 C140.917488,58.5461043 141.053575,58.5333333 141.191652,58.5217596 C142.236979,58.5293424 143.198346,58.5333333 144.066202,58.5345306 C144.934059,58.5357279 145.707609,58.5333333 146.378098,58.5265488 C147.719077,58.5129796 148.651794,58.4830476 149.114173,58.4379501 C149.114173,58.4379501 149.587694,58.4495238 150.384721,58.4662857 C151.181748,58.4826485 152.299894,58.5026032 153.591531,58.510585 C154.883567,58.5181678 156.347104,58.5077914 157.838098,58.4874376 C158.583794,58.4774603 159.335856,58.4646893 160.076777,58.4507211 C160.818096,58.4371519 161.548273,58.4231837 162.249004,58.4100136 C163.650865,58.3832744 164.939319,58.368907 165.971913,58.372898 C167.004109,58.3764898 167.78124,58.3984399 168.159261,58.4395465 C168.765288,58.5820227 169.503821,58.4966168 170.122979,58.5045986 C171.318321,58.5201633 172.512469,58.5153741 173.706219,58.5069932 C174.095381,58.5041995 174.483748,58.5006077 174.872513,58.4970159 C175.267246,58.4930249 175.661581,58.489034 176.064273,58.4842449 C176.466965,58.4798549 176.877217,58.4750658 177.293438,58.4698776 C177.709659,58.4650884 178.131052,58.4599002 178.556425,58.454712 C178.893859,58.450322 179.242036,58.4614966 179.594192,58.4778594 C179.946746,58.4942222 180.302484,58.5161723 180.656231,58.5357279 C181.362931,58.574839 182.053715,58.6019773 182.686402,58.5461043 C182.722613,58.0065306 182.747681,57.4665578 182.760415,56.9253878 C182.773546,56.3850159 182.776331,55.8434467 182.770363,55.3018776 C182.763996,54.7595102 182.754446,54.217542 182.744896,53.6747755",id:"Fill-164",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:127}}),_react2.default.createElement("path",{d:"M22.4556667,48.2447964 C22.3207729,48.182937 22.17235,48.1805424 22.0267125,48.1817397 C21.7219083,48.1849324 21.4127271,48.1989007 21.0939958,48.2168599 C20.7752646,48.234819 20.4469833,48.2555719 20.1071625,48.2675447 C19.8636375,48.2755265 19.6157354,48.2771229 19.3642521,48.2743293 C19.1131667,48.2711365 18.8585,48.2639528 18.6018438,48.2543746 C18.3447896,48.2451955 18.0885313,48.23442 17.8322729,48.226039 C17.5756167,48.2180571 17.3197563,48.2128689 17.0623042,48.213268 C16.8573771,48.213268 16.6516542,48.2140662 16.4455333,48.2156626 C16.2398104,48.217658 16.0336896,48.2200526 15.8275688,48.2232454 C15.62105,48.2268372 15.4149292,48.2308281 15.2088083,48.2352181 C15.0030854,48.23881 14.7973625,48.2432 14.5928333,48.2471909 C14.3202604,48.25198 14.0520646,48.2547737 13.7910313,48.2551728 C13.5976438,48.2555719 13.4070417,48.2551728 13.2176333,48.2543746 C13.0286229,48.2531773 12.8408063,48.25198 12.6537854,48.2503837 C12.4576125,48.2483882 12.2506958,48.2503837 12.0787958,48.3533497 C11.9072938,48.4563156 11.7907042,48.6945741 11.87745,48.8893315 C11.9757354,49.1112272 12.2463188,49.1475447 12.4671625,49.1527329 C12.6541833,49.1571229 12.842,49.1611138 13.0314083,49.1639075 C13.2208167,49.1671002 13.4118167,49.1686966 13.606,49.1694948 C13.7997854,49.1698939 13.9967542,49.1690957 14.1957125,49.1671002 C14.3950688,49.1647057 14.5968125,49.1615129 14.8005458,49.1571229 C15.0062688,49.1523338 15.2123896,49.1475447 15.4185104,49.1427556 C15.6246313,49.1379664 15.8315479,49.1335764 16.0372708,49.1303837 C16.3810708,49.1243973 16.7248708,49.1208054 17.067875,49.1208054 C17.4104813,49.1208054 17.7538833,49.1220027 18.0964896,49.1239982 C18.4394938,49.1255946 18.7832938,49.1263927 19.1223188,49.1247964 C19.4609458,49.1235991 19.7904208,49.1208054 20.1111417,49.1180118 C20.4318625,49.114819 20.7438292,49.1116263 21.0474396,49.1128236 C21.3506521,49.1140209 21.6459063,49.1196082 21.9367833,49.1287873 C22.2025917,49.1379664 22.635525,49.0872816 22.7127208,48.7057488 C22.7517167,48.513785 22.6156292,48.3214222 22.4556667,48.2447964",id:"Fill-166",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:128}}),_react2.default.createElement("path",{d:"M12.923931,47.5658594 C13.1169206,47.5666576 13.310706,47.5678549 13.5052873,47.5690522 C13.7002665,47.5706485 13.898429,47.5706485 14.0993769,47.5702494 C14.3003248,47.5698503 14.5040581,47.568254 14.7089852,47.5662585 C14.915504,47.5638639 15.1220227,47.5614694 15.3285415,47.5594739 C15.5350602,47.5574785 15.741579,47.5558821 15.9476998,47.5546848 C16.204754,47.5534875 16.462206,47.5534875 16.7184644,47.5534875 C16.9755185,47.5538866 17.2317769,47.5542857 17.4880352,47.5546848 C17.7438956,47.5550839 18.000154,47.5558821 18.2564123,47.5566803 C18.5126706,47.5574785 18.7693269,47.5578776 19.0271769,47.5574785 C19.3693852,47.5562812 19.7068185,47.5538866 20.033906,47.551093 C20.3605956,47.5482993 20.6769394,47.5455057 20.9849269,47.542712 C21.2917206,47.5411156 21.590556,47.542712 21.8842185,47.5482993 C22.1528123,47.5534875 22.5925102,47.4968163 22.6860206,47.1144853 C22.7333727,46.9225215 22.5992748,46.7349478 22.436129,46.662712 C22.2984498,46.6048435 22.1452519,46.6056417 21.9948394,46.6096327 C21.6800873,46.6180136 21.3609581,46.6379683 21.0362581,46.6587211 C20.7107623,46.6790748 20.3765123,46.6994286 20.0283352,46.709805 C19.7788415,46.7177868 19.5257665,46.718585 19.2714977,46.7149932 C19.0176269,46.7110023 18.7629602,46.7030204 18.5082935,46.6934422 C18.2540248,46.6846621 17.999756,46.6750839 17.7446915,46.6675011 C17.4904227,46.6603175 17.2349602,46.6555283 16.9790998,46.6559274 C16.7745706,46.6563265 16.5692456,46.6567256 16.3639206,46.6567256 L15.746354,46.6567256 C15.5398352,46.6567256 15.3337144,46.6567256 15.1267977,46.6571247 C14.920279,46.6575238 14.7129644,46.6579229 14.5068435,46.658322 C14.2310873,46.6591202 13.9589123,46.6587211 13.6899206,46.6579229 C13.4937477,46.6571247 13.2983706,46.6563265 13.1041873,46.6563265 C12.910004,46.6563265 12.7166165,46.6567256 12.522831,46.658322 C12.3194956,46.6595193 12.1042227,46.6659048 11.9267519,46.774059 C11.749281,46.8818141 11.6318956,47.1244626 11.725804,47.3172245 C11.8336394,47.5371247 12.1161602,47.5650612 12.3445644,47.5646621 C12.5379519,47.564263 12.7309415,47.5646621 12.923931,47.5658594",id:"Fill-168",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:129}}),_react2.default.createElement("path",{d:"M12.8022879,45.9761125 C13.0028379,45.9757134 13.2033879,45.9761125 13.4047338,45.9773098 C13.6056817,45.9789061 13.8082213,45.9809016 14.0123525,45.9828971 C14.2164838,45.9848925 14.4218088,45.986888 14.6283275,45.9888834 C14.8344483,45.9908789 15.041365,45.9924753 15.2478838,45.9940717 C15.4548004,45.9952689 15.6617171,45.9964662 15.86744,45.9972644 C16.2108421,45.9988608 16.5534483,46.000058 16.894065,46.0004571 C17.2354775,46.0008562 17.5752983,46.0008562 17.9151192,46.0008562 C18.2545421,46.0008562 18.593965,46.0008562 18.93299,46.0004571 C19.272015,46.000058 19.6090504,45.9992599 19.9425046,45.9976635 C20.2763567,45.9952689 20.6010567,45.9944707 20.9166046,45.9948698 C21.2317546,45.9952689 21.5405379,45.9968653 21.84574,45.9988608 C22.1254754,46.0008562 22.5838754,45.9377995 22.6761921,45.5746249 C22.7231463,45.3914413 22.5779067,45.2158404 22.4056088,45.1487927 C22.2599713,45.0937179 22.0996108,45.0945161 21.9432296,45.0969107 C21.6157442,45.1028971 21.2858713,45.1152689 20.9500296,45.1268426 C20.6133921,45.1388154 20.26999,45.1511873 19.9230067,45.1559764 C19.6743088,45.1599673 19.4244171,45.1587701 19.1737296,45.1551782 C18.92344,45.1523846 18.6719567,45.1448018 18.4188817,45.13682 C18.1658067,45.1288381 17.9127317,45.119659 17.6588608,45.1128744 C17.40499,45.1060898 17.1507213,45.1013007 16.8952588,45.1016998 C16.6907296,45.1016998 16.4862004,45.1016998 16.2804775,45.1013007 C16.0755504,45.1005025 15.8690317,45.1001034 15.6625129,45.0989061 C15.4559942,45.0977088 15.2494754,45.0961125 15.0433546,45.094117 C14.8368358,45.0921215 14.6311129,45.0901261 14.42539,45.0877315 C14.1512254,45.0849379 13.8778567,45.0817451 13.6044879,45.0793506 C13.4023463,45.0777542 13.2006025,45.0773551 12.9996546,45.0773551 C12.7983088,45.0777542 12.5973608,45.0789515 12.3968108,45.0809469 C12.1867108,45.0837406 11.9646733,45.0909243 11.7788463,45.2006748 C11.5934171,45.3100263 11.4668796,45.5546703 11.5619817,45.7458358 C11.670215,45.9637406 11.9634796,45.9860898 12.2006379,45.982498 C12.4015858,45.9789061 12.6021358,45.9769107 12.8022879,45.9761125",id:"Fill-170",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:130}}),_react2.default.createElement("path",{d:"M12.0830138,44.4031274 C12.2895325,44.3999347 12.4944596,44.3987374 12.6997846,44.3987374 C12.9047117,44.3983383 13.1092408,44.3995356 13.31377,44.4015311 C13.5182992,44.4039256 13.7228283,44.4067193 13.9277554,44.409912 C14.1322846,44.4127057 14.3372117,44.4158984 14.5425367,44.4190912 C14.7474638,44.4222839 14.9531867,44.4254766 15.1589096,44.4278712 C15.3650304,44.4302658 15.5711513,44.4326603 15.7772721,44.4346558 C15.9837908,44.4362522 16.1891158,44.4378485 16.3944408,44.4390458 C16.6001638,44.4402431 16.804295,44.4410413 17.0084263,44.4414404 C17.2129554,44.4418395 17.4162908,44.4418395 17.6196263,44.4414404 C17.8229617,44.4414404 18.0262971,44.4406422 18.2284388,44.4402431 C18.4309783,44.4394449 18.6327221,44.4382476 18.8332721,44.4370503 C19.0334242,44.4362522 19.2327804,44.4362522 19.4309429,44.4378485 C19.6291054,44.4390458 19.8260742,44.4418395 20.022645,44.4454313 C20.2188179,44.4494222 20.4149908,44.4542113 20.6111638,44.4593995 C20.8065408,44.4641887 21.0011221,44.4693769 21.1945096,44.4749642 C21.388295,44.4801524 21.5804888,44.4849415 21.7714888,44.4897306 C22.0635596,44.4961161 22.5398658,44.4362522 22.6246221,44.0674902 C22.6675971,43.8815129 22.5092263,43.7011229 22.3269804,43.6304834 C22.1725888,43.5730141 22.0062596,43.5722159 21.8443075,43.572615 C21.5056804,43.5738122 21.1674513,43.581395 20.8288242,43.5881796 C20.4901971,43.5945651 20.1495804,43.6009506 19.8069742,43.6005515 C19.5614596,43.6001524 19.3151492,43.5957624 19.0672471,43.5893769 C18.8189471,43.5829914 18.5686575,43.5758077 18.3163783,43.5674268 C18.0637013,43.559844 17.8110242,43.5502658 17.5567554,43.5434812 C17.3028846,43.5362975 17.0482179,43.5311093 16.7919596,43.5307102 C16.5189888,43.5307102 16.24562,43.529912 15.9714554,43.5287147 C15.6972908,43.5271184 15.4235242,43.5251229 15.1493596,43.5223293 C14.8759908,43.5191365 14.6026221,43.5159438 14.3300492,43.512751 C14.0574763,43.5091592 13.7856992,43.5051683 13.5151158,43.5015764 C13.3145658,43.4991819 13.11322,43.4971864 12.9118742,43.4959891 C12.7105283,43.4947918 12.5087846,43.4943927 12.3070408,43.4947918 C12.0953492,43.4947918 11.8729138,43.4991819 11.6827096,43.6073361 C11.4929033,43.7150912 11.3540304,43.9625288 11.44197,44.1588825 C11.542245,44.3819755 11.8398867,44.4063202 12.0830138,44.4031274",id:"Fill-172",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:131}}),_react2.default.createElement("path",{d:"M88.4950706,54.6941787 C88.4421477,54.6857977 88.3896227,54.6786141 88.3374956,54.6714304 C88.1807165,54.6510766 88.0243352,54.6351129 87.8667602,54.6239383 C87.7091852,54.6127637 87.5492227,54.6075755 87.385679,54.6087728 C87.2217373,54.609571 87.0526227,54.6171537 86.8803248,54.626732 C86.7080269,54.6367093 86.535331,54.6462875 86.3666144,54.6554667 C86.2432602,54.6622512 86.1238852,54.6590585 86.0112748,54.6574621 C85.8986644,54.6562649 85.7912269,54.6566639 85.6925435,54.6714304 C85.5934623,54.6861968 85.5023394,54.7157297 85.4207665,54.7712036 C85.3391935,54.8266776 85.2671706,54.9088907 85.2042998,55.030215 C85.1668956,55.103249 85.1895769,55.1990313 85.2349394,55.2644825 C85.3411831,55.4233215 85.4677206,55.4987501 85.6065935,55.5310766 C85.7458644,55.5630041 85.8998581,55.5506322 86.0586269,55.5358658 C86.1648706,55.5262875 86.2742977,55.5151129 86.3813373,55.5147138 C86.5027019,55.5131175 86.6248623,55.515512 86.7478185,55.5183057 C86.8707748,55.5210993 86.994129,55.5254893 87.1158915,55.5278839 C87.237654,55.5306776 87.3582227,55.5334712 87.4783935,55.5338703 C87.5973706,55.5350676 87.7155519,55.5354667 87.8333352,55.5334712 C88.0422415,55.5286821 88.2555248,55.5290812 88.4497081,55.4644281 C88.6434935,55.3997751 88.8185769,55.2549043 88.8448394,55.0585506 C88.8567769,54.9683556 88.8332998,54.8637932 88.760481,54.7947501 C88.6896519,54.7273034 88.588581,54.708546 88.4950706,54.6941787",id:"Fill-174",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:132}}),_react2.default.createElement("path",{d:"M186.999222,41.1448925 C186.981316,41.065473 186.948289,40.9856544 186.89656,40.9233959 C186.869103,40.8898721 186.835678,40.8623347 186.796682,40.841981 C186.706753,40.7964844 186.60051,40.8004753 186.499439,40.8052644 C186.279391,40.816439 186.060935,40.8192327 185.842876,40.8196317 C185.648295,40.8200308 185.399199,40.8044662 185.217749,40.8814912 C184.907374,41.0131918 184.801528,41.5284209 185.216555,41.5368018 C185.68928,41.5471782 186.16678,41.5451828 186.640301,41.5236317 C186.71113,41.520439 186.784347,41.5164481 186.84881,41.4853188 C186.978132,41.4226612 187.02827,41.2769923 186.999222,41.1448925",id:"Fill-176",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:133}}),_react2.default.createElement("path",{d:"M135.251035,55.0932717 C135.198112,55.0848907 135.145189,55.077707 135.093062,55.0705234 C134.936681,55.0501696 134.7803,55.0342059 134.622725,55.0230313 C134.464752,55.0122558 134.305187,55.0066685 134.141245,55.0078658 C133.977702,55.009063 133.808587,55.0166458 133.635891,55.0258249 C133.463991,55.0358023 133.291295,55.0453805 133.122579,55.0545596 C132.999225,55.0613442 132.87985,55.0581515 132.767239,55.0565551 C132.654231,55.0553578 132.547191,55.056156 132.44811,55.0709224 C132.349427,55.0856889 132.258304,55.1148227 132.176333,55.1702966 C132.095158,55.2257705 132.022737,55.3079837 131.960264,55.4293079 C131.922462,55.502342 131.945541,55.5981243 131.990904,55.6635755 C132.097148,55.8224145 132.223287,55.8982422 132.36216,55.9301696 C132.501431,55.9620971 132.655823,55.9497252 132.814591,55.9353578 C132.920437,55.9253805 133.029864,55.9142059 133.137302,55.9138068 C133.258268,55.9122104 133.380827,55.914605 133.503385,55.9173986 C133.626739,55.9201923 133.749695,55.9245823 133.871458,55.9269769 C133.99322,55.9297705 134.114187,55.9325642 134.23396,55.9329633 C134.353335,55.9345596 134.471516,55.9345596 134.5893,55.9325642 C134.798206,55.9277751 135.011489,55.9281741 135.205673,55.8635211 C135.399458,55.798868 135.574541,55.6539973 135.600804,55.4576435 C135.612741,55.3674485 135.589264,55.2628862 135.516445,55.1938431 C135.445218,55.1263964 135.344148,55.107639 135.251035,55.0932717",id:"Fill-178",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:134}}),_react2.default.createElement("path",{d:"M22.4556667,48.2447964 C22.3207729,48.182937 22.17235,48.1805424 22.0267125,48.1817397 C21.7219083,48.1849324 21.4127271,48.1989007 21.0939958,48.2168599 C20.7752646,48.234819 20.4469833,48.2555719 20.1071625,48.2675447 C19.8636375,48.2755265 19.6157354,48.2771229 19.3642521,48.2743293 C19.1131667,48.2711365 18.8585,48.2639528 18.6018438,48.2543746 C18.3447896,48.2451955 18.0885313,48.23442 17.8322729,48.226039 C17.5756167,48.2180571 17.3197563,48.2128689 17.0623042,48.213268 C16.8573771,48.213268 16.6516542,48.2140662 16.4455333,48.2156626 C16.2398104,48.217658 16.0336896,48.2200526 15.8275688,48.2232454 C15.62105,48.2268372 15.4149292,48.2308281 15.2088083,48.2352181 C15.0030854,48.23881 14.7973625,48.2432 14.5928333,48.2471909 C14.3202604,48.25198 14.0520646,48.2547737 13.7910313,48.2551728 C13.5976438,48.2555719 13.4070417,48.2551728 13.2176333,48.2543746 C13.0286229,48.2531773 12.8408063,48.25198 12.6537854,48.2503837 C12.4576125,48.2483882 12.2506958,48.2503837 12.0787958,48.3533497 C11.9072938,48.4563156 11.7907042,48.6945741 11.87745,48.8893315 C11.9757354,49.1112272 12.2463188,49.1475447 12.4671625,49.1527329 C12.6541833,49.1571229 12.842,49.1611138 13.0314083,49.1639075 C13.2208167,49.1671002 13.4118167,49.1686966 13.606,49.1694948 C13.7997854,49.1698939 13.9967542,49.1690957 14.1957125,49.1671002 C14.3950688,49.1647057 14.5968125,49.1615129 14.8005458,49.1571229 C15.0062688,49.1523338 15.2123896,49.1475447 15.4185104,49.1427556 C15.6246313,49.1379664 15.8315479,49.1335764 16.0372708,49.1303837 C16.3810708,49.1243973 16.7248708,49.1208054 17.067875,49.1208054 C17.4104813,49.1208054 17.7538833,49.1220027 18.0964896,49.1239982 C18.4394938,49.1255946 18.7832938,49.1263927 19.1223188,49.1247964 C19.4609458,49.1235991 19.7904208,49.1208054 20.1111417,49.1180118 C20.4318625,49.114819 20.7438292,49.1116263 21.0474396,49.1128236 C21.3506521,49.1140209 21.6459063,49.1196082 21.9367833,49.1287873 C22.2025917,49.1379664 22.635525,49.0872816 22.7127208,48.7057488 C22.7517167,48.513785 22.6156292,48.3214222 22.4556667,48.2447964",id:"Fill-180",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:135}}),_react2.default.createElement("path",{d:"M12.923931,47.5658594 C13.1169206,47.5666576 13.310706,47.5678549 13.5052873,47.5690522 C13.7002665,47.5706485 13.898429,47.5706485 14.0993769,47.5702494 C14.3003248,47.5698503 14.5040581,47.568254 14.7089852,47.5662585 C14.915504,47.5638639 15.1220227,47.5614694 15.3285415,47.5594739 C15.5350602,47.5574785 15.741579,47.5558821 15.9476998,47.5546848 C16.204754,47.5534875 16.462206,47.5534875 16.7184644,47.5534875 C16.9755185,47.5538866 17.2317769,47.5542857 17.4880352,47.5546848 C17.7438956,47.5550839 18.000154,47.5558821 18.2564123,47.5566803 C18.5126706,47.5574785 18.7693269,47.5578776 19.0271769,47.5574785 C19.3693852,47.5562812 19.7068185,47.5538866 20.033906,47.551093 C20.3605956,47.5482993 20.6769394,47.5455057 20.9849269,47.542712 C21.2917206,47.5411156 21.590556,47.542712 21.8842185,47.5482993 C22.1528123,47.5534875 22.5925102,47.4968163 22.6860206,47.1144853 C22.7333727,46.9225215 22.5992748,46.7349478 22.436129,46.662712 C22.2984498,46.6048435 22.1452519,46.6056417 21.9948394,46.6096327 C21.6800873,46.6180136 21.3609581,46.6379683 21.0362581,46.6587211 C20.7107623,46.6790748 20.3765123,46.6994286 20.0283352,46.709805 C19.7788415,46.7177868 19.5257665,46.718585 19.2714977,46.7149932 C19.0176269,46.7110023 18.7629602,46.7030204 18.5082935,46.6934422 C18.2540248,46.6846621 17.999756,46.6750839 17.7446915,46.6675011 C17.4904227,46.6603175 17.2349602,46.6555283 16.9790998,46.6559274 C16.7745706,46.6563265 16.5692456,46.6567256 16.3639206,46.6567256 L15.746354,46.6567256 C15.5398352,46.6567256 15.3337144,46.6567256 15.1267977,46.6571247 C14.920279,46.6575238 14.7129644,46.6579229 14.5068435,46.658322 C14.2310873,46.6591202 13.9589123,46.6587211 13.6899206,46.6579229 C13.4937477,46.6571247 13.2983706,46.6563265 13.1041873,46.6563265 C12.910004,46.6563265 12.7166165,46.6567256 12.522831,46.658322 C12.3194956,46.6595193 12.1042227,46.6659048 11.9267519,46.774059 C11.749281,46.8818141 11.6318956,47.1244626 11.725804,47.3172245 C11.8336394,47.5371247 12.1161602,47.5650612 12.3445644,47.5646621 C12.5379519,47.564263 12.7309415,47.5646621 12.923931,47.5658594",id:"Fill-182",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:136}}),_react2.default.createElement("path",{d:"M12.8022879,45.9761125 C13.0028379,45.9757134 13.2033879,45.9761125 13.4047338,45.9773098 C13.6056817,45.9789061 13.8082213,45.9809016 14.0123525,45.9828971 C14.2164838,45.9848925 14.4218088,45.986888 14.6283275,45.9888834 C14.8344483,45.9908789 15.041365,45.9924753 15.2478838,45.9940717 C15.4548004,45.9952689 15.6617171,45.9964662 15.86744,45.9972644 C16.2108421,45.9988608 16.5534483,46.000058 16.894065,46.0004571 C17.2354775,46.0008562 17.5752983,46.0008562 17.9151192,46.0008562 C18.2545421,46.0008562 18.593965,46.0008562 18.93299,46.0004571 C19.272015,46.000058 19.6090504,45.9992599 19.9425046,45.9976635 C20.2763567,45.9952689 20.6010567,45.9944707 20.9166046,45.9948698 C21.2317546,45.9952689 21.5405379,45.9968653 21.84574,45.9988608 C22.1254754,46.0008562 22.5838754,45.9377995 22.6761921,45.5746249 C22.7231463,45.3914413 22.5779067,45.2158404 22.4056088,45.1487927 C22.2599713,45.0937179 22.0996108,45.0945161 21.9432296,45.0969107 C21.6157442,45.1028971 21.2858713,45.1152689 20.9500296,45.1268426 C20.6133921,45.1388154 20.26999,45.1511873 19.9230067,45.1559764 C19.6743088,45.1599673 19.4244171,45.1587701 19.1737296,45.1551782 C18.92344,45.1523846 18.6719567,45.1448018 18.4188817,45.13682 C18.1658067,45.1288381 17.9127317,45.119659 17.6588608,45.1128744 C17.40499,45.1060898 17.1507213,45.1013007 16.8952588,45.1016998 C16.6907296,45.1016998 16.4862004,45.1016998 16.2804775,45.1013007 C16.0755504,45.1005025 15.8690317,45.1001034 15.6625129,45.0989061 C15.4559942,45.0977088 15.2494754,45.0961125 15.0433546,45.094117 C14.8368358,45.0921215 14.6311129,45.0901261 14.42539,45.0877315 C14.1512254,45.0849379 13.8778567,45.0817451 13.6044879,45.0793506 C13.4023463,45.0777542 13.2006025,45.0773551 12.9996546,45.0773551 C12.7983088,45.0777542 12.5973608,45.0789515 12.3968108,45.0809469 C12.1867108,45.0837406 11.9646733,45.0909243 11.7788463,45.2006748 C11.5934171,45.3100263 11.4668796,45.5546703 11.5619817,45.7458358 C11.670215,45.9637406 11.9634796,45.9860898 12.2006379,45.982498 C12.4015858,45.9789061 12.6021358,45.9769107 12.8022879,45.9761125",id:"Fill-184",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:137}}),_react2.default.createElement("path",{d:"M12.0830138,44.4031274 C12.2895325,44.3999347 12.4944596,44.3987374 12.6997846,44.3987374 C12.9047117,44.3983383 13.1092408,44.3995356 13.31377,44.4015311 C13.5182992,44.4039256 13.7228283,44.4067193 13.9277554,44.409912 C14.1322846,44.4127057 14.3372117,44.4158984 14.5425367,44.4190912 C14.7474638,44.4222839 14.9531867,44.4254766 15.1589096,44.4278712 C15.3650304,44.4302658 15.5711513,44.4326603 15.7772721,44.4346558 C15.9837908,44.4362522 16.1891158,44.4378485 16.3944408,44.4390458 C16.6001638,44.4402431 16.804295,44.4410413 17.0084263,44.4414404 C17.2129554,44.4418395 17.4162908,44.4418395 17.6196263,44.4414404 C17.8229617,44.4414404 18.0262971,44.4406422 18.2284388,44.4402431 C18.4309783,44.4394449 18.6327221,44.4382476 18.8332721,44.4370503 C19.0334242,44.4362522 19.2327804,44.4362522 19.4309429,44.4378485 C19.6291054,44.4390458 19.8260742,44.4418395 20.022645,44.4454313 C20.2188179,44.4494222 20.4149908,44.4542113 20.6111638,44.4593995 C20.8065408,44.4641887 21.0011221,44.4693769 21.1945096,44.4749642 C21.388295,44.4801524 21.5804888,44.4849415 21.7714888,44.4897306 C22.0635596,44.4961161 22.5398658,44.4362522 22.6246221,44.0674902 C22.6675971,43.8815129 22.5092263,43.7011229 22.3269804,43.6304834 C22.1725888,43.5730141 22.0062596,43.5722159 21.8443075,43.572615 C21.5056804,43.5738122 21.1674513,43.581395 20.8288242,43.5881796 C20.4901971,43.5945651 20.1495804,43.6009506 19.8069742,43.6005515 C19.5614596,43.6001524 19.3151492,43.5957624 19.0672471,43.5893769 C18.8189471,43.5829914 18.5686575,43.5758077 18.3163783,43.5674268 C18.0637013,43.559844 17.8110242,43.5502658 17.5567554,43.5434812 C17.3028846,43.5362975 17.0482179,43.5311093 16.7919596,43.5307102 C16.5189888,43.5307102 16.24562,43.529912 15.9714554,43.5287147 C15.6972908,43.5271184 15.4235242,43.5251229 15.1493596,43.5223293 C14.8759908,43.5191365 14.6026221,43.5159438 14.3300492,43.512751 C14.0574763,43.5091592 13.7856992,43.5051683 13.5151158,43.5015764 C13.3145658,43.4991819 13.11322,43.4971864 12.9118742,43.4959891 C12.7105283,43.4947918 12.5087846,43.4943927 12.3070408,43.4947918 C12.0953492,43.4947918 11.8729138,43.4991819 11.6827096,43.6073361 C11.4929033,43.7150912 11.3540304,43.9625288 11.44197,44.1588825 C11.542245,44.3819755 11.8398867,44.4063202 12.0830138,44.4031274",id:"Fill-186",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:138}}),_react2.default.createElement("path",{d:"M88.4950706,54.6941787 C88.4421477,54.6857977 88.3896227,54.6786141 88.3374956,54.6714304 C88.1807165,54.6510766 88.0243352,54.6351129 87.8667602,54.6239383 C87.7091852,54.6127637 87.5492227,54.6075755 87.385679,54.6087728 C87.2217373,54.609571 87.0526227,54.6171537 86.8803248,54.626732 C86.7080269,54.6367093 86.535331,54.6462875 86.3666144,54.6554667 C86.2432602,54.6622512 86.1238852,54.6590585 86.0112748,54.6574621 C85.8986644,54.6562649 85.7912269,54.6566639 85.6925435,54.6714304 C85.5934623,54.6861968 85.5023394,54.7157297 85.4207665,54.7712036 C85.3391935,54.8266776 85.2671706,54.9088907 85.2042998,55.030215 C85.1668956,55.103249 85.1895769,55.1990313 85.2349394,55.2644825 C85.3411831,55.4233215 85.4677206,55.4987501 85.6065935,55.5310766 C85.7458644,55.5630041 85.8998581,55.5506322 86.0586269,55.5358658 C86.1648706,55.5262875 86.2742977,55.5151129 86.3813373,55.5147138 C86.5027019,55.5131175 86.6248623,55.515512 86.7478185,55.5183057 C86.8707748,55.5210993 86.994129,55.5254893 87.1158915,55.5278839 C87.237654,55.5306776 87.3582227,55.5334712 87.4783935,55.5338703 C87.5973706,55.5350676 87.7155519,55.5354667 87.8333352,55.5334712 C88.0422415,55.5286821 88.2555248,55.5290812 88.4497081,55.4644281 C88.6434935,55.3997751 88.8185769,55.2549043 88.8448394,55.0585506 C88.8567769,54.9683556 88.8332998,54.8637932 88.760481,54.7947501 C88.6896519,54.7273034 88.588581,54.708546 88.4950706,54.6941787",id:"Fill-188",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:139}}),_react2.default.createElement("path",{d:"M186.999222,41.1448925 C186.981316,41.065473 186.948289,40.9856544 186.89656,40.9233959 C186.869103,40.8898721 186.835678,40.8623347 186.796682,40.841981 C186.706753,40.7964844 186.60051,40.8004753 186.499439,40.8052644 C186.279391,40.816439 186.060935,40.8192327 185.842876,40.8196317 C185.648295,40.8200308 185.399199,40.8044662 185.217749,40.8814912 C184.907374,41.0131918 184.801528,41.5284209 185.216555,41.5368018 C185.68928,41.5471782 186.16678,41.5451828 186.640301,41.5236317 C186.71113,41.520439 186.784347,41.5164481 186.84881,41.4853188 C186.978132,41.4226612 187.02827,41.2769923 186.999222,41.1448925",id:"Fill-190",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:140}}),_react2.default.createElement("path",{d:"M135.251035,55.0932717 C135.198112,55.0848907 135.145189,55.077707 135.093062,55.0705234 C134.936681,55.0501696 134.7803,55.0342059 134.622725,55.0230313 C134.464752,55.0122558 134.305187,55.0066685 134.141245,55.0078658 C133.977702,55.009063 133.808587,55.0166458 133.635891,55.0258249 C133.463991,55.0358023 133.291295,55.0453805 133.122579,55.0545596 C132.999225,55.0613442 132.87985,55.0581515 132.767239,55.0565551 C132.654231,55.0553578 132.547191,55.056156 132.44811,55.0709224 C132.349427,55.0856889 132.258304,55.1148227 132.176333,55.1702966 C132.095158,55.2257705 132.022737,55.3079837 131.960264,55.4293079 C131.922462,55.502342 131.945541,55.5981243 131.990904,55.6635755 C132.097148,55.8224145 132.223287,55.8982422 132.36216,55.9301696 C132.501431,55.9620971 132.655823,55.9497252 132.814591,55.9353578 C132.920437,55.9253805 133.029864,55.9142059 133.137302,55.9138068 C133.258268,55.9122104 133.380827,55.914605 133.503385,55.9173986 C133.626739,55.9201923 133.749695,55.9245823 133.871458,55.9269769 C133.99322,55.9297705 134.114187,55.9325642 134.23396,55.9329633 C134.353335,55.9345596 134.471516,55.9345596 134.5893,55.9325642 C134.798206,55.9277751 135.011489,55.9281741 135.205673,55.8635211 C135.399458,55.798868 135.574541,55.6539973 135.600804,55.4576435 C135.612741,55.3674485 135.589264,55.2628862 135.516445,55.1938431 C135.445218,55.1263964 135.344148,55.107639 135.251035,55.0932717",id:"Fill-192",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:141}}),_react2.default.createElement("path",{d:"M178.556346,58.4547918 C178.894177,58.4504018 179.242354,58.4615764 179.594112,58.4779392 C179.695183,58.4823293 179.79705,58.4887147 179.898519,58.494302 C179.889366,58.4372317 179.879021,58.3821569 179.871062,58.3238893 C179.806998,57.8697215 179.769991,57.3732499 179.735771,56.858819 C179.701152,56.3443882 179.670512,55.8131955 179.621171,55.2943746 C179.571431,54.7759528 179.505775,54.2750912 179.402714,53.8145379 C179.296471,53.3392181 179.173912,52.8778667 179.034641,52.4312816 C178.895769,51.9850957 178.740581,51.5584653 178.571069,51.1569778 C178.401556,50.7558893 178.217321,50.3847329 178.017169,50.0251501 C177.816619,49.6659664 177.60055,49.3135673 177.368166,48.9703474 C177.1326,48.6223383 176.888279,48.2882975 176.634408,47.9754086 C176.381731,47.6609234 176.117912,47.3691864 175.84335,47.1017941 C175.568389,46.8332045 175.281889,46.5901569 174.983452,46.3710549 C174.685014,46.1515537 174.375833,45.9559982 174.056306,45.7831909 C173.800844,45.6451048 173.538616,45.5221841 173.270023,45.4136308 C173.001827,45.3054766 172.727662,45.2108916 172.447529,45.131073 C172.167794,45.0512544 171.882885,44.9854041 171.592406,44.9339211 C171.302325,44.882039 171.006673,44.8441252 170.706644,44.8201796 C170.406614,44.7958349 170.100616,44.7858576 169.789446,44.7910458 C169.048525,44.8026195 168.345406,44.8696671 167.681681,44.9858032 C167.017956,45.1019392 166.394819,45.2867193 165.809483,45.5457306 C165.224148,45.805141 164.675819,46.1343927 164.16171,46.5271002 C163.647204,46.9202068 163.169306,47.3731773 162.732394,47.8756354 C162.296277,48.3780934 161.904329,48.9236535 161.560529,49.4979483 C161.217127,50.0722431 160.919485,50.6740753 160.668798,51.2874812 C160.41811,51.9008871 160.216366,52.5198803 160.063566,53.1444608 C159.951752,53.6038168 159.866996,54.0691592 159.805319,54.5396898 C159.720562,55.2389007 159.683158,55.9480889 159.689127,56.6520889 C159.693902,57.2120163 159.73051,57.7707465 159.783831,58.326683 C159.726929,58.3606059 159.679179,58.4076989 159.645356,58.4619755 C160.6111,58.4404245 161.564906,58.4200707 162.467381,58.4037079 C163.369856,58.3877442 164.221398,58.3757714 164.982214,58.3713814 C166.504246,58.3633995 167.66855,58.3857488 168.159181,58.4396263 C168.765606,58.5817034 169.503741,58.4962975 170.123298,58.5046785 C171.318639,58.5202431 172.512787,58.5150549 173.706537,58.507073 C174.095302,58.5042794 174.484066,58.5006875 174.872433,58.4966966 C175.267166,58.4931048 175.6619,58.4891138 176.064194,58.4843247 C176.466885,58.4795356 176.877137,58.4751456 177.293358,58.4699574 C177.709579,58.4647692 178.131371,58.45998 178.556346,58.4547918",id:"Fill-194",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:142}}),_react2.default.createElement("path",{d:"M47.2442435,55.230839 C47.1933102,54.8373333 47.1387956,54.4422313 47.0731394,54.0471293 C47.0074831,53.6516281 46.9306852,53.256127 46.8335935,52.8610249 C46.7365019,52.4655238 46.6195144,52.0704218 46.4754685,51.6769161 C46.3314227,51.2830113 46.1619102,50.8907029 45.9609623,50.5011882 C45.761606,50.1136689 45.5463331,49.740517 45.3183269,49.3849252 C45.0907185,49.0289342 44.8519685,48.6901043 44.6044644,48.3708299 C44.3569602,48.0515556 44.0975185,47.7522358 43.8241498,47.4748662 C43.551179,47.1978957 43.264679,46.9424762 42.9662415,46.7118005 C42.667406,46.4811247 42.357429,46.2747937 42.0339227,46.0944036 C41.7108144,45.9140136 41.3709935,45.7603628 41.0136644,45.6330522 C40.6531519,45.4191383 40.2822935,45.2355556 39.9090477,45.0898866 C39.5361998,44.9438186 39.1609644,44.8352653 38.7912998,44.7706122 C35.810506,44.2513923 32.7525165,45.3788299 30.6706165,47.5151746 C27.9727415,50.2820862 26.422856,54.9590567 27.8824144,58.3605261 C34.086731,58.4231837 44.1603894,58.4998095 47.3083081,58.3613243 C47.4181331,57.917932 47.4459873,57.445805 47.4308665,56.9748753 C47.4105727,56.3674558 47.313481,55.7628299 47.2442435,55.230839",id:"Fill-196",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:143}}),_react2.default.createElement("path",{d:"M71.0383869,58.0930939 C71.0435598,57.9957152 71.0491306,57.8991347 71.0495285,57.8001596 C71.052314,57.2182821 70.9775056,56.6060735 70.9178181,56.0493388 C70.8740473,55.6370757 70.8195327,55.2104454 70.7522848,54.7726404 C70.6854348,54.3348354 70.6066473,53.8878512 70.5091577,53.4348807 C70.4116681,52.9819102 70.2958744,52.5269442 70.1558077,52.0743728 C70.016139,51.6218014 69.853789,51.1772118 69.662789,50.7406041 C69.476564,50.3163683 69.2736265,49.916078 69.0587515,49.5461188 C68.8398973,49.177756 68.6095035,48.8337379 68.3675702,48.5132662 C68.1268306,48.19479 67.8705723,47.8994612 67.5979994,47.628078 C67.3258244,47.357493 67.0377327,47.1080599 66.7345202,46.8801778 C66.4309098,46.6522957 66.1117806,46.4459646 65.775541,46.2615837 C65.4396994,46.0776018 65.0819723,45.9139737 64.7027577,45.7762866 C64.3080244,45.5635701 63.903741,45.3859737 63.5006515,45.2506812 C63.097164,45.1153887 62.6952681,45.0204045 62.3033202,44.9713161 C61.7768765,44.9054658 61.2512285,44.8827175 60.7319473,44.8998785 C60.2118702,44.9166404 59.696966,44.9761052 59.1916119,45.0718875 C58.6858598,45.1680689 58.1916473,45.2933841 57.7173306,45.4422458 C57.2434119,45.5911075 56.7870015,45.7635156 56.3508848,45.9562776 C55.9147681,46.1490395 55.4969556,46.3693388 55.0998348,46.6207673 C54.702714,46.8721959 54.3246931,47.1547537 53.9693535,47.4740281 C53.5809869,47.8228354 53.2053535,48.2311075 52.8492181,48.6836789 C52.4938785,49.1362503 52.1592306,49.6319238 51.856814,50.1535383 C51.5539994,50.6751528 51.2846098,51.2259011 51.049839,51.8333206 C50.8142723,52.4415383 50.6177015,53.0988444 50.4692785,53.7940644 C50.3948681,54.1416744 50.3351806,54.4980644 50.2890223,54.8600417 C50.2432619,55.222019 50.2118265,55.5887855 50.1955119,55.9563501 C50.1787994,56.3231166 50.1772077,56.6846948 50.1907369,57.0354975 C50.204664,57.3863002 50.233314,57.7267265 50.2774827,58.0515882 C50.2834515,58.093493 50.2914098,58.132205 50.2973785,58.1725134 C55.5104848,57.9761596 67.1929202,57.9067175 67.1929202,57.9067175 C67.771889,57.9761596 69.1005327,58.03762 71.0383869,58.0930939",id:"Fill-198",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:144}}),_react2.default.createElement("path",{d:"M163.207387,51.8903909 C163.051801,52.2228354 162.920091,52.5584726 162.808674,52.8925134 C162.697655,53.2269533 162.605737,53.5625905 162.53252,53.9018195 C162.458905,54.2414476 162.403197,54.582273 162.364997,54.9207039 C162.326001,55.2591347 162.303718,55.5931755 162.297749,55.9188354 C162.291383,56.2440961 162.303718,56.5637696 162.333562,56.8790531 C162.356243,57.1201052 162.387678,57.3587628 162.42946,57.5946268 C162.470843,57.8304907 162.52297,58.0631619 162.587433,58.2906449 C162.655476,58.5145361 162.738243,58.7312435 162.837324,58.939171 C162.936405,59.1478966 163.051801,59.3482413 163.181522,59.5422005 C163.357799,59.8000145 163.557155,60.0494476 163.775612,60.2920961 C163.994068,60.5347447 164.226053,60.7730032 164.467987,61.0076698 C164.70992,61.2423365 164.960608,61.4738104 165.222835,61.6969034 C165.443678,61.892459 165.673674,62.0812299 165.914016,62.2584272 C166.07557,62.377756 166.240308,62.4875066 166.407433,62.5876789 C166.574558,62.6882503 166.744468,62.7788444 166.918358,62.8590621 C167.266137,63.0202957 167.625853,63.1400236 167.990345,63.2202413 C168.23586,63.2729215 168.482568,63.3152254 168.730868,63.3483501 C168.979566,63.3810757 169.229458,63.4046222 169.478951,63.416595 C169.728445,63.4281687 169.977541,63.4289669 170.225841,63.4181914 C170.474539,63.4070168 170.722839,63.3846676 170.971139,63.3515429 C171.218643,63.3184181 171.464953,63.2753161 171.709274,63.2218376 C171.988612,63.1603773 172.265164,63.0829533 172.534951,62.9891664 C172.805535,62.8953796 173.069353,62.7876245 173.32601,62.665502 C173.58187,62.5429805 173.830966,62.4060916 174.071705,62.2520417 C174.338708,62.0812299 174.594568,61.8892662 174.837695,61.6765497 C175.081618,61.4622367 175.313205,61.2275701 175.533651,60.974146 C175.753699,60.7211211 175.963401,60.4505361 176.157585,60.1607946 C176.352166,59.8694567 176.521678,59.5633524 176.665326,59.2432798 C176.80977,58.9236063 176.926758,58.5923592 177.01987,58.2563229 C177.11338,57.9103093 177.187791,57.5607039 177.244693,57.209502 C177.301993,56.8583002 177.340193,56.5082957 177.357303,56.1634794 C177.374414,55.8190621 177.370037,55.4786358 177.343376,55.1433977 C177.317512,54.8081596 177.270558,54.4781098 177.205697,54.1560417 C177.140837,53.8339737 177.056876,53.5202866 176.953816,53.2161778 C176.850358,52.912468 176.727799,52.6171392 176.586141,52.3333841 C176.444483,52.0500281 176.283724,51.7770485 176.102672,51.5108535 C175.921222,51.2442594 175.719478,50.9840508 175.501022,50.7322231 C175.280974,50.4784 175.043418,50.2313615 174.789149,49.9903093 C174.535278,49.7500553 174.263899,49.5189805 173.975808,49.3070621 C173.729099,49.1322594 173.477616,48.9762141 173.217776,48.8373297 C172.958335,48.6980463 172.690935,48.5739283 172.417566,48.4653751 C172.144197,48.3568218 171.866451,48.2638331 171.585522,48.18601 C171.304593,48.1077878 171.021674,48.0459283 170.739153,48.0004317 C170.45703,47.9549351 170.174908,47.9258014 169.891989,47.9150259 C169.609468,47.9038512 169.324958,47.9082413 169.041243,47.9262005 C168.697045,47.9521415 168.353643,47.9988354 168.009445,48.0690757 C167.668033,48.138917 167.32861,48.2319057 166.995951,48.3504363 C166.662895,48.4689669 166.336603,48.6134385 166.023841,48.7830531 C165.71068,48.9526676 165.41662,49.1454295 165.142853,49.3641324 C164.869883,49.5828354 164.614818,49.825883 164.380843,50.0904816 C164.14647,50.3546812 163.931993,50.6380372 163.736218,50.9389533 C163.540841,51.2390712 163.362972,51.5575474 163.207387,51.8903909",id:"Fill-200",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:145}}),_react2.default.createElement("path",{d:"M172.83319,58.4547918 C172.675217,58.6311909 172.503715,58.7840435 172.320673,58.9125515 C172.137631,59.0418576 171.944244,59.1480163 171.746877,59.2354177 C171.548715,59.3232181 171.347767,59.3942567 171.144829,59.451327 C170.94229,59.5087964 170.737761,59.5546921 170.532038,59.5838259 C170.3291,59.6225379 170.120194,59.6392998 169.906513,59.6373043 C169.58619,59.6341116 169.254327,59.5782385 168.92525,59.4573134 C168.589011,59.339581 168.260729,59.1607873 167.950354,58.9253224 C167.640377,58.6898576 167.368998,58.4144834 167.137809,58.1115719 C166.907415,57.8082612 166.718802,57.4730231 166.579134,57.1154358 C166.48244,56.879971 166.408825,56.6341297 166.357494,56.3831002 C166.305367,56.1312726 166.273534,55.8718621 166.260402,55.6112544 C166.247669,55.3506467 166.254434,55.090039 166.281492,54.8330231 C166.308948,54.5760073 166.360677,54.3221841 166.439067,54.077141 C166.517059,53.8324971 166.622506,53.5990277 166.755013,53.3811229 C166.887917,53.162819 167.042706,52.9688599 167.218984,52.793658 C167.395261,52.6184562 167.592229,52.4612136 167.803921,52.3263202 C168.016409,52.1910277 168.244017,52.0780844 168.483165,51.9898848 C168.722711,51.9008871 168.976184,51.8354358 169.243584,51.7919347 C169.511381,51.7480345 169.791515,51.7248871 170.076423,51.7232907 C170.361729,51.7220934 170.649025,51.7452408 170.933536,51.8015129 C171.216852,51.8581841 171.494996,51.9511728 171.758417,52.0776853 C172.022236,52.2041977 172.268546,52.3634358 172.492573,52.5557986 C172.714611,52.746166 172.904417,52.9636717 173.061594,53.2007329 C173.244636,53.4757079 173.386692,53.7702385 173.488559,54.0743474 C173.590823,54.3792544 173.656479,54.6933406 173.688711,55.0150095 C173.720544,55.330293 173.719748,55.6583474 173.693884,55.9872 C173.673988,56.2342385 173.646134,56.4772862 173.607536,56.7087601 C173.569734,56.9406331 173.517209,57.1613315 173.449563,57.3688599 C173.381519,57.5763882 173.297559,57.7715447 173.194896,57.9519347 C173.092234,58.1327238 172.971267,58.3003429 172.83319,58.4547918",id:"Fill-202",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:146}}),_react2.default.createElement("g",{id:"Group-206",transform:"translate(52.729167, 47.551293)",__source:{fileName:_jsxFileName,lineNumber:147}},_react2.default.createElement("mask",{id:"mask-12",fill:"white",__source:{fileName:_jsxFileName,lineNumber:148}},_react2.default.createElement("use",{xlinkHref:"#path-11",__source:{fileName:_jsxFileName,lineNumber:149}})),_react2.default.createElement("g",{id:"Clip-205",__source:{fileName:_jsxFileName,lineNumber:151}}),_react2.default.createElement("path",{d:"M1.03056438,4.33909841 C0.868214375,4.67194195 0.730137292,5.00757914 0.612353958,5.34281723 C0.494570625,5.67765624 0.397081042,6.0144907 0.317497708,6.3553161 C0.238312292,6.6957424 0.176635208,7.03856327 0.132466458,7.37898957 C0.088695625,7.71981497 0.061239375,8.05585125 0.050495625,8.38390567 C0.039751875,8.71196009 0.0477102083,9.03402812 0.0739727083,9.35210522 C0.0938685417,9.59515283 0.122916458,9.83620499 0.161912292,10.0744635 C0.200908125,10.312722 0.251045625,10.5477878 0.313518542,10.7772662 C0.379572708,11.0035519 0.461145625,11.222654 0.559033125,11.4333751 C0.657716458,11.6444952 0.771918542,11.8472345 0.900843542,12.0439873 C1.07632479,12.3053932 1.27528313,12.558019 1.49373937,12.8038603 C1.71179771,13.0497016 1.94418104,13.2915519 2.18651229,13.5290122 C2.42924146,13.7664726 2.68032687,14.0015383 2.94334979,14.2274249 C3.16459146,14.4257741 3.39538313,14.6165406 3.63652063,14.7953342 C3.79926854,14.9162594 3.96440396,15.0272073 4.13272271,15.1281778 C4.30064354,15.2295474 4.47174771,15.3213388 4.64722896,15.4023546 C4.99739562,15.5643864 5.35949979,15.6849125 5.72717479,15.7647311 C5.97507687,15.8170122 6.22417271,15.8585179 6.47565604,15.8908444 C6.72634354,15.923171 6.97941854,15.9451211 7.23249354,15.9558966 C7.48556854,15.9670712 7.73864354,15.966273 7.99211646,15.9539011 C8.24598729,15.9411302 8.49985813,15.9171846 8.75492271,15.8820644 C9.00919146,15.8469442 9.26306229,15.8026449 9.51573938,15.7467719 C9.80462688,15.6837152 10.0915248,15.6038966 10.3736477,15.5077152 C10.6557706,15.4119329 10.9335165,15.3017832 11.2040998,15.1772662 C11.475081,15.0531483 11.7396956,14.9134658 11.9975456,14.7578195 C12.2832498,14.5850122 12.5605977,14.3910531 12.8256102,14.175942 C13.0918165,13.9600327 13.346881,13.7237696 13.5923956,13.4695474 C13.838706,13.2149261 14.0742727,12.9435429 14.2963102,12.6526041 C14.5187456,12.3608671 14.7169081,12.0539646 14.8884102,11.7338921 C15.0607081,11.4142186 15.2055498,11.0825723 15.3261185,10.7477333 C15.4466873,10.4017197 15.5473602,10.0529125 15.629331,9.70250884 C15.7120977,9.35250431 15.772979,9.00369705 15.811179,8.65967891 C15.8485831,8.31645896 15.8625102,7.97683084 15.8529602,7.64279002 C15.8430123,7.30835011 15.8095873,6.97949751 15.7554706,6.65822766 C15.701354,6.33655873 15.6257498,6.02327075 15.5274644,5.7191619 C15.429179,5.41505306 15.3086102,5.12012336 15.1657581,4.83596916 C15.0237019,4.55181497 14.8593623,4.27843628 14.6715456,4.01144308 C14.483729,3.74405079 14.2724352,3.4826449 14.0416435,3.22922086 C13.8096581,2.97420045 13.5577769,2.72556553 13.2871935,2.4833161 C13.0162123,2.24066757 12.726131,2.00759728 12.4165519,1.79408254 C12.1523352,1.61768345 11.8821498,1.45964263 11.6032102,1.3191619 C11.3246685,1.17828209 11.0373727,1.0525678 10.7437102,0.942019048 C10.4504456,0.831869388 10.1520081,0.737284354 9.85078521,0.657066667 C9.54916438,0.577647166 9.24634979,0.514191383 8.94472896,0.467497506 C8.64310812,0.420404535 8.34188521,0.389674376 8.04066229,0.377302494 C7.73943938,0.364930612 7.43781854,0.368123356 7.13619771,0.384885261 C6.77130812,0.409229932 6.40761229,0.454726531 6.04431437,0.523769615 C5.68340396,0.592413605 5.32647271,0.684604082 4.97670396,0.802336508 C4.62653729,0.920068934 4.28552271,1.0637424 3.95843521,1.23295782 C3.63134771,1.40217324 3.32534979,1.59453605 3.04083937,1.81283991 C2.75672687,2.03154286 2.49290813,2.27459048 2.24978104,2.53918912 C2.00705188,2.80338866 1.78501437,3.08674467 1.58128104,3.38766077 C1.37834354,3.68777868 1.19291437,4.00625488 1.03056438,4.33909841",id:"Fill-204",fill:"#C5168C",mask:"url(#mask-12)",__source:{fileName:_jsxFileName,lineNumber:152}})),_react2.default.createElement("path",{d:"M63.648955,58.4999692 C63.47228,58.6771664 63.2820758,58.8308172 63.0823217,58.9601234 C62.8821696,59.0902277 62.6724675,59.1971846 62.45998,59.2857832 C62.2470946,59.3739828 62.0314237,59.4458195 61.8157529,59.503688 C61.6000821,59.5615565 61.3832175,59.6082503 61.165955,59.6381823 C60.95108,59.6772934 60.73143,59.6944544 60.5081987,59.692858 C60.1731529,59.6896653 59.8285571,59.6345905 59.48993,59.512468 C59.1445383,59.3935383 58.8086967,59.2131483 58.4939446,58.9752889 C58.1791925,58.7378286 57.9058237,58.4600599 57.6750321,58.1539556 C57.4446383,57.8470531 57.2580154,57.5090213 57.1227237,57.1474431 C57.0284175,56.9099828 56.9587821,56.662146 56.9110321,56.4083229 C56.86368,56.1544998 56.8370196,55.8930939 56.830255,55.6304907 C56.8234904,55.3674884 56.8362237,55.1052844 56.8708425,54.8466721 C56.9058592,54.5876608 56.9651487,54.3326404 57.0526904,54.0864 C57.1398342,53.8405587 57.2556279,53.6062912 57.3992758,53.3875882 C57.5433217,53.1696834 57.7108446,52.9749261 57.9006508,52.7997243 C58.0900592,52.6245224 58.3017508,52.468078 58.5289612,52.3335837 C58.7565696,52.1986902 59.0004925,52.0869442 59.2571487,51.9991438 C59.513805,51.9113433 59.7855821,51.8470893 60.0728779,51.8047855 C60.3597758,51.7620825 60.6606008,51.7405315 60.9665987,51.7405315 C61.2721987,51.7405315 61.5805842,51.7652753 61.8845925,51.8235429 C62.1886008,51.8814113 62.4850487,51.9763955 62.76558,52.1045043 C63.0461112,52.2322141 63.3075425,52.3926494 63.5431092,52.5866086 C63.7770842,52.7777741 63.9752467,52.9964771 64.1375967,53.2343365 C64.3254133,53.5101098 64.4682654,53.8046404 64.5661529,54.1099465 C64.6644383,54.4152526 64.7213404,54.730137 64.7412362,55.0514068 C64.7611321,55.3670893 64.7444196,55.695942 64.6998529,56.0255927 C64.6664279,56.2722322 64.6234529,56.5156789 64.5697342,56.747951 C64.5164133,56.9802231 64.4483696,57.2017197 64.3644092,57.4100463 C64.2800508,57.6179737 64.1797758,57.8135293 64.0607987,57.9947175 C63.9414237,58.1759057 63.8041425,58.3443229 63.648955,58.4999692",id:"Fill-207",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:154}}),_react2.default.createElement("path",{d:"M31.5265352,60.6665651 C31.785181,60.9287692 32.0541727,61.1694222 32.3291331,61.3901206 C32.6036956,61.6112181 32.8866144,61.8135583 33.1782873,61.9999347 C33.470756,62.1867102 33.7707852,62.3559256 34.0739977,62.5091773 C34.378006,62.6620299 34.6844019,62.7973224 34.9884102,62.9138576 C35.2928165,63.0307918 35.5988144,63.1265741 35.9071998,63.2032 C36.1435623,63.2618667 36.3807206,63.3109551 36.6190727,63.3488689 C36.8574248,63.3863837 37.0969706,63.4131229 37.3361185,63.4250957 C37.5732769,63.4326785 37.8088435,63.422302 38.0424206,63.3935673 C38.2759977,63.3652317 38.5079831,63.3177397 38.7383769,63.2538848 C39.0459665,63.164488 39.353556,63.0491501 39.659554,62.9110639 C39.9663477,62.7733769 40.2723456,62.6201252 40.5775477,62.4545016 C40.8831477,62.2892771 41.187156,62.1144744 41.4863894,61.9257034 C41.7454331,61.7700571 41.9997019,61.6024381 42.2456144,61.421649 C42.4115456,61.2995265 42.5691206,61.1722159 42.7175435,61.0389188 C42.8663644,60.9060209 43.0072269,60.7667374 43.1385394,60.6206694 C43.4011644,60.3281342 43.627579,60.0108553 43.8173852,59.6752181 C43.9435248,59.4485333 44.0597165,59.2182567 44.1675519,58.98359 C44.2749894,58.7489234 44.3728769,58.5102658 44.4592248,58.2688145 C44.5455727,58.0277624 44.6199831,57.7831184 44.682854,57.5360798 C44.7457248,57.2894404 44.7962602,57.03881 44.8364498,56.785785 C44.8766394,56.5339574 44.906881,56.2801342 44.9255831,56.0251138 C44.9474685,55.7341751 44.9518456,55.4408417 44.9395102,55.1487057 C44.9275727,54.8561705 44.8997185,54.5656308 44.8563456,54.2774857 C44.8133706,53.9901388 44.7536831,53.7043882 44.6764873,53.4214313 C44.5905373,53.106946 44.481906,52.7956535 44.3505935,52.4903474 C44.2180873,52.1830458 44.0628998,51.8805333 43.8890102,51.5824109 C43.7151206,51.2838893 43.5233248,50.9893587 43.3108373,50.7020118 C43.097554,50.4142658 42.8627831,50.1440798 42.6085144,49.8942476 C42.3534498,49.6440163 42.0792852,49.4153361 41.7919894,49.2078077 C41.4967352,48.9958893 41.1911352,48.801132 40.8791685,48.6215401 C40.5672019,48.4423474 40.2504602,48.2823111 39.9325248,48.1450231 C39.6145894,48.0077351 39.2938685,47.8943927 38.9699644,47.8045968 C38.6464581,47.7152 38.3205644,47.6485515 37.9962623,47.6038531 C37.6715623,47.5583565 37.348454,47.5368054 37.0277331,47.5392 C36.7074102,47.5419937 36.3890769,47.5687329 36.0755185,47.6194177 C35.7623581,47.6705016 35.452779,47.745132 35.1447915,47.8437079 C34.8356102,47.9422839 34.5280206,48.0640073 34.2240123,48.2060844 C33.9184123,48.3489596 33.6155977,48.5109914 33.3159665,48.6909823 C33.0163352,48.8709732 32.7222748,49.0701206 32.4417435,49.2932136 C32.2085644,49.4843791 31.9916998,49.6867193 31.7883644,49.9014313 C31.585029,50.1157442 31.394029,50.3420299 31.2153644,50.578293 C31.0370977,50.8141569 30.8707685,51.0588009 30.7171727,51.3102295 C30.5635769,51.5620571 30.4239081,51.8198712 30.2981665,52.0812771 C30.1732206,52.3434812 30.0625998,52.6096762 29.9682935,52.8810594 C29.8739873,53.1528417 29.7936081,53.4306104 29.7247685,53.7115719 C29.6443894,54.0539937 29.5831102,54.4020027 29.5421248,54.7571955 C29.5011394,55.1107918 29.4816415,55.4691773 29.4856206,55.8299574 C29.4899977,56.1907374 29.5186477,56.5531138 29.5731623,56.9118984 C29.6280748,57.270683 29.7092498,57.6186921 29.8202685,57.9555265 C29.9312873,58.292361 30.0725477,58.618819 30.2404685,58.932107 C30.4079915,59.2457941 30.6005831,59.5471093 30.815856,59.8368508 C31.0303331,60.1257941 31.2678894,60.404361 31.5265352,60.6665651",id:"Fill-209",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:155}}),_react2.default.createElement("path",{d:"M40.4773125,53.2790349 C40.6098188,53.4797787 40.7160625,53.687307 40.7964417,53.8988263 C40.8764229,54.1099465 40.9321313,54.3254567 40.9683417,54.5397696 C41.0045521,54.7540825 41.02405,54.9683955 41.0300188,55.1807129 C41.0359875,55.3930304 41.0304167,55.6041506 41.0077354,55.8132753 C40.9950021,56.0231982 40.9595875,56.2323229 40.9038792,56.4422458 C40.8203167,56.756332 40.6834333,57.0672254 40.4832813,57.3557696 C40.2831292,57.6550893 40.026075,57.9276698 39.7196792,58.1663274 C39.4124875,58.404985 39.0782375,58.5933569 38.7280708,58.7330395 C38.3783021,58.8723229 38.0106271,58.9597243 37.6361875,58.9904544 C37.3882854,59.0159964 37.1387917,59.0140009 36.8904917,58.9892571 C36.6417938,58.9637152 36.3926979,58.9162231 36.1483771,58.8487764 C35.9036583,58.7813297 35.6649083,58.6947265 35.4361063,58.5881687 C35.2069063,58.4812118 34.9880521,58.3519057 34.7859104,58.198654 C34.5833708,58.0458014 34.3999313,57.8698014 34.2383771,57.6722503 C34.0772208,57.4750984 33.9439188,57.2635791 33.8332979,57.0384907 C33.7222792,56.8130032 33.6339417,56.5747447 33.5678875,56.3293025 C33.5018333,56.0830621 33.4588583,55.8308354 33.4397583,55.5754159 C33.4210563,55.3195973 33.4246375,55.0585905 33.4501042,54.7907991 C33.4755708,54.5230077 33.5213313,54.249629 33.5861917,53.9782458 C33.6510521,53.7068626 33.7377979,53.4398694 33.8531938,53.1856472 C33.9685896,52.9314249 34.1150229,52.6935655 34.2885146,52.4780553 C34.4620063,52.2625451 34.6617604,52.0725769 34.8869813,51.9125406 C35.1102125,51.7544998 35.3517479,51.6347719 35.604425,51.5517605 C35.8976896,51.4555791 36.2001063,51.4040961 36.5037167,51.3937197 C36.8073271,51.3837424 37.1121313,51.412078 37.4169354,51.4743365 C37.7157708,51.5353977 38.0201771,51.63118 38.3217979,51.7509079 C38.5478146,51.8407039 38.7710458,51.9372844 38.9823396,52.0402503 C39.1940313,52.1432163 39.3929896,52.2561596 39.5760313,52.3810757 C39.7602667,52.5051937 39.9281875,52.6404862 40.0782021,52.790146 C40.2282167,52.9398059 40.3611208,53.103434 40.4773125,53.2790349",id:"Fill-211",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:156}}),_react2.default.createElement("path",{d:"M200.013922,55.7406404 C199.941104,56.2654476 199.423812,57.6993887 199.976518,58.0545814 C200.617164,58.4656472 200.915601,57.3952798 201.099837,56.9981823 C201.159126,56.8712707 201.216029,56.7515429 201.272533,56.6366041 C201.329435,56.5224635 201.385541,56.408722 201.442045,56.2945814 C201.526006,56.1233705 201.609568,55.9517605 201.691937,55.7801506 C201.774704,55.6085406 201.856674,55.4365315 201.938645,55.2653206 C202.020616,55.0933116 202.102587,54.9217016 202.184558,54.7504907 C202.266926,54.5788807 202.349693,54.4076698 202.433654,54.236459 C202.517614,54.0660463 202.60237,53.8956336 202.688718,53.72562 C202.775066,53.5560054 202.863006,53.38679 202.952935,53.2183728 C203.049231,53.0367855 203.153485,52.8516063 203.260126,52.6636336 C203.366768,52.4752617 203.475797,52.2844952 203.582837,52.0905361 C203.689081,51.8965769 203.793335,51.7002231 203.890029,51.5010757 C203.986324,51.3023274 204.07506,51.1011846 204.15146,50.8980463 C204.195231,50.7819102 204.234226,50.664976 204.268447,50.5484408 C204.301474,50.433502 204.326543,50.3209578 204.340868,50.2136018 C204.354795,50.1094385 204.359172,50.0104635 204.353999,49.9174748 C204.348031,49.7993433 204.214331,49.7115429 204.001047,49.6464907 C203.154679,49.3886766 201.054872,49.4912435 200.68481,49.5044136 C200.619949,49.5068082 200.551906,49.5111982 200.499779,49.5483138",id:"Fill-213",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:157}})))))));};exports.default=IcBusBig;module.exports=exports["default"];

/***/ }),
/* 2048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-truck-big.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IcTruckBig=function IcTruckBig(props){return _react2.default.createElement("svg",{width:"192px",height:"64px",viewBox:"0 0 192 64",__source:{fileName:_jsxFileName,lineNumber:4}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("polygon",{id:"path-1",points:"0.265877252 0.224308644 4.002294 0.224308644 4.002294 18.4774353 0.265877252 18.4774353",__source:{fileName:_jsxFileName,lineNumber:6}}),_react2.default.createElement("polygon",{id:"path-3",points:"0 0.127938199 149.070251 0.127938199 149.070251 49.63863 0 49.63863",__source:{fileName:_jsxFileName,lineNumber:7}}),_react2.default.createElement("polygon",{id:"path-5",points:"0.0938859944 0.261167702 149.129238 0.261167702 149.129238 3.59385839 0.0938859944 3.59385839",__source:{fileName:_jsxFileName,lineNumber:8}}),_react2.default.createElement("polygon",{id:"path-7",points:"0.265877252 0.224308644 4.002294 0.224308644 4.002294 18.4774353 0.265877252 18.4774353",__source:{fileName:_jsxFileName,lineNumber:9}}),_react2.default.createElement("polygon",{id:"path-9",points:"0 0.127938199 149.070251 0.127938199 149.070251 49.63863 0 49.63863",__source:{fileName:_jsxFileName,lineNumber:10}}),_react2.default.createElement("polygon",{id:"path-11",points:"0.0938859944 0.261167702 149.129238 0.261167702 149.129238 3.59385839 0.0938859944 3.59385839",__source:{fileName:_jsxFileName,lineNumber:11}})),_react2.default.createElement("g",{id:"1A---1o-Acesso",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement("g",{id:"1A---7.5-Sucesso-(Varios)",transform:"translate(-596.000000, -594.000000)",__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement("g",{id:"Group-3",transform:"translate(572.000000, 560.000000)",__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement("g",{id:"Page-1",transform:"translate(24.000000, 34.000000)",__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement("path",{d:"M155.143191,54.3571478 C155.143191,54.3571478 156.505624,54.4501665 157.15546,54.4191602 L157.805694,54.388154 L181.396826,54.4501665 C181.396826,54.4501665 178.053504,44.9074087 175.205107,43.4199056 C172.35671,41.9328 163.626021,41.5615205 163.626021,41.5615205 C163.626021,41.5615205 155.793425,47.4169242 155.452618,48.2222907 C155.112209,49.0280547 155.143191,54.3571478 155.143191,54.3571478",id:"Fill-1",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:17}}),_react2.default.createElement("g",{id:"Group-5",transform:"translate(185.497350, 31.540075)",__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement("mask",{id:"mask-2",fill:"white",__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement("use",{xlinkHref:"#path-1",__source:{fileName:_jsxFileName,lineNumber:20}})),_react2.default.createElement("g",{id:"Clip-4",__source:{fileName:_jsxFileName,lineNumber:22}}),_react2.default.createElement("path",{d:"M3.96694226,1.74020373 C3.95860084,1.46949565 3.93516541,1.20673789 3.87677545,0.980551553 C3.8183855,0.753967702 3.72067169,0.564352795 3.56536234,0.438737888 C3.30638103,0.228452174 2.99536513,0.215731677 2.67362455,0.236402484 C2.35228117,0.256675776 2.02061032,0.309545342 1.71793584,0.231234783 C1.61346946,0.204601242 1.5364106,0.258265839 1.49867559,0.332601242 C0.969988285,0.0571229814 0.50326583,0.443508075 0.374172385,1.05250186 C0.204563459,1.84991801 0.260967364,2.80157019 0.361461646,3.69995528 C0.386485914,3.92455155 0.414687866,4.1459677 0.442095397,4.36062609 C0.469502929,4.57528447 0.497307671,4.78318509 0.521934728,4.98154534 C0.549342259,5.20017888 0.574763738,5.41920994 0.599788006,5.63824099 C0.625209484,5.85687453 0.649836541,6.07590559 0.672874756,6.29493665 C0.695912971,6.51436522 0.716567922,6.73379379 0.735634031,6.95322236 C0.752714086,7.15118509 0.767808089,7.34914783 0.780121618,7.54711056 C0.792037936,7.74507329 0.800379358,7.94303602 0.805543096,8.14060124 C0.810706834,8.33816646 0.812692887,8.53573168 0.811501255,8.73250186 C0.810309623,8.92966957 0.807529149,9.12643975 0.803954254,9.32320994 C0.800379358,9.51958261 0.797598884,9.71595528 0.796010042,9.91312298 C0.794421199,10.1094957 0.792832357,10.3058683 0.791640725,10.5026385 C0.790846304,10.6998062 0.789654672,10.8965764 0.78846304,11.0937441 C0.784093724,11.6848497 0.775355091,12.2751602 0.765822036,12.8654708 C0.76145272,13.1544646 0.756686192,13.4418683 0.753111297,13.7332472 C0.751919665,13.830241 0.751125244,13.9276323 0.749933612,14.0258186 C0.74874198,14.1236075 0.747947559,14.2221913 0.747153138,14.3215702 C0.746358717,14.4205516 0.745564296,14.5207255 0.745167085,14.6212969 C0.744769874,14.7222658 0.744769874,14.8248248 0.745167085,14.9285764 C0.745564296,15.032328 0.746358717,15.1368745 0.747153138,15.2430112 C0.747550349,15.3570981 0.747947559,15.4719801 0.74874198,15.5880547 C0.749536402,15.7037317 0.750330823,15.8206012 0.750330823,15.9378683 C0.750728033,16.0555329 0.750330823,16.1731975 0.749933612,16.2908621 C0.749139191,16.4085267 0.747947559,16.5265888 0.747153138,16.6442534 C0.745961506,16.761918 0.744372664,16.8787876 0.742386611,16.9940671 C0.740797768,17.1093466 0.738414505,17.2234335 0.734442399,17.3355329 C0.730867503,17.4484273 0.725703766,17.5589366 0.719745607,17.6678559 C0.713787448,17.7775702 0.707034868,17.8852969 0.699090656,17.9918311 C0.691146444,18.1071106 0.687174338,18.232328 0.763438773,18.3181913 C0.805940307,18.3658932 0.864330265,18.3921292 0.929075593,18.4068373 C0.993026499,18.4211478 1.06253835,18.4239304 1.154294,18.4060422 C1.33701088,18.4032596 1.57732329,18.4203528 1.84067392,18.4354584 C1.86927308,18.4672596 1.93759331,18.4704398 2.00670795,18.4728248 C2.07582259,18.4752099 2.14652608,18.4768 2.21802399,18.4771975 C2.28872748,18.477595 2.36062259,18.477595 2.43251771,18.4764025 C2.50361841,18.4748124 2.57511632,18.4724273 2.6458198,18.4684522 C2.71652329,18.464477 2.78563794,18.4601043 2.85316374,18.4533466 C2.95484965,18.4442037 3.05256346,18.4310857 3.14471632,18.4139925 C3.23607476,18.3972969 3.32187225,18.3762286 3.40051994,18.3491975 C3.50498633,18.3134211 3.5975364,18.2657193 3.67578689,18.2033093 C3.75324296,18.1412969 3.81600223,18.0641789 3.8596954,17.9695702 C3.92245467,17.8356075 3.95423152,17.6885267 3.97091437,17.5350857 C3.98759721,17.3824398 3.98878884,17.2226385 3.98998047,17.0640298 C3.9907749,16.9074087 3.99156932,16.7499925 3.99236374,16.5905888 C3.99315816,16.4315826 3.99434979,16.2713839 3.99554142,16.1107876 C3.99673305,15.9501913 3.99752748,15.7899925 3.99871911,15.6297938 C3.99951353,15.4699925 4.00030795,15.3113839 4.00110237,15.1539677 C4.00149958,14.9659429 4.00189679,14.7803031 4.002294,14.5978435 C4.00189679,14.4161789 4.00269121,14.2357068 4.00269121,14.0552348 C4.00269121,13.8751602 4.00149958,13.6946882 3.99991074,13.5138186 C3.9983219,13.3329491 3.99593863,13.151682 3.99276095,12.9704149 C3.98878884,12.7287255 3.98283068,12.4866385 3.97528368,12.2445516 C3.96614784,12.001272 3.9534371,11.757595 3.94191799,11.513918 C3.93000167,11.2706385 3.92046862,11.027359 3.91172999,10.7848745 C3.90338856,10.5423901 3.89862204,10.2999056 3.89941646,10.0586137 C3.90021088,9.81652671 3.90418298,9.57523478 3.90696346,9.33275031 C3.90894951,9.19282484 3.90974393,9.05289938 3.91014114,8.91337143 C3.91093556,8.77344596 3.91093556,8.63391801 3.91093556,8.49359503 C3.91053835,8.35366957 3.90934672,8.21334658 3.90815509,8.07342112 C3.90656625,7.93309814 3.90497741,7.79277516 3.90378577,7.65205466 C3.89862204,7.41871304 3.89901925,7.18298634 3.90140251,6.9464646 C3.90338856,6.70914783 3.90696346,6.47103602 3.91133278,6.23252671 C3.91570209,5.99361988 3.92404351,5.75630311 3.93556262,5.52017888 C3.94708173,5.28405466 3.95860084,5.04912298 3.96733947,4.81538385 C3.97568089,4.58164472 3.98124184,4.34870062 3.98124184,4.11694907 C3.98124184,3.8848 3.97647531,3.65384348 3.96932552,3.42447702 C3.96297015,3.22651429 3.9685311,2.96017888 3.97011994,2.66641491 C3.97091437,2.51973168 3.97250321,2.36549565 3.97250321,2.21006708 C3.97250321,2.05384348 3.97170879,1.89602981 3.96694226,1.74020373",id:"Fill-3",fill:"#FFD300",mask:"url(#mask-2)",__source:{fileName:_jsxFileName,lineNumber:23}})),_react2.default.createElement("path",{d:"M82.3570897,41.5178733 C82.0047638,41.5278112 81.614703,41.5389416 81.1892905,41.549277 C80.7630835,41.5596124 80.3027164,41.5703453 79.8109697,41.5794882 C79.3188258,41.5894261 78.7953022,41.5965814 78.2443711,41.5997615 C77.69344,41.6029416 77.1143069,41.6021466 76.508958,41.5977739 C76.2066807,41.5953888 75.8980481,41.5934012 75.5834573,41.5934012 C75.2692637,41.5930037 74.9495092,41.5945938 74.6233993,41.5973764 C74.2976866,41.6005565 73.9660157,41.6045317 73.6279895,41.6089043 C73.2907577,41.6136745 72.9467733,41.6192398 72.5968308,41.6252025 C72.2472855,41.6303702 71.8905903,41.6367304 71.5283343,41.6422957 C71.1660782,41.6490534 70.7982612,41.6526311 70.4248832,41.6530286 C70.0519025,41.6534261 69.6729636,41.650246 69.2892581,41.6438857 C68.9055527,41.6375255 68.5162863,41.6271901 68.1226506,41.614072 C67.7286177,41.6013516 67.3302155,41.5866435 66.9274439,41.5703453 C66.5246724,41.5544447 66.1175315,41.5377491 65.7072129,41.5214509 C65.2964972,41.5055503 64.8826037,41.4900472 64.4659298,41.4761342 C64.0488587,41.4618236 63.6298015,41.4502957 63.2071694,41.4431404 C62.8198891,41.4363826 62.4326088,41.4332025 62.0433424,41.4324075 L60.8715711,41.4324075 L24.2833111,41.4324075 C21.8563544,41.4324075 19.3861016,40.9390907 16.9901273,41.1076373 C15.1391259,41.2380224 13.3087795,41.7373019 11.6897491,42.6531776 C11.1102188,42.981128 10.5628626,43.367513 10.052447,43.7984199 L10.052447,55.397128 C11.0494456,55.5744199 12.1147644,55.5434137 13.0926969,55.4917366 C13.3608141,55.4778236 13.6277396,55.4651031 13.890693,55.4575503 C14.1536464,55.4499975 14.4126277,55.4480099 14.6660481,55.4515876 C14.9194685,55.4555627 15.1677251,55.461128 15.4096263,55.4690783 C15.6519248,55.4770286 15.8878679,55.487364 16.116264,55.5000845 C16.257671,55.5076373 16.4439627,55.5207553 16.6703728,55.5366559 C16.8967828,55.552954 17.1637083,55.5716373 17.4675744,55.5903205 C17.7738238,55.6050286 18.117411,55.6181466 18.4955555,55.6249043 C18.8733028,55.6320596 19.2832241,55.6352398 19.7193613,55.6388174 C20.4820057,55.6455752 21.3225033,55.654718 22.2130495,55.6646559 C22.5097658,55.6682335 22.8124403,55.6718112 23.1190869,55.6753888 C23.4265279,55.679364 23.7375438,55.680159 24.0525318,55.6706186 C24.3675198,55.6606807 24.6860827,55.642395 25.0066316,55.6177491 C25.2477385,55.5990658 25.4896397,55.576805 25.7323354,55.5533516 C25.9754283,55.5295006 26.2193156,55.5052522 26.4636001,55.4806062 C26.7082818,55.4563578 26.9533608,55.4333019 27.1984397,55.4122335 C27.4431215,55.3915627 27.6882004,55.3736745 27.9328821,55.3585689 C28.1779611,55.3450534 28.4222456,55.3323329 28.6653385,55.322395 C28.9088286,55.3124571 29.1519215,55.3056994 29.3934255,55.3021217 C29.6349295,55.2985441 29.8748447,55.2977491 30.1139655,55.2989416 C30.3522919,55.3001342 30.5890294,55.3025193 30.8241781,55.3053019 C31.0589295,55.3072894 31.2912977,55.3124571 31.5216799,55.3196124 C31.7516648,55.3263702 31.9792665,55.334718 32.2036905,55.3434634 C32.6529357,55.3613516 33.0902645,55.3804323 33.5121022,55.399513 C33.9339399,55.4177988 34.3394919,55.4261466 34.726375,55.4297242 C35.1124637,55.4273391 35.4790891,55.4325068 35.8238679,55.4404571 C36.1682495,55.4492025 36.4899901,55.4563578 36.7863092,55.4623205 C37.0830255,55.4682832 37.3531287,55.4730534 37.59503,55.4770286 C38.0776408,55.4841839 38.4442662,55.4790161 38.6659097,55.463513 C38.7922227,55.4547677 39.0448486,55.4468174 39.4086936,55.4392646 C39.5910132,55.4368795 39.8011376,55.437277 40.0378751,55.4412522 C40.2750099,55.4456248 40.5379633,55.4547677 40.825941,55.4686807 C41.0968386,55.4817988 41.3895828,55.4984944 41.7025848,55.5175752 C42.0159839,55.5370534 42.3492436,55.5581217 42.7015694,55.5803826 C43.0538952,55.602246 43.4240955,55.6217242 43.8117731,55.6368298 C44.1998478,55.6515379 44.603811,55.6602832 45.0236626,55.6626683 C45.4427198,55.6610783 45.8780626,55.6598857 46.327705,55.6586932 C46.8341485,55.6571031 47.3596581,55.6559106 47.900659,55.654718 C48.4416598,55.6543205 48.9993435,55.6535255 49.5693407,55.6467677 C50.1397351,55.6400099 50.7228403,55.6280845 51.3174645,55.6137739 C51.5724738,55.6074137 51.8298662,55.6014509 52.0888475,55.5950907 C52.3478288,55.5887304 52.6091934,55.5807801 52.8737357,55.5700472 C53.1378807,55.5593143 53.4052035,55.5469913 53.6749095,55.5334758 C53.9446155,55.5203578 54.2163075,55.5064447 54.4899856,55.4937242 C54.7636637,55.4810037 55.0397251,55.4690783 55.3165809,55.4587429 C55.5934367,55.4484075 55.8718813,55.4400596 56.1511203,55.4348919 C56.4307566,55.4293267 56.7111873,55.4261466 56.9920152,55.4265441 C57.2728431,55.4269416 57.5544654,55.4293267 57.8372793,55.4336994 C58.1196961,55.438072 58.4033044,55.4440348 58.68731,55.4511901 C58.9713156,55.4583453 59.2557184,55.4658981 59.5405184,55.4746435 C59.824524,55.4833888 60.109324,55.4933267 60.394124,55.5048547 C60.678924,55.5155876 60.9641212,55.526718 61.248524,55.538246 C61.5329268,55.5489789 61.8177268,55.5593143 62.1017323,55.5684571 C62.3857379,55.576805 62.6697435,55.5839602 62.9529546,55.5879354 C63.236563,55.5919106 63.519377,55.5950907 63.8009993,55.5998609 C64.9874673,55.6197366 66.1667856,55.6431901 67.3377625,55.6535255 C68.5095337,55.6634634 69.6693887,55.6650534 70.7994528,55.6666435 C72.118192,55.6682335 73.3952241,55.6698236 74.6122774,55.6710161 C75.8293307,55.6718112 76.9856107,55.6726062 78.0703929,55.640805 C79.1547778,55.6086062 80.1652816,55.5553391 81.0709217,55.5187677 C81.7326746,55.4913391 82.3352431,55.4806062 82.8746551,55.4825938 L82.8746551,41.5031652 C82.7125931,41.5079354 82.5406009,41.5127056 82.3570897,41.5178733",id:"Fill-6",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:25}}),_react2.default.createElement("path",{d:"M167.6305,12.4483975 C167.461288,11.9777391 167.212634,11.5424596 166.951667,11.1123478 C166.690699,10.682236 166.410666,10.260472 166.180681,9.81525466 C166.026563,9.51711801 165.867679,9.22613665 165.701645,8.94111801 C165.535611,8.65649689 165.362824,8.37823602 165.181299,8.10593789 C164.999774,7.83443478 164.810304,7.56849689 164.611699,7.30812422 C164.412696,7.04814907 164.206147,6.7929441 163.98927,6.54330435 C163.771996,6.29326708 163.546777,6.04720497 163.311231,5.80551553 C163.075288,5.56382609 162.831004,5.32491925 162.576789,5.08879503 C162.291195,4.82404969 162.009572,4.57759006 161.723581,4.35100621 C161.487638,4.16099379 161.249311,3.98489441 161.00741,3.82032298 C160.765906,3.65614907 160.521224,3.50390062 160.270187,3.36357764 C160.01915,3.22404969 159.762155,3.09604969 159.498407,2.97918012 C158.707163,2.6277764 157.853955,2.37455901 156.920113,2.18653416 C155.675652,1.93570186 154.420069,1.9802236 153.158529,1.93450932 C151.765908,1.88362733 150.375671,1.79021118 148.981065,1.77947826 C148.97749,1.77947826 148.975106,1.78106832 148.971134,1.78106832 C148.965573,1.78146584 148.960807,1.77868323 148.954452,1.77947826 C147.630151,1.89952795 146.389265,3.03721739 145.847867,4.1971677 C144.971224,6.07423602 145.512224,8.46688199 145.531688,10.4572422 C145.541618,11.4589814 145.320769,12.6992298 146.622825,12.8097391 C147.670667,12.8987826 148.772926,12.8053665 149.829904,12.8530683 C151.119647,12.9111056 152.408595,12.9774907 153.698338,13.0347329 C155.326504,13.1062857 156.955862,13.1496149 158.585617,13.1853913 C158.992758,13.1949317 159.400296,13.2032795 159.808231,13.2120248 C160.216166,13.2203727 160.628074,13.2287205 161.047528,13.2338882 C161.345039,13.2370683 161.646522,13.2386584 161.950388,13.2398509 C162.254254,13.240646 162.559312,13.241441 162.864767,13.242236 C163.170222,13.2430311 163.474088,13.2450186 163.776762,13.2481988 C164.079437,13.2513789 164.378934,13.2557516 164.676047,13.2633043 C165.004937,13.2708571 165.329856,13.2811925 165.651199,13.2847702 C165.972145,13.2883478 166.289914,13.2851677 166.606093,13.2664845 C166.791591,13.254559 167.299226,13.2768199 167.485518,13.1579627 C167.787795,12.9655652 167.738541,12.7497143 167.6305,12.4483975",id:"Fill-8",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:26}}),_react2.default.createElement("path",{d:"M160.412468,60.4220025 C160.73262,60.730872 161.064688,61.0162882 161.402714,61.279046 C161.74074,61.5418037 162.087902,61.7842882 162.445392,62.0072944 C162.803676,62.2310957 163.169507,62.4350211 163.540501,62.6190708 C163.911496,62.803518 164.28408,62.9668969 164.654677,63.1084124 C165.025275,63.2491329 165.398255,63.3664 165.773619,63.4606112 C166.0612,63.532164 166.350369,63.5925863 166.64073,63.6394932 C166.931091,63.6860025 167.223041,63.7189963 167.513799,63.7348969 C167.801777,63.7452323 168.087768,63.7348969 168.37098,63.7026981 C168.653793,63.6701019 168.934621,63.6152447 169.212272,63.5417043 C169.582869,63.4363627 169.951481,63.3004124 170.316914,63.1374311 C170.682348,62.9744497 171.046193,62.7915925 171.407655,62.5936298 C171.769116,62.3960646 172.128592,62.1857789 172.481712,61.9584 C172.787564,61.7703752 173.088253,61.5684373 173.379011,61.3505988 C173.575233,61.2039155 173.760333,61.050872 173.9359,60.8914683 C174.11107,60.7316671 174.27631,60.5655056 174.431222,60.3913938 C174.739854,60.0435677 175.004397,59.667518 175.224054,59.2707975 C175.370625,59.0040646 175.505676,58.732959 175.631195,58.4574807 C175.757111,58.181605 175.871904,57.901754 175.973988,57.6199155 C176.076071,57.338077 176.165046,57.0538534 176.240913,56.7672447 C176.316383,56.4802385 176.379142,56.1904497 176.429588,55.8982758 C176.481226,55.6076919 176.521741,55.3151205 176.549149,55.0229466 C176.580925,54.688636 176.592842,54.3523379 176.585692,54.0172323 C176.578145,53.6817292 176.552723,53.3478161 176.508633,53.0174807 C176.46494,52.6867478 176.401783,52.3584 176.31678,52.0328348 C176.222641,51.6710957 176.100301,51.3125366 175.949758,50.9595429 C175.798421,50.6053565 175.618881,50.2551453 175.415907,49.9089093 C175.213329,49.5630708 174.988111,49.2204124 174.736279,48.8857043 C174.483653,48.5490087 174.203223,48.2321888 173.896179,47.9364373 C173.589532,47.6410832 173.25667,47.3687851 172.907125,47.1211329 C172.546855,46.8671205 172.172285,46.6329839 171.78858,46.4155429 C171.404477,46.1984994 171.013622,46.0037168 170.621972,45.8359652 C170.230322,45.6686112 169.834701,45.5286857 169.435901,45.4181764 C169.037102,45.3076671 168.635919,45.2249839 168.236722,45.1685366 C167.837128,45.1120894 167.439521,45.0846609 167.045488,45.0866484 C166.651455,45.0890335 166.260997,45.1212323 165.876497,45.1828472 C165.4916,45.2448596 165.112661,45.3366857 164.734914,45.4571329 C164.356769,45.5783752 163.979419,45.727841 163.60763,45.9019528 C163.233458,46.0768596 162.862066,46.2744248 162.494646,46.4942509 C162.127226,46.714077 161.766559,46.9557665 161.422972,47.2256795 C161.137377,47.4562385 160.872438,47.699518 160.624578,47.9567106 C160.376719,48.2139031 160.143954,48.4834186 159.927077,48.7640646 C159.709802,49.044313 159.508814,49.3333068 159.322919,49.6298534 C159.137025,49.9260025 158.967813,50.2281143 158.816476,50.5338037 C158.665536,50.8394932 158.532867,51.1487602 158.419662,51.4635925 C158.306855,51.7784248 158.21073,52.0992199 158.130096,52.4235925 C158.034765,52.8171329 157.96287,53.2170335 157.915999,53.6248845 C157.869526,54.0299528 157.848474,54.4397913 157.856418,54.8516174 C157.864759,55.2634435 157.903686,55.6764621 157.973198,56.0847106 C158.043504,56.492959 158.146381,56.8896795 158.2862,57.274872 C158.426018,57.6604621 158.602776,58.0353193 158.813298,58.3978534 C159.023422,58.7603876 159.26294,59.1102012 159.531058,59.448487 C159.797983,59.7855801 160.092316,60.1127354 160.412468,60.4220025",id:"Fill-10",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:27}}),_react2.default.createElement("path",{d:"M37.4431763,49.8664944 C37.259665,50.2727553 37.1023697,50.6837863 36.967318,51.0932273 C36.8326637,51.5026683 36.7210475,51.9144944 36.6304835,52.3291031 C36.5403167,52.7441093 36.471202,53.1599106 36.4227423,53.5717366 C36.3746798,53.9835627 36.3468751,54.3898236 36.3405197,54.7861466 C36.3337671,55.1828671 36.3512444,55.5724323 36.3913627,55.9572273 C36.4223451,56.2517863 36.4644494,56.5443578 36.5200589,56.832954 C36.5752712,57.1219478 36.6439886,57.407364 36.7281973,57.6864199 C36.8167752,57.9611031 36.9236249,58.2266435 37.0507323,58.482246 C37.1770452,58.7374509 37.323616,58.983513 37.4868695,59.2200348 C37.7112935,59.533277 37.9639194,59.8345938 38.240378,60.1239851 C38.517631,60.4129789 38.8123613,60.6936248 39.1205967,60.967513 C39.4288321,61.2406062 39.7481895,61.5085317 40.0810519,61.7645317 C40.3614826,61.9887304 40.6530352,62.2037863 40.9557097,62.4041342 C41.1598759,62.5392894 41.3668226,62.6617242 41.5761526,62.7734261 C41.7854826,62.8847304 41.9975931,62.9841093 42.2136756,63.0711652 C42.6454436,63.2440845 43.0883334,63.3665193 43.5351953,63.4392646 C43.8358837,63.4869665 44.1365722,63.5227429 44.438055,63.5477863 C44.7395379,63.5728298 45.0418151,63.5867429 45.3413119,63.5875379 C45.6408087,63.5887304 45.9383194,63.5760099 46.2334469,63.5505689 C46.5285744,63.5247304 46.8225102,63.4861714 47.11446,63.4348919 C47.4052182,63.3852025 48.0483021,63.3243826 48.3327049,63.2516373 C48.6576232,63.1685565 48.6234631,63.066395 48.936465,62.9459478 C49.249467,62.8258981 49.5545247,62.6887553 49.8504466,62.5357118 C50.1463685,62.3826683 50.433949,62.2121342 50.711202,62.0221217 C51.0198346,61.8114385 51.3157565,61.5749168 51.5965844,61.3137491 C51.8790012,61.0517863 52.1479127,60.7639851 52.4045108,60.4563081 C52.6615061,60.1482335 52.9073794,59.8202832 53.1373644,59.4696745 C53.3681437,59.1178733 53.5715155,58.7469913 53.745891,58.3578236 C53.9198692,57.9690534 54.0636595,57.5635876 54.1784533,57.1505689 C54.2952332,56.7256248 54.3893722,56.293923 54.4616645,55.8594385 C54.5335596,55.424954 54.5812249,54.9928547 54.600291,54.5691031 C54.6193571,54.1457491 54.6102213,53.7283578 54.5716918,53.3189168 C54.5327652,52.9086807 54.4652394,52.5083826 54.3711005,52.1188174 C54.2773588,51.7292522 54.1566068,51.3520099 54.0088444,50.9882832 C53.8614793,50.624159 53.687501,50.2731528 53.4892929,49.9376497 C53.2910849,49.6017491 53.0690441,49.2797615 52.8219791,48.9681093 C52.5749141,48.6564571 52.3044137,48.3531528 52.0160388,48.0621714 C51.7264723,47.7692025 51.4194285,47.4849789 51.0972907,47.2098981 C50.7747557,46.9352149 50.4367295,46.6728547 50.0796372,46.4347429 C49.7781543,46.2383702 49.4707133,46.0654509 49.1565197,45.9139975 C48.8423261,45.7617491 48.5205856,45.6277863 48.1924896,45.5125068 C47.8647909,45.3968298 47.5323256,45.299041 47.1978743,45.2187429 C46.8630257,45.1380472 46.5273828,45.0760348 46.1937259,45.0327056 C45.8596717,44.9889789 45.5276037,44.965923 45.1951384,44.9643329 C44.8622759,44.9623453 44.5282218,44.979836 44.1957565,45.0132273 C43.792985,45.0565565 43.3929939,45.1245317 42.9941945,45.2195379 C42.5977783,45.3133516 42.204937,45.4334012 41.8208344,45.5816745 C41.4367317,45.7295503 41.0613677,45.9064447 40.7014949,46.1111652 C40.3416221,46.3150907 40.0035959,46.5460472 39.6882107,46.8076124 C39.3732226,47.0687801 39.0800812,47.360954 38.8095808,47.680159 C38.5394776,47.9989665 38.2908238,48.3420224 38.0632221,48.7073391 C37.8352232,49.0722584 37.6270849,49.459836 37.4431763,49.8664944",id:"Fill-12",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:28}}),_react2.default.createElement("path",{d:"M65.7173021,62.482564 C66.0918717,62.6920547 66.4755771,62.8709366 66.8660351,63.0208 C67.0610656,63.0955329 67.258082,63.1635081 67.4562901,63.224328 C67.6548954,63.2859429 67.8546923,63.340005 68.0552837,63.3877068 C68.255875,63.4358062 68.4564664,63.4771478 68.657455,63.5125267 C68.8588407,63.5479056 69.0598293,63.5769242 69.2604206,63.5999801 C69.461012,63.6226385 69.6612061,63.6397317 69.8602086,63.6508621 C70.0592112,63.6623901 70.257022,63.6679553 70.4532441,63.6675578 C70.6498633,63.6671602 70.8452909,63.6611975 71.0399241,63.6488745 C71.2349545,63.636154 71.4283961,63.6174708 71.6210432,63.5924273 C71.9161707,63.5542658 72.2089149,63.5013963 72.4980842,63.4342161 C72.7872536,63.3666385 73.0732452,63.2843528 73.3532787,63.1869615 C73.6281484,63.0863901 73.8954711,62.9675329 74.1524664,62.8307876 C74.4098589,62.6936447 74.6577183,62.5398062 74.8968391,62.3700671 C75.2138131,62.1418932 75.5188709,61.8898683 75.8124095,61.6167752 C76.1063453,61.3440795 76.3915425,61.0530981 76.6687955,60.7493963 C76.946843,60.4452969 77.2181378,60.1296696 77.4779135,59.8009242 C78.1217919,59.014241 78.6635872,58.2899677 78.9221713,57.2806758 C79.3507615,55.6095205 79.3976324,53.8437565 79.0743029,52.1499429 C78.9301155,51.3954584 78.7569317,50.6270609 78.3315191,49.9946137 C78.1166282,49.6746137 77.8739325,49.3736944 77.6248815,49.0787379 C77.3754332,48.7841789 77.1188351,48.4951851 76.8749478,48.199036 C76.6223219,47.892154 76.3482466,47.5991851 76.0551052,47.3205267 C75.7627582,47.0422658 75.4505506,46.7795081 75.1160993,46.5358311 C74.781648,46.292154 74.4336915,46.0763031 74.0718326,45.8882783 C73.7564474,45.7245019 73.4323236,45.5762286 73.1014471,45.445446 C72.7705707,45.3146634 72.4325445,45.202564 72.0905462,45.1095453 C71.7481506,45.0161292 71.4005914,44.9406012 71.0498544,44.883359 C70.6991174,44.8257193 70.3448056,44.7859677 69.9893021,44.7652969 C69.6334014,44.7442286 69.2763091,44.7418435 68.9192167,44.7601292 C68.5621244,44.7784149 68.2054293,44.8177689 67.850323,44.8793839 C67.5369238,44.9346385 67.2255107,45.0101665 66.920453,45.1063652 C66.4628664,45.2502658 66.0199766,45.4430609 65.6036999,45.6807752 C65.1878204,45.918887 64.7981568,46.2015205 64.447817,46.5286758 C63.5811035,47.3368248 62.5165791,48.1091975 62.050651,49.2456944 C61.6494683,50.2231851 61.486612,51.3390112 61.2705294,52.3697689 C61.2002232,52.705272 61.1446137,53.0419677 61.105687,53.3782658 C61.065966,53.7137689 61.0437222,54.049272 61.0401473,54.3831851 C61.0361752,54.7170981 61.0512692,55.0510112 61.0846349,55.3821416 C61.1291225,55.7824398 61.2006204,56.1803528 61.2991286,56.5766758 C61.3976368,56.9729988 61.5239498,57.3673342 61.6776703,57.7557068 C61.8313908,58.144477 62.0117244,58.5256944 62.2162879,58.8953839 C62.4204541,59.2650733 62.6476586,59.6224398 62.8979013,59.9635081 C63.1477467,60.3045764 63.4202332,60.6293466 63.7125802,60.9330484 C64.0049272,61.2367503 64.3183264,61.5189863 64.6523805,61.7781665 C64.987229,62.0373466 65.3427325,62.2726758 65.7173021,62.482564",id:"Fill-14",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:29}}),_react2.default.createElement("path",{d:"M22.2285407,45.2721292 C21.7999505,45.2808745 21.3797016,45.3202286 20.9685887,45.3870112 C20.5578729,45.4537938 20.1547042,45.5472099 19.7618629,45.6640795 C19.3694188,45.7809491 18.9876994,45.9208745 18.6194852,46.0810733 C18.2508738,46.241272 17.8961647,46.4209491 17.5569468,46.6181168 C17.2181262,46.8152845 16.8936051,47.032328 16.5853697,47.2684522 C16.3494266,47.4501168 16.1226194,47.6429118 15.9057424,47.8468373 C15.6888654,48.0503652 15.4823159,48.2650236 15.2880799,48.4900174 C15.1005965,48.7158062 14.9282071,48.953123 14.7740894,49.2003776 C14.6203689,49.4480298 14.482934,49.7056199 14.3609903,49.9723528 C14.2017089,50.3289242 14.064274,50.6998062 13.9470969,51.0830112 C13.8299198,51.4662161 13.7294255,51.8609491 13.6412447,52.2636323 C13.553064,52.6663155 13.4760051,53.0757565 13.4152319,53.4915578 C13.3564447,53.8457441 13.3111627,54.2058932 13.2841524,54.5676323 C13.2666751,54.8121043 13.2603198,55.0526012 13.2654835,55.289918 C13.27025,55.5268373 13.2869329,55.7609739 13.3167237,55.9919304 C13.3767025,56.453446 13.4863326,56.9002534 13.6412447,57.325595 C13.7476972,57.6094211 13.8672576,57.8837068 13.9983371,58.1496447 C14.1294166,58.4151851 14.2724124,58.6727752 14.4261329,58.9204273 C14.5802506,59.168477 14.7454902,59.4073839 14.9210573,59.6371478 C15.0966244,59.8673093 15.2833134,60.089918 15.480727,60.3053714 C15.6781407,60.5208248 15.8862791,60.7295205 16.1059365,60.9306634 C16.3565764,61.1600298 16.6235019,61.3794584 16.902741,61.587359 C17.18198,61.7952596 17.4703549,61.9932224 17.7662768,62.1800547 C18.0618015,62.366887 18.3648732,62.5413963 18.6762863,62.7011975 C19.0218595,62.8784894 19.3785546,63.0359056 19.7447828,63.1686758 C20.1114082,63.303036 20.4879638,63.4131478 20.8732581,63.5002037 C21.2585524,63.5876571 21.6529825,63.6516571 22.0521792,63.687036 C22.4517731,63.7224149 22.845806,63.7259925 23.2386473,63.6969739 C23.6314885,63.6671602 24.0199605,63.6043528 24.3985022,63.5117317 C24.7837965,63.4123528 25.1603521,63.2875329 25.5273747,63.1392596 C25.8940001,62.9909863 26.2499008,62.8188621 26.5930908,62.6232845 C26.9362807,62.4285019 27.2663627,62.2102658 27.5813507,61.971359 C27.8959415,61.7320547 28.1942467,61.471682 28.4742802,61.1926261 C28.7539164,60.9131727 29.0156782,60.615036 29.2607572,60.2998062 C29.5054389,59.9845764 29.733835,59.6530484 29.9407817,59.308005 C30.1481256,58.9629615 30.3352118,58.6048 30.5008486,58.232328 C30.6664855,57.8594584 30.8106729,57.4714832 30.9302333,57.0719801 C31.0497937,56.6720795 31.1439326,56.261446 31.21265,55.8420671 C31.2813675,55.4226882 31.3230746,54.9969491 31.3337993,54.5680298 C31.3429351,54.2102658 31.3318132,53.8604522 31.3020224,53.5173963 C31.2722316,53.1739429 31.2241691,52.8356571 31.1606155,52.5041292 C31.0966645,52.1726012 31.0188113,51.8474335 30.9270556,51.5298186 C30.8360944,51.2118062 30.7304364,50.9021416 30.6104788,50.6012224 C30.4905212,50.3007006 30.3554696,50.0097193 30.2041323,49.7294708 C30.0527951,49.4492224 29.8843778,49.1785143 29.7008665,48.9193342 C29.4744565,48.6080795 29.2250082,48.3115329 28.9517273,48.0300919 C28.6780492,47.7482534 28.3805385,47.4823155 28.0611811,47.2334708 C27.7414266,46.9850236 27.4006199,46.7548621 27.0439248,46.5461665 C26.6868325,46.3378683 26.3146461,46.151036 25.9293519,45.9888497 C25.544852,45.8270609 25.1472442,45.689918 24.741295,45.5798062 C24.3357429,45.4704894 23.9226439,45.3886012 23.5023951,45.3369242 C23.0825435,45.2848497 22.6575281,45.2633839 22.2285407,45.2721292",id:"Fill-16",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:30}}),_react2.default.createElement("path",{d:"M11.3591904,53.0407752 C11.3691207,52.8925019 11.39057,52.7247503 11.4203608,52.5518311 C11.4100334,52.5518311 11.3997059,52.5522286 11.3893784,52.5522286 C11.2257276,52.5538186 11.0636657,52.5558062 10.9023982,52.5581913 C10.7411307,52.5601789 10.5810548,52.5629615 10.4225678,52.5653466 C10.2632864,52.5681292 10.105991,52.5701168 9.95028441,52.5725019 C9.79457785,52.574887 9.64085735,52.5768745 9.4891229,52.5788621 C9.33738845,52.5804522 9.18764006,52.5820422 9.04106934,52.5824398 C8.89449863,52.5832348 8.74951676,52.5836323 8.60493211,52.5836323 L7.96582025,52.5836323 C7.65122946,52.5836323 7.34498008,52.5832348 7.04468887,52.5820422 C6.74479487,52.5804522 6.45125623,52.5776696 6.16327855,52.5732969 C5.77838148,52.5681292 5.40420909,52.5573963 5.04235024,52.5434832 C4.68049138,52.5299677 4.33134326,52.512477 3.99689194,52.4937938 C3.7855759,52.4818683 3.56949333,52.4647752 3.35142471,52.4464894 C3.13335609,52.4278062 3.35936893,52.4385391 3.14010868,52.4198559 C2.91965679,52.4007752 2.69602722,52.3824894 2.47160324,52.3665888 C2.20944424,52.3483031 1.95046293,52.3165019 1.69267325,52.2906634 C1.45156642,52.2668124 1.21284285,52.3157068 0.980474644,52.2326261 C0.833506722,52.180154 0.665089428,52.088328 0.53361272,52.179359 C0.510971715,52.1952596 0.492700028,52.2151354 0.477208815,52.2373963 C0.445829177,52.2815205 0.427160279,52.3351851 0.410080223,52.3864646 C0.264701144,52.8312845 0.165795704,53.2315826 0.111775063,53.689123 C0.07682053,54.0127006 0.0565627894,54.3315081 0.0696707392,54.6022161 C0.082778689,54.8725267 0.127663487,55.0955329 0.21584424,55.2294957 C0.374331269,55.468005 0.661117322,55.5745391 0.981269066,55.6242286 C1.3010236,55.673918 1.65374661,55.6683528 1.93735498,55.6806758 C2.34608469,55.6981665 2.77110003,55.7021416 3.21081216,55.7077068 C3.65131872,55.7136696 3.65171593,55.6941913 4.11367185,55.6973714 C4.57721662,55.7017441 5.03241997,55.7013466 5.47054326,55.7017441 C5.90826934,55.7025391 6.33249026,55.7021416 6.74638371,55.7100919 C6.96048022,55.7144646 7.17219347,55.7164522 7.38271509,55.7172472 C7.59363392,55.7180422 7.80336112,55.7172472 8.01388273,55.7148621 C8.22480156,55.712477 8.43770644,55.7077068 8.65299459,55.7009491 C8.86828273,55.6941913 9.08754298,55.6846509 9.31156976,55.673918 C9.98523894,55.6409242 10.6688384,55.5892472 11.3353578,55.481918 C11.2539296,55.495036 11.345288,53.2359553 11.3591904,53.0407752",id:"Fill-18",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:31}}),_react2.default.createElement("path",{d:"M34.3869188,53.818713 C34.3885077,53.7058186 34.3904937,53.5941168 34.3924798,53.4828124 C34.3936714,53.3162534 34.3952603,53.152477 34.4008212,52.9918807 C34.4063821,52.830887 34.4167096,52.6722783 34.4365702,52.5168497 C34.3150237,52.5156571 34.1914912,52.5152596 34.0707392,52.5144646 C33.6060028,52.5104894 33.1456357,52.4997565 32.684077,52.4778932 C32.6658053,52.4770981 32.646342,52.4763031 32.631248,52.486241 C32.6054293,52.5029366 32.6042377,52.5403031 32.6062237,52.5713093 C32.6340285,53.025272 32.6511085,53.4796323 32.6570667,53.9347876 C32.6582583,54.048477 32.6590527,54.1621665 32.6590527,54.2758559 C32.6594499,54.3895453 32.6586555,54.5032348 32.6578611,54.6169242 C32.6574639,54.7206758 32.640781,54.8514584 32.6419727,54.9790609 C32.6435615,55.1062658 32.6638192,55.2302907 32.7396865,55.3193342 C32.7968848,55.3869118 32.8890377,55.4214957 32.9803961,55.4381913 C33.1666879,55.4723776 33.3831676,55.4445516 33.5702538,55.4409739 C33.6838561,55.4389863 33.8248658,55.4477317 33.9539593,55.4405764 C34.0826555,55.4334211 34.1982438,55.4123528 34.272125,55.3495453 C34.3039018,55.3225143 34.3237623,55.2835578 34.3392536,55.2434087 C34.3773858,55.1456199 34.3904937,55.045446 34.3940686,54.9420919 C34.3976435,54.8383404 34.3936714,54.7318062 34.3956575,54.6212969 C34.3988351,54.4909118 34.3952603,54.3569491 34.3920826,54.2217938 C34.3885077,54.0866385 34.3849328,53.9510857 34.3869188,53.818713",id:"Fill-20",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:32}}),_react2.default.createElement("path",{d:"M58.5159136,54.0935553 C58.5258439,53.9615801 58.5349797,53.8335801 58.542924,53.7043876 C58.5516626,53.5755925 58.5588124,53.445605 58.5659622,53.3124373 C58.5794673,53.0584248 58.5965474,52.8075925 58.6275298,52.5603379 L57.9896096,52.5603379 L56.5592542,52.5603379 C56.5699789,52.7098037 56.5799092,52.8616547 56.5882506,53.0162882 C56.5969892,53.1709217 56.604139,53.3271453 56.6093028,53.4853565 C56.6148637,53.6427727 56.6188358,53.8021764 56.6208219,53.9619776 C56.6220135,54.0677168 56.6291633,54.1718658 56.6371075,54.2756174 C56.6450517,54.3793689 56.6541876,54.482723 56.6597485,54.5864745 C56.6665011,54.7112944 56.662529,54.8341267 56.664515,54.9466236 C56.6665011,55.0591205 56.6736509,55.162077 56.7038389,55.2447602 C56.7332325,55.327841 56.7856643,55.3930335 56.8770227,55.4335801 C56.9683811,55.4749217 57.0986662,55.4944 57.2837664,55.4896298 C57.3826718,55.4868472 57.5006433,55.4892323 57.622587,55.4876422 C57.7445307,55.4864497 57.869652,55.4808845 57.9836514,55.4618037 C58.0976509,55.4431205 58.2005284,55.4081391 58.2779845,55.3473193 C58.3558378,55.2868969 58.409064,55.1994435 58.4245552,55.0774062 C58.4460046,54.9036919 58.4630846,54.7335553 58.4777814,54.5681888 C58.492081,54.4028224 58.5047917,54.2454062 58.5159136,54.0935553",id:"Fill-22",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:33}}),_react2.default.createElement("path",{d:"M187.833544,51.6902161 C187.880812,51.0816199 187.846255,50.597446 187.620242,50.2810236 C187.507434,50.1232099 187.346961,50.0059429 187.124126,49.9343901 C186.900894,49.8624398 186.615299,49.8366012 186.249866,49.8600547 C185.764077,49.8918559 185.27233,49.8870857 184.793294,49.8660174 C184.311478,49.8449491 183.859055,49.8103652 183.414974,49.7809491 C182.931965,49.7495453 182.45849,49.7765764 181.985413,49.8103652 C181.512732,49.8445516 181.040449,49.8862907 180.564987,49.8835081 C180.222592,49.8815205 179.722901,49.7821416 179.270081,49.7745888 C179.101664,49.7690236 178.946751,49.7773714 178.803756,49.8167255 C178.660363,49.8560795 178.530078,49.9272348 178.411312,50.047682 C178.320748,50.1395081 178.291354,50.2110609 178.171794,50.2750609 C178.05263,50.3390609 177.79206,50.3020919 177.823043,50.497272 C177.852436,50.6833093 177.883419,50.8685516 177.914798,51.0533963 C177.946178,51.2386385 177.97716,51.4234832 178.00576,51.609123 C178.034756,51.7943652 178.061766,51.9804025 178.089174,52.1684273 C178.115787,52.3564522 178.141606,52.5456696 178.164247,52.736477 C178.187285,52.9272845 178.20794,53.118887 178.225814,53.310887 C178.243291,53.5032845 178.258783,53.6960795 178.269905,53.8888745 C178.281424,54.0820671 178.289368,54.2756571 178.294134,54.4696447 C178.299298,54.6640298 178.301681,54.8588124 178.301284,55.0543901 C178.30049,55.3910857 178.426008,55.5310112 178.607534,55.5898435 C178.789059,55.6478807 179.030166,55.6240298 179.253398,55.6327752 C179.43254,55.640328 179.618037,55.6482783 179.808301,55.6538435 C179.998565,55.6594087 180.190021,55.6629863 180.381079,55.6617938 C180.825558,55.6594087 181.261298,55.6609988 181.69664,55.667359 C182.131983,55.6737193 182.566929,55.6840547 183.018955,55.7019429 C183.257281,55.7110857 183.499182,55.7154584 183.747836,55.7150609 C183.99649,55.7146634 184.254279,55.7087006 184.523985,55.6987627 C184.7925,55.6884273 185.068164,55.6749118 185.345417,55.6606012 C185.623067,55.6466882 185.90032,55.6331727 186.172807,55.6228373 C186.440924,55.6121043 186.733271,55.628005 187.003771,55.6057441 C187.274272,55.5826882 187.518556,55.5226634 187.685782,55.3620671 C187.938805,55.1195826 187.926491,54.719682 187.914575,54.3945143 C187.899084,53.9683776 187.855788,53.5350857 187.829969,53.0858932 C187.804151,52.6370981 187.796206,52.1692224 187.833544,51.6902161",id:"Fill-24",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:34}}),_react2.default.createElement("path",{d:"M156.41359,49.4813814 C156.159772,49.4678658 155.89245,49.4805863 155.64459,49.5175553 C155.449163,49.5469714 155.237052,49.5728099 155.011834,49.5966609 C154.786218,49.6209093 154.547495,49.6407851 154.299635,49.6594683 C154.044626,49.6729839 153.788822,49.6825242 153.535005,49.6888845 C153.283968,49.6936547 153.034917,49.6976298 152.787057,49.7075677 C152.490738,49.7179031 152.196405,49.7433441 151.902469,49.7731578 C151.608533,49.8033689 151.315392,49.8371578 151.022648,49.8625988 C150.436365,49.9134807 149.850479,49.932164 149.257841,49.8216547 C149.163702,49.804164 149.03302,49.8451081 149.013954,49.9564124 C148.898365,50.623841 148.871752,51.2956422 148.81654,51.9702261 C148.791516,52.2751205 148.690227,52.4945491 148.549217,52.6766112 C148.539287,52.6782012 148.529357,52.6809839 148.519426,52.6817789 C148.357762,52.697282 148.193317,52.6984745 148.024502,52.6956919 C147.855688,52.6929093 147.683695,52.6865491 147.50932,52.6877416 C147.363544,52.6889342 147.205851,52.6889342 147.03942,52.6873441 C146.873386,52.6865491 146.698613,52.684164 146.517882,52.6805863 C146.337151,52.6774062 146.154037,52.6730335 145.969334,52.6682634 C145.788604,52.6630957 145.607078,52.658723 145.420787,52.6567354 C145.235289,52.6563379 145.04145,52.6571329 144.838476,52.658723 C144.635898,52.6607106 144.424185,52.6626981 144.204528,52.6646857 C143.32272,52.6698534 142.305861,52.6738286 141.163483,52.672636 C140.592295,52.6722385 139.989329,52.6690584 139.35697,52.6630957 C138.724213,52.6575304 138.062063,52.6495801 137.371711,52.6396422 C136.680962,52.6297043 135.962408,52.6181764 135.216844,52.6050584 C134.470882,52.5919404 133.69791,52.5776298 132.89912,52.5629217 C132.258419,52.5486112 131.603021,52.5362882 130.932927,52.5239652 C130.262436,52.5120398 129.578439,52.4997168 128.881732,52.4873938 C128.185819,52.4754683 127.476003,52.4643379 126.755463,52.4547975 C126.034923,52.4456547 125.301673,52.4381019 124.554122,52.4317416 C123.806572,52.4245863 123.044722,52.4186236 122.26897,52.4130584 C121.493217,52.4074932 120.704357,52.4047106 119.902389,52.403518 C119.100421,52.402723 118.286139,52.4039155 117.459544,52.4066981 C116.632948,52.4098783 115.79404,52.4154435 114.945201,52.4218037 C114.095964,52.4285615 113.237592,52.4361143 112.370084,52.4448596 C111.600687,52.4524124 110.822949,52.4623503 110.038061,52.4718907 C109.253173,52.4822261 108.463518,52.4893814 107.668302,52.493754 C106.873484,52.4985242 106.073899,52.4997168 105.269548,52.4973317 C104.465593,52.4953441 103.65727,52.4893814 102.844974,52.480636 C102.033076,52.4710957 101.216411,52.4591702 100.394582,52.4480398 C99.6430594,52.4377043 98.8867704,52.4293565 98.1253177,52.4229963 C97.363865,52.4170335 96.5968513,52.4134559 95.8250711,52.4122634 C95.0532909,52.4110708 94.2787303,52.4102758 93.5013891,52.4094807 C92.7244452,52.4086857 92.7387448,52.4078907 91.9566371,52.4074932 C91.173735,52.4066981 90.3880524,52.4063006 89.6003838,52.4059031 C88.812318,52.4051081 88.0218689,52.4051081 87.2302282,52.4051081 C86.4381902,52.4051081 85.6445635,52.4055056 84.8485534,52.4059031 C84.4509456,52.4059031 84.0525434,52.4063006 83.6537439,52.4066981 C83.2549445,52.4070957 82.8557478,52.4082882 82.4545651,52.4102758 C82.1248803,52.4122634 81.7920179,52.416636 81.4599498,52.4194186 C81.4682912,52.5335056 81.4722633,52.6499776 81.4758382,52.7664497 C81.4762354,52.7724124 81.4770298,52.7783752 81.4770298,52.7847354 C81.4941099,53.2152447 81.5350226,53.645754 81.5636218,54.0778534 C81.5914265,54.5103503 81.6069177,54.9432447 81.5691827,55.3781267 C81.9906232,55.4942012 82.4319241,55.4997665 82.8684586,55.500959 C83.3312089,55.5021516 83.791576,55.512487 84.2507515,55.5240149 C84.7103241,55.5355429 85.1691024,55.551046 85.6282778,55.5629714 C86.0874533,55.5752944 86.5478204,55.5860273 87.0109679,55.5860273 C87.6139336,55.601928 88.2168993,55.6233938 88.8214538,55.6424745 C89.4260084,55.6619528 90.0317545,55.679046 90.639884,55.6877913 C91.8831531,55.706872 92.3474923,55.6822261 93.6078416,55.6567851 C94.8681908,55.6317416 96.1261568,55.6078907 97.3678371,55.615841 C98.203171,55.6206112 99.0377105,55.6361143 99.8694695,55.653605 C100.702023,55.6710957 101.532193,55.6873938 102.358391,55.6961391 C103.184986,55.704487 104.008007,55.6997168 104.827055,55.6814311 C105.645706,55.6603627 106.461179,55.6309466 107.273475,55.5919901 C108.331644,55.5983503 109.385841,55.6055056 110.432888,55.6174311 C111.218174,55.6257789 111.996309,55.6381019 112.770075,55.6508224 C113.543842,55.6635429 114.316019,55.6742758 115.087402,55.6782509 C115.858785,55.6818286 116.632948,55.6766609 117.411481,55.6639404 C118.190411,55.6512199 118.973313,55.6329342 119.760187,55.6114683 C120.345676,55.5955677 120.93315,55.5812571 121.521816,55.5705242 C122.110483,55.5605863 122.700738,55.5534311 123.292581,55.5530335 C123.884425,55.5530335 124.478652,55.5582012 125.074468,55.5717168 C125.670284,55.5852323 126.267689,55.6059031 126.867874,55.6341267 C127.163001,55.6464497 127.458526,55.6579776 127.754448,55.6679155 C128.05037,55.6782509 128.345895,55.6854062 128.641816,55.6889839 C128.937341,55.6925615 129.233263,55.693754 129.529185,55.6925615 C129.825107,55.6913689 130.121426,55.6889839 130.417745,55.6850087 C130.714859,55.679841 131.012369,55.6734807 131.309086,55.6663255 C131.606199,55.6587727 131.902518,55.6512199 132.199235,55.6440646 C132.495951,55.6365118 132.792667,55.6305491 133.089781,55.6257789 C133.386894,55.6210087 133.684802,55.6182261 133.983107,55.6178286 C134.387071,55.6170335 134.791431,55.6182261 135.19738,55.6222012 C135.602932,55.6269714 136.010073,55.6341267 136.418406,55.641282 C136.826738,55.6492323 137.237057,55.6555925 137.647772,55.6619528 C138.058488,55.6679155 138.469204,55.6718907 138.877536,55.6738783 C139.285869,55.6762634 139.689435,55.6770584 140.089029,55.6794435 C140.48902,55.6818286 140.885833,55.6850087 141.279866,55.6881888 C141.673899,55.6917665 142.06674,55.6949466 142.459979,55.6989217 C142.854012,55.7021019 143.254797,55.706872 143.665513,55.7124373 C144.075832,55.717605 144.494094,55.7203876 144.910768,55.7199901 C145.118907,55.7199901 145.325059,55.7187975 145.530417,55.7164124 C145.735775,55.7136298 145.945899,55.7088596 146.16079,55.7017043 C146.375681,55.6913689 146.592558,55.679841 146.811024,55.6663255 C147.02949,55.6528099 147.246764,55.6384994 147.459271,55.6241888 C147.671382,55.6098783 147.877931,55.5959652 148.076934,55.5828472 C148.275936,55.5697292 148.465803,55.5574062 148.647328,55.5470708 C148.86063,55.5343503 148.812171,55.3280398 148.81376,55.1785739 C148.815746,54.9877665 148.847522,54.7965615 148.907501,54.6148969 C148.921801,54.5723627 148.938881,54.5274435 148.973835,54.4992199 C149.009187,54.4698037 149.056852,54.4618534 149.102929,54.4554932 C149.566871,54.3891081 150.033991,54.3553193 150.501905,54.3561143 C150.658008,54.3561143 150.814112,54.3600894 150.970216,54.3680398 C151.240716,54.3823503 151.511614,54.3934807 151.783306,54.4034186 C152.054601,54.4133565 152.327087,54.4209093 152.599177,54.426077 C152.871663,54.4316422 153.143355,54.4336298 153.411075,54.4324373 C153.645032,54.4316422 153.878592,54.4256795 154.111357,54.4169342 C154.343726,54.4081888 154.575299,54.399841 154.805681,54.3950708 C154.959402,54.3922882 155.112725,54.3906981 155.265254,54.3906981 C155.41818,54.3903006 155.569915,54.3906981 155.717677,54.3914932 C155.865837,54.3922882 156.008832,54.3934807 156.149048,54.3958658 C156.209821,54.3966609 156.274963,54.3954683 156.31389,54.349754 C156.344078,54.3143752 156.351625,54.2599155 156.356789,54.2074435 C156.383799,53.9609839 156.401674,53.708959 156.417959,53.4509714 C156.433848,53.1933814 156.451325,52.9314186 156.474363,52.6678658 C156.489457,52.4917665 156.508921,52.3164621 156.530767,52.1407602 C156.5546,51.9658534 156.580418,51.7905491 156.607032,51.6152447 C156.634042,51.4407354 156.661847,51.2666236 156.690446,51.0960894 C156.734139,50.8384994 156.776243,50.5824994 156.827881,50.3296795 C156.877929,50.0768596 156.939497,49.8276174 157.022911,49.5871205 C156.84218,49.5290832 156.636028,49.4941019 156.41359,49.4813814",id:"Fill-26",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:35}}),_react2.default.createElement("path",{d:"M187.89678,31.5461963 C187.864209,31.4686807 187.831638,31.3903702 187.799464,31.3120596 C187.669576,30.9972273 187.541277,30.6804075 187.395898,30.3723329 C187.24893,30.0606807 187.094018,29.7486311 186.933942,29.4349913 C186.738117,29.0529789 186.539114,28.6693764 186.342098,28.2849789 C186.145479,27.9001839 185.955215,27.5145938 185.778059,27.1286062 C185.689481,26.9350161 185.603286,26.7422211 185.517489,26.5498236 C185.431691,26.3566311 185.346291,26.1642335 185.260891,25.9726311 C185.17549,25.7810286 185.089296,25.5902211 185.001909,25.4002087 C184.914126,25.2101963 184.826342,25.0209789 184.73697,24.832954 C184.647597,24.6453267 184.558225,24.4588919 184.467661,24.2736497 C184.377494,24.0884075 184.286533,23.9047553 184.195175,23.7222957 C184.103419,23.5394385 184.011266,23.3581714 183.917524,23.1780969 C183.824577,22.9984199 183.730041,22.8195379 183.634313,22.642246 C183.523094,22.4367304 183.414259,22.2300224 183.305423,22.0229168 C183.197382,21.8154137 183.090135,21.606718 182.984477,21.3976248 C182.560256,20.5604571 182.155895,19.7137491 181.74796,18.8837366 C181.137447,17.6490534 180.51621,16.4739975 179.782959,15.4531776 C179.031834,14.4057242 178.142877,13.7363081 177.114101,13.3069913 C176.085723,12.878072 174.898858,12.6805068 173.57138,12.5847056 C172.693544,12.5215006 171.78711,12.4841342 170.863198,12.4610783 C169.938889,12.4384199 169.008224,12.430072 168.076368,12.4237118 C167.143321,12.4165565 166.20352,12.4129789 165.258159,12.4046311 C164.309223,12.3958857 163.357109,12.3911155 162.403009,12.3823702 C161.2936,12.3736248 160.182999,12.3616994 159.070015,12.3537491 C157.956634,12.3450037 156.844047,12.3414261 155.735035,12.3489789 C154.903276,12.3545441 154.075489,12.3628919 153.251674,12.3732273 C152.977202,12.3764075 152.702729,12.3799851 152.429448,12.3839602 C151.930155,12.390718 151.424506,12.3998609 150.898996,12.4105938 C150.63644,12.416159 150.36872,12.4225193 150.097822,12.428482 C149.826925,12.4352398 149.553247,12.4416 149.277582,12.4487553 C149.277582,12.4209292 149.28076,12.3938981 149.279568,12.3656745 C149.271624,12.1188174 148.825159,12.1216 148.834295,12.3684571 C148.835884,12.4074137 148.833501,12.4467677 148.834693,12.4857242 C148.702421,12.5544944 148.706791,12.7286062 148.838665,12.7945938 C148.839459,13.080805 148.828337,13.3678112 148.812052,13.6556124 C148.795766,13.9434137 148.774317,14.2316124 148.753264,14.5206062 C148.727048,14.8811528 148.699244,15.2420969 148.680972,15.6026435 C148.663495,15.9631901 148.651578,16.3233391 148.655948,16.6822957 C148.660317,17.063513 148.658331,17.445923 148.653565,17.8287304 C148.648798,18.2111404 148.643237,18.5935503 148.637676,18.9763578 C148.632512,19.3587677 148.628937,19.7419727 148.62576,20.1255752 C148.622185,20.5091776 148.619802,20.8935752 148.617021,21.2783702 C148.613843,21.8150161 148.609474,22.3520596 148.603913,22.8902957 C148.597955,23.4281342 148.591997,23.9675627 148.588025,24.5081839 C148.589216,25.0499975 148.597558,25.5926062 148.613049,26.1356124 C148.62854,26.6782211 148.650387,27.2200348 148.673822,27.7614509 C148.69686,28.3024696 148.719899,28.8422957 148.740951,29.3813267 C148.762003,29.9195627 148.780672,30.4566062 148.794177,30.9912646 C148.810065,31.6256994 148.815229,32.2589416 148.812449,32.8901963 C148.809271,33.4586435 148.800135,34.0258981 148.788219,34.5923578 C148.776303,35.1592149 148.763195,35.726072 148.75525,36.2929292 C148.747306,36.8601839 148.747703,37.4274385 148.754456,37.9954882 C148.765578,38.5639354 148.777494,39.1339727 148.788616,39.7040099 C148.799341,40.2744447 148.809668,40.8448795 148.81801,41.4153143 C148.826748,41.9861466 148.833501,42.5569789 148.836679,43.1294012 C148.840254,43.7014261 148.838665,44.275041 148.834693,44.850246 C148.831118,45.4246559 148.826748,46.0002584 148.823571,46.5762584 C148.820393,47.1518609 148.821187,47.7266683 148.828337,48.3006807 C148.83509,48.8754882 148.848595,49.4491031 148.868058,50.0215255 C148.871633,50.1300472 148.958622,50.2115379 149.069841,50.2127304 C149.481351,50.2182957 149.892862,50.2143205 150.303975,50.2035876 C150.715088,50.1920596 151.125406,50.1737739 151.53493,50.150718 C151.944057,50.1268671 152.353184,50.0986435 152.769461,50.0739975 C153.186135,50.0497491 153.612342,50.0322584 154.036165,50.0215255 C154.469919,50.0096 154.981129,50.0537242 155.441099,50.0362335 C155.634144,50.0286807 155.825202,50.0203329 156.014671,50.0131776 C156.20136,50.0052273 156.385666,49.998072 156.568383,49.9952894 C156.673644,49.9936994 156.781288,49.9901217 156.874632,49.9360596 C156.976715,49.8764323 157.104617,49.318718 157.168568,49.1859478 C157.241655,49.0325068 157.318714,48.8806559 157.39895,48.730395 C157.47879,48.5801342 157.561807,48.4310658 157.64681,48.2831901 C157.729827,48.1388919 157.815624,47.9957863 157.903408,47.8538733 C157.991191,47.7123578 158.081358,47.5724323 158.174703,47.4352894 C158.268047,47.2973516 158.364172,47.1617988 158.463077,47.0282335 C158.56238,46.8946683 158.664463,46.7634882 158.769327,46.6342957 C159.288084,45.9966807 159.875161,45.4143205 160.518245,44.902718 C160.856271,44.6339975 161.219322,44.4109913 161.569662,44.1613516 C161.881472,43.9395379 162.140453,43.6966559 162.487218,43.5086311 C162.908261,43.2808547 163.350754,43.1015752 163.810327,42.9628422 C164.270694,42.8233143 164.751318,42.7203578 165.249421,42.6523826 C165.747523,42.5939478 166.263102,42.5748671 166.795761,42.597923 C167.061893,42.6094509 167.33279,42.6265441 167.605674,42.650395 C167.878955,42.6734509 168.154222,42.7032646 168.429886,42.7402335 C168.707139,42.7740224 168.983597,42.8133764 169.256878,42.8563081 C169.530556,42.8996373 169.801057,42.9473391 170.065996,43.0014012 C170.330936,43.0558609 170.589123,43.1170783 170.84016,43.1866435 C171.0908,43.2566062 171.335481,43.3345193 171.573411,43.4219727 C171.81134,43.5094261 172.043708,43.6068174 172.270912,43.7157366 C172.498117,43.8250534 172.722144,43.9455006 172.941404,44.0746932 C173.196413,44.224159 173.443081,44.3859478 173.688557,44.5604571 C173.951908,44.7472894 174.144158,45.0227677 174.368979,45.2692273 C174.610483,45.5339727 174.863109,45.7935503 175.118515,46.0571031 C175.372333,46.3182708 175.62615,46.5830161 175.869243,46.8588919 C176.112336,47.1355627 176.342321,47.4245565 176.548473,47.7326311 C176.820563,48.139687 177.044589,48.5729789 177.243195,49.0126311 C177.330184,49.2062211 177.393737,49.4153143 177.481918,49.6045317 C177.564538,49.7818236 177.657883,49.9261217 177.699987,50.1125565 C177.73375,50.2608298 177.834244,50.4536248 177.769896,50.6022957 C178.392722,50.5216 179.033026,50.5498236 179.659824,50.5375006 C180.062198,50.5299478 180.46497,50.5291528 180.86655,50.5299478 C181.267732,50.5303453 181.666532,50.5311404 182.062154,50.5287553 C182.457378,50.5263702 182.851411,50.5235876 183.246238,50.5196124 C183.641463,50.5156373 184.036688,50.5112646 184.431912,50.5041093 C184.827137,50.496954 185.222361,50.4878112 185.615997,50.4746932 C185.720463,50.4711155 185.825724,50.4671404 185.93019,50.4603826 C186.034657,50.4536248 186.137932,50.444482 186.23922,50.4297739 C186.306746,50.419836 186.373477,50.4079106 186.439017,50.3924075 C186.50416,50.3769043 186.568508,50.3586186 186.63087,50.3363578 C186.694026,50.3136994 186.7548,50.2874634 186.813587,50.2560596 C186.868005,50.227836 186.922025,50.1940472 186.952213,50.1411776 C186.980018,50.0922832 186.983593,50.0338484 186.987168,49.9770037 C186.992729,49.8851776 186.997098,49.7933516 187.001865,49.7023205 C187.006631,49.6108919 187.010603,49.5202584 187.013384,49.4288298 C187.016164,49.3377988 187.018945,49.2459727 187.021328,49.1533516 C187.023711,49.0607304 187.026095,48.9673143 187.027683,48.8735006 C187.029272,48.779687 187.031258,48.6850783 187.033244,48.590072 C187.03523,48.4946683 187.037614,48.3988671 187.040394,48.3018733 C187.043175,48.2056745 187.046352,48.1082832 187.051119,48.0100969 C187.056283,47.9119106 187.061049,47.8133267 187.067007,47.7147429 C187.072568,47.616159 187.078129,47.5171776 187.081704,47.4185938 C187.085676,47.3200099 187.086868,47.2218236 187.086471,47.1244323 C187.085279,47.0274385 187.082896,46.9308422 187.079321,46.8338484 C187.075746,46.7372522 187.071377,46.6406559 187.067007,46.5444571 C187.062638,46.4482584 187.058269,46.3528547 187.053899,46.2578484 C187.050324,46.1628422 187.047147,46.0674385 187.044763,45.9720348 C187.042777,45.8766311 187.041189,45.7812273 187.0396,45.6850286 C187.038408,45.5892273 187.036819,45.4934261 187.03523,45.3972273 C187.032847,45.2763826 187.030464,45.1555379 187.027683,45.0350907 C187.024506,44.914246 187.020136,44.7934012 187.015767,44.672954 C187.011398,44.5529043 187.00822,44.4324571 187.004645,44.3120099 C186.969691,42.9886807 186.992332,41.6677366 186.981607,40.3412273 C186.978826,39.9528547 186.970485,39.566072 186.955788,39.179687 C186.941886,38.7929043 186.929572,38.4065193 186.927586,38.0205317 C186.924806,37.6341466 186.930367,37.248954 186.938311,36.8637615 C186.946255,36.4789665 186.951816,36.0945689 186.949433,35.7117615 C186.947447,35.3806311 186.942283,35.0495006 186.93553,34.7179727 C186.928778,34.3868422 186.921231,34.0553143 186.914876,33.7233888 C186.90852,33.3874882 186.902959,33.0507925 186.900973,32.7133019 C186.899782,32.5487304 186.910109,32.3813764 186.897001,32.216805 C186.889454,32.1162335 186.845364,31.962395 186.912095,31.8737491 C186.958966,31.8129292 187.046749,31.8077615 187.123014,31.807364 C187.338302,31.8061714 187.551604,31.8232646 187.767687,31.8192894 C187.807011,31.8188919 187.849512,31.8180969 187.882878,31.7954385 C187.958348,31.744159 187.931735,31.6288795 187.89678,31.5461963",id:"Fill-28",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:36}}),_react2.default.createElement("path",{d:"M183.546093,30.298554 C183.642615,30.8451379 183.607263,31.3674733 182.978876,31.6461317 C182.693679,31.7725416 182.349694,31.8413118 181.994985,31.8842435 C181.639482,31.9275727 181.274445,31.9446658 180.944761,31.9673242 C180.59879,31.9915727 180.254011,32.0058832 179.91241,32.0138335 C179.570809,32.0221814 179.234372,32.0241689 178.903495,32.0233739 C178.573016,32.0225789 178.250878,32.0182062 177.937876,32.0150261 C177.624874,32.0122435 177.318625,32.0110509 177.017142,32.0166161 C176.68706,32.0229764 176.355389,32.0333118 176.022924,32.0416596 C175.025528,32.0639205 174.018202,32.0674981 173.046625,31.8663553 C171.765224,31.6016099 170.962858,30.7306534 170.115608,29.7964919 C169.268358,28.8619329 168.343254,28.0132373 167.45668,27.1172373 C166.589967,26.2419081 165.844005,25.2222807 164.614638,24.8525913 C163.430951,24.4960199 162.147166,24.6737093 160.931304,24.6733118 C159.657053,24.6729143 158.353408,24.7639453 157.084717,24.6307776 C155.953858,24.511523 154.718136,24.1207652 154.052808,23.1325416 C153.336241,22.067995 153.388275,20.6933863 153.358882,19.4650634 C153.342993,18.802405 153.337035,18.1393491 153.346171,17.4762932 C153.35054,17.1435727 153.358882,16.8108522 153.371195,16.4781317 C153.383509,16.1462062 153.329885,15.8929888 153.667117,15.7622062 C154.182696,15.5626534 154.794798,15.7053615 155.333018,15.6882683 C156.00351,15.6672 156.669235,15.6373863 157.340521,15.6429516 C159.974424,15.6644174 162.60515,15.8277963 165.239053,15.8639702 C166.606649,15.8826534 167.961138,15.8735106 169.322776,16.0178087 C169.942821,16.0830012 170.588289,16.0877714 171.196418,16.2249143 C171.858171,16.3739826 172.48338,16.6693366 173.079593,16.9853615 C174.1751,17.5653366 175.172099,18.2128894 176.023718,19.1232 C176.918634,20.0796224 177.647118,21.1779578 178.41294,22.2365416 C178.703698,22.6380323 178.990882,23.0419081 179.276476,23.4477714 C179.56207,23.8532373 179.845282,24.2602932 180.127698,24.6673491 C180.314784,24.9396472 180.501473,25.2127404 180.686971,25.4870261 C180.855388,25.7354733 181.015067,25.9926658 181.17554,26.251846 C181.33641,26.5114236 181.499266,26.7725913 181.666889,27.032964 C181.833718,27.2929391 182.003724,27.5533118 182.177305,27.8105043 C182.350092,28.0680944 182.526056,28.3229019 182.704403,28.5737342 C182.898242,28.8460323 183.080165,29.1223056 183.228721,29.4077217 C183.377675,29.6927404 183.491278,29.9876969 183.546093,30.298554",id:"Fill-30",fill:"#28C4D4",__source:{fileName:_jsxFileName,lineNumber:37}}),_react2.default.createElement("path",{d:"M185.288934,46.6459826 C185.410083,46.6396224 185.545532,46.6567155 185.6782,46.6638708 C185.810868,46.6706286 185.941551,46.6670509 186.050784,46.6197466 C186.171138,46.567672 186.22794,46.4718708 186.256141,46.3581814 C186.283946,46.2444919 186.283152,46.1129143 186.286329,45.9896845 C186.289507,45.8521441 186.291096,45.7150012 186.292288,45.5774609 C186.293876,45.439523 186.295863,45.3011876 186.298643,45.1624547 C186.301423,45.0229267 186.305793,44.8830012 186.311354,44.7422807 C186.317312,44.6011627 186.324859,44.4592497 186.332406,44.3173366 C186.341542,44.134082 186.347897,43.9520199 186.347897,43.7779081 C186.347897,43.6037963 186.339953,43.4396224 186.327639,43.2833988 C186.317312,43.1422807 186.320887,43.0087155 186.320887,42.8779329 C186.320887,42.7479453 186.318504,42.6199453 186.295465,42.4907528 C186.280371,42.406082 186.248992,42.3098832 186.150483,42.2681441 C186.10401,42.2482683 186.049989,42.2450882 185.998352,42.2431006 C185.741754,42.2335602 185.490717,42.2693366 185.238091,42.2542311 C185.060538,42.2438957 184.886162,42.2347528 184.715759,42.2295851 C184.545355,42.2240199 184.37813,42.2216348 184.212493,42.2228273 C184.046856,42.2236224 183.882411,42.227995 183.717966,42.2331627 C183.553123,42.2399205 183.388678,42.2458832 183.225027,42.2482683 C182.952938,42.2530385 182.682835,42.2566161 182.410348,42.2582062 C182.137465,42.2597963 181.857829,42.2601938 181.570248,42.2629764 C181.452674,42.2637714 181.32795,42.2653615 181.224278,42.3086907 C180.986348,42.4088646 181.059038,42.7213118 181.056655,42.9037714 C181.055066,43.046877 181.052285,43.1951503 181.054669,43.3525665 C181.057846,43.5505292 181.056258,43.7552497 181.05308,43.9703056 C181.049902,44.1861565 181.045136,44.4123429 181.041164,44.6436969 C181.039177,44.8750509 181.034808,45.1052124 181.029247,45.3337839 C181.024083,45.5619578 181.016139,45.7897342 181.010578,46.0179081 C181.005415,46.2103056 181.007401,46.4297342 181.140466,46.5410385 C181.232222,46.6181565 181.362507,46.6213366 181.483656,46.6221317 C181.687425,46.6237217 181.884839,46.6384298 182.083841,46.6531379 C182.283241,46.6674484 182.484627,46.681759 182.694354,46.681759 C182.833775,46.6861317 182.977168,46.6877217 183.121753,46.6881193 C183.266337,46.6889143 183.412908,46.6885168 183.557493,46.6893118 C183.70168,46.6901068 183.842293,46.6916969 183.974961,46.6960696 C184.126695,46.7012373 184.275649,46.7000447 184.422617,46.695672 C184.569585,46.6909019 184.714964,46.6829516 184.859549,46.6734112 C185.004134,46.6642683 185.147924,46.6535354 185.288934,46.6459826",id:"Fill-32",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:38}}),_react2.default.createElement("g",{id:"Group-36",transform:"translate(0.000000, 3.316472)",__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement("mask",{id:"mask-4",fill:"white",__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement("use",{xlinkHref:"#path-3",__source:{fileName:_jsxFileName,lineNumber:41}})),_react2.default.createElement("g",{id:"Clip-35",__source:{fileName:_jsxFileName,lineNumber:43}}),_react2.default.createElement("path",{d:"M149.06714,43.4242385 C149.061976,42.5043876 149.049663,41.5014559 149.0302,40.4321391 C149.010339,39.3628224 148.985712,38.2271205 148.959893,37.0401391 C148.947183,36.447046 148.935266,35.8412323 148.924939,35.2242882 C148.914214,34.6077416 148.905873,33.9800646 148.899915,33.3440398 C148.893162,32.5494062 148.88919,31.7404621 148.887998,30.9227727 C148.887204,30.1046857 148.887204,29.2770584 148.887204,28.4438658 C148.887204,27.6110708 148.886807,26.7719155 148.888395,25.9307727 C148.889984,25.0896298 148.89634,24.2449093 148.907064,23.4005863 C148.917392,22.5566609 148.9305,21.713928 148.945594,20.8763627 C148.960688,20.039195 148.976179,19.2079901 148.991273,18.386723 C149.006367,17.5654559 149.020269,16.7549217 149.031788,15.9594932 C149.043308,15.1636671 149.052046,14.3833441 149.057607,13.6217043 C149.061976,12.9260522 149.063963,12.2463006 149.063565,11.5852323 C149.061976,10.924959 149.05999,10.2825739 149.058004,9.66046211 C149.056018,9.03874783 149.053635,8.43810186 149.050457,7.86130683 C149.044102,6.70811429 149.037747,5.65151801 149.030597,4.71497143 C149.023447,3.77842484 149.016694,2.96272298 149.010339,2.29092174 C149.007956,1.95581615 148.99882,1.61991553 149.001998,1.28480994 C149.005175,0.978722981 149.134269,0.603070807 149.008353,0.310896894 C148.991273,0.271145342 148.968235,0.232586335 148.934075,0.206350311 C148.885218,0.169381366 148.82087,0.161431056 148.759699,0.157058385 C148.481255,0.136387578 148.204796,0.170971429 147.927146,0.167791304 C147.22885,0.159443478 146.197691,0.148313043 144.867433,0.136387578 C143.977284,0.131219876 142.950891,0.12724472 141.797392,0.128039752 C141.220642,0.128834783 140.612513,0.132412422 139.973401,0.137580124 C139.335083,0.143542857 138.666181,0.151890683 137.969473,0.161431056 C137.272369,0.171368944 136.546665,0.182896894 135.793951,0.196014907 C135.040442,0.209132919 134.260321,0.223443478 133.453983,0.238151553 C132.807722,0.252462112 132.145571,0.265182609 131.469122,0.277108075 C130.792672,0.28903354 130.10232,0.301754037 129.39886,0.313679503 C128.695797,0.325604969 127.979627,0.336735404 127.251937,0.346275776 C126.524247,0.355418634 125.784244,0.362971429 125.029544,0.369331677 C124.275241,0.376089441 123.506241,0.382449689 122.722942,0.388014907 C121.939642,0.393580124 121.143235,0.396760248 120.33372,0.397952795 C119.524602,0.398747826 118.702376,0.39755528 117.867439,0.394375155 C117.033297,0.391195031 116.186444,0.385629814 115.328866,0.379269565 C114.472083,0.372511801 113.605369,0.365356522 112.729917,0.356213665 C111.952576,0.349058385 111.167688,0.338722981 110.37565,0.328785093 C109.583612,0.318847205 108.786013,0.311691925 107.983251,0.306921739 C107.180885,0.302549068 106.373753,0.301754037 105.561855,0.303344099 C104.749956,0.305729193 103.933689,0.311691925 103.114243,0.320437267 C102.294003,0.32997764 101.469791,0.341903106 100.640018,0.35303354 C99.8817433,0.363368944 99.1179073,0.37171677 98.3493048,0.378077019 C97.5807023,0.384039752 96.8065388,0.387617391 96.0272116,0.388809938 C95.2482816,0.390002484 94.4661739,0.390797516 93.6812858,0.391592547 C92.8971921,0.392387578 92.1095235,0.393182609 91.3194716,0.393580124 C90.5294197,0.39397764 89.7365873,0.394772671 88.9409745,0.395170186 C88.1453617,0.395567702 87.3477628,0.395965217 86.5481779,0.395965217 C85.7489901,0.395965217 84.9474191,0.395567702 84.1442593,0.395170186 C83.3407023,0.394772671 82.5359536,0.39397764 81.7296161,0.393182609 C80.9224841,0.392387578 80.1133661,0.389604969 79.3022621,0.383642236 C78.4907608,0.377679503 77.6768763,0.368934161 76.8618002,0.358996273 C76.0463268,0.34866087 75.2296618,0.336735404 74.413394,0.324412422 C73.596729,0.312486957 72.780064,0.300163975 71.9645907,0.288636025 C71.1487201,0.27750559 70.3340412,0.267567702 69.5221427,0.259219876 C68.709847,0.251269565 67.8999346,0.245704348 67.0939943,0.243319255 C66.288054,0.240934161 65.4837025,0.240934161 64.6821315,0.240934161 L50.4723196,0.240934161 C49.739466,0.240934161 49.0105845,0.241331677 48.2864696,0.241729193 C47.5623547,0.242126708 46.8434035,0.243319255 46.1284244,0.244511801 C45.4138426,0.246101863 44.7040272,0.247691925 43.998184,0.250077019 C43.292738,0.252064596 42.5916613,0.253654658 41.8953511,0.255642236 C41.1994381,0.258027329 40.5074972,0.260014907 39.8203229,0.262002484 C39.1224239,0.263990062 38.4292914,0.265580124 37.7413226,0.266772671 C37.0541483,0.268362733 36.3717405,0.269952795 35.6952908,0.273530435 C35.0192384,0.277108075 34.3487469,0.281878261 33.6846108,0.286648447 C33.0204746,0.292213665 32.3622967,0.298176398 31.7108713,0.303741615 C31.0590487,0.310101863 30.4139787,0.316462112 29.7760585,0.322027329 C29.1468769,0.327592547 28.5248451,0.332362733 27.9119491,0.335940373 C26.68576,0.343890683 25.4929366,0.347468323 24.3334788,0.345878261 C23.1740211,0.344288199 22.0467374,0.338722981 20.952025,0.329580124 C19.8577098,0.320437267 18.794377,0.308114286 17.7632183,0.294598758 C16.5751614,0.278698137 15.4307977,0.263592547 14.3329076,0.251269565 C13.2350175,0.238549068 12.1847926,0.229803727 11.1889857,0.224238509 C10.1931787,0.219070807 9.25496725,0.217480745 8.37832346,0.217878261 C7.50128245,0.218275776 6.68580909,0.218275776 5.93627269,0.218275776 C5.18673629,0.217878261 4.50313685,0.217480745 3.88944647,0.216685714 C2.9575904,0.215493168 1.98601328,0.279095652 1.06210142,0.1984 C0.451985941,0.145132919 0.187443682,0.192834783 0.0583502371,0.800636025 C-0.0767013668,1.43626335 0.0591446583,2.01902112 0.102043403,2.6482882 C0.149311464,3.34950559 0.0837717155,4.06543106 0.0809912413,4.76744348 C0.0770191353,5.70836273 0.0730470293,6.76933168 0.0690749233,7.92610186 C0.0666916597,8.50448696 0.0651028173,9.10672298 0.0639111855,9.7292323 C0.0627195537,10.3525366 0.0623223431,10.9957168 0.0627195537,11.6563876 C0.0627195537,12.3174559 0.0631167643,12.9964124 0.0631167643,13.690077 L0.0631167643,15.8140025 L0.0631167643,40.698872 C0.0631167643,43.2215056 0.206907001,45.7580522 0.193401841,48.2258286 C0.192210209,48.442077 0.196976736,48.6766112 0.330042287,48.8467478 C0.627155816,49.2275677 1.60627994,49.2283627 2.0618805,49.3448348 C2.4253282,49.4378534 2.76017674,49.4585242 3.1335547,49.4605118 C3.63880658,49.4628969 3.74684787,49.4605118 4.25249696,49.4605118 C4.25249696,49.4605118 5.08822806,49.4605118 6.18214605,49.453754 C6.72910505,49.4501764 7.32770142,49.4362634 7.91795637,49.4167851 C8.50821132,49.3973068 9.09369975,49.3746484 9.61523727,49.3531826 C10.6575179,49.311046 11.4463781,49.2792447 11.4463781,49.2792447 C11.4837159,48.8721888 11.5496529,48.4742758 11.642203,48.0866981 C11.734753,47.698723 11.8531218,47.3186981 11.9945288,46.9450335 C12.1363329,46.5717665 12.3015726,46.2048596 12.4882615,45.8463006 C12.6753477,45.4873441 12.8834861,45.137928 13.1130738,44.7976547 C13.2656027,44.5714683 13.4276646,44.3492571 13.5972735,44.1330087 C13.7676769,43.9163627 13.9464216,43.7056795 14.1327134,43.500164 C14.3194024,43.2954435 14.512844,43.0962882 14.7134353,42.9082634 C14.9140267,42.7202385 15.1217678,42.5433441 15.3362615,42.3755925 C15.5511525,42.2082385 15.7743848,42.0496298 16.0059586,41.900164 C16.2375324,41.7506981 16.4774476,41.6091826 16.7268958,41.4768099 C16.9759469,41.3464248 17.234531,41.2283627 17.5018537,41.1222261 C17.7687792,41.016487 18.0448406,40.9210832 18.328449,40.8344248 C18.6124546,40.7485615 18.9032127,40.6702509 19.1987374,40.6002882 C19.4942621,40.5303255 19.7949505,40.467518 20.0988166,40.4114683 C20.4026827,40.3554186 20.7085349,40.3061267 21.0135926,40.2639901 C21.3190476,40.2218534 21.6245025,40.186077 21.9287659,40.1586484 C22.232632,40.1304248 22.5321288,40.1125366 22.826859,40.1085615 C23.1211921,40.1045863 23.4103614,40.1157168 23.694367,40.1435429 C24.1706225,40.1908472 24.6294007,40.2735304 25.0703045,40.3900025 C25.5112083,40.5064745 25.9397985,40.659518 26.3540891,40.8495304 C26.7679826,41.0403379 27.1695625,41.2673193 27.5520763,41.5241143 C27.9345901,41.7805118 28.298435,42.0655304 28.641625,42.375195 C28.9844177,42.6844621 29.3101304,43.0183752 29.6143938,43.3777292 C29.7665254,43.5570087 29.9130961,43.743841 30.0541059,43.9370335 C30.1951156,44.1302261 30.32977,44.3305739 30.4580691,44.5392696 C30.6828903,44.9065739 30.891823,45.280636 31.0880451,45.6558907 C31.2882392,46.0267727 31.4761198,46.4000398 31.653673,46.7733068 C31.8316233,47.1453814 31.9976574,47.5210335 32.1509806,47.9006609 C32.3003318,48.2779031 32.4306169,48.6571329 32.5450136,49.0323876 C32.5688462,49.1095056 32.5934732,49.1898037 32.6184975,49.2712944 C32.6184975,49.2712944 32.7920785,49.2752696 33.1189829,49.2812323 C33.3533371,49.285605 34.0663302,49.2907727 34.4540077,49.2951453 C34.4726766,48.8682137 34.5386136,48.4341267 34.6422855,47.9928845 C34.7455603,47.5512447 34.8861728,47.1064248 35.0545901,46.6659776 C35.2226102,46.225928 35.4208183,45.7914435 35.6440507,45.3688845 C35.8116735,45.0516671 35.9939932,44.7412075 36.1874348,44.4402882 C36.3808763,44.1385739 36.5850426,43.8460025 36.7975502,43.5621764 C37.0100579,43.2779528 37.2301126,43.0024745 37.455331,42.7377292 C37.6801522,42.4725863 37.9093427,42.2177789 38.138136,41.9713193 C38.4876813,41.5944745 38.858676,41.2414807 39.2475452,40.915518 C39.6372088,40.5891578 40.0467329,40.2997665 40.4733371,40.056487 C40.9003385,39.813605 41.34442,39.6148472 41.8016094,39.4578286 C42.259196,39.3012075 42.7290961,39.1835429 43.2121042,39.1004621 C43.6947151,39.0177789 44.1952004,38.9633193 44.7083965,38.9343006 C45.2215926,38.905282 45.7451162,38.9001143 46.2694342,38.9199901 C46.8183792,38.9374807 47.3589829,39.0054559 47.8789315,39.121928 C48.398483,39.2387975 48.90016,39.4069466 49.3819765,39.6271702 C49.8637929,39.8473938 50.3301182,40.1200894 50.7793633,40.4257789 C51.229403,40.7286857 51.6663346,41.0594186 52.0881723,41.4080398 C52.5096127,41.7562634 52.9171508,42.1227727 53.3044311,42.5004124 C53.6917115,42.8780522 54.0591313,43.2692075 54.3947742,43.667518 C54.6283341,43.9449839 54.843225,44.2315925 55.0370638,44.5277416 C55.231697,44.8238907 55.4032919,45.1295801 55.5546292,45.4420273 C55.705172,45.754077 55.8370459,46.074077 55.9510454,46.3992447 C56.1222431,46.8877913 56.2545143,47.391046 56.3510364,47.903046 C56.448353,48.4154435 56.5083318,48.9361888 56.5337533,49.4605118 L57.5792116,49.4605118 L58.6246699,49.4605118 C58.7164256,48.8678161 58.8351915,48.2830708 59.0008283,47.7138286 C59.1660679,47.1445863 59.3761924,46.5900522 59.6403374,46.0534062 C59.7372568,45.7465242 59.8460925,45.4440149 59.9668445,45.1466733 C60.0875965,44.8489342 60.2198677,44.5567602 60.3644523,44.2701516 C60.509037,43.9835429 60.6651408,43.7028969 60.8347497,43.4317913 C61.0047558,43.1602882 61.1882671,42.9026981 61.3856808,42.6594186 C61.6494286,42.3354435 61.9382007,42.0341267 62.2547776,41.7538783 C62.6027341,41.4442137 62.9594292,41.1611826 63.3240685,40.9008099 C63.689105,40.6412323 64.0616886,40.4059031 64.4422163,40.2027727 C64.8223469,39.9996422 65.2104216,39.8255304 65.605249,39.6764621 C66.0000763,39.5273938 66.4024507,39.4021764 66.8131664,39.301605 C67.2238822,39.2010335 67.6437338,39.1270957 68.070338,39.0793938 C68.4973394,39.0316919 68.9295045,39.0102261 69.3676278,39.0138037 C69.7910543,38.9875677 70.2252055,38.9951205 70.673259,39.0452075 C71.2134654,39.1060273 71.7512886,39.1922882 72.2815647,39.3091578 C72.8110465,39.443518 73.3226537,39.6061019 73.8096339,39.7945242 C74.2966141,39.9829466 74.7629394,40.197605 75.2082124,40.440487 C75.6546772,40.6837665 76.0812813,40.9501019 76.4908055,41.2438658 C76.9007268,41.5376298 77.2947597,41.8580273 77.6693293,42.2138037 C78.0486654,42.5679901 78.4109215,42.964313 78.7560975,43.410723 C78.9570861,43.6703006 79.1628412,43.9477665 79.3674046,44.2415304 C79.5727625,44.5352944 79.7761343,44.8461516 79.971562,45.1725118 C80.1669896,45.4992696 80.3520897,45.842723 80.520507,46.1977043 C80.6885271,46.5526857 80.8402615,46.9148224 80.971341,47.2813317 C81.1028177,47.647841 81.2112562,48.018723 81.2934788,48.391195 C81.3753042,48.7636671 81.4301193,49.1381267 81.4567324,49.5109963 C81.8825421,49.5018534 82.3107352,49.4931081 82.7496529,49.4839652 C83.1730794,49.4756174 83.6056417,49.4688596 84.0477371,49.4648845 C84.4898325,49.4609093 84.9394749,49.4601143 85.3895145,49.4605118 L86.8480719,49.4605118 L105.497904,49.4605118 C106.311788,49.4605118 107.119318,49.4609093 107.920094,49.4609093 C108.721268,49.4613068 109.516484,49.4621019 110.304549,49.4648845 C111.092615,49.4680646 111.873928,49.4724373 112.647695,49.4768099 C113.421858,49.4811826 114.188077,49.4855553 114.946352,49.4891329 C115.705025,49.4935056 116.457739,49.4990708 117.205289,49.5078161 C117.953237,49.516164 118.694432,49.5268969 119.428477,49.5376298 C120.162125,49.5479652 120.888226,49.5590957 121.603999,49.5694311 C122.320567,49.5797665 123.026808,49.5893068 123.721926,49.5976547 C124.417442,49.6064 125.103425,49.6135553 125.779874,49.6199155 C126.455927,49.6262758 127.121652,49.631046 127.77546,49.6346236 C128.430461,49.6385988 129.074339,49.6397913 129.708287,49.6374062 C130.461001,49.6350211 131.198224,49.6294559 131.917175,49.6219031 C132.636524,49.6139528 133.336409,49.6044124 134.017228,49.593282 C134.69765,49.581754 135.357416,49.5698286 135.995734,49.5575056 C136.633654,49.5451826 137.250522,49.5328596 137.843955,49.5221267 C139.030423,49.4994683 140.130299,49.4823752 141.138022,49.4724373 C142.146143,49.4621019 143.066082,49.4601143 143.891089,49.4597168 L146.079719,49.4597168 C146.214771,49.4597168 146.349822,49.4577292 146.484874,49.4549466 C146.620323,49.4517665 146.756169,49.4481888 146.892412,49.4442137 C147.029053,49.4402385 147.166487,49.4358658 147.303922,49.4318907 C147.37264,49.4299031 147.441357,49.428313 147.510869,49.4263255 C147.580381,49.4243379 147.650687,49.4223503 147.720993,49.4195677 C147.7913,49.4171826 147.8624,49.4147975 147.933501,49.4120149 C148.004999,49.4100273 148.076497,49.4076422 148.147598,49.4056547 C148.218698,49.4036671 148.289799,49.402077 148.360105,49.401282 C148.430412,49.4000894 148.499923,49.3996919 148.568641,49.4000894 C148.694954,49.4008845 148.806967,49.4068472 148.885218,49.3746484 C148.963865,49.3428472 149.009942,49.272487 149.00597,49.1230211 C149.003984,49.0665739 149.004778,49.0093317 149.007161,48.9501019 C149.009147,48.8912696 149.011928,48.8308472 149.014708,48.7684373 C149.017489,48.7068224 149.019872,48.6428224 149.020269,48.5776298 C149.020667,48.5124373 149.019872,48.4456547 149.019872,48.3776795 C149.019872,48.3093068 149.021064,48.2401391 149.022255,48.1713689 C149.02305,48.1029963 149.024241,48.0342261 149.025433,47.9662509 C149.026228,47.8982758 149.027816,47.8314932 149.0302,47.7663006 C149.032186,47.7007106 149.034966,47.6367106 149.037747,47.5746981 C149.041322,47.505928 149.044896,47.4363627 149.049266,47.367195 C149.053635,47.2980273 149.056813,47.2292571 149.059196,47.160487 C149.061579,47.0917168 149.063168,47.0225491 149.06436,46.9537789 C149.065551,46.8846112 149.065949,46.8154435 149.066346,46.7462758 C149.066743,46.6083379 149.066346,46.469605 149.065154,46.3316671 C149.064757,46.1941267 149.063565,46.0561888 149.064757,45.9194435 C149.070715,45.1812571 149.072304,44.3436919 149.06714,43.4242385",id:"Fill-34",fill:"#FFD300",mask:"url(#mask-4)",__source:{fileName:_jsxFileName,lineNumber:44}})),_react2.default.createElement("g",{id:"Group-39",transform:"translate(0.000000, 0.136348)",__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement("mask",{id:"mask-6",fill:"white",__source:{fileName:_jsxFileName,lineNumber:47}},_react2.default.createElement("use",{xlinkHref:"#path-5",__source:{fileName:_jsxFileName,lineNumber:48}})),_react2.default.createElement("g",{id:"Clip-38",__source:{fileName:_jsxFileName,lineNumber:50}}),_react2.default.createElement("path",{d:"M0.206231743,3.59385839 C0.365513194,3.35773416 0.624097294,3.33984596 1.06182338,3.37840497 C1.98573523,3.45910062 2.95770957,3.39549814 3.88916842,3.39669068 C4.5028588,3.39748571 5.18685545,3.39788323 5.93639185,3.39828075 C6.68553105,3.39828075 7.50100441,3.39828075 8.37804541,3.39788323 C9.25468921,3.39748571 10.1932979,3.39907578 11.1887076,3.40424348 C12.1845146,3.4098087 13.2351366,3.41895155 14.3326295,3.43127453 C15.4305196,3.44359752 16.5752806,3.45870311 17.7629403,3.47460373 C18.7944962,3.48811925 19.857829,3.50083975 20.9521442,3.50958509 C22.0464594,3.51912547 23.173743,3.52429317 24.3332008,3.52588323 C25.4926585,3.52747329 26.6858792,3.52389565 27.9120683,3.51634286 C28.5249642,3.5123677 29.1465988,3.50759752 29.7757804,3.50242981 C30.4140979,3.49646708 31.0591679,3.49010683 31.7105932,3.4841441 C32.3624158,3.47818137 33.0201966,3.47221863 33.6843327,3.46705093 C34.3488661,3.46188323 35.0193575,3.45711304 35.69541,3.4535354 C36.3718596,3.45035528 37.0542674,3.4483677 37.7414418,3.44677764 C38.4294105,3.44558509 39.122543,3.44399503 39.8200449,3.44200745 C40.5076164,3.44001988 41.1991601,3.4380323 41.8954702,3.43604472 C42.5917804,3.43405714 43.2928571,3.43206957 43.9983032,3.43008199 C44.7037492,3.42769689 45.4139617,3.42610683 46.1281464,3.42451677 C46.8431255,3.42332422 47.5624739,3.42213168 48.2865888,3.42173416 C49.0103065,3.42133665 49.7391879,3.42093913 50.4724387,3.42093913 L64.6818535,3.42093913 C65.4838217,3.42093913 66.287776,3.42093913 67.0941135,3.42332422 C67.9000538,3.42570932 68.7099662,3.43127453 69.5222619,3.43922484 C70.3341603,3.44757267 71.1488393,3.45751056 71.9643126,3.46903851 C72.7801832,3.48016894 73.5968482,3.49249193 74.413116,3.50441739 C75.229781,3.51713789 76.046446,3.52866584 76.8615221,3.53900124 C77.6769955,3.54933665 78.49088,3.55768447 79.3023813,3.5636472 C80.1134853,3.56960994 80.9226033,3.57239255 81.729338,3.57318758 C82.5360727,3.57398261 83.3408214,3.57477764 84.1439813,3.57517516 C84.9475383,3.57557267 85.7487121,3.57597019 86.548297,3.57597019 C87.347882,3.57597019 88.1454808,3.57557267 88.9410937,3.57517516 C89.7363093,3.57477764 90.5295389,3.57398261 91.3195907,3.57358509 C92.1096426,3.57318758 92.896914,3.57239255 93.681405,3.57159752 C94.4662931,3.57080248 95.2480036,3.57000745 96.0269336,3.56921242 C96.8062608,3.56801988 97.5808214,3.56404472 98.3494239,3.55808199 C99.1180264,3.55211925 99.8814652,3.54337391 100.640137,3.53343602 C101.46991,3.52190807 102.294122,3.50998261 103.113965,3.50083975 C103.933808,3.49169689 104.749678,3.48613168 105.561577,3.48374658 C106.373475,3.48175901 107.180607,3.48295155 107.98337,3.48692671 C108.785735,3.49169689 109.583334,3.49924969 110.375372,3.50879006 C111.167807,3.51912547 111.952695,3.52906335 112.729639,3.53621863 C113.605091,3.54536149 114.472202,3.55251677 115.328985,3.55927453 C116.186166,3.5660323 117.033019,3.5712 117.867558,3.57438012 C118.702098,3.57756025 119.524721,3.5787528 120.333839,3.57795776 C121.143354,3.57676522 121.939761,3.57358509 122.722664,3.56841739 C123.50636,3.56245466 124.27536,3.55609441 125.029663,3.54973416 C125.783966,3.5429764 126.524366,3.53582112 127.252056,3.52628075 C127.979746,3.51713789 128.695519,3.50560994 129.398979,3.49368447 C130.102439,3.48175901 130.792791,3.46943602 131.469241,3.45711304 C132.145691,3.44518758 132.807841,3.4328646 133.454102,3.41855404 C134.260043,3.40344845 135.040561,3.38913789 135.79407,3.37601988 C136.546784,3.36290186 137.272091,3.35177143 137.969195,3.34143602 C138.6663,3.33189565 139.335202,3.32354783 139.97352,3.31798261 C140.612235,3.31241739 141.220761,3.30883975 141.797511,3.30804472 C142.950613,3.30724969 143.977006,3.31122484 144.867154,3.31679006 C146.19781,3.32831801 147.228969,3.33944845 147.927265,3.34779627 C148.204915,3.35137391 148.481374,3.31679006 148.759421,3.33706335 C148.792787,3.33944845 148.82655,3.34421863 148.858724,3.35296398 C148.891295,3.34421863 148.923866,3.33706335 148.955246,3.32394534 C148.986228,3.31162236 149.017608,3.29572174 149.03588,3.26829317 C149.054946,3.2408646 149.059315,3.20628075 149.062493,3.17328696 C149.117308,2.6342559 149.13836,2.0916472 149.125649,1.54903851 C149.119691,1.28548571 149.089106,1.01954783 149.094667,0.756790062 C149.095461,0.702330435 149.106186,0.624814907 149.102214,0.553659627 C149.096653,0.457063354 149.064082,0.371597516 148.944918,0.366032298 C148.616425,0.351324224 148.279194,0.335423602 147.926471,0.319522981 C147.572953,0.304019876 147.199972,0.288119255 146.812692,0.275001242 C146.412304,0.266255901 146.001191,0.261485714 145.580545,0.261088199 C145.159899,0.260690683 144.737664,0.263473292 144.322976,0.269038509 C143.908685,0.274206211 143.504325,0.278976398 143.10632,0.282554037 C142.709109,0.286529193 142.312693,0.289311801 141.915085,0.292491925 C141.51708,0.296069565 141.116692,0.299249689 140.712729,0.302032298 C140.309163,0.304417391 139.901625,0.305212422 139.48932,0.306802484 C139.077413,0.309187578 138.662725,0.313560248 138.248037,0.319522981 C137.833349,0.325485714 137.419456,0.332243478 137.007151,0.339796273 C136.594449,0.347349068 136.184131,0.354504348 135.774607,0.358479503 C135.365083,0.363249689 134.956353,0.364442236 134.548815,0.363647205 C134.247332,0.363249689 133.946643,0.360069565 133.646749,0.355696894 C133.346458,0.350926708 133.047359,0.34456646 132.747862,0.33741118 L131.849371,0.315150311 C131.549477,0.307597516 131.249186,0.301634783 130.948895,0.296069565 C130.649795,0.29209441 130.350696,0.289311801 130.052391,0.288914286 C129.753688,0.287721739 129.454986,0.288914286 129.156284,0.29209441 C128.857978,0.29567205 128.559276,0.303224845 128.260574,0.312765217 C127.961871,0.323100621 127.663566,0.335026087 127.366055,0.347349068 C126.759912,0.375175155 126.156152,0.395845963 125.554775,0.409361491 C124.953398,0.422877019 124.35361,0.42804472 123.756206,0.427647205 C123.158801,0.427249689 122.562985,0.420889441 121.968361,0.410156522 C121.374134,0.399821118 120.781495,0.385510559 120.189652,0.370007453 C119.396025,0.348541615 118.605178,0.330255901 117.819099,0.317535404 C117.032622,0.304417391 116.251706,0.299647205 115.472776,0.303224845 C114.693846,0.306802484 113.914916,0.317932919 113.133602,0.330255901 C112.352289,0.342976398 111.566209,0.355696894 110.773774,0.36404472 C109.717194,0.375175155 108.653067,0.38272795 107.58457,0.388690683 C106.764728,0.350529193 105.94131,0.321113043 105.114715,0.299647205 C104.28812,0.281759006 103.457155,0.276591304 102.623013,0.285336646 C101.788473,0.293286957 100.950359,0.309982609 100.110259,0.327473292 C99.2697609,0.344963975 98.4280716,0.360467081 97.5843963,0.365634783 C96.3307997,0.373187578 95.0613146,0.349734161 93.7886518,0.324293168 C92.5163863,0.299249689 91.2457096,0.274206211 89.9905241,0.293286957 C88.7619517,0.31077764 87.544104,0.362852174 86.3266535,0.395050932 C85.1096002,0.427249689 83.894533,0.45388323 82.6746992,0.424467081 C81.8437347,0.405386335 81.0151534,0.388690683 80.1869693,0.375175155 C79.3587852,0.362454658 78.5309983,0.35609441 77.702417,0.358081988 C76.8742329,0.360069565 76.0444599,0.368417391 75.2134953,0.381137888 C73.9670485,0.407373913 72.7206016,0.427249689 71.4733603,0.439970186 C70.2265163,0.453485714 68.9796722,0.459448447 67.7324309,0.461038509 C65.1648616,0.464218634 62.5980867,0.494827329 60.031709,0.537361491 C59.5181157,0.544914286 59.0045224,0.553262112 58.4901347,0.558827329 C57.9761442,0.564790062 57.4617564,0.565585093 56.9465743,0.562802484 C56.4317893,0.560019876 55.91621,0.554852174 55.4006306,0.549286957 C54.8850513,0.543324224 54.3698691,0.538951553 53.8550842,0.538156522 C53.3414909,0.536963975 52.8298836,0.534578882 52.3234401,0.532193789 C51.8165994,0.52941118 51.3129363,0.528218634 50.8112594,0.52941118 C50.3095824,0.530206211 49.8086998,0.534578882 49.3070228,0.542131677 C48.805743,0.549684472 48.3024772,0.560019876 47.7972253,0.569560248 C47.291179,0.579100621 46.7835439,0.584268323 46.2739227,0.582280745 C45.7643015,0.579895652 45.2526942,0.572342857 44.7398953,0.565982609 C44.2266992,0.55962236 43.7123115,0.555647205 43.1967322,0.554852174 C42.68155,0.554454658 42.1643818,0.558429814 41.6456248,0.565585093 C41.1272649,0.572740373 40.6077135,0.579100621 40.0849843,0.581485714 C39.5626524,0.583473292 39.0359511,0.585063354 38.5064694,0.587050932 C37.9769877,0.588243478 37.4459171,0.590231056 36.9172298,0.589436025 C36.4814898,0.588640994 36.0521051,0.58546087 35.6286786,0.578703106 C35.2048549,0.572342857 34.7869893,0.5632 34.3730959,0.553659627 C33.9615857,0.544914286 33.552856,0.538554037 33.1453179,0.536963975 C32.6865397,0.534578882 32.2281587,0.536168944 31.7677916,0.540144099 C31.3074245,0.544914286 30.8438797,0.551274534 30.3743768,0.558827329 C29.9056683,0.56677764 29.4302072,0.573535404 28.9499796,0.577908075 C28.4693548,0.582678261 27.9847578,0.583473292 27.4957916,0.581485714 C27.0072225,0.579498137 26.5166674,0.576715528 26.0280984,0.573535404 C25.661473,0.571150311 25.2960393,0.568367702 24.9321944,0.564790062 C24.5687467,0.561212422 24.2068878,0.556839752 23.8478094,0.55167205 C23.4883338,0.546504348 23.1308443,0.540541615 22.7729575,0.535373913 C22.4158652,0.52941118 22.0591701,0.523448447 21.7016806,0.518678261 C21.3501492,0.513113043 20.9986178,0.508740373 20.6470864,0.505560248 C20.2951578,0.502380124 19.9432292,0.499995031 19.5920951,0.498404969 C19.2401665,0.496417391 18.8890323,0.492839752 18.5386926,0.488069565 C18.1883528,0.482901863 17.8392047,0.476144099 17.4900566,0.468591304 C17.1409085,0.460640994 16.7921575,0.452690683 16.4434066,0.444342857 C16.0950529,0.435995031 15.746302,0.42804472 15.3971539,0.421286957 C14.9780967,0.412541615 14.5586423,0.405386335 14.1383935,0.400218634 C13.7185419,0.394653416 13.2971015,0.390280745 12.8752638,0.388690683 C12.453029,0.387100621 12.0299997,0.387895652 11.6053815,0.390280745 C11.1815578,0.393063354 10.7565425,0.39783354 10.3311299,0.404193789 C9.90611459,0.410156522 9.48070204,0.416914286 9.05489227,0.422877019 C8.62947972,0.429237267 8.20446438,0.4352 7.78024346,0.43877764 C7.35602254,0.441957764 6.93339046,0.442752795 6.51115559,0.439572671 C6.10401473,0.436392547 5.69568223,0.42009441 5.28695252,0.399026087 C4.87822282,0.37835528 4.46472658,0.354901863 4.04964151,0.335821118 C3.64051459,0.315945342 3.23893467,0.297262112 2.85324318,0.284541615 C2.46755169,0.272218634 2.09774862,0.266255901 1.74224513,0.276193789 C1.49557735,0.283349068 1.18813635,0.272218634 0.908897294,0.313957764 C0.629261032,0.355696894 0.378223933,0.45030559 0.239597434,0.670131677 C0.0846852999,0.916193789 0.0779327197,1.48861615 0.108120725,2.08091429 C0.13791152,2.67162236 0.206628954,3.27902609 0.206231743,3.59385839",id:"Fill-37",fill:"#C5168C",mask:"url(#mask-6)",__source:{fileName:_jsxFileName,lineNumber:51}})),_react2.default.createElement("path",{d:"M49.099242,57.2088845 C48.9292358,57.4306981 48.7417524,57.6246857 48.539175,57.7912447 C48.3362004,57.9574062 48.1189262,58.0985242 47.8945022,58.2185739 C47.669681,58.3386236 47.43771,58.4407851 47.2021641,58.5282385 C46.966221,58.616487 46.7255114,58.6924124 46.479638,58.7516422 C46.2361479,58.821605 45.9823304,58.8685118 45.7185825,58.8963379 C45.3225636,58.938077 44.902712,58.925754 44.4741217,58.8422758 C44.0344096,58.7635677 43.5927114,58.616487 43.1621351,58.4022261 C42.7315588,58.1879652 42.3422924,57.9200398 42.0026774,57.6095801 C41.6622679,57.299518 41.3734958,56.9425491 41.1435109,56.5517913 C40.9905848,56.2906236 40.8662579,56.0139528 40.7709273,55.724164 C40.675994,55.4335801 40.6072765,55.1270957 40.5671583,54.8102758 C40.5262456,54.4930584 40.5139321,54.1682882 40.5322037,53.8391453 C40.5500782,53.5100025 40.6017156,53.177282 40.6902936,52.8485366 C40.7788715,52.5197913 40.9043901,52.1985988 41.0668492,51.8913193 C41.2297056,51.5840398 41.4223527,51.3029963 41.6443934,51.0430211 C41.8668314,50.7834435 42.1178685,50.5457292 42.3895605,50.336636 C42.662047,50.1271453 42.9547912,49.9478658 43.2622322,49.8023752 C43.5696732,49.656487 43.8933998,49.5427975 44.2310288,49.4617043 C44.5694523,49.3802137 44.9189976,49.3301267 45.2689401,49.312636 C45.6196771,49.2947478 45.9668392,49.3114435 46.3064542,49.3694807 C46.6448777,49.4279155 46.9745625,49.5296795 47.2891532,49.6704 C47.603744,49.8111205 47.9008576,49.9900025 48.1753301,50.2066484 C48.4470221,50.4228969 48.6853485,50.6709466 48.889912,50.9424497 C49.1266495,51.2576795 49.3204883,51.5979528 49.4706339,51.9521391 C49.6203823,52.306723 49.7288208,52.6748224 49.7999215,53.0528596 C49.8686389,53.4241391 49.9008129,53.8129093 49.9016074,54.2044621 C49.9020046,54.4982261 49.8908827,54.7888099 49.8658584,55.0678658 C49.8400397,55.3465242 49.797141,55.6140522 49.7339845,55.8672696 C49.6712252,56.1200894 49.587811,56.3593938 49.482153,56.5827975 C49.3760977,56.8062012 49.2481959,57.0152944 49.099242,57.2088845",id:"Fill-40",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:53}}),_react2.default.createElement("path",{d:"M71.3717141,58.7756522 C69.606113,59.1306335 67.4699144,58.425441 66.2909934,57.2841739 C64.7879485,55.828472 64.9194252,53.010087 65.962103,51.320646 C66.0550503,51.1699876 66.1567362,51.0264845 66.2659691,50.8901366 C66.3759964,50.7537888 66.4943652,50.6245963 66.6206782,50.502559 C66.7672489,50.3610435 66.9237498,50.2290683 67.0885922,50.1074286 C67.2538319,49.9857888 67.4270157,49.874087 67.6085409,49.7735155 C67.789669,49.6725466 67.9759607,49.5823106 68.1658274,49.5036025 C68.3552968,49.4248944 68.5487384,49.3569193 68.7433716,49.3000745 C69.1258854,49.1887702 69.5159462,49.1223851 69.9004461,49.1017143 C70.1884238,49.0862112 70.4700461,49.0961491 70.7397521,49.132323 C71.0094581,49.1688944 71.267645,49.2309068 71.5123267,49.3171677 C71.7570084,49.4034286 71.9893766,49.5127453 72.2090341,49.6463106 C72.4290888,49.7802733 72.6380215,49.938087 72.837024,50.1181615 C73.0650229,50.3240745 73.270778,50.5486708 73.4538921,50.7879752 C73.6370062,51.027677 73.7982737,51.2816894 73.9388862,51.5436522 C74.0791016,51.8056149 74.2002508,52.0751304 74.3035256,52.3482236 C74.4068003,52.6217143 74.492995,52.8995776 74.5593292,53.1798261 C74.6300327,53.4600745 74.6753147,53.7454907 74.694778,54.034087 C74.7237744,54.4673789 74.6868338,54.9098137 74.5779981,55.3478758 C74.4707512,55.7930932 74.2987591,56.2331429 74.0640076,56.6576894 C73.9464332,56.8699627 73.817737,57.0719006 73.6787133,57.261913 C73.5392924,57.452323 73.3899412,57.631205 73.2318514,57.7969689 C72.7281883,58.3200994 72.0799406,58.6333416 71.3717141,58.7756522",id:"Fill-42",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:54}}),_react2.default.createElement("path",{d:"M49.099242,57.2088845 C48.9292358,57.4306981 48.7417524,57.6246857 48.539175,57.7912447 C48.3362004,57.9574062 48.1189262,58.0985242 47.8945022,58.2185739 C47.669681,58.3386236 47.43771,58.4407851 47.2021641,58.5282385 C46.966221,58.616487 46.7255114,58.6924124 46.479638,58.7516422 C46.2361479,58.821605 45.9823304,58.8685118 45.7185825,58.8963379 C45.3225636,58.938077 44.902712,58.925754 44.4741217,58.8422758 C44.0344096,58.7635677 43.5927114,58.616487 43.1621351,58.4022261 C42.7315588,58.1879652 42.3422924,57.9200398 42.0026774,57.6095801 C41.6622679,57.299518 41.3734958,56.9425491 41.1435109,56.5517913 C40.9905848,56.2906236 40.8662579,56.0139528 40.7709273,55.724164 C40.675994,55.4335801 40.6072765,55.1270957 40.5671583,54.8102758 C40.5262456,54.4930584 40.5139321,54.1682882 40.5322037,53.8391453 C40.5500782,53.5100025 40.6017156,53.177282 40.6902936,52.8485366 C40.7788715,52.5197913 40.9043901,52.1985988 41.0668492,51.8913193 C41.2297056,51.5840398 41.4223527,51.3029963 41.6443934,51.0430211 C41.8668314,50.7834435 42.1178685,50.5457292 42.3895605,50.336636 C42.662047,50.1271453 42.9547912,49.9478658 43.2622322,49.8023752 C43.5696732,49.656487 43.8933998,49.5427975 44.2310288,49.4617043 C44.5694523,49.3802137 44.9189976,49.3301267 45.2689401,49.312636 C45.6196771,49.2947478 45.9668392,49.3114435 46.3064542,49.3694807 C46.6448777,49.4279155 46.9745625,49.5296795 47.2891532,49.6704 C47.603744,49.8111205 47.9008576,49.9900025 48.1753301,50.2066484 C48.4470221,50.4228969 48.6853485,50.6709466 48.889912,50.9424497 C49.1266495,51.2576795 49.3204883,51.5979528 49.4706339,51.9521391 C49.6203823,52.306723 49.7288208,52.6748224 49.7999215,53.0528596 C49.8686389,53.4241391 49.9008129,53.8129093 49.9016074,54.2044621 C49.9020046,54.4982261 49.8908827,54.7888099 49.8658584,55.0678658 C49.8400397,55.3465242 49.797141,55.6140522 49.7339845,55.8672696 C49.6712252,56.1200894 49.587811,56.3593938 49.482153,56.5827975 C49.3760977,56.8062012 49.2481959,57.0152944 49.099242,57.2088845",id:"Fill-44",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:55}}),_react2.default.createElement("path",{d:"M71.3717141,58.7756522 C69.606113,59.1306335 67.4699144,58.425441 66.2909934,57.2841739 C64.7879485,55.828472 64.9194252,53.010087 65.962103,51.320646 C66.0550503,51.1699876 66.1567362,51.0264845 66.2659691,50.8901366 C66.3759964,50.7537888 66.4943652,50.6245963 66.6206782,50.502559 C66.7672489,50.3610435 66.9237498,50.2290683 67.0885922,50.1074286 C67.2538319,49.9857888 67.4270157,49.874087 67.6085409,49.7735155 C67.789669,49.6725466 67.9759607,49.5823106 68.1658274,49.5036025 C68.3552968,49.4248944 68.5487384,49.3569193 68.7433716,49.3000745 C69.1258854,49.1887702 69.5159462,49.1223851 69.9004461,49.1017143 C70.1884238,49.0862112 70.4700461,49.0961491 70.7397521,49.132323 C71.0094581,49.1688944 71.267645,49.2309068 71.5123267,49.3171677 C71.7570084,49.4034286 71.9893766,49.5127453 72.2090341,49.6463106 C72.4290888,49.7802733 72.6380215,49.938087 72.837024,50.1181615 C73.0650229,50.3240745 73.270778,50.5486708 73.4538921,50.7879752 C73.6370062,51.027677 73.7982737,51.2816894 73.9388862,51.5436522 C74.0791016,51.8056149 74.2002508,52.0751304 74.3035256,52.3482236 C74.4068003,52.6217143 74.492995,52.8995776 74.5593292,53.1798261 C74.6300327,53.4600745 74.6753147,53.7454907 74.694778,54.034087 C74.7237744,54.4673789 74.6868338,54.9098137 74.5779981,55.3478758 C74.4707512,55.7930932 74.2987591,56.2331429 74.0640076,56.6576894 C73.9464332,56.8699627 73.817737,57.0719006 73.6787133,57.261913 C73.5392924,57.452323 73.3899412,57.631205 73.2318514,57.7969689 C72.7281883,58.3200994 72.0799406,58.6333416 71.3717141,58.7756522",id:"Fill-46",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:56}}),_react2.default.createElement("path",{d:"M21.5889125,59.469754 C21.3064957,59.4141019 21.0328176,59.3318161 20.769467,59.2240894 C20.5061164,59.1163627 20.2534904,58.9847851 20.0127808,58.8357168 C19.7728656,58.6866484 19.5440723,58.521282 19.3271953,58.343195 C19.1103183,58.1655056 18.9037688,57.9746981 18.7127105,57.7711702 C18.5176801,57.5708224 18.3397298,57.3521888 18.1828316,57.1168596 C17.9460941,56.7638658 17.7609939,56.3687354 17.6394475,55.9394186 C17.5107512,55.5049342 17.4408422,55.0422261 17.4317063,54.5592447 C17.4225705,54.0770584 17.4738107,53.6075925 17.5790715,53.1627727 C17.6851267,52.7175553 17.8495719,52.2973814 18.0684349,51.9141764 C18.2142112,51.6585739 18.3850118,51.4192696 18.5788505,51.1994435 C18.7730865,50.9796174 18.992744,50.776487 19.2330564,50.5940273 C19.4741632,50.4119652 19.7355278,50.2513689 20.0167529,50.1162137 C20.2975808,49.9810584 20.6002553,49.8721391 20.9196126,49.7942261 C21.2397644,49.7167106 21.5754073,49.6709963 21.9241582,49.6610584 C22.2729091,49.651518 22.6184823,49.6789466 22.9565086,49.740959 C23.294932,49.8033689 23.6230279,49.8991702 23.9336466,50.0267727 C24.2450597,50.1539776 24.5389956,50.3141764 24.8098932,50.5022012 C25.0811881,50.6906236 25.3286503,50.906077 25.5487049,51.1437913 C25.7683624,51.3811081 25.9614068,51.6394932 26.1242631,51.9129839 C26.2871194,52.186872 26.422171,52.4742758 26.5226653,52.7783752 C26.6243512,53.082872 26.6922743,53.4064497 26.7272288,53.7447354 C26.7617861,54.0822261 26.7641694,54.4320398 26.7319953,54.7890087 C26.7010129,55.1459776 26.629515,55.4965863 26.5218709,55.8396422 C26.3967496,56.2375553 26.2271406,56.6215553 26.0193995,56.9824994 C25.8124528,57.3434435 25.5713459,57.6785491 25.3048176,57.9822509 C25.0438503,58.2795925 24.756667,58.5439404 24.4531981,58.7673441 C24.2259936,58.9346981 23.9924338,59.0778037 23.7560935,59.1910957 C23.5201504,59.3047851 23.281824,59.3902509 23.0423061,59.4470957 C22.8035825,59.5047354 22.5628729,59.5353441 22.321766,59.5385242 C22.0798648,59.5413068 21.8359775,59.5178534 21.5889125,59.469754",id:"Fill-48",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:57}}),_react2.default.createElement("path",{d:"M171.251551,51.9301565 C171.400108,52.1631006 171.517285,52.403995 171.604274,52.6504547 C171.691263,52.8969143 171.75005,53.1481441 171.786593,53.3985789 C171.82274,53.6490137 171.840217,53.899846 171.8426,54.1478957 C171.844983,54.3963429 171.834259,54.643995 171.805262,54.8884671 C171.787388,55.1345292 171.744092,55.3805913 171.678949,55.6266534 C171.581633,55.9963429 171.424735,56.3632497 171.197133,56.7074981 C170.971517,57.0616845 170.681951,57.3876472 170.336775,57.6750509 C169.991599,57.9624547 169.61544,58.1914236 169.219421,58.3623553 C168.8238,58.533287 168.406331,58.6437963 167.981316,58.6871255 C167.698502,58.7209143 167.412908,58.7236969 167.128108,58.6978584 C166.843308,58.6724174 166.556522,58.6203429 166.273708,58.5448149 C165.990496,58.4688894 165.713243,58.3707031 165.445126,58.2490634 C165.177406,58.1266286 164.920411,57.9779578 164.680893,57.8018584 C164.441772,57.6253615 164.223704,57.4226286 164.030262,57.1944547 C163.837218,56.9666783 163.676745,56.7230012 163.54209,56.4622311 C163.407039,56.2018584 163.297806,55.9259826 163.214392,55.6413615 C163.130977,55.3559453 163.075368,55.0625789 163.047166,54.7652373 C163.018964,54.4678957 163.017772,54.1630012 163.042399,53.8493615 C163.066629,53.5357217 163.1135,53.2145292 163.183409,52.8941317 C163.252921,52.5733366 163.348251,52.2569143 163.478537,51.954405 C163.608822,51.6514981 163.777636,51.3672745 163.979022,51.1084919 C164.180805,50.8497093 164.415556,50.6203429 164.682482,50.4271503 C164.947421,50.2351503 165.235399,50.0892621 165.537676,49.9863056 C165.889208,49.8674484 166.251067,49.8014609 166.614117,49.7851627 C166.977168,49.7684671 167.340615,49.7974857 167.702077,49.8662559 C168.056786,49.9338335 168.416262,50.0419578 168.770176,50.1783056 C169.035513,50.2804671 169.294891,50.3897839 169.540368,50.5070509 C169.786241,50.6239205 170.015829,50.752318 170.226747,50.8950261 C170.437666,51.0365416 170.630313,51.1927652 170.800717,51.3648894 C170.971517,51.5374112 171.121663,51.7262311 171.251551,51.9301565",id:"Fill-50",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:58}}),_react2.default.createElement("path",{d:"M157.706471,28.0978286 C157.663175,28.0592696 157.609551,28.0286609 157.545998,28.0044124 C157.482047,27.9793689 157.406974,27.9610832 157.319985,27.9475677 C157.276292,27.9408099 157.228626,27.9352447 157.176592,27.930077 C157.124557,27.9249093 157.068948,27.9209342 157.007777,27.9173565 C156.946607,27.9141764 156.880273,27.9113938 156.809172,27.9090087 C156.738071,27.9074186 156.662601,27.9058286 156.585542,27.904636 C156.508086,27.903841 156.432219,27.9034435 156.35953,27.9034435 C156.28684,27.9034435 156.21852,27.9042385 156.156158,27.9054311 C156.093001,27.9070211 156.0362,27.9082137 155.984166,27.9105988 C155.932528,27.9129839 155.88526,27.9157665 155.843156,27.9189466 C155.758947,27.9245118 155.687449,27.9324621 155.627073,27.9404124 C155.566697,27.9491578 155.516649,27.9583006 155.474942,27.9682385 C155.457464,27.9726112 155.443959,27.980959 155.432043,27.9920894 C155.381994,28.0099776 155.33711,28.0513193 155.296594,28.1443379 C155.279911,28.1908472 155.282294,28.2496795 155.296991,28.2997665 C155.311291,28.3498534 155.33711,28.391195 155.364517,28.404313 C155.412977,28.4269714 155.467395,28.4440646 155.529359,28.4563876 C155.590927,28.4691081 155.660439,28.4766609 155.737498,28.4822261 C155.784369,28.4842137 155.83402,28.4854062 155.888041,28.4865988 C155.941664,28.4873938 156.000451,28.4881888 156.064799,28.4889839 C156.129545,28.4897789 156.201043,28.4905739 156.278101,28.4917665 C156.355557,28.4925615 156.437383,28.493754 156.522783,28.4949466 C156.594281,28.4957416 156.666971,28.4965366 156.737277,28.4969342 C156.807583,28.4973317 156.875109,28.4973317 156.938265,28.4965366 C157.001819,28.4953441 157.060606,28.493754 157.115024,28.4909714 C157.169442,28.4877913 157.220285,28.4842137 157.267156,28.4786484 C157.360898,28.468313 157.44312,28.4524124 157.514221,28.4285615 C157.584924,28.4051081 157.646095,28.3741019 157.697335,28.3339528 C157.765258,28.2790957 157.780749,28.1630211 157.706471,28.0978286",id:"Fill-52",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:59}}),_react2.default.createElement("path",{d:"M1.94287621,50.1750857 C1.94764273,50.2959304 1.93453478,50.4318807 1.92937105,50.5642534 C1.9238101,50.6974211 1.92698778,50.8282037 1.96313395,50.937123 C2.00285501,51.0579677 2.07633897,51.1148124 2.1637253,51.143036 C2.25031721,51.1704646 2.3512087,51.1696696 2.44614204,51.1732472 C2.55140285,51.1760298 2.65666365,51.1776199 2.76232167,51.1792099 C2.86797969,51.1808 2.97403492,51.1823901 3.08048736,51.1851727 C3.18733702,51.1879553 3.29458388,51.192328 3.40262516,51.1978932 C3.51066644,51.2042534 3.61950215,51.2114087 3.72833785,51.2189615 C3.86934762,51.2285019 4.00837132,51.2344646 4.14183409,51.2344646 C4.27529685,51.2344646 4.4008154,51.2265143 4.520773,51.2145888 C4.6296087,51.2042534 4.73169183,51.2074335 4.83139169,51.2078311 C4.93148876,51.2078311 5.02959978,51.2050484 5.12890243,51.1819925 C5.19404497,51.1672845 5.26752893,51.1354832 5.29930577,51.0372969 C5.31439978,50.9907876 5.31718025,50.9367255 5.31876909,50.8850484 C5.32591888,50.6278559 5.29851135,50.3770236 5.31003046,50.1242037 C5.31797467,49.9465143 5.32512446,49.7716075 5.32909657,49.6014708 C5.33346589,49.4305391 5.33505473,49.2631851 5.33426031,49.0974211 C5.33346589,48.9320547 5.32989099,48.7674832 5.32631609,48.6029118 C5.32115236,48.4379429 5.31678304,48.2733714 5.31439978,48.1091975 C5.31082488,47.8372969 5.30844162,47.5669863 5.30724999,47.2942907 C5.30605835,47.0211975 5.30566114,46.7413466 5.30367509,46.4531478 C5.30288067,46.3358807 5.30129183,46.2110609 5.26832335,46.1073093 C5.1916617,45.8688 4.95214371,45.9419429 4.81192837,45.9395578 C4.70229824,45.9375702 4.5882988,45.9347876 4.46754678,45.9375702 C4.31620954,45.9407503 4.15931135,45.9387627 3.99446895,45.9355826 C3.82883213,45.9328 3.65564831,45.9276323 3.47809517,45.9236571 C3.30054204,45.9220671 3.12418053,45.9172969 2.94861344,45.9117317 C2.77384078,45.906564 2.59906812,45.8990112 2.42429545,45.8930484 C2.27693032,45.8878807 2.10891024,45.8898683 2.02311275,46.0234335 C1.96432558,46.1152596 1.96194232,46.2456447 1.96114789,46.3664894 C1.95995626,46.5704149 1.94883437,46.7679801 1.93731526,46.9675329 C1.92659057,47.1666882 1.91546868,47.3682286 1.91546868,47.5781168 C1.91229099,47.7180422 1.91070215,47.8611478 1.91030494,48.0058435 C1.90990773,48.1509366 1.90990773,48.2976199 1.90951052,48.4423155 C1.90871609,48.5866137 1.90752446,48.7273342 1.90434678,48.8601043 C1.90077188,49.0119553 1.9015663,49.1610236 1.90474399,49.3081043 C1.90831888,49.4547876 1.91467425,49.6006758 1.92142683,49.7453714 C1.92897384,49.8900671 1.93691805,50.0339677 1.94287621,50.1750857",id:"Fill-54",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:60}}),_react2.default.createElement("path",{d:"M155.143191,54.3571478 C155.143191,54.3571478 156.505624,54.4501665 157.15546,54.4191602 L157.805694,54.388154 L181.396826,54.4501665 C181.396826,54.4501665 178.053504,44.9074087 175.205107,43.4199056 C172.35671,41.9328 163.626021,41.5615205 163.626021,41.5615205 C163.626021,41.5615205 155.793425,47.4169242 155.452618,48.2222907 C155.112209,49.0280547 155.143191,54.3571478 155.143191,54.3571478",id:"Fill-56",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:61}}),_react2.default.createElement("g",{id:"Group-60",transform:"translate(185.497350, 31.540075)",__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement("mask",{id:"mask-8",fill:"white",__source:{fileName:_jsxFileName,lineNumber:63}},_react2.default.createElement("use",{xlinkHref:"#path-7",__source:{fileName:_jsxFileName,lineNumber:64}})),_react2.default.createElement("g",{id:"Clip-59",__source:{fileName:_jsxFileName,lineNumber:66}}),_react2.default.createElement("path",{d:"M3.96694226,1.74020373 C3.95860084,1.46949565 3.93516541,1.20673789 3.87677545,0.980551553 C3.8183855,0.753967702 3.72067169,0.564352795 3.56536234,0.438737888 C3.30638103,0.228452174 2.99536513,0.215731677 2.67362455,0.236402484 C2.35228117,0.256675776 2.02061032,0.309545342 1.71793584,0.231234783 C1.61346946,0.204601242 1.5364106,0.258265839 1.49867559,0.332601242 C0.969988285,0.0571229814 0.50326583,0.443508075 0.374172385,1.05250186 C0.204563459,1.84991801 0.260967364,2.80157019 0.361461646,3.69995528 C0.386485914,3.92455155 0.414687866,4.1459677 0.442095397,4.36062609 C0.469502929,4.57528447 0.497307671,4.78318509 0.521934728,4.98154534 C0.549342259,5.20017888 0.574763738,5.41920994 0.599788006,5.63824099 C0.625209484,5.85687453 0.649836541,6.07590559 0.672874756,6.29493665 C0.695912971,6.51436522 0.716567922,6.73379379 0.735634031,6.95322236 C0.752714086,7.15118509 0.767808089,7.34914783 0.780121618,7.54711056 C0.792037936,7.74507329 0.800379358,7.94303602 0.805543096,8.14060124 C0.810706834,8.33816646 0.812692887,8.53573168 0.811501255,8.73250186 C0.810309623,8.92966957 0.807529149,9.12643975 0.803954254,9.32320994 C0.800379358,9.51958261 0.797598884,9.71595528 0.796010042,9.91312298 C0.794421199,10.1094957 0.792832357,10.3058683 0.791640725,10.5026385 C0.790846304,10.6998062 0.789654672,10.8965764 0.78846304,11.0937441 C0.784093724,11.6848497 0.775355091,12.2751602 0.765822036,12.8654708 C0.76145272,13.1544646 0.756686192,13.4418683 0.753111297,13.7332472 C0.751919665,13.830241 0.751125244,13.9276323 0.749933612,14.0258186 C0.74874198,14.1236075 0.747947559,14.2221913 0.747153138,14.3215702 C0.746358717,14.4205516 0.745564296,14.5207255 0.745167085,14.6212969 C0.744769874,14.7222658 0.744769874,14.8248248 0.745167085,14.9285764 C0.745564296,15.032328 0.746358717,15.1368745 0.747153138,15.2430112 C0.747550349,15.3570981 0.747947559,15.4719801 0.74874198,15.5880547 C0.749536402,15.7037317 0.750330823,15.8206012 0.750330823,15.9378683 C0.750728033,16.0555329 0.750330823,16.1731975 0.749933612,16.2908621 C0.749139191,16.4085267 0.747947559,16.5265888 0.747153138,16.6442534 C0.745961506,16.761918 0.744372664,16.8787876 0.742386611,16.9940671 C0.740797768,17.1093466 0.738414505,17.2234335 0.734442399,17.3355329 C0.730867503,17.4484273 0.725703766,17.5589366 0.719745607,17.6678559 C0.713787448,17.7775702 0.707034868,17.8852969 0.699090656,17.9918311 C0.691146444,18.1071106 0.687174338,18.232328 0.763438773,18.3181913 C0.805940307,18.3658932 0.864330265,18.3921292 0.929075593,18.4068373 C0.993026499,18.4211478 1.06253835,18.4239304 1.154294,18.4060422 C1.33701088,18.4032596 1.57732329,18.4203528 1.84067392,18.4354584 C1.86927308,18.4672596 1.93759331,18.4704398 2.00670795,18.4728248 C2.07582259,18.4752099 2.14652608,18.4768 2.21802399,18.4771975 C2.28872748,18.477595 2.36062259,18.477595 2.43251771,18.4764025 C2.50361841,18.4748124 2.57511632,18.4724273 2.6458198,18.4684522 C2.71652329,18.464477 2.78563794,18.4601043 2.85316374,18.4533466 C2.95484965,18.4442037 3.05256346,18.4310857 3.14471632,18.4139925 C3.23607476,18.3972969 3.32187225,18.3762286 3.40051994,18.3491975 C3.50498633,18.3134211 3.5975364,18.2657193 3.67578689,18.2033093 C3.75324296,18.1412969 3.81600223,18.0641789 3.8596954,17.9695702 C3.92245467,17.8356075 3.95423152,17.6885267 3.97091437,17.5350857 C3.98759721,17.3824398 3.98878884,17.2226385 3.98998047,17.0640298 C3.9907749,16.9074087 3.99156932,16.7499925 3.99236374,16.5905888 C3.99315816,16.4315826 3.99434979,16.2713839 3.99554142,16.1107876 C3.99673305,15.9501913 3.99752748,15.7899925 3.99871911,15.6297938 C3.99951353,15.4699925 4.00030795,15.3113839 4.00110237,15.1539677 C4.00149958,14.9659429 4.00189679,14.7803031 4.002294,14.5978435 C4.00189679,14.4161789 4.00269121,14.2357068 4.00269121,14.0552348 C4.00269121,13.8751602 4.00149958,13.6946882 3.99991074,13.5138186 C3.9983219,13.3329491 3.99593863,13.151682 3.99276095,12.9704149 C3.98878884,12.7287255 3.98283068,12.4866385 3.97528368,12.2445516 C3.96614784,12.001272 3.9534371,11.757595 3.94191799,11.513918 C3.93000167,11.2706385 3.92046862,11.027359 3.91172999,10.7848745 C3.90338856,10.5423901 3.89862204,10.2999056 3.89941646,10.0586137 C3.90021088,9.81652671 3.90418298,9.57523478 3.90696346,9.33275031 C3.90894951,9.19282484 3.90974393,9.05289938 3.91014114,8.91337143 C3.91093556,8.77344596 3.91093556,8.63391801 3.91093556,8.49359503 C3.91053835,8.35366957 3.90934672,8.21334658 3.90815509,8.07342112 C3.90656625,7.93309814 3.90497741,7.79277516 3.90378577,7.65205466 C3.89862204,7.41871304 3.89901925,7.18298634 3.90140251,6.9464646 C3.90338856,6.70914783 3.90696346,6.47103602 3.91133278,6.23252671 C3.91570209,5.99361988 3.92404351,5.75630311 3.93556262,5.52017888 C3.94708173,5.28405466 3.95860084,5.04912298 3.96733947,4.81538385 C3.97568089,4.58164472 3.98124184,4.34870062 3.98124184,4.11694907 C3.98124184,3.8848 3.97647531,3.65384348 3.96932552,3.42447702 C3.96297015,3.22651429 3.9685311,2.96017888 3.97011994,2.66641491 C3.97091437,2.51973168 3.97250321,2.36549565 3.97250321,2.21006708 C3.97250321,2.05384348 3.97170879,1.89602981 3.96694226,1.74020373",id:"Fill-58",fill:"#FFD300",mask:"url(#mask-8)",__source:{fileName:_jsxFileName,lineNumber:67}})),_react2.default.createElement("path",{d:"M82.3570897,41.5178733 C82.0047638,41.5278112 81.614703,41.5389416 81.1892905,41.549277 C80.7630835,41.5596124 80.3027164,41.5703453 79.8109697,41.5794882 C79.3188258,41.5894261 78.7953022,41.5965814 78.2443711,41.5997615 C77.69344,41.6029416 77.1143069,41.6021466 76.508958,41.5977739 C76.2066807,41.5953888 75.8980481,41.5934012 75.5834573,41.5934012 C75.2692637,41.5930037 74.9495092,41.5945938 74.6233993,41.5973764 C74.2976866,41.6005565 73.9660157,41.6045317 73.6279895,41.6089043 C73.2907577,41.6136745 72.9467733,41.6192398 72.5968308,41.6252025 C72.2472855,41.6303702 71.8905903,41.6367304 71.5283343,41.6422957 C71.1660782,41.6490534 70.7982612,41.6526311 70.4248832,41.6530286 C70.0519025,41.6534261 69.6729636,41.650246 69.2892581,41.6438857 C68.9055527,41.6375255 68.5162863,41.6271901 68.1226506,41.614072 C67.7286177,41.6013516 67.3302155,41.5866435 66.9274439,41.5703453 C66.5246724,41.5544447 66.1175315,41.5377491 65.7072129,41.5214509 C65.2964972,41.5055503 64.8826037,41.4900472 64.4659298,41.4761342 C64.0488587,41.4618236 63.6298015,41.4502957 63.2071694,41.4431404 C62.8198891,41.4363826 62.4326088,41.4332025 62.0433424,41.4324075 L60.8715711,41.4324075 L24.2833111,41.4324075 C21.8563544,41.4324075 19.3861016,40.9390907 16.9901273,41.1076373 C15.1391259,41.2380224 13.3087795,41.7373019 11.6897491,42.6531776 C11.1102188,42.981128 10.5628626,43.367513 10.052447,43.7984199 L10.052447,55.397128 C11.0494456,55.5744199 12.1147644,55.5434137 13.0926969,55.4917366 C13.3608141,55.4778236 13.6277396,55.4651031 13.890693,55.4575503 C14.1536464,55.4499975 14.4126277,55.4480099 14.6660481,55.4515876 C14.9194685,55.4555627 15.1677251,55.461128 15.4096263,55.4690783 C15.6519248,55.4770286 15.8878679,55.487364 16.116264,55.5000845 C16.257671,55.5076373 16.4439627,55.5207553 16.6703728,55.5366559 C16.8967828,55.552954 17.1637083,55.5716373 17.4675744,55.5903205 C17.7738238,55.6050286 18.117411,55.6181466 18.4955555,55.6249043 C18.8733028,55.6320596 19.2832241,55.6352398 19.7193613,55.6388174 C20.4820057,55.6455752 21.3225033,55.654718 22.2130495,55.6646559 C22.5097658,55.6682335 22.8124403,55.6718112 23.1190869,55.6753888 C23.4265279,55.679364 23.7375438,55.680159 24.0525318,55.6706186 C24.3675198,55.6606807 24.6860827,55.642395 25.0066316,55.6177491 C25.2477385,55.5990658 25.4896397,55.576805 25.7323354,55.5533516 C25.9754283,55.5295006 26.2193156,55.5052522 26.4636001,55.4806062 C26.7082818,55.4563578 26.9533608,55.4333019 27.1984397,55.4122335 C27.4431215,55.3915627 27.6882004,55.3736745 27.9328821,55.3585689 C28.1779611,55.3450534 28.4222456,55.3323329 28.6653385,55.322395 C28.9088286,55.3124571 29.1519215,55.3056994 29.3934255,55.3021217 C29.6349295,55.2985441 29.8748447,55.2977491 30.1139655,55.2989416 C30.3522919,55.3001342 30.5890294,55.3025193 30.8241781,55.3053019 C31.0589295,55.3072894 31.2912977,55.3124571 31.5216799,55.3196124 C31.7516648,55.3263702 31.9792665,55.334718 32.2036905,55.3434634 C32.6529357,55.3613516 33.0902645,55.3804323 33.5121022,55.399513 C33.9339399,55.4177988 34.3394919,55.4261466 34.726375,55.4297242 C35.1124637,55.4273391 35.4790891,55.4325068 35.8238679,55.4404571 C36.1682495,55.4492025 36.4899901,55.4563578 36.7863092,55.4623205 C37.0830255,55.4682832 37.3531287,55.4730534 37.59503,55.4770286 C38.0776408,55.4841839 38.4442662,55.4790161 38.6659097,55.463513 C38.7922227,55.4547677 39.0448486,55.4468174 39.4086936,55.4392646 C39.5910132,55.4368795 39.8011376,55.437277 40.0378751,55.4412522 C40.2750099,55.4456248 40.5379633,55.4547677 40.825941,55.4686807 C41.0968386,55.4817988 41.3895828,55.4984944 41.7025848,55.5175752 C42.0159839,55.5370534 42.3492436,55.5581217 42.7015694,55.5803826 C43.0538952,55.602246 43.4240955,55.6217242 43.8117731,55.6368298 C44.1998478,55.6515379 44.603811,55.6602832 45.0236626,55.6626683 C45.4427198,55.6610783 45.8780626,55.6598857 46.327705,55.6586932 C46.8341485,55.6571031 47.3596581,55.6559106 47.900659,55.654718 C48.4416598,55.6543205 48.9993435,55.6535255 49.5693407,55.6467677 C50.1397351,55.6400099 50.7228403,55.6280845 51.3174645,55.6137739 C51.5724738,55.6074137 51.8298662,55.6014509 52.0888475,55.5950907 C52.3478288,55.5887304 52.6091934,55.5807801 52.8737357,55.5700472 C53.1378807,55.5593143 53.4052035,55.5469913 53.6749095,55.5334758 C53.9446155,55.5203578 54.2163075,55.5064447 54.4899856,55.4937242 C54.7636637,55.4810037 55.0397251,55.4690783 55.3165809,55.4587429 C55.5934367,55.4484075 55.8718813,55.4400596 56.1511203,55.4348919 C56.4307566,55.4293267 56.7111873,55.4261466 56.9920152,55.4265441 C57.2728431,55.4269416 57.5544654,55.4293267 57.8372793,55.4336994 C58.1196961,55.438072 58.4033044,55.4440348 58.68731,55.4511901 C58.9713156,55.4583453 59.2557184,55.4658981 59.5405184,55.4746435 C59.824524,55.4833888 60.109324,55.4933267 60.394124,55.5048547 C60.678924,55.5155876 60.9641212,55.526718 61.248524,55.538246 C61.5329268,55.5489789 61.8177268,55.5593143 62.1017323,55.5684571 C62.3857379,55.576805 62.6697435,55.5839602 62.9529546,55.5879354 C63.236563,55.5919106 63.519377,55.5950907 63.8009993,55.5998609 C64.9874673,55.6197366 66.1667856,55.6431901 67.3377625,55.6535255 C68.5095337,55.6634634 69.6693887,55.6650534 70.7994528,55.6666435 C72.118192,55.6682335 73.3952241,55.6698236 74.6122774,55.6710161 C75.8293307,55.6718112 76.9856107,55.6726062 78.0703929,55.640805 C79.1547778,55.6086062 80.1652816,55.5553391 81.0709217,55.5187677 C81.7326746,55.4913391 82.3352431,55.4806062 82.8746551,55.4825938 L82.8746551,41.5031652 C82.7125931,41.5079354 82.5406009,41.5127056 82.3570897,41.5178733",id:"Fill-61",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:69}}),_react2.default.createElement("path",{d:"M167.6305,12.4483975 C167.461288,11.9777391 167.212634,11.5424596 166.951667,11.1123478 C166.690699,10.682236 166.410666,10.260472 166.180681,9.81525466 C166.026563,9.51711801 165.867679,9.22613665 165.701645,8.94111801 C165.535611,8.65649689 165.362824,8.37823602 165.181299,8.10593789 C164.999774,7.83443478 164.810304,7.56849689 164.611699,7.30812422 C164.412696,7.04814907 164.206147,6.7929441 163.98927,6.54330435 C163.771996,6.29326708 163.546777,6.04720497 163.311231,5.80551553 C163.075288,5.56382609 162.831004,5.32491925 162.576789,5.08879503 C162.291195,4.82404969 162.009572,4.57759006 161.723581,4.35100621 C161.487638,4.16099379 161.249311,3.98489441 161.00741,3.82032298 C160.765906,3.65614907 160.521224,3.50390062 160.270187,3.36357764 C160.01915,3.22404969 159.762155,3.09604969 159.498407,2.97918012 C158.707163,2.6277764 157.853955,2.37455901 156.920113,2.18653416 C155.675652,1.93570186 154.420069,1.9802236 153.158529,1.93450932 C151.765908,1.88362733 150.375671,1.79021118 148.981065,1.77947826 C148.97749,1.77947826 148.975106,1.78106832 148.971134,1.78106832 C148.965573,1.78146584 148.960807,1.77868323 148.954452,1.77947826 C147.630151,1.89952795 146.389265,3.03721739 145.847867,4.1971677 C144.971224,6.07423602 145.512224,8.46688199 145.531688,10.4572422 C145.541618,11.4589814 145.320769,12.6992298 146.622825,12.8097391 C147.670667,12.8987826 148.772926,12.8053665 149.829904,12.8530683 C151.119647,12.9111056 152.408595,12.9774907 153.698338,13.0347329 C155.326504,13.1062857 156.955862,13.1496149 158.585617,13.1853913 C158.992758,13.1949317 159.400296,13.2032795 159.808231,13.2120248 C160.216166,13.2203727 160.628074,13.2287205 161.047528,13.2338882 C161.345039,13.2370683 161.646522,13.2386584 161.950388,13.2398509 C162.254254,13.240646 162.559312,13.241441 162.864767,13.242236 C163.170222,13.2430311 163.474088,13.2450186 163.776762,13.2481988 C164.079437,13.2513789 164.378934,13.2557516 164.676047,13.2633043 C165.004937,13.2708571 165.329856,13.2811925 165.651199,13.2847702 C165.972145,13.2883478 166.289914,13.2851677 166.606093,13.2664845 C166.791591,13.254559 167.299226,13.2768199 167.485518,13.1579627 C167.787795,12.9655652 167.738541,12.7497143 167.6305,12.4483975",id:"Fill-63",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:70}}),_react2.default.createElement("path",{d:"M160.412468,60.4220025 C160.73262,60.730872 161.064688,61.0162882 161.402714,61.279046 C161.74074,61.5418037 162.087902,61.7842882 162.445392,62.0072944 C162.803676,62.2310957 163.169507,62.4350211 163.540501,62.6190708 C163.911496,62.803518 164.28408,62.9668969 164.654677,63.1084124 C165.025275,63.2491329 165.398255,63.3664 165.773619,63.4606112 C166.0612,63.532164 166.350369,63.5925863 166.64073,63.6394932 C166.931091,63.6860025 167.223041,63.7189963 167.513799,63.7348969 C167.801777,63.7452323 168.087768,63.7348969 168.37098,63.7026981 C168.653793,63.6701019 168.934621,63.6152447 169.212272,63.5417043 C169.582869,63.4363627 169.951481,63.3004124 170.316914,63.1374311 C170.682348,62.9744497 171.046193,62.7915925 171.407655,62.5936298 C171.769116,62.3960646 172.128592,62.1857789 172.481712,61.9584 C172.787564,61.7703752 173.088253,61.5684373 173.379011,61.3505988 C173.575233,61.2039155 173.760333,61.050872 173.9359,60.8914683 C174.11107,60.7316671 174.27631,60.5655056 174.431222,60.3913938 C174.739854,60.0435677 175.004397,59.667518 175.224054,59.2707975 C175.370625,59.0040646 175.505676,58.732959 175.631195,58.4574807 C175.757111,58.181605 175.871904,57.901754 175.973988,57.6199155 C176.076071,57.338077 176.165046,57.0538534 176.240913,56.7672447 C176.316383,56.4802385 176.379142,56.1904497 176.429588,55.8982758 C176.481226,55.6076919 176.521741,55.3151205 176.549149,55.0229466 C176.580925,54.688636 176.592842,54.3523379 176.585692,54.0172323 C176.578145,53.6817292 176.552723,53.3478161 176.508633,53.0174807 C176.46494,52.6867478 176.401783,52.3584 176.31678,52.0328348 C176.222641,51.6710957 176.100301,51.3125366 175.949758,50.9595429 C175.798421,50.6053565 175.618881,50.2551453 175.415907,49.9089093 C175.213329,49.5630708 174.988111,49.2204124 174.736279,48.8857043 C174.483653,48.5490087 174.203223,48.2321888 173.896179,47.9364373 C173.589532,47.6410832 173.25667,47.3687851 172.907125,47.1211329 C172.546855,46.8671205 172.172285,46.6329839 171.78858,46.4155429 C171.404477,46.1984994 171.013622,46.0037168 170.621972,45.8359652 C170.230322,45.6686112 169.834701,45.5286857 169.435901,45.4181764 C169.037102,45.3076671 168.635919,45.2249839 168.236722,45.1685366 C167.837128,45.1120894 167.439521,45.0846609 167.045488,45.0866484 C166.651455,45.0890335 166.260997,45.1212323 165.876497,45.1828472 C165.4916,45.2448596 165.112661,45.3366857 164.734914,45.4571329 C164.356769,45.5783752 163.979419,45.727841 163.60763,45.9019528 C163.233458,46.0768596 162.862066,46.2744248 162.494646,46.4942509 C162.127226,46.714077 161.766559,46.9557665 161.422972,47.2256795 C161.137377,47.4562385 160.872438,47.699518 160.624578,47.9567106 C160.376719,48.2139031 160.143954,48.4834186 159.927077,48.7640646 C159.709802,49.044313 159.508814,49.3333068 159.322919,49.6298534 C159.137025,49.9260025 158.967813,50.2281143 158.816476,50.5338037 C158.665536,50.8394932 158.532867,51.1487602 158.419662,51.4635925 C158.306855,51.7784248 158.21073,52.0992199 158.130096,52.4235925 C158.034765,52.8171329 157.96287,53.2170335 157.915999,53.6248845 C157.869526,54.0299528 157.848474,54.4397913 157.856418,54.8516174 C157.864759,55.2634435 157.903686,55.6764621 157.973198,56.0847106 C158.043504,56.492959 158.146381,56.8896795 158.2862,57.274872 C158.426018,57.6604621 158.602776,58.0353193 158.813298,58.3978534 C159.023422,58.7603876 159.26294,59.1102012 159.531058,59.448487 C159.797983,59.7855801 160.092316,60.1127354 160.412468,60.4220025",id:"Fill-65",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:71}}),_react2.default.createElement("path",{d:"M37.4431763,49.8664944 C37.259665,50.2727553 37.1023697,50.6837863 36.967318,51.0932273 C36.8326637,51.5026683 36.7210475,51.9144944 36.6304835,52.3291031 C36.5403167,52.7441093 36.471202,53.1599106 36.4227423,53.5717366 C36.3746798,53.9835627 36.3468751,54.3898236 36.3405197,54.7861466 C36.3337671,55.1828671 36.3512444,55.5724323 36.3913627,55.9572273 C36.4223451,56.2517863 36.4644494,56.5443578 36.5200589,56.832954 C36.5752712,57.1219478 36.6439886,57.407364 36.7281973,57.6864199 C36.8167752,57.9611031 36.9236249,58.2266435 37.0507323,58.482246 C37.1770452,58.7374509 37.323616,58.983513 37.4868695,59.2200348 C37.7112935,59.533277 37.9639194,59.8345938 38.240378,60.1239851 C38.517631,60.4129789 38.8123613,60.6936248 39.1205967,60.967513 C39.4288321,61.2406062 39.7481895,61.5085317 40.0810519,61.7645317 C40.3614826,61.9887304 40.6530352,62.2037863 40.9557097,62.4041342 C41.1598759,62.5392894 41.3668226,62.6617242 41.5761526,62.7734261 C41.7854826,62.8847304 41.9975931,62.9841093 42.2136756,63.0711652 C42.6454436,63.2440845 43.0883334,63.3665193 43.5351953,63.4392646 C43.8358837,63.4869665 44.1365722,63.5227429 44.438055,63.5477863 C44.7395379,63.5728298 45.0418151,63.5867429 45.3413119,63.5875379 C45.6408087,63.5887304 45.9383194,63.5760099 46.2334469,63.5505689 C46.5285744,63.5247304 46.8225102,63.4861714 47.11446,63.4348919 C47.4052182,63.3852025 48.0483021,63.3243826 48.3327049,63.2516373 C48.6576232,63.1685565 48.6234631,63.066395 48.936465,62.9459478 C49.249467,62.8258981 49.5545247,62.6887553 49.8504466,62.5357118 C50.1463685,62.3826683 50.433949,62.2121342 50.711202,62.0221217 C51.0198346,61.8114385 51.3157565,61.5749168 51.5965844,61.3137491 C51.8790012,61.0517863 52.1479127,60.7639851 52.4045108,60.4563081 C52.6615061,60.1482335 52.9073794,59.8202832 53.1373644,59.4696745 C53.3681437,59.1178733 53.5715155,58.7469913 53.745891,58.3578236 C53.9198692,57.9690534 54.0636595,57.5635876 54.1784533,57.1505689 C54.2952332,56.7256248 54.3893722,56.293923 54.4616645,55.8594385 C54.5335596,55.424954 54.5812249,54.9928547 54.600291,54.5691031 C54.6193571,54.1457491 54.6102213,53.7283578 54.5716918,53.3189168 C54.5327652,52.9086807 54.4652394,52.5083826 54.3711005,52.1188174 C54.2773588,51.7292522 54.1566068,51.3520099 54.0088444,50.9882832 C53.8614793,50.624159 53.687501,50.2731528 53.4892929,49.9376497 C53.2910849,49.6017491 53.0690441,49.2797615 52.8219791,48.9681093 C52.5749141,48.6564571 52.3044137,48.3531528 52.0160388,48.0621714 C51.7264723,47.7692025 51.4194285,47.4849789 51.0972907,47.2098981 C50.7747557,46.9352149 50.4367295,46.6728547 50.0796372,46.4347429 C49.7781543,46.2383702 49.4707133,46.0654509 49.1565197,45.9139975 C48.8423261,45.7617491 48.5205856,45.6277863 48.1924896,45.5125068 C47.8647909,45.3968298 47.5323256,45.299041 47.1978743,45.2187429 C46.8630257,45.1380472 46.5273828,45.0760348 46.1937259,45.0327056 C45.8596717,44.9889789 45.5276037,44.965923 45.1951384,44.9643329 C44.8622759,44.9623453 44.5282218,44.979836 44.1957565,45.0132273 C43.792985,45.0565565 43.3929939,45.1245317 42.9941945,45.2195379 C42.5977783,45.3133516 42.204937,45.4334012 41.8208344,45.5816745 C41.4367317,45.7295503 41.0613677,45.9064447 40.7014949,46.1111652 C40.3416221,46.3150907 40.0035959,46.5460472 39.6882107,46.8076124 C39.3732226,47.0687801 39.0800812,47.360954 38.8095808,47.680159 C38.5394776,47.9989665 38.2908238,48.3420224 38.0632221,48.7073391 C37.8352232,49.0722584 37.6270849,49.459836 37.4431763,49.8664944",id:"Fill-67",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:72}}),_react2.default.createElement("path",{d:"M65.7173021,62.482564 C66.0918717,62.6920547 66.4755771,62.8709366 66.8660351,63.0208 C67.0610656,63.0955329 67.258082,63.1635081 67.4562901,63.224328 C67.6548954,63.2859429 67.8546923,63.340005 68.0552837,63.3877068 C68.255875,63.4358062 68.4564664,63.4771478 68.657455,63.5125267 C68.8588407,63.5479056 69.0598293,63.5769242 69.2604206,63.5999801 C69.461012,63.6226385 69.6612061,63.6397317 69.8602086,63.6508621 C70.0592112,63.6623901 70.257022,63.6679553 70.4532441,63.6675578 C70.6498633,63.6671602 70.8452909,63.6611975 71.0399241,63.6488745 C71.2349545,63.636154 71.4283961,63.6174708 71.6210432,63.5924273 C71.9161707,63.5542658 72.2089149,63.5013963 72.4980842,63.4342161 C72.7872536,63.3666385 73.0732452,63.2843528 73.3532787,63.1869615 C73.6281484,63.0863901 73.8954711,62.9675329 74.1524664,62.8307876 C74.4098589,62.6936447 74.6577183,62.5398062 74.8968391,62.3700671 C75.2138131,62.1418932 75.5188709,61.8898683 75.8124095,61.6167752 C76.1063453,61.3440795 76.3915425,61.0530981 76.6687955,60.7493963 C76.946843,60.4452969 77.2181378,60.1296696 77.4779135,59.8009242 C78.1217919,59.014241 78.6635872,58.2899677 78.9221713,57.2806758 C79.3507615,55.6095205 79.3976324,53.8437565 79.0743029,52.1499429 C78.9301155,51.3954584 78.7569317,50.6270609 78.3315191,49.9946137 C78.1166282,49.6746137 77.8739325,49.3736944 77.6248815,49.0787379 C77.3754332,48.7841789 77.1188351,48.4951851 76.8749478,48.199036 C76.6223219,47.892154 76.3482466,47.5991851 76.0551052,47.3205267 C75.7627582,47.0422658 75.4505506,46.7795081 75.1160993,46.5358311 C74.781648,46.292154 74.4336915,46.0763031 74.0718326,45.8882783 C73.7564474,45.7245019 73.4323236,45.5762286 73.1014471,45.445446 C72.7705707,45.3146634 72.4325445,45.202564 72.0905462,45.1095453 C71.7481506,45.0161292 71.4005914,44.9406012 71.0498544,44.883359 C70.6991174,44.8257193 70.3448056,44.7859677 69.9893021,44.7652969 C69.6334014,44.7442286 69.2763091,44.7418435 68.9192167,44.7601292 C68.5621244,44.7784149 68.2054293,44.8177689 67.850323,44.8793839 C67.5369238,44.9346385 67.2255107,45.0101665 66.920453,45.1063652 C66.4628664,45.2502658 66.0199766,45.4430609 65.6036999,45.6807752 C65.1878204,45.918887 64.7981568,46.2015205 64.447817,46.5286758 C63.5811035,47.3368248 62.5165791,48.1091975 62.050651,49.2456944 C61.6494683,50.2231851 61.486612,51.3390112 61.2705294,52.3697689 C61.2002232,52.705272 61.1446137,53.0419677 61.105687,53.3782658 C61.065966,53.7137689 61.0437222,54.049272 61.0401473,54.3831851 C61.0361752,54.7170981 61.0512692,55.0510112 61.0846349,55.3821416 C61.1291225,55.7824398 61.2006204,56.1803528 61.2991286,56.5766758 C61.3976368,56.9729988 61.5239498,57.3673342 61.6776703,57.7557068 C61.8313908,58.144477 62.0117244,58.5256944 62.2162879,58.8953839 C62.4204541,59.2650733 62.6476586,59.6224398 62.8979013,59.9635081 C63.1477467,60.3045764 63.4202332,60.6293466 63.7125802,60.9330484 C64.0049272,61.2367503 64.3183264,61.5189863 64.6523805,61.7781665 C64.987229,62.0373466 65.3427325,62.2726758 65.7173021,62.482564",id:"Fill-69",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:73}}),_react2.default.createElement("path",{d:"M22.2285407,45.2721292 C21.7999505,45.2808745 21.3797016,45.3202286 20.9685887,45.3870112 C20.5578729,45.4537938 20.1547042,45.5472099 19.7618629,45.6640795 C19.3694188,45.7809491 18.9876994,45.9208745 18.6194852,46.0810733 C18.2508738,46.241272 17.8961647,46.4209491 17.5569468,46.6181168 C17.2181262,46.8152845 16.8936051,47.032328 16.5853697,47.2684522 C16.3494266,47.4501168 16.1226194,47.6429118 15.9057424,47.8468373 C15.6888654,48.0503652 15.4823159,48.2650236 15.2880799,48.4900174 C15.1005965,48.7158062 14.9282071,48.953123 14.7740894,49.2003776 C14.6203689,49.4480298 14.482934,49.7056199 14.3609903,49.9723528 C14.2017089,50.3289242 14.064274,50.6998062 13.9470969,51.0830112 C13.8299198,51.4662161 13.7294255,51.8609491 13.6412447,52.2636323 C13.553064,52.6663155 13.4760051,53.0757565 13.4152319,53.4915578 C13.3564447,53.8457441 13.3111627,54.2058932 13.2841524,54.5676323 C13.2666751,54.8121043 13.2603198,55.0526012 13.2654835,55.289918 C13.27025,55.5268373 13.2869329,55.7609739 13.3167237,55.9919304 C13.3767025,56.453446 13.4863326,56.9002534 13.6412447,57.325595 C13.7476972,57.6094211 13.8672576,57.8837068 13.9983371,58.1496447 C14.1294166,58.4151851 14.2724124,58.6727752 14.4261329,58.9204273 C14.5802506,59.168477 14.7454902,59.4073839 14.9210573,59.6371478 C15.0966244,59.8673093 15.2833134,60.089918 15.480727,60.3053714 C15.6781407,60.5208248 15.8862791,60.7295205 16.1059365,60.9306634 C16.3565764,61.1600298 16.6235019,61.3794584 16.902741,61.587359 C17.18198,61.7952596 17.4703549,61.9932224 17.7662768,62.1800547 C18.0618015,62.366887 18.3648732,62.5413963 18.6762863,62.7011975 C19.0218595,62.8784894 19.3785546,63.0359056 19.7447828,63.1686758 C20.1114082,63.303036 20.4879638,63.4131478 20.8732581,63.5002037 C21.2585524,63.5876571 21.6529825,63.6516571 22.0521792,63.687036 C22.4517731,63.7224149 22.845806,63.7259925 23.2386473,63.6969739 C23.6314885,63.6671602 24.0199605,63.6043528 24.3985022,63.5117317 C24.7837965,63.4123528 25.1603521,63.2875329 25.5273747,63.1392596 C25.8940001,62.9909863 26.2499008,62.8188621 26.5930908,62.6232845 C26.9362807,62.4285019 27.2663627,62.2102658 27.5813507,61.971359 C27.8959415,61.7320547 28.1942467,61.471682 28.4742802,61.1926261 C28.7539164,60.9131727 29.0156782,60.615036 29.2607572,60.2998062 C29.5054389,59.9845764 29.733835,59.6530484 29.9407817,59.308005 C30.1481256,58.9629615 30.3352118,58.6048 30.5008486,58.232328 C30.6664855,57.8594584 30.8106729,57.4714832 30.9302333,57.0719801 C31.0497937,56.6720795 31.1439326,56.261446 31.21265,55.8420671 C31.2813675,55.4226882 31.3230746,54.9969491 31.3337993,54.5680298 C31.3429351,54.2102658 31.3318132,53.8604522 31.3020224,53.5173963 C31.2722316,53.1739429 31.2241691,52.8356571 31.1606155,52.5041292 C31.0966645,52.1726012 31.0188113,51.8474335 30.9270556,51.5298186 C30.8360944,51.2118062 30.7304364,50.9021416 30.6104788,50.6012224 C30.4905212,50.3007006 30.3554696,50.0097193 30.2041323,49.7294708 C30.0527951,49.4492224 29.8843778,49.1785143 29.7008665,48.9193342 C29.4744565,48.6080795 29.2250082,48.3115329 28.9517273,48.0300919 C28.6780492,47.7482534 28.3805385,47.4823155 28.0611811,47.2334708 C27.7414266,46.9850236 27.4006199,46.7548621 27.0439248,46.5461665 C26.6868325,46.3378683 26.3146461,46.151036 25.9293519,45.9888497 C25.544852,45.8270609 25.1472442,45.689918 24.741295,45.5798062 C24.3357429,45.4704894 23.9226439,45.3886012 23.5023951,45.3369242 C23.0825435,45.2848497 22.6575281,45.2633839 22.2285407,45.2721292",id:"Fill-71",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:74}}),_react2.default.createElement("path",{d:"M11.3591904,53.0407752 C11.3691207,52.8925019 11.39057,52.7247503 11.4203608,52.5518311 C11.4100334,52.5518311 11.3997059,52.5522286 11.3893784,52.5522286 C11.2257276,52.5538186 11.0636657,52.5558062 10.9023982,52.5581913 C10.7411307,52.5601789 10.5810548,52.5629615 10.4225678,52.5653466 C10.2632864,52.5681292 10.105991,52.5701168 9.95028441,52.5725019 C9.79457785,52.574887 9.64085735,52.5768745 9.4891229,52.5788621 C9.33738845,52.5804522 9.18764006,52.5820422 9.04106934,52.5824398 C8.89449863,52.5832348 8.74951676,52.5836323 8.60493211,52.5836323 L7.96582025,52.5836323 C7.65122946,52.5836323 7.34498008,52.5832348 7.04468887,52.5820422 C6.74479487,52.5804522 6.45125623,52.5776696 6.16327855,52.5732969 C5.77838148,52.5681292 5.40420909,52.5573963 5.04235024,52.5434832 C4.68049138,52.5299677 4.33134326,52.512477 3.99689194,52.4937938 C3.7855759,52.4818683 3.56949333,52.4647752 3.35142471,52.4464894 C3.13335609,52.4278062 3.35936893,52.4385391 3.14010868,52.4198559 C2.91965679,52.4007752 2.69602722,52.3824894 2.47160324,52.3665888 C2.20944424,52.3483031 1.95046293,52.3165019 1.69267325,52.2906634 C1.45156642,52.2668124 1.21284285,52.3157068 0.980474644,52.2326261 C0.833506722,52.180154 0.665089428,52.088328 0.53361272,52.179359 C0.510971715,52.1952596 0.492700028,52.2151354 0.477208815,52.2373963 C0.445829177,52.2815205 0.427160279,52.3351851 0.410080223,52.3864646 C0.264701144,52.8312845 0.165795704,53.2315826 0.111775063,53.689123 C0.07682053,54.0127006 0.0565627894,54.3315081 0.0696707392,54.6022161 C0.082778689,54.8725267 0.127663487,55.0955329 0.21584424,55.2294957 C0.374331269,55.468005 0.661117322,55.5745391 0.981269066,55.6242286 C1.3010236,55.673918 1.65374661,55.6683528 1.93735498,55.6806758 C2.34608469,55.6981665 2.77110003,55.7021416 3.21081216,55.7077068 C3.65131872,55.7136696 3.65171593,55.6941913 4.11367185,55.6973714 C4.57721662,55.7017441 5.03241997,55.7013466 5.47054326,55.7017441 C5.90826934,55.7025391 6.33249026,55.7021416 6.74638371,55.7100919 C6.96048022,55.7144646 7.17219347,55.7164522 7.38271509,55.7172472 C7.59363392,55.7180422 7.80336112,55.7172472 8.01388273,55.7148621 C8.22480156,55.712477 8.43770644,55.7077068 8.65299459,55.7009491 C8.86828273,55.6941913 9.08754298,55.6846509 9.31156976,55.673918 C9.98523894,55.6409242 10.6688384,55.5892472 11.3353578,55.481918 C11.2539296,55.495036 11.345288,53.2359553 11.3591904,53.0407752",id:"Fill-73",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:75}}),_react2.default.createElement("path",{d:"M34.3869188,53.818713 C34.3885077,53.7058186 34.3904937,53.5941168 34.3924798,53.4828124 C34.3936714,53.3162534 34.3952603,53.152477 34.4008212,52.9918807 C34.4063821,52.830887 34.4167096,52.6722783 34.4365702,52.5168497 C34.3150237,52.5156571 34.1914912,52.5152596 34.0707392,52.5144646 C33.6060028,52.5104894 33.1456357,52.4997565 32.684077,52.4778932 C32.6658053,52.4770981 32.646342,52.4763031 32.631248,52.486241 C32.6054293,52.5029366 32.6042377,52.5403031 32.6062237,52.5713093 C32.6340285,53.025272 32.6511085,53.4796323 32.6570667,53.9347876 C32.6582583,54.048477 32.6590527,54.1621665 32.6590527,54.2758559 C32.6594499,54.3895453 32.6586555,54.5032348 32.6578611,54.6169242 C32.6574639,54.7206758 32.640781,54.8514584 32.6419727,54.9790609 C32.6435615,55.1062658 32.6638192,55.2302907 32.7396865,55.3193342 C32.7968848,55.3869118 32.8890377,55.4214957 32.9803961,55.4381913 C33.1666879,55.4723776 33.3831676,55.4445516 33.5702538,55.4409739 C33.6838561,55.4389863 33.8248658,55.4477317 33.9539593,55.4405764 C34.0826555,55.4334211 34.1982438,55.4123528 34.272125,55.3495453 C34.3039018,55.3225143 34.3237623,55.2835578 34.3392536,55.2434087 C34.3773858,55.1456199 34.3904937,55.045446 34.3940686,54.9420919 C34.3976435,54.8383404 34.3936714,54.7318062 34.3956575,54.6212969 C34.3988351,54.4909118 34.3952603,54.3569491 34.3920826,54.2217938 C34.3885077,54.0866385 34.3849328,53.9510857 34.3869188,53.818713",id:"Fill-75",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:76}}),_react2.default.createElement("path",{d:"M58.5159136,54.0935553 C58.5258439,53.9615801 58.5349797,53.8335801 58.542924,53.7043876 C58.5516626,53.5755925 58.5588124,53.445605 58.5659622,53.3124373 C58.5794673,53.0584248 58.5965474,52.8075925 58.6275298,52.5603379 L57.9896096,52.5603379 L56.5592542,52.5603379 C56.5699789,52.7098037 56.5799092,52.8616547 56.5882506,53.0162882 C56.5969892,53.1709217 56.604139,53.3271453 56.6093028,53.4853565 C56.6148637,53.6427727 56.6188358,53.8021764 56.6208219,53.9619776 C56.6220135,54.0677168 56.6291633,54.1718658 56.6371075,54.2756174 C56.6450517,54.3793689 56.6541876,54.482723 56.6597485,54.5864745 C56.6665011,54.7112944 56.662529,54.8341267 56.664515,54.9466236 C56.6665011,55.0591205 56.6736509,55.162077 56.7038389,55.2447602 C56.7332325,55.327841 56.7856643,55.3930335 56.8770227,55.4335801 C56.9683811,55.4749217 57.0986662,55.4944 57.2837664,55.4896298 C57.3826718,55.4868472 57.5006433,55.4892323 57.622587,55.4876422 C57.7445307,55.4864497 57.869652,55.4808845 57.9836514,55.4618037 C58.0976509,55.4431205 58.2005284,55.4081391 58.2779845,55.3473193 C58.3558378,55.2868969 58.409064,55.1994435 58.4245552,55.0774062 C58.4460046,54.9036919 58.4630846,54.7335553 58.4777814,54.5681888 C58.492081,54.4028224 58.5047917,54.2454062 58.5159136,54.0935553",id:"Fill-77",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:77}}),_react2.default.createElement("path",{d:"M187.833544,51.6902161 C187.880812,51.0816199 187.846255,50.597446 187.620242,50.2810236 C187.507434,50.1232099 187.346961,50.0059429 187.124126,49.9343901 C186.900894,49.8624398 186.615299,49.8366012 186.249866,49.8600547 C185.764077,49.8918559 185.27233,49.8870857 184.793294,49.8660174 C184.311478,49.8449491 183.859055,49.8103652 183.414974,49.7809491 C182.931965,49.7495453 182.45849,49.7765764 181.985413,49.8103652 C181.512732,49.8445516 181.040449,49.8862907 180.564987,49.8835081 C180.222592,49.8815205 179.722901,49.7821416 179.270081,49.7745888 C179.101664,49.7690236 178.946751,49.7773714 178.803756,49.8167255 C178.660363,49.8560795 178.530078,49.9272348 178.411312,50.047682 C178.320748,50.1395081 178.291354,50.2110609 178.171794,50.2750609 C178.05263,50.3390609 177.79206,50.3020919 177.823043,50.497272 C177.852436,50.6833093 177.883419,50.8685516 177.914798,51.0533963 C177.946178,51.2386385 177.97716,51.4234832 178.00576,51.609123 C178.034756,51.7943652 178.061766,51.9804025 178.089174,52.1684273 C178.115787,52.3564522 178.141606,52.5456696 178.164247,52.736477 C178.187285,52.9272845 178.20794,53.118887 178.225814,53.310887 C178.243291,53.5032845 178.258783,53.6960795 178.269905,53.8888745 C178.281424,54.0820671 178.289368,54.2756571 178.294134,54.4696447 C178.299298,54.6640298 178.301681,54.8588124 178.301284,55.0543901 C178.30049,55.3910857 178.426008,55.5310112 178.607534,55.5898435 C178.789059,55.6478807 179.030166,55.6240298 179.253398,55.6327752 C179.43254,55.640328 179.618037,55.6482783 179.808301,55.6538435 C179.998565,55.6594087 180.190021,55.6629863 180.381079,55.6617938 C180.825558,55.6594087 181.261298,55.6609988 181.69664,55.667359 C182.131983,55.6737193 182.566929,55.6840547 183.018955,55.7019429 C183.257281,55.7110857 183.499182,55.7154584 183.747836,55.7150609 C183.99649,55.7146634 184.254279,55.7087006 184.523985,55.6987627 C184.7925,55.6884273 185.068164,55.6749118 185.345417,55.6606012 C185.623067,55.6466882 185.90032,55.6331727 186.172807,55.6228373 C186.440924,55.6121043 186.733271,55.628005 187.003771,55.6057441 C187.274272,55.5826882 187.518556,55.5226634 187.685782,55.3620671 C187.938805,55.1195826 187.926491,54.719682 187.914575,54.3945143 C187.899084,53.9683776 187.855788,53.5350857 187.829969,53.0858932 C187.804151,52.6370981 187.796206,52.1692224 187.833544,51.6902161",id:"Fill-79",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:78}}),_react2.default.createElement("path",{d:"M156.41359,49.4813814 C156.159772,49.4678658 155.89245,49.4805863 155.64459,49.5175553 C155.449163,49.5469714 155.237052,49.5728099 155.011834,49.5966609 C154.786218,49.6209093 154.547495,49.6407851 154.299635,49.6594683 C154.044626,49.6729839 153.788822,49.6825242 153.535005,49.6888845 C153.283968,49.6936547 153.034917,49.6976298 152.787057,49.7075677 C152.490738,49.7179031 152.196405,49.7433441 151.902469,49.7731578 C151.608533,49.8033689 151.315392,49.8371578 151.022648,49.8625988 C150.436365,49.9134807 149.850479,49.932164 149.257841,49.8216547 C149.163702,49.804164 149.03302,49.8451081 149.013954,49.9564124 C148.898365,50.623841 148.871752,51.2956422 148.81654,51.9702261 C148.791516,52.2751205 148.690227,52.4945491 148.549217,52.6766112 C148.539287,52.6782012 148.529357,52.6809839 148.519426,52.6817789 C148.357762,52.697282 148.193317,52.6984745 148.024502,52.6956919 C147.855688,52.6929093 147.683695,52.6865491 147.50932,52.6877416 C147.363544,52.6889342 147.205851,52.6889342 147.03942,52.6873441 C146.873386,52.6865491 146.698613,52.684164 146.517882,52.6805863 C146.337151,52.6774062 146.154037,52.6730335 145.969334,52.6682634 C145.788604,52.6630957 145.607078,52.658723 145.420787,52.6567354 C145.235289,52.6563379 145.04145,52.6571329 144.838476,52.658723 C144.635898,52.6607106 144.424185,52.6626981 144.204528,52.6646857 C143.32272,52.6698534 142.305861,52.6738286 141.163483,52.672636 C140.592295,52.6722385 139.989329,52.6690584 139.35697,52.6630957 C138.724213,52.6575304 138.062063,52.6495801 137.371711,52.6396422 C136.680962,52.6297043 135.962408,52.6181764 135.216844,52.6050584 C134.470882,52.5919404 133.69791,52.5776298 132.89912,52.5629217 C132.258419,52.5486112 131.603021,52.5362882 130.932927,52.5239652 C130.262436,52.5120398 129.578439,52.4997168 128.881732,52.4873938 C128.185819,52.4754683 127.476003,52.4643379 126.755463,52.4547975 C126.034923,52.4456547 125.301673,52.4381019 124.554122,52.4317416 C123.806572,52.4245863 123.044722,52.4186236 122.26897,52.4130584 C121.493217,52.4074932 120.704357,52.4047106 119.902389,52.403518 C119.100421,52.402723 118.286139,52.4039155 117.459544,52.4066981 C116.632948,52.4098783 115.79404,52.4154435 114.945201,52.4218037 C114.095964,52.4285615 113.237592,52.4361143 112.370084,52.4448596 C111.600687,52.4524124 110.822949,52.4623503 110.038061,52.4718907 C109.253173,52.4822261 108.463518,52.4893814 107.668302,52.493754 C106.873484,52.4985242 106.073899,52.4997168 105.269548,52.4973317 C104.465593,52.4953441 103.65727,52.4893814 102.844974,52.480636 C102.033076,52.4710957 101.216411,52.4591702 100.394582,52.4480398 C99.6430594,52.4377043 98.8867704,52.4293565 98.1253177,52.4229963 C97.363865,52.4170335 96.5968513,52.4134559 95.8250711,52.4122634 C95.0532909,52.4110708 94.2787303,52.4102758 93.5013891,52.4094807 C92.7244452,52.4086857 92.7387448,52.4078907 91.9566371,52.4074932 C91.173735,52.4066981 90.3880524,52.4063006 89.6003838,52.4059031 C88.812318,52.4051081 88.0218689,52.4051081 87.2302282,52.4051081 C86.4381902,52.4051081 85.6445635,52.4055056 84.8485534,52.4059031 C84.4509456,52.4059031 84.0525434,52.4063006 83.6537439,52.4066981 C83.2549445,52.4070957 82.8557478,52.4082882 82.4545651,52.4102758 C82.1248803,52.4122634 81.7920179,52.416636 81.4599498,52.4194186 C81.4682912,52.5335056 81.4722633,52.6499776 81.4758382,52.7664497 C81.4762354,52.7724124 81.4770298,52.7783752 81.4770298,52.7847354 C81.4941099,53.2152447 81.5350226,53.645754 81.5636218,54.0778534 C81.5914265,54.5103503 81.6069177,54.9432447 81.5691827,55.3781267 C81.9906232,55.4942012 82.4319241,55.4997665 82.8684586,55.500959 C83.3312089,55.5021516 83.791576,55.512487 84.2507515,55.5240149 C84.7103241,55.5355429 85.1691024,55.551046 85.6282778,55.5629714 C86.0874533,55.5752944 86.5478204,55.5860273 87.0109679,55.5860273 C87.6139336,55.601928 88.2168993,55.6233938 88.8214538,55.6424745 C89.4260084,55.6619528 90.0317545,55.679046 90.639884,55.6877913 C91.8831531,55.706872 92.3474923,55.6822261 93.6078416,55.6567851 C94.8681908,55.6317416 96.1261568,55.6078907 97.3678371,55.615841 C98.203171,55.6206112 99.0377105,55.6361143 99.8694695,55.653605 C100.702023,55.6710957 101.532193,55.6873938 102.358391,55.6961391 C103.184986,55.704487 104.008007,55.6997168 104.827055,55.6814311 C105.645706,55.6603627 106.461179,55.6309466 107.273475,55.5919901 C108.331644,55.5983503 109.385841,55.6055056 110.432888,55.6174311 C111.218174,55.6257789 111.996309,55.6381019 112.770075,55.6508224 C113.543842,55.6635429 114.316019,55.6742758 115.087402,55.6782509 C115.858785,55.6818286 116.632948,55.6766609 117.411481,55.6639404 C118.190411,55.6512199 118.973313,55.6329342 119.760187,55.6114683 C120.345676,55.5955677 120.93315,55.5812571 121.521816,55.5705242 C122.110483,55.5605863 122.700738,55.5534311 123.292581,55.5530335 C123.884425,55.5530335 124.478652,55.5582012 125.074468,55.5717168 C125.670284,55.5852323 126.267689,55.6059031 126.867874,55.6341267 C127.163001,55.6464497 127.458526,55.6579776 127.754448,55.6679155 C128.05037,55.6782509 128.345895,55.6854062 128.641816,55.6889839 C128.937341,55.6925615 129.233263,55.693754 129.529185,55.6925615 C129.825107,55.6913689 130.121426,55.6889839 130.417745,55.6850087 C130.714859,55.679841 131.012369,55.6734807 131.309086,55.6663255 C131.606199,55.6587727 131.902518,55.6512199 132.199235,55.6440646 C132.495951,55.6365118 132.792667,55.6305491 133.089781,55.6257789 C133.386894,55.6210087 133.684802,55.6182261 133.983107,55.6178286 C134.387071,55.6170335 134.791431,55.6182261 135.19738,55.6222012 C135.602932,55.6269714 136.010073,55.6341267 136.418406,55.641282 C136.826738,55.6492323 137.237057,55.6555925 137.647772,55.6619528 C138.058488,55.6679155 138.469204,55.6718907 138.877536,55.6738783 C139.285869,55.6762634 139.689435,55.6770584 140.089029,55.6794435 C140.48902,55.6818286 140.885833,55.6850087 141.279866,55.6881888 C141.673899,55.6917665 142.06674,55.6949466 142.459979,55.6989217 C142.854012,55.7021019 143.254797,55.706872 143.665513,55.7124373 C144.075832,55.717605 144.494094,55.7203876 144.910768,55.7199901 C145.118907,55.7199901 145.325059,55.7187975 145.530417,55.7164124 C145.735775,55.7136298 145.945899,55.7088596 146.16079,55.7017043 C146.375681,55.6913689 146.592558,55.679841 146.811024,55.6663255 C147.02949,55.6528099 147.246764,55.6384994 147.459271,55.6241888 C147.671382,55.6098783 147.877931,55.5959652 148.076934,55.5828472 C148.275936,55.5697292 148.465803,55.5574062 148.647328,55.5470708 C148.86063,55.5343503 148.812171,55.3280398 148.81376,55.1785739 C148.815746,54.9877665 148.847522,54.7965615 148.907501,54.6148969 C148.921801,54.5723627 148.938881,54.5274435 148.973835,54.4992199 C149.009187,54.4698037 149.056852,54.4618534 149.102929,54.4554932 C149.566871,54.3891081 150.033991,54.3553193 150.501905,54.3561143 C150.658008,54.3561143 150.814112,54.3600894 150.970216,54.3680398 C151.240716,54.3823503 151.511614,54.3934807 151.783306,54.4034186 C152.054601,54.4133565 152.327087,54.4209093 152.599177,54.426077 C152.871663,54.4316422 153.143355,54.4336298 153.411075,54.4324373 C153.645032,54.4316422 153.878592,54.4256795 154.111357,54.4169342 C154.343726,54.4081888 154.575299,54.399841 154.805681,54.3950708 C154.959402,54.3922882 155.112725,54.3906981 155.265254,54.3906981 C155.41818,54.3903006 155.569915,54.3906981 155.717677,54.3914932 C155.865837,54.3922882 156.008832,54.3934807 156.149048,54.3958658 C156.209821,54.3966609 156.274963,54.3954683 156.31389,54.349754 C156.344078,54.3143752 156.351625,54.2599155 156.356789,54.2074435 C156.383799,53.9609839 156.401674,53.708959 156.417959,53.4509714 C156.433848,53.1933814 156.451325,52.9314186 156.474363,52.6678658 C156.489457,52.4917665 156.508921,52.3164621 156.530767,52.1407602 C156.5546,51.9658534 156.580418,51.7905491 156.607032,51.6152447 C156.634042,51.4407354 156.661847,51.2666236 156.690446,51.0960894 C156.734139,50.8384994 156.776243,50.5824994 156.827881,50.3296795 C156.877929,50.0768596 156.939497,49.8276174 157.022911,49.5871205 C156.84218,49.5290832 156.636028,49.4941019 156.41359,49.4813814",id:"Fill-81",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:79}}),_react2.default.createElement("path",{d:"M187.89678,31.5461963 C187.864209,31.4686807 187.831638,31.3903702 187.799464,31.3120596 C187.669576,30.9972273 187.541277,30.6804075 187.395898,30.3723329 C187.24893,30.0606807 187.094018,29.7486311 186.933942,29.4349913 C186.738117,29.0529789 186.539114,28.6693764 186.342098,28.2849789 C186.145479,27.9001839 185.955215,27.5145938 185.778059,27.1286062 C185.689481,26.9350161 185.603286,26.7422211 185.517489,26.5498236 C185.431691,26.3566311 185.346291,26.1642335 185.260891,25.9726311 C185.17549,25.7810286 185.089296,25.5902211 185.001909,25.4002087 C184.914126,25.2101963 184.826342,25.0209789 184.73697,24.832954 C184.647597,24.6453267 184.558225,24.4588919 184.467661,24.2736497 C184.377494,24.0884075 184.286533,23.9047553 184.195175,23.7222957 C184.103419,23.5394385 184.011266,23.3581714 183.917524,23.1780969 C183.824577,22.9984199 183.730041,22.8195379 183.634313,22.642246 C183.523094,22.4367304 183.414259,22.2300224 183.305423,22.0229168 C183.197382,21.8154137 183.090135,21.606718 182.984477,21.3976248 C182.560256,20.5604571 182.155895,19.7137491 181.74796,18.8837366 C181.137447,17.6490534 180.51621,16.4739975 179.782959,15.4531776 C179.031834,14.4057242 178.142877,13.7363081 177.114101,13.3069913 C176.085723,12.878072 174.898858,12.6805068 173.57138,12.5847056 C172.693544,12.5215006 171.78711,12.4841342 170.863198,12.4610783 C169.938889,12.4384199 169.008224,12.430072 168.076368,12.4237118 C167.143321,12.4165565 166.20352,12.4129789 165.258159,12.4046311 C164.309223,12.3958857 163.357109,12.3911155 162.403009,12.3823702 C161.2936,12.3736248 160.182999,12.3616994 159.070015,12.3537491 C157.956634,12.3450037 156.844047,12.3414261 155.735035,12.3489789 C154.903276,12.3545441 154.075489,12.3628919 153.251674,12.3732273 C152.977202,12.3764075 152.702729,12.3799851 152.429448,12.3839602 C151.930155,12.390718 151.424506,12.3998609 150.898996,12.4105938 C150.63644,12.416159 150.36872,12.4225193 150.097822,12.428482 C149.826925,12.4352398 149.553247,12.4416 149.277582,12.4487553 C149.277582,12.4209292 149.28076,12.3938981 149.279568,12.3656745 C149.271624,12.1188174 148.825159,12.1216 148.834295,12.3684571 C148.835884,12.4074137 148.833501,12.4467677 148.834693,12.4857242 C148.702421,12.5544944 148.706791,12.7286062 148.838665,12.7945938 C148.839459,13.080805 148.828337,13.3678112 148.812052,13.6556124 C148.795766,13.9434137 148.774317,14.2316124 148.753264,14.5206062 C148.727048,14.8811528 148.699244,15.2420969 148.680972,15.6026435 C148.663495,15.9631901 148.651578,16.3233391 148.655948,16.6822957 C148.660317,17.063513 148.658331,17.445923 148.653565,17.8287304 C148.648798,18.2111404 148.643237,18.5935503 148.637676,18.9763578 C148.632512,19.3587677 148.628937,19.7419727 148.62576,20.1255752 C148.622185,20.5091776 148.619802,20.8935752 148.617021,21.2783702 C148.613843,21.8150161 148.609474,22.3520596 148.603913,22.8902957 C148.597955,23.4281342 148.591997,23.9675627 148.588025,24.5081839 C148.589216,25.0499975 148.597558,25.5926062 148.613049,26.1356124 C148.62854,26.6782211 148.650387,27.2200348 148.673822,27.7614509 C148.69686,28.3024696 148.719899,28.8422957 148.740951,29.3813267 C148.762003,29.9195627 148.780672,30.4566062 148.794177,30.9912646 C148.810065,31.6256994 148.815229,32.2589416 148.812449,32.8901963 C148.809271,33.4586435 148.800135,34.0258981 148.788219,34.5923578 C148.776303,35.1592149 148.763195,35.726072 148.75525,36.2929292 C148.747306,36.8601839 148.747703,37.4274385 148.754456,37.9954882 C148.765578,38.5639354 148.777494,39.1339727 148.788616,39.7040099 C148.799341,40.2744447 148.809668,40.8448795 148.81801,41.4153143 C148.826748,41.9861466 148.833501,42.5569789 148.836679,43.1294012 C148.840254,43.7014261 148.838665,44.275041 148.834693,44.850246 C148.831118,45.4246559 148.826748,46.0002584 148.823571,46.5762584 C148.820393,47.1518609 148.821187,47.7266683 148.828337,48.3006807 C148.83509,48.8754882 148.848595,49.4491031 148.868058,50.0215255 C148.871633,50.1300472 148.958622,50.2115379 149.069841,50.2127304 C149.481351,50.2182957 149.892862,50.2143205 150.303975,50.2035876 C150.715088,50.1920596 151.125406,50.1737739 151.53493,50.150718 C151.944057,50.1268671 152.353184,50.0986435 152.769461,50.0739975 C153.186135,50.0497491 153.612342,50.0322584 154.036165,50.0215255 C154.469919,50.0096 154.981129,50.0537242 155.441099,50.0362335 C155.634144,50.0286807 155.825202,50.0203329 156.014671,50.0131776 C156.20136,50.0052273 156.385666,49.998072 156.568383,49.9952894 C156.673644,49.9936994 156.781288,49.9901217 156.874632,49.9360596 C156.976715,49.8764323 157.104617,49.318718 157.168568,49.1859478 C157.241655,49.0325068 157.318714,48.8806559 157.39895,48.730395 C157.47879,48.5801342 157.561807,48.4310658 157.64681,48.2831901 C157.729827,48.1388919 157.815624,47.9957863 157.903408,47.8538733 C157.991191,47.7123578 158.081358,47.5724323 158.174703,47.4352894 C158.268047,47.2973516 158.364172,47.1617988 158.463077,47.0282335 C158.56238,46.8946683 158.664463,46.7634882 158.769327,46.6342957 C159.288084,45.9966807 159.875161,45.4143205 160.518245,44.902718 C160.856271,44.6339975 161.219322,44.4109913 161.569662,44.1613516 C161.881472,43.9395379 162.140453,43.6966559 162.487218,43.5086311 C162.908261,43.2808547 163.350754,43.1015752 163.810327,42.9628422 C164.270694,42.8233143 164.751318,42.7203578 165.249421,42.6523826 C165.747523,42.5939478 166.263102,42.5748671 166.795761,42.597923 C167.061893,42.6094509 167.33279,42.6265441 167.605674,42.650395 C167.878955,42.6734509 168.154222,42.7032646 168.429886,42.7402335 C168.707139,42.7740224 168.983597,42.8133764 169.256878,42.8563081 C169.530556,42.8996373 169.801057,42.9473391 170.065996,43.0014012 C170.330936,43.0558609 170.589123,43.1170783 170.84016,43.1866435 C171.0908,43.2566062 171.335481,43.3345193 171.573411,43.4219727 C171.81134,43.5094261 172.043708,43.6068174 172.270912,43.7157366 C172.498117,43.8250534 172.722144,43.9455006 172.941404,44.0746932 C173.196413,44.224159 173.443081,44.3859478 173.688557,44.5604571 C173.951908,44.7472894 174.144158,45.0227677 174.368979,45.2692273 C174.610483,45.5339727 174.863109,45.7935503 175.118515,46.0571031 C175.372333,46.3182708 175.62615,46.5830161 175.869243,46.8588919 C176.112336,47.1355627 176.342321,47.4245565 176.548473,47.7326311 C176.820563,48.139687 177.044589,48.5729789 177.243195,49.0126311 C177.330184,49.2062211 177.393737,49.4153143 177.481918,49.6045317 C177.564538,49.7818236 177.657883,49.9261217 177.699987,50.1125565 C177.73375,50.2608298 177.834244,50.4536248 177.769896,50.6022957 C178.392722,50.5216 179.033026,50.5498236 179.659824,50.5375006 C180.062198,50.5299478 180.46497,50.5291528 180.86655,50.5299478 C181.267732,50.5303453 181.666532,50.5311404 182.062154,50.5287553 C182.457378,50.5263702 182.851411,50.5235876 183.246238,50.5196124 C183.641463,50.5156373 184.036688,50.5112646 184.431912,50.5041093 C184.827137,50.496954 185.222361,50.4878112 185.615997,50.4746932 C185.720463,50.4711155 185.825724,50.4671404 185.93019,50.4603826 C186.034657,50.4536248 186.137932,50.444482 186.23922,50.4297739 C186.306746,50.419836 186.373477,50.4079106 186.439017,50.3924075 C186.50416,50.3769043 186.568508,50.3586186 186.63087,50.3363578 C186.694026,50.3136994 186.7548,50.2874634 186.813587,50.2560596 C186.868005,50.227836 186.922025,50.1940472 186.952213,50.1411776 C186.980018,50.0922832 186.983593,50.0338484 186.987168,49.9770037 C186.992729,49.8851776 186.997098,49.7933516 187.001865,49.7023205 C187.006631,49.6108919 187.010603,49.5202584 187.013384,49.4288298 C187.016164,49.3377988 187.018945,49.2459727 187.021328,49.1533516 C187.023711,49.0607304 187.026095,48.9673143 187.027683,48.8735006 C187.029272,48.779687 187.031258,48.6850783 187.033244,48.590072 C187.03523,48.4946683 187.037614,48.3988671 187.040394,48.3018733 C187.043175,48.2056745 187.046352,48.1082832 187.051119,48.0100969 C187.056283,47.9119106 187.061049,47.8133267 187.067007,47.7147429 C187.072568,47.616159 187.078129,47.5171776 187.081704,47.4185938 C187.085676,47.3200099 187.086868,47.2218236 187.086471,47.1244323 C187.085279,47.0274385 187.082896,46.9308422 187.079321,46.8338484 C187.075746,46.7372522 187.071377,46.6406559 187.067007,46.5444571 C187.062638,46.4482584 187.058269,46.3528547 187.053899,46.2578484 C187.050324,46.1628422 187.047147,46.0674385 187.044763,45.9720348 C187.042777,45.8766311 187.041189,45.7812273 187.0396,45.6850286 C187.038408,45.5892273 187.036819,45.4934261 187.03523,45.3972273 C187.032847,45.2763826 187.030464,45.1555379 187.027683,45.0350907 C187.024506,44.914246 187.020136,44.7934012 187.015767,44.672954 C187.011398,44.5529043 187.00822,44.4324571 187.004645,44.3120099 C186.969691,42.9886807 186.992332,41.6677366 186.981607,40.3412273 C186.978826,39.9528547 186.970485,39.566072 186.955788,39.179687 C186.941886,38.7929043 186.929572,38.4065193 186.927586,38.0205317 C186.924806,37.6341466 186.930367,37.248954 186.938311,36.8637615 C186.946255,36.4789665 186.951816,36.0945689 186.949433,35.7117615 C186.947447,35.3806311 186.942283,35.0495006 186.93553,34.7179727 C186.928778,34.3868422 186.921231,34.0553143 186.914876,33.7233888 C186.90852,33.3874882 186.902959,33.0507925 186.900973,32.7133019 C186.899782,32.5487304 186.910109,32.3813764 186.897001,32.216805 C186.889454,32.1162335 186.845364,31.962395 186.912095,31.8737491 C186.958966,31.8129292 187.046749,31.8077615 187.123014,31.807364 C187.338302,31.8061714 187.551604,31.8232646 187.767687,31.8192894 C187.807011,31.8188919 187.849512,31.8180969 187.882878,31.7954385 C187.958348,31.744159 187.931735,31.6288795 187.89678,31.5461963",id:"Fill-83",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:80}}),_react2.default.createElement("path",{d:"M183.546093,30.298554 C183.642615,30.8451379 183.607263,31.3674733 182.978876,31.6461317 C182.693679,31.7725416 182.349694,31.8413118 181.994985,31.8842435 C181.639482,31.9275727 181.274445,31.9446658 180.944761,31.9673242 C180.59879,31.9915727 180.254011,32.0058832 179.91241,32.0138335 C179.570809,32.0221814 179.234372,32.0241689 178.903495,32.0233739 C178.573016,32.0225789 178.250878,32.0182062 177.937876,32.0150261 C177.624874,32.0122435 177.318625,32.0110509 177.017142,32.0166161 C176.68706,32.0229764 176.355389,32.0333118 176.022924,32.0416596 C175.025528,32.0639205 174.018202,32.0674981 173.046625,31.8663553 C171.765224,31.6016099 170.962858,30.7306534 170.115608,29.7964919 C169.268358,28.8619329 168.343254,28.0132373 167.45668,27.1172373 C166.589967,26.2419081 165.844005,25.2222807 164.614638,24.8525913 C163.430951,24.4960199 162.147166,24.6737093 160.931304,24.6733118 C159.657053,24.6729143 158.353408,24.7639453 157.084717,24.6307776 C155.953858,24.511523 154.718136,24.1207652 154.052808,23.1325416 C153.336241,22.067995 153.388275,20.6933863 153.358882,19.4650634 C153.342993,18.802405 153.337035,18.1393491 153.346171,17.4762932 C153.35054,17.1435727 153.358882,16.8108522 153.371195,16.4781317 C153.383509,16.1462062 153.329885,15.8929888 153.667117,15.7622062 C154.182696,15.5626534 154.794798,15.7053615 155.333018,15.6882683 C156.00351,15.6672 156.669235,15.6373863 157.340521,15.6429516 C159.974424,15.6644174 162.60515,15.8277963 165.239053,15.8639702 C166.606649,15.8826534 167.961138,15.8735106 169.322776,16.0178087 C169.942821,16.0830012 170.588289,16.0877714 171.196418,16.2249143 C171.858171,16.3739826 172.48338,16.6693366 173.079593,16.9853615 C174.1751,17.5653366 175.172099,18.2128894 176.023718,19.1232 C176.918634,20.0796224 177.647118,21.1779578 178.41294,22.2365416 C178.703698,22.6380323 178.990882,23.0419081 179.276476,23.4477714 C179.56207,23.8532373 179.845282,24.2602932 180.127698,24.6673491 C180.314784,24.9396472 180.501473,25.2127404 180.686971,25.4870261 C180.855388,25.7354733 181.015067,25.9926658 181.17554,26.251846 C181.33641,26.5114236 181.499266,26.7725913 181.666889,27.032964 C181.833718,27.2929391 182.003724,27.5533118 182.177305,27.8105043 C182.350092,28.0680944 182.526056,28.3229019 182.704403,28.5737342 C182.898242,28.8460323 183.080165,29.1223056 183.228721,29.4077217 C183.377675,29.6927404 183.491278,29.9876969 183.546093,30.298554",id:"Fill-85",fill:"#28C4D4",__source:{fileName:_jsxFileName,lineNumber:81}}),_react2.default.createElement("path",{d:"M185.288934,46.6459826 C185.410083,46.6396224 185.545532,46.6567155 185.6782,46.6638708 C185.810868,46.6706286 185.941551,46.6670509 186.050784,46.6197466 C186.171138,46.567672 186.22794,46.4718708 186.256141,46.3581814 C186.283946,46.2444919 186.283152,46.1129143 186.286329,45.9896845 C186.289507,45.8521441 186.291096,45.7150012 186.292288,45.5774609 C186.293876,45.439523 186.295863,45.3011876 186.298643,45.1624547 C186.301423,45.0229267 186.305793,44.8830012 186.311354,44.7422807 C186.317312,44.6011627 186.324859,44.4592497 186.332406,44.3173366 C186.341542,44.134082 186.347897,43.9520199 186.347897,43.7779081 C186.347897,43.6037963 186.339953,43.4396224 186.327639,43.2833988 C186.317312,43.1422807 186.320887,43.0087155 186.320887,42.8779329 C186.320887,42.7479453 186.318504,42.6199453 186.295465,42.4907528 C186.280371,42.406082 186.248992,42.3098832 186.150483,42.2681441 C186.10401,42.2482683 186.049989,42.2450882 185.998352,42.2431006 C185.741754,42.2335602 185.490717,42.2693366 185.238091,42.2542311 C185.060538,42.2438957 184.886162,42.2347528 184.715759,42.2295851 C184.545355,42.2240199 184.37813,42.2216348 184.212493,42.2228273 C184.046856,42.2236224 183.882411,42.227995 183.717966,42.2331627 C183.553123,42.2399205 183.388678,42.2458832 183.225027,42.2482683 C182.952938,42.2530385 182.682835,42.2566161 182.410348,42.2582062 C182.137465,42.2597963 181.857829,42.2601938 181.570248,42.2629764 C181.452674,42.2637714 181.32795,42.2653615 181.224278,42.3086907 C180.986348,42.4088646 181.059038,42.7213118 181.056655,42.9037714 C181.055066,43.046877 181.052285,43.1951503 181.054669,43.3525665 C181.057846,43.5505292 181.056258,43.7552497 181.05308,43.9703056 C181.049902,44.1861565 181.045136,44.4123429 181.041164,44.6436969 C181.039177,44.8750509 181.034808,45.1052124 181.029247,45.3337839 C181.024083,45.5619578 181.016139,45.7897342 181.010578,46.0179081 C181.005415,46.2103056 181.007401,46.4297342 181.140466,46.5410385 C181.232222,46.6181565 181.362507,46.6213366 181.483656,46.6221317 C181.687425,46.6237217 181.884839,46.6384298 182.083841,46.6531379 C182.283241,46.6674484 182.484627,46.681759 182.694354,46.681759 C182.833775,46.6861317 182.977168,46.6877217 183.121753,46.6881193 C183.266337,46.6889143 183.412908,46.6885168 183.557493,46.6893118 C183.70168,46.6901068 183.842293,46.6916969 183.974961,46.6960696 C184.126695,46.7012373 184.275649,46.7000447 184.422617,46.695672 C184.569585,46.6909019 184.714964,46.6829516 184.859549,46.6734112 C185.004134,46.6642683 185.147924,46.6535354 185.288934,46.6459826",id:"Fill-87",fill:"#D6DE23",__source:{fileName:_jsxFileName,lineNumber:82}}),_react2.default.createElement("g",{id:"Group-91",transform:"translate(0.000000, 3.316472)",__source:{fileName:_jsxFileName,lineNumber:83}},_react2.default.createElement("mask",{id:"mask-10",fill:"white",__source:{fileName:_jsxFileName,lineNumber:84}},_react2.default.createElement("use",{xlinkHref:"#path-9",__source:{fileName:_jsxFileName,lineNumber:85}})),_react2.default.createElement("g",{id:"Clip-90",__source:{fileName:_jsxFileName,lineNumber:87}}),_react2.default.createElement("path",{d:"M149.06714,43.4242385 C149.061976,42.5043876 149.049663,41.5014559 149.0302,40.4321391 C149.010339,39.3628224 148.985712,38.2271205 148.959893,37.0401391 C148.947183,36.447046 148.935266,35.8412323 148.924939,35.2242882 C148.914214,34.6077416 148.905873,33.9800646 148.899915,33.3440398 C148.893162,32.5494062 148.88919,31.7404621 148.887998,30.9227727 C148.887204,30.1046857 148.887204,29.2770584 148.887204,28.4438658 C148.887204,27.6110708 148.886807,26.7719155 148.888395,25.9307727 C148.889984,25.0896298 148.89634,24.2449093 148.907064,23.4005863 C148.917392,22.5566609 148.9305,21.713928 148.945594,20.8763627 C148.960688,20.039195 148.976179,19.2079901 148.991273,18.386723 C149.006367,17.5654559 149.020269,16.7549217 149.031788,15.9594932 C149.043308,15.1636671 149.052046,14.3833441 149.057607,13.6217043 C149.061976,12.9260522 149.063963,12.2463006 149.063565,11.5852323 C149.061976,10.924959 149.05999,10.2825739 149.058004,9.66046211 C149.056018,9.03874783 149.053635,8.43810186 149.050457,7.86130683 C149.044102,6.70811429 149.037747,5.65151801 149.030597,4.71497143 C149.023447,3.77842484 149.016694,2.96272298 149.010339,2.29092174 C149.007956,1.95581615 148.99882,1.61991553 149.001998,1.28480994 C149.005175,0.978722981 149.134269,0.603070807 149.008353,0.310896894 C148.991273,0.271145342 148.968235,0.232586335 148.934075,0.206350311 C148.885218,0.169381366 148.82087,0.161431056 148.759699,0.157058385 C148.481255,0.136387578 148.204796,0.170971429 147.927146,0.167791304 C147.22885,0.159443478 146.197691,0.148313043 144.867433,0.136387578 C143.977284,0.131219876 142.950891,0.12724472 141.797392,0.128039752 C141.220642,0.128834783 140.612513,0.132412422 139.973401,0.137580124 C139.335083,0.143542857 138.666181,0.151890683 137.969473,0.161431056 C137.272369,0.171368944 136.546665,0.182896894 135.793951,0.196014907 C135.040442,0.209132919 134.260321,0.223443478 133.453983,0.238151553 C132.807722,0.252462112 132.145571,0.265182609 131.469122,0.277108075 C130.792672,0.28903354 130.10232,0.301754037 129.39886,0.313679503 C128.695797,0.325604969 127.979627,0.336735404 127.251937,0.346275776 C126.524247,0.355418634 125.784244,0.362971429 125.029544,0.369331677 C124.275241,0.376089441 123.506241,0.382449689 122.722942,0.388014907 C121.939642,0.393580124 121.143235,0.396760248 120.33372,0.397952795 C119.524602,0.398747826 118.702376,0.39755528 117.867439,0.394375155 C117.033297,0.391195031 116.186444,0.385629814 115.328866,0.379269565 C114.472083,0.372511801 113.605369,0.365356522 112.729917,0.356213665 C111.952576,0.349058385 111.167688,0.338722981 110.37565,0.328785093 C109.583612,0.318847205 108.786013,0.311691925 107.983251,0.306921739 C107.180885,0.302549068 106.373753,0.301754037 105.561855,0.303344099 C104.749956,0.305729193 103.933689,0.311691925 103.114243,0.320437267 C102.294003,0.32997764 101.469791,0.341903106 100.640018,0.35303354 C99.8817433,0.363368944 99.1179073,0.37171677 98.3493048,0.378077019 C97.5807023,0.384039752 96.8065388,0.387617391 96.0272116,0.388809938 C95.2482816,0.390002484 94.4661739,0.390797516 93.6812858,0.391592547 C92.8971921,0.392387578 92.1095235,0.393182609 91.3194716,0.393580124 C90.5294197,0.39397764 89.7365873,0.394772671 88.9409745,0.395170186 C88.1453617,0.395567702 87.3477628,0.395965217 86.5481779,0.395965217 C85.7489901,0.395965217 84.9474191,0.395567702 84.1442593,0.395170186 C83.3407023,0.394772671 82.5359536,0.39397764 81.7296161,0.393182609 C80.9224841,0.392387578 80.1133661,0.389604969 79.3022621,0.383642236 C78.4907608,0.377679503 77.6768763,0.368934161 76.8618002,0.358996273 C76.0463268,0.34866087 75.2296618,0.336735404 74.413394,0.324412422 C73.596729,0.312486957 72.780064,0.300163975 71.9645907,0.288636025 C71.1487201,0.27750559 70.3340412,0.267567702 69.5221427,0.259219876 C68.709847,0.251269565 67.8999346,0.245704348 67.0939943,0.243319255 C66.288054,0.240934161 65.4837025,0.240934161 64.6821315,0.240934161 L50.4723196,0.240934161 C49.739466,0.240934161 49.0105845,0.241331677 48.2864696,0.241729193 C47.5623547,0.242126708 46.8434035,0.243319255 46.1284244,0.244511801 C45.4138426,0.246101863 44.7040272,0.247691925 43.998184,0.250077019 C43.292738,0.252064596 42.5916613,0.253654658 41.8953511,0.255642236 C41.1994381,0.258027329 40.5074972,0.260014907 39.8203229,0.262002484 C39.1224239,0.263990062 38.4292914,0.265580124 37.7413226,0.266772671 C37.0541483,0.268362733 36.3717405,0.269952795 35.6952908,0.273530435 C35.0192384,0.277108075 34.3487469,0.281878261 33.6846108,0.286648447 C33.0204746,0.292213665 32.3622967,0.298176398 31.7108713,0.303741615 C31.0590487,0.310101863 30.4139787,0.316462112 29.7760585,0.322027329 C29.1468769,0.327592547 28.5248451,0.332362733 27.9119491,0.335940373 C26.68576,0.343890683 25.4929366,0.347468323 24.3334788,0.345878261 C23.1740211,0.344288199 22.0467374,0.338722981 20.952025,0.329580124 C19.8577098,0.320437267 18.794377,0.308114286 17.7632183,0.294598758 C16.5751614,0.278698137 15.4307977,0.263592547 14.3329076,0.251269565 C13.2350175,0.238549068 12.1847926,0.229803727 11.1889857,0.224238509 C10.1931787,0.219070807 9.25496725,0.217480745 8.37832346,0.217878261 C7.50128245,0.218275776 6.68580909,0.218275776 5.93627269,0.218275776 C5.18673629,0.217878261 4.50313685,0.217480745 3.88944647,0.216685714 C2.9575904,0.215493168 1.98601328,0.279095652 1.06210142,0.1984 C0.451985941,0.145132919 0.187443682,0.192834783 0.0583502371,0.800636025 C-0.0767013668,1.43626335 0.0591446583,2.01902112 0.102043403,2.6482882 C0.149311464,3.34950559 0.0837717155,4.06543106 0.0809912413,4.76744348 C0.0770191353,5.70836273 0.0730470293,6.76933168 0.0690749233,7.92610186 C0.0666916597,8.50448696 0.0651028173,9.10672298 0.0639111855,9.7292323 C0.0627195537,10.3525366 0.0623223431,10.9957168 0.0627195537,11.6563876 C0.0627195537,12.3174559 0.0631167643,12.9964124 0.0631167643,13.690077 L0.0631167643,15.8140025 L0.0631167643,40.698872 C0.0631167643,43.2215056 0.206907001,45.7580522 0.193401841,48.2258286 C0.192210209,48.442077 0.196976736,48.6766112 0.330042287,48.8467478 C0.627155816,49.2275677 1.60627994,49.2283627 2.0618805,49.3448348 C2.4253282,49.4378534 2.76017674,49.4585242 3.1335547,49.4605118 C3.63880658,49.4628969 3.74684787,49.4605118 4.25249696,49.4605118 C4.25249696,49.4605118 5.08822806,49.4605118 6.18214605,49.453754 C6.72910505,49.4501764 7.32770142,49.4362634 7.91795637,49.4167851 C8.50821132,49.3973068 9.09369975,49.3746484 9.61523727,49.3531826 C10.6575179,49.311046 11.4463781,49.2792447 11.4463781,49.2792447 C11.4837159,48.8721888 11.5496529,48.4742758 11.642203,48.0866981 C11.734753,47.698723 11.8531218,47.3186981 11.9945288,46.9450335 C12.1363329,46.5717665 12.3015726,46.2048596 12.4882615,45.8463006 C12.6753477,45.4873441 12.8834861,45.137928 13.1130738,44.7976547 C13.2656027,44.5714683 13.4276646,44.3492571 13.5972735,44.1330087 C13.7676769,43.9163627 13.9464216,43.7056795 14.1327134,43.500164 C14.3194024,43.2954435 14.512844,43.0962882 14.7134353,42.9082634 C14.9140267,42.7202385 15.1217678,42.5433441 15.3362615,42.3755925 C15.5511525,42.2082385 15.7743848,42.0496298 16.0059586,41.900164 C16.2375324,41.7506981 16.4774476,41.6091826 16.7268958,41.4768099 C16.9759469,41.3464248 17.234531,41.2283627 17.5018537,41.1222261 C17.7687792,41.016487 18.0448406,40.9210832 18.328449,40.8344248 C18.6124546,40.7485615 18.9032127,40.6702509 19.1987374,40.6002882 C19.4942621,40.5303255 19.7949505,40.467518 20.0988166,40.4114683 C20.4026827,40.3554186 20.7085349,40.3061267 21.0135926,40.2639901 C21.3190476,40.2218534 21.6245025,40.186077 21.9287659,40.1586484 C22.232632,40.1304248 22.5321288,40.1125366 22.826859,40.1085615 C23.1211921,40.1045863 23.4103614,40.1157168 23.694367,40.1435429 C24.1706225,40.1908472 24.6294007,40.2735304 25.0703045,40.3900025 C25.5112083,40.5064745 25.9397985,40.659518 26.3540891,40.8495304 C26.7679826,41.0403379 27.1695625,41.2673193 27.5520763,41.5241143 C27.9345901,41.7805118 28.298435,42.0655304 28.641625,42.375195 C28.9844177,42.6844621 29.3101304,43.0183752 29.6143938,43.3777292 C29.7665254,43.5570087 29.9130961,43.743841 30.0541059,43.9370335 C30.1951156,44.1302261 30.32977,44.3305739 30.4580691,44.5392696 C30.6828903,44.9065739 30.891823,45.280636 31.0880451,45.6558907 C31.2882392,46.0267727 31.4761198,46.4000398 31.653673,46.7733068 C31.8316233,47.1453814 31.9976574,47.5210335 32.1509806,47.9006609 C32.3003318,48.2779031 32.4306169,48.6571329 32.5450136,49.0323876 C32.5688462,49.1095056 32.5934732,49.1898037 32.6184975,49.2712944 C32.6184975,49.2712944 32.7920785,49.2752696 33.1189829,49.2812323 C33.3533371,49.285605 34.0663302,49.2907727 34.4540077,49.2951453 C34.4726766,48.8682137 34.5386136,48.4341267 34.6422855,47.9928845 C34.7455603,47.5512447 34.8861728,47.1064248 35.0545901,46.6659776 C35.2226102,46.225928 35.4208183,45.7914435 35.6440507,45.3688845 C35.8116735,45.0516671 35.9939932,44.7412075 36.1874348,44.4402882 C36.3808763,44.1385739 36.5850426,43.8460025 36.7975502,43.5621764 C37.0100579,43.2779528 37.2301126,43.0024745 37.455331,42.7377292 C37.6801522,42.4725863 37.9093427,42.2177789 38.138136,41.9713193 C38.4876813,41.5944745 38.858676,41.2414807 39.2475452,40.915518 C39.6372088,40.5891578 40.0467329,40.2997665 40.4733371,40.056487 C40.9003385,39.813605 41.34442,39.6148472 41.8016094,39.4578286 C42.259196,39.3012075 42.7290961,39.1835429 43.2121042,39.1004621 C43.6947151,39.0177789 44.1952004,38.9633193 44.7083965,38.9343006 C45.2215926,38.905282 45.7451162,38.9001143 46.2694342,38.9199901 C46.8183792,38.9374807 47.3589829,39.0054559 47.8789315,39.121928 C48.398483,39.2387975 48.90016,39.4069466 49.3819765,39.6271702 C49.8637929,39.8473938 50.3301182,40.1200894 50.7793633,40.4257789 C51.229403,40.7286857 51.6663346,41.0594186 52.0881723,41.4080398 C52.5096127,41.7562634 52.9171508,42.1227727 53.3044311,42.5004124 C53.6917115,42.8780522 54.0591313,43.2692075 54.3947742,43.667518 C54.6283341,43.9449839 54.843225,44.2315925 55.0370638,44.5277416 C55.231697,44.8238907 55.4032919,45.1295801 55.5546292,45.4420273 C55.705172,45.754077 55.8370459,46.074077 55.9510454,46.3992447 C56.1222431,46.8877913 56.2545143,47.391046 56.3510364,47.903046 C56.448353,48.4154435 56.5083318,48.9361888 56.5337533,49.4605118 L57.5792116,49.4605118 L58.6246699,49.4605118 C58.7164256,48.8678161 58.8351915,48.2830708 59.0008283,47.7138286 C59.1660679,47.1445863 59.3761924,46.5900522 59.6403374,46.0534062 C59.7372568,45.7465242 59.8460925,45.4440149 59.9668445,45.1466733 C60.0875965,44.8489342 60.2198677,44.5567602 60.3644523,44.2701516 C60.509037,43.9835429 60.6651408,43.7028969 60.8347497,43.4317913 C61.0047558,43.1602882 61.1882671,42.9026981 61.3856808,42.6594186 C61.6494286,42.3354435 61.9382007,42.0341267 62.2547776,41.7538783 C62.6027341,41.4442137 62.9594292,41.1611826 63.3240685,40.9008099 C63.689105,40.6412323 64.0616886,40.4059031 64.4422163,40.2027727 C64.8223469,39.9996422 65.2104216,39.8255304 65.605249,39.6764621 C66.0000763,39.5273938 66.4024507,39.4021764 66.8131664,39.301605 C67.2238822,39.2010335 67.6437338,39.1270957 68.070338,39.0793938 C68.4973394,39.0316919 68.9295045,39.0102261 69.3676278,39.0138037 C69.7910543,38.9875677 70.2252055,38.9951205 70.673259,39.0452075 C71.2134654,39.1060273 71.7512886,39.1922882 72.2815647,39.3091578 C72.8110465,39.443518 73.3226537,39.6061019 73.8096339,39.7945242 C74.2966141,39.9829466 74.7629394,40.197605 75.2082124,40.440487 C75.6546772,40.6837665 76.0812813,40.9501019 76.4908055,41.2438658 C76.9007268,41.5376298 77.2947597,41.8580273 77.6693293,42.2138037 C78.0486654,42.5679901 78.4109215,42.964313 78.7560975,43.410723 C78.9570861,43.6703006 79.1628412,43.9477665 79.3674046,44.2415304 C79.5727625,44.5352944 79.7761343,44.8461516 79.971562,45.1725118 C80.1669896,45.4992696 80.3520897,45.842723 80.520507,46.1977043 C80.6885271,46.5526857 80.8402615,46.9148224 80.971341,47.2813317 C81.1028177,47.647841 81.2112562,48.018723 81.2934788,48.391195 C81.3753042,48.7636671 81.4301193,49.1381267 81.4567324,49.5109963 C81.8825421,49.5018534 82.3107352,49.4931081 82.7496529,49.4839652 C83.1730794,49.4756174 83.6056417,49.4688596 84.0477371,49.4648845 C84.4898325,49.4609093 84.9394749,49.4601143 85.3895145,49.4605118 L86.8480719,49.4605118 L105.497904,49.4605118 C106.311788,49.4605118 107.119318,49.4609093 107.920094,49.4609093 C108.721268,49.4613068 109.516484,49.4621019 110.304549,49.4648845 C111.092615,49.4680646 111.873928,49.4724373 112.647695,49.4768099 C113.421858,49.4811826 114.188077,49.4855553 114.946352,49.4891329 C115.705025,49.4935056 116.457739,49.4990708 117.205289,49.5078161 C117.953237,49.516164 118.694432,49.5268969 119.428477,49.5376298 C120.162125,49.5479652 120.888226,49.5590957 121.603999,49.5694311 C122.320567,49.5797665 123.026808,49.5893068 123.721926,49.5976547 C124.417442,49.6064 125.103425,49.6135553 125.779874,49.6199155 C126.455927,49.6262758 127.121652,49.631046 127.77546,49.6346236 C128.430461,49.6385988 129.074339,49.6397913 129.708287,49.6374062 C130.461001,49.6350211 131.198224,49.6294559 131.917175,49.6219031 C132.636524,49.6139528 133.336409,49.6044124 134.017228,49.593282 C134.69765,49.581754 135.357416,49.5698286 135.995734,49.5575056 C136.633654,49.5451826 137.250522,49.5328596 137.843955,49.5221267 C139.030423,49.4994683 140.130299,49.4823752 141.138022,49.4724373 C142.146143,49.4621019 143.066082,49.4601143 143.891089,49.4597168 L146.079719,49.4597168 C146.214771,49.4597168 146.349822,49.4577292 146.484874,49.4549466 C146.620323,49.4517665 146.756169,49.4481888 146.892412,49.4442137 C147.029053,49.4402385 147.166487,49.4358658 147.303922,49.4318907 C147.37264,49.4299031 147.441357,49.428313 147.510869,49.4263255 C147.580381,49.4243379 147.650687,49.4223503 147.720993,49.4195677 C147.7913,49.4171826 147.8624,49.4147975 147.933501,49.4120149 C148.004999,49.4100273 148.076497,49.4076422 148.147598,49.4056547 C148.218698,49.4036671 148.289799,49.402077 148.360105,49.401282 C148.430412,49.4000894 148.499923,49.3996919 148.568641,49.4000894 C148.694954,49.4008845 148.806967,49.4068472 148.885218,49.3746484 C148.963865,49.3428472 149.009942,49.272487 149.00597,49.1230211 C149.003984,49.0665739 149.004778,49.0093317 149.007161,48.9501019 C149.009147,48.8912696 149.011928,48.8308472 149.014708,48.7684373 C149.017489,48.7068224 149.019872,48.6428224 149.020269,48.5776298 C149.020667,48.5124373 149.019872,48.4456547 149.019872,48.3776795 C149.019872,48.3093068 149.021064,48.2401391 149.022255,48.1713689 C149.02305,48.1029963 149.024241,48.0342261 149.025433,47.9662509 C149.026228,47.8982758 149.027816,47.8314932 149.0302,47.7663006 C149.032186,47.7007106 149.034966,47.6367106 149.037747,47.5746981 C149.041322,47.505928 149.044896,47.4363627 149.049266,47.367195 C149.053635,47.2980273 149.056813,47.2292571 149.059196,47.160487 C149.061579,47.0917168 149.063168,47.0225491 149.06436,46.9537789 C149.065551,46.8846112 149.065949,46.8154435 149.066346,46.7462758 C149.066743,46.6083379 149.066346,46.469605 149.065154,46.3316671 C149.064757,46.1941267 149.063565,46.0561888 149.064757,45.9194435 C149.070715,45.1812571 149.072304,44.3436919 149.06714,43.4242385",id:"Fill-89",fill:"#FFD300",mask:"url(#mask-10)",__source:{fileName:_jsxFileName,lineNumber:88}})),_react2.default.createElement("g",{id:"Group-94",transform:"translate(0.000000, 0.136348)",__source:{fileName:_jsxFileName,lineNumber:90}},_react2.default.createElement("mask",{id:"mask-12",fill:"white",__source:{fileName:_jsxFileName,lineNumber:91}},_react2.default.createElement("use",{xlinkHref:"#path-11",__source:{fileName:_jsxFileName,lineNumber:92}})),_react2.default.createElement("g",{id:"Clip-93",__source:{fileName:_jsxFileName,lineNumber:94}}),_react2.default.createElement("path",{d:"M0.206231743,3.59385839 C0.365513194,3.35773416 0.624097294,3.33984596 1.06182338,3.37840497 C1.98573523,3.45910062 2.95770957,3.39549814 3.88916842,3.39669068 C4.5028588,3.39748571 5.18685545,3.39788323 5.93639185,3.39828075 C6.68553105,3.39828075 7.50100441,3.39828075 8.37804541,3.39788323 C9.25468921,3.39748571 10.1932979,3.39907578 11.1887076,3.40424348 C12.1845146,3.4098087 13.2351366,3.41895155 14.3326295,3.43127453 C15.4305196,3.44359752 16.5752806,3.45870311 17.7629403,3.47460373 C18.7944962,3.48811925 19.857829,3.50083975 20.9521442,3.50958509 C22.0464594,3.51912547 23.173743,3.52429317 24.3332008,3.52588323 C25.4926585,3.52747329 26.6858792,3.52389565 27.9120683,3.51634286 C28.5249642,3.5123677 29.1465988,3.50759752 29.7757804,3.50242981 C30.4140979,3.49646708 31.0591679,3.49010683 31.7105932,3.4841441 C32.3624158,3.47818137 33.0201966,3.47221863 33.6843327,3.46705093 C34.3488661,3.46188323 35.0193575,3.45711304 35.69541,3.4535354 C36.3718596,3.45035528 37.0542674,3.4483677 37.7414418,3.44677764 C38.4294105,3.44558509 39.122543,3.44399503 39.8200449,3.44200745 C40.5076164,3.44001988 41.1991601,3.4380323 41.8954702,3.43604472 C42.5917804,3.43405714 43.2928571,3.43206957 43.9983032,3.43008199 C44.7037492,3.42769689 45.4139617,3.42610683 46.1281464,3.42451677 C46.8431255,3.42332422 47.5624739,3.42213168 48.2865888,3.42173416 C49.0103065,3.42133665 49.7391879,3.42093913 50.4724387,3.42093913 L64.6818535,3.42093913 C65.4838217,3.42093913 66.287776,3.42093913 67.0941135,3.42332422 C67.9000538,3.42570932 68.7099662,3.43127453 69.5222619,3.43922484 C70.3341603,3.44757267 71.1488393,3.45751056 71.9643126,3.46903851 C72.7801832,3.48016894 73.5968482,3.49249193 74.413116,3.50441739 C75.229781,3.51713789 76.046446,3.52866584 76.8615221,3.53900124 C77.6769955,3.54933665 78.49088,3.55768447 79.3023813,3.5636472 C80.1134853,3.56960994 80.9226033,3.57239255 81.729338,3.57318758 C82.5360727,3.57398261 83.3408214,3.57477764 84.1439813,3.57517516 C84.9475383,3.57557267 85.7487121,3.57597019 86.548297,3.57597019 C87.347882,3.57597019 88.1454808,3.57557267 88.9410937,3.57517516 C89.7363093,3.57477764 90.5295389,3.57398261 91.3195907,3.57358509 C92.1096426,3.57318758 92.896914,3.57239255 93.681405,3.57159752 C94.4662931,3.57080248 95.2480036,3.57000745 96.0269336,3.56921242 C96.8062608,3.56801988 97.5808214,3.56404472 98.3494239,3.55808199 C99.1180264,3.55211925 99.8814652,3.54337391 100.640137,3.53343602 C101.46991,3.52190807 102.294122,3.50998261 103.113965,3.50083975 C103.933808,3.49169689 104.749678,3.48613168 105.561577,3.48374658 C106.373475,3.48175901 107.180607,3.48295155 107.98337,3.48692671 C108.785735,3.49169689 109.583334,3.49924969 110.375372,3.50879006 C111.167807,3.51912547 111.952695,3.52906335 112.729639,3.53621863 C113.605091,3.54536149 114.472202,3.55251677 115.328985,3.55927453 C116.186166,3.5660323 117.033019,3.5712 117.867558,3.57438012 C118.702098,3.57756025 119.524721,3.5787528 120.333839,3.57795776 C121.143354,3.57676522 121.939761,3.57358509 122.722664,3.56841739 C123.50636,3.56245466 124.27536,3.55609441 125.029663,3.54973416 C125.783966,3.5429764 126.524366,3.53582112 127.252056,3.52628075 C127.979746,3.51713789 128.695519,3.50560994 129.398979,3.49368447 C130.102439,3.48175901 130.792791,3.46943602 131.469241,3.45711304 C132.145691,3.44518758 132.807841,3.4328646 133.454102,3.41855404 C134.260043,3.40344845 135.040561,3.38913789 135.79407,3.37601988 C136.546784,3.36290186 137.272091,3.35177143 137.969195,3.34143602 C138.6663,3.33189565 139.335202,3.32354783 139.97352,3.31798261 C140.612235,3.31241739 141.220761,3.30883975 141.797511,3.30804472 C142.950613,3.30724969 143.977006,3.31122484 144.867154,3.31679006 C146.19781,3.32831801 147.228969,3.33944845 147.927265,3.34779627 C148.204915,3.35137391 148.481374,3.31679006 148.759421,3.33706335 C148.792787,3.33944845 148.82655,3.34421863 148.858724,3.35296398 C148.891295,3.34421863 148.923866,3.33706335 148.955246,3.32394534 C148.986228,3.31162236 149.017608,3.29572174 149.03588,3.26829317 C149.054946,3.2408646 149.059315,3.20628075 149.062493,3.17328696 C149.117308,2.6342559 149.13836,2.0916472 149.125649,1.54903851 C149.119691,1.28548571 149.089106,1.01954783 149.094667,0.756790062 C149.095461,0.702330435 149.106186,0.624814907 149.102214,0.553659627 C149.096653,0.457063354 149.064082,0.371597516 148.944918,0.366032298 C148.616425,0.351324224 148.279194,0.335423602 147.926471,0.319522981 C147.572953,0.304019876 147.199972,0.288119255 146.812692,0.275001242 C146.412304,0.266255901 146.001191,0.261485714 145.580545,0.261088199 C145.159899,0.260690683 144.737664,0.263473292 144.322976,0.269038509 C143.908685,0.274206211 143.504325,0.278976398 143.10632,0.282554037 C142.709109,0.286529193 142.312693,0.289311801 141.915085,0.292491925 C141.51708,0.296069565 141.116692,0.299249689 140.712729,0.302032298 C140.309163,0.304417391 139.901625,0.305212422 139.48932,0.306802484 C139.077413,0.309187578 138.662725,0.313560248 138.248037,0.319522981 C137.833349,0.325485714 137.419456,0.332243478 137.007151,0.339796273 C136.594449,0.347349068 136.184131,0.354504348 135.774607,0.358479503 C135.365083,0.363249689 134.956353,0.364442236 134.548815,0.363647205 C134.247332,0.363249689 133.946643,0.360069565 133.646749,0.355696894 C133.346458,0.350926708 133.047359,0.34456646 132.747862,0.33741118 L131.849371,0.315150311 C131.549477,0.307597516 131.249186,0.301634783 130.948895,0.296069565 C130.649795,0.29209441 130.350696,0.289311801 130.052391,0.288914286 C129.753688,0.287721739 129.454986,0.288914286 129.156284,0.29209441 C128.857978,0.29567205 128.559276,0.303224845 128.260574,0.312765217 C127.961871,0.323100621 127.663566,0.335026087 127.366055,0.347349068 C126.759912,0.375175155 126.156152,0.395845963 125.554775,0.409361491 C124.953398,0.422877019 124.35361,0.42804472 123.756206,0.427647205 C123.158801,0.427249689 122.562985,0.420889441 121.968361,0.410156522 C121.374134,0.399821118 120.781495,0.385510559 120.189652,0.370007453 C119.396025,0.348541615 118.605178,0.330255901 117.819099,0.317535404 C117.032622,0.304417391 116.251706,0.299647205 115.472776,0.303224845 C114.693846,0.306802484 113.914916,0.317932919 113.133602,0.330255901 C112.352289,0.342976398 111.566209,0.355696894 110.773774,0.36404472 C109.717194,0.375175155 108.653067,0.38272795 107.58457,0.388690683 C106.764728,0.350529193 105.94131,0.321113043 105.114715,0.299647205 C104.28812,0.281759006 103.457155,0.276591304 102.623013,0.285336646 C101.788473,0.293286957 100.950359,0.309982609 100.110259,0.327473292 C99.2697609,0.344963975 98.4280716,0.360467081 97.5843963,0.365634783 C96.3307997,0.373187578 95.0613146,0.349734161 93.7886518,0.324293168 C92.5163863,0.299249689 91.2457096,0.274206211 89.9905241,0.293286957 C88.7619517,0.31077764 87.544104,0.362852174 86.3266535,0.395050932 C85.1096002,0.427249689 83.894533,0.45388323 82.6746992,0.424467081 C81.8437347,0.405386335 81.0151534,0.388690683 80.1869693,0.375175155 C79.3587852,0.362454658 78.5309983,0.35609441 77.702417,0.358081988 C76.8742329,0.360069565 76.0444599,0.368417391 75.2134953,0.381137888 C73.9670485,0.407373913 72.7206016,0.427249689 71.4733603,0.439970186 C70.2265163,0.453485714 68.9796722,0.459448447 67.7324309,0.461038509 C65.1648616,0.464218634 62.5980867,0.494827329 60.031709,0.537361491 C59.5181157,0.544914286 59.0045224,0.553262112 58.4901347,0.558827329 C57.9761442,0.564790062 57.4617564,0.565585093 56.9465743,0.562802484 C56.4317893,0.560019876 55.91621,0.554852174 55.4006306,0.549286957 C54.8850513,0.543324224 54.3698691,0.538951553 53.8550842,0.538156522 C53.3414909,0.536963975 52.8298836,0.534578882 52.3234401,0.532193789 C51.8165994,0.52941118 51.3129363,0.528218634 50.8112594,0.52941118 C50.3095824,0.530206211 49.8086998,0.534578882 49.3070228,0.542131677 C48.805743,0.549684472 48.3024772,0.560019876 47.7972253,0.569560248 C47.291179,0.579100621 46.7835439,0.584268323 46.2739227,0.582280745 C45.7643015,0.579895652 45.2526942,0.572342857 44.7398953,0.565982609 C44.2266992,0.55962236 43.7123115,0.555647205 43.1967322,0.554852174 C42.68155,0.554454658 42.1643818,0.558429814 41.6456248,0.565585093 C41.1272649,0.572740373 40.6077135,0.579100621 40.0849843,0.581485714 C39.5626524,0.583473292 39.0359511,0.585063354 38.5064694,0.587050932 C37.9769877,0.588243478 37.4459171,0.590231056 36.9172298,0.589436025 C36.4814898,0.588640994 36.0521051,0.58546087 35.6286786,0.578703106 C35.2048549,0.572342857 34.7869893,0.5632 34.3730959,0.553659627 C33.9615857,0.544914286 33.552856,0.538554037 33.1453179,0.536963975 C32.6865397,0.534578882 32.2281587,0.536168944 31.7677916,0.540144099 C31.3074245,0.544914286 30.8438797,0.551274534 30.3743768,0.558827329 C29.9056683,0.56677764 29.4302072,0.573535404 28.9499796,0.577908075 C28.4693548,0.582678261 27.9847578,0.583473292 27.4957916,0.581485714 C27.0072225,0.579498137 26.5166674,0.576715528 26.0280984,0.573535404 C25.661473,0.571150311 25.2960393,0.568367702 24.9321944,0.564790062 C24.5687467,0.561212422 24.2068878,0.556839752 23.8478094,0.55167205 C23.4883338,0.546504348 23.1308443,0.540541615 22.7729575,0.535373913 C22.4158652,0.52941118 22.0591701,0.523448447 21.7016806,0.518678261 C21.3501492,0.513113043 20.9986178,0.508740373 20.6470864,0.505560248 C20.2951578,0.502380124 19.9432292,0.499995031 19.5920951,0.498404969 C19.2401665,0.496417391 18.8890323,0.492839752 18.5386926,0.488069565 C18.1883528,0.482901863 17.8392047,0.476144099 17.4900566,0.468591304 C17.1409085,0.460640994 16.7921575,0.452690683 16.4434066,0.444342857 C16.0950529,0.435995031 15.746302,0.42804472 15.3971539,0.421286957 C14.9780967,0.412541615 14.5586423,0.405386335 14.1383935,0.400218634 C13.7185419,0.394653416 13.2971015,0.390280745 12.8752638,0.388690683 C12.453029,0.387100621 12.0299997,0.387895652 11.6053815,0.390280745 C11.1815578,0.393063354 10.7565425,0.39783354 10.3311299,0.404193789 C9.90611459,0.410156522 9.48070204,0.416914286 9.05489227,0.422877019 C8.62947972,0.429237267 8.20446438,0.4352 7.78024346,0.43877764 C7.35602254,0.441957764 6.93339046,0.442752795 6.51115559,0.439572671 C6.10401473,0.436392547 5.69568223,0.42009441 5.28695252,0.399026087 C4.87822282,0.37835528 4.46472658,0.354901863 4.04964151,0.335821118 C3.64051459,0.315945342 3.23893467,0.297262112 2.85324318,0.284541615 C2.46755169,0.272218634 2.09774862,0.266255901 1.74224513,0.276193789 C1.49557735,0.283349068 1.18813635,0.272218634 0.908897294,0.313957764 C0.629261032,0.355696894 0.378223933,0.45030559 0.239597434,0.670131677 C0.0846852999,0.916193789 0.0779327197,1.48861615 0.108120725,2.08091429 C0.13791152,2.67162236 0.206628954,3.27902609 0.206231743,3.59385839",id:"Fill-92",fill:"#C5168C",mask:"url(#mask-12)",__source:{fileName:_jsxFileName,lineNumber:95}})),_react2.default.createElement("path",{d:"M49.099242,57.2088845 C48.9292358,57.4306981 48.7417524,57.6246857 48.539175,57.7912447 C48.3362004,57.9574062 48.1189262,58.0985242 47.8945022,58.2185739 C47.669681,58.3386236 47.43771,58.4407851 47.2021641,58.5282385 C46.966221,58.616487 46.7255114,58.6924124 46.479638,58.7516422 C46.2361479,58.821605 45.9823304,58.8685118 45.7185825,58.8963379 C45.3225636,58.938077 44.902712,58.925754 44.4741217,58.8422758 C44.0344096,58.7635677 43.5927114,58.616487 43.1621351,58.4022261 C42.7315588,58.1879652 42.3422924,57.9200398 42.0026774,57.6095801 C41.6622679,57.299518 41.3734958,56.9425491 41.1435109,56.5517913 C40.9905848,56.2906236 40.8662579,56.0139528 40.7709273,55.724164 C40.675994,55.4335801 40.6072765,55.1270957 40.5671583,54.8102758 C40.5262456,54.4930584 40.5139321,54.1682882 40.5322037,53.8391453 C40.5500782,53.5100025 40.6017156,53.177282 40.6902936,52.8485366 C40.7788715,52.5197913 40.9043901,52.1985988 41.0668492,51.8913193 C41.2297056,51.5840398 41.4223527,51.3029963 41.6443934,51.0430211 C41.8668314,50.7834435 42.1178685,50.5457292 42.3895605,50.336636 C42.662047,50.1271453 42.9547912,49.9478658 43.2622322,49.8023752 C43.5696732,49.656487 43.8933998,49.5427975 44.2310288,49.4617043 C44.5694523,49.3802137 44.9189976,49.3301267 45.2689401,49.312636 C45.6196771,49.2947478 45.9668392,49.3114435 46.3064542,49.3694807 C46.6448777,49.4279155 46.9745625,49.5296795 47.2891532,49.6704 C47.603744,49.8111205 47.9008576,49.9900025 48.1753301,50.2066484 C48.4470221,50.4228969 48.6853485,50.6709466 48.889912,50.9424497 C49.1266495,51.2576795 49.3204883,51.5979528 49.4706339,51.9521391 C49.6203823,52.306723 49.7288208,52.6748224 49.7999215,53.0528596 C49.8686389,53.4241391 49.9008129,53.8129093 49.9016074,54.2044621 C49.9020046,54.4982261 49.8908827,54.7888099 49.8658584,55.0678658 C49.8400397,55.3465242 49.797141,55.6140522 49.7339845,55.8672696 C49.6712252,56.1200894 49.587811,56.3593938 49.482153,56.5827975 C49.3760977,56.8062012 49.2481959,57.0152944 49.099242,57.2088845",id:"Fill-95",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:97}}),_react2.default.createElement("path",{d:"M71.3717141,58.7756522 C69.606113,59.1306335 67.4699144,58.425441 66.2909934,57.2841739 C64.7879485,55.828472 64.9194252,53.010087 65.962103,51.320646 C66.0550503,51.1699876 66.1567362,51.0264845 66.2659691,50.8901366 C66.3759964,50.7537888 66.4943652,50.6245963 66.6206782,50.502559 C66.7672489,50.3610435 66.9237498,50.2290683 67.0885922,50.1074286 C67.2538319,49.9857888 67.4270157,49.874087 67.6085409,49.7735155 C67.789669,49.6725466 67.9759607,49.5823106 68.1658274,49.5036025 C68.3552968,49.4248944 68.5487384,49.3569193 68.7433716,49.3000745 C69.1258854,49.1887702 69.5159462,49.1223851 69.9004461,49.1017143 C70.1884238,49.0862112 70.4700461,49.0961491 70.7397521,49.132323 C71.0094581,49.1688944 71.267645,49.2309068 71.5123267,49.3171677 C71.7570084,49.4034286 71.9893766,49.5127453 72.2090341,49.6463106 C72.4290888,49.7802733 72.6380215,49.938087 72.837024,50.1181615 C73.0650229,50.3240745 73.270778,50.5486708 73.4538921,50.7879752 C73.6370062,51.027677 73.7982737,51.2816894 73.9388862,51.5436522 C74.0791016,51.8056149 74.2002508,52.0751304 74.3035256,52.3482236 C74.4068003,52.6217143 74.492995,52.8995776 74.5593292,53.1798261 C74.6300327,53.4600745 74.6753147,53.7454907 74.694778,54.034087 C74.7237744,54.4673789 74.6868338,54.9098137 74.5779981,55.3478758 C74.4707512,55.7930932 74.2987591,56.2331429 74.0640076,56.6576894 C73.9464332,56.8699627 73.817737,57.0719006 73.6787133,57.261913 C73.5392924,57.452323 73.3899412,57.631205 73.2318514,57.7969689 C72.7281883,58.3200994 72.0799406,58.6333416 71.3717141,58.7756522",id:"Fill-97",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:98}}),_react2.default.createElement("path",{d:"M49.099242,57.2088845 C48.9292358,57.4306981 48.7417524,57.6246857 48.539175,57.7912447 C48.3362004,57.9574062 48.1189262,58.0985242 47.8945022,58.2185739 C47.669681,58.3386236 47.43771,58.4407851 47.2021641,58.5282385 C46.966221,58.616487 46.7255114,58.6924124 46.479638,58.7516422 C46.2361479,58.821605 45.9823304,58.8685118 45.7185825,58.8963379 C45.3225636,58.938077 44.902712,58.925754 44.4741217,58.8422758 C44.0344096,58.7635677 43.5927114,58.616487 43.1621351,58.4022261 C42.7315588,58.1879652 42.3422924,57.9200398 42.0026774,57.6095801 C41.6622679,57.299518 41.3734958,56.9425491 41.1435109,56.5517913 C40.9905848,56.2906236 40.8662579,56.0139528 40.7709273,55.724164 C40.675994,55.4335801 40.6072765,55.1270957 40.5671583,54.8102758 C40.5262456,54.4930584 40.5139321,54.1682882 40.5322037,53.8391453 C40.5500782,53.5100025 40.6017156,53.177282 40.6902936,52.8485366 C40.7788715,52.5197913 40.9043901,52.1985988 41.0668492,51.8913193 C41.2297056,51.5840398 41.4223527,51.3029963 41.6443934,51.0430211 C41.8668314,50.7834435 42.1178685,50.5457292 42.3895605,50.336636 C42.662047,50.1271453 42.9547912,49.9478658 43.2622322,49.8023752 C43.5696732,49.656487 43.8933998,49.5427975 44.2310288,49.4617043 C44.5694523,49.3802137 44.9189976,49.3301267 45.2689401,49.312636 C45.6196771,49.2947478 45.9668392,49.3114435 46.3064542,49.3694807 C46.6448777,49.4279155 46.9745625,49.5296795 47.2891532,49.6704 C47.603744,49.8111205 47.9008576,49.9900025 48.1753301,50.2066484 C48.4470221,50.4228969 48.6853485,50.6709466 48.889912,50.9424497 C49.1266495,51.2576795 49.3204883,51.5979528 49.4706339,51.9521391 C49.6203823,52.306723 49.7288208,52.6748224 49.7999215,53.0528596 C49.8686389,53.4241391 49.9008129,53.8129093 49.9016074,54.2044621 C49.9020046,54.4982261 49.8908827,54.7888099 49.8658584,55.0678658 C49.8400397,55.3465242 49.797141,55.6140522 49.7339845,55.8672696 C49.6712252,56.1200894 49.587811,56.3593938 49.482153,56.5827975 C49.3760977,56.8062012 49.2481959,57.0152944 49.099242,57.2088845",id:"Fill-99",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:99}}),_react2.default.createElement("path",{d:"M71.3717141,58.7756522 C69.606113,59.1306335 67.4699144,58.425441 66.2909934,57.2841739 C64.7879485,55.828472 64.9194252,53.010087 65.962103,51.320646 C66.0550503,51.1699876 66.1567362,51.0264845 66.2659691,50.8901366 C66.3759964,50.7537888 66.4943652,50.6245963 66.6206782,50.502559 C66.7672489,50.3610435 66.9237498,50.2290683 67.0885922,50.1074286 C67.2538319,49.9857888 67.4270157,49.874087 67.6085409,49.7735155 C67.789669,49.6725466 67.9759607,49.5823106 68.1658274,49.5036025 C68.3552968,49.4248944 68.5487384,49.3569193 68.7433716,49.3000745 C69.1258854,49.1887702 69.5159462,49.1223851 69.9004461,49.1017143 C70.1884238,49.0862112 70.4700461,49.0961491 70.7397521,49.132323 C71.0094581,49.1688944 71.267645,49.2309068 71.5123267,49.3171677 C71.7570084,49.4034286 71.9893766,49.5127453 72.2090341,49.6463106 C72.4290888,49.7802733 72.6380215,49.938087 72.837024,50.1181615 C73.0650229,50.3240745 73.270778,50.5486708 73.4538921,50.7879752 C73.6370062,51.027677 73.7982737,51.2816894 73.9388862,51.5436522 C74.0791016,51.8056149 74.2002508,52.0751304 74.3035256,52.3482236 C74.4068003,52.6217143 74.492995,52.8995776 74.5593292,53.1798261 C74.6300327,53.4600745 74.6753147,53.7454907 74.694778,54.034087 C74.7237744,54.4673789 74.6868338,54.9098137 74.5779981,55.3478758 C74.4707512,55.7930932 74.2987591,56.2331429 74.0640076,56.6576894 C73.9464332,56.8699627 73.817737,57.0719006 73.6787133,57.261913 C73.5392924,57.452323 73.3899412,57.631205 73.2318514,57.7969689 C72.7281883,58.3200994 72.0799406,58.6333416 71.3717141,58.7756522",id:"Fill-101",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:100}}),_react2.default.createElement("path",{d:"M21.5889125,59.469754 C21.3064957,59.4141019 21.0328176,59.3318161 20.769467,59.2240894 C20.5061164,59.1163627 20.2534904,58.9847851 20.0127808,58.8357168 C19.7728656,58.6866484 19.5440723,58.521282 19.3271953,58.343195 C19.1103183,58.1655056 18.9037688,57.9746981 18.7127105,57.7711702 C18.5176801,57.5708224 18.3397298,57.3521888 18.1828316,57.1168596 C17.9460941,56.7638658 17.7609939,56.3687354 17.6394475,55.9394186 C17.5107512,55.5049342 17.4408422,55.0422261 17.4317063,54.5592447 C17.4225705,54.0770584 17.4738107,53.6075925 17.5790715,53.1627727 C17.6851267,52.7175553 17.8495719,52.2973814 18.0684349,51.9141764 C18.2142112,51.6585739 18.3850118,51.4192696 18.5788505,51.1994435 C18.7730865,50.9796174 18.992744,50.776487 19.2330564,50.5940273 C19.4741632,50.4119652 19.7355278,50.2513689 20.0167529,50.1162137 C20.2975808,49.9810584 20.6002553,49.8721391 20.9196126,49.7942261 C21.2397644,49.7167106 21.5754073,49.6709963 21.9241582,49.6610584 C22.2729091,49.651518 22.6184823,49.6789466 22.9565086,49.740959 C23.294932,49.8033689 23.6230279,49.8991702 23.9336466,50.0267727 C24.2450597,50.1539776 24.5389956,50.3141764 24.8098932,50.5022012 C25.0811881,50.6906236 25.3286503,50.906077 25.5487049,51.1437913 C25.7683624,51.3811081 25.9614068,51.6394932 26.1242631,51.9129839 C26.2871194,52.186872 26.422171,52.4742758 26.5226653,52.7783752 C26.6243512,53.082872 26.6922743,53.4064497 26.7272288,53.7447354 C26.7617861,54.0822261 26.7641694,54.4320398 26.7319953,54.7890087 C26.7010129,55.1459776 26.629515,55.4965863 26.5218709,55.8396422 C26.3967496,56.2375553 26.2271406,56.6215553 26.0193995,56.9824994 C25.8124528,57.3434435 25.5713459,57.6785491 25.3048176,57.9822509 C25.0438503,58.2795925 24.756667,58.5439404 24.4531981,58.7673441 C24.2259936,58.9346981 23.9924338,59.0778037 23.7560935,59.1910957 C23.5201504,59.3047851 23.281824,59.3902509 23.0423061,59.4470957 C22.8035825,59.5047354 22.5628729,59.5353441 22.321766,59.5385242 C22.0798648,59.5413068 21.8359775,59.5178534 21.5889125,59.469754",id:"Fill-103",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:101}}),_react2.default.createElement("path",{d:"M171.251551,51.9301565 C171.400108,52.1631006 171.517285,52.403995 171.604274,52.6504547 C171.691263,52.8969143 171.75005,53.1481441 171.786593,53.3985789 C171.82274,53.6490137 171.840217,53.899846 171.8426,54.1478957 C171.844983,54.3963429 171.834259,54.643995 171.805262,54.8884671 C171.787388,55.1345292 171.744092,55.3805913 171.678949,55.6266534 C171.581633,55.9963429 171.424735,56.3632497 171.197133,56.7074981 C170.971517,57.0616845 170.681951,57.3876472 170.336775,57.6750509 C169.991599,57.9624547 169.61544,58.1914236 169.219421,58.3623553 C168.8238,58.533287 168.406331,58.6437963 167.981316,58.6871255 C167.698502,58.7209143 167.412908,58.7236969 167.128108,58.6978584 C166.843308,58.6724174 166.556522,58.6203429 166.273708,58.5448149 C165.990496,58.4688894 165.713243,58.3707031 165.445126,58.2490634 C165.177406,58.1266286 164.920411,57.9779578 164.680893,57.8018584 C164.441772,57.6253615 164.223704,57.4226286 164.030262,57.1944547 C163.837218,56.9666783 163.676745,56.7230012 163.54209,56.4622311 C163.407039,56.2018584 163.297806,55.9259826 163.214392,55.6413615 C163.130977,55.3559453 163.075368,55.0625789 163.047166,54.7652373 C163.018964,54.4678957 163.017772,54.1630012 163.042399,53.8493615 C163.066629,53.5357217 163.1135,53.2145292 163.183409,52.8941317 C163.252921,52.5733366 163.348251,52.2569143 163.478537,51.954405 C163.608822,51.6514981 163.777636,51.3672745 163.979022,51.1084919 C164.180805,50.8497093 164.415556,50.6203429 164.682482,50.4271503 C164.947421,50.2351503 165.235399,50.0892621 165.537676,49.9863056 C165.889208,49.8674484 166.251067,49.8014609 166.614117,49.7851627 C166.977168,49.7684671 167.340615,49.7974857 167.702077,49.8662559 C168.056786,49.9338335 168.416262,50.0419578 168.770176,50.1783056 C169.035513,50.2804671 169.294891,50.3897839 169.540368,50.5070509 C169.786241,50.6239205 170.015829,50.752318 170.226747,50.8950261 C170.437666,51.0365416 170.630313,51.1927652 170.800717,51.3648894 C170.971517,51.5374112 171.121663,51.7262311 171.251551,51.9301565",id:"Fill-105",fill:"#FFD300",__source:{fileName:_jsxFileName,lineNumber:102}}),_react2.default.createElement("path",{d:"M157.706471,28.0978286 C157.663175,28.0592696 157.609551,28.0286609 157.545998,28.0044124 C157.482047,27.9793689 157.406974,27.9610832 157.319985,27.9475677 C157.276292,27.9408099 157.228626,27.9352447 157.176592,27.930077 C157.124557,27.9249093 157.068948,27.9209342 157.007777,27.9173565 C156.946607,27.9141764 156.880273,27.9113938 156.809172,27.9090087 C156.738071,27.9074186 156.662601,27.9058286 156.585542,27.904636 C156.508086,27.903841 156.432219,27.9034435 156.35953,27.9034435 C156.28684,27.9034435 156.21852,27.9042385 156.156158,27.9054311 C156.093001,27.9070211 156.0362,27.9082137 155.984166,27.9105988 C155.932528,27.9129839 155.88526,27.9157665 155.843156,27.9189466 C155.758947,27.9245118 155.687449,27.9324621 155.627073,27.9404124 C155.566697,27.9491578 155.516649,27.9583006 155.474942,27.9682385 C155.457464,27.9726112 155.443959,27.980959 155.432043,27.9920894 C155.381994,28.0099776 155.33711,28.0513193 155.296594,28.1443379 C155.279911,28.1908472 155.282294,28.2496795 155.296991,28.2997665 C155.311291,28.3498534 155.33711,28.391195 155.364517,28.404313 C155.412977,28.4269714 155.467395,28.4440646 155.529359,28.4563876 C155.590927,28.4691081 155.660439,28.4766609 155.737498,28.4822261 C155.784369,28.4842137 155.83402,28.4854062 155.888041,28.4865988 C155.941664,28.4873938 156.000451,28.4881888 156.064799,28.4889839 C156.129545,28.4897789 156.201043,28.4905739 156.278101,28.4917665 C156.355557,28.4925615 156.437383,28.493754 156.522783,28.4949466 C156.594281,28.4957416 156.666971,28.4965366 156.737277,28.4969342 C156.807583,28.4973317 156.875109,28.4973317 156.938265,28.4965366 C157.001819,28.4953441 157.060606,28.493754 157.115024,28.4909714 C157.169442,28.4877913 157.220285,28.4842137 157.267156,28.4786484 C157.360898,28.468313 157.44312,28.4524124 157.514221,28.4285615 C157.584924,28.4051081 157.646095,28.3741019 157.697335,28.3339528 C157.765258,28.2790957 157.780749,28.1630211 157.706471,28.0978286",id:"Fill-107",fill:"#292663",__source:{fileName:_jsxFileName,lineNumber:103}}),_react2.default.createElement("path",{d:"M1.94287621,50.1750857 C1.94764273,50.2959304 1.93453478,50.4318807 1.92937105,50.5642534 C1.9238101,50.6974211 1.92698778,50.8282037 1.96313395,50.937123 C2.00285501,51.0579677 2.07633897,51.1148124 2.1637253,51.143036 C2.25031721,51.1704646 2.3512087,51.1696696 2.44614204,51.1732472 C2.55140285,51.1760298 2.65666365,51.1776199 2.76232167,51.1792099 C2.86797969,51.1808 2.97403492,51.1823901 3.08048736,51.1851727 C3.18733702,51.1879553 3.29458388,51.192328 3.40262516,51.1978932 C3.51066644,51.2042534 3.61950215,51.2114087 3.72833785,51.2189615 C3.86934762,51.2285019 4.00837132,51.2344646 4.14183409,51.2344646 C4.27529685,51.2344646 4.4008154,51.2265143 4.520773,51.2145888 C4.6296087,51.2042534 4.73169183,51.2074335 4.83139169,51.2078311 C4.93148876,51.2078311 5.02959978,51.2050484 5.12890243,51.1819925 C5.19404497,51.1672845 5.26752893,51.1354832 5.29930577,51.0372969 C5.31439978,50.9907876 5.31718025,50.9367255 5.31876909,50.8850484 C5.32591888,50.6278559 5.29851135,50.3770236 5.31003046,50.1242037 C5.31797467,49.9465143 5.32512446,49.7716075 5.32909657,49.6014708 C5.33346589,49.4305391 5.33505473,49.2631851 5.33426031,49.0974211 C5.33346589,48.9320547 5.32989099,48.7674832 5.32631609,48.6029118 C5.32115236,48.4379429 5.31678304,48.2733714 5.31439978,48.1091975 C5.31082488,47.8372969 5.30844162,47.5669863 5.30724999,47.2942907 C5.30605835,47.0211975 5.30566114,46.7413466 5.30367509,46.4531478 C5.30288067,46.3358807 5.30129183,46.2110609 5.26832335,46.1073093 C5.1916617,45.8688 4.95214371,45.9419429 4.81192837,45.9395578 C4.70229824,45.9375702 4.5882988,45.9347876 4.46754678,45.9375702 C4.31620954,45.9407503 4.15931135,45.9387627 3.99446895,45.9355826 C3.82883213,45.9328 3.65564831,45.9276323 3.47809517,45.9236571 C3.30054204,45.9220671 3.12418053,45.9172969 2.94861344,45.9117317 C2.77384078,45.906564 2.59906812,45.8990112 2.42429545,45.8930484 C2.27693032,45.8878807 2.10891024,45.8898683 2.02311275,46.0234335 C1.96432558,46.1152596 1.96194232,46.2456447 1.96114789,46.3664894 C1.95995626,46.5704149 1.94883437,46.7679801 1.93731526,46.9675329 C1.92659057,47.1666882 1.91546868,47.3682286 1.91546868,47.5781168 C1.91229099,47.7180422 1.91070215,47.8611478 1.91030494,48.0058435 C1.90990773,48.1509366 1.90990773,48.2976199 1.90951052,48.4423155 C1.90871609,48.5866137 1.90752446,48.7273342 1.90434678,48.8601043 C1.90077188,49.0119553 1.9015663,49.1610236 1.90474399,49.3081043 C1.90831888,49.4547876 1.91467425,49.6006758 1.92142683,49.7453714 C1.92897384,49.8900671 1.93691805,50.0339677 1.94287621,50.1750857",id:"Fill-109",fill:"#C5168C",__source:{fileName:_jsxFileName,lineNumber:104}}))))));};exports.default=IcTruckBig;module.exports=exports["default"];

/***/ }),
/* 2049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/truck.be888861.pdf";

/***/ }),
/* 2050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/car.cc9259a2.pdf";

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bus.caee5ecc.pdf";

/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/PlanData/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(13);var _lodash=__webpack_require__(43);var _lodash2=_interopRequireDefault(_lodash);var _PaymentMethods=__webpack_require__(2053);var _PaymentMethods2=_interopRequireDefault(_PaymentMethods);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _IconTextCarousel=__webpack_require__(2056);var _IconTextCarousel2=_interopRequireDefault(_IconTextCarousel);var _PlanResume=__webpack_require__(255);var _PlanResume2=_interopRequireDefault(_PlanResume);var _CallDownloadTerms=__webpack_require__(2058);var _CallDownloadTerms2=_interopRequireDefault(_CallDownloadTerms);var _actions2=__webpack_require__(36);var _styles=__webpack_require__(2061);var _data=__webpack_require__(2062);var _apolloClient=__webpack_require__(42);var _vehicles=__webpack_require__(94);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import CallBuyIdentifier from '../../modules/CallBuyIdentifier'
var PlanData=function(_Component){_inherits(PlanData,_Component);function PlanData(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,PlanData);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PlanData.__proto__||Object.getPrototypeOf(PlanData)).call.apply(_ref,[this].concat(args))),_this),_this.state={qtdTag:0},_this.checkAuthorizations=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(accountId){var _this$props,plandata,checkEditAuthorizationPayment;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,plandata=_this$props.plandata,checkEditAuthorizationPayment=_this$props.checkEditAuthorizationPayment;if(!_lodash2.default.isEmpty(plandata.authorizations)){_context.next=8;break;}_context.next=4;return checkEditAuthorizationPayment('FORMA',accountId);case 4:_context.next=6;return checkEditAuthorizationPayment('DATA',accountId);case 6:_context.next=14;break;case 8:if(!(plandata.authorizations.FORMA&&!plandata.authorizations.FORMA.error)){_context.next=11;break;}_context.next=11;return checkEditAuthorizationPayment('FORMA',accountId);case 11:if(!(plandata.authorizations.DATA&&!plandata.authorizations.DATA.error)){_context.next=14;break;}_context.next=14;return checkEditAuthorizationPayment('DATA',accountId);case 14:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.applyFilter=function(checkPlan){return checkPlan.id.toString()===_this.props.accountPlans.activePlanId.toString();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PlanData,[{key:'componentWillMount',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var plan,qtdTag;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.props.setLoading(true);plan=this.props.accountPlans.plans.find(this.applyFilter);if(!(this.props.account||{}).pc){_context2.next=9;break;}_context2.next=5;return this.props.getTotalTags(this.props.match.params.id);case 5:qtdTag=_context2.sent;this.setState({qtdTag:qtdTag||0});_context2.next=20;break;case 9:_context2.next=11;return this.props.fetchBankList();case 11:_context2.next=13;return this.props.getUser(this.props.account.accountType);case 13:_context2.next=15;return this.props.getPaymentInfo(plan.accountId);case 15:this.checkAuthorizations(plan.accountId);_context2.next=18;return this.props.fetchPaymentType();case 18:_context2.next=20;return this.props.fetchDueDates();case 20:_context2.next=22;return this.props.fetchPlanData(plan);case 22:_context2.next=24;return this.props.downloadTermsAndConditions();case 24:case'end':return _context2.stop();}}},_callee2,this);}));function componentWillMount(){return _ref3.apply(this,arguments);}return componentWillMount;}()},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var hasPlanChange=this.props.accountPlans.activePlanId!==nextProps.accountPlans.activePlanId;if(hasPlanChange){this.props.fetchResume(this.props.match.params.id);}return true;}},{key:'render',value:function render(){var qtdTag=this.state.qtdTag;var _props=this.props,accountPlans=_props.accountPlans,plandata=_props.plandata,creditPaymentInfo=_props.creditPaymentInfo,account=_props.account;var currentPlan=accountPlans.plans[0]?accountPlans.plans.find(this.applyFilter):'';return _react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:95}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:96}},_react2.default.createElement(_gridStyled.Box,{width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:97}},_react2.default.createElement(_PlanResume2.default,{showSummary:true,qtdTag:qtdTag,__source:{fileName:_jsxFileName,lineNumber:98}}),_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:99}},_react2.default.createElement(_CallDownloadTerms2.default,{__source:{fileName:_jsxFileName,lineNumber:100}}))),_react2.default.createElement(_styles.FinancialInformation,{__source:{fileName:_jsxFileName,lineNumber:103}},currentPlan&&!(account||{}).pc&&_react2.default.createElement(_PaymentMethods2.default,{currentPlan:currentPlan,plandata:plandata,creditPaymentInfo:creditPaymentInfo,accountType:account.accountType,__source:{fileName:_jsxFileName,lineNumber:106}}),_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:113}}),_react2.default.createElement(_IconTextCarousel2.default,{data:_data.dados,__source:{fileName:_jsxFileName,lineNumber:114}}),_react2.default.createElement(_Hide2.default,{at:'large',__source:{fileName:_jsxFileName,lineNumber:116}},_react2.default.createElement(_CallDownloadTerms2.default,{__source:{fileName:_jsxFileName,lineNumber:117}})))));}}]);return PlanData;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref4){var reducer=_ref4.reducer;return{account:reducer.account,resume:reducer.dashboardResume,accountPlans:reducer.accountPlans,plandata:reducer.planData,creditPaymentInfo:reducer.recharge.paymentInfo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getUser:function getUser(userType){if(userType==='pf'){dispatch((0,_actions.fetchGetUser)());}else{dispatch((0,_actions.fetchGetBusinessUser)());}},getPaymentInfo:function getPaymentInfo(accountPlanId){return dispatch((0,_actions.fetchPaymentInfo)(accountPlanId));},fetchResume:function fetchResume(token,planId){return dispatch((0,_actions.fetchDashboardResume)(token,planId));},checkEditAuthorizationPayment:function checkEditAuthorizationPayment(type,accountPlanId){return dispatch((0,_actions.checkEditAuthorizationPayment)(type,accountPlanId));},fetchPlanData:function fetchPlanData(plano){return dispatch((0,_actions.fetchPlanData)(plano)).then(function(){return dispatch((0,_actions2.setLoading)(false));});},fetchPaymentType:function fetchPaymentType(){return dispatch((0,_actions.fetchPaymentType)());},downloadTermsAndConditions:function downloadTermsAndConditions(){return dispatch((0,_actions.fetchTermsAndConditions)());},fetchDueDates:function fetchDueDates(){return dispatch((0,_actions.fetchDueDates)());},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));},fetchBankList:function fetchBankList(){return dispatch((0,_actions.fetchBankList)());},getTotalTags:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(idConta){var _ref6,total;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return(0,_apolloClient.gqlQuery)(_vehicles.gqlTotalIdentificadores,{idConta:idConta});case 2:_ref6=_context3.sent;total=_ref6.data.identificadoresPJV2.paginacao.total;return _context3.abrupt('return',total);case 5:case'end':return _context3.stop();}}},_callee3,undefined);}));return function getTotalTags(_x2){return _ref5.apply(this,arguments);};}()};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(PlanData);module.exports=exports['default'];

/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/PaymentMethods/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(15);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _reactRedux=__webpack_require__(7);var _styles=__webpack_require__(2054);var _actions=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _iconVeloeBackground=__webpack_require__(137);var _iconVeloeBackground2=_interopRequireDefault(_iconVeloeBackground);var _trafficSignalError=__webpack_require__(401);var _trafficSignalError2=_interopRequireDefault(_trafficSignalError);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _DotButton=__webpack_require__(253);var _DotButton2=_interopRequireDefault(_DotButton);var _DropdownList=__webpack_require__(264);var _DropdownList2=_interopRequireDefault(_DropdownList);var _data=__webpack_require__(2055);var _Icon=__webpack_require__(31);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var isPos='pos';var isPre='pre';var isAutomatic='RECARGA_AUTOMATICA';var isManual='RECARGA_MANUAL';var paymentTypeCC='Cartão de crédito';var paymentTypeDebit='Débito automático';var paymentTypeTicket='Boleto bancário';var PaymentMethods=function(_React$Component){_inherits(PaymentMethods,_React$Component);function PaymentMethods(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PaymentMethods);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PaymentMethods.__proto__||Object.getPrototypeOf(PaymentMethods)).call.apply(_ref,[this].concat(args))),_this),_this.state={openPaymentModal:false,showDropdown:false},_this.toggleDropdown=function(){_this.setState(function(prevState){return{showDropdown:!prevState.showDropdown};});},_this.handlePaymentMethodChange=function(){var _this$props=_this.props,currentPlan=_this$props.currentPlan,plandata=_this$props.plandata,match=_this$props.match;// Removido por ora até ser confirmado que não haverá mais restrição de alteração
// const ableToChangePaymentMethod =
//   plandata.authorizations.FORMA &&
//   !plandata.authorizations.FORMA.dataProximaAlteracao &&
//   !plandata.authorizations.FORMA.error
// const daysToChangePaymentMethod =
//   !ableToChangePaymentMethod && plandata.authorizations.FORMA.dataProximaAlteracao
//     ? moment(plandata.authorizations.FORMA.dataProximaAlteracao, 'DD/MM/YYYY').diff(
//         moment(),
//         'days'
//       ) + 1
//     : null
// if (!ableToChangePaymentMethod) {
//   showErrorModal(accountType, 'forma de pagamento', daysToChangePaymentMethod)
// } else {
_this.props.history.push('/minha-veloe/'+match.params.id+'/metodo-de-pagamento',{currentPlan:currentPlan,paymentTypes:plandata.paymentTypes||[]});// }
},_this.checkChannelAuthorization=function(){var plandata=_this.props.plandata;var regTest=/Alteração não permitida por este canal/;var matchString=plandata.authorizations.FORMA&&plandata.authorizations.FORMA.mensagem&&plandata.authorizations.FORMA.mensagem.match(regTest);if(matchString)return true;return false;},_this.handleDueDateChange=function(){var _this$props2=_this.props,currentPlan=_this$props2.currentPlan,plandata=_this$props2.plandata,match=_this$props2.match,accountType=_this$props2.accountType,showErrorModal=_this$props2.showErrorModal;var ableToChangeDueDate=plandata.authorizations.DATA&&!plandata.authorizations.DATA.dataProximaAlteracao&&!plandata.authorizations.DATA.error;var daysToChangeDueDate=!ableToChangeDueDate&&plandata.authorizations.DATA.dataProximaAlteracao?(0,_moment2.default)(plandata.authorizations.DATA.dataProximaAlteracao,'DD/MM/YYYY').diff((0,_moment2.default)(),'days')+1:null;if(!ableToChangeDueDate){showErrorModal(accountType,'data de vencimento',daysToChangeDueDate);}else{_this.props.history.push('/minha-veloe/'+match.params.id+'/data-de-vencimento',{currentPlan:currentPlan,dueDates:plandata.dueDates?plandata.dueDates.sort(function(a,b){return a.dia-b.dia;}):[]});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PaymentMethods,[{key:'render',value:function render(){var _this2=this;var showDropdown=this.state.showDropdown;var _ref2=this.props||{},currentPlan=_ref2.currentPlan,plandata=_ref2.plandata,creditPaymentInfo=_ref2.creditPaymentInfo,match=_ref2.match;var _ref3=this.props.currentPlan||{},debitPaymentData=_ref3.debitPaymentData;var typeAccountPos=currentPlan.plan.type===isPos;var finalCreditCardNumber=currentPlan.paymentType==='CARTAO_DE_CREDITO'&&creditPaymentInfo.numeroMascarado?creditPaymentInfo.numeroMascarado.split('-')[3]:null;return _react2.default.createElement(_styles.Container,{typeAccountPos:typeAccountPos,__source:{fileName:_jsxFileName,lineNumber:152}},_react2.default.createElement(_styles.ContainerHeader,{__source:{fileName:_jsxFileName,lineNumber:153}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:154}},_data.paymentMethods),currentPlan.plan.type===isPre?_react2.default.createElement(_styles.EditData,{to:'/minha-veloe/'+match.params.id+'/editar-dados',__source:{fileName:_jsxFileName,lineNumber:156}},_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:157}},_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:158}},_react2.default.createElement(_styles.EditItem,{typeAccountPos:typeAccountPos,__source:{fileName:_jsxFileName,lineNumber:159}},_data.planType[currentPlan.plan.type]),_react2.default.createElement(_styles.ContainerIcon,{__source:{fileName:_jsxFileName,lineNumber:162}},_react2.default.createElement(_Icon.Icon,{icon:'right-arrow',width:'8',height:'13',viewBox:'0 0 8 13',__source:{fileName:_jsxFileName,lineNumber:163}}))))):currentPlan.plan.type===isPos&&!this.checkChannelAuthorization()?_react2.default.createElement(_styles.DropdownContainer,{__source:{fileName:_jsxFileName,lineNumber:169}},_react2.default.createElement(_DotButton2.default,{onClick:function onClick(){return _this2.toggleDropdown();},__source:{fileName:_jsxFileName,lineNumber:170}}),_react2.default.createElement(_DropdownList2.default,{withIcon:true,isOpen:showDropdown,onClose:function onClose(){return _this2.toggleDropdown();},__source:{fileName:_jsxFileName,lineNumber:171}},_react2.default.createElement(_styles.EditDataPos,{onClick:this.handlePaymentMethodChange,__source:{fileName:_jsxFileName,lineNumber:172}},_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:173}},_react2.default.createElement(_styles.ContainerIcon,{marginLeft:'8',alignSelf:'center',__source:{fileName:_jsxFileName,lineNumber:174}},_react2.default.createElement(_Icon.Icon,{icon:'money',width:'24',height:'24',viewBox:'0 0 100 100',__source:{fileName:_jsxFileName,lineNumber:175}})),_react2.default.createElement(_DropdownList.ListItem,{__source:{fileName:_jsxFileName,lineNumber:177}},'Alterar forma de pagamento'))),_react2.default.createElement(_styles.EditDataPos,{onClick:this.handleDueDateChange,__source:{fileName:_jsxFileName,lineNumber:180}},_react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:181}},_react2.default.createElement(_styles.ContainerIcon,{marginLeft:'8',alignSelf:'center',__source:{fileName:_jsxFileName,lineNumber:182}},_react2.default.createElement(_Icon.Icon,{icon:'calendar',width:'24',height:'24',viewBox:'0 0 100 100',__source:{fileName:_jsxFileName,lineNumber:183}})),_react2.default.createElement(_DropdownList.ListItem,{__source:{fileName:_jsxFileName,lineNumber:185}},'Alterar data de vencimento'))))):null),currentPlan.plan.type===isPre&&currentPlan.plan.rechargeType===isAutomatic&&_react2.default.createElement(_styles.PlanType,{__source:{fileName:_jsxFileName,lineNumber:193}},_data.autoRecharge),currentPlan.plan.type===isPre&&currentPlan.plan.rechargeType===isManual&&_react2.default.createElement(_styles.PlanType,{__source:{fileName:_jsxFileName,lineNumber:195}},_data.manualRecharge),currentPlan.plan.type===isPos&&currentPlan.paymentType==='CARTAO_DE_CREDITO'&&_react2.default.createElement(_styles.PlanType,{typeAccountPos:typeAccountPos,__source:{fileName:_jsxFileName,lineNumber:198}},paymentTypeCC),currentPlan.plan.type===isPos&&currentPlan.paymentType==='DEBITO_EM_CONTA'&&_react2.default.createElement(_styles.PlanType,{typeAccountPos:typeAccountPos,__source:{fileName:_jsxFileName,lineNumber:202}},paymentTypeDebit),currentPlan.plan.type===isPos&&currentPlan.paymentType==='BOLETO'&&_react2.default.createElement(_styles.PlanType,{typeAccountPos:typeAccountPos,__source:{fileName:_jsxFileName,lineNumber:206}},paymentTypeTicket),_react2.default.createElement(_styles.PaymentInfo,{__source:{fileName:_jsxFileName,lineNumber:208}},currentPlan.paymentType==='CARTAO_DE_CREDITO'&&creditPaymentInfo.numeroMascarado&&_react2.default.createElement(_styles.PaymentItem,{__source:{fileName:_jsxFileName,lineNumber:211}},_react2.default.createElement(_styles.ContainerIcon,{__source:{fileName:_jsxFileName,lineNumber:212}},_react2.default.createElement(_Icon.Icon,{icon:'card',width:'24',height:'24',viewBox:'0 0 100 100',__source:{fileName:_jsxFileName,lineNumber:213}})),_react2.default.createElement(_styles.ListInfo,{__source:{fileName:_jsxFileName,lineNumber:215}},_react2.default.createElement(_styles.InfoItem,{__source:{fileName:_jsxFileName,lineNumber:216}},_data.card),_react2.default.createElement(_styles.InfoItemAdditional,{__source:{fileName:_jsxFileName,lineNumber:217}},_data.final,' ',finalCreditCardNumber))),currentPlan.debitPaymentData&&currentPlan.paymentType==='DEBITO_EM_CONTA'&&debitPaymentData.bankName&&debitPaymentData.bankCode&&_react2.default.createElement(_styles.PaymentItem,{typeAccountPos:typeAccountPos,__source:{fileName:_jsxFileName,lineNumber:227}},_react2.default.createElement(_styles.ContainerIcon,{__source:{fileName:_jsxFileName,lineNumber:228}},_react2.default.createElement(_Icon.Icon,{icon:'card',width:'24',height:'24',viewBox:'0 0 100 100',__source:{fileName:_jsxFileName,lineNumber:229}})),_react2.default.createElement(_styles.ListInfo,{__source:{fileName:_jsxFileName,lineNumber:231}},_react2.default.createElement(_styles.InfoItem,{__source:{fileName:_jsxFileName,lineNumber:232}},_data.bank),_react2.default.createElement(_styles.InfoItemAdditional,{__source:{fileName:_jsxFileName,lineNumber:233}},debitPaymentData.bankName))),currentPlan.debitPaymentData&&currentPlan.paymentType==='DEBITO_EM_CONTA'&&debitPaymentData.agency&&debitPaymentData.account&&_react2.default.createElement(_styles.PaymentItem,{grouped:true,__source:{fileName:_jsxFileName,lineNumber:241}},_react2.default.createElement(_styles.ListInfo,{__source:{fileName:_jsxFileName,lineNumber:242}},_react2.default.createElement(_styles.InfoItem,{__source:{fileName:_jsxFileName,lineNumber:243}},_data.agency),_react2.default.createElement(_styles.InfoItemAdditional,{__source:{fileName:_jsxFileName,lineNumber:244}},debitPaymentData.agency)),_react2.default.createElement(_styles.ListInfo,{__source:{fileName:_jsxFileName,lineNumber:246}},_react2.default.createElement(_styles.InfoItem,{__source:{fileName:_jsxFileName,lineNumber:247}},_data.account),_react2.default.createElement(_styles.InfoItemAdditional,{__source:{fileName:_jsxFileName,lineNumber:248}},debitPaymentData.account))),plandata&&plandata.recharge&&_react2.default.createElement(_styles.PaymentItem,{__source:{fileName:_jsxFileName,lineNumber:254}},_react2.default.createElement(_styles.ContainerIcon,{__source:{fileName:_jsxFileName,lineNumber:255}},_react2.default.createElement(_Icon.Icon,{icon:'dollar-sign',width:'41',height:'41',viewBox:'0 0 60 60',__source:{fileName:_jsxFileName,lineNumber:256}})),_react2.default.createElement(_styles.ListInfo,{__source:{fileName:_jsxFileName,lineNumber:258}},_react2.default.createElement(_styles.InfoItem,{__source:{fileName:_jsxFileName,lineNumber:259}},_data.monthlyPayment[currentPlan.plan.type]),_react2.default.createElement(_styles.InfoItemAdditional,{__source:{fileName:_jsxFileName,lineNumber:260}},plandata.recharge!==undefined&&_aleloLogic.utils.currencyParser(plandata.recharge,'R$ ')))),currentPlan.plan.type===isPos&&currentPlan.posData&&_react2.default.createElement(_styles.PaymentItem,{typeAccountPos:typeAccountPos,__source:{fileName:_jsxFileName,lineNumber:269}},_react2.default.createElement(_styles.ContainerIcon,{__source:{fileName:_jsxFileName,lineNumber:270}},_react2.default.createElement(_Icon.Icon,{icon:'calendar',width:'24',height:'24',viewBox:'0 0 100 100',__source:{fileName:_jsxFileName,lineNumber:271}})),_react2.default.createElement(_styles.ListInfo,{__source:{fileName:_jsxFileName,lineNumber:273}},_react2.default.createElement(_styles.InfoItem,{__source:{fileName:_jsxFileName,lineNumber:274}},_data.duoDate),_react2.default.createElement(_styles.InfoItemAdditional,{__source:{fileName:_jsxFileName,lineNumber:275}},_data.day,' ',currentPlan.posData.dueDayAccount,' ',_data.ofEachMonth))),_react2.default.createElement(_Hide2.default,{at:'large',__source:{fileName:_jsxFileName,lineNumber:292}},_react2.default.createElement(_gridStyled.Flex,{mt:20,__source:{fileName:_jsxFileName,lineNumber:293}},_react2.default.createElement(_styles.EditItem,{__source:{fileName:_jsxFileName,lineNumber:294}},_data.planType[this.props.type]),_react2.default.createElement(_styles.ContainerIcon,{__source:{fileName:_jsxFileName,lineNumber:295}},_react2.default.createElement(_Icon.Icon,{icon:'right-arrow',width:'8',height:'13',viewBox:'0 0 8 13',__source:{fileName:_jsxFileName,lineNumber:296}}))))),currentPlan.plan.type===isPre&&currentPlan.plan.rechargeAmount!==undefined&&_react2.default.createElement(_styles.PaymentFooter,{__source:{fileName:_jsxFileName,lineNumber:303}},_data.recharge1,_aleloLogic.utils.currencyParser(currentPlan.plan.rechargeAmount,'R$ '),_data.recharge2));}}]);return PaymentMethods;}(_react2.default.Component);var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showErrorModal:function showErrorModal(accountType,label,daysToChange){return dispatch((0,_actions.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:'Voc\xEA fez uma altera\xE7\xE3o de '+label+' recentemente.',modalDescription:_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:320}},daysToChange&&_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:322}},'Em ',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:323}},daysToChange),' dia',daysToChange>1?'s':'',' voc\xEA poder\xE1 fazer uma nova altera\xE7\xE3o.')),accountType:accountType,image:accountType==='pf'?_trafficSignalError2.default:_iconVeloeBackground2.default}));}};};exports.default=(0,_reactRedux.connect)(null,mapDispatchToProps)((0,_reactRouterDom.withRouter)(PaymentMethods));module.exports=exports['default'];

/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DropdownContainer=exports.PaymentFooter=exports.InfoItemAdditional=exports.InfoItem=exports.Text=exports.PaymentItem=exports.ListInfo=exports.PaymentInfo=exports.EditDataPos=exports.EditData=exports.PlanType=exports.ContainerIcon=exports.EditItem=exports.Title=exports.ContainerHeader=exports.Container=exports.Separator=undefined;var _templateObject=_taggedTemplateLiteral(['\n        flex-direction: row;\n    '],['\n        flex-direction: row;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n            padding-left: ',';\n        '],['\n            padding-left: ',';\n        ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'styles__Separator',componentId:'sc-1ype2x7-0'})(['background-color:',';border:0;height:',';margin:',' 0;'],_colors.offWhite,(0,_rem2.default)('1px'),(0,_rem2.default)('20px'));var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-1ype2x7-1'})(['width:100%;',';'],function(_ref){var typeAccountPos=_ref.typeAccountPos;return typeAccountPos&&'\n      max-width: '+(0,_rem2.default)('500px')+';\n      padding: '+(0,_rem2.default)('32px')+';\n      background-color: '+_colors.white+';\n      border-radius: '+(0,_rem2.default)('4.4px')+';\n      border: solid '+(0,_rem2.default)('1px')+' '+_colors.grey+';\n    ';});var ContainerHeader=exports.ContainerHeader=_styledComponents2.default.div.withConfig({displayName:'styles__ContainerHeader',componentId:'sc-1ype2x7-2'})(['display:flex;justify-content:space-between;width:100%;']);var Title=exports.Title=_styledComponents2.default.p.withConfig({displayName:'styles__Title',componentId:'sc-1ype2x7-3'})(['',' color:',';font-weight:bold;margin:0;'],_types.txt16OpenSans,_colors.linkNavyBlue);var EditItem=exports.EditItem=_styledComponents2.default.p.withConfig({displayName:'styles__EditItem',componentId:'sc-1ype2x7-4'})(['',';margin:0 ',' 0 0;letter-spacing:',';color:',';'],_types.txt14OpenSansBold,'8px',(0,_rem2.default)('-0.4px'),function(_ref2){var typeAccountPos=_ref2.typeAccountPos;return typeAccountPos?_colors.lightBlue:_colors.linkNavyBlue;});var ContainerIcon=exports.ContainerIcon=_styledComponents2.default.div.withConfig({displayName:'styles__ContainerIcon',componentId:'sc-1ype2x7-5'})(['margin-right:',';margin-left:',';align-items:center;align-self:',';'],function(_ref3){var marginRight=_ref3.marginRight;return marginRight?marginRight+'px':''+(0,_rem2.default)('8px');},function(_ref4){var marginLeft=_ref4.marginLeft;return marginLeft?marginLeft+'px':'0';},function(_ref5){var alignSelf=_ref5.alignSelf;return alignSelf||'normal';});var PlanType=exports.PlanType=_styledComponents2.default.p.withConfig({displayName:'styles__PlanType',componentId:'sc-1ype2x7-6'})(['',' color:',';margin:',';;'],_types.txt14OpenSans,_colors.linkNavyBlue,function(_ref6){var typeAccountPos=_ref6.typeAccountPos;return typeAccountPos?'8px 0 0':'0';});var EditData=exports.EditData=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__EditData',componentId:'sc-1ype2x7-7'})(['align-items:baseline;text-decoration:none;']);var EditDataPos=exports.EditDataPos=_styledComponents2.default.span.withConfig({displayName:'styles__EditDataPos',componentId:'sc-1ype2x7-8'})(['align-items:baseline;text-decoration:none;cursor:pointer;']);var PaymentInfo=exports.PaymentInfo=_styledComponents2.default.div.withConfig({displayName:'styles__PaymentInfo',componentId:'sc-1ype2x7-9'})(['display:flex;flex-direction:column;flex-wrap:wrap;margin-left:',';',';'],(0,_rem2.default)('-36px'),_media2.default.large(_templateObject));var ListInfo=exports.ListInfo=_styledComponents2.default.div.withConfig({displayName:'styles__ListInfo',componentId:'sc-1ype2x7-10'})(['display:flex;flex-direction:column;']);var PaymentItem=exports.PaymentItem=_styledComponents2.default.div.withConfig({displayName:'styles__PaymentItem',componentId:'sc-1ype2x7-11'})(['align-items:',';box-sizing:border-box;display:flex;margin-left:',';margin-top:',';',';'],function(_ref7){var typeAccountPos=_ref7.typeAccountPos;return typeAccountPos?'flex-start':'center';},(0,_rem2.default)('36px'),(0,_rem2.default)('22px'),function(_ref8){var grouped=_ref8.grouped;return grouped&&(0,_styledComponents.css)(['',' & > ',' + ','{margin-left:',';}'],_media2.default.small(_templateObject2,(0,_rem2.default)('50px')),ListInfo,ListInfo,(0,_rem2.default)('36px'));});var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1ype2x7-12'})(['margin:0 ',';'],(0,_rem2.default)('15px'));var InfoItem=exports.InfoItem=_styledComponents2.default.p.withConfig({displayName:'styles__InfoItem',componentId:'sc-1ype2x7-13'})(['',' color:',';letter-spacing:',';margin:0;text-transform:uppercase;'],_types.txt12OpenSans,_colors.darkGrey,(0,_rem2.default)('1px'));var InfoItemAdditional=exports.InfoItemAdditional=_styledComponents2.default.p.withConfig({displayName:'styles__InfoItemAdditional',componentId:'sc-1ype2x7-14'})(['',' color:',';font-weight:',';margin:0;'],_types.txt14OpenSans,_colors.linkNavyBlue,function(_ref9){var typeAccountPos=_ref9.typeAccountPos;return typeAccountPos?'600':'normal';});var PaymentFooter=exports.PaymentFooter=_styledComponents2.default.p.withConfig({displayName:'styles__PaymentFooter',componentId:'sc-1ype2x7-15'})(['',' color:',';'],_types.txt12OpenSans,_colors.darkGrey);var DropdownContainer=exports.DropdownContainer=_styledComponents2.default.div.withConfig({displayName:'styles__DropdownContainer',componentId:'sc-1ype2x7-16'})(['display:flex;align-items:center;min-height:100%;position:relative;']);

/***/ }),
/* 2055 */
/***/ (function(module, exports) {

module.exports = {"planType":{"pre":"Editar","pos":"Editar"},"monthlyPayment":{"pre":"Valor da recarga","pos":"Mensalidade"},"account":"Conta","duoDate":"Vencimento","lateFees":"Taxas por atraso","agency":"Agência","day":"dia","ofEachMonth":"de cada mês","mulctAndInterest":"Multa: 2% a.m. e Juros: 5% a.d.","bank":"Banco","card":"Cartão","final":"final","rechargeValue":"Valor da recarga","paymentMethods":"Formas de pagamento","autoRecharge":"PLANO PRÉ PAGO - RECARGA AUTOMÁTICA","manualRecharge":"PLANO PRÉ PAGO - RECARGA MANUAL","posLabel":"PLANO PÓS PAGO","recharge1":"*Assim que sua conta chegar no valor de ","recharge2":", uma nova recarga vai ser feita automaticamente."}

/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/IconTextCarousel/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _Carousel=__webpack_require__(631);var _Carousel2=_interopRequireDefault(_Carousel);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _Icon=__webpack_require__(31);var _styles=__webpack_require__(2057);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function renderItems(item){return _react2.default.createElement(_styles.List,{key:item.id,width:[1,4/12],__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement(_Icon.Icon,{icon:item.icon,height:'75px',width:'75px',viewBox:'0 0 20 75',__source:{fileName:_jsxFileName,lineNumber:12}}),_react2.default.createElement(_styles.ItemDescription,{__source:{fileName:_jsxFileName,lineNumber:13}},item.description));}function groupItems(items,limitItems){var result=[];var itemIndex=0;if(limitItems>0){while(itemIndex<items.length){var cursor=0;var group=[];while(group.length<limitItems&&itemIndex<items.length){group[cursor++]=items[itemIndex++];}// eslint-disable-line
result.push(group);}}return result;}var IconTextCarousel=function IconTextCarousel(_ref){var data=_ref.data;var desktopItems=groupItems(data,3);return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:40}},data&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_Carousel2.default,{hasNavigation:true,hasArrow:true,mobileOnly:false,__source:{fileName:_jsxFileName,lineNumber:44}},desktopItems.map(function(group,index){return _react2.default.createElement(_gridStyled.Flex,{align:'stretch',key:index,__source:{fileName:_jsxFileName,lineNumber:46}},group.map(function(item){return renderItems(item);}));}))),_react2.default.createElement(_Hide2.default,{at:'large',__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_Carousel2.default,{flexibleWidth:true,hasNavigation:true,mobileOnly:false,__source:{fileName:_jsxFileName,lineNumber:53}},data.map(function(item){return renderItems(item);})))));};exports.default=IconTextCarousel;module.exports=exports['default'];

/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.List=exports.ItemDescription=exports.Teste=undefined;var _templateObject=_taggedTemplateLiteral(['\n    max-width: ',';\n  '],['\n    max-width: ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    margin-right: ',';\n    max-width: ',';\n  '],['\n    margin-right: ',';\n    max-width: ',';\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _gridStyled=__webpack_require__(8);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Teste=exports.Teste=_styledComponents2.default.div.withConfig({displayName:'styles__Teste',componentId:'sc-1vg9uv4-0'})(['']);var ItemDescription=exports.ItemDescription=_styledComponents2.default.p.withConfig({displayName:'styles__ItemDescription',componentId:'sc-1vg9uv4-1'})(['',' white-space:normal;color:',';margin:0 0 ',' 0;',';'],_types.txt14OpenSans,_colors.darkGrey,(0,_rem2.default)('37px'),_media2.default.large(_templateObject,(0,_rem2.default)('184px')));var List=exports.List=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'styles__List',componentId:'sc-1vg9uv4-2'})(['margin-top:',';max-width:',';&:last-child{max-width:100%;}',';'],(0,_rem2.default)('30px'),(0,_rem2.default)('184px'),_media2.default.large(_templateObject2,(0,_rem2.default)('30px'),(0,_rem2.default)('230px')));

/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapStateToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/CallDownloadTerms/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _styles=__webpack_require__(2059);var _data=__webpack_require__(2060);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var CallDownloadTerms=function CallDownloadTerms(_ref){var match=_ref.match,accountId=_ref.accountId,planId=_ref.planId,accountPlans=_ref.accountPlans,terms=_ref.terms,props=_objectWithoutProperties(_ref,['match','accountId','planId','accountPlans','terms']);// const plans = accountPlans.plans || []
// const hasMultiplePlans = plans.length > 1
// const cancelLink = hasMultiplePlans ? `/minha-veloe/${planId}/cancelar-plano` : '/cancelar-conta'
console.log({terms:terms});var term=terms&&terms.termo&&terms.termo.length>1?terms.termo[0]:terms.termo;return _react2.default.createElement(_styles.CallContainer,{__source:{fileName:_jsxFileName,lineNumber:36}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_styles.DownloadItem,{__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement(_styles.IconDownload,{svgStyle:_styles.IconColorCian,icon:'download',height:'40px',width:'40px',viewBox:'0 0 70 70',onClick:function onClick(){return window.open(term.url);},__source:{fileName:_jsxFileName,lineNumber:39}}),_react2.default.createElement(_styles.Title,{onClick:function onClick(){return window.open(term.url);},__source:{fileName:_jsxFileName,lineNumber:47}},_data.downloadTerm)),_react2.default.createElement(_styles.DownloadItem,{__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_styles.IconDownload,{svgStyle:_styles.IconColorCian,icon:'download',height:'40px',width:'40px',viewBox:'0 0 70 70',onClick:function onClick(){return window.open(term.url);},__source:{fileName:_jsxFileName,lineNumber:50}}),_react2.default.createElement(_styles.Title,{style:{marginTop:0},onClick:function onClick(){return window.open(terms.manualUsuario.url);},__source:{fileName:_jsxFileName,lineNumber:58}},_data.downloadGuide)),_react2.default.createElement(_styles.DownloadItem,{__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement(_styles.IconDownload,{svgStyle:_styles.IconColorCian,icon:'download',height:'40px',width:'40px',viewBox:'0 0 70 70',onClick:function onClick(){return window.open(terms.termo.url);},__source:{fileName:_jsxFileName,lineNumber:63}}),_react2.default.createElement(_styles.Title,{style:{marginTop:0},onClick:function onClick(){return window.open(terms.termoPrivacidade.url);},__source:{fileName:_jsxFileName,lineNumber:71}},_data.downloadPrivacy))));};var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{accountPlans:reducer.accountPlans,terms:reducer.termsCondition,userGuideLink:reducer.userGuideLink};};exports.default=(0,_reactRedux.connect)(mapStateToProps)((0,_reactRouterDom.withRouter)(CallDownloadTerms));

/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Arrow=exports.Text=exports.LinkCancelPlan=exports.Title=exports.IconDownload=exports.DownloadItem=exports.Container=exports.CallContainer=exports.IconColorDarkBlue=exports.IconColorCian=undefined;var _templateObject=_taggedTemplateLiteral(['\n    flex-direction: column;\n    justify-content: flex-end;\n    margin: ',' auto ',';\n    min-height: ',';\n    padding: ',' ',' ',';\n    align-items: flex-start;\n  '],['\n    flex-direction: column;\n    justify-content: flex-end;\n    margin: ',' auto ',';\n    min-height: ',';\n    padding: ',' ',' ',';\n    align-items: flex-start;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _gridStyled=__webpack_require__(8);var _reactRouterDom=__webpack_require__(15);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _Icon=__webpack_require__(31);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var IconColorCian=exports.IconColorCian='fill: '+_colors.veloeBlue;var IconColorDarkBlue=exports.IconColorDarkBlue='fill: '+_colors.linkNavyBlue+';';var CallContainer=exports.CallContainer=_styledComponents2.default.div.withConfig({displayName:'styles__CallContainer',componentId:'sc-10pmig9-0'})(['']);var Container=exports.Container=(0,_styledComponents2.default)(_gridStyled.Flex).withConfig({displayName:'styles__Container',componentId:'sc-10pmig9-1'})(['background-color:',';border-radius:',';box-sizing:border-box;flex-direction:row;height:',';align-items:center;padding-left:',';',';'],_colors.ghostWhite,(0,_rem2.default)('4.4px'),(0,_rem2.default)('76px'),(0,_rem2.default)('20px'),_media2.default.large(_templateObject,(0,_rem2.default)('25px'),(0,_rem2.default)('10px'),(0,_rem2.default)('190px'),(0,_rem2.default)('15px'),(0,_rem2.default)('10px'),(0,_rem2.default)('10px')));var DownloadItem=exports.DownloadItem=_styledComponents2.default.div.withConfig({displayName:'styles__DownloadItem',componentId:'sc-10pmig9-2'})(['margin:5px 0;']);var IconDownload=exports.IconDownload=(0,_styledComponents2.default)(_Icon.Icon).withConfig({displayName:'styles__IconDownload',componentId:'sc-10pmig9-3'})(['cursor:pointer;display:inline-block;height:20px;width:25px;']);var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-10pmig9-4'})(['color:',';cursor:pointer;font-family:',';font-size:',';height:',';display:inline-block;margin-top:0;margin-left:5px;'],_colors.linkNavyBlue,_types.txt14OpenSansBold,(0,_rem2.default)('14px'),(0,_rem2.default)('30px'));var LinkCancelPlan=exports.LinkCancelPlan=(0,_styledComponents2.default)(_gridStyled.Flex).withConfig({displayName:'styles__LinkCancelPlan',componentId:'sc-10pmig9-5'})(['cursor:pointer;margin:',' 0;'],(0,_rem2.default)('15px'));var Text=exports.Text=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__Text',componentId:'sc-10pmig9-6'})(['color:',';font-family:',';text-decoration:none;'],_colors.linkNavyBlue,_types.txt14OpenSansBold);var Arrow=exports.Arrow=(0,_styledComponents2.default)(_Icon.Icon).withConfig({displayName:'styles__Arrow',componentId:'sc-10pmig9-7'})(['margin-left:',';text-decoration:none;'],(0,_rem2.default)('10px'));

/***/ }),
/* 2060 */
/***/ (function(module, exports) {

module.exports = {"downloadTerm":"Termos de Uso","downloadGuide":"Manual do Usuário","downloadPrivacy":"Termo de Privacidade","cancelPlan":"Cancelar plano","cancelAccount":"Cancelar conta"}

/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FinancialInformation=exports.Container=exports.Separator=undefined;var _templateObject=_taggedTemplateLiteral(['\n        margin: ',' 0 ',' 0;\n        align-sefl: stretch;\n        width: 100%;\n        flex-direction: row;\n    '],['\n        margin: ',' 0 ',' 0;\n        align-sefl: stretch;\n        width: 100%;\n        flex-direction: row;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        margin-left: ',';\n    '],['\n        margin-left: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _gridStyled=__webpack_require__(8);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'styles__Separator',componentId:'sc-17uxyn0-0'})(['background-color:',';border:0;height:',';margin:',' 0 ',' 0;'],_colors.offWhite,(0,_rem2.default)('1px'),(0,_rem2.default)('35px'),(0,_rem2.default)('25px'));var Container=exports.Container=(0,_styledComponents2.default)(_gridStyled.Flex).withConfig({displayName:'styles__Container',componentId:'sc-17uxyn0-1'})(['flex-direction:column;',';'],_media2.default.large(_templateObject,(0,_rem2.default)('40px'),(0,_rem2.default)('60px')));var FinancialInformation=exports.FinancialInformation=(0,_styledComponents2.default)(_gridStyled.Flex).withConfig({displayName:'styles__FinancialInformation',componentId:'sc-17uxyn0-2'})(['width:100%;flex-direction:column;',';'],_media2.default.large(_templateObject2,(0,_rem2.default)('41px')));

/***/ }),
/* 2062 */
/***/ (function(module, exports) {

module.exports = {"dados":[{"id":1,"icon":"car","description":"Você pode adicionar mais de um veículo no seu plano e compartilhar o saldo entre eles."},{"id":2,"icon":"tagVeloe","description":"Seu saldo será usado para pagar suas passagens em pedágios, estacionamentos, abastecimento e a também mensalidade do seu plano, descontada na data de aniversário da sua adesão."},{"id":3,"icon":"hand","description":"Baixe o nosso app e conheça nossos outros serviços."}]}

/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/InvoiceDetails/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _lodash=__webpack_require__(43);var _lodash2=_interopRequireDefault(_lodash);var _actions=__webpack_require__(13);var _aleloLogic=__webpack_require__(12);var _utils=__webpack_require__(95);var _gridStyled=__webpack_require__(8);var _paymentMethods=__webpack_require__(649);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _InvoiceComplete=__webpack_require__(2064);var _InvoiceComplete2=_interopRequireDefault(_InvoiceComplete);var _InvoiceHeader=__webpack_require__(2076);var _InvoiceHeader2=_interopRequireDefault(_InvoiceHeader);var _InvoiceResume=__webpack_require__(2079);var _InvoiceResume2=_interopRequireDefault(_InvoiceResume);var _InvoiceValue=__webpack_require__(2082);var _InvoiceValue2=_interopRequireDefault(_InvoiceValue);var _PlanResume=__webpack_require__(255);var _PlanResume2=_interopRequireDefault(_PlanResume);var _InvoiceDetailsHeaderAmount=__webpack_require__(2085);var _InvoiceDetailsHeaderAmount2=_interopRequireDefault(_InvoiceDetailsHeaderAmount);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _PageLoader=__webpack_require__(88);var _PageLoader2=_interopRequireDefault(_PageLoader);var _actions2=__webpack_require__(36);var _styles=__webpack_require__(2088);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import InvoiceFooter from '../../modules/InvoiceFooter'
var InvoiceDetails=function(_Component){_inherits(InvoiceDetails,_Component);function InvoiceDetails(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InvoiceDetails);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InvoiceDetails.__proto__||Object.getPrototypeOf(InvoiceDetails)).call.apply(_ref,[this].concat(args))),_this),_this.parsePositive=function(number){return String(number).includes('-')?number*-1:number;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InvoiceDetails,[{key:'componentWillMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.props.setLoading(true);_context.next=3;return this.fetchDetails();case 3:case'end':return _context.stop();}}},_callee,this);}));function componentWillMount(){return _ref2.apply(this,arguments);}return componentWillMount;}()},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var hasPlanChange=this.props.accountPlans.activePlanId!==nextProps.accountPlans.activePlanId;if(hasPlanChange){this.props.setLoading(true);this.props.invoiceDetails(this.props.match.params.id,this.props.match.params.fatura,this.props.match.params.qtdtransacoes);}return true;}},{key:'fetchDetails',value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(){var _this2=this;var params;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:params=this.props.match.params||{};this.props.setLoading(true);_context2.next=4;return this.props.fetchResume(params.id);case 4:_context2.next=6;return this.props.invoiceDetails(params.id,params.fatura,params.qtdtransacoes).then(function(resp){_this2.props.setLoading(false);});case 6:case'end':return _context2.stop();}}},_callee2,this);}));function fetchDetails(){return _ref3.apply(this,arguments);}return fetchDetails;}()},{key:'render',value:function render(){var _this3=this;var _props=this.props,details=_props.details,resume=_props.resume,user=_props.user,bankData=_props.bankData,match=_props.match;var email=user.email||'';var vehicles=resume.vehicles||[];var title='Atual';var vencimento='Em Aberto';var faturaId=match.params.fatura;var currentInvoice=this.props.invoices.data.find(function(invoice){return invoice.numero===parseInt(faturaId);});if(!details){return null;}if(!details)return _react2.default.createElement(_PageLoader2.default,{__source:{fileName:_jsxFileName,lineNumber:75}});var invoiceProps={status:currentInvoice?currentInvoice.status:'',email:email,nfe:details.linkNFE||'',linkFaturaPDF:details.linkFaturaPDF||'',linkFaturaCSV:details.linkFaturaCSV||'',linkBoleto:details.linkBoleto||'',printRef:this.printRef,transacoes:details&&details.transacoes&&details.transacoes.length,nsu:currentInvoice?currentInvoice.nsu:''};return _react2.default.createElement(_PageLoader2.default,{__source:{fileName:_jsxFileName,lineNumber:90}},resume&&_react2.default.createElement(_styles.Structure,{ref:function ref(node){return _this3.printRef=node;},__source:{fileName:_jsxFileName,lineNumber:92}},_react2.default.createElement(_InvoiceHeader2.default,_extends({title:faturaId==='0'||!details.dataVencimento?title:!_lodash2.default.isEmpty(details)?(0,_utils.capitalize)((0,_utils.ISODateFormat)(details.dataVencimento,'MMMM'))+'/'+(0,_utils.ISODateFormat)(details.dataVencimento,'YY'):''},invoiceProps,{__source:{fileName:_jsxFileName,lineNumber:93}})),_react2.default.createElement(_styles.Resume,{__source:{fileName:_jsxFileName,lineNumber:106}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:107}},_react2.default.createElement(_gridStyled.Flex,{align:'stretch',justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:108}},_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('20px'),0],pr:[0,20],width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:109}}),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],pb:(0,_rem2.default)('20px'),pt:(0,_rem2.default)('20px'),width:[1,8/12],__source:{fileName:_jsxFileName,lineNumber:110}},_react2.default.createElement(_InvoiceValue2.default,{currentInvoice:!details.dataVencimento&&!details.formaPagamento,date:faturaId==='0'||!details.dataVencimento?vencimento:(0,_utils.ISODateFormat)(details.dataVencimento),paymentMethod:!_lodash2.default.isEmpty(details)?_paymentMethods.paymentMethodDescription[details.formaPagamento]:'',bankName:bankData&&bankData.bankName?bankData.bankName:'',total:!_lodash2.default.isEmpty(details)?_aleloLogic.utils.currencyParser(this.parsePositive(details.total)):'',__source:{fileName:_jsxFileName,lineNumber:111}}))))),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:132}},_react2.default.createElement(_gridStyled.Flex,{mt:[0,(0,_rem2.default)('35px')],align:'stretch',justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:133}},_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('20px'),0],pr:[0,20],width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:134}},_react2.default.createElement(_styles.BoxPlanResume,{__source:{fileName:_jsxFileName,lineNumber:135}},_react2.default.createElement(_PlanResume2.default,{active:resume.active,category:resume.category,name:resume.name,vehicles:vehicles.length,__source:{fileName:_jsxFileName,lineNumber:136}}))),_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('20px'),0],pl:[0,20],width:[1,8/12],__source:{fileName:_jsxFileName,lineNumber:144}},_react2.default.createElement(_InvoiceResume2.default,{benefitsValue:details.totalBeneficios,dataServices:details.servicosVeloe,dataConsumption:details.consumos,subtotalValue:details.subTotal,totalValue:details.total,__source:{fileName:_jsxFileName,lineNumber:145}})))),details&&details.transacoes&&details.exibirTransacoes&&_react2.default.createElement(_InvoiceComplete2.default,{data:details,__source:{fileName:_jsxFileName,lineNumber:157}}),details.exibirTransacoes&&_react2.default.createElement(_InvoiceDetailsHeaderAmount2.default,{amount:details.total*-1||0,__source:{fileName:_jsxFileName,lineNumber:159}})));}}]);return InvoiceDetails;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref4){var reducer=_ref4.reducer;return{accountPlans:reducer.accountPlans,details:reducer.invoiceDetails.details,resume:reducer.dashboardResume,user:reducer.account,invoices:reducer.dashboardInvoices,bankData:reducer.accountPlans.plans.find(function(plan){return plan.accountId===reducer.accountPlans.activePlanId;})?reducer.accountPlans.plans.find(function(plan){return plan.accountId===reducer.accountPlans.activePlanId;}).debitPaymentData:null};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{resetInvoices:function resetInvoices(){return dispatch((0,_actions.resetDashboardInvoices)());},invoiceDetails:function invoiceDetails(planId,faturaId,qtdTransacoes){return dispatch((0,_actions.fetchInvoiceDetails)(planId,faturaId,qtdTransacoes)).then().catch(function(resp){if(resp&&(resp.status===401||resp.status===403)){dispatch((0,_actions.fetchLogout)());ownProps.history.push('/conta/login');}});},fetchResume:function fetchResume(planId){return dispatch((0,_actions.fetchDashboardResume)(planId)).then().catch(function(resp){if(resp&&(resp.status===401||resp.status===403)){dispatch((0,_actions.fetchLogout)());ownProps.history.push('/conta/login');}});},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(InvoiceDetails);module.exports=exports['default'];

/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/InvoiceComplete/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _InvoiceDetailsVehicle=__webpack_require__(2065);var _InvoiceDetailsVehicle2=_interopRequireDefault(_InvoiceDetailsVehicle);var _InvoiceDetailsListHeaders=__webpack_require__(2068);var _InvoiceDetailsListHeaders2=_interopRequireDefault(_InvoiceDetailsListHeaders);var _data=__webpack_require__(2074);var _styles=__webpack_require__(2075);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// function calcAmount(data) {
//   let amount = 0
//   data.forEach(el => {
//     if (el.type.caption !== benefits) amount += el.value
//   })
//   return amount
// }
// function groupData(data) {
//   const groupedData = utils.groupArray(data || [], item => item.vehicle.licensePlate)
//   const keys = Object.keys(groupedData)
//   return { keys, groupedData }
// }
// function renderInvoiceComplete(data) {
//   const group = groupData(data)
//   return group.keys.map(key => {
//     const amountVehicle = calcAmount(group.groupedData[key])
//     const conductor = group.groupedData[key][0].vehicle.conductor
//     return (
//       <InvoiceTable key={key}>
//         <InvoiceDetailsVehicle
//           amount={amountVehicle}
//           conductorName={conductor}
//           licensePlateNumber={key}
//         />
//         <InvoiceDetailsListHeaders data={group.groupedData[key]} />
//       </InvoiceTable>
//     )
//   })
// }
function renderInvoiceComplete(data){return data.transacoes.map(function(item,i){return _react2.default.createElement(_styles.InvoiceTable,{key:i,__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_InvoiceDetailsVehicle2.default,{amount:_aleloLogic.utils.currencyParser(item.total*-1,_data.currency),licensePlateNumber:item.placa,conductorName:item.condutor,transacao:item,__source:{fileName:_jsxFileName,lineNumber:45}}),_react2.default.createElement(_InvoiceDetailsListHeaders2.default,{data:item.transacoesAgrupadas,__source:{fileName:_jsxFileName,lineNumber:51}}));});}var InvoiceComplete=function InvoiceComplete(_ref){var data=_ref.data;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:56}},renderInvoiceComplete(data));};exports.default=InvoiceComplete;module.exports=exports['default'];

/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/InvoiceDetailsVehicle/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _styles=__webpack_require__(2066);var _data=__webpack_require__(2067);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InvoiceDetailsVehicle=function InvoiceDetailsVehicle(_ref){var amount=_ref.amount,licensePlateNumber=_ref.licensePlateNumber,transacao=_ref.transacao;return _react2.default.createElement(_styles.VehicleBar,{__source:{fileName:_jsxFileName,lineNumber:10}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement(_gridStyled.Flex,{align:'center',justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_gridStyled.Box,{width:[1,2/12],style:{height:41,display:'flex',flexDirection:'column'},__source:{fileName:_jsxFileName,lineNumber:13}},licensePlateNumber===''?_react2.default.createElement(_styles.Span,{__source:{fileName:_jsxFileName,lineNumber:22}},transacao.transacoesAgrupadas[0].tipoTransacao):_react2.default.createElement(_styles.Span,{__source:{fileName:_jsxFileName,lineNumber:24}},_data.vehicle)),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,4/12],style:{height:41,display:'flex',flexDirection:'column'},__source:{fileName:_jsxFileName,lineNumber:27}},licensePlateNumber&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_styles.Span,{__source:{fileName:_jsxFileName,lineNumber:38}},_data.licensePlate),_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:39}},licensePlateNumber))),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,4/12],style:{height:41,display:'flex',flexDirection:'column'},__source:{fileName:_jsxFileName,lineNumber:43}}),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,2/12],style:{height:41,display:'flex',flexDirection:'column'},__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_styles.Span,{__source:{fileName:_jsxFileName,lineNumber:61}},_data.subtotal,' (',_data.currency,')'),_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:65}},amount)))));};exports.default=InvoiceDetailsVehicle;module.exports=exports['default'];

/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Title=exports.Span=exports.VehicleBar=exports.Content=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-1xhdjy9-0'})(['',';'],_content2.default);var VehicleBar=exports.VehicleBar=_styledComponents2.default.div.withConfig({displayName:'styles__VehicleBar',componentId:'sc-1xhdjy9-1'})(['background-color:',';color:',';padding:',' 0;'],_colors.skyBlue,_colors.white,(0,_rem2.default)('25px'));var Span=exports.Span=_styledComponents2.default.div.withConfig({displayName:'styles__Span',componentId:'sc-1xhdjy9-2'})(['',';text-transform:uppercase;'],_types.txt12OpenSans);var Title=exports.Title=_styledComponents2.default.div.withConfig({displayName:'styles__Title',componentId:'sc-1xhdjy9-3'})(['',';'],_types.txt14OpenSansBold);

/***/ }),
/* 2067 */
/***/ (function(module, exports) {

module.exports = {"conductor":"Condutor","currency":"R$","licensePlate":"Placa","subtotal":"Subtotal","vehicle":"Veículo"}

/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/InvoiceDetailsListHeaders/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _InvoiceDetailsListItems=__webpack_require__(2069);var _InvoiceDetailsListItems2=_interopRequireDefault(_InvoiceDetailsListItems);var _styles=__webpack_require__(2072);var _data=__webpack_require__(2073);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// function calcAmount(data) {
//   let amount = 0
//   data.forEach(el => {
//     amount += el.value
//   })
//   return utils.currencyParser(amount)
// }
function renderHeaderCat(typeName){if(typeName.tipoTransacao===_data.toll)return _data.cat;if(typeName.tipoTransacao===_data.parking)return _data.stay;return'';}function renderHeaderPlace(typeName){return typeName.tipoTransacao===_data.veloeServices||typeName.tipoTransacao===_data.benefits?_data.description:_data.place;}function renderHeaderHour(typeName){return typeName.tipoTransacao===_data.parking?_data.entExt:_data.hour;}function renderHeaderPayable(typeName,amountType){if(typeName.tipoTransacao===_data.benefits)return _data.receive+' ('+_data.currency+') -'+amountType;// if (typeName.tipoTransacao === veloeServices) return `${valuesIn} (${currency})`
return _data.payable+' ('+_data.currency+') '+amountType;}function parsePositive(number){return String(number).includes('-')?number*-1:number;}function renderGroups(data,loadingItem){// const groupedData = utils.groupArray(data || [], item => item.type.caption)
// const keys = Object.keys(groupedData)
return data.map(function(key,i){var amountType=_aleloLogic.utils.currencyParser(parsePositive(key.total));return _react2.default.createElement('div',{key:i,__source:{fileName:_jsxFileName,lineNumber:66}},loadingItem&&parseInt(loadingItem)===i?_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:68}},_react2.default.createElement(_styles.GroupHeader,{__source:{fileName:_jsxFileName,lineNumber:69}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:70}},_react2.default.createElement(_gridStyled.Flex,{align:'center',justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:71}},_react2.default.createElement(_gridStyled.Box,{width:[1,2/12],__source:{fileName:_jsxFileName,lineNumber:72}},_react2.default.createElement(_styles.GroupSpan,{__source:{fileName:_jsxFileName,lineNumber:73}},key.tipoTransacao)),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,1/12],__source:{fileName:_jsxFileName,lineNumber:75}},_react2.default.createElement(_styles.GroupSpan,{__source:{fileName:_jsxFileName,lineNumber:76}},_data.date)),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,2/12],__source:{fileName:_jsxFileName,lineNumber:78}},_react2.default.createElement(_styles.GroupSpanCenter,{__source:{fileName:_jsxFileName,lineNumber:79}},renderHeaderHour(key))),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,1/12],__source:{fileName:_jsxFileName,lineNumber:81}},_react2.default.createElement(_styles.GroupSpanCenter,{__source:{fileName:_jsxFileName,lineNumber:82}},renderHeaderCat(key))),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:84}},_react2.default.createElement(_styles.GroupSpan,{__source:{fileName:_jsxFileName,lineNumber:85}},renderHeaderPlace(key))),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:87}},_react2.default.createElement(_styles.GroupAmountSpan,{__source:{fileName:_jsxFileName,lineNumber:88}},renderHeaderPayable(key,amountType)))))),_react2.default.createElement(_InvoiceDetailsListItems2.default,{data:key,__source:{fileName:_jsxFileName,lineNumber:93}})):null,!loadingItem&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:97}},_react2.default.createElement(_styles.GroupHeader,{__source:{fileName:_jsxFileName,lineNumber:98}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:99}},_react2.default.createElement(_gridStyled.Flex,{align:'center',justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:100}},_react2.default.createElement(_gridStyled.Box,{width:[1,2/12],__source:{fileName:_jsxFileName,lineNumber:101}},_react2.default.createElement(_styles.GroupSpan,{__source:{fileName:_jsxFileName,lineNumber:102}},key.tipoTransacao)),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,1/12],__source:{fileName:_jsxFileName,lineNumber:104}},_react2.default.createElement(_styles.GroupSpan,{__source:{fileName:_jsxFileName,lineNumber:105}},_data.date)),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,2/12],__source:{fileName:_jsxFileName,lineNumber:107}},_react2.default.createElement(_styles.GroupSpanCenter,{__source:{fileName:_jsxFileName,lineNumber:108}},renderHeaderHour(key))),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,1/12],__source:{fileName:_jsxFileName,lineNumber:110}},_react2.default.createElement(_styles.GroupSpanCenter,{__source:{fileName:_jsxFileName,lineNumber:111}},renderHeaderCat(key))),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:113}},_react2.default.createElement(_styles.GroupSpan,{__source:{fileName:_jsxFileName,lineNumber:114}},renderHeaderPlace(key))),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:116}},_react2.default.createElement(_styles.GroupAmountSpan,{__source:{fileName:_jsxFileName,lineNumber:117}},renderHeaderPayable(key,amountType)))))),_react2.default.createElement(_InvoiceDetailsListItems2.default,{data:key,__source:{fileName:_jsxFileName,lineNumber:122}})));});}var InvoiceDetailsListHeaders=function InvoiceDetailsListHeaders(_ref){var data=_ref.data,loadingItem=_ref.loadingItem;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:131}},renderGroups(data,loadingItem));};exports.default=InvoiceDetailsListHeaders;module.exports=exports['default'];

/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/InvoiceDetailsListItems/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _styles=__webpack_require__(2070);var _data=__webpack_require__(2071);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function renderHour(item,transacao){return item.tipoTransacao===_data.parking?renderColor(item,transacao,(transacao.horaEntrada||'')+' / '+(transacao.horaSaida||'')):renderColor(item,transacao,transacao.hora||'');}function renderCategory(item,transacao){if(item.tipoTransacao===_data.toll){if(transacao.categoria<10)return renderColor(item,transacao,''+(transacao.categoria||'-'));return renderColor(item,transacao,transacao.categoria);}if(item.tipoTransacao===_data.parking)return renderColor(item,transacao,transacao.permanencia||'');return'';}function renderPlace(item,transacao){if(item.tipoTransacao===_data.veloeServices||item.tipoTransacao===_data.benefits){return _react2.default.createElement(_styles.ItemStrongGrey,{__source:{fileName:_jsxFileName,lineNumber:40}},renderColor(item,transacao,item.tipoTransacao));}return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_styles.ItemStrongGrey,{__source:{fileName:_jsxFileName,lineNumber:44}},renderColor(item,transacao,transacao.estabelecimento)),_react2.default.createElement(_styles.ItemSpan,{__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:47}},renderColor(item,transacao,transacao.endereco))));}function renderValue(item,transacao){if(item.tipoTransacao===_data.benefits||!String(transacao.valor).includes('-'))return _react2.default.createElement(_styles.ValueBlue,{__source:{fileName:_jsxFileName,lineNumber:55}},_aleloLogic.utils.currencyParser(transacao.valor*-1));return _react2.default.createElement(_styles.Value,{__source:{fileName:_jsxFileName,lineNumber:56}},_aleloLogic.utils.currencyParser(transacao.valor*-1));}function renderColor(item,transacao,value){if(item.tipoTransacao===_data.benefits||!String(transacao.valor).includes('-'))return _react2.default.createElement(_styles.ValueYellow,{__source:{fileName:_jsxFileName,lineNumber:61}},value);return value;}function renderItems(data){return data&&data.transacaoes&&data.transacaoes.map(function(transacao,i){return _react2.default.createElement(_styles.Item,{key:i,__source:{fileName:_jsxFileName,lineNumber:70}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:71}},_react2.default.createElement(_styles.ItemRow,{align:'center',justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:72}},_react2.default.createElement(_styles.ItemCell,{width:[1,2/12],__source:{fileName:_jsxFileName,lineNumber:73}}),_react2.default.createElement(_styles.ItemCell,{pl:[0,20],width:[1,1/12],__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement(_styles.ItemStrong,{__source:{fileName:_jsxFileName,lineNumber:75}},renderColor(data,transacao,_aleloLogic.utils.ISODateFormat(transacao.data)))),_react2.default.createElement(_styles.ItemCell,{pl:[0,20],width:[1,2/12],__source:{fileName:_jsxFileName,lineNumber:79}},_react2.default.createElement(_styles.ItemSpanCenter,{__source:{fileName:_jsxFileName,lineNumber:80}},renderHour(data,transacao))),_react2.default.createElement(_styles.ItemCell,{pl:[0,20],width:[1,1/12],__source:{fileName:_jsxFileName,lineNumber:82}},_react2.default.createElement(_styles.ItemSpanCenter,{__source:{fileName:_jsxFileName,lineNumber:83}},renderCategory(data,transacao))),_react2.default.createElement(_styles.ItemCell,{pl:[0,20],width:[1,5/12],__source:{fileName:_jsxFileName,lineNumber:85}},renderPlace(data,transacao)),_react2.default.createElement(_styles.ItemCell,{pl:[0,20],width:[1,1/12],__source:{fileName:_jsxFileName,lineNumber:88}},renderValue(data,transacao)))));});}var InvoiceDetailsListItems=function InvoiceDetailsListItems(_ref){var data=_ref.data;return data&&_react2.default.createElement(_styles.GroupItems,{__source:{fileName:_jsxFileName,lineNumber:98}},renderItems(data));};exports.default=InvoiceDetailsListItems;module.exports=exports['default'];

/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ValueYellow=exports.ValueBlue=exports.Value=exports.ItemStrongGrey=exports.ItemStrongBlue=exports.ItemStrongCenter=exports.ItemStrong=exports.ItemSpanCenter=exports.ItemSpan=exports.ItemCell=exports.ItemRow=exports.Item=exports.GroupItems=exports.Content=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _gridStyled=__webpack_require__(8);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-1z12shq-0'})(['',';'],_content2.default);var GroupItems=exports.GroupItems=_styledComponents2.default.div.withConfig({displayName:'styles__GroupItems',componentId:'sc-1z12shq-1'})(['margin-bottom:',';'],(0,_rem2.default)('25px'));var Item=exports.Item=_styledComponents2.default.div.withConfig({displayName:'styles__Item',componentId:'sc-1z12shq-2'})(['position:relative;&:before{background-color:',';content:\'\';display:inline-block;height:100%;position:absolute;width:calc(((100% - ',') / 2) + ((2 / 12) * ','));}&:nth-child(2n + 1){background-color:',';}'],_colors.white,(0,_rem2.default)('1000px'),(0,_rem2.default)('1000px'),_colors.offWhite);var ItemRow=exports.ItemRow=(0,_styledComponents2.default)(_gridStyled.Flex).withConfig({displayName:'styles__ItemRow',componentId:'sc-1z12shq-3'})(['padding:0;']);var ItemCell=exports.ItemCell=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'styles__ItemCell',componentId:'sc-1z12shq-4'})(['padding-bottom:',';padding-top:',';'],(0,_rem2.default)('4px'),(0,_rem2.default)('4px'));var ItemSpan=exports.ItemSpan=_styledComponents2.default.div.withConfig({displayName:'styles__ItemSpan',componentId:'sc-1z12shq-5'})(['',';color:',';span{text-transform:uppercase;}'],_types.txt12OpenSansLight,_colors.darkGrey);var ItemSpanCenter=exports.ItemSpanCenter=_styledComponents2.default.div.withConfig({displayName:'styles__ItemSpanCenter',componentId:'sc-1z12shq-6'})(['',';color:',';text-align:center;'],_types.txt12OpenSansLight,_colors.linkNavyBlue);var ItemStrong=exports.ItemStrong=_styledComponents2.default.div.withConfig({displayName:'styles__ItemStrong',componentId:'sc-1z12shq-7'})(['',';color:',';'],_types.txt12OpenSansBold,_colors.linkNavyBlue);var ItemStrongCenter=exports.ItemStrongCenter=_styledComponents2.default.div.withConfig({displayName:'styles__ItemStrongCenter',componentId:'sc-1z12shq-8'})(['',';color:',';text-align:center;'],_types.txt12OpenSansBold,_colors.linkNavyBlue);var ItemStrongBlue=exports.ItemStrongBlue=_styledComponents2.default.div.withConfig({displayName:'styles__ItemStrongBlue',componentId:'sc-1z12shq-9'})(['',';color:',';'],_types.txt12OpenSansBold,_colors.skyBlue);var ItemStrongGrey=exports.ItemStrongGrey=_styledComponents2.default.div.withConfig({displayName:'styles__ItemStrongGrey',componentId:'sc-1z12shq-10'})(['',';color:',';'],_types.txt12OpenSansBold,_colors.darkGrey);var Value=exports.Value=_styledComponents2.default.div.withConfig({displayName:'styles__Value',componentId:'sc-1z12shq-11'})(['',';color:',';text-align:right;'],_types.txt12OpenSansBold,_colors.linkNavyBlue);var ValueBlue=exports.ValueBlue=_styledComponents2.default.div.withConfig({displayName:'styles__ValueBlue',componentId:'sc-1z12shq-12'})(['',';color:',';text-align:right;'],_types.txt12OpenSansBold,_colors.olive);var ValueYellow=exports.ValueYellow=_styledComponents2.default.div.withConfig({displayName:'styles__ValueYellow',componentId:'sc-1z12shq-13'})(['',';line-height:1.5;color:',';'],_types.txt12OpenSansBold,_colors.olive);

/***/ }),
/* 2071 */
/***/ (function(module, exports) {

module.exports = {"benefits":"BENEFICIO","parking":"ESTACIONAMENTO","toll":"PEDAGIO","veloeServices":"MENSALIDADE"}

/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.GroupAmountSpan=exports.GroupSpanCenter=exports.GroupSpan=exports.GroupHeader=exports.Content=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-125bdqg-0'})(['',';'],_content2.default);var GroupHeader=exports.GroupHeader=_styledComponents2.default.div.withConfig({displayName:'styles__GroupHeader',componentId:'sc-125bdqg-1'})(['background-color:',';border-bottom:',' ',' solid;border-top:',' ',' solid;padding:',' 0;'],_colors.white,(0,_rem2.default)('2px'),_colors.borderGrey,(0,_rem2.default)('2px'),_colors.borderGrey,(0,_rem2.default)('10px'));var GroupSpan=exports.GroupSpan=_styledComponents2.default.div.withConfig({displayName:'styles__GroupSpan',componentId:'sc-125bdqg-2'})(['',';color:',';text-transform:uppercase;'],_types.txt12OpenSansLight,_colors.darkGrey);var GroupSpanCenter=exports.GroupSpanCenter=_styledComponents2.default.div.withConfig({displayName:'styles__GroupSpanCenter',componentId:'sc-125bdqg-3'})(['',';color:',';text-align:center;text-transform:uppercase;'],_types.txt12OpenSansLight,_colors.darkGrey);var GroupAmountSpan=exports.GroupAmountSpan=_styledComponents2.default.div.withConfig({displayName:'styles__GroupAmountSpan',componentId:'sc-125bdqg-4'})(['',';color:',';text-transform:uppercase;text-align:right;'],_types.txt12OpenSansLight,_colors.darkGrey);

/***/ }),
/* 2073 */
/***/ (function(module, exports) {

module.exports = {"benefits":"BENEFICIO","cat":"Cat","currency":"R$","date":"Data","description":"Descrição","entExt":"Ent/Sai","hour":"Hora","payable":"A pagar","parking":"ESTACIONAMENTO","place":"Estabelecimento","receive":"Receber","stay":"Perm","toll":"PEDAGIO","valuesIn":"Valores em","veloeServices":"MENSALIDADE"}

/***/ }),
/* 2074 */
/***/ (function(module, exports) {

module.exports = {"benefits":"Benefícios","currency":"R$"}

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.InvoiceTable=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: none;\n    '],['\n        display: none;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InvoiceTable=exports.InvoiceTable=_styledComponents2.default.div.withConfig({displayName:'styles__InvoiceTable',componentId:'sc-k00j01-0'})(['',';@media{',';}'],_media2.default.small(_templateObject),function(props){return props.noBreak?'':'display: block;\n    page-break-before: initial;';});

/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/InvoiceHeader/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(15);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _actions2=__webpack_require__(18);var _actions3=__webpack_require__(36);var _ModalTypes=__webpack_require__(20);var _Icon=__webpack_require__(31);var _mailTo=__webpack_require__(256);var _mailTo2=_interopRequireDefault(_mailTo);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);var _styles=__webpack_require__(2077);var _data=__webpack_require__(2078);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var InvoiceHeader=function InvoiceHeader(_ref){var title=_ref.title,match=_ref.match,email=_ref.email,nfe=_ref.nfe,status=_ref.status,transacoes=_ref.transacoes,nsu=_ref.nsu,linkFaturaPDF=_ref.linkFaturaPDF,linkFaturaCSV=_ref.linkFaturaCSV,linkBoleto=_ref.linkBoleto,props=_objectWithoutProperties(_ref,['title','match','email','nfe','status','transacoes','nsu','linkFaturaPDF','linkFaturaCSV','linkBoleto']);return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement(_styles.ResumeTitle,{__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:52}},_data.invoice),_react2.default.createElement(_styles.Title,{id:'detalhe_fatura_mes',__source:{fileName:_jsxFileName,lineNumber:53}},title)),_react2.default.createElement(_styles.NavHeader,{__source:{fileName:_jsxFileName,lineNumber:55}},nfe&&_react2.default.createElement(_styles.NavIcon,{title:'Download da NFe',id:'btn_download_nfe',__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_Icon.Icon,{icon:'doc',svgStyle:_styles.IconColor,'aria-label':_data.downloadInvoice,width:'40',height:'40',viewBox:'0 0 45 45',onClick:function onClick(){return window.open(nfe,'_blank');},__source:{fileName:_jsxFileName,lineNumber:58}})),linkFaturaCSV&&_react2.default.createElement(_styles.NavIcon,{className:'print',title:'Download fatura em CSV',id:'btn_download_csv',__source:{fileName:_jsxFileName,lineNumber:70}},_react2.default.createElement(_Icon.Icon,{icon:'download',svgStyle:_styles.IconColor,'aria-label':_data.downloadInvoice,width:'40',height:'40',viewBox:'0 0 70 70',onClick:function onClick(){return window.open(linkFaturaCSV,'_blank');},__source:{fileName:_jsxFileName,lineNumber:71}})),linkBoleto&&_react2.default.createElement(_styles.NavIcon,{title:'Download do Boleto',id:'btn_download_boleto',__source:{fileName:_jsxFileName,lineNumber:96}},_react2.default.createElement(_Icon.Icon,{icon:'barcode',svgStyle:_styles.IconColor,'aria-label':_data.downloadBoleto,width:'40',height:'40',viewBox:'0 0 23 23',onClick:function onClick(){return window.open(linkBoleto,'_blank');},__source:{fileName:_jsxFileName,lineNumber:97}})),linkFaturaPDF&&_react2.default.createElement(_styles.NavIcon,{className:'print',title:'Download fatura em PDF',id:'btn_download_pdf',__source:{fileName:_jsxFileName,lineNumber:110}},_react2.default.createElement(_Icon.Icon,{icon:'print',svgStyle:_styles.IconColor,'aria-label':_data.printInvoice,width:'40',height:'40',viewBox:'0 0 85 75',onClick:function onClick(){return window.open(linkFaturaPDF,'_blank');},__source:{fileName:_jsxFileName,lineNumber:111}})))));};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{downloadCSVInvoice:function downloadCSVInvoice(planId,invoiceId){return dispatch((0,_actions.downloadInvoiceCSVFile)(planId,invoiceId));},downloadBoletoInvoice:function downloadBoletoInvoice(planId,invoiceId){dispatch((0,_actions3.setLoading)(true));dispatch((0,_actions.downloadTicketFile)(planId,invoiceId)).catch(function(err){console.error(err);return err;}).then(function(){var message=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(message.statusCode==='20'||message.statusName==='NAO_DISPONIVEL_SOLICITANDO'){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.boletoModalTitle,modalDescription:_data.boletoModalBody,image:_confirmation2.default}));}else if(message.statusCode==='21'||message.statusName==='NAO_DISPONIVEL_SOLICITADO_PREVIAMENTE'){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.boletoUnavailableModalTitle,modalDescription:_data.boletoUnavailableModalBody||message.message,image:_confirmation2.default}));}}).finally(function(){return dispatch((0,_actions3.setLoading)(false));});},downloadFaturaInvoice:function downloadFaturaInvoice(planId,invoiceId){console.log('CAll Download Fatura');dispatch((0,_actions3.setLoading)(true));dispatch((0,_actions.downloadFaturaFile)(planId,invoiceId)).catch(function(err){if(err.status===404||err.statusText==='Not Found'){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.erroModalTitleFatura,modalDescription:_data.erroModalBodyFatura,image:_confirmation2.default}));}else{console.error('Erro download fatura',err);}}).finally(function(){return dispatch((0,_actions3.setLoading)(false));});},downloadPdfInvoice:function downloadPdfInvoice(planId,year,month){return dispatch((0,_actions.downloadInvoiceFile)(planId,year,month)).then(function(response){window.open('data:application/octed-stream;base64,'+response.data);});},shareInvoice:function shareInvoice(planId,year,month,email){dispatch((0,_actions2.showModal)(_ModalTypes.INPUT_MODAL,_extends({},_data.modal,{value:email,fetchSendProvider:function fetchSendProvider(){return fetch('/api/accountplans/'+planId+'/invoices/'+year+'/'+month+'/mail');},onConfirm:function onConfirm(){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:'Sua fatura foi enviada.',image:_mailTo2.default}));},image:_mailTo2.default})));}};};exports.default=(0,_reactRedux.connect)(null,mapDispatchToProps)((0,_reactRouterDom.withRouter)(InvoiceHeader));module.exports=exports['default'];

/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.NavIcon=exports.NavHeader=exports.Title=exports.Text=exports.ResumeTitle=exports.Back=exports.BreadCrumb=exports.Content=exports.IconColor=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ',';\n        margin-top: ',';\n        text-align: left;\n    '],['\n        ',';\n        margin-top: ',';\n        text-align: left;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        .print {\n            display: block;\n        }\n    '],['\n        .print {\n            display: block;\n        }\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var IconColor=exports.IconColor='fill: '+_colors.linkNavyBlue;var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-12w7zi8-0'})(['',';display:flex;flex-direction:row;justify-content:space-between;'],_content2.default);var BreadCrumb=exports.BreadCrumb=_styledComponents2.default.div.withConfig({displayName:'styles__BreadCrumb',componentId:'sc-12w7zi8-1'})(['',' border-bottom:',' solid ',';display:block;font-weight:700;letter-spacing:',';padding:',' 0;@media print{display:none;}','{align-items:center;justify-content:left;}'],_types.txt14OpenSans,(0,_rem2.default)('1px'),_colors.lighterGrey,(0,_rem2.default)('-0.4px'),(0,_rem2.default)('16px'),Content);var Back=exports.Back=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'styles__Back',componentId:'sc-12w7zi8-2'})(['color:',';cursor:pointer;display:table;text-decoration:none;margin:',' 0;*{display:table-cell;vertical-align:middle;}svg{max-width:',';}'],_colors.linkNavyBlue,(0,_rem2.default)('18px'),(0,_rem2.default)('40px'));var ResumeTitle=exports.ResumeTitle=_styledComponents2.default.div.withConfig({displayName:'styles__ResumeTitle',componentId:'sc-12w7zi8-3'})(['padding:',' 0;'],(0,_rem2.default)('42px'));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-12w7zi8-4'})(['',';color:',';margin:0;position:relative;text-transform:uppercase;top:',';'],_types.txt12OpenSansLight,_colors.darkGrey,(0,_rem2.default)('3px'));var Title=exports.Title=_styledComponents2.default.p.withConfig({displayName:'styles__Title',componentId:'sc-12w7zi8-5'})(['',';color:',';margin:0;text-align:right;',';'],_types.title24GalanoBold,_colors.linkNavyBlue,_media2.default.large(_templateObject,_types.title40GalanoBold,(0,_rem2.default)('10')));var NavHeader=exports.NavHeader=_styledComponents2.default.div.withConfig({displayName:'styles__NavHeader',componentId:'sc-12w7zi8-6'})(['align-items:center;display:flex;position:relative;top:',';@media print{display:none;}.print{display:block;}',';'],(0,_rem2.default)('16px'),_media2.default.large(_templateObject2));var NavIcon=exports.NavIcon=_styledComponents2.default.a.withConfig({displayName:'styles__NavIcon',componentId:'sc-12w7zi8-7'})(['cursor:pointer;display:inline-block;height:',';width:',';@media print{display:none;}img{width:100%;height:auto;}:not(:first-child){margin-left:',';}'],(0,_rem2.default)('45px'),(0,_rem2.default)('45px'),(0,_rem2.default)('28px'));

/***/ }),
/* 2078 */
/***/ (function(module, exports) {

module.exports = {"urlInvoices":"/minha-veloe/combo-pre-pago-auto/fatura","backToInvoices":"Voltar para suas faturas","invoice":"Fatura","downloadInvoice":"Fazer download da Fatura","downloadBoleto":"Fazer download do Boleto","nfeInvoice":"Fazer download da Nota fiscal eletrônica","printInvoice":"Imprimir Fatura","shareInvoice":"Compartilhar Fatura","modal":{"title":"Já vamos enviar a sua fatura.","description":"Diga pra gente o e-mail em que você quer receber sua fatura.","buttonText":"Enviar","label":"E-mail","placeholder":"Ex nome@exemplo.com.br"},"boletoModalTitle":"Seu boleto está a caminho!","boletoModalBody":"Você vai receber em até 2 dias úteis no seu e-mail e também poderá consultar no site ou app.","boletoUnavailableModalTitle":"Seu boleto está a caminho!","boletoUnavailableModalBody":"Você vai receber em até 2 dias úteis no seu e-mail e também poderá consultar no site ou app.","erroModalTitleFatura":"Opps!","erroModalBodyFatura":"Problemas ao gerar o pdf da fatura."}

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/InvoiceResume/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _styles=__webpack_require__(2080);var _data=__webpack_require__(2081);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function parseNumber(number){return number<10?'0'+number:number;}function parsePositive(number){return String(number).includes('-')?number*-1:number;}function parseNegative(number){return String(number).includes('-')?number:number*-1;}function renderItems(item,index,idTransacao){if(item.tipoTransacao){var idQtd='detalhe_fatura_qtd_'+item.tipoTransacao.toLowerCase();var idValor='detalhe_fatura_valor_'+item.tipoTransacao.toLowerCase();return _react2.default.createElement(_gridStyled.Flex,{align:'stretch',justify:'space-between',key:index,__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_gridStyled.Box,{width:[1,8/12],__source:{fileName:_jsxFileName,lineNumber:47}},_react2.default.createElement(_styles.SummaryItemTitle,{__source:{fileName:_jsxFileName,lineNumber:48}},item.tipoTransacao)),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,1/12],__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement(_styles.SummaryItemNumber,{id:idQtd,__source:{fileName:_jsxFileName,lineNumber:51}},parseNumber(item.quantidade))),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_styles.SummaryItemNumber,{id:idValor,__source:{fileName:_jsxFileName,lineNumber:54}},_aleloLogic.utils.currencyParser(parsePositive(item.total),_data.currency))));}}function renderResume(items){return items.map(function(item,index){return renderItems(item,index);});}var InvoiceResume=function InvoiceResume(_ref){var benefitsValue=_ref.benefitsValue,dataServices=_ref.dataServices,dataConsumption=_ref.dataConsumption,subtotalValue=_ref.subtotalValue,totalValue=_ref.totalValue;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:75}},dataServices&&dataConsumption&&_react2.default.createElement(_styles.ResumeContent,{__source:{fileName:_jsxFileName,lineNumber:78}},_react2.default.createElement(_styles.GroupedSummary,{__source:{fileName:_jsxFileName,lineNumber:79}},_react2.default.createElement(_styles.SummaryCategory,{__source:{fileName:_jsxFileName,lineNumber:80}},_data.veloeServices),renderResume(dataServices)),_react2.default.createElement(_styles.GroupedSummary,{__source:{fileName:_jsxFileName,lineNumber:83}},_react2.default.createElement(_styles.SummaryCategory,{__source:{fileName:_jsxFileName,lineNumber:84}},_data.consumption),renderResume(dataConsumption)),_react2.default.createElement(_gridStyled.Flex,{align:'stretch',justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:87}},_react2.default.createElement(_gridStyled.Box,{pt:6,width:[1,9/12],__source:{fileName:_jsxFileName,lineNumber:88}},_react2.default.createElement(_styles.Subtotal,{__source:{fileName:_jsxFileName,lineNumber:89}},_data.subtotal),_react2.default.createElement(_styles.Benefits,{__source:{fileName:_jsxFileName,lineNumber:90}},_data.benefits),_react2.default.createElement(_styles.Total,{__source:{fileName:_jsxFileName,lineNumber:91}},_data.total)),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:93}},_react2.default.createElement(_styles.Values,{__source:{fileName:_jsxFileName,lineNumber:94}},_react2.default.createElement(_styles.Subtotal,{id:'detalhe_fatura_sub_total',__source:{fileName:_jsxFileName,lineNumber:95}},_aleloLogic.utils.currencyParser(parsePositive(subtotalValue),_data.currency)),_react2.default.createElement(_styles.Benefits,{id:'detalhe_fatura_valor_beneficios',__source:{fileName:_jsxFileName,lineNumber:98}},_aleloLogic.utils.currencyParser(parseNegative(benefitsValue),_data.currency)),_react2.default.createElement(_styles.Total,{id:'detalhe_fatura_valor_total',__source:{fileName:_jsxFileName,lineNumber:101}},_aleloLogic.utils.currencyParser(parsePositive(totalValue),_data.currency))))),_react2.default.createElement(_styles.Message,{__source:{fileName:_jsxFileName,lineNumber:107}},_data.messageTax),_react2.default.createElement(_styles.Message,{marginBottom:true,__source:{fileName:_jsxFileName,lineNumber:108}},_data.messageTax2)));};exports.default=InvoiceResume;module.exports=exports['default'];

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Message=exports.Values=exports.Total=exports.Benefits=exports.Subtotal=exports.SummaryItemNumber=exports.SummaryItemTitle=exports.SummaryCategory=exports.GroupedSummary=exports.ResumeContent=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ResumeContent=exports.ResumeContent=_styledComponents2.default.div.withConfig({displayName:'styles__ResumeContent',componentId:'sc-1al9tsl-0'})(['margin-bottom:',';'],(0,_rem2.default)('40px'));var GroupedSummary=exports.GroupedSummary=_styledComponents2.default.div.withConfig({displayName:'styles__GroupedSummary',componentId:'sc-1al9tsl-1'})(['margin-bottom:',';'],(0,_rem2.default)('20px'));var SummaryCategory=exports.SummaryCategory=_styledComponents2.default.div.withConfig({displayName:'styles__SummaryCategory',componentId:'sc-1al9tsl-2'})(['',';color:',';font-weight:bold;text-transform:uppercase;'],_types.txt12OpenSansBold,_colors.linkNavyBlue);var SummaryItemTitle=exports.SummaryItemTitle=_styledComponents2.default.div.withConfig({displayName:'styles__SummaryItemTitle',componentId:'sc-1al9tsl-3'})(['',';color:',';'],_types.txt12OpenSans,_colors.linkNavyBlue);var SummaryItemNumber=exports.SummaryItemNumber=_styledComponents2.default.div.withConfig({displayName:'styles__SummaryItemNumber',componentId:'sc-1al9tsl-4'})(['',';color:',';text-align:right;'],_types.txt12OpenSans,_colors.darkGrey);var Subtotal=exports.Subtotal=_styledComponents2.default.div.withConfig({displayName:'styles__Subtotal',componentId:'sc-1al9tsl-5'})(['',';color:',';font-weight:bold;margin-bottom:',';text-transform:uppercase;'],_types.txt12OpenSansBold,_colors.linkNavyBlue,(0,_rem2.default)('15px'));var Benefits=exports.Benefits=_styledComponents2.default.div.withConfig({displayName:'styles__Benefits',componentId:'sc-1al9tsl-6'})(['',';color:',';font-weight:bold;margin-bottom:',';text-transform:uppercase;'],_types.txt12OpenSansBold,_colors.olive,(0,_rem2.default)('15px'));var Total=exports.Total=_styledComponents2.default.div.withConfig({displayName:'styles__Total',componentId:'sc-1al9tsl-7'})(['',';color:',';font-weight:bold;margin-bottom:',';text-transform:uppercase;'],_types.txt12OpenSansBold,_colors.linkNavyBlue,(0,_rem2.default)('15px'));var Values=exports.Values=_styledComponents2.default.div.withConfig({displayName:'styles__Values',componentId:'sc-1al9tsl-8'})(['',',',',','{text-align:right;}'],Subtotal,Benefits,Total);var Message=exports.Message=_styledComponents2.default.div.withConfig({displayName:'styles__Message',componentId:'sc-1al9tsl-9'})(['',';',';color:',';'],_types.txt12OpenSans,function(props){return props.marginBottom||'margin-bottom: '+(0,_rem2.default)('10px');},_colors.darkGrey);

/***/ }),
/* 2081 */
/***/ (function(module, exports) {

module.exports = {"benefits":"Benefícios","consumption":"Consumo","currency":"R$","messageTax":"* Essa fatura não tem valor fiscal e será considerada quitada após a confirmação do débito em conta ou do lançamento em cartão de crédito.","messageTax2":"** Conforme lei 12.741/12 e IBPT, o valor aproximado dos tributos na prestação de serviço de concessionária operadora de rodovia (pedágio) é de 18,45% e a responsabilidade pelo recolhimento é da respectiva concessionária","subtotal":"Subtotal","total":"total","veloeServices":"Serviços Veloe"}

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/InvoiceValue/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _styles=__webpack_require__(2083);var _lodash=__webpack_require__(43);var _lodash2=_interopRequireDefault(_lodash);var _data=__webpack_require__(2084);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InvoiceValue=function InvoiceValue(_ref){var currentInvoice=_ref.currentInvoice,total=_ref.total,date=_ref.date,paymentMethod=_ref.paymentMethod,bankName=_ref.bankName;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement(_gridStyled.Flex,{align:'stretch',justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_gridStyled.Box,{mb:11,pr:[0,20],width:[1,6/12],__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:14}},_data.maturity),_react2.default.createElement(_styles.Title,{id:'detalhe_fatura_vencimento',__source:{fileName:_jsxFileName,lineNumber:15}},date||_data.open)),_react2.default.createElement(_gridStyled.Box,{pl:[0,40],width:[1,6/12],__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:18}},currentInvoice?_data.partialAmount:_data.amount),_react2.default.createElement(_styles.Value,{__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement(_styles.Currency,{__source:{fileName:_jsxFileName,lineNumber:20}},!_lodash2.default.isEmpty(total)?_data.currency:''),_react2.default.createElement(_styles.Title,{id:'detalhe_fatura_valor_total_parcial',__source:{fileName:_jsxFileName,lineNumber:21}},total)))),paymentMethod&&_react2.default.createElement(_styles.Payment,{__source:{fileName:_jsxFileName,lineNumber:25}},paymentMethod+' '+bankName));};exports.default=InvoiceValue;module.exports=exports['default'];

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Payment=exports.Currency=exports.Value=exports.Text=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ',';\n        margin-top: ',';\n        text-align: left;\n    '],['\n        ',';\n        margin-top: ',';\n        text-align: left;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n            margin-top: 0;\n        '],['\n            margin-top: 0;\n        ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.p.withConfig({displayName:'styles__Title',componentId:'sc-j6fh4d-0'})(['',';color:',';font-size:','!important;margin:0;text-align:right;',';@media print{font-size:','!important;margin-top:',';text-align:left;}'],_types.title24GalanoBold,_colors.linkNavyBlue,(0,_rem2.default)('30px'),_media2.default.large(_templateObject,_types.title40GalanoBold,(0,_rem2.default)('20px')),(0,_rem2.default)('22px'),(0,_rem2.default)('20px'));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-j6fh4d-1'})(['',';color:',';margin:0;position:relative;text-transform:uppercase;top:',';'],_types.txt12OpenSansLight,_colors.darkGrey,(0,_rem2.default)('3px'));var Value=exports.Value=_styledComponents2.default.div.withConfig({displayName:'styles__Value',componentId:'sc-j6fh4d-2'})(['align-items:center;display:flex;flex-direction:row;justify-content:start;padding-top:',';','{',';@media print{margin-top:0 !important;}}'],(0,_rem2.default)('20px'),Title,_media2.default.large(_templateObject2));var Currency=exports.Currency=_styledComponents2.default.p.withConfig({displayName:'styles__Currency',componentId:'sc-j6fh4d-3'})(['',';color:',';font-size:',';margin:0 ',' 0 0;'],_types.title24GalanoBold,_colors.linkNavyBlue,(0,_rem2.default)('15px'),(0,_rem2.default)('10px'));var Payment=exports.Payment=_styledComponents2.default.p.withConfig({displayName:'styles__Payment',componentId:'sc-j6fh4d-4'})(['',';color:',';margin:0;'],_types.txt12OpenSansLight,_colors.darkGrey);

/***/ }),
/* 2084 */
/***/ (function(module, exports) {

module.exports = {"maturity":"Vencimento","amount":"Valor total","partialAmount":"Valor parcial","currency":"R$","open":"Em Aberto"}

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/InvoiceDetailsHeaderAmount/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _styles=__webpack_require__(2086);var _data=__webpack_require__(2087);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var InvoiceDetailHeaderAmount=function InvoiceDetailHeaderAmount(_ref){var amount=_ref.amount;return _react2.default.createElement(_styles.VehicleBar,{__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_gridStyled.Flex,{align:'center',justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_gridStyled.Box,{width:[1,2/12],__source:{fileName:_jsxFileName,lineNumber:14}}),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,4/12],__source:{fileName:_jsxFileName,lineNumber:15}}),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,4/12],__source:{fileName:_jsxFileName,lineNumber:16}}),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,2/12],__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement(_styles.Span,{__source:{fileName:_jsxFileName,lineNumber:18}},_data.total,' (',_data.currency,')'),_react2.default.createElement(_styles.Title,{id:'detalhe_fatura_valor_total_transacoes',__source:{fileName:_jsxFileName,lineNumber:21}},_aleloLogic.utils.currencyParser(amount,_data.currency))))));};exports.default=InvoiceDetailHeaderAmount;module.exports=exports['default'];

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Title=exports.Span=exports.VehicleBar=exports.Content=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-1iicpif-0'})(['',';'],_content2.default);var VehicleBar=exports.VehicleBar=_styledComponents2.default.div.withConfig({displayName:'styles__VehicleBar',componentId:'sc-1iicpif-1'})(['background-color:',';color:',';padding:',' 0;'],_colors.skyBlue,_colors.white,(0,_rem2.default)('25px'));var Span=exports.Span=_styledComponents2.default.div.withConfig({displayName:'styles__Span',componentId:'sc-1iicpif-2'})(['',';text-transform:uppercase;'],_types.txt12OpenSans);var Title=exports.Title=_styledComponents2.default.div.withConfig({displayName:'styles__Title',componentId:'sc-1iicpif-3'})(['',';'],_types.txt14OpenSansBold);

/***/ }),
/* 2087 */
/***/ (function(module, exports) {

module.exports = {"currency":"R$","total":"Total"}

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BoxPlanResume=exports.Resume=exports.Structure=undefined;var _templateObject=_taggedTemplateLiteral(['\n    height: ',';\n  '],['\n    height: ',';\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Structure=exports.Structure=_styledComponents2.default.div.withConfig({displayName:'styles__Structure',componentId:'sc-jzbue2-0'})(['width:100%;']);var Resume=exports.Resume=_styledComponents2.default.div.withConfig({displayName:'styles__Resume',componentId:'sc-jzbue2-1'})(['background-color:',';border:0;',';@media print{height:',';}'],_colors.offWhite,_media2.default.large(_templateObject,(0,_rem2.default)('140px')),(0,_rem2.default)('140px'));var BoxPlanResume=exports.BoxPlanResume=_styledComponents2.default.div.withConfig({displayName:'styles__BoxPlanResume',componentId:'sc-jzbue2-2'})(['margin-top:',';@media print{margin-top:',';}'],(0,_rem2.default)('-154px'),(0,_rem2.default)('-120px'));

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/Login/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _gridStyled=__webpack_require__(8);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _LoginForm=__webpack_require__(2090);var _LoginForm2=_interopRequireDefault(_LoginForm);var _login=__webpack_require__(396);var _login2=_interopRequireDefault(_login);var _logoVeloe=__webpack_require__(397);var _logoVeloe2=_interopRequireDefault(_logoVeloe);var _data=__webpack_require__(2116);var _style=__webpack_require__(2117);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var nomeCompTipoLogin='radioTipoLogin';var tipoPF='loginPessoaFisica';var tipoPJ='loginPessoaJuridica';var Login=function Login(_ref){var doLogin=_ref.doLogin,closeModal=_ref.closeModal,stateModal=_ref.stateModal,loginMsgError=_ref.loginMsgError,showCaptcha=_ref.showCaptcha;return _react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_style.Aside,{__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement('img',{src:_login2.default,alt:'Avatar',__source:{fileName:_jsxFileName,lineNumber:28}})),_react2.default.createElement(_style.Content,{__source:{fileName:_jsxFileName,lineNumber:30}},_react2.default.createElement(_Hide2.default,{at:'large',__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_style.Veloe,{__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement('img',{src:_logoVeloe2.default,alt:'Logo Veloe',__source:{fileName:_jsxFileName,lineNumber:33}}))),_react2.default.createElement(_style.Title,{__source:{fileName:_jsxFileName,lineNumber:36}},_data.title),_react2.default.createElement(_style.Container,{__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_LoginForm2.default,{onSubmit:doLogin,nomeCompTipoLogin:nomeCompTipoLogin,tipoPF:tipoPF,tipoPJ:tipoPJ,isOpen:stateModal,closeModal:closeModal,loginMsgError:loginMsgError,showCaptcha:showCaptcha,__source:{fileName:_jsxFileName,lineNumber:38}}))));};var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{account:reducer.account,stateModal:reducer.loginModal.stateModal,loginMsgError:reducer.loginModal.loginMsgError,showCaptcha:reducer.loginModal.showCaptcha};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{doLogin:function doLogin(values){dispatch((0,_actions.fetchLogout)());var login=values[nomeCompTipoLogin]===tipoPF?values.cpfLogin:values.emailLogin;dispatch((0,_actions.fetchAuthentication)(login,values.password,values.captcha)).then(function(credentials){if(credentials){if(!credentials.active){ownProps.history.push(_data.redirect.canceledAccount);}else{if(credentials.at){ownProps.history.push('/minha-veloe/identificadores-parceiros');return true;}else{ownProps.history.push(_data.redirect.dashboard);return true;}}}}).catch(function(e){e.json().then(function(json){var msg=json.messageError;dispatch((0,_actions.setLoginMsgError)(msg));dispatch((0,_actions.setShowCaptch)(json.captcha));});if(e.status===_data.authCode.unauthorized||e.status===_data.authCode.locked){dispatch((0,_actions.setStateModal)(true));}else{dispatch((0,_actions.setStateModal)(true));console.log(e);// eslint-disable-line
}window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'login',eventCategory:'veloe:login',eventAction:'login:tentativa',eventLabel:'erro'});});},closeModal:function closeModal(){return dispatch((0,_actions.setStateModal)(false));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(Login);module.exports=exports['default'];

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/LoginForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _lodash=__webpack_require__(43);var _reactGoogleRecaptcha=__webpack_require__(2091);var _reactGoogleRecaptcha2=_interopRequireDefault(_reactGoogleRecaptcha);var _ButtonV=__webpack_require__(2110);var _ButtonV2=_interopRequireDefault(_ButtonV);var _renderInputs=__webpack_require__(44);var _data=__webpack_require__(2113);var _style=__webpack_require__(2114);var _constants=__webpack_require__(149);var _config=__webpack_require__(221);var _Radio=__webpack_require__(136);var _Radio2=_interopRequireDefault(_Radio);var _FormModal=__webpack_require__(2115);var _FormModal2=_interopRequireDefault(_FormModal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function validateEmailLogin(value){return value.replace(/[^\w@.\-_]/gi,'');}function validateCpfLogin(value){return value.replace(/[^\d]/gi,'');}function validate(values){var errors={};if(!values||(0,_lodash.isEmpty)(values.cpfLogin||values.emailLogin)){errors.cpfLogin='Não esqueça do número do seu documento.';errors.emailLogin='Não esqueça do seu e-mail.';}else{if(values.cpfLogin)values.cpfLogin=validateCpfLogin(values.cpfLogin);else if(values.emailLogin)values.emailLogin=validateEmailLogin(values.emailLogin);}if((0,_lodash.isEmpty)(values.password)){errors.password='Não esqueça da sua senha.';}if(!values.captcha){errors.captcha='É preciso resolver o captcha.';}return errors;}var renderRadio=function renderRadio(_ref){var input=_ref.input,label=_ref.label,checked=_ref.checked;return _react2.default.createElement(_Radio2.default,_extends({},input,{label:label,checked:checked,__source:{fileName:_jsxFileName,lineNumber:44}}));};var recaptcha=void 0;var renderCaptcha=function renderCaptcha(_ref2){var input=_ref2.input,meta=_ref2.meta;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement(_reactGoogleRecaptcha2.default,{ref:function ref(e){return recaptcha=e;},sitekey:'6Lfkrl4UAAAAACDEi92ieHL94KKMnDNt0c0MUuzs',onChange:function onChange(value){input.onChange(value);},__source:{fileName:_jsxFileName,lineNumber:51}}),meta.touched&&meta.error&&_react2.default.createElement(_style.ErrorMessage,{__source:{fileName:_jsxFileName,lineNumber:58}},meta.error));};var LoginForm=function(_Component){_inherits(LoginForm,_Component);function LoginForm(props){_classCallCheck(this,LoginForm);var _this=_possibleConstructorReturn(this,(LoginForm.__proto__||Object.getPrototypeOf(LoginForm)).call(this,props));_this.resetCaptcha=function(){if(recaptcha){recaptcha.reset();}};_this.onSubmit=function(values){values.radioTipoLogin=_this.state.radioTipoLogin;_this.props.onSubmit(values);};_this.state={radioTipoLogin:props.tipoPJ};_this.handleRadioChange=_this.handleRadioChange.bind(_this);return _this;}_createClass(LoginForm,[{key:'componentDidMount',value:function componentDidMount(){window.dataLayer=window.dataLayer||[];window.dataLayer.push({dimension6:'nao-logado'});}},{key:'handleRadioChange',value:function handleRadioChange(e){var _urlsMap;var urlsMap=(_urlsMap={},_defineProperty(_urlsMap,this.props.tipoPF,_config.pfURL),_defineProperty(_urlsMap,this.props.tipoPJ,_config.pjURL),_urlsMap);this.setState({radioTipoLogin:e.currentTarget.value});window.location=urlsMap[e.currentTarget.value];}},{key:'render',value:function render(){var _props=this.props,isOpen=_props.isOpen,closeModal=_props.closeModal,msgError=_props.msgError,handleSubmit=_props.handleSubmit,nomeCompTipoLogin=_props.nomeCompTipoLogin,tipoPF=_props.tipoPF,tipoPJ=_props.tipoPJ,loginMsgError=_props.loginMsgError,showCaptcha=_props.showCaptcha;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:113}},_react2.default.createElement('form',{onSubmit:handleSubmit(this.onSubmit),__source:{fileName:_jsxFileName,lineNumber:114}},_react2.default.createElement(_style.Radios,{__source:{fileName:_jsxFileName,lineNumber:115}},_react2.default.createElement(_gridStyled.Box,{mb:24,__source:{fileName:_jsxFileName,lineNumber:116}},_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:'Pessoa F\xEDsica',name:nomeCompTipoLogin,type:'radio',value:tipoPF,checked:false,onChange:this.handleRadioChange,__source:{fileName:_jsxFileName,lineNumber:117}})),_react2.default.createElement(_gridStyled.Box,{mb:24,__source:{fileName:_jsxFileName,lineNumber:127}},_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:'Pessoa Jur\xEDdica',name:nomeCompTipoLogin,type:'radio',value:tipoPJ,checked:this.state.radioTipoLogin===tipoPJ,onChange:this.handleRadioChange,__source:{fileName:_jsxFileName,lineNumber:128}}))),_react2.default.createElement(_gridStyled.Flex,{direction:'column',__source:{fileName:_jsxFileName,lineNumber:140}},_react2.default.createElement(_gridStyled.Box,{mb:[24,28],__source:{fileName:_jsxFileName,lineNumber:141}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:'E-mail',name:'emailLogin',__source:{fileName:_jsxFileName,lineNumber:142}})),_react2.default.createElement(_gridStyled.Box,{mb:[17,20],__source:{fileName:_jsxFileName,lineNumber:144}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderPasswordInput,label:'senha',name:'password',__source:{fileName:_jsxFileName,lineNumber:145}})),_react2.default.createElement(_gridStyled.Box,{mb:17,__source:{fileName:_jsxFileName,lineNumber:148}},_react2.default.createElement(_style.TextPassword,{href:_constants.PUBLIC_SITE_URL+'/login/recuperar-a-senha',__source:{fileName:_jsxFileName,lineNumber:149}},_data.forgotpassword)),_react2.default.createElement(_gridStyled.Box,{mb:17,__source:{fileName:_jsxFileName,lineNumber:153}},showCaptcha&&_react2.default.createElement(_reduxForm.Field,{component:renderCaptcha,name:'captcha',__source:{fileName:_jsxFileName,lineNumber:153}}))),_react2.default.createElement(_style.Buttons,{__source:{fileName:_jsxFileName,lineNumber:155}},_react2.default.createElement(_gridStyled.Box,{mr:[0,15],mt:15,flex:1,__source:{fileName:_jsxFileName,lineNumber:156}},_react2.default.createElement(_ButtonV2.default,{type:'submit',text:'Continuar',buttonType:'darkBlue',__source:{fileName:_jsxFileName,lineNumber:157}})),_react2.default.createElement(_gridStyled.Box,{mt:15,__source:{fileName:_jsxFileName,lineNumber:159}},_react2.default.createElement(_ButtonV2.default,{text:'\xC9 sua primeira visita?',buttonType:'white',className:'gtm-element-event','data-gtm-event-category':'veloe:login','data-gtm-event-action':'clique:primeira-visita','data-gtm-event-label':'login',onClick:function onClick(){window.location=_constants.PUBLIC_SITE_URL+'/login/acesso';},__source:{fileName:_jsxFileName,lineNumber:160}})))),_react2.default.createElement(_FormModal2.default,{closeModal:closeModal,isOpen:isOpen,error:msgError,resetCaptcha:this.resetCaptcha,loginMsgError:loginMsgError,__source:{fileName:_jsxFileName,lineNumber:174}}),_react2.default.createElement('div',{style:{color:'#FFFFFF',position:'fixed',bottom:0,right:0,fontSize:'9px'},__source:{fileName:_jsxFileName,lineNumber:181}},_constants.BUILD_NUMBER,'J'));}}]);return LoginForm;}(_react.Component);exports.default=(0,_reduxForm.reduxForm)({form:'login',validate:validate,destroyOnUnmount:true})(LoginForm);module.exports=exports['default'];

/***/ }),
/* 2091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__recaptcha__ = __webpack_require__(2092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script__ = __webpack_require__(2093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_async_script___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_async_script__);



var callbackName = "onloadcallback";
var lang = typeof window !== "undefined" && window.recaptchaOptions && window.recaptchaOptions.lang ? "&hl=" + window.recaptchaOptions.lang : "";
var URL = "https://www.google.com/recaptcha/api.js?onload=" + callbackName + "&render=explicit" + lang;
var globalName = "grecaptcha";

/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_1_react_async_script___default()(__WEBPACK_IMPORTED_MODULE_0__recaptcha__["a" /* default */], URL, {
  callbackName: callbackName,
  globalName: globalName,
  exposeFuncs: ["getValue", "getWidgetId", "reset", "execute"]
}));

/***/ }),
/* 2092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);








var ReCAPTCHA = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ReCAPTCHA);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this));

    _this.state = {};
    _this.handleExpired = _this.handleExpired.bind(_this);
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_this);
    return _this;
  }

  ReCAPTCHA.prototype.getValue = function getValue() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this.state.widgetId);
    }
    return null;
  };

  ReCAPTCHA.prototype.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      return this.state.widgetId;
    }
    return null;
  };

  ReCAPTCHA.prototype.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;
    var widgetId = this.state.widgetId;


    if (grecaptcha && widgetId !== undefined) {
      return grecaptcha.execute(widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  ReCAPTCHA.prototype.reset = function reset() {
    if (this.props.grecaptcha && this.state.widgetId !== undefined) {
      this.props.grecaptcha.reset(this.state.widgetId);
    }
  };

  ReCAPTCHA.prototype.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else if (this.props.onChange) {
      this.props.onChange(null);
    }
  };

  ReCAPTCHA.prototype.explicitRender = function explicitRender(cb) {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this.state.widgetId === undefined) {
      var wrapper = document.createElement("div");
      var id = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.props.onChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        size: this.props.size,
        stoken: this.props.stoken,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);

      this.setState({
        widgetId: id
      }, cb);
    }
    if (this._executeRequested && this.props.grecaptcha && this.state.widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  ReCAPTCHA.prototype.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  ReCAPTCHA.prototype.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  ReCAPTCHA.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.state.widgetId !== undefined) {
      while (this.captcha.firstChild) {
        this.captcha.removeChild(this.captcha.firstChild);
      }
      this.reset();
    }
  };

  ReCAPTCHA.prototype.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  ReCAPTCHA.prototype.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
    /* eslint-disable no-unused-vars */
    var _props = this.props,
        sitekey = _props.sitekey,
        onChange = _props.onChange,
        theme = _props.theme,
        type = _props.type,
        tabindex = _props.tabindex,
        onExpired = _props.onExpired,
        size = _props.size,
        stoken = _props.stoken,
        grecaptcha = _props.grecaptcha,
        badge = _props.badge,
        childProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "size", "stoken", "grecaptcha", "badge"]);
    /* eslint-enable no-unused-vars */


    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, childProps, { ref: this.handleRecaptchaRef }));
  };

  return ReCAPTCHA;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ReCAPTCHA);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string.isRequired,
  onChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  grecaptcha: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  theme: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["dark", "light"]),
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["image", "audio"]),
  tabindex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  onExpired: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  size: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["compact", "normal", "invisible"]),
  stoken: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  badge: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends2 = __webpack_require__(654);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(655);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getIterator2 = __webpack_require__(576);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _classCallCheck2 = __webpack_require__(382);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = __webpack_require__(383);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(384);

var _inherits3 = _interopRequireDefault(_inherits2);

var _map = __webpack_require__(2094);

var _map2 = _interopRequireDefault(_map);

exports.default = makeAsyncScript;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SCRIPT_MAP = new _map2.default();

// A counter used to generate a unique id for each component that uses the function
var idCount = 0;

function makeAsyncScript(Component, scriptURL, options) {
  options = options || {};
  var wrappedComponentName = Component.displayName || Component.name || "Component";

  var AsyncScriptLoader = function (_React$Component) {
    (0, _inherits3.default)(AsyncScriptLoader, _React$Component);

    function AsyncScriptLoader() {
      (0, _classCallCheck3.default)(this, AsyncScriptLoader);

      var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));

      _this.state = {};
      return _this;
    }

    AsyncScriptLoader.prototype.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
      if (!this.__scriptLoaderID) {
        this.__scriptLoaderID = "async-script-loader-" + idCount++;
      }
      return this.__scriptLoaderID;
    };

    AsyncScriptLoader.prototype.getComponent = function getComponent() {
      return this.childComponent;
    };

    AsyncScriptLoader.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      var key = this.asyncScriptLoaderGetScriptLoaderID();
      var _options = options,
          globalName = _options.globalName,
          callbackName = _options.callbackName;

      if (globalName && typeof window[globalName] !== "undefined") {
        SCRIPT_MAP.set(scriptURL, { loaded: true, observers: new _map2.default() });
      }

      if (SCRIPT_MAP.has(scriptURL)) {
        var entry = SCRIPT_MAP.get(scriptURL);
        if (entry && (entry.loaded || entry.errored)) {
          this.asyncScriptLoaderHandleLoad(entry);
          return;
        }
        entry.observers.set(key, function (entry) {
          return _this2.asyncScriptLoaderHandleLoad(entry);
        });
        return;
      }

      var observers = new _map2.default();
      observers.set(key, function (entry) {
        return _this2.asyncScriptLoaderHandleLoad(entry);
      });
      SCRIPT_MAP.set(scriptURL, {
        loaded: false,
        observers: observers
      });

      var script = document.createElement("script");

      script.src = scriptURL;
      script.async = 1;

      var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
        if (SCRIPT_MAP.has(scriptURL)) {
          var mapEntry = SCRIPT_MAP.get(scriptURL);
          var observersMap = mapEntry.observers;

          for (var _iterator = observersMap, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
            var _ref;

            if (_isArray) {
              if (_i >= _iterator.length) break;
              _ref = _iterator[_i++];
            } else {
              _i = _iterator.next();
              if (_i.done) break;
              _ref = _i.value;
            }

            var _ref2 = _ref,
                obsKey = _ref2[0],
                observer = _ref2[1];

            if (func(observer)) {
              observersMap.delete(obsKey);
            }
          }
        }
      };

      if (callbackName && typeof window !== "undefined") {
        window[callbackName] = AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded;
      }

      script.onload = function () {
        var mapEntry = SCRIPT_MAP.get(scriptURL);
        if (mapEntry) {
          mapEntry.loaded = true;
          callObserverFuncAndRemoveObserver(function (observer) {
            if (callbackName) {
              return false;
            }
            observer(mapEntry);
            return true;
          });
        }
      };
      script.onerror = function (event) {
        var mapEntry = SCRIPT_MAP.get(scriptURL);
        if (mapEntry) {
          mapEntry.errored = true;
          callObserverFuncAndRemoveObserver(function (observer) {
            observer(mapEntry);
            return true;
          });
        }
      };

      // (old) MSIE browsers may call "onreadystatechange" instead of "onload"
      script.onreadystatechange = function () {
        if (_this2.readyState === "loaded") {
          // wait for other events, then call onload if default onload hadn't been called
          window.setTimeout(function () {
            var mapEntry = SCRIPT_MAP.get(scriptURL);
            if (mapEntry && mapEntry.loaded !== true) {
              script.onload();
            }
          }, 0);
        }
      };

      document.body.appendChild(script);
    };

    AsyncScriptLoader.prototype.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
      this.setState(state, this.props.asyncScriptOnLoad);
    };

    AsyncScriptLoader.prototype.componentWillUnmount = function componentWillUnmount() {
      // Remove tag script
      if (options.removeOnUnmount === true) {
        var allScripts = document.getElementsByTagName("script");
        for (var i = 0; i < allScripts.length; i += 1) {
          if (allScripts[i].src.indexOf(scriptURL) > -1) {
            if (allScripts[i].parentNode) {
              allScripts[i].parentNode.removeChild(allScripts[i]);
            }
          }
        }
      }
      // Clean the observer entry
      var mapEntry = SCRIPT_MAP.get(scriptURL);
      if (mapEntry) {
        mapEntry.observers.delete(this.asyncScriptLoaderGetScriptLoaderID());
        if (options.removeOnUnmount === true) {
          SCRIPT_MAP.delete(scriptURL);
        }
      }
    };

    AsyncScriptLoader.prototype.render = function render() {
      var _this3 = this;

      var globalName = options.globalName;
      var _props = this.props,
          asyncScriptOnLoad = _props.asyncScriptOnLoad,
          childProps = (0, _objectWithoutProperties3.default)(_props, ["asyncScriptOnLoad"]);

      if (globalName && typeof window !== "undefined") {
        childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
      }
      return _react2.default.createElement(Component, (0, _extends3.default)({ ref: function ref(comp) {
          _this3.childComponent = comp;
        } }, childProps));
    };

    return AsyncScriptLoader;
  }(_react2.default.Component);

  AsyncScriptLoader.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
  AsyncScriptLoader.propTypes = {
    asyncScriptOnLoad: _propTypes2.default.func
  };
  AsyncScriptLoader.asyncScriptLoaderTriggerOnScriptLoaded = function () {
    var mapEntry = SCRIPT_MAP.get(scriptURL);
    if (!mapEntry || !mapEntry.loaded) {
      throw new Error("Script is not loaded.");
    }
    for (var _iterator2 = mapEntry.observers.values(), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : (0, _getIterator3.default)(_iterator2);;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var observer = _ref3;

      observer(mapEntry);
    }
    delete window[options.callbackName];
  };

  if (options.exposeFuncs) {
    var _loop = function _loop() {
      if (_isArray3) {
        if (_i3 >= _iterator3.length) return "break";
        _ref4 = _iterator3[_i3++];
      } else {
        _i3 = _iterator3.next();
        if (_i3.done) return "break";
        _ref4 = _i3.value;
      }

      var funcToExpose = _ref4;

      /* eslint-disable no-loop-func */
      AsyncScriptLoader.prototype[funcToExpose] = function () {
        var _getComponent;

        return (_getComponent = this.getComponent())[funcToExpose].apply(_getComponent, arguments);
      };
      /* eslint-enable no-loop-func */
    };

    for (var _iterator3 = options.exposeFuncs, _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : (0, _getIterator3.default)(_iterator3);;) {
      var _ref4;

      var _ret = _loop();

      if (_ret === "break") break;
    }
  }
  return AsyncScriptLoader;
}

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2095), __esModule: true };

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(582);
__webpack_require__(179);
__webpack_require__(231);
__webpack_require__(2096);
__webpack_require__(2103);
__webpack_require__(2106);
__webpack_require__(2108);
module.exports = __webpack_require__(50).Map;


/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(2097);
var validate = __webpack_require__(658);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(2099)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(75).f;
var create = __webpack_require__(233);
var redefineAll = __webpack_require__(656);
var ctx = __webpack_require__(131);
var anInstance = __webpack_require__(657);
var forOf = __webpack_require__(265);
var $iterDefine = __webpack_require__(368);
var step = __webpack_require__(569);
var setSpecies = __webpack_require__(2098);
var DESCRIPTORS = __webpack_require__(76);
var fastKey = __webpack_require__(379).fastKey;
var validate = __webpack_require__(658);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(87);
var core = __webpack_require__(50);
var dP = __webpack_require__(75);
var DESCRIPTORS = __webpack_require__(76);
var SPECIES = __webpack_require__(58)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(87);
var $export = __webpack_require__(67);
var meta = __webpack_require__(379);
var fails = __webpack_require__(132);
var hide = __webpack_require__(109);
var redefineAll = __webpack_require__(656);
var forOf = __webpack_require__(265);
var anInstance = __webpack_require__(657);
var isObject = __webpack_require__(97);
var setToStringTag = __webpack_require__(236);
var dP = __webpack_require__(75).f;
var each = __webpack_require__(2100)(0);
var DESCRIPTORS = __webpack_require__(76);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(131);
var IObject = __webpack_require__(365);
var toObject = __webpack_require__(134);
var toLength = __webpack_require__(234);
var asc = __webpack_require__(2101);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(2102);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(97);
var isArray = __webpack_require__(579);
var SPECIES = __webpack_require__(58)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(67);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(2104)('Map') });


/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(374);
var from = __webpack_require__(2105);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(265);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(2107)('Map');


/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(67);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(2109)('Map');


/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(67);
var aFunction = __webpack_require__(570);
var ctx = __webpack_require__(131);
var forOf = __webpack_require__(265);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Button=__webpack_require__(2111);var _Button2=_interopRequireDefault(_Button);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Button2.default;module.exports=exports['default'];

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/ButtonV2/Button.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _propTypes2=_interopRequireDefault(_propTypes);var _styles=__webpack_require__(2112);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Button(_ref){var disabled=_ref.disabled,text=_ref.text,href=_ref.href,onClick=_ref.onClick,buttonType=_ref.buttonType,type=_ref.type,width=_ref.width,id=_ref.id,loading=_ref.loading,props=_objectWithoutProperties(_ref,['disabled','text','href','onClick','buttonType','type','width','id','loading']);var handleDisabled=function handleDisabled(e){e.preventDefault();};var handleClick=function handleClick(e){e.preventDefault();if(onClick){onClick();}};return _react2.default.createElement(_styles.Wrapper,{width:width,disabled:disabled,buttonType:buttonType,__source:{fileName:_jsxFileName,lineNumber:20}},type&&type==='submit'?_react2.default.createElement(_styles.FormButtonField,_extends({disabled:disabled,type:type,loading:loading},props,{__source:{fileName:_jsxFileName,lineNumber:22}}),text):_react2.default.createElement(_styles.ButtonField,_extends({id:id,disabled:disabled,href:href,onClick:disabled?handleDisabled:handleClick,loading:loading},props,{__source:{fileName:_jsxFileName,lineNumber:26}}),props.icon&&_react2.default.createElement(_styles.BtnIcon,{alt:'',src:props.icon,__source:{fileName:_jsxFileName,lineNumber:34}}),text));}Button.defaultProps={disabled:null,buttonType:'',text:null,href:null,onClick:null,loading:false};Button.propTypes={disabled:_propTypes2.default.bool,buttonType:_propTypes2.default.string,text:_propTypes2.default.string.isRequired,href:_propTypes2.default.string,onClick:_propTypes2.default.func,loading:_propTypes2.default.bool};exports.default=Button;module.exports=exports['default'];

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.BtnIcon=exports.FormButtonField=exports.ButtonField=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n      :hover {\n        color: ',';\n        background-color: ',';\n      }\n    '],['\n      :hover {\n        color: ',';\n        background-color: ',';\n      }\n    ']),_templateObject2=_taggedTemplateLiteral(['\n    line-height: ',';\n    padding: 0 ',' ',';\n  '],['\n    line-height: ',';\n    padding: 0 ',' ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    border: none;\n'],['\n    border: none;\n']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _loading=__webpack_require__(100);var _loading2=_interopRequireDefault(_loading);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var buttonStyles={white:(0,_styledComponents.css)(['background-color:',';box-shadow:0 0 0 ',' ',' inset;color:',';',';'],_colors.white,(0,_rem2.default)('2px'),_colors.darkBlue,_colors.darkBlue,_media2.default.large(_templateObject,_colors.white,_colors.darkBlue)),transparent:(0,_styledComponents.css)(['background-color:transparent;box-shadow:0 0 0 ',' ',' inset;color:',';'],(0,_rem2.default)('2px'),_colors.white,_colors.white),darkBlue:(0,_styledComponents.css)(['background-color:',';color:',';'],_colors.darkBlue,_colors.white),skyBlue:(0,_styledComponents.css)(['background-color:',';box-shadow:0 ',' ',' 0 rgba(0,0,0,0.29);color:',';'],_colors.skyBlue,(0,_rem2.default)('2px'),(0,_rem2.default)('8px'),_colors.white),whiteNavyBlue:(0,_styledComponents.css)(['background-color:',';box-shadow:0 0 0 ',' ',' inset;color:',';'],_colors.white,(0,_rem2.default)('2px'),_colors.linkNavyBlue,_colors.linkNavyBlue)};var disabled=function disabled(props){return props.disabled&&(0,_styledComponents.css)(['background-color:',';box-shadow:none;color:',';cursor:default;:hover,:visited,:active,:focus{transform:none;background-color:',';box-shadow:none;color:',';cursor:default;}:before{display:none;}'],_colors.offWhite,_colors.grey,_colors.offWhite,_colors.grey);};var buttonModifier=function buttonModifier(props){return buttonStyles[props.buttonType];};var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-8pw00y-0'})(['background:transparent;background-color:',';border-radius:9999px;color:',';display:inline-block;min-width:auto;overflow:hidden;position:relative;text-align:center;transform:translateY(0);user-select:none;width:100%;&:hover{transform:scale(1.1);transition:transform 0.25s;}&:before{background-color:#110e49;border-radius:9999px 0 0 9999px;left:0;height:100%;content:\'\';display:block;position:absolute;opacity:0;transition:width 0.15s ease-in 0s,opacity 0.2s ease-in 0.15s;top:0;width:100%;}&:active:before{opacity:0.8;transition:0s;width:0;}',';',';'],_colors.lightBlue,_colors.white,buttonModifier,disabled);var ButtonField=exports.ButtonField=_styledComponents2.default.a.withConfig({displayName:'styles__ButtonField',componentId:'sc-8pw00y-1'})(['cursor:pointer;display:block;font-family:Galano;font-size:',';font-weight:700;height:100%;line-height:',';letter-spacing:',';position:relative;text-align:center;width:100%;z-index:1;',';',';'],(0,_rem2.default)('16px'),(0,_rem2.default)('60px'),(0,_rem2.default)('0px'),_media2.default.large(_templateObject2,(0,_rem2.default)('56px'),(0,_rem2.default)('32px'),(0,_rem2.default)('2px')),function(props){return props.disabled&&(0,_styledComponents.css)(['cursor:not-allowed;',';background-repeat:no-repeat;background-position:20px center;background-size:20px;'],props.loading&&'background-image: url('+_loading2.default+')');});var FormButtonField=exports.FormButtonField=ButtonField.withComponent('button').extend(_templateObject3);var BtnIcon=exports.BtnIcon=_styledComponents2.default.img.withConfig({displayName:'styles__BtnIcon',componentId:'sc-8pw00y-2'})(['padding-right:10px;']);

/***/ }),
/* 2113 */
/***/ (function(module, exports) {

module.exports = {"forgotpassword":"Esqueceu sua senha?"}

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Radios=exports.Buttons=exports.TextPassword=exports.ErrorMessage=undefined;var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n  '],['\n    display: flex;\n    flex-direction: row;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n  '],['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-around;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ErrorMessage=exports.ErrorMessage=_styledComponents2.default.span.withConfig({displayName:'style__ErrorMessage',componentId:'sc-buo9f1-0'})(['',' color:',';'],_types.txt14OpenSans,_colors.red);var TextPassword=exports.TextPassword=_styledComponents2.default.a.withConfig({displayName:'style__TextPassword',componentId:'sc-buo9f1-1'})(['',' color:',';cursor:pointer;font-weight:bold;line-height:1.57;text-decoration:none;'],_types.txt14OpenSans,_colors.linkNavyBlue);var Buttons=exports.Buttons=_styledComponents2.default.div.withConfig({displayName:'style__Buttons',componentId:'sc-buo9f1-2'})(['display:flex;flex-direction:column;',';'],_media2.default.large(_templateObject));var Radios=exports.Radios=_styledComponents2.default.div.withConfig({displayName:'style__Radios',componentId:'sc-buo9f1-3'})(['display:flex;flex-direction:column;',';'],_media2.default.large(_templateObject2));

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Row=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/LoginForm/FormModal.js';var _templateObject=_taggedTemplateLiteral(['\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n\n    > button {\n      width: 160px;\n    }\n  '],['\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n\n    > button {\n      width: 160px;\n    }\n  ']);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reduxForm=__webpack_require__(11);var _reactRedux=__webpack_require__(7);var _Modal=__webpack_require__(113);var _Modal2=_interopRequireDefault(_Modal);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FormModal=function FormModal(props){return props.isOpen?_react2.default.createElement(_Modal2.default,{title:'Tem algo errado com seu login ou sua senha. Tente novamente.',__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement(SecurityMessage,{__source:{fileName:_jsxFileName,lineNumber:15}},props.loginMsgError),_react2.default.createElement(Row,{__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement(_Button2.default,{buttonType:'transparent',onClick:function onClick(){props.closeModal();props.resetCaptcha();props.dispatch((0,_reduxForm.destroy)('login'));},type:'button',title:'Ok',borderWhite:true,minWidth:'180',text:'Ok',__source:{fileName:_jsxFileName,lineNumber:17}})))):null;};var Row=exports.Row=_styledComponents2.default.div.withConfig({displayName:'FormModal__Row',componentId:'sc-13rmbvf-0'})(['display:flex;justify-content:space-between;margin:40px 0 0;',';'],_media2.default.small(_templateObject));var SecurityMessage=_styledComponents2.default.h4.withConfig({displayName:'FormModal__SecurityMessage',componentId:'sc-13rmbvf-1'})(['',';'],_types.title16Galano);exports.default=(0,_reactRedux.connect)(function(state){return state;})(FormModal);

/***/ }),
/* 2116 */
/***/ (function(module, exports) {

module.exports = {"title":"Pode entrar que a casa é sua ;)","forgotpassword":"Esqueceu sua senha?","authError":"Tem algo errado com seu login ou sua senha. Tente novamente.","authCode":{"unauthorized":401,"locked":423},"redirect":{"dashboard":"/minha-veloe/resumo","canceledAccount":"/perfil/conta-cancelada"}}

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Container=exports.Title=exports.Content=exports.Veloe=exports.Text=exports.Header=exports.Aside=undefined;var _templateObject=_taggedTemplateLiteral(['\n        background-color: ',';\n        display: block;\n        height: 100vh;\n        margin-right: ',';\n        position: relative;\n        width: 32.4%;\n        img {\n            bottom: 0;\n            position: absolute;\n            width: 100%;\n        }\n    '],['\n        background-color: ',';\n        display: block;\n        height: 100vh;\n        margin-right: ',';\n        position: relative;\n        width: 32.4%;\n        img {\n            bottom: 0;\n            position: absolute;\n            width: 100%;\n        }\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        border: 0;\n        margin-top: ',';\n\n    '],['\n        border: 0;\n        margin-top: ',';\n\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        cursor: pointer;\n        margin-left: 0;\n    '],['\n        cursor: pointer;\n        margin-left: 0;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        display: flex;\n        flex-direction: column;\n        width: ',';\n    '],['\n        display: flex;\n        flex-direction: column;\n        width: ',';\n    ']),_templateObject5=_taggedTemplateLiteral(['\n        color:',';\n        display: block;\n        font-weight: bold;\n        letter-spacing: ',';\n        margin-bottom: ',';\n        margin-top: ',';\n        max-width: ',';\n    '],['\n        color:',';\n        display: block;\n        font-weight: bold;\n        letter-spacing: ',';\n        margin-bottom: ',';\n        margin-top: ',';\n        max-width: ',';\n    ']),_templateObject6=_taggedTemplateLiteral(['\n        min-width: ',';\n        padding: ',' ',' 0 0;\n    '],['\n        min-width: ',';\n        padding: ',' ',' 0 0;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Aside=exports.Aside=_styledComponents2.default.div.withConfig({displayName:'style__Aside',componentId:'sc-2nxrlu-0'})(['display:none;',';'],_media2.default.large(_templateObject,_colors.skyBlue,(0,_rem2.default)('120px')));var Header=exports.Header=_styledComponents2.default.div.withConfig({displayName:'style__Header',componentId:'sc-2nxrlu-1'})(['border-bottom:',' solid ',';border-top:',' solid ',';display:block;width:100%;',';'],(0,_rem2.default)('2px'),_colors.lighterGrey,(0,_rem2.default)('4px'),_colors.skyBlue,_media2.default.large(_templateObject2,(0,_rem2.default)('60px')));var Text=exports.Text=_styledComponents2.default.a.withConfig({displayName:'style__Text',componentId:'sc-2nxrlu-2'})(['',' font-weight:bold;line-height:1;color:',';display:flex;width:',';margin:',' 0 ',' ',';',';'],_types.txt14OpenSans,_colors.linkNavyBlue,(0,_rem2.default)('100px'),(0,_rem2.default)('17px'),(0,_rem2.default)('21px'),(0,_rem2.default)('29px'),_media2.default.large(_templateObject3));var Veloe=exports.Veloe=_styledComponents2.default.span.withConfig({displayName:'style__Veloe',componentId:'sc-2nxrlu-3'})(['display:flex;justify-content:center;margin:',' 0 ',' 0;img{height:',';width:',';}'],(0,_rem2.default)('24px'),(0,_rem2.default)('33px'),(0,_rem2.default)('32px'),(0,_rem2.default)('74px'));var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'style__Content',componentId:'sc-2nxrlu-4'})(['width:100%;',';'],_media2.default.large(_templateObject4,(0,_rem2.default)('456px')));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'style__Title',componentId:'sc-2nxrlu-5'})(['',' display:none;width:100%;',';'],_types.title40GalanoBold,_media2.default.large(_templateObject5,_colors.linkNavyBlue,(0,_rem2.default)('0.4px'),(0,_rem2.default)('30px'),(0,_rem2.default)('39px'),(0,_rem2.default)('350px')));var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'style__Container',componentId:'sc-2nxrlu-6'})(['',' width:100%;',';'],_content2.default,_media2.default.large(_templateObject6,(0,_rem2.default)('456px'),(0,_rem2.default)('20px'),(0,_rem2.default)('20px')));

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ForgotPassword/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _gridStyled=__webpack_require__(8);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _Icon=__webpack_require__(31);var _actions2=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _ForgotPasswordForm=__webpack_require__(2119);var _ForgotPasswordForm2=_interopRequireDefault(_ForgotPasswordForm);var _login=__webpack_require__(396);var _login2=_interopRequireDefault(_login);var _logoVeloe=__webpack_require__(397);var _logoVeloe2=_interopRequireDefault(_logoVeloe);var _data=__webpack_require__(2122);var _style=__webpack_require__(2123);var _alterarSenha=__webpack_require__(394);var _alterarSenha2=_interopRequireDefault(_alterarSenha);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ForgotPassword=function ForgotPassword(_ref){var sendEmail=_ref.sendEmail;return _react2.default.createElement(_gridStyled.Flex,{__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_style.Aside,{__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement('img',{src:_login2.default,alt:'Avatar',__source:{fileName:_jsxFileName,lineNumber:23}})),_react2.default.createElement(_style.Content,{__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement(_style.Header,{__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_style.Text,{__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement(_Icon.Icon,{height:16,icon:'back-arrow',viewBox:'0 0 16 13',display:'flex',__source:{fileName:_jsxFileName,lineNumber:28}}),_data.back)),_react2.default.createElement(_Hide2.default,{at:'large',__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_style.Veloe,{__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement('img',{src:_logoVeloe2.default,alt:_data.veloeLogoAlt,__source:{fileName:_jsxFileName,lineNumber:34}}))),_react2.default.createElement(_style.Title,{__source:{fileName:_jsxFileName,lineNumber:37}},_data.title),_react2.default.createElement(_style.Description,{__source:{fileName:_jsxFileName,lineNumber:38}},_data.description),_react2.default.createElement(_style.Container,{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_ForgotPasswordForm2.default,{onSubmit:sendEmail,__source:{fileName:_jsxFileName,lineNumber:40}}))));};var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{destinationEmail:reducer.recover};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{sendEmail:function sendEmail(values){dispatch((0,_actions.fetchRecover)(values.login)).then(function(data){if(data.success){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modalTitle,modalDescription:_data.modalDescription+' '+data.email,onConfirm:function onConfirm(){return ownProps.history.push('/conta/login');},image:_alterarSenha2.default}));}else{dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:data.message,image:_alterarSenha2.default}));}},function(data){data.json().then(function(err){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:err.message,image:_alterarSenha2.default}));});});}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ForgotPassword);module.exports=exports['default'];

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ForgotPasswordForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _lodash=__webpack_require__(43);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _renderInputs=__webpack_require__(44);var _style=__webpack_require__(2120);var _data=__webpack_require__(2121);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function validate(values){var errors={};if((0,_lodash.isEmpty)(values.login)){errors.login=_data.errorLogin;}return errors;}var ForgoPasswordForm=function ForgoPasswordForm(_ref){var handleSubmit=_ref.handleSubmit;return _react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement(_gridStyled.Flex,{direction:'column',__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement(_gridStyled.Box,{mb:[24,28],__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labelLogin,name:'login',__source:{fileName:_jsxFileName,lineNumber:27}}))),_react2.default.createElement(_style.Buttons,{__source:{fileName:_jsxFileName,lineNumber:30}},_react2.default.createElement(_gridStyled.Box,{mt:15,__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_Button2.default,{type:'submit',text:_data.send,width:(0,_rem2.default)('210px'),__source:{fileName:_jsxFileName,lineNumber:32}}))));};exports.default=(0,_reduxForm.reduxForm)({form:'login',validate:validate})(ForgoPasswordForm);module.exports=exports['default'];

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Buttons=exports.TextPassword=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n    '],['\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TextPassword=exports.TextPassword=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'style__TextPassword',componentId:'sc-44utlh-0'})(['',' color:',';cursor:pointer;font-weight:bold;line-height:1.57;text-decoration:none;'],_types.txt14OpenSans,_colors.linkNavyBlue);var Buttons=exports.Buttons=_styledComponents2.default.div.withConfig({displayName:'style__Buttons',componentId:'sc-44utlh-1'})(['display:flex;flex-direction:column;',';'],_media2.default.large(_templateObject));

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

module.exports = {"errorLogin":"Não esqueça do número do seu documento ou e-mail.","labelLogin":"cpf/cnpj ou e-mail","send":"Enviar"}

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

module.exports = {"back":"Voltar","description":"E você pode contar com a gente para ajudar. É só confirmar seu CPF/CNPJ ou seu e-mail.","modalDescription":"Enviamos os dados necessários para","modalTitle":"Pronto! A ajuda já está a caminho do seu e-mail. :)","title":"Relaxa! Isso acontece com todo mundo.","veloeLogoAlt":"Logo Veloe"}

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Container=exports.Description=exports.Title=exports.Content=exports.Veloe=exports.Text=exports.Header=exports.Aside=undefined;var _templateObject=_taggedTemplateLiteral(['\n        background-color: ',';\n        display: block;\n        height: 100vh;\n        margin-right: ',';\n        position: relative;\n        width: 32.4%;\n        img {\n            bottom: 0;\n            position: absolute;\n            width: 100%;\n        }\n    '],['\n        background-color: ',';\n        display: block;\n        height: 100vh;\n        margin-right: ',';\n        position: relative;\n        width: 32.4%;\n        img {\n            bottom: 0;\n            position: absolute;\n            width: 100%;\n        }\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        border: 0;\n        margin-top: ',';\n\n    '],['\n        border: 0;\n        margin-top: ',';\n\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        cursor: pointer;\n        margin-left: 0;\n    '],['\n        cursor: pointer;\n        margin-left: 0;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        display: flex;\n        flex-direction: column;\n        width: ',';\n    '],['\n        display: flex;\n        flex-direction: column;\n        width: ',';\n    ']),_templateObject5=_taggedTemplateLiteral(['\n        color:',';\n        display: block;\n        font-weight: bold;\n        letter-spacing: ',';\n        margin-bottom: ',';\n        margin-top: ',';\n        max-width: ',';\n    '],['\n        color:',';\n        display: block;\n        font-weight: bold;\n        letter-spacing: ',';\n        margin-bottom: ',';\n        margin-top: ',';\n        max-width: ',';\n    ']),_templateObject6=_taggedTemplateLiteral(['\n        width: ',';\n        padding: 0;\n    '],['\n        width: ',';\n        padding: 0;\n    ']),_templateObject7=_taggedTemplateLiteral(['\n        min-width: ',';\n        padding: ',' ',' 0 0;\n    '],['\n        min-width: ',';\n        padding: ',' ',' 0 0;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Aside=exports.Aside=_styledComponents2.default.div.withConfig({displayName:'style__Aside',componentId:'sc-1726z81-0'})(['display:none;',';'],_media2.default.large(_templateObject,_colors.skyBlue,(0,_rem2.default)('120px')));var Header=exports.Header=_styledComponents2.default.div.withConfig({displayName:'style__Header',componentId:'sc-1726z81-1'})(['border-bottom:',' solid ',';border-top:',' solid ',';display:block;width:100%;',';'],(0,_rem2.default)('2px'),_colors.lighterGrey,(0,_rem2.default)('4px'),_colors.skyBlue,_media2.default.large(_templateObject2,(0,_rem2.default)('85px')));var Text=exports.Text=_styledComponents2.default.a.withConfig({displayName:'style__Text',componentId:'sc-1726z81-2'})(['',' font-weight:bold;line-height:1;color:',';display:flex;width:',';margin:',' 0 ',' ',';',';'],_types.txt14OpenSans,_colors.linkNavyBlue,(0,_rem2.default)('100px'),(0,_rem2.default)('17px'),(0,_rem2.default)('21px'),(0,_rem2.default)('29px'),_media2.default.large(_templateObject3));var Veloe=exports.Veloe=_styledComponents2.default.span.withConfig({displayName:'style__Veloe',componentId:'sc-1726z81-3'})(['display:flex;justify-content:center;margin:',' 0 ',' 0;img{height:',';width:',';}'],(0,_rem2.default)('24px'),(0,_rem2.default)('33px'),(0,_rem2.default)('32px'),(0,_rem2.default)('74px'));var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'style__Content',componentId:'sc-1726z81-4'})(['width:100%;',';'],_media2.default.large(_templateObject4,(0,_rem2.default)('456px')));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'style__Title',componentId:'sc-1726z81-5'})(['',' display:none;width:100%;',';'],_types.title40GalanoBold,_media2.default.large(_templateObject5,_colors.linkNavyBlue,(0,_rem2.default)('0.4px'),(0,_rem2.default)('20px'),(0,_rem2.default)('68px'),(0,_rem2.default)('450px')));var Description=exports.Description=_styledComponents2.default.p.withConfig({displayName:'style__Description',componentId:'sc-1726z81-6'})(['',' color:',';font-weight:200;letter-spacing:',';line-height:1.71;margin-bottom:',';white-space:normal;width:100%;box-sizing:border-box;padding:0 ',' ',';',';'],_types.txt14OpenSans,_colors.darkGrey,(0,_rem2.default)('0.2px'),(0,_rem2.default)('25px'),(0,_rem2.default)('40px'),(0,_rem2.default)('20px'),_media2.default.large(_templateObject6,(0,_rem2.default)('340px')));var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'style__Container',componentId:'sc-1726z81-7'})(['',' width:100%;',';'],_content2.default,_media2.default.large(_templateObject7,(0,_rem2.default)('456px'),(0,_rem2.default)('20px'),(0,_rem2.default)('20px')));

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/CreateNewPassword/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(15);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _ChangePasswordForm=__webpack_require__(393);var _ChangePasswordForm2=_interopRequireDefault(_ChangePasswordForm);var _actions2=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _factory=__webpack_require__(2125);var _factory2=_interopRequireDefault(_factory);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(2126);var _data=__webpack_require__(2127);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateNewPassword=function(_Component){_inherits(CreateNewPassword,_Component);function CreateNewPassword(){_classCallCheck(this,CreateNewPassword);return _possibleConstructorReturn(this,(CreateNewPassword.__proto__||Object.getPrototypeOf(CreateNewPassword)).apply(this,arguments));}_createClass(CreateNewPassword,[{key:'componentWillMount',value:function componentWillMount(){var params=this.props.match.params||{};this.props.fetchStatusToken(params.token);}},{key:'render',value:function render(){var _this2=this;var recoverTokenStatus=this.props.recoverTokenStatus.recoverTokenStatus;var token=this.props.match.params.token||{};return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:30}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_reactRouterDom.Link,{to:'/conta/login',__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_Icon2.default,{icon:'veloe-logo',svgStyle:_styles.Logo,width:'74',height:'31',viewBox:'0 0 74 31',__source:{fileName:_jsxFileName,lineNumber:33}}))),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:36}},recoverTokenStatus&&recoverTokenStatus.success&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:40}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:41}},_data.subtitle),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_ChangePasswordForm2.default,{form:'createNewPasswordData',asyncValidate:null,asyncBlurFields:['newPassword'],onSubmit:function onSubmit(values){return _this2.props.handleSave(_factory2.default.toAPI(values,token));},__source:{fileName:_jsxFileName,lineNumber:43}}))),recoverTokenStatus&&!recoverTokenStatus.success&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:54}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:55}},recoverTokenStatus.message),recoverTokenStatus.description&&_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:57}},recoverTokenStatus.description),_react2.default.createElement(_Button2.default,{type:'button',text:'Voltar',onClick:function onClick(){return _this2.props.history.push('/');},__source:{fileName:_jsxFileName,lineNumber:59}}))));}}]);return CreateNewPassword;}(_react.Component);var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref){var reducer=_ref.reducer;return{recoverTokenStatus:reducer.recoverTokenStatus};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{handleSave:function handleSave(newPass){dispatch((0,_actions.fetchNewPassword)(newPass)).then(function(data){if(data.success){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.modalTitle,onConfirm:function onConfirm(){return ownProps.history.push('/conta/login');},image:_confirmation2.default}));}else{dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:data.message,image:_confirmation2.default}));}},function(data){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:data.message,image:_confirmation2.default}));});},fetchStatusToken:function fetchStatusToken(token){return dispatch((0,_actions.fetchRecoverTokenStatus)(token));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(CreateNewPassword);

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var passwordFactory={toAPI:function toAPI(data,token){return data&&token&&{token:token,password:data.newPassword};}};exports.default=passwordFactory;module.exports=exports["default"];

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Logo=exports.Content=exports.Wrapper=exports.Paragraph=exports.Heading=exports.Header=undefined;var _templateObject=_taggedTemplateLiteral(['\n        padding: ',' ',';\n        position: relative;\n        text-align: center;\n        & > a {\n            margin: 0 auto;\n        }\n    '],['\n        padding: ',' ',';\n        position: relative;\n        text-align: center;\n        & > a {\n            margin: 0 auto;\n        }\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        font-size: ',';\n        margin: 0;\n    '],['\n        font-size: ',';\n        margin: 0;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        margin: ',' auto ',';\n    '],['\n        margin: ',' auto ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _container=__webpack_require__(183);var _container2=_interopRequireDefault(_container);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=exports.Header=_styledComponents2.default.div.withConfig({displayName:'styles__Header',componentId:'sc-1afks49-0'})(['',';align-items:center;display:flex;justify-content:space-between;padding:',' ',' ',';',';'],_container2.default,(0,_rem2.default)('40px'),(0,_rem2.default)('65px'),(0,_rem2.default)('5px'),_media2.default.small(_templateObject,(0,_rem2.default)('20px'),(0,_rem2.default)('30px')));var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-1afks49-1'})(['',' color:',';font-size:',';margin-bottom:0;',';'],_types.title24Galano,_colors.darkBlue,(0,_rem2.default)('40px'),_media2.default.small(_templateObject2,(0,_rem2.default)('24px')));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-1afks49-2'})(['',' color:',';max-width:',';margin-top:0;'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('430px'));var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-1afks49-3'})(['margin-top:',';'],(0,_rem2.default)('32px'));var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-1afks49-4'})(['',';margin:',' auto;',';'],_content2.default,(0,_rem2.default)('42px'),_media2.default.small(_templateObject3,(0,_rem2.default)('10px'),(0,_rem2.default)('42px')));var Logo=exports.Logo='\n    height: '+(0,_rem2.default)('30px')+';\n    fill: '+_colors.linkNavyBlue+';\n    width: '+(0,_rem2.default)('74px')+';\n';

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Criar nova senha","title":"Criar nova senha","subtitle":"Agora é só você pensar numa senha nova para acessar a Veloe. E lembre-se: ela deve ter seis caracteres e pelo menos uma letra e um número.","modalTitle":"Pronto! A gente já salvou suas alterações. ;)"}

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateEmpty=__webpack_require__(112);var _TemplateEmpty2=_interopRequireDefault(_TemplateEmpty);var _EditPaymentMethod=__webpack_require__(2129);var _EditPaymentMethod2=_interopRequireDefault(_EditPaymentMethod);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id/metodo-de-pagamento',component:_TemplateEmpty2.default,routes:[{path:'/minha-veloe/:id/metodo-de-pagamento',exact:true,component:_EditPaymentMethod2.default}]};module.exports=exports['default'];

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditPaymentMethod/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _rechargeService=__webpack_require__(358);var _actions=__webpack_require__(13);var _actions2=__webpack_require__(36);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _PaymentForm=__webpack_require__(2130);var _PaymentForm2=_interopRequireDefault(_PaymentForm);var _validators=__webpack_require__(266);var _actions3=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);var _iconVeloeBackground=__webpack_require__(137);var _iconVeloeBackground2=_interopRequireDefault(_iconVeloeBackground);var _trafficSignalError=__webpack_require__(401);var _trafficSignalError2=_interopRequireDefault(_trafficSignalError);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _styles=__webpack_require__(2137);var _data3=__webpack_require__(2138);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// import moment from 'moment'
var EditPaymentMethod=function EditPaymentMethod(props){var getPaymentToken=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(values){var paymentToken;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:paymentToken=void 0;_context2.next=3;return(0,_rechargeService.getBrasPagAccessToken)().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(response){var resp;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_rechargeService.postBraspagCard)(formatCardHolderName(values.fullName),values.cardNumber.replace(/\s/g,''),values.validThru,values.cvv,response.data);case 2:resp=_context.sent;paymentToken=resp.data;case 4:case'end':return _context.stop();}}},_callee,undefined);}));return function(_x2){return _ref2.apply(this,arguments);};}()).catch(function(error){return console.error(error);});case 3:return _context2.abrupt('return',paymentToken);case 4:case'end':return _context2.stop();}}},_callee2,undefined);}));return function getPaymentToken(_x){return _ref.apply(this,arguments);};}();var checkCreditCardFlag=function checkCreditCardFlag(values){var creditCardFlag=(0,_validators.validateCreditCardFlag)(values);if(creditCardFlag){return creditCardFlag;}};var formatCardHolderName=function formatCardHolderName(name){return name.toUpperCase().replace(new RegExp('[ÁÀÂÃ]','gi'),'A').replace(new RegExp('[ÉÈÊ]','gi'),'E').replace(new RegExp('[ÍÌÎ]','gi'),'I').replace(new RegExp('[ÓÒÔÕ]','gi'),'O').replace(new RegExp('[ÚÙÛ]','gi'),'U').replace(new RegExp('[Ç]','gi'),'C');};var onSubmit=function onSubmit(values){var updatePaymentMethod=props.updatePaymentMethod,showSuccessModal=props.showSuccessModal,showErrorModal=props.showErrorModal,showCardErrorModal=props.showCardErrorModal,userData=props.userData,currentPlan=props.location.state.currentPlan,setBlockChangePaymentMethod=props.setBlockChangePaymentMethod,accountType=props.accountType;return new Promise(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(resolve,reject){var data,_data,paymentToken,_data2;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:if(!(values.paymentMethod==='CUENTA'&&values.agency&&values.account)){_context6.next=5;break;}// 2. Aplicar debito em conta
data={dados:{conta:currentPlan.accountId,alias:'EDICAO FORMA PAGAMENTO',tipoPagamento:values.paymentMethod,cpf:userData.profile.cpf,nome:userData.profile.nome,agencia:values.agency,numeroContaCorrente:''+values.account+values.accountDigit,ativo:1,idBanco:values.bankCode.toString()}};updatePaymentMethod(data).then(_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(){return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return setBlockChangePaymentMethod();case 2:showSuccessModal(accountType);resolve();props.history.goBack();case 5:case'end':return _context3.stop();}}},_callee3,undefined);}))).catch(function(e){console.error(e);// eslint-disable-line
showErrorModal();reject(e);});_context6.next=22;break;case 5:if(!(values.paymentMethod==='DISPOSICION')){_context6.next=10;break;}_data={dados:{conta:currentPlan.accountId,alias:'EDICAO FORMA PAGAMENTO',tipoPagamento:values.paymentMethod,cpf:userData.profile.cpf,nome:userData.profile.nome}};updatePaymentMethod(_data).then(_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(){return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return setBlockChangePaymentMethod();case 2:showSuccessModal(accountType);resolve();props.history.goBack();case 5:case'end':return _context4.stop();}}},_callee4,undefined);}))).catch(function(e){console.error(e);// eslint-disable-line
props.showErrorModal();reject(e);});_context6.next=22;break;case 10:if(!(values.paymentMethod==='CAJA'&&values.cardNumber)){_context6.next=21;break;}_context6.next=13;return getPaymentToken(values);case 13:paymentToken=_context6.sent;if(paymentToken){_context6.next=17;break;}showCardErrorModal();return _context6.abrupt('return',reject(new Error('Payment Token error')));case 17:_data2={dados:{conta:currentPlan.accountId,numeroMascarado:(values.cardNumber.replace(/[^\dA-Z]/g,'').replace(/(.{4})/g,'$1 ').trim().substring(0,7)+'XX-XXXX-'+values.cardNumber.replace(/[^\dA-Z]/g,'').replace(/(.{4})/g,'$1 ').trim().substring(15)).replace(/\s/g,'-'),validade:values.validThru.replace('/20','-'),bandeira:checkCreditCardFlag(values.cardNumber.replace(/\s/g,'')),tipoPagamento:values.paymentMethod,alias:'EDICAO FORMA PAGAMENTO',nome:formatCardHolderName(values.fullName),paymentToken:paymentToken.PaymentToken,cvv:checkCreditCardFlag(values.cardNumber.replace(/\s/g,''))==='amex'?values.cvv:values.cvv.slice(0,3)}};updatePaymentMethod(_data2).then(_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(){return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.next=2;return setBlockChangePaymentMethod();case 2:showSuccessModal(accountType);resolve();props.history.goBack();case 5:case'end':return _context5.stop();}}},_callee5,undefined);}))).catch(function(e){console.error(e);// eslint-disable-line
showErrorModal();reject(e);});_context6.next=22;break;case 21:resolve();case 22:case'end':return _context6.stop();}}},_callee6,undefined);}));return function(_x3,_x4){return _ref3.apply(this,arguments);};}());};// Removido por ora até ser confirmado que não haverá mais restrição de alteração
// const ableToChangePaymentForm =
//   props.authorizations.FORMA &&
//   !props.authorizations.FORMA.dataProximaAlteracao &&
//   !props.authorizations.FORMA.error
// const daysToChangePaymentForm = !ableToChangePaymentForm
//   ? moment(props.authorizations.FORMA.dataProximaAlteracao, 'DD/MM/YYYY').diff(moment(), 'days') +
//     1
//   : 0
var isCredit=props.location.state.currentPlan&&props.location.state.currentPlan.paymentType==='CARTAO_DE_CREDITO';var finalCardNumber=isCredit&&props.creditPaymentInfo.numeroMascarado?props.creditPaymentInfo.numeroMascarado.split('-')[3]:null;return _react2.default.createElement(_gridStyled.Flex,{direction:'column',__source:{fileName:_jsxFileName,lineNumber:204}},_react2.default.createElement(_reactHelmet2.default,{title:'Editar forma de pagamento',__source:{fileName:_jsxFileName,lineNumber:205}}),_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:206}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Dados do plano',back:function back(){return props.history.goBack();},__source:{fileName:_jsxFileName,lineNumber:207}})),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:209}},_react2.default.createElement(_gridStyled.Box,{width:[1,400],mt:24,__source:{fileName:_jsxFileName,lineNumber:210}},_react2.default.createElement(_styles.Notice,{__source:{fileName:_jsxFileName,lineNumber:211}},_react2.default.createElement(_Icon2.default,{height:14,icon:'alert',viewBox:'0 0 16 13',display:'flex',__source:{fileName:_jsxFileName,lineNumber:212}}),isCredit&&finalCardNumber?_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:215}},'Ao alterar a forma de pagamento, o cart\xE3o final ',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:216}},finalCardNumber),' ser\xE1 automaticamente descadastrado.'):_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:220}},'A forma de pagamento atual ser\xE1 automaticamente descadastrada assim que voc\xEA cadastrar uma nova op\xE7\xE3o de pagamento.')// Removido por ora até ser confirmado que não haverá mais restrição de alteração
// )
// )
// : (
//   <span>
//     Você fez uma alteração de forma de pagamento recentemente.<br /> Em{' '}
//     <b>{daysToChangePaymentForm}</b> dia{daysToChangePaymentForm > 1 ? 's' : ''} você
//     poderá fazer uma nova alteração.
//   </span>
)),_react2.default.createElement(_gridStyled.Box,{width:[1,680],__source:{fileName:_jsxFileName,lineNumber:236}},_react2.default.createElement(_PaymentForm2.default// ableToChangePaymentForm={ableToChangePaymentForm}
,{paymentType:props.location.state.currentPlan.paymentType,onSubmit:onSubmit,dueDates:props.location.state.dueDates,paymentTypesOptions:props.location.state.paymentTypes,handleBackClick:function handleBackClick(){return props.history.goBack();},__source:{fileName:_jsxFileName,lineNumber:237}}))));};var mapStateToProps=function mapStateToProps(_ref7){var reducer=_ref7.reducer;return{userData:reducer.user,accountType:reducer.account.accountType,authorizations:reducer.planData.authorizations,creditPaymentInfo:reducer.recharge.paymentInfo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showSuccessModal:function showSuccessModal(accountType){return dispatch((0,_actions3.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data3.titleModalSuccess,modalDescription:_data3.bodyModalSuccess,accountType:accountType,image:accountType==='pf'?_confirmation2.default:_iconVeloeBackground2.default}));},showErrorModal:function showErrorModal(accountType){return dispatch((0,_actions3.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data3.titleModalError,modalDescription:_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:273}},'N\xE3o foi poss\xEDvel alterar sua forma de pagamento. ',_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:274}}),' Verifique os dados fornecidos e tente novamente'),accountType:accountType,image:accountType==='pf'?_trafficSignalError2.default:_iconVeloeBackground2.default}));},showCardErrorModal:function showCardErrorModal(accountType){return dispatch((0,_actions3.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data3.titleModalError,modalDescription:_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:287}},_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:288}},'Cart\xE3o inv\xE1lido'),_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:289}}),'Por favor, confira o n\xFAmero digitado ou escolha outro cart\xE3o'),accountType:accountType,image:accountType==='pf'?_trafficSignalError2.default:_iconVeloeBackground2.default}));},setBlockChangePaymentMethod:function setBlockChangePaymentMethod(){return dispatch((0,_actions.lockAuthorizationPayment)('FORMA'));},updatePaymentMethod:function updatePaymentMethod(data){return dispatch((0,_actions.setNewDataValueWithoutRecharge)(data));},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(EditPaymentMethod);module.exports=exports['default'];

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/PaymentForm/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _Radio=__webpack_require__(136);var _Radio2=_interopRequireDefault(_Radio);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _data=__webpack_require__(405);var _styles=__webpack_require__(659);var _credit=__webpack_require__(2131);var _credit2=_interopRequireDefault(_credit);var _debit=__webpack_require__(2136);var _debit2=_interopRequireDefault(_debit);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentForm=function(_Component){_inherits(PaymentForm,_Component);function PaymentForm(){_classCallCheck(this,PaymentForm);return _possibleConstructorReturn(this,(PaymentForm.__proto__||Object.getPrototypeOf(PaymentForm)).apply(this,arguments));}_createClass(PaymentForm,[{key:'componentDidMount',value:function componentDidMount(){var paymentType=this.props.paymentType;if(paymentType==='DEBITO_EM_CONTA'){this.props.initialize({paymentMethod:'CUENTA'});}else if(paymentType==='CARTAO_DE_CREDITO'){this.props.initialize({paymentMethod:'CAJA'});}else{this.props.initialize({paymentMethod:'DISPOSICION'});}}},{key:'render',value:function render(){var _props=this.props,handleSubmit=_props.handleSubmit,onSubmit=_props.onSubmit,paymentType=_props.paymentType,paymentInfo=_props.paymentInfo,onSucessUpdate=_props.onSucessUpdate,creditCardUpdated=_props.creditCardUpdated,reset=_props.reset,dueDates=_props.dueDates,paymentTypesOptions=_props.paymentTypesOptions,formValues=_props.formValues,props=_objectWithoutProperties(_props,['handleSubmit','onSubmit','paymentType','paymentInfo','onSucessUpdate','creditCardUpdated','reset','dueDates','paymentTypesOptions','formValues']);return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement('form',{onSubmit:handleSubmit(onSubmit),__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement(_styles.FormField,{__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:47}},'Selecione a forma de pagamento'),_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:48}},_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:49}},paymentTypesOptions.formas.map(function(paymentType){return _react2.default.createElement(_gridStyled.Box,{key:paymentType.forma,mr:20,mb:[39,28],__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_reduxForm.Field,{component:_Radio2.default,label:paymentType.descricao,name:'paymentMethod',type:'radio',value:paymentType.forma,__source:{fileName:_jsxFileName,lineNumber:52}}));}))),_react2.default.createElement(_gridStyled.Flex,{direction:'column',__source:{fileName:_jsxFileName,lineNumber:63}},formValues&&formValues.paymentMethod==='CUENTA'&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:66}},_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:67}},'Preencha os dados do seu banco'),_react2.default.createElement(_debit2.default,{__source:{fileName:_jsxFileName,lineNumber:68}})),formValues&&formValues.paymentMethod==='CAJA'&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:74}},'Preencha os dados do seu cart\xE3o'),_react2.default.createElement(_credit2.default,{formValues:formValues,__source:{fileName:_jsxFileName,lineNumber:75}})))),_react2.default.createElement(_styles.Buttons,{__source:{fileName:_jsxFileName,lineNumber:80}},_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:81}},_react2.default.createElement(_Button2.default,{onClick:props.handleBackClick,text:_data.labels.buttons.back,buttonType:'white',width:(0,_rem2.default)('220px'),__source:{fileName:_jsxFileName,lineNumber:82}})),_react2.default.createElement(_gridStyled.Box,{mt:[15,0],ml:[12,60],__source:{fileName:_jsxFileName,lineNumber:89}},_react2.default.createElement(_Button2.default,{text:props.submitting?_data.labels.buttons.saving:_data.labels.buttons.save,type:formValues&&'submit',width:(0,_rem2.default)('220px'),disabled:!props.dirty||props.invalid||props.submitting,__source:{fileName:_jsxFileName,lineNumber:90}})))));}}]);return PaymentForm;}(_react.Component);var Container=(0,_reactRedux.connect)(function(state){return{formValues:(0,_reduxForm.getFormValues)('PaymentForm')(state)};});var Form=(0,_reduxForm.reduxForm)({form:'PaymentForm'})(Container(PaymentForm));exports.default=Form;module.exports=exports['default'];

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/PaymentForm/credit.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _reduxForm=__webpack_require__(11);var _renderInputs=__webpack_require__(44);var _validators=__webpack_require__(266);var _CardFlags=__webpack_require__(2135);var _Icon=__webpack_require__(31);var _validators2=__webpack_require__(267);var _styles=__webpack_require__(659);var _data=__webpack_require__(405);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CreditPaymentForm=function CreditPaymentForm(_ref){var formValues=_ref.formValues;var checkCreditCardFlag=function checkCreditCardFlag(cardNumber){var creditCardFlag=(0,_validators.validateCreditCardFlag)(cardNumber);if(creditCardFlag){return creditCardFlag;}else{return undefined;}};var creditCardFlag=checkCreditCardFlag(formValues.cardNumber);var validateSecurityCode=creditCardFlag==='amex'?[_validators2.required,_validators2.validateAmexCVV]:[_validators2.required,_validators2.validateCVV];return _react2.default.createElement(_gridStyled.Flex,{direction:'column',__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_gridStyled.Box,{width:[1,380],mb:[24,28],__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCardInput,label:_data.labels.cardNumber,name:'cardNumber',placeholder:_data.labels.placeholder.cardNumber,validate:_validators2.required,labelIcon:_react2.default.createElement(_Icon.Icon,{icon:'lock',width:'100',height:'100',viewBox:'0 0 100 100',__source:{fileName:_jsxFileName,lineNumber:47}}),__source:{fileName:_jsxFileName,lineNumber:41}}),_react2.default.createElement(_styles.CardFlagList,{__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_styles.CardFlagItem,{hideCard:creditCardFlag!==undefined&&creditCardFlag!=='elo',__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement(_CardFlags.Elo,{__source:{fileName:_jsxFileName,lineNumber:51}})),_react2.default.createElement(_styles.CardFlagItem,{hideCard:creditCardFlag!==undefined&&creditCardFlag!=='master',__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_CardFlags.MasterCard,{__source:{fileName:_jsxFileName,lineNumber:54}})),_react2.default.createElement(_styles.CardFlagItem,{hideCard:creditCardFlag!==undefined&&creditCardFlag!=='visa',__source:{fileName:_jsxFileName,lineNumber:56}},_react2.default.createElement(_CardFlags.Visa,{__source:{fileName:_jsxFileName,lineNumber:57}})),_react2.default.createElement(_styles.CardFlagItem,{hideCard:creditCardFlag!==undefined&&creditCardFlag!=='amex',__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_CardFlags.Amex,{__source:{fileName:_jsxFileName,lineNumber:60}})))),_react2.default.createElement(_gridStyled.Box,{width:[1,380],mb:[17,20],__source:{fileName:_jsxFileName,lineNumber:64}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.yourName,placeholder:_data.labels.placeholder.yourName,name:'fullName',validate:_validators2.required,__source:{fileName:_jsxFileName,lineNumber:65}})),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],width:[1,380],__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement(_gridStyled.Box,{mb:[17,20],mr:33,width:[1,200],__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderValidThruInput,label:_data.labels.validThru,placeholder:_data.labels.placeholder.validThru,name:'validThru',validate:[_validators2.required,_validators2.validateExpireDate],__source:{fileName:_jsxFileName,lineNumber:75}})),_react2.default.createElement(_gridStyled.Box,{mb:[17,37],width:[1,300],__source:{fileName:_jsxFileName,lineNumber:83}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCvcInput,label:_data.labels.securityCode,placeholder:creditCardFlag==='amex'?_data.labels.placeholder.amexSecurityCode:_data.labels.placeholder.securityCode,name:'cvv',validate:validateSecurityCode,tooltip:'O c\xF3digo de seguran\xE7a de seu cart\xE3o (CVV) \xE9 o n\xFAmero de 3 ou 4 d\xEDgitos localizado no verso da maioria dos cart\xF5es.',tooltipColor:_colors.deepCerise,limitDigit:creditCardFlag==='amex'?4:3,tooltipPositionRight:true,endIcon:_react2.default.createElement(_Icon.Icon,{icon:'info',width:'100',height:'100',viewBox:'0 0 100 100',__source:{fileName:_jsxFileName,lineNumber:98}}),__source:{fileName:_jsxFileName,lineNumber:84}}))));};exports.default=CreditPaymentForm;module.exports=exports['default'];

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Type = __webpack_require__(2133)

module.exports = Type({
  name: 'Elo',
  pattern: /^(4[035]|5[0]|6[235])(6[7263]|9[90]|1[2416]|7[736]|8[9]|0[04579]|5[0])([0-9])([0-9])\d{10}$/,
  eagerPattern: /^(4[035]|5[0]|6[235])(6[7263]|9[90]|1[2416]|7[736]|8[9]|0[04579]|5[0])([0-9])([0-9])/,
  groupPattern: /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?(\d{1,3})?/
})


/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign = __webpack_require__(2134)

module.exports = CardType

function CardType (data) {
  if (!(this instanceof CardType)) return new CardType(data)
  assign(this, data)
}

CardType.prototype.digits = 16
CardType.prototype.cvcLength = 3
CardType.prototype.luhn = true
CardType.prototype.groupPattern = /(\d{1,4})(\d{1,4})?(\d{1,4})?(\d{1,4})?/

CardType.prototype.group = function (number) {
  return (number.match(this.groupPattern) || [])
    .slice(1)
    .filter(Boolean)
}

CardType.prototype.test = function (number, eager) {
  return this[eager ? 'eagerPattern' : 'pattern'].test(number)
}


/***/ }),
/* 2134 */
/***/ (function(module, exports) {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Visa=exports.Amex=exports.Diners=exports.MasterCard=exports.Elo=undefined;var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/CardFlags/index.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Elo=exports.Elo=function Elo(){return _react2.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"40",height:"24",viewBox:"0 0 40 24",__source:{fileName:_jsxFileName,lineNumber:4}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{id:"a",d:"M.007.013h4.85v3.266H.007z",__source:{fileName:_jsxFileName,lineNumber:6}})),_react2.default.createElement("g",{fill:"none",fillRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement("rect",{width:"40",height:"24",fill:"#000",rx:"2",__source:{fileName:_jsxFileName,lineNumber:9}}),_react2.default.createElement("path",{fill:"#FFCA05",d:"M8.987 8.65c.36-.117.744-.18 1.144-.18 1.744 0 3.2 1.212 3.534 2.824l2.473-.494C15.571 8.061 13.097 6 10.131 6c-.68 0-1.333.108-1.944.308l.8 2.342z",__source:{fileName:_jsxFileName,lineNumber:10}}),_react2.default.createElement("path",{fill:"#00A4DF",d:"M6.069 16.493l1.672-1.85a3.49 3.49 0 0 1-1.217-2.644c0-1.052.47-1.996 1.216-2.642l-1.672-1.85A5.932 5.932 0 0 0 4 11.999c0 1.789.8 3.395 2.069 4.494",__source:{fileName:_jsxFileName,lineNumber:14}}),_react2.default.createElement("path",{fill:"#EE4123",d:"M13.664 12.707c-.334 1.61-1.79 2.821-3.533 2.821-.4 0-.786-.063-1.145-.181l-.8 2.343c.61.2 1.264.307 1.945.307 2.963 0 5.436-2.057 6.006-4.794l-2.473-.496z",__source:{fileName:_jsxFileName,lineNumber:18}}),_react2.default.createElement("path",{fill:"#FEFEFE",d:"M23.242 13.99l-.002.003-.07-.047a1.977 1.977 0 0 1-.918.752c-.759.323-1.462.24-1.967-.194l-.046.07-.001-.002-.861 1.26c.213.146.443.269.684.367.95.387 1.924.37 2.883-.039.693-.294 1.237-.742 1.61-1.31l-1.312-.86zm-2.688-3.11c-.802.337-1.215 1.073-1.13 1.935l3.394-1.43c-.583-.67-1.343-.893-2.264-.504zM18.3 14.72a4.272 4.272 0 0 1-.257-.484 3.49 3.49 0 0 1-.08-2.695c.364-.969 1.058-1.71 1.956-2.089 1.128-.475 2.376-.381 3.457.247.687.385 1.174.98 1.544 1.823.047.108.088.223.129.32L18.3 14.722zM27.408 7.596v7.008l1.113.442-.633 1.445-1.229-.501a1.386 1.386 0 0 1-.605-.498c-.136-.206-.238-.488-.238-.869V7.596h1.592zM30.292 12.819c0-.597.27-1.132.696-1.496l-1.142-1.246a3.618 3.618 0 0 0-1.264 2.74 3.619 3.619 0 0 0 1.26 2.744l1.141-1.248a1.965 1.965 0 0 1-.69-1.494M32.322 14.808c-.225 0-.442-.037-.644-.103l-.545 1.588c.372.122.772.189 1.187.19 1.809.001 3.32-1.255 3.669-2.924l-1.677-.336a2.021 2.021 0 0 1-1.99 1.585",__source:{fileName:_jsxFileName,lineNumber:22}}),_react2.default.createElement("g",{transform:"translate(31.134 9.146)",__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement("path",{fill:"#FEFEFE",d:"M1.193.013C.778.013.38.078.007.199l.54 1.59a2.09 2.09 0 0 1 .644-.103c.984.001 1.803.686 1.99 1.593l1.676-.333C4.512 1.274 3.003.014 1.193.013",mask:"url(#b)",__source:{fileName:_jsxFileName,lineNumber:27}}))));};var MasterCard=exports.MasterCard=function MasterCard(){return _react2.default.createElement("svg",{width:"40px",height:"24px",viewBox:"0 0 40 24",version:"1.1",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement("g",{id:"FC---8.-Pagamento",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd",transform:"translate(-780.000000, -272.000000)",__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement("g",{id:"Cartoes",transform:"translate(684.000000, 272.000000)",__source:{fileName:_jsxFileName,lineNumber:54}},_react2.default.createElement("g",{id:"Mastercard",transform:"translate(96.000000, 0.000000)",__source:{fileName:_jsxFileName,lineNumber:55}},_react2.default.createElement("rect",{id:"Rectangle",fill:"#F1F1F7",x:"0",y:"0",width:"40",height:"24",rx:"2",__source:{fileName:_jsxFileName,lineNumber:56}}),_react2.default.createElement("g",{id:"Group-7",transform:"translate(8.000000, 5.000000)",__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement("circle",{id:"Oval",fill:"#DE001A",cx:"7",cy:"7",r:"7",__source:{fileName:_jsxFileName,lineNumber:58}}),_react2.default.createElement("circle",{id:"Oval",fill:"#E9951A",cx:"17",cy:"7",r:"7",__source:{fileName:_jsxFileName,lineNumber:59}}),_react2.default.createElement("path",{d:"M12,2.10101726 C13.237187,3.36355437 14,5.09269493 14,7 C14,8.90730507 13.237187,10.6364456 12,11.8989827 C10.762813,10.6364456 10,8.90730507 10,7 C10,5.09269493 10.762813,3.36355437 12,2.10101727 Z",id:"Combined-Shape",fill:"#F15900",__source:{fileName:_jsxFileName,lineNumber:60}}))))));};var Diners=exports.Diners=function Diners(){return _react2.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"40",height:"24",viewBox:"0 0 40 24",__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement("rect",{id:"a",width:"40",height:"24",rx:"2",__source:{fileName:_jsxFileName,lineNumber:75}})),_react2.default.createElement("g",{fill:"none",fillRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:77}},_react2.default.createElement("g",{__source:{fileName:_jsxFileName,lineNumber:78}},_react2.default.createElement("use",{fill:"#FFF",__source:{fileName:_jsxFileName,lineNumber:79}}),_react2.default.createElement("rect",{width:"39",height:"23",x:".5",y:".5",stroke:"#184977",rx:"2",__source:{fileName:_jsxFileName,lineNumber:80}})),_react2.default.createElement("path",{fill:"#FFFFFE",d:"M12 12.333a6.667 6.667 0 1 1 13.333 0 6.667 6.667 0 0 1-13.333 0",__source:{fileName:_jsxFileName,lineNumber:82}}),_react2.default.createElement("path",{fill:"#184977",d:"M23.004 11.988a4.065 4.065 0 0 0-2.578-3.791v7.582a4.065 4.065 0 0 0 2.578-3.791zm-5.45 3.79v-7.58a4.068 4.068 0 0 0-2.576 3.79 4.067 4.067 0 0 0 2.576 3.79zM18.99 5.578c-3.497.001-6.33 2.87-6.33 6.409 0 3.539 2.833 6.407 6.33 6.407 3.496 0 6.33-2.868 6.33-6.407 0-3.54-2.834-6.408-6.33-6.409zm-.016 13.42C15.15 19.02 12 15.882 12 12.062 12 7.887 15.15 4.999 18.975 5h1.793C24.55 5 28 7.885 28 12.061 28 15.879 24.55 19 20.768 19h-1.793z",__source:{fileName:_jsxFileName,lineNumber:83}})));};var Amex=exports.Amex=function Amex(){return _react2.default.createElement("svg",{width:"40px",height:"24px",viewBox:"0 0 40 24",version:"1.1",xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",__source:{fileName:_jsxFileName,lineNumber:92}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:100}},_react2.default.createElement("radialGradient",{cx:"0%",cy:"0%",fx:"0%",fy:"0%",r:"141.421356%",gradientTransform:"translate(0.000000,0.000000),scale(0.600000,1.000000),rotate(30.963757),translate(-0.000000,-0.000000)",id:"radialGradient-1",__source:{fileName:_jsxFileName,lineNumber:101}},_react2.default.createElement("stop",{stopColor:"#60BCE8",offset:"0%",__source:{fileName:_jsxFileName,lineNumber:110}}),_react2.default.createElement("stop",{stopColor:"#0067B4",offset:"100%",__source:{fileName:_jsxFileName,lineNumber:111}})),_react2.default.createElement("polygon",{id:"path-2",points:"0 0.731466667 30.9857692 0.731466667 30.9857692 5.83691333 0 5.83691333",__source:{fileName:_jsxFileName,lineNumber:113}}),_react2.default.createElement("polygon",{id:"path-4",points:"0.0451589744 0.0914333333 3.54192821 0.0914333333 3.54192821 5.2 0.0451589744 5.2",__source:{fileName:_jsxFileName,lineNumber:117}})),_react2.default.createElement("g",{id:"FC---8.-Pagamento",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd",transform:"translate(-876.000000, -272.000000)",__source:{fileName:_jsxFileName,lineNumber:122}},_react2.default.createElement("g",{id:"Cartoes",transform:"translate(684.000000, 272.000000)",__source:{fileName:_jsxFileName,lineNumber:130}},_react2.default.createElement("g",{id:"Amex",transform:"translate(192.000000, 0.000000)",__source:{fileName:_jsxFileName,lineNumber:131}},_react2.default.createElement("rect",{id:"Rectangle",fill:"url(#radialGradient-1)",x:"0",y:"0",width:"40",height:"24",rx:"2",__source:{fileName:_jsxFileName,lineNumber:132}}),_react2.default.createElement("g",{id:"Page-1",transform:"translate(3.000000, 5.000000)",__source:{fileName:_jsxFileName,lineNumber:141}},_react2.default.createElement("path",{d:"M17.2332923,3.09426 C17.1138564,3.16272667 16.9708821,3.16879333 16.7991385,3.16879333 L15.7294462,3.16879333 L15.7294462,2.35586 L16.8130872,2.35586 C16.9673949,2.35586 17.1278051,2.36106 17.2315487,2.41999333 C17.3457538,2.47459333 17.4154974,2.58812667 17.4154974,2.74326 C17.4154974,2.90359333 17.3474974,3.03099333 17.2332923,3.09426",id:"Fill-1",fill:"#FFFFFF",__source:{fileName:_jsxFileName,lineNumber:142}}),_react2.default.createElement("polygon",{id:"Fill-3",fill:"#FFFFFF",points:"3.97372821 3.67232667 3.37131795 2.21546 2.77152308 3.67232667",__source:{fileName:_jsxFileName,lineNumber:147}}),_react2.default.createElement("polygon",{id:"Fill-5",fill:"#FFFFFF",points:"23.6440359 3.67146 24.8567026 3.67146 24.2464462 2.21546",__source:{fileName:_jsxFileName,lineNumber:152}}),_react2.default.createElement("g",{id:"Group-9",transform:"translate(0.000000, 0.134940)",__source:{fileName:_jsxFileName,lineNumber:157}},_react2.default.createElement("mask",{id:"mask-3",fill:"white",__source:{fileName:_jsxFileName,lineNumber:158}},_react2.default.createElement("use",{xlinkHref:"#path-2",__source:{fileName:_jsxFileName,lineNumber:159}})),_react2.default.createElement("g",{id:"Clip-8",__source:{fileName:_jsxFileName,lineNumber:161}}),_react2.default.createElement("path",{d:"M30.2028974,5.11411333 L28.9562308,5.11411333 L27.289359,2.37198 L27.2911026,5.11411333 L25.4995641,5.11411333 L25.1578205,4.29858 L23.3270513,4.29858 L22.9983846,5.11411333 L21.9687949,5.11411333 C21.539,5.11411333 20.9976154,5.01964667 20.693359,4.71111333 C20.3812564,4.39824667 20.2234615,3.97964667 20.2234615,3.31318 C20.2234615,2.76978 20.3202308,2.27578 20.6968462,1.88404667 C20.9827949,1.59198 21.4274103,1.45591333 22.0333077,1.45591333 L22.8833077,1.45591333 L22.8833077,2.24024667 L22.0516154,2.24024667 C21.7299231,2.24024667 21.5459744,2.28878 21.3707436,2.45864667 C21.2242821,2.61204667 21.1205385,2.90324667 21.1205385,3.28804667 C21.1205385,3.68064667 21.1972564,3.95971333 21.3637692,4.14604667 C21.4971538,4.28991333 21.7438718,4.33411333 21.9748974,4.33411333 L22.3706923,4.33411333 L23.6103846,1.45591333 L24.9276667,1.45591333 L26.4158205,4.91564667 L26.4158205,1.45591333 L27.7575128,1.45591333 L29.3040769,4.00391333 L29.3040769,1.45591333 L30.2028974,1.45591333 L30.2028974,5.11411333 Z M18.8957179,5.11411333 L19.7927949,5.11411333 L19.7927949,1.45591333 L18.8957179,1.45591333 L18.8957179,5.11411333 Z M18.1982821,3.72744667 C18.3229487,3.90598 18.3464872,4.07324667 18.3464872,4.39564667 L18.3464872,5.11411333 L17.4598718,5.11411333 L17.4563846,4.65478 C17.4563846,4.43724667 17.4781795,4.11918 17.3151538,3.94411333 C17.1852564,3.81411333 16.9934615,3.78724667 16.6743846,3.78724667 L15.729359,3.78724667 L15.729359,5.11411333 L14.8514615,5.11411333 L14.8514615,1.45678 L16.8757692,1.45678 C17.3221282,1.45678 17.6551538,1.47151333 17.9402308,1.63358 C18.2192051,1.79651333 18.3839744,2.03484667 18.3839744,2.44478 C18.3839744,3.02458 17.9925385,3.32791333 17.7658718,3.41891333 C17.9585385,3.49258 18.1224359,3.61824667 18.1982821,3.72744667 Z M14.2420769,2.22118 L12.1855128,2.22118 L12.1855128,2.87811333 L14.190641,2.87811333 L14.190641,3.62951333 L12.1855128,3.62691333 L12.1855128,4.35838 L14.2420769,4.35838 L14.2420769,5.11411333 L11.3032564,5.11411333 L11.3032564,1.45678 L14.2420769,1.45678 L14.2420769,2.22118 Z M10.6485385,5.11411333 L9.74797436,5.11411333 L9.74274359,2.25324667 L8.46905128,5.11411333 L7.69751282,5.11411333 L6.41510256,2.24718 L6.41510256,5.11411333 L4.62792308,5.11411333 L4.29053846,4.29944667 L2.45802564,4.29944667 L2.11976923,5.11411333 L1.16253846,5.11411333 L2.73612821,1.45678 L4.04382051,1.45678 L5.53807692,4.92171333 L5.53807692,1.45678 L6.97741026,1.45678 L8.1264359,3.94064667 L9.18392308,1.45678 L10.6485385,1.45678 L10.6485385,5.11411333 Z M28.543,0.73138 L28.543,1.33631333 L28.2021282,0.73138 L25.6939744,0.73138 L25.6939744,1.33631333 L25.381,0.73138 L21.9940769,0.73138 C21.4274103,0.73138 20.9261282,0.80938 20.5242308,1.02951333 L20.5242308,0.73138 L18.1904359,0.73138 L18.1904359,1.02951333 C17.9315128,0.802446667 17.5819231,0.73138 17.1957179,0.73138 L8.65735897,0.73138 L8.08110256,2.05044667 L7.497,0.73138 L4.80751282,0.73138 L4.80751282,1.33631333 L4.50935897,0.73138 L2.21653846,0.73138 L1.15120513,3.15544667 L-0.000435897436,5.83518 L2.65505128,5.83518 L2.99417949,5.01964667 L3.75264103,5.01964667 L4.08915385,5.83518 L7.04715385,5.83518 L7.04715385,5.21204667 L7.31217949,5.83691333 L8.84479487,5.83691333 L9.10807692,5.20511333 L9.10807692,5.83518 L16.4564359,5.83518 L16.4538205,4.50138 L16.5967949,4.50138 C16.6970513,4.50311333 16.7258205,4.51524667 16.7258205,4.67731333 L16.7258205,5.83518 L20.5242308,5.83518 L20.5242308,5.52404667 C20.8311026,5.68784667 21.3097179,5.83518 21.9347949,5.83518 L23.5354103,5.83518 L23.8771538,5.01964667 L24.6364872,5.01964667 L24.9721282,5.83518 L28.0521795,5.83518 L28.0521795,5.06124667 L28.5185897,5.83518 L30.9857692,5.83518 L30.9857692,0.73138 L28.543,0.73138 Z",id:"Fill-7",fill:"#FFFFFF",mask:"url(#mask-3)",__source:{fileName:_jsxFileName,lineNumber:162}})),_react2.default.createElement("path",{d:"M32.4454154,8.66623333 L30.8395692,8.66623333 C30.6800308,8.66623333 30.5728,8.67316667 30.4856205,8.7321 C30.3932103,8.7919 30.3565949,8.88116667 30.3565949,8.99643333 C30.3565949,9.13336667 30.4341846,9.22783333 30.5501333,9.26856667 C30.6408,9.30063333 30.7410564,9.3093 30.8892615,9.31103333 L31.3643897,9.32316667 C31.8447487,9.33616667 32.166441,9.41763333 32.3634667,9.6161 C32.3957231,9.6447 32.4201333,9.6785 32.4454154,9.70883333 L32.4454154,8.66623333 Z M32.4454154,11.0781667 C32.2292103,11.3919 31.9973128,11.5470333 31.2501846,11.5470333 L29.5510564,11.5470333 L29.5510564,10.7618333 L31.2432103,10.7618333 C31.4105949,10.7618333 31.5274154,10.7401667 31.5989026,10.6708333 C31.6590564,10.6162333 31.7043897,10.5347667 31.7043897,10.4333667 C31.7043897,10.3267667 31.6590564,10.2401 31.597159,10.1915667 C31.5309026,10.1335 31.4393641,10.1101 31.2876718,10.1083667 C30.4620821,10.0815 29.4316205,10.1335 29.4316205,8.97563333 C29.4316205,8.4461 29.7707487,7.88796667 30.6913641,7.88796667 L32.4454154,7.88796667 L32.4454154,7.15996667 L30.8160308,7.15996667 C30.3234667,7.15996667 29.9677744,7.2761 29.7140821,7.45896667 L29.7140821,7.15996667 L27.3061846,7.15996667 C26.9234667,7.15996667 26.4718769,7.25616667 26.2556718,7.45896667 L26.2574154,7.15996667 L21.9568513,7.15996667 L21.9568513,7.45896667 C21.6142359,7.21543333 21.0388513,7.15996667 20.7694667,7.15996667 L17.9361333,7.15996667 L17.9361333,7.45896667 C17.6641333,7.19896667 17.0643385,7.15996667 16.6973128,7.15996667 L13.5213641,7.15996667 L12.795159,7.94343333 L12.1160308,7.15996667 L7.37346667,7.15996667 L7.37346667,12.2663667 L12.0271077,12.2663667 L12.7751077,11.4725 L13.4812615,12.2663667 L16.3459795,12.2681 L16.3459795,11.0669 L16.6301846,11.0669 C17.0085436,11.0712333 17.4601333,11.0582333 17.8550564,10.8883667 L17.8550564,12.2663667 L20.2202359,12.2663667 L20.2202359,10.9343 L20.3335692,10.9343 C20.4800308,10.9343 20.4939795,10.9429667 20.4939795,11.0851 L20.4939795,12.2663667 L27.6793128,12.2663667 C28.1343897,12.2663667 28.6112615,12.1502333 28.8745436,11.9396333 L28.8745436,12.2663667 L31.155159,12.2663667 C31.6294154,12.2663667 32.0914667,12.2005 32.4454154,12.0315 L32.4454154,11.0781667 Z M28.9346974,9.6161 C29.1081846,9.79376667 29.1979795,10.0173667 29.1979795,10.3909 C29.1979795,11.1795667 28.7028,11.5470333 27.8170564,11.5470333 L26.1031077,11.5470333 L26.1031077,10.7618333 L27.8109538,10.7618333 C27.9792103,10.7618333 28.095159,10.7401667 28.1701333,10.6708333 C28.2294154,10.6162333 28.2738769,10.5347667 28.2738769,10.4333667 C28.2738769,10.3267667 28.2276718,10.2401 28.1649026,10.1915667 C28.0986462,10.1335 28.0062359,10.1101 27.8528,10.1083667 C27.0306974,10.0815 26.0002359,10.1335 26.0002359,8.97563333 C26.0002359,8.4461 26.3358769,7.88796667 27.2573641,7.88796667 L29.0210051,7.88796667 L29.0210051,8.66623333 L27.4090564,8.66623333 C27.2469026,8.66623333 27.143159,8.67316667 27.0542359,8.7321 C26.9592103,8.7919 26.9234667,8.88116667 26.9234667,8.99643333 C26.9234667,9.13336667 27.0054154,9.22783333 27.1161333,9.26856667 C27.2076718,9.30063333 27.3061846,9.3093 27.4561333,9.31103333 L27.9312615,9.32316667 C28.4098769,9.33616667 28.7350564,9.41763333 28.9346974,9.6161 Z M20.9978769,9.3925 C20.8819282,9.4601 20.7354667,9.46703333 20.5654667,9.46703333 L19.4957744,9.46703333 L19.4957744,8.6463 L20.5794154,8.6463 C20.7354667,8.6463 20.8941333,8.6489 20.9978769,8.71043333 C21.1120821,8.7711 21.1800821,8.8829 21.1800821,9.04063333 C21.1800821,9.19576667 21.1120821,9.32316667 20.9978769,9.3925 Z M21.5296718,9.84576667 C21.7249538,9.91683333 21.8853641,10.0459667 21.9603385,10.1543 C22.0841333,10.3337 22.1050564,10.4992333 22.1068,10.8225 L22.1068,11.5470333 L21.2245436,11.5470333 L21.2245436,11.0885667 C21.2245436,10.8684333 21.2445949,10.5434333 21.0815692,10.3744333 C20.9534154,10.2401 20.7581333,10.2097667 20.4381846,10.2097667 L19.4957744,10.2097667 L19.4957744,11.5470333 L18.6143897,11.5470333 L18.6143897,7.88796667 L20.6421846,7.88796667 C21.0902872,7.88796667 21.4137231,7.90616667 21.7014154,8.06216667 C21.9786462,8.22596667 22.1521333,8.45823333 22.1521333,8.87423333 C22.1521333,9.45663333 21.7606974,9.75476667 21.5296718,9.84576667 Z M22.6412103,7.88796667 L25.5782872,7.88796667 L25.5782872,8.6463 L23.5182359,8.6463 L23.5182359,9.3093 L25.5268513,9.3093 L25.5268513,10.0563667 L23.5182359,10.0563667 L23.5182359,10.7835 L25.5782872,10.7869667 L25.5782872,11.5470333 L22.6412103,11.5470333 L22.6412103,7.88796667 Z M16.7086462,9.57536667 L15.5692103,9.57536667 L15.5692103,8.6463 L16.7173641,8.6463 C17.0355692,8.6463 17.2552615,8.77283333 17.2552615,9.09436667 C17.2552615,9.4107 17.0460308,9.57536667 16.7086462,9.57536667 Z M14.6930564,11.2151 L13.3443897,9.72443333 L14.6930564,8.2823 L14.6930564,11.2151 Z M11.2067487,10.7835 L9.04469744,10.7835 L9.04469744,10.0563667 L10.9757231,10.0563667 L10.9757231,9.3093 L9.04469744,9.3093 L9.04469744,8.6463 L11.2485949,8.6463 L12.2110564,9.71056667 L11.2067487,10.7835 Z M18.1985436,9.09436667 C18.1985436,10.1083667 17.4374667,10.3198333 16.6659282,10.3198333 L15.5692103,10.3198333 L15.5692103,11.5470333 L13.8622359,11.5470333 L12.7785949,10.3371667 L11.6531077,11.5470333 L8.17028718,11.5470333 L8.17028718,7.88796667 L11.707159,7.88796667 L12.7890564,9.0857 L13.9075692,7.88796667 L16.7173641,7.88796667 C17.4156718,7.88796667 18.1985436,8.08036667 18.1985436,9.09436667 Z",id:"Fill-10",fill:"#FFFFFF",__source:{fileName:_jsxFileName,lineNumber:169}}),_react2.default.createElement("g",{id:"Group-14",transform:"translate(29.641026, 7.068273)",__source:{fileName:_jsxFileName,lineNumber:174}},_react2.default.createElement("mask",{id:"mask-5",fill:"white",__source:{fileName:_jsxFileName,lineNumber:175}},_react2.default.createElement("use",{xlinkHref:"#path-4",__source:{fileName:_jsxFileName,lineNumber:176}})),_react2.default.createElement("g",{id:"Clip-13",__source:{fileName:_jsxFileName,lineNumber:178}}),_react2.default.createElement("path",{d:"M2.80438974,0.0914333333 L2.80438974,0.819433333 L2.80438974,1.5977 L2.80438974,2.65676667 C2.91946667,2.81796667 2.9813641,3.0199 2.9813641,3.32323333 C2.9813641,3.8545 2.73987692,4.1795 2.32141538,4.34416667 C2.28131282,4.36756667 2.24382564,4.38576667 2.20546667,4.40223333 C2.19762051,4.40483333 2.19151795,4.40743333 2.18367179,4.40916667 C1.95962051,4.49323333 1.75997949,4.4785 1.75997949,4.4785 L1.60044103,4.4785 L0.0451589744,4.4785 L0.0451589744,5.20043333 L1.98228718,5.20043333 C2.9822359,5.20043333 3.54192821,4.7853 3.54192821,3.89436667 L3.54192821,0.0914333333 L2.80438974,0.0914333333 Z",id:"Fill-12",fill:"#FFFFFF",mask:"url(#mask-5)",__source:{fileName:_jsxFileName,lineNumber:179}})))))));};var Visa=exports.Visa=function Visa(){return _react2.default.createElement("svg",{width:"40px",height:"24px",viewBox:"0 0 40 24",version:"1.1",xmlns:"http://www.w3.org/2000/svg",__source:{fileName:_jsxFileName,lineNumber:194}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:201}},_react2.default.createElement("linearGradient",{x1:"0%",y1:"0%",x2:"100%",y2:"0%",id:"linearGradient-1",__source:{fileName:_jsxFileName,lineNumber:202}},_react2.default.createElement("stop",{stopColor:"#201F46",offset:"0%",__source:{fileName:_jsxFileName,lineNumber:203}}),_react2.default.createElement("stop",{stopColor:"#1A4788",offset:"100%",__source:{fileName:_jsxFileName,lineNumber:204}}))),_react2.default.createElement("g",{id:"FC---8.-Pagamento",stroke:"none",strokeWidth:"1",fill:"none",fillRule:"evenodd",transform:"translate(-732.000000, -272.000000)",__source:{fileName:_jsxFileName,lineNumber:207}},_react2.default.createElement("g",{id:"Cartoes",transform:"translate(684.000000, 272.000000)",__source:{fileName:_jsxFileName,lineNumber:215}},_react2.default.createElement("g",{id:"Visa",transform:"translate(48.000000, 0.000000)",__source:{fileName:_jsxFileName,lineNumber:216}},_react2.default.createElement("rect",{id:"Rectangle",fill:"#F1F1F7",x:"0",y:"0",width:"40",height:"24",rx:"2",__source:{fileName:_jsxFileName,lineNumber:217}}),_react2.default.createElement("path",{d:"M20.4116173,10.5574565 C20.4224897,9.05175576 21.7716877,8 23.6883869,8 C24.4357937,8 25.0358192,8.1681313 25.5027742,8.34297635 L25.1620132,9.98371917 C24.294081,9.57130355 23.5277172,9.60026855 23.2500532,9.63738596 C22.6896143,9.71315534 22.433788,10.0081764 22.427562,10.2855499 C22.4086979,11.1979475 25.1530923,11.3106425 25.1445431,13.3524835 C25.1380382,14.9615758 23.8057529,16 21.7682494,16 C20.9009676,15.9906008 20.0644444,15.8034792 19.6117072,15.5889271 L19.962783,13.8933234 C20.4137547,14.1102732 20.9796762,14.3978132 21.9544738,14.3820839 C22.5126825,14.3731642 23.1097344,14.1443215 23.1154029,13.6249655 C23.1182836,13.2859215 22.8648734,13.0425963 22.1096609,12.6634617 C21.3745204,12.292959 20.3989794,11.6720337 20.4116173,10.5574565 Z M28.779265,8.14146815 L30.4343766,8.14146815 L32,15.8789608 L30.2064282,15.8789608 L29.9720679,14.7229502 L27.4843361,14.7229502 L27.0797347,15.8789608 L25.0436251,15.8789608 L27.9537072,8.70897124 C28.0929109,8.36484397 28.4068161,8.14146815 28.779265,8.14146815 Z M29.0633409,10.2321277 L28.0424519,13.137356 L29.6509144,13.137356 L29.0633409,10.2321277 Z M17.9444223,8.14146815 L19.883238,8.14146815 L18.2795148,15.8789608 L16.3401415,15.8789608 L17.9444223,8.14146815 Z M15.0751348,8.14146815 L17.1119879,8.14146815 L13.9699616,15.8789608 L11.9201917,15.8789608 L10.373897,9.70394792 C10.2800414,9.32385417 10.1987308,9.18430423 9.91326098,9.02432533 C9.44704939,8.76306482 8.67724737,8.5179173 8,8.36580307 L8.04571977,8.14146815 L11.3457209,8.14146815 C11.7660269,8.14146815 12.144516,8.430255 12.2401372,8.93014111 L13.0565883,13.407728 L15.0751348,8.14146815 Z",id:"Clip-14",fill:"url(#linearGradient-1)",__source:{fileName:_jsxFileName,lineNumber:218}})))));};

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/PaymentForm/debit.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _renderInputs=__webpack_require__(44);var _validators=__webpack_require__(267);var _data=__webpack_require__(405);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DebitPaymentForm=function DebitPaymentForm(_ref){var banks=_ref.banks,blockFields=_ref.blockFields;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement(_gridStyled.Box,{mb:[24,28],width:[1,380],__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderSelectField,label:_data.labels.bank,placeholder:_data.labels.placeholder.bank,name:'bankCode',options:banks,validate:_validators.required,disabled:blockFields,__source:{fileName:_jsxFileName,lineNumber:17}})),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],width:[1,380],__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement(_gridStyled.Box,{mb:[17,20],mr:33,width:1,__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderAgencyInput,label:_data.labels.agency,name:'agency',placeholder:_data.labels.placeholder.agency,validate:_validators.required,__source:{fileName:_jsxFileName,lineNumber:29}})),_react2.default.createElement(_gridStyled.Box,{mb:[17,20],mr:33,width:1,__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderAccountInput,label:_data.labels.account,name:'account',placeholder:_data.labels.placeholder.account,validate:_validators.required,__source:{fileName:_jsxFileName,lineNumber:38}})),_react2.default.createElement(_gridStyled.Box,{mb:[17,20],width:1,__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderAccountDigitInput,label:_data.labels.accountDigit,name:'accountDigit',placeholder:_data.labels.placeholder.accountDigit,validate:_validators.required,limitDigit:1,__source:{fileName:_jsxFileName,lineNumber:47}}))));};var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{banks:reducer.banks};};exports.default=(0,_reactRedux.connect)(mapStateToProps,null)(DebitPaymentForm);module.exports=exports['default'];

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Notice=exports.SubTitle=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ','\n\n    '],['\n        ','\n\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-433fkf-0'})(['',' color:',';margin:',' 0 ',' 0;',';'],_types.title32GalanoBold,_colors.linkNavyBlue,(0,_rem2.default)('40px'),(0,_rem2.default)('30px'),_media2.default.large(_templateObject,_types.title32GalanoBold));var SubTitle=exports.SubTitle=_styledComponents2.default.p.withConfig({displayName:'styles__SubTitle',componentId:'sc-433fkf-1'})(['',';color:',';letter-spacing:',';margin:0 0 ',' 0;text-transform:uppercase;'],_types.txt12OpenSans,_colors.darkGrey,(0,_em2.default)('1px'),(0,_rem2.default)('18'));var Notice=exports.Notice=_styledComponents2.default.div.withConfig({displayName:'styles__Notice',componentId:'sc-433fkf-2'})(['display:flex;',';color:',';line-height:1.29;svg{overflow:inherit;padding-top:2px;}span{margin-left:16px;}'],_types.txt14OpenSans,_colors.darkViolet);

/***/ }),
/* 2138 */
/***/ (function(module, exports) {

module.exports = {"titleModalSuccess":"Tudo certo!","bodyModalSuccess":"Sua forma de pagamento foi alterada com sucesso!","titleModalError":"Ops! Algo deu errado","bodyModalError":"Não foi possível alterar sua forma de pagamento. Verifique os dados fornecidos e tente novamente"}

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateEmpty=__webpack_require__(112);var _TemplateEmpty2=_interopRequireDefault(_TemplateEmpty);var _EditDueDate=__webpack_require__(2140);var _EditDueDate2=_interopRequireDefault(_EditDueDate);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id/data-de-vencimento',component:_TemplateEmpty2.default,routes:[{path:'/minha-veloe/:id/data-de-vencimento',exact:true,component:_EditDueDate2.default}]};module.exports=exports['default'];

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditDueDate/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRedux=__webpack_require__(7);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(13);var _actions2=__webpack_require__(36);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _DueDateForm=__webpack_require__(2141);var _DueDateForm2=_interopRequireDefault(_DueDateForm);var _actions3=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _styles=__webpack_require__(2146);var _data=__webpack_require__(2147);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var EditDueDate=function EditDueDate(props){var onSubmit=function onSubmit(values){var updateDueDate=props.updateDueDate,setBlockChangeDueDate=props.setBlockChangeDueDate,showSuccessModal=props.showSuccessModal,showErrorModal=props.showErrorModal,currentPlan=props.location.state.currentPlan;return new Promise(function(resolve,reject){if(values.dataFatura){var data={idConta:currentPlan.accountId,diaVenctoSolicitado:values.dataFatura};updateDueDate(data).then(_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return setBlockChangeDueDate();case 2:showSuccessModal();resolve();props.history.goBack();case 5:case'end':return _context.stop();}}},_callee,undefined);}))).catch(function(err){console.error(err);showErrorModal();return reject(err);});}});};var ableToChangeDueDate=props.authorizations.DATA&&!props.authorizations.DATA.dataProximaAlteracao&&!props.authorizations.DATA.error;var daysToChangeDueDate=!ableToChangeDueDate?(0,_moment2.default)(props.authorizations.DATA.dataProximaAlteracao,'DD/MM/YYYY').diff((0,_moment2.default)(),'days')+1:null;return _react2.default.createElement(_gridStyled.Flex,{direction:'column',__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_reactHelmet2.default,{title:'Editar data de vencimento',__source:{fileName:_jsxFileName,lineNumber:61}}),_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Dados do plano',back:function back(){return props.history.goBack();},__source:{fileName:_jsxFileName,lineNumber:63}})),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:65}},_react2.default.createElement(_gridStyled.Box,{width:[1,480],mt:24,__source:{fileName:_jsxFileName,lineNumber:66}},_react2.default.createElement(_styles.Notice,{__source:{fileName:_jsxFileName,lineNumber:67}},_react2.default.createElement(_Icon2.default,{height:14,icon:'alert',viewBox:'0 0 16 13',display:'flex',__source:{fileName:_jsxFileName,lineNumber:68}}),!ableToChangeDueDate?props.authorizations.DATA.error&&props.authorizations.DATA.description?_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:71}},props.authorizations.DATA.description):_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:73}},'Voc\xEA fez uma altera\xE7\xE3o de vencimento recentemente. ',_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:74}}),'Em',' ',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:75}},daysToChangeDueDate),' dia',daysToChangeDueDate>1?'s':'',' voc\xEA poder\xE1 fazer uma nova altera\xE7\xE3o.'):_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:80}},'Voc\xEA s\xF3 pode alterar a data de vencimento uma vez a cada ',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:81}},'90 dias'),'.'))),_react2.default.createElement(_gridStyled.Box,{width:[1,680],__source:{fileName:_jsxFileName,lineNumber:86}},_react2.default.createElement(_DueDateForm2.default,{ableToChangeDueDate:ableToChangeDueDate,onSubmit:onSubmit,dueDates:props.location.state.dueDates,handleBackClick:function handleBackClick(){return props.history.goBack();},__source:{fileName:_jsxFileName,lineNumber:87}}))));};var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{authorizations:reducer.planData.authorizations};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{showSuccessModal:function showSuccessModal(){return dispatch((0,_actions3.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalSuccess,modalDescription:_data.bodyModalSuccess,image:_confirmation2.default}));},showErrorModal:function showErrorModal(){return dispatch((0,_actions3.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,modalDescription:_data.bodyModalError,image:_confirmation2.default}));},updateDueDate:function updateDueDate(data){return dispatch((0,_actions.setNewDueDate)(data));},setBlockChangeDueDate:function setBlockChangeDueDate(){return dispatch((0,_actions.lockAuthorizationPayment)('DATA'));},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(EditDueDate);module.exports=exports['default'];

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/DueDateForm/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _gridStyled=__webpack_require__(8);var _Icon=__webpack_require__(31);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _RoundedCheck=__webpack_require__(2142);var _RoundedCheck2=_interopRequireDefault(_RoundedCheck);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _validators=__webpack_require__(267);var _data=__webpack_require__(2144);var _styles=__webpack_require__(2145);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DueDateForm=function(_Component){_inherits(DueDateForm,_Component);function DueDateForm(){_classCallCheck(this,DueDateForm);return _possibleConstructorReturn(this,(DueDateForm.__proto__||Object.getPrototypeOf(DueDateForm)).apply(this,arguments));}_createClass(DueDateForm,[{key:'componentDidMount',value:function componentDidMount(){this.props.initialize({dataFatura:this.props.dueDates[0].dia.toString()});}},{key:'render',value:function render(){var _props=this.props,handleSubmit=_props.handleSubmit,onSubmit=_props.onSubmit,paymentInfo=_props.paymentInfo,onSucessUpdate=_props.onSucessUpdate,reset=_props.reset,dueDates=_props.dueDates,formValues=_props.formValues,ableToChangeDueDate=_props.ableToChangeDueDate,props=_objectWithoutProperties(_props,['handleSubmit','onSubmit','paymentInfo','onSucessUpdate','reset','dueDates','formValues','ableToChangeDueDate']);var nextDueDates=formValues?dueDates.find(function(dueDate){return dueDate.dia===parseInt(formValues.dataFatura);}):[];return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement('form',{onSubmit:handleSubmit(onSubmit),__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.FormField,{disabled:!ableToChangeDueDate,__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:41}},'Selecione uma nova data para o vencimento de sua fatura'),_react2.default.createElement(_gridStyled.Box,{width:[1],__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:43}},dueDates.map(function(date){return _react2.default.createElement(_gridStyled.Box,{key:date.dia,mb:[12,28],ml:8,mr:8,width:[1,56],__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement(_reduxForm.Field,{component:_RoundedCheck2.default,label:date.dia.toString(),name:'dataFatura',type:'radio',value:date.dia.toString(),validate:_validators.required,__source:{fileName:_jsxFileName,lineNumber:46}}));}))),_react2.default.createElement(_gridStyled.Box,{width:[1,382],__source:{fileName:_jsxFileName,lineNumber:58}},_react2.default.createElement(_styles.Legend,{__source:{fileName:_jsxFileName,lineNumber:59}},'Veja como fica o vencimento das suas pr\xF3ximas faturas:'),_react2.default.createElement(_gridStyled.Flex,{direction:['column'],__source:{fileName:_jsxFileName,lineNumber:60}},nextDueDates.proximasFaturas&&nextDueDates.proximasFaturas.map(function(date){return _react2.default.createElement(_gridStyled.Box,{key:date,mb:[12,28],width:[1,290],__source:{fileName:_jsxFileName,lineNumber:63}},_react2.default.createElement(_gridStyled.Flex,{direction:['row'],align:'center',__source:{fileName:_jsxFileName,lineNumber:64}},_react2.default.createElement(_Icon.Icon,{icon:'calendar',width:'24',height:'24',viewBox:'0 0 100 100',__source:{fileName:_jsxFileName,lineNumber:65}}),_react2.default.createElement(_styles.DateLabel,{__source:{fileName:_jsxFileName,lineNumber:66}},(0,_moment2.default)(date,'DD/MM/YYYY').format('DD [de] MMMM'))));})))),_react2.default.createElement(_styles.Buttons,{__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement(_Button2.default,{onClick:props.handleBackClick,text:_data.labels.buttons.back,buttonType:'white',width:(0,_rem2.default)('220px'),__source:{fileName:_jsxFileName,lineNumber:75}})),_react2.default.createElement(_gridStyled.Box,{mt:[15,0],ml:[12,60],__source:{fileName:_jsxFileName,lineNumber:82}},_react2.default.createElement(_Button2.default,{text:props.submitting?_data.labels.buttons.saving:_data.labels.buttons.save,type:formValues&&'submit',width:(0,_rem2.default)('220px'),disabled:props.invalid||props.submitting||!ableToChangeDueDate,__source:{fileName:_jsxFileName,lineNumber:83}})))));}}]);return DueDateForm;}(_react.Component);var Container=(0,_reactRedux.connect)(function(state){return{formValues:(0,_reduxForm.getFormValues)('DueDateForm')(state)};});var Form=(0,_reduxForm.reduxForm)({form:'DueDateForm'})(Container(DueDateForm));exports.default=Form;module.exports=exports['default'];

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/RoundedCheck/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(2143);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var RoundedCheck=function RoundedCheck(_ref){var checked=_ref.checked,label=_ref.label,name=_ref.name,props=_objectWithoutProperties(_ref,['checked','label','name']);var inputProps=props.input;return _react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:7}},_react2.default.createElement(_styles.Container,{checked:props.input?props.input.checked:checked,role:'presentation',__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement(_styles.Input,_extends({},inputProps,{type:'radio',name:name,__source:{fileName:_jsxFileName,lineNumber:9}})),_react2.default.createElement(_styles.Text,{checked:props.input?props.input.checked:checked,__source:{fileName:_jsxFileName,lineNumber:10}},label)));};exports.default=RoundedCheck;module.exports=exports['default'];

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Input=exports.Label=exports.Text=exports.Container=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-vm1gxo-0'})(['width:56px;height:56px;border-radius:60px;display:flex;background-color:',';justify-content:center;align-items:center;cursor:pointer;'],function(props){return props.checked?_colors.lightBlue:_colors.paleGray;});var Text=exports.Text=_styledComponents2.default.span.withConfig({displayName:'styles__Text',componentId:'sc-vm1gxo-1'})(['',';font-weight:bold;text-align:center;color:',';'],_types.title18Galano,function(props){return props.checked?_colors.white:_colors.lightSilver;});var Label=exports.Label=_styledComponents2.default.label.withConfig({displayName:'styles__Label',componentId:'sc-vm1gxo-2'})(['user-select:none;']);var Input=exports.Input=_styledComponents2.default.input.withConfig({displayName:'styles__Input',componentId:'sc-vm1gxo-3'})(['display:none;']);

/***/ }),
/* 2144 */
/***/ (function(module, exports) {

module.exports = {"forgotpassword":"Esqueceu sua senha?","labels":{"bank":"informe seu banco","agency":"agência","account":"conta corrente","accountDigit":"Dígito","cardNumber":"Número do cartão de crédito","yourName":"Nome impresso no cartao","month":"Mês","year":"Ano","validThru":"Validade","securityCode":"código de segurança","buttons":{"save":"Alterar data de vencimento","saving":"Salvando","cancel":"Cancelar","back":"Voltar"},"placeholder":{"bank":"Selecione","account":"00000","agency":"0000","accountDigit":"0","validThru":"mm/aaaa","cardNumber":"0000 1111 2222 3333","yourName":"Digite aqui","securityCode":"000"},"radiosButtons":{"credit":"Cartão de crédito","debit":"Débito em conta"}},"banks":[{"value":"","label":"Selecione","disabled":true,"hidden":true},{"value":"Bradesco","label":"Bradesco"},{"value":"Banco do Brasil","label":"Banco do Brasil"},{"value":"Banco Safra","label":"Banco Safra"},{"value":"Itaú","label":"Itaú"},{"value":"Santander","label":"Santander"}]}

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.FormField=exports.CardFlagItem=exports.CardFlagList=exports.SelectCreditCardWrapper=exports.CardSubtitle=exports.CardTitle=exports.ItemDescription=exports.Item=exports.Separator=exports.Buttons=exports.DateLabel=exports.Legend=exports.Subtitle=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ','\n\n    '],['\n        ','\n\n    ']),_templateObject2=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  '],['\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-11f9ogz-0'})(['',' color:',';margin:',' 0 ',' 0;',';'],_types.title26GalanoBold,_colors.linkNavyBlue,(0,_rem2.default)('40px'),(0,_rem2.default)('30px'),_media2.default.large(_templateObject,_types.title32GalanoBold));var Subtitle=exports.Subtitle=_styledComponents2.default.div.withConfig({displayName:'styles__Subtitle',componentId:'sc-11f9ogz-1'})(['color:',';',' font-weight:bold;margin:12px 0 36px 0;'],_colors.darkBlue,_types.title26GalanoBold);var Legend=exports.Legend=_styledComponents2.default.div.withConfig({displayName:'styles__Legend',componentId:'sc-11f9ogz-2'})(['color:',';',';letter-spacing:1px;line-height:1.5;margin-top:30px;margin-bottom:16px;text-transform:uppercase;'],_colors.darkGrey,_types.txt14OpenSans);var DateLabel=exports.DateLabel=_styledComponents2.default.div.withConfig({displayName:'styles__DateLabel',componentId:'sc-11f9ogz-3'})(['',';color:',';margin:0 8px;'],_types.txt14OpenSansBold,_colors.darkBlue);var Buttons=exports.Buttons=_styledComponents2.default.div.withConfig({displayName:'styles__Buttons',componentId:'sc-11f9ogz-4'})(['display:flex;flex-direction:column;margin-top:',';margin-left:',';',';'],(0,_rem2.default)('88px'),(0,_rem2.default)('130px'),_media2.default.large(_templateObject2));var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'styles__Separator',componentId:'sc-11f9ogz-5'})(['border:1px solid ',';margin-left:-20px;width:calc(100% + 36px);'],_colors.paleGrayTwo);var Item=exports.Item=_styledComponents2.default.div.withConfig({displayName:'styles__Item',componentId:'sc-11f9ogz-6'})(['display:flex;flex-direction:row;width:223px;cursor:pointer;align-items:center;box-shadow:0 12px 27px 0 rgba(221,231,243,0.66);']);var ItemDescription=exports.ItemDescription=_styledComponents2.default.div.withConfig({displayName:'styles__ItemDescription',componentId:'sc-11f9ogz-7'})(['flex-direction:column;flex:0.85;padding:22px 14px;']);var CardTitle=exports.CardTitle=_styledComponents2.default.div.withConfig({displayName:'styles__CardTitle',componentId:'sc-11f9ogz-8'})(['',';font-weight:500;color:#14110c;'],_types.title16Galano);var CardSubtitle=exports.CardSubtitle=_styledComponents2.default.div.withConfig({displayName:'styles__CardSubtitle',componentId:'sc-11f9ogz-9'})(['',';color:#656769;'],_types.txt12OpenSans);var SelectCreditCardWrapper=exports.SelectCreditCardWrapper=_styledComponents2.default.div.withConfig({displayName:'styles__SelectCreditCardWrapper',componentId:'sc-11f9ogz-10'})(['display:flex;justify-content:space-between;']);var CardFlagList=exports.CardFlagList=_styledComponents2.default.div.withConfig({displayName:'styles__CardFlagList',componentId:'sc-11f9ogz-11'})(['padding:8px 0 0 12px;']);var CardFlagItem=exports.CardFlagItem=_styledComponents2.default.span.withConfig({displayName:'styles__CardFlagItem',componentId:'sc-11f9ogz-12'})(['',';margin-right:8px;'],function(props){return props.hideCard?'display: none':'display: inline';});var FormField=exports.FormField=_styledComponents2.default.fieldset.withConfig({displayName:'styles__FormField',componentId:'sc-11f9ogz-13'})(['border:0;padding:0;margin:0;min-width:0;',';'],function(_ref){var disabled=_ref.disabled;return disabled&&'\n  opacity: 0.4;\n  cursor: not-allowed\n  ';});

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Notice=exports.SubTitle=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ','\n\n    '],['\n        ','\n\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-18z0y89-0'})(['',' color:',';margin:',' 0 ',' 0;',';'],_types.title32GalanoBold,_colors.linkNavyBlue,(0,_rem2.default)('40px'),(0,_rem2.default)('30px'),_media2.default.large(_templateObject,_types.title32GalanoBold));var SubTitle=exports.SubTitle=_styledComponents2.default.p.withConfig({displayName:'styles__SubTitle',componentId:'sc-18z0y89-1'})(['',';color:',';letter-spacing:',';margin:0 0 ',' 0;text-transform:uppercase;'],_types.txt12OpenSans,_colors.darkGrey,(0,_em2.default)('1px'),(0,_rem2.default)('18'));var Notice=exports.Notice=_styledComponents2.default.div.withConfig({displayName:'styles__Notice',componentId:'sc-18z0y89-2'})(['display:flex;',';color:',';line-height:1.29;svg{overflow:inherit;padding-top:2px;}span{margin-left:16px;}'],_types.txt14OpenSans,_colors.darkViolet);

/***/ }),
/* 2147 */
/***/ (function(module, exports) {

module.exports = {"titleModalSuccess":"Tudo certo!","bodyModalSuccess":"Sua data de vencimento foi alterada com sucesso!","titleModalError":"Ops! Algo deu errado","bodyModalError":"Não foi possível alterar sua data de vencimento. Verifique os dados fornecidos e tente novamente"}

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateEmpty=__webpack_require__(112);var _TemplateEmpty2=_interopRequireDefault(_TemplateEmpty);var _CancelPlan=__webpack_require__(2149);var _CancelPlan2=_interopRequireDefault(_CancelPlan);var _CancelPlanMotive=__webpack_require__(2155);var _CancelPlanMotive2=_interopRequireDefault(_CancelPlanMotive);var _CancelPlanConfirmation=__webpack_require__(2158);var _CancelPlanConfirmation2=_interopRequireDefault(_CancelPlanConfirmation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id/cancelar-plano',component:_TemplateEmpty2.default,routes:[{path:'/minha-veloe/:id/cancelar-plano',exact:true,component:_CancelPlan2.default},{path:'/minha-veloe/:id/cancelar-plano/motivo',exact:true,component:_CancelPlanMotive2.default},{path:'/minha-veloe/:id/cancelar-plano/confirmacao',exact:true,component:_CancelPlanConfirmation2.default}]};module.exports=exports['default'];

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/CancelPlan/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRouterDom=__webpack_require__(15);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(13);var _styles=__webpack_require__(2150);var _data=__webpack_require__(2151);var _data2=_interopRequireDefault(_data);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _IdentifierDetails=__webpack_require__(2152);var _IdentifierDetails2=_interopRequireDefault(_IdentifierDetails);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CancelPlan=function(_Component){_inherits(CancelPlan,_Component);function CancelPlan(){_classCallCheck(this,CancelPlan);return _possibleConstructorReturn(this,(CancelPlan.__proto__||Object.getPrototypeOf(CancelPlan)).apply(this,arguments));}_createClass(CancelPlan,[{key:'componentWillMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.getCurrentPlan(this.props.match.params.id);case 2:case'end':return _context.stop();}}},_callee,this);}));function componentWillMount(){return _ref.apply(this,arguments);}return componentWillMount;}()},{key:'render',value:function render(){var _props=this.props,history=_props.history,match=_props.match,accountPlans=_props.accountPlans;var currentPlan=accountPlans.plan;var identifiers=currentPlan?currentPlan.identifiers:[];return _react2.default.createElement('main',{__source:{fileName:_jsxFileName,lineNumber:30}},_react2.default.createElement(_reactHelmet2.default,{title:'Cancelar plano',__source:{fileName:_jsxFileName,lineNumber:31}}),_react2.default.createElement(_ImersiveHeader2.default,{text:'Dados do plano',url:'/minha-veloe/'+match.params.id+'/dados-do-plano',__source:{fileName:_jsxFileName,lineNumber:33}}),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:40}},_data2.default.label),_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:41}},_data2.default.title),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:42}},_data2.default.description.areYouSure),_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:43}},_data2.default.description.advice)),identifiers.map(function(identifier){return identifier.active&&_react2.default.createElement('div',{key:identifier.identifierId,__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_styles.Hr,{__source:{fileName:_jsxFileName,lineNumber:50}}),_react2.default.createElement(_IdentifierDetails2.default,_extends({},identifier,{__source:{fileName:_jsxFileName,lineNumber:51}})));})),_react2.default.createElement(_styles.Footer,{__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:58}},_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],align:'center',justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_styles.Disclaimer,{__source:{fileName:_jsxFileName,lineNumber:60}},_data2.default.disclaimer),_react2.default.createElement(_Button2.default,{onClick:function onClick(){return history.push('/minha-veloe/'+match.params.id+'/cancelar-plano/motivo');},text:_data2.default.button,__source:{fileName:_jsxFileName,lineNumber:61}})))));}}]);return CancelPlan;}(_react.Component);CancelPlan.defaultProps={accountPlans:{plan:{}}};var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{accountPlans:reducer.accountPlans,account:reducer.account};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{getCurrentPlan:function getCurrentPlan(planId){return dispatch((0,_actions.fetchAccountPlan)(planId));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)((0,_reactRouterDom.withRouter)(CancelPlan));

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Disclaimer=exports.Footer=exports.Hr=exports.Text=exports.Label=exports.Title=exports.Heading=undefined;var _templateObject=_taggedTemplateLiteral(['\n        padding: ',' 0 ',';\n    '],['\n        padding: ',' 0 ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        ','\n    '],['\n        ','\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        margin-bottom: 0;\n        max-width: ',';\n    '],['\n        margin-bottom: 0;\n        max-width: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Heading=exports.Heading=_styledComponents2.default.header.withConfig({displayName:'styles__Heading',componentId:'sc-1l3qwk3-0'})(['padding:',' 0 ',';',';'],(0,_rem2.default)('25px'),(0,_rem2.default)('15px'),_media2.default.large(_templateObject,(0,_rem2.default)('68px'),(0,_rem2.default)('32px')));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-1l3qwk3-1'})(['',' color:',';margin:0 0 ',';line-height:1;',';'],_types.title24GalanoBold,_colors.linkNavyBlue,(0,_rem2.default)('15px'),_media2.default.large(_templateObject2,_types.title40GalanoBold));var Label=exports.Label=_styledComponents2.default.p.withConfig({displayName:'styles__Label',componentId:'sc-1l3qwk3-2'})(['',' color:',';margin:0 0 ',';line-height:1;text-transform:uppercase;'],_types.txt12OpenSans,_colors.darkGrey,(0,_rem2.default)('16px'));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1l3qwk3-3'})(['',' color:',';margin:0;line-height:1.5;'],_types.txt14OpenSans,_colors.darkGrey);var Hr=exports.Hr=_styledComponents2.default.hr.withConfig({displayName:'styles__Hr',componentId:'sc-1l3qwk3-4'})(['height:',';border:0;background:',';width:100%;display:block;'],(0,_rem2.default)('1px'),_colors.paleGrayTwo);var Footer=exports.Footer=_styledComponents2.default.footer.withConfig({displayName:'styles__Footer',componentId:'sc-1l3qwk3-5'})(['background-color:',';padding:',' 0;'],_colors.ghostWhite,(0,_rem2.default)('40px'));var Disclaimer=exports.Disclaimer=_styledComponents2.default.strong.withConfig({displayName:'styles__Disclaimer',componentId:'sc-1l3qwk3-6'})(['',' color:',';margin-bottom:',';',';'],_types.txt16OpenSans,_colors.darkGrey,(0,_rem2.default)('26px'),_media2.default.large(_templateObject3,(0,_rem2.default)('380px')));

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

module.exports = {"label":"Cancelar plano","title":"Urbano pós pago","description":{"areYouSure":"Tem certeza que deseja cancelar seu plano?","advice":"A VeloeTag abaixo deixará de funcionar."},"disclaimer":"Fazendo o cancelamento, a VeloeTag acima vai parar de funcionar e você não vai mais ter acesso livre aos locais conveniados.","button":"Solicitar cancelamento"}

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/IdentifierDetails/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _styles=__webpack_require__(2153);var _car=__webpack_require__(2154);var _car2=_interopRequireDefault(_car);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IdentifierData=function IdentifierData(_ref){var label=_ref.label,value=_ref.value,highlighted=_ref.highlighted;return value?_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('24px'),0],width:[1/2,3/12],__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:13}},label),value&&_react2.default.createElement(_styles.Text,{highlighted:highlighted,__source:{fileName:_jsxFileName,lineNumber:14}},value)):null;};var IdentifierDetails=function IdentifierDetails(_ref2){var carBrand=_ref2.carBrand,carColor=_ref2.carColor,carModel=_ref2.carModel,carPlate=_ref2.carPlate,carYear=_ref2.carYear,driverName=_ref2.driverName,identifierId=_ref2.identifierId,category=_ref2.category,serialNumber=_ref2.serialNumber,Axes=_ref2.Axes,driverEmail=_ref2.driverEmail,driverDocument=_ref2.driverDocument,driverPhone=_ref2.driverPhone;return _react2.default.createElement(_gridStyled.Flex,{px:[0,(0,_rem2.default)('20px')],py:(0,_rem2.default)('32px'),__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_Hide2.default,{at:'small',width:2/12,__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement('img',{src:_car2.default,alt:'',__source:{fileName:_jsxFileName,lineNumber:35}})),_react2.default.createElement(_gridStyled.Box,{width:[1,10/12],__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,mb:[0,(0,_rem2.default)('27px')],__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(IdentifierData,{highlighted:true,label:'Placa',value:carPlate,__source:{fileName:_jsxFileName,lineNumber:40}}),_react2.default.createElement(IdentifierData,{highlighted:true,label:'VeloeTag',value:identifierId,__source:{fileName:_jsxFileName,lineNumber:41}})),_react2.default.createElement(_gridStyled.Flex,{wrap:true,mb:[0,(0,_rem2.default)('24px')],__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(IdentifierData,{label:'fabricante',value:carBrand,__source:{fileName:_jsxFileName,lineNumber:45}}),_react2.default.createElement(IdentifierData,{label:'Modelo',value:carModel,__source:{fileName:_jsxFileName,lineNumber:46}}),_react2.default.createElement(IdentifierData,{label:'Ano',value:carYear,__source:{fileName:_jsxFileName,lineNumber:47}}),_react2.default.createElement(IdentifierData,{label:'Cor',value:carColor,__source:{fileName:_jsxFileName,lineNumber:48}})),_react2.default.createElement(_gridStyled.Flex,{wrap:true,mb:[0,(0,_rem2.default)('24px')],__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(IdentifierData,{label:'Categoria',value:category,__source:{fileName:_jsxFileName,lineNumber:52}}),_react2.default.createElement(IdentifierData,{label:'N\xFAmero de s\xE9rie',value:serialNumber,__source:{fileName:_jsxFileName,lineNumber:53}}),_react2.default.createElement(IdentifierData,{label:'Eixos',value:Axes,__source:{fileName:_jsxFileName,lineNumber:54}})),_react2.default.createElement(_gridStyled.Flex,{wrap:true,__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(IdentifierData,{label:'Condutor',value:driverName,__source:{fileName:_jsxFileName,lineNumber:58}}),_react2.default.createElement(IdentifierData,{label:'Email',value:driverEmail,__source:{fileName:_jsxFileName,lineNumber:59}}),_react2.default.createElement(IdentifierData,{label:'CPF',value:driverDocument,__source:{fileName:_jsxFileName,lineNumber:60}}),_react2.default.createElement(IdentifierData,{label:'Telefone',value:driverPhone,__source:{fileName:_jsxFileName,lineNumber:61}}))));};exports.default=IdentifierDetails;module.exports=exports['default'];

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Text=exports.Label=undefined;var _templateObject=_taggedTemplateLiteral(['\n            ','\n        '],['\n            ','\n        ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Label=exports.Label=_styledComponents2.default.p.withConfig({displayName:'styles__Label',componentId:'sc-1ko6vyk-0'})(['',' color:',';margin:0 0 ',';text-transform:uppercase;'],_types.txt12OpenSans,_colors.darkGrey,(0,_rem2.default)('8px'));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1ko6vyk-1'})(['',' color:',';margin:0;',';'],_types.txt14OpenSans,_colors.darkGrey,function(_ref){var highlighted=_ref.highlighted;return highlighted&&(0,_styledComponents.css)(['',' color:',';text-transform:uppercase;',';'],_types.title18Galano,_colors.linkNavyBlue,_media2.default.large(_templateObject,_types.title24GalanoBold));});

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/car.e3daf367.svg";

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/CancelPlanMotive/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _reactRouterDom=__webpack_require__(15);var _actions=__webpack_require__(13);var _ModalTypes=__webpack_require__(20);var _actions2=__webpack_require__(18);var _mailTo=__webpack_require__(256);var _mailTo2=_interopRequireDefault(_mailTo);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _CancelAccountForm=__webpack_require__(603);var _CancelAccountForm2=_interopRequireDefault(_CancelAccountForm);var _styles=__webpack_require__(2156);var _data=__webpack_require__(2157);var _data2=_interopRequireDefault(_data);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CancelPlanMotive=function(_Component){_inherits(CancelPlanMotive,_Component);function CancelPlanMotive(){_classCallCheck(this,CancelPlanMotive);return _possibleConstructorReturn(this,(CancelPlanMotive.__proto__||Object.getPrototypeOf(CancelPlanMotive)).apply(this,arguments));}_createClass(CancelPlanMotive,[{key:'componentWillMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return this.props.getCurrentPlan(this.props.match.params.id);case 2:case'end':return _context.stop();}}},_callee,this);}));function componentWillMount(){return _ref.apply(this,arguments);}return componentWillMount;}()},{key:'render',value:function render(){var _props=this.props,match=_props.match,account=_props.account,accountPlans=_props.accountPlans,props=_objectWithoutProperties(_props,['match','account','accountPlans']);var currentPlan=accountPlans.plan;var planFullName='';if(currentPlan){planFullName=currentPlan.plan.category+' '+_data2.default.planType[currentPlan.plan.type];}return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Dados do plano',url:'/minha-veloe/'+match.params.id+'/dados-do-plano',__source:{fileName:_jsxFileName,lineNumber:41}}),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_gridStyled.Box,{width:[1,6/12],__source:{fileName:_jsxFileName,lineNumber:47}},_react2.default.createElement(_reactHelmet2.default,{title:_data2.default.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:48}}),_react2.default.createElement(_styles.Label,{__source:{fileName:_jsxFileName,lineNumber:49}},_data2.default.label),_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:50}},planFullName),_react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:52}},_data2.default.optionsSubtitle),_react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_CancelAccountForm2.default,{ctaText:'Cancelar plano',form:'cancelPlanMotive',onSubmit:function onSubmit(values){return props.fetchPostCancellationRequest(account.id,match.params.id,values);},__source:{fileName:_jsxFileName,lineNumber:54}}))))));}}]);return CancelPlanMotive;}(_react.Component);var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{accountPlans:reducer.accountPlans,account:reducer.account};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{getCurrentPlan:function getCurrentPlan(planId){return dispatch((0,_actions.fetchAccountPlan)(planId));},fetchPostCancellationRequest:function fetchPostCancellationRequest(accountId,planId,motive){var _this2=this;return dispatch((0,_actions.fetchPostCancellationRequest)(accountId,planId,motive)).then(function(){_this2.showTokenModal(accountId,planId);});},showTokenModal:function showTokenModal(accountId,planId,motive){var _this3=this;dispatch((0,_actions2.showModal)(_ModalTypes.INPUT_MODAL,_extends({},_data2.default.modal,{fetchSendProvider:function fetchSendProvider(token){return dispatch((0,_actions.fetchPutCancellationRequest)(accountId,planId,token));},fetchRefreshProvider:function fetchRefreshProvider(){return _this3.fetchPostCancellationRequest(accountId,planId,motive);},onConfirm:function onConfirm(){var params=ownProps.match.params;ownProps.history.push('/minha-veloe/'+params.id+'/cancelar-plano/confirmacao');},image:_mailTo2.default})));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)((0,_reactRouterDom.withRouter)(CancelPlanMotive));

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Content=exports.Wrapper=exports.Subtitle=exports.Heading=exports.Label=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ',';\n\n        margin: 0 0 ',';\n    '],['\n        ',';\n\n        margin: 0 0 ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        max-width: none;\n    '],['\n        max-width: none;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Label=exports.Label=_styledComponents2.default.p.withConfig({displayName:'styles__Label',componentId:'sc-suut2c-0'})(['',';letter-spacing:0.1em;color:',';line-height:1;margin:0 0 ',';text-transform:uppercase;'],_types.txt12OpenSans,_colors.darkGrey,(0,_rem2.default)('16px'));var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-suut2c-1'})(['',' color:',';line-height:1;margin:0 0 ',';',';'],_types.title24GalanoBold,_colors.darkBlue,(0,_rem2.default)('24px'),_media2.default.large(_templateObject,_types.title40GalanoBold,(0,_rem2.default)('42px')));var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-suut2c-2'})(['',';color:',';font-weight:bold;line-height:1.5;margin:0 0 ',';max-width:',';',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('24px'),(0,_rem2.default)('210px'),_media2.default.large(_templateObject2));var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-suut2c-3'})(['margin-bottom:',';'],(0,_rem2.default)('32px'));var Content=exports.Content=_styledComponents2.default.section.withConfig({displayName:'styles__Content',componentId:'sc-suut2c-4'})(['',';margin:',' auto;'],_content2.default,(0,_rem2.default)('42px'));

/***/ }),
/* 2157 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Veloe - Cancelar plano","label":"Cancelar plano","optionsSubtitle":"Por que você quer cancelar seu plano?","modal":{"title":"Enviamos um código para você.","description":"Para fazer o bloqueio, coloque aqui o código que a gente enviou para o celular final (00) xxxxx-xx00.","buttonText":"ok","label":"Código","placeholder":"Ex 0000000","fetchErrorMessage":"O código não é esse. Tente de novo.","refreshMessage":"Reenviamos um código para você."},"planType":{"pos":"pós","pre":"pré"}}

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapStateToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/CancelPlanConfirmation/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(15);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _aleloLogic=__webpack_require__(12);var _gridStyled=__webpack_require__(8);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _styles=__webpack_require__(2159);var _data=__webpack_require__(2160);var _car=__webpack_require__(623);var _car2=_interopRequireDefault(_car);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var CancelPlanConfirmation=function CancelPlanConfirmation(_ref){var accountPlans=_ref.accountPlans,match=_ref.match,history=_ref.history;var plan=accountPlans.plan||{};var cancelation=plan.cancelation||{};return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:24}}),_react2.default.createElement(_ImersiveHeader2.default,{isColored:true,text:'Meus planos',url:'/minha-veloe/'+match.params.id+'/resumo',__source:{fileName:_jsxFileName,lineNumber:25}}),_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement(_gridStyled.Flex,{direction:'row',__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_gridStyled.Box,{width:1,__source:{fileName:_jsxFileName,lineNumber:29}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:30}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:31}},_data.text),_react2.default.createElement(_styles.Separator,{__source:{fileName:_jsxFileName,lineNumber:32}}),_react2.default.createElement(_styles.Protocol,{__source:{fileName:_jsxFileName,lineNumber:33}},cancelation.protocol),cancelation.date&&_react2.default.createElement(_styles.Date,{__source:{fileName:_jsxFileName,lineNumber:36}},'Salvo em ',_aleloLogic.utils.ISODateFormat(cancelation.date)+' ','\xE0s ',_aleloLogic.utils.ISODateFormat(cancelation.date,'HH:mm')),_react2.default.createElement(_gridStyled.Box,{mt:32,mb:37,__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_Button2.default,{buttonType:'transparent',onClick:function onClick(){return history.push('/minha-veloe/'+match.params.id+'/resumo');},text:'Ok',width:140,__source:{fileName:_jsxFileName,lineNumber:43}}))),_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_styles.Illustration,{__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement('img',{src:_car2.default,alt:'sem\xE1foro',__source:{fileName:_jsxFileName,lineNumber:54}}))))))));};var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{accountPlans:reducer.accountPlans};};exports.default=(0,_reactRedux.connect)(mapStateToProps)((0,_reactRouterDom.withRouter)(CancelPlanConfirmation));

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Separator=exports.Illustration=exports.Date=exports.Protocol=exports.Paragraph=exports.Title=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n        ','\n\n        letter-spacing: ',';\n        margin: ',' 0 ',' 0;\n        max-width: ',';\n    '],['\n        ','\n\n        letter-spacing: ',';\n        margin: ',' 0 ',' 0;\n        max-width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        border: ',' solid ',';\n        display: block;\n        margin-right: ',';\n        margin: ',' 0 ',' 0;\n        width: 30%;\n    '],['\n        border: ',' solid ',';\n        display: block;\n        margin-right: ',';\n        margin: ',' 0 ',' 0;\n        width: 30%;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.main.withConfig({displayName:'styles__Container',componentId:'sc-qzlhqa-0'})(['background:',';height:100vh;margin:0;overflow:auto;'],_colors.skyBlue);var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-qzlhqa-1'})(['',' color:',';letter-spacing:',';font-weight:bold;margin:',' 0 ',' 0;max-width:',';',';'],_types.title24GalanoBold,_colors.white,(0,_rem2.default)('0.4px'),(0,_rem2.default)('46px'),(0,_rem2.default)('16px'),(0,_rem2.default)('231px'),_media2.default.large(_templateObject,_types.title40GalanoBold,(0,_rem2.default)('0.4px'),(0,_rem2.default)('78px'),(0,_rem2.default)('16px'),(0,_rem2.default)('364px')));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-qzlhqa-2'})(['',' color:',';margin:0;max-width:',';'],_types.txt14OpenSans,_colors.white,(0,_rem2.default)('431px'));var Protocol=exports.Protocol=_styledComponents2.default.p.withConfig({displayName:'styles__Protocol',componentId:'sc-qzlhqa-3'})(['',' color:',';letter-spacing:0.3px;line-height:1;margin:0;'],_types.title32GalanoBold,_colors.white);var Date=exports.Date=_styledComponents2.default.time.withConfig({displayName:'styles__Date',componentId:'sc-qzlhqa-4'})(['',' color:',';letter-spacing:1px;'],_types.txt12OpenSans,_colors.white);var Illustration=exports.Illustration=_styledComponents2.default.div.withConfig({displayName:'styles__Illustration',componentId:'sc-qzlhqa-5'})(['position:absolute;right:0;top:',';'],(0,_rem2.default)('220px'));var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'styles__Separator',componentId:'sc-qzlhqa-6'})(['border:',' solid ',';margin:',' 0 ',' 0;width:100%;',';'],(0,_rem2.default)('1px'),_colors.blizzardBlue,(0,_rem2.default)('29px'),(0,_rem2.default)('34px'),_media2.default.large(_templateObject2,(0,_rem2.default)('1px'),_colors.blizzardBlue,(0,_rem2.default)('600px'),(0,_rem2.default)('29px'),(0,_rem2.default)('32px')));

/***/ }),
/* 2160 */
/***/ (function(module, exports) {

module.exports = {"title":"Plano cancelado","text":"A solicitação de cancelamento foi enviada. Entraremos em contato com você nos próximos dias para confirmar o cancelamento. Até lá, você pode continuar utilizando o seu Veloe com acesso livre aos locais conveniados. Enquanto isso, guarde o número do protocolo: ","protocol":"18U3187388","helmetTitle":"plano cancelado","date":"Salvo em 10/10/2017 às 19:30"}

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateNoSubMenu=__webpack_require__(2162);var _TemplateNoSubMenu2=_interopRequireDefault(_TemplateNoSubMenu);var _FirstAccessFollowRequest=__webpack_require__(660);var _FirstAccessFollowRequest2=_interopRequireDefault(_FirstAccessFollowRequest);var _FirstAccessFollowRequestDetail=__webpack_require__(2180);var _FirstAccessFollowRequestDetail2=_interopRequireDefault(_FirstAccessFollowRequestDetail);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id/identificadores/acompanhar-pedido',component:_TemplateNoSubMenu2.default,routes:[{path:'/minha-veloe/:id/identificadores/acompanhar-pedido',exact:true,component:_FirstAccessFollowRequest2.default},{path:'/minha-veloe/:id/identificadores/acompanhar-pedido/:order',exact:true,component:_FirstAccessFollowRequestDetail2.default}]};module.exports=exports['default'];

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/templates/TemplateNoSubMenu/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactTransitionGroup=__webpack_require__(363);var _actions=__webpack_require__(13);var _Header=__webpack_require__(176);var _Header2=_interopRequireDefault(_Header);var _FooterSmall=__webpack_require__(249);var _FooterSmall2=_interopRequireDefault(_FooterSmall);var _routes=__webpack_require__(96);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TemplateLayout=function(_Component){_inherits(TemplateLayout,_Component);function TemplateLayout(props){_classCallCheck(this,TemplateLayout);var _this=_possibleConstructorReturn(this,(TemplateLayout.__proto__||Object.getPrototypeOf(TemplateLayout)).call(this,props));_this.state={user:null};return _this;}_createClass(TemplateLayout,[{key:'componentDidMount',value:function componentDidMount(){this.props.getAccountPlans();this.props.getUser(this.props.account.accountType);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var hasChange=nextProps.location.pathname!==this.props.location.pathname;return hasChange;}},{key:'render',value:function render(){var _this2=this;var _props=this.props,routes=_props.routes,location=_props.location,account=_props.account;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement('div',{className:'empty-template',__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_Header2.default,{userCancelled:!account.active,__source:{fileName:_jsxFileName,lineNumber:34}})),_react2.default.createElement(_reactTransitionGroup.TransitionGroup,{__source:{fileName:_jsxFileName,lineNumber:36}},_react2.default.createElement(_reactTransitionGroup.CSSTransition,{key:location.key,timeout:500,exit:false,classNames:'fade-in',__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:38}},routes.map(function(route){return _react2.default.createElement(_routes.RouteWithSubRoutes,_extends({user:_this2.state.user,key:route.path},route,{__source:{fileName:_jsxFileName,lineNumber:40}}));})))),_react2.default.createElement('div',{className:'empty-template',__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement(_FooterSmall2.default,{__source:{fileName:_jsxFileName,lineNumber:46}})));}}]);return TemplateLayout;}(_react.Component);var mapStateToProps=function mapStateToProps(state){return{account:state.reducer.account,user:state.reducer.user};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getAccountPlans:function getAccountPlans(){return dispatch((0,_actions.fetchAccountPlans)());},getUser:function getUser(userType){if(userType==='pf'){dispatch((0,_actions.fetchGetUser)());}else{dispatch((0,_actions.fetchGetBusinessUser)());}}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(TemplateLayout);module.exports=exports['default'];

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DateTicket=exports.Description=exports.Infos=exports.ItemContainer=exports.Item=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n    flex-direction: column;\n    margin-bottom: 0;\n  '],['\n    flex-direction: column;\n    margin-bottom: 0;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    display: flex;\n    height: 95px;\n    align-items: flex-start;\n  '],['\n    display: flex;\n    height: 95px;\n    align-items: flex-start;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    min-width: 235px;\n  '],['\n    min-width: 235px;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n      padding-top: 0;\n      max-width: 205px;\n    '],['\n      padding-top: 0;\n      max-width: 205px;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n      height: 31px;\n      left: 32px;\n      bottom: 0;\n      top: auto;\n      width: 2px;\n    '],['\n      height: 31px;\n      left: 32px;\n      bottom: 0;\n      top: auto;\n      width: 2px;\n    ']),_templateObject6=_taggedTemplateLiteral(['\n    margin-left: 16px;\n  '],['\n    margin-left: 16px;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _gridStyled=__webpack_require__(8);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=exports.Wrapper=(0,_styledComponents2.default)(_gridStyled.Flex).withConfig({displayName:'styles__Wrapper',componentId:'sc-agjkxw-0'})(['justify-content:space-between;margin-bottom:25px;',';'],_media2.default.small(_templateObject));var Item=exports.Item=_styledComponents2.default.div.withConfig({displayName:'styles__Item',componentId:'sc-agjkxw-1'})(['border:',' solid ',';border-radius:',';height:',';width:',';color:',';display:flex;align-items:center;justify-content:center;position:relative;'],(0,_rem2.default)('1px'),_colors.lightSilver,(0,_rem2.default)('40px'),(0,_rem2.default)('64px'),(0,_rem2.default)('64px'),_colors.lightSilver);var ItemContainer=exports.ItemContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ItemContainer',componentId:'sc-agjkxw-2'})(['background:',';align-items:center;position:relative;min-width:235px;',';',';',';:last-child{min-width:auto;padding-top:4px;',';}:not(:last-child):after{background:',';content:\'\';height:2px;position:absolute;width:100%;left:63px;top:calc(64px - 30%);',';}&:after{background:',';}svg{max-width:32px;max-height:28px;}'],_colors.white,_media2.default.small(_templateObject2),_media2.default.large(_templateObject3),function(props){return props.borderBlue&&' & {\n      div {\n        background: '+_colors.tealish+' !important;;\n        border: '+(0,_rem2.default)('1px')+' solid '+_colors.tealish+';\n        color: '+_colors.darkSlateBlue+' !important;\n      }\n\n      p {\n        color: '+_colors.darkSlateBlue+' !important;\n      }\n    }';},_media2.default.small(_templateObject4),_colors.lightSilver,_media2.default.small(_templateObject5),function(props){return props.borderBlue?_colors.tealish+' !important;':_colors.lightSilver+';';});var Infos=exports.Infos=_styledComponents2.default.span.withConfig({displayName:'styles__Infos',componentId:'sc-agjkxw-3'})(['display:flex;flex-direction:column;',';'],_media2.default.small(_templateObject6));var Description=exports.Description=_styledComponents2.default.p.withConfig({displayName:'styles__Description',componentId:'sc-agjkxw-4'})(['color:',';',';font-weight:600;line-height:1.57;margin:15px 0 0;text-transform:capitalize;'],_colors.blueGray,_types.txt14OpenSans);var DateTicket=exports.DateTicket=_styledComponents2.default.span.withConfig({displayName:'styles__DateTicket',componentId:'sc-agjkxw-5'})(['color:',';',';font-weight:600;line-height:1.57;margin:0;'],_colors.blueGray,_types.txt14OpenSans);

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/OrdersRequestList/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _reactClickOut=__webpack_require__(591);var _reactClickOut2=_interopRequireDefault(_reactClickOut);var _lodash=__webpack_require__(43);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _styles=__webpack_require__(2165);var _OrderRequestItem=__webpack_require__(2166);var _OrderRequestItem2=_interopRequireDefault(_OrderRequestItem);var _Dropdown=__webpack_require__(2169);var _Dropdown2=_interopRequireDefault(_Dropdown);var _DropdownList=__webpack_require__(2171);var _DropdownList2=_interopRequireDefault(_DropdownList);var _helpers=__webpack_require__(2173);var _data=__webpack_require__(2174);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrdersRequestList=function(_React$Component){_inherits(OrdersRequestList,_React$Component);function OrdersRequestList(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OrdersRequestList);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OrdersRequestList.__proto__||Object.getPrototypeOf(OrdersRequestList)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpenStatus:false,selectedStatus:'Todos',isOpenDate:false},_this.toggleDropdownStatus=function(){_this.setState({isOpenStatus:!_this.state.isOpenStatus});},_this.closeDropdownStatus=function(){_this.setState({isOpenStatus:false});},_this.toggleDropdownDate=function(){_this.setState({isOpenDate:!_this.state.isOpenDate});},_this.sortDate=function(orders,isOpenDate){var ordered=(0,_lodash.orderBy)(orders,function(o){return(0,_moment2.default)(o.date,'DD/MM/YYYY').format('YYYYMMDD');});return isOpenDate?ordered:ordered.reverse();},_this.selectStatus=function(status){_this.setState({selectedStatus:status});_this.closeDropdownStatus();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OrdersRequestList,[{key:'render',value:function render(){var _props=this.props,_props$orders=_props.orders,orders=_props$orders===undefined?[]:_props$orders,accountId=_props.accountId,type=_props.type,history=_props.history;var _state=this.state,isOpenStatus=_state.isOpenStatus,selectedStatus=_state.selectedStatus,isOpenDate=_state.isOpenDate;return _react2.default.createElement(_styles.ListContainer,{__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_styles.ListItem,{__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_gridStyled.Flex,{width:1,direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_gridStyled.Box,{width:[1/12],__source:{fileName:_jsxFileName,lineNumber:54}}),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:55}},'N\xBA do pedido'),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:56}},_react2.default.createElement(_Dropdown2.default,{isOpen:isOpenDate,categoryLabel:'DATA DO PEDIDO',dropdownLabel:isOpenDate?'Mais antigos':'Mais recentes',onClick:this.toggleDropdownDate,__source:{fileName:_jsxFileName,lineNumber:57}})),_react2.default.createElement(_styles.DropdownBox,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:64}},_react2.default.createElement(_Dropdown2.default,{isOpen:isOpenStatus,categoryLabel:'STATUS',dropdownLabel:selectedStatus,onClick:this.toggleDropdownStatus,__source:{fileName:_jsxFileName,lineNumber:65}}),this.state.isOpenStatus&&_react2.default.createElement(_reactClickOut2.default,{callback:this.closeDropdownStatus,__source:{fileName:_jsxFileName,lineNumber:72}},_react2.default.createElement(_DropdownList2.default,{options:_data.orderStatus,isOpen:isOpenStatus,onClose:this.toggleDropdown,onSelect:this.selectStatus,__source:{fileName:_jsxFileName,lineNumber:73}}))),_react2.default.createElement(_gridStyled.Box,{width:[5/12],__source:{fileName:_jsxFileName,lineNumber:82}}))),(0,_helpers.statusFilter)(selectedStatus,this.sortDate(orders,isOpenDate)).map(function(order,index){return _react2.default.createElement(_OrderRequestItem2.default,{order:order,key:index,accountId:accountId,type:type,history:history,__source:{fileName:_jsxFileName,lineNumber:86}});}));}}]);return OrdersRequestList;}(_react2.default.Component);exports.default=OrdersRequestList;module.exports=exports['default'];

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DropdownBox=exports.ListItem=exports.ListContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n        li:last-of-type {\n            border-bottom: 0 !important;\n        }\n    '],['\n        li:last-of-type {\n            border-bottom: 0 !important;\n        }\n    ']),_templateObject2=_taggedTemplateLiteral(['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  '],['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _gridStyled=__webpack_require__(8);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ListContainer=exports.ListContainer=_styledComponents2.default.ul.withConfig({displayName:'styles__ListContainer',componentId:'sc-bruioj-0'})(['list-style:none;margin:15px 0 0;padding:0;',';'],_media2.default.small(_templateObject));var ListItem=exports.ListItem=_styledComponents2.default.div.withConfig({displayName:'styles__ListItem',componentId:'sc-bruioj-1'})(['display:block;padding:',' 0 ',';border-bottom:',' solid ',';div{',';line-height:1.67;letter-spacing:1.6px;text-align:left;color:',';text-transform:uppercase;}',';'],(0,_rem2.default)('18px'),(0,_rem2.default)('18px'),(0,_rem2.default)('1px'),_colors.paleGrayTwo,_types.txt12OpenSansBold,_colors.blueGray,_media2.default.small(_templateObject2,(0,_rem2.default)('13px')));var DropdownBox=exports.DropdownBox=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'styles__DropdownBox',componentId:'sc-bruioj-2'})(['position:relative;']);

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/OrdersRequestList/OrderRequestItem/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _reactRouter=__webpack_require__(54);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _logoPipe=__webpack_require__(2167);var _logoPipe2=_interopRequireDefault(_logoPipe);var _colors=__webpack_require__(2);var _colors2=_interopRequireDefault(_colors);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(2168);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OrderRequestItem=function(_Component){_inherits(OrderRequestItem,_Component);function OrderRequestItem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OrderRequestItem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OrderRequestItem.__proto__||Object.getPrototypeOf(OrderRequestItem)).call.apply(_ref,[this].concat(args))),_this),_this.getStatusColor=function(status){switch(status){case'ENTREGUE':return{green:true};case'DEVOLVIDO':return{red:true};case'CANCELADO':return{red:true};case'':// Erro no pedido
return{red:true};default:return null;}},_this.buttonCredit=function(){var _this$props=_this.props,accountId=_this$props.accountId,history=_this$props.history;return _react2.default.createElement(_Button2.default,{text:'Efetuar Recarga',onClick:function onClick(){return history.push('/minha-veloe/'+accountId+'/editar-dados/cartao?path=track');},loading:false,__source:{fileName:_jsxFileName,lineNumber:33}});},_this.buttonActivate=function(){var history=_this.props.history;return _react2.default.createElement(_Button2.default,{onClick:function onClick(){return history.push('/identificadores/ativacao');},text:'Ativar Veloetag',loading:false,__source:{fileName:_jsxFileName,lineNumber:44}});},_this.renderButtonByStatus=function(order,history){var type=_this.props.type;switch(order.status){case'ENTREGUE':if(type==='pre'){if(order.paymentStatus==='Pagamento Aprovado'){return _this.buttonActivate();}return _this.buttonCredit();}else{return _this.buttonActivate();}case'DEVOLVIDO':return _react2.default.createElement(_Button2.default,{buttonType:'whiteNavyBlue',onClick:function onClick(){return history.push('acompanhar-pedido/'+order.number);},loading:false,text:'Rastrear pedido',__source:{fileName:_jsxFileName,lineNumber:66}});case'CANCELADO':return _react2.default.createElement(_Button2.default,{disabled:true,loading:false,text:'Rastrear pedido',__source:{fileName:_jsxFileName,lineNumber:74}});case'EXTRAVIADO':return _react2.default.createElement(_Button2.default,{buttonType:'whiteNavyBlue',onClick:function onClick(){return history.push('acompanhar-pedido/'+order.number);},loading:false,text:'Rastrear pedido',__source:{fileName:_jsxFileName,lineNumber:78}});case'ENVIADO':return _react2.default.createElement(_Button2.default,{buttonType:'whiteNavyBlue',onClick:function onClick(){return history.push('acompanhar-pedido/'+order.number);},loading:false,text:'Rastrear pedido',__source:{fileName:_jsxFileName,lineNumber:88}});case'SEPARACAO':return _react2.default.createElement(_Button2.default,{buttonType:'whiteNavyBlue',onClick:function onClick(){return history.push('acompanhar-pedido/'+order.number);},loading:false,text:'Rastrear pedido',__source:{fileName:_jsxFileName,lineNumber:98}});case'TRANSPORTE':return _react2.default.createElement(_Button2.default,{buttonType:'whiteNavyBlue',onClick:function onClick(){return history.push('acompanhar-pedido/'+order.number);},loading:false,text:'Rastrear pedido',__source:{fileName:_jsxFileName,lineNumber:108}});default:return _react2.default.createElement(_Button2.default,{disabled:true,loading:false,text:'Rastrear pedido',__source:{fileName:_jsxFileName,lineNumber:117}});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OrderRequestItem,[{key:'render',value:function render(){var _props=this.props,order=_props.order,history=_props.history,match=_props.match;return _react2.default.createElement(_styles.ListItem,{__source:{fileName:_jsxFileName,lineNumber:124}},_react2.default.createElement(_gridStyled.Flex,{width:1,direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:125}},_react2.default.createElement(_gridStyled.Box,{width:[1/12],__source:{fileName:_jsxFileName,lineNumber:126}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:127}},_react2.default.createElement(_logoPipe2.default,{fill:_colors2.default.lightBlue,__source:{fileName:_jsxFileName,lineNumber:128}}))),_react2.default.createElement(_gridStyled.Box,{width:[2/12],__source:{fileName:_jsxFileName,lineNumber:132}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:133}},_react2.default.createElement(_styles.LineText,{bold:true,__source:{fileName:_jsxFileName,lineNumber:134}},order.number))),_react2.default.createElement(_Hide2.default,{at:'small',width:[2/12],__source:{fileName:_jsxFileName,lineNumber:138}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:139}},_react2.default.createElement(_styles.LineText,{__source:{fileName:_jsxFileName,lineNumber:140}},order.date))),_react2.default.createElement(_gridStyled.Box,{width:[2/12],mr:[10,20],__source:{fileName:_jsxFileName,lineNumber:144}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:145}},_react2.default.createElement(_styles.LineText,_extends({capitalize:true},this.getStatusColor(order.status),{__source:{fileName:_jsxFileName,lineNumber:146}}),order.status?order.status==='ENVIADO'?'Separacao':order.status.toLowerCase():'Erro'))),_react2.default.createElement(_gridStyled.Box,{width:[5/12],mr:[10,20],__source:{fileName:_jsxFileName,lineNumber:153}},_react2.default.createElement(_styles.LineTextContainer,{justifyContent:'flex-end',__source:{fileName:_jsxFileName,lineNumber:154}},this.renderButtonByStatus(order,history,match)))));}}]);return OrderRequestItem;}(_react.Component);exports.default=(0,_reactRouter.withRouter)(OrderRequestItem);module.exports=exports['default'];

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/logoPipe.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var LogoPipe=function LogoPipe(props){return _react2.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",xmlnsXlink:"http://www.w3.org/1999/xlink",width:"38",height:"14",viewBox:'0 0 38 14',__source:{fileName:_jsxFileName,lineNumber:4}},_react2.default.createElement("defs",{__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement("path",{id:"a",d:"M19 14C11.845 14 5.374 11.485.778 6.919.205 6.374-.056 5.797.01 5.215c.088-.783.737-1.247.874-1.337L5.504.586A2.843 2.843 0 0 1 7.194 0c.68 0 1.31.265 1.869.789C11.596 3.034 15.129 4.276 19 4.276c3.871 0 7.405-1.242 9.948-3.497C29.497.265 30.125 0 30.805 0c.905 0 1.555.477 1.691.586l4.62 3.292c.137.09.786.554.874 1.337.065.582-.195 1.159-.776 1.712C32.625 11.485 26.154 14 19 14",__source:{fileName:_jsxFileName,lineNumber:12}})),_react2.default.createElement("g",{fill:"none",fillRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement("mask",{id:"b",fill:"#fff",__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement("use",{xlinkHref:"#a",__source:{fileName:_jsxFileName,lineNumber:19}})),_react2.default.createElement("use",{fill:props.fill,xlinkHref:"#a",__source:{fileName:_jsxFileName,lineNumber:21}}),_react2.default.createElement("g",{fill:props.fill,mask:"url(#b)",__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement("path",{d:"M-5-17h48v48H-5z",__source:{fileName:_jsxFileName,lineNumber:23}}))));};exports.default=LogoPipe;module.exports=exports["default"];

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ListItem=exports.LineText=exports.LineTextContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  '],['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LineTextContainer=exports.LineTextContainer=_styledComponents2.default.div.withConfig({displayName:'styles__LineTextContainer',componentId:'sc-1fj2s05-0'})(['display:flex;align-items:center;min-height:100%;justify-content:',';'],function(_ref){var justifyContent=_ref.justifyContent;return justifyContent||'flex-start';});var LineText=exports.LineText=_styledComponents2.default.div.withConfig({displayName:'styles__LineText',componentId:'sc-1fj2s05-1'})(['',';font-weight:normal;line-height:1.5;letter-spacing:normal;text-align:left;color:',';display:block;',';',';',';',';'],_types.txt16OpenSans,_colors.darkSlateBlue,function(_ref2){var capitalize=_ref2.capitalize;return capitalize&&'\n    text-transform: capitalize;\n  ';},function(_ref3){var bold=_ref3.bold;return bold&&'\n    font-weight: bold;\n  ';},function(_ref4){var green=_ref4.green;return green&&'\n    color: '+_colors.deliveredGreen+'\n  ';},function(_ref5){var red=_ref5.red;return red&&'\n    color: '+_colors.carnation+'\n  ';});var ListItem=exports.ListItem=_styledComponents2.default.div.withConfig({displayName:'styles__ListItem',componentId:'sc-1fj2s05-2'})(['display:block;padding:',' 0 ',';border-bottom:',' solid ',';',';'],(0,_rem2.default)('18px'),(0,_rem2.default)('18px'),(0,_rem2.default)('1px'),_colors.paleGrayTwo,_media2.default.small(_templateObject,(0,_rem2.default)('13px')));

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/OrdersRequestList/Dropdown/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _propTypes2=_interopRequireDefault(_propTypes);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _styles=__webpack_require__(2170);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function Dropdown(_ref){var categoryLabel=_ref.categoryLabel,dropdownLabel=_ref.dropdownLabel,onClick=_ref.onClick,isOpen=_ref.isOpen;return _react2.default.createElement(_styles.DropdownContainer,{isOpen:isOpen,onClick:onClick,__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement(_styles.DropdownLabelContainer,{__source:{fileName:_jsxFileName,lineNumber:16}},_react2.default.createElement(_styles.HeaderLabel,{isOpen:isOpen,__source:{fileName:_jsxFileName,lineNumber:17}},categoryLabel),_react2.default.createElement(_Icon2.default,{icon:'dropdown-arrow',svgStyle:_styles.DropdownArrow,width:'12',height:'7',viewBox:'0 0 12 7',__source:{fileName:_jsxFileName,lineNumber:18}})),_react2.default.createElement(_styles.DropdownLabel,{__source:{fileName:_jsxFileName,lineNumber:27}},dropdownLabel));}Dropdown.defaultProps={categoryLabel:'',dropdownLabel:'',headerLabelCategory:'',onClick:null};Dropdown.propTypes={categoryLabel:_propTypes2.default.string,dropdownLabel:_propTypes2.default.string,headerLabelCategory:_propTypes2.default.string,onClick:_propTypes2.default.func};exports.default=Dropdown;module.exports=exports['default'];

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DropdownContainer=exports.HeaderLabel=exports.DropdownArrow=exports.DropdownLabelContainer=exports.DropdownLabel=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var DropdownLabel=exports.DropdownLabel=_styledComponents2.default.p.withConfig({displayName:'styles__DropdownLabel',componentId:'sc-1sbhmod-0'})(['color:',';font-family:\'OpenSans\';font-size:',';font-weight:lighter;margin:0;min-width:',';user-select:none;text-transform:capitalize;'],_colors.darkBlue,(0,_rem2.default)('12px'),(0,_rem2.default)('60px'));var DropdownLabelContainer=exports.DropdownLabelContainer=_styledComponents2.default.div.withConfig({displayName:'styles__DropdownLabelContainer',componentId:'sc-1sbhmod-1'})(['align-items:center;display:flex;position:relative;']);var DropdownArrow=exports.DropdownArrow='height: 5px; width: 10px; stroke: '+_colors.linkNavyBlue;var HeaderLabel=exports.HeaderLabel=_styledComponents2.default.p.withConfig({displayName:'styles__HeaderLabel',componentId:'sc-1sbhmod-2'})(['',';margin:0;line-height:1.67;letter-spacing:1.6px;text-align:left;color:',';text-transform:uppercase;'],_types.txt12OpenSansBold,function(_ref){var isOpen=_ref.isOpen;return isOpen?_colors.linkNavyBlue:_colors.blueGray;});var DropdownContainer=exports.DropdownContainer=_styledComponents2.default.div.withConfig({displayName:'styles__DropdownContainer',componentId:'sc-1sbhmod-3'})(['cursor:pointer;margin:0;',';'],function(_ref2){var isOpen=_ref2.isOpen;return isOpen&&(0,_styledComponents.css)(['svg{color:',';transform:rotate(180deg);}'],_colors.darkGrey);});

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/OrdersRequestList/DropdownList/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(2172);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function DropdownList(_ref){var options=_ref.options,isOpen=_ref.isOpen,onClose=_ref.onClose,onSelect=_ref.onSelect;var closeDropdown=function closeDropdown(onClick){if(onClose){onClose();}if(onClick){onClick();}};return _react2.default.createElement(_styles.DropdownListContainer,{isOpen:isOpen,__source:{fileName:_jsxFileName,lineNumber:17}},options.map(function(option,index){return _react2.default.createElement(_styles.DropdownListItem,{key:index,onClick:function onClick(){closeDropdown(option.onClick);onSelect(option);},__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:26}},option));}));}exports.default=DropdownList;module.exports=exports['default'];

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DropdownListItem=exports.DropdownListContainer=exports.Title=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Title=exports.Title=_styledComponents2.default.span.withConfig({displayName:'styles__Title',componentId:'sc-14p4quu-0'})(['',';color:',';display:block;line-height:1;text-transform:capitalize;:hover{color:',';}'],_types.txt12OpenSans,_colors.darkGrey,_colors.linkNavyBlue);var DropdownListContainer=exports.DropdownListContainer=_styledComponents2.default.ul.withConfig({displayName:'styles__DropdownListContainer',componentId:'sc-14p4quu-1'})(['background-color:white;border-radius:',';box-shadow:0 ',' ',' 0 rgba(0,0,0,0.2);display:flex;flex-direction:column;left:0;pointer-events:none;position:absolute;top:',';width:100%;z-index:20;margin:0;padding:',' 0;',';'],(0,_rem2.default)('2px'),(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),(0,_rem2.default)('50px'),(0,_rem2.default)('15px'),function(props){return props.isOpen&&'\n        pointer-events: all;\n    ';});var DropdownListItem=exports.DropdownListItem=_styledComponents2.default.li.withConfig({displayName:'styles__DropdownListItem',componentId:'sc-14p4quu-2'})(['text-decoration:none;list-style:none;padding:',' ',';'],(0,_rem2.default)('15px'),(0,_rem2.default)('20px'));

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var statusFilter=exports.statusFilter=function statusFilter(status,list){return status==='Todos'?list:list.filter(function(item){return item.status&&item.status.toUpperCase()===status.toUpperCase();});};

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var orderStatus=exports.orderStatus=['Todos','Enviado','Entregue','Devolvido','Cancelado','Extraviado','Processado'];

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _accountService=__webpack_require__(64);function fetchOrders(accountNumber,type){return(0,_accountService.getOrders)(accountNumber,type);}exports.default=fetchOrders;module.exports=exports['default'];

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SearchForm=exports.searchFilter=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/FirstAccessFollowRequest/RoundedSearchForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(11);var _renderInputs=__webpack_require__(44);var _icSearch=__webpack_require__(600);var _icSearch2=_interopRequireDefault(_icSearch);var _styles=__webpack_require__(2177);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var searchFilter=exports.searchFilter=function searchFilter(searchValue,list){if(searchValue&&searchValue.length>2){var result=void 0;result=list.filter(function(listItem){if(listItem.date.includes(searchValue.toUpperCase())||listItem.number.includes(searchValue.toUpperCase())||listItem.status.toUpperCase().includes(searchValue.toUpperCase())){return listItem;}});return result;}return list;};var SearchForm=exports.SearchForm=function SearchForm(props){return _react2.default.createElement(_styles.Form,{__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_reduxForm.Field,{name:'search',id:'search',component:_renderInputs.renderRoundedInput,type:'text',placeholder:props.placeholder,label:props.label,icon:_icSearch2.default,__source:{fileName:_jsxFileName,lineNumber:27}}));};exports.default=(0,_reduxForm.reduxForm)({form:'searchOrders'})(SearchForm);

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Form=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Form=exports.Form=_styledComponents2.default.form.withConfig({displayName:'styles__Form',componentId:'sc-ttig7d-0'})(['width:335px;position:relative;img{position:absolute;right:13px;top:35px;width:25px;height:25px;}input{padding-left:45px;box-sizing:border-box;}']);

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TitleBox=exports.TitleContainer=exports.Wrapper=exports.Paragraph=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n    ','\n    letter-spacing: normal;\n    line-height: 1;\n  '],['\n    ','\n    letter-spacing: normal;\n    line-height: 1;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _gridStyled=__webpack_require__(8);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-8nbw3t-0'})(['',' letter-spacing:',';color:',';margin-top:',';',';'],_types.title40GalanoBold,(0,_em2.default)('0.4px'),_colors.darkSlateBlue,(0,_rem2.default)('40px'),_media2.default.small(_templateObject,_types.title28GalanoBold));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-8nbw3t-1'})(['',' color:',';max-width:',';'],_types.txt14OpenSans,_colors.darkSlateBlue,(0,_rem2.default)('400px'));var Wrapper=exports.Wrapper=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'styles__Wrapper',componentId:'sc-8nbw3t-2'})(['border-top:',' solid ',';'],(0,_rem2.default)('1px'),_colors.lightGray);var TitleContainer=exports.TitleContainer=_styledComponents2.default.div.withConfig({displayName:'styles__TitleContainer',componentId:'sc-8nbw3t-3'})(['display:flex;justify-content:space-between;']);var TitleBox=exports.TitleBox=_styledComponents2.default.div.withConfig({displayName:'styles__TitleBox',componentId:'sc-8nbw3t-4'})(['',';',';'],function(_ref){var alignSelf=_ref.alignSelf;return'align-self: '+alignSelf;},function(_ref2){var margin=_ref2.margin;return'margin: '+margin;});

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

module.exports = {"title":"Meus pedidos","paragraph":"Veja abaixo a lista do pedidos realizados","searchPlaceholder":"Filtrar pedidos"}

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/FirstAccessFollowRequestDetail/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _IdentifiersRequestStatus=__webpack_require__(661);var _IdentifiersRequestStatus2=_interopRequireDefault(_IdentifiersRequestStatus);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _actions=__webpack_require__(36);var _actions2=__webpack_require__(13);var _PageLoader=__webpack_require__(88);var _PageLoader2=_interopRequireDefault(_PageLoader);var _helpers=__webpack_require__(2181);var _styles=__webpack_require__(663);var _data=__webpack_require__(664);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var FirstAccessFollowRequest=function(_React$Component){_inherits(FirstAccessFollowRequest,_React$Component);function FirstAccessFollowRequest(props){_classCallCheck(this,FirstAccessFollowRequest);var _this=_possibleConstructorReturn(this,(FirstAccessFollowRequest.__proto__||Object.getPrototypeOf(FirstAccessFollowRequest)).call(this,props));_this.state={orders:null,type:'pre'};return _this;}_createClass(FirstAccessFollowRequest,[{key:'componentWillMount',value:function componentWillMount(){var accPlans=this.props.accountPlans;var acc=accPlans&&accPlans.plans&&accPlans.plans.length>0?accPlans.plans.find(function(plan){return plan.accountId==accPlans.activePlanId;}):null;var type=acc&&acc.plan&&acc.plan.type?acc.plan.type:null;this.setState({type:type});}},{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var accountNumber,response;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.props.setLoading(true);accountNumber=this.props.match.params.id;_context.prev=2;_context.next=5;return(0,_actions2.fetchFollowRequestDetails)(accountNumber,this.props.match.params.order);case 5:response=_context.sent;this.setState({orders:response});this.props.setLoading(false);_context.next=13;break;case 10:_context.prev=10;_context.t0=_context['catch'](2);console.log(_context.t0);case 13:case'end':return _context.stop();}}},_callee,this,[[2,10]]);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var orders=this.state.orders;var _props=this.props,activePlanId=_props.accountPlans.activePlanId,url=_props.match.url,history=_props.history,loading=_props.loading;var urlBack='/minha-veloe/'+activePlanId+'/identificadores/acompanhar-pedido';return _react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:68}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:69}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Voltar',url:urlBack,__source:{fileName:_jsxFileName,lineNumber:70}})),_react2.default.createElement(_PageLoader2.default,{__source:{fileName:_jsxFileName,lineNumber:72}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:74}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:75}},_data.paragraph),orders&&_react2.default.createElement(_styles.WrapperOrder,{__source:{fileName:_jsxFileName,lineNumber:77}},_react2.default.createElement(_styles.Ticket,{__source:{fileName:_jsxFileName,lineNumber:78}},_data.ticket,' ',orders.ticket),_react2.default.createElement(_IdentifiersRequestStatus2.default,{payment:orders.payment,tracker:orders.tracker,history:history,accountId:this.props.match.params.id,type:this.state.type,__source:{fileName:_jsxFileName,lineNumber:81}}),_react2.default.createElement(_styles.WrapperHelpers,{__source:{fileName:_jsxFileName,lineNumber:88}},(0,_helpers.renderActivateTagHelper)(orders,this.state.type,history),(0,_helpers.renderNotArrivedHelper)(orders,this.state.type,history))))));}}]);return FirstAccessFollowRequest;}(_react2.default.Component);var mapStateToProps=function mapStateToProps(state){return{accountPlans:state.reducer.accountPlans,loading:state.pageLoader.isLoading};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setLoading:function setLoading(isLoading){dispatch((0,_actions.setLoading)(isLoading));}};};var routeredFirstAccessFollowRequest=(0,_reactRouterDom.withRouter)(FirstAccessFollowRequest);exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(routeredFirstAccessFollowRequest);module.exports=exports['default'];

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.renderActivateTagHelper=exports.renderNotArrivedHelper=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/FirstAccessFollowRequestDetail/helpers.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _lodash=__webpack_require__(43);var _styles=__webpack_require__(663);var _data=__webpack_require__(664);var _arrowRight=__webpack_require__(662);var _arrowRight2=_interopRequireDefault(_arrowRight);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ActivateTagHelper=function ActivateTagHelper(props){return _react2.default.createElement(_styles.WrapperInfoLink,{__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement(_styles.TextInfoLink,{__source:{fileName:_jsxFileName,lineNumber:16}},_data.textActivateTagHelper),_react2.default.createElement(_styles.ButtonAddress,{onClick:function onClick(){return props.history.push('/identificadores/ativacao');},__source:{fileName:_jsxFileName,lineNumber:18}},_data.buttonActivateTagHelper,_react2.default.createElement(_arrowRight2.default,{width:'16',height:'16',__source:{fileName:_jsxFileName,lineNumber:20}})));};var NotArrivedHelper=function NotArrivedHelper(props){return _react2.default.createElement(_styles.WrapperInfoLink,{__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_styles.TextInfoLink,{__source:{fileName:_jsxFileName,lineNumber:27}},_data.textNotArrived),_react2.default.createElement(_styles.ButtonAddress,{onClick:function onClick(){return props.history.push('/primeiro-acesso/extravio');},__source:{fileName:_jsxFileName,lineNumber:29}},_data.buttonNotArrived,_react2.default.createElement(_arrowRight2.default,{width:'16',height:'16',__source:{fileName:_jsxFileName,lineNumber:31}})));};var renderNotArrivedHelper=exports.renderNotArrivedHelper=function renderNotArrivedHelper(order,type,history){var trackerStatus=order.tracker[0].status.toUpperCase();var paymentStatus=order.payment.status.toUpperCase();if(trackerStatus==='DEVOLVIDO'&&paymentStatus==='PAGAMENTO APROVADO'||trackerStatus==='DEVOLVIDO'&&type==='pos'||trackerStatus==='CANCELADO'&&type==='pos'||trackerStatus==='ENTREGUE'&&(0,_lodash.isEmpty)(paymentStatus)||trackerStatus==='DEVOLVIDO'&&(0,_lodash.isEmpty)(paymentStatus)||trackerStatus==='CANCELADO'&&(0,_lodash.isEmpty)(paymentStatus)){return _react2.default.createElement(NotArrivedHelper,{history:history,__source:{fileName:_jsxFileName,lineNumber:47}});}return null;};var renderActivateTagHelper=exports.renderActivateTagHelper=function renderActivateTagHelper(order,type,history){var trackerStatus=order.tracker[0].status.toUpperCase();var paymentStatus=order.payment.status.toUpperCase();if((0,_lodash.isEmpty)(order.tracker.status)&&paymentStatus==='PAGAMENTO APROVADO'||trackerStatus==='EM TRANSPORTE'&&paymentStatus==='PAGAMENTO APROVADO'||trackerStatus==='CANCELADO'&&paymentStatus==='PAGAMENTO APROVADO'||trackerStatus==='ENVIADO'&&paymentStatus==='PAGAMENTO APROVADO'||trackerStatus==='EXTRAVIADO'&&paymentStatus==='PAGAMENTO APROVADO'||trackerStatus==='DEVOLVIDO'&&paymentStatus==='PAGAMENTO APROVADO'||trackerStatus==='EM TRANSPORTE'&&type==='pos'||trackerStatus==='CANCELADO'&&type==='pos'||trackerStatus==='ENVIADO'&&type==='pos'||trackerStatus==='EXTRAVIADO'&&type==='pos'||trackerStatus==='DEVOLVIDO'&&type==='pos'){return _react2.default.createElement(ActivateTagHelper,{history:history,__source:{fileName:_jsxFileName,lineNumber:68}});}return null;};

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateEmpty=__webpack_require__(112);var _TemplateEmpty2=_interopRequireDefault(_TemplateEmpty);var _Activation=__webpack_require__(2183);var _Activation2=_interopRequireDefault(_Activation);var _ActivationSuccess=__webpack_require__(2187);var _ActivationSuccess2=_interopRequireDefault(_ActivationSuccess);var _FirstAccessFollowRequest=__webpack_require__(660);var _FirstAccessFollowRequest2=_interopRequireDefault(_FirstAccessFollowRequest);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/identificadores',component:_TemplateEmpty2.default,routes:[{path:'/identificadores/ativacao',exact:true,component:_Activation2.default},{path:'/identificadores/ativacao/sucesso',exact:true,component:_ActivationSuccess2.default},{path:'/identificadores/acompanhar-pedido',exact:true,component:_FirstAccessFollowRequest2.default}]};module.exports=exports['default'];

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/Activation/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _lodash=__webpack_require__(43);var _lodash2=_interopRequireDefault(_lodash);var _actions=__webpack_require__(13);var _activationService=__webpack_require__(359);var _actions2=__webpack_require__(18);var _formStateActions=__webpack_require__(102);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);var _ModalTypes=__webpack_require__(20);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _Option=__webpack_require__(403);var _Option2=_interopRequireDefault(_Option);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _icInfo=__webpack_require__(2184);var _icInfo2=_interopRequireDefault(_icInfo);var _icClose=__webpack_require__(157);var _icClose2=_interopRequireDefault(_icClose);var _ManageInfoModal=__webpack_require__(189);var _ManageInfoModal2=_interopRequireDefault(_ManageInfoModal);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);var _formFields=__webpack_require__(2185);var _styles=__webpack_require__(2186);var _data=__webpack_require__(665);var _icCar=__webpack_require__(666);var _icCar2=_interopRequireDefault(_icCar);var _icUtility=__webpack_require__(667);var _icUtility2=_interopRequireDefault(_icUtility);var _icTruck=__webpack_require__(668);var _icTruck2=_interopRequireDefault(_icTruck);var _icBus=__webpack_require__(669);var _icBus2=_interopRequireDefault(_icBus);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var Activation=function(_React$Component){_inherits(Activation,_React$Component);function Activation(props){_classCallCheck(this,Activation);var _this=_possibleConstructorReturn(this,(Activation.__proto__||Object.getPrototypeOf(Activation)).call(this,props));_this.setOption=function(selected){_this.setState({selected:selected},function(){var selected=_this.state.selected;if(selected==='caminhao'||selected==='onibus')_this.getCategory(selected);});};_this.getCategory=function(selected){(0,_activationService.getVehiclesCategory)(selected).then(function(response){var optionCategory=response.map(function(item){return Object.assign({},{value:item.id,label:item.descricao});});_this.setState({axis:optionCategory});});};_this.handleSubmit=function(values){var _this$state=_this.state,selected=_this$state.selected,manageInfo=_this$state.manageInfo;var accountPlans=_this.props.accountPlans;var plans=accountPlans.plans,activePlanId=accountPlans.activePlanId;var currentPlan=plans.find(function(plan){return String(plan.id)===String(activePlanId);});var formatValues=Object.assign({typeCar:selected},values,{accountId:currentPlan.accountId,type:currentPlan.plan.type});var data=Object.values(manageInfo).map(function(item){if(item!=null){item.codIdentificador=formatValues.identifier;item.conta=formatValues.accountId;item.placa=formatValues.plate;return item;}});_this.props.fetchActivation(formatValues,_lodash2.default.compact(data));};_this.toggleModal=function(){_this.setState({modalIsOpen:!_this.state.modalIsOpen});};_this.addManageInf=function(values){var manageInfo=_this.state.manageInfo;switch(values.tipoInfo){case'INFORMACAO_1':manageInfo.informacao1=values;break;case'INFORMACAO_2':manageInfo.informacao2=values;break;case'INFORMACAO_3':manageInfo.informacao3=values;break;}_this.setState({manageInfo:manageInfo});_this.toggleModal();};_this.handleDeletePil=function(typeInfo){var manageInfo=_this.state.manageInfo;switch(typeInfo){case'INFORMACAO_1':manageInfo.informacao1='';break;case'INFORMACAO_2':manageInfo.informacao2='';break;case'INFORMACAO_3':manageInfo.informacao3='';break;}_this.setState({manageInfo:manageInfo});};_this.state={selected:'',axis:[],modalIsOpen:false,manageInfo:{informacao1:null,informacao2:null,informacao3:null}};return _this;}_createClass(Activation,[{key:'componentDidMount',value:function componentDidMount(){this.props.dispatchReset();}},{key:'render',value:function render(){var _this2=this;var _state=this.state,selected=_state.selected,axis=_state.axis,modalIsOpen=_state.modalIsOpen,manageInfo=_state.manageInfo;var _props=this.props,fieldPlate=_props.fieldPlate,fieldIdentifier=_props.fieldIdentifier,saving=_props.saving,activePlanId=_props.accountPlans.activePlanId;var showAxios=selected==='caminhao'||selected==='onibus';var urlBack='/minha-veloe/'+activePlanId+'/identificadores';return _react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:175}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:176}},_react2.default.createElement(_ImersiveHeader2.default,{text:'Voltar',url:urlBack,__source:{fileName:_jsxFileName,lineNumber:177}})),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:180}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:181}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:182}},_data.paragraph)),_react2.default.createElement('form',{onSubmit:this.props.handleSubmit(this.handleSubmit),__source:{fileName:_jsxFileName,lineNumber:184}},_react2.default.createElement(_styles.BoxGrey,{__source:{fileName:_jsxFileName,lineNumber:185}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:186}},_react2.default.createElement(_styles.TextInfo,{__source:{fileName:_jsxFileName,lineNumber:187}},_data.textInfo),_react2.default.createElement(_styles.List,{__source:{fileName:_jsxFileName,lineNumber:188}},_react2.default.createElement(_Option2.default,{active:selected==='carro-passeio',description:'Carro de passeio',icon:_react2.default.createElement(_icCar2.default,{__source:{fileName:_jsxFileName,lineNumber:192}}),setOption:this.setOption,value:'carro-passeio',__source:{fileName:_jsxFileName,lineNumber:189}}),_react2.default.createElement(_Option2.default,{active:selected==='carro-utilitario',description:'Carro utilit\xE1rio',icon:_react2.default.createElement(_icUtility2.default,{__source:{fileName:_jsxFileName,lineNumber:199}}),setOption:this.setOption,value:'carro-utilitario',__source:{fileName:_jsxFileName,lineNumber:196}}),_react2.default.createElement(_Option2.default,{active:selected==='caminhao',description:'Caminh\xE3o',icon:_react2.default.createElement(_icTruck2.default,{__source:{fileName:_jsxFileName,lineNumber:206}}),setOption:this.setOption,value:'caminhao',__source:{fileName:_jsxFileName,lineNumber:203}}),_react2.default.createElement(_Option2.default,{active:selected==='onibus',description:'\xD4nibus',icon:_react2.default.createElement(_icBus2.default,{__source:{fileName:_jsxFileName,lineNumber:213}}),setOption:this.setOption,value:'onibus',__source:{fileName:_jsxFileName,lineNumber:210}})),_react2.default.createElement(_styles.ListForm,{__source:{fileName:_jsxFileName,lineNumber:220}},_react2.default.createElement(_gridStyled.Box,{width:1,mb:1,__source:{fileName:_jsxFileName,lineNumber:221}},_react2.default.createElement(_formFields.PlateField,{__source:{fileName:_jsxFileName,lineNumber:222}})),showAxios&&_react2.default.createElement(_gridStyled.Box,{width:1,mb:1,__source:{fileName:_jsxFileName,lineNumber:225}},_react2.default.createElement(_formFields.AxisField,{axis:axis,__source:{fileName:_jsxFileName,lineNumber:226}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:1,__source:{fileName:_jsxFileName,lineNumber:229}},_react2.default.createElement(_formFields.IdentifierField,{__source:{fileName:_jsxFileName,lineNumber:230}}))))),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:236}},_react2.default.createElement(_styles.Notice,{__source:{fileName:_jsxFileName,lineNumber:240}},_react2.default.createElement(_icInfo2.default,{__source:{fileName:_jsxFileName,lineNumber:241}}),_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:242}},'Depois de ativar o adesivo Veloe, voc\xEA j\xE1 pode usar nos estacionamentos, mas \xE9 importante ',_react2.default.createElement('b',{__source:{fileName:_jsxFileName,lineNumber:242}},'aguardar at\xE9 6 horas pra passar livre e sem filas nos ped\xE1gios'),' das rodovias de todo o Brasil.')),_react2.default.createElement(_styles.TitleSecond,{__source:{fileName:_jsxFileName,lineNumber:245}},'Informa\xE7\xF5es Gerenciais'),_react2.default.createElement(_styles.Paragraph,{noMargin:true,__source:{fileName:_jsxFileName,lineNumber:246}},'Para facilitar o gerenciamento das suas transa\xE7\xF5es, voc\xEA pode adicionar at\xE9 3 informa\xE7\xF5es gerenciais por VeloeTag, que ser\xE3o apresentadas nos seus extratos e faturas.'),_react2.default.createElement(_styles.TextInfo,{initialCase:true,noMargin:true,__source:{fileName:_jsxFileName,lineNumber:251}},'Voc\xEA pode adicionar as informa\xE7\xF5es posteriormente no menu "Minhas VeloeTags"'),_react2.default.createElement(_styles.WrapperPill,{__source:{fileName:_jsxFileName,lineNumber:255}},!manageInfo.informacao1&&!manageInfo.informacao2&&!manageInfo.informacao3&&_react2.default.createElement(_styles.Pill,{noSelected:true,__source:{fileName:_jsxFileName,lineNumber:258}},'Nenhuma informa\xE7\xE3o adicionada.'),manageInfo.informacao1&&_react2.default.createElement(_styles.Pill,{__source:{fileName:_jsxFileName,lineNumber:261}},'1. ',manageInfo.informacao1.descricao,_react2.default.createElement('span',{onClick:function onClick(){return _this2.handleDeletePil('INFORMACAO_1');},__source:{fileName:_jsxFileName,lineNumber:263}},_react2.default.createElement(_icClose2.default,{__source:{fileName:_jsxFileName,lineNumber:264}}))),manageInfo.informacao2&&_react2.default.createElement(_styles.Pill,{__source:{fileName:_jsxFileName,lineNumber:270}},'2. ',manageInfo.informacao2.descricao,_react2.default.createElement('span',{onClick:function onClick(){return _this2.handleDeletePil('INFORMACAO_2');},__source:{fileName:_jsxFileName,lineNumber:272}},_react2.default.createElement(_icClose2.default,{__source:{fileName:_jsxFileName,lineNumber:273}}))),manageInfo.informacao3&&_react2.default.createElement(_styles.Pill,{__source:{fileName:_jsxFileName,lineNumber:279}},'3. ',manageInfo.informacao3.descricao,_react2.default.createElement('span',{onClick:function onClick(){return _this2.handleDeletePil('INFORMACAO_3');},__source:{fileName:_jsxFileName,lineNumber:281}},_react2.default.createElement(_icClose2.default,{__source:{fileName:_jsxFileName,lineNumber:282}})))),_react2.default.createElement(_gridStyled.Box,{width:1,__source:{fileName:_jsxFileName,lineNumber:288}},_react2.default.createElement(_Button2.default,{buttonType:'darkBlue',text:_data.labels.addInformation,onClick:function onClick(){return _this2.toggleModal();},__source:{fileName:_jsxFileName,lineNumber:289}})),_react2.default.createElement(_gridStyled.Flex,{align:'center',justify:'flex-end',mt:[0,'10px'],mb:32,__source:{fileName:_jsxFileName,lineNumber:296}},_react2.default.createElement(_Button2.default,{text:_data.labels.submitButton,type:'submit',loading:saving,width:'200px',disabled:saving||!fieldPlate||!fieldIdentifier||selected==='',__source:{fileName:_jsxFileName,lineNumber:297}})))),modalIsOpen?_react2.default.createElement(_ManageInfoModal2.default,{isOpen:modalIsOpen,toggleModal:this.toggleModal,modalStart:'include',match:this.props.match,controlled:true,handleSubmitExternal:function handleSubmitExternal(values){return _this2.addManageInf(values);},__source:{fileName:_jsxFileName,lineNumber:308}}):null);}}]);return Activation;}(_react2.default.Component);var mapStateToProps=exports.mapStateToProps=function mapStateToProps(state){var selector=(0,_reduxForm.formValueSelector)('activationForm');return{fieldPlate:selector(state,'plate'),fieldIdentifier:selector(state,'identifier'),saving:state.reducer.formState.saving,accountPlans:state.reducer.accountPlans};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{initFormState:function initFormState(){return dispatch((0,_formStateActions.stopSaving)());},dispatchReset:function dispatchReset(){dispatch((0,_reduxForm.reset)('activationForm'));},fetchActivation:function fetchActivation(values,manageInfs){dispatch((0,_formStateActions.startSaving)());dispatch((0,_actions.fetchActivation)(values)).then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(resp){var total;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!resp){_context2.next=14;break;}if(!resp.status){_context2.next=11;break;}total=manageInfs.length;if(!(total===1)){_context2.next=8;break;}_context2.next=6;return manageInfs.map(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(data){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return dispatch((0,_actions.saveManageInf)({data:data})).then(function(){dispatch((0,_formStateActions.stopSaving)());ownProps.history.push('/identificadores/ativacao/sucesso');}).catch(function(erro){return console.error(erro);});case 2:case'end':return _context.stop();}}},_callee,undefined);}));return function(_x2){return _ref2.apply(this,arguments);};}());case 6:_context2.next=9;break;case 8:if(total===2){Promise.all([dispatch((0,_actions.saveManageInf)({data:manageInfs[0]})),dispatch((0,_actions.saveManageInf)({data:manageInfs[1]}))]).then(function(){dispatch((0,_formStateActions.stopSaving)());ownProps.history.push('/identificadores/ativacao/sucesso');}).catch(function(erro){return console.error(erro);});}else if(total===3){Promise.all([dispatch((0,_actions.saveManageInf)({data:manageInfs[0]})),dispatch((0,_actions.saveManageInf)({data:manageInfs[1]})),dispatch((0,_actions.saveManageInf)({data:manageInfs[2]}))]).then(function(){dispatch((0,_formStateActions.stopSaving)());ownProps.history.push('/identificadores/ativacao/sucesso');}).catch(function(erro){return console.error(erro);});}else{dispatch((0,_formStateActions.stopSaving)());ownProps.history.push('/identificadores/ativacao/sucesso');}case 9:_context2.next=12;break;case 11:dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModal,image:_confirmation2.default}));case 12:window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'event',eventCategory:'veloe:area-logado:ativar-identificador',eventAction:'ativar-tag',eventLabel:'tentativa:sucesso',dimension5:values.identifier});case 14:case'end':return _context2.stop();}}},_callee2,undefined);}));return function(_x){return _ref.apply(this,arguments);};}()).catch(function(e){e.json().then(function(response){dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:response.title||_data.titleModalError,modalDescription:response.message||_data.modalDescriptionError,image:_contestacao2.default}));});dispatch((0,_formStateActions.stopSaving)());window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'event',eventCategory:'veloe:area-logado:ativar-identificador',eventAction:'ativar-tag',eventLabel:'tentativa:erro',dimension5:values.identifier});});}};};var form=(0,_reduxForm.reduxForm)({form:'activationForm',destroyOnUnmount:false})(Activation);exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(form);

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName="/work/vsts-agent-5-agent/29/s/src/app/elements/Icon/ic-info.js";var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function IcInfo(){return _react2.default.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",fill:"none",viewBox:"0 0 24 24",__source:{fileName:_jsxFileName,lineNumber:5}},_react2.default.createElement("path",{fill:"#24206B",fillRule:"evenodd",d:"M2.39 10.486a.963.963 0 01-.93-1.215 10.948 10.948 0 013.835-5.755 10.83 10.83 0 016.67-2.283 10.856 10.856 0 019.034 4.814 10.812 10.812 0 011.466 3.202.963.963 0 11-1.86.506 9.01 9.01 0 00-3.16-4.723 8.866 8.866 0 00-5.48-1.872c-2.008 0-3.906.649-5.488 1.878A9.01 9.01 0 003.32 9.774a.964.964 0 01-.93.712zm9.575 12.51A10.885 10.885 0 011.44 14.885a.963.963 0 111.863-.49 8.957 8.957 0 008.662 6.674 8.957 8.957 0 008.662-6.673.964.964 0 011.863.489 10.885 10.885 0 01-10.525 8.11zM11 8a1 1 0 112 0v4a1 1 0 11-2 0V8zm1 9a1 1 0 100-2 1 1 0 000 2z",clipRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:12}}),_react2.default.createElement("mask",{style:{maskType:"alpha"},width:"22",height:"22",x:"1",y:"1",maskUnits:"userSpaceOnUse",__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement("path",{fill:"#fff",fillRule:"evenodd",d:"M2.39 10.486a.963.963 0 01-.93-1.215 10.948 10.948 0 013.835-5.755 10.83 10.83 0 016.67-2.283 10.856 10.856 0 019.034 4.814 10.812 10.812 0 011.466 3.202.963.963 0 11-1.86.506 9.01 9.01 0 00-3.16-4.723 8.866 8.866 0 00-5.48-1.872c-2.008 0-3.906.649-5.488 1.878A9.01 9.01 0 003.32 9.774a.964.964 0 01-.93.712zm9.575 12.51A10.885 10.885 0 011.44 14.885a.963.963 0 111.863-.49 8.957 8.957 0 008.662 6.674 8.957 8.957 0 008.662-6.673.964.964 0 011.863.489 10.885 10.885 0 01-10.525 8.11zM11 8a1 1 0 112 0v4a1 1 0 11-2 0V8zm1 9a1 1 0 100-2 1 1 0 000 2z",clipRule:"evenodd",__source:{fileName:_jsxFileName,lineNumber:26}})));}exports.default=IcInfo;module.exports=exports["default"];

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.IdentifierField=exports.PlateField=exports.AxisField=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/Activation/form-fields.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _renderInputs=__webpack_require__(44);var _reduxForm=__webpack_require__(11);var _data=__webpack_require__(665);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var AxisField=function AxisField(_ref){var axis=_ref.axis;return _react2.default.createElement(_reduxForm.Field,{placeholder:' ',component:_renderInputs.renderSelectField,label:_data.labels.axis,name:'axis',options:axis,validate:_aleloLogic.utils.emptyFieldValidate,__source:{fileName:_jsxFileName,lineNumber:9}});};var PlateField=function PlateField(){return _react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.plate,name:'plate',type:'text',validate:_aleloLogic.utils.plateValidate,normalize:_aleloLogic.utils.plateMask,isRequired:true,autoComplete:'off',tooltip:'O preenchimento deve seguir o padr\xE3o atual ABC1234 ou padr\xE3o placa Mercosul ABC1D23',__source:{fileName:_jsxFileName,lineNumber:20}});};var IdentifierField=function IdentifierField(){return _react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.identifier,name:'identifier',type:'text',validate:_aleloLogic.utils.identifierValidate,isRequired:true,__source:{fileName:_jsxFileName,lineNumber:34}});};exports.AxisField=AxisField;exports.PlateField=PlateField;exports.IdentifierField=IdentifierField;

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Notice=exports.Pill=exports.WrapperPill=exports.TitleSecond=exports.ListForm=exports.List=exports.TextInfo=exports.BoxGrey=exports.Paragraph=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n    width: ',';\n  '],['\n    width: ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    flex-direction: column;\n  '],['\n    flex-direction: column;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n      max-width: 100%;\n      min-width: 100%;\n      margin-bottom: 10px;\n      padding-top: 0;\n      padding-bottom: 0;\n    '],['\n      max-width: 100%;\n      min-width: 100%;\n      margin-bottom: 10px;\n      padding-top: 0;\n      padding-bottom: 0;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n    flex-direction: column;\n    margin-top: 20px;\n  '],['\n    flex-direction: column;\n    margin-top: 20px;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n      margin-bottom: 15px;\n      margin-right: 0;\n      max-width: 100%;\n    '],['\n      margin-bottom: 15px;\n      margin-right: 0;\n      max-width: 100%;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-4hoql1-0'})(['',' letter-spacing:',';color:',';margin-top:',';'],_types.title40GalanoBold,(0,_em2.default)('0.4px'),_colors.darkSlateBlue,(0,_rem2.default)('40px'));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-4hoql1-1'})(['',' color:',';width:',';',';',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('320px'),_media2.default.large(_templateObject,(0,_rem2.default)('660px')),function(_ref){var noMargin=_ref.noMargin;return noMargin&&(0,_styledComponents.css)(['margin-bottom:0;']);});var BoxGrey=exports.BoxGrey=_styledComponents2.default.div.withConfig({displayName:'styles__BoxGrey',componentId:'sc-4hoql1-2'})(['background:-moz-linear-gradient( top,rgba(241,241,247,1) 0%,rgba(241,241,247,1) 45%,rgba(241,241,247,1) 40%,rgba(241,241,247,0) 41% );background:-webkit-linear-gradient( top,rgba(241,241,247,1) 0%,rgba(241,241,247,1) 45%,rgba(241,241,247,1) 40%,rgba(241,241,247,0) 41% );background:linear-gradient( to bottom,rgba(241,241,247,1) 0%,rgba(241,241,247,1) 100%,rgba(241,241,247,1) 40%,rgba(241,241,247,0) 41% );filter:progid:DXImageTransform.Microsoft.gradient( startColorstr=\'','\',endColorstr=\'','\',GradientType=0 );margin:50px 0 0;padding:40px 0;'],_colors.paleGray,_colors.paleGray);var TextInfo=exports.TextInfo=_styledComponents2.default.p.withConfig({displayName:'styles__TextInfo',componentId:'sc-4hoql1-3'})(['',';font-weight:bold;letter-spacing:',';color:',';text-transform:uppercase;',';',';'],_types.txt12OpenSans,(0,_em2.default)('1.6px'),_colors.blueGray,function(_ref2){var initialCase=_ref2.initialCase;return initialCase&&'\n    text-transform: initial;\n    font-weight: normal;\n  ';},function(_ref3){var noMargin=_ref3.noMargin;return noMargin&&'\n    margin-top: 0;\n  ';});var List=exports.List=_styledComponents2.default.ul.withConfig({displayName:'styles__List',componentId:'sc-4hoql1-4'})(['display:flex;align-items:center;justify-content:space-between;margin:0;padding:0;',';li{max-width:216px;min-width:216px;',';}'],_media2.default.small(_templateObject2),_media2.default.small(_templateObject3));var ListForm=exports.ListForm=_styledComponents2.default.div.withConfig({displayName:'styles__ListForm',componentId:'sc-4hoql1-5'})(['display:flex;justify-content:flex-start;align-items:center;margin:40px 0 30px;',';> div{max-width:216px;margin-right:25px;',';}label{',';font-weight:bold;letter-spacing:',';color:',';text-transform:uppercase;}'],_media2.default.small(_templateObject4),_media2.default.small(_templateObject5),_types.txt12OpenSans,(0,_em2.default)('1.6px'),_colors.blueGray);var TitleSecond=exports.TitleSecond=_styledComponents2.default.h2.withConfig({displayName:'styles__TitleSecond',componentId:'sc-4hoql1-6'})(['',' letter-spacing:',';color:',';'],_types.title36GalanoBold,(0,_em2.default)('0.1px'),_colors.darkSlateBlue);var WrapperPill=exports.WrapperPill=_styledComponents2.default.ul.withConfig({displayName:'styles__WrapperPill',componentId:'sc-4hoql1-7'})(['display:flex;justify-content:flex-start;margin:0;padding:0;padding-top:25px;min-height:',';'],(0,_rem2.default)('100px'));var Pill=exports.Pill=_styledComponents2.default.li.withConfig({displayName:'styles__Pill',componentId:'sc-4hoql1-8'})(['background:',';border-radius:12px;',' color:',';font-size:10px;font-weight:bold;height:24px;letter-spacing:0.5px;list-style:none;margin-right:20px;padding:5px 30px 5px 15px;position:relative;',';span{cursor:pointer;display:block;position:absolute;right:12px;top:5px;}'],_colors.lightBlue,_types.txt14OpenSans,_colors.white,function(_ref4){var noSelected=_ref4.noSelected;return noSelected&&'\n    background: '+_colors.grey+';\n    padding-right: 15px;\n\n    span {\n      display: none;\n    }\n  ';});var Notice=exports.Notice=_styledComponents2.default.p.withConfig({displayName:'styles__Notice',componentId:'sc-4hoql1-9'})(['svg{width:64px;margin-right:8px;}position:relative;display:flex;align-items:center;',' color:',';background:#fff5cc;padding:24px 164px 24px 14px;margin-top:32px;box-shadow:0px 4px 12px rgba(0,0,0,0.08),0px 0px 1px rgba(0,0,0,0.12);border-radius:8px;&::after{position:absolute;content:\'\';height:5px;width:315px;background:',';border-bottom-left-radius:8px;bottom:0;left:0;}'],_types.txt16OpenSans,_colors.darkBlue,_colors.darkBlue);

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapStateToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ActivationSuccess/index.js';/* eslint-disable */var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _HeaderWithBrand=__webpack_require__(606);var _HeaderWithBrand2=_interopRequireDefault(_HeaderWithBrand);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _styles=__webpack_require__(2188);var _data=__webpack_require__(2189);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var ActivationSuccess=function ActivationSuccess(props){console.log(props);var activePlanId=props.accountPlans.activePlanId,history=props.history;return _react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:20}},_react2.default.createElement(_HeaderWithBrand2.default,{__source:{fileName:_jsxFileName,lineNumber:21}}),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:23}},_data.title),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:24}},_data.paragraph),_react2.default.createElement(_Button2.default,{text:_data.submitButton,onClick:function onClick(){history.push('/minha-veloe/'+activePlanId+'/identificadores');},buttonType:'transparent',__source:{fileName:_jsxFileName,lineNumber:25}})));};var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref){var reducer=_ref.reducer;return{accountPlans:reducer.accountPlans};};exports.default=(0,_reactRedux.connect)(mapStateToProps,null)(ActivationSuccess);

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Paragraph=exports.Title=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n        height: ',';\n        background: ',';\n    '],['\n        height: ',';\n        background: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=exports.Wrapper=_styledComponents2.default.div.withConfig({displayName:'styles__Wrapper',componentId:'sc-1sod8ns-0'})(['background-color:',';min-height:100vh;',';'],_colors.tealish,_media2.default.small(_templateObject,(0,_rem2.default)('70px'),_colors.white));var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-1sod8ns-1'})(['',' letter-spacing:',';color:',';font-size:',';margin:',' 0;max-width:',';'],_types.title40GalanoBold,(0,_em2.default)('0.4px'),_colors.white,(0,_rem2.default)('48px'),(0,_rem2.default)('40px'),(0,_rem2.default)('615px'));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-1sod8ns-2'})(['',' color:',';max-width:',';margin-bottom:',';'],_types.txt16OpenSans,_colors.darkBlue,(0,_rem2.default)('615px'),(0,_rem2.default)('40px'));

/***/ }),
/* 2189 */
/***/ (function(module, exports) {

module.exports = {"title":"Parabéns! Sua VeloeTag foi ativada com sucesso.","paragraph":"Agora, você precisa colar a VeloeTag no seu veículo, veja na próxima tela. É simples e rápido.","submitButton":"Continuar"}

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateRecharge=__webpack_require__(614);var _TemplateRecharge2=_interopRequireDefault(_TemplateRecharge);var _EditPaymentRechargePrices=__webpack_require__(2191);var _EditPaymentRechargePrices2=_interopRequireDefault(_EditPaymentRechargePrices);var _EditPaymentCreditCard=__webpack_require__(2194);var _EditPaymentCreditCard2=_interopRequireDefault(_EditPaymentCreditCard);var _EditPaymentConfirmation=__webpack_require__(2200);var _EditPaymentConfirmation2=_interopRequireDefault(_EditPaymentConfirmation);var _editPaymentSuccess=__webpack_require__(2206);var _editPaymentSuccess2=_interopRequireDefault(_editPaymentSuccess);var _editPaymentSuccessAutomatic=__webpack_require__(2209);var _editPaymentSuccessAutomatic2=_interopRequireDefault(_editPaymentSuccessAutomatic);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id/editar-dados',component:_TemplateRecharge2.default,routes:[{path:'/minha-veloe/:id/editar-dados',exact:true,component:_EditPaymentRechargePrices2.default},{path:'/minha-veloe/:id/editar-dados/recarga',exact:true,component:_EditPaymentRechargePrices2.default},{path:'/minha-veloe/:id/editar-dados/cartao',exact:true,component:_EditPaymentCreditCard2.default},{path:'/minha-veloe/:id/editar-dados/confirmacao',exact:true,component:_EditPaymentConfirmation2.default},{path:'/minha-veloe/:id/editar-dados/sucesso',exact:true,component:_editPaymentSuccess2.default},{path:'/minha-veloe/:id/editar-dados/sucesso-automatico',exact:true,component:_editPaymentSuccessAutomatic2.default}]};module.exports=exports['default'];

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditPaymentRechargePrices/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(13);var _ValuePicker=__webpack_require__(615);var _ValuePicker2=_interopRequireDefault(_ValuePicker);var _RechargeBreadcrumbs=__webpack_require__(114);var _RechargeBreadcrumbs2=_interopRequireDefault(_RechargeBreadcrumbs);var _Button=__webpack_require__(155);var _Button2=_interopRequireDefault(_Button);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _styles=__webpack_require__(2192);var _data=__webpack_require__(2193);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RechargePrices=function(_Component){_inherits(RechargePrices,_Component);function RechargePrices(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RechargePrices);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RechargePrices.__proto__||Object.getPrototypeOf(RechargePrices)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.onConfirm=function(){var _this$props=_this.props,currentRechargeValue=_this$props.recharge.currentRechargeValue,history=_this$props.history,match=_this$props.match;var accountId=match.params.id;_this.props.dispatch((0,_actions.fetchChangeRecharge)(accountId,currentRechargeValue)).then(function(){history.push('/minha-veloe/'+match.params.id+'/editar-dados/cartao');}).catch(function(e){console.error(e);// eslint-disable-line
});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RechargePrices,[{key:'render',value:function render(){var _this2=this;var _props$recharge=this.props.recharge,currentRechargeValue=_props$recharge.currentRechargeValue,rechargeValues=_props$recharge.rechargeValues;var valuePickerStartIndex=rechargeValues.findIndex(function(rechargeValue){return rechargeValue===currentRechargeValue;});return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_RechargeBreadcrumbs2.default,{active:1,__source:{fileName:_jsxFileName,lineNumber:40}}),_react2.default.createElement(_gridStyled.Flex,{justify:'space-between',direction:['column','row'],mt:(0,_rem2.default)('50px'),__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement(_gridStyled.Box,{width:[1,'auto'],__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:43}},_data.title)),_react2.default.createElement(_gridStyled.Flex,{justify:'space-between',align:'center',mt:[(0,_rem2.default)('50px'),(0,_rem2.default)('-30px')],wrap:true,width:[1,8/12],direction:'column',style:{position:'relative'},__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement(_styles.Currency,{__source:{fileName:_jsxFileName,lineNumber:54}},_data.currency),rechargeValues.length>0&&_react2.default.createElement(_ValuePicker2.default,{id:'lstRechargesValues',values:rechargeValues,startIndex:valuePickerStartIndex,onChange:function onChange(index){return _this2.props.dispatch((0,_actions.setCurrentRechargeValue)(rechargeValues[index]));},__source:{fileName:_jsxFileName,lineNumber:57}}),_react2.default.createElement(_gridStyled.Box,{mt:(0,_rem2.default)('50px'),width:[1,'auto'],__source:{fileName:_jsxFileName,lineNumber:67}},_react2.default.createElement(_Button2.default,{id:'btnContinue',width:(0,_rem2.default)('182px'),buttonType:'transparent',text:_data.button,onClick:this.onConfirm,__source:{fileName:_jsxFileName,lineNumber:68}})))));}}]);return RechargePrices;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{recharge:reducer.recharge};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(RechargePrices);module.exports=exports['default'];

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Currency=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n    line-height: normal;\n    padding: 0;\n    max-width: 100%;\n  '],['\n    line-height: normal;\n    padding: 0;\n    max-width: 100%;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    mmin-height: 227px !important;\n    top: 25%;\n    left: 30px;\n  '],['\n    mmin-height: 227px !important;\n    top: 25%;\n    left: 30px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    font-size: ',';\n    letter-spacing: ',';\n  '],['\n    font-size: ',';\n    letter-spacing: ',';\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _styles=__webpack_require__(103);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__Title',componentId:'sc-fb6acj-0'})(['line-height:50px;max-width:',';',';'],(0,_rem2.default)('240px'),_media2.default.small(_templateObject));var Currency=exports.Currency=_styledComponents2.default.span.withConfig({displayName:'styles__Currency',componentId:'sc-fb6acj-1'})(['',';color:',';font-weight:bold;position:absolute;top:30%;left:80px;',';',';'],_types.title24Galano,_colors.white,_media2.default.small(_templateObject2),_media2.default.large(_templateObject3,(0,_rem2.default)('50px'),(0,_rem2.default)('-1.1px')));

/***/ }),
/* 2193 */
/***/ (function(module, exports) {

module.exports = {"title":"Escolha um novo valor para a sua recarga automática ou deixe o escolhido anteriormente:","currency":"R$","button":"Continuar para edição da forma de pagamento"}

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditPaymentCreditCard/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _gridStyled=__webpack_require__(8);var _EditPaymentForm=__webpack_require__(2195);var _EditPaymentForm2=_interopRequireDefault(_EditPaymentForm);var _RechargeBreadcrumbs=__webpack_require__(114);var _RechargeBreadcrumbs2=_interopRequireDefault(_RechargeBreadcrumbs);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _actions2=__webpack_require__(18);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);var _ModalTypes=__webpack_require__(20);var _styles=__webpack_require__(2198);var _data=__webpack_require__(2199);var _rechargeService=__webpack_require__(358);var _validators=__webpack_require__(266);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RechargePayment=function(_Component){_inherits(RechargePayment,_Component);function RechargePayment(props){var _this2=this;_classCallCheck(this,RechargePayment);var _this=_possibleConstructorReturn(this,(RechargePayment.__proto__||Object.getPrototypeOf(RechargePayment)).call(this,props));_this.applyFilter=function(checkPlan){return checkPlan.id.toString()===_this.props.accountPlans.activePlanId.toString();};_this.resolverTipoCompra=function(){return window.location.href.includes('/empresa')?'compra-pj':'compra';};_this.getPaymentToken=function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(values){var paymentToken;return regeneratorRuntime.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return(0,_rechargeService.getBrasPagAccessToken)().then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(response){var resp;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return(0,_rechargeService.postBraspagCard)(_this.formatCardHolderName(values.yourName),values.cardNumber.replace(/\s/g,''),values.validad,values.securityCode,response.data);case 2:resp=_context.sent;paymentToken=resp.data;case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}()).catch(function(error){return console.error(error);});case 2:return _context2.abrupt('return',paymentToken);case 3:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.checkCreditCardFlag=function(values){var creditCardFlag=(0,_validators.validateCreditCardFlag)(values);if(creditCardFlag){return creditCardFlag;}};_this.formatCardHolderName=function(name){return name.toUpperCase().replace(new RegExp('[ÁÀÂÃ]','gi'),'A').replace(new RegExp('[ÉÈÊ]','gi'),'E').replace(new RegExp('[ÍÌÎ]','gi'),'I').replace(new RegExp('[ÓÒÔÕ]','gi'),'O').replace(new RegExp('[ÚÙÛ]','gi'),'U').replace(new RegExp('[Ç]','gi'),'C');};_this.cardErrorModalButtonClick=function(){_this.setState({showCardErrorModal:false});};_this.onConfirm=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5(evt,values){var search,_ref4,paymentToken,data;return regeneratorRuntime.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:search=_this.props.location.search;_this.setState({loading:true});if(!(values&&values.paymentMethod==='Adicionar um novo cartão'||location.search.includes('path=track')||location.search.includes('path=recharge'))){_context5.next=10;break;}_context5.next=5;return _this.getPaymentToken(values);case 5:_ref4=_context5.sent;paymentToken=_ref4.PaymentToken;if(!paymentToken){_this.setState({loading:false});_this.props.showErrorModal();}else{data={dados:{conta:_this.props.match.params.id,numeroMascarado:(values.cardNumber.substring(0,7)+'XX-XXXX-'+values.cardNumber.substring(15)).replace(/\s/g,'-'),validade:values.validad.replace('/','-'),bandeira:_this.checkCreditCardFlag(values.cardNumber.replace(/\s/g,'')),alias:'EDICAO FORMA PAGAMENTO',nome:_this.formatCardHolderName(values.yourName),paymentToken:paymentToken,cvv:values.securityCode,valorRecarga:_this.state.valorRecarga}};_this.props.handleSave(data).then(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(resp){var msgRecarga;return regeneratorRuntime.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.props.getPaymentInfo(_this.props.match.params.id);case 2:_this.setState({loading:false});msgRecarga=resp&&resp.result.msgRecarga?'&msgrecarga='+resp.result.msgRecarga:'&msgrecarga=Vimos que você estava com saldo menor e ja atualizamos seu saldo!';if(search.includes('path=recharge')||search.includes('path=track')){_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/editar-dados/sucesso'+search+msgRecarga);}else{_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/editar-dados/sucesso-automatico?path=edit'+msgRecarga);}case 5:case'end':return _context3.stop();}}},_callee3,_this2);}));return function(_x5){return _ref5.apply(this,arguments);};}()).catch(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(e){return regeneratorRuntime.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:console.error(e);// eslint-disable-line
_context4.next=3;return _this.props.getPaymentInfo(_this.props.match.params.id);case 3:_this.setState({loading:false});_this.props.showErrorModal();case 5:case'end':return _context4.stop();}}},_callee4,_this2);}));return function(_x6){return _ref6.apply(this,arguments);};}());}_context5.next=14;break;case 10:_context5.next=12;return _this.props.getPaymentInfo(_this.props.match.params.id);case 12:_this.setState({loading:false});if(search.includes('path=recharge')){_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/editar-dados/sucesso'+search);}else{_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/editar-dados/sucesso-automatico');}case 14:case'end':return _context5.stop();}}},_callee5,_this2);}));return function(_x3,_x4){return _ref3.apply(this,arguments);};}();_this.formatCurrencyRecharge=function(value){if(!isNaN(value)){return parseFloat(value);}};_this.state={maskedNumber:'',loading:false,valorRecarga:''};return _this;}_createClass(RechargePayment,[{key:'componentDidMount',value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6(){var _this3=this;var plan;return regeneratorRuntime.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.next=2;return this.props.getPaymentInfo(this.props.match.params.id);case 2:plan=this.props.accountPlans.plans.find(this.applyFilter);if(!this.props.location.search.includes('path=track')){_context6.next=8;break;}_context6.next=6;return this.props.fetchPlanData(plan).then(function(){_this3.setState({valorRecarga:_this3.props.planData.recharge});});case 6:_context6.next=9;break;case 8:this.setState({valorRecarga:this.props.recharge.currentRechargeValue});case 9:case'end':return _context6.stop();}}},_callee6,this);}));function componentDidMount(){return _ref7.apply(this,arguments);}return componentDidMount;}()},{key:'render',value:function render(){var _props=this.props,id=_props.match.params.id,location=_props.location,search=_props.location.search;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:192}},_react2.default.createElement(_RechargeBreadcrumbs2.default,{active:2,__source:{fileName:_jsxFileName,lineNumber:193}}),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:194}},_react2.default.createElement(_gridStyled.Box,{mr:[0,1/12*100+'%'],mb:(0,_rem2.default)('20px'),width:[1,4/12],__source:{fileName:_jsxFileName,lineNumber:195}},_react2.default.createElement(_styles.RechargeValue,{__source:{fileName:_jsxFileName,lineNumber:196}},search.includes('path=recharge')?_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:198}},_data.valueLabel):_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:200}},_data.rechargeValueLabel),_react2.default.createElement(_styles.Cash,{__source:{fileName:_jsxFileName,lineNumber:203}},_react2.default.createElement(_styles.CashPrefix,{__source:{fileName:_jsxFileName,lineNumber:204}},_data.currency),_react2.default.createElement(_styles.CashValue,{id:'lblCurrentRechargeValue',bigValue:this.state.valorRecarga>1000,__source:{fileName:_jsxFileName,lineNumber:205}},this.state.valorRecarga)))),_react2.default.createElement(_styles.BoxPayment,{width:[1,6/12],__source:{fileName:_jsxFileName,lineNumber:211}},search.includes('path=recharge')||search.includes('path=track')?_react2.default.createElement(_styles.TitlePayment,{__source:{fileName:_jsxFileName,lineNumber:213}},'Inserir um novo cart\xE3o para sua recarga?'):_react2.default.createElement(_styles.TitlePayment,{__source:{fileName:_jsxFileName,lineNumber:215}},'Inserir um novo cart\xE3o para sua recarga autom\xE1tica?'),_react2.default.createElement(_EditPaymentForm2.default,{paymentInfo:true,loading:this.state.loading,onSubmit:this.onConfirm,id:id,location:location,__source:{fileName:_jsxFileName,lineNumber:217}}))));}}]);return RechargePayment;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref8){var reducer=_ref8.reducer;return{recharge:reducer.recharge,account:reducer.account,activePlanId:reducer.accountPlans.activePlanId,accountPlans:reducer.accountPlans,planData:reducer.planData};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getPaymentInfo:function getPaymentInfo(accountPlanId){return(0,_actions.fetchPaymentInfo)(accountPlanId)(dispatch);},handleSave:function handleSave(data){return dispatch((0,_actions.setNewDataValue)(data));},showErrorModal:function showErrorModal(){return dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,image:_confirmation2.default}));},fetchPlanData:function fetchPlanData(plano){return dispatch((0,_actions.fetchPlanData)(plano));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(RechargePayment);module.exports=exports['default'];

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/EditPaymentForm/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _gridStyled=__webpack_require__(8);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _renderInputs=__webpack_require__(44);var _validators=__webpack_require__(266);var _validators2=__webpack_require__(267);var _aleloLogic=__webpack_require__(12);var _data=__webpack_require__(2196);var _style=__webpack_require__(2197);var _Radio=__webpack_require__(136);var _Radio2=_interopRequireDefault(_Radio);var _dictionary=__webpack_require__(252);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var renderRadio=function renderRadio(_ref){var input=_ref.input,label=_ref.label,negative=_ref.negative,checked=_ref.checked,onClick=_ref.onClick;return _react2.default.createElement(_Radio2.default,_extends({},input,{label:label,negative:negative,checked:checked,onClick:onClick,__source:{fileName:_jsxFileName,lineNumber:21}}));};var validate=function validate(values){var errors={};if(!values.cardNumber){errors.cardNumber=_dictionary.errorMessage.required;}if(!values.yourName){errors.yourName=_dictionary.errorMessage.required;}if(!values.securityCode){errors.securityCode=_dictionary.errorMessage.required;}if(!values.validad){errors.validad=_dictionary.errorMessage.required;}return errors;};function CreditCardFields(_ref2){var formValues=_ref2.formValues;var creditCardFlag=(0,_validators.validateCreditCardFlag)(formValues&&formValues.cardNumber||null);var validateSecurityCode=creditCardFlag==='amex'?[_validators2.required,_validators2.validateAmexCVV]:[_validators2.required,_validators2.validateCVV];return _react2.default.createElement(_style.BoxCreditCard,{__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_gridStyled.Flex,{direction:'column',__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_gridStyled.Box,{width:[1,358],mb:[17,20],__source:{fileName:_jsxFileName,lineNumber:54}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.cardNumber,name:'cardNumber',validate:_aleloLogic.utils.creditCardValidate,normalize:_aleloLogic.utils.creditCardMask,isRequired:true,negative:true,placeholder:'XXXX XXXX XXXX XXXX',__source:{fileName:_jsxFileName,lineNumber:55}})),_react2.default.createElement(_gridStyled.Box,{width:[1,358],mb:[17,20],__source:{fileName:_jsxFileName,lineNumber:66}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,label:_data.labels.yourName,name:'yourName',isRequired:true,negative:true,placeholder:'Nome do portador do cart\xE3o',__source:{fileName:_jsxFileName,lineNumber:67}})),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],width:[1,358],justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:76}},_react2.default.createElement(_gridStyled.Box,{mb:[17,20],mr:33,width:[1,170],__source:{fileName:_jsxFileName,lineNumber:77}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderTextInput,validate:_aleloLogic.utils.creditCardValidadValidate,normalize:_aleloLogic.utils.creditCardValidadMask,label:_data.labels.validad,name:'validad',isRequired:true,negative:true,placeholder:'mm/aa',__source:{fileName:_jsxFileName,lineNumber:78}})),_react2.default.createElement(_gridStyled.Box,{mb:[17,37],width:[1,170],__source:{fileName:_jsxFileName,lineNumber:89}},_react2.default.createElement(_reduxForm.Field,{component:_renderInputs.renderCvcInput,label:_data.labels.securityCode,validate:validateSecurityCode,limitDigit:creditCardFlag==='amex'?4:3,name:'securityCode',isRequired:true,negative:true,placeholder:'CVV',__source:{fileName:_jsxFileName,lineNumber:90}})))));}var PaymentForm=function(_Component){_inherits(PaymentForm,_Component);function PaymentForm(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,PaymentForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=PaymentForm.__proto__||Object.getPrototypeOf(PaymentForm)).call.apply(_ref3,[this].concat(args))),_this),_this.state={isCreditCard:false,cardFinal:'XXXX',isTrack:false},_this.onSubmit=function(evt,values){var isCreditCard=_this.state.isCreditCard;if(values)values.paymentMethod=isCreditCard?values.paymentMethod:'';evt.preventDefault();_this.props.onSubmit(evt,values);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PaymentForm,[{key:'render',value:function render(){var _this2=this;var _props=this.props,creditCardFinaly=_props.creditCardFinaly,paymentInfo=_props.paymentInfo,handleSubmit=_props.handleSubmit,values=_props.values,accountPlanId=_props.accountPlanId,loading=_props.loading,id=_props.id,location=_props.location,props=_objectWithoutProperties(_props,['creditCardFinaly','paymentInfo','handleSubmit','values','accountPlanId','loading','id','location']);var numeroFinal=paymentInfo.numeroMascarado;if(numeroFinal!==undefined){numeroFinal=numeroFinal.substring(numeroFinal.length-4);}this.isTrack=location.search.includes('path=track');this.isRecharge=location.search.includes('path=recharge');this.isCreditCard=this.props.values&&this.props.values.paymentMethod===_data.labels.radiosButtons.debit;// const textCreditCardFinaly = `Usar cartão final ${numeroFinal || 'XXXX'}`
var backButton=location.search.includes('path=recharge')?'recarga/pagamento':'editar-dados';var label=!this.isTrack&&!this.isRecharge?_data.labels.radiosButtons.debit:'';return _react2.default.createElement(_style.WrapperPayment,{__source:{fileName:_jsxFileName,lineNumber:155}},_react2.default.createElement('form',{onSubmit:function onSubmit(evt){return handleSubmit(_this2.onSubmit.bind(_this2.onSubmit(evt,values)));},__source:{fileName:_jsxFileName,lineNumber:156}},_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:157}},_react2.default.createElement(_gridStyled.Box,{mb:[39,28],width:[1,458],__source:{fileName:_jsxFileName,lineNumber:158}},_react2.default.createElement(_reduxForm.Field,{component:renderRadio,label:label,name:'paymentMethod',type:'radio',value:_data.labels.radiosButtons.debit,negative:!this.isTrack&&!this.isRecharge,disabled:this.isTrack||this.isRecharge,checked:this.state.isCreditCard||this.isTrack||this.isRecharge,onClick:function onClick(){return _this2.setState({isCreditCard:!_this2.state.isCreditCard});},__source:{fileName:_jsxFileName,lineNumber:159}}))),_react2.default.createElement(_Hide2.default,{at:'large',width:1,__source:{fileName:_jsxFileName,lineNumber:172}},!this.state.isCreditCard&&_react2.default.createElement(_style.Separator,{__source:{fileName:_jsxFileName,lineNumber:173}})),_react2.default.createElement(_gridStyled.Flex,{direction:'column',__source:{fileName:_jsxFileName,lineNumber:175}},this.state.isCreditCard&&_react2.default.createElement(CreditCardFields,{formValues:values,__source:{fileName:_jsxFileName,lineNumber:176}})||this.isTrack&&_react2.default.createElement(CreditCardFields,{formValues:values,__source:{fileName:_jsxFileName,lineNumber:177}})||this.isRecharge&&_react2.default.createElement(CreditCardFields,{formValues:values,__source:{fileName:_jsxFileName,lineNumber:178}}),' '),_react2.default.createElement(_style.Buttons,{__source:{fileName:_jsxFileName,lineNumber:180}},_react2.default.createElement(_style.ButtonBack,{to:'/minha-veloe/'+id+'/'+backButton,__source:{fileName:_jsxFileName,lineNumber:181}},_react2.default.createElement(_Icon2.default,{icon:'back-arrow',width:'10px',height:'15px',viewBox:'0 0 10 15',hidden:this.isTrack,__source:{fileName:_jsxFileName,lineNumber:182}}),_react2.default.createElement('span',{hidden:this.isTrack,__source:{fileName:_jsxFileName,lineNumber:189}},'Voltar')),_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:191}},_react2.default.createElement(_Button2.default,{text:loading?'Carregando':_data.labels.buttons.save,type:'submit',loading:loading,width:(0,_rem2.default)('220px'),disabled:(props.saving||!props.dirty||!props.valid||loading)&&(this.state.isCreditCard||this.isTrack||this.isRecharge)// || ((props.saving || !props.dirty || !props.valid || loading) && this.isTrack)
,buttonType:'transparent',__source:{fileName:_jsxFileName,lineNumber:192}})))));}}]);return PaymentForm;}(_react.Component);var Container=(0,_reactRedux.connect)(function(state,reducer){return{values:(0,_reduxForm.getFormValues)('PaymentForm')(state),isCreditCard:state.isCreditCard,paymentInfo:state.reducer.recharge.paymentInfo,account:reducer.account};},null);var Form=(0,_reduxForm.reduxForm)({form:'PaymentForm',validate:validate})(Container(PaymentForm));exports.default=Form;module.exports=exports['default'];

/***/ }),
/* 2196 */
/***/ (function(module, exports) {

module.exports = {"forgotpassword":"Esqueceu sua senha?","labels":{"bank":"banco","agency":"agência (sem dígito)","account":"conta (com dígito)","cardNumber":"número do cartāo","yourName":"seu nome","validad":"validade","securityCode":"cód. de segurança","buttons":{"save":"Continuar para concluir","cancel":"Cancelar"},"placeholder":{"account":"Ex 000000-0","agency":"Ex 0000"},"radiosButtons":{"credit":"Sim, adicionar novo cartão","debit":"Adicionar um novo cartão"}},"banks":[{"value":"","label":"Selecione","disabled":true,"hidden":true},{"value":"Bradesco","label":"Bradesco"},{"value":"Banco do Brasil","label":"Banco do Brasil"},{"value":"Banco Safra","label":"Banco Safra"},{"value":"Itaú","label":"Itaú"},{"value":"Santander","label":"Santander"}]}

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonBack=exports.BoxCreditCard=exports.WrapperPayment=exports.Separator=exports.Buttons=undefined;var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  '],['\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n      display: block;\n      line-height: ',';\n      position: relative;\n      text-align: center;\n      vertical-align: middle;\n      width: 100%;\n\n      svg {\n          left: 0;\n          position: absolute;\n          top: 50%;\n          transform: translateY(-50%);\n      }\n  '],['\n      display: block;\n      line-height: ',';\n      position: relative;\n      text-align: center;\n      vertical-align: middle;\n      width: 100%;\n\n      svg {\n          left: 0;\n          position: absolute;\n          top: 50%;\n          transform: translateY(-50%);\n      }\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _reactRouterDom=__webpack_require__(15);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Buttons=exports.Buttons=_styledComponents2.default.div.withConfig({displayName:'style__Buttons',componentId:'sc-16xjq5w-0'})(['display:flex;flex-direction:column;margin-bottom:',';margin-top:',';',';'],(0,_rem2.default)('45px'),(0,_rem2.default)('40px'),_media2.default.large(_templateObject));var Separator=exports.Separator=_styledComponents2.default.hr.withConfig({displayName:'style__Separator',componentId:'sc-16xjq5w-1'})(['border:1px solid ',';margin-left:-20px;width:calc(100% + 36px);'],_colors.paleGrayTwo);var WrapperPayment=exports.WrapperPayment=_styledComponents2.default.div.withConfig({displayName:'style__WrapperPayment',componentId:'sc-16xjq5w-2'})(['input{color:',';}span{color:',';}label{color:',';div > span{font-size:12px;}}'],_colors.white,_colors.white,_colors.white);var BoxCreditCard=exports.BoxCreditCard=_styledComponents2.default.div.withConfig({displayName:'style__BoxCreditCard',componentId:'sc-16xjq5w-3'})(['div > span{color:',' !important;}'],_colors.red);var ButtonBack=exports.ButtonBack=(0,_styledComponents2.default)(_reactRouterDom.Link).withConfig({displayName:'style__ButtonBack',componentId:'sc-16xjq5w-4'})(['',';font-size:16px;align-items:center;color:',';display:inline-flex;line-height:1;text-decoration:none;svg{margin-right:',';}',';'],_types.txt14OpenSansBold,_colors.white,(0,_rem2.default)('15px'),_media2.default.small(_templateObject2,(0,_rem2.default)('60px')));

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TitlePayment=exports.BoxPayment=exports.RechargeValue=exports.CashValue=exports.CashPrefix=exports.Cash=exports.Text=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: flex;\n    '],['\n        display: flex;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        ','\n    '],['\n        ','\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        ','\n        letter-spacing: .072em;\n        font-size: ',';\n    '],['\n        ','\n        letter-spacing: .072em;\n        font-size: ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        margin: 0;\n        display: block;\n    '],['\n        margin: 0;\n        display: block;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n            margin: ',' 0 ',';\n            text-transform: uppercase;\n        '],['\n            margin: ',' 0 ',';\n            text-transform: uppercase;\n        ']),_templateObject6=_taggedTemplateLiteral(['\n    max-width: 100%;\n  '],['\n    max-width: 100%;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _gridStyled=__webpack_require__(8);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _styles=__webpack_require__(103);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Text=exports.Text=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__Text',componentId:'sc-dfaq4g-0'})(['',';letter-spacing:',';'],_types.txt12OpenSans,(0,_rem2.default)('1px'));var Cash=exports.Cash=_styledComponents2.default.p.withConfig({displayName:'styles__Cash',componentId:'sc-dfaq4g-1'})(['color:',';margin:0;align-items:center;display:inline-flex;justify-content:space-between;',';'],_colors.white,_media2.default.large(_templateObject));var CashPrefix=exports.CashPrefix=_styledComponents2.default.span.withConfig({displayName:'styles__CashPrefix',componentId:'sc-dfaq4g-2'})(['',' line-height:1;margin-right:',';',';'],_types.title18Galano,(0,_rem2.default)('12px'),_media2.default.large(_templateObject2,_types.title32GalanoBold));var CashValue=exports.CashValue=_styledComponents2.default.span.withConfig({displayName:'styles__CashValue',componentId:'sc-dfaq4g-3'})(['',' line-height:1;',';'],_types.title44GalanoBold,_media2.default.large(_templateObject3,_types.title144GalanoBold,function(props){return props.bigValue?'113px':'134px';}));var RechargeValue=exports.RechargeValue=_styledComponents2.default.div.withConfig({displayName:'styles__RechargeValue',componentId:'sc-dfaq4g-4'})(['display:flex;align-items:center;justify-content:space-between;margin:',' 0 ',';',' ','{',';}'],(0,_rem2.default)('28px'),(0,_rem2.default)('5px'),_media2.default.large(_templateObject4),Text,_media2.default.large(_templateObject5,(0,_rem2.default)('50px'),(0,_rem2.default)('25px')));var BoxPayment=exports.BoxPayment=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'styles__BoxPayment',componentId:'sc-dfaq4g-5'})(['color:',';margin-top:-44px;max-width:442px;',';'],_colors.white,_media2.default.large(_templateObject6));var TitlePayment=exports.TitlePayment=_styledComponents2.default.h2.withConfig({displayName:'styles__TitlePayment',componentId:'sc-dfaq4g-6'})(['',';font-size:40px;font-weight:normal;line-height:normal;margin:0 0 20px;'],_types.title44GalanoBold);

/***/ }),
/* 2199 */
/***/ (function(module, exports) {

module.exports = {"rechargeValueLabel":"O valor da sua recarga escolhida foi:","valueLabel":"Valor da Recarga:","currency":"R$","button":"continue","titleModalError":"Tem algo errado com os dados do seu cartão. Tente novamente."}

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/EditPaymentConfirmation/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(13);var _gridStyled=__webpack_require__(8);var _EditPaymentInfoCard=__webpack_require__(2201);var _EditPaymentInfoCard2=_interopRequireDefault(_EditPaymentInfoCard);var _RechargeBreadcrumbs=__webpack_require__(114);var _RechargeBreadcrumbs2=_interopRequireDefault(_RechargeBreadcrumbs);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _styles=__webpack_require__(2204);var _data=__webpack_require__(2205);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RechargePayment=function(_Component){_inherits(RechargePayment,_Component);function RechargePayment(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RechargePayment);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RechargePayment.__proto__||Object.getPrototypeOf(RechargePayment)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false},_this.onConfirm=function(){_this.setState({loading:true});var _this$props=_this.props,currentRechargeValue=_this$props.recharge.currentRechargeValue,history=_this$props.history,match=_this$props.match,search=_this$props.location.search;var accountId=_this.props.match.params.id;_this.props.changeRecharge(accountId,currentRechargeValue).then(function(){_this.setState({loading:false});history.push('/minha-veloe/'+match.params.id+'/editar-dados/sucesso'+search);}).catch(function(e){_this.setState({loading:false});console.error(e);// eslint-disable-line
});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RechargePayment,[{key:'render',value:function render(){var _props=this.props,_props$recharge=_props.recharge,currentRechargeValue=_props$recharge.currentRechargeValue,paymentInfo=_props$recharge.paymentInfo,history=_props.history;var loading=this.state.loading;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_RechargeBreadcrumbs2.default,{active:3,__source:{fileName:_jsxFileName,lineNumber:43}}),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_gridStyled.Box,{mr:[0,1/12*100+'%'],mb:(0,_rem2.default)('20px'),width:[1,4/12],__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement(_styles.RechargeValue,{__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:47}},_data.rechargeValueLabel),_react2.default.createElement(_styles.Cash,{__source:{fileName:_jsxFileName,lineNumber:48}},_react2.default.createElement(_styles.CashPrefix,{__source:{fileName:_jsxFileName,lineNumber:49}},_data.currency),_react2.default.createElement(_styles.CashValue,{id:'lblCurrentRechargeValue',__source:{fileName:_jsxFileName,lineNumber:50}},currentRechargeValue))),_react2.default.createElement(_styles.Text,{id:'lblDisclaimer',__source:{fileName:_jsxFileName,lineNumber:53}},_data.disclaimer)),_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:55}},_react2.default.createElement(_EditPaymentInfoCard2.default,{accountPlanId:this.props.match.params.id,onConfirm:this.onConfirm,history:history,cardNumber:paymentInfo.numeroMascarado,loading:loading,__source:{fileName:_jsxFileName,lineNumber:56}}))));}}]);return RechargePayment;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{accountPlanId:reducer.accountPlanId,recharge:reducer.recharge,editPaymentData:reducer.editPaymentData};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getPaymentInfo:function getPaymentInfo(accountPlanId){return(0,_actions.fetchPaymentInfo)(accountPlanId)(dispatch);},changeRecharge:function changeRecharge(accountId,valorRecarga){return(0,_actions.fetchChangeRecharge)(accountId,valorRecarga)(dispatch);}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(RechargePayment);module.exports=exports['default'];

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/EditPaymentInfoCard/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(13);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _styles=__webpack_require__(2202);var _data=__webpack_require__(2203);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PaymentInfoCard=function(_React$Component){_inherits(PaymentInfoCard,_React$Component);function PaymentInfoCard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PaymentInfoCard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PaymentInfoCard.__proto__||Object.getPrototypeOf(PaymentInfoCard)).call.apply(_ref,[this].concat(args))),_this),_this.state={editing:false},_this.onConfirm=function(){_this.props.onConfirm();},_this.goBack=function(){_this.props.history.goBack();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PaymentInfoCard,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,getPaymentInfo=_props.getPaymentInfo,accountPlanId=_props.accountPlanId;getPaymentInfo(accountPlanId);}},{key:'render',value:function render(){var _props2=this.props,avatar=_props2.avatar,paymentInfo=_props2.paymentInfo,loading=_props2.loading;var splitedUsername=paymentInfo.nome?paymentInfo.nome.split(' '):[''];return _react2.default.createElement(_styles.Wrapper,{__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('20px'),(0,_rem2.default)('50px')],__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:40}},_data.paymentTypeLabel),_react2.default.createElement(_styles.TextBold,{__source:{fileName:_jsxFileName,lineNumber:41}},_data.creditLabel)),_react2.default.createElement(_gridStyled.Flex,{align:'center',mb:[(0,_rem2.default)('30px'),(0,_rem2.default)('40px')],__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_styles.UserImage,{src:__webpack_require__(616)("./avatar-"+(avatar+1)+'.png'),__source:{fileName:_jsxFileName,lineNumber:44}}),_react2.default.createElement(_styles.Username,{__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement('span',{id:'lblFirstName',__source:{fileName:_jsxFileName,lineNumber:46}},splitedUsername.shift()),_react2.default.createElement('br',{__source:{fileName:_jsxFileName,lineNumber:47}}),_react2.default.createElement('span',{id:'lblLastName',__source:{fileName:_jsxFileName,lineNumber:48}},splitedUsername.join(' ')))),_react2.default.createElement(_gridStyled.Box,{mb:'30px',__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:52}},_data.cardLabel),_react2.default.createElement(_styles.TextBold,{id:'lblMaskedCard',__source:{fileName:_jsxFileName,lineNumber:53}},paymentInfo.numeroMascarado)),_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:55}},_react2.default.createElement(_Button2.default,{id:'btnContinue',onClick:this.onConfirm,width:'100%',text:_data.confirmBtn,disabled:loading,loading:loading,__source:{fileName:_jsxFileName,lineNumber:56}}),_react2.default.createElement(_styles.EditPaymentMethod,{onClick:this.goBack,__source:{fileName:_jsxFileName,lineNumber:64}},_data.editDataBtn)));}}]);return PaymentInfoCard;}(_react2.default.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer,header=_ref2.header;return{account:reducer.account,avatar:header.avatar,paymentInfo:reducer.recharge.paymentInfo};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getPaymentInfo:function getPaymentInfo(accountPlanId){return(0,_actions.fetchPaymentInfo)(accountPlanId)(dispatch);}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(PaymentInfoCard);module.exports=exports['default'];

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.EditPaymentMethod=exports.Username=exports.UserImage=exports.TextBold=exports.Text=exports.Wrapper=undefined;var _templateObject=_taggedTemplateLiteral(['\n        padding: ',' ',' ',';\n        width: ',';\n    '],['\n        padding: ',' ',' ',';\n        width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        ','\n    '],['\n        ','\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=exports.Wrapper=_styledComponents2.default.section.withConfig({displayName:'styles__Wrapper',componentId:'sc-kh5f1d-0'})(['width:100%;border-radius:',';background-color:',';padding:',';box-shadow:0 ',' ',' 0 rgba(30,27,91,0.11);',';'],(0,_rem2.default)('6px'),_colors.white,(0,_rem2.default)('22px'),(0,_rem2.default)('8px'),(0,_rem2.default)('8px'),_media2.default.large(_templateObject,(0,_rem2.default)('40px'),(0,_rem2.default)('40px'),(0,_rem2.default)('30px'),(0,_rem2.default)('335px')));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-kh5f1d-1'})(['',' letter-spacing:',';color:',';margin:0;margin-bottom:',';text-transform:uppercase;'],_types.txt12OpenSansLight,(0,_rem2.default)('1px'),_colors.darkGrey,(0,_rem2.default)('5px'));var TextBold=exports.TextBold=_styledComponents2.default.p.withConfig({displayName:'styles__TextBold',componentId:'sc-kh5f1d-2'})(['',' font-weight:bold;color:',';margin:0;'],_types.txt16OpenSans,_colors.linkNavyBlue);var UserImage=exports.UserImage=_styledComponents2.default.img.withConfig({displayName:'styles__UserImage',componentId:'sc-kh5f1d-3'})(['width:',';height:',';border-radius:100%;margin-right:',';'],(0,_rem2.default)('50px'),(0,_rem2.default)('50px'),(0,_rem2.default)('25px'));var Username=exports.Username=_styledComponents2.default.p.withConfig({displayName:'styles__Username',componentId:'sc-kh5f1d-4'})(['',' color:',';font-weight:bold;margin:0;',';'],_types.txt16OpenSans,_colors.linkNavyBlue,_media2.default.large(_templateObject2,_types.txt24OpenSansBold));var EditPaymentMethod=exports.EditPaymentMethod=_styledComponents2.default.p.withConfig({displayName:'styles__EditPaymentMethod',componentId:'sc-kh5f1d-5'})(['',';cursor:pointer;line-height:1;text-align:center;margin-top:',';margin-bottom:0;color:',';'],_types.txt14OpenSansBold,(0,_rem2.default)('20px'),_colors.linkNavyBlue);

/***/ }),
/* 2203 */
/***/ (function(module, exports) {

module.exports = {"paymentTypeLabel":"tipo de pagamento","creditLabel":"Crédito","cardLabel":"Cartão","confirmBtn":"Confirmar a alteração?","editDataBtn":"Editar dados"}

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.RechargeValue=exports.CashValue=exports.CashPrefix=exports.Cash=exports.Text=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: flex;\n    '],['\n        display: flex;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        ','\n    '],['\n        ','\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        ','\n        letter-spacing: .072em;\n    '],['\n        ','\n        letter-spacing: .072em;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        margin: 0;\n        display: block;\n    '],['\n        margin: 0;\n        display: block;\n    ']),_templateObject5=_taggedTemplateLiteral(['\n            margin: ',' 0 ',';\n            text-transform: uppercase;\n        '],['\n            margin: ',' 0 ',';\n            text-transform: uppercase;\n        ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _styles=__webpack_require__(103);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Text=exports.Text=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__Text',componentId:'sc-1oi2jcs-0'})(['',';letter-spacing:',';'],_types.txt12OpenSans,(0,_rem2.default)('1px'));var Cash=exports.Cash=_styledComponents2.default.p.withConfig({displayName:'styles__Cash',componentId:'sc-1oi2jcs-1'})(['color:',';margin:0;align-items:center;display:inline-flex;justify-content:space-between;',';'],_colors.white,_media2.default.large(_templateObject));var CashPrefix=exports.CashPrefix=_styledComponents2.default.span.withConfig({displayName:'styles__CashPrefix',componentId:'sc-1oi2jcs-2'})(['',' line-height:1;margin-right:',';',';'],_types.title18Galano,(0,_rem2.default)('12px'),_media2.default.large(_templateObject2,_types.title32GalanoBold));var CashValue=exports.CashValue=_styledComponents2.default.span.withConfig({displayName:'styles__CashValue',componentId:'sc-1oi2jcs-3'})(['',' line-height:1;',';'],_types.title44GalanoBold,_media2.default.large(_templateObject3,_types.title144GalanoBold));var RechargeValue=exports.RechargeValue=_styledComponents2.default.div.withConfig({displayName:'styles__RechargeValue',componentId:'sc-1oi2jcs-4'})(['display:flex;align-items:center;justify-content:space-between;margin:',' 0 ',';',' ','{',';}'],(0,_rem2.default)('28px'),(0,_rem2.default)('5px'),_media2.default.large(_templateObject4),Text,_media2.default.large(_templateObject5,(0,_rem2.default)('50px'),(0,_rem2.default)('25px')));

/***/ }),
/* 2205 */
/***/ (function(module, exports) {

module.exports = {"rechargeValueLabel":"Valor da Recarga","currency":"R$","disclaimer":"","button":"continue"}

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/editPaymentSuccess/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(13);var _textSlug=__webpack_require__(184);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _RechargeBreadcrumbs=__webpack_require__(114);var _RechargeBreadcrumbs2=_interopRequireDefault(_RechargeBreadcrumbs);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _recarga=__webpack_require__(254);var _recarga2=_interopRequireDefault(_recarga);var _actions2=__webpack_require__(18);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);var _ModalTypes=__webpack_require__(20);var _styles=__webpack_require__(2207);var _data=__webpack_require__(2208);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditPaymentSuccess=function(_Component){_inherits(EditPaymentSuccess,_Component);function EditPaymentSuccess(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EditPaymentSuccess);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EditPaymentSuccess.__proto__||Object.getPrototypeOf(EditPaymentSuccess)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false},_this.onConfirm=function(){_this.setState({loading:true});var _this$props=_this.props,_this$props$recharge=_this$props.recharge,currentRechargeValue=_this$props$recharge.currentRechargeValue,paymentInfo=_this$props$recharge.paymentInfo,history=_this$props.history,match=_this$props.match,dispatch=_this$props.dispatch,dashboardResume=_this$props.dashboardResume,actualPlan=_this$props.actualPlan;dispatch((0,_actions.fetchCreateRecharge)({accountPlanId:match.params.id,value:currentRechargeValue,paymentMethod:'credit',type:'manual'})).then(function(){window.dataLayer.push({event:'purchase',eventCategory:'veloe:area-logado:recarga-manual',eventAction:'sucesso:recarga',eventLabel:'purchase',dimension9:'recarga',ecommerce:{purchase:{actionField:{id:paymentInfo.id,revenue:currentRechargeValue.toFixed(2)},products:[{name:(0,_textSlug.converText)('plano-'+actualPlan.plan.category),id:(0,_textSlug.converText)('plano-'+actualPlan.plan.category+'-'+currentRechargeValue),price:currentRechargeValue.toFixed(2),category:dashboardResume.type,quantity:'1'}]}}});_this.setState({loading:false});history.push('/minha-veloe/'+match.params.id+'/recarga/confirmacao');}).catch(function(e){_this.setState({loading:false});console.error(e);// eslint-disable-line
dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,modalDescription:_data.descriptionModalError,image:_contestacao2.default}));});},_this.minor=function(){var actualPlan=_this.props.actualPlan;return parseFloat(actualPlan.ammount)<parseFloat(actualPlan.plan.rechargeAmount);},_this.onBack=function(){var search=_this.props.location.search;if(search.includes('path=recharge')){if(_this.minor()){_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/resumo');}else{_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/recarga/confirmacao?path=recharge');}}else{_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/dados-do-plano');}},_this.onStatement=function(){_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/historico-de-recarga');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EditPaymentSuccess,[{key:'render',value:function render(){var search=this.props.location.search;var loading=this.state.loading;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:123}},_react2.default.createElement(_RechargeBreadcrumbs2.default,{active:4,__source:{fileName:_jsxFileName,lineNumber:124}}),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:125}},_react2.default.createElement(_gridStyled.Box,{mr:[0,1/12*100+'%'],mt:[(0,_rem2.default)('35px'),(0,_rem2.default)('60px')],mb:(0,_rem2.default)('20px'),width:[1,7/12],__source:{fileName:_jsxFileName,lineNumber:126}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:132}},_data.title),this.minor()?_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:135}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:136}},search.split('msgrecarga=')[1]),_react2.default.createElement(_styles.TextSmall,{__source:{fileName:_jsxFileName,lineNumber:138}},_data.awaitUpdate),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],mt:[(0,_rem2.default)('30px'),(0,_rem2.default)('30px')],__source:{fileName:_jsxFileName,lineNumber:140}},_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('16px'),0],mr:[0,(0,_rem2.default)('10px')],width:[1,1/2],__source:{fileName:_jsxFileName,lineNumber:141}},_react2.default.createElement(_Button2.default,{id:'btnOk',buttonType:'white',onClick:this.onBack,width:'50%',text:'Voltar',__source:{fileName:_jsxFileName,lineNumber:142}})),_react2.default.createElement(_gridStyled.Box,{ml:[0,(0,_rem2.default)('10px')],width:[1,1/2],__source:{fileName:_jsxFileName,lineNumber:150}},_react2.default.createElement(_Button2.default,{id:'btnNewRecharge',buttonType:'transparent',onClick:this.onStatement,width:'100%',text:'Consultar suas recargas',__source:{fileName:_jsxFileName,lineNumber:151}})))):_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:162}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:163}},'Confirmar sua recarga escolhida ?'),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],mt:[(0,_rem2.default)('30px'),(0,_rem2.default)('30px')],__source:{fileName:_jsxFileName,lineNumber:165}},_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('16px'),0],mr:[0,(0,_rem2.default)('10px')],width:[1,1/2],__source:{fileName:_jsxFileName,lineNumber:166}},_react2.default.createElement(_Button2.default,{id:'btnOk',buttonType:'white',onClick:this.onBack,width:'50%',text:_data.button,__source:{fileName:_jsxFileName,lineNumber:167}})),_react2.default.createElement(_gridStyled.Box,{ml:[0,(0,_rem2.default)('10px')],width:[1,1/2],__source:{fileName:_jsxFileName,lineNumber:175}},_react2.default.createElement(_Button2.default,{id:'btnNewRecharge',buttonType:'transparent',onClick:this.onConfirm,width:'100%',text:loading?'Carregando':_data.buttonLabel,disabled:loading,loading:loading,__source:{fileName:_jsxFileName,lineNumber:176}}))))),_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:190}},_react2.default.createElement('img',{alt:'recarga',src:_recarga2.default,__source:{fileName:_jsxFileName,lineNumber:191}}))));}}]);return EditPaymentSuccess;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{recharge:reducer.recharge,dashboardResume:reducer.dashboardResume,actualPlan:reducer.accountPlans.plans.find(function(plan){return plan.accountId===reducer.accountPlans.activePlanId;})||{}};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(EditPaymentSuccess);module.exports=exports['default'];

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.CashValue=exports.CashPrefix=exports.Cash=exports.TextSmall=exports.Text=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n        max-width: ',';\n    '],['\n        max-width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        margin-right: ',';\n        ','\n    '],['\n        margin-right: ',';\n        ','\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        ','\n        letter-spacing: .072em;\n    '],['\n        ','\n        letter-spacing: .072em;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _styles=__webpack_require__(103);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__Title',componentId:'sc-1goe5w1-0'})(['line-height:1.3;margin-bottom:',';',';'],(0,_rem2.default)('30px'),_media2.default.large(_templateObject,(0,_rem2.default)('350px')));var Text=exports.Text=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__Text',componentId:'sc-1goe5w1-1'})(['',';letter-spacing:',';'],_types.title24Galano,(0,_rem2.default)('1px'));var TextSmall=exports.TextSmall=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__TextSmall',componentId:'sc-1goe5w1-2'})(['',';font-size:',';letter-spacing:',';margin-top:',';'],_types.title24Galano,(0,_rem2.default)('15px'),(0,_rem2.default)('1px'),(0,_rem2.default)('15px'));var Cash=exports.Cash=_styledComponents2.default.p.withConfig({displayName:'styles__Cash',componentId:'sc-1goe5w1-3'})(['align-items:center;color:',';display:inline-flex;justify-content:space-between;margin:0;'],_colors.white);var CashPrefix=exports.CashPrefix=_styledComponents2.default.span.withConfig({displayName:'styles__CashPrefix',componentId:'sc-1goe5w1-4'})(['',' line-height:1;margin-right:',';',';'],_types.title24Galano,(0,_rem2.default)('22px'),_media2.default.large(_templateObject2,(0,_rem2.default)('12px'),_types.title32GalanoBold));var CashValue=exports.CashValue=_styledComponents2.default.span.withConfig({displayName:'styles__CashValue',componentId:'sc-1goe5w1-5'})(['',' font-size:',';line-height:1;',';'],_types.title44GalanoBold,(0,_rem2.default)('100px'),_media2.default.large(_templateObject3,_types.title144GalanoBold));

/***/ }),
/* 2208 */
/***/ (function(module, exports) {

module.exports = {"title":"Pronto! A gente já salvou suas alterações ;)","currency":"R$","buttonLabel":"Sim","button":"Voltar","titleModalError":"Ops.","descriptionModalError":"Recarga não autorizada. Consulte seu cartão ou tente novamente com outro cartão de crédito.","awaitUpdate":"Dentro de alguns segundos o saldo da sua conta estará atualizado."}

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/editPaymentSuccessAutomatic/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _RechargeBreadcrumbs=__webpack_require__(114);var _RechargeBreadcrumbs2=_interopRequireDefault(_RechargeBreadcrumbs);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _recarga=__webpack_require__(254);var _recarga2=_interopRequireDefault(_recarga);var _styles=__webpack_require__(2210);var _data=__webpack_require__(2211);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditPaymentSuccess=function(_Component){_inherits(EditPaymentSuccess,_Component);function EditPaymentSuccess(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EditPaymentSuccess);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EditPaymentSuccess.__proto__||Object.getPrototypeOf(EditPaymentSuccess)).call.apply(_ref,[this].concat(args))),_this),_this.state={loading:false},_this.minor=function(){var actualPlan=_this.props.actualPlan;return parseFloat(actualPlan.ammount)<parseFloat(actualPlan.plan.rechargeAmount);},_this.onBack=function(){var search=_this.props.location.search;if(search.includes('path=recharge')){if(_this.minor()){_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/resumo');}else{_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/recarga/confirmacao?path=recharge');}}else{_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/dados-do-plano');}},_this.onStatement=function(){_this.props.history.push('/minha-veloe/'+_this.props.match.params.id+'/historico-de-recarga');},_this.isEditCreditCard=function(){var search=_this.props.location.search;return search.includes('?path=edit');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EditPaymentSuccess,[{key:'render',value:function render(){var search=this.props.location.search;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:55}},_react2.default.createElement(_RechargeBreadcrumbs2.default,{active:4,__source:{fileName:_jsxFileName,lineNumber:56}}),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_gridStyled.Box,{mr:[0,1/12*100+'%'],mt:[(0,_rem2.default)('35px'),(0,_rem2.default)('60px')],mb:(0,_rem2.default)('20px'),width:[1,7/12],__source:{fileName:_jsxFileName,lineNumber:58}},this.isEditCreditCard()?_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:64}},_data.titleEdit):_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:64}},_data.title),this.minor()?_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:67}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:68}},search.split('msgrecarga=')[1]),_react2.default.createElement(_styles.TextSmall,{__source:{fileName:_jsxFileName,lineNumber:70}},_data.awaitUpdate),_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],mt:[(0,_rem2.default)('30px'),(0,_rem2.default)('30px')],__source:{fileName:_jsxFileName,lineNumber:72}},_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('16px'),0],mr:[0,(0,_rem2.default)('10px')],width:[1,1/2],__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement(_Button2.default,{id:'btnOk',buttonType:'white',onClick:this.onBack,width:'50%',text:'Voltar',__source:{fileName:_jsxFileName,lineNumber:74}})),_react2.default.createElement(_gridStyled.Box,{ml:[0,(0,_rem2.default)('10px')],width:[1,1/2],__source:{fileName:_jsxFileName,lineNumber:82}},_react2.default.createElement(_Button2.default,{id:'btnNewRecharge',buttonType:'transparent',onClick:this.onStatement,width:'100%',text:'Consultar suas recargas',__source:{fileName:_jsxFileName,lineNumber:83}})))):_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:94}},_react2.default.createElement(_gridStyled.Flex,{direction:['column','row'],mt:[(0,_rem2.default)('30px'),(0,_rem2.default)('30px')],__source:{fileName:_jsxFileName,lineNumber:95}},_react2.default.createElement(_gridStyled.Box,{mb:[(0,_rem2.default)('16px'),0],mr:[0,(0,_rem2.default)('10px')],width:[1,1/2],__source:{fileName:_jsxFileName,lineNumber:96}},_react2.default.createElement(_Button2.default,{id:'btnOk',buttonType:'white',onClick:this.onBack,width:'100%',text:'Ok',__source:{fileName:_jsxFileName,lineNumber:97}}))))),_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:109}},_react2.default.createElement('img',{alt:'recarga',src:_recarga2.default,__source:{fileName:_jsxFileName,lineNumber:110}}))));}}]);return EditPaymentSuccess;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{recharge:reducer.recharge,dashboardResume:reducer.dashboardResume,actualPlan:reducer.accountPlans.plans.find(function(plan){return plan.accountId===reducer.accountPlans.activePlanId;})||{}};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(EditPaymentSuccess);module.exports=exports['default'];

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.CashValue=exports.CashPrefix=exports.Cash=exports.TextSmall=exports.Text=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n        max-width: ',';\n    '],['\n        max-width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        margin-right: ',';\n        ','\n    '],['\n        margin-right: ',';\n        ','\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        ','\n        letter-spacing: .072em;\n    '],['\n        ','\n        letter-spacing: .072em;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _styles=__webpack_require__(103);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__Title',componentId:'sc-4ci7kj-0'})(['line-height:1.3;margin-bottom:',';',';'],(0,_rem2.default)('30px'),_media2.default.large(_templateObject,(0,_rem2.default)('350px')));var Text=exports.Text=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__Text',componentId:'sc-4ci7kj-1'})(['',';letter-spacing:',';'],_types.title24Galano,(0,_rem2.default)('1px'));var TextSmall=exports.TextSmall=(0,_styledComponents2.default)(_styles.PageTitle).withConfig({displayName:'styles__TextSmall',componentId:'sc-4ci7kj-2'})(['',';font-size:',';letter-spacing:',';margin-top:',';'],_types.title24Galano,(0,_rem2.default)('15px'),(0,_rem2.default)('1px'),(0,_rem2.default)('15px'));var Cash=exports.Cash=_styledComponents2.default.p.withConfig({displayName:'styles__Cash',componentId:'sc-4ci7kj-3'})(['align-items:center;color:',';display:inline-flex;justify-content:space-between;margin:0;'],_colors.white);var CashPrefix=exports.CashPrefix=_styledComponents2.default.span.withConfig({displayName:'styles__CashPrefix',componentId:'sc-4ci7kj-4'})(['',' line-height:1;margin-right:',';',';'],_types.title24Galano,(0,_rem2.default)('22px'),_media2.default.large(_templateObject2,(0,_rem2.default)('12px'),_types.title32GalanoBold));var CashValue=exports.CashValue=_styledComponents2.default.span.withConfig({displayName:'styles__CashValue',componentId:'sc-4ci7kj-5'})(['',' font-size:',';line-height:1;',';'],_types.title44GalanoBold,(0,_rem2.default)('100px'),_media2.default.large(_templateObject3,_types.title144GalanoBold));

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

module.exports = {"title":"Pronto! A gente já salvou seu novo valor de recarga ;)","titleEdit":"Pronto! A gente já salvou suas alterações ;)","currency":"R$","buttonLabel":"Sim","button":"Voltar","titleModalError":"Ops.","descriptionModalError":"Recarga não autorizada. Consulte seu cartão ou tente novamente com outro cartão de crédito.","awaitUpdate":"Dentro de alguns segundos o saldo da sua conta estará atualizado."}

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Home=__webpack_require__(388);var _Home2=_interopRequireDefault(_Home);var _authentication=__webpack_require__(404);var _authentication2=_interopRequireDefault(_authentication);var _carPlate=__webpack_require__(2213);var _carPlate2=_interopRequireDefault(_carPlate);var _dashboard=__webpack_require__(2221);var _dashboard2=_interopRequireDefault(_dashboard);var _requestFile=__webpack_require__(2249);var _requestFile2=_interopRequireDefault(_requestFile);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=[{exact:true,path:'/',component:_Home2.default},_authentication2.default,_carPlate2.default,_requestFile2.default,_dashboard2.default];module.exports=exports['default'];

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateLayout=__webpack_require__(362);var _TemplateLayout2=_interopRequireDefault(_TemplateLayout);var _CarPlateQuery=__webpack_require__(2214);var _CarPlateQuery2=_interopRequireDefault(_CarPlateQuery);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/consultar-placa',component:_TemplateLayout2.default,routes:[{path:'/minha-veloe/consultar-placa',exact:true,component:_CarPlateQuery2.default}]};module.exports=exports['default'];

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/CarPlateQuery/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _actions=__webpack_require__(13);var _icArrowBlueLeft=__webpack_require__(626);var _icArrowBlueLeft2=_interopRequireDefault(_icArrowBlueLeft);var _header=__webpack_require__(2215);var _header2=_interopRequireDefault(_header);var _form=__webpack_require__(2216);var _form2=_interopRequireDefault(_form);var _car=__webpack_require__(2217);var _car2=_interopRequireDefault(_car);var _styles=__webpack_require__(190);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CarPlateQuery=function(_React$Component){_inherits(CarPlateQuery,_React$Component);function CarPlateQuery(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CarPlateQuery);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CarPlateQuery.__proto__||Object.getPrototypeOf(CarPlateQuery)).call.apply(_ref,[this].concat(args))),_this),_this.state={formValues:{}},_this.onForm=function(values){_this.setState({formValues:values});_this.props.fetchQueryPlate(values);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CarPlateQuery,[{key:'componentWillMount',value:function componentWillMount(){var state=this.props.history.location.state;if(state)this.onForm(state);}},{key:'render',value:function render(){var _props=this.props,clearQueryPlate=_props.clearQueryPlate,carData=_props.carData;var formValues=this.state.formValues;return carData==null?_react2.default.createElement(_styles.Main,{__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement(_header2.default,{__source:{fileName:_jsxFileName,lineNumber:35}}),_react2.default.createElement(_form2.default,{formValues:formValues,onSubmit:this.onForm,__source:{fileName:_jsxFileName,lineNumber:36}})):_react2.default.createElement(_styles.Main,{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.HideOnSmall,{__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_form2.default,{formValues:formValues,onSubmit:this.onForm,__source:{fileName:_jsxFileName,lineNumber:41}})),_react2.default.createElement(_styles.HideOnLarge,{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_styles.BackToFormContainer,{__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement('img',{src:_icArrowBlueLeft2.default,alt:'voltar',__source:{fileName:_jsxFileName,lineNumber:45}}),_react2.default.createElement(_styles.BackToFormText,{onClick:clearQueryPlate,__source:{fileName:_jsxFileName,lineNumber:46}},'Fazer nova consulta'))),_react2.default.createElement(_car2.default,{data:carData,__source:{fileName:_jsxFileName,lineNumber:49}}));}}]);return CarPlateQuery;}(_react2.default.Component);CarPlateQuery.displayName='Consultar Placa';var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{carData:reducer.ecQueryPlate};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{clearQueryPlate:function clearQueryPlate(){return dispatch((0,_actions.clearECQueryPlate)());},fetchQueryPlate:function fetchQueryPlate(values){return dispatch((0,_actions.fetchECQueryPlate)(values));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(CarPlateQuery));module.exports=exports['default'];

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/CarPlateQuery/header.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _styles=__webpack_require__(190);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Header=function Header(){return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:6}},_react2.default.createElement(_reactHelmet2.default,{title:'Consultar Placa',__source:{fileName:_jsxFileName,lineNumber:7}}),_react2.default.createElement(_styles.SubHeader,{__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:9}},'Consultar placa'),_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:10}},'Digite as letras e n\xFAmeros da placa e per\xEDodo que deseja fazer a pesquisa.')));};exports.default=Header;module.exports=exports['default'];

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/CarPlateQuery/form.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _reduxForm=__webpack_require__(11);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _actions=__webpack_require__(13);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _data=__webpack_require__(268);var _formFields=__webpack_require__(670);var _styles=__webpack_require__(190);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var dateFormat='DD/MM/YYYY';var CarPlateForm=function(_React$Component){_inherits(CarPlateForm,_React$Component);function CarPlateForm(props){_classCallCheck(this,CarPlateForm);var _this=_possibleConstructorReturn(this,(CarPlateForm.__proto__||Object.getPrototypeOf(CarPlateForm)).call(this,props));var today=(0,_moment2.default)().format(dateFormat);_this.initialValues={periodInitDate:today,periodEndDate:today};return _this;}_createClass(CarPlateForm,[{key:'componentWillMount',value:function componentWillMount(){this.props.initialize(_extends({},this.initialValues,this.props.formValues));}},{key:'componentDidMount',value:function componentDidMount(){this.props.fetchLocations();}},{key:'render',value:function render(){var _props=this.props,handleSubmit=_props.handleSubmit,locations=_props.locations;return _react2.default.createElement(_styles.FormContent,{__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_gridStyled.Box,{width:[1,10/12],mb:3,__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_formFields.LocationField,{locations:locations,__source:{fileName:_jsxFileName,lineNumber:45}})),_react2.default.createElement(_gridStyled.Box,{width:[1,4/12],mb:[3,0],__source:{fileName:_jsxFileName,lineNumber:47}},_react2.default.createElement(_formFields.PlateField,{__source:{fileName:_jsxFileName,lineNumber:48}})),_react2.default.createElement(_gridStyled.Box,{width:[1,6/12],pl:[0,3],mb:[3,0],__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement('div',{style:{display:'flex',direction:'row'},__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_gridStyled.Box,{width:1/2,__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_formFields.PeriodInitDateField,{dateFormat:dateFormat,__source:{fileName:_jsxFileName,lineNumber:53}})),_react2.default.createElement(_styles.Divider,{__source:{fileName:_jsxFileName,lineNumber:55}}),_react2.default.createElement(_gridStyled.Box,{width:1/2,__source:{fileName:_jsxFileName,lineNumber:56}},_react2.default.createElement(_formFields.PeriodEndDateField,{dateFormat:dateFormat,__source:{fileName:_jsxFileName,lineNumber:57}})))),_react2.default.createElement(_gridStyled.Box,{width:[1,2/12],pl:[0,3],__source:{fileName:_jsxFileName,lineNumber:61}},_react2.default.createElement(_styles.QueryButtonContainer,{__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement(_Button2.default,{text:_data.labels.submitButton,type:'submit',__source:{fileName:_jsxFileName,lineNumber:63}})))))));}}]);return CarPlateForm;}(_react2.default.Component);var mapStateToProps=function mapStateToProps(_ref){var reducer=_ref.reducer;return{saving:reducer.formState.saving,locations:reducer.ecLocations};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchLocations:function fetchLocations(){return dispatch((0,_actions.fetchECLocations)());}};};var form=(0,_reduxForm.reduxForm)({form:'carPlateForm',destroyOnUnmount:false})(CarPlateForm);exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(form);module.exports=exports['default'];

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/CarPlateQuery/car.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _colors=__webpack_require__(2);var _styles=__webpack_require__(190);var _table=__webpack_require__(2218);var _table2=_interopRequireDefault(_table);var _data=__webpack_require__(268);var _blockedCar=__webpack_require__(622);var _blockedCar2=_interopRequireDefault(_blockedCar);var _unblockedCar=__webpack_require__(630);var _unblockedCar2=_interopRequireDefault(_unblockedCar);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Car=function Car(_ref){var data=_ref.data;var blocked=data.blocked,queries=data.queries;var colors=blocked?{content:_colors.lightRed,plateLabel:_colors.white,plate:_colors.white,status:_colors.white}:{content:_colors.lightOlive,plateLabel:_colors.darkGrey,plate:_colors.darkBlue,status:_colors.linkNavyBlue};var image=blocked?{src:_blockedCar2.default,alt:'carro bloqueado'}:{src:_unblockedCar2.default,alt:'carro liberado'};var status=blocked?'Bloqueado':'Liberado';return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement(_styles.CarContent,{color:colors.content,__source:{fileName:_jsxFileName,lineNumber:42}},_react2.default.createElement(_styles.HideOnLarge,{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_styles.PlateLabel,{color:colors.plateLabel,__source:{fileName:_jsxFileName,lineNumber:44}},_data.labels.plate),_react2.default.createElement(_styles.Plate,{color:colors.plate,__source:{fileName:_jsxFileName,lineNumber:45}},data.plate)),_react2.default.createElement(_styles.RowContainer,{__source:{fileName:_jsxFileName,lineNumber:47}},_react2.default.createElement('img',{src:image.src,alt:image.alt,__source:{fileName:_jsxFileName,lineNumber:48}}),_react2.default.createElement(_styles.CarStatus,{color:colors.status,__source:{fileName:_jsxFileName,lineNumber:49}},status))),_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_table2.default,{data:queries,__source:{fileName:_jsxFileName,lineNumber:53}})));};exports.default=Car;module.exports=exports['default'];

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/CarPlateQuery/table/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(2219);var _data=__webpack_require__(2220);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Index=function Index(_ref){var data=_ref.data;var columns=_data.tableConfig.columns;return _react2.default.createElement(_styles.Table,{__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement(_styles.TableHeader,{__source:{fileName:_jsxFileName,lineNumber:18}},columns.map(function(column,index){return _react2.default.createElement(_styles.TableHeaderCell,{key:'car-table-header-'+index,width:column.width,__source:{fileName:_jsxFileName,lineNumber:20}},column.header);})),data.map(function(row,index){return _react2.default.createElement(_styles.TableRow,{key:'car-table-body-'+index,index:index,__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_styles.TableRowCell,{width:columns[0].width,__source:{fileName:_jsxFileName,lineNumber:27}},row.date),_react2.default.createElement(_styles.TableRowCell,{width:columns[1].width,__source:{fileName:_jsxFileName,lineNumber:28}},row.hour),_react2.default.createElement(_styles.TableRowCellStatus,{width:columns[2].width,blocked:row.blocked,__source:{fileName:_jsxFileName,lineNumber:29}},row.blocked?'Bloqueado':'Liberado'));}));};exports.default=Index;module.exports=exports['default'];

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TableRowCellStatus=exports.TableRowCellBold=exports.TableRowCell=exports.TableRow=exports.TableHeaderCell=exports.TableHeader=exports.Table=undefined;var _templateObject=_taggedTemplateLiteral(['\n      padding: ',';\n    '],['\n      padding: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n      margin: 40px 0px;\n    '],['\n      margin: 40px 0px;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Table=exports.Table=_styledComponents2.default.div.withConfig({displayName:'styles__Table',componentId:'sc-1dhllru-0'})(['display:flex;flex-direction:column;width:100%;max-width:600px;',';',';'],_media2.default.small(_templateObject,(0,_rem2.default)('16px')),_media2.default.large(_templateObject2));var TableHeader=exports.TableHeader=_styledComponents2.default.div.withConfig({displayName:'styles__TableHeader',componentId:'sc-1dhllru-1'})(['border-top:1px solid ',';border-bottom:1px solid ',';display:flex;flex-direction:row;height:40px;width:100%;'],_colors.paleGrayTwo,_colors.paleGrayTwo);var TableHeaderCell=exports.TableHeaderCell=_styledComponents2.default.p.withConfig({displayName:'styles__TableHeaderCell',componentId:'sc-1dhllru-2'})(['',' margin:10px;color:',';display:inline-block;overflow:hidden;',';'],_types.txt12OpenSansBold,_colors.graySuit,function(_ref){var width=_ref.width;return'width: '+width+';';});var TableRow=exports.TableRow=_styledComponents2.default.div.withConfig({displayName:'styles__TableRow',componentId:'sc-1dhllru-3'})(['display:flex;flex-direction:row;height:40px;width:100%;',';'],function(_ref2){var index=_ref2.index;return'background-color: '+(index%2===0?_colors.white:_colors.ghostWhite)+';';});var TableRowCell=exports.TableRowCell=_styledComponents2.default.p.withConfig({displayName:'styles__TableRowCell',componentId:'sc-1dhllru-4'})(['',' margin:10px;color:',';display:inline-block;overflow:hidden;white-space:nowrap;',';'],_types.txt14OpenSans,_colors.linkNavyBlue,function(_ref3){var width=_ref3.width;return'width: '+width+';';});var TableRowCellBold=exports.TableRowCellBold=(0,_styledComponents2.default)(TableRowCell).withConfig({displayName:'styles__TableRowCellBold',componentId:'sc-1dhllru-5'})(['',';'],_types.txt14OpenSansBold);var TableRowCellStatus=exports.TableRowCellStatus=(0,_styledComponents2.default)(TableRowCellBold).withConfig({displayName:'styles__TableRowCellStatus',componentId:'sc-1dhllru-6'})(['',';'],function(_ref4){var blocked=_ref4.blocked;return'color: '+(blocked?_colors.lightRed:_colors.linkNavyBlue)+';';});

/***/ }),
/* 2220 */
/***/ (function(module, exports) {

module.exports = {"tableConfig":{"columns":[{"header":"DATA","width":"27.5%"},{"header":"HORA","width":"27.5%"},{"header":"STATUS","width":"45%"}]}}

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateECDashboard=__webpack_require__(2222);var _TemplateECDashboard2=_interopRequireDefault(_TemplateECDashboard);var _DashboardResume=__webpack_require__(2228);var _DashboardResume2=_interopRequireDefault(_DashboardResume);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id',component:_TemplateECDashboard2.default,routes:[{exact:true,path:'/minha-veloe/:id/resumo/',component:_DashboardResume2.default}]};module.exports=exports['default'];

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/templates/ec/TemplateECDashboard/index.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _actions=__webpack_require__(13);var _Header=__webpack_require__(176);var _Header2=_interopRequireDefault(_Header);var _Submenu=__webpack_require__(248);var _Submenu2=_interopRequireDefault(_Submenu);var _Footer=__webpack_require__(2223);var _Footer2=_interopRequireDefault(_Footer);var _PageLoader=__webpack_require__(88);var _PageLoader2=_interopRequireDefault(_PageLoader);var _data=__webpack_require__(2227);var _routes=__webpack_require__(96);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TemplateECDashboard=function(_Component){_inherits(TemplateECDashboard,_Component);function TemplateECDashboard(){_classCallCheck(this,TemplateECDashboard);return _possibleConstructorReturn(this,(TemplateECDashboard.__proto__||Object.getPrototypeOf(TemplateECDashboard)).apply(this,arguments));}_createClass(TemplateECDashboard,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;this.props.fetchAccountPlans().then(function(){return _this2.props.setActivePlanId(_this2.props.match.params.id);});}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var hasChange=// eslint-disable-next-line
nextProps.accountPlans.activePlanId!=nextProps.match.params.id||nextProps.location.pathname!==this.props.location.pathname;if(hasChange){this.props.setActivePlanId(this.props.match.params.id);}return hasChange;}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.props.setActivePlanId(this.props.match.params.id);}},{key:'render',value:function render(){var _props=this.props,routes=_props.routes,match=_props.match;var subnavLinksWithPlanId=_data.subnavLinks.map(function(subnavLink){return _extends({},subnavLink,{link:subnavLink.link.replace(':id',match.params.id)});});return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:48}},_react2.default.createElement('div',{className:'empty-template',__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_Header2.default,{__source:{fileName:_jsxFileName,lineNumber:50}}),_react2.default.createElement(_Submenu2.default,{navItems:subnavLinksWithPlanId,__source:{fileName:_jsxFileName,lineNumber:51}})),_react2.default.createElement(_PageLoader2.default,{__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:54}},routes.map(function(route){return _react2.default.createElement(_routes.RouteWithSubRoutes,_extends({key:route.path},route,{__source:{fileName:_jsxFileName,lineNumber:54}}));}))),_react2.default.createElement('div',{className:'empty-template',__source:{fileName:_jsxFileName,lineNumber:56}},_react2.default.createElement(_Footer2.default,{__source:{fileName:_jsxFileName,lineNumber:57}})));}}]);return TemplateECDashboard;}(_react.Component);var mapStateToProps=function mapStateToProps(state){return{account:state.reducer.account,accountPlans:state.reducer.accountPlans.ecPlans};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{fetchAccountPlans:function fetchAccountPlans(){return dispatch((0,_actions.fetchECAccountPlans)()).then(function(accountPlans){var history=ownProps.history,match=ownProps.match;if(accountPlans&&(match.params.id===''||match.params.id==='resumo')){var firstPlanId=accountPlans&&accountPlans[0]&&accountPlans[0].id;history.push('/minha-veloe/'+firstPlanId+'/resumo');}});},setActivePlanId:function setActivePlanId(planId){return dispatch((0,_actions.setActivePlanId)(planId));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)((0,_reactRouterDom.withRouter)(TemplateECDashboard));module.exports=exports['default'];

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Footer=__webpack_require__(2224);var _Footer2=_interopRequireDefault(_Footer);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=_Footer2.default;module.exports=exports['default'];

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Footer/Footer.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _FooterNavigationSmall=__webpack_require__(2225);var _FooterNavigationSmall2=_interopRequireDefault(_FooterNavigationSmall);var _FooterNavigationLarge=__webpack_require__(2226);var _FooterNavigationLarge2=_interopRequireDefault(_FooterNavigationLarge);var _styles=__webpack_require__(406);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function Footer(){return _react2.default.createElement(_styles.FooterContainer,{id:'footer',__source:{fileName:_jsxFileName,lineNumber:11}},_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_FooterNavigationLarge2.default,{__source:{fileName:_jsxFileName,lineNumber:13}})),_react2.default.createElement(_Hide2.default,{at:'large',__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement(_FooterNavigationSmall2.default,{__source:{fileName:_jsxFileName,lineNumber:16}})),_react2.default.createElement(_styles.CardsContainer,{__source:{fileName:_jsxFileName,lineNumber:18}},_react2.default.createElement(_styles.NavigationText,{marginOnSmall:true,__source:{fileName:_jsxFileName,lineNumber:19}},'\xA9 consectetur adipiscing elit. Hoc dixerit potius Ennius: Veloe 2017'),_react2.default.createElement(_styles.CardsFlags,{__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(_Icon2.default,{icon:'visa',svgStyle:_styles.CardFlag,width:'50',height:'30',viewBox:'0 0 50 30',__source:{fileName:_jsxFileName,lineNumber:23}}),_react2.default.createElement(_Icon2.default,{icon:'master',svgStyle:_styles.CardFlag,width:'50',height:'30',viewBox:'0 0 50 30',__source:{fileName:_jsxFileName,lineNumber:24}}),_react2.default.createElement(_Icon2.default,{icon:'maestro',svgStyle:_styles.CardFlag,width:'50',height:'30',viewBox:'0 0 50 30',__source:{fileName:_jsxFileName,lineNumber:25}}),_react2.default.createElement(_Icon2.default,{icon:'diners',svgStyle:_styles.CardFlag,width:'50',height:'30',viewBox:'0 0 50 30',__source:{fileName:_jsxFileName,lineNumber:26}}))));}exports.default=Footer;module.exports=exports['default'];

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Footer/FooterNavigationSmall.js';var _templateObject=_taggedTemplateLiteral(['\n  flex-direction: column;\n  padding: 50px;\n'],['\n  flex-direction: column;\n  padding: 50px;\n']),_templateObject2=_taggedTemplateLiteral(['\n  width: 100%;\n'],['\n  width: 100%;\n']),_templateObject3=_taggedTemplateLiteral(['\n  text-align: center;\n'],['\n  text-align: center;\n']),_templateObject4=_taggedTemplateLiteral(['\n  min-width: 0;\n'],['\n  min-width: 0;\n']);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _styles=__webpack_require__(406);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function FooterNavigationSmall(){return _react2.default.createElement(FooterNavigationSm,{__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(NavigationContentSm,{__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(NavigationColumnSm,{__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement(_Icon2.default,{icon:'veloe-logo',svgStyle:VeloeLogoSmall,width:'74',height:'31',viewBox:'0 0 74 31',__source:{fileName:_jsxFileName,lineNumber:25}}),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:32}},'Sobre a Veloe'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:33}},'Planos'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:34}},'Onde encontrar'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:35}},'Ajuda'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:36}},'Imprensa')),_react2.default.createElement(NavigationColumnSm,{__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement(IconWrapper,{__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_Icon2.default,{icon:'social-icons',svgStyle:SocialIconsSmall,width:'58',height:'24',viewBox:'0 0 58 24',__source:{fileName:_jsxFileName,lineNumber:40}})),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:48}},'Carreiras'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:49}},'Mapa do site'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:50}},'Termos de uso'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:51}},'Mais carreiras'))),_react2.default.createElement(NavigationBottomItemSm,{__source:{fileName:_jsxFileName,lineNumber:54}},_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:55}},'Tem alguma d\xFAvida?'),_react2.default.createElement(_styles.TelephoneNumber,{__source:{fileName:_jsxFileName,lineNumber:56}},'0800 000 800'),_react2.default.createElement(_styles.NavigationText,{short:true,__source:{fileName:_jsxFileName,lineNumber:57}},'Estamos prontos para te atender 24h por dia, 7 dias por semana.')),_react2.default.createElement(NavigationBottomItemSm,{__source:{fileName:_jsxFileName,lineNumber:61}},_react2.default.createElement(_styles.NavigationLabel,{__source:{fileName:_jsxFileName,lineNumber:62}},'Baixe nossos apps'),_react2.default.createElement(_styles.AppsLinkContainer,{__source:{fileName:_jsxFileName,lineNumber:63}},_react2.default.createElement(_Icon2.default,{icon:'play-store',svgStyle:_styles.AppIcon,width:'110',height:'38',viewBox:'0 0 110 38',__source:{fileName:_jsxFileName,lineNumber:64}}),_react2.default.createElement(_Icon2.default,{icon:'app-store',svgStyle:_styles.AppIcon,width:'110',height:'38',viewBox:'0 0 110 38',__source:{fileName:_jsxFileName,lineNumber:65}}))));}exports.default=FooterNavigationSmall;// Extending styles for small breakpoint
var FooterNavigationSm=_styles.FooterNavigation.extend(_templateObject);var NavigationContentSm=_styles.NavigationContent.extend(_templateObject2);var NavigationBottomItemSm=_styles.NavigationBottomItem.extend(_templateObject3);var NavigationColumnSm=_styles.NavigationColumn.extend(_templateObject4);var VeloeLogoSmall=(0,_styledComponents.css)(['',' margin-bottom:40px;'],_styles.VeloeLogo);var SocialIconsSmall=(0,_styledComponents.css)(['',' margin-bottom:40px;'],_styles.SocialIcons);var IconWrapper=_styledComponents2.default.div.withConfig({displayName:'FooterNavigationSmall__IconWrapper',componentId:'sc-4sfav1-0'})(['padding:10px;']);module.exports=exports['default'];

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/Footer/FooterNavigationLarge.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _styles=__webpack_require__(406);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function FooterNavigationLarge(){return _react2.default.createElement(_styles.FooterNavigation,{__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement(_styles.LogoSocial,{__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(_Icon2.default,{icon:'veloe-logo',svgStyle:_styles.VeloeLogo,width:'74',height:'31',viewBox:'0 0 74 31',__source:{fileName:_jsxFileName,lineNumber:24}}),_react2.default.createElement(_Icon2.default,{icon:'social-icons',svgStyle:_styles.SocialIcons,width:'58',height:'24',viewBox:'0 0 58 24',__source:{fileName:_jsxFileName,lineNumber:25}})),_react2.default.createElement(_styles.NavigationContent,{__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_styles.NavigationColumn,{__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:35}},'Sobre a Veloe'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:36}},'Planos'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:37}},'Onde encontrar'),_react2.default.createElement(_styles.NavigationBottomItem,{__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement(_styles.NavigationLabel,{__source:{fileName:_jsxFileName,lineNumber:39}},'Baixe nossos apps'),_react2.default.createElement(_styles.AppsLinkContainer,{__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_Icon2.default,{icon:'play-store',svgStyle:_styles.AppIcon,width:'110',height:'38',viewBox:'0 0 110 38',__source:{fileName:_jsxFileName,lineNumber:41}}),_react2.default.createElement(_Icon2.default,{icon:'app-store',svgStyle:_styles.AppIcon,width:'110',height:'38',viewBox:'0 0 110 38',__source:{fileName:_jsxFileName,lineNumber:48}})))),_react2.default.createElement(_styles.NavigationColumn,{__source:{fileName:_jsxFileName,lineNumber:58}},_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:59}},'Ajuda'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:60}},'Imprensa'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:61}},'Carreiras')),_react2.default.createElement(_styles.NavigationColumn,{__source:{fileName:_jsxFileName,lineNumber:63}},_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:64}},'Mapa do site'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:65}},'Termos de uso'),_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:66}},'Mais carreiras'),_react2.default.createElement(_styles.NavigationBottomItem,{__source:{fileName:_jsxFileName,lineNumber:67}},_react2.default.createElement(_styles.NavigationLink,{__source:{fileName:_jsxFileName,lineNumber:68}},'Tem alguma d\xFAvida?'),_react2.default.createElement(_styles.TelephoneNumber,{__source:{fileName:_jsxFileName,lineNumber:69}},'0800 000 800'),_react2.default.createElement(_styles.NavigationText,{short:true,__source:{fileName:_jsxFileName,lineNumber:70}},'Estamos prontos para te atender 24h por dia, 7 dias por semana.')))));}exports.default=FooterNavigationLarge;module.exports=exports['default'];

/***/ }),
/* 2227 */
/***/ (function(module, exports) {

module.exports = {"subnavLinks":[{"label":"Resumo","link":"/minha-veloe/:id/resumo","id":"mnuSummary"},{"label":"Lançamentos","link":"/minha-veloe/:id/lancamentos","id":"mnuNews"},{"label":"Repasses","link":"/minha-veloe/:id/repasses","id":"mnuPass"}]}

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/DashboardResume/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(13);var _PlanResume=__webpack_require__(255);var _PlanResume2=_interopRequireDefault(_PlanResume);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _Hide=__webpack_require__(32);var _Hide2=_interopRequireDefault(_Hide);var _actions2=__webpack_require__(36);var _advertise=__webpack_require__(2229);var _advertise2=_interopRequireDefault(_advertise);var _contestations=__webpack_require__(2232);var _contestations2=_interopRequireDefault(_contestations);var _formSimple=__webpack_require__(2235);var _formSimple2=_interopRequireDefault(_formSimple);var _newPlaces=__webpack_require__(2236);var _newPlaces2=_interopRequireDefault(_newPlaces);var _receipts=__webpack_require__(2239);var _receipts2=_interopRequireDefault(_receipts);var _formSimple3=__webpack_require__(2248);var _formSimple4=_interopRequireDefault(_formSimple3);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DashboardResume=function(_Component){_inherits(DashboardResume,_Component);function DashboardResume(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DashboardResume);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DashboardResume.__proto__||Object.getPrototypeOf(DashboardResume)).call.apply(_ref,[this].concat(args))),_this),_this.onCarPlateQuery=function(values){_this.props.history.push('/minha-veloe/consultar-placa',values);},_this.onRequestFile=function(values){_this.props.history.push('/minha-veloe/solicitar-lista',values);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DashboardResume,[{key:'componentWillMount',value:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.props.setLoading(true);_context.next=3;return this.props.fetchResume(this.props.match.params.id);case 3:_context.next=5;return this.props.fetchMoneyTransfer();case 5:_context.next=7;return this.props.fetchContestations();case 7:case'end':return _context.stop();}}},_callee,this);}));function componentWillMount(){return _ref2.apply(this,arguments);}return componentWillMount;}()},{key:'render',value:function render(){var _props=this.props,contestations=_props.contestations,resume=_props.resume,moneyTransfer=_props.moneyTransfer;if(!resume||!resume.type)return null;var finantialData=resume.consumption||resume.balance||{};return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:50}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement(_gridStyled.Flex,{mt:[0,(0,_rem2.default)('35px')],align:'stretch',wrap:[true,false],__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_gridStyled.Box,{mb:(0,_rem2.default)('20px'),pr:[0,20],width:[1,3/12],__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_PlanResume2.default,{__source:{fileName:_jsxFileName,lineNumber:54}})),_react2.default.createElement(_gridStyled.Box,{pl:[0,20],width:[1,9/12],__source:{fileName:_jsxFileName,lineNumber:56}},_react2.default.createElement(_receipts2.default,{resume:resume,value:finantialData.cash||finantialData.spent,moneyTransfer:moneyTransfer,__source:{fileName:_jsxFileName,lineNumber:57}}))),_react2.default.createElement(_gridStyled.Flex,{mb:[0,(0,_rem2.default)('20px')],wrap:true,__source:{fileName:_jsxFileName,lineNumber:64}},_react2.default.createElement(_gridStyled.Box,{pr:[0,20],width:[1,3/12],mb:[2,0],__source:{fileName:_jsxFileName,lineNumber:65}},_react2.default.createElement(_contestations2.default,{data:contestations,__source:{fileName:_jsxFileName,lineNumber:66}})),_react2.default.createElement(_gridStyled.Box,{pr:[0,20],width:[1,4.5/12],mb:[2,0],__source:{fileName:_jsxFileName,lineNumber:68}},_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:69}},_react2.default.createElement(_formSimple2.default,{onSubmit:this.onCarPlateQuery,__source:{fileName:_jsxFileName,lineNumber:70}}))),_react2.default.createElement(_gridStyled.Box,{width:[1,4.5/12],mb:[2,0],__source:{fileName:_jsxFileName,lineNumber:73}},_react2.default.createElement(_Hide2.default,{at:'small',__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement(_formSimple4.default,{onSubmit:this.onRequestFile,__source:{fileName:_jsxFileName,lineNumber:75}})))),_react2.default.createElement(_gridStyled.Flex,{mb:(0,_rem2.default)('60px'),wrap:true,__source:{fileName:_jsxFileName,lineNumber:79}},_react2.default.createElement(_gridStyled.Box,{pr:[0,20],width:[1,3/12],mb:[2,0],__source:{fileName:_jsxFileName,lineNumber:80}},_react2.default.createElement(_newPlaces2.default,{__source:{fileName:_jsxFileName,lineNumber:81}})),_react2.default.createElement(_gridStyled.Box,{width:[1,9/12],__source:{fileName:_jsxFileName,lineNumber:83}},_react2.default.createElement(_advertise2.default,{__source:{fileName:_jsxFileName,lineNumber:84}})))));}}]);return DashboardResume;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref3){var reducer=_ref3.reducer;return{contestations:reducer.ecContestations,resume:reducer.dashboardResume,moneyTransfer:reducer.ecMoneyTransfer};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchResume:function fetchResume(planId){return dispatch((0,_actions.fetchDashboardResume)(planId)).then(function(){return dispatch((0,_actions2.setLoading)(false));});},fetchMoneyTransfer:function fetchMoneyTransfer(){return dispatch((0,_actions.fetchECMoneyTransfer)());},fetchContestations:function fetchContestations(){return dispatch((0,_actions.fetchECContestations)());},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DashboardResume);module.exports=exports['default'];

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/DashboardResume/advertise/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _data=__webpack_require__(2230);var _styles=__webpack_require__(2231);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Advertise=function Advertise(){return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:9}},_react2.default.createElement('header',{__source:{fileName:_jsxFileName,lineNumber:10}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:11}},_data.title),_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:12}},_data.subtitle)),_react2.default.createElement(_styles.ButtonContainer,{__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement(_Button2.default,{text:_data.button,__source:{fileName:_jsxFileName,lineNumber:15}})));};exports.default=Advertise;module.exports=exports['default'];

/***/ }),
/* 2230 */
/***/ (function(module, exports) {

module.exports = {"title":"Propaganda","subtitle":"Você deseja adicionar outra VeloeTag em sua conta? Clique em adicionar e veja que rápido de fazer.","button":"Link"}

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ButtonContainer=exports.Subtitle=exports.Title=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n    padding: 20px;\n  '],['\n    padding: 20px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    padding: 30px;\n  '],['\n    padding: 30px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    max-width: 50%;\n  '],['\n    max-width: 50%;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    max-width: 33%;\n  '],['\n    max-width: 33%;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-1t18glz-0'})(['background-color:',';border-radius:4.4px;display:flex;flex-direction:column;height:100%;justify-content:space-between;width:100%;',';',';'],_colors.offWhite,_media2.default.small(_templateObject),_media2.default.large(_templateObject2));var Title=exports.Title=_styledComponents2.default.p.withConfig({displayName:'styles__Title',componentId:'sc-1t18glz-1'})(['',';color:',';margin:0;'],_types.title24GalanoBold,_colors.linkNavyBlue);var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-1t18glz-2'})(['',';color:',';',';'],_types.txt14OpenSans,_colors.darkGrey,_media2.default.large(_templateObject3));var ButtonContainer=exports.ButtonContainer=_styledComponents2.default.div.withConfig({displayName:'styles__ButtonContainer',componentId:'sc-1t18glz-3'})(['margin-top:30px;',';'],_media2.default.large(_templateObject4));

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/DashboardResume/contestations/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _utils=__webpack_require__(95);var _data=__webpack_require__(2233);var _styles=__webpack_require__(2234);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CollapsedShowCount=5;var Contestations=function(_React$Component){_inherits(Contestations,_React$Component);function Contestations(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Contestations);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Contestations.__proto__||Object.getPrototypeOf(Contestations)).call.apply(_ref,[this].concat(args))),_this),_this.state={showAll:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Contestations,[{key:'render',value:function render(){var _this2=this;var data=this.props.data;var showAll=this.state.showAll;var columns=_data.tableConfig.columns;var showData=showAll?{text:_data.seeLess,count:data.length}:{text:_data.seeAll,count:CollapsedShowCount};return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_styles.Header,{__source:{fileName:_jsxFileName,lineNumber:38}},_react2.default.createElement(_styles.TotalValue,{__source:{fileName:_jsxFileName,lineNumber:39}},data.length),_react2.default.createElement(_styles.TotalText,{__source:{fileName:_jsxFileName,lineNumber:40}},_data.headerTitle)),data.length>0&&_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:43}},_react2.default.createElement(_styles.Table,{__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_styles.TableHeader,{__source:{fileName:_jsxFileName,lineNumber:45}},columns.map(function(column,index){return _react2.default.createElement(_styles.TableHeaderCell,{key:'contestations-header-'+index,width:column.width,__source:{fileName:_jsxFileName,lineNumber:47}},column.header);})),data.slice(0,showData.count).map(function(row,index){return _react2.default.createElement(_styles.TableRow,{key:'contestations-body-'+index,__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_styles.TableRowCell,{width:columns[0].width,__source:{fileName:_jsxFileName,lineNumber:54}},row.date),_react2.default.createElement(_styles.TableRowCell,{width:columns[1].width,__source:{fileName:_jsxFileName,lineNumber:55}},(0,_utils.currencyParser)(row.value)));})),_react2.default.createElement(_styles.SeeAllContainer,{onClick:function onClick(){return _this2.setState({showAll:!_this2.state.showAll});},__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_styles.SeeAll,{__source:{fileName:_jsxFileName,lineNumber:60}},showData.text),_react2.default.createElement(_styles.SeeAllIcon,{icon:'right-arrow',width:'8',height:'13',viewBox:'0 0 8 13',__source:{fileName:_jsxFileName,lineNumber:61}}))));}}]);return Contestations;}(_react2.default.Component);exports.default=Contestations;module.exports=exports['default'];

/***/ }),
/* 2233 */
/***/ (function(module, exports) {

module.exports = {"headerTitle":"Contestações não respondidas","seeLess":"ver menos","seeAll":"ver todas","tableConfig":{"columns":[{"header":"DATA","width":"40%"},{"header":"VALOR (R$)","width":"60%"}]}}

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SeeAllIcon=exports.SeeAll=exports.SeeAllContainer=exports.TableRowCell=exports.TableRow=exports.TableHeaderCell=exports.TableHeader=exports.Table=exports.TotalText=exports.TotalValue=exports.Header=exports.Container=undefined;var _templateObject=_taggedTemplateLiteral(['\n    padding: ',';\n  '],['\n    padding: ',';\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _Table=__webpack_require__(671);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-1bm883b-0'})(['background-color:',';border-radius:4.4px;height:100%;width:100%;'],_colors.offWhite);var Header=exports.Header=_styledComponents2.default.div.withConfig({displayName:'styles__Header',componentId:'sc-1bm883b-1'})(['padding:20px;']);var TotalValue=exports.TotalValue=_styledComponents2.default.p.withConfig({displayName:'styles__TotalValue',componentId:'sc-1bm883b-2'})(['',';color:',';margin:0;'],_types.title24GalanoBold,_colors.linkNavyBlue);var TotalText=exports.TotalText=_styledComponents2.default.p.withConfig({displayName:'styles__TotalText',componentId:'sc-1bm883b-3'})(['',';color:',';margin:0;'],_types.txt14OpenSans,_colors.darkGrey);var Table=exports.Table=(0,_styledComponents2.default)(_Table.BaseTable).withConfig({displayName:'styles__Table',componentId:'sc-1bm883b-4'})(['',';'],_media2.default.small(_templateObject,(0,_rem2.default)('16px')));var TableHeader=exports.TableHeader=(0,_styledComponents2.default)(_Table.BaseTableHeader).withConfig({displayName:'styles__TableHeader',componentId:'sc-1bm883b-5'})(['height:40px;']);var TableHeaderCell=exports.TableHeaderCell=(0,_styledComponents2.default)(_Table.BaseTableHeaderCell).withConfig({displayName:'styles__TableHeaderCell',componentId:'sc-1bm883b-6'})(['',';color:',';padding:0 10px;'],_types.txt12OpenSans,_colors.graySuit);var TableRow=exports.TableRow=(0,_styledComponents2.default)(_Table.BaseTableRow).withConfig({displayName:'styles__TableRow',componentId:'sc-1bm883b-7'})(['height:40px;']);var TableRowCell=exports.TableRowCell=(0,_styledComponents2.default)(_Table.BaseTableRowCell).withConfig({displayName:'styles__TableRowCell',componentId:'sc-1bm883b-8'})(['',';color:',';padding:0 10px;'],_types.txt12OpenSansBold,_colors.linkNavyBlue);var SeeAllContainer=exports.SeeAllContainer=_styledComponents2.default.div.withConfig({displayName:'styles__SeeAllContainer',componentId:'sc-1bm883b-9'})(['cursor:pointer;display:flex;flex-direction:row;padding:28px 20px;']);var SeeAll=exports.SeeAll=_styledComponents2.default.p.withConfig({displayName:'styles__SeeAll',componentId:'sc-1bm883b-10'})(['',';color:',';margin:0;padding-right:10px;'],_types.txt14OpenSansBold,_colors.linkNavyBlue);var SeeAllIcon=exports.SeeAllIcon=(0,_styledComponents2.default)(_Icon2.default).withConfig({displayName:'styles__SeeAllIcon',componentId:'sc-1bm883b-11'})(['margin:auto 0;']);

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/CarPlateQuery/form-simple.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _reduxForm=__webpack_require__(11);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _actions=__webpack_require__(13);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _data=__webpack_require__(268);var _formFields=__webpack_require__(670);var _styles=__webpack_require__(190);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var dateFormat='DD/MM/YYYY';var CarPlateForm=function(_React$Component){_inherits(CarPlateForm,_React$Component);function CarPlateForm(props){_classCallCheck(this,CarPlateForm);var _this=_possibleConstructorReturn(this,(CarPlateForm.__proto__||Object.getPrototypeOf(CarPlateForm)).call(this,props));var today=(0,_moment2.default)().format(dateFormat);_this.initialValues={periodInitDate:today,periodEndDate:today};return _this;}_createClass(CarPlateForm,[{key:'componentWillMount',value:function componentWillMount(){this.props.initialize(_extends({},this.initialValues,this.props.formValues));}},{key:'componentDidMount',value:function componentDidMount(){this.props.fetchLocations();}},{key:'render',value:function render(){var _props=this.props,handleSubmit=_props.handleSubmit,locations=_props.locations;return _react2.default.createElement(_styles.FormSimpleContent,{__source:{fileName:_jsxFileName,lineNumber:47}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:48}},_react2.default.createElement(_styles.CarPlateQueryTitle,{__source:{fileName:_jsxFileName,lineNumber:49}},_data.queryPlateTitle),_react2.default.createElement(_styles.CarPlateQuerySubtitle,{__source:{fileName:_jsxFileName,lineNumber:50}},_data.queryPlateSubtitle),_react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,__source:{fileName:_jsxFileName,lineNumber:53}},_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:54}},_react2.default.createElement(_formFields.LocationField,{locations:locations,__source:{fileName:_jsxFileName,lineNumber:55}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_formFields.PlateField,{__source:{fileName:_jsxFileName,lineNumber:58}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement('div',{style:{display:'flex',direction:'row'},__source:{fileName:_jsxFileName,lineNumber:61}},_react2.default.createElement(_gridStyled.Box,{width:1/2,__source:{fileName:_jsxFileName,lineNumber:62}},_react2.default.createElement(_formFields.PeriodInitDateField,{dateFormat:dateFormat,__source:{fileName:_jsxFileName,lineNumber:63}})),_react2.default.createElement(_styles.Divider,{__source:{fileName:_jsxFileName,lineNumber:65}}),_react2.default.createElement(_gridStyled.Box,{width:1/2,__source:{fileName:_jsxFileName,lineNumber:66}},_react2.default.createElement(_formFields.PeriodEndDateField,{dateFormat:dateFormat,__source:{fileName:_jsxFileName,lineNumber:67}})))),_react2.default.createElement(_gridStyled.Box,{width:1,__source:{fileName:_jsxFileName,lineNumber:71}},_react2.default.createElement(_styles.SimpleFormQueryButtonContainer,{__source:{fileName:_jsxFileName,lineNumber:72}},_react2.default.createElement(_Button2.default,{text:_data.labels.submitButton,type:'submit',__source:{fileName:_jsxFileName,lineNumber:73}})))))));}}]);return CarPlateForm;}(_react2.default.Component);var mapStateToProps=function mapStateToProps(_ref){var reducer=_ref.reducer;return{saving:reducer.formState.saving,locations:reducer.ecLocations};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchLocations:function fetchLocations(){return dispatch((0,_actions.fetchECLocations)());}};};var form=(0,_reduxForm.reduxForm)({form:'carPlateForm',destroyOnUnmount:false})(CarPlateForm);exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(form);module.exports=exports['default'];

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/DashboardResume/newPlaces/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _data=__webpack_require__(2237);var _styles=__webpack_require__(2238);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var NewPlaces=function NewPlaces(){return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:7}},_react2.default.createElement('header',{__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:9}},_data.title),_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:10}},_data.subtitle)),_react2.default.createElement(_styles.SeeMoreContainer,{__source:{fileName:_jsxFileName,lineNumber:12}},_react2.default.createElement(_styles.SeeMore,{__source:{fileName:_jsxFileName,lineNumber:13}},_data.seeMore),_react2.default.createElement(_styles.SeeMoreIcon,{icon:'right-arrow',width:'8',height:'13',viewBox:'0 0 8 13',__source:{fileName:_jsxFileName,lineNumber:14}})));};exports.default=NewPlaces;module.exports=exports['default'];

/***/ }),
/* 2237 */
/***/ (function(module, exports) {

module.exports = {"title":"Novos lugares disponíveis","subtitle":"A Veloe acaba de fechar uma parceria com os Postos Shell. Mais uma comodidade .","seeMore":"Saiba mais"}

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.SeeMoreIcon=exports.SeeMore=exports.SeeMoreContainer=exports.Subtitle=exports.Title=exports.Container=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _Icon=__webpack_require__(30);var _Icon2=_interopRequireDefault(_Icon);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Container=exports.Container=_styledComponents2.default.section.withConfig({displayName:'styles__Container',componentId:'sc-1l5vb36-0'})(['background-color:',';border-radius:4.4px;display:flex;flex-direction:column;height:100%;justify-content:space-between;padding:20px;width:100%;'],_colors.offWhite);var Title=exports.Title=_styledComponents2.default.p.withConfig({displayName:'styles__Title',componentId:'sc-1l5vb36-1'})(['',';color:',';margin:0;'],_types.title24GalanoBold,_colors.linkNavyBlue);var Subtitle=exports.Subtitle=_styledComponents2.default.p.withConfig({displayName:'styles__Subtitle',componentId:'sc-1l5vb36-2'})(['',';color:',';'],_types.txt14OpenSans,_colors.darkGrey);var SeeMoreContainer=exports.SeeMoreContainer=_styledComponents2.default.div.withConfig({displayName:'styles__SeeMoreContainer',componentId:'sc-1l5vb36-3'})(['cursor:pointer;display:flex;flex-direction:row;']);var SeeMore=exports.SeeMore=_styledComponents2.default.p.withConfig({displayName:'styles__SeeMore',componentId:'sc-1l5vb36-4'})(['',';color:',';margin:0;padding-right:10px;'],_types.txt14OpenSansBold,_colors.linkNavyBlue);var SeeMoreIcon=exports.SeeMoreIcon=(0,_styledComponents2.default)(_Icon2.default).withConfig({displayName:'styles__SeeMoreIcon',componentId:'sc-1l5vb36-5'})(['margin:auto 0;']);

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/DashboardResume/receipts/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _aleloLogic=__webpack_require__(12);var _chart=__webpack_require__(2240);var _chart2=_interopRequireDefault(_chart);var _table=__webpack_require__(2243);var _table2=_interopRequireDefault(_table);var _data=__webpack_require__(2246);var _styles=__webpack_require__(2247);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var currencyParser=_aleloLogic.utils.currencyParser;var DashboardCashDisplay=function DashboardCashDisplay(_ref){var resume=_ref.resume,value=_ref.value,moneyTransfer=_ref.moneyTransfer;return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:13}},_react2.default.createElement(_styles.CashDisplay,{__source:{fileName:_jsxFileName,lineNumber:14}},_react2.default.createElement(_styles.Text,{__source:{fileName:_jsxFileName,lineNumber:15}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:16}},_data.title)),_react2.default.createElement(_gridStyled.Flex,{display:'flex',direction:['column','row'],justify:'space-between',__source:{fileName:_jsxFileName,lineNumber:19}},_react2.default.createElement(_styles.Currency,{__source:{fileName:_jsxFileName,lineNumber:20}},currencyParser(value)))),_react2.default.createElement(_chart2.default,{consumption:resume.consumption,__source:{fileName:_jsxFileName,lineNumber:23}}),_react2.default.createElement(_table2.default,{data:moneyTransfer,__source:{fileName:_jsxFileName,lineNumber:24}}));};exports.default=DashboardCashDisplay;module.exports=exports['default'];

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/DashboardResume/receipts/chart/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _colors=__webpack_require__(2);var _ConsumptionChartBar=__webpack_require__(617);var _ConsumptionChartBar2=_interopRequireDefault(_ConsumptionChartBar);var _ConsumptionChartIndicator=__webpack_require__(618);var _ConsumptionChartIndicator2=_interopRequireDefault(_ConsumptionChartIndicator);var _data=__webpack_require__(2241);var _styles=__webpack_require__(2242);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var currencyParser=_aleloLogic.utils.currencyParser;var colors=[_colors.yellowGreen,_colors.eletricViolet];var toPercentage=function toPercentage(value,total){var decimal=value/total;return decimal*100;};var calculateDataPercentage=function calculateDataPercentage(){var dataArray=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var maxValue=arguments[1];if(maxValue){return dataArray.map(function(data){return toPercentage(data,maxValue);});}var total=dataArray.reduce(function(data,nextData){return data+nextData;},0);return dataArray.map(function(data){return toPercentage(data,total);});};var ConsumptionChart=function ConsumptionChart(_ref){var consumption=_ref.consumption;var consumptionTypes=Object.keys(_data.chartData);var consumptionValues=consumptionTypes.map(function(consumptionType){return _data.chartData[consumptionType];});var dataPercentage=calculateDataPercentage(consumptionValues,consumption&&consumption.limit)||[];var totalPercentage=dataPercentage.reduce(function(percentage,nextData){return percentage+nextData;},0);return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:37}},_react2.default.createElement(_ConsumptionChartBar2.default,{colors:colors,values:dataPercentage,__source:{fileName:_jsxFileName,lineNumber:38}}),consumption&&_react2.default.createElement(_styles.Usage,{__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:42}},totalPercentage,'%'),_react2.default.createElement('span',{__source:{fileName:_jsxFileName,lineNumber:44}},'De ',currencyParser(consumption.limit,'R$ '))),_react2.default.createElement(_styles.IndicatorList,{__source:{fileName:_jsxFileName,lineNumber:47}},consumptionTypes.map(function(indicator,index){return _react2.default.createElement(_styles.IndicatorItem,{key:indicator,__source:{fileName:_jsxFileName,lineNumber:49}},_react2.default.createElement(_ConsumptionChartIndicator2.default,{name:_data.indicatorLabel[indicator],color:colors[index],value:currencyParser(_data.chartData[indicator]),__source:{fileName:_jsxFileName,lineNumber:50}}));}),_react2.default.createElement(_styles.IndicatorItem,{__source:{fileName:_jsxFileName,lineNumber:57}},_react2.default.createElement(_styles.TextWithoutMargins,{__source:{fileName:_jsxFileName,lineNumber:58}},_data.totalLabel))));};exports.default=ConsumptionChart;module.exports=exports['default'];

/***/ }),
/* 2241 */
/***/ (function(module, exports) {

module.exports = {"totalLabel":"De R$ 13.500,00","indicatorLabel":{"received":"Total recebido","toReceive":"Total a receber"},"chartData":{"received":9000,"toReceive":4500}}

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.IndicatorItem=exports.IndicatorList=exports.TextWithoutMargins=exports.Text=exports.Usage=undefined;var _templateObject=_taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    margin-top: 20px;\n  '],['\n    display: flex;\n    flex-direction: row;\n    margin-top: 20px;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    display: flex;\n    justify-content: space-between;\n    margin-top: ',';\n  '],['\n    display: flex;\n    justify-content: space-between;\n    margin-top: ',';\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    display: inline-flex;\n    width: 33%;\n  '],['\n    display: inline-flex;\n    width: 33%;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var textStyles='\n  font-family: OpenSans;\n  font-size: '+(0,_rem2.default)('12px')+';\n  letter-spacing: '+(0,_rem2.default)('1px')+';\n  color: '+_colors.darkGrey+';\n  font-weight: 200;\n  text-transform: uppercase;\n';var Usage=exports.Usage=_styledComponents2.default.p.withConfig({displayName:'styles__Usage',componentId:'sc-fozk4l-0'})(['',';margin-top:0;display:flex;justify-content:space-between;span{font-family:OpenSans;font-size:',';font-weight:400;line-height:1.57;color:',';text-transform:none;margin-top:',';:first-child{font-family:Galano;font-size:',';font-weight:bold;}}'],textStyles,(0,_rem2.default)('14px'),_colors.darkGrey,(0,_rem2.default)('7px'),(0,_rem2.default)('18px'));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-fozk4l-1'})(['',';'],textStyles);var TextWithoutMargins=exports.TextWithoutMargins=(0,_styledComponents2.default)(Text).withConfig({displayName:'styles__TextWithoutMargins',componentId:'sc-fozk4l-2'})(['margin:0px;']);var IndicatorList=exports.IndicatorList=_styledComponents2.default.ul.withConfig({displayName:'styles__IndicatorList',componentId:'sc-fozk4l-3'})(['list-style:none;padding:0;margin:0;',';',';'],_media2.default.small(_templateObject),_media2.default.large(_templateObject2,(0,_rem2.default)('12px')));var IndicatorItem=exports.IndicatorItem=_styledComponents2.default.li.withConfig({displayName:'styles__IndicatorItem',componentId:'sc-fozk4l-4'})(['',';'],_media2.default.small(_templateObject3));

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/DashboardResume/receipts/table/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _utils=__webpack_require__(95);var _mediaQuery=__webpack_require__(633);var _styles=__webpack_require__(2244);var _data=__webpack_require__(2245);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Index=function Index(_ref){var data=_ref.data;var columns=_data.tableConfig.columns;if((0,_mediaQuery.isMobile)()){return _react2.default.createElement(MobileTable,{data:data,__source:{fileName:_jsxFileName,lineNumber:21}});}else{return _react2.default.createElement(_styles.Table,{__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement(_styles.TableHeader,{__source:{fileName:_jsxFileName,lineNumber:25}},columns.map(function(column,index){return column.type==='action'?_react2.default.createElement(_styles.TableHeaderActionCell,{index:index,key:'money-transfer-header-'+index,width:column.width,__source:{fileName:_jsxFileName,lineNumber:29}},column.header):_react2.default.createElement(_styles.TableHeaderCell,{index:index,key:'money-transfer-header-'+index,width:column.width,__source:{fileName:_jsxFileName,lineNumber:37}},column.header);})),data.map(function(row,index){return _react2.default.createElement(_styles.TableRow,{key:'money-transfer-body-'+index,index:index,__source:{fileName:_jsxFileName,lineNumber:48}},_react2.default.createElement(_styles.TableRowBoldCell,{width:columns[0].width,__source:{fileName:_jsxFileName,lineNumber:49}},row.date),_react2.default.createElement(_styles.TableRowBoldCell,{width:columns[1].width,__source:{fileName:_jsxFileName,lineNumber:50}},(0,_utils.currencyParser)(row.value)),_react2.default.createElement(_styles.TableRowCell,{width:columns[2].width,__source:{fileName:_jsxFileName,lineNumber:53}},row.status),_react2.default.createElement(_styles.TableRowActionCell,{width:columns[3].width,__source:{fileName:_jsxFileName,lineNumber:54}},'ver transa\xE7\xF5es'));}));}};var MobileTable=function MobileTable(_ref2){var data=_ref2.data;return _react2.default.createElement(_styles.Table,{__source:{fileName:_jsxFileName,lineNumber:64}},_react2.default.createElement(_styles.TableHeader,{__source:{fileName:_jsxFileName,lineNumber:65}},_react2.default.createElement(_styles.TableHeaderCell,{key:'money-transfer-header-2',width:50,__source:{fileName:_jsxFileName,lineNumber:66}},'REPASSES'),_react2.default.createElement(_styles.TableHeaderActionCell,{key:'money-transfer-header-1',width:50,__source:{fileName:_jsxFileName,lineNumber:69}},'Ver mais >')),data.map(function(row,index){return _react2.default.createElement(_styles.TableRow,{key:'money-transfer-body-'+index,index:index,style:{justifyContent:'space-between'},__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement(_styles.TableRowBoldCell,{width:33,__source:{fileName:_jsxFileName,lineNumber:79}},row.date),_react2.default.createElement(_styles.TableRowBoldCell,{width:33,__source:{fileName:_jsxFileName,lineNumber:80}},(0,_utils.currencyParser)(row.value)),_react2.default.createElement(_styles.TableRowCell,{width:33,__source:{fileName:_jsxFileName,lineNumber:81}},row.status));}));};exports.default=Index;module.exports=exports['default'];

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TableRowActionCell=exports.TableRowBoldCell=exports.TableRowCell=exports.TableRow=exports.TableHeaderActionCell=exports.TableHeaderCell=exports.TableHeader=exports.Table=undefined;var _templateObject=_taggedTemplateLiteral(['\n    padding: ',';\n  '],['\n    padding: ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    margin: 40px 0px;\n  '],['\n    margin: 40px 0px;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    justify-content: space-between;\n  '],['\n    justify-content: space-between;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);var _Table=__webpack_require__(671);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Table=exports.Table=(0,_styledComponents2.default)(_Table.BaseTable).withConfig({displayName:'styles__Table',componentId:'sc-4ooayr-0'})(['max-width:700px;',';',';'],_media2.default.small(_templateObject,(0,_rem2.default)('16px')),_media2.default.large(_templateObject2));var TableHeader=exports.TableHeader=(0,_styledComponents2.default)(_Table.BaseTableHeader).withConfig({displayName:'styles__TableHeader',componentId:'sc-4ooayr-1'})(['height:40px;',';'],_media2.default.small(_templateObject3));var TableHeaderCell=exports.TableHeaderCell=(0,_styledComponents2.default)(_Table.BaseTableHeaderCell).withConfig({displayName:'styles__TableHeaderCell',componentId:'sc-4ooayr-2'})(['',';color:',';'],_types.txt12OpenSansBold,_colors.graySuit);var TableHeaderActionCell=exports.TableHeaderActionCell=(0,_styledComponents2.default)(TableHeaderCell).withConfig({displayName:'styles__TableHeaderActionCell',componentId:'sc-4ooayr-3'})(['',';color:',';text-align:right;'],_types.txt12OpenSansBold,_colors.linkNavyBlue);var TableRow=exports.TableRow=(0,_styledComponents2.default)(_Table.BaseTableRow).withConfig({displayName:'styles__TableRow',componentId:'sc-4ooayr-4'})(['height:40px;',';'],function(_ref){var index=_ref.index;return'background-color: '+(index%2===0?_colors.white:_colors.ghostWhite)+';';});var TableRowCell=exports.TableRowCell=(0,_styledComponents2.default)(_Table.BaseTableRowCell).withConfig({displayName:'styles__TableRowCell',componentId:'sc-4ooayr-5'})(['',';color:',';'],_types.txt12OpenSans,_colors.linkNavyBlue);var TableRowBoldCell=exports.TableRowBoldCell=(0,_styledComponents2.default)(TableRowCell).withConfig({displayName:'styles__TableRowBoldCell',componentId:'sc-4ooayr-6'})(['',';'],_types.txt12OpenSansBold);var TableRowActionCell=exports.TableRowActionCell=(0,_styledComponents2.default)(TableRowBoldCell).withConfig({displayName:'styles__TableRowActionCell',componentId:'sc-4ooayr-7'})(['text-align:right;']);

/***/ }),
/* 2245 */
/***/ (function(module, exports) {

module.exports = {"tableConfig":{"columns":[{"header":"DATA DO REPASSE","type":"bold","width":"30%"},{"header":"VALOR (R$)","type":"bold","width":"25%"},{"header":"STATUS","type":"normal","width":"25%"},{"header":"Ver mais","type":"action","width":"20%"}]}}

/***/ }),
/* 2246 */
/***/ (function(module, exports) {

module.exports = {"title":"Total a receber (R$) em out/17 19:32 - 22/10/17"}

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Currency=exports.Text=exports.CashDisplay=undefined;var _templateObject=_taggedTemplateLiteral(['\n        display: flex;\n        justify-content: space-between;\n    '],['\n        display: flex;\n        justify-content: space-between;\n    ']),_templateObject2=_taggedTemplateLiteral(['\n            display: inline;\n\n            :after {\n                content: " \u2022 "\n            }\n        '],['\n            display: inline;\n\n            :after {\n                content: " \u2022 "\n            }\n        ']),_templateObject3=_taggedTemplateLiteral(['\n        ',';\n        text-align: left;\n        margin-top: ',';\n    '],['\n        ',';\n        text-align: left;\n        margin-top: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CashDisplay=exports.CashDisplay=_styledComponents2.default.section.withConfig({displayName:'styles__CashDisplay',componentId:'sc-1dzoagz-0'})(['margin-bottom:17px;',';'],_media2.default.small(_templateObject));var Text=exports.Text=_styledComponents2.default.p.withConfig({displayName:'styles__Text',componentId:'sc-1dzoagz-1'})(['',';color:',';margin:0;text-transform:uppercase;span{display:block;',';}'],_types.txt12OpenSansLight,_colors.darkGrey,_media2.default.large(_templateObject2));var Currency=exports.Currency=_styledComponents2.default.p.withConfig({displayName:'styles__Currency',componentId:'sc-1dzoagz-2'})(['',';color:',';margin:0;text-align:right;',';'],_types.title24GalanoBold,_colors.linkNavyBlue,_media2.default.large(_templateObject3,_types.title40GalanoBold,(0,_rem2.default)('10')));

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/RequestFile/form-simple.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _reduxForm=__webpack_require__(11);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _data=__webpack_require__(407);var _formFields=__webpack_require__(672);var _styles=__webpack_require__(269);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RequestFileForm=function(_React$Component){_inherits(RequestFileForm,_React$Component);function RequestFileForm(){_classCallCheck(this,RequestFileForm);return _possibleConstructorReturn(this,(RequestFileForm.__proto__||Object.getPrototypeOf(RequestFileForm)).apply(this,arguments));}_createClass(RequestFileForm,[{key:'componentWillMount',value:function componentWillMount(){this.props.initialize();}},{key:'render',value:function render(){var _props=this.props,handleSubmit=_props.handleSubmit,saving=_props.saving;return _react2.default.createElement(_styles.FormSimpleContent,{__source:{fileName:_jsxFileName,lineNumber:27}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_styles.RequestFileFormTitle,{__source:{fileName:_jsxFileName,lineNumber:29}},_data.simpleForm.title),_react2.default.createElement(_styles.RequestFileFormSubtitle,{__source:{fileName:_jsxFileName,lineNumber:30}},_data.simpleForm.subtitle),_react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_formFields.FileTypeField,{fileTypes:_data.fileTypes,saving:saving,__source:{fileName:_jsxFileName,lineNumber:34}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:36}},_react2.default.createElement(_formFields.SequentialField,{saving:saving,__source:{fileName:_jsxFileName,lineNumber:37}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:3,__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_styles.SimpleFormQueryButtonContainer,{__source:{fileName:_jsxFileName,lineNumber:40}},_react2.default.createElement(_Button2.default,{text:_data.labels.submitButton,type:'submit',disabled:saving,__source:{fileName:_jsxFileName,lineNumber:41}})))))));}}]);return RequestFileForm;}(_react2.default.Component);var form=(0,_reduxForm.reduxForm)({form:'fileRequestForm',destroyOnUnmount:false})(RequestFileForm);var mapStateToProps=function mapStateToProps(_ref){var reducer=_ref.reducer;return{saving:reducer.formState.saving};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(form);module.exports=exports['default'];

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateLayout=__webpack_require__(362);var _TemplateLayout2=_interopRequireDefault(_TemplateLayout);var _RequestFile=__webpack_require__(2250);var _RequestFile2=_interopRequireDefault(_RequestFile);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/solicitar-lista',component:_TemplateLayout2.default,routes:[{path:'/minha-veloe/solicitar-lista',exact:true,component:_RequestFile2.default}]};module.exports=exports['default'];

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/RequestFile/index.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _moment=__webpack_require__(19);var _moment2=_interopRequireDefault(_moment);var _actions=__webpack_require__(13);var _header=__webpack_require__(2251);var _header2=_interopRequireDefault(_header);var _form=__webpack_require__(2252);var _form2=_interopRequireDefault(_form);var _table=__webpack_require__(2253);var _table2=_interopRequireDefault(_table);var _styles=__webpack_require__(269);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RequestFile=function(_React$Component){_inherits(RequestFile,_React$Component);function RequestFile(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RequestFile);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RequestFile.__proto__||Object.getPrototypeOf(RequestFile)).call.apply(_ref,[this].concat(args))),_this),_this.state={requestedFiles:[]},_this.onFormSubmit=function(values){var request=_extends({},values);var current=(0,_moment2.default)();request.date=current.format('DD/MM/YYYY');request.hour=current.format('hh:mma');request.status='Processando';_this.setState({requestedFiles:[request].concat(_this.state.requestedFiles)});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RequestFile,[{key:'componentDidMount',value:function componentDidMount(){this.props.fetchECRequestFileHistory();}},{key:'componentWillMount',value:function componentWillMount(){var state=this.props.history.location.state;if(state)this.onFormSubmit(state);}},{key:'render',value:function render(){var requestedFiles=this.state.requestedFiles;var requestFileHistory=this.props.requestFileHistory;return _react2.default.createElement(_styles.Main,{__source:{fileName:_jsxFileName,lineNumber:41}},_react2.default.createElement(_header2.default,{__source:{fileName:_jsxFileName,lineNumber:42}}),_react2.default.createElement(_form2.default,{onSubmit:this.onFormSubmit,__source:{fileName:_jsxFileName,lineNumber:43}}),_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:44}},_react2.default.createElement(_styles.SubHeader,{__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement(_styles.TableTitle,{__source:{fileName:_jsxFileName,lineNumber:46}},'Acompanhe o status da sua solicita\xE7\xE3o.')),_react2.default.createElement(_table2.default,{data:requestedFiles.concat(requestFileHistory),__source:{fileName:_jsxFileName,lineNumber:48}})));}}]);return RequestFile;}(_react2.default.Component);var mapStateToProps=function mapStateToProps(_ref2){var reducer=_ref2.reducer;return{requestFileHistory:reducer.ecRequestFileHistory};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchECRequestFileHistory:function fetchECRequestFileHistory(){return dispatch((0,_actions.fetchECRequestFileHistory)());}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(RequestFile));module.exports=exports['default'];

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/RequestFile/header.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _styles=__webpack_require__(269);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Header=function Header(){return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:6}},_react2.default.createElement(_reactHelmet2.default,{title:'Solicitar Lista',__source:{fileName:_jsxFileName,lineNumber:7}}),_react2.default.createElement(_styles.SubHeader,{__source:{fileName:_jsxFileName,lineNumber:8}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:9}},'Solicitar lista'),_react2.default.createElement(_styles.Subtitle,{__source:{fileName:_jsxFileName,lineNumber:10}},'Escolha o tipo de arquivo para exportar os dados e preencha o n\xFAmero sequencial que deseja.')));};exports.default=Header;module.exports=exports['default'];

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/RequestFile/form.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _reduxForm=__webpack_require__(11);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _data=__webpack_require__(407);var _formFields=__webpack_require__(672);var _styles=__webpack_require__(269);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RequestFileForm=function(_React$Component){_inherits(RequestFileForm,_React$Component);function RequestFileForm(){_classCallCheck(this,RequestFileForm);return _possibleConstructorReturn(this,(RequestFileForm.__proto__||Object.getPrototypeOf(RequestFileForm)).apply(this,arguments));}_createClass(RequestFileForm,[{key:'componentWillMount',value:function componentWillMount(){this.props.initialize();}},{key:'render',value:function render(){var _props=this.props,handleSubmit=_props.handleSubmit,saving=_props.saving;return _react2.default.createElement(_styles.FormContent,{__source:{fileName:_jsxFileName,lineNumber:21}},_react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:22}},_react2.default.createElement('form',{onSubmit:handleSubmit,__source:{fileName:_jsxFileName,lineNumber:23}},_react2.default.createElement(_gridStyled.Flex,{wrap:true,__source:{fileName:_jsxFileName,lineNumber:24}},_react2.default.createElement(_gridStyled.Box,{width:[1,3/12],mb:3,mr:3,__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement(_formFields.FileTypeField,{fileTypes:_data.fileTypes,saving:saving,__source:{fileName:_jsxFileName,lineNumber:26}})),_react2.default.createElement(_gridStyled.Box,{width:[1,3/12],mb:[3,0],mr:3,__source:{fileName:_jsxFileName,lineNumber:28}},_react2.default.createElement(_formFields.SequentialField,{saving:saving,__source:{fileName:_jsxFileName,lineNumber:29}})),_react2.default.createElement(_gridStyled.Box,{width:[1,2/12],pl:[0,3],__source:{fileName:_jsxFileName,lineNumber:31}},_react2.default.createElement(_styles.QueryButtonContainer,{__source:{fileName:_jsxFileName,lineNumber:32}},_react2.default.createElement(_Button2.default,{text:_data.labels.submitButton,type:'submit',disabled:saving,__source:{fileName:_jsxFileName,lineNumber:33}})))))));}}]);return RequestFileForm;}(_react2.default.Component);var form=(0,_reduxForm.reduxForm)({form:'fileRequestForm',destroyOnUnmount:false})(RequestFileForm);var mapStateToProps=function mapStateToProps(_ref){var reducer=_ref.reducer;return{saving:reducer.formState.saving};};exports.default=(0,_reactRedux.connect)(mapStateToProps)(form);module.exports=exports['default'];

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ec/RequestFile/table/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _styles=__webpack_require__(2254);var _data=__webpack_require__(2255);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Index=function Index(_ref){var data=_ref.data;var columns=_data.tableConfig.columns;return _react2.default.createElement(_styles.Table,{__source:{fileName:_jsxFileName,lineNumber:17}},_react2.default.createElement(_styles.TableHeader,{__source:{fileName:_jsxFileName,lineNumber:18}},columns.map(function(column,index){return _react2.default.createElement(_styles.TableHeaderCell,_extends({key:'request-file-header-'+index},column,{__source:{fileName:_jsxFileName,lineNumber:20}}),column.header);})),data.map(function(row,index){return _react2.default.createElement(_styles.TableRow,{key:'request-file-body-'+index,index:index,__source:{fileName:_jsxFileName,lineNumber:26}},_react2.default.createElement(_styles.TableRowCell,_extends({},columns[0],{__source:{fileName:_jsxFileName,lineNumber:27}}),row.date),_react2.default.createElement(_styles.TableRowCell,_extends({},columns[1],{__source:{fileName:_jsxFileName,lineNumber:28}}),row.hour),_react2.default.createElement(_styles.TableRowCellBold,_extends({},columns[2],{__source:{fileName:_jsxFileName,lineNumber:29}}),row.fileType),_react2.default.createElement(_styles.TableRowCell,_extends({},columns[3],{__source:{fileName:_jsxFileName,lineNumber:30}}),row.sequential),_react2.default.createElement(_styles.TableRowCellBold,_extends({},columns[4],{__source:{fileName:_jsxFileName,lineNumber:31}}),row.status));}));};exports.default=Index;module.exports=exports['default'];

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.TableRowCellBold=exports.TableRowCell=exports.TableRow=exports.TableHeaderCell=exports.TableHeader=exports.TableCell=exports.Table=undefined;var _templateObject=_taggedTemplateLiteral(['\n        padding: ',';\n    '],['\n        padding: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        margin: 40px 0px;\n    '],['\n        margin: 40px 0px;\n    ']),_templateObject3=_taggedTemplateLiteral(['\n        ',';\n        ',';\n    '],['\n        ',';\n        ',';\n    ']),_templateObject4=_taggedTemplateLiteral(['\n        ',';\n    '],['\n        ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Table=exports.Table=_styledComponents2.default.div.withConfig({displayName:'styles__Table',componentId:'sc-1jvyhle-0'})(['display:flex;flex-direction:column;width:100%;max-width:960px;',';',';'],_media2.default.small(_templateObject,(0,_rem2.default)('16px')),_media2.default.large(_templateObject2));var TableCell=exports.TableCell=_styledComponents2.default.p.withConfig({displayName:'styles__TableCell',componentId:'sc-1jvyhle-1'})(['display:inline-block;overflow:hidden;',';',';'],_media2.default.small(_templateObject3,function(_ref){var mobileWidth=_ref.mobileWidth,width=_ref.width;return'width: '+(mobileWidth||width)+';';},function(_ref2){var showInMobile=_ref2.showInMobile;return'display: '+(showInMobile?'inline-block':'none')+';';}),_media2.default.large(_templateObject4,function(_ref3){var width=_ref3.width;return'width: '+width+';';}));var TableHeader=exports.TableHeader=_styledComponents2.default.div.withConfig({displayName:'styles__TableHeader',componentId:'sc-1jvyhle-2'})(['border-top:1px solid ',';border-bottom:1px solid ',';display:flex;flex-direction:row;height:40px;width:100%;'],_colors.paleGrayTwo,_colors.paleGrayTwo);var TableHeaderCell=exports.TableHeaderCell=(0,_styledComponents2.default)(TableCell).withConfig({displayName:'styles__TableHeaderCell',componentId:'sc-1jvyhle-3'})(['',' margin:10px;color:',';'],_types.txt12OpenSansBold,_colors.graySuit);var TableRow=exports.TableRow=_styledComponents2.default.div.withConfig({displayName:'styles__TableRow',componentId:'sc-1jvyhle-4'})(['display:flex;flex-direction:row;height:40px;width:100%;',';'],function(_ref4){var index=_ref4.index;return'background-color: '+(index%2===0?_colors.white:_colors.ghostWhite)+';';});var TableRowCell=exports.TableRowCell=(0,_styledComponents2.default)(TableCell).withConfig({displayName:'styles__TableRowCell',componentId:'sc-1jvyhle-5'})(['',' margin:10px;color:',';white-space:nowrap;'],_types.txt14OpenSans,_colors.linkNavyBlue);var TableRowCellBold=exports.TableRowCellBold=(0,_styledComponents2.default)(TableRowCell).withConfig({displayName:'styles__TableRowCellBold',componentId:'sc-1jvyhle-6'})(['',';'],_types.txt14OpenSansBold);

/***/ }),
/* 2255 */
/***/ (function(module, exports) {

module.exports = {"tableConfig":{"columns":[{"header":"DATA","mobileWidth":"0%","width":"25%","showInMobile":false},{"header":"HORA","mobileWidth":"0%","width":"20%","showInMobile":false},{"header":"ARQUIVO","mobileWidth":"25%","width":"20%","showInMobile":true},{"header":"SEQUENCIAL","mobileWidth":"30%","width":"20%","showInMobile":true},{"header":"STATUS","mobileWidth":"45%","width":"20%","showInMobile":true}]}}

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _Home=__webpack_require__(388);var _Home2=_interopRequireDefault(_Home);var _authentication=__webpack_require__(404);var _authentication2=_interopRequireDefault(_authentication);var _dashboard=__webpack_require__(2257);var _dashboard2=_interopRequireDefault(_dashboard);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}// import requestFile from './requestFile'
// import activation from '../pageActivation'
exports.default=[{exact:true,path:'/',component:_Home2.default},_authentication2.default,_dashboard2.default];// import carPlate from './carPlate'
module.exports=exports['default'];

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _TemplateProfileActivation=__webpack_require__(2258);var _TemplateProfileActivation2=_interopRequireDefault(_TemplateProfileActivation);var _DashboardIdentifiersForPartners=__webpack_require__(2260);var _DashboardIdentifiersForPartners2=_interopRequireDefault(_DashboardIdentifiersForPartners);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default={path:'/minha-veloe/:id',component:_TemplateProfileActivation2.default,routes:[{exact:true,path:'/minha-veloe/:id/identificadores-parceiros/',component:_DashboardIdentifiersForPartners2.default},{exact:true,path:'/minha-veloe/:id/resumo/',component:_DashboardIdentifiersForPartners2.default}]};module.exports=exports['default'];

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/templates/TemplateProfileActivation/index.js';var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactRouterDom=__webpack_require__(15);var _actions=__webpack_require__(13);var _Header=__webpack_require__(176);var _Header2=_interopRequireDefault(_Header);var _Submenu=__webpack_require__(248);var _Submenu2=_interopRequireDefault(_Submenu);var _FooterSmall=__webpack_require__(249);var _FooterSmall2=_interopRequireDefault(_FooterSmall);var _PageLoader=__webpack_require__(88);var _PageLoader2=_interopRequireDefault(_PageLoader);var _actions2=__webpack_require__(36);var _data=__webpack_require__(2259);var _routes=__webpack_require__(96);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TemplateProfileActivation=function(_Component){_inherits(TemplateProfileActivation,_Component);function TemplateProfileActivation(){_classCallCheck(this,TemplateProfileActivation);return _possibleConstructorReturn(this,(TemplateProfileActivation.__proto__||Object.getPrototypeOf(TemplateProfileActivation)).apply(this,arguments));}_createClass(TemplateProfileActivation,[{key:'componentDidMount',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(){var _this2=this;return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:this.props.setLoading(true);_context.next=3;return this.props.fetchAccountPlansActivation().then(function(){return _this2.props.setActivePlanId(_this2.props.match.params.id);}).then(function(){return _this2.props.setLoading(false);});case 3:case'end':return _context.stop();}}},_callee,this);}));function componentDidMount(){return _ref.apply(this,arguments);}return componentDidMount;}()},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps){var hasChange=// eslint-disable-next-line
nextProps.accountPlans.activePlanId!=nextProps.match.params.id||nextProps.location.pathname!==this.props.location.pathname;if(hasChange){this.props.setActivePlanId(this.props.match.params.id);}return hasChange;}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.props.setActivePlanId(this.props.match.params.id);}},{key:'render',value:function render(){var _props=this.props,routes=_props.routes,match=_props.match;var subnavLinksWithPlanId=_data.subnavLinks.map(function(subnavLink){return _extends({},subnavLink,{link:subnavLink.link.replace(':id',match.params.id)});});return _react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:51}},_react2.default.createElement('div',{className:'empty-template',__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_Header2.default,{__source:{fileName:_jsxFileName,lineNumber:53}}),_react2.default.createElement(_Submenu2.default,{navItems:subnavLinksWithPlanId,__source:{fileName:_jsxFileName,lineNumber:54}})),_react2.default.createElement(_PageLoader2.default,{__source:{fileName:_jsxFileName,lineNumber:56}},_react2.default.createElement('div',{__source:{fileName:_jsxFileName,lineNumber:57}},routes.map(function(route){return _react2.default.createElement(_routes.RouteWithSubRoutes,_extends({key:route.path},route,{__source:{fileName:_jsxFileName,lineNumber:57}}));}))),_react2.default.createElement('div',{className:'empty-template',__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_FooterSmall2.default,{__source:{fileName:_jsxFileName,lineNumber:60}})));}}]);return TemplateProfileActivation;}(_react.Component);var mapStateToProps=function mapStateToProps(state){return{account:state.reducer.account,accountPlans:state.reducer.accountPlans.plans};};var mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{fetchAccountPlansActivation:function fetchAccountPlansActivation(){return dispatch((0,_actions.fetchAccountPlansActivation)()).then(function(accountPlans){var history=ownProps.history,match=ownProps.match;if(accountPlans&&(match.params.id===''||match.params.id==='identificadores-parceiros')){var firstPlanId=accountPlans&&accountPlans[0]&&accountPlans[0].id;history.push('/minha-veloe/'+firstPlanId+'/resumo');}});},setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));},setActivePlanId:function setActivePlanId(planId){return dispatch((0,_actions.setActivePlanId)(planId));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)((0,_reactRouterDom.withRouter)(TemplateProfileActivation));module.exports=exports['default'];

/***/ }),
/* 2259 */
/***/ (function(module, exports) {

module.exports = {"subnavLinks":[{"label":"Identificadores Ativação","link":"#","id":"profileActivation"}]}

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/DashboardIdentifiersForPartners/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _reactHelmet=__webpack_require__(23);var _reactHelmet2=_interopRequireDefault(_reactHelmet);var _actions=__webpack_require__(13);var _actions2=__webpack_require__(36);var _actions3=__webpack_require__(18);var _ModalTypes=__webpack_require__(20);var _IdentifiersListForPartners=__webpack_require__(2261);var _IdentifiersListForPartners2=_interopRequireDefault(_IdentifiersListForPartners);var _styles=__webpack_require__(2265);var _SearchForm=__webpack_require__(402);var _SearchForm2=_interopRequireDefault(_SearchForm);var _QRCodeReader=__webpack_require__(2266);var _QRCodeReader2=_interopRequireDefault(_QRCodeReader);var _ActivationForPartner=__webpack_require__(2285);var _ActivationForPartner2=_interopRequireDefault(_ActivationForPartner);var _data=__webpack_require__(2288);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Services and Actions
// Components
// import ManagementModal from 'app/modules/ManageInfoModal'
// Assets
// import IconLoading from 'app/elements/Icon/ic-loading'
// import image from '../../../static/alterarSenha.png'
var DashboardIdentifiersForPartners=function(_Component){_inherits(DashboardIdentifiersForPartners,_Component);function DashboardIdentifiersForPartners(props){_classCallCheck(this,DashboardIdentifiersForPartners);var _this=_possibleConstructorReturn(this,(DashboardIdentifiersForPartners.__proto__||Object.getPrototypeOf(DashboardIdentifiersForPartners)).call(this,props));_this.handleSearchChange=function(_ref){var target=_ref.target;_this.setState({searchText:target.value});};_this.handleSelectItem=function(item){return function(){var itemsSelected=_this.state.itemsSelected;var newArray=void 0;var hasItem=itemsSelected.findIndex(function(_ref2){var idIdentificador=_ref2.idIdentificador;return item.idIdentificador===idIdentificador;})!==-1;if(hasItem){newArray=itemsSelected.filter(function(_ref3){var idIdentificador=_ref3.idIdentificador;return item.idIdentificador!==idIdentificador;});return _this.setState({itemsSelected:newArray});}newArray=[].concat(_toConsumableArray(itemsSelected),[item]);_this.setState({itemsSelected:newArray});};};_this.handleGetVehicle=function(identifierNumber,next){var identifiersList=_this.state.identifiersList;_this.props.dispatch((0,_actions.fetchFilterVehicles)(identifierNumber)).then(function(resp){if(!resp[0].veiculo){_this.setState({numberVeloeTag:identifierNumber,nextAgain:next},function(){return _this.toggleModal();});}else{if(identifiersList.filter(function(_ref4){var codIdentificador=_ref4.codIdentificador;return codIdentificador===resp[0].codIdentificador;}).length<1)_this.setState({identifiersList:[].concat(_toConsumableArray(identifiersList),[resp[0]])});if(next)_this.toggleQRCode(true);_this.props.dispatch((0,_actions3.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:'VeloeTag: '+resp[0].codIdentificador+' j\xE1 cadastrada.',modalDescription:'Placa: '+resp[0].veiculo.placa}));}});};_this.handleSetIdentifiers=function(identifiersList){var indetifierItem={situacao:'ATIVO',codIdentificador:identifiersList.identifier,veiculo:{placa:identifiersList.plate}};_this.setState({identifiersList:[].concat(_toConsumableArray(_this.state.identifiersList),[indetifierItem])});};_this.toggleModal=function(){_this.setState({modalIsOpen:!_this.state.modalIsOpen});};_this.toggleQRCode=function(status){return _this.setState({QRCodeIsOpen:status});};_this.state={itemsSelected:[],searchText:'',identifiersList:[],listGrowNumber:20,isLoadingMoreItems:false,modalIsOpen:false,vehicle:{},numberVeloeTag:'',nextAgain:false,QRCodeIsOpen:false};return _this;}// Checkbox
_createClass(DashboardIdentifiersForPartners,[{key:'render',value:function render(){var _this2=this;var _state=this.state,searchText=_state.searchText,itemsSelected=_state.itemsSelected,identifiersList=_state.identifiersList,modalIsOpen=_state.modalIsOpen,numberVeloeTag=_state.numberVeloeTag,nextAgain=_state.nextAgain,QRCodeIsOpen=_state.QRCodeIsOpen;return _react2.default.createElement('section',{__source:{fileName:_jsxFileName,lineNumber:124}},_react2.default.createElement(_reactHelmet2.default,{title:_data.helmetTitle,__source:{fileName:_jsxFileName,lineNumber:125}}),_react2.default.createElement(_styles.Content,{__source:{fileName:_jsxFileName,lineNumber:126}},_react2.default.createElement(_styles.Heading,{__source:{fileName:_jsxFileName,lineNumber:127}},_data.identifiersTitle),_react2.default.createElement(_styles.Paragraph,{__source:{fileName:_jsxFileName,lineNumber:128}},_data.identifiersDescription),_react2.default.createElement(_styles.Subheader,{__source:{fileName:_jsxFileName,lineNumber:129}},_react2.default.createElement(_styles.QRCodeContainer,{__source:{fileName:_jsxFileName,lineNumber:130}},_react2.default.createElement(_QRCodeReader2.default,{isOpen:QRCodeIsOpen,setIsOpen:this.toggleQRCode,onScan:function onScan(identifierNumber){return _this2.handleGetVehicle(identifierNumber,true);},__source:{fileName:_jsxFileName,lineNumber:131}})),_react2.default.createElement(_styles.SearchBox,{__source:{fileName:_jsxFileName,lineNumber:137}},_react2.default.createElement(_SearchForm2.default,{value:searchText,onChange:this.handleSearchChange,onSearch:function onSearch(){return _this2.handleGetVehicle(searchText,false);},placeholder:'Insira o n\xBA da VeloeTag',__source:{fileName:_jsxFileName,lineNumber:138}}))),_react2.default.createElement(_IdentifiersListForPartners2.default,{handleCreateInf:this.handleModalCreateInfo,checkboxValues:itemsSelected// handleLoadMoreItems={this.loadMoreItems}
// handleSelectItem={this.handleSelectItem}
// handleSelectAll={this.handleSelectAll}
,identifiers:identifiersList,__source:{fileName:_jsxFileName,lineNumber:146}}),modalIsOpen&&_react2.default.createElement(_ActivationForPartner2.default,_extends({numberVeloeTag:numberVeloeTag,toggleModal:this.toggleModal,setIdentifiers:this.handleSetIdentifiers,next:nextAgain,toggleQRCode:this.toggleQRCode},this.props,{__source:{fileName:_jsxFileName,lineNumber:155}}))));}}]);return DashboardIdentifiersForPartners;}(_react.Component);var mapStateToProps=exports.mapStateToProps=function mapStateToProps(_ref5){var reducer=_ref5.reducer;return{vehicles:reducer.dashboardVehicles,accountPlans:reducer.accountPlans};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchVehicles:function fetchVehicles(history,accountId){return dispatch((0,_actions.fetchGetVehicles)(accountId)).then(function(resp){if(resp&&(resp.status===401||resp.status===403)){dispatch((0,_actions.fetchLogout)());history.push('/conta/login');}dispatch((0,_actions2.setLoading)(false));});},// fetchFilterVehicles: (history, identifierNumber) =>
//   dispatch(fetchFilterVehicles(identifierNumber)).then(resp => {
//     if (resp && (resp.status === 401 || resp.status === 403)) {
//       dispatch(fetchLogout())
//       history.push('/conta/login')
//     }
//     dispatch(setLoading(false))
//   }),
setLoading:function setLoading(isLoading){dispatch((0,_actions2.setLoading)(isLoading));},dispatch:dispatch};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DashboardIdentifiersForPartners);

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/IdentifiersListForPartners/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _gridStyled=__webpack_require__(8);var _IdentifiersListItemForPartners=__webpack_require__(2262);var _IdentifiersListItemForPartners2=_interopRequireDefault(_IdentifiersListItemForPartners);var _styles=__webpack_require__(2264);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Hide from '../../../styles/utilities/Hide'
// Components
// import DropdownList from './DropdownList'
// import Dropdown from './Dropdown'
// import DotButton from 'app/elements/DotButton'
// import Checkbox from 'app/elements/Checkbox'
// Styles
// import { blueGray } from 'styles/settings/colors'
var IdentifiersList=function(_Component){_inherits(IdentifiersList,_Component);function IdentifiersList(props){_classCallCheck(this,IdentifiersList);var _this=_possibleConstructorReturn(this,(IdentifiersList.__proto__||Object.getPrototypeOf(IdentifiersList)).call(this,props));_this.handleDropdown=function(){_this.setState({isDropdownOpen:!_this.state.isDropdownOpen});};_this.handleItemDropdown=function(itemDropdownId){return function(){if(itemDropdownId){return _this.setState({isItemDropdownOpen:true,itemDropdownId:itemDropdownId});}_this.setState({isItemDropdownOpen:false,itemDropdownId:null});};};_this.handleSelectOption=function(selectedOption){_this.setState({selectedOption:selectedOption,isDropdownOpen:false});};_this.state={isItemDropdownOpen:null,itemDropdownId:null,isDropdownOpen:false,veloeTagsOptions:['Ativa','Bloqueada'],selectedOption:'Ativa'// window.onscroll = () => {
//   if (
//     window.innerHeight +
//       document.documentElement.scrollTop +
//       document.getElementById('footer').offsetHeight >=
//     document.documentElement.offsetHeight
//   ) {
//     // props.handleLoadMoreItems()
//   }
// }
};return _this;}_createClass(IdentifiersList,[{key:'render',value:function render(){var _this2=this;var _props=this.props,identifiers=_props.identifiers,checkboxValues=_props.checkboxValues,handleSelectItem=_props.handleSelectItem,handleCreateInf=_props.handleCreateInf;var selectedOption=this.state.selectedOption;var itemStatus=selectedOption==='Bloqueada'?'INATIVO':'ATIVO';// const isAllChecked = checkboxValues.length === identifiers.length
// const identifiersFiltered = identifiers.filter(({ situacao }) => situacao === itemStatus)
return _react2.default.createElement(_styles.ListContainer,{__source:{fileName:_jsxFileName,lineNumber:80}},_react2.default.createElement(_styles.ListItem,{__source:{fileName:_jsxFileName,lineNumber:81}},_react2.default.createElement(_gridStyled.Flex,{width:1,direction:['row','row'],__source:{fileName:_jsxFileName,lineNumber:82}},_react2.default.createElement(_gridStyled.Box,{width:[4/12,2/12],__source:{fileName:_jsxFileName,lineNumber:83}},'placa'),_react2.default.createElement(_gridStyled.Box,{width:[5/12,2/12],__source:{fileName:_jsxFileName,lineNumber:84}},'VeloeTag'),_react2.default.createElement(_gridStyled.Box,{width:[3/12,2/12],__source:{fileName:_jsxFileName,lineNumber:85}},'status'))),identifiers.map(function(vehicle,index){return _react2.default.createElement(_IdentifiersListItemForPartners2.default,{checkboxValues:checkboxValues,vehicle:vehicle,handleSelectItem:handleSelectItem,key:index,handleCreateInf:handleCreateInf,itemDropdownId:_this2.state.itemDropdownId,isItemDropdownOpen:_this2.state.isItemDropdownOpen,handleItemDropdown:_this2.handleItemDropdown,itemStatus:itemStatus,__source:{fileName:_jsxFileName,lineNumber:89}});}));}}]);return IdentifiersList;}(_react.Component);IdentifiersList.propTypes={identifiers:_propTypes.array.isRequired,checkboxValues:_propTypes.array.isRequired,handleSelectItem:_propTypes.func.isRequired,handleSelectAll:_propTypes.func.isRequired// handleLoadMoreItems: func.isRequired
};IdentifiersList.defaultProps={identifiers:[],checkboxValues:[],handleSelectItem:function handleSelectItem(){},handleSelectAll:function handleSelectAll(){},handleIncreaseList:function handleIncreaseList(){}};exports.default=IdentifiersList;module.exports=exports['default'];

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/elements/IdentifiersListItemForPartners/index.js';// import Hide from 'styles/utilities/Hide'
// import DropdownList, { ListItem as DropListItem } from 'app/modules/IdentifiersList/DropdownList'
// import DotButton from 'app/elements/DotButton'
// import Checkbox from 'app/elements/Checkbox'
// import PlusIcon from 'app/elements/Icon/ic-plus'
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _reactRouterDom=__webpack_require__(15);var _styles=__webpack_require__(2263);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var IdentifierListItem=function IdentifierListItem(_ref){var checkboxValues=_ref.checkboxValues,vehicle=_ref.vehicle,itemDropdownId=_ref.itemDropdownId,history=_ref.history,isItemDropdownOpen=_ref.isItemDropdownOpen,handleSelectItem=_ref.handleSelectItem,handleItemDropdown=_ref.handleItemDropdown,handleItemDropdownClose=_ref.handleItemDropdownClose,handleCreateInf=_ref.handleCreateInf,itemStatus=_ref.itemStatus;var veiculo=vehicle.veiculo,situacao=vehicle.situacao,codIdentificador=vehicle.codIdentificador;var active=situacao==='ATIVO';var carPlate=veiculo.placa;var identifierId=codIdentificador;// const carCategory = veiculo.categoria
// const carType = veiculo.tipo === 'CAMINHAO' ? 'Caminhão' : veiculo.tipo
// const sortedInfos = sortedInformations(informacoesGerenciais)
// const isChecked = !!checkboxValues.find(item => item.idIdentificador === idIdentificador)
// const renderIndexInfoManage = tipo =>
//   tipo === 'INFORMACAO_1' ? 1 : tipo === 'INFORMACAO_2' ? 2 : 3
// function sortedInformations(informations) {
//   return informations == null
//     ? null
//     : informations.sort((a, b) => {
//         return a.tipoInfo.toLowerCase() < b.tipoInfo.toLowerCase() ? -1 : 1
//       })
// }
return _react2.default.createElement(_styles.ListItem,{blocked:!!active,__source:{fileName:_jsxFileName,lineNumber:45}},_react2.default.createElement(_gridStyled.Flex,{width:1,direction:['row','row'],__source:{fileName:_jsxFileName,lineNumber:46}},_react2.default.createElement(_gridStyled.Box,{width:[4/12,2/12],__source:{fileName:_jsxFileName,lineNumber:59}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:60}},_react2.default.createElement(_styles.LineText,{__source:{fileName:_jsxFileName,lineNumber:61}},carPlate))),_react2.default.createElement(_gridStyled.Box,{width:[5/12,2/12],__source:{fileName:_jsxFileName,lineNumber:69}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:70}},_react2.default.createElement(_styles.LineText,{__source:{fileName:_jsxFileName,lineNumber:71}},identifierId))),_react2.default.createElement(_gridStyled.Box,{width:[3/12,2/12],__source:{fileName:_jsxFileName,lineNumber:74}},_react2.default.createElement(_styles.LineTextContainer,{__source:{fileName:_jsxFileName,lineNumber:75}},_react2.default.createElement(_styles.LineText,{__source:{fileName:_jsxFileName,lineNumber:76}},situacao)))));};IdentifierListItem.defaultProps={checkboxValues:[],vehicle:{},handleSelectItem:function handleSelectItem(){},itemDropdownId:0,isItemDropdownOpen:false,handleItemDropdown:function handleItemDropdown(){},handleItemDropdownClose:function handleItemDropdownClose(){},handleCreateInf:function handleCreateInf(){}};exports.default=(0,_reactRouterDom.withRouter)(IdentifierListItem);module.exports=exports['default'];

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ChipEmpty=exports.Chip=exports.ChipContainer=exports.ListItem=exports.LineText=exports.LineTextContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  '],['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LineTextContainer=exports.LineTextContainer=_styledComponents2.default.div.withConfig({displayName:'styles__LineTextContainer',componentId:'sc-w0v1dv-0'})(['display:flex;align-items:center;min-height:100%;position:relative;']);var LineText=exports.LineText=_styledComponents2.default.div.withConfig({displayName:'styles__LineText',componentId:'sc-w0v1dv-1'})(['',';font-weight:normal;line-height:1.5;letter-spacing:normal;text-align:left;color:',';display:block;',';',';',';'],_types.txt16OpenSans,_colors.darkSlateBlue,function(_ref){var capitalize=_ref.capitalize;return capitalize&&(0,_styledComponents.css)(['text-transform:capitalize;']);},function(_ref2){var uppercase=_ref2.uppercase;return uppercase&&(0,_styledComponents.css)(['text-transform:uppercase;font-size:12px;font-weight:bold;letter-spacing:1.6px;']);},function(_ref3){var bold=_ref3.bold;return bold&&(0,_styledComponents.css)(['font-weight:bold;']);});var ListItem=exports.ListItem=_styledComponents2.default.div.withConfig({displayName:'styles__ListItem',componentId:'sc-w0v1dv-2'})(['display:block;padding:',' 0 ',';border-bottom:',' solid ',';',';',';'],(0,_rem2.default)('18px'),(0,_rem2.default)('18px'),(0,_rem2.default)('1px'),_colors.paleGrayTwo,_media2.default.small(_templateObject,(0,_rem2.default)('13px')),function(props){return!props.blocked&&(0,_styledComponents.css)(['border-bottom:',' solid ',';','{color:',';}'],(0,_rem2.default)('4px'),_colors.red,LineText,_colors.red);});var ChipContainer=exports.ChipContainer=(0,_styledComponents2.default)(LineTextContainer).withConfig({displayName:'styles__ChipContainer',componentId:'sc-w0v1dv-3'})(['flex-wrap:wrap;& span:nth-child(1),& span:nth-child(2){margin-right:',';}'],(0,_rem2.default)('5px'));var Chip=exports.Chip=_styledComponents2.default.span.withConfig({displayName:'styles__Chip',componentId:'sc-w0v1dv-4'})(['',';color:',';background-color:',';padding:',' ',';border-radius:',';margin-top:',';'],_types.txt12OpenSansBold,_colors.white,_colors.tealish,(0,_rem2.default)('3px'),(0,_rem2.default)('10px'),(0,_rem2.default)('15px'),(0,_rem2.default)('5px'));var ChipEmpty=exports.ChipEmpty=_styledComponents2.default.a.withConfig({displayName:'styles__ChipEmpty',componentId:'sc-w0v1dv-5'})(['',';background-color:',';padding:',' ',';cursor:pointer;text-transform:uppercase;border-radius:',';border:solid 1px ',';color:',';transition:all 0.3s;svg{font-size:',';margin-right:',';path{fill:',';}}&:hover{background-color:',';color:',';svg{path{fill:',';}}}'],_types.txt12OpenSansBold,_colors.paleGray,(0,_rem2.default)('3px'),(0,_rem2.default)('10px'),(0,_rem2.default)('15px'),_colors.darkGrey,_colors.darkGrey,(0,_rem2.default)('18px'),(0,_rem2.default)('4px'),_colors.darkGrey,_colors.darkGrey,_colors.paleGray,_colors.paleGray);

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DropdownBox=exports.ListItem=exports.ListContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n        li:last-of-type {\n            border-bottom: 0 !important;\n        }\n    '],['\n        li:last-of-type {\n            border-bottom: 0 !important;\n        }\n    ']),_templateObject2=_taggedTemplateLiteral(['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  '],['\n    width: 100%;\n    padding: ',' 0;\n    margin: 0;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _gridStyled=__webpack_require__(8);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ListContainer=exports.ListContainer=_styledComponents2.default.ul.withConfig({displayName:'styles__ListContainer',componentId:'sc-1lwgvbk-0'})(['list-style:none;margin:15px 0 0;padding:0;',';'],_media2.default.small(_templateObject));var ListItem=exports.ListItem=_styledComponents2.default.div.withConfig({displayName:'styles__ListItem',componentId:'sc-1lwgvbk-1'})(['display:block;padding:',' 0 ',';border-bottom:',' solid ',';',';line-height:1.67;letter-spacing:1.6px;text-align:left;color:',';text-transform:uppercase;',';'],(0,_rem2.default)('18px'),(0,_rem2.default)('18px'),(0,_rem2.default)('1px'),_colors.paleGrayTwo,_types.txt12OpenSansBold,_colors.blueGray,_media2.default.small(_templateObject2,(0,_rem2.default)('13px')));var DropdownBox=exports.DropdownBox=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'styles__DropdownBox',componentId:'sc-1lwgvbk-2'})(['position:relative;']);

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.LoadingText=exports.LoadingContainer=exports.SearchBox=exports.BoxHeader=exports.WrapperButtons=exports.QRCodeContainer=exports.Subheader=exports.Heading=exports.Paragraph=exports.Content=undefined;var _templateObject=_taggedTemplateLiteral(['\n      margin: ',' auto;\n  '],['\n      margin: ',' auto;\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    width: ',';\n    margin: 0;\n  '],['\n    width: ',';\n    margin: 0;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n    ','\n    margin: ',' 0;\n  '],['\n    ','\n    margin: ',' 0;\n  ']),_templateObject4=_taggedTemplateLiteral(['\n    flex-direction: column;\n  '],['\n    flex-direction: column;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n    margin-bottom: 30px;\n  '],['\n    margin-bottom: 30px;\n  ']),_templateObject6=_taggedTemplateLiteral(['\n    width: 100%;\n  '],['\n    width: 100%;\n  ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _colors=__webpack_require__(2);var _types=__webpack_require__(4);var _content=__webpack_require__(22);var _content2=_interopRequireDefault(_content);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=exports.Content=_styledComponents2.default.div.withConfig({displayName:'styles__Content',componentId:'sc-12vn68i-0'})(['',';margin:',' auto;',';'],_content2.default,(0,_rem2.default)('42px'),_media2.default.small(_templateObject,(0,_rem2.default)('29px')));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-12vn68i-1'})(['',' color:',';width:',';margin-top:',';',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('270px'),(0,_rem2.default)('7px'),_media2.default.large(_templateObject2,(0,_rem2.default)('313px')));var Heading=exports.Heading=_styledComponents2.default.h1.withConfig({displayName:'styles__Heading',componentId:'sc-12vn68i-2'})(['',' color:',';font-size:48px;font-weight:bold;line-height:1.08;letter-spacing:normal;margin:0 0 ',';',';'],_types.title24Galano,_colors.darkSlateBlue,(0,_rem2.default)('10px'),_media2.default.small(_templateObject3,_types.title18Galano,(0,_rem2.default)('8px')));var Subheader=exports.Subheader=_styledComponents2.default.div.withConfig({displayName:'styles__Subheader',componentId:'sc-12vn68i-3'})(['display:flex;width:100%;align-items:center;margin-top:',';margin-bottom:',';',';'],(0,_rem2.default)('20px'),(0,_rem2.default)('20px'),_media2.default.small(_templateObject4));var QRCodeContainer=exports.QRCodeContainer=_styledComponents2.default.div.withConfig({displayName:'styles__QRCodeContainer',componentId:'sc-12vn68i-4'})(['display:flex;flex:1;justify-content:flex-end;padding-right:25px;',';'],_media2.default.small(_templateObject5));var WrapperButtons=exports.WrapperButtons=_styledComponents2.default.div.withConfig({displayName:'styles__WrapperButtons',componentId:'sc-12vn68i-5'})(['display:flex;justify-content:space-between;min-width:400px;& > div{margin:0 15px;}']);var BoxHeader=exports.BoxHeader=_styledComponents2.default.div.withConfig({displayName:'styles__BoxHeader',componentId:'sc-12vn68i-6'})(['display:flex;justify-content:space-between;margin-bottom:40px;']);var SearchBox=exports.SearchBox=_styledComponents2.default.div.withConfig({displayName:'styles__SearchBox',componentId:'sc-12vn68i-7'})(['display:flex;justify-content:flex-end;flex:1;',';& > *{flex:1;}'],_media2.default.small(_templateObject6));var spin=(0,_styledComponents.keyframes)(['from{transform:rotate(0deg);}to{transform:rotate(360deg);}']);var LoadingContainer=exports.LoadingContainer=_styledComponents2.default.div.withConfig({displayName:'styles__LoadingContainer',componentId:'sc-12vn68i-8'})(['margin-top:',';display:flex;align-items:center;justify-content:center;svg{animation:',' 1s linear infinite;}'],(0,_rem2.default)('20px'),spin);var LoadingText=exports.LoadingText=_styledComponents2.default.span.withConfig({displayName:'styles__LoadingText',componentId:'sc-12vn68i-9'})(['margin-left:',';',';color:',';'],(0,_rem2.default)('10px'),_types.txt14OpenSans,_colors.darkGrey);

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/QRCodeReader/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactQrReader=__webpack_require__(2267);var _reactQrReader2=_interopRequireDefault(_reactQrReader);var _Button=__webpack_require__(155);var _Button2=_interopRequireDefault(_Button);var _Icon=__webpack_require__(31);var _styles=__webpack_require__(2284);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var QRCodeReader=function(_Component){_inherits(QRCodeReader,_Component);function QRCodeReader(){var _ref;var _temp,_this,_ret;_classCallCheck(this,QRCodeReader);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=QRCodeReader.__proto__||Object.getPrototypeOf(QRCodeReader)).call.apply(_ref,[this].concat(args))),_this),_this.setIsOpen=function(status){return _this.props.setIsOpen(status);},_this.handleScan=function(data){if(data){var onScan=_this.props.onScan;onScan&&onScan(data);_this.setIsOpen(false);}},_this.handleError=function(err){console.error(err);_this.setIsOpen(false);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(QRCodeReader,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement(_styles.Container,{__source:{fileName:_jsxFileName,lineNumber:25}},_react2.default.createElement(_Button2.default,{buttonType:'skyBlue',text:'Coletar TAG por QRCode',onClick:function onClick(){return _this2.setIsOpen(true);},id:'btnQRCode',__source:{fileName:_jsxFileName,lineNumber:26}}),this.props.isOpen&&_react2.default.createElement(_styles.QrReaderContainer,{__source:{fileName:_jsxFileName,lineNumber:33}},_react2.default.createElement(_styles.Close,{onClick:function onClick(){return _this2.setIsOpen(false);},__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement(_Icon.Icon,{icon:'modal-close',height:'31.2px',width:'31.2px',viewBox:'0 0 24 24',__source:{fileName:_jsxFileName,lineNumber:35}})),_react2.default.createElement(_reactQrReader2.default,{delay:300,onError:this.handleError,onScan:this.handleScan,style:{width:'100%',height:'100%'},__source:{fileName:_jsxFileName,lineNumber:37}})));}}]);return QRCodeReader;}(_react.Component);exports.default=QRCodeReader;module.exports=exports['default'];

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var Component = React.Component;

var PropTypes = __webpack_require__(9);

var _require = __webpack_require__(2268),
    getDeviceId = _require.getDeviceId,
    getFacingModePattern = _require.getFacingModePattern;

var havePropsChanged = __webpack_require__(2270);
var createBlob = __webpack_require__(2271);

// Require adapter to support older browser implementations
__webpack_require__(2272);

// Inline worker.js as a string value of workerBlob.
// eslint-disable-next-line
var workerBlob = createBlob(["!function(o,e){\"object\"==typeof exports&&\"object\"==typeof module?module.exports=e():\"function\"==typeof define&&define.amd?define([],e):\"object\"==typeof exports?exports.jsQR=e():o.jsQR=e()}(\"undefined\"!=typeof self?self:this,function(){return function(o){function e(t){if(r[t])return r[t].exports;var c=r[t]={i:t,l:!1,exports:{}};return o[t].call(c.exports,c,c.exports,e),c.l=!0,c.exports}var r={};return e.m=o,e.c=r,e.d=function(o,r,t){e.o(o,r)||Object.defineProperty(o,r,{configurable:!1,enumerable:!0,get:t})},e.n=function(o){var r=o&&o.__esModule?function(){return o.default}:function(){return o};return e.d(r,\"a\",r),r},e.o=function(o,e){return Object.prototype.hasOwnProperty.call(o,e)},e.p=\"\",e(e.s=3)}([function(o,e,r){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var t=function(){function o(o,e){this.width=e,this.height=o.length/e,this.data=o}return o.createEmpty=function(e,r){return new o(new Uint8ClampedArray(e*r),e)},o.prototype.get=function(o,e){return!(o<0||o>=this.width||e<0||e>=this.height)&&!!this.data[e*this.width+o]},o.prototype.set=function(o,e,r){this.data[e*this.width+o]=r?1:0},o.prototype.setRegion=function(o,e,r,t,c){for(var s=e;s<e+t;s++)for(var a=o;a<o+r;a++)this.set(a,s,!!c)},o.prototype.getInverted=function(){return new o(this.data.map(function(o){return 0===o?1:0}),this.width)},o}();e.BitMatrix=t},function(o,e,r){\"use strict\";function t(o,e){return o^e}Object.defineProperty(e,\"__esModule\",{value:!0});var c=r(2);e.addOrSubtractGF=t;var s=function(){function o(o,e,r){this.primitive=o,this.size=e,this.generatorBase=r,this.expTable=new Array(this.size),this.logTable=new Array(this.size);for(var t=1,s=0;s<this.size;s++)this.expTable[s]=t,(t*=2)>=this.size&&(t=(t^this.primitive)&this.size-1);for(var s=0;s<this.size-1;s++)this.logTable[this.expTable[s]]=s;this.zero=new c.default(this,Uint8ClampedArray.from([0])),this.one=new c.default(this,Uint8ClampedArray.from([1]))}return o.prototype.multiply=function(o,e){return 0===o||0===e?0:this.expTable[(this.logTable[o]+this.logTable[e])%(this.size-1)]},o.prototype.inverse=function(o){if(0===o)throw new Error(\"Can't invert 0\");return this.expTable[this.size-this.logTable[o]-1]},o.prototype.buildMonomial=function(o,e){if(o<0)throw new Error(\"Invalid monomial degree less than 0\");if(0===e)return this.zero;var r=new Uint8ClampedArray(o+1);return r[0]=e,new c.default(this,r)},o.prototype.log=function(o){if(0===o)throw new Error(\"Can't take log(0)\");return this.logTable[o]},o.prototype.exp=function(o){return this.expTable[o]},o}();e.default=s},function(o,e,r){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var t=r(1),c=function(){function o(o,e){if(0===e.length)throw new Error(\"No coefficients.\");this.field=o;var r=e.length;if(r>1&&0===e[0]){for(var t=1;t<r&&0===e[t];)t++;if(t===r)this.coefficients=o.zero.coefficients;else{this.coefficients=new Uint8ClampedArray(r-t);for(var c=0;c<this.coefficients.length;c++)this.coefficients[c]=e[t+c]}}else this.coefficients=e}return o.prototype.degree=function(){return this.coefficients.length-1},o.prototype.isZero=function(){return 0===this.coefficients[0]},o.prototype.getCoefficient=function(o){return this.coefficients[this.coefficients.length-1-o]},o.prototype.addOrSubtract=function(e){if(this.isZero())return e;if(e.isZero())return this;var r=this.coefficients,c=e.coefficients;r.length>c.length&&(n=[c,r],r=n[0],c=n[1]);for(var s=new Uint8ClampedArray(c.length),a=c.length-r.length,d=0;d<a;d++)s[d]=c[d];for(var d=a;d<c.length;d++)s[d]=t.addOrSubtractGF(r[d-a],c[d]);return new o(this.field,s);var n},o.prototype.multiply=function(e){if(0===e)return this.field.zero;if(1===e)return this;for(var r=this.coefficients.length,t=new Uint8ClampedArray(r),c=0;c<r;c++)t[c]=this.field.multiply(this.coefficients[c],e);return new o(this.field,t)},o.prototype.multiplyPoly=function(e){if(this.isZero()||e.isZero())return this.field.zero;for(var r=this.coefficients,c=r.length,s=e.coefficients,a=s.length,d=new Uint8ClampedArray(c+a-1),n=0;n<c;n++)for(var l=r[n],i=0;i<a;i++)d[n+i]=t.addOrSubtractGF(d[n+i],this.field.multiply(l,s[i]));return new o(this.field,d)},o.prototype.multiplyByMonomial=function(e,r){if(e<0)throw new Error(\"Invalid degree less than 0\");if(0===r)return this.field.zero;for(var t=this.coefficients.length,c=new Uint8ClampedArray(t+e),s=0;s<t;s++)c[s]=this.field.multiply(this.coefficients[s],r);return new o(this.field,c)},o.prototype.evaluateAt=function(o){var e=0;if(0===o)return this.getCoefficient(0);var r=this.coefficients.length;if(1===o)return this.coefficients.forEach(function(o){e=t.addOrSubtractGF(e,o)}),e;e=this.coefficients[0];for(var c=1;c<r;c++)e=t.addOrSubtractGF(this.field.multiply(o,e),this.coefficients[c]);return e},o}();e.default=c},function(o,e,r){\"use strict\";function t(o){var e=n.locate(o);if(!e)return null;var r=d.extract(o,e),t=a.decode(r.matrix);return t?{binaryData:t.bytes,data:t.text,chunks:t.chunks,location:{topRightCorner:r.mappingFunction(e.dimension,0),topLeftCorner:r.mappingFunction(0,0),bottomRightCorner:r.mappingFunction(e.dimension,e.dimension),bottomLeftCorner:r.mappingFunction(0,e.dimension),topRightFinderPattern:e.topRight,topLeftFinderPattern:e.topLeft,bottomLeftFinderPattern:e.bottomLeft,bottomRightAlignmentPattern:e.alignmentPattern}}:null}function c(o,e,r){var c=s.binarize(o,e,r),a=t(c);return a||(a=t(c.getInverted())),a}Object.defineProperty(e,\"__esModule\",{value:!0});var s=r(4),a=r(5),d=r(11),n=r(12);c.default=c,e.default=c},function(o,e,r){\"use strict\";function t(o,e,r){return o<e?e:o>r?r:o}function c(o,e,r){if(o.length!==e*r*4)throw new Error(\"Malformed data passed to binarizer.\");for(var c=new n(e,r),l=0;l<e;l++)for(var i=0;i<r;i++){var B=o[4*(i*e+l)+0],k=o[4*(i*e+l)+1],u=o[4*(i*e+l)+2];c.set(l,i,.2126*B+.7152*k+.0722*u)}for(var C=Math.ceil(e/a),m=Math.ceil(r/a),f=new n(C,m),w=0;w<m;w++)for(var P=0;P<C;P++){for(var v=0,h=1/0,y=0,i=0;i<a;i++)for(var l=0;l<a;l++){var p=c.get(P*a+l,w*a+i);v+=p,h=Math.min(h,p),y=Math.max(y,p)}var b=v/Math.pow(a,2);if(y-h<=d&&(b=h/2,w>0&&P>0)){var g=(f.get(P,w-1)+2*f.get(P-1,w)+f.get(P-1,w-1))/4;h<g&&(b=g)}f.set(P,w,b)}for(var x=s.BitMatrix.createEmpty(e,r),w=0;w<m;w++)for(var P=0;P<C;P++){for(var M=t(P,2,C-3),L=t(w,2,m-3),v=0,N=-2;N<=2;N++)for(var I=-2;I<=2;I++)v+=f.get(M+N,L+I);for(var O=v/25,l=0;l<a;l++)for(var i=0;i<a;i++){var S=c.get(P*a+l,w*a+i);x.set(P*a+l,w*a+i,S<=O)}}return x}Object.defineProperty(e,\"__esModule\",{value:!0});var s=r(0),a=8,d=24,n=function(){function o(o,e){this.width=o,this.data=new Uint8ClampedArray(o*e)}return o.prototype.get=function(o,e){return this.data[e*this.width+o]},o.prototype.set=function(o,e,r){this.data[e*this.width+o]=r},o}();e.binarize=c},function(o,e,r){\"use strict\";function t(o,e){for(var r=o^e,t=0;r;)t++,r&=r-1;return t}function c(o,e){return e<<1|o}function s(o){var e=17+4*o.versionNumber,r=k.BitMatrix.createEmpty(e,e);r.setRegion(0,0,9,9,!0),r.setRegion(e-8,0,8,9,!0),r.setRegion(0,e-8,9,8,!0);for(var t=0,c=o.alignmentPatternCenters;t<c.length;t++)for(var s=c[t],a=0,d=o.alignmentPatternCenters;a<d.length;a++){var n=d[a];6===s&&6===n||6===s&&n===e-7||s===e-7&&6===n||r.setRegion(s-2,n-2,5,5,!0)}return r.setRegion(6,9,1,e-17,!0),r.setRegion(9,6,e-17,1,!0),o.versionNumber>6&&(r.setRegion(e-11,0,3,6,!0),r.setRegion(0,e-11,6,3,!0)),r}function a(o,e,r){for(var t=w[r.dataMask],a=o.height,d=s(e),n=[],l=0,i=0,B=!0,k=a-1;k>0;k-=2){6===k&&k--;for(var u=0;u<a;u++)for(var C=B?a-1-u:u,m=0;m<2;m++){var f=k-m;if(!d.get(f,C)){i++;var P=o.get(f,C);t({y:C,x:f})&&(P=!P),l=c(P,l),8===i&&(n.push(l),i=0,l=0)}}B=!B}return n}function d(o){var e=o.height,r=Math.floor((e-17)/4);if(r<=6)return m.VERSIONS[r-1];for(var s=0,a=5;a>=0;a--)for(var d=e-9;d>=e-11;d--)s=c(o.get(d,a),s);for(var n=0,d=5;d>=0;d--)for(var a=e-9;a>=e-11;a--)n=c(o.get(d,a),n);for(var l,i=1/0,B=0,k=m.VERSIONS;B<k.length;B++){var u=k[B];if(u.infoBits===s||u.infoBits===n)return u;var C=t(s,u.infoBits);C<i&&(l=u,i=C),C=t(n,u.infoBits),C<i&&(l=u,i=C)}return i<=3?l:void 0}function n(o){for(var e=0,r=0;r<=8;r++)6!==r&&(e=c(o.get(r,8),e));for(var s=7;s>=0;s--)6!==s&&(e=c(o.get(8,s),e));for(var a=o.height,d=0,s=a-1;s>=a-7;s--)d=c(o.get(8,s),d);for(var r=a-8;r<a;r++)d=c(o.get(r,8),d);for(var n=1/0,l=null,i=0,B=f;i<B.length;i++){var k=B[i],u=k.bits,C=k.formatInfo;if(u===e||u===d)return C;var m=t(e,u);m<n&&(l=C,n=m),e!==d&&(m=t(d,u))<n&&(l=C,n=m)}return n<=3?l:null}function l(o,e,r){var t=e.errorCorrectionLevels[r],c=[],s=0;if(t.ecBlocks.forEach(function(o){for(var e=0;e<o.numBlocks;e++)c.push({numDataCodewords:o.dataCodewordsPerBlock,codewords:[]}),s+=o.dataCodewordsPerBlock+t.ecCodewordsPerBlock}),o.length<s)return null;o=o.slice(0,s);for(var a=t.ecBlocks[0].dataCodewordsPerBlock,d=0;d<a;d++)for(var n=0,l=c;n<l.length;n++){var i=l[n];i.codewords.push(o.shift())}if(t.ecBlocks.length>1)for(var B=t.ecBlocks[0].numBlocks,k=t.ecBlocks[1].numBlocks,d=0;d<k;d++)c[B+d].codewords.push(o.shift());for(;o.length>0;)for(var u=0,C=c;u<C.length;u++){var i=C[u];i.codewords.push(o.shift())}return c}function i(o){var e=d(o);if(!e)return null;var r=n(o);if(!r)return null;var t=a(o,e,r),c=l(t,e,r.errorCorrectionLevel);if(!c)return null;for(var s=c.reduce(function(o,e){return o+e.numDataCodewords},0),i=new Uint8ClampedArray(s),B=0,k=0,m=c;k<m.length;k++){var f=m[k],w=C.decode(f.codewords,f.codewords.length-f.numDataCodewords);if(!w)return null;for(var P=0;P<f.numDataCodewords;P++)i[B++]=w[P]}try{return u.decode(i,e.versionNumber)}catch(o){return null}}function B(o){if(null==o)return null;var e=i(o);if(e)return e;for(var r=0;r<o.width;r++)for(var t=r+1;t<o.height;t++)o.get(r,t)!==o.get(t,r)&&(o.set(r,t,!o.get(r,t)),o.set(t,r,!o.get(t,r)));return i(o)}Object.defineProperty(e,\"__esModule\",{value:!0});var k=r(0),u=r(6),C=r(9),m=r(10),f=[{bits:21522,formatInfo:{errorCorrectionLevel:1,dataMask:0}},{bits:20773,formatInfo:{errorCorrectionLevel:1,dataMask:1}},{bits:24188,formatInfo:{errorCorrectionLevel:1,dataMask:2}},{bits:23371,formatInfo:{errorCorrectionLevel:1,dataMask:3}},{bits:17913,formatInfo:{errorCorrectionLevel:1,dataMask:4}},{bits:16590,formatInfo:{errorCorrectionLevel:1,dataMask:5}},{bits:20375,formatInfo:{errorCorrectionLevel:1,dataMask:6}},{bits:19104,formatInfo:{errorCorrectionLevel:1,dataMask:7}},{bits:30660,formatInfo:{errorCorrectionLevel:0,dataMask:0}},{bits:29427,formatInfo:{errorCorrectionLevel:0,dataMask:1}},{bits:32170,formatInfo:{errorCorrectionLevel:0,dataMask:2}},{bits:30877,formatInfo:{errorCorrectionLevel:0,dataMask:3}},{bits:26159,formatInfo:{errorCorrectionLevel:0,dataMask:4}},{bits:25368,formatInfo:{errorCorrectionLevel:0,dataMask:5}},{bits:27713,formatInfo:{errorCorrectionLevel:0,dataMask:6}},{bits:26998,formatInfo:{errorCorrectionLevel:0,dataMask:7}},{bits:5769,formatInfo:{errorCorrectionLevel:3,dataMask:0}},{bits:5054,formatInfo:{errorCorrectionLevel:3,dataMask:1}},{bits:7399,formatInfo:{errorCorrectionLevel:3,dataMask:2}},{bits:6608,formatInfo:{errorCorrectionLevel:3,dataMask:3}},{bits:1890,formatInfo:{errorCorrectionLevel:3,dataMask:4}},{bits:597,formatInfo:{errorCorrectionLevel:3,dataMask:5}},{bits:3340,formatInfo:{errorCorrectionLevel:3,dataMask:6}},{bits:2107,formatInfo:{errorCorrectionLevel:3,dataMask:7}},{bits:13663,formatInfo:{errorCorrectionLevel:2,dataMask:0}},{bits:12392,formatInfo:{errorCorrectionLevel:2,dataMask:1}},{bits:16177,formatInfo:{errorCorrectionLevel:2,dataMask:2}},{bits:14854,formatInfo:{errorCorrectionLevel:2,dataMask:3}},{bits:9396,formatInfo:{errorCorrectionLevel:2,dataMask:4}},{bits:8579,formatInfo:{errorCorrectionLevel:2,dataMask:5}},{bits:11994,formatInfo:{errorCorrectionLevel:2,dataMask:6}},{bits:11245,formatInfo:{errorCorrectionLevel:2,dataMask:7}}],w=[function(o){return(o.y+o.x)%2==0},function(o){return o.y%2==0},function(o){return o.x%3==0},function(o){return(o.y+o.x)%3==0},function(o){return(Math.floor(o.y/2)+Math.floor(o.x/3))%2==0},function(o){return o.x*o.y%2+o.x*o.y%3==0},function(o){return(o.y*o.x%2+o.y*o.x%3)%2==0},function(o){return((o.y+o.x)%2+o.y*o.x%3)%2==0}];e.decode=B},function(o,e,r){\"use strict\";function t(o,e){for(var r=[],t=\"\",c=[10,12,14][e],s=o.readBits(c);s>=3;){var a=o.readBits(10);if(a>=1e3)throw new Error(\"Invalid numeric value above 999\");var d=Math.floor(a/100),n=Math.floor(a/10)%10,l=a%10;r.push(48+d,48+n,48+l),t+=d.toString()+n.toString()+l.toString(),s-=3}if(2===s){var a=o.readBits(7);if(a>=100)throw new Error(\"Invalid numeric value above 99\");var d=Math.floor(a/10),n=a%10;r.push(48+d,48+n),t+=d.toString()+n.toString()}else if(1===s){var a=o.readBits(4);if(a>=10)throw new Error(\"Invalid numeric value above 9\");r.push(48+a),t+=a.toString()}return{bytes:r,text:t}}function c(o,e){for(var r=[],t=\"\",c=[9,11,13][e],s=o.readBits(c);s>=2;){var a=o.readBits(11),d=Math.floor(a/45),n=a%45;r.push(k[d].charCodeAt(0),k[n].charCodeAt(0)),t+=k[d]+k[n],s-=2}if(1===s){var d=o.readBits(6);r.push(k[d].charCodeAt(0)),t+=k[d]}return{bytes:r,text:t}}function s(o,e){for(var r=[],t=\"\",c=[8,16,16][e],s=o.readBits(c),a=0;a<s;a++){var d=o.readBits(8);r.push(d)}try{t+=decodeURIComponent(r.map(function(o){return\"%\"+(\"0\"+o.toString(16)).substr(-2)}).join(\"\"))}catch(o){}return{bytes:r,text:t}}function a(o,e){for(var r=[],t=\"\",c=[8,10,12][e],s=o.readBits(c),a=0;a<s;a++){var d=o.readBits(13),n=Math.floor(d/192)<<8|d%192;n+=n<7936?33088:49472,r.push(n>>8,255&n),t+=String.fromCharCode(i.shiftJISTable[n])}return{bytes:r,text:t}}function d(o,e){for(var r=new l.BitStream(o),d=e<=9?0:e<=26?1:2,i={text:\"\",bytes:[],chunks:[]};r.available()>=4;){var k=r.readBits(4);if(k===B.Terminator)return i;if(k===B.ECI)0===r.readBits(1)?i.chunks.push({type:n.ECI,assignmentNumber:r.readBits(7)}):0===r.readBits(1)?i.chunks.push({type:n.ECI,assignmentNumber:r.readBits(14)}):0===r.readBits(1)?i.chunks.push({type:n.ECI,assignmentNumber:r.readBits(21)}):i.chunks.push({type:n.ECI,assignmentNumber:-1});else if(k===B.Numeric){var u=t(r,d);i.text+=u.text,(w=i.bytes).push.apply(w,u.bytes),i.chunks.push({type:n.Numeric,text:u.text})}else if(k===B.Alphanumeric){var C=c(r,d);i.text+=C.text,(P=i.bytes).push.apply(P,C.bytes),i.chunks.push({type:n.Alphanumeric,text:C.text})}else if(k===B.Byte){var m=s(r,d);i.text+=m.text,(v=i.bytes).push.apply(v,m.bytes),i.chunks.push({type:n.Byte,bytes:m.bytes,text:m.text})}else if(k===B.Kanji){var f=a(r,d);i.text+=f.text,(h=i.bytes).push.apply(h,f.bytes),i.chunks.push({type:n.Kanji,bytes:f.bytes,text:f.text})}}var w,P,v,h}Object.defineProperty(e,\"__esModule\",{value:!0});var n,l=r(7),i=r(8);!function(o){o.Numeric=\"numeric\",o.Alphanumeric=\"alphanumeric\",o.Byte=\"byte\",o.Kanji=\"kanji\",o.ECI=\"eci\"}(n=e.Mode||(e.Mode={}));var B;!function(o){o[o.Terminator=0]=\"Terminator\",o[o.Numeric=1]=\"Numeric\",o[o.Alphanumeric=2]=\"Alphanumeric\",o[o.Byte=4]=\"Byte\",o[o.Kanji=8]=\"Kanji\",o[o.ECI=7]=\"ECI\"}(B||(B={}));var k=[\"0\",\"1\",\"2\",\"3\",\"4\",\"5\",\"6\",\"7\",\"8\",\"9\",\"A\",\"B\",\"C\",\"D\",\"E\",\"F\",\"G\",\"H\",\"I\",\"J\",\"K\",\"L\",\"M\",\"N\",\"O\",\"P\",\"Q\",\"R\",\"S\",\"T\",\"U\",\"V\",\"W\",\"X\",\"Y\",\"Z\",\" \",\"$\",\"%\",\"*\",\"+\",\"-\",\".\",\"/\",\":\"];e.decode=d},function(o,e,r){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0});var t=function(){function o(o){this.byteOffset=0,this.bitOffset=0,this.bytes=o}return o.prototype.readBits=function(o){if(o<1||o>32||o>this.available())throw new Error(\"Cannot read \"+o.toString()+\" bits\");var e=0;if(this.bitOffset>0){var r=8-this.bitOffset,t=o<r?o:r,c=r-t,s=255>>8-t<<c;e=(this.bytes[this.byteOffset]&s)>>c,o-=t,this.bitOffset+=t,8===this.bitOffset&&(this.bitOffset=0,this.byteOffset++)}if(o>0){for(;o>=8;)e=e<<8|255&this.bytes[this.byteOffset],this.byteOffset++,o-=8;if(o>0){var c=8-o,s=255>>c<<c;e=e<<o|(this.bytes[this.byteOffset]&s)>>c,this.bitOffset+=o}}return e},o.prototype.available=function(){return 8*(this.bytes.length-this.byteOffset)-this.bitOffset},o}();e.BitStream=t},function(o,e,r){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.shiftJISTable={32:32,33:33,34:34,35:35,36:36,37:37,38:38,39:39,40:40,41:41,42:42,43:43,44:44,45:45,46:46,47:47,48:48,49:49,50:50,51:51,52:52,53:53,54:54,55:55,56:56,57:57,58:58,59:59,60:60,61:61,62:62,63:63,64:64,65:65,66:66,67:67,68:68,69:69,70:70,71:71,72:72,73:73,74:74,75:75,76:76,77:77,78:78,79:79,80:80,81:81,82:82,83:83,84:84,85:85,86:86,87:87,88:88,89:89,90:90,91:91,92:165,93:93,94:94,95:95,96:96,97:97,98:98,99:99,100:100,101:101,102:102,103:103,104:104,105:105,106:106,107:107,108:108,109:109,110:110,111:111,112:112,113:113,114:114,115:115,116:116,117:117,118:118,119:119,120:120,121:121,122:122,123:123,124:124,125:125,126:8254,33088:12288,33089:12289,33090:12290,33091:65292,33092:65294,33093:12539,33094:65306,33095:65307,33096:65311,33097:65281,33098:12443,33099:12444,33100:180,33101:65344,33102:168,33103:65342,33104:65507,33105:65343,33106:12541,33107:12542,33108:12445,33109:12446,33110:12291,33111:20189,33112:12293,33113:12294,33114:12295,33115:12540,33116:8213,33117:8208,33118:65295,33119:92,33120:12316,33121:8214,33122:65372,33123:8230,33124:8229,33125:8216,33126:8217,33127:8220,33128:8221,33129:65288,33130:65289,33131:12308,33132:12309,33133:65339,33134:65341,33135:65371,33136:65373,33137:12296,33138:12297,33139:12298,33140:12299,33141:12300,33142:12301,33143:12302,33144:12303,33145:12304,33146:12305,33147:65291,33148:8722,33149:177,33150:215,33152:247,33153:65309,33154:8800,33155:65308,33156:65310,33157:8806,33158:8807,33159:8734,33160:8756,33161:9794,33162:9792,33163:176,33164:8242,33165:8243,33166:8451,33167:65509,33168:65284,33169:162,33170:163,33171:65285,33172:65283,33173:65286,33174:65290,33175:65312,33176:167,33177:9734,33178:9733,33179:9675,33180:9679,33181:9678,33182:9671,33183:9670,33184:9633,33185:9632,33186:9651,33187:9650,33188:9661,33189:9660,33190:8251,33191:12306,33192:8594,33193:8592,33194:8593,33195:8595,33196:12307,33208:8712,33209:8715,33210:8838,33211:8839,33212:8834,33213:8835,33214:8746,33215:8745,33224:8743,33225:8744,33226:172,33227:8658,33228:8660,33229:8704,33230:8707,33242:8736,33243:8869,33244:8978,33245:8706,33246:8711,33247:8801,33248:8786,33249:8810,33250:8811,33251:8730,33252:8765,33253:8733,33254:8757,33255:8747,33256:8748,33264:8491,33265:8240,33266:9839,33267:9837,33268:9834,33269:8224,33270:8225,33271:182,33276:9711,33359:65296,33360:65297,33361:65298,33362:65299,33363:65300,33364:65301,33365:65302,33366:65303,33367:65304,33368:65305,33376:65313,33377:65314,33378:65315,33379:65316,33380:65317,33381:65318,33382:65319,33383:65320,33384:65321,33385:65322,33386:65323,33387:65324,33388:65325,33389:65326,33390:65327,33391:65328,33392:65329,33393:65330,33394:65331,33395:65332,33396:65333,33397:65334,33398:65335,33399:65336,33400:65337,33401:65338,33409:65345,33410:65346,33411:65347,33412:65348,33413:65349,33414:65350,33415:65351,33416:65352,33417:65353,33418:65354,33419:65355,33420:65356,33421:65357,33422:65358,33423:65359,33424:65360,33425:65361,33426:65362,33427:65363,33428:65364,33429:65365,33430:65366,33431:65367,33432:65368,33433:65369,33434:65370,33439:12353,33440:12354,33441:12355,33442:12356,33443:12357,33444:12358,33445:12359,33446:12360,33447:12361,33448:12362,33449:12363,33450:12364,33451:12365,33452:12366,33453:12367,33454:12368,33455:12369,33456:12370,33457:12371,33458:12372,33459:12373,33460:12374,33461:12375,33462:12376,33463:12377,33464:12378,33465:12379,33466:12380,33467:12381,33468:12382,33469:12383,33470:12384,33471:12385,33472:12386,33473:12387,33474:12388,33475:12389,33476:12390,33477:12391,33478:12392,33479:12393,33480:12394,33481:12395,33482:12396,33483:12397,33484:12398,33485:12399,33486:12400,33487:12401,33488:12402,33489:12403,33490:12404,33491:12405,33492:12406,33493:12407,33494:12408,33495:12409,33496:12410,33497:12411,33498:12412,33499:12413,33500:12414,33501:12415,33502:12416,33503:12417,33504:12418,33505:12419,33506:12420,33507:12421,33508:12422,33509:12423,33510:12424,33511:12425,33512:12426,33513:12427,33514:12428,33515:12429,33516:12430,33517:12431,33518:12432,33519:12433,33520:12434,33521:12435,33600:12449,33601:12450,33602:12451,33603:12452,33604:12453,33605:12454,33606:12455,33607:12456,33608:12457,33609:12458,33610:12459,33611:12460,33612:12461,33613:12462,33614:12463,33615:12464,33616:12465,33617:12466,33618:12467,33619:12468,33620:12469,33621:12470,33622:12471,33623:12472,33624:12473,33625:12474,33626:12475,33627:12476,33628:12477,33629:12478,33630:12479,33631:12480,33632:12481,33633:12482,33634:12483,33635:12484,33636:12485,33637:12486,33638:12487,33639:12488,33640:12489,33641:12490,33642:12491,33643:12492,33644:12493,33645:12494,33646:12495,33647:12496,33648:12497,33649:12498,33650:12499,33651:12500,33652:12501,33653:12502,33654:12503,33655:12504,33656:12505,33657:12506,33658:12507,33659:12508,33660:12509,33661:12510,33662:12511,33664:12512,33665:12513,33666:12514,33667:12515,33668:12516,33669:12517,33670:12518,33671:12519,33672:12520,33673:12521,33674:12522,33675:12523,33676:12524,33677:12525,33678:12526,33679:12527,33680:12528,33681:12529,33682:12530,33683:12531,33684:12532,33685:12533,33686:12534,33695:913,33696:914,33697:915,33698:916,33699:917,33700:918,33701:919,33702:920,33703:921,33704:922,33705:923,33706:924,33707:925,33708:926,33709:927,33710:928,33711:929,33712:931,33713:932,33714:933,33715:934,33716:935,33717:936,33718:937,33727:945,33728:946,33729:947,33730:948,33731:949,33732:950,33733:951,33734:952,33735:953,33736:954,33737:955,33738:956,33739:957,33740:958,33741:959,33742:960,33743:961,33744:963,33745:964,33746:965,33747:966,33748:967,33749:968,33750:969,33856:1040,33857:1041,33858:1042,33859:1043,33860:1044,33861:1045,33862:1025,33863:1046,33864:1047,33865:1048,33866:1049,33867:1050,33868:1051,33869:1052,33870:1053,33871:1054,33872:1055,33873:1056,33874:1057,33875:1058,33876:1059,33877:1060,33878:1061,33879:1062,33880:1063,33881:1064,33882:1065,33883:1066,33884:1067,33885:1068,33886:1069,33887:1070,33888:1071,33904:1072,33905:1073,33906:1074,33907:1075,33908:1076,33909:1077,33910:1105,33911:1078,33912:1079,33913:1080,33914:1081,33915:1082,33916:1083,33917:1084,33918:1085,33920:1086,33921:1087,33922:1088,33923:1089,33924:1090,33925:1091,33926:1092,33927:1093,33928:1094,33929:1095,33930:1096,33931:1097,33932:1098,33933:1099,33934:1100,33935:1101,33936:1102,33937:1103,33951:9472,33952:9474,33953:9484,33954:9488,33955:9496,33956:9492,33957:9500,33958:9516,33959:9508,33960:9524,33961:9532,33962:9473,33963:9475,33964:9487,33965:9491,33966:9499,33967:9495,33968:9507,33969:9523,33970:9515,33971:9531,33972:9547,33973:9504,33974:9519,33975:9512,33976:9527,33977:9535,33978:9501,33979:9520,33980:9509,33981:9528,33982:9538,34975:20124,34976:21782,34977:23043,34978:38463,34979:21696,34980:24859,34981:25384,34982:23030,34983:36898,34984:33909,34985:33564,34986:31312,34987:24746,34988:25569,34989:28197,34990:26093,34991:33894,34992:33446,34993:39925,34994:26771,34995:22311,34996:26017,34997:25201,34998:23451,34999:22992,35e3:34427,35001:39156,35002:32098,35003:32190,35004:39822,35005:25110,35006:31903,35007:34999,35008:23433,35009:24245,35010:25353,35011:26263,35012:26696,35013:38343,35014:38797,35015:26447,35016:20197,35017:20234,35018:20301,35019:20381,35020:20553,35021:22258,35022:22839,35023:22996,35024:23041,35025:23561,35026:24799,35027:24847,35028:24944,35029:26131,35030:26885,35031:28858,35032:30031,35033:30064,35034:31227,35035:32173,35036:32239,35037:32963,35038:33806,35039:34915,35040:35586,35041:36949,35042:36986,35043:21307,35044:20117,35045:20133,35046:22495,35047:32946,35048:37057,35049:30959,35050:19968,35051:22769,35052:28322,35053:36920,35054:31282,35055:33576,35056:33419,35057:39983,35058:20801,35059:21360,35060:21693,35061:21729,35062:22240,35063:23035,35064:24341,35065:39154,35066:28139,35067:32996,35068:34093,35136:38498,35137:38512,35138:38560,35139:38907,35140:21515,35141:21491,35142:23431,35143:28879,35144:32701,35145:36802,35146:38632,35147:21359,35148:40284,35149:31418,35150:19985,35151:30867,35152:33276,35153:28198,35154:22040,35155:21764,35156:27421,35157:34074,35158:39995,35159:23013,35160:21417,35161:28006,35162:29916,35163:38287,35164:22082,35165:20113,35166:36939,35167:38642,35168:33615,35169:39180,35170:21473,35171:21942,35172:23344,35173:24433,35174:26144,35175:26355,35176:26628,35177:27704,35178:27891,35179:27945,35180:29787,35181:30408,35182:31310,35183:38964,35184:33521,35185:34907,35186:35424,35187:37613,35188:28082,35189:30123,35190:30410,35191:39365,35192:24742,35193:35585,35194:36234,35195:38322,35196:27022,35197:21421,35198:20870,35200:22290,35201:22576,35202:22852,35203:23476,35204:24310,35205:24616,35206:25513,35207:25588,35208:27839,35209:28436,35210:28814,35211:28948,35212:29017,35213:29141,35214:29503,35215:32257,35216:33398,35217:33489,35218:34199,35219:36960,35220:37467,35221:40219,35222:22633,35223:26044,35224:27738,35225:29989,35226:20985,35227:22830,35228:22885,35229:24448,35230:24540,35231:25276,35232:26106,35233:27178,35234:27431,35235:27572,35236:29579,35237:32705,35238:35158,35239:40236,35240:40206,35241:40644,35242:23713,35243:27798,35244:33659,35245:20740,35246:23627,35247:25014,35248:33222,35249:26742,35250:29281,35251:20057,35252:20474,35253:21368,35254:24681,35255:28201,35256:31311,35257:38899,35258:19979,35259:21270,35260:20206,35261:20309,35262:20285,35263:20385,35264:20339,35265:21152,35266:21487,35267:22025,35268:22799,35269:23233,35270:23478,35271:23521,35272:31185,35273:26247,35274:26524,35275:26550,35276:27468,35277:27827,35278:28779,35279:29634,35280:31117,35281:31166,35282:31292,35283:31623,35284:33457,35285:33499,35286:33540,35287:33655,35288:33775,35289:33747,35290:34662,35291:35506,35292:22057,35293:36008,35294:36838,35295:36942,35296:38686,35297:34442,35298:20420,35299:23784,35300:25105,35301:29273,35302:30011,35303:33253,35304:33469,35305:34558,35306:36032,35307:38597,35308:39187,35309:39381,35310:20171,35311:20250,35312:35299,35313:22238,35314:22602,35315:22730,35316:24315,35317:24555,35318:24618,35319:24724,35320:24674,35321:25040,35322:25106,35323:25296,35324:25913,35392:39745,35393:26214,35394:26800,35395:28023,35396:28784,35397:30028,35398:30342,35399:32117,35400:33445,35401:34809,35402:38283,35403:38542,35404:35997,35405:20977,35406:21182,35407:22806,35408:21683,35409:23475,35410:23830,35411:24936,35412:27010,35413:28079,35414:30861,35415:33995,35416:34903,35417:35442,35418:37799,35419:39608,35420:28012,35421:39336,35422:34521,35423:22435,35424:26623,35425:34510,35426:37390,35427:21123,35428:22151,35429:21508,35430:24275,35431:25313,35432:25785,35433:26684,35434:26680,35435:27579,35436:29554,35437:30906,35438:31339,35439:35226,35440:35282,35441:36203,35442:36611,35443:37101,35444:38307,35445:38548,35446:38761,35447:23398,35448:23731,35449:27005,35450:38989,35451:38990,35452:25499,35453:31520,35454:27179,35456:27263,35457:26806,35458:39949,35459:28511,35460:21106,35461:21917,35462:24688,35463:25324,35464:27963,35465:28167,35466:28369,35467:33883,35468:35088,35469:36676,35470:19988,35471:39993,35472:21494,35473:26907,35474:27194,35475:38788,35476:26666,35477:20828,35478:31427,35479:33970,35480:37340,35481:37772,35482:22107,35483:40232,35484:26658,35485:33541,35486:33841,35487:31909,35488:21e3,35489:33477,35490:29926,35491:20094,35492:20355,35493:20896,35494:23506,35495:21002,35496:21208,35497:21223,35498:24059,35499:21914,35500:22570,35501:23014,35502:23436,35503:23448,35504:23515,35505:24178,35506:24185,35507:24739,35508:24863,35509:24931,35510:25022,35511:25563,35512:25954,35513:26577,35514:26707,35515:26874,35516:27454,35517:27475,35518:27735,35519:28450,35520:28567,35521:28485,35522:29872,35523:29976,35524:30435,35525:30475,35526:31487,35527:31649,35528:31777,35529:32233,35530:32566,35531:32752,35532:32925,35533:33382,35534:33694,35535:35251,35536:35532,35537:36011,35538:36996,35539:37969,35540:38291,35541:38289,35542:38306,35543:38501,35544:38867,35545:39208,35546:33304,35547:20024,35548:21547,35549:23736,35550:24012,35551:29609,35552:30284,35553:30524,35554:23721,35555:32747,35556:36107,35557:38593,35558:38929,35559:38996,35560:39e3,35561:20225,35562:20238,35563:21361,35564:21916,35565:22120,35566:22522,35567:22855,35568:23305,35569:23492,35570:23696,35571:24076,35572:24190,35573:24524,35574:25582,35575:26426,35576:26071,35577:26082,35578:26399,35579:26827,35580:26820,35648:27231,35649:24112,35650:27589,35651:27671,35652:27773,35653:30079,35654:31048,35655:23395,35656:31232,35657:32e3,35658:24509,35659:35215,35660:35352,35661:36020,35662:36215,35663:36556,35664:36637,35665:39138,35666:39438,35667:39740,35668:20096,35669:20605,35670:20736,35671:22931,35672:23452,35673:25135,35674:25216,35675:25836,35676:27450,35677:29344,35678:30097,35679:31047,35680:32681,35681:34811,35682:35516,35683:35696,35684:25516,35685:33738,35686:38816,35687:21513,35688:21507,35689:21931,35690:26708,35691:27224,35692:35440,35693:30759,35694:26485,35695:40653,35696:21364,35697:23458,35698:33050,35699:34384,35700:36870,35701:19992,35702:20037,35703:20167,35704:20241,35705:21450,35706:21560,35707:23470,35708:24339,35709:24613,35710:25937,35712:26429,35713:27714,35714:27762,35715:27875,35716:28792,35717:29699,35718:31350,35719:31406,35720:31496,35721:32026,35722:31998,35723:32102,35724:26087,35725:29275,35726:21435,35727:23621,35728:24040,35729:25298,35730:25312,35731:25369,35732:28192,35733:34394,35734:35377,35735:36317,35736:37624,35737:28417,35738:31142,35739:39770,35740:20136,35741:20139,35742:20140,35743:20379,35744:20384,35745:20689,35746:20807,35747:31478,35748:20849,35749:20982,35750:21332,35751:21281,35752:21375,35753:21483,35754:21932,35755:22659,35756:23777,35757:24375,35758:24394,35759:24623,35760:24656,35761:24685,35762:25375,35763:25945,35764:27211,35765:27841,35766:29378,35767:29421,35768:30703,35769:33016,35770:33029,35771:33288,35772:34126,35773:37111,35774:37857,35775:38911,35776:39255,35777:39514,35778:20208,35779:20957,35780:23597,35781:26241,35782:26989,35783:23616,35784:26354,35785:26997,35786:29577,35787:26704,35788:31873,35789:20677,35790:21220,35791:22343,35792:24062,35793:37670,35794:26020,35795:27427,35796:27453,35797:29748,35798:31105,35799:31165,35800:31563,35801:32202,35802:33465,35803:33740,35804:34943,35805:35167,35806:35641,35807:36817,35808:37329,35809:21535,35810:37504,35811:20061,35812:20534,35813:21477,35814:21306,35815:29399,35816:29590,35817:30697,35818:33510,35819:36527,35820:39366,35821:39368,35822:39378,35823:20855,35824:24858,35825:34398,35826:21936,35827:31354,35828:20598,35829:23507,35830:36935,35831:38533,35832:20018,35833:27355,35834:37351,35835:23633,35836:23624,35904:25496,35905:31391,35906:27795,35907:38772,35908:36705,35909:31402,35910:29066,35911:38536,35912:31874,35913:26647,35914:32368,35915:26705,35916:37740,35917:21234,35918:21531,35919:34219,35920:35347,35921:32676,35922:36557,35923:37089,35924:21350,35925:34952,35926:31041,35927:20418,35928:20670,35929:21009,35930:20804,35931:21843,35932:22317,35933:29674,35934:22411,35935:22865,35936:24418,35937:24452,35938:24693,35939:24950,35940:24935,35941:25001,35942:25522,35943:25658,35944:25964,35945:26223,35946:26690,35947:28179,35948:30054,35949:31293,35950:31995,35951:32076,35952:32153,35953:32331,35954:32619,35955:33550,35956:33610,35957:34509,35958:35336,35959:35427,35960:35686,35961:36605,35962:38938,35963:40335,35964:33464,35965:36814,35966:39912,35968:21127,35969:25119,35970:25731,35971:28608,35972:38553,35973:26689,35974:20625,35975:27424,35976:27770,35977:28500,35978:31348,35979:32080,35980:34880,35981:35363,35982:26376,35983:20214,35984:20537,35985:20518,35986:20581,35987:20860,35988:21048,35989:21091,35990:21927,35991:22287,35992:22533,35993:23244,35994:24314,35995:25010,35996:25080,35997:25331,35998:25458,35999:26908,36e3:27177,36001:29309,36002:29356,36003:29486,36004:30740,36005:30831,36006:32121,36007:30476,36008:32937,36009:35211,36010:35609,36011:36066,36012:36562,36013:36963,36014:37749,36015:38522,36016:38997,36017:39443,36018:40568,36019:20803,36020:21407,36021:21427,36022:24187,36023:24358,36024:28187,36025:28304,36026:29572,36027:29694,36028:32067,36029:33335,36030:35328,36031:35578,36032:38480,36033:20046,36034:20491,36035:21476,36036:21628,36037:22266,36038:22993,36039:23396,36040:24049,36041:24235,36042:24359,\n36043:25144,36044:25925,36045:26543,36046:28246,36047:29392,36048:31946,36049:34996,36050:32929,36051:32993,36052:33776,36053:34382,36054:35463,36055:36328,36056:37431,36057:38599,36058:39015,36059:40723,36060:20116,36061:20114,36062:20237,36063:21320,36064:21577,36065:21566,36066:23087,36067:24460,36068:24481,36069:24735,36070:26791,36071:27278,36072:29786,36073:30849,36074:35486,36075:35492,36076:35703,36077:37264,36078:20062,36079:39881,36080:20132,36081:20348,36082:20399,36083:20505,36084:20502,36085:20809,36086:20844,36087:21151,36088:21177,36089:21246,36090:21402,36091:21475,36092:21521,36160:21518,36161:21897,36162:22353,36163:22434,36164:22909,36165:23380,36166:23389,36167:23439,36168:24037,36169:24039,36170:24055,36171:24184,36172:24195,36173:24218,36174:24247,36175:24344,36176:24658,36177:24908,36178:25239,36179:25304,36180:25511,36181:25915,36182:26114,36183:26179,36184:26356,36185:26477,36186:26657,36187:26775,36188:27083,36189:27743,36190:27946,36191:28009,36192:28207,36193:28317,36194:30002,36195:30343,36196:30828,36197:31295,36198:31968,36199:32005,36200:32024,36201:32094,36202:32177,36203:32789,36204:32771,36205:32943,36206:32945,36207:33108,36208:33167,36209:33322,36210:33618,36211:34892,36212:34913,36213:35611,36214:36002,36215:36092,36216:37066,36217:37237,36218:37489,36219:30783,36220:37628,36221:38308,36222:38477,36224:38917,36225:39321,36226:39640,36227:40251,36228:21083,36229:21163,36230:21495,36231:21512,36232:22741,36233:25335,36234:28640,36235:35946,36236:36703,36237:40633,36238:20811,36239:21051,36240:21578,36241:22269,36242:31296,36243:37239,36244:40288,36245:40658,36246:29508,36247:28425,36248:33136,36249:29969,36250:24573,36251:24794,36252:39592,36253:29403,36254:36796,36255:27492,36256:38915,36257:20170,36258:22256,36259:22372,36260:22718,36261:23130,36262:24680,36263:25031,36264:26127,36265:26118,36266:26681,36267:26801,36268:28151,36269:30165,36270:32058,36271:33390,36272:39746,36273:20123,36274:20304,36275:21449,36276:21766,36277:23919,36278:24038,36279:24046,36280:26619,36281:27801,36282:29811,36283:30722,36284:35408,36285:37782,36286:35039,36287:22352,36288:24231,36289:25387,36290:20661,36291:20652,36292:20877,36293:26368,36294:21705,36295:22622,36296:22971,36297:23472,36298:24425,36299:25165,36300:25505,36301:26685,36302:27507,36303:28168,36304:28797,36305:37319,36306:29312,36307:30741,36308:30758,36309:31085,36310:25998,36311:32048,36312:33756,36313:35009,36314:36617,36315:38555,36316:21092,36317:22312,36318:26448,36319:32618,36320:36001,36321:20916,36322:22338,36323:38442,36324:22586,36325:27018,36326:32948,36327:21682,36328:23822,36329:22524,36330:30869,36331:40442,36332:20316,36333:21066,36334:21643,36335:25662,36336:26152,36337:26388,36338:26613,36339:31364,36340:31574,36341:32034,36342:37679,36343:26716,36344:39853,36345:31545,36346:21273,36347:20874,36348:21047,36416:23519,36417:25334,36418:25774,36419:25830,36420:26413,36421:27578,36422:34217,36423:38609,36424:30352,36425:39894,36426:25420,36427:37638,36428:39851,36429:30399,36430:26194,36431:19977,36432:20632,36433:21442,36434:23665,36435:24808,36436:25746,36437:25955,36438:26719,36439:29158,36440:29642,36441:29987,36442:31639,36443:32386,36444:34453,36445:35715,36446:36059,36447:37240,36448:39184,36449:26028,36450:26283,36451:27531,36452:20181,36453:20180,36454:20282,36455:20351,36456:21050,36457:21496,36458:21490,36459:21987,36460:22235,36461:22763,36462:22987,36463:22985,36464:23039,36465:23376,36466:23629,36467:24066,36468:24107,36469:24535,36470:24605,36471:25351,36472:25903,36473:23388,36474:26031,36475:26045,36476:26088,36477:26525,36478:27490,36480:27515,36481:27663,36482:29509,36483:31049,36484:31169,36485:31992,36486:32025,36487:32043,36488:32930,36489:33026,36490:33267,36491:35222,36492:35422,36493:35433,36494:35430,36495:35468,36496:35566,36497:36039,36498:36060,36499:38604,36500:39164,36501:27503,36502:20107,36503:20284,36504:20365,36505:20816,36506:23383,36507:23546,36508:24904,36509:25345,36510:26178,36511:27425,36512:28363,36513:27835,36514:29246,36515:29885,36516:30164,36517:30913,36518:31034,36519:32780,36520:32819,36521:33258,36522:33940,36523:36766,36524:27728,36525:40575,36526:24335,36527:35672,36528:40235,36529:31482,36530:36600,36531:23437,36532:38635,36533:19971,36534:21489,36535:22519,36536:22833,36537:23241,36538:23460,36539:24713,36540:28287,36541:28422,36542:30142,36543:36074,36544:23455,36545:34048,36546:31712,36547:20594,36548:26612,36549:33437,36550:23649,36551:34122,36552:32286,36553:33294,36554:20889,36555:23556,36556:25448,36557:36198,36558:26012,36559:29038,36560:31038,36561:32023,36562:32773,36563:35613,36564:36554,36565:36974,36566:34503,36567:37034,36568:20511,36569:21242,36570:23610,36571:26451,36572:28796,36573:29237,36574:37196,36575:37320,36576:37675,36577:33509,36578:23490,36579:24369,36580:24825,36581:20027,36582:21462,36583:23432,36584:25163,36585:26417,36586:27530,36587:29417,36588:29664,36589:31278,36590:33131,36591:36259,36592:37202,36593:39318,36594:20754,36595:21463,36596:21610,36597:23551,36598:25480,36599:27193,36600:32172,36601:38656,36602:22234,36603:21454,36604:21608,36672:23447,36673:23601,36674:24030,36675:20462,36676:24833,36677:25342,36678:27954,36679:31168,36680:31179,36681:32066,36682:32333,36683:32722,36684:33261,36685:33311,36686:33936,36687:34886,36688:35186,36689:35728,36690:36468,36691:36655,36692:36913,36693:37195,36694:37228,36695:38598,36696:37276,36697:20160,36698:20303,36699:20805,36700:21313,36701:24467,36702:25102,36703:26580,36704:27713,36705:28171,36706:29539,36707:32294,36708:37325,36709:37507,36710:21460,36711:22809,36712:23487,36713:28113,36714:31069,36715:32302,36716:31899,36717:22654,36718:29087,36719:20986,36720:34899,36721:36848,36722:20426,36723:23803,36724:26149,36725:30636,36726:31459,36727:33308,36728:39423,36729:20934,36730:24490,36731:26092,36732:26991,36733:27529,36734:28147,36736:28310,36737:28516,36738:30462,36739:32020,36740:24033,36741:36981,36742:37255,36743:38918,36744:20966,36745:21021,36746:25152,36747:26257,36748:26329,36749:28186,36750:24246,36751:32210,36752:32626,36753:26360,36754:34223,36755:34295,36756:35576,36757:21161,36758:21465,36759:22899,36760:24207,36761:24464,36762:24661,36763:37604,36764:38500,36765:20663,36766:20767,36767:21213,36768:21280,36769:21319,36770:21484,36771:21736,36772:21830,36773:21809,36774:22039,36775:22888,36776:22974,36777:23100,36778:23477,36779:23558,36780:23567,36781:23569,36782:23578,36783:24196,36784:24202,36785:24288,36786:24432,36787:25215,36788:25220,36789:25307,36790:25484,36791:25463,36792:26119,36793:26124,36794:26157,36795:26230,36796:26494,36797:26786,36798:27167,36799:27189,36800:27836,36801:28040,36802:28169,36803:28248,36804:28988,36805:28966,36806:29031,36807:30151,36808:30465,36809:30813,36810:30977,36811:31077,36812:31216,36813:31456,36814:31505,36815:31911,36816:32057,36817:32918,36818:33750,36819:33931,36820:34121,36821:34909,36822:35059,36823:35359,36824:35388,36825:35412,36826:35443,36827:35937,36828:36062,36829:37284,36830:37478,36831:37758,36832:37912,36833:38556,36834:38808,36835:19978,36836:19976,36837:19998,36838:20055,36839:20887,36840:21104,36841:22478,36842:22580,36843:22732,36844:23330,36845:24120,36846:24773,36847:25854,36848:26465,36849:26454,36850:27972,36851:29366,36852:30067,36853:31331,36854:33976,36855:35698,36856:37304,36857:37664,36858:22065,36859:22516,36860:39166,36928:25325,36929:26893,36930:27542,36931:29165,36932:32340,36933:32887,36934:33394,36935:35302,36936:39135,36937:34645,36938:36785,36939:23611,36940:20280,36941:20449,36942:20405,36943:21767,36944:23072,36945:23517,36946:23529,36947:24515,36948:24910,36949:25391,36950:26032,36951:26187,36952:26862,36953:27035,36954:28024,36955:28145,36956:30003,36957:30137,36958:30495,36959:31070,36960:31206,36961:32051,36962:33251,36963:33455,36964:34218,36965:35242,36966:35386,36967:36523,36968:36763,36969:36914,36970:37341,36971:38663,36972:20154,36973:20161,36974:20995,36975:22645,36976:22764,36977:23563,36978:29978,36979:23613,36980:33102,36981:35338,36982:36805,36983:38499,36984:38765,36985:31525,36986:35535,36987:38920,36988:37218,36989:22259,36990:21416,36992:36887,36993:21561,36994:22402,36995:24101,36996:25512,36997:27700,36998:28810,36999:30561,37e3:31883,37001:32736,37002:34928,37003:36930,37004:37204,37005:37648,37006:37656,37007:38543,37008:29790,37009:39620,37010:23815,37011:23913,37012:25968,37013:26530,37014:36264,37015:38619,37016:25454,37017:26441,37018:26905,37019:33733,37020:38935,37021:38592,37022:35070,37023:28548,37024:25722,37025:23544,37026:19990,37027:28716,37028:30045,37029:26159,37030:20932,37031:21046,37032:21218,37033:22995,37034:24449,37035:24615,37036:25104,37037:25919,37038:25972,37039:26143,37040:26228,37041:26866,37042:26646,37043:27491,37044:28165,37045:29298,37046:29983,37047:30427,37048:31934,37049:32854,37050:22768,37051:35069,37052:35199,37053:35488,37054:35475,37055:35531,37056:36893,37057:37266,37058:38738,37059:38745,37060:25993,37061:31246,37062:33030,37063:38587,37064:24109,37065:24796,37066:25114,37067:26021,37068:26132,37069:26512,37070:30707,37071:31309,37072:31821,37073:32318,37074:33034,37075:36012,37076:36196,37077:36321,37078:36447,37079:30889,37080:20999,37081:25305,37082:25509,37083:25666,37084:25240,37085:35373,37086:31363,37087:31680,37088:35500,37089:38634,37090:32118,37091:33292,37092:34633,37093:20185,37094:20808,37095:21315,37096:21344,37097:23459,37098:23554,37099:23574,37100:24029,37101:25126,37102:25159,37103:25776,37104:26643,37105:26676,37106:27849,37107:27973,37108:27927,37109:26579,37110:28508,37111:29006,37112:29053,37113:26059,37114:31359,37115:31661,37116:32218,37184:32330,37185:32680,37186:33146,37187:33307,37188:33337,37189:34214,37190:35438,37191:36046,37192:36341,37193:36984,37194:36983,37195:37549,37196:37521,37197:38275,37198:39854,37199:21069,37200:21892,37201:28472,37202:28982,37203:20840,37204:31109,37205:32341,37206:33203,37207:31950,37208:22092,37209:22609,37210:23720,37211:25514,37212:26366,37213:26365,37214:26970,37215:29401,37216:30095,37217:30094,37218:30990,37219:31062,37220:31199,37221:31895,37222:32032,37223:32068,37224:34311,37225:35380,37226:38459,37227:36961,37228:40736,37229:20711,37230:21109,37231:21452,37232:21474,37233:20489,37234:21930,37235:22766,37236:22863,37237:29245,37238:23435,37239:23652,37240:21277,37241:24803,37242:24819,37243:25436,37244:25475,37245:25407,37246:25531,37248:25805,37249:26089,37250:26361,37251:24035,37252:27085,37253:27133,37254:28437,37255:29157,37256:20105,37257:30185,37258:30456,37259:31379,37260:31967,37261:32207,37262:32156,37263:32865,37264:33609,37265:33624,37266:33900,37267:33980,37268:34299,37269:35013,37270:36208,37271:36865,37272:36973,37273:37783,37274:38684,37275:39442,37276:20687,37277:22679,37278:24974,37279:33235,37280:34101,37281:36104,37282:36896,37283:20419,37284:20596,37285:21063,37286:21363,37287:24687,37288:25417,37289:26463,37290:28204,37291:36275,37292:36895,37293:20439,37294:23646,37295:36042,37296:26063,37297:32154,37298:21330,37299:34966,37300:20854,37301:25539,37302:23384,37303:23403,37304:23562,37305:25613,37306:26449,37307:36956,37308:20182,37309:22810,37310:22826,37311:27760,37312:35409,37313:21822,37314:22549,37315:22949,37316:24816,37317:25171,37318:26561,37319:33333,37320:26965,37321:38464,37322:39364,37323:39464,37324:20307,37325:22534,37326:23550,37327:32784,37328:23729,37329:24111,37330:24453,37331:24608,37332:24907,37333:25140,37334:26367,37335:27888,37336:28382,37337:32974,37338:33151,37339:33492,37340:34955,37341:36024,37342:36864,37343:36910,37344:38538,37345:40667,37346:39899,37347:20195,37348:21488,37349:22823,37350:31532,37351:37261,37352:38988,37353:40441,37354:28381,37355:28711,37356:21331,37357:21828,37358:23429,37359:25176,37360:25246,37361:25299,37362:27810,37363:28655,37364:29730,37365:35351,37366:37944,37367:28609,37368:35582,37369:33592,37370:20967,37371:34552,37372:21482,37440:21481,37441:20294,37442:36948,37443:36784,37444:22890,37445:33073,37446:24061,37447:31466,37448:36799,37449:26842,37450:35895,37451:29432,37452:40008,37453:27197,37454:35504,37455:20025,37456:21336,37457:22022,37458:22374,37459:25285,37460:25506,37461:26086,37462:27470,37463:28129,37464:28251,37465:28845,37466:30701,37467:31471,37468:31658,37469:32187,37470:32829,37471:32966,37472:34507,37473:35477,37474:37723,37475:22243,37476:22727,37477:24382,37478:26029,37479:26262,37480:27264,37481:27573,37482:30007,37483:35527,37484:20516,37485:30693,37486:22320,37487:24347,37488:24677,37489:26234,37490:27744,37491:30196,37492:31258,37493:32622,37494:33268,37495:34584,37496:36933,37497:39347,37498:31689,37499:30044,37500:31481,37501:31569,37502:33988,37504:36880,37505:31209,37506:31378,37507:33590,37508:23265,37509:30528,37510:20013,37511:20210,37512:23449,37513:24544,37514:25277,37515:26172,37516:26609,37517:27880,37518:34411,37519:34935,37520:35387,37521:37198,37522:37619,37523:39376,37524:27159,37525:28710,37526:29482,37527:33511,37528:33879,37529:36015,37530:19969,37531:20806,37532:20939,37533:21899,37534:23541,37535:24086,37536:24115,37537:24193,37538:24340,37539:24373,37540:24427,37541:24500,37542:25074,37543:25361,37544:26274,37545:26397,37546:28526,37547:29266,37548:30010,37549:30522,37550:32884,37551:33081,37552:33144,37553:34678,37554:35519,37555:35548,37556:36229,37557:36339,37558:37530,37559:38263,37560:38914,37561:40165,37562:21189,37563:25431,37564:30452,37565:26389,37566:27784,37567:29645,37568:36035,37569:37806,37570:38515,37571:27941,37572:22684,37573:26894,37574:27084,37575:36861,37576:37786,37577:30171,37578:36890,37579:22618,37580:26626,37581:25524,37582:27131,37583:20291,37584:28460,37585:26584,37586:36795,37587:34086,37588:32180,37589:37716,37590:26943,37591:28528,37592:22378,37593:22775,37594:23340,37595:32044,37596:29226,37597:21514,37598:37347,37599:40372,37600:20141,37601:20302,37602:20572,37603:20597,37604:21059,37605:35998,37606:21576,37607:22564,37608:23450,37609:24093,37610:24213,37611:24237,37612:24311,37613:24351,37614:24716,37615:25269,37616:25402,37617:25552,37618:26799,37619:27712,37620:30855,37621:31118,37622:31243,37623:32224,37624:33351,37625:35330,37626:35558,37627:36420,37628:36883,37696:37048,37697:37165,37698:37336,37699:40718,37700:27877,37701:25688,37702:25826,37703:25973,37704:28404,37705:30340,37706:31515,37707:36969,37708:37841,37709:28346,37710:21746,37711:24505,37712:25764,37713:36685,37714:36845,37715:37444,37716:20856,37717:22635,37718:22825,37719:23637,37720:24215,37721:28155,37722:32399,37723:29980,37724:36028,37725:36578,37726:39003,37727:28857,37728:20253,37729:27583,37730:28593,37731:3e4,37732:38651,37733:20814,37734:21520,37735:22581,37736:22615,37737:22956,37738:23648,37739:24466,37740:26007,37741:26460,37742:28193,37743:30331,37744:33759,37745:36077,37746:36884,37747:37117,37748:37709,37749:30757,37750:30778,37751:21162,37752:24230,37753:22303,37754:22900,37755:24594,37756:20498,37757:20826,37758:20908,37760:20941,37761:20992,37762:21776,37763:22612,37764:22616,37765:22871,37766:23445,37767:23798,37768:23947,37769:24764,37770:25237,37771:25645,37772:26481,37773:26691,37774:26812,37775:26847,37776:30423,37777:28120,37778:28271,37779:28059,37780:28783,37781:29128,37782:24403,37783:30168,37784:31095,37785:31561,37786:31572,37787:31570,37788:31958,37789:32113,37790:21040,37791:33891,37792:34153,37793:34276,37794:35342,37795:35588,37796:35910,37797:36367,37798:36867,37799:36879,37800:37913,37801:38518,37802:38957,37803:39472,37804:38360,37805:20685,37806:21205,37807:21516,37808:22530,37809:23566,37810:24999,37811:25758,37812:27934,37813:30643,37814:31461,37815:33012,37816:33796,37817:36947,37818:37509,37819:23776,37820:40199,37821:21311,37822:24471,37823:24499,37824:28060,37825:29305,37826:30563,37827:31167,37828:31716,37829:27602,37830:29420,37831:35501,37832:26627,37833:27233,37834:20984,37835:31361,37836:26932,37837:23626,37838:40182,37839:33515,37840:23493,37841:37193,37842:28702,37843:22136,37844:23663,37845:24775,37846:25958,37847:27788,37848:35930,37849:36929,37850:38931,37851:21585,37852:26311,37853:37389,37854:22856,37855:37027,37856:20869,37857:20045,37858:20970,37859:34201,37860:35598,37861:28760,37862:25466,37863:37707,37864:26978,37865:39348,37866:32260,37867:30071,37868:21335,37869:26976,37870:36575,37871:38627,37872:27741,37873:20108,37874:23612,37875:24336,37876:36841,37877:21250,37878:36049,37879:32905,37880:34425,37881:24319,37882:26085,37883:20083,37884:20837,37952:22914,37953:23615,37954:38894,37955:20219,37956:22922,37957:24525,37958:35469,37959:28641,37960:31152,37961:31074,37962:23527,37963:33905,37964:29483,37965:29105,37966:24180,37967:24565,37968:25467,37969:25754,37970:29123,37971:31896,37972:20035,37973:24316,37974:20043,37975:22492,37976:22178,37977:24745,37978:28611,37979:32013,37980:33021,37981:33075,37982:33215,37983:36786,37984:35223,37985:34468,37986:24052,37987:25226,37988:25773,37989:35207,37990:26487,37991:27874,37992:27966,37993:29750,37994:30772,37995:23110,37996:32629,37997:33453,37998:39340,37999:20467,38e3:24259,38001:25309,38002:25490,38003:25943,38004:26479,38005:30403,38006:29260,38007:32972,38008:32954,38009:36649,38010:37197,38011:20493,38012:22521,38013:23186,38014:26757,38016:26995,38017:29028,38018:29437,38019:36023,38020:22770,38021:36064,38022:38506,38023:36889,38024:34687,38025:31204,38026:30695,38027:33833,38028:20271,38029:21093,38030:21338,38031:25293,38032:26575,38033:27850,38034:30333,38035:31636,38036:31893,38037:33334,38038:34180,38039:36843,38040:26333,38041:28448,38042:29190,38043:32283,38044:33707,38045:39361,38046:40614,38047:20989,38048:31665,38049:30834,38050:31672,38051:32903,38052:31560,38053:27368,38054:24161,38055:32908,38056:30033,38057:30048,38058:20843,38059:37474,38060:28300,38061:30330,38062:37271,38063:39658,38064:20240,38065:32624,38066:25244,38067:31567,38068:38309,38069:40169,38070:22138,38071:22617,38072:34532,38073:38588,38074:20276,38075:21028,38076:21322,38077:21453,38078:21467,38079:24070,38080:25644,38081:26001,38082:26495,38083:27710,38084:27726,38085:29256,38086:29359,38087:29677,38088:30036,38089:32321,38090:33324,38091:34281,38092:36009,38093:31684,38094:37318,38095:29033,38096:38930,38097:39151,38098:25405,38099:26217,38100:30058,38101:30436,38102:30928,38103:34115,38104:34542,38105:21290,38106:21329,38107:21542,38108:22915,38109:24199,38110:24444,38111:24754,38112:25161,38113:25209,38114:25259,38115:26e3,38116:27604,38117:27852,38118:30130,38119:30382,38120:30865,38121:31192,38122:32203,38123:32631,38124:32933,38125:34987,38126:35513,38127:36027,38128:36991,38129:38750,38130:39131,38131:27147,38132:31800,38133:20633,38134:23614,38135:24494,38136:26503,38137:27608,38138:29749,38139:30473,38140:32654,38208:40763,38209:26570,38210:31255,38211:21305,38212:30091,38213:39661,38214:24422,38215:33181,38216:33777,38217:32920,38218:24380,38219:24517,38220:30050,38221:31558,38222:36924,38223:26727,38224:23019,38225:23195,38226:32016,38227:30334,38228:35628,38229:20469,38230:24426,38231:27161,38232:27703,38233:28418,38234:29922,38235:31080,38236:34920,38237:35413,38238:35961,38239:24287,38240:25551,38241:30149,38242:31186,38243:33495,38244:37672,38245:37618,38246:33948,38247:34541,38248:39981,38249:21697,38250:24428,38251:25996,38252:27996,38253:28693,38254:36007,38255:36051,38256:38971,38257:25935,38258:29942,38259:19981,38260:20184,38261:22496,38262:22827,38263:23142,38264:23500,38265:20904,38266:24067,38267:24220,38268:24598,38269:25206,38270:25975,38272:26023,38273:26222,38274:28014,38275:29238,38276:31526,38277:33104,38278:33178,38279:33433,38280:35676,38281:36e3,38282:36070,38283:36212,38284:38428,38285:38468,38286:20398,38287:25771,38288:27494,38289:33310,38290:33889,38291:34154,38292:37096,38293:23553,38294:26963,38295:39080,38296:33914,38297:34135,38298:20239,38299:21103,38300:24489,38301:24133,38302:26381,38303:31119,38304:33145,38305:35079,38306:35206,38307:28149,38308:24343,38309:25173,38310:27832,38311:20175,38312:29289,38313:39826,38314:20998,38315:21563,38316:22132,38317:22707,38318:24996,38319:25198,38320:28954,38321:22894,38322:31881,38323:31966,38324:32027,38325:38640,38326:25991,38327:32862,38328:19993,38329:20341,38330:20853,38331:22592,38332:24163,38333:24179,38334:24330,38335:26564,38336:20006,38337:34109,38338:38281,38339:38491,38340:31859,38341:38913,38342:20731,38343:22721,38344:30294,38345:30887,38346:21029,38347:30629,38348:34065,38349:31622,38350:20559,38351:22793,38352:29255,38353:31687,38354:32232,38355:36794,38356:36820,38357:36941,38358:20415,38359:21193,38360:23081,38361:24321,38362:38829,38363:20445,38364:33303,38365:37610,38366:22275,38367:25429,38368:27497,38369:29995,38370:35036,38371:36628,38372:31298,38373:21215,38374:22675,38375:24917,38376:25098,38377:26286,38378:27597,38379:31807,38380:33769,38381:20515,38382:20472,38383:21253,38384:21574,38385:22577,38386:22857,38387:23453,38388:23792,38389:23791,38390:23849,38391:24214,38392:25265,38393:25447,38394:25918,38395:26041,38396:26379,38464:27861,38465:27873,38466:28921,38467:30770,38468:32299,38469:32990,38470:33459,38471:33804,38472:34028,38473:34562,38474:35090,38475:35370,38476:35914,38477:37030,38478:37586,38479:39165,38480:40179,38481:40300,38482:20047,38483:20129,38484:20621,38485:21078,38486:22346,38487:22952,38488:24125,38489:24536,38490:24537,38491:25151,38492:26292,38493:26395,38494:26576,38495:26834,38496:20882,38497:32033,38498:32938,38499:33192,38500:35584,38501:35980,38502:36031,38503:37502,38504:38450,38505:21536,38506:38956,38507:21271,38508:20693,38509:21340,38510:22696,38511:25778,38512:26420,38513:29287,38514:30566,38515:31302,38516:37350,38517:21187,38518:27809,38519:27526,38520:22528,38521:24140,38522:22868,38523:26412,38524:32763,38525:20961,38526:30406,38528:25705,38529:30952,38530:39764,38531:40635,38532:22475,38533:22969,38534:26151,38535:26522,38536:27598,38537:21737,38538:27097,38539:24149,38540:33180,38541:26517,38542:39850,38543:26622,38544:40018,38545:26717,38546:20134,38547:20451,38548:21448,38549:25273,38550:26411,38551:27819,38552:36804,38553:20397,38554:32365,38555:40639,38556:19975,38557:24930,38558:28288,38559:28459,38560:34067,38561:21619,38562:26410,38563:39749,38564:24051,38565:31637,38566:23724,38567:23494,38568:34588,38569:28234,38570:34001,38571:31252,38572:33032,38573:22937,38574:31885,38575:27665,38576:30496,38577:21209,38578:22818,38579:28961,38580:29279,38581:30683,38582:38695,38583:40289,38584:26891,38585:23167,38586:23064,38587:20901,38588:21517,38589:21629,38590:26126,38591:30431,38592:36855,38593:37528,38594:40180,38595:23018,38596:29277,38597:28357,38598:20813,38599:26825,38600:32191,38601:32236,38602:38754,38603:40634,38604:25720,38605:27169,38606:33538,38607:22916,38608:23391,38609:27611,38610:29467,38611:30450,38612:32178,38613:32791,38614:33945,38615:20786,38616:26408,38617:40665,38618:30446,38619:26466,38620:21247,38621:39173,38622:23588,38623:25147,38624:31870,38625:36016,38626:21839,38627:24758,38628:32011,38629:38272,38630:21249,38631:20063,38632:20918,38633:22812,38634:29242,38635:32822,38636:37326,38637:24357,38638:30690,38639:21380,38640:24441,38641:32004,38642:34220,38643:35379,38644:36493,38645:38742,38646:26611,38647:34222,38648:37971,38649:24841,38650:24840,38651:27833,38652:30290,38720:35565,38721:36664,38722:21807,38723:20305,38724:20778,38725:21191,38726:21451,38727:23461,38728:24189,38729:24736,38730:24962,38731:25558,38732:26377,38733:26586,38734:28263,38735:28044,38736:29494,38737:29495,38738:30001,38739:31056,38740:35029,38741:35480,38742:36938,38743:37009,38744:37109,38745:38596,38746:34701,38747:22805,38748:20104,38749:20313,38750:19982,38751:35465,38752:36671,38753:38928,38754:20653,38755:24188,38756:22934,38757:23481,38758:24248,38759:25562,38760:25594,38761:25793,38762:26332,38763:26954,38764:27096,38765:27915,38766:28342,38767:29076,38768:29992,38769:31407,38770:32650,38771:32768,38772:33865,38773:33993,38774:35201,38775:35617,38776:36362,38777:36965,38778:38525,38779:39178,38780:24958,38781:25233,38782:27442,38784:27779,38785:28020,38786:32716,38787:32764,38788:28096,38789:32645,38790:34746,38791:35064,38792:26469,38793:33713,38794:38972,38795:38647,38796:27931,38797:32097,38798:33853,38799:37226,38800:20081,38801:21365,38802:23888,38803:27396,38804:28651,38805:34253,38806:34349,38807:35239,38808:21033,38809:21519,38810:23653,38811:26446,38812:26792,38813:29702,38814:29827,38815:30178,38816:35023,38817:35041,38818:37324,38819:38626,38820:38520,38821:24459,38822:29575,38823:31435,38824:33870,38825:25504,38826:30053,38827:21129,38828:27969,38829:28316,38830:29705,38831:30041,38832:30827,38833:31890,38834:38534,38835:31452,38836:40845,38837:20406,38838:24942,38839:26053,38840:34396,38841:20102,38842:20142,38843:20698,38844:20001,38845:20940,38846:23534,38847:26009,38848:26753,38849:28092,38850:29471,38851:30274,38852:30637,38853:31260,38854:31975,38855:33391,38856:35538,38857:36988,38858:37327,38859:38517,38860:38936,38861:21147,38862:32209,38863:20523,38864:21400,38865:26519,38866:28107,38867:29136,38868:29747,38869:33256,38870:36650,38871:38563,38872:40023,38873:40607,38874:29792,38875:22593,38876:28057,38877:32047,38878:39006,38879:20196,38880:20278,38881:20363,38882:20919,38883:21169,38884:23994,38885:24604,38886:29618,38887:31036,38888:33491,38889:37428,38890:38583,38891:38646,38892:38666,38893:40599,38894:40802,38895:26278,38896:27508,38897:21015,38898:21155,38899:28872,38900:35010,38901:24265,38902:24651,38903:24976,38904:28451,38905:29001,38906:31806,38907:32244,38908:32879,38976:34030,38977:36899,38978:37676,38979:21570,38980:39791,38981:27347,38982:28809,38983:36034,38984:36335,38985:38706,38986:21172,38987:23105,38988:24266,38989:24324,38990:26391,38991:27004,38992:27028,38993:28010,38994:28431,38995:29282,38996:29436,38997:31725,38998:32769,38999:32894,39e3:34635,39001:37070,39002:20845,39003:40595,39004:31108,39005:32907,39006:37682,39007:35542,39008:20525,39009:21644,39010:35441,39011:27498,39012:36036,39013:33031,39014:24785,39015:26528,39016:40434,39017:20121,39018:20120,39019:39952,39020:35435,39021:34241,39022:34152,39023:26880,39024:28286,39025:30871,39026:33109,39071:24332,39072:19984,39073:19989,39074:20010,39075:20017,39076:20022,39077:20028,39078:20031,39079:20034,39080:20054,39081:20056,39082:20098,39083:20101,39084:35947,39085:20106,39086:33298,39087:24333,39088:20110,39089:20126,39090:20127,39091:20128,39092:20130,39093:20144,39094:20147,39095:20150,39096:20174,39097:20173,39098:20164,39099:20166,39100:20162,39101:20183,39102:20190,39103:20205,39104:20191,39105:20215,39106:20233,39107:20314,39108:20272,39109:20315,39110:20317,39111:20311,39112:20295,39113:20342,39114:20360,39115:20367,39116:20376,39117:20347,39118:20329,39119:20336,39120:20369,39121:20335,39122:20358,39123:20374,39124:20760,39125:20436,39126:20447,39127:20430,39128:20440,39129:20443,39130:20433,39131:20442,39132:20432,39133:20452,39134:20453,39135:20506,39136:20520,39137:20500,39138:20522,39139:20517,39140:20485,39141:20252,39142:20470,39143:20513,39144:20521,39145:20524,39146:20478,39147:20463,39148:20497,39149:20486,39150:20547,39151:20551,39152:26371,39153:20565,39154:20560,39155:20552,39156:20570,39157:20566,39158:20588,39159:20600,39160:20608,39161:20634,39162:20613,39163:20660,39164:20658,39232:20681,39233:20682,39234:20659,39235:20674,39236:20694,39237:20702,39238:20709,39239:20717,39240:20707,39241:20718,39242:20729,39243:20725,39244:20745,39245:20737,39246:20738,39247:20758,39248:20757,39249:20756,39250:20762,39251:20769,39252:20794,39253:20791,39254:20796,39255:20795,39256:20799,39257:20800,39258:20818,39259:20812,39260:20820,39261:20834,39262:31480,39263:20841,39264:20842,39265:20846,39266:20864,39267:20866,39268:22232,39269:20876,39270:20873,39271:20879,39272:20881,39273:20883,39274:20885,39275:20886,39276:20900,39277:20902,39278:20898,39279:20905,39280:20906,39281:20907,39282:20915,39283:20913,39284:20914,39285:20912,39286:20917,39287:20925,39288:20933,39289:20937,39290:20955,39291:20960,39292:34389,39293:20969,39294:20973,39296:20976,39297:20981,39298:20990,39299:20996,39300:21003,39301:21012,39302:21006,39303:21031,39304:21034,39305:21038,39306:21043,39307:21049,39308:21071,39309:21060,39310:21067,39311:21068,39312:21086,39313:21076,39314:21098,39315:21108,39316:21097,39317:21107,39318:21119,39319:21117,39320:21133,39321:21140,39322:21138,39323:21105,39324:21128,39325:21137,39326:36776,39327:36775,39328:21164,39329:21165,39330:21180,39331:21173,39332:21185,39333:21197,39334:21207,39335:21214,39336:21219,39337:21222,39338:39149,39339:21216,39340:21235,39341:21237,39342:21240,39343:21241,39344:21254,39345:21256,39346:30008,39347:21261,39348:21264,39349:21263,39350:21269,39351:21274,39352:21283,39353:21295,39354:21297,39355:21299,39356:21304,39357:21312,39358:21318,39359:21317,39360:19991,39361:21321,39362:21325,39363:20950,39364:21342,39365:21353,39366:21358,39367:22808,39368:21371,39369:21367,39370:21378,39371:21398,39372:21408,39373:21414,39374:21413,39375:21422,39376:21424,39377:21430,39378:21443,39379:31762,39380:38617,39381:21471,39382:26364,39383:29166,39384:21486,39385:21480,39386:21485,39387:21498,39388:21505,39389:21565,39390:21568,39391:21548,39392:21549,39393:21564,39394:21550,39395:21558,39396:21545,39397:21533,39398:21582,39399:21647,39400:21621,39401:21646,39402:21599,39403:21617,39404:21623,39405:21616,39406:21650,39407:21627,39408:21632,39409:21622,39410:21636,39411:21648,39412:21638,39413:21703,39414:21666,39415:21688,39416:21669,39417:21676,39418:21700,39419:21704,39420:21672,39488:21675,39489:21698,39490:21668,39491:21694,39492:21692,39493:21720,39494:21733,39495:21734,39496:21775,39497:21780,39498:21757,39499:21742,39500:21741,39501:21754,39502:21730,39503:21817,39504:21824,39505:21859,39506:21836,39507:21806,39508:21852,39509:21829,39510:21846,39511:21847,39512:21816,39513:21811,39514:21853,39515:21913,39516:21888,39517:21679,39518:21898,39519:21919,39520:21883,39521:21886,39522:21912,39523:21918,39524:21934,39525:21884,39526:21891,39527:21929,39528:21895,39529:21928,39530:21978,39531:21957,39532:21983,39533:21956,39534:21980,39535:21988,39536:21972,39537:22036,39538:22007,39539:22038,39540:22014,39541:22013,39542:22043,39543:22009,39544:22094,39545:22096,39546:29151,39547:22068,39548:22070,39549:22066,39550:22072,39552:22123,39553:22116,39554:22063,39555:22124,39556:22122,39557:22150,39558:22144,39559:22154,39560:22176,39561:22164,39562:22159,39563:22181,39564:22190,39565:22198,39566:22196,39567:22210,39568:22204,39569:22209,39570:22211,39571:22208,39572:22216,39573:22222,39574:22225,39575:22227,39576:22231,39577:22254,39578:22265,39579:22272,39580:22271,39581:22276,39582:22281,39583:22280,39584:22283,39585:22285,39586:22291,39587:22296,39588:22294,39589:21959,39590:22300,39591:22310,39592:22327,39593:22328,39594:22350,39595:22331,39596:22336,39597:22351,39598:22377,39599:22464,39600:22408,39601:22369,39602:22399,39603:22409,39604:22419,39605:22432,39606:22451,39607:22436,39608:22442,39609:22448,39610:22467,39611:22470,39612:22484,39613:22482,39614:22483,39615:22538,39616:22486,39617:22499,39618:22539,39619:22553,39620:22557,39621:22642,39622:22561,39623:22626,39624:22603,39625:22640,39626:27584,39627:22610,39628:22589,39629:22649,39630:22661,39631:22713,39632:22687,39633:22699,39634:22714,39635:22750,39636:22715,39637:22712,39638:22702,39639:22725,39640:22739,39641:22737,39642:22743,39643:22745,39644:22744,39645:22757,39646:22748,39647:22756,39648:22751,39649:22767,39650:22778,39651:22777,39652:22779,39653:22780,39654:22781,39655:22786,39656:22794,39657:22800,39658:22811,39659:26790,39660:22821,39661:22828,39662:22829,39663:22834,39664:22840,39665:22846,39666:31442,39667:22869,39668:22864,39669:22862,39670:22874,39671:22872,39672:22882,39673:22880,39674:22887,39675:22892,39676:22889,39744:22904,39745:22913,39746:22941,39747:20318,39748:20395,39749:22947,39750:22962,39751:22982,39752:23016,39753:23004,39754:22925,39755:23001,39756:23002,39757:23077,39758:23071,39759:23057,39760:23068,39761:23049,39762:23066,39763:23104,39764:23148,39765:23113,39766:23093,39767:23094,39768:23138,39769:23146,39770:23194,39771:23228,\n39772:23230,39773:23243,39774:23234,39775:23229,39776:23267,39777:23255,39778:23270,39779:23273,39780:23254,39781:23290,39782:23291,39783:23308,39784:23307,39785:23318,39786:23346,39787:23248,39788:23338,39789:23350,39790:23358,39791:23363,39792:23365,39793:23360,39794:23377,39795:23381,39796:23386,39797:23387,39798:23397,39799:23401,39800:23408,39801:23411,39802:23413,39803:23416,39804:25992,39805:23418,39806:23424,39808:23427,39809:23462,39810:23480,39811:23491,39812:23495,39813:23497,39814:23508,39815:23504,39816:23524,39817:23526,39818:23522,39819:23518,39820:23525,39821:23531,39822:23536,39823:23542,39824:23539,39825:23557,39826:23559,39827:23560,39828:23565,39829:23571,39830:23584,39831:23586,39832:23592,39833:23608,39834:23609,39835:23617,39836:23622,39837:23630,39838:23635,39839:23632,39840:23631,39841:23409,39842:23660,39843:23662,39844:20066,39845:23670,39846:23673,39847:23692,39848:23697,39849:23700,39850:22939,39851:23723,39852:23739,39853:23734,39854:23740,39855:23735,39856:23749,39857:23742,39858:23751,39859:23769,39860:23785,39861:23805,39862:23802,39863:23789,39864:23948,39865:23786,39866:23819,39867:23829,39868:23831,39869:23900,39870:23839,39871:23835,39872:23825,39873:23828,39874:23842,39875:23834,39876:23833,39877:23832,39878:23884,39879:23890,39880:23886,39881:23883,39882:23916,39883:23923,39884:23926,39885:23943,39886:23940,39887:23938,39888:23970,39889:23965,39890:23980,39891:23982,39892:23997,39893:23952,39894:23991,39895:23996,39896:24009,39897:24013,39898:24019,39899:24018,39900:24022,39901:24027,39902:24043,39903:24050,39904:24053,39905:24075,39906:24090,39907:24089,39908:24081,39909:24091,39910:24118,39911:24119,39912:24132,39913:24131,39914:24128,39915:24142,39916:24151,39917:24148,39918:24159,39919:24162,39920:24164,39921:24135,39922:24181,39923:24182,39924:24186,39925:40636,39926:24191,39927:24224,39928:24257,39929:24258,39930:24264,39931:24272,39932:24271,4e4:24278,40001:24291,40002:24285,40003:24282,40004:24283,40005:24290,40006:24289,40007:24296,40008:24297,40009:24300,40010:24305,40011:24307,40012:24304,40013:24308,40014:24312,40015:24318,40016:24323,40017:24329,40018:24413,40019:24412,40020:24331,40021:24337,40022:24342,40023:24361,40024:24365,40025:24376,40026:24385,40027:24392,40028:24396,40029:24398,40030:24367,40031:24401,40032:24406,40033:24407,40034:24409,40035:24417,40036:24429,40037:24435,40038:24439,40039:24451,40040:24450,40041:24447,40042:24458,40043:24456,40044:24465,40045:24455,40046:24478,40047:24473,40048:24472,40049:24480,40050:24488,40051:24493,40052:24508,40053:24534,40054:24571,40055:24548,40056:24568,40057:24561,40058:24541,40059:24755,40060:24575,40061:24609,40062:24672,40064:24601,40065:24592,40066:24617,40067:24590,40068:24625,40069:24603,40070:24597,40071:24619,40072:24614,40073:24591,40074:24634,40075:24666,40076:24641,40077:24682,40078:24695,40079:24671,40080:24650,40081:24646,40082:24653,40083:24675,40084:24643,40085:24676,40086:24642,40087:24684,40088:24683,40089:24665,40090:24705,40091:24717,40092:24807,40093:24707,40094:24730,40095:24708,40096:24731,40097:24726,40098:24727,40099:24722,40100:24743,40101:24715,40102:24801,40103:24760,40104:24800,40105:24787,40106:24756,40107:24560,40108:24765,40109:24774,40110:24757,40111:24792,40112:24909,40113:24853,40114:24838,40115:24822,40116:24823,40117:24832,40118:24820,40119:24826,40120:24835,40121:24865,40122:24827,40123:24817,40124:24845,40125:24846,40126:24903,40127:24894,40128:24872,40129:24871,40130:24906,40131:24895,40132:24892,40133:24876,40134:24884,40135:24893,40136:24898,40137:24900,40138:24947,40139:24951,40140:24920,40141:24921,40142:24922,40143:24939,40144:24948,40145:24943,40146:24933,40147:24945,40148:24927,40149:24925,40150:24915,40151:24949,40152:24985,40153:24982,40154:24967,40155:25004,40156:24980,40157:24986,40158:24970,40159:24977,40160:25003,40161:25006,40162:25036,40163:25034,40164:25033,40165:25079,40166:25032,40167:25027,40168:25030,40169:25018,40170:25035,40171:32633,40172:25037,40173:25062,40174:25059,40175:25078,40176:25082,40177:25076,40178:25087,40179:25085,40180:25084,40181:25086,40182:25088,40183:25096,40184:25097,40185:25101,40186:25100,40187:25108,40188:25115,40256:25118,40257:25121,40258:25130,40259:25134,40260:25136,40261:25138,40262:25139,40263:25153,40264:25166,40265:25182,40266:25187,40267:25179,40268:25184,40269:25192,40270:25212,40271:25218,40272:25225,40273:25214,40274:25234,40275:25235,40276:25238,40277:25300,40278:25219,40279:25236,40280:25303,40281:25297,40282:25275,40283:25295,40284:25343,40285:25286,40286:25812,40287:25288,40288:25308,40289:25292,40290:25290,40291:25282,40292:25287,40293:25243,40294:25289,40295:25356,40296:25326,40297:25329,40298:25383,40299:25346,40300:25352,40301:25327,40302:25333,40303:25424,40304:25406,40305:25421,40306:25628,40307:25423,40308:25494,40309:25486,40310:25472,40311:25515,40312:25462,40313:25507,40314:25487,40315:25481,40316:25503,40317:25525,40318:25451,40320:25449,40321:25534,40322:25577,40323:25536,40324:25542,40325:25571,40326:25545,40327:25554,40328:25590,40329:25540,40330:25622,40331:25652,40332:25606,40333:25619,40334:25638,40335:25654,40336:25885,40337:25623,40338:25640,40339:25615,40340:25703,40341:25711,40342:25718,40343:25678,40344:25898,40345:25749,40346:25747,40347:25765,40348:25769,40349:25736,40350:25788,40351:25818,40352:25810,40353:25797,40354:25799,40355:25787,40356:25816,40357:25794,40358:25841,40359:25831,40360:33289,40361:25824,40362:25825,40363:25260,40364:25827,40365:25839,40366:25900,40367:25846,40368:25844,40369:25842,40370:25850,40371:25856,40372:25853,40373:25880,40374:25884,40375:25861,40376:25892,40377:25891,40378:25899,40379:25908,40380:25909,40381:25911,40382:25910,40383:25912,40384:30027,40385:25928,40386:25942,40387:25941,40388:25933,40389:25944,40390:25950,40391:25949,40392:25970,40393:25976,40394:25986,40395:25987,40396:35722,40397:26011,40398:26015,40399:26027,40400:26039,40401:26051,40402:26054,40403:26049,40404:26052,40405:26060,40406:26066,40407:26075,40408:26073,40409:26080,40410:26081,40411:26097,40412:26482,40413:26122,40414:26115,40415:26107,40416:26483,40417:26165,40418:26166,40419:26164,40420:26140,40421:26191,40422:26180,40423:26185,40424:26177,40425:26206,40426:26205,40427:26212,40428:26215,40429:26216,40430:26207,40431:26210,40432:26224,40433:26243,40434:26248,40435:26254,40436:26249,40437:26244,40438:26264,40439:26269,40440:26305,40441:26297,40442:26313,40443:26302,40444:26300,40512:26308,40513:26296,40514:26326,40515:26330,40516:26336,40517:26175,40518:26342,40519:26345,40520:26352,40521:26357,40522:26359,40523:26383,40524:26390,40525:26398,40526:26406,40527:26407,40528:38712,40529:26414,40530:26431,40531:26422,40532:26433,40533:26424,40534:26423,40535:26438,40536:26462,40537:26464,40538:26457,40539:26467,40540:26468,40541:26505,40542:26480,40543:26537,40544:26492,40545:26474,40546:26508,40547:26507,40548:26534,40549:26529,40550:26501,40551:26551,40552:26607,40553:26548,40554:26604,40555:26547,40556:26601,40557:26552,40558:26596,40559:26590,40560:26589,40561:26594,40562:26606,40563:26553,40564:26574,40565:26566,40566:26599,40567:27292,40568:26654,40569:26694,40570:26665,40571:26688,40572:26701,40573:26674,40574:26702,40576:26803,40577:26667,40578:26713,40579:26723,40580:26743,40581:26751,40582:26783,40583:26767,40584:26797,40585:26772,40586:26781,40587:26779,40588:26755,40589:27310,40590:26809,40591:26740,40592:26805,40593:26784,40594:26810,40595:26895,40596:26765,40597:26750,40598:26881,40599:26826,40600:26888,40601:26840,40602:26914,40603:26918,40604:26849,40605:26892,40606:26829,40607:26836,40608:26855,40609:26837,40610:26934,40611:26898,40612:26884,40613:26839,40614:26851,40615:26917,40616:26873,40617:26848,40618:26863,40619:26920,40620:26922,40621:26906,40622:26915,40623:26913,40624:26822,40625:27001,40626:26999,40627:26972,40628:27e3,40629:26987,40630:26964,40631:27006,40632:26990,40633:26937,40634:26996,40635:26941,40636:26969,40637:26928,40638:26977,40639:26974,40640:26973,40641:27009,40642:26986,40643:27058,40644:27054,40645:27088,40646:27071,40647:27073,40648:27091,40649:27070,40650:27086,40651:23528,40652:27082,40653:27101,40654:27067,40655:27075,40656:27047,40657:27182,40658:27025,40659:27040,40660:27036,40661:27029,40662:27060,40663:27102,40664:27112,40665:27138,40666:27163,40667:27135,40668:27402,40669:27129,40670:27122,40671:27111,40672:27141,40673:27057,40674:27166,40675:27117,40676:27156,40677:27115,40678:27146,40679:27154,40680:27329,40681:27171,40682:27155,40683:27204,40684:27148,40685:27250,40686:27190,40687:27256,40688:27207,40689:27234,40690:27225,40691:27238,40692:27208,40693:27192,40694:27170,40695:27280,40696:27277,40697:27296,40698:27268,40699:27298,40700:27299,40768:27287,40769:34327,40770:27323,40771:27331,40772:27330,40773:27320,40774:27315,40775:27308,40776:27358,40777:27345,40778:27359,40779:27306,40780:27354,40781:27370,40782:27387,40783:27397,40784:34326,40785:27386,40786:27410,40787:27414,40788:39729,40789:27423,40790:27448,40791:27447,40792:30428,40793:27449,40794:39150,40795:27463,40796:27459,40797:27465,40798:27472,40799:27481,40800:27476,40801:27483,40802:27487,40803:27489,40804:27512,40805:27513,40806:27519,40807:27520,40808:27524,40809:27523,40810:27533,40811:27544,40812:27541,40813:27550,40814:27556,40815:27562,40816:27563,40817:27567,40818:27570,40819:27569,40820:27571,40821:27575,40822:27580,40823:27590,40824:27595,40825:27603,40826:27615,40827:27628,40828:27627,40829:27635,40830:27631,40832:40638,40833:27656,40834:27667,40835:27668,40836:27675,40837:27684,40838:27683,40839:27742,40840:27733,40841:27746,40842:27754,40843:27778,40844:27789,40845:27802,40846:27777,40847:27803,40848:27774,40849:27752,40850:27763,40851:27794,40852:27792,40853:27844,40854:27889,40855:27859,40856:27837,40857:27863,40858:27845,40859:27869,40860:27822,40861:27825,40862:27838,40863:27834,40864:27867,40865:27887,40866:27865,40867:27882,40868:27935,40869:34893,40870:27958,40871:27947,40872:27965,40873:27960,40874:27929,40875:27957,40876:27955,40877:27922,40878:27916,40879:28003,40880:28051,40881:28004,40882:27994,40883:28025,40884:27993,40885:28046,40886:28053,40887:28644,40888:28037,40889:28153,40890:28181,40891:28170,40892:28085,40893:28103,40894:28134,40895:28088,40896:28102,40897:28140,40898:28126,40899:28108,40900:28136,40901:28114,40902:28101,40903:28154,40904:28121,40905:28132,40906:28117,40907:28138,40908:28142,40909:28205,40910:28270,40911:28206,40912:28185,40913:28274,40914:28255,40915:28222,40916:28195,40917:28267,40918:28203,40919:28278,40920:28237,40921:28191,40922:28227,40923:28218,40924:28238,40925:28196,40926:28415,40927:28189,40928:28216,40929:28290,40930:28330,40931:28312,40932:28361,40933:28343,40934:28371,40935:28349,40936:28335,40937:28356,40938:28338,40939:28372,40940:28373,40941:28303,40942:28325,40943:28354,40944:28319,40945:28481,40946:28433,40947:28748,40948:28396,40949:28408,40950:28414,40951:28479,40952:28402,40953:28465,40954:28399,40955:28466,40956:28364,161:65377,162:65378,163:65379,164:65380,165:65381,166:65382,167:65383,168:65384,169:65385,170:65386,171:65387,172:65388,173:65389,174:65390,175:65391,176:65392,177:65393,178:65394,179:65395,180:65396,181:65397,182:65398,183:65399,184:65400,185:65401,186:65402,187:65403,188:65404,189:65405,190:65406,191:65407,192:65408,193:65409,194:65410,195:65411,196:65412,197:65413,198:65414,199:65415,200:65416,201:65417,202:65418,203:65419,204:65420,205:65421,206:65422,207:65423,208:65424,209:65425,210:65426,211:65427,212:65428,213:65429,214:65430,215:65431,216:65432,217:65433,218:65434,219:65435,220:65436,221:65437,222:65438,223:65439,57408:28478,57409:28435,57410:28407,57411:28550,57412:28538,57413:28536,57414:28545,57415:28544,57416:28527,57417:28507,57418:28659,57419:28525,57420:28546,57421:28540,57422:28504,57423:28558,57424:28561,57425:28610,57426:28518,57427:28595,57428:28579,57429:28577,57430:28580,57431:28601,57432:28614,57433:28586,57434:28639,57435:28629,57436:28652,57437:28628,57438:28632,57439:28657,57440:28654,57441:28635,57442:28681,57443:28683,57444:28666,57445:28689,57446:28673,57447:28687,57448:28670,57449:28699,57450:28698,57451:28532,57452:28701,57453:28696,57454:28703,57455:28720,57456:28734,57457:28722,57458:28753,57459:28771,57460:28825,57461:28818,57462:28847,57463:28913,57464:28844,57465:28856,57466:28851,57467:28846,57468:28895,57469:28875,57470:28893,57472:28889,57473:28937,57474:28925,57475:28956,57476:28953,57477:29029,57478:29013,57479:29064,57480:29030,57481:29026,57482:29004,57483:29014,57484:29036,57485:29071,57486:29179,57487:29060,57488:29077,57489:29096,57490:29100,57491:29143,57492:29113,57493:29118,57494:29138,57495:29129,57496:29140,57497:29134,57498:29152,57499:29164,57500:29159,57501:29173,57502:29180,57503:29177,57504:29183,57505:29197,57506:29200,57507:29211,57508:29224,57509:29229,57510:29228,57511:29232,57512:29234,57513:29243,57514:29244,57515:29247,57516:29248,57517:29254,57518:29259,57519:29272,57520:29300,57521:29310,57522:29314,57523:29313,57524:29319,57525:29330,57526:29334,57527:29346,57528:29351,57529:29369,57530:29362,57531:29379,57532:29382,57533:29380,57534:29390,57535:29394,57536:29410,57537:29408,57538:29409,57539:29433,57540:29431,57541:20495,57542:29463,57543:29450,57544:29468,57545:29462,57546:29469,57547:29492,57548:29487,57549:29481,57550:29477,57551:29502,57552:29518,57553:29519,57554:40664,57555:29527,57556:29546,57557:29544,57558:29552,57559:29560,57560:29557,57561:29563,57562:29562,57563:29640,57564:29619,57565:29646,57566:29627,57567:29632,57568:29669,57569:29678,57570:29662,57571:29858,57572:29701,57573:29807,57574:29733,57575:29688,57576:29746,57577:29754,57578:29781,57579:29759,57580:29791,57581:29785,57582:29761,57583:29788,57584:29801,57585:29808,57586:29795,57587:29802,57588:29814,57589:29822,57590:29835,57591:29854,57592:29863,57593:29898,57594:29903,57595:29908,57596:29681,57664:29920,57665:29923,57666:29927,57667:29929,57668:29934,57669:29938,57670:29936,57671:29937,57672:29944,57673:29943,57674:29956,57675:29955,57676:29957,57677:29964,57678:29966,57679:29965,57680:29973,57681:29971,57682:29982,57683:29990,57684:29996,57685:30012,57686:30020,57687:30029,57688:30026,57689:30025,57690:30043,57691:30022,57692:30042,57693:30057,57694:30052,57695:30055,57696:30059,57697:30061,57698:30072,57699:30070,57700:30086,57701:30087,57702:30068,57703:30090,57704:30089,57705:30082,57706:30100,57707:30106,57708:30109,57709:30117,57710:30115,57711:30146,57712:30131,57713:30147,57714:30133,57715:30141,57716:30136,57717:30140,57718:30129,57719:30157,57720:30154,57721:30162,57722:30169,57723:30179,57724:30174,57725:30206,57726:30207,57728:30204,57729:30209,57730:30192,57731:30202,57732:30194,57733:30195,57734:30219,57735:30221,57736:30217,57737:30239,57738:30247,57739:30240,57740:30241,57741:30242,57742:30244,57743:30260,57744:30256,57745:30267,57746:30279,57747:30280,57748:30278,57749:30300,57750:30296,57751:30305,57752:30306,57753:30312,57754:30313,57755:30314,57756:30311,57757:30316,57758:30320,57759:30322,57760:30326,57761:30328,57762:30332,57763:30336,57764:30339,57765:30344,57766:30347,57767:30350,57768:30358,57769:30355,57770:30361,57771:30362,57772:30384,57773:30388,57774:30392,57775:30393,57776:30394,57777:30402,57778:30413,57779:30422,57780:30418,57781:30430,57782:30433,57783:30437,57784:30439,57785:30442,57786:34351,57787:30459,57788:30472,57789:30471,57790:30468,57791:30505,57792:30500,57793:30494,57794:30501,57795:30502,57796:30491,57797:30519,57798:30520,57799:30535,57800:30554,57801:30568,57802:30571,57803:30555,57804:30565,57805:30591,57806:30590,57807:30585,57808:30606,57809:30603,57810:30609,57811:30624,57812:30622,57813:30640,57814:30646,57815:30649,57816:30655,57817:30652,57818:30653,57819:30651,57820:30663,57821:30669,57822:30679,57823:30682,57824:30684,57825:30691,57826:30702,57827:30716,57828:30732,57829:30738,57830:31014,57831:30752,57832:31018,57833:30789,57834:30862,57835:30836,57836:30854,57837:30844,57838:30874,57839:30860,57840:30883,57841:30901,57842:30890,57843:30895,57844:30929,57845:30918,57846:30923,57847:30932,57848:30910,57849:30908,57850:30917,57851:30922,57852:30956,57920:30951,57921:30938,57922:30973,57923:30964,57924:30983,57925:30994,57926:30993,57927:31001,57928:31020,57929:31019,57930:31040,57931:31072,57932:31063,57933:31071,57934:31066,57935:31061,57936:31059,57937:31098,57938:31103,57939:31114,57940:31133,57941:31143,57942:40779,57943:31146,57944:31150,57945:31155,57946:31161,57947:31162,57948:31177,57949:31189,57950:31207,57951:31212,57952:31201,57953:31203,57954:31240,57955:31245,57956:31256,57957:31257,57958:31264,57959:31263,57960:31104,57961:31281,57962:31291,57963:31294,57964:31287,57965:31299,57966:31319,57967:31305,57968:31329,57969:31330,57970:31337,57971:40861,57972:31344,57973:31353,57974:31357,57975:31368,57976:31383,57977:31381,57978:31384,57979:31382,57980:31401,57981:31432,57982:31408,57984:31414,57985:31429,57986:31428,57987:31423,57988:36995,57989:31431,57990:31434,57991:31437,57992:31439,57993:31445,57994:31443,57995:31449,57996:31450,57997:31453,57998:31457,57999:31458,58e3:31462,58001:31469,58002:31472,58003:31490,58004:31503,58005:31498,58006:31494,58007:31539,58008:31512,58009:31513,58010:31518,58011:31541,58012:31528,58013:31542,58014:31568,58015:31610,58016:31492,58017:31565,58018:31499,58019:31564,58020:31557,58021:31605,58022:31589,58023:31604,58024:31591,58025:31600,58026:31601,58027:31596,58028:31598,58029:31645,58030:31640,58031:31647,58032:31629,58033:31644,58034:31642,58035:31627,58036:31634,58037:31631,58038:31581,58039:31641,58040:31691,58041:31681,58042:31692,58043:31695,58044:31668,58045:31686,58046:31709,58047:31721,58048:31761,58049:31764,58050:31718,58051:31717,58052:31840,58053:31744,58054:31751,58055:31763,58056:31731,58057:31735,58058:31767,58059:31757,58060:31734,58061:31779,58062:31783,58063:31786,58064:31775,58065:31799,58066:31787,58067:31805,58068:31820,58069:31811,58070:31828,58071:31823,58072:31808,58073:31824,58074:31832,58075:31839,58076:31844,58077:31830,58078:31845,58079:31852,58080:31861,58081:31875,58082:31888,58083:31908,58084:31917,58085:31906,58086:31915,58087:31905,58088:31912,58089:31923,58090:31922,58091:31921,58092:31918,58093:31929,58094:31933,58095:31936,58096:31941,58097:31938,58098:31960,58099:31954,58100:31964,58101:31970,58102:39739,58103:31983,58104:31986,58105:31988,58106:31990,58107:31994,58108:32006,58176:32002,58177:32028,58178:32021,58179:32010,58180:32069,58181:32075,58182:32046,58183:32050,58184:32063,58185:32053,58186:32070,58187:32115,58188:32086,58189:32078,58190:32114,58191:32104,58192:32110,58193:32079,58194:32099,58195:32147,58196:32137,58197:32091,58198:32143,58199:32125,58200:32155,58201:32186,58202:32174,58203:32163,58204:32181,58205:32199,58206:32189,58207:32171,58208:32317,58209:32162,58210:32175,58211:32220,58212:32184,58213:32159,58214:32176,58215:32216,58216:32221,58217:32228,58218:32222,58219:32251,58220:32242,58221:32225,58222:32261,58223:32266,58224:32291,58225:32289,58226:32274,58227:32305,58228:32287,58229:32265,58230:32267,58231:32290,58232:32326,58233:32358,58234:32315,58235:32309,58236:32313,58237:32323,58238:32311,58240:32306,58241:32314,58242:32359,58243:32349,58244:32342,58245:32350,58246:32345,58247:32346,58248:32377,58249:32362,58250:32361,58251:32380,58252:32379,58253:32387,58254:32213,58255:32381,58256:36782,58257:32383,58258:32392,58259:32393,58260:32396,58261:32402,58262:32400,58263:32403,58264:32404,58265:32406,58266:32398,58267:32411,58268:32412,58269:32568,58270:32570,58271:32581,58272:32588,58273:32589,58274:32590,58275:32592,58276:32593,58277:32597,58278:32596,58279:32600,58280:32607,58281:32608,58282:32616,58283:32617,58284:32615,58285:32632,58286:32642,58287:32646,58288:32643,58289:32648,58290:32647,58291:32652,58292:32660,58293:32670,58294:32669,58295:32666,58296:32675,58297:32687,58298:32690,58299:32697,58300:32686,58301:32694,58302:32696,58303:35697,58304:32709,58305:32710,58306:32714,58307:32725,58308:32724,58309:32737,58310:32742,58311:32745,58312:32755,58313:32761,58314:39132,58315:32774,58316:32772,58317:32779,58318:32786,58319:32792,58320:32793,58321:32796,58322:32801,58323:32808,58324:32831,58325:32827,58326:32842,58327:32838,58328:32850,58329:32856,58330:32858,58331:32863,58332:32866,58333:32872,58334:32883,58335:32882,58336:32880,58337:32886,58338:32889,58339:32893,58340:32895,58341:32900,58342:32902,58343:32901,58344:32923,58345:32915,58346:32922,58347:32941,58348:20880,58349:32940,58350:32987,58351:32997,58352:32985,58353:32989,58354:32964,58355:32986,58356:32982,58357:33033,58358:33007,58359:33009,58360:33051,58361:33065,58362:33059,58363:33071,58364:33099,58432:38539,58433:33094,58434:33086,58435:33107,58436:33105,58437:33020,58438:33137,58439:33134,58440:33125,58441:33126,58442:33140,58443:33155,58444:33160,58445:33162,58446:33152,58447:33154,58448:33184,58449:33173,58450:33188,58451:33187,58452:33119,58453:33171,58454:33193,58455:33200,58456:33205,58457:33214,58458:33208,58459:33213,58460:33216,58461:33218,58462:33210,58463:33225,58464:33229,58465:33233,58466:33241,58467:33240,58468:33224,58469:33242,58470:33247,58471:33248,58472:33255,58473:33274,58474:33275,58475:33278,58476:33281,58477:33282,58478:33285,58479:33287,58480:33290,58481:33293,58482:33296,58483:33302,58484:33321,58485:33323,58486:33336,58487:33331,58488:33344,58489:33369,58490:33368,58491:33373,58492:33370,58493:33375,58494:33380,58496:33378,58497:33384,58498:33386,58499:33387,58500:33326,58501:33393,58502:33399,58503:33400,58504:33406,58505:33421,58506:33426,58507:33451,58508:33439,58509:33467,58510:33452,58511:33505,58512:33507,58513:33503,58514:33490,58515:33524,58516:33523,58517:33530,58518:33683,58519:33539,58520:33531,58521:33529,58522:33502,58523:33542,58524:33500,58525:33545,58526:33497,58527:33589,58528:33588,58529:33558,58530:33586,58531:33585,58532:33600,58533:33593,58534:33616,58535:33605,58536:33583,58537:33579,58538:33559,58539:33560,58540:33669,58541:33690,58542:33706,58543:33695,58544:33698,58545:33686,58546:33571,58547:33678,58548:33671,58549:33674,58550:33660,58551:33717,58552:33651,58553:33653,58554:33696,58555:33673,58556:33704,58557:33780,58558:33811,58559:33771,58560:33742,58561:33789,58562:33795,58563:33752,58564:33803,58565:33729,58566:33783,58567:33799,58568:33760,58569:33778,58570:33805,58571:33826,58572:33824,58573:33725,58574:33848,58575:34054,58576:33787,58577:33901,58578:33834,58579:33852,58580:34138,58581:33924,58582:33911,58583:33899,58584:33965,58585:33902,58586:33922,58587:33897,58588:33862,58589:33836,58590:33903,58591:33913,58592:33845,58593:33994,58594:33890,58595:33977,58596:33983,58597:33951,58598:34009,58599:33997,58600:33979,58601:34010,58602:34e3,58603:33985,58604:33990,58605:34006,58606:33953,58607:34081,58608:34047,58609:34036,58610:34071,58611:34072,58612:34092,58613:34079,58614:34069,58615:34068,58616:34044,58617:34112,58618:34147,58619:34136,58620:34120,58688:34113,58689:34306,58690:34123,58691:34133,58692:34176,58693:34212,58694:34184,58695:34193,58696:34186,58697:34216,58698:34157,58699:34196,58700:34203,58701:34282,58702:34183,58703:34204,58704:34167,58705:34174,58706:34192,58707:34249,58708:34234,58709:34255,58710:34233,58711:34256,58712:34261,58713:34269,58714:34277,58715:34268,58716:34297,58717:34314,58718:34323,58719:34315,58720:34302,58721:34298,58722:34310,58723:34338,58724:34330,58725:34352,58726:34367,58727:34381,58728:20053,58729:34388,58730:34399,58731:34407,58732:34417,58733:34451,58734:34467,58735:34473,58736:34474,58737:34443,58738:34444,58739:34486,58740:34479,58741:34500,58742:34502,58743:34480,58744:34505,58745:34851,58746:34475,58747:34516,58748:34526,58749:34537,58750:34540,58752:34527,58753:34523,58754:34543,58755:34578,58756:34566,58757:34568,58758:34560,58759:34563,58760:34555,58761:34577,58762:34569,58763:34573,58764:34553,58765:34570,58766:34612,58767:34623,58768:34615,58769:34619,58770:34597,58771:34601,58772:34586,58773:34656,58774:34655,58775:34680,58776:34636,58777:34638,58778:34676,58779:34647,58780:34664,58781:34670,58782:34649,58783:34643,58784:34659,58785:34666,58786:34821,58787:34722,58788:34719,58789:34690,58790:34735,58791:34763,58792:34749,58793:34752,58794:34768,58795:38614,58796:34731,58797:34756,58798:34739,58799:34759,58800:34758,58801:34747,58802:34799,58803:34802,58804:34784,58805:34831,58806:34829,58807:34814,58808:34806,58809:34807,58810:34830,58811:34770,58812:34833,58813:34838,58814:34837,58815:34850,58816:34849,58817:34865,58818:34870,58819:34873,58820:34855,58821:34875,58822:34884,58823:34882,58824:34898,58825:34905,58826:34910,58827:34914,58828:34923,58829:34945,58830:34942,58831:34974,58832:34933,58833:34941,58834:34997,58835:34930,58836:34946,58837:34967,58838:34962,58839:34990,58840:34969,58841:34978,58842:34957,58843:34980,58844:34992,58845:35007,58846:34993,58847:35011,58848:35012,58849:35028,58850:35032,58851:35033,58852:35037,58853:35065,58854:35074,58855:35068,58856:35060,58857:35048,58858:35058,58859:35076,58860:35084,58861:35082,58862:35091,58863:35139,58864:35102,58865:35109,58866:35114,58867:35115,58868:35137,58869:35140,58870:35131,58871:35126,58872:35128,58873:35148,58874:35101,58875:35168,58876:35166,58944:35174,58945:35172,58946:35181,58947:35178,58948:35183,58949:35188,58950:35191,58951:35198,58952:35203,58953:35208,58954:35210,58955:35219,58956:35224,58957:35233,58958:35241,58959:35238,58960:35244,58961:35247,58962:35250,58963:35258,58964:35261,58965:35263,58966:35264,58967:35290,58968:35292,58969:35293,58970:35303,58971:35316,58972:35320,58973:35331,58974:35350,58975:35344,58976:35340,58977:35355,58978:35357,58979:35365,58980:35382,58981:35393,58982:35419,58983:35410,58984:35398,58985:35400,58986:35452,58987:35437,58988:35436,58989:35426,58990:35461,58991:35458,58992:35460,58993:35496,58994:35489,58995:35473,58996:35493,58997:35494,58998:35482,58999:35491,59e3:35524,59001:35533,59002:35522,59003:35546,59004:35563,59005:35571,59006:35559,59008:35556,59009:35569,59010:35604,59011:35552,59012:35554,59013:35575,59014:35550,59015:35547,59016:35596,59017:35591,59018:35610,59019:35553,59020:35606,59021:35600,59022:35607,59023:35616,59024:35635,59025:38827,59026:35622,59027:35627,59028:35646,59029:35624,59030:35649,59031:35660,59032:35663,59033:35662,59034:35657,59035:35670,59036:35675,59037:35674,59038:35691,59039:35679,59040:35692,59041:35695,59042:35700,59043:35709,59044:35712,59045:35724,59046:35726,59047:35730,59048:35731,59049:35734,59050:35737,59051:35738,59052:35898,59053:35905,59054:35903,59055:35912,59056:35916,59057:35918,59058:35920,59059:35925,59060:35938,59061:35948,59062:35960,59063:35962,59064:35970,59065:35977,59066:35973,59067:35978,59068:35981,59069:35982,59070:35988,59071:35964,59072:35992,59073:25117,59074:36013,59075:36010,59076:36029,59077:36018,59078:36019,59079:36014,59080:36022,59081:36040,59082:36033,59083:36068,59084:36067,59085:36058,59086:36093,59087:36090,59088:36091,59089:36100,59090:36101,59091:36106,59092:36103,59093:36111,59094:36109,59095:36112,59096:40782,59097:36115,59098:36045,59099:36116,59100:36118,59101:36199,59102:36205,59103:36209,59104:36211,59105:36225,59106:36249,59107:36290,59108:36286,59109:36282,59110:36303,59111:36314,59112:36310,59113:36300,59114:36315,59115:36299,59116:36330,59117:36331,59118:36319,59119:36323,59120:36348,59121:36360,59122:36361,59123:36351,59124:36381,59125:36382,59126:36368,59127:36383,59128:36418,59129:36405,59130:36400,59131:36404,59132:36426,59200:36423,59201:36425,59202:36428,59203:36432,59204:36424,59205:36441,59206:36452,59207:36448,59208:36394,59209:36451,59210:36437,59211:36470,59212:36466,59213:36476,59214:36481,59215:36487,59216:36485,59217:36484,59218:36491,59219:36490,59220:36499,59221:36497,59222:36500,59223:36505,59224:36522,59225:36513,59226:36524,59227:36528,59228:36550,59229:36529,59230:36542,59231:36549,59232:36552,59233:36555,59234:36571,59235:36579,59236:36604,59237:36603,59238:36587,59239:36606,59240:36618,59241:36613,59242:36629,59243:36626,59244:36633,59245:36627,59246:36636,59247:36639,59248:36635,59249:36620,59250:36646,59251:36659,59252:36667,59253:36665,59254:36677,59255:36674,59256:36670,59257:36684,59258:36681,59259:36678,59260:36686,59261:36695,59262:36700,59264:36706,59265:36707,59266:36708,59267:36764,59268:36767,59269:36771,59270:36781,59271:36783,59272:36791,59273:36826,59274:36837,59275:36834,59276:36842,59277:36847,59278:36999,59279:36852,59280:36869,59281:36857,59282:36858,59283:36881,59284:36885,59285:36897,59286:36877,59287:36894,59288:36886,59289:36875,59290:36903,59291:36918,59292:36917,59293:36921,59294:36856,59295:36943,59296:36944,59297:36945,59298:36946,59299:36878,59300:36937,59301:36926,59302:36950,59303:36952,59304:36958,59305:36968,59306:36975,59307:36982,59308:38568,59309:36978,59310:36994,59311:36989,59312:36993,59313:36992,59314:37002,59315:37001,59316:37007,59317:37032,59318:37039,59319:37041,59320:37045,59321:37090,59322:37092,59323:25160,59324:37083,59325:37122,59326:37138,59327:37145,59328:37170,59329:37168,59330:37194,59331:37206,59332:37208,59333:37219,59334:37221,59335:37225,59336:37235,59337:37234,59338:37259,59339:37257,59340:37250,59341:37282,59342:37291,59343:37295,59344:37290,59345:37301,59346:37300,59347:37306,59348:37312,59349:37313,59350:37321,59351:37323,59352:37328,59353:37334,59354:37343,59355:37345,59356:37339,59357:37372,59358:37365,59359:37366,59360:37406,59361:37375,59362:37396,59363:37420,59364:37397,59365:37393,59366:37470,59367:37463,59368:37445,59369:37449,59370:37476,59371:37448,59372:37525,59373:37439,59374:37451,59375:37456,59376:37532,59377:37526,59378:37523,59379:37531,59380:37466,59381:37583,59382:37561,59383:37559,59384:37609,59385:37647,59386:37626,59387:37700,59388:37678,59456:37657,59457:37666,59458:37658,59459:37667,59460:37690,59461:37685,59462:37691,59463:37724,59464:37728,59465:37756,59466:37742,59467:37718,59468:37808,59469:37804,59470:37805,59471:37780,59472:37817,59473:37846,59474:37847,59475:37864,59476:37861,59477:37848,59478:37827,59479:37853,59480:37840,59481:37832,59482:37860,59483:37914,59484:37908,59485:37907,59486:37891,59487:37895,59488:37904,59489:37942,59490:37931,59491:37941,59492:37921,59493:37946,59494:37953,59495:37970,59496:37956,59497:37979,59498:37984,59499:37986,59500:37982,59501:37994,59502:37417,59503:38e3,59504:38005,59505:38007,59506:38013,59507:37978,59508:38012,59509:38014,59510:38017,59511:38015,59512:38274,59513:38279,59514:38282,59515:38292,59516:38294,59517:38296,59518:38297,59520:38304,59521:38312,59522:38311,59523:38317,59524:38332,59525:38331,59526:38329,59527:38334,59528:38346,59529:28662,59530:38339,59531:38349,59532:38348,59533:38357,59534:38356,59535:38358,59536:38364,59537:38369,59538:38373,59539:38370,59540:38433,59541:38440,59542:38446,59543:38447,59544:38466,59545:38476,59546:38479,59547:38475,59548:38519,59549:38492,59550:38494,59551:38493,59552:38495,59553:38502,59554:38514,59555:38508,59556:38541,59557:38552,59558:38549,59559:38551,59560:38570,59561:38567,59562:38577,59563:38578,59564:38576,59565:38580,59566:38582,59567:38584,59568:38585,59569:38606,59570:38603,59571:38601,59572:38605,59573:35149,59574:38620,59575:38669,59576:38613,59577:38649,59578:38660,59579:38662,59580:38664,59581:38675,59582:38670,59583:38673,59584:38671,59585:38678,59586:38681,59587:38692,59588:38698,59589:38704,59590:38713,59591:38717,59592:38718,59593:38724,59594:38726,59595:38728,59596:38722,59597:38729,59598:38748,59599:38752,59600:38756,59601:38758,59602:38760,59603:21202,59604:38763,59605:38769,59606:38777,59607:38789,59608:38780,59609:38785,59610:38778,59611:38790,59612:38795,59613:38799,59614:38800,59615:38812,59616:38824,59617:38822,59618:38819,59619:38835,59620:38836,59621:38851,59622:38854,59623:38856,59624:38859,59625:38876,59626:38893,59627:40783,59628:38898,59629:31455,59630:38902,59631:38901,59632:38927,59633:38924,59634:38968,59635:38948,59636:38945,59637:38967,59638:38973,59639:38982,59640:38991,59641:38987,59642:39019,59643:39023,59644:39024,59712:39025,59713:39028,59714:39027,59715:39082,59716:39087,59717:39089,59718:39094,59719:39108,59720:39107,59721:39110,\n59722:39145,59723:39147,59724:39171,59725:39177,59726:39186,59727:39188,59728:39192,59729:39201,59730:39197,59731:39198,59732:39204,59733:39200,59734:39212,59735:39214,59736:39229,59737:39230,59738:39234,59739:39241,59740:39237,59741:39248,59742:39243,59743:39249,59744:39250,59745:39244,59746:39253,59747:39319,59748:39320,59749:39333,59750:39341,59751:39342,59752:39356,59753:39391,59754:39387,59755:39389,59756:39384,59757:39377,59758:39405,59759:39406,59760:39409,59761:39410,59762:39419,59763:39416,59764:39425,59765:39439,59766:39429,59767:39394,59768:39449,59769:39467,59770:39479,59771:39493,59772:39490,59773:39488,59774:39491,59776:39486,59777:39509,59778:39501,59779:39515,59780:39511,59781:39519,59782:39522,59783:39525,59784:39524,59785:39529,59786:39531,59787:39530,59788:39597,59789:39600,59790:39612,59791:39616,59792:39631,59793:39633,59794:39635,59795:39636,59796:39646,59797:39647,59798:39650,59799:39651,59800:39654,59801:39663,59802:39659,59803:39662,59804:39668,59805:39665,59806:39671,59807:39675,59808:39686,59809:39704,59810:39706,59811:39711,59812:39714,59813:39715,59814:39717,59815:39719,59816:39720,59817:39721,59818:39722,59819:39726,59820:39727,59821:39730,59822:39748,59823:39747,59824:39759,59825:39757,59826:39758,59827:39761,59828:39768,59829:39796,59830:39827,59831:39811,59832:39825,59833:39830,59834:39831,59835:39839,59836:39840,59837:39848,59838:39860,59839:39872,59840:39882,59841:39865,59842:39878,59843:39887,59844:39889,59845:39890,59846:39907,59847:39906,59848:39908,59849:39892,59850:39905,59851:39994,59852:39922,59853:39921,59854:39920,59855:39957,59856:39956,59857:39945,59858:39955,59859:39948,59860:39942,59861:39944,59862:39954,59863:39946,59864:39940,59865:39982,59866:39963,59867:39973,59868:39972,59869:39969,59870:39984,59871:40007,59872:39986,59873:40006,59874:39998,59875:40026,59876:40032,59877:40039,59878:40054,59879:40056,59880:40167,59881:40172,59882:40176,59883:40201,59884:40200,59885:40171,59886:40195,59887:40198,59888:40234,59889:40230,59890:40367,59891:40227,59892:40223,59893:40260,59894:40213,59895:40210,59896:40257,59897:40255,59898:40254,59899:40262,59900:40264,59968:40285,59969:40286,59970:40292,59971:40273,59972:40272,59973:40281,59974:40306,59975:40329,59976:40327,59977:40363,59978:40303,59979:40314,59980:40346,59981:40356,59982:40361,59983:40370,59984:40388,59985:40385,59986:40379,59987:40376,59988:40378,59989:40390,59990:40399,59991:40386,59992:40409,59993:40403,59994:40440,59995:40422,59996:40429,59997:40431,59998:40445,59999:40474,6e4:40475,60001:40478,60002:40565,60003:40569,60004:40573,60005:40577,60006:40584,60007:40587,60008:40588,60009:40594,60010:40597,60011:40593,60012:40605,60013:40613,60014:40617,60015:40632,60016:40618,60017:40621,60018:38753,60019:40652,60020:40654,60021:40655,60022:40656,60023:40660,60024:40668,60025:40670,60026:40669,60027:40672,60028:40677,60029:40680,60030:40687,60032:40692,60033:40694,60034:40695,60035:40697,60036:40699,60037:40700,60038:40701,60039:40711,60040:40712,60041:30391,60042:40725,60043:40737,60044:40748,60045:40766,60046:40778,60047:40786,60048:40788,60049:40803,60050:40799,60051:40800,60052:40801,60053:40806,60054:40807,60055:40812,60056:40810,60057:40823,60058:40818,60059:40822,60060:40853,60061:40860,60062:40864,60063:22575,60064:27079,60065:36953,60066:29796,60067:20956,60068:29081}},function(o,e,r){\"use strict\";function t(o,e,r,t){e.degree()<r.degree()&&(w=[r,e],e=w[0],r=w[1]);for(var c=e,s=r,a=o.zero,d=o.one;s.degree()>=t/2;){var n=c,l=a;if(c=s,a=d,c.isZero())return null;s=n;for(var i=o.zero,B=c.getCoefficient(c.degree()),k=o.inverse(B);s.degree()>=c.degree()&&!s.isZero();){var u=s.degree()-c.degree(),C=o.multiply(s.getCoefficient(s.degree()),k);i=i.addOrSubtract(o.buildMonomial(u,C)),s=s.addOrSubtract(c.multiplyByMonomial(u,C))}if(d=i.multiplyPoly(a).addOrSubtract(l),s.degree()>=c.degree())return null}var m=d.getCoefficient(0);if(0===m)return null;var f=o.inverse(m);return[d.multiply(f),s.multiply(f)];var w}function c(o,e){var r=e.degree();if(1===r)return[e.getCoefficient(1)];for(var t=new Array(r),c=0,s=1;s<o.size&&c<r;s++)0===e.evaluateAt(s)&&(t[c]=o.inverse(s),c++);return c!==r?null:t}function s(o,e,r){for(var t=r.length,c=new Array(t),s=0;s<t;s++){for(var a=o.inverse(r[s]),n=1,l=0;l<t;l++)s!==l&&(n=o.multiply(n,d.addOrSubtractGF(1,o.multiply(r[l],a))));c[s]=o.multiply(e.evaluateAt(a),o.inverse(n)),0!==o.generatorBase&&(c[s]=o.multiply(c[s],a))}return c}function a(o,e){var r=new Uint8ClampedArray(o.length);r.set(o);for(var a=new d.default(285,256,0),l=new n.default(a,r),i=new Uint8ClampedArray(e),B=!1,k=0;k<e;k++){var u=l.evaluateAt(a.exp(k+a.generatorBase));i[i.length-1-k]=u,0!==u&&(B=!0)}if(!B)return r;var C=new n.default(a,i),m=t(a,a.buildMonomial(e,1),C,e);if(null===m)return null;var f=c(a,m[0]);if(null==f)return null;for(var w=s(a,m[1],f),P=0;P<f.length;P++){var v=r.length-1-a.log(f[P]);if(v<0)return null;r[v]=d.addOrSubtractGF(r[v],w[P])}return r}Object.defineProperty(e,\"__esModule\",{value:!0});var d=r(1),n=r(2);e.decode=a},function(o,e,r){\"use strict\";Object.defineProperty(e,\"__esModule\",{value:!0}),e.VERSIONS=[{infoBits:null,versionNumber:1,alignmentPatternCenters:[],errorCorrectionLevels:[{ecCodewordsPerBlock:7,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:10,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:16}]},{ecCodewordsPerBlock:13,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:13}]},{ecCodewordsPerBlock:17,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:9}]}]},{infoBits:null,versionNumber:2,alignmentPatternCenters:[6,18],errorCorrectionLevels:[{ecCodewordsPerBlock:10,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:34}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:28}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:22}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:16}]}]},{infoBits:null,versionNumber:3,alignmentPatternCenters:[6,22],errorCorrectionLevels:[{ecCodewordsPerBlock:15,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:55}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:13}]}]},{infoBits:null,versionNumber:4,alignmentPatternCenters:[6,26],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:80}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:32}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:9}]}]},{infoBits:null,versionNumber:5,alignmentPatternCenters:[6,30],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:43}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:15},{numBlocks:2,dataCodewordsPerBlock:16}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:11},{numBlocks:2,dataCodewordsPerBlock:12}]}]},{infoBits:null,versionNumber:6,alignmentPatternCenters:[6,34],errorCorrectionLevels:[{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:68}]},{ecCodewordsPerBlock:16,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:27}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:15}]}]},{infoBits:31892,versionNumber:7,alignmentPatternCenters:[6,22,38],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:78}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:31}]},{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:4,dataCodewordsPerBlock:15}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:13},{numBlocks:1,dataCodewordsPerBlock:14}]}]},{infoBits:34236,versionNumber:8,alignmentPatternCenters:[6,24,42],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:97}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:38},{numBlocks:2,dataCodewordsPerBlock:39}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:18},{numBlocks:2,dataCodewordsPerBlock:19}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:14},{numBlocks:2,dataCodewordsPerBlock:15}]}]},{infoBits:39577,versionNumber:9,alignmentPatternCenters:[6,26,46],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:36},{numBlocks:2,dataCodewordsPerBlock:37}]},{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:16},{numBlocks:4,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:12},{numBlocks:4,dataCodewordsPerBlock:13}]}]},{infoBits:42195,versionNumber:10,alignmentPatternCenters:[6,28,50],errorCorrectionLevels:[{ecCodewordsPerBlock:18,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:68},{numBlocks:2,dataCodewordsPerBlock:69}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:43},{numBlocks:1,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:19},{numBlocks:2,dataCodewordsPerBlock:20}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:15},{numBlocks:2,dataCodewordsPerBlock:16}]}]},{infoBits:48118,versionNumber:11,alignmentPatternCenters:[6,30,54],errorCorrectionLevels:[{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:81}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:50},{numBlocks:4,dataCodewordsPerBlock:51}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:22},{numBlocks:4,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:12},{numBlocks:8,dataCodewordsPerBlock:13}]}]},{infoBits:51042,versionNumber:12,alignmentPatternCenters:[6,32,58],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:92},{numBlocks:2,dataCodewordsPerBlock:93}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:36},{numBlocks:2,dataCodewordsPerBlock:37}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:20},{numBlocks:6,dataCodewordsPerBlock:21}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:14},{numBlocks:4,dataCodewordsPerBlock:15}]}]},{infoBits:55367,versionNumber:13,alignmentPatternCenters:[6,34,62],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:107}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:37},{numBlocks:1,dataCodewordsPerBlock:38}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:20},{numBlocks:4,dataCodewordsPerBlock:21}]},{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:11},{numBlocks:4,dataCodewordsPerBlock:12}]}]},{infoBits:58893,versionNumber:14,alignmentPatternCenters:[6,26,46,66],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:115},{numBlocks:1,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:40},{numBlocks:5,dataCodewordsPerBlock:41}]},{ecCodewordsPerBlock:20,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:16},{numBlocks:5,dataCodewordsPerBlock:17}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:12},{numBlocks:5,dataCodewordsPerBlock:13}]}]},{infoBits:63784,versionNumber:15,alignmentPatternCenters:[6,26,48,70],errorCorrectionLevels:[{ecCodewordsPerBlock:22,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:87},{numBlocks:1,dataCodewordsPerBlock:88}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:41},{numBlocks:5,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:24},{numBlocks:7,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:12},{numBlocks:7,dataCodewordsPerBlock:13}]}]},{infoBits:68472,versionNumber:16,alignmentPatternCenters:[6,26,50,74],errorCorrectionLevels:[{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:98},{numBlocks:1,dataCodewordsPerBlock:99}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:45},{numBlocks:3,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:19},{numBlocks:2,dataCodewordsPerBlock:20}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:15},{numBlocks:13,dataCodewordsPerBlock:16}]}]},{infoBits:70749,versionNumber:17,alignmentPatternCenters:[6,30,54,78],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:107},{numBlocks:5,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:46},{numBlocks:1,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:22},{numBlocks:15,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:17,dataCodewordsPerBlock:15}]}]},{infoBits:76311,versionNumber:18,alignmentPatternCenters:[6,30,56,82],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:120},{numBlocks:1,dataCodewordsPerBlock:121}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:9,dataCodewordsPerBlock:43},{numBlocks:4,dataCodewordsPerBlock:44}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:22},{numBlocks:1,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:14},{numBlocks:19,dataCodewordsPerBlock:15}]}]},{infoBits:79154,versionNumber:19,alignmentPatternCenters:[6,30,58,86],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:113},{numBlocks:4,dataCodewordsPerBlock:114}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:44},{numBlocks:11,dataCodewordsPerBlock:45}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:21},{numBlocks:4,dataCodewordsPerBlock:22}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:9,dataCodewordsPerBlock:13},{numBlocks:16,dataCodewordsPerBlock:14}]}]},{infoBits:84390,versionNumber:20,alignmentPatternCenters:[6,34,62,90],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:107},{numBlocks:5,dataCodewordsPerBlock:108}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:41},{numBlocks:13,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:24},{numBlocks:5,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:15},{numBlocks:10,dataCodewordsPerBlock:16}]}]},{infoBits:87683,versionNumber:21,alignmentPatternCenters:[6,28,50,72,94],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:116},{numBlocks:4,dataCodewordsPerBlock:117}]},{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:42}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:22},{numBlocks:6,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:16},{numBlocks:6,dataCodewordsPerBlock:17}]}]},{infoBits:92361,versionNumber:22,alignmentPatternCenters:[6,26,50,74,98],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:111},{numBlocks:7,dataCodewordsPerBlock:112}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:24},{numBlocks:16,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:24,ecBlocks:[{numBlocks:34,dataCodewordsPerBlock:13}]}]},{infoBits:96236,versionNumber:23,alignmentPatternCenters:[6,30,54,74,102],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:121},{numBlocks:5,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:47},{numBlocks:14,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:16,dataCodewordsPerBlock:15},{numBlocks:14,dataCodewordsPerBlock:16}]}]},{infoBits:102084,versionNumber:24,alignmentPatternCenters:[6,28,54,80,106],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:117},{numBlocks:4,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:45},{numBlocks:14,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:24},{numBlocks:16,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:30,dataCodewordsPerBlock:16},{numBlocks:2,dataCodewordsPerBlock:17}]}]},{infoBits:102881,versionNumber:25,alignmentPatternCenters:[6,32,58,84,110],errorCorrectionLevels:[{ecCodewordsPerBlock:26,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:106},{numBlocks:4,dataCodewordsPerBlock:107}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:47},{numBlocks:13,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:24},{numBlocks:22,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:15},{numBlocks:13,dataCodewordsPerBlock:16}]}]},{infoBits:110507,versionNumber:26,alignmentPatternCenters:[6,30,58,86,114],errorCorrectionLevels:[{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:114},{numBlocks:2,dataCodewordsPerBlock:115}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:46},{numBlocks:4,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:28,dataCodewordsPerBlock:22},{numBlocks:6,dataCodewordsPerBlock:23}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:33,dataCodewordsPerBlock:16},{numBlocks:4,dataCodewordsPerBlock:17}]}]},{infoBits:110734,versionNumber:27,alignmentPatternCenters:[6,34,62,90,118],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:122},{numBlocks:4,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:45},{numBlocks:3,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:8,dataCodewordsPerBlock:23},{numBlocks:26,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:15},{numBlocks:28,dataCodewordsPerBlock:16}]}]},{infoBits:117786,versionNumber:28,alignmentPatternCenters:[6,26,50,74,98,122],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:117},{numBlocks:10,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:3,dataCodewordsPerBlock:45},{numBlocks:23,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:24},{numBlocks:31,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:15},{numBlocks:31,dataCodewordsPerBlock:16}]}]},{infoBits:119615,versionNumber:29,alignmentPatternCenters:[6,30,54,78,102,126],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:7,dataCodewordsPerBlock:116},{numBlocks:7,dataCodewordsPerBlock:117}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:21,dataCodewordsPerBlock:45},{numBlocks:7,dataCodewordsPerBlock:46}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:1,dataCodewordsPerBlock:23},{numBlocks:37,dataCodewordsPerBlock:24}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:15},{numBlocks:26,dataCodewordsPerBlock:16}]}]},{infoBits:126325,versionNumber:30,alignmentPatternCenters:[6,26,52,78,104,130],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:5,dataCodewordsPerBlock:115},{numBlocks:10,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:47},{numBlocks:10,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:15,dataCodewordsPerBlock:24},{numBlocks:25,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:23,dataCodewordsPerBlock:15},{numBlocks:25,dataCodewordsPerBlock:16}]}]},{infoBits:127568,versionNumber:31,alignmentPatternCenters:[6,30,56,82,108,134],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:115},{numBlocks:3,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:46},{numBlocks:29,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:42,dataCodewordsPerBlock:24},{numBlocks:1,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:23,dataCodewordsPerBlock:15},{numBlocks:28,dataCodewordsPerBlock:16}]}]},{infoBits:133589,versionNumber:32,alignmentPatternCenters:[6,34,60,86,112,138],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:115}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:46},{numBlocks:23,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:24},{numBlocks:35,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:15},{numBlocks:35,dataCodewordsPerBlock:16}]}]},{infoBits:136944,versionNumber:33,alignmentPatternCenters:[6,30,58,86,114,142],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:115},{numBlocks:1,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:14,dataCodewordsPerBlock:46},{numBlocks:21,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:29,dataCodewordsPerBlock:24},{numBlocks:19,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:11,dataCodewordsPerBlock:15},{numBlocks:46,dataCodewordsPerBlock:16}]}]},{infoBits:141498,versionNumber:34,alignmentPatternCenters:[6,34,62,90,118,146],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:115},{numBlocks:6,dataCodewordsPerBlock:116}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:14,dataCodewordsPerBlock:46},{numBlocks:23,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:44,dataCodewordsPerBlock:24},{numBlocks:7,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:59,dataCodewordsPerBlock:16},{numBlocks:1,dataCodewordsPerBlock:17}]}]},{infoBits:145311,versionNumber:35,alignmentPatternCenters:[6,30,54,78,102,126,150],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:121},{numBlocks:7,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:12,dataCodewordsPerBlock:47},{numBlocks:26,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:39,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:22,dataCodewordsPerBlock:15},{numBlocks:41,dataCodewordsPerBlock:16}]}]},{infoBits:150283,versionNumber:36,alignmentPatternCenters:[6,24,50,76,102,128,154],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:121},{numBlocks:14,dataCodewordsPerBlock:122}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:6,dataCodewordsPerBlock:47},{numBlocks:34,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:46,dataCodewordsPerBlock:24},{numBlocks:10,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:2,dataCodewordsPerBlock:15},{numBlocks:64,dataCodewordsPerBlock:16}]}]},{infoBits:152622,versionNumber:37,alignmentPatternCenters:[6,28,54,80,106,132,158],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:17,dataCodewordsPerBlock:122},{numBlocks:4,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:29,dataCodewordsPerBlock:46},{numBlocks:14,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:49,dataCodewordsPerBlock:24},{numBlocks:10,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:24,dataCodewordsPerBlock:15},{numBlocks:46,dataCodewordsPerBlock:16}]}]},{infoBits:158308,versionNumber:38,alignmentPatternCenters:[6,32,58,84,110,136,162],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:4,dataCodewordsPerBlock:122},{numBlocks:18,dataCodewordsPerBlock:123}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:13,dataCodewordsPerBlock:46},{numBlocks:32,dataCodewordsPerBlock:47}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:48,dataCodewordsPerBlock:24},{numBlocks:14,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:42,dataCodewordsPerBlock:15},{numBlocks:32,dataCodewordsPerBlock:16}]}]},{infoBits:161089,versionNumber:39,alignmentPatternCenters:[6,26,54,82,110,138,166],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:20,dataCodewordsPerBlock:117},{numBlocks:4,dataCodewordsPerBlock:118}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:40,dataCodewordsPerBlock:47},{numBlocks:7,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:43,dataCodewordsPerBlock:24},{numBlocks:22,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:10,dataCodewordsPerBlock:15},{numBlocks:67,dataCodewordsPerBlock:16}]}]},{infoBits:167017,versionNumber:40,alignmentPatternCenters:[6,30,58,86,114,142,170],errorCorrectionLevels:[{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:19,dataCodewordsPerBlock:118},{numBlocks:6,dataCodewordsPerBlock:119}]},{ecCodewordsPerBlock:28,ecBlocks:[{numBlocks:18,dataCodewordsPerBlock:47},{numBlocks:31,dataCodewordsPerBlock:48}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:34,dataCodewordsPerBlock:24},{numBlocks:34,dataCodewordsPerBlock:25}]},{ecCodewordsPerBlock:30,ecBlocks:[{numBlocks:20,dataCodewordsPerBlock:15},{numBlocks:61,dataCodewordsPerBlock:16}]}]}]},function(o,e,r){\"use strict\";function t(o,e,r,t){var c=o.x-e.x+r.x-t.x,s=o.y-e.y+r.y-t.y;if(0===c&&0===s)return{a11:e.x-o.x,a12:e.y-o.y,a13:0,a21:r.x-e.x,a22:r.y-e.y,a23:0,a31:o.x,a32:o.y,a33:1};var a=e.x-r.x,d=t.x-r.x,n=e.y-r.y,l=t.y-r.y,i=a*l-d*n,B=(c*l-d*s)/i,k=(a*s-c*n)/i;return{a11:e.x-o.x+B*e.x,a12:e.y-o.y+B*e.y,a13:B,a21:t.x-o.x+k*t.x,a22:t.y-o.y+k*t.y,a23:k,a31:o.x,a32:o.y,a33:1}}function c(o,e,r,c){var s=t(o,e,r,c);return{a11:s.a22*s.a33-s.a23*s.a32,a12:s.a13*s.a32-s.a12*s.a33,a13:s.a12*s.a23-s.a13*s.a22,a21:s.a23*s.a31-s.a21*s.a33,a22:s.a11*s.a33-s.a13*s.a31,a23:s.a13*s.a21-s.a11*s.a23,a31:s.a21*s.a32-s.a22*s.a31,a32:s.a12*s.a31-s.a11*s.a32,a33:s.a11*s.a22-s.a12*s.a21}}function s(o,e){return{a11:o.a11*e.a11+o.a21*e.a12+o.a31*e.a13,a12:o.a12*e.a11+o.a22*e.a12+o.a32*e.a13,a13:o.a13*e.a11+o.a23*e.a12+o.a33*e.a13,a21:o.a11*e.a21+o.a21*e.a22+o.a31*e.a23,a22:o.a12*e.a21+o.a22*e.a22+o.a32*e.a23,a23:o.a13*e.a21+o.a23*e.a22+o.a33*e.a23,a31:o.a11*e.a31+o.a21*e.a32+o.a31*e.a33,a32:o.a12*e.a31+o.a22*e.a32+o.a32*e.a33,a33:o.a13*e.a31+o.a23*e.a32+o.a33*e.a33}}function a(o,e){for(var r=c({x:3.5,y:3.5},{x:e.dimension-3.5,y:3.5},{x:e.dimension-6.5,y:e.dimension-6.5},{x:3.5,y:e.dimension-3.5}),a=t(e.topLeft,e.topRight,e.alignmentPattern,e.bottomLeft),n=s(a,r),l=d.BitMatrix.createEmpty(e.dimension,e.dimension),i=function(o,e){var r=n.a13*o+n.a23*e+n.a33;return{x:(n.a11*o+n.a21*e+n.a31)/r,y:(n.a12*o+n.a22*e+n.a32)/r}},B=0;B<e.dimension;B++)for(var k=0;k<e.dimension;k++){var u=k+.5,C=B+.5,m=i(u,C);l.set(k,B,o.get(Math.floor(m.x),Math.floor(m.y)))}return{matrix:l,mappingFunction:i}}Object.defineProperty(e,\"__esModule\",{value:!0});var d=r(0);e.extract=a},function(o,e,r){\"use strict\";function t(o){return o.reduce(function(o,e){return o+e})}function c(o,e,r){var t,c,s,a=C(o,e),d=C(e,r),n=C(o,r);return d>=a&&d>=n?(l=[e,o,r],t=l[0],c=l[1],s=l[2]):n>=d&&n>=a?(i=[o,e,r],t=i[0],c=i[1],s=i[2]):(B=[o,r,e],t=B[0],c=B[1],s=B[2]),(s.x-c.x)*(t.y-c.y)-(s.y-c.y)*(t.x-c.x)<0&&(k=[s,t],t=k[0],s=k[1]),{bottomLeft:t,topLeft:c,topRight:s};var l,i,B,k}function s(o,e,r,c){var s=(t(d(o,r,c,5))/7+t(d(o,e,c,5))/7+t(d(r,o,c,5))/7+t(d(e,o,c,5))/7)/4;if(s<1)throw new Error(\"Invalid module size\");var a=Math.round(C(o,e)/s),n=Math.round(C(o,r)/s),l=Math.floor((a+n)/2)+7;switch(l%4){case 0:l++;break;case 2:l--}return{dimension:l,moduleSize:s}}function a(o,e,r,t){var c,s,a,d,n=[{x:Math.floor(o.x),y:Math.floor(o.y)}],l=Math.abs(e.y-o.y)>Math.abs(e.x-o.x);l?(c=Math.floor(o.y),s=Math.floor(o.x),a=Math.floor(e.y),d=Math.floor(e.x)):(c=Math.floor(o.x),s=Math.floor(o.y),a=Math.floor(e.x),d=Math.floor(e.y));for(var i=Math.abs(a-c),B=Math.abs(d-s),k=Math.floor(-i/2),u=c<a?1:-1,m=s<d?1:-1,f=!0,w=c,P=s;w!==a+u;w+=u){var v=l?P:w,h=l?w:P;if(r.get(v,h)!==f&&(f=!f,n.push({x:v,y:h}),n.length===t+1))break;if((k+=B)>0){if(P===d)break;P+=m,k-=i}}for(var y=[],p=0;p<t;p++)n[p]&&n[p+1]?y.push(C(n[p],n[p+1])):y.push(0);return y}function d(o,e,r,t){var c=e.y-o.y,s=e.x-o.x,d=a(o,e,r,Math.ceil(t/2)),n=a(o,{x:o.x-s,y:o.y-c},r,Math.ceil(t/2)),l=d.shift()+n.shift()-1;return(i=n.concat(l)).concat.apply(i,d);var i}function n(o,e){var r=t(o)/t(e),c=0;return e.forEach(function(e,t){c+=Math.pow(o[t]-e*r,2)}),{averageSize:r,error:c}}function l(o,e,r){try{var t=d(o,{x:-1,y:o.y},r,e.length),c=d(o,{x:o.x,y:-1},r,e.length),s={x:Math.max(0,o.x-o.y)-1,y:Math.max(0,o.y-o.x)-1},a=d(o,s,r,e.length),l={x:Math.min(r.width,o.x+o.y)+1,y:Math.min(r.height,o.y+o.x)+1},i=d(o,l,r,e.length),B=n(t,e),k=n(c,e),u=n(a,e),C=n(i,e),m=Math.sqrt(B.error*B.error+k.error*k.error+u.error*u.error+C.error*C.error),f=(B.averageSize+k.averageSize+u.averageSize+C.averageSize)/4;return m+(Math.pow(B.averageSize-f,2)+Math.pow(k.averageSize-f,2)+Math.pow(u.averageSize-f,2)+Math.pow(C.averageSize-f,2))/f}catch(o){return 1/0}}function i(o){for(var e=[],r=[],a=[],d=[],n=0;n<=o.height;n++)!function(c){for(var s=0,n=!1,l=[0,0,0,0,0],i=-1;i<=o.width;i++)!function(e){var a=o.get(e,c);if(a===n)s++;else{l=[l[1],l[2],l[3],l[4],s],s=1,n=a;var i=t(l)/7,B=Math.abs(l[0]-i)<i&&Math.abs(l[1]-i)<i&&Math.abs(l[2]-3*i)<3*i&&Math.abs(l[3]-i)<i&&Math.abs(l[4]-i)<i&&!a,C=t(l.slice(-3))/3,m=Math.abs(l[2]-C)<C&&Math.abs(l[3]-C)<C&&Math.abs(l[4]-C)<C&&a;if(B){var f=e-l[3]-l[4],w=f-l[2],P={startX:w,endX:f,y:c},v=r.filter(function(o){return w>=o.bottom.startX&&w<=o.bottom.endX||f>=o.bottom.startX&&w<=o.bottom.endX||w<=o.bottom.startX&&f>=o.bottom.endX&&l[2]/(o.bottom.endX-o.bottom.startX)<u&&l[2]/(o.bottom.endX-o.bottom.startX)>k});v.length>0?v[0].bottom=P:r.push({top:P,bottom:P})}if(m){var h=e-l[4],y=h-l[3],P={startX:y,y:c,endX:h},v=d.filter(function(o){return y>=o.bottom.startX&&y<=o.bottom.endX||h>=o.bottom.startX&&y<=o.bottom.endX||y<=o.bottom.startX&&h>=o.bottom.endX&&l[2]/(o.bottom.endX-o.bottom.startX)<u&&l[2]/(o.bottom.endX-o.bottom.startX)>k});v.length>0?v[0].bottom=P:d.push({top:P,bottom:P})}}}(i);e.push.apply(e,r.filter(function(o){return o.bottom.y!==c&&o.bottom.y-o.top.y>=2})),r=r.filter(function(o){return o.bottom.y===c}),a.push.apply(a,d.filter(function(o){return o.bottom.y!==c})),d=d.filter(function(o){return o.bottom.y===c})}(n);e.push.apply(e,r.filter(function(o){return o.bottom.y-o.top.y>=2})),a.push.apply(a,d);var i=e.filter(function(o){return o.bottom.y-o.top.y>=2}).map(function(e){var r=(e.top.startX+e.top.endX+e.bottom.startX+e.bottom.endX)/4,c=(e.top.y+e.bottom.y+1)/2;if(o.get(Math.round(r),Math.round(c))){var s=[e.top.endX-e.top.startX,e.bottom.endX-e.bottom.startX,e.bottom.y-e.top.y+1],a=t(s)/s.length;return{score:l({x:Math.round(r),y:Math.round(c)},[1,1,3,1,1],o),x:r,y:c,size:a}}}).filter(function(o){return!!o}).sort(function(o,e){return o.score-e.score}).map(function(o,e,r){if(e>B)return null;var t=r.filter(function(o,r){return e!==r}).map(function(e){return{x:e.x,y:e.y,score:e.score+Math.pow(e.size-o.size,2)/o.size,size:e.size}\n}).sort(function(o,e){return o.score-e.score});if(t.length<2)return null;var c=o.score+t[0].score+t[1].score;return{points:[o].concat(t.slice(0,2)),score:c}}).filter(function(o){return!!o}).sort(function(o,e){return o.score-e.score});if(0===i.length)return null;var m,f,w=c(i[0].points[0],i[0].points[1],i[0].points[2]),P=w.topRight,v=w.topLeft,h=w.bottomLeft;try{L=s(v,P,h,o),m=L.dimension,f=L.moduleSize}catch(o){return null}var y={x:P.x-v.x+h.x,y:P.y-v.y+h.y},p=(C(v,h)+C(v,P))/2/f,b=1-3/p,g={x:v.x+b*(y.x-v.x),y:v.y+b*(y.y-v.y)},x=a.map(function(e){var r=(e.top.startX+e.top.endX+e.bottom.startX+e.bottom.endX)/4,c=(e.top.y+e.bottom.y+1)/2;if(o.get(Math.floor(r),Math.floor(c))){var s=[e.top.endX-e.top.startX,e.bottom.endX-e.bottom.startX,e.bottom.y-e.top.y+1];t(s);return{x:r,y:c,score:l({x:Math.floor(r),y:Math.floor(c)},[1,1,1],o)+C({x:r,y:c},g)}}}).filter(function(o){return!!o}).sort(function(o,e){return o.score-e.score}),M=p>=15&&x.length?x[0]:g;return{alignmentPattern:{x:M.x,y:M.y},bottomLeft:{x:h.x,y:h.y},dimension:m,topLeft:{x:v.x,y:v.y},topRight:{x:P.x,y:P.y}};var L}Object.defineProperty(e,\"__esModule\",{value:!0});var B=4,k=.5,u=1.5,C=function(o,e){return Math.sqrt(Math.pow(e.x-o.x,2)+Math.pow(e.y-o.y,2))};e.locate=i}]).default}),self.addEventListener(\"message\",function(o){var e=jsQR(o.data.data,o.data.width,o.data.height);e?postMessage(e.data):postMessage(null)});"], {
  type: 'application/javascript'
});

// Props that are allowed to change dynamicly
var propsKeys = ['delay', 'legacyMode', 'facingMode'];

module.exports = (_temp = _class = function (_Component) {
  _inherits(Reader, _Component);

  function Reader(props) {
    _classCallCheck(this, Reader);

    var _this = _possibleConstructorReturn(this, (Reader.__proto__ || Object.getPrototypeOf(Reader)).call(this, props));

    _this.els = {};


    _this.state = {
      mirrorVideo: false

      // Bind function to the class
    };_this.initiate = _this.initiate.bind(_this);
    _this.initiateLegacyMode = _this.initiateLegacyMode.bind(_this);
    _this.check = _this.check.bind(_this);
    _this.handleVideo = _this.handleVideo.bind(_this);
    _this.handleLoadStart = _this.handleLoadStart.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.clearComponent = _this.clearComponent.bind(_this);
    _this.handleReaderLoad = _this.handleReaderLoad.bind(_this);
    _this.openImageDialog = _this.openImageDialog.bind(_this);
    _this.handleWorkerMessage = _this.handleWorkerMessage.bind(_this);
    _this.setRefFactory = _this.setRefFactory.bind(_this);
    return _this;
  }

  _createClass(Reader, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Initiate web worker execute handler according to mode.
      this.worker = new Worker(URL.createObjectURL(workerBlob));
      this.worker.onmessage = this.handleWorkerMessage;

      if (!this.props.legacyMode) {
        this.initiate();
      } else {
        this.initiateLegacyMode();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // React according to change in props
      var changedProps = havePropsChanged(this.props, nextProps, propsKeys);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = changedProps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var prop = _step.value;

          if (prop == 'facingMode') {
            this.clearComponent();
            this.initiate(nextProps);
            break;
          } else if (prop == 'delay') {
            if (this.props.delay == false && !nextProps.legacyMode) {
              this.timeout = setTimeout(this.check, nextProps.delay);
            }
            if (nextProps.delay == false) {
              clearTimeout(this.timeout);
            }
          } else if (prop == 'legacyMode') {
            if (this.props.legacyMode && !nextProps.legacyMode) {
              this.clearComponent();
              this.initiate(nextProps);
            } else {
              this.clearComponent();
              this.componentDidUpdate = this.initiateLegacyMode;
            }
            break;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      if (nextState !== this.state) {
        return true;
      }

      // Only render when the `propsKeys` have changed.
      var changedProps = havePropsChanged(this.props, nextProps, propsKeys);
      return changedProps.length > 0;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Stop web-worker and clear the component
      if (this.worker) {
        this.worker.terminate();
        this.worker = undefined;
      }
      this.clearComponent();
    }
  }, {
    key: 'clearComponent',
    value: function clearComponent() {
      // Remove all event listeners and variables
      if (this.timeout) {
        clearTimeout(this.timeout);
        this.timeout = undefined;
      }
      if (this.stopCamera) {
        this.stopCamera();
      }
      if (this.reader) {
        this.reader.removeEventListener('load', this.handleReaderLoad);
      }
      if (this.els.img) {
        this.els.img.removeEventListener('load', this.check);
      }
    }
  }, {
    key: 'initiate',
    value: function initiate() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var onError = props.onError,
          facingMode = props.facingMode;

      // Check browser facingMode constraint support
      // Firefox ignores facingMode or deviceId constraints

      var isFirefox = /firefox/i.test(navigator.userAgent);
      var supported = {};
      if (navigator.mediaDevices && typeof navigator.mediaDevices.getSupportedConstraints === 'function') {
        supported = navigator.mediaDevices.getSupportedConstraints();
      }
      var constraints = {};

      if (supported.facingMode) {
        constraints.facingMode = { ideal: facingMode };
      }
      if (supported.frameRate) {
        constraints.frameRate = { ideal: 25, min: 10 };
      }

      var vConstraintsPromise = supported.facingMode || isFirefox ? Promise.resolve(props.constraints || constraints) : getDeviceId(facingMode).then(function (deviceId) {
        return Object.assign({}, { deviceId: deviceId }, props.constraints);
      });

      vConstraintsPromise.then(function (video) {
        return navigator.mediaDevices.getUserMedia({ video: video });
      }).then(this.handleVideo).catch(onError);
    }
  }, {
    key: 'handleVideo',
    value: function handleVideo(stream) {
      var preview = this.els.preview;

      // Preview element hasn't been rendered so wait for it.

      if (!preview) {
        setTimeout(this.handleVideo, 200, stream);
      }

      // Handle different browser implementations of MediaStreams as src
      if (preview.srcObject !== undefined) {
        preview.srcObject = stream;
      } else if (preview.mozSrcObject !== undefined) {
        preview.mozSrcObject = stream;
      } else if (window.URL.createObjectURL) {
        preview.src = window.URL.createObjectURL(stream);
      } else if (window.webkitURL) {
        preview.src = window.webkitURL.createObjectURL(stream);
      } else {
        preview.src = stream;
      }

      // IOS play in fullscreen
      preview.playsInline = true;

      var streamTrack = stream.getTracks()[0];
      // Assign `stopCamera` so the track can be stopped once component is cleared
      this.stopCamera = streamTrack.stop.bind(streamTrack);

      preview.addEventListener('loadstart', this.handleLoadStart);

      var facingUserPattern = getFacingModePattern('user');
      var isUserFacing = facingUserPattern.test(streamTrack.label);
      this.setState({ mirrorVideo: isUserFacing });
    }
  }, {
    key: 'handleLoadStart',
    value: function handleLoadStart() {
      var _props = this.props,
          delay = _props.delay,
          onLoad = _props.onLoad;

      var preview = this.els.preview;
      preview.play();

      if (typeof onLoad == 'function') {
        onLoad();
      }

      if (typeof delay == 'number') {
        this.timeout = setTimeout(this.check, delay);
      }

      // Some browsers call loadstart continuously
      preview.removeEventListener('loadstart', this.handleLoadStart);
    }
  }, {
    key: 'check',
    value: function check() {
      var _props2 = this.props,
          legacyMode = _props2.legacyMode,
          resolution = _props2.resolution,
          delay = _props2.delay;
      var _els = this.els,
          preview = _els.preview,
          canvas = _els.canvas,
          img = _els.img;

      // Get image/video dimensions

      var width = Math.floor(legacyMode ? img.naturalWidth : preview.videoWidth);
      var height = Math.floor(legacyMode ? img.naturalHeight : preview.videoHeight);

      // Canvas draw offsets
      var hozOffset = 0;
      var vertOffset = 0;

      // Scale image to correct resolution
      if (legacyMode) {
        // Keep image aspect ratio
        var greatestSize = width > height ? width : height;
        var ratio = resolution / greatestSize;

        height = ratio * height;
        width = ratio * width;

        canvas.width = width;
        canvas.height = height;
      } else {
        // Crop image to fit 1:1 aspect ratio
        var smallestSize = width < height ? width : height;
        var _ratio = resolution / smallestSize;

        height = _ratio * height;
        width = _ratio * width;

        vertOffset = (height - resolution) / 2 * -1;
        hozOffset = (width - resolution) / 2 * -1;

        canvas.width = resolution;
        canvas.height = resolution;
      }

      var previewIsPlaying = preview && preview.readyState === preview.HAVE_ENOUGH_DATA;

      if (legacyMode || previewIsPlaying) {
        var ctx = canvas.getContext('2d');

        ctx.drawImage(legacyMode ? img : preview, hozOffset, vertOffset, width, height);

        var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        // Send data to web-worker
        this.worker.postMessage(imageData);
      } else {
        // Preview not ready -> check later
        this.timeout = setTimeout(this.check, delay);
      }
    }
  }, {
    key: 'handleWorkerMessage',
    value: function handleWorkerMessage(e) {
      var _props3 = this.props,
          onScan = _props3.onScan,
          legacyMode = _props3.legacyMode,
          delay = _props3.delay;

      var decoded = e.data;
      onScan(decoded || null);

      if (!legacyMode && typeof delay == 'number' && this.worker) {
        this.timeout = setTimeout(this.check, delay);
      }
    }
  }, {
    key: 'initiateLegacyMode',
    value: function initiateLegacyMode() {
      this.reader = new FileReader();
      this.reader.addEventListener('load', this.handleReaderLoad);
      this.els.img.addEventListener('load', this.check, false);

      // Reset componentDidUpdate
      this.componentDidUpdate = undefined;

      if (typeof this.props.onLoad == 'function') {
        this.props.onLoad();
      }
    }
  }, {
    key: 'handleInputChange',
    value: function handleInputChange(e) {
      var selectedImg = e.target.files[0];
      this.reader.readAsDataURL(selectedImg);
    }
  }, {
    key: 'handleReaderLoad',
    value: function handleReaderLoad(e) {
      // Set selected image blob as img source
      this.els.img.src = e.target.result;
    }
  }, {
    key: 'openImageDialog',
    value: function openImageDialog() {
      // Function to be executed by parent in user action context to trigger img file uploader
      this.els.input.click();
    }
  }, {
    key: 'setRefFactory',
    value: function setRefFactory(key) {
      var _this2 = this;

      return function (element) {
        _this2.els[key] = element;
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          style = _props4.style,
          className = _props4.className,
          onImageLoad = _props4.onImageLoad,
          legacyMode = _props4.legacyMode,
          showViewFinder = _props4.showViewFinder,
          facingMode = _props4.facingMode;


      var containerStyle = {
        overflow: 'hidden',
        position: 'relative',
        width: '100%',
        paddingTop: '100%'
      };
      var hiddenStyle = { display: 'none' };
      var previewStyle = {
        top: 0,
        left: 0,
        display: 'block',
        position: 'absolute',
        overflow: 'hidden',
        width: '100%',
        height: '100%'
      };
      var videoPreviewStyle = _extends({}, previewStyle, {
        objectFit: 'cover',
        transform: this.state.mirrorVideo ? 'scaleX(-1)' : undefined
      });
      var imgPreviewStyle = _extends({}, previewStyle, {
        objectFit: 'scale-down'
      });

      var viewFinderStyle = {
        top: 0,
        left: 0,
        zIndex: 1,
        boxSizing: 'border-box',
        border: '50px solid rgba(0, 0, 0, 0.3)',
        boxShadow: 'inset 0 0 0 5px rgba(255, 0, 0, 0.5)',
        position: 'absolute',
        width: '100%',
        height: '100%'
      };

      return React.createElement(
        'section',
        { className: className, style: style },
        React.createElement(
          'section',
          { style: containerStyle },
          !legacyMode && showViewFinder ? React.createElement('div', { style: viewFinderStyle }) : null,
          legacyMode ? React.createElement('input', {
            style: hiddenStyle,
            type: 'file',
            accept: 'image/*',
            ref: this.setRefFactory('input'),
            onChange: this.handleInputChange
          }) : null,
          legacyMode ? React.createElement('img', { style: imgPreviewStyle, ref: this.setRefFactory('img'), onLoad: onImageLoad }) : React.createElement('video', { style: videoPreviewStyle, ref: this.setRefFactory('preview') }),
          React.createElement('canvas', { style: hiddenStyle, ref: this.setRefFactory('canvas') })
        )
      );
    }
  }]);

  return Reader;
}(Component), _class.propTypes = {
  onScan: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  onLoad: PropTypes.func,
  onImageLoad: PropTypes.func,
  delay: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  facingMode: PropTypes.oneOf(['user', 'environment']),
  legacyMode: PropTypes.bool,
  resolution: PropTypes.number,
  showViewFinder: PropTypes.bool,
  style: PropTypes.any,
  className: PropTypes.string,
  constraints: PropTypes.object
}, _class.defaultProps = {
  delay: 500,
  resolution: 600,
  facingMode: 'environment',
  showViewFinder: true,
  constraints: null
}, _temp);

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(2269),
    NoVideoInputDevicesError = _require.NoVideoInputDevicesError;

function defaultDeviceIdChooser(filteredDevices, videoDevices, facingMode) {
  if (filteredDevices.length > 0) {
    return filteredDevices[0].deviceId;
  }
  if (videoDevices.length == 1 || facingMode == 'user') {
    return videoDevices[0].deviceId;
  }
  return videoDevices[1].deviceId;
}

var getFacingModePattern = function getFacingModePattern(facingMode) {
  return facingMode == 'environment' ? /rear|back|environment/ig : /front|user|face/ig;
};

function getDeviceId(facingMode) {
  var chooseDeviceId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDeviceIdChooser;

  // Get manual deviceId from available devices.
  return new Promise(function (resolve, reject) {
    var enumerateDevices = void 0;
    try {
      enumerateDevices = navigator.mediaDevices.enumerateDevices();
    } catch (err) {
      reject(new NoVideoInputDevicesError());
    }
    enumerateDevices.then(function (devices) {
      // Filter out non-videoinputs
      var videoDevices = devices.filter(function (device) {
        return device.kind == 'videoinput';
      });

      if (videoDevices.length < 1) {
        reject(new NoVideoInputDevicesError());
        return;
      }

      var pattern = getFacingModePattern(facingMode);

      // Filter out video devices without the pattern
      var filteredDevices = videoDevices.filter(function (_ref) {
        var label = _ref.label;
        return pattern.test(label);
      });

      resolve(chooseDeviceId(filteredDevices, videoDevices, facingMode));
    });
  });
}

module.exports = { getDeviceId: getDeviceId, getFacingModePattern: getFacingModePattern };

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function NoVideoInputDevicesError() {
  this.name = 'NoVideoInputDevicesError';
  this.message = 'No video input devices found';
}
NoVideoInputDevicesError.prototype = new Error();

module.exports = {
  NoVideoInputDevicesError: NoVideoInputDevicesError
};

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function havePropsChanged(prevProps, nextProps, keys) {
  var changedProps = [];
  keys.forEach(function (key) {
    if (prevProps[key] != nextProps[key]) {
      changedProps.push(key);
    }
  });
  return changedProps;
};

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * From https://gist.github.com/nolanlawson/10340255
 */
module.exports = function createBlob(parts, properties) {
  parts = parts || [];
  properties = properties || {};
  try {
    return new Blob(parts, properties);
  } catch (e) {
    if (e.name !== "TypeError") {
      throw e;
    }
    var BlobBuilder = window.BlobBuilder || window.MSBlobBuilder || window.MozBlobBuilder || window.WebKitBlobBuilder;
    var builder = new BlobBuilder();
    for (var i = 0; i < parts.length; i += 1) {
      builder.append(parts[i]);
    }
    return builder.getBlob(properties.type);
  }
};

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */



var adapterFactory = __webpack_require__(2273);
module.exports = adapterFactory({window: global.window});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(77)))

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */



var utils = __webpack_require__(104);
// Shimming starts here.
module.exports = function(dependencies, opts) {
  var window = dependencies && dependencies.window;

  var options = {
    shimChrome: true,
    shimFirefox: true,
    shimEdge: true,
    shimSafari: true,
  };

  for (var key in opts) {
    if (hasOwnProperty.call(opts, key)) {
      options[key] = opts[key];
    }
  }

  // Utils.
  var logging = utils.log;
  var browserDetails = utils.detectBrowser(window);

  // Uncomment the line below if you want logging to occur, including logging
  // for the switch statement below. Can also be turned on in the browser via
  // adapter.disableLog(false), but then logging from the switch statement below
  // will not appear.
  // require('./utils').disableLog(false);

  // Browser shims.
  var chromeShim = __webpack_require__(2274) || null;
  var edgeShim = __webpack_require__(2276) || null;
  var firefoxShim = __webpack_require__(2280) || null;
  var safariShim = __webpack_require__(2282) || null;
  var commonShim = __webpack_require__(2283) || null;

  // Export to the adapter global object visible in the browser.
  var adapter = {
    browserDetails: browserDetails,
    commonShim: commonShim,
    extractVersion: utils.extractVersion,
    disableLog: utils.disableLog,
    disableWarnings: utils.disableWarnings
  };

  // Shim browser if found.
  switch (browserDetails.browser) {
    case 'chrome':
      if (!chromeShim || !chromeShim.shimPeerConnection ||
          !options.shimChrome) {
        logging('Chrome shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming chrome.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = chromeShim;
      commonShim.shimCreateObjectURL(window);

      chromeShim.shimGetUserMedia(window);
      chromeShim.shimMediaStream(window);
      chromeShim.shimSourceObject(window);
      chromeShim.shimPeerConnection(window);
      chromeShim.shimOnTrack(window);
      chromeShim.shimAddTrackRemoveTrack(window);
      chromeShim.shimGetSendersWithDtmf(window);
      chromeShim.shimSenderReceiverGetStats(window);
      chromeShim.fixNegotiationNeeded(window);

      commonShim.shimRTCIceCandidate(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    case 'firefox':
      if (!firefoxShim || !firefoxShim.shimPeerConnection ||
          !options.shimFirefox) {
        logging('Firefox shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming firefox.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = firefoxShim;
      commonShim.shimCreateObjectURL(window);

      firefoxShim.shimGetUserMedia(window);
      firefoxShim.shimSourceObject(window);
      firefoxShim.shimPeerConnection(window);
      firefoxShim.shimOnTrack(window);
      firefoxShim.shimRemoveStream(window);
      firefoxShim.shimSenderGetStats(window);
      firefoxShim.shimReceiverGetStats(window);
      firefoxShim.shimRTCDataChannel(window);

      commonShim.shimRTCIceCandidate(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    case 'edge':
      if (!edgeShim || !edgeShim.shimPeerConnection || !options.shimEdge) {
        logging('MS edge shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming edge.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = edgeShim;
      commonShim.shimCreateObjectURL(window);

      edgeShim.shimGetUserMedia(window);
      edgeShim.shimPeerConnection(window);
      edgeShim.shimReplaceTrack(window);
      edgeShim.shimGetDisplayMedia(window);

      // the edge shim implements the full RTCIceCandidate object.

      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    case 'safari':
      if (!safariShim || !options.shimSafari) {
        logging('Safari shim is not included in this adapter release.');
        return adapter;
      }
      logging('adapter.js shimming safari.');
      // Export to the adapter global object visible in the browser.
      adapter.browserShim = safariShim;
      commonShim.shimCreateObjectURL(window);

      safariShim.shimRTCIceServerUrls(window);
      safariShim.shimCreateOfferLegacy(window);
      safariShim.shimCallbacksAPI(window);
      safariShim.shimLocalStreamsAPI(window);
      safariShim.shimRemoteStreamsAPI(window);
      safariShim.shimTrackEventTransceiver(window);
      safariShim.shimGetUserMedia(window);

      commonShim.shimRTCIceCandidate(window);
      commonShim.shimMaxMessageSize(window);
      commonShim.shimSendThrowTypeError(window);
      break;
    default:
      logging('Unsupported browser!');
      break;
  }

  return adapter;
};


/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */

var utils = __webpack_require__(104);
var logging = utils.log;

/* iterates the stats graph recursively. */
function walkStats(stats, base, resultSet) {
  if (!base || resultSet.has(base.id)) {
    return;
  }
  resultSet.set(base.id, base);
  Object.keys(base).forEach(function(name) {
    if (name.endsWith('Id')) {
      walkStats(stats, stats.get(base[name]), resultSet);
    } else if (name.endsWith('Ids')) {
      base[name].forEach(function(id) {
        walkStats(stats, stats.get(id), resultSet);
      });
    }
  });
}

/* filter getStats for a sender/receiver track. */
function filterStats(result, track, outbound) {
  var streamStatsType = outbound ? 'outbound-rtp' : 'inbound-rtp';
  var filteredResult = new Map();
  if (track === null) {
    return filteredResult;
  }
  var trackStats = [];
  result.forEach(function(value) {
    if (value.type === 'track' &&
        value.trackIdentifier === track.id) {
      trackStats.push(value);
    }
  });
  trackStats.forEach(function(trackStat) {
    result.forEach(function(stats) {
      if (stats.type === streamStatsType && stats.trackId === trackStat.id) {
        walkStats(result, stats, filteredResult);
      }
    });
  });
  return filteredResult;
}

module.exports = {
  shimGetUserMedia: __webpack_require__(2275),
  shimMediaStream: function(window) {
    window.MediaStream = window.MediaStream || window.webkitMediaStream;
  },

  shimOnTrack: function(window) {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in
        window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
        get: function() {
          return this._ontrack;
        },
        set: function(f) {
          if (this._ontrack) {
            this.removeEventListener('track', this._ontrack);
          }
          this.addEventListener('track', this._ontrack = f);
        },
        enumerable: true,
        configurable: true
      });
      var origSetRemoteDescription =
          window.RTCPeerConnection.prototype.setRemoteDescription;
      window.RTCPeerConnection.prototype.setRemoteDescription = function() {
        var pc = this;
        if (!pc._ontrackpoly) {
          pc._ontrackpoly = function(e) {
            // onaddstream does not fire when a track is added to an existing
            // stream. But stream.onaddtrack is implemented so we use that.
            e.stream.addEventListener('addtrack', function(te) {
              var receiver;
              if (window.RTCPeerConnection.prototype.getReceivers) {
                receiver = pc.getReceivers().find(function(r) {
                  return r.track && r.track.id === te.track.id;
                });
              } else {
                receiver = {track: te.track};
              }

              var event = new Event('track');
              event.track = te.track;
              event.receiver = receiver;
              event.transceiver = {receiver: receiver};
              event.streams = [e.stream];
              pc.dispatchEvent(event);
            });
            e.stream.getTracks().forEach(function(track) {
              var receiver;
              if (window.RTCPeerConnection.prototype.getReceivers) {
                receiver = pc.getReceivers().find(function(r) {
                  return r.track && r.track.id === track.id;
                });
              } else {
                receiver = {track: track};
              }
              var event = new Event('track');
              event.track = track;
              event.receiver = receiver;
              event.transceiver = {receiver: receiver};
              event.streams = [e.stream];
              pc.dispatchEvent(event);
            });
          };
          pc.addEventListener('addstream', pc._ontrackpoly);
        }
        return origSetRemoteDescription.apply(pc, arguments);
      };
    } else {
      // even if RTCRtpTransceiver is in window, it is only used and
      // emitted in unified-plan. Unfortunately this means we need
      // to unconditionally wrap the event.
      utils.wrapPeerConnectionEvent(window, 'track', function(e) {
        if (!e.transceiver) {
          Object.defineProperty(e, 'transceiver',
            {value: {receiver: e.receiver}});
        }
        return e;
      });
    }
  },

  shimGetSendersWithDtmf: function(window) {
    // Overrides addTrack/removeTrack, depends on shimAddTrackRemoveTrack.
    if (typeof window === 'object' && window.RTCPeerConnection &&
        !('getSenders' in window.RTCPeerConnection.prototype) &&
        'createDTMFSender' in window.RTCPeerConnection.prototype) {
      var shimSenderWithDtmf = function(pc, track) {
        return {
          track: track,
          get dtmf() {
            if (this._dtmf === undefined) {
              if (track.kind === 'audio') {
                this._dtmf = pc.createDTMFSender(track);
              } else {
                this._dtmf = null;
              }
            }
            return this._dtmf;
          },
          _pc: pc
        };
      };

      // augment addTrack when getSenders is not available.
      if (!window.RTCPeerConnection.prototype.getSenders) {
        window.RTCPeerConnection.prototype.getSenders = function() {
          this._senders = this._senders || [];
          return this._senders.slice(); // return a copy of the internal state.
        };
        var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
        window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
          var pc = this;
          var sender = origAddTrack.apply(pc, arguments);
          if (!sender) {
            sender = shimSenderWithDtmf(pc, track);
            pc._senders.push(sender);
          }
          return sender;
        };

        var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
        window.RTCPeerConnection.prototype.removeTrack = function(sender) {
          var pc = this;
          origRemoveTrack.apply(pc, arguments);
          var idx = pc._senders.indexOf(sender);
          if (idx !== -1) {
            pc._senders.splice(idx, 1);
          }
        };
      }
      var origAddStream = window.RTCPeerConnection.prototype.addStream;
      window.RTCPeerConnection.prototype.addStream = function(stream) {
        var pc = this;
        pc._senders = pc._senders || [];
        origAddStream.apply(pc, [stream]);
        stream.getTracks().forEach(function(track) {
          pc._senders.push(shimSenderWithDtmf(pc, track));
        });
      };

      var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
      window.RTCPeerConnection.prototype.removeStream = function(stream) {
        var pc = this;
        pc._senders = pc._senders || [];
        origRemoveStream.apply(pc, [stream]);

        stream.getTracks().forEach(function(track) {
          var sender = pc._senders.find(function(s) {
            return s.track === track;
          });
          if (sender) {
            pc._senders.splice(pc._senders.indexOf(sender), 1); // remove sender
          }
        });
      };
    } else if (typeof window === 'object' && window.RTCPeerConnection &&
               'getSenders' in window.RTCPeerConnection.prototype &&
               'createDTMFSender' in window.RTCPeerConnection.prototype &&
               window.RTCRtpSender &&
               !('dtmf' in window.RTCRtpSender.prototype)) {
      var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
      window.RTCPeerConnection.prototype.getSenders = function() {
        var pc = this;
        var senders = origGetSenders.apply(pc, []);
        senders.forEach(function(sender) {
          sender._pc = pc;
        });
        return senders;
      };

      Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
        get: function() {
          if (this._dtmf === undefined) {
            if (this.track.kind === 'audio') {
              this._dtmf = this._pc.createDTMFSender(this.track);
            } else {
              this._dtmf = null;
            }
          }
          return this._dtmf;
        }
      });
    }
  },

  shimSenderReceiverGetStats: function(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection &&
        window.RTCRtpSender && window.RTCRtpReceiver)) {
      return;
    }

    // shim sender stats.
    if (!('getStats' in window.RTCRtpSender.prototype)) {
      var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
      if (origGetSenders) {
        window.RTCPeerConnection.prototype.getSenders = function() {
          var pc = this;
          var senders = origGetSenders.apply(pc, []);
          senders.forEach(function(sender) {
            sender._pc = pc;
          });
          return senders;
        };
      }

      var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
      if (origAddTrack) {
        window.RTCPeerConnection.prototype.addTrack = function() {
          var sender = origAddTrack.apply(this, arguments);
          sender._pc = this;
          return sender;
        };
      }
      window.RTCRtpSender.prototype.getStats = function() {
        var sender = this;
        return this._pc.getStats().then(function(result) {
          /* Note: this will include stats of all senders that
           *   send a track with the same id as sender.track as
           *   it is not possible to identify the RTCRtpSender.
           */
          return filterStats(result, sender.track, true);
        });
      };
    }

    // shim receiver stats.
    if (!('getStats' in window.RTCRtpReceiver.prototype)) {
      var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
      if (origGetReceivers) {
        window.RTCPeerConnection.prototype.getReceivers = function() {
          var pc = this;
          var receivers = origGetReceivers.apply(pc, []);
          receivers.forEach(function(receiver) {
            receiver._pc = pc;
          });
          return receivers;
        };
      }
      utils.wrapPeerConnectionEvent(window, 'track', function(e) {
        e.receiver._pc = e.srcElement;
        return e;
      });
      window.RTCRtpReceiver.prototype.getStats = function() {
        var receiver = this;
        return this._pc.getStats().then(function(result) {
          return filterStats(result, receiver.track, false);
        });
      };
    }

    if (!('getStats' in window.RTCRtpSender.prototype &&
        'getStats' in window.RTCRtpReceiver.prototype)) {
      return;
    }

    // shim RTCPeerConnection.getStats(track).
    var origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function() {
      var pc = this;
      if (arguments.length > 0 &&
          arguments[0] instanceof window.MediaStreamTrack) {
        var track = arguments[0];
        var sender;
        var receiver;
        var err;
        pc.getSenders().forEach(function(s) {
          if (s.track === track) {
            if (sender) {
              err = true;
            } else {
              sender = s;
            }
          }
        });
        pc.getReceivers().forEach(function(r) {
          if (r.track === track) {
            if (receiver) {
              err = true;
            } else {
              receiver = r;
            }
          }
          return r.track === track;
        });
        if (err || (sender && receiver)) {
          return Promise.reject(new DOMException(
            'There are more than one sender or receiver for the track.',
            'InvalidAccessError'));
        } else if (sender) {
          return sender.getStats();
        } else if (receiver) {
          return receiver.getStats();
        }
        return Promise.reject(new DOMException(
          'There is no sender or receiver for the track.',
          'InvalidAccessError'));
      }
      return origGetStats.apply(pc, arguments);
    };
  },

  shimSourceObject: function(window) {
    var URL = window && window.URL;

    if (typeof window === 'object') {
      if (window.HTMLMediaElement &&
        !('srcObject' in window.HTMLMediaElement.prototype)) {
        // Shim the srcObject property, once, when HTMLMediaElement is found.
        Object.defineProperty(window.HTMLMediaElement.prototype, 'srcObject', {
          get: function() {
            return this._srcObject;
          },
          set: function(stream) {
            var self = this;
            // Use _srcObject as a private property for this shim
            this._srcObject = stream;
            if (this.src) {
              URL.revokeObjectURL(this.src);
            }

            if (!stream) {
              this.src = '';
              return undefined;
            }
            this.src = URL.createObjectURL(stream);
            // We need to recreate the blob url when a track is added or
            // removed. Doing it manually since we want to avoid a recursion.
            stream.addEventListener('addtrack', function() {
              if (self.src) {
                URL.revokeObjectURL(self.src);
              }
              self.src = URL.createObjectURL(stream);
            });
            stream.addEventListener('removetrack', function() {
              if (self.src) {
                URL.revokeObjectURL(self.src);
              }
              self.src = URL.createObjectURL(stream);
            });
          }
        });
      }
    }
  },

  shimAddTrackRemoveTrackWithNative: function(window) {
    // shim addTrack/removeTrack with native variants in order to make
    // the interactions with legacy getLocalStreams behave as in other browsers.
    // Keeps a mapping stream.id => [stream, rtpsenders...]
    window.RTCPeerConnection.prototype.getLocalStreams = function() {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      return Object.keys(this._shimmedLocalStreams).map(function(streamId) {
        return pc._shimmedLocalStreams[streamId][0];
      });
    };

    var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
      if (!stream) {
        return origAddTrack.apply(this, arguments);
      }
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};

      var sender = origAddTrack.apply(this, arguments);
      if (!this._shimmedLocalStreams[stream.id]) {
        this._shimmedLocalStreams[stream.id] = [stream, sender];
      } else if (this._shimmedLocalStreams[stream.id].indexOf(sender) === -1) {
        this._shimmedLocalStreams[stream.id].push(sender);
      }
      return sender;
    };

    var origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function(stream) {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};

      stream.getTracks().forEach(function(track) {
        var alreadyExists = pc.getSenders().find(function(s) {
          return s.track === track;
        });
        if (alreadyExists) {
          throw new DOMException('Track already exists.',
              'InvalidAccessError');
        }
      });
      var existingSenders = pc.getSenders();
      origAddStream.apply(this, arguments);
      var newSenders = pc.getSenders().filter(function(newSender) {
        return existingSenders.indexOf(newSender) === -1;
      });
      this._shimmedLocalStreams[stream.id] = [stream].concat(newSenders);
    };

    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      delete this._shimmedLocalStreams[stream.id];
      return origRemoveStream.apply(this, arguments);
    };

    var origRemoveTrack = window.RTCPeerConnection.prototype.removeTrack;
    window.RTCPeerConnection.prototype.removeTrack = function(sender) {
      var pc = this;
      this._shimmedLocalStreams = this._shimmedLocalStreams || {};
      if (sender) {
        Object.keys(this._shimmedLocalStreams).forEach(function(streamId) {
          var idx = pc._shimmedLocalStreams[streamId].indexOf(sender);
          if (idx !== -1) {
            pc._shimmedLocalStreams[streamId].splice(idx, 1);
          }
          if (pc._shimmedLocalStreams[streamId].length === 1) {
            delete pc._shimmedLocalStreams[streamId];
          }
        });
      }
      return origRemoveTrack.apply(this, arguments);
    };
  },

  shimAddTrackRemoveTrack: function(window) {
    if (!window.RTCPeerConnection) {
      return;
    }
    var browserDetails = utils.detectBrowser(window);
    // shim addTrack and removeTrack.
    if (window.RTCPeerConnection.prototype.addTrack &&
        browserDetails.version >= 65) {
      return this.shimAddTrackRemoveTrackWithNative(window);
    }

    // also shim pc.getLocalStreams when addTrack is shimmed
    // to return the original streams.
    var origGetLocalStreams = window.RTCPeerConnection.prototype
        .getLocalStreams;
    window.RTCPeerConnection.prototype.getLocalStreams = function() {
      var pc = this;
      var nativeStreams = origGetLocalStreams.apply(this);
      pc._reverseStreams = pc._reverseStreams || {};
      return nativeStreams.map(function(stream) {
        return pc._reverseStreams[stream.id];
      });
    };

    var origAddStream = window.RTCPeerConnection.prototype.addStream;
    window.RTCPeerConnection.prototype.addStream = function(stream) {
      var pc = this;
      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};

      stream.getTracks().forEach(function(track) {
        var alreadyExists = pc.getSenders().find(function(s) {
          return s.track === track;
        });
        if (alreadyExists) {
          throw new DOMException('Track already exists.',
              'InvalidAccessError');
        }
      });
      // Add identity mapping for consistency with addTrack.
      // Unless this is being used with a stream from addTrack.
      if (!pc._reverseStreams[stream.id]) {
        var newStream = new window.MediaStream(stream.getTracks());
        pc._streams[stream.id] = newStream;
        pc._reverseStreams[newStream.id] = stream;
        stream = newStream;
      }
      origAddStream.apply(pc, [stream]);
    };

    var origRemoveStream = window.RTCPeerConnection.prototype.removeStream;
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      var pc = this;
      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};

      origRemoveStream.apply(pc, [(pc._streams[stream.id] || stream)]);
      delete pc._reverseStreams[(pc._streams[stream.id] ?
          pc._streams[stream.id].id : stream.id)];
      delete pc._streams[stream.id];
    };

    window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
      var pc = this;
      if (pc.signalingState === 'closed') {
        throw new DOMException(
          'The RTCPeerConnection\'s signalingState is \'closed\'.',
          'InvalidStateError');
      }
      var streams = [].slice.call(arguments, 1);
      if (streams.length !== 1 ||
          !streams[0].getTracks().find(function(t) {
            return t === track;
          })) {
        // this is not fully correct but all we can manage without
        // [[associated MediaStreams]] internal slot.
        throw new DOMException(
          'The adapter.js addTrack polyfill only supports a single ' +
          ' stream which is associated with the specified track.',
          'NotSupportedError');
      }

      var alreadyExists = pc.getSenders().find(function(s) {
        return s.track === track;
      });
      if (alreadyExists) {
        throw new DOMException('Track already exists.',
            'InvalidAccessError');
      }

      pc._streams = pc._streams || {};
      pc._reverseStreams = pc._reverseStreams || {};
      var oldStream = pc._streams[stream.id];
      if (oldStream) {
        // this is using odd Chrome behaviour, use with caution:
        // https://bugs.chromium.org/p/webrtc/issues/detail?id=7815
        // Note: we rely on the high-level addTrack/dtmf shim to
        // create the sender with a dtmf sender.
        oldStream.addTrack(track);

        // Trigger ONN async.
        Promise.resolve().then(function() {
          pc.dispatchEvent(new Event('negotiationneeded'));
        });
      } else {
        var newStream = new window.MediaStream([track]);
        pc._streams[stream.id] = newStream;
        pc._reverseStreams[newStream.id] = stream;
        pc.addStream(newStream);
      }
      return pc.getSenders().find(function(s) {
        return s.track === track;
      });
    };

    // replace the internal stream id with the external one and
    // vice versa.
    function replaceInternalStreamId(pc, description) {
      var sdp = description.sdp;
      Object.keys(pc._reverseStreams || []).forEach(function(internalId) {
        var externalStream = pc._reverseStreams[internalId];
        var internalStream = pc._streams[externalStream.id];
        sdp = sdp.replace(new RegExp(internalStream.id, 'g'),
            externalStream.id);
      });
      return new RTCSessionDescription({
        type: description.type,
        sdp: sdp
      });
    }
    function replaceExternalStreamId(pc, description) {
      var sdp = description.sdp;
      Object.keys(pc._reverseStreams || []).forEach(function(internalId) {
        var externalStream = pc._reverseStreams[internalId];
        var internalStream = pc._streams[externalStream.id];
        sdp = sdp.replace(new RegExp(externalStream.id, 'g'),
            internalStream.id);
      });
      return new RTCSessionDescription({
        type: description.type,
        sdp: sdp
      });
    }
    ['createOffer', 'createAnswer'].forEach(function(method) {
      var nativeMethod = window.RTCPeerConnection.prototype[method];
      window.RTCPeerConnection.prototype[method] = function() {
        var pc = this;
        var args = arguments;
        var isLegacyCall = arguments.length &&
            typeof arguments[0] === 'function';
        if (isLegacyCall) {
          return nativeMethod.apply(pc, [
            function(description) {
              var desc = replaceInternalStreamId(pc, description);
              args[0].apply(null, [desc]);
            },
            function(err) {
              if (args[1]) {
                args[1].apply(null, err);
              }
            }, arguments[2]
          ]);
        }
        return nativeMethod.apply(pc, arguments)
        .then(function(description) {
          return replaceInternalStreamId(pc, description);
        });
      };
    });

    var origSetLocalDescription =
        window.RTCPeerConnection.prototype.setLocalDescription;
    window.RTCPeerConnection.prototype.setLocalDescription = function() {
      var pc = this;
      if (!arguments.length || !arguments[0].type) {
        return origSetLocalDescription.apply(pc, arguments);
      }
      arguments[0] = replaceExternalStreamId(pc, arguments[0]);
      return origSetLocalDescription.apply(pc, arguments);
    };

    // TODO: mangle getStats: https://w3c.github.io/webrtc-stats/#dom-rtcmediastreamstats-streamidentifier

    var origLocalDescription = Object.getOwnPropertyDescriptor(
        window.RTCPeerConnection.prototype, 'localDescription');
    Object.defineProperty(window.RTCPeerConnection.prototype,
        'localDescription', {
          get: function() {
            var pc = this;
            var description = origLocalDescription.get.apply(this);
            if (description.type === '') {
              return description;
            }
            return replaceInternalStreamId(pc, description);
          }
        });

    window.RTCPeerConnection.prototype.removeTrack = function(sender) {
      var pc = this;
      if (pc.signalingState === 'closed') {
        throw new DOMException(
          'The RTCPeerConnection\'s signalingState is \'closed\'.',
          'InvalidStateError');
      }
      // We can not yet check for sender instanceof RTCRtpSender
      // since we shim RTPSender. So we check if sender._pc is set.
      if (!sender._pc) {
        throw new DOMException('Argument 1 of RTCPeerConnection.removeTrack ' +
            'does not implement interface RTCRtpSender.', 'TypeError');
      }
      var isLocal = sender._pc === pc;
      if (!isLocal) {
        throw new DOMException('Sender was not created by this connection.',
            'InvalidAccessError');
      }

      // Search for the native stream the senders track belongs to.
      pc._streams = pc._streams || {};
      var stream;
      Object.keys(pc._streams).forEach(function(streamid) {
        var hasTrack = pc._streams[streamid].getTracks().find(function(track) {
          return sender.track === track;
        });
        if (hasTrack) {
          stream = pc._streams[streamid];
        }
      });

      if (stream) {
        if (stream.getTracks().length === 1) {
          // if this is the last track of the stream, remove the stream. This
          // takes care of any shimmed _senders.
          pc.removeStream(pc._reverseStreams[stream.id]);
        } else {
          // relying on the same odd chrome behaviour as above.
          stream.removeTrack(sender.track);
        }
        pc.dispatchEvent(new Event('negotiationneeded'));
      }
    };
  },

  shimPeerConnection: function(window) {
    var browserDetails = utils.detectBrowser(window);

    // The RTCPeerConnection object.
    if (!window.RTCPeerConnection && window.webkitRTCPeerConnection) {
      window.RTCPeerConnection = function(pcConfig, pcConstraints) {
        // Translate iceTransportPolicy to iceTransports,
        // see https://code.google.com/p/webrtc/issues/detail?id=4869
        // this was fixed in M56 along with unprefixing RTCPeerConnection.
        logging('PeerConnection');
        if (pcConfig && pcConfig.iceTransportPolicy) {
          pcConfig.iceTransports = pcConfig.iceTransportPolicy;
        }

        return new window.webkitRTCPeerConnection(pcConfig, pcConstraints);
      };
      window.RTCPeerConnection.prototype =
          window.webkitRTCPeerConnection.prototype;
      // wrap static methods. Currently just generateCertificate.
      if (window.webkitRTCPeerConnection.generateCertificate) {
        Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
          get: function() {
            return window.webkitRTCPeerConnection.generateCertificate;
          }
        });
      }
    }
    if (!window.RTCPeerConnection) {
      return;
    }

    var origGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function(selector,
        successCallback, errorCallback) {
      var pc = this;
      var args = arguments;

      // If selector is a function then we are in the old style stats so just
      // pass back the original getStats format to avoid breaking old users.
      if (arguments.length > 0 && typeof selector === 'function') {
        return origGetStats.apply(this, arguments);
      }

      // When spec-style getStats is supported, return those when called with
      // either no arguments or the selector argument is null.
      if (origGetStats.length === 0 && (arguments.length === 0 ||
          typeof arguments[0] !== 'function')) {
        return origGetStats.apply(this, []);
      }

      var fixChromeStats_ = function(response) {
        var standardReport = {};
        var reports = response.result();
        reports.forEach(function(report) {
          var standardStats = {
            id: report.id,
            timestamp: report.timestamp,
            type: {
              localcandidate: 'local-candidate',
              remotecandidate: 'remote-candidate'
            }[report.type] || report.type
          };
          report.names().forEach(function(name) {
            standardStats[name] = report.stat(name);
          });
          standardReport[standardStats.id] = standardStats;
        });

        return standardReport;
      };

      // shim getStats with maplike support
      var makeMapStats = function(stats) {
        return new Map(Object.keys(stats).map(function(key) {
          return [key, stats[key]];
        }));
      };

      if (arguments.length >= 2) {
        var successCallbackWrapper_ = function(response) {
          args[1](makeMapStats(fixChromeStats_(response)));
        };

        return origGetStats.apply(this, [successCallbackWrapper_,
          arguments[0]]);
      }

      // promise-support
      return new Promise(function(resolve, reject) {
        origGetStats.apply(pc, [
          function(response) {
            resolve(makeMapStats(fixChromeStats_(response)));
          }, reject]);
      }).then(successCallback, errorCallback);
    };

    // add promise support -- natively available in Chrome 51
    if (browserDetails.version < 51) {
      ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
          .forEach(function(method) {
            var nativeMethod = window.RTCPeerConnection.prototype[method];
            window.RTCPeerConnection.prototype[method] = function() {
              var args = arguments;
              var pc = this;
              var promise = new Promise(function(resolve, reject) {
                nativeMethod.apply(pc, [args[0], resolve, reject]);
              });
              if (args.length < 2) {
                return promise;
              }
              return promise.then(function() {
                args[1].apply(null, []);
              },
              function(err) {
                if (args.length >= 3) {
                  args[2].apply(null, [err]);
                }
              });
            };
          });
    }

    // promise support for createOffer and createAnswer. Available (without
    // bugs) since M52: crbug/619289
    if (browserDetails.version < 52) {
      ['createOffer', 'createAnswer'].forEach(function(method) {
        var nativeMethod = window.RTCPeerConnection.prototype[method];
        window.RTCPeerConnection.prototype[method] = function() {
          var pc = this;
          if (arguments.length < 1 || (arguments.length === 1 &&
              typeof arguments[0] === 'object')) {
            var opts = arguments.length === 1 ? arguments[0] : undefined;
            return new Promise(function(resolve, reject) {
              nativeMethod.apply(pc, [resolve, reject, opts]);
            });
          }
          return nativeMethod.apply(this, arguments);
        };
      });
    }

    // shim implicit creation of RTCSessionDescription/RTCIceCandidate
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          var nativeMethod = window.RTCPeerConnection.prototype[method];
          window.RTCPeerConnection.prototype[method] = function() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                window.RTCIceCandidate :
                window.RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          };
        });

    // support for addIceCandidate(null or undefined)
    var nativeAddIceCandidate =
        window.RTCPeerConnection.prototype.addIceCandidate;
    window.RTCPeerConnection.prototype.addIceCandidate = function() {
      if (!arguments[0]) {
        if (arguments[1]) {
          arguments[1].apply(null);
        }
        return Promise.resolve();
      }
      return nativeAddIceCandidate.apply(this, arguments);
    };
  },

  fixNegotiationNeeded: function(window) {
    utils.wrapPeerConnectionEvent(window, 'negotiationneeded', function(e) {
      var pc = e.target;
      if (pc.signalingState !== 'stable') {
        return;
      }
      return e;
    });
  },

  shimGetDisplayMedia: function(window, getSourceId) {
    if (!window.navigator || !window.navigator.mediaDevices ||
        'getDisplayMedia' in window.navigator.mediaDevices) {
      return;
    }
    // getSourceId is a function that returns a promise resolving with
    // the sourceId of the screen/window/tab to be shared.
    if (typeof getSourceId !== 'function') {
      console.error('shimGetDisplayMedia: getSourceId argument is not ' +
          'a function');
      return;
    }
    window.navigator.mediaDevices.getDisplayMedia = function(constraints) {
      return getSourceId(constraints)
        .then(function(sourceId) {
          var widthSpecified = constraints.video && constraints.video.width;
          var heightSpecified = constraints.video && constraints.video.height;
          var frameRateSpecified = constraints.video &&
            constraints.video.frameRate;
          constraints.video = {
            mandatory: {
              chromeMediaSource: 'desktop',
              chromeMediaSourceId: sourceId,
              maxFrameRate: frameRateSpecified || 3
            }
          };
          if (widthSpecified) {
            constraints.video.mandatory.maxWidth = widthSpecified;
          }
          if (heightSpecified) {
            constraints.video.mandatory.maxHeight = heightSpecified;
          }
          return window.navigator.mediaDevices.getUserMedia(constraints);
        });
    };
    window.navigator.getDisplayMedia = function(constraints) {
      utils.deprecated('navigator.getDisplayMedia',
          'navigator.mediaDevices.getDisplayMedia');
      return window.navigator.mediaDevices.getDisplayMedia(constraints);
    };
  }
};


/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */

var utils = __webpack_require__(104);
var logging = utils.log;

// Expose public methods.
module.exports = function(window) {
  var browserDetails = utils.detectBrowser(window);
  var navigator = window && window.navigator;

  var constraintsToChrome_ = function(c) {
    if (typeof c !== 'object' || c.mandatory || c.optional) {
      return c;
    }
    var cc = {};
    Object.keys(c).forEach(function(key) {
      if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
        return;
      }
      var r = (typeof c[key] === 'object') ? c[key] : {ideal: c[key]};
      if (r.exact !== undefined && typeof r.exact === 'number') {
        r.min = r.max = r.exact;
      }
      var oldname_ = function(prefix, name) {
        if (prefix) {
          return prefix + name.charAt(0).toUpperCase() + name.slice(1);
        }
        return (name === 'deviceId') ? 'sourceId' : name;
      };
      if (r.ideal !== undefined) {
        cc.optional = cc.optional || [];
        var oc = {};
        if (typeof r.ideal === 'number') {
          oc[oldname_('min', key)] = r.ideal;
          cc.optional.push(oc);
          oc = {};
          oc[oldname_('max', key)] = r.ideal;
          cc.optional.push(oc);
        } else {
          oc[oldname_('', key)] = r.ideal;
          cc.optional.push(oc);
        }
      }
      if (r.exact !== undefined && typeof r.exact !== 'number') {
        cc.mandatory = cc.mandatory || {};
        cc.mandatory[oldname_('', key)] = r.exact;
      } else {
        ['min', 'max'].forEach(function(mix) {
          if (r[mix] !== undefined) {
            cc.mandatory = cc.mandatory || {};
            cc.mandatory[oldname_(mix, key)] = r[mix];
          }
        });
      }
    });
    if (c.advanced) {
      cc.optional = (cc.optional || []).concat(c.advanced);
    }
    return cc;
  };

  var shimConstraints_ = function(constraints, func) {
    if (browserDetails.version >= 61) {
      return func(constraints);
    }
    constraints = JSON.parse(JSON.stringify(constraints));
    if (constraints && typeof constraints.audio === 'object') {
      var remap = function(obj, a, b) {
        if (a in obj && !(b in obj)) {
          obj[b] = obj[a];
          delete obj[a];
        }
      };
      constraints = JSON.parse(JSON.stringify(constraints));
      remap(constraints.audio, 'autoGainControl', 'googAutoGainControl');
      remap(constraints.audio, 'noiseSuppression', 'googNoiseSuppression');
      constraints.audio = constraintsToChrome_(constraints.audio);
    }
    if (constraints && typeof constraints.video === 'object') {
      // Shim facingMode for mobile & surface pro.
      var face = constraints.video.facingMode;
      face = face && ((typeof face === 'object') ? face : {ideal: face});
      var getSupportedFacingModeLies = browserDetails.version < 66;

      if ((face && (face.exact === 'user' || face.exact === 'environment' ||
                    face.ideal === 'user' || face.ideal === 'environment')) &&
          !(navigator.mediaDevices.getSupportedConstraints &&
            navigator.mediaDevices.getSupportedConstraints().facingMode &&
            !getSupportedFacingModeLies)) {
        delete constraints.video.facingMode;
        var matches;
        if (face.exact === 'environment' || face.ideal === 'environment') {
          matches = ['back', 'rear'];
        } else if (face.exact === 'user' || face.ideal === 'user') {
          matches = ['front'];
        }
        if (matches) {
          // Look for matches in label, or use last cam for back (typical).
          return navigator.mediaDevices.enumerateDevices()
          .then(function(devices) {
            devices = devices.filter(function(d) {
              return d.kind === 'videoinput';
            });
            var dev = devices.find(function(d) {
              return matches.some(function(match) {
                return d.label.toLowerCase().indexOf(match) !== -1;
              });
            });
            if (!dev && devices.length && matches.indexOf('back') !== -1) {
              dev = devices[devices.length - 1]; // more likely the back cam
            }
            if (dev) {
              constraints.video.deviceId = face.exact ? {exact: dev.deviceId} :
                                                        {ideal: dev.deviceId};
            }
            constraints.video = constraintsToChrome_(constraints.video);
            logging('chrome: ' + JSON.stringify(constraints));
            return func(constraints);
          });
        }
      }
      constraints.video = constraintsToChrome_(constraints.video);
    }
    logging('chrome: ' + JSON.stringify(constraints));
    return func(constraints);
  };

  var shimError_ = function(e) {
    if (browserDetails.version >= 64) {
      return e;
    }
    return {
      name: {
        PermissionDeniedError: 'NotAllowedError',
        PermissionDismissedError: 'NotAllowedError',
        InvalidStateError: 'NotAllowedError',
        DevicesNotFoundError: 'NotFoundError',
        ConstraintNotSatisfiedError: 'OverconstrainedError',
        TrackStartError: 'NotReadableError',
        MediaDeviceFailedDueToShutdown: 'NotAllowedError',
        MediaDeviceKillSwitchOn: 'NotAllowedError',
        TabCaptureError: 'AbortError',
        ScreenCaptureError: 'AbortError',
        DeviceCaptureError: 'AbortError'
      }[e.name] || e.name,
      message: e.message,
      constraint: e.constraint || e.constraintName,
      toString: function() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  var getUserMedia_ = function(constraints, onSuccess, onError) {
    shimConstraints_(constraints, function(c) {
      navigator.webkitGetUserMedia(c, onSuccess, function(e) {
        if (onError) {
          onError(shimError_(e));
        }
      });
    });
  };

  navigator.getUserMedia = getUserMedia_;

  // Returns the result of getUserMedia as a Promise.
  var getUserMediaPromise_ = function(constraints) {
    return new Promise(function(resolve, reject) {
      navigator.getUserMedia(constraints, resolve, reject);
    });
  };

  if (!navigator.mediaDevices) {
    navigator.mediaDevices = {
      getUserMedia: getUserMediaPromise_,
      enumerateDevices: function() {
        return new Promise(function(resolve) {
          var kinds = {audio: 'audioinput', video: 'videoinput'};
          return window.MediaStreamTrack.getSources(function(devices) {
            resolve(devices.map(function(device) {
              return {label: device.label,
                kind: kinds[device.kind],
                deviceId: device.id,
                groupId: ''};
            }));
          });
        });
      },
      getSupportedConstraints: function() {
        return {
          deviceId: true, echoCancellation: true, facingMode: true,
          frameRate: true, height: true, width: true
        };
      }
    };
  }

  // A shim for getUserMedia method on the mediaDevices object.
  // TODO(KaptenJansson) remove once implemented in Chrome stable.
  if (!navigator.mediaDevices.getUserMedia) {
    navigator.mediaDevices.getUserMedia = function(constraints) {
      return getUserMediaPromise_(constraints);
    };
  } else {
    // Even though Chrome 45 has navigator.mediaDevices and a getUserMedia
    // function which returns a Promise, it does not accept spec-style
    // constraints.
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(cs) {
      return shimConstraints_(cs, function(c) {
        return origGetUserMedia(c).then(function(stream) {
          if (c.audio && !stream.getAudioTracks().length ||
              c.video && !stream.getVideoTracks().length) {
            stream.getTracks().forEach(function(track) {
              track.stop();
            });
            throw new DOMException('', 'NotFoundError');
          }
          return stream;
        }, function(e) {
          return Promise.reject(shimError_(e));
        });
      });
    };
  }

  // Dummy devicechange event methods.
  // TODO(KaptenJansson) remove once implemented in Chrome stable.
  if (typeof navigator.mediaDevices.addEventListener === 'undefined') {
    navigator.mediaDevices.addEventListener = function() {
      logging('Dummy mediaDevices.addEventListener called.');
    };
  }
  if (typeof navigator.mediaDevices.removeEventListener === 'undefined') {
    navigator.mediaDevices.removeEventListener = function() {
      logging('Dummy mediaDevices.removeEventListener called.');
    };
  }
};


/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var utils = __webpack_require__(104);
var filterIceServers = __webpack_require__(2277);
var shimRTCPeerConnection = __webpack_require__(2278);

module.exports = {
  shimGetUserMedia: __webpack_require__(2279),
  shimPeerConnection: function(window) {
    var browserDetails = utils.detectBrowser(window);

    if (window.RTCIceGatherer) {
      if (!window.RTCIceCandidate) {
        window.RTCIceCandidate = function(args) {
          return args;
        };
      }
      if (!window.RTCSessionDescription) {
        window.RTCSessionDescription = function(args) {
          return args;
        };
      }
      // this adds an additional event listener to MediaStrackTrack that signals
      // when a tracks enabled property was changed. Workaround for a bug in
      // addStream, see below. No longer required in 15025+
      if (browserDetails.version < 15025) {
        var origMSTEnabled = Object.getOwnPropertyDescriptor(
            window.MediaStreamTrack.prototype, 'enabled');
        Object.defineProperty(window.MediaStreamTrack.prototype, 'enabled', {
          set: function(value) {
            origMSTEnabled.set.call(this, value);
            var ev = new Event('enabled');
            ev.enabled = value;
            this.dispatchEvent(ev);
          }
        });
      }
    }

    // ORTC defines the DTMF sender a bit different.
    // https://github.com/w3c/ortc/issues/714
    if (window.RTCRtpSender && !('dtmf' in window.RTCRtpSender.prototype)) {
      Object.defineProperty(window.RTCRtpSender.prototype, 'dtmf', {
        get: function() {
          if (this._dtmf === undefined) {
            if (this.track.kind === 'audio') {
              this._dtmf = new window.RTCDtmfSender(this);
            } else if (this.track.kind === 'video') {
              this._dtmf = null;
            }
          }
          return this._dtmf;
        }
      });
    }
    // Edge currently only implements the RTCDtmfSender, not the
    // RTCDTMFSender alias. See http://draft.ortc.org/#rtcdtmfsender2*
    if (window.RTCDtmfSender && !window.RTCDTMFSender) {
      window.RTCDTMFSender = window.RTCDtmfSender;
    }

    var RTCPeerConnectionShim = shimRTCPeerConnection(window,
        browserDetails.version);
    window.RTCPeerConnection = function(config) {
      if (config && config.iceServers) {
        config.iceServers = filterIceServers(config.iceServers);
      }
      return new RTCPeerConnectionShim(config);
    };
    window.RTCPeerConnection.prototype = RTCPeerConnectionShim.prototype;
  },
  shimReplaceTrack: function(window) {
    // ORTC has replaceTrack -- https://github.com/w3c/ortc/issues/614
    if (window.RTCRtpSender &&
        !('replaceTrack' in window.RTCRtpSender.prototype)) {
      window.RTCRtpSender.prototype.replaceTrack =
          window.RTCRtpSender.prototype.setTrack;
    }
  },
  shimGetDisplayMedia: function(window, preferredMediaSource) {
    if (!('getDisplayMedia' in window.navigator) ||
        !window.navigator.mediaDevices ||
        'getDisplayMedia' in window.navigator.mediaDevices) {
      return;
    }
    var origGetDisplayMedia = window.navigator.getDisplayMedia;
    window.navigator.mediaDevices.getDisplayMedia = function(constraints) {
      return origGetDisplayMedia.call(window.navigator, constraints);
    };
    window.navigator.getDisplayMedia = function(constraints) {
      utils.deprecated('navigator.getDisplayMedia',
          'navigator.mediaDevices.getDisplayMedia');
      return origGetDisplayMedia.call(window.navigator, constraints);
    };
  }
};


/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2018 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var utils = __webpack_require__(104);
// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times
module.exports = function(iceServers, edgeVersion) {
  var hasTurn = false;
  iceServers = JSON.parse(JSON.stringify(iceServers));
  return iceServers.filter(function(server) {
    if (server && (server.urls || server.url)) {
      var urls = server.urls || server.url;
      if (server.url && !server.urls) {
        utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
      }
      var isString = typeof urls === 'string';
      if (isString) {
        urls = [urls];
      }
      urls = urls.filter(function(url) {
        var validTurn = url.indexOf('turn:') === 0 &&
            url.indexOf('transport=udp') !== -1 &&
            url.indexOf('turn:[') === -1 &&
            !hasTurn;

        if (validTurn) {
          hasTurn = true;
          return true;
        }
        return url.indexOf('stun:') === 0 && edgeVersion >= 14393 &&
            url.indexOf('?transport=udp') === -1;
      });

      delete server.url;
      server.urls = isString ? urls[0] : urls;
      return !!urls.length;
    }
  });
};


/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var SDPUtils = __webpack_require__(673);

function fixStatsType(stat) {
  return {
    inboundrtp: 'inbound-rtp',
    outboundrtp: 'outbound-rtp',
    candidatepair: 'candidate-pair',
    localcandidate: 'local-candidate',
    remotecandidate: 'remote-candidate'
  }[stat.type] || stat.type;
}

function writeMediaSection(transceiver, caps, type, stream, dtlsRole) {
  var sdp = SDPUtils.writeRtpDescription(transceiver.kind, caps);

  // Map ICE parameters (ufrag, pwd) to SDP.
  sdp += SDPUtils.writeIceParameters(
      transceiver.iceGatherer.getLocalParameters());

  // Map DTLS parameters to SDP.
  sdp += SDPUtils.writeDtlsParameters(
      transceiver.dtlsTransport.getLocalParameters(),
      type === 'offer' ? 'actpass' : dtlsRole || 'active');

  sdp += 'a=mid:' + transceiver.mid + '\r\n';

  if (transceiver.rtpSender && transceiver.rtpReceiver) {
    sdp += 'a=sendrecv\r\n';
  } else if (transceiver.rtpSender) {
    sdp += 'a=sendonly\r\n';
  } else if (transceiver.rtpReceiver) {
    sdp += 'a=recvonly\r\n';
  } else {
    sdp += 'a=inactive\r\n';
  }

  if (transceiver.rtpSender) {
    var trackId = transceiver.rtpSender._initialTrackId ||
        transceiver.rtpSender.track.id;
    transceiver.rtpSender._initialTrackId = trackId;
    // spec.
    var msid = 'msid:' + (stream ? stream.id : '-') + ' ' +
        trackId + '\r\n';
    sdp += 'a=' + msid;
    // for Chrome. Legacy should no longer be required.
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
        ' ' + msid;

    // RTX
    if (transceiver.sendEncodingParameters[0].rtx) {
      sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
          ' ' + msid;
      sdp += 'a=ssrc-group:FID ' +
          transceiver.sendEncodingParameters[0].ssrc + ' ' +
          transceiver.sendEncodingParameters[0].rtx.ssrc +
          '\r\n';
    }
  }
  // FIXME: this should be written by writeRtpDescription.
  sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].ssrc +
      ' cname:' + SDPUtils.localCName + '\r\n';
  if (transceiver.rtpSender && transceiver.sendEncodingParameters[0].rtx) {
    sdp += 'a=ssrc:' + transceiver.sendEncodingParameters[0].rtx.ssrc +
        ' cname:' + SDPUtils.localCName + '\r\n';
  }
  return sdp;
}

// Edge does not like
// 1) stun: filtered after 14393 unless ?transport=udp is present
// 2) turn: that does not have all of turn:host:port?transport=udp
// 3) turn: with ipv6 addresses
// 4) turn: occurring muliple times
function filterIceServers(iceServers, edgeVersion) {
  var hasTurn = false;
  iceServers = JSON.parse(JSON.stringify(iceServers));
  return iceServers.filter(function(server) {
    if (server && (server.urls || server.url)) {
      var urls = server.urls || server.url;
      if (server.url && !server.urls) {
        console.warn('RTCIceServer.url is deprecated! Use urls instead.');
      }
      var isString = typeof urls === 'string';
      if (isString) {
        urls = [urls];
      }
      urls = urls.filter(function(url) {
        var validTurn = url.indexOf('turn:') === 0 &&
            url.indexOf('transport=udp') !== -1 &&
            url.indexOf('turn:[') === -1 &&
            !hasTurn;

        if (validTurn) {
          hasTurn = true;
          return true;
        }
        return url.indexOf('stun:') === 0 && edgeVersion >= 14393 &&
            url.indexOf('?transport=udp') === -1;
      });

      delete server.url;
      server.urls = isString ? urls[0] : urls;
      return !!urls.length;
    }
  });
}

// Determines the intersection of local and remote capabilities.
function getCommonCapabilities(localCapabilities, remoteCapabilities) {
  var commonCapabilities = {
    codecs: [],
    headerExtensions: [],
    fecMechanisms: []
  };

  var findCodecByPayloadType = function(pt, codecs) {
    pt = parseInt(pt, 10);
    for (var i = 0; i < codecs.length; i++) {
      if (codecs[i].payloadType === pt ||
          codecs[i].preferredPayloadType === pt) {
        return codecs[i];
      }
    }
  };

  var rtxCapabilityMatches = function(lRtx, rRtx, lCodecs, rCodecs) {
    var lCodec = findCodecByPayloadType(lRtx.parameters.apt, lCodecs);
    var rCodec = findCodecByPayloadType(rRtx.parameters.apt, rCodecs);
    return lCodec && rCodec &&
        lCodec.name.toLowerCase() === rCodec.name.toLowerCase();
  };

  localCapabilities.codecs.forEach(function(lCodec) {
    for (var i = 0; i < remoteCapabilities.codecs.length; i++) {
      var rCodec = remoteCapabilities.codecs[i];
      if (lCodec.name.toLowerCase() === rCodec.name.toLowerCase() &&
          lCodec.clockRate === rCodec.clockRate) {
        if (lCodec.name.toLowerCase() === 'rtx' &&
            lCodec.parameters && rCodec.parameters.apt) {
          // for RTX we need to find the local rtx that has a apt
          // which points to the same local codec as the remote one.
          if (!rtxCapabilityMatches(lCodec, rCodec,
              localCapabilities.codecs, remoteCapabilities.codecs)) {
            continue;
          }
        }
        rCodec = JSON.parse(JSON.stringify(rCodec)); // deepcopy
        // number of channels is the highest common number of channels
        rCodec.numChannels = Math.min(lCodec.numChannels,
            rCodec.numChannels);
        // push rCodec so we reply with offerer payload type
        commonCapabilities.codecs.push(rCodec);

        // determine common feedback mechanisms
        rCodec.rtcpFeedback = rCodec.rtcpFeedback.filter(function(fb) {
          for (var j = 0; j < lCodec.rtcpFeedback.length; j++) {
            if (lCodec.rtcpFeedback[j].type === fb.type &&
                lCodec.rtcpFeedback[j].parameter === fb.parameter) {
              return true;
            }
          }
          return false;
        });
        // FIXME: also need to determine .parameters
        //  see https://github.com/openpeer/ortc/issues/569
        break;
      }
    }
  });

  localCapabilities.headerExtensions.forEach(function(lHeaderExtension) {
    for (var i = 0; i < remoteCapabilities.headerExtensions.length;
         i++) {
      var rHeaderExtension = remoteCapabilities.headerExtensions[i];
      if (lHeaderExtension.uri === rHeaderExtension.uri) {
        commonCapabilities.headerExtensions.push(rHeaderExtension);
        break;
      }
    }
  });

  // FIXME: fecMechanisms
  return commonCapabilities;
}

// is action=setLocalDescription with type allowed in signalingState
function isActionAllowedInSignalingState(action, type, signalingState) {
  return {
    offer: {
      setLocalDescription: ['stable', 'have-local-offer'],
      setRemoteDescription: ['stable', 'have-remote-offer']
    },
    answer: {
      setLocalDescription: ['have-remote-offer', 'have-local-pranswer'],
      setRemoteDescription: ['have-local-offer', 'have-remote-pranswer']
    }
  }[type][action].indexOf(signalingState) !== -1;
}

function maybeAddCandidate(iceTransport, candidate) {
  // Edge's internal representation adds some fields therefore
  // not all fieldѕ are taken into account.
  var alreadyAdded = iceTransport.getRemoteCandidates()
      .find(function(remoteCandidate) {
        return candidate.foundation === remoteCandidate.foundation &&
            candidate.ip === remoteCandidate.ip &&
            candidate.port === remoteCandidate.port &&
            candidate.priority === remoteCandidate.priority &&
            candidate.protocol === remoteCandidate.protocol &&
            candidate.type === remoteCandidate.type;
      });
  if (!alreadyAdded) {
    iceTransport.addRemoteCandidate(candidate);
  }
  return !alreadyAdded;
}


function makeError(name, description) {
  var e = new Error(description);
  e.name = name;
  // legacy error codes from https://heycam.github.io/webidl/#idl-DOMException-error-names
  e.code = {
    NotSupportedError: 9,
    InvalidStateError: 11,
    InvalidAccessError: 15,
    TypeError: undefined,
    OperationError: undefined
  }[name];
  return e;
}

module.exports = function(window, edgeVersion) {
  // https://w3c.github.io/mediacapture-main/#mediastream
  // Helper function to add the track to the stream and
  // dispatch the event ourselves.
  function addTrackToStreamAndFireEvent(track, stream) {
    stream.addTrack(track);
    stream.dispatchEvent(new window.MediaStreamTrackEvent('addtrack',
        {track: track}));
  }

  function removeTrackFromStreamAndFireEvent(track, stream) {
    stream.removeTrack(track);
    stream.dispatchEvent(new window.MediaStreamTrackEvent('removetrack',
        {track: track}));
  }

  function fireAddTrack(pc, track, receiver, streams) {
    var trackEvent = new Event('track');
    trackEvent.track = track;
    trackEvent.receiver = receiver;
    trackEvent.transceiver = {receiver: receiver};
    trackEvent.streams = streams;
    window.setTimeout(function() {
      pc._dispatchEvent('track', trackEvent);
    });
  }

  var RTCPeerConnection = function(config) {
    var pc = this;

    var _eventTarget = document.createDocumentFragment();
    ['addEventListener', 'removeEventListener', 'dispatchEvent']
        .forEach(function(method) {
          pc[method] = _eventTarget[method].bind(_eventTarget);
        });

    this.canTrickleIceCandidates = null;

    this.needNegotiation = false;

    this.localStreams = [];
    this.remoteStreams = [];

    this._localDescription = null;
    this._remoteDescription = null;

    this.signalingState = 'stable';
    this.iceConnectionState = 'new';
    this.connectionState = 'new';
    this.iceGatheringState = 'new';

    config = JSON.parse(JSON.stringify(config || {}));

    this.usingBundle = config.bundlePolicy === 'max-bundle';
    if (config.rtcpMuxPolicy === 'negotiate') {
      throw(makeError('NotSupportedError',
          'rtcpMuxPolicy \'negotiate\' is not supported'));
    } else if (!config.rtcpMuxPolicy) {
      config.rtcpMuxPolicy = 'require';
    }

    switch (config.iceTransportPolicy) {
      case 'all':
      case 'relay':
        break;
      default:
        config.iceTransportPolicy = 'all';
        break;
    }

    switch (config.bundlePolicy) {
      case 'balanced':
      case 'max-compat':
      case 'max-bundle':
        break;
      default:
        config.bundlePolicy = 'balanced';
        break;
    }

    config.iceServers = filterIceServers(config.iceServers || [], edgeVersion);

    this._iceGatherers = [];
    if (config.iceCandidatePoolSize) {
      for (var i = config.iceCandidatePoolSize; i > 0; i--) {
        this._iceGatherers.push(new window.RTCIceGatherer({
          iceServers: config.iceServers,
          gatherPolicy: config.iceTransportPolicy
        }));
      }
    } else {
      config.iceCandidatePoolSize = 0;
    }

    this._config = config;

    // per-track iceGathers, iceTransports, dtlsTransports, rtpSenders, ...
    // everything that is needed to describe a SDP m-line.
    this.transceivers = [];

    this._sdpSessionId = SDPUtils.generateSessionId();
    this._sdpSessionVersion = 0;

    this._dtlsRole = undefined; // role for a=setup to use in answers.

    this._isClosed = false;
  };

  Object.defineProperty(RTCPeerConnection.prototype, 'localDescription', {
    configurable: true,
    get: function() {
      return this._localDescription;
    }
  });
  Object.defineProperty(RTCPeerConnection.prototype, 'remoteDescription', {
    configurable: true,
    get: function() {
      return this._remoteDescription;
    }
  });

  // set up event handlers on prototype
  RTCPeerConnection.prototype.onicecandidate = null;
  RTCPeerConnection.prototype.onaddstream = null;
  RTCPeerConnection.prototype.ontrack = null;
  RTCPeerConnection.prototype.onremovestream = null;
  RTCPeerConnection.prototype.onsignalingstatechange = null;
  RTCPeerConnection.prototype.oniceconnectionstatechange = null;
  RTCPeerConnection.prototype.onconnectionstatechange = null;
  RTCPeerConnection.prototype.onicegatheringstatechange = null;
  RTCPeerConnection.prototype.onnegotiationneeded = null;
  RTCPeerConnection.prototype.ondatachannel = null;

  RTCPeerConnection.prototype._dispatchEvent = function(name, event) {
    if (this._isClosed) {
      return;
    }
    this.dispatchEvent(event);
    if (typeof this['on' + name] === 'function') {
      this['on' + name](event);
    }
  };

  RTCPeerConnection.prototype._emitGatheringStateChange = function() {
    var event = new Event('icegatheringstatechange');
    this._dispatchEvent('icegatheringstatechange', event);
  };

  RTCPeerConnection.prototype.getConfiguration = function() {
    return this._config;
  };

  RTCPeerConnection.prototype.getLocalStreams = function() {
    return this.localStreams;
  };

  RTCPeerConnection.prototype.getRemoteStreams = function() {
    return this.remoteStreams;
  };

  // internal helper to create a transceiver object.
  // (which is not yet the same as the WebRTC 1.0 transceiver)
  RTCPeerConnection.prototype._createTransceiver = function(kind, doNotAdd) {
    var hasBundleTransport = this.transceivers.length > 0;
    var transceiver = {
      track: null,
      iceGatherer: null,
      iceTransport: null,
      dtlsTransport: null,
      localCapabilities: null,
      remoteCapabilities: null,
      rtpSender: null,
      rtpReceiver: null,
      kind: kind,
      mid: null,
      sendEncodingParameters: null,
      recvEncodingParameters: null,
      stream: null,
      associatedRemoteMediaStreams: [],
      wantReceive: true
    };
    if (this.usingBundle && hasBundleTransport) {
      transceiver.iceTransport = this.transceivers[0].iceTransport;
      transceiver.dtlsTransport = this.transceivers[0].dtlsTransport;
    } else {
      var transports = this._createIceAndDtlsTransports();
      transceiver.iceTransport = transports.iceTransport;
      transceiver.dtlsTransport = transports.dtlsTransport;
    }
    if (!doNotAdd) {
      this.transceivers.push(transceiver);
    }
    return transceiver;
  };

  RTCPeerConnection.prototype.addTrack = function(track, stream) {
    if (this._isClosed) {
      throw makeError('InvalidStateError',
          'Attempted to call addTrack on a closed peerconnection.');
    }

    var alreadyExists = this.transceivers.find(function(s) {
      return s.track === track;
    });

    if (alreadyExists) {
      throw makeError('InvalidAccessError', 'Track already exists.');
    }

    var transceiver;
    for (var i = 0; i < this.transceivers.length; i++) {
      if (!this.transceivers[i].track &&
          this.transceivers[i].kind === track.kind) {
        transceiver = this.transceivers[i];
      }
    }
    if (!transceiver) {
      transceiver = this._createTransceiver(track.kind);
    }

    this._maybeFireNegotiationNeeded();

    if (this.localStreams.indexOf(stream) === -1) {
      this.localStreams.push(stream);
    }

    transceiver.track = track;
    transceiver.stream = stream;
    transceiver.rtpSender = new window.RTCRtpSender(track,
        transceiver.dtlsTransport);
    return transceiver.rtpSender;
  };

  RTCPeerConnection.prototype.addStream = function(stream) {
    var pc = this;
    if (edgeVersion >= 15025) {
      stream.getTracks().forEach(function(track) {
        pc.addTrack(track, stream);
      });
    } else {
      // Clone is necessary for local demos mostly, attaching directly
      // to two different senders does not work (build 10547).
      // Fixed in 15025 (or earlier)
      var clonedStream = stream.clone();
      stream.getTracks().forEach(function(track, idx) {
        var clonedTrack = clonedStream.getTracks()[idx];
        track.addEventListener('enabled', function(event) {
          clonedTrack.enabled = event.enabled;
        });
      });
      clonedStream.getTracks().forEach(function(track) {
        pc.addTrack(track, clonedStream);
      });
    }
  };

  RTCPeerConnection.prototype.removeTrack = function(sender) {
    if (this._isClosed) {
      throw makeError('InvalidStateError',
          'Attempted to call removeTrack on a closed peerconnection.');
    }

    if (!(sender instanceof window.RTCRtpSender)) {
      throw new TypeError('Argument 1 of RTCPeerConnection.removeTrack ' +
          'does not implement interface RTCRtpSender.');
    }

    var transceiver = this.transceivers.find(function(t) {
      return t.rtpSender === sender;
    });

    if (!transceiver) {
      throw makeError('InvalidAccessError',
          'Sender was not created by this connection.');
    }
    var stream = transceiver.stream;

    transceiver.rtpSender.stop();
    transceiver.rtpSender = null;
    transceiver.track = null;
    transceiver.stream = null;

    // remove the stream from the set of local streams
    var localStreams = this.transceivers.map(function(t) {
      return t.stream;
    });
    if (localStreams.indexOf(stream) === -1 &&
        this.localStreams.indexOf(stream) > -1) {
      this.localStreams.splice(this.localStreams.indexOf(stream), 1);
    }

    this._maybeFireNegotiationNeeded();
  };

  RTCPeerConnection.prototype.removeStream = function(stream) {
    var pc = this;
    stream.getTracks().forEach(function(track) {
      var sender = pc.getSenders().find(function(s) {
        return s.track === track;
      });
      if (sender) {
        pc.removeTrack(sender);
      }
    });
  };

  RTCPeerConnection.prototype.getSenders = function() {
    return this.transceivers.filter(function(transceiver) {
      return !!transceiver.rtpSender;
    })
    .map(function(transceiver) {
      return transceiver.rtpSender;
    });
  };

  RTCPeerConnection.prototype.getReceivers = function() {
    return this.transceivers.filter(function(transceiver) {
      return !!transceiver.rtpReceiver;
    })
    .map(function(transceiver) {
      return transceiver.rtpReceiver;
    });
  };


  RTCPeerConnection.prototype._createIceGatherer = function(sdpMLineIndex,
      usingBundle) {
    var pc = this;
    if (usingBundle && sdpMLineIndex > 0) {
      return this.transceivers[0].iceGatherer;
    } else if (this._iceGatherers.length) {
      return this._iceGatherers.shift();
    }
    var iceGatherer = new window.RTCIceGatherer({
      iceServers: this._config.iceServers,
      gatherPolicy: this._config.iceTransportPolicy
    });
    Object.defineProperty(iceGatherer, 'state',
        {value: 'new', writable: true}
    );

    this.transceivers[sdpMLineIndex].bufferedCandidateEvents = [];
    this.transceivers[sdpMLineIndex].bufferCandidates = function(event) {
      var end = !event.candidate || Object.keys(event.candidate).length === 0;
      // polyfill since RTCIceGatherer.state is not implemented in
      // Edge 10547 yet.
      iceGatherer.state = end ? 'completed' : 'gathering';
      if (pc.transceivers[sdpMLineIndex].bufferedCandidateEvents !== null) {
        pc.transceivers[sdpMLineIndex].bufferedCandidateEvents.push(event);
      }
    };
    iceGatherer.addEventListener('localcandidate',
      this.transceivers[sdpMLineIndex].bufferCandidates);
    return iceGatherer;
  };

  // start gathering from an RTCIceGatherer.
  RTCPeerConnection.prototype._gather = function(mid, sdpMLineIndex) {
    var pc = this;
    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
    if (iceGatherer.onlocalcandidate) {
      return;
    }
    var bufferedCandidateEvents =
      this.transceivers[sdpMLineIndex].bufferedCandidateEvents;
    this.transceivers[sdpMLineIndex].bufferedCandidateEvents = null;
    iceGatherer.removeEventListener('localcandidate',
      this.transceivers[sdpMLineIndex].bufferCandidates);
    iceGatherer.onlocalcandidate = function(evt) {
      if (pc.usingBundle && sdpMLineIndex > 0) {
        // if we know that we use bundle we can drop candidates with
        // ѕdpMLineIndex > 0. If we don't do this then our state gets
        // confused since we dispose the extra ice gatherer.
        return;
      }
      var event = new Event('icecandidate');
      event.candidate = {sdpMid: mid, sdpMLineIndex: sdpMLineIndex};

      var cand = evt.candidate;
      // Edge emits an empty object for RTCIceCandidateComplete‥
      var end = !cand || Object.keys(cand).length === 0;
      if (end) {
        // polyfill since RTCIceGatherer.state is not implemented in
        // Edge 10547 yet.
        if (iceGatherer.state === 'new' || iceGatherer.state === 'gathering') {
          iceGatherer.state = 'completed';
        }
      } else {
        if (iceGatherer.state === 'new') {
          iceGatherer.state = 'gathering';
        }
        // RTCIceCandidate doesn't have a component, needs to be added
        cand.component = 1;
        // also the usernameFragment. TODO: update SDP to take both variants.
        cand.ufrag = iceGatherer.getLocalParameters().usernameFragment;

        var serializedCandidate = SDPUtils.writeCandidate(cand);
        event.candidate = Object.assign(event.candidate,
            SDPUtils.parseCandidate(serializedCandidate));

        event.candidate.candidate = serializedCandidate;
        event.candidate.toJSON = function() {
          return {
            candidate: event.candidate.candidate,
            sdpMid: event.candidate.sdpMid,
            sdpMLineIndex: event.candidate.sdpMLineIndex,
            usernameFragment: event.candidate.usernameFragment
          };
        };
      }

      // update local description.
      var sections = SDPUtils.getMediaSections(pc._localDescription.sdp);
      if (!end) {
        sections[event.candidate.sdpMLineIndex] +=
            'a=' + event.candidate.candidate + '\r\n';
      } else {
        sections[event.candidate.sdpMLineIndex] +=
            'a=end-of-candidates\r\n';
      }
      pc._localDescription.sdp =
          SDPUtils.getDescription(pc._localDescription.sdp) +
          sections.join('');
      var complete = pc.transceivers.every(function(transceiver) {
        return transceiver.iceGatherer &&
            transceiver.iceGatherer.state === 'completed';
      });

      if (pc.iceGatheringState !== 'gathering') {
        pc.iceGatheringState = 'gathering';
        pc._emitGatheringStateChange();
      }

      // Emit candidate. Also emit null candidate when all gatherers are
      // complete.
      if (!end) {
        pc._dispatchEvent('icecandidate', event);
      }
      if (complete) {
        pc._dispatchEvent('icecandidate', new Event('icecandidate'));
        pc.iceGatheringState = 'complete';
        pc._emitGatheringStateChange();
      }
    };

    // emit already gathered candidates.
    window.setTimeout(function() {
      bufferedCandidateEvents.forEach(function(e) {
        iceGatherer.onlocalcandidate(e);
      });
    }, 0);
  };

  // Create ICE transport and DTLS transport.
  RTCPeerConnection.prototype._createIceAndDtlsTransports = function() {
    var pc = this;
    var iceTransport = new window.RTCIceTransport(null);
    iceTransport.onicestatechange = function() {
      pc._updateIceConnectionState();
      pc._updateConnectionState();
    };

    var dtlsTransport = new window.RTCDtlsTransport(iceTransport);
    dtlsTransport.ondtlsstatechange = function() {
      pc._updateConnectionState();
    };
    dtlsTransport.onerror = function() {
      // onerror does not set state to failed by itself.
      Object.defineProperty(dtlsTransport, 'state',
          {value: 'failed', writable: true});
      pc._updateConnectionState();
    };

    return {
      iceTransport: iceTransport,
      dtlsTransport: dtlsTransport
    };
  };

  // Destroy ICE gatherer, ICE transport and DTLS transport.
  // Without triggering the callbacks.
  RTCPeerConnection.prototype._disposeIceAndDtlsTransports = function(
      sdpMLineIndex) {
    var iceGatherer = this.transceivers[sdpMLineIndex].iceGatherer;
    if (iceGatherer) {
      delete iceGatherer.onlocalcandidate;
      delete this.transceivers[sdpMLineIndex].iceGatherer;
    }
    var iceTransport = this.transceivers[sdpMLineIndex].iceTransport;
    if (iceTransport) {
      delete iceTransport.onicestatechange;
      delete this.transceivers[sdpMLineIndex].iceTransport;
    }
    var dtlsTransport = this.transceivers[sdpMLineIndex].dtlsTransport;
    if (dtlsTransport) {
      delete dtlsTransport.ondtlsstatechange;
      delete dtlsTransport.onerror;
      delete this.transceivers[sdpMLineIndex].dtlsTransport;
    }
  };

  // Start the RTP Sender and Receiver for a transceiver.
  RTCPeerConnection.prototype._transceive = function(transceiver,
      send, recv) {
    var params = getCommonCapabilities(transceiver.localCapabilities,
        transceiver.remoteCapabilities);
    if (send && transceiver.rtpSender) {
      params.encodings = transceiver.sendEncodingParameters;
      params.rtcp = {
        cname: SDPUtils.localCName,
        compound: transceiver.rtcpParameters.compound
      };
      if (transceiver.recvEncodingParameters.length) {
        params.rtcp.ssrc = transceiver.recvEncodingParameters[0].ssrc;
      }
      transceiver.rtpSender.send(params);
    }
    if (recv && transceiver.rtpReceiver && params.codecs.length > 0) {
      // remove RTX field in Edge 14942
      if (transceiver.kind === 'video'
          && transceiver.recvEncodingParameters
          && edgeVersion < 15019) {
        transceiver.recvEncodingParameters.forEach(function(p) {
          delete p.rtx;
        });
      }
      if (transceiver.recvEncodingParameters.length) {
        params.encodings = transceiver.recvEncodingParameters;
      } else {
        params.encodings = [{}];
      }
      params.rtcp = {
        compound: transceiver.rtcpParameters.compound
      };
      if (transceiver.rtcpParameters.cname) {
        params.rtcp.cname = transceiver.rtcpParameters.cname;
      }
      if (transceiver.sendEncodingParameters.length) {
        params.rtcp.ssrc = transceiver.sendEncodingParameters[0].ssrc;
      }
      transceiver.rtpReceiver.receive(params);
    }
  };

  RTCPeerConnection.prototype.setLocalDescription = function(description) {
    var pc = this;

    // Note: pranswer is not supported.
    if (['offer', 'answer'].indexOf(description.type) === -1) {
      return Promise.reject(makeError('TypeError',
          'Unsupported type "' + description.type + '"'));
    }

    if (!isActionAllowedInSignalingState('setLocalDescription',
        description.type, pc.signalingState) || pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not set local ' + description.type +
          ' in state ' + pc.signalingState));
    }

    var sections;
    var sessionpart;
    if (description.type === 'offer') {
      // VERY limited support for SDP munging. Limited to:
      // * changing the order of codecs
      sections = SDPUtils.splitSections(description.sdp);
      sessionpart = sections.shift();
      sections.forEach(function(mediaSection, sdpMLineIndex) {
        var caps = SDPUtils.parseRtpParameters(mediaSection);
        pc.transceivers[sdpMLineIndex].localCapabilities = caps;
      });

      pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
        pc._gather(transceiver.mid, sdpMLineIndex);
      });
    } else if (description.type === 'answer') {
      sections = SDPUtils.splitSections(pc._remoteDescription.sdp);
      sessionpart = sections.shift();
      var isIceLite = SDPUtils.matchPrefix(sessionpart,
          'a=ice-lite').length > 0;
      sections.forEach(function(mediaSection, sdpMLineIndex) {
        var transceiver = pc.transceivers[sdpMLineIndex];
        var iceGatherer = transceiver.iceGatherer;
        var iceTransport = transceiver.iceTransport;
        var dtlsTransport = transceiver.dtlsTransport;
        var localCapabilities = transceiver.localCapabilities;
        var remoteCapabilities = transceiver.remoteCapabilities;

        // treat bundle-only as not-rejected.
        var rejected = SDPUtils.isRejected(mediaSection) &&
            SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;

        if (!rejected && !transceiver.rejected) {
          var remoteIceParameters = SDPUtils.getIceParameters(
              mediaSection, sessionpart);
          var remoteDtlsParameters = SDPUtils.getDtlsParameters(
              mediaSection, sessionpart);
          if (isIceLite) {
            remoteDtlsParameters.role = 'server';
          }

          if (!pc.usingBundle || sdpMLineIndex === 0) {
            pc._gather(transceiver.mid, sdpMLineIndex);
            if (iceTransport.state === 'new') {
              iceTransport.start(iceGatherer, remoteIceParameters,
                  isIceLite ? 'controlling' : 'controlled');
            }
            if (dtlsTransport.state === 'new') {
              dtlsTransport.start(remoteDtlsParameters);
            }
          }

          // Calculate intersection of capabilities.
          var params = getCommonCapabilities(localCapabilities,
              remoteCapabilities);

          // Start the RTCRtpSender. The RTCRtpReceiver for this
          // transceiver has already been started in setRemoteDescription.
          pc._transceive(transceiver,
              params.codecs.length > 0,
              false);
        }
      });
    }

    pc._localDescription = {
      type: description.type,
      sdp: description.sdp
    };
    if (description.type === 'offer') {
      pc._updateSignalingState('have-local-offer');
    } else {
      pc._updateSignalingState('stable');
    }

    return Promise.resolve();
  };

  RTCPeerConnection.prototype.setRemoteDescription = function(description) {
    var pc = this;

    // Note: pranswer is not supported.
    if (['offer', 'answer'].indexOf(description.type) === -1) {
      return Promise.reject(makeError('TypeError',
          'Unsupported type "' + description.type + '"'));
    }

    if (!isActionAllowedInSignalingState('setRemoteDescription',
        description.type, pc.signalingState) || pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not set remote ' + description.type +
          ' in state ' + pc.signalingState));
    }

    var streams = {};
    pc.remoteStreams.forEach(function(stream) {
      streams[stream.id] = stream;
    });
    var receiverList = [];
    var sections = SDPUtils.splitSections(description.sdp);
    var sessionpart = sections.shift();
    var isIceLite = SDPUtils.matchPrefix(sessionpart,
        'a=ice-lite').length > 0;
    var usingBundle = SDPUtils.matchPrefix(sessionpart,
        'a=group:BUNDLE ').length > 0;
    pc.usingBundle = usingBundle;
    var iceOptions = SDPUtils.matchPrefix(sessionpart,
        'a=ice-options:')[0];
    if (iceOptions) {
      pc.canTrickleIceCandidates = iceOptions.substr(14).split(' ')
          .indexOf('trickle') >= 0;
    } else {
      pc.canTrickleIceCandidates = false;
    }

    sections.forEach(function(mediaSection, sdpMLineIndex) {
      var lines = SDPUtils.splitLines(mediaSection);
      var kind = SDPUtils.getKind(mediaSection);
      // treat bundle-only as not-rejected.
      var rejected = SDPUtils.isRejected(mediaSection) &&
          SDPUtils.matchPrefix(mediaSection, 'a=bundle-only').length === 0;
      var protocol = lines[0].substr(2).split(' ')[2];

      var direction = SDPUtils.getDirection(mediaSection, sessionpart);
      var remoteMsid = SDPUtils.parseMsid(mediaSection);

      var mid = SDPUtils.getMid(mediaSection) || SDPUtils.generateIdentifier();

      // Reject datachannels which are not implemented yet.
      if (rejected || (kind === 'application' && (protocol === 'DTLS/SCTP' ||
          protocol === 'UDP/DTLS/SCTP'))) {
        // TODO: this is dangerous in the case where a non-rejected m-line
        //     becomes rejected.
        pc.transceivers[sdpMLineIndex] = {
          mid: mid,
          kind: kind,
          protocol: protocol,
          rejected: true
        };
        return;
      }

      if (!rejected && pc.transceivers[sdpMLineIndex] &&
          pc.transceivers[sdpMLineIndex].rejected) {
        // recycle a rejected transceiver.
        pc.transceivers[sdpMLineIndex] = pc._createTransceiver(kind, true);
      }

      var transceiver;
      var iceGatherer;
      var iceTransport;
      var dtlsTransport;
      var rtpReceiver;
      var sendEncodingParameters;
      var recvEncodingParameters;
      var localCapabilities;

      var track;
      // FIXME: ensure the mediaSection has rtcp-mux set.
      var remoteCapabilities = SDPUtils.parseRtpParameters(mediaSection);
      var remoteIceParameters;
      var remoteDtlsParameters;
      if (!rejected) {
        remoteIceParameters = SDPUtils.getIceParameters(mediaSection,
            sessionpart);
        remoteDtlsParameters = SDPUtils.getDtlsParameters(mediaSection,
            sessionpart);
        remoteDtlsParameters.role = 'client';
      }
      recvEncodingParameters =
          SDPUtils.parseRtpEncodingParameters(mediaSection);

      var rtcpParameters = SDPUtils.parseRtcpParameters(mediaSection);

      var isComplete = SDPUtils.matchPrefix(mediaSection,
          'a=end-of-candidates', sessionpart).length > 0;
      var cands = SDPUtils.matchPrefix(mediaSection, 'a=candidate:')
          .map(function(cand) {
            return SDPUtils.parseCandidate(cand);
          })
          .filter(function(cand) {
            return cand.component === 1;
          });

      // Check if we can use BUNDLE and dispose transports.
      if ((description.type === 'offer' || description.type === 'answer') &&
          !rejected && usingBundle && sdpMLineIndex > 0 &&
          pc.transceivers[sdpMLineIndex]) {
        pc._disposeIceAndDtlsTransports(sdpMLineIndex);
        pc.transceivers[sdpMLineIndex].iceGatherer =
            pc.transceivers[0].iceGatherer;
        pc.transceivers[sdpMLineIndex].iceTransport =
            pc.transceivers[0].iceTransport;
        pc.transceivers[sdpMLineIndex].dtlsTransport =
            pc.transceivers[0].dtlsTransport;
        if (pc.transceivers[sdpMLineIndex].rtpSender) {
          pc.transceivers[sdpMLineIndex].rtpSender.setTransport(
              pc.transceivers[0].dtlsTransport);
        }
        if (pc.transceivers[sdpMLineIndex].rtpReceiver) {
          pc.transceivers[sdpMLineIndex].rtpReceiver.setTransport(
              pc.transceivers[0].dtlsTransport);
        }
      }
      if (description.type === 'offer' && !rejected) {
        transceiver = pc.transceivers[sdpMLineIndex] ||
            pc._createTransceiver(kind);
        transceiver.mid = mid;

        if (!transceiver.iceGatherer) {
          transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex,
              usingBundle);
        }

        if (cands.length && transceiver.iceTransport.state === 'new') {
          if (isComplete && (!usingBundle || sdpMLineIndex === 0)) {
            transceiver.iceTransport.setRemoteCandidates(cands);
          } else {
            cands.forEach(function(candidate) {
              maybeAddCandidate(transceiver.iceTransport, candidate);
            });
          }
        }

        localCapabilities = window.RTCRtpReceiver.getCapabilities(kind);

        // filter RTX until additional stuff needed for RTX is implemented
        // in adapter.js
        if (edgeVersion < 15019) {
          localCapabilities.codecs = localCapabilities.codecs.filter(
              function(codec) {
                return codec.name !== 'rtx';
              });
        }

        sendEncodingParameters = transceiver.sendEncodingParameters || [{
          ssrc: (2 * sdpMLineIndex + 2) * 1001
        }];

        // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
        var isNewTrack = false;
        if (direction === 'sendrecv' || direction === 'sendonly') {
          isNewTrack = !transceiver.rtpReceiver;
          rtpReceiver = transceiver.rtpReceiver ||
              new window.RTCRtpReceiver(transceiver.dtlsTransport, kind);

          if (isNewTrack) {
            var stream;
            track = rtpReceiver.track;
            // FIXME: does not work with Plan B.
            if (remoteMsid && remoteMsid.stream === '-') {
              // no-op. a stream id of '-' means: no associated stream.
            } else if (remoteMsid) {
              if (!streams[remoteMsid.stream]) {
                streams[remoteMsid.stream] = new window.MediaStream();
                Object.defineProperty(streams[remoteMsid.stream], 'id', {
                  get: function() {
                    return remoteMsid.stream;
                  }
                });
              }
              Object.defineProperty(track, 'id', {
                get: function() {
                  return remoteMsid.track;
                }
              });
              stream = streams[remoteMsid.stream];
            } else {
              if (!streams.default) {
                streams.default = new window.MediaStream();
              }
              stream = streams.default;
            }
            if (stream) {
              addTrackToStreamAndFireEvent(track, stream);
              transceiver.associatedRemoteMediaStreams.push(stream);
            }
            receiverList.push([track, rtpReceiver, stream]);
          }
        } else if (transceiver.rtpReceiver && transceiver.rtpReceiver.track) {
          transceiver.associatedRemoteMediaStreams.forEach(function(s) {
            var nativeTrack = s.getTracks().find(function(t) {
              return t.id === transceiver.rtpReceiver.track.id;
            });
            if (nativeTrack) {
              removeTrackFromStreamAndFireEvent(nativeTrack, s);
            }
          });
          transceiver.associatedRemoteMediaStreams = [];
        }

        transceiver.localCapabilities = localCapabilities;
        transceiver.remoteCapabilities = remoteCapabilities;
        transceiver.rtpReceiver = rtpReceiver;
        transceiver.rtcpParameters = rtcpParameters;
        transceiver.sendEncodingParameters = sendEncodingParameters;
        transceiver.recvEncodingParameters = recvEncodingParameters;

        // Start the RTCRtpReceiver now. The RTPSender is started in
        // setLocalDescription.
        pc._transceive(pc.transceivers[sdpMLineIndex],
            false,
            isNewTrack);
      } else if (description.type === 'answer' && !rejected) {
        transceiver = pc.transceivers[sdpMLineIndex];
        iceGatherer = transceiver.iceGatherer;
        iceTransport = transceiver.iceTransport;
        dtlsTransport = transceiver.dtlsTransport;
        rtpReceiver = transceiver.rtpReceiver;
        sendEncodingParameters = transceiver.sendEncodingParameters;
        localCapabilities = transceiver.localCapabilities;

        pc.transceivers[sdpMLineIndex].recvEncodingParameters =
            recvEncodingParameters;
        pc.transceivers[sdpMLineIndex].remoteCapabilities =
            remoteCapabilities;
        pc.transceivers[sdpMLineIndex].rtcpParameters = rtcpParameters;

        if (cands.length && iceTransport.state === 'new') {
          if ((isIceLite || isComplete) &&
              (!usingBundle || sdpMLineIndex === 0)) {
            iceTransport.setRemoteCandidates(cands);
          } else {
            cands.forEach(function(candidate) {
              maybeAddCandidate(transceiver.iceTransport, candidate);
            });
          }
        }

        if (!usingBundle || sdpMLineIndex === 0) {
          if (iceTransport.state === 'new') {
            iceTransport.start(iceGatherer, remoteIceParameters,
                'controlling');
          }
          if (dtlsTransport.state === 'new') {
            dtlsTransport.start(remoteDtlsParameters);
          }
        }

        // If the offer contained RTX but the answer did not,
        // remove RTX from sendEncodingParameters.
        var commonCapabilities = getCommonCapabilities(
          transceiver.localCapabilities,
          transceiver.remoteCapabilities);

        var hasRtx = commonCapabilities.codecs.filter(function(c) {
          return c.name.toLowerCase() === 'rtx';
        }).length;
        if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) {
          delete transceiver.sendEncodingParameters[0].rtx;
        }

        pc._transceive(transceiver,
            direction === 'sendrecv' || direction === 'recvonly',
            direction === 'sendrecv' || direction === 'sendonly');

        // TODO: rewrite to use http://w3c.github.io/webrtc-pc/#set-associated-remote-streams
        if (rtpReceiver &&
            (direction === 'sendrecv' || direction === 'sendonly')) {
          track = rtpReceiver.track;
          if (remoteMsid) {
            if (!streams[remoteMsid.stream]) {
              streams[remoteMsid.stream] = new window.MediaStream();
            }
            addTrackToStreamAndFireEvent(track, streams[remoteMsid.stream]);
            receiverList.push([track, rtpReceiver, streams[remoteMsid.stream]]);
          } else {
            if (!streams.default) {
              streams.default = new window.MediaStream();
            }
            addTrackToStreamAndFireEvent(track, streams.default);
            receiverList.push([track, rtpReceiver, streams.default]);
          }
        } else {
          // FIXME: actually the receiver should be created later.
          delete transceiver.rtpReceiver;
        }
      }
    });

    if (pc._dtlsRole === undefined) {
      pc._dtlsRole = description.type === 'offer' ? 'active' : 'passive';
    }

    pc._remoteDescription = {
      type: description.type,
      sdp: description.sdp
    };
    if (description.type === 'offer') {
      pc._updateSignalingState('have-remote-offer');
    } else {
      pc._updateSignalingState('stable');
    }
    Object.keys(streams).forEach(function(sid) {
      var stream = streams[sid];
      if (stream.getTracks().length) {
        if (pc.remoteStreams.indexOf(stream) === -1) {
          pc.remoteStreams.push(stream);
          var event = new Event('addstream');
          event.stream = stream;
          window.setTimeout(function() {
            pc._dispatchEvent('addstream', event);
          });
        }

        receiverList.forEach(function(item) {
          var track = item[0];
          var receiver = item[1];
          if (stream.id !== item[2].id) {
            return;
          }
          fireAddTrack(pc, track, receiver, [stream]);
        });
      }
    });
    receiverList.forEach(function(item) {
      if (item[2]) {
        return;
      }
      fireAddTrack(pc, item[0], item[1], []);
    });

    // check whether addIceCandidate({}) was called within four seconds after
    // setRemoteDescription.
    window.setTimeout(function() {
      if (!(pc && pc.transceivers)) {
        return;
      }
      pc.transceivers.forEach(function(transceiver) {
        if (transceiver.iceTransport &&
            transceiver.iceTransport.state === 'new' &&
            transceiver.iceTransport.getRemoteCandidates().length > 0) {
          console.warn('Timeout for addRemoteCandidate. Consider sending ' +
              'an end-of-candidates notification');
          transceiver.iceTransport.addRemoteCandidate({});
        }
      });
    }, 4000);

    return Promise.resolve();
  };

  RTCPeerConnection.prototype.close = function() {
    this.transceivers.forEach(function(transceiver) {
      /* not yet
      if (transceiver.iceGatherer) {
        transceiver.iceGatherer.close();
      }
      */
      if (transceiver.iceTransport) {
        transceiver.iceTransport.stop();
      }
      if (transceiver.dtlsTransport) {
        transceiver.dtlsTransport.stop();
      }
      if (transceiver.rtpSender) {
        transceiver.rtpSender.stop();
      }
      if (transceiver.rtpReceiver) {
        transceiver.rtpReceiver.stop();
      }
    });
    // FIXME: clean up tracks, local streams, remote streams, etc
    this._isClosed = true;
    this._updateSignalingState('closed');
  };

  // Update the signaling state.
  RTCPeerConnection.prototype._updateSignalingState = function(newState) {
    this.signalingState = newState;
    var event = new Event('signalingstatechange');
    this._dispatchEvent('signalingstatechange', event);
  };

  // Determine whether to fire the negotiationneeded event.
  RTCPeerConnection.prototype._maybeFireNegotiationNeeded = function() {
    var pc = this;
    if (this.signalingState !== 'stable' || this.needNegotiation === true) {
      return;
    }
    this.needNegotiation = true;
    window.setTimeout(function() {
      if (pc.needNegotiation) {
        pc.needNegotiation = false;
        var event = new Event('negotiationneeded');
        pc._dispatchEvent('negotiationneeded', event);
      }
    }, 0);
  };

  // Update the ice connection state.
  RTCPeerConnection.prototype._updateIceConnectionState = function() {
    var newState;
    var states = {
      'new': 0,
      closed: 0,
      checking: 0,
      connected: 0,
      completed: 0,
      disconnected: 0,
      failed: 0
    };
    this.transceivers.forEach(function(transceiver) {
      if (transceiver.iceTransport && !transceiver.rejected) {
        states[transceiver.iceTransport.state]++;
      }
    });

    newState = 'new';
    if (states.failed > 0) {
      newState = 'failed';
    } else if (states.checking > 0) {
      newState = 'checking';
    } else if (states.disconnected > 0) {
      newState = 'disconnected';
    } else if (states.new > 0) {
      newState = 'new';
    } else if (states.connected > 0) {
      newState = 'connected';
    } else if (states.completed > 0) {
      newState = 'completed';
    }

    if (newState !== this.iceConnectionState) {
      this.iceConnectionState = newState;
      var event = new Event('iceconnectionstatechange');
      this._dispatchEvent('iceconnectionstatechange', event);
    }
  };

  // Update the connection state.
  RTCPeerConnection.prototype._updateConnectionState = function() {
    var newState;
    var states = {
      'new': 0,
      closed: 0,
      connecting: 0,
      connected: 0,
      completed: 0,
      disconnected: 0,
      failed: 0
    };
    this.transceivers.forEach(function(transceiver) {
      if (transceiver.iceTransport && transceiver.dtlsTransport &&
          !transceiver.rejected) {
        states[transceiver.iceTransport.state]++;
        states[transceiver.dtlsTransport.state]++;
      }
    });
    // ICETransport.completed and connected are the same for this purpose.
    states.connected += states.completed;

    newState = 'new';
    if (states.failed > 0) {
      newState = 'failed';
    } else if (states.connecting > 0) {
      newState = 'connecting';
    } else if (states.disconnected > 0) {
      newState = 'disconnected';
    } else if (states.new > 0) {
      newState = 'new';
    } else if (states.connected > 0) {
      newState = 'connected';
    }

    if (newState !== this.connectionState) {
      this.connectionState = newState;
      var event = new Event('connectionstatechange');
      this._dispatchEvent('connectionstatechange', event);
    }
  };

  RTCPeerConnection.prototype.createOffer = function() {
    var pc = this;

    if (pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not call createOffer after close'));
    }

    var numAudioTracks = pc.transceivers.filter(function(t) {
      return t.kind === 'audio';
    }).length;
    var numVideoTracks = pc.transceivers.filter(function(t) {
      return t.kind === 'video';
    }).length;

    // Determine number of audio and video tracks we need to send/recv.
    var offerOptions = arguments[0];
    if (offerOptions) {
      // Reject Chrome legacy constraints.
      if (offerOptions.mandatory || offerOptions.optional) {
        throw new TypeError(
            'Legacy mandatory/optional constraints not supported.');
      }
      if (offerOptions.offerToReceiveAudio !== undefined) {
        if (offerOptions.offerToReceiveAudio === true) {
          numAudioTracks = 1;
        } else if (offerOptions.offerToReceiveAudio === false) {
          numAudioTracks = 0;
        } else {
          numAudioTracks = offerOptions.offerToReceiveAudio;
        }
      }
      if (offerOptions.offerToReceiveVideo !== undefined) {
        if (offerOptions.offerToReceiveVideo === true) {
          numVideoTracks = 1;
        } else if (offerOptions.offerToReceiveVideo === false) {
          numVideoTracks = 0;
        } else {
          numVideoTracks = offerOptions.offerToReceiveVideo;
        }
      }
    }

    pc.transceivers.forEach(function(transceiver) {
      if (transceiver.kind === 'audio') {
        numAudioTracks--;
        if (numAudioTracks < 0) {
          transceiver.wantReceive = false;
        }
      } else if (transceiver.kind === 'video') {
        numVideoTracks--;
        if (numVideoTracks < 0) {
          transceiver.wantReceive = false;
        }
      }
    });

    // Create M-lines for recvonly streams.
    while (numAudioTracks > 0 || numVideoTracks > 0) {
      if (numAudioTracks > 0) {
        pc._createTransceiver('audio');
        numAudioTracks--;
      }
      if (numVideoTracks > 0) {
        pc._createTransceiver('video');
        numVideoTracks--;
      }
    }

    var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId,
        pc._sdpSessionVersion++);
    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      // For each track, create an ice gatherer, ice transport,
      // dtls transport, potentially rtpsender and rtpreceiver.
      var track = transceiver.track;
      var kind = transceiver.kind;
      var mid = transceiver.mid || SDPUtils.generateIdentifier();
      transceiver.mid = mid;

      if (!transceiver.iceGatherer) {
        transceiver.iceGatherer = pc._createIceGatherer(sdpMLineIndex,
            pc.usingBundle);
      }

      var localCapabilities = window.RTCRtpSender.getCapabilities(kind);
      // filter RTX until additional stuff needed for RTX is implemented
      // in adapter.js
      if (edgeVersion < 15019) {
        localCapabilities.codecs = localCapabilities.codecs.filter(
            function(codec) {
              return codec.name !== 'rtx';
            });
      }
      localCapabilities.codecs.forEach(function(codec) {
        // work around https://bugs.chromium.org/p/webrtc/issues/detail?id=6552
        // by adding level-asymmetry-allowed=1
        if (codec.name === 'H264' &&
            codec.parameters['level-asymmetry-allowed'] === undefined) {
          codec.parameters['level-asymmetry-allowed'] = '1';
        }

        // for subsequent offers, we might have to re-use the payload
        // type of the last offer.
        if (transceiver.remoteCapabilities &&
            transceiver.remoteCapabilities.codecs) {
          transceiver.remoteCapabilities.codecs.forEach(function(remoteCodec) {
            if (codec.name.toLowerCase() === remoteCodec.name.toLowerCase() &&
                codec.clockRate === remoteCodec.clockRate) {
              codec.preferredPayloadType = remoteCodec.payloadType;
            }
          });
        }
      });
      localCapabilities.headerExtensions.forEach(function(hdrExt) {
        var remoteExtensions = transceiver.remoteCapabilities &&
            transceiver.remoteCapabilities.headerExtensions || [];
        remoteExtensions.forEach(function(rHdrExt) {
          if (hdrExt.uri === rHdrExt.uri) {
            hdrExt.id = rHdrExt.id;
          }
        });
      });

      // generate an ssrc now, to be used later in rtpSender.send
      var sendEncodingParameters = transceiver.sendEncodingParameters || [{
        ssrc: (2 * sdpMLineIndex + 1) * 1001
      }];
      if (track) {
        // add RTX
        if (edgeVersion >= 15019 && kind === 'video' &&
            !sendEncodingParameters[0].rtx) {
          sendEncodingParameters[0].rtx = {
            ssrc: sendEncodingParameters[0].ssrc + 1
          };
        }
      }

      if (transceiver.wantReceive) {
        transceiver.rtpReceiver = new window.RTCRtpReceiver(
            transceiver.dtlsTransport, kind);
      }

      transceiver.localCapabilities = localCapabilities;
      transceiver.sendEncodingParameters = sendEncodingParameters;
    });

    // always offer BUNDLE and dispose on return if not supported.
    if (pc._config.bundlePolicy !== 'max-compat') {
      sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
        return t.mid;
      }).join(' ') + '\r\n';
    }
    sdp += 'a=ice-options:trickle\r\n';

    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      sdp += writeMediaSection(transceiver, transceiver.localCapabilities,
          'offer', transceiver.stream, pc._dtlsRole);
      sdp += 'a=rtcp-rsize\r\n';

      if (transceiver.iceGatherer && pc.iceGatheringState !== 'new' &&
          (sdpMLineIndex === 0 || !pc.usingBundle)) {
        transceiver.iceGatherer.getLocalCandidates().forEach(function(cand) {
          cand.component = 1;
          sdp += 'a=' + SDPUtils.writeCandidate(cand) + '\r\n';
        });

        if (transceiver.iceGatherer.state === 'completed') {
          sdp += 'a=end-of-candidates\r\n';
        }
      }
    });

    var desc = new window.RTCSessionDescription({
      type: 'offer',
      sdp: sdp
    });
    return Promise.resolve(desc);
  };

  RTCPeerConnection.prototype.createAnswer = function() {
    var pc = this;

    if (pc._isClosed) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not call createAnswer after close'));
    }

    if (!(pc.signalingState === 'have-remote-offer' ||
        pc.signalingState === 'have-local-pranswer')) {
      return Promise.reject(makeError('InvalidStateError',
          'Can not call createAnswer in signalingState ' + pc.signalingState));
    }

    var sdp = SDPUtils.writeSessionBoilerplate(pc._sdpSessionId,
        pc._sdpSessionVersion++);
    if (pc.usingBundle) {
      sdp += 'a=group:BUNDLE ' + pc.transceivers.map(function(t) {
        return t.mid;
      }).join(' ') + '\r\n';
    }
    sdp += 'a=ice-options:trickle\r\n';

    var mediaSectionsInOffer = SDPUtils.getMediaSections(
        pc._remoteDescription.sdp).length;
    pc.transceivers.forEach(function(transceiver, sdpMLineIndex) {
      if (sdpMLineIndex + 1 > mediaSectionsInOffer) {
        return;
      }
      if (transceiver.rejected) {
        if (transceiver.kind === 'application') {
          if (transceiver.protocol === 'DTLS/SCTP') { // legacy fmt
            sdp += 'm=application 0 DTLS/SCTP 5000\r\n';
          } else {
            sdp += 'm=application 0 ' + transceiver.protocol +
                ' webrtc-datachannel\r\n';
          }
        } else if (transceiver.kind === 'audio') {
          sdp += 'm=audio 0 UDP/TLS/RTP/SAVPF 0\r\n' +
              'a=rtpmap:0 PCMU/8000\r\n';
        } else if (transceiver.kind === 'video') {
          sdp += 'm=video 0 UDP/TLS/RTP/SAVPF 120\r\n' +
              'a=rtpmap:120 VP8/90000\r\n';
        }
        sdp += 'c=IN IP4 0.0.0.0\r\n' +
            'a=inactive\r\n' +
            'a=mid:' + transceiver.mid + '\r\n';
        return;
      }

      // FIXME: look at direction.
      if (transceiver.stream) {
        var localTrack;
        if (transceiver.kind === 'audio') {
          localTrack = transceiver.stream.getAudioTracks()[0];
        } else if (transceiver.kind === 'video') {
          localTrack = transceiver.stream.getVideoTracks()[0];
        }
        if (localTrack) {
          // add RTX
          if (edgeVersion >= 15019 && transceiver.kind === 'video' &&
              !transceiver.sendEncodingParameters[0].rtx) {
            transceiver.sendEncodingParameters[0].rtx = {
              ssrc: transceiver.sendEncodingParameters[0].ssrc + 1
            };
          }
        }
      }

      // Calculate intersection of capabilities.
      var commonCapabilities = getCommonCapabilities(
          transceiver.localCapabilities,
          transceiver.remoteCapabilities);

      var hasRtx = commonCapabilities.codecs.filter(function(c) {
        return c.name.toLowerCase() === 'rtx';
      }).length;
      if (!hasRtx && transceiver.sendEncodingParameters[0].rtx) {
        delete transceiver.sendEncodingParameters[0].rtx;
      }

      sdp += writeMediaSection(transceiver, commonCapabilities,
          'answer', transceiver.stream, pc._dtlsRole);
      if (transceiver.rtcpParameters &&
          transceiver.rtcpParameters.reducedSize) {
        sdp += 'a=rtcp-rsize\r\n';
      }
    });

    var desc = new window.RTCSessionDescription({
      type: 'answer',
      sdp: sdp
    });
    return Promise.resolve(desc);
  };

  RTCPeerConnection.prototype.addIceCandidate = function(candidate) {
    var pc = this;
    var sections;
    if (candidate && !(candidate.sdpMLineIndex !== undefined ||
        candidate.sdpMid)) {
      return Promise.reject(new TypeError('sdpMLineIndex or sdpMid required'));
    }

    // TODO: needs to go into ops queue.
    return new Promise(function(resolve, reject) {
      if (!pc._remoteDescription) {
        return reject(makeError('InvalidStateError',
            'Can not add ICE candidate without a remote description'));
      } else if (!candidate || candidate.candidate === '') {
        for (var j = 0; j < pc.transceivers.length; j++) {
          if (pc.transceivers[j].rejected) {
            continue;
          }
          pc.transceivers[j].iceTransport.addRemoteCandidate({});
          sections = SDPUtils.getMediaSections(pc._remoteDescription.sdp);
          sections[j] += 'a=end-of-candidates\r\n';
          pc._remoteDescription.sdp =
              SDPUtils.getDescription(pc._remoteDescription.sdp) +
              sections.join('');
          if (pc.usingBundle) {
            break;
          }
        }
      } else {
        var sdpMLineIndex = candidate.sdpMLineIndex;
        if (candidate.sdpMid) {
          for (var i = 0; i < pc.transceivers.length; i++) {
            if (pc.transceivers[i].mid === candidate.sdpMid) {
              sdpMLineIndex = i;
              break;
            }
          }
        }
        var transceiver = pc.transceivers[sdpMLineIndex];
        if (transceiver) {
          if (transceiver.rejected) {
            return resolve();
          }
          var cand = Object.keys(candidate.candidate).length > 0 ?
              SDPUtils.parseCandidate(candidate.candidate) : {};
          // Ignore Chrome's invalid candidates since Edge does not like them.
          if (cand.protocol === 'tcp' && (cand.port === 0 || cand.port === 9)) {
            return resolve();
          }
          // Ignore RTCP candidates, we assume RTCP-MUX.
          if (cand.component && cand.component !== 1) {
            return resolve();
          }
          // when using bundle, avoid adding candidates to the wrong
          // ice transport. And avoid adding candidates added in the SDP.
          if (sdpMLineIndex === 0 || (sdpMLineIndex > 0 &&
              transceiver.iceTransport !== pc.transceivers[0].iceTransport)) {
            if (!maybeAddCandidate(transceiver.iceTransport, cand)) {
              return reject(makeError('OperationError',
                  'Can not add ICE candidate'));
            }
          }

          // update the remoteDescription.
          var candidateString = candidate.candidate.trim();
          if (candidateString.indexOf('a=') === 0) {
            candidateString = candidateString.substr(2);
          }
          sections = SDPUtils.getMediaSections(pc._remoteDescription.sdp);
          sections[sdpMLineIndex] += 'a=' +
              (cand.type ? candidateString : 'end-of-candidates')
              + '\r\n';
          pc._remoteDescription.sdp =
              SDPUtils.getDescription(pc._remoteDescription.sdp) +
              sections.join('');
        } else {
          return reject(makeError('OperationError',
              'Can not add ICE candidate'));
        }
      }
      resolve();
    });
  };

  RTCPeerConnection.prototype.getStats = function(selector) {
    if (selector && selector instanceof window.MediaStreamTrack) {
      var senderOrReceiver = null;
      this.transceivers.forEach(function(transceiver) {
        if (transceiver.rtpSender &&
            transceiver.rtpSender.track === selector) {
          senderOrReceiver = transceiver.rtpSender;
        } else if (transceiver.rtpReceiver &&
            transceiver.rtpReceiver.track === selector) {
          senderOrReceiver = transceiver.rtpReceiver;
        }
      });
      if (!senderOrReceiver) {
        throw makeError('InvalidAccessError', 'Invalid selector.');
      }
      return senderOrReceiver.getStats();
    }

    var promises = [];
    this.transceivers.forEach(function(transceiver) {
      ['rtpSender', 'rtpReceiver', 'iceGatherer', 'iceTransport',
          'dtlsTransport'].forEach(function(method) {
            if (transceiver[method]) {
              promises.push(transceiver[method].getStats());
            }
          });
    });
    return Promise.all(promises).then(function(allStats) {
      var results = new Map();
      allStats.forEach(function(stats) {
        stats.forEach(function(stat) {
          results.set(stat.id, stat);
        });
      });
      return results;
    });
  };

  // fix low-level stat names and return Map instead of object.
  var ortcObjects = ['RTCRtpSender', 'RTCRtpReceiver', 'RTCIceGatherer',
    'RTCIceTransport', 'RTCDtlsTransport'];
  ortcObjects.forEach(function(ortcObjectName) {
    var obj = window[ortcObjectName];
    if (obj && obj.prototype && obj.prototype.getStats) {
      var nativeGetstats = obj.prototype.getStats;
      obj.prototype.getStats = function() {
        return nativeGetstats.apply(this)
        .then(function(nativeStats) {
          var mapStats = new Map();
          Object.keys(nativeStats).forEach(function(id) {
            nativeStats[id].type = fixStatsType(nativeStats[id]);
            mapStats.set(id, nativeStats[id]);
          });
          return mapStats;
        });
      };
    }
  });

  // legacy callback shims. Should be moved to adapter.js some days.
  var methods = ['createOffer', 'createAnswer'];
  methods.forEach(function(method) {
    var nativeMethod = RTCPeerConnection.prototype[method];
    RTCPeerConnection.prototype[method] = function() {
      var args = arguments;
      if (typeof args[0] === 'function' ||
          typeof args[1] === 'function') { // legacy
        return nativeMethod.apply(this, [arguments[2]])
        .then(function(description) {
          if (typeof args[0] === 'function') {
            args[0].apply(null, [description]);
          }
        }, function(error) {
          if (typeof args[1] === 'function') {
            args[1].apply(null, [error]);
          }
        });
      }
      return nativeMethod.apply(this, arguments);
    };
  });

  methods = ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate'];
  methods.forEach(function(method) {
    var nativeMethod = RTCPeerConnection.prototype[method];
    RTCPeerConnection.prototype[method] = function() {
      var args = arguments;
      if (typeof args[1] === 'function' ||
          typeof args[2] === 'function') { // legacy
        return nativeMethod.apply(this, arguments)
        .then(function() {
          if (typeof args[1] === 'function') {
            args[1].apply(null);
          }
        }, function(error) {
          if (typeof args[2] === 'function') {
            args[2].apply(null, [error]);
          }
        });
      }
      return nativeMethod.apply(this, arguments);
    };
  });

  // getStats is special. It doesn't have a spec legacy method yet we support
  // getStats(something, cb) without error callbacks.
  ['getStats'].forEach(function(method) {
    var nativeMethod = RTCPeerConnection.prototype[method];
    RTCPeerConnection.prototype[method] = function() {
      var args = arguments;
      if (typeof args[1] === 'function') {
        return nativeMethod.apply(this, arguments)
        .then(function() {
          if (typeof args[1] === 'function') {
            args[1].apply(null);
          }
        });
      }
      return nativeMethod.apply(this, arguments);
    };
  });

  return RTCPeerConnection;
};


/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


// Expose public methods.
module.exports = function(window) {
  var navigator = window && window.navigator;

  var shimError_ = function(e) {
    return {
      name: {PermissionDeniedError: 'NotAllowedError'}[e.name] || e.name,
      message: e.message,
      constraint: e.constraint,
      toString: function() {
        return this.name;
      }
    };
  };

  // getUserMedia error shim.
  var origGetUserMedia = navigator.mediaDevices.getUserMedia.
      bind(navigator.mediaDevices);
  navigator.mediaDevices.getUserMedia = function(c) {
    return origGetUserMedia(c).catch(function(e) {
      return Promise.reject(shimError_(e));
    });
  };
};


/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var utils = __webpack_require__(104);

module.exports = {
  shimGetUserMedia: __webpack_require__(2281),
  shimOnTrack: function(window) {
    if (typeof window === 'object' && window.RTCPeerConnection && !('ontrack' in
        window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'ontrack', {
        get: function() {
          return this._ontrack;
        },
        set: function(f) {
          if (this._ontrack) {
            this.removeEventListener('track', this._ontrack);
            this.removeEventListener('addstream', this._ontrackpoly);
          }
          this.addEventListener('track', this._ontrack = f);
          this.addEventListener('addstream', this._ontrackpoly = function(e) {
            e.stream.getTracks().forEach(function(track) {
              var event = new Event('track');
              event.track = track;
              event.receiver = {track: track};
              event.transceiver = {receiver: event.receiver};
              event.streams = [e.stream];
              this.dispatchEvent(event);
            }.bind(this));
          }.bind(this));
        },
        enumerable: true,
        configurable: true
      });
    }
    if (typeof window === 'object' && window.RTCTrackEvent &&
        ('receiver' in window.RTCTrackEvent.prototype) &&
        !('transceiver' in window.RTCTrackEvent.prototype)) {
      Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get: function() {
          return {receiver: this.receiver};
        }
      });
    }
  },

  shimSourceObject: function(window) {
    // Firefox has supported mozSrcObject since FF22, unprefixed in 42.
    if (typeof window === 'object') {
      if (window.HTMLMediaElement &&
        !('srcObject' in window.HTMLMediaElement.prototype)) {
        // Shim the srcObject property, once, when HTMLMediaElement is found.
        Object.defineProperty(window.HTMLMediaElement.prototype, 'srcObject', {
          get: function() {
            return this.mozSrcObject;
          },
          set: function(stream) {
            this.mozSrcObject = stream;
          }
        });
      }
    }
  },

  shimPeerConnection: function(window) {
    var browserDetails = utils.detectBrowser(window);

    if (typeof window !== 'object' || !(window.RTCPeerConnection ||
        window.mozRTCPeerConnection)) {
      return; // probably media.peerconnection.enabled=false in about:config
    }
    // The RTCPeerConnection object.
    if (!window.RTCPeerConnection) {
      window.RTCPeerConnection = function(pcConfig, pcConstraints) {
        if (browserDetails.version < 38) {
          // .urls is not supported in FF < 38.
          // create RTCIceServers with a single url.
          if (pcConfig && pcConfig.iceServers) {
            var newIceServers = [];
            for (var i = 0; i < pcConfig.iceServers.length; i++) {
              var server = pcConfig.iceServers[i];
              if (server.hasOwnProperty('urls')) {
                for (var j = 0; j < server.urls.length; j++) {
                  var newServer = {
                    url: server.urls[j]
                  };
                  if (server.urls[j].indexOf('turn') === 0) {
                    newServer.username = server.username;
                    newServer.credential = server.credential;
                  }
                  newIceServers.push(newServer);
                }
              } else {
                newIceServers.push(pcConfig.iceServers[i]);
              }
            }
            pcConfig.iceServers = newIceServers;
          }
        }
        return new window.mozRTCPeerConnection(pcConfig, pcConstraints);
      };
      window.RTCPeerConnection.prototype =
          window.mozRTCPeerConnection.prototype;

      // wrap static methods. Currently just generateCertificate.
      if (window.mozRTCPeerConnection.generateCertificate) {
        Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
          get: function() {
            return window.mozRTCPeerConnection.generateCertificate;
          }
        });
      }

      window.RTCSessionDescription = window.mozRTCSessionDescription;
      window.RTCIceCandidate = window.mozRTCIceCandidate;
    }

    // shim away need for obsolete RTCIceCandidate/RTCSessionDescription.
    ['setLocalDescription', 'setRemoteDescription', 'addIceCandidate']
        .forEach(function(method) {
          var nativeMethod = window.RTCPeerConnection.prototype[method];
          window.RTCPeerConnection.prototype[method] = function() {
            arguments[0] = new ((method === 'addIceCandidate') ?
                window.RTCIceCandidate :
                window.RTCSessionDescription)(arguments[0]);
            return nativeMethod.apply(this, arguments);
          };
        });

    // support for addIceCandidate(null or undefined)
    var nativeAddIceCandidate =
        window.RTCPeerConnection.prototype.addIceCandidate;
    window.RTCPeerConnection.prototype.addIceCandidate = function() {
      if (!arguments[0]) {
        if (arguments[1]) {
          arguments[1].apply(null);
        }
        return Promise.resolve();
      }
      return nativeAddIceCandidate.apply(this, arguments);
    };

    // shim getStats with maplike support
    var makeMapStats = function(stats) {
      var map = new Map();
      Object.keys(stats).forEach(function(key) {
        map.set(key, stats[key]);
        map[key] = stats[key];
      });
      return map;
    };

    var modernStatsTypes = {
      inboundrtp: 'inbound-rtp',
      outboundrtp: 'outbound-rtp',
      candidatepair: 'candidate-pair',
      localcandidate: 'local-candidate',
      remotecandidate: 'remote-candidate'
    };

    var nativeGetStats = window.RTCPeerConnection.prototype.getStats;
    window.RTCPeerConnection.prototype.getStats = function(
      selector,
      onSucc,
      onErr
    ) {
      return nativeGetStats.apply(this, [selector || null])
        .then(function(stats) {
          if (browserDetails.version < 48) {
            stats = makeMapStats(stats);
          }
          if (browserDetails.version < 53 && !onSucc) {
            // Shim only promise getStats with spec-hyphens in type names
            // Leave callback version alone; misc old uses of forEach before Map
            try {
              stats.forEach(function(stat) {
                stat.type = modernStatsTypes[stat.type] || stat.type;
              });
            } catch (e) {
              if (e.name !== 'TypeError') {
                throw e;
              }
              // Avoid TypeError: "type" is read-only, in old versions. 34-43ish
              stats.forEach(function(stat, i) {
                stats.set(i, Object.assign({}, stat, {
                  type: modernStatsTypes[stat.type] || stat.type
                }));
              });
            }
          }
          return stats;
        })
        .then(onSucc, onErr);
    };
  },

  shimSenderGetStats: function(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection &&
        window.RTCRtpSender)) {
      return;
    }
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpSender.prototype) {
      return;
    }
    var origGetSenders = window.RTCPeerConnection.prototype.getSenders;
    if (origGetSenders) {
      window.RTCPeerConnection.prototype.getSenders = function() {
        var pc = this;
        var senders = origGetSenders.apply(pc, []);
        senders.forEach(function(sender) {
          sender._pc = pc;
        });
        return senders;
      };
    }

    var origAddTrack = window.RTCPeerConnection.prototype.addTrack;
    if (origAddTrack) {
      window.RTCPeerConnection.prototype.addTrack = function() {
        var sender = origAddTrack.apply(this, arguments);
        sender._pc = this;
        return sender;
      };
    }
    window.RTCRtpSender.prototype.getStats = function() {
      return this.track ? this._pc.getStats(this.track) :
          Promise.resolve(new Map());
    };
  },

  shimReceiverGetStats: function(window) {
    if (!(typeof window === 'object' && window.RTCPeerConnection &&
        window.RTCRtpSender)) {
      return;
    }
    if (window.RTCRtpSender && 'getStats' in window.RTCRtpReceiver.prototype) {
      return;
    }
    var origGetReceivers = window.RTCPeerConnection.prototype.getReceivers;
    if (origGetReceivers) {
      window.RTCPeerConnection.prototype.getReceivers = function() {
        var pc = this;
        var receivers = origGetReceivers.apply(pc, []);
        receivers.forEach(function(receiver) {
          receiver._pc = pc;
        });
        return receivers;
      };
    }
    utils.wrapPeerConnectionEvent(window, 'track', function(e) {
      e.receiver._pc = e.srcElement;
      return e;
    });
    window.RTCRtpReceiver.prototype.getStats = function() {
      return this._pc.getStats(this.track);
    };
  },

  shimRemoveStream: function(window) {
    if (!window.RTCPeerConnection ||
        'removeStream' in window.RTCPeerConnection.prototype) {
      return;
    }
    window.RTCPeerConnection.prototype.removeStream = function(stream) {
      var pc = this;
      utils.deprecated('removeStream', 'removeTrack');
      this.getSenders().forEach(function(sender) {
        if (sender.track && stream.getTracks().indexOf(sender.track) !== -1) {
          pc.removeTrack(sender);
        }
      });
    };
  },

  shimRTCDataChannel: function(window) {
    // rename DataChannel to RTCDataChannel (native fix in FF60):
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1173851
    if (window.DataChannel && !window.RTCDataChannel) {
      window.RTCDataChannel = window.DataChannel;
    }
  },

  shimGetDisplayMedia: function(window, preferredMediaSource) {
    if (!window.navigator || !window.navigator.mediaDevices ||
        'getDisplayMedia' in window.navigator.mediaDevices) {
      return;
    }
    window.navigator.mediaDevices.getDisplayMedia = function(constraints) {
      if (!(constraints && constraints.video)) {
        var err = new DOMException('getDisplayMedia without video ' +
            'constraints is undefined');
        err.name = 'NotFoundError';
        // from https://heycam.github.io/webidl/#idl-DOMException-error-names
        err.code = 8;
        return Promise.reject(err);
      }
      if (constraints.video === true) {
        constraints.video = {mediaSource: preferredMediaSource};
      } else {
        constraints.video.mediaSource = preferredMediaSource;
      }
      return window.navigator.mediaDevices.getUserMedia(constraints);
    };
    window.navigator.getDisplayMedia = function(constraints) {
      utils.deprecated('navigator.getDisplayMedia',
          'navigator.mediaDevices.getDisplayMedia');
      return window.navigator.mediaDevices.getDisplayMedia(constraints);
    };
  }
};


/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var utils = __webpack_require__(104);
var logging = utils.log;

// Expose public methods.
module.exports = function(window) {
  var browserDetails = utils.detectBrowser(window);
  var navigator = window && window.navigator;
  var MediaStreamTrack = window && window.MediaStreamTrack;

  var shimError_ = function(e) {
    return {
      name: {
        InternalError: 'NotReadableError',
        NotSupportedError: 'TypeError',
        PermissionDeniedError: 'NotAllowedError',
        SecurityError: 'NotAllowedError'
      }[e.name] || e.name,
      message: {
        'The operation is insecure.': 'The request is not allowed by the ' +
        'user agent or the platform in the current context.'
      }[e.message] || e.message,
      constraint: e.constraint,
      toString: function() {
        return this.name + (this.message && ': ') + this.message;
      }
    };
  };

  // getUserMedia constraints shim.
  var getUserMedia_ = function(constraints, onSuccess, onError) {
    var constraintsToFF37_ = function(c) {
      if (typeof c !== 'object' || c.require) {
        return c;
      }
      var require = [];
      Object.keys(c).forEach(function(key) {
        if (key === 'require' || key === 'advanced' || key === 'mediaSource') {
          return;
        }
        var r = c[key] = (typeof c[key] === 'object') ?
            c[key] : {ideal: c[key]};
        if (r.min !== undefined ||
            r.max !== undefined || r.exact !== undefined) {
          require.push(key);
        }
        if (r.exact !== undefined) {
          if (typeof r.exact === 'number') {
            r. min = r.max = r.exact;
          } else {
            c[key] = r.exact;
          }
          delete r.exact;
        }
        if (r.ideal !== undefined) {
          c.advanced = c.advanced || [];
          var oc = {};
          if (typeof r.ideal === 'number') {
            oc[key] = {min: r.ideal, max: r.ideal};
          } else {
            oc[key] = r.ideal;
          }
          c.advanced.push(oc);
          delete r.ideal;
          if (!Object.keys(r).length) {
            delete c[key];
          }
        }
      });
      if (require.length) {
        c.require = require;
      }
      return c;
    };
    constraints = JSON.parse(JSON.stringify(constraints));
    if (browserDetails.version < 38) {
      logging('spec: ' + JSON.stringify(constraints));
      if (constraints.audio) {
        constraints.audio = constraintsToFF37_(constraints.audio);
      }
      if (constraints.video) {
        constraints.video = constraintsToFF37_(constraints.video);
      }
      logging('ff37: ' + JSON.stringify(constraints));
    }
    return navigator.mozGetUserMedia(constraints, onSuccess, function(e) {
      onError(shimError_(e));
    });
  };

  // Returns the result of getUserMedia as a Promise.
  var getUserMediaPromise_ = function(constraints) {
    return new Promise(function(resolve, reject) {
      getUserMedia_(constraints, resolve, reject);
    });
  };

  // Shim for mediaDevices on older versions.
  if (!navigator.mediaDevices) {
    navigator.mediaDevices = {getUserMedia: getUserMediaPromise_,
      addEventListener: function() { },
      removeEventListener: function() { }
    };
  }
  navigator.mediaDevices.enumerateDevices =
      navigator.mediaDevices.enumerateDevices || function() {
        return new Promise(function(resolve) {
          var infos = [
            {kind: 'audioinput', deviceId: 'default', label: '', groupId: ''},
            {kind: 'videoinput', deviceId: 'default', label: '', groupId: ''}
          ];
          resolve(infos);
        });
      };

  if (browserDetails.version < 41) {
    // Work around http://bugzil.la/1169665
    var orgEnumerateDevices =
        navigator.mediaDevices.enumerateDevices.bind(navigator.mediaDevices);
    navigator.mediaDevices.enumerateDevices = function() {
      return orgEnumerateDevices().then(undefined, function(e) {
        if (e.name === 'NotFoundError') {
          return [];
        }
        throw e;
      });
    };
  }
  if (browserDetails.version < 49) {
    var origGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(c) {
      return origGetUserMedia(c).then(function(stream) {
        // Work around https://bugzil.la/802326
        if (c.audio && !stream.getAudioTracks().length ||
            c.video && !stream.getVideoTracks().length) {
          stream.getTracks().forEach(function(track) {
            track.stop();
          });
          throw new DOMException('The object can not be found here.',
                                 'NotFoundError');
        }
        return stream;
      }, function(e) {
        return Promise.reject(shimError_(e));
      });
    };
  }
  if (!(browserDetails.version > 55 &&
      'autoGainControl' in navigator.mediaDevices.getSupportedConstraints())) {
    var remap = function(obj, a, b) {
      if (a in obj && !(b in obj)) {
        obj[b] = obj[a];
        delete obj[a];
      }
    };

    var nativeGetUserMedia = navigator.mediaDevices.getUserMedia.
        bind(navigator.mediaDevices);
    navigator.mediaDevices.getUserMedia = function(c) {
      if (typeof c === 'object' && typeof c.audio === 'object') {
        c = JSON.parse(JSON.stringify(c));
        remap(c.audio, 'autoGainControl', 'mozAutoGainControl');
        remap(c.audio, 'noiseSuppression', 'mozNoiseSuppression');
      }
      return nativeGetUserMedia(c);
    };

    if (MediaStreamTrack && MediaStreamTrack.prototype.getSettings) {
      var nativeGetSettings = MediaStreamTrack.prototype.getSettings;
      MediaStreamTrack.prototype.getSettings = function() {
        var obj = nativeGetSettings.apply(this, arguments);
        remap(obj, 'mozAutoGainControl', 'autoGainControl');
        remap(obj, 'mozNoiseSuppression', 'noiseSuppression');
        return obj;
      };
    }

    if (MediaStreamTrack && MediaStreamTrack.prototype.applyConstraints) {
      var nativeApplyConstraints = MediaStreamTrack.prototype.applyConstraints;
      MediaStreamTrack.prototype.applyConstraints = function(c) {
        if (this.kind === 'audio' && typeof c === 'object') {
          c = JSON.parse(JSON.stringify(c));
          remap(c, 'autoGainControl', 'mozAutoGainControl');
          remap(c, 'noiseSuppression', 'mozNoiseSuppression');
        }
        return nativeApplyConstraints.apply(this, [c]);
      };
    }
  }
  navigator.getUserMedia = function(constraints, onSuccess, onError) {
    if (browserDetails.version < 44) {
      return getUserMedia_(constraints, onSuccess, onError);
    }
    // Replace Firefox 44+'s deprecation warning with unprefixed version.
    utils.deprecated('navigator.getUserMedia',
        'navigator.mediaDevices.getUserMedia');
    navigator.mediaDevices.getUserMedia(constraints).then(onSuccess, onError);
  };
};


/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2016 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */

var utils = __webpack_require__(104);

module.exports = {
  shimLocalStreamsAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    if (!('getLocalStreams' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getLocalStreams = function() {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        return this._localStreams;
      };
    }
    if (!('getStreamById' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getStreamById = function(id) {
        var result = null;
        if (this._localStreams) {
          this._localStreams.forEach(function(stream) {
            if (stream.id === id) {
              result = stream;
            }
          });
        }
        if (this._remoteStreams) {
          this._remoteStreams.forEach(function(stream) {
            if (stream.id === id) {
              result = stream;
            }
          });
        }
        return result;
      };
    }
    if (!('addStream' in window.RTCPeerConnection.prototype)) {
      var _addTrack = window.RTCPeerConnection.prototype.addTrack;
      window.RTCPeerConnection.prototype.addStream = function(stream) {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        if (this._localStreams.indexOf(stream) === -1) {
          this._localStreams.push(stream);
        }
        var pc = this;
        stream.getTracks().forEach(function(track) {
          _addTrack.call(pc, track, stream);
        });
      };

      window.RTCPeerConnection.prototype.addTrack = function(track, stream) {
        if (stream) {
          if (!this._localStreams) {
            this._localStreams = [stream];
          } else if (this._localStreams.indexOf(stream) === -1) {
            this._localStreams.push(stream);
          }
        }
        return _addTrack.call(this, track, stream);
      };
    }
    if (!('removeStream' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.removeStream = function(stream) {
        if (!this._localStreams) {
          this._localStreams = [];
        }
        var index = this._localStreams.indexOf(stream);
        if (index === -1) {
          return;
        }
        this._localStreams.splice(index, 1);
        var pc = this;
        var tracks = stream.getTracks();
        this.getSenders().forEach(function(sender) {
          if (tracks.indexOf(sender.track) !== -1) {
            pc.removeTrack(sender);
          }
        });
      };
    }
  },
  shimRemoteStreamsAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    if (!('getRemoteStreams' in window.RTCPeerConnection.prototype)) {
      window.RTCPeerConnection.prototype.getRemoteStreams = function() {
        return this._remoteStreams ? this._remoteStreams : [];
      };
    }
    if (!('onaddstream' in window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'onaddstream', {
        get: function() {
          return this._onaddstream;
        },
        set: function(f) {
          if (this._onaddstream) {
            this.removeEventListener('addstream', this._onaddstream);
          }
          this.addEventListener('addstream', this._onaddstream = f);
        }
      });
      var origSetRemoteDescription =
          window.RTCPeerConnection.prototype.setRemoteDescription;
      window.RTCPeerConnection.prototype.setRemoteDescription = function() {
        var pc = this;
        if (!this._onaddstreampoly) {
          this.addEventListener('track', this._onaddstreampoly = function(e) {
            e.streams.forEach(function(stream) {
              if (!pc._remoteStreams) {
                pc._remoteStreams = [];
              }
              if (pc._remoteStreams.indexOf(stream) >= 0) {
                return;
              }
              pc._remoteStreams.push(stream);
              var event = new Event('addstream');
              event.stream = stream;
              pc.dispatchEvent(event);
            });
          });
        }
        return origSetRemoteDescription.apply(pc, arguments);
      };
    }
  },
  shimCallbacksAPI: function(window) {
    if (typeof window !== 'object' || !window.RTCPeerConnection) {
      return;
    }
    var prototype = window.RTCPeerConnection.prototype;
    var createOffer = prototype.createOffer;
    var createAnswer = prototype.createAnswer;
    var setLocalDescription = prototype.setLocalDescription;
    var setRemoteDescription = prototype.setRemoteDescription;
    var addIceCandidate = prototype.addIceCandidate;

    prototype.createOffer = function(successCallback, failureCallback) {
      var options = (arguments.length >= 2) ? arguments[2] : arguments[0];
      var promise = createOffer.apply(this, [options]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };

    prototype.createAnswer = function(successCallback, failureCallback) {
      var options = (arguments.length >= 2) ? arguments[2] : arguments[0];
      var promise = createAnswer.apply(this, [options]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };

    var withCallback = function(description, successCallback, failureCallback) {
      var promise = setLocalDescription.apply(this, [description]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.setLocalDescription = withCallback;

    withCallback = function(description, successCallback, failureCallback) {
      var promise = setRemoteDescription.apply(this, [description]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.setRemoteDescription = withCallback;

    withCallback = function(candidate, successCallback, failureCallback) {
      var promise = addIceCandidate.apply(this, [candidate]);
      if (!failureCallback) {
        return promise;
      }
      promise.then(successCallback, failureCallback);
      return Promise.resolve();
    };
    prototype.addIceCandidate = withCallback;
  },
  shimGetUserMedia: function(window) {
    var navigator = window && window.navigator;

    if (!navigator.getUserMedia) {
      if (navigator.webkitGetUserMedia) {
        navigator.getUserMedia = navigator.webkitGetUserMedia.bind(navigator);
      } else if (navigator.mediaDevices &&
          navigator.mediaDevices.getUserMedia) {
        navigator.getUserMedia = function(constraints, cb, errcb) {
          navigator.mediaDevices.getUserMedia(constraints)
          .then(cb, errcb);
        }.bind(navigator);
      }
    }
  },
  shimRTCIceServerUrls: function(window) {
    // migrate from non-spec RTCIceServer.url to RTCIceServer.urls
    var OrigPeerConnection = window.RTCPeerConnection;
    window.RTCPeerConnection = function(pcConfig, pcConstraints) {
      if (pcConfig && pcConfig.iceServers) {
        var newIceServers = [];
        for (var i = 0; i < pcConfig.iceServers.length; i++) {
          var server = pcConfig.iceServers[i];
          if (!server.hasOwnProperty('urls') &&
              server.hasOwnProperty('url')) {
            utils.deprecated('RTCIceServer.url', 'RTCIceServer.urls');
            server = JSON.parse(JSON.stringify(server));
            server.urls = server.url;
            delete server.url;
            newIceServers.push(server);
          } else {
            newIceServers.push(pcConfig.iceServers[i]);
          }
        }
        pcConfig.iceServers = newIceServers;
      }
      return new OrigPeerConnection(pcConfig, pcConstraints);
    };
    window.RTCPeerConnection.prototype = OrigPeerConnection.prototype;
    // wrap static methods. Currently just generateCertificate.
    if ('generateCertificate' in window.RTCPeerConnection) {
      Object.defineProperty(window.RTCPeerConnection, 'generateCertificate', {
        get: function() {
          return OrigPeerConnection.generateCertificate;
        }
      });
    }
  },
  shimTrackEventTransceiver: function(window) {
    // Add event.transceiver member over deprecated event.receiver
    if (typeof window === 'object' && window.RTCPeerConnection &&
        ('receiver' in window.RTCTrackEvent.prototype) &&
        // can't check 'transceiver' in window.RTCTrackEvent.prototype, as it is
        // defined for some reason even when window.RTCTransceiver is not.
        !window.RTCTransceiver) {
      Object.defineProperty(window.RTCTrackEvent.prototype, 'transceiver', {
        get: function() {
          return {receiver: this.receiver};
        }
      });
    }
  },

  shimCreateOfferLegacy: function(window) {
    var origCreateOffer = window.RTCPeerConnection.prototype.createOffer;
    window.RTCPeerConnection.prototype.createOffer = function(offerOptions) {
      var pc = this;
      if (offerOptions) {
        if (typeof offerOptions.offerToReceiveAudio !== 'undefined') {
          // support bit values
          offerOptions.offerToReceiveAudio = !!offerOptions.offerToReceiveAudio;
        }
        var audioTransceiver = pc.getTransceivers().find(function(transceiver) {
          return transceiver.sender.track &&
              transceiver.sender.track.kind === 'audio';
        });
        if (offerOptions.offerToReceiveAudio === false && audioTransceiver) {
          if (audioTransceiver.direction === 'sendrecv') {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection('sendonly');
            } else {
              audioTransceiver.direction = 'sendonly';
            }
          } else if (audioTransceiver.direction === 'recvonly') {
            if (audioTransceiver.setDirection) {
              audioTransceiver.setDirection('inactive');
            } else {
              audioTransceiver.direction = 'inactive';
            }
          }
        } else if (offerOptions.offerToReceiveAudio === true &&
            !audioTransceiver) {
          pc.addTransceiver('audio');
        }


        if (typeof offerOptions.offerToReceiveVideo !== 'undefined') {
          // support bit values
          offerOptions.offerToReceiveVideo = !!offerOptions.offerToReceiveVideo;
        }
        var videoTransceiver = pc.getTransceivers().find(function(transceiver) {
          return transceiver.sender.track &&
              transceiver.sender.track.kind === 'video';
        });
        if (offerOptions.offerToReceiveVideo === false && videoTransceiver) {
          if (videoTransceiver.direction === 'sendrecv') {
            videoTransceiver.setDirection('sendonly');
          } else if (videoTransceiver.direction === 'recvonly') {
            videoTransceiver.setDirection('inactive');
          }
        } else if (offerOptions.offerToReceiveVideo === true &&
            !videoTransceiver) {
          pc.addTransceiver('video');
        }
      }
      return origCreateOffer.apply(pc, arguments);
    };
  }
};


/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Copyright (c) 2017 The WebRTC project authors. All Rights Reserved.
 *
 *  Use of this source code is governed by a BSD-style license
 *  that can be found in the LICENSE file in the root of the source
 *  tree.
 */
 /* eslint-env node */


var SDPUtils = __webpack_require__(673);
var utils = __webpack_require__(104);

module.exports = {
  shimRTCIceCandidate: function(window) {
    // foundation is arbitrarily chosen as an indicator for full support for
    // https://w3c.github.io/webrtc-pc/#rtcicecandidate-interface
    if (!window.RTCIceCandidate || (window.RTCIceCandidate && 'foundation' in
        window.RTCIceCandidate.prototype)) {
      return;
    }

    var NativeRTCIceCandidate = window.RTCIceCandidate;
    window.RTCIceCandidate = function(args) {
      // Remove the a= which shouldn't be part of the candidate string.
      if (typeof args === 'object' && args.candidate &&
          args.candidate.indexOf('a=') === 0) {
        args = JSON.parse(JSON.stringify(args));
        args.candidate = args.candidate.substr(2);
      }

      if (args.candidate && args.candidate.length) {
        // Augment the native candidate with the parsed fields.
        var nativeCandidate = new NativeRTCIceCandidate(args);
        var parsedCandidate = SDPUtils.parseCandidate(args.candidate);
        var augmentedCandidate = Object.assign(nativeCandidate,
            parsedCandidate);

        // Add a serializer that does not serialize the extra attributes.
        augmentedCandidate.toJSON = function() {
          return {
            candidate: augmentedCandidate.candidate,
            sdpMid: augmentedCandidate.sdpMid,
            sdpMLineIndex: augmentedCandidate.sdpMLineIndex,
            usernameFragment: augmentedCandidate.usernameFragment,
          };
        };
        return augmentedCandidate;
      }
      return new NativeRTCIceCandidate(args);
    };
    window.RTCIceCandidate.prototype = NativeRTCIceCandidate.prototype;

    // Hook up the augmented candidate in onicecandidate and
    // addEventListener('icecandidate', ...)
    utils.wrapPeerConnectionEvent(window, 'icecandidate', function(e) {
      if (e.candidate) {
        Object.defineProperty(e, 'candidate', {
          value: new window.RTCIceCandidate(e.candidate),
          writable: 'false'
        });
      }
      return e;
    });
  },

  // shimCreateObjectURL must be called before shimSourceObject to avoid loop.

  shimCreateObjectURL: function(window) {
    var URL = window && window.URL;

    if (!(typeof window === 'object' && window.HTMLMediaElement &&
          'srcObject' in window.HTMLMediaElement.prototype &&
        URL.createObjectURL && URL.revokeObjectURL)) {
      // Only shim CreateObjectURL using srcObject if srcObject exists.
      return undefined;
    }

    var nativeCreateObjectURL = URL.createObjectURL.bind(URL);
    var nativeRevokeObjectURL = URL.revokeObjectURL.bind(URL);
    var streams = new Map(), newId = 0;

    URL.createObjectURL = function(stream) {
      if ('getTracks' in stream) {
        var url = 'polyblob:' + (++newId);
        streams.set(url, stream);
        utils.deprecated('URL.createObjectURL(stream)',
            'elem.srcObject = stream');
        return url;
      }
      return nativeCreateObjectURL(stream);
    };
    URL.revokeObjectURL = function(url) {
      nativeRevokeObjectURL(url);
      streams.delete(url);
    };

    var dsc = Object.getOwnPropertyDescriptor(window.HTMLMediaElement.prototype,
                                              'src');
    Object.defineProperty(window.HTMLMediaElement.prototype, 'src', {
      get: function() {
        return dsc.get.apply(this);
      },
      set: function(url) {
        this.srcObject = streams.get(url) || null;
        return dsc.set.apply(this, [url]);
      }
    });

    var nativeSetAttribute = window.HTMLMediaElement.prototype.setAttribute;
    window.HTMLMediaElement.prototype.setAttribute = function() {
      if (arguments.length === 2 &&
          ('' + arguments[0]).toLowerCase() === 'src') {
        this.srcObject = streams.get(arguments[1]) || null;
      }
      return nativeSetAttribute.apply(this, arguments);
    };
  },

  shimMaxMessageSize: function(window) {
    if (window.RTCSctpTransport || !window.RTCPeerConnection) {
      return;
    }
    var browserDetails = utils.detectBrowser(window);

    if (!('sctp' in window.RTCPeerConnection.prototype)) {
      Object.defineProperty(window.RTCPeerConnection.prototype, 'sctp', {
        get: function() {
          return typeof this._sctp === 'undefined' ? null : this._sctp;
        }
      });
    }

    var sctpInDescription = function(description) {
      var sections = SDPUtils.splitSections(description.sdp);
      sections.shift();
      return sections.some(function(mediaSection) {
        var mLine = SDPUtils.parseMLine(mediaSection);
        return mLine && mLine.kind === 'application'
            && mLine.protocol.indexOf('SCTP') !== -1;
      });
    };

    var getRemoteFirefoxVersion = function(description) {
      // TODO: Is there a better solution for detecting Firefox?
      var match = description.sdp.match(/mozilla...THIS_IS_SDPARTA-(\d+)/);
      if (match === null || match.length < 2) {
        return -1;
      }
      var version = parseInt(match[1], 10);
      // Test for NaN (yes, this is ugly)
      return version !== version ? -1 : version;
    };

    var getCanSendMaxMessageSize = function(remoteIsFirefox) {
      // Every implementation we know can send at least 64 KiB.
      // Note: Although Chrome is technically able to send up to 256 KiB, the
      //       data does not reach the other peer reliably.
      //       See: https://bugs.chromium.org/p/webrtc/issues/detail?id=8419
      var canSendMaxMessageSize = 65536;
      if (browserDetails.browser === 'firefox') {
        if (browserDetails.version < 57) {
          if (remoteIsFirefox === -1) {
            // FF < 57 will send in 16 KiB chunks using the deprecated PPID
            // fragmentation.
            canSendMaxMessageSize = 16384;
          } else {
            // However, other FF (and RAWRTC) can reassemble PPID-fragmented
            // messages. Thus, supporting ~2 GiB when sending.
            canSendMaxMessageSize = 2147483637;
          }
        } else if (browserDetails.version < 60) {
          // Currently, all FF >= 57 will reset the remote maximum message size
          // to the default value when a data channel is created at a later
          // stage. :(
          // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831
          canSendMaxMessageSize =
            browserDetails.version === 57 ? 65535 : 65536;
        } else {
          // FF >= 60 supports sending ~2 GiB
          canSendMaxMessageSize = 2147483637;
        }
      }
      return canSendMaxMessageSize;
    };

    var getMaxMessageSize = function(description, remoteIsFirefox) {
      // Note: 65536 bytes is the default value from the SDP spec. Also,
      //       every implementation we know supports receiving 65536 bytes.
      var maxMessageSize = 65536;

      // FF 57 has a slightly incorrect default remote max message size, so
      // we need to adjust it here to avoid a failure when sending.
      // See: https://bugzilla.mozilla.org/show_bug.cgi?id=1425697
      if (browserDetails.browser === 'firefox'
           && browserDetails.version === 57) {
        maxMessageSize = 65535;
      }

      var match = SDPUtils.matchPrefix(description.sdp, 'a=max-message-size:');
      if (match.length > 0) {
        maxMessageSize = parseInt(match[0].substr(19), 10);
      } else if (browserDetails.browser === 'firefox' &&
                  remoteIsFirefox !== -1) {
        // If the maximum message size is not present in the remote SDP and
        // both local and remote are Firefox, the remote peer can receive
        // ~2 GiB.
        maxMessageSize = 2147483637;
      }
      return maxMessageSize;
    };

    var origSetRemoteDescription =
        window.RTCPeerConnection.prototype.setRemoteDescription;
    window.RTCPeerConnection.prototype.setRemoteDescription = function() {
      var pc = this;
      pc._sctp = null;

      if (sctpInDescription(arguments[0])) {
        // Check if the remote is FF.
        var isFirefox = getRemoteFirefoxVersion(arguments[0]);

        // Get the maximum message size the local peer is capable of sending
        var canSendMMS = getCanSendMaxMessageSize(isFirefox);

        // Get the maximum message size of the remote peer.
        var remoteMMS = getMaxMessageSize(arguments[0], isFirefox);

        // Determine final maximum message size
        var maxMessageSize;
        if (canSendMMS === 0 && remoteMMS === 0) {
          maxMessageSize = Number.POSITIVE_INFINITY;
        } else if (canSendMMS === 0 || remoteMMS === 0) {
          maxMessageSize = Math.max(canSendMMS, remoteMMS);
        } else {
          maxMessageSize = Math.min(canSendMMS, remoteMMS);
        }

        // Create a dummy RTCSctpTransport object and the 'maxMessageSize'
        // attribute.
        var sctp = {};
        Object.defineProperty(sctp, 'maxMessageSize', {
          get: function() {
            return maxMessageSize;
          }
        });
        pc._sctp = sctp;
      }

      return origSetRemoteDescription.apply(pc, arguments);
    };
  },

  shimSendThrowTypeError: function(window) {
    if (!(window.RTCPeerConnection &&
        'createDataChannel' in window.RTCPeerConnection.prototype)) {
      return;
    }

    // Note: Although Firefox >= 57 has a native implementation, the maximum
    //       message size can be reset for all data channels at a later stage.
    //       See: https://bugzilla.mozilla.org/show_bug.cgi?id=1426831

    function wrapDcSend(dc, pc) {
      var origDataChannelSend = dc.send;
      dc.send = function() {
        var data = arguments[0];
        var length = data.length || data.size || data.byteLength;
        if (dc.readyState === 'open' &&
            pc.sctp && length > pc.sctp.maxMessageSize) {
          throw new TypeError('Message too large (can send a maximum of ' +
            pc.sctp.maxMessageSize + ' bytes)');
        }
        return origDataChannelSend.apply(dc, arguments);
      };
    }
    var origCreateDataChannel =
      window.RTCPeerConnection.prototype.createDataChannel;
    window.RTCPeerConnection.prototype.createDataChannel = function() {
      var pc = this;
      var dataChannel = origCreateDataChannel.apply(pc, arguments);
      wrapDcSend(dataChannel, pc);
      return dataChannel;
    };
    utils.wrapPeerConnectionEvent(window, 'datachannel', function(e) {
      wrapDcSend(e.channel, e.target);
      return e;
    });
  }
};


/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.QrReaderContainer=exports.Close=exports.Trigger=exports.Container=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-1hbxsby-0'})(['display:flex;& > *:first-child{min-width:200px;}']);var Trigger=exports.Trigger=_styledComponents2.default.div.withConfig({displayName:'styles__Trigger',componentId:'sc-1hbxsby-1'})(['display:flex;']);var Close=exports.Close=_styledComponents2.default.div.withConfig({displayName:'styles__Close',componentId:'sc-1hbxsby-2'})(['background-color:rgb(255,255,255,0.3);border-radius:50%;position:absolute;top:20px;right:20px;cursor:pointer;z-index:10;height:50px;width:50px;display:flex;align-items:center;justify-content:center;padding-top:4px;padding-left:3px;z-index:50;']);var QrReaderContainer=exports.QrReaderContainer=_styledComponents2.default.div.withConfig({displayName:'styles__QrReaderContainer',componentId:'sc-1hbxsby-3'})(['display:flex;position:absolute;left:0;top:0;right:0;bottom:0;background:black;z-index:51;']);

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.mapDispatchToProps=exports.mapStateToProps=undefined;var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ActivationForPartner/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _gridStyled=__webpack_require__(8);var _reactRedux=__webpack_require__(7);var _reduxForm=__webpack_require__(11);var _lodash=__webpack_require__(43);var _lodash2=_interopRequireDefault(_lodash);var _actions=__webpack_require__(13);var _activationService=__webpack_require__(359);var _actions2=__webpack_require__(18);var _formStateActions=__webpack_require__(102);var _confirmation=__webpack_require__(49);var _confirmation2=_interopRequireDefault(_confirmation);var _ModalTypes=__webpack_require__(20);var _ImersiveHeader=__webpack_require__(51);var _ImersiveHeader2=_interopRequireDefault(_ImersiveHeader);var _Content=__webpack_require__(27);var _Content2=_interopRequireDefault(_Content);var _Modal=__webpack_require__(113);var _colors=__webpack_require__(2);var _Option=__webpack_require__(403);var _Option2=_interopRequireDefault(_Option);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _icClose=__webpack_require__(157);var _icClose2=_interopRequireDefault(_icClose);var _ManageInfoModal=__webpack_require__(189);var _ManageInfoModal2=_interopRequireDefault(_ManageInfoModal);var _contestacao=__webpack_require__(47);var _contestacao2=_interopRequireDefault(_contestacao);var _formFields=__webpack_require__(2286);var _styles=__webpack_require__(2287);var _data=__webpack_require__(674);var _icCar=__webpack_require__(666);var _icCar2=_interopRequireDefault(_icCar);var _icUtility=__webpack_require__(667);var _icUtility2=_interopRequireDefault(_icUtility);var _icTruck=__webpack_require__(668);var _icTruck2=_interopRequireDefault(_icTruck);var _icBus=__webpack_require__(669);var _icBus2=_interopRequireDefault(_icBus);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* eslint-disable */var Activation=function(_React$Component){_inherits(Activation,_React$Component);function Activation(props){_classCallCheck(this,Activation);var _this=_possibleConstructorReturn(this,(Activation.__proto__||Object.getPrototypeOf(Activation)).call(this,props));_this.setOption=function(selected){_this.setState({selected:selected},function(){var selected=_this.state.selected;if(selected==='caminhao'||selected==='onibus')_this.getCategory(selected);});};_this.getCategory=function(selected){(0,_activationService.getVehiclesCategory)(selected).then(function(response){var optionCategory=response.map(function(item){return Object.assign({},{value:item.id,label:item.descricao});});_this.setState({axis:optionCategory});});};_this.handleSubmit=function(values){var _this$state=_this.state,selected=_this$state.selected,manageInfo=_this$state.manageInfo;var _this$props=_this.props,_this$props$accountPl=_this$props.accountPlans,accountPlans=_this$props$accountPl===undefined?{}:_this$props$accountPl,_this$props$setIdenti=_this$props.setIdentifiers,setIdentifiers=_this$props$setIdenti===undefined?null:_this$props$setIdenti,_this$props$next=_this$props.next,next=_this$props$next===undefined?false:_this$props$next;var _accountPlans$plans=accountPlans.plans,plans=_accountPlans$plans===undefined?[]:_accountPlans$plans,activePlanId=accountPlans.activePlanId;var currentPlan=plans.find(function(plan){return String(plan.id)===String(activePlanId);})||{};var accountId=currentPlan.accountId,_currentPlan$plan=currentPlan.plan,plan=_currentPlan$plan===undefined?{}:_currentPlan$plan;var formatValues=Object.assign({typeCar:selected},values,{accountId:accountId,type:plan.type});var data=Object.values(manageInfo).map(function(item){if(item!=null){item.codIdentificador=formatValues.identifier;item.conta=formatValues.accountId;item.placa=formatValues.plate;return item;}});_this.props.fetchActivation(formatValues,next);};_this.toggleModal=function(){_this.setState({modalIsOpen:!_this.state.modalIsOpen});};_this.handleCloseModal=function(){_this.setState({modalType:'chooseEdit',informationSelected:null,msgError:''});_this.props.toggleModal();};_this.state={selected:'carro-passeio',axis:[],modalIsOpen:false,manageInfo:{informacao1:null,informacao2:null,informacao3:null}};return _this;}_createClass(Activation,[{key:'componentDidMount',value:function componentDidMount(){// this.props.dispatchReset()
// console.log(this.refs.form)
// const { querySelectorAll: formSelector = null } = this.refs.form || {};
// const firstInput = formSelector && formSelector('input')[0];
// firstInput && firstInput.focus();
// console.log('firstInput',  firstInput)
if(window&&window.document&&window.document.getElementById("inputPlate"))window.document.getElementById("inputPlate").focus();// document.querySelectorAll('input')
// window.document.querySelectorAll('input')[1].focus()
}},{key:'render',value:function render(){var _this2=this;var _state=this.state,selected=_state.selected,axis=_state.axis,modalIsOpen=_state.modalIsOpen;var _props=this.props,fieldPlate=_props.fieldPlate,fieldConfirmPlate=_props.fieldConfirmPlate,fieldIdentifier=_props.fieldIdentifier,saving=_props.saving,toggleModal=_props.toggleModal;var showAxios=selected==='caminhao'||selected==='onibus';return _react2.default.createElement(_Modal.SimpleModal,{hideModal:toggleModal,maxWidth:924,__source:{fileName:_jsxFileName,lineNumber:152}},_react2.default.createElement(_gridStyled.Box,{__source:{fileName:_jsxFileName,lineNumber:153}},_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:154}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:155}},_data.title)),_react2.default.createElement(_Content2.default,{__source:{fileName:_jsxFileName,lineNumber:159}},_react2.default.createElement(_styles.TextInfo,{__source:{fileName:_jsxFileName,lineNumber:160}},_data.textInfo),_react2.default.createElement(_styles.List,{__source:{fileName:_jsxFileName,lineNumber:161}},_react2.default.createElement(_Option2.default,{active:selected==='carro-passeio',description:'Carro de passeio',icon:_react2.default.createElement(_icCar2.default,{__source:{fileName:_jsxFileName,lineNumber:165}}),setOption:this.setOption,value:'carro-passeio',__source:{fileName:_jsxFileName,lineNumber:162}}),_react2.default.createElement(_Option2.default,{active:selected==='carro-utilitario',description:'Carro utilit\xE1rio',icon:_react2.default.createElement(_icUtility2.default,{__source:{fileName:_jsxFileName,lineNumber:172}}),setOption:this.setOption,value:'carro-utilitario',__source:{fileName:_jsxFileName,lineNumber:169}}),_react2.default.createElement(_Option2.default,{active:selected==='caminhao',description:'Caminh\xE3o',icon:_react2.default.createElement(_icTruck2.default,{__source:{fileName:_jsxFileName,lineNumber:179}}),setOption:this.setOption,value:'caminhao',__source:{fileName:_jsxFileName,lineNumber:176}}),_react2.default.createElement(_Option2.default,{active:selected==='onibus',description:'\xD4nibus',icon:_react2.default.createElement(_icBus2.default,{__source:{fileName:_jsxFileName,lineNumber:186}}),setOption:this.setOption,value:'onibus',__source:{fileName:_jsxFileName,lineNumber:183}})),_react2.default.createElement(_styles.Form,{onSubmit:this.props.handleSubmit(this.handleSubmit),ref:'form',__source:{fileName:_jsxFileName,lineNumber:192}},_react2.default.createElement(_styles.ListForm,{__source:{fileName:_jsxFileName,lineNumber:193}},_react2.default.createElement(_gridStyled.Box,{width:1,mb:1,__source:{fileName:_jsxFileName,lineNumber:194}},_react2.default.createElement(_formFields.PlateField,{autoFocus:true,id:'inputPlate',__source:{fileName:_jsxFileName,lineNumber:195}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:1,__source:{fileName:_jsxFileName,lineNumber:197}},_react2.default.createElement(_formFields.ConfirmPlateField,{id:'inputConfirmPlate',__source:{fileName:_jsxFileName,lineNumber:198}})),showAxios&&_react2.default.createElement(_gridStyled.Box,{width:1,mb:1,id:'selectAxis',__source:{fileName:_jsxFileName,lineNumber:201}},_react2.default.createElement(_formFields.AxisField,{axis:axis,__source:{fileName:_jsxFileName,lineNumber:202}})),_react2.default.createElement(_gridStyled.Box,{width:1,mb:1,__source:{fileName:_jsxFileName,lineNumber:205}},_react2.default.createElement(_formFields.IdentifierField,{disabled:true,__source:{fileName:_jsxFileName,lineNumber:206}}))),_react2.default.createElement(_gridStyled.Flex,{align:'center',justify:'flex-start',mt:[0,'0px'],__source:{fileName:_jsxFileName,lineNumber:210}},_react2.default.createElement(_Button2.default,{text:_data.labels.submitButton,type:'submit',loading:saving,width:'200px',disabled:saving||!fieldPlate||!fieldConfirmPlate||!fieldIdentifier||selected==='',__source:{fileName:_jsxFileName,lineNumber:211}})))),modalIsOpen?_react2.default.createElement(_ManageInfoModal2.default,{isOpen:modalIsOpen,toggleModal:this.toggleModal,modalStart:'include',match:this.props.match,controlled:true,handleSubmitExternal:function handleSubmitExternal(values){return _this2.addManageInf(values);},__source:{fileName:_jsxFileName,lineNumber:223}}):null),_react2.default.createElement(_styles.Back,{onClick:this.handleCloseModal,__source:{fileName:_jsxFileName,lineNumber:233}},_react2.default.createElement(_icClose2.default,{width:24,height:24,fill:_colors.blueGray,__source:{fileName:_jsxFileName,lineNumber:234}})));}}]);return Activation;}(_react2.default.Component);var mapStateToProps=exports.mapStateToProps=function mapStateToProps(state,ownProps){var selector=(0,_reduxForm.formValueSelector)('activationForm');return{fieldPlate:selector(state,'plate'),fieldConfirmPlate:selector(state,'confirmPlate'),fieldIdentifier:selector(state,'identifier'),saving:state.reducer.formState.saving,accountPlans:state.reducer.accountPlans,initialValues:{identifier:ownProps.numberVeloeTag}};};var mapDispatchToProps=exports.mapDispatchToProps=function mapDispatchToProps(dispatch,ownProps){return{initFormState:function initFormState(){return dispatch((0,_formStateActions.stopSaving)());},dispatchReset:function dispatchReset(){dispatch((0,_reduxForm.reset)('activationForm'));},fetchActivation:function fetchActivation(values,next){dispatch((0,_formStateActions.startSaving)());dispatch((0,_actions.fetchActivationForPartners)(values)).then(function(){var _ref=_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(resp){return regeneratorRuntime.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch((0,_formStateActions.stopSaving)());ownProps.setIdentifiers(resp);ownProps.toggleModal();if(next){ownProps.toggleQRCode(true);}case 4:case'end':return _context.stop();}}},_callee,undefined);}));return function(_x){return _ref.apply(this,arguments);};}()).catch(function(e){dispatch((0,_formStateActions.stopSaving)());dispatch((0,_actions2.showModal)(_ModalTypes.CONFIRM_UPDATE,{modalTitle:_data.titleModalError,modalDescription:_data.modalDescriptionError,image:_contestacao2.default}));});}};};var form=(0,_reduxForm.reduxForm)({form:'activationForm',destroyOnUnmount:true})(Activation);exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(form);

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.IdentifierField=exports.ConfirmPlateField=exports.PlateField=exports.AxisField=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/pages/ActivationForPartner/form-fields.js';exports.default=validateConfirmPlate;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _aleloLogic=__webpack_require__(12);var _renderInputs=__webpack_require__(44);var _reduxForm=__webpack_require__(11);var _data=__webpack_require__(674);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function validateConfirmPlate(value,_ref){var plate=_ref.plate;if(!value)return'Campo obrigatório';if(value!==plate){return'Placas não coincidem. Favor digitar novamente a placa e confirmá-la.';}}var AxisField=function AxisField(_ref2){var axis=_ref2.axis;return _react2.default.createElement(_reduxForm.Field,{placeholder:' ',component:_renderInputs.renderSelectField,label:_data.labels.axis,name:'axis',options:axis,validate:_aleloLogic.utils.emptyFieldValidate,__source:{fileName:_jsxFileName,lineNumber:17}});};var PlateField=function PlateField(props){return _react2.default.createElement(_reduxForm.Field,_extends({component:_renderInputs.renderTextInput,label:_data.labels.plate,name:'plate',type:'text',validate:_aleloLogic.utils.plateValidate,normalize:_aleloLogic.utils.plateMask,isRequired:true,autoComplete:'off',tooltip:'O preenchimento deve ser exatamente igual a placa inserida no campo anterior'},props,{__source:{fileName:_jsxFileName,lineNumber:28}}));};var ConfirmPlateField=function ConfirmPlateField(props){return _react2.default.createElement(_reduxForm.Field,_extends({component:_renderInputs.renderTextInput,label:_data.labels.confirmPlate,name:'confirmPlate',type:'text',validate:validateConfirmPlate,normalize:_aleloLogic.utils.plateMask,isRequired:true,autoComplete:'off',tooltip:'O preenchimento deve seguir o padr\xE3o atual ABC1234 ou padr\xE3o placa Mercosul ABC1D23'},props,{__source:{fileName:_jsxFileName,lineNumber:43}}));};var IdentifierField=function IdentifierField(props){return _react2.default.createElement(_reduxForm.Field,_extends({component:_renderInputs.renderTextInput,label:_data.labels.identifier,name:'identifier',type:'text',validate:_aleloLogic.utils.identifierValidate,isRequired:true,isFocus:true},props,{__source:{fileName:_jsxFileName,lineNumber:58}}));};exports.AxisField=AxisField;exports.PlateField=PlateField;exports.ConfirmPlateField=ConfirmPlateField;exports.IdentifierField=IdentifierField;

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Form=exports.Back=exports.Pill=exports.WrapperPill=exports.TitleSecond=exports.ListForm=exports.List=exports.TextInfo=exports.BoxGrey=exports.Paragraph=exports.Title=undefined;var _templateObject=_taggedTemplateLiteral(['\n    width: ',';\n  '],['\n    width: ',';\n  ']),_templateObject2=_taggedTemplateLiteral(['\n    flex-direction: column;\n  '],['\n    flex-direction: column;\n  ']),_templateObject3=_taggedTemplateLiteral(['\n      max-width: 100%;\n      min-width: 100%;\n      margin-bottom: 10px;\n      padding-top: 0;\n      padding-bottom: 0;\n    '],['\n      max-width: 100%;\n      min-width: 100%;\n      margin-bottom: 10px;\n      padding-top: 0;\n      padding-bottom: 0;\n    ']),_templateObject4=_taggedTemplateLiteral(['\n    flex-direction: column;\n    margin-top: 20px;\n  '],['\n    flex-direction: column;\n    margin-top: 20px;\n  ']),_templateObject5=_taggedTemplateLiteral(['\n      margin-bottom: 15px;\n      margin-right: 0;\n      max-width: 100%;\n    '],['\n      margin-bottom: 15px;\n      margin-right: 0;\n      max-width: 100%;\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _em=__webpack_require__(35);var _em2=_interopRequireDefault(_em);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _styles=__webpack_require__(185);var _types=__webpack_require__(4);var _colors=__webpack_require__(2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=exports.Title=_styledComponents2.default.h1.withConfig({displayName:'styles__Title',componentId:'sc-l7pdxz-0'})(['',' letter-spacing:',';color:',';margin-top:',';'],_types.title40GalanoBold,(0,_em2.default)('0.4px'),_colors.darkSlateBlue,(0,_rem2.default)('40px'));var Paragraph=exports.Paragraph=_styledComponents2.default.p.withConfig({displayName:'styles__Paragraph',componentId:'sc-l7pdxz-1'})(['',' color:',';width:',';',';',';'],_types.txt14OpenSans,_colors.darkBlue,(0,_rem2.default)('320px'),_media2.default.large(_templateObject,(0,_rem2.default)('660px')),function(_ref){var noMargin=_ref.noMargin;return noMargin&&(0,_styledComponents.css)(['margin-bottom:0;']);});var BoxGrey=exports.BoxGrey=_styledComponents2.default.div.withConfig({displayName:'styles__BoxGrey',componentId:'sc-l7pdxz-2'})(['background:-moz-linear-gradient( top,rgba(241,241,247,1) 0%,rgba(241,241,247,1) 45%,rgba(241,241,247,1) 40%,rgba(241,241,247,0) 41% );background:-webkit-linear-gradient( top,rgba(241,241,247,1) 0%,rgba(241,241,247,1) 45%,rgba(241,241,247,1) 40%,rgba(241,241,247,0) 41% );background:linear-gradient( to bottom,rgba(241,241,247,1) 0%,rgba(241,241,247,1) 45%,rgba(241,241,247,1) 40%,rgba(241,241,247,0) 41% );filter:progid:DXImageTransform.Microsoft.gradient( startColorstr=\'','\',endColorstr=\'','\',GradientType=0 );margin:50px 0 0;padding:40px 0;'],_colors.paleGray,_colors.paleGray);var TextInfo=exports.TextInfo=_styledComponents2.default.p.withConfig({displayName:'styles__TextInfo',componentId:'sc-l7pdxz-3'})(['',';font-weight:bold;letter-spacing:',';color:',';text-transform:uppercase;',';',';'],_types.txt12OpenSans,(0,_em2.default)('1.6px'),_colors.blueGray,function(_ref2){var initialCase=_ref2.initialCase;return initialCase&&'\n    text-transform: initial;\n    font-weight: normal;\n  ';},function(_ref3){var noMargin=_ref3.noMargin;return noMargin&&'\n    margin-top: 0;\n  ';});var List=exports.List=_styledComponents2.default.ul.withConfig({displayName:'styles__List',componentId:'sc-l7pdxz-4'})(['display:flex;align-items:center;justify-content:space-between;margin:0;padding:0;',';li{max-width:216px;min-width:216px;',';}'],_media2.default.small(_templateObject2),_media2.default.small(_templateObject3));var greyBottomLine='\n    '+_styles.bottomLine+'\n    background-color: '+_colors.grey+';\n    left: 0;\n    right: 0;\n    width: 100%;\n';var ListForm=exports.ListForm=_styledComponents2.default.div.withConfig({displayName:'styles__ListForm',componentId:'sc-l7pdxz-5'})(['display:flex;justify-content:flex-start;align-items:center;margin:40px 0 30px;',';> div{max-width:216px;margin-right:25px;',';}label{',';font-weight:bold;letter-spacing:',';color:',';text-transform:uppercase;}select{color:',' !important;}#selectAxis{> div{&:last-child{&:after{',';}}}}'],_media2.default.small(_templateObject4),_media2.default.small(_templateObject5),_types.txt12OpenSans,(0,_em2.default)('1.6px'),_colors.blueGray,_colors.grey,greyBottomLine);var TitleSecond=exports.TitleSecond=_styledComponents2.default.h2.withConfig({displayName:'styles__TitleSecond',componentId:'sc-l7pdxz-6'})(['',' letter-spacing:',';color:',';margin-top:',';'],_types.title36GalanoBold,(0,_em2.default)('0.1px'),_colors.darkSlateBlue,(0,_rem2.default)('100px'));var WrapperPill=exports.WrapperPill=_styledComponents2.default.ul.withConfig({displayName:'styles__WrapperPill',componentId:'sc-l7pdxz-7'})(['display:flex;justify-content:flex-start;margin:0;padding:0;padding-top:25px;min-height:',';'],(0,_rem2.default)('100px'));var Pill=exports.Pill=_styledComponents2.default.li.withConfig({displayName:'styles__Pill',componentId:'sc-l7pdxz-8'})(['background:',';border-radius:12px;',' color:',';font-size:10px;font-weight:bold;height:24px;letter-spacing:0.5px;list-style:none;margin-right:20px;padding:5px 30px 5px 15px;position:relative;',';span{cursor:pointer;display:block;position:absolute;right:12px;top:5px;}'],_colors.lightBlue,_types.txt14OpenSans,_colors.white,function(_ref4){var noSelected=_ref4.noSelected;return noSelected&&'\n    background: '+_colors.grey+';\n    padding-right: 15px;\n\n    span {\n      display: none;\n    }\n  ';});var Back=exports.Back=_styledComponents2.default.a.withConfig({displayName:'styles__Back',componentId:'sc-l7pdxz-9'})(['',';font-weight:bold;line-height:1;color:',';display:flex;position:absolute;top:0;right:0;padding:',';cursor:pointer;svg{fill:',';}'],_types.txt14OpenSans,_colors.linkNavyBlue,(0,_rem2.default)('16px'),_colors.posGreyInfo);var Form=exports.Form=_styledComponents2.default.form.withConfig({displayName:'styles__Form',componentId:'sc-l7pdxz-10'})(['padding-bottom:100px;']);

/***/ }),
/* 2288 */
/***/ (function(module, exports) {

module.exports = {"helmetTitle":"Minha Veloe - VeloeTags","identifiersTitle":"Minhas VeloeTags","identifiersDescription":"Veja abaixo a sua lista de veículos ativados:","btnFollow":"Meus pedidos","btnActivation":"Ativar novo veículo","btnNewTag":"Solicitar VeloeTag","noIdentifierTitle":"Ops","noIdentifierDescription":"Você não tem VeloeTags a serem exibidas."}

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Main=exports.MainWrapper=exports.Container=undefined;var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Container=exports.Container=_styledComponents2.default.div.withConfig({displayName:'styles__Container',componentId:'sc-vini0x-0'})(['max-width:',';margin:0 auto;'],(0,_rem2.default)('1280px'));var MainWrapper=exports.MainWrapper=_styledComponents2.default.main.withConfig({displayName:'styles__MainWrapper',componentId:'sc-vini0x-1'})(['max-width:',';margin:inherit;'],(0,_rem2.default)('940px'));var Main=exports.Main=_styledComponents2.default.main.withConfig({displayName:'styles__Main',componentId:'sc-vini0x-2'})(['display:block;',';'],function(_ref){var modalOpen=_ref.modalOpen;return modalOpen&&(0,_styledComponents.css)(['height:100vh;']);});

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ModalRoot/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _ConfirmationModal=__webpack_require__(2291);var _ConfirmationModal2=_interopRequireDefault(_ConfirmationModal);var _InputModal=__webpack_require__(2292);var _InputModal2=_interopRequireDefault(_InputModal);var _TokenModal=__webpack_require__(2295);var _TokenModal2=_interopRequireDefault(_TokenModal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var MODAL_LIST={CONFIRM_UPDATE:_ConfirmationModal2.default,TOKEN_MODAL:_TokenModal2.default,INPUT_MODAL:_InputModal2.default};var ModalRoot=function ModalRoot(_ref){var type=_ref.type,props=_ref.props;if(!type){return null;}var Component=MODAL_LIST[type];return _react2.default.createElement(Component,_extends({},props,{__source:{fileName:_jsxFileName,lineNumber:19}}));};exports.default=(0,_reactRedux.connect)(function(state){return{type:state.modalReducer.type,props:state.modalReducer.props};})(ModalRoot);module.exports=exports['default'];

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/ConfirmationModal/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(18);var _Modal=__webpack_require__(113);var _Modal2=_interopRequireDefault(_Modal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var Confirmation=function Confirmation(props){var handleConfirm=function handleConfirm(){if(props.onConfirm){props.onConfirm();}props.hideModal();};return _react2.default.createElement(_Modal2.default,{description:props.modalDescription,image:props.image,hideModal:props.hideModal,onConfirm:function onConfirm(){return handleConfirm();},title:props.modalTitle,accountType:props.accountType,confirmButtonLabel:props.confirmButtonLabel,__source:{fileName:_jsxFileName,lineNumber:16}});};exports.default=(0,_reactRedux.connect)(null,{hideModal:_actions.hideModal})(Confirmation);module.exports=exports['default'];

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/InputModal/index.js';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(7);var _gridStyled=__webpack_require__(8);var _actions=__webpack_require__(18);var _Icon=__webpack_require__(31);var _Modal=__webpack_require__(113);var _Modal2=_interopRequireDefault(_Modal);var _TextInput=__webpack_require__(101);var _TextInput2=_interopRequireDefault(_TextInput);var _Button=__webpack_require__(14);var _Button2=_interopRequireDefault(_Button);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);var _styles=__webpack_require__(2293);var _data=__webpack_require__(2294);var _data2=_interopRequireDefault(_data);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InputModal=function(_Component){_inherits(InputModal,_Component);function InputModal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InputModal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InputModal.__proto__||Object.getPrototypeOf(InputModal)).call.apply(_ref,[this].concat(args))),_this),_this.state={isLoading:false,isRefreshed:false},_this.onInputChange=function(value){_this.setState({inputValue:value});},_this.handleRefresh=function(e){_this.setState({errorMessage:false,isLoading:true,inputValue:''});_this.props.fetchRefreshProvider().then(function(){_this.setState({isLoading:false,isRefreshed:true});}).catch(function(){_this.setState({errorMessage:_data2.default.defaultError,isLoading:false});});},_this.handleConfirm=function(e){e.preventDefault();_this.setState({isLoading:true});_this.props.fetchSendProvider(_this.state.inputValue).then(function(){_this.setState({isLoading:false});_this.props.hideModal();if(_this.props.onConfirm){_this.props.onConfirm();}}).catch(function(){_this.setState({errorMessage:_this.props.fetchErrorMessage||_data2.default.defaultError,isLoading:false});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InputModal,[{key:'render',value:function render(){var _this2=this;var _props=this.props,fetchRefreshProvider=_props.fetchRefreshProvider,image=_props.image,title=_props.title,description=_props.description,buttonText=_props.buttonText,label=_props.label,placeholder=_props.placeholder,refreshMessage=_props.refreshMessage;var _state=this.state,isLoading=_state.isLoading,isRefreshed=_state.isRefreshed;var inputValue=this.state.inputValue;var modalTitle=title||_data2.default.title;var modalDesc=description||_data2.default.description;var modalButtonText=buttonText||_data2.default.buttonText;return _react2.default.createElement(_styles.InputModalContainer,{__source:{fileName:_jsxFileName,lineNumber:94}},_react2.default.createElement(_Modal2.default,{image:image,hideModal:this.props.hideModal,__source:{fileName:_jsxFileName,lineNumber:95}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:96}},isRefreshed?refreshMessage:modalTitle),_react2.default.createElement(_styles.Description,{__source:{fileName:_jsxFileName,lineNumber:97}},modalDesc),_react2.default.createElement(_styles.InputContainer,{mb:[60,48],width:[1,262],__source:{fileName:_jsxFileName,lineNumber:99}},_react2.default.createElement('form',{onSubmit:this.handleConfirm,__source:{fileName:_jsxFileName,lineNumber:100}},_react2.default.createElement(_TextInput2.default,{errorMessage:this.state.errorMessage,label:label,loading:isLoading,negative:true,onChange:function onChange(e){return _this2.onInputChange(e);},placeholder:placeholder,value:inputValue,__source:{fileName:_jsxFileName,lineNumber:101}}),!isLoading&&fetchRefreshProvider&&_react2.default.createElement(_styles.Resend,{onClick:this.handleRefresh,__source:{fileName:_jsxFileName,lineNumber:113}},_react2.default.createElement(_Icon.Icon,{height:'18px',icon:'resend',width:'18px',viewBox:'0 0 18 18',__source:{fileName:_jsxFileName,lineNumber:114}})),_react2.default.createElement(_gridStyled.Box,{mt:[(0,_rem2.default)('30px'),(0,_rem2.default)('48px')],__source:{fileName:_jsxFileName,lineNumber:118}},_react2.default.createElement(_Button2.default,{buttonType:'transparent',type:'submit',text:modalButtonText,onClick:this.props.onConfirm,__source:{fileName:_jsxFileName,lineNumber:119}}))))));}}]);return InputModal;}(_react.Component);exports.default=(0,_reactRedux.connect)(null,{hideModal:_actions.hideModal})(InputModal);module.exports=exports['default'];

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Resend=exports.InputContainer=exports.Description=exports.Title=exports.InputModalContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n        font-size: ',';\n        max-width: ',';\n    '],['\n        font-size: ',';\n        max-width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        margin-bottom: ',';\n        max-width: ',';\n    '],['\n        margin-bottom: ',';\n        max-width: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _gridStyled=__webpack_require__(8);var _colors=__webpack_require__(2);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InputModalContainer=exports.InputModalContainer=_styledComponents2.default.div.withConfig({displayName:'styles__InputModalContainer',componentId:'sc-jobh73-0'})(['.feedback-image{display:none;}']);var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-jobh73-1'})(['color:',';font-family:Galano;font-size:',';font-weight:bold;line-height:1.1;margin:0 0 ',';',';'],_colors.white,(0,_rem2.default)('24px'),(0,_rem2.default)('20px'),_media2.default.large(_templateObject,(0,_rem2.default)('40px'),(0,_rem2.default)('345px')));var Description=exports.Description=_styledComponents2.default.p.withConfig({displayName:'styles__Description',componentId:'sc-jobh73-2'})(['color:',';font-family:OpenSans;font-size:',';font-weight:200;margin-bottom:',';',';'],_colors.white,(0,_rem2.default)('14px'),(0,_rem2.default)('40px'),_media2.default.large(_templateObject2,(0,_rem2.default)('36px'),(0,_rem2.default)('245px')));var InputContainer=exports.InputContainer=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'styles__InputContainer',componentId:'sc-jobh73-3'})(['position:relative;']);var Resend=exports.Resend=_styledComponents2.default.div.withConfig({displayName:'styles__Resend',componentId:'sc-jobh73-4'})(['cursor:pointer;height:',';position:absolute;right:',';top:',';width:',';z-index:1;'],(0,_rem2.default)('16px'),(0,_rem2.default)('14px'),(0,_rem2.default)('30px'),(0,_rem2.default)('16px'));

/***/ }),
/* 2294 */
/***/ (function(module, exports) {

module.exports = {"title":"Já vamos enviar seu extrato.","description":"Diga pra gente o e-mail em que você quer receber seu extrato.","buttonText":"Continuar","error":{"invalid":"Campo inválido"},"defaultError":"Erro."}

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _jsxFileName='/work/vsts-agent-5-agent/29/s/src/app/modules/TokenModal/index.js';var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _propTypes=__webpack_require__(9);var _reactRedux=__webpack_require__(7);var _actions=__webpack_require__(18);var _actions2=__webpack_require__(604);var _Icon=__webpack_require__(31);var _Modal=__webpack_require__(113);var _Modal2=_interopRequireDefault(_Modal);var _TextInput=__webpack_require__(101);var _TextInput2=_interopRequireDefault(_TextInput);var _styles=__webpack_require__(2296);var _data=__webpack_require__(2297);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var TokenModal=function TokenModal(props){var error=props.error,loading=props.loading,onConfirm=props.onConfirm,onResendToken=props.onResendToken,token=props.token;var handleConfirm=function handleConfirm(){if(onConfirm){onConfirm(props);}else{props.hideModal();}};var handleResend=function handleResend(){if(onResendToken){onResendToken();}};return _react2.default.createElement(_styles.TokenModalContainer,{__source:{fileName:_jsxFileName,lineNumber:34}},_react2.default.createElement(_Modal2.default,{hideModal:props.hideModal,onConfirm:handleConfirm,__source:{fileName:_jsxFileName,lineNumber:35}},_react2.default.createElement(_styles.Title,{__source:{fileName:_jsxFileName,lineNumber:36}},props.title?props.title:_data.title),_react2.default.createElement(_styles.Description,{__source:{fileName:_jsxFileName,lineNumber:37}},_data.description),_react2.default.createElement(_styles.InputContainer,{mb:[60,48],width:[1,262],__source:{fileName:_jsxFileName,lineNumber:39}},_react2.default.createElement(_TextInput2.default,{errorMessage:error,label:_data.label,loading:loading,negative:true,onChange:props.updateTokenModal,placeholder:_data.placeholder,value:token,__source:{fileName:_jsxFileName,lineNumber:40}}),!loading&&onResendToken&&_react2.default.createElement(_styles.Resend,{onClick:handleResend,__source:{fileName:_jsxFileName,lineNumber:52}},_react2.default.createElement(_Icon.Icon,{height:'18px',icon:'resend',width:'18px',viewBox:'0 0 18 18',__source:{fileName:_jsxFileName,lineNumber:53}})))));};TokenModal.defaultProps={error:null,loading:false,onConfirm:null,onResendToken:null,token:''};TokenModal.propTypes={error:_propTypes.string,loading:_propTypes.bool,onConfirm:_propTypes.func,onResendToken:_propTypes.func,token:_propTypes.string};var mapStateToProps=function mapStateToProps(_ref){var tokenModal=_ref.tokenModal;return tokenModal;};exports.default=(0,_reactRedux.connect)(mapStateToProps,{hideModal:_actions.hideModal,setTokenModalError:_actions2.setTokenModalError,updateTokenModal:_actions2.updateTokenModal})(TokenModal);module.exports=exports['default'];

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.Resend=exports.InputContainer=exports.Description=exports.Title=exports.TokenModalContainer=undefined;var _templateObject=_taggedTemplateLiteral(['\n        font-size: ',';\n        max-width: ',';\n    '],['\n        font-size: ',';\n        max-width: ',';\n    ']),_templateObject2=_taggedTemplateLiteral(['\n        margin-bottom: ',';\n        max-width: ',';\n    '],['\n        margin-bottom: ',';\n        max-width: ',';\n    ']);var _styledComponents=__webpack_require__(1);var _styledComponents2=_interopRequireDefault(_styledComponents);var _gridStyled=__webpack_require__(8);var _colors=__webpack_require__(2);var _media=__webpack_require__(6);var _media2=_interopRequireDefault(_media);var _rem=__webpack_require__(3);var _rem2=_interopRequireDefault(_rem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TokenModalContainer=exports.TokenModalContainer=_styledComponents2.default.div.withConfig({displayName:'styles__TokenModalContainer',componentId:'sc-9nto1w-0'})(['.feedback-image{display:none;}']);var Title=exports.Title=_styledComponents2.default.h2.withConfig({displayName:'styles__Title',componentId:'sc-9nto1w-1'})(['color:',';font-family:Galano;font-size:',';font-weight:bold;line-height:1.1;margin:0 0 ',';',';'],_colors.white,(0,_rem2.default)('24px'),(0,_rem2.default)('20px'),_media2.default.large(_templateObject,(0,_rem2.default)('40px'),(0,_rem2.default)('345px')));var Description=exports.Description=_styledComponents2.default.p.withConfig({displayName:'styles__Description',componentId:'sc-9nto1w-2'})(['color:',';font-family:OpenSans;font-size:',';font-weight:200;margin-bottom:',';',';'],_colors.white,(0,_rem2.default)('14px'),(0,_rem2.default)('40px'),_media2.default.large(_templateObject2,(0,_rem2.default)('36px'),(0,_rem2.default)('245px')));var InputContainer=exports.InputContainer=(0,_styledComponents2.default)(_gridStyled.Box).withConfig({displayName:'styles__InputContainer',componentId:'sc-9nto1w-3'})(['position:relative;']);var Resend=exports.Resend=_styledComponents2.default.div.withConfig({displayName:'styles__Resend',componentId:'sc-9nto1w-4'})(['cursor:pointer;height:',';position:absolute;right:',';top:',';width:',';z-index:1;'],(0,_rem2.default)('16px'),(0,_rem2.default)('14px'),(0,_rem2.default)('30px'),(0,_rem2.default)('16px'));

/***/ }),
/* 2297 */
/***/ (function(module, exports) {

module.exports = {"title":"Enviamos um código para você.","description":"Para fazer o bloqueio, coloque aqui o código que a gente enviou para o celular final (00) xxxxx-xx00.","label":"código","placeholder":"Ex 0000000"}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.165622a5.js